/**
 * Generated by orval 🍺
 * Do not edit manually.
 * CDF Template API
 * OpenAPI-first contract for the CDF template.
 *
 * Workflow:
 *   1. Edit this spec FIRST for any API change.
 *   2. Run `pnpm gen:api` to regenerate the React Query client
 *      (lib/api-client-react) and Zod schemas (lib/api-zod).
 *   3. Implement/adjust the Fastify routes in artifacts/api-server
 *      to match, validating with the generated Zod schemas.
 *
 * OpenAPI spec version: 0.1.0
 */
import * as zod from 'zod';

/**
 * Platform Admin may preview platform roles; a tenant Owner may preview only their tenant. Read-only. Lists permanent and eligible replacements separately.
 * @summary Preview access migration
 */
export const previewAccessMigrationQueryLimitDefault = 25;
export const previewAccessMigrationQueryLimitMax = 100;

export const previewAccessMigrationQueryOffsetDefault = 0;
export const previewAccessMigrationQueryOffsetMin = 0;



export const previewAccessMigrationQueryParams = zod.object({
  "tenantId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(previewAccessMigrationQueryLimitMax).default(previewAccessMigrationQueryLimitDefault),
  "offset": zod.int().min(previewAccessMigrationQueryOffsetMin).default(previewAccessMigrationQueryOffsetDefault)
})

export const previewAccessMigrationResponse = zod.object({
  "digest": zod.string(),
  "items": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['person', 'group']),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "currentRoles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})),
  "permanentRoles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})),
  "eligibleRoles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})),
  "addedPermissions": zod.array(zod.string()),
  "elevationPermissions": zod.array(zod.string()),
  "status": zod.enum(['ready', 'unchanged', 'blocked']),
  "message": zod.string()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "ready": zod.int(),
  "blocked": zod.int()
})


/**
 * Requires explicit confirmation of the exact current preview digest and Platform Admin or tenant Owner authority. Conflicting duties move to eligible access requiring separate approval. Atomic, audited, and rejects stale previews.
 * @summary Apply reviewed access migration
 */
export const applyAccessMigrationBodyDigestRegExp = new RegExp('^[a-f0-9]{64}$');
export const applyAccessMigrationBodyReasonMin = 10;
export const applyAccessMigrationBodyReasonMax = 1000;



export const applyAccessMigrationBody = zod.object({
  "tenantId": zod.uuid().optional(),
  "digest": zod.string().regex(applyAccessMigrationBodyDigestRegExp),
  "confirmation": zod.enum(['APPLY']),
  "reason": zod.string().min(applyAccessMigrationBodyReasonMin).max(applyAccessMigrationBodyReasonMax)
})

export const applyAccessMigrationResponse = zod.object({
  "changed": zod.int(),
  "unchanged": zod.int(),
  "blocked": zod.int()
})


export const listProposalTasksParams = zod.object({
  "id": zod.uuid()
})

export const listProposalTasksQueryLimitDefault = 20;
export const listProposalTasksQueryLimitMax = 100;

export const listProposalTasksQueryOffsetDefault = 0;
export const listProposalTasksQueryOffsetMin = 0;



export const listProposalTasksQueryParams = zod.object({
  "limit": zod.int().min(1).max(listProposalTasksQueryLimitMax).default(listProposalTasksQueryLimitDefault),
  "offset": zod.int().min(listProposalTasksQueryOffsetMin).default(listProposalTasksQueryOffsetDefault)
})


export const listProposalTasksResponseItemsItemActivityDurationMinutesMin = 0;

export const listProposalTasksResponseItemsItemActivityIsTestDataDefault = false;
export const listProposalTasksResponseItemsItemSourcesItemRevisionMax = 200;

export const listProposalTasksResponseItemsItemSourcesItemQuoteMax = 1000;

export const listProposalTasksResponseItemsItemSourcesItemLocationMax = 500;



export const listProposalTasksResponse = zod.object({
  "items": zod.array(zod.object({
  "activity": zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listProposalTasksResponseItemsItemActivityDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listProposalTasksResponseItemsItemActivityIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "sources": zod.array(zod.object({
  "revision": zod.string().min(1).max(listProposalTasksResponseItemsItemSourcesItemRevisionMax),
  "quote": zod.string().min(1).max(listProposalTasksResponseItemsItemSourcesItemQuoteMax),
  "location": zod.string().min(1).max(listProposalTasksResponseItemsItemSourcesItemLocationMax)
}))
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const listProposalTaskOwnersParams = zod.object({
  "id": zod.uuid()
})

export const listProposalTaskOwnersQueryLimitDefault = 20;
export const listProposalTaskOwnersQueryLimitMax = 100;

export const listProposalTaskOwnersQueryOffsetDefault = 0;
export const listProposalTaskOwnersQueryOffsetMin = 0;



export const listProposalTaskOwnersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listProposalTaskOwnersQueryLimitMax).default(listProposalTaskOwnersQueryLimitDefault),
  "offset": zod.int().min(listProposalTaskOwnersQueryOffsetMin).default(listProposalTaskOwnersQueryOffsetDefault)
})

export const listProposalTaskOwnersResponse = zod.object({
  "total": zod.int(),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}))
})


export const reviewProposalTasksParams = zod.object({
  "id": zod.uuid()
})


export const reviewProposalTasksBodyTasksItemTitleMax = 500;

export const reviewProposalTasksBodyTasksItemDescriptionMax = 5000;

export const reviewProposalTasksBodyTasksItemStatusMax = 100;

export const reviewProposalTasksBodyTasksItemSourcesItemRevisionMax = 200;

export const reviewProposalTasksBodyTasksItemSourcesItemQuoteMax = 1000;

export const reviewProposalTasksBodyTasksItemSourcesItemLocationMax = 500;

export const reviewProposalTasksBodyTasksItemSourcesMax = 20;

export const reviewProposalTasksBodyTasksItemAllowSimilarDefault = false;
export const reviewProposalTasksBodyTasksMax = 30;



export const reviewProposalTasksBody = zod.object({
  "requestId": zod.uuid(),
  "draftId": zod.uuid().optional(),
  "tasks": zod.array(zod.object({
  "activityId": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "title": zod.string().min(1).max(reviewProposalTasksBodyTasksItemTitleMax),
  "description": zod.string().min(1).max(reviewProposalTasksBodyTasksItemDescriptionMax),
  "status": zod.string().min(1).max(reviewProposalTasksBodyTasksItemStatusMax),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']),
  "ownerId": zod.uuid().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "sources": zod.array(zod.object({
  "revision": zod.string().min(1).max(reviewProposalTasksBodyTasksItemSourcesItemRevisionMax),
  "quote": zod.string().min(1).max(reviewProposalTasksBodyTasksItemSourcesItemQuoteMax),
  "location": zod.string().min(1).max(reviewProposalTasksBodyTasksItemSourcesItemLocationMax)
})).max(reviewProposalTasksBodyTasksItemSourcesMax),
  "allowSimilar": zod.boolean().default(reviewProposalTasksBodyTasksItemAllowSimilarDefault)
})).min(1).max(reviewProposalTasksBodyTasksMax)
})


export const reviewProposalTasksResponseTasksItemTitleMax = 500;

export const reviewProposalTasksResponseTasksItemDescriptionMax = 5000;

export const reviewProposalTasksResponseTasksItemStatusMax = 100;

export const reviewProposalTasksResponseTasksItemSourcesItemRevisionMax = 200;

export const reviewProposalTasksResponseTasksItemSourcesItemQuoteMax = 1000;

export const reviewProposalTasksResponseTasksItemSourcesItemLocationMax = 500;

export const reviewProposalTasksResponseTasksItemSourcesMax = 20;

export const reviewProposalTasksResponseTasksItemAllowSimilarDefault = false;

export const reviewProposalTasksResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "status": zod.enum(['generating', 'draft', 'reviewed', 'committed', 'failed']),
  "hash": zod.string(),
  "tasks": zod.array(zod.object({
  "activityId": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "title": zod.string().min(1).max(reviewProposalTasksResponseTasksItemTitleMax),
  "description": zod.string().min(1).max(reviewProposalTasksResponseTasksItemDescriptionMax),
  "status": zod.string().min(1).max(reviewProposalTasksResponseTasksItemStatusMax),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']),
  "ownerId": zod.uuid().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "sources": zod.array(zod.object({
  "revision": zod.string().min(1).max(reviewProposalTasksResponseTasksItemSourcesItemRevisionMax),
  "quote": zod.string().min(1).max(reviewProposalTasksResponseTasksItemSourcesItemQuoteMax),
  "location": zod.string().min(1).max(reviewProposalTasksResponseTasksItemSourcesItemLocationMax)
})).max(reviewProposalTasksResponseTasksItemSourcesMax),
  "allowSimilar": zod.boolean().default(reviewProposalTasksResponseTasksItemAllowSimilarDefault)
})),
  "warnings": zod.array(zod.string()),
  "activityIds": zod.array(zod.uuid()),
  "expiresAt": zod.iso.datetime({"offset":true})
})


export const getProposalTaskReviewParams = zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid()
})


export const getProposalTaskReviewResponseTasksItemTitleMax = 500;

export const getProposalTaskReviewResponseTasksItemDescriptionMax = 5000;

export const getProposalTaskReviewResponseTasksItemStatusMax = 100;

export const getProposalTaskReviewResponseTasksItemSourcesItemRevisionMax = 200;

export const getProposalTaskReviewResponseTasksItemSourcesItemQuoteMax = 1000;

export const getProposalTaskReviewResponseTasksItemSourcesItemLocationMax = 500;

export const getProposalTaskReviewResponseTasksItemSourcesMax = 20;

export const getProposalTaskReviewResponseTasksItemAllowSimilarDefault = false;

export const getProposalTaskReviewResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "status": zod.enum(['generating', 'draft', 'reviewed', 'committed', 'failed']),
  "hash": zod.string(),
  "tasks": zod.array(zod.object({
  "activityId": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "title": zod.string().min(1).max(getProposalTaskReviewResponseTasksItemTitleMax),
  "description": zod.string().min(1).max(getProposalTaskReviewResponseTasksItemDescriptionMax),
  "status": zod.string().min(1).max(getProposalTaskReviewResponseTasksItemStatusMax),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']),
  "ownerId": zod.uuid().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "sources": zod.array(zod.object({
  "revision": zod.string().min(1).max(getProposalTaskReviewResponseTasksItemSourcesItemRevisionMax),
  "quote": zod.string().min(1).max(getProposalTaskReviewResponseTasksItemSourcesItemQuoteMax),
  "location": zod.string().min(1).max(getProposalTaskReviewResponseTasksItemSourcesItemLocationMax)
})).max(getProposalTaskReviewResponseTasksItemSourcesMax),
  "allowSimilar": zod.boolean().default(getProposalTaskReviewResponseTasksItemAllowSimilarDefault)
})),
  "warnings": zod.array(zod.string()),
  "activityIds": zod.array(zod.uuid()),
  "expiresAt": zod.iso.datetime({"offset":true})
})


export const confirmProposalTasksParams = zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid()
})

export const confirmProposalTasksBodyHashMin = 64;
export const confirmProposalTasksBodyHashMax = 64;



export const confirmProposalTasksBody = zod.object({
  "hash": zod.string().min(confirmProposalTasksBodyHashMin).max(confirmProposalTasksBodyHashMax),
  "confirmation": zod.enum(['CONFIRM'])
})


export const confirmProposalTasksResponseTasksItemTitleMax = 500;

export const confirmProposalTasksResponseTasksItemDescriptionMax = 5000;

export const confirmProposalTasksResponseTasksItemStatusMax = 100;

export const confirmProposalTasksResponseTasksItemSourcesItemRevisionMax = 200;

export const confirmProposalTasksResponseTasksItemSourcesItemQuoteMax = 1000;

export const confirmProposalTasksResponseTasksItemSourcesItemLocationMax = 500;

export const confirmProposalTasksResponseTasksItemSourcesMax = 20;

export const confirmProposalTasksResponseTasksItemAllowSimilarDefault = false;

export const confirmProposalTasksResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "status": zod.enum(['generating', 'draft', 'reviewed', 'committed', 'failed']),
  "hash": zod.string(),
  "tasks": zod.array(zod.object({
  "activityId": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "title": zod.string().min(1).max(confirmProposalTasksResponseTasksItemTitleMax),
  "description": zod.string().min(1).max(confirmProposalTasksResponseTasksItemDescriptionMax),
  "status": zod.string().min(1).max(confirmProposalTasksResponseTasksItemStatusMax),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']),
  "ownerId": zod.uuid().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "sources": zod.array(zod.object({
  "revision": zod.string().min(1).max(confirmProposalTasksResponseTasksItemSourcesItemRevisionMax),
  "quote": zod.string().min(1).max(confirmProposalTasksResponseTasksItemSourcesItemQuoteMax),
  "location": zod.string().min(1).max(confirmProposalTasksResponseTasksItemSourcesItemLocationMax)
})).max(confirmProposalTasksResponseTasksItemSourcesMax),
  "allowSimilar": zod.boolean().default(confirmProposalTasksResponseTasksItemAllowSimilarDefault)
})),
  "warnings": zod.array(zod.string()),
  "activityIds": zod.array(zod.uuid()),
  "expiresAt": zod.iso.datetime({"offset":true})
})


export const getCampaignAutonomyQueryParams = zod.object({
  "campaignId": zod.uuid().optional()
})

export const getCampaignAutonomyResponse = zod.object({
  "policyVersion": zod.int(),
  "validationVersion": zod.int(),
  "approvalVersion": zod.int(),
  "enabled": zod.boolean(),
  "authorized": zod.boolean(),
  "reasons": zod.array(zod.string()),
  "policy": zod.record(zod.string(), zod.unknown()).nullable(),
  "validation": zod.record(zod.string(), zod.unknown()).nullable(),
  "approval": zod.record(zod.string(), zod.unknown()).nullable()
})


export const reviewCampaignAutonomyBodyChangeExpectedVersionMin = 0;

export const reviewCampaignAutonomyBodyChangeFieldsOneEvidenceMin = 10;
export const reviewCampaignAutonomyBodyChangeFieldsOneEvidenceMax = 10000;

export const reviewCampaignAutonomyBodyChangeFieldsOneChannelsMax = 4;


export const reviewCampaignAutonomyBodyChangeFieldsTwoBoundsChannelsMax = 4;

export const reviewCampaignAutonomyBodyChangeFieldsTwoBoundsMaxRecipientsMax = 20000;

export const reviewCampaignAutonomyBodyChangeFieldsTwoBoundsMaxSendsMax = 100000;

export const reviewCampaignAutonomyBodyChangeFieldsTwoBoundsMaxCostMinorMin = 0;
export const reviewCampaignAutonomyBodyChangeFieldsTwoBoundsMaxCostMinorMax = 100000000;

export const reviewCampaignAutonomyBodyChangeFieldsTwoBoundsCurrencyRegExp = new RegExp('^[A-Z]{3}$');

export const reviewCampaignAutonomyBodyChangeFieldsThreeBoundsChannelsMax = 4;

export const reviewCampaignAutonomyBodyChangeFieldsThreeBoundsMaxRecipientsMax = 20000;

export const reviewCampaignAutonomyBodyChangeFieldsThreeBoundsMaxSendsMax = 100000;

export const reviewCampaignAutonomyBodyChangeFieldsThreeBoundsMaxCostMinorMin = 0;
export const reviewCampaignAutonomyBodyChangeFieldsThreeBoundsMaxCostMinorMax = 100000000;

export const reviewCampaignAutonomyBodyChangeFieldsThreeBoundsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviewCampaignAutonomyBodyChangeReasonMin = 3;
export const reviewCampaignAutonomyBodyChangeReasonMax = 2000;



export const reviewCampaignAutonomyBody = zod.object({
  "conversationId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['validate', 'enable', 'disable', 'approve', 'revoke']),
  "campaignId": zod.uuid().optional(),
  "expectedVersion": zod.int().min(reviewCampaignAutonomyBodyChangeExpectedVersionMin),
  "fields": zod.union([zod.object({
  "evidence": zod.string().min(reviewCampaignAutonomyBodyChangeFieldsOneEvidenceMin).max(reviewCampaignAutonomyBodyChangeFieldsOneEvidenceMax),
  "validatedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "channels": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social_post'])).min(1).max(reviewCampaignAutonomyBodyChangeFieldsOneChannelsMax)
}),zod.object({
  "validationVersion": zod.int().min(1),
  "bounds": zod.object({
  "channels": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social_post'])).min(1).max(reviewCampaignAutonomyBodyChangeFieldsTwoBoundsChannelsMax),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "maxRecipients": zod.int().min(1).max(reviewCampaignAutonomyBodyChangeFieldsTwoBoundsMaxRecipientsMax),
  "maxSends": zod.int().min(1).max(reviewCampaignAutonomyBodyChangeFieldsTwoBoundsMaxSendsMax),
  "maxCostMinor": zod.int().min(reviewCampaignAutonomyBodyChangeFieldsTwoBoundsMaxCostMinorMin).max(reviewCampaignAutonomyBodyChangeFieldsTwoBoundsMaxCostMinorMax),
  "currency": zod.string().regex(reviewCampaignAutonomyBodyChangeFieldsTwoBoundsCurrencyRegExp)
}),
  "confirmed": zod.literal(true)
}),zod.object({
  "policyVersion": zod.int().min(1),
  "bounds": zod.object({
  "channels": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social_post'])).min(1).max(reviewCampaignAutonomyBodyChangeFieldsThreeBoundsChannelsMax),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "maxRecipients": zod.int().min(1).max(reviewCampaignAutonomyBodyChangeFieldsThreeBoundsMaxRecipientsMax),
  "maxSends": zod.int().min(1).max(reviewCampaignAutonomyBodyChangeFieldsThreeBoundsMaxSendsMax),
  "maxCostMinor": zod.int().min(reviewCampaignAutonomyBodyChangeFieldsThreeBoundsMaxCostMinorMin).max(reviewCampaignAutonomyBodyChangeFieldsThreeBoundsMaxCostMinorMax),
  "currency": zod.string().regex(reviewCampaignAutonomyBodyChangeFieldsThreeBoundsCurrencyRegExp)
}),
  "autonomousExecution": zod.literal(true)
}),zod.object({

})]),
  "reason": zod.string().min(reviewCampaignAutonomyBodyChangeReasonMin).max(reviewCampaignAutonomyBodyChangeReasonMax)
})
})


export const reviewCampaignAutonomyResponseReviewDestructiveDefault = false;

export const reviewCampaignAutonomyResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(reviewCampaignAutonomyResponseReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})


/**
 * @summary Complete authorized lifecycle metrics and exact filtered record drilldown
 */
export const getLifecycleInsightsQueryAudienceDefault = `all`;
export const getLifecycleInsightsQueryGroupByDefault = `source`;
export const getLifecycleInsightsQueryGroupKeyMax = 200;

export const getLifecycleInsightsQueryOwnerIdMax = 200;

export const getLifecycleInsightsQueryStatusMax = 120;

export const getLifecycleInsightsQueryDateStateDefault = `all`;
export const getLifecycleInsightsQueryArchiveStateDefault = `active`;
export const getLifecycleInsightsQueryCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getLifecycleInsightsQueryIncludeTestDataDefault = false;
export const getLifecycleInsightsQueryLimitDefault = 20;
export const getLifecycleInsightsQueryLimitMax = 100;

export const getLifecycleInsightsQueryOffsetDefault = 0;
export const getLifecycleInsightsQueryOffsetMin = 0;

export const getLifecycleInsightsQueryGroupLimitDefault = 20;
export const getLifecycleInsightsQueryGroupLimitMax = 100;

export const getLifecycleInsightsQueryGroupOffsetDefault = 0;
export const getLifecycleInsightsQueryGroupOffsetMin = 0;



export const getLifecycleInsightsQueryParams = zod.object({
  "asOf": zod.iso.datetime({"offset":true}).optional(),
  "responseState": zod.enum(['missing', 'recorded', 'met', 'late', 'due', 'overdue', 'pending']).optional(),
  "resolutionState": zod.enum(['missing', 'recorded', 'met', 'late', 'due', 'overdue', 'pending']).optional(),
  "sourceKind": zod.enum(['segment', 'referral', 'stakeholder', 'activity', 'improvement', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan', 'quality_decision', 'retention_decision', 'opportunity']).optional(),
  "audience": zod.enum(['all', 'b2b', 'b2c', 'partner', 'investor']).default(getLifecycleInsightsQueryAudienceDefault),
  "groupBy": zod.enum(['source', 'status', 'owner', 'month']).default(getLifecycleInsightsQueryGroupByDefault),
  "groupKey": zod.string().max(getLifecycleInsightsQueryGroupKeyMax).optional(),
  "ownerId": zod.string().max(getLifecycleInsightsQueryOwnerIdMax).optional(),
  "status": zod.string().max(getLifecycleInsightsQueryStatusMax).optional(),
  "from": zod.iso.date().optional(),
  "to": zod.iso.date().optional(),
  "dateState": zod.enum(['all', 'known', 'missing']).default(getLifecycleInsightsQueryDateStateDefault),
  "archiveState": zod.enum(['active', 'archived', 'all']).default(getLifecycleInsightsQueryArchiveStateDefault),
  "recordId": zod.uuid().optional(),
  "currency": zod.string().regex(getLifecycleInsightsQueryCurrencyRegExp).optional(),
  "ratingScale": zod.enum(['one_to_five']).optional(),
  "includeTestData": zod.boolean().default(getLifecycleInsightsQueryIncludeTestDataDefault),
  "limit": zod.int().min(1).max(getLifecycleInsightsQueryLimitMax).default(getLifecycleInsightsQueryLimitDefault),
  "offset": zod.int().min(getLifecycleInsightsQueryOffsetMin).default(getLifecycleInsightsQueryOffsetDefault),
  "groupLimit": zod.int().min(1).max(getLifecycleInsightsQueryGroupLimitMax).default(getLifecycleInsightsQueryGroupLimitDefault),
  "groupOffset": zod.int().min(getLifecycleInsightsQueryGroupOffsetMin).default(getLifecycleInsightsQueryGroupOffsetDefault)
})

export const getLifecycleInsightsResponse = zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "calculation": zod.string(),
  "sources": zod.array(zod.object({
  "kind": zod.enum(['segment', 'referral', 'stakeholder', 'activity', 'improvement', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan', 'quality_decision', 'retention_decision', 'opportunity']),
  "available": zod.boolean(),
  "explanation": zod.string(),
  "dateBasis": zod.string()
})),
  "total": zod.int(),
  "missingDate": zod.int(),
  "missingOwner": zod.int(),
  "missingValue": zod.int(),
  "missingProbability": zod.int(),
  "missingCurrency": zod.int(),
  "missingRating": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "groupTotal": zod.int(),
  "groupLimit": zod.int(),
  "groupOffset": zod.int(),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['segment', 'referral', 'stakeholder', 'activity', 'improvement', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan', 'quality_decision', 'retention_decision', 'opportunity']),
  "title": zod.string(),
  "status": zod.string().nullable(),
  "ownerId": zod.string().nullable(),
  "date": zod.string().nullable(),
  "dateBasis": zod.string(),
  "nativePath": zod.string(),
  "archived": zod.boolean(),
  "currency": zod.string().nullable(),
  "value": zod.string().nullable(),
  "weighted": zod.string().nullable(),
  "rating": zod.number().nullable(),
  "ratingScale": zod.string().nullable(),
  "responseState": zod.string().nullable(),
  "resolutionState": zod.string().nullable()
})),
  "groups": zod.array(zod.object({
  "key": zod.string(),
  "count": zod.int(),
  "drilldown": zod.string()
})),
  "money": zod.array(zod.object({
  "currency": zod.string().nullable(),
  "outcome": zod.string(),
  "count": zod.int(),
  "gross": zod.string().nullable(),
  "grossCount": zod.int(),
  "weighted": zod.string().nullable(),
  "weightedCount": zod.int()
})),
  "ratings": zod.array(zod.object({
  "scale": zod.string(),
  "count": zod.int(),
  "average": zod.string()
})),
  "serviceStates": zod.array(zod.object({
  "kind": zod.enum(['response', 'resolution']),
  "state": zod.string(),
  "count": zod.int(),
  "drilldown": zod.string()
}))
})


export const listRetentionQueryLimitDefault = 20;
export const listRetentionQueryLimitMax = 100;

export const listRetentionQueryOffsetDefault = 0;
export const listRetentionQueryOffsetMin = 0;

export const listRetentionQuerySearchMax = 200;

export const listRetentionQueryStateDefault = `active`;
export const listRetentionQueryReviewStateDefault = `all`;
export const listRetentionQueryIncludeTestDataDefault = false;

export const listRetentionQueryParams = zod.object({
  "limit": zod.int().min(1).max(listRetentionQueryLimitMax).default(listRetentionQueryLimitDefault),
  "offset": zod.int().min(listRetentionQueryOffsetMin).default(listRetentionQueryOffsetDefault),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']).optional(),
  "search": zod.string().max(listRetentionQuerySearchMax).optional(),
  "state": zod.enum(['all', 'active', 'archived']).default(listRetentionQueryStateDefault),
  "reviewState": zod.enum(['all', 'unreviewed', 'due', 'scheduled']).default(listRetentionQueryReviewStateDefault),
  "reviewOnOrBefore": zod.iso.date().optional(),
  "includeTestData": zod.boolean().default(listRetentionQueryIncludeTestDataDefault)
})

export const listRetentionResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getRetentionParams = zod.object({
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "id": zod.uuid()
})

export const getRetentionResponse = zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
})


export const listRetentionHistoryParams = zod.object({
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "id": zod.uuid()
})

export const listRetentionHistoryQueryLimitDefault = 20;
export const listRetentionHistoryQueryLimitMax = 100;

export const listRetentionHistoryQueryOffsetDefault = 0;
export const listRetentionHistoryQueryOffsetMin = 0;



export const listRetentionHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listRetentionHistoryQueryLimitMax).default(listRetentionHistoryQueryLimitDefault),
  "offset": zod.int().min(listRetentionHistoryQueryOffsetMin).default(listRetentionHistoryQueryOffsetDefault)
})

export const listRetentionHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "actorId": zod.string(),
  "reason": zod.string(),
  "operation": zod.string(),
  "createdAt": zod.string(),
  "snapshot": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})



export const reviewRetentionChangeBodyChangeReasonMin = 3;
export const reviewRetentionChangeBodyChangeReasonMax = 500;



export const reviewRetentionChangeBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['review', 'retain', 'archive', 'unarchive']),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().min(reviewRetentionChangeBodyChangeReasonMin).max(reviewRetentionChangeBodyChangeReasonMax)
})
})


export const reviewRetentionChangeResponseChangeReasonMin = 3;
export const reviewRetentionChangeResponseChangeReasonMax = 500;



export const reviewRetentionChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['review', 'retain', 'archive', 'unarchive']),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().min(reviewRetentionChangeResponseChangeReasonMin).max(reviewRetentionChangeResponseChangeReasonMax)
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
}),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
}),zod.null()])
})


export const getRetentionChangeParams = zod.object({
  "id": zod.uuid()
})


export const getRetentionChangeResponseChangeReasonMin = 3;
export const getRetentionChangeResponseChangeReasonMax = 500;



export const getRetentionChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['review', 'retain', 'archive', 'unarchive']),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().min(getRetentionChangeResponseChangeReasonMin).max(getRetentionChangeResponseChangeReasonMax)
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
}),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
}),zod.null()])
})


export const confirmRetentionChangeParams = zod.object({
  "id": zod.uuid()
})




export const confirmRetentionChangeBody = zod.object({
  "hash": zod.string().min(1),
  "confirmation": zod.enum(['CONFIRM'])
})


export const confirmRetentionChangeResponseChangeReasonMin = 3;
export const confirmRetentionChangeResponseChangeReasonMax = 500;



export const confirmRetentionChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['review', 'retain', 'archive', 'unarchive']),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().min(confirmRetentionChangeResponseChangeReasonMin).max(confirmRetentionChangeResponseChangeReasonMax)
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
}),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
}),zod.null()])
})


export const cancelRetentionChangeParams = zod.object({
  "id": zod.uuid()
})


export const cancelRetentionChangeResponseChangeReasonMin = 3;
export const cancelRetentionChangeResponseChangeReasonMax = 500;



export const cancelRetentionChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['review', 'retain', 'archive', 'unarchive']),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().min(cancelRetentionChangeResponseChangeReasonMin).max(cancelRetentionChangeResponseChangeReasonMax)
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
}),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'segment', 'referral', 'stakeholder', 'activity', 'opportunity_note', 'general_agreement', 'obligation', 'delivery', 'case', 'account_review', 'renewal_plan']),
  "label": zod.string(),
  "nativePath": zod.string(),
  "version": zod.string(),
  "state": zod.enum(['active', 'archived']),
  "reviewOn": zod.iso.date().nullable(),
  "reason": zod.string().nullable(),
  "decision": zod.string().nullable(),
  "actorId": zod.string().nullable(),
  "decidedAt": zod.string().nullable(),
  "archivedAt": zod.string().nullable()
}),zod.null()])
})


export const listDataQualityQueryIncludeTestDataDefault = false;
export const listDataQualityQueryLimitDefault = 20;
export const listDataQualityQueryLimitMax = 100;

export const listDataQualityQueryOffsetDefault = 0;
export const listDataQualityQueryOffsetMin = 0;



export const listDataQualityQueryParams = zod.object({
  "search": zod.string().optional(),
  "ownerId": zod.string().optional(),
  "finding": zod.string().optional(),
  "decision": zod.string().optional(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']).optional(),
  "includeTestData": zod.boolean().default(listDataQualityQueryIncludeTestDataDefault),
  "limit": zod.int().min(1).max(listDataQualityQueryLimitMax).default(listDataQualityQueryLimitDefault),
  "offset": zod.int().min(listDataQualityQueryOffsetMin).default(listDataQualityQueryOffsetDefault)
})

export const listDataQualityResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getDataQualityParams = zod.object({
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "id": zod.uuid()
})

export const getDataQualityResponse = zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
})


export const listDataQualityCandidatesParams = zod.object({
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "id": zod.uuid()
})

export const listDataQualityCandidatesQueryLimitDefault = 20;
export const listDataQualityCandidatesQueryLimitMax = 100;

export const listDataQualityCandidatesQueryOffsetDefault = 0;
export const listDataQualityCandidatesQueryOffsetMin = 0;



export const listDataQualityCandidatesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDataQualityCandidatesQueryLimitMax).default(listDataQualityCandidatesQueryLimitDefault),
  "offset": zod.int().min(listDataQualityCandidatesQueryOffsetMin).default(listDataQualityCandidatesQueryOffsetDefault)
})

export const listDataQualityCandidatesResponse = zod.object({
  "items": zod.array(zod.object({
  "record": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),
  "reasons": zod.array(zod.string())
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const listDataQualityHistoryParams = zod.object({
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "id": zod.uuid()
})

export const listDataQualityHistoryQueryLimitDefault = 20;
export const listDataQualityHistoryQueryLimitMax = 100;

export const listDataQualityHistoryQueryOffsetDefault = 0;
export const listDataQualityHistoryQueryOffsetMin = 0;



export const listDataQualityHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDataQualityHistoryQueryLimitMax).default(listDataQualityHistoryQueryLimitDefault),
  "offset": zod.int().min(listDataQualityHistoryQueryOffsetMin).default(listDataQualityHistoryQueryOffsetDefault)
})

export const listDataQualityHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "actorId": zod.string(),
  "reason": zod.string(),
  "operation": zod.string(),
  "createdAt": zod.string(),
  "snapshot": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const listDataQualityOwnersQueryLimitDefault = 20;
export const listDataQualityOwnersQueryLimitMax = 100;

export const listDataQualityOwnersQueryOffsetDefault = 0;
export const listDataQualityOwnersQueryOffsetMin = 0;



export const listDataQualityOwnersQueryParams = zod.object({
  "search": zod.string().optional(),
  "limit": zod.int().min(1).max(listDataQualityOwnersQueryLimitMax).default(listDataQualityOwnersQueryLimitDefault),
  "offset": zod.int().min(listDataQualityOwnersQueryOffsetMin).default(listDataQualityOwnersQueryOffsetDefault)
})

export const listDataQualityOwnersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "revision": zod.string(),
  "versionId": zod.uuid().optional()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})



export const reviewDataQualityChangeBodyChangeReasonMin = 3;
export const reviewDataQualityChangeBodyChangeReasonMax = 500;




export const reviewDataQualityChangeBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['prefer', 'distinct', 'reverse', 'reassign']),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(reviewDataQualityChangeBodyChangeReasonMin).max(reviewDataQualityChangeBodyChangeReasonMax),
  "targetId": zod.uuid().optional(),
  "expectedTargetVersion": zod.string().min(1).optional(),
  "ownerId": zod.uuid().nullish()
})
})


export const reviewDataQualityChangeResponseChangeReasonMin = 3;
export const reviewDataQualityChangeResponseChangeReasonMax = 500;




export const reviewDataQualityChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['prefer', 'distinct', 'reverse', 'reassign']),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(reviewDataQualityChangeResponseChangeReasonMin).max(reviewDataQualityChangeResponseChangeReasonMax),
  "targetId": zod.uuid().optional(),
  "expectedTargetVersion": zod.string().min(1).optional(),
  "ownerId": zod.uuid().nullish()
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),
  "target": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),zod.null()]),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),zod.null()])
})


export const getDataQualityChangeParams = zod.object({
  "id": zod.uuid()
})


export const getDataQualityChangeResponseChangeReasonMin = 3;
export const getDataQualityChangeResponseChangeReasonMax = 500;




export const getDataQualityChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['prefer', 'distinct', 'reverse', 'reassign']),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(getDataQualityChangeResponseChangeReasonMin).max(getDataQualityChangeResponseChangeReasonMax),
  "targetId": zod.uuid().optional(),
  "expectedTargetVersion": zod.string().min(1).optional(),
  "ownerId": zod.uuid().nullish()
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),
  "target": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),zod.null()]),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),zod.null()])
})


export const confirmDataQualityChangeParams = zod.object({
  "id": zod.uuid()
})




export const confirmDataQualityChangeBody = zod.object({
  "hash": zod.string().min(1),
  "confirmation": zod.enum(['CONFIRM'])
})


export const confirmDataQualityChangeResponseChangeReasonMin = 3;
export const confirmDataQualityChangeResponseChangeReasonMax = 500;




export const confirmDataQualityChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['prefer', 'distinct', 'reverse', 'reassign']),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(confirmDataQualityChangeResponseChangeReasonMin).max(confirmDataQualityChangeResponseChangeReasonMax),
  "targetId": zod.uuid().optional(),
  "expectedTargetVersion": zod.string().min(1).optional(),
  "ownerId": zod.uuid().nullish()
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),
  "target": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),zod.null()]),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),zod.null()])
})


export const cancelDataQualityChangeParams = zod.object({
  "id": zod.uuid()
})


export const cancelDataQualityChangeResponseChangeReasonMin = 3;
export const cancelDataQualityChangeResponseChangeReasonMax = 500;




export const cancelDataQualityChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['prefer', 'distinct', 'reverse', 'reassign']),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(cancelDataQualityChangeResponseChangeReasonMin).max(cancelDataQualityChangeResponseChangeReasonMax),
  "targetId": zod.uuid().optional(),
  "expectedTargetVersion": zod.string().min(1).optional(),
  "ownerId": zod.uuid().nullish()
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),
  "target": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),zod.null()]),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'activity', 'tender']),
  "label": zod.string(),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "version": zod.string(),
  "nativePath": zod.string(),
  "findings": zod.array(zod.string()),
  "decisions": zod.array(zod.object({
  "id": zod.string(),
  "otherId": zod.string(),
  "decision": zod.enum(['preferred', 'distinct', 'reversed']),
  "preferredId": zod.string().nullable(),
  "reason": zod.string(),
  "actorId": zod.string(),
  "version": zod.int(),
  "updatedAt": zod.string()
})),
  "facts": zod.record(zod.string(), zod.string().nullable())
}),zod.null()])
})


export const listRenewalPlanningQueryLimitDefault = 20;
export const listRenewalPlanningQueryLimitMax = 100;

export const listRenewalPlanningQueryOffsetDefault = 0;
export const listRenewalPlanningQueryOffsetMin = 0;



export const listRenewalPlanningQueryParams = zod.object({
  "search": zod.string().optional(),
  "accountId": zod.string().optional(),
  "ownerId": zod.string().optional(),
  "sourceKind": zod.string().optional(),
  "decision": zod.string().optional(),
  "dateState": zod.string().optional(),
  "from": zod.string().optional(),
  "to": zod.string().optional(),
  "followUpFrom": zod.string().optional(),
  "followUpTo": zod.string().optional(),
  "limit": zod.int().min(1).max(listRenewalPlanningQueryLimitMax).default(listRenewalPlanningQueryLimitDefault),
  "offset": zod.int().min(listRenewalPlanningQueryOffsetMin).default(listRenewalPlanningQueryOffsetDefault)
})

export const listRenewalPlanningResponseItemsItemFieldsDecisionMax = 120;

export const listRenewalPlanningResponseItemsItemFieldsNextStepsMax = 10000;



export const listRenewalPlanningResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(listRenewalPlanningResponseItemsItemFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(listRenewalPlanningResponseItemsItemFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getRenewalPlanningParams = zod.object({
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "id": zod.uuid()
})

export const getRenewalPlanningResponseFieldsDecisionMax = 120;

export const getRenewalPlanningResponseFieldsNextStepsMax = 10000;



export const getRenewalPlanningResponse = zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(getRenewalPlanningResponseFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(getRenewalPlanningResponseFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
})


export const listRenewalPlanningHistoryParams = zod.object({
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "id": zod.uuid()
})

export const listRenewalPlanningHistoryQueryLimitDefault = 20;
export const listRenewalPlanningHistoryQueryLimitMax = 100;

export const listRenewalPlanningHistoryQueryOffsetDefault = 0;
export const listRenewalPlanningHistoryQueryOffsetMin = 0;



export const listRenewalPlanningHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listRenewalPlanningHistoryQueryLimitMax).default(listRenewalPlanningHistoryQueryLimitDefault),
  "offset": zod.int().min(listRenewalPlanningHistoryQueryOffsetMin).default(listRenewalPlanningHistoryQueryOffsetDefault)
})

export const listRenewalPlanningHistoryResponseItemsItemSnapshotFieldsDecisionMax = 120;

export const listRenewalPlanningHistoryResponseItemsItemSnapshotFieldsNextStepsMax = 10000;



export const listRenewalPlanningHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "actorId": zod.string(),
  "reason": zod.string(),
  "createdAt": zod.string(),
  "snapshot": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(listRenewalPlanningHistoryResponseItemsItemSnapshotFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(listRenewalPlanningHistoryResponseItemsItemSnapshotFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})



export const reviewRenewalPlanningChangeBodyChangeReasonMin = 3;
export const reviewRenewalPlanningChangeBodyChangeReasonMax = 500;

export const reviewRenewalPlanningChangeBodyChangeFieldsDecisionMax = 120;

export const reviewRenewalPlanningChangeBodyChangeFieldsNextStepsMax = 10000;

export const reviewRenewalPlanningChangeBodyChangeOpportunityTitleMax = 300;

export const reviewRenewalPlanningChangeBodyChangeOpportunityCurrencyMin = 3;
export const reviewRenewalPlanningChangeBodyChangeOpportunityCurrencyMax = 3;

export const reviewRenewalPlanningChangeBodyChangeOpportunityProbabilityMin = 0;
export const reviewRenewalPlanningChangeBodyChangeOpportunityProbabilityMax = 100;

export const reviewRenewalPlanningChangeBodyChangeOpportunityIsTestDataDefault = false;
export const reviewRenewalPlanningChangeBodyChangeReferralPartyTextMax = 500;

export const reviewRenewalPlanningChangeBodyChangeReferralNotesMax = 10000;

export const reviewRenewalPlanningChangeBodyChangeReferralOutcomeMax = 120;



export const reviewRenewalPlanningChangeBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['save', 'renew_product', 'create_opportunity', 'create_referral']),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(reviewRenewalPlanningChangeBodyChangeReasonMin).max(reviewRenewalPlanningChangeBodyChangeReasonMax),
  "fields": zod.object({
  "decision": zod.string().min(1).max(reviewRenewalPlanningChangeBodyChangeFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(reviewRenewalPlanningChangeBodyChangeFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}).optional(),
  "renewal": zod.object({
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "opportunity": zod.object({
  "title": zod.string().min(1).max(reviewRenewalPlanningChangeBodyChangeOpportunityTitleMax),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']).optional(),
  "value": zod.number().nullish(),
  "currency": zod.string().min(reviewRenewalPlanningChangeBodyChangeOpportunityCurrencyMin).max(reviewRenewalPlanningChangeBodyChangeOpportunityCurrencyMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(reviewRenewalPlanningChangeBodyChangeOpportunityProbabilityMin).max(reviewRenewalPlanningChangeBodyChangeOpportunityProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewRenewalPlanningChangeBodyChangeOpportunityIsTestDataDefault),
  "notes": zod.string().nullish()
}).optional(),
  "referral": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(reviewRenewalPlanningChangeBodyChangeReferralPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(reviewRenewalPlanningChangeBodyChangeReferralNotesMax).optional(),
  "outcome": zod.string().min(1).max(reviewRenewalPlanningChangeBodyChangeReferralOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional()
})
})


export const reviewRenewalPlanningChangeResponseChangeReasonMin = 3;
export const reviewRenewalPlanningChangeResponseChangeReasonMax = 500;

export const reviewRenewalPlanningChangeResponseChangeFieldsDecisionMax = 120;

export const reviewRenewalPlanningChangeResponseChangeFieldsNextStepsMax = 10000;

export const reviewRenewalPlanningChangeResponseChangeOpportunityTitleMax = 300;

export const reviewRenewalPlanningChangeResponseChangeOpportunityCurrencyMin = 3;
export const reviewRenewalPlanningChangeResponseChangeOpportunityCurrencyMax = 3;

export const reviewRenewalPlanningChangeResponseChangeOpportunityProbabilityMin = 0;
export const reviewRenewalPlanningChangeResponseChangeOpportunityProbabilityMax = 100;

export const reviewRenewalPlanningChangeResponseChangeOpportunityIsTestDataDefault = false;
export const reviewRenewalPlanningChangeResponseChangeReferralPartyTextMax = 500;

export const reviewRenewalPlanningChangeResponseChangeReferralNotesMax = 10000;

export const reviewRenewalPlanningChangeResponseChangeReferralOutcomeMax = 120;

export const reviewRenewalPlanningChangeResponseBeforeFieldsDecisionMax = 120;

export const reviewRenewalPlanningChangeResponseBeforeFieldsNextStepsMax = 10000;

export const reviewRenewalPlanningChangeResponseAfterDecisionMax = 120;

export const reviewRenewalPlanningChangeResponseAfterNextStepsMax = 10000;

export const reviewRenewalPlanningChangeResponseReceiptOneFieldsDecisionMax = 120;

export const reviewRenewalPlanningChangeResponseReceiptOneFieldsNextStepsMax = 10000;



export const reviewRenewalPlanningChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['save', 'renew_product', 'create_opportunity', 'create_referral']),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(reviewRenewalPlanningChangeResponseChangeReasonMin).max(reviewRenewalPlanningChangeResponseChangeReasonMax),
  "fields": zod.object({
  "decision": zod.string().min(1).max(reviewRenewalPlanningChangeResponseChangeFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(reviewRenewalPlanningChangeResponseChangeFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}).optional(),
  "renewal": zod.object({
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "opportunity": zod.object({
  "title": zod.string().min(1).max(reviewRenewalPlanningChangeResponseChangeOpportunityTitleMax),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']).optional(),
  "value": zod.number().nullish(),
  "currency": zod.string().min(reviewRenewalPlanningChangeResponseChangeOpportunityCurrencyMin).max(reviewRenewalPlanningChangeResponseChangeOpportunityCurrencyMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(reviewRenewalPlanningChangeResponseChangeOpportunityProbabilityMin).max(reviewRenewalPlanningChangeResponseChangeOpportunityProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewRenewalPlanningChangeResponseChangeOpportunityIsTestDataDefault),
  "notes": zod.string().nullish()
}).optional(),
  "referral": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(reviewRenewalPlanningChangeResponseChangeReferralPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(reviewRenewalPlanningChangeResponseChangeReferralNotesMax).optional(),
  "outcome": zod.string().min(1).max(reviewRenewalPlanningChangeResponseChangeReferralOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional()
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(reviewRenewalPlanningChangeResponseBeforeFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(reviewRenewalPlanningChangeResponseBeforeFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
}),
  "after": zod.object({
  "decision": zod.string().min(1).max(reviewRenewalPlanningChangeResponseAfterDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(reviewRenewalPlanningChangeResponseAfterNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(reviewRenewalPlanningChangeResponseReceiptOneFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(reviewRenewalPlanningChangeResponseReceiptOneFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
}),zod.null()])
})


export const getRenewalPlanningChangeParams = zod.object({
  "id": zod.uuid()
})


export const getRenewalPlanningChangeResponseChangeReasonMin = 3;
export const getRenewalPlanningChangeResponseChangeReasonMax = 500;

export const getRenewalPlanningChangeResponseChangeFieldsDecisionMax = 120;

export const getRenewalPlanningChangeResponseChangeFieldsNextStepsMax = 10000;

export const getRenewalPlanningChangeResponseChangeOpportunityTitleMax = 300;

export const getRenewalPlanningChangeResponseChangeOpportunityCurrencyMin = 3;
export const getRenewalPlanningChangeResponseChangeOpportunityCurrencyMax = 3;

export const getRenewalPlanningChangeResponseChangeOpportunityProbabilityMin = 0;
export const getRenewalPlanningChangeResponseChangeOpportunityProbabilityMax = 100;

export const getRenewalPlanningChangeResponseChangeOpportunityIsTestDataDefault = false;
export const getRenewalPlanningChangeResponseChangeReferralPartyTextMax = 500;

export const getRenewalPlanningChangeResponseChangeReferralNotesMax = 10000;

export const getRenewalPlanningChangeResponseChangeReferralOutcomeMax = 120;

export const getRenewalPlanningChangeResponseBeforeFieldsDecisionMax = 120;

export const getRenewalPlanningChangeResponseBeforeFieldsNextStepsMax = 10000;

export const getRenewalPlanningChangeResponseAfterDecisionMax = 120;

export const getRenewalPlanningChangeResponseAfterNextStepsMax = 10000;

export const getRenewalPlanningChangeResponseReceiptOneFieldsDecisionMax = 120;

export const getRenewalPlanningChangeResponseReceiptOneFieldsNextStepsMax = 10000;



export const getRenewalPlanningChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['save', 'renew_product', 'create_opportunity', 'create_referral']),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(getRenewalPlanningChangeResponseChangeReasonMin).max(getRenewalPlanningChangeResponseChangeReasonMax),
  "fields": zod.object({
  "decision": zod.string().min(1).max(getRenewalPlanningChangeResponseChangeFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(getRenewalPlanningChangeResponseChangeFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}).optional(),
  "renewal": zod.object({
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "opportunity": zod.object({
  "title": zod.string().min(1).max(getRenewalPlanningChangeResponseChangeOpportunityTitleMax),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']).optional(),
  "value": zod.number().nullish(),
  "currency": zod.string().min(getRenewalPlanningChangeResponseChangeOpportunityCurrencyMin).max(getRenewalPlanningChangeResponseChangeOpportunityCurrencyMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(getRenewalPlanningChangeResponseChangeOpportunityProbabilityMin).max(getRenewalPlanningChangeResponseChangeOpportunityProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(getRenewalPlanningChangeResponseChangeOpportunityIsTestDataDefault),
  "notes": zod.string().nullish()
}).optional(),
  "referral": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(getRenewalPlanningChangeResponseChangeReferralPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(getRenewalPlanningChangeResponseChangeReferralNotesMax).optional(),
  "outcome": zod.string().min(1).max(getRenewalPlanningChangeResponseChangeReferralOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional()
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(getRenewalPlanningChangeResponseBeforeFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(getRenewalPlanningChangeResponseBeforeFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
}),
  "after": zod.object({
  "decision": zod.string().min(1).max(getRenewalPlanningChangeResponseAfterDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(getRenewalPlanningChangeResponseAfterNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(getRenewalPlanningChangeResponseReceiptOneFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(getRenewalPlanningChangeResponseReceiptOneFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
}),zod.null()])
})


export const confirmRenewalPlanningChangeParams = zod.object({
  "id": zod.uuid()
})




export const confirmRenewalPlanningChangeBody = zod.object({
  "hash": zod.string().min(1),
  "confirmation": zod.enum(['CONFIRM'])
})


export const confirmRenewalPlanningChangeResponseChangeReasonMin = 3;
export const confirmRenewalPlanningChangeResponseChangeReasonMax = 500;

export const confirmRenewalPlanningChangeResponseChangeFieldsDecisionMax = 120;

export const confirmRenewalPlanningChangeResponseChangeFieldsNextStepsMax = 10000;

export const confirmRenewalPlanningChangeResponseChangeOpportunityTitleMax = 300;

export const confirmRenewalPlanningChangeResponseChangeOpportunityCurrencyMin = 3;
export const confirmRenewalPlanningChangeResponseChangeOpportunityCurrencyMax = 3;

export const confirmRenewalPlanningChangeResponseChangeOpportunityProbabilityMin = 0;
export const confirmRenewalPlanningChangeResponseChangeOpportunityProbabilityMax = 100;

export const confirmRenewalPlanningChangeResponseChangeOpportunityIsTestDataDefault = false;
export const confirmRenewalPlanningChangeResponseChangeReferralPartyTextMax = 500;

export const confirmRenewalPlanningChangeResponseChangeReferralNotesMax = 10000;

export const confirmRenewalPlanningChangeResponseChangeReferralOutcomeMax = 120;

export const confirmRenewalPlanningChangeResponseBeforeFieldsDecisionMax = 120;

export const confirmRenewalPlanningChangeResponseBeforeFieldsNextStepsMax = 10000;

export const confirmRenewalPlanningChangeResponseAfterDecisionMax = 120;

export const confirmRenewalPlanningChangeResponseAfterNextStepsMax = 10000;

export const confirmRenewalPlanningChangeResponseReceiptOneFieldsDecisionMax = 120;

export const confirmRenewalPlanningChangeResponseReceiptOneFieldsNextStepsMax = 10000;



export const confirmRenewalPlanningChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['save', 'renew_product', 'create_opportunity', 'create_referral']),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(confirmRenewalPlanningChangeResponseChangeReasonMin).max(confirmRenewalPlanningChangeResponseChangeReasonMax),
  "fields": zod.object({
  "decision": zod.string().min(1).max(confirmRenewalPlanningChangeResponseChangeFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(confirmRenewalPlanningChangeResponseChangeFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}).optional(),
  "renewal": zod.object({
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "opportunity": zod.object({
  "title": zod.string().min(1).max(confirmRenewalPlanningChangeResponseChangeOpportunityTitleMax),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']).optional(),
  "value": zod.number().nullish(),
  "currency": zod.string().min(confirmRenewalPlanningChangeResponseChangeOpportunityCurrencyMin).max(confirmRenewalPlanningChangeResponseChangeOpportunityCurrencyMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(confirmRenewalPlanningChangeResponseChangeOpportunityProbabilityMin).max(confirmRenewalPlanningChangeResponseChangeOpportunityProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(confirmRenewalPlanningChangeResponseChangeOpportunityIsTestDataDefault),
  "notes": zod.string().nullish()
}).optional(),
  "referral": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(confirmRenewalPlanningChangeResponseChangeReferralPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(confirmRenewalPlanningChangeResponseChangeReferralNotesMax).optional(),
  "outcome": zod.string().min(1).max(confirmRenewalPlanningChangeResponseChangeReferralOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional()
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(confirmRenewalPlanningChangeResponseBeforeFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(confirmRenewalPlanningChangeResponseBeforeFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
}),
  "after": zod.object({
  "decision": zod.string().min(1).max(confirmRenewalPlanningChangeResponseAfterDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(confirmRenewalPlanningChangeResponseAfterNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(confirmRenewalPlanningChangeResponseReceiptOneFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(confirmRenewalPlanningChangeResponseReceiptOneFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
}),zod.null()])
})


export const cancelRenewalPlanningChangeParams = zod.object({
  "id": zod.uuid()
})


export const cancelRenewalPlanningChangeResponseChangeReasonMin = 3;
export const cancelRenewalPlanningChangeResponseChangeReasonMax = 500;

export const cancelRenewalPlanningChangeResponseChangeFieldsDecisionMax = 120;

export const cancelRenewalPlanningChangeResponseChangeFieldsNextStepsMax = 10000;

export const cancelRenewalPlanningChangeResponseChangeOpportunityTitleMax = 300;

export const cancelRenewalPlanningChangeResponseChangeOpportunityCurrencyMin = 3;
export const cancelRenewalPlanningChangeResponseChangeOpportunityCurrencyMax = 3;

export const cancelRenewalPlanningChangeResponseChangeOpportunityProbabilityMin = 0;
export const cancelRenewalPlanningChangeResponseChangeOpportunityProbabilityMax = 100;

export const cancelRenewalPlanningChangeResponseChangeOpportunityIsTestDataDefault = false;
export const cancelRenewalPlanningChangeResponseChangeReferralPartyTextMax = 500;

export const cancelRenewalPlanningChangeResponseChangeReferralNotesMax = 10000;

export const cancelRenewalPlanningChangeResponseChangeReferralOutcomeMax = 120;

export const cancelRenewalPlanningChangeResponseBeforeFieldsDecisionMax = 120;

export const cancelRenewalPlanningChangeResponseBeforeFieldsNextStepsMax = 10000;

export const cancelRenewalPlanningChangeResponseAfterDecisionMax = 120;

export const cancelRenewalPlanningChangeResponseAfterNextStepsMax = 10000;

export const cancelRenewalPlanningChangeResponseReceiptOneFieldsDecisionMax = 120;

export const cancelRenewalPlanningChangeResponseReceiptOneFieldsNextStepsMax = 10000;



export const cancelRenewalPlanningChangeResponse = zod.object({
  "id": zod.string(),
  "hash": zod.string(),
  "expiresAt": zod.string(),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['save', 'renew_product', 'create_opportunity', 'create_referral']),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "sourceId": zod.uuid(),
  "expectedVersion": zod.string().min(1),
  "reason": zod.string().min(cancelRenewalPlanningChangeResponseChangeReasonMin).max(cancelRenewalPlanningChangeResponseChangeReasonMax),
  "fields": zod.object({
  "decision": zod.string().min(1).max(cancelRenewalPlanningChangeResponseChangeFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(cancelRenewalPlanningChangeResponseChangeFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}).optional(),
  "renewal": zod.object({
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "opportunity": zod.object({
  "title": zod.string().min(1).max(cancelRenewalPlanningChangeResponseChangeOpportunityTitleMax),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']).optional(),
  "value": zod.number().nullish(),
  "currency": zod.string().min(cancelRenewalPlanningChangeResponseChangeOpportunityCurrencyMin).max(cancelRenewalPlanningChangeResponseChangeOpportunityCurrencyMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(cancelRenewalPlanningChangeResponseChangeOpportunityProbabilityMin).max(cancelRenewalPlanningChangeResponseChangeOpportunityProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(cancelRenewalPlanningChangeResponseChangeOpportunityIsTestDataDefault),
  "notes": zod.string().nullish()
}).optional(),
  "referral": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(cancelRenewalPlanningChangeResponseChangeReferralPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(cancelRenewalPlanningChangeResponseChangeReferralNotesMax).optional(),
  "outcome": zod.string().min(1).max(cancelRenewalPlanningChangeResponseChangeReferralOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional()
}),
  "before": zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(cancelRenewalPlanningChangeResponseBeforeFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(cancelRenewalPlanningChangeResponseBeforeFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
}),
  "after": zod.object({
  "decision": zod.string().min(1).max(cancelRenewalPlanningChangeResponseAfterDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(cancelRenewalPlanningChangeResponseAfterNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "effect": zod.string(),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['account', 'product', 'general_agreement', 'partner_agreement']),
  "accountId": zod.uuid(),
  "label": zod.string(),
  "sourceDate": zod.string().nullable(),
  "dateState": zod.enum(['missing', 'dated']),
  "version": zod.string(),
  "fields": zod.object({
  "decision": zod.string().min(1).max(cancelRenewalPlanningChangeResponseReceiptOneFieldsDecisionMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "nextSteps": zod.string().max(cancelRenewalPlanningChangeResponseReceiptOneFieldsNextStepsMax).nullish(),
  "followUpOn": zod.iso.date().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "referralId": zod.uuid().nullish()
}),
  "nativePath": zod.string()
}),zod.null()])
})


export const listAccountReviewsQuerySearchMax = 200;

export const listAccountReviewsQueryLimitDefault = 20;
export const listAccountReviewsQueryLimitMax = 100;

export const listAccountReviewsQueryOffsetDefault = 0;
export const listAccountReviewsQueryOffsetMin = 0;
export const listAccountReviewsQueryOffsetMax = 1000000;



export const listAccountReviewsQueryParams = zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().optional(),
  "ownerId": zod.uuid().optional(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "ratingState": zod.enum(['rated', 'unrated']).optional(),
  "search": zod.string().max(listAccountReviewsQuerySearchMax).optional(),
  "from": zod.iso.date().optional(),
  "to": zod.iso.date().optional(),
  "nextFrom": zod.iso.date().optional(),
  "nextTo": zod.iso.date().optional(),
  "limit": zod.int().min(1).max(listAccountReviewsQueryLimitMax).default(listAccountReviewsQueryLimitDefault),
  "offset": zod.int().min(listAccountReviewsQueryOffsetMin).max(listAccountReviewsQueryOffsetMax).default(listAccountReviewsQueryOffsetDefault)
})

export const listAccountReviewsResponseItemsItemFieldsTitleMax = 500;

export const listAccountReviewsResponseItemsItemFieldsSourceContextMax = 5000;

export const listAccountReviewsResponseItemsItemFieldsNotesMax = 10000;

export const listAccountReviewsResponseItemsItemFieldsOutcomeMax = 5000;

export const listAccountReviewsResponseItemsItemFieldsSatisfactionRatingMax = 5;

export const listAccountReviewsResponseItemsItemFieldsAdvocacyPurposeMax = 1000;

export const listAccountReviewsResponseItemsItemFieldsAdvocacyEvidenceMax = 5000;

export const listAccountReviewsResponseItemsItemFieldsEvidenceItemRevisionMax = 128;

export const listAccountReviewsResponseItemsItemFieldsEvidenceMax = 50;


export const listAccountReviewsResponseItemsItemTaskOneDurationMinutesMin = 0;

export const listAccountReviewsResponseItemsItemTaskOneIsTestDataDefault = false;

export const listAccountReviewsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(listAccountReviewsResponseItemsItemFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(listAccountReviewsResponseItemsItemFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(listAccountReviewsResponseItemsItemFieldsNotesMax).nullish(),
  "outcome": zod.string().max(listAccountReviewsResponseItemsItemFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(listAccountReviewsResponseItemsItemFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(listAccountReviewsResponseItemsItemFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(listAccountReviewsResponseItemsItemFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(listAccountReviewsResponseItemsItemFieldsEvidenceItemRevisionMax)
})).max(listAccountReviewsResponseItemsItemFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listAccountReviewsResponseItemsItemTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listAccountReviewsResponseItemsItemTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getAccountReviewParams = zod.object({
  "id": zod.uuid()
})

export const getAccountReviewResponseFieldsTitleMax = 500;

export const getAccountReviewResponseFieldsSourceContextMax = 5000;

export const getAccountReviewResponseFieldsNotesMax = 10000;

export const getAccountReviewResponseFieldsOutcomeMax = 5000;

export const getAccountReviewResponseFieldsSatisfactionRatingMax = 5;

export const getAccountReviewResponseFieldsAdvocacyPurposeMax = 1000;

export const getAccountReviewResponseFieldsAdvocacyEvidenceMax = 5000;

export const getAccountReviewResponseFieldsEvidenceItemRevisionMax = 128;

export const getAccountReviewResponseFieldsEvidenceMax = 50;


export const getAccountReviewResponseTaskOneDurationMinutesMin = 0;

export const getAccountReviewResponseTaskOneIsTestDataDefault = false;

export const getAccountReviewResponse = zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(getAccountReviewResponseFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(getAccountReviewResponseFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(getAccountReviewResponseFieldsNotesMax).nullish(),
  "outcome": zod.string().max(getAccountReviewResponseFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(getAccountReviewResponseFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(getAccountReviewResponseFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(getAccountReviewResponseFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getAccountReviewResponseFieldsEvidenceItemRevisionMax)
})).max(getAccountReviewResponseFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getAccountReviewResponseTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getAccountReviewResponseTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
})


export const listAccountReviewHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listAccountReviewHistoryQueryLimitDefault = 20;
export const listAccountReviewHistoryQueryLimitMax = 100;

export const listAccountReviewHistoryQueryOffsetDefault = 0;
export const listAccountReviewHistoryQueryOffsetMin = 0;
export const listAccountReviewHistoryQueryOffsetMax = 1000000;



export const listAccountReviewHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listAccountReviewHistoryQueryLimitMax).default(listAccountReviewHistoryQueryLimitDefault),
  "offset": zod.int().min(listAccountReviewHistoryQueryOffsetMin).max(listAccountReviewHistoryQueryOffsetMax).default(listAccountReviewHistoryQueryOffsetDefault)
})

export const listAccountReviewHistoryResponseItemsItemSnapshotFieldsTitleMax = 500;

export const listAccountReviewHistoryResponseItemsItemSnapshotFieldsSourceContextMax = 5000;

export const listAccountReviewHistoryResponseItemsItemSnapshotFieldsNotesMax = 10000;

export const listAccountReviewHistoryResponseItemsItemSnapshotFieldsOutcomeMax = 5000;

export const listAccountReviewHistoryResponseItemsItemSnapshotFieldsSatisfactionRatingMax = 5;

export const listAccountReviewHistoryResponseItemsItemSnapshotFieldsAdvocacyPurposeMax = 1000;

export const listAccountReviewHistoryResponseItemsItemSnapshotFieldsAdvocacyEvidenceMax = 5000;

export const listAccountReviewHistoryResponseItemsItemSnapshotFieldsEvidenceItemRevisionMax = 128;

export const listAccountReviewHistoryResponseItemsItemSnapshotFieldsEvidenceMax = 50;


export const listAccountReviewHistoryResponseItemsItemSnapshotTaskOneDurationMinutesMin = 0;

export const listAccountReviewHistoryResponseItemsItemSnapshotTaskOneIsTestDataDefault = false;

export const listAccountReviewHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actorId": zod.uuid(),
  "reason": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "snapshot": zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(listAccountReviewHistoryResponseItemsItemSnapshotFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(listAccountReviewHistoryResponseItemsItemSnapshotFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(listAccountReviewHistoryResponseItemsItemSnapshotFieldsNotesMax).nullish(),
  "outcome": zod.string().max(listAccountReviewHistoryResponseItemsItemSnapshotFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(listAccountReviewHistoryResponseItemsItemSnapshotFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(listAccountReviewHistoryResponseItemsItemSnapshotFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(listAccountReviewHistoryResponseItemsItemSnapshotFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(listAccountReviewHistoryResponseItemsItemSnapshotFieldsEvidenceItemRevisionMax)
})).max(listAccountReviewHistoryResponseItemsItemSnapshotFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listAccountReviewHistoryResponseItemsItemSnapshotTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listAccountReviewHistoryResponseItemsItemSnapshotTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})



export const reviewAccountReviewChangeBodyChangeReasonMin = 3;
export const reviewAccountReviewChangeBodyChangeReasonMax = 500;

export const reviewAccountReviewChangeBodyChangeFieldsTitleMax = 500;

export const reviewAccountReviewChangeBodyChangeFieldsSourceContextMax = 5000;

export const reviewAccountReviewChangeBodyChangeFieldsNotesMax = 10000;

export const reviewAccountReviewChangeBodyChangeFieldsOutcomeMax = 5000;

export const reviewAccountReviewChangeBodyChangeFieldsSatisfactionRatingMax = 5;

export const reviewAccountReviewChangeBodyChangeFieldsAdvocacyPurposeMax = 1000;

export const reviewAccountReviewChangeBodyChangeFieldsAdvocacyEvidenceMax = 5000;

export const reviewAccountReviewChangeBodyChangeFieldsEvidenceItemRevisionMax = 128;

export const reviewAccountReviewChangeBodyChangeFieldsEvidenceMax = 50;


export const reviewAccountReviewChangeBodyChangeTaskSubjectMax = 500;

export const reviewAccountReviewChangeBodyChangeTaskBodyMax = 5000;

export const reviewAccountReviewChangeBodyChangeTaskPriorityMax = 120;



export const reviewAccountReviewChangeBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'task', 'link_task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(reviewAccountReviewChangeBodyChangeReasonMin).max(reviewAccountReviewChangeBodyChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(reviewAccountReviewChangeBodyChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(reviewAccountReviewChangeBodyChangeFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(reviewAccountReviewChangeBodyChangeFieldsNotesMax).nullish(),
  "outcome": zod.string().max(reviewAccountReviewChangeBodyChangeFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(reviewAccountReviewChangeBodyChangeFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(reviewAccountReviewChangeBodyChangeFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(reviewAccountReviewChangeBodyChangeFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewAccountReviewChangeBodyChangeFieldsEvidenceItemRevisionMax)
})).max(reviewAccountReviewChangeBodyChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(reviewAccountReviewChangeBodyChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(reviewAccountReviewChangeBodyChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(reviewAccountReviewChangeBodyChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "activityId": zod.uuid().nullish()
})
})


export const reviewAccountReviewChangeResponseChangeReasonMin = 3;
export const reviewAccountReviewChangeResponseChangeReasonMax = 500;

export const reviewAccountReviewChangeResponseChangeFieldsTitleMax = 500;

export const reviewAccountReviewChangeResponseChangeFieldsSourceContextMax = 5000;

export const reviewAccountReviewChangeResponseChangeFieldsNotesMax = 10000;

export const reviewAccountReviewChangeResponseChangeFieldsOutcomeMax = 5000;

export const reviewAccountReviewChangeResponseChangeFieldsSatisfactionRatingMax = 5;

export const reviewAccountReviewChangeResponseChangeFieldsAdvocacyPurposeMax = 1000;

export const reviewAccountReviewChangeResponseChangeFieldsAdvocacyEvidenceMax = 5000;

export const reviewAccountReviewChangeResponseChangeFieldsEvidenceItemRevisionMax = 128;

export const reviewAccountReviewChangeResponseChangeFieldsEvidenceMax = 50;


export const reviewAccountReviewChangeResponseChangeTaskSubjectMax = 500;

export const reviewAccountReviewChangeResponseChangeTaskBodyMax = 5000;

export const reviewAccountReviewChangeResponseChangeTaskPriorityMax = 120;

export const reviewAccountReviewChangeResponseBeforeOneFieldsTitleMax = 500;

export const reviewAccountReviewChangeResponseBeforeOneFieldsSourceContextMax = 5000;

export const reviewAccountReviewChangeResponseBeforeOneFieldsNotesMax = 10000;

export const reviewAccountReviewChangeResponseBeforeOneFieldsOutcomeMax = 5000;

export const reviewAccountReviewChangeResponseBeforeOneFieldsSatisfactionRatingMax = 5;

export const reviewAccountReviewChangeResponseBeforeOneFieldsAdvocacyPurposeMax = 1000;

export const reviewAccountReviewChangeResponseBeforeOneFieldsAdvocacyEvidenceMax = 5000;

export const reviewAccountReviewChangeResponseBeforeOneFieldsEvidenceItemRevisionMax = 128;

export const reviewAccountReviewChangeResponseBeforeOneFieldsEvidenceMax = 50;


export const reviewAccountReviewChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const reviewAccountReviewChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const reviewAccountReviewChangeResponseAfterTitleMax = 500;

export const reviewAccountReviewChangeResponseAfterSourceContextMax = 5000;

export const reviewAccountReviewChangeResponseAfterNotesMax = 10000;

export const reviewAccountReviewChangeResponseAfterOutcomeMax = 5000;

export const reviewAccountReviewChangeResponseAfterSatisfactionRatingMax = 5;

export const reviewAccountReviewChangeResponseAfterAdvocacyPurposeMax = 1000;

export const reviewAccountReviewChangeResponseAfterAdvocacyEvidenceMax = 5000;

export const reviewAccountReviewChangeResponseAfterEvidenceItemRevisionMax = 128;

export const reviewAccountReviewChangeResponseAfterEvidenceMax = 50;

export const reviewAccountReviewChangeResponseReceiptOneFieldsTitleMax = 500;

export const reviewAccountReviewChangeResponseReceiptOneFieldsSourceContextMax = 5000;

export const reviewAccountReviewChangeResponseReceiptOneFieldsNotesMax = 10000;

export const reviewAccountReviewChangeResponseReceiptOneFieldsOutcomeMax = 5000;

export const reviewAccountReviewChangeResponseReceiptOneFieldsSatisfactionRatingMax = 5;

export const reviewAccountReviewChangeResponseReceiptOneFieldsAdvocacyPurposeMax = 1000;

export const reviewAccountReviewChangeResponseReceiptOneFieldsAdvocacyEvidenceMax = 5000;

export const reviewAccountReviewChangeResponseReceiptOneFieldsEvidenceItemRevisionMax = 128;

export const reviewAccountReviewChangeResponseReceiptOneFieldsEvidenceMax = 50;


export const reviewAccountReviewChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const reviewAccountReviewChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const reviewAccountReviewChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'task', 'link_task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(reviewAccountReviewChangeResponseChangeReasonMin).max(reviewAccountReviewChangeResponseChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(reviewAccountReviewChangeResponseChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(reviewAccountReviewChangeResponseChangeFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(reviewAccountReviewChangeResponseChangeFieldsNotesMax).nullish(),
  "outcome": zod.string().max(reviewAccountReviewChangeResponseChangeFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(reviewAccountReviewChangeResponseChangeFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(reviewAccountReviewChangeResponseChangeFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(reviewAccountReviewChangeResponseChangeFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewAccountReviewChangeResponseChangeFieldsEvidenceItemRevisionMax)
})).max(reviewAccountReviewChangeResponseChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(reviewAccountReviewChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(reviewAccountReviewChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(reviewAccountReviewChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "activityId": zod.uuid().nullish()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(reviewAccountReviewChangeResponseBeforeOneFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(reviewAccountReviewChangeResponseBeforeOneFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(reviewAccountReviewChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "outcome": zod.string().max(reviewAccountReviewChangeResponseBeforeOneFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(reviewAccountReviewChangeResponseBeforeOneFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(reviewAccountReviewChangeResponseBeforeOneFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(reviewAccountReviewChangeResponseBeforeOneFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewAccountReviewChangeResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(reviewAccountReviewChangeResponseBeforeOneFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewAccountReviewChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewAccountReviewChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "after": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(reviewAccountReviewChangeResponseAfterTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(reviewAccountReviewChangeResponseAfterSourceContextMax).nullish(),
  "notes": zod.string().max(reviewAccountReviewChangeResponseAfterNotesMax).nullish(),
  "outcome": zod.string().max(reviewAccountReviewChangeResponseAfterOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(reviewAccountReviewChangeResponseAfterSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(reviewAccountReviewChangeResponseAfterAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(reviewAccountReviewChangeResponseAfterAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewAccountReviewChangeResponseAfterEvidenceItemRevisionMax)
})).max(reviewAccountReviewChangeResponseAfterEvidenceMax).optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(reviewAccountReviewChangeResponseReceiptOneFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(reviewAccountReviewChangeResponseReceiptOneFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(reviewAccountReviewChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "outcome": zod.string().max(reviewAccountReviewChangeResponseReceiptOneFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(reviewAccountReviewChangeResponseReceiptOneFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(reviewAccountReviewChangeResponseReceiptOneFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(reviewAccountReviewChangeResponseReceiptOneFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewAccountReviewChangeResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(reviewAccountReviewChangeResponseReceiptOneFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewAccountReviewChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewAccountReviewChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()])
})


export const getAccountReviewChangeParams = zod.object({
  "id": zod.uuid()
})


export const getAccountReviewChangeResponseChangeReasonMin = 3;
export const getAccountReviewChangeResponseChangeReasonMax = 500;

export const getAccountReviewChangeResponseChangeFieldsTitleMax = 500;

export const getAccountReviewChangeResponseChangeFieldsSourceContextMax = 5000;

export const getAccountReviewChangeResponseChangeFieldsNotesMax = 10000;

export const getAccountReviewChangeResponseChangeFieldsOutcomeMax = 5000;

export const getAccountReviewChangeResponseChangeFieldsSatisfactionRatingMax = 5;

export const getAccountReviewChangeResponseChangeFieldsAdvocacyPurposeMax = 1000;

export const getAccountReviewChangeResponseChangeFieldsAdvocacyEvidenceMax = 5000;

export const getAccountReviewChangeResponseChangeFieldsEvidenceItemRevisionMax = 128;

export const getAccountReviewChangeResponseChangeFieldsEvidenceMax = 50;


export const getAccountReviewChangeResponseChangeTaskSubjectMax = 500;

export const getAccountReviewChangeResponseChangeTaskBodyMax = 5000;

export const getAccountReviewChangeResponseChangeTaskPriorityMax = 120;

export const getAccountReviewChangeResponseBeforeOneFieldsTitleMax = 500;

export const getAccountReviewChangeResponseBeforeOneFieldsSourceContextMax = 5000;

export const getAccountReviewChangeResponseBeforeOneFieldsNotesMax = 10000;

export const getAccountReviewChangeResponseBeforeOneFieldsOutcomeMax = 5000;

export const getAccountReviewChangeResponseBeforeOneFieldsSatisfactionRatingMax = 5;

export const getAccountReviewChangeResponseBeforeOneFieldsAdvocacyPurposeMax = 1000;

export const getAccountReviewChangeResponseBeforeOneFieldsAdvocacyEvidenceMax = 5000;

export const getAccountReviewChangeResponseBeforeOneFieldsEvidenceItemRevisionMax = 128;

export const getAccountReviewChangeResponseBeforeOneFieldsEvidenceMax = 50;


export const getAccountReviewChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const getAccountReviewChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const getAccountReviewChangeResponseAfterTitleMax = 500;

export const getAccountReviewChangeResponseAfterSourceContextMax = 5000;

export const getAccountReviewChangeResponseAfterNotesMax = 10000;

export const getAccountReviewChangeResponseAfterOutcomeMax = 5000;

export const getAccountReviewChangeResponseAfterSatisfactionRatingMax = 5;

export const getAccountReviewChangeResponseAfterAdvocacyPurposeMax = 1000;

export const getAccountReviewChangeResponseAfterAdvocacyEvidenceMax = 5000;

export const getAccountReviewChangeResponseAfterEvidenceItemRevisionMax = 128;

export const getAccountReviewChangeResponseAfterEvidenceMax = 50;

export const getAccountReviewChangeResponseReceiptOneFieldsTitleMax = 500;

export const getAccountReviewChangeResponseReceiptOneFieldsSourceContextMax = 5000;

export const getAccountReviewChangeResponseReceiptOneFieldsNotesMax = 10000;

export const getAccountReviewChangeResponseReceiptOneFieldsOutcomeMax = 5000;

export const getAccountReviewChangeResponseReceiptOneFieldsSatisfactionRatingMax = 5;

export const getAccountReviewChangeResponseReceiptOneFieldsAdvocacyPurposeMax = 1000;

export const getAccountReviewChangeResponseReceiptOneFieldsAdvocacyEvidenceMax = 5000;

export const getAccountReviewChangeResponseReceiptOneFieldsEvidenceItemRevisionMax = 128;

export const getAccountReviewChangeResponseReceiptOneFieldsEvidenceMax = 50;


export const getAccountReviewChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const getAccountReviewChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const getAccountReviewChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'task', 'link_task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(getAccountReviewChangeResponseChangeReasonMin).max(getAccountReviewChangeResponseChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(getAccountReviewChangeResponseChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(getAccountReviewChangeResponseChangeFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(getAccountReviewChangeResponseChangeFieldsNotesMax).nullish(),
  "outcome": zod.string().max(getAccountReviewChangeResponseChangeFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(getAccountReviewChangeResponseChangeFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(getAccountReviewChangeResponseChangeFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(getAccountReviewChangeResponseChangeFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getAccountReviewChangeResponseChangeFieldsEvidenceItemRevisionMax)
})).max(getAccountReviewChangeResponseChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(getAccountReviewChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(getAccountReviewChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(getAccountReviewChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "activityId": zod.uuid().nullish()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(getAccountReviewChangeResponseBeforeOneFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(getAccountReviewChangeResponseBeforeOneFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(getAccountReviewChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "outcome": zod.string().max(getAccountReviewChangeResponseBeforeOneFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(getAccountReviewChangeResponseBeforeOneFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(getAccountReviewChangeResponseBeforeOneFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(getAccountReviewChangeResponseBeforeOneFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getAccountReviewChangeResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(getAccountReviewChangeResponseBeforeOneFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getAccountReviewChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getAccountReviewChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "after": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(getAccountReviewChangeResponseAfterTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(getAccountReviewChangeResponseAfterSourceContextMax).nullish(),
  "notes": zod.string().max(getAccountReviewChangeResponseAfterNotesMax).nullish(),
  "outcome": zod.string().max(getAccountReviewChangeResponseAfterOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(getAccountReviewChangeResponseAfterSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(getAccountReviewChangeResponseAfterAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(getAccountReviewChangeResponseAfterAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getAccountReviewChangeResponseAfterEvidenceItemRevisionMax)
})).max(getAccountReviewChangeResponseAfterEvidenceMax).optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(getAccountReviewChangeResponseReceiptOneFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(getAccountReviewChangeResponseReceiptOneFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(getAccountReviewChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "outcome": zod.string().max(getAccountReviewChangeResponseReceiptOneFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(getAccountReviewChangeResponseReceiptOneFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(getAccountReviewChangeResponseReceiptOneFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(getAccountReviewChangeResponseReceiptOneFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getAccountReviewChangeResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(getAccountReviewChangeResponseReceiptOneFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getAccountReviewChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getAccountReviewChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()])
})


export const confirmAccountReviewChangeParams = zod.object({
  "id": zod.uuid()
})




export const confirmAccountReviewChangeBody = zod.object({
  "hash": zod.string().min(1),
  "confirmation": zod.enum(['CONFIRM'])
})


export const confirmAccountReviewChangeResponseChangeReasonMin = 3;
export const confirmAccountReviewChangeResponseChangeReasonMax = 500;

export const confirmAccountReviewChangeResponseChangeFieldsTitleMax = 500;

export const confirmAccountReviewChangeResponseChangeFieldsSourceContextMax = 5000;

export const confirmAccountReviewChangeResponseChangeFieldsNotesMax = 10000;

export const confirmAccountReviewChangeResponseChangeFieldsOutcomeMax = 5000;

export const confirmAccountReviewChangeResponseChangeFieldsSatisfactionRatingMax = 5;

export const confirmAccountReviewChangeResponseChangeFieldsAdvocacyPurposeMax = 1000;

export const confirmAccountReviewChangeResponseChangeFieldsAdvocacyEvidenceMax = 5000;

export const confirmAccountReviewChangeResponseChangeFieldsEvidenceItemRevisionMax = 128;

export const confirmAccountReviewChangeResponseChangeFieldsEvidenceMax = 50;


export const confirmAccountReviewChangeResponseChangeTaskSubjectMax = 500;

export const confirmAccountReviewChangeResponseChangeTaskBodyMax = 5000;

export const confirmAccountReviewChangeResponseChangeTaskPriorityMax = 120;

export const confirmAccountReviewChangeResponseBeforeOneFieldsTitleMax = 500;

export const confirmAccountReviewChangeResponseBeforeOneFieldsSourceContextMax = 5000;

export const confirmAccountReviewChangeResponseBeforeOneFieldsNotesMax = 10000;

export const confirmAccountReviewChangeResponseBeforeOneFieldsOutcomeMax = 5000;

export const confirmAccountReviewChangeResponseBeforeOneFieldsSatisfactionRatingMax = 5;

export const confirmAccountReviewChangeResponseBeforeOneFieldsAdvocacyPurposeMax = 1000;

export const confirmAccountReviewChangeResponseBeforeOneFieldsAdvocacyEvidenceMax = 5000;

export const confirmAccountReviewChangeResponseBeforeOneFieldsEvidenceItemRevisionMax = 128;

export const confirmAccountReviewChangeResponseBeforeOneFieldsEvidenceMax = 50;


export const confirmAccountReviewChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const confirmAccountReviewChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const confirmAccountReviewChangeResponseAfterTitleMax = 500;

export const confirmAccountReviewChangeResponseAfterSourceContextMax = 5000;

export const confirmAccountReviewChangeResponseAfterNotesMax = 10000;

export const confirmAccountReviewChangeResponseAfterOutcomeMax = 5000;

export const confirmAccountReviewChangeResponseAfterSatisfactionRatingMax = 5;

export const confirmAccountReviewChangeResponseAfterAdvocacyPurposeMax = 1000;

export const confirmAccountReviewChangeResponseAfterAdvocacyEvidenceMax = 5000;

export const confirmAccountReviewChangeResponseAfterEvidenceItemRevisionMax = 128;

export const confirmAccountReviewChangeResponseAfterEvidenceMax = 50;

export const confirmAccountReviewChangeResponseReceiptOneFieldsTitleMax = 500;

export const confirmAccountReviewChangeResponseReceiptOneFieldsSourceContextMax = 5000;

export const confirmAccountReviewChangeResponseReceiptOneFieldsNotesMax = 10000;

export const confirmAccountReviewChangeResponseReceiptOneFieldsOutcomeMax = 5000;

export const confirmAccountReviewChangeResponseReceiptOneFieldsSatisfactionRatingMax = 5;

export const confirmAccountReviewChangeResponseReceiptOneFieldsAdvocacyPurposeMax = 1000;

export const confirmAccountReviewChangeResponseReceiptOneFieldsAdvocacyEvidenceMax = 5000;

export const confirmAccountReviewChangeResponseReceiptOneFieldsEvidenceItemRevisionMax = 128;

export const confirmAccountReviewChangeResponseReceiptOneFieldsEvidenceMax = 50;


export const confirmAccountReviewChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const confirmAccountReviewChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const confirmAccountReviewChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'task', 'link_task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(confirmAccountReviewChangeResponseChangeReasonMin).max(confirmAccountReviewChangeResponseChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(confirmAccountReviewChangeResponseChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(confirmAccountReviewChangeResponseChangeFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(confirmAccountReviewChangeResponseChangeFieldsNotesMax).nullish(),
  "outcome": zod.string().max(confirmAccountReviewChangeResponseChangeFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(confirmAccountReviewChangeResponseChangeFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(confirmAccountReviewChangeResponseChangeFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(confirmAccountReviewChangeResponseChangeFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmAccountReviewChangeResponseChangeFieldsEvidenceItemRevisionMax)
})).max(confirmAccountReviewChangeResponseChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(confirmAccountReviewChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(confirmAccountReviewChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(confirmAccountReviewChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "activityId": zod.uuid().nullish()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(confirmAccountReviewChangeResponseBeforeOneFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(confirmAccountReviewChangeResponseBeforeOneFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(confirmAccountReviewChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "outcome": zod.string().max(confirmAccountReviewChangeResponseBeforeOneFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(confirmAccountReviewChangeResponseBeforeOneFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(confirmAccountReviewChangeResponseBeforeOneFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(confirmAccountReviewChangeResponseBeforeOneFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmAccountReviewChangeResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(confirmAccountReviewChangeResponseBeforeOneFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmAccountReviewChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(confirmAccountReviewChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "after": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(confirmAccountReviewChangeResponseAfterTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(confirmAccountReviewChangeResponseAfterSourceContextMax).nullish(),
  "notes": zod.string().max(confirmAccountReviewChangeResponseAfterNotesMax).nullish(),
  "outcome": zod.string().max(confirmAccountReviewChangeResponseAfterOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(confirmAccountReviewChangeResponseAfterSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(confirmAccountReviewChangeResponseAfterAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(confirmAccountReviewChangeResponseAfterAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmAccountReviewChangeResponseAfterEvidenceItemRevisionMax)
})).max(confirmAccountReviewChangeResponseAfterEvidenceMax).optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(confirmAccountReviewChangeResponseReceiptOneFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(confirmAccountReviewChangeResponseReceiptOneFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(confirmAccountReviewChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "outcome": zod.string().max(confirmAccountReviewChangeResponseReceiptOneFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(confirmAccountReviewChangeResponseReceiptOneFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(confirmAccountReviewChangeResponseReceiptOneFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(confirmAccountReviewChangeResponseReceiptOneFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmAccountReviewChangeResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(confirmAccountReviewChangeResponseReceiptOneFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmAccountReviewChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(confirmAccountReviewChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()])
})


export const cancelAccountReviewChangeParams = zod.object({
  "id": zod.uuid()
})


export const cancelAccountReviewChangeResponseChangeReasonMin = 3;
export const cancelAccountReviewChangeResponseChangeReasonMax = 500;

export const cancelAccountReviewChangeResponseChangeFieldsTitleMax = 500;

export const cancelAccountReviewChangeResponseChangeFieldsSourceContextMax = 5000;

export const cancelAccountReviewChangeResponseChangeFieldsNotesMax = 10000;

export const cancelAccountReviewChangeResponseChangeFieldsOutcomeMax = 5000;

export const cancelAccountReviewChangeResponseChangeFieldsSatisfactionRatingMax = 5;

export const cancelAccountReviewChangeResponseChangeFieldsAdvocacyPurposeMax = 1000;

export const cancelAccountReviewChangeResponseChangeFieldsAdvocacyEvidenceMax = 5000;

export const cancelAccountReviewChangeResponseChangeFieldsEvidenceItemRevisionMax = 128;

export const cancelAccountReviewChangeResponseChangeFieldsEvidenceMax = 50;


export const cancelAccountReviewChangeResponseChangeTaskSubjectMax = 500;

export const cancelAccountReviewChangeResponseChangeTaskBodyMax = 5000;

export const cancelAccountReviewChangeResponseChangeTaskPriorityMax = 120;

export const cancelAccountReviewChangeResponseBeforeOneFieldsTitleMax = 500;

export const cancelAccountReviewChangeResponseBeforeOneFieldsSourceContextMax = 5000;

export const cancelAccountReviewChangeResponseBeforeOneFieldsNotesMax = 10000;

export const cancelAccountReviewChangeResponseBeforeOneFieldsOutcomeMax = 5000;

export const cancelAccountReviewChangeResponseBeforeOneFieldsSatisfactionRatingMax = 5;

export const cancelAccountReviewChangeResponseBeforeOneFieldsAdvocacyPurposeMax = 1000;

export const cancelAccountReviewChangeResponseBeforeOneFieldsAdvocacyEvidenceMax = 5000;

export const cancelAccountReviewChangeResponseBeforeOneFieldsEvidenceItemRevisionMax = 128;

export const cancelAccountReviewChangeResponseBeforeOneFieldsEvidenceMax = 50;


export const cancelAccountReviewChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const cancelAccountReviewChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const cancelAccountReviewChangeResponseAfterTitleMax = 500;

export const cancelAccountReviewChangeResponseAfterSourceContextMax = 5000;

export const cancelAccountReviewChangeResponseAfterNotesMax = 10000;

export const cancelAccountReviewChangeResponseAfterOutcomeMax = 5000;

export const cancelAccountReviewChangeResponseAfterSatisfactionRatingMax = 5;

export const cancelAccountReviewChangeResponseAfterAdvocacyPurposeMax = 1000;

export const cancelAccountReviewChangeResponseAfterAdvocacyEvidenceMax = 5000;

export const cancelAccountReviewChangeResponseAfterEvidenceItemRevisionMax = 128;

export const cancelAccountReviewChangeResponseAfterEvidenceMax = 50;

export const cancelAccountReviewChangeResponseReceiptOneFieldsTitleMax = 500;

export const cancelAccountReviewChangeResponseReceiptOneFieldsSourceContextMax = 5000;

export const cancelAccountReviewChangeResponseReceiptOneFieldsNotesMax = 10000;

export const cancelAccountReviewChangeResponseReceiptOneFieldsOutcomeMax = 5000;

export const cancelAccountReviewChangeResponseReceiptOneFieldsSatisfactionRatingMax = 5;

export const cancelAccountReviewChangeResponseReceiptOneFieldsAdvocacyPurposeMax = 1000;

export const cancelAccountReviewChangeResponseReceiptOneFieldsAdvocacyEvidenceMax = 5000;

export const cancelAccountReviewChangeResponseReceiptOneFieldsEvidenceItemRevisionMax = 128;

export const cancelAccountReviewChangeResponseReceiptOneFieldsEvidenceMax = 50;


export const cancelAccountReviewChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const cancelAccountReviewChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const cancelAccountReviewChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'task', 'link_task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(cancelAccountReviewChangeResponseChangeReasonMin).max(cancelAccountReviewChangeResponseChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(cancelAccountReviewChangeResponseChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(cancelAccountReviewChangeResponseChangeFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(cancelAccountReviewChangeResponseChangeFieldsNotesMax).nullish(),
  "outcome": zod.string().max(cancelAccountReviewChangeResponseChangeFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(cancelAccountReviewChangeResponseChangeFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(cancelAccountReviewChangeResponseChangeFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(cancelAccountReviewChangeResponseChangeFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelAccountReviewChangeResponseChangeFieldsEvidenceItemRevisionMax)
})).max(cancelAccountReviewChangeResponseChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(cancelAccountReviewChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(cancelAccountReviewChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(cancelAccountReviewChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "activityId": zod.uuid().nullish()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(cancelAccountReviewChangeResponseBeforeOneFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(cancelAccountReviewChangeResponseBeforeOneFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(cancelAccountReviewChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "outcome": zod.string().max(cancelAccountReviewChangeResponseBeforeOneFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(cancelAccountReviewChangeResponseBeforeOneFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(cancelAccountReviewChangeResponseBeforeOneFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(cancelAccountReviewChangeResponseBeforeOneFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelAccountReviewChangeResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(cancelAccountReviewChangeResponseBeforeOneFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelAccountReviewChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(cancelAccountReviewChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "after": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(cancelAccountReviewChangeResponseAfterTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(cancelAccountReviewChangeResponseAfterSourceContextMax).nullish(),
  "notes": zod.string().max(cancelAccountReviewChangeResponseAfterNotesMax).nullish(),
  "outcome": zod.string().max(cancelAccountReviewChangeResponseAfterOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(cancelAccountReviewChangeResponseAfterSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(cancelAccountReviewChangeResponseAfterAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(cancelAccountReviewChangeResponseAfterAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelAccountReviewChangeResponseAfterEvidenceItemRevisionMax)
})).max(cancelAccountReviewChangeResponseAfterEvidenceMax).optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "kind": zod.enum(['review', 'feedback', 'advocacy']).optional(),
  "title": zod.string().min(1).max(cancelAccountReviewChangeResponseReceiptOneFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "nextReviewOn": zod.iso.date().nullish(),
  "sourceKind": zod.enum(['staff', 'customer', 'partner', 'other']).optional(),
  "sourceContext": zod.string().max(cancelAccountReviewChangeResponseReceiptOneFieldsSourceContextMax).nullish(),
  "notes": zod.string().max(cancelAccountReviewChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "outcome": zod.string().max(cancelAccountReviewChangeResponseReceiptOneFieldsOutcomeMax).nullish(),
  "satisfactionRating": zod.int().min(1).max(cancelAccountReviewChangeResponseReceiptOneFieldsSatisfactionRatingMax).nullish().describe('Optional staff-recorded satisfaction, 1 very dissatisfied through 5 very satisfied. Not a calculated health score.'),
  "advocacyStatus": zod.enum(['unknown', 'granted', 'declined', 'withdrawn']).optional(),
  "advocacyPurpose": zod.string().max(cancelAccountReviewChangeResponseReceiptOneFieldsAdvocacyPurposeMax).nullish(),
  "advocacyEvidence": zod.string().max(cancelAccountReviewChangeResponseReceiptOneFieldsAdvocacyEvidenceMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelAccountReviewChangeResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(cancelAccountReviewChangeResponseReceiptOneFieldsEvidenceMax).optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelAccountReviewChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(cancelAccountReviewChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()])
})


export const listServiceCasesQueryStatusMax = 120;

export const listServiceCasesQuerySearchMax = 200;

export const listServiceCasesQueryLimitDefault = 20;
export const listServiceCasesQueryLimitMax = 100;

export const listServiceCasesQueryOffsetDefault = 0;
export const listServiceCasesQueryOffsetMin = 0;
export const listServiceCasesQueryOffsetMax = 1000000;



export const listServiceCasesQueryParams = zod.object({
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']).optional(),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']).optional(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().optional(),
  "asOf": zod.iso.datetime({"offset":true}).optional(),
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().optional(),
  "enquiryId": zod.uuid().optional(),
  "agreementId": zod.uuid().optional(),
  "ownerId": zod.uuid().optional(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "status": zod.string().max(listServiceCasesQueryStatusMax).optional(),
  "search": zod.string().max(listServiceCasesQuerySearchMax).optional(),
  "from": zod.iso.date().optional(),
  "to": zod.iso.date().optional(),
  "limit": zod.int().min(1).max(listServiceCasesQueryLimitMax).default(listServiceCasesQueryLimitDefault),
  "offset": zod.int().min(listServiceCasesQueryOffsetMin).max(listServiceCasesQueryOffsetMax).default(listServiceCasesQueryOffsetDefault)
})

export const listServiceCasesResponseItemsItemFieldsEscalationReasonMin = 3;
export const listServiceCasesResponseItemsItemFieldsEscalationReasonMax = 5000;

export const listServiceCasesResponseItemsItemFieldsInternalUpdateMax = 5000;

export const listServiceCasesResponseItemsItemFieldsSummaryMax = 500;

export const listServiceCasesResponseItemsItemFieldsNotesMax = 10000;

export const listServiceCasesResponseItemsItemFieldsStatusMax = 120;

export const listServiceCasesResponseItemsItemFieldsDecisionMax = 5000;

export const listServiceCasesResponseItemsItemFieldsEvidenceItemRevisionMax = 128;

export const listServiceCasesResponseItemsItemFieldsEvidenceMax = 50;


export const listServiceCasesResponseItemsItemTaskOneDurationMinutesMin = 0;

export const listServiceCasesResponseItemsItemTaskOneIsTestDataDefault = false;

export const listServiceCasesResponse = zod.object({
  "asOf": zod.iso.datetime({"offset":true}).optional(),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(listServiceCasesResponseItemsItemFieldsEscalationReasonMin).max(listServiceCasesResponseItemsItemFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(listServiceCasesResponseItemsItemFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(listServiceCasesResponseItemsItemFieldsSummaryMax).optional(),
  "notes": zod.string().max(listServiceCasesResponseItemsItemFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(listServiceCasesResponseItemsItemFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(listServiceCasesResponseItemsItemFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(listServiceCasesResponseItemsItemFieldsEvidenceItemRevisionMax)
})).max(listServiceCasesResponseItemsItemFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listServiceCasesResponseItemsItemTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listServiceCasesResponseItemsItemTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getServiceCaseParams = zod.object({
  "id": zod.uuid()
})

export const getServiceCaseResponseFieldsEscalationReasonMin = 3;
export const getServiceCaseResponseFieldsEscalationReasonMax = 5000;

export const getServiceCaseResponseFieldsInternalUpdateMax = 5000;

export const getServiceCaseResponseFieldsSummaryMax = 500;

export const getServiceCaseResponseFieldsNotesMax = 10000;

export const getServiceCaseResponseFieldsStatusMax = 120;

export const getServiceCaseResponseFieldsDecisionMax = 5000;

export const getServiceCaseResponseFieldsEvidenceItemRevisionMax = 128;

export const getServiceCaseResponseFieldsEvidenceMax = 50;


export const getServiceCaseResponseTaskOneDurationMinutesMin = 0;

export const getServiceCaseResponseTaskOneIsTestDataDefault = false;

export const getServiceCaseResponse = zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(getServiceCaseResponseFieldsEscalationReasonMin).max(getServiceCaseResponseFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(getServiceCaseResponseFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(getServiceCaseResponseFieldsSummaryMax).optional(),
  "notes": zod.string().max(getServiceCaseResponseFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(getServiceCaseResponseFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(getServiceCaseResponseFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getServiceCaseResponseFieldsEvidenceItemRevisionMax)
})).max(getServiceCaseResponseFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getServiceCaseResponseTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getServiceCaseResponseTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
})


export const listServiceCaseHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listServiceCaseHistoryQueryLimitDefault = 20;
export const listServiceCaseHistoryQueryLimitMax = 100;

export const listServiceCaseHistoryQueryOffsetDefault = 0;
export const listServiceCaseHistoryQueryOffsetMin = 0;
export const listServiceCaseHistoryQueryOffsetMax = 1000000;



export const listServiceCaseHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listServiceCaseHistoryQueryLimitMax).default(listServiceCaseHistoryQueryLimitDefault),
  "offset": zod.int().min(listServiceCaseHistoryQueryOffsetMin).max(listServiceCaseHistoryQueryOffsetMax).default(listServiceCaseHistoryQueryOffsetDefault)
})

export const listServiceCaseHistoryResponseItemsItemSnapshotFieldsEscalationReasonMin = 3;
export const listServiceCaseHistoryResponseItemsItemSnapshotFieldsEscalationReasonMax = 5000;

export const listServiceCaseHistoryResponseItemsItemSnapshotFieldsInternalUpdateMax = 5000;

export const listServiceCaseHistoryResponseItemsItemSnapshotFieldsSummaryMax = 500;

export const listServiceCaseHistoryResponseItemsItemSnapshotFieldsNotesMax = 10000;

export const listServiceCaseHistoryResponseItemsItemSnapshotFieldsStatusMax = 120;

export const listServiceCaseHistoryResponseItemsItemSnapshotFieldsDecisionMax = 5000;

export const listServiceCaseHistoryResponseItemsItemSnapshotFieldsEvidenceItemRevisionMax = 128;

export const listServiceCaseHistoryResponseItemsItemSnapshotFieldsEvidenceMax = 50;


export const listServiceCaseHistoryResponseItemsItemSnapshotTaskOneDurationMinutesMin = 0;

export const listServiceCaseHistoryResponseItemsItemSnapshotTaskOneIsTestDataDefault = false;

export const listServiceCaseHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actorId": zod.uuid(),
  "reason": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "snapshot": zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(listServiceCaseHistoryResponseItemsItemSnapshotFieldsEscalationReasonMin).max(listServiceCaseHistoryResponseItemsItemSnapshotFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(listServiceCaseHistoryResponseItemsItemSnapshotFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(listServiceCaseHistoryResponseItemsItemSnapshotFieldsSummaryMax).optional(),
  "notes": zod.string().max(listServiceCaseHistoryResponseItemsItemSnapshotFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(listServiceCaseHistoryResponseItemsItemSnapshotFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(listServiceCaseHistoryResponseItemsItemSnapshotFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(listServiceCaseHistoryResponseItemsItemSnapshotFieldsEvidenceItemRevisionMax)
})).max(listServiceCaseHistoryResponseItemsItemSnapshotFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listServiceCaseHistoryResponseItemsItemSnapshotTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listServiceCaseHistoryResponseItemsItemSnapshotTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})



export const reviewServiceCaseChangeBodyChangeReasonMin = 3;
export const reviewServiceCaseChangeBodyChangeReasonMax = 500;

export const reviewServiceCaseChangeBodyChangeFieldsEscalationReasonMin = 3;
export const reviewServiceCaseChangeBodyChangeFieldsEscalationReasonMax = 5000;

export const reviewServiceCaseChangeBodyChangeFieldsInternalUpdateMax = 5000;

export const reviewServiceCaseChangeBodyChangeFieldsSummaryMax = 500;

export const reviewServiceCaseChangeBodyChangeFieldsNotesMax = 10000;

export const reviewServiceCaseChangeBodyChangeFieldsStatusMax = 120;

export const reviewServiceCaseChangeBodyChangeFieldsDecisionMax = 5000;

export const reviewServiceCaseChangeBodyChangeFieldsEvidenceItemRevisionMax = 128;

export const reviewServiceCaseChangeBodyChangeFieldsEvidenceMax = 50;


export const reviewServiceCaseChangeBodyChangeTaskSubjectMax = 500;

export const reviewServiceCaseChangeBodyChangeTaskBodyMax = 5000;

export const reviewServiceCaseChangeBodyChangeTaskPriorityMax = 120;



export const reviewServiceCaseChangeBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['create', 'from_enquiry', 'update', 'link_enquiry', 'resolve', 'close', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(reviewServiceCaseChangeBodyChangeReasonMin).max(reviewServiceCaseChangeBodyChangeReasonMax),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(reviewServiceCaseChangeBodyChangeFieldsEscalationReasonMin).max(reviewServiceCaseChangeBodyChangeFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(reviewServiceCaseChangeBodyChangeFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(reviewServiceCaseChangeBodyChangeFieldsSummaryMax).optional(),
  "notes": zod.string().max(reviewServiceCaseChangeBodyChangeFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(reviewServiceCaseChangeBodyChangeFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(reviewServiceCaseChangeBodyChangeFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewServiceCaseChangeBodyChangeFieldsEvidenceItemRevisionMax)
})).max(reviewServiceCaseChangeBodyChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(reviewServiceCaseChangeBodyChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(reviewServiceCaseChangeBodyChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(reviewServiceCaseChangeBodyChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
})
})


export const reviewServiceCaseChangeResponseChangeReasonMin = 3;
export const reviewServiceCaseChangeResponseChangeReasonMax = 500;

export const reviewServiceCaseChangeResponseChangeFieldsEscalationReasonMin = 3;
export const reviewServiceCaseChangeResponseChangeFieldsEscalationReasonMax = 5000;

export const reviewServiceCaseChangeResponseChangeFieldsInternalUpdateMax = 5000;

export const reviewServiceCaseChangeResponseChangeFieldsSummaryMax = 500;

export const reviewServiceCaseChangeResponseChangeFieldsNotesMax = 10000;

export const reviewServiceCaseChangeResponseChangeFieldsStatusMax = 120;

export const reviewServiceCaseChangeResponseChangeFieldsDecisionMax = 5000;

export const reviewServiceCaseChangeResponseChangeFieldsEvidenceItemRevisionMax = 128;

export const reviewServiceCaseChangeResponseChangeFieldsEvidenceMax = 50;


export const reviewServiceCaseChangeResponseChangeTaskSubjectMax = 500;

export const reviewServiceCaseChangeResponseChangeTaskBodyMax = 5000;

export const reviewServiceCaseChangeResponseChangeTaskPriorityMax = 120;

export const reviewServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMin = 3;
export const reviewServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMax = 5000;

export const reviewServiceCaseChangeResponseBeforeOneFieldsInternalUpdateMax = 5000;

export const reviewServiceCaseChangeResponseBeforeOneFieldsSummaryMax = 500;

export const reviewServiceCaseChangeResponseBeforeOneFieldsNotesMax = 10000;

export const reviewServiceCaseChangeResponseBeforeOneFieldsStatusMax = 120;

export const reviewServiceCaseChangeResponseBeforeOneFieldsDecisionMax = 5000;

export const reviewServiceCaseChangeResponseBeforeOneFieldsEvidenceItemRevisionMax = 128;

export const reviewServiceCaseChangeResponseBeforeOneFieldsEvidenceMax = 50;


export const reviewServiceCaseChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const reviewServiceCaseChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const reviewServiceCaseChangeResponseAfterEscalationReasonMin = 3;
export const reviewServiceCaseChangeResponseAfterEscalationReasonMax = 5000;

export const reviewServiceCaseChangeResponseAfterInternalUpdateMax = 5000;

export const reviewServiceCaseChangeResponseAfterSummaryMax = 500;

export const reviewServiceCaseChangeResponseAfterNotesMax = 10000;

export const reviewServiceCaseChangeResponseAfterStatusMax = 120;

export const reviewServiceCaseChangeResponseAfterDecisionMax = 5000;

export const reviewServiceCaseChangeResponseAfterEvidenceItemRevisionMax = 128;

export const reviewServiceCaseChangeResponseAfterEvidenceMax = 50;

export const reviewServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMin = 3;
export const reviewServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMax = 5000;

export const reviewServiceCaseChangeResponseReceiptOneFieldsInternalUpdateMax = 5000;

export const reviewServiceCaseChangeResponseReceiptOneFieldsSummaryMax = 500;

export const reviewServiceCaseChangeResponseReceiptOneFieldsNotesMax = 10000;

export const reviewServiceCaseChangeResponseReceiptOneFieldsStatusMax = 120;

export const reviewServiceCaseChangeResponseReceiptOneFieldsDecisionMax = 5000;

export const reviewServiceCaseChangeResponseReceiptOneFieldsEvidenceItemRevisionMax = 128;

export const reviewServiceCaseChangeResponseReceiptOneFieldsEvidenceMax = 50;


export const reviewServiceCaseChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const reviewServiceCaseChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const reviewServiceCaseChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'from_enquiry', 'update', 'link_enquiry', 'resolve', 'close', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(reviewServiceCaseChangeResponseChangeReasonMin).max(reviewServiceCaseChangeResponseChangeReasonMax),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(reviewServiceCaseChangeResponseChangeFieldsEscalationReasonMin).max(reviewServiceCaseChangeResponseChangeFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(reviewServiceCaseChangeResponseChangeFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(reviewServiceCaseChangeResponseChangeFieldsSummaryMax).optional(),
  "notes": zod.string().max(reviewServiceCaseChangeResponseChangeFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(reviewServiceCaseChangeResponseChangeFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(reviewServiceCaseChangeResponseChangeFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewServiceCaseChangeResponseChangeFieldsEvidenceItemRevisionMax)
})).max(reviewServiceCaseChangeResponseChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(reviewServiceCaseChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(reviewServiceCaseChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(reviewServiceCaseChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(reviewServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMin).max(reviewServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(reviewServiceCaseChangeResponseBeforeOneFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(reviewServiceCaseChangeResponseBeforeOneFieldsSummaryMax).optional(),
  "notes": zod.string().max(reviewServiceCaseChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(reviewServiceCaseChangeResponseBeforeOneFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(reviewServiceCaseChangeResponseBeforeOneFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewServiceCaseChangeResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(reviewServiceCaseChangeResponseBeforeOneFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewServiceCaseChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewServiceCaseChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "after": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(reviewServiceCaseChangeResponseAfterEscalationReasonMin).max(reviewServiceCaseChangeResponseAfterEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(reviewServiceCaseChangeResponseAfterInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(reviewServiceCaseChangeResponseAfterSummaryMax).optional(),
  "notes": zod.string().max(reviewServiceCaseChangeResponseAfterNotesMax).nullish(),
  "status": zod.string().min(1).max(reviewServiceCaseChangeResponseAfterStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(reviewServiceCaseChangeResponseAfterDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewServiceCaseChangeResponseAfterEvidenceItemRevisionMax)
})).max(reviewServiceCaseChangeResponseAfterEvidenceMax).optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(reviewServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMin).max(reviewServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(reviewServiceCaseChangeResponseReceiptOneFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(reviewServiceCaseChangeResponseReceiptOneFieldsSummaryMax).optional(),
  "notes": zod.string().max(reviewServiceCaseChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(reviewServiceCaseChangeResponseReceiptOneFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(reviewServiceCaseChangeResponseReceiptOneFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewServiceCaseChangeResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(reviewServiceCaseChangeResponseReceiptOneFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewServiceCaseChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewServiceCaseChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "copiedContext": zod.record(zod.string(), zod.unknown()).nullable()
})


export const getServiceCaseReviewParams = zod.object({
  "id": zod.uuid()
})


export const getServiceCaseReviewResponseChangeReasonMin = 3;
export const getServiceCaseReviewResponseChangeReasonMax = 500;

export const getServiceCaseReviewResponseChangeFieldsEscalationReasonMin = 3;
export const getServiceCaseReviewResponseChangeFieldsEscalationReasonMax = 5000;

export const getServiceCaseReviewResponseChangeFieldsInternalUpdateMax = 5000;

export const getServiceCaseReviewResponseChangeFieldsSummaryMax = 500;

export const getServiceCaseReviewResponseChangeFieldsNotesMax = 10000;

export const getServiceCaseReviewResponseChangeFieldsStatusMax = 120;

export const getServiceCaseReviewResponseChangeFieldsDecisionMax = 5000;

export const getServiceCaseReviewResponseChangeFieldsEvidenceItemRevisionMax = 128;

export const getServiceCaseReviewResponseChangeFieldsEvidenceMax = 50;


export const getServiceCaseReviewResponseChangeTaskSubjectMax = 500;

export const getServiceCaseReviewResponseChangeTaskBodyMax = 5000;

export const getServiceCaseReviewResponseChangeTaskPriorityMax = 120;

export const getServiceCaseReviewResponseBeforeOneFieldsEscalationReasonMin = 3;
export const getServiceCaseReviewResponseBeforeOneFieldsEscalationReasonMax = 5000;

export const getServiceCaseReviewResponseBeforeOneFieldsInternalUpdateMax = 5000;

export const getServiceCaseReviewResponseBeforeOneFieldsSummaryMax = 500;

export const getServiceCaseReviewResponseBeforeOneFieldsNotesMax = 10000;

export const getServiceCaseReviewResponseBeforeOneFieldsStatusMax = 120;

export const getServiceCaseReviewResponseBeforeOneFieldsDecisionMax = 5000;

export const getServiceCaseReviewResponseBeforeOneFieldsEvidenceItemRevisionMax = 128;

export const getServiceCaseReviewResponseBeforeOneFieldsEvidenceMax = 50;


export const getServiceCaseReviewResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const getServiceCaseReviewResponseBeforeOneTaskOneIsTestDataDefault = false;
export const getServiceCaseReviewResponseAfterEscalationReasonMin = 3;
export const getServiceCaseReviewResponseAfterEscalationReasonMax = 5000;

export const getServiceCaseReviewResponseAfterInternalUpdateMax = 5000;

export const getServiceCaseReviewResponseAfterSummaryMax = 500;

export const getServiceCaseReviewResponseAfterNotesMax = 10000;

export const getServiceCaseReviewResponseAfterStatusMax = 120;

export const getServiceCaseReviewResponseAfterDecisionMax = 5000;

export const getServiceCaseReviewResponseAfterEvidenceItemRevisionMax = 128;

export const getServiceCaseReviewResponseAfterEvidenceMax = 50;

export const getServiceCaseReviewResponseReceiptOneFieldsEscalationReasonMin = 3;
export const getServiceCaseReviewResponseReceiptOneFieldsEscalationReasonMax = 5000;

export const getServiceCaseReviewResponseReceiptOneFieldsInternalUpdateMax = 5000;

export const getServiceCaseReviewResponseReceiptOneFieldsSummaryMax = 500;

export const getServiceCaseReviewResponseReceiptOneFieldsNotesMax = 10000;

export const getServiceCaseReviewResponseReceiptOneFieldsStatusMax = 120;

export const getServiceCaseReviewResponseReceiptOneFieldsDecisionMax = 5000;

export const getServiceCaseReviewResponseReceiptOneFieldsEvidenceItemRevisionMax = 128;

export const getServiceCaseReviewResponseReceiptOneFieldsEvidenceMax = 50;


export const getServiceCaseReviewResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const getServiceCaseReviewResponseReceiptOneTaskOneIsTestDataDefault = false;

export const getServiceCaseReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'from_enquiry', 'update', 'link_enquiry', 'resolve', 'close', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(getServiceCaseReviewResponseChangeReasonMin).max(getServiceCaseReviewResponseChangeReasonMax),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(getServiceCaseReviewResponseChangeFieldsEscalationReasonMin).max(getServiceCaseReviewResponseChangeFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(getServiceCaseReviewResponseChangeFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(getServiceCaseReviewResponseChangeFieldsSummaryMax).optional(),
  "notes": zod.string().max(getServiceCaseReviewResponseChangeFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(getServiceCaseReviewResponseChangeFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(getServiceCaseReviewResponseChangeFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getServiceCaseReviewResponseChangeFieldsEvidenceItemRevisionMax)
})).max(getServiceCaseReviewResponseChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(getServiceCaseReviewResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(getServiceCaseReviewResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(getServiceCaseReviewResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(getServiceCaseReviewResponseBeforeOneFieldsEscalationReasonMin).max(getServiceCaseReviewResponseBeforeOneFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(getServiceCaseReviewResponseBeforeOneFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(getServiceCaseReviewResponseBeforeOneFieldsSummaryMax).optional(),
  "notes": zod.string().max(getServiceCaseReviewResponseBeforeOneFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(getServiceCaseReviewResponseBeforeOneFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(getServiceCaseReviewResponseBeforeOneFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getServiceCaseReviewResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(getServiceCaseReviewResponseBeforeOneFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getServiceCaseReviewResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getServiceCaseReviewResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "after": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(getServiceCaseReviewResponseAfterEscalationReasonMin).max(getServiceCaseReviewResponseAfterEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(getServiceCaseReviewResponseAfterInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(getServiceCaseReviewResponseAfterSummaryMax).optional(),
  "notes": zod.string().max(getServiceCaseReviewResponseAfterNotesMax).nullish(),
  "status": zod.string().min(1).max(getServiceCaseReviewResponseAfterStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(getServiceCaseReviewResponseAfterDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getServiceCaseReviewResponseAfterEvidenceItemRevisionMax)
})).max(getServiceCaseReviewResponseAfterEvidenceMax).optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(getServiceCaseReviewResponseReceiptOneFieldsEscalationReasonMin).max(getServiceCaseReviewResponseReceiptOneFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(getServiceCaseReviewResponseReceiptOneFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(getServiceCaseReviewResponseReceiptOneFieldsSummaryMax).optional(),
  "notes": zod.string().max(getServiceCaseReviewResponseReceiptOneFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(getServiceCaseReviewResponseReceiptOneFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(getServiceCaseReviewResponseReceiptOneFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getServiceCaseReviewResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(getServiceCaseReviewResponseReceiptOneFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getServiceCaseReviewResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getServiceCaseReviewResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "copiedContext": zod.record(zod.string(), zod.unknown()).nullable()
})


export const confirmServiceCaseChangeParams = zod.object({
  "id": zod.uuid()
})




export const confirmServiceCaseChangeBody = zod.object({
  "hash": zod.string().min(1),
  "confirmation": zod.enum(['CONFIRM'])
})


export const confirmServiceCaseChangeResponseChangeReasonMin = 3;
export const confirmServiceCaseChangeResponseChangeReasonMax = 500;

export const confirmServiceCaseChangeResponseChangeFieldsEscalationReasonMin = 3;
export const confirmServiceCaseChangeResponseChangeFieldsEscalationReasonMax = 5000;

export const confirmServiceCaseChangeResponseChangeFieldsInternalUpdateMax = 5000;

export const confirmServiceCaseChangeResponseChangeFieldsSummaryMax = 500;

export const confirmServiceCaseChangeResponseChangeFieldsNotesMax = 10000;

export const confirmServiceCaseChangeResponseChangeFieldsStatusMax = 120;

export const confirmServiceCaseChangeResponseChangeFieldsDecisionMax = 5000;

export const confirmServiceCaseChangeResponseChangeFieldsEvidenceItemRevisionMax = 128;

export const confirmServiceCaseChangeResponseChangeFieldsEvidenceMax = 50;


export const confirmServiceCaseChangeResponseChangeTaskSubjectMax = 500;

export const confirmServiceCaseChangeResponseChangeTaskBodyMax = 5000;

export const confirmServiceCaseChangeResponseChangeTaskPriorityMax = 120;

export const confirmServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMin = 3;
export const confirmServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMax = 5000;

export const confirmServiceCaseChangeResponseBeforeOneFieldsInternalUpdateMax = 5000;

export const confirmServiceCaseChangeResponseBeforeOneFieldsSummaryMax = 500;

export const confirmServiceCaseChangeResponseBeforeOneFieldsNotesMax = 10000;

export const confirmServiceCaseChangeResponseBeforeOneFieldsStatusMax = 120;

export const confirmServiceCaseChangeResponseBeforeOneFieldsDecisionMax = 5000;

export const confirmServiceCaseChangeResponseBeforeOneFieldsEvidenceItemRevisionMax = 128;

export const confirmServiceCaseChangeResponseBeforeOneFieldsEvidenceMax = 50;


export const confirmServiceCaseChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const confirmServiceCaseChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const confirmServiceCaseChangeResponseAfterEscalationReasonMin = 3;
export const confirmServiceCaseChangeResponseAfterEscalationReasonMax = 5000;

export const confirmServiceCaseChangeResponseAfterInternalUpdateMax = 5000;

export const confirmServiceCaseChangeResponseAfterSummaryMax = 500;

export const confirmServiceCaseChangeResponseAfterNotesMax = 10000;

export const confirmServiceCaseChangeResponseAfterStatusMax = 120;

export const confirmServiceCaseChangeResponseAfterDecisionMax = 5000;

export const confirmServiceCaseChangeResponseAfterEvidenceItemRevisionMax = 128;

export const confirmServiceCaseChangeResponseAfterEvidenceMax = 50;

export const confirmServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMin = 3;
export const confirmServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMax = 5000;

export const confirmServiceCaseChangeResponseReceiptOneFieldsInternalUpdateMax = 5000;

export const confirmServiceCaseChangeResponseReceiptOneFieldsSummaryMax = 500;

export const confirmServiceCaseChangeResponseReceiptOneFieldsNotesMax = 10000;

export const confirmServiceCaseChangeResponseReceiptOneFieldsStatusMax = 120;

export const confirmServiceCaseChangeResponseReceiptOneFieldsDecisionMax = 5000;

export const confirmServiceCaseChangeResponseReceiptOneFieldsEvidenceItemRevisionMax = 128;

export const confirmServiceCaseChangeResponseReceiptOneFieldsEvidenceMax = 50;


export const confirmServiceCaseChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const confirmServiceCaseChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const confirmServiceCaseChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'from_enquiry', 'update', 'link_enquiry', 'resolve', 'close', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(confirmServiceCaseChangeResponseChangeReasonMin).max(confirmServiceCaseChangeResponseChangeReasonMax),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(confirmServiceCaseChangeResponseChangeFieldsEscalationReasonMin).max(confirmServiceCaseChangeResponseChangeFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(confirmServiceCaseChangeResponseChangeFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(confirmServiceCaseChangeResponseChangeFieldsSummaryMax).optional(),
  "notes": zod.string().max(confirmServiceCaseChangeResponseChangeFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(confirmServiceCaseChangeResponseChangeFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(confirmServiceCaseChangeResponseChangeFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmServiceCaseChangeResponseChangeFieldsEvidenceItemRevisionMax)
})).max(confirmServiceCaseChangeResponseChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(confirmServiceCaseChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(confirmServiceCaseChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(confirmServiceCaseChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(confirmServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMin).max(confirmServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(confirmServiceCaseChangeResponseBeforeOneFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(confirmServiceCaseChangeResponseBeforeOneFieldsSummaryMax).optional(),
  "notes": zod.string().max(confirmServiceCaseChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(confirmServiceCaseChangeResponseBeforeOneFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(confirmServiceCaseChangeResponseBeforeOneFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmServiceCaseChangeResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(confirmServiceCaseChangeResponseBeforeOneFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmServiceCaseChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(confirmServiceCaseChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "after": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(confirmServiceCaseChangeResponseAfterEscalationReasonMin).max(confirmServiceCaseChangeResponseAfterEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(confirmServiceCaseChangeResponseAfterInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(confirmServiceCaseChangeResponseAfterSummaryMax).optional(),
  "notes": zod.string().max(confirmServiceCaseChangeResponseAfterNotesMax).nullish(),
  "status": zod.string().min(1).max(confirmServiceCaseChangeResponseAfterStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(confirmServiceCaseChangeResponseAfterDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmServiceCaseChangeResponseAfterEvidenceItemRevisionMax)
})).max(confirmServiceCaseChangeResponseAfterEvidenceMax).optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(confirmServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMin).max(confirmServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(confirmServiceCaseChangeResponseReceiptOneFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(confirmServiceCaseChangeResponseReceiptOneFieldsSummaryMax).optional(),
  "notes": zod.string().max(confirmServiceCaseChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(confirmServiceCaseChangeResponseReceiptOneFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(confirmServiceCaseChangeResponseReceiptOneFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmServiceCaseChangeResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(confirmServiceCaseChangeResponseReceiptOneFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmServiceCaseChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(confirmServiceCaseChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "copiedContext": zod.record(zod.string(), zod.unknown()).nullable()
})


export const cancelServiceCaseChangeParams = zod.object({
  "id": zod.uuid()
})


export const cancelServiceCaseChangeResponseChangeReasonMin = 3;
export const cancelServiceCaseChangeResponseChangeReasonMax = 500;

export const cancelServiceCaseChangeResponseChangeFieldsEscalationReasonMin = 3;
export const cancelServiceCaseChangeResponseChangeFieldsEscalationReasonMax = 5000;

export const cancelServiceCaseChangeResponseChangeFieldsInternalUpdateMax = 5000;

export const cancelServiceCaseChangeResponseChangeFieldsSummaryMax = 500;

export const cancelServiceCaseChangeResponseChangeFieldsNotesMax = 10000;

export const cancelServiceCaseChangeResponseChangeFieldsStatusMax = 120;

export const cancelServiceCaseChangeResponseChangeFieldsDecisionMax = 5000;

export const cancelServiceCaseChangeResponseChangeFieldsEvidenceItemRevisionMax = 128;

export const cancelServiceCaseChangeResponseChangeFieldsEvidenceMax = 50;


export const cancelServiceCaseChangeResponseChangeTaskSubjectMax = 500;

export const cancelServiceCaseChangeResponseChangeTaskBodyMax = 5000;

export const cancelServiceCaseChangeResponseChangeTaskPriorityMax = 120;

export const cancelServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMin = 3;
export const cancelServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMax = 5000;

export const cancelServiceCaseChangeResponseBeforeOneFieldsInternalUpdateMax = 5000;

export const cancelServiceCaseChangeResponseBeforeOneFieldsSummaryMax = 500;

export const cancelServiceCaseChangeResponseBeforeOneFieldsNotesMax = 10000;

export const cancelServiceCaseChangeResponseBeforeOneFieldsStatusMax = 120;

export const cancelServiceCaseChangeResponseBeforeOneFieldsDecisionMax = 5000;

export const cancelServiceCaseChangeResponseBeforeOneFieldsEvidenceItemRevisionMax = 128;

export const cancelServiceCaseChangeResponseBeforeOneFieldsEvidenceMax = 50;


export const cancelServiceCaseChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const cancelServiceCaseChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const cancelServiceCaseChangeResponseAfterEscalationReasonMin = 3;
export const cancelServiceCaseChangeResponseAfterEscalationReasonMax = 5000;

export const cancelServiceCaseChangeResponseAfterInternalUpdateMax = 5000;

export const cancelServiceCaseChangeResponseAfterSummaryMax = 500;

export const cancelServiceCaseChangeResponseAfterNotesMax = 10000;

export const cancelServiceCaseChangeResponseAfterStatusMax = 120;

export const cancelServiceCaseChangeResponseAfterDecisionMax = 5000;

export const cancelServiceCaseChangeResponseAfterEvidenceItemRevisionMax = 128;

export const cancelServiceCaseChangeResponseAfterEvidenceMax = 50;

export const cancelServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMin = 3;
export const cancelServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMax = 5000;

export const cancelServiceCaseChangeResponseReceiptOneFieldsInternalUpdateMax = 5000;

export const cancelServiceCaseChangeResponseReceiptOneFieldsSummaryMax = 500;

export const cancelServiceCaseChangeResponseReceiptOneFieldsNotesMax = 10000;

export const cancelServiceCaseChangeResponseReceiptOneFieldsStatusMax = 120;

export const cancelServiceCaseChangeResponseReceiptOneFieldsDecisionMax = 5000;

export const cancelServiceCaseChangeResponseReceiptOneFieldsEvidenceItemRevisionMax = 128;

export const cancelServiceCaseChangeResponseReceiptOneFieldsEvidenceMax = 50;


export const cancelServiceCaseChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const cancelServiceCaseChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const cancelServiceCaseChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'from_enquiry', 'update', 'link_enquiry', 'resolve', 'close', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(cancelServiceCaseChangeResponseChangeReasonMin).max(cancelServiceCaseChangeResponseChangeReasonMax),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(cancelServiceCaseChangeResponseChangeFieldsEscalationReasonMin).max(cancelServiceCaseChangeResponseChangeFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(cancelServiceCaseChangeResponseChangeFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(cancelServiceCaseChangeResponseChangeFieldsSummaryMax).optional(),
  "notes": zod.string().max(cancelServiceCaseChangeResponseChangeFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(cancelServiceCaseChangeResponseChangeFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(cancelServiceCaseChangeResponseChangeFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelServiceCaseChangeResponseChangeFieldsEvidenceItemRevisionMax)
})).max(cancelServiceCaseChangeResponseChangeFieldsEvidenceMax).optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(cancelServiceCaseChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(cancelServiceCaseChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(cancelServiceCaseChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(cancelServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMin).max(cancelServiceCaseChangeResponseBeforeOneFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(cancelServiceCaseChangeResponseBeforeOneFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(cancelServiceCaseChangeResponseBeforeOneFieldsSummaryMax).optional(),
  "notes": zod.string().max(cancelServiceCaseChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(cancelServiceCaseChangeResponseBeforeOneFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(cancelServiceCaseChangeResponseBeforeOneFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelServiceCaseChangeResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(cancelServiceCaseChangeResponseBeforeOneFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelServiceCaseChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(cancelServiceCaseChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "after": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(cancelServiceCaseChangeResponseAfterEscalationReasonMin).max(cancelServiceCaseChangeResponseAfterEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(cancelServiceCaseChangeResponseAfterInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(cancelServiceCaseChangeResponseAfterSummaryMax).optional(),
  "notes": zod.string().max(cancelServiceCaseChangeResponseAfterNotesMax).nullish(),
  "status": zod.string().min(1).max(cancelServiceCaseChangeResponseAfterStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(cancelServiceCaseChangeResponseAfterDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelServiceCaseChangeResponseAfterEvidenceItemRevisionMax)
})).max(cancelServiceCaseChangeResponseAfterEvidenceMax).optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.string(),
  "fields": zod.object({
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "responseTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "resolutionActualAt": zod.iso.datetime({"offset":true}).nullish(),
  "escalationState": zod.enum(['none', 'active', 'cleared']).optional(),
  "escalationOwnerId": zod.uuid().nullish(),
  "escalationReason": zod.string().min(cancelServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMin).max(cancelServiceCaseChangeResponseReceiptOneFieldsEscalationReasonMax).nullish(),
  "escalatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "internalUpdate": zod.string().max(cancelServiceCaseChangeResponseReceiptOneFieldsInternalUpdateMax).nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "ownerId": zod.uuid().nullish(),
  "classification": zod.enum(['case', 'request', 'complaint']).optional(),
  "priority": zod.enum(['low', 'normal', 'high', 'urgent']).optional(),
  "summary": zod.string().min(1).max(cancelServiceCaseChangeResponseReceiptOneFieldsSummaryMax).optional(),
  "notes": zod.string().max(cancelServiceCaseChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "status": zod.string().min(1).max(cancelServiceCaseChangeResponseReceiptOneFieldsStatusMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "resolvedOn": zod.iso.date().nullish(),
  "closedOn": zod.iso.date().nullish(),
  "decision": zod.string().max(cancelServiceCaseChangeResponseReceiptOneFieldsDecisionMax).nullish(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelServiceCaseChangeResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(cancelServiceCaseChangeResponseReceiptOneFieldsEvidenceMax).optional()
}),
  "timing": zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "responseState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "resolutionState": zod.enum(['missing', 'pending', 'due', 'overdue', 'met', 'late', 'recorded']),
  "responseElapsedSeconds": zod.number().nullable(),
  "resolutionElapsedSeconds": zod.number().nullable()
}).optional(),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelServiceCaseChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(cancelServiceCaseChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "unavailableEvidence": zod.int()
}),zod.null()]),
  "copiedContext": zod.record(zod.string(), zod.unknown()).nullable()
})


export const listDeliveryRecordsQueryResourceDefault = `plan`;
export const listDeliveryRecordsQueryStatusMax = 120;

export const listDeliveryRecordsQuerySearchMax = 200;

export const listDeliveryRecordsQueryLimitDefault = 20;
export const listDeliveryRecordsQueryLimitMax = 100;

export const listDeliveryRecordsQueryOffsetDefault = 0;
export const listDeliveryRecordsQueryOffsetMin = 0;
export const listDeliveryRecordsQueryOffsetMax = 1000000;



export const listDeliveryRecordsQueryParams = zod.object({
  "resource": zod.enum(['plan', 'item']).default(listDeliveryRecordsQueryResourceDefault),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "accountId": zod.uuid().optional(),
  "planId": zod.uuid().optional(),
  "opportunityId": zod.uuid().optional(),
  "agreementId": zod.uuid().optional(),
  "ownerId": zod.uuid().optional(),
  "status": zod.string().max(listDeliveryRecordsQueryStatusMax).optional(),
  "search": zod.string().max(listDeliveryRecordsQuerySearchMax).optional(),
  "from": zod.iso.date().optional(),
  "to": zod.iso.date().optional(),
  "limit": zod.int().min(1).max(listDeliveryRecordsQueryLimitMax).default(listDeliveryRecordsQueryLimitDefault),
  "offset": zod.int().min(listDeliveryRecordsQueryOffsetMin).max(listDeliveryRecordsQueryOffsetMax).default(listDeliveryRecordsQueryOffsetDefault)
})

export const listDeliveryRecordsResponseItemsItemFieldsTitleMax = 200;

export const listDeliveryRecordsResponseItemsItemFieldsSummaryMax = 5000;

export const listDeliveryRecordsResponseItemsItemFieldsNotesMax = 5000;

export const listDeliveryRecordsResponseItemsItemFieldsEvidenceMax = 5000;

export const listDeliveryRecordsResponseItemsItemFieldsStatusMax = 120;


export const listDeliveryRecordsResponseItemsItemTaskOneDurationMinutesMin = 0;

export const listDeliveryRecordsResponseItemsItemTaskOneIsTestDataDefault = false;

export const listDeliveryRecordsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(listDeliveryRecordsResponseItemsItemFieldsTitleMax).optional(),
  "summary": zod.string().max(listDeliveryRecordsResponseItemsItemFieldsSummaryMax).nullish(),
  "notes": zod.string().max(listDeliveryRecordsResponseItemsItemFieldsNotesMax).nullish(),
  "evidence": zod.string().max(listDeliveryRecordsResponseItemsItemFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(listDeliveryRecordsResponseItemsItemFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listDeliveryRecordsResponseItemsItemTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listDeliveryRecordsResponseItemsItemTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getDeliveryRecordParams = zod.object({
  "id": zod.uuid()
})

export const getDeliveryRecordResponseFieldsTitleMax = 200;

export const getDeliveryRecordResponseFieldsSummaryMax = 5000;

export const getDeliveryRecordResponseFieldsNotesMax = 5000;

export const getDeliveryRecordResponseFieldsEvidenceMax = 5000;

export const getDeliveryRecordResponseFieldsStatusMax = 120;


export const getDeliveryRecordResponseTaskOneDurationMinutesMin = 0;

export const getDeliveryRecordResponseTaskOneIsTestDataDefault = false;

export const getDeliveryRecordResponse = zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(getDeliveryRecordResponseFieldsTitleMax).optional(),
  "summary": zod.string().max(getDeliveryRecordResponseFieldsSummaryMax).nullish(),
  "notes": zod.string().max(getDeliveryRecordResponseFieldsNotesMax).nullish(),
  "evidence": zod.string().max(getDeliveryRecordResponseFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(getDeliveryRecordResponseFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getDeliveryRecordResponseTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getDeliveryRecordResponseTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
})


export const listDeliveryHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listDeliveryHistoryQueryLimitDefault = 20;
export const listDeliveryHistoryQueryLimitMax = 100;

export const listDeliveryHistoryQueryOffsetDefault = 0;
export const listDeliveryHistoryQueryOffsetMin = 0;
export const listDeliveryHistoryQueryOffsetMax = 1000000;



export const listDeliveryHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDeliveryHistoryQueryLimitMax).default(listDeliveryHistoryQueryLimitDefault),
  "offset": zod.int().min(listDeliveryHistoryQueryOffsetMin).max(listDeliveryHistoryQueryOffsetMax).default(listDeliveryHistoryQueryOffsetDefault)
})

export const listDeliveryHistoryResponseItemsItemSnapshotFieldsTitleMax = 200;

export const listDeliveryHistoryResponseItemsItemSnapshotFieldsSummaryMax = 5000;

export const listDeliveryHistoryResponseItemsItemSnapshotFieldsNotesMax = 5000;

export const listDeliveryHistoryResponseItemsItemSnapshotFieldsEvidenceMax = 5000;

export const listDeliveryHistoryResponseItemsItemSnapshotFieldsStatusMax = 120;


export const listDeliveryHistoryResponseItemsItemSnapshotTaskOneDurationMinutesMin = 0;

export const listDeliveryHistoryResponseItemsItemSnapshotTaskOneIsTestDataDefault = false;

export const listDeliveryHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actorId": zod.uuid(),
  "reason": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "snapshot": zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(listDeliveryHistoryResponseItemsItemSnapshotFieldsTitleMax).optional(),
  "summary": zod.string().max(listDeliveryHistoryResponseItemsItemSnapshotFieldsSummaryMax).nullish(),
  "notes": zod.string().max(listDeliveryHistoryResponseItemsItemSnapshotFieldsNotesMax).nullish(),
  "evidence": zod.string().max(listDeliveryHistoryResponseItemsItemSnapshotFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(listDeliveryHistoryResponseItemsItemSnapshotFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listDeliveryHistoryResponseItemsItemSnapshotTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listDeliveryHistoryResponseItemsItemSnapshotTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})



export const reviewDeliveryChangeBodyChangeReasonMin = 3;
export const reviewDeliveryChangeBodyChangeReasonMax = 500;

export const reviewDeliveryChangeBodyChangeFieldsTitleMax = 200;

export const reviewDeliveryChangeBodyChangeFieldsSummaryMax = 5000;

export const reviewDeliveryChangeBodyChangeFieldsNotesMax = 5000;

export const reviewDeliveryChangeBodyChangeFieldsEvidenceMax = 5000;

export const reviewDeliveryChangeBodyChangeFieldsStatusMax = 120;


export const reviewDeliveryChangeBodyChangeTaskSubjectMax = 500;

export const reviewDeliveryChangeBodyChangeTaskBodyMax = 5000;

export const reviewDeliveryChangeBodyChangeTaskPriorityMax = 120;



export const reviewDeliveryChangeBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "resource": zod.enum(['plan', 'item']),
  "operation": zod.enum(['create', 'update', 'accept', 'complete', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(reviewDeliveryChangeBodyChangeReasonMin).max(reviewDeliveryChangeBodyChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(reviewDeliveryChangeBodyChangeFieldsTitleMax).optional(),
  "summary": zod.string().max(reviewDeliveryChangeBodyChangeFieldsSummaryMax).nullish(),
  "notes": zod.string().max(reviewDeliveryChangeBodyChangeFieldsNotesMax).nullish(),
  "evidence": zod.string().max(reviewDeliveryChangeBodyChangeFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(reviewDeliveryChangeBodyChangeFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(reviewDeliveryChangeBodyChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(reviewDeliveryChangeBodyChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(reviewDeliveryChangeBodyChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
})
})


export const reviewDeliveryChangeResponseChangeReasonMin = 3;
export const reviewDeliveryChangeResponseChangeReasonMax = 500;

export const reviewDeliveryChangeResponseChangeFieldsTitleMax = 200;

export const reviewDeliveryChangeResponseChangeFieldsSummaryMax = 5000;

export const reviewDeliveryChangeResponseChangeFieldsNotesMax = 5000;

export const reviewDeliveryChangeResponseChangeFieldsEvidenceMax = 5000;

export const reviewDeliveryChangeResponseChangeFieldsStatusMax = 120;


export const reviewDeliveryChangeResponseChangeTaskSubjectMax = 500;

export const reviewDeliveryChangeResponseChangeTaskBodyMax = 5000;

export const reviewDeliveryChangeResponseChangeTaskPriorityMax = 120;

export const reviewDeliveryChangeResponseBeforeOneFieldsTitleMax = 200;

export const reviewDeliveryChangeResponseBeforeOneFieldsSummaryMax = 5000;

export const reviewDeliveryChangeResponseBeforeOneFieldsNotesMax = 5000;

export const reviewDeliveryChangeResponseBeforeOneFieldsEvidenceMax = 5000;

export const reviewDeliveryChangeResponseBeforeOneFieldsStatusMax = 120;


export const reviewDeliveryChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const reviewDeliveryChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const reviewDeliveryChangeResponseAfterTitleMax = 200;

export const reviewDeliveryChangeResponseAfterSummaryMax = 5000;

export const reviewDeliveryChangeResponseAfterNotesMax = 5000;

export const reviewDeliveryChangeResponseAfterEvidenceMax = 5000;

export const reviewDeliveryChangeResponseAfterStatusMax = 120;

export const reviewDeliveryChangeResponseReceiptOneFieldsTitleMax = 200;

export const reviewDeliveryChangeResponseReceiptOneFieldsSummaryMax = 5000;

export const reviewDeliveryChangeResponseReceiptOneFieldsNotesMax = 5000;

export const reviewDeliveryChangeResponseReceiptOneFieldsEvidenceMax = 5000;

export const reviewDeliveryChangeResponseReceiptOneFieldsStatusMax = 120;


export const reviewDeliveryChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const reviewDeliveryChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const reviewDeliveryChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "resource": zod.enum(['plan', 'item']),
  "operation": zod.enum(['create', 'update', 'accept', 'complete', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(reviewDeliveryChangeResponseChangeReasonMin).max(reviewDeliveryChangeResponseChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(reviewDeliveryChangeResponseChangeFieldsTitleMax).optional(),
  "summary": zod.string().max(reviewDeliveryChangeResponseChangeFieldsSummaryMax).nullish(),
  "notes": zod.string().max(reviewDeliveryChangeResponseChangeFieldsNotesMax).nullish(),
  "evidence": zod.string().max(reviewDeliveryChangeResponseChangeFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(reviewDeliveryChangeResponseChangeFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(reviewDeliveryChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(reviewDeliveryChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(reviewDeliveryChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(reviewDeliveryChangeResponseBeforeOneFieldsTitleMax).optional(),
  "summary": zod.string().max(reviewDeliveryChangeResponseBeforeOneFieldsSummaryMax).nullish(),
  "notes": zod.string().max(reviewDeliveryChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "evidence": zod.string().max(reviewDeliveryChangeResponseBeforeOneFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(reviewDeliveryChangeResponseBeforeOneFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewDeliveryChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewDeliveryChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}),zod.null()]),
  "after": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(reviewDeliveryChangeResponseAfterTitleMax).optional(),
  "summary": zod.string().max(reviewDeliveryChangeResponseAfterSummaryMax).nullish(),
  "notes": zod.string().max(reviewDeliveryChangeResponseAfterNotesMax).nullish(),
  "evidence": zod.string().max(reviewDeliveryChangeResponseAfterEvidenceMax).nullish(),
  "status": zod.string().min(1).max(reviewDeliveryChangeResponseAfterStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(reviewDeliveryChangeResponseReceiptOneFieldsTitleMax).optional(),
  "summary": zod.string().max(reviewDeliveryChangeResponseReceiptOneFieldsSummaryMax).nullish(),
  "notes": zod.string().max(reviewDeliveryChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "evidence": zod.string().max(reviewDeliveryChangeResponseReceiptOneFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(reviewDeliveryChangeResponseReceiptOneFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewDeliveryChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewDeliveryChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}),zod.null()])
})


export const getDeliveryReviewParams = zod.object({
  "id": zod.uuid()
})


export const getDeliveryReviewResponseChangeReasonMin = 3;
export const getDeliveryReviewResponseChangeReasonMax = 500;

export const getDeliveryReviewResponseChangeFieldsTitleMax = 200;

export const getDeliveryReviewResponseChangeFieldsSummaryMax = 5000;

export const getDeliveryReviewResponseChangeFieldsNotesMax = 5000;

export const getDeliveryReviewResponseChangeFieldsEvidenceMax = 5000;

export const getDeliveryReviewResponseChangeFieldsStatusMax = 120;


export const getDeliveryReviewResponseChangeTaskSubjectMax = 500;

export const getDeliveryReviewResponseChangeTaskBodyMax = 5000;

export const getDeliveryReviewResponseChangeTaskPriorityMax = 120;

export const getDeliveryReviewResponseBeforeOneFieldsTitleMax = 200;

export const getDeliveryReviewResponseBeforeOneFieldsSummaryMax = 5000;

export const getDeliveryReviewResponseBeforeOneFieldsNotesMax = 5000;

export const getDeliveryReviewResponseBeforeOneFieldsEvidenceMax = 5000;

export const getDeliveryReviewResponseBeforeOneFieldsStatusMax = 120;


export const getDeliveryReviewResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const getDeliveryReviewResponseBeforeOneTaskOneIsTestDataDefault = false;
export const getDeliveryReviewResponseAfterTitleMax = 200;

export const getDeliveryReviewResponseAfterSummaryMax = 5000;

export const getDeliveryReviewResponseAfterNotesMax = 5000;

export const getDeliveryReviewResponseAfterEvidenceMax = 5000;

export const getDeliveryReviewResponseAfterStatusMax = 120;

export const getDeliveryReviewResponseReceiptOneFieldsTitleMax = 200;

export const getDeliveryReviewResponseReceiptOneFieldsSummaryMax = 5000;

export const getDeliveryReviewResponseReceiptOneFieldsNotesMax = 5000;

export const getDeliveryReviewResponseReceiptOneFieldsEvidenceMax = 5000;

export const getDeliveryReviewResponseReceiptOneFieldsStatusMax = 120;


export const getDeliveryReviewResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const getDeliveryReviewResponseReceiptOneTaskOneIsTestDataDefault = false;

export const getDeliveryReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "resource": zod.enum(['plan', 'item']),
  "operation": zod.enum(['create', 'update', 'accept', 'complete', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(getDeliveryReviewResponseChangeReasonMin).max(getDeliveryReviewResponseChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(getDeliveryReviewResponseChangeFieldsTitleMax).optional(),
  "summary": zod.string().max(getDeliveryReviewResponseChangeFieldsSummaryMax).nullish(),
  "notes": zod.string().max(getDeliveryReviewResponseChangeFieldsNotesMax).nullish(),
  "evidence": zod.string().max(getDeliveryReviewResponseChangeFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(getDeliveryReviewResponseChangeFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(getDeliveryReviewResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(getDeliveryReviewResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(getDeliveryReviewResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(getDeliveryReviewResponseBeforeOneFieldsTitleMax).optional(),
  "summary": zod.string().max(getDeliveryReviewResponseBeforeOneFieldsSummaryMax).nullish(),
  "notes": zod.string().max(getDeliveryReviewResponseBeforeOneFieldsNotesMax).nullish(),
  "evidence": zod.string().max(getDeliveryReviewResponseBeforeOneFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(getDeliveryReviewResponseBeforeOneFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getDeliveryReviewResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getDeliveryReviewResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}),zod.null()]),
  "after": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(getDeliveryReviewResponseAfterTitleMax).optional(),
  "summary": zod.string().max(getDeliveryReviewResponseAfterSummaryMax).nullish(),
  "notes": zod.string().max(getDeliveryReviewResponseAfterNotesMax).nullish(),
  "evidence": zod.string().max(getDeliveryReviewResponseAfterEvidenceMax).nullish(),
  "status": zod.string().min(1).max(getDeliveryReviewResponseAfterStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(getDeliveryReviewResponseReceiptOneFieldsTitleMax).optional(),
  "summary": zod.string().max(getDeliveryReviewResponseReceiptOneFieldsSummaryMax).nullish(),
  "notes": zod.string().max(getDeliveryReviewResponseReceiptOneFieldsNotesMax).nullish(),
  "evidence": zod.string().max(getDeliveryReviewResponseReceiptOneFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(getDeliveryReviewResponseReceiptOneFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getDeliveryReviewResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getDeliveryReviewResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}),zod.null()])
})


export const confirmDeliveryChangeParams = zod.object({
  "id": zod.uuid()
})




export const confirmDeliveryChangeBody = zod.object({
  "hash": zod.string().min(1),
  "confirmation": zod.enum(['CONFIRM'])
})


export const confirmDeliveryChangeResponseChangeReasonMin = 3;
export const confirmDeliveryChangeResponseChangeReasonMax = 500;

export const confirmDeliveryChangeResponseChangeFieldsTitleMax = 200;

export const confirmDeliveryChangeResponseChangeFieldsSummaryMax = 5000;

export const confirmDeliveryChangeResponseChangeFieldsNotesMax = 5000;

export const confirmDeliveryChangeResponseChangeFieldsEvidenceMax = 5000;

export const confirmDeliveryChangeResponseChangeFieldsStatusMax = 120;


export const confirmDeliveryChangeResponseChangeTaskSubjectMax = 500;

export const confirmDeliveryChangeResponseChangeTaskBodyMax = 5000;

export const confirmDeliveryChangeResponseChangeTaskPriorityMax = 120;

export const confirmDeliveryChangeResponseBeforeOneFieldsTitleMax = 200;

export const confirmDeliveryChangeResponseBeforeOneFieldsSummaryMax = 5000;

export const confirmDeliveryChangeResponseBeforeOneFieldsNotesMax = 5000;

export const confirmDeliveryChangeResponseBeforeOneFieldsEvidenceMax = 5000;

export const confirmDeliveryChangeResponseBeforeOneFieldsStatusMax = 120;


export const confirmDeliveryChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const confirmDeliveryChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const confirmDeliveryChangeResponseAfterTitleMax = 200;

export const confirmDeliveryChangeResponseAfterSummaryMax = 5000;

export const confirmDeliveryChangeResponseAfterNotesMax = 5000;

export const confirmDeliveryChangeResponseAfterEvidenceMax = 5000;

export const confirmDeliveryChangeResponseAfterStatusMax = 120;

export const confirmDeliveryChangeResponseReceiptOneFieldsTitleMax = 200;

export const confirmDeliveryChangeResponseReceiptOneFieldsSummaryMax = 5000;

export const confirmDeliveryChangeResponseReceiptOneFieldsNotesMax = 5000;

export const confirmDeliveryChangeResponseReceiptOneFieldsEvidenceMax = 5000;

export const confirmDeliveryChangeResponseReceiptOneFieldsStatusMax = 120;


export const confirmDeliveryChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const confirmDeliveryChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const confirmDeliveryChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "resource": zod.enum(['plan', 'item']),
  "operation": zod.enum(['create', 'update', 'accept', 'complete', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(confirmDeliveryChangeResponseChangeReasonMin).max(confirmDeliveryChangeResponseChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(confirmDeliveryChangeResponseChangeFieldsTitleMax).optional(),
  "summary": zod.string().max(confirmDeliveryChangeResponseChangeFieldsSummaryMax).nullish(),
  "notes": zod.string().max(confirmDeliveryChangeResponseChangeFieldsNotesMax).nullish(),
  "evidence": zod.string().max(confirmDeliveryChangeResponseChangeFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(confirmDeliveryChangeResponseChangeFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(confirmDeliveryChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(confirmDeliveryChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(confirmDeliveryChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(confirmDeliveryChangeResponseBeforeOneFieldsTitleMax).optional(),
  "summary": zod.string().max(confirmDeliveryChangeResponseBeforeOneFieldsSummaryMax).nullish(),
  "notes": zod.string().max(confirmDeliveryChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "evidence": zod.string().max(confirmDeliveryChangeResponseBeforeOneFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(confirmDeliveryChangeResponseBeforeOneFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmDeliveryChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(confirmDeliveryChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}),zod.null()]),
  "after": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(confirmDeliveryChangeResponseAfterTitleMax).optional(),
  "summary": zod.string().max(confirmDeliveryChangeResponseAfterSummaryMax).nullish(),
  "notes": zod.string().max(confirmDeliveryChangeResponseAfterNotesMax).nullish(),
  "evidence": zod.string().max(confirmDeliveryChangeResponseAfterEvidenceMax).nullish(),
  "status": zod.string().min(1).max(confirmDeliveryChangeResponseAfterStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(confirmDeliveryChangeResponseReceiptOneFieldsTitleMax).optional(),
  "summary": zod.string().max(confirmDeliveryChangeResponseReceiptOneFieldsSummaryMax).nullish(),
  "notes": zod.string().max(confirmDeliveryChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "evidence": zod.string().max(confirmDeliveryChangeResponseReceiptOneFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(confirmDeliveryChangeResponseReceiptOneFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmDeliveryChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(confirmDeliveryChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}),zod.null()])
})


export const cancelDeliveryChangeParams = zod.object({
  "id": zod.uuid()
})


export const cancelDeliveryChangeResponseChangeReasonMin = 3;
export const cancelDeliveryChangeResponseChangeReasonMax = 500;

export const cancelDeliveryChangeResponseChangeFieldsTitleMax = 200;

export const cancelDeliveryChangeResponseChangeFieldsSummaryMax = 5000;

export const cancelDeliveryChangeResponseChangeFieldsNotesMax = 5000;

export const cancelDeliveryChangeResponseChangeFieldsEvidenceMax = 5000;

export const cancelDeliveryChangeResponseChangeFieldsStatusMax = 120;


export const cancelDeliveryChangeResponseChangeTaskSubjectMax = 500;

export const cancelDeliveryChangeResponseChangeTaskBodyMax = 5000;

export const cancelDeliveryChangeResponseChangeTaskPriorityMax = 120;

export const cancelDeliveryChangeResponseBeforeOneFieldsTitleMax = 200;

export const cancelDeliveryChangeResponseBeforeOneFieldsSummaryMax = 5000;

export const cancelDeliveryChangeResponseBeforeOneFieldsNotesMax = 5000;

export const cancelDeliveryChangeResponseBeforeOneFieldsEvidenceMax = 5000;

export const cancelDeliveryChangeResponseBeforeOneFieldsStatusMax = 120;


export const cancelDeliveryChangeResponseBeforeOneTaskOneDurationMinutesMin = 0;

export const cancelDeliveryChangeResponseBeforeOneTaskOneIsTestDataDefault = false;
export const cancelDeliveryChangeResponseAfterTitleMax = 200;

export const cancelDeliveryChangeResponseAfterSummaryMax = 5000;

export const cancelDeliveryChangeResponseAfterNotesMax = 5000;

export const cancelDeliveryChangeResponseAfterEvidenceMax = 5000;

export const cancelDeliveryChangeResponseAfterStatusMax = 120;

export const cancelDeliveryChangeResponseReceiptOneFieldsTitleMax = 200;

export const cancelDeliveryChangeResponseReceiptOneFieldsSummaryMax = 5000;

export const cancelDeliveryChangeResponseReceiptOneFieldsNotesMax = 5000;

export const cancelDeliveryChangeResponseReceiptOneFieldsEvidenceMax = 5000;

export const cancelDeliveryChangeResponseReceiptOneFieldsStatusMax = 120;


export const cancelDeliveryChangeResponseReceiptOneTaskOneDurationMinutesMin = 0;

export const cancelDeliveryChangeResponseReceiptOneTaskOneIsTestDataDefault = false;

export const cancelDeliveryChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "resource": zod.enum(['plan', 'item']),
  "operation": zod.enum(['create', 'update', 'accept', 'complete', 'reopen', 'task']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(1).optional(),
  "reason": zod.string().min(cancelDeliveryChangeResponseChangeReasonMin).max(cancelDeliveryChangeResponseChangeReasonMax),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(cancelDeliveryChangeResponseChangeFieldsTitleMax).optional(),
  "summary": zod.string().max(cancelDeliveryChangeResponseChangeFieldsSummaryMax).nullish(),
  "notes": zod.string().max(cancelDeliveryChangeResponseChangeFieldsNotesMax).nullish(),
  "evidence": zod.string().max(cancelDeliveryChangeResponseChangeFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(cancelDeliveryChangeResponseChangeFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}).optional(),
  "task": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "expectedVersion": zod.int().min(1).optional(),
  "subject": zod.string().max(cancelDeliveryChangeResponseChangeTaskSubjectMax).nullish(),
  "body": zod.string().min(1).max(cancelDeliveryChangeResponseChangeTaskBodyMax).optional(),
  "ownerId": zod.uuid().nullish(),
  "priority": zod.string().max(cancelDeliveryChangeResponseChangeTaskPriorityMax).nullish(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional()
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(cancelDeliveryChangeResponseBeforeOneFieldsTitleMax).optional(),
  "summary": zod.string().max(cancelDeliveryChangeResponseBeforeOneFieldsSummaryMax).nullish(),
  "notes": zod.string().max(cancelDeliveryChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "evidence": zod.string().max(cancelDeliveryChangeResponseBeforeOneFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(cancelDeliveryChangeResponseBeforeOneFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelDeliveryChangeResponseBeforeOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(cancelDeliveryChangeResponseBeforeOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}),zod.null()]),
  "after": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(cancelDeliveryChangeResponseAfterTitleMax).optional(),
  "summary": zod.string().max(cancelDeliveryChangeResponseAfterSummaryMax).nullish(),
  "notes": zod.string().max(cancelDeliveryChangeResponseAfterNotesMax).nullish(),
  "evidence": zod.string().max(cancelDeliveryChangeResponseAfterEvidenceMax).nullish(),
  "status": zod.string().min(1).max(cancelDeliveryChangeResponseAfterStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['plan', 'item']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().nullish(),
  "planId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "agreementId": zod.uuid().nullish(),
  "obligationId": zod.uuid().nullish(),
  "initiatingId": zod.uuid().nullish(),
  "receivingId": zod.uuid().nullish(),
  "ownerId": zod.uuid().nullish(),
  "agreementKind": zod.enum(['partner', 'general']).nullish(),
  "kind": zod.enum(['setup', 'responsibility', 'obligation', 'milestone']).optional(),
  "title": zod.string().min(1).max(cancelDeliveryChangeResponseReceiptOneFieldsTitleMax).optional(),
  "summary": zod.string().max(cancelDeliveryChangeResponseReceiptOneFieldsSummaryMax).nullish(),
  "notes": zod.string().max(cancelDeliveryChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "evidence": zod.string().max(cancelDeliveryChangeResponseReceiptOneFieldsEvidenceMax).nullish(),
  "status": zod.string().min(1).max(cancelDeliveryChangeResponseReceiptOneFieldsStatusMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completedOn": zod.iso.date().nullish(),
  "acceptedOn": zod.iso.date().nullish(),
  "initiatedOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional()
}),
  "task": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelDeliveryChangeResponseReceiptOneTaskOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(cancelDeliveryChangeResponseReceiptOneTaskOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
}),zod.null()])
})


/**
 * @summary Complete scoped read-only opportunity forecast with stable paged groups and drilldowns
 */
export const getOpportunityForecastQueryOwnerIdMax = 200;

export const getOpportunityForecastQueryOwnerStateDefault = `any`;
export const getOpportunityForecastQueryCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getOpportunityForecastQueryOutcomeDefault = `all`;
export const getOpportunityForecastQueryCloseDateDefault = `any`;
export const getOpportunityForecastQueryMissingDefault = `all`;
export const getOpportunityForecastQueryGroupByDefault = `month`;
export const getOpportunityForecastQueryGroupKeyMax = 300;

export const getOpportunityForecastQueryIncludeTestDataDefault = false;
export const getOpportunityForecastQueryLimitDefault = 25;
export const getOpportunityForecastQueryLimitMax = 100;

export const getOpportunityForecastQueryOffsetDefault = 0;
export const getOpportunityForecastQueryOffsetMin = 0;
export const getOpportunityForecastQueryOffsetMax = 1000000;

export const getOpportunityForecastQueryGroupLimitDefault = 25;
export const getOpportunityForecastQueryGroupLimitMax = 100;

export const getOpportunityForecastQueryGroupOffsetDefault = 0;
export const getOpportunityForecastQueryGroupOffsetMin = 0;
export const getOpportunityForecastQueryGroupOffsetMax = 1000000;



export const getOpportunityForecastQueryParams = zod.object({
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "ownerId": zod.string().min(1).max(getOpportunityForecastQueryOwnerIdMax).optional(),
  "ownerState": zod.enum(['any', 'assigned', 'unassigned']).default(getOpportunityForecastQueryOwnerStateDefault),
  "currency": zod.string().regex(getOpportunityForecastQueryCurrencyRegExp).optional(),
  "outcome": zod.enum(['all', 'open', 'won', 'lost']).default(getOpportunityForecastQueryOutcomeDefault),
  "from": zod.iso.date().optional(),
  "to": zod.iso.date().optional(),
  "closeDate": zod.enum(['any', 'known', 'missing']).default(getOpportunityForecastQueryCloseDateDefault),
  "missing": zod.enum(['all', 'complete', 'any', 'value', 'probability', 'currency', 'closeDate', 'owner']).default(getOpportunityForecastQueryMissingDefault),
  "groupBy": zod.enum(['currency', 'owner', 'pipeline', 'month', 'quarter', 'year']).default(getOpportunityForecastQueryGroupByDefault),
  "groupKey": zod.string().min(1).max(getOpportunityForecastQueryGroupKeyMax).optional(),
  "opportunityId": zod.uuid().optional(),
  "includeTestData": zod.boolean().default(getOpportunityForecastQueryIncludeTestDataDefault),
  "limit": zod.int().min(1).max(getOpportunityForecastQueryLimitMax).default(getOpportunityForecastQueryLimitDefault),
  "offset": zod.int().min(getOpportunityForecastQueryOffsetMin).max(getOpportunityForecastQueryOffsetMax).default(getOpportunityForecastQueryOffsetDefault),
  "groupLimit": zod.int().min(1).max(getOpportunityForecastQueryGroupLimitMax).default(getOpportunityForecastQueryGroupLimitDefault),
  "groupOffset": zod.int().min(getOpportunityForecastQueryGroupOffsetMin).max(getOpportunityForecastQueryGroupOffsetMax).default(getOpportunityForecastQueryGroupOffsetDefault)
})

export const getOpportunityForecastResponse = zod.object({
  "asOf": zod.iso.datetime({"offset":true}),
  "calculation": zod.string(),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "groupTotal": zod.int(),
  "groupLimit": zod.int(),
  "groupOffset": zod.int(),
  "totals": zod.array(zod.object({
  "groupKey": zod.string(),
  "currency": zod.string().nullable(),
  "outcome": zod.enum(['open', 'won', 'lost']),
  "count": zod.int(),
  "gross": zod.string().nullable().describe('Exact decimal sum of valid nonnegative values with known currency'),
  "weighted": zod.string().nullable().describe('Exact decimal sum of value times probability divided by 100 for valid inputs and known currency'),
  "grossCount": zod.int(),
  "weightedCount": zod.int(),
  "missingValue": zod.int(),
  "missingProbability": zod.int(),
  "missingCurrency": zod.int(),
  "missingCloseDate": zod.int(),
  "missingOwner": zod.int()
})),
  "groups": zod.array(zod.object({
  "groupKey": zod.string(),
  "currency": zod.string().nullable(),
  "outcome": zod.enum(['open', 'won', 'lost']),
  "count": zod.int(),
  "gross": zod.string().nullable().describe('Exact decimal sum of valid nonnegative values with known currency'),
  "weighted": zod.string().nullable().describe('Exact decimal sum of value times probability divided by 100 for valid inputs and known currency'),
  "grossCount": zod.int(),
  "weightedCount": zod.int(),
  "missingValue": zod.int(),
  "missingProbability": zod.int(),
  "missingCurrency": zod.int(),
  "missingCloseDate": zod.int(),
  "missingOwner": zod.int()
})),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "pipeline": zod.string(),
  "stage": zod.string(),
  "outcome": zod.enum(['open', 'won', 'lost']),
  "ownerId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "currency": zod.string().nullable(),
  "value": zod.string().nullable(),
  "probability": zod.int().nullable(),
  "weighted": zod.string().nullable(),
  "expectedCloseDate": zod.string().nullable(),
  "groupKey": zod.string(),
  "link": zod.string()
}))
})


export const listAgreementRegisterQueryResourceDefault = `agreement`;
export const listAgreementRegisterQueryStatusMax = 120;

export const listAgreementRegisterQuerySearchMax = 200;

export const listAgreementRegisterQueryLimitDefault = 20;
export const listAgreementRegisterQueryLimitMax = 100;

export const listAgreementRegisterQueryOffsetDefault = 0;
export const listAgreementRegisterQueryOffsetMin = 0;
export const listAgreementRegisterQueryOffsetMax = 10000;



export const listAgreementRegisterQueryParams = zod.object({
  "resource": zod.enum(['agreement', 'obligation']).default(listAgreementRegisterQueryResourceDefault),
  "sourceKind": zod.enum(['partner', 'general']).optional(),
  "agreementId": zod.uuid().optional(),
  "accountId": zod.uuid().optional(),
  "ownerId": zod.uuid().optional(),
  "status": zod.string().max(listAgreementRegisterQueryStatusMax).optional(),
  "search": zod.string().max(listAgreementRegisterQuerySearchMax).optional(),
  "from": zod.iso.date().optional(),
  "to": zod.iso.date().optional(),
  "limit": zod.int().min(1).max(listAgreementRegisterQueryLimitMax).default(listAgreementRegisterQueryLimitDefault),
  "offset": zod.int().min(listAgreementRegisterQueryOffsetMin).max(listAgreementRegisterQueryOffsetMax).default(listAgreementRegisterQueryOffsetDefault)
})

export const listAgreementRegisterResponseItemsItemFieldsPartiesMax = 2000;

export const listAgreementRegisterResponseItemsItemFieldsTitleMax = 200;

export const listAgreementRegisterResponseItemsItemFieldsTermsMax = 10000;

export const listAgreementRegisterResponseItemsItemFieldsNotesMax = 10000;

export const listAgreementRegisterResponseItemsItemFieldsDocumentsItemRevisionMin = 64;
export const listAgreementRegisterResponseItemsItemFieldsDocumentsItemRevisionMax = 64;

export const listAgreementRegisterResponseItemsItemFieldsDocumentsMax = 30;

export const listAgreementRegisterResponseItemsItemFieldsDescriptionMax = 5000;



export const listAgreementRegisterResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(listAgreementRegisterResponseItemsItemFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(listAgreementRegisterResponseItemsItemFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(listAgreementRegisterResponseItemsItemFieldsTermsMax).nullish(),
  "notes": zod.string().max(listAgreementRegisterResponseItemsItemFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(listAgreementRegisterResponseItemsItemFieldsDocumentsItemRevisionMin).max(listAgreementRegisterResponseItemsItemFieldsDocumentsItemRevisionMax)
})).max(listAgreementRegisterResponseItemsItemFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(listAgreementRegisterResponseItemsItemFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const listAgreementRegisterChoicesQuerySearchMax = 200;

export const listAgreementRegisterChoicesQueryLimitDefault = 20;
export const listAgreementRegisterChoicesQueryLimitMax = 100;

export const listAgreementRegisterChoicesQueryOffsetDefault = 0;
export const listAgreementRegisterChoicesQueryOffsetMin = 0;
export const listAgreementRegisterChoicesQueryOffsetMax = 10000;



export const listAgreementRegisterChoicesQueryParams = zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'owner', 'document']),
  "search": zod.string().max(listAgreementRegisterChoicesQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listAgreementRegisterChoicesQueryLimitMax).default(listAgreementRegisterChoicesQueryLimitDefault),
  "offset": zod.int().min(listAgreementRegisterChoicesQueryOffsetMin).max(listAgreementRegisterChoicesQueryOffsetMax).default(listAgreementRegisterChoicesQueryOffsetDefault)
})

export const listAgreementRegisterChoicesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "revision": zod.string(),
  "versionId": zod.uuid().optional()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getAgreementRegisterRecordParams = zod.object({
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "id": zod.uuid()
})

export const getAgreementRegisterRecordResponseFieldsPartiesMax = 2000;

export const getAgreementRegisterRecordResponseFieldsTitleMax = 200;

export const getAgreementRegisterRecordResponseFieldsTermsMax = 10000;

export const getAgreementRegisterRecordResponseFieldsNotesMax = 10000;

export const getAgreementRegisterRecordResponseFieldsDocumentsItemRevisionMin = 64;
export const getAgreementRegisterRecordResponseFieldsDocumentsItemRevisionMax = 64;

export const getAgreementRegisterRecordResponseFieldsDocumentsMax = 30;

export const getAgreementRegisterRecordResponseFieldsDescriptionMax = 5000;



export const getAgreementRegisterRecordResponse = zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(getAgreementRegisterRecordResponseFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(getAgreementRegisterRecordResponseFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(getAgreementRegisterRecordResponseFieldsTermsMax).nullish(),
  "notes": zod.string().max(getAgreementRegisterRecordResponseFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(getAgreementRegisterRecordResponseFieldsDocumentsItemRevisionMin).max(getAgreementRegisterRecordResponseFieldsDocumentsItemRevisionMax)
})).max(getAgreementRegisterRecordResponseFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(getAgreementRegisterRecordResponseFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
})


export const listAgreementRegisterHistoryParams = zod.object({
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "id": zod.uuid()
})

export const listAgreementRegisterHistoryQueryLimitDefault = 20;
export const listAgreementRegisterHistoryQueryLimitMax = 100;

export const listAgreementRegisterHistoryQueryOffsetDefault = 0;
export const listAgreementRegisterHistoryQueryOffsetMin = 0;
export const listAgreementRegisterHistoryQueryOffsetMax = 10000;



export const listAgreementRegisterHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listAgreementRegisterHistoryQueryLimitMax).default(listAgreementRegisterHistoryQueryLimitDefault),
  "offset": zod.int().min(listAgreementRegisterHistoryQueryOffsetMin).max(listAgreementRegisterHistoryQueryOffsetMax).default(listAgreementRegisterHistoryQueryOffsetDefault)
})

export const listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsPartiesMax = 2000;

export const listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsTitleMax = 200;

export const listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsTermsMax = 10000;

export const listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsNotesMax = 10000;

export const listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsDocumentsItemRevisionMin = 64;
export const listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsDocumentsItemRevisionMax = 64;

export const listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsDocumentsMax = 30;

export const listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsDescriptionMax = 5000;



export const listAgreementRegisterHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "actorId": zod.string(),
  "reason": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "snapshot": zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsTermsMax).nullish(),
  "notes": zod.string().max(listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsDocumentsItemRevisionMin).max(listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsDocumentsItemRevisionMax)
})).max(listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(listAgreementRegisterHistoryResponseItemsItemSnapshotFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const reviewAgreementRegisterChangeBodyChangeExpectedVersionMin = 64;
export const reviewAgreementRegisterChangeBodyChangeExpectedVersionMax = 64;

export const reviewAgreementRegisterChangeBodyChangeFieldsPartiesMax = 2000;

export const reviewAgreementRegisterChangeBodyChangeFieldsTitleMax = 200;

export const reviewAgreementRegisterChangeBodyChangeFieldsTermsMax = 10000;

export const reviewAgreementRegisterChangeBodyChangeFieldsNotesMax = 10000;

export const reviewAgreementRegisterChangeBodyChangeFieldsDocumentsItemRevisionMin = 64;
export const reviewAgreementRegisterChangeBodyChangeFieldsDocumentsItemRevisionMax = 64;

export const reviewAgreementRegisterChangeBodyChangeFieldsDocumentsMax = 30;

export const reviewAgreementRegisterChangeBodyChangeFieldsDescriptionMax = 5000;

export const reviewAgreementRegisterChangeBodyChangeReasonMin = 3;
export const reviewAgreementRegisterChangeBodyChangeReasonMax = 500;



export const reviewAgreementRegisterChangeBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(reviewAgreementRegisterChangeBodyChangeExpectedVersionMin).max(reviewAgreementRegisterChangeBodyChangeExpectedVersionMax).optional(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(reviewAgreementRegisterChangeBodyChangeFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(reviewAgreementRegisterChangeBodyChangeFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(reviewAgreementRegisterChangeBodyChangeFieldsTermsMax).nullish(),
  "notes": zod.string().max(reviewAgreementRegisterChangeBodyChangeFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(reviewAgreementRegisterChangeBodyChangeFieldsDocumentsItemRevisionMin).max(reviewAgreementRegisterChangeBodyChangeFieldsDocumentsItemRevisionMax)
})).max(reviewAgreementRegisterChangeBodyChangeFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(reviewAgreementRegisterChangeBodyChangeFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(reviewAgreementRegisterChangeBodyChangeReasonMin).max(reviewAgreementRegisterChangeBodyChangeReasonMax)
})
})

export const reviewAgreementRegisterChangeResponseChangeExpectedVersionMin = 64;
export const reviewAgreementRegisterChangeResponseChangeExpectedVersionMax = 64;

export const reviewAgreementRegisterChangeResponseChangeFieldsPartiesMax = 2000;

export const reviewAgreementRegisterChangeResponseChangeFieldsTitleMax = 200;

export const reviewAgreementRegisterChangeResponseChangeFieldsTermsMax = 10000;

export const reviewAgreementRegisterChangeResponseChangeFieldsNotesMax = 10000;

export const reviewAgreementRegisterChangeResponseChangeFieldsDocumentsItemRevisionMin = 64;
export const reviewAgreementRegisterChangeResponseChangeFieldsDocumentsItemRevisionMax = 64;

export const reviewAgreementRegisterChangeResponseChangeFieldsDocumentsMax = 30;

export const reviewAgreementRegisterChangeResponseChangeFieldsDescriptionMax = 5000;

export const reviewAgreementRegisterChangeResponseChangeReasonMin = 3;
export const reviewAgreementRegisterChangeResponseChangeReasonMax = 500;

export const reviewAgreementRegisterChangeResponseBeforeOneFieldsPartiesMax = 2000;

export const reviewAgreementRegisterChangeResponseBeforeOneFieldsTitleMax = 200;

export const reviewAgreementRegisterChangeResponseBeforeOneFieldsTermsMax = 10000;

export const reviewAgreementRegisterChangeResponseBeforeOneFieldsNotesMax = 10000;

export const reviewAgreementRegisterChangeResponseBeforeOneFieldsDocumentsItemRevisionMin = 64;
export const reviewAgreementRegisterChangeResponseBeforeOneFieldsDocumentsItemRevisionMax = 64;

export const reviewAgreementRegisterChangeResponseBeforeOneFieldsDocumentsMax = 30;

export const reviewAgreementRegisterChangeResponseBeforeOneFieldsDescriptionMax = 5000;

export const reviewAgreementRegisterChangeResponseAfterPartiesMax = 2000;

export const reviewAgreementRegisterChangeResponseAfterTitleMax = 200;

export const reviewAgreementRegisterChangeResponseAfterTermsMax = 10000;

export const reviewAgreementRegisterChangeResponseAfterNotesMax = 10000;

export const reviewAgreementRegisterChangeResponseAfterDocumentsItemRevisionMin = 64;
export const reviewAgreementRegisterChangeResponseAfterDocumentsItemRevisionMax = 64;

export const reviewAgreementRegisterChangeResponseAfterDocumentsMax = 30;

export const reviewAgreementRegisterChangeResponseAfterDescriptionMax = 5000;

export const reviewAgreementRegisterChangeResponseReceiptOneFieldsPartiesMax = 2000;

export const reviewAgreementRegisterChangeResponseReceiptOneFieldsTitleMax = 200;

export const reviewAgreementRegisterChangeResponseReceiptOneFieldsTermsMax = 10000;

export const reviewAgreementRegisterChangeResponseReceiptOneFieldsNotesMax = 10000;

export const reviewAgreementRegisterChangeResponseReceiptOneFieldsDocumentsItemRevisionMin = 64;
export const reviewAgreementRegisterChangeResponseReceiptOneFieldsDocumentsItemRevisionMax = 64;

export const reviewAgreementRegisterChangeResponseReceiptOneFieldsDocumentsMax = 30;

export const reviewAgreementRegisterChangeResponseReceiptOneFieldsDescriptionMax = 5000;



export const reviewAgreementRegisterChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(reviewAgreementRegisterChangeResponseChangeExpectedVersionMin).max(reviewAgreementRegisterChangeResponseChangeExpectedVersionMax).optional(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(reviewAgreementRegisterChangeResponseChangeFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(reviewAgreementRegisterChangeResponseChangeFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(reviewAgreementRegisterChangeResponseChangeFieldsTermsMax).nullish(),
  "notes": zod.string().max(reviewAgreementRegisterChangeResponseChangeFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(reviewAgreementRegisterChangeResponseChangeFieldsDocumentsItemRevisionMin).max(reviewAgreementRegisterChangeResponseChangeFieldsDocumentsItemRevisionMax)
})).max(reviewAgreementRegisterChangeResponseChangeFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(reviewAgreementRegisterChangeResponseChangeFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(reviewAgreementRegisterChangeResponseChangeReasonMin).max(reviewAgreementRegisterChangeResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(reviewAgreementRegisterChangeResponseBeforeOneFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(reviewAgreementRegisterChangeResponseBeforeOneFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(reviewAgreementRegisterChangeResponseBeforeOneFieldsTermsMax).nullish(),
  "notes": zod.string().max(reviewAgreementRegisterChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(reviewAgreementRegisterChangeResponseBeforeOneFieldsDocumentsItemRevisionMin).max(reviewAgreementRegisterChangeResponseBeforeOneFieldsDocumentsItemRevisionMax)
})).max(reviewAgreementRegisterChangeResponseBeforeOneFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(reviewAgreementRegisterChangeResponseBeforeOneFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
}),zod.null()]).optional(),
  "after": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(reviewAgreementRegisterChangeResponseAfterPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(reviewAgreementRegisterChangeResponseAfterTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(reviewAgreementRegisterChangeResponseAfterTermsMax).nullish(),
  "notes": zod.string().max(reviewAgreementRegisterChangeResponseAfterNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(reviewAgreementRegisterChangeResponseAfterDocumentsItemRevisionMin).max(reviewAgreementRegisterChangeResponseAfterDocumentsItemRevisionMax)
})).max(reviewAgreementRegisterChangeResponseAfterDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(reviewAgreementRegisterChangeResponseAfterDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(reviewAgreementRegisterChangeResponseReceiptOneFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(reviewAgreementRegisterChangeResponseReceiptOneFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(reviewAgreementRegisterChangeResponseReceiptOneFieldsTermsMax).nullish(),
  "notes": zod.string().max(reviewAgreementRegisterChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(reviewAgreementRegisterChangeResponseReceiptOneFieldsDocumentsItemRevisionMin).max(reviewAgreementRegisterChangeResponseReceiptOneFieldsDocumentsItemRevisionMax)
})).max(reviewAgreementRegisterChangeResponseReceiptOneFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(reviewAgreementRegisterChangeResponseReceiptOneFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
}),zod.null()]).optional()
})


export const getAgreementRegisterReviewParams = zod.object({
  "id": zod.uuid()
})

export const getAgreementRegisterReviewResponseChangeExpectedVersionMin = 64;
export const getAgreementRegisterReviewResponseChangeExpectedVersionMax = 64;

export const getAgreementRegisterReviewResponseChangeFieldsPartiesMax = 2000;

export const getAgreementRegisterReviewResponseChangeFieldsTitleMax = 200;

export const getAgreementRegisterReviewResponseChangeFieldsTermsMax = 10000;

export const getAgreementRegisterReviewResponseChangeFieldsNotesMax = 10000;

export const getAgreementRegisterReviewResponseChangeFieldsDocumentsItemRevisionMin = 64;
export const getAgreementRegisterReviewResponseChangeFieldsDocumentsItemRevisionMax = 64;

export const getAgreementRegisterReviewResponseChangeFieldsDocumentsMax = 30;

export const getAgreementRegisterReviewResponseChangeFieldsDescriptionMax = 5000;

export const getAgreementRegisterReviewResponseChangeReasonMin = 3;
export const getAgreementRegisterReviewResponseChangeReasonMax = 500;

export const getAgreementRegisterReviewResponseBeforeOneFieldsPartiesMax = 2000;

export const getAgreementRegisterReviewResponseBeforeOneFieldsTitleMax = 200;

export const getAgreementRegisterReviewResponseBeforeOneFieldsTermsMax = 10000;

export const getAgreementRegisterReviewResponseBeforeOneFieldsNotesMax = 10000;

export const getAgreementRegisterReviewResponseBeforeOneFieldsDocumentsItemRevisionMin = 64;
export const getAgreementRegisterReviewResponseBeforeOneFieldsDocumentsItemRevisionMax = 64;

export const getAgreementRegisterReviewResponseBeforeOneFieldsDocumentsMax = 30;

export const getAgreementRegisterReviewResponseBeforeOneFieldsDescriptionMax = 5000;

export const getAgreementRegisterReviewResponseAfterPartiesMax = 2000;

export const getAgreementRegisterReviewResponseAfterTitleMax = 200;

export const getAgreementRegisterReviewResponseAfterTermsMax = 10000;

export const getAgreementRegisterReviewResponseAfterNotesMax = 10000;

export const getAgreementRegisterReviewResponseAfterDocumentsItemRevisionMin = 64;
export const getAgreementRegisterReviewResponseAfterDocumentsItemRevisionMax = 64;

export const getAgreementRegisterReviewResponseAfterDocumentsMax = 30;

export const getAgreementRegisterReviewResponseAfterDescriptionMax = 5000;

export const getAgreementRegisterReviewResponseReceiptOneFieldsPartiesMax = 2000;

export const getAgreementRegisterReviewResponseReceiptOneFieldsTitleMax = 200;

export const getAgreementRegisterReviewResponseReceiptOneFieldsTermsMax = 10000;

export const getAgreementRegisterReviewResponseReceiptOneFieldsNotesMax = 10000;

export const getAgreementRegisterReviewResponseReceiptOneFieldsDocumentsItemRevisionMin = 64;
export const getAgreementRegisterReviewResponseReceiptOneFieldsDocumentsItemRevisionMax = 64;

export const getAgreementRegisterReviewResponseReceiptOneFieldsDocumentsMax = 30;

export const getAgreementRegisterReviewResponseReceiptOneFieldsDescriptionMax = 5000;



export const getAgreementRegisterReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(getAgreementRegisterReviewResponseChangeExpectedVersionMin).max(getAgreementRegisterReviewResponseChangeExpectedVersionMax).optional(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(getAgreementRegisterReviewResponseChangeFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(getAgreementRegisterReviewResponseChangeFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(getAgreementRegisterReviewResponseChangeFieldsTermsMax).nullish(),
  "notes": zod.string().max(getAgreementRegisterReviewResponseChangeFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(getAgreementRegisterReviewResponseChangeFieldsDocumentsItemRevisionMin).max(getAgreementRegisterReviewResponseChangeFieldsDocumentsItemRevisionMax)
})).max(getAgreementRegisterReviewResponseChangeFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(getAgreementRegisterReviewResponseChangeFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(getAgreementRegisterReviewResponseChangeReasonMin).max(getAgreementRegisterReviewResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(getAgreementRegisterReviewResponseBeforeOneFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(getAgreementRegisterReviewResponseBeforeOneFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(getAgreementRegisterReviewResponseBeforeOneFieldsTermsMax).nullish(),
  "notes": zod.string().max(getAgreementRegisterReviewResponseBeforeOneFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(getAgreementRegisterReviewResponseBeforeOneFieldsDocumentsItemRevisionMin).max(getAgreementRegisterReviewResponseBeforeOneFieldsDocumentsItemRevisionMax)
})).max(getAgreementRegisterReviewResponseBeforeOneFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(getAgreementRegisterReviewResponseBeforeOneFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
}),zod.null()]).optional(),
  "after": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(getAgreementRegisterReviewResponseAfterPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(getAgreementRegisterReviewResponseAfterTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(getAgreementRegisterReviewResponseAfterTermsMax).nullish(),
  "notes": zod.string().max(getAgreementRegisterReviewResponseAfterNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(getAgreementRegisterReviewResponseAfterDocumentsItemRevisionMin).max(getAgreementRegisterReviewResponseAfterDocumentsItemRevisionMax)
})).max(getAgreementRegisterReviewResponseAfterDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(getAgreementRegisterReviewResponseAfterDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(getAgreementRegisterReviewResponseReceiptOneFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(getAgreementRegisterReviewResponseReceiptOneFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(getAgreementRegisterReviewResponseReceiptOneFieldsTermsMax).nullish(),
  "notes": zod.string().max(getAgreementRegisterReviewResponseReceiptOneFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(getAgreementRegisterReviewResponseReceiptOneFieldsDocumentsItemRevisionMin).max(getAgreementRegisterReviewResponseReceiptOneFieldsDocumentsItemRevisionMax)
})).max(getAgreementRegisterReviewResponseReceiptOneFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(getAgreementRegisterReviewResponseReceiptOneFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
}),zod.null()]).optional()
})


export const confirmAgreementRegisterChangeParams = zod.object({
  "id": zod.uuid()
})

export const confirmAgreementRegisterChangeBodyHashMin = 64;
export const confirmAgreementRegisterChangeBodyHashMax = 64;



export const confirmAgreementRegisterChangeBody = zod.object({
  "hash": zod.string().min(confirmAgreementRegisterChangeBodyHashMin).max(confirmAgreementRegisterChangeBodyHashMax),
  "confirmation": zod.enum(['CONFIRM'])
})

export const confirmAgreementRegisterChangeResponseChangeExpectedVersionMin = 64;
export const confirmAgreementRegisterChangeResponseChangeExpectedVersionMax = 64;

export const confirmAgreementRegisterChangeResponseChangeFieldsPartiesMax = 2000;

export const confirmAgreementRegisterChangeResponseChangeFieldsTitleMax = 200;

export const confirmAgreementRegisterChangeResponseChangeFieldsTermsMax = 10000;

export const confirmAgreementRegisterChangeResponseChangeFieldsNotesMax = 10000;

export const confirmAgreementRegisterChangeResponseChangeFieldsDocumentsItemRevisionMin = 64;
export const confirmAgreementRegisterChangeResponseChangeFieldsDocumentsItemRevisionMax = 64;

export const confirmAgreementRegisterChangeResponseChangeFieldsDocumentsMax = 30;

export const confirmAgreementRegisterChangeResponseChangeFieldsDescriptionMax = 5000;

export const confirmAgreementRegisterChangeResponseChangeReasonMin = 3;
export const confirmAgreementRegisterChangeResponseChangeReasonMax = 500;

export const confirmAgreementRegisterChangeResponseBeforeOneFieldsPartiesMax = 2000;

export const confirmAgreementRegisterChangeResponseBeforeOneFieldsTitleMax = 200;

export const confirmAgreementRegisterChangeResponseBeforeOneFieldsTermsMax = 10000;

export const confirmAgreementRegisterChangeResponseBeforeOneFieldsNotesMax = 10000;

export const confirmAgreementRegisterChangeResponseBeforeOneFieldsDocumentsItemRevisionMin = 64;
export const confirmAgreementRegisterChangeResponseBeforeOneFieldsDocumentsItemRevisionMax = 64;

export const confirmAgreementRegisterChangeResponseBeforeOneFieldsDocumentsMax = 30;

export const confirmAgreementRegisterChangeResponseBeforeOneFieldsDescriptionMax = 5000;

export const confirmAgreementRegisterChangeResponseAfterPartiesMax = 2000;

export const confirmAgreementRegisterChangeResponseAfterTitleMax = 200;

export const confirmAgreementRegisterChangeResponseAfterTermsMax = 10000;

export const confirmAgreementRegisterChangeResponseAfterNotesMax = 10000;

export const confirmAgreementRegisterChangeResponseAfterDocumentsItemRevisionMin = 64;
export const confirmAgreementRegisterChangeResponseAfterDocumentsItemRevisionMax = 64;

export const confirmAgreementRegisterChangeResponseAfterDocumentsMax = 30;

export const confirmAgreementRegisterChangeResponseAfterDescriptionMax = 5000;

export const confirmAgreementRegisterChangeResponseReceiptOneFieldsPartiesMax = 2000;

export const confirmAgreementRegisterChangeResponseReceiptOneFieldsTitleMax = 200;

export const confirmAgreementRegisterChangeResponseReceiptOneFieldsTermsMax = 10000;

export const confirmAgreementRegisterChangeResponseReceiptOneFieldsNotesMax = 10000;

export const confirmAgreementRegisterChangeResponseReceiptOneFieldsDocumentsItemRevisionMin = 64;
export const confirmAgreementRegisterChangeResponseReceiptOneFieldsDocumentsItemRevisionMax = 64;

export const confirmAgreementRegisterChangeResponseReceiptOneFieldsDocumentsMax = 30;

export const confirmAgreementRegisterChangeResponseReceiptOneFieldsDescriptionMax = 5000;



export const confirmAgreementRegisterChangeResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(confirmAgreementRegisterChangeResponseChangeExpectedVersionMin).max(confirmAgreementRegisterChangeResponseChangeExpectedVersionMax).optional(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(confirmAgreementRegisterChangeResponseChangeFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(confirmAgreementRegisterChangeResponseChangeFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(confirmAgreementRegisterChangeResponseChangeFieldsTermsMax).nullish(),
  "notes": zod.string().max(confirmAgreementRegisterChangeResponseChangeFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(confirmAgreementRegisterChangeResponseChangeFieldsDocumentsItemRevisionMin).max(confirmAgreementRegisterChangeResponseChangeFieldsDocumentsItemRevisionMax)
})).max(confirmAgreementRegisterChangeResponseChangeFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(confirmAgreementRegisterChangeResponseChangeFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(confirmAgreementRegisterChangeResponseChangeReasonMin).max(confirmAgreementRegisterChangeResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(confirmAgreementRegisterChangeResponseBeforeOneFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(confirmAgreementRegisterChangeResponseBeforeOneFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(confirmAgreementRegisterChangeResponseBeforeOneFieldsTermsMax).nullish(),
  "notes": zod.string().max(confirmAgreementRegisterChangeResponseBeforeOneFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(confirmAgreementRegisterChangeResponseBeforeOneFieldsDocumentsItemRevisionMin).max(confirmAgreementRegisterChangeResponseBeforeOneFieldsDocumentsItemRevisionMax)
})).max(confirmAgreementRegisterChangeResponseBeforeOneFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(confirmAgreementRegisterChangeResponseBeforeOneFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
}),zod.null()]).optional(),
  "after": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(confirmAgreementRegisterChangeResponseAfterPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(confirmAgreementRegisterChangeResponseAfterTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(confirmAgreementRegisterChangeResponseAfterTermsMax).nullish(),
  "notes": zod.string().max(confirmAgreementRegisterChangeResponseAfterNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(confirmAgreementRegisterChangeResponseAfterDocumentsItemRevisionMin).max(confirmAgreementRegisterChangeResponseAfterDocumentsItemRevisionMax)
})).max(confirmAgreementRegisterChangeResponseAfterDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(confirmAgreementRegisterChangeResponseAfterDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(confirmAgreementRegisterChangeResponseReceiptOneFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(confirmAgreementRegisterChangeResponseReceiptOneFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(confirmAgreementRegisterChangeResponseReceiptOneFieldsTermsMax).nullish(),
  "notes": zod.string().max(confirmAgreementRegisterChangeResponseReceiptOneFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(confirmAgreementRegisterChangeResponseReceiptOneFieldsDocumentsItemRevisionMin).max(confirmAgreementRegisterChangeResponseReceiptOneFieldsDocumentsItemRevisionMax)
})).max(confirmAgreementRegisterChangeResponseReceiptOneFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(confirmAgreementRegisterChangeResponseReceiptOneFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
}),zod.null()]).optional()
})


export const cancelAgreementRegisterReviewParams = zod.object({
  "id": zod.uuid()
})

export const cancelAgreementRegisterReviewResponseChangeExpectedVersionMin = 64;
export const cancelAgreementRegisterReviewResponseChangeExpectedVersionMax = 64;

export const cancelAgreementRegisterReviewResponseChangeFieldsPartiesMax = 2000;

export const cancelAgreementRegisterReviewResponseChangeFieldsTitleMax = 200;

export const cancelAgreementRegisterReviewResponseChangeFieldsTermsMax = 10000;

export const cancelAgreementRegisterReviewResponseChangeFieldsNotesMax = 10000;

export const cancelAgreementRegisterReviewResponseChangeFieldsDocumentsItemRevisionMin = 64;
export const cancelAgreementRegisterReviewResponseChangeFieldsDocumentsItemRevisionMax = 64;

export const cancelAgreementRegisterReviewResponseChangeFieldsDocumentsMax = 30;

export const cancelAgreementRegisterReviewResponseChangeFieldsDescriptionMax = 5000;

export const cancelAgreementRegisterReviewResponseChangeReasonMin = 3;
export const cancelAgreementRegisterReviewResponseChangeReasonMax = 500;

export const cancelAgreementRegisterReviewResponseBeforeOneFieldsPartiesMax = 2000;

export const cancelAgreementRegisterReviewResponseBeforeOneFieldsTitleMax = 200;

export const cancelAgreementRegisterReviewResponseBeforeOneFieldsTermsMax = 10000;

export const cancelAgreementRegisterReviewResponseBeforeOneFieldsNotesMax = 10000;

export const cancelAgreementRegisterReviewResponseBeforeOneFieldsDocumentsItemRevisionMin = 64;
export const cancelAgreementRegisterReviewResponseBeforeOneFieldsDocumentsItemRevisionMax = 64;

export const cancelAgreementRegisterReviewResponseBeforeOneFieldsDocumentsMax = 30;

export const cancelAgreementRegisterReviewResponseBeforeOneFieldsDescriptionMax = 5000;

export const cancelAgreementRegisterReviewResponseAfterPartiesMax = 2000;

export const cancelAgreementRegisterReviewResponseAfterTitleMax = 200;

export const cancelAgreementRegisterReviewResponseAfterTermsMax = 10000;

export const cancelAgreementRegisterReviewResponseAfterNotesMax = 10000;

export const cancelAgreementRegisterReviewResponseAfterDocumentsItemRevisionMin = 64;
export const cancelAgreementRegisterReviewResponseAfterDocumentsItemRevisionMax = 64;

export const cancelAgreementRegisterReviewResponseAfterDocumentsMax = 30;

export const cancelAgreementRegisterReviewResponseAfterDescriptionMax = 5000;

export const cancelAgreementRegisterReviewResponseReceiptOneFieldsPartiesMax = 2000;

export const cancelAgreementRegisterReviewResponseReceiptOneFieldsTitleMax = 200;

export const cancelAgreementRegisterReviewResponseReceiptOneFieldsTermsMax = 10000;

export const cancelAgreementRegisterReviewResponseReceiptOneFieldsNotesMax = 10000;

export const cancelAgreementRegisterReviewResponseReceiptOneFieldsDocumentsItemRevisionMin = 64;
export const cancelAgreementRegisterReviewResponseReceiptOneFieldsDocumentsItemRevisionMax = 64;

export const cancelAgreementRegisterReviewResponseReceiptOneFieldsDocumentsMax = 30;

export const cancelAgreementRegisterReviewResponseReceiptOneFieldsDescriptionMax = 5000;



export const cancelAgreementRegisterReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.string().min(cancelAgreementRegisterReviewResponseChangeExpectedVersionMin).max(cancelAgreementRegisterReviewResponseChangeExpectedVersionMax).optional(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(cancelAgreementRegisterReviewResponseChangeFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(cancelAgreementRegisterReviewResponseChangeFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(cancelAgreementRegisterReviewResponseChangeFieldsTermsMax).nullish(),
  "notes": zod.string().max(cancelAgreementRegisterReviewResponseChangeFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(cancelAgreementRegisterReviewResponseChangeFieldsDocumentsItemRevisionMin).max(cancelAgreementRegisterReviewResponseChangeFieldsDocumentsItemRevisionMax)
})).max(cancelAgreementRegisterReviewResponseChangeFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(cancelAgreementRegisterReviewResponseChangeFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(cancelAgreementRegisterReviewResponseChangeReasonMin).max(cancelAgreementRegisterReviewResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(cancelAgreementRegisterReviewResponseBeforeOneFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(cancelAgreementRegisterReviewResponseBeforeOneFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(cancelAgreementRegisterReviewResponseBeforeOneFieldsTermsMax).nullish(),
  "notes": zod.string().max(cancelAgreementRegisterReviewResponseBeforeOneFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(cancelAgreementRegisterReviewResponseBeforeOneFieldsDocumentsItemRevisionMin).max(cancelAgreementRegisterReviewResponseBeforeOneFieldsDocumentsItemRevisionMax)
})).max(cancelAgreementRegisterReviewResponseBeforeOneFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(cancelAgreementRegisterReviewResponseBeforeOneFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
}),zod.null()]).optional(),
  "after": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(cancelAgreementRegisterReviewResponseAfterPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(cancelAgreementRegisterReviewResponseAfterTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(cancelAgreementRegisterReviewResponseAfterTermsMax).nullish(),
  "notes": zod.string().max(cancelAgreementRegisterReviewResponseAfterNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(cancelAgreementRegisterReviewResponseAfterDocumentsItemRevisionMin).max(cancelAgreementRegisterReviewResponseAfterDocumentsItemRevisionMax)
})).max(cancelAgreementRegisterReviewResponseAfterDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(cancelAgreementRegisterReviewResponseAfterDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "resource": zod.enum(['agreement', 'obligation']),
  "sourceKind": zod.enum(['partner', 'general']),
  "version": zod.string(),
  "fields": zod.object({
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().nullish(),
  "partyContactId": zod.uuid().nullish(),
  "parties": zod.string().max(cancelAgreementRegisterReviewResponseReceiptOneFieldsPartiesMax).nullish(),
  "ownerId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(cancelAgreementRegisterReviewResponseReceiptOneFieldsTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional(),
  "signedOn": zod.iso.date().nullish(),
  "expiresOn": zod.iso.date().nullish(),
  "terms": zod.string().max(cancelAgreementRegisterReviewResponseReceiptOneFieldsTermsMax).nullish(),
  "notes": zod.string().max(cancelAgreementRegisterReviewResponseReceiptOneFieldsNotesMax).nullish(),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "revision": zod.string().min(cancelAgreementRegisterReviewResponseReceiptOneFieldsDocumentsItemRevisionMin).max(cancelAgreementRegisterReviewResponseReceiptOneFieldsDocumentsItemRevisionMax)
})).max(cancelAgreementRegisterReviewResponseReceiptOneFieldsDocumentsMax).optional(),
  "agreementId": zod.uuid().optional(),
  "description": zod.string().min(1).max(cancelAgreementRegisterReviewResponseReceiptOneFieldsDescriptionMax).optional(),
  "dueOn": zod.iso.date().nullish(),
  "completed": zod.boolean().optional(),
  "completedOn": zod.iso.date().nullish()
}),
  "unavailableDocuments": zod.int()
}),zod.null()]).optional()
})


/**
 * @summary listCrmStakeholders
 */
export const listCrmStakeholdersQueryLimitDefault = 25;
export const listCrmStakeholdersQueryLimitMax = 100;

export const listCrmStakeholdersQueryOffsetDefault = 0;
export const listCrmStakeholdersQueryOffsetMin = 0;

export const listCrmStakeholdersQuerySearchMax = 200;

export const listCrmStakeholdersQueryRoleMax = 120;

export const listCrmStakeholdersQueryStanceMax = 120;

export const listCrmStakeholdersQueryIncludeRemovedDefault = false;

export const listCrmStakeholdersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listCrmStakeholdersQueryLimitMax).default(listCrmStakeholdersQueryLimitDefault),
  "offset": zod.int().min(listCrmStakeholdersQueryOffsetMin).default(listCrmStakeholdersQueryOffsetDefault),
  "search": zod.string().max(listCrmStakeholdersQuerySearchMax).optional(),
  "contextAccountId": zod.uuid().optional(),
  "contextOpportunityId": zod.uuid().optional(),
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().optional(),
  "relatedAccountId": zod.uuid().optional(),
  "relatedContactId": zod.uuid().optional(),
  "role": zod.string().max(listCrmStakeholdersQueryRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high', 'unknown']).optional(),
  "stance": zod.string().max(listCrmStakeholdersQueryStanceMax).optional(),
  "from": zod.iso.date().optional(),
  "to": zod.iso.date().optional(),
  "includeRemoved": zod.boolean().default(listCrmStakeholdersQueryIncludeRemovedDefault)
})

export const listCrmStakeholdersResponseItemsItemOneRoleMax = 120;

export const listCrmStakeholdersResponseItemsItemOneStanceMax = 120;

export const listCrmStakeholdersResponseItemsItemOneRelationshipLabelMax = 120;

export const listCrmStakeholdersResponseItemsItemOneNotesMax = 10000;


export const listCrmStakeholdersResponseTotalMin = 0;



export const listCrmStakeholdersResponse = zod.object({
  "items": zod.array(zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(listCrmStakeholdersResponseItemsItemOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(listCrmStakeholdersResponseItemsItemOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(listCrmStakeholdersResponseItemsItemOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(listCrmStakeholdersResponseItemsItemOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}))),
  "total": zod.int().min(listCrmStakeholdersResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary getCrmStakeholder
 */
export const getCrmStakeholderParams = zod.object({
  "id": zod.uuid()
})

export const getCrmStakeholderResponseOneRoleMax = 120;

export const getCrmStakeholderResponseOneStanceMax = 120;

export const getCrmStakeholderResponseOneRelationshipLabelMax = 120;

export const getCrmStakeholderResponseOneNotesMax = 10000;




export const getCrmStakeholderResponse = zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(getCrmStakeholderResponseOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(getCrmStakeholderResponseOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(getCrmStakeholderResponseOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(getCrmStakeholderResponseOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}))


/**
 * @summary listCrmStakeholderHistory
 */
export const listCrmStakeholderHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listCrmStakeholderHistoryQueryLimitDefault = 25;
export const listCrmStakeholderHistoryQueryLimitMax = 100;

export const listCrmStakeholderHistoryQueryOffsetDefault = 0;
export const listCrmStakeholderHistoryQueryOffsetMin = 0;



export const listCrmStakeholderHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listCrmStakeholderHistoryQueryLimitMax).default(listCrmStakeholderHistoryQueryLimitDefault),
  "offset": zod.int().min(listCrmStakeholderHistoryQueryOffsetMin).default(listCrmStakeholderHistoryQueryOffsetDefault)
})

export const listCrmStakeholderHistoryResponseItemsItemSnapshotOneRoleMax = 120;

export const listCrmStakeholderHistoryResponseItemsItemSnapshotOneStanceMax = 120;

export const listCrmStakeholderHistoryResponseItemsItemSnapshotOneRelationshipLabelMax = 120;

export const listCrmStakeholderHistoryResponseItemsItemSnapshotOneNotesMax = 10000;


export const listCrmStakeholderHistoryResponseTotalMin = 0;



export const listCrmStakeholderHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "operation": zod.string(),
  "reason": zod.string(),
  "snapshot": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(listCrmStakeholderHistoryResponseItemsItemSnapshotOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(listCrmStakeholderHistoryResponseItemsItemSnapshotOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(listCrmStakeholderHistoryResponseItemsItemSnapshotOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(listCrmStakeholderHistoryResponseItemsItemSnapshotOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),
  "actorId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listCrmStakeholderHistoryResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary listCrmStakeholderChoices
 */
export const listCrmStakeholderChoicesQueryLimitDefault = 25;
export const listCrmStakeholderChoicesQueryLimitMax = 100;

export const listCrmStakeholderChoicesQueryOffsetDefault = 0;
export const listCrmStakeholderChoicesQueryOffsetMin = 0;

export const listCrmStakeholderChoicesQuerySearchMax = 200;



export const listCrmStakeholderChoicesQueryParams = zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity']),
  "limit": zod.int().min(1).max(listCrmStakeholderChoicesQueryLimitMax).default(listCrmStakeholderChoicesQueryLimitDefault),
  "offset": zod.int().min(listCrmStakeholderChoicesQueryOffsetMin).default(listCrmStakeholderChoicesQueryOffsetDefault),
  "search": zod.string().max(listCrmStakeholderChoicesQuerySearchMax).optional()
})

export const listCrmStakeholderChoicesResponseTotalMin = 0;



export const listCrmStakeholderChoicesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string()
})),
  "total": zod.int().min(listCrmStakeholderChoicesResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary reviewCrmStakeholder
 */

export const reviewCrmStakeholderBodyChangeFieldsRoleMax = 120;

export const reviewCrmStakeholderBodyChangeFieldsStanceMax = 120;

export const reviewCrmStakeholderBodyChangeFieldsRelationshipLabelMax = 120;

export const reviewCrmStakeholderBodyChangeFieldsNotesMax = 10000;

export const reviewCrmStakeholderBodyChangeReasonMin = 3;
export const reviewCrmStakeholderBodyChangeReasonMax = 500;



export const reviewCrmStakeholderBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'remove']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(reviewCrmStakeholderBodyChangeFieldsRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(reviewCrmStakeholderBodyChangeFieldsStanceMax).nullish(),
  "relationshipLabel": zod.string().max(reviewCrmStakeholderBodyChangeFieldsRelationshipLabelMax).nullish(),
  "notes": zod.string().max(reviewCrmStakeholderBodyChangeFieldsNotesMax).optional(),
  "reviewOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(reviewCrmStakeholderBodyChangeReasonMin).max(reviewCrmStakeholderBodyChangeReasonMax)
})
})


export const reviewCrmStakeholderResponseChangeFieldsRoleMax = 120;

export const reviewCrmStakeholderResponseChangeFieldsStanceMax = 120;

export const reviewCrmStakeholderResponseChangeFieldsRelationshipLabelMax = 120;

export const reviewCrmStakeholderResponseChangeFieldsNotesMax = 10000;

export const reviewCrmStakeholderResponseChangeReasonMin = 3;
export const reviewCrmStakeholderResponseChangeReasonMax = 500;

export const reviewCrmStakeholderResponseBeforeOneOneRoleMax = 120;

export const reviewCrmStakeholderResponseBeforeOneOneStanceMax = 120;

export const reviewCrmStakeholderResponseBeforeOneOneRelationshipLabelMax = 120;

export const reviewCrmStakeholderResponseBeforeOneOneNotesMax = 10000;


export const reviewCrmStakeholderResponseAfterRoleMax = 120;

export const reviewCrmStakeholderResponseAfterStanceMax = 120;

export const reviewCrmStakeholderResponseAfterRelationshipLabelMax = 120;

export const reviewCrmStakeholderResponseAfterNotesMax = 10000;

export const reviewCrmStakeholderResponseReceiptOneOneRoleMax = 120;

export const reviewCrmStakeholderResponseReceiptOneOneStanceMax = 120;

export const reviewCrmStakeholderResponseReceiptOneOneRelationshipLabelMax = 120;

export const reviewCrmStakeholderResponseReceiptOneOneNotesMax = 10000;




export const reviewCrmStakeholderResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'remove']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(reviewCrmStakeholderResponseChangeFieldsRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(reviewCrmStakeholderResponseChangeFieldsStanceMax).nullish(),
  "relationshipLabel": zod.string().max(reviewCrmStakeholderResponseChangeFieldsRelationshipLabelMax).nullish(),
  "notes": zod.string().max(reviewCrmStakeholderResponseChangeFieldsNotesMax).optional(),
  "reviewOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(reviewCrmStakeholderResponseChangeReasonMin).max(reviewCrmStakeholderResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(reviewCrmStakeholderResponseBeforeOneOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(reviewCrmStakeholderResponseBeforeOneOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(reviewCrmStakeholderResponseBeforeOneOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(reviewCrmStakeholderResponseBeforeOneOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()]),
  "after": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(reviewCrmStakeholderResponseAfterRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(reviewCrmStakeholderResponseAfterStanceMax).nullish(),
  "relationshipLabel": zod.string().max(reviewCrmStakeholderResponseAfterRelationshipLabelMax).nullish(),
  "notes": zod.string().max(reviewCrmStakeholderResponseAfterNotesMax).optional(),
  "reviewOn": zod.iso.date().nullish()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(reviewCrmStakeholderResponseReceiptOneOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(reviewCrmStakeholderResponseReceiptOneOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(reviewCrmStakeholderResponseReceiptOneOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(reviewCrmStakeholderResponseReceiptOneOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()])
})


/**
 * @summary getCrmStakeholderReview
 */
export const getCrmStakeholderReviewParams = zod.object({
  "id": zod.uuid()
})


export const getCrmStakeholderReviewResponseChangeFieldsRoleMax = 120;

export const getCrmStakeholderReviewResponseChangeFieldsStanceMax = 120;

export const getCrmStakeholderReviewResponseChangeFieldsRelationshipLabelMax = 120;

export const getCrmStakeholderReviewResponseChangeFieldsNotesMax = 10000;

export const getCrmStakeholderReviewResponseChangeReasonMin = 3;
export const getCrmStakeholderReviewResponseChangeReasonMax = 500;

export const getCrmStakeholderReviewResponseBeforeOneOneRoleMax = 120;

export const getCrmStakeholderReviewResponseBeforeOneOneStanceMax = 120;

export const getCrmStakeholderReviewResponseBeforeOneOneRelationshipLabelMax = 120;

export const getCrmStakeholderReviewResponseBeforeOneOneNotesMax = 10000;


export const getCrmStakeholderReviewResponseAfterRoleMax = 120;

export const getCrmStakeholderReviewResponseAfterStanceMax = 120;

export const getCrmStakeholderReviewResponseAfterRelationshipLabelMax = 120;

export const getCrmStakeholderReviewResponseAfterNotesMax = 10000;

export const getCrmStakeholderReviewResponseReceiptOneOneRoleMax = 120;

export const getCrmStakeholderReviewResponseReceiptOneOneStanceMax = 120;

export const getCrmStakeholderReviewResponseReceiptOneOneRelationshipLabelMax = 120;

export const getCrmStakeholderReviewResponseReceiptOneOneNotesMax = 10000;




export const getCrmStakeholderReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'remove']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(getCrmStakeholderReviewResponseChangeFieldsRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(getCrmStakeholderReviewResponseChangeFieldsStanceMax).nullish(),
  "relationshipLabel": zod.string().max(getCrmStakeholderReviewResponseChangeFieldsRelationshipLabelMax).nullish(),
  "notes": zod.string().max(getCrmStakeholderReviewResponseChangeFieldsNotesMax).optional(),
  "reviewOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(getCrmStakeholderReviewResponseChangeReasonMin).max(getCrmStakeholderReviewResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(getCrmStakeholderReviewResponseBeforeOneOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(getCrmStakeholderReviewResponseBeforeOneOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(getCrmStakeholderReviewResponseBeforeOneOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(getCrmStakeholderReviewResponseBeforeOneOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()]),
  "after": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(getCrmStakeholderReviewResponseAfterRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(getCrmStakeholderReviewResponseAfterStanceMax).nullish(),
  "relationshipLabel": zod.string().max(getCrmStakeholderReviewResponseAfterRelationshipLabelMax).nullish(),
  "notes": zod.string().max(getCrmStakeholderReviewResponseAfterNotesMax).optional(),
  "reviewOn": zod.iso.date().nullish()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(getCrmStakeholderReviewResponseReceiptOneOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(getCrmStakeholderReviewResponseReceiptOneOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(getCrmStakeholderReviewResponseReceiptOneOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(getCrmStakeholderReviewResponseReceiptOneOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()])
})


/**
 * @summary confirmCrmStakeholder
 */
export const confirmCrmStakeholderParams = zod.object({
  "id": zod.uuid()
})

export const confirmCrmStakeholderBodyHashMin = 64;
export const confirmCrmStakeholderBodyHashMax = 64;



export const confirmCrmStakeholderBody = zod.object({
  "hash": zod.string().min(confirmCrmStakeholderBodyHashMin).max(confirmCrmStakeholderBodyHashMax),
  "confirmed": zod.literal(true)
})


export const confirmCrmStakeholderResponseChangeFieldsRoleMax = 120;

export const confirmCrmStakeholderResponseChangeFieldsStanceMax = 120;

export const confirmCrmStakeholderResponseChangeFieldsRelationshipLabelMax = 120;

export const confirmCrmStakeholderResponseChangeFieldsNotesMax = 10000;

export const confirmCrmStakeholderResponseChangeReasonMin = 3;
export const confirmCrmStakeholderResponseChangeReasonMax = 500;

export const confirmCrmStakeholderResponseBeforeOneOneRoleMax = 120;

export const confirmCrmStakeholderResponseBeforeOneOneStanceMax = 120;

export const confirmCrmStakeholderResponseBeforeOneOneRelationshipLabelMax = 120;

export const confirmCrmStakeholderResponseBeforeOneOneNotesMax = 10000;


export const confirmCrmStakeholderResponseAfterRoleMax = 120;

export const confirmCrmStakeholderResponseAfterStanceMax = 120;

export const confirmCrmStakeholderResponseAfterRelationshipLabelMax = 120;

export const confirmCrmStakeholderResponseAfterNotesMax = 10000;

export const confirmCrmStakeholderResponseReceiptOneOneRoleMax = 120;

export const confirmCrmStakeholderResponseReceiptOneOneStanceMax = 120;

export const confirmCrmStakeholderResponseReceiptOneOneRelationshipLabelMax = 120;

export const confirmCrmStakeholderResponseReceiptOneOneNotesMax = 10000;




export const confirmCrmStakeholderResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'remove']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(confirmCrmStakeholderResponseChangeFieldsRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(confirmCrmStakeholderResponseChangeFieldsStanceMax).nullish(),
  "relationshipLabel": zod.string().max(confirmCrmStakeholderResponseChangeFieldsRelationshipLabelMax).nullish(),
  "notes": zod.string().max(confirmCrmStakeholderResponseChangeFieldsNotesMax).optional(),
  "reviewOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(confirmCrmStakeholderResponseChangeReasonMin).max(confirmCrmStakeholderResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(confirmCrmStakeholderResponseBeforeOneOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(confirmCrmStakeholderResponseBeforeOneOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(confirmCrmStakeholderResponseBeforeOneOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(confirmCrmStakeholderResponseBeforeOneOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()]),
  "after": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(confirmCrmStakeholderResponseAfterRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(confirmCrmStakeholderResponseAfterStanceMax).nullish(),
  "relationshipLabel": zod.string().max(confirmCrmStakeholderResponseAfterRelationshipLabelMax).nullish(),
  "notes": zod.string().max(confirmCrmStakeholderResponseAfterNotesMax).optional(),
  "reviewOn": zod.iso.date().nullish()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(confirmCrmStakeholderResponseReceiptOneOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(confirmCrmStakeholderResponseReceiptOneOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(confirmCrmStakeholderResponseReceiptOneOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(confirmCrmStakeholderResponseReceiptOneOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()])
})


/**
 * @summary cancelCrmStakeholderReview
 */
export const cancelCrmStakeholderReviewParams = zod.object({
  "id": zod.uuid()
})


export const cancelCrmStakeholderReviewResponseChangeFieldsRoleMax = 120;

export const cancelCrmStakeholderReviewResponseChangeFieldsStanceMax = 120;

export const cancelCrmStakeholderReviewResponseChangeFieldsRelationshipLabelMax = 120;

export const cancelCrmStakeholderReviewResponseChangeFieldsNotesMax = 10000;

export const cancelCrmStakeholderReviewResponseChangeReasonMin = 3;
export const cancelCrmStakeholderReviewResponseChangeReasonMax = 500;

export const cancelCrmStakeholderReviewResponseBeforeOneOneRoleMax = 120;

export const cancelCrmStakeholderReviewResponseBeforeOneOneStanceMax = 120;

export const cancelCrmStakeholderReviewResponseBeforeOneOneRelationshipLabelMax = 120;

export const cancelCrmStakeholderReviewResponseBeforeOneOneNotesMax = 10000;


export const cancelCrmStakeholderReviewResponseAfterRoleMax = 120;

export const cancelCrmStakeholderReviewResponseAfterStanceMax = 120;

export const cancelCrmStakeholderReviewResponseAfterRelationshipLabelMax = 120;

export const cancelCrmStakeholderReviewResponseAfterNotesMax = 10000;

export const cancelCrmStakeholderReviewResponseReceiptOneOneRoleMax = 120;

export const cancelCrmStakeholderReviewResponseReceiptOneOneStanceMax = 120;

export const cancelCrmStakeholderReviewResponseReceiptOneOneRelationshipLabelMax = 120;

export const cancelCrmStakeholderReviewResponseReceiptOneOneNotesMax = 10000;




export const cancelCrmStakeholderReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'remove']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(cancelCrmStakeholderReviewResponseChangeFieldsRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(cancelCrmStakeholderReviewResponseChangeFieldsStanceMax).nullish(),
  "relationshipLabel": zod.string().max(cancelCrmStakeholderReviewResponseChangeFieldsRelationshipLabelMax).nullish(),
  "notes": zod.string().max(cancelCrmStakeholderReviewResponseChangeFieldsNotesMax).optional(),
  "reviewOn": zod.iso.date().nullish()
}).optional(),
  "reason": zod.string().min(cancelCrmStakeholderReviewResponseChangeReasonMin).max(cancelCrmStakeholderReviewResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(cancelCrmStakeholderReviewResponseBeforeOneOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(cancelCrmStakeholderReviewResponseBeforeOneOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(cancelCrmStakeholderReviewResponseBeforeOneOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(cancelCrmStakeholderReviewResponseBeforeOneOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()]),
  "after": zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(cancelCrmStakeholderReviewResponseAfterRoleMax).optional(),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(cancelCrmStakeholderReviewResponseAfterStanceMax).nullish(),
  "relationshipLabel": zod.string().max(cancelCrmStakeholderReviewResponseAfterRelationshipLabelMax).nullish(),
  "notes": zod.string().max(cancelCrmStakeholderReviewResponseAfterNotesMax).optional(),
  "reviewOn": zod.iso.date().nullish()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "contextAccountId": zod.uuid().nullish(),
  "contextOpportunityId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "relatedAccountId": zod.uuid().nullish(),
  "relatedContactId": zod.uuid().nullish(),
  "role": zod.string().min(1).max(cancelCrmStakeholderReviewResponseReceiptOneOneRoleMax),
  "influence": zod.enum(['low', 'medium', 'high']).nullish(),
  "stance": zod.string().max(cancelCrmStakeholderReviewResponseReceiptOneOneStanceMax).nullish(),
  "relationshipLabel": zod.string().max(cancelCrmStakeholderReviewResponseReceiptOneOneRelationshipLabelMax).nullish(),
  "notes": zod.string().max(cancelCrmStakeholderReviewResponseReceiptOneOneNotesMax),
  "reviewOn": zod.iso.date().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "removed": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()])
})


/**
 * @summary listCrmReferrals
 */
export const listCrmReferralsQueryLimitDefault = 25;
export const listCrmReferralsQueryLimitMax = 100;

export const listCrmReferralsQueryOffsetDefault = 0;
export const listCrmReferralsQueryOffsetMin = 0;

export const listCrmReferralsQuerySearchMax = 200;

export const listCrmReferralsQueryOutcomeMax = 120;



export const listCrmReferralsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listCrmReferralsQueryLimitMax).default(listCrmReferralsQueryLimitDefault),
  "offset": zod.int().min(listCrmReferralsQueryOffsetMin).default(listCrmReferralsQueryOffsetDefault),
  "search": zod.string().max(listCrmReferralsQuerySearchMax).optional(),
  "outcome": zod.string().max(listCrmReferralsQueryOutcomeMax).optional(),
  "ownerId": zod.uuid().optional(),
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().optional(),
  "enquiryId": zod.uuid().optional(),
  "opportunityId": zod.uuid().optional(),
  "from": zod.iso.date().optional(),
  "to": zod.iso.date().optional()
})

export const listCrmReferralsResponseItemsItemOnePartyTextMax = 500;

export const listCrmReferralsResponseItemsItemOneNotesMax = 10000;

export const listCrmReferralsResponseItemsItemOneOutcomeMax = 120;


export const listCrmReferralsResponseTotalMin = 0;



export const listCrmReferralsResponse = zod.object({
  "items": zod.array(zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(listCrmReferralsResponseItemsItemOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(listCrmReferralsResponseItemsItemOneNotesMax),
  "outcome": zod.string().min(1).max(listCrmReferralsResponseItemsItemOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}))),
  "total": zod.int().min(listCrmReferralsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary getCrmReferral
 */
export const getCrmReferralParams = zod.object({
  "id": zod.uuid()
})

export const getCrmReferralResponseOnePartyTextMax = 500;

export const getCrmReferralResponseOneNotesMax = 10000;

export const getCrmReferralResponseOneOutcomeMax = 120;




export const getCrmReferralResponse = zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(getCrmReferralResponseOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(getCrmReferralResponseOneNotesMax),
  "outcome": zod.string().min(1).max(getCrmReferralResponseOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}))


/**
 * @summary listCrmReferralHistory
 */
export const listCrmReferralHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listCrmReferralHistoryQueryLimitDefault = 25;
export const listCrmReferralHistoryQueryLimitMax = 100;

export const listCrmReferralHistoryQueryOffsetDefault = 0;
export const listCrmReferralHistoryQueryOffsetMin = 0;



export const listCrmReferralHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listCrmReferralHistoryQueryLimitMax).default(listCrmReferralHistoryQueryLimitDefault),
  "offset": zod.int().min(listCrmReferralHistoryQueryOffsetMin).default(listCrmReferralHistoryQueryOffsetDefault)
})

export const listCrmReferralHistoryResponseItemsItemSnapshotOnePartyTextMax = 500;

export const listCrmReferralHistoryResponseItemsItemSnapshotOneNotesMax = 10000;

export const listCrmReferralHistoryResponseItemsItemSnapshotOneOutcomeMax = 120;




export const listCrmReferralHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "operation": zod.string(),
  "reason": zod.string(),
  "snapshot": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(listCrmReferralHistoryResponseItemsItemSnapshotOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(listCrmReferralHistoryResponseItemsItemSnapshotOneNotesMax),
  "outcome": zod.string().min(1).max(listCrmReferralHistoryResponseItemsItemSnapshotOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),
  "actorId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary listCrmReferralChoices
 */
export const listCrmReferralChoicesQueryLimitDefault = 25;
export const listCrmReferralChoicesQueryLimitMax = 100;

export const listCrmReferralChoicesQueryOffsetDefault = 0;
export const listCrmReferralChoicesQueryOffsetMin = 0;

export const listCrmReferralChoicesQuerySearchMax = 200;



export const listCrmReferralChoicesQueryParams = zod.object({
  "kind": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "limit": zod.int().min(1).max(listCrmReferralChoicesQueryLimitMax).default(listCrmReferralChoicesQueryLimitDefault),
  "offset": zod.int().min(listCrmReferralChoicesQueryOffsetMin).default(listCrmReferralChoicesQueryOffsetDefault),
  "search": zod.string().max(listCrmReferralChoicesQuerySearchMax).optional()
})

export const listCrmReferralChoicesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary reviewCrmReferral
 */

export const reviewCrmReferralBodyChangeFieldsPartyTextMax = 500;

export const reviewCrmReferralBodyChangeFieldsNotesMax = 10000;

export const reviewCrmReferralBodyChangeFieldsOutcomeMax = 120;

export const reviewCrmReferralBodyChangeAccountNameMax = 200;

export const reviewCrmReferralBodyChangeReasonMin = 3;
export const reviewCrmReferralBodyChangeReasonMax = 500;



export const reviewCrmReferralBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'create_target_account']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(reviewCrmReferralBodyChangeFieldsPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(reviewCrmReferralBodyChangeFieldsNotesMax).optional(),
  "outcome": zod.string().min(1).max(reviewCrmReferralBodyChangeFieldsOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional(),
  "account": zod.object({
  "name": zod.string().min(1).max(reviewCrmReferralBodyChangeAccountNameMax),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "accountKind": zod.enum(['organization', 'person'])
}).optional(),
  "reason": zod.string().min(reviewCrmReferralBodyChangeReasonMin).max(reviewCrmReferralBodyChangeReasonMax)
})
})


export const reviewCrmReferralResponseChangeFieldsPartyTextMax = 500;

export const reviewCrmReferralResponseChangeFieldsNotesMax = 10000;

export const reviewCrmReferralResponseChangeFieldsOutcomeMax = 120;

export const reviewCrmReferralResponseChangeAccountNameMax = 200;

export const reviewCrmReferralResponseChangeReasonMin = 3;
export const reviewCrmReferralResponseChangeReasonMax = 500;

export const reviewCrmReferralResponseBeforeOneOnePartyTextMax = 500;

export const reviewCrmReferralResponseBeforeOneOneNotesMax = 10000;

export const reviewCrmReferralResponseBeforeOneOneOutcomeMax = 120;


export const reviewCrmReferralResponseAfterPartyTextMax = 500;

export const reviewCrmReferralResponseAfterNotesMax = 10000;

export const reviewCrmReferralResponseAfterOutcomeMax = 120;

export const reviewCrmReferralResponseReceiptOneOnePartyTextMax = 500;

export const reviewCrmReferralResponseReceiptOneOneNotesMax = 10000;

export const reviewCrmReferralResponseReceiptOneOneOutcomeMax = 120;




export const reviewCrmReferralResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'create_target_account']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(reviewCrmReferralResponseChangeFieldsPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(reviewCrmReferralResponseChangeFieldsNotesMax).optional(),
  "outcome": zod.string().min(1).max(reviewCrmReferralResponseChangeFieldsOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional(),
  "account": zod.object({
  "name": zod.string().min(1).max(reviewCrmReferralResponseChangeAccountNameMax),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "accountKind": zod.enum(['organization', 'person'])
}).optional(),
  "reason": zod.string().min(reviewCrmReferralResponseChangeReasonMin).max(reviewCrmReferralResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(reviewCrmReferralResponseBeforeOneOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(reviewCrmReferralResponseBeforeOneOneNotesMax),
  "outcome": zod.string().min(1).max(reviewCrmReferralResponseBeforeOneOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()]),
  "after": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(reviewCrmReferralResponseAfterPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(reviewCrmReferralResponseAfterNotesMax).optional(),
  "outcome": zod.string().min(1).max(reviewCrmReferralResponseAfterOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(reviewCrmReferralResponseReceiptOneOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(reviewCrmReferralResponseReceiptOneOneNotesMax),
  "outcome": zod.string().min(1).max(reviewCrmReferralResponseReceiptOneOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()])
})


/**
 * @summary getCrmReferralReview
 */
export const getCrmReferralReviewParams = zod.object({
  "id": zod.uuid()
})


export const getCrmReferralReviewResponseChangeFieldsPartyTextMax = 500;

export const getCrmReferralReviewResponseChangeFieldsNotesMax = 10000;

export const getCrmReferralReviewResponseChangeFieldsOutcomeMax = 120;

export const getCrmReferralReviewResponseChangeAccountNameMax = 200;

export const getCrmReferralReviewResponseChangeReasonMin = 3;
export const getCrmReferralReviewResponseChangeReasonMax = 500;

export const getCrmReferralReviewResponseBeforeOneOnePartyTextMax = 500;

export const getCrmReferralReviewResponseBeforeOneOneNotesMax = 10000;

export const getCrmReferralReviewResponseBeforeOneOneOutcomeMax = 120;


export const getCrmReferralReviewResponseAfterPartyTextMax = 500;

export const getCrmReferralReviewResponseAfterNotesMax = 10000;

export const getCrmReferralReviewResponseAfterOutcomeMax = 120;

export const getCrmReferralReviewResponseReceiptOneOnePartyTextMax = 500;

export const getCrmReferralReviewResponseReceiptOneOneNotesMax = 10000;

export const getCrmReferralReviewResponseReceiptOneOneOutcomeMax = 120;




export const getCrmReferralReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'create_target_account']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(getCrmReferralReviewResponseChangeFieldsPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(getCrmReferralReviewResponseChangeFieldsNotesMax).optional(),
  "outcome": zod.string().min(1).max(getCrmReferralReviewResponseChangeFieldsOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional(),
  "account": zod.object({
  "name": zod.string().min(1).max(getCrmReferralReviewResponseChangeAccountNameMax),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "accountKind": zod.enum(['organization', 'person'])
}).optional(),
  "reason": zod.string().min(getCrmReferralReviewResponseChangeReasonMin).max(getCrmReferralReviewResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(getCrmReferralReviewResponseBeforeOneOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(getCrmReferralReviewResponseBeforeOneOneNotesMax),
  "outcome": zod.string().min(1).max(getCrmReferralReviewResponseBeforeOneOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()]),
  "after": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(getCrmReferralReviewResponseAfterPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(getCrmReferralReviewResponseAfterNotesMax).optional(),
  "outcome": zod.string().min(1).max(getCrmReferralReviewResponseAfterOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(getCrmReferralReviewResponseReceiptOneOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(getCrmReferralReviewResponseReceiptOneOneNotesMax),
  "outcome": zod.string().min(1).max(getCrmReferralReviewResponseReceiptOneOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()])
})


/**
 * @summary confirmCrmReferral
 */
export const confirmCrmReferralParams = zod.object({
  "id": zod.uuid()
})

export const confirmCrmReferralBodyHashMin = 64;
export const confirmCrmReferralBodyHashMax = 64;



export const confirmCrmReferralBody = zod.object({
  "hash": zod.string().min(confirmCrmReferralBodyHashMin).max(confirmCrmReferralBodyHashMax),
  "confirmed": zod.literal(true)
})


export const confirmCrmReferralResponseChangeFieldsPartyTextMax = 500;

export const confirmCrmReferralResponseChangeFieldsNotesMax = 10000;

export const confirmCrmReferralResponseChangeFieldsOutcomeMax = 120;

export const confirmCrmReferralResponseChangeAccountNameMax = 200;

export const confirmCrmReferralResponseChangeReasonMin = 3;
export const confirmCrmReferralResponseChangeReasonMax = 500;

export const confirmCrmReferralResponseBeforeOneOnePartyTextMax = 500;

export const confirmCrmReferralResponseBeforeOneOneNotesMax = 10000;

export const confirmCrmReferralResponseBeforeOneOneOutcomeMax = 120;


export const confirmCrmReferralResponseAfterPartyTextMax = 500;

export const confirmCrmReferralResponseAfterNotesMax = 10000;

export const confirmCrmReferralResponseAfterOutcomeMax = 120;

export const confirmCrmReferralResponseReceiptOneOnePartyTextMax = 500;

export const confirmCrmReferralResponseReceiptOneOneNotesMax = 10000;

export const confirmCrmReferralResponseReceiptOneOneOutcomeMax = 120;




export const confirmCrmReferralResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'create_target_account']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(confirmCrmReferralResponseChangeFieldsPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(confirmCrmReferralResponseChangeFieldsNotesMax).optional(),
  "outcome": zod.string().min(1).max(confirmCrmReferralResponseChangeFieldsOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional(),
  "account": zod.object({
  "name": zod.string().min(1).max(confirmCrmReferralResponseChangeAccountNameMax),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "accountKind": zod.enum(['organization', 'person'])
}).optional(),
  "reason": zod.string().min(confirmCrmReferralResponseChangeReasonMin).max(confirmCrmReferralResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(confirmCrmReferralResponseBeforeOneOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(confirmCrmReferralResponseBeforeOneOneNotesMax),
  "outcome": zod.string().min(1).max(confirmCrmReferralResponseBeforeOneOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()]),
  "after": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(confirmCrmReferralResponseAfterPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(confirmCrmReferralResponseAfterNotesMax).optional(),
  "outcome": zod.string().min(1).max(confirmCrmReferralResponseAfterOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(confirmCrmReferralResponseReceiptOneOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(confirmCrmReferralResponseReceiptOneOneNotesMax),
  "outcome": zod.string().min(1).max(confirmCrmReferralResponseReceiptOneOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()])
})


/**
 * @summary cancelCrmReferralReview
 */
export const cancelCrmReferralReviewParams = zod.object({
  "id": zod.uuid()
})


export const cancelCrmReferralReviewResponseChangeFieldsPartyTextMax = 500;

export const cancelCrmReferralReviewResponseChangeFieldsNotesMax = 10000;

export const cancelCrmReferralReviewResponseChangeFieldsOutcomeMax = 120;

export const cancelCrmReferralReviewResponseChangeAccountNameMax = 200;

export const cancelCrmReferralReviewResponseChangeReasonMin = 3;
export const cancelCrmReferralReviewResponseChangeReasonMax = 500;

export const cancelCrmReferralReviewResponseBeforeOneOnePartyTextMax = 500;

export const cancelCrmReferralReviewResponseBeforeOneOneNotesMax = 10000;

export const cancelCrmReferralReviewResponseBeforeOneOneOutcomeMax = 120;


export const cancelCrmReferralReviewResponseAfterPartyTextMax = 500;

export const cancelCrmReferralReviewResponseAfterNotesMax = 10000;

export const cancelCrmReferralReviewResponseAfterOutcomeMax = 120;

export const cancelCrmReferralReviewResponseReceiptOneOnePartyTextMax = 500;

export const cancelCrmReferralReviewResponseReceiptOneOneNotesMax = 10000;

export const cancelCrmReferralReviewResponseReceiptOneOneOutcomeMax = 120;




export const cancelCrmReferralReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'create_target_account']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(cancelCrmReferralReviewResponseChangeFieldsPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(cancelCrmReferralReviewResponseChangeFieldsNotesMax).optional(),
  "outcome": zod.string().min(1).max(cancelCrmReferralReviewResponseChangeFieldsOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).optional(),
  "account": zod.object({
  "name": zod.string().min(1).max(cancelCrmReferralReviewResponseChangeAccountNameMax),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "accountKind": zod.enum(['organization', 'person'])
}).optional(),
  "reason": zod.string().min(cancelCrmReferralReviewResponseChangeReasonMin).max(cancelCrmReferralReviewResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(cancelCrmReferralReviewResponseBeforeOneOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(cancelCrmReferralReviewResponseBeforeOneOneNotesMax),
  "outcome": zod.string().min(1).max(cancelCrmReferralReviewResponseBeforeOneOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()]),
  "after": zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(cancelCrmReferralReviewResponseAfterPartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date().optional(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(cancelCrmReferralReviewResponseAfterNotesMax).optional(),
  "outcome": zod.string().min(1).max(cancelCrmReferralReviewResponseAfterOutcomeMax).optional(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "sourceAccountId": zod.uuid().nullish(),
  "sourceContactId": zod.uuid().nullish(),
  "partyText": zod.string().max(cancelCrmReferralReviewResponseReceiptOneOnePartyTextMax).nullish(),
  "targetAccountId": zod.uuid().nullish(),
  "targetContactId": zod.uuid().nullish(),
  "referredOn": zod.iso.date(),
  "ownerId": zod.uuid().nullish(),
  "notes": zod.string().max(cancelCrmReferralReviewResponseReceiptOneOneNotesMax),
  "outcome": zod.string().min(1).max(cancelCrmReferralReviewResponseReceiptOneOneOutcomeMax),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),zod.null()])
})


export const listNativeWordProposalsParams = zod.object({
  "entryId": zod.uuid()
})

export const listNativeWordProposalsQueryLimitDefault = 10;
export const listNativeWordProposalsQueryLimitMax = 20;

export const listNativeWordProposalsQueryOffsetDefault = 0;
export const listNativeWordProposalsQueryOffsetMin = 0;
export const listNativeWordProposalsQueryOffsetMax = 20;



export const listNativeWordProposalsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listNativeWordProposalsQueryLimitMax).default(listNativeWordProposalsQueryLimitDefault),
  "offset": zod.int().min(listNativeWordProposalsQueryOffsetMin).max(listNativeWordProposalsQueryOffsetMax).default(listNativeWordProposalsQueryOffsetDefault)
})

export const listNativeWordProposalsResponseItemsItemRequestHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listNativeWordProposalsResponseItemsItemSourceSourceSizeMin = 0;
export const listNativeWordProposalsResponseItemsItemSourceSourceSizeMax = 20971520;

export const listNativeWordProposalsResponseItemsItemSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listNativeWordProposalsResponseItemsItemInstructionMax = 4000;

export const listNativeWordProposalsResponseItemsItemTargetIdsItemMax = 100;

export const listNativeWordProposalsResponseItemsItemTargetIdsMax = 50;

export const listNativeWordProposalsResponseItemsItemPolicyHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listNativeWordProposalsResponseItemsItemModelMax = 200;

export const listNativeWordProposalsResponseItemsItemInstructionVersionMax = 100;

export const listNativeWordProposalsResponseItemsItemPatchOneSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listNativeWordProposalsResponseItemsItemPatchOneOperationsItemTargetIdMax = 100;

export const listNativeWordProposalsResponseItemsItemPatchOneOperationsItemExpectedHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listNativeWordProposalsResponseItemsItemPatchOneOperationsItemExpectedTextMax = 10000;

export const listNativeWordProposalsResponseItemsItemPatchOneOperationsItemReplacementTextMax = 10000;

export const listNativeWordProposalsResponseItemsItemPatchOneOperationsMax = 50;

export const listNativeWordProposalsResponseItemsItemCandidateOneSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listNativeWordProposalsResponseItemsItemCandidateOneCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listNativeWordProposalsResponseItemsItemCandidateOneChangedPartsItemMax = 500;

export const listNativeWordProposalsResponseItemsItemCandidateOneChangedPartsMax = 50;

export const listNativeWordProposalsResponseItemsItemCandidateOnePreservedPartsItemNameMax = 500;

export const listNativeWordProposalsResponseItemsItemCandidateOnePreservedPartsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listNativeWordProposalsResponseItemsItemCandidateOnePreservedPartsMax = 2000;

export const listNativeWordProposalsResponseItemsItemCandidateOneWarningsItemMax = 1000;

export const listNativeWordProposalsResponseItemsItemCandidateOneWarningsMax = 30;

export const listNativeWordProposalsResponseItemsItemCandidateOneChangedTargetsItemMax = 100;

export const listNativeWordProposalsResponseItemsItemCandidateOneChangedTargetsMax = 50;

export const listNativeWordProposalsResponseItemsItemSensitiveTargetsItemIdMax = 100;

export const listNativeWordProposalsResponseItemsItemSensitiveTargetsItemPartMax = 500;

export const listNativeWordProposalsResponseItemsItemSensitiveTargetsItemParagraphMin = 0;

export const listNativeWordProposalsResponseItemsItemSensitiveTargetsItemTextMax = 10000;

export const listNativeWordProposalsResponseItemsItemSensitiveTargetsItemTextHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listNativeWordProposalsResponseItemsItemSensitiveTargetsItemBlockersItemMax = 100;

export const listNativeWordProposalsResponseItemsItemSensitiveTargetsItemBlockersMax = 50;

export const listNativeWordProposalsResponseItemsItemSensitiveTargetsItemSensitiveMax = 2;

export const listNativeWordProposalsResponseItemsItemSensitiveTargetsMax = 50;

export const listNativeWordProposalsResponseItemsItemWarningsItemMax = 1000;

export const listNativeWordProposalsResponseItemsItemWarningsMax = 30;

export const listNativeWordProposalsResponseItemsMax = 20;

export const listNativeWordProposalsResponseTotalMin = 0;



export const listNativeWordProposalsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "requestHash": zod.string().regex(listNativeWordProposalsResponseItemsItemRequestHashRegExp),
  "revision": zod.int().min(1),
  "state": zod.enum(['attempted', 'pending', 'accepted', 'rejected', 'failed', 'uncertain']),
  "source": zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(listNativeWordProposalsResponseItemsItemSourceSourceSizeMin).max(listNativeWordProposalsResponseItemsItemSourceSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(listNativeWordProposalsResponseItemsItemSourceContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
}),
  "instruction": zod.string().min(1).max(listNativeWordProposalsResponseItemsItemInstructionMax),
  "targetIds": zod.array(zod.string().max(listNativeWordProposalsResponseItemsItemTargetIdsItemMax)).min(1).max(listNativeWordProposalsResponseItemsItemTargetIdsMax),
  "policyHash": zod.string().regex(listNativeWordProposalsResponseItemsItemPolicyHashRegExp),
  "model": zod.string().max(listNativeWordProposalsResponseItemsItemModelMax),
  "instructionVersion": zod.string().max(listNativeWordProposalsResponseItemsItemInstructionVersionMax),
  "patch": zod.union([zod.object({
  "sourceHash": zod.string().regex(listNativeWordProposalsResponseItemsItemPatchOneSourceHashRegExp),
  "operations": zod.array(zod.object({
  "targetId": zod.string().max(listNativeWordProposalsResponseItemsItemPatchOneOperationsItemTargetIdMax),
  "expectedHash": zod.string().regex(listNativeWordProposalsResponseItemsItemPatchOneOperationsItemExpectedHashRegExp),
  "expectedText": zod.string().max(listNativeWordProposalsResponseItemsItemPatchOneOperationsItemExpectedTextMax),
  "replacementText": zod.string().max(listNativeWordProposalsResponseItemsItemPatchOneOperationsItemReplacementTextMax)
})).max(listNativeWordProposalsResponseItemsItemPatchOneOperationsMax)
}),zod.null()]),
  "candidate": zod.union([zod.object({
  "sourceHash": zod.string().regex(listNativeWordProposalsResponseItemsItemCandidateOneSourceHashRegExp),
  "candidateHash": zod.string().regex(listNativeWordProposalsResponseItemsItemCandidateOneCandidateHashRegExp),
  "changedParts": zod.array(zod.string().max(listNativeWordProposalsResponseItemsItemCandidateOneChangedPartsItemMax)).max(listNativeWordProposalsResponseItemsItemCandidateOneChangedPartsMax),
  "preservedParts": zod.array(zod.object({
  "name": zod.string().max(listNativeWordProposalsResponseItemsItemCandidateOnePreservedPartsItemNameMax),
  "hash": zod.string().regex(listNativeWordProposalsResponseItemsItemCandidateOnePreservedPartsItemHashRegExp)
})).max(listNativeWordProposalsResponseItemsItemCandidateOnePreservedPartsMax),
  "warnings": zod.array(zod.string().max(listNativeWordProposalsResponseItemsItemCandidateOneWarningsItemMax)).max(listNativeWordProposalsResponseItemsItemCandidateOneWarningsMax),
  "changedTargets": zod.array(zod.string().max(listNativeWordProposalsResponseItemsItemCandidateOneChangedTargetsItemMax)).max(listNativeWordProposalsResponseItemsItemCandidateOneChangedTargetsMax)
}),zod.null()]),
  "sensitiveTargets": zod.array(zod.object({
  "id": zod.string().max(listNativeWordProposalsResponseItemsItemSensitiveTargetsItemIdMax),
  "part": zod.string().max(listNativeWordProposalsResponseItemsItemSensitiveTargetsItemPartMax),
  "paragraph": zod.int().min(listNativeWordProposalsResponseItemsItemSensitiveTargetsItemParagraphMin),
  "text": zod.string().max(listNativeWordProposalsResponseItemsItemSensitiveTargetsItemTextMax),
  "textHash": zod.string().regex(listNativeWordProposalsResponseItemsItemSensitiveTargetsItemTextHashRegExp),
  "editable": zod.boolean(),
  "blockers": zod.array(zod.string().max(listNativeWordProposalsResponseItemsItemSensitiveTargetsItemBlockersItemMax)).max(listNativeWordProposalsResponseItemsItemSensitiveTargetsItemBlockersMax),
  "inTable": zod.boolean(),
  "sensitive": zod.array(zod.enum(['legal', 'commercial'])).max(listNativeWordProposalsResponseItemsItemSensitiveTargetsItemSensitiveMax)
})).max(listNativeWordProposalsResponseItemsItemSensitiveTargetsMax),
  "warnings": zod.array(zod.string().max(listNativeWordProposalsResponseItemsItemWarningsItemMax)).max(listNativeWordProposalsResponseItemsItemWarningsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewAcknowledged": zod.boolean(),
  "approvalState": zod.enum(['review_only'])
})).max(listNativeWordProposalsResponseItemsMax),
  "total": zod.int().min(listNativeWordProposalsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createNativeWordProposalParams = zod.object({
  "entryId": zod.uuid()
})

export const createNativeWordProposalBodySourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createNativeWordProposalBodyInstructionMax = 4000;

export const createNativeWordProposalBodyTargetIdsItemMax = 100;

export const createNativeWordProposalBodyTargetIdsMax = 50;



export const createNativeWordProposalBody = zod.object({
  "clientRequestId": zod.uuid(),
  "sourceHash": zod.string().regex(createNativeWordProposalBodySourceHashRegExp),
  "instruction": zod.string().min(1).max(createNativeWordProposalBodyInstructionMax),
  "targetIds": zod.array(zod.string().max(createNativeWordProposalBodyTargetIdsItemMax)).min(1).max(createNativeWordProposalBodyTargetIdsMax)
})

export const createNativeWordProposalResponseRequestHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const createNativeWordProposalResponseSourceSourceSizeMin = 0;
export const createNativeWordProposalResponseSourceSourceSizeMax = 20971520;

export const createNativeWordProposalResponseSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createNativeWordProposalResponseInstructionMax = 4000;

export const createNativeWordProposalResponseTargetIdsItemMax = 100;

export const createNativeWordProposalResponseTargetIdsMax = 50;

export const createNativeWordProposalResponsePolicyHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createNativeWordProposalResponseModelMax = 200;

export const createNativeWordProposalResponseInstructionVersionMax = 100;

export const createNativeWordProposalResponsePatchOneSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createNativeWordProposalResponsePatchOneOperationsItemTargetIdMax = 100;

export const createNativeWordProposalResponsePatchOneOperationsItemExpectedHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createNativeWordProposalResponsePatchOneOperationsItemExpectedTextMax = 10000;

export const createNativeWordProposalResponsePatchOneOperationsItemReplacementTextMax = 10000;

export const createNativeWordProposalResponsePatchOneOperationsMax = 50;

export const createNativeWordProposalResponseCandidateOneSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createNativeWordProposalResponseCandidateOneCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createNativeWordProposalResponseCandidateOneChangedPartsItemMax = 500;

export const createNativeWordProposalResponseCandidateOneChangedPartsMax = 50;

export const createNativeWordProposalResponseCandidateOnePreservedPartsItemNameMax = 500;

export const createNativeWordProposalResponseCandidateOnePreservedPartsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createNativeWordProposalResponseCandidateOnePreservedPartsMax = 2000;

export const createNativeWordProposalResponseCandidateOneWarningsItemMax = 1000;

export const createNativeWordProposalResponseCandidateOneWarningsMax = 30;

export const createNativeWordProposalResponseCandidateOneChangedTargetsItemMax = 100;

export const createNativeWordProposalResponseCandidateOneChangedTargetsMax = 50;

export const createNativeWordProposalResponseSensitiveTargetsItemIdMax = 100;

export const createNativeWordProposalResponseSensitiveTargetsItemPartMax = 500;

export const createNativeWordProposalResponseSensitiveTargetsItemParagraphMin = 0;

export const createNativeWordProposalResponseSensitiveTargetsItemTextMax = 10000;

export const createNativeWordProposalResponseSensitiveTargetsItemTextHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createNativeWordProposalResponseSensitiveTargetsItemBlockersItemMax = 100;

export const createNativeWordProposalResponseSensitiveTargetsItemBlockersMax = 50;

export const createNativeWordProposalResponseSensitiveTargetsItemSensitiveMax = 2;

export const createNativeWordProposalResponseSensitiveTargetsMax = 50;

export const createNativeWordProposalResponseWarningsItemMax = 1000;

export const createNativeWordProposalResponseWarningsMax = 30;



export const createNativeWordProposalResponse = zod.object({
  "id": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "requestHash": zod.string().regex(createNativeWordProposalResponseRequestHashRegExp),
  "revision": zod.int().min(1),
  "state": zod.enum(['attempted', 'pending', 'accepted', 'rejected', 'failed', 'uncertain']),
  "source": zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(createNativeWordProposalResponseSourceSourceSizeMin).max(createNativeWordProposalResponseSourceSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(createNativeWordProposalResponseSourceContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
}),
  "instruction": zod.string().min(1).max(createNativeWordProposalResponseInstructionMax),
  "targetIds": zod.array(zod.string().max(createNativeWordProposalResponseTargetIdsItemMax)).min(1).max(createNativeWordProposalResponseTargetIdsMax),
  "policyHash": zod.string().regex(createNativeWordProposalResponsePolicyHashRegExp),
  "model": zod.string().max(createNativeWordProposalResponseModelMax),
  "instructionVersion": zod.string().max(createNativeWordProposalResponseInstructionVersionMax),
  "patch": zod.union([zod.object({
  "sourceHash": zod.string().regex(createNativeWordProposalResponsePatchOneSourceHashRegExp),
  "operations": zod.array(zod.object({
  "targetId": zod.string().max(createNativeWordProposalResponsePatchOneOperationsItemTargetIdMax),
  "expectedHash": zod.string().regex(createNativeWordProposalResponsePatchOneOperationsItemExpectedHashRegExp),
  "expectedText": zod.string().max(createNativeWordProposalResponsePatchOneOperationsItemExpectedTextMax),
  "replacementText": zod.string().max(createNativeWordProposalResponsePatchOneOperationsItemReplacementTextMax)
})).max(createNativeWordProposalResponsePatchOneOperationsMax)
}),zod.null()]),
  "candidate": zod.union([zod.object({
  "sourceHash": zod.string().regex(createNativeWordProposalResponseCandidateOneSourceHashRegExp),
  "candidateHash": zod.string().regex(createNativeWordProposalResponseCandidateOneCandidateHashRegExp),
  "changedParts": zod.array(zod.string().max(createNativeWordProposalResponseCandidateOneChangedPartsItemMax)).max(createNativeWordProposalResponseCandidateOneChangedPartsMax),
  "preservedParts": zod.array(zod.object({
  "name": zod.string().max(createNativeWordProposalResponseCandidateOnePreservedPartsItemNameMax),
  "hash": zod.string().regex(createNativeWordProposalResponseCandidateOnePreservedPartsItemHashRegExp)
})).max(createNativeWordProposalResponseCandidateOnePreservedPartsMax),
  "warnings": zod.array(zod.string().max(createNativeWordProposalResponseCandidateOneWarningsItemMax)).max(createNativeWordProposalResponseCandidateOneWarningsMax),
  "changedTargets": zod.array(zod.string().max(createNativeWordProposalResponseCandidateOneChangedTargetsItemMax)).max(createNativeWordProposalResponseCandidateOneChangedTargetsMax)
}),zod.null()]),
  "sensitiveTargets": zod.array(zod.object({
  "id": zod.string().max(createNativeWordProposalResponseSensitiveTargetsItemIdMax),
  "part": zod.string().max(createNativeWordProposalResponseSensitiveTargetsItemPartMax),
  "paragraph": zod.int().min(createNativeWordProposalResponseSensitiveTargetsItemParagraphMin),
  "text": zod.string().max(createNativeWordProposalResponseSensitiveTargetsItemTextMax),
  "textHash": zod.string().regex(createNativeWordProposalResponseSensitiveTargetsItemTextHashRegExp),
  "editable": zod.boolean(),
  "blockers": zod.array(zod.string().max(createNativeWordProposalResponseSensitiveTargetsItemBlockersItemMax)).max(createNativeWordProposalResponseSensitiveTargetsItemBlockersMax),
  "inTable": zod.boolean(),
  "sensitive": zod.array(zod.enum(['legal', 'commercial'])).max(createNativeWordProposalResponseSensitiveTargetsItemSensitiveMax)
})).max(createNativeWordProposalResponseSensitiveTargetsMax),
  "warnings": zod.array(zod.string().max(createNativeWordProposalResponseWarningsItemMax)).max(createNativeWordProposalResponseWarningsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewAcknowledged": zod.boolean(),
  "approvalState": zod.enum(['review_only'])
})


export const getNativeWordProposalParams = zod.object({
  "entryId": zod.uuid(),
  "proposalId": zod.uuid()
})

export const getNativeWordProposalResponseRequestHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const getNativeWordProposalResponseSourceSourceSizeMin = 0;
export const getNativeWordProposalResponseSourceSourceSizeMax = 20971520;

export const getNativeWordProposalResponseSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getNativeWordProposalResponseInstructionMax = 4000;

export const getNativeWordProposalResponseTargetIdsItemMax = 100;

export const getNativeWordProposalResponseTargetIdsMax = 50;

export const getNativeWordProposalResponsePolicyHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getNativeWordProposalResponseModelMax = 200;

export const getNativeWordProposalResponseInstructionVersionMax = 100;

export const getNativeWordProposalResponsePatchOneSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getNativeWordProposalResponsePatchOneOperationsItemTargetIdMax = 100;

export const getNativeWordProposalResponsePatchOneOperationsItemExpectedHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getNativeWordProposalResponsePatchOneOperationsItemExpectedTextMax = 10000;

export const getNativeWordProposalResponsePatchOneOperationsItemReplacementTextMax = 10000;

export const getNativeWordProposalResponsePatchOneOperationsMax = 50;

export const getNativeWordProposalResponseCandidateOneSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getNativeWordProposalResponseCandidateOneCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getNativeWordProposalResponseCandidateOneChangedPartsItemMax = 500;

export const getNativeWordProposalResponseCandidateOneChangedPartsMax = 50;

export const getNativeWordProposalResponseCandidateOnePreservedPartsItemNameMax = 500;

export const getNativeWordProposalResponseCandidateOnePreservedPartsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getNativeWordProposalResponseCandidateOnePreservedPartsMax = 2000;

export const getNativeWordProposalResponseCandidateOneWarningsItemMax = 1000;

export const getNativeWordProposalResponseCandidateOneWarningsMax = 30;

export const getNativeWordProposalResponseCandidateOneChangedTargetsItemMax = 100;

export const getNativeWordProposalResponseCandidateOneChangedTargetsMax = 50;

export const getNativeWordProposalResponseSensitiveTargetsItemIdMax = 100;

export const getNativeWordProposalResponseSensitiveTargetsItemPartMax = 500;

export const getNativeWordProposalResponseSensitiveTargetsItemParagraphMin = 0;

export const getNativeWordProposalResponseSensitiveTargetsItemTextMax = 10000;

export const getNativeWordProposalResponseSensitiveTargetsItemTextHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getNativeWordProposalResponseSensitiveTargetsItemBlockersItemMax = 100;

export const getNativeWordProposalResponseSensitiveTargetsItemBlockersMax = 50;

export const getNativeWordProposalResponseSensitiveTargetsItemSensitiveMax = 2;

export const getNativeWordProposalResponseSensitiveTargetsMax = 50;

export const getNativeWordProposalResponseWarningsItemMax = 1000;

export const getNativeWordProposalResponseWarningsMax = 30;



export const getNativeWordProposalResponse = zod.object({
  "id": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "requestHash": zod.string().regex(getNativeWordProposalResponseRequestHashRegExp),
  "revision": zod.int().min(1),
  "state": zod.enum(['attempted', 'pending', 'accepted', 'rejected', 'failed', 'uncertain']),
  "source": zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(getNativeWordProposalResponseSourceSourceSizeMin).max(getNativeWordProposalResponseSourceSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(getNativeWordProposalResponseSourceContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
}),
  "instruction": zod.string().min(1).max(getNativeWordProposalResponseInstructionMax),
  "targetIds": zod.array(zod.string().max(getNativeWordProposalResponseTargetIdsItemMax)).min(1).max(getNativeWordProposalResponseTargetIdsMax),
  "policyHash": zod.string().regex(getNativeWordProposalResponsePolicyHashRegExp),
  "model": zod.string().max(getNativeWordProposalResponseModelMax),
  "instructionVersion": zod.string().max(getNativeWordProposalResponseInstructionVersionMax),
  "patch": zod.union([zod.object({
  "sourceHash": zod.string().regex(getNativeWordProposalResponsePatchOneSourceHashRegExp),
  "operations": zod.array(zod.object({
  "targetId": zod.string().max(getNativeWordProposalResponsePatchOneOperationsItemTargetIdMax),
  "expectedHash": zod.string().regex(getNativeWordProposalResponsePatchOneOperationsItemExpectedHashRegExp),
  "expectedText": zod.string().max(getNativeWordProposalResponsePatchOneOperationsItemExpectedTextMax),
  "replacementText": zod.string().max(getNativeWordProposalResponsePatchOneOperationsItemReplacementTextMax)
})).max(getNativeWordProposalResponsePatchOneOperationsMax)
}),zod.null()]),
  "candidate": zod.union([zod.object({
  "sourceHash": zod.string().regex(getNativeWordProposalResponseCandidateOneSourceHashRegExp),
  "candidateHash": zod.string().regex(getNativeWordProposalResponseCandidateOneCandidateHashRegExp),
  "changedParts": zod.array(zod.string().max(getNativeWordProposalResponseCandidateOneChangedPartsItemMax)).max(getNativeWordProposalResponseCandidateOneChangedPartsMax),
  "preservedParts": zod.array(zod.object({
  "name": zod.string().max(getNativeWordProposalResponseCandidateOnePreservedPartsItemNameMax),
  "hash": zod.string().regex(getNativeWordProposalResponseCandidateOnePreservedPartsItemHashRegExp)
})).max(getNativeWordProposalResponseCandidateOnePreservedPartsMax),
  "warnings": zod.array(zod.string().max(getNativeWordProposalResponseCandidateOneWarningsItemMax)).max(getNativeWordProposalResponseCandidateOneWarningsMax),
  "changedTargets": zod.array(zod.string().max(getNativeWordProposalResponseCandidateOneChangedTargetsItemMax)).max(getNativeWordProposalResponseCandidateOneChangedTargetsMax)
}),zod.null()]),
  "sensitiveTargets": zod.array(zod.object({
  "id": zod.string().max(getNativeWordProposalResponseSensitiveTargetsItemIdMax),
  "part": zod.string().max(getNativeWordProposalResponseSensitiveTargetsItemPartMax),
  "paragraph": zod.int().min(getNativeWordProposalResponseSensitiveTargetsItemParagraphMin),
  "text": zod.string().max(getNativeWordProposalResponseSensitiveTargetsItemTextMax),
  "textHash": zod.string().regex(getNativeWordProposalResponseSensitiveTargetsItemTextHashRegExp),
  "editable": zod.boolean(),
  "blockers": zod.array(zod.string().max(getNativeWordProposalResponseSensitiveTargetsItemBlockersItemMax)).max(getNativeWordProposalResponseSensitiveTargetsItemBlockersMax),
  "inTable": zod.boolean(),
  "sensitive": zod.array(zod.enum(['legal', 'commercial'])).max(getNativeWordProposalResponseSensitiveTargetsItemSensitiveMax)
})).max(getNativeWordProposalResponseSensitiveTargetsMax),
  "warnings": zod.array(zod.string().max(getNativeWordProposalResponseWarningsItemMax)).max(getNativeWordProposalResponseWarningsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewAcknowledged": zod.boolean(),
  "approvalState": zod.enum(['review_only'])
})


export const decideNativeWordProposalParams = zod.object({
  "entryId": zod.uuid(),
  "proposalId": zod.uuid()
})


export const decideNativeWordProposalBodyCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const decideNativeWordProposalBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "candidateHash": zod.string().regex(decideNativeWordProposalBodyCandidateHashRegExp).nullable(),
  "decision": zod.enum(['accepted', 'rejected']),
  "acknowledgeReview": zod.boolean()
})

export const decideNativeWordProposalResponseRequestHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const decideNativeWordProposalResponseSourceSourceSizeMin = 0;
export const decideNativeWordProposalResponseSourceSourceSizeMax = 20971520;

export const decideNativeWordProposalResponseSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideNativeWordProposalResponseInstructionMax = 4000;

export const decideNativeWordProposalResponseTargetIdsItemMax = 100;

export const decideNativeWordProposalResponseTargetIdsMax = 50;

export const decideNativeWordProposalResponsePolicyHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideNativeWordProposalResponseModelMax = 200;

export const decideNativeWordProposalResponseInstructionVersionMax = 100;

export const decideNativeWordProposalResponsePatchOneSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideNativeWordProposalResponsePatchOneOperationsItemTargetIdMax = 100;

export const decideNativeWordProposalResponsePatchOneOperationsItemExpectedHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideNativeWordProposalResponsePatchOneOperationsItemExpectedTextMax = 10000;

export const decideNativeWordProposalResponsePatchOneOperationsItemReplacementTextMax = 10000;

export const decideNativeWordProposalResponsePatchOneOperationsMax = 50;

export const decideNativeWordProposalResponseCandidateOneSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideNativeWordProposalResponseCandidateOneCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideNativeWordProposalResponseCandidateOneChangedPartsItemMax = 500;

export const decideNativeWordProposalResponseCandidateOneChangedPartsMax = 50;

export const decideNativeWordProposalResponseCandidateOnePreservedPartsItemNameMax = 500;

export const decideNativeWordProposalResponseCandidateOnePreservedPartsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideNativeWordProposalResponseCandidateOnePreservedPartsMax = 2000;

export const decideNativeWordProposalResponseCandidateOneWarningsItemMax = 1000;

export const decideNativeWordProposalResponseCandidateOneWarningsMax = 30;

export const decideNativeWordProposalResponseCandidateOneChangedTargetsItemMax = 100;

export const decideNativeWordProposalResponseCandidateOneChangedTargetsMax = 50;

export const decideNativeWordProposalResponseSensitiveTargetsItemIdMax = 100;

export const decideNativeWordProposalResponseSensitiveTargetsItemPartMax = 500;

export const decideNativeWordProposalResponseSensitiveTargetsItemParagraphMin = 0;

export const decideNativeWordProposalResponseSensitiveTargetsItemTextMax = 10000;

export const decideNativeWordProposalResponseSensitiveTargetsItemTextHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideNativeWordProposalResponseSensitiveTargetsItemBlockersItemMax = 100;

export const decideNativeWordProposalResponseSensitiveTargetsItemBlockersMax = 50;

export const decideNativeWordProposalResponseSensitiveTargetsItemSensitiveMax = 2;

export const decideNativeWordProposalResponseSensitiveTargetsMax = 50;

export const decideNativeWordProposalResponseWarningsItemMax = 1000;

export const decideNativeWordProposalResponseWarningsMax = 30;



export const decideNativeWordProposalResponse = zod.object({
  "id": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "requestHash": zod.string().regex(decideNativeWordProposalResponseRequestHashRegExp),
  "revision": zod.int().min(1),
  "state": zod.enum(['attempted', 'pending', 'accepted', 'rejected', 'failed', 'uncertain']),
  "source": zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(decideNativeWordProposalResponseSourceSourceSizeMin).max(decideNativeWordProposalResponseSourceSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(decideNativeWordProposalResponseSourceContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
}),
  "instruction": zod.string().min(1).max(decideNativeWordProposalResponseInstructionMax),
  "targetIds": zod.array(zod.string().max(decideNativeWordProposalResponseTargetIdsItemMax)).min(1).max(decideNativeWordProposalResponseTargetIdsMax),
  "policyHash": zod.string().regex(decideNativeWordProposalResponsePolicyHashRegExp),
  "model": zod.string().max(decideNativeWordProposalResponseModelMax),
  "instructionVersion": zod.string().max(decideNativeWordProposalResponseInstructionVersionMax),
  "patch": zod.union([zod.object({
  "sourceHash": zod.string().regex(decideNativeWordProposalResponsePatchOneSourceHashRegExp),
  "operations": zod.array(zod.object({
  "targetId": zod.string().max(decideNativeWordProposalResponsePatchOneOperationsItemTargetIdMax),
  "expectedHash": zod.string().regex(decideNativeWordProposalResponsePatchOneOperationsItemExpectedHashRegExp),
  "expectedText": zod.string().max(decideNativeWordProposalResponsePatchOneOperationsItemExpectedTextMax),
  "replacementText": zod.string().max(decideNativeWordProposalResponsePatchOneOperationsItemReplacementTextMax)
})).max(decideNativeWordProposalResponsePatchOneOperationsMax)
}),zod.null()]),
  "candidate": zod.union([zod.object({
  "sourceHash": zod.string().regex(decideNativeWordProposalResponseCandidateOneSourceHashRegExp),
  "candidateHash": zod.string().regex(decideNativeWordProposalResponseCandidateOneCandidateHashRegExp),
  "changedParts": zod.array(zod.string().max(decideNativeWordProposalResponseCandidateOneChangedPartsItemMax)).max(decideNativeWordProposalResponseCandidateOneChangedPartsMax),
  "preservedParts": zod.array(zod.object({
  "name": zod.string().max(decideNativeWordProposalResponseCandidateOnePreservedPartsItemNameMax),
  "hash": zod.string().regex(decideNativeWordProposalResponseCandidateOnePreservedPartsItemHashRegExp)
})).max(decideNativeWordProposalResponseCandidateOnePreservedPartsMax),
  "warnings": zod.array(zod.string().max(decideNativeWordProposalResponseCandidateOneWarningsItemMax)).max(decideNativeWordProposalResponseCandidateOneWarningsMax),
  "changedTargets": zod.array(zod.string().max(decideNativeWordProposalResponseCandidateOneChangedTargetsItemMax)).max(decideNativeWordProposalResponseCandidateOneChangedTargetsMax)
}),zod.null()]),
  "sensitiveTargets": zod.array(zod.object({
  "id": zod.string().max(decideNativeWordProposalResponseSensitiveTargetsItemIdMax),
  "part": zod.string().max(decideNativeWordProposalResponseSensitiveTargetsItemPartMax),
  "paragraph": zod.int().min(decideNativeWordProposalResponseSensitiveTargetsItemParagraphMin),
  "text": zod.string().max(decideNativeWordProposalResponseSensitiveTargetsItemTextMax),
  "textHash": zod.string().regex(decideNativeWordProposalResponseSensitiveTargetsItemTextHashRegExp),
  "editable": zod.boolean(),
  "blockers": zod.array(zod.string().max(decideNativeWordProposalResponseSensitiveTargetsItemBlockersItemMax)).max(decideNativeWordProposalResponseSensitiveTargetsItemBlockersMax),
  "inTable": zod.boolean(),
  "sensitive": zod.array(zod.enum(['legal', 'commercial'])).max(decideNativeWordProposalResponseSensitiveTargetsItemSensitiveMax)
})).max(decideNativeWordProposalResponseSensitiveTargetsMax),
  "warnings": zod.array(zod.string().max(decideNativeWordProposalResponseWarningsItemMax)).max(decideNativeWordProposalResponseWarningsMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewAcknowledged": zod.boolean(),
  "approvalState": zod.enum(['review_only'])
})


export const inspectSharePointWordSnapshotParams = zod.object({
  "entryId": zod.uuid()
})

export const inspectSharePointWordSnapshotQueryLimitDefault = 25;
export const inspectSharePointWordSnapshotQueryLimitMax = 100;

export const inspectSharePointWordSnapshotQueryOffsetDefault = 0;
export const inspectSharePointWordSnapshotQueryOffsetMin = 0;
export const inspectSharePointWordSnapshotQueryOffsetMax = 20000;



export const inspectSharePointWordSnapshotQueryParams = zod.object({
  "limit": zod.int().min(1).max(inspectSharePointWordSnapshotQueryLimitMax).default(inspectSharePointWordSnapshotQueryLimitDefault),
  "offset": zod.int().min(inspectSharePointWordSnapshotQueryOffsetMin).max(inspectSharePointWordSnapshotQueryOffsetMax).default(inspectSharePointWordSnapshotQueryOffsetDefault)
})

export const inspectSharePointWordSnapshotResponseSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const inspectSharePointWordSnapshotResponseTargetsItemIdMax = 100;

export const inspectSharePointWordSnapshotResponseTargetsItemPartMax = 500;

export const inspectSharePointWordSnapshotResponseTargetsItemParagraphMin = 0;

export const inspectSharePointWordSnapshotResponseTargetsItemTextMax = 10000;

export const inspectSharePointWordSnapshotResponseTargetsItemTextHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const inspectSharePointWordSnapshotResponseTargetsItemBlockersItemMax = 100;

export const inspectSharePointWordSnapshotResponseTargetsItemBlockersMax = 50;

export const inspectSharePointWordSnapshotResponseTargetsItemSensitiveMax = 2;

export const inspectSharePointWordSnapshotResponseTargetsMax = 100;

export const inspectSharePointWordSnapshotResponseWarningsItemMax = 1000;

export const inspectSharePointWordSnapshotResponseWarningsMax = 30;

export const inspectSharePointWordSnapshotResponsePartsItemNameMax = 500;

export const inspectSharePointWordSnapshotResponsePartsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const inspectSharePointWordSnapshotResponsePartsMax = 2000;

export const inspectSharePointWordSnapshotResponseTotalMin = 0;

export const inspectSharePointWordSnapshotResponseLimitMax = 100;

export const inspectSharePointWordSnapshotResponseOffsetMin = 0;
export const inspectSharePointWordSnapshotResponseOffsetMax = 20000;



export const inspectSharePointWordSnapshotResponse = zod.object({
  "sourceHash": zod.string().regex(inspectSharePointWordSnapshotResponseSourceHashRegExp),
  "targets": zod.array(zod.object({
  "id": zod.string().max(inspectSharePointWordSnapshotResponseTargetsItemIdMax),
  "part": zod.string().max(inspectSharePointWordSnapshotResponseTargetsItemPartMax),
  "paragraph": zod.int().min(inspectSharePointWordSnapshotResponseTargetsItemParagraphMin),
  "text": zod.string().max(inspectSharePointWordSnapshotResponseTargetsItemTextMax),
  "textHash": zod.string().regex(inspectSharePointWordSnapshotResponseTargetsItemTextHashRegExp),
  "editable": zod.boolean(),
  "blockers": zod.array(zod.string().max(inspectSharePointWordSnapshotResponseTargetsItemBlockersItemMax)).max(inspectSharePointWordSnapshotResponseTargetsItemBlockersMax),
  "inTable": zod.boolean(),
  "sensitive": zod.array(zod.enum(['legal', 'commercial'])).max(inspectSharePointWordSnapshotResponseTargetsItemSensitiveMax)
})).max(inspectSharePointWordSnapshotResponseTargetsMax),
  "warnings": zod.array(zod.string().max(inspectSharePointWordSnapshotResponseWarningsItemMax)).max(inspectSharePointWordSnapshotResponseWarningsMax),
  "editBlocked": zod.boolean(),
  "parts": zod.array(zod.object({
  "name": zod.string().max(inspectSharePointWordSnapshotResponsePartsItemNameMax),
  "hash": zod.string().regex(inspectSharePointWordSnapshotResponsePartsItemHashRegExp)
})).max(inspectSharePointWordSnapshotResponsePartsMax),
  "total": zod.int().min(inspectSharePointWordSnapshotResponseTotalMin),
  "limit": zod.int().min(1).max(inspectSharePointWordSnapshotResponseLimitMax),
  "offset": zod.int().min(inspectSharePointWordSnapshotResponseOffsetMin).max(inspectSharePointWordSnapshotResponseOffsetMax)
})


export const previewSharePointWordCandidateParams = zod.object({
  "entryId": zod.uuid()
})

export const previewSharePointWordCandidateBodySourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewSharePointWordCandidateBodyOperationsItemTargetIdMax = 100;

export const previewSharePointWordCandidateBodyOperationsItemExpectedHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewSharePointWordCandidateBodyOperationsItemExpectedTextMax = 10000;

export const previewSharePointWordCandidateBodyOperationsItemReplacementTextMax = 10000;

export const previewSharePointWordCandidateBodyOperationsMax = 50;



export const previewSharePointWordCandidateBody = zod.object({
  "sourceHash": zod.string().regex(previewSharePointWordCandidateBodySourceHashRegExp),
  "operations": zod.array(zod.object({
  "targetId": zod.string().max(previewSharePointWordCandidateBodyOperationsItemTargetIdMax),
  "expectedHash": zod.string().regex(previewSharePointWordCandidateBodyOperationsItemExpectedHashRegExp),
  "expectedText": zod.string().max(previewSharePointWordCandidateBodyOperationsItemExpectedTextMax),
  "replacementText": zod.string().max(previewSharePointWordCandidateBodyOperationsItemReplacementTextMax)
})).max(previewSharePointWordCandidateBodyOperationsMax)
})

export const previewSharePointWordCandidateResponseSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewSharePointWordCandidateResponseCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewSharePointWordCandidateResponseChangedPartsItemMax = 500;

export const previewSharePointWordCandidateResponseChangedPartsMax = 50;

export const previewSharePointWordCandidateResponsePreservedPartsItemNameMax = 500;

export const previewSharePointWordCandidateResponsePreservedPartsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewSharePointWordCandidateResponsePreservedPartsMax = 2000;

export const previewSharePointWordCandidateResponseWarningsItemMax = 1000;

export const previewSharePointWordCandidateResponseWarningsMax = 30;

export const previewSharePointWordCandidateResponseChangedTargetsItemMax = 100;

export const previewSharePointWordCandidateResponseChangedTargetsMax = 50;



export const previewSharePointWordCandidateResponse = zod.object({
  "sourceHash": zod.string().regex(previewSharePointWordCandidateResponseSourceHashRegExp),
  "candidateHash": zod.string().regex(previewSharePointWordCandidateResponseCandidateHashRegExp),
  "changedParts": zod.array(zod.string().max(previewSharePointWordCandidateResponseChangedPartsItemMax)).max(previewSharePointWordCandidateResponseChangedPartsMax),
  "preservedParts": zod.array(zod.object({
  "name": zod.string().max(previewSharePointWordCandidateResponsePreservedPartsItemNameMax),
  "hash": zod.string().regex(previewSharePointWordCandidateResponsePreservedPartsItemHashRegExp)
})).max(previewSharePointWordCandidateResponsePreservedPartsMax),
  "warnings": zod.array(zod.string().max(previewSharePointWordCandidateResponseWarningsItemMax)).max(previewSharePointWordCandidateResponseWarningsMax),
  "changedTargets": zod.array(zod.string().max(previewSharePointWordCandidateResponseChangedTargetsItemMax)).max(previewSharePointWordCandidateResponseChangedTargetsMax)
})


export const listNativeWordSavesParams = zod.object({
  "entryId": zod.uuid()
})

export const listNativeWordSavesQueryLimitDefault = 10;
export const listNativeWordSavesQueryLimitMax = 20;

export const listNativeWordSavesQueryOffsetDefault = 0;
export const listNativeWordSavesQueryOffsetMin = 0;
export const listNativeWordSavesQueryOffsetMax = 20;



export const listNativeWordSavesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listNativeWordSavesQueryLimitMax).default(listNativeWordSavesQueryLimitDefault),
  "offset": zod.int().min(listNativeWordSavesQueryOffsetMin).max(listNativeWordSavesQueryOffsetMax).default(listNativeWordSavesQueryOffsetDefault)
})

export const listNativeWordSavesResponseItemsItemRequestHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listNativeWordSavesResponseItemsItemCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listNativeWordSavesResponseItemsItemSourceSourceSizeMin = 0;
export const listNativeWordSavesResponseItemsItemSourceSourceSizeMax = 20971520;

export const listNativeWordSavesResponseItemsItemSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listNativeWordSavesResponseItemsItemMessageMax = 1000;

export const listNativeWordSavesResponseItemsItemResultETagMax = 500;

export const listNativeWordSavesResponseItemsItemResultVersionMax = 500;

export const listNativeWordSavesResponseItemsItemEventsItemMessageMax = 1000;

export const listNativeWordSavesResponseItemsItemEventsMax = 100;

export const listNativeWordSavesResponseItemsMax = 20;



export const listNativeWordSavesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "requestHash": zod.string().regex(listNativeWordSavesResponseItemsItemRequestHashRegExp),
  "proposalId": zod.uuid(),
  "proposalRevision": zod.int().min(1),
  "candidateHash": zod.string().regex(listNativeWordSavesResponseItemsItemCandidateHashRegExp),
  "source": zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(listNativeWordSavesResponseItemsItemSourceSourceSizeMin).max(listNativeWordSavesResponseItemsItemSourceSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(listNativeWordSavesResponseItemsItemSourceContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
}),
  "state": zod.enum(['writing', 'verified', 'blocked', 'conflict', 'uncertain']),
  "revision": zod.int().min(1),
  "message": zod.string().max(listNativeWordSavesResponseItemsItemMessageMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "leaseUntil": zod.iso.datetime({"offset":true}).nullable(),
  "resultETag": zod.string().max(listNativeWordSavesResponseItemsItemResultETagMax).nullable(),
  "resultVersion": zod.string().max(listNativeWordSavesResponseItemsItemResultVersionMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "events": zod.array(zod.object({
  "state": zod.enum(['writing', 'verified', 'blocked', 'conflict', 'uncertain']),
  "at": zod.iso.datetime({"offset":true}),
  "message": zod.string().max(listNativeWordSavesResponseItemsItemEventsItemMessageMax)
})).max(listNativeWordSavesResponseItemsItemEventsMax)
})).max(listNativeWordSavesResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const saveNativeWordOriginalParams = zod.object({
  "entryId": zod.uuid()
})


export const saveNativeWordOriginalBodyCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const saveNativeWordOriginalBody = zod.object({
  "clientRequestId": zod.uuid(),
  "proposalId": zod.uuid(),
  "expectedProposalRevision": zod.int().min(1),
  "candidateHash": zod.string().regex(saveNativeWordOriginalBodyCandidateHashRegExp),
  "acknowledgeOriginalSave": zod.literal(true)
})

export const saveNativeWordOriginalResponseRequestHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const saveNativeWordOriginalResponseCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const saveNativeWordOriginalResponseSourceSourceSizeMin = 0;
export const saveNativeWordOriginalResponseSourceSourceSizeMax = 20971520;

export const saveNativeWordOriginalResponseSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const saveNativeWordOriginalResponseMessageMax = 1000;

export const saveNativeWordOriginalResponseResultETagMax = 500;

export const saveNativeWordOriginalResponseResultVersionMax = 500;

export const saveNativeWordOriginalResponseEventsItemMessageMax = 1000;

export const saveNativeWordOriginalResponseEventsMax = 100;



export const saveNativeWordOriginalResponse = zod.object({
  "id": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "requestHash": zod.string().regex(saveNativeWordOriginalResponseRequestHashRegExp),
  "proposalId": zod.uuid(),
  "proposalRevision": zod.int().min(1),
  "candidateHash": zod.string().regex(saveNativeWordOriginalResponseCandidateHashRegExp),
  "source": zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(saveNativeWordOriginalResponseSourceSourceSizeMin).max(saveNativeWordOriginalResponseSourceSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(saveNativeWordOriginalResponseSourceContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
}),
  "state": zod.enum(['writing', 'verified', 'blocked', 'conflict', 'uncertain']),
  "revision": zod.int().min(1),
  "message": zod.string().max(saveNativeWordOriginalResponseMessageMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "leaseUntil": zod.iso.datetime({"offset":true}).nullable(),
  "resultETag": zod.string().max(saveNativeWordOriginalResponseResultETagMax).nullable(),
  "resultVersion": zod.string().max(saveNativeWordOriginalResponseResultVersionMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "events": zod.array(zod.object({
  "state": zod.enum(['writing', 'verified', 'blocked', 'conflict', 'uncertain']),
  "at": zod.iso.datetime({"offset":true}),
  "message": zod.string().max(saveNativeWordOriginalResponseEventsItemMessageMax)
})).max(saveNativeWordOriginalResponseEventsMax)
})


export const getNativeWordSaveParams = zod.object({
  "entryId": zod.uuid(),
  "saveId": zod.uuid()
})

export const getNativeWordSaveResponseRequestHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const getNativeWordSaveResponseCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getNativeWordSaveResponseSourceSourceSizeMin = 0;
export const getNativeWordSaveResponseSourceSourceSizeMax = 20971520;

export const getNativeWordSaveResponseSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const getNativeWordSaveResponseMessageMax = 1000;

export const getNativeWordSaveResponseResultETagMax = 500;

export const getNativeWordSaveResponseResultVersionMax = 500;

export const getNativeWordSaveResponseEventsItemMessageMax = 1000;

export const getNativeWordSaveResponseEventsMax = 100;



export const getNativeWordSaveResponse = zod.object({
  "id": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "requestHash": zod.string().regex(getNativeWordSaveResponseRequestHashRegExp),
  "proposalId": zod.uuid(),
  "proposalRevision": zod.int().min(1),
  "candidateHash": zod.string().regex(getNativeWordSaveResponseCandidateHashRegExp),
  "source": zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(getNativeWordSaveResponseSourceSourceSizeMin).max(getNativeWordSaveResponseSourceSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(getNativeWordSaveResponseSourceContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
}),
  "state": zod.enum(['writing', 'verified', 'blocked', 'conflict', 'uncertain']),
  "revision": zod.int().min(1),
  "message": zod.string().max(getNativeWordSaveResponseMessageMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "leaseUntil": zod.iso.datetime({"offset":true}).nullable(),
  "resultETag": zod.string().max(getNativeWordSaveResponseResultETagMax).nullable(),
  "resultVersion": zod.string().max(getNativeWordSaveResponseResultVersionMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "events": zod.array(zod.object({
  "state": zod.enum(['writing', 'verified', 'blocked', 'conflict', 'uncertain']),
  "at": zod.iso.datetime({"offset":true}),
  "message": zod.string().max(getNativeWordSaveResponseEventsItemMessageMax)
})).max(getNativeWordSaveResponseEventsMax)
})


/**
 * Read-only provider reconciliation. Never resends content.
 */
export const reconcileNativeWordSaveParams = zod.object({
  "entryId": zod.uuid(),
  "saveId": zod.uuid()
})

export const reconcileNativeWordSaveResponseRequestHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const reconcileNativeWordSaveResponseCandidateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reconcileNativeWordSaveResponseSourceSourceSizeMin = 0;
export const reconcileNativeWordSaveResponseSourceSourceSizeMax = 20971520;

export const reconcileNativeWordSaveResponseSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const reconcileNativeWordSaveResponseMessageMax = 1000;

export const reconcileNativeWordSaveResponseResultETagMax = 500;

export const reconcileNativeWordSaveResponseResultVersionMax = 500;

export const reconcileNativeWordSaveResponseEventsItemMessageMax = 1000;

export const reconcileNativeWordSaveResponseEventsMax = 100;



export const reconcileNativeWordSaveResponse = zod.object({
  "id": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "requestHash": zod.string().regex(reconcileNativeWordSaveResponseRequestHashRegExp),
  "proposalId": zod.uuid(),
  "proposalRevision": zod.int().min(1),
  "candidateHash": zod.string().regex(reconcileNativeWordSaveResponseCandidateHashRegExp),
  "source": zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(reconcileNativeWordSaveResponseSourceSourceSizeMin).max(reconcileNativeWordSaveResponseSourceSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(reconcileNativeWordSaveResponseSourceContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
}),
  "state": zod.enum(['writing', 'verified', 'blocked', 'conflict', 'uncertain']),
  "revision": zod.int().min(1),
  "message": zod.string().max(reconcileNativeWordSaveResponseMessageMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "leaseUntil": zod.iso.datetime({"offset":true}).nullable(),
  "resultETag": zod.string().max(reconcileNativeWordSaveResponseResultETagMax).nullable(),
  "resultVersion": zod.string().max(reconcileNativeWordSaveResponseResultVersionMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "events": zod.array(zod.object({
  "state": zod.enum(['writing', 'verified', 'blocked', 'conflict', 'uncertain']),
  "at": zod.iso.datetime({"offset":true}),
  "message": zod.string().max(reconcileNativeWordSaveResponseEventsItemMessageMax)
})).max(reconcileNativeWordSaveResponseEventsMax)
})


export const listSharePointWordSourcesQueryLimitDefault = 25;
export const listSharePointWordSourcesQueryLimitMax = 100;

export const listSharePointWordSourcesQueryOffsetDefault = 0;
export const listSharePointWordSourcesQueryOffsetMin = 0;
export const listSharePointWordSourcesQueryOffsetMax = 10000;



export const listSharePointWordSourcesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSharePointWordSourcesQueryLimitMax).default(listSharePointWordSourcesQueryLimitDefault),
  "offset": zod.int().min(listSharePointWordSourcesQueryOffsetMin).max(listSharePointWordSourcesQueryOffsetMax).default(listSharePointWordSourcesQueryOffsetDefault)
})

export const listSharePointWordSourcesResponse = zod.object({
  "state": zod.enum(['ready', 'setup_required']),
  "message": zod.string(),
  "bindingFingerprint": zod.string(),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "items": zod.array(zod.object({
  "destinationId": zod.uuid(),
  "displayName": zod.string(),
  "siteId": zod.string(),
  "driveId": zod.string(),
  "folderPath": zod.string()
}))
})


/**
 * @summary Actor-authorized native Word browse
 */
export const browseSharePointWordSourcesBodyOneBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const browseSharePointWordSourcesBodyTwoFolderIdMax = 500;

export const browseSharePointWordSourcesBodyTwoCursorMax = 6000;

export const browseSharePointWordSourcesBodyTwoLimitDefault = 25;
export const browseSharePointWordSourcesBodyTwoLimitMax = 100;



export const browseSharePointWordSourcesBody = zod.object({
  "destinationId": zod.uuid(),
  "bindingFingerprint": zod.string().regex(browseSharePointWordSourcesBodyOneBindingFingerprintRegExp)
}).and(zod.object({
  "folderId": zod.string().min(1).max(browseSharePointWordSourcesBodyTwoFolderIdMax).optional(),
  "cursor": zod.string().min(1).max(browseSharePointWordSourcesBodyTwoCursorMax).optional(),
  "limit": zod.int().min(1).max(browseSharePointWordSourcesBodyTwoLimitMax).default(browseSharePointWordSourcesBodyTwoLimitDefault)
}))

export const browseSharePointWordSourcesResponseItemsItemSizeMin = 0;
export const browseSharePointWordSourcesResponseItemsItemSizeMax = 20971520;



export const browseSharePointWordSourcesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(browseSharePointWordSourcesResponseItemsItemSizeMin).max(browseSharePointWordSourcesResponseItemsItemSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
})),
  "nextCursor": zod.string().nullable()
})


/**
 * @summary Actor-authorized native Word resolve
 */
export const resolveSharePointWordSourceBodyOneBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const resolveSharePointWordSourceBodyTwoUrlMax = 2048;



export const resolveSharePointWordSourceBody = zod.object({
  "destinationId": zod.uuid(),
  "bindingFingerprint": zod.string().regex(resolveSharePointWordSourceBodyOneBindingFingerprintRegExp)
}).and(zod.object({
  "url": zod.string().min(1).max(resolveSharePointWordSourceBodyTwoUrlMax)
}))

export const resolveSharePointWordSourceResponseSizeMin = 0;
export const resolveSharePointWordSourceResponseSizeMax = 20971520;



export const resolveSharePointWordSourceResponse = zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(resolveSharePointWordSourceResponseSizeMin).max(resolveSharePointWordSourceResponseSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
})


/**
 * @summary Actor-authorized native Word snapshots
 */
export const captureSharePointWordSnapshotBodyOneBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const captureSharePointWordSnapshotBodyTwoItemIdMax = 500;

export const captureSharePointWordSnapshotBodyTwoExpectedETagMax = 500;



export const captureSharePointWordSnapshotBody = zod.object({
  "destinationId": zod.uuid(),
  "bindingFingerprint": zod.string().regex(captureSharePointWordSnapshotBodyOneBindingFingerprintRegExp)
}).and(zod.object({
  "itemId": zod.string().min(1).max(captureSharePointWordSnapshotBodyTwoItemIdMax),
  "expectedETag": zod.string().min(1).max(captureSharePointWordSnapshotBodyTwoExpectedETagMax)
}))

export const captureSharePointWordSnapshotResponseSourceSizeMin = 0;
export const captureSharePointWordSnapshotResponseSourceSizeMax = 20971520;

export const captureSharePointWordSnapshotResponseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const captureSharePointWordSnapshotResponse = zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(captureSharePointWordSnapshotResponseSourceSizeMin).max(captureSharePointWordSnapshotResponseSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(captureSharePointWordSnapshotResponseContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
})


export const getSharePointWordSnapshotParams = zod.object({
  "entryId": zod.uuid()
})

export const getSharePointWordSnapshotResponseSourceSizeMin = 0;
export const getSharePointWordSnapshotResponseSourceSizeMax = 20971520;

export const getSharePointWordSnapshotResponseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const getSharePointWordSnapshotResponse = zod.object({
  "entryId": zod.uuid(),
  "fileId": zod.uuid(),
  "source": zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "size": zod.int().min(getSharePointWordSnapshotResponseSourceSizeMin).max(getSharePointWordSnapshotResponseSourceSizeMax),
  "eTag": zod.string().nullable(),
  "cTag": zod.string().nullable(),
  "kind": zod.enum(['folder', 'word']),
  "siteId": zod.string(),
  "driveId": zod.string()
}),
  "versionId": zod.string().nullable(),
  "contentHash": zod.string().regex(getSharePointWordSnapshotResponseContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "bindingFingerprint": zod.string(),
  "destinationId": zod.uuid(),
  "connectionId": zod.uuid(),
  "actorAppUserId": zod.uuid()
})


export const getGovernmentTenantOverviewQueryLimitDefault = 20;
export const getGovernmentTenantOverviewQueryLimitMax = 50;

export const getGovernmentTenantOverviewQueryOffsetDefault = 0;
export const getGovernmentTenantOverviewQueryOffsetMin = 0;



export const getGovernmentTenantOverviewQueryParams = zod.object({
  "limit": zod.int().min(1).max(getGovernmentTenantOverviewQueryLimitMax).default(getGovernmentTenantOverviewQueryLimitDefault),
  "offset": zod.int().min(getGovernmentTenantOverviewQueryOffsetMin).default(getGovernmentTenantOverviewQueryOffsetDefault),
  "entityId": zod.uuid().optional(),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).optional(),
  "progress": zod.enum(['interested', 'assessing', 'preparing', 'submitted', 'active_awarded', 'unsuccessful', 'withdrawn', 'expired']).optional(),
  "ownerAppUserId": zod.uuid().optional(),
  "targetBefore": zod.iso.datetime({"offset":true}).optional()
})

export const getGovernmentTenantOverviewResponseItemsItemMatchesMin = 0;

export const getGovernmentTenantOverviewResponseItemsItemPursuitsMin = 0;

export const getGovernmentTenantOverviewResponseItemsItemUnassignedMin = 0;

export const getGovernmentTenantOverviewResponseItemsItemOwnersItemCountMin = 0;

export const getGovernmentTenantOverviewResponseItemsItemOwnersMax = 20;

export const getGovernmentTenantOverviewResponseItemsItemOwnerTotalMin = 0;

export const getGovernmentTenantOverviewResponseItemsItemCoverageGapsMin = 0;

export const getGovernmentTenantOverviewResponseItemsMax = 50;

export const getGovernmentTenantOverviewResponseTotalMin = 0;


export const getGovernmentTenantOverviewResponseOffsetMin = 0;

export const getGovernmentTenantOverviewResponseTotalsEntitiesMin = 0;

export const getGovernmentTenantOverviewResponseTotalsMatchesMin = 0;

export const getGovernmentTenantOverviewResponseTotalsPursuitsMin = 0;

export const getGovernmentTenantOverviewResponseTotalsCoverageGapsMin = 0;

export const getGovernmentTenantOverviewResponseFacetsCategoriesItemCountMin = 0;

export const getGovernmentTenantOverviewResponseFacetsCategoriesMax = 7;

export const getGovernmentTenantOverviewResponseFacetsProgressItemCountMin = 0;

export const getGovernmentTenantOverviewResponseFacetsProgressMax = 8;

export const getGovernmentTenantOverviewResponseWarningsMax = 10;



export const getGovernmentTenantOverviewResponse = zod.object({
  "tenantId": zod.uuid(),
  "items": zod.array(zod.object({
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "matches": zod.int().min(getGovernmentTenantOverviewResponseItemsItemMatchesMin),
  "pursuits": zod.int().min(getGovernmentTenantOverviewResponseItemsItemPursuitsMin),
  "unassigned": zod.int().min(getGovernmentTenantOverviewResponseItemsItemUnassignedMin),
  "owners": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "count": zod.int().min(getGovernmentTenantOverviewResponseItemsItemOwnersItemCountMin)
})).max(getGovernmentTenantOverviewResponseItemsItemOwnersMax),
  "ownerTotal": zod.int().min(getGovernmentTenantOverviewResponseItemsItemOwnerTotalMin),
  "nextProgramDeadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextStaffTargetAt": zod.iso.datetime({"offset":true}).nullable(),
  "coverageOrigin": zod.enum(['setup_required', 'tenant', 'entity']),
  "coverageGaps": zod.int().min(getGovernmentTenantOverviewResponseItemsItemCoverageGapsMin),
  "coverageState": zod.enum(['setup_required', 'partial', 'unavailable'])
})).max(getGovernmentTenantOverviewResponseItemsMax),
  "total": zod.int().min(getGovernmentTenantOverviewResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getGovernmentTenantOverviewResponseOffsetMin),
  "totals": zod.object({
  "entities": zod.int().min(getGovernmentTenantOverviewResponseTotalsEntitiesMin),
  "matches": zod.int().min(getGovernmentTenantOverviewResponseTotalsMatchesMin),
  "pursuits": zod.int().min(getGovernmentTenantOverviewResponseTotalsPursuitsMin),
  "coverageGaps": zod.int().min(getGovernmentTenantOverviewResponseTotalsCoverageGapsMin)
}),
  "facets": zod.object({
  "categories": zod.array(zod.object({
  "value": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "count": zod.int().min(getGovernmentTenantOverviewResponseFacetsCategoriesItemCountMin)
})).max(getGovernmentTenantOverviewResponseFacetsCategoriesMax),
  "progress": zod.array(zod.object({
  "value": zod.enum(['interested', 'assessing', 'preparing', 'submitted', 'active_awarded', 'unsuccessful', 'withdrawn', 'expired']),
  "count": zod.int().min(getGovernmentTenantOverviewResponseFacetsProgressItemCountMin)
})).max(getGovernmentTenantOverviewResponseFacetsProgressMax)
}),
  "warnings": zod.array(zod.string()).max(getGovernmentTenantOverviewResponseWarningsMax)
})


export const listGovernmentPursuitsQueryLimitDefault = 20;
export const listGovernmentPursuitsQueryLimitMax = 50;

export const listGovernmentPursuitsQueryOffsetDefault = 0;
export const listGovernmentPursuitsQueryOffsetMin = 0;



export const listGovernmentPursuitsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listGovernmentPursuitsQueryLimitMax).default(listGovernmentPursuitsQueryLimitDefault),
  "offset": zod.int().min(listGovernmentPursuitsQueryOffsetMin).default(listGovernmentPursuitsQueryOffsetDefault),
  "progress": zod.enum(['interested', 'assessing', 'preparing', 'submitted', 'active_awarded', 'unsuccessful', 'withdrawn', 'expired']).optional(),
  "ownerAppUserId": zod.uuid().optional(),
  "unassigned": zod.boolean().optional(),
  "targetBefore": zod.iso.datetime({"offset":true}).optional()
})





export const listGovernmentPursuitsResponseItemsItemPinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitsResponseItemsItemPinsSourceUrlMax = 2048;

export const listGovernmentPursuitsResponseItemsItemPinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listGovernmentPursuitsResponseItemsItemPinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitsResponseItemsItemPinsConfigurationRevisionsItemRevisionMin = 0;

export const listGovernmentPursuitsResponseItemsItemPinsConfigurationRevisionsMax = 2;

export const listGovernmentPursuitsResponseItemsItemApplicationUrlMax = 2048;

export const listGovernmentPursuitsResponseItemsItemNotesMax = 20000;


export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationOfficialProgramIdMax = 200;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationRoundIdMax = 200;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationIdentityKeyRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationTitleMax = 500;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationAdministeringBodyMax = 500;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationOfficialUrlMax = 2048;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationLocalJurisdictionOneIdMax = 100;


export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationLocalJurisdictionOneNameMax = 200;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationTimezoneMax = 100;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationBenefitsMax = 10000;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemIdMax = 100;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemTextMax = 10000;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemEvidenceQuoteMax = 10000;




export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemEvidenceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemEvidenceUrlMax = 2048;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaMax = 100;




export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationSourceUrlMax = 2048;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationMetadataEvidenceItemFieldMax = 100;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationMetadataEvidenceItemQuoteMax = 10000;

export const listGovernmentPursuitsResponseItemsItemStartingFindingObservationMetadataEvidenceMax = 30;





export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsSourceUrlMax = 2048;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin = 0;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsConfigurationRevisionsMax = 2;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemCriterionIdMax = 100;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemReasonMax = 10000;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemFactKeysItemMax = 200;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemFactKeysMax = 100;




export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax = 2048;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemCitationsMax = 100;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaMax = 100;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneMissingFactsItemMax = 1000;

export const listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneMissingFactsMax = 100;

export const listGovernmentPursuitsResponseItemsItemStartingFindingWarningsItemMax = 1000;

export const listGovernmentPursuitsResponseItemsItemStartingFindingWarningsMax = 100;

export const listGovernmentPursuitsResponseTotalMin = 0;



export const listGovernmentPursuitsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "assessmentId": zod.uuid().nullable(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitsResponseItemsItemPinsSourceContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitsResponseItemsItemPinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(listGovernmentPursuitsResponseItemsItemPinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(listGovernmentPursuitsResponseItemsItemPinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(listGovernmentPursuitsResponseItemsItemPinsConfigurationRevisionsItemRevisionMin)
})).max(listGovernmentPursuitsResponseItemsItemPinsConfigurationRevisionsMax)
}),
  "ownerAppUserId": zod.uuid().nullable(),
  "progress": zod.enum(['interested', 'assessing', 'preparing', 'submitted', 'active_awarded', 'unsuccessful', 'withdrawn', 'expired']),
  "applicationUrl": zod.url().max(listGovernmentPursuitsResponseItemsItemApplicationUrlMax).nullable(),
  "sourceDeadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "staffTargetAt": zod.iso.datetime({"offset":true}).nullable(),
  "notes": zod.string().max(listGovernmentPursuitsResponseItemsItemNotesMax),
  "outcome": zod.enum(['not_recorded', 'panel_membership', 'incentive_award', 'unsuccessful', 'withdrawn']),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validUntil": zod.iso.datetime({"offset":true}).nullable(),
  "startingFinding": zod.object({
  "observation": zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "revision": zod.int().min(1),
  "officialProgramId": zod.string().max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationOfficialProgramIdMax).nullable(),
  "roundId": zod.string().max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationRoundIdMax).nullable(),
  "identityKey": zod.string().regex(listGovernmentPursuitsResponseItemsItemStartingFindingObservationIdentityKeyRegExp),
  "title": zod.string().min(1).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationTitleMax),
  "administeringBody": zod.string().min(1).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationAdministeringBodyMax),
  "officialUrl": zod.url().max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationOfficialUrlMax),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationLocalJurisdictionOneIdMax).regex(listGovernmentPursuitsResponseItemsItemStartingFindingObservationLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationLocalJurisdictionOneNameMax)
}),zod.null()]),
  "applicationStatus": zod.enum(['unknown', 'upcoming', 'open', 'closed', 'ongoing', 'suspended']),
  "opensAt": zod.iso.datetime({"offset":true}).nullable(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "timezone": zod.string().max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationTimezoneMax).nullable(),
  "benefits": zod.string().max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationBenefitsMax).nullable(),
  "criteria": zod.array(zod.object({
  "id": zod.string().min(1).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemIdMax),
  "text": zod.string().min(1).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemTextMax),
  "evidenceQuote": zod.string().min(1).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemEvidenceQuoteMax),
  "evidence": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemEvidenceContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaItemEvidenceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})
})).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationCriteriaMax),
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitsResponseItemsItemStartingFindingObservationSourceContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "effectiveAt": zod.iso.datetime({"offset":true}).nullable(),
  "metadataEvidence": zod.array(zod.object({
  "field": zod.string().max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationMetadataEvidenceItemFieldMax),
  "quote": zod.string().min(1).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationMetadataEvidenceItemQuoteMax)
})).max(listGovernmentPursuitsResponseItemsItemStartingFindingObservationMetadataEvidenceMax),
  "checkedAt": zod.iso.datetime({"offset":true})
}),
  "assessment": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "revision": zod.int().min(1),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsSourceContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin)
})).max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOnePinsConfigurationRevisionsMax)
}),
  "relevance": zod.enum(['potential', 'not_relevant', 'unknown']),
  "criteria": zod.array(zod.object({
  "criterionId": zod.string().max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemCriterionIdMax),
  "status": zod.enum(['supported', 'unmet', 'unknown', 'conflicting', 'expired']),
  "reason": zod.string().min(1).max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemReasonMax),
  "factKeys": zod.array(zod.string().max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemFactKeysItemMax)).max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemFactKeysMax),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaItemCitationsMax)
})).max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneCriteriaMax),
  "missingFacts": zod.array(zod.string().max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneMissingFactsItemMax)).max(listGovernmentPursuitsResponseItemsItemStartingFindingAssessmentOneMissingFactsMax),
  "assessedAt": zod.iso.datetime({"offset":true}),
  "eligibilityDetermination": zod.literal(false)
}),zod.null()]),
  "freshness": zod.enum(['current', 'stale', 'expired']),
  "warnings": zod.array(zod.string().max(listGovernmentPursuitsResponseItemsItemStartingFindingWarningsItemMax)).max(listGovernmentPursuitsResponseItemsItemStartingFindingWarningsMax)
}),
  "title": zod.string(),
  "identityKey": zod.string(),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "ownerName": zod.string().nullable(),
  "warnings": zod.array(zod.string()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "reviewRequired": zod.boolean(),
  "activityTarget": zod.object({
  "entityType": zod.enum(['government_pursuit']),
  "entityId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "tenantId": zod.uuid()
})
})),
  "total": zod.int().min(listGovernmentPursuitsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createGovernmentPursuitBody = zod.object({
  "requestKey": zod.uuid(),
  "observationId": zod.uuid(),
  "assessmentId": zod.uuid(),
  "ownerAppUserId": zod.uuid().nullish()
})





export const createGovernmentPursuitResponsePinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createGovernmentPursuitResponsePinsSourceUrlMax = 2048;

export const createGovernmentPursuitResponsePinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const createGovernmentPursuitResponsePinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const createGovernmentPursuitResponsePinsConfigurationRevisionsItemRevisionMin = 0;

export const createGovernmentPursuitResponsePinsConfigurationRevisionsMax = 2;

export const createGovernmentPursuitResponseApplicationUrlMax = 2048;

export const createGovernmentPursuitResponseNotesMax = 20000;


export const createGovernmentPursuitResponseStartingFindingObservationOfficialProgramIdMax = 200;

export const createGovernmentPursuitResponseStartingFindingObservationRoundIdMax = 200;

export const createGovernmentPursuitResponseStartingFindingObservationIdentityKeyRegExp = new RegExp('^[a-f0-9]{64}$');
export const createGovernmentPursuitResponseStartingFindingObservationTitleMax = 500;

export const createGovernmentPursuitResponseStartingFindingObservationAdministeringBodyMax = 500;

export const createGovernmentPursuitResponseStartingFindingObservationOfficialUrlMax = 2048;

export const createGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdMax = 100;


export const createGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const createGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneNameMax = 200;

export const createGovernmentPursuitResponseStartingFindingObservationTimezoneMax = 100;

export const createGovernmentPursuitResponseStartingFindingObservationBenefitsMax = 10000;

export const createGovernmentPursuitResponseStartingFindingObservationCriteriaItemIdMax = 100;

export const createGovernmentPursuitResponseStartingFindingObservationCriteriaItemTextMax = 10000;

export const createGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceQuoteMax = 10000;




export const createGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceUrlMax = 2048;

export const createGovernmentPursuitResponseStartingFindingObservationCriteriaMax = 100;




export const createGovernmentPursuitResponseStartingFindingObservationSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createGovernmentPursuitResponseStartingFindingObservationSourceUrlMax = 2048;

export const createGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemFieldMax = 100;

export const createGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemQuoteMax = 10000;

export const createGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceMax = 30;





export const createGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceUrlMax = 2048;

export const createGovernmentPursuitResponseStartingFindingAssessmentOnePinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const createGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const createGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin = 0;

export const createGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsMax = 2;

export const createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCriterionIdMax = 100;

export const createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemReasonMax = 10000;

export const createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysItemMax = 200;

export const createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysMax = 100;




export const createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax = 2048;

export const createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsMax = 100;

export const createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaMax = 100;

export const createGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsItemMax = 1000;

export const createGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsMax = 100;

export const createGovernmentPursuitResponseStartingFindingWarningsItemMax = 1000;

export const createGovernmentPursuitResponseStartingFindingWarningsMax = 100;



export const createGovernmentPursuitResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "assessmentId": zod.uuid().nullable(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(createGovernmentPursuitResponsePinsSourceContentHashRegExp),
  "url": zod.url().max(createGovernmentPursuitResponsePinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(createGovernmentPursuitResponsePinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(createGovernmentPursuitResponsePinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(createGovernmentPursuitResponsePinsConfigurationRevisionsItemRevisionMin)
})).max(createGovernmentPursuitResponsePinsConfigurationRevisionsMax)
}),
  "ownerAppUserId": zod.uuid().nullable(),
  "progress": zod.enum(['interested', 'assessing', 'preparing', 'submitted', 'active_awarded', 'unsuccessful', 'withdrawn', 'expired']),
  "applicationUrl": zod.url().max(createGovernmentPursuitResponseApplicationUrlMax).nullable(),
  "sourceDeadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "staffTargetAt": zod.iso.datetime({"offset":true}).nullable(),
  "notes": zod.string().max(createGovernmentPursuitResponseNotesMax),
  "outcome": zod.enum(['not_recorded', 'panel_membership', 'incentive_award', 'unsuccessful', 'withdrawn']),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validUntil": zod.iso.datetime({"offset":true}).nullable(),
  "startingFinding": zod.object({
  "observation": zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "revision": zod.int().min(1),
  "officialProgramId": zod.string().max(createGovernmentPursuitResponseStartingFindingObservationOfficialProgramIdMax).nullable(),
  "roundId": zod.string().max(createGovernmentPursuitResponseStartingFindingObservationRoundIdMax).nullable(),
  "identityKey": zod.string().regex(createGovernmentPursuitResponseStartingFindingObservationIdentityKeyRegExp),
  "title": zod.string().min(1).max(createGovernmentPursuitResponseStartingFindingObservationTitleMax),
  "administeringBody": zod.string().min(1).max(createGovernmentPursuitResponseStartingFindingObservationAdministeringBodyMax),
  "officialUrl": zod.url().max(createGovernmentPursuitResponseStartingFindingObservationOfficialUrlMax),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(createGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdMax).regex(createGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(createGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneNameMax)
}),zod.null()]),
  "applicationStatus": zod.enum(['unknown', 'upcoming', 'open', 'closed', 'ongoing', 'suspended']),
  "opensAt": zod.iso.datetime({"offset":true}).nullable(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "timezone": zod.string().max(createGovernmentPursuitResponseStartingFindingObservationTimezoneMax).nullable(),
  "benefits": zod.string().max(createGovernmentPursuitResponseStartingFindingObservationBenefitsMax).nullable(),
  "criteria": zod.array(zod.object({
  "id": zod.string().min(1).max(createGovernmentPursuitResponseStartingFindingObservationCriteriaItemIdMax),
  "text": zod.string().min(1).max(createGovernmentPursuitResponseStartingFindingObservationCriteriaItemTextMax),
  "evidenceQuote": zod.string().min(1).max(createGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceQuoteMax),
  "evidence": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(createGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceContentHashRegExp),
  "url": zod.url().max(createGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})
})).max(createGovernmentPursuitResponseStartingFindingObservationCriteriaMax),
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(createGovernmentPursuitResponseStartingFindingObservationSourceContentHashRegExp),
  "url": zod.url().max(createGovernmentPursuitResponseStartingFindingObservationSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "effectiveAt": zod.iso.datetime({"offset":true}).nullable(),
  "metadataEvidence": zod.array(zod.object({
  "field": zod.string().max(createGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemFieldMax),
  "quote": zod.string().min(1).max(createGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemQuoteMax)
})).max(createGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceMax),
  "checkedAt": zod.iso.datetime({"offset":true})
}),
  "assessment": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "revision": zod.int().min(1),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(createGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceContentHashRegExp),
  "url": zod.url().max(createGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(createGovernmentPursuitResponseStartingFindingAssessmentOnePinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(createGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(createGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin)
})).max(createGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsMax)
}),
  "relevance": zod.enum(['potential', 'not_relevant', 'unknown']),
  "criteria": zod.array(zod.object({
  "criterionId": zod.string().max(createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCriterionIdMax),
  "status": zod.enum(['supported', 'unmet', 'unknown', 'conflicting', 'expired']),
  "reason": zod.string().min(1).max(createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemReasonMax),
  "factKeys": zod.array(zod.string().max(createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysItemMax)).max(createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysMax),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp),
  "url": zod.url().max(createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsMax)
})).max(createGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaMax),
  "missingFacts": zod.array(zod.string().max(createGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsItemMax)).max(createGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsMax),
  "assessedAt": zod.iso.datetime({"offset":true}),
  "eligibilityDetermination": zod.literal(false)
}),zod.null()]),
  "freshness": zod.enum(['current', 'stale', 'expired']),
  "warnings": zod.array(zod.string().max(createGovernmentPursuitResponseStartingFindingWarningsItemMax)).max(createGovernmentPursuitResponseStartingFindingWarningsMax)
}),
  "title": zod.string(),
  "identityKey": zod.string(),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "ownerName": zod.string().nullable(),
  "warnings": zod.array(zod.string()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "reviewRequired": zod.boolean(),
  "activityTarget": zod.object({
  "entityType": zod.enum(['government_pursuit']),
  "entityId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "tenantId": zod.uuid()
})
})


export const listGovernmentPursuitOwnersQueryLimitDefault = 20;
export const listGovernmentPursuitOwnersQueryLimitMax = 50;

export const listGovernmentPursuitOwnersQueryOffsetDefault = 0;
export const listGovernmentPursuitOwnersQueryOffsetMin = 0;



export const listGovernmentPursuitOwnersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listGovernmentPursuitOwnersQueryLimitMax).default(listGovernmentPursuitOwnersQueryLimitDefault),
  "offset": zod.int().min(listGovernmentPursuitOwnersQueryOffsetMin).default(listGovernmentPursuitOwnersQueryOffsetDefault)
})

export const listGovernmentPursuitOwnersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})),
  "limit": zod.int(),
  "offset": zod.int(),
  "nextOffset": zod.int().nullable()
})


export const getGovernmentPursuitParams = zod.object({
  "id": zod.uuid()
})





export const getGovernmentPursuitResponsePinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentPursuitResponsePinsSourceUrlMax = 2048;

export const getGovernmentPursuitResponsePinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const getGovernmentPursuitResponsePinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentPursuitResponsePinsConfigurationRevisionsItemRevisionMin = 0;

export const getGovernmentPursuitResponsePinsConfigurationRevisionsMax = 2;

export const getGovernmentPursuitResponseApplicationUrlMax = 2048;

export const getGovernmentPursuitResponseNotesMax = 20000;


export const getGovernmentPursuitResponseStartingFindingObservationOfficialProgramIdMax = 200;

export const getGovernmentPursuitResponseStartingFindingObservationRoundIdMax = 200;

export const getGovernmentPursuitResponseStartingFindingObservationIdentityKeyRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentPursuitResponseStartingFindingObservationTitleMax = 500;

export const getGovernmentPursuitResponseStartingFindingObservationAdministeringBodyMax = 500;

export const getGovernmentPursuitResponseStartingFindingObservationOfficialUrlMax = 2048;

export const getGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdMax = 100;


export const getGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const getGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneNameMax = 200;

export const getGovernmentPursuitResponseStartingFindingObservationTimezoneMax = 100;

export const getGovernmentPursuitResponseStartingFindingObservationBenefitsMax = 10000;

export const getGovernmentPursuitResponseStartingFindingObservationCriteriaItemIdMax = 100;

export const getGovernmentPursuitResponseStartingFindingObservationCriteriaItemTextMax = 10000;

export const getGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceQuoteMax = 10000;




export const getGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceUrlMax = 2048;

export const getGovernmentPursuitResponseStartingFindingObservationCriteriaMax = 100;




export const getGovernmentPursuitResponseStartingFindingObservationSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentPursuitResponseStartingFindingObservationSourceUrlMax = 2048;

export const getGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemFieldMax = 100;

export const getGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemQuoteMax = 10000;

export const getGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceMax = 30;





export const getGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceUrlMax = 2048;

export const getGovernmentPursuitResponseStartingFindingAssessmentOnePinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const getGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin = 0;

export const getGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsMax = 2;

export const getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCriterionIdMax = 100;

export const getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemReasonMax = 10000;

export const getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysItemMax = 200;

export const getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysMax = 100;




export const getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax = 2048;

export const getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsMax = 100;

export const getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaMax = 100;

export const getGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsItemMax = 1000;

export const getGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsMax = 100;

export const getGovernmentPursuitResponseStartingFindingWarningsItemMax = 1000;

export const getGovernmentPursuitResponseStartingFindingWarningsMax = 100;



export const getGovernmentPursuitResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "assessmentId": zod.uuid().nullable(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(getGovernmentPursuitResponsePinsSourceContentHashRegExp),
  "url": zod.url().max(getGovernmentPursuitResponsePinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(getGovernmentPursuitResponsePinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(getGovernmentPursuitResponsePinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getGovernmentPursuitResponsePinsConfigurationRevisionsItemRevisionMin)
})).max(getGovernmentPursuitResponsePinsConfigurationRevisionsMax)
}),
  "ownerAppUserId": zod.uuid().nullable(),
  "progress": zod.enum(['interested', 'assessing', 'preparing', 'submitted', 'active_awarded', 'unsuccessful', 'withdrawn', 'expired']),
  "applicationUrl": zod.url().max(getGovernmentPursuitResponseApplicationUrlMax).nullable(),
  "sourceDeadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "staffTargetAt": zod.iso.datetime({"offset":true}).nullable(),
  "notes": zod.string().max(getGovernmentPursuitResponseNotesMax),
  "outcome": zod.enum(['not_recorded', 'panel_membership', 'incentive_award', 'unsuccessful', 'withdrawn']),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validUntil": zod.iso.datetime({"offset":true}).nullable(),
  "startingFinding": zod.object({
  "observation": zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "revision": zod.int().min(1),
  "officialProgramId": zod.string().max(getGovernmentPursuitResponseStartingFindingObservationOfficialProgramIdMax).nullable(),
  "roundId": zod.string().max(getGovernmentPursuitResponseStartingFindingObservationRoundIdMax).nullable(),
  "identityKey": zod.string().regex(getGovernmentPursuitResponseStartingFindingObservationIdentityKeyRegExp),
  "title": zod.string().min(1).max(getGovernmentPursuitResponseStartingFindingObservationTitleMax),
  "administeringBody": zod.string().min(1).max(getGovernmentPursuitResponseStartingFindingObservationAdministeringBodyMax),
  "officialUrl": zod.url().max(getGovernmentPursuitResponseStartingFindingObservationOfficialUrlMax),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(getGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdMax).regex(getGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(getGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneNameMax)
}),zod.null()]),
  "applicationStatus": zod.enum(['unknown', 'upcoming', 'open', 'closed', 'ongoing', 'suspended']),
  "opensAt": zod.iso.datetime({"offset":true}).nullable(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "timezone": zod.string().max(getGovernmentPursuitResponseStartingFindingObservationTimezoneMax).nullable(),
  "benefits": zod.string().max(getGovernmentPursuitResponseStartingFindingObservationBenefitsMax).nullable(),
  "criteria": zod.array(zod.object({
  "id": zod.string().min(1).max(getGovernmentPursuitResponseStartingFindingObservationCriteriaItemIdMax),
  "text": zod.string().min(1).max(getGovernmentPursuitResponseStartingFindingObservationCriteriaItemTextMax),
  "evidenceQuote": zod.string().min(1).max(getGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceQuoteMax),
  "evidence": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(getGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceContentHashRegExp),
  "url": zod.url().max(getGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})
})).max(getGovernmentPursuitResponseStartingFindingObservationCriteriaMax),
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(getGovernmentPursuitResponseStartingFindingObservationSourceContentHashRegExp),
  "url": zod.url().max(getGovernmentPursuitResponseStartingFindingObservationSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "effectiveAt": zod.iso.datetime({"offset":true}).nullable(),
  "metadataEvidence": zod.array(zod.object({
  "field": zod.string().max(getGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemFieldMax),
  "quote": zod.string().min(1).max(getGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemQuoteMax)
})).max(getGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceMax),
  "checkedAt": zod.iso.datetime({"offset":true})
}),
  "assessment": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "revision": zod.int().min(1),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(getGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceContentHashRegExp),
  "url": zod.url().max(getGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(getGovernmentPursuitResponseStartingFindingAssessmentOnePinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(getGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin)
})).max(getGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsMax)
}),
  "relevance": zod.enum(['potential', 'not_relevant', 'unknown']),
  "criteria": zod.array(zod.object({
  "criterionId": zod.string().max(getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCriterionIdMax),
  "status": zod.enum(['supported', 'unmet', 'unknown', 'conflicting', 'expired']),
  "reason": zod.string().min(1).max(getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemReasonMax),
  "factKeys": zod.array(zod.string().max(getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysItemMax)).max(getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysMax),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp),
  "url": zod.url().max(getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsMax)
})).max(getGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaMax),
  "missingFacts": zod.array(zod.string().max(getGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsItemMax)).max(getGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsMax),
  "assessedAt": zod.iso.datetime({"offset":true}),
  "eligibilityDetermination": zod.literal(false)
}),zod.null()]),
  "freshness": zod.enum(['current', 'stale', 'expired']),
  "warnings": zod.array(zod.string().max(getGovernmentPursuitResponseStartingFindingWarningsItemMax)).max(getGovernmentPursuitResponseStartingFindingWarningsMax)
}),
  "title": zod.string(),
  "identityKey": zod.string(),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "ownerName": zod.string().nullable(),
  "warnings": zod.array(zod.string()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "reviewRequired": zod.boolean(),
  "activityTarget": zod.object({
  "entityType": zod.enum(['government_pursuit']),
  "entityId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "tenantId": zod.uuid()
})
})


export const updateGovernmentPursuitParams = zod.object({
  "id": zod.uuid()
})


export const updateGovernmentPursuitBodyApplicationUrlMax = 2048;

export const updateGovernmentPursuitBodyNotesMax = 20000;



export const updateGovernmentPursuitBody = zod.object({
  "requestKey": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "ownerAppUserId": zod.uuid().nullish(),
  "progress": zod.enum(['interested', 'assessing', 'preparing', 'submitted', 'active_awarded', 'unsuccessful', 'withdrawn', 'expired']).optional(),
  "applicationUrl": zod.url().max(updateGovernmentPursuitBodyApplicationUrlMax).nullish(),
  "staffTargetAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().max(updateGovernmentPursuitBodyNotesMax).optional(),
  "outcome": zod.enum(['not_recorded', 'panel_membership', 'incentive_award', 'unsuccessful', 'withdrawn']).optional(),
  "validFrom": zod.iso.datetime({"offset":true}).nullish(),
  "validUntil": zod.iso.datetime({"offset":true}).nullish()
})





export const updateGovernmentPursuitResponsePinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateGovernmentPursuitResponsePinsSourceUrlMax = 2048;

export const updateGovernmentPursuitResponsePinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const updateGovernmentPursuitResponsePinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateGovernmentPursuitResponsePinsConfigurationRevisionsItemRevisionMin = 0;

export const updateGovernmentPursuitResponsePinsConfigurationRevisionsMax = 2;

export const updateGovernmentPursuitResponseApplicationUrlMax = 2048;

export const updateGovernmentPursuitResponseNotesMax = 20000;


export const updateGovernmentPursuitResponseStartingFindingObservationOfficialProgramIdMax = 200;

export const updateGovernmentPursuitResponseStartingFindingObservationRoundIdMax = 200;

export const updateGovernmentPursuitResponseStartingFindingObservationIdentityKeyRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateGovernmentPursuitResponseStartingFindingObservationTitleMax = 500;

export const updateGovernmentPursuitResponseStartingFindingObservationAdministeringBodyMax = 500;

export const updateGovernmentPursuitResponseStartingFindingObservationOfficialUrlMax = 2048;

export const updateGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdMax = 100;


export const updateGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const updateGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneNameMax = 200;

export const updateGovernmentPursuitResponseStartingFindingObservationTimezoneMax = 100;

export const updateGovernmentPursuitResponseStartingFindingObservationBenefitsMax = 10000;

export const updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemIdMax = 100;

export const updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemTextMax = 10000;

export const updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceQuoteMax = 10000;




export const updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceUrlMax = 2048;

export const updateGovernmentPursuitResponseStartingFindingObservationCriteriaMax = 100;




export const updateGovernmentPursuitResponseStartingFindingObservationSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateGovernmentPursuitResponseStartingFindingObservationSourceUrlMax = 2048;

export const updateGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemFieldMax = 100;

export const updateGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemQuoteMax = 10000;

export const updateGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceMax = 30;





export const updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceUrlMax = 2048;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin = 0;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsMax = 2;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCriterionIdMax = 100;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemReasonMax = 10000;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysItemMax = 200;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysMax = 100;




export const updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax = 2048;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsMax = 100;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaMax = 100;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsItemMax = 1000;

export const updateGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsMax = 100;

export const updateGovernmentPursuitResponseStartingFindingWarningsItemMax = 1000;

export const updateGovernmentPursuitResponseStartingFindingWarningsMax = 100;



export const updateGovernmentPursuitResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "assessmentId": zod.uuid().nullable(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(updateGovernmentPursuitResponsePinsSourceContentHashRegExp),
  "url": zod.url().max(updateGovernmentPursuitResponsePinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(updateGovernmentPursuitResponsePinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(updateGovernmentPursuitResponsePinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(updateGovernmentPursuitResponsePinsConfigurationRevisionsItemRevisionMin)
})).max(updateGovernmentPursuitResponsePinsConfigurationRevisionsMax)
}),
  "ownerAppUserId": zod.uuid().nullable(),
  "progress": zod.enum(['interested', 'assessing', 'preparing', 'submitted', 'active_awarded', 'unsuccessful', 'withdrawn', 'expired']),
  "applicationUrl": zod.url().max(updateGovernmentPursuitResponseApplicationUrlMax).nullable(),
  "sourceDeadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "staffTargetAt": zod.iso.datetime({"offset":true}).nullable(),
  "notes": zod.string().max(updateGovernmentPursuitResponseNotesMax),
  "outcome": zod.enum(['not_recorded', 'panel_membership', 'incentive_award', 'unsuccessful', 'withdrawn']),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validUntil": zod.iso.datetime({"offset":true}).nullable(),
  "startingFinding": zod.object({
  "observation": zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "revision": zod.int().min(1),
  "officialProgramId": zod.string().max(updateGovernmentPursuitResponseStartingFindingObservationOfficialProgramIdMax).nullable(),
  "roundId": zod.string().max(updateGovernmentPursuitResponseStartingFindingObservationRoundIdMax).nullable(),
  "identityKey": zod.string().regex(updateGovernmentPursuitResponseStartingFindingObservationIdentityKeyRegExp),
  "title": zod.string().min(1).max(updateGovernmentPursuitResponseStartingFindingObservationTitleMax),
  "administeringBody": zod.string().min(1).max(updateGovernmentPursuitResponseStartingFindingObservationAdministeringBodyMax),
  "officialUrl": zod.url().max(updateGovernmentPursuitResponseStartingFindingObservationOfficialUrlMax),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(updateGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdMax).regex(updateGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(updateGovernmentPursuitResponseStartingFindingObservationLocalJurisdictionOneNameMax)
}),zod.null()]),
  "applicationStatus": zod.enum(['unknown', 'upcoming', 'open', 'closed', 'ongoing', 'suspended']),
  "opensAt": zod.iso.datetime({"offset":true}).nullable(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "timezone": zod.string().max(updateGovernmentPursuitResponseStartingFindingObservationTimezoneMax).nullable(),
  "benefits": zod.string().max(updateGovernmentPursuitResponseStartingFindingObservationBenefitsMax).nullable(),
  "criteria": zod.array(zod.object({
  "id": zod.string().min(1).max(updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemIdMax),
  "text": zod.string().min(1).max(updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemTextMax),
  "evidenceQuote": zod.string().min(1).max(updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceQuoteMax),
  "evidence": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceContentHashRegExp),
  "url": zod.url().max(updateGovernmentPursuitResponseStartingFindingObservationCriteriaItemEvidenceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})
})).max(updateGovernmentPursuitResponseStartingFindingObservationCriteriaMax),
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(updateGovernmentPursuitResponseStartingFindingObservationSourceContentHashRegExp),
  "url": zod.url().max(updateGovernmentPursuitResponseStartingFindingObservationSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "effectiveAt": zod.iso.datetime({"offset":true}).nullable(),
  "metadataEvidence": zod.array(zod.object({
  "field": zod.string().max(updateGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemFieldMax),
  "quote": zod.string().min(1).max(updateGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceItemQuoteMax)
})).max(updateGovernmentPursuitResponseStartingFindingObservationMetadataEvidenceMax),
  "checkedAt": zod.iso.datetime({"offset":true})
}),
  "assessment": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "revision": zod.int().min(1),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceContentHashRegExp),
  "url": zod.url().max(updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin)
})).max(updateGovernmentPursuitResponseStartingFindingAssessmentOnePinsConfigurationRevisionsMax)
}),
  "relevance": zod.enum(['potential', 'not_relevant', 'unknown']),
  "criteria": zod.array(zod.object({
  "criterionId": zod.string().max(updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCriterionIdMax),
  "status": zod.enum(['supported', 'unmet', 'unknown', 'conflicting', 'expired']),
  "reason": zod.string().min(1).max(updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemReasonMax),
  "factKeys": zod.array(zod.string().max(updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysItemMax)).max(updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemFactKeysMax),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp),
  "url": zod.url().max(updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaItemCitationsMax)
})).max(updateGovernmentPursuitResponseStartingFindingAssessmentOneCriteriaMax),
  "missingFacts": zod.array(zod.string().max(updateGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsItemMax)).max(updateGovernmentPursuitResponseStartingFindingAssessmentOneMissingFactsMax),
  "assessedAt": zod.iso.datetime({"offset":true}),
  "eligibilityDetermination": zod.literal(false)
}),zod.null()]),
  "freshness": zod.enum(['current', 'stale', 'expired']),
  "warnings": zod.array(zod.string().max(updateGovernmentPursuitResponseStartingFindingWarningsItemMax)).max(updateGovernmentPursuitResponseStartingFindingWarningsMax)
}),
  "title": zod.string(),
  "identityKey": zod.string(),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "ownerName": zod.string().nullable(),
  "warnings": zod.array(zod.string()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "reviewRequired": zod.boolean(),
  "activityTarget": zod.object({
  "entityType": zod.enum(['government_pursuit']),
  "entityId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "tenantId": zod.uuid()
})
})


export const listGovernmentPursuitHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listGovernmentPursuitHistoryQueryLimitDefault = 20;
export const listGovernmentPursuitHistoryQueryLimitMax = 50;

export const listGovernmentPursuitHistoryQueryOffsetDefault = 0;
export const listGovernmentPursuitHistoryQueryOffsetMin = 0;



export const listGovernmentPursuitHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listGovernmentPursuitHistoryQueryLimitMax).default(listGovernmentPursuitHistoryQueryLimitDefault),
  "offset": zod.int().min(listGovernmentPursuitHistoryQueryOffsetMin).default(listGovernmentPursuitHistoryQueryOffsetDefault)
})


export const listGovernmentPursuitHistoryResponseItemsItemActivitySnapshotOneDurationMinutesMin = 0;

export const listGovernmentPursuitHistoryResponseItemsItemActivitySnapshotOneIsTestDataDefault = false;



export const listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsSourceUrlMax = 2048;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsConfigurationRevisionsItemRevisionMin = 0;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsConfigurationRevisionsMax = 2;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotApplicationUrlMax = 2048;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotNotesMax = 20000;


export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationOfficialProgramIdMax = 200;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationRoundIdMax = 200;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationIdentityKeyRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationTitleMax = 500;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationAdministeringBodyMax = 500;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationOfficialUrlMax = 2048;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationLocalJurisdictionOneIdMax = 100;


export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationLocalJurisdictionOneNameMax = 200;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationTimezoneMax = 100;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationBenefitsMax = 10000;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemIdMax = 100;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemTextMax = 10000;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemEvidenceQuoteMax = 10000;




export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemEvidenceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemEvidenceUrlMax = 2048;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaMax = 100;




export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationSourceUrlMax = 2048;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationMetadataEvidenceItemFieldMax = 100;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationMetadataEvidenceItemQuoteMax = 10000;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationMetadataEvidenceMax = 30;





export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsSourceUrlMax = 2048;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin = 0;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsConfigurationRevisionsMax = 2;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemCriterionIdMax = 100;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemReasonMax = 10000;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemFactKeysItemMax = 200;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemFactKeysMax = 100;




export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax = 2048;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemCitationsMax = 100;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaMax = 100;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneMissingFactsItemMax = 1000;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneMissingFactsMax = 100;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingWarningsItemMax = 1000;

export const listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingWarningsMax = 100;



export const listGovernmentPursuitHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "pursuitId": zod.uuid(),
  "revision": zod.int(),
  "actorAppUserId": zod.uuid(),
  "action": zod.string(),
  "activityId": zod.uuid().nullable(),
  "activitySnapshot": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listGovernmentPursuitHistoryResponseItemsItemActivitySnapshotOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listGovernmentPursuitHistoryResponseItemsItemActivitySnapshotOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]).optional(),
  "snapshot": zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "assessmentId": zod.uuid().nullable(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsSourceContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsConfigurationRevisionsItemRevisionMin)
})).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotPinsConfigurationRevisionsMax)
}),
  "ownerAppUserId": zod.uuid().nullable(),
  "progress": zod.enum(['interested', 'assessing', 'preparing', 'submitted', 'active_awarded', 'unsuccessful', 'withdrawn', 'expired']),
  "applicationUrl": zod.url().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotApplicationUrlMax).nullable(),
  "sourceDeadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "staffTargetAt": zod.iso.datetime({"offset":true}).nullable(),
  "notes": zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotNotesMax),
  "outcome": zod.enum(['not_recorded', 'panel_membership', 'incentive_award', 'unsuccessful', 'withdrawn']),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validUntil": zod.iso.datetime({"offset":true}).nullable(),
  "startingFinding": zod.object({
  "observation": zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "revision": zod.int().min(1),
  "officialProgramId": zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationOfficialProgramIdMax).nullable(),
  "roundId": zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationRoundIdMax).nullable(),
  "identityKey": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationIdentityKeyRegExp),
  "title": zod.string().min(1).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationTitleMax),
  "administeringBody": zod.string().min(1).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationAdministeringBodyMax),
  "officialUrl": zod.url().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationOfficialUrlMax),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationLocalJurisdictionOneIdMax).regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationLocalJurisdictionOneNameMax)
}),zod.null()]),
  "applicationStatus": zod.enum(['unknown', 'upcoming', 'open', 'closed', 'ongoing', 'suspended']),
  "opensAt": zod.iso.datetime({"offset":true}).nullable(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "timezone": zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationTimezoneMax).nullable(),
  "benefits": zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationBenefitsMax).nullable(),
  "criteria": zod.array(zod.object({
  "id": zod.string().min(1).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemIdMax),
  "text": zod.string().min(1).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemTextMax),
  "evidenceQuote": zod.string().min(1).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemEvidenceQuoteMax),
  "evidence": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemEvidenceContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaItemEvidenceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})
})).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationCriteriaMax),
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationSourceContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "effectiveAt": zod.iso.datetime({"offset":true}).nullable(),
  "metadataEvidence": zod.array(zod.object({
  "field": zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationMetadataEvidenceItemFieldMax),
  "quote": zod.string().min(1).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationMetadataEvidenceItemQuoteMax)
})).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingObservationMetadataEvidenceMax),
  "checkedAt": zod.iso.datetime({"offset":true})
}),
  "assessment": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "revision": zod.int().min(1),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsSourceContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsConfigurationRevisionsItemRevisionMin)
})).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOnePinsConfigurationRevisionsMax)
}),
  "relevance": zod.enum(['potential', 'not_relevant', 'unknown']),
  "criteria": zod.array(zod.object({
  "criterionId": zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemCriterionIdMax),
  "status": zod.enum(['supported', 'unmet', 'unknown', 'conflicting', 'expired']),
  "reason": zod.string().min(1).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemReasonMax),
  "factKeys": zod.array(zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemFactKeysItemMax)).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemFactKeysMax),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemCitationsItemContentHashRegExp),
  "url": zod.url().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemCitationsItemUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaItemCitationsMax)
})).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneCriteriaMax),
  "missingFacts": zod.array(zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneMissingFactsItemMax)).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingAssessmentOneMissingFactsMax),
  "assessedAt": zod.iso.datetime({"offset":true}),
  "eligibilityDetermination": zod.literal(false)
}),zod.null()]),
  "freshness": zod.enum(['current', 'stale', 'expired']),
  "warnings": zod.array(zod.string().max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingWarningsItemMax)).max(listGovernmentPursuitHistoryResponseItemsItemSnapshotStartingFindingWarningsMax)
}),
  "title": zod.string(),
  "identityKey": zod.string(),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "ownerName": zod.string().nullable(),
  "warnings": zod.array(zod.string()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "reviewRequired": zod.boolean(),
  "activityTarget": zod.object({
  "entityType": zod.enum(['government_pursuit']),
  "entityId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "tenantId": zod.uuid()
})
}),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary List discovered tender opportunities in this entity, ranked by match band then closing date. Low-match items are included unless filtered out.
 */
export const listTenderOpportunitiesQueryLimitDefault = 25;
export const listTenderOpportunitiesQueryLimitMax = 100;

export const listTenderOpportunitiesQueryOffsetDefault = 0;
export const listTenderOpportunitiesQueryOffsetMin = 0;

export const listTenderOpportunitiesQueryStatusMax = 7;

export const listTenderOpportunitiesQueryBandMax = 3;

export const listTenderOpportunitiesQueryJurisdictionMax = 80;

export const listTenderOpportunitiesQueryClosingWithinDaysMax = 365;

export const listTenderOpportunitiesQuerySearchMax = 200;

export const listTenderOpportunitiesQueryObservationIdMax = 50;



export const listTenderOpportunitiesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderOpportunitiesQueryLimitMax).default(listTenderOpportunitiesQueryLimitDefault),
  "offset": zod.int().min(listTenderOpportunitiesQueryOffsetMin).default(listTenderOpportunitiesQueryOffsetDefault),
  "status": zod.array(zod.enum(['new', 'reviewing', 'shortlisted', 'low_match', 'dismissed', 'converted', 'expired'])).max(listTenderOpportunitiesQueryStatusMax).optional(),
  "band": zod.array(zod.enum(['strong', 'possible', 'low'])).max(listTenderOpportunitiesQueryBandMax).optional(),
  "notForUs": zod.enum(['include', 'exclude', 'only']).optional().describe('Not for us recommendations: include (default), exclude (the tender list default view) or only.'),
  "jurisdiction": zod.string().min(1).max(listTenderOpportunitiesQueryJurisdictionMax).optional(),
  "closingWithinDays": zod.int().min(1).max(listTenderOpportunitiesQueryClosingWithinDaysMax).optional(),
  "search": zod.string().min(1).max(listTenderOpportunitiesQuerySearchMax).optional(),
  "assigned": zod.enum(['me', 'unassigned']).optional(),
  "includeDismissed": zod.boolean().optional(),
  "observationId": zod.array(zod.uuid()).max(listTenderOpportunitiesQueryObservationIdMax).optional().describe('Only opportunities mirrored into these Government observations.'),
  "pursuitId": zod.uuid().optional().describe('Only the opportunity linked to this Government pursuit.'),
  "tenderId": zod.uuid().optional().describe('Only the opportunity converted into this tender/SOW response.'),
  "pipelineOpportunityId": zod.uuid().optional().describe('Only the opportunity linked to this pipeline opportunity.')
})

export const listTenderOpportunitiesResponseItemsItemMatchScoreMin = 0;
export const listTenderOpportunitiesResponseItemsItemMatchScoreMax = 100;

export const listTenderOpportunitiesResponseItemsItemDocumentSummaryTotalMin = 0;

export const listTenderOpportunitiesResponseItemsItemDocumentSummaryAcquiredMin = 0;

export const listTenderOpportunitiesResponseItemsItemDocumentSummaryPendingMin = 0;

export const listTenderOpportunitiesResponseItemsItemDocumentSummaryNeedsUploadMin = 0;

export const listTenderOpportunitiesResponseItemsItemDocumentSummaryFailedMin = 0;

export const listTenderOpportunitiesResponseItemsItemDocumentSummaryAutoAcquiredMin = 0;


export const listTenderOpportunitiesResponseTotalMin = 0;



export const listTenderOpportunitiesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "portalKey": zod.string(),
  "portalReference": zod.string(),
  "canonicalUrl": zod.string(),
  "title": zod.string(),
  "buyerName": zod.string().nullable(),
  "buyerAbn": zod.string().nullable(),
  "jurisdiction": zod.string().nullable(),
  "categoryCodes": zod.array(zod.string()),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "briefingAt": zod.iso.datetime({"offset":true}).nullable(),
  "estimatedValue": zod.number().nullable(),
  "summaryMd": zod.string(),
  "status": zod.enum(['new', 'reviewing', 'shortlisted', 'low_match', 'dismissed', 'converted', 'expired']),
  "matchScore": zod.int().min(listTenderOpportunitiesResponseItemsItemMatchScoreMin).max(listTenderOpportunitiesResponseItemsItemMatchScoreMax).nullable(),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "matchReasons": zod.array(zod.string()),
  "disqualifiers": zod.array(zod.string()),
  "suggestedProposalType": zod.enum(['tender', 'sow']).nullable(),
  "matchConfidence": zod.enum(['high', 'medium', 'low']).nullable().describe('How much to trust the ranking. Low when the AI service was unavailable and keyword scoring was used.'),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]).optional().describe('Bid/no-bid recommendation from the bid rules and Offerings Profile. People decide; Not for us is kept and only hidden by default.'),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]).optional().describe('prefilter when a bid rule filtered the tender without an AI call, ai for an AI assessment, keyword for the AI-unavailable fallback.'),
  "rankedAt": zod.iso.datetime({"offset":true}).nullable(),
  "assignedAppUserId": zod.uuid().nullable(),
  "assigneeName": zod.string().nullable(),
  "candidateId": zod.uuid().nullable(),
  "sourceId": zod.uuid().nullable(),
  "observationId": zod.uuid().nullable(),
  "assessmentId": zod.uuid().nullable(),
  "pursuitId": zod.uuid().nullable(),
  "tenderId": zod.uuid().nullable(),
  "pipelineOpportunityId": zod.uuid().nullable(),
  "accountId": zod.uuid().nullable().describe('Buyer account matched or created when the opportunity was converted.'),
  "convertedAt": zod.iso.datetime({"offset":true}).nullable(),
  "seenByMe": zod.boolean(),
  "hasNewAddenda": zod.boolean().describe('A re-scan added an addendum that staff have not yet viewed.'),
  "documentSummary": zod.object({
  "total": zod.int().min(listTenderOpportunitiesResponseItemsItemDocumentSummaryTotalMin),
  "acquired": zod.int().min(listTenderOpportunitiesResponseItemsItemDocumentSummaryAcquiredMin),
  "pending": zod.int().min(listTenderOpportunitiesResponseItemsItemDocumentSummaryPendingMin),
  "needsUpload": zod.int().min(listTenderOpportunitiesResponseItemsItemDocumentSummaryNeedsUploadMin),
  "failed": zod.int().min(listTenderOpportunitiesResponseItemsItemDocumentSummaryFailedMin),
  "autoAcquired": zod.int().min(listTenderOpportunitiesResponseItemsItemDocumentSummaryAutoAcquiredMin)
}).describe('Counts of the opportunity\'s documents by acquisition state, so lists can show whether documents are ready or need uploading.'),
  "revision": zod.int().min(1),
  "firstSeenAt": zod.iso.datetime({"offset":true}),
  "lastSeenAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderOpportunitiesResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary Count new strong or possible tender opportunities the caller has not viewed.
 */
export const getTenderOpportunityUnreadCountResponseCountMin = 0;

export const getTenderOpportunityUnreadCountResponseStrongMin = 0;

export const getTenderOpportunityUnreadCountResponsePossibleMin = 0;



export const getTenderOpportunityUnreadCountResponse = zod.object({
  "count": zod.int().min(getTenderOpportunityUnreadCountResponseCountMin),
  "strong": zod.int().min(getTenderOpportunityUnreadCountResponseStrongMin),
  "possible": zod.int().min(getTenderOpportunityUnreadCountResponsePossibleMin)
})


/**
 * @summary Render the daily tender digest the caller would receive today: new matches, closing-soon items and new addenda. Nothing is sent.
 */
export const previewTenderOpportunityDigestResponseSendHourMin = 0;
export const previewTenderOpportunityDigestResponseSendHourMax = 23;

export const previewTenderOpportunityDigestResponseItemCountMin = 0;

export const previewTenderOpportunityDigestResponseNewMatchesItemMatchScoreMin = 0;
export const previewTenderOpportunityDigestResponseNewMatchesItemMatchScoreMax = 100;

export const previewTenderOpportunityDigestResponseNewMatchesMax = 25;

export const previewTenderOpportunityDigestResponseClosingSoonItemMatchScoreMin = 0;
export const previewTenderOpportunityDigestResponseClosingSoonItemMatchScoreMax = 100;

export const previewTenderOpportunityDigestResponseClosingSoonMax = 25;

export const previewTenderOpportunityDigestResponseAddendaItemMatchScoreMin = 0;
export const previewTenderOpportunityDigestResponseAddendaItemMatchScoreMax = 100;

export const previewTenderOpportunityDigestResponseAddendaMax = 25;



export const previewTenderOpportunityDigestResponse = zod.object({
  "localDate": zod.iso.date(),
  "sendHour": zod.int().min(previewTenderOpportunityDigestResponseSendHourMin).max(previewTenderOpportunityDigestResponseSendHourMax),
  "timezone": zod.string(),
  "enabled": zod.boolean(),
  "optedOut": zod.boolean(),
  "eligible": zod.boolean(),
  "alreadySentToday": zod.boolean(),
  "wouldSend": zod.boolean().describe('True when today\'s digest would be emailed to the caller: enabled, eligible, not opted out, not already sent and not empty.'),
  "itemCount": zod.int().min(previewTenderOpportunityDigestResponseItemCountMin),
  "since": zod.iso.datetime({"offset":true}).describe('Changes after this time count as new.'),
  "subject": zod.string(),
  "html": zod.string(),
  "text": zod.string(),
  "newMatches": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "buyerName": zod.string().nullable(),
  "matchBand": zod.enum(['strong', 'possible', 'low']).nullable(),
  "matchScore": zod.int().min(previewTenderOpportunityDigestResponseNewMatchesItemMatchScoreMin).max(previewTenderOpportunityDigestResponseNewMatchesItemMatchScoreMax).nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "link": zod.string().describe('Deep link to the opportunity in the app.'),
  "detail": zod.string().describe('Short plain-language line shown under the title.')
})).max(previewTenderOpportunityDigestResponseNewMatchesMax),
  "closingSoon": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "buyerName": zod.string().nullable(),
  "matchBand": zod.enum(['strong', 'possible', 'low']).nullable(),
  "matchScore": zod.int().min(previewTenderOpportunityDigestResponseClosingSoonItemMatchScoreMin).max(previewTenderOpportunityDigestResponseClosingSoonItemMatchScoreMax).nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "link": zod.string().describe('Deep link to the opportunity in the app.'),
  "detail": zod.string().describe('Short plain-language line shown under the title.')
})).max(previewTenderOpportunityDigestResponseClosingSoonMax),
  "addenda": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "buyerName": zod.string().nullable(),
  "matchBand": zod.enum(['strong', 'possible', 'low']).nullable(),
  "matchScore": zod.int().min(previewTenderOpportunityDigestResponseAddendaItemMatchScoreMin).max(previewTenderOpportunityDigestResponseAddendaItemMatchScoreMax).nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "link": zod.string().describe('Deep link to the opportunity in the app.'),
  "detail": zod.string().describe('Short plain-language line shown under the title.')
})).max(previewTenderOpportunityDigestResponseAddendaMax)
})


/**
 * @summary Read the caller's personal daily tender digest preference in this entity.
 */
export const getTenderDigestPreferenceResponse = zod.object({
  "optedOut": zod.boolean().describe('True when the caller has turned off the daily digest for this entity.'),
  "eligible": zod.boolean().describe('True when the caller holds tender write access and so is a digest recipient.')
})


/**
 * @summary Opt the caller in to or out of the daily tender digest email for this entity.
 */
export const updateTenderDigestPreferenceBody = zod.object({
  "optedOut": zod.boolean()
})

export const updateTenderDigestPreferenceResponse = zod.object({
  "optedOut": zod.boolean().describe('True when the caller has turned off the daily digest for this entity.'),
  "eligible": zod.boolean().describe('True when the caller holds tender write access and so is a digest recipient.')
})


/**
 * @summary Read one tender opportunity with its documents and recent history.
 */
export const getTenderOpportunityParams = zod.object({
  "id": zod.uuid()
})

export const getTenderOpportunityResponseOpportunityMatchScoreMin = 0;
export const getTenderOpportunityResponseOpportunityMatchScoreMax = 100;

export const getTenderOpportunityResponseOpportunityDocumentSummaryTotalMin = 0;

export const getTenderOpportunityResponseOpportunityDocumentSummaryAcquiredMin = 0;

export const getTenderOpportunityResponseOpportunityDocumentSummaryPendingMin = 0;

export const getTenderOpportunityResponseOpportunityDocumentSummaryNeedsUploadMin = 0;

export const getTenderOpportunityResponseOpportunityDocumentSummaryFailedMin = 0;

export const getTenderOpportunityResponseOpportunityDocumentSummaryAutoAcquiredMin = 0;


export const getTenderOpportunityResponseDocumentsItemAttemptCountMin = 0;



export const getTenderOpportunityResponse = zod.object({
  "opportunity": zod.object({
  "id": zod.uuid(),
  "portalKey": zod.string(),
  "portalReference": zod.string(),
  "canonicalUrl": zod.string(),
  "title": zod.string(),
  "buyerName": zod.string().nullable(),
  "buyerAbn": zod.string().nullable(),
  "jurisdiction": zod.string().nullable(),
  "categoryCodes": zod.array(zod.string()),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "briefingAt": zod.iso.datetime({"offset":true}).nullable(),
  "estimatedValue": zod.number().nullable(),
  "summaryMd": zod.string(),
  "status": zod.enum(['new', 'reviewing', 'shortlisted', 'low_match', 'dismissed', 'converted', 'expired']),
  "matchScore": zod.int().min(getTenderOpportunityResponseOpportunityMatchScoreMin).max(getTenderOpportunityResponseOpportunityMatchScoreMax).nullable(),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "matchReasons": zod.array(zod.string()),
  "disqualifiers": zod.array(zod.string()),
  "suggestedProposalType": zod.enum(['tender', 'sow']).nullable(),
  "matchConfidence": zod.enum(['high', 'medium', 'low']).nullable().describe('How much to trust the ranking. Low when the AI service was unavailable and keyword scoring was used.'),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]).optional().describe('Bid/no-bid recommendation from the bid rules and Offerings Profile. People decide; Not for us is kept and only hidden by default.'),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]).optional().describe('prefilter when a bid rule filtered the tender without an AI call, ai for an AI assessment, keyword for the AI-unavailable fallback.'),
  "rankedAt": zod.iso.datetime({"offset":true}).nullable(),
  "assignedAppUserId": zod.uuid().nullable(),
  "assigneeName": zod.string().nullable(),
  "candidateId": zod.uuid().nullable(),
  "sourceId": zod.uuid().nullable(),
  "observationId": zod.uuid().nullable(),
  "assessmentId": zod.uuid().nullable(),
  "pursuitId": zod.uuid().nullable(),
  "tenderId": zod.uuid().nullable(),
  "pipelineOpportunityId": zod.uuid().nullable(),
  "accountId": zod.uuid().nullable().describe('Buyer account matched or created when the opportunity was converted.'),
  "convertedAt": zod.iso.datetime({"offset":true}).nullable(),
  "seenByMe": zod.boolean(),
  "hasNewAddenda": zod.boolean().describe('A re-scan added an addendum that staff have not yet viewed.'),
  "documentSummary": zod.object({
  "total": zod.int().min(getTenderOpportunityResponseOpportunityDocumentSummaryTotalMin),
  "acquired": zod.int().min(getTenderOpportunityResponseOpportunityDocumentSummaryAcquiredMin),
  "pending": zod.int().min(getTenderOpportunityResponseOpportunityDocumentSummaryPendingMin),
  "needsUpload": zod.int().min(getTenderOpportunityResponseOpportunityDocumentSummaryNeedsUploadMin),
  "failed": zod.int().min(getTenderOpportunityResponseOpportunityDocumentSummaryFailedMin),
  "autoAcquired": zod.int().min(getTenderOpportunityResponseOpportunityDocumentSummaryAutoAcquiredMin)
}).describe('Counts of the opportunity\'s documents by acquisition state, so lists can show whether documents are ready or need uploading.'),
  "revision": zod.int().min(1),
  "firstSeenAt": zod.iso.datetime({"offset":true}),
  "lastSeenAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "documents": zod.array(zod.object({
  "id": zod.uuid(),
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['rfx', 'addendum', 'attachment', 'response_template', 'other']),
  "title": zod.string(),
  "sourceUrl": zod.string().nullable(),
  "acquisitionStatus": zod.enum(['pending', 'acquired', 'needs_manual_upload', 'failed', 'duplicate']),
  "acquiredVia": zod.enum(['auto', 'browser_worker', 'manual']).nullable(),
  "storageProvider": zod.string().nullable(),
  "contentHash": zod.string().nullable(),
  "sizeBytes": zod.int().nullable(),
  "contentType": zod.string().nullable(),
  "acquiredByAppUserId": zod.uuid().nullable(),
  "acquiredAt": zod.iso.datetime({"offset":true}).nullable(),
  "extractedTextStatus": zod.enum(['not_started', 'pending', 'ready', 'failed', 'unsupported']),
  "filename": zod.string().nullable(),
  "acquiredByName": zod.string().nullable().describe('Display name of the staff member who uploaded a manual document.'),
  "acquisitionDetail": zod.string().nullable().describe('Plain-language reason for the current acquisition state.'),
  "attemptCount": zod.int().min(getTenderOpportunityResponseDocumentsItemAttemptCountMin),
  "duplicateOfDocumentId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "recentEvents": zod.array(zod.object({
  "id": zod.uuid(),
  "opportunityId": zod.uuid(),
  "type": zod.enum(['discovered', 'updated', 'ranked', 're_ranked', 'document_added', 'status_changed', 'assigned', 'converted', 'digest_sent', 'dismissed', 'restored', 'expired']),
  "actorAppUserId": zod.uuid().nullable(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "createdAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Change a tender opportunity's review status or assignee. Converted and expired opportunities cannot be changed; dismissed ones can be restored.
 */
export const updateTenderOpportunityParams = zod.object({
  "id": zod.uuid()
})


export const updateTenderOpportunityBodyNoteMax = 2000;



export const updateTenderOpportunityBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "status": zod.enum(['new', 'reviewing', 'shortlisted', 'low_match', 'dismissed']).optional().describe('Statuses staff may set directly. Converted is set by the conversion flow and expired by the closing-date check.'),
  "assignedAppUserId": zod.uuid().nullish(),
  "note": zod.string().max(updateTenderOpportunityBodyNoteMax).optional()
})

export const updateTenderOpportunityResponseMatchScoreMin = 0;
export const updateTenderOpportunityResponseMatchScoreMax = 100;

export const updateTenderOpportunityResponseDocumentSummaryTotalMin = 0;

export const updateTenderOpportunityResponseDocumentSummaryAcquiredMin = 0;

export const updateTenderOpportunityResponseDocumentSummaryPendingMin = 0;

export const updateTenderOpportunityResponseDocumentSummaryNeedsUploadMin = 0;

export const updateTenderOpportunityResponseDocumentSummaryFailedMin = 0;

export const updateTenderOpportunityResponseDocumentSummaryAutoAcquiredMin = 0;




export const updateTenderOpportunityResponse = zod.object({
  "id": zod.uuid(),
  "portalKey": zod.string(),
  "portalReference": zod.string(),
  "canonicalUrl": zod.string(),
  "title": zod.string(),
  "buyerName": zod.string().nullable(),
  "buyerAbn": zod.string().nullable(),
  "jurisdiction": zod.string().nullable(),
  "categoryCodes": zod.array(zod.string()),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "briefingAt": zod.iso.datetime({"offset":true}).nullable(),
  "estimatedValue": zod.number().nullable(),
  "summaryMd": zod.string(),
  "status": zod.enum(['new', 'reviewing', 'shortlisted', 'low_match', 'dismissed', 'converted', 'expired']),
  "matchScore": zod.int().min(updateTenderOpportunityResponseMatchScoreMin).max(updateTenderOpportunityResponseMatchScoreMax).nullable(),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "matchReasons": zod.array(zod.string()),
  "disqualifiers": zod.array(zod.string()),
  "suggestedProposalType": zod.enum(['tender', 'sow']).nullable(),
  "matchConfidence": zod.enum(['high', 'medium', 'low']).nullable().describe('How much to trust the ranking. Low when the AI service was unavailable and keyword scoring was used.'),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]).optional().describe('Bid/no-bid recommendation from the bid rules and Offerings Profile. People decide; Not for us is kept and only hidden by default.'),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]).optional().describe('prefilter when a bid rule filtered the tender without an AI call, ai for an AI assessment, keyword for the AI-unavailable fallback.'),
  "rankedAt": zod.iso.datetime({"offset":true}).nullable(),
  "assignedAppUserId": zod.uuid().nullable(),
  "assigneeName": zod.string().nullable(),
  "candidateId": zod.uuid().nullable(),
  "sourceId": zod.uuid().nullable(),
  "observationId": zod.uuid().nullable(),
  "assessmentId": zod.uuid().nullable(),
  "pursuitId": zod.uuid().nullable(),
  "tenderId": zod.uuid().nullable(),
  "pipelineOpportunityId": zod.uuid().nullable(),
  "accountId": zod.uuid().nullable().describe('Buyer account matched or created when the opportunity was converted.'),
  "convertedAt": zod.iso.datetime({"offset":true}).nullable(),
  "seenByMe": zod.boolean(),
  "hasNewAddenda": zod.boolean().describe('A re-scan added an addendum that staff have not yet viewed.'),
  "documentSummary": zod.object({
  "total": zod.int().min(updateTenderOpportunityResponseDocumentSummaryTotalMin),
  "acquired": zod.int().min(updateTenderOpportunityResponseDocumentSummaryAcquiredMin),
  "pending": zod.int().min(updateTenderOpportunityResponseDocumentSummaryPendingMin),
  "needsUpload": zod.int().min(updateTenderOpportunityResponseDocumentSummaryNeedsUploadMin),
  "failed": zod.int().min(updateTenderOpportunityResponseDocumentSummaryFailedMin),
  "autoAcquired": zod.int().min(updateTenderOpportunityResponseDocumentSummaryAutoAcquiredMin)
}).describe('Counts of the opportunity\'s documents by acquisition state, so lists can show whether documents are ready or need uploading.'),
  "revision": zod.int().min(1),
  "firstSeenAt": zod.iso.datetime({"offset":true}),
  "lastSeenAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Respond to a tender opportunity: create the tender/SOW response with its documents, match or create the buyer account, add a linked pipeline opportunity and mark the opportunity converted. Idempotent by request key.
 */
export const convertTenderOpportunityParams = zod.object({
  "id": zod.uuid()
})


export const convertTenderOpportunityBodyTitleMax = 300;

export const convertTenderOpportunityBodyNewAccountNameMax = 200;

export const convertTenderOpportunityBodyEstimatedValueMin = 0;

export const convertTenderOpportunityBodyDocumentIdsMax = 100;



export const convertTenderOpportunityBody = zod.object({
  "requestKey": zod.uuid().describe('Client-generated key; retrying with the same key never duplicates records.'),
  "expectedRevision": zod.int().min(1),
  "proposalType": zod.enum(['tender', 'sow']),
  "title": zod.string().min(1).max(convertTenderOpportunityBodyTitleMax),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "ownerAppUserId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish().describe('Existing buyer account. Leave empty and supply newAccountName to create the buyer.'),
  "newAccountName": zod.string().min(1).max(convertTenderOpportunityBodyNewAccountNameMax).nullish().describe('Name for a new buyer account. An existing account with exactly this name is reused instead.'),
  "pipelineStage": zod.union([zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']),zod.null()]).optional(),
  "estimatedValue": zod.number().min(convertTenderOpportunityBodyEstimatedValueMin).nullish(),
  "documentIds": zod.array(zod.uuid()).max(convertTenderOpportunityBodyDocumentIdsMax).describe('Acquired opportunity documents to attach to the response. May be empty.')
})

export const convertTenderOpportunityResponseOpportunityMatchScoreMin = 0;
export const convertTenderOpportunityResponseOpportunityMatchScoreMax = 100;

export const convertTenderOpportunityResponseOpportunityDocumentSummaryTotalMin = 0;

export const convertTenderOpportunityResponseOpportunityDocumentSummaryAcquiredMin = 0;

export const convertTenderOpportunityResponseOpportunityDocumentSummaryPendingMin = 0;

export const convertTenderOpportunityResponseOpportunityDocumentSummaryNeedsUploadMin = 0;

export const convertTenderOpportunityResponseOpportunityDocumentSummaryFailedMin = 0;

export const convertTenderOpportunityResponseOpportunityDocumentSummaryAutoAcquiredMin = 0;


export const convertTenderOpportunityResponseDocumentsSelectedMin = 0;

export const convertTenderOpportunityResponseDocumentsAttachedMin = 0;

export const convertTenderOpportunityResponseDocumentsFailedMin = 0;



export const convertTenderOpportunityResponse = zod.object({
  "opportunity": zod.object({
  "id": zod.uuid(),
  "portalKey": zod.string(),
  "portalReference": zod.string(),
  "canonicalUrl": zod.string(),
  "title": zod.string(),
  "buyerName": zod.string().nullable(),
  "buyerAbn": zod.string().nullable(),
  "jurisdiction": zod.string().nullable(),
  "categoryCodes": zod.array(zod.string()),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "briefingAt": zod.iso.datetime({"offset":true}).nullable(),
  "estimatedValue": zod.number().nullable(),
  "summaryMd": zod.string(),
  "status": zod.enum(['new', 'reviewing', 'shortlisted', 'low_match', 'dismissed', 'converted', 'expired']),
  "matchScore": zod.int().min(convertTenderOpportunityResponseOpportunityMatchScoreMin).max(convertTenderOpportunityResponseOpportunityMatchScoreMax).nullable(),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "matchReasons": zod.array(zod.string()),
  "disqualifiers": zod.array(zod.string()),
  "suggestedProposalType": zod.enum(['tender', 'sow']).nullable(),
  "matchConfidence": zod.enum(['high', 'medium', 'low']).nullable().describe('How much to trust the ranking. Low when the AI service was unavailable and keyword scoring was used.'),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]).optional().describe('Bid/no-bid recommendation from the bid rules and Offerings Profile. People decide; Not for us is kept and only hidden by default.'),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]).optional().describe('prefilter when a bid rule filtered the tender without an AI call, ai for an AI assessment, keyword for the AI-unavailable fallback.'),
  "rankedAt": zod.iso.datetime({"offset":true}).nullable(),
  "assignedAppUserId": zod.uuid().nullable(),
  "assigneeName": zod.string().nullable(),
  "candidateId": zod.uuid().nullable(),
  "sourceId": zod.uuid().nullable(),
  "observationId": zod.uuid().nullable(),
  "assessmentId": zod.uuid().nullable(),
  "pursuitId": zod.uuid().nullable(),
  "tenderId": zod.uuid().nullable(),
  "pipelineOpportunityId": zod.uuid().nullable(),
  "accountId": zod.uuid().nullable().describe('Buyer account matched or created when the opportunity was converted.'),
  "convertedAt": zod.iso.datetime({"offset":true}).nullable(),
  "seenByMe": zod.boolean(),
  "hasNewAddenda": zod.boolean().describe('A re-scan added an addendum that staff have not yet viewed.'),
  "documentSummary": zod.object({
  "total": zod.int().min(convertTenderOpportunityResponseOpportunityDocumentSummaryTotalMin),
  "acquired": zod.int().min(convertTenderOpportunityResponseOpportunityDocumentSummaryAcquiredMin),
  "pending": zod.int().min(convertTenderOpportunityResponseOpportunityDocumentSummaryPendingMin),
  "needsUpload": zod.int().min(convertTenderOpportunityResponseOpportunityDocumentSummaryNeedsUploadMin),
  "failed": zod.int().min(convertTenderOpportunityResponseOpportunityDocumentSummaryFailedMin),
  "autoAcquired": zod.int().min(convertTenderOpportunityResponseOpportunityDocumentSummaryAutoAcquiredMin)
}).describe('Counts of the opportunity\'s documents by acquisition state, so lists can show whether documents are ready or need uploading.'),
  "revision": zod.int().min(1),
  "firstSeenAt": zod.iso.datetime({"offset":true}),
  "lastSeenAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "replayed": zod.boolean(),
  "path": zod.enum(['preparation', 'direct']).describe('preparation: documents were read by AI tender preparation; direct: the response was created without AI reading.'),
  "tender": zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "proposalType": zod.enum(['tender', 'sow']),
  "link": zod.string()
}),
  "account": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "created": zod.boolean(),
  "link": zod.string()
}),
  "pipelineOpportunity": zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "link": zod.string()
}),
  "pursuit": zod.object({
  "id": zod.uuid(),
  "progress": zod.string()
}).nullable(),
  "documents": zod.object({
  "selected": zod.int().min(convertTenderOpportunityResponseDocumentsSelectedMin),
  "attached": zod.int().min(convertTenderOpportunityResponseDocumentsAttachedMin),
  "failed": zod.int().min(convertTenderOpportunityResponseDocumentsFailedMin)
}),
  "warnings": zod.array(zod.string())
})


/**
 * @summary Queue a fresh match ranking for one tender opportunity against the current Offerings Profile and thresholds.
 */
export const rerankTenderOpportunityParams = zod.object({
  "id": zod.uuid()
})

export const rerankTenderOpportunityResponse = zod.object({
  "opportunityId": zod.uuid(),
  "queuedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Record that the caller has viewed a tender opportunity so it no longer counts as unread for them.
 */
export const markTenderOpportunitySeenParams = zod.object({
  "id": zod.uuid()
})

export const markTenderOpportunitySeenResponseMatchScoreMin = 0;
export const markTenderOpportunitySeenResponseMatchScoreMax = 100;

export const markTenderOpportunitySeenResponseDocumentSummaryTotalMin = 0;

export const markTenderOpportunitySeenResponseDocumentSummaryAcquiredMin = 0;

export const markTenderOpportunitySeenResponseDocumentSummaryPendingMin = 0;

export const markTenderOpportunitySeenResponseDocumentSummaryNeedsUploadMin = 0;

export const markTenderOpportunitySeenResponseDocumentSummaryFailedMin = 0;

export const markTenderOpportunitySeenResponseDocumentSummaryAutoAcquiredMin = 0;




export const markTenderOpportunitySeenResponse = zod.object({
  "id": zod.uuid(),
  "portalKey": zod.string(),
  "portalReference": zod.string(),
  "canonicalUrl": zod.string(),
  "title": zod.string(),
  "buyerName": zod.string().nullable(),
  "buyerAbn": zod.string().nullable(),
  "jurisdiction": zod.string().nullable(),
  "categoryCodes": zod.array(zod.string()),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "briefingAt": zod.iso.datetime({"offset":true}).nullable(),
  "estimatedValue": zod.number().nullable(),
  "summaryMd": zod.string(),
  "status": zod.enum(['new', 'reviewing', 'shortlisted', 'low_match', 'dismissed', 'converted', 'expired']),
  "matchScore": zod.int().min(markTenderOpportunitySeenResponseMatchScoreMin).max(markTenderOpportunitySeenResponseMatchScoreMax).nullable(),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "matchReasons": zod.array(zod.string()),
  "disqualifiers": zod.array(zod.string()),
  "suggestedProposalType": zod.enum(['tender', 'sow']).nullable(),
  "matchConfidence": zod.enum(['high', 'medium', 'low']).nullable().describe('How much to trust the ranking. Low when the AI service was unavailable and keyword scoring was used.'),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]).optional().describe('Bid/no-bid recommendation from the bid rules and Offerings Profile. People decide; Not for us is kept and only hidden by default.'),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]).optional().describe('prefilter when a bid rule filtered the tender without an AI call, ai for an AI assessment, keyword for the AI-unavailable fallback.'),
  "rankedAt": zod.iso.datetime({"offset":true}).nullable(),
  "assignedAppUserId": zod.uuid().nullable(),
  "assigneeName": zod.string().nullable(),
  "candidateId": zod.uuid().nullable(),
  "sourceId": zod.uuid().nullable(),
  "observationId": zod.uuid().nullable(),
  "assessmentId": zod.uuid().nullable(),
  "pursuitId": zod.uuid().nullable(),
  "tenderId": zod.uuid().nullable(),
  "pipelineOpportunityId": zod.uuid().nullable(),
  "accountId": zod.uuid().nullable().describe('Buyer account matched or created when the opportunity was converted.'),
  "convertedAt": zod.iso.datetime({"offset":true}).nullable(),
  "seenByMe": zod.boolean(),
  "hasNewAddenda": zod.boolean().describe('A re-scan added an addendum that staff have not yet viewed.'),
  "documentSummary": zod.object({
  "total": zod.int().min(markTenderOpportunitySeenResponseDocumentSummaryTotalMin),
  "acquired": zod.int().min(markTenderOpportunitySeenResponseDocumentSummaryAcquiredMin),
  "pending": zod.int().min(markTenderOpportunitySeenResponseDocumentSummaryPendingMin),
  "needsUpload": zod.int().min(markTenderOpportunitySeenResponseDocumentSummaryNeedsUploadMin),
  "failed": zod.int().min(markTenderOpportunitySeenResponseDocumentSummaryFailedMin),
  "autoAcquired": zod.int().min(markTenderOpportunitySeenResponseDocumentSummaryAutoAcquiredMin)
}).describe('Counts of the opportunity\'s documents by acquisition state, so lists can show whether documents are ready or need uploading.'),
  "revision": zod.int().min(1),
  "firstSeenAt": zod.iso.datetime({"offset":true}),
  "lastSeenAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List the append-only history of a tender opportunity, newest first.
 */
export const listTenderOpportunityEventsParams = zod.object({
  "id": zod.uuid()
})

export const listTenderOpportunityEventsQueryLimitDefault = 25;
export const listTenderOpportunityEventsQueryLimitMax = 100;

export const listTenderOpportunityEventsQueryOffsetDefault = 0;
export const listTenderOpportunityEventsQueryOffsetMin = 0;



export const listTenderOpportunityEventsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderOpportunityEventsQueryLimitMax).default(listTenderOpportunityEventsQueryLimitDefault),
  "offset": zod.int().min(listTenderOpportunityEventsQueryOffsetMin).default(listTenderOpportunityEventsQueryOffsetDefault)
})

export const listTenderOpportunityEventsResponseTotalMin = 0;



export const listTenderOpportunityEventsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "opportunityId": zod.uuid(),
  "type": zod.enum(['discovered', 'updated', 'ranked', 're_ranked', 'document_added', 'status_changed', 'assigned', 'converted', 'digest_sent', 'dismissed', 'restored', 'expired']),
  "actorAppUserId": zod.uuid().nullable(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderOpportunityEventsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary List the tender documents on an opportunity with how each was acquired.
 */
export const listTenderOpportunityDocumentsParams = zod.object({
  "id": zod.uuid()
})

export const listTenderOpportunityDocumentsQueryLimitDefault = 50;
export const listTenderOpportunityDocumentsQueryLimitMax = 100;

export const listTenderOpportunityDocumentsQueryOffsetDefault = 0;
export const listTenderOpportunityDocumentsQueryOffsetMin = 0;



export const listTenderOpportunityDocumentsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderOpportunityDocumentsQueryLimitMax).default(listTenderOpportunityDocumentsQueryLimitDefault),
  "offset": zod.int().min(listTenderOpportunityDocumentsQueryOffsetMin).default(listTenderOpportunityDocumentsQueryOffsetDefault)
})

export const listTenderOpportunityDocumentsResponseItemsItemAttemptCountMin = 0;

export const listTenderOpportunityDocumentsResponseTotalMin = 0;



export const listTenderOpportunityDocumentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['rfx', 'addendum', 'attachment', 'response_template', 'other']),
  "title": zod.string(),
  "sourceUrl": zod.string().nullable(),
  "acquisitionStatus": zod.enum(['pending', 'acquired', 'needs_manual_upload', 'failed', 'duplicate']),
  "acquiredVia": zod.enum(['auto', 'browser_worker', 'manual']).nullable(),
  "storageProvider": zod.string().nullable(),
  "contentHash": zod.string().nullable(),
  "sizeBytes": zod.int().nullable(),
  "contentType": zod.string().nullable(),
  "acquiredByAppUserId": zod.uuid().nullable(),
  "acquiredAt": zod.iso.datetime({"offset":true}).nullable(),
  "extractedTextStatus": zod.enum(['not_started', 'pending', 'ready', 'failed', 'unsupported']),
  "filename": zod.string().nullable(),
  "acquiredByName": zod.string().nullable().describe('Display name of the staff member who uploaded a manual document.'),
  "acquisitionDetail": zod.string().nullable().describe('Plain-language reason for the current acquisition state.'),
  "attemptCount": zod.int().min(listTenderOpportunityDocumentsResponseItemsItemAttemptCountMin),
  "duplicateOfDocumentId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderOpportunityDocumentsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary Upload a tender document from the portal (up to 20 MB). Uploading the same file again returns the existing document.
 */
export const uploadTenderOpportunityDocumentParams = zod.object({
  "id": zod.uuid()
})

export const uploadTenderOpportunityDocumentBodyFilenameMax = 255;

export const uploadTenderOpportunityDocumentBodyContentTypeMax = 200;

export const uploadTenderOpportunityDocumentBodyDataBase64Min = 4;
export const uploadTenderOpportunityDocumentBodyDataBase64Max = 27962028;

export const uploadTenderOpportunityDocumentBodyTitleMax = 500;



export const uploadTenderOpportunityDocumentBody = zod.object({
  "filename": zod.string().min(1).max(uploadTenderOpportunityDocumentBodyFilenameMax),
  "contentType": zod.string().min(1).max(uploadTenderOpportunityDocumentBodyContentTypeMax),
  "dataBase64": zod.string().min(uploadTenderOpportunityDocumentBodyDataBase64Min).max(uploadTenderOpportunityDocumentBodyDataBase64Max).describe('Base64-encoded file bytes.'),
  "kind": zod.enum(['rfx', 'addendum', 'attachment', 'response_template', 'other']).optional(),
  "title": zod.string().min(1).max(uploadTenderOpportunityDocumentBodyTitleMax).optional(),
  "documentId": zod.uuid().optional().describe('Portal document this upload fulfils (for example one that needs sign-in to download).')
})

export const uploadTenderOpportunityDocumentResponseDocumentAttemptCountMin = 0;



export const uploadTenderOpportunityDocumentResponse = zod.object({
  "document": zod.object({
  "id": zod.uuid(),
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['rfx', 'addendum', 'attachment', 'response_template', 'other']),
  "title": zod.string(),
  "sourceUrl": zod.string().nullable(),
  "acquisitionStatus": zod.enum(['pending', 'acquired', 'needs_manual_upload', 'failed', 'duplicate']),
  "acquiredVia": zod.enum(['auto', 'browser_worker', 'manual']).nullable(),
  "storageProvider": zod.string().nullable(),
  "contentHash": zod.string().nullable(),
  "sizeBytes": zod.int().nullable(),
  "contentType": zod.string().nullable(),
  "acquiredByAppUserId": zod.uuid().nullable(),
  "acquiredAt": zod.iso.datetime({"offset":true}).nullable(),
  "extractedTextStatus": zod.enum(['not_started', 'pending', 'ready', 'failed', 'unsupported']),
  "filename": zod.string().nullable(),
  "acquiredByName": zod.string().nullable().describe('Display name of the staff member who uploaded a manual document.'),
  "acquisitionDetail": zod.string().nullable().describe('Plain-language reason for the current acquisition state.'),
  "attemptCount": zod.int().min(uploadTenderOpportunityDocumentResponseDocumentAttemptCountMin),
  "duplicateOfDocumentId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "duplicate": zod.boolean().describe('The same file was already held on this opportunity; the existing document is returned.')
})


/**
 * @summary Remove a document that staff uploaded by hand. Portal documents cannot be removed.
 */
export const deleteTenderOpportunityDocumentParams = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid()
})

export const deleteTenderOpportunityDocumentResponse = zod.void()


/**
 * @summary Download the stored bytes of one acquired tender opportunity document
 */
export const downloadTenderOpportunityDocumentParams = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid()
})

export const downloadTenderOpportunityDocumentResponse = zod.unknown()


/**
 * @summary Queue another download attempt for a portal document that failed or needs sign-in.
 */
export const retryTenderOpportunityDocumentParams = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid()
})

export const retryTenderOpportunityDocumentResponseAttemptCountMin = 0;



export const retryTenderOpportunityDocumentResponse = zod.object({
  "id": zod.uuid(),
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['rfx', 'addendum', 'attachment', 'response_template', 'other']),
  "title": zod.string(),
  "sourceUrl": zod.string().nullable(),
  "acquisitionStatus": zod.enum(['pending', 'acquired', 'needs_manual_upload', 'failed', 'duplicate']),
  "acquiredVia": zod.enum(['auto', 'browser_worker', 'manual']).nullable(),
  "storageProvider": zod.string().nullable(),
  "contentHash": zod.string().nullable(),
  "sizeBytes": zod.int().nullable(),
  "contentType": zod.string().nullable(),
  "acquiredByAppUserId": zod.uuid().nullable(),
  "acquiredAt": zod.iso.datetime({"offset":true}).nullable(),
  "extractedTextStatus": zod.enum(['not_started', 'pending', 'ready', 'failed', 'unsupported']),
  "filename": zod.string().nullable(),
  "acquiredByName": zod.string().nullable().describe('Display name of the staff member who uploaded a manual document.'),
  "acquisitionDetail": zod.string().nullable().describe('Plain-language reason for the current acquisition state.'),
  "attemptCount": zod.int().min(retryTenderOpportunityDocumentResponseAttemptCountMin),
  "duplicateOfDocumentId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const createGovernmentPursuitTaskParams = zod.object({
  "id": zod.uuid()
})


export const createGovernmentPursuitTaskBodyTitleMax = 200;

export const createGovernmentPursuitTaskBodyBodyMax = 5000;



export const createGovernmentPursuitTaskBody = zod.object({
  "requestKey": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "title": zod.string().min(1).max(createGovernmentPursuitTaskBodyTitleMax),
  "body": zod.string().min(1).max(createGovernmentPursuitTaskBodyBodyMax),
  "ownerAppUserId": zod.uuid().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable()
})


export const createGovernmentPursuitTaskResponseDurationMinutesMin = 0;

export const createGovernmentPursuitTaskResponseIsTestDataDefault = false;

export const createGovernmentPursuitTaskResponse = zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(createGovernmentPursuitTaskResponseDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(createGovernmentPursuitTaskResponseIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


export const getGovernmentSourceSuggestionsResponseItemsItemKeyMax = 200;

export const getGovernmentSourceSuggestionsResponseItemsItemNameMax = 500;

export const getGovernmentSourceSuggestionsResponseItemsItemConfigurationAdministeringBodyMax = 500;

export const getGovernmentSourceSuggestionsResponseItemsItemConfigurationLocalJurisdictionOneIdMax = 100;


export const getGovernmentSourceSuggestionsResponseItemsItemConfigurationLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const getGovernmentSourceSuggestionsResponseItemsItemConfigurationLocalJurisdictionOneNameMax = 200;

export const getGovernmentSourceSuggestionsResponseItemsItemConfigurationCategoriesMax = 8;

export const getGovernmentSourceSuggestionsResponseItemsItemNoteMax = 2000;

export const getGovernmentSourceSuggestionsResponseItemsItemConnectorKeyMax = 80;

export const getGovernmentSourceSuggestionsResponseItemsMax = 30;

export const getGovernmentSourceSuggestionsResponseGapsItemMax = 1000;

export const getGovernmentSourceSuggestionsResponseGapsMax = 100;



export const getGovernmentSourceSuggestionsResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string().max(getGovernmentSourceSuggestionsResponseItemsItemKeyMax),
  "name": zod.string().max(getGovernmentSourceSuggestionsResponseItemsItemNameMax),
  "url": zod.url(),
  "configuration": zod.object({
  "administeringBody": zod.string().min(1).max(getGovernmentSourceSuggestionsResponseItemsItemConfigurationAdministeringBodyMax),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(getGovernmentSourceSuggestionsResponseItemsItemConfigurationLocalJurisdictionOneIdMax).regex(getGovernmentSourceSuggestionsResponseItemsItemConfigurationLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(getGovernmentSourceSuggestionsResponseItemsItemConfigurationLocalJurisdictionOneNameMax)
}),zod.null()]),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).min(1).max(getGovernmentSourceSuggestionsResponseItemsItemConfigurationCategoriesMax)
}),
  "verification": zod.enum(['accessible', 'entry_point_only']),
  "note": zod.string().max(getGovernmentSourceSuggestionsResponseItemsItemNoteMax),
  "connectorKey": zod.string().max(getGovernmentSourceSuggestionsResponseItemsItemConnectorKeyMax).nullish().describe('Built-in tender portal connector that can monitor this source from Web Signals tender portals.')
})).max(getGovernmentSourceSuggestionsResponseItemsMax),
  "gaps": zod.array(zod.string().max(getGovernmentSourceSuggestionsResponseGapsItemMax)).max(getGovernmentSourceSuggestionsResponseGapsMax)
})


export const getGovernmentDiscoveryCoverageQueryLimitDefault = 20;
export const getGovernmentDiscoveryCoverageQueryLimitMax = 50;

export const getGovernmentDiscoveryCoverageQueryOffsetDefault = 0;
export const getGovernmentDiscoveryCoverageQueryOffsetMin = 0;



export const getGovernmentDiscoveryCoverageQueryParams = zod.object({
  "limit": zod.int().min(1).max(getGovernmentDiscoveryCoverageQueryLimitMax).default(getGovernmentDiscoveryCoverageQueryLimitDefault),
  "offset": zod.int().min(getGovernmentDiscoveryCoverageQueryOffsetMin).default(getGovernmentDiscoveryCoverageQueryOffsetDefault)
})

export const getGovernmentDiscoveryCoverageResponseConfigurationLocalRevisionMin = 0;

export const getGovernmentDiscoveryCoverageResponseConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentDiscoveryCoverageResponseConfigurationRevisionsItemRevisionMin = 0;

export const getGovernmentDiscoveryCoverageResponseConfigurationRevisionsMax = 2;

export const getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneStatesMax = 8;

export const getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneLocalJurisdictionsItemIdMax = 100;


export const getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneLocalJurisdictionsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneLocalJurisdictionsItemNameMax = 200;

export const getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneLocalJurisdictionsMax = 100;

export const getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneCategoriesMax = 8;

export const getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneStatesMax = 8;

export const getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneLocalJurisdictionsItemIdMax = 100;


export const getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneLocalJurisdictionsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneLocalJurisdictionsItemNameMax = 200;

export const getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneLocalJurisdictionsMax = 100;

export const getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneCategoriesMax = 8;

export const getGovernmentDiscoveryCoverageResponseSourcesItemNameMax = 500;

export const getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationAdministeringBodyMax = 500;

export const getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationLocalJurisdictionOneIdMax = 100;


export const getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationLocalJurisdictionOneNameMax = 200;

export const getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationCategoriesMax = 8;

export const getGovernmentDiscoveryCoverageResponseSourcesItemStatusMax = 200;

export const getGovernmentDiscoveryCoverageResponseSourcesItemReadinessMax = 200;

export const getGovernmentDiscoveryCoverageResponseSourcesItemCodeMax = 200;

export const getGovernmentDiscoveryCoverageResponseSourcesItemLastRunStatusMax = 200;

export const getGovernmentDiscoveryCoverageResponseSourcesMax = 50;

export const getGovernmentDiscoveryCoverageResponseGapsItemMax = 1000;

export const getGovernmentDiscoveryCoverageResponseGapsMax = 100;

export const getGovernmentDiscoveryCoverageResponseTotalMin = 0;


export const getGovernmentDiscoveryCoverageResponseOffsetMin = 0;



export const getGovernmentDiscoveryCoverageResponse = zod.object({
  "configuration": zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "localRevision": zod.int().min(getGovernmentDiscoveryCoverageResponseConfigurationLocalRevisionMin),
  "fingerprint": zod.string().regex(getGovernmentDiscoveryCoverageResponseConfigurationFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getGovernmentDiscoveryCoverageResponseConfigurationRevisionsItemRevisionMin)
})).max(getGovernmentDiscoveryCoverageResponseConfigurationRevisionsMax),
  "localCoverage": zod.union([zod.object({
  "country": zod.enum(['AU']),
  "federal": zod.boolean(),
  "states": zod.array(zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'])).max(getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneStatesMax),
  "localMode": zod.enum(['none', 'all', 'selected']),
  "localJurisdictions": zod.array(zod.object({
  "id": zod.string().min(1).max(getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneLocalJurisdictionsItemIdMax).regex(getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneLocalJurisdictionsItemIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneLocalJurisdictionsItemNameMax)
})).max(getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneLocalJurisdictionsMax),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).max(getGovernmentDiscoveryCoverageResponseConfigurationLocalCoverageOneCategoriesMax)
}),zod.null()]),
  "effectiveCoverage": zod.union([zod.object({
  "country": zod.enum(['AU']),
  "federal": zod.boolean(),
  "states": zod.array(zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'])).max(getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneStatesMax),
  "localMode": zod.enum(['none', 'all', 'selected']),
  "localJurisdictions": zod.array(zod.object({
  "id": zod.string().min(1).max(getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneLocalJurisdictionsItemIdMax).regex(getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneLocalJurisdictionsItemIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneLocalJurisdictionsItemNameMax)
})).max(getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneLocalJurisdictionsMax),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).max(getGovernmentDiscoveryCoverageResponseConfigurationEffectiveCoverageOneCategoriesMax)
}),zod.null()]),
  "origin": zod.enum(['setup_required', 'tenant', 'entity']),
  "readiness": zod.enum(['setup_required', 'configured'])
}),
  "sources": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "name": zod.string().max(getGovernmentDiscoveryCoverageResponseSourcesItemNameMax),
  "configuration": zod.object({
  "administeringBody": zod.string().min(1).max(getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationAdministeringBodyMax),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationLocalJurisdictionOneIdMax).regex(getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationLocalJurisdictionOneNameMax)
}),zod.null()]),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).min(1).max(getGovernmentDiscoveryCoverageResponseSourcesItemConfigurationCategoriesMax)
}),
  "status": zod.string().max(getGovernmentDiscoveryCoverageResponseSourcesItemStatusMax),
  "readiness": zod.string().max(getGovernmentDiscoveryCoverageResponseSourcesItemReadinessMax),
  "code": zod.string().max(getGovernmentDiscoveryCoverageResponseSourcesItemCodeMax).nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastRunStatus": zod.string().max(getGovernmentDiscoveryCoverageResponseSourcesItemLastRunStatusMax).nullable(),
  "partial": zod.boolean()
})).max(getGovernmentDiscoveryCoverageResponseSourcesMax),
  "gaps": zod.array(zod.string().max(getGovernmentDiscoveryCoverageResponseGapsItemMax)).max(getGovernmentDiscoveryCoverageResponseGapsMax),
  "exhaustive": zod.literal(false),
  "providerDispatch": zod.enum(['not_used']),
  "total": zod.int().min(getGovernmentDiscoveryCoverageResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getGovernmentDiscoveryCoverageResponseOffsetMin)
})


export const listGovernmentFindingsQueryLimitDefault = 20;
export const listGovernmentFindingsQueryLimitMax = 50;

export const listGovernmentFindingsQueryOffsetDefault = 0;
export const listGovernmentFindingsQueryOffsetMin = 0;



export const listGovernmentFindingsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listGovernmentFindingsQueryLimitMax).default(listGovernmentFindingsQueryLimitDefault),
  "offset": zod.int().min(listGovernmentFindingsQueryOffsetMin).default(listGovernmentFindingsQueryOffsetDefault),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).optional(),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']).optional(),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']).optional(),
  "applicationStatus": zod.enum(['unknown', 'upcoming', 'open', 'closed', 'ongoing', 'suspended']).optional(),
  "relevance": zod.enum(['potential', 'not_relevant', 'unknown']).optional()
})


export const listGovernmentFindingsResponseItemsItemObservationOfficialProgramIdMax = 200;

export const listGovernmentFindingsResponseItemsItemObservationRoundIdMax = 200;

export const listGovernmentFindingsResponseItemsItemObservationIdentityKeyRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentFindingsResponseItemsItemObservationTitleMax = 500;

export const listGovernmentFindingsResponseItemsItemObservationAdministeringBodyMax = 500;

export const listGovernmentFindingsResponseItemsItemObservationOfficialUrlMax = 2048;

export const listGovernmentFindingsResponseItemsItemObservationLocalJurisdictionOneIdMax = 100;


export const listGovernmentFindingsResponseItemsItemObservationLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const listGovernmentFindingsResponseItemsItemObservationLocalJurisdictionOneNameMax = 200;

export const listGovernmentFindingsResponseItemsItemObservationTimezoneMax = 100;

export const listGovernmentFindingsResponseItemsItemObservationBenefitsMax = 10000;

export const listGovernmentFindingsResponseItemsItemObservationCriteriaItemIdMax = 100;

export const listGovernmentFindingsResponseItemsItemObservationCriteriaItemTextMax = 10000;

export const listGovernmentFindingsResponseItemsItemObservationCriteriaItemEvidenceQuoteMax = 10000;




export const listGovernmentFindingsResponseItemsItemObservationCriteriaItemEvidenceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentFindingsResponseItemsItemObservationCriteriaItemEvidenceUrlMax = 2048;

export const listGovernmentFindingsResponseItemsItemObservationCriteriaMax = 100;




export const listGovernmentFindingsResponseItemsItemObservationSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentFindingsResponseItemsItemObservationSourceUrlMax = 2048;

export const listGovernmentFindingsResponseItemsItemObservationMetadataEvidenceItemFieldMax = 100;

export const listGovernmentFindingsResponseItemsItemObservationMetadataEvidenceItemQuoteMax = 10000;

export const listGovernmentFindingsResponseItemsItemObservationMetadataEvidenceMax = 30;





export const listGovernmentFindingsResponseItemsItemAssessmentOnePinsSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentFindingsResponseItemsItemAssessmentOnePinsSourceUrlMax = 2048;

export const listGovernmentFindingsResponseItemsItemAssessmentOnePinsProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listGovernmentFindingsResponseItemsItemAssessmentOnePinsConfigurationFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentFindingsResponseItemsItemAssessmentOnePinsConfigurationRevisionsItemRevisionMin = 0;

export const listGovernmentFindingsResponseItemsItemAssessmentOnePinsConfigurationRevisionsMax = 2;

export const listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemCriterionIdMax = 100;

export const listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemReasonMax = 10000;

export const listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemFactKeysItemMax = 200;

export const listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemFactKeysMax = 100;




export const listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemCitationsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemCitationsItemUrlMax = 2048;

export const listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemCitationsMax = 100;

export const listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaMax = 100;

export const listGovernmentFindingsResponseItemsItemAssessmentOneMissingFactsItemMax = 1000;

export const listGovernmentFindingsResponseItemsItemAssessmentOneMissingFactsMax = 100;

export const listGovernmentFindingsResponseItemsItemWarningsItemMax = 1000;

export const listGovernmentFindingsResponseItemsItemWarningsMax = 100;

export const listGovernmentFindingsResponseItemsMax = 50;



export const listGovernmentFindingsResponse = zod.object({
  "items": zod.array(zod.object({
  "observation": zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "revision": zod.int().min(1),
  "officialProgramId": zod.string().max(listGovernmentFindingsResponseItemsItemObservationOfficialProgramIdMax).nullable(),
  "roundId": zod.string().max(listGovernmentFindingsResponseItemsItemObservationRoundIdMax).nullable(),
  "identityKey": zod.string().regex(listGovernmentFindingsResponseItemsItemObservationIdentityKeyRegExp),
  "title": zod.string().min(1).max(listGovernmentFindingsResponseItemsItemObservationTitleMax),
  "administeringBody": zod.string().min(1).max(listGovernmentFindingsResponseItemsItemObservationAdministeringBodyMax),
  "officialUrl": zod.url().max(listGovernmentFindingsResponseItemsItemObservationOfficialUrlMax),
  "category": zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.'),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(listGovernmentFindingsResponseItemsItemObservationLocalJurisdictionOneIdMax).regex(listGovernmentFindingsResponseItemsItemObservationLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(listGovernmentFindingsResponseItemsItemObservationLocalJurisdictionOneNameMax)
}),zod.null()]),
  "applicationStatus": zod.enum(['unknown', 'upcoming', 'open', 'closed', 'ongoing', 'suspended']),
  "opensAt": zod.iso.datetime({"offset":true}).nullable(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "timezone": zod.string().max(listGovernmentFindingsResponseItemsItemObservationTimezoneMax).nullable(),
  "benefits": zod.string().max(listGovernmentFindingsResponseItemsItemObservationBenefitsMax).nullable(),
  "criteria": zod.array(zod.object({
  "id": zod.string().min(1).max(listGovernmentFindingsResponseItemsItemObservationCriteriaItemIdMax),
  "text": zod.string().min(1).max(listGovernmentFindingsResponseItemsItemObservationCriteriaItemTextMax),
  "evidenceQuote": zod.string().min(1).max(listGovernmentFindingsResponseItemsItemObservationCriteriaItemEvidenceQuoteMax),
  "evidence": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentFindingsResponseItemsItemObservationCriteriaItemEvidenceContentHashRegExp),
  "url": zod.url().max(listGovernmentFindingsResponseItemsItemObservationCriteriaItemEvidenceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})
})).max(listGovernmentFindingsResponseItemsItemObservationCriteriaMax),
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentFindingsResponseItemsItemObservationSourceContentHashRegExp),
  "url": zod.url().max(listGovernmentFindingsResponseItemsItemObservationSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "effectiveAt": zod.iso.datetime({"offset":true}).nullable(),
  "metadataEvidence": zod.array(zod.object({
  "field": zod.string().max(listGovernmentFindingsResponseItemsItemObservationMetadataEvidenceItemFieldMax),
  "quote": zod.string().min(1).max(listGovernmentFindingsResponseItemsItemObservationMetadataEvidenceItemQuoteMax)
})).max(listGovernmentFindingsResponseItemsItemObservationMetadataEvidenceMax),
  "checkedAt": zod.iso.datetime({"offset":true})
}),
  "assessment": zod.union([zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "candidateId": zod.uuid(),
  "observationId": zod.uuid(),
  "revision": zod.int().min(1),
  "pins": zod.object({
  "source": zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentFindingsResponseItemsItemAssessmentOnePinsSourceContentHashRegExp),
  "url": zod.url().max(listGovernmentFindingsResponseItemsItemAssessmentOnePinsSourceUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
}),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(listGovernmentFindingsResponseItemsItemAssessmentOnePinsProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "configurationFingerprint": zod.string().regex(listGovernmentFindingsResponseItemsItemAssessmentOnePinsConfigurationFingerprintRegExp),
  "configurationRevisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(listGovernmentFindingsResponseItemsItemAssessmentOnePinsConfigurationRevisionsItemRevisionMin)
})).max(listGovernmentFindingsResponseItemsItemAssessmentOnePinsConfigurationRevisionsMax)
}),
  "relevance": zod.enum(['potential', 'not_relevant', 'unknown']),
  "criteria": zod.array(zod.object({
  "criterionId": zod.string().max(listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemCriterionIdMax),
  "status": zod.enum(['supported', 'unmet', 'unknown', 'conflicting', 'expired']),
  "reason": zod.string().min(1).max(listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemReasonMax),
  "factKeys": zod.array(zod.string().max(listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemFactKeysItemMax)).max(listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemFactKeysMax),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid().nullable(),
  "recipeRevision": zod.int().min(1).nullable(),
  "scanRunId": zod.uuid().nullable(),
  "evidenceId": zod.uuid(),
  "evidenceRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemCitationsItemContentHashRegExp),
  "url": zod.url().max(listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemCitationsItemUrlMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaItemCitationsMax)
})).max(listGovernmentFindingsResponseItemsItemAssessmentOneCriteriaMax),
  "missingFacts": zod.array(zod.string().max(listGovernmentFindingsResponseItemsItemAssessmentOneMissingFactsItemMax)).max(listGovernmentFindingsResponseItemsItemAssessmentOneMissingFactsMax),
  "assessedAt": zod.iso.datetime({"offset":true}),
  "eligibilityDetermination": zod.literal(false)
}),zod.null()]),
  "freshness": zod.enum(['current', 'stale', 'expired']),
  "warnings": zod.array(zod.string().max(listGovernmentFindingsResponseItemsItemWarningsItemMax)).max(listGovernmentFindingsResponseItemsItemWarningsMax)
})).max(listGovernmentFindingsResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary Read administrator jurisdiction settings
 */
export const getGovernmentJurisdictionsParams = zod.object({
  "scope": zod.enum(['tenant', 'entity'])
})

export const getGovernmentJurisdictionsResponseLocalRevisionMin = 0;

export const getGovernmentJurisdictionsResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGovernmentJurisdictionsResponseRevisionsItemRevisionMin = 0;

export const getGovernmentJurisdictionsResponseRevisionsMax = 2;

export const getGovernmentJurisdictionsResponseLocalCoverageOneStatesMax = 8;

export const getGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdMax = 100;


export const getGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const getGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemNameMax = 200;

export const getGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsMax = 100;

export const getGovernmentJurisdictionsResponseLocalCoverageOneCategoriesMax = 8;

export const getGovernmentJurisdictionsResponseEffectiveCoverageOneStatesMax = 8;

export const getGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdMax = 100;


export const getGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const getGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemNameMax = 200;

export const getGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsMax = 100;

export const getGovernmentJurisdictionsResponseEffectiveCoverageOneCategoriesMax = 8;



export const getGovernmentJurisdictionsResponse = zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "localRevision": zod.int().min(getGovernmentJurisdictionsResponseLocalRevisionMin),
  "fingerprint": zod.string().regex(getGovernmentJurisdictionsResponseFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getGovernmentJurisdictionsResponseRevisionsItemRevisionMin)
})).max(getGovernmentJurisdictionsResponseRevisionsMax),
  "localCoverage": zod.union([zod.object({
  "country": zod.enum(['AU']),
  "federal": zod.boolean(),
  "states": zod.array(zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'])).max(getGovernmentJurisdictionsResponseLocalCoverageOneStatesMax),
  "localMode": zod.enum(['none', 'all', 'selected']),
  "localJurisdictions": zod.array(zod.object({
  "id": zod.string().min(1).max(getGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdMax).regex(getGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(getGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemNameMax)
})).max(getGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsMax),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).max(getGovernmentJurisdictionsResponseLocalCoverageOneCategoriesMax)
}),zod.null()]),
  "effectiveCoverage": zod.union([zod.object({
  "country": zod.enum(['AU']),
  "federal": zod.boolean(),
  "states": zod.array(zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'])).max(getGovernmentJurisdictionsResponseEffectiveCoverageOneStatesMax),
  "localMode": zod.enum(['none', 'all', 'selected']),
  "localJurisdictions": zod.array(zod.object({
  "id": zod.string().min(1).max(getGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdMax).regex(getGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(getGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemNameMax)
})).max(getGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsMax),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).max(getGovernmentJurisdictionsResponseEffectiveCoverageOneCategoriesMax)
}),zod.null()]),
  "origin": zod.enum(['setup_required', 'tenant', 'entity']),
  "readiness": zod.enum(['setup_required', 'configured'])
})


/**
 * @summary Append tenant defaults or entity override; null resets inheritance
 */
export const writeGovernmentJurisdictionsParams = zod.object({
  "scope": zod.enum(['tenant', 'entity'])
})

export const writeGovernmentJurisdictionsBodyExpectedRevisionMin = 0;

export const writeGovernmentJurisdictionsBodyExpectedFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const writeGovernmentJurisdictionsBodyCoverageOneStatesMax = 8;

export const writeGovernmentJurisdictionsBodyCoverageOneLocalJurisdictionsItemIdMax = 100;


export const writeGovernmentJurisdictionsBodyCoverageOneLocalJurisdictionsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const writeGovernmentJurisdictionsBodyCoverageOneLocalJurisdictionsItemNameMax = 200;

export const writeGovernmentJurisdictionsBodyCoverageOneLocalJurisdictionsMax = 100;

export const writeGovernmentJurisdictionsBodyCoverageOneCategoriesMax = 8;

export const writeGovernmentJurisdictionsBodyReasonMin = 10;
export const writeGovernmentJurisdictionsBodyReasonMax = 2000;



export const writeGovernmentJurisdictionsBody = zod.object({
  "expectedRevision": zod.int().min(writeGovernmentJurisdictionsBodyExpectedRevisionMin),
  "expectedFingerprint": zod.string().regex(writeGovernmentJurisdictionsBodyExpectedFingerprintRegExp),
  "coverage": zod.union([zod.object({
  "country": zod.enum(['AU']),
  "federal": zod.boolean(),
  "states": zod.array(zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'])).max(writeGovernmentJurisdictionsBodyCoverageOneStatesMax),
  "localMode": zod.enum(['none', 'all', 'selected']),
  "localJurisdictions": zod.array(zod.object({
  "id": zod.string().min(1).max(writeGovernmentJurisdictionsBodyCoverageOneLocalJurisdictionsItemIdMax).regex(writeGovernmentJurisdictionsBodyCoverageOneLocalJurisdictionsItemIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(writeGovernmentJurisdictionsBodyCoverageOneLocalJurisdictionsItemNameMax)
})).max(writeGovernmentJurisdictionsBodyCoverageOneLocalJurisdictionsMax),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).max(writeGovernmentJurisdictionsBodyCoverageOneCategoriesMax)
}),zod.null()]),
  "reason": zod.string().min(writeGovernmentJurisdictionsBodyReasonMin).max(writeGovernmentJurisdictionsBodyReasonMax)
})

export const writeGovernmentJurisdictionsResponseLocalRevisionMin = 0;

export const writeGovernmentJurisdictionsResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const writeGovernmentJurisdictionsResponseRevisionsItemRevisionMin = 0;

export const writeGovernmentJurisdictionsResponseRevisionsMax = 2;

export const writeGovernmentJurisdictionsResponseLocalCoverageOneStatesMax = 8;

export const writeGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdMax = 100;


export const writeGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const writeGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemNameMax = 200;

export const writeGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsMax = 100;

export const writeGovernmentJurisdictionsResponseLocalCoverageOneCategoriesMax = 8;

export const writeGovernmentJurisdictionsResponseEffectiveCoverageOneStatesMax = 8;

export const writeGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdMax = 100;


export const writeGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const writeGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemNameMax = 200;

export const writeGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsMax = 100;

export const writeGovernmentJurisdictionsResponseEffectiveCoverageOneCategoriesMax = 8;



export const writeGovernmentJurisdictionsResponse = zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "localRevision": zod.int().min(writeGovernmentJurisdictionsResponseLocalRevisionMin),
  "fingerprint": zod.string().regex(writeGovernmentJurisdictionsResponseFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(writeGovernmentJurisdictionsResponseRevisionsItemRevisionMin)
})).max(writeGovernmentJurisdictionsResponseRevisionsMax),
  "localCoverage": zod.union([zod.object({
  "country": zod.enum(['AU']),
  "federal": zod.boolean(),
  "states": zod.array(zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'])).max(writeGovernmentJurisdictionsResponseLocalCoverageOneStatesMax),
  "localMode": zod.enum(['none', 'all', 'selected']),
  "localJurisdictions": zod.array(zod.object({
  "id": zod.string().min(1).max(writeGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdMax).regex(writeGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(writeGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemNameMax)
})).max(writeGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsMax),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).max(writeGovernmentJurisdictionsResponseLocalCoverageOneCategoriesMax)
}),zod.null()]),
  "effectiveCoverage": zod.union([zod.object({
  "country": zod.enum(['AU']),
  "federal": zod.boolean(),
  "states": zod.array(zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'])).max(writeGovernmentJurisdictionsResponseEffectiveCoverageOneStatesMax),
  "localMode": zod.enum(['none', 'all', 'selected']),
  "localJurisdictions": zod.array(zod.object({
  "id": zod.string().min(1).max(writeGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdMax).regex(writeGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(writeGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemNameMax)
})).max(writeGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsMax),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).max(writeGovernmentJurisdictionsResponseEffectiveCoverageOneCategoriesMax)
}),zod.null()]),
  "origin": zod.enum(['setup_required', 'tenant', 'entity']),
  "readiness": zod.enum(['setup_required', 'configured'])
})


/**
 * @summary Read selected entity effective government coverage
 */
export const getEffectiveGovernmentJurisdictionsResponseLocalRevisionMin = 0;

export const getEffectiveGovernmentJurisdictionsResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getEffectiveGovernmentJurisdictionsResponseRevisionsItemRevisionMin = 0;

export const getEffectiveGovernmentJurisdictionsResponseRevisionsMax = 2;

export const getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneStatesMax = 8;

export const getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdMax = 100;


export const getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemNameMax = 200;

export const getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsMax = 100;

export const getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneCategoriesMax = 8;

export const getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneStatesMax = 8;

export const getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdMax = 100;


export const getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemNameMax = 200;

export const getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsMax = 100;

export const getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneCategoriesMax = 8;



export const getEffectiveGovernmentJurisdictionsResponse = zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "localRevision": zod.int().min(getEffectiveGovernmentJurisdictionsResponseLocalRevisionMin),
  "fingerprint": zod.string().regex(getEffectiveGovernmentJurisdictionsResponseFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getEffectiveGovernmentJurisdictionsResponseRevisionsItemRevisionMin)
})).max(getEffectiveGovernmentJurisdictionsResponseRevisionsMax),
  "localCoverage": zod.union([zod.object({
  "country": zod.enum(['AU']),
  "federal": zod.boolean(),
  "states": zod.array(zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'])).max(getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneStatesMax),
  "localMode": zod.enum(['none', 'all', 'selected']),
  "localJurisdictions": zod.array(zod.object({
  "id": zod.string().min(1).max(getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdMax).regex(getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsItemNameMax)
})).max(getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneLocalJurisdictionsMax),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).max(getEffectiveGovernmentJurisdictionsResponseLocalCoverageOneCategoriesMax)
}),zod.null()]),
  "effectiveCoverage": zod.union([zod.object({
  "country": zod.enum(['AU']),
  "federal": zod.boolean(),
  "states": zod.array(zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'])).max(getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneStatesMax),
  "localMode": zod.enum(['none', 'all', 'selected']),
  "localJurisdictions": zod.array(zod.object({
  "id": zod.string().min(1).max(getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdMax).regex(getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsItemNameMax)
})).max(getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneLocalJurisdictionsMax),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).max(getEffectiveGovernmentJurisdictionsResponseEffectiveCoverageOneCategoriesMax)
}),zod.null()]),
  "origin": zod.enum(['setup_required', 'tenant', 'entity']),
  "readiness": zod.enum(['setup_required', 'configured'])
})


export const previewDocumentWorkspaceEvidenceParams = zod.object({
  "workspaceId": zod.uuid()
})

export const previewDocumentWorkspaceEvidenceBodyQueryMax = 4000;

export const previewDocumentWorkspaceEvidenceBodyChannelDefault = `agent`;
export const previewDocumentWorkspaceEvidenceBodyMaxEvidenceCharsDefault = 12000;
export const previewDocumentWorkspaceEvidenceBodyMaxEvidenceCharsMin = 2000;
export const previewDocumentWorkspaceEvidenceBodyMaxEvidenceCharsMax = 24000;

export const previewDocumentWorkspaceEvidenceBodyMaxPassagesDefault = 12;
export const previewDocumentWorkspaceEvidenceBodyMaxPassagesMin = 2;
export const previewDocumentWorkspaceEvidenceBodyMaxPassagesMax = 24;

export const previewDocumentWorkspaceEvidenceBodyExpectedContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const previewDocumentWorkspaceEvidenceBody = zod.object({
  "expectedRevision": zod.uuid(),
  "query": zod.string().min(1).max(previewDocumentWorkspaceEvidenceBodyQueryMax),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(previewDocumentWorkspaceEvidenceBodyChannelDefault),
  "maxEvidenceChars": zod.int().min(previewDocumentWorkspaceEvidenceBodyMaxEvidenceCharsMin).max(previewDocumentWorkspaceEvidenceBodyMaxEvidenceCharsMax).default(previewDocumentWorkspaceEvidenceBodyMaxEvidenceCharsDefault),
  "maxPassages": zod.int().min(previewDocumentWorkspaceEvidenceBodyMaxPassagesMin).max(previewDocumentWorkspaceEvidenceBodyMaxPassagesMax).default(previewDocumentWorkspaceEvidenceBodyMaxPassagesDefault),
  "expectedContextFingerprint": zod.string().regex(previewDocumentWorkspaceEvidenceBodyExpectedContextFingerprintRegExp).optional().describe('Optional exact preview context fence. Consumers must review the returned immutable snapshot before dispatch.')
})

export const previewDocumentWorkspaceEvidenceResponseContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewDocumentWorkspaceEvidenceResponseQueryHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewDocumentWorkspaceEvidenceResponseChannelDefault = `agent`;
export const previewDocumentWorkspaceEvidenceResponseMaxEvidenceCharsMin = 2000;
export const previewDocumentWorkspaceEvidenceResponseMaxEvidenceCharsMax = 24000;

export const previewDocumentWorkspaceEvidenceResponseMaxPassagesMin = 2;
export const previewDocumentWorkspaceEvidenceResponseMaxPassagesMax = 24;

export const previewDocumentWorkspaceEvidenceResponseMessageMax = 1000;

export const previewDocumentWorkspaceEvidenceResponseBackgroundStateMax = 100;

export const previewDocumentWorkspaceEvidenceResponsePassagesItemCitationMax = 24;

export const previewDocumentWorkspaceEvidenceResponsePassagesItemCrmIdentityMax = 150;

export const previewDocumentWorkspaceEvidenceResponsePassagesItemSourceVersionMax = 200;

export const previewDocumentWorkspaceEvidenceResponsePassagesItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewDocumentWorkspaceEvidenceResponsePassagesItemExcerptHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewDocumentWorkspaceEvidenceResponsePassagesItemLabelMax = 500;

export const previewDocumentWorkspaceEvidenceResponsePassagesItemLocationMax = 500;

export const previewDocumentWorkspaceEvidenceResponsePassagesItemExcerptMax = 2000;

export const previewDocumentWorkspaceEvidenceResponsePassagesItemScoreMin = 0;
export const previewDocumentWorkspaceEvidenceResponsePassagesItemScoreMax = 1;

export const previewDocumentWorkspaceEvidenceResponsePassagesItemStartMin = 0;

export const previewDocumentWorkspaceEvidenceResponsePassagesItemEndMin = 0;

export const previewDocumentWorkspaceEvidenceResponsePassagesMax = 24;

export const previewDocumentWorkspaceEvidenceResponseSourcesItemMessageMax = 1000;

export const previewDocumentWorkspaceEvidenceResponseSourcesMax = 100;

export const previewDocumentWorkspaceEvidenceResponseWarningsItemMax = 1000;

export const previewDocumentWorkspaceEvidenceResponseWarningsMax = 100;



export const previewDocumentWorkspaceEvidenceResponse = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "workspaceId": zod.uuid(),
  "workspaceRevision": zod.uuid(),
  "contextFingerprint": zod.string().regex(previewDocumentWorkspaceEvidenceResponseContextFingerprintRegExp),
  "queryHash": zod.string().regex(previewDocumentWorkspaceEvidenceResponseQueryHashRegExp),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(previewDocumentWorkspaceEvidenceResponseChannelDefault),
  "retrievalMode": zod.enum(['lexical']),
  "maxEvidenceChars": zod.int().min(previewDocumentWorkspaceEvidenceResponseMaxEvidenceCharsMin).max(previewDocumentWorkspaceEvidenceResponseMaxEvidenceCharsMax),
  "maxPassages": zod.int().min(previewDocumentWorkspaceEvidenceResponseMaxPassagesMin).max(previewDocumentWorkspaceEvidenceResponseMaxPassagesMax),
  "state": zod.enum(['ready', 'partial', 'insufficient', 'conflicting', 'unavailable']),
  "message": zod.string().min(1).max(previewDocumentWorkspaceEvidenceResponseMessageMax),
  "backgroundState": zod.string().min(1).max(previewDocumentWorkspaceEvidenceResponseBackgroundStateMax),
  "passages": zod.array(zod.object({
  "id": zod.uuid(),
  "citation": zod.int().min(1).max(previewDocumentWorkspaceEvidenceResponsePassagesItemCitationMax),
  "kind": zod.enum(['workspace', 'knowledge', 'crm']),
  "tier": zod.enum(['primary', 'background']),
  "reason": zod.enum(['automatic', 'explicit', 'entity_background']),
  "role": zod.enum(['provided', 'working', 'submission']).nullable(),
  "membershipId": zod.uuid().nullable(),
  "membershipRevision": zod.uuid().nullable(),
  "folderRevision": zod.uuid().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "extractionRevision": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "managedDocumentId": zod.uuid().nullable(),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "knowledgeFileId": zod.uuid().nullable(),
  "indexDocumentId": zod.uuid().nullable(),
  "chunkId": zod.uuid().nullable(),
  "crmIdentity": zod.string().min(1).max(previewDocumentWorkspaceEvidenceResponsePassagesItemCrmIdentityMax).nullable(),
  "sourceVersion": zod.string().min(1).max(previewDocumentWorkspaceEvidenceResponsePassagesItemSourceVersionMax),
  "contentHash": zod.string().regex(previewDocumentWorkspaceEvidenceResponsePassagesItemContentHashRegExp),
  "excerptHash": zod.string().regex(previewDocumentWorkspaceEvidenceResponsePassagesItemExcerptHashRegExp),
  "label": zod.string().min(1).max(previewDocumentWorkspaceEvidenceResponsePassagesItemLabelMax),
  "location": zod.string().min(1).max(previewDocumentWorkspaceEvidenceResponsePassagesItemLocationMax),
  "excerpt": zod.string().min(1).max(previewDocumentWorkspaceEvidenceResponsePassagesItemExcerptMax),
  "score": zod.number().min(previewDocumentWorkspaceEvidenceResponsePassagesItemScoreMin).max(previewDocumentWorkspaceEvidenceResponsePassagesItemScoreMax),
  "start": zod.int().min(previewDocumentWorkspaceEvidenceResponsePassagesItemStartMin).nullable(),
  "end": zod.int().min(previewDocumentWorkspaceEvidenceResponsePassagesItemEndMin).nullable()
})).max(previewDocumentWorkspaceEvidenceResponsePassagesMax),
  "sources": zod.array(zod.object({
  "membershipId": zod.uuid(),
  "role": zod.enum(['provided', 'working', 'submission']),
  "state": zod.enum(['excluded', 'stored', 'pending', 'ready', 'unsupported', 'failed', 'denied', 'stale', 'unavailable', 'irrelevant', 'omitted_budget']),
  "message": zod.string().min(1).max(previewDocumentWorkspaceEvidenceResponseSourcesItemMessageMax)
})).max(previewDocumentWorkspaceEvidenceResponseSourcesMax),
  "warnings": zod.array(zod.string().min(1).max(previewDocumentWorkspaceEvidenceResponseWarningsItemMax)).max(previewDocumentWorkspaceEvidenceResponseWarningsMax)
})


export const createDocumentWorkspaceEvidenceSnapshotParams = zod.object({
  "workspaceId": zod.uuid()
})

export const createDocumentWorkspaceEvidenceSnapshotBodyQueryMax = 4000;

export const createDocumentWorkspaceEvidenceSnapshotBodyChannelDefault = `agent`;
export const createDocumentWorkspaceEvidenceSnapshotBodyMaxEvidenceCharsDefault = 12000;
export const createDocumentWorkspaceEvidenceSnapshotBodyMaxEvidenceCharsMin = 2000;
export const createDocumentWorkspaceEvidenceSnapshotBodyMaxEvidenceCharsMax = 24000;

export const createDocumentWorkspaceEvidenceSnapshotBodyMaxPassagesDefault = 12;
export const createDocumentWorkspaceEvidenceSnapshotBodyMaxPassagesMin = 2;
export const createDocumentWorkspaceEvidenceSnapshotBodyMaxPassagesMax = 24;

export const createDocumentWorkspaceEvidenceSnapshotBodyExpectedContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const createDocumentWorkspaceEvidenceSnapshotBody = zod.object({
  "expectedRevision": zod.uuid(),
  "query": zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotBodyQueryMax),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(createDocumentWorkspaceEvidenceSnapshotBodyChannelDefault),
  "maxEvidenceChars": zod.int().min(createDocumentWorkspaceEvidenceSnapshotBodyMaxEvidenceCharsMin).max(createDocumentWorkspaceEvidenceSnapshotBodyMaxEvidenceCharsMax).default(createDocumentWorkspaceEvidenceSnapshotBodyMaxEvidenceCharsDefault),
  "maxPassages": zod.int().min(createDocumentWorkspaceEvidenceSnapshotBodyMaxPassagesMin).max(createDocumentWorkspaceEvidenceSnapshotBodyMaxPassagesMax).default(createDocumentWorkspaceEvidenceSnapshotBodyMaxPassagesDefault),
  "requestId": zod.uuid(),
  "expectedContextFingerprint": zod.string().regex(createDocumentWorkspaceEvidenceSnapshotBodyExpectedContextFingerprintRegExp).optional().describe('Optional exact preview context fence. Consumers must review the returned immutable snapshot before dispatch.')
})

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createDocumentWorkspaceEvidenceSnapshotResponseManifestContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const createDocumentWorkspaceEvidenceSnapshotResponseManifestQueryHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createDocumentWorkspaceEvidenceSnapshotResponseManifestChannelDefault = `agent`;
export const createDocumentWorkspaceEvidenceSnapshotResponseManifestMaxEvidenceCharsMin = 2000;
export const createDocumentWorkspaceEvidenceSnapshotResponseManifestMaxEvidenceCharsMax = 24000;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestMaxPassagesMin = 2;
export const createDocumentWorkspaceEvidenceSnapshotResponseManifestMaxPassagesMax = 24;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestMessageMax = 1000;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestBackgroundStateMax = 100;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemCitationMax = 24;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemCrmIdentityMax = 150;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemSourceVersionMax = 200;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemExcerptHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemLabelMax = 500;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemLocationMax = 500;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemExcerptMax = 2000;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemScoreMin = 0;
export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemScoreMax = 1;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemStartMin = 0;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemEndMin = 0;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesMax = 24;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestSourcesItemMessageMax = 1000;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestSourcesMax = 100;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestWarningsItemMax = 1000;

export const createDocumentWorkspaceEvidenceSnapshotResponseManifestWarningsMax = 100;



export const createDocumentWorkspaceEvidenceSnapshotResponse = zod.object({
  "id": zod.uuid(),
  "manifestHash": zod.string().regex(createDocumentWorkspaceEvidenceSnapshotResponseManifestHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "manifest": zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "workspaceId": zod.uuid(),
  "workspaceRevision": zod.uuid(),
  "contextFingerprint": zod.string().regex(createDocumentWorkspaceEvidenceSnapshotResponseManifestContextFingerprintRegExp),
  "queryHash": zod.string().regex(createDocumentWorkspaceEvidenceSnapshotResponseManifestQueryHashRegExp),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(createDocumentWorkspaceEvidenceSnapshotResponseManifestChannelDefault),
  "retrievalMode": zod.enum(['lexical']),
  "maxEvidenceChars": zod.int().min(createDocumentWorkspaceEvidenceSnapshotResponseManifestMaxEvidenceCharsMin).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestMaxEvidenceCharsMax),
  "maxPassages": zod.int().min(createDocumentWorkspaceEvidenceSnapshotResponseManifestMaxPassagesMin).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestMaxPassagesMax),
  "state": zod.enum(['ready', 'partial', 'insufficient', 'conflicting', 'unavailable']),
  "message": zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestMessageMax),
  "backgroundState": zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestBackgroundStateMax),
  "passages": zod.array(zod.object({
  "id": zod.uuid(),
  "citation": zod.int().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemCitationMax),
  "kind": zod.enum(['workspace', 'knowledge', 'crm']),
  "tier": zod.enum(['primary', 'background']),
  "reason": zod.enum(['automatic', 'explicit', 'entity_background']),
  "role": zod.enum(['provided', 'working', 'submission']).nullable(),
  "membershipId": zod.uuid().nullable(),
  "membershipRevision": zod.uuid().nullable(),
  "folderRevision": zod.uuid().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "extractionRevision": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "managedDocumentId": zod.uuid().nullable(),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "knowledgeFileId": zod.uuid().nullable(),
  "indexDocumentId": zod.uuid().nullable(),
  "chunkId": zod.uuid().nullable(),
  "crmIdentity": zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemCrmIdentityMax).nullable(),
  "sourceVersion": zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemSourceVersionMax),
  "contentHash": zod.string().regex(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemContentHashRegExp),
  "excerptHash": zod.string().regex(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemExcerptHashRegExp),
  "label": zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemLabelMax),
  "location": zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemLocationMax),
  "excerpt": zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemExcerptMax),
  "score": zod.number().min(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemScoreMin).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemScoreMax),
  "start": zod.int().min(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemStartMin).nullable(),
  "end": zod.int().min(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemEndMin).nullable()
})).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesMax),
  "sources": zod.array(zod.object({
  "membershipId": zod.uuid(),
  "role": zod.enum(['provided', 'working', 'submission']),
  "state": zod.enum(['excluded', 'stored', 'pending', 'ready', 'unsupported', 'failed', 'denied', 'stale', 'unavailable', 'irrelevant', 'omitted_budget']),
  "message": zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestSourcesItemMessageMax)
})).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestSourcesMax),
  "warnings": zod.array(zod.string().min(1).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestWarningsItemMax)).max(createDocumentWorkspaceEvidenceSnapshotResponseManifestWarningsMax)
})
})


export const getDocumentWorkspaceEvidenceSnapshotParams = zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid()
})

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentWorkspaceEvidenceSnapshotResponseManifestContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentWorkspaceEvidenceSnapshotResponseManifestQueryHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentWorkspaceEvidenceSnapshotResponseManifestChannelDefault = `agent`;
export const getDocumentWorkspaceEvidenceSnapshotResponseManifestMaxEvidenceCharsMin = 2000;
export const getDocumentWorkspaceEvidenceSnapshotResponseManifestMaxEvidenceCharsMax = 24000;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestMaxPassagesMin = 2;
export const getDocumentWorkspaceEvidenceSnapshotResponseManifestMaxPassagesMax = 24;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestMessageMax = 1000;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestBackgroundStateMax = 100;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemCitationMax = 24;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemCrmIdentityMax = 150;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemSourceVersionMax = 200;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemExcerptHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemLabelMax = 500;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemLocationMax = 500;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemExcerptMax = 2000;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemScoreMin = 0;
export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemScoreMax = 1;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemStartMin = 0;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemEndMin = 0;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesMax = 24;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestSourcesItemMessageMax = 1000;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestSourcesMax = 100;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestWarningsItemMax = 1000;

export const getDocumentWorkspaceEvidenceSnapshotResponseManifestWarningsMax = 100;



export const getDocumentWorkspaceEvidenceSnapshotResponse = zod.object({
  "id": zod.uuid(),
  "manifestHash": zod.string().regex(getDocumentWorkspaceEvidenceSnapshotResponseManifestHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "manifest": zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "workspaceId": zod.uuid(),
  "workspaceRevision": zod.uuid(),
  "contextFingerprint": zod.string().regex(getDocumentWorkspaceEvidenceSnapshotResponseManifestContextFingerprintRegExp),
  "queryHash": zod.string().regex(getDocumentWorkspaceEvidenceSnapshotResponseManifestQueryHashRegExp),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(getDocumentWorkspaceEvidenceSnapshotResponseManifestChannelDefault),
  "retrievalMode": zod.enum(['lexical']),
  "maxEvidenceChars": zod.int().min(getDocumentWorkspaceEvidenceSnapshotResponseManifestMaxEvidenceCharsMin).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestMaxEvidenceCharsMax),
  "maxPassages": zod.int().min(getDocumentWorkspaceEvidenceSnapshotResponseManifestMaxPassagesMin).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestMaxPassagesMax),
  "state": zod.enum(['ready', 'partial', 'insufficient', 'conflicting', 'unavailable']),
  "message": zod.string().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestMessageMax),
  "backgroundState": zod.string().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestBackgroundStateMax),
  "passages": zod.array(zod.object({
  "id": zod.uuid(),
  "citation": zod.int().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemCitationMax),
  "kind": zod.enum(['workspace', 'knowledge', 'crm']),
  "tier": zod.enum(['primary', 'background']),
  "reason": zod.enum(['automatic', 'explicit', 'entity_background']),
  "role": zod.enum(['provided', 'working', 'submission']).nullable(),
  "membershipId": zod.uuid().nullable(),
  "membershipRevision": zod.uuid().nullable(),
  "folderRevision": zod.uuid().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "extractionRevision": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "managedDocumentId": zod.uuid().nullable(),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "knowledgeFileId": zod.uuid().nullable(),
  "indexDocumentId": zod.uuid().nullable(),
  "chunkId": zod.uuid().nullable(),
  "crmIdentity": zod.string().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemCrmIdentityMax).nullable(),
  "sourceVersion": zod.string().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemSourceVersionMax),
  "contentHash": zod.string().regex(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemContentHashRegExp),
  "excerptHash": zod.string().regex(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemExcerptHashRegExp),
  "label": zod.string().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemLabelMax),
  "location": zod.string().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemLocationMax),
  "excerpt": zod.string().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemExcerptMax),
  "score": zod.number().min(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemScoreMin).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemScoreMax),
  "start": zod.int().min(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemStartMin).nullable(),
  "end": zod.int().min(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesItemEndMin).nullable()
})).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestPassagesMax),
  "sources": zod.array(zod.object({
  "membershipId": zod.uuid(),
  "role": zod.enum(['provided', 'working', 'submission']),
  "state": zod.enum(['excluded', 'stored', 'pending', 'ready', 'unsupported', 'failed', 'denied', 'stale', 'unavailable', 'irrelevant', 'omitted_budget']),
  "message": zod.string().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestSourcesItemMessageMax)
})).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestSourcesMax),
  "warnings": zod.array(zod.string().min(1).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestWarningsItemMax)).max(getDocumentWorkspaceEvidenceSnapshotResponseManifestWarningsMax)
})
})


export const validateDocumentWorkspaceEvidenceSnapshotParams = zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid()
})

export const validateDocumentWorkspaceEvidenceSnapshotResponseManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const validateDocumentWorkspaceEvidenceSnapshotResponse = zod.object({
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(validateDocumentWorkspaceEvidenceSnapshotResponseManifestHashRegExp),
  "valid": zod.boolean()
})


export const openDocumentWorkspaceEvidenceCitationParams = zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "citationId": zod.uuid()
})

export const openDocumentWorkspaceEvidenceCitationResponseManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const openDocumentWorkspaceEvidenceCitationResponsePassageCitationMax = 24;

export const openDocumentWorkspaceEvidenceCitationResponsePassageCrmIdentityMax = 150;

export const openDocumentWorkspaceEvidenceCitationResponsePassageSourceVersionMax = 200;

export const openDocumentWorkspaceEvidenceCitationResponsePassageContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const openDocumentWorkspaceEvidenceCitationResponsePassageExcerptHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const openDocumentWorkspaceEvidenceCitationResponsePassageLabelMax = 500;

export const openDocumentWorkspaceEvidenceCitationResponsePassageLocationMax = 500;

export const openDocumentWorkspaceEvidenceCitationResponsePassageExcerptMax = 2000;

export const openDocumentWorkspaceEvidenceCitationResponsePassageScoreMin = 0;
export const openDocumentWorkspaceEvidenceCitationResponsePassageScoreMax = 1;

export const openDocumentWorkspaceEvidenceCitationResponsePassageStartMin = 0;

export const openDocumentWorkspaceEvidenceCitationResponsePassageEndMin = 0;



export const openDocumentWorkspaceEvidenceCitationResponse = zod.object({
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(openDocumentWorkspaceEvidenceCitationResponseManifestHashRegExp),
  "passage": zod.object({
  "id": zod.uuid(),
  "citation": zod.int().min(1).max(openDocumentWorkspaceEvidenceCitationResponsePassageCitationMax),
  "kind": zod.enum(['workspace', 'knowledge', 'crm']),
  "tier": zod.enum(['primary', 'background']),
  "reason": zod.enum(['automatic', 'explicit', 'entity_background']),
  "role": zod.enum(['provided', 'working', 'submission']).nullable(),
  "membershipId": zod.uuid().nullable(),
  "membershipRevision": zod.uuid().nullable(),
  "folderRevision": zod.uuid().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "extractionRevision": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "managedDocumentId": zod.uuid().nullable(),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "knowledgeFileId": zod.uuid().nullable(),
  "indexDocumentId": zod.uuid().nullable(),
  "chunkId": zod.uuid().nullable(),
  "crmIdentity": zod.string().min(1).max(openDocumentWorkspaceEvidenceCitationResponsePassageCrmIdentityMax).nullable(),
  "sourceVersion": zod.string().min(1).max(openDocumentWorkspaceEvidenceCitationResponsePassageSourceVersionMax),
  "contentHash": zod.string().regex(openDocumentWorkspaceEvidenceCitationResponsePassageContentHashRegExp),
  "excerptHash": zod.string().regex(openDocumentWorkspaceEvidenceCitationResponsePassageExcerptHashRegExp),
  "label": zod.string().min(1).max(openDocumentWorkspaceEvidenceCitationResponsePassageLabelMax),
  "location": zod.string().min(1).max(openDocumentWorkspaceEvidenceCitationResponsePassageLocationMax),
  "excerpt": zod.string().min(1).max(openDocumentWorkspaceEvidenceCitationResponsePassageExcerptMax),
  "score": zod.number().min(openDocumentWorkspaceEvidenceCitationResponsePassageScoreMin).max(openDocumentWorkspaceEvidenceCitationResponsePassageScoreMax),
  "start": zod.int().min(openDocumentWorkspaceEvidenceCitationResponsePassageStartMin).nullable(),
  "end": zod.int().min(openDocumentWorkspaceEvidenceCitationResponsePassageEndMin).nullable()
})
})


export const createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsTopMin = 5;
export const createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsTopMax = 50;

export const createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsRightMin = 5;
export const createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsRightMax = 50;

export const createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsBottomMin = 5;
export const createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsBottomMax = 50;

export const createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsLeftMin = 5;
export const createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsLeftMax = 50;

export const createLibraryRecordItemBodyItemOneContentLayoutHeaderItemTypeMax = 40;

export const createLibraryRecordItemBodyItemOneContentLayoutHeaderItemTextMax = 200000;

export const createLibraryRecordItemBodyItemOneContentLayoutHeaderItemMarksItemTypeMax = 40;

export const createLibraryRecordItemBodyItemOneContentLayoutHeaderItemMarksMax = 20;

export const createLibraryRecordItemBodyItemOneContentLayoutHeaderItemContentMax = 10000;

export const createLibraryRecordItemBodyItemOneContentLayoutHeaderMax = 100;

export const createLibraryRecordItemBodyItemOneContentLayoutFooterItemTypeMax = 40;

export const createLibraryRecordItemBodyItemOneContentLayoutFooterItemTextMax = 200000;

export const createLibraryRecordItemBodyItemOneContentLayoutFooterItemMarksItemTypeMax = 40;

export const createLibraryRecordItemBodyItemOneContentLayoutFooterItemMarksMax = 20;

export const createLibraryRecordItemBodyItemOneContentLayoutFooterItemContentMax = 10000;

export const createLibraryRecordItemBodyItemOneContentLayoutFooterMax = 100;

export const createLibraryRecordItemBodyItemOneContentSectionsItemsItemTitleMax = 160;

export const createLibraryRecordItemBodyItemOneContentSectionsItemsItemAuthoringNotesMax = 4000;


export const createLibraryRecordItemBodyItemOneContentSectionsItemsMax = 200;

export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemNameMax = 80;

export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemFontSizeMin = 6;
export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemFontSizeMax = 96;

export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemSpaceAfterMin = 0;
export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemSpaceAfterMax = 144;

export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemLineHeightMax = 3;

export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsMin = 7;
export const createLibraryRecordItemBodyItemOneContentStylesDefinitionsMax = 100;

export const createLibraryRecordItemBodyItemOneContentTemplateGuidanceMax = 4000;

export const createLibraryRecordItemBodyItemOneContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createLibraryRecordItemBodyItemOneContentTemplateSectionGuidanceMax = 200;

export const createLibraryRecordItemBodyItemOneContentContentItemTypeMax = 40;

export const createLibraryRecordItemBodyItemOneContentContentItemTextMax = 200000;

export const createLibraryRecordItemBodyItemOneContentContentItemMarksItemTypeMax = 40;

export const createLibraryRecordItemBodyItemOneContentContentItemMarksMax = 20;

export const createLibraryRecordItemBodyItemOneContentContentItemContentMax = 10000;

export const createLibraryRecordItemBodyItemOneContentContentMax = 10000;


export const createLibraryRecordItemBodyItemOneTemplateSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createLibraryRecordItemBodyItemOneTitleMax = 240;

export const createLibraryRecordItemBodyItemTwoFilenameMax = 255;

export const createLibraryRecordItemBodyItemTwoContentTypeMax = 200;

export const createLibraryRecordItemBodyItemTwoContentBase64Min = 4;
export const createLibraryRecordItemBodyItemTwoContentBase64Max = 27962028;

export const createLibraryRecordItemBodyItemThreeFilenameMax = 255;

export const createLibraryRecordItemBodyItemThreeContentTypeMax = 200;

export const createLibraryRecordItemBodyItemThreeContentBase64Min = 4;
export const createLibraryRecordItemBodyItemThreeContentBase64Max = 27962028;



export const createLibraryRecordItemBody = zod.object({
  "requestId": zod.uuid(),
  "destination": zod.union([zod.object({
  "kind": zod.enum(['workspace']),
  "workspaceId": zod.uuid(),
  "expectedRevision": zod.uuid(),
  "folderId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['account']),
  "accountId": zod.uuid()
})]),
  "item": zod.union([zod.object({
  "kind": zod.enum(['document']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsTopMin).max(createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsRightMin).max(createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsBottomMin).max(createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsLeftMin).max(createLibraryRecordItemBodyItemOneContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createLibraryRecordItemBodyItemOneContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(createLibraryRecordItemBodyItemOneContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createLibraryRecordItemBodyItemOneContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createLibraryRecordItemBodyItemOneContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createLibraryRecordItemBodyItemOneContentLayoutHeaderItemContentMax).optional()
})).max(createLibraryRecordItemBodyItemOneContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createLibraryRecordItemBodyItemOneContentLayoutFooterItemTypeMax),
  "text": zod.string().max(createLibraryRecordItemBodyItemOneContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createLibraryRecordItemBodyItemOneContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createLibraryRecordItemBodyItemOneContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createLibraryRecordItemBodyItemOneContentLayoutFooterItemContentMax).optional()
})).max(createLibraryRecordItemBodyItemOneContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createLibraryRecordItemBodyItemOneContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createLibraryRecordItemBodyItemOneContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createLibraryRecordItemBodyItemOneContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemFontSizeMin).max(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemSpaceBeforeMin).max(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemSpaceAfterMin).max(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createLibraryRecordItemBodyItemOneContentStylesDefinitionsItemLineHeightMax)
})).min(createLibraryRecordItemBodyItemOneContentStylesDefinitionsMin).max(createLibraryRecordItemBodyItemOneContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createLibraryRecordItemBodyItemOneContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createLibraryRecordItemBodyItemOneContentTemplateSectionGuidanceItemGuidanceMax)
})).max(createLibraryRecordItemBodyItemOneContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createLibraryRecordItemBodyItemOneContentContentItemTypeMax),
  "text": zod.string().max(createLibraryRecordItemBodyItemOneContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createLibraryRecordItemBodyItemOneContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createLibraryRecordItemBodyItemOneContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createLibraryRecordItemBodyItemOneContentContentItemContentMax).optional()
})).max(createLibraryRecordItemBodyItemOneContentContentMax)
}).optional(),
  "templateSource": zod.object({
  "documentId": zod.uuid(),
  "revision": zod.int().min(1),
  "contentHash": zod.string().regex(createLibraryRecordItemBodyItemOneTemplateSourceContentHashRegExp)
}).optional(),
  "title": zod.string().min(1).max(createLibraryRecordItemBodyItemOneTitleMax)
}),zod.object({
  "kind": zod.enum(['upload']),
  "filename": zod.string().min(1).max(createLibraryRecordItemBodyItemTwoFilenameMax),
  "contentType": zod.string().min(1).max(createLibraryRecordItemBodyItemTwoContentTypeMax),
  "contentBase64": zod.string().min(createLibraryRecordItemBodyItemTwoContentBase64Min).max(createLibraryRecordItemBodyItemTwoContentBase64Max)
}),zod.object({
  "kind": zod.enum(['import']),
  "filename": zod.string().min(1).max(createLibraryRecordItemBodyItemThreeFilenameMax),
  "contentType": zod.string().min(1).max(createLibraryRecordItemBodyItemThreeContentTypeMax),
  "contentBase64": zod.string().min(createLibraryRecordItemBodyItemThreeContentBase64Min).max(createLibraryRecordItemBodyItemThreeContentBase64Max),
  "reviewed": zod.literal(true)
})])
})

export const createLibraryRecordItemResponse = zod.object({
  "requestId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "destination": zod.union([zod.object({
  "kind": zod.enum(['workspace']),
  "workspaceId": zod.uuid(),
  "expectedRevision": zod.uuid(),
  "folderId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['account']),
  "accountId": zod.uuid()
})]),
  "membershipId": zod.uuid().nullable(),
  "state": zod.enum(['saved', 'unconfirmed'])
})


export const getLibraryRecordCreationParams = zod.object({
  "requestId": zod.uuid()
})

export const getLibraryRecordCreationResponse = zod.object({
  "state": zod.enum(['absent', 'saved', 'unconfirmed']),
  "result": zod.union([zod.object({
  "requestId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "destination": zod.union([zod.object({
  "kind": zod.enum(['workspace']),
  "workspaceId": zod.uuid(),
  "expectedRevision": zod.uuid(),
  "folderId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['account']),
  "accountId": zod.uuid()
})]),
  "membershipId": zod.uuid().nullable(),
  "state": zod.enum(['saved', 'unconfirmed'])
}),zod.null()])
})


export const reviewWorkspaceMarkdownParams = zod.object({
  "workspaceId": zod.uuid()
})

export const reviewWorkspaceMarkdownBodyExpectedContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewWorkspaceMarkdownBodySourceMax = 131072;

export const reviewWorkspaceMarkdownBodyInstructionMax = 4000;




export const reviewWorkspaceMarkdownBody = zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.uuid(),
  "membershipId": zod.uuid(),
  "expectedMembershipRevision": zod.uuid(),
  "sourceRevisionId": zod.uuid(),
  "expectedFileId": zod.uuid(),
  "expectedContentHash": zod.string().regex(reviewWorkspaceMarkdownBodyExpectedContentHashRegExp),
  "source": zod.string().max(reviewWorkspaceMarkdownBodySourceMax),
  "instruction": zod.string().min(1).max(reviewWorkspaceMarkdownBodyInstructionMax),
  "savedPrompt": zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
}).optional()
})

export const reviewWorkspaceMarkdownResponseSuggestionsItemIdMax = 80;

export const reviewWorkspaceMarkdownResponseSuggestionsItemStartMin = 0;


export const reviewWorkspaceMarkdownResponseSuggestionsItemBeforeMax = 1200;

export const reviewWorkspaceMarkdownResponseSuggestionsItemAfterMax = 1200;

export const reviewWorkspaceMarkdownResponseSuggestionsItemReasonMax = 300;

export const reviewWorkspaceMarkdownResponseSuggestionsMax = 24;



export const reviewWorkspaceMarkdownResponse = zod.object({
  "requestId": zod.uuid(),
  "suggestions": zod.array(zod.object({
  "id": zod.string().max(reviewWorkspaceMarkdownResponseSuggestionsItemIdMax),
  "start": zod.int().min(reviewWorkspaceMarkdownResponseSuggestionsItemStartMin),
  "end": zod.int().min(1),
  "before": zod.string().max(reviewWorkspaceMarkdownResponseSuggestionsItemBeforeMax),
  "after": zod.string().min(1).max(reviewWorkspaceMarkdownResponseSuggestionsItemAfterMax),
  "reason": zod.string().max(reviewWorkspaceMarkdownResponseSuggestionsItemReasonMax)
})).max(reviewWorkspaceMarkdownResponseSuggestionsMax)
})


export const previewMarkdownConversionParams = zod.object({
  "workspaceId": zod.uuid()
})

export const previewMarkdownConversionBodyExpectedContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewMarkdownConversionBodySourceMax = 2097152;

export const previewMarkdownConversionBodyTitleMax = 240;



export const previewMarkdownConversionBody = zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.uuid(),
  "folderId": zod.uuid(),
  "membershipId": zod.uuid(),
  "expectedMembershipRevision": zod.uuid(),
  "sourceRevisionId": zod.uuid(),
  "expectedFileId": zod.uuid(),
  "expectedContentHash": zod.string().regex(previewMarkdownConversionBodyExpectedContentHashRegExp),
  "source": zod.string().max(previewMarkdownConversionBodySourceMax),
  "title": zod.string().min(1).max(previewMarkdownConversionBodyTitleMax),
  "removeFromWorkspace": zod.boolean()
})

export const previewMarkdownConversionResponsePreviewHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewMarkdownConversionResponseDraftHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const previewMarkdownConversionResponse = zod.object({
  "previewHash": zod.string().regex(previewMarkdownConversionResponsePreviewHashRegExp),
  "draftHash": zod.string().regex(previewMarkdownConversionResponseDraftHashRegExp),
  "destinationLabel": zod.string(),
  "sourceFilename": zod.string(),
  "removalAllowed": zod.boolean(),
  "removalReason": zod.string(),
  "content": zod.record(zod.string(), zod.unknown())
})


export const confirmMarkdownConversionParams = zod.object({
  "workspaceId": zod.uuid()
})

export const confirmMarkdownConversionBodyReviewExpectedContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmMarkdownConversionBodyReviewSourceMax = 2097152;

export const confirmMarkdownConversionBodyReviewTitleMax = 240;

export const confirmMarkdownConversionBodyPreviewHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const confirmMarkdownConversionBody = zod.object({
  "review": zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.uuid(),
  "folderId": zod.uuid(),
  "membershipId": zod.uuid(),
  "expectedMembershipRevision": zod.uuid(),
  "sourceRevisionId": zod.uuid(),
  "expectedFileId": zod.uuid(),
  "expectedContentHash": zod.string().regex(confirmMarkdownConversionBodyReviewExpectedContentHashRegExp),
  "source": zod.string().max(confirmMarkdownConversionBodyReviewSourceMax),
  "title": zod.string().min(1).max(confirmMarkdownConversionBodyReviewTitleMax),
  "removeFromWorkspace": zod.boolean()
}),
  "previewHash": zod.string().regex(confirmMarkdownConversionBodyPreviewHashRegExp),
  "confirmed": zod.literal(true)
})

export const confirmMarkdownConversionResponse = zod.object({
  "documentId": zod.uuid(),
  "membership": zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
}),
  "workspaceRevision": zod.uuid()
})


export const getMarkdownConversionOperationParams = zod.object({
  "workspaceId": zod.uuid(),
  "requestId": zod.uuid()
})

export const getMarkdownConversionOperationResponse = zod.object({
  "state": zod.enum(['absent', 'saved']),
  "result": zod.union([zod.object({
  "documentId": zod.uuid(),
  "membership": zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
}),
  "workspaceRevision": zod.uuid()
}),zod.null()])
})


export const createDocumentWorkspaceDocumentParams = zod.object({
  "workspaceId": zod.uuid()
})

export const createDocumentWorkspaceDocumentBodyTitleMax = 240;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsTopMin = 5;
export const createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsTopMax = 50;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsRightMin = 5;
export const createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsRightMax = 50;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemTypeMax = 40;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemTextMax = 200000;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemMarksMax = 20;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemContentMax = 10000;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderMax = 100;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemTypeMax = 40;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemTextMax = 200000;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemMarksMax = 20;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemContentMax = 10000;

export const createDocumentWorkspaceDocumentBodyContentOneLayoutFooterMax = 100;

export const createDocumentWorkspaceDocumentBodyContentOneSectionsItemsItemTitleMax = 160;

export const createDocumentWorkspaceDocumentBodyContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const createDocumentWorkspaceDocumentBodyContentOneSectionsItemsMax = 200;

export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemNameMax = 80;

export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemFontSizeMin = 6;
export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemFontSizeMax = 96;

export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemLineHeightMax = 3;

export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsMin = 7;
export const createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsMax = 100;

export const createDocumentWorkspaceDocumentBodyContentOneTemplateGuidanceMax = 4000;

export const createDocumentWorkspaceDocumentBodyContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createDocumentWorkspaceDocumentBodyContentOneTemplateSectionGuidanceMax = 200;

export const createDocumentWorkspaceDocumentBodyContentOneContentItemTypeMax = 40;

export const createDocumentWorkspaceDocumentBodyContentOneContentItemTextMax = 200000;

export const createDocumentWorkspaceDocumentBodyContentOneContentItemMarksItemTypeMax = 40;

export const createDocumentWorkspaceDocumentBodyContentOneContentItemMarksMax = 20;

export const createDocumentWorkspaceDocumentBodyContentOneContentItemContentMax = 10000;

export const createDocumentWorkspaceDocumentBodyContentOneContentMax = 10000;



export const createDocumentWorkspaceDocumentBody = zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.uuid(),
  "folderId": zod.uuid(),
  "title": zod.string().min(1).max(createDocumentWorkspaceDocumentBodyTitleMax),
  "kind": zod.enum(['blank', 'tender_response']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsTopMin).max(createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsRightMin).max(createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsBottomMin).max(createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsLeftMin).max(createDocumentWorkspaceDocumentBodyContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderItemContentMax).optional()
})).max(createDocumentWorkspaceDocumentBodyContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createDocumentWorkspaceDocumentBodyContentOneLayoutFooterItemContentMax).optional()
})).max(createDocumentWorkspaceDocumentBodyContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createDocumentWorkspaceDocumentBodyContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createDocumentWorkspaceDocumentBodyContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createDocumentWorkspaceDocumentBodyContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemFontSizeMin).max(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemSpaceBeforeMin).max(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemSpaceAfterMin).max(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsItemLineHeightMax)
})).min(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsMin).max(createDocumentWorkspaceDocumentBodyContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createDocumentWorkspaceDocumentBodyContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createDocumentWorkspaceDocumentBodyContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(createDocumentWorkspaceDocumentBodyContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createDocumentWorkspaceDocumentBodyContentOneContentItemTypeMax),
  "text": zod.string().max(createDocumentWorkspaceDocumentBodyContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createDocumentWorkspaceDocumentBodyContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createDocumentWorkspaceDocumentBodyContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createDocumentWorkspaceDocumentBodyContentOneContentItemContentMax).optional()
})).max(createDocumentWorkspaceDocumentBodyContentOneContentMax)
}).optional().describe('Optional authored initial content, replacing the blank or tender scaffold. Uses native document validation and a maximum UTF-8 JSON size of 1000000 bytes; omitted content preserves legacy creation and request recovery.')
})

export const createDocumentWorkspaceDocumentResponse = zod.object({
  "documentId": zod.uuid(),
  "membership": zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
}),
  "workspaceRevision": zod.uuid()
})


export const getDocumentWorkspaceDocumentOperationParams = zod.object({
  "workspaceId": zod.uuid(),
  "requestId": zod.uuid()
})

export const getDocumentWorkspaceDocumentOperationResponse = zod.object({
  "state": zod.enum(['absent', 'saved']),
  "result": zod.union([zod.object({
  "documentId": zod.uuid(),
  "membership": zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
}),
  "workspaceRevision": zod.uuid()
}),zod.null()])
})


export const getDocumentWorkspaceUploadOperationParams = zod.object({
  "workspaceId": zod.uuid(),
  "requestId": zod.uuid()
})

export const getDocumentWorkspaceUploadOperationResponseResultOneSourceRevisionContentHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const getDocumentWorkspaceUploadOperationResponse = zod.object({
  "state": zod.enum(['absent', 'saved', 'unconfirmed']),
  "result": zod.union([zod.object({
  "membership": zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
}),
  "sourceRevision": zod.object({
  "id": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "contentHash": zod.string().regex(getDocumentWorkspaceUploadOperationResponseResultOneSourceRevisionContentHashRegExp)
}),
  "workspaceRevision": zod.uuid()
}),zod.null()])
})


export const uploadDocumentWorkspaceFileParams = zod.object({
  "workspaceId": zod.uuid()
})

export const uploadDocumentWorkspaceFileBodyMarkdownEditExpectedContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadDocumentWorkspaceFileBodyFilenameMax = 255;

export const uploadDocumentWorkspaceFileBodyContentTypeMax = 200;

export const uploadDocumentWorkspaceFileBodyContentBase64Min = 4;
export const uploadDocumentWorkspaceFileBodyContentBase64Max = 27962028;

export const uploadDocumentWorkspaceFileBodyBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const uploadDocumentWorkspaceFileBody = zod.object({
  "markdownEdit": zod.object({
  "expectedFileId": zod.uuid(),
  "expectedContentHash": zod.string().regex(uploadDocumentWorkspaceFileBodyMarkdownEditExpectedContentHashRegExp)
}).optional().describe('Explicit Markdown version replacement only. Requires exact native membership and original file/hash; preserves filename/MIME, validates fatal UTF-8 and the 2 MiB editing limit. Unsupported syntax remains source-editable. History, exact downloads and actor-private original recovery use the existing native version/upload operations; no publication transition.'),
  "includeEvidence": zod.boolean().optional().describe('Reviewed evidence choice. New tender Working/Submission uploads default to included when omitted; replacement uploads and other workspaces preserve existing selections. Inclusion requires preparation and current access before grounding.'),
  "expectedRevision": zod.uuid(),
  "requestId": zod.uuid(),
  "folderId": zod.uuid(),
  "filename": zod.string().min(1).max(uploadDocumentWorkspaceFileBodyFilenameMax),
  "contentType": zod.string().min(1).max(uploadDocumentWorkspaceFileBodyContentTypeMax),
  "contentBase64": zod.string().min(uploadDocumentWorkspaceFileBodyContentBase64Min).max(uploadDocumentWorkspaceFileBodyContentBase64Max),
  "membershipId": zod.uuid().optional(),
  "expectedMembershipRevision": zod.uuid().optional(),
  "destinationId": zod.uuid().optional(),
  "bindingFingerprint": zod.string().regex(uploadDocumentWorkspaceFileBodyBindingFingerprintRegExp).optional()
})

export const uploadDocumentWorkspaceFileResponseSourceRevisionContentHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const uploadDocumentWorkspaceFileResponse = zod.object({
  "membership": zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
}),
  "sourceRevision": zod.object({
  "id": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "contentHash": zod.string().regex(uploadDocumentWorkspaceFileResponseSourceRevisionContentHashRegExp)
}),
  "workspaceRevision": zod.uuid()
})


export const listDocumentWorkspaceSourceVersionsParams = zod.object({
  "workspaceId": zod.uuid(),
  "membershipId": zod.uuid()
})

export const listDocumentWorkspaceSourceVersionsQueryLimitDefault = 25;
export const listDocumentWorkspaceSourceVersionsQueryLimitMax = 100;

export const listDocumentWorkspaceSourceVersionsQueryOffsetDefault = 0;
export const listDocumentWorkspaceSourceVersionsQueryOffsetMin = 0;
export const listDocumentWorkspaceSourceVersionsQueryOffsetMax = 10000;



export const listDocumentWorkspaceSourceVersionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDocumentWorkspaceSourceVersionsQueryLimitMax).default(listDocumentWorkspaceSourceVersionsQueryLimitDefault),
  "offset": zod.int().min(listDocumentWorkspaceSourceVersionsQueryOffsetMin).max(listDocumentWorkspaceSourceVersionsQueryOffsetMax).default(listDocumentWorkspaceSourceVersionsQueryOffsetDefault)
})

export const listDocumentWorkspaceSourceVersionsResponseItemsItemSourceRevisionContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listDocumentWorkspaceSourceVersionsResponseItemsItemAttemptsMin = 0;
export const listDocumentWorkspaceSourceVersionsResponseItemsItemAttemptsMax = 3;

export const listDocumentWorkspaceSourceVersionsResponseItemsItemLocatorsItemStartMin = 0;

export const listDocumentWorkspaceSourceVersionsResponseItemsItemLocatorsItemEndMin = 0;



export const listDocumentWorkspaceSourceVersionsResponse = zod.object({
  "items": zod.array(zod.object({
  "sourceRevision": zod.object({
  "id": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "contentHash": zod.string().regex(listDocumentWorkspaceSourceVersionsResponseItemsItemSourceRevisionContentHashRegExp)
}),
  "state": zod.enum(['stored', 'pending', 'ready', 'unsupported', 'failed']),
  "message": zod.string().nullable(),
  "attempts": zod.int().min(listDocumentWorkspaceSourceVersionsResponseItemsItemAttemptsMin).max(listDocumentWorkspaceSourceVersionsResponseItemsItemAttemptsMax),
  "extractionRevision": zod.uuid(),
  "locators": zod.array(zod.object({
  "location": zod.string(),
  "start": zod.int().min(listDocumentWorkspaceSourceVersionsResponseItemsItemLocatorsItemStartMin),
  "end": zod.int().min(listDocumentWorkspaceSourceVersionsResponseItemsItemLocatorsItemEndMin)
})),
  "warnings": zod.array(zod.string())
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const prepareDocumentWorkspaceSourceParams = zod.object({
  "workspaceId": zod.uuid(),
  "membershipId": zod.uuid()
})

export const prepareDocumentWorkspaceSourceBody = zod.object({
  "expectedRevision": zod.uuid(),
  "expectedMembershipRevision": zod.uuid(),
  "sourceRevisionId": zod.uuid().nullish(),
  "expectedExtractionRevision": zod.uuid().optional()
})

export const prepareDocumentWorkspaceSourceResponseSourceRevisionContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const prepareDocumentWorkspaceSourceResponseAttemptsMin = 0;
export const prepareDocumentWorkspaceSourceResponseAttemptsMax = 3;

export const prepareDocumentWorkspaceSourceResponseLocatorsItemStartMin = 0;

export const prepareDocumentWorkspaceSourceResponseLocatorsItemEndMin = 0;



export const prepareDocumentWorkspaceSourceResponse = zod.object({
  "sourceRevision": zod.object({
  "id": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "contentHash": zod.string().regex(prepareDocumentWorkspaceSourceResponseSourceRevisionContentHashRegExp)
}),
  "state": zod.enum(['stored', 'pending', 'ready', 'unsupported', 'failed']),
  "message": zod.string().nullable(),
  "attempts": zod.int().min(prepareDocumentWorkspaceSourceResponseAttemptsMin).max(prepareDocumentWorkspaceSourceResponseAttemptsMax),
  "extractionRevision": zod.uuid(),
  "locators": zod.array(zod.object({
  "location": zod.string(),
  "start": zod.int().min(prepareDocumentWorkspaceSourceResponseLocatorsItemStartMin),
  "end": zod.int().min(prepareDocumentWorkspaceSourceResponseLocatorsItemEndMin)
})),
  "warnings": zod.array(zod.string())
})


export const downloadDocumentWorkspaceSourceVersionParams = zod.object({
  "workspaceId": zod.uuid(),
  "membershipId": zod.uuid(),
  "sourceRevisionId": zod.uuid()
})

export const downloadDocumentWorkspaceSourceVersionResponse = zod.unknown()


export const initializeDocumentWorkspaceSourcesParams = zod.object({
  "workspaceId": zod.uuid()
})

export const initializeDocumentWorkspaceSourcesBody = zod.object({
  "expectedRevision": zod.uuid()
})

export const initializeDocumentWorkspaceSourcesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const listDocumentWorkspacesQueryLimitDefault = 25;
export const listDocumentWorkspacesQueryLimitMax = 100;

export const listDocumentWorkspacesQueryOffsetDefault = 0;
export const listDocumentWorkspacesQueryOffsetMin = 0;
export const listDocumentWorkspacesQueryOffsetMax = 10000;



export const listDocumentWorkspacesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDocumentWorkspacesQueryLimitMax).default(listDocumentWorkspacesQueryLimitDefault),
  "offset": zod.int().min(listDocumentWorkspacesQueryOffsetMin).max(listDocumentWorkspacesQueryOffsetMax).default(listDocumentWorkspacesQueryOffsetDefault),
  "anchorKind": zod.enum(['partner_agreement', 'managed_document', 'tender', 'sow_preparation']).optional(),
  "recordId": zod.uuid().optional()
})

export const listDocumentWorkspacesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "anchor": zod.object({
  "kind": zod.enum(['partner_agreement', 'managed_document', 'tender', 'sow_preparation']),
  "recordId": zod.uuid()
}),
  "title": zod.string(),
  "revision": zod.uuid()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createDocumentWorkspaceBody = zod.object({
  "anchor": zod.object({
  "kind": zod.enum(['partner_agreement', 'managed_document', 'tender', 'sow_preparation']),
  "recordId": zod.uuid()
})
})

export const createDocumentWorkspaceResponse = zod.object({
  "id": zod.uuid(),
  "anchor": zod.object({
  "kind": zod.enum(['partner_agreement', 'managed_document', 'tender', 'sow_preparation']),
  "recordId": zod.uuid()
}),
  "title": zod.string(),
  "revision": zod.uuid()
})


export const getDocumentWorkspaceParams = zod.object({
  "workspaceId": zod.uuid()
})

export const getDocumentWorkspaceResponse = zod.object({
  "id": zod.uuid(),
  "anchor": zod.object({
  "kind": zod.enum(['partner_agreement', 'managed_document', 'tender', 'sow_preparation']),
  "recordId": zod.uuid()
}),
  "title": zod.string(),
  "revision": zod.uuid()
})


export const listDocumentWorkspaceFoldersParams = zod.object({
  "workspaceId": zod.uuid()
})

export const listDocumentWorkspaceFoldersQueryLimitDefault = 25;
export const listDocumentWorkspaceFoldersQueryLimitMax = 100;

export const listDocumentWorkspaceFoldersQueryOffsetDefault = 0;
export const listDocumentWorkspaceFoldersQueryOffsetMin = 0;
export const listDocumentWorkspaceFoldersQueryOffsetMax = 10000;



export const listDocumentWorkspaceFoldersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDocumentWorkspaceFoldersQueryLimitMax).default(listDocumentWorkspaceFoldersQueryLimitDefault),
  "offset": zod.int().min(listDocumentWorkspaceFoldersQueryOffsetMin).max(listDocumentWorkspaceFoldersQueryOffsetMax).default(listDocumentWorkspaceFoldersQueryOffsetDefault)
})

export const listDocumentWorkspaceFoldersResponseItemsItemDepthMin = 0;
export const listDocumentWorkspaceFoldersResponseItemsItemDepthMax = 8;



export const listDocumentWorkspaceFoldersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "name": zod.string(),
  "role": zod.enum(['root', 'reference', 'provided', 'working', 'submission']),
  "system": zod.boolean(),
  "depth": zod.int().min(listDocumentWorkspaceFoldersResponseItemsItemDepthMin).max(listDocumentWorkspaceFoldersResponseItemsItemDepthMax),
  "path": zod.string().optional().describe('Current full contextual folder breadcrumb when listed; never a provider path.'),
  "revision": zod.uuid()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createDocumentWorkspaceFolderParams = zod.object({
  "workspaceId": zod.uuid()
})

export const createDocumentWorkspaceFolderBodyNameMax = 120;



export const createDocumentWorkspaceFolderBody = zod.object({
  "expectedRevision": zod.uuid(),
  "requestId": zod.uuid().optional().describe('Optional stable folder identity for read-first recovery.'),
  "parentId": zod.uuid(),
  "name": zod.string().min(1).max(createDocumentWorkspaceFolderBodyNameMax)
})

export const createDocumentWorkspaceFolderResponseDepthMin = 0;
export const createDocumentWorkspaceFolderResponseDepthMax = 8;



export const createDocumentWorkspaceFolderResponse = zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "name": zod.string(),
  "role": zod.enum(['root', 'reference', 'provided', 'working', 'submission']),
  "system": zod.boolean(),
  "depth": zod.int().min(createDocumentWorkspaceFolderResponseDepthMin).max(createDocumentWorkspaceFolderResponseDepthMax),
  "path": zod.string().optional().describe('Current full contextual folder breadcrumb when listed; never a provider path.'),
  "revision": zod.uuid()
})


export const updateDocumentWorkspaceFolderParams = zod.object({
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid()
})

export const updateDocumentWorkspaceFolderBodyNameMax = 120;



export const updateDocumentWorkspaceFolderBody = zod.object({
  "expectedRevision": zod.uuid(),
  "expectedFolderRevision": zod.uuid(),
  "parentId": zod.uuid(),
  "name": zod.string().min(1).max(updateDocumentWorkspaceFolderBodyNameMax)
})

export const updateDocumentWorkspaceFolderResponseDepthMin = 0;
export const updateDocumentWorkspaceFolderResponseDepthMax = 8;



export const updateDocumentWorkspaceFolderResponse = zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "name": zod.string(),
  "role": zod.enum(['root', 'reference', 'provided', 'working', 'submission']),
  "system": zod.boolean(),
  "depth": zod.int().min(updateDocumentWorkspaceFolderResponseDepthMin).max(updateDocumentWorkspaceFolderResponseDepthMax),
  "path": zod.string().optional().describe('Current full contextual folder breadcrumb when listed; never a provider path.'),
  "revision": zod.uuid()
})


export const removeDocumentWorkspaceFolderParams = zod.object({
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid()
})

export const removeDocumentWorkspaceFolderBody = zod.object({
  "expectedRevision": zod.uuid(),
  "expectedFolderRevision": zod.uuid()
})

export const removeDocumentWorkspaceFolderResponse = zod.object({
  "id": zod.uuid(),
  "anchor": zod.object({
  "kind": zod.enum(['partner_agreement', 'managed_document', 'tender', 'sow_preparation']),
  "recordId": zod.uuid()
}),
  "title": zod.string(),
  "revision": zod.uuid()
})


export const listDocumentWorkspaceMembershipsParams = zod.object({
  "workspaceId": zod.uuid()
})

export const listDocumentWorkspaceMembershipsQueryLimitDefault = 25;
export const listDocumentWorkspaceMembershipsQueryLimitMax = 100;

export const listDocumentWorkspaceMembershipsQueryOffsetDefault = 0;
export const listDocumentWorkspaceMembershipsQueryOffsetMin = 0;
export const listDocumentWorkspaceMembershipsQueryOffsetMax = 10000;



export const listDocumentWorkspaceMembershipsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDocumentWorkspaceMembershipsQueryLimitMax).default(listDocumentWorkspaceMembershipsQueryLimitDefault),
  "offset": zod.int().min(listDocumentWorkspaceMembershipsQueryOffsetMin).max(listDocumentWorkspaceMembershipsQueryOffsetMax).default(listDocumentWorkspaceMembershipsQueryOffsetDefault),
  "folderId": zod.uuid().optional()
})

export const listDocumentWorkspaceMembershipsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createDocumentWorkspaceMembershipParams = zod.object({
  "workspaceId": zod.uuid()
})

export const createDocumentWorkspaceMembershipBody = zod.object({
  "expectedRevision": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
})
})

export const createDocumentWorkspaceMembershipResponse = zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
})


export const updateDocumentWorkspaceMembershipParams = zod.object({
  "workspaceId": zod.uuid(),
  "membershipId": zod.uuid()
})

export const updateDocumentWorkspaceMembershipBody = zod.object({
  "expectedRevision": zod.uuid(),
  "expectedMembershipRevision": zod.uuid(),
  "folderId": zod.uuid()
})

export const updateDocumentWorkspaceMembershipResponse = zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
})


export const unlinkDocumentWorkspaceSourceParams = zod.object({
  "workspaceId": zod.uuid(),
  "membershipId": zod.uuid()
})

export const unlinkDocumentWorkspaceSourceBody = zod.object({
  "expectedRevision": zod.uuid(),
  "expectedMembershipRevision": zod.uuid()
})

export const unlinkDocumentWorkspaceSourceResponse = zod.object({
  "id": zod.uuid(),
  "anchor": zod.object({
  "kind": zod.enum(['partner_agreement', 'managed_document', 'tender', 'sow_preparation']),
  "recordId": zod.uuid()
}),
  "title": zod.string(),
  "revision": zod.uuid()
})


export const selectDocumentWorkspaceSourceParams = zod.object({
  "workspaceId": zod.uuid(),
  "membershipId": zod.uuid()
})

export const selectDocumentWorkspaceSourceBody = zod.object({
  "expectedRevision": zod.uuid(),
  "expectedMembershipRevision": zod.uuid(),
  "sourceRevisionId": zod.uuid().nullable()
})

export const selectDocumentWorkspaceSourceResponse = zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
})


export const removeDocumentWorkspaceEvidenceSelectionParams = zod.object({
  "workspaceId": zod.uuid(),
  "membershipId": zod.uuid()
})

export const removeDocumentWorkspaceEvidenceSelectionBody = zod.object({
  "expectedRevision": zod.uuid(),
  "expectedMembershipRevision": zod.uuid()
})

export const removeDocumentWorkspaceEvidenceSelectionResponse = zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
})


export const getFileAssociationsParams = zod.object({
  "sourceKind": zod.enum(['library', 'managed_document']),
  "sourceId": zod.uuid()
})

export const getFileAssociationsQueryLimitDefault = 25;
export const getFileAssociationsQueryLimitMax = 100;

export const getFileAssociationsQueryOffsetDefault = 0;
export const getFileAssociationsQueryOffsetMin = 0;
export const getFileAssociationsQueryOffsetMax = 10000;



export const getFileAssociationsQueryParams = zod.object({
  "limit": zod.int().min(1).max(getFileAssociationsQueryLimitMax).default(getFileAssociationsQueryLimitDefault),
  "offset": zod.int().min(getFileAssociationsQueryOffsetMin).max(getFileAssociationsQueryOffsetMax).default(getFileAssociationsQueryOffsetDefault)
})

export const getFileAssociationsResponseSourceRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const getFileAssociationsResponseAdditionalAccountIdsMax = 50;



export const getFileAssociationsResponse = zod.object({
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "sourceRevision": zod.string().regex(getFileAssociationsResponseSourceRevisionRegExp),
  "revision": zod.uuid().nullable(),
  "additionalAccountIds": zod.array(zod.uuid()).max(getFileAssociationsResponseAdditionalAccountIdsMax),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "derived": zod.boolean(),
  "additional": zod.boolean()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const saveFileAssociationsParams = zod.object({
  "sourceKind": zod.enum(['library', 'managed_document']),
  "sourceId": zod.uuid()
})

export const saveFileAssociationsBodyExpectedSourceRevisionRegExp = new RegExp('^[a-f0-9]{64}$');
export const saveFileAssociationsBodyAccountIdsMax = 50;



export const saveFileAssociationsBody = zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.uuid().nullable(),
  "expectedSourceRevision": zod.string().regex(saveFileAssociationsBodyExpectedSourceRevisionRegExp),
  "accountIds": zod.array(zod.uuid()).max(saveFileAssociationsBodyAccountIdsMax),
  "confirmed": zod.literal(true)
})

export const saveFileAssociationsResponseAccountIdsMax = 50;



export const saveFileAssociationsResponse = zod.object({
  "requestId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "sourceRevision": zod.string(),
  "accountIds": zod.array(zod.uuid()).max(saveFileAssociationsResponseAccountIdsMax),
  "savedAt": zod.iso.datetime({"offset":true})
})


export const getFileAssociationOperationParams = zod.object({
  "sourceKind": zod.enum(['library', 'managed_document']),
  "sourceId": zod.uuid(),
  "requestId": zod.uuid()
})

export const getFileAssociationOperationResponseAccountIdsMax = 50;



export const getFileAssociationOperationResponse = zod.object({
  "requestId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "sourceRevision": zod.string(),
  "accountIds": zod.array(zod.uuid()).max(getFileAssociationOperationResponseAccountIdsMax),
  "savedAt": zod.iso.datetime({"offset":true})
})


/**
 * Library files and managed documents attached to one CRM record, newest first. Only files the caller may read are listed.
 */
export const listRecordFilesParams = zod.object({
  "recordKind": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid()
})

export const listRecordFilesQuerySearchMax = 200;

export const listRecordFilesQueryLimitDefault = 25;
export const listRecordFilesQueryLimitMax = 100;

export const listRecordFilesQueryOffsetDefault = 0;
export const listRecordFilesQueryOffsetMin = 0;
export const listRecordFilesQueryOffsetMax = 10000;



export const listRecordFilesQueryParams = zod.object({
  "search": zod.string().max(listRecordFilesQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listRecordFilesQueryLimitMax).default(listRecordFilesQueryLimitDefault),
  "offset": zod.int().min(listRecordFilesQueryOffsetMin).max(listRecordFilesQueryOffsetMax).default(listRecordFilesQueryOffsetDefault)
})

export const listRecordFilesResponse = zod.object({
  "recordKind": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid(),
  "canEdit": zod.boolean(),
  "items": zod.array(zod.object({
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "title": zod.string(),
  "contentType": zod.string().nullable(),
  "sizeBytes": zod.int().nullable(),
  "folder": zod.string(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "linkedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Attach an existing library file or managed document to a CRM record. Idempotent; attaching never grants file access.
 */
export const attachRecordFileParams = zod.object({
  "recordKind": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid()
})

export const attachRecordFileBody = zod.object({
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
})
})

export const attachRecordFileResponse = zod.object({
  "recordKind": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "outcome": zod.enum(['attached', 'already_attached', 'detached', 'not_attached']),
  "revision": zod.uuid().nullable()
})


/**
 * Remove an explicit attachment. The file itself, its versions and other links are unchanged.
 */
export const detachRecordFileParams = zod.object({
  "recordKind": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid(),
  "sourceKind": zod.enum(['library', 'managed_document']),
  "sourceId": zod.uuid()
})

export const detachRecordFileResponse = zod.object({
  "recordKind": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "outcome": zod.enum(['attached', 'already_attached', 'detached', 'not_attached']),
  "revision": zod.uuid().nullable()
})


export const listFileLocationsQueryLimitDefault = 10;
export const listFileLocationsQueryLimitMax = 100;

export const listFileLocationsQueryOffsetDefault = 0;
export const listFileLocationsQueryOffsetMin = 0;
export const listFileLocationsQueryOffsetMax = 10000;



export const listFileLocationsQueryParams = zod.object({
  "sourceKind": zod.enum(['library', 'managed_document']),
  "sourceId": zod.uuid(),
  "workspaceId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listFileLocationsQueryLimitMax).default(listFileLocationsQueryLimitDefault),
  "offset": zod.int().min(listFileLocationsQueryOffsetMin).max(listFileLocationsQueryOffsetMax).default(listFileLocationsQueryOffsetDefault)
})

export const listFileLocationsResponseItemsItemBreadcrumbsItemDepthMin = 0;
export const listFileLocationsResponseItemsItemBreadcrumbsItemDepthMax = 8;

export const listFileLocationsResponseItemsItemBreadcrumbsMax = 9;



export const listFileLocationsResponse = zod.object({
  "items": zod.array(zod.object({
  "workspace": zod.object({
  "id": zod.uuid(),
  "anchor": zod.object({
  "kind": zod.enum(['partner_agreement', 'managed_document', 'tender', 'sow_preparation']),
  "recordId": zod.uuid()
}),
  "title": zod.string(),
  "revision": zod.uuid()
}),
  "membership": zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
}),
  "breadcrumbs": zod.array(zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "name": zod.string(),
  "role": zod.enum(['root', 'reference', 'provided', 'working', 'submission']),
  "system": zod.boolean(),
  "depth": zod.int().min(listFileLocationsResponseItemsItemBreadcrumbsItemDepthMin).max(listFileLocationsResponseItemsItemBreadcrumbsItemDepthMax),
  "path": zod.string().optional().describe('Current full contextual folder breadcrumb when listed; never a provider path.'),
  "revision": zod.uuid()
})).max(listFileLocationsResponseItemsItemBreadcrumbsMax)
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getDocumentWorkspaceContextParams = zod.object({
  "workspaceId": zod.uuid()
})

export const getDocumentWorkspaceContextQuerySearchMax = 200;

export const getDocumentWorkspaceContextQueryTypeMax = 200;

export const getDocumentWorkspaceContextQueryLimitDefault = 25;
export const getDocumentWorkspaceContextQueryLimitMax = 100;

export const getDocumentWorkspaceContextQueryOffsetDefault = 0;
export const getDocumentWorkspaceContextQueryOffsetMin = 0;
export const getDocumentWorkspaceContextQueryOffsetMax = 10000;



export const getDocumentWorkspaceContextQueryParams = zod.object({
  "search": zod.string().max(getDocumentWorkspaceContextQuerySearchMax).optional(),
  "sourceKind": zod.enum(['library', 'managed_document']).optional(),
  "type": zod.string().max(getDocumentWorkspaceContextQueryTypeMax).optional(),
  "limit": zod.int().min(1).max(getDocumentWorkspaceContextQueryLimitMax).default(getDocumentWorkspaceContextQueryLimitDefault),
  "offset": zod.int().min(getDocumentWorkspaceContextQueryOffsetMin).max(getDocumentWorkspaceContextQueryOffsetMax).default(getDocumentWorkspaceContextQueryOffsetDefault),
  "folderId": zod.uuid().optional()
})

export const getDocumentWorkspaceContextResponseItemsItemSelectedRevisionOneContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentWorkspaceContextResponseItemsItemCurrentRevisionOneContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentWorkspaceContextResponseItemsItemCurrentStateOneSourceRevisionContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentWorkspaceContextResponseItemsItemCurrentStateOneAttemptsMin = 0;
export const getDocumentWorkspaceContextResponseItemsItemCurrentStateOneAttemptsMax = 3;

export const getDocumentWorkspaceContextResponseItemsItemCurrentStateOneLocatorsItemStartMin = 0;

export const getDocumentWorkspaceContextResponseItemsItemCurrentStateOneLocatorsItemEndMin = 0;

export const getDocumentWorkspaceContextResponseItemsItemSelectedStateOneSourceRevisionContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentWorkspaceContextResponseItemsItemSelectedStateOneAttemptsMin = 0;
export const getDocumentWorkspaceContextResponseItemsItemSelectedStateOneAttemptsMax = 3;

export const getDocumentWorkspaceContextResponseItemsItemSelectedStateOneLocatorsItemStartMin = 0;

export const getDocumentWorkspaceContextResponseItemsItemSelectedStateOneLocatorsItemEndMin = 0;



export const getDocumentWorkspaceContextResponse = zod.object({
  "workspace": zod.object({
  "id": zod.uuid(),
  "anchor": zod.object({
  "kind": zod.enum(['partner_agreement', 'managed_document', 'tender', 'sow_preparation']),
  "recordId": zod.uuid()
}),
  "title": zod.string(),
  "revision": zod.uuid()
}),
  "items": zod.array(zod.object({
  "title": zod.string(),
  "canReplace": zod.boolean().describe('True only for canonical local upload sources; destination policy is rechecked on write.'),
  "membership": zod.object({
  "id": zod.uuid(),
  "workspaceId": zod.uuid(),
  "folderId": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "revision": zod.uuid(),
  "selectedRevisionId": zod.uuid().nullable()
}),
  "role": zod.enum(['provided', 'working', 'submission']),
  "inclusion": zod.enum(['automatic', 'explicit', 'excluded']),
  "selectedRevision": zod.union([zod.object({
  "id": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "contentHash": zod.string().regex(getDocumentWorkspaceContextResponseItemsItemSelectedRevisionOneContentHashRegExp)
}),zod.null()]),
  "readiness": zod.enum(['revision_required', 'version_pinned', 'excluded']),
  "currentRevision": zod.union([zod.object({
  "id": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "contentHash": zod.string().regex(getDocumentWorkspaceContextResponseItemsItemCurrentRevisionOneContentHashRegExp)
}),zod.null()]),
  "currentState": zod.union([zod.object({
  "sourceRevision": zod.object({
  "id": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "contentHash": zod.string().regex(getDocumentWorkspaceContextResponseItemsItemCurrentStateOneSourceRevisionContentHashRegExp)
}),
  "state": zod.enum(['stored', 'pending', 'ready', 'unsupported', 'failed']),
  "message": zod.string().nullable(),
  "attempts": zod.int().min(getDocumentWorkspaceContextResponseItemsItemCurrentStateOneAttemptsMin).max(getDocumentWorkspaceContextResponseItemsItemCurrentStateOneAttemptsMax),
  "extractionRevision": zod.uuid(),
  "locators": zod.array(zod.object({
  "location": zod.string(),
  "start": zod.int().min(getDocumentWorkspaceContextResponseItemsItemCurrentStateOneLocatorsItemStartMin),
  "end": zod.int().min(getDocumentWorkspaceContextResponseItemsItemCurrentStateOneLocatorsItemEndMin)
})),
  "warnings": zod.array(zod.string())
}),zod.null()]),
  "selectedState": zod.union([zod.object({
  "sourceRevision": zod.object({
  "id": zod.uuid(),
  "source": zod.object({
  "kind": zod.enum(['library', 'managed_document']),
  "id": zod.uuid()
}),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "contentHash": zod.string().regex(getDocumentWorkspaceContextResponseItemsItemSelectedStateOneSourceRevisionContentHashRegExp)
}),
  "state": zod.enum(['stored', 'pending', 'ready', 'unsupported', 'failed']),
  "message": zod.string().nullable(),
  "attempts": zod.int().min(getDocumentWorkspaceContextResponseItemsItemSelectedStateOneAttemptsMin).max(getDocumentWorkspaceContextResponseItemsItemSelectedStateOneAttemptsMax),
  "extractionRevision": zod.uuid(),
  "locators": zod.array(zod.object({
  "location": zod.string(),
  "start": zod.int().min(getDocumentWorkspaceContextResponseItemsItemSelectedStateOneLocatorsItemStartMin),
  "end": zod.int().min(getDocumentWorkspaceContextResponseItemsItemSelectedStateOneLocatorsItemEndMin)
})),
  "warnings": zod.array(zod.string())
}),zod.null()]),
  "versionMismatch": zod.boolean()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createBidBuyerReviewParams = zod.object({
  "id": zod.uuid()
})

export const createBidBuyerReviewHeaderIdempotencyKeyMax = 128;



export const createBidBuyerReviewHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createBidBuyerReviewHeaderIdempotencyKeyMax)
})




export const createBidBuyerReviewBody = zod.object({
  "packageRevisionId": zod.uuid(),
  "selectionRevision": zod.int().min(1)
})

export const createBidBuyerReviewResponseWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createBidBuyerReviewResponseInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createBidBuyerReviewResponseProgressCompletedMin = 0;


export const createBidBuyerReviewResponseAttemptCountMin = 0;

export const createBidBuyerReviewResponseMaxAttemptsMax = 5;



export const createBidBuyerReviewResponse = zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(createBidBuyerReviewResponseWorkspaceContextManifestHashRegExp)
}).optional(),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "modelId": zod.string(),
  "settings": zod.record(zod.string(), zod.unknown()),
  "inputHash": zod.string().regex(createBidBuyerReviewResponseInputHashRegExp),
  "progressCompleted": zod.int().min(createBidBuyerReviewResponseProgressCompletedMin),
  "progressTotal": zod.int().min(1),
  "attemptCount": zod.int().min(createBidBuyerReviewResponseAttemptCountMin),
  "maxAttempts": zod.int().min(1).max(createBidBuyerReviewResponseMaxAttemptsMax),
  "cancelRequested": zod.boolean(),
  "usage": zod.record(zod.string(), zod.unknown()).nullish(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listBidLessonsQueryLimitDefault = 50;
export const listBidLessonsQueryLimitMax = 100;

export const listBidLessonsQueryOffsetDefault = 0;
export const listBidLessonsQueryOffsetMin = 0;



export const listBidLessonsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listBidLessonsQueryLimitMax).default(listBidLessonsQueryLimitDefault),
  "offset": zod.int().min(listBidLessonsQueryOffsetMin).default(listBidLessonsQueryOffsetDefault)
})




export const listBidLessonsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "lessonId": zod.uuid(),
  "revision": zod.int().min(1),
  "status": zod.enum(['proposed', 'approved', 'rejected', 'withdrawn']),
  "guideline": zod.enum(['evidence_first', 'explicit_gaps', 'buyer_headings', 'proposed_commitments', 'concise_narrative']),
  "applicability": zod.enum(['all_responses', 'matching_document_category']),
  "guidance": zod.string(),
  "tenderId": zod.uuid(),
  "documentId": zod.uuid(),
  "beforeVersionId": zod.uuid(),
  "afterVersionId": zod.uuid(),
  "beforeHash": zod.string(),
  "afterHash": zod.string(),
  "beforeExcerpt": zod.string(),
  "afterExcerpt": zod.string(),
  "excerptNote": zod.string(),
  "explanation": zod.string(),
  "reason": zod.string(),
  "actorAppUserId": zod.uuid(),
  "editActorAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "eligible": zod.boolean(),
  "sourcePins": zod.array(zod.object({
  "kind": zod.string(),
  "id": zod.uuid(),
  "revision": zod.string(),
  "hash": zod.string()
})).optional(),
  "reviewOutcomeIds": zod.array(zod.uuid()).optional(),
  "exclusionReason": zod.string().nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const proposeBidLessonParams = zod.object({
  "id": zod.uuid()
})

export const proposeBidLessonHeaderIdempotencyKeyMax = 128;



export const proposeBidLessonHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(proposeBidLessonHeaderIdempotencyKeyMax)
})

export const proposeBidLessonBodyExplanationMax = 2000;



export const proposeBidLessonBody = zod.object({
  "beforeVersionId": zod.uuid(),
  "afterVersionId": zod.uuid(),
  "guideline": zod.enum(['evidence_first', 'explicit_gaps', 'buyer_headings', 'proposed_commitments', 'concise_narrative']),
  "applicability": zod.enum(['all_responses', 'matching_document_category']),
  "explanation": zod.string().min(1).max(proposeBidLessonBodyExplanationMax)
})




export const proposeBidLessonResponse = zod.object({
  "id": zod.uuid(),
  "lessonId": zod.uuid(),
  "revision": zod.int().min(1),
  "status": zod.enum(['proposed', 'approved', 'rejected', 'withdrawn']),
  "guideline": zod.enum(['evidence_first', 'explicit_gaps', 'buyer_headings', 'proposed_commitments', 'concise_narrative']),
  "applicability": zod.enum(['all_responses', 'matching_document_category']),
  "guidance": zod.string(),
  "tenderId": zod.uuid(),
  "documentId": zod.uuid(),
  "beforeVersionId": zod.uuid(),
  "afterVersionId": zod.uuid(),
  "beforeHash": zod.string(),
  "afterHash": zod.string(),
  "beforeExcerpt": zod.string(),
  "afterExcerpt": zod.string(),
  "excerptNote": zod.string(),
  "explanation": zod.string(),
  "reason": zod.string(),
  "actorAppUserId": zod.uuid(),
  "editActorAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "eligible": zod.boolean(),
  "sourcePins": zod.array(zod.object({
  "kind": zod.string(),
  "id": zod.uuid(),
  "revision": zod.string(),
  "hash": zod.string()
})).optional(),
  "reviewOutcomeIds": zod.array(zod.uuid()).optional(),
  "exclusionReason": zod.string().nullable()
})


export const decideBidLessonParams = zod.object({
  "lessonId": zod.uuid()
})


export const decideBidLessonBodyReasonMax = 2000;



export const decideBidLessonBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "decision": zod.enum(['approve', 'reject', 'withdraw']),
  "reason": zod.string().min(1).max(decideBidLessonBodyReasonMax)
})




export const decideBidLessonResponse = zod.object({
  "id": zod.uuid(),
  "lessonId": zod.uuid(),
  "revision": zod.int().min(1),
  "status": zod.enum(['proposed', 'approved', 'rejected', 'withdrawn']),
  "guideline": zod.enum(['evidence_first', 'explicit_gaps', 'buyer_headings', 'proposed_commitments', 'concise_narrative']),
  "applicability": zod.enum(['all_responses', 'matching_document_category']),
  "guidance": zod.string(),
  "tenderId": zod.uuid(),
  "documentId": zod.uuid(),
  "beforeVersionId": zod.uuid(),
  "afterVersionId": zod.uuid(),
  "beforeHash": zod.string(),
  "afterHash": zod.string(),
  "beforeExcerpt": zod.string(),
  "afterExcerpt": zod.string(),
  "excerptNote": zod.string(),
  "explanation": zod.string(),
  "reason": zod.string(),
  "actorAppUserId": zod.uuid(),
  "editActorAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "eligible": zod.boolean(),
  "sourcePins": zod.array(zod.object({
  "kind": zod.string(),
  "id": zod.uuid(),
  "revision": zod.string(),
  "hash": zod.string()
})).optional(),
  "reviewOutcomeIds": zod.array(zod.uuid()).optional(),
  "exclusionReason": zod.string().nullable()
})


export const listBidLessonHistoryParams = zod.object({
  "lessonId": zod.uuid()
})

export const listBidLessonHistoryQueryLimitDefault = 50;
export const listBidLessonHistoryQueryLimitMax = 100;

export const listBidLessonHistoryQueryOffsetDefault = 0;
export const listBidLessonHistoryQueryOffsetMin = 0;



export const listBidLessonHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listBidLessonHistoryQueryLimitMax).default(listBidLessonHistoryQueryLimitDefault),
  "offset": zod.int().min(listBidLessonHistoryQueryOffsetMin).default(listBidLessonHistoryQueryOffsetDefault)
})




export const listBidLessonHistoryResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "lessonId": zod.uuid(),
  "revision": zod.int().min(1),
  "status": zod.enum(['proposed', 'approved', 'rejected', 'withdrawn']),
  "guideline": zod.enum(['evidence_first', 'explicit_gaps', 'buyer_headings', 'proposed_commitments', 'concise_narrative']),
  "applicability": zod.enum(['all_responses', 'matching_document_category']),
  "guidance": zod.string(),
  "tenderId": zod.uuid(),
  "documentId": zod.uuid(),
  "beforeVersionId": zod.uuid(),
  "afterVersionId": zod.uuid(),
  "beforeHash": zod.string(),
  "afterHash": zod.string(),
  "beforeExcerpt": zod.string(),
  "afterExcerpt": zod.string(),
  "excerptNote": zod.string(),
  "explanation": zod.string(),
  "reason": zod.string(),
  "actorAppUserId": zod.uuid(),
  "editActorAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "eligible": zod.boolean(),
  "sourcePins": zod.array(zod.object({
  "kind": zod.string(),
  "id": zod.uuid(),
  "revision": zod.string(),
  "hash": zod.string()
})).optional(),
  "reviewOutcomeIds": zod.array(zod.uuid()).optional(),
  "exclusionReason": zod.string().nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createBidSynthesisParams = zod.object({
  "id": zod.uuid()
})

export const createBidSynthesisHeaderIdempotencyKeyMax = 128;



export const createBidSynthesisHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createBidSynthesisHeaderIdempotencyKeyMax)
})


export const createBidSynthesisBodyDocumentKeysItemMax = 100;

export const createBidSynthesisBodyDocumentKeysMax = 20;

export const createBidSynthesisBodyInstructionMax = 4000;



export const createBidSynthesisBody = zod.object({
  "planRevisionId": zod.uuid(),
  "selectionRevision": zod.int().min(1),
  "documentKeys": zod.array(zod.string().min(1).max(createBidSynthesisBodyDocumentKeysItemMax)).min(1).max(createBidSynthesisBodyDocumentKeysMax).optional(),
  "instruction": zod.string().max(createBidSynthesisBodyInstructionMax).optional()
})

export const createBidSynthesisResponseWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createBidSynthesisResponseInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createBidSynthesisResponseProgressCompletedMin = 0;


export const createBidSynthesisResponseAttemptCountMin = 0;

export const createBidSynthesisResponseMaxAttemptsMax = 5;



export const createBidSynthesisResponse = zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(createBidSynthesisResponseWorkspaceContextManifestHashRegExp)
}).optional(),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "modelId": zod.string(),
  "settings": zod.record(zod.string(), zod.unknown()),
  "inputHash": zod.string().regex(createBidSynthesisResponseInputHashRegExp),
  "progressCompleted": zod.int().min(createBidSynthesisResponseProgressCompletedMin),
  "progressTotal": zod.int().min(1),
  "attemptCount": zod.int().min(createBidSynthesisResponseAttemptCountMin),
  "maxAttempts": zod.int().min(1).max(createBidSynthesisResponseMaxAttemptsMax),
  "cancelRequested": zod.boolean(),
  "usage": zod.record(zod.string(), zod.unknown()).nullish(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getBidSynthesisParams = zod.object({
  "id": zod.uuid(),
  "runId": zod.uuid()
})

export const getBidSynthesisQueryLimitDefault = 50;
export const getBidSynthesisQueryLimitMax = 100;

export const getBidSynthesisQueryOffsetDefault = 0;
export const getBidSynthesisQueryOffsetMin = 0;



export const getBidSynthesisQueryParams = zod.object({
  "limit": zod.int().min(1).max(getBidSynthesisQueryLimitMax).default(getBidSynthesisQueryLimitDefault),
  "offset": zod.int().min(getBidSynthesisQueryOffsetMin).default(getBidSynthesisQueryOffsetDefault)
})

export const getBidSynthesisResponseCoverageItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');



export const getBidSynthesisResponseDocumentsItemProposalOneContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getBidSynthesisResponseDocumentsMax = 20;


export const getBidSynthesisResponseLessonsMax = 30;



export const getBidSynthesisResponse = zod.object({
  "runId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "coverageComplete": zod.boolean(),
  "warnings": zod.array(zod.string()),
  "coverage": zod.array(zod.object({
  "id": zod.string(),
  "sourceType": zod.enum(['tender_source', 'knowledge', 'workspace']),
  "sourceId": zod.string(),
  "revision": zod.string(),
  "sourceHash": zod.string(),
  "location": zod.string(),
  "start": zod.int(),
  "end": zod.int(),
  "text": zod.string(),
  "textHash": zod.string(),
  "reviewed": zod.boolean(),
  "summary": zod.string().nullable(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(getBidSynthesisResponseCoverageItemWorkspaceContextManifestHashRegExp)
}).optional()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "documents": zod.array(zod.object({
  "key": zod.string(),
  "documentId": zod.uuid(),
  "title": zod.string(),
  "baseRevision": zod.int().min(1),
  "currentRevision": zod.int().min(1),
  "proposalId": zod.uuid().nullable(),
  "status": zod.enum(['not_generated', 'pending', 'accepted', 'rejected', 'stale']),
  "acceptedVersionId": zod.uuid().nullable(),
  "baseChanged": zod.boolean(),
  "gaps": zod.array(zod.string()),
  "proposal": zod.union([zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "runId": zod.uuid(),
  "targetType": zod.enum(['tender', 'requirement', 'section']),
  "targetId": zod.uuid().nullish(),
  "baseRevision": zod.int().min(1),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "content": zod.record(zod.string(), zod.unknown()),
  "citations": zod.array(zod.record(zod.string(), zod.unknown())),
  "contentHash": zod.string().regex(getBidSynthesisResponseDocumentsItemProposalOneContentHashRegExp),
  "decisionNote": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish()
}),zod.null()]),
  "requirementIds": zod.array(zod.uuid())
})).max(getBidSynthesisResponseDocumentsMax),
  "consistency": zod.array(zod.string()),
  "gapTasks": zod.array(zod.object({
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullable(),
  "status": zod.enum(['proposed']),
  "approvalRequired": zod.literal(true),
  "planRevisionId": zod.uuid(),
  "documentKeys": zod.array(zod.string()),
  "requirementIds": zod.array(zod.uuid())
})),
  "lessons": zod.array(zod.object({
  "lessonId": zod.uuid(),
  "revision": zod.int().min(1),
  "guidance": zod.string(),
  "sourceTenderId": zod.uuid(),
  "documentId": zod.uuid(),
  "afterVersionId": zod.uuid()
})).max(getBidSynthesisResponseLessonsMax).optional()
})


export const resumeBidSynthesisParams = zod.object({
  "id": zod.uuid(),
  "runId": zod.uuid()
})

export const resumeBidSynthesisResponseWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const resumeBidSynthesisResponseInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const resumeBidSynthesisResponseProgressCompletedMin = 0;


export const resumeBidSynthesisResponseAttemptCountMin = 0;

export const resumeBidSynthesisResponseMaxAttemptsMax = 5;



export const resumeBidSynthesisResponse = zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(resumeBidSynthesisResponseWorkspaceContextManifestHashRegExp)
}).optional(),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "modelId": zod.string(),
  "settings": zod.record(zod.string(), zod.unknown()),
  "inputHash": zod.string().regex(resumeBidSynthesisResponseInputHashRegExp),
  "progressCompleted": zod.int().min(resumeBidSynthesisResponseProgressCompletedMin),
  "progressTotal": zod.int().min(1),
  "attemptCount": zod.int().min(resumeBidSynthesisResponseAttemptCountMin),
  "maxAttempts": zod.int().min(1).max(resumeBidSynthesisResponseMaxAttemptsMax),
  "cancelRequested": zod.boolean(),
  "usage": zod.record(zod.string(), zod.unknown()).nullish(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const decideBidSynthesisProposalParams = zod.object({
  "id": zod.uuid(),
  "runId": zod.uuid(),
  "proposalId": zod.uuid()
})

export const decideBidSynthesisProposalBodyNoteMax = 2000;



export const decideBidSynthesisProposalBody = zod.object({
  "decision": zod.enum(['accept', 'reject']),
  "note": zod.string().max(decideBidSynthesisProposalBodyNoteMax).optional()
})


export const decideBidSynthesisProposalResponseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const decideBidSynthesisProposalResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "runId": zod.uuid(),
  "targetType": zod.enum(['tender', 'requirement', 'section']),
  "targetId": zod.uuid().nullish(),
  "baseRevision": zod.int().min(1),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "content": zod.record(zod.string(), zod.unknown()),
  "citations": zod.array(zod.record(zod.string(), zod.unknown())),
  "contentHash": zod.string().regex(decideBidSynthesisProposalResponseContentHashRegExp),
  "decisionNote": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish()
})


export const getBidStageModelsParams = zod.object({
  "id": zod.uuid(),
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review'])
})

export const getBidStageModelsQueryLimitDefault = 50;
export const getBidStageModelsQueryLimitMax = 100;

export const getBidStageModelsQueryOffsetDefault = 0;
export const getBidStageModelsQueryOffsetMin = 0;



export const getBidStageModelsQueryParams = zod.object({
  "limit": zod.int().min(1).max(getBidStageModelsQueryLimitMax).default(getBidStageModelsQueryLimitDefault),
  "offset": zod.int().min(getBidStageModelsQueryOffsetMin).default(getBidStageModelsQueryOffsetDefault)
})

export const getBidStageModelsResponseSelectionOneChoiceIdMax = 64;



export const getBidStageModelsResponseSelectionOnePolicyFingerprintMax = 64;

export const getBidStageModelsResponseSelectionOneSettingsMaxOutputTokensMax = 131072;

export const getBidStageModelsResponseSelectionOneSettingsTimeoutMsMin = 1000;
export const getBidStageModelsResponseSelectionOneSettingsTimeoutMsMax = 120000;

export const getBidStageModelsResponsePolicyFingerprintMax = 64;

export const getBidStageModelsResponseRecommendedChoiceIdMax = 64;

export const getBidStageModelsResponseChoicesItemModelRecordChoiceIdRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getBidStageModelsResponseChoicesItemModelRecordRevisionMax = 4000000;

export const getBidStageModelsResponseChoicesItemModelRecordDataDisplayNameMax = 120;

export const getBidStageModelsResponseChoicesItemModelRecordDataDescriptionMax = 1000;

export const getBidStageModelsResponseChoicesItemModelRecordDataConnectionRefRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getBidStageModelsResponseChoicesItemModelRecordDataStagesMax = 4;

export const getBidStageModelsResponseChoicesItemModelRecordDataReasoningEffortsMax = 6;

export const getBidStageModelsResponseChoicesItemModelRecordDataContextWindowTokensMax = 4000000;

export const getBidStageModelsResponseChoicesItemModelRecordDataMaxOutputTokensMax = 131072;

export const getBidStageModelsResponseChoicesItemModelRecordDataCapabilityEvidenceSourceRefMax = 1000;

export const getBidStageModelsResponseChoicesItemModelRecordDataProcessingLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const getBidStageModelsResponseChoicesItemModelRecordDataProcessingLocationsMax = 40;

export const getBidStageModelsResponseChoicesItemModelRecordDataProcessingEvidenceSourceRefMax = 1000;

export const getBidStageModelsResponseChoicesItemModelRecordDataInputPerMillionUsdMin = 0;
export const getBidStageModelsResponseChoicesItemModelRecordDataInputPerMillionUsdMax = 100000;

export const getBidStageModelsResponseChoicesItemModelRecordDataOutputPerMillionUsdMin = 0;
export const getBidStageModelsResponseChoicesItemModelRecordDataOutputPerMillionUsdMax = 100000;

export const getBidStageModelsResponseChoicesItemModelRecordDataLatencyMsMax = 3600000;

export const getBidStageModelsResponseChoicesItemModelRecordDataPerformanceEvidenceSourceRefMax = 1000;

export const getBidStageModelsResponseChoicesItemModelRecordReasonMin = 10;
export const getBidStageModelsResponseChoicesItemModelRecordReasonMax = 2000;

export const getBidStageModelsResponseChoicesItemModelReasonsItemMax = 1000;

export const getBidStageModelsResponseChoicesItemModelReasonsMax = 20;


export const getBidStageModelsResponseChoicesItemMaxTimeoutMsMin = 1000;

export const getBidStageModelsResponseChoicesItemReasoningEffortsMax = 6;

export const getBidStageModelsResponseChoicesItemReasonsItemMax = 1000;

export const getBidStageModelsResponseChoicesItemReasonsMax = 30;

export const getBidStageModelsResponseChoicesItemLimitationsItemMax = 1000;

export const getBidStageModelsResponseChoicesItemLimitationsMax = 30;

export const getBidStageModelsResponseChoicesMax = 100;



export const getBidStageModelsResponse = zod.object({
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review']),
  "selection": zod.union([zod.object({
  "id": zod.uuid(),
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review']),
  "choiceId": zod.string().max(getBidStageModelsResponseSelectionOneChoiceIdMax),
  "revision": zod.int().min(1),
  "modelRevision": zod.int().min(1),
  "policyFingerprint": zod.string().max(getBidStageModelsResponseSelectionOnePolicyFingerprintMax),
  "settings": zod.object({
  "reasoningEffort": zod.union([zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh']),zod.null()]),
  "maxOutputTokens": zod.int().min(1).max(getBidStageModelsResponseSelectionOneSettingsMaxOutputTokensMax),
  "timeoutMs": zod.int().min(getBidStageModelsResponseSelectionOneSettingsTimeoutMsMin).max(getBidStageModelsResponseSelectionOneSettingsTimeoutMsMax)
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "policyFingerprint": zod.string().max(getBidStageModelsResponsePolicyFingerprintMax),
  "recommendedChoiceId": zod.string().max(getBidStageModelsResponseRecommendedChoiceIdMax).nullable(),
  "choices": zod.array(zod.object({
  "model": zod.object({
  "record": zod.object({
  "id": zod.uuid(),
  "choiceId": zod.string().regex(getBidStageModelsResponseChoicesItemModelRecordChoiceIdRegExp),
  "revision": zod.int().min(1).max(getBidStageModelsResponseChoicesItemModelRecordRevisionMax),
  "data": zod.object({
  "displayName": zod.string().min(1).max(getBidStageModelsResponseChoicesItemModelRecordDataDisplayNameMax),
  "description": zod.string().max(getBidStageModelsResponseChoicesItemModelRecordDataDescriptionMax),
  "status": zod.enum(['active', 'disabled', 'removed']),
  "connectionRef": zod.string().regex(getBidStageModelsResponseChoicesItemModelRecordDataConnectionRefRegExp),
  "adapter": zod.enum(['chat-completions', 'unsupported']),
  "stages": zod.array(zod.enum(['research', 'assessment', 'drafting', 'buyer_review'])).max(getBidStageModelsResponseChoicesItemModelRecordDataStagesMax),
  "reasoningEfforts": zod.array(zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh'])).max(getBidStageModelsResponseChoicesItemModelRecordDataReasoningEffortsMax),
  "contextWindowTokens": zod.int().min(1).max(getBidStageModelsResponseChoicesItemModelRecordDataContextWindowTokensMax).nullable(),
  "maxOutputTokens": zod.int().min(1).max(getBidStageModelsResponseChoicesItemModelRecordDataMaxOutputTokensMax).nullable(),
  "capabilityEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(getBidStageModelsResponseChoicesItemModelRecordDataCapabilityEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "processingLocations": zod.array(zod.string().regex(getBidStageModelsResponseChoicesItemModelRecordDataProcessingLocationsItemRegExp)).max(getBidStageModelsResponseChoicesItemModelRecordDataProcessingLocationsMax),
  "processingScope": zod.enum(['regional', 'global', 'unknown']),
  "processingEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(getBidStageModelsResponseChoicesItemModelRecordDataProcessingEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "inputPerMillionUsd": zod.number().min(getBidStageModelsResponseChoicesItemModelRecordDataInputPerMillionUsdMin).max(getBidStageModelsResponseChoicesItemModelRecordDataInputPerMillionUsdMax).nullable(),
  "outputPerMillionUsd": zod.number().min(getBidStageModelsResponseChoicesItemModelRecordDataOutputPerMillionUsdMin).max(getBidStageModelsResponseChoicesItemModelRecordDataOutputPerMillionUsdMax).nullable(),
  "latencyMs": zod.int().min(1).max(getBidStageModelsResponseChoicesItemModelRecordDataLatencyMsMax).nullable(),
  "performanceEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(getBidStageModelsResponseChoicesItemModelRecordDataPerformanceEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(getBidStageModelsResponseChoicesItemModelRecordReasonMin).max(getBidStageModelsResponseChoicesItemModelRecordReasonMax)
}),
  "configured": zod.boolean(),
  "policyEligible": zod.boolean(),
  "executable": zod.boolean(),
  "liveVerified": zod.boolean(),
  "reasons": zod.array(zod.string().max(getBidStageModelsResponseChoicesItemModelReasonsItemMax)).max(getBidStageModelsResponseChoicesItemModelReasonsMax)
}),
  "contextWindowTokens": zod.int().nullable(),
  "maxOutputTokens": zod.int().min(1),
  "maxTimeoutMs": zod.int().min(getBidStageModelsResponseChoicesItemMaxTimeoutMsMin),
  "reasoningEfforts": zod.array(zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh'])).max(getBidStageModelsResponseChoicesItemReasoningEffortsMax),
  "reasons": zod.array(zod.string().max(getBidStageModelsResponseChoicesItemReasonsItemMax)).max(getBidStageModelsResponseChoicesItemReasonsMax),
  "limitations": zod.array(zod.string().max(getBidStageModelsResponseChoicesItemLimitationsItemMax)).max(getBidStageModelsResponseChoicesItemLimitationsMax)
})).max(getBidStageModelsResponseChoicesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const saveBidStageSelectionParams = zod.object({
  "id": zod.uuid(),
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review'])
})

export const saveBidStageSelectionBodyExpectedRevisionMin = 0;

export const saveBidStageSelectionBodyChoiceIdMax = 64;


export const saveBidStageSelectionBodyChoiceIdRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');

export const saveBidStageSelectionBodyPolicyFingerprintMin = 64;
export const saveBidStageSelectionBodyPolicyFingerprintMax = 64;

export const saveBidStageSelectionBodySettingsMaxOutputTokensMax = 131072;

export const saveBidStageSelectionBodySettingsTimeoutMsMin = 1000;
export const saveBidStageSelectionBodySettingsTimeoutMsMax = 120000;



export const saveBidStageSelectionBody = zod.object({
  "expectedRevision": zod.int().min(saveBidStageSelectionBodyExpectedRevisionMin),
  "choiceId": zod.string().max(saveBidStageSelectionBodyChoiceIdMax).regex(saveBidStageSelectionBodyChoiceIdRegExp),
  "expectedModelRevision": zod.int().min(1),
  "policyFingerprint": zod.string().min(saveBidStageSelectionBodyPolicyFingerprintMin).max(saveBidStageSelectionBodyPolicyFingerprintMax),
  "settings": zod.object({
  "reasoningEffort": zod.union([zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh']),zod.null()]),
  "maxOutputTokens": zod.int().min(1).max(saveBidStageSelectionBodySettingsMaxOutputTokensMax),
  "timeoutMs": zod.int().min(saveBidStageSelectionBodySettingsTimeoutMsMin).max(saveBidStageSelectionBodySettingsTimeoutMsMax)
})
})

export const saveBidStageSelectionResponseChoiceIdMax = 64;



export const saveBidStageSelectionResponsePolicyFingerprintMax = 64;

export const saveBidStageSelectionResponseSettingsMaxOutputTokensMax = 131072;

export const saveBidStageSelectionResponseSettingsTimeoutMsMin = 1000;
export const saveBidStageSelectionResponseSettingsTimeoutMsMax = 120000;



export const saveBidStageSelectionResponse = zod.object({
  "id": zod.uuid(),
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review']),
  "choiceId": zod.string().max(saveBidStageSelectionResponseChoiceIdMax),
  "revision": zod.int().min(1),
  "modelRevision": zod.int().min(1),
  "policyFingerprint": zod.string().max(saveBidStageSelectionResponsePolicyFingerprintMax),
  "settings": zod.object({
  "reasoningEffort": zod.union([zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh']),zod.null()]),
  "maxOutputTokens": zod.int().min(1).max(saveBidStageSelectionResponseSettingsMaxOutputTokensMax),
  "timeoutMs": zod.int().min(saveBidStageSelectionResponseSettingsTimeoutMsMin).max(saveBidStageSelectionResponseSettingsTimeoutMsMax)
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})


export const createBidStageRunParams = zod.object({
  "id": zod.uuid(),
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review'])
})

export const createBidStageRunHeaderIdempotencyKeyMax = 128;



export const createBidStageRunHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createBidStageRunHeaderIdempotencyKeyMax)
})


export const createBidStageRunBodyInstructionMax = 4000;



export const createBidStageRunBody = zod.object({
  "selectionRevision": zod.int().min(1),
  "instruction": zod.string().max(createBidStageRunBodyInstructionMax).optional(),
  "planRevisionId": zod.uuid().nullish()
})

export const createBidStageRunResponseWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createBidStageRunResponseInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createBidStageRunResponseProgressCompletedMin = 0;


export const createBidStageRunResponseAttemptCountMin = 0;

export const createBidStageRunResponseMaxAttemptsMax = 5;



export const createBidStageRunResponse = zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(createBidStageRunResponseWorkspaceContextManifestHashRegExp)
}).optional(),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "modelId": zod.string(),
  "settings": zod.record(zod.string(), zod.unknown()),
  "inputHash": zod.string().regex(createBidStageRunResponseInputHashRegExp),
  "progressCompleted": zod.int().min(createBidStageRunResponseProgressCompletedMin),
  "progressTotal": zod.int().min(1),
  "attemptCount": zod.int().min(createBidStageRunResponseAttemptCountMin),
  "maxAttempts": zod.int().min(1).max(createBidStageRunResponseMaxAttemptsMax),
  "cancelRequested": zod.boolean(),
  "usage": zod.record(zod.string(), zod.unknown()).nullish(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getBidModelAdministrationParams = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})

export const getBidModelAdministrationQueryLimitDefault = 25;
export const getBidModelAdministrationQueryLimitMax = 100;

export const getBidModelAdministrationQueryOffsetDefault = 0;
export const getBidModelAdministrationQueryOffsetMin = 0;



export const getBidModelAdministrationQueryParams = zod.object({
  "limit": zod.int().min(1).max(getBidModelAdministrationQueryLimitMax).default(getBidModelAdministrationQueryLimitDefault),
  "offset": zod.int().min(getBidModelAdministrationQueryOffsetMin).default(getBidModelAdministrationQueryOffsetDefault)
})

export const getBidModelAdministrationResponseLocalPolicyOneRevisionMax = 4000000;

export const getBidModelAdministrationResponseLocalPolicyOnePolicyAllowedChoiceIdsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getBidModelAdministrationResponseLocalPolicyOnePolicyAllowedChoiceIdsMax = 200;

export const getBidModelAdministrationResponseLocalPolicyOnePolicyAllowedLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const getBidModelAdministrationResponseLocalPolicyOnePolicyAllowedLocationsMax = 40;

export const getBidModelAdministrationResponseLocalPolicyOneReasonMin = 10;
export const getBidModelAdministrationResponseLocalPolicyOneReasonMax = 2000;

export const getBidModelAdministrationResponseParentsItemRevisionMax = 4000000;

export const getBidModelAdministrationResponseParentsItemPolicyAllowedChoiceIdsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getBidModelAdministrationResponseParentsItemPolicyAllowedChoiceIdsMax = 200;

export const getBidModelAdministrationResponseParentsItemPolicyAllowedLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const getBidModelAdministrationResponseParentsItemPolicyAllowedLocationsMax = 40;

export const getBidModelAdministrationResponseParentsItemReasonMin = 10;
export const getBidModelAdministrationResponseParentsItemReasonMax = 2000;

export const getBidModelAdministrationResponseParentsMax = 2;

export const getBidModelAdministrationResponseEffectivePolicyAllowedChoiceIdsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getBidModelAdministrationResponseEffectivePolicyAllowedChoiceIdsMax = 200;

export const getBidModelAdministrationResponseEffectivePolicyAllowedLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const getBidModelAdministrationResponseEffectivePolicyAllowedLocationsMax = 40;

export const getBidModelAdministrationResponseParentFingerprintMax = 64;

export const getBidModelAdministrationResponseModelsItemRecordChoiceIdRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getBidModelAdministrationResponseModelsItemRecordRevisionMax = 4000000;

export const getBidModelAdministrationResponseModelsItemRecordDataDisplayNameMax = 120;

export const getBidModelAdministrationResponseModelsItemRecordDataDescriptionMax = 1000;

export const getBidModelAdministrationResponseModelsItemRecordDataConnectionRefRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getBidModelAdministrationResponseModelsItemRecordDataStagesMax = 4;

export const getBidModelAdministrationResponseModelsItemRecordDataReasoningEffortsMax = 6;

export const getBidModelAdministrationResponseModelsItemRecordDataContextWindowTokensMax = 4000000;

export const getBidModelAdministrationResponseModelsItemRecordDataMaxOutputTokensMax = 131072;

export const getBidModelAdministrationResponseModelsItemRecordDataCapabilityEvidenceSourceRefMax = 1000;

export const getBidModelAdministrationResponseModelsItemRecordDataProcessingLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const getBidModelAdministrationResponseModelsItemRecordDataProcessingLocationsMax = 40;

export const getBidModelAdministrationResponseModelsItemRecordDataProcessingEvidenceSourceRefMax = 1000;

export const getBidModelAdministrationResponseModelsItemRecordDataInputPerMillionUsdMin = 0;
export const getBidModelAdministrationResponseModelsItemRecordDataInputPerMillionUsdMax = 100000;

export const getBidModelAdministrationResponseModelsItemRecordDataOutputPerMillionUsdMin = 0;
export const getBidModelAdministrationResponseModelsItemRecordDataOutputPerMillionUsdMax = 100000;

export const getBidModelAdministrationResponseModelsItemRecordDataLatencyMsMax = 3600000;

export const getBidModelAdministrationResponseModelsItemRecordDataPerformanceEvidenceSourceRefMax = 1000;

export const getBidModelAdministrationResponseModelsItemRecordReasonMin = 10;
export const getBidModelAdministrationResponseModelsItemRecordReasonMax = 2000;

export const getBidModelAdministrationResponseModelsItemReasonsItemMax = 1000;

export const getBidModelAdministrationResponseModelsItemReasonsMax = 20;

export const getBidModelAdministrationResponseModelsMax = 100;

export const getBidModelAdministrationResponseConnectionRefsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getBidModelAdministrationResponseConnectionRefsMax = 20;



export const getBidModelAdministrationResponse = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localPolicy": zod.union([zod.object({
  "id": zod.uuid(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "revision": zod.int().min(1).max(getBidModelAdministrationResponseLocalPolicyOneRevisionMax),
  "policy": zod.object({
  "allowedChoiceIds": zod.array(zod.string().regex(getBidModelAdministrationResponseLocalPolicyOnePolicyAllowedChoiceIdsItemRegExp)).max(getBidModelAdministrationResponseLocalPolicyOnePolicyAllowedChoiceIdsMax).nullable(),
  "allowedLocations": zod.array(zod.string().regex(getBidModelAdministrationResponseLocalPolicyOnePolicyAllowedLocationsItemRegExp)).max(getBidModelAdministrationResponseLocalPolicyOnePolicyAllowedLocationsMax).nullable(),
  "requireVerifiedLocation": zod.boolean().nullable()
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(getBidModelAdministrationResponseLocalPolicyOneReasonMin).max(getBidModelAdministrationResponseLocalPolicyOneReasonMax)
}),zod.null()]),
  "parents": zod.array(zod.object({
  "id": zod.uuid(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "revision": zod.int().min(1).max(getBidModelAdministrationResponseParentsItemRevisionMax),
  "policy": zod.object({
  "allowedChoiceIds": zod.array(zod.string().regex(getBidModelAdministrationResponseParentsItemPolicyAllowedChoiceIdsItemRegExp)).max(getBidModelAdministrationResponseParentsItemPolicyAllowedChoiceIdsMax).nullable(),
  "allowedLocations": zod.array(zod.string().regex(getBidModelAdministrationResponseParentsItemPolicyAllowedLocationsItemRegExp)).max(getBidModelAdministrationResponseParentsItemPolicyAllowedLocationsMax).nullable(),
  "requireVerifiedLocation": zod.boolean().nullable()
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(getBidModelAdministrationResponseParentsItemReasonMin).max(getBidModelAdministrationResponseParentsItemReasonMax)
})).max(getBidModelAdministrationResponseParentsMax),
  "effectivePolicy": zod.object({
  "allowedChoiceIds": zod.array(zod.string().regex(getBidModelAdministrationResponseEffectivePolicyAllowedChoiceIdsItemRegExp)).max(getBidModelAdministrationResponseEffectivePolicyAllowedChoiceIdsMax).nullable(),
  "allowedLocations": zod.array(zod.string().regex(getBidModelAdministrationResponseEffectivePolicyAllowedLocationsItemRegExp)).max(getBidModelAdministrationResponseEffectivePolicyAllowedLocationsMax).nullable(),
  "requireVerifiedLocation": zod.boolean().nullable()
}),
  "parentFingerprint": zod.string().max(getBidModelAdministrationResponseParentFingerprintMax),
  "models": zod.array(zod.object({
  "record": zod.object({
  "id": zod.uuid(),
  "choiceId": zod.string().regex(getBidModelAdministrationResponseModelsItemRecordChoiceIdRegExp),
  "revision": zod.int().min(1).max(getBidModelAdministrationResponseModelsItemRecordRevisionMax),
  "data": zod.object({
  "displayName": zod.string().min(1).max(getBidModelAdministrationResponseModelsItemRecordDataDisplayNameMax),
  "description": zod.string().max(getBidModelAdministrationResponseModelsItemRecordDataDescriptionMax),
  "status": zod.enum(['active', 'disabled', 'removed']),
  "connectionRef": zod.string().regex(getBidModelAdministrationResponseModelsItemRecordDataConnectionRefRegExp),
  "adapter": zod.enum(['chat-completions', 'unsupported']),
  "stages": zod.array(zod.enum(['research', 'assessment', 'drafting', 'buyer_review'])).max(getBidModelAdministrationResponseModelsItemRecordDataStagesMax),
  "reasoningEfforts": zod.array(zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh'])).max(getBidModelAdministrationResponseModelsItemRecordDataReasoningEffortsMax),
  "contextWindowTokens": zod.int().min(1).max(getBidModelAdministrationResponseModelsItemRecordDataContextWindowTokensMax).nullable(),
  "maxOutputTokens": zod.int().min(1).max(getBidModelAdministrationResponseModelsItemRecordDataMaxOutputTokensMax).nullable(),
  "capabilityEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(getBidModelAdministrationResponseModelsItemRecordDataCapabilityEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "processingLocations": zod.array(zod.string().regex(getBidModelAdministrationResponseModelsItemRecordDataProcessingLocationsItemRegExp)).max(getBidModelAdministrationResponseModelsItemRecordDataProcessingLocationsMax),
  "processingScope": zod.enum(['regional', 'global', 'unknown']),
  "processingEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(getBidModelAdministrationResponseModelsItemRecordDataProcessingEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "inputPerMillionUsd": zod.number().min(getBidModelAdministrationResponseModelsItemRecordDataInputPerMillionUsdMin).max(getBidModelAdministrationResponseModelsItemRecordDataInputPerMillionUsdMax).nullable(),
  "outputPerMillionUsd": zod.number().min(getBidModelAdministrationResponseModelsItemRecordDataOutputPerMillionUsdMin).max(getBidModelAdministrationResponseModelsItemRecordDataOutputPerMillionUsdMax).nullable(),
  "latencyMs": zod.int().min(1).max(getBidModelAdministrationResponseModelsItemRecordDataLatencyMsMax).nullable(),
  "performanceEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(getBidModelAdministrationResponseModelsItemRecordDataPerformanceEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(getBidModelAdministrationResponseModelsItemRecordReasonMin).max(getBidModelAdministrationResponseModelsItemRecordReasonMax)
}),
  "configured": zod.boolean(),
  "policyEligible": zod.boolean(),
  "executable": zod.boolean(),
  "liveVerified": zod.boolean(),
  "reasons": zod.array(zod.string().max(getBidModelAdministrationResponseModelsItemReasonsItemMax)).max(getBidModelAdministrationResponseModelsItemReasonsMax)
})).max(getBidModelAdministrationResponseModelsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "connectionRefs": zod.array(zod.string().regex(getBidModelAdministrationResponseConnectionRefsItemRegExp)).max(getBidModelAdministrationResponseConnectionRefsMax)
})


export const writeBidProcessingPolicyParams = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})

export const writeBidProcessingPolicyBodyExpectedRevisionMin = 0;

export const writeBidProcessingPolicyBodyParentFingerprintMin = 64;
export const writeBidProcessingPolicyBodyParentFingerprintMax = 64;

export const writeBidProcessingPolicyBodyPolicyAllowedChoiceIdsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const writeBidProcessingPolicyBodyPolicyAllowedChoiceIdsMax = 200;

export const writeBidProcessingPolicyBodyPolicyAllowedLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const writeBidProcessingPolicyBodyPolicyAllowedLocationsMax = 40;

export const writeBidProcessingPolicyBodyReasonMin = 10;
export const writeBidProcessingPolicyBodyReasonMax = 2000;



export const writeBidProcessingPolicyBody = zod.object({
  "expectedRevision": zod.int().min(writeBidProcessingPolicyBodyExpectedRevisionMin),
  "parentFingerprint": zod.string().min(writeBidProcessingPolicyBodyParentFingerprintMin).max(writeBidProcessingPolicyBodyParentFingerprintMax),
  "policy": zod.object({
  "allowedChoiceIds": zod.array(zod.string().regex(writeBidProcessingPolicyBodyPolicyAllowedChoiceIdsItemRegExp)).max(writeBidProcessingPolicyBodyPolicyAllowedChoiceIdsMax).nullable(),
  "allowedLocations": zod.array(zod.string().regex(writeBidProcessingPolicyBodyPolicyAllowedLocationsItemRegExp)).max(writeBidProcessingPolicyBodyPolicyAllowedLocationsMax).nullable(),
  "requireVerifiedLocation": zod.boolean().nullable()
}),
  "reason": zod.string().min(writeBidProcessingPolicyBodyReasonMin).max(writeBidProcessingPolicyBodyReasonMax)
})

export const writeBidProcessingPolicyResponseRevisionMax = 4000000;

export const writeBidProcessingPolicyResponsePolicyAllowedChoiceIdsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const writeBidProcessingPolicyResponsePolicyAllowedChoiceIdsMax = 200;

export const writeBidProcessingPolicyResponsePolicyAllowedLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const writeBidProcessingPolicyResponsePolicyAllowedLocationsMax = 40;

export const writeBidProcessingPolicyResponseReasonMin = 10;
export const writeBidProcessingPolicyResponseReasonMax = 2000;



export const writeBidProcessingPolicyResponse = zod.object({
  "id": zod.uuid(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "revision": zod.int().min(1).max(writeBidProcessingPolicyResponseRevisionMax),
  "policy": zod.object({
  "allowedChoiceIds": zod.array(zod.string().regex(writeBidProcessingPolicyResponsePolicyAllowedChoiceIdsItemRegExp)).max(writeBidProcessingPolicyResponsePolicyAllowedChoiceIdsMax).nullable(),
  "allowedLocations": zod.array(zod.string().regex(writeBidProcessingPolicyResponsePolicyAllowedLocationsItemRegExp)).max(writeBidProcessingPolicyResponsePolicyAllowedLocationsMax).nullable(),
  "requireVerifiedLocation": zod.boolean().nullable()
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(writeBidProcessingPolicyResponseReasonMin).max(writeBidProcessingPolicyResponseReasonMax)
})


export const writeBidModelRecordPathChoiceIdRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');


export const writeBidModelRecordParams = zod.object({
  "choiceId": zod.string().regex(writeBidModelRecordPathChoiceIdRegExp)
})

export const writeBidModelRecordBodyExpectedRevisionMin = 0;

export const writeBidModelRecordBodyDataDisplayNameMax = 120;

export const writeBidModelRecordBodyDataDescriptionMax = 1000;

export const writeBidModelRecordBodyDataConnectionRefRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const writeBidModelRecordBodyDataStagesMax = 4;

export const writeBidModelRecordBodyDataReasoningEffortsMax = 6;

export const writeBidModelRecordBodyDataContextWindowTokensMax = 4000000;

export const writeBidModelRecordBodyDataMaxOutputTokensMax = 131072;

export const writeBidModelRecordBodyDataCapabilityEvidenceSourceRefMax = 1000;

export const writeBidModelRecordBodyDataProcessingLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const writeBidModelRecordBodyDataProcessingLocationsMax = 40;

export const writeBidModelRecordBodyDataProcessingEvidenceSourceRefMax = 1000;

export const writeBidModelRecordBodyDataInputPerMillionUsdMin = 0;
export const writeBidModelRecordBodyDataInputPerMillionUsdMax = 100000;

export const writeBidModelRecordBodyDataOutputPerMillionUsdMin = 0;
export const writeBidModelRecordBodyDataOutputPerMillionUsdMax = 100000;

export const writeBidModelRecordBodyDataLatencyMsMax = 3600000;

export const writeBidModelRecordBodyDataPerformanceEvidenceSourceRefMax = 1000;

export const writeBidModelRecordBodyReasonMin = 10;
export const writeBidModelRecordBodyReasonMax = 2000;



export const writeBidModelRecordBody = zod.object({
  "expectedRevision": zod.int().min(writeBidModelRecordBodyExpectedRevisionMin),
  "data": zod.object({
  "displayName": zod.string().min(1).max(writeBidModelRecordBodyDataDisplayNameMax),
  "description": zod.string().max(writeBidModelRecordBodyDataDescriptionMax),
  "status": zod.enum(['active', 'disabled', 'removed']),
  "connectionRef": zod.string().regex(writeBidModelRecordBodyDataConnectionRefRegExp),
  "adapter": zod.enum(['chat-completions', 'unsupported']),
  "stages": zod.array(zod.enum(['research', 'assessment', 'drafting', 'buyer_review'])).max(writeBidModelRecordBodyDataStagesMax),
  "reasoningEfforts": zod.array(zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh'])).max(writeBidModelRecordBodyDataReasoningEffortsMax),
  "contextWindowTokens": zod.int().min(1).max(writeBidModelRecordBodyDataContextWindowTokensMax).nullable(),
  "maxOutputTokens": zod.int().min(1).max(writeBidModelRecordBodyDataMaxOutputTokensMax).nullable(),
  "capabilityEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(writeBidModelRecordBodyDataCapabilityEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "processingLocations": zod.array(zod.string().regex(writeBidModelRecordBodyDataProcessingLocationsItemRegExp)).max(writeBidModelRecordBodyDataProcessingLocationsMax),
  "processingScope": zod.enum(['regional', 'global', 'unknown']),
  "processingEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(writeBidModelRecordBodyDataProcessingEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "inputPerMillionUsd": zod.number().min(writeBidModelRecordBodyDataInputPerMillionUsdMin).max(writeBidModelRecordBodyDataInputPerMillionUsdMax).nullable(),
  "outputPerMillionUsd": zod.number().min(writeBidModelRecordBodyDataOutputPerMillionUsdMin).max(writeBidModelRecordBodyDataOutputPerMillionUsdMax).nullable(),
  "latencyMs": zod.int().min(1).max(writeBidModelRecordBodyDataLatencyMsMax).nullable(),
  "performanceEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(writeBidModelRecordBodyDataPerformanceEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),
  "reason": zod.string().min(writeBidModelRecordBodyReasonMin).max(writeBidModelRecordBodyReasonMax)
})

export const writeBidModelRecordResponseChoiceIdRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const writeBidModelRecordResponseRevisionMax = 4000000;

export const writeBidModelRecordResponseDataDisplayNameMax = 120;

export const writeBidModelRecordResponseDataDescriptionMax = 1000;

export const writeBidModelRecordResponseDataConnectionRefRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const writeBidModelRecordResponseDataStagesMax = 4;

export const writeBidModelRecordResponseDataReasoningEffortsMax = 6;

export const writeBidModelRecordResponseDataContextWindowTokensMax = 4000000;

export const writeBidModelRecordResponseDataMaxOutputTokensMax = 131072;

export const writeBidModelRecordResponseDataCapabilityEvidenceSourceRefMax = 1000;

export const writeBidModelRecordResponseDataProcessingLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const writeBidModelRecordResponseDataProcessingLocationsMax = 40;

export const writeBidModelRecordResponseDataProcessingEvidenceSourceRefMax = 1000;

export const writeBidModelRecordResponseDataInputPerMillionUsdMin = 0;
export const writeBidModelRecordResponseDataInputPerMillionUsdMax = 100000;

export const writeBidModelRecordResponseDataOutputPerMillionUsdMin = 0;
export const writeBidModelRecordResponseDataOutputPerMillionUsdMax = 100000;

export const writeBidModelRecordResponseDataLatencyMsMax = 3600000;

export const writeBidModelRecordResponseDataPerformanceEvidenceSourceRefMax = 1000;

export const writeBidModelRecordResponseReasonMin = 10;
export const writeBidModelRecordResponseReasonMax = 2000;



export const writeBidModelRecordResponse = zod.object({
  "id": zod.uuid(),
  "choiceId": zod.string().regex(writeBidModelRecordResponseChoiceIdRegExp),
  "revision": zod.int().min(1).max(writeBidModelRecordResponseRevisionMax),
  "data": zod.object({
  "displayName": zod.string().min(1).max(writeBidModelRecordResponseDataDisplayNameMax),
  "description": zod.string().max(writeBidModelRecordResponseDataDescriptionMax),
  "status": zod.enum(['active', 'disabled', 'removed']),
  "connectionRef": zod.string().regex(writeBidModelRecordResponseDataConnectionRefRegExp),
  "adapter": zod.enum(['chat-completions', 'unsupported']),
  "stages": zod.array(zod.enum(['research', 'assessment', 'drafting', 'buyer_review'])).max(writeBidModelRecordResponseDataStagesMax),
  "reasoningEfforts": zod.array(zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh'])).max(writeBidModelRecordResponseDataReasoningEffortsMax),
  "contextWindowTokens": zod.int().min(1).max(writeBidModelRecordResponseDataContextWindowTokensMax).nullable(),
  "maxOutputTokens": zod.int().min(1).max(writeBidModelRecordResponseDataMaxOutputTokensMax).nullable(),
  "capabilityEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(writeBidModelRecordResponseDataCapabilityEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "processingLocations": zod.array(zod.string().regex(writeBidModelRecordResponseDataProcessingLocationsItemRegExp)).max(writeBidModelRecordResponseDataProcessingLocationsMax),
  "processingScope": zod.enum(['regional', 'global', 'unknown']),
  "processingEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(writeBidModelRecordResponseDataProcessingEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "inputPerMillionUsd": zod.number().min(writeBidModelRecordResponseDataInputPerMillionUsdMin).max(writeBidModelRecordResponseDataInputPerMillionUsdMax).nullable(),
  "outputPerMillionUsd": zod.number().min(writeBidModelRecordResponseDataOutputPerMillionUsdMin).max(writeBidModelRecordResponseDataOutputPerMillionUsdMax).nullable(),
  "latencyMs": zod.int().min(1).max(writeBidModelRecordResponseDataLatencyMsMax).nullable(),
  "performanceEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(writeBidModelRecordResponseDataPerformanceEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(writeBidModelRecordResponseReasonMin).max(writeBidModelRecordResponseReasonMax)
})


export const listBidModelRevisionsPathChoiceIdRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');


export const listBidModelRevisionsParams = zod.object({
  "choiceId": zod.string().regex(listBidModelRevisionsPathChoiceIdRegExp)
})

export const listBidModelRevisionsQueryLimitDefault = 25;
export const listBidModelRevisionsQueryLimitMax = 100;

export const listBidModelRevisionsQueryOffsetDefault = 0;
export const listBidModelRevisionsQueryOffsetMin = 0;



export const listBidModelRevisionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listBidModelRevisionsQueryLimitMax).default(listBidModelRevisionsQueryLimitDefault),
  "offset": zod.int().min(listBidModelRevisionsQueryOffsetMin).default(listBidModelRevisionsQueryOffsetDefault)
})

export const listBidModelRevisionsResponseItemsItemChoiceIdRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const listBidModelRevisionsResponseItemsItemRevisionMax = 4000000;

export const listBidModelRevisionsResponseItemsItemDataDisplayNameMax = 120;

export const listBidModelRevisionsResponseItemsItemDataDescriptionMax = 1000;

export const listBidModelRevisionsResponseItemsItemDataConnectionRefRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const listBidModelRevisionsResponseItemsItemDataStagesMax = 4;

export const listBidModelRevisionsResponseItemsItemDataReasoningEffortsMax = 6;

export const listBidModelRevisionsResponseItemsItemDataContextWindowTokensMax = 4000000;

export const listBidModelRevisionsResponseItemsItemDataMaxOutputTokensMax = 131072;

export const listBidModelRevisionsResponseItemsItemDataCapabilityEvidenceSourceRefMax = 1000;

export const listBidModelRevisionsResponseItemsItemDataProcessingLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const listBidModelRevisionsResponseItemsItemDataProcessingLocationsMax = 40;

export const listBidModelRevisionsResponseItemsItemDataProcessingEvidenceSourceRefMax = 1000;

export const listBidModelRevisionsResponseItemsItemDataInputPerMillionUsdMin = 0;
export const listBidModelRevisionsResponseItemsItemDataInputPerMillionUsdMax = 100000;

export const listBidModelRevisionsResponseItemsItemDataOutputPerMillionUsdMin = 0;
export const listBidModelRevisionsResponseItemsItemDataOutputPerMillionUsdMax = 100000;

export const listBidModelRevisionsResponseItemsItemDataLatencyMsMax = 3600000;

export const listBidModelRevisionsResponseItemsItemDataPerformanceEvidenceSourceRefMax = 1000;

export const listBidModelRevisionsResponseItemsItemReasonMin = 10;
export const listBidModelRevisionsResponseItemsItemReasonMax = 2000;

export const listBidModelRevisionsResponseItemsMax = 100;



export const listBidModelRevisionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "choiceId": zod.string().regex(listBidModelRevisionsResponseItemsItemChoiceIdRegExp),
  "revision": zod.int().min(1).max(listBidModelRevisionsResponseItemsItemRevisionMax),
  "data": zod.object({
  "displayName": zod.string().min(1).max(listBidModelRevisionsResponseItemsItemDataDisplayNameMax),
  "description": zod.string().max(listBidModelRevisionsResponseItemsItemDataDescriptionMax),
  "status": zod.enum(['active', 'disabled', 'removed']),
  "connectionRef": zod.string().regex(listBidModelRevisionsResponseItemsItemDataConnectionRefRegExp),
  "adapter": zod.enum(['chat-completions', 'unsupported']),
  "stages": zod.array(zod.enum(['research', 'assessment', 'drafting', 'buyer_review'])).max(listBidModelRevisionsResponseItemsItemDataStagesMax),
  "reasoningEfforts": zod.array(zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh'])).max(listBidModelRevisionsResponseItemsItemDataReasoningEffortsMax),
  "contextWindowTokens": zod.int().min(1).max(listBidModelRevisionsResponseItemsItemDataContextWindowTokensMax).nullable(),
  "maxOutputTokens": zod.int().min(1).max(listBidModelRevisionsResponseItemsItemDataMaxOutputTokensMax).nullable(),
  "capabilityEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(listBidModelRevisionsResponseItemsItemDataCapabilityEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "processingLocations": zod.array(zod.string().regex(listBidModelRevisionsResponseItemsItemDataProcessingLocationsItemRegExp)).max(listBidModelRevisionsResponseItemsItemDataProcessingLocationsMax),
  "processingScope": zod.enum(['regional', 'global', 'unknown']),
  "processingEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(listBidModelRevisionsResponseItemsItemDataProcessingEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "inputPerMillionUsd": zod.number().min(listBidModelRevisionsResponseItemsItemDataInputPerMillionUsdMin).max(listBidModelRevisionsResponseItemsItemDataInputPerMillionUsdMax).nullable(),
  "outputPerMillionUsd": zod.number().min(listBidModelRevisionsResponseItemsItemDataOutputPerMillionUsdMin).max(listBidModelRevisionsResponseItemsItemDataOutputPerMillionUsdMax).nullable(),
  "latencyMs": zod.int().min(1).max(listBidModelRevisionsResponseItemsItemDataLatencyMsMax).nullable(),
  "performanceEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(listBidModelRevisionsResponseItemsItemDataPerformanceEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(listBidModelRevisionsResponseItemsItemReasonMin).max(listBidModelRevisionsResponseItemsItemReasonMax)
})).max(listBidModelRevisionsResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const listBidPolicyRevisionsParams = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})

export const listBidPolicyRevisionsQueryLimitDefault = 25;
export const listBidPolicyRevisionsQueryLimitMax = 100;

export const listBidPolicyRevisionsQueryOffsetDefault = 0;
export const listBidPolicyRevisionsQueryOffsetMin = 0;



export const listBidPolicyRevisionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listBidPolicyRevisionsQueryLimitMax).default(listBidPolicyRevisionsQueryLimitDefault),
  "offset": zod.int().min(listBidPolicyRevisionsQueryOffsetMin).default(listBidPolicyRevisionsQueryOffsetDefault)
})

export const listBidPolicyRevisionsResponseItemsItemRevisionMax = 4000000;

export const listBidPolicyRevisionsResponseItemsItemPolicyAllowedChoiceIdsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const listBidPolicyRevisionsResponseItemsItemPolicyAllowedChoiceIdsMax = 200;

export const listBidPolicyRevisionsResponseItemsItemPolicyAllowedLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const listBidPolicyRevisionsResponseItemsItemPolicyAllowedLocationsMax = 40;

export const listBidPolicyRevisionsResponseItemsItemReasonMin = 10;
export const listBidPolicyRevisionsResponseItemsItemReasonMax = 2000;

export const listBidPolicyRevisionsResponseItemsMax = 100;



export const listBidPolicyRevisionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "revision": zod.int().min(1).max(listBidPolicyRevisionsResponseItemsItemRevisionMax),
  "policy": zod.object({
  "allowedChoiceIds": zod.array(zod.string().regex(listBidPolicyRevisionsResponseItemsItemPolicyAllowedChoiceIdsItemRegExp)).max(listBidPolicyRevisionsResponseItemsItemPolicyAllowedChoiceIdsMax).nullable(),
  "allowedLocations": zod.array(zod.string().regex(listBidPolicyRevisionsResponseItemsItemPolicyAllowedLocationsItemRegExp)).max(listBidPolicyRevisionsResponseItemsItemPolicyAllowedLocationsMax).nullable(),
  "requireVerifiedLocation": zod.boolean().nullable()
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(listBidPolicyRevisionsResponseItemsItemReasonMin).max(listBidPolicyRevisionsResponseItemsItemReasonMax)
})).max(listBidPolicyRevisionsResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getEffectiveBidModelsQueryLimitDefault = 25;
export const getEffectiveBidModelsQueryLimitMax = 100;

export const getEffectiveBidModelsQueryOffsetDefault = 0;
export const getEffectiveBidModelsQueryOffsetMin = 0;



export const getEffectiveBidModelsQueryParams = zod.object({
  "limit": zod.int().min(1).max(getEffectiveBidModelsQueryLimitMax).default(getEffectiveBidModelsQueryLimitDefault),
  "offset": zod.int().min(getEffectiveBidModelsQueryOffsetMin).default(getEffectiveBidModelsQueryOffsetDefault),
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review']).optional()
})

export const getEffectiveBidModelsResponseLocalPolicyOneRevisionMax = 4000000;

export const getEffectiveBidModelsResponseLocalPolicyOnePolicyAllowedChoiceIdsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getEffectiveBidModelsResponseLocalPolicyOnePolicyAllowedChoiceIdsMax = 200;

export const getEffectiveBidModelsResponseLocalPolicyOnePolicyAllowedLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const getEffectiveBidModelsResponseLocalPolicyOnePolicyAllowedLocationsMax = 40;

export const getEffectiveBidModelsResponseLocalPolicyOneReasonMin = 10;
export const getEffectiveBidModelsResponseLocalPolicyOneReasonMax = 2000;

export const getEffectiveBidModelsResponseParentsItemRevisionMax = 4000000;

export const getEffectiveBidModelsResponseParentsItemPolicyAllowedChoiceIdsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getEffectiveBidModelsResponseParentsItemPolicyAllowedChoiceIdsMax = 200;

export const getEffectiveBidModelsResponseParentsItemPolicyAllowedLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const getEffectiveBidModelsResponseParentsItemPolicyAllowedLocationsMax = 40;

export const getEffectiveBidModelsResponseParentsItemReasonMin = 10;
export const getEffectiveBidModelsResponseParentsItemReasonMax = 2000;

export const getEffectiveBidModelsResponseParentsMax = 2;

export const getEffectiveBidModelsResponseEffectivePolicyAllowedChoiceIdsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getEffectiveBidModelsResponseEffectivePolicyAllowedChoiceIdsMax = 200;

export const getEffectiveBidModelsResponseEffectivePolicyAllowedLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const getEffectiveBidModelsResponseEffectivePolicyAllowedLocationsMax = 40;

export const getEffectiveBidModelsResponseParentFingerprintMax = 64;

export const getEffectiveBidModelsResponseModelsItemRecordChoiceIdRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getEffectiveBidModelsResponseModelsItemRecordRevisionMax = 4000000;

export const getEffectiveBidModelsResponseModelsItemRecordDataDisplayNameMax = 120;

export const getEffectiveBidModelsResponseModelsItemRecordDataDescriptionMax = 1000;

export const getEffectiveBidModelsResponseModelsItemRecordDataConnectionRefRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getEffectiveBidModelsResponseModelsItemRecordDataStagesMax = 4;

export const getEffectiveBidModelsResponseModelsItemRecordDataReasoningEffortsMax = 6;

export const getEffectiveBidModelsResponseModelsItemRecordDataContextWindowTokensMax = 4000000;

export const getEffectiveBidModelsResponseModelsItemRecordDataMaxOutputTokensMax = 131072;

export const getEffectiveBidModelsResponseModelsItemRecordDataCapabilityEvidenceSourceRefMax = 1000;

export const getEffectiveBidModelsResponseModelsItemRecordDataProcessingLocationsItemRegExp = new RegExp('^[A-Z]{2}$');
export const getEffectiveBidModelsResponseModelsItemRecordDataProcessingLocationsMax = 40;

export const getEffectiveBidModelsResponseModelsItemRecordDataProcessingEvidenceSourceRefMax = 1000;

export const getEffectiveBidModelsResponseModelsItemRecordDataInputPerMillionUsdMin = 0;
export const getEffectiveBidModelsResponseModelsItemRecordDataInputPerMillionUsdMax = 100000;

export const getEffectiveBidModelsResponseModelsItemRecordDataOutputPerMillionUsdMin = 0;
export const getEffectiveBidModelsResponseModelsItemRecordDataOutputPerMillionUsdMax = 100000;

export const getEffectiveBidModelsResponseModelsItemRecordDataLatencyMsMax = 3600000;

export const getEffectiveBidModelsResponseModelsItemRecordDataPerformanceEvidenceSourceRefMax = 1000;

export const getEffectiveBidModelsResponseModelsItemRecordReasonMin = 10;
export const getEffectiveBidModelsResponseModelsItemRecordReasonMax = 2000;

export const getEffectiveBidModelsResponseModelsItemReasonsItemMax = 1000;

export const getEffectiveBidModelsResponseModelsItemReasonsMax = 20;

export const getEffectiveBidModelsResponseModelsMax = 100;

export const getEffectiveBidModelsResponseConnectionRefsItemRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const getEffectiveBidModelsResponseConnectionRefsMax = 20;



export const getEffectiveBidModelsResponse = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localPolicy": zod.union([zod.object({
  "id": zod.uuid(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "revision": zod.int().min(1).max(getEffectiveBidModelsResponseLocalPolicyOneRevisionMax),
  "policy": zod.object({
  "allowedChoiceIds": zod.array(zod.string().regex(getEffectiveBidModelsResponseLocalPolicyOnePolicyAllowedChoiceIdsItemRegExp)).max(getEffectiveBidModelsResponseLocalPolicyOnePolicyAllowedChoiceIdsMax).nullable(),
  "allowedLocations": zod.array(zod.string().regex(getEffectiveBidModelsResponseLocalPolicyOnePolicyAllowedLocationsItemRegExp)).max(getEffectiveBidModelsResponseLocalPolicyOnePolicyAllowedLocationsMax).nullable(),
  "requireVerifiedLocation": zod.boolean().nullable()
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(getEffectiveBidModelsResponseLocalPolicyOneReasonMin).max(getEffectiveBidModelsResponseLocalPolicyOneReasonMax)
}),zod.null()]),
  "parents": zod.array(zod.object({
  "id": zod.uuid(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "revision": zod.int().min(1).max(getEffectiveBidModelsResponseParentsItemRevisionMax),
  "policy": zod.object({
  "allowedChoiceIds": zod.array(zod.string().regex(getEffectiveBidModelsResponseParentsItemPolicyAllowedChoiceIdsItemRegExp)).max(getEffectiveBidModelsResponseParentsItemPolicyAllowedChoiceIdsMax).nullable(),
  "allowedLocations": zod.array(zod.string().regex(getEffectiveBidModelsResponseParentsItemPolicyAllowedLocationsItemRegExp)).max(getEffectiveBidModelsResponseParentsItemPolicyAllowedLocationsMax).nullable(),
  "requireVerifiedLocation": zod.boolean().nullable()
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(getEffectiveBidModelsResponseParentsItemReasonMin).max(getEffectiveBidModelsResponseParentsItemReasonMax)
})).max(getEffectiveBidModelsResponseParentsMax),
  "effectivePolicy": zod.object({
  "allowedChoiceIds": zod.array(zod.string().regex(getEffectiveBidModelsResponseEffectivePolicyAllowedChoiceIdsItemRegExp)).max(getEffectiveBidModelsResponseEffectivePolicyAllowedChoiceIdsMax).nullable(),
  "allowedLocations": zod.array(zod.string().regex(getEffectiveBidModelsResponseEffectivePolicyAllowedLocationsItemRegExp)).max(getEffectiveBidModelsResponseEffectivePolicyAllowedLocationsMax).nullable(),
  "requireVerifiedLocation": zod.boolean().nullable()
}),
  "parentFingerprint": zod.string().max(getEffectiveBidModelsResponseParentFingerprintMax),
  "models": zod.array(zod.object({
  "record": zod.object({
  "id": zod.uuid(),
  "choiceId": zod.string().regex(getEffectiveBidModelsResponseModelsItemRecordChoiceIdRegExp),
  "revision": zod.int().min(1).max(getEffectiveBidModelsResponseModelsItemRecordRevisionMax),
  "data": zod.object({
  "displayName": zod.string().min(1).max(getEffectiveBidModelsResponseModelsItemRecordDataDisplayNameMax),
  "description": zod.string().max(getEffectiveBidModelsResponseModelsItemRecordDataDescriptionMax),
  "status": zod.enum(['active', 'disabled', 'removed']),
  "connectionRef": zod.string().regex(getEffectiveBidModelsResponseModelsItemRecordDataConnectionRefRegExp),
  "adapter": zod.enum(['chat-completions', 'unsupported']),
  "stages": zod.array(zod.enum(['research', 'assessment', 'drafting', 'buyer_review'])).max(getEffectiveBidModelsResponseModelsItemRecordDataStagesMax),
  "reasoningEfforts": zod.array(zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh'])).max(getEffectiveBidModelsResponseModelsItemRecordDataReasoningEffortsMax),
  "contextWindowTokens": zod.int().min(1).max(getEffectiveBidModelsResponseModelsItemRecordDataContextWindowTokensMax).nullable(),
  "maxOutputTokens": zod.int().min(1).max(getEffectiveBidModelsResponseModelsItemRecordDataMaxOutputTokensMax).nullable(),
  "capabilityEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(getEffectiveBidModelsResponseModelsItemRecordDataCapabilityEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "processingLocations": zod.array(zod.string().regex(getEffectiveBidModelsResponseModelsItemRecordDataProcessingLocationsItemRegExp)).max(getEffectiveBidModelsResponseModelsItemRecordDataProcessingLocationsMax),
  "processingScope": zod.enum(['regional', 'global', 'unknown']),
  "processingEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(getEffectiveBidModelsResponseModelsItemRecordDataProcessingEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "inputPerMillionUsd": zod.number().min(getEffectiveBidModelsResponseModelsItemRecordDataInputPerMillionUsdMin).max(getEffectiveBidModelsResponseModelsItemRecordDataInputPerMillionUsdMax).nullable(),
  "outputPerMillionUsd": zod.number().min(getEffectiveBidModelsResponseModelsItemRecordDataOutputPerMillionUsdMin).max(getEffectiveBidModelsResponseModelsItemRecordDataOutputPerMillionUsdMax).nullable(),
  "latencyMs": zod.int().min(1).max(getEffectiveBidModelsResponseModelsItemRecordDataLatencyMsMax).nullable(),
  "performanceEvidence": zod.object({
  "state": zod.enum(['verified', 'unknown', 'unavailable']),
  "sourceRef": zod.string().max(getEffectiveBidModelsResponseModelsItemRecordDataPerformanceEvidenceSourceRefMax).nullable(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),
  "changedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(getEffectiveBidModelsResponseModelsItemRecordReasonMin).max(getEffectiveBidModelsResponseModelsItemRecordReasonMax)
}),
  "configured": zod.boolean(),
  "policyEligible": zod.boolean(),
  "executable": zod.boolean(),
  "liveVerified": zod.boolean(),
  "reasons": zod.array(zod.string().max(getEffectiveBidModelsResponseModelsItemReasonsItemMax)).max(getEffectiveBidModelsResponseModelsItemReasonsMax)
})).max(getEffectiveBidModelsResponseModelsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "connectionRefs": zod.array(zod.string().regex(getEffectiveBidModelsResponseConnectionRefsItemRegExp)).max(getEffectiveBidModelsResponseConnectionRefsMax)
})



export const getSupplierGroundingResponseFactsItemCitationsItemLocationMax = 1000;

export const getSupplierGroundingResponseFactsItemCitationsItemExcerptMax = 1200;

export const getSupplierGroundingResponseFactsItemCitationsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSupplierGroundingResponseFactsMax = 19;



export const getSupplierGroundingResponse = zod.object({
  "facts": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.enum(['legal_name', 'incorporation', 'abn_acn', 'corporate_structure', 'addresses', 'contact_person', 'capabilities', 'capacity', 'intellectual_property', 'data_sovereignty', 'information_security', 'conflicts', 'eservices', 'insurance', 'declarations', 'case_study_1', 'case_study_2', 'case_study_3', 'case_study_4']),
  "revision": zod.int(),
  "state": zod.enum(['confirmed', 'unknown', 'conflicting', 'expired']),
  "recordedState": zod.enum(['confirmed', 'unknown', 'conflicting', 'expired']),
  "value": zod.string(),
  "note": zod.string(),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "fileId": zod.uuid(),
  "location": zod.string().min(1).max(getSupplierGroundingResponseFactsItemCitationsItemLocationMax),
  "excerpt": zod.string().min(1).max(getSupplierGroundingResponseFactsItemCitationsItemExcerptMax),
  "sourceHash": zod.string().regex(getSupplierGroundingResponseFactsItemCitationsItemSourceHashRegExp)
})),
  "confirmedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "evidenceMessage": zod.string()
})).max(getSupplierGroundingResponseFactsMax),
  "checklist": zod.array(zod.object({
  "key": zod.enum(['legal_name', 'incorporation', 'abn_acn', 'corporate_structure', 'addresses', 'contact_person', 'capabilities', 'capacity', 'intellectual_property', 'data_sovereignty', 'information_security', 'conflicts', 'eservices', 'insurance', 'declarations', 'case_study_1', 'case_study_2', 'case_study_3', 'case_study_4']),
  "label": zod.string(),
  "state": zod.enum(['confirmed', 'unknown', 'conflicting', 'expired']),
  "action": zod.string()
})),
  "ready": zod.boolean().describe('Evidence checklist complete only; never submission or signature approval')
})


export const saveSupplierFactParams = zod.object({
  "key": zod.enum(['legal_name', 'incorporation', 'abn_acn', 'corporate_structure', 'addresses', 'contact_person', 'capabilities', 'capacity', 'intellectual_property', 'data_sovereignty', 'information_security', 'conflicts', 'eservices', 'insurance', 'declarations', 'case_study_1', 'case_study_2', 'case_study_3', 'case_study_4'])
})

export const saveSupplierFactBodyExpectedRevisionMin = 0;

export const saveSupplierFactBodyValueMax = 5000;

export const saveSupplierFactBodyNoteMax = 2000;


export const saveSupplierFactBodyCitationsItemLocationMax = 1000;

export const saveSupplierFactBodyCitationsItemExcerptMax = 1200;

export const saveSupplierFactBodyCitationsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const saveSupplierFactBodyCitationsMax = 10;



export const saveSupplierFactBody = zod.object({
  "expectedRevision": zod.int().min(saveSupplierFactBodyExpectedRevisionMin),
  "state": zod.enum(['confirmed', 'unknown', 'conflicting', 'expired']),
  "value": zod.string().max(saveSupplierFactBodyValueMax),
  "note": zod.string().min(1).max(saveSupplierFactBodyNoteMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "fileId": zod.uuid(),
  "location": zod.string().min(1).max(saveSupplierFactBodyCitationsItemLocationMax),
  "excerpt": zod.string().min(1).max(saveSupplierFactBodyCitationsItemExcerptMax),
  "sourceHash": zod.string().regex(saveSupplierFactBodyCitationsItemSourceHashRegExp)
})).max(saveSupplierFactBodyCitationsMax)
})


export const saveSupplierFactResponseCitationsItemLocationMax = 1000;

export const saveSupplierFactResponseCitationsItemExcerptMax = 1200;

export const saveSupplierFactResponseCitationsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const saveSupplierFactResponse = zod.object({
  "id": zod.uuid(),
  "key": zod.enum(['legal_name', 'incorporation', 'abn_acn', 'corporate_structure', 'addresses', 'contact_person', 'capabilities', 'capacity', 'intellectual_property', 'data_sovereignty', 'information_security', 'conflicts', 'eservices', 'insurance', 'declarations', 'case_study_1', 'case_study_2', 'case_study_3', 'case_study_4']),
  "revision": zod.int(),
  "state": zod.enum(['confirmed', 'unknown', 'conflicting', 'expired']),
  "recordedState": zod.enum(['confirmed', 'unknown', 'conflicting', 'expired']),
  "value": zod.string(),
  "note": zod.string(),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "fileId": zod.uuid(),
  "location": zod.string().min(1).max(saveSupplierFactResponseCitationsItemLocationMax),
  "excerpt": zod.string().min(1).max(saveSupplierFactResponseCitationsItemExcerptMax),
  "sourceHash": zod.string().regex(saveSupplierFactResponseCitationsItemSourceHashRegExp)
})),
  "confirmedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "evidenceMessage": zod.string()
})


export const listSupplierFactRevisionsParams = zod.object({
  "key": zod.enum(['legal_name', 'incorporation', 'abn_acn', 'corporate_structure', 'addresses', 'contact_person', 'capabilities', 'capacity', 'intellectual_property', 'data_sovereignty', 'information_security', 'conflicts', 'eservices', 'insurance', 'declarations', 'case_study_1', 'case_study_2', 'case_study_3', 'case_study_4'])
})

export const listSupplierFactRevisionsQueryLimitDefault = 25;
export const listSupplierFactRevisionsQueryLimitMax = 100;

export const listSupplierFactRevisionsQueryOffsetDefault = 0;
export const listSupplierFactRevisionsQueryOffsetMin = 0;



export const listSupplierFactRevisionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSupplierFactRevisionsQueryLimitMax).default(listSupplierFactRevisionsQueryLimitDefault),
  "offset": zod.int().min(listSupplierFactRevisionsQueryOffsetMin).default(listSupplierFactRevisionsQueryOffsetDefault)
})


export const listSupplierFactRevisionsResponseItemsItemCitationsItemLocationMax = 1000;

export const listSupplierFactRevisionsResponseItemsItemCitationsItemExcerptMax = 1200;

export const listSupplierFactRevisionsResponseItemsItemCitationsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const listSupplierFactRevisionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.enum(['legal_name', 'incorporation', 'abn_acn', 'corporate_structure', 'addresses', 'contact_person', 'capabilities', 'capacity', 'intellectual_property', 'data_sovereignty', 'information_security', 'conflicts', 'eservices', 'insurance', 'declarations', 'case_study_1', 'case_study_2', 'case_study_3', 'case_study_4']),
  "revision": zod.int(),
  "state": zod.enum(['confirmed', 'unknown', 'conflicting', 'expired']),
  "recordedState": zod.enum(['confirmed', 'unknown', 'conflicting', 'expired']),
  "value": zod.string(),
  "note": zod.string(),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "fileId": zod.uuid(),
  "location": zod.string().min(1).max(listSupplierFactRevisionsResponseItemsItemCitationsItemLocationMax),
  "excerpt": zod.string().min(1).max(listSupplierFactRevisionsResponseItemsItemCitationsItemExcerptMax),
  "sourceHash": zod.string().regex(listSupplierFactRevisionsResponseItemsItemCitationsItemSourceHashRegExp)
})),
  "confirmedByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "evidenceMessage": zod.string()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getBidInventoryParams = zod.object({
  "id": zod.uuid()
})

export const getBidInventoryQueryLimitDefault = 20;
export const getBidInventoryQueryLimitMax = 100;

export const getBidInventoryQueryOffsetDefault = 0;
export const getBidInventoryQueryOffsetMin = 0;



export const getBidInventoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(getBidInventoryQueryLimitMax).default(getBidInventoryQueryLimitDefault),
  "offset": zod.int().min(getBidInventoryQueryOffsetMin).default(getBidInventoryQueryOffsetDefault)
})

export const getBidInventoryResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getBidInventoryResponseSourcesItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getBidInventoryResponseSourcesItemLedgerItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getBidInventoryResponseSourcesItemLedgerMax = 2000;

export const getBidInventoryResponseSourcesItemWarningsMax = 100;

export const getBidInventoryResponseSourcesMax = 30;

export const getBidInventoryResponseItemsItemFactKeysMax = 19;

export const getBidInventoryResponseItemsItemRulesMax = 30;

export const getBidInventoryResponseItemsItemCitationsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getBidInventoryResponseItemsItemCitationsMax = 30;

export const getBidInventoryResponseItemsMax = 100;

export const getBidInventoryResponseWarningsMax = 100;

export const getBidInventoryResponseMandatoryMax = 5;

export const getBidInventoryResponseWeightedMax = 4;

export const getBidInventoryResponseGapsMax = 100;

export const getBidInventoryResponseDecisionOneEvaluationsItemScoreMin = 0;
export const getBidInventoryResponseDecisionOneEvaluationsItemScoreMax = 100;

export const getBidInventoryResponseDecisionOneEvaluationsItemRationaleMin = 10;
export const getBidInventoryResponseDecisionOneEvaluationsItemRationaleMax = 2000;

export const getBidInventoryResponseDecisionOneEvaluationsItemFactRevisionIdsMax = 19;

export const getBidInventoryResponseDecisionOneEvaluationsMax = 10;



export const getBidInventoryResponse = zod.object({
  "fingerprint": zod.string().regex(getBidInventoryResponseFingerprintRegExp),
  "invitationReference": zod.string().nullable(),
  "sources": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceHash": zod.string().regex(getBidInventoryResponseSourcesItemSourceHashRegExp),
  "format": zod.string(),
  "state": zod.enum(['complete', 'partial', 'unavailable']),
  "blocks": zod.int(),
  "characters": zod.int(),
  "ledger": zod.array(zod.object({
  "location": zod.string(),
  "start": zod.int(),
  "end": zod.int(),
  "hash": zod.string().regex(getBidInventoryResponseSourcesItemLedgerItemHashRegExp)
})).max(getBidInventoryResponseSourcesItemLedgerMax),
  "warnings": zod.array(zod.string()).max(getBidInventoryResponseSourcesItemWarningsMax)
})).max(getBidInventoryResponseSourcesMax),
  "items": zod.array(zod.object({
  "key": zod.string(),
  "title": zod.string(),
  "classification": zod.enum(['mandatory', 'weighted', 'non_weighted', 'output', 'format', 'delivery']),
  "weight": zod.int().nullable(),
  "factKeys": zod.array(zod.enum(['legal_name', 'incorporation', 'abn_acn', 'corporate_structure', 'addresses', 'contact_person', 'capabilities', 'capacity', 'intellectual_property', 'data_sovereignty', 'information_security', 'conflicts', 'eservices', 'insurance', 'declarations', 'case_study_1', 'case_study_2', 'case_study_3', 'case_study_4'])).max(getBidInventoryResponseItemsItemFactKeysMax),
  "rules": zod.array(zod.string()).max(getBidInventoryResponseItemsItemRulesMax),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.string(),
  "sourceHash": zod.string().regex(getBidInventoryResponseItemsItemCitationsItemSourceHashRegExp),
  "location": zod.string(),
  "excerpt": zod.string()
})).max(getBidInventoryResponseItemsItemCitationsMax),
  "requirementId": zod.uuid().nullable()
})).max(getBidInventoryResponseItemsMax),
  "warnings": zod.array(zod.string()).max(getBidInventoryResponseWarningsMax),
  "complete": zod.boolean(),
  "reviewed": zod.boolean(),
  "recommendation": zod.enum(['proceed', 'conditional', 'defer']),
  "mandatory": zod.array(zod.object({
  "key": zod.string(),
  "status": zod.enum(['pass', 'fail', 'unknown']),
  "reason": zod.string()
})).max(getBidInventoryResponseMandatoryMax),
  "weighted": zod.array(zod.object({
  "key": zod.string(),
  "weight": zod.int(),
  "score": zod.number().nullable(),
  "reason": zod.string()
})).max(getBidInventoryResponseWeightedMax),
  "gaps": zod.array(zod.string()).max(getBidInventoryResponseGapsMax),
  "decision": zod.union([zod.object({
  "id": zod.uuid(),
  "decision": zod.enum(['proceed', 'conditional', 'defer']),
  "rationale": zod.string(),
  "evaluations": zod.array(zod.object({
  "key": zod.string(),
  "status": zod.enum(['pass', 'fail', 'unknown']),
  "score": zod.number().min(getBidInventoryResponseDecisionOneEvaluationsItemScoreMin).max(getBidInventoryResponseDecisionOneEvaluationsItemScoreMax).nullable(),
  "rationale": zod.string().min(getBidInventoryResponseDecisionOneEvaluationsItemRationaleMin).max(getBidInventoryResponseDecisionOneEvaluationsItemRationaleMax),
  "factRevisionIds": zod.array(zod.uuid()).max(getBidInventoryResponseDecisionOneEvaluationsItemFactRevisionIdsMax)
})).max(getBidInventoryResponseDecisionOneEvaluationsMax),
  "actorAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "current": zod.boolean()
}),zod.null()])
})


export const reviewBidInventoryParams = zod.object({
  "id": zod.uuid()
})

export const reviewBidInventoryBodyFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const reviewBidInventoryBody = zod.object({
  "fingerprint": zod.string().regex(reviewBidInventoryBodyFingerprintRegExp)
})

export const reviewBidInventoryResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewBidInventoryResponseSourcesItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewBidInventoryResponseSourcesItemLedgerItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewBidInventoryResponseSourcesItemLedgerMax = 2000;

export const reviewBidInventoryResponseSourcesItemWarningsMax = 100;

export const reviewBidInventoryResponseSourcesMax = 30;

export const reviewBidInventoryResponseItemsItemFactKeysMax = 19;

export const reviewBidInventoryResponseItemsItemRulesMax = 30;

export const reviewBidInventoryResponseItemsItemCitationsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewBidInventoryResponseItemsItemCitationsMax = 30;

export const reviewBidInventoryResponseItemsMax = 100;

export const reviewBidInventoryResponseWarningsMax = 100;

export const reviewBidInventoryResponseMandatoryMax = 5;

export const reviewBidInventoryResponseWeightedMax = 4;

export const reviewBidInventoryResponseGapsMax = 100;

export const reviewBidInventoryResponseDecisionOneEvaluationsItemScoreMin = 0;
export const reviewBidInventoryResponseDecisionOneEvaluationsItemScoreMax = 100;

export const reviewBidInventoryResponseDecisionOneEvaluationsItemRationaleMin = 10;
export const reviewBidInventoryResponseDecisionOneEvaluationsItemRationaleMax = 2000;

export const reviewBidInventoryResponseDecisionOneEvaluationsItemFactRevisionIdsMax = 19;

export const reviewBidInventoryResponseDecisionOneEvaluationsMax = 10;



export const reviewBidInventoryResponse = zod.object({
  "fingerprint": zod.string().regex(reviewBidInventoryResponseFingerprintRegExp),
  "invitationReference": zod.string().nullable(),
  "sources": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceHash": zod.string().regex(reviewBidInventoryResponseSourcesItemSourceHashRegExp),
  "format": zod.string(),
  "state": zod.enum(['complete', 'partial', 'unavailable']),
  "blocks": zod.int(),
  "characters": zod.int(),
  "ledger": zod.array(zod.object({
  "location": zod.string(),
  "start": zod.int(),
  "end": zod.int(),
  "hash": zod.string().regex(reviewBidInventoryResponseSourcesItemLedgerItemHashRegExp)
})).max(reviewBidInventoryResponseSourcesItemLedgerMax),
  "warnings": zod.array(zod.string()).max(reviewBidInventoryResponseSourcesItemWarningsMax)
})).max(reviewBidInventoryResponseSourcesMax),
  "items": zod.array(zod.object({
  "key": zod.string(),
  "title": zod.string(),
  "classification": zod.enum(['mandatory', 'weighted', 'non_weighted', 'output', 'format', 'delivery']),
  "weight": zod.int().nullable(),
  "factKeys": zod.array(zod.enum(['legal_name', 'incorporation', 'abn_acn', 'corporate_structure', 'addresses', 'contact_person', 'capabilities', 'capacity', 'intellectual_property', 'data_sovereignty', 'information_security', 'conflicts', 'eservices', 'insurance', 'declarations', 'case_study_1', 'case_study_2', 'case_study_3', 'case_study_4'])).max(reviewBidInventoryResponseItemsItemFactKeysMax),
  "rules": zod.array(zod.string()).max(reviewBidInventoryResponseItemsItemRulesMax),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.string(),
  "sourceHash": zod.string().regex(reviewBidInventoryResponseItemsItemCitationsItemSourceHashRegExp),
  "location": zod.string(),
  "excerpt": zod.string()
})).max(reviewBidInventoryResponseItemsItemCitationsMax),
  "requirementId": zod.uuid().nullable()
})).max(reviewBidInventoryResponseItemsMax),
  "warnings": zod.array(zod.string()).max(reviewBidInventoryResponseWarningsMax),
  "complete": zod.boolean(),
  "reviewed": zod.boolean(),
  "recommendation": zod.enum(['proceed', 'conditional', 'defer']),
  "mandatory": zod.array(zod.object({
  "key": zod.string(),
  "status": zod.enum(['pass', 'fail', 'unknown']),
  "reason": zod.string()
})).max(reviewBidInventoryResponseMandatoryMax),
  "weighted": zod.array(zod.object({
  "key": zod.string(),
  "weight": zod.int(),
  "score": zod.number().nullable(),
  "reason": zod.string()
})).max(reviewBidInventoryResponseWeightedMax),
  "gaps": zod.array(zod.string()).max(reviewBidInventoryResponseGapsMax),
  "decision": zod.union([zod.object({
  "id": zod.uuid(),
  "decision": zod.enum(['proceed', 'conditional', 'defer']),
  "rationale": zod.string(),
  "evaluations": zod.array(zod.object({
  "key": zod.string(),
  "status": zod.enum(['pass', 'fail', 'unknown']),
  "score": zod.number().min(reviewBidInventoryResponseDecisionOneEvaluationsItemScoreMin).max(reviewBidInventoryResponseDecisionOneEvaluationsItemScoreMax).nullable(),
  "rationale": zod.string().min(reviewBidInventoryResponseDecisionOneEvaluationsItemRationaleMin).max(reviewBidInventoryResponseDecisionOneEvaluationsItemRationaleMax),
  "factRevisionIds": zod.array(zod.uuid()).max(reviewBidInventoryResponseDecisionOneEvaluationsItemFactRevisionIdsMax)
})).max(reviewBidInventoryResponseDecisionOneEvaluationsMax),
  "actorAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "current": zod.boolean()
}),zod.null()])
})


export const recordBidFitDecisionParams = zod.object({
  "id": zod.uuid()
})

export const recordBidFitDecisionBodyFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const recordBidFitDecisionBodyRationaleMin = 10;
export const recordBidFitDecisionBodyRationaleMax = 2000;

export const recordBidFitDecisionBodyEvaluationsItemScoreMin = 0;
export const recordBidFitDecisionBodyEvaluationsItemScoreMax = 100;

export const recordBidFitDecisionBodyEvaluationsItemRationaleMin = 10;
export const recordBidFitDecisionBodyEvaluationsItemRationaleMax = 2000;

export const recordBidFitDecisionBodyEvaluationsItemFactRevisionIdsMax = 19;

export const recordBidFitDecisionBodyEvaluationsMax = 10;



export const recordBidFitDecisionBody = zod.object({
  "fingerprint": zod.string().regex(recordBidFitDecisionBodyFingerprintRegExp),
  "decision": zod.enum(['proceed', 'conditional', 'defer']),
  "rationale": zod.string().min(recordBidFitDecisionBodyRationaleMin).max(recordBidFitDecisionBodyRationaleMax),
  "evaluations": zod.array(zod.object({
  "key": zod.string(),
  "status": zod.enum(['pass', 'fail', 'unknown']),
  "score": zod.number().min(recordBidFitDecisionBodyEvaluationsItemScoreMin).max(recordBidFitDecisionBodyEvaluationsItemScoreMax).nullable(),
  "rationale": zod.string().min(recordBidFitDecisionBodyEvaluationsItemRationaleMin).max(recordBidFitDecisionBodyEvaluationsItemRationaleMax),
  "factRevisionIds": zod.array(zod.uuid()).max(recordBidFitDecisionBodyEvaluationsItemFactRevisionIdsMax)
})).max(recordBidFitDecisionBodyEvaluationsMax)
})

export const recordBidFitDecisionResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const recordBidFitDecisionResponseSourcesItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const recordBidFitDecisionResponseSourcesItemLedgerItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const recordBidFitDecisionResponseSourcesItemLedgerMax = 2000;

export const recordBidFitDecisionResponseSourcesItemWarningsMax = 100;

export const recordBidFitDecisionResponseSourcesMax = 30;

export const recordBidFitDecisionResponseItemsItemFactKeysMax = 19;

export const recordBidFitDecisionResponseItemsItemRulesMax = 30;

export const recordBidFitDecisionResponseItemsItemCitationsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const recordBidFitDecisionResponseItemsItemCitationsMax = 30;

export const recordBidFitDecisionResponseItemsMax = 100;

export const recordBidFitDecisionResponseWarningsMax = 100;

export const recordBidFitDecisionResponseMandatoryMax = 5;

export const recordBidFitDecisionResponseWeightedMax = 4;

export const recordBidFitDecisionResponseGapsMax = 100;

export const recordBidFitDecisionResponseDecisionOneEvaluationsItemScoreMin = 0;
export const recordBidFitDecisionResponseDecisionOneEvaluationsItemScoreMax = 100;

export const recordBidFitDecisionResponseDecisionOneEvaluationsItemRationaleMin = 10;
export const recordBidFitDecisionResponseDecisionOneEvaluationsItemRationaleMax = 2000;

export const recordBidFitDecisionResponseDecisionOneEvaluationsItemFactRevisionIdsMax = 19;

export const recordBidFitDecisionResponseDecisionOneEvaluationsMax = 10;



export const recordBidFitDecisionResponse = zod.object({
  "fingerprint": zod.string().regex(recordBidFitDecisionResponseFingerprintRegExp),
  "invitationReference": zod.string().nullable(),
  "sources": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceHash": zod.string().regex(recordBidFitDecisionResponseSourcesItemSourceHashRegExp),
  "format": zod.string(),
  "state": zod.enum(['complete', 'partial', 'unavailable']),
  "blocks": zod.int(),
  "characters": zod.int(),
  "ledger": zod.array(zod.object({
  "location": zod.string(),
  "start": zod.int(),
  "end": zod.int(),
  "hash": zod.string().regex(recordBidFitDecisionResponseSourcesItemLedgerItemHashRegExp)
})).max(recordBidFitDecisionResponseSourcesItemLedgerMax),
  "warnings": zod.array(zod.string()).max(recordBidFitDecisionResponseSourcesItemWarningsMax)
})).max(recordBidFitDecisionResponseSourcesMax),
  "items": zod.array(zod.object({
  "key": zod.string(),
  "title": zod.string(),
  "classification": zod.enum(['mandatory', 'weighted', 'non_weighted', 'output', 'format', 'delivery']),
  "weight": zod.int().nullable(),
  "factKeys": zod.array(zod.enum(['legal_name', 'incorporation', 'abn_acn', 'corporate_structure', 'addresses', 'contact_person', 'capabilities', 'capacity', 'intellectual_property', 'data_sovereignty', 'information_security', 'conflicts', 'eservices', 'insurance', 'declarations', 'case_study_1', 'case_study_2', 'case_study_3', 'case_study_4'])).max(recordBidFitDecisionResponseItemsItemFactKeysMax),
  "rules": zod.array(zod.string()).max(recordBidFitDecisionResponseItemsItemRulesMax),
  "citations": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.string(),
  "sourceHash": zod.string().regex(recordBidFitDecisionResponseItemsItemCitationsItemSourceHashRegExp),
  "location": zod.string(),
  "excerpt": zod.string()
})).max(recordBidFitDecisionResponseItemsItemCitationsMax),
  "requirementId": zod.uuid().nullable()
})).max(recordBidFitDecisionResponseItemsMax),
  "warnings": zod.array(zod.string()).max(recordBidFitDecisionResponseWarningsMax),
  "complete": zod.boolean(),
  "reviewed": zod.boolean(),
  "recommendation": zod.enum(['proceed', 'conditional', 'defer']),
  "mandatory": zod.array(zod.object({
  "key": zod.string(),
  "status": zod.enum(['pass', 'fail', 'unknown']),
  "reason": zod.string()
})).max(recordBidFitDecisionResponseMandatoryMax),
  "weighted": zod.array(zod.object({
  "key": zod.string(),
  "weight": zod.int(),
  "score": zod.number().nullable(),
  "reason": zod.string()
})).max(recordBidFitDecisionResponseWeightedMax),
  "gaps": zod.array(zod.string()).max(recordBidFitDecisionResponseGapsMax),
  "decision": zod.union([zod.object({
  "id": zod.uuid(),
  "decision": zod.enum(['proceed', 'conditional', 'defer']),
  "rationale": zod.string(),
  "evaluations": zod.array(zod.object({
  "key": zod.string(),
  "status": zod.enum(['pass', 'fail', 'unknown']),
  "score": zod.number().min(recordBidFitDecisionResponseDecisionOneEvaluationsItemScoreMin).max(recordBidFitDecisionResponseDecisionOneEvaluationsItemScoreMax).nullable(),
  "rationale": zod.string().min(recordBidFitDecisionResponseDecisionOneEvaluationsItemRationaleMin).max(recordBidFitDecisionResponseDecisionOneEvaluationsItemRationaleMax),
  "factRevisionIds": zod.array(zod.uuid()).max(recordBidFitDecisionResponseDecisionOneEvaluationsItemFactRevisionIdsMax)
})).max(recordBidFitDecisionResponseDecisionOneEvaluationsMax),
  "actorAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "current": zod.boolean()
}),zod.null()])
})


export const getBidFoundationParams = zod.object({
  "id": zod.uuid()
})

export const getBidFoundationQueryLimitDefault = 25;
export const getBidFoundationQueryLimitMax = 100;

export const getBidFoundationQueryOffsetDefault = 0;
export const getBidFoundationQueryOffsetMin = 0;



export const getBidFoundationQueryParams = zod.object({
  "limit": zod.int().min(1).max(getBidFoundationQueryLimitMax).default(getBidFoundationQueryLimitDefault),
  "offset": zod.int().min(getBidFoundationQueryOffsetMin).default(getBidFoundationQueryOffsetDefault)
})


export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemKeyMax = 64;


export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]*$');
export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemTitleMax = 200;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemSkeletonTextMax = 4000;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemRequirementIdsMax = 100;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsMax = 20;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemKeyMax = 64;


export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]*$');
export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemTitleMax = 200;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemRequirementIdsMax = 100;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemDocumentKeysItemMax = 64;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemDocumentKeysMax = 20;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsMax = 40;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupExistingAssignmentsMax = 40;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupSourceRevisionsMax = 30;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupOwnersMax = 40;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupStageModelsMax = 4;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSetupWarningsMax = 150;

export const getBidFoundationResponsePlanRevisionsItemSnapshotScopeMax = 10000;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSourceRevisionsMax = 200;

export const getBidFoundationResponsePlanRevisionsItemSnapshotSupplierFactRevisionIdsMax = 200;

export const getBidFoundationResponsePlanRevisionsItemSnapshotDocumentsItemKeyMax = 100;

export const getBidFoundationResponsePlanRevisionsItemSnapshotDocumentsItemTitleMax = 300;

export const getBidFoundationResponsePlanRevisionsItemSnapshotDocumentsItemRequirementIdsMax = 200;

export const getBidFoundationResponsePlanRevisionsItemSnapshotDocumentsMax = 100;

export const getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsItemTitleMax = 300;

export const getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsItemRequirementIdsMax = 200;

export const getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsItemDocumentKeysItemMax = 100;

export const getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsItemDocumentKeysMax = 100;

export const getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsMax = 100;

export const getBidFoundationResponsePlanRevisionsItemSnapshotStageModelsItemModelIdMax = 300;

export const getBidFoundationResponsePlanRevisionsItemSnapshotStageModelsItemPolicyRevisionMax = 128;

export const getBidFoundationResponsePlanRevisionsItemSnapshotStageModelsMax = 4;

export const getBidFoundationResponsePlanRevisionsItemSnapshotPermittedDraftWorkMax = 10000;



export const getBidFoundationResponse = zod.object({
  "planRevisions": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "revision": zod.int().min(1),
  "snapshot": zod.object({
  "setup": zod.object({
  "input": zod.object({
  "tenderId": zod.uuid(),
  "documents": zod.array(zod.object({
  "key": zod.string().min(1).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemKeyMax).regex(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemKeyRegExp),
  "title": zod.string().min(1).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemTitleMax),
  "skeletonText": zod.string().max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemSkeletonTextMax),
  "requirementIds": zod.array(zod.uuid()).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsItemRequirementIdsMax)
})).min(1).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputDocumentsMax),
  "assignments": zod.array(zod.object({
  "key": zod.string().min(1).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemKeyMax).regex(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemKeyRegExp),
  "title": zod.string().min(1).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemTitleMax),
  "ownerAppUserId": zod.uuid().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "requirementIds": zod.array(zod.uuid()).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemRequirementIdsMax),
  "documentKeys": zod.array(zod.string().max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemDocumentKeysItemMax)).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsItemDocumentKeysMax)
})).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupInputAssignmentsMax)
}),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "tenantName": zod.string(),
  "entityName": zod.string(),
  "tenderTitle": zod.string(),
  "inventoryFingerprint": zod.string(),
  "storageFingerprint": zod.string(),
  "priorStepHashes": zod.record(zod.string(), zod.string()).optional(),
  "existingAssignments": zod.array(zod.object({
  "key": zod.string(),
  "activityId": zod.uuid(),
  "ownerAppUserId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable()
})).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupExistingAssignmentsMax).optional(),
  "sourceRevisions": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.string(),
  "hash": zod.string()
})).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupSourceRevisionsMax),
  "owners": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "authorizationRevision": zod.string()
})).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupOwnersMax),
  "stageModels": zod.array(zod.object({
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review']),
  "choiceId": zod.string().nullable(),
  "selectionRevision": zod.int().nullable(),
  "policyFingerprint": zod.string(),
  "binding": zod.record(zod.string(), zod.unknown()).nullable()
})).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupStageModelsMax),
  "warnings": zod.array(zod.string()).max(getBidFoundationResponsePlanRevisionsItemSnapshotSetupWarningsMax),
  "permittedDraftWork": zod.string()
}).optional(),
  "scope": zod.string().min(1).max(getBidFoundationResponsePlanRevisionsItemSnapshotScopeMax),
  "sourceRevisions": zod.array(zod.uuid()).max(getBidFoundationResponsePlanRevisionsItemSnapshotSourceRevisionsMax),
  "supplierFactRevisionIds": zod.array(zod.uuid()).max(getBidFoundationResponsePlanRevisionsItemSnapshotSupplierFactRevisionIdsMax),
  "documents": zod.array(zod.object({
  "key": zod.string().max(getBidFoundationResponsePlanRevisionsItemSnapshotDocumentsItemKeyMax),
  "title": zod.string().max(getBidFoundationResponsePlanRevisionsItemSnapshotDocumentsItemTitleMax),
  "requirementIds": zod.array(zod.uuid()).max(getBidFoundationResponsePlanRevisionsItemSnapshotDocumentsItemRequirementIdsMax)
})).max(getBidFoundationResponsePlanRevisionsItemSnapshotDocumentsMax),
  "assignments": zod.array(zod.object({
  "ownerAppUserId": zod.uuid().nullable(),
  "title": zod.string().max(getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsItemTitleMax),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "requirementIds": zod.array(zod.uuid()).max(getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsItemRequirementIdsMax),
  "documentKeys": zod.array(zod.string().max(getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsItemDocumentKeysItemMax)).max(getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsItemDocumentKeysMax)
})).max(getBidFoundationResponsePlanRevisionsItemSnapshotAssignmentsMax),
  "stageModels": zod.array(zod.object({
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review']),
  "modelId": zod.string().max(getBidFoundationResponsePlanRevisionsItemSnapshotStageModelsItemModelIdMax),
  "policyRevision": zod.string().max(getBidFoundationResponsePlanRevisionsItemSnapshotStageModelsItemPolicyRevisionMax)
})).max(getBidFoundationResponsePlanRevisionsItemSnapshotStageModelsMax),
  "permittedDraftWork": zod.string().max(getBidFoundationResponsePlanRevisionsItemSnapshotPermittedDraftWorkMax)
}),
  "snapshotHash": zod.string(),
  "status": zod.enum(['proposed', 'approved', 'superseded', 'cancelled']),
  "approvedByAppUserId": zod.uuid().nullable(),
  "proposedByAppUserId": zod.uuid().optional()
})),
  "responseDocuments": zod.array(zod.object({
  "id": zod.uuid(),
  "requirementId": zod.uuid(),
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "sourceCoverage": zod.enum(['unaddressed', 'partial', 'covered', 'not_applicable'])
})),
  "stageRuns": zod.array(zod.object({
  "id": zod.uuid(),
  "runId": zod.uuid(),
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review']),
  "planRevisionId": zod.uuid(),
  "selectedModelId": zod.string(),
  "policyRevision": zod.string()
})),
  "planTotal": zod.int(),
  "documentTotal": zod.int(),
  "runTotal": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const listDocumentStorageOptionsParams = zod.object({
  "scope": zod.enum(['tenant', 'entity'])
})

export const listDocumentStorageOptionsQueryLimitDefault = 25;
export const listDocumentStorageOptionsQueryLimitMax = 100;

export const listDocumentStorageOptionsQueryConnectionOffsetDefault = 0;
export const listDocumentStorageOptionsQueryConnectionOffsetMin = 0;

export const listDocumentStorageOptionsQueryDestinationOffsetDefault = 0;
export const listDocumentStorageOptionsQueryDestinationOffsetMin = 0;



export const listDocumentStorageOptionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDocumentStorageOptionsQueryLimitMax).default(listDocumentStorageOptionsQueryLimitDefault),
  "connectionOffset": zod.int().min(listDocumentStorageOptionsQueryConnectionOffsetMin).default(listDocumentStorageOptionsQueryConnectionOffsetDefault),
  "destinationOffset": zod.int().min(listDocumentStorageOptionsQueryDestinationOffsetMin).default(listDocumentStorageOptionsQueryDestinationOffsetDefault)
})


export const listDocumentStorageOptionsResponseConnectionsItemDisplayNameMax = 120;

export const listDocumentStorageOptionsResponseConnectionsMax = 100;

export const listDocumentStorageOptionsResponseConnectionTotalMin = 0;


export const listDocumentStorageOptionsResponseDestinationsItemDisplayNameMax = 120;

export const listDocumentStorageOptionsResponseDestinationsItemFolderPathMax = 1000;

export const listDocumentStorageOptionsResponseDestinationsMax = 100;

export const listDocumentStorageOptionsResponseDestinationTotalMin = 0;



export const listDocumentStorageOptionsResponse = zod.object({
  "connections": zod.array(zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string().min(1).max(listDocumentStorageOptionsResponseConnectionsItemDisplayNameMax),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "externalTenantId": zod.uuid(),
  "grantKind": zod.enum(['environment', 'delegated', 'application']),
  "principalAppUserId": zod.uuid().nullable()
})).max(listDocumentStorageOptionsResponseConnectionsMax),
  "connectionTotal": zod.int().min(listDocumentStorageOptionsResponseConnectionTotalMin),
  "destinations": zod.array(zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string().min(1).max(listDocumentStorageOptionsResponseDestinationsItemDisplayNameMax),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().nullable(),
  "siteId": zod.string().nullable(),
  "driveId": zod.string().nullable(),
  "containerId": zod.string().nullable(),
  "folderPath": zod.string().max(listDocumentStorageOptionsResponseDestinationsItemFolderPathMax)
})).max(listDocumentStorageOptionsResponseDestinationsMax),
  "destinationTotal": zod.int().min(listDocumentStorageOptionsResponseDestinationTotalMin)
})


export const createApplicationDocumentDestinationParams = zod.object({
  "scope": zod.enum(['tenant', 'entity'])
})

export const createApplicationDocumentDestinationBodyDisplayNameMax = 120;

export const createApplicationDocumentDestinationBodyReasonMin = 10;
export const createApplicationDocumentDestinationBodyReasonMax = 1000;



export const createApplicationDocumentDestinationBody = zod.object({
  "displayName": zod.string().min(1).max(createApplicationDocumentDestinationBodyDisplayNameMax),
  "reason": zod.string().min(createApplicationDocumentDestinationBodyReasonMin).max(createApplicationDocumentDestinationBodyReasonMax)
})


export const createApplicationDocumentDestinationResponseDisplayNameMax = 120;

export const createApplicationDocumentDestinationResponseFolderPathMax = 1000;



export const createApplicationDocumentDestinationResponse = zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string().min(1).max(createApplicationDocumentDestinationResponseDisplayNameMax),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().nullable(),
  "siteId": zod.string().nullable(),
  "driveId": zod.string().nullable(),
  "containerId": zod.string().nullable(),
  "folderPath": zod.string().max(createApplicationDocumentDestinationResponseFolderPathMax)
})


export const listDocumentMaterializationsQueryLimitDefault = 25;
export const listDocumentMaterializationsQueryLimitMax = 100;

export const listDocumentMaterializationsQueryOffsetMin = 0;



export const listDocumentMaterializationsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDocumentMaterializationsQueryLimitMax).default(listDocumentMaterializationsQueryLimitDefault),
  "offset": zod.int().min(listDocumentMaterializationsQueryOffsetMin).optional()
})

export const listDocumentMaterializationsResponseTotalMin = 0;

export const listDocumentMaterializationsResponseLimitMin = 0;

export const listDocumentMaterializationsResponseOffsetMin = 0;



export const listDocumentMaterializationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "storageKey": zod.string(),
  "category": zod.string(),
  "state": zod.enum(['pending', 'writing', 'complete', 'uncertain', 'blocked']),
  "message": zod.string(),
  "destinationId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listDocumentMaterializationsResponseTotalMin),
  "limit": zod.int().min(listDocumentMaterializationsResponseLimitMin),
  "offset": zod.int().min(listDocumentMaterializationsResponseOffsetMin)
})


export const saveDocumentRepresentationBodySourceRevisionMax = 100;

export const saveDocumentRepresentationBodyBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const saveDocumentRepresentationBody = zod.object({
  "sourceKind": zod.enum(['managed_version', 'research_version', 'content_asset', 'quote_spreadsheet']),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.string().min(1).max(saveDocumentRepresentationBodySourceRevisionMax),
  "format": zod.enum(['docx', 'pdf', 'markdown', 'xlsx']).optional(),
  "destinationId": zod.uuid().optional(),
  "bindingFingerprint": zod.string().regex(saveDocumentRepresentationBodyBindingFingerprintRegExp)
})

export const saveDocumentRepresentationResponse = zod.object({
  "fileId": zod.uuid(),
  "filename": zod.string(),
  "storageKey": zod.string()
})


export const reconcileDocumentMaterializationParams = zod.object({
  "id": zod.uuid()
})

export const reconcileDocumentMaterializationResponse = zod.object({
  "id": zod.uuid(),
  "storageKey": zod.string(),
  "category": zod.string(),
  "state": zod.enum(['pending', 'writing', 'complete', 'uncertain', 'blocked']),
  "message": zod.string(),
  "destinationId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listM365LibrariesParams = zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "resourceId": zod.uuid()
})


export const listM365LibrariesQuerySiteUrlMax = 2000;

export const listM365LibrariesQueryLimitDefault = 25;
export const listM365LibrariesQueryLimitMax = 100;

export const listM365LibrariesQueryOffsetDefault = 0;
export const listM365LibrariesQueryOffsetMin = 0;



export const listM365LibrariesQueryParams = zod.object({
  "expectedRevision": zod.int().min(1),
  "siteUrl": zod.url().max(listM365LibrariesQuerySiteUrlMax),
  "limit": zod.int().min(1).max(listM365LibrariesQueryLimitMax).default(listM365LibrariesQueryLimitDefault),
  "offset": zod.int().min(listM365LibrariesQueryOffsetMin).default(listM365LibrariesQueryOffsetDefault)
})

export const listM365LibrariesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "displayName": zod.string()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const listM365ConnectionsParams = zod.object({
  "scope": zod.enum(['tenant', 'entity'])
})

export const listM365ConnectionsQueryLimitDefault = 20;
export const listM365ConnectionsQueryLimitMax = 100;

export const listM365ConnectionsQueryOffsetDefault = 0;
export const listM365ConnectionsQueryOffsetMin = 0;



export const listM365ConnectionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listM365ConnectionsQueryLimitMax).default(listM365ConnectionsQueryLimitDefault),
  "offset": zod.int().min(listM365ConnectionsQueryOffsetMin).default(listM365ConnectionsQueryOffsetDefault)
})


export const listM365ConnectionsResponseTotalMin = 0;

export const listM365ConnectionsResponseLimitMax = 100;

export const listM365ConnectionsResponseOffsetMin = 0;



export const listM365ConnectionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string(),
  "externalTenantId": zod.uuid(),
  "grantKind": zod.enum(['environment', 'delegated', 'application']),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "clientId": zod.uuid().nullable(),
  "principalId": zod.string().nullable(),
  "credentialConfigured": zod.boolean(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "message": zod.string(),
  "verifiedMailboxes": zod.array(zod.string()),
  "destinations": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.string(),
  "driveId": zod.string(),
  "displayName": zod.string(),
  "readVerified": zod.boolean(),
  "writeVerified": zod.boolean(),
  "requiredMetadata": zod.array(zod.string())
}))
})),
  "total": zod.int().min(listM365ConnectionsResponseTotalMin),
  "limit": zod.int().min(1).max(listM365ConnectionsResponseLimitMax),
  "offset": zod.int().min(listM365ConnectionsResponseOffsetMin)
})


export const createM365ConnectionParams = zod.object({
  "scope": zod.enum(['tenant', 'entity'])
})

export const createM365ConnectionBodyDisplayNameMax = 120;

export const createM365ConnectionBodyReasonMin = 10;
export const createM365ConnectionBodyReasonMax = 1000;



export const createM365ConnectionBody = zod.object({
  "displayName": zod.string().min(1).max(createM365ConnectionBodyDisplayNameMax),
  "externalTenantId": zod.uuid(),
  "grantKind": zod.enum(['delegated', 'application']),
  "reason": zod.string().min(createM365ConnectionBodyReasonMin).max(createM365ConnectionBodyReasonMax)
})




export const createM365ConnectionResponse = zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string(),
  "externalTenantId": zod.uuid(),
  "grantKind": zod.enum(['environment', 'delegated', 'application']),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "clientId": zod.uuid().nullable(),
  "principalId": zod.string().nullable(),
  "credentialConfigured": zod.boolean(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "message": zod.string(),
  "verifiedMailboxes": zod.array(zod.string()),
  "destinations": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.string(),
  "driveId": zod.string(),
  "displayName": zod.string(),
  "readVerified": zod.boolean(),
  "writeVerified": zod.boolean(),
  "requiredMetadata": zod.array(zod.string())
}))
})


export const configureM365CredentialsParams = zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "resourceId": zod.uuid()
})

export const configureM365CredentialsBodyExpectedRevisionMin = 0;

export const configureM365CredentialsBodyClientSecretMax = 4096;

export const configureM365CredentialsBodyMailboxesMax = 50;

export const configureM365CredentialsBodyScopeEvidenceMax = 2000;

export const configureM365CredentialsBodyReasonMin = 10;
export const configureM365CredentialsBodyReasonMax = 1000;



export const configureM365CredentialsBody = zod.object({
  "expectedRevision": zod.int().min(configureM365CredentialsBodyExpectedRevisionMin),
  "clientId": zod.uuid(),
  "clientSecret": zod.string().min(1).max(configureM365CredentialsBodyClientSecretMax),
  "sharepoint": zod.boolean(),
  "mailboxes": zod.array(zod.email()).max(configureM365CredentialsBodyMailboxesMax),
  "excludedMailbox": zod.email().nullable(),
  "scopeEvidence": zod.string().max(configureM365CredentialsBodyScopeEvidenceMax),
  "reason": zod.string().min(configureM365CredentialsBodyReasonMin).max(configureM365CredentialsBodyReasonMax)
})




export const configureM365CredentialsResponse = zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string(),
  "externalTenantId": zod.uuid(),
  "grantKind": zod.enum(['environment', 'delegated', 'application']),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "clientId": zod.uuid().nullable(),
  "principalId": zod.string().nullable(),
  "credentialConfigured": zod.boolean(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "message": zod.string(),
  "verifiedMailboxes": zod.array(zod.string()),
  "destinations": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.string(),
  "driveId": zod.string(),
  "displayName": zod.string(),
  "readVerified": zod.boolean(),
  "writeVerified": zod.boolean(),
  "requiredMetadata": zod.array(zod.string())
}))
})


export const disconnectM365ConnectionParams = zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "resourceId": zod.uuid()
})

export const disconnectM365ConnectionBodyExpectedRevisionMin = 0;

export const disconnectM365ConnectionBodyReasonMin = 10;
export const disconnectM365ConnectionBodyReasonMax = 1000;



export const disconnectM365ConnectionBody = zod.object({
  "expectedRevision": zod.int().min(disconnectM365ConnectionBodyExpectedRevisionMin),
  "reason": zod.string().min(disconnectM365ConnectionBodyReasonMin).max(disconnectM365ConnectionBodyReasonMax)
})




export const disconnectM365ConnectionResponse = zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string(),
  "externalTenantId": zod.uuid(),
  "grantKind": zod.enum(['environment', 'delegated', 'application']),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "clientId": zod.uuid().nullable(),
  "principalId": zod.string().nullable(),
  "credentialConfigured": zod.boolean(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "message": zod.string(),
  "verifiedMailboxes": zod.array(zod.string()),
  "destinations": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.string(),
  "driveId": zod.string(),
  "displayName": zod.string(),
  "readVerified": zod.boolean(),
  "writeVerified": zod.boolean(),
  "requiredMetadata": zod.array(zod.string())
}))
})


export const probeM365ConnectionParams = zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "resourceId": zod.uuid()
})

export const probeM365ConnectionBodyExpectedRevisionMin = 0;

export const probeM365ConnectionBodyReasonMin = 10;
export const probeM365ConnectionBodyReasonMax = 1000;

export const probeM365ConnectionBodySiteUrlMax = 2000;

export const probeM365ConnectionBodyDriveIdMax = 500;



export const probeM365ConnectionBody = zod.object({
  "expectedRevision": zod.int().min(probeM365ConnectionBodyExpectedRevisionMin),
  "reason": zod.string().min(probeM365ConnectionBodyReasonMin).max(probeM365ConnectionBodyReasonMax),
  "siteUrl": zod.url().max(probeM365ConnectionBodySiteUrlMax).nullable(),
  "driveId": zod.string().max(probeM365ConnectionBodyDriveIdMax).nullable()
})




export const probeM365ConnectionResponse = zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string(),
  "externalTenantId": zod.uuid(),
  "grantKind": zod.enum(['environment', 'delegated', 'application']),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "clientId": zod.uuid().nullable(),
  "principalId": zod.string().nullable(),
  "credentialConfigured": zod.boolean(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "message": zod.string(),
  "verifiedMailboxes": zod.array(zod.string()),
  "destinations": zod.array(zod.object({
  "id": zod.uuid(),
  "siteId": zod.string(),
  "driveId": zod.string(),
  "displayName": zod.string(),
  "readVerified": zod.boolean(),
  "writeVerified": zod.boolean(),
  "requiredMetadata": zod.array(zod.string())
}))
})


export const startM365ConnectionParams = zod.object({
  "scope": zod.enum(['tenant', 'entity']),
  "resourceId": zod.uuid()
})

export const startM365ConnectionBodyExpectedRevisionMin = 0;

export const startM365ConnectionBodyReasonMin = 10;
export const startM365ConnectionBodyReasonMax = 1000;



export const startM365ConnectionBody = zod.object({
  "expectedRevision": zod.int().min(startM365ConnectionBodyExpectedRevisionMin),
  "reason": zod.string().min(startM365ConnectionBodyReasonMin).max(startM365ConnectionBodyReasonMax)
})

export const startM365ConnectionResponse = zod.object({
  "authorizationUrl": zod.url()
})


export const completeM365ConnectionQueryCodeMax = 4096;



export const completeM365ConnectionQueryParams = zod.object({
  "code": zod.string().min(1).max(completeM365ConnectionQueryCodeMax),
  "state": zod.uuid()
})

export const completeM365ConnectionResponse = zod.void()


export const getTenantDocumentStorageSettingsResponseRevisionMin = 0;

export const getTenantDocumentStorageSettingsResponseConfigurationAllowedDestinationIdsMax = 100;

export const getTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryMax = 80;


export const getTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const getTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsMax = 50;



export const getTenantDocumentStorageSettingsResponse = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "revision": zod.int().min(getTenantDocumentStorageSettingsResponseRevisionMin),
  "configuration": zod.object({
  "connectionMode": zod.enum(['inherit', 'disabled', 'override']),
  "connectionId": zod.uuid().nullable(),
  "storageMode": zod.enum(['inherit', 'override']),
  "allowedDestinationIds": zod.array(zod.uuid()).max(getTenantDocumentStorageSettingsResponseConfigurationAllowedDestinationIdsMax),
  "defaultDestinationId": zod.uuid().nullable(),
  "categoryDefaults": zod.array(zod.object({
  "category": zod.string().min(1).max(getTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryMax).regex(getTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryRegExp),
  "destinationId": zod.uuid()
})).max(getTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsMax),
  "savePolicy": zod.enum(['approved_only', 'drafts_and_approved']).nullable()
})
})


export const updateTenantDocumentStorageSettingsBodyExpectedRevisionMin = 0;
export const updateTenantDocumentStorageSettingsBodyExpectedRevisionMax = 2147483646;

export const updateTenantDocumentStorageSettingsBodyConfigurationAllowedDestinationIdsMax = 100;

export const updateTenantDocumentStorageSettingsBodyConfigurationCategoryDefaultsItemCategoryMax = 80;


export const updateTenantDocumentStorageSettingsBodyConfigurationCategoryDefaultsItemCategoryRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const updateTenantDocumentStorageSettingsBodyConfigurationCategoryDefaultsMax = 50;

export const updateTenantDocumentStorageSettingsBodyReasonMin = 10;
export const updateTenantDocumentStorageSettingsBodyReasonMax = 1000;



export const updateTenantDocumentStorageSettingsBody = zod.object({
  "expectedRevision": zod.int().min(updateTenantDocumentStorageSettingsBodyExpectedRevisionMin).max(updateTenantDocumentStorageSettingsBodyExpectedRevisionMax),
  "configuration": zod.object({
  "connectionMode": zod.enum(['inherit', 'disabled', 'override']),
  "connectionId": zod.uuid().nullable(),
  "storageMode": zod.enum(['inherit', 'override']),
  "allowedDestinationIds": zod.array(zod.uuid()).max(updateTenantDocumentStorageSettingsBodyConfigurationAllowedDestinationIdsMax),
  "defaultDestinationId": zod.uuid().nullable(),
  "categoryDefaults": zod.array(zod.object({
  "category": zod.string().min(1).max(updateTenantDocumentStorageSettingsBodyConfigurationCategoryDefaultsItemCategoryMax).regex(updateTenantDocumentStorageSettingsBodyConfigurationCategoryDefaultsItemCategoryRegExp),
  "destinationId": zod.uuid()
})).max(updateTenantDocumentStorageSettingsBodyConfigurationCategoryDefaultsMax),
  "savePolicy": zod.enum(['approved_only', 'drafts_and_approved']).nullable()
}),
  "reason": zod.string().min(updateTenantDocumentStorageSettingsBodyReasonMin).max(updateTenantDocumentStorageSettingsBodyReasonMax)
})

export const updateTenantDocumentStorageSettingsResponseRevisionMin = 0;

export const updateTenantDocumentStorageSettingsResponseConfigurationAllowedDestinationIdsMax = 100;

export const updateTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryMax = 80;


export const updateTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const updateTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsMax = 50;



export const updateTenantDocumentStorageSettingsResponse = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "revision": zod.int().min(updateTenantDocumentStorageSettingsResponseRevisionMin),
  "configuration": zod.object({
  "connectionMode": zod.enum(['inherit', 'disabled', 'override']),
  "connectionId": zod.uuid().nullable(),
  "storageMode": zod.enum(['inherit', 'override']),
  "allowedDestinationIds": zod.array(zod.uuid()).max(updateTenantDocumentStorageSettingsResponseConfigurationAllowedDestinationIdsMax),
  "defaultDestinationId": zod.uuid().nullable(),
  "categoryDefaults": zod.array(zod.object({
  "category": zod.string().min(1).max(updateTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryMax).regex(updateTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryRegExp),
  "destinationId": zod.uuid()
})).max(updateTenantDocumentStorageSettingsResponseConfigurationCategoryDefaultsMax),
  "savePolicy": zod.enum(['approved_only', 'drafts_and_approved']).nullable()
})
})


export const getEntityDocumentStorageSettingsResponseRevisionMin = 0;

export const getEntityDocumentStorageSettingsResponseConfigurationAllowedDestinationIdsMax = 100;

export const getEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryMax = 80;


export const getEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const getEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsMax = 50;



export const getEntityDocumentStorageSettingsResponse = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "revision": zod.int().min(getEntityDocumentStorageSettingsResponseRevisionMin),
  "configuration": zod.object({
  "connectionMode": zod.enum(['inherit', 'disabled', 'override']),
  "connectionId": zod.uuid().nullable(),
  "storageMode": zod.enum(['inherit', 'override']),
  "allowedDestinationIds": zod.array(zod.uuid()).max(getEntityDocumentStorageSettingsResponseConfigurationAllowedDestinationIdsMax),
  "defaultDestinationId": zod.uuid().nullable(),
  "categoryDefaults": zod.array(zod.object({
  "category": zod.string().min(1).max(getEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryMax).regex(getEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryRegExp),
  "destinationId": zod.uuid()
})).max(getEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsMax),
  "savePolicy": zod.enum(['approved_only', 'drafts_and_approved']).nullable()
})
})


export const updateEntityDocumentStorageSettingsBodyExpectedRevisionMin = 0;
export const updateEntityDocumentStorageSettingsBodyExpectedRevisionMax = 2147483646;

export const updateEntityDocumentStorageSettingsBodyConfigurationAllowedDestinationIdsMax = 100;

export const updateEntityDocumentStorageSettingsBodyConfigurationCategoryDefaultsItemCategoryMax = 80;


export const updateEntityDocumentStorageSettingsBodyConfigurationCategoryDefaultsItemCategoryRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const updateEntityDocumentStorageSettingsBodyConfigurationCategoryDefaultsMax = 50;

export const updateEntityDocumentStorageSettingsBodyReasonMin = 10;
export const updateEntityDocumentStorageSettingsBodyReasonMax = 1000;



export const updateEntityDocumentStorageSettingsBody = zod.object({
  "expectedRevision": zod.int().min(updateEntityDocumentStorageSettingsBodyExpectedRevisionMin).max(updateEntityDocumentStorageSettingsBodyExpectedRevisionMax),
  "configuration": zod.object({
  "connectionMode": zod.enum(['inherit', 'disabled', 'override']),
  "connectionId": zod.uuid().nullable(),
  "storageMode": zod.enum(['inherit', 'override']),
  "allowedDestinationIds": zod.array(zod.uuid()).max(updateEntityDocumentStorageSettingsBodyConfigurationAllowedDestinationIdsMax),
  "defaultDestinationId": zod.uuid().nullable(),
  "categoryDefaults": zod.array(zod.object({
  "category": zod.string().min(1).max(updateEntityDocumentStorageSettingsBodyConfigurationCategoryDefaultsItemCategoryMax).regex(updateEntityDocumentStorageSettingsBodyConfigurationCategoryDefaultsItemCategoryRegExp),
  "destinationId": zod.uuid()
})).max(updateEntityDocumentStorageSettingsBodyConfigurationCategoryDefaultsMax),
  "savePolicy": zod.enum(['approved_only', 'drafts_and_approved']).nullable()
}),
  "reason": zod.string().min(updateEntityDocumentStorageSettingsBodyReasonMin).max(updateEntityDocumentStorageSettingsBodyReasonMax)
})

export const updateEntityDocumentStorageSettingsResponseRevisionMin = 0;

export const updateEntityDocumentStorageSettingsResponseConfigurationAllowedDestinationIdsMax = 100;

export const updateEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryMax = 80;


export const updateEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const updateEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsMax = 50;



export const updateEntityDocumentStorageSettingsResponse = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "revision": zod.int().min(updateEntityDocumentStorageSettingsResponseRevisionMin),
  "configuration": zod.object({
  "connectionMode": zod.enum(['inherit', 'disabled', 'override']),
  "connectionId": zod.uuid().nullable(),
  "storageMode": zod.enum(['inherit', 'override']),
  "allowedDestinationIds": zod.array(zod.uuid()).max(updateEntityDocumentStorageSettingsResponseConfigurationAllowedDestinationIdsMax),
  "defaultDestinationId": zod.uuid().nullable(),
  "categoryDefaults": zod.array(zod.object({
  "category": zod.string().min(1).max(updateEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryMax).regex(updateEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsItemCategoryRegExp),
  "destinationId": zod.uuid()
})).max(updateEntityDocumentStorageSettingsResponseConfigurationCategoryDefaultsMax),
  "savePolicy": zod.enum(['approved_only', 'drafts_and_approved']).nullable()
})
})


export const getEffectiveDocumentStorageResponseTenantRevisionMin = 0;

export const getEffectiveDocumentStorageResponseEntityRevisionMin = 0;


export const getEffectiveDocumentStorageResponseConnectionOneDisplayNameMax = 120;


export const getEffectiveDocumentStorageResponseAllowedDestinationsItemDisplayNameMax = 120;

export const getEffectiveDocumentStorageResponseAllowedDestinationsItemFolderPathMax = 1000;

export const getEffectiveDocumentStorageResponseAllowedDestinationsMax = 100;

export const getEffectiveDocumentStorageResponseCategoryDefaultsItemCategoryMax = 80;


export const getEffectiveDocumentStorageResponseCategoryDefaultsItemCategoryRegExp = new RegExp('^[a-z][a-z0-9_]*$');
export const getEffectiveDocumentStorageResponseCategoryDefaultsMax = 50;

export const getEffectiveDocumentStorageResponseBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getEffectiveDocumentStorageResponseIssuesMax = 302;



export const getEffectiveDocumentStorageResponse = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "tenantRevision": zod.int().min(getEffectiveDocumentStorageResponseTenantRevisionMin),
  "entityRevision": zod.int().min(getEffectiveDocumentStorageResponseEntityRevisionMin),
  "connectionSource": zod.enum(['tenant', 'entity', 'disabled', 'legacy']),
  "storageSource": zod.enum(['tenant', 'entity', 'legacy']),
  "policySource": zod.enum(['tenant', 'entity', 'legacy']),
  "connection": zod.union([zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string().min(1).max(getEffectiveDocumentStorageResponseConnectionOneDisplayNameMax),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "externalTenantId": zod.uuid(),
  "grantKind": zod.enum(['environment', 'delegated', 'application']),
  "principalAppUserId": zod.uuid().nullable()
}),zod.null()]),
  "allowedDestinations": zod.array(zod.object({
  "id": zod.uuid(),
  "resourceId": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "displayName": zod.string().min(1).max(getEffectiveDocumentStorageResponseAllowedDestinationsItemDisplayNameMax),
  "status": zod.enum(['setup_required', 'ready', 'unavailable', 'revoked']),
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().nullable(),
  "siteId": zod.string().nullable(),
  "driveId": zod.string().nullable(),
  "containerId": zod.string().nullable(),
  "folderPath": zod.string().max(getEffectiveDocumentStorageResponseAllowedDestinationsItemFolderPathMax)
})).max(getEffectiveDocumentStorageResponseAllowedDestinationsMax),
  "defaultDestinationId": zod.uuid().nullable(),
  "categoryDefaults": zod.array(zod.object({
  "category": zod.string().min(1).max(getEffectiveDocumentStorageResponseCategoryDefaultsItemCategoryMax).regex(getEffectiveDocumentStorageResponseCategoryDefaultsItemCategoryRegExp),
  "destinationId": zod.uuid()
})).max(getEffectiveDocumentStorageResponseCategoryDefaultsMax),
  "savePolicy": zod.enum(['approved_only', 'drafts_and_approved']).nullable(),
  "bindingFingerprint": zod.string().regex(getEffectiveDocumentStorageResponseBindingFingerprintRegExp),
  "issues": zod.array(zod.object({
  "code": zod.enum(['connection_unavailable', 'destination_unavailable', 'stale_binding', 'legacy_unbound']),
  "referenceId": zod.uuid().nullable(),
  "message": zod.string()
})).max(getEffectiveDocumentStorageResponseIssuesMax),
  "legacyBehavior": zod.boolean()
})


/**
 * @summary Liveness probe
 */
export const getHealthResponse = zod.object({
  "status": zod.enum(['ok']),
  "uptimeSeconds": zod.number(),
  "timestamp": zod.iso.datetime({"offset":true}),
  "database": zod.enum(['connected', 'not_configured']),
  "plugins": zod.object({
  "database": zod.boolean(),
  "storage": zod.boolean(),
  "ai": zod.boolean(),
  "auth": zod.boolean()
})
})


/**
 * @summary Aggregate counters for the dashboard stat cards
 */
export const getDashboardStatsResponse = zod.object({
  "categories": zod.int(),
  "solutions": zod.int(),
  "products": zod.int(),
  "modules": zod.int(),
  "capabilities": zod.int()
})


/**
 * Returns compact aggregates across every matching CRM row. The current authenticated tenant and entity scope is enforced by the database.
 * @summary Get exact scoped CRM dashboard totals and pipeline distribution
 */
export const getDashboardSummaryQueryIncludeTestDataDefault = false;

export const getDashboardSummaryQueryParams = zod.object({
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "includeTestData": zod.boolean().default(getDashboardSummaryQueryIncludeTestDataDefault).describe('Include records flagged as test or demo data. They are excluded by default.')
})

export const getDashboardSummaryResponseAccountTotalMin = 0;

export const getDashboardSummaryResponseB2bCustomerCountMin = 0;

export const getDashboardSummaryResponseEmailOptInCountMin = 0;

export const getDashboardSummaryResponseActivePartnerCountMin = 0;

export const getDashboardSummaryResponseOpportunityTotalMin = 0;

export const getDashboardSummaryResponseActiveOpportunityCountMin = 0;

export const getDashboardSummaryResponseActiveOpportunityValueMin = 0;

export const getDashboardSummaryResponseCommittedOpportunityCountMin = 0;

export const getDashboardSummaryResponseEnquiryTotalMin = 0;

export const getDashboardSummaryResponseNewEnquiryCountMin = 0;

export const getDashboardSummaryResponseStageCountsItemCountMin = 0;

export const getDashboardSummaryResponseStageCountsMax = 17;



export const getDashboardSummaryResponse = zod.object({
  "accountTotal": zod.int().min(getDashboardSummaryResponseAccountTotalMin),
  "b2bCustomerCount": zod.int().min(getDashboardSummaryResponseB2bCustomerCountMin),
  "emailOptInCount": zod.int().min(getDashboardSummaryResponseEmailOptInCountMin),
  "activePartnerCount": zod.int().min(getDashboardSummaryResponseActivePartnerCountMin),
  "opportunityTotal": zod.int().min(getDashboardSummaryResponseOpportunityTotalMin),
  "activeOpportunityCount": zod.int().min(getDashboardSummaryResponseActiveOpportunityCountMin),
  "activeOpportunityValue": zod.number().min(getDashboardSummaryResponseActiveOpportunityValueMin),
  "committedOpportunityCount": zod.int().min(getDashboardSummaryResponseCommittedOpportunityCountMin),
  "enquiryTotal": zod.int().min(getDashboardSummaryResponseEnquiryTotalMin),
  "newEnquiryCount": zod.int().min(getDashboardSummaryResponseNewEnquiryCountMin),
  "stageCounts": zod.array(zod.object({
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']),
  "count": zod.int().min(getDashboardSummaryResponseStageCountsItemCountMin)
})).max(getDashboardSummaryResponseStageCountsMax)
})


/**
 * @summary Daily activity series for the dashboard chart
 */
export const getDashboardTimeseriesQueryDaysDefault = 30;
export const getDashboardTimeseriesQueryDaysMin = 7;
export const getDashboardTimeseriesQueryDaysMax = 90;



export const getDashboardTimeseriesQueryParams = zod.object({
  "days": zod.int().min(getDashboardTimeseriesQueryDaysMin).max(getDashboardTimeseriesQueryDaysMax).default(getDashboardTimeseriesQueryDaysDefault)
})

export const getDashboardTimeseriesResponse = zod.object({
  "days": zod.int(),
  "points": zod.array(zod.object({
  "date": zod.iso.date(),
  "created": zod.int(),
  "completed": zod.int()
}))
})


/**
 * Aggregates all four CRM audiences in PostgreSQL. When DATABASE_URL is not configured, returns the same complete shape with zero values and databaseConfigured false.
 * @summary Get cross-workspace KPIs, attention exceptions, and pipeline stage snapshots
 */
export const getHomeOverviewResponseWorkspacesItemDirectoryTotalMin = 0;

export const getHomeOverviewResponseWorkspacesItemOpenOpportunityCountMin = 0;

export const getHomeOverviewResponseWorkspacesItemOpenOpportunityValueMin = 0;

export const getHomeOverviewResponseWorkspacesItemNewEnquiryCountMin = 0;

export const getHomeOverviewResponseWorkspacesMin = 4;
export const getHomeOverviewResponseWorkspacesMax = 4;

export const getHomeOverviewResponseNeedsAttentionItemAgeDaysMin = 0;

export const getHomeOverviewResponseNeedsAttentionItemRankingBoostMin = 0;
export const getHomeOverviewResponseNeedsAttentionItemRankingBoostMax = 10;

export const getHomeOverviewResponsePipelineSnapshotItemStagesItemCountMin = 0;

export const getHomeOverviewResponsePipelineSnapshotMin = 4;
export const getHomeOverviewResponsePipelineSnapshotMax = 4;

export const getHomeOverviewResponseTenderOpportunitiesNewStrongMin = 0;

export const getHomeOverviewResponseTenderOpportunitiesNewPossibleMin = 0;

export const getHomeOverviewResponseTenderOpportunitiesClosingSoonMin = 0;

export const getHomeOverviewResponseTenderOpportunitiesNewAddendaMin = 0;



export const getHomeOverviewResponse = zod.object({
  "databaseConfigured": zod.boolean().describe('False when DATABASE_URL is absent and deterministic empty aggregates are returned'),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "workspaces": zod.array(zod.object({
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "directoryTotal": zod.int().min(getHomeOverviewResponseWorkspacesItemDirectoryTotalMin),
  "openOpportunityCount": zod.int().min(getHomeOverviewResponseWorkspacesItemOpenOpportunityCountMin),
  "openOpportunityValue": zod.number().min(getHomeOverviewResponseWorkspacesItemOpenOpportunityValueMin),
  "newEnquiryCount": zod.int().min(getHomeOverviewResponseWorkspacesItemNewEnquiryCountMin)
})).min(getHomeOverviewResponseWorkspacesMin).max(getHomeOverviewResponseWorkspacesMax),
  "needsAttention": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['stalled_opportunity', 'aging_enquiry', 'new_tender_opportunity', 'tender_closing_soon']),
  "name": zod.string(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "ageDays": zod.int().min(getHomeOverviewResponseNeedsAttentionItemAgeDaysMin),
  "deepLink": zod.string(),
  "accountName": zod.string().nullish().describe('Name of the related account, when the item has one.'),
  "contactName": zod.string().nullish().describe('Full name of the related contact, when the item has one.'),
  "closesAt": zod.iso.datetime({"offset":true}).nullish().describe('Closing date for tender items; absent for other kinds.'),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).optional().describe('More important of the related account and primary contact.'),
  "rankingBoost": zod.int().min(getHomeOverviewResponseNeedsAttentionItemRankingBoostMin).max(getHomeOverviewResponseNeedsAttentionItemRankingBoostMax).optional().describe('Bounded strategic boost that orders otherwise-equally urgent items.'),
  "priorityReasons": zod.array(zod.string()).optional().describe('Why the item ranks higher, e.g. \'Strategic account\' or \'Strategic brief on file\'.')
})),
  "pipelineSnapshot": zod.array(zod.object({
  "key": zod.enum(['b2b_sales', 'b2c_sales', 'partner_joint', 'investor_funding']),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),
  "stages": zod.array(zod.object({
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']),
  "count": zod.int().min(getHomeOverviewResponsePipelineSnapshotItemStagesItemCountMin)
}))
})).min(getHomeOverviewResponsePipelineSnapshotMin).max(getHomeOverviewResponsePipelineSnapshotMax),
  "tenderOpportunities": zod.object({
  "newStrong": zod.int().min(getHomeOverviewResponseTenderOpportunitiesNewStrongMin),
  "newPossible": zod.int().min(getHomeOverviewResponseTenderOpportunitiesNewPossibleMin),
  "closingSoon": zod.int().min(getHomeOverviewResponseTenderOpportunitiesClosingSoonMin).describe('Open strong or possible matches closing within 7 days.'),
  "newAddenda": zod.int().min(getHomeOverviewResponseTenderOpportunitiesNewAddendaMin).describe('Open opportunities with addenda added since they were last viewed.')
}).optional().describe('Present only for callers who can read tender opportunities. New counts are open items the caller has not viewed.')
})


/**
 * Generates a bounded briefing from aggregate CRM data and top action signals, then caches it for one hour. If project AI is disabled or the model call fails, a deterministic non-AI briefing is returned instead.
 * @summary Get the cached AI daily briefing for an audience or all CRM workspaces
 */
export const getHomeBriefingQueryParams = zod.object({
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional().describe('Limit the briefing to this audience; omit for the overall briefing.')
})

export const getHomeBriefingResponseSummaryMax = 600;

export const getHomeBriefingResponseFactsItemIdMax = 100;

export const getHomeBriefingResponseFactsItemLabelMax = 120;

export const getHomeBriefingResponseFactsItemValueMax = 100;

export const getHomeBriefingResponseFactsItemHrefRegExp = new RegExp('^(?:/\\?view=(?:b2b|b2c|partner|investor)|/(?:dashboard|next-actions|partner-engagement/(?:opportunities|enquiries|accounts))(?:/[A-Za-z0-9-]+)?(?:\\?[A-Za-z0-9_=&%.-]*)?)$');

export const getHomeBriefingResponseSegmentsItemHrefRegExp = new RegExp('^(?:/\\?view=(?:b2b|b2c|partner|investor)|/(?:dashboard|next-actions|partner-engagement/(?:opportunities|enquiries|accounts))(?:/[A-Za-z0-9-]+)?(?:\\?[A-Za-z0-9_=&%.-]*)?)$');
export const getHomeBriefingResponseSegmentsItemFactIdMax = 100;


export const getHomeBriefingResponseInsightsItemTitleMax = 100;

export const getHomeBriefingResponseInsightsItemDetailMax = 300;

export const getHomeBriefingResponseInsightsItemLinkRegExp = new RegExp('^(?:/\\?view=(?:b2b|b2c|partner|investor)|/(?:dashboard|next-actions|partner-engagement/(?:opportunities|enquiries|accounts))(?:/[A-Za-z0-9-]+)?(?:\\?[A-Za-z0-9_=&%.-]*)?)$');
export const getHomeBriefingResponseInsightsMin = 3;
export const getHomeBriefingResponseInsightsMax = 5;



export const getHomeBriefingResponse = zod.object({
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).nullable(),
  "summary": zod.string().min(1).max(getHomeBriefingResponseSummaryMax),
  "facts": zod.array(zod.object({
  "id": zod.string().min(1).max(getHomeBriefingResponseFactsItemIdMax),
  "label": zod.string().min(1).max(getHomeBriefingResponseFactsItemLabelMax),
  "value": zod.string().min(1).max(getHomeBriefingResponseFactsItemValueMax),
  "kind": zod.enum(['count', 'currency', 'record', 'workspace']),
  "href": zod.string().regex(getHomeBriefingResponseFactsItemHrefRegExp)
})),
  "segments": zod.array(zod.object({
  "type": zod.enum(['text', 'link']),
  "text": zod.string().min(1),
  "href": zod.string().regex(getHomeBriefingResponseSegmentsItemHrefRegExp).optional(),
  "factId": zod.string().min(1).max(getHomeBriefingResponseSegmentsItemFactIdMax).optional()
})).min(1),
  "insights": zod.array(zod.object({
  "title": zod.string().min(1).max(getHomeBriefingResponseInsightsItemTitleMax),
  "detail": zod.string().min(1).max(getHomeBriefingResponseInsightsItemDetailMax),
  "tone": zod.enum(['positive', 'warning', 'neutral']),
  "link": zod.string().regex(getHomeBriefingResponseInsightsItemLinkRegExp).optional()
})).min(getHomeBriefingResponseInsightsMin).max(getHomeBriefingResponseInsightsMax),
  "source": zod.enum(['ai', 'fallback']),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "cached": zod.boolean().describe('True when the response was served from the in-memory one-hour cache')
})


/**
 * Bypasses only this audience's one-hour briefing cache and generates a fresh AI or deterministic briefing.
 * @summary Regenerate only the selected audience or overall daily briefing
 */
export const refreshHomeBriefingQueryParams = zod.object({
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional().describe('Limit the briefing to this audience; omit for the overall briefing.')
})

export const refreshHomeBriefingResponseSummaryMax = 600;

export const refreshHomeBriefingResponseFactsItemIdMax = 100;

export const refreshHomeBriefingResponseFactsItemLabelMax = 120;

export const refreshHomeBriefingResponseFactsItemValueMax = 100;

export const refreshHomeBriefingResponseFactsItemHrefRegExp = new RegExp('^(?:/\\?view=(?:b2b|b2c|partner|investor)|/(?:dashboard|next-actions|partner-engagement/(?:opportunities|enquiries|accounts))(?:/[A-Za-z0-9-]+)?(?:\\?[A-Za-z0-9_=&%.-]*)?)$');

export const refreshHomeBriefingResponseSegmentsItemHrefRegExp = new RegExp('^(?:/\\?view=(?:b2b|b2c|partner|investor)|/(?:dashboard|next-actions|partner-engagement/(?:opportunities|enquiries|accounts))(?:/[A-Za-z0-9-]+)?(?:\\?[A-Za-z0-9_=&%.-]*)?)$');
export const refreshHomeBriefingResponseSegmentsItemFactIdMax = 100;


export const refreshHomeBriefingResponseInsightsItemTitleMax = 100;

export const refreshHomeBriefingResponseInsightsItemDetailMax = 300;

export const refreshHomeBriefingResponseInsightsItemLinkRegExp = new RegExp('^(?:/\\?view=(?:b2b|b2c|partner|investor)|/(?:dashboard|next-actions|partner-engagement/(?:opportunities|enquiries|accounts))(?:/[A-Za-z0-9-]+)?(?:\\?[A-Za-z0-9_=&%.-]*)?)$');
export const refreshHomeBriefingResponseInsightsMin = 3;
export const refreshHomeBriefingResponseInsightsMax = 5;



export const refreshHomeBriefingResponse = zod.object({
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).nullable(),
  "summary": zod.string().min(1).max(refreshHomeBriefingResponseSummaryMax),
  "facts": zod.array(zod.object({
  "id": zod.string().min(1).max(refreshHomeBriefingResponseFactsItemIdMax),
  "label": zod.string().min(1).max(refreshHomeBriefingResponseFactsItemLabelMax),
  "value": zod.string().min(1).max(refreshHomeBriefingResponseFactsItemValueMax),
  "kind": zod.enum(['count', 'currency', 'record', 'workspace']),
  "href": zod.string().regex(refreshHomeBriefingResponseFactsItemHrefRegExp)
})),
  "segments": zod.array(zod.object({
  "type": zod.enum(['text', 'link']),
  "text": zod.string().min(1),
  "href": zod.string().regex(refreshHomeBriefingResponseSegmentsItemHrefRegExp).optional(),
  "factId": zod.string().min(1).max(refreshHomeBriefingResponseSegmentsItemFactIdMax).optional()
})).min(1),
  "insights": zod.array(zod.object({
  "title": zod.string().min(1).max(refreshHomeBriefingResponseInsightsItemTitleMax),
  "detail": zod.string().min(1).max(refreshHomeBriefingResponseInsightsItemDetailMax),
  "tone": zod.enum(['positive', 'warning', 'neutral']),
  "link": zod.string().regex(refreshHomeBriefingResponseInsightsItemLinkRegExp).optional()
})).min(refreshHomeBriefingResponseInsightsMin).max(refreshHomeBriefingResponseInsightsMax),
  "source": zod.enum(['ai', 'fallback']),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "cached": zod.boolean().describe('True when the response was served from the in-memory one-hour cache')
})


/**
 * @summary Full nested catalogue tree
 */
export const getCatalogueHierarchyQueryIncludeInactiveDefault = false;

export const getCatalogueHierarchyQueryParams = zod.object({
  "includeInactive": zod.boolean().default(getCatalogueHierarchyQueryIncludeInactiveDefault)
})

export const getCatalogueHierarchyResponse = zod.object({
  "categories": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "solutions": zod.array(zod.object({
  "id": zod.uuid(),
  "categoryId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "products": zod.array(zod.object({
  "id": zod.uuid(),
  "solutionId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "basePrice": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "modules": zod.array(zod.object({
  "id": zod.uuid(),
  "productId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "modulePrice": zod.string().nullish(),
  "isCore": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "capabilities": zod.array(zod.object({
  "id": zod.uuid(),
  "moduleId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "isUnverified": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))),
  "requirements": zod.array(zod.object({
  "id": zod.uuid(),
  "productId": zod.uuid(),
  "capabilityId": zod.uuid().nullish(),
  "code": zod.string(),
  "role": zod.string(),
  "requirement": zod.string(),
  "category": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})))
})))
})))
})


/**
 * @summary Published catalogue hierarchy (public, unauthenticated)
 */
export const getPublicCatalogueResponse = zod.object({
  "categories": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "solutions": zod.array(zod.object({
  "id": zod.uuid(),
  "categoryId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "products": zod.array(zod.object({
  "id": zod.uuid(),
  "solutionId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "basePrice": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "modules": zod.array(zod.object({
  "id": zod.uuid(),
  "productId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "modulePrice": zod.string().nullish(),
  "isCore": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "capabilities": zod.array(zod.object({
  "id": zod.uuid(),
  "moduleId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "isUnverified": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})))
})))
})))
})))
})


/**
 * @summary Active catalogue services (public, unauthenticated)
 */
export const listPublicCatalogueServicesResponseTotalMin = 0;



export const listPublicCatalogueServicesResponse = zod.object({
  "items": zod.array(zod.object({
  "componentId": zod.uuid().nullish(),
  "description": zod.string().nullish(),
  "shortDescription": zod.string().nullish(),
  "serviceType": zod.string(),
  "servicePrice": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isFeatured": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listPublicCatalogueServicesResponseTotalMin)
})


/**
 * @summary Guest quote request submission (public, unauthenticated)
 */
export const submitPublicQuoteRequestBodyRequesterNameMax = 200;

export const submitPublicQuoteRequestBodyRequesterPhoneMax = 50;

export const submitPublicQuoteRequestBodyRequesterOrganizationMax = 200;

export const submitPublicQuoteRequestBodyNotesMax = 2000;

export const submitPublicQuoteRequestBodyItemsItemLabelMax = 300;

export const submitPublicQuoteRequestBodyItemsMax = 50;



export const submitPublicQuoteRequestBody = zod.object({
  "requesterName": zod.string().min(1).max(submitPublicQuoteRequestBodyRequesterNameMax),
  "requesterEmail": zod.email(),
  "requesterPhone": zod.string().max(submitPublicQuoteRequestBodyRequesterPhoneMax).nullish(),
  "requesterOrganization": zod.string().max(submitPublicQuoteRequestBodyRequesterOrganizationMax).nullish(),
  "notes": zod.string().max(submitPublicQuoteRequestBodyNotesMax).nullish(),
  "items": zod.array(zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "label": zod.string().min(1).max(submitPublicQuoteRequestBodyItemsItemLabelMax),
  "quantity": zod.string().nullish()
})).min(1).max(submitPublicQuoteRequestBodyItemsMax),
  "website": zod.string().optional().describe('Honeypot field — must be left empty. Filled values are rejected.')
})

export const submitPublicQuoteRequestResponse = zod.object({
  "id": zod.uuid(),
  "reference": zod.string()
})


/**
 * @summary List entity price lists
 */
export const listPriceListsQueryLimitDefault = 50;
export const listPriceListsQueryLimitMax = 100;

export const listPriceListsQueryOffsetDefault = 0;
export const listPriceListsQueryOffsetMin = 0;



export const listPriceListsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPriceListsQueryLimitMax).default(listPriceListsQueryLimitDefault),
  "offset": zod.int().min(listPriceListsQueryOffsetMin).default(listPriceListsQueryOffsetDefault)
})

export const listPriceListsResponseTotalMin = 0;

export const listPriceListsResponseLimitMax = 100;

export const listPriceListsResponseOffsetMin = 0;



export const listPriceListsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "code": zod.string(),
  "currency": zod.string(),
  "appliesToAccountTypes": zod.array(zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])),
  "isDefault": zod.boolean(),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validTo": zod.iso.datetime({"offset":true}).nullable(),
  "status": zod.enum(['active', 'archived']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPriceListsResponseTotalMin),
  "limit": zod.int().min(1).max(listPriceListsResponseLimitMax),
  "offset": zod.int().min(listPriceListsResponseOffsetMin)
})


/**
 * @summary Create an entity price list
 */
export const createPriceListBodyOneNameMax = 120;

export const createPriceListBodyOneCodeRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]{0,29}$');
export const createPriceListBodyOneCurrencyRegExp = new RegExp('^[A-Za-z]{3}$');
export const createPriceListBodyOneAppliesToAccountTypesMax = 6;

export const createPriceListBodyOneIsDefaultDefault = false;

export const createPriceListBody = zod.object({
  "name": zod.string().min(1).max(createPriceListBodyOneNameMax),
  "code": zod.string().regex(createPriceListBodyOneCodeRegExp),
  "currency": zod.string().regex(createPriceListBodyOneCurrencyRegExp),
  "appliesToAccountTypes": zod.array(zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])).max(createPriceListBodyOneAppliesToAccountTypesMax),
  "isDefault": zod.boolean().default(createPriceListBodyOneIsDefaultDefault),
  "validFrom": zod.iso.datetime({"offset":true}).nullish(),
  "validTo": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['active', 'archived']).optional()
})

export const createPriceListResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "code": zod.string(),
  "currency": zod.string(),
  "appliesToAccountTypes": zod.array(zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])),
  "isDefault": zod.boolean(),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validTo": zod.iso.datetime({"offset":true}).nullable(),
  "status": zod.enum(['active', 'archived']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Resolve the active price list for an account classification
 */
export const resolveAccountPriceListQueryParams = zod.object({
  "accountId": zod.uuid()
})

export const resolveAccountPriceListResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "code": zod.string(),
  "currency": zod.string(),
  "appliesToAccountTypes": zod.array(zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])),
  "isDefault": zod.boolean(),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validTo": zod.iso.datetime({"offset":true}).nullable(),
  "status": zod.enum(['active', 'archived']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get one entity price list
 */
export const getPriceListParams = zod.object({
  "id": zod.uuid()
})

export const getPriceListResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "code": zod.string(),
  "currency": zod.string(),
  "appliesToAccountTypes": zod.array(zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])),
  "isDefault": zod.boolean(),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validTo": zod.iso.datetime({"offset":true}).nullable(),
  "status": zod.enum(['active', 'archived']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update, archive, or make a price list the default
 */
export const updatePriceListParams = zod.object({
  "id": zod.uuid()
})

export const updatePriceListBodyNameMax = 120;

export const updatePriceListBodyCodeRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]{0,29}$');
export const updatePriceListBodyCurrencyRegExp = new RegExp('^[A-Za-z]{3}$');
export const updatePriceListBodyAppliesToAccountTypesMax = 6;



export const updatePriceListBody = zod.object({
  "name": zod.string().min(1).max(updatePriceListBodyNameMax).optional(),
  "code": zod.string().regex(updatePriceListBodyCodeRegExp).optional(),
  "currency": zod.string().regex(updatePriceListBodyCurrencyRegExp).optional(),
  "appliesToAccountTypes": zod.array(zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])).max(updatePriceListBodyAppliesToAccountTypesMax).optional(),
  "isDefault": zod.boolean().optional(),
  "validFrom": zod.iso.datetime({"offset":true}).nullish(),
  "validTo": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['active', 'archived']).optional()
})

export const updatePriceListResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "code": zod.string(),
  "currency": zod.string(),
  "appliesToAccountTypes": zod.array(zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])),
  "isDefault": zod.boolean(),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validTo": zod.iso.datetime({"offset":true}).nullable(),
  "status": zod.enum(['active', 'archived']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List stored items for a price list
 */
export const listPriceListItemsParams = zod.object({
  "id": zod.uuid()
})

export const listPriceListItemsQueryLimitDefault = 50;
export const listPriceListItemsQueryLimitMax = 100;

export const listPriceListItemsQueryOffsetDefault = 0;
export const listPriceListItemsQueryOffsetMin = 0;



export const listPriceListItemsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPriceListItemsQueryLimitMax).default(listPriceListItemsQueryLimitDefault),
  "offset": zod.int().min(listPriceListItemsQueryOffsetMin).default(listPriceListItemsQueryOffsetDefault)
})

export const listPriceListItemsResponseTotalMin = 0;

export const listPriceListItemsResponseLimitMax = 100;

export const listPriceListItemsResponseOffsetMin = 0;



export const listPriceListItemsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "priceListId": zod.uuid(),
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "itemId": zod.uuid(),
  "oneOffPrice": zod.string().nullable(),
  "recurringPrice": zod.string().nullable(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "unitLabel": zod.string().nullable(),
  "taxTreatment": zod.string(),
  "minQty": zod.string(),
  "isQuotable": zod.boolean(),
  "notes": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPriceListItemsResponseTotalMin),
  "limit": zod.int().min(1).max(listPriceListItemsResponseLimitMax),
  "offset": zod.int().min(listPriceListItemsResponseOffsetMin)
})


/**
 * @summary Upsert up to 100 unique price-list items
 */
export const bulkUpsertPriceListItemsParams = zod.object({
  "id": zod.uuid()
})

export const bulkUpsertPriceListItemsBodyItemsItemOneOffPriceMin = 0;

export const bulkUpsertPriceListItemsBodyItemsItemRecurringPriceMin = 0;

export const bulkUpsertPriceListItemsBodyItemsItemUnitLabelMax = 80;

export const bulkUpsertPriceListItemsBodyItemsItemTaxTreatmentMax = 80;

export const bulkUpsertPriceListItemsBodyItemsItemMinQtyExclusiveMin = 0;

export const bulkUpsertPriceListItemsBodyItemsItemNotesMax = 2000;

export const bulkUpsertPriceListItemsBodyItemsMax = 100;



export const bulkUpsertPriceListItemsBody = zod.object({
  "items": zod.array(zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "itemId": zod.uuid(),
  "oneOffPrice": zod.number().min(bulkUpsertPriceListItemsBodyItemsItemOneOffPriceMin).nullish(),
  "recurringPrice": zod.number().min(bulkUpsertPriceListItemsBodyItemsItemRecurringPriceMin).nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "unitLabel": zod.string().max(bulkUpsertPriceListItemsBodyItemsItemUnitLabelMax).nullish(),
  "taxTreatment": zod.string().min(1).max(bulkUpsertPriceListItemsBodyItemsItemTaxTreatmentMax),
  "minQty": zod.number().gt(bulkUpsertPriceListItemsBodyItemsItemMinQtyExclusiveMin),
  "isQuotable": zod.boolean(),
  "notes": zod.string().max(bulkUpsertPriceListItemsBodyItemsItemNotesMax).nullish()
})).min(1).max(bulkUpsertPriceListItemsBodyItemsMax)
})

export const bulkUpsertPriceListItemsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "priceListId": zod.uuid(),
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "itemId": zod.uuid(),
  "oneOffPrice": zod.string().nullable(),
  "recurringPrice": zod.string().nullable(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "unitLabel": zod.string().nullable(),
  "taxTreatment": zod.string(),
  "minQty": zod.string(),
  "isQuotable": zod.boolean(),
  "notes": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary List the roles and sell rates on a price list
 */
export const listPriceListRatesParams = zod.object({
  "id": zod.uuid()
})

export const listPriceListRatesQueryLimitDefault = 50;
export const listPriceListRatesQueryLimitMax = 100;

export const listPriceListRatesQueryOffsetDefault = 0;
export const listPriceListRatesQueryOffsetMin = 0;



export const listPriceListRatesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPriceListRatesQueryLimitMax).default(listPriceListRatesQueryLimitDefault),
  "offset": zod.int().min(listPriceListRatesQueryOffsetMin).default(listPriceListRatesQueryOffsetDefault)
})

export const listPriceListRatesResponseTotalMin = 0;

export const listPriceListRatesResponseLimitMax = 100;

export const listPriceListRatesResponseOffsetMin = 0;



export const listPriceListRatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "priceListId": zod.uuid(),
  "roleCode": zod.string(),
  "roleName": zod.string(),
  "hourlyRate": zod.string(),
  "dailyRate": zod.string().nullable(),
  "costHourlyRate": zod.string().nullable(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPriceListRatesResponseTotalMin),
  "limit": zod.int().min(1).max(listPriceListRatesResponseLimitMax),
  "offset": zod.int().min(listPriceListRatesResponseOffsetMin)
})


/**
 * @summary Upsert up to 100 unique rate-card roles
 */
export const bulkUpsertPriceListRatesParams = zod.object({
  "id": zod.uuid()
})

export const bulkUpsertPriceListRatesBodyRatesItemRoleCodeRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]{0,29}$');
export const bulkUpsertPriceListRatesBodyRatesItemRoleNameMax = 120;

export const bulkUpsertPriceListRatesBodyRatesItemHourlyRateMin = 0;

export const bulkUpsertPriceListRatesBodyRatesItemDailyRateMin = 0;

export const bulkUpsertPriceListRatesBodyRatesItemCostHourlyRateMin = 0;

export const bulkUpsertPriceListRatesBodyRatesItemSortOrderMin = 0;

export const bulkUpsertPriceListRatesBodyRatesMax = 100;



export const bulkUpsertPriceListRatesBody = zod.object({
  "rates": zod.array(zod.object({
  "roleCode": zod.string().regex(bulkUpsertPriceListRatesBodyRatesItemRoleCodeRegExp),
  "roleName": zod.string().min(1).max(bulkUpsertPriceListRatesBodyRatesItemRoleNameMax),
  "hourlyRate": zod.number().min(bulkUpsertPriceListRatesBodyRatesItemHourlyRateMin),
  "dailyRate": zod.number().min(bulkUpsertPriceListRatesBodyRatesItemDailyRateMin).nullish(),
  "costHourlyRate": zod.number().min(bulkUpsertPriceListRatesBodyRatesItemCostHourlyRateMin).nullish(),
  "sortOrder": zod.int().min(bulkUpsertPriceListRatesBodyRatesItemSortOrderMin),
  "isActive": zod.boolean()
})).min(1).max(bulkUpsertPriceListRatesBodyRatesMax)
})

export const bulkUpsertPriceListRatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "priceListId": zod.uuid(),
  "roleCode": zod.string(),
  "roleName": zod.string(),
  "hourlyRate": zod.string(),
  "dailyRate": zod.string().nullable(),
  "costHourlyRate": zod.string().nullable(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Copy a price list and all of its item prices
 */
export const copyPriceListParams = zod.object({
  "id": zod.uuid()
})

export const copyPriceListBodyNameMax = 120;

export const copyPriceListBodyCodeRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]{0,29}$');


export const copyPriceListBody = zod.object({
  "name": zod.string().min(1).max(copyPriceListBodyNameMax),
  "code": zod.string().regex(copyPriceListBodyCodeRegExp)
})

export const copyPriceListResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "code": zod.string(),
  "currency": zod.string(),
  "appliesToAccountTypes": zod.array(zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])),
  "isDefault": zod.boolean(),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validTo": zod.iso.datetime({"offset":true}).nullable(),
  "status": zod.enum(['active', 'archived']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List active quotable catalogue entries with prices and requirements
 */
export const getQuotablePriceBookParams = zod.object({
  "id": zod.uuid()
})

export const getQuotablePriceBookQuerySearchMax = 100;

export const getQuotablePriceBookQueryIncludeUnpricedDefault = false;
export const getQuotablePriceBookQueryLimitDefault = 50;
export const getQuotablePriceBookQueryLimitMax = 100;

export const getQuotablePriceBookQueryOffsetDefault = 0;
export const getQuotablePriceBookQueryOffsetMin = 0;



export const getQuotablePriceBookQueryParams = zod.object({
  "search": zod.string().max(getQuotablePriceBookQuerySearchMax).optional(),
  "includeUnpriced": zod.boolean().default(getQuotablePriceBookQueryIncludeUnpricedDefault).describe('Include active catalogue entries that do not yet have a price-list item (admin grid only).'),
  "limit": zod.int().min(1).max(getQuotablePriceBookQueryLimitMax).default(getQuotablePriceBookQueryLimitDefault),
  "offset": zod.int().min(getQuotablePriceBookQueryOffsetMin).default(getQuotablePriceBookQueryOffsetDefault)
})

export const getQuotablePriceBookResponseTotalMin = 0;

export const getQuotablePriceBookResponseLimitMax = 100;

export const getQuotablePriceBookResponseOffsetMin = 0;



export const getQuotablePriceBookResponse = zod.object({
  "priceList": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "code": zod.string(),
  "currency": zod.string(),
  "appliesToAccountTypes": zod.array(zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])),
  "isDefault": zod.boolean(),
  "validFrom": zod.iso.datetime({"offset":true}).nullable(),
  "validTo": zod.iso.datetime({"offset":true}).nullable(),
  "status": zod.enum(['active', 'archived']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "items": zod.array(zod.object({
  "priceListItemId": zod.uuid().nullable(),
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "itemId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "requirements": zod.array(zod.string()),
  "effortHours": zod.string().nullable(),
  "oneOffPrice": zod.string().nullable(),
  "recurringPrice": zod.string().nullable(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "unitLabel": zod.string().nullable(),
  "taxTreatment": zod.string(),
  "minQty": zod.string(),
  "isQuotable": zod.boolean(),
  "notes": zod.string().nullable()
})),
  "total": zod.int().min(getQuotablePriceBookResponseTotalMin),
  "limit": zod.int().min(1).max(getQuotablePriceBookResponseLimitMax),
  "offset": zod.int().min(getQuotablePriceBookResponseOffsetMin)
})


/**
 * @summary Get entity quote defaults and PDF branding
 */
export const getQuoteSettingsResponseDiscountApprovalThresholdPctMin = 0;
export const getQuoteSettingsResponseDiscountApprovalThresholdPctMax = 100;

export const getQuoteSettingsResponseDefaultValidityDaysMax = 365;

export const getQuoteSettingsResponseQuoteReferencePrefixRegExp = new RegExp('^[A-Z0-9_-]{1,12}$');
export const getQuoteSettingsResponseTermsMdMax = 20000;

export const getQuoteSettingsResponsePdfBrandAccentColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getQuoteSettingsResponsePdfBrandFooterTextMax = 500;



export const getQuoteSettingsResponse = zod.object({
  "defaultPriceListId": zod.uuid().nullable(),
  "discountApprovalThresholdPct": zod.number().min(getQuoteSettingsResponseDiscountApprovalThresholdPctMin).max(getQuoteSettingsResponseDiscountApprovalThresholdPctMax),
  "defaultValidityDays": zod.int().min(1).max(getQuoteSettingsResponseDefaultValidityDaysMax),
  "quoteReferencePrefix": zod.string().regex(getQuoteSettingsResponseQuoteReferencePrefixRegExp),
  "termsMd": zod.string().max(getQuoteSettingsResponseTermsMdMax).nullable(),
  "pdfBrandLogoFileId": zod.uuid().nullable(),
  "pdfBrandAccentColour": zod.string().regex(getQuoteSettingsResponsePdfBrandAccentColourRegExp),
  "pdfBrandFooterText": zod.string().max(getQuoteSettingsResponsePdfBrandFooterTextMax).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Save entity quote defaults and PDF branding
 */
export const updateQuoteSettingsBodyDiscountApprovalThresholdPctMin = 0;
export const updateQuoteSettingsBodyDiscountApprovalThresholdPctMax = 100;

export const updateQuoteSettingsBodyDefaultValidityDaysMax = 365;

export const updateQuoteSettingsBodyQuoteReferencePrefixRegExp = new RegExp('^[A-Za-z0-9_-]{1,12}$');
export const updateQuoteSettingsBodyTermsMdMax = 20000;

export const updateQuoteSettingsBodyPdfBrandAccentColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateQuoteSettingsBodyPdfBrandFooterTextMax = 500;



export const updateQuoteSettingsBody = zod.object({
  "defaultPriceListId": zod.uuid().nullish(),
  "discountApprovalThresholdPct": zod.number().min(updateQuoteSettingsBodyDiscountApprovalThresholdPctMin).max(updateQuoteSettingsBodyDiscountApprovalThresholdPctMax),
  "defaultValidityDays": zod.int().min(1).max(updateQuoteSettingsBodyDefaultValidityDaysMax),
  "quoteReferencePrefix": zod.string().regex(updateQuoteSettingsBodyQuoteReferencePrefixRegExp),
  "termsMd": zod.string().max(updateQuoteSettingsBodyTermsMdMax).nullish(),
  "pdfBrandLogoFileId": zod.uuid().nullish(),
  "pdfBrandAccentColour": zod.string().regex(updateQuoteSettingsBodyPdfBrandAccentColourRegExp),
  "pdfBrandFooterText": zod.string().max(updateQuoteSettingsBodyPdfBrandFooterTextMax).nullish()
})

export const updateQuoteSettingsResponseDiscountApprovalThresholdPctMin = 0;
export const updateQuoteSettingsResponseDiscountApprovalThresholdPctMax = 100;

export const updateQuoteSettingsResponseDefaultValidityDaysMax = 365;

export const updateQuoteSettingsResponseQuoteReferencePrefixRegExp = new RegExp('^[A-Z0-9_-]{1,12}$');
export const updateQuoteSettingsResponseTermsMdMax = 20000;

export const updateQuoteSettingsResponsePdfBrandAccentColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateQuoteSettingsResponsePdfBrandFooterTextMax = 500;



export const updateQuoteSettingsResponse = zod.object({
  "defaultPriceListId": zod.uuid().nullable(),
  "discountApprovalThresholdPct": zod.number().min(updateQuoteSettingsResponseDiscountApprovalThresholdPctMin).max(updateQuoteSettingsResponseDiscountApprovalThresholdPctMax),
  "defaultValidityDays": zod.int().min(1).max(updateQuoteSettingsResponseDefaultValidityDaysMax),
  "quoteReferencePrefix": zod.string().regex(updateQuoteSettingsResponseQuoteReferencePrefixRegExp),
  "termsMd": zod.string().max(updateQuoteSettingsResponseTermsMdMax).nullable(),
  "pdfBrandLogoFileId": zod.uuid().nullable(),
  "pdfBrandAccentColour": zod.string().regex(updateQuoteSettingsResponsePdfBrandAccentColourRegExp),
  "pdfBrandFooterText": zod.string().max(updateQuoteSettingsResponsePdfBrandFooterTextMax).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Create a catalogue category
 */
export const createCatalogueCategoryBodyNameMax = 200;

export const createCatalogueCategoryBodySlugMax = 200;



export const createCatalogueCategoryBody = zod.object({
  "name": zod.string().min(1).max(createCatalogueCategoryBodyNameMax),
  "slug": zod.string().min(1).max(createCatalogueCategoryBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const createCatalogueCategoryResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a catalogue category
 */
export const updateCatalogueCategoryParams = zod.object({
  "id": zod.uuid()
})

export const updateCatalogueCategoryBodyNameMax = 200;

export const updateCatalogueCategoryBodySlugMax = 200;



export const updateCatalogueCategoryBody = zod.object({
  "name": zod.string().min(1).max(updateCatalogueCategoryBodyNameMax).optional(),
  "slug": zod.string().min(1).max(updateCatalogueCategoryBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const updateCatalogueCategoryResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a catalogue category
 */
export const deleteCatalogueCategoryParams = zod.object({
  "id": zod.uuid()
})

export const deleteCatalogueCategoryResponse = zod.void()


/**
 * @summary Create a solution
 */
export const createCatalogueSolutionBodyNameMax = 200;

export const createCatalogueSolutionBodySlugMax = 200;



export const createCatalogueSolutionBody = zod.object({
  "categoryId": zod.uuid(),
  "name": zod.string().min(1).max(createCatalogueSolutionBodyNameMax),
  "slug": zod.string().min(1).max(createCatalogueSolutionBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']).optional(),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const createCatalogueSolutionResponse = zod.object({
  "id": zod.uuid(),
  "categoryId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a solution
 */
export const updateCatalogueSolutionParams = zod.object({
  "id": zod.uuid()
})

export const updateCatalogueSolutionBodyNameMax = 200;

export const updateCatalogueSolutionBodySlugMax = 200;



export const updateCatalogueSolutionBody = zod.object({
  "categoryId": zod.uuid().optional(),
  "name": zod.string().min(1).max(updateCatalogueSolutionBodyNameMax).optional(),
  "slug": zod.string().min(1).max(updateCatalogueSolutionBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']).optional(),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const updateCatalogueSolutionResponse = zod.object({
  "id": zod.uuid(),
  "categoryId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a solution
 */
export const deleteCatalogueSolutionParams = zod.object({
  "id": zod.uuid()
})

export const deleteCatalogueSolutionResponse = zod.void()


/**
 * @summary Create a product
 */
export const createCatalogueProductBodyNameMax = 200;

export const createCatalogueProductBodySlugMax = 200;



export const createCatalogueProductBody = zod.object({
  "solutionId": zod.uuid(),
  "name": zod.string().min(1).max(createCatalogueProductBodyNameMax),
  "slug": zod.string().min(1).max(createCatalogueProductBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']).optional(),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']).optional(),
  "basePrice": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const createCatalogueProductResponse = zod.object({
  "id": zod.uuid(),
  "solutionId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "basePrice": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a product
 */
export const updateCatalogueProductParams = zod.object({
  "id": zod.uuid()
})

export const updateCatalogueProductBodyNameMax = 200;

export const updateCatalogueProductBodySlugMax = 200;



export const updateCatalogueProductBody = zod.object({
  "solutionId": zod.uuid().optional(),
  "name": zod.string().min(1).max(updateCatalogueProductBodyNameMax).optional(),
  "slug": zod.string().min(1).max(updateCatalogueProductBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']).optional(),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']).optional(),
  "basePrice": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const updateCatalogueProductResponse = zod.object({
  "id": zod.uuid(),
  "solutionId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "basePrice": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a product
 */
export const deleteCatalogueProductParams = zod.object({
  "id": zod.uuid()
})

export const deleteCatalogueProductResponse = zod.void()


/**
 * @summary Create a product module
 */
export const createProductModuleBodyNameMax = 200;

export const createProductModuleBodySlugMax = 200;



export const createProductModuleBody = zod.object({
  "productId": zod.uuid(),
  "name": zod.string().min(1).max(createProductModuleBodyNameMax),
  "slug": zod.string().min(1).max(createProductModuleBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']).optional(),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']).optional(),
  "modulePrice": zod.string().nullish(),
  "isCore": zod.boolean().optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const createProductModuleResponse = zod.object({
  "id": zod.uuid(),
  "productId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "modulePrice": zod.string().nullish(),
  "isCore": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a product module
 */
export const updateProductModuleParams = zod.object({
  "id": zod.uuid()
})

export const updateProductModuleBodyNameMax = 200;

export const updateProductModuleBodySlugMax = 200;



export const updateProductModuleBody = zod.object({
  "productId": zod.uuid().optional(),
  "name": zod.string().min(1).max(updateProductModuleBodyNameMax).optional(),
  "slug": zod.string().min(1).max(updateProductModuleBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']).optional(),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']).optional(),
  "modulePrice": zod.string().nullish(),
  "isCore": zod.boolean().optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const updateProductModuleResponse = zod.object({
  "id": zod.uuid(),
  "productId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "contentStatus": zod.enum(['draft', 'in_review', 'approved', 'published', 'needs_update', 'archived']),
  "buildStatus": zod.enum(['idea', 'planning', 'in_development', 'testing', 'released', 'deprecated', 'retired']),
  "modulePrice": zod.string().nullish(),
  "isCore": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a product module
 */
export const deleteProductModuleParams = zod.object({
  "id": zod.uuid()
})

export const deleteProductModuleResponse = zod.void()


/**
 * @summary Create a module capability
 */
export const createModuleCapabilityBodyNameMax = 300;



export const createModuleCapabilityBody = zod.object({
  "moduleId": zod.uuid(),
  "name": zod.string().min(1).max(createModuleCapabilityBodyNameMax),
  "description": zod.string().nullish(),
  "isUnverified": zod.boolean().optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const createModuleCapabilityResponse = zod.object({
  "id": zod.uuid(),
  "moduleId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "isUnverified": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a module capability
 */
export const updateModuleCapabilityParams = zod.object({
  "id": zod.uuid()
})

export const updateModuleCapabilityBodyNameMax = 300;



export const updateModuleCapabilityBody = zod.object({
  "moduleId": zod.uuid().optional(),
  "name": zod.string().min(1).max(updateModuleCapabilityBodyNameMax).optional(),
  "description": zod.string().nullish(),
  "isUnverified": zod.boolean().optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
})

export const updateModuleCapabilityResponse = zod.object({
  "id": zod.uuid(),
  "moduleId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "isUnverified": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a module capability
 */
export const deleteModuleCapabilityParams = zod.object({
  "id": zod.uuid()
})

export const deleteModuleCapabilityResponse = zod.void()


/**
 * @summary Add a requirement to a product
 */
export const createProductRequirementParams = zod.object({
  "id": zod.uuid()
})

export const createProductRequirementBodyCodeMax = 50;

export const createProductRequirementBodyRoleMax = 200;




export const createProductRequirementBody = zod.object({
  "code": zod.string().min(1).max(createProductRequirementBodyCodeMax),
  "role": zod.string().min(1).max(createProductRequirementBodyRoleMax),
  "requirement": zod.string().min(1),
  "category": zod.string().nullish(),
  "capabilityId": zod.uuid().nullish(),
  "isActive": zod.boolean().optional()
})

export const createProductRequirementResponse = zod.object({
  "id": zod.uuid(),
  "productId": zod.uuid(),
  "capabilityId": zod.uuid().nullish(),
  "code": zod.string(),
  "role": zod.string(),
  "requirement": zod.string(),
  "category": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a requirement
 */
export const updateProductRequirementParams = zod.object({
  "id": zod.uuid()
})

export const updateProductRequirementBodyCodeMax = 50;

export const updateProductRequirementBodyRoleMax = 200;




export const updateProductRequirementBody = zod.object({
  "code": zod.string().min(1).max(updateProductRequirementBodyCodeMax).optional(),
  "role": zod.string().min(1).max(updateProductRequirementBodyRoleMax).optional(),
  "requirement": zod.string().min(1).optional(),
  "category": zod.string().nullish(),
  "capabilityId": zod.uuid().nullish(),
  "isActive": zod.boolean().optional()
})

export const updateProductRequirementResponse = zod.object({
  "id": zod.uuid(),
  "productId": zod.uuid(),
  "capabilityId": zod.uuid().nullish(),
  "code": zod.string(),
  "role": zod.string(),
  "requirement": zod.string(),
  "category": zod.string().nullish(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a requirement
 */
export const deleteProductRequirementParams = zod.object({
  "id": zod.uuid()
})

export const deleteProductRequirementResponse = zod.void()


/**
 * Explicit staff action. Uses only public name and website input, never CRM, documents or chat history. Website evidence is extractive and cited; general AI suggestions are unverified and unsourced.
 * @summary Review an entered public website and general AI knowledge without saving an account
 */
export const reviewAccountOrganisationBodyNameMin = 3;
export const reviewAccountOrganisationBodyNameMax = 200;

export const reviewAccountOrganisationBodyWebsiteMax = 300;



export const reviewAccountOrganisationBody = zod.object({
  "requestId": zod.uuid(),
  "name": zod.string().min(reviewAccountOrganisationBodyNameMin).max(reviewAccountOrganisationBodyNameMax),
  "website": zod.string().min(1).max(reviewAccountOrganisationBodyWebsiteMax).describe('Public HTTPS origin without credentials or query parameters')
})

export const reviewAccountOrganisationResponseNameMin = 3;
export const reviewAccountOrganisationResponseNameMax = 200;

export const reviewAccountOrganisationResponseWebsiteMax = 300;

export const reviewAccountOrganisationResponseSourcesItemIdRegExp = new RegExp('^page-[1-5]$');
export const reviewAccountOrganisationResponseSourcesItemTitleMax = 200;

export const reviewAccountOrganisationResponseSourcesItemUrlMax = 2000;

export const reviewAccountOrganisationResponseSourcesItemExcerptMax = 6000;

export const reviewAccountOrganisationResponseSourcesMax = 5;

export const reviewAccountOrganisationResponseMessageMax = 1000;

export const reviewAccountOrganisationResponseSuggestionsItemValueMax = 2000;

export const reviewAccountOrganisationResponseSuggestionsItemSourceIdsItemRegExp = new RegExp('^page-[1-5]$');
export const reviewAccountOrganisationResponseSuggestionsItemSourceIdsMax = 5;

export const reviewAccountOrganisationResponseSuggestionsMax = 24;

export const reviewAccountOrganisationResponseSummaryItemTextMax = 2000;

export const reviewAccountOrganisationResponseSummaryItemSourceIdsItemRegExp = new RegExp('^page-[1-5]$');
export const reviewAccountOrganisationResponseSummaryItemSourceIdsMax = 5;

export const reviewAccountOrganisationResponseSummaryMax = 8;

export const reviewAccountOrganisationResponseMissingFieldsMax = 12;

export const reviewAccountOrganisationResponseLimitationsItemMax = 500;

export const reviewAccountOrganisationResponseLimitationsMax = 10;



export const reviewAccountOrganisationResponse = zod.object({
  "requestId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "actorAppUserId": zod.uuid(),
  "name": zod.string().min(reviewAccountOrganisationResponseNameMin).max(reviewAccountOrganisationResponseNameMax),
  "website": zod.url().max(reviewAccountOrganisationResponseWebsiteMax),
  "reviewedAt": zod.iso.datetime({"offset":true}),
  "sources": zod.array(zod.object({
  "id": zod.string().regex(reviewAccountOrganisationResponseSourcesItemIdRegExp),
  "title": zod.string().max(reviewAccountOrganisationResponseSourcesItemTitleMax),
  "url": zod.url().max(reviewAccountOrganisationResponseSourcesItemUrlMax),
  "excerpt": zod.string().min(1).max(reviewAccountOrganisationResponseSourcesItemExcerptMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).min(1).max(reviewAccountOrganisationResponseSourcesMax),
  "message": zod.string().max(reviewAccountOrganisationResponseMessageMax),
  "suggestions": zod.array(zod.object({
  "field": zod.enum(['industry', 'organisationType', 'size', 'description', 'phone', 'email', 'addressLine1', 'addressLine2', 'city', 'stateProvince', 'postcode', 'country']),
  "value": zod.string().min(1).max(reviewAccountOrganisationResponseSuggestionsItemValueMax),
  "origin": zod.enum(['website', 'general_ai']),
  "sourceIds": zod.array(zod.string().regex(reviewAccountOrganisationResponseSuggestionsItemSourceIdsItemRegExp)).max(reviewAccountOrganisationResponseSuggestionsItemSourceIdsMax)
})).max(reviewAccountOrganisationResponseSuggestionsMax),
  "summary": zod.array(zod.object({
  "text": zod.string().min(1).max(reviewAccountOrganisationResponseSummaryItemTextMax),
  "origin": zod.enum(['website', 'general_ai']).describe('Website text is a literal retrieved excerpt; general_ai is unverified model knowledge'),
  "sourceIds": zod.array(zod.string().regex(reviewAccountOrganisationResponseSummaryItemSourceIdsItemRegExp)).max(reviewAccountOrganisationResponseSummaryItemSourceIdsMax)
})).max(reviewAccountOrganisationResponseSummaryMax),
  "missingFields": zod.array(zod.enum(['industry', 'organisationType', 'size', 'description', 'phone', 'email', 'addressLine1', 'addressLine2', 'city', 'stateProvince', 'postcode', 'country'])).max(reviewAccountOrganisationResponseMissingFieldsMax),
  "limitations": zod.array(zod.string().min(1).max(reviewAccountOrganisationResponseLimitationsItemMax)).max(reviewAccountOrganisationResponseLimitationsMax)
})


/**
 * @summary Read approved public business lookup availability and usage
 */
export const getAccountBusinessLookupStatusResponseLimitsMaxResultsPerQueryMax = 5;

export const getAccountBusinessLookupStatusResponseLimitsMaxSearchesPerTurnMax = 3;

export const getAccountBusinessLookupStatusResponseLimitsMonthlyCreditCapMax = 1000;

export const getAccountBusinessLookupStatusResponseLimitsCreditsUsedThisMonthMin = 0;



export const getAccountBusinessLookupStatusResponse = zod.object({
  "provider": zod.enum(['azure_web_search']),
  "state": zod.enum(['disabled', 'approval_required', 'misconfigured', 'quota_exhausted', 'timeout', 'failed', 'ready']),
  "approved": zod.boolean(),
  "configured": zod.boolean(),
  "enabled": zod.boolean(),
  "liveSmokeTested": zod.boolean(),
  "message": zod.string(),
  "limits": zod.object({
  "searchDepth": zod.enum(['basic']),
  "maxResultsPerQuery": zod.int().min(1).max(getAccountBusinessLookupStatusResponseLimitsMaxResultsPerQueryMax),
  "maxSearchesPerTurn": zod.int().min(1).max(getAccountBusinessLookupStatusResponseLimitsMaxSearchesPerTurnMax),
  "monthlyCreditCap": zod.int().min(1).max(getAccountBusinessLookupStatusResponseLimitsMonthlyCreditCapMax),
  "creditsUsedThisMonth": zod.int().min(getAccountBusinessLookupStatusResponseLimitsCreditsUsedThisMonthMin)
}),
  "pricingCheckedAt": zod.iso.date(),
  "pricingUrl": zod.url(),
  "searchApiUrl": zod.url()
})


/**
 * @summary Explicit public search for an unsaved business; never saves records
 */
export const lookupAccountBusinessBodyNameMin = 3;
export const lookupAccountBusinessBodyNameMax = 200;

export const lookupAccountBusinessBodyWebsiteMax = 300;

export const lookupAccountBusinessBodyLocationMax = 80;



export const lookupAccountBusinessBody = zod.object({
  "requestId": zod.uuid(),
  "name": zod.string().min(lookupAccountBusinessBodyNameMin).max(lookupAccountBusinessBodyNameMax),
  "website": zod.string().min(1).max(lookupAccountBusinessBodyWebsiteMax).optional().describe('Public HTTPS origin only; no path, query or credentials'),
  "location": zod.string().min(1).max(lookupAccountBusinessBodyLocationMax).optional()
})

export const lookupAccountBusinessResponseQueryMax = 300;

export const lookupAccountBusinessResponseMessageMax = 1000;

export const lookupAccountBusinessResponseCreditsUsedMin = 0;
export const lookupAccountBusinessResponseCreditsUsedMax = 1;

export const lookupAccountBusinessResponseCandidatesItemTitleMax = 500;

export const lookupAccountBusinessResponseCandidatesItemSourceUrlMax = 4000;

export const lookupAccountBusinessResponseCandidatesItemExcerptMax = 2000;

export const lookupAccountBusinessResponseCandidatesItemSuggestionsNotesMax = 2000;

export const lookupAccountBusinessResponseCandidatesItemSuggestionsWebsiteMax = 2000;

export const lookupAccountBusinessResponseCandidatesMax = 5;



export const lookupAccountBusinessResponse = zod.object({
  "requestId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "actorAppUserId": zod.uuid(),
  "query": zod.string().max(lookupAccountBusinessResponseQueryMax),
  "state": zod.enum(['suggestions', 'ambiguous', 'no_match']),
  "message": zod.string().max(lookupAccountBusinessResponseMessageMax),
  "creditsUsed": zod.int().min(lookupAccountBusinessResponseCreditsUsedMin).max(lookupAccountBusinessResponseCreditsUsedMax),
  "candidates": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(lookupAccountBusinessResponseCandidatesItemTitleMax),
  "sourceUrl": zod.url().max(lookupAccountBusinessResponseCandidatesItemSourceUrlMax),
  "excerpt": zod.string().max(lookupAccountBusinessResponseCandidatesItemExcerptMax),
  "retrievedAt": zod.iso.datetime({"offset":true}),
  "suggestions": zod.object({
  "notes": zod.string().max(lookupAccountBusinessResponseCandidatesItemSuggestionsNotesMax).describe('Literal untrusted public excerpt; review before applying'),
  "website": zod.url().max(lookupAccountBusinessResponseCandidatesItemSuggestionsWebsiteMax).optional().describe('Unverified homepage candidate, never a verified business identity')
})
})).max(lookupAccountBusinessResponseCandidatesMax)
})


/**
 * @summary List current entity saved targeting filters
 */
export const listCrmSegmentsQueryLimitDefault = 50;
export const listCrmSegmentsQueryLimitMax = 100;

export const listCrmSegmentsQueryOffsetDefault = 0;
export const listCrmSegmentsQueryOffsetMin = 0;

export const listCrmSegmentsQuerySearchMax = 200;



export const listCrmSegmentsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listCrmSegmentsQueryLimitMax).default(listCrmSegmentsQueryLimitDefault),
  "offset": zod.int().min(listCrmSegmentsQueryOffsetMin).default(listCrmSegmentsQueryOffsetDefault),
  "search": zod.string().max(listCrmSegmentsQuerySearchMax).optional()
})

export const listCrmSegmentsResponseItemsItemFiltersSearchMax = 200;

export const listCrmSegmentsResponseItemsItemFiltersTargetSegmentsItemMax = 100;

export const listCrmSegmentsResponseItemsItemFiltersTargetSegmentsMax = 30;

export const listCrmSegmentsResponseItemsItemFiltersSegmentMatchDefault = `all`;
export const listCrmSegmentsResponseItemsItemFiltersOwnerIdMax = 200;

export const listCrmSegmentsResponseItemsItemFiltersIndustryMax = 200;

export const listCrmSegmentsResponseItemsItemFiltersStatusMax = 200;

export const listCrmSegmentsResponseItemsItemFiltersIncludeTestDataDefault = false;

export const listCrmSegmentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(listCrmSegmentsResponseItemsItemFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(listCrmSegmentsResponseItemsItemFiltersTargetSegmentsItemMax)).max(listCrmSegmentsResponseItemsItemFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(listCrmSegmentsResponseItemsItemFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(listCrmSegmentsResponseItemsItemFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(listCrmSegmentsResponseItemsItemFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(listCrmSegmentsResponseItemsItemFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(listCrmSegmentsResponseItemsItemFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary Read one current segment definition
 */
export const getCrmSegmentParams = zod.object({
  "id": zod.uuid()
})

export const getCrmSegmentResponseFiltersSearchMax = 200;

export const getCrmSegmentResponseFiltersTargetSegmentsItemMax = 100;

export const getCrmSegmentResponseFiltersTargetSegmentsMax = 30;

export const getCrmSegmentResponseFiltersSegmentMatchDefault = `all`;
export const getCrmSegmentResponseFiltersOwnerIdMax = 200;

export const getCrmSegmentResponseFiltersIndustryMax = 200;

export const getCrmSegmentResponseFiltersStatusMax = 200;

export const getCrmSegmentResponseFiltersIncludeTestDataDefault = false;

export const getCrmSegmentResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(getCrmSegmentResponseFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(getCrmSegmentResponseFiltersTargetSegmentsItemMax)).max(getCrmSegmentResponseFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(getCrmSegmentResponseFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(getCrmSegmentResponseFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(getCrmSegmentResponseFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(getCrmSegmentResponseFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(getCrmSegmentResponseFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
})


/**
 * @summary Read attributed definition history
 */
export const listCrmSegmentHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listCrmSegmentHistoryQueryLimitDefault = 50;
export const listCrmSegmentHistoryQueryLimitMax = 100;

export const listCrmSegmentHistoryQueryOffsetDefault = 0;
export const listCrmSegmentHistoryQueryOffsetMin = 0;



export const listCrmSegmentHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listCrmSegmentHistoryQueryLimitMax).default(listCrmSegmentHistoryQueryLimitDefault),
  "offset": zod.int().min(listCrmSegmentHistoryQueryOffsetMin).default(listCrmSegmentHistoryQueryOffsetDefault)
})

export const listCrmSegmentHistoryResponseItemsItemSnapshotFiltersSearchMax = 200;

export const listCrmSegmentHistoryResponseItemsItemSnapshotFiltersTargetSegmentsItemMax = 100;

export const listCrmSegmentHistoryResponseItemsItemSnapshotFiltersTargetSegmentsMax = 30;

export const listCrmSegmentHistoryResponseItemsItemSnapshotFiltersSegmentMatchDefault = `all`;
export const listCrmSegmentHistoryResponseItemsItemSnapshotFiltersOwnerIdMax = 200;

export const listCrmSegmentHistoryResponseItemsItemSnapshotFiltersIndustryMax = 200;

export const listCrmSegmentHistoryResponseItemsItemSnapshotFiltersStatusMax = 200;

export const listCrmSegmentHistoryResponseItemsItemSnapshotFiltersIncludeTestDataDefault = false;

export const listCrmSegmentHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "operation": zod.string(),
  "reason": zod.string(),
  "snapshot": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(listCrmSegmentHistoryResponseItemsItemSnapshotFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(listCrmSegmentHistoryResponseItemsItemSnapshotFiltersTargetSegmentsItemMax)).max(listCrmSegmentHistoryResponseItemsItemSnapshotFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(listCrmSegmentHistoryResponseItemsItemSnapshotFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(listCrmSegmentHistoryResponseItemsItemSnapshotFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(listCrmSegmentHistoryResponseItemsItemSnapshotFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(listCrmSegmentHistoryResponseItemsItemSnapshotFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(listCrmSegmentHistoryResponseItemsItemSnapshotFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "actorId": zod.uuid()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary Review exact saved-filter changes without changing accounts
 */

export const reviewCrmSegmentBodyChangeNameMax = 120;

export const reviewCrmSegmentBodyChangeFiltersSearchMax = 200;

export const reviewCrmSegmentBodyChangeFiltersTargetSegmentsItemMax = 100;

export const reviewCrmSegmentBodyChangeFiltersTargetSegmentsMax = 30;

export const reviewCrmSegmentBodyChangeFiltersSegmentMatchDefault = `all`;
export const reviewCrmSegmentBodyChangeFiltersOwnerIdMax = 200;

export const reviewCrmSegmentBodyChangeFiltersIndustryMax = 200;

export const reviewCrmSegmentBodyChangeFiltersStatusMax = 200;

export const reviewCrmSegmentBodyChangeFiltersIncludeTestDataDefault = false;
export const reviewCrmSegmentBodyChangeReasonMin = 3;
export const reviewCrmSegmentBodyChangeReasonMax = 500;



export const reviewCrmSegmentBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'delete']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "name": zod.string().min(1).max(reviewCrmSegmentBodyChangeNameMax).optional(),
  "filters": zod.object({
  "search": zod.string().max(reviewCrmSegmentBodyChangeFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(reviewCrmSegmentBodyChangeFiltersTargetSegmentsItemMax)).max(reviewCrmSegmentBodyChangeFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(reviewCrmSegmentBodyChangeFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(reviewCrmSegmentBodyChangeFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(reviewCrmSegmentBodyChangeFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(reviewCrmSegmentBodyChangeFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(reviewCrmSegmentBodyChangeFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).optional().describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "reason": zod.string().min(reviewCrmSegmentBodyChangeReasonMin).max(reviewCrmSegmentBodyChangeReasonMax)
})
})


export const reviewCrmSegmentResponseChangeNameMax = 120;

export const reviewCrmSegmentResponseChangeFiltersSearchMax = 200;

export const reviewCrmSegmentResponseChangeFiltersTargetSegmentsItemMax = 100;

export const reviewCrmSegmentResponseChangeFiltersTargetSegmentsMax = 30;

export const reviewCrmSegmentResponseChangeFiltersSegmentMatchDefault = `all`;
export const reviewCrmSegmentResponseChangeFiltersOwnerIdMax = 200;

export const reviewCrmSegmentResponseChangeFiltersIndustryMax = 200;

export const reviewCrmSegmentResponseChangeFiltersStatusMax = 200;

export const reviewCrmSegmentResponseChangeFiltersIncludeTestDataDefault = false;
export const reviewCrmSegmentResponseChangeReasonMin = 3;
export const reviewCrmSegmentResponseChangeReasonMax = 500;

export const reviewCrmSegmentResponseBeforeOneFiltersSearchMax = 200;

export const reviewCrmSegmentResponseBeforeOneFiltersTargetSegmentsItemMax = 100;

export const reviewCrmSegmentResponseBeforeOneFiltersTargetSegmentsMax = 30;

export const reviewCrmSegmentResponseBeforeOneFiltersSegmentMatchDefault = `all`;
export const reviewCrmSegmentResponseBeforeOneFiltersOwnerIdMax = 200;

export const reviewCrmSegmentResponseBeforeOneFiltersIndustryMax = 200;

export const reviewCrmSegmentResponseBeforeOneFiltersStatusMax = 200;

export const reviewCrmSegmentResponseBeforeOneFiltersIncludeTestDataDefault = false;
export const reviewCrmSegmentResponseAfterOneFiltersSearchMax = 200;

export const reviewCrmSegmentResponseAfterOneFiltersTargetSegmentsItemMax = 100;

export const reviewCrmSegmentResponseAfterOneFiltersTargetSegmentsMax = 30;

export const reviewCrmSegmentResponseAfterOneFiltersSegmentMatchDefault = `all`;
export const reviewCrmSegmentResponseAfterOneFiltersOwnerIdMax = 200;

export const reviewCrmSegmentResponseAfterOneFiltersIndustryMax = 200;

export const reviewCrmSegmentResponseAfterOneFiltersStatusMax = 200;

export const reviewCrmSegmentResponseAfterOneFiltersIncludeTestDataDefault = false;
export const reviewCrmSegmentResponseReceiptOneFiltersSearchMax = 200;

export const reviewCrmSegmentResponseReceiptOneFiltersTargetSegmentsItemMax = 100;

export const reviewCrmSegmentResponseReceiptOneFiltersTargetSegmentsMax = 30;

export const reviewCrmSegmentResponseReceiptOneFiltersSegmentMatchDefault = `all`;
export const reviewCrmSegmentResponseReceiptOneFiltersOwnerIdMax = 200;

export const reviewCrmSegmentResponseReceiptOneFiltersIndustryMax = 200;

export const reviewCrmSegmentResponseReceiptOneFiltersStatusMax = 200;

export const reviewCrmSegmentResponseReceiptOneFiltersIncludeTestDataDefault = false;

export const reviewCrmSegmentResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'delete']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "name": zod.string().min(1).max(reviewCrmSegmentResponseChangeNameMax).optional(),
  "filters": zod.object({
  "search": zod.string().max(reviewCrmSegmentResponseChangeFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(reviewCrmSegmentResponseChangeFiltersTargetSegmentsItemMax)).max(reviewCrmSegmentResponseChangeFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(reviewCrmSegmentResponseChangeFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(reviewCrmSegmentResponseChangeFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(reviewCrmSegmentResponseChangeFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(reviewCrmSegmentResponseChangeFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(reviewCrmSegmentResponseChangeFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).optional().describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "reason": zod.string().min(reviewCrmSegmentResponseChangeReasonMin).max(reviewCrmSegmentResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(reviewCrmSegmentResponseBeforeOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(reviewCrmSegmentResponseBeforeOneFiltersTargetSegmentsItemMax)).max(reviewCrmSegmentResponseBeforeOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(reviewCrmSegmentResponseBeforeOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(reviewCrmSegmentResponseBeforeOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(reviewCrmSegmentResponseBeforeOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(reviewCrmSegmentResponseBeforeOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(reviewCrmSegmentResponseBeforeOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()]),
  "after": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(reviewCrmSegmentResponseAfterOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(reviewCrmSegmentResponseAfterOneFiltersTargetSegmentsItemMax)).max(reviewCrmSegmentResponseAfterOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(reviewCrmSegmentResponseAfterOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(reviewCrmSegmentResponseAfterOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(reviewCrmSegmentResponseAfterOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(reviewCrmSegmentResponseAfterOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(reviewCrmSegmentResponseAfterOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()]),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(reviewCrmSegmentResponseReceiptOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(reviewCrmSegmentResponseReceiptOneFiltersTargetSegmentsItemMax)).max(reviewCrmSegmentResponseReceiptOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(reviewCrmSegmentResponseReceiptOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(reviewCrmSegmentResponseReceiptOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(reviewCrmSegmentResponseReceiptOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(reviewCrmSegmentResponseReceiptOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(reviewCrmSegmentResponseReceiptOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()])
})


/**
 * @summary Recover the original private review or committed receipt
 */
export const getCrmSegmentReviewParams = zod.object({
  "id": zod.uuid()
})


export const getCrmSegmentReviewResponseChangeNameMax = 120;

export const getCrmSegmentReviewResponseChangeFiltersSearchMax = 200;

export const getCrmSegmentReviewResponseChangeFiltersTargetSegmentsItemMax = 100;

export const getCrmSegmentReviewResponseChangeFiltersTargetSegmentsMax = 30;

export const getCrmSegmentReviewResponseChangeFiltersSegmentMatchDefault = `all`;
export const getCrmSegmentReviewResponseChangeFiltersOwnerIdMax = 200;

export const getCrmSegmentReviewResponseChangeFiltersIndustryMax = 200;

export const getCrmSegmentReviewResponseChangeFiltersStatusMax = 200;

export const getCrmSegmentReviewResponseChangeFiltersIncludeTestDataDefault = false;
export const getCrmSegmentReviewResponseChangeReasonMin = 3;
export const getCrmSegmentReviewResponseChangeReasonMax = 500;

export const getCrmSegmentReviewResponseBeforeOneFiltersSearchMax = 200;

export const getCrmSegmentReviewResponseBeforeOneFiltersTargetSegmentsItemMax = 100;

export const getCrmSegmentReviewResponseBeforeOneFiltersTargetSegmentsMax = 30;

export const getCrmSegmentReviewResponseBeforeOneFiltersSegmentMatchDefault = `all`;
export const getCrmSegmentReviewResponseBeforeOneFiltersOwnerIdMax = 200;

export const getCrmSegmentReviewResponseBeforeOneFiltersIndustryMax = 200;

export const getCrmSegmentReviewResponseBeforeOneFiltersStatusMax = 200;

export const getCrmSegmentReviewResponseBeforeOneFiltersIncludeTestDataDefault = false;
export const getCrmSegmentReviewResponseAfterOneFiltersSearchMax = 200;

export const getCrmSegmentReviewResponseAfterOneFiltersTargetSegmentsItemMax = 100;

export const getCrmSegmentReviewResponseAfterOneFiltersTargetSegmentsMax = 30;

export const getCrmSegmentReviewResponseAfterOneFiltersSegmentMatchDefault = `all`;
export const getCrmSegmentReviewResponseAfterOneFiltersOwnerIdMax = 200;

export const getCrmSegmentReviewResponseAfterOneFiltersIndustryMax = 200;

export const getCrmSegmentReviewResponseAfterOneFiltersStatusMax = 200;

export const getCrmSegmentReviewResponseAfterOneFiltersIncludeTestDataDefault = false;
export const getCrmSegmentReviewResponseReceiptOneFiltersSearchMax = 200;

export const getCrmSegmentReviewResponseReceiptOneFiltersTargetSegmentsItemMax = 100;

export const getCrmSegmentReviewResponseReceiptOneFiltersTargetSegmentsMax = 30;

export const getCrmSegmentReviewResponseReceiptOneFiltersSegmentMatchDefault = `all`;
export const getCrmSegmentReviewResponseReceiptOneFiltersOwnerIdMax = 200;

export const getCrmSegmentReviewResponseReceiptOneFiltersIndustryMax = 200;

export const getCrmSegmentReviewResponseReceiptOneFiltersStatusMax = 200;

export const getCrmSegmentReviewResponseReceiptOneFiltersIncludeTestDataDefault = false;

export const getCrmSegmentReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'delete']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "name": zod.string().min(1).max(getCrmSegmentReviewResponseChangeNameMax).optional(),
  "filters": zod.object({
  "search": zod.string().max(getCrmSegmentReviewResponseChangeFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(getCrmSegmentReviewResponseChangeFiltersTargetSegmentsItemMax)).max(getCrmSegmentReviewResponseChangeFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(getCrmSegmentReviewResponseChangeFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(getCrmSegmentReviewResponseChangeFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(getCrmSegmentReviewResponseChangeFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(getCrmSegmentReviewResponseChangeFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(getCrmSegmentReviewResponseChangeFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).optional().describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "reason": zod.string().min(getCrmSegmentReviewResponseChangeReasonMin).max(getCrmSegmentReviewResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(getCrmSegmentReviewResponseBeforeOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(getCrmSegmentReviewResponseBeforeOneFiltersTargetSegmentsItemMax)).max(getCrmSegmentReviewResponseBeforeOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(getCrmSegmentReviewResponseBeforeOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(getCrmSegmentReviewResponseBeforeOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(getCrmSegmentReviewResponseBeforeOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(getCrmSegmentReviewResponseBeforeOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(getCrmSegmentReviewResponseBeforeOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()]),
  "after": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(getCrmSegmentReviewResponseAfterOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(getCrmSegmentReviewResponseAfterOneFiltersTargetSegmentsItemMax)).max(getCrmSegmentReviewResponseAfterOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(getCrmSegmentReviewResponseAfterOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(getCrmSegmentReviewResponseAfterOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(getCrmSegmentReviewResponseAfterOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(getCrmSegmentReviewResponseAfterOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(getCrmSegmentReviewResponseAfterOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()]),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(getCrmSegmentReviewResponseReceiptOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(getCrmSegmentReviewResponseReceiptOneFiltersTargetSegmentsItemMax)).max(getCrmSegmentReviewResponseReceiptOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(getCrmSegmentReviewResponseReceiptOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(getCrmSegmentReviewResponseReceiptOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(getCrmSegmentReviewResponseReceiptOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(getCrmSegmentReviewResponseReceiptOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(getCrmSegmentReviewResponseReceiptOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()])
})


/**
 * @summary Confirm the reviewed definition once
 */
export const confirmCrmSegmentParams = zod.object({
  "id": zod.uuid()
})

export const confirmCrmSegmentBodyHashMin = 64;
export const confirmCrmSegmentBodyHashMax = 64;



export const confirmCrmSegmentBody = zod.object({
  "hash": zod.string().min(confirmCrmSegmentBodyHashMin).max(confirmCrmSegmentBodyHashMax),
  "confirmed": zod.literal(true)
})


export const confirmCrmSegmentResponseChangeNameMax = 120;

export const confirmCrmSegmentResponseChangeFiltersSearchMax = 200;

export const confirmCrmSegmentResponseChangeFiltersTargetSegmentsItemMax = 100;

export const confirmCrmSegmentResponseChangeFiltersTargetSegmentsMax = 30;

export const confirmCrmSegmentResponseChangeFiltersSegmentMatchDefault = `all`;
export const confirmCrmSegmentResponseChangeFiltersOwnerIdMax = 200;

export const confirmCrmSegmentResponseChangeFiltersIndustryMax = 200;

export const confirmCrmSegmentResponseChangeFiltersStatusMax = 200;

export const confirmCrmSegmentResponseChangeFiltersIncludeTestDataDefault = false;
export const confirmCrmSegmentResponseChangeReasonMin = 3;
export const confirmCrmSegmentResponseChangeReasonMax = 500;

export const confirmCrmSegmentResponseBeforeOneFiltersSearchMax = 200;

export const confirmCrmSegmentResponseBeforeOneFiltersTargetSegmentsItemMax = 100;

export const confirmCrmSegmentResponseBeforeOneFiltersTargetSegmentsMax = 30;

export const confirmCrmSegmentResponseBeforeOneFiltersSegmentMatchDefault = `all`;
export const confirmCrmSegmentResponseBeforeOneFiltersOwnerIdMax = 200;

export const confirmCrmSegmentResponseBeforeOneFiltersIndustryMax = 200;

export const confirmCrmSegmentResponseBeforeOneFiltersStatusMax = 200;

export const confirmCrmSegmentResponseBeforeOneFiltersIncludeTestDataDefault = false;
export const confirmCrmSegmentResponseAfterOneFiltersSearchMax = 200;

export const confirmCrmSegmentResponseAfterOneFiltersTargetSegmentsItemMax = 100;

export const confirmCrmSegmentResponseAfterOneFiltersTargetSegmentsMax = 30;

export const confirmCrmSegmentResponseAfterOneFiltersSegmentMatchDefault = `all`;
export const confirmCrmSegmentResponseAfterOneFiltersOwnerIdMax = 200;

export const confirmCrmSegmentResponseAfterOneFiltersIndustryMax = 200;

export const confirmCrmSegmentResponseAfterOneFiltersStatusMax = 200;

export const confirmCrmSegmentResponseAfterOneFiltersIncludeTestDataDefault = false;
export const confirmCrmSegmentResponseReceiptOneFiltersSearchMax = 200;

export const confirmCrmSegmentResponseReceiptOneFiltersTargetSegmentsItemMax = 100;

export const confirmCrmSegmentResponseReceiptOneFiltersTargetSegmentsMax = 30;

export const confirmCrmSegmentResponseReceiptOneFiltersSegmentMatchDefault = `all`;
export const confirmCrmSegmentResponseReceiptOneFiltersOwnerIdMax = 200;

export const confirmCrmSegmentResponseReceiptOneFiltersIndustryMax = 200;

export const confirmCrmSegmentResponseReceiptOneFiltersStatusMax = 200;

export const confirmCrmSegmentResponseReceiptOneFiltersIncludeTestDataDefault = false;

export const confirmCrmSegmentResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'delete']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "name": zod.string().min(1).max(confirmCrmSegmentResponseChangeNameMax).optional(),
  "filters": zod.object({
  "search": zod.string().max(confirmCrmSegmentResponseChangeFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(confirmCrmSegmentResponseChangeFiltersTargetSegmentsItemMax)).max(confirmCrmSegmentResponseChangeFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(confirmCrmSegmentResponseChangeFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(confirmCrmSegmentResponseChangeFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(confirmCrmSegmentResponseChangeFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(confirmCrmSegmentResponseChangeFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(confirmCrmSegmentResponseChangeFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).optional().describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "reason": zod.string().min(confirmCrmSegmentResponseChangeReasonMin).max(confirmCrmSegmentResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(confirmCrmSegmentResponseBeforeOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(confirmCrmSegmentResponseBeforeOneFiltersTargetSegmentsItemMax)).max(confirmCrmSegmentResponseBeforeOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(confirmCrmSegmentResponseBeforeOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(confirmCrmSegmentResponseBeforeOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(confirmCrmSegmentResponseBeforeOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(confirmCrmSegmentResponseBeforeOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(confirmCrmSegmentResponseBeforeOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()]),
  "after": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(confirmCrmSegmentResponseAfterOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(confirmCrmSegmentResponseAfterOneFiltersTargetSegmentsItemMax)).max(confirmCrmSegmentResponseAfterOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(confirmCrmSegmentResponseAfterOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(confirmCrmSegmentResponseAfterOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(confirmCrmSegmentResponseAfterOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(confirmCrmSegmentResponseAfterOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(confirmCrmSegmentResponseAfterOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()]),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(confirmCrmSegmentResponseReceiptOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(confirmCrmSegmentResponseReceiptOneFiltersTargetSegmentsItemMax)).max(confirmCrmSegmentResponseReceiptOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(confirmCrmSegmentResponseReceiptOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(confirmCrmSegmentResponseReceiptOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(confirmCrmSegmentResponseReceiptOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(confirmCrmSegmentResponseReceiptOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(confirmCrmSegmentResponseReceiptOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()])
})


/**
 * @summary Cancel an uncommitted review
 */
export const cancelCrmSegmentReviewParams = zod.object({
  "id": zod.uuid()
})


export const cancelCrmSegmentReviewResponseChangeNameMax = 120;

export const cancelCrmSegmentReviewResponseChangeFiltersSearchMax = 200;

export const cancelCrmSegmentReviewResponseChangeFiltersTargetSegmentsItemMax = 100;

export const cancelCrmSegmentReviewResponseChangeFiltersTargetSegmentsMax = 30;

export const cancelCrmSegmentReviewResponseChangeFiltersSegmentMatchDefault = `all`;
export const cancelCrmSegmentReviewResponseChangeFiltersOwnerIdMax = 200;

export const cancelCrmSegmentReviewResponseChangeFiltersIndustryMax = 200;

export const cancelCrmSegmentReviewResponseChangeFiltersStatusMax = 200;

export const cancelCrmSegmentReviewResponseChangeFiltersIncludeTestDataDefault = false;
export const cancelCrmSegmentReviewResponseChangeReasonMin = 3;
export const cancelCrmSegmentReviewResponseChangeReasonMax = 500;

export const cancelCrmSegmentReviewResponseBeforeOneFiltersSearchMax = 200;

export const cancelCrmSegmentReviewResponseBeforeOneFiltersTargetSegmentsItemMax = 100;

export const cancelCrmSegmentReviewResponseBeforeOneFiltersTargetSegmentsMax = 30;

export const cancelCrmSegmentReviewResponseBeforeOneFiltersSegmentMatchDefault = `all`;
export const cancelCrmSegmentReviewResponseBeforeOneFiltersOwnerIdMax = 200;

export const cancelCrmSegmentReviewResponseBeforeOneFiltersIndustryMax = 200;

export const cancelCrmSegmentReviewResponseBeforeOneFiltersStatusMax = 200;

export const cancelCrmSegmentReviewResponseBeforeOneFiltersIncludeTestDataDefault = false;
export const cancelCrmSegmentReviewResponseAfterOneFiltersSearchMax = 200;

export const cancelCrmSegmentReviewResponseAfterOneFiltersTargetSegmentsItemMax = 100;

export const cancelCrmSegmentReviewResponseAfterOneFiltersTargetSegmentsMax = 30;

export const cancelCrmSegmentReviewResponseAfterOneFiltersSegmentMatchDefault = `all`;
export const cancelCrmSegmentReviewResponseAfterOneFiltersOwnerIdMax = 200;

export const cancelCrmSegmentReviewResponseAfterOneFiltersIndustryMax = 200;

export const cancelCrmSegmentReviewResponseAfterOneFiltersStatusMax = 200;

export const cancelCrmSegmentReviewResponseAfterOneFiltersIncludeTestDataDefault = false;
export const cancelCrmSegmentReviewResponseReceiptOneFiltersSearchMax = 200;

export const cancelCrmSegmentReviewResponseReceiptOneFiltersTargetSegmentsItemMax = 100;

export const cancelCrmSegmentReviewResponseReceiptOneFiltersTargetSegmentsMax = 30;

export const cancelCrmSegmentReviewResponseReceiptOneFiltersSegmentMatchDefault = `all`;
export const cancelCrmSegmentReviewResponseReceiptOneFiltersOwnerIdMax = 200;

export const cancelCrmSegmentReviewResponseReceiptOneFiltersIndustryMax = 200;

export const cancelCrmSegmentReviewResponseReceiptOneFiltersStatusMax = 200;

export const cancelCrmSegmentReviewResponseReceiptOneFiltersIncludeTestDataDefault = false;

export const cancelCrmSegmentReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'delete']),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "name": zod.string().min(1).max(cancelCrmSegmentReviewResponseChangeNameMax).optional(),
  "filters": zod.object({
  "search": zod.string().max(cancelCrmSegmentReviewResponseChangeFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(cancelCrmSegmentReviewResponseChangeFiltersTargetSegmentsItemMax)).max(cancelCrmSegmentReviewResponseChangeFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(cancelCrmSegmentReviewResponseChangeFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(cancelCrmSegmentReviewResponseChangeFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(cancelCrmSegmentReviewResponseChangeFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(cancelCrmSegmentReviewResponseChangeFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(cancelCrmSegmentReviewResponseChangeFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).optional().describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "reason": zod.string().min(cancelCrmSegmentReviewResponseChangeReasonMin).max(cancelCrmSegmentReviewResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(cancelCrmSegmentReviewResponseBeforeOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(cancelCrmSegmentReviewResponseBeforeOneFiltersTargetSegmentsItemMax)).max(cancelCrmSegmentReviewResponseBeforeOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(cancelCrmSegmentReviewResponseBeforeOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(cancelCrmSegmentReviewResponseBeforeOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(cancelCrmSegmentReviewResponseBeforeOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(cancelCrmSegmentReviewResponseBeforeOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(cancelCrmSegmentReviewResponseBeforeOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()]),
  "after": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(cancelCrmSegmentReviewResponseAfterOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(cancelCrmSegmentReviewResponseAfterOneFiltersTargetSegmentsItemMax)).max(cancelCrmSegmentReviewResponseAfterOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(cancelCrmSegmentReviewResponseAfterOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(cancelCrmSegmentReviewResponseAfterOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(cancelCrmSegmentReviewResponseAfterOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(cancelCrmSegmentReviewResponseAfterOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(cancelCrmSegmentReviewResponseAfterOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()]),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "filters": zod.object({
  "search": zod.string().max(cancelCrmSegmentReviewResponseReceiptOneFiltersSearchMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "targetSegments": zod.array(zod.string().min(1).max(cancelCrmSegmentReviewResponseReceiptOneFiltersTargetSegmentsItemMax)).max(cancelCrmSegmentReviewResponseReceiptOneFiltersTargetSegmentsMax).optional(),
  "segmentMatch": zod.enum(['all', 'any']).default(cancelCrmSegmentReviewResponseReceiptOneFiltersSegmentMatchDefault),
  "ownerId": zod.string().min(1).max(cancelCrmSegmentReviewResponseReceiptOneFiltersOwnerIdMax).optional(),
  "unassigned": zod.boolean().optional(),
  "industry": zod.string().min(1).max(cancelCrmSegmentReviewResponseReceiptOneFiltersIndustryMax).optional(),
  "status": zod.string().min(1).max(cancelCrmSegmentReviewResponseReceiptOneFiltersStatusMax).optional(),
  "includeTestData": zod.boolean().default(cancelCrmSegmentReviewResponseReceiptOneFiltersIncludeTestDataDefault),
  "createdFrom": zod.iso.date().optional(),
  "createdTo": zod.iso.date().optional(),
  "updatedFrom": zod.iso.date().optional(),
  "updatedTo": zod.iso.date().optional(),
  "lastContactedFrom": zod.iso.date().optional(),
  "lastContactedTo": zod.iso.date().optional(),
  "renewalFrom": zod.iso.date().optional(),
  "renewalTo": zod.iso.date().optional()
}).describe('AND conditions over authorized accounts. Omitted fields impose no condition. Dates are inclusive UTC calendar days. Tags use the selected all/any rule. Never grants consent.'),
  "version": zod.int(),
  "deleted": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.uuid()
}),zod.null()])
})


/**
 * @summary List accounts
 */
export const listAccountsQueryTargetingMax = 6000;

export const listAccountsQuerySearchMax = 200;

export const listAccountsQueryIncludeTestDataDefault = false;
export const listAccountsQueryLimitDefault = 50;
export const listAccountsQueryLimitMax = 100;

export const listAccountsQueryOffsetDefault = 0;
export const listAccountsQueryOffsetMin = 0;



export const listAccountsQueryParams = zod.object({
  "targeting": zod.string().max(listAccountsQueryTargetingMax).optional().describe('JSON encoded CrmSegmentFilters. Validated allowlist; intersects existing query conditions before paging.'),
  "segmentId": zod.uuid().optional().describe('Re-evaluate this current scoped saved definition before paging.'),
  "search": zod.string().max(listAccountsQuerySearchMax).optional().describe('Case-insensitive match on account name.'),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional().describe('Workspace audience lens. B2B includes both customers and prospects.'),
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "includeTestData": zod.boolean().default(listAccountsQueryIncludeTestDataDefault).describe('Include records flagged as test or demo data. They are excluded by default.'),
  "limit": zod.int().min(1).max(listAccountsQueryLimitMax).default(listAccountsQueryLimitDefault),
  "offset": zod.int().min(listAccountsQueryOffsetMin).default(listAccountsQueryOffsetDefault)
})

export const listAccountsResponseItemsItemOneRelationshipTypeDefault = `prospect`;
export const listAccountsResponseItemsItemOneShowPricesInQuotesDefault = true;
export const listAccountsResponseItemsItemOneIsTestDataDefault = false;
export const listAccountsResponseItemsItemOneAnnualRevenueMin = 0;

export const listAccountsResponseItemsItemOneNumberOfEmployeesMin = 0;

export const listAccountsResponseItemsItemOneTypicalChequeMinMin = 0;

export const listAccountsResponseItemsItemOneTypicalChequeMaxMin = 0;

export const listAccountsResponseItemsItemOneLeadScoreMin = 0;
export const listAccountsResponseItemsItemOneLeadScoreMax = 100;

export const listAccountsResponseItemsItemOneHealthScoreMin = 0;
export const listAccountsResponseItemsItemOneHealthScoreMax = 100;

export const listAccountsResponseTotalMin = 0;



export const listAccountsResponse = zod.object({
  "items": zod.array(zod.object({
  "accountKind": zod.enum(['organization', 'person']),
  "website": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "emailDomain": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).default(listAccountsResponseItemsItemOneRelationshipTypeDefault),
  "partnerType": zod.union([zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),zod.null()]).optional(),
  "partnerStatus": zod.union([zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),zod.null()]).optional(),
  "organisationType": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().default(listAccountsResponseItemsItemOneShowPricesInQuotesDefault),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "accountNumber": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(listAccountsResponseItemsItemOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "annualRevenue": zod.number().min(listAccountsResponseItemsItemOneAnnualRevenueMin).nullish(),
  "numberOfEmployees": zod.int().min(listAccountsResponseItemsItemOneNumberOfEmployeesMin).nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "emailConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "consentSource": zod.string().nullish(),
  "consentUpdatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "investorType": zod.string().nullish(),
  "investmentFocus": zod.string().nullish(),
  "typicalChequeMin": zod.number().min(listAccountsResponseItemsItemOneTypicalChequeMinMin).nullish(),
  "typicalChequeMax": zod.number().min(listAccountsResponseItemsItemOneTypicalChequeMaxMin).nullish(),
  "accreditationStatus": zod.string().nullish(),
  "lastInvestorUpdateAt": zod.iso.datetime({"offset":true}).nullish(),
  "leadScore": zod.int().min(listAccountsResponseItemsItemOneLeadScoreMin).max(listAccountsResponseItemsItemOneLeadScoreMax).nullish(),
  "healthScore": zod.int().min(listAccountsResponseItemsItemOneHealthScoreMin).max(listAccountsResponseItemsItemOneHealthScoreMax).nullish().describe('0-100 composite score computed by account intelligence; staff-editable.'),
  "temperature": zod.enum(['hot', 'warm', 'cool', 'cold', 'new']).optional(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).optional(),
  "targetSegments": zod.array(zod.enum(['au-federal-defence', 'au-federal-national-security', 'au-federal-services-citizen', 'au-federal-policy-economic', 'au-federal-research-science', 'au-federal-regulator', 'au-federal-other', 'au-state-central', 'au-state-police-justice', 'au-state-health', 'au-state-transport', 'au-state-education', 'au-state-other', 'au-local-government-large', 'au-defence-prime', 'au-defence-supplier', 'au-critical-infra-energy', 'au-critical-infra-water', 'au-critical-infra-telco', 'au-critical-infra-postal-logistics', 'au-bank-tier1', 'au-insurer-tier1', 'au-superannuation', 'au-university-go8', 'au-private-health-tier1', 'uk-public-sector', 'uk-defence', 'ca-public-sector', 'nz-public-sector', 'eu-sovereign-cloud-mover'])).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listAccountsResponseTotalMin),
  "limit": zod.int().optional(),
  "offset": zod.int().optional()
})


/**
 * @summary Create an account
 */
export const createAccountBodyOneRelationshipTypeDefault = `prospect`;
export const createAccountBodyOneShowPricesInQuotesDefault = true;
export const createAccountBodyOneIsTestDataDefault = false;
export const createAccountBodyOneAnnualRevenueMin = 0;

export const createAccountBodyOneNumberOfEmployeesMin = 0;

export const createAccountBodyOneTypicalChequeMinMin = 0;

export const createAccountBodyOneTypicalChequeMaxMin = 0;

export const createAccountBodyOneLeadScoreMin = 0;
export const createAccountBodyOneLeadScoreMax = 100;

export const createAccountBodyOneHealthScoreMin = 0;
export const createAccountBodyOneHealthScoreMax = 100;

export const createAccountBodyTwoNameMax = 200;



export const createAccountBody = zod.object({
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "website": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "emailDomain": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).default(createAccountBodyOneRelationshipTypeDefault),
  "partnerType": zod.union([zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),zod.null()]).optional(),
  "partnerStatus": zod.union([zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),zod.null()]).optional(),
  "organisationType": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().default(createAccountBodyOneShowPricesInQuotesDefault),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "accountNumber": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(createAccountBodyOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "annualRevenue": zod.number().min(createAccountBodyOneAnnualRevenueMin).nullish(),
  "numberOfEmployees": zod.int().min(createAccountBodyOneNumberOfEmployeesMin).nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "emailConsent": zod.enum(['unknown', 'opted_in', 'opted_out']).optional(),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']).optional(),
  "consentSource": zod.string().nullish(),
  "consentUpdatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "investorType": zod.string().nullish(),
  "investmentFocus": zod.string().nullish(),
  "typicalChequeMin": zod.number().min(createAccountBodyOneTypicalChequeMinMin).nullish(),
  "typicalChequeMax": zod.number().min(createAccountBodyOneTypicalChequeMaxMin).nullish(),
  "accreditationStatus": zod.string().nullish(),
  "lastInvestorUpdateAt": zod.iso.datetime({"offset":true}).nullish(),
  "leadScore": zod.int().min(createAccountBodyOneLeadScoreMin).max(createAccountBodyOneLeadScoreMax).nullish(),
  "healthScore": zod.int().min(createAccountBodyOneHealthScoreMin).max(createAccountBodyOneHealthScoreMax).nullish().describe('0-100 composite score computed by account intelligence; staff-editable.'),
  "temperature": zod.enum(['hot', 'warm', 'cool', 'cold', 'new']).optional(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).optional(),
  "targetSegments": zod.array(zod.enum(['au-federal-defence', 'au-federal-national-security', 'au-federal-services-citizen', 'au-federal-policy-economic', 'au-federal-research-science', 'au-federal-regulator', 'au-federal-other', 'au-state-central', 'au-state-police-justice', 'au-state-health', 'au-state-transport', 'au-state-education', 'au-state-other', 'au-local-government-large', 'au-defence-prime', 'au-defence-supplier', 'au-critical-infra-energy', 'au-critical-infra-water', 'au-critical-infra-telco', 'au-critical-infra-postal-logistics', 'au-bank-tier1', 'au-insurer-tier1', 'au-superannuation', 'au-university-go8', 'au-private-health-tier1', 'uk-public-sector', 'uk-defence', 'ca-public-sector', 'nz-public-sector', 'eu-sovereign-cloud-mover'])).optional()
}).and(zod.object({
  "name": zod.string().min(1).max(createAccountBodyTwoNameMax)
}))

export const createAccountResponseOneRelationshipTypeDefault = `prospect`;
export const createAccountResponseOneShowPricesInQuotesDefault = true;
export const createAccountResponseOneIsTestDataDefault = false;
export const createAccountResponseOneAnnualRevenueMin = 0;

export const createAccountResponseOneNumberOfEmployeesMin = 0;

export const createAccountResponseOneTypicalChequeMinMin = 0;

export const createAccountResponseOneTypicalChequeMaxMin = 0;

export const createAccountResponseOneLeadScoreMin = 0;
export const createAccountResponseOneLeadScoreMax = 100;

export const createAccountResponseOneHealthScoreMin = 0;
export const createAccountResponseOneHealthScoreMax = 100;



export const createAccountResponse = zod.object({
  "accountKind": zod.enum(['organization', 'person']),
  "website": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "emailDomain": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).default(createAccountResponseOneRelationshipTypeDefault),
  "partnerType": zod.union([zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),zod.null()]).optional(),
  "partnerStatus": zod.union([zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),zod.null()]).optional(),
  "organisationType": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().default(createAccountResponseOneShowPricesInQuotesDefault),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "accountNumber": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(createAccountResponseOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "annualRevenue": zod.number().min(createAccountResponseOneAnnualRevenueMin).nullish(),
  "numberOfEmployees": zod.int().min(createAccountResponseOneNumberOfEmployeesMin).nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "emailConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "consentSource": zod.string().nullish(),
  "consentUpdatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "investorType": zod.string().nullish(),
  "investmentFocus": zod.string().nullish(),
  "typicalChequeMin": zod.number().min(createAccountResponseOneTypicalChequeMinMin).nullish(),
  "typicalChequeMax": zod.number().min(createAccountResponseOneTypicalChequeMaxMin).nullish(),
  "accreditationStatus": zod.string().nullish(),
  "lastInvestorUpdateAt": zod.iso.datetime({"offset":true}).nullish(),
  "leadScore": zod.int().min(createAccountResponseOneLeadScoreMin).max(createAccountResponseOneLeadScoreMax).nullish(),
  "healthScore": zod.int().min(createAccountResponseOneHealthScoreMin).max(createAccountResponseOneHealthScoreMax).nullish().describe('0-100 composite score computed by account intelligence; staff-editable.'),
  "temperature": zod.enum(['hot', 'warm', 'cool', 'cold', 'new']).optional(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).optional(),
  "targetSegments": zod.array(zod.enum(['au-federal-defence', 'au-federal-national-security', 'au-federal-services-citizen', 'au-federal-policy-economic', 'au-federal-research-science', 'au-federal-regulator', 'au-federal-other', 'au-state-central', 'au-state-police-justice', 'au-state-health', 'au-state-transport', 'au-state-education', 'au-state-other', 'au-local-government-large', 'au-defence-prime', 'au-defence-supplier', 'au-critical-infra-energy', 'au-critical-infra-water', 'au-critical-infra-telco', 'au-critical-infra-postal-logistics', 'au-bank-tier1', 'au-insurer-tier1', 'au-superannuation', 'au-university-go8', 'au-private-health-tier1', 'uk-public-sector', 'uk-defence', 'ca-public-sector', 'nz-public-sector', 'eu-sovereign-cloud-mover'])).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Get one account
 */
export const getAccountParams = zod.object({
  "id": zod.uuid()
})

export const getAccountResponseOneRelationshipTypeDefault = `prospect`;
export const getAccountResponseOneShowPricesInQuotesDefault = true;
export const getAccountResponseOneIsTestDataDefault = false;
export const getAccountResponseOneAnnualRevenueMin = 0;

export const getAccountResponseOneNumberOfEmployeesMin = 0;

export const getAccountResponseOneTypicalChequeMinMin = 0;

export const getAccountResponseOneTypicalChequeMaxMin = 0;

export const getAccountResponseOneLeadScoreMin = 0;
export const getAccountResponseOneLeadScoreMax = 100;

export const getAccountResponseOneHealthScoreMin = 0;
export const getAccountResponseOneHealthScoreMax = 100;



export const getAccountResponse = zod.object({
  "accountKind": zod.enum(['organization', 'person']),
  "website": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "emailDomain": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).default(getAccountResponseOneRelationshipTypeDefault),
  "partnerType": zod.union([zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),zod.null()]).optional(),
  "partnerStatus": zod.union([zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),zod.null()]).optional(),
  "organisationType": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().default(getAccountResponseOneShowPricesInQuotesDefault),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "accountNumber": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(getAccountResponseOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "annualRevenue": zod.number().min(getAccountResponseOneAnnualRevenueMin).nullish(),
  "numberOfEmployees": zod.int().min(getAccountResponseOneNumberOfEmployeesMin).nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "emailConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "consentSource": zod.string().nullish(),
  "consentUpdatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "investorType": zod.string().nullish(),
  "investmentFocus": zod.string().nullish(),
  "typicalChequeMin": zod.number().min(getAccountResponseOneTypicalChequeMinMin).nullish(),
  "typicalChequeMax": zod.number().min(getAccountResponseOneTypicalChequeMaxMin).nullish(),
  "accreditationStatus": zod.string().nullish(),
  "lastInvestorUpdateAt": zod.iso.datetime({"offset":true}).nullish(),
  "leadScore": zod.int().min(getAccountResponseOneLeadScoreMin).max(getAccountResponseOneLeadScoreMax).nullish(),
  "healthScore": zod.int().min(getAccountResponseOneHealthScoreMin).max(getAccountResponseOneHealthScoreMax).nullish().describe('0-100 composite score computed by account intelligence; staff-editable.'),
  "temperature": zod.enum(['hot', 'warm', 'cool', 'cold', 'new']).optional(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).optional(),
  "targetSegments": zod.array(zod.enum(['au-federal-defence', 'au-federal-national-security', 'au-federal-services-citizen', 'au-federal-policy-economic', 'au-federal-research-science', 'au-federal-regulator', 'au-federal-other', 'au-state-central', 'au-state-police-justice', 'au-state-health', 'au-state-transport', 'au-state-education', 'au-state-other', 'au-local-government-large', 'au-defence-prime', 'au-defence-supplier', 'au-critical-infra-energy', 'au-critical-infra-water', 'au-critical-infra-telco', 'au-critical-infra-postal-logistics', 'au-bank-tier1', 'au-insurer-tier1', 'au-superannuation', 'au-university-go8', 'au-private-health-tier1', 'uk-public-sector', 'uk-defence', 'ca-public-sector', 'nz-public-sector', 'eu-sovereign-cloud-mover'])).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update an account
 */
export const updateAccountParams = zod.object({
  "id": zod.uuid()
})

export const updateAccountBodyOneRelationshipTypeDefault = `prospect`;
export const updateAccountBodyOneShowPricesInQuotesDefault = true;
export const updateAccountBodyOneIsTestDataDefault = false;
export const updateAccountBodyOneAnnualRevenueMin = 0;

export const updateAccountBodyOneNumberOfEmployeesMin = 0;

export const updateAccountBodyOneTypicalChequeMinMin = 0;

export const updateAccountBodyOneTypicalChequeMaxMin = 0;

export const updateAccountBodyOneLeadScoreMin = 0;
export const updateAccountBodyOneLeadScoreMax = 100;

export const updateAccountBodyOneHealthScoreMin = 0;
export const updateAccountBodyOneHealthScoreMax = 100;

export const updateAccountBodyTwoNameMax = 200;



export const updateAccountBody = zod.object({
  "accountKind": zod.enum(['organization', 'person']).optional(),
  "website": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "emailDomain": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).default(updateAccountBodyOneRelationshipTypeDefault),
  "partnerType": zod.union([zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),zod.null()]).optional(),
  "partnerStatus": zod.union([zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),zod.null()]).optional(),
  "organisationType": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().default(updateAccountBodyOneShowPricesInQuotesDefault),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "accountNumber": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(updateAccountBodyOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "annualRevenue": zod.number().min(updateAccountBodyOneAnnualRevenueMin).nullish(),
  "numberOfEmployees": zod.int().min(updateAccountBodyOneNumberOfEmployeesMin).nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "emailConsent": zod.enum(['unknown', 'opted_in', 'opted_out']).optional(),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']).optional(),
  "consentSource": zod.string().nullish(),
  "consentUpdatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "investorType": zod.string().nullish(),
  "investmentFocus": zod.string().nullish(),
  "typicalChequeMin": zod.number().min(updateAccountBodyOneTypicalChequeMinMin).nullish(),
  "typicalChequeMax": zod.number().min(updateAccountBodyOneTypicalChequeMaxMin).nullish(),
  "accreditationStatus": zod.string().nullish(),
  "lastInvestorUpdateAt": zod.iso.datetime({"offset":true}).nullish(),
  "leadScore": zod.int().min(updateAccountBodyOneLeadScoreMin).max(updateAccountBodyOneLeadScoreMax).nullish(),
  "healthScore": zod.int().min(updateAccountBodyOneHealthScoreMin).max(updateAccountBodyOneHealthScoreMax).nullish().describe('0-100 composite score computed by account intelligence; staff-editable.'),
  "temperature": zod.enum(['hot', 'warm', 'cool', 'cold', 'new']).optional(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).optional(),
  "targetSegments": zod.array(zod.enum(['au-federal-defence', 'au-federal-national-security', 'au-federal-services-citizen', 'au-federal-policy-economic', 'au-federal-research-science', 'au-federal-regulator', 'au-federal-other', 'au-state-central', 'au-state-police-justice', 'au-state-health', 'au-state-transport', 'au-state-education', 'au-state-other', 'au-local-government-large', 'au-defence-prime', 'au-defence-supplier', 'au-critical-infra-energy', 'au-critical-infra-water', 'au-critical-infra-telco', 'au-critical-infra-postal-logistics', 'au-bank-tier1', 'au-insurer-tier1', 'au-superannuation', 'au-university-go8', 'au-private-health-tier1', 'uk-public-sector', 'uk-defence', 'ca-public-sector', 'nz-public-sector', 'eu-sovereign-cloud-mover'])).optional()
}).and(zod.object({
  "name": zod.string().min(1).max(updateAccountBodyTwoNameMax).optional()
}))

export const updateAccountResponseOneRelationshipTypeDefault = `prospect`;
export const updateAccountResponseOneShowPricesInQuotesDefault = true;
export const updateAccountResponseOneIsTestDataDefault = false;
export const updateAccountResponseOneAnnualRevenueMin = 0;

export const updateAccountResponseOneNumberOfEmployeesMin = 0;

export const updateAccountResponseOneTypicalChequeMinMin = 0;

export const updateAccountResponseOneTypicalChequeMaxMin = 0;

export const updateAccountResponseOneLeadScoreMin = 0;
export const updateAccountResponseOneLeadScoreMax = 100;

export const updateAccountResponseOneHealthScoreMin = 0;
export const updateAccountResponseOneHealthScoreMax = 100;



export const updateAccountResponse = zod.object({
  "accountKind": zod.enum(['organization', 'person']),
  "website": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "emailDomain": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).default(updateAccountResponseOneRelationshipTypeDefault),
  "partnerType": zod.union([zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),zod.null()]).optional(),
  "partnerStatus": zod.union([zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),zod.null()]).optional(),
  "organisationType": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().default(updateAccountResponseOneShowPricesInQuotesDefault),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "accountNumber": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(updateAccountResponseOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "annualRevenue": zod.number().min(updateAccountResponseOneAnnualRevenueMin).nullish(),
  "numberOfEmployees": zod.int().min(updateAccountResponseOneNumberOfEmployeesMin).nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "emailConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "consentSource": zod.string().nullish(),
  "consentUpdatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "investorType": zod.string().nullish(),
  "investmentFocus": zod.string().nullish(),
  "typicalChequeMin": zod.number().min(updateAccountResponseOneTypicalChequeMinMin).nullish(),
  "typicalChequeMax": zod.number().min(updateAccountResponseOneTypicalChequeMaxMin).nullish(),
  "accreditationStatus": zod.string().nullish(),
  "lastInvestorUpdateAt": zod.iso.datetime({"offset":true}).nullish(),
  "leadScore": zod.int().min(updateAccountResponseOneLeadScoreMin).max(updateAccountResponseOneLeadScoreMax).nullish(),
  "healthScore": zod.int().min(updateAccountResponseOneHealthScoreMin).max(updateAccountResponseOneHealthScoreMax).nullish().describe('0-100 composite score computed by account intelligence; staff-editable.'),
  "temperature": zod.enum(['hot', 'warm', 'cool', 'cold', 'new']).optional(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).optional(),
  "targetSegments": zod.array(zod.enum(['au-federal-defence', 'au-federal-national-security', 'au-federal-services-citizen', 'au-federal-policy-economic', 'au-federal-research-science', 'au-federal-regulator', 'au-federal-other', 'au-state-central', 'au-state-police-justice', 'au-state-health', 'au-state-transport', 'au-state-education', 'au-state-other', 'au-local-government-large', 'au-defence-prime', 'au-defence-supplier', 'au-critical-infra-energy', 'au-critical-infra-water', 'au-critical-infra-telco', 'au-critical-infra-postal-logistics', 'au-bank-tier1', 'au-insurer-tier1', 'au-superannuation', 'au-university-go8', 'au-private-health-tier1', 'uk-public-sector', 'uk-defence', 'ca-public-sector', 'nz-public-sector', 'eu-sovereign-cloud-mover'])).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete an account
 */
export const deleteAccountParams = zod.object({
  "id": zod.uuid()
})

export const deleteAccountResponse = zod.void()


/**
 * @summary List contacts
 */
export const listContactsQuerySearchMax = 200;

export const listContactsQueryIncludeTestDataDefault = false;
export const listContactsQueryLimitDefault = 50;
export const listContactsQueryLimitMax = 100;

export const listContactsQueryOffsetDefault = 0;
export const listContactsQueryOffsetMin = 0;



export const listContactsQueryParams = zod.object({
  "accountId": zod.uuid().optional(),
  "search": zod.string().max(listContactsQuerySearchMax).optional().describe('Case-insensitive match on name or email.'),
  "includeTestData": zod.boolean().default(listContactsQueryIncludeTestDataDefault).describe('Include records flagged as test or demo data. They are excluded by default.'),
  "limit": zod.int().min(1).max(listContactsQueryLimitMax).default(listContactsQueryLimitDefault),
  "offset": zod.int().min(listContactsQueryOffsetMin).default(listContactsQueryOffsetDefault)
})

export const listContactsResponseItemsItemOneIsTestDataDefault = false;
export const listContactsResponseItemsItemOneFocusLevelDefault = `standard`;
export const listContactsResponseItemsItemOneLeadScoreMin = 0;
export const listContactsResponseItemsItemOneLeadScoreMax = 100;

export const listContactsResponseTotalMin = 0;



export const listContactsResponse = zod.object({
  "items": zod.array(zod.object({
  "accountId": zod.uuid().nullish(),
  "phone": zod.string().nullish(),
  "mobile": zod.string().nullish(),
  "secondaryEmail": zod.string().nullish(),
  "fax": zod.string().nullish(),
  "department": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "preferredContactMethod": zod.string().nullish(),
  "doNotEmail": zod.boolean().optional(),
  "doNotPhone": zod.boolean().optional(),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(listContactsResponseItemsItemOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "unsubscribedAt": zod.iso.datetime({"offset":true}).nullish(),
  "jobTitle": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).default(listContactsResponseItemsItemOneFocusLevelDefault).describe('Relationship importance, using the same levels as accounts.'),
  "leadScore": zod.int().min(listContactsResponseItemsItemOneLeadScoreMin).max(listContactsResponseItemsItemOneLeadScoreMax).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "email": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listContactsResponseTotalMin),
  "limit": zod.int().optional(),
  "offset": zod.int().optional()
})


/**
 * @summary Create a contact
 */
export const createContactBodyOneIsTestDataDefault = false;
export const createContactBodyOneFocusLevelDefault = `standard`;
export const createContactBodyOneLeadScoreMin = 0;
export const createContactBodyOneLeadScoreMax = 100;

export const createContactBodyTwoFirstNameMax = 100;

export const createContactBodyTwoLastNameMax = 100;



export const createContactBody = zod.object({
  "accountId": zod.uuid().nullish(),
  "phone": zod.string().nullish(),
  "mobile": zod.string().nullish(),
  "secondaryEmail": zod.string().nullish(),
  "fax": zod.string().nullish(),
  "department": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "preferredContactMethod": zod.string().nullish(),
  "doNotEmail": zod.boolean().optional(),
  "doNotPhone": zod.boolean().optional(),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']).optional(),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(createContactBodyOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "unsubscribedAt": zod.iso.datetime({"offset":true}).nullish(),
  "jobTitle": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).default(createContactBodyOneFocusLevelDefault).describe('Relationship importance, using the same levels as accounts.'),
  "leadScore": zod.int().min(createContactBodyOneLeadScoreMin).max(createContactBodyOneLeadScoreMax).nullish()
}).and(zod.object({
  "firstName": zod.string().min(1).max(createContactBodyTwoFirstNameMax),
  "lastName": zod.string().min(1).max(createContactBodyTwoLastNameMax),
  "email": zod.email()
}))

export const createContactResponseOneIsTestDataDefault = false;
export const createContactResponseOneFocusLevelDefault = `standard`;
export const createContactResponseOneLeadScoreMin = 0;
export const createContactResponseOneLeadScoreMax = 100;



export const createContactResponse = zod.object({
  "accountId": zod.uuid().nullish(),
  "phone": zod.string().nullish(),
  "mobile": zod.string().nullish(),
  "secondaryEmail": zod.string().nullish(),
  "fax": zod.string().nullish(),
  "department": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "preferredContactMethod": zod.string().nullish(),
  "doNotEmail": zod.boolean().optional(),
  "doNotPhone": zod.boolean().optional(),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(createContactResponseOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "unsubscribedAt": zod.iso.datetime({"offset":true}).nullish(),
  "jobTitle": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).default(createContactResponseOneFocusLevelDefault).describe('Relationship importance, using the same levels as accounts.'),
  "leadScore": zod.int().min(createContactResponseOneLeadScoreMin).max(createContactResponseOneLeadScoreMax).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "email": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Get one contact
 */
export const getContactParams = zod.object({
  "id": zod.uuid()
})

export const getContactResponseOneIsTestDataDefault = false;
export const getContactResponseOneFocusLevelDefault = `standard`;
export const getContactResponseOneLeadScoreMin = 0;
export const getContactResponseOneLeadScoreMax = 100;



export const getContactResponse = zod.object({
  "accountId": zod.uuid().nullish(),
  "phone": zod.string().nullish(),
  "mobile": zod.string().nullish(),
  "secondaryEmail": zod.string().nullish(),
  "fax": zod.string().nullish(),
  "department": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "preferredContactMethod": zod.string().nullish(),
  "doNotEmail": zod.boolean().optional(),
  "doNotPhone": zod.boolean().optional(),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(getContactResponseOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "unsubscribedAt": zod.iso.datetime({"offset":true}).nullish(),
  "jobTitle": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).default(getContactResponseOneFocusLevelDefault).describe('Relationship importance, using the same levels as accounts.'),
  "leadScore": zod.int().min(getContactResponseOneLeadScoreMin).max(getContactResponseOneLeadScoreMax).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "email": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a contact
 */
export const updateContactParams = zod.object({
  "id": zod.uuid()
})

export const updateContactBodyOneIsTestDataDefault = false;
export const updateContactBodyOneFocusLevelDefault = `standard`;
export const updateContactBodyOneLeadScoreMin = 0;
export const updateContactBodyOneLeadScoreMax = 100;

export const updateContactBodyTwoFirstNameMax = 100;

export const updateContactBodyTwoLastNameMax = 100;



export const updateContactBody = zod.object({
  "accountId": zod.uuid().nullish(),
  "phone": zod.string().nullish(),
  "mobile": zod.string().nullish(),
  "secondaryEmail": zod.string().nullish(),
  "fax": zod.string().nullish(),
  "department": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "preferredContactMethod": zod.string().nullish(),
  "doNotEmail": zod.boolean().optional(),
  "doNotPhone": zod.boolean().optional(),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']).optional(),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(updateContactBodyOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "unsubscribedAt": zod.iso.datetime({"offset":true}).nullish(),
  "jobTitle": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).default(updateContactBodyOneFocusLevelDefault).describe('Relationship importance, using the same levels as accounts.'),
  "leadScore": zod.int().min(updateContactBodyOneLeadScoreMin).max(updateContactBodyOneLeadScoreMax).nullish()
}).and(zod.object({
  "firstName": zod.string().min(1).max(updateContactBodyTwoFirstNameMax).optional(),
  "lastName": zod.string().min(1).max(updateContactBodyTwoLastNameMax).optional(),
  "email": zod.email().optional()
}))

export const updateContactResponseOneIsTestDataDefault = false;
export const updateContactResponseOneFocusLevelDefault = `standard`;
export const updateContactResponseOneLeadScoreMin = 0;
export const updateContactResponseOneLeadScoreMax = 100;



export const updateContactResponse = zod.object({
  "accountId": zod.uuid().nullish(),
  "phone": zod.string().nullish(),
  "mobile": zod.string().nullish(),
  "secondaryEmail": zod.string().nullish(),
  "fax": zod.string().nullish(),
  "department": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "preferredContactMethod": zod.string().nullish(),
  "doNotEmail": zod.boolean().optional(),
  "doNotPhone": zod.boolean().optional(),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(updateContactResponseOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "unsubscribedAt": zod.iso.datetime({"offset":true}).nullish(),
  "jobTitle": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).default(updateContactResponseOneFocusLevelDefault).describe('Relationship importance, using the same levels as accounts.'),
  "leadScore": zod.int().min(updateContactResponseOneLeadScoreMin).max(updateContactResponseOneLeadScoreMax).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "email": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a contact
 */
export const deleteContactParams = zod.object({
  "id": zod.uuid()
})

export const deleteContactResponse = zod.void()


/**
 * @summary Get a contact's importance level
 */
export const getContactFocusLevelParams = zod.object({
  "id": zod.uuid()
})

export const getContactFocusLevelResponse = zod.object({
  "id": zod.uuid(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard'])
})


/**
 * Requires the same edit permission as the contact itself.
 * @summary Set a contact's importance level (Strategic, Key, Growth or Standard)
 */
export const updateContactFocusLevelParams = zod.object({
  "id": zod.uuid()
})

export const updateContactFocusLevelBody = zod.object({
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard'])
})

export const updateContactFocusLevelResponse = zod.object({
  "id": zod.uuid(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard'])
})


/**
 * Idempotent. Returns the record's existing brief when one exists; otherwise creates a managed document titled "<Name> — Strategic brief" and links it. Requires edit permission on the record.
 * @summary Create or open the strategic brief for an account or contact
 */
export const createStrategicBriefBody = zod.object({
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid()
})

export const createStrategicBriefResponseExcerptMax = 500;



export const createStrategicBriefResponse = zod.object({
  "id": zod.uuid().describe('Brief link identifier.'),
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "documentId": zod.uuid().describe('Managed document holding the brief; edit it through the managed-document API.'),
  "title": zod.string(),
  "excerpt": zod.string().max(createStrategicBriefResponseExcerptMax).nullable().describe('Plain-text start of the brief, or null when nothing has been written yet.'),
  "canEdit": zod.boolean().describe('Whether the signed-in user may change this brief.'),
  "created": zod.boolean().optional().describe('Present on create; true when this request created the brief.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}).describe('When the brief\'s document was last saved.')
})


/**
 * @summary Get the strategic brief for an account or contact, or null when none exists
 */
export const getStrategicBriefParams = zod.object({
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid()
})

export const getStrategicBriefResponseBriefOneExcerptMax = 500;



export const getStrategicBriefResponse = zod.object({
  "brief": zod.union([zod.object({
  "id": zod.uuid().describe('Brief link identifier.'),
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "documentId": zod.uuid().describe('Managed document holding the brief; edit it through the managed-document API.'),
  "title": zod.string(),
  "excerpt": zod.string().max(getStrategicBriefResponseBriefOneExcerptMax).nullable().describe('Plain-text start of the brief, or null when nothing has been written yet.'),
  "canEdit": zod.boolean().describe('Whether the signed-in user may change this brief.'),
  "created": zod.boolean().optional().describe('Present on create; true when this request created the brief.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}).describe('When the brief\'s document was last saved.')
}),zod.null()])
})


/**
 * Used to undo starting a brief. The link is removed and the empty document is archived, never deleted. Briefs with written content are refused with 409 so no strategy text is lost.
 * @summary Remove a strategic brief that has no written content yet
 */
export const deleteStrategicBriefParams = zod.object({
  "briefId": zod.uuid()
})

export const deleteStrategicBriefResponse = zod.void()


/**
 * Read-only roll-up of enquiries, social leads, web signals, pipeline opportunities, referrals, quote requests and tender opportunities. A lead that has become an opportunity appears once, as the opportunity. Filtering, ordering and paging happen on the server.
 * @summary List every potential opportunity in one inbox
 */
export const listOpportunityHubItemsQuerySearchMax = 200;

export const listOpportunityHubItemsQueryTypesMax = 200;


export const listOpportunityHubItemsQueryTypesRegExp = new RegExp('^(enquiry|social|web_signal|opportunity|referral|quote|tender)(,(enquiry|social|web_signal|opportunity|referral|quote|tender))*$');
export const listOpportunityHubItemsQueryNotForUsDefault = `exclude`;
export const listOpportunityHubItemsQueryViewDefault = `open`;
export const listOpportunityHubItemsQueryOwnerDefault = `everyone`;
export const listOpportunityHubItemsQuerySortDefault = `urgent`;
export const listOpportunityHubItemsQueryLimitDefault = 50;
export const listOpportunityHubItemsQueryLimitMax = 100;

export const listOpportunityHubItemsQueryOffsetDefault = 0;
export const listOpportunityHubItemsQueryOffsetMin = 0;



export const listOpportunityHubItemsQueryParams = zod.object({
  "search": zod.string().max(listOpportunityHubItemsQuerySearchMax).optional().describe('Literal case-insensitive text in the title, summary, account, contact or owner.'),
  "types": zod.string().max(listOpportunityHubItemsQueryTypesMax).regex(listOpportunityHubItemsQueryTypesRegExp).optional().describe('Comma-separated item types to include. Omit for every type.'),
  "notForUs": zod.enum(['exclude', 'include']).default(listOpportunityHubItemsQueryNotForUsDefault).describe('Tenders recommended Not for us are kept but hidden by default; include shows them.'),
  "view": zod.enum(['open', 'all']).default(listOpportunityHubItemsQueryViewDefault).describe('open shows items still needing attention; all includes closed, won, lost and dismissed items.'),
  "owner": zod.enum(['everyone', 'mine']).default(listOpportunityHubItemsQueryOwnerDefault).describe('mine keeps items owned by or assigned to the signed-in person.'),
  "sort": zod.enum(['urgent', 'newest', 'value', 'activity']).default(listOpportunityHubItemsQuerySortDefault),
  "limit": zod.int().min(1).max(listOpportunityHubItemsQueryLimitMax).default(listOpportunityHubItemsQueryLimitDefault),
  "offset": zod.int().min(listOpportunityHubItemsQueryOffsetMin).default(listOpportunityHubItemsQueryOffsetDefault)
})

export const listOpportunityHubItemsResponseItemsItemAgeDaysMin = 0;

export const listOpportunityHubItemsResponseItemsMax = 100;

export const listOpportunityHubItemsResponseTotalMin = 0;

export const listOpportunityHubItemsResponseCountsEnquiryMin = 0;

export const listOpportunityHubItemsResponseCountsSocialMin = 0;

export const listOpportunityHubItemsResponseCountsWebSignalMin = 0;

export const listOpportunityHubItemsResponseCountsOpportunityMin = 0;

export const listOpportunityHubItemsResponseCountsReferralMin = 0;

export const listOpportunityHubItemsResponseCountsQuoteMin = 0;

export const listOpportunityHubItemsResponseCountsTenderMin = 0;



export const listOpportunityHubItemsResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string().describe('Stable list key: type and record id.'),
  "type": zod.enum(['enquiry', 'social', 'web_signal', 'opportunity', 'referral', 'quote', 'tender']),
  "recordId": zod.uuid(),
  "title": zod.string(),
  "summary": zod.string().nullable(),
  "message": zod.string().nullable().describe('Body text, notes or rationale, shortened to 2000 characters.'),
  "status": zod.string().describe('Native status or stage of the source record.'),
  "priority": zod.enum(['urgent', 'normal', 'low']),
  "isOpen": zod.boolean(),
  "isNew": zod.boolean(),
  "overdue": zod.boolean(),
  "accountId": zod.uuid().nullable(),
  "accountName": zod.string().nullable(),
  "contactId": zod.uuid().nullable(),
  "contactName": zod.string().nullable(),
  "contactEmail": zod.string().nullable(),
  "contactPhone": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "value": zod.number().nullable(),
  "currency": zod.string().nullable(),
  "score": zod.number().nullable().describe('Web signal fit score or tender match score from 0 to 100.'),
  "source": zod.string().nullable().describe('Channel, network or kind of the source record.'),
  "stage": zod.string().nullable(),
  "pipeline": zod.string().nullable(),
  "origin": zod.union([zod.literal('enquiry'),zod.literal('social'),zod.literal('web_signal'),zod.literal('referral'),zod.literal('quote'),zod.literal(null)]).nullable().describe('For opportunities, the kind of lead it came from.'),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable().describe('For tenders, the portal closing date.'),
  "recommendation": zod.union([zod.literal('respond'),zod.literal('maybe'),zod.literal('not_for_us'),zod.literal(null)]).nullable().describe('For tenders, the bid recommendation. People decide; the AI only recommends.'),
  "receivedAt": zod.iso.datetime({"offset":true}),
  "lastActivityAt": zod.iso.datetime({"offset":true}),
  "ageDays": zod.int().min(listOpportunityHubItemsResponseItemsItemAgeDaysMin),
  "deepLink": zod.string()
})).max(listOpportunityHubItemsResponseItemsMax),
  "total": zod.int().min(listOpportunityHubItemsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int(),
  "counts": zod.object({
  "enquiry": zod.int().min(listOpportunityHubItemsResponseCountsEnquiryMin),
  "social": zod.int().min(listOpportunityHubItemsResponseCountsSocialMin),
  "web_signal": zod.int().min(listOpportunityHubItemsResponseCountsWebSignalMin),
  "opportunity": zod.int().min(listOpportunityHubItemsResponseCountsOpportunityMin),
  "referral": zod.int().min(listOpportunityHubItemsResponseCountsReferralMin),
  "quote": zod.int().min(listOpportunityHubItemsResponseCountsQuoteMin),
  "tender": zod.int().min(listOpportunityHubItemsResponseCountsTenderMin)
})
})


/**
 * Read-only search across accounts, contacts, opportunities, enquiries, quotes, tenders and agreements in the caller's entity. Every word must match. Results are ranked by match quality, with accounts and contacts ahead of other types. limit and offset apply within each type, so an unfiltered search returns the best matches of every type.
 * @summary Search records across the site
 */
export const searchSiteQuerySearchMin = 2;
export const searchSiteQuerySearchMax = 200;

export const searchSiteQueryTypesMax = 200;


export const searchSiteQueryTypesRegExp = new RegExp('^(account|contact|opportunity|enquiry|quote|tender|agreement)(,(account|contact|opportunity|enquiry|quote|tender|agreement))*$');
export const searchSiteQueryLimitDefault = 50;
export const searchSiteQueryLimitMax = 100;

export const searchSiteQueryOffsetDefault = 0;
export const searchSiteQueryOffsetMin = 0;



export const searchSiteQueryParams = zod.object({
  "search": zod.string().min(searchSiteQuerySearchMin).max(searchSiteQuerySearchMax).describe('Literal case-insensitive words to find.'),
  "types": zod.string().max(searchSiteQueryTypesMax).regex(searchSiteQueryTypesRegExp).optional().describe('Comma-separated record types to return. Omit for every type. Counts always cover every type.'),
  "limit": zod.int().min(1).max(searchSiteQueryLimitMax).default(searchSiteQueryLimitDefault),
  "offset": zod.int().min(searchSiteQueryOffsetMin).default(searchSiteQueryOffsetDefault)
})

export const searchSiteResponseItemsMax = 700;

export const searchSiteResponseTotalMin = 0;

export const searchSiteResponseCountsAccountMin = 0;

export const searchSiteResponseCountsContactMin = 0;

export const searchSiteResponseCountsOpportunityMin = 0;

export const searchSiteResponseCountsEnquiryMin = 0;

export const searchSiteResponseCountsQuoteMin = 0;

export const searchSiteResponseCountsTenderMin = 0;

export const searchSiteResponseCountsAgreementMin = 0;



export const searchSiteResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string(),
  "type": zod.enum(['account', 'contact', 'opportunity', 'enquiry', 'quote', 'tender', 'agreement']),
  "recordId": zod.uuid(),
  "title": zod.string(),
  "subtitle": zod.string().nullable().describe('Short detail such as job title, email, stage or reference.'),
  "status": zod.string().nullable(),
  "accountName": zod.string().nullable(),
  "score": zod.number().describe('Relevance; higher is better.'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deepLink": zod.string()
})).max(searchSiteResponseItemsMax),
  "total": zod.int().min(searchSiteResponseTotalMin).describe('Matches across the requested types.'),
  "limit": zod.int(),
  "offset": zod.int(),
  "counts": zod.object({
  "account": zod.int().min(searchSiteResponseCountsAccountMin),
  "contact": zod.int().min(searchSiteResponseCountsContactMin),
  "opportunity": zod.int().min(searchSiteResponseCountsOpportunityMin),
  "enquiry": zod.int().min(searchSiteResponseCountsEnquiryMin),
  "quote": zod.int().min(searchSiteResponseCountsQuoteMin),
  "tender": zod.int().min(searchSiteResponseCountsTenderMin),
  "agreement": zod.int().min(searchSiteResponseCountsAgreementMin)
})
})


/**
 * @summary List enquiries
 */
export const listEnquiriesQuerySearchMax = 200;

export const listEnquiriesQueryIncludeTestDataDefault = false;
export const listEnquiriesQueryLimitDefault = 50;
export const listEnquiriesQueryLimitMax = 100;

export const listEnquiriesQueryOffsetDefault = 0;
export const listEnquiriesQueryOffsetMin = 0;



export const listEnquiriesQueryParams = zod.object({
  "search": zod.string().max(listEnquiriesQuerySearchMax).optional().describe('Literal case-insensitive text in name, email, company, or subject; applied before paging.'),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']).optional(),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']).optional(),
  "type": zod.enum(['general', 'booking']).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().optional(),
  "includeTestData": zod.boolean().default(listEnquiriesQueryIncludeTestDataDefault).describe('Include records flagged as test or demo data. They are excluded by default.'),
  "limit": zod.int().min(1).max(listEnquiriesQueryLimitMax).default(listEnquiriesQueryLimitDefault),
  "offset": zod.int().min(listEnquiriesQueryOffsetMin).default(listEnquiriesQueryOffsetDefault)
})

export const listEnquiriesResponseItemsItemContactAttemptsMin = 0;

export const listEnquiriesResponseTotalMin = 0;



export const listEnquiriesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "phone": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "subject": zod.string(),
  "message": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']),
  "type": zod.enum(['general', 'booking']).describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "bookingProduct": zod.string().nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "assignedTo": zod.string().nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactAttempts": zod.int().min(listEnquiriesResponseItemsItemContactAttemptsMin),
  "outcomeReason": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listEnquiriesResponseTotalMin),
  "limit": zod.int().optional(),
  "offset": zod.int().optional()
})


/**
 * @summary Create an enquiry
 */
export const createEnquiryBodyNameMax = 200;

export const createEnquiryBodyCompanyNameMax = 200;

export const createEnquiryBodySubjectMax = 300;

export const createEnquiryBodyMessageMax = 5000;

export const createEnquiryBodyBookingProductMax = 200;



export const createEnquiryBody = zod.object({
  "name": zod.string().min(1).max(createEnquiryBodyNameMax),
  "email": zod.email(),
  "phone": zod.string().nullish(),
  "companyName": zod.string().max(createEnquiryBodyCompanyNameMax).nullish(),
  "subject": zod.string().min(1).max(createEnquiryBodySubjectMax),
  "message": zod.string().min(1).max(createEnquiryBodyMessageMax),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']).optional(),
  "type": zod.enum(['general', 'booking']).optional().describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "bookingProduct": zod.string().max(createEnquiryBodyBookingProductMax).nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish()
})

export const createEnquiryResponseContactAttemptsMin = 0;



export const createEnquiryResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "phone": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "subject": zod.string(),
  "message": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']),
  "type": zod.enum(['general', 'booking']).describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "bookingProduct": zod.string().nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "assignedTo": zod.string().nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactAttempts": zod.int().min(createEnquiryResponseContactAttemptsMin),
  "outcomeReason": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get one enquiry
 */
export const getEnquiryParams = zod.object({
  "id": zod.uuid()
})

export const getEnquiryResponseContactAttemptsMin = 0;



export const getEnquiryResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "phone": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "subject": zod.string(),
  "message": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']),
  "type": zod.enum(['general', 'booking']).describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "bookingProduct": zod.string().nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "assignedTo": zod.string().nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactAttempts": zod.int().min(getEnquiryResponseContactAttemptsMin),
  "outcomeReason": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update an enquiry
 */
export const updateEnquiryParams = zod.object({
  "id": zod.uuid()
})

export const updateEnquiryBodyNameMax = 200;

export const updateEnquiryBodySubjectMax = 300;

export const updateEnquiryBodyMessageMax = 5000;

export const updateEnquiryBodyBookingProductMax = 200;

export const updateEnquiryBodyAssignedToMax = 200;

export const updateEnquiryBodyOutcomeReasonMax = 500;

export const updateEnquiryBodyChangedByMax = 200;

export const updateEnquiryBodyCompanyNameMax = 200;



export const updateEnquiryBody = zod.object({
  "name": zod.string().min(1).max(updateEnquiryBodyNameMax).optional(),
  "email": zod.email().optional(),
  "phone": zod.string().nullish(),
  "subject": zod.string().min(1).max(updateEnquiryBodySubjectMax).optional(),
  "message": zod.string().min(1).max(updateEnquiryBodyMessageMax).optional(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']).optional(),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']).optional(),
  "type": zod.enum(['general', 'booking']).optional().describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "bookingProduct": zod.string().max(updateEnquiryBodyBookingProductMax).nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "assignedTo": zod.string().max(updateEnquiryBodyAssignedToMax).nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish(),
  "outcomeReason": zod.string().max(updateEnquiryBodyOutcomeReasonMax).nullish(),
  "changedBy": zod.string().max(updateEnquiryBodyChangedByMax).nullish(),
  "companyName": zod.string().max(updateEnquiryBodyCompanyNameMax).nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish()
})

export const updateEnquiryResponseContactAttemptsMin = 0;



export const updateEnquiryResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "phone": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "subject": zod.string(),
  "message": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']),
  "type": zod.enum(['general', 'booking']).describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "bookingProduct": zod.string().nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "assignedTo": zod.string().nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactAttempts": zod.int().min(updateEnquiryResponseContactAttemptsMin),
  "outcomeReason": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete an enquiry
 */
export const deleteEnquiryParams = zod.object({
  "id": zod.uuid()
})

export const deleteEnquiryResponse = zod.void()


/**
 * Matches or creates a contact by email (and an account by name when provided), optionally opens an opportunity in the first pipeline stage, links the records back onto the enquiry, and marks it converted.
 * @summary Convert an enquiry into a contact (and optionally an opportunity)
 */
export const convertEnquiryParams = zod.object({
  "id": zod.uuid()
})

export const convertEnquiryBodyCreateOpportunityDefault = false;
export const convertEnquiryBodyOpportunityTitleMax = 300;



export const convertEnquiryBody = zod.object({
  "createOpportunity": zod.boolean().default(convertEnquiryBodyCreateOpportunityDefault),
  "opportunityTitle": zod.string().min(1).max(convertEnquiryBodyOpportunityTitleMax).optional(),
  "opportunityValue": zod.number().nullish()
})

export const convertEnquiryResponseEnquiryContactAttemptsMin = 0;

export const convertEnquiryResponseContactOneIsTestDataDefault = false;
export const convertEnquiryResponseContactOneFocusLevelDefault = `standard`;
export const convertEnquiryResponseContactOneLeadScoreMin = 0;
export const convertEnquiryResponseContactOneLeadScoreMax = 100;

export const convertEnquiryResponseAccountOneRelationshipTypeDefault = `prospect`;
export const convertEnquiryResponseAccountOneShowPricesInQuotesDefault = true;
export const convertEnquiryResponseAccountOneIsTestDataDefault = false;
export const convertEnquiryResponseAccountOneAnnualRevenueMin = 0;

export const convertEnquiryResponseAccountOneNumberOfEmployeesMin = 0;

export const convertEnquiryResponseAccountOneTypicalChequeMinMin = 0;

export const convertEnquiryResponseAccountOneTypicalChequeMaxMin = 0;

export const convertEnquiryResponseAccountOneLeadScoreMin = 0;
export const convertEnquiryResponseAccountOneLeadScoreMax = 100;

export const convertEnquiryResponseAccountOneHealthScoreMin = 0;
export const convertEnquiryResponseAccountOneHealthScoreMax = 100;

export const convertEnquiryResponseOpportunityProbabilityMin = 0;
export const convertEnquiryResponseOpportunityProbabilityMax = 100;

export const convertEnquiryResponseOpportunityIsTestDataDefault = false;

export const convertEnquiryResponse = zod.object({
  "enquiry": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "phone": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "subject": zod.string(),
  "message": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']),
  "type": zod.enum(['general', 'booking']).describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "bookingProduct": zod.string().nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "assignedTo": zod.string().nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactAttempts": zod.int().min(convertEnquiryResponseEnquiryContactAttemptsMin),
  "outcomeReason": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "contact": zod.object({
  "accountId": zod.uuid().nullish(),
  "phone": zod.string().nullish(),
  "mobile": zod.string().nullish(),
  "secondaryEmail": zod.string().nullish(),
  "fax": zod.string().nullish(),
  "department": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "preferredContactMethod": zod.string().nullish(),
  "doNotEmail": zod.boolean().optional(),
  "doNotPhone": zod.boolean().optional(),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(convertEnquiryResponseContactOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "unsubscribedAt": zod.iso.datetime({"offset":true}).nullish(),
  "jobTitle": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).default(convertEnquiryResponseContactOneFocusLevelDefault).describe('Relationship importance, using the same levels as accounts.'),
  "leadScore": zod.int().min(convertEnquiryResponseContactOneLeadScoreMin).max(convertEnquiryResponseContactOneLeadScoreMax).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "email": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "account": zod.object({
  "accountKind": zod.enum(['organization', 'person']),
  "website": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "email": zod.string().nullish(),
  "emailDomain": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "status": zod.string().nullish(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).default(convertEnquiryResponseAccountOneRelationshipTypeDefault),
  "partnerType": zod.union([zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),zod.null()]).optional(),
  "partnerStatus": zod.union([zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),zod.null()]).optional(),
  "organisationType": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().default(convertEnquiryResponseAccountOneShowPricesInQuotesDefault),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "accountNumber": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sector": zod.string().nullish(),
  "source": zod.string().nullish(),
  "isTestData": zod.boolean().default(convertEnquiryResponseAccountOneIsTestDataDefault).describe('Marks test or demo data so production-style lists can exclude it.'),
  "annualRevenue": zod.number().min(convertEnquiryResponseAccountOneAnnualRevenueMin).nullish(),
  "numberOfEmployees": zod.int().min(convertEnquiryResponseAccountOneNumberOfEmployeesMin).nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "emailConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "smsConsent": zod.enum(['unknown', 'opted_in', 'opted_out']),
  "consentSource": zod.string().nullish(),
  "consentUpdatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "investorType": zod.string().nullish(),
  "investmentFocus": zod.string().nullish(),
  "typicalChequeMin": zod.number().min(convertEnquiryResponseAccountOneTypicalChequeMinMin).nullish(),
  "typicalChequeMax": zod.number().min(convertEnquiryResponseAccountOneTypicalChequeMaxMin).nullish(),
  "accreditationStatus": zod.string().nullish(),
  "lastInvestorUpdateAt": zod.iso.datetime({"offset":true}).nullish(),
  "leadScore": zod.int().min(convertEnquiryResponseAccountOneLeadScoreMin).max(convertEnquiryResponseAccountOneLeadScoreMax).nullish(),
  "healthScore": zod.int().min(convertEnquiryResponseAccountOneHealthScoreMin).max(convertEnquiryResponseAccountOneHealthScoreMax).nullish().describe('0-100 composite score computed by account intelligence; staff-editable.'),
  "temperature": zod.enum(['hot', 'warm', 'cool', 'cold', 'new']).optional(),
  "focusLevel": zod.enum(['strategic', 'key', 'growth', 'standard']).optional(),
  "targetSegments": zod.array(zod.enum(['au-federal-defence', 'au-federal-national-security', 'au-federal-services-citizen', 'au-federal-policy-economic', 'au-federal-research-science', 'au-federal-regulator', 'au-federal-other', 'au-state-central', 'au-state-police-justice', 'au-state-health', 'au-state-transport', 'au-state-education', 'au-state-other', 'au-local-government-large', 'au-defence-prime', 'au-defence-supplier', 'au-critical-infra-energy', 'au-critical-infra-water', 'au-critical-infra-telco', 'au-critical-infra-postal-logistics', 'au-bank-tier1', 'au-insurer-tier1', 'au-superannuation', 'au-university-go8', 'au-private-health-tier1', 'uk-public-sector', 'uk-defence', 'ca-public-sector', 'nz-public-sector', 'eu-sovereign-cloud-mover'])).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).optional(),
  "opportunity": zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']),
  "value": zod.number().nullish(),
  "currency": zod.string(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(convertEnquiryResponseOpportunityProbabilityMin).max(convertEnquiryResponseOpportunityProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(convertEnquiryResponseOpportunityIsTestDataDefault),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).optional(),
  "contactCreated": zod.boolean(),
  "accountCreated": zod.boolean(),
  "opportunityCreated": zod.boolean()
})


/**
 * The lead recovery call list: overdue first responses (new, uncontacted, past deadline), stalled conversations (in progress, untouched for a week), and aged new leads (14+ days, never contacted).
 * @summary List inactive-lead recovery segments
 */
export const listStaleEnquiriesResponseSegmentsItemItemsItemContactAttemptsMin = 0;



export const listStaleEnquiriesResponse = zod.object({
  "generatedAt": zod.iso.datetime({"offset":true}),
  "segments": zod.array(zod.object({
  "key": zod.enum(['overdue_first_response', 'stalled_no_decision', 'aged_new']),
  "label": zod.string(),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "phone": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "subject": zod.string(),
  "message": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']),
  "type": zod.enum(['general', 'booking']).describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "bookingProduct": zod.string().nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "assignedTo": zod.string().nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactAttempts": zod.int().min(listStaleEnquiriesResponseSegmentsItemItemsItemContactAttemptsMin),
  "outcomeReason": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))
})


/**
 * Increments the contact-attempt count and stamps the contacted-at clock, so first-response targets and recovery segments stay accurate.
 * @summary Log a contact attempt on an enquiry
 */
export const recordEnquiryContactAttemptParams = zod.object({
  "id": zod.uuid()
})

export const recordEnquiryContactAttemptBodyNoteMax = 500;

export const recordEnquiryContactAttemptBodyByMax = 200;



export const recordEnquiryContactAttemptBody = zod.object({
  "note": zod.string().max(recordEnquiryContactAttemptBodyNoteMax).optional(),
  "by": zod.string().max(recordEnquiryContactAttemptBodyByMax).optional()
})

export const recordEnquiryContactAttemptResponseContactAttemptsMin = 0;



export const recordEnquiryContactAttemptResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "phone": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "subject": zod.string(),
  "message": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']),
  "type": zod.enum(['general', 'booking']).describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "bookingProduct": zod.string().nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "assignedTo": zod.string().nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactAttempts": zod.int().min(recordEnquiryContactAttemptResponseContactAttemptsMin),
  "outcomeReason": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Immutable stage history for an enquiry
 */
export const listEnquiryStatusHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listEnquiryStatusHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "enquiryId": zod.uuid(),
  "fromStatus": zod.union([zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),zod.null()]).optional(),
  "toStatus": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "reason": zod.string().nullish(),
  "changedBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary List the canonical configured CRM journeys
 */
export const listJourneyDefinitionsResponseItemsItemStagesItemOrderMin = 0;

export const listJourneyDefinitionsResponseItemsItemStagesItemServiceExpectationDurationHoursMax = 8760;


export const listJourneyDefinitionsResponseTotalMin = 0;



export const listJourneyDefinitionsResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "label": zod.string(),
  "description": zod.string(),
  "entityType": zod.enum(['enquiry', 'opportunity', 'partner']),
  "initialStageId": zod.string(),
  "appliesTo": zod.record(zod.string(), zod.string()),
  "stages": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "objective": zod.string(),
  "order": zod.int().min(listJourneyDefinitionsResponseItemsItemStagesItemOrderMin),
  "terminal": zod.boolean(),
  "outcome": zod.string().nullish(),
  "requiresOutcomeDetails": zod.boolean(),
  "requirements": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "field": zod.string(),
  "rule": zod.enum(['present', 'min_number']),
  "minimum": zod.number().nullish(),
  "blocking": zod.boolean()
})),
  "transitions": zod.array(zod.string()),
  "ownership": zod.object({
  "field": zod.string(),
  "label": zod.string()
}),
  "serviceExpectation": zod.object({
  "durationHours": zod.int().min(1).max(listJourneyDefinitionsResponseItemsItemStagesItemServiceExpectationDurationHoursMax),
  "label": zod.string()
}),
  "nextActions": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "actionType": zod.string()
}))
})).min(1)
})),
  "total": zod.int().min(listJourneyDefinitionsResponseTotalMin)
})


/**
 * @summary Get evaluated journey state for one CRM record
 */
export const getJourneyRecordParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid()
})

export const getJourneyRecordResponseDefinitionStagesItemOrderMin = 0;

export const getJourneyRecordResponseDefinitionStagesItemServiceExpectationDurationHoursMax = 8760;


export const getJourneyRecordResponseStagesItemOrderMin = 0;



export const getJourneyRecordResponse = zod.object({
  "definition": zod.object({
  "key": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "label": zod.string(),
  "description": zod.string(),
  "entityType": zod.enum(['enquiry', 'opportunity', 'partner']),
  "initialStageId": zod.string(),
  "appliesTo": zod.record(zod.string(), zod.string()),
  "stages": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "objective": zod.string(),
  "order": zod.int().min(getJourneyRecordResponseDefinitionStagesItemOrderMin),
  "terminal": zod.boolean(),
  "outcome": zod.string().nullish(),
  "requiresOutcomeDetails": zod.boolean(),
  "requirements": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "field": zod.string(),
  "rule": zod.enum(['present', 'min_number']),
  "minimum": zod.number().nullish(),
  "blocking": zod.boolean()
})),
  "transitions": zod.array(zod.string()),
  "ownership": zod.object({
  "field": zod.string(),
  "label": zod.string()
}),
  "serviceExpectation": zod.object({
  "durationHours": zod.int().min(1).max(getJourneyRecordResponseDefinitionStagesItemServiceExpectationDurationHoursMax),
  "label": zod.string()
}),
  "nextActions": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "actionType": zod.string()
}))
})).min(1)
}),
  "recordId": zod.uuid(),
  "recordLabel": zod.string(),
  "entityType": zod.enum(['enquiry', 'opportunity', 'partner']),
  "currentStageId": zod.string(),
  "stages": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "objective": zod.string(),
  "order": zod.int().min(getJourneyRecordResponseStagesItemOrderMin),
  "terminal": zod.boolean(),
  "outcome": zod.string().nullish(),
  "status": zod.enum(['completed', 'current', 'upcoming'])
})),
  "requirements": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "field": zod.string(),
  "rule": zod.enum(['present', 'min_number']),
  "minimum": zod.number().nullish(),
  "blocking": zod.boolean()
}).and(zod.object({
  "satisfied": zod.boolean(),
  "detail": zod.string()
}))),
  "validTransitions": zod.array(zod.object({
  "stageId": zod.string(),
  "label": zod.string(),
  "outcome": zod.string().nullish(),
  "blocked": zod.boolean(),
  "requiresOutcomeDetails": zod.boolean(),
  "missingRequirements": zod.array(zod.string())
})),
  "handoffs": zod.array(zod.object({
  "direction": zod.enum(['inbound', 'outbound']),
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid(),
  "recordLabel": zod.string(),
  "stageId": zod.string(),
  "owner": zod.string().nullable(),
  "href": zod.string(),
  "context": zod.string()
})),
  "owner": zod.string().nullable(),
  "startedAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "overdue": zod.boolean(),
  "terminal": zod.boolean()
})


/**
 * @summary Get the read-only customer signal twin for one journey record
 */
export const getJourneyRecordSignalsParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid()
})

export const getJourneyRecordSignalsQueryWindowDefault = `90d`;
export const getJourneyRecordSignalsQueryChannelMax = 100;

export const getJourneyRecordSignalsQueryLimitDefault = 200;
export const getJourneyRecordSignalsQueryLimitMax = 500;

export const getJourneyRecordSignalsQueryOffsetDefault = 0;
export const getJourneyRecordSignalsQueryOffsetMin = 0;



export const getJourneyRecordSignalsQueryParams = zod.object({
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(getJourneyRecordSignalsQueryWindowDefault),
  "channel": zod.string().min(1).max(getJourneyRecordSignalsQueryChannelMax).optional(),
  "limit": zod.int().min(1).max(getJourneyRecordSignalsQueryLimitMax).default(getJourneyRecordSignalsQueryLimitDefault),
  "offset": zod.int().min(getJourneyRecordSignalsQueryOffsetMin).default(getJourneyRecordSignalsQueryOffsetDefault)
})

export const getJourneyRecordSignalsResponseWindowDefault = `90d`;
export const getJourneyRecordSignalsResponseChannelsItemInboundCountMin = 0;

export const getJourneyRecordSignalsResponseChannelsItemOutboundCountMin = 0;


export const getJourneyRecordSignalsResponseSignalsItemPreviewMax = 240;

export const getJourneyRecordSignalsResponseTotalMin = 0;



export const getJourneyRecordSignalsResponse = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid(),
  "recordLabel": zod.string(),
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(getJourneyRecordSignalsResponseWindowDefault),
  "entity": zod.object({
  "enquiryId": zod.uuid().nullable(),
  "contactId": zod.uuid().nullable(),
  "accountId": zod.uuid().nullable(),
  "opportunityIds": zod.array(zod.uuid())
}),
  "channels": zod.array(zod.object({
  "channel": zod.string(),
  "label": zod.string(),
  "inboundCount": zod.int().min(getJourneyRecordSignalsResponseChannelsItemInboundCountMin),
  "outboundCount": zod.int().min(getJourneyRecordSignalsResponseChannelsItemOutboundCountMin),
  "lastAt": zod.iso.datetime({"offset":true}).nullable(),
  "connection": zod.enum(['connected', 'not_configured', 'inbound_unavailable', 'not_applicable'])
})),
  "signals": zod.array(zod.object({
  "id": zod.string().min(1),
  "sourceKind": zod.enum(['interaction', 'telephony_call', 'chat_session', 'social_inbox_item', 'email_message', 'activity', 'enquiry']),
  "channel": zod.string(),
  "type": zod.string(),
  "direction": zod.enum(['inbound', 'outbound', 'internal']),
  "subject": zod.string().nullable(),
  "preview": zod.string().max(getJourneyRecordSignalsResponseSignalsItemPreviewMax),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "stageId": zod.string(),
  "href": zod.string()
})),
  "total": zod.int().min(getJourneyRecordSignalsResponseTotalMin)
})


/**
 * Uses the summary record scope. Sparse UTC buckets include internal activity so counts reconcile. Missing points are zero. Bucket size widens in whole units to keep at most 400 points per series without dropping history.
 * @summary Get historically attributed, bounded signal time series
 */
export const getJourneySignalTimeseriesParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement'])
})

export const getJourneySignalTimeseriesQueryWindowDefault = `90d`;
export const getJourneySignalTimeseriesQueryChannelMax = 100;

export const getJourneySignalTimeseriesQueryIncludeTestDataDefault = false;

export const getJourneySignalTimeseriesQueryParams = zod.object({
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(getJourneySignalTimeseriesQueryWindowDefault),
  "channel": zod.string().min(1).max(getJourneySignalTimeseriesQueryChannelMax).optional(),
  "recordId": zod.uuid().optional(),
  "bucket": zod.enum(['hour', 'day', 'week']).optional(),
  "includeTestData": zod.boolean().default(getJourneySignalTimeseriesQueryIncludeTestDataDefault)
})

export const getJourneySignalTimeseriesResponseWindowDefault = `90d`;
export const getJourneySignalTimeseriesResponseSeriesItemPointsItemInboundMin = 0;

export const getJourneySignalTimeseriesResponseSeriesItemPointsItemOutboundMin = 0;

export const getJourneySignalTimeseriesResponseSeriesItemPointsItemInternalMin = 0;

export const getJourneySignalTimeseriesResponseSeriesItemPointsMax = 400;

export const getJourneySignalTimeseriesResponseTotalsSignalsMin = 0;

export const getJourneySignalTimeseriesResponseTotalsRecordsMin = 0;



export const getJourneySignalTimeseriesResponse = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid().optional(),
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(getJourneySignalTimeseriesResponseWindowDefault),
  "bucket": zod.enum(['hour', 'day', 'week']),
  "bucketSize": zod.int().min(1).describe('Whole bucket units per point; weeks start on Monday UTC. Increases only to preserve the 400-point bound.'),
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "series": zod.array(zod.object({
  "channel": zod.string(),
  "label": zod.string(),
  "stageId": zod.string(),
  "connection": zod.enum(['connected', 'not_configured', 'inbound_unavailable', 'not_applicable']),
  "points": zod.array(zod.object({
  "t": zod.iso.datetime({"offset":true}),
  "inbound": zod.int().min(getJourneySignalTimeseriesResponseSeriesItemPointsItemInboundMin),
  "outbound": zod.int().min(getJourneySignalTimeseriesResponseSeriesItemPointsItemOutboundMin),
  "internal": zod.int().min(getJourneySignalTimeseriesResponseSeriesItemPointsItemInternalMin)
})).max(getJourneySignalTimeseriesResponseSeriesItemPointsMax)
})),
  "totals": zod.object({
  "signals": zod.int().min(getJourneySignalTimeseriesResponseTotalsSignalsMin),
  "records": zod.int().min(getJourneySignalTimeseriesResponseTotalsRecordsMin)
})
})


/**
 * @summary Get bounded stage-by-channel signal totals for a journey
 */
export const getJourneySignalSummaryParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement'])
})

export const getJourneySignalSummaryQueryWindowDefault = `90d`;
export const getJourneySignalSummaryQueryChannelMax = 100;

export const getJourneySignalSummaryQueryIncludeTestDataDefault = false;

export const getJourneySignalSummaryQueryParams = zod.object({
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(getJourneySignalSummaryQueryWindowDefault),
  "channel": zod.string().min(1).max(getJourneySignalSummaryQueryChannelMax).optional(),
  "includeTestData": zod.boolean().default(getJourneySignalSummaryQueryIncludeTestDataDefault)
})

export const getJourneySignalSummaryResponseWindowDefault = `90d`;
export const getJourneySignalSummaryResponseCellsItemInboundCountMin = 0;

export const getJourneySignalSummaryResponseCellsItemOutboundCountMin = 0;

export const getJourneySignalSummaryResponseCellsItemRecordCountMin = 0;


export const getJourneySignalSummaryResponseRecordsMax = 200;

export const getJourneySignalSummaryResponseTotalsSignalsMin = 0;

export const getJourneySignalSummaryResponseTotalsRecordsMin = 0;



export const getJourneySignalSummaryResponse = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(getJourneySignalSummaryResponseWindowDefault),
  "cells": zod.array(zod.object({
  "stageId": zod.string(),
  "channel": zod.string(),
  "inboundCount": zod.int().min(getJourneySignalSummaryResponseCellsItemInboundCountMin),
  "outboundCount": zod.int().min(getJourneySignalSummaryResponseCellsItemOutboundCountMin),
  "recordCount": zod.int().min(getJourneySignalSummaryResponseCellsItemRecordCountMin),
  "lastAt": zod.iso.datetime({"offset":true})
})),
  "records": zod.array(zod.object({
  "recordId": zod.uuid(),
  "recordLabel": zod.string(),
  "stageId": zod.string(),
  "owner": zod.string().nullable(),
  "channel": zod.string(),
  "lastAt": zod.iso.datetime({"offset":true}),
  "signalCount": zod.int().min(1)
})).max(getJourneySignalSummaryResponseRecordsMax),
  "totals": zod.object({
  "signals": zod.int().min(getJourneySignalSummaryResponseTotalsSignalsMin),
  "records": zod.int().min(getJourneySignalSummaryResponseTotalsRecordsMin)
})
})


/**
 * @summary Propose a staff-authored stage instruction for administrator review
 */
export const proposeStageCoachingPathStageIdMax = 100;



export const proposeStageCoachingParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "stageId": zod.string().min(1).max(proposeStageCoachingPathStageIdMax)
})

export const proposeStageCoachingBodyActionTypeMax = 100;

export const proposeStageCoachingBodyTextMax = 2000;



export const proposeStageCoachingBody = zod.object({
  "actionType": zod.string().min(1).max(proposeStageCoachingBodyActionTypeMax),
  "text": zod.string().min(1).max(proposeStageCoachingBodyTextMax)
})

export const proposeStageCoachingResponseDraftVersionMin = 0;

export const proposeStageCoachingResponseEffectiveInstructionVersionMin = 0;



export const proposeStageCoachingResponse = zod.object({
  "draft": zod.object({
  "id": zod.string(),
  "actionType": zod.string(),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "version": zod.int().min(proposeStageCoachingResponseDraftVersionMin),
  "content": zod.string(),
  "note": zod.string(),
  "status": zod.enum(['draft', 'active', 'retired']),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "proposedBy": zod.string().nullable(),
  "proposedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewStatus": zod.union([zod.enum(['awaiting_review', 'activated', 'declined']),zod.null()]),
  "reviewNote": zod.string().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "effectiveInstruction": zod.object({
  "id": zod.string(),
  "actionType": zod.string(),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "version": zod.int().min(proposeStageCoachingResponseEffectiveInstructionVersionMin),
  "content": zod.string(),
  "note": zod.string(),
  "status": zod.enum(['draft', 'active', 'retired']),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "proposedBy": zod.string().nullable(),
  "proposedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewStatus": zod.union([zod.enum(['awaiting_review', 'activated', 'declined']),zod.null()]),
  "reviewNote": zod.string().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable()
})
})


/**
 * @summary List visible coaching proposals and stage-level review counts
 */
export const listJourneyCoachingParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement'])
})

export const listJourneyCoachingQueryLimitDefault = 50;
export const listJourneyCoachingQueryLimitMax = 100;

export const listJourneyCoachingQueryOffsetDefault = 0;
export const listJourneyCoachingQueryOffsetMin = 0;



export const listJourneyCoachingQueryParams = zod.object({
  "status": zod.enum(['awaiting_review', 'activated', 'declined']).optional(),
  "limit": zod.int().min(1).max(listJourneyCoachingQueryLimitMax).default(listJourneyCoachingQueryLimitDefault),
  "offset": zod.int().min(listJourneyCoachingQueryOffsetMin).default(listJourneyCoachingQueryOffsetDefault)
})

export const listJourneyCoachingResponseItemsItemVersionMin = 0;

export const listJourneyCoachingResponseTotalMin = 0;

export const listJourneyCoachingResponseLimitMax = 100;

export const listJourneyCoachingResponseOffsetMin = 0;

export const listJourneyCoachingResponseStageCountsItemAwaitingReviewMin = 0;

export const listJourneyCoachingResponseStageCountsItemActivatedMin = 0;

export const listJourneyCoachingResponseStageCountsItemDeclinedMin = 0;

export const listJourneyCoachingResponseStageCountsItemTotalMin = 0;



export const listJourneyCoachingResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "actionType": zod.string(),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "version": zod.int().min(listJourneyCoachingResponseItemsItemVersionMin),
  "content": zod.string(),
  "note": zod.string(),
  "status": zod.enum(['draft', 'active', 'retired']),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "proposedBy": zod.string().nullable(),
  "proposedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewStatus": zod.union([zod.enum(['awaiting_review', 'activated', 'declined']),zod.null()]),
  "reviewNote": zod.string().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int().min(listJourneyCoachingResponseTotalMin),
  "limit": zod.int().min(1).max(listJourneyCoachingResponseLimitMax),
  "offset": zod.int().min(listJourneyCoachingResponseOffsetMin),
  "stageCounts": zod.array(zod.object({
  "stageId": zod.string(),
  "awaitingReview": zod.int().min(listJourneyCoachingResponseStageCountsItemAwaitingReviewMin),
  "activated": zod.int().min(listJourneyCoachingResponseStageCountsItemActivatedMin),
  "declined": zod.int().min(listJourneyCoachingResponseStageCountsItemDeclinedMin),
  "total": zod.int().min(listJourneyCoachingResponseStageCountsItemTotalMin)
}))
})


/**
 * @summary Add record-only staff context and regenerate governed stage guidance
 */
export const steerJourneyRecordParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid()
})

export const steerJourneyRecordBodyTextMax = 2000;



export const steerJourneyRecordBody = zod.object({
  "text": zod.string().min(1).max(steerJourneyRecordBodyTextMax),
  "itemId": zod.uuid().optional()
})


export const steerJourneyRecordResponseGuidanceActionOneFeedbackOneCommentMax = 1000;


export const steerJourneyRecordResponseAuditFeedbackOneCommentMax = 1000;



export const steerJourneyRecordResponse = zod.object({
  "note": zod.object({
  "id": zod.uuid(),
  "itemId": zod.uuid().nullable(),
  "text": zod.string(),
  "stageId": zod.string(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "guidance": zod.object({
  "status": zod.enum(['empty', 'ready']),
  "guidance": zod.union([zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid(),
  "stageId": zod.string(),
  "availability": zod.enum(['ready', 'blocked']),
  "summary": zod.string(),
  "objective": zod.string(),
  "missingInformation": zod.array(zod.string()),
  "recommendation": zod.union([zod.object({
  "label": zod.string(),
  "description": zod.string(),
  "actionType": zod.string()
}),zod.null()]),
  "rationale": zod.string(),
  "evidenceState": zod.enum(['grounded', 'insufficient', 'crm_only', 'ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence']),
  "evidence": zod.array(zod.object({
  "id": zod.string(),
  "sourceType": zod.enum(['crm_record', 'uploaded_document']),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}),
  "retrievalScore": zod.number().nullable(),
  "href": zod.string()
})),
  "citationIds": zod.array(zod.string()),
  "limitations": zod.array(zod.string()),
  "contextNotes": zod.array(zod.string()),
  "preparedOutput": zod.union([zod.object({
  "title": zod.string(),
  "body": zod.string(),
  "editable": zod.boolean(),
  "editedByUser": zod.boolean()
}),zod.null()]),
  "manualAlternative": zod.string(),
  "generatedAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "action": zod.union([zod.object({
  "id": zod.uuid(),
  "actionType": zod.string(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "status": zod.enum(['executed', 'recommended', 'pending_approval', 'approved', 'rejected', 'deferred', 'dismissed', 'blocked', 'failed']),
  "requestId": zod.uuid().nullish(),
  "journeyKey": zod.union([zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),zod.null()]).optional(),
  "entityType": zod.union([zod.enum(['enquiry', 'opportunity', 'partner']),zod.null()]).optional(),
  "entityId": zod.uuid().nullish(),
  "stageId": zod.string().nullish(),
  "revision": zod.int().min(1),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "input": zod.record(zod.string(), zod.unknown()),
  "output": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestedBy": zod.string().nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "feedback": zod.union([zod.object({
  "rating": zod.enum(['helpful', 'not_helpful']),
  "comment": zod.string().max(steerJourneyRecordResponseGuidanceActionOneFeedbackOneCommentMax).optional()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "replayed": zod.boolean().optional()
}),
  "audit": zod.object({
  "id": zod.uuid(),
  "actionType": zod.string(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "status": zod.enum(['executed', 'recommended', 'pending_approval', 'approved', 'rejected', 'deferred', 'dismissed', 'blocked', 'failed']),
  "requestId": zod.uuid().nullish(),
  "journeyKey": zod.union([zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),zod.null()]).optional(),
  "entityType": zod.union([zod.enum(['enquiry', 'opportunity', 'partner']),zod.null()]).optional(),
  "entityId": zod.uuid().nullish(),
  "stageId": zod.string().nullish(),
  "revision": zod.int().min(1),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "input": zod.record(zod.string(), zod.unknown()),
  "output": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestedBy": zod.string().nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "feedback": zod.union([zod.object({
  "rating": zod.enum(['helpful', 'not_helpful']),
  "comment": zod.string().max(steerJourneyRecordResponseAuditFeedbackOneCommentMax).optional()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
})


/**
 * @summary Read the latest governed AI guidance for the record's current stage
 */
export const getLatestStageGuidanceParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid()
})


export const getLatestStageGuidanceResponseActionOneFeedbackOneCommentMax = 1000;



export const getLatestStageGuidanceResponse = zod.object({
  "status": zod.enum(['empty', 'ready']),
  "guidance": zod.union([zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid(),
  "stageId": zod.string(),
  "availability": zod.enum(['ready', 'blocked']),
  "summary": zod.string(),
  "objective": zod.string(),
  "missingInformation": zod.array(zod.string()),
  "recommendation": zod.union([zod.object({
  "label": zod.string(),
  "description": zod.string(),
  "actionType": zod.string()
}),zod.null()]),
  "rationale": zod.string(),
  "evidenceState": zod.enum(['grounded', 'insufficient', 'crm_only', 'ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence']),
  "evidence": zod.array(zod.object({
  "id": zod.string(),
  "sourceType": zod.enum(['crm_record', 'uploaded_document']),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}),
  "retrievalScore": zod.number().nullable(),
  "href": zod.string()
})),
  "citationIds": zod.array(zod.string()),
  "limitations": zod.array(zod.string()),
  "contextNotes": zod.array(zod.string()),
  "preparedOutput": zod.union([zod.object({
  "title": zod.string(),
  "body": zod.string(),
  "editable": zod.boolean(),
  "editedByUser": zod.boolean()
}),zod.null()]),
  "manualAlternative": zod.string(),
  "generatedAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "action": zod.union([zod.object({
  "id": zod.uuid(),
  "actionType": zod.string(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "status": zod.enum(['executed', 'recommended', 'pending_approval', 'approved', 'rejected', 'deferred', 'dismissed', 'blocked', 'failed']),
  "requestId": zod.uuid().nullish(),
  "journeyKey": zod.union([zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),zod.null()]).optional(),
  "entityType": zod.union([zod.enum(['enquiry', 'opportunity', 'partner']),zod.null()]).optional(),
  "entityId": zod.uuid().nullish(),
  "stageId": zod.string().nullish(),
  "revision": zod.int().min(1),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "input": zod.record(zod.string(), zod.unknown()),
  "output": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestedBy": zod.string().nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "feedback": zod.union([zod.object({
  "rating": zod.enum(['helpful', 'not_helpful']),
  "comment": zod.string().max(getLatestStageGuidanceResponseActionOneFeedbackOneCommentMax).optional()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "replayed": zod.boolean().optional()
})


/**
 * @summary Generate grounded guidance for the current stage under administrator authority policy
 */
export const generateStageGuidanceParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid()
})

export const generateStageGuidanceBodyExpectedStageIdMax = 80;



export const generateStageGuidanceBody = zod.object({
  "requestId": zod.uuid(),
  "expectedStageId": zod.string().min(1).max(generateStageGuidanceBodyExpectedStageIdMax),
  "expectedRecordUpdatedAt": zod.iso.datetime({"offset":true})
})


export const generateStageGuidanceResponseActionOneFeedbackOneCommentMax = 1000;



export const generateStageGuidanceResponse = zod.object({
  "status": zod.enum(['empty', 'ready']),
  "guidance": zod.union([zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid(),
  "stageId": zod.string(),
  "availability": zod.enum(['ready', 'blocked']),
  "summary": zod.string(),
  "objective": zod.string(),
  "missingInformation": zod.array(zod.string()),
  "recommendation": zod.union([zod.object({
  "label": zod.string(),
  "description": zod.string(),
  "actionType": zod.string()
}),zod.null()]),
  "rationale": zod.string(),
  "evidenceState": zod.enum(['grounded', 'insufficient', 'crm_only', 'ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence']),
  "evidence": zod.array(zod.object({
  "id": zod.string(),
  "sourceType": zod.enum(['crm_record', 'uploaded_document']),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}),
  "retrievalScore": zod.number().nullable(),
  "href": zod.string()
})),
  "citationIds": zod.array(zod.string()),
  "limitations": zod.array(zod.string()),
  "contextNotes": zod.array(zod.string()),
  "preparedOutput": zod.union([zod.object({
  "title": zod.string(),
  "body": zod.string(),
  "editable": zod.boolean(),
  "editedByUser": zod.boolean()
}),zod.null()]),
  "manualAlternative": zod.string(),
  "generatedAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "action": zod.union([zod.object({
  "id": zod.uuid(),
  "actionType": zod.string(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "status": zod.enum(['executed', 'recommended', 'pending_approval', 'approved', 'rejected', 'deferred', 'dismissed', 'blocked', 'failed']),
  "requestId": zod.uuid().nullish(),
  "journeyKey": zod.union([zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),zod.null()]).optional(),
  "entityType": zod.union([zod.enum(['enquiry', 'opportunity', 'partner']),zod.null()]).optional(),
  "entityId": zod.uuid().nullish(),
  "stageId": zod.string().nullish(),
  "revision": zod.int().min(1),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "input": zod.record(zod.string(), zod.unknown()),
  "output": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestedBy": zod.string().nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "feedback": zod.union([zod.object({
  "rating": zod.enum(['helpful', 'not_helpful']),
  "comment": zod.string().max(generateStageGuidanceResponseActionOneFeedbackOneCommentMax).optional()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "replayed": zod.boolean().optional()
})


/**
 * @summary List append-only journey transitions and staff steer notes for one CRM record
 */
export const listJourneyTransitionHistoryParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid()
})

export const listJourneyTransitionHistoryQueryLimitDefault = 50;
export const listJourneyTransitionHistoryQueryLimitMax = 100;

export const listJourneyTransitionHistoryQueryOffsetDefault = 0;
export const listJourneyTransitionHistoryQueryOffsetMin = 0;



export const listJourneyTransitionHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listJourneyTransitionHistoryQueryLimitMax).default(listJourneyTransitionHistoryQueryLimitDefault),
  "offset": zod.int().min(listJourneyTransitionHistoryQueryOffsetMin).default(listJourneyTransitionHistoryQueryOffsetDefault)
})

export const listJourneyTransitionHistoryResponseTotalMin = 0;


export const listJourneyTransitionHistoryResponseOffsetMin = 0;



export const listJourneyTransitionHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['transition', 'steer_note']),
  "requestId": zod.uuid(),
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "entityType": zod.enum(['enquiry', 'opportunity', 'partner']),
  "recordId": zod.uuid(),
  "fromStageId": zod.string(),
  "toStageId": zod.string(),
  "outcome": zod.string().nullish(),
  "reason": zod.string().nullish(),
  "changedBy": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "note": zod.string().nullable(),
  "itemId": zod.string().nullable()
})),
  "total": zod.int().min(listJourneyTransitionHistoryResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listJourneyTransitionHistoryResponseOffsetMin)
})


/**
 * @summary Validate and apply one journey transition
 */
export const transitionJourneyRecordParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid()
})

export const transitionJourneyRecordBodyFromStageIdMax = 80;

export const transitionJourneyRecordBodyToStageIdMax = 80;

export const transitionJourneyRecordBodyReasonMax = 500;



export const transitionJourneyRecordBody = zod.object({
  "requestId": zod.uuid(),
  "fromStageId": zod.string().min(1).max(transitionJourneyRecordBodyFromStageIdMax),
  "toStageId": zod.string().min(1).max(transitionJourneyRecordBodyToStageIdMax),
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(1).max(transitionJourneyRecordBodyReasonMax).nullish()
})

export const transitionJourneyRecordResponseStateDefinitionStagesItemOrderMin = 0;

export const transitionJourneyRecordResponseStateDefinitionStagesItemServiceExpectationDurationHoursMax = 8760;


export const transitionJourneyRecordResponseStateStagesItemOrderMin = 0;



export const transitionJourneyRecordResponse = zod.object({
  "state": zod.object({
  "definition": zod.object({
  "key": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "label": zod.string(),
  "description": zod.string(),
  "entityType": zod.enum(['enquiry', 'opportunity', 'partner']),
  "initialStageId": zod.string(),
  "appliesTo": zod.record(zod.string(), zod.string()),
  "stages": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "objective": zod.string(),
  "order": zod.int().min(transitionJourneyRecordResponseStateDefinitionStagesItemOrderMin),
  "terminal": zod.boolean(),
  "outcome": zod.string().nullish(),
  "requiresOutcomeDetails": zod.boolean(),
  "requirements": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "field": zod.string(),
  "rule": zod.enum(['present', 'min_number']),
  "minimum": zod.number().nullish(),
  "blocking": zod.boolean()
})),
  "transitions": zod.array(zod.string()),
  "ownership": zod.object({
  "field": zod.string(),
  "label": zod.string()
}),
  "serviceExpectation": zod.object({
  "durationHours": zod.int().min(1).max(transitionJourneyRecordResponseStateDefinitionStagesItemServiceExpectationDurationHoursMax),
  "label": zod.string()
}),
  "nextActions": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "actionType": zod.string()
}))
})).min(1)
}),
  "recordId": zod.uuid(),
  "recordLabel": zod.string(),
  "entityType": zod.enum(['enquiry', 'opportunity', 'partner']),
  "currentStageId": zod.string(),
  "stages": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "objective": zod.string(),
  "order": zod.int().min(transitionJourneyRecordResponseStateStagesItemOrderMin),
  "terminal": zod.boolean(),
  "outcome": zod.string().nullish(),
  "status": zod.enum(['completed', 'current', 'upcoming'])
})),
  "requirements": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "field": zod.string(),
  "rule": zod.enum(['present', 'min_number']),
  "minimum": zod.number().nullish(),
  "blocking": zod.boolean()
}).and(zod.object({
  "satisfied": zod.boolean(),
  "detail": zod.string()
}))),
  "validTransitions": zod.array(zod.object({
  "stageId": zod.string(),
  "label": zod.string(),
  "outcome": zod.string().nullish(),
  "blocked": zod.boolean(),
  "requiresOutcomeDetails": zod.boolean(),
  "missingRequirements": zod.array(zod.string())
})),
  "handoffs": zod.array(zod.object({
  "direction": zod.enum(['inbound', 'outbound']),
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "recordId": zod.uuid(),
  "recordLabel": zod.string(),
  "stageId": zod.string(),
  "owner": zod.string().nullable(),
  "href": zod.string(),
  "context": zod.string()
})),
  "owner": zod.string().nullable(),
  "startedAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "overdue": zod.boolean(),
  "terminal": zod.boolean()
}),
  "transition": zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['transition', 'steer_note']),
  "requestId": zod.uuid(),
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "entityType": zod.enum(['enquiry', 'opportunity', 'partner']),
  "recordId": zod.uuid(),
  "fromStageId": zod.string(),
  "toStageId": zod.string(),
  "outcome": zod.string().nullish(),
  "reason": zod.string().nullish(),
  "changedBy": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "note": zod.string().nullable(),
  "itemId": zod.string().nullable()
}),
  "replayed": zod.boolean()
})


/**
 * @summary List active entities the signed-in administrator may manage for microsites
 */
export const listMicrositeAdminEntitiesQueryLimitDefault = 50;
export const listMicrositeAdminEntitiesQueryLimitMax = 100;

export const listMicrositeAdminEntitiesQueryOffsetDefault = 0;
export const listMicrositeAdminEntitiesQueryOffsetMin = 0;



export const listMicrositeAdminEntitiesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listMicrositeAdminEntitiesQueryLimitMax).default(listMicrositeAdminEntitiesQueryLimitDefault),
  "offset": zod.int().min(listMicrositeAdminEntitiesQueryOffsetMin).default(listMicrositeAdminEntitiesQueryOffsetDefault)
})

export const listMicrositeAdminEntitiesResponseItemsItemTenantNameMax = 200;

export const listMicrositeAdminEntitiesResponseItemsItemEntityNameMax = 200;

export const listMicrositeAdminEntitiesResponseTotalMin = 0;

export const listMicrositeAdminEntitiesResponseLimitMax = 100;

export const listMicrositeAdminEntitiesResponseOffsetMin = 0;



export const listMicrositeAdminEntitiesResponse = zod.object({
  "items": zod.array(zod.object({
  "tenantId": zod.uuid(),
  "tenantName": zod.string().min(1).max(listMicrositeAdminEntitiesResponseItemsItemTenantNameMax),
  "entityId": zod.uuid(),
  "entityName": zod.string().min(1).max(listMicrositeAdminEntitiesResponseItemsItemEntityNameMax)
})),
  "total": zod.int().min(listMicrositeAdminEntitiesResponseTotalMin),
  "limit": zod.int().min(1).max(listMicrositeAdminEntitiesResponseLimitMax),
  "offset": zod.int().min(listMicrositeAdminEntitiesResponseOffsetMin)
})


/**
 * @summary Get the selected entity's published public microsite address for signed-in staff
 */
export const getEntityMicrositePublicLinkParams = zod.object({
  "entityId": zod.uuid()
})

export const getEntityMicrositePublicLinkResponseSlugMin = 3;
export const getEntityMicrositePublicLinkResponseSlugMax = 80;

export const getEntityMicrositePublicLinkResponseCanonicalHostMax = 253;



export const getEntityMicrositePublicLinkResponse = zod.object({
  "isPublished": zod.boolean(),
  "publicUrl": zod.string().nullable(),
  "slug": zod.string().min(getEntityMicrositePublicLinkResponseSlugMin).max(getEntityMicrositePublicLinkResponseSlugMax),
  "canonicalHost": zod.string().max(getEntityMicrositePublicLinkResponseCanonicalHostMax).optional()
})


/**
 * @summary Get the authorised entity's draft and publication metadata
 */
export const getEntityMicrositeParams = zod.object({
  "entityId": zod.uuid()
})

export const getEntityMicrositeResponsePublicIdentityOneSlugMin = 3;
export const getEntityMicrositeResponsePublicIdentityOneSlugMax = 80;

export const getEntityMicrositeResponsePublicIdentityOneCanonicalHostMax = 253;




export const getEntityMicrositeResponseDraftHeadlineMax = 160;

export const getEntityMicrositeResponseDraftDescriptionMax = 4000;

export const getEntityMicrositeResponseDraftPublicWebsiteUrlMax = 2048;

export const getEntityMicrositeResponseDraftBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponseDraftBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponseDraftBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponseDraftBrandAccentColorDefault = `#111111`;
export const getEntityMicrositeResponseDraftBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponseDraftBrandSurfaceColorDefault = `#ffffff`;
export const getEntityMicrositeResponseDraftBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponseDraftBrandMutedColorDefault = `#f5f5f5`;
export const getEntityMicrositeResponseDraftBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponseDraftBrandHeadingFontDefault = `system-sans`;
export const getEntityMicrositeResponseDraftBrandBodyFontDefault = `system-sans`;
export const getEntityMicrositeResponseDraftBrandTypeScaleDefault = `standard`;
export const getEntityMicrositeResponseDraftBrandSpacingDefault = `standard`;
export const getEntityMicrositeResponseDraftBrandContentWidthDefault = `standard`;
export const getEntityMicrositeResponseDraftBrandLogoTreatmentDefault = `natural`;
export const getEntityMicrositeResponseDraftBrandLogoScaleDefault = `medium`;
export const getEntityMicrositeResponseDraftBrandImageryTreatmentDefault = `natural`;
export const getEntityMicrositeResponseDraftBrandImageShapeDefault = `rounded`;
export const getEntityMicrositeResponseDraftBrandButtonStyleDefault = `solid`;
export const getEntityMicrositeResponseDraftBrandButtonShapeDefault = `rounded`;
export const getEntityMicrositeResponseDraftBrandButtonWeightDefault = `medium`;
export const getEntityMicrositeResponseDraftBrandSurfaceStyleDefault = `bordered`;
export const getEntityMicrositeResponseDraftBrandBorderStyleDefault = `subtle`;
export const getEntityMicrositeResponseDraftBrandRadiusDefault = `medium`;
export const getEntityMicrositeResponseDraftBrandResponsiveLayoutDefault = `adaptive`;
export const getEntityMicrositeResponseDraftBrandHeroAlignmentDefault = `left`;
export const getEntityMicrositeResponseDraftStartingInstructionMax = 4000;

export const getEntityMicrositeResponseDraftPromptChoicesItemLabelMax = 80;

export const getEntityMicrositeResponseDraftPromptChoicesItemInstructionMax = 2000;

export const getEntityMicrositeResponseDraftPromptChoicesMax = 12;


export const getEntityMicrositeResponseDraftApprovedContentItemLabelMax = 160;

export const getEntityMicrositeResponseDraftApprovedContentMax = 100;

export const getEntityMicrositeResponseDraftContactEmailMax = 254;

export const getEntityMicrositeResponseDraftContactPhoneMax = 40;

export const getEntityMicrositeResponseDraftContactAddressMax = 300;

export const getEntityMicrositeResponseDraftEnquiryCallToActionHeadingMax = 140;

export const getEntityMicrositeResponseDraftEnquiryCallToActionLabelMax = 60;

export const getEntityMicrositeResponseDraftEnquiryCallToActionSupportingTextMax = 400;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsMax = 50;

export const getEntityMicrositeResponseDraftLayoutRowsItemColumnsMax = 4;

export const getEntityMicrositeResponseDraftLayoutRowsMax = 50;

export const getEntityMicrositeResponsePublishedOneHeadlineMax = 160;

export const getEntityMicrositeResponsePublishedOneDescriptionMax = 4000;

export const getEntityMicrositeResponsePublishedOnePublicWebsiteUrlMax = 2048;

export const getEntityMicrositeResponsePublishedOneBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponsePublishedOneBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponsePublishedOneBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponsePublishedOneBrandAccentColorDefault = `#111111`;
export const getEntityMicrositeResponsePublishedOneBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponsePublishedOneBrandSurfaceColorDefault = `#ffffff`;
export const getEntityMicrositeResponsePublishedOneBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponsePublishedOneBrandMutedColorDefault = `#f5f5f5`;
export const getEntityMicrositeResponsePublishedOneBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getEntityMicrositeResponsePublishedOneBrandHeadingFontDefault = `system-sans`;
export const getEntityMicrositeResponsePublishedOneBrandBodyFontDefault = `system-sans`;
export const getEntityMicrositeResponsePublishedOneBrandTypeScaleDefault = `standard`;
export const getEntityMicrositeResponsePublishedOneBrandSpacingDefault = `standard`;
export const getEntityMicrositeResponsePublishedOneBrandContentWidthDefault = `standard`;
export const getEntityMicrositeResponsePublishedOneBrandLogoTreatmentDefault = `natural`;
export const getEntityMicrositeResponsePublishedOneBrandLogoScaleDefault = `medium`;
export const getEntityMicrositeResponsePublishedOneBrandImageryTreatmentDefault = `natural`;
export const getEntityMicrositeResponsePublishedOneBrandImageShapeDefault = `rounded`;
export const getEntityMicrositeResponsePublishedOneBrandButtonStyleDefault = `solid`;
export const getEntityMicrositeResponsePublishedOneBrandButtonShapeDefault = `rounded`;
export const getEntityMicrositeResponsePublishedOneBrandButtonWeightDefault = `medium`;
export const getEntityMicrositeResponsePublishedOneBrandSurfaceStyleDefault = `bordered`;
export const getEntityMicrositeResponsePublishedOneBrandBorderStyleDefault = `subtle`;
export const getEntityMicrositeResponsePublishedOneBrandRadiusDefault = `medium`;
export const getEntityMicrositeResponsePublishedOneBrandResponsiveLayoutDefault = `adaptive`;
export const getEntityMicrositeResponsePublishedOneBrandHeroAlignmentDefault = `left`;
export const getEntityMicrositeResponsePublishedOneStartingInstructionMax = 4000;

export const getEntityMicrositeResponsePublishedOnePromptChoicesItemLabelMax = 80;

export const getEntityMicrositeResponsePublishedOnePromptChoicesItemInstructionMax = 2000;

export const getEntityMicrositeResponsePublishedOnePromptChoicesMax = 12;


export const getEntityMicrositeResponsePublishedOneApprovedContentItemLabelMax = 160;

export const getEntityMicrositeResponsePublishedOneApprovedContentMax = 100;

export const getEntityMicrositeResponsePublishedOneContactEmailMax = 254;

export const getEntityMicrositeResponsePublishedOneContactPhoneMax = 40;

export const getEntityMicrositeResponsePublishedOneContactAddressMax = 300;

export const getEntityMicrositeResponsePublishedOneEnquiryCallToActionHeadingMax = 140;

export const getEntityMicrositeResponsePublishedOneEnquiryCallToActionLabelMax = 60;

export const getEntityMicrositeResponsePublishedOneEnquiryCallToActionSupportingTextMax = 400;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsMax = 50;

export const getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsMax = 4;

export const getEntityMicrositeResponsePublishedOneLayoutRowsMax = 50;



export const getEntityMicrositeResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "publicIdentity": zod.object({
  "slug": zod.string().min(getEntityMicrositeResponsePublicIdentityOneSlugMin).max(getEntityMicrositeResponsePublicIdentityOneSlugMax),
  "canonicalHost": zod.string().max(getEntityMicrositeResponsePublicIdentityOneCanonicalHostMax).optional()
}).and(zod.object({
  "status": zod.enum(['disabled', 'active'])
})),
  "revision": zod.int().min(1),
  "draftVersion": zod.int().min(1),
  "publishedVersion": zod.int().min(1).nullish(),
  "isPublished": zod.boolean(),
  "draft": zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(getEntityMicrositeResponseDraftHeadlineMax),
  "description": zod.string().min(1).max(getEntityMicrositeResponseDraftDescriptionMax),
  "publicWebsiteUrl": zod.url().max(getEntityMicrositeResponseDraftPublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(getEntityMicrositeResponseDraftBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(getEntityMicrositeResponseDraftBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(getEntityMicrositeResponseDraftBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(getEntityMicrositeResponseDraftBrandAccentColorRegExp).default(getEntityMicrositeResponseDraftBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(getEntityMicrositeResponseDraftBrandSurfaceColorRegExp).default(getEntityMicrositeResponseDraftBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(getEntityMicrositeResponseDraftBrandMutedColorRegExp).default(getEntityMicrositeResponseDraftBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(getEntityMicrositeResponseDraftBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(getEntityMicrositeResponseDraftBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(getEntityMicrositeResponseDraftBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(getEntityMicrositeResponseDraftBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(getEntityMicrositeResponseDraftBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(getEntityMicrositeResponseDraftBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(getEntityMicrositeResponseDraftBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(getEntityMicrositeResponseDraftBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(getEntityMicrositeResponseDraftBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(getEntityMicrositeResponseDraftBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(getEntityMicrositeResponseDraftBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(getEntityMicrositeResponseDraftBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(getEntityMicrositeResponseDraftBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(getEntityMicrositeResponseDraftBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(getEntityMicrositeResponseDraftBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(getEntityMicrositeResponseDraftBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(getEntityMicrositeResponseDraftBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(getEntityMicrositeResponseDraftStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(getEntityMicrositeResponseDraftPromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(getEntityMicrositeResponseDraftPromptChoicesItemInstructionMax)
})).min(1).max(getEntityMicrositeResponseDraftPromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(getEntityMicrositeResponseDraftApprovedContentItemLabelMax)
})).max(getEntityMicrositeResponseDraftApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(getEntityMicrositeResponseDraftContactEmailMax).optional(),
  "phone": zod.string().max(getEntityMicrositeResponseDraftContactPhoneMax).optional(),
  "address": zod.string().max(getEntityMicrositeResponseDraftContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponseDraftEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(getEntityMicrositeResponseDraftEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(getEntityMicrositeResponseDraftEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(getEntityMicrositeResponseDraftLayoutRowsItemColumnsMax)
})).min(1).max(getEntityMicrositeResponseDraftLayoutRowsMax)
})
}),
  "published": zod.union([zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneHeadlineMax),
  "description": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneDescriptionMax),
  "publicWebsiteUrl": zod.url().max(getEntityMicrositeResponsePublishedOnePublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(getEntityMicrositeResponsePublishedOneBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(getEntityMicrositeResponsePublishedOneBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(getEntityMicrositeResponsePublishedOneBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(getEntityMicrositeResponsePublishedOneBrandAccentColorRegExp).default(getEntityMicrositeResponsePublishedOneBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(getEntityMicrositeResponsePublishedOneBrandSurfaceColorRegExp).default(getEntityMicrositeResponsePublishedOneBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(getEntityMicrositeResponsePublishedOneBrandMutedColorRegExp).default(getEntityMicrositeResponsePublishedOneBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(getEntityMicrositeResponsePublishedOneBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(getEntityMicrositeResponsePublishedOneBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(getEntityMicrositeResponsePublishedOneBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(getEntityMicrositeResponsePublishedOneBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(getEntityMicrositeResponsePublishedOneBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(getEntityMicrositeResponsePublishedOneBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(getEntityMicrositeResponsePublishedOneBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(getEntityMicrositeResponsePublishedOneBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(getEntityMicrositeResponsePublishedOneBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(getEntityMicrositeResponsePublishedOneBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(getEntityMicrositeResponsePublishedOneBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(getEntityMicrositeResponsePublishedOneBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(getEntityMicrositeResponsePublishedOneBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(getEntityMicrositeResponsePublishedOneBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(getEntityMicrositeResponsePublishedOneBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(getEntityMicrositeResponsePublishedOneBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(getEntityMicrositeResponsePublishedOneBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(getEntityMicrositeResponsePublishedOnePromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(getEntityMicrositeResponsePublishedOnePromptChoicesItemInstructionMax)
})).min(1).max(getEntityMicrositeResponsePublishedOnePromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneApprovedContentItemLabelMax)
})).max(getEntityMicrositeResponsePublishedOneApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(getEntityMicrositeResponsePublishedOneContactEmailMax).optional(),
  "phone": zod.string().max(getEntityMicrositeResponsePublishedOneContactPhoneMax).optional(),
  "address": zod.string().max(getEntityMicrositeResponsePublishedOneContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(getEntityMicrositeResponsePublishedOneEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsMax)
})).min(1).max(getEntityMicrositeResponsePublishedOneLayoutRowsMax)
})
}),zod.null()]).optional(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Create or update an entity microsite draft with optimistic concurrency
 */
export const updateEntityMicrositeParams = zod.object({
  "entityId": zod.uuid()
})

export const updateEntityMicrositeBodyRevisionMin = 0;

export const updateEntityMicrositeBodyPublicIdentitySlugMin = 3;
export const updateEntityMicrositeBodyPublicIdentitySlugMax = 80;

export const updateEntityMicrositeBodyPublicIdentityCanonicalHostMax = 253;

export const updateEntityMicrositeBodyConfigurationHeadlineMax = 160;

export const updateEntityMicrositeBodyConfigurationDescriptionMax = 4000;

export const updateEntityMicrositeBodyConfigurationPublicWebsiteUrlMax = 2048;

export const updateEntityMicrositeBodyConfigurationBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeBodyConfigurationBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeBodyConfigurationBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeBodyConfigurationBrandAccentColorDefault = `#111111`;
export const updateEntityMicrositeBodyConfigurationBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeBodyConfigurationBrandSurfaceColorDefault = `#ffffff`;
export const updateEntityMicrositeBodyConfigurationBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeBodyConfigurationBrandMutedColorDefault = `#f5f5f5`;
export const updateEntityMicrositeBodyConfigurationBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeBodyConfigurationBrandHeadingFontDefault = `system-sans`;
export const updateEntityMicrositeBodyConfigurationBrandBodyFontDefault = `system-sans`;
export const updateEntityMicrositeBodyConfigurationBrandTypeScaleDefault = `standard`;
export const updateEntityMicrositeBodyConfigurationBrandSpacingDefault = `standard`;
export const updateEntityMicrositeBodyConfigurationBrandContentWidthDefault = `standard`;
export const updateEntityMicrositeBodyConfigurationBrandLogoTreatmentDefault = `natural`;
export const updateEntityMicrositeBodyConfigurationBrandLogoScaleDefault = `medium`;
export const updateEntityMicrositeBodyConfigurationBrandImageryTreatmentDefault = `natural`;
export const updateEntityMicrositeBodyConfigurationBrandImageShapeDefault = `rounded`;
export const updateEntityMicrositeBodyConfigurationBrandButtonStyleDefault = `solid`;
export const updateEntityMicrositeBodyConfigurationBrandButtonShapeDefault = `rounded`;
export const updateEntityMicrositeBodyConfigurationBrandButtonWeightDefault = `medium`;
export const updateEntityMicrositeBodyConfigurationBrandSurfaceStyleDefault = `bordered`;
export const updateEntityMicrositeBodyConfigurationBrandBorderStyleDefault = `subtle`;
export const updateEntityMicrositeBodyConfigurationBrandRadiusDefault = `medium`;
export const updateEntityMicrositeBodyConfigurationBrandResponsiveLayoutDefault = `adaptive`;
export const updateEntityMicrositeBodyConfigurationBrandHeroAlignmentDefault = `left`;
export const updateEntityMicrositeBodyConfigurationStartingInstructionMax = 4000;

export const updateEntityMicrositeBodyConfigurationPromptChoicesItemLabelMax = 80;

export const updateEntityMicrositeBodyConfigurationPromptChoicesItemInstructionMax = 2000;

export const updateEntityMicrositeBodyConfigurationPromptChoicesMax = 12;


export const updateEntityMicrositeBodyConfigurationApprovedContentItemLabelMax = 160;

export const updateEntityMicrositeBodyConfigurationApprovedContentMax = 100;

export const updateEntityMicrositeBodyConfigurationContactEmailMax = 254;

export const updateEntityMicrositeBodyConfigurationContactPhoneMax = 40;

export const updateEntityMicrositeBodyConfigurationContactAddressMax = 300;

export const updateEntityMicrositeBodyConfigurationEnquiryCallToActionHeadingMax = 140;

export const updateEntityMicrositeBodyConfigurationEnquiryCallToActionLabelMax = 60;

export const updateEntityMicrositeBodyConfigurationEnquiryCallToActionSupportingTextMax = 400;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsMax = 50;

export const updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsMax = 4;

export const updateEntityMicrositeBodyConfigurationLayoutRowsMax = 50;



export const updateEntityMicrositeBody = zod.object({
  "revision": zod.int().min(updateEntityMicrositeBodyRevisionMin),
  "publicIdentity": zod.object({
  "slug": zod.string().min(updateEntityMicrositeBodyPublicIdentitySlugMin).max(updateEntityMicrositeBodyPublicIdentitySlugMax),
  "canonicalHost": zod.string().max(updateEntityMicrositeBodyPublicIdentityCanonicalHostMax).optional()
}),
  "configuration": zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationHeadlineMax),
  "description": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationDescriptionMax),
  "publicWebsiteUrl": zod.url().max(updateEntityMicrositeBodyConfigurationPublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(updateEntityMicrositeBodyConfigurationBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(updateEntityMicrositeBodyConfigurationBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(updateEntityMicrositeBodyConfigurationBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(updateEntityMicrositeBodyConfigurationBrandAccentColorRegExp).default(updateEntityMicrositeBodyConfigurationBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(updateEntityMicrositeBodyConfigurationBrandSurfaceColorRegExp).default(updateEntityMicrositeBodyConfigurationBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(updateEntityMicrositeBodyConfigurationBrandMutedColorRegExp).default(updateEntityMicrositeBodyConfigurationBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(updateEntityMicrositeBodyConfigurationBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(updateEntityMicrositeBodyConfigurationBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(updateEntityMicrositeBodyConfigurationBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(updateEntityMicrositeBodyConfigurationBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(updateEntityMicrositeBodyConfigurationBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(updateEntityMicrositeBodyConfigurationBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(updateEntityMicrositeBodyConfigurationBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(updateEntityMicrositeBodyConfigurationBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(updateEntityMicrositeBodyConfigurationBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(updateEntityMicrositeBodyConfigurationBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(updateEntityMicrositeBodyConfigurationBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(updateEntityMicrositeBodyConfigurationBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(updateEntityMicrositeBodyConfigurationBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(updateEntityMicrositeBodyConfigurationBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(updateEntityMicrositeBodyConfigurationBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(updateEntityMicrositeBodyConfigurationBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(updateEntityMicrositeBodyConfigurationBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationPromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationPromptChoicesItemInstructionMax)
})).min(1).max(updateEntityMicrositeBodyConfigurationPromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationApprovedContentItemLabelMax)
})).max(updateEntityMicrositeBodyConfigurationApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(updateEntityMicrositeBodyConfigurationContactEmailMax).optional(),
  "phone": zod.string().max(updateEntityMicrositeBodyConfigurationContactPhoneMax).optional(),
  "address": zod.string().max(updateEntityMicrositeBodyConfigurationContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(updateEntityMicrositeBodyConfigurationEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsItemColumnsMax)
})).min(1).max(updateEntityMicrositeBodyConfigurationLayoutRowsMax)
})
})
})

export const updateEntityMicrositeResponsePublicIdentityOneSlugMin = 3;
export const updateEntityMicrositeResponsePublicIdentityOneSlugMax = 80;

export const updateEntityMicrositeResponsePublicIdentityOneCanonicalHostMax = 253;




export const updateEntityMicrositeResponseDraftHeadlineMax = 160;

export const updateEntityMicrositeResponseDraftDescriptionMax = 4000;

export const updateEntityMicrositeResponseDraftPublicWebsiteUrlMax = 2048;

export const updateEntityMicrositeResponseDraftBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponseDraftBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponseDraftBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponseDraftBrandAccentColorDefault = `#111111`;
export const updateEntityMicrositeResponseDraftBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponseDraftBrandSurfaceColorDefault = `#ffffff`;
export const updateEntityMicrositeResponseDraftBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponseDraftBrandMutedColorDefault = `#f5f5f5`;
export const updateEntityMicrositeResponseDraftBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponseDraftBrandHeadingFontDefault = `system-sans`;
export const updateEntityMicrositeResponseDraftBrandBodyFontDefault = `system-sans`;
export const updateEntityMicrositeResponseDraftBrandTypeScaleDefault = `standard`;
export const updateEntityMicrositeResponseDraftBrandSpacingDefault = `standard`;
export const updateEntityMicrositeResponseDraftBrandContentWidthDefault = `standard`;
export const updateEntityMicrositeResponseDraftBrandLogoTreatmentDefault = `natural`;
export const updateEntityMicrositeResponseDraftBrandLogoScaleDefault = `medium`;
export const updateEntityMicrositeResponseDraftBrandImageryTreatmentDefault = `natural`;
export const updateEntityMicrositeResponseDraftBrandImageShapeDefault = `rounded`;
export const updateEntityMicrositeResponseDraftBrandButtonStyleDefault = `solid`;
export const updateEntityMicrositeResponseDraftBrandButtonShapeDefault = `rounded`;
export const updateEntityMicrositeResponseDraftBrandButtonWeightDefault = `medium`;
export const updateEntityMicrositeResponseDraftBrandSurfaceStyleDefault = `bordered`;
export const updateEntityMicrositeResponseDraftBrandBorderStyleDefault = `subtle`;
export const updateEntityMicrositeResponseDraftBrandRadiusDefault = `medium`;
export const updateEntityMicrositeResponseDraftBrandResponsiveLayoutDefault = `adaptive`;
export const updateEntityMicrositeResponseDraftBrandHeroAlignmentDefault = `left`;
export const updateEntityMicrositeResponseDraftStartingInstructionMax = 4000;

export const updateEntityMicrositeResponseDraftPromptChoicesItemLabelMax = 80;

export const updateEntityMicrositeResponseDraftPromptChoicesItemInstructionMax = 2000;

export const updateEntityMicrositeResponseDraftPromptChoicesMax = 12;


export const updateEntityMicrositeResponseDraftApprovedContentItemLabelMax = 160;

export const updateEntityMicrositeResponseDraftApprovedContentMax = 100;

export const updateEntityMicrositeResponseDraftContactEmailMax = 254;

export const updateEntityMicrositeResponseDraftContactPhoneMax = 40;

export const updateEntityMicrositeResponseDraftContactAddressMax = 300;

export const updateEntityMicrositeResponseDraftEnquiryCallToActionHeadingMax = 140;

export const updateEntityMicrositeResponseDraftEnquiryCallToActionLabelMax = 60;

export const updateEntityMicrositeResponseDraftEnquiryCallToActionSupportingTextMax = 400;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsMax = 50;

export const updateEntityMicrositeResponseDraftLayoutRowsItemColumnsMax = 4;

export const updateEntityMicrositeResponseDraftLayoutRowsMax = 50;

export const updateEntityMicrositeResponsePublishedOneHeadlineMax = 160;

export const updateEntityMicrositeResponsePublishedOneDescriptionMax = 4000;

export const updateEntityMicrositeResponsePublishedOnePublicWebsiteUrlMax = 2048;

export const updateEntityMicrositeResponsePublishedOneBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponsePublishedOneBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponsePublishedOneBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponsePublishedOneBrandAccentColorDefault = `#111111`;
export const updateEntityMicrositeResponsePublishedOneBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponsePublishedOneBrandSurfaceColorDefault = `#ffffff`;
export const updateEntityMicrositeResponsePublishedOneBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponsePublishedOneBrandMutedColorDefault = `#f5f5f5`;
export const updateEntityMicrositeResponsePublishedOneBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateEntityMicrositeResponsePublishedOneBrandHeadingFontDefault = `system-sans`;
export const updateEntityMicrositeResponsePublishedOneBrandBodyFontDefault = `system-sans`;
export const updateEntityMicrositeResponsePublishedOneBrandTypeScaleDefault = `standard`;
export const updateEntityMicrositeResponsePublishedOneBrandSpacingDefault = `standard`;
export const updateEntityMicrositeResponsePublishedOneBrandContentWidthDefault = `standard`;
export const updateEntityMicrositeResponsePublishedOneBrandLogoTreatmentDefault = `natural`;
export const updateEntityMicrositeResponsePublishedOneBrandLogoScaleDefault = `medium`;
export const updateEntityMicrositeResponsePublishedOneBrandImageryTreatmentDefault = `natural`;
export const updateEntityMicrositeResponsePublishedOneBrandImageShapeDefault = `rounded`;
export const updateEntityMicrositeResponsePublishedOneBrandButtonStyleDefault = `solid`;
export const updateEntityMicrositeResponsePublishedOneBrandButtonShapeDefault = `rounded`;
export const updateEntityMicrositeResponsePublishedOneBrandButtonWeightDefault = `medium`;
export const updateEntityMicrositeResponsePublishedOneBrandSurfaceStyleDefault = `bordered`;
export const updateEntityMicrositeResponsePublishedOneBrandBorderStyleDefault = `subtle`;
export const updateEntityMicrositeResponsePublishedOneBrandRadiusDefault = `medium`;
export const updateEntityMicrositeResponsePublishedOneBrandResponsiveLayoutDefault = `adaptive`;
export const updateEntityMicrositeResponsePublishedOneBrandHeroAlignmentDefault = `left`;
export const updateEntityMicrositeResponsePublishedOneStartingInstructionMax = 4000;

export const updateEntityMicrositeResponsePublishedOnePromptChoicesItemLabelMax = 80;

export const updateEntityMicrositeResponsePublishedOnePromptChoicesItemInstructionMax = 2000;

export const updateEntityMicrositeResponsePublishedOnePromptChoicesMax = 12;


export const updateEntityMicrositeResponsePublishedOneApprovedContentItemLabelMax = 160;

export const updateEntityMicrositeResponsePublishedOneApprovedContentMax = 100;

export const updateEntityMicrositeResponsePublishedOneContactEmailMax = 254;

export const updateEntityMicrositeResponsePublishedOneContactPhoneMax = 40;

export const updateEntityMicrositeResponsePublishedOneContactAddressMax = 300;

export const updateEntityMicrositeResponsePublishedOneEnquiryCallToActionHeadingMax = 140;

export const updateEntityMicrositeResponsePublishedOneEnquiryCallToActionLabelMax = 60;

export const updateEntityMicrositeResponsePublishedOneEnquiryCallToActionSupportingTextMax = 400;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsMax = 50;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsMax = 4;

export const updateEntityMicrositeResponsePublishedOneLayoutRowsMax = 50;



export const updateEntityMicrositeResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "publicIdentity": zod.object({
  "slug": zod.string().min(updateEntityMicrositeResponsePublicIdentityOneSlugMin).max(updateEntityMicrositeResponsePublicIdentityOneSlugMax),
  "canonicalHost": zod.string().max(updateEntityMicrositeResponsePublicIdentityOneCanonicalHostMax).optional()
}).and(zod.object({
  "status": zod.enum(['disabled', 'active'])
})),
  "revision": zod.int().min(1),
  "draftVersion": zod.int().min(1),
  "publishedVersion": zod.int().min(1).nullish(),
  "isPublished": zod.boolean(),
  "draft": zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(updateEntityMicrositeResponseDraftHeadlineMax),
  "description": zod.string().min(1).max(updateEntityMicrositeResponseDraftDescriptionMax),
  "publicWebsiteUrl": zod.url().max(updateEntityMicrositeResponseDraftPublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(updateEntityMicrositeResponseDraftBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(updateEntityMicrositeResponseDraftBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(updateEntityMicrositeResponseDraftBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(updateEntityMicrositeResponseDraftBrandAccentColorRegExp).default(updateEntityMicrositeResponseDraftBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(updateEntityMicrositeResponseDraftBrandSurfaceColorRegExp).default(updateEntityMicrositeResponseDraftBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(updateEntityMicrositeResponseDraftBrandMutedColorRegExp).default(updateEntityMicrositeResponseDraftBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(updateEntityMicrositeResponseDraftBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(updateEntityMicrositeResponseDraftBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(updateEntityMicrositeResponseDraftBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(updateEntityMicrositeResponseDraftBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(updateEntityMicrositeResponseDraftBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(updateEntityMicrositeResponseDraftBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(updateEntityMicrositeResponseDraftBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(updateEntityMicrositeResponseDraftBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(updateEntityMicrositeResponseDraftBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(updateEntityMicrositeResponseDraftBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(updateEntityMicrositeResponseDraftBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(updateEntityMicrositeResponseDraftBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(updateEntityMicrositeResponseDraftBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(updateEntityMicrositeResponseDraftBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(updateEntityMicrositeResponseDraftBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(updateEntityMicrositeResponseDraftBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(updateEntityMicrositeResponseDraftBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(updateEntityMicrositeResponseDraftStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(updateEntityMicrositeResponseDraftPromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(updateEntityMicrositeResponseDraftPromptChoicesItemInstructionMax)
})).min(1).max(updateEntityMicrositeResponseDraftPromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(updateEntityMicrositeResponseDraftApprovedContentItemLabelMax)
})).max(updateEntityMicrositeResponseDraftApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(updateEntityMicrositeResponseDraftContactEmailMax).optional(),
  "phone": zod.string().max(updateEntityMicrositeResponseDraftContactPhoneMax).optional(),
  "address": zod.string().max(updateEntityMicrositeResponseDraftContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponseDraftEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(updateEntityMicrositeResponseDraftEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(updateEntityMicrositeResponseDraftEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(updateEntityMicrositeResponseDraftLayoutRowsItemColumnsMax)
})).min(1).max(updateEntityMicrositeResponseDraftLayoutRowsMax)
})
}),
  "published": zod.union([zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneHeadlineMax),
  "description": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneDescriptionMax),
  "publicWebsiteUrl": zod.url().max(updateEntityMicrositeResponsePublishedOnePublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(updateEntityMicrositeResponsePublishedOneBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(updateEntityMicrositeResponsePublishedOneBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(updateEntityMicrositeResponsePublishedOneBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(updateEntityMicrositeResponsePublishedOneBrandAccentColorRegExp).default(updateEntityMicrositeResponsePublishedOneBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(updateEntityMicrositeResponsePublishedOneBrandSurfaceColorRegExp).default(updateEntityMicrositeResponsePublishedOneBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(updateEntityMicrositeResponsePublishedOneBrandMutedColorRegExp).default(updateEntityMicrositeResponsePublishedOneBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(updateEntityMicrositeResponsePublishedOneBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(updateEntityMicrositeResponsePublishedOneBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(updateEntityMicrositeResponsePublishedOneBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(updateEntityMicrositeResponsePublishedOneBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(updateEntityMicrositeResponsePublishedOneBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(updateEntityMicrositeResponsePublishedOneBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(updateEntityMicrositeResponsePublishedOneBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(updateEntityMicrositeResponsePublishedOneBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(updateEntityMicrositeResponsePublishedOneBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(updateEntityMicrositeResponsePublishedOneBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(updateEntityMicrositeResponsePublishedOneBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(updateEntityMicrositeResponsePublishedOneBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(updateEntityMicrositeResponsePublishedOneBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(updateEntityMicrositeResponsePublishedOneBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(updateEntityMicrositeResponsePublishedOneBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(updateEntityMicrositeResponsePublishedOneBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(updateEntityMicrositeResponsePublishedOneBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOnePromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOnePromptChoicesItemInstructionMax)
})).min(1).max(updateEntityMicrositeResponsePublishedOnePromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneApprovedContentItemLabelMax)
})).max(updateEntityMicrositeResponsePublishedOneApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(updateEntityMicrositeResponsePublishedOneContactEmailMax).optional(),
  "phone": zod.string().max(updateEntityMicrositeResponsePublishedOneContactPhoneMax).optional(),
  "address": zod.string().max(updateEntityMicrositeResponsePublishedOneContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(updateEntityMicrositeResponsePublishedOneEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsMax)
})).min(1).max(updateEntityMicrositeResponsePublishedOneLayoutRowsMax)
})
}),zod.null()]).optional(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List immutable microsite change snapshots
 */
export const listEntityMicrositeVersionsParams = zod.object({
  "entityId": zod.uuid()
})

export const listEntityMicrositeVersionsQueryLimitDefault = 50;
export const listEntityMicrositeVersionsQueryLimitMax = 100;

export const listEntityMicrositeVersionsQueryOffsetDefault = 0;
export const listEntityMicrositeVersionsQueryOffsetMin = 0;



export const listEntityMicrositeVersionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEntityMicrositeVersionsQueryLimitMax).default(listEntityMicrositeVersionsQueryLimitDefault),
  "offset": zod.int().min(listEntityMicrositeVersionsQueryOffsetMin).default(listEntityMicrositeVersionsQueryOffsetDefault)
})




export const listEntityMicrositeVersionsResponseItemsItemDraftHeadlineMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemDraftDescriptionMax = 4000;

export const listEntityMicrositeVersionsResponseItemsItemDraftPublicWebsiteUrlMax = 2048;

export const listEntityMicrositeVersionsResponseItemsItemDraftBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandAccentColorDefault = `#111111`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandSurfaceColorDefault = `#ffffff`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandMutedColorDefault = `#f5f5f5`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandHeadingFontDefault = `system-sans`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandBodyFontDefault = `system-sans`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandTypeScaleDefault = `standard`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandSpacingDefault = `standard`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandContentWidthDefault = `standard`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandLogoTreatmentDefault = `natural`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandLogoScaleDefault = `medium`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandImageryTreatmentDefault = `natural`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandImageShapeDefault = `rounded`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandButtonStyleDefault = `solid`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandButtonShapeDefault = `rounded`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandButtonWeightDefault = `medium`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandSurfaceStyleDefault = `bordered`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandBorderStyleDefault = `subtle`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandRadiusDefault = `medium`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandResponsiveLayoutDefault = `adaptive`;
export const listEntityMicrositeVersionsResponseItemsItemDraftBrandHeroAlignmentDefault = `left`;
export const listEntityMicrositeVersionsResponseItemsItemDraftStartingInstructionMax = 4000;

export const listEntityMicrositeVersionsResponseItemsItemDraftPromptChoicesItemLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemDraftPromptChoicesItemInstructionMax = 2000;

export const listEntityMicrositeVersionsResponseItemsItemDraftPromptChoicesMax = 12;


export const listEntityMicrositeVersionsResponseItemsItemDraftApprovedContentItemLabelMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemDraftApprovedContentMax = 100;

export const listEntityMicrositeVersionsResponseItemsItemDraftContactEmailMax = 254;

export const listEntityMicrositeVersionsResponseItemsItemDraftContactPhoneMax = 40;

export const listEntityMicrositeVersionsResponseItemsItemDraftContactAddressMax = 300;

export const listEntityMicrositeVersionsResponseItemsItemDraftEnquiryCallToActionHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemDraftEnquiryCallToActionLabelMax = 60;

export const listEntityMicrositeVersionsResponseItemsItemDraftEnquiryCallToActionSupportingTextMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsMax = 50;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsMax = 4;

export const listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsMax = 50;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneHeadlineMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneDescriptionMax = 4000;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOnePublicWebsiteUrlMax = 2048;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandAccentColorDefault = `#111111`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandSurfaceColorDefault = `#ffffff`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandMutedColorDefault = `#f5f5f5`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandHeadingFontDefault = `system-sans`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandBodyFontDefault = `system-sans`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandTypeScaleDefault = `standard`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandSpacingDefault = `standard`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandContentWidthDefault = `standard`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandLogoTreatmentDefault = `natural`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandLogoScaleDefault = `medium`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandImageryTreatmentDefault = `natural`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandImageShapeDefault = `rounded`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandButtonStyleDefault = `solid`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandButtonShapeDefault = `rounded`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandButtonWeightDefault = `medium`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandSurfaceStyleDefault = `bordered`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandBorderStyleDefault = `subtle`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandRadiusDefault = `medium`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandResponsiveLayoutDefault = `adaptive`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandHeroAlignmentDefault = `left`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneStartingInstructionMax = 4000;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOnePromptChoicesItemLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOnePromptChoicesItemInstructionMax = 2000;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOnePromptChoicesMax = 12;


export const listEntityMicrositeVersionsResponseItemsItemPublishedOneApprovedContentItemLabelMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneApprovedContentMax = 100;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneContactEmailMax = 254;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneContactPhoneMax = 40;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneContactAddressMax = 300;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneEnquiryCallToActionHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneEnquiryCallToActionLabelMax = 60;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneEnquiryCallToActionSupportingTextMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsMax = 50;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsMax = 4;

export const listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsMax = 50;

export const listEntityMicrositeVersionsResponseTotalMin = 0;

export const listEntityMicrositeVersionsResponseLimitMax = 100;

export const listEntityMicrositeVersionsResponseOffsetMin = 0;



export const listEntityMicrositeVersionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "draftVersion": zod.int().min(1),
  "publishedVersion": zod.int().min(1).nullish(),
  "action": zod.enum(['draft_updated', 'published', 'unpublished']),
  "draft": zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftHeadlineMax),
  "description": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftDescriptionMax),
  "publicWebsiteUrl": zod.url().max(listEntityMicrositeVersionsResponseItemsItemDraftPublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemDraftBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemDraftBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemDraftBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemDraftBrandAccentColorRegExp).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemDraftBrandSurfaceColorRegExp).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemDraftBrandMutedColorRegExp).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(listEntityMicrositeVersionsResponseItemsItemDraftBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftPromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftPromptChoicesItemInstructionMax)
})).min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftPromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftApprovedContentItemLabelMax)
})).max(listEntityMicrositeVersionsResponseItemsItemDraftApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(listEntityMicrositeVersionsResponseItemsItemDraftContactEmailMax).optional(),
  "phone": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftContactPhoneMax).optional(),
  "address": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsItemColumnsMax)
})).min(1).max(listEntityMicrositeVersionsResponseItemsItemDraftLayoutRowsMax)
})
}),
  "published": zod.union([zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneHeadlineMax),
  "description": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneDescriptionMax),
  "publicWebsiteUrl": zod.url().max(listEntityMicrositeVersionsResponseItemsItemPublishedOnePublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandAccentColorRegExp).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandSurfaceColorRegExp).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandMutedColorRegExp).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOnePromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOnePromptChoicesItemInstructionMax)
})).min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOnePromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneApprovedContentItemLabelMax)
})).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneContactEmailMax).optional(),
  "phone": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneContactPhoneMax).optional(),
  "address": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsItemColumnsMax)
})).min(1).max(listEntityMicrositeVersionsResponseItemsItemPublishedOneLayoutRowsMax)
})
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listEntityMicrositeVersionsResponseTotalMin),
  "limit": zod.int().min(1).max(listEntityMicrositeVersionsResponseLimitMax),
  "offset": zod.int().min(listEntityMicrositeVersionsResponseOffsetMin)
})


/**
 * @summary Generate a protected, uncached preview from a validated draft configuration
 */
export const previewEntityMicrositeParams = zod.object({
  "entityId": zod.uuid()
})


export const previewEntityMicrositeBodyConfigurationHeadlineMax = 160;

export const previewEntityMicrositeBodyConfigurationDescriptionMax = 4000;

export const previewEntityMicrositeBodyConfigurationPublicWebsiteUrlMax = 2048;

export const previewEntityMicrositeBodyConfigurationBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const previewEntityMicrositeBodyConfigurationBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const previewEntityMicrositeBodyConfigurationBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const previewEntityMicrositeBodyConfigurationBrandAccentColorDefault = `#111111`;
export const previewEntityMicrositeBodyConfigurationBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const previewEntityMicrositeBodyConfigurationBrandSurfaceColorDefault = `#ffffff`;
export const previewEntityMicrositeBodyConfigurationBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const previewEntityMicrositeBodyConfigurationBrandMutedColorDefault = `#f5f5f5`;
export const previewEntityMicrositeBodyConfigurationBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const previewEntityMicrositeBodyConfigurationBrandHeadingFontDefault = `system-sans`;
export const previewEntityMicrositeBodyConfigurationBrandBodyFontDefault = `system-sans`;
export const previewEntityMicrositeBodyConfigurationBrandTypeScaleDefault = `standard`;
export const previewEntityMicrositeBodyConfigurationBrandSpacingDefault = `standard`;
export const previewEntityMicrositeBodyConfigurationBrandContentWidthDefault = `standard`;
export const previewEntityMicrositeBodyConfigurationBrandLogoTreatmentDefault = `natural`;
export const previewEntityMicrositeBodyConfigurationBrandLogoScaleDefault = `medium`;
export const previewEntityMicrositeBodyConfigurationBrandImageryTreatmentDefault = `natural`;
export const previewEntityMicrositeBodyConfigurationBrandImageShapeDefault = `rounded`;
export const previewEntityMicrositeBodyConfigurationBrandButtonStyleDefault = `solid`;
export const previewEntityMicrositeBodyConfigurationBrandButtonShapeDefault = `rounded`;
export const previewEntityMicrositeBodyConfigurationBrandButtonWeightDefault = `medium`;
export const previewEntityMicrositeBodyConfigurationBrandSurfaceStyleDefault = `bordered`;
export const previewEntityMicrositeBodyConfigurationBrandBorderStyleDefault = `subtle`;
export const previewEntityMicrositeBodyConfigurationBrandRadiusDefault = `medium`;
export const previewEntityMicrositeBodyConfigurationBrandResponsiveLayoutDefault = `adaptive`;
export const previewEntityMicrositeBodyConfigurationBrandHeroAlignmentDefault = `left`;
export const previewEntityMicrositeBodyConfigurationStartingInstructionMax = 4000;

export const previewEntityMicrositeBodyConfigurationPromptChoicesItemLabelMax = 80;

export const previewEntityMicrositeBodyConfigurationPromptChoicesItemInstructionMax = 2000;

export const previewEntityMicrositeBodyConfigurationPromptChoicesMax = 12;


export const previewEntityMicrositeBodyConfigurationApprovedContentItemLabelMax = 160;

export const previewEntityMicrositeBodyConfigurationApprovedContentMax = 100;

export const previewEntityMicrositeBodyConfigurationContactEmailMax = 254;

export const previewEntityMicrositeBodyConfigurationContactPhoneMax = 40;

export const previewEntityMicrositeBodyConfigurationContactAddressMax = 300;

export const previewEntityMicrositeBodyConfigurationEnquiryCallToActionHeadingMax = 140;

export const previewEntityMicrositeBodyConfigurationEnquiryCallToActionLabelMax = 60;

export const previewEntityMicrositeBodyConfigurationEnquiryCallToActionSupportingTextMax = 400;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsMax = 50;

export const previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsMax = 4;

export const previewEntityMicrositeBodyConfigurationLayoutRowsMax = 50;



export const previewEntityMicrositeBody = zod.object({
  "configurationVersion": zod.int().min(1),
  "configuration": zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationHeadlineMax),
  "description": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationDescriptionMax),
  "publicWebsiteUrl": zod.url().max(previewEntityMicrositeBodyConfigurationPublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(previewEntityMicrositeBodyConfigurationBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(previewEntityMicrositeBodyConfigurationBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(previewEntityMicrositeBodyConfigurationBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(previewEntityMicrositeBodyConfigurationBrandAccentColorRegExp).default(previewEntityMicrositeBodyConfigurationBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(previewEntityMicrositeBodyConfigurationBrandSurfaceColorRegExp).default(previewEntityMicrositeBodyConfigurationBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(previewEntityMicrositeBodyConfigurationBrandMutedColorRegExp).default(previewEntityMicrositeBodyConfigurationBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(previewEntityMicrositeBodyConfigurationBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(previewEntityMicrositeBodyConfigurationBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(previewEntityMicrositeBodyConfigurationBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(previewEntityMicrositeBodyConfigurationBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(previewEntityMicrositeBodyConfigurationBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(previewEntityMicrositeBodyConfigurationBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(previewEntityMicrositeBodyConfigurationBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(previewEntityMicrositeBodyConfigurationBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(previewEntityMicrositeBodyConfigurationBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(previewEntityMicrositeBodyConfigurationBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(previewEntityMicrositeBodyConfigurationBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(previewEntityMicrositeBodyConfigurationBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(previewEntityMicrositeBodyConfigurationBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(previewEntityMicrositeBodyConfigurationBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(previewEntityMicrositeBodyConfigurationBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(previewEntityMicrositeBodyConfigurationBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(previewEntityMicrositeBodyConfigurationBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationPromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationPromptChoicesItemInstructionMax)
})).min(1).max(previewEntityMicrositeBodyConfigurationPromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationApprovedContentItemLabelMax)
})).max(previewEntityMicrositeBodyConfigurationApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(previewEntityMicrositeBodyConfigurationContactEmailMax).optional(),
  "phone": zod.string().max(previewEntityMicrositeBodyConfigurationContactPhoneMax).optional(),
  "address": zod.string().max(previewEntityMicrositeBodyConfigurationContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(previewEntityMicrositeBodyConfigurationEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsItemColumnsMax)
})).min(1).max(previewEntityMicrositeBodyConfigurationLayoutRowsMax)
})
}),
  "promptChoiceId": zod.uuid().optional()
})

export const previewEntityMicrositeResponseTitleMax = 160;

export const previewEntityMicrositeResponseIntroMax = 600;

export const previewEntityMicrositeResponseSectionsItemIdMax = 60;


export const previewEntityMicrositeResponseSectionsItemIdRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
export const previewEntityMicrositeResponseSectionsItemHeadingMax = 120;

export const previewEntityMicrositeResponseSectionsItemBodyMax = 4000;

export const previewEntityMicrositeResponseSectionsItemHighlightsItemMax = 240;

export const previewEntityMicrositeResponseSectionsItemHighlightsMax = 6;

export const previewEntityMicrositeResponseSectionsItemCitationIdsItemMax = 80;

export const previewEntityMicrositeResponseSectionsItemCitationIdsMax = 12;

export const previewEntityMicrositeResponseSectionsMax = 8;

export const previewEntityMicrositeResponseSourcesItemIdMax = 80;

export const previewEntityMicrositeResponseSourcesItemLabelMax = 160;


export const previewEntityMicrositeResponseSourcesMax = 100;

export const previewEntityMicrositeResponseNoticeMax = 300;


export const previewEntityMicrositeResponsePromptLabelMax = 80;



export const previewEntityMicrositeResponse = zod.object({
  "title": zod.string().min(1).max(previewEntityMicrositeResponseTitleMax),
  "intro": zod.string().min(1).max(previewEntityMicrositeResponseIntroMax),
  "sections": zod.array(zod.object({
  "id": zod.string().max(previewEntityMicrositeResponseSectionsItemIdMax).regex(previewEntityMicrositeResponseSectionsItemIdRegExp),
  "heading": zod.string().min(1).max(previewEntityMicrositeResponseSectionsItemHeadingMax),
  "body": zod.string().min(1).max(previewEntityMicrositeResponseSectionsItemBodyMax),
  "highlights": zod.array(zod.string().min(1).max(previewEntityMicrositeResponseSectionsItemHighlightsItemMax)).max(previewEntityMicrositeResponseSectionsItemHighlightsMax),
  "citationIds": zod.array(zod.string().min(1).max(previewEntityMicrositeResponseSectionsItemCitationIdsItemMax)).max(previewEntityMicrositeResponseSectionsItemCitationIdsMax)
})).min(1).max(previewEntityMicrositeResponseSectionsMax),
  "sources": zod.array(zod.object({
  "id": zod.string().min(1).max(previewEntityMicrositeResponseSourcesItemIdMax),
  "label": zod.string().min(1).max(previewEntityMicrositeResponseSourcesItemLabelMax),
  "url": zod.url().optional(),
  "version": zod.int().min(1)
})).max(previewEntityMicrositeResponseSourcesMax),
  "generatedBy": zod.enum(['ai', 'fallback']),
  "notice": zod.string().max(previewEntityMicrositeResponseNoticeMax).optional(),
  "configurationVersion": zod.int().min(1),
  "promptChoiceId": zod.uuid().nullable(),
  "promptLabel": zod.string().max(previewEntityMicrositeResponsePromptLabelMax).nullable()
})


/**
 * @summary Atomically publish the current draft snapshot and activate its public binding
 */
export const publishEntityMicrositeParams = zod.object({
  "entityId": zod.uuid()
})




export const publishEntityMicrositeBody = zod.object({
  "revision": zod.int().min(1)
})

export const publishEntityMicrositeResponsePublicIdentityOneSlugMin = 3;
export const publishEntityMicrositeResponsePublicIdentityOneSlugMax = 80;

export const publishEntityMicrositeResponsePublicIdentityOneCanonicalHostMax = 253;




export const publishEntityMicrositeResponseDraftHeadlineMax = 160;

export const publishEntityMicrositeResponseDraftDescriptionMax = 4000;

export const publishEntityMicrositeResponseDraftPublicWebsiteUrlMax = 2048;

export const publishEntityMicrositeResponseDraftBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponseDraftBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponseDraftBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponseDraftBrandAccentColorDefault = `#111111`;
export const publishEntityMicrositeResponseDraftBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponseDraftBrandSurfaceColorDefault = `#ffffff`;
export const publishEntityMicrositeResponseDraftBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponseDraftBrandMutedColorDefault = `#f5f5f5`;
export const publishEntityMicrositeResponseDraftBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponseDraftBrandHeadingFontDefault = `system-sans`;
export const publishEntityMicrositeResponseDraftBrandBodyFontDefault = `system-sans`;
export const publishEntityMicrositeResponseDraftBrandTypeScaleDefault = `standard`;
export const publishEntityMicrositeResponseDraftBrandSpacingDefault = `standard`;
export const publishEntityMicrositeResponseDraftBrandContentWidthDefault = `standard`;
export const publishEntityMicrositeResponseDraftBrandLogoTreatmentDefault = `natural`;
export const publishEntityMicrositeResponseDraftBrandLogoScaleDefault = `medium`;
export const publishEntityMicrositeResponseDraftBrandImageryTreatmentDefault = `natural`;
export const publishEntityMicrositeResponseDraftBrandImageShapeDefault = `rounded`;
export const publishEntityMicrositeResponseDraftBrandButtonStyleDefault = `solid`;
export const publishEntityMicrositeResponseDraftBrandButtonShapeDefault = `rounded`;
export const publishEntityMicrositeResponseDraftBrandButtonWeightDefault = `medium`;
export const publishEntityMicrositeResponseDraftBrandSurfaceStyleDefault = `bordered`;
export const publishEntityMicrositeResponseDraftBrandBorderStyleDefault = `subtle`;
export const publishEntityMicrositeResponseDraftBrandRadiusDefault = `medium`;
export const publishEntityMicrositeResponseDraftBrandResponsiveLayoutDefault = `adaptive`;
export const publishEntityMicrositeResponseDraftBrandHeroAlignmentDefault = `left`;
export const publishEntityMicrositeResponseDraftStartingInstructionMax = 4000;

export const publishEntityMicrositeResponseDraftPromptChoicesItemLabelMax = 80;

export const publishEntityMicrositeResponseDraftPromptChoicesItemInstructionMax = 2000;

export const publishEntityMicrositeResponseDraftPromptChoicesMax = 12;


export const publishEntityMicrositeResponseDraftApprovedContentItemLabelMax = 160;

export const publishEntityMicrositeResponseDraftApprovedContentMax = 100;

export const publishEntityMicrositeResponseDraftContactEmailMax = 254;

export const publishEntityMicrositeResponseDraftContactPhoneMax = 40;

export const publishEntityMicrositeResponseDraftContactAddressMax = 300;

export const publishEntityMicrositeResponseDraftEnquiryCallToActionHeadingMax = 140;

export const publishEntityMicrositeResponseDraftEnquiryCallToActionLabelMax = 60;

export const publishEntityMicrositeResponseDraftEnquiryCallToActionSupportingTextMax = 400;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsMax = 50;

export const publishEntityMicrositeResponseDraftLayoutRowsItemColumnsMax = 4;

export const publishEntityMicrositeResponseDraftLayoutRowsMax = 50;

export const publishEntityMicrositeResponsePublishedOneHeadlineMax = 160;

export const publishEntityMicrositeResponsePublishedOneDescriptionMax = 4000;

export const publishEntityMicrositeResponsePublishedOnePublicWebsiteUrlMax = 2048;

export const publishEntityMicrositeResponsePublishedOneBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponsePublishedOneBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponsePublishedOneBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponsePublishedOneBrandAccentColorDefault = `#111111`;
export const publishEntityMicrositeResponsePublishedOneBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponsePublishedOneBrandSurfaceColorDefault = `#ffffff`;
export const publishEntityMicrositeResponsePublishedOneBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponsePublishedOneBrandMutedColorDefault = `#f5f5f5`;
export const publishEntityMicrositeResponsePublishedOneBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const publishEntityMicrositeResponsePublishedOneBrandHeadingFontDefault = `system-sans`;
export const publishEntityMicrositeResponsePublishedOneBrandBodyFontDefault = `system-sans`;
export const publishEntityMicrositeResponsePublishedOneBrandTypeScaleDefault = `standard`;
export const publishEntityMicrositeResponsePublishedOneBrandSpacingDefault = `standard`;
export const publishEntityMicrositeResponsePublishedOneBrandContentWidthDefault = `standard`;
export const publishEntityMicrositeResponsePublishedOneBrandLogoTreatmentDefault = `natural`;
export const publishEntityMicrositeResponsePublishedOneBrandLogoScaleDefault = `medium`;
export const publishEntityMicrositeResponsePublishedOneBrandImageryTreatmentDefault = `natural`;
export const publishEntityMicrositeResponsePublishedOneBrandImageShapeDefault = `rounded`;
export const publishEntityMicrositeResponsePublishedOneBrandButtonStyleDefault = `solid`;
export const publishEntityMicrositeResponsePublishedOneBrandButtonShapeDefault = `rounded`;
export const publishEntityMicrositeResponsePublishedOneBrandButtonWeightDefault = `medium`;
export const publishEntityMicrositeResponsePublishedOneBrandSurfaceStyleDefault = `bordered`;
export const publishEntityMicrositeResponsePublishedOneBrandBorderStyleDefault = `subtle`;
export const publishEntityMicrositeResponsePublishedOneBrandRadiusDefault = `medium`;
export const publishEntityMicrositeResponsePublishedOneBrandResponsiveLayoutDefault = `adaptive`;
export const publishEntityMicrositeResponsePublishedOneBrandHeroAlignmentDefault = `left`;
export const publishEntityMicrositeResponsePublishedOneStartingInstructionMax = 4000;

export const publishEntityMicrositeResponsePublishedOnePromptChoicesItemLabelMax = 80;

export const publishEntityMicrositeResponsePublishedOnePromptChoicesItemInstructionMax = 2000;

export const publishEntityMicrositeResponsePublishedOnePromptChoicesMax = 12;


export const publishEntityMicrositeResponsePublishedOneApprovedContentItemLabelMax = 160;

export const publishEntityMicrositeResponsePublishedOneApprovedContentMax = 100;

export const publishEntityMicrositeResponsePublishedOneContactEmailMax = 254;

export const publishEntityMicrositeResponsePublishedOneContactPhoneMax = 40;

export const publishEntityMicrositeResponsePublishedOneContactAddressMax = 300;

export const publishEntityMicrositeResponsePublishedOneEnquiryCallToActionHeadingMax = 140;

export const publishEntityMicrositeResponsePublishedOneEnquiryCallToActionLabelMax = 60;

export const publishEntityMicrositeResponsePublishedOneEnquiryCallToActionSupportingTextMax = 400;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsMax = 50;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsMax = 4;

export const publishEntityMicrositeResponsePublishedOneLayoutRowsMax = 50;



export const publishEntityMicrositeResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "publicIdentity": zod.object({
  "slug": zod.string().min(publishEntityMicrositeResponsePublicIdentityOneSlugMin).max(publishEntityMicrositeResponsePublicIdentityOneSlugMax),
  "canonicalHost": zod.string().max(publishEntityMicrositeResponsePublicIdentityOneCanonicalHostMax).optional()
}).and(zod.object({
  "status": zod.enum(['disabled', 'active'])
})),
  "revision": zod.int().min(1),
  "draftVersion": zod.int().min(1),
  "publishedVersion": zod.int().min(1).nullish(),
  "isPublished": zod.boolean(),
  "draft": zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(publishEntityMicrositeResponseDraftHeadlineMax),
  "description": zod.string().min(1).max(publishEntityMicrositeResponseDraftDescriptionMax),
  "publicWebsiteUrl": zod.url().max(publishEntityMicrositeResponseDraftPublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(publishEntityMicrositeResponseDraftBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(publishEntityMicrositeResponseDraftBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(publishEntityMicrositeResponseDraftBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(publishEntityMicrositeResponseDraftBrandAccentColorRegExp).default(publishEntityMicrositeResponseDraftBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(publishEntityMicrositeResponseDraftBrandSurfaceColorRegExp).default(publishEntityMicrositeResponseDraftBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(publishEntityMicrositeResponseDraftBrandMutedColorRegExp).default(publishEntityMicrositeResponseDraftBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(publishEntityMicrositeResponseDraftBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(publishEntityMicrositeResponseDraftBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(publishEntityMicrositeResponseDraftBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(publishEntityMicrositeResponseDraftBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(publishEntityMicrositeResponseDraftBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(publishEntityMicrositeResponseDraftBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(publishEntityMicrositeResponseDraftBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(publishEntityMicrositeResponseDraftBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(publishEntityMicrositeResponseDraftBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(publishEntityMicrositeResponseDraftBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(publishEntityMicrositeResponseDraftBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(publishEntityMicrositeResponseDraftBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(publishEntityMicrositeResponseDraftBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(publishEntityMicrositeResponseDraftBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(publishEntityMicrositeResponseDraftBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(publishEntityMicrositeResponseDraftBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(publishEntityMicrositeResponseDraftBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(publishEntityMicrositeResponseDraftStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(publishEntityMicrositeResponseDraftPromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(publishEntityMicrositeResponseDraftPromptChoicesItemInstructionMax)
})).min(1).max(publishEntityMicrositeResponseDraftPromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(publishEntityMicrositeResponseDraftApprovedContentItemLabelMax)
})).max(publishEntityMicrositeResponseDraftApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(publishEntityMicrositeResponseDraftContactEmailMax).optional(),
  "phone": zod.string().max(publishEntityMicrositeResponseDraftContactPhoneMax).optional(),
  "address": zod.string().max(publishEntityMicrositeResponseDraftContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponseDraftEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(publishEntityMicrositeResponseDraftEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(publishEntityMicrositeResponseDraftEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(publishEntityMicrositeResponseDraftLayoutRowsItemColumnsMax)
})).min(1).max(publishEntityMicrositeResponseDraftLayoutRowsMax)
})
}),
  "published": zod.union([zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneHeadlineMax),
  "description": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneDescriptionMax),
  "publicWebsiteUrl": zod.url().max(publishEntityMicrositeResponsePublishedOnePublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(publishEntityMicrositeResponsePublishedOneBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(publishEntityMicrositeResponsePublishedOneBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(publishEntityMicrositeResponsePublishedOneBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(publishEntityMicrositeResponsePublishedOneBrandAccentColorRegExp).default(publishEntityMicrositeResponsePublishedOneBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(publishEntityMicrositeResponsePublishedOneBrandSurfaceColorRegExp).default(publishEntityMicrositeResponsePublishedOneBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(publishEntityMicrositeResponsePublishedOneBrandMutedColorRegExp).default(publishEntityMicrositeResponsePublishedOneBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(publishEntityMicrositeResponsePublishedOneBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(publishEntityMicrositeResponsePublishedOneBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(publishEntityMicrositeResponsePublishedOneBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(publishEntityMicrositeResponsePublishedOneBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(publishEntityMicrositeResponsePublishedOneBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(publishEntityMicrositeResponsePublishedOneBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(publishEntityMicrositeResponsePublishedOneBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(publishEntityMicrositeResponsePublishedOneBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(publishEntityMicrositeResponsePublishedOneBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(publishEntityMicrositeResponsePublishedOneBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(publishEntityMicrositeResponsePublishedOneBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(publishEntityMicrositeResponsePublishedOneBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(publishEntityMicrositeResponsePublishedOneBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(publishEntityMicrositeResponsePublishedOneBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(publishEntityMicrositeResponsePublishedOneBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(publishEntityMicrositeResponsePublishedOneBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(publishEntityMicrositeResponsePublishedOneBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOnePromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOnePromptChoicesItemInstructionMax)
})).min(1).max(publishEntityMicrositeResponsePublishedOnePromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneApprovedContentItemLabelMax)
})).max(publishEntityMicrositeResponsePublishedOneApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(publishEntityMicrositeResponsePublishedOneContactEmailMax).optional(),
  "phone": zod.string().max(publishEntityMicrositeResponsePublishedOneContactPhoneMax).optional(),
  "address": zod.string().max(publishEntityMicrositeResponsePublishedOneContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(publishEntityMicrositeResponsePublishedOneEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsMax)
})).min(1).max(publishEntityMicrositeResponsePublishedOneLayoutRowsMax)
})
}),zod.null()]).optional(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Disable public access without deleting draft or published history
 */
export const unpublishEntityMicrositeParams = zod.object({
  "entityId": zod.uuid()
})




export const unpublishEntityMicrositeBody = zod.object({
  "revision": zod.int().min(1)
})

export const unpublishEntityMicrositeResponsePublicIdentityOneSlugMin = 3;
export const unpublishEntityMicrositeResponsePublicIdentityOneSlugMax = 80;

export const unpublishEntityMicrositeResponsePublicIdentityOneCanonicalHostMax = 253;




export const unpublishEntityMicrositeResponseDraftHeadlineMax = 160;

export const unpublishEntityMicrositeResponseDraftDescriptionMax = 4000;

export const unpublishEntityMicrositeResponseDraftPublicWebsiteUrlMax = 2048;

export const unpublishEntityMicrositeResponseDraftBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponseDraftBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponseDraftBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponseDraftBrandAccentColorDefault = `#111111`;
export const unpublishEntityMicrositeResponseDraftBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponseDraftBrandSurfaceColorDefault = `#ffffff`;
export const unpublishEntityMicrositeResponseDraftBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponseDraftBrandMutedColorDefault = `#f5f5f5`;
export const unpublishEntityMicrositeResponseDraftBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponseDraftBrandHeadingFontDefault = `system-sans`;
export const unpublishEntityMicrositeResponseDraftBrandBodyFontDefault = `system-sans`;
export const unpublishEntityMicrositeResponseDraftBrandTypeScaleDefault = `standard`;
export const unpublishEntityMicrositeResponseDraftBrandSpacingDefault = `standard`;
export const unpublishEntityMicrositeResponseDraftBrandContentWidthDefault = `standard`;
export const unpublishEntityMicrositeResponseDraftBrandLogoTreatmentDefault = `natural`;
export const unpublishEntityMicrositeResponseDraftBrandLogoScaleDefault = `medium`;
export const unpublishEntityMicrositeResponseDraftBrandImageryTreatmentDefault = `natural`;
export const unpublishEntityMicrositeResponseDraftBrandImageShapeDefault = `rounded`;
export const unpublishEntityMicrositeResponseDraftBrandButtonStyleDefault = `solid`;
export const unpublishEntityMicrositeResponseDraftBrandButtonShapeDefault = `rounded`;
export const unpublishEntityMicrositeResponseDraftBrandButtonWeightDefault = `medium`;
export const unpublishEntityMicrositeResponseDraftBrandSurfaceStyleDefault = `bordered`;
export const unpublishEntityMicrositeResponseDraftBrandBorderStyleDefault = `subtle`;
export const unpublishEntityMicrositeResponseDraftBrandRadiusDefault = `medium`;
export const unpublishEntityMicrositeResponseDraftBrandResponsiveLayoutDefault = `adaptive`;
export const unpublishEntityMicrositeResponseDraftBrandHeroAlignmentDefault = `left`;
export const unpublishEntityMicrositeResponseDraftStartingInstructionMax = 4000;

export const unpublishEntityMicrositeResponseDraftPromptChoicesItemLabelMax = 80;

export const unpublishEntityMicrositeResponseDraftPromptChoicesItemInstructionMax = 2000;

export const unpublishEntityMicrositeResponseDraftPromptChoicesMax = 12;


export const unpublishEntityMicrositeResponseDraftApprovedContentItemLabelMax = 160;

export const unpublishEntityMicrositeResponseDraftApprovedContentMax = 100;

export const unpublishEntityMicrositeResponseDraftContactEmailMax = 254;

export const unpublishEntityMicrositeResponseDraftContactPhoneMax = 40;

export const unpublishEntityMicrositeResponseDraftContactAddressMax = 300;

export const unpublishEntityMicrositeResponseDraftEnquiryCallToActionHeadingMax = 140;

export const unpublishEntityMicrositeResponseDraftEnquiryCallToActionLabelMax = 60;

export const unpublishEntityMicrositeResponseDraftEnquiryCallToActionSupportingTextMax = 400;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsMax = 50;

export const unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsMax = 4;

export const unpublishEntityMicrositeResponseDraftLayoutRowsMax = 50;

export const unpublishEntityMicrositeResponsePublishedOneHeadlineMax = 160;

export const unpublishEntityMicrositeResponsePublishedOneDescriptionMax = 4000;

export const unpublishEntityMicrositeResponsePublishedOnePublicWebsiteUrlMax = 2048;

export const unpublishEntityMicrositeResponsePublishedOneBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponsePublishedOneBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponsePublishedOneBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponsePublishedOneBrandAccentColorDefault = `#111111`;
export const unpublishEntityMicrositeResponsePublishedOneBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponsePublishedOneBrandSurfaceColorDefault = `#ffffff`;
export const unpublishEntityMicrositeResponsePublishedOneBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponsePublishedOneBrandMutedColorDefault = `#f5f5f5`;
export const unpublishEntityMicrositeResponsePublishedOneBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const unpublishEntityMicrositeResponsePublishedOneBrandHeadingFontDefault = `system-sans`;
export const unpublishEntityMicrositeResponsePublishedOneBrandBodyFontDefault = `system-sans`;
export const unpublishEntityMicrositeResponsePublishedOneBrandTypeScaleDefault = `standard`;
export const unpublishEntityMicrositeResponsePublishedOneBrandSpacingDefault = `standard`;
export const unpublishEntityMicrositeResponsePublishedOneBrandContentWidthDefault = `standard`;
export const unpublishEntityMicrositeResponsePublishedOneBrandLogoTreatmentDefault = `natural`;
export const unpublishEntityMicrositeResponsePublishedOneBrandLogoScaleDefault = `medium`;
export const unpublishEntityMicrositeResponsePublishedOneBrandImageryTreatmentDefault = `natural`;
export const unpublishEntityMicrositeResponsePublishedOneBrandImageShapeDefault = `rounded`;
export const unpublishEntityMicrositeResponsePublishedOneBrandButtonStyleDefault = `solid`;
export const unpublishEntityMicrositeResponsePublishedOneBrandButtonShapeDefault = `rounded`;
export const unpublishEntityMicrositeResponsePublishedOneBrandButtonWeightDefault = `medium`;
export const unpublishEntityMicrositeResponsePublishedOneBrandSurfaceStyleDefault = `bordered`;
export const unpublishEntityMicrositeResponsePublishedOneBrandBorderStyleDefault = `subtle`;
export const unpublishEntityMicrositeResponsePublishedOneBrandRadiusDefault = `medium`;
export const unpublishEntityMicrositeResponsePublishedOneBrandResponsiveLayoutDefault = `adaptive`;
export const unpublishEntityMicrositeResponsePublishedOneBrandHeroAlignmentDefault = `left`;
export const unpublishEntityMicrositeResponsePublishedOneStartingInstructionMax = 4000;

export const unpublishEntityMicrositeResponsePublishedOnePromptChoicesItemLabelMax = 80;

export const unpublishEntityMicrositeResponsePublishedOnePromptChoicesItemInstructionMax = 2000;

export const unpublishEntityMicrositeResponsePublishedOnePromptChoicesMax = 12;


export const unpublishEntityMicrositeResponsePublishedOneApprovedContentItemLabelMax = 160;

export const unpublishEntityMicrositeResponsePublishedOneApprovedContentMax = 100;

export const unpublishEntityMicrositeResponsePublishedOneContactEmailMax = 254;

export const unpublishEntityMicrositeResponsePublishedOneContactPhoneMax = 40;

export const unpublishEntityMicrositeResponsePublishedOneContactAddressMax = 300;

export const unpublishEntityMicrositeResponsePublishedOneEnquiryCallToActionHeadingMax = 140;

export const unpublishEntityMicrositeResponsePublishedOneEnquiryCallToActionLabelMax = 60;

export const unpublishEntityMicrositeResponsePublishedOneEnquiryCallToActionSupportingTextMax = 400;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsMax = 50;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsMax = 4;

export const unpublishEntityMicrositeResponsePublishedOneLayoutRowsMax = 50;



export const unpublishEntityMicrositeResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "publicIdentity": zod.object({
  "slug": zod.string().min(unpublishEntityMicrositeResponsePublicIdentityOneSlugMin).max(unpublishEntityMicrositeResponsePublicIdentityOneSlugMax),
  "canonicalHost": zod.string().max(unpublishEntityMicrositeResponsePublicIdentityOneCanonicalHostMax).optional()
}).and(zod.object({
  "status": zod.enum(['disabled', 'active'])
})),
  "revision": zod.int().min(1),
  "draftVersion": zod.int().min(1),
  "publishedVersion": zod.int().min(1).nullish(),
  "isPublished": zod.boolean(),
  "draft": zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftHeadlineMax),
  "description": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftDescriptionMax),
  "publicWebsiteUrl": zod.url().max(unpublishEntityMicrositeResponseDraftPublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(unpublishEntityMicrositeResponseDraftBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(unpublishEntityMicrositeResponseDraftBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(unpublishEntityMicrositeResponseDraftBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(unpublishEntityMicrositeResponseDraftBrandAccentColorRegExp).default(unpublishEntityMicrositeResponseDraftBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(unpublishEntityMicrositeResponseDraftBrandSurfaceColorRegExp).default(unpublishEntityMicrositeResponseDraftBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(unpublishEntityMicrositeResponseDraftBrandMutedColorRegExp).default(unpublishEntityMicrositeResponseDraftBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(unpublishEntityMicrositeResponseDraftBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(unpublishEntityMicrositeResponseDraftBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(unpublishEntityMicrositeResponseDraftBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(unpublishEntityMicrositeResponseDraftBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(unpublishEntityMicrositeResponseDraftBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(unpublishEntityMicrositeResponseDraftBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(unpublishEntityMicrositeResponseDraftBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(unpublishEntityMicrositeResponseDraftBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(unpublishEntityMicrositeResponseDraftBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(unpublishEntityMicrositeResponseDraftBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(unpublishEntityMicrositeResponseDraftBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(unpublishEntityMicrositeResponseDraftBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(unpublishEntityMicrositeResponseDraftBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(unpublishEntityMicrositeResponseDraftBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(unpublishEntityMicrositeResponseDraftBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(unpublishEntityMicrositeResponseDraftBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(unpublishEntityMicrositeResponseDraftBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftPromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftPromptChoicesItemInstructionMax)
})).min(1).max(unpublishEntityMicrositeResponseDraftPromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftApprovedContentItemLabelMax)
})).max(unpublishEntityMicrositeResponseDraftApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(unpublishEntityMicrositeResponseDraftContactEmailMax).optional(),
  "phone": zod.string().max(unpublishEntityMicrositeResponseDraftContactPhoneMax).optional(),
  "address": zod.string().max(unpublishEntityMicrositeResponseDraftContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(unpublishEntityMicrositeResponseDraftEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsItemColumnsMax)
})).min(1).max(unpublishEntityMicrositeResponseDraftLayoutRowsMax)
})
}),
  "published": zod.union([zod.object({
  "schemaVersion": zod.literal(2),
  "headline": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneHeadlineMax),
  "description": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneDescriptionMax),
  "publicWebsiteUrl": zod.url().max(unpublishEntityMicrositeResponsePublishedOnePublicWebsiteUrlMax),
  "brand": zod.object({
  "logoAssetId": zod.uuid().nullish(),
  "heroAssetId": zod.uuid().nullish(),
  "primaryColor": zod.string().regex(unpublishEntityMicrositeResponsePublishedOneBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(unpublishEntityMicrositeResponsePublishedOneBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(unpublishEntityMicrositeResponsePublishedOneBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(unpublishEntityMicrositeResponsePublishedOneBrandAccentColorRegExp).default(unpublishEntityMicrositeResponsePublishedOneBrandAccentColorDefault),
  "surfaceColor": zod.string().regex(unpublishEntityMicrositeResponsePublishedOneBrandSurfaceColorRegExp).default(unpublishEntityMicrositeResponsePublishedOneBrandSurfaceColorDefault),
  "mutedColor": zod.string().regex(unpublishEntityMicrositeResponsePublishedOneBrandMutedColorRegExp).default(unpublishEntityMicrositeResponsePublishedOneBrandMutedColorDefault),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(unpublishEntityMicrositeResponsePublishedOneBrandHeadingFontDefault),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).default(unpublishEntityMicrositeResponsePublishedOneBrandBodyFontDefault),
  "typeScale": zod.enum(['compact', 'standard', 'large']).default(unpublishEntityMicrositeResponsePublishedOneBrandTypeScaleDefault),
  "spacing": zod.enum(['compact', 'standard', 'generous']).default(unpublishEntityMicrositeResponsePublishedOneBrandSpacingDefault),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).default(unpublishEntityMicrositeResponsePublishedOneBrandContentWidthDefault),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).default(unpublishEntityMicrositeResponsePublishedOneBrandLogoTreatmentDefault),
  "logoScale": zod.enum(['small', 'medium', 'large']).default(unpublishEntityMicrositeResponsePublishedOneBrandLogoScaleDefault),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).default(unpublishEntityMicrositeResponsePublishedOneBrandImageryTreatmentDefault),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).default(unpublishEntityMicrositeResponsePublishedOneBrandImageShapeDefault),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).default(unpublishEntityMicrositeResponsePublishedOneBrandButtonStyleDefault),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).default(unpublishEntityMicrositeResponsePublishedOneBrandButtonShapeDefault),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).default(unpublishEntityMicrositeResponsePublishedOneBrandButtonWeightDefault),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).default(unpublishEntityMicrositeResponsePublishedOneBrandSurfaceStyleDefault),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).default(unpublishEntityMicrositeResponsePublishedOneBrandBorderStyleDefault),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).default(unpublishEntityMicrositeResponsePublishedOneBrandRadiusDefault),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).default(unpublishEntityMicrositeResponsePublishedOneBrandResponsiveLayoutDefault),
  "heroAlignment": zod.enum(['left', 'center']).default(unpublishEntityMicrositeResponsePublishedOneBrandHeroAlignmentDefault)
}),
  "startingInstruction": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneStartingInstructionMax),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOnePromptChoicesItemLabelMax),
  "instruction": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOnePromptChoicesItemInstructionMax)
})).min(1).max(unpublishEntityMicrositeResponsePublishedOnePromptChoicesMax),
  "approvedContent": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneApprovedContentItemLabelMax)
})).max(unpublishEntityMicrositeResponsePublishedOneApprovedContentMax),
  "contact": zod.object({
  "email": zod.email().max(unpublishEntityMicrositeResponsePublishedOneContactEmailMax).optional(),
  "phone": zod.string().max(unpublishEntityMicrositeResponsePublishedOneContactPhoneMax).optional(),
  "address": zod.string().max(unpublishEntityMicrositeResponsePublishedOneContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(unpublishEntityMicrositeResponsePublishedOneEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsItemColumnsMax)
})).min(1).max(unpublishEntityMicrositeResponsePublishedOneLayoutRowsMax)
})
}),zod.null()]).optional(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List entity-scoped logo and hero assets
 */
export const listEntityMicrositeAssetsParams = zod.object({
  "entityId": zod.uuid()
})

export const listEntityMicrositeAssetsQueryLimitDefault = 50;
export const listEntityMicrositeAssetsQueryLimitMax = 100;

export const listEntityMicrositeAssetsQueryOffsetDefault = 0;
export const listEntityMicrositeAssetsQueryOffsetMin = 0;



export const listEntityMicrositeAssetsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEntityMicrositeAssetsQueryLimitMax).default(listEntityMicrositeAssetsQueryLimitDefault),
  "offset": zod.int().min(listEntityMicrositeAssetsQueryOffsetMin).default(listEntityMicrositeAssetsQueryOffsetDefault)
})

export const listEntityMicrositeAssetsResponseItemsItemSizeBytesMax = 8388608;

export const listEntityMicrositeAssetsResponseTotalMin = 0;

export const listEntityMicrositeAssetsResponseLimitMax = 100;

export const listEntityMicrositeAssetsResponseOffsetMin = 0;



export const listEntityMicrositeAssetsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['logo', 'hero']),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(1).max(listEntityMicrositeAssetsResponseItemsItemSizeBytesMax),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listEntityMicrositeAssetsResponseTotalMin),
  "limit": zod.int().min(1).max(listEntityMicrositeAssetsResponseLimitMax),
  "offset": zod.int().min(listEntityMicrositeAssetsResponseOffsetMin)
})


/**
 * @summary Upload an entity-scoped logo or hero image
 */
export const uploadEntityMicrositeAssetParams = zod.object({
  "entityId": zod.uuid()
})

export const uploadEntityMicrositeAssetQueryParams = zod.object({
  "kind": zod.enum(['logo', 'hero'])
})

export const uploadEntityMicrositeAssetBody = zod.object({
  "file": zod.instanceof(Blob)
})

export const uploadEntityMicrositeAssetResponseSizeBytesMax = 8388608;



export const uploadEntityMicrositeAssetResponse = zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['logo', 'hero']),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(1).max(uploadEntityMicrositeAssetResponseSizeBytesMax),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Download an asset only within its resolved entity scope
 */
export const getEntityMicrositeAssetParams = zod.object({
  "entityId": zod.uuid(),
  "assetId": zod.uuid()
})

export const getEntityMicrositeAssetResponse = zod.unknown()


/**
 * @summary Delete an unused draft asset within its resolved entity scope
 */
export const deleteEntityMicrositeAssetParams = zod.object({
  "entityId": zod.uuid(),
  "assetId": zod.uuid()
})

export const deleteEntityMicrositeAssetResponse = zod.void()


/**
 * @summary List source registrations and review status in the authorised entity scope
 */
export const listEntityMicrositeSourcesParams = zod.object({
  "entityId": zod.uuid()
})

export const listEntityMicrositeSourcesQueryLimitDefault = 50;
export const listEntityMicrositeSourcesQueryLimitMax = 100;

export const listEntityMicrositeSourcesQueryOffsetDefault = 0;
export const listEntityMicrositeSourcesQueryOffsetMin = 0;



export const listEntityMicrositeSourcesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEntityMicrositeSourcesQueryLimitMax).default(listEntityMicrositeSourcesQueryLimitDefault),
  "offset": zod.int().min(listEntityMicrositeSourcesQueryOffsetMin).default(listEntityMicrositeSourcesQueryOffsetDefault)
})

export const listEntityMicrositeSourcesResponseItemsItemLabelMax = 160;




export const listEntityMicrositeSourcesResponseTotalMin = 0;

export const listEntityMicrositeSourcesResponseLimitMax = 100;

export const listEntityMicrositeSourcesResponseOffsetMin = 0;



export const listEntityMicrositeSourcesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "label": zod.string().min(1).max(listEntityMicrositeSourcesResponseItemsItemLabelMax),
  "url": zod.url().nullish(),
  "status": zod.enum(['pending', 'refreshing', 'ready', 'failed']),
  "revision": zod.int().min(1),
  "latestVersion": zod.int().min(1).nullish(),
  "approvedVersion": zod.int().min(1).nullish(),
  "lastRefreshRequestedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastCompletedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listEntityMicrositeSourcesResponseTotalMin),
  "limit": zod.int().min(1).max(listEntityMicrositeSourcesResponseLimitMax),
  "offset": zod.int().min(listEntityMicrositeSourcesResponseOffsetMin)
})


/**
 * @summary Register a bounded website source or stage administrator-supplied content for review
 */
export const createEntityMicrositeSourceParams = zod.object({
  "entityId": zod.uuid()
})

export const createEntityMicrositeSourceBodyLabelMax = 160;

export const createEntityMicrositeSourceBodyUrlMax = 2048;

export const createEntityMicrositeSourceBodyContentMax = 160000;



export const createEntityMicrositeSourceBody = zod.object({
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "label": zod.string().min(1).max(createEntityMicrositeSourceBodyLabelMax),
  "url": zod.url().max(createEntityMicrositeSourceBodyUrlMax).optional(),
  "content": zod.string().min(1).max(createEntityMicrositeSourceBodyContentMax).optional()
})

export const createEntityMicrositeSourceResponseLabelMax = 160;






export const createEntityMicrositeSourceResponse = zod.object({
  "id": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "label": zod.string().min(1).max(createEntityMicrositeSourceResponseLabelMax),
  "url": zod.url().nullish(),
  "status": zod.enum(['pending', 'refreshing', 'ready', 'failed']),
  "revision": zod.int().min(1),
  "latestVersion": zod.int().min(1).nullish(),
  "approvedVersion": zod.int().min(1).nullish(),
  "lastRefreshRequestedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastCompletedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Review immutable fetched or supplied source versions
 */
export const listEntityMicrositeSourceVersionsParams = zod.object({
  "entityId": zod.uuid(),
  "sourceId": zod.uuid()
})

export const listEntityMicrositeSourceVersionsQueryLimitDefault = 50;
export const listEntityMicrositeSourceVersionsQueryLimitMax = 100;

export const listEntityMicrositeSourceVersionsQueryOffsetDefault = 0;
export const listEntityMicrositeSourceVersionsQueryOffsetMin = 0;



export const listEntityMicrositeSourceVersionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEntityMicrositeSourceVersionsQueryLimitMax).default(listEntityMicrositeSourceVersionsQueryLimitDefault),
  "offset": zod.int().min(listEntityMicrositeSourceVersionsQueryOffsetMin).default(listEntityMicrositeSourceVersionsQueryOffsetDefault)
})


export const listEntityMicrositeSourceVersionsResponseItemsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityMicrositeSourceVersionsResponseItemsItemPagesItemTitleMax = 200;

export const listEntityMicrositeSourceVersionsResponseItemsItemPagesItemTextMax = 160000;

export const listEntityMicrositeSourceVersionsResponseItemsItemPagesItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityMicrositeSourceVersionsResponseItemsItemPagesMax = 5;

export const listEntityMicrositeSourceVersionsResponseItemsItemTotalBytesMax = 2097152;

export const listEntityMicrositeSourceVersionsResponseItemsItemPageCountMax = 5;

export const listEntityMicrositeSourceVersionsResponseTotalMin = 0;

export const listEntityMicrositeSourceVersionsResponseLimitMax = 100;

export const listEntityMicrositeSourceVersionsResponseOffsetMin = 0;



export const listEntityMicrositeSourceVersionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "version": zod.int().min(1),
  "contentHash": zod.string().regex(listEntityMicrositeSourceVersionsResponseItemsItemContentHashRegExp),
  "pages": zod.array(zod.object({
  "url": zod.url().optional(),
  "title": zod.string().min(1).max(listEntityMicrositeSourceVersionsResponseItemsItemPagesItemTitleMax),
  "text": zod.string().min(1).max(listEntityMicrositeSourceVersionsResponseItemsItemPagesItemTextMax),
  "contentHash": zod.string().regex(listEntityMicrositeSourceVersionsResponseItemsItemPagesItemContentHashRegExp)
})).min(1).max(listEntityMicrositeSourceVersionsResponseItemsItemPagesMax),
  "totalBytes": zod.int().min(1).max(listEntityMicrositeSourceVersionsResponseItemsItemTotalBytesMax),
  "pageCount": zod.int().min(1).max(listEntityMicrositeSourceVersionsResponseItemsItemPageCountMax),
  "reviewStatus": zod.enum(['pending', 'approved', 'rejected']),
  "fetchedAt": zod.iso.datetime({"offset":true}),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "total": zod.int().min(listEntityMicrositeSourceVersionsResponseTotalMin),
  "limit": zod.int().min(1).max(listEntityMicrositeSourceVersionsResponseLimitMax),
  "offset": zod.int().min(listEntityMicrositeSourceVersionsResponseOffsetMin)
})


/**
 * @summary Fetch a website source within private-network, redirect, crawl, type, size, timeout, and rate boundaries
 */
export const refreshEntityMicrositeSourceParams = zod.object({
  "entityId": zod.uuid(),
  "sourceId": zod.uuid()
})




export const refreshEntityMicrositeSourceBody = zod.object({
  "revision": zod.int().min(1)
})

export const refreshEntityMicrositeSourceResponseLabelMax = 160;






export const refreshEntityMicrositeSourceResponse = zod.object({
  "id": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "label": zod.string().min(1).max(refreshEntityMicrositeSourceResponseLabelMax),
  "url": zod.url().nullish(),
  "status": zod.enum(['pending', 'refreshing', 'ready', 'failed']),
  "revision": zod.int().min(1),
  "latestVersion": zod.int().min(1).nullish(),
  "approvedVersion": zod.int().min(1).nullish(),
  "lastRefreshRequestedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastCompletedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Approve or reject one immutable source version with optimistic concurrency
 */
export const reviewEntityMicrositeSourceParams = zod.object({
  "entityId": zod.uuid(),
  "sourceId": zod.uuid()
})





export const reviewEntityMicrositeSourceBody = zod.object({
  "revision": zod.int().min(1),
  "version": zod.int().min(1),
  "decision": zod.enum(['approve', 'reject'])
})

export const reviewEntityMicrositeSourceResponseLabelMax = 160;






export const reviewEntityMicrositeSourceResponse = zod.object({
  "id": zod.uuid(),
  "sourceType": zod.enum(['website', 'document', 'manual']),
  "label": zod.string().min(1).max(reviewEntityMicrositeSourceResponseLabelMax),
  "url": zod.url().nullish(),
  "status": zod.enum(['pending', 'refreshing', 'ready', 'failed']),
  "revision": zod.int().min(1),
  "latestVersion": zod.int().min(1).nullish(),
  "approvedVersion": zod.int().min(1).nullish(),
  "lastRefreshRequestedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastCompletedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List private immutable brand-analysis sources in the authorised entity scope
 */
export const listEntityMicrositeBrandSourcesParams = zod.object({
  "entityId": zod.uuid()
})

export const listEntityMicrositeBrandSourcesQueryLimitDefault = 50;
export const listEntityMicrositeBrandSourcesQueryLimitMax = 100;

export const listEntityMicrositeBrandSourcesQueryOffsetDefault = 0;
export const listEntityMicrositeBrandSourcesQueryOffsetMin = 0;



export const listEntityMicrositeBrandSourcesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEntityMicrositeBrandSourcesQueryLimitMax).default(listEntityMicrositeBrandSourcesQueryLimitDefault),
  "offset": zod.int().min(listEntityMicrositeBrandSourcesQueryOffsetMin).default(listEntityMicrositeBrandSourcesQueryOffsetDefault)
})

export const listEntityMicrositeBrandSourcesHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const listEntityMicrositeBrandSourcesHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(listEntityMicrositeBrandSourcesHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})


export const listEntityMicrositeBrandSourcesResponseItemsItemLabelMax = 200;

export const listEntityMicrositeBrandSourcesResponseItemsItemFilenameMax = 200;

export const listEntityMicrositeBrandSourcesResponseItemsItemContentTypeMax = 200;

export const listEntityMicrositeBrandSourcesResponseItemsItemSizeBytesMax = 8388608;

export const listEntityMicrositeBrandSourcesResponseItemsItemFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const listEntityMicrositeBrandSourcesResponseItemsItemEvidenceItemIdMax = 80;

export const listEntityMicrositeBrandSourcesResponseItemsItemEvidenceItemPropertyMax = 80;

export const listEntityMicrositeBrandSourcesResponseItemsItemEvidenceItemLocationMax = 500;

export const listEntityMicrositeBrandSourcesResponseItemsItemEvidenceMax = 200;

export const listEntityMicrositeBrandSourcesResponseItemsItemVisualEvidenceReasonMax = 300;

export const listEntityMicrositeBrandSourcesResponseItemsItemVisualEvidenceEmbeddedImageCountMin = 0;
export const listEntityMicrositeBrandSourcesResponseItemsItemVisualEvidenceEmbeddedImageCountMax = 20;

export const listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemIdMax = 80;

export const listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemUrlMax = 2048;

export const listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemSizeBytesMax = 1048576;

export const listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemLocationMax = 500;

export const listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesMax = 8;

export const listEntityMicrositeBrandSourcesResponseTotalMin = 0;

export const listEntityMicrositeBrandSourcesResponseLimitMax = 100;

export const listEntityMicrositeBrandSourcesResponseOffsetMin = 0;



export const listEntityMicrositeBrandSourcesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['style_guide', 'website']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(listEntityMicrositeBrandSourcesResponseItemsItemLabelMax),
  "url": zod.url().nullish(),
  "filename": zod.string().max(listEntityMicrositeBrandSourcesResponseItemsItemFilenameMax).nullish(),
  "contentType": zod.string().max(listEntityMicrositeBrandSourcesResponseItemsItemContentTypeMax).nullish(),
  "sizeBytes": zod.int().min(1).max(listEntityMicrositeBrandSourcesResponseItemsItemSizeBytesMax).nullish(),
  "fingerprint": zod.string().regex(listEntityMicrositeBrandSourcesResponseItemsItemFingerprintRegExp),
  "evidence": zod.array(zod.object({
  "id": zod.string().min(1).max(listEntityMicrositeBrandSourcesResponseItemsItemEvidenceItemIdMax),
  "property": zod.string().min(1).max(listEntityMicrositeBrandSourcesResponseItemsItemEvidenceItemPropertyMax),
  "value": zod.unknown().nullable(),
  "sourceKind": zod.enum(['style_guide', 'website']),
  "location": zod.string().min(1).max(listEntityMicrositeBrandSourcesResponseItemsItemEvidenceItemLocationMax),
  "state": zod.enum(['evidence', 'inferred', 'missing'])
})).max(listEntityMicrositeBrandSourcesResponseItemsItemEvidenceMax),
  "visualEvidence": zod.object({
  "state": zod.enum(['available', 'unavailable']),
  "reason": zod.string().max(listEntityMicrositeBrandSourcesResponseItemsItemVisualEvidenceReasonMax).optional(),
  "embeddedImageCount": zod.int().min(listEntityMicrositeBrandSourcesResponseItemsItemVisualEvidenceEmbeddedImageCountMin).max(listEntityMicrositeBrandSourcesResponseItemsItemVisualEvidenceEmbeddedImageCountMax)
}),
  "assetCandidates": zod.array(zod.object({
  "id": zod.string().min(1).max(listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemIdMax),
  "url": zod.url().max(listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemUrlMax),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemSizeBytesMax),
  "fingerprint": zod.string().regex(listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemFingerprintRegExp),
  "location": zod.string().min(1).max(listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesItemLocationMax)
})).max(listEntityMicrositeBrandSourcesResponseItemsItemAssetCandidatesMax),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listEntityMicrositeBrandSourcesResponseTotalMin),
  "limit": zod.int().min(1).max(listEntityMicrositeBrandSourcesResponseLimitMax),
  "offset": zod.int().min(listEntityMicrositeBrandSourcesResponseOffsetMin)
})


/**
 * @summary Privately upload and extract one bounded organisation style guide
 */
export const uploadEntityMicrositeBrandGuideParams = zod.object({
  "entityId": zod.uuid()
})

export const uploadEntityMicrositeBrandGuideHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const uploadEntityMicrositeBrandGuideHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(uploadEntityMicrositeBrandGuideHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const uploadEntityMicrositeBrandGuideBody = zod.object({
  "file": zod.instanceof(Blob)
})


export const uploadEntityMicrositeBrandGuideResponseLabelMax = 200;

export const uploadEntityMicrositeBrandGuideResponseFilenameMax = 200;

export const uploadEntityMicrositeBrandGuideResponseContentTypeMax = 200;

export const uploadEntityMicrositeBrandGuideResponseSizeBytesMax = 8388608;

export const uploadEntityMicrositeBrandGuideResponseFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const uploadEntityMicrositeBrandGuideResponseEvidenceItemIdMax = 80;

export const uploadEntityMicrositeBrandGuideResponseEvidenceItemPropertyMax = 80;

export const uploadEntityMicrositeBrandGuideResponseEvidenceItemLocationMax = 500;

export const uploadEntityMicrositeBrandGuideResponseEvidenceMax = 200;

export const uploadEntityMicrositeBrandGuideResponseVisualEvidenceReasonMax = 300;

export const uploadEntityMicrositeBrandGuideResponseVisualEvidenceEmbeddedImageCountMin = 0;
export const uploadEntityMicrositeBrandGuideResponseVisualEvidenceEmbeddedImageCountMax = 20;

export const uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemIdMax = 80;

export const uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemUrlMax = 2048;

export const uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemSizeBytesMax = 1048576;

export const uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemLocationMax = 500;

export const uploadEntityMicrositeBrandGuideResponseAssetCandidatesMax = 8;



export const uploadEntityMicrositeBrandGuideResponse = zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['style_guide', 'website']),
  "version": zod.int().min(1),
  "label": zod.string().min(1).max(uploadEntityMicrositeBrandGuideResponseLabelMax),
  "url": zod.url().nullish(),
  "filename": zod.string().max(uploadEntityMicrositeBrandGuideResponseFilenameMax).nullish(),
  "contentType": zod.string().max(uploadEntityMicrositeBrandGuideResponseContentTypeMax).nullish(),
  "sizeBytes": zod.int().min(1).max(uploadEntityMicrositeBrandGuideResponseSizeBytesMax).nullish(),
  "fingerprint": zod.string().regex(uploadEntityMicrositeBrandGuideResponseFingerprintRegExp),
  "evidence": zod.array(zod.object({
  "id": zod.string().min(1).max(uploadEntityMicrositeBrandGuideResponseEvidenceItemIdMax),
  "property": zod.string().min(1).max(uploadEntityMicrositeBrandGuideResponseEvidenceItemPropertyMax),
  "value": zod.unknown().nullable(),
  "sourceKind": zod.enum(['style_guide', 'website']),
  "location": zod.string().min(1).max(uploadEntityMicrositeBrandGuideResponseEvidenceItemLocationMax),
  "state": zod.enum(['evidence', 'inferred', 'missing'])
})).max(uploadEntityMicrositeBrandGuideResponseEvidenceMax),
  "visualEvidence": zod.object({
  "state": zod.enum(['available', 'unavailable']),
  "reason": zod.string().max(uploadEntityMicrositeBrandGuideResponseVisualEvidenceReasonMax).optional(),
  "embeddedImageCount": zod.int().min(uploadEntityMicrositeBrandGuideResponseVisualEvidenceEmbeddedImageCountMin).max(uploadEntityMicrositeBrandGuideResponseVisualEvidenceEmbeddedImageCountMax)
}),
  "assetCandidates": zod.array(zod.object({
  "id": zod.string().min(1).max(uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemIdMax),
  "url": zod.url().max(uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemUrlMax),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemSizeBytesMax),
  "fingerprint": zod.string().regex(uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemFingerprintRegExp),
  "location": zod.string().min(1).max(uploadEntityMicrositeBrandGuideResponseAssetCandidatesItemLocationMax)
})).max(uploadEntityMicrositeBrandGuideResponseAssetCandidatesMax),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List bounded review-only brand analysis jobs
 */
export const listEntityMicrositeBrandProposalsParams = zod.object({
  "entityId": zod.uuid()
})

export const listEntityMicrositeBrandProposalsQueryLimitDefault = 50;
export const listEntityMicrositeBrandProposalsQueryLimitMax = 100;

export const listEntityMicrositeBrandProposalsQueryOffsetDefault = 0;
export const listEntityMicrositeBrandProposalsQueryOffsetMin = 0;



export const listEntityMicrositeBrandProposalsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEntityMicrositeBrandProposalsQueryLimitMax).default(listEntityMicrositeBrandProposalsQueryLimitDefault),
  "offset": zod.int().min(listEntityMicrositeBrandProposalsQueryOffsetMin).default(listEntityMicrositeBrandProposalsQueryOffsetDefault)
})

export const listEntityMicrositeBrandProposalsResponseItemsItemRevisionMin = 0;


export const listEntityMicrositeBrandProposalsResponseItemsItemSourceIdsMax = 2;

export const listEntityMicrositeBrandProposalsResponseItemsItemSourceFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const listEntityMicrositeBrandProposalsResponseItemsItemDraftFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemPropertyMax = 80;

export const listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemEvidenceIdsItemMax = 80;

export const listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemEvidenceIdsMax = 20;

export const listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemRequestedFontMax = 120;

export const listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemSubstitutionMax = 120;

export const listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsMax = 30;

export const listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemIdMax = 80;

export const listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemPropertyMax = 80;

export const listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemGuideEvidenceIdMax = 80;

export const listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemGuideLocationMax = 500;

export const listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemWebsiteEvidenceIdMax = 80;

export const listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemWebsiteLocationMax = 500;

export const listEntityMicrositeBrandProposalsResponseItemsItemConflictsMax = 30;

export const listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemIdMax = 80;

export const listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemUrlMax = 2048;

export const listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemSizeBytesMax = 1048576;

export const listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemLocationMax = 500;

export const listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesMax = 8;

export const listEntityMicrositeBrandProposalsResponseItemsItemErrorCodeMax = 100;

export const listEntityMicrositeBrandProposalsResponseItemsItemErrorMessageMax = 300;

export const listEntityMicrositeBrandProposalsResponseTotalMin = 0;

export const listEntityMicrositeBrandProposalsResponseLimitMax = 100;

export const listEntityMicrositeBrandProposalsResponseOffsetMin = 0;



export const listEntityMicrositeBrandProposalsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "revision": zod.int().min(listEntityMicrositeBrandProposalsResponseItemsItemRevisionMin),
  "attempt": zod.int().min(1),
  "sourceIds": zod.array(zod.uuid()).min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemSourceIdsMax),
  "sourceFingerprint": zod.string().regex(listEntityMicrositeBrandProposalsResponseItemsItemSourceFingerprintRegExp),
  "draftFingerprint": zod.string().regex(listEntityMicrositeBrandProposalsResponseItemsItemDraftFingerprintRegExp),
  "suggestions": zod.array(zod.object({
  "property": zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemPropertyMax),
  "value": zod.unknown().nullable(),
  "state": zod.enum(['evidence', 'inferred', 'missing']),
  "evidenceIds": zod.array(zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemEvidenceIdsItemMax)).max(listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemEvidenceIdsMax),
  "requestedFont": zod.string().max(listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemRequestedFontMax).optional(),
  "substitution": zod.string().max(listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsItemSubstitutionMax).optional()
})).max(listEntityMicrositeBrandProposalsResponseItemsItemSuggestionsMax),
  "conflicts": zod.array(zod.object({
  "id": zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemIdMax),
  "property": zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemPropertyMax),
  "guideEvidenceId": zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemGuideEvidenceIdMax),
  "guideValue": zod.unknown().nullable(),
  "guideLocation": zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemGuideLocationMax),
  "websiteEvidenceId": zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemWebsiteEvidenceIdMax),
  "websiteValue": zod.unknown().nullable(),
  "websiteLocation": zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemConflictsItemWebsiteLocationMax),
  "resolution": zod.union([zod.object({
  "choice": zod.enum(['guide', 'website', 'custom', 'keep_current']),
  "customValue": zod.unknown().nullish()
}),zod.null()])
})).max(listEntityMicrositeBrandProposalsResponseItemsItemConflictsMax),
  "assetCandidates": zod.array(zod.object({
  "id": zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemIdMax),
  "url": zod.url().max(listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemUrlMax),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemSizeBytesMax),
  "fingerprint": zod.string().regex(listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemFingerprintRegExp),
  "location": zod.string().min(1).max(listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesItemLocationMax)
})).max(listEntityMicrositeBrandProposalsResponseItemsItemAssetCandidatesMax),
  "allConflictsResolved": zod.boolean(),
  "stale": zod.boolean(),
  "errorCode": zod.string().max(listEntityMicrositeBrandProposalsResponseItemsItemErrorCodeMax).nullable(),
  "errorMessage": zod.string().max(listEntityMicrositeBrandProposalsResponseItemsItemErrorMessageMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listEntityMicrositeBrandProposalsResponseTotalMin),
  "limit": zod.int().min(1).max(listEntityMicrositeBrandProposalsResponseLimitMax),
  "offset": zod.int().min(listEntityMicrositeBrandProposalsResponseOffsetMin)
})


/**
 * @summary Analyse a private style guide, a public website, or both without changing the draft
 */
export const createEntityMicrositeBrandProposalParams = zod.object({
  "entityId": zod.uuid()
})

export const createEntityMicrositeBrandProposalBodyOneWebsiteUrlMax = 2048;


export const createEntityMicrositeBrandProposalBodyTwoWebsiteUrlMax = 2048;


export const createEntityMicrositeBrandProposalBodyThreeWebsiteUrlMax = 2048;




export const createEntityMicrositeBrandProposalBody = zod.union([zod.object({
  "styleGuideSourceId": zod.uuid(),
  "websiteUrl": zod.url().max(createEntityMicrositeBrandProposalBodyOneWebsiteUrlMax).optional(),
  "expectedMicrositeRevision": zod.int().min(1).optional()
}),zod.object({
  "styleGuideSourceId": zod.uuid().optional(),
  "websiteUrl": zod.url().max(createEntityMicrositeBrandProposalBodyTwoWebsiteUrlMax),
  "expectedMicrositeRevision": zod.int().min(1).optional()
})]).and(zod.object({
  "styleGuideSourceId": zod.uuid().optional(),
  "websiteUrl": zod.url().max(createEntityMicrositeBrandProposalBodyThreeWebsiteUrlMax).optional(),
  "expectedMicrositeRevision": zod.int().min(1)
}))

export const createEntityMicrositeBrandProposalResponseRevisionMin = 0;


export const createEntityMicrositeBrandProposalResponseSourceIdsMax = 2;

export const createEntityMicrositeBrandProposalResponseSourceFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const createEntityMicrositeBrandProposalResponseDraftFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const createEntityMicrositeBrandProposalResponseSuggestionsItemPropertyMax = 80;

export const createEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsItemMax = 80;

export const createEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsMax = 20;

export const createEntityMicrositeBrandProposalResponseSuggestionsItemRequestedFontMax = 120;

export const createEntityMicrositeBrandProposalResponseSuggestionsItemSubstitutionMax = 120;

export const createEntityMicrositeBrandProposalResponseSuggestionsMax = 30;

export const createEntityMicrositeBrandProposalResponseConflictsItemIdMax = 80;

export const createEntityMicrositeBrandProposalResponseConflictsItemPropertyMax = 80;

export const createEntityMicrositeBrandProposalResponseConflictsItemGuideEvidenceIdMax = 80;

export const createEntityMicrositeBrandProposalResponseConflictsItemGuideLocationMax = 500;

export const createEntityMicrositeBrandProposalResponseConflictsItemWebsiteEvidenceIdMax = 80;

export const createEntityMicrositeBrandProposalResponseConflictsItemWebsiteLocationMax = 500;

export const createEntityMicrositeBrandProposalResponseConflictsMax = 30;

export const createEntityMicrositeBrandProposalResponseAssetCandidatesItemIdMax = 80;

export const createEntityMicrositeBrandProposalResponseAssetCandidatesItemUrlMax = 2048;

export const createEntityMicrositeBrandProposalResponseAssetCandidatesItemSizeBytesMax = 1048576;

export const createEntityMicrositeBrandProposalResponseAssetCandidatesItemFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const createEntityMicrositeBrandProposalResponseAssetCandidatesItemLocationMax = 500;

export const createEntityMicrositeBrandProposalResponseAssetCandidatesMax = 8;

export const createEntityMicrositeBrandProposalResponseErrorCodeMax = 100;

export const createEntityMicrositeBrandProposalResponseErrorMessageMax = 300;



export const createEntityMicrositeBrandProposalResponse = zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "revision": zod.int().min(createEntityMicrositeBrandProposalResponseRevisionMin),
  "attempt": zod.int().min(1),
  "sourceIds": zod.array(zod.uuid()).min(1).max(createEntityMicrositeBrandProposalResponseSourceIdsMax),
  "sourceFingerprint": zod.string().regex(createEntityMicrositeBrandProposalResponseSourceFingerprintRegExp),
  "draftFingerprint": zod.string().regex(createEntityMicrositeBrandProposalResponseDraftFingerprintRegExp),
  "suggestions": zod.array(zod.object({
  "property": zod.string().min(1).max(createEntityMicrositeBrandProposalResponseSuggestionsItemPropertyMax),
  "value": zod.unknown().nullable(),
  "state": zod.enum(['evidence', 'inferred', 'missing']),
  "evidenceIds": zod.array(zod.string().min(1).max(createEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsItemMax)).max(createEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsMax),
  "requestedFont": zod.string().max(createEntityMicrositeBrandProposalResponseSuggestionsItemRequestedFontMax).optional(),
  "substitution": zod.string().max(createEntityMicrositeBrandProposalResponseSuggestionsItemSubstitutionMax).optional()
})).max(createEntityMicrositeBrandProposalResponseSuggestionsMax),
  "conflicts": zod.array(zod.object({
  "id": zod.string().min(1).max(createEntityMicrositeBrandProposalResponseConflictsItemIdMax),
  "property": zod.string().min(1).max(createEntityMicrositeBrandProposalResponseConflictsItemPropertyMax),
  "guideEvidenceId": zod.string().min(1).max(createEntityMicrositeBrandProposalResponseConflictsItemGuideEvidenceIdMax),
  "guideValue": zod.unknown().nullable(),
  "guideLocation": zod.string().min(1).max(createEntityMicrositeBrandProposalResponseConflictsItemGuideLocationMax),
  "websiteEvidenceId": zod.string().min(1).max(createEntityMicrositeBrandProposalResponseConflictsItemWebsiteEvidenceIdMax),
  "websiteValue": zod.unknown().nullable(),
  "websiteLocation": zod.string().min(1).max(createEntityMicrositeBrandProposalResponseConflictsItemWebsiteLocationMax),
  "resolution": zod.union([zod.object({
  "choice": zod.enum(['guide', 'website', 'custom', 'keep_current']),
  "customValue": zod.unknown().nullish()
}),zod.null()])
})).max(createEntityMicrositeBrandProposalResponseConflictsMax),
  "assetCandidates": zod.array(zod.object({
  "id": zod.string().min(1).max(createEntityMicrositeBrandProposalResponseAssetCandidatesItemIdMax),
  "url": zod.url().max(createEntityMicrositeBrandProposalResponseAssetCandidatesItemUrlMax),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(createEntityMicrositeBrandProposalResponseAssetCandidatesItemSizeBytesMax),
  "fingerprint": zod.string().regex(createEntityMicrositeBrandProposalResponseAssetCandidatesItemFingerprintRegExp),
  "location": zod.string().min(1).max(createEntityMicrositeBrandProposalResponseAssetCandidatesItemLocationMax)
})).max(createEntityMicrositeBrandProposalResponseAssetCandidatesMax),
  "allConflictsResolved": zod.boolean(),
  "stale": zod.boolean(),
  "errorCode": zod.string().max(createEntityMicrositeBrandProposalResponseErrorCodeMax).nullable(),
  "errorMessage": zod.string().max(createEntityMicrositeBrandProposalResponseErrorMessageMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Read one entity-scoped proposal and its source evidence
 */
export const getEntityMicrositeBrandProposalParams = zod.object({
  "entityId": zod.uuid(),
  "proposalId": zod.uuid()
})

export const getEntityMicrositeBrandProposalResponseRevisionMin = 0;


export const getEntityMicrositeBrandProposalResponseSourceIdsMax = 2;

export const getEntityMicrositeBrandProposalResponseSourceFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const getEntityMicrositeBrandProposalResponseDraftFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const getEntityMicrositeBrandProposalResponseSuggestionsItemPropertyMax = 80;

export const getEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsItemMax = 80;

export const getEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsMax = 20;

export const getEntityMicrositeBrandProposalResponseSuggestionsItemRequestedFontMax = 120;

export const getEntityMicrositeBrandProposalResponseSuggestionsItemSubstitutionMax = 120;

export const getEntityMicrositeBrandProposalResponseSuggestionsMax = 30;

export const getEntityMicrositeBrandProposalResponseConflictsItemIdMax = 80;

export const getEntityMicrositeBrandProposalResponseConflictsItemPropertyMax = 80;

export const getEntityMicrositeBrandProposalResponseConflictsItemGuideEvidenceIdMax = 80;

export const getEntityMicrositeBrandProposalResponseConflictsItemGuideLocationMax = 500;

export const getEntityMicrositeBrandProposalResponseConflictsItemWebsiteEvidenceIdMax = 80;

export const getEntityMicrositeBrandProposalResponseConflictsItemWebsiteLocationMax = 500;

export const getEntityMicrositeBrandProposalResponseConflictsMax = 30;

export const getEntityMicrositeBrandProposalResponseAssetCandidatesItemIdMax = 80;

export const getEntityMicrositeBrandProposalResponseAssetCandidatesItemUrlMax = 2048;

export const getEntityMicrositeBrandProposalResponseAssetCandidatesItemSizeBytesMax = 1048576;

export const getEntityMicrositeBrandProposalResponseAssetCandidatesItemFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const getEntityMicrositeBrandProposalResponseAssetCandidatesItemLocationMax = 500;

export const getEntityMicrositeBrandProposalResponseAssetCandidatesMax = 8;

export const getEntityMicrositeBrandProposalResponseErrorCodeMax = 100;

export const getEntityMicrositeBrandProposalResponseErrorMessageMax = 300;



export const getEntityMicrositeBrandProposalResponse = zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "revision": zod.int().min(getEntityMicrositeBrandProposalResponseRevisionMin),
  "attempt": zod.int().min(1),
  "sourceIds": zod.array(zod.uuid()).min(1).max(getEntityMicrositeBrandProposalResponseSourceIdsMax),
  "sourceFingerprint": zod.string().regex(getEntityMicrositeBrandProposalResponseSourceFingerprintRegExp),
  "draftFingerprint": zod.string().regex(getEntityMicrositeBrandProposalResponseDraftFingerprintRegExp),
  "suggestions": zod.array(zod.object({
  "property": zod.string().min(1).max(getEntityMicrositeBrandProposalResponseSuggestionsItemPropertyMax),
  "value": zod.unknown().nullable(),
  "state": zod.enum(['evidence', 'inferred', 'missing']),
  "evidenceIds": zod.array(zod.string().min(1).max(getEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsItemMax)).max(getEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsMax),
  "requestedFont": zod.string().max(getEntityMicrositeBrandProposalResponseSuggestionsItemRequestedFontMax).optional(),
  "substitution": zod.string().max(getEntityMicrositeBrandProposalResponseSuggestionsItemSubstitutionMax).optional()
})).max(getEntityMicrositeBrandProposalResponseSuggestionsMax),
  "conflicts": zod.array(zod.object({
  "id": zod.string().min(1).max(getEntityMicrositeBrandProposalResponseConflictsItemIdMax),
  "property": zod.string().min(1).max(getEntityMicrositeBrandProposalResponseConflictsItemPropertyMax),
  "guideEvidenceId": zod.string().min(1).max(getEntityMicrositeBrandProposalResponseConflictsItemGuideEvidenceIdMax),
  "guideValue": zod.unknown().nullable(),
  "guideLocation": zod.string().min(1).max(getEntityMicrositeBrandProposalResponseConflictsItemGuideLocationMax),
  "websiteEvidenceId": zod.string().min(1).max(getEntityMicrositeBrandProposalResponseConflictsItemWebsiteEvidenceIdMax),
  "websiteValue": zod.unknown().nullable(),
  "websiteLocation": zod.string().min(1).max(getEntityMicrositeBrandProposalResponseConflictsItemWebsiteLocationMax),
  "resolution": zod.union([zod.object({
  "choice": zod.enum(['guide', 'website', 'custom', 'keep_current']),
  "customValue": zod.unknown().nullish()
}),zod.null()])
})).max(getEntityMicrositeBrandProposalResponseConflictsMax),
  "assetCandidates": zod.array(zod.object({
  "id": zod.string().min(1).max(getEntityMicrositeBrandProposalResponseAssetCandidatesItemIdMax),
  "url": zod.url().max(getEntityMicrositeBrandProposalResponseAssetCandidatesItemUrlMax),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(getEntityMicrositeBrandProposalResponseAssetCandidatesItemSizeBytesMax),
  "fingerprint": zod.string().regex(getEntityMicrositeBrandProposalResponseAssetCandidatesItemFingerprintRegExp),
  "location": zod.string().min(1).max(getEntityMicrositeBrandProposalResponseAssetCandidatesItemLocationMax)
})).max(getEntityMicrositeBrandProposalResponseAssetCandidatesMax),
  "allConflictsResolved": zod.boolean(),
  "stale": zod.boolean(),
  "errorCode": zod.string().max(getEntityMicrositeBrandProposalResponseErrorCodeMax).nullable(),
  "errorMessage": zod.string().max(getEntityMicrositeBrandProposalResponseErrorMessageMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Retry a failed analysis against the same source versions and unchanged draft
 */
export const retryEntityMicrositeBrandProposalParams = zod.object({
  "entityId": zod.uuid(),
  "proposalId": zod.uuid()
})




export const retryEntityMicrositeBrandProposalBody = zod.object({
  "expectedRevision": zod.int().min(1)
})

export const retryEntityMicrositeBrandProposalResponseRevisionMin = 0;


export const retryEntityMicrositeBrandProposalResponseSourceIdsMax = 2;

export const retryEntityMicrositeBrandProposalResponseSourceFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const retryEntityMicrositeBrandProposalResponseDraftFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const retryEntityMicrositeBrandProposalResponseSuggestionsItemPropertyMax = 80;

export const retryEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsItemMax = 80;

export const retryEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsMax = 20;

export const retryEntityMicrositeBrandProposalResponseSuggestionsItemRequestedFontMax = 120;

export const retryEntityMicrositeBrandProposalResponseSuggestionsItemSubstitutionMax = 120;

export const retryEntityMicrositeBrandProposalResponseSuggestionsMax = 30;

export const retryEntityMicrositeBrandProposalResponseConflictsItemIdMax = 80;

export const retryEntityMicrositeBrandProposalResponseConflictsItemPropertyMax = 80;

export const retryEntityMicrositeBrandProposalResponseConflictsItemGuideEvidenceIdMax = 80;

export const retryEntityMicrositeBrandProposalResponseConflictsItemGuideLocationMax = 500;

export const retryEntityMicrositeBrandProposalResponseConflictsItemWebsiteEvidenceIdMax = 80;

export const retryEntityMicrositeBrandProposalResponseConflictsItemWebsiteLocationMax = 500;

export const retryEntityMicrositeBrandProposalResponseConflictsMax = 30;

export const retryEntityMicrositeBrandProposalResponseAssetCandidatesItemIdMax = 80;

export const retryEntityMicrositeBrandProposalResponseAssetCandidatesItemUrlMax = 2048;

export const retryEntityMicrositeBrandProposalResponseAssetCandidatesItemSizeBytesMax = 1048576;

export const retryEntityMicrositeBrandProposalResponseAssetCandidatesItemFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const retryEntityMicrositeBrandProposalResponseAssetCandidatesItemLocationMax = 500;

export const retryEntityMicrositeBrandProposalResponseAssetCandidatesMax = 8;

export const retryEntityMicrositeBrandProposalResponseErrorCodeMax = 100;

export const retryEntityMicrositeBrandProposalResponseErrorMessageMax = 300;



export const retryEntityMicrositeBrandProposalResponse = zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "revision": zod.int().min(retryEntityMicrositeBrandProposalResponseRevisionMin),
  "attempt": zod.int().min(1),
  "sourceIds": zod.array(zod.uuid()).min(1).max(retryEntityMicrositeBrandProposalResponseSourceIdsMax),
  "sourceFingerprint": zod.string().regex(retryEntityMicrositeBrandProposalResponseSourceFingerprintRegExp),
  "draftFingerprint": zod.string().regex(retryEntityMicrositeBrandProposalResponseDraftFingerprintRegExp),
  "suggestions": zod.array(zod.object({
  "property": zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseSuggestionsItemPropertyMax),
  "value": zod.unknown().nullable(),
  "state": zod.enum(['evidence', 'inferred', 'missing']),
  "evidenceIds": zod.array(zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsItemMax)).max(retryEntityMicrositeBrandProposalResponseSuggestionsItemEvidenceIdsMax),
  "requestedFont": zod.string().max(retryEntityMicrositeBrandProposalResponseSuggestionsItemRequestedFontMax).optional(),
  "substitution": zod.string().max(retryEntityMicrositeBrandProposalResponseSuggestionsItemSubstitutionMax).optional()
})).max(retryEntityMicrositeBrandProposalResponseSuggestionsMax),
  "conflicts": zod.array(zod.object({
  "id": zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseConflictsItemIdMax),
  "property": zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseConflictsItemPropertyMax),
  "guideEvidenceId": zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseConflictsItemGuideEvidenceIdMax),
  "guideValue": zod.unknown().nullable(),
  "guideLocation": zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseConflictsItemGuideLocationMax),
  "websiteEvidenceId": zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseConflictsItemWebsiteEvidenceIdMax),
  "websiteValue": zod.unknown().nullable(),
  "websiteLocation": zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseConflictsItemWebsiteLocationMax),
  "resolution": zod.union([zod.object({
  "choice": zod.enum(['guide', 'website', 'custom', 'keep_current']),
  "customValue": zod.unknown().nullish()
}),zod.null()])
})).max(retryEntityMicrositeBrandProposalResponseConflictsMax),
  "assetCandidates": zod.array(zod.object({
  "id": zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseAssetCandidatesItemIdMax),
  "url": zod.url().max(retryEntityMicrositeBrandProposalResponseAssetCandidatesItemUrlMax),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(retryEntityMicrositeBrandProposalResponseAssetCandidatesItemSizeBytesMax),
  "fingerprint": zod.string().regex(retryEntityMicrositeBrandProposalResponseAssetCandidatesItemFingerprintRegExp),
  "location": zod.string().min(1).max(retryEntityMicrositeBrandProposalResponseAssetCandidatesItemLocationMax)
})).max(retryEntityMicrositeBrandProposalResponseAssetCandidatesMax),
  "allConflictsResolved": zod.boolean(),
  "stale": zod.boolean(),
  "errorCode": zod.string().max(retryEntityMicrositeBrandProposalResponseErrorCodeMax).nullable(),
  "errorMessage": zod.string().max(retryEntityMicrositeBrandProposalResponseErrorMessageMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Record an explicit guide, website, custom, or keep-current decision for conflicts
 */
export const resolveEntityMicrositeBrandProposalConflictsParams = zod.object({
  "entityId": zod.uuid(),
  "proposalId": zod.uuid()
})


export const resolveEntityMicrositeBrandProposalConflictsBodyResolutionsItemConflictIdMax = 80;

export const resolveEntityMicrositeBrandProposalConflictsBodyResolutionsMax = 30;



export const resolveEntityMicrositeBrandProposalConflictsBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "resolutions": zod.array(zod.object({
  "conflictId": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsBodyResolutionsItemConflictIdMax),
  "choice": zod.enum(['guide', 'website', 'custom', 'keep_current']),
  "customValue": zod.unknown().nullish()
})).min(1).max(resolveEntityMicrositeBrandProposalConflictsBodyResolutionsMax)
})

export const resolveEntityMicrositeBrandProposalConflictsResponseRevisionMin = 0;


export const resolveEntityMicrositeBrandProposalConflictsResponseSourceIdsMax = 2;

export const resolveEntityMicrositeBrandProposalConflictsResponseSourceFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const resolveEntityMicrositeBrandProposalConflictsResponseDraftFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemPropertyMax = 80;

export const resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemEvidenceIdsItemMax = 80;

export const resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemEvidenceIdsMax = 20;

export const resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemRequestedFontMax = 120;

export const resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemSubstitutionMax = 120;

export const resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsMax = 30;

export const resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemIdMax = 80;

export const resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemPropertyMax = 80;

export const resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemGuideEvidenceIdMax = 80;

export const resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemGuideLocationMax = 500;

export const resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemWebsiteEvidenceIdMax = 80;

export const resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemWebsiteLocationMax = 500;

export const resolveEntityMicrositeBrandProposalConflictsResponseConflictsMax = 30;

export const resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemIdMax = 80;

export const resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemUrlMax = 2048;

export const resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemSizeBytesMax = 1048576;

export const resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');
export const resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemLocationMax = 500;

export const resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesMax = 8;

export const resolveEntityMicrositeBrandProposalConflictsResponseErrorCodeMax = 100;

export const resolveEntityMicrositeBrandProposalConflictsResponseErrorMessageMax = 300;



export const resolveEntityMicrositeBrandProposalConflictsResponse = zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "revision": zod.int().min(resolveEntityMicrositeBrandProposalConflictsResponseRevisionMin),
  "attempt": zod.int().min(1),
  "sourceIds": zod.array(zod.uuid()).min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseSourceIdsMax),
  "sourceFingerprint": zod.string().regex(resolveEntityMicrositeBrandProposalConflictsResponseSourceFingerprintRegExp),
  "draftFingerprint": zod.string().regex(resolveEntityMicrositeBrandProposalConflictsResponseDraftFingerprintRegExp),
  "suggestions": zod.array(zod.object({
  "property": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemPropertyMax),
  "value": zod.unknown().nullable(),
  "state": zod.enum(['evidence', 'inferred', 'missing']),
  "evidenceIds": zod.array(zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemEvidenceIdsItemMax)).max(resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemEvidenceIdsMax),
  "requestedFont": zod.string().max(resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemRequestedFontMax).optional(),
  "substitution": zod.string().max(resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsItemSubstitutionMax).optional()
})).max(resolveEntityMicrositeBrandProposalConflictsResponseSuggestionsMax),
  "conflicts": zod.array(zod.object({
  "id": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemIdMax),
  "property": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemPropertyMax),
  "guideEvidenceId": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemGuideEvidenceIdMax),
  "guideValue": zod.unknown().nullable(),
  "guideLocation": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemGuideLocationMax),
  "websiteEvidenceId": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemWebsiteEvidenceIdMax),
  "websiteValue": zod.unknown().nullable(),
  "websiteLocation": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseConflictsItemWebsiteLocationMax),
  "resolution": zod.union([zod.object({
  "choice": zod.enum(['guide', 'website', 'custom', 'keep_current']),
  "customValue": zod.unknown().nullish()
}),zod.null()])
})).max(resolveEntityMicrositeBrandProposalConflictsResponseConflictsMax),
  "assetCandidates": zod.array(zod.object({
  "id": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemIdMax),
  "url": zod.url().max(resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemUrlMax),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemSizeBytesMax),
  "fingerprint": zod.string().regex(resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemFingerprintRegExp),
  "location": zod.string().min(1).max(resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesItemLocationMax)
})).max(resolveEntityMicrositeBrandProposalConflictsResponseAssetCandidatesMax),
  "allConflictsResolved": zod.boolean(),
  "stale": zod.boolean(),
  "errorCode": zod.string().max(resolveEntityMicrositeBrandProposalConflictsResponseErrorCodeMax).nullable(),
  "errorMessage": zod.string().max(resolveEntityMicrositeBrandProposalConflictsResponseErrorMessageMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Revalidate and import one accepted website image into the entity asset library
 */
export const importEntityMicrositeBrandAssetParams = zod.object({
  "entityId": zod.uuid(),
  "proposalId": zod.uuid()
})

export const importEntityMicrositeBrandAssetBodyCandidateIdMax = 80;

export const importEntityMicrositeBrandAssetBodyExpectedFingerprintRegExp = new RegExp('^[0-9a-f]{64}$');


export const importEntityMicrositeBrandAssetBody = zod.object({
  "candidateId": zod.string().min(1).max(importEntityMicrositeBrandAssetBodyCandidateIdMax),
  "expectedFingerprint": zod.string().regex(importEntityMicrositeBrandAssetBodyExpectedFingerprintRegExp),
  "kind": zod.enum(['logo', 'hero'])
})

export const importEntityMicrositeBrandAssetResponseSizeBytesMax = 8388608;



export const importEntityMicrositeBrandAssetResponse = zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['logo', 'hero']),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(1).max(importEntityMicrositeBrandAssetResponseSizeBytesMax),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * Returns only visitor-safe published fields after resolving the active shared public binding.
 * @summary Get the latest published public microsite shell without authentication
 */
export const getPublicMicrositePathSlugMin = 3;
export const getPublicMicrositePathSlugMax = 80;



export const getPublicMicrositeParams = zod.object({
  "slug": zod.string().min(getPublicMicrositePathSlugMin).max(getPublicMicrositePathSlugMax)
})

export const getPublicMicrositeResponseSlugMin = 3;
export const getPublicMicrositeResponseSlugMax = 80;

export const getPublicMicrositeResponseCanonicalUrlMax = 2048;

export const getPublicMicrositeResponseHeadlineMax = 160;

export const getPublicMicrositeResponseDescriptionMax = 4000;

export const getPublicMicrositeResponsePublicWebsiteUrlMax = 2048;

export const getPublicMicrositeResponseBrandLogoUrlMax = 2048;

export const getPublicMicrositeResponseBrandHeroUrlMax = 2048;

export const getPublicMicrositeResponseBrandPrimaryColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getPublicMicrositeResponseBrandBackgroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getPublicMicrositeResponseBrandForegroundColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getPublicMicrositeResponseBrandAccentColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getPublicMicrositeResponseBrandSurfaceColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getPublicMicrositeResponseBrandMutedColorRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getPublicMicrositeResponsePromptChoicesItemLabelMax = 80;

export const getPublicMicrositeResponsePromptChoicesMax = 12;

export const getPublicMicrositeResponseContactEmailMax = 254;

export const getPublicMicrositeResponseContactPhoneMax = 40;

export const getPublicMicrositeResponseContactAddressMax = 300;

export const getPublicMicrositeResponseEnquiryCallToActionHeadingMax = 140;

export const getPublicMicrositeResponseEnquiryCallToActionLabelMax = 60;

export const getPublicMicrositeResponseEnquiryCallToActionSupportingTextMax = 400;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax = 120;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax = 80;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax = 160;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax = 4000;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax = 300;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax = 300;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax = 80;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax = 2048;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax = 20000;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax = 2048;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax = 120;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax = 6;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax = 140;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax = 400;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax = 60;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax = 400;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax = 80;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax = 5;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax = 140;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax = 600;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax = 160;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax = 60;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax = 80;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax = 160;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault = [];
export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax = 6;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault = `inline`;
export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax = 140;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax = 400;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax = 80;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax = 80;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax = 80;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax = 140;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax = 400;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax = 80;

export const getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsMax = 50;

export const getPublicMicrositeResponseLayoutRowsItemColumnsMax = 4;

export const getPublicMicrositeResponseLayoutRowsMax = 50;




export const getPublicMicrositeResponse = zod.object({
  "slug": zod.string().min(getPublicMicrositeResponseSlugMin).max(getPublicMicrositeResponseSlugMax),
  "canonicalUrl": zod.string().min(1).max(getPublicMicrositeResponseCanonicalUrlMax),
  "headline": zod.string().min(1).max(getPublicMicrositeResponseHeadlineMax),
  "description": zod.string().min(1).max(getPublicMicrositeResponseDescriptionMax),
  "publicWebsiteUrl": zod.url().max(getPublicMicrositeResponsePublicWebsiteUrlMax),
  "brand": zod.object({
  "logoUrl": zod.string().max(getPublicMicrositeResponseBrandLogoUrlMax).nullable(),
  "heroUrl": zod.string().max(getPublicMicrositeResponseBrandHeroUrlMax).nullable(),
  "primaryColor": zod.string().regex(getPublicMicrositeResponseBrandPrimaryColorRegExp),
  "backgroundColor": zod.string().regex(getPublicMicrositeResponseBrandBackgroundColorRegExp),
  "foregroundColor": zod.string().regex(getPublicMicrositeResponseBrandForegroundColorRegExp),
  "accentColor": zod.string().regex(getPublicMicrositeResponseBrandAccentColorRegExp).optional(),
  "surfaceColor": zod.string().regex(getPublicMicrositeResponseBrandSurfaceColorRegExp).optional(),
  "mutedColor": zod.string().regex(getPublicMicrositeResponseBrandMutedColorRegExp).optional(),
  "headingFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).optional(),
  "bodyFont": zod.enum(['system-sans', 'humanist-sans', 'editorial-serif', 'monospace']).optional(),
  "typeScale": zod.enum(['compact', 'standard', 'large']).optional(),
  "spacing": zod.enum(['compact', 'standard', 'generous']).optional(),
  "contentWidth": zod.enum(['narrow', 'standard', 'wide']).optional(),
  "logoTreatment": zod.enum(['natural', 'contained', 'monochrome']).optional(),
  "logoScale": zod.enum(['small', 'medium', 'large']).optional(),
  "imageryTreatment": zod.enum(['natural', 'soft', 'high-contrast', 'monochrome']).optional(),
  "imageShape": zod.enum(['square', 'rounded', 'pill']).optional(),
  "buttonStyle": zod.enum(['solid', 'soft', 'outline']).optional(),
  "buttonShape": zod.enum(['square', 'rounded', 'pill']).optional(),
  "buttonWeight": zod.enum(['regular', 'medium', 'bold']).optional(),
  "surfaceStyle": zod.enum(['flat', 'bordered', 'elevated']).optional(),
  "borderStyle": zod.enum(['none', 'subtle', 'strong']).optional(),
  "radius": zod.enum(['none', 'small', 'medium', 'large']).optional(),
  "responsiveLayout": zod.enum(['adaptive', 'stacked']).optional(),
  "heroAlignment": zod.enum(['left', 'center']).optional()
}),
  "promptChoices": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string().min(1).max(getPublicMicrositeResponsePromptChoicesItemLabelMax)
})).min(1).max(getPublicMicrositeResponsePromptChoicesMax),
  "contact": zod.object({
  "email": zod.email().max(getPublicMicrositeResponseContactEmailMax).optional(),
  "phone": zod.string().max(getPublicMicrositeResponseContactPhoneMax).optional(),
  "address": zod.string().max(getPublicMicrositeResponseContactAddressMax).optional()
}),
  "enquiryCallToAction": zod.object({
  "heading": zod.string().min(1).max(getPublicMicrositeResponseEnquiryCallToActionHeadingMax),
  "label": zod.string().min(1).max(getPublicMicrositeResponseEnquiryCallToActionLabelMax),
  "supportingText": zod.string().max(getPublicMicrositeResponseEnquiryCallToActionSupportingTextMax).optional()
}),
  "layout": zod.object({
  "rows": zod.array(zod.object({
  "id": zod.uuid(),
  "columns": zod.array(zod.object({
  "id": zod.uuid(),
  "width": zod.enum(['full', 'half', 'third', 'two-thirds']),
  "components": zod.array(zod.union([zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['header']),
  "props": zod.object({
  "showLogo": zod.boolean(),
  "showSiteName": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['hero']),
  "props": zod.object({
  "showImage": zod.boolean(),
  "showPromptChoices": zod.boolean(),
  "eyebrow": zod.string().max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemTwoPropsEyebrowMax).optional()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['approvedContentSections']),
  "props": zod.object({
  "columns": zod.union([zod.literal(1),zod.literal(2)]),
  "showHighlights": zod.boolean(),
  "showCitations": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['sourcesFooter']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemFourPropsHeadingMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['text']),
  "props": zod.object({
  "heading": zod.string().max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemFivePropsHeadingMax).optional(),
  "text": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemFivePropsTextMax),
  "alignment": zod.enum(['left', 'center', 'right'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['image']),
  "props": zod.object({
  "assetId": zod.uuid(),
  "alt": zod.string().max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemSixPropsAltMax),
  "caption": zod.string().max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemSixPropsCaptionMax).optional(),
  "fit": zod.enum(['cover', 'contain'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['button']),
  "props": zod.object({
  "label": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemSevenPropsLabelMax),
  "href": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemSevenPropsHrefMax),
  "appearance": zod.enum(['primary', 'outline', 'link']),
  "alignment": zod.enum(['left', 'center', 'right']),
  "openInNewTab": zod.boolean()
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['spacer']),
  "props": zod.object({
  "size": zod.enum(['small', 'medium', 'large'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['divider']),
  "props": zod.object({
  "style": zod.enum(['solid', 'dashed'])
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['richContent']),
  "props": zod.object({
  "html": zod.string().max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnezeroPropsHtmlMax),
  "embeds": zod.array(zod.object({
  "provider": zod.enum(['youtube', 'vimeo', 'google-maps']),
  "url": zod.url().max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemUrlMax),
  "title": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsItemTitleMax)
})).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnezeroPropsEmbedsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['contactForm']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsHeadingMax),
  "supportingText": zod.string().max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsSupportingTextMax).optional(),
  "submitLabel": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsSubmitLabelMax),
  "successMessage": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsSuccessMessageMax),
  "fields": zod.array(zod.object({
  "type": zod.enum(['name', 'email', 'phone', 'account', 'message']),
  "label": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsItemLabelMax),
  "enabled": zod.boolean(),
  "required": zod.boolean()
})).min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOneonePropsFieldsMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['aiChat']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHeadingMax),
  "welcomeMessage": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsWelcomeMessageMax),
  "inputPlaceholder": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsInputPlaceholderMax),
  "submitLabel": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSubmitLabelMax),
  "handoffEnabled": zod.boolean(),
  "handoffLabel": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsHandoffLabelMax),
  "suggestedQuestions": zod.array(zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsItemMax)).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsMax).default(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsSuggestedQuestionsDefault),
  "displayMode": zod.enum(['inline', 'floating']).default(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnetwoPropsDisplayModeDefault)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['clickToCall']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsHeadingMax),
  "supportingText": zod.string().max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsSupportingTextMax).optional(),
  "browserVoice": zod.boolean(),
  "callbackRequest": zod.boolean(),
  "tapToDial": zod.boolean(),
  "browserVoiceLabel": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsBrowserVoiceLabelMax),
  "callbackRequestLabel": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsCallbackRequestLabelMax),
  "tapToDialLabel": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnethreePropsTapToDialLabelMax)
})
}),zod.object({
  "id": zod.uuid(),
  "type": zod.enum(['voiceAgent']),
  "props": zod.object({
  "heading": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnefourPropsHeadingMax),
  "supportingText": zod.string().max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnefourPropsSupportingTextMax).optional(),
  "startLabel": zod.string().min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsItemOnefourPropsStartLabelMax)
})
})])).max(getPublicMicrositeResponseLayoutRowsItemColumnsItemComponentsMax)
})).min(1).max(getPublicMicrositeResponseLayoutRowsItemColumnsMax)
})).min(1).max(getPublicMicrositeResponseLayoutRowsMax)
}),
  "aiEnabled": zod.boolean(),
  "publishedVersion": zod.int().min(1),
  "publishedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get an image referenced by the latest published microsite
 */
export const getPublicMicrositeAssetPathSlugMin = 3;
export const getPublicMicrositeAssetPathSlugMax = 80;



export const getPublicMicrositeAssetParams = zod.object({
  "slug": zod.string().min(getPublicMicrositeAssetPathSlugMin).max(getPublicMicrositeAssetPathSlugMax),
  "assetId": zod.uuid()
})

export const getPublicMicrositeAssetResponse = zod.unknown()


/**
 * Resolves ownership from the active shared public binding; never accepts tenant, entity, or raw instruction input.
 * @summary Generate or load a structured published microsite page without authentication
 */
export const generatePublicMicrositePagePathSlugMin = 3;
export const generatePublicMicrositePagePathSlugMax = 80;



export const generatePublicMicrositePageParams = zod.object({
  "slug": zod.string().min(generatePublicMicrositePagePathSlugMin).max(generatePublicMicrositePagePathSlugMax)
})

export const generatePublicMicrositePageBody = zod.object({
  "promptChoiceId": zod.uuid().optional()
})

export const generatePublicMicrositePageResponseTitleMax = 160;

export const generatePublicMicrositePageResponseIntroMax = 600;

export const generatePublicMicrositePageResponseSectionsItemIdMax = 60;


export const generatePublicMicrositePageResponseSectionsItemIdRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
export const generatePublicMicrositePageResponseSectionsItemHeadingMax = 120;

export const generatePublicMicrositePageResponseSectionsItemBodyMax = 4000;

export const generatePublicMicrositePageResponseSectionsItemHighlightsItemMax = 240;

export const generatePublicMicrositePageResponseSectionsItemHighlightsMax = 6;

export const generatePublicMicrositePageResponseSectionsItemCitationIdsItemMax = 80;

export const generatePublicMicrositePageResponseSectionsItemCitationIdsMax = 12;

export const generatePublicMicrositePageResponseSectionsMax = 8;

export const generatePublicMicrositePageResponseSourcesItemIdMax = 80;

export const generatePublicMicrositePageResponseSourcesItemLabelMax = 160;


export const generatePublicMicrositePageResponseSourcesMax = 100;

export const generatePublicMicrositePageResponseNoticeMax = 300;


export const generatePublicMicrositePageResponsePromptLabelMax = 80;



export const generatePublicMicrositePageResponse = zod.object({
  "title": zod.string().min(1).max(generatePublicMicrositePageResponseTitleMax),
  "intro": zod.string().min(1).max(generatePublicMicrositePageResponseIntroMax),
  "sections": zod.array(zod.object({
  "id": zod.string().max(generatePublicMicrositePageResponseSectionsItemIdMax).regex(generatePublicMicrositePageResponseSectionsItemIdRegExp),
  "heading": zod.string().min(1).max(generatePublicMicrositePageResponseSectionsItemHeadingMax),
  "body": zod.string().min(1).max(generatePublicMicrositePageResponseSectionsItemBodyMax),
  "highlights": zod.array(zod.string().min(1).max(generatePublicMicrositePageResponseSectionsItemHighlightsItemMax)).max(generatePublicMicrositePageResponseSectionsItemHighlightsMax),
  "citationIds": zod.array(zod.string().min(1).max(generatePublicMicrositePageResponseSectionsItemCitationIdsItemMax)).max(generatePublicMicrositePageResponseSectionsItemCitationIdsMax)
})).min(1).max(generatePublicMicrositePageResponseSectionsMax),
  "sources": zod.array(zod.object({
  "id": zod.string().min(1).max(generatePublicMicrositePageResponseSourcesItemIdMax),
  "label": zod.string().min(1).max(generatePublicMicrositePageResponseSourcesItemLabelMax),
  "url": zod.url().optional(),
  "version": zod.int().min(1)
})).max(generatePublicMicrositePageResponseSourcesMax),
  "generatedBy": zod.enum(['ai', 'fallback']),
  "notice": zod.string().max(generatePublicMicrositePageResponseNoticeMax).optional(),
  "configurationVersion": zod.int().min(1),
  "promptChoiceId": zod.uuid().nullable(),
  "promptLabel": zod.string().max(generatePublicMicrositePageResponsePromptLabelMax).nullable()
})


/**
 * Reuses public enquiry validation, honeypot, and rate limits; tenant and entity identifiers are never accepted from the visitor.
 * @summary Submit an enquiry to the entity resolved from a published microsite
 */
export const submitPublicMicrositeEnquiryPathSlugMin = 3;
export const submitPublicMicrositeEnquiryPathSlugMax = 80;



export const submitPublicMicrositeEnquiryParams = zod.object({
  "slug": zod.string().min(submitPublicMicrositeEnquiryPathSlugMin).max(submitPublicMicrositeEnquiryPathSlugMax)
})

export const submitPublicMicrositeEnquiryBodyNameMax = 200;

export const submitPublicMicrositeEnquiryBodyPhoneMax = 50;

export const submitPublicMicrositeEnquiryBodyAccountMax = 200;

export const submitPublicMicrositeEnquiryBodySubjectMax = 300;

export const submitPublicMicrositeEnquiryBodyMessageMax = 5000;



export const submitPublicMicrositeEnquiryBody = zod.object({
  "name": zod.string().min(1).max(submitPublicMicrositeEnquiryBodyNameMax),
  "email": zod.email(),
  "phone": zod.string().max(submitPublicMicrositeEnquiryBodyPhoneMax).nullish(),
  "account": zod.string().max(submitPublicMicrositeEnquiryBodyAccountMax).nullish(),
  "subject": zod.string().max(submitPublicMicrositeEnquiryBodySubjectMax).optional(),
  "message": zod.string().min(1).max(submitPublicMicrositeEnquiryBodyMessageMax),
  "website": zod.string().optional().describe('Honeypot field — must be left empty. Filled values are rejected.')
})

export const submitPublicMicrositeEnquiryResponse = zod.object({
  "id": zod.uuid(),
  "message": zod.string()
})


/**
 * Tenant and entity identifiers are resolved exclusively from the active public microsite binding.
 * @summary List future bookable slots for the server-resolved entity
 */
export const listPublicMicrositeBookingSlotsPathSlugMin = 3;
export const listPublicMicrositeBookingSlotsPathSlugMax = 80;



export const listPublicMicrositeBookingSlotsParams = zod.object({
  "slug": zod.string().min(listPublicMicrositeBookingSlotsPathSlugMin).max(listPublicMicrositeBookingSlotsPathSlugMax)
})

export const listPublicMicrositeBookingSlotsQueryServiceMax = 300;

export const listPublicMicrositeBookingSlotsQueryLimitDefault = 50;
export const listPublicMicrositeBookingSlotsQueryLimitMax = 100;

export const listPublicMicrositeBookingSlotsQueryOffsetDefault = 0;
export const listPublicMicrositeBookingSlotsQueryOffsetMin = 0;



export const listPublicMicrositeBookingSlotsQueryParams = zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "service": zod.string().min(1).max(listPublicMicrositeBookingSlotsQueryServiceMax).optional(),
  "limit": zod.int().min(1).max(listPublicMicrositeBookingSlotsQueryLimitMax).default(listPublicMicrositeBookingSlotsQueryLimitDefault),
  "offset": zod.int().min(listPublicMicrositeBookingSlotsQueryOffsetMin).default(listPublicMicrositeBookingSlotsQueryOffsetDefault)
})


export const listPublicMicrositeBookingSlotsResponseTotalMin = 0;


export const listPublicMicrositeBookingSlotsResponseOffsetMin = 0;



export const listPublicMicrositeBookingSlotsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "service": zod.string(),
  "description": zod.string().nullish(),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string(),
  "remaining": zod.int().min(1)
})),
  "total": zod.int().min(listPublicMicrositeBookingSlotsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPublicMicrositeBookingSlotsResponseOffsetMin)
})


/**
 * Reuses canonical CRM contacts and enquiries; tenant, entity, contact, account, and enquiry identifiers are never accepted from the visitor.
 * @summary Reserve a capacity-controlled slot for the server-resolved entity
 */
export const createPublicMicrositeBookingPathSlugMin = 3;
export const createPublicMicrositeBookingPathSlugMax = 80;



export const createPublicMicrositeBookingParams = zod.object({
  "slug": zod.string().min(createPublicMicrositeBookingPathSlugMin).max(createPublicMicrositeBookingPathSlugMax)
})

export const createPublicMicrositeBookingBodyNameMax = 200;

export const createPublicMicrositeBookingBodyPhoneMax = 100;

export const createPublicMicrositeBookingBodyNotesMax = 2000;

export const createPublicMicrositeBookingBodyWebsiteDefault = ``;
export const createPublicMicrositeBookingBodyWebsiteMax = 200;



export const createPublicMicrositeBookingBody = zod.object({
  "requestId": zod.uuid(),
  "slotId": zod.uuid(),
  "name": zod.string().min(1).max(createPublicMicrositeBookingBodyNameMax),
  "email": zod.email(),
  "phone": zod.string().max(createPublicMicrositeBookingBodyPhoneMax).nullish(),
  "notes": zod.string().max(createPublicMicrositeBookingBodyNotesMax).nullish(),
  "consentToContact": zod.literal(true),
  "website": zod.string().max(createPublicMicrositeBookingBodyWebsiteMax).default(createPublicMicrositeBookingBodyWebsiteDefault)
})

export const createPublicMicrositeBookingResponse = zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['pending', 'confirmed', 'completed', 'cancelled']),
  "service": zod.string(),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "message": zod.string()
})


/**
 * Streams Server-Sent Events grounded only in approved sources from the resolved published microsite.
 * @summary Stream a microsite-scoped AI chat reply
 */
export const micrositeChatPathSlugMin = 3;
export const micrositeChatPathSlugMax = 80;



export const micrositeChatParams = zod.object({
  "slug": zod.string().min(micrositeChatPathSlugMin).max(micrositeChatPathSlugMax)
})

export const micrositeChatBodyMessageMax = 2000;

export const micrositeChatBodyHistoryItemContentMax = 2000;

export const micrositeChatBodyHistoryMax = 20;

export const micrositeChatBodyModeDefault = `chat`;

export const micrositeChatBody = zod.object({
  "message": zod.string().min(1).max(micrositeChatBodyMessageMax),
  "history": zod.array(zod.object({
  "role": zod.enum(['user', 'assistant']),
  "content": zod.string().min(1).max(micrositeChatBodyHistoryItemContentMax)
})).max(micrositeChatBodyHistoryMax).optional().describe('Prior messages of this browser session, oldest first.'),
  "website": zod.string().optional().describe('Honeypot field — must be left empty. Filled values are rejected.'),
  "sessionId": zod.uuid().optional().describe('Optional durable browser-session id. Existing embeds may omit it.'),
  "mode": zod.enum(['chat', 'voice']).default(micrositeChatBodyModeDefault)
})

export const micrositeChatResponse = zod.unknown()


/**
 * @summary Capture visitor details for a microsite chat
 */
export const captureMicrositeChatLeadPathSlugMin = 3;
export const captureMicrositeChatLeadPathSlugMax = 80;



export const captureMicrositeChatLeadParams = zod.object({
  "slug": zod.string().min(captureMicrositeChatLeadPathSlugMin).max(captureMicrositeChatLeadPathSlugMax)
})

export const captureMicrositeChatLeadBodyNameMax = 200;

export const captureMicrositeChatLeadBodyEmailMax = 320;

export const captureMicrositeChatLeadBodyPhoneMax = 50;

export const captureMicrositeChatLeadBodyAccountMax = 200;

export const captureMicrositeChatLeadBodyNeedMax = 4000;



export const captureMicrositeChatLeadBody = zod.object({
  "sessionId": zod.uuid(),
  "name": zod.string().min(1).max(captureMicrositeChatLeadBodyNameMax),
  "email": zod.email().max(captureMicrositeChatLeadBodyEmailMax),
  "phone": zod.string().max(captureMicrositeChatLeadBodyPhoneMax).nullish(),
  "account": zod.string().max(captureMicrositeChatLeadBodyAccountMax).nullish(),
  "need": zod.string().min(1).max(captureMicrositeChatLeadBodyNeedMax)
})

export const captureMicrositeChatLeadResponse = zod.object({
  "sessionId": zod.uuid(),
  "contactId": zod.uuid(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "action": zod.enum(['enquiry', 'booking_request', 'contact_only'])
})


/**
 * @summary Request human follow-up for a microsite chat
 */
export const requestMicrositeChatHandoffPathSlugMin = 3;
export const requestMicrositeChatHandoffPathSlugMax = 80;



export const requestMicrositeChatHandoffParams = zod.object({
  "slug": zod.string().min(requestMicrositeChatHandoffPathSlugMin).max(requestMicrositeChatHandoffPathSlugMax)
})

export const requestMicrositeChatHandoffBodyReasonMax = 1000;



export const requestMicrositeChatHandoffBody = zod.object({
  "sessionId": zod.uuid(),
  "reason": zod.string().max(requestMicrositeChatHandoffBodyReasonMax).optional()
})

export const requestMicrositeChatHandoffResponse = zod.object({
  "sessionId": zod.uuid(),
  "status": zod.enum(['handoff_requested'])
})


/**
 * Public endpoint used by the website enquiry form. Protected by a honeypot field and per-client rate limiting rather than authentication.
 * @summary Submit a website enquiry (public, no authentication)
 */
export const submitPublicEnquiryBodyNameMax = 200;

export const submitPublicEnquiryBodyPhoneMax = 50;

export const submitPublicEnquiryBodyAccountMax = 200;

export const submitPublicEnquiryBodySubjectMax = 300;

export const submitPublicEnquiryBodyMessageMax = 5000;



export const submitPublicEnquiryBody = zod.object({
  "name": zod.string().min(1).max(submitPublicEnquiryBodyNameMax),
  "email": zod.email(),
  "phone": zod.string().max(submitPublicEnquiryBodyPhoneMax).nullish(),
  "account": zod.string().max(submitPublicEnquiryBodyAccountMax).nullish(),
  "subject": zod.string().max(submitPublicEnquiryBodySubjectMax).optional(),
  "message": zod.string().min(1).max(submitPublicEnquiryBodyMessageMax),
  "website": zod.string().optional().describe('Honeypot field — must be left empty. Filled values are rejected.')
})

export const submitPublicEnquiryResponse = zod.object({
  "id": zod.uuid(),
  "message": zod.string()
})


/**
 * Public endpoint backing the website AI chat widget. Streams the assistant reply as Server-Sent Events (text/event-stream), so the SPA consumes it with a dedicated streaming reader instead of a generated hook. Protected by per-client rate limiting, message length caps, and a honeypot field. The assistant can create Partner Engagement enquiries (source "chat") on the visitor's behalf.
 * @summary Website AI chat (public, no authentication)
 */
export const publicChatBodyMessageMax = 2000;

export const publicChatBodyHistoryItemContentMax = 2000;

export const publicChatBodyHistoryMax = 20;

export const publicChatBodyModeDefault = `chat`;

export const publicChatBody = zod.object({
  "message": zod.string().min(1).max(publicChatBodyMessageMax),
  "history": zod.array(zod.object({
  "role": zod.enum(['user', 'assistant']),
  "content": zod.string().min(1).max(publicChatBodyHistoryItemContentMax)
})).max(publicChatBodyHistoryMax).optional().describe('Prior messages of this browser session, oldest first.'),
  "website": zod.string().optional().describe('Honeypot field — must be left empty. Filled values are rejected.'),
  "sessionId": zod.uuid().optional().describe('Optional durable browser-session id. Existing embeds may omit it.'),
  "mode": zod.enum(['chat', 'voice']).default(publicChatBodyModeDefault)
})

export const publicChatResponse = zod.unknown()


/**
 * @summary Attach visitor details to a public chat and create or update the CRM lead
 */
export const capturePublicChatLeadBodyNameMax = 200;

export const capturePublicChatLeadBodyEmailMax = 320;

export const capturePublicChatLeadBodyPhoneMax = 50;

export const capturePublicChatLeadBodyAccountMax = 200;

export const capturePublicChatLeadBodyNeedMax = 4000;



export const capturePublicChatLeadBody = zod.object({
  "sessionId": zod.uuid(),
  "name": zod.string().min(1).max(capturePublicChatLeadBodyNameMax),
  "email": zod.email().max(capturePublicChatLeadBodyEmailMax),
  "phone": zod.string().max(capturePublicChatLeadBodyPhoneMax).nullish(),
  "account": zod.string().max(capturePublicChatLeadBodyAccountMax).nullish(),
  "need": zod.string().min(1).max(capturePublicChatLeadBodyNeedMax)
})

export const capturePublicChatLeadResponse = zod.object({
  "sessionId": zod.uuid(),
  "contactId": zod.uuid(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "action": zod.enum(['enquiry', 'booking_request', 'contact_only'])
})


/**
 * @summary Request a human follow-up for a public chat
 */
export const requestPublicChatHandoffBodyReasonMax = 1000;



export const requestPublicChatHandoffBody = zod.object({
  "sessionId": zod.uuid(),
  "reason": zod.string().max(requestPublicChatHandoffBodyReasonMax).optional()
})

export const requestPublicChatHandoffResponse = zod.object({
  "sessionId": zod.uuid(),
  "status": zod.enum(['handoff_requested'])
})


/**
 * @summary List persisted chat sessions and human handoff queue
 */
export const listChatAssistantSessionsQueryLimitDefault = 50;
export const listChatAssistantSessionsQueryLimitMax = 100;



export const listChatAssistantSessionsQueryParams = zod.object({
  "status": zod.enum(['active', 'handoff_requested', 'resolved']).optional(),
  "limit": zod.int().min(1).max(listChatAssistantSessionsQueryLimitMax).default(listChatAssistantSessionsQueryLimitDefault)
})

export const listChatAssistantSessionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "publicSessionId": zod.uuid(),
  "micrositeBindingId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'handoff_requested', 'resolved']),
  "primaryMode": zod.enum(['chat', 'voice']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "visitorName": zod.string().nullish(),
  "visitorEmail": zod.string().nullish(),
  "visitorPhone": zod.string().nullish(),
  "visitorAccount": zod.string().nullish(),
  "handoffReason": zod.string().nullish(),
  "messageCount": zod.int(),
  "lastMessageAt": zod.iso.datetime({"offset":true}),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Get a chat session with its complete transcript
 */
export const getChatAssistantSessionParams = zod.object({
  "id": zod.uuid()
})

export const getChatAssistantSessionResponse = zod.object({
  "id": zod.uuid(),
  "publicSessionId": zod.uuid(),
  "micrositeBindingId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'handoff_requested', 'resolved']),
  "primaryMode": zod.enum(['chat', 'voice']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "visitorName": zod.string().nullish(),
  "visitorEmail": zod.string().nullish(),
  "visitorPhone": zod.string().nullish(),
  "visitorAccount": zod.string().nullish(),
  "handoffReason": zod.string().nullish(),
  "messageCount": zod.int(),
  "lastMessageAt": zod.iso.datetime({"offset":true}),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "messages": zod.array(zod.object({
  "id": zod.uuid(),
  "role": zod.enum(['visitor', 'assistant', 'system']),
  "mode": zod.enum(['chat', 'voice']),
  "content": zod.string(),
  "validationStatus": zod.enum(['not_applicable', 'grounded', 'low_confidence', 'failed']),
  "validationConfidence": zod.number().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))
}))


/**
 * @summary Mark a human handoff as resolved
 */
export const resolveChatAssistantSessionParams = zod.object({
  "id": zod.uuid()
})

export const resolveChatAssistantSessionResponse = zod.object({
  "id": zod.uuid(),
  "publicSessionId": zod.uuid(),
  "micrositeBindingId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'handoff_requested', 'resolved']),
  "primaryMode": zod.enum(['chat', 'voice']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "visitorName": zod.string().nullish(),
  "visitorEmail": zod.string().nullish(),
  "visitorPhone": zod.string().nullish(),
  "visitorAccount": zod.string().nullish(),
  "handoffReason": zod.string().nullish(),
  "messageCount": zod.int(),
  "lastMessageAt": zod.iso.datetime({"offset":true}),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * Public endpoint backing the standalone event microsites. Returns the published event with its agenda, speakers, and venue details. Unknown, draft, or archived slugs return 404.
 * @summary Get a published event for its public microsite (no authentication)
 */
export const getPublicEventParams = zod.object({
  "slug": zod.string()
})

export const getPublicEventQueryRefMax = 100;



export const getPublicEventQueryParams = zod.object({
  "ref": zod.string().max(getPublicEventQueryRefMax).optional().describe('Personal SMS tracking reference. Invalid references are ignored.')
})

export const getPublicEventResponse = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "heroBadge": zod.string().nullish(),
  "heroHeadline": zod.string().nullish(),
  "heroSubheading": zod.string().nullish(),
  "dateLabel": zod.string().nullish(),
  "timeLabel": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "rsvpDeadlineLabel": zod.string().nullish(),
  "startsAt": zod.iso.datetime({"offset":true}).nullish(),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "venueName": zod.string().nullish(),
  "venueRoom": zod.string().nullish(),
  "venueAddress": zod.string().nullish(),
  "venueWebsite": zod.string().nullish(),
  "venueMapsUrl": zod.string().nullish(),
  "livestreamUrl": zod.string().nullish(),
  "agenda": zod.array(zod.object({
  "id": zod.uuid(),
  "timeLabel": zod.string(),
  "title": zod.string(),
  "speaker": zod.string().nullish(),
  "speakerRole": zod.string().nullish()
})),
  "speakers": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "role": zod.string().nullish(),
  "blurb": zod.string().nullish(),
  "photoUrl": zod.string().nullish()
})),
  "invitationBypass": zod.boolean(),
  "prefill": zod.union([zod.object({
  "firstName": zod.string(),
  "lastName": zod.string(),
  "email": zod.email(),
  "mobile": zod.string().nullable()
}),zod.null()])
})


/**
 * Checks an invitation code for a published event without consuming a use. Invalid, inactive, expired, and exhausted codes all collapse to the same safe 404 so codes cannot be probed. Protected by a honeypot field and per-client rate limiting.
 * @summary Validate an event invitation code (public, no authentication)
 */
export const validateEventInvitationCodeParams = zod.object({
  "slug": zod.string()
})

export const validateEventInvitationCodeBodyCodeMax = 200;


export const validateEventInvitationCodeBodyCodeRegExp = new RegExp('^[A-Za-z0-9-]+$');


export const validateEventInvitationCodeBody = zod.object({
  "code": zod.string().min(1).max(validateEventInvitationCodeBodyCodeMax).regex(validateEventInvitationCodeBodyCodeRegExp),
  "website": zod.string().optional().describe('Honeypot field — must be left empty. Filled values are rejected.')
})

export const validateEventInvitationCodeResponse = zod.object({
  "valid": zod.boolean(),
  "label": zod.string().nullish()
})


/**
 * Validates and consumes one invitation-code use, stores the attendee details, and links the RSVP to a Partner Engagement contact matched by email (a new contact is created when no match exists). One RSVP per email per event. Protected by a honeypot field and per-client rate limiting.
 * @summary Submit an RSVP for a published event (public, no authentication)
 */
export const submitEventRsvpParams = zod.object({
  "slug": zod.string()
})

export const submitEventRsvpBodyCodeMax = 200;


export const submitEventRsvpBodyCodeRegExp = new RegExp('^[A-Za-z0-9-]+$');
export const submitEventRsvpBodyRefMax = 100;

export const submitEventRsvpBodyNameMax = 200;

export const submitEventRsvpBodyEmailMax = 320;

export const submitEventRsvpBodyAccountMax = 200;

export const submitEventRsvpBodyPhoneMax = 50;

export const submitEventRsvpBodyDietaryRequirementsMax = 500;

export const submitEventRsvpBodyNotesMax = 2000;

export const submitEventRsvpBodyAttendingDefault = true;

export const submitEventRsvpBody = zod.object({
  "code": zod.string().min(1).max(submitEventRsvpBodyCodeMax).regex(submitEventRsvpBodyCodeRegExp).optional(),
  "ref": zod.string().max(submitEventRsvpBodyRefMax).optional(),
  "name": zod.string().min(1).max(submitEventRsvpBodyNameMax),
  "email": zod.email().max(submitEventRsvpBodyEmailMax),
  "account": zod.string().max(submitEventRsvpBodyAccountMax).nullish(),
  "phone": zod.string().max(submitEventRsvpBodyPhoneMax).nullish(),
  "dietaryRequirements": zod.string().max(submitEventRsvpBodyDietaryRequirementsMax).nullish(),
  "notes": zod.string().max(submitEventRsvpBodyNotesMax).nullish(),
  "attending": zod.boolean().default(submitEventRsvpBodyAttendingDefault).describe('Set false to record a "can\'t attend" response instead of a confirmed RSVP.'),
  "website": zod.string().optional().describe('Honeypot field — must be left empty. Filled values are rejected.')
})

export const submitEventRsvpResponse = zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['confirmed', 'declined', 'waitlisted', 'cancelled']),
  "message": zod.string()
})


/**
 * @summary List opportunities
 */
export const listOpportunitiesQueryIncludeTestDataDefault = false;
export const listOpportunitiesQueryLimitDefault = 50;
export const listOpportunitiesQueryLimitMax = 100;

export const listOpportunitiesQueryOffsetDefault = 0;
export const listOpportunitiesQueryOffsetMin = 0;



export const listOpportunitiesQueryParams = zod.object({
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']).optional(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().optional(),
  "includeTestData": zod.boolean().default(listOpportunitiesQueryIncludeTestDataDefault).describe('Include records flagged as test or demo data. They are excluded by default.'),
  "limit": zod.int().min(1).max(listOpportunitiesQueryLimitMax).default(listOpportunitiesQueryLimitDefault),
  "offset": zod.int().min(listOpportunitiesQueryOffsetMin).default(listOpportunitiesQueryOffsetDefault)
})

export const listOpportunitiesResponseItemsItemProbabilityMin = 0;
export const listOpportunitiesResponseItemsItemProbabilityMax = 100;

export const listOpportunitiesResponseItemsItemIsTestDataDefault = false;
export const listOpportunitiesResponseTotalMin = 0;



export const listOpportunitiesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']),
  "value": zod.number().nullish(),
  "currency": zod.string(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(listOpportunitiesResponseItemsItemProbabilityMin).max(listOpportunitiesResponseItemsItemProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(listOpportunitiesResponseItemsItemIsTestDataDefault),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listOpportunitiesResponseTotalMin),
  "limit": zod.int().optional(),
  "offset": zod.int().optional()
})


/**
 * @summary Create an opportunity
 */
export const createOpportunityBodyTitleMax = 300;

export const createOpportunityBodyCurrencyMin = 3;
export const createOpportunityBodyCurrencyMax = 3;

export const createOpportunityBodyProbabilityMin = 0;
export const createOpportunityBodyProbabilityMax = 100;

export const createOpportunityBodyIsTestDataDefault = false;

export const createOpportunityBody = zod.object({
  "title": zod.string().min(1).max(createOpportunityBodyTitleMax),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']).optional(),
  "value": zod.number().nullish(),
  "currency": zod.string().min(createOpportunityBodyCurrencyMin).max(createOpportunityBodyCurrencyMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(createOpportunityBodyProbabilityMin).max(createOpportunityBodyProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(createOpportunityBodyIsTestDataDefault),
  "notes": zod.string().nullish()
})

export const createOpportunityResponseProbabilityMin = 0;
export const createOpportunityResponseProbabilityMax = 100;

export const createOpportunityResponseIsTestDataDefault = false;

export const createOpportunityResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']),
  "value": zod.number().nullish(),
  "currency": zod.string(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(createOpportunityResponseProbabilityMin).max(createOpportunityResponseProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(createOpportunityResponseIsTestDataDefault),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get one opportunity
 */
export const getOpportunityParams = zod.object({
  "id": zod.uuid()
})

export const getOpportunityResponseProbabilityMin = 0;
export const getOpportunityResponseProbabilityMax = 100;

export const getOpportunityResponseIsTestDataDefault = false;

export const getOpportunityResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']),
  "value": zod.number().nullish(),
  "currency": zod.string(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(getOpportunityResponseProbabilityMin).max(getOpportunityResponseProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(getOpportunityResponseIsTestDataDefault),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update an opportunity
 */
export const updateOpportunityParams = zod.object({
  "id": zod.uuid()
})

export const updateOpportunityBodyTitleMax = 300;

export const updateOpportunityBodyCurrencyMin = 3;
export const updateOpportunityBodyCurrencyMax = 3;

export const updateOpportunityBodyProbabilityMin = 0;
export const updateOpportunityBodyProbabilityMax = 100;

export const updateOpportunityBodyIsTestDataDefault = false;

export const updateOpportunityBody = zod.object({
  "title": zod.string().min(1).max(updateOpportunityBodyTitleMax).optional(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']).optional(),
  "value": zod.number().nullish(),
  "currency": zod.string().min(updateOpportunityBodyCurrencyMin).max(updateOpportunityBodyCurrencyMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(updateOpportunityBodyProbabilityMin).max(updateOpportunityBodyProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(updateOpportunityBodyIsTestDataDefault),
  "notes": zod.string().nullish()
})

export const updateOpportunityResponseProbabilityMin = 0;
export const updateOpportunityResponseProbabilityMax = 100;

export const updateOpportunityResponseIsTestDataDefault = false;

export const updateOpportunityResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),
  "stage": zod.enum(['lead', 'qualified', 'proposal', 'negotiation', 'won', 'lost', 'awareness', 'consideration', 'checkout', 'purchased', 'abandoned', 'identified', 'contacted', 'diligence', 'term_sheet', 'committed', 'passed']),
  "value": zod.number().nullish(),
  "currency": zod.string(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "expectedCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "actualCloseDate": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().nullish(),
  "topic": zod.string().nullish(),
  "source": zod.string().nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "probability": zod.int().min(updateOpportunityResponseProbabilityMin).max(updateOpportunityResponseProbabilityMax).nullish(),
  "originatingLeadId": zod.string().nullish(),
  "isTestData": zod.boolean().default(updateOpportunityResponseIsTestDataDefault),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete an opportunity
 */
export const deleteOpportunityParams = zod.object({
  "id": zod.uuid()
})

export const deleteOpportunityResponse = zod.void()


export const listOpportunityNotesQuerySearchMax = 200;

export const listOpportunityNotesQueryLimitDefault = 50;
export const listOpportunityNotesQueryLimitMax = 100;

export const listOpportunityNotesQueryOffsetDefault = 0;
export const listOpportunityNotesQueryOffsetMin = 0;



export const listOpportunityNotesQueryParams = zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "search": zod.string().max(listOpportunityNotesQuerySearchMax).optional(),
  "from": zod.iso.date().optional(),
  "to": zod.iso.date().optional(),
  "limit": zod.int().min(1).max(listOpportunityNotesQueryLimitMax).default(listOpportunityNotesQueryLimitDefault),
  "offset": zod.int().min(listOpportunityNotesQueryOffsetMin).default(listOpportunityNotesQueryOffsetDefault)
})

export const listOpportunityNotesResponseItemsItemOneTitleMax = 200;

export const listOpportunityNotesResponseItemsItemOneNeedsMax = 5000;

export const listOpportunityNotesResponseItemsItemOnePrioritiesMax = 5000;

export const listOpportunityNotesResponseItemsItemOneConstraintsMax = 5000;

export const listOpportunityNotesResponseItemsItemOneSuccessCriteriaMax = 5000;

export const listOpportunityNotesResponseItemsItemOneSolutionOptionsMax = 5000;

export const listOpportunityNotesResponseItemsItemOneNotesMax = 5000;

export const listOpportunityNotesResponseItemsItemOneLinksItemRevisionMax = 200;

export const listOpportunityNotesResponseItemsItemOneLinksMax = 30;



export const listOpportunityNotesResponse = zod.object({
  "items": zod.array(zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(listOpportunityNotesResponseItemsItemOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(listOpportunityNotesResponseItemsItemOneNeedsMax).nullish(),
  "priorities": zod.string().max(listOpportunityNotesResponseItemsItemOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(listOpportunityNotesResponseItemsItemOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(listOpportunityNotesResponseItemsItemOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(listOpportunityNotesResponseItemsItemOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(listOpportunityNotesResponseItemsItemOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(listOpportunityNotesResponseItemsItemOneLinksItemRevisionMax)
})).max(listOpportunityNotesResponseItemsItemOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
}))),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const listOpportunityNoteChoicesQuerySearchMax = 200;

export const listOpportunityNoteChoicesQueryLimitDefault = 50;
export const listOpportunityNoteChoicesQueryLimitMax = 100;

export const listOpportunityNoteChoicesQueryOffsetDefault = 0;
export const listOpportunityNoteChoicesQueryOffsetMin = 0;



export const listOpportunityNoteChoicesQueryParams = zod.object({
  "kind": zod.enum(['opportunity', 'catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "search": zod.string().max(listOpportunityNoteChoicesQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listOpportunityNoteChoicesQueryLimitMax).default(listOpportunityNoteChoicesQueryLimitDefault),
  "offset": zod.int().min(listOpportunityNoteChoicesQueryOffsetMin).default(listOpportunityNoteChoicesQueryOffsetDefault)
})

export const listOpportunityNoteChoicesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "revision": zod.string()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getOpportunityNoteParams = zod.object({
  "id": zod.uuid()
})

export const getOpportunityNoteResponseOneTitleMax = 200;

export const getOpportunityNoteResponseOneNeedsMax = 5000;

export const getOpportunityNoteResponseOnePrioritiesMax = 5000;

export const getOpportunityNoteResponseOneConstraintsMax = 5000;

export const getOpportunityNoteResponseOneSuccessCriteriaMax = 5000;

export const getOpportunityNoteResponseOneSolutionOptionsMax = 5000;

export const getOpportunityNoteResponseOneNotesMax = 5000;

export const getOpportunityNoteResponseOneLinksItemRevisionMax = 200;

export const getOpportunityNoteResponseOneLinksMax = 30;



export const getOpportunityNoteResponse = zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(getOpportunityNoteResponseOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(getOpportunityNoteResponseOneNeedsMax).nullish(),
  "priorities": zod.string().max(getOpportunityNoteResponseOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(getOpportunityNoteResponseOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(getOpportunityNoteResponseOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(getOpportunityNoteResponseOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(getOpportunityNoteResponseOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getOpportunityNoteResponseOneLinksItemRevisionMax)
})).max(getOpportunityNoteResponseOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
}))


export const listOpportunityNoteHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listOpportunityNoteHistoryQueryLimitDefault = 50;
export const listOpportunityNoteHistoryQueryLimitMax = 100;

export const listOpportunityNoteHistoryQueryOffsetDefault = 0;
export const listOpportunityNoteHistoryQueryOffsetMin = 0;



export const listOpportunityNoteHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listOpportunityNoteHistoryQueryLimitMax).default(listOpportunityNoteHistoryQueryLimitDefault),
  "offset": zod.int().min(listOpportunityNoteHistoryQueryOffsetMin).default(listOpportunityNoteHistoryQueryOffsetDefault)
})

export const listOpportunityNoteHistoryResponseItemsItemSnapshotOneTitleMax = 200;

export const listOpportunityNoteHistoryResponseItemsItemSnapshotOneNeedsMax = 5000;

export const listOpportunityNoteHistoryResponseItemsItemSnapshotOnePrioritiesMax = 5000;

export const listOpportunityNoteHistoryResponseItemsItemSnapshotOneConstraintsMax = 5000;

export const listOpportunityNoteHistoryResponseItemsItemSnapshotOneSuccessCriteriaMax = 5000;

export const listOpportunityNoteHistoryResponseItemsItemSnapshotOneSolutionOptionsMax = 5000;

export const listOpportunityNoteHistoryResponseItemsItemSnapshotOneNotesMax = 5000;

export const listOpportunityNoteHistoryResponseItemsItemSnapshotOneLinksItemRevisionMax = 200;

export const listOpportunityNoteHistoryResponseItemsItemSnapshotOneLinksMax = 30;



export const listOpportunityNoteHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actorId": zod.uuid(),
  "reason": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "snapshot": zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(listOpportunityNoteHistoryResponseItemsItemSnapshotOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(listOpportunityNoteHistoryResponseItemsItemSnapshotOneNeedsMax).nullish(),
  "priorities": zod.string().max(listOpportunityNoteHistoryResponseItemsItemSnapshotOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(listOpportunityNoteHistoryResponseItemsItemSnapshotOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(listOpportunityNoteHistoryResponseItemsItemSnapshotOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(listOpportunityNoteHistoryResponseItemsItemSnapshotOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(listOpportunityNoteHistoryResponseItemsItemSnapshotOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(listOpportunityNoteHistoryResponseItemsItemSnapshotOneLinksItemRevisionMax)
})).max(listOpportunityNoteHistoryResponseItemsItemSnapshotOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
}))
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const reviewOpportunityNoteBodyChangeReasonMin = 3;
export const reviewOpportunityNoteBodyChangeReasonMax = 500;


export const reviewOpportunityNoteBodyChangeFieldsTitleMax = 200;

export const reviewOpportunityNoteBodyChangeFieldsNeedsMax = 5000;

export const reviewOpportunityNoteBodyChangeFieldsPrioritiesMax = 5000;

export const reviewOpportunityNoteBodyChangeFieldsConstraintsMax = 5000;

export const reviewOpportunityNoteBodyChangeFieldsSuccessCriteriaMax = 5000;

export const reviewOpportunityNoteBodyChangeFieldsSolutionOptionsMax = 5000;

export const reviewOpportunityNoteBodyChangeFieldsNotesMax = 5000;

export const reviewOpportunityNoteBodyChangeFieldsLinksItemRevisionMax = 200;

export const reviewOpportunityNoteBodyChangeFieldsLinksMax = 30;



export const reviewOpportunityNoteBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['create', 'update']),
  "reason": zod.string().min(reviewOpportunityNoteBodyChangeReasonMin).max(reviewOpportunityNoteBodyChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "title": zod.string().min(1).max(reviewOpportunityNoteBodyChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "needs": zod.string().max(reviewOpportunityNoteBodyChangeFieldsNeedsMax).nullish(),
  "priorities": zod.string().max(reviewOpportunityNoteBodyChangeFieldsPrioritiesMax).nullish(),
  "constraints": zod.string().max(reviewOpportunityNoteBodyChangeFieldsConstraintsMax).nullish(),
  "successCriteria": zod.string().max(reviewOpportunityNoteBodyChangeFieldsSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(reviewOpportunityNoteBodyChangeFieldsSolutionOptionsMax).nullish(),
  "notes": zod.string().max(reviewOpportunityNoteBodyChangeFieldsNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewOpportunityNoteBodyChangeFieldsLinksItemRevisionMax)
})).max(reviewOpportunityNoteBodyChangeFieldsLinksMax).optional()
}).optional()
})
})

export const reviewOpportunityNoteResponseChangeReasonMin = 3;
export const reviewOpportunityNoteResponseChangeReasonMax = 500;


export const reviewOpportunityNoteResponseChangeFieldsTitleMax = 200;

export const reviewOpportunityNoteResponseChangeFieldsNeedsMax = 5000;

export const reviewOpportunityNoteResponseChangeFieldsPrioritiesMax = 5000;

export const reviewOpportunityNoteResponseChangeFieldsConstraintsMax = 5000;

export const reviewOpportunityNoteResponseChangeFieldsSuccessCriteriaMax = 5000;

export const reviewOpportunityNoteResponseChangeFieldsSolutionOptionsMax = 5000;

export const reviewOpportunityNoteResponseChangeFieldsNotesMax = 5000;

export const reviewOpportunityNoteResponseChangeFieldsLinksItemRevisionMax = 200;

export const reviewOpportunityNoteResponseChangeFieldsLinksMax = 30;

export const reviewOpportunityNoteResponseBeforeOneOneTitleMax = 200;

export const reviewOpportunityNoteResponseBeforeOneOneNeedsMax = 5000;

export const reviewOpportunityNoteResponseBeforeOneOnePrioritiesMax = 5000;

export const reviewOpportunityNoteResponseBeforeOneOneConstraintsMax = 5000;

export const reviewOpportunityNoteResponseBeforeOneOneSuccessCriteriaMax = 5000;

export const reviewOpportunityNoteResponseBeforeOneOneSolutionOptionsMax = 5000;

export const reviewOpportunityNoteResponseBeforeOneOneNotesMax = 5000;

export const reviewOpportunityNoteResponseBeforeOneOneLinksItemRevisionMax = 200;

export const reviewOpportunityNoteResponseBeforeOneOneLinksMax = 30;

export const reviewOpportunityNoteResponseAfterTitleMax = 200;

export const reviewOpportunityNoteResponseAfterNeedsMax = 5000;

export const reviewOpportunityNoteResponseAfterPrioritiesMax = 5000;

export const reviewOpportunityNoteResponseAfterConstraintsMax = 5000;

export const reviewOpportunityNoteResponseAfterSuccessCriteriaMax = 5000;

export const reviewOpportunityNoteResponseAfterSolutionOptionsMax = 5000;

export const reviewOpportunityNoteResponseAfterNotesMax = 5000;

export const reviewOpportunityNoteResponseAfterLinksItemRevisionMax = 200;

export const reviewOpportunityNoteResponseAfterLinksMax = 30;

export const reviewOpportunityNoteResponseReceiptOneOneTitleMax = 200;

export const reviewOpportunityNoteResponseReceiptOneOneNeedsMax = 5000;

export const reviewOpportunityNoteResponseReceiptOneOnePrioritiesMax = 5000;

export const reviewOpportunityNoteResponseReceiptOneOneConstraintsMax = 5000;

export const reviewOpportunityNoteResponseReceiptOneOneSuccessCriteriaMax = 5000;

export const reviewOpportunityNoteResponseReceiptOneOneSolutionOptionsMax = 5000;

export const reviewOpportunityNoteResponseReceiptOneOneNotesMax = 5000;

export const reviewOpportunityNoteResponseReceiptOneOneLinksItemRevisionMax = 200;

export const reviewOpportunityNoteResponseReceiptOneOneLinksMax = 30;



export const reviewOpportunityNoteResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'update']),
  "reason": zod.string().min(reviewOpportunityNoteResponseChangeReasonMin).max(reviewOpportunityNoteResponseChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "title": zod.string().min(1).max(reviewOpportunityNoteResponseChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "needs": zod.string().max(reviewOpportunityNoteResponseChangeFieldsNeedsMax).nullish(),
  "priorities": zod.string().max(reviewOpportunityNoteResponseChangeFieldsPrioritiesMax).nullish(),
  "constraints": zod.string().max(reviewOpportunityNoteResponseChangeFieldsConstraintsMax).nullish(),
  "successCriteria": zod.string().max(reviewOpportunityNoteResponseChangeFieldsSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(reviewOpportunityNoteResponseChangeFieldsSolutionOptionsMax).nullish(),
  "notes": zod.string().max(reviewOpportunityNoteResponseChangeFieldsNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewOpportunityNoteResponseChangeFieldsLinksItemRevisionMax)
})).max(reviewOpportunityNoteResponseChangeFieldsLinksMax).optional()
}).optional()
}),
  "before": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(reviewOpportunityNoteResponseBeforeOneOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(reviewOpportunityNoteResponseBeforeOneOneNeedsMax).nullish(),
  "priorities": zod.string().max(reviewOpportunityNoteResponseBeforeOneOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(reviewOpportunityNoteResponseBeforeOneOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(reviewOpportunityNoteResponseBeforeOneOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(reviewOpportunityNoteResponseBeforeOneOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(reviewOpportunityNoteResponseBeforeOneOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewOpportunityNoteResponseBeforeOneOneLinksItemRevisionMax)
})).max(reviewOpportunityNoteResponseBeforeOneOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
})),zod.null()]),
  "after": zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "title": zod.string().min(1).max(reviewOpportunityNoteResponseAfterTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "needs": zod.string().max(reviewOpportunityNoteResponseAfterNeedsMax).nullish(),
  "priorities": zod.string().max(reviewOpportunityNoteResponseAfterPrioritiesMax).nullish(),
  "constraints": zod.string().max(reviewOpportunityNoteResponseAfterConstraintsMax).nullish(),
  "successCriteria": zod.string().max(reviewOpportunityNoteResponseAfterSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(reviewOpportunityNoteResponseAfterSolutionOptionsMax).nullish(),
  "notes": zod.string().max(reviewOpportunityNoteResponseAfterNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewOpportunityNoteResponseAfterLinksItemRevisionMax)
})).max(reviewOpportunityNoteResponseAfterLinksMax).optional()
}),
  "receipt": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(reviewOpportunityNoteResponseReceiptOneOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(reviewOpportunityNoteResponseReceiptOneOneNeedsMax).nullish(),
  "priorities": zod.string().max(reviewOpportunityNoteResponseReceiptOneOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(reviewOpportunityNoteResponseReceiptOneOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(reviewOpportunityNoteResponseReceiptOneOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(reviewOpportunityNoteResponseReceiptOneOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(reviewOpportunityNoteResponseReceiptOneOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(reviewOpportunityNoteResponseReceiptOneOneLinksItemRevisionMax)
})).max(reviewOpportunityNoteResponseReceiptOneOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
})),zod.null()])
})


export const getOpportunityNoteReviewParams = zod.object({
  "id": zod.uuid()
})

export const getOpportunityNoteReviewResponseChangeReasonMin = 3;
export const getOpportunityNoteReviewResponseChangeReasonMax = 500;


export const getOpportunityNoteReviewResponseChangeFieldsTitleMax = 200;

export const getOpportunityNoteReviewResponseChangeFieldsNeedsMax = 5000;

export const getOpportunityNoteReviewResponseChangeFieldsPrioritiesMax = 5000;

export const getOpportunityNoteReviewResponseChangeFieldsConstraintsMax = 5000;

export const getOpportunityNoteReviewResponseChangeFieldsSuccessCriteriaMax = 5000;

export const getOpportunityNoteReviewResponseChangeFieldsSolutionOptionsMax = 5000;

export const getOpportunityNoteReviewResponseChangeFieldsNotesMax = 5000;

export const getOpportunityNoteReviewResponseChangeFieldsLinksItemRevisionMax = 200;

export const getOpportunityNoteReviewResponseChangeFieldsLinksMax = 30;

export const getOpportunityNoteReviewResponseBeforeOneOneTitleMax = 200;

export const getOpportunityNoteReviewResponseBeforeOneOneNeedsMax = 5000;

export const getOpportunityNoteReviewResponseBeforeOneOnePrioritiesMax = 5000;

export const getOpportunityNoteReviewResponseBeforeOneOneConstraintsMax = 5000;

export const getOpportunityNoteReviewResponseBeforeOneOneSuccessCriteriaMax = 5000;

export const getOpportunityNoteReviewResponseBeforeOneOneSolutionOptionsMax = 5000;

export const getOpportunityNoteReviewResponseBeforeOneOneNotesMax = 5000;

export const getOpportunityNoteReviewResponseBeforeOneOneLinksItemRevisionMax = 200;

export const getOpportunityNoteReviewResponseBeforeOneOneLinksMax = 30;

export const getOpportunityNoteReviewResponseAfterTitleMax = 200;

export const getOpportunityNoteReviewResponseAfterNeedsMax = 5000;

export const getOpportunityNoteReviewResponseAfterPrioritiesMax = 5000;

export const getOpportunityNoteReviewResponseAfterConstraintsMax = 5000;

export const getOpportunityNoteReviewResponseAfterSuccessCriteriaMax = 5000;

export const getOpportunityNoteReviewResponseAfterSolutionOptionsMax = 5000;

export const getOpportunityNoteReviewResponseAfterNotesMax = 5000;

export const getOpportunityNoteReviewResponseAfterLinksItemRevisionMax = 200;

export const getOpportunityNoteReviewResponseAfterLinksMax = 30;

export const getOpportunityNoteReviewResponseReceiptOneOneTitleMax = 200;

export const getOpportunityNoteReviewResponseReceiptOneOneNeedsMax = 5000;

export const getOpportunityNoteReviewResponseReceiptOneOnePrioritiesMax = 5000;

export const getOpportunityNoteReviewResponseReceiptOneOneConstraintsMax = 5000;

export const getOpportunityNoteReviewResponseReceiptOneOneSuccessCriteriaMax = 5000;

export const getOpportunityNoteReviewResponseReceiptOneOneSolutionOptionsMax = 5000;

export const getOpportunityNoteReviewResponseReceiptOneOneNotesMax = 5000;

export const getOpportunityNoteReviewResponseReceiptOneOneLinksItemRevisionMax = 200;

export const getOpportunityNoteReviewResponseReceiptOneOneLinksMax = 30;



export const getOpportunityNoteReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'update']),
  "reason": zod.string().min(getOpportunityNoteReviewResponseChangeReasonMin).max(getOpportunityNoteReviewResponseChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "title": zod.string().min(1).max(getOpportunityNoteReviewResponseChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "needs": zod.string().max(getOpportunityNoteReviewResponseChangeFieldsNeedsMax).nullish(),
  "priorities": zod.string().max(getOpportunityNoteReviewResponseChangeFieldsPrioritiesMax).nullish(),
  "constraints": zod.string().max(getOpportunityNoteReviewResponseChangeFieldsConstraintsMax).nullish(),
  "successCriteria": zod.string().max(getOpportunityNoteReviewResponseChangeFieldsSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(getOpportunityNoteReviewResponseChangeFieldsSolutionOptionsMax).nullish(),
  "notes": zod.string().max(getOpportunityNoteReviewResponseChangeFieldsNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getOpportunityNoteReviewResponseChangeFieldsLinksItemRevisionMax)
})).max(getOpportunityNoteReviewResponseChangeFieldsLinksMax).optional()
}).optional()
}),
  "before": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(getOpportunityNoteReviewResponseBeforeOneOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(getOpportunityNoteReviewResponseBeforeOneOneNeedsMax).nullish(),
  "priorities": zod.string().max(getOpportunityNoteReviewResponseBeforeOneOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(getOpportunityNoteReviewResponseBeforeOneOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(getOpportunityNoteReviewResponseBeforeOneOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(getOpportunityNoteReviewResponseBeforeOneOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(getOpportunityNoteReviewResponseBeforeOneOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getOpportunityNoteReviewResponseBeforeOneOneLinksItemRevisionMax)
})).max(getOpportunityNoteReviewResponseBeforeOneOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
})),zod.null()]),
  "after": zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "title": zod.string().min(1).max(getOpportunityNoteReviewResponseAfterTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "needs": zod.string().max(getOpportunityNoteReviewResponseAfterNeedsMax).nullish(),
  "priorities": zod.string().max(getOpportunityNoteReviewResponseAfterPrioritiesMax).nullish(),
  "constraints": zod.string().max(getOpportunityNoteReviewResponseAfterConstraintsMax).nullish(),
  "successCriteria": zod.string().max(getOpportunityNoteReviewResponseAfterSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(getOpportunityNoteReviewResponseAfterSolutionOptionsMax).nullish(),
  "notes": zod.string().max(getOpportunityNoteReviewResponseAfterNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getOpportunityNoteReviewResponseAfterLinksItemRevisionMax)
})).max(getOpportunityNoteReviewResponseAfterLinksMax).optional()
}),
  "receipt": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(getOpportunityNoteReviewResponseReceiptOneOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(getOpportunityNoteReviewResponseReceiptOneOneNeedsMax).nullish(),
  "priorities": zod.string().max(getOpportunityNoteReviewResponseReceiptOneOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(getOpportunityNoteReviewResponseReceiptOneOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(getOpportunityNoteReviewResponseReceiptOneOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(getOpportunityNoteReviewResponseReceiptOneOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(getOpportunityNoteReviewResponseReceiptOneOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(getOpportunityNoteReviewResponseReceiptOneOneLinksItemRevisionMax)
})).max(getOpportunityNoteReviewResponseReceiptOneOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
})),zod.null()])
})


export const confirmOpportunityNoteParams = zod.object({
  "id": zod.uuid()
})

export const confirmOpportunityNoteBodyHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const confirmOpportunityNoteBody = zod.object({
  "hash": zod.string().regex(confirmOpportunityNoteBodyHashRegExp),
  "confirmation": zod.enum(['CONFIRM'])
})

export const confirmOpportunityNoteResponseChangeReasonMin = 3;
export const confirmOpportunityNoteResponseChangeReasonMax = 500;


export const confirmOpportunityNoteResponseChangeFieldsTitleMax = 200;

export const confirmOpportunityNoteResponseChangeFieldsNeedsMax = 5000;

export const confirmOpportunityNoteResponseChangeFieldsPrioritiesMax = 5000;

export const confirmOpportunityNoteResponseChangeFieldsConstraintsMax = 5000;

export const confirmOpportunityNoteResponseChangeFieldsSuccessCriteriaMax = 5000;

export const confirmOpportunityNoteResponseChangeFieldsSolutionOptionsMax = 5000;

export const confirmOpportunityNoteResponseChangeFieldsNotesMax = 5000;

export const confirmOpportunityNoteResponseChangeFieldsLinksItemRevisionMax = 200;

export const confirmOpportunityNoteResponseChangeFieldsLinksMax = 30;

export const confirmOpportunityNoteResponseBeforeOneOneTitleMax = 200;

export const confirmOpportunityNoteResponseBeforeOneOneNeedsMax = 5000;

export const confirmOpportunityNoteResponseBeforeOneOnePrioritiesMax = 5000;

export const confirmOpportunityNoteResponseBeforeOneOneConstraintsMax = 5000;

export const confirmOpportunityNoteResponseBeforeOneOneSuccessCriteriaMax = 5000;

export const confirmOpportunityNoteResponseBeforeOneOneSolutionOptionsMax = 5000;

export const confirmOpportunityNoteResponseBeforeOneOneNotesMax = 5000;

export const confirmOpportunityNoteResponseBeforeOneOneLinksItemRevisionMax = 200;

export const confirmOpportunityNoteResponseBeforeOneOneLinksMax = 30;

export const confirmOpportunityNoteResponseAfterTitleMax = 200;

export const confirmOpportunityNoteResponseAfterNeedsMax = 5000;

export const confirmOpportunityNoteResponseAfterPrioritiesMax = 5000;

export const confirmOpportunityNoteResponseAfterConstraintsMax = 5000;

export const confirmOpportunityNoteResponseAfterSuccessCriteriaMax = 5000;

export const confirmOpportunityNoteResponseAfterSolutionOptionsMax = 5000;

export const confirmOpportunityNoteResponseAfterNotesMax = 5000;

export const confirmOpportunityNoteResponseAfterLinksItemRevisionMax = 200;

export const confirmOpportunityNoteResponseAfterLinksMax = 30;

export const confirmOpportunityNoteResponseReceiptOneOneTitleMax = 200;

export const confirmOpportunityNoteResponseReceiptOneOneNeedsMax = 5000;

export const confirmOpportunityNoteResponseReceiptOneOnePrioritiesMax = 5000;

export const confirmOpportunityNoteResponseReceiptOneOneConstraintsMax = 5000;

export const confirmOpportunityNoteResponseReceiptOneOneSuccessCriteriaMax = 5000;

export const confirmOpportunityNoteResponseReceiptOneOneSolutionOptionsMax = 5000;

export const confirmOpportunityNoteResponseReceiptOneOneNotesMax = 5000;

export const confirmOpportunityNoteResponseReceiptOneOneLinksItemRevisionMax = 200;

export const confirmOpportunityNoteResponseReceiptOneOneLinksMax = 30;



export const confirmOpportunityNoteResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'update']),
  "reason": zod.string().min(confirmOpportunityNoteResponseChangeReasonMin).max(confirmOpportunityNoteResponseChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "title": zod.string().min(1).max(confirmOpportunityNoteResponseChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "needs": zod.string().max(confirmOpportunityNoteResponseChangeFieldsNeedsMax).nullish(),
  "priorities": zod.string().max(confirmOpportunityNoteResponseChangeFieldsPrioritiesMax).nullish(),
  "constraints": zod.string().max(confirmOpportunityNoteResponseChangeFieldsConstraintsMax).nullish(),
  "successCriteria": zod.string().max(confirmOpportunityNoteResponseChangeFieldsSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(confirmOpportunityNoteResponseChangeFieldsSolutionOptionsMax).nullish(),
  "notes": zod.string().max(confirmOpportunityNoteResponseChangeFieldsNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmOpportunityNoteResponseChangeFieldsLinksItemRevisionMax)
})).max(confirmOpportunityNoteResponseChangeFieldsLinksMax).optional()
}).optional()
}),
  "before": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(confirmOpportunityNoteResponseBeforeOneOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(confirmOpportunityNoteResponseBeforeOneOneNeedsMax).nullish(),
  "priorities": zod.string().max(confirmOpportunityNoteResponseBeforeOneOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(confirmOpportunityNoteResponseBeforeOneOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(confirmOpportunityNoteResponseBeforeOneOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(confirmOpportunityNoteResponseBeforeOneOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(confirmOpportunityNoteResponseBeforeOneOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmOpportunityNoteResponseBeforeOneOneLinksItemRevisionMax)
})).max(confirmOpportunityNoteResponseBeforeOneOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
})),zod.null()]),
  "after": zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "title": zod.string().min(1).max(confirmOpportunityNoteResponseAfterTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "needs": zod.string().max(confirmOpportunityNoteResponseAfterNeedsMax).nullish(),
  "priorities": zod.string().max(confirmOpportunityNoteResponseAfterPrioritiesMax).nullish(),
  "constraints": zod.string().max(confirmOpportunityNoteResponseAfterConstraintsMax).nullish(),
  "successCriteria": zod.string().max(confirmOpportunityNoteResponseAfterSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(confirmOpportunityNoteResponseAfterSolutionOptionsMax).nullish(),
  "notes": zod.string().max(confirmOpportunityNoteResponseAfterNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmOpportunityNoteResponseAfterLinksItemRevisionMax)
})).max(confirmOpportunityNoteResponseAfterLinksMax).optional()
}),
  "receipt": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(confirmOpportunityNoteResponseReceiptOneOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(confirmOpportunityNoteResponseReceiptOneOneNeedsMax).nullish(),
  "priorities": zod.string().max(confirmOpportunityNoteResponseReceiptOneOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(confirmOpportunityNoteResponseReceiptOneOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(confirmOpportunityNoteResponseReceiptOneOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(confirmOpportunityNoteResponseReceiptOneOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(confirmOpportunityNoteResponseReceiptOneOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(confirmOpportunityNoteResponseReceiptOneOneLinksItemRevisionMax)
})).max(confirmOpportunityNoteResponseReceiptOneOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
})),zod.null()])
})


export const cancelOpportunityNoteReviewParams = zod.object({
  "id": zod.uuid()
})

export const cancelOpportunityNoteReviewResponseChangeReasonMin = 3;
export const cancelOpportunityNoteReviewResponseChangeReasonMax = 500;


export const cancelOpportunityNoteReviewResponseChangeFieldsTitleMax = 200;

export const cancelOpportunityNoteReviewResponseChangeFieldsNeedsMax = 5000;

export const cancelOpportunityNoteReviewResponseChangeFieldsPrioritiesMax = 5000;

export const cancelOpportunityNoteReviewResponseChangeFieldsConstraintsMax = 5000;

export const cancelOpportunityNoteReviewResponseChangeFieldsSuccessCriteriaMax = 5000;

export const cancelOpportunityNoteReviewResponseChangeFieldsSolutionOptionsMax = 5000;

export const cancelOpportunityNoteReviewResponseChangeFieldsNotesMax = 5000;

export const cancelOpportunityNoteReviewResponseChangeFieldsLinksItemRevisionMax = 200;

export const cancelOpportunityNoteReviewResponseChangeFieldsLinksMax = 30;

export const cancelOpportunityNoteReviewResponseBeforeOneOneTitleMax = 200;

export const cancelOpportunityNoteReviewResponseBeforeOneOneNeedsMax = 5000;

export const cancelOpportunityNoteReviewResponseBeforeOneOnePrioritiesMax = 5000;

export const cancelOpportunityNoteReviewResponseBeforeOneOneConstraintsMax = 5000;

export const cancelOpportunityNoteReviewResponseBeforeOneOneSuccessCriteriaMax = 5000;

export const cancelOpportunityNoteReviewResponseBeforeOneOneSolutionOptionsMax = 5000;

export const cancelOpportunityNoteReviewResponseBeforeOneOneNotesMax = 5000;

export const cancelOpportunityNoteReviewResponseBeforeOneOneLinksItemRevisionMax = 200;

export const cancelOpportunityNoteReviewResponseBeforeOneOneLinksMax = 30;

export const cancelOpportunityNoteReviewResponseAfterTitleMax = 200;

export const cancelOpportunityNoteReviewResponseAfterNeedsMax = 5000;

export const cancelOpportunityNoteReviewResponseAfterPrioritiesMax = 5000;

export const cancelOpportunityNoteReviewResponseAfterConstraintsMax = 5000;

export const cancelOpportunityNoteReviewResponseAfterSuccessCriteriaMax = 5000;

export const cancelOpportunityNoteReviewResponseAfterSolutionOptionsMax = 5000;

export const cancelOpportunityNoteReviewResponseAfterNotesMax = 5000;

export const cancelOpportunityNoteReviewResponseAfterLinksItemRevisionMax = 200;

export const cancelOpportunityNoteReviewResponseAfterLinksMax = 30;

export const cancelOpportunityNoteReviewResponseReceiptOneOneTitleMax = 200;

export const cancelOpportunityNoteReviewResponseReceiptOneOneNeedsMax = 5000;

export const cancelOpportunityNoteReviewResponseReceiptOneOnePrioritiesMax = 5000;

export const cancelOpportunityNoteReviewResponseReceiptOneOneConstraintsMax = 5000;

export const cancelOpportunityNoteReviewResponseReceiptOneOneSuccessCriteriaMax = 5000;

export const cancelOpportunityNoteReviewResponseReceiptOneOneSolutionOptionsMax = 5000;

export const cancelOpportunityNoteReviewResponseReceiptOneOneNotesMax = 5000;

export const cancelOpportunityNoteReviewResponseReceiptOneOneLinksItemRevisionMax = 200;

export const cancelOpportunityNoteReviewResponseReceiptOneOneLinksMax = 30;



export const cancelOpportunityNoteReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "change": zod.object({
  "operation": zod.enum(['create', 'update']),
  "reason": zod.string().min(cancelOpportunityNoteReviewResponseChangeReasonMin).max(cancelOpportunityNoteReviewResponseChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "title": zod.string().min(1).max(cancelOpportunityNoteReviewResponseChangeFieldsTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "needs": zod.string().max(cancelOpportunityNoteReviewResponseChangeFieldsNeedsMax).nullish(),
  "priorities": zod.string().max(cancelOpportunityNoteReviewResponseChangeFieldsPrioritiesMax).nullish(),
  "constraints": zod.string().max(cancelOpportunityNoteReviewResponseChangeFieldsConstraintsMax).nullish(),
  "successCriteria": zod.string().max(cancelOpportunityNoteReviewResponseChangeFieldsSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(cancelOpportunityNoteReviewResponseChangeFieldsSolutionOptionsMax).nullish(),
  "notes": zod.string().max(cancelOpportunityNoteReviewResponseChangeFieldsNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelOpportunityNoteReviewResponseChangeFieldsLinksItemRevisionMax)
})).max(cancelOpportunityNoteReviewResponseChangeFieldsLinksMax).optional()
}).optional()
}),
  "before": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(cancelOpportunityNoteReviewResponseBeforeOneOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(cancelOpportunityNoteReviewResponseBeforeOneOneNeedsMax).nullish(),
  "priorities": zod.string().max(cancelOpportunityNoteReviewResponseBeforeOneOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(cancelOpportunityNoteReviewResponseBeforeOneOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(cancelOpportunityNoteReviewResponseBeforeOneOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(cancelOpportunityNoteReviewResponseBeforeOneOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(cancelOpportunityNoteReviewResponseBeforeOneOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelOpportunityNoteReviewResponseBeforeOneOneLinksItemRevisionMax)
})).max(cancelOpportunityNoteReviewResponseBeforeOneOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
})),zod.null()]),
  "after": zod.object({
  "opportunityId": zod.uuid().optional(),
  "kind": zod.enum(['discovery', 'negotiation']).optional(),
  "title": zod.string().min(1).max(cancelOpportunityNoteReviewResponseAfterTitleMax).optional(),
  "recordedOn": zod.iso.date().optional(),
  "status": zod.enum(['open', 'settled']).optional(),
  "needs": zod.string().max(cancelOpportunityNoteReviewResponseAfterNeedsMax).nullish(),
  "priorities": zod.string().max(cancelOpportunityNoteReviewResponseAfterPrioritiesMax).nullish(),
  "constraints": zod.string().max(cancelOpportunityNoteReviewResponseAfterConstraintsMax).nullish(),
  "successCriteria": zod.string().max(cancelOpportunityNoteReviewResponseAfterSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(cancelOpportunityNoteReviewResponseAfterSolutionOptionsMax).nullish(),
  "notes": zod.string().max(cancelOpportunityNoteReviewResponseAfterNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelOpportunityNoteReviewResponseAfterLinksItemRevisionMax)
})).max(cancelOpportunityNoteReviewResponseAfterLinksMax).optional()
}),
  "receipt": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "kind": zod.enum(['discovery', 'negotiation']),
  "title": zod.string().min(1).max(cancelOpportunityNoteReviewResponseReceiptOneOneTitleMax),
  "recordedOn": zod.iso.date(),
  "status": zod.enum(['open', 'settled']),
  "needs": zod.string().max(cancelOpportunityNoteReviewResponseReceiptOneOneNeedsMax).nullish(),
  "priorities": zod.string().max(cancelOpportunityNoteReviewResponseReceiptOneOnePrioritiesMax).nullish(),
  "constraints": zod.string().max(cancelOpportunityNoteReviewResponseReceiptOneOneConstraintsMax).nullish(),
  "successCriteria": zod.string().max(cancelOpportunityNoteReviewResponseReceiptOneOneSuccessCriteriaMax).nullish(),
  "solutionOptions": zod.string().max(cancelOpportunityNoteReviewResponseReceiptOneOneSolutionOptionsMax).nullish(),
  "notes": zod.string().max(cancelOpportunityNoteReviewResponseReceiptOneOneNotesMax).nullish(),
  "links": zod.array(zod.object({
  "kind": zod.enum(['catalogue_product', 'catalogue_solution', 'catalogue_service', 'business_case', 'quote', 'tender', 'library', 'managed_document']),
  "id": zod.uuid(),
  "revision": zod.string().min(1).max(cancelOpportunityNoteReviewResponseReceiptOneOneLinksItemRevisionMax)
})).max(cancelOpportunityNoteReviewResponseReceiptOneOneLinksMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "unavailableLinks": zod.int()
})),zod.null()])
})


/**
 * @summary Complete scoped staff interaction and task worklist
 */
export const listStaffActivitiesQueryCategoryMax = 200;

export const listStaffActivitiesQuerySearchMax = 200;

export const listStaffActivitiesQueryOwnerIdMax = 200;

export const listStaffActivitiesQueryStatusMax = 120;

export const listStaffActivitiesQueryPriorityMax = 120;

export const listStaffActivitiesQueryIncludeTestDataDefault = false;
export const listStaffActivitiesQueryLimitDefault = 50;
export const listStaffActivitiesQueryLimitMax = 100;

export const listStaffActivitiesQueryOffsetDefault = 0;
export const listStaffActivitiesQueryOffsetMin = 0;



export const listStaffActivitiesQueryParams = zod.object({
  "category": zod.string().max(listStaffActivitiesQueryCategoryMax).optional(),
  "search": zod.string().max(listStaffActivitiesQuerySearchMax).optional(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "ownerId": zod.string().max(listStaffActivitiesQueryOwnerIdMax).optional(),
  "status": zod.string().max(listStaffActivitiesQueryStatusMax).optional(),
  "priority": zod.string().max(listStaffActivitiesQueryPriorityMax).optional(),
  "from": zod.iso.date().optional().describe('Inclusive scheduled end UTC date'),
  "to": zod.iso.date().optional().describe('Inclusive scheduled end UTC date'),
  "includeTestData": zod.boolean().default(listStaffActivitiesQueryIncludeTestDataDefault).describe('Include records flagged as test or demo data. They are excluded by default.'),
  "limit": zod.int().min(1).max(listStaffActivitiesQueryLimitMax).default(listStaffActivitiesQueryLimitDefault),
  "offset": zod.int().min(listStaffActivitiesQueryOffsetMin).default(listStaffActivitiesQueryOffsetDefault)
})


export const listStaffActivitiesResponseItemsItemDurationMinutesMin = 0;

export const listStaffActivitiesResponseItemsItemIsTestDataDefault = false;
export const listStaffActivitiesResponseTotalMin = 0;



export const listStaffActivitiesResponse = zod.object({
  "items": zod.array(zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listStaffActivitiesResponseItemsItemDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listStaffActivitiesResponseItemsItemIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listStaffActivitiesResponseTotalMin),
  "limit": zod.int().optional(),
  "offset": zod.int().optional()
})


export const getStaffActivityParams = zod.object({
  "id": zod.uuid()
})


export const getStaffActivityResponseDurationMinutesMin = 0;

export const getStaffActivityResponseIsTestDataDefault = false;

export const getStaffActivityResponse = zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getStaffActivityResponseDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getStaffActivityResponseIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


export const listStaffActivityHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listStaffActivityHistoryQueryLimitDefault = 50;
export const listStaffActivityHistoryQueryLimitMax = 100;

export const listStaffActivityHistoryQueryOffsetDefault = 0;
export const listStaffActivityHistoryQueryOffsetMin = 0;



export const listStaffActivityHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listStaffActivityHistoryQueryLimitMax).default(listStaffActivityHistoryQueryLimitDefault),
  "offset": zod.int().min(listStaffActivityHistoryQueryOffsetMin).default(listStaffActivityHistoryQueryOffsetDefault)
})


export const listStaffActivityHistoryResponseItemsItemSnapshotDurationMinutesMin = 0;

export const listStaffActivityHistoryResponseItemsItemSnapshotIsTestDataDefault = false;

export const listStaffActivityHistoryResponse = zod.object({
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "activityId": zod.uuid(),
  "operation": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "snapshot": zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listStaffActivityHistoryResponseItemsItemSnapshotDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listStaffActivityHistoryResponseItemsItemSnapshotIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})
}))
})


export const reviewStaffActivityBodyChangeReasonMin = 3;
export const reviewStaffActivityBodyChangeReasonMax = 500;


export const reviewStaffActivityBodyChangeFieldsSubjectMax = 500;

export const reviewStaffActivityBodyChangeFieldsBodyMax = 5000;

export const reviewStaffActivityBodyChangeFieldsStatusMax = 120;

export const reviewStaffActivityBodyChangeFieldsPriorityMax = 120;

export const reviewStaffActivityBodyChangeFieldsOwnerIdMax = 200;

export const reviewStaffActivityBodyChangeFieldsOwnerNameMax = 200;

export const reviewStaffActivityBodyChangeFieldsDurationMinutesMin = 0;

export const reviewStaffActivityBodyChangeFieldsParticipantsMax = 100;

export const reviewStaffActivityBodyChangeFieldsLocationMax = 500;

export const reviewStaffActivityBodyChangeFieldsCategoryMax = 120;

export const reviewStaffActivityBodyChangeFieldsExternalUrlMax = 2000;



export const reviewStaffActivityBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "reason": zod.string().min(reviewStaffActivityBodyChangeReasonMin).max(reviewStaffActivityBodyChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().max(reviewStaffActivityBodyChangeFieldsSubjectMax).nullish(),
  "body": zod.string().min(1).max(reviewStaffActivityBodyChangeFieldsBodyMax).optional(),
  "status": zod.string().max(reviewStaffActivityBodyChangeFieldsStatusMax).nullish(),
  "priority": zod.string().max(reviewStaffActivityBodyChangeFieldsPriorityMax).nullish(),
  "ownerId": zod.string().max(reviewStaffActivityBodyChangeFieldsOwnerIdMax).nullish(),
  "ownerName": zod.string().max(reviewStaffActivityBodyChangeFieldsOwnerNameMax).nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewStaffActivityBodyChangeFieldsDurationMinutesMin).nullish(),
  "participants": zod.array(zod.unknown()).max(reviewStaffActivityBodyChangeFieldsParticipantsMax).nullish(),
  "location": zod.string().max(reviewStaffActivityBodyChangeFieldsLocationMax).nullish(),
  "category": zod.string().max(reviewStaffActivityBodyChangeFieldsCategoryMax).nullish(),
  "externalUrl": zod.string().max(reviewStaffActivityBodyChangeFieldsExternalUrlMax).nullish(),
  "visibleToCustomer": zod.boolean().optional(),
  "isTestData": zod.boolean().optional()
}).optional()
})
})

export const reviewStaffActivityResponseChangeReasonMin = 3;
export const reviewStaffActivityResponseChangeReasonMax = 500;


export const reviewStaffActivityResponseChangeFieldsSubjectMax = 500;

export const reviewStaffActivityResponseChangeFieldsBodyMax = 5000;

export const reviewStaffActivityResponseChangeFieldsStatusMax = 120;

export const reviewStaffActivityResponseChangeFieldsPriorityMax = 120;

export const reviewStaffActivityResponseChangeFieldsOwnerIdMax = 200;

export const reviewStaffActivityResponseChangeFieldsOwnerNameMax = 200;

export const reviewStaffActivityResponseChangeFieldsDurationMinutesMin = 0;

export const reviewStaffActivityResponseChangeFieldsParticipantsMax = 100;

export const reviewStaffActivityResponseChangeFieldsLocationMax = 500;

export const reviewStaffActivityResponseChangeFieldsCategoryMax = 120;

export const reviewStaffActivityResponseChangeFieldsExternalUrlMax = 2000;


export const reviewStaffActivityResponseBeforeOneDurationMinutesMin = 0;

export const reviewStaffActivityResponseBeforeOneIsTestDataDefault = false;
export const reviewStaffActivityResponseAfterSubjectMax = 500;

export const reviewStaffActivityResponseAfterBodyMax = 5000;

export const reviewStaffActivityResponseAfterStatusMax = 120;

export const reviewStaffActivityResponseAfterPriorityMax = 120;

export const reviewStaffActivityResponseAfterOwnerIdMax = 200;

export const reviewStaffActivityResponseAfterOwnerNameMax = 200;

export const reviewStaffActivityResponseAfterDurationMinutesMin = 0;

export const reviewStaffActivityResponseAfterParticipantsMax = 100;

export const reviewStaffActivityResponseAfterLocationMax = 500;

export const reviewStaffActivityResponseAfterCategoryMax = 120;

export const reviewStaffActivityResponseAfterExternalUrlMax = 2000;


export const reviewStaffActivityResponseReceiptOneDurationMinutesMin = 0;

export const reviewStaffActivityResponseReceiptOneIsTestDataDefault = false;

export const reviewStaffActivityResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "reason": zod.string().min(reviewStaffActivityResponseChangeReasonMin).max(reviewStaffActivityResponseChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().max(reviewStaffActivityResponseChangeFieldsSubjectMax).nullish(),
  "body": zod.string().min(1).max(reviewStaffActivityResponseChangeFieldsBodyMax).optional(),
  "status": zod.string().max(reviewStaffActivityResponseChangeFieldsStatusMax).nullish(),
  "priority": zod.string().max(reviewStaffActivityResponseChangeFieldsPriorityMax).nullish(),
  "ownerId": zod.string().max(reviewStaffActivityResponseChangeFieldsOwnerIdMax).nullish(),
  "ownerName": zod.string().max(reviewStaffActivityResponseChangeFieldsOwnerNameMax).nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewStaffActivityResponseChangeFieldsDurationMinutesMin).nullish(),
  "participants": zod.array(zod.unknown()).max(reviewStaffActivityResponseChangeFieldsParticipantsMax).nullish(),
  "location": zod.string().max(reviewStaffActivityResponseChangeFieldsLocationMax).nullish(),
  "category": zod.string().max(reviewStaffActivityResponseChangeFieldsCategoryMax).nullish(),
  "externalUrl": zod.string().max(reviewStaffActivityResponseChangeFieldsExternalUrlMax).nullish(),
  "visibleToCustomer": zod.boolean().optional(),
  "isTestData": zod.boolean().optional()
}).optional()
}),
  "before": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewStaffActivityResponseBeforeOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewStaffActivityResponseBeforeOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "after": zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().max(reviewStaffActivityResponseAfterSubjectMax).nullish(),
  "body": zod.string().min(1).max(reviewStaffActivityResponseAfterBodyMax).optional(),
  "status": zod.string().max(reviewStaffActivityResponseAfterStatusMax).nullish(),
  "priority": zod.string().max(reviewStaffActivityResponseAfterPriorityMax).nullish(),
  "ownerId": zod.string().max(reviewStaffActivityResponseAfterOwnerIdMax).nullish(),
  "ownerName": zod.string().max(reviewStaffActivityResponseAfterOwnerNameMax).nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewStaffActivityResponseAfterDurationMinutesMin).nullish(),
  "participants": zod.array(zod.unknown()).max(reviewStaffActivityResponseAfterParticipantsMax).nullish(),
  "location": zod.string().max(reviewStaffActivityResponseAfterLocationMax).nullish(),
  "category": zod.string().max(reviewStaffActivityResponseAfterCategoryMax).nullish(),
  "externalUrl": zod.string().max(reviewStaffActivityResponseAfterExternalUrlMax).nullish(),
  "visibleToCustomer": zod.boolean().optional(),
  "isTestData": zod.boolean().optional()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(reviewStaffActivityResponseReceiptOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(reviewStaffActivityResponseReceiptOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
})


export const getStaffActivityReviewParams = zod.object({
  "id": zod.uuid()
})

export const getStaffActivityReviewResponseChangeReasonMin = 3;
export const getStaffActivityReviewResponseChangeReasonMax = 500;


export const getStaffActivityReviewResponseChangeFieldsSubjectMax = 500;

export const getStaffActivityReviewResponseChangeFieldsBodyMax = 5000;

export const getStaffActivityReviewResponseChangeFieldsStatusMax = 120;

export const getStaffActivityReviewResponseChangeFieldsPriorityMax = 120;

export const getStaffActivityReviewResponseChangeFieldsOwnerIdMax = 200;

export const getStaffActivityReviewResponseChangeFieldsOwnerNameMax = 200;

export const getStaffActivityReviewResponseChangeFieldsDurationMinutesMin = 0;

export const getStaffActivityReviewResponseChangeFieldsParticipantsMax = 100;

export const getStaffActivityReviewResponseChangeFieldsLocationMax = 500;

export const getStaffActivityReviewResponseChangeFieldsCategoryMax = 120;

export const getStaffActivityReviewResponseChangeFieldsExternalUrlMax = 2000;


export const getStaffActivityReviewResponseBeforeOneDurationMinutesMin = 0;

export const getStaffActivityReviewResponseBeforeOneIsTestDataDefault = false;
export const getStaffActivityReviewResponseAfterSubjectMax = 500;

export const getStaffActivityReviewResponseAfterBodyMax = 5000;

export const getStaffActivityReviewResponseAfterStatusMax = 120;

export const getStaffActivityReviewResponseAfterPriorityMax = 120;

export const getStaffActivityReviewResponseAfterOwnerIdMax = 200;

export const getStaffActivityReviewResponseAfterOwnerNameMax = 200;

export const getStaffActivityReviewResponseAfterDurationMinutesMin = 0;

export const getStaffActivityReviewResponseAfterParticipantsMax = 100;

export const getStaffActivityReviewResponseAfterLocationMax = 500;

export const getStaffActivityReviewResponseAfterCategoryMax = 120;

export const getStaffActivityReviewResponseAfterExternalUrlMax = 2000;


export const getStaffActivityReviewResponseReceiptOneDurationMinutesMin = 0;

export const getStaffActivityReviewResponseReceiptOneIsTestDataDefault = false;

export const getStaffActivityReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "reason": zod.string().min(getStaffActivityReviewResponseChangeReasonMin).max(getStaffActivityReviewResponseChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().max(getStaffActivityReviewResponseChangeFieldsSubjectMax).nullish(),
  "body": zod.string().min(1).max(getStaffActivityReviewResponseChangeFieldsBodyMax).optional(),
  "status": zod.string().max(getStaffActivityReviewResponseChangeFieldsStatusMax).nullish(),
  "priority": zod.string().max(getStaffActivityReviewResponseChangeFieldsPriorityMax).nullish(),
  "ownerId": zod.string().max(getStaffActivityReviewResponseChangeFieldsOwnerIdMax).nullish(),
  "ownerName": zod.string().max(getStaffActivityReviewResponseChangeFieldsOwnerNameMax).nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getStaffActivityReviewResponseChangeFieldsDurationMinutesMin).nullish(),
  "participants": zod.array(zod.unknown()).max(getStaffActivityReviewResponseChangeFieldsParticipantsMax).nullish(),
  "location": zod.string().max(getStaffActivityReviewResponseChangeFieldsLocationMax).nullish(),
  "category": zod.string().max(getStaffActivityReviewResponseChangeFieldsCategoryMax).nullish(),
  "externalUrl": zod.string().max(getStaffActivityReviewResponseChangeFieldsExternalUrlMax).nullish(),
  "visibleToCustomer": zod.boolean().optional(),
  "isTestData": zod.boolean().optional()
}).optional()
}),
  "before": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getStaffActivityReviewResponseBeforeOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getStaffActivityReviewResponseBeforeOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "after": zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().max(getStaffActivityReviewResponseAfterSubjectMax).nullish(),
  "body": zod.string().min(1).max(getStaffActivityReviewResponseAfterBodyMax).optional(),
  "status": zod.string().max(getStaffActivityReviewResponseAfterStatusMax).nullish(),
  "priority": zod.string().max(getStaffActivityReviewResponseAfterPriorityMax).nullish(),
  "ownerId": zod.string().max(getStaffActivityReviewResponseAfterOwnerIdMax).nullish(),
  "ownerName": zod.string().max(getStaffActivityReviewResponseAfterOwnerNameMax).nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getStaffActivityReviewResponseAfterDurationMinutesMin).nullish(),
  "participants": zod.array(zod.unknown()).max(getStaffActivityReviewResponseAfterParticipantsMax).nullish(),
  "location": zod.string().max(getStaffActivityReviewResponseAfterLocationMax).nullish(),
  "category": zod.string().max(getStaffActivityReviewResponseAfterCategoryMax).nullish(),
  "externalUrl": zod.string().max(getStaffActivityReviewResponseAfterExternalUrlMax).nullish(),
  "visibleToCustomer": zod.boolean().optional(),
  "isTestData": zod.boolean().optional()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getStaffActivityReviewResponseReceiptOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getStaffActivityReviewResponseReceiptOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
})


export const confirmStaffActivityParams = zod.object({
  "id": zod.uuid()
})

export const confirmStaffActivityBodyHashMin = 64;
export const confirmStaffActivityBodyHashMax = 64;



export const confirmStaffActivityBody = zod.object({
  "hash": zod.string().min(confirmStaffActivityBodyHashMin).max(confirmStaffActivityBodyHashMax),
  "confirmation": zod.enum(['CONFIRM'])
})

export const confirmStaffActivityResponseChangeReasonMin = 3;
export const confirmStaffActivityResponseChangeReasonMax = 500;


export const confirmStaffActivityResponseChangeFieldsSubjectMax = 500;

export const confirmStaffActivityResponseChangeFieldsBodyMax = 5000;

export const confirmStaffActivityResponseChangeFieldsStatusMax = 120;

export const confirmStaffActivityResponseChangeFieldsPriorityMax = 120;

export const confirmStaffActivityResponseChangeFieldsOwnerIdMax = 200;

export const confirmStaffActivityResponseChangeFieldsOwnerNameMax = 200;

export const confirmStaffActivityResponseChangeFieldsDurationMinutesMin = 0;

export const confirmStaffActivityResponseChangeFieldsParticipantsMax = 100;

export const confirmStaffActivityResponseChangeFieldsLocationMax = 500;

export const confirmStaffActivityResponseChangeFieldsCategoryMax = 120;

export const confirmStaffActivityResponseChangeFieldsExternalUrlMax = 2000;


export const confirmStaffActivityResponseBeforeOneDurationMinutesMin = 0;

export const confirmStaffActivityResponseBeforeOneIsTestDataDefault = false;
export const confirmStaffActivityResponseAfterSubjectMax = 500;

export const confirmStaffActivityResponseAfterBodyMax = 5000;

export const confirmStaffActivityResponseAfterStatusMax = 120;

export const confirmStaffActivityResponseAfterPriorityMax = 120;

export const confirmStaffActivityResponseAfterOwnerIdMax = 200;

export const confirmStaffActivityResponseAfterOwnerNameMax = 200;

export const confirmStaffActivityResponseAfterDurationMinutesMin = 0;

export const confirmStaffActivityResponseAfterParticipantsMax = 100;

export const confirmStaffActivityResponseAfterLocationMax = 500;

export const confirmStaffActivityResponseAfterCategoryMax = 120;

export const confirmStaffActivityResponseAfterExternalUrlMax = 2000;


export const confirmStaffActivityResponseReceiptOneDurationMinutesMin = 0;

export const confirmStaffActivityResponseReceiptOneIsTestDataDefault = false;

export const confirmStaffActivityResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "reason": zod.string().min(confirmStaffActivityResponseChangeReasonMin).max(confirmStaffActivityResponseChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().max(confirmStaffActivityResponseChangeFieldsSubjectMax).nullish(),
  "body": zod.string().min(1).max(confirmStaffActivityResponseChangeFieldsBodyMax).optional(),
  "status": zod.string().max(confirmStaffActivityResponseChangeFieldsStatusMax).nullish(),
  "priority": zod.string().max(confirmStaffActivityResponseChangeFieldsPriorityMax).nullish(),
  "ownerId": zod.string().max(confirmStaffActivityResponseChangeFieldsOwnerIdMax).nullish(),
  "ownerName": zod.string().max(confirmStaffActivityResponseChangeFieldsOwnerNameMax).nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmStaffActivityResponseChangeFieldsDurationMinutesMin).nullish(),
  "participants": zod.array(zod.unknown()).max(confirmStaffActivityResponseChangeFieldsParticipantsMax).nullish(),
  "location": zod.string().max(confirmStaffActivityResponseChangeFieldsLocationMax).nullish(),
  "category": zod.string().max(confirmStaffActivityResponseChangeFieldsCategoryMax).nullish(),
  "externalUrl": zod.string().max(confirmStaffActivityResponseChangeFieldsExternalUrlMax).nullish(),
  "visibleToCustomer": zod.boolean().optional(),
  "isTestData": zod.boolean().optional()
}).optional()
}),
  "before": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmStaffActivityResponseBeforeOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(confirmStaffActivityResponseBeforeOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "after": zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().max(confirmStaffActivityResponseAfterSubjectMax).nullish(),
  "body": zod.string().min(1).max(confirmStaffActivityResponseAfterBodyMax).optional(),
  "status": zod.string().max(confirmStaffActivityResponseAfterStatusMax).nullish(),
  "priority": zod.string().max(confirmStaffActivityResponseAfterPriorityMax).nullish(),
  "ownerId": zod.string().max(confirmStaffActivityResponseAfterOwnerIdMax).nullish(),
  "ownerName": zod.string().max(confirmStaffActivityResponseAfterOwnerNameMax).nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmStaffActivityResponseAfterDurationMinutesMin).nullish(),
  "participants": zod.array(zod.unknown()).max(confirmStaffActivityResponseAfterParticipantsMax).nullish(),
  "location": zod.string().max(confirmStaffActivityResponseAfterLocationMax).nullish(),
  "category": zod.string().max(confirmStaffActivityResponseAfterCategoryMax).nullish(),
  "externalUrl": zod.string().max(confirmStaffActivityResponseAfterExternalUrlMax).nullish(),
  "visibleToCustomer": zod.boolean().optional(),
  "isTestData": zod.boolean().optional()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(confirmStaffActivityResponseReceiptOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(confirmStaffActivityResponseReceiptOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
})


export const cancelStaffActivityReviewParams = zod.object({
  "id": zod.uuid()
})

export const cancelStaffActivityReviewResponseChangeReasonMin = 3;
export const cancelStaffActivityReviewResponseChangeReasonMax = 500;


export const cancelStaffActivityReviewResponseChangeFieldsSubjectMax = 500;

export const cancelStaffActivityReviewResponseChangeFieldsBodyMax = 5000;

export const cancelStaffActivityReviewResponseChangeFieldsStatusMax = 120;

export const cancelStaffActivityReviewResponseChangeFieldsPriorityMax = 120;

export const cancelStaffActivityReviewResponseChangeFieldsOwnerIdMax = 200;

export const cancelStaffActivityReviewResponseChangeFieldsOwnerNameMax = 200;

export const cancelStaffActivityReviewResponseChangeFieldsDurationMinutesMin = 0;

export const cancelStaffActivityReviewResponseChangeFieldsParticipantsMax = 100;

export const cancelStaffActivityReviewResponseChangeFieldsLocationMax = 500;

export const cancelStaffActivityReviewResponseChangeFieldsCategoryMax = 120;

export const cancelStaffActivityReviewResponseChangeFieldsExternalUrlMax = 2000;


export const cancelStaffActivityReviewResponseBeforeOneDurationMinutesMin = 0;

export const cancelStaffActivityReviewResponseBeforeOneIsTestDataDefault = false;
export const cancelStaffActivityReviewResponseAfterSubjectMax = 500;

export const cancelStaffActivityReviewResponseAfterBodyMax = 5000;

export const cancelStaffActivityReviewResponseAfterStatusMax = 120;

export const cancelStaffActivityReviewResponseAfterPriorityMax = 120;

export const cancelStaffActivityReviewResponseAfterOwnerIdMax = 200;

export const cancelStaffActivityReviewResponseAfterOwnerNameMax = 200;

export const cancelStaffActivityReviewResponseAfterDurationMinutesMin = 0;

export const cancelStaffActivityReviewResponseAfterParticipantsMax = 100;

export const cancelStaffActivityReviewResponseAfterLocationMax = 500;

export const cancelStaffActivityReviewResponseAfterCategoryMax = 120;

export const cancelStaffActivityReviewResponseAfterExternalUrlMax = 2000;


export const cancelStaffActivityReviewResponseReceiptOneDurationMinutesMin = 0;

export const cancelStaffActivityReviewResponseReceiptOneIsTestDataDefault = false;

export const cancelStaffActivityReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'complete', 'reopen']),
  "reason": zod.string().min(cancelStaffActivityReviewResponseChangeReasonMin).max(cancelStaffActivityReviewResponseChangeReasonMax),
  "id": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().max(cancelStaffActivityReviewResponseChangeFieldsSubjectMax).nullish(),
  "body": zod.string().min(1).max(cancelStaffActivityReviewResponseChangeFieldsBodyMax).optional(),
  "status": zod.string().max(cancelStaffActivityReviewResponseChangeFieldsStatusMax).nullish(),
  "priority": zod.string().max(cancelStaffActivityReviewResponseChangeFieldsPriorityMax).nullish(),
  "ownerId": zod.string().max(cancelStaffActivityReviewResponseChangeFieldsOwnerIdMax).nullish(),
  "ownerName": zod.string().max(cancelStaffActivityReviewResponseChangeFieldsOwnerNameMax).nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelStaffActivityReviewResponseChangeFieldsDurationMinutesMin).nullish(),
  "participants": zod.array(zod.unknown()).max(cancelStaffActivityReviewResponseChangeFieldsParticipantsMax).nullish(),
  "location": zod.string().max(cancelStaffActivityReviewResponseChangeFieldsLocationMax).nullish(),
  "category": zod.string().max(cancelStaffActivityReviewResponseChangeFieldsCategoryMax).nullish(),
  "externalUrl": zod.string().max(cancelStaffActivityReviewResponseChangeFieldsExternalUrlMax).nullish(),
  "visibleToCustomer": zod.boolean().optional(),
  "isTestData": zod.boolean().optional()
}).optional()
}),
  "before": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelStaffActivityReviewResponseBeforeOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(cancelStaffActivityReviewResponseBeforeOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "after": zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().max(cancelStaffActivityReviewResponseAfterSubjectMax).nullish(),
  "body": zod.string().min(1).max(cancelStaffActivityReviewResponseAfterBodyMax).optional(),
  "status": zod.string().max(cancelStaffActivityReviewResponseAfterStatusMax).nullish(),
  "priority": zod.string().max(cancelStaffActivityReviewResponseAfterPriorityMax).nullish(),
  "ownerId": zod.string().max(cancelStaffActivityReviewResponseAfterOwnerIdMax).nullish(),
  "ownerName": zod.string().max(cancelStaffActivityReviewResponseAfterOwnerNameMax).nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelStaffActivityReviewResponseAfterDurationMinutesMin).nullish(),
  "participants": zod.array(zod.unknown()).max(cancelStaffActivityReviewResponseAfterParticipantsMax).nullish(),
  "location": zod.string().max(cancelStaffActivityReviewResponseAfterLocationMax).nullish(),
  "category": zod.string().max(cancelStaffActivityReviewResponseAfterCategoryMax).nullish(),
  "externalUrl": zod.string().max(cancelStaffActivityReviewResponseAfterExternalUrlMax).nullish(),
  "visibleToCustomer": zod.boolean().optional(),
  "isTestData": zod.boolean().optional()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "receipt": zod.union([zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(cancelStaffActivityReviewResponseReceiptOneDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(cancelStaffActivityReviewResponseReceiptOneIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()])
})


/**
 * @summary List activities (optionally scoped to one record)
 */
export const listActivitiesQueryIncludeTestDataDefault = false;
export const listActivitiesQueryLimitDefault = 50;
export const listActivitiesQueryLimitMax = 100;

export const listActivitiesQueryOffsetDefault = 0;
export const listActivitiesQueryOffsetMin = 0;



export const listActivitiesQueryParams = zod.object({
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']).optional(),
  "entityId": zod.uuid().optional(),
  "includeTestData": zod.boolean().default(listActivitiesQueryIncludeTestDataDefault).describe('Include records flagged as test or demo data. They are excluded by default.'),
  "limit": zod.int().min(1).max(listActivitiesQueryLimitMax).default(listActivitiesQueryLimitDefault),
  "offset": zod.int().min(listActivitiesQueryOffsetMin).default(listActivitiesQueryOffsetDefault)
})


export const listActivitiesResponseItemsItemDurationMinutesMin = 0;

export const listActivitiesResponseItemsItemIsTestDataDefault = false;
export const listActivitiesResponseTotalMin = 0;



export const listActivitiesResponse = zod.object({
  "items": zod.array(zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(listActivitiesResponseItemsItemDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(listActivitiesResponseItemsItemIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listActivitiesResponseTotalMin),
  "limit": zod.int().optional(),
  "offset": zod.int().optional()
})


/**
 * @summary Log an activity against a record
 */

export const createActivityBodyDurationMinutesMin = 0;

export const createActivityBodyIsTestDataDefault = false;
export const createActivityBodyBodyMax = 5000;

export const createActivityBodyVisibleToCustomerDefault = false;

export const createActivityBody = zod.object({
  "requestKey": zod.uuid().optional(),
  "expectedPursuitRevision": zod.int().min(1).optional(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(createActivityBodyDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(createActivityBodyIsTestDataDefault),
  "body": zod.string().min(1).max(createActivityBodyBodyMax),
  "visibleToCustomer": zod.boolean().default(createActivityBodyVisibleToCustomerDefault).describe('Show this update to the customer in the portal.')
})


export const createActivityResponseDurationMinutesMin = 0;

export const createActivityResponseIsTestDataDefault = false;

export const createActivityResponse = zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(createActivityResponseDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(createActivityResponseIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get one activity
 */
export const getActivityParams = zod.object({
  "id": zod.uuid()
})


export const getActivityResponseDurationMinutesMin = 0;

export const getActivityResponseIsTestDataDefault = false;

export const getActivityResponse = zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(getActivityResponseDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(getActivityResponseIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update an activity
 */
export const updateActivityParams = zod.object({
  "id": zod.uuid()
})


export const updateActivityBodyDurationMinutesMin = 0;

export const updateActivityBodyIsTestDataDefault = false;
export const updateActivityBodyBodyMax = 5000;



export const updateActivityBody = zod.object({
  "expectedPursuitRevision": zod.int().min(1).optional(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']).optional(),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(updateActivityBodyDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(updateActivityBodyIsTestDataDefault),
  "body": zod.string().min(1).max(updateActivityBodyBodyMax).optional(),
  "visibleToCustomer": zod.boolean().optional().describe('Show this update to the customer in the portal.')
})


export const updateActivityResponseDurationMinutesMin = 0;

export const updateActivityResponseIsTestDataDefault = false;

export const updateActivityResponse = zod.object({
  "version": zod.int().min(1).optional(),
  "updatedAt": zod.iso.datetime({"offset":true}).optional(),
  "bidLinks": zod.array(zod.object({
  "tenderId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "documentIds": zod.array(zod.uuid())
})).optional(),
  "visibleToCustomer": zod.boolean().describe('When true, this update is shown to the customer in the portal.'),
  "id": zod.uuid(),
  "entityType": zod.enum(['account', 'contact', 'enquiry', 'opportunity', 'government_pursuit']),
  "entityId": zod.uuid(),
  "type": zod.enum(['note', 'status_change', 'call', 'email', 'meeting', 'assignment', 'conversion']),
  "subject": zod.string().nullish(),
  "status": zod.string().nullish(),
  "priority": zod.string().nullish(),
  "scheduledStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduledEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualStartAt": zod.iso.datetime({"offset":true}).nullish(),
  "actualEndAt": zod.iso.datetime({"offset":true}).nullish(),
  "durationMinutes": zod.int().min(updateActivityResponseDurationMinutesMin).nullish(),
  "ownerName": zod.string().nullish(),
  "ownerId": zod.string().nullish(),
  "participants": zod.array(zod.unknown()).nullish(),
  "location": zod.string().nullish(),
  "category": zod.string().nullish(),
  "externalUrl": zod.string().nullish(),
  "isTestData": zod.boolean().default(updateActivityResponseIsTestDataDefault),
  "body": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete an activity
 */
export const deleteActivityParams = zod.object({
  "id": zod.uuid()
})

export const deleteActivityResponse = zod.void()


/**
 * @summary List records currently flagged as test data for review
 */
export const getTestDataReportResponseTotalMin = 0;



export const getTestDataReportResponse = zod.object({
  "generatedAt": zod.iso.datetime({"offset":true}),
  "total": zod.int().min(getTestDataReportResponseTotalMin),
  "items": zod.array(zod.object({
  "entityType": zod.enum(['account', 'contact', 'opportunity', 'partner', 'activity']),
  "id": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string()
}))
})


/**
 * @summary List partners
 */
export const listPartnersQuerySearchMax = 200;

export const listPartnersQueryAgreementsExpiringWithinDaysMax = 365;

export const listPartnersQueryIncludeTestDataDefault = false;
export const listPartnersQueryLimitDefault = 50;
export const listPartnersQueryLimitMax = 100;

export const listPartnersQueryOffsetDefault = 0;
export const listPartnersQueryOffsetMin = 0;



export const listPartnersQueryParams = zod.object({
  "status": zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']).optional(),
  "type": zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']).optional(),
  "search": zod.string().max(listPartnersQuerySearchMax).optional().describe('Case-insensitive match on partner name.'),
  "agreementsExpiringWithinDays": zod.int().min(1).max(listPartnersQueryAgreementsExpiringWithinDaysMax).optional().describe('Return partners with an active agreement expiring within this many days.'),
  "includeTestData": zod.boolean().default(listPartnersQueryIncludeTestDataDefault).describe('Include records flagged as test or demo data. They are excluded by default.'),
  "limit": zod.int().min(1).max(listPartnersQueryLimitMax).default(listPartnersQueryLimitDefault),
  "offset": zod.int().min(listPartnersQueryOffsetMin).default(listPartnersQueryOffsetDefault)
})

export const listPartnersResponseItemsItemOneIsTestDataDefault = false;
export const listPartnersResponseTotalMin = 0;



export const listPartnersResponse = zod.object({
  "items": zod.array(zod.object({
  "website": zod.string().nullish(),
  "organisationType": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "isTestData": zod.boolean().default(listPartnersResponseItemsItemOneIsTestDataDefault),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().optional(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "type": zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),
  "status": zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listPartnersResponseTotalMin),
  "limit": zod.int().optional(),
  "offset": zod.int().optional()
})


/**
 * @summary Create a partner
 */
export const createPartnerBodyOneIsTestDataDefault = false;
export const createPartnerBodyTwoNameMax = 200;



export const createPartnerBody = zod.object({
  "website": zod.string().nullish(),
  "organisationType": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "isTestData": zod.boolean().default(createPartnerBodyOneIsTestDataDefault),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().optional(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "name": zod.string().min(1).max(createPartnerBodyTwoNameMax),
  "type": zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']).optional(),
  "status": zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']).optional()
}))

export const createPartnerResponseOneIsTestDataDefault = false;

export const createPartnerResponse = zod.object({
  "website": zod.string().nullish(),
  "organisationType": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "isTestData": zod.boolean().default(createPartnerResponseOneIsTestDataDefault),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().optional(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "type": zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),
  "status": zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Get one partner
 */
export const getPartnerParams = zod.object({
  "id": zod.uuid()
})

export const getPartnerResponseOneIsTestDataDefault = false;

export const getPartnerResponse = zod.object({
  "website": zod.string().nullish(),
  "organisationType": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "isTestData": zod.boolean().default(getPartnerResponseOneIsTestDataDefault),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().optional(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "type": zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),
  "status": zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a partner
 */
export const updatePartnerParams = zod.object({
  "id": zod.uuid()
})

export const updatePartnerBodyOneIsTestDataDefault = false;
export const updatePartnerBodyTwoNameMax = 200;



export const updatePartnerBody = zod.object({
  "website": zod.string().nullish(),
  "organisationType": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "isTestData": zod.boolean().default(updatePartnerBodyOneIsTestDataDefault),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().optional(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "name": zod.string().min(1).max(updatePartnerBodyTwoNameMax).optional(),
  "type": zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']).optional(),
  "status": zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']).optional()
}))

export const updatePartnerResponseOneIsTestDataDefault = false;

export const updatePartnerResponse = zod.object({
  "website": zod.string().nullish(),
  "organisationType": zod.string().nullish(),
  "industry": zod.string().nullish(),
  "size": zod.string().nullish(),
  "description": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "addressLine1": zod.string().nullish(),
  "addressLine2": zod.string().nullish(),
  "city": zod.string().nullish(),
  "stateProvince": zod.string().nullish(),
  "postcode": zod.string().nullish(),
  "country": zod.string().nullish(),
  "accountManagerName": zod.string().nullish(),
  "lastContactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "isTestData": zod.boolean().default(updatePartnerResponseOneIsTestDataDefault),
  "primaryContactName": zod.string().nullish(),
  "primaryContactEmail": zod.string().nullish(),
  "primaryContactPhone": zod.string().nullish(),
  "showPricesInQuotes": zod.boolean().optional(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "type": zod.enum(['reseller', 'referral', 'technology', 'consulting', 'strategic']),
  "status": zod.enum(['identified', 'qualified', 'onboarding', 'active', 'review', 'inactive']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Remove the partner classification from an account
 */
export const deletePartnerParams = zod.object({
  "id": zod.uuid()
})

export const deletePartnerResponse = zod.void()


/**
 * @summary List portal memberships for an account (internal staff)
 */
export const listPartnerEmailsQueryParams = zod.object({
  "accountId": zod.uuid()
})

export const listPartnerEmailsResponseTotalMin = 0;



export const listPartnerEmailsResponse = zod.object({
  "items": zod.array(zod.object({
  "name": zod.string().nullish(),
  "role": zod.string().nullish(),
  "isActive": zod.boolean(),
  "isAdmin": zod.boolean()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "email": zod.email(),
  "lastSignedInAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listPartnerEmailsResponseTotalMin)
})


/**
 * @summary Add a portal membership to an account (internal staff)
 */
export const createPartnerEmailBody = zod.object({
  "name": zod.string().nullish(),
  "role": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "isAdmin": zod.boolean().optional()
}).and(zod.object({
  "accountId": zod.uuid(),
  "email": zod.email()
}))

export const createPartnerEmailResponse = zod.object({
  "name": zod.string().nullish(),
  "role": zod.string().nullish(),
  "isActive": zod.boolean(),
  "isAdmin": zod.boolean()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "email": zod.email(),
  "lastSignedInAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a portal membership (internal staff)
 */
export const updatePartnerEmailParams = zod.object({
  "id": zod.uuid()
})

export const updatePartnerEmailBody = zod.object({
  "name": zod.string().nullish(),
  "role": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "isAdmin": zod.boolean().optional()
}).and(zod.object({
  "email": zod.email().optional()
}))

export const updatePartnerEmailResponse = zod.object({
  "name": zod.string().nullish(),
  "role": zod.string().nullish(),
  "isActive": zod.boolean(),
  "isAdmin": zod.boolean()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "email": zod.email(),
  "lastSignedInAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a never-used portal membership (internal staff)
 */
export const deletePartnerEmailParams = zod.object({
  "id": zod.uuid()
})

export const deletePartnerEmailResponse = zod.void()


/**
 * @summary List consumer portal shares for a person account (internal staff)
 */
export const listPortalSharesForStaffQueryParams = zod.object({
  "accountId": zod.uuid()
})

export const listPortalSharesForStaffResponseTotalMin = 0;



export const listPortalSharesForStaffResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "ownerAccountId": zod.uuid(),
  "granteeEmail": zod.email(),
  "granteeName": zod.string().nullable(),
  "permission": zod.enum(['view', 'act']),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdByEmail": zod.email(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPortalSharesForStaffResponseTotalMin)
})


/**
 * @summary Revoke a consumer portal share (internal staff)
 */
export const revokePortalShareForStaffParams = zod.object({
  "id": zod.uuid()
})

export const revokePortalShareForStaffQueryParams = zod.object({
  "accountId": zod.uuid()
})

export const revokePortalShareForStaffResponse = zod.void()


/**
 * @summary List agreements for a partner
 */
export const listPartnerAgreementsQueryParams = zod.object({
  "accountId": zod.uuid()
})

export const listPartnerAgreementsResponseTotalMin = 0;



export const listPartnerAgreementsResponse = zod.object({
  "items": zod.array(zod.object({
  "signedDate": zod.iso.datetime({"offset":true}).nullish(),
  "expiryDate": zod.iso.datetime({"offset":true}).nullish(),
  "documentUrl": zod.string().nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "title": zod.string(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listPartnerAgreementsResponseTotalMin)
})


/**
 * @summary Add an agreement to a partner
 */
export const createPartnerAgreementBodyTwoTitleMax = 200;



export const createPartnerAgreementBody = zod.object({
  "signedDate": zod.iso.datetime({"offset":true}).nullish(),
  "expiryDate": zod.iso.datetime({"offset":true}).nullish(),
  "documentUrl": zod.string().nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "accountId": zod.uuid(),
  "title": zod.string().min(1).max(createPartnerAgreementBodyTwoTitleMax),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional()
}))

export const createPartnerAgreementResponse = zod.object({
  "signedDate": zod.iso.datetime({"offset":true}).nullish(),
  "expiryDate": zod.iso.datetime({"offset":true}).nullish(),
  "documentUrl": zod.string().nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "title": zod.string(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a partner agreement
 */
export const updatePartnerAgreementParams = zod.object({
  "id": zod.uuid()
})

export const updatePartnerAgreementBodyTwoTitleMax = 200;



export const updatePartnerAgreementBody = zod.object({
  "signedDate": zod.iso.datetime({"offset":true}).nullish(),
  "expiryDate": zod.iso.datetime({"offset":true}).nullish(),
  "documentUrl": zod.string().nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "title": zod.string().min(1).max(updatePartnerAgreementBodyTwoTitleMax).optional(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']).optional(),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']).optional()
}))

export const updatePartnerAgreementResponse = zod.object({
  "signedDate": zod.iso.datetime({"offset":true}).nullish(),
  "expiryDate": zod.iso.datetime({"offset":true}).nullish(),
  "documentUrl": zod.string().nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "title": zod.string(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Remove a partner agreement
 */
export const deletePartnerAgreementParams = zod.object({
  "id": zod.uuid()
})

export const deletePartnerAgreementResponse = zod.void()


/**
 * @summary List interactions for a partner
 */
export const listPartnerInteractionsQueryParams = zod.object({
  "accountId": zod.uuid()
})

export const listPartnerInteractionsResponseTotalMin = 0;



export const listPartnerInteractionsResponse = zod.object({
  "items": zod.array(zod.object({
  "contactName": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "followUpDate": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "type": zod.enum(['meeting', 'call', 'email', 'presentation', 'event', 'other']),
  "direction": zod.enum(['inbound', 'outbound']),
  "subject": zod.string(),
  "interactionDate": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['planned', 'completed', 'cancelled']),
  "createdAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listPartnerInteractionsResponseTotalMin)
})


/**
 * @summary Log an interaction with a partner
 */
export const createPartnerInteractionBodyTwoSubjectMax = 200;



export const createPartnerInteractionBody = zod.object({
  "contactName": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "followUpDate": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "accountId": zod.uuid(),
  "subject": zod.string().min(1).max(createPartnerInteractionBodyTwoSubjectMax),
  "type": zod.enum(['meeting', 'call', 'email', 'presentation', 'event', 'other']).optional(),
  "direction": zod.enum(['inbound', 'outbound']).optional(),
  "interactionDate": zod.iso.datetime({"offset":true}).optional(),
  "status": zod.enum(['planned', 'completed', 'cancelled']).optional()
}))

export const createPartnerInteractionResponse = zod.object({
  "contactName": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "followUpDate": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "type": zod.enum(['meeting', 'call', 'email', 'presentation', 'event', 'other']),
  "direction": zod.enum(['inbound', 'outbound']),
  "subject": zod.string(),
  "interactionDate": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['planned', 'completed', 'cancelled']),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a partner interaction
 */
export const updatePartnerInteractionParams = zod.object({
  "id": zod.uuid()
})

export const updatePartnerInteractionBodyTwoSubjectMax = 200;



export const updatePartnerInteractionBody = zod.object({
  "contactName": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "followUpDate": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "subject": zod.string().min(1).max(updatePartnerInteractionBodyTwoSubjectMax).optional(),
  "type": zod.enum(['meeting', 'call', 'email', 'presentation', 'event', 'other']).optional(),
  "direction": zod.enum(['inbound', 'outbound']).optional(),
  "interactionDate": zod.iso.datetime({"offset":true}).optional(),
  "status": zod.enum(['planned', 'completed', 'cancelled']).optional()
}))

export const updatePartnerInteractionResponse = zod.object({
  "contactName": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "followUpDate": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "type": zod.enum(['meeting', 'call', 'email', 'presentation', 'event', 'other']),
  "direction": zod.enum(['inbound', 'outbound']),
  "subject": zod.string(),
  "interactionDate": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['planned', 'completed', 'cancelled']),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Remove a partner interaction
 */
export const deletePartnerInteractionParams = zod.object({
  "id": zod.uuid()
})

export const deletePartnerInteractionResponse = zod.void()


/**
 * @summary List collateral links for a partner
 */
export const listPartnerCollateralQueryParams = zod.object({
  "accountId": zod.uuid()
})

export const listPartnerCollateralResponseTotalMin = 0;



export const listPartnerCollateralResponse = zod.object({
  "items": zod.array(zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "title": zod.string(),
  "href": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listPartnerCollateralResponseTotalMin)
})


/**
 * @summary Add a collateral link to a partner
 */
export const createPartnerCollateralBodyTwoTitleMax = 200;

export const createPartnerCollateralBodyTwoHrefMax = 500;



export const createPartnerCollateralBody = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
}).and(zod.object({
  "accountId": zod.uuid(),
  "title": zod.string().min(1).max(createPartnerCollateralBodyTwoTitleMax),
  "href": zod.string().min(1).max(createPartnerCollateralBodyTwoHrefMax)
}))

export const createPartnerCollateralResponse = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "title": zod.string(),
  "href": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a partner collateral link
 */
export const updatePartnerCollateralParams = zod.object({
  "id": zod.uuid()
})

export const updatePartnerCollateralBodyTwoTitleMax = 200;

export const updatePartnerCollateralBodyTwoHrefMax = 500;



export const updatePartnerCollateralBody = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
}).and(zod.object({
  "title": zod.string().min(1).max(updatePartnerCollateralBodyTwoTitleMax).optional(),
  "href": zod.string().min(1).max(updatePartnerCollateralBodyTwoHrefMax).optional()
}))

export const updatePartnerCollateralResponse = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "title": zod.string(),
  "href": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Remove a partner collateral link
 */
export const deletePartnerCollateralParams = zod.object({
  "id": zod.uuid()
})

export const deletePartnerCollateralResponse = zod.void()


/**
 * @summary Partner Engagement dashboard KPI aggregates
 */
export const getPartnerDashboardStatsResponse = zod.object({
  "totalPartners": zod.int(),
  "activePartners": zod.int(),
  "linkedToAccount": zod.int(),
  "agreementsExpiringSoon": zod.int().describe('Agreements with status active and expiryDate within 30 days.'),
  "interactionsLast30Days": zod.int()
})


/**
 * Public (unauthenticated) endpoint. Returns the normalized state of the
 * database, storage, AI, video generation, and auth plugins. Only non-secret values are
 * included (e.g. the MSAL public client config). Never returns keys,
 * connection strings, or SAS URLs.
 * @summary Availability and public config of platform plugins
 */
export const getPluginsStatusResponseVideoGenerationModelsItemPriceUsdPerSecondMin = 0;



export const getPluginsStatusResponse = zod.object({
  "database": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "capabilities": zod.object({
  "persistentStorage": zod.boolean(),
  "appUsers": zod.boolean()
})
}),
  "storage": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "capabilities": zod.object({
  "fileUpload": zod.boolean(),
  "fileDownload": zod.boolean()
})
}),
  "ai": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "reason": zod.string().optional().describe('Public-safe explanation when AI is disabled, misconfigured, or partially available.'),
  "capabilities": zod.object({
  "llm": zod.boolean(),
  "embeddings": zod.boolean(),
  "semanticSearch": zod.boolean()
})
}),
  "videoGeneration": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled']),
  "reason": zod.string().optional().describe('Public-safe setup guidance when OpenRouter video generation is disabled.'),
  "provider": zod.enum(['openrouter']),
  "capabilities": zod.object({
  "render": zod.boolean(),
  "stitch": zod.boolean()
}),
  "models": zod.array(zod.object({
  "id": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),
  "label": zod.string(),
  "tier": zod.enum(['draft', 'polish', 'economy']),
  "supportedAspectRatios": zod.array(zod.enum(['16:9', '9:16'])),
  "supportedDurationsSeconds": zod.array(zod.union([zod.literal(4),zod.literal(6),zod.literal(8)])),
  "supportedResolutions": zod.array(zod.enum(['720p', '1080p'])),
  "resolutionConstraints": zod.object({
  "1080p": zod.object({
  "aspectRatios": zod.array(zod.enum(['16:9', '9:16'])),
  "durationsSeconds": zod.array(zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]))
})
}),
  "priceUsdPerSecond": zod.number().min(getPluginsStatusResponseVideoGenerationModelsItemPriceUsdPerSecondMin),
  "supportsFirstFrame": zod.boolean(),
  "supportsReferenceImages": zod.boolean()
}))
}),
  "auth": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "capabilities": zod.object({
  "login": zod.boolean(),
  "protectedRoutes": zod.boolean(),
  "persistentUsers": zod.boolean()
}),
  "config": zod.object({
  "clientId": zod.string(),
  "authority": zod.string(),
  "redirectUri": zod.string(),
  "postLoginRedirect": zod.string(),
  "scopes": zod.array(zod.string()),
  "apiScopes": zod.array(zod.string()).optional().describe('Delegated custom API scopes for this provider, separate from sign-in scopes.'),
  "interactionMode": zod.enum(['redirect', 'popup']).optional().describe('Browser interaction contract. popup enables embedded-first sign-in through the dedicated redirect bridge.'),
  "popupRedirectUri": zod.string().optional().describe('Dedicated MSAL redirect bridge on the application origin, used only for popup and silent requests.')
}).optional().describe('Public MSAL client configuration (no secrets).'),
  "external": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled', 'misconfigured']),
  "config": zod.object({
  "clientId": zod.string(),
  "authority": zod.string(),
  "redirectUri": zod.string(),
  "postLoginRedirect": zod.string(),
  "scopes": zod.array(zod.string()),
  "apiScopes": zod.array(zod.string()).optional().describe('Delegated custom API scopes for this provider, separate from sign-in scopes.'),
  "interactionMode": zod.enum(['redirect', 'popup']).optional().describe('Browser interaction contract. popup enables embedded-first sign-in through the dedicated redirect bridge.'),
  "popupRedirectUri": zod.string().optional().describe('Dedicated MSAL redirect bridge on the application origin, used only for popup and silent requests.')
}).optional().describe('Public MSAL client configuration (no secrets).')
}).optional()
})
})


/**
 * Sends a minimal server-side completion using the configured model and
 * credentials. The response contains only a safe result message and
 * latency; credentials, upstream headers, prompts, and response bodies
 * are never returned.
 * @summary Test the configured Project AI chat connection
 */
export const testAiPluginConnectionResponseLatencyMsMin = 0;



export const testAiPluginConnectionResponse = zod.object({
  "success": zod.boolean(),
  "message": zod.string(),
  "latencyMs": zod.int().min(testAiPluginConnectionResponseLatencyMsMin)
})


/**
 * Requires platform.tokens.manage.
 * @summary List configured metered action rates
 */
export const listPlatformUsageTokenRatesQueryLimitDefault = 25;
export const listPlatformUsageTokenRatesQueryLimitMax = 100;

export const listPlatformUsageTokenRatesQueryOffsetDefault = 0;
export const listPlatformUsageTokenRatesQueryOffsetMin = 0;



export const listPlatformUsageTokenRatesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformUsageTokenRatesQueryLimitMax).default(listPlatformUsageTokenRatesQueryLimitDefault),
  "offset": zod.int().min(listPlatformUsageTokenRatesQueryOffsetMin).default(listPlatformUsageTokenRatesQueryOffsetDefault)
})


export const listPlatformUsageTokenRatesResponseTotalMin = 0;


export const listPlatformUsageTokenRatesResponseOffsetMin = 0;



export const listPlatformUsageTokenRatesResponse = zod.object({
  "items": zod.array(zod.object({
  "actionKey": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "tokens": zod.int().min(1),
  "active": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPlatformUsageTokenRatesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPlatformUsageTokenRatesResponseOffsetMin)
})


/**
 * Requires platform.tokens.manage.
 * @summary Update a metered action rate
 */
export const updatePlatformUsageTokenRatePathActionKeyMax = 120;


export const updatePlatformUsageTokenRatePathActionKeyRegExp = new RegExp('^[a-z0-9_.-]+$');


export const updatePlatformUsageTokenRateParams = zod.object({
  "actionKey": zod.string().max(updatePlatformUsageTokenRatePathActionKeyMax).regex(updatePlatformUsageTokenRatePathActionKeyRegExp)
})

export const updatePlatformUsageTokenRateBodyTokensMax = 1000000;

export const updatePlatformUsageTokenRateBodyReasonMin = 10;
export const updatePlatformUsageTokenRateBodyReasonMax = 1000;



export const updatePlatformUsageTokenRateBody = zod.object({
  "tokens": zod.int().min(1).max(updatePlatformUsageTokenRateBodyTokensMax),
  "active": zod.boolean(),
  "reason": zod.string().min(updatePlatformUsageTokenRateBodyReasonMin).max(updatePlatformUsageTokenRateBodyReasonMax)
})




export const updatePlatformUsageTokenRateResponse = zod.object({
  "actionKey": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "tokens": zod.int().min(1),
  "active": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires platform.tokens.manage.
 * @summary List tenant usage token balances
 */
export const listPlatformUsageTokenBalancesQueryLimitDefault = 25;
export const listPlatformUsageTokenBalancesQueryLimitMax = 100;

export const listPlatformUsageTokenBalancesQueryOffsetDefault = 0;
export const listPlatformUsageTokenBalancesQueryOffsetMin = 0;

export const listPlatformUsageTokenBalancesQuerySearchMax = 200;



export const listPlatformUsageTokenBalancesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformUsageTokenBalancesQueryLimitMax).default(listPlatformUsageTokenBalancesQueryLimitDefault),
  "offset": zod.int().min(listPlatformUsageTokenBalancesQueryOffsetMin).default(listPlatformUsageTokenBalancesQueryOffsetDefault),
  "search": zod.string().max(listPlatformUsageTokenBalancesQuerySearchMax).optional()
})

export const listPlatformUsageTokenBalancesResponseItemsItemBalanceMin = 0;

export const listPlatformUsageTokenBalancesResponseItemsItemAllocatedMin = 0;

export const listPlatformUsageTokenBalancesResponseTotalMin = 0;


export const listPlatformUsageTokenBalancesResponseOffsetMin = 0;



export const listPlatformUsageTokenBalancesResponse = zod.object({
  "items": zod.array(zod.object({
  "tenantId": zod.uuid(),
  "tenantName": zod.string(),
  "balance": zod.int().min(listPlatformUsageTokenBalancesResponseItemsItemBalanceMin),
  "allocated": zod.int().min(listPlatformUsageTokenBalancesResponseItemsItemAllocatedMin)
})),
  "total": zod.int().min(listPlatformUsageTokenBalancesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPlatformUsageTokenBalancesResponseOffsetMin)
})


/**
 * Requires platform.tokens.manage.
 * @summary List usage token grants
 */
export const listPlatformUsageTokenGrantsQueryLimitDefault = 25;
export const listPlatformUsageTokenGrantsQueryLimitMax = 100;

export const listPlatformUsageTokenGrantsQueryOffsetDefault = 0;
export const listPlatformUsageTokenGrantsQueryOffsetMin = 0;



export const listPlatformUsageTokenGrantsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformUsageTokenGrantsQueryLimitMax).default(listPlatformUsageTokenGrantsQueryLimitDefault),
  "offset": zod.int().min(listPlatformUsageTokenGrantsQueryOffsetMin).default(listPlatformUsageTokenGrantsQueryOffsetDefault),
  "tenantId": zod.uuid().optional()
})


export const listPlatformUsageTokenGrantsResponseTotalMin = 0;


export const listPlatformUsageTokenGrantsResponseOffsetMin = 0;



export const listPlatformUsageTokenGrantsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "tenantName": zod.string().optional(),
  "amount": zod.int().min(1),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPlatformUsageTokenGrantsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPlatformUsageTokenGrantsResponseOffsetMin)
})


/**
 * Requires platform.tokens.manage.
 * @summary Grant usage tokens to a tenant
 */
export const createPlatformUsageTokenGrantBodyAmountMax = 1000000000;

export const createPlatformUsageTokenGrantBodyReasonMin = 10;
export const createPlatformUsageTokenGrantBodyReasonMax = 1000;



export const createPlatformUsageTokenGrantBody = zod.object({
  "tenantId": zod.uuid(),
  "amount": zod.int().min(1).max(createPlatformUsageTokenGrantBodyAmountMax),
  "reason": zod.string().min(createPlatformUsageTokenGrantBodyReasonMin).max(createPlatformUsageTokenGrantBodyReasonMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
})


export const createPlatformUsageTokenGrantResponseTwoBalanceMin = 0;



export const createPlatformUsageTokenGrantResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "tenantName": zod.string().optional(),
  "amount": zod.int().min(1),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "ledgerId": zod.uuid().nullable(),
  "balance": zod.int().min(createPlatformUsageTokenGrantResponseTwoBalanceMin)
}))


/**
 * Requires platform.tenants.manage.
 * @summary Queue a data export for a tenant
 */
export const createPlatformTenantDataExportParams = zod.object({
  "id": zod.uuid()
})

export const createPlatformTenantDataExportBodyAreasMax = 7;

export const createPlatformTenantDataExportBodyReasonMin = 10;
export const createPlatformTenantDataExportBodyReasonMax = 1000;



export const createPlatformTenantDataExportBody = zod.object({
  "areas": zod.array(zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])).min(1).max(createPlatformTenantDataExportBodyAreasMax),
  "reason": zod.string().min(createPlatformTenantDataExportBodyReasonMin).max(createPlatformTenantDataExportBodyReasonMax)
})

export const createPlatformTenantDataExportResponseSummaryOneAreasItemOneCreateMin = 0;

export const createPlatformTenantDataExportResponseSummaryOneAreasItemOneUpdateMin = 0;

export const createPlatformTenantDataExportResponseSummaryOneAreasItemOneDeleteMin = 0;

export const createPlatformTenantDataExportResponseSummaryOneAreasItemOneSkipMin = 0;

export const createPlatformTenantDataExportResponseSummaryOneTablesItemOneCreateMin = 0;

export const createPlatformTenantDataExportResponseSummaryOneTablesItemOneUpdateMin = 0;

export const createPlatformTenantDataExportResponseSummaryOneTablesItemOneDeleteMin = 0;

export const createPlatformTenantDataExportResponseSummaryOneTablesItemOneSkipMin = 0;



export const createPlatformTenantDataExportResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "status": zod.enum(['queued', 'running', 'completed', 'failed', 'cancelled', 'awaiting_apply', 'applied']),
  "areas": zod.array(zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])),
  "summary": zod.union([zod.object({
  "areas": zod.array(zod.object({
  "create": zod.int().min(createPlatformTenantDataExportResponseSummaryOneAreasItemOneCreateMin),
  "update": zod.int().min(createPlatformTenantDataExportResponseSummaryOneAreasItemOneUpdateMin),
  "delete": zod.int().min(createPlatformTenantDataExportResponseSummaryOneAreasItemOneDeleteMin),
  "skip": zod.int().min(createPlatformTenantDataExportResponseSummaryOneAreasItemOneSkipMin)
}).and(zod.object({
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules']),
  "label": zod.string()
}))),
  "tables": zod.array(zod.object({
  "create": zod.int().min(createPlatformTenantDataExportResponseSummaryOneTablesItemOneCreateMin),
  "update": zod.int().min(createPlatformTenantDataExportResponseSummaryOneTablesItemOneUpdateMin),
  "delete": zod.int().min(createPlatformTenantDataExportResponseSummaryOneTablesItemOneDeleteMin),
  "skip": zod.int().min(createPlatformTenantDataExportResponseSummaryOneTablesItemOneSkipMin)
}).and(zod.object({
  "table": zod.string(),
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])
}))),
  "warnings": zod.array(zod.string())
}),zod.null()]),
  "error": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "downloadReady": zod.boolean()
})


/**
 * Requires platform.features.manage. Null means no configured limit.
 * @summary Read optional platform-wide Agent voice allowances
 */
export const getPlatformAgentVoicePolicyResponseRevisionMin = 0;

export const getPlatformAgentVoicePolicyResponseDailySessionLimitMax = 1000000;

export const getPlatformAgentVoicePolicyResponseMaxSessionSecondsMin = 60;
export const getPlatformAgentVoicePolicyResponseMaxSessionSecondsMax = 31536000;
export const getPlatformAgentVoicePolicyResponseMaxSessionSecondsMultipleOf = 60;



export const getPlatformAgentVoicePolicyResponse = zod.object({
  "revision": zod.int().min(getPlatformAgentVoicePolicyResponseRevisionMin),
  "requestId": zod.uuid().nullable(),
  "dailySessionLimit": zod.int().min(1).max(getPlatformAgentVoicePolicyResponseDailySessionLimitMax).nullable(),
  "maxSessionSeconds": zod.int().min(getPlatformAgentVoicePolicyResponseMaxSessionSecondsMin).max(getPlatformAgentVoicePolicyResponseMaxSessionSecondsMax).multipleOf(getPlatformAgentVoicePolicyResponseMaxSessionSecondsMultipleOf).nullable()
})


/**
 * Requires platform.features.manage and the exact current revision. Null clears a limit.
 * @summary Explicitly save an audited Agent voice policy revision
 */
export const writePlatformAgentVoicePolicyBodyExpectedRevisionMin = 0;

export const writePlatformAgentVoicePolicyBodyDailySessionLimitMax = 1000000;

export const writePlatformAgentVoicePolicyBodyMaxSessionSecondsMin = 60;
export const writePlatformAgentVoicePolicyBodyMaxSessionSecondsMax = 31536000;
export const writePlatformAgentVoicePolicyBodyMaxSessionSecondsMultipleOf = 60;

export const writePlatformAgentVoicePolicyBodyReasonMin = 10;
export const writePlatformAgentVoicePolicyBodyReasonMax = 2000;



export const writePlatformAgentVoicePolicyBody = zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.int().min(writePlatformAgentVoicePolicyBodyExpectedRevisionMin),
  "dailySessionLimit": zod.int().min(1).max(writePlatformAgentVoicePolicyBodyDailySessionLimitMax).nullable(),
  "maxSessionSeconds": zod.int().min(writePlatformAgentVoicePolicyBodyMaxSessionSecondsMin).max(writePlatformAgentVoicePolicyBodyMaxSessionSecondsMax).multipleOf(writePlatformAgentVoicePolicyBodyMaxSessionSecondsMultipleOf).nullable(),
  "reason": zod.string().min(writePlatformAgentVoicePolicyBodyReasonMin).max(writePlatformAgentVoicePolicyBodyReasonMax)
})

export const writePlatformAgentVoicePolicyResponseRevisionMin = 0;

export const writePlatformAgentVoicePolicyResponseDailySessionLimitMax = 1000000;

export const writePlatformAgentVoicePolicyResponseMaxSessionSecondsMin = 60;
export const writePlatformAgentVoicePolicyResponseMaxSessionSecondsMax = 31536000;
export const writePlatformAgentVoicePolicyResponseMaxSessionSecondsMultipleOf = 60;



export const writePlatformAgentVoicePolicyResponse = zod.object({
  "revision": zod.int().min(writePlatformAgentVoicePolicyResponseRevisionMin),
  "requestId": zod.uuid().nullable(),
  "dailySessionLimit": zod.int().min(1).max(writePlatformAgentVoicePolicyResponseDailySessionLimitMax).nullable(),
  "maxSessionSeconds": zod.int().min(writePlatformAgentVoicePolicyResponseMaxSessionSecondsMin).max(writePlatformAgentVoicePolicyResponseMaxSessionSecondsMax).multipleOf(writePlatformAgentVoicePolicyResponseMaxSessionSecondsMultipleOf).nullable()
})


/**
 * @summary Read the original actor-owned voice policy save outcome
 */
export const getPlatformAgentVoicePolicySaveParams = zod.object({
  "requestId": zod.uuid()
})

export const getPlatformAgentVoicePolicySaveResponsePolicyOneRevisionMin = 0;

export const getPlatformAgentVoicePolicySaveResponsePolicyOneDailySessionLimitMax = 1000000;

export const getPlatformAgentVoicePolicySaveResponsePolicyOneMaxSessionSecondsMin = 60;
export const getPlatformAgentVoicePolicySaveResponsePolicyOneMaxSessionSecondsMax = 31536000;
export const getPlatformAgentVoicePolicySaveResponsePolicyOneMaxSessionSecondsMultipleOf = 60;



export const getPlatformAgentVoicePolicySaveResponse = zod.object({
  "policy": zod.union([zod.object({
  "revision": zod.int().min(getPlatformAgentVoicePolicySaveResponsePolicyOneRevisionMin),
  "requestId": zod.uuid().nullable(),
  "dailySessionLimit": zod.int().min(1).max(getPlatformAgentVoicePolicySaveResponsePolicyOneDailySessionLimitMax).nullable(),
  "maxSessionSeconds": zod.int().min(getPlatformAgentVoicePolicySaveResponsePolicyOneMaxSessionSecondsMin).max(getPlatformAgentVoicePolicySaveResponsePolicyOneMaxSessionSecondsMax).multipleOf(getPlatformAgentVoicePolicySaveResponsePolicyOneMaxSessionSecondsMultipleOf).nullable()
}),zod.null()])
})


/**
 * The server chooses the model. Only models served by the saved Project AI connection can be allowed, and a personal choice is honoured only while the platform policy permits it.
 * @summary Read the assistant models this person may use
 */
export const getAssistantModelChoicesResponse = zod.object({
  "models": zod.array(zod.object({
  "id": zod.string(),
  "isDefault": zod.boolean()
})),
  "defaultModel": zod.string().nullable(),
  "allowPersonalChoice": zod.boolean(),
  "preferredModel": zod.string().nullable(),
  "effectiveModel": zod.string().nullable().describe('The model the server will use for this person\'s next reply')
})


/**
 * Rejected unless the platform policy allows personal choice and the model is allowed.
 * @summary Save or clear this person's preferred assistant model
 */
export const setAssistantModelPreferenceBodyModelMax = 200;



export const setAssistantModelPreferenceBody = zod.object({
  "model": zod.string().min(1).max(setAssistantModelPreferenceBodyModelMax).nullable().describe('Null clears the preference')
})

export const setAssistantModelPreferenceResponse = zod.object({
  "models": zod.array(zod.object({
  "id": zod.string(),
  "isDefault": zod.boolean()
})),
  "defaultModel": zod.string().nullable(),
  "allowPersonalChoice": zod.boolean(),
  "preferredModel": zod.string().nullable(),
  "effectiveModel": zod.string().nullable().describe('The model the server will use for this person\'s next reply')
})


/**
 * @summary Read this person's assistant usage today (no per-person limits apply)
 */
export const getMyAssistantUsageResponseRequestsMin = 0;

export const getMyAssistantUsageResponseInputTokensMin = 0;

export const getMyAssistantUsageResponseOutputTokensMin = 0;

export const getMyAssistantUsageResponseLimitsDailyRequestLimitMax = 100000;

export const getMyAssistantUsageResponseLimitsDailyTokenLimitMin = 1000;
export const getMyAssistantUsageResponseLimitsDailyTokenLimitMax = 1000000000;

export const getMyAssistantUsageResponseRemainingRequestsMin = 0;

export const getMyAssistantUsageResponseRemainingTokensMin = 0;



export const getMyAssistantUsageResponse = zod.object({
  "date": zod.iso.date(),
  "requests": zod.int().min(getMyAssistantUsageResponseRequestsMin),
  "inputTokens": zod.int().min(getMyAssistantUsageResponseInputTokensMin),
  "outputTokens": zod.int().min(getMyAssistantUsageResponseOutputTokensMin),
  "limits": zod.object({
  "dailyRequestLimit": zod.int().min(1).max(getMyAssistantUsageResponseLimitsDailyRequestLimitMax).nullable().describe('Signed-in assistant replies and image drafts per person per UTC day; null for no limit'),
  "dailyTokenLimit": zod.int().min(getMyAssistantUsageResponseLimitsDailyTokenLimitMin).max(getMyAssistantUsageResponseLimitsDailyTokenLimitMax).nullable().describe('AI tokens per person per UTC day; null for no limit')
}),
  "remainingRequests": zod.int().min(getMyAssistantUsageResponseRemainingRequestsMin).nullable(),
  "remainingTokens": zod.int().min(getMyAssistantUsageResponseRemainingTokensMin).nullable()
})


/**
 * @summary List this person's own AI activity (no message content)
 */
export const listMyAiActivityQueryLimitMax = 100;

export const listMyAiActivityQueryOffsetMin = 0;



export const listMyAiActivityQueryParams = zod.object({
  "limit": zod.int().min(1).max(listMyAiActivityQueryLimitMax).optional(),
  "offset": zod.int().min(listMyAiActivityQueryOffsetMin).optional()
})

export const listMyAiActivityResponseTotalMin = 0;


export const listMyAiActivityResponseOffsetMin = 0;



export const listMyAiActivityResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "actorAppUserId": zod.uuid(),
  "actorDisplayName": zod.string().nullable(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "feature": zod.enum(['assistant_chat', 'research', 'search', 'image_draft', 'document_agent', 'model_preference']),
  "action": zod.string(),
  "outcome": zod.enum(['succeeded', 'failed', 'denied', 'limited']),
  "model": zod.string().nullable(),
  "durationMs": zod.int().nullable(),
  "inputTokens": zod.int().nullable(),
  "outputTokens": zod.int().nullable(),
  "resultCount": zod.int().nullable(),
  "errorCode": zod.string().nullable(),
  "resourceId": zod.uuid().nullable()
}).describe('Identifiers, counts and codes only. Never prompts, replies, search text, file names or provider error prose.')),
  "total": zod.int().min(listMyAiActivityResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listMyAiActivityResponseOffsetMin)
})


/**
 * @summary List this person's private image drafts
 */
export const listAssistantImageDraftsQueryLimitMax = 50;

export const listAssistantImageDraftsQueryOffsetMin = 0;



export const listAssistantImageDraftsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listAssistantImageDraftsQueryLimitMax).optional(),
  "offset": zod.int().min(listAssistantImageDraftsQueryOffsetMin).optional()
})


export const listAssistantImageDraftsResponseTotalMin = 0;


export const listAssistantImageDraftsResponseOffsetMin = 0;



export const listAssistantImageDraftsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "prompt": zod.string(),
  "size": zod.enum(['1024x1024', '1536x1024', '1024x1536']),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(1),
  "model": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAssistantImageDraftsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listAssistantImageDraftsResponseOffsetMin)
})


/**
 * @summary Generate a private image draft with the saved Project AI image connection
 */
export const createAssistantImageDraftBodyPromptMin = 3;
export const createAssistantImageDraftBodyPromptMax = 2000;



export const createAssistantImageDraftBody = zod.object({
  "prompt": zod.string().min(createAssistantImageDraftBodyPromptMin).max(createAssistantImageDraftBodyPromptMax),
  "size": zod.enum(['1024x1024', '1536x1024', '1024x1536'])
})




export const createAssistantImageDraftResponse = zod.object({
  "id": zod.uuid(),
  "prompt": zod.string(),
  "size": zod.enum(['1024x1024', '1536x1024', '1024x1536']),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(1),
  "model": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Read the image bytes of one of this person's drafts
 */
export const getAssistantImageDraftContentParams = zod.object({
  "draftId": zod.uuid()
})

export const getAssistantImageDraftContentResponse = zod.unknown()


/**
 * @summary Discard one of this person's image drafts
 */
export const deleteAssistantImageDraftParams = zod.object({
  "draftId": zod.uuid()
})

export const deleteAssistantImageDraftResponse = zod.void()


/**
 * Records come from the active entity's permission-filtered search; knowledge passages only from ready sources the caller may read. Every result carries its source.
 * @summary Search CRM records and approved knowledge the person may read, with sources
 */
export const searchAssistantSourcesQuerySearchMin = 2;
export const searchAssistantSourcesQuerySearchMax = 200;

export const searchAssistantSourcesQueryLimitMax = 20;

export const searchAssistantSourcesQueryOffsetMin = 0;



export const searchAssistantSourcesQueryParams = zod.object({
  "search": zod.string().min(searchAssistantSourcesQuerySearchMin).max(searchAssistantSourcesQuerySearchMax),
  "limit": zod.int().min(1).max(searchAssistantSourcesQueryLimitMax).optional(),
  "offset": zod.int().min(searchAssistantSourcesQueryOffsetMin).optional()
})

export const searchAssistantSourcesResponseRecordTotalMin = 0;


export const searchAssistantSourcesResponseOffsetMin = 0;



export const searchAssistantSourcesResponse = zod.object({
  "search": zod.string(),
  "records": zod.array(zod.object({
  "key": zod.string(),
  "type": zod.string(),
  "recordId": zod.string(),
  "title": zod.string(),
  "subtitle": zod.string().nullable(),
  "status": zod.string().nullable(),
  "accountName": zod.string().nullable(),
  "updatedAt": zod.string().nullable(),
  "source": zod.object({
  "kind": zod.enum(['crm_record', 'knowledge_document']),
  "id": zod.string(),
  "title": zod.string(),
  "deepLink": zod.string().nullable(),
  "sourceVersion": zod.int().nullable(),
  "location": zod.string().nullable()
})
})),
  "recordTotal": zod.int().min(searchAssistantSourcesResponseRecordTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(searchAssistantSourcesResponseOffsetMin),
  "passages": zod.array(zod.object({
  "chunkId": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.string(),
  "score": zod.number(),
  "source": zod.object({
  "kind": zod.enum(['crm_record', 'knowledge_document']),
  "id": zod.string(),
  "title": zod.string(),
  "deepLink": zod.string().nullable(),
  "sourceVersion": zod.int().nullable(),
  "location": zod.string().nullable()
})
})).describe('Approved knowledge passages; only on the first page'),
  "knowledgeState": zod.string(),
  "knowledgeMessage": zod.string()
})


/**
 * Requires platform.features.manage. Revision 0 means the saved Project AI model is the only choice.
 * @summary Read the platform assistant model policy
 */
export const getPlatformAssistantModelPolicyResponseRevisionMin = 0;



export const getPlatformAssistantModelPolicyResponse = zod.object({
  "revision": zod.int().min(getPlatformAssistantModelPolicyResponseRevisionMin),
  "requestId": zod.uuid().nullable(),
  "allowedModels": zod.array(zod.string()),
  "defaultModel": zod.string().nullable(),
  "allowPersonalChoice": zod.boolean(),
  "configuredModels": zod.array(zod.string()).describe('Models served by the saved Project AI connection')
})


/**
 * Requires platform.features.manage and the exact current revision. Allowed models must be served by the saved Project AI connection; the connection itself is never changed.
 * @summary Save an audited assistant model policy revision
 */
export const writePlatformAssistantModelPolicyBodyExpectedRevisionMin = 0;

export const writePlatformAssistantModelPolicyBodyAllowedModelsItemMax = 200;

export const writePlatformAssistantModelPolicyBodyAllowedModelsMax = 16;

export const writePlatformAssistantModelPolicyBodyDefaultModelMax = 200;

export const writePlatformAssistantModelPolicyBodyReasonMin = 10;
export const writePlatformAssistantModelPolicyBodyReasonMax = 2000;



export const writePlatformAssistantModelPolicyBody = zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.int().min(writePlatformAssistantModelPolicyBodyExpectedRevisionMin),
  "allowedModels": zod.array(zod.string().min(1).max(writePlatformAssistantModelPolicyBodyAllowedModelsItemMax)).min(1).max(writePlatformAssistantModelPolicyBodyAllowedModelsMax),
  "defaultModel": zod.string().min(1).max(writePlatformAssistantModelPolicyBodyDefaultModelMax),
  "allowPersonalChoice": zod.boolean(),
  "reason": zod.string().min(writePlatformAssistantModelPolicyBodyReasonMin).max(writePlatformAssistantModelPolicyBodyReasonMax)
})

export const writePlatformAssistantModelPolicyResponseRevisionMin = 0;



export const writePlatformAssistantModelPolicyResponse = zod.object({
  "revision": zod.int().min(writePlatformAssistantModelPolicyResponseRevisionMin),
  "requestId": zod.uuid().nullable(),
  "allowedModels": zod.array(zod.string()),
  "defaultModel": zod.string().nullable(),
  "allowPersonalChoice": zod.boolean(),
  "configuredModels": zod.array(zod.string()).describe('Models served by the saved Project AI connection')
})


/**
 * Requires platform.features.manage. Saved revisions are inert history; signed-in people have no per-person usage limits (see getPlatformAiLimits).
 * @summary Read the retired per-person daily assistant usage limits record
 */
export const getPlatformAssistantUsagePolicyResponseRevisionMin = 0;

export const getPlatformAssistantUsagePolicyResponseLimitsDailyRequestLimitMax = 100000;

export const getPlatformAssistantUsagePolicyResponseLimitsDailyTokenLimitMin = 1000;
export const getPlatformAssistantUsagePolicyResponseLimitsDailyTokenLimitMax = 1000000000;



export const getPlatformAssistantUsagePolicyResponse = zod.object({
  "revision": zod.int().min(getPlatformAssistantUsagePolicyResponseRevisionMin),
  "requestId": zod.uuid().nullable(),
  "limits": zod.object({
  "dailyRequestLimit": zod.int().min(1).max(getPlatformAssistantUsagePolicyResponseLimitsDailyRequestLimitMax).nullable().describe('Signed-in assistant replies and image drafts per person per UTC day; null for no limit'),
  "dailyTokenLimit": zod.int().min(getPlatformAssistantUsagePolicyResponseLimitsDailyTokenLimitMin).max(getPlatformAssistantUsagePolicyResponseLimitsDailyTokenLimitMax).nullable().describe('AI tokens per person per UTC day; null for no limit')
})
})


/**
 * Requires platform.features.manage. Per-person usage limits were removed, so nothing is saved and 410 AI_LIMIT_REMOVED is returned. Existing revisions are kept unchanged.
 * @deprecated
 * @summary Retired per-person daily assistant usage limits writer
 */
export const writePlatformAssistantUsagePolicyBodyExpectedRevisionMin = 0;

export const writePlatformAssistantUsagePolicyBodyLimitsDailyRequestLimitMax = 100000;

export const writePlatformAssistantUsagePolicyBodyLimitsDailyTokenLimitMin = 1000;
export const writePlatformAssistantUsagePolicyBodyLimitsDailyTokenLimitMax = 1000000000;

export const writePlatformAssistantUsagePolicyBodyReasonMin = 10;
export const writePlatformAssistantUsagePolicyBodyReasonMax = 2000;



export const writePlatformAssistantUsagePolicyBody = zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.int().min(writePlatformAssistantUsagePolicyBodyExpectedRevisionMin),
  "limits": zod.object({
  "dailyRequestLimit": zod.int().min(1).max(writePlatformAssistantUsagePolicyBodyLimitsDailyRequestLimitMax).nullable().describe('Signed-in assistant replies and image drafts per person per UTC day; null for no limit'),
  "dailyTokenLimit": zod.int().min(writePlatformAssistantUsagePolicyBodyLimitsDailyTokenLimitMin).max(writePlatformAssistantUsagePolicyBodyLimitsDailyTokenLimitMax).nullable().describe('AI tokens per person per UTC day; null for no limit')
}),
  "reason": zod.string().min(writePlatformAssistantUsagePolicyBodyReasonMin).max(writePlatformAssistantUsagePolicyBodyReasonMax)
})

export const writePlatformAssistantUsagePolicyResponseRevisionMin = 0;

export const writePlatformAssistantUsagePolicyResponseLimitsDailyRequestLimitMax = 100000;

export const writePlatformAssistantUsagePolicyResponseLimitsDailyTokenLimitMin = 1000;
export const writePlatformAssistantUsagePolicyResponseLimitsDailyTokenLimitMax = 1000000000;



export const writePlatformAssistantUsagePolicyResponse = zod.object({
  "revision": zod.int().min(writePlatformAssistantUsagePolicyResponseRevisionMin),
  "requestId": zod.uuid().nullable(),
  "limits": zod.object({
  "dailyRequestLimit": zod.int().min(1).max(writePlatformAssistantUsagePolicyResponseLimitsDailyRequestLimitMax).nullable().describe('Signed-in assistant replies and image drafts per person per UTC day; null for no limit'),
  "dailyTokenLimit": zod.int().min(writePlatformAssistantUsagePolicyResponseLimitsDailyTokenLimitMin).max(writePlatformAssistantUsagePolicyResponseLimitsDailyTokenLimitMax).nullable().describe('AI tokens per person per UTC day; null for no limit')
})
})


/**
 * Requires platform.features.manage.
 * @summary List per-person assistant usage for one UTC day
 */
export const listPlatformAssistantUsageQueryLimitMax = 100;

export const listPlatformAssistantUsageQueryOffsetMin = 0;



export const listPlatformAssistantUsageQueryParams = zod.object({
  "date": zod.iso.date().optional(),
  "limit": zod.int().min(1).max(listPlatformAssistantUsageQueryLimitMax).optional(),
  "offset": zod.int().min(listPlatformAssistantUsageQueryOffsetMin).optional()
})

export const listPlatformAssistantUsageResponseItemsItemRequestsMin = 0;

export const listPlatformAssistantUsageResponseItemsItemInputTokensMin = 0;

export const listPlatformAssistantUsageResponseItemsItemOutputTokensMin = 0;

export const listPlatformAssistantUsageResponseTotalMin = 0;


export const listPlatformAssistantUsageResponseOffsetMin = 0;

export const listPlatformAssistantUsageResponseLimitsDailyRequestLimitMax = 100000;

export const listPlatformAssistantUsageResponseLimitsDailyTokenLimitMin = 1000;
export const listPlatformAssistantUsageResponseLimitsDailyTokenLimitMax = 1000000000;



export const listPlatformAssistantUsageResponse = zod.object({
  "date": zod.iso.date(),
  "items": zod.array(zod.object({
  "appUserId": zod.uuid(),
  "displayName": zod.string().nullable(),
  "requests": zod.int().min(listPlatformAssistantUsageResponseItemsItemRequestsMin),
  "inputTokens": zod.int().min(listPlatformAssistantUsageResponseItemsItemInputTokensMin),
  "outputTokens": zod.int().min(listPlatformAssistantUsageResponseItemsItemOutputTokensMin)
})),
  "total": zod.int().min(listPlatformAssistantUsageResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPlatformAssistantUsageResponseOffsetMin),
  "limits": zod.object({
  "dailyRequestLimit": zod.int().min(1).max(listPlatformAssistantUsageResponseLimitsDailyRequestLimitMax).nullable().describe('Signed-in assistant replies and image drafts per person per UTC day; null for no limit'),
  "dailyTokenLimit": zod.int().min(listPlatformAssistantUsageResponseLimitsDailyTokenLimitMin).max(listPlatformAssistantUsageResponseLimitsDailyTokenLimitMax).nullable().describe('AI tokens per person per UTC day; null for no limit')
})
})


/**
 * Requires platform.audit.read. Events hold identifiers, counts and codes only, never prompts, replies or file names.
 * @summary List the content-free AI activity log
 */
export const listPlatformAiActivityQueryLimitMax = 100;

export const listPlatformAiActivityQueryOffsetMin = 0;



export const listPlatformAiActivityQueryParams = zod.object({
  "feature": zod.enum(['assistant_chat', 'research', 'search', 'image_draft', 'document_agent', 'model_preference']).optional(),
  "outcome": zod.enum(['succeeded', 'failed', 'denied', 'limited']).optional(),
  "limit": zod.int().min(1).max(listPlatformAiActivityQueryLimitMax).optional(),
  "offset": zod.int().min(listPlatformAiActivityQueryOffsetMin).optional()
})

export const listPlatformAiActivityResponseTotalMin = 0;


export const listPlatformAiActivityResponseOffsetMin = 0;



export const listPlatformAiActivityResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "actorAppUserId": zod.uuid(),
  "actorDisplayName": zod.string().nullable(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "feature": zod.enum(['assistant_chat', 'research', 'search', 'image_draft', 'document_agent', 'model_preference']),
  "action": zod.string(),
  "outcome": zod.enum(['succeeded', 'failed', 'denied', 'limited']),
  "model": zod.string().nullable(),
  "durationMs": zod.int().nullable(),
  "inputTokens": zod.int().nullable(),
  "outputTokens": zod.int().nullable(),
  "resultCount": zod.int().nullable(),
  "errorCode": zod.string().nullable(),
  "resourceId": zod.uuid().nullable()
}).describe('Identifiers, counts and codes only. Never prompts, replies, search text, file names or provider error prose.')),
  "total": zod.int().min(listPlatformAiActivityResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPlatformAiActivityResponseOffsetMin)
})


/**
 * Requires platform.features.manage. Lists every app-made AI limit from the single registry. Signed-in limits are permanently removed (the AI token budget is the only usage stop); public visitor protections stay enforced from the server environment or the built-in default. Retired administrator values are shown as inert history.
 * @summary Read the consolidated AI limits policy
 */
export const getPlatformAiLimitsResponseItemsItemKeyRegExp = new RegExp('^[A-Z][A-Z0-9_]{1,63}$');
export const getPlatformAiLimitsResponseLegacyAgentLimitRevisionMin = 0;

export const getPlatformAiLimitsResponseLegacyAssistantUsagePolicyRevisionMin = 0;



export const getPlatformAiLimitsResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string().regex(getPlatformAiLimitsResponseItemsItemKeyRegExp),
  "category": zod.enum(['agent', 'reply', 'usage', 'public']),
  "label": zod.string(),
  "description": zod.string(),
  "unit": zod.string(),
  "audience": zod.enum(['signed_in', 'public']).describe('Who the setting would apply to'),
  "status": zod.enum(['removed', 'enforced']).describe('removed means permanently disabled; enforced means a public protection'),
  "effectiveSource": zod.enum(['disabled', 'server', 'default']),
  "effectiveValue": zod.int().nullable().describe('Effective limit; null when no limit applies'),
  "retainedDefault": zod.int().nullable().describe('Built-in value kept for reference'),
  "disabledBehaviour": zod.string(),
  "legacyValue": zod.int().nullable().describe('Retired administrator value kept as inert history')
})),
  "legacy": zod.object({
  "agentLimitRevision": zod.int().min(getPlatformAiLimitsResponseLegacyAgentLimitRevisionMin).describe('Latest retained Agent working limits revision (inert)'),
  "assistantUsagePolicyRevision": zod.int().min(getPlatformAiLimitsResponseLegacyAssistantUsagePolicyRevisionMin).describe('Latest retained usage limits revision (inert)')
})
})


/**
 * Requires platform.features.manage. Saved revisions are inert history; signed-in Agent turns have no app-made limits (see getPlatformAiLimits).
 * @summary Read the retired Agent working limits record
 */
export const getPlatformAgentLimitsResponseRevisionMin = 0;

export const getPlatformAgentLimitsResponseLimitsLookupRoundsMax = 48;

export const getPlatformAgentLimitsResponseLimitsLookupCallsMax = 512;

export const getPlatformAgentLimitsResponseLimitsLookupTimeLimitSecondsMin = 30;
export const getPlatformAgentLimitsResponseLimitsLookupTimeLimitSecondsMax = 1800;

export const getPlatformAgentLimitsResponseLimitsToolResultBytesMin = 8192;
export const getPlatformAgentLimitsResponseLimitsToolResultBytesMax = 1048576;

export const getPlatformAgentLimitsResponseLimitsToolArgumentBytesMin = 131072;
export const getPlatformAgentLimitsResponseLimitsToolArgumentBytesMax = 4194304;

export const getPlatformAgentLimitsResponseLimitsResponseBytesMin = 65536;
export const getPlatformAgentLimitsResponseLimitsResponseBytesMax = 4194304;

export const getPlatformAgentLimitsResponseLimitsFileToolRoundsMax = 48;

export const getPlatformAgentLimitsResponseDefaultsLookupRoundsMax = 48;

export const getPlatformAgentLimitsResponseDefaultsLookupCallsMax = 512;

export const getPlatformAgentLimitsResponseDefaultsLookupTimeLimitSecondsMin = 30;
export const getPlatformAgentLimitsResponseDefaultsLookupTimeLimitSecondsMax = 1800;

export const getPlatformAgentLimitsResponseDefaultsToolResultBytesMin = 8192;
export const getPlatformAgentLimitsResponseDefaultsToolResultBytesMax = 1048576;

export const getPlatformAgentLimitsResponseDefaultsToolArgumentBytesMin = 131072;
export const getPlatformAgentLimitsResponseDefaultsToolArgumentBytesMax = 4194304;

export const getPlatformAgentLimitsResponseDefaultsResponseBytesMin = 65536;
export const getPlatformAgentLimitsResponseDefaultsResponseBytesMax = 4194304;

export const getPlatformAgentLimitsResponseDefaultsFileToolRoundsMax = 48;



export const getPlatformAgentLimitsResponse = zod.object({
  "revision": zod.int().min(getPlatformAgentLimitsResponseRevisionMin),
  "requestId": zod.uuid().nullable(),
  "limits": zod.object({
  "lookupRounds": zod.int().min(1).max(getPlatformAgentLimitsResponseLimitsLookupRoundsMax).describe('Model steps for application lookups in one reply'),
  "lookupCalls": zod.int().min(1).max(getPlatformAgentLimitsResponseLimitsLookupCallsMax).describe('Lookup tool calls in one reply'),
  "lookupTimeLimitSeconds": zod.int().min(getPlatformAgentLimitsResponseLimitsLookupTimeLimitSecondsMin).max(getPlatformAgentLimitsResponseLimitsLookupTimeLimitSecondsMax).describe('Overall time for lookups in one reply'),
  "toolResultBytes": zod.int().min(getPlatformAgentLimitsResponseLimitsToolResultBytesMin).max(getPlatformAgentLimitsResponseLimitsToolResultBytesMax).describe('Size of one tool result returned to the model'),
  "toolArgumentBytes": zod.int().min(getPlatformAgentLimitsResponseLimitsToolArgumentBytesMin).max(getPlatformAgentLimitsResponseLimitsToolArgumentBytesMax).describe('Size of one tool request from the model'),
  "responseBytes": zod.int().min(getPlatformAgentLimitsResponseLimitsResponseBytesMin).max(getPlatformAgentLimitsResponseLimitsResponseBytesMax).describe('Size of one model response'),
  "fileToolRounds": zod.int().min(1).max(getPlatformAgentLimitsResponseLimitsFileToolRoundsMax).describe('Model steps for record file actions in one reply')
}),
  "defaults": zod.object({
  "lookupRounds": zod.int().min(1).max(getPlatformAgentLimitsResponseDefaultsLookupRoundsMax).describe('Model steps for application lookups in one reply'),
  "lookupCalls": zod.int().min(1).max(getPlatformAgentLimitsResponseDefaultsLookupCallsMax).describe('Lookup tool calls in one reply'),
  "lookupTimeLimitSeconds": zod.int().min(getPlatformAgentLimitsResponseDefaultsLookupTimeLimitSecondsMin).max(getPlatformAgentLimitsResponseDefaultsLookupTimeLimitSecondsMax).describe('Overall time for lookups in one reply'),
  "toolResultBytes": zod.int().min(getPlatformAgentLimitsResponseDefaultsToolResultBytesMin).max(getPlatformAgentLimitsResponseDefaultsToolResultBytesMax).describe('Size of one tool result returned to the model'),
  "toolArgumentBytes": zod.int().min(getPlatformAgentLimitsResponseDefaultsToolArgumentBytesMin).max(getPlatformAgentLimitsResponseDefaultsToolArgumentBytesMax).describe('Size of one tool request from the model'),
  "responseBytes": zod.int().min(getPlatformAgentLimitsResponseDefaultsResponseBytesMin).max(getPlatformAgentLimitsResponseDefaultsResponseBytesMax).describe('Size of one model response'),
  "fileToolRounds": zod.int().min(1).max(getPlatformAgentLimitsResponseDefaultsFileToolRoundsMax).describe('Model steps for record file actions in one reply')
})
})


/**
 * Requires platform.features.manage. Agent working limits were removed for signed-in people, so nothing is saved and 410 AI_LIMIT_REMOVED is returned. Existing revisions are kept unchanged.
 * @deprecated
 * @summary Retired Agent working limits writer
 */
export const writePlatformAgentLimitsBodyExpectedRevisionMin = 0;

export const writePlatformAgentLimitsBodyLimitsLookupRoundsMax = 48;

export const writePlatformAgentLimitsBodyLimitsLookupCallsMax = 512;

export const writePlatformAgentLimitsBodyLimitsLookupTimeLimitSecondsMin = 30;
export const writePlatformAgentLimitsBodyLimitsLookupTimeLimitSecondsMax = 1800;

export const writePlatformAgentLimitsBodyLimitsToolResultBytesMin = 8192;
export const writePlatformAgentLimitsBodyLimitsToolResultBytesMax = 1048576;

export const writePlatformAgentLimitsBodyLimitsToolArgumentBytesMin = 131072;
export const writePlatformAgentLimitsBodyLimitsToolArgumentBytesMax = 4194304;

export const writePlatformAgentLimitsBodyLimitsResponseBytesMin = 65536;
export const writePlatformAgentLimitsBodyLimitsResponseBytesMax = 4194304;

export const writePlatformAgentLimitsBodyLimitsFileToolRoundsMax = 48;

export const writePlatformAgentLimitsBodyReasonMin = 10;
export const writePlatformAgentLimitsBodyReasonMax = 2000;



export const writePlatformAgentLimitsBody = zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.int().min(writePlatformAgentLimitsBodyExpectedRevisionMin),
  "limits": zod.object({
  "lookupRounds": zod.int().min(1).max(writePlatformAgentLimitsBodyLimitsLookupRoundsMax).describe('Model steps for application lookups in one reply'),
  "lookupCalls": zod.int().min(1).max(writePlatformAgentLimitsBodyLimitsLookupCallsMax).describe('Lookup tool calls in one reply'),
  "lookupTimeLimitSeconds": zod.int().min(writePlatformAgentLimitsBodyLimitsLookupTimeLimitSecondsMin).max(writePlatformAgentLimitsBodyLimitsLookupTimeLimitSecondsMax).describe('Overall time for lookups in one reply'),
  "toolResultBytes": zod.int().min(writePlatformAgentLimitsBodyLimitsToolResultBytesMin).max(writePlatformAgentLimitsBodyLimitsToolResultBytesMax).describe('Size of one tool result returned to the model'),
  "toolArgumentBytes": zod.int().min(writePlatformAgentLimitsBodyLimitsToolArgumentBytesMin).max(writePlatformAgentLimitsBodyLimitsToolArgumentBytesMax).describe('Size of one tool request from the model'),
  "responseBytes": zod.int().min(writePlatformAgentLimitsBodyLimitsResponseBytesMin).max(writePlatformAgentLimitsBodyLimitsResponseBytesMax).describe('Size of one model response'),
  "fileToolRounds": zod.int().min(1).max(writePlatformAgentLimitsBodyLimitsFileToolRoundsMax).describe('Model steps for record file actions in one reply')
}),
  "reason": zod.string().min(writePlatformAgentLimitsBodyReasonMin).max(writePlatformAgentLimitsBodyReasonMax)
})

export const writePlatformAgentLimitsResponseRevisionMin = 0;

export const writePlatformAgentLimitsResponseLimitsLookupRoundsMax = 48;

export const writePlatformAgentLimitsResponseLimitsLookupCallsMax = 512;

export const writePlatformAgentLimitsResponseLimitsLookupTimeLimitSecondsMin = 30;
export const writePlatformAgentLimitsResponseLimitsLookupTimeLimitSecondsMax = 1800;

export const writePlatformAgentLimitsResponseLimitsToolResultBytesMin = 8192;
export const writePlatformAgentLimitsResponseLimitsToolResultBytesMax = 1048576;

export const writePlatformAgentLimitsResponseLimitsToolArgumentBytesMin = 131072;
export const writePlatformAgentLimitsResponseLimitsToolArgumentBytesMax = 4194304;

export const writePlatformAgentLimitsResponseLimitsResponseBytesMin = 65536;
export const writePlatformAgentLimitsResponseLimitsResponseBytesMax = 4194304;

export const writePlatformAgentLimitsResponseLimitsFileToolRoundsMax = 48;

export const writePlatformAgentLimitsResponseDefaultsLookupRoundsMax = 48;

export const writePlatformAgentLimitsResponseDefaultsLookupCallsMax = 512;

export const writePlatformAgentLimitsResponseDefaultsLookupTimeLimitSecondsMin = 30;
export const writePlatformAgentLimitsResponseDefaultsLookupTimeLimitSecondsMax = 1800;

export const writePlatformAgentLimitsResponseDefaultsToolResultBytesMin = 8192;
export const writePlatformAgentLimitsResponseDefaultsToolResultBytesMax = 1048576;

export const writePlatformAgentLimitsResponseDefaultsToolArgumentBytesMin = 131072;
export const writePlatformAgentLimitsResponseDefaultsToolArgumentBytesMax = 4194304;

export const writePlatformAgentLimitsResponseDefaultsResponseBytesMin = 65536;
export const writePlatformAgentLimitsResponseDefaultsResponseBytesMax = 4194304;

export const writePlatformAgentLimitsResponseDefaultsFileToolRoundsMax = 48;



export const writePlatformAgentLimitsResponse = zod.object({
  "revision": zod.int().min(writePlatformAgentLimitsResponseRevisionMin),
  "requestId": zod.uuid().nullable(),
  "limits": zod.object({
  "lookupRounds": zod.int().min(1).max(writePlatformAgentLimitsResponseLimitsLookupRoundsMax).describe('Model steps for application lookups in one reply'),
  "lookupCalls": zod.int().min(1).max(writePlatformAgentLimitsResponseLimitsLookupCallsMax).describe('Lookup tool calls in one reply'),
  "lookupTimeLimitSeconds": zod.int().min(writePlatformAgentLimitsResponseLimitsLookupTimeLimitSecondsMin).max(writePlatformAgentLimitsResponseLimitsLookupTimeLimitSecondsMax).describe('Overall time for lookups in one reply'),
  "toolResultBytes": zod.int().min(writePlatformAgentLimitsResponseLimitsToolResultBytesMin).max(writePlatformAgentLimitsResponseLimitsToolResultBytesMax).describe('Size of one tool result returned to the model'),
  "toolArgumentBytes": zod.int().min(writePlatformAgentLimitsResponseLimitsToolArgumentBytesMin).max(writePlatformAgentLimitsResponseLimitsToolArgumentBytesMax).describe('Size of one tool request from the model'),
  "responseBytes": zod.int().min(writePlatformAgentLimitsResponseLimitsResponseBytesMin).max(writePlatformAgentLimitsResponseLimitsResponseBytesMax).describe('Size of one model response'),
  "fileToolRounds": zod.int().min(1).max(writePlatformAgentLimitsResponseLimitsFileToolRoundsMax).describe('Model steps for record file actions in one reply')
}),
  "defaults": zod.object({
  "lookupRounds": zod.int().min(1).max(writePlatformAgentLimitsResponseDefaultsLookupRoundsMax).describe('Model steps for application lookups in one reply'),
  "lookupCalls": zod.int().min(1).max(writePlatformAgentLimitsResponseDefaultsLookupCallsMax).describe('Lookup tool calls in one reply'),
  "lookupTimeLimitSeconds": zod.int().min(writePlatformAgentLimitsResponseDefaultsLookupTimeLimitSecondsMin).max(writePlatformAgentLimitsResponseDefaultsLookupTimeLimitSecondsMax).describe('Overall time for lookups in one reply'),
  "toolResultBytes": zod.int().min(writePlatformAgentLimitsResponseDefaultsToolResultBytesMin).max(writePlatformAgentLimitsResponseDefaultsToolResultBytesMax).describe('Size of one tool result returned to the model'),
  "toolArgumentBytes": zod.int().min(writePlatformAgentLimitsResponseDefaultsToolArgumentBytesMin).max(writePlatformAgentLimitsResponseDefaultsToolArgumentBytesMax).describe('Size of one tool request from the model'),
  "responseBytes": zod.int().min(writePlatformAgentLimitsResponseDefaultsResponseBytesMin).max(writePlatformAgentLimitsResponseDefaultsResponseBytesMax).describe('Size of one model response'),
  "fileToolRounds": zod.int().min(1).max(writePlatformAgentLimitsResponseDefaultsFileToolRoundsMax).describe('Model steps for record file actions in one reply')
})
})


/**
 * @summary Read the original actor-owned Agent limits save outcome
 */
export const getPlatformAgentLimitsSaveParams = zod.object({
  "requestId": zod.uuid()
})

export const getPlatformAgentLimitsSaveResponseLimitsOneRevisionMin = 0;

export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsLookupRoundsMax = 48;

export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsLookupCallsMax = 512;

export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsLookupTimeLimitSecondsMin = 30;
export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsLookupTimeLimitSecondsMax = 1800;

export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsToolResultBytesMin = 8192;
export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsToolResultBytesMax = 1048576;

export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsToolArgumentBytesMin = 131072;
export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsToolArgumentBytesMax = 4194304;

export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsResponseBytesMin = 65536;
export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsResponseBytesMax = 4194304;

export const getPlatformAgentLimitsSaveResponseLimitsOneLimitsFileToolRoundsMax = 48;

export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsLookupRoundsMax = 48;

export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsLookupCallsMax = 512;

export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsLookupTimeLimitSecondsMin = 30;
export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsLookupTimeLimitSecondsMax = 1800;

export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsToolResultBytesMin = 8192;
export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsToolResultBytesMax = 1048576;

export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsToolArgumentBytesMin = 131072;
export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsToolArgumentBytesMax = 4194304;

export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsResponseBytesMin = 65536;
export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsResponseBytesMax = 4194304;

export const getPlatformAgentLimitsSaveResponseLimitsOneDefaultsFileToolRoundsMax = 48;



export const getPlatformAgentLimitsSaveResponse = zod.object({
  "limits": zod.union([zod.object({
  "revision": zod.int().min(getPlatformAgentLimitsSaveResponseLimitsOneRevisionMin),
  "requestId": zod.uuid().nullable(),
  "limits": zod.object({
  "lookupRounds": zod.int().min(1).max(getPlatformAgentLimitsSaveResponseLimitsOneLimitsLookupRoundsMax).describe('Model steps for application lookups in one reply'),
  "lookupCalls": zod.int().min(1).max(getPlatformAgentLimitsSaveResponseLimitsOneLimitsLookupCallsMax).describe('Lookup tool calls in one reply'),
  "lookupTimeLimitSeconds": zod.int().min(getPlatformAgentLimitsSaveResponseLimitsOneLimitsLookupTimeLimitSecondsMin).max(getPlatformAgentLimitsSaveResponseLimitsOneLimitsLookupTimeLimitSecondsMax).describe('Overall time for lookups in one reply'),
  "toolResultBytes": zod.int().min(getPlatformAgentLimitsSaveResponseLimitsOneLimitsToolResultBytesMin).max(getPlatformAgentLimitsSaveResponseLimitsOneLimitsToolResultBytesMax).describe('Size of one tool result returned to the model'),
  "toolArgumentBytes": zod.int().min(getPlatformAgentLimitsSaveResponseLimitsOneLimitsToolArgumentBytesMin).max(getPlatformAgentLimitsSaveResponseLimitsOneLimitsToolArgumentBytesMax).describe('Size of one tool request from the model'),
  "responseBytes": zod.int().min(getPlatformAgentLimitsSaveResponseLimitsOneLimitsResponseBytesMin).max(getPlatformAgentLimitsSaveResponseLimitsOneLimitsResponseBytesMax).describe('Size of one model response'),
  "fileToolRounds": zod.int().min(1).max(getPlatformAgentLimitsSaveResponseLimitsOneLimitsFileToolRoundsMax).describe('Model steps for record file actions in one reply')
}),
  "defaults": zod.object({
  "lookupRounds": zod.int().min(1).max(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsLookupRoundsMax).describe('Model steps for application lookups in one reply'),
  "lookupCalls": zod.int().min(1).max(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsLookupCallsMax).describe('Lookup tool calls in one reply'),
  "lookupTimeLimitSeconds": zod.int().min(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsLookupTimeLimitSecondsMin).max(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsLookupTimeLimitSecondsMax).describe('Overall time for lookups in one reply'),
  "toolResultBytes": zod.int().min(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsToolResultBytesMin).max(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsToolResultBytesMax).describe('Size of one tool result returned to the model'),
  "toolArgumentBytes": zod.int().min(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsToolArgumentBytesMin).max(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsToolArgumentBytesMax).describe('Size of one tool request from the model'),
  "responseBytes": zod.int().min(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsResponseBytesMin).max(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsResponseBytesMax).describe('Size of one model response'),
  "fileToolRounds": zod.int().min(1).max(getPlatformAgentLimitsSaveResponseLimitsOneDefaultsFileToolRoundsMax).describe('Model steps for record file actions in one reply')
})
}),zod.null()])
})


/**
 * Requires platform.features.manage.
 * @summary List platform-owned module definitions
 */
export const listPlatformFeaturesQueryLimitDefault = 25;
export const listPlatformFeaturesQueryLimitMax = 100;

export const listPlatformFeaturesQueryOffsetDefault = 0;
export const listPlatformFeaturesQueryOffsetMin = 0;



export const listPlatformFeaturesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformFeaturesQueryLimitMax).default(listPlatformFeaturesQueryLimitDefault),
  "offset": zod.int().min(listPlatformFeaturesQueryOffsetMin).default(listPlatformFeaturesQueryOffsetDefault)
})

export const listPlatformFeaturesResponseTotalMin = 0;


export const listPlatformFeaturesResponseOffsetMin = 0;



export const listPlatformFeaturesResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "stage": zod.enum(['available', 'preview', 'deprecated', 'hidden']),
  "defaultEnabled": zod.boolean(),
  "sortOrder": zod.int(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPlatformFeaturesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPlatformFeaturesResponseOffsetMin)
})


/**
 * Requires platform.features.manage.
 */
export const updatePlatformFeaturePathKeyMax = 80;


export const updatePlatformFeaturePathKeyRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');


export const updatePlatformFeatureParams = zod.object({
  "key": zod.string().max(updatePlatformFeaturePathKeyMax).regex(updatePlatformFeaturePathKeyRegExp)
})

export const updatePlatformFeatureBodyNameMin = 2;
export const updatePlatformFeatureBodyNameMax = 100;

export const updatePlatformFeatureBodyDescriptionMin = 2;
export const updatePlatformFeatureBodyDescriptionMax = 500;

export const updatePlatformFeatureBodyReasonMin = 10;
export const updatePlatformFeatureBodyReasonMax = 1000;



export const updatePlatformFeatureBody = zod.object({
  "name": zod.string().min(updatePlatformFeatureBodyNameMin).max(updatePlatformFeatureBodyNameMax),
  "description": zod.string().min(updatePlatformFeatureBodyDescriptionMin).max(updatePlatformFeatureBodyDescriptionMax),
  "stage": zod.enum(['available', 'preview', 'deprecated', 'hidden']),
  "defaultEnabled": zod.boolean(),
  "reason": zod.string().min(updatePlatformFeatureBodyReasonMin).max(updatePlatformFeatureBodyReasonMax)
})

export const updatePlatformFeatureResponse = zod.object({
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "stage": zod.enum(['available', 'preview', 'deprecated', 'hidden']),
  "defaultEnabled": zod.boolean(),
  "sortOrder": zod.int(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires platform.features.manage.
 */
export const setPlatformFeatureTenantOverridePathKeyMax = 80;


export const setPlatformFeatureTenantOverridePathKeyRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');


export const setPlatformFeatureTenantOverrideParams = zod.object({
  "key": zod.string().max(setPlatformFeatureTenantOverridePathKeyMax).regex(setPlatformFeatureTenantOverridePathKeyRegExp),
  "tenantId": zod.uuid()
})

export const setPlatformFeatureTenantOverrideBodyReasonMin = 10;
export const setPlatformFeatureTenantOverrideBodyReasonMax = 1000;



export const setPlatformFeatureTenantOverrideBody = zod.object({
  "forcedState": zod.enum(['on', 'off']),
  "reason": zod.string().min(setPlatformFeatureTenantOverrideBodyReasonMin).max(setPlatformFeatureTenantOverrideBodyReasonMax)
})

export const setPlatformFeatureTenantOverrideResponse = zod.object({
  "featureKey": zod.string(),
  "tenantId": zod.uuid(),
  "forcedState": zod.enum(['on', 'off']),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires platform.users.manage.
 * @summary List synced application users for platform administration
 */
export const listPlatformUsersQueryLimitDefault = 25;
export const listPlatformUsersQueryLimitMax = 100;

export const listPlatformUsersQueryOffsetDefault = 0;
export const listPlatformUsersQueryOffsetMin = 0;

export const listPlatformUsersQuerySearchMax = 200;



export const listPlatformUsersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformUsersQueryLimitMax).default(listPlatformUsersQueryLimitDefault),
  "offset": zod.int().min(listPlatformUsersQueryOffsetMin).default(listPlatformUsersQueryOffsetDefault),
  "search": zod.string().max(listPlatformUsersQuerySearchMax).optional(),
  "role": zod.enum(['staff', 'admin']).optional()
})

export const listPlatformUsersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullish(),
  "role": zod.enum(['staff', 'admin']).describe('Database-backed application role stored on app_users.'),
  "lastLoginAt": zod.iso.datetime({"offset":true}).nullish(),
  "tenantNames": zod.array(zod.string()),
  "platformRoles": zod.array(zod.string())
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires platform.users.manage and platform.roles.manage. The server binds the user to the configured Workforce tenant.
 * @summary Add an Entra directory user and assign platform roles
 */
export const addPlatformUserBodyDisplayNameMax = 200;

export const addPlatformUserBodyEmailMax = 320;

export const addPlatformUserBodyRoleDefinitionIdsMax = 20;

export const addPlatformUserBodyReasonMin = 10;
export const addPlatformUserBodyReasonMax = 1000;



export const addPlatformUserBody = zod.object({
  "entraObjectId": zod.uuid().describe('Stable Microsoft Entra object identifier returned by Graph.'),
  "displayName": zod.string().min(1).max(addPlatformUserBodyDisplayNameMax),
  "email": zod.email().max(addPlatformUserBodyEmailMax).describe('Directory mail address or user principal name.'),
  "roleDefinitionIds": zod.array(zod.uuid()).min(1).max(addPlatformUserBodyRoleDefinitionIdsMax),
  "reason": zod.string().min(addPlatformUserBodyReasonMin).max(addPlatformUserBodyReasonMax)
})

export const addPlatformUserResponse = zod.object({
  "id": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullish(),
  "role": zod.enum(['staff', 'admin']).describe('Database-backed application role stored on app_users.'),
  "lastLoginAt": zod.iso.datetime({"offset":true}).nullish(),
  "tenantNames": zod.array(zod.string()),
  "platformRoles": zod.array(zod.string())
})


/**
 * Requires platform.users.manage.
 * @summary Change the legacy application-wide role
 */
export const setAppUserRoleParams = zod.object({
  "id": zod.uuid()
})

export const setAppUserRoleBody = zod.object({
  "role": zod.enum(['staff', 'admin']).describe('Database-backed application role stored on app_users.')
})

export const setAppUserRoleResponse = zod.object({
  "id": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullish(),
  "role": zod.enum(['staff', 'admin']).describe('Database-backed application role stored on app_users.'),
  "lastLoginAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})


export const getPlatformOptionsResponse = zod.object({
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scope": zod.string()
}))
})


export const listPlatformTenantEntitiesParams = zod.object({
  "id": zod.uuid()
})

export const listPlatformTenantEntitiesQueryLimitDefault = 25;
export const listPlatformTenantEntitiesQueryLimitMax = 100;

export const listPlatformTenantEntitiesQueryOffsetDefault = 0;
export const listPlatformTenantEntitiesQueryOffsetMin = 0;



export const listPlatformTenantEntitiesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformTenantEntitiesQueryLimitMax).default(listPlatformTenantEntitiesQueryLimitDefault),
  "offset": zod.int().min(listPlatformTenantEntitiesQueryOffsetMin).default(listPlatformTenantEntitiesQueryOffsetDefault)
})

export const listPlatformTenantEntitiesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "status": zod.string()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires platform.tenants.read. Status and search are applied before paging; totals describe the filtered directory.
 * @summary listPlatformTenants
 */
export const listPlatformTenantsQuerySearchMax = 120;

export const listPlatformTenantsQueryLimitDefault = 25;
export const listPlatformTenantsQueryLimitMax = 100;

export const listPlatformTenantsQueryOffsetDefault = 0;
export const listPlatformTenantsQueryOffsetMin = 0;



export const listPlatformTenantsQueryParams = zod.object({
  "status": zod.enum(['active', 'suspended', 'archived']).optional(),
  "search": zod.string().max(listPlatformTenantsQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listPlatformTenantsQueryLimitMax).default(listPlatformTenantsQueryLimitDefault),
  "offset": zod.int().min(listPlatformTenantsQueryOffsetMin).default(listPlatformTenantsQueryOffsetDefault)
})

export const listPlatformTenantsResponseItemsItemNameMin = 2;
export const listPlatformTenantsResponseItemsItemNameMax = 120;

export const listPlatformTenantsResponseItemsItemVanityAliasMin = 2;
export const listPlatformTenantsResponseItemsItemVanityAliasMax = 80;


export const listPlatformTenantsResponseItemsItemVanityAliasRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');


export const listPlatformTenantsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(listPlatformTenantsResponseItemsItemNameMin).max(listPlatformTenantsResponseItemsItemNameMax),
  "slug": zod.uuid(),
  "vanityAlias": zod.string().min(listPlatformTenantsResponseItemsItemVanityAliasMin).max(listPlatformTenantsResponseItemsItemVanityAliasMax).regex(listPlatformTenantsResponseItemsItemVanityAliasRegExp),
  "status": zod.string(),
  "ownerEmails": zod.array(zod.string()),
  "entityCount": zod.int(),
  "memberCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "activeTotal": zod.int().optional(),
  "suspendedTotal": zod.int().optional(),
  "archivedTotal": zod.int().optional()
})


/**
 * Requires platform.tenants.provision.
 * @summary provisionPlatformTenant
 */
export const provisionPlatformTenantBodyNameMin = 2;
export const provisionPlatformTenantBodyNameMax = 120;

export const provisionPlatformTenantBodyVanityAliasMin = 2;
export const provisionPlatformTenantBodyVanityAliasMax = 80;


export const provisionPlatformTenantBodyVanityAliasRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
export const provisionPlatformTenantBodyFirstOwnerEmailMax = 254;

export const provisionPlatformTenantBodyFirstEntityNameMin = 2;
export const provisionPlatformTenantBodyFirstEntityNameMax = 120;

export const provisionPlatformTenantBodyGrantCreatorTemporaryAccessDefault = false;
export const provisionPlatformTenantBodyReasonMax = 1000;



export const provisionPlatformTenantBody = zod.object({
  "name": zod.string().min(provisionPlatformTenantBodyNameMin).max(provisionPlatformTenantBodyNameMax),
  "vanityAlias": zod.string().min(provisionPlatformTenantBodyVanityAliasMin).max(provisionPlatformTenantBodyVanityAliasMax).regex(provisionPlatformTenantBodyVanityAliasRegExp),
  "firstOwnerEmail": zod.email().max(provisionPlatformTenantBodyFirstOwnerEmailMax).optional(),
  "firstEntityName": zod.string().min(provisionPlatformTenantBodyFirstEntityNameMin).max(provisionPlatformTenantBodyFirstEntityNameMax).optional(),
  "grantCreatorTemporaryAccess": zod.boolean().default(provisionPlatformTenantBodyGrantCreatorTemporaryAccessDefault).describe('Grant the provisioning administrator tenant-owner authority and first-entity access for eight hours.'),
  "reason": zod.string().max(provisionPlatformTenantBodyReasonMax).optional()
})

export const provisionPlatformTenantResponse = zod.object({
  "id": zod.uuid(),
  "invitationId": zod.uuid().nullable(),
  "emailStatus": zod.enum(['sent', 'failed', 'not_requested']),
  "creatorAccessExpiresAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires platform.tenants.manage.
 * @summary updatePlatformTenant
 */
export const updatePlatformTenantParams = zod.object({
  "id": zod.uuid()
})

export const updatePlatformTenantBodyVanityAliasMin = 2;
export const updatePlatformTenantBodyVanityAliasMax = 80;


export const updatePlatformTenantBodyVanityAliasRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
export const updatePlatformTenantBodyReasonMin = 10;
export const updatePlatformTenantBodyReasonMax = 1000;



export const updatePlatformTenantBody = zod.object({
  "status": zod.enum(['active', 'suspended']).optional(),
  "vanityAlias": zod.string().min(updatePlatformTenantBodyVanityAliasMin).max(updatePlatformTenantBodyVanityAliasMax).regex(updatePlatformTenantBodyVanityAliasRegExp).optional(),
  "reason": zod.string().min(updatePlatformTenantBodyReasonMin).max(updatePlatformTenantBodyReasonMax)
})

export const updatePlatformTenantResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.tenants.manage, an exact tenant-name confirmation, and a completed full export from the last 24 hours. Archival disables access but retains tenant data.
 * @summary Archive a suspended tenant indefinitely
 */
export const archivePlatformTenantParams = zod.object({
  "id": zod.uuid()
})

export const archivePlatformTenantBodyConfirmNameMin = 2;
export const archivePlatformTenantBodyConfirmNameMax = 120;

export const archivePlatformTenantBodyReasonMin = 10;
export const archivePlatformTenantBodyReasonMax = 1000;



export const archivePlatformTenantBody = zod.object({
  "confirmName": zod.string().min(archivePlatformTenantBodyConfirmNameMin).max(archivePlatformTenantBodyConfirmNameMax),
  "reason": zod.string().min(archivePlatformTenantBodyReasonMin).max(archivePlatformTenantBodyReasonMax)
})

export const archivePlatformTenantResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.tenants.provision.
 * @summary resendPlatformOwnerInvitation
 */
export const resendPlatformOwnerInvitationParams = zod.object({
  "id": zod.uuid()
})

export const resendPlatformOwnerInvitationBodyReasonMin = 10;
export const resendPlatformOwnerInvitationBodyReasonMax = 1000;



export const resendPlatformOwnerInvitationBody = zod.object({
  "reason": zod.string().min(resendPlatformOwnerInvitationBodyReasonMin).max(resendPlatformOwnerInvitationBodyReasonMax)
})

export const resendPlatformOwnerInvitationResponse = zod.object({
  "id": zod.uuid(),
  "invitationId": zod.uuid().nullable(),
  "emailStatus": zod.enum(['sent', 'failed', 'not_requested']),
  "creatorAccessExpiresAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires platform.tenants.read.
 * @summary getPlatformTenantDetails
 */
export const getPlatformTenantDetailsParams = zod.object({
  "id": zod.uuid()
})

export const getPlatformTenantDetailsResponseTenantVanityAliasMin = 2;
export const getPlatformTenantDetailsResponseTenantVanityAliasMax = 80;


export const getPlatformTenantDetailsResponseTenantVanityAliasRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');


export const getPlatformTenantDetailsResponse = zod.object({
  "tenant": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.uuid(),
  "vanityAlias": zod.string().min(getPlatformTenantDetailsResponseTenantVanityAliasMin).max(getPlatformTenantDetailsResponseTenantVanityAliasMax).regex(getPlatformTenantDetailsResponseTenantVanityAliasRegExp),
  "status": zod.string(),
  "ownerEmails": zod.array(zod.string()),
  "entityCount": zod.int(),
  "memberCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "lastActivityAt": zod.iso.datetime({"offset":true})
}),
  "ownerInvitation": zod.union([zod.object({
  "id": zod.uuid(),
  "email": zod.email(),
  "status": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "latestCompletedExportAt": zod.iso.datetime({"offset":true}).nullable(),
  "recentAudit": zod.array(zod.object({
  "id": zod.uuid(),
  "action": zod.string(),
  "actorName": zod.string().nullable(),
  "outcome": zod.string(),
  "reason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * Creates or updates and resends an unopened tenant's owner invitation. Requires platform.tenants.provision.
 * @summary changePlatformTenantOwnerEmail
 */
export const changePlatformTenantOwnerEmailParams = zod.object({
  "id": zod.uuid()
})

export const changePlatformTenantOwnerEmailBodyEmailMax = 254;

export const changePlatformTenantOwnerEmailBodyReasonMin = 10;
export const changePlatformTenantOwnerEmailBodyReasonMax = 1000;



export const changePlatformTenantOwnerEmailBody = zod.object({
  "email": zod.email().max(changePlatformTenantOwnerEmailBodyEmailMax),
  "reason": zod.string().min(changePlatformTenantOwnerEmailBodyReasonMin).max(changePlatformTenantOwnerEmailBodyReasonMax)
})

export const changePlatformTenantOwnerEmailResponse = zod.object({
  "id": zod.uuid(),
  "invitationId": zod.uuid().nullable(),
  "emailStatus": zod.enum(['sent', 'failed', 'not_requested']),
  "creatorAccessExpiresAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires platform.roles.assign.
 * @summary listPlatformRoleAssignments
 */
export const listPlatformRoleAssignmentsQueryLimitDefault = 25;
export const listPlatformRoleAssignmentsQueryLimitMax = 100;

export const listPlatformRoleAssignmentsQueryOffsetDefault = 0;
export const listPlatformRoleAssignmentsQueryOffsetMin = 0;



export const listPlatformRoleAssignmentsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformRoleAssignmentsQueryLimitMax).default(listPlatformRoleAssignmentsQueryLimitDefault),
  "offset": zod.int().min(listPlatformRoleAssignmentsQueryOffsetMin).default(listPlatformRoleAssignmentsQueryOffsetDefault)
})

export const listPlatformRoleAssignmentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "email": zod.string().nullable(),
  "name": zod.string(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "administratorTotal": zod.int().optional()
})


/**
 * Requires platform.roles.assign.
 * @summary assignPlatformRole
 */
export const assignPlatformRoleBodyReasonMin = 10;
export const assignPlatformRoleBodyReasonMax = 1000;



export const assignPlatformRoleBody = zod.object({
  "email": zod.email(),
  "roleDefinitionId": zod.uuid(),
  "reason": zod.string().min(assignPlatformRoleBodyReasonMin).max(assignPlatformRoleBodyReasonMax)
})

export const assignPlatformRoleResponse = zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "email": zod.string().nullable(),
  "name": zod.string(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires platform.roles.assign.
 * @summary revokePlatformRole
 */
export const revokePlatformRoleParams = zod.object({
  "id": zod.uuid()
})

export const revokePlatformRoleBodyReasonMin = 10;
export const revokePlatformRoleBodyReasonMax = 1000;



export const revokePlatformRoleBody = zod.object({
  "reason": zod.string().min(revokePlatformRoleBodyReasonMin).max(revokePlatformRoleBodyReasonMax)
})

export const revokePlatformRoleResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.roles.manage, platform.roles.assign or platform.groups.manage.
 */
export const listPlatformRolesQueryLimitDefault = 25;
export const listPlatformRolesQueryLimitMax = 100;

export const listPlatformRolesQueryOffsetDefault = 0;
export const listPlatformRolesQueryOffsetMin = 0;



export const listPlatformRolesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformRolesQueryLimitMax).default(listPlatformRolesQueryLimitDefault),
  "offset": zod.int().min(listPlatformRolesQueryOffsetMin).default(listPlatformRolesQueryOffsetDefault)
})

export const listPlatformRolesResponseItemsItemAssignmentCountMin = 0;

export const listPlatformRolesResponseTotalMin = 0;


export const listPlatformRolesResponseOffsetMin = 0;



export const listPlatformRolesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "assignmentCount": zod.int().min(listPlatformRolesResponseItemsItemAssignmentCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPlatformRolesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPlatformRolesResponseOffsetMin)
})


/**
 * Requires platform.roles.manage.
 */
export const createPlatformRoleBodyKeyRegExp = new RegExp('^[a-z][a-z0-9-]{1,63}$');
export const createPlatformRoleBodyNameMin = 2;
export const createPlatformRoleBodyNameMax = 120;

export const createPlatformRoleBodyDescriptionMin = 2;
export const createPlatformRoleBodyDescriptionMax = 500;

export const createPlatformRoleBodyPermissionKeysMax = 50;

export const createPlatformRoleBodyReasonMin = 10;
export const createPlatformRoleBodyReasonMax = 1000;



export const createPlatformRoleBody = zod.object({
  "key": zod.string().regex(createPlatformRoleBodyKeyRegExp),
  "name": zod.string().min(createPlatformRoleBodyNameMin).max(createPlatformRoleBodyNameMax),
  "description": zod.string().min(createPlatformRoleBodyDescriptionMin).max(createPlatformRoleBodyDescriptionMax),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "permissionKeys": zod.array(zod.string()).min(1).max(createPlatformRoleBodyPermissionKeysMax),
  "reason": zod.string().min(createPlatformRoleBodyReasonMin).max(createPlatformRoleBodyReasonMax)
})

export const createPlatformRoleResponseAssignmentCountMin = 0;



export const createPlatformRoleResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "assignmentCount": zod.int().min(createPlatformRoleResponseAssignmentCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires platform.roles.manage.
 */
export const updatePlatformRoleParams = zod.object({
  "id": zod.uuid()
})

export const updatePlatformRoleBodyKeyRegExp = new RegExp('^[a-z][a-z0-9-]{1,63}$');
export const updatePlatformRoleBodyNameMin = 2;
export const updatePlatformRoleBodyNameMax = 120;

export const updatePlatformRoleBodyDescriptionMin = 2;
export const updatePlatformRoleBodyDescriptionMax = 500;

export const updatePlatformRoleBodyPermissionKeysMax = 50;

export const updatePlatformRoleBodyReasonMin = 10;
export const updatePlatformRoleBodyReasonMax = 1000;



export const updatePlatformRoleBody = zod.object({
  "key": zod.string().regex(updatePlatformRoleBodyKeyRegExp),
  "name": zod.string().min(updatePlatformRoleBodyNameMin).max(updatePlatformRoleBodyNameMax),
  "description": zod.string().min(updatePlatformRoleBodyDescriptionMin).max(updatePlatformRoleBodyDescriptionMax),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "permissionKeys": zod.array(zod.string()).min(1).max(updatePlatformRoleBodyPermissionKeysMax),
  "reason": zod.string().min(updatePlatformRoleBodyReasonMin).max(updatePlatformRoleBodyReasonMax)
})

export const updatePlatformRoleResponseAssignmentCountMin = 0;



export const updatePlatformRoleResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "assignmentCount": zod.int().min(updatePlatformRoleResponseAssignmentCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires platform.roles.manage.
 */
export const deletePlatformRoleParams = zod.object({
  "id": zod.uuid()
})

export const deletePlatformRoleBodyReasonMin = 10;
export const deletePlatformRoleBodyReasonMax = 1000;



export const deletePlatformRoleBody = zod.object({
  "reason": zod.string().min(deletePlatformRoleBodyReasonMin).max(deletePlatformRoleBodyReasonMax)
})

export const deletePlatformRoleResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.groups.manage.
 */
export const listPlatformGroupsQueryLimitDefault = 25;
export const listPlatformGroupsQueryLimitMax = 100;

export const listPlatformGroupsQueryOffsetDefault = 0;
export const listPlatformGroupsQueryOffsetMin = 0;



export const listPlatformGroupsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformGroupsQueryLimitMax).default(listPlatformGroupsQueryLimitDefault),
  "offset": zod.int().min(listPlatformGroupsQueryOffsetMin).default(listPlatformGroupsQueryOffsetDefault)
})

export const listPlatformGroupsResponseTotalMin = 0;


export const listPlatformGroupsResponseOffsetMin = 0;



export const listPlatformGroupsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "scope": zod.enum(['platform', 'tenant']),
  "name": zod.string(),
  "description": zod.string(),
  "members": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string().nullable()
})),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})),
  "entraBindings": zod.array(zod.object({
  "id": zod.uuid(),
  "objectId": zod.uuid(),
  "note": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPlatformGroupsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPlatformGroupsResponseOffsetMin),
  "entraGroupsClaimActive": zod.boolean(),
  "entraGroupsSeenAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires platform.groups.manage.
 */
export const createPlatformGroupBodyNameMin = 2;
export const createPlatformGroupBodyNameMax = 120;

export const createPlatformGroupBodyDescriptionMax = 500;

export const createPlatformGroupBodyMemberIdsMax = 100;

export const createPlatformGroupBodyRoleIdsMax = 50;

export const createPlatformGroupBodyEntraBindingsItemNoteMax = 250;

export const createPlatformGroupBodyEntraBindingsMax = 20;

export const createPlatformGroupBodyReasonMin = 10;
export const createPlatformGroupBodyReasonMax = 1000;



export const createPlatformGroupBody = zod.object({
  "name": zod.string().min(createPlatformGroupBodyNameMin).max(createPlatformGroupBodyNameMax),
  "description": zod.string().max(createPlatformGroupBodyDescriptionMax),
  "memberIds": zod.array(zod.uuid()).max(createPlatformGroupBodyMemberIdsMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(createPlatformGroupBodyRoleIdsMax),
  "entraBindings": zod.array(zod.object({
  "objectId": zod.uuid(),
  "note": zod.string().max(createPlatformGroupBodyEntraBindingsItemNoteMax)
})).max(createPlatformGroupBodyEntraBindingsMax),
  "reason": zod.string().min(createPlatformGroupBodyReasonMin).max(createPlatformGroupBodyReasonMax)
})

export const createPlatformGroupResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "scope": zod.enum(['platform', 'tenant']),
  "name": zod.string(),
  "description": zod.string(),
  "members": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string().nullable()
})),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})),
  "entraBindings": zod.array(zod.object({
  "id": zod.uuid(),
  "objectId": zod.uuid(),
  "note": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires platform.groups.manage.
 */
export const updatePlatformGroupParams = zod.object({
  "id": zod.uuid()
})

export const updatePlatformGroupBodyNameMin = 2;
export const updatePlatformGroupBodyNameMax = 120;

export const updatePlatformGroupBodyDescriptionMax = 500;

export const updatePlatformGroupBodyMemberIdsMax = 100;

export const updatePlatformGroupBodyRoleIdsMax = 50;

export const updatePlatformGroupBodyEntraBindingsItemNoteMax = 250;

export const updatePlatformGroupBodyEntraBindingsMax = 20;

export const updatePlatformGroupBodyReasonMin = 10;
export const updatePlatformGroupBodyReasonMax = 1000;



export const updatePlatformGroupBody = zod.object({
  "name": zod.string().min(updatePlatformGroupBodyNameMin).max(updatePlatformGroupBodyNameMax),
  "description": zod.string().max(updatePlatformGroupBodyDescriptionMax),
  "memberIds": zod.array(zod.uuid()).max(updatePlatformGroupBodyMemberIdsMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(updatePlatformGroupBodyRoleIdsMax),
  "entraBindings": zod.array(zod.object({
  "objectId": zod.uuid(),
  "note": zod.string().max(updatePlatformGroupBodyEntraBindingsItemNoteMax)
})).max(updatePlatformGroupBodyEntraBindingsMax),
  "reason": zod.string().min(updatePlatformGroupBodyReasonMin).max(updatePlatformGroupBodyReasonMax)
})

export const updatePlatformGroupResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "scope": zod.enum(['platform', 'tenant']),
  "name": zod.string(),
  "description": zod.string(),
  "members": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string().nullable()
})),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})),
  "entraBindings": zod.array(zod.object({
  "id": zod.uuid(),
  "objectId": zod.uuid(),
  "note": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires platform.groups.manage.
 */
export const deletePlatformGroupParams = zod.object({
  "id": zod.uuid()
})

export const deletePlatformGroupBodyReasonMin = 10;
export const deletePlatformGroupBodyReasonMax = 1000;



export const deletePlatformGroupBody = zod.object({
  "reason": zod.string().min(deletePlatformGroupBodyReasonMin).max(deletePlatformGroupBodyReasonMax)
})

export const deletePlatformGroupResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Search platform users available for group membership.
 */
export const listPlatformGroupMembersQuerySearchMax = 120;

export const listPlatformGroupMembersQueryLimitDefault = 25;
export const listPlatformGroupMembersQueryLimitMax = 100;

export const listPlatformGroupMembersQueryOffsetDefault = 0;
export const listPlatformGroupMembersQueryOffsetMin = 0;



export const listPlatformGroupMembersQueryParams = zod.object({
  "search": zod.string().max(listPlatformGroupMembersQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listPlatformGroupMembersQueryLimitMax).default(listPlatformGroupMembersQueryLimitDefault),
  "offset": zod.int().min(listPlatformGroupMembersQueryOffsetMin).default(listPlatformGroupMembersQueryOffsetDefault)
})

export const listPlatformGroupMembersResponseTotalMin = 0;


export const listPlatformGroupMembersResponseOffsetMin = 0;



export const listPlatformGroupMembersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string().nullable()
})),
  "total": zod.int().min(listPlatformGroupMembersResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listPlatformGroupMembersResponseOffsetMin)
})


/**
 * Requires platform.audit.read.
 * @summary listPlatformAudit
 */
export const listPlatformAuditQueryLimitDefault = 25;
export const listPlatformAuditQueryLimitMax = 100;

export const listPlatformAuditQueryOffsetDefault = 0;
export const listPlatformAuditQueryOffsetMin = 0;

export const listPlatformAuditQueryActionMax = 100;

export const listPlatformAuditQueryActorMax = 200;



export const listPlatformAuditQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformAuditQueryLimitMax).default(listPlatformAuditQueryLimitDefault),
  "offset": zod.int().min(listPlatformAuditQueryOffsetMin).default(listPlatformAuditQueryOffsetDefault),
  "tenantId": zod.uuid().optional(),
  "action": zod.string().max(listPlatformAuditQueryActionMax).optional(),
  "actor": zod.string().max(listPlatformAuditQueryActorMax).optional(),
  "outcome": zod.enum(['succeeded', 'denied', 'failed']).optional()
})

export const listPlatformAuditResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "actorAppUserId": zod.uuid().nullable(),
  "action": zod.string(),
  "targetType": zod.string(),
  "targetId": zod.string().nullable(),
  "outcome": zod.string(),
  "reason": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "actorName": zod.string().nullish()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires signed-in staff.
 * @summary listMyEligibleRoles
 */
export const listMyEligibleRolesQueryLimitDefault = 25;
export const listMyEligibleRolesQueryLimitMax = 100;

export const listMyEligibleRolesQueryOffsetDefault = 0;
export const listMyEligibleRolesQueryOffsetMin = 0;



export const listMyEligibleRolesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listMyEligibleRolesQueryLimitMax).default(listMyEligibleRolesQueryLimitDefault),
  "offset": zod.int().min(listMyEligibleRolesQueryOffsetMin).default(listMyEligibleRolesQueryOffsetDefault)
})

export const listMyEligibleRolesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Lists tenant roles whose permissions fit within the caller's active tenant elevation. Requires permanent platform role-management permission.
 * @summary listMyPermanentTenantRoleOptions
 */
export const listMyPermanentTenantRoleOptionsQueryLimitDefault = 25;
export const listMyPermanentTenantRoleOptionsQueryLimitMax = 100;

export const listMyPermanentTenantRoleOptionsQueryOffsetDefault = 0;
export const listMyPermanentTenantRoleOptionsQueryOffsetMin = 0;



export const listMyPermanentTenantRoleOptionsQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "limit": zod.int().min(1).max(listMyPermanentTenantRoleOptionsQueryLimitMax).default(listMyPermanentTenantRoleOptionsQueryLimitDefault),
  "offset": zod.int().min(listMyPermanentTenantRoleOptionsQueryOffsetMin).default(listMyPermanentTenantRoleOptionsQueryOffsetDefault)
})

export const listMyPermanentTenantRoleOptionsResponseTotalMin = 0;


export const listMyPermanentTenantRoleOptionsResponseOffsetMin = 0;



export const listMyPermanentTenantRoleOptionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string(),
  "permissions": zod.array(zod.string())
})),
  "total": zod.int().min(listMyPermanentTenantRoleOptionsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listMyPermanentTenantRoleOptionsResponseOffsetMin)
})


/**
 * Creates or reactivates the caller's tenant membership and grants one tenant role within their active elevation. Requires permanent platform role-management permission.
 * @summary grantMyPermanentTenantRole
 */
export const grantMyPermanentTenantRoleBodyReasonMin = 10;
export const grantMyPermanentTenantRoleBodyReasonMax = 1000;



export const grantMyPermanentTenantRoleBody = zod.object({
  "tenantId": zod.uuid(),
  "roleDefinitionId": zod.uuid(),
  "reason": zod.string().min(grantMyPermanentTenantRoleBodyReasonMin).max(grantMyPermanentTenantRoleBodyReasonMax)
})

export const grantMyPermanentTenantRoleResponse = zod.object({
  "tenantId": zod.uuid(),
  "membershipId": zod.uuid(),
  "roleAssignmentId": zod.uuid(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "membershipCreated": zod.boolean()
})


/**
 * Requires signed-in staff.
 * @summary listMyElevations
 */
export const listMyElevationsQueryLimitDefault = 25;
export const listMyElevationsQueryLimitMax = 100;

export const listMyElevationsQueryOffsetDefault = 0;
export const listMyElevationsQueryOffsetMin = 0;



export const listMyElevationsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listMyElevationsQueryLimitMax).default(listMyElevationsQueryLimitDefault),
  "offset": zod.int().min(listMyElevationsQueryOffsetMin).default(listMyElevationsQueryOffsetDefault)
})

export const listMyElevationsResponseItemsItemReasonMin = 10;
export const listMyElevationsResponseItemsItemReasonMax = 1000;



export const listMyElevationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "reason": zod.string().min(listMyElevationsResponseItemsItemReasonMin).max(listMyElevationsResponseItemsItemReasonMax),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "userName": zod.string().nullish(),
  "tenantName": zod.string().nullish(),
  "entityName": zod.string().nullish()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "activeTotal": zod.int().optional()
})


/**
 * Requests 1–24 hours for an eligible role. Access stays pending until another authorized administrator approves it.
 * @summary activateMyElevation
 */
export const activateMyElevationBodyReasonMin = 10;
export const activateMyElevationBodyReasonMax = 1000;

export const activateMyElevationBodyDurationMinutesDefault = 240;
export const activateMyElevationBodyDurationMinutesMin = 60;
export const activateMyElevationBodyDurationMinutesMax = 1440;



export const activateMyElevationBody = zod.object({
  "eligibleAssignmentId": zod.uuid(),
  "reason": zod.string().min(activateMyElevationBodyReasonMin).max(activateMyElevationBodyReasonMax),
  "durationMinutes": zod.int().min(activateMyElevationBodyDurationMinutesMin).max(activateMyElevationBodyDurationMinutesMax).default(activateMyElevationBodyDurationMinutesDefault)
})

export const activateMyElevationResponseReasonMin = 10;
export const activateMyElevationResponseReasonMax = 1000;



export const activateMyElevationResponse = zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "reason": zod.string().min(activateMyElevationResponseReasonMin).max(activateMyElevationResponseReasonMax),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "userName": zod.string().nullish(),
  "tenantName": zod.string().nullish(),
  "entityName": zod.string().nullish()
})


/**
 * Requires session owner.
 * @summary endMyElevation
 */
export const endMyElevationParams = zod.object({
  "id": zod.uuid()
})

export const endMyElevationBodyReasonMin = 10;
export const endMyElevationBodyReasonMax = 1000;



export const endMyElevationBody = zod.object({
  "reason": zod.string().min(endMyElevationBodyReasonMin).max(endMyElevationBodyReasonMax)
})

export const endMyElevationResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.elevation.manage.
 * @summary listPlatformEligibleRoles
 */
export const listPlatformEligibleRolesQueryLimitDefault = 25;
export const listPlatformEligibleRolesQueryLimitMax = 100;

export const listPlatformEligibleRolesQueryOffsetDefault = 0;
export const listPlatformEligibleRolesQueryOffsetMin = 0;



export const listPlatformEligibleRolesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformEligibleRolesQueryLimitMax).default(listPlatformEligibleRolesQueryLimitDefault),
  "offset": zod.int().min(listPlatformEligibleRolesQueryOffsetMin).default(listPlatformEligibleRolesQueryOffsetDefault)
})

export const listPlatformEligibleRolesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires platform.elevation.manage.
 * @summary grantPlatformEligibleRole
 */
export const grantPlatformEligibleRoleBodyReasonMin = 10;
export const grantPlatformEligibleRoleBodyReasonMax = 1000;



export const grantPlatformEligibleRoleBody = zod.object({
  "appUserId": zod.uuid(),
  "roleDefinitionId": zod.uuid(),
  "entityId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "reason": zod.string().min(grantPlatformEligibleRoleBodyReasonMin).max(grantPlatformEligibleRoleBodyReasonMax)
})

export const grantPlatformEligibleRoleResponse = zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires platform.elevation.manage.
 * @summary revokePlatformEligibleRole
 */
export const revokePlatformEligibleRoleParams = zod.object({
  "id": zod.uuid()
})

export const revokePlatformEligibleRoleBodyReasonMin = 10;
export const revokePlatformEligibleRoleBodyReasonMax = 1000;



export const revokePlatformEligibleRoleBody = zod.object({
  "reason": zod.string().min(revokePlatformEligibleRoleBodyReasonMin).max(revokePlatformEligibleRoleBodyReasonMax)
})

export const revokePlatformEligibleRoleResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.elevation.manage.
 * @summary listPlatformElevations
 */
export const listPlatformElevationsQueryLimitDefault = 25;
export const listPlatformElevationsQueryLimitMax = 100;

export const listPlatformElevationsQueryOffsetDefault = 0;
export const listPlatformElevationsQueryOffsetMin = 0;



export const listPlatformElevationsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformElevationsQueryLimitMax).default(listPlatformElevationsQueryLimitDefault),
  "offset": zod.int().min(listPlatformElevationsQueryOffsetMin).default(listPlatformElevationsQueryOffsetDefault),
  "status": zod.enum(['active', 'expired', 'revoked']).optional(),
  "tenantId": zod.uuid().optional()
})

export const listPlatformElevationsResponseItemsItemReasonMin = 10;
export const listPlatformElevationsResponseItemsItemReasonMax = 1000;



export const listPlatformElevationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "reason": zod.string().min(listPlatformElevationsResponseItemsItemReasonMin).max(listPlatformElevationsResponseItemsItemReasonMax),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "userName": zod.string().nullish(),
  "tenantName": zod.string().nullish(),
  "entityName": zod.string().nullish()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "activeTotal": zod.int().optional()
})


/**
 * Shows whether the signed-in person is an appointed recovery custodian, whether recovery is ready (at least two active custodians) and any active recovery access.
 * @summary getMyRecoveryAccess
 */
export const getMyRecoveryAccessResponse = zod.object({
  "isCustodian": zod.boolean(),
  "ready": zod.boolean(),
  "activeCustodians": zod.int(),
  "minimumCustodians": zod.int(),
  "minDurationMinutes": zod.int(),
  "maxDurationMinutes": zod.int(),
  "session": zod.union([zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "userName": zod.string().nullable(),
  "custodianId": zod.uuid(),
  "status": zod.enum(['active', 'expired', 'ended', 'revoked']),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()])
})


/**
 * Emergency recovery for an appointed custodian when normal administrator approval is unavailable. Grants Platform Administrator permissions for 15–60 minutes, requires at least two active custodians, and is audited.
 * @summary activateMyRecoveryAccess
 */
export const activateMyRecoveryAccessBodyReasonMin = 10;
export const activateMyRecoveryAccessBodyReasonMax = 1000;

export const activateMyRecoveryAccessBodyDurationMinutesDefault = 60;
export const activateMyRecoveryAccessBodyDurationMinutesMin = 15;
export const activateMyRecoveryAccessBodyDurationMinutesMax = 60;



export const activateMyRecoveryAccessBody = zod.object({
  "reason": zod.string().min(activateMyRecoveryAccessBodyReasonMin).max(activateMyRecoveryAccessBodyReasonMax),
  "durationMinutes": zod.int().min(activateMyRecoveryAccessBodyDurationMinutesMin).max(activateMyRecoveryAccessBodyDurationMinutesMax).default(activateMyRecoveryAccessBodyDurationMinutesDefault)
})

export const activateMyRecoveryAccessResponse = zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "userName": zod.string().nullable(),
  "custodianId": zod.uuid(),
  "status": zod.enum(['active', 'expired', 'ended', 'revoked']),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Ends your own active recovery access early.
 * @summary endMyRecoveryAccess
 */
export const endMyRecoveryAccessParams = zod.object({
  "id": zod.uuid()
})

export const endMyRecoveryAccessBodyReasonMin = 10;
export const endMyRecoveryAccessBodyReasonMax = 1000;



export const endMyRecoveryAccessBody = zod.object({
  "reason": zod.string().min(endMyRecoveryAccessBodyReasonMin).max(endMyRecoveryAccessBodyReasonMax)
})

export const endMyRecoveryAccessResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.elevation.manage.
 * @summary listPlatformRecoveryCustodians
 */
export const listPlatformRecoveryCustodiansQueryLimitDefault = 25;
export const listPlatformRecoveryCustodiansQueryLimitMax = 100;

export const listPlatformRecoveryCustodiansQueryOffsetDefault = 0;
export const listPlatformRecoveryCustodiansQueryOffsetMin = 0;



export const listPlatformRecoveryCustodiansQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformRecoveryCustodiansQueryLimitMax).default(listPlatformRecoveryCustodiansQueryLimitDefault),
  "offset": zod.int().min(listPlatformRecoveryCustodiansQueryOffsetMin).default(listPlatformRecoveryCustodiansQueryOffsetDefault),
  "status": zod.enum(['active', 'revoked']).optional()
})

export const listPlatformRecoveryCustodiansResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "userName": zod.string().nullable(),
  "email": zod.string().nullable(),
  "status": zod.enum(['active', 'revoked']),
  "reason": zod.string(),
  "appointedByName": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "activeCount": zod.int(),
  "minimumCustodians": zod.int(),
  "ready": zod.boolean()
})


/**
 * Requires platform.elevation.manage. Appoints another signed-in person, identified by their Microsoft account, as a recovery custodian. You cannot appoint yourself.
 * @summary appointPlatformRecoveryCustodian
 */
export const appointPlatformRecoveryCustodianBodyReasonMin = 10;
export const appointPlatformRecoveryCustodianBodyReasonMax = 1000;



export const appointPlatformRecoveryCustodianBody = zod.object({
  "appUserId": zod.uuid(),
  "reason": zod.string().min(appointPlatformRecoveryCustodianBodyReasonMin).max(appointPlatformRecoveryCustodianBodyReasonMax)
})

export const appointPlatformRecoveryCustodianResponse = zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "userName": zod.string().nullable(),
  "email": zod.string().nullable(),
  "status": zod.enum(['active', 'revoked']),
  "reason": zod.string(),
  "appointedByName": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires platform.elevation.manage. Removes the appointment and immediately ends that custodian's active recovery access.
 * @summary revokePlatformRecoveryCustodian
 */
export const revokePlatformRecoveryCustodianParams = zod.object({
  "id": zod.uuid()
})

export const revokePlatformRecoveryCustodianBodyReasonMin = 10;
export const revokePlatformRecoveryCustodianBodyReasonMax = 1000;



export const revokePlatformRecoveryCustodianBody = zod.object({
  "reason": zod.string().min(revokePlatformRecoveryCustodianBodyReasonMin).max(revokePlatformRecoveryCustodianBodyReasonMax)
})

export const revokePlatformRecoveryCustodianResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.elevation.manage.
 * @summary listPlatformRecoverySessions
 */
export const listPlatformRecoverySessionsQueryLimitDefault = 25;
export const listPlatformRecoverySessionsQueryLimitMax = 100;

export const listPlatformRecoverySessionsQueryOffsetDefault = 0;
export const listPlatformRecoverySessionsQueryOffsetMin = 0;



export const listPlatformRecoverySessionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformRecoverySessionsQueryLimitMax).default(listPlatformRecoverySessionsQueryLimitDefault),
  "offset": zod.int().min(listPlatformRecoverySessionsQueryOffsetMin).default(listPlatformRecoverySessionsQueryOffsetDefault),
  "status": zod.enum(['active', 'expired', 'ended', 'revoked']).optional()
})

export const listPlatformRecoverySessionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "userName": zod.string().nullable(),
  "custodianId": zod.uuid(),
  "status": zod.enum(['active', 'expired', 'ended', 'revoked']),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "activeTotal": zod.int()
})


/**
 * Requires platform.elevation.manage.
 * @summary revokePlatformRecoverySession
 */
export const revokePlatformRecoverySessionParams = zod.object({
  "id": zod.uuid()
})

export const revokePlatformRecoverySessionBodyReasonMin = 10;
export const revokePlatformRecoverySessionBodyReasonMax = 1000;



export const revokePlatformRecoverySessionBody = zod.object({
  "reason": zod.string().min(revokePlatformRecoverySessionBodyReasonMin).max(revokePlatformRecoverySessionBodyReasonMax)
})

export const revokePlatformRecoverySessionResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.elevation.manage.
 * @summary revokePlatformElevation
 */
export const revokePlatformElevationParams = zod.object({
  "id": zod.uuid()
})

export const revokePlatformElevationBodyReasonMin = 10;
export const revokePlatformElevationBodyReasonMax = 1000;



export const revokePlatformElevationBody = zod.object({
  "reason": zod.string().min(revokePlatformElevationBodyReasonMin).max(revokePlatformElevationBodyReasonMax)
})

export const revokePlatformElevationResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires tenant.roles.assign.
 * @summary listTenantEligibleRoles
 */
export const listTenantEligibleRolesQueryLimitDefault = 25;
export const listTenantEligibleRolesQueryLimitMax = 100;

export const listTenantEligibleRolesQueryOffsetDefault = 0;
export const listTenantEligibleRolesQueryOffsetMin = 0;



export const listTenantEligibleRolesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantEligibleRolesQueryLimitMax).default(listTenantEligibleRolesQueryLimitDefault),
  "offset": zod.int().min(listTenantEligibleRolesQueryOffsetMin).default(listTenantEligibleRolesQueryOffsetDefault)
})

export const listTenantEligibleRolesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires tenant.roles.assign.
 * @summary grantTenantEligibleRole
 */
export const grantTenantEligibleRoleBodyReasonMin = 10;
export const grantTenantEligibleRoleBodyReasonMax = 1000;



export const grantTenantEligibleRoleBody = zod.object({
  "appUserId": zod.uuid(),
  "roleDefinitionId": zod.uuid(),
  "entityId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "reason": zod.string().min(grantTenantEligibleRoleBodyReasonMin).max(grantTenantEligibleRoleBodyReasonMax)
})

export const grantTenantEligibleRoleResponse = zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires tenant.roles.assign.
 * @summary revokeTenantEligibleRole
 */
export const revokeTenantEligibleRoleParams = zod.object({
  "id": zod.uuid()
})

export const revokeTenantEligibleRoleBodyReasonMin = 10;
export const revokeTenantEligibleRoleBodyReasonMax = 1000;



export const revokeTenantEligibleRoleBody = zod.object({
  "reason": zod.string().min(revokeTenantEligibleRoleBodyReasonMin).max(revokeTenantEligibleRoleBodyReasonMax)
})

export const revokeTenantEligibleRoleResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires tenant.roles.assign. Another administrator must approve; self-approval is forbidden.
 * @summary Approve a pending elevation request
 */
export const approveTenantElevationParams = zod.object({
  "id": zod.uuid()
})

export const approveTenantElevationBodyReasonMin = 10;
export const approveTenantElevationBodyReasonMax = 1000;



export const approveTenantElevationBody = zod.object({
  "reason": zod.string().min(approveTenantElevationBodyReasonMin).max(approveTenantElevationBodyReasonMax)
})

export const approveTenantElevationResponseReasonMin = 10;
export const approveTenantElevationResponseReasonMax = 1000;



export const approveTenantElevationResponse = zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "reason": zod.string().min(approveTenantElevationResponseReasonMin).max(approveTenantElevationResponseReasonMax),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "userName": zod.string().nullish(),
  "tenantName": zod.string().nullish(),
  "entityName": zod.string().nullish()
})


/**
 * Requires platform.elevation.manage. Another administrator must approve; self-approval is forbidden.
 * @summary Approve a pending elevation request
 */
export const approvePlatformElevationParams = zod.object({
  "id": zod.uuid()
})

export const approvePlatformElevationBodyReasonMin = 10;
export const approvePlatformElevationBodyReasonMax = 1000;



export const approvePlatformElevationBody = zod.object({
  "reason": zod.string().min(approvePlatformElevationBodyReasonMin).max(approvePlatformElevationBodyReasonMax)
})

export const approvePlatformElevationResponseReasonMin = 10;
export const approvePlatformElevationResponseReasonMax = 1000;



export const approvePlatformElevationResponse = zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "reason": zod.string().min(approvePlatformElevationResponseReasonMin).max(approvePlatformElevationResponseReasonMax),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "userName": zod.string().nullish(),
  "tenantName": zod.string().nullish(),
  "entityName": zod.string().nullish()
})


/**
 * Requires tenant.roles.assign.
 * @summary listTenantElevations
 */
export const listTenantElevationsQueryLimitDefault = 25;
export const listTenantElevationsQueryLimitMax = 100;

export const listTenantElevationsQueryOffsetDefault = 0;
export const listTenantElevationsQueryOffsetMin = 0;



export const listTenantElevationsQueryParams = zod.object({
  "status": zod.enum(['pending', 'active', 'expired', 'revoked']).optional(),
  "limit": zod.int().min(1).max(listTenantElevationsQueryLimitMax).default(listTenantElevationsQueryLimitDefault),
  "offset": zod.int().min(listTenantElevationsQueryOffsetMin).default(listTenantElevationsQueryOffsetDefault)
})

export const listTenantElevationsResponseItemsItemReasonMin = 10;
export const listTenantElevationsResponseItemsItemReasonMax = 1000;



export const listTenantElevationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleDefinitionId": zod.uuid(),
  "roleName": zod.string(),
  "status": zod.string(),
  "reason": zod.string().min(listTenantElevationsResponseItemsItemReasonMin).max(listTenantElevationsResponseItemsItemReasonMax),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "userName": zod.string().nullish(),
  "tenantName": zod.string().nullish(),
  "entityName": zod.string().nullish()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "activeTotal": zod.int().optional()
})


/**
 * Requires tenant.roles.assign.
 * @summary revokeTenantElevation
 */
export const revokeTenantElevationParams = zod.object({
  "id": zod.uuid()
})

export const revokeTenantElevationBodyReasonMin = 10;
export const revokeTenantElevationBodyReasonMax = 1000;



export const revokeTenantElevationBody = zod.object({
  "reason": zod.string().min(revokeTenantElevationBodyReasonMin).max(revokeTenantElevationBodyReasonMax)
})

export const revokeTenantElevationResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires platform.support.access.
 * @summary listPlatformSupportSessions
 */
export const listPlatformSupportSessionsQueryLimitDefault = 25;
export const listPlatformSupportSessionsQueryLimitMax = 100;

export const listPlatformSupportSessionsQueryOffsetDefault = 0;
export const listPlatformSupportSessionsQueryOffsetMin = 0;



export const listPlatformSupportSessionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPlatformSupportSessionsQueryLimitMax).default(listPlatformSupportSessionsQueryLimitDefault),
  "offset": zod.int().min(listPlatformSupportSessionsQueryOffsetMin).default(listPlatformSupportSessionsQueryOffsetDefault),
  "status": zod.enum(['active', 'expired', 'revoked']).optional(),
  "tenantId": zod.uuid().optional()
})

export const listPlatformSupportSessionsResponseItemsItemReasonMin = 10;
export const listPlatformSupportSessionsResponseItemsItemReasonMax = 1000;



export const listPlatformSupportSessionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "permissionKeys": zod.array(zod.string()),
  "reason": zod.string().min(listPlatformSupportSessionsResponseItemsItemReasonMin).max(listPlatformSupportSessionsResponseItemsItemReasonMax),
  "status": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "userName": zod.string().nullish(),
  "tenantName": zod.string().nullish(),
  "entityName": zod.string().nullish()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "activeTotal": zod.int().optional()
})


/**
 * Requires platform.support.access.
 * @summary startPlatformSupportSession
 */
export const startPlatformSupportSessionBodyPermissionKeysMax = 15;

export const startPlatformSupportSessionBodyReasonMin = 10;
export const startPlatformSupportSessionBodyReasonMax = 1000;

export const startPlatformSupportSessionBodyDurationMinutesDefault = 60;
export const startPlatformSupportSessionBodyDurationMinutesMax = 480;



export const startPlatformSupportSessionBody = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullish(),
  "roleDefinitionId": zod.uuid().optional(),
  "permissionKeys": zod.array(zod.string()).min(1).max(startPlatformSupportSessionBodyPermissionKeysMax).optional(),
  "reason": zod.string().min(startPlatformSupportSessionBodyReasonMin).max(startPlatformSupportSessionBodyReasonMax),
  "durationMinutes": zod.int().min(1).max(startPlatformSupportSessionBodyDurationMinutesMax).default(startPlatformSupportSessionBodyDurationMinutesDefault)
})

export const startPlatformSupportSessionResponseReasonMin = 10;
export const startPlatformSupportSessionResponseReasonMax = 1000;



export const startPlatformSupportSessionResponse = zod.object({
  "id": zod.uuid(),
  "appUserId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "permissionKeys": zod.array(zod.string()),
  "reason": zod.string().min(startPlatformSupportSessionResponseReasonMin).max(startPlatformSupportSessionResponseReasonMax),
  "status": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "userName": zod.string().nullish(),
  "tenantName": zod.string().nullish(),
  "entityName": zod.string().nullish()
})


/**
 * Requires platform.support.access.
 * @summary endPlatformSupportSession
 */
export const endPlatformSupportSessionParams = zod.object({
  "id": zod.uuid()
})

export const endPlatformSupportSessionBodyReasonMin = 10;
export const endPlatformSupportSessionBodyReasonMax = 1000;



export const endPlatformSupportSessionBody = zod.object({
  "reason": zod.string().min(endPlatformSupportSessionBodyReasonMin).max(endPlatformSupportSessionBodyReasonMax)
})

export const endPlatformSupportSessionResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Read tenant administration profile independently of entity access
 */
export const getTenantAdministrationResponse = zod.object({
  "tenant": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "vanityAlias": zod.string().optional(),
  "status": zod.enum(['active', 'suspended', 'archived', 'transferring'])
}),
  "memberCount": zod.int(),
  "entityCount": zod.int()
})


/**
 * List tenant business functions, assignments, journey stages, AI action types, and a page of active staff. Requires tenant.members.manage.
 */
export const listAdminBusinessFunctionsQueryStaffSearchMax = 120;

export const listAdminBusinessFunctionsQueryStaffLimitDefault = 25;
export const listAdminBusinessFunctionsQueryStaffLimitMax = 100;

export const listAdminBusinessFunctionsQueryStaffOffsetDefault = 0;
export const listAdminBusinessFunctionsQueryStaffOffsetMin = 0;



export const listAdminBusinessFunctionsQueryParams = zod.object({
  "staffSearch": zod.string().max(listAdminBusinessFunctionsQueryStaffSearchMax).optional(),
  "staffLimit": zod.int().min(1).max(listAdminBusinessFunctionsQueryStaffLimitMax).default(listAdminBusinessFunctionsQueryStaffLimitDefault),
  "staffOffset": zod.int().min(listAdminBusinessFunctionsQueryStaffOffsetMin).default(listAdminBusinessFunctionsQueryStaffOffsetDefault)
})

export const listAdminBusinessFunctionsResponseFunctionsItemColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const listAdminBusinessFunctionsResponseFunctionsItemSortOrderMin = 0;

export const listAdminBusinessFunctionsResponseStaffTotalMin = 0;


export const listAdminBusinessFunctionsResponseStaffOffsetMin = 0;



export const listAdminBusinessFunctionsResponse = zod.object({
  "functions": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "label": zod.string(),
  "colour": zod.string().regex(listAdminBusinessFunctionsResponseFunctionsItemColourRegExp),
  "sortOrder": zod.int().min(listAdminBusinessFunctionsResponseFunctionsItemSortOrderMin),
  "isDefault": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "assignments": zod.array(zod.object({
  "id": zod.uuid(),
  "functionId": zod.uuid(),
  "kind": zod.enum(['stage', 'action_type', 'staff']),
  "journeyKey": zod.string().nullable(),
  "ref": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "journeys": zod.array(zod.object({
  "key": zod.string(),
  "label": zod.string(),
  "stages": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "order": zod.int()
}))
})),
  "actionTypes": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string()
})),
  "staff": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string().nullable()
})),
  "total": zod.int().min(listAdminBusinessFunctionsResponseStaffTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listAdminBusinessFunctionsResponseStaffOffsetMin)
})
})


/**
 * Create a tenant business function. Requires tenant.members.manage.
 */
export const createAdminBusinessFunctionBodyLabelMin = 2;
export const createAdminBusinessFunctionBodyLabelMax = 80;

export const createAdminBusinessFunctionBodyColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const createAdminBusinessFunctionBodyReasonMin = 10;
export const createAdminBusinessFunctionBodyReasonMax = 1000;



export const createAdminBusinessFunctionBody = zod.object({
  "label": zod.string().min(createAdminBusinessFunctionBodyLabelMin).max(createAdminBusinessFunctionBodyLabelMax),
  "colour": zod.string().regex(createAdminBusinessFunctionBodyColourRegExp),
  "reason": zod.string().min(createAdminBusinessFunctionBodyReasonMin).max(createAdminBusinessFunctionBodyReasonMax)
})

export const createAdminBusinessFunctionResponseColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const createAdminBusinessFunctionResponseSortOrderMin = 0;



export const createAdminBusinessFunctionResponse = zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "label": zod.string(),
  "colour": zod.string().regex(createAdminBusinessFunctionResponseColourRegExp),
  "sortOrder": zod.int().min(createAdminBusinessFunctionResponseSortOrderMin),
  "isDefault": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Replace the tenant business-function order. Requires tenant.members.manage.
 */
export const reorderAdminBusinessFunctionsBodyIdsMax = 100;

export const reorderAdminBusinessFunctionsBodyReasonMin = 10;
export const reorderAdminBusinessFunctionsBodyReasonMax = 1000;



export const reorderAdminBusinessFunctionsBody = zod.object({
  "ids": zod.array(zod.uuid()).min(1).max(reorderAdminBusinessFunctionsBodyIdsMax),
  "reason": zod.string().min(reorderAdminBusinessFunctionsBodyReasonMin).max(reorderAdminBusinessFunctionsBodyReasonMax)
})

export const reorderAdminBusinessFunctionsResponseColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const reorderAdminBusinessFunctionsResponseSortOrderMin = 0;



export const reorderAdminBusinessFunctionsResponseItem = zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "label": zod.string(),
  "colour": zod.string().regex(reorderAdminBusinessFunctionsResponseColourRegExp),
  "sortOrder": zod.int().min(reorderAdminBusinessFunctionsResponseSortOrderMin),
  "isDefault": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
export const reorderAdminBusinessFunctionsResponse = zod.array(reorderAdminBusinessFunctionsResponseItem)


/**
 * Rename or recolour a tenant business function. Requires tenant.members.manage.
 */
export const updateAdminBusinessFunctionParams = zod.object({
  "id": zod.uuid()
})

export const updateAdminBusinessFunctionBodyLabelMin = 2;
export const updateAdminBusinessFunctionBodyLabelMax = 80;

export const updateAdminBusinessFunctionBodyColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateAdminBusinessFunctionBodyReasonMin = 10;
export const updateAdminBusinessFunctionBodyReasonMax = 1000;



export const updateAdminBusinessFunctionBody = zod.object({
  "label": zod.string().min(updateAdminBusinessFunctionBodyLabelMin).max(updateAdminBusinessFunctionBodyLabelMax).optional(),
  "colour": zod.string().regex(updateAdminBusinessFunctionBodyColourRegExp).optional(),
  "reason": zod.string().min(updateAdminBusinessFunctionBodyReasonMin).max(updateAdminBusinessFunctionBodyReasonMax)
})

export const updateAdminBusinessFunctionResponseColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const updateAdminBusinessFunctionResponseSortOrderMin = 0;



export const updateAdminBusinessFunctionResponse = zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "label": zod.string(),
  "colour": zod.string().regex(updateAdminBusinessFunctionResponseColourRegExp),
  "sortOrder": zod.int().min(updateAdminBusinessFunctionResponseSortOrderMin),
  "isDefault": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Delete a tenant business function after optionally reassigning its mappings. Requires tenant.members.manage.
 */
export const deleteAdminBusinessFunctionParams = zod.object({
  "id": zod.uuid()
})

export const deleteAdminBusinessFunctionBodyReasonMin = 10;
export const deleteAdminBusinessFunctionBodyReasonMax = 1000;



export const deleteAdminBusinessFunctionBody = zod.object({
  "reassignToId": zod.uuid().nullish(),
  "reason": zod.string().min(deleteAdminBusinessFunctionBodyReasonMin).max(deleteAdminBusinessFunctionBodyReasonMax)
})

export const deleteAdminBusinessFunctionResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Replace assignments owned by one business function, moving matching references from other functions atomically. Requires tenant.members.manage.
 */
export const replaceAdminBusinessFunctionAssignmentsParams = zod.object({
  "id": zod.uuid()
})

export const replaceAdminBusinessFunctionAssignmentsBodyAssignmentsItemRefMax = 200;

export const replaceAdminBusinessFunctionAssignmentsBodyAssignmentsMax = 1000;

export const replaceAdminBusinessFunctionAssignmentsBodyReasonMin = 10;
export const replaceAdminBusinessFunctionAssignmentsBodyReasonMax = 1000;



export const replaceAdminBusinessFunctionAssignmentsBody = zod.object({
  "assignments": zod.array(zod.object({
  "kind": zod.enum(['stage', 'action_type', 'staff']),
  "journeyKey": zod.string().nullish(),
  "ref": zod.string().min(1).max(replaceAdminBusinessFunctionAssignmentsBodyAssignmentsItemRefMax)
})).max(replaceAdminBusinessFunctionAssignmentsBodyAssignmentsMax),
  "reason": zod.string().min(replaceAdminBusinessFunctionAssignmentsBodyReasonMin).max(replaceAdminBusinessFunctionAssignmentsBodyReasonMax)
})

export const replaceAdminBusinessFunctionAssignmentsResponseItem = zod.object({
  "id": zod.uuid(),
  "functionId": zod.uuid(),
  "kind": zod.enum(['stage', 'action_type', 'staff']),
  "journeyKey": zod.string().nullable(),
  "ref": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
export const replaceAdminBusinessFunctionAssignmentsResponse = zod.array(replaceAdminBusinessFunctionAssignmentsResponseItem)


/**
 * Returns the permission catalogue available to the signed-in administrator.
 */
export const getPermissionCatalogueResponseItem = zod.object({
  "area": zod.enum(['Platform', 'Tenant', 'Entity']),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "key": zod.string(),
  "label": zod.string(),
  "description": zod.string()
})
export const getPermissionCatalogueResponse = zod.array(getPermissionCatalogueResponseItem)


/**
 * Requires tenant.roles.manage, tenant.roles.assign or tenant.groups.manage.
 */
export const listTenantRolesQueryLimitDefault = 25;
export const listTenantRolesQueryLimitMax = 100;

export const listTenantRolesQueryOffsetDefault = 0;
export const listTenantRolesQueryOffsetMin = 0;



export const listTenantRolesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantRolesQueryLimitMax).default(listTenantRolesQueryLimitDefault),
  "offset": zod.int().min(listTenantRolesQueryOffsetMin).default(listTenantRolesQueryOffsetDefault)
})

export const listTenantRolesResponseItemsItemAssignmentCountMin = 0;

export const listTenantRolesResponseTotalMin = 0;


export const listTenantRolesResponseOffsetMin = 0;



export const listTenantRolesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "assignmentCount": zod.int().min(listTenantRolesResponseItemsItemAssignmentCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenantRolesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listTenantRolesResponseOffsetMin)
})


/**
 * Requires tenant.roles.manage.
 */
export const createTenantRoleBodyKeyRegExp = new RegExp('^[a-z][a-z0-9-]{1,63}$');
export const createTenantRoleBodyNameMin = 2;
export const createTenantRoleBodyNameMax = 120;

export const createTenantRoleBodyDescriptionMin = 2;
export const createTenantRoleBodyDescriptionMax = 500;

export const createTenantRoleBodyPermissionKeysMax = 50;

export const createTenantRoleBodyReasonMin = 10;
export const createTenantRoleBodyReasonMax = 1000;



export const createTenantRoleBody = zod.object({
  "key": zod.string().regex(createTenantRoleBodyKeyRegExp),
  "name": zod.string().min(createTenantRoleBodyNameMin).max(createTenantRoleBodyNameMax),
  "description": zod.string().min(createTenantRoleBodyDescriptionMin).max(createTenantRoleBodyDescriptionMax),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "permissionKeys": zod.array(zod.string()).min(1).max(createTenantRoleBodyPermissionKeysMax),
  "reason": zod.string().min(createTenantRoleBodyReasonMin).max(createTenantRoleBodyReasonMax)
})

export const createTenantRoleResponseAssignmentCountMin = 0;



export const createTenantRoleResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "assignmentCount": zod.int().min(createTenantRoleResponseAssignmentCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.roles.manage.
 */
export const updateTenantRoleParams = zod.object({
  "id": zod.uuid()
})

export const updateTenantRoleBodyKeyRegExp = new RegExp('^[a-z][a-z0-9-]{1,63}$');
export const updateTenantRoleBodyNameMin = 2;
export const updateTenantRoleBodyNameMax = 120;

export const updateTenantRoleBodyDescriptionMin = 2;
export const updateTenantRoleBodyDescriptionMax = 500;

export const updateTenantRoleBodyPermissionKeysMax = 50;

export const updateTenantRoleBodyReasonMin = 10;
export const updateTenantRoleBodyReasonMax = 1000;



export const updateTenantRoleBody = zod.object({
  "key": zod.string().regex(updateTenantRoleBodyKeyRegExp),
  "name": zod.string().min(updateTenantRoleBodyNameMin).max(updateTenantRoleBodyNameMax),
  "description": zod.string().min(updateTenantRoleBodyDescriptionMin).max(updateTenantRoleBodyDescriptionMax),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "permissionKeys": zod.array(zod.string()).min(1).max(updateTenantRoleBodyPermissionKeysMax),
  "reason": zod.string().min(updateTenantRoleBodyReasonMin).max(updateTenantRoleBodyReasonMax)
})

export const updateTenantRoleResponseAssignmentCountMin = 0;



export const updateTenantRoleResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "isSystem": zod.boolean(),
  "permissions": zod.array(zod.string()),
  "assignmentCount": zod.int().min(updateTenantRoleResponseAssignmentCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.roles.manage.
 */
export const deleteTenantRoleParams = zod.object({
  "id": zod.uuid()
})

export const deleteTenantRoleBodyReasonMin = 10;
export const deleteTenantRoleBodyReasonMax = 1000;



export const deleteTenantRoleBody = zod.object({
  "reason": zod.string().min(deleteTenantRoleBodyReasonMin).max(deleteTenantRoleBodyReasonMax)
})

export const deleteTenantRoleResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires tenant.groups.manage.
 */
export const listTenantGroupsQueryLimitDefault = 25;
export const listTenantGroupsQueryLimitMax = 100;

export const listTenantGroupsQueryOffsetDefault = 0;
export const listTenantGroupsQueryOffsetMin = 0;



export const listTenantGroupsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantGroupsQueryLimitMax).default(listTenantGroupsQueryLimitDefault),
  "offset": zod.int().min(listTenantGroupsQueryOffsetMin).default(listTenantGroupsQueryOffsetDefault)
})

export const listTenantGroupsResponseTotalMin = 0;


export const listTenantGroupsResponseOffsetMin = 0;



export const listTenantGroupsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "scope": zod.enum(['platform', 'tenant']),
  "name": zod.string(),
  "description": zod.string(),
  "members": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string().nullable()
})),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})),
  "entraBindings": zod.array(zod.object({
  "id": zod.uuid(),
  "objectId": zod.uuid(),
  "note": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenantGroupsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listTenantGroupsResponseOffsetMin),
  "entraGroupsClaimActive": zod.boolean(),
  "entraGroupsSeenAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires tenant.groups.manage.
 */
export const createTenantGroupBodyNameMin = 2;
export const createTenantGroupBodyNameMax = 120;

export const createTenantGroupBodyDescriptionMax = 500;

export const createTenantGroupBodyMemberIdsMax = 100;

export const createTenantGroupBodyRoleIdsMax = 50;

export const createTenantGroupBodyEntraBindingsItemNoteMax = 250;

export const createTenantGroupBodyEntraBindingsMax = 20;

export const createTenantGroupBodyReasonMin = 10;
export const createTenantGroupBodyReasonMax = 1000;



export const createTenantGroupBody = zod.object({
  "name": zod.string().min(createTenantGroupBodyNameMin).max(createTenantGroupBodyNameMax),
  "description": zod.string().max(createTenantGroupBodyDescriptionMax),
  "memberIds": zod.array(zod.uuid()).max(createTenantGroupBodyMemberIdsMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(createTenantGroupBodyRoleIdsMax),
  "entraBindings": zod.array(zod.object({
  "objectId": zod.uuid(),
  "note": zod.string().max(createTenantGroupBodyEntraBindingsItemNoteMax)
})).max(createTenantGroupBodyEntraBindingsMax),
  "reason": zod.string().min(createTenantGroupBodyReasonMin).max(createTenantGroupBodyReasonMax)
})

export const createTenantGroupResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "scope": zod.enum(['platform', 'tenant']),
  "name": zod.string(),
  "description": zod.string(),
  "members": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string().nullable()
})),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})),
  "entraBindings": zod.array(zod.object({
  "id": zod.uuid(),
  "objectId": zod.uuid(),
  "note": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.groups.manage.
 */
export const updateTenantGroupParams = zod.object({
  "id": zod.uuid()
})

export const updateTenantGroupBodyNameMin = 2;
export const updateTenantGroupBodyNameMax = 120;

export const updateTenantGroupBodyDescriptionMax = 500;

export const updateTenantGroupBodyMemberIdsMax = 100;

export const updateTenantGroupBodyRoleIdsMax = 50;

export const updateTenantGroupBodyEntraBindingsItemNoteMax = 250;

export const updateTenantGroupBodyEntraBindingsMax = 20;

export const updateTenantGroupBodyReasonMin = 10;
export const updateTenantGroupBodyReasonMax = 1000;



export const updateTenantGroupBody = zod.object({
  "name": zod.string().min(updateTenantGroupBodyNameMin).max(updateTenantGroupBodyNameMax),
  "description": zod.string().max(updateTenantGroupBodyDescriptionMax),
  "memberIds": zod.array(zod.uuid()).max(updateTenantGroupBodyMemberIdsMax),
  "roleIds": zod.array(zod.uuid()).min(1).max(updateTenantGroupBodyRoleIdsMax),
  "entraBindings": zod.array(zod.object({
  "objectId": zod.uuid(),
  "note": zod.string().max(updateTenantGroupBodyEntraBindingsItemNoteMax)
})).max(updateTenantGroupBodyEntraBindingsMax),
  "reason": zod.string().min(updateTenantGroupBodyReasonMin).max(updateTenantGroupBodyReasonMax)
})

export const updateTenantGroupResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "scope": zod.enum(['platform', 'tenant']),
  "name": zod.string(),
  "description": zod.string(),
  "members": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string().nullable()
})),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})),
  "entraBindings": zod.array(zod.object({
  "id": zod.uuid(),
  "objectId": zod.uuid(),
  "note": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.groups.manage.
 */
export const deleteTenantGroupParams = zod.object({
  "id": zod.uuid()
})

export const deleteTenantGroupBodyReasonMin = 10;
export const deleteTenantGroupBodyReasonMax = 1000;



export const deleteTenantGroupBody = zod.object({
  "reason": zod.string().min(deleteTenantGroupBodyReasonMin).max(deleteTenantGroupBodyReasonMax)
})

export const deleteTenantGroupResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Search active tenant members available for group membership.
 */
export const listTenantGroupMembersQuerySearchMax = 120;

export const listTenantGroupMembersQueryLimitDefault = 25;
export const listTenantGroupMembersQueryLimitMax = 100;

export const listTenantGroupMembersQueryOffsetDefault = 0;
export const listTenantGroupMembersQueryOffsetMin = 0;



export const listTenantGroupMembersQueryParams = zod.object({
  "search": zod.string().max(listTenantGroupMembersQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listTenantGroupMembersQueryLimitMax).default(listTenantGroupMembersQueryLimitDefault),
  "offset": zod.int().min(listTenantGroupMembersQueryOffsetMin).default(listTenantGroupMembersQueryOffsetDefault)
})

export const listTenantGroupMembersResponseTotalMin = 0;


export const listTenantGroupMembersResponseOffsetMin = 0;



export const listTenantGroupMembersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string().nullable()
})),
  "total": zod.int().min(listTenantGroupMembersResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listTenantGroupMembersResponseOffsetMin)
})


/**
 * @summary Read selected entity profile and permission-filtered administration data
 */
export const getEntityAdministrationQueryLimitDefault = 25;
export const getEntityAdministrationQueryLimitMax = 100;

export const getEntityAdministrationQueryOffsetDefault = 0;
export const getEntityAdministrationQueryOffsetMin = 0;



export const getEntityAdministrationQueryParams = zod.object({
  "limit": zod.int().min(1).max(getEntityAdministrationQueryLimitMax).default(getEntityAdministrationQueryLimitDefault),
  "offset": zod.int().min(getEntityAdministrationQueryOffsetMin).default(getEntityAdministrationQueryOffsetDefault)
})

export const getEntityAdministrationResponse = zod.object({
  "tenant": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "vanityAlias": zod.string().optional(),
  "status": zod.enum(['active', 'suspended', 'archived', 'transferring'])
}),
  "entity": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "vanityAlias": zod.string().optional(),
  "status": zod.enum(['active', 'suspended', 'archived', 'transferring'])
}),
  "members": zod.array(zod.object({
  "id": zod.uuid(),
  "membershipId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullable(),
  "legacyRole": zod.enum(['staff', 'admin']).describe('Database-backed application role stored on app_users.'),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['tenant', 'entity']),
  "permissions": zod.array(zod.string()),
  "canonical": zod.boolean()
})),
  "hasEntityAccess": zod.boolean(),
  "membershipStatus": zod.enum(['active', 'suspended', 'revoked']),
  "grantId": zod.uuid().nullish(),
  "grantExpiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "grantedBy": zod.string().nullish(),
  "grantedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastActiveAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "memberTotal": zod.int(),
  "invitations": zod.array(zod.object({
  "id": zod.uuid(),
  "email": zod.string(),
  "status": zod.enum(['pending', 'expired']),
  "roleIds": zod.array(zod.uuid()),
  "roleNames": zod.array(zod.string()),
  "message": zod.string().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "lastSentAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "invitationTotal": zod.int(),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['tenant', 'entity']),
  "permissions": zod.array(zod.string()),
  "canonical": zod.boolean()
})),
  "connectionCount": zod.int().nullable(),
  "publishedPageCount": zod.int().nullable(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary Search active tenant members without access to the selected entity
 */
export const listEntityAccessCandidatesQueryQMax = 200;

export const listEntityAccessCandidatesQueryLimitDefault = 25;
export const listEntityAccessCandidatesQueryLimitMax = 100;

export const listEntityAccessCandidatesQueryOffsetDefault = 0;
export const listEntityAccessCandidatesQueryOffsetMin = 0;



export const listEntityAccessCandidatesQueryParams = zod.object({
  "q": zod.string().max(listEntityAccessCandidatesQueryQMax).optional(),
  "limit": zod.int().min(1).max(listEntityAccessCandidatesQueryLimitMax).default(listEntityAccessCandidatesQueryLimitDefault),
  "offset": zod.int().min(listEntityAccessCandidatesQueryOffsetMin).default(listEntityAccessCandidatesQueryOffsetDefault)
})

export const listEntityAccessCandidatesResponseTotalMin = 0;


export const listEntityAccessCandidatesResponseOffsetMin = 0;



export const listEntityAccessCandidatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullable(),
  "lastActiveAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int().min(listEntityAccessCandidatesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listEntityAccessCandidatesResponseOffsetMin)
})


/**
 * @summary Grant an existing tenant member or invite an email to the selected entity
 */
export const createEntityAccessBodyEmailMax = 320;

export const createEntityAccessBodyRoleIdsMax = 20;

export const createEntityAccessBodyMessageMax = 2000;



export const createEntityAccessBody = zod.object({
  "userId": zod.uuid().optional(),
  "email": zod.email().max(createEntityAccessBodyEmailMax).optional(),
  "roleIds": zod.array(zod.uuid()).min(1).max(createEntityAccessBodyRoleIdsMax),
  "message": zod.string().max(createEntityAccessBodyMessageMax).optional()
})

export const createEntityAccessResponse = zod.object({
  "status": zod.enum(['granted', 'invited', 'merged']),
  "grantId": zod.uuid().nullable(),
  "invitationId": zod.uuid().nullable(),
  "emailStatus": zod.enum(['not_required', 'sent', 'suppressed', 'failed'])
})


/**
 * @summary Replace the entity roles assigned through an access grant
 */
export const updateEntityAccessGrantParams = zod.object({
  "id": zod.uuid()
})

export const updateEntityAccessGrantBodyRoleIdsMax = 20;

export const updateEntityAccessGrantBodyReasonMin = 8;
export const updateEntityAccessGrantBodyReasonMax = 500;



export const updateEntityAccessGrantBody = zod.object({
  "roleIds": zod.array(zod.uuid()).min(1).max(updateEntityAccessGrantBodyRoleIdsMax),
  "reason": zod.string().min(updateEntityAccessGrantBodyReasonMin).max(updateEntityAccessGrantBodyReasonMax)
})

export const updateEntityAccessGrantResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Revoke an entity access grant and its entity roles
 */
export const deleteEntityAccessGrantParams = zod.object({
  "id": zod.uuid()
})

export const deleteEntityAccessGrantBodyReasonMin = 8;
export const deleteEntityAccessGrantBodyReasonMax = 500;



export const deleteEntityAccessGrantBody = zod.object({
  "reason": zod.string().min(deleteEntityAccessGrantBodyReasonMin).max(deleteEntityAccessGrantBodyReasonMax)
})

export const deleteEntityAccessGrantResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Resend a pending invitation containing access to the selected entity
 */
export const resendEntityAccessInvitationParams = zod.object({
  "id": zod.uuid()
})

export const resendEntityAccessInvitationBodyReasonMin = 8;
export const resendEntityAccessInvitationBodyReasonMax = 500;



export const resendEntityAccessInvitationBody = zod.object({
  "reason": zod.string().min(resendEntityAccessInvitationBodyReasonMin).max(resendEntityAccessInvitationBodyReasonMax)
})

export const resendEntityAccessInvitationResponse = zod.object({
  "ok": zod.boolean(),
  "emailStatus": zod.enum(['sent', 'suppressed', 'failed'])
})


/**
 * @summary Cancel access to the selected entity from a pending invitation
 */
export const cancelEntityAccessInvitationParams = zod.object({
  "id": zod.uuid()
})

export const cancelEntityAccessInvitationBodyReasonMin = 8;
export const cancelEntityAccessInvitationBodyReasonMax = 500;



export const cancelEntityAccessInvitationBody = zod.object({
  "reason": zod.string().min(cancelEntityAccessInvitationBodyReasonMin).max(cancelEntityAccessInvitationBodyReasonMax)
})

export const cancelEntityAccessInvitationResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires tenant.roles.manage.
 * @summary listTenantEntities
 */
export const listTenantEntitiesQueryLimitDefault = 25;
export const listTenantEntitiesQueryLimitMax = 100;

export const listTenantEntitiesQueryOffsetDefault = 0;
export const listTenantEntitiesQueryOffsetMin = 0;



export const listTenantEntitiesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantEntitiesQueryLimitMax).default(listTenantEntitiesQueryLimitDefault),
  "offset": zod.int().min(listTenantEntitiesQueryOffsetMin).default(listTenantEntitiesQueryOffsetDefault)
})

export const listTenantEntitiesResponseItemsItemNameMin = 2;
export const listTenantEntitiesResponseItemsItemNameMax = 120;



export const listTenantEntitiesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "name": zod.string().min(listTenantEntitiesResponseItemsItemNameMin).max(listTenantEntitiesResponseItemsItemNameMax),
  "slug": zod.string(),
  "status": zod.string(),
  "memberCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires entity.manage and tenant owner.
 * @summary createTenantEntity
 */
export const createTenantEntityBodyNameMin = 2;
export const createTenantEntityBodyNameMax = 120;

export const createTenantEntityBodySlugMin = 2;
export const createTenantEntityBodySlugMax = 80;


export const createTenantEntityBodySlugRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
export const createTenantEntityBodyReasonMax = 1000;



export const createTenantEntityBody = zod.object({
  "name": zod.string().min(createTenantEntityBodyNameMin).max(createTenantEntityBodyNameMax),
  "slug": zod.string().min(createTenantEntityBodySlugMin).max(createTenantEntityBodySlugMax).regex(createTenantEntityBodySlugRegExp),
  "reason": zod.string().max(createTenantEntityBodyReasonMax).optional()
})

export const createTenantEntityResponseNameMin = 2;
export const createTenantEntityResponseNameMax = 120;



export const createTenantEntityResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "name": zod.string().min(createTenantEntityResponseNameMin).max(createTenantEntityResponseNameMax),
  "slug": zod.string(),
  "status": zod.string(),
  "memberCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires entity.manage and tenant owner.
 * @summary updateTenantEntity
 */
export const updateTenantEntityParams = zod.object({
  "id": zod.uuid()
})

export const updateTenantEntityBodyNameMin = 2;
export const updateTenantEntityBodyNameMax = 120;

export const updateTenantEntityBodyReasonMax = 1000;



export const updateTenantEntityBody = zod.object({
  "name": zod.string().min(updateTenantEntityBodyNameMin).max(updateTenantEntityBodyNameMax).optional(),
  "status": zod.enum(['active', 'suspended']).optional(),
  "reason": zod.string().max(updateTenantEntityBodyReasonMax).optional()
})

export const updateTenantEntityResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires entity.transfer in both tenants.
 * @summary previewTenantEntityTransfer
 */
export const previewTenantEntityTransferParams = zod.object({
  "id": zod.uuid()
})

export const previewTenantEntityTransferBody = zod.object({
  "destinationTenantId": zod.uuid()
})

export const previewTenantEntityTransferResponse = zod.object({
  "previewDigest": zod.string(),
  "entityId": zod.uuid(),
  "destinationTenantId": zod.uuid(),
  "recordCount": zod.int(),
  "grantCount": zod.int()
})


/**
 * Requires entity.transfer in both tenants.
 * @summary transferTenantEntity
 */
export const transferTenantEntityParams = zod.object({
  "id": zod.uuid()
})

export const transferTenantEntityBodyReasonMax = 1000;



export const transferTenantEntityBody = zod.object({
  "destinationTenantId": zod.uuid(),
  "previewDigest": zod.string(),
  "reason": zod.string().max(transferTenantEntityBodyReasonMax).optional()
})

export const transferTenantEntityResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires tenant.settings.read.
 * @summary listTenantSettings
 */
export const listTenantSettingsQueryLimitDefault = 25;
export const listTenantSettingsQueryLimitMax = 100;

export const listTenantSettingsQueryOffsetDefault = 0;
export const listTenantSettingsQueryOffsetMin = 0;



export const listTenantSettingsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantSettingsQueryLimitMax).default(listTenantSettingsQueryLimitDefault),
  "offset": zod.int().min(listTenantSettingsQueryOffsetMin).default(listTenantSettingsQueryOffsetDefault)
})

export const listTenantSettingsResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string(),
  "value": zod.unknown(),
  "revision": zod.int(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires tenant.settings.manage.
 * @summary writeTenantSetting
 */
export const writeTenantSettingBodyKeyMax = 100;

export const writeTenantSettingBodyReasonMin = 10;
export const writeTenantSettingBodyReasonMax = 1000;



export const writeTenantSettingBody = zod.object({
  "key": zod.string().min(1).max(writeTenantSettingBodyKeyMax),
  "value": zod.unknown(),
  "reason": zod.string().min(writeTenantSettingBodyReasonMin).max(writeTenantSettingBodyReasonMax)
})

export const writeTenantSettingResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires tenant.settings.read.
 * @summary listTenantModules
 */
export const listTenantModulesQueryLimitDefault = 25;
export const listTenantModulesQueryLimitMax = 100;

export const listTenantModulesQueryOffsetDefault = 0;
export const listTenantModulesQueryOffsetMin = 0;



export const listTenantModulesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantModulesQueryLimitMax).default(listTenantModulesQueryLimitDefault),
  "offset": zod.int().min(listTenantModulesQueryOffsetMin).default(listTenantModulesQueryOffsetDefault)
})

export const listTenantModulesResponse = zod.object({
  "items": zod.array(zod.object({
  "configuration": zod.record(zod.string(), zod.unknown()).nullish(),
  "key": zod.string(),
  "enabled": zod.boolean(),
  "revision": zod.int(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires tenant.settings.manage.
 * @summary writeTenantModule
 */
export const writeTenantModuleBodyKeyMax = 100;

export const writeTenantModuleBodyReasonMin = 10;
export const writeTenantModuleBodyReasonMax = 1000;



export const writeTenantModuleBody = zod.object({
  "configuration": zod.record(zod.string(), zod.unknown()).nullish(),
  "key": zod.string().min(1).max(writeTenantModuleBodyKeyMax),
  "enabled": zod.boolean(),
  "reason": zod.string().min(writeTenantModuleBodyReasonMin).max(writeTenantModuleBodyReasonMax)
})

export const writeTenantModuleResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires tenant.tokens.read or tenant.tokens.manage.
 * @summary Get the selected tenant usage token balance
 */
export const getTenantUsageTokenSummaryResponseBalanceMin = 0;

export const getTenantUsageTokenSummaryResponseAllocatedMin = 0;

export const getTenantUsageTokenSummaryResponseEntityAllocationCountMin = 0;



export const getTenantUsageTokenSummaryResponse = zod.object({
  "tenantId": zod.uuid(),
  "balance": zod.int().min(getTenantUsageTokenSummaryResponseBalanceMin),
  "allocated": zod.int().min(getTenantUsageTokenSummaryResponseAllocatedMin),
  "entityAllocationCount": zod.int().min(getTenantUsageTokenSummaryResponseEntityAllocationCountMin)
})


/**
 * Requires tenant.tokens.read or tenant.tokens.manage.
 * @summary List per-entity usage token allocations
 */
export const listTenantUsageTokenAllocationsQueryLimitDefault = 25;
export const listTenantUsageTokenAllocationsQueryLimitMax = 100;

export const listTenantUsageTokenAllocationsQueryOffsetDefault = 0;
export const listTenantUsageTokenAllocationsQueryOffsetMin = 0;



export const listTenantUsageTokenAllocationsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantUsageTokenAllocationsQueryLimitMax).default(listTenantUsageTokenAllocationsQueryLimitDefault),
  "offset": zod.int().min(listTenantUsageTokenAllocationsQueryOffsetMin).default(listTenantUsageTokenAllocationsQueryOffsetDefault)
})

export const listTenantUsageTokenAllocationsResponseItemsItemAmountMin = 0;

export const listTenantUsageTokenAllocationsResponseItemsItemSpentMin = 0;

export const listTenantUsageTokenAllocationsResponseItemsItemRemainingMin = 0;

export const listTenantUsageTokenAllocationsResponseTotalMin = 0;


export const listTenantUsageTokenAllocationsResponseOffsetMin = 0;



export const listTenantUsageTokenAllocationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid().nullable(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "amount": zod.int().min(listTenantUsageTokenAllocationsResponseItemsItemAmountMin),
  "spent": zod.int().min(listTenantUsageTokenAllocationsResponseItemsItemSpentMin),
  "remaining": zod.int().min(listTenantUsageTokenAllocationsResponseItemsItemRemainingMin),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int().min(listTenantUsageTokenAllocationsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listTenantUsageTokenAllocationsResponseOffsetMin)
})


/**
 * Requires tenant.tokens.manage.
 * @summary Set an entity usage token allocation
 */
export const setTenantUsageTokenAllocationParams = zod.object({
  "entityId": zod.uuid()
})

export const setTenantUsageTokenAllocationBodyAmountMin = 0;
export const setTenantUsageTokenAllocationBodyAmountMax = 1000000000;

export const setTenantUsageTokenAllocationBodyReasonMin = 10;
export const setTenantUsageTokenAllocationBodyReasonMax = 1000;



export const setTenantUsageTokenAllocationBody = zod.object({
  "amount": zod.int().min(setTenantUsageTokenAllocationBodyAmountMin).max(setTenantUsageTokenAllocationBodyAmountMax),
  "reason": zod.string().min(setTenantUsageTokenAllocationBodyReasonMin).max(setTenantUsageTokenAllocationBodyReasonMax)
})

export const setTenantUsageTokenAllocationResponseAmountMin = 0;



export const setTenantUsageTokenAllocationResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "amount": zod.int().min(setTenantUsageTokenAllocationResponseAmountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.tokens.read or tenant.tokens.manage.
 * @summary List immutable usage token ledger entries
 */
export const listTenantUsageTokenLedgerQueryLimitDefault = 25;
export const listTenantUsageTokenLedgerQueryLimitMax = 100;

export const listTenantUsageTokenLedgerQueryOffsetDefault = 0;
export const listTenantUsageTokenLedgerQueryOffsetMin = 0;

export const listTenantUsageTokenLedgerQueryActionKeyMax = 120;



export const listTenantUsageTokenLedgerQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantUsageTokenLedgerQueryLimitMax).default(listTenantUsageTokenLedgerQueryLimitDefault),
  "offset": zod.int().min(listTenantUsageTokenLedgerQueryOffsetMin).default(listTenantUsageTokenLedgerQueryOffsetDefault),
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "entityId": zod.uuid().optional(),
  "actionKey": zod.string().max(listTenantUsageTokenLedgerQueryActionKeyMax).optional()
})

export const listTenantUsageTokenLedgerResponseItemsItemBalanceAfterMin = 0;

export const listTenantUsageTokenLedgerResponseTotalMin = 0;


export const listTenantUsageTokenLedgerResponseOffsetMin = 0;



export const listTenantUsageTokenLedgerResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "entityName": zod.string().nullable(),
  "userId": zod.uuid().nullable(),
  "userName": zod.string().nullable(),
  "actionKey": zod.string(),
  "delta": zod.int(),
  "balanceAfter": zod.int().min(listTenantUsageTokenLedgerResponseItemsItemBalanceAfterMin),
  "reference": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenantUsageTokenLedgerResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listTenantUsageTokenLedgerResponseOffsetMin)
})


/**
 * Requires tenant.tokens.read or tenant.tokens.manage.
 * @summary Aggregate token consumption by day and action
 */
export const getTenantUsageTokenReportQueryActionKeyMax = 120;



export const getTenantUsageTokenReportQueryParams = zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "entityId": zod.uuid().optional(),
  "actionKey": zod.string().max(getTenantUsageTokenReportQueryActionKeyMax).optional()
})

export const getTenantUsageTokenReportResponseItemsItemTokensMin = 0;

export const getTenantUsageTokenReportResponseItemsItemTransactionCountMin = 0;



export const getTenantUsageTokenReportResponse = zod.object({
  "items": zod.array(zod.object({
  "date": zod.iso.date(),
  "actionKey": zod.string(),
  "tokens": zod.int().min(getTenantUsageTokenReportResponseItemsItemTokensMin),
  "transactionCount": zod.int().min(getTenantUsageTokenReportResponseItemsItemTransactionCountMin)
}))
})


/**
 * Requires tenant.tokens.read or tenant.tokens.manage. Exports up to 10,000 filtered rows.
 * @summary Export the filtered usage token ledger as CSV
 */
export const exportTenantUsageTokenLedgerQueryActionKeyMax = 120;



export const exportTenantUsageTokenLedgerQueryParams = zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "entityId": zod.uuid().optional(),
  "actionKey": zod.string().max(exportTenantUsageTokenLedgerQueryActionKeyMax).optional()
})

export const exportTenantUsageTokenLedgerResponse = zod.object({
  "filename": zod.string(),
  "csv": zod.string(),
  "truncated": zod.boolean()
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Exports use durable leased jobs, a consistent source snapshot and verified private ZIP downloads. Retry starts a new snapshot; incomplete content blocks completion. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const createEntityPackageExportParams = zod.object({
  "entityId": zod.uuid()
})

export const createEntityPackageExportBodyReasonMax = 2000;



export const createEntityPackageExportBody = zod.object({
  "idempotencyKey": zod.uuid(),
  "reason": zod.string().min(1).max(createEntityPackageExportBodyReasonMax)
})

export const createEntityPackageExportResponseProgressCompletedRecordsMin = 0;

export const createEntityPackageExportResponseProgressTotalRecordsMin = 0;

export const createEntityPackageExportResponseProgressCompletedFilesMin = 0;

export const createEntityPackageExportResponseProgressTotalFilesMin = 0;

export const createEntityPackageExportResponseProgressCompletedBytesMin = 0;

export const createEntityPackageExportResponseProgressTotalBytesMin = 0;

export const createEntityPackageExportResponseProgressAttemptMin = 0;

export const createEntityPackageExportResponsePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const createEntityPackageExportResponseManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const createEntityPackageExportResponseManifestOneTablesItemRecordCountMin = 0;

export const createEntityPackageExportResponseManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const createEntityPackageExportResponseManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const createEntityPackageExportResponseManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const createEntityPackageExportResponseManifestOneFilesItemSizeBytesMin = 0;

export const createEntityPackageExportResponseManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const createEntityPackageExportResponseManifestOneTransformationsItemCountMin = 0;

export const createEntityPackageExportResponseManifestOneTotalsRecordsMin = 0;

export const createEntityPackageExportResponseManifestOneTotalsFilesMin = 0;

export const createEntityPackageExportResponseManifestOneTotalsFileBytesMin = 0;

export const createEntityPackageExportResponseManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const createEntityPackageExportResponseBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const createEntityPackageExportResponseBindingOneMappingRevisionMin = 0;

export const createEntityPackageExportResponseBindingOneDecisionRevisionMin = 0;

export const createEntityPackageExportResponseBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const createEntityPackageExportResponseBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const createEntityPackageExportResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(createEntityPackageExportResponseProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(createEntityPackageExportResponseProgressTotalRecordsMin),
  "completedFiles": zod.int().min(createEntityPackageExportResponseProgressCompletedFilesMin),
  "totalFiles": zod.int().min(createEntityPackageExportResponseProgressTotalFilesMin),
  "completedBytes": zod.int().min(createEntityPackageExportResponseProgressCompletedBytesMin),
  "totalBytes": zod.int().min(createEntityPackageExportResponseProgressTotalBytesMin),
  "attempt": zod.int().min(createEntityPackageExportResponseProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(createEntityPackageExportResponsePackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(createEntityPackageExportResponseManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(createEntityPackageExportResponseManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(createEntityPackageExportResponseManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(createEntityPackageExportResponseManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(createEntityPackageExportResponseManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(createEntityPackageExportResponseManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(createEntityPackageExportResponseManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(createEntityPackageExportResponseManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(createEntityPackageExportResponseManifestOneTotalsRecordsMin),
  "files": zod.int().min(createEntityPackageExportResponseManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(createEntityPackageExportResponseManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(createEntityPackageExportResponseManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(createEntityPackageExportResponseBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(createEntityPackageExportResponseBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(createEntityPackageExportResponseBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(createEntityPackageExportResponseBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(createEntityPackageExportResponseBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Private upload validation and read-only, entity-scoped Add, Merge and Replace planning. Merge uses persisted source lineage only. Exact value-bound review expires after 30 minutes. Multipart uploads require idempotencyKey before file; previews support up to 20,000 records. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const uploadEntityPackageParams = zod.object({
  "entityId": zod.uuid()
})

export const uploadEntityPackageBody = zod.object({
  "file": zod.instanceof(Blob),
  "idempotencyKey": zod.uuid()
})

export const uploadEntityPackageResponseProgressCompletedRecordsMin = 0;

export const uploadEntityPackageResponseProgressTotalRecordsMin = 0;

export const uploadEntityPackageResponseProgressCompletedFilesMin = 0;

export const uploadEntityPackageResponseProgressTotalFilesMin = 0;

export const uploadEntityPackageResponseProgressCompletedBytesMin = 0;

export const uploadEntityPackageResponseProgressTotalBytesMin = 0;

export const uploadEntityPackageResponseProgressAttemptMin = 0;

export const uploadEntityPackageResponsePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadEntityPackageResponseManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const uploadEntityPackageResponseManifestOneTablesItemRecordCountMin = 0;

export const uploadEntityPackageResponseManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadEntityPackageResponseManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const uploadEntityPackageResponseManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const uploadEntityPackageResponseManifestOneFilesItemSizeBytesMin = 0;

export const uploadEntityPackageResponseManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadEntityPackageResponseManifestOneTransformationsItemCountMin = 0;

export const uploadEntityPackageResponseManifestOneTotalsRecordsMin = 0;

export const uploadEntityPackageResponseManifestOneTotalsFilesMin = 0;

export const uploadEntityPackageResponseManifestOneTotalsFileBytesMin = 0;

export const uploadEntityPackageResponseManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadEntityPackageResponseBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const uploadEntityPackageResponseBindingOneMappingRevisionMin = 0;

export const uploadEntityPackageResponseBindingOneDecisionRevisionMin = 0;

export const uploadEntityPackageResponseBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadEntityPackageResponseBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const uploadEntityPackageResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(uploadEntityPackageResponseProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(uploadEntityPackageResponseProgressTotalRecordsMin),
  "completedFiles": zod.int().min(uploadEntityPackageResponseProgressCompletedFilesMin),
  "totalFiles": zod.int().min(uploadEntityPackageResponseProgressTotalFilesMin),
  "completedBytes": zod.int().min(uploadEntityPackageResponseProgressCompletedBytesMin),
  "totalBytes": zod.int().min(uploadEntityPackageResponseProgressTotalBytesMin),
  "attempt": zod.int().min(uploadEntityPackageResponseProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(uploadEntityPackageResponsePackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(uploadEntityPackageResponseManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(uploadEntityPackageResponseManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(uploadEntityPackageResponseManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(uploadEntityPackageResponseManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(uploadEntityPackageResponseManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(uploadEntityPackageResponseManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(uploadEntityPackageResponseManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(uploadEntityPackageResponseManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(uploadEntityPackageResponseManifestOneTotalsRecordsMin),
  "files": zod.int().min(uploadEntityPackageResponseManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(uploadEntityPackageResponseManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(uploadEntityPackageResponseManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(uploadEntityPackageResponseBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(uploadEntityPackageResponseBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(uploadEntityPackageResponseBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(uploadEntityPackageResponseBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(uploadEntityPackageResponseBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Exports use durable leased jobs, a consistent source snapshot and verified private ZIP downloads. Retry starts a new snapshot; incomplete content blocks completion. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const listEntityPackageJobsParams = zod.object({
  "entityId": zod.uuid()
})

export const listEntityPackageJobsQueryLimitDefault = 25;
export const listEntityPackageJobsQueryLimitMax = 100;

export const listEntityPackageJobsQueryOffsetDefault = 0;
export const listEntityPackageJobsQueryOffsetMin = 0;



export const listEntityPackageJobsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEntityPackageJobsQueryLimitMax).default(listEntityPackageJobsQueryLimitDefault),
  "offset": zod.int().min(listEntityPackageJobsQueryOffsetMin).default(listEntityPackageJobsQueryOffsetDefault)
})

export const listEntityPackageJobsResponseItemsItemProgressCompletedRecordsMin = 0;

export const listEntityPackageJobsResponseItemsItemProgressTotalRecordsMin = 0;

export const listEntityPackageJobsResponseItemsItemProgressCompletedFilesMin = 0;

export const listEntityPackageJobsResponseItemsItemProgressTotalFilesMin = 0;

export const listEntityPackageJobsResponseItemsItemProgressCompletedBytesMin = 0;

export const listEntityPackageJobsResponseItemsItemProgressTotalBytesMin = 0;

export const listEntityPackageJobsResponseItemsItemProgressAttemptMin = 0;

export const listEntityPackageJobsResponseItemsItemPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityPackageJobsResponseItemsItemManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const listEntityPackageJobsResponseItemsItemManifestOneTablesItemRecordCountMin = 0;

export const listEntityPackageJobsResponseItemsItemManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityPackageJobsResponseItemsItemManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const listEntityPackageJobsResponseItemsItemManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const listEntityPackageJobsResponseItemsItemManifestOneFilesItemSizeBytesMin = 0;

export const listEntityPackageJobsResponseItemsItemManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityPackageJobsResponseItemsItemManifestOneTransformationsItemCountMin = 0;

export const listEntityPackageJobsResponseItemsItemManifestOneTotalsRecordsMin = 0;

export const listEntityPackageJobsResponseItemsItemManifestOneTotalsFilesMin = 0;

export const listEntityPackageJobsResponseItemsItemManifestOneTotalsFileBytesMin = 0;

export const listEntityPackageJobsResponseItemsItemManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityPackageJobsResponseItemsItemBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const listEntityPackageJobsResponseItemsItemBindingOneMappingRevisionMin = 0;

export const listEntityPackageJobsResponseItemsItemBindingOneDecisionRevisionMin = 0;

export const listEntityPackageJobsResponseItemsItemBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityPackageJobsResponseItemsItemBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityPackageJobsResponseTotalMin = 0;

export const listEntityPackageJobsResponseLimitMin = 0;

export const listEntityPackageJobsResponseOffsetMin = 0;



export const listEntityPackageJobsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(listEntityPackageJobsResponseItemsItemProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(listEntityPackageJobsResponseItemsItemProgressTotalRecordsMin),
  "completedFiles": zod.int().min(listEntityPackageJobsResponseItemsItemProgressCompletedFilesMin),
  "totalFiles": zod.int().min(listEntityPackageJobsResponseItemsItemProgressTotalFilesMin),
  "completedBytes": zod.int().min(listEntityPackageJobsResponseItemsItemProgressCompletedBytesMin),
  "totalBytes": zod.int().min(listEntityPackageJobsResponseItemsItemProgressTotalBytesMin),
  "attempt": zod.int().min(listEntityPackageJobsResponseItemsItemProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(listEntityPackageJobsResponseItemsItemPackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(listEntityPackageJobsResponseItemsItemManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(listEntityPackageJobsResponseItemsItemManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(listEntityPackageJobsResponseItemsItemManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(listEntityPackageJobsResponseItemsItemManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(listEntityPackageJobsResponseItemsItemManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(listEntityPackageJobsResponseItemsItemManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(listEntityPackageJobsResponseItemsItemManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(listEntityPackageJobsResponseItemsItemManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(listEntityPackageJobsResponseItemsItemManifestOneTotalsRecordsMin),
  "files": zod.int().min(listEntityPackageJobsResponseItemsItemManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(listEntityPackageJobsResponseItemsItemManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(listEntityPackageJobsResponseItemsItemManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(listEntityPackageJobsResponseItemsItemBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(listEntityPackageJobsResponseItemsItemBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(listEntityPackageJobsResponseItemsItemBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(listEntityPackageJobsResponseItemsItemBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(listEntityPackageJobsResponseItemsItemBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listEntityPackageJobsResponseTotalMin),
  "limit": zod.int().min(listEntityPackageJobsResponseLimitMin),
  "offset": zod.int().min(listEntityPackageJobsResponseOffsetMin)
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Exports use durable leased jobs, a consistent source snapshot and verified private ZIP downloads. Retry starts a new snapshot; incomplete content blocks completion. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const getEntityPackageJobParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const getEntityPackageJobResponseProgressCompletedRecordsMin = 0;

export const getEntityPackageJobResponseProgressTotalRecordsMin = 0;

export const getEntityPackageJobResponseProgressCompletedFilesMin = 0;

export const getEntityPackageJobResponseProgressTotalFilesMin = 0;

export const getEntityPackageJobResponseProgressCompletedBytesMin = 0;

export const getEntityPackageJobResponseProgressTotalBytesMin = 0;

export const getEntityPackageJobResponseProgressAttemptMin = 0;

export const getEntityPackageJobResponsePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackageJobResponseManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const getEntityPackageJobResponseManifestOneTablesItemRecordCountMin = 0;

export const getEntityPackageJobResponseManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackageJobResponseManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const getEntityPackageJobResponseManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const getEntityPackageJobResponseManifestOneFilesItemSizeBytesMin = 0;

export const getEntityPackageJobResponseManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackageJobResponseManifestOneTransformationsItemCountMin = 0;

export const getEntityPackageJobResponseManifestOneTotalsRecordsMin = 0;

export const getEntityPackageJobResponseManifestOneTotalsFilesMin = 0;

export const getEntityPackageJobResponseManifestOneTotalsFileBytesMin = 0;

export const getEntityPackageJobResponseManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackageJobResponseBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const getEntityPackageJobResponseBindingOneMappingRevisionMin = 0;

export const getEntityPackageJobResponseBindingOneDecisionRevisionMin = 0;

export const getEntityPackageJobResponseBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackageJobResponseBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const getEntityPackageJobResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(getEntityPackageJobResponseProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(getEntityPackageJobResponseProgressTotalRecordsMin),
  "completedFiles": zod.int().min(getEntityPackageJobResponseProgressCompletedFilesMin),
  "totalFiles": zod.int().min(getEntityPackageJobResponseProgressTotalFilesMin),
  "completedBytes": zod.int().min(getEntityPackageJobResponseProgressCompletedBytesMin),
  "totalBytes": zod.int().min(getEntityPackageJobResponseProgressTotalBytesMin),
  "attempt": zod.int().min(getEntityPackageJobResponseProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(getEntityPackageJobResponsePackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(getEntityPackageJobResponseManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(getEntityPackageJobResponseManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(getEntityPackageJobResponseManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(getEntityPackageJobResponseManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(getEntityPackageJobResponseManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(getEntityPackageJobResponseManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(getEntityPackageJobResponseManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(getEntityPackageJobResponseManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(getEntityPackageJobResponseManifestOneTotalsRecordsMin),
  "files": zod.int().min(getEntityPackageJobResponseManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(getEntityPackageJobResponseManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(getEntityPackageJobResponseManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(getEntityPackageJobResponseBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(getEntityPackageJobResponseBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(getEntityPackageJobResponseBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(getEntityPackageJobResponseBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(getEntityPackageJobResponseBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Read-only, authorized destination-scoped prior copy revisions and compiled source-person references for a verified upload. No natural-key identity matching or access changes.
 */
export const getEntityPackageImportOptionsParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const getEntityPackageImportOptionsQueryLimitDefault = 25;
export const getEntityPackageImportOptionsQueryLimitMax = 25;

export const getEntityPackageImportOptionsQueryOffsetDefault = 0;
export const getEntityPackageImportOptionsQueryOffsetMin = 0;



export const getEntityPackageImportOptionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(getEntityPackageImportOptionsQueryLimitMax).default(getEntityPackageImportOptionsQueryLimitDefault),
  "offset": zod.int().min(getEntityPackageImportOptionsQueryOffsetMin).default(getEntityPackageImportOptionsQueryOffsetDefault)
})

export const getEntityPackageImportOptionsResponseCopiesItemMappingRevisionMin = 0;

export const getEntityPackageImportOptionsResponseCopyTotalMin = 0;

export const getEntityPackageImportOptionsResponseUserReferenceTotalMin = 0;


export const getEntityPackageImportOptionsResponseOffsetMin = 0;



export const getEntityPackageImportOptionsResponse = zod.object({
  "copies": zod.array(zod.object({
  "id": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "mappingRevision": zod.int().min(getEntityPackageImportOptionsResponseCopiesItemMappingRevisionMin)
})),
  "copyTotal": zod.int().min(getEntityPackageImportOptionsResponseCopyTotalMin),
  "userReferences": zod.array(zod.object({
  "sourceReference": zod.string(),
  "label": zod.string()
})),
  "userReferenceTotal": zod.int().min(getEntityPackageImportOptionsResponseUserReferenceTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getEntityPackageImportOptionsResponseOffsetMin)
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Private upload validation and read-only, entity-scoped Add, Merge and Replace planning. Merge uses persisted source lineage only. Exact value-bound review expires after 30 minutes. Multipart uploads require idempotencyKey before file; previews support up to 20,000 records. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const preflightEntityPackageParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const preflightEntityPackageBodyExpectedMappingRevisionMin = 0;



export const preflightEntityPackageBody = zod.object({
  "mode": zod.enum(['add', 'merge', 'replace']),
  "copyLineageId": zod.uuid().optional(),
  "userMappings": zod.array(zod.object({
  "sourceReference": zod.string(),
  "destinationAppUserId": zod.uuid()
})),
  "expectedMappingRevision": zod.int().min(preflightEntityPackageBodyExpectedMappingRevisionMin),
  "idempotencyKey": zod.uuid()
})

export const preflightEntityPackageResponseProgressCompletedRecordsMin = 0;

export const preflightEntityPackageResponseProgressTotalRecordsMin = 0;

export const preflightEntityPackageResponseProgressCompletedFilesMin = 0;

export const preflightEntityPackageResponseProgressTotalFilesMin = 0;

export const preflightEntityPackageResponseProgressCompletedBytesMin = 0;

export const preflightEntityPackageResponseProgressTotalBytesMin = 0;

export const preflightEntityPackageResponseProgressAttemptMin = 0;

export const preflightEntityPackageResponsePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const preflightEntityPackageResponseManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const preflightEntityPackageResponseManifestOneTablesItemRecordCountMin = 0;

export const preflightEntityPackageResponseManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const preflightEntityPackageResponseManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const preflightEntityPackageResponseManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const preflightEntityPackageResponseManifestOneFilesItemSizeBytesMin = 0;

export const preflightEntityPackageResponseManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const preflightEntityPackageResponseManifestOneTransformationsItemCountMin = 0;

export const preflightEntityPackageResponseManifestOneTotalsRecordsMin = 0;

export const preflightEntityPackageResponseManifestOneTotalsFilesMin = 0;

export const preflightEntityPackageResponseManifestOneTotalsFileBytesMin = 0;

export const preflightEntityPackageResponseManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const preflightEntityPackageResponseBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const preflightEntityPackageResponseBindingOneMappingRevisionMin = 0;

export const preflightEntityPackageResponseBindingOneDecisionRevisionMin = 0;

export const preflightEntityPackageResponseBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const preflightEntityPackageResponseBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const preflightEntityPackageResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(preflightEntityPackageResponseProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(preflightEntityPackageResponseProgressTotalRecordsMin),
  "completedFiles": zod.int().min(preflightEntityPackageResponseProgressCompletedFilesMin),
  "totalFiles": zod.int().min(preflightEntityPackageResponseProgressTotalFilesMin),
  "completedBytes": zod.int().min(preflightEntityPackageResponseProgressCompletedBytesMin),
  "totalBytes": zod.int().min(preflightEntityPackageResponseProgressTotalBytesMin),
  "attempt": zod.int().min(preflightEntityPackageResponseProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(preflightEntityPackageResponsePackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(preflightEntityPackageResponseManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(preflightEntityPackageResponseManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(preflightEntityPackageResponseManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(preflightEntityPackageResponseManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(preflightEntityPackageResponseManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(preflightEntityPackageResponseManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(preflightEntityPackageResponseManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(preflightEntityPackageResponseManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(preflightEntityPackageResponseManifestOneTotalsRecordsMin),
  "files": zod.int().min(preflightEntityPackageResponseManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(preflightEntityPackageResponseManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(preflightEntityPackageResponseManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(preflightEntityPackageResponseBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(preflightEntityPackageResponseBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(preflightEntityPackageResponseBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(preflightEntityPackageResponseBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(preflightEntityPackageResponseBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Private upload validation and read-only, entity-scoped Add, Merge and Replace planning. Merge uses persisted source lineage only. Exact value-bound review expires after 30 minutes. Multipart uploads require idempotencyKey before file; previews support up to 20,000 records. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const getEntityPackagePreviewParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const getEntityPackagePreviewQueryLimitDefault = 25;
export const getEntityPackagePreviewQueryLimitMax = 100;

export const getEntityPackagePreviewQueryOffsetDefault = 0;
export const getEntityPackagePreviewQueryOffsetMin = 0;



export const getEntityPackagePreviewQueryParams = zod.object({
  "limit": zod.int().min(1).max(getEntityPackagePreviewQueryLimitMax).default(getEntityPackagePreviewQueryLimitDefault),
  "offset": zod.int().min(getEntityPackagePreviewQueryOffsetMin).default(getEntityPackagePreviewQueryOffsetDefault)
})

export const getEntityPackagePreviewResponseJobProgressCompletedRecordsMin = 0;

export const getEntityPackagePreviewResponseJobProgressTotalRecordsMin = 0;

export const getEntityPackagePreviewResponseJobProgressCompletedFilesMin = 0;

export const getEntityPackagePreviewResponseJobProgressTotalFilesMin = 0;

export const getEntityPackagePreviewResponseJobProgressCompletedBytesMin = 0;

export const getEntityPackagePreviewResponseJobProgressTotalBytesMin = 0;

export const getEntityPackagePreviewResponseJobProgressAttemptMin = 0;

export const getEntityPackagePreviewResponseJobPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackagePreviewResponseJobManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const getEntityPackagePreviewResponseJobManifestOneTablesItemRecordCountMin = 0;

export const getEntityPackagePreviewResponseJobManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackagePreviewResponseJobManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const getEntityPackagePreviewResponseJobManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const getEntityPackagePreviewResponseJobManifestOneFilesItemSizeBytesMin = 0;

export const getEntityPackagePreviewResponseJobManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackagePreviewResponseJobManifestOneTransformationsItemCountMin = 0;

export const getEntityPackagePreviewResponseJobManifestOneTotalsRecordsMin = 0;

export const getEntityPackagePreviewResponseJobManifestOneTotalsFilesMin = 0;

export const getEntityPackagePreviewResponseJobManifestOneTotalsFileBytesMin = 0;

export const getEntityPackagePreviewResponseJobManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackagePreviewResponseJobBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const getEntityPackagePreviewResponseJobBindingOneMappingRevisionMin = 0;

export const getEntityPackagePreviewResponseJobBindingOneDecisionRevisionMin = 0;

export const getEntityPackagePreviewResponseJobBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackagePreviewResponseJobBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackagePreviewResponseBindingPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const getEntityPackagePreviewResponseBindingMappingRevisionMin = 0;

export const getEntityPackagePreviewResponseBindingDecisionRevisionMin = 0;

export const getEntityPackagePreviewResponseBindingDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackagePreviewResponseBindingPlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackagePreviewResponseCountsAddsMin = 0;

export const getEntityPackagePreviewResponseCountsUpdatesMin = 0;

export const getEntityPackagePreviewResponseCountsDeletesMin = 0;

export const getEntityPackagePreviewResponseCountsUnchangedMin = 0;

export const getEntityPackagePreviewResponseCountsConflictsMin = 0;

export const getEntityPackagePreviewResponseCountsBlockersMin = 0;

export const getEntityPackagePreviewResponseChangesItemPackageRecordSourceContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getEntityPackagePreviewResponseTotalChangesMin = 0;

export const getEntityPackagePreviewResponseLimitMin = 0;

export const getEntityPackagePreviewResponseOffsetMin = 0;

export const getEntityPackagePreviewResponseTransformationsItemCountMin = 0;

export const getEntityPackagePreviewResponseFilesCountMin = 0;

export const getEntityPackagePreviewResponseFilesBytesMin = 0;

export const getEntityPackagePreviewResponseFilesUnavailableMin = 0;



export const getEntityPackagePreviewResponse = zod.object({
  "job": zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(getEntityPackagePreviewResponseJobProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(getEntityPackagePreviewResponseJobProgressTotalRecordsMin),
  "completedFiles": zod.int().min(getEntityPackagePreviewResponseJobProgressCompletedFilesMin),
  "totalFiles": zod.int().min(getEntityPackagePreviewResponseJobProgressTotalFilesMin),
  "completedBytes": zod.int().min(getEntityPackagePreviewResponseJobProgressCompletedBytesMin),
  "totalBytes": zod.int().min(getEntityPackagePreviewResponseJobProgressTotalBytesMin),
  "attempt": zod.int().min(getEntityPackagePreviewResponseJobProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(getEntityPackagePreviewResponseJobPackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(getEntityPackagePreviewResponseJobManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(getEntityPackagePreviewResponseJobManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(getEntityPackagePreviewResponseJobManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(getEntityPackagePreviewResponseJobManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(getEntityPackagePreviewResponseJobManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(getEntityPackagePreviewResponseJobManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(getEntityPackagePreviewResponseJobManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(getEntityPackagePreviewResponseJobManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(getEntityPackagePreviewResponseJobManifestOneTotalsRecordsMin),
  "files": zod.int().min(getEntityPackagePreviewResponseJobManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(getEntityPackagePreviewResponseJobManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(getEntityPackagePreviewResponseJobManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(getEntityPackagePreviewResponseJobBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(getEntityPackagePreviewResponseJobBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(getEntityPackagePreviewResponseJobBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(getEntityPackagePreviewResponseJobBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(getEntityPackagePreviewResponseJobBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "binding": zod.object({
  "packageSha256": zod.string().regex(getEntityPackagePreviewResponseBindingPackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(getEntityPackagePreviewResponseBindingMappingRevisionMin),
  "decisionRevision": zod.int().min(getEntityPackagePreviewResponseBindingDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(getEntityPackagePreviewResponseBindingDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(getEntityPackagePreviewResponseBindingPlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),
  "counts": zod.object({
  "adds": zod.int().min(getEntityPackagePreviewResponseCountsAddsMin),
  "updates": zod.int().min(getEntityPackagePreviewResponseCountsUpdatesMin),
  "deletes": zod.int().min(getEntityPackagePreviewResponseCountsDeletesMin),
  "unchanged": zod.int().min(getEntityPackagePreviewResponseCountsUnchangedMin),
  "conflicts": zod.int().min(getEntityPackagePreviewResponseCountsConflictsMin),
  "blockers": zod.int().min(getEntityPackagePreviewResponseCountsBlockersMin)
}),
  "changes": zod.array(zod.object({
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "destinationRecordKey": zod.string().nullable(),
  "action": zod.enum(['add', 'update', 'delete', 'unchanged', 'conflict', 'blocked']),
  "changedFields": zod.array(zod.string()),
  "immutable": zod.boolean(),
  "packageRecord": zod.object({
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "sourceEntityLineageId": zod.uuid(),
  "sourceContentSha256": zod.string().regex(getEntityPackagePreviewResponseChangesItemPackageRecordSourceContentSha256RegExp),
  "immutable": zod.boolean(),
  "data": zod.record(zod.string(), zod.unknown())
}).optional()
})),
  "totalChanges": zod.int().min(getEntityPackagePreviewResponseTotalChangesMin),
  "limit": zod.int().min(getEntityPackagePreviewResponseLimitMin),
  "offset": zod.int().min(getEntityPackagePreviewResponseOffsetMin),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(getEntityPackagePreviewResponseTransformationsItemCountMin)
})),
  "files": zod.object({
  "count": zod.int().min(getEntityPackagePreviewResponseFilesCountMin),
  "bytes": zod.int().min(getEntityPackagePreviewResponseFilesBytesMin),
  "unavailable": zod.int().min(getEntityPackagePreviewResponseFilesUnavailableMin)
}),
  "recoveryRequired": zod.boolean(),
  "activationRequired": zod.boolean()
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Private upload validation and read-only, entity-scoped Add, Merge and Replace planning. Merge uses persisted source lineage only. Exact value-bound review expires after 30 minutes. Multipart uploads require idempotencyKey before file; previews support up to 20,000 records. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const listEntityPackageConflictsParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const listEntityPackageConflictsQueryLimitDefault = 25;
export const listEntityPackageConflictsQueryLimitMax = 100;

export const listEntityPackageConflictsQueryOffsetDefault = 0;
export const listEntityPackageConflictsQueryOffsetMin = 0;



export const listEntityPackageConflictsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEntityPackageConflictsQueryLimitMax).default(listEntityPackageConflictsQueryLimitDefault),
  "offset": zod.int().min(listEntityPackageConflictsQueryOffsetMin).default(listEntityPackageConflictsQueryOffsetDefault)
})

export const listEntityPackageConflictsResponseItemsItemPackageValueSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityPackageConflictsResponseItemsItemDestinationValueSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listEntityPackageConflictsResponseItemsItemRevisionMin = 0;

export const listEntityPackageConflictsResponseTotalMin = 0;

export const listEntityPackageConflictsResponseLimitMin = 0;

export const listEntityPackageConflictsResponseOffsetMin = 0;



export const listEntityPackageConflictsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "destinationRecordKey": zod.string().nullable(),
  "fieldPath": zod.string(),
  "kind": zod.enum(['value', 'relationship', 'local_deletion', 'multiple_copies', 'singleton', 'unique_key', 'immutable_history']),
  "packageValue": zod.unknown().nullable(),
  "destinationValue": zod.unknown().nullable(),
  "packageValueSha256": zod.string().regex(listEntityPackageConflictsResponseItemsItemPackageValueSha256RegExp),
  "destinationValueSha256": zod.string().regex(listEntityPackageConflictsResponseItemsItemDestinationValueSha256RegExp),
  "resolution": zod.enum(['unresolved', 'keep_destination', 'use_package', 'add_copy', 'block']),
  "revision": zod.int().min(listEntityPackageConflictsResponseItemsItemRevisionMin)
})),
  "total": zod.int().min(listEntityPackageConflictsResponseTotalMin),
  "limit": zod.int().min(listEntityPackageConflictsResponseLimitMin),
  "offset": zod.int().min(listEntityPackageConflictsResponseOffsetMin)
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Private upload validation and read-only, entity-scoped Add, Merge and Replace planning. Merge uses persisted source lineage only. Exact value-bound review expires after 30 minutes. Multipart uploads require idempotencyKey before file; previews support up to 20,000 records. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const decideEntityPackageConflictParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const decideEntityPackageConflictBodyBindingPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const decideEntityPackageConflictBodyBindingMappingRevisionMin = 0;

export const decideEntityPackageConflictBodyBindingDecisionRevisionMin = 0;

export const decideEntityPackageConflictBodyBindingDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const decideEntityPackageConflictBodyBindingPlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const decideEntityPackageConflictBodyExpectedRevisionMin = 0;

export const decideEntityPackageConflictBodyReasonMax = 2000;



export const decideEntityPackageConflictBody = zod.object({
  "binding": zod.object({
  "packageSha256": zod.string().regex(decideEntityPackageConflictBodyBindingPackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(decideEntityPackageConflictBodyBindingMappingRevisionMin),
  "decisionRevision": zod.int().min(decideEntityPackageConflictBodyBindingDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(decideEntityPackageConflictBodyBindingDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(decideEntityPackageConflictBodyBindingPlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),
  "conflictId": zod.uuid(),
  "expectedRevision": zod.int().min(decideEntityPackageConflictBodyExpectedRevisionMin),
  "resolution": zod.enum(['keep_destination', 'use_package', 'add_copy', 'block']),
  "reason": zod.string().min(1).max(decideEntityPackageConflictBodyReasonMax),
  "idempotencyKey": zod.uuid()
})

export const decideEntityPackageConflictResponseProgressCompletedRecordsMin = 0;

export const decideEntityPackageConflictResponseProgressTotalRecordsMin = 0;

export const decideEntityPackageConflictResponseProgressCompletedFilesMin = 0;

export const decideEntityPackageConflictResponseProgressTotalFilesMin = 0;

export const decideEntityPackageConflictResponseProgressCompletedBytesMin = 0;

export const decideEntityPackageConflictResponseProgressTotalBytesMin = 0;

export const decideEntityPackageConflictResponseProgressAttemptMin = 0;

export const decideEntityPackageConflictResponsePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const decideEntityPackageConflictResponseManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const decideEntityPackageConflictResponseManifestOneTablesItemRecordCountMin = 0;

export const decideEntityPackageConflictResponseManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const decideEntityPackageConflictResponseManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const decideEntityPackageConflictResponseManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const decideEntityPackageConflictResponseManifestOneFilesItemSizeBytesMin = 0;

export const decideEntityPackageConflictResponseManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const decideEntityPackageConflictResponseManifestOneTransformationsItemCountMin = 0;

export const decideEntityPackageConflictResponseManifestOneTotalsRecordsMin = 0;

export const decideEntityPackageConflictResponseManifestOneTotalsFilesMin = 0;

export const decideEntityPackageConflictResponseManifestOneTotalsFileBytesMin = 0;

export const decideEntityPackageConflictResponseManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const decideEntityPackageConflictResponseBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const decideEntityPackageConflictResponseBindingOneMappingRevisionMin = 0;

export const decideEntityPackageConflictResponseBindingOneDecisionRevisionMin = 0;

export const decideEntityPackageConflictResponseBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const decideEntityPackageConflictResponseBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const decideEntityPackageConflictResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(decideEntityPackageConflictResponseProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(decideEntityPackageConflictResponseProgressTotalRecordsMin),
  "completedFiles": zod.int().min(decideEntityPackageConflictResponseProgressCompletedFilesMin),
  "totalFiles": zod.int().min(decideEntityPackageConflictResponseProgressTotalFilesMin),
  "completedBytes": zod.int().min(decideEntityPackageConflictResponseProgressCompletedBytesMin),
  "totalBytes": zod.int().min(decideEntityPackageConflictResponseProgressTotalBytesMin),
  "attempt": zod.int().min(decideEntityPackageConflictResponseProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(decideEntityPackageConflictResponsePackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(decideEntityPackageConflictResponseManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(decideEntityPackageConflictResponseManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(decideEntityPackageConflictResponseManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(decideEntityPackageConflictResponseManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(decideEntityPackageConflictResponseManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(decideEntityPackageConflictResponseManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(decideEntityPackageConflictResponseManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(decideEntityPackageConflictResponseManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(decideEntityPackageConflictResponseManifestOneTotalsRecordsMin),
  "files": zod.int().min(decideEntityPackageConflictResponseManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(decideEntityPackageConflictResponseManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(decideEntityPackageConflictResponseManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(decideEntityPackageConflictResponseBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(decideEntityPackageConflictResponseBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(decideEntityPackageConflictResponseBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(decideEntityPackageConflictResponseBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(decideEntityPackageConflictResponseBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Atomically applies current reviewed Add, Merge or guarded Replace plans with private files, lineage and audit. A committed operation replays only the same request; a deliberate new Add needs a new upload and review. Unresolved conflicts, stale contents or lost authority block publication. Replace requires a verified private recovery snapshot and exact destination confirmation; active workers and protected dependencies fail closed. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const applyEntityPackageParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const applyEntityPackageBodyOneBindingPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const applyEntityPackageBodyOneBindingMappingRevisionMin = 0;

export const applyEntityPackageBodyOneBindingDecisionRevisionMin = 0;

export const applyEntityPackageBodyOneBindingDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const applyEntityPackageBodyOneBindingPlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const applyEntityPackageBodyOneReasonMax = 2000;

export const applyEntityPackageBodyTwoBindingPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const applyEntityPackageBodyTwoBindingMappingRevisionMin = 0;

export const applyEntityPackageBodyTwoBindingDecisionRevisionMin = 0;

export const applyEntityPackageBodyTwoBindingDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const applyEntityPackageBodyTwoBindingPlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const applyEntityPackageBodyTwoReasonMax = 2000;

export const applyEntityPackageBodyTwoReplacementConfirmationRecoverySnapshotSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const applyEntityPackageBody = zod.union([zod.object({
  "binding": zod.object({
  "packageSha256": zod.string().regex(applyEntityPackageBodyOneBindingPackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(applyEntityPackageBodyOneBindingMappingRevisionMin),
  "decisionRevision": zod.int().min(applyEntityPackageBodyOneBindingDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(applyEntityPackageBodyOneBindingDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(applyEntityPackageBodyOneBindingPlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),
  "idempotencyKey": zod.uuid(),
  "reason": zod.string().min(1).max(applyEntityPackageBodyOneReasonMax)
}),zod.object({
  "binding": zod.object({
  "packageSha256": zod.string().regex(applyEntityPackageBodyTwoBindingPackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(applyEntityPackageBodyTwoBindingMappingRevisionMin),
  "decisionRevision": zod.int().min(applyEntityPackageBodyTwoBindingDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(applyEntityPackageBodyTwoBindingDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(applyEntityPackageBodyTwoBindingPlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),
  "idempotencyKey": zod.uuid(),
  "reason": zod.string().min(1).max(applyEntityPackageBodyTwoReasonMax),
  "replacementConfirmation": zod.object({
  "destinationEntityId": zod.uuid(),
  "destinationEntityName": zod.string(),
  "confirmation": zod.enum(['REPLACE']),
  "recoverySnapshotSha256": zod.string().regex(applyEntityPackageBodyTwoReplacementConfirmationRecoverySnapshotSha256RegExp)
})
})])

export const applyEntityPackageResponseProgressCompletedRecordsMin = 0;

export const applyEntityPackageResponseProgressTotalRecordsMin = 0;

export const applyEntityPackageResponseProgressCompletedFilesMin = 0;

export const applyEntityPackageResponseProgressTotalFilesMin = 0;

export const applyEntityPackageResponseProgressCompletedBytesMin = 0;

export const applyEntityPackageResponseProgressTotalBytesMin = 0;

export const applyEntityPackageResponseProgressAttemptMin = 0;

export const applyEntityPackageResponsePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const applyEntityPackageResponseManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const applyEntityPackageResponseManifestOneTablesItemRecordCountMin = 0;

export const applyEntityPackageResponseManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const applyEntityPackageResponseManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const applyEntityPackageResponseManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const applyEntityPackageResponseManifestOneFilesItemSizeBytesMin = 0;

export const applyEntityPackageResponseManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const applyEntityPackageResponseManifestOneTransformationsItemCountMin = 0;

export const applyEntityPackageResponseManifestOneTotalsRecordsMin = 0;

export const applyEntityPackageResponseManifestOneTotalsFilesMin = 0;

export const applyEntityPackageResponseManifestOneTotalsFileBytesMin = 0;

export const applyEntityPackageResponseManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const applyEntityPackageResponseBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const applyEntityPackageResponseBindingOneMappingRevisionMin = 0;

export const applyEntityPackageResponseBindingOneDecisionRevisionMin = 0;

export const applyEntityPackageResponseBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const applyEntityPackageResponseBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const applyEntityPackageResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(applyEntityPackageResponseProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(applyEntityPackageResponseProgressTotalRecordsMin),
  "completedFiles": zod.int().min(applyEntityPackageResponseProgressCompletedFilesMin),
  "totalFiles": zod.int().min(applyEntityPackageResponseProgressTotalFilesMin),
  "completedBytes": zod.int().min(applyEntityPackageResponseProgressCompletedBytesMin),
  "totalBytes": zod.int().min(applyEntityPackageResponseProgressTotalBytesMin),
  "attempt": zod.int().min(applyEntityPackageResponseProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(applyEntityPackageResponsePackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(applyEntityPackageResponseManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(applyEntityPackageResponseManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(applyEntityPackageResponseManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(applyEntityPackageResponseManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(applyEntityPackageResponseManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(applyEntityPackageResponseManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(applyEntityPackageResponseManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(applyEntityPackageResponseManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(applyEntityPackageResponseManifestOneTotalsRecordsMin),
  "files": zod.int().min(applyEntityPackageResponseManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(applyEntityPackageResponseManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(applyEntityPackageResponseManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(applyEntityPackageResponseBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(applyEntityPackageResponseBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(applyEntityPackageResponseBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(applyEntityPackageResponseBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(applyEntityPackageResponseBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Exports use durable leased jobs, a consistent source snapshot and verified private ZIP downloads. Retry starts a new snapshot; incomplete content blocks completion. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const cancelEntityPackageJobParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const cancelEntityPackageJobBodyReasonMin = 8;
export const cancelEntityPackageJobBodyReasonMax = 500;



export const cancelEntityPackageJobBody = zod.object({
  "reason": zod.string().min(cancelEntityPackageJobBodyReasonMin).max(cancelEntityPackageJobBodyReasonMax)
})

export const cancelEntityPackageJobResponseProgressCompletedRecordsMin = 0;

export const cancelEntityPackageJobResponseProgressTotalRecordsMin = 0;

export const cancelEntityPackageJobResponseProgressCompletedFilesMin = 0;

export const cancelEntityPackageJobResponseProgressTotalFilesMin = 0;

export const cancelEntityPackageJobResponseProgressCompletedBytesMin = 0;

export const cancelEntityPackageJobResponseProgressTotalBytesMin = 0;

export const cancelEntityPackageJobResponseProgressAttemptMin = 0;

export const cancelEntityPackageJobResponsePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelEntityPackageJobResponseManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const cancelEntityPackageJobResponseManifestOneTablesItemRecordCountMin = 0;

export const cancelEntityPackageJobResponseManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelEntityPackageJobResponseManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const cancelEntityPackageJobResponseManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const cancelEntityPackageJobResponseManifestOneFilesItemSizeBytesMin = 0;

export const cancelEntityPackageJobResponseManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelEntityPackageJobResponseManifestOneTransformationsItemCountMin = 0;

export const cancelEntityPackageJobResponseManifestOneTotalsRecordsMin = 0;

export const cancelEntityPackageJobResponseManifestOneTotalsFilesMin = 0;

export const cancelEntityPackageJobResponseManifestOneTotalsFileBytesMin = 0;

export const cancelEntityPackageJobResponseManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelEntityPackageJobResponseBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const cancelEntityPackageJobResponseBindingOneMappingRevisionMin = 0;

export const cancelEntityPackageJobResponseBindingOneDecisionRevisionMin = 0;

export const cancelEntityPackageJobResponseBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelEntityPackageJobResponseBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const cancelEntityPackageJobResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(cancelEntityPackageJobResponseProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(cancelEntityPackageJobResponseProgressTotalRecordsMin),
  "completedFiles": zod.int().min(cancelEntityPackageJobResponseProgressCompletedFilesMin),
  "totalFiles": zod.int().min(cancelEntityPackageJobResponseProgressTotalFilesMin),
  "completedBytes": zod.int().min(cancelEntityPackageJobResponseProgressCompletedBytesMin),
  "totalBytes": zod.int().min(cancelEntityPackageJobResponseProgressTotalBytesMin),
  "attempt": zod.int().min(cancelEntityPackageJobResponseProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(cancelEntityPackageJobResponsePackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(cancelEntityPackageJobResponseManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(cancelEntityPackageJobResponseManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(cancelEntityPackageJobResponseManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(cancelEntityPackageJobResponseManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(cancelEntityPackageJobResponseManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(cancelEntityPackageJobResponseManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(cancelEntityPackageJobResponseManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(cancelEntityPackageJobResponseManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(cancelEntityPackageJobResponseManifestOneTotalsRecordsMin),
  "files": zod.int().min(cancelEntityPackageJobResponseManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(cancelEntityPackageJobResponseManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(cancelEntityPackageJobResponseManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(cancelEntityPackageJobResponseBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(cancelEntityPackageJobResponseBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(cancelEntityPackageJobResponseBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(cancelEntityPackageJobResponseBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(cancelEntityPackageJobResponseBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Exports use durable leased jobs, a consistent source snapshot and verified private ZIP downloads. Retry starts a new snapshot; incomplete content blocks completion. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const retryEntityPackageJobParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const retryEntityPackageJobBodyReasonMax = 2000;



export const retryEntityPackageJobBody = zod.object({
  "idempotencyKey": zod.uuid(),
  "reason": zod.string().min(1).max(retryEntityPackageJobBodyReasonMax)
})

export const retryEntityPackageJobResponseProgressCompletedRecordsMin = 0;

export const retryEntityPackageJobResponseProgressTotalRecordsMin = 0;

export const retryEntityPackageJobResponseProgressCompletedFilesMin = 0;

export const retryEntityPackageJobResponseProgressTotalFilesMin = 0;

export const retryEntityPackageJobResponseProgressCompletedBytesMin = 0;

export const retryEntityPackageJobResponseProgressTotalBytesMin = 0;

export const retryEntityPackageJobResponseProgressAttemptMin = 0;

export const retryEntityPackageJobResponsePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const retryEntityPackageJobResponseManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const retryEntityPackageJobResponseManifestOneTablesItemRecordCountMin = 0;

export const retryEntityPackageJobResponseManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const retryEntityPackageJobResponseManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const retryEntityPackageJobResponseManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const retryEntityPackageJobResponseManifestOneFilesItemSizeBytesMin = 0;

export const retryEntityPackageJobResponseManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const retryEntityPackageJobResponseManifestOneTransformationsItemCountMin = 0;

export const retryEntityPackageJobResponseManifestOneTotalsRecordsMin = 0;

export const retryEntityPackageJobResponseManifestOneTotalsFilesMin = 0;

export const retryEntityPackageJobResponseManifestOneTotalsFileBytesMin = 0;

export const retryEntityPackageJobResponseManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const retryEntityPackageJobResponseBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const retryEntityPackageJobResponseBindingOneMappingRevisionMin = 0;

export const retryEntityPackageJobResponseBindingOneDecisionRevisionMin = 0;

export const retryEntityPackageJobResponseBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const retryEntityPackageJobResponseBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const retryEntityPackageJobResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(retryEntityPackageJobResponseProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(retryEntityPackageJobResponseProgressTotalRecordsMin),
  "completedFiles": zod.int().min(retryEntityPackageJobResponseProgressCompletedFilesMin),
  "totalFiles": zod.int().min(retryEntityPackageJobResponseProgressTotalFilesMin),
  "completedBytes": zod.int().min(retryEntityPackageJobResponseProgressCompletedBytesMin),
  "totalBytes": zod.int().min(retryEntityPackageJobResponseProgressTotalBytesMin),
  "attempt": zod.int().min(retryEntityPackageJobResponseProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(retryEntityPackageJobResponsePackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(retryEntityPackageJobResponseManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(retryEntityPackageJobResponseManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(retryEntityPackageJobResponseManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(retryEntityPackageJobResponseManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(retryEntityPackageJobResponseManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(retryEntityPackageJobResponseManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(retryEntityPackageJobResponseManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(retryEntityPackageJobResponseManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(retryEntityPackageJobResponseManifestOneTotalsRecordsMin),
  "files": zod.int().min(retryEntityPackageJobResponseManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(retryEntityPackageJobResponseManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(retryEntityPackageJobResponseManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(retryEntityPackageJobResponseBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(retryEntityPackageJobResponseBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(retryEntityPackageJobResponseBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(retryEntityPackageJobResponseBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(retryEntityPackageJobResponseBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Reviews restoration of a verified private recovery snapshot. Rejects subsequent destination edits and requires current destination authority.
 */
export const reviewEntityPackageRecoveryParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const reviewEntityPackageRecoveryResponseRecoverySnapshotSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewEntityPackageRecoveryResponseBindingPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const reviewEntityPackageRecoveryResponseBindingMappingRevisionMin = 0;

export const reviewEntityPackageRecoveryResponseBindingDecisionRevisionMin = 0;

export const reviewEntityPackageRecoveryResponseBindingDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewEntityPackageRecoveryResponseBindingPlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewEntityPackageRecoveryResponseDeletionCountMin = 0;



export const reviewEntityPackageRecoveryResponse = zod.object({
  "recoveryJobId": zod.uuid(),
  "recoverySnapshotSha256": zod.string().regex(reviewEntityPackageRecoveryResponseRecoverySnapshotSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "destinationEntityName": zod.string(),
  "binding": zod.object({
  "packageSha256": zod.string().regex(reviewEntityPackageRecoveryResponseBindingPackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(reviewEntityPackageRecoveryResponseBindingMappingRevisionMin),
  "decisionRevision": zod.int().min(reviewEntityPackageRecoveryResponseBindingDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(reviewEntityPackageRecoveryResponseBindingDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(reviewEntityPackageRecoveryResponseBindingPlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),
  "deletionCount": zod.int().min(reviewEntityPackageRecoveryResponseDeletionCountMin)
})


/**
 * Creates and verifies a private recovery snapshot for the current exact Replace preview. No destination business mutation. Native operational dependencies or protected references block Replace.
 */
export const prepareEntityPackageReplacementParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const prepareEntityPackageReplacementBodyBindingPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const prepareEntityPackageReplacementBodyBindingMappingRevisionMin = 0;

export const prepareEntityPackageReplacementBodyBindingDecisionRevisionMin = 0;

export const prepareEntityPackageReplacementBodyBindingDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const prepareEntityPackageReplacementBodyBindingPlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const prepareEntityPackageReplacementBodyReasonMax = 2000;



export const prepareEntityPackageReplacementBody = zod.object({
  "binding": zod.object({
  "packageSha256": zod.string().regex(prepareEntityPackageReplacementBodyBindingPackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(prepareEntityPackageReplacementBodyBindingMappingRevisionMin),
  "decisionRevision": zod.int().min(prepareEntityPackageReplacementBodyBindingDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(prepareEntityPackageReplacementBodyBindingDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(prepareEntityPackageReplacementBodyBindingPlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),
  "idempotencyKey": zod.uuid(),
  "reason": zod.string().min(1).max(prepareEntityPackageReplacementBodyReasonMax)
})

export const prepareEntityPackageReplacementResponseRecoverySnapshotSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const prepareEntityPackageReplacementResponseBindingPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const prepareEntityPackageReplacementResponseBindingMappingRevisionMin = 0;

export const prepareEntityPackageReplacementResponseBindingDecisionRevisionMin = 0;

export const prepareEntityPackageReplacementResponseBindingDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const prepareEntityPackageReplacementResponseBindingPlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const prepareEntityPackageReplacementResponseDeletionCountMin = 0;



export const prepareEntityPackageReplacementResponse = zod.object({
  "recoveryJobId": zod.uuid(),
  "recoverySnapshotSha256": zod.string().regex(prepareEntityPackageReplacementResponseRecoverySnapshotSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "destinationEntityName": zod.string(),
  "binding": zod.object({
  "packageSha256": zod.string().regex(prepareEntityPackageReplacementResponseBindingPackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(prepareEntityPackageReplacementResponseBindingMappingRevisionMin),
  "decisionRevision": zod.int().min(prepareEntityPackageReplacementResponseBindingDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(prepareEntityPackageReplacementResponseBindingDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(prepareEntityPackageReplacementResponseBindingPlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),
  "deletionCount": zod.int().min(prepareEntityPackageReplacementResponseDeletionCountMin)
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Restores a verified private recovery snapshot only after a fresh authority-bound recovery review; subsequent destination changes block restoration. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const recoverEntityPackageParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const recoverEntityPackageBodyBindingPackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const recoverEntityPackageBodyBindingMappingRevisionMin = 0;

export const recoverEntityPackageBodyBindingDecisionRevisionMin = 0;

export const recoverEntityPackageBodyBindingDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const recoverEntityPackageBodyBindingPlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const recoverEntityPackageBodyRecoverySnapshotSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const recoverEntityPackageBodyReasonMax = 2000;



export const recoverEntityPackageBody = zod.object({
  "binding": zod.object({
  "packageSha256": zod.string().regex(recoverEntityPackageBodyBindingPackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(recoverEntityPackageBodyBindingMappingRevisionMin),
  "decisionRevision": zod.int().min(recoverEntityPackageBodyBindingDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(recoverEntityPackageBodyBindingDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(recoverEntityPackageBodyBindingPlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),
  "recoverySnapshotSha256": zod.string().regex(recoverEntityPackageBodyRecoverySnapshotSha256RegExp),
  "confirmation": zod.enum(['RECOVER']),
  "reason": zod.string().min(1).max(recoverEntityPackageBodyReasonMax),
  "idempotencyKey": zod.uuid()
})

export const recoverEntityPackageResponseProgressCompletedRecordsMin = 0;

export const recoverEntityPackageResponseProgressTotalRecordsMin = 0;

export const recoverEntityPackageResponseProgressCompletedFilesMin = 0;

export const recoverEntityPackageResponseProgressTotalFilesMin = 0;

export const recoverEntityPackageResponseProgressCompletedBytesMin = 0;

export const recoverEntityPackageResponseProgressTotalBytesMin = 0;

export const recoverEntityPackageResponseProgressAttemptMin = 0;

export const recoverEntityPackageResponsePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const recoverEntityPackageResponseManifestOneCompatibilityInventorySha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const recoverEntityPackageResponseManifestOneTablesItemRecordCountMin = 0;

export const recoverEntityPackageResponseManifestOneTablesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const recoverEntityPackageResponseManifestOneTablesItemArchivePathRegExp = new RegExp('^records/[a-z0-9_-]+[.]jsonl$');

export const recoverEntityPackageResponseManifestOneFilesItemArchivePathRegExp = new RegExp('^files/[a-zA-Z0-9._/-]+$');
export const recoverEntityPackageResponseManifestOneFilesItemSizeBytesMin = 0;

export const recoverEntityPackageResponseManifestOneFilesItemSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const recoverEntityPackageResponseManifestOneTransformationsItemCountMin = 0;

export const recoverEntityPackageResponseManifestOneTotalsRecordsMin = 0;

export const recoverEntityPackageResponseManifestOneTotalsFilesMin = 0;

export const recoverEntityPackageResponseManifestOneTotalsFileBytesMin = 0;

export const recoverEntityPackageResponseManifestOneContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const recoverEntityPackageResponseBindingOnePackageSha256RegExp = new RegExp('^[a-f0-9]{64}$');

export const recoverEntityPackageResponseBindingOneMappingRevisionMin = 0;

export const recoverEntityPackageResponseBindingOneDecisionRevisionMin = 0;

export const recoverEntityPackageResponseBindingOneDestinationContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const recoverEntityPackageResponseBindingOnePlanSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const recoverEntityPackageResponse = zod.object({
  "id": zod.uuid(),
  "entityId": zod.uuid(),
  "kind": zod.enum(['export', 'upload', 'preflight', 'apply', 'recovery']),
  "mode": zod.union([zod.enum(['add', 'merge', 'replace']),zod.null()]),
  "status": zod.enum(['queued', 'running', 'blocked', 'awaiting_review', 'committing', 'succeeded', 'failed', 'cancelled', 'reconciliation_required']),
  "progress": zod.object({
  "phase": zod.string(),
  "completedRecords": zod.int().min(recoverEntityPackageResponseProgressCompletedRecordsMin),
  "totalRecords": zod.int().min(recoverEntityPackageResponseProgressTotalRecordsMin),
  "completedFiles": zod.int().min(recoverEntityPackageResponseProgressCompletedFilesMin),
  "totalFiles": zod.int().min(recoverEntityPackageResponseProgressTotalFilesMin),
  "completedBytes": zod.int().min(recoverEntityPackageResponseProgressCompletedBytesMin),
  "totalBytes": zod.int().min(recoverEntityPackageResponseProgressTotalBytesMin),
  "attempt": zod.int().min(recoverEntityPackageResponseProgressAttemptMin),
  "cancellable": zod.boolean(),
  "retryable": zod.boolean()
}),
  "packageSha256": zod.string().regex(recoverEntityPackageResponsePackageSha256RegExp).nullable(),
  "manifest": zod.union([zod.object({
  "packageType": zod.enum(['cdf.entity-package']),
  "formatVersion": zod.literal(1),
  "packageId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "source": zod.object({
  "applicationId": zod.string(),
  "environmentId": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "entityLineageId": zod.uuid()
}),
  "compatibility": zod.object({
  "applicationContract": zod.enum(['cdf-business-entity']),
  "schemaRevision": zod.string(),
  "inventorySha256": zod.string().regex(recoverEntityPackageResponseManifestOneCompatibilityInventorySha256RegExp),
  "minimumReaderVersion": zod.int().min(1),
  "adapterContractVersion": zod.literal(1)
}),
  "tables": zod.array(zod.object({
  "recordType": zod.string(),
  "recordCount": zod.int().min(recoverEntityPackageResponseManifestOneTablesItemRecordCountMin),
  "sha256": zod.string().regex(recoverEntityPackageResponseManifestOneTablesItemSha256RegExp),
  "archivePath": zod.string().regex(recoverEntityPackageResponseManifestOneTablesItemArchivePathRegExp),
  "adapterVersion": zod.int().min(1)
})),
  "files": zod.array(zod.object({
  "fileKey": zod.uuid(),
  "family": zod.string(),
  "recordType": zod.string(),
  "sourceRecordKey": zod.string(),
  "fieldPath": zod.string(),
  "archivePath": zod.string().regex(recoverEntityPackageResponseManifestOneFilesItemArchivePathRegExp),
  "sizeBytes": zod.int().min(recoverEntityPackageResponseManifestOneFilesItemSizeBytesMin),
  "sha256": zod.string().regex(recoverEntityPackageResponseManifestOneFilesItemSha256RegExp),
  "contentType": zod.string(),
  "filename": zod.string(),
  "sourceRevision": zod.string(),
  "required": zod.boolean(),
  "importStorage": zod.enum(['private_app_files'])
})),
  "dependencies": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['destination_user', 'record', 'copy_lineage', 'unique_key', 'singleton', 'provider', 'adapter']),
  "required": zod.boolean(),
  "sourceReference": zod.string(),
  "destinationReference": zod.string().nullable(),
  "status": zod.enum(['resolved', 'unresolved', 'excluded', 'reconnect_required']),
  "message": zod.string()
})),
  "transformations": zod.array(zod.object({
  "recordType": zod.string(),
  "fieldPath": zod.string(),
  "classification": zod.enum(['transformed', 'derived', 'excluded']),
  "reason": zod.string(),
  "count": zod.int().min(recoverEntityPackageResponseManifestOneTransformationsItemCountMin)
})),
  "totals": zod.object({
  "records": zod.int().min(recoverEntityPackageResponseManifestOneTotalsRecordsMin),
  "files": zod.int().min(recoverEntityPackageResponseManifestOneTotalsFilesMin),
  "fileBytes": zod.int().min(recoverEntityPackageResponseManifestOneTotalsFileBytesMin)
}),
  "contentSha256": zod.string().regex(recoverEntityPackageResponseManifestOneContentSha256RegExp)
}),zod.null()]),
  "binding": zod.union([zod.object({
  "packageSha256": zod.string().regex(recoverEntityPackageResponseBindingOnePackageSha256RegExp),
  "destinationEntityId": zod.uuid(),
  "mode": zod.enum(['add', 'merge', 'replace']),
  "previewRevision": zod.int().min(1),
  "mappingRevision": zod.int().min(recoverEntityPackageResponseBindingOneMappingRevisionMin),
  "decisionRevision": zod.int().min(recoverEntityPackageResponseBindingOneDecisionRevisionMin),
  "destinationContentSha256": zod.string().regex(recoverEntityPackageResponseBindingOneDestinationContentSha256RegExp),
  "planSha256": zod.string().regex(recoverEntityPackageResponseBindingOnePlanSha256RegExp),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "recoveryJobId": zod.uuid().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires tenant.data.manage and current server-verified ownership/access to the exact path entity. Exports use durable leased jobs, a consistent source snapshot and verified private ZIP downloads. Retry starts a new snapshot; incomplete content blocks completion. Package metadata grants no authority. Destination identity, access and tenant settings remain authoritative.
 */
export const downloadEntityPackageParams = zod.object({
  "entityId": zod.uuid(),
  "jobId": zod.uuid()
})

export const downloadEntityPackageResponse = zod.unknown()


/**
 * Requires tenant.data.manage.
 * @summary List tenant data export and import jobs
 */
export const listTenantDataManagementJobsQueryLimitDefault = 25;
export const listTenantDataManagementJobsQueryLimitMax = 100;

export const listTenantDataManagementJobsQueryOffsetDefault = 0;
export const listTenantDataManagementJobsQueryOffsetMin = 0;



export const listTenantDataManagementJobsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantDataManagementJobsQueryLimitMax).default(listTenantDataManagementJobsQueryLimitDefault),
  "offset": zod.int().min(listTenantDataManagementJobsQueryOffsetMin).default(listTenantDataManagementJobsQueryOffsetDefault),
  "kind": zod.enum(['export', 'import']).optional()
})

export const listTenantDataManagementJobsResponseItemsItemSummaryOneAreasItemOneCreateMin = 0;

export const listTenantDataManagementJobsResponseItemsItemSummaryOneAreasItemOneUpdateMin = 0;

export const listTenantDataManagementJobsResponseItemsItemSummaryOneAreasItemOneDeleteMin = 0;

export const listTenantDataManagementJobsResponseItemsItemSummaryOneAreasItemOneSkipMin = 0;

export const listTenantDataManagementJobsResponseItemsItemSummaryOneTablesItemOneCreateMin = 0;

export const listTenantDataManagementJobsResponseItemsItemSummaryOneTablesItemOneUpdateMin = 0;

export const listTenantDataManagementJobsResponseItemsItemSummaryOneTablesItemOneDeleteMin = 0;

export const listTenantDataManagementJobsResponseItemsItemSummaryOneTablesItemOneSkipMin = 0;

export const listTenantDataManagementJobsResponseTotalMin = 0;


export const listTenantDataManagementJobsResponseOffsetMin = 0;



export const listTenantDataManagementJobsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "status": zod.enum(['queued', 'running', 'completed', 'failed', 'cancelled', 'awaiting_apply', 'applied']),
  "areas": zod.array(zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])),
  "summary": zod.union([zod.object({
  "areas": zod.array(zod.object({
  "create": zod.int().min(listTenantDataManagementJobsResponseItemsItemSummaryOneAreasItemOneCreateMin),
  "update": zod.int().min(listTenantDataManagementJobsResponseItemsItemSummaryOneAreasItemOneUpdateMin),
  "delete": zod.int().min(listTenantDataManagementJobsResponseItemsItemSummaryOneAreasItemOneDeleteMin),
  "skip": zod.int().min(listTenantDataManagementJobsResponseItemsItemSummaryOneAreasItemOneSkipMin)
}).and(zod.object({
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules']),
  "label": zod.string()
}))),
  "tables": zod.array(zod.object({
  "create": zod.int().min(listTenantDataManagementJobsResponseItemsItemSummaryOneTablesItemOneCreateMin),
  "update": zod.int().min(listTenantDataManagementJobsResponseItemsItemSummaryOneTablesItemOneUpdateMin),
  "delete": zod.int().min(listTenantDataManagementJobsResponseItemsItemSummaryOneTablesItemOneDeleteMin),
  "skip": zod.int().min(listTenantDataManagementJobsResponseItemsItemSummaryOneTablesItemOneSkipMin)
}).and(zod.object({
  "table": zod.string(),
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])
}))),
  "warnings": zod.array(zod.string())
}),zod.null()]),
  "error": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "downloadReady": zod.boolean()
})),
  "total": zod.int().min(listTenantDataManagementJobsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listTenantDataManagementJobsResponseOffsetMin)
})


/**
 * Requires tenant.data.manage.
 */
export const getTenantDataManagementJobParams = zod.object({
  "id": zod.uuid()
})

export const getTenantDataManagementJobResponseSummaryOneAreasItemOneCreateMin = 0;

export const getTenantDataManagementJobResponseSummaryOneAreasItemOneUpdateMin = 0;

export const getTenantDataManagementJobResponseSummaryOneAreasItemOneDeleteMin = 0;

export const getTenantDataManagementJobResponseSummaryOneAreasItemOneSkipMin = 0;

export const getTenantDataManagementJobResponseSummaryOneTablesItemOneCreateMin = 0;

export const getTenantDataManagementJobResponseSummaryOneTablesItemOneUpdateMin = 0;

export const getTenantDataManagementJobResponseSummaryOneTablesItemOneDeleteMin = 0;

export const getTenantDataManagementJobResponseSummaryOneTablesItemOneSkipMin = 0;



export const getTenantDataManagementJobResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "status": zod.enum(['queued', 'running', 'completed', 'failed', 'cancelled', 'awaiting_apply', 'applied']),
  "areas": zod.array(zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])),
  "summary": zod.union([zod.object({
  "areas": zod.array(zod.object({
  "create": zod.int().min(getTenantDataManagementJobResponseSummaryOneAreasItemOneCreateMin),
  "update": zod.int().min(getTenantDataManagementJobResponseSummaryOneAreasItemOneUpdateMin),
  "delete": zod.int().min(getTenantDataManagementJobResponseSummaryOneAreasItemOneDeleteMin),
  "skip": zod.int().min(getTenantDataManagementJobResponseSummaryOneAreasItemOneSkipMin)
}).and(zod.object({
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules']),
  "label": zod.string()
}))),
  "tables": zod.array(zod.object({
  "create": zod.int().min(getTenantDataManagementJobResponseSummaryOneTablesItemOneCreateMin),
  "update": zod.int().min(getTenantDataManagementJobResponseSummaryOneTablesItemOneUpdateMin),
  "delete": zod.int().min(getTenantDataManagementJobResponseSummaryOneTablesItemOneDeleteMin),
  "skip": zod.int().min(getTenantDataManagementJobResponseSummaryOneTablesItemOneSkipMin)
}).and(zod.object({
  "table": zod.string(),
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])
}))),
  "warnings": zod.array(zod.string())
}),zod.null()]),
  "error": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "downloadReady": zod.boolean()
})


/**
 * Requires tenant.data.manage.
 * @summary Queue a tenant data export
 */
export const createTenantDataExportBodyAreasMax = 7;

export const createTenantDataExportBodyReasonMin = 10;
export const createTenantDataExportBodyReasonMax = 1000;



export const createTenantDataExportBody = zod.object({
  "areas": zod.array(zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])).min(1).max(createTenantDataExportBodyAreasMax),
  "reason": zod.string().min(createTenantDataExportBodyReasonMin).max(createTenantDataExportBodyReasonMax)
})

export const createTenantDataExportResponseSummaryOneAreasItemOneCreateMin = 0;

export const createTenantDataExportResponseSummaryOneAreasItemOneUpdateMin = 0;

export const createTenantDataExportResponseSummaryOneAreasItemOneDeleteMin = 0;

export const createTenantDataExportResponseSummaryOneAreasItemOneSkipMin = 0;

export const createTenantDataExportResponseSummaryOneTablesItemOneCreateMin = 0;

export const createTenantDataExportResponseSummaryOneTablesItemOneUpdateMin = 0;

export const createTenantDataExportResponseSummaryOneTablesItemOneDeleteMin = 0;

export const createTenantDataExportResponseSummaryOneTablesItemOneSkipMin = 0;



export const createTenantDataExportResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "status": zod.enum(['queued', 'running', 'completed', 'failed', 'cancelled', 'awaiting_apply', 'applied']),
  "areas": zod.array(zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])),
  "summary": zod.union([zod.object({
  "areas": zod.array(zod.object({
  "create": zod.int().min(createTenantDataExportResponseSummaryOneAreasItemOneCreateMin),
  "update": zod.int().min(createTenantDataExportResponseSummaryOneAreasItemOneUpdateMin),
  "delete": zod.int().min(createTenantDataExportResponseSummaryOneAreasItemOneDeleteMin),
  "skip": zod.int().min(createTenantDataExportResponseSummaryOneAreasItemOneSkipMin)
}).and(zod.object({
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules']),
  "label": zod.string()
}))),
  "tables": zod.array(zod.object({
  "create": zod.int().min(createTenantDataExportResponseSummaryOneTablesItemOneCreateMin),
  "update": zod.int().min(createTenantDataExportResponseSummaryOneTablesItemOneUpdateMin),
  "delete": zod.int().min(createTenantDataExportResponseSummaryOneTablesItemOneDeleteMin),
  "skip": zod.int().min(createTenantDataExportResponseSummaryOneTablesItemOneSkipMin)
}).and(zod.object({
  "table": zod.string(),
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])
}))),
  "warnings": zod.array(zod.string())
}),zod.null()]),
  "error": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "downloadReady": zod.boolean()
})


/**
 * Requires tenant.data.manage.
 */
export const cancelTenantDataExportParams = zod.object({
  "id": zod.uuid()
})

export const cancelTenantDataExportBodyReasonMin = 8;
export const cancelTenantDataExportBodyReasonMax = 500;



export const cancelTenantDataExportBody = zod.object({
  "reason": zod.string().min(cancelTenantDataExportBodyReasonMin).max(cancelTenantDataExportBodyReasonMax)
})

export const cancelTenantDataExportResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires tenant.data.manage. The archive is streamed through this authenticated endpoint.
 */
export const downloadTenantDataExportParams = zod.object({
  "id": zod.uuid()
})

export const downloadTenantDataExportResponse = zod.unknown()


/**
 * Requires tenant.data.manage. No tenant data is changed.
 * @summary Upload an export ZIP and calculate a dry-run diff
 */
export const createTenantDataImportDryRunBody = zod.object({
  "file": zod.instanceof(Blob)
})

export const createTenantDataImportDryRunResponseSummaryOneAreasItemOneCreateMin = 0;

export const createTenantDataImportDryRunResponseSummaryOneAreasItemOneUpdateMin = 0;

export const createTenantDataImportDryRunResponseSummaryOneAreasItemOneDeleteMin = 0;

export const createTenantDataImportDryRunResponseSummaryOneAreasItemOneSkipMin = 0;

export const createTenantDataImportDryRunResponseSummaryOneTablesItemOneCreateMin = 0;

export const createTenantDataImportDryRunResponseSummaryOneTablesItemOneUpdateMin = 0;

export const createTenantDataImportDryRunResponseSummaryOneTablesItemOneDeleteMin = 0;

export const createTenantDataImportDryRunResponseSummaryOneTablesItemOneSkipMin = 0;



export const createTenantDataImportDryRunResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "status": zod.enum(['queued', 'running', 'completed', 'failed', 'cancelled', 'awaiting_apply', 'applied']),
  "areas": zod.array(zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])),
  "summary": zod.union([zod.object({
  "areas": zod.array(zod.object({
  "create": zod.int().min(createTenantDataImportDryRunResponseSummaryOneAreasItemOneCreateMin),
  "update": zod.int().min(createTenantDataImportDryRunResponseSummaryOneAreasItemOneUpdateMin),
  "delete": zod.int().min(createTenantDataImportDryRunResponseSummaryOneAreasItemOneDeleteMin),
  "skip": zod.int().min(createTenantDataImportDryRunResponseSummaryOneAreasItemOneSkipMin)
}).and(zod.object({
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules']),
  "label": zod.string()
}))),
  "tables": zod.array(zod.object({
  "create": zod.int().min(createTenantDataImportDryRunResponseSummaryOneTablesItemOneCreateMin),
  "update": zod.int().min(createTenantDataImportDryRunResponseSummaryOneTablesItemOneUpdateMin),
  "delete": zod.int().min(createTenantDataImportDryRunResponseSummaryOneTablesItemOneDeleteMin),
  "skip": zod.int().min(createTenantDataImportDryRunResponseSummaryOneTablesItemOneSkipMin)
}).and(zod.object({
  "table": zod.string(),
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])
}))),
  "warnings": zod.array(zod.string())
}),zod.null()]),
  "error": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "downloadReady": zod.boolean()
})


/**
 * Requires tenant.data.manage and exact OVERWRITE confirmation.
 * @summary Apply a reviewed tenant import
 */
export const applyTenantDataImportParams = zod.object({
  "id": zod.uuid()
})

export const applyTenantDataImportBody = zod.object({
  "confirmation": zod.enum(['OVERWRITE'])
})

export const applyTenantDataImportResponseSummaryOneAreasItemOneCreateMin = 0;

export const applyTenantDataImportResponseSummaryOneAreasItemOneUpdateMin = 0;

export const applyTenantDataImportResponseSummaryOneAreasItemOneDeleteMin = 0;

export const applyTenantDataImportResponseSummaryOneAreasItemOneSkipMin = 0;

export const applyTenantDataImportResponseSummaryOneTablesItemOneCreateMin = 0;

export const applyTenantDataImportResponseSummaryOneTablesItemOneUpdateMin = 0;

export const applyTenantDataImportResponseSummaryOneTablesItemOneDeleteMin = 0;

export const applyTenantDataImportResponseSummaryOneTablesItemOneSkipMin = 0;



export const applyTenantDataImportResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "kind": zod.enum(['export', 'import']),
  "status": zod.enum(['queued', 'running', 'completed', 'failed', 'cancelled', 'awaiting_apply', 'applied']),
  "areas": zod.array(zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])),
  "summary": zod.union([zod.object({
  "areas": zod.array(zod.object({
  "create": zod.int().min(applyTenantDataImportResponseSummaryOneAreasItemOneCreateMin),
  "update": zod.int().min(applyTenantDataImportResponseSummaryOneAreasItemOneUpdateMin),
  "delete": zod.int().min(applyTenantDataImportResponseSummaryOneAreasItemOneDeleteMin),
  "skip": zod.int().min(applyTenantDataImportResponseSummaryOneAreasItemOneSkipMin)
}).and(zod.object({
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules']),
  "label": zod.string()
}))),
  "tables": zod.array(zod.object({
  "create": zod.int().min(applyTenantDataImportResponseSummaryOneTablesItemOneCreateMin),
  "update": zod.int().min(applyTenantDataImportResponseSummaryOneTablesItemOneUpdateMin),
  "delete": zod.int().min(applyTenantDataImportResponseSummaryOneTablesItemOneDeleteMin),
  "skip": zod.int().min(applyTenantDataImportResponseSummaryOneTablesItemOneSkipMin)
}).and(zod.object({
  "table": zod.string(),
  "area": zod.enum(['entities_access', 'crm_records', 'content_hub', 'research', 'catalogue', 'custom_pages', 'settings_modules'])
}))),
  "warnings": zod.array(zod.string())
}),zod.null()]),
  "error": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "downloadReady": zod.boolean()
})


/**
 * Returns visible resolved modules. Requires tenant.settings.read.
 */
export const listResolvedTenantModulesResponseTotalMin = 0;



export const listResolvedTenantModulesResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string(),
  "name": zod.string(),
  "description": zod.string(),
  "stage": zod.enum(['available', 'preview', 'deprecated', 'hidden']),
  "enabled": zod.boolean(),
  "locked": zod.boolean(),
  "forcedState": zod.enum(['on', 'off']).nullable(),
  "revision": zod.int().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int().min(listResolvedTenantModulesResponseTotalMin)
})


/**
 * Requires tenant.settings.manage.
 */
export const updateResolvedTenantModulePathKeyMax = 80;


export const updateResolvedTenantModulePathKeyRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');


export const updateResolvedTenantModuleParams = zod.object({
  "key": zod.string().max(updateResolvedTenantModulePathKeyMax).regex(updateResolvedTenantModulePathKeyRegExp)
})

export const updateResolvedTenantModuleBodyReasonMin = 10;
export const updateResolvedTenantModuleBodyReasonMax = 1000;



export const updateResolvedTenantModuleBody = zod.object({
  "enabled": zod.boolean(),
  "reason": zod.string().min(updateResolvedTenantModuleBodyReasonMin).max(updateResolvedTenantModuleBodyReasonMax)
})

export const updateResolvedTenantModuleResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Requires tenant.settings.read.
 */
export const getTenantTypedSettingsResponseBrandingNameMin = 2;
export const getTenantTypedSettingsResponseBrandingNameMax = 120;

export const getTenantTypedSettingsResponseDefaultLocaleRegExp = new RegExp('^[a-z]{2,3}(?:-[A-Z]{2})?$');
export const getTenantTypedSettingsResponseDefaultTimezoneMax = 100;



export const getTenantTypedSettingsResponse = zod.object({
  "brandingName": zod.string().min(getTenantTypedSettingsResponseBrandingNameMin).max(getTenantTypedSettingsResponseBrandingNameMax),
  "defaultLocale": zod.string().regex(getTenantTypedSettingsResponseDefaultLocaleRegExp),
  "defaultTimezone": zod.string().min(1).max(getTenantTypedSettingsResponseDefaultTimezoneMax),
  "notificationSender": zod.email().nullable(),
  "supportContact": zod.email().nullable(),
  "advanced": zod.record(zod.string(), zod.unknown())
})


/**
 * Requires tenant.settings.manage.
 */
export const updateTenantTypedSettingsBodyOneBrandingNameMin = 2;
export const updateTenantTypedSettingsBodyOneBrandingNameMax = 120;

export const updateTenantTypedSettingsBodyOneDefaultLocaleRegExp = new RegExp('^[a-z]{2,3}(?:-[A-Z]{2})?$');
export const updateTenantTypedSettingsBodyOneDefaultTimezoneMax = 100;

export const updateTenantTypedSettingsBodyTwoReasonMin = 10;
export const updateTenantTypedSettingsBodyTwoReasonMax = 1000;



export const updateTenantTypedSettingsBody = zod.object({
  "brandingName": zod.string().min(updateTenantTypedSettingsBodyOneBrandingNameMin).max(updateTenantTypedSettingsBodyOneBrandingNameMax),
  "defaultLocale": zod.string().regex(updateTenantTypedSettingsBodyOneDefaultLocaleRegExp),
  "defaultTimezone": zod.string().min(1).max(updateTenantTypedSettingsBodyOneDefaultTimezoneMax),
  "notificationSender": zod.email().nullable(),
  "supportContact": zod.email().nullable(),
  "advanced": zod.record(zod.string(), zod.unknown())
}).and(zod.object({
  "reason": zod.string().min(updateTenantTypedSettingsBodyTwoReasonMin).max(updateTenantTypedSettingsBodyTwoReasonMax)
}))

export const updateTenantTypedSettingsResponseBrandingNameMin = 2;
export const updateTenantTypedSettingsResponseBrandingNameMax = 120;

export const updateTenantTypedSettingsResponseDefaultLocaleRegExp = new RegExp('^[a-z]{2,3}(?:-[A-Z]{2})?$');
export const updateTenantTypedSettingsResponseDefaultTimezoneMax = 100;



export const updateTenantTypedSettingsResponse = zod.object({
  "brandingName": zod.string().min(updateTenantTypedSettingsResponseBrandingNameMin).max(updateTenantTypedSettingsResponseBrandingNameMax),
  "defaultLocale": zod.string().regex(updateTenantTypedSettingsResponseDefaultLocaleRegExp),
  "defaultTimezone": zod.string().min(1).max(updateTenantTypedSettingsResponseDefaultTimezoneMax),
  "notificationSender": zod.email().nullable(),
  "supportContact": zod.email().nullable(),
  "advanced": zod.record(zod.string(), zod.unknown())
})


/**
 * Requires tenant.settings.read.
 * @summary List the tenant's stored design systems and which tenant or entities use them
 */
export const listDesignSystemsQueryLimitDefault = 25;
export const listDesignSystemsQueryLimitMax = 100;

export const listDesignSystemsQueryOffsetDefault = 0;
export const listDesignSystemsQueryOffsetMin = 0;



export const listDesignSystemsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDesignSystemsQueryLimitMax).default(listDesignSystemsQueryLimitDefault),
  "offset": zod.int().min(listDesignSystemsQueryOffsetMin).default(listDesignSystemsQueryOffsetDefault)
})

export const listDesignSystemsResponseItemsMax = 100;



export const listDesignSystemsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string(),
  "version": zod.string(),
  "status": zod.enum(['ready', 'blocked']),
  "vocabulary": zod.enum(['mui', 'material3', 'mixed']),
  "origin": zod.enum(['upload', 'sample']),
  "darkSource": zod.enum(['explicit', 'derived', 'none']),
  "blockingCount": zod.int(),
  "warningCount": zod.int(),
  "activeForTenant": zod.boolean(),
  "activeEntityIds": zod.array(zod.uuid()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listDesignSystemsResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "tenantActiveId": zod.uuid().nullable(),
  "entityActivations": zod.array(zod.object({
  "entityId": zod.uuid(),
  "entityName": zod.string(),
  "designSystemId": zod.uuid()
})),
  "samples": zod.array(zod.object({
  "id": zod.enum(['platform-default', 'template']),
  "name": zod.string(),
  "description": zod.string()
}))
})


/**
 * Requires tenant.settings.manage. Tokens are validated and contrast-checked; remote references are rejected.
 * @summary Add a W3C design-token document (Material UI or Material Design 3 vocabulary)
 */
export const createDesignSystemBodyNameMax = 120;

export const createDesignSystemBodyDescriptionMax = 1000;

export const createDesignSystemBodyVersionMax = 40;



export const createDesignSystemBody = zod.object({
  "name": zod.string().min(1).max(createDesignSystemBodyNameMax),
  "description": zod.string().max(createDesignSystemBodyDescriptionMax).optional(),
  "version": zod.string().min(1).max(createDesignSystemBodyVersionMax).optional(),
  "tokens": zod.record(zod.string(), zod.unknown()).describe('W3C Design Tokens document (JSON object). Material UI or Material Design 3 vocabulary; optional light and dark groups.')
})

export const createDesignSystemResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string(),
  "version": zod.string(),
  "status": zod.enum(['ready', 'blocked']),
  "vocabulary": zod.enum(['mui', 'material3', 'mixed']),
  "origin": zod.enum(['upload', 'sample']),
  "darkSource": zod.enum(['explicit', 'derived', 'none']),
  "blockingCount": zod.int(),
  "warningCount": zod.int(),
  "activeForTenant": zod.boolean(),
  "activeEntityIds": zod.array(zod.uuid()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "tokensLight": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.'),
  "tokensDark": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.'),
  "report": zod.object({
  "blocking": zod.array(zod.object({
  "pair": zod.string(),
  "foreground": zod.string(),
  "background": zod.string(),
  "mode": zod.enum(['light', 'dark']),
  "ratio": zod.number(),
  "threshold": zod.number()
})),
  "warnings": zod.array(zod.object({
  "pair": zod.string(),
  "foreground": zod.string(),
  "background": zod.string(),
  "mode": zod.enum(['light', 'dark']),
  "ratio": zod.number(),
  "threshold": zod.number()
})),
  "suppliedTokens": zod.array(zod.string()),
  "inheritedFromPlatform": zod.array(zod.string()),
  "unknownTokens": zod.array(zod.string()),
  "ignoredGroups": zod.array(zod.string())
})
}))


/**
 * Requires tenant.settings.manage.
 * @summary Add a built-in sample design system to the tenant library
 */
export const importDesignSystemSampleParams = zod.object({
  "sampleId": zod.enum(['platform-default', 'template'])
})

export const importDesignSystemSampleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string(),
  "version": zod.string(),
  "status": zod.enum(['ready', 'blocked']),
  "vocabulary": zod.enum(['mui', 'material3', 'mixed']),
  "origin": zod.enum(['upload', 'sample']),
  "darkSource": zod.enum(['explicit', 'derived', 'none']),
  "blockingCount": zod.int(),
  "warningCount": zod.int(),
  "activeForTenant": zod.boolean(),
  "activeEntityIds": zod.array(zod.uuid()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "tokensLight": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.'),
  "tokensDark": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.'),
  "report": zod.object({
  "blocking": zod.array(zod.object({
  "pair": zod.string(),
  "foreground": zod.string(),
  "background": zod.string(),
  "mode": zod.enum(['light', 'dark']),
  "ratio": zod.number(),
  "threshold": zod.number()
})),
  "warnings": zod.array(zod.object({
  "pair": zod.string(),
  "foreground": zod.string(),
  "background": zod.string(),
  "mode": zod.enum(['light', 'dark']),
  "ratio": zod.number(),
  "threshold": zod.number()
})),
  "suppliedTokens": zod.array(zod.string()),
  "inheritedFromPlatform": zod.array(zod.string()),
  "unknownTokens": zod.array(zod.string()),
  "ignoredGroups": zod.array(zod.string())
})
}))


/**
 * Requires tenant.settings.manage.
 * @summary Return the tenant to the platform default, or an entity to the tenant choice
 */
export const resetDesignSystemActivationBody = zod.object({
  "entityId": zod.uuid().nullish().describe('Omit or null for the tenant-wide choice.')
})

export const resetDesignSystemActivationResponse = zod.void()


/**
 * Requires tenant.settings.read.
 * @summary Read one design system with its resolved tokens and contrast report
 */
export const getDesignSystemParams = zod.object({
  "designSystemId": zod.uuid()
})

export const getDesignSystemResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string(),
  "version": zod.string(),
  "status": zod.enum(['ready', 'blocked']),
  "vocabulary": zod.enum(['mui', 'material3', 'mixed']),
  "origin": zod.enum(['upload', 'sample']),
  "darkSource": zod.enum(['explicit', 'derived', 'none']),
  "blockingCount": zod.int(),
  "warningCount": zod.int(),
  "activeForTenant": zod.boolean(),
  "activeEntityIds": zod.array(zod.uuid()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "tokensLight": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.'),
  "tokensDark": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.'),
  "report": zod.object({
  "blocking": zod.array(zod.object({
  "pair": zod.string(),
  "foreground": zod.string(),
  "background": zod.string(),
  "mode": zod.enum(['light', 'dark']),
  "ratio": zod.number(),
  "threshold": zod.number()
})),
  "warnings": zod.array(zod.object({
  "pair": zod.string(),
  "foreground": zod.string(),
  "background": zod.string(),
  "mode": zod.enum(['light', 'dark']),
  "ratio": zod.number(),
  "threshold": zod.number()
})),
  "suppliedTokens": zod.array(zod.string()),
  "inheritedFromPlatform": zod.array(zod.string()),
  "unknownTokens": zod.array(zod.string()),
  "ignoredGroups": zod.array(zod.string())
})
}))


/**
 * Requires tenant.settings.manage.
 * @summary Rename or re-describe a design system (tokens are immutable; add a new version instead)
 */
export const updateDesignSystemParams = zod.object({
  "designSystemId": zod.uuid()
})

export const updateDesignSystemBodyNameMax = 120;

export const updateDesignSystemBodyDescriptionMax = 1000;

export const updateDesignSystemBodyVersionMax = 40;



export const updateDesignSystemBody = zod.object({
  "name": zod.string().min(1).max(updateDesignSystemBodyNameMax).optional(),
  "description": zod.string().max(updateDesignSystemBodyDescriptionMax).optional(),
  "version": zod.string().min(1).max(updateDesignSystemBodyVersionMax).optional()
})

export const updateDesignSystemResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string(),
  "version": zod.string(),
  "status": zod.enum(['ready', 'blocked']),
  "vocabulary": zod.enum(['mui', 'material3', 'mixed']),
  "origin": zod.enum(['upload', 'sample']),
  "darkSource": zod.enum(['explicit', 'derived', 'none']),
  "blockingCount": zod.int(),
  "warningCount": zod.int(),
  "activeForTenant": zod.boolean(),
  "activeEntityIds": zod.array(zod.uuid()),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "tokensLight": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.'),
  "tokensDark": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.'),
  "report": zod.object({
  "blocking": zod.array(zod.object({
  "pair": zod.string(),
  "foreground": zod.string(),
  "background": zod.string(),
  "mode": zod.enum(['light', 'dark']),
  "ratio": zod.number(),
  "threshold": zod.number()
})),
  "warnings": zod.array(zod.object({
  "pair": zod.string(),
  "foreground": zod.string(),
  "background": zod.string(),
  "mode": zod.enum(['light', 'dark']),
  "ratio": zod.number(),
  "threshold": zod.number()
})),
  "suppliedTokens": zod.array(zod.string()),
  "inheritedFromPlatform": zod.array(zod.string()),
  "unknownTokens": zod.array(zod.string()),
  "ignoredGroups": zod.array(zod.string())
})
}))


/**
 * Requires tenant.settings.manage.
 * @summary Delete a design system; anything using it falls back to the next level
 */
export const deleteDesignSystemParams = zod.object({
  "designSystemId": zod.uuid()
})

export const deleteDesignSystemResponse = zod.void()


/**
 * Requires tenant.settings.read.
 * @summary Export a design system as a normalised Material UI token document
 */
export const exportDesignSystemParams = zod.object({
  "designSystemId": zod.uuid()
})

export const exportDesignSystemResponse = zod.object({
  "fileName": zod.string(),
  "document": zod.record(zod.string(), zod.unknown())
})


/**
 * Requires tenant.settings.manage. Design systems with blocking contrast issues cannot be activated.
 * @summary Use a ready design system for the tenant, or for one entity
 */
export const activateDesignSystemParams = zod.object({
  "designSystemId": zod.uuid()
})

export const activateDesignSystemBody = zod.object({
  "entityId": zod.uuid().nullish().describe('Omit or null for the tenant-wide choice.')
})

export const activateDesignSystemResponse = zod.void()


/**
 * Resolution order is entity, then tenant, then the platform default.
 * @summary Design-system variables for the signed-in staff member's selected entity
 */
export const getResolvedBrandingResponse = zod.object({
  "source": zod.enum(['entity', 'tenant', 'platform']),
  "designSystemId": zod.uuid().nullable(),
  "name": zod.string().nullable(),
  "light": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.'),
  "dark": zod.record(zod.string(), zod.string()).describe('Canonical CSS variable name (for example --primary) to a validated CSS value.')
})


/**
 * @summary List active tenant/entity contexts available to the signed-in user
 */
export const listAccessContextsQueryLimitDefault = 50;
export const listAccessContextsQueryLimitMax = 100;

export const listAccessContextsQueryOffsetDefault = 0;
export const listAccessContextsQueryOffsetMin = 0;



export const listAccessContextsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listAccessContextsQueryLimitMax).default(listAccessContextsQueryLimitDefault),
  "offset": zod.int().min(listAccessContextsQueryOffsetMin).default(listAccessContextsQueryOffsetDefault)
})

export const listAccessContextsResponseOneTenantsItemTwoEntityTotalMin = 0;

export const listAccessContextsResponseOneTenantTotalMin = 0;

export const listAccessContextsResponseOneHierarchyTotalMin = 0;

export const listAccessContextsResponseOneEligibleRoleTotalMin = 0;

export const listAccessContextsResponseOneActiveElevationTotalMin = 0;

export const listAccessContextsResponseOneActiveSupportSessionTotalMin = 0;

export const listAccessContextsResponseTwoTotalMin = 0;


export const listAccessContextsResponseTwoOffsetMin = 0;



export const listAccessContextsResponse = zod.object({
  "platformPermissions": zod.array(zod.string()),
  "platformRoles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "source": zod.enum(['direct', 'group', 'entra', 'elevation']).optional(),
  "groupName": zod.string().nullish()
})),
  "isPlatformAdmin": zod.boolean(),
  "tenants": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "vanityAlias": zod.string().optional(),
  "status": zod.enum(['active', 'suspended', 'archived', 'transferring'])
}).and(zod.object({
  "permissions": zod.array(zod.string()).optional(),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "source": zod.enum(['direct', 'group', 'entra', 'elevation']).optional(),
  "groupName": zod.string().nullish()
})),
  "entities": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "status": zod.string(),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "source": zod.enum(['direct', 'group', 'entra', 'elevation']).optional(),
  "groupName": zod.string().nullish()
}))
})),
  "entityTotal": zod.int().min(listAccessContextsResponseOneTenantsItemTwoEntityTotalMin)
}))),
  "tenantTotal": zod.int().min(listAccessContextsResponseOneTenantTotalMin),
  "hierarchyTotal": zod.int().min(listAccessContextsResponseOneHierarchyTotalMin),
  "eligibleRoles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "source": zod.enum(['direct', 'group', 'entra', 'elevation']).optional(),
  "groupName": zod.string().nullish()
}).and(zod.object({
  "eligibleAssignmentId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}))),
  "eligibleRoleTotal": zod.int().min(listAccessContextsResponseOneEligibleRoleTotalMin),
  "activeElevations": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleId": zod.uuid(),
  "roleName": zod.string(),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "activatedAt": zod.iso.datetime({"offset":true})
})),
  "activeElevationTotal": zod.int().min(listAccessContextsResponseOneActiveElevationTotalMin),
  "activeSupportSessions": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "permissionKey": zod.string(),
  "permissionKeys": zod.array(zod.string()).optional(),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "activeSupportSessionTotal": zod.int().min(listAccessContextsResponseOneActiveSupportSessionTotalMin)
}).describe('Identity access independent of the selected entity. Collections use limit/offset and report their own totals. Tenants and nested entities are grouped from a flattened tenant/entity page; hierarchyTotal counts those entries.').and(zod.object({
  "items": zod.array(zod.object({
  "tenantId": zod.uuid(),
  "tenantName": zod.string(),
  "entityId": zod.uuid(),
  "entityName": zod.string()
})),
  "total": zod.int().min(listAccessContextsResponseTwoTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listAccessContextsResponseTwoOffsetMin)
}))


/**
 * @summary Resolve the selected active context and effective permissions
 */
export const getAccessContextResponseOneTenantsItemTwoEntityTotalMin = 0;

export const getAccessContextResponseOneTenantTotalMin = 0;

export const getAccessContextResponseOneHierarchyTotalMin = 0;

export const getAccessContextResponseOneEligibleRoleTotalMin = 0;

export const getAccessContextResponseOneActiveElevationTotalMin = 0;

export const getAccessContextResponseOneActiveSupportSessionTotalMin = 0;



export const getAccessContextResponse = zod.object({
  "platformPermissions": zod.array(zod.string()),
  "platformRoles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "source": zod.enum(['direct', 'group', 'entra', 'elevation']).optional(),
  "groupName": zod.string().nullish()
})),
  "isPlatformAdmin": zod.boolean(),
  "tenants": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "vanityAlias": zod.string().optional(),
  "status": zod.enum(['active', 'suspended', 'archived', 'transferring'])
}).and(zod.object({
  "permissions": zod.array(zod.string()).optional(),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "source": zod.enum(['direct', 'group', 'entra', 'elevation']).optional(),
  "groupName": zod.string().nullish()
})),
  "entities": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "status": zod.string(),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "source": zod.enum(['direct', 'group', 'entra', 'elevation']).optional(),
  "groupName": zod.string().nullish()
}))
})),
  "entityTotal": zod.int().min(getAccessContextResponseOneTenantsItemTwoEntityTotalMin)
}))),
  "tenantTotal": zod.int().min(getAccessContextResponseOneTenantTotalMin),
  "hierarchyTotal": zod.int().min(getAccessContextResponseOneHierarchyTotalMin),
  "eligibleRoles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "source": zod.enum(['direct', 'group', 'entra', 'elevation']).optional(),
  "groupName": zod.string().nullish()
}).and(zod.object({
  "eligibleAssignmentId": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
}))),
  "eligibleRoleTotal": zod.int().min(getAccessContextResponseOneEligibleRoleTotalMin),
  "activeElevations": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid().nullable(),
  "entityId": zod.uuid().nullable(),
  "roleId": zod.uuid(),
  "roleName": zod.string(),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "activatedAt": zod.iso.datetime({"offset":true})
})),
  "activeElevationTotal": zod.int().min(getAccessContextResponseOneActiveElevationTotalMin),
  "activeSupportSessions": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable(),
  "permissionKey": zod.string(),
  "permissionKeys": zod.array(zod.string()).optional(),
  "reason": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "activeSupportSessionTotal": zod.int().min(getAccessContextResponseOneActiveSupportSessionTotalMin)
}).describe('Identity access independent of the selected entity. Collections use limit/offset and report their own totals. Tenants and nested entities are grouped from a flattened tenant/entity page; hierarchyTotal counts those entries.').and(zod.object({
  "tenantId": zod.uuid(),
  "tenantName": zod.string(),
  "entityId": zod.uuid(),
  "entityName": zod.string()
})).and(zod.object({
  "logoAssetId": zod.uuid().nullable(),
  "permissions": zod.array(zod.string()),
  "enabledModules": zod.array(zod.string()),
  "featureStages": zod.record(zod.string(), zod.enum(['available', 'preview', 'deprecated', 'hidden'])).optional().describe('Lifecycle metadata for enabled modules; preview is displayed as Frontier.'),
  "authorizationRevision": zod.string(),
  "viaOverride": zod.boolean()
}))


/**
 * @summary Download the active entity logo for an authorized entity reader
 */
export const getAccessContextLogoResponse = zod.unknown()


/**
 * @summary Get the selected tenant/entity access administration view
 */
export const getAccessAdministrationQueryLimitDefault = 25;
export const getAccessAdministrationQueryLimitMax = 100;

export const getAccessAdministrationQueryOffsetDefault = 0;
export const getAccessAdministrationQueryOffsetMin = 0;



export const getAccessAdministrationQueryParams = zod.object({
  "limit": zod.int().min(1).max(getAccessAdministrationQueryLimitMax).default(getAccessAdministrationQueryLimitDefault),
  "offset": zod.int().min(getAccessAdministrationQueryOffsetMin).default(getAccessAdministrationQueryOffsetDefault)
})

export const getAccessAdministrationResponseMemberTotalMin = 0;

export const getAccessAdministrationResponseInvitationTotalMin = 0;




export const getAccessAdministrationResponseOffsetMin = 0;



export const getAccessAdministrationResponse = zod.object({
  "tenant": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "vanityAlias": zod.string().optional(),
  "status": zod.enum(['active', 'suspended', 'archived', 'transferring'])
}),
  "entity": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "vanityAlias": zod.string().optional(),
  "status": zod.enum(['active', 'suspended', 'archived', 'transferring'])
}),
  "permissions": zod.array(zod.string()),
  "members": zod.array(zod.object({
  "id": zod.uuid(),
  "membershipId": zod.uuid(),
  "displayName": zod.string(),
  "email": zod.string().nullable(),
  "legacyRole": zod.enum(['staff', 'admin']).describe('Database-backed application role stored on app_users.'),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['tenant', 'entity']),
  "permissions": zod.array(zod.string()),
  "canonical": zod.boolean()
})),
  "hasEntityAccess": zod.boolean(),
  "membershipStatus": zod.enum(['active', 'suspended', 'revoked']),
  "grantId": zod.uuid().nullish(),
  "grantExpiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "grantedBy": zod.string().nullish(),
  "grantedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastActiveAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "memberTotal": zod.int().min(getAccessAdministrationResponseMemberTotalMin),
  "invitations": zod.array(zod.object({
  "id": zod.uuid(),
  "email": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'revoked', 'expired']),
  "roleDefinitionId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "invitationTotal": zod.int().min(getAccessAdministrationResponseInvitationTotalMin),
  "roles": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "name": zod.string(),
  "scope": zod.enum(['tenant', 'entity']),
  "permissions": zod.array(zod.string()),
  "canonical": zod.boolean()
})),
  "settings": zod.array(zod.object({
  "key": zod.string(),
  "value": zod.unknown(),
  "revision": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "modules": zod.array(zod.object({
  "key": zod.string(),
  "enabled": zod.boolean(),
  "revision": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getAccessAdministrationResponseOffsetMin)
})


/**
 * @summary Invite a person to the selected tenant and entity
 */
export const createAccessInvitationBodyEmailMax = 320;



export const createAccessInvitationBody = zod.object({
  "email": zod.email().max(createAccessInvitationBodyEmailMax),
  "roleDefinitionId": zod.uuid(),
  "expiresAt": zod.iso.datetime({"offset":true})
})

export const createAccessInvitationResponseTokenMin = 32;



export const createAccessInvitationResponse = zod.object({
  "id": zod.uuid(),
  "token": zod.string().min(createAccessInvitationResponseTokenMin)
})


/**
 * @summary Revoke a pending invitation
 */
export const revokeAccessInvitationParams = zod.object({
  "id": zod.uuid()
})

export const revokeAccessInvitationBodyReasonMin = 8;
export const revokeAccessInvitationBodyReasonMax = 500;



export const revokeAccessInvitationBody = zod.object({
  "reason": zod.string().min(revokeAccessInvitationBodyReasonMin).max(revokeAccessInvitationBodyReasonMax)
})

export const revokeAccessInvitationResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Accept an email-bound invitation as the signed-in identity
 */
export const acceptAccessInvitationBodyTokenMin = 32;
export const acceptAccessInvitationBodyTokenMax = 512;



export const acceptAccessInvitationBody = zod.object({
  "token": zod.string().min(acceptAccessInvitationBodyTokenMin).max(acceptAccessInvitationBodyTokenMax)
})

export const acceptAccessInvitationResponse = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid().nullable()
})


/**
 * @summary Grant a tenant member access to the selected entity
 */
export const grantAccessMemberEntityParams = zod.object({
  "id": zod.uuid()
})

export const grantAccessMemberEntityBody = zod.object({
  "roleDefinitionId": zod.uuid().optional()
})

export const grantAccessMemberEntityResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Revoke a tenant member's access to the selected entity
 */
export const revokeAccessMemberEntityParams = zod.object({
  "id": zod.uuid()
})

export const revokeAccessMemberEntityBodyReasonMin = 8;
export const revokeAccessMemberEntityBodyReasonMax = 500;



export const revokeAccessMemberEntityBody = zod.object({
  "reason": zod.string().min(revokeAccessMemberEntityBodyReasonMin).max(revokeAccessMemberEntityBodyReasonMax)
})

export const revokeAccessMemberEntityResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Revoke tenant membership, roles, and grants atomically
 */
export const revokeAccessMemberParams = zod.object({
  "id": zod.uuid()
})

export const revokeAccessMemberBodyReasonMin = 8;
export const revokeAccessMemberBodyReasonMax = 500;



export const revokeAccessMemberBody = zod.object({
  "reason": zod.string().min(revokeAccessMemberBodyReasonMin).max(revokeAccessMemberBodyReasonMax)
})

export const revokeAccessMemberResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Set the canonical owner or entity-manager role
 */
export const setAccessMemberRoleParams = zod.object({
  "id": zod.uuid()
})

export const setAccessMemberRoleBody = zod.object({
  "role": zod.enum(['staff', 'admin']).describe('Database-backed application role stored on app_users.')
})

export const setAccessMemberRoleResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Update the selected tenant profile
 */
export const updateAccessTenantProfileBodyNameMax = 200;



export const updateAccessTenantProfileBody = zod.object({
  "name": zod.string().min(1).max(updateAccessTenantProfileBodyNameMax)
})

export const updateAccessTenantProfileResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Update the selected entity profile
 */
export const updateAccessEntityProfileBodyNameMax = 200;



export const updateAccessEntityProfileBody = zod.object({
  "name": zod.string().min(1).max(updateAccessEntityProfileBodyNameMax)
})

export const updateAccessEntityProfileResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Save a selected-tenant setting
 */
export const setAccessTenantSettingPathKeyMax = 100;


export const setAccessTenantSettingPathKeyRegExp = new RegExp('^[a-z][a-z0-9._-]*$');


export const setAccessTenantSettingParams = zod.object({
  "key": zod.string().max(setAccessTenantSettingPathKeyMax).regex(setAccessTenantSettingPathKeyRegExp)
})

export const setAccessTenantSettingBody = zod.object({
  "value": zod.unknown()
})

export const setAccessTenantSettingResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * @summary Enable or disable a selected-tenant module
 */
export const setAccessTenantModulePathKeyMax = 100;


export const setAccessTenantModulePathKeyRegExp = new RegExp('^[a-z][a-z0-9._-]*$');


export const setAccessTenantModuleParams = zod.object({
  "key": zod.string().max(setAccessTenantModulePathKeyMax).regex(setAccessTenantModulePathKeyRegExp)
})

export const setAccessTenantModuleBody = zod.object({
  "enabled": zod.boolean()
})

export const setAccessTenantModuleResponse = zod.object({
  "ok": zod.boolean()
})


/**
 * Tenant auditors may query their tenant; entity managers must provide the currently selected entityId.
 * @summary List immutable access and security audit events for the selected tenant or managed entity
 */
export const listAccessAuditQueryActionMax = 150;

export const listAccessAuditQueryTargetTypeMax = 150;

export const listAccessAuditQueryTargetIdMax = 200;

export const listAccessAuditQueryActorMax = 200;

export const listAccessAuditQueryLimitDefault = 25;
export const listAccessAuditQueryLimitMax = 100;

export const listAccessAuditQueryOffsetDefault = 0;
export const listAccessAuditQueryOffsetMin = 0;



export const listAccessAuditQueryParams = zod.object({
  "action": zod.string().max(listAccessAuditQueryActionMax).optional(),
  "targetType": zod.string().max(listAccessAuditQueryTargetTypeMax).optional(),
  "targetId": zod.string().max(listAccessAuditQueryTargetIdMax).optional(),
  "outcome": zod.enum(['succeeded', 'denied', 'failed']).optional(),
  "actor": zod.string().max(listAccessAuditQueryActorMax).optional(),
  "entityId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAccessAuditQueryLimitMax).default(listAccessAuditQueryLimitDefault),
  "offset": zod.int().min(listAccessAuditQueryOffsetMin).default(listAccessAuditQueryOffsetDefault)
})

export const listAccessAuditResponseTotalMin = 0;


export const listAccessAuditResponseOffsetMin = 0;



export const listAccessAuditResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "action": zod.string(),
  "targetType": zod.string(),
  "targetId": zod.string().nullish(),
  "actorName": zod.string().nullish(),
  "outcome": zod.enum(['succeeded', 'denied', 'failed']),
  "reason": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAccessAuditResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listAccessAuditResponseOffsetMin)
})


/**
 * @summary List published global custom pages for staff navigation
 */
export const listCustomPagesResponseWidgetCountMin = 0;



export const listCustomPagesResponseItem = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "icon": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isPublished": zod.boolean(),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "widgetCount": zod.int().min(listCustomPagesResponseWidgetCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
export const listCustomPagesResponse = zod.array(listCustomPagesResponseItem)


/**
 * @summary Get a published global custom page and its widgets by slug
 */
export const getCustomPagePathSlugMax = 120;


export const getCustomPagePathSlugRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');


export const getCustomPageParams = zod.object({
  "slug": zod.string().min(1).max(getCustomPagePathSlugMax).regex(getCustomPagePathSlugRegExp)
})

export const getCustomPageResponseOneWidgetCountMin = 0;

export const getCustomPageResponseTwoWidgetsItemWidthMax = 12;



export const getCustomPageResponse = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "icon": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isPublished": zod.boolean(),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "widgetCount": zod.int().min(getCustomPageResponseOneWidgetCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "widgets": zod.array(zod.object({
  "id": zod.uuid(),
  "pageId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().nullish(),
  "config": zod.record(zod.string(), zod.unknown()),
  "position": zod.int(),
  "width": zod.int().min(1).max(getCustomPageResponseTwoWidgetsItemWidthMax),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))


/**
 * @summary List all global custom pages including drafts (admin only)
 */
export const listAdminCustomPagesResponseWidgetCountMin = 0;



export const listAdminCustomPagesResponseItem = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "icon": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isPublished": zod.boolean(),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "widgetCount": zod.int().min(listAdminCustomPagesResponseWidgetCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
export const listAdminCustomPagesResponse = zod.array(listAdminCustomPagesResponseItem)


/**
 * @summary Create a global custom page (admin only)
 */
export const createAdminCustomPageBodySlugMax = 120;


export const createAdminCustomPageBodySlugRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
export const createAdminCustomPageBodyTitleMax = 300;

export const createAdminCustomPageBodyDescriptionMax = 5000;

export const createAdminCustomPageBodyIconMax = 100;

export const createAdminCustomPageBodySortOrderMin = 0;



export const createAdminCustomPageBody = zod.object({
  "slug": zod.string().min(1).max(createAdminCustomPageBodySlugMax).regex(createAdminCustomPageBodySlugRegExp),
  "title": zod.string().min(1).max(createAdminCustomPageBodyTitleMax),
  "description": zod.string().max(createAdminCustomPageBodyDescriptionMax).nullish(),
  "icon": zod.string().max(createAdminCustomPageBodyIconMax).nullish(),
  "sortOrder": zod.int().min(createAdminCustomPageBodySortOrderMin).optional(),
  "isPublished": zod.boolean().optional()
})

export const createAdminCustomPageResponseOneWidgetCountMin = 0;

export const createAdminCustomPageResponseTwoWidgetsItemWidthMax = 12;



export const createAdminCustomPageResponse = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "icon": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isPublished": zod.boolean(),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "widgetCount": zod.int().min(createAdminCustomPageResponseOneWidgetCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "widgets": zod.array(zod.object({
  "id": zod.uuid(),
  "pageId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().nullish(),
  "config": zod.record(zod.string(), zod.unknown()),
  "position": zod.int(),
  "width": zod.int().min(1).max(createAdminCustomPageResponseTwoWidgetsItemWidthMax),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))


/**
 * @summary Get a global custom page and its widgets including drafts (admin only)
 */
export const getAdminCustomPageParams = zod.object({
  "id": zod.uuid()
})

export const getAdminCustomPageResponseOneWidgetCountMin = 0;

export const getAdminCustomPageResponseTwoWidgetsItemWidthMax = 12;



export const getAdminCustomPageResponse = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "icon": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isPublished": zod.boolean(),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "widgetCount": zod.int().min(getAdminCustomPageResponseOneWidgetCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "widgets": zod.array(zod.object({
  "id": zod.uuid(),
  "pageId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().nullish(),
  "config": zod.record(zod.string(), zod.unknown()),
  "position": zod.int(),
  "width": zod.int().min(1).max(getAdminCustomPageResponseTwoWidgetsItemWidthMax),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))


/**
 * @summary Update page metadata, publication state, or display order (admin only)
 */
export const updateAdminCustomPageParams = zod.object({
  "id": zod.uuid()
})

export const updateAdminCustomPageBodySlugMax = 120;


export const updateAdminCustomPageBodySlugRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
export const updateAdminCustomPageBodyTitleMax = 300;

export const updateAdminCustomPageBodyDescriptionMax = 5000;

export const updateAdminCustomPageBodyIconMax = 100;

export const updateAdminCustomPageBodySortOrderMin = 0;



export const updateAdminCustomPageBody = zod.object({
  "slug": zod.string().min(1).max(updateAdminCustomPageBodySlugMax).regex(updateAdminCustomPageBodySlugRegExp).optional(),
  "title": zod.string().min(1).max(updateAdminCustomPageBodyTitleMax).optional(),
  "description": zod.string().max(updateAdminCustomPageBodyDescriptionMax).nullish(),
  "icon": zod.string().max(updateAdminCustomPageBodyIconMax).nullish(),
  "sortOrder": zod.int().min(updateAdminCustomPageBodySortOrderMin).optional(),
  "isPublished": zod.boolean().optional()
})

export const updateAdminCustomPageResponseOneWidgetCountMin = 0;

export const updateAdminCustomPageResponseTwoWidgetsItemWidthMax = 12;



export const updateAdminCustomPageResponse = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "icon": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isPublished": zod.boolean(),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "widgetCount": zod.int().min(updateAdminCustomPageResponseOneWidgetCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "widgets": zod.array(zod.object({
  "id": zod.uuid(),
  "pageId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().nullish(),
  "config": zod.record(zod.string(), zod.unknown()),
  "position": zod.int(),
  "width": zod.int().min(1).max(updateAdminCustomPageResponseTwoWidgetsItemWidthMax),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))


/**
 * @summary Delete a page and only its widget configuration (admin only)
 */
export const deleteAdminCustomPageParams = zod.object({
  "id": zod.uuid()
})

export const deleteAdminCustomPageResponse = zod.void()


/**
 * @summary Add a widget to a global custom page (admin only)
 */
export const createAdminCustomPageWidgetParams = zod.object({
  "id": zod.uuid()
})

export const createAdminCustomPageWidgetBodyTitleMax = 300;

export const createAdminCustomPageWidgetBodyPositionMin = 0;



export const createAdminCustomPageWidgetBody = zod.object({
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().max(createAdminCustomPageWidgetBodyTitleMax).nullish(),
  "config": zod.record(zod.string(), zod.unknown()).optional(),
  "position": zod.int().min(createAdminCustomPageWidgetBodyPositionMin).optional(),
  "width": zod.union([zod.literal(6),zod.literal(12)]).optional()
})

export const createAdminCustomPageWidgetResponseWidthMax = 12;



export const createAdminCustomPageWidgetResponse = zod.object({
  "id": zod.uuid(),
  "pageId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().nullish(),
  "config": zod.record(zod.string(), zod.unknown()),
  "position": zod.int(),
  "width": zod.int().min(1).max(createAdminCustomPageWidgetResponseWidthMax),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Edit, resize, or reposition a page widget (admin only)
 */
export const updateAdminCustomPageWidgetParams = zod.object({
  "id": zod.uuid(),
  "widgetId": zod.uuid()
})

export const updateAdminCustomPageWidgetBodyTitleMax = 300;

export const updateAdminCustomPageWidgetBodyPositionMin = 0;



export const updateAdminCustomPageWidgetBody = zod.object({
  "title": zod.string().max(updateAdminCustomPageWidgetBodyTitleMax).nullish(),
  "config": zod.record(zod.string(), zod.unknown()).optional(),
  "position": zod.int().min(updateAdminCustomPageWidgetBodyPositionMin).optional(),
  "width": zod.union([zod.literal(6),zod.literal(12)]).optional()
})

export const updateAdminCustomPageWidgetResponseWidthMax = 12;



export const updateAdminCustomPageWidgetResponse = zod.object({
  "id": zod.uuid(),
  "pageId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().nullish(),
  "config": zod.record(zod.string(), zod.unknown()),
  "position": zod.int(),
  "width": zod.int().min(1).max(updateAdminCustomPageWidgetResponseWidthMax),
  "scope": zod.enum(['global', 'user']),
  "ownerUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Remove a page widget (admin only)
 */
export const deleteAdminCustomPageWidgetParams = zod.object({
  "id": zod.uuid(),
  "widgetId": zod.uuid()
})

export const deleteAdminCustomPageWidgetResponse = zod.void()


/**
 * @summary List all events with RSVP and code counts (admin only)
 */
export const listAdminEventsResponseItem = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "status": zod.enum(['draft', 'published', 'archived']),
  "dateLabel": zod.string().nullish(),
  "startsAt": zod.iso.datetime({"offset":true}).nullish(),
  "rsvpCount": zod.int(),
  "codeCount": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
export const listAdminEventsResponse = zod.array(listAdminEventsResponseItem)


/**
 * @summary Create a new event (admin only)
 */
export const createAdminEventBodySlugMax = 120;


export const createAdminEventBodySlugRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
export const createAdminEventBodyTitleMax = 300;

export const createAdminEventBodyDescriptionMax = 5000;

export const createAdminEventBodyHeroBadgeMax = 200;

export const createAdminEventBodyHeroHeadlineMax = 300;

export const createAdminEventBodyHeroSubheadingMax = 1000;

export const createAdminEventBodyDateLabelMax = 200;

export const createAdminEventBodyTimeLabelMax = 200;

export const createAdminEventBodyTimezoneMax = 100;

export const createAdminEventBodyRsvpDeadlineLabelMax = 200;


export const createAdminEventBodyVenueNameMax = 300;

export const createAdminEventBodyVenueRoomMax = 300;

export const createAdminEventBodyVenueAddressMax = 500;

export const createAdminEventBodyVenueWebsiteMax = 500;

export const createAdminEventBodyVenueMapsUrlMax = 1000;

export const createAdminEventBodyLivestreamUrlMax = 1000;



export const createAdminEventBody = zod.object({
  "slug": zod.string().min(1).max(createAdminEventBodySlugMax).regex(createAdminEventBodySlugRegExp),
  "title": zod.string().min(1).max(createAdminEventBodyTitleMax),
  "description": zod.string().max(createAdminEventBodyDescriptionMax).nullish(),
  "status": zod.enum(['draft', 'published', 'archived']).optional(),
  "heroBadge": zod.string().max(createAdminEventBodyHeroBadgeMax).nullish(),
  "heroHeadline": zod.string().max(createAdminEventBodyHeroHeadlineMax).nullish(),
  "heroSubheading": zod.string().max(createAdminEventBodyHeroSubheadingMax).nullish(),
  "dateLabel": zod.string().max(createAdminEventBodyDateLabelMax).nullish(),
  "timeLabel": zod.string().max(createAdminEventBodyTimeLabelMax).nullish(),
  "timezone": zod.string().max(createAdminEventBodyTimezoneMax).nullish(),
  "rsvpDeadlineLabel": zod.string().max(createAdminEventBodyRsvpDeadlineLabelMax).nullish(),
  "startsAt": zod.iso.datetime({"offset":true}).nullish(),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "capacity": zod.int().min(1).nullish(),
  "venueName": zod.string().max(createAdminEventBodyVenueNameMax).nullish(),
  "venueRoom": zod.string().max(createAdminEventBodyVenueRoomMax).nullish(),
  "venueAddress": zod.string().max(createAdminEventBodyVenueAddressMax).nullish(),
  "venueWebsite": zod.string().max(createAdminEventBodyVenueWebsiteMax).nullish(),
  "venueMapsUrl": zod.string().max(createAdminEventBodyVenueMapsUrlMax).nullish(),
  "livestreamUrl": zod.string().max(createAdminEventBodyLivestreamUrlMax).nullish()
})

export const createAdminEventResponse = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "status": zod.enum(['draft', 'published', 'archived']),
  "heroBadge": zod.string().nullish(),
  "heroHeadline": zod.string().nullish(),
  "heroSubheading": zod.string().nullish(),
  "dateLabel": zod.string().nullish(),
  "timeLabel": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "rsvpDeadlineLabel": zod.string().nullish(),
  "startsAt": zod.iso.datetime({"offset":true}).nullish(),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "capacity": zod.int().nullish(),
  "venueName": zod.string().nullish(),
  "venueRoom": zod.string().nullish(),
  "venueAddress": zod.string().nullish(),
  "venueWebsite": zod.string().nullish(),
  "venueMapsUrl": zod.string().nullish(),
  "livestreamUrl": zod.string().nullish(),
  "agenda": zod.array(zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "timeLabel": zod.string(),
  "title": zod.string(),
  "speaker": zod.string().nullish(),
  "speakerRole": zod.string().nullish()
})),
  "speakers": zod.array(zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "name": zod.string(),
  "role": zod.string().nullish(),
  "blurb": zod.string().nullish(),
  "photoUrl": zod.string().nullish()
})),
  "invitationCodes": zod.array(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "label": zod.string().nullish(),
  "isActive": zod.boolean(),
  "maxUses": zod.int().nullish(),
  "useCount": zod.int(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get an event with agenda, speakers, and invitation codes (admin only)
 */
export const getAdminEventParams = zod.object({
  "id": zod.uuid()
})

export const getAdminEventResponse = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "status": zod.enum(['draft', 'published', 'archived']),
  "heroBadge": zod.string().nullish(),
  "heroHeadline": zod.string().nullish(),
  "heroSubheading": zod.string().nullish(),
  "dateLabel": zod.string().nullish(),
  "timeLabel": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "rsvpDeadlineLabel": zod.string().nullish(),
  "startsAt": zod.iso.datetime({"offset":true}).nullish(),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "capacity": zod.int().nullish(),
  "venueName": zod.string().nullish(),
  "venueRoom": zod.string().nullish(),
  "venueAddress": zod.string().nullish(),
  "venueWebsite": zod.string().nullish(),
  "venueMapsUrl": zod.string().nullish(),
  "livestreamUrl": zod.string().nullish(),
  "agenda": zod.array(zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "timeLabel": zod.string(),
  "title": zod.string(),
  "speaker": zod.string().nullish(),
  "speakerRole": zod.string().nullish()
})),
  "speakers": zod.array(zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "name": zod.string(),
  "role": zod.string().nullish(),
  "blurb": zod.string().nullish(),
  "photoUrl": zod.string().nullish()
})),
  "invitationCodes": zod.array(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "label": zod.string().nullish(),
  "isActive": zod.boolean(),
  "maxUses": zod.int().nullish(),
  "useCount": zod.int(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update event details, venue, hero content, or status (admin only)
 */
export const updateAdminEventParams = zod.object({
  "id": zod.uuid()
})

export const updateAdminEventBodySlugMax = 120;


export const updateAdminEventBodySlugRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');
export const updateAdminEventBodyTitleMax = 300;

export const updateAdminEventBodyDescriptionMax = 5000;

export const updateAdminEventBodyHeroBadgeMax = 200;

export const updateAdminEventBodyHeroHeadlineMax = 300;

export const updateAdminEventBodyHeroSubheadingMax = 1000;

export const updateAdminEventBodyDateLabelMax = 200;

export const updateAdminEventBodyTimeLabelMax = 200;

export const updateAdminEventBodyTimezoneMax = 100;

export const updateAdminEventBodyRsvpDeadlineLabelMax = 200;


export const updateAdminEventBodyVenueNameMax = 300;

export const updateAdminEventBodyVenueRoomMax = 300;

export const updateAdminEventBodyVenueAddressMax = 500;

export const updateAdminEventBodyVenueWebsiteMax = 500;

export const updateAdminEventBodyVenueMapsUrlMax = 1000;

export const updateAdminEventBodyLivestreamUrlMax = 1000;



export const updateAdminEventBody = zod.object({
  "slug": zod.string().min(1).max(updateAdminEventBodySlugMax).regex(updateAdminEventBodySlugRegExp).optional(),
  "title": zod.string().min(1).max(updateAdminEventBodyTitleMax).optional(),
  "description": zod.string().max(updateAdminEventBodyDescriptionMax).nullish(),
  "status": zod.enum(['draft', 'published', 'archived']).optional(),
  "heroBadge": zod.string().max(updateAdminEventBodyHeroBadgeMax).nullish(),
  "heroHeadline": zod.string().max(updateAdminEventBodyHeroHeadlineMax).nullish(),
  "heroSubheading": zod.string().max(updateAdminEventBodyHeroSubheadingMax).nullish(),
  "dateLabel": zod.string().max(updateAdminEventBodyDateLabelMax).nullish(),
  "timeLabel": zod.string().max(updateAdminEventBodyTimeLabelMax).nullish(),
  "timezone": zod.string().max(updateAdminEventBodyTimezoneMax).nullish(),
  "rsvpDeadlineLabel": zod.string().max(updateAdminEventBodyRsvpDeadlineLabelMax).nullish(),
  "startsAt": zod.iso.datetime({"offset":true}).nullish(),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "capacity": zod.int().min(1).nullish(),
  "venueName": zod.string().max(updateAdminEventBodyVenueNameMax).nullish(),
  "venueRoom": zod.string().max(updateAdminEventBodyVenueRoomMax).nullish(),
  "venueAddress": zod.string().max(updateAdminEventBodyVenueAddressMax).nullish(),
  "venueWebsite": zod.string().max(updateAdminEventBodyVenueWebsiteMax).nullish(),
  "venueMapsUrl": zod.string().max(updateAdminEventBodyVenueMapsUrlMax).nullish(),
  "livestreamUrl": zod.string().max(updateAdminEventBodyLivestreamUrlMax).nullish()
})

export const updateAdminEventResponse = zod.object({
  "id": zod.uuid(),
  "slug": zod.string(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "status": zod.enum(['draft', 'published', 'archived']),
  "heroBadge": zod.string().nullish(),
  "heroHeadline": zod.string().nullish(),
  "heroSubheading": zod.string().nullish(),
  "dateLabel": zod.string().nullish(),
  "timeLabel": zod.string().nullish(),
  "timezone": zod.string().nullish(),
  "rsvpDeadlineLabel": zod.string().nullish(),
  "startsAt": zod.iso.datetime({"offset":true}).nullish(),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "capacity": zod.int().nullish(),
  "venueName": zod.string().nullish(),
  "venueRoom": zod.string().nullish(),
  "venueAddress": zod.string().nullish(),
  "venueWebsite": zod.string().nullish(),
  "venueMapsUrl": zod.string().nullish(),
  "livestreamUrl": zod.string().nullish(),
  "agenda": zod.array(zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "timeLabel": zod.string(),
  "title": zod.string(),
  "speaker": zod.string().nullish(),
  "speakerRole": zod.string().nullish()
})),
  "speakers": zod.array(zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "name": zod.string(),
  "role": zod.string().nullish(),
  "blurb": zod.string().nullish(),
  "photoUrl": zod.string().nullish()
})),
  "invitationCodes": zod.array(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "label": zod.string().nullish(),
  "isActive": zod.boolean(),
  "maxUses": zod.int().nullish(),
  "useCount": zod.int(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete an event and all its agenda, speakers, codes, and RSVPs (admin only)
 */
export const deleteAdminEventParams = zod.object({
  "id": zod.uuid()
})

export const deleteAdminEventResponse = zod.void()


/**
 * @summary Add an agenda item to an event (admin only)
 */
export const createEventAgendaItemParams = zod.object({
  "id": zod.uuid()
})

export const createEventAgendaItemBodyTimeLabelMax = 200;

export const createEventAgendaItemBodyTitleMax = 300;

export const createEventAgendaItemBodySpeakerMax = 200;

export const createEventAgendaItemBodySpeakerRoleMax = 200;

export const createEventAgendaItemBodySortOrderMin = 0;



export const createEventAgendaItemBody = zod.object({
  "timeLabel": zod.string().min(1).max(createEventAgendaItemBodyTimeLabelMax),
  "title": zod.string().min(1).max(createEventAgendaItemBodyTitleMax),
  "speaker": zod.string().max(createEventAgendaItemBodySpeakerMax).nullish(),
  "speakerRole": zod.string().max(createEventAgendaItemBodySpeakerRoleMax).nullish(),
  "sortOrder": zod.int().min(createEventAgendaItemBodySortOrderMin).optional()
})

export const createEventAgendaItemResponse = zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "timeLabel": zod.string(),
  "title": zod.string(),
  "speaker": zod.string().nullish(),
  "speakerRole": zod.string().nullish()
})


/**
 * @summary Update an agenda item (admin only)
 */
export const updateEventAgendaItemParams = zod.object({
  "id": zod.uuid(),
  "itemId": zod.uuid()
})

export const updateEventAgendaItemBodyTimeLabelMax = 200;

export const updateEventAgendaItemBodyTitleMax = 300;

export const updateEventAgendaItemBodySpeakerMax = 200;

export const updateEventAgendaItemBodySpeakerRoleMax = 200;

export const updateEventAgendaItemBodySortOrderMin = 0;



export const updateEventAgendaItemBody = zod.object({
  "timeLabel": zod.string().min(1).max(updateEventAgendaItemBodyTimeLabelMax).optional(),
  "title": zod.string().min(1).max(updateEventAgendaItemBodyTitleMax).optional(),
  "speaker": zod.string().max(updateEventAgendaItemBodySpeakerMax).nullish(),
  "speakerRole": zod.string().max(updateEventAgendaItemBodySpeakerRoleMax).nullish(),
  "sortOrder": zod.int().min(updateEventAgendaItemBodySortOrderMin).optional()
})

export const updateEventAgendaItemResponse = zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "timeLabel": zod.string(),
  "title": zod.string(),
  "speaker": zod.string().nullish(),
  "speakerRole": zod.string().nullish()
})


/**
 * @summary Remove an agenda item (admin only)
 */
export const deleteEventAgendaItemParams = zod.object({
  "id": zod.uuid(),
  "itemId": zod.uuid()
})

export const deleteEventAgendaItemResponse = zod.void()


/**
 * @summary Add a speaker to an event (admin only)
 */
export const createEventSpeakerParams = zod.object({
  "id": zod.uuid()
})

export const createEventSpeakerBodyNameMax = 200;

export const createEventSpeakerBodyRoleMax = 200;

export const createEventSpeakerBodyBlurbMax = 2000;

export const createEventSpeakerBodyPhotoUrlMax = 1000;

export const createEventSpeakerBodySortOrderMin = 0;



export const createEventSpeakerBody = zod.object({
  "name": zod.string().min(1).max(createEventSpeakerBodyNameMax),
  "role": zod.string().max(createEventSpeakerBodyRoleMax).nullish(),
  "blurb": zod.string().max(createEventSpeakerBodyBlurbMax).nullish(),
  "photoUrl": zod.string().max(createEventSpeakerBodyPhotoUrlMax).nullish(),
  "sortOrder": zod.int().min(createEventSpeakerBodySortOrderMin).optional()
})

export const createEventSpeakerResponse = zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "name": zod.string(),
  "role": zod.string().nullish(),
  "blurb": zod.string().nullish(),
  "photoUrl": zod.string().nullish()
})


/**
 * @summary Update a speaker (admin only)
 */
export const updateEventSpeakerParams = zod.object({
  "id": zod.uuid(),
  "speakerId": zod.uuid()
})

export const updateEventSpeakerBodyNameMax = 200;

export const updateEventSpeakerBodyRoleMax = 200;

export const updateEventSpeakerBodyBlurbMax = 2000;

export const updateEventSpeakerBodyPhotoUrlMax = 1000;

export const updateEventSpeakerBodySortOrderMin = 0;



export const updateEventSpeakerBody = zod.object({
  "name": zod.string().min(1).max(updateEventSpeakerBodyNameMax).optional(),
  "role": zod.string().max(updateEventSpeakerBodyRoleMax).nullish(),
  "blurb": zod.string().max(updateEventSpeakerBodyBlurbMax).nullish(),
  "photoUrl": zod.string().max(updateEventSpeakerBodyPhotoUrlMax).nullish(),
  "sortOrder": zod.int().min(updateEventSpeakerBodySortOrderMin).optional()
})

export const updateEventSpeakerResponse = zod.object({
  "id": zod.uuid(),
  "sortOrder": zod.int(),
  "name": zod.string(),
  "role": zod.string().nullish(),
  "blurb": zod.string().nullish(),
  "photoUrl": zod.string().nullish()
})


/**
 * @summary Remove a speaker (admin only)
 */
export const deleteEventSpeakerParams = zod.object({
  "id": zod.uuid(),
  "speakerId": zod.uuid()
})

export const deleteEventSpeakerResponse = zod.void()


/**
 * @summary Create a single invitation code for an event (admin only)
 */
export const createEventInvitationCodeParams = zod.object({
  "id": zod.uuid()
})

export const createEventInvitationCodeBodyCodeMax = 64;


export const createEventInvitationCodeBodyCodeRegExp = new RegExp('^[A-Za-z0-9-]+$');
export const createEventInvitationCodeBodyLabelMax = 200;


export const createEventInvitationCodeBodyNotesMax = 1000;



export const createEventInvitationCodeBody = zod.object({
  "code": zod.string().min(1).max(createEventInvitationCodeBodyCodeMax).regex(createEventInvitationCodeBodyCodeRegExp),
  "label": zod.string().max(createEventInvitationCodeBodyLabelMax).nullish(),
  "maxUses": zod.int().min(1).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().max(createEventInvitationCodeBodyNotesMax).nullish()
})

export const createEventInvitationCodeResponse = zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "label": zod.string().nullish(),
  "isActive": zod.boolean(),
  "maxUses": zod.int().nullish(),
  "useCount": zod.int(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Bulk-generate unique invitation codes for an event (admin only)
 */
export const bulkGenerateEventInvitationCodesParams = zod.object({
  "id": zod.uuid()
})

export const bulkGenerateEventInvitationCodesBodyCountMax = 500;

export const bulkGenerateEventInvitationCodesBodyPrefixMax = 20;


export const bulkGenerateEventInvitationCodesBodyPrefixRegExp = new RegExp('^[A-Za-z0-9-]*$');
export const bulkGenerateEventInvitationCodesBodyLabelMax = 200;




export const bulkGenerateEventInvitationCodesBody = zod.object({
  "count": zod.int().min(1).max(bulkGenerateEventInvitationCodesBodyCountMax),
  "prefix": zod.string().max(bulkGenerateEventInvitationCodesBodyPrefixMax).regex(bulkGenerateEventInvitationCodesBodyPrefixRegExp).optional(),
  "label": zod.string().max(bulkGenerateEventInvitationCodesBodyLabelMax).nullish(),
  "maxUses": zod.int().min(1).nullish()
})

export const bulkGenerateEventInvitationCodesResponseItem = zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "label": zod.string().nullish(),
  "isActive": zod.boolean(),
  "maxUses": zod.int().nullish(),
  "useCount": zod.int(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})
export const bulkGenerateEventInvitationCodesResponse = zod.array(bulkGenerateEventInvitationCodesResponseItem)


/**
 * @summary Update an invitation code (activate/deactivate, label, limits) (admin only)
 */
export const updateEventInvitationCodeParams = zod.object({
  "id": zod.uuid(),
  "codeId": zod.uuid()
})

export const updateEventInvitationCodeBodyLabelMax = 200;


export const updateEventInvitationCodeBodyNotesMax = 1000;



export const updateEventInvitationCodeBody = zod.object({
  "isActive": zod.boolean().optional(),
  "label": zod.string().max(updateEventInvitationCodeBodyLabelMax).nullish(),
  "maxUses": zod.int().min(1).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().max(updateEventInvitationCodeBodyNotesMax).nullish()
})

export const updateEventInvitationCodeResponse = zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "label": zod.string().nullish(),
  "isActive": zod.boolean(),
  "maxUses": zod.int().nullish(),
  "useCount": zod.int(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete an invitation code (admin only)
 */
export const deleteEventInvitationCodeParams = zod.object({
  "id": zod.uuid(),
  "codeId": zod.uuid()
})

export const deleteEventInvitationCodeResponse = zod.void()


/**
 * @summary List RSVPs for an event with filtering and pagination (admin only)
 */
export const listEventRsvpsParams = zod.object({
  "id": zod.uuid()
})

export const listEventRsvpsQuerySearchMax = 200;

export const listEventRsvpsQueryPageDefault = 1;

export const listEventRsvpsQueryPageSizeDefault = 25;
export const listEventRsvpsQueryPageSizeMax = 100;



export const listEventRsvpsQueryParams = zod.object({
  "status": zod.enum(['confirmed', 'declined', 'waitlisted', 'cancelled']).optional(),
  "search": zod.string().max(listEventRsvpsQuerySearchMax).optional().describe('Case-insensitive match on attendee name, email, or account'),
  "page": zod.int().min(1).default(listEventRsvpsQueryPageDefault),
  "pageSize": zod.int().min(1).max(listEventRsvpsQueryPageSizeMax).default(listEventRsvpsQueryPageSizeDefault)
})

export const listEventRsvpsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "account": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "dietaryRequirements": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "status": zod.enum(['confirmed', 'declined', 'waitlisted', 'cancelled']),
  "invitationCode": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "contactName": zod.string().nullish(),
  "source": zod.enum(['web', 'sms']),
  "campaignName": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "page": zod.int(),
  "pageSize": zod.int()
})


/**
 * @summary Per-event RSVP counts by status (admin only)
 */
export const getEventRsvpSummaryParams = zod.object({
  "id": zod.uuid()
})

export const getEventRsvpSummaryResponse = zod.object({
  "total": zod.int(),
  "confirmed": zod.int(),
  "declined": zod.int(),
  "waitlisted": zod.int(),
  "cancelled": zod.int()
})


/**
 * @summary Download RSVPs matching the filters as CSV (admin only)
 */
export const exportEventRsvpsParams = zod.object({
  "id": zod.uuid()
})

export const exportEventRsvpsQuerySearchMax = 200;



export const exportEventRsvpsQueryParams = zod.object({
  "status": zod.enum(['confirmed', 'declined', 'waitlisted', 'cancelled']).optional(),
  "search": zod.string().max(exportEventRsvpsQuerySearchMax).optional().describe('Case-insensitive match on attendee name, email, or account')
})

export const exportEventRsvpsResponse = zod.unknown()


/**
 * @summary Update an RSVP's status (admin only)
 */
export const updateEventRsvpStatusParams = zod.object({
  "id": zod.uuid(),
  "rsvpId": zod.uuid()
})

export const updateEventRsvpStatusBody = zod.object({
  "status": zod.enum(['confirmed', 'declined', 'waitlisted', 'cancelled'])
})

export const updateEventRsvpStatusResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "account": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "dietaryRequirements": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "status": zod.enum(['confirmed', 'declined', 'waitlisted', 'cancelled']),
  "invitationCode": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "contactName": zod.string().nullish(),
  "source": zod.enum(['web', 'sms']),
  "campaignName": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Current authenticated user
 */
export const getCurrentUserResponse = zod.object({
  "role": zod.enum(['staff', 'admin', 'customer']).describe('staff = Entra tenant member; customer = invited guest user.'),
  "appUserId": zod.uuid().nullish(),
  "entraObjectId": zod.string(),
  "entraTenantId": zod.string(),
  "email": zod.string().nullish(),
  "displayName": zod.string(),
  "persistent": zod.boolean().describe('True when the user is synced to the app_users table.')
})


export const getAgentResearchStatusBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
})
})

export const getAgentResearchStatusResponseLimitsMaxResultsPerQueryMax = 5;

export const getAgentResearchStatusResponseLimitsMaxSearchesPerTurnMax = 3;

export const getAgentResearchStatusResponseLimitsMonthlyCreditCapMax = 1000;

export const getAgentResearchStatusResponseLimitsCreditsUsedThisMonthMin = 0;



export const getAgentResearchStatusResponse = zod.object({
  "provider": zod.enum(['azure_web_search']),
  "state": zod.enum(['disabled', 'approval_required', 'misconfigured', 'quota_exhausted', 'timeout', 'failed', 'ready']),
  "approved": zod.boolean(),
  "configured": zod.boolean(),
  "enabled": zod.boolean(),
  "liveSmokeTested": zod.boolean(),
  "message": zod.string(),
  "limits": zod.object({
  "searchDepth": zod.enum(['basic']),
  "maxResultsPerQuery": zod.int().min(1).max(getAgentResearchStatusResponseLimitsMaxResultsPerQueryMax),
  "maxSearchesPerTurn": zod.int().min(1).max(getAgentResearchStatusResponseLimitsMaxSearchesPerTurnMax),
  "monthlyCreditCap": zod.int().min(1).max(getAgentResearchStatusResponseLimitsMonthlyCreditCapMax),
  "creditsUsedThisMonth": zod.int().min(getAgentResearchStatusResponseLimitsCreditsUsedThisMonthMin)
}),
  "pricingCheckedAt": zod.iso.date(),
  "pricingUrl": zod.url(),
  "searchApiUrl": zod.url()
})


/**
 * Read the current actor's authorized unfinished work. Derived metadata only; no task store or execution.
 */
export const listPersonalWorkQuerySearchMax = 200;

export const listPersonalWorkQueryLimitDefault = 25;
export const listPersonalWorkQueryLimitMax = 100;

export const listPersonalWorkQueryOffsetDefault = 0;
export const listPersonalWorkQueryOffsetMin = 0;



export const listPersonalWorkQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "source": zod.enum(['agent', 'content_asset', 'social_post', 'campaign', 'research_thread', 'research_document']).optional(),
  "state": zod.enum(['needs_details', 'awaiting_review', 'pending', 'uncertain', 'expired', 'stale', 'draft', 'active', 'failed']).optional(),
  "search": zod.string().max(listPersonalWorkQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listPersonalWorkQueryLimitMax).default(listPersonalWorkQueryLimitDefault),
  "offset": zod.int().min(listPersonalWorkQueryOffsetMin).default(listPersonalWorkQueryOffsetDefault)
})


export const listPersonalWorkResponseTotalMin = 0;



export const listPersonalWorkResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "source": zod.enum(['agent', 'content_asset', 'social_post', 'campaign', 'research_thread', 'research_document']),
  "title": zod.string(),
  "state": zod.enum(['needs_details', 'awaiting_review', 'pending', 'uncertain', 'expired', 'stale', 'draft', 'active', 'failed']),
  "nativeStatus": zod.string(),
  "revision": zod.string(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "nextAction": zod.string(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "resume": zod.object({
  "kind": zod.enum(['conversation', 'native', 'receipt']),
  "destination": zod.string(),
  "requiresFreshRequest": zod.boolean(),
  "conversationId": zod.uuid().optional(),
  "mode": zod.enum(['internal', 'public_research']).optional(),
  "proposalId": zod.uuid().optional(),
  "executionId": zod.uuid().optional(),
  "actionId": zod.uuid().optional(),
  "actionRevision": zod.int().min(1).optional(),
  "expiresAt": zod.iso.datetime({"offset":true}).optional()
})
})),
  "total": zod.int().min(listPersonalWorkResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int(),
  "asOf": zod.iso.datetime({"offset":true}),
  "sources": zod.array(zod.object({
  "source": zod.string(),
  "status": zod.enum(['available', 'unavailable', 'not_authorized', 'unsupported']),
  "reason": zod.string()
}))
})


/**
 * Reauthorize the exact source and read its current resume context. Never confirms, retries, renews expiry or writes.
 */
export const getPersonalWorkResumeParams = zod.object({
  "source": zod.enum(['agent', 'content_asset', 'social_post', 'campaign', 'research_thread', 'research_document']),
  "id": zod.uuid()
})

export const getPersonalWorkResumeQueryExpectedRevisionMax = 160;



export const getPersonalWorkResumeQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "expectedRevision": zod.string().max(getPersonalWorkResumeQueryExpectedRevisionMax).optional()
})




export const getPersonalWorkResumeResponse = zod.object({
  "id": zod.uuid(),
  "source": zod.enum(['agent', 'content_asset', 'social_post', 'campaign', 'research_thread', 'research_document']),
  "title": zod.string(),
  "state": zod.enum(['needs_details', 'awaiting_review', 'pending', 'uncertain', 'expired', 'stale', 'draft', 'active', 'failed']),
  "nativeStatus": zod.string(),
  "revision": zod.string(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "nextAction": zod.string(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "resume": zod.object({
  "kind": zod.enum(['conversation', 'native', 'receipt']),
  "destination": zod.string(),
  "requiresFreshRequest": zod.boolean(),
  "conversationId": zod.uuid().optional(),
  "mode": zod.enum(['internal', 'public_research']).optional(),
  "proposalId": zod.uuid().optional(),
  "executionId": zod.uuid().optional(),
  "actionId": zod.uuid().optional(),
  "actionRevision": zod.int().min(1).optional(),
  "expiresAt": zod.iso.datetime({"offset":true}).optional()
})
})


export const listAgentAttachmentsParams = zod.object({
  "id": zod.uuid()
})

export const listAgentAttachmentsQueryLimitDefault = 25;
export const listAgentAttachmentsQueryLimitMax = 100;

export const listAgentAttachmentsQueryOffsetDefault = 0;
export const listAgentAttachmentsQueryOffsetMin = 0;
export const listAgentAttachmentsQueryOffsetMax = 100000;



export const listAgentAttachmentsQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAgentAttachmentsQueryLimitMax).default(listAgentAttachmentsQueryLimitDefault),
  "offset": zod.int().min(listAgentAttachmentsQueryOffsetMin).max(listAgentAttachmentsQueryOffsetMax).default(listAgentAttachmentsQueryOffsetDefault)
})

export const listAgentAttachmentsResponseItemsItemSizeBytesMin = 0;
export const listAgentAttachmentsResponseItemsItemSizeBytesMax = 20971520;

export const listAgentAttachmentsResponseItemsItemContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const listAgentAttachmentsResponseItemsItemFailureCodeMax = 80;

export const listAgentAttachmentsResponseItemsItemExtractionWarningsItemMax = 500;

export const listAgentAttachmentsResponseItemsItemExtractionWarningsMax = 110;

export const listAgentAttachmentsResponseTotalMin = 0;



export const listAgentAttachmentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(listAgentAttachmentsResponseItemsItemSizeBytesMin).max(listAgentAttachmentsResponseItemsItemSizeBytesMax),
  "contentHash": zod.string().regex(listAgentAttachmentsResponseItemsItemContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(listAgentAttachmentsResponseItemsItemFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(listAgentAttachmentsResponseItemsItemExtractionWarningsItemMax)).max(listAgentAttachmentsResponseItemsItemExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAgentAttachmentsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * One original per immutable batch. Retry the same uploadId and bytes; never sends chat or creates a tender.
 */
export const uploadAgentAttachmentParams = zod.object({
  "id": zod.uuid()
})

export const uploadAgentAttachmentBodyFilenameMax = 255;

export const uploadAgentAttachmentBodyContentTypeMax = 200;

export const uploadAgentAttachmentBodyDataBase64Min = 4;
export const uploadAgentAttachmentBodyDataBase64Max = 27962028;



export const uploadAgentAttachmentBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "uploadId": zod.uuid(),
  "filename": zod.string().min(1).max(uploadAgentAttachmentBodyFilenameMax),
  "contentType": zod.string().min(1).max(uploadAgentAttachmentBodyContentTypeMax),
  "dataBase64": zod.string().min(uploadAgentAttachmentBodyDataBase64Min).max(uploadAgentAttachmentBodyDataBase64Max).describe('Canonical padded base64 of at most 20 MiB')
})

export const uploadAgentAttachmentResponseSizeBytesMin = 0;
export const uploadAgentAttachmentResponseSizeBytesMax = 20971520;

export const uploadAgentAttachmentResponseContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const uploadAgentAttachmentResponseFailureCodeMax = 80;

export const uploadAgentAttachmentResponseExtractionWarningsItemMax = 500;

export const uploadAgentAttachmentResponseExtractionWarningsMax = 110;



export const uploadAgentAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(uploadAgentAttachmentResponseSizeBytesMin).max(uploadAgentAttachmentResponseSizeBytesMax),
  "contentHash": zod.string().regex(uploadAgentAttachmentResponseContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(uploadAgentAttachmentResponseFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(uploadAgentAttachmentResponseExtractionWarningsItemMax)).max(uploadAgentAttachmentResponseExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getAgentAttachmentParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const getAgentAttachmentQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional()
})

export const getAgentAttachmentResponseSizeBytesMin = 0;
export const getAgentAttachmentResponseSizeBytesMax = 20971520;

export const getAgentAttachmentResponseContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const getAgentAttachmentResponseFailureCodeMax = 80;

export const getAgentAttachmentResponseExtractionWarningsItemMax = 500;

export const getAgentAttachmentResponseExtractionWarningsMax = 110;



export const getAgentAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(getAgentAttachmentResponseSizeBytesMin).max(getAgentAttachmentResponseSizeBytesMax),
  "contentHash": zod.string().regex(getAgentAttachmentResponseContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(getAgentAttachmentResponseFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(getAgentAttachmentResponseExtractionWarningsItemMax)).max(getAgentAttachmentResponseExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Removes uncommitted evidence only. Saved-turn references prevent byte deletion. Repeating removal retries pending cleanup.
 */
export const removeAgentAttachmentParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const removeAgentAttachmentQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional()
})

export const removeAgentAttachmentResponseSizeBytesMin = 0;
export const removeAgentAttachmentResponseSizeBytesMax = 20971520;

export const removeAgentAttachmentResponseContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const removeAgentAttachmentResponseFailureCodeMax = 80;

export const removeAgentAttachmentResponseExtractionWarningsItemMax = 500;

export const removeAgentAttachmentResponseExtractionWarningsMax = 110;



export const removeAgentAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(removeAgentAttachmentResponseSizeBytesMin).max(removeAgentAttachmentResponseSizeBytesMax),
  "contentHash": zod.string().regex(removeAgentAttachmentResponseContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(removeAgentAttachmentResponseFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(removeAgentAttachmentResponseExtractionWarningsItemMax)).max(removeAgentAttachmentResponseExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listAgentAttachmentMembersParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const listAgentAttachmentMembersQueryLimitDefault = 25;
export const listAgentAttachmentMembersQueryLimitMax = 100;

export const listAgentAttachmentMembersQueryOffsetDefault = 0;
export const listAgentAttachmentMembersQueryOffsetMin = 0;
export const listAgentAttachmentMembersQueryOffsetMax = 100000;



export const listAgentAttachmentMembersQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAgentAttachmentMembersQueryLimitMax).default(listAgentAttachmentMembersQueryLimitDefault),
  "offset": zod.int().min(listAgentAttachmentMembersQueryOffsetMin).max(listAgentAttachmentMembersQueryOffsetMax).default(listAgentAttachmentMembersQueryOffsetDefault)
})

export const listAgentAttachmentMembersResponseItemsItemSizeBytesMin = 0;
export const listAgentAttachmentMembersResponseItemsItemSizeBytesMax = 20971520;

export const listAgentAttachmentMembersResponseItemsItemContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const listAgentAttachmentMembersResponseItemsItemFailureCodeMax = 80;

export const listAgentAttachmentMembersResponseItemsItemExtractionWarningsItemMax = 500;

export const listAgentAttachmentMembersResponseItemsItemExtractionWarningsMax = 110;

export const listAgentAttachmentMembersResponseTotalMin = 0;



export const listAgentAttachmentMembersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(listAgentAttachmentMembersResponseItemsItemSizeBytesMin).max(listAgentAttachmentMembersResponseItemsItemSizeBytesMax),
  "contentHash": zod.string().regex(listAgentAttachmentMembersResponseItemsItemContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(listAgentAttachmentMembersResponseItemsItemFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(listAgentAttachmentMembersResponseItemsItemExtractionWarningsItemMax)).max(listAgentAttachmentMembersResponseItemsItemExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAgentAttachmentMembersResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


export const getAgentAttachmentUploadParams = zod.object({
  "id": zod.uuid(),
  "uploadId": zod.uuid()
})

export const getAgentAttachmentUploadQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional()
})

export const getAgentAttachmentUploadResponseSizeBytesMin = 0;
export const getAgentAttachmentUploadResponseSizeBytesMax = 20971520;

export const getAgentAttachmentUploadResponseContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const getAgentAttachmentUploadResponseFailureCodeMax = 80;

export const getAgentAttachmentUploadResponseExtractionWarningsItemMax = 500;

export const getAgentAttachmentUploadResponseExtractionWarningsMax = 110;



export const getAgentAttachmentUploadResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(getAgentAttachmentUploadResponseSizeBytesMin).max(getAgentAttachmentUploadResponseSizeBytesMax),
  "contentHash": zod.string().regex(getAgentAttachmentUploadResponseContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(getAgentAttachmentUploadResponseFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(getAgentAttachmentUploadResponseExtractionWarningsItemMax)).max(getAgentAttachmentUploadResponseExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const processAgentAttachmentParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const processAgentAttachmentBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
})
})

export const processAgentAttachmentResponseSizeBytesMin = 0;
export const processAgentAttachmentResponseSizeBytesMax = 20971520;

export const processAgentAttachmentResponseContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const processAgentAttachmentResponseFailureCodeMax = 80;

export const processAgentAttachmentResponseExtractionWarningsItemMax = 500;

export const processAgentAttachmentResponseExtractionWarningsMax = 110;



export const processAgentAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(processAgentAttachmentResponseSizeBytesMin).max(processAgentAttachmentResponseSizeBytesMax),
  "contentHash": zod.string().regex(processAgentAttachmentResponseContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(processAgentAttachmentResponseFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(processAgentAttachmentResponseExtractionWarningsItemMax)).max(processAgentAttachmentResponseExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listAgentAttachmentSectionsParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const listAgentAttachmentSectionsQueryLimitDefault = 25;
export const listAgentAttachmentSectionsQueryLimitMax = 100;

export const listAgentAttachmentSectionsQueryOffsetDefault = 0;
export const listAgentAttachmentSectionsQueryOffsetMin = 0;
export const listAgentAttachmentSectionsQueryOffsetMax = 100000;



export const listAgentAttachmentSectionsQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAgentAttachmentSectionsQueryLimitMax).default(listAgentAttachmentSectionsQueryLimitDefault),
  "offset": zod.int().min(listAgentAttachmentSectionsQueryOffsetMin).max(listAgentAttachmentSectionsQueryOffsetMax).default(listAgentAttachmentSectionsQueryOffsetDefault)
})

export const listAgentAttachmentSectionsResponseItemsItemIndexMin = 0;

export const listAgentAttachmentSectionsResponseItemsItemLocationMax = 300;

export const listAgentAttachmentSectionsResponseItemsItemTextMax = 2000;



export const listAgentAttachmentSectionsResponse = zod.object({
  "items": zod.array(zod.object({
  "index": zod.int().min(listAgentAttachmentSectionsResponseItemsItemIndexMin),
  "location": zod.string().max(listAgentAttachmentSectionsResponseItemsItemLocationMax),
  "text": zod.string().max(listAgentAttachmentSectionsResponseItemsItemTextMax)
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const downloadAgentAttachmentParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const downloadAgentAttachmentQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional()
})

export const downloadAgentAttachmentResponse = zod.unknown()


/**
 * Exact record-shared uploads; no Collateral adoption, public link or document approval.
 */
export const listAgentSharedAttachmentsParams = zod.object({
  "id": zod.uuid()
})

export const listAgentSharedAttachmentsQueryLimitDefault = 25;
export const listAgentSharedAttachmentsQueryLimitMax = 100;

export const listAgentSharedAttachmentsQueryOffsetDefault = 0;
export const listAgentSharedAttachmentsQueryOffsetMin = 0;
export const listAgentSharedAttachmentsQueryOffsetMax = 100000;



export const listAgentSharedAttachmentsQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid(),
  "limit": zod.int().min(1).max(listAgentSharedAttachmentsQueryLimitMax).default(listAgentSharedAttachmentsQueryLimitDefault),
  "offset": zod.int().min(listAgentSharedAttachmentsQueryOffsetMin).max(listAgentSharedAttachmentsQueryOffsetMax).default(listAgentSharedAttachmentsQueryOffsetDefault)
})

export const listAgentSharedAttachmentsResponseItemsItemOneSizeBytesMin = 0;
export const listAgentSharedAttachmentsResponseItemsItemOneSizeBytesMax = 20971520;

export const listAgentSharedAttachmentsResponseItemsItemOneContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const listAgentSharedAttachmentsResponseItemsItemOneFailureCodeMax = 80;

export const listAgentSharedAttachmentsResponseItemsItemOneExtractionWarningsItemMax = 500;

export const listAgentSharedAttachmentsResponseItemsItemOneExtractionWarningsMax = 110;

export const listAgentSharedAttachmentsResponseTotalMin = 0;



export const listAgentSharedAttachmentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(listAgentSharedAttachmentsResponseItemsItemOneSizeBytesMin).max(listAgentSharedAttachmentsResponseItemsItemOneSizeBytesMax),
  "contentHash": zod.string().regex(listAgentSharedAttachmentsResponseItemsItemOneContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(listAgentSharedAttachmentsResponseItemsItemOneFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(listAgentSharedAttachmentsResponseItemsItemOneExtractionWarningsItemMax)).max(listAgentSharedAttachmentsResponseItemsItemOneExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('conversationId identifies this shared thread; audience is record access. No private conversation is relabelled.')),
  "total": zod.int().min(listAgentSharedAttachmentsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Exact record-shared uploads; no Collateral adoption, public link or document approval.
 */
export const uploadAgentSharedAttachmentParams = zod.object({
  "id": zod.uuid()
})

export const uploadAgentSharedAttachmentBodyFilenameMax = 255;

export const uploadAgentSharedAttachmentBodyContentTypeMax = 200;

export const uploadAgentSharedAttachmentBodyDataBase64Min = 4;
export const uploadAgentSharedAttachmentBodyDataBase64Max = 27962028;



export const uploadAgentSharedAttachmentBody = zod.object({
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "acknowledgeSharing": zod.literal(true).describe('Explicit acknowledgement that this new file is shared with staff who currently have access to this exact record.'),
  "uploadId": zod.uuid(),
  "filename": zod.string().min(1).max(uploadAgentSharedAttachmentBodyFilenameMax),
  "contentType": zod.string().min(1).max(uploadAgentSharedAttachmentBodyContentTypeMax),
  "dataBase64": zod.string().min(uploadAgentSharedAttachmentBodyDataBase64Min).max(uploadAgentSharedAttachmentBodyDataBase64Max)
})

export const uploadAgentSharedAttachmentResponseOneSizeBytesMin = 0;
export const uploadAgentSharedAttachmentResponseOneSizeBytesMax = 20971520;

export const uploadAgentSharedAttachmentResponseOneContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const uploadAgentSharedAttachmentResponseOneFailureCodeMax = 80;

export const uploadAgentSharedAttachmentResponseOneExtractionWarningsItemMax = 500;

export const uploadAgentSharedAttachmentResponseOneExtractionWarningsMax = 110;



export const uploadAgentSharedAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(uploadAgentSharedAttachmentResponseOneSizeBytesMin).max(uploadAgentSharedAttachmentResponseOneSizeBytesMax),
  "contentHash": zod.string().regex(uploadAgentSharedAttachmentResponseOneContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(uploadAgentSharedAttachmentResponseOneFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(uploadAgentSharedAttachmentResponseOneExtractionWarningsItemMax)).max(uploadAgentSharedAttachmentResponseOneExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('conversationId identifies this shared thread; audience is record access. No private conversation is relabelled.')


/**
 * Exact record-shared uploads; no Collateral adoption, public link or document approval.
 */
export const getAgentSharedAttachmentUploadParams = zod.object({
  "id": zod.uuid(),
  "uploadId": zod.uuid()
})

export const getAgentSharedAttachmentUploadQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid()
})

export const getAgentSharedAttachmentUploadResponseOneSizeBytesMin = 0;
export const getAgentSharedAttachmentUploadResponseOneSizeBytesMax = 20971520;

export const getAgentSharedAttachmentUploadResponseOneContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const getAgentSharedAttachmentUploadResponseOneFailureCodeMax = 80;

export const getAgentSharedAttachmentUploadResponseOneExtractionWarningsItemMax = 500;

export const getAgentSharedAttachmentUploadResponseOneExtractionWarningsMax = 110;



export const getAgentSharedAttachmentUploadResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(getAgentSharedAttachmentUploadResponseOneSizeBytesMin).max(getAgentSharedAttachmentUploadResponseOneSizeBytesMax),
  "contentHash": zod.string().regex(getAgentSharedAttachmentUploadResponseOneContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(getAgentSharedAttachmentUploadResponseOneFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(getAgentSharedAttachmentUploadResponseOneExtractionWarningsItemMax)).max(getAgentSharedAttachmentUploadResponseOneExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('conversationId identifies this shared thread; audience is record access. No private conversation is relabelled.')


/**
 * Exact record-shared uploads; no Collateral adoption, public link or document approval.
 */
export const getAgentSharedAttachmentParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const getAgentSharedAttachmentQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid()
})

export const getAgentSharedAttachmentResponseOneSizeBytesMin = 0;
export const getAgentSharedAttachmentResponseOneSizeBytesMax = 20971520;

export const getAgentSharedAttachmentResponseOneContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const getAgentSharedAttachmentResponseOneFailureCodeMax = 80;

export const getAgentSharedAttachmentResponseOneExtractionWarningsItemMax = 500;

export const getAgentSharedAttachmentResponseOneExtractionWarningsMax = 110;



export const getAgentSharedAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(getAgentSharedAttachmentResponseOneSizeBytesMin).max(getAgentSharedAttachmentResponseOneSizeBytesMax),
  "contentHash": zod.string().regex(getAgentSharedAttachmentResponseOneContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(getAgentSharedAttachmentResponseOneFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(getAgentSharedAttachmentResponseOneExtractionWarningsItemMax)).max(getAgentSharedAttachmentResponseOneExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('conversationId identifies this shared thread; audience is record access. No private conversation is relabelled.')


/**
 * Exact record-shared uploads; no Collateral adoption, public link or document approval.
 */
export const removeAgentSharedAttachmentParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const removeAgentSharedAttachmentQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid()
})

export const removeAgentSharedAttachmentResponseOneSizeBytesMin = 0;
export const removeAgentSharedAttachmentResponseOneSizeBytesMax = 20971520;

export const removeAgentSharedAttachmentResponseOneContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const removeAgentSharedAttachmentResponseOneFailureCodeMax = 80;

export const removeAgentSharedAttachmentResponseOneExtractionWarningsItemMax = 500;

export const removeAgentSharedAttachmentResponseOneExtractionWarningsMax = 110;



export const removeAgentSharedAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(removeAgentSharedAttachmentResponseOneSizeBytesMin).max(removeAgentSharedAttachmentResponseOneSizeBytesMax),
  "contentHash": zod.string().regex(removeAgentSharedAttachmentResponseOneContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(removeAgentSharedAttachmentResponseOneFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(removeAgentSharedAttachmentResponseOneExtractionWarningsItemMax)).max(removeAgentSharedAttachmentResponseOneExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('conversationId identifies this shared thread; audience is record access. No private conversation is relabelled.')


/**
 * Exact record-shared uploads; no Collateral adoption, public link or document approval.
 */
export const listAgentSharedAttachmentMembersParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const listAgentSharedAttachmentMembersQueryLimitDefault = 25;
export const listAgentSharedAttachmentMembersQueryLimitMax = 100;

export const listAgentSharedAttachmentMembersQueryOffsetDefault = 0;
export const listAgentSharedAttachmentMembersQueryOffsetMin = 0;
export const listAgentSharedAttachmentMembersQueryOffsetMax = 100000;



export const listAgentSharedAttachmentMembersQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid(),
  "limit": zod.int().min(1).max(listAgentSharedAttachmentMembersQueryLimitMax).default(listAgentSharedAttachmentMembersQueryLimitDefault),
  "offset": zod.int().min(listAgentSharedAttachmentMembersQueryOffsetMin).max(listAgentSharedAttachmentMembersQueryOffsetMax).default(listAgentSharedAttachmentMembersQueryOffsetDefault)
})

export const listAgentSharedAttachmentMembersResponseItemsItemOneSizeBytesMin = 0;
export const listAgentSharedAttachmentMembersResponseItemsItemOneSizeBytesMax = 20971520;

export const listAgentSharedAttachmentMembersResponseItemsItemOneContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const listAgentSharedAttachmentMembersResponseItemsItemOneFailureCodeMax = 80;

export const listAgentSharedAttachmentMembersResponseItemsItemOneExtractionWarningsItemMax = 500;

export const listAgentSharedAttachmentMembersResponseItemsItemOneExtractionWarningsMax = 110;

export const listAgentSharedAttachmentMembersResponseTotalMin = 0;



export const listAgentSharedAttachmentMembersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(listAgentSharedAttachmentMembersResponseItemsItemOneSizeBytesMin).max(listAgentSharedAttachmentMembersResponseItemsItemOneSizeBytesMax),
  "contentHash": zod.string().regex(listAgentSharedAttachmentMembersResponseItemsItemOneContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(listAgentSharedAttachmentMembersResponseItemsItemOneFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(listAgentSharedAttachmentMembersResponseItemsItemOneExtractionWarningsItemMax)).max(listAgentSharedAttachmentMembersResponseItemsItemOneExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('conversationId identifies this shared thread; audience is record access. No private conversation is relabelled.')),
  "total": zod.int().min(listAgentSharedAttachmentMembersResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Exact record-shared uploads; no Collateral adoption, public link or document approval.
 */
export const listAgentSharedAttachmentSectionsParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const listAgentSharedAttachmentSectionsQueryLimitDefault = 25;
export const listAgentSharedAttachmentSectionsQueryLimitMax = 100;

export const listAgentSharedAttachmentSectionsQueryOffsetDefault = 0;
export const listAgentSharedAttachmentSectionsQueryOffsetMin = 0;
export const listAgentSharedAttachmentSectionsQueryOffsetMax = 100000;



export const listAgentSharedAttachmentSectionsQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid(),
  "limit": zod.int().min(1).max(listAgentSharedAttachmentSectionsQueryLimitMax).default(listAgentSharedAttachmentSectionsQueryLimitDefault),
  "offset": zod.int().min(listAgentSharedAttachmentSectionsQueryOffsetMin).max(listAgentSharedAttachmentSectionsQueryOffsetMax).default(listAgentSharedAttachmentSectionsQueryOffsetDefault)
})

export const listAgentSharedAttachmentSectionsResponseItemsItemIndexMin = 0;

export const listAgentSharedAttachmentSectionsResponseItemsItemLocationMax = 300;

export const listAgentSharedAttachmentSectionsResponseItemsItemTextMax = 2000;

export const listAgentSharedAttachmentSectionsResponseTotalMin = 0;



export const listAgentSharedAttachmentSectionsResponse = zod.object({
  "items": zod.array(zod.object({
  "index": zod.int().min(listAgentSharedAttachmentSectionsResponseItemsItemIndexMin),
  "location": zod.string().max(listAgentSharedAttachmentSectionsResponseItemsItemLocationMax),
  "text": zod.string().max(listAgentSharedAttachmentSectionsResponseItemsItemTextMax)
})),
  "total": zod.int().min(listAgentSharedAttachmentSectionsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Exact record-shared uploads; no Collateral adoption, public link or document approval.
 */
export const downloadAgentSharedAttachmentParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const downloadAgentSharedAttachmentQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid()
})

export const downloadAgentSharedAttachmentResponse = zod.unknown()


/**
 * Exact record-shared uploads; no Collateral adoption, public link or document approval.
 */
export const processAgentSharedAttachmentParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const processAgentSharedAttachmentBody = zod.object({
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.')
})

export const processAgentSharedAttachmentResponseOneSizeBytesMin = 0;
export const processAgentSharedAttachmentResponseOneSizeBytesMax = 20971520;

export const processAgentSharedAttachmentResponseOneContentHashRegExp = new RegExp('^[0-9a-f]{64}$');

export const processAgentSharedAttachmentResponseOneFailureCodeMax = 80;

export const processAgentSharedAttachmentResponseOneExtractionWarningsItemMax = 500;

export const processAgentSharedAttachmentResponseOneExtractionWarningsMax = 110;



export const processAgentSharedAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "batchId": zod.uuid(),
  "uploadId": zod.uuid(),
  "parentId": zod.uuid().nullable(),
  "filename": zod.string(),
  "relativePath": zod.string().nullable(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(processAgentSharedAttachmentResponseOneSizeBytesMin).max(processAgentSharedAttachmentResponseOneSizeBytesMax),
  "contentHash": zod.string().regex(processAgentSharedAttachmentResponseOneContentHashRegExp),
  "revision": zod.int().min(1),
  "status": zod.enum(['uploading', 'pending', 'processing', 'ready', 'partial', 'unsupported', 'failed', 'removed']),
  "failureCode": zod.string().max(processAgentSharedAttachmentResponseOneFailureCodeMax).nullable(),
  "cleanupPending": zod.boolean(),
  "extraction": zod.object({
  "sectionCount": zod.int(),
  "warnings": zod.array(zod.string().max(processAgentSharedAttachmentResponseOneExtractionWarningsItemMax)).max(processAgentSharedAttachmentResponseOneExtractionWarningsMax),
  "truncated": zod.boolean(),
  "hash": zod.string()
}).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('conversationId identifies this shared thread; audience is record access. No private conversation is relabelled.')


export const listAgentSharedMessagesParams = zod.object({
  "id": zod.uuid()
})

export const listAgentSharedMessagesQueryLimitDefault = 25;
export const listAgentSharedMessagesQueryLimitMax = 100;

export const listAgentSharedMessagesQueryOffsetDefault = 0;
export const listAgentSharedMessagesQueryOffsetMin = 0;
export const listAgentSharedMessagesQueryOffsetMax = 100000;



export const listAgentSharedMessagesQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid(),
  "limit": zod.int().min(1).max(listAgentSharedMessagesQueryLimitMax).default(listAgentSharedMessagesQueryLimitDefault),
  "offset": zod.int().min(listAgentSharedMessagesQueryOffsetMin).max(listAgentSharedMessagesQueryOffsetMax).default(listAgentSharedMessagesQueryOffsetDefault)
})


export const listAgentSharedMessagesResponseItemsItemSourcesItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentSharedMessagesResponseTotalMin = 0;



export const listAgentSharedMessagesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "content": zod.string().nullable(),
  "assistantContent": zod.string().nullable(),
  "status": zod.enum(['running', 'completed', 'failed', 'interrupted', 'cancelled']),
  "restricted": zod.boolean(),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(listAgentSharedMessagesResponseItemsItemSourcesItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})).optional(),
  "evidenceMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "stoppedByAppUserId": zod.uuid().nullable()
})),
  "total": zod.int().min(listAgentSharedMessagesResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


export const sendAgentSharedTurnParams = zod.object({
  "id": zod.uuid()
})

export const sendAgentSharedTurnBodyMessageMax = 4000;

export const sendAgentSharedTurnBodyContinuationActionKeyMax = 120;


export const sendAgentSharedTurnBodyContinuationFieldsMaxOne = 30000;

export const sendAgentSharedTurnBodyClarificationAnswersAnswersItemQuestionIdMax = 64;


export const sendAgentSharedTurnBodyClarificationAnswersAnswersItemQuestionIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const sendAgentSharedTurnBodyClarificationAnswersAnswersItemOptionIdsItemMax = 64;


export const sendAgentSharedTurnBodyClarificationAnswersAnswersItemOptionIdsItemRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const sendAgentSharedTurnBodyClarificationAnswersAnswersItemOptionIdsMax = 8;

export const sendAgentSharedTurnBodyClarificationAnswersAnswersItemTextMax = 1000;

export const sendAgentSharedTurnBodyClarificationAnswersAnswersMax = 6;


export const sendAgentSharedTurnBodyAttachmentsItemContentHashRegExp = new RegExp('^[0-9a-f]{64}$');
export const sendAgentSharedTurnBodyAttachmentsMax = 10;



export const sendAgentSharedTurnBody = zod.object({
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "clientRequestId": zod.uuid(),
  "message": zod.string().min(1).max(sendAgentSharedTurnBodyMessageMax),
  "mode": zod.enum(['shared', 'private_action']),
  "continuation": zod.object({
  "actionKey": zod.string().min(1).max(sendAgentSharedTurnBodyContinuationActionKeyMax),
  "actionId": zod.uuid(),
  "revision": zod.int().min(1),
  "mode": zod.enum(['details', 'review', 'cancel']),
  "fields": zod.record(zod.string(), zod.string().max(sendAgentSharedTurnBodyContinuationFieldsMaxOne)).optional()
}).optional(),
  "clarificationAnswers": zod.object({
  "groupId": zod.uuid(),
  "answers": zod.array(zod.object({
  "questionId": zod.string().min(1).max(sendAgentSharedTurnBodyClarificationAnswersAnswersItemQuestionIdMax).regex(sendAgentSharedTurnBodyClarificationAnswersAnswersItemQuestionIdRegExp),
  "optionIds": zod.array(zod.string().min(1).max(sendAgentSharedTurnBodyClarificationAnswersAnswersItemOptionIdsItemMax).regex(sendAgentSharedTurnBodyClarificationAnswersAnswersItemOptionIdsItemRegExp)).max(sendAgentSharedTurnBodyClarificationAnswersAnswersItemOptionIdsMax),
  "text": zod.string().max(sendAgentSharedTurnBodyClarificationAnswersAnswersItemTextMax).nullish()
})).min(1).max(sendAgentSharedTurnBodyClarificationAnswersAnswersMax)
}).optional(),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "contentHash": zod.string().regex(sendAgentSharedTurnBodyAttachmentsItemContentHashRegExp)
})).max(sendAgentSharedTurnBodyAttachmentsMax).optional()
})


export const sendAgentSharedTurnResponseMessageSourcesItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponseFileResultFilenameMax = 120;

export const sendAgentSharedTurnResponseFileResultLinkRegExp = new RegExp('^/files(?:\\?entry=|/)[0-9a-fA-F-]{36}$');

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardActionKeyMax = 120;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardTitleMax = 300;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemNameMax = 120;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemLabelMax = 120;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemValueMax = 30000;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemMinLengthMin = 0;


export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemOptionsItemMax = 120;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemOptionsMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsMax = 20;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardMissingInputsItemMax = 120;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardMissingInputsMax = 40;


export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardEvidenceItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardEvidenceMax = 20;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardAvailableActionsMax = 8;


export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardProposalReviewDestructiveDefault = false;
export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardDependencyOwnerMax = 120;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemActionKeyMax = 120;


export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemDestinationMax = 500;


export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemDestinationRegExp = new RegExp('^/(?!/)[a-zA-Z0-9/?=&._-]+$');
export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemMinimumInputsItemMax = 120;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemMinimumInputsMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemMissingInputsItemMax = 120;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemMissingInputsMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemExplanationMax = 2000;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillNameMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillTitleMax = 300;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillSubjectMax = 500;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillBodyMax = 30000;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillContentMax = 30000;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillMarkdownMax = 30000;

export const sendAgentSharedTurnResponsePrivateResponseOneContinuationsMax = 20;

export const sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemIdMax = 60;


export const sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemIdRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemLabelMax = 80;

export const sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemDescriptionMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemPromptMax = 500;

export const sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemDestinationMax = 500;


export const sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemDestinationRegExp = new RegExp('^/(?!/)[a-zA-Z0-9/?=&._-]+$');
export const sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsMax = 6;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestQueryHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestChannelDefault = `agent`;
export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMin = 2000;
export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMax = 24000;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMaxPassagesMin = 2;
export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMaxPassagesMax = 24;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMessageMax = 1000;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestBackgroundStateMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemCitationMax = 24;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemCrmIdentityMax = 150;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemSourceVersionMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemExcerptHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemLabelMax = 500;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemLocationMax = 500;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemExcerptMax = 2000;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemScoreMin = 0;
export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemScoreMax = 1;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemStartMin = 0;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemEndMin = 0;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesMax = 24;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestSourcesItemMessageMax = 1000;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestSourcesMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestWarningsItemMax = 1000;

export const sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestWarningsMax = 100;




export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsProjectTitleMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomerNameMax = 300;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsAgreementIdMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsPreparedDateMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsStartDateMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsSprintWeeksMax = 52;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsNarrativeItemTextMax = 20000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsNarrativeMax = 5;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsTablesItemRowsItemItemMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsTablesItemRowsItemMax = 7;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsTablesItemRowsMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsTablesMax = 6;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemIdMax = 80;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemTitleMax = 300;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemDescriptionMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemIdMax = 80;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemTitleMax = 300;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemDescriptionMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemIdMax = 80;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemMilestonesMax = 500;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemDateMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemNotesMax = 2000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialReferenceMax = 300;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialSourceStatusMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialTermsMax = 20000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialAssumptionsMax = 20000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialExclusionsMax = 20000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialReviewReasonMin = 10;
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialReviewReasonMax = 2000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesItemTitleMax = 300;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsUnresolvedFactsItemFieldMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsUnresolvedFactsItemMessageMax = 2000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsUnresolvedFactsMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomFieldsItemSectionIdMax = 48;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomFieldsItemFieldIdMax = 48;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomFieldsItemValueMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomFieldsMax = 600;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomProseItemSectionIdMax = 48;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomProseItemTextMax = 20000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomProseMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesItemSectionIdMax = 48;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsItemItemMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsItemMax = 8;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoRevisionMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoSourceKeyMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoLabelMax = 500;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoExcerptMax = 12000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesMax = 20;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoConfirmedFactsItemQuoteMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoConfirmedFactsItemSourceIdsItemMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoConfirmedFactsItemSourceIdsMax = 20;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoConfirmedFactsMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoAssumptionsItemQuoteMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoAssumptionsItemSourceIdsItemMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoAssumptionsItemSourceIdsMax = 20;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoAssumptionsMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoGapsMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoCorrectionsMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsTopMin = 5;
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsTopMax = 50;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsRightMin = 5;
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsRightMax = 50;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMin = 5;
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMax = 50;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMin = 5;
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMax = 50;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemTypeMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemTextMax = 200000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemMarksItemTypeMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemMarksMax = 20;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemContentMax = 10000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemTypeMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemTextMax = 200000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemMarksItemTypeMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemMarksMax = 20;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemContentMax = 10000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentSectionsItemsItemTitleMax = 160;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentSectionsItemsItemAuthoringNotesMax = 4000;


export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentSectionsItemsMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemNameMax = 80;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemFontSizeMin = 6;
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemFontSizeMax = 96;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMin = 0;
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMax = 144;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemLineHeightMax = 3;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsMin = 7;
export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsMax = 100;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentTemplateGuidanceMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentTemplateSectionGuidanceMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemTypeMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemTextMax = 200000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemMarksItemTypeMax = 40;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemMarksMax = 20;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemContentMax = 10000;

export const sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentMax = 10000;

export const sendAgentSharedTurnResponsePrivateResponseOneWebEvidenceMax = 15;


export const sendAgentSharedTurnResponsePrivateResponseOneSourcesItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneTitleMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneBriefMax = 10000;

export const sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemTitleMax = 200;

export const sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemPromptMax = 20000;

export const sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemNegativePromptMax = 5000;

export const sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesMax = 8;


export const sendAgentSharedTurnResponsePrivateResponseOneProposalsItemReviewDestructiveDefault = false;
export const sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemIdMax = 64;


export const sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemLabelMax = 300;

export const sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemIdMax = 64;


export const sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemLabelMax = 160;

export const sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemDescriptionMax = 300;

export const sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsMax = 8;

export const sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsMax = 6;



export const sendAgentSharedTurnResponse = zod.object({
  "message": zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "content": zod.string().nullable(),
  "assistantContent": zod.string().nullable(),
  "status": zod.enum(['running', 'completed', 'failed', 'interrupted', 'cancelled']),
  "restricted": zod.boolean(),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(sendAgentSharedTurnResponseMessageSourcesItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})).optional(),
  "evidenceMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "stoppedByAppUserId": zod.uuid().nullable()
}),
  "clientRequestId": zod.uuid(),
  "fileResult": zod.object({
  "operation": zod.enum(['create', 'update']),
  "workspaceId": zod.uuid(),
  "filename": zod.string().min(1).max(sendAgentSharedTurnResponseFileResultFilenameMax),
  "link": zod.string().regex(sendAgentSharedTurnResponseFileResultLinkRegExp),
  "state": zod.enum(['saved', 'unconfirmed'])
}).optional().describe('Current actor-private native file outcome. Present only after current record, evidence and original-save checks; never inferred from model text.'),
  "privateResponse": zod.union([zod.object({
  "tenderPreparationId": zod.uuid().optional(),
  "continuations": zod.array(zod.object({
  "workCard": zod.object({
  "version": zod.literal(1),
  "actionId": zod.uuid(),
  "revision": zod.int().min(1),
  "actionKey": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardActionKeyMax),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardTitleMax),
  "state": zod.enum(['needs_details', 'ready_for_review', 'awaiting_review', 'pending', 'uncertain', 'completed', 'failed', 'cancelled', 'stale', 'expired', 'native_only', 'read_only']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "nativeSchema": zod.enum(['#/components/schemas/AccountCreate', '#/components/schemas/EmailCampaignCreate', '#/components/schemas/CampaignBriefChange', '#/components/schemas/ContentHubAssetCreate', '#/components/schemas/CreateResearchThread', '#/components/schemas/CreateResearchDocument']).optional().describe('Canonical native input reference. The registered action schema owns its supported subset and all validation; field metadata is only a rendering hint.'),
  "fields": zod.array(zod.object({
  "name": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemNameMax),
  "label": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemLabelMax),
  "control": zod.enum(['text', 'multiline', 'select']),
  "required": zod.boolean(),
  "value": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemValueMax).optional(),
  "minLength": zod.int().min(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemMinLengthMin).optional(),
  "maxLength": zod.int().min(1).optional(),
  "options": zod.array(zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemOptionsItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemOptionsMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardFieldsMax),
  "missingInputs": zod.array(zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardMissingInputsItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardMissingInputsMax),
  "evidence": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardEvidenceItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardEvidenceMax).describe('Authorized source evidence only. Empty for supplied inert draft values; never infer source attribution.'),
  "availableActions": zod.array(zod.enum(['details', 'review', 'cancel', 'open_native', 'confirm', 'check_result'])).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardAvailableActionsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional(),
  "execution": zod.object({
  "replayed": zod.boolean().optional().describe('True for read-only receipt recovery or a review that found an existing execution. Only an explicit false on a fresh successful confirmation is eligible for create-and-open navigation.'),
  "id": zod.uuid(),
  "proposalId": zod.uuid(),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'partial', 'indeterminate']),
  "receipt": zod.record(zod.string(), zod.unknown()).nullable(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "auditIds": zod.array(zod.uuid()),
  "jobIds": zod.array(zod.uuid()),
  "startedAt": zod.iso.datetime({"offset":true}),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "dependencyOwner": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemWorkCardDependencyOwnerMax).optional(),
  "reviewRequired": zod.literal(true)
}).optional().describe('Server-derived presentation over private continuation and canonical proposal/receipt owners. Never accept a submitted card as authority or dispatch model-provided UI. Edits use the existing actionId/revision continuation request; confirmation uses the exact canonical proposal.'),
  "actionKey": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemActionKeyMax),
  "actionId": zod.uuid().optional(),
  "revision": zod.int().min(1).optional(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "state": zod.enum(['needs_details', 'ready_for_review', 'native_only', 'read_only']),
  "detailsMode": zod.enum(['exact_review', 'native_clarification', 'read_query']),
  "screenMode": zod.enum(['review_draft', 'native_workflow']),
  "destination": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemDestinationMax).regex(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemDestinationRegExp).describe('Exact server-allowlisted application route; never includes supplied private text.'),
  "draftEligible": zod.boolean().describe('True only for an existing inert local creation adapter. Required inputs and explicit proposal confirmation still apply.'),
  "minimumInputs": zod.array(zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemMinimumInputsItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemMinimumInputsMax),
  "missingInputs": zod.array(zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemMissingInputsItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemMissingInputsMax).describe('Invalid or missing field paths, never submitted values.'),
  "explanation": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemExplanationMax).optional(),
  "prefill": zod.object({
  "name": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillNameMax).optional(),
  "title": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillTitleMax).optional(),
  "subject": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillSubjectMax).optional(),
  "body": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillBodyMax).optional(),
  "content": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillContentMax).optional(),
  "markdown": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsItemPrefillMarkdownMax).optional(),
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional()
}).optional().describe('Editable non-authoritative values in this actor-private response. Transfer only within the same signed-in actor and scope; never in a URL.'),
  "reviewRequired": zod.literal(true)
}).describe('Non-authoritative choices for one recognized action. Recheck current scope, permissions, modules and native prerequisites before review or navigation. Never dispatch from these fields.')).max(sendAgentSharedTurnResponsePrivateResponseOneContinuationsMax).optional(),
  "suggestedSteps": zod.array(zod.object({
  "id": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemIdMax).regex(sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemIdRegExp),
  "kind": zod.enum(['ask', 'open']),
  "label": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemLabelMax),
  "description": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemDescriptionMax).optional(),
  "prompt": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemPromptMax).optional(),
  "destination": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemDestinationMax).regex(sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsItemDestinationRegExp).optional().describe('In-app route validated against the application navigation catalogue; required when kind is open.')
}).describe('A clickable next step the Agent recommends after its answer. `ask` sends `prompt` back to the Agent as the user\'s next message; `open` navigates to a server-validated in-app destination. Neither executes work; changes still need an exact review and confirmation, and destinations recheck access.')).max(sendAgentSharedTurnResponsePrivateResponseOneSuggestedStepsMax).optional().describe('Clickable next steps for the user after an answer that identifies work (for example what needs attention).'),
  "workspaceEvidence": zod.object({
  "id": zod.uuid(),
  "manifestHash": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "manifest": zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "workspaceId": zod.uuid(),
  "workspaceRevision": zod.uuid(),
  "contextFingerprint": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestContextFingerprintRegExp),
  "queryHash": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestQueryHashRegExp),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestChannelDefault),
  "retrievalMode": zod.enum(['lexical']),
  "maxEvidenceChars": zod.int().min(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMin).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMax),
  "maxPassages": zod.int().min(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMaxPassagesMin).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMaxPassagesMax),
  "state": zod.enum(['ready', 'partial', 'insufficient', 'conflicting', 'unavailable']),
  "message": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestMessageMax),
  "backgroundState": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestBackgroundStateMax),
  "passages": zod.array(zod.object({
  "id": zod.uuid(),
  "citation": zod.int().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemCitationMax),
  "kind": zod.enum(['workspace', 'knowledge', 'crm']),
  "tier": zod.enum(['primary', 'background']),
  "reason": zod.enum(['automatic', 'explicit', 'entity_background']),
  "role": zod.enum(['provided', 'working', 'submission']).nullable(),
  "membershipId": zod.uuid().nullable(),
  "membershipRevision": zod.uuid().nullable(),
  "folderRevision": zod.uuid().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "extractionRevision": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "managedDocumentId": zod.uuid().nullable(),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "knowledgeFileId": zod.uuid().nullable(),
  "indexDocumentId": zod.uuid().nullable(),
  "chunkId": zod.uuid().nullable(),
  "crmIdentity": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemCrmIdentityMax).nullable(),
  "sourceVersion": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemSourceVersionMax),
  "contentHash": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemContentHashRegExp),
  "excerptHash": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemExcerptHashRegExp),
  "label": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemLabelMax),
  "location": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemLocationMax),
  "excerpt": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemExcerptMax),
  "score": zod.number().min(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemScoreMin).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemScoreMax),
  "start": zod.int().min(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemStartMin).nullable(),
  "end": zod.int().min(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemEndMin).nullable()
})).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesMax),
  "sources": zod.array(zod.object({
  "membershipId": zod.uuid(),
  "role": zod.enum(['provided', 'working', 'submission']),
  "state": zod.enum(['excluded', 'stored', 'pending', 'ready', 'unsupported', 'failed', 'denied', 'stale', 'unavailable', 'irrelevant', 'omitted_budget']),
  "message": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestSourcesItemMessageMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestSourcesMax),
  "warnings": zod.array(zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestWarningsItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneWorkspaceEvidenceManifestWarningsMax)
})
}).optional(),
  "sow": zod.object({
  "proposalId": zod.uuid().optional(),
  "proposalRevision": zod.int().min(1).optional(),
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid(),
  "templateVersionId": zod.uuid(),
  "title": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoWorkspaceContextManifestHashRegExp)
}).optional(),
  "requestId": zod.uuid().nullish(),
  "facts": zod.object({
  "projectTitle": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsNarrativeItemTextMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsTablesItemRowsItemItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsTablesItemRowsItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsTablesItemRowsMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemIdMax),
  "title": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemTitleMax),
  "description": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemIdMax),
  "title": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemTitleMax),
  "description": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemIdMax),
  "milestones": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesItemNotesMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsInvoicesMax),
  "milestoneDays": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialReviewReasonMin).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsUnresolvedFactsItemMessageMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomFieldsItemValueMax).nullable()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomProseItemTextMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsItemItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}),
  "selectedSources": zod.array(zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'document', 'request']),
  "id": zod.uuid()
}).and(zod.object({
  "hash": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoHashRegExp),
  "revision": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoRevisionMax),
  "sourceKey": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoSourceKeyMax),
  "label": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoLabelMax),
  "excerpt": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoExcerptMax)
}))).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoSelectedSourcesMax),
  "confirmedFacts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoConfirmedFactsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoConfirmedFactsItemSourceIdsItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoConfirmedFactsItemSourceIdsMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoConfirmedFactsMax),
  "assumptions": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoAssumptionsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoAssumptionsItemSourceIdsItemMax)).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoAssumptionsItemSourceIdsMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoAssumptionsMax),
  "gaps": zod.array(zod.object({
  "field": zod.string(),
  "message": zod.string()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoGapsMax),
  "corrections": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string(),
  "after": zod.string(),
  "reason": zod.string()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoCorrectionsMax),
  "validation": zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsTopMin).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsRightMin).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMin).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMin).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderItemContentMax).optional()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemTypeMax),
  "text": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterItemContentMax).optional()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemFontSizeMin).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMin).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMin).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemLineHeightMax)
})).min(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsMin).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentTemplateSectionGuidanceItemGuidanceMax)
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemTypeMax),
  "text": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentItemContentMax).optional()
})).max(sendAgentSharedTurnResponsePrivateResponseOneSowTwoContentContentMax)
}),
  "sourceStatus": zod.enum(['current', 'stale'])
})).optional(),
  "webEvidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(sendAgentSharedTurnResponsePrivateResponseOneWebEvidenceMax).optional(),
  "reply": zod.string(),
  "conversationId": zod.uuid(),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(sendAgentSharedTurnResponsePrivateResponseOneSourcesItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})),
  "draftHandoffs": zod.array(zod.object({
  "channel": zod.enum(['email', 'social', 'quote', 'video_project']),
  "label": zod.string(),
  "deepLink": zod.string(),
  "draft": zod.string(),
  "videoProject": zod.union([zod.object({
  "mode": zod.enum(['single_clip', 'storyboard']),
  "title": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneTitleMax),
  "brief": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneBriefMax),
  "aspectRatio": zod.enum(['16:9', '9:16']),
  "scenes": zod.array(zod.object({
  "title": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemTitleMax),
  "prompt": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemPromptMax),
  "negativePrompt": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemNegativePromptMax).nullable(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)])
})).min(1).max(sendAgentSharedTurnResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesMax)
}),zod.null()]).optional(),
  "aiAuditId": zod.uuid().nullish()
})),
  "evidenceState": zod.enum(['ready', 'crm_only', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence']),
  "evidenceMessage": zod.string(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "proposals": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(sendAgentSharedTurnResponsePrivateResponseOneProposalsItemReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})),
  "clarification": zod.union([zod.object({
  "id": zod.uuid(),
  "questions": zod.array(zod.object({
  "id": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemIdMax).regex(sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemIdRegExp),
  "label": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemLabelMax),
  "mode": zod.enum(['single_choice', 'multiple_choice', 'text']),
  "options": zod.array(zod.object({
  "id": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemIdMax).regex(sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemIdRegExp),
  "label": zod.string().min(1).max(sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemLabelMax),
  "description": zod.string().max(sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemDescriptionMax).nullish()
})).max(sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsItemOptionsMax),
  "allowFreeText": zod.boolean()
})).min(1).max(sendAgentSharedTurnResponsePrivateResponseOneClarificationOneQuestionsMax)
}),zod.null()]).optional()
}),zod.null()])
})


export const getAgentSharedOperationParams = zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid()
})

export const getAgentSharedOperationQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid()
})


export const getAgentSharedOperationResponseMessageSourcesItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponseFileResultFilenameMax = 120;

export const getAgentSharedOperationResponseFileResultLinkRegExp = new RegExp('^/files(?:\\?entry=|/)[0-9a-fA-F-]{36}$');

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardActionKeyMax = 120;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardTitleMax = 300;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemNameMax = 120;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemLabelMax = 120;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemValueMax = 30000;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemMinLengthMin = 0;


export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemOptionsItemMax = 120;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemOptionsMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsMax = 20;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardMissingInputsItemMax = 120;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardMissingInputsMax = 40;


export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardEvidenceItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardEvidenceMax = 20;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardAvailableActionsMax = 8;


export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardProposalReviewDestructiveDefault = false;
export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardDependencyOwnerMax = 120;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemActionKeyMax = 120;


export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemDestinationMax = 500;


export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemDestinationRegExp = new RegExp('^/(?!/)[a-zA-Z0-9/?=&._-]+$');
export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemMinimumInputsItemMax = 120;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemMinimumInputsMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemMissingInputsItemMax = 120;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemMissingInputsMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemExplanationMax = 2000;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillNameMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillTitleMax = 300;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillSubjectMax = 500;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillBodyMax = 30000;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillContentMax = 30000;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillMarkdownMax = 30000;

export const getAgentSharedOperationResponsePrivateResponseOneContinuationsMax = 20;

export const getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemIdMax = 60;


export const getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemIdRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemLabelMax = 80;

export const getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemDescriptionMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemPromptMax = 500;

export const getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemDestinationMax = 500;


export const getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemDestinationRegExp = new RegExp('^/(?!/)[a-zA-Z0-9/?=&._-]+$');
export const getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsMax = 6;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestQueryHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestChannelDefault = `agent`;
export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMin = 2000;
export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMax = 24000;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMaxPassagesMin = 2;
export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMaxPassagesMax = 24;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMessageMax = 1000;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestBackgroundStateMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemCitationMax = 24;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemCrmIdentityMax = 150;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemSourceVersionMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemExcerptHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemLabelMax = 500;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemLocationMax = 500;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemExcerptMax = 2000;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemScoreMin = 0;
export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemScoreMax = 1;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemStartMin = 0;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemEndMin = 0;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesMax = 24;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestSourcesItemMessageMax = 1000;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestSourcesMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestWarningsItemMax = 1000;

export const getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestWarningsMax = 100;




export const getAgentSharedOperationResponsePrivateResponseOneSowTwoWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsProjectTitleMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomerNameMax = 300;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsAgreementIdMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsPreparedDateMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsStartDateMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsSprintWeeksMax = 52;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsNarrativeItemTextMax = 20000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsNarrativeMax = 5;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsTablesItemRowsItemItemMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsTablesItemRowsItemMax = 7;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsTablesItemRowsMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsTablesMax = 6;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemIdMax = 80;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemTitleMax = 300;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemDescriptionMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemIdMax = 80;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemTitleMax = 300;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemDescriptionMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemIdMax = 80;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemMilestonesMax = 500;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemDateMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemNotesMax = 2000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialReferenceMax = 300;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialSourceStatusMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialTermsMax = 20000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialAssumptionsMax = 20000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialExclusionsMax = 20000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialReviewReasonMin = 10;
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialReviewReasonMax = 2000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesItemTitleMax = 300;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsUnresolvedFactsItemFieldMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsUnresolvedFactsItemMessageMax = 2000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsUnresolvedFactsMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomFieldsItemSectionIdMax = 48;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomFieldsItemFieldIdMax = 48;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomFieldsItemValueMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomFieldsMax = 600;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomProseItemSectionIdMax = 48;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomProseItemTextMax = 20000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomProseMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesItemSectionIdMax = 48;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsItemItemMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsItemMax = 8;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoRevisionMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoSourceKeyMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoLabelMax = 500;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoExcerptMax = 12000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesMax = 20;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoConfirmedFactsItemQuoteMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoConfirmedFactsItemSourceIdsItemMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoConfirmedFactsItemSourceIdsMax = 20;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoConfirmedFactsMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoAssumptionsItemQuoteMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoAssumptionsItemSourceIdsItemMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoAssumptionsItemSourceIdsMax = 20;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoAssumptionsMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoGapsMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoCorrectionsMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsTopMin = 5;
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsTopMax = 50;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsRightMin = 5;
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsRightMax = 50;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMin = 5;
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMax = 50;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMin = 5;
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMax = 50;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemTypeMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemTextMax = 200000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemMarksMax = 20;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemContentMax = 10000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemTypeMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemTextMax = 200000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemMarksItemTypeMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemMarksMax = 20;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemContentMax = 10000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentSectionsItemsItemTitleMax = 160;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentSectionsItemsMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemNameMax = 80;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemFontSizeMin = 6;
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemFontSizeMax = 96;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemLineHeightMax = 3;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsMin = 7;
export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsMax = 100;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentTemplateGuidanceMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentTemplateSectionGuidanceMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemTypeMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemTextMax = 200000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemMarksItemTypeMax = 40;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemMarksMax = 20;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemContentMax = 10000;

export const getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentMax = 10000;

export const getAgentSharedOperationResponsePrivateResponseOneWebEvidenceMax = 15;


export const getAgentSharedOperationResponsePrivateResponseOneSourcesItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneTitleMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneBriefMax = 10000;

export const getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemTitleMax = 200;

export const getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemPromptMax = 20000;

export const getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemNegativePromptMax = 5000;

export const getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesMax = 8;


export const getAgentSharedOperationResponsePrivateResponseOneProposalsItemReviewDestructiveDefault = false;
export const getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemIdMax = 64;


export const getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemLabelMax = 300;

export const getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemIdMax = 64;


export const getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemLabelMax = 160;

export const getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemDescriptionMax = 300;

export const getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsMax = 8;

export const getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsMax = 6;



export const getAgentSharedOperationResponse = zod.object({
  "message": zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "content": zod.string().nullable(),
  "assistantContent": zod.string().nullable(),
  "status": zod.enum(['running', 'completed', 'failed', 'interrupted', 'cancelled']),
  "restricted": zod.boolean(),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(getAgentSharedOperationResponseMessageSourcesItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})).optional(),
  "evidenceMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "stoppedByAppUserId": zod.uuid().nullable()
}),
  "clientRequestId": zod.uuid(),
  "fileResult": zod.object({
  "operation": zod.enum(['create', 'update']),
  "workspaceId": zod.uuid(),
  "filename": zod.string().min(1).max(getAgentSharedOperationResponseFileResultFilenameMax),
  "link": zod.string().regex(getAgentSharedOperationResponseFileResultLinkRegExp),
  "state": zod.enum(['saved', 'unconfirmed'])
}).optional().describe('Current actor-private native file outcome. Present only after current record, evidence and original-save checks; never inferred from model text.'),
  "privateResponse": zod.union([zod.object({
  "tenderPreparationId": zod.uuid().optional(),
  "continuations": zod.array(zod.object({
  "workCard": zod.object({
  "version": zod.literal(1),
  "actionId": zod.uuid(),
  "revision": zod.int().min(1),
  "actionKey": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardActionKeyMax),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardTitleMax),
  "state": zod.enum(['needs_details', 'ready_for_review', 'awaiting_review', 'pending', 'uncertain', 'completed', 'failed', 'cancelled', 'stale', 'expired', 'native_only', 'read_only']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "nativeSchema": zod.enum(['#/components/schemas/AccountCreate', '#/components/schemas/EmailCampaignCreate', '#/components/schemas/CampaignBriefChange', '#/components/schemas/ContentHubAssetCreate', '#/components/schemas/CreateResearchThread', '#/components/schemas/CreateResearchDocument']).optional().describe('Canonical native input reference. The registered action schema owns its supported subset and all validation; field metadata is only a rendering hint.'),
  "fields": zod.array(zod.object({
  "name": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemNameMax),
  "label": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemLabelMax),
  "control": zod.enum(['text', 'multiline', 'select']),
  "required": zod.boolean(),
  "value": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemValueMax).optional(),
  "minLength": zod.int().min(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemMinLengthMin).optional(),
  "maxLength": zod.int().min(1).optional(),
  "options": zod.array(zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemOptionsItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsItemOptionsMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardFieldsMax),
  "missingInputs": zod.array(zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardMissingInputsItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardMissingInputsMax),
  "evidence": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardEvidenceItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardEvidenceMax).describe('Authorized source evidence only. Empty for supplied inert draft values; never infer source attribution.'),
  "availableActions": zod.array(zod.enum(['details', 'review', 'cancel', 'open_native', 'confirm', 'check_result'])).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardAvailableActionsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional(),
  "execution": zod.object({
  "replayed": zod.boolean().optional().describe('True for read-only receipt recovery or a review that found an existing execution. Only an explicit false on a fresh successful confirmation is eligible for create-and-open navigation.'),
  "id": zod.uuid(),
  "proposalId": zod.uuid(),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'partial', 'indeterminate']),
  "receipt": zod.record(zod.string(), zod.unknown()).nullable(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "auditIds": zod.array(zod.uuid()),
  "jobIds": zod.array(zod.uuid()),
  "startedAt": zod.iso.datetime({"offset":true}),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "dependencyOwner": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemWorkCardDependencyOwnerMax).optional(),
  "reviewRequired": zod.literal(true)
}).optional().describe('Server-derived presentation over private continuation and canonical proposal/receipt owners. Never accept a submitted card as authority or dispatch model-provided UI. Edits use the existing actionId/revision continuation request; confirmation uses the exact canonical proposal.'),
  "actionKey": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemActionKeyMax),
  "actionId": zod.uuid().optional(),
  "revision": zod.int().min(1).optional(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "state": zod.enum(['needs_details', 'ready_for_review', 'native_only', 'read_only']),
  "detailsMode": zod.enum(['exact_review', 'native_clarification', 'read_query']),
  "screenMode": zod.enum(['review_draft', 'native_workflow']),
  "destination": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemDestinationMax).regex(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemDestinationRegExp).describe('Exact server-allowlisted application route; never includes supplied private text.'),
  "draftEligible": zod.boolean().describe('True only for an existing inert local creation adapter. Required inputs and explicit proposal confirmation still apply.'),
  "minimumInputs": zod.array(zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemMinimumInputsItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemMinimumInputsMax),
  "missingInputs": zod.array(zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemMissingInputsItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemMissingInputsMax).describe('Invalid or missing field paths, never submitted values.'),
  "explanation": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemExplanationMax).optional(),
  "prefill": zod.object({
  "name": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillNameMax).optional(),
  "title": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillTitleMax).optional(),
  "subject": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillSubjectMax).optional(),
  "body": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillBodyMax).optional(),
  "content": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillContentMax).optional(),
  "markdown": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneContinuationsItemPrefillMarkdownMax).optional(),
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional()
}).optional().describe('Editable non-authoritative values in this actor-private response. Transfer only within the same signed-in actor and scope; never in a URL.'),
  "reviewRequired": zod.literal(true)
}).describe('Non-authoritative choices for one recognized action. Recheck current scope, permissions, modules and native prerequisites before review or navigation. Never dispatch from these fields.')).max(getAgentSharedOperationResponsePrivateResponseOneContinuationsMax).optional(),
  "suggestedSteps": zod.array(zod.object({
  "id": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemIdMax).regex(getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemIdRegExp),
  "kind": zod.enum(['ask', 'open']),
  "label": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemLabelMax),
  "description": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemDescriptionMax).optional(),
  "prompt": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemPromptMax).optional(),
  "destination": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemDestinationMax).regex(getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsItemDestinationRegExp).optional().describe('In-app route validated against the application navigation catalogue; required when kind is open.')
}).describe('A clickable next step the Agent recommends after its answer. `ask` sends `prompt` back to the Agent as the user\'s next message; `open` navigates to a server-validated in-app destination. Neither executes work; changes still need an exact review and confirmation, and destinations recheck access.')).max(getAgentSharedOperationResponsePrivateResponseOneSuggestedStepsMax).optional().describe('Clickable next steps for the user after an answer that identifies work (for example what needs attention).'),
  "workspaceEvidence": zod.object({
  "id": zod.uuid(),
  "manifestHash": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "manifest": zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "workspaceId": zod.uuid(),
  "workspaceRevision": zod.uuid(),
  "contextFingerprint": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestContextFingerprintRegExp),
  "queryHash": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestQueryHashRegExp),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestChannelDefault),
  "retrievalMode": zod.enum(['lexical']),
  "maxEvidenceChars": zod.int().min(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMin).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMax),
  "maxPassages": zod.int().min(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMaxPassagesMin).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMaxPassagesMax),
  "state": zod.enum(['ready', 'partial', 'insufficient', 'conflicting', 'unavailable']),
  "message": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestMessageMax),
  "backgroundState": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestBackgroundStateMax),
  "passages": zod.array(zod.object({
  "id": zod.uuid(),
  "citation": zod.int().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemCitationMax),
  "kind": zod.enum(['workspace', 'knowledge', 'crm']),
  "tier": zod.enum(['primary', 'background']),
  "reason": zod.enum(['automatic', 'explicit', 'entity_background']),
  "role": zod.enum(['provided', 'working', 'submission']).nullable(),
  "membershipId": zod.uuid().nullable(),
  "membershipRevision": zod.uuid().nullable(),
  "folderRevision": zod.uuid().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "extractionRevision": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "managedDocumentId": zod.uuid().nullable(),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "knowledgeFileId": zod.uuid().nullable(),
  "indexDocumentId": zod.uuid().nullable(),
  "chunkId": zod.uuid().nullable(),
  "crmIdentity": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemCrmIdentityMax).nullable(),
  "sourceVersion": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemSourceVersionMax),
  "contentHash": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemContentHashRegExp),
  "excerptHash": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemExcerptHashRegExp),
  "label": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemLabelMax),
  "location": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemLocationMax),
  "excerpt": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemExcerptMax),
  "score": zod.number().min(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemScoreMin).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemScoreMax),
  "start": zod.int().min(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemStartMin).nullable(),
  "end": zod.int().min(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesItemEndMin).nullable()
})).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestPassagesMax),
  "sources": zod.array(zod.object({
  "membershipId": zod.uuid(),
  "role": zod.enum(['provided', 'working', 'submission']),
  "state": zod.enum(['excluded', 'stored', 'pending', 'ready', 'unsupported', 'failed', 'denied', 'stale', 'unavailable', 'irrelevant', 'omitted_budget']),
  "message": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestSourcesItemMessageMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestSourcesMax),
  "warnings": zod.array(zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestWarningsItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneWorkspaceEvidenceManifestWarningsMax)
})
}).optional(),
  "sow": zod.object({
  "proposalId": zod.uuid().optional(),
  "proposalRevision": zod.int().min(1).optional(),
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid(),
  "templateVersionId": zod.uuid(),
  "title": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoWorkspaceContextManifestHashRegExp)
}).optional(),
  "requestId": zod.uuid().nullish(),
  "facts": zod.object({
  "projectTitle": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsNarrativeItemTextMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsTablesItemRowsItemItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsTablesItemRowsItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsTablesItemRowsMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemIdMax),
  "title": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemTitleMax),
  "description": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemIdMax),
  "title": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemTitleMax),
  "description": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemIdMax),
  "milestones": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesItemNotesMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsInvoicesMax),
  "milestoneDays": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialReviewReasonMin).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsUnresolvedFactsItemMessageMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomFieldsItemValueMax).nullable()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomProseItemTextMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsItemItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesItemRowsMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}),
  "selectedSources": zod.array(zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'document', 'request']),
  "id": zod.uuid()
}).and(zod.object({
  "hash": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoHashRegExp),
  "revision": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoRevisionMax),
  "sourceKey": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoSourceKeyMax),
  "label": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoLabelMax),
  "excerpt": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesItemTwoExcerptMax)
}))).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoSelectedSourcesMax),
  "confirmedFacts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoConfirmedFactsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoConfirmedFactsItemSourceIdsItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoConfirmedFactsItemSourceIdsMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoConfirmedFactsMax),
  "assumptions": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoAssumptionsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoAssumptionsItemSourceIdsItemMax)).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoAssumptionsItemSourceIdsMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoAssumptionsMax),
  "gaps": zod.array(zod.object({
  "field": zod.string(),
  "message": zod.string()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoGapsMax),
  "corrections": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string(),
  "after": zod.string(),
  "reason": zod.string()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoCorrectionsMax),
  "validation": zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsTopMin).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsRightMin).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMin).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMin).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderItemContentMax).optional()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterItemContentMax).optional()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemFontSizeMin).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMin).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMin).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsItemLineHeightMax)
})).min(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsMin).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemTypeMax),
  "text": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentItemContentMax).optional()
})).max(getAgentSharedOperationResponsePrivateResponseOneSowTwoContentContentMax)
}),
  "sourceStatus": zod.enum(['current', 'stale'])
})).optional(),
  "webEvidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(getAgentSharedOperationResponsePrivateResponseOneWebEvidenceMax).optional(),
  "reply": zod.string(),
  "conversationId": zod.uuid(),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(getAgentSharedOperationResponsePrivateResponseOneSourcesItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})),
  "draftHandoffs": zod.array(zod.object({
  "channel": zod.enum(['email', 'social', 'quote', 'video_project']),
  "label": zod.string(),
  "deepLink": zod.string(),
  "draft": zod.string(),
  "videoProject": zod.union([zod.object({
  "mode": zod.enum(['single_clip', 'storyboard']),
  "title": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneTitleMax),
  "brief": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneBriefMax),
  "aspectRatio": zod.enum(['16:9', '9:16']),
  "scenes": zod.array(zod.object({
  "title": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemTitleMax),
  "prompt": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemPromptMax),
  "negativePrompt": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesItemNegativePromptMax).nullable(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)])
})).min(1).max(getAgentSharedOperationResponsePrivateResponseOneDraftHandoffsItemVideoProjectOneScenesMax)
}),zod.null()]).optional(),
  "aiAuditId": zod.uuid().nullish()
})),
  "evidenceState": zod.enum(['ready', 'crm_only', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence']),
  "evidenceMessage": zod.string(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "proposals": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(getAgentSharedOperationResponsePrivateResponseOneProposalsItemReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})),
  "clarification": zod.union([zod.object({
  "id": zod.uuid(),
  "questions": zod.array(zod.object({
  "id": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemIdMax).regex(getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemIdRegExp),
  "label": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemLabelMax),
  "mode": zod.enum(['single_choice', 'multiple_choice', 'text']),
  "options": zod.array(zod.object({
  "id": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemIdMax).regex(getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemIdRegExp),
  "label": zod.string().min(1).max(getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemLabelMax),
  "description": zod.string().max(getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsItemDescriptionMax).nullish()
})).max(getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsItemOptionsMax),
  "allowFreeText": zod.boolean()
})).min(1).max(getAgentSharedOperationResponsePrivateResponseOneClarificationOneQuestionsMax)
}),zod.null()]).optional()
}),zod.null()])
})


export const stopAgentSharedTurnParams = zod.object({
  "id": zod.uuid(),
  "messageId": zod.uuid()
})

export const stopAgentSharedTurnBodyReasonMax = 500;



export const stopAgentSharedTurnBody = zod.object({
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "reason": zod.string().min(1).max(stopAgentSharedTurnBodyReasonMax)
})


export const stopAgentSharedTurnResponseSourcesItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const stopAgentSharedTurnResponse = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "content": zod.string().nullable(),
  "assistantContent": zod.string().nullable(),
  "status": zod.enum(['running', 'completed', 'failed', 'interrupted', 'cancelled']),
  "restricted": zod.boolean(),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(stopAgentSharedTurnResponseSourcesItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})).optional(),
  "evidenceMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "stoppedByAppUserId": zod.uuid().nullable()
})


export const listAgentSharedConversationsQueryLimitDefault = 25;
export const listAgentSharedConversationsQueryLimitMax = 100;

export const listAgentSharedConversationsQueryOffsetDefault = 0;
export const listAgentSharedConversationsQueryOffsetMin = 0;
export const listAgentSharedConversationsQueryOffsetMax = 100000;



export const listAgentSharedConversationsQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid(),
  "limit": zod.int().min(1).max(listAgentSharedConversationsQueryLimitMax).default(listAgentSharedConversationsQueryLimitDefault),
  "offset": zod.int().min(listAgentSharedConversationsQueryOffsetMin).max(listAgentSharedConversationsQueryOffsetMax).default(listAgentSharedConversationsQueryOffsetDefault)
})


export const listAgentSharedConversationsResponseTotalMin = 0;



export const listAgentSharedConversationsResponse = zod.object({
  "defaultConversationId": zod.uuid().nullish().describe('Current default shared thread for this exact record, independent of paging'),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "title": zod.string(),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "deleted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAgentSharedConversationsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createAgentSharedConversationBodyTitleMax = 200;



export const createAgentSharedConversationBody = zod.object({
  "useDefault": zod.boolean().optional().describe('Resolve or create the record default thread on an explicit first send; competing staff reuse the same active thread'),
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "title": zod.string().min(1).max(createAgentSharedConversationBodyTitleMax),
  "clientConversationId": zod.uuid()
})




export const createAgentSharedConversationResponse = zod.object({
  "id": zod.uuid(),
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "title": zod.string(),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "deleted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getAgentSharedConversationParams = zod.object({
  "id": zod.uuid()
})

export const getAgentSharedConversationQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "contextKind": zod.enum(['tender', 'campaign', 'content_asset', 'social_post', 'managed_document', 'microsite', 'sow_preparation']),
  "recordId": zod.uuid()
})




export const getAgentSharedConversationResponse = zod.object({
  "id": zod.uuid(),
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "title": zod.string(),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "deleted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const updateAgentSharedConversationParams = zod.object({
  "id": zod.uuid()
})


export const updateAgentSharedConversationBodyTitleMax = 200;



export const updateAgentSharedConversationBody = zod.object({
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "expectedRevision": zod.int().min(1),
  "title": zod.string().min(1).max(updateAgentSharedConversationBodyTitleMax).optional(),
  "deleted": zod.literal(true).optional()
})




export const updateAgentSharedConversationResponse = zod.object({
  "id": zod.uuid(),
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "title": zod.string(),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "deleted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listAgentConversationsQueryModeDefault = `internal`;
export const listAgentConversationsQueryLimitDefault = 25;
export const listAgentConversationsQueryLimitMax = 100;

export const listAgentConversationsQueryOffsetDefault = 0;
export const listAgentConversationsQueryOffsetMin = 0;
export const listAgentConversationsQueryOffsetMax = 100000;



export const listAgentConversationsQueryParams = zod.object({
  "mode": zod.enum(['internal', 'public_research']).default(listAgentConversationsQueryModeDefault),
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAgentConversationsQueryLimitMax).default(listAgentConversationsQueryLimitDefault),
  "offset": zod.int().min(listAgentConversationsQueryOffsetMin).max(listAgentConversationsQueryOffsetMax).default(listAgentConversationsQueryOffsetDefault)
})

export const listAgentConversationsResponseTotalMin = 0;



export const listAgentConversationsResponse = zod.object({
  "items": zod.array(zod.object({
  "mode": zod.enum(['internal', 'public_research']).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string(),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAgentConversationsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createAgentConversationBodyModeDefault = `internal`;
export const createAgentConversationBodyTitleMax = 200;



export const createAgentConversationBody = zod.object({
  "clientConversationId": zod.uuid().optional().describe('Optional immutable reservation ID; exact retries recover the original empty chat even after rename'),
  "mode": zod.enum(['internal', 'public_research']).default(createAgentConversationBodyModeDefault),
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string().min(1).max(createAgentConversationBodyTitleMax)
})

export const createAgentConversationResponse = zod.object({
  "mode": zod.enum(['internal', 'public_research']).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string(),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getAgentConversationParams = zod.object({
  "id": zod.uuid()
})

export const getAgentConversationQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional()
})

export const getAgentConversationResponse = zod.object({
  "mode": zod.enum(['internal', 'public_research']).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string(),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const updateAgentConversationParams = zod.object({
  "id": zod.uuid()
})


export const updateAgentConversationBodyTitleMax = 200;



export const updateAgentConversationBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "expectedRevision": zod.int().min(1),
  "title": zod.string().min(1).max(updateAgentConversationBodyTitleMax).optional(),
  "deleted": zod.literal(true).optional()
})

export const updateAgentConversationResponse = zod.object({
  "mode": zod.enum(['internal', 'public_research']).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string(),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Paged list of the other assistants (authorized scopes and research or internal modes) the signed-in person may hand a private saved chat to.
 * @summary List assistants a saved chat can be handed to
 */
export const listAgentHandoffDestinationsQueryModeDefault = `internal`;
export const listAgentHandoffDestinationsQuerySearchMax = 120;

export const listAgentHandoffDestinationsQueryLimitDefault = 25;
export const listAgentHandoffDestinationsQueryLimitMax = 100;

export const listAgentHandoffDestinationsQueryOffsetDefault = 0;
export const listAgentHandoffDestinationsQueryOffsetMin = 0;
export const listAgentHandoffDestinationsQueryOffsetMax = 100000;



export const listAgentHandoffDestinationsQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "mode": zod.enum(['internal', 'public_research']).default(listAgentHandoffDestinationsQueryModeDefault),
  "search": zod.string().max(listAgentHandoffDestinationsQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listAgentHandoffDestinationsQueryLimitMax).default(listAgentHandoffDestinationsQueryLimitDefault),
  "offset": zod.int().min(listAgentHandoffDestinationsQueryOffsetMin).max(listAgentHandoffDestinationsQueryOffsetMax).default(listAgentHandoffDestinationsQueryOffsetDefault)
})

export const listAgentHandoffDestinationsResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string(),
  "target": zod.object({
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "mode": zod.enum(['internal', 'public_research'])
}),
  "label": zod.string(),
  "assistant": zod.enum(['assistant', 'research'])
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Prepares an actor-private, expiring hand-off review. Nothing is copied until the person confirms it.
 * @summary Review which messages a chat hand-off copies
 */
export const reviewAgentHandoffParams = zod.object({
  "id": zod.uuid()
})

export const reviewAgentHandoffBodyExcludedMessageIdsMax = 200;



export const reviewAgentHandoffBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "destination": zod.object({
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "mode": zod.enum(['internal', 'public_research'])
}),
  "excludedMessageIds": zod.array(zod.uuid()).max(reviewAgentHandoffBodyExcludedMessageIdsMax).optional()
})

export const reviewAgentHandoffResponseMessagesMax = 200;



export const reviewAgentHandoffResponse = zod.object({
  "handoffId": zod.uuid(),
  "reviewToken": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "sourceTitle": zod.string(),
  "destination": zod.object({
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "mode": zod.enum(['internal', 'public_research'])
}),
  "destinationLabel": zod.string(),
  "messages": zod.array(zod.object({
  "id": zod.uuid(),
  "preview": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "included": zod.boolean(),
  "evidenceCount": zod.int(),
  "attachmentCount": zod.int()
})).max(reviewAgentHandoffResponseMessagesMax),
  "includedCount": zod.int(),
  "excludedMessageIds": zod.array(zod.uuid()),
  "notes": zod.array(zod.string())
})


/**
 * Copies the reviewed messages into a new private chat in the destination assistant. The source chat is unchanged. Retrying the same request returns the same receipt.
 * @summary Confirm a reviewed chat hand-off
 */
export const confirmAgentHandoffParams = zod.object({
  "id": zod.uuid()
})

export const confirmAgentHandoffBodyReviewTokenMin = 43;
export const confirmAgentHandoffBodyReviewTokenMax = 128;

export const confirmAgentHandoffBodyExcludedMessageIdsMax = 200;



export const confirmAgentHandoffBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "handoffId": zod.uuid(),
  "reviewToken": zod.string().min(confirmAgentHandoffBodyReviewTokenMin).max(confirmAgentHandoffBodyReviewTokenMax),
  "excludedMessageIds": zod.array(zod.uuid()).max(confirmAgentHandoffBodyExcludedMessageIdsMax),
  "requestId": zod.uuid()
})

export const confirmAgentHandoffResponse = zod.object({
  "handoffId": zod.uuid(),
  "status": zod.enum(['confirmed']),
  "conversation": zod.object({
  "mode": zod.enum(['internal', 'public_research']).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string(),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "copiedMessages": zod.int()
})


export const exportAgentPromptsBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team'])
})

export const exportAgentPromptsResponsePromptsItemTargetsItemKeyMax = 100;

export const exportAgentPromptsResponsePromptsItemTargetsMax = 20;

export const exportAgentPromptsResponsePromptsItemTitleMax = 120;

export const exportAgentPromptsResponsePromptsItemContentMax = 4000;

export const exportAgentPromptsResponsePromptsItemDescriptionDefault = ``;
export const exportAgentPromptsResponsePromptsItemDescriptionMax = 500;

export const exportAgentPromptsResponsePromptsItemCategoryDefault = `general`;
export const exportAgentPromptsResponsePromptsItemCategoryMax = 60;

export const exportAgentPromptsResponsePromptsItemIsActiveDefault = true;
export const exportAgentPromptsResponsePromptsItemSortOrderDefault = 0;
export const exportAgentPromptsResponsePromptsItemSortOrderMin = 0;
export const exportAgentPromptsResponsePromptsItemSortOrderMax = 100000;

export const exportAgentPromptsResponsePromptsMax = 100;



export const exportAgentPromptsResponse = zod.object({
  "kind": zod.enum(['agent-prompts']),
  "version": zod.literal(1),
  "prompts": zod.array(zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(exportAgentPromptsResponsePromptsItemTargetsItemKeyMax).optional()
})).min(1).max(exportAgentPromptsResponsePromptsItemTargetsMax).optional(),
  "title": zod.string().min(1).max(exportAgentPromptsResponsePromptsItemTitleMax),
  "content": zod.string().min(1).max(exportAgentPromptsResponsePromptsItemContentMax),
  "description": zod.string().max(exportAgentPromptsResponsePromptsItemDescriptionMax).default(exportAgentPromptsResponsePromptsItemDescriptionDefault),
  "category": zod.string().min(1).max(exportAgentPromptsResponsePromptsItemCategoryMax).default(exportAgentPromptsResponsePromptsItemCategoryDefault),
  "isActive": zod.boolean().default(exportAgentPromptsResponsePromptsItemIsActiveDefault),
  "sortOrder": zod.int().min(exportAgentPromptsResponsePromptsItemSortOrderMin).max(exportAgentPromptsResponsePromptsItemSortOrderMax).default(exportAgentPromptsResponsePromptsItemSortOrderDefault)
})).max(exportAgentPromptsResponsePromptsMax)
})


export const previewAgentPromptImportBodyFilePromptsItemTargetsItemKeyMax = 100;

export const previewAgentPromptImportBodyFilePromptsItemTargetsMax = 20;

export const previewAgentPromptImportBodyFilePromptsItemTitleMax = 120;

export const previewAgentPromptImportBodyFilePromptsItemContentMax = 4000;

export const previewAgentPromptImportBodyFilePromptsItemDescriptionDefault = ``;
export const previewAgentPromptImportBodyFilePromptsItemDescriptionMax = 500;

export const previewAgentPromptImportBodyFilePromptsItemCategoryDefault = `general`;
export const previewAgentPromptImportBodyFilePromptsItemCategoryMax = 60;

export const previewAgentPromptImportBodyFilePromptsItemIsActiveDefault = true;
export const previewAgentPromptImportBodyFilePromptsItemSortOrderDefault = 0;
export const previewAgentPromptImportBodyFilePromptsItemSortOrderMin = 0;
export const previewAgentPromptImportBodyFilePromptsItemSortOrderMax = 100000;

export const previewAgentPromptImportBodyFilePromptsMax = 100;



export const previewAgentPromptImportBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "mode": zod.enum(['add', 'update', 'replace']),
  "file": zod.object({
  "kind": zod.enum(['agent-prompts']),
  "version": zod.literal(1),
  "prompts": zod.array(zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(previewAgentPromptImportBodyFilePromptsItemTargetsItemKeyMax).optional()
})).min(1).max(previewAgentPromptImportBodyFilePromptsItemTargetsMax).optional(),
  "title": zod.string().min(1).max(previewAgentPromptImportBodyFilePromptsItemTitleMax),
  "content": zod.string().min(1).max(previewAgentPromptImportBodyFilePromptsItemContentMax),
  "description": zod.string().max(previewAgentPromptImportBodyFilePromptsItemDescriptionMax).default(previewAgentPromptImportBodyFilePromptsItemDescriptionDefault),
  "category": zod.string().min(1).max(previewAgentPromptImportBodyFilePromptsItemCategoryMax).default(previewAgentPromptImportBodyFilePromptsItemCategoryDefault),
  "isActive": zod.boolean().default(previewAgentPromptImportBodyFilePromptsItemIsActiveDefault),
  "sortOrder": zod.int().min(previewAgentPromptImportBodyFilePromptsItemSortOrderMin).max(previewAgentPromptImportBodyFilePromptsItemSortOrderMax).default(previewAgentPromptImportBodyFilePromptsItemSortOrderDefault)
})).max(previewAgentPromptImportBodyFilePromptsMax)
})
})

export const previewAgentPromptImportResponseInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewAgentPromptImportResponseAdditionsMax = 100;

export const previewAgentPromptImportResponseUpdatesMax = 100;

export const previewAgentPromptImportResponseRemovalsMax = 1000;

export const previewAgentPromptImportResponseConflictsMax = 1100;



export const previewAgentPromptImportResponse = zod.object({
  "previewId": zod.uuid(),
  "inputHash": zod.string().regex(previewAgentPromptImportResponseInputHashRegExp),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "mode": zod.enum(['add', 'update', 'replace']),
  "visibility": zod.enum(['personal', 'team']),
  "additions": zod.array(zod.string()).max(previewAgentPromptImportResponseAdditionsMax),
  "updates": zod.array(zod.string()).max(previewAgentPromptImportResponseUpdatesMax),
  "removals": zod.array(zod.string()).max(previewAgentPromptImportResponseRemovalsMax),
  "conflicts": zod.array(zod.string()).max(previewAgentPromptImportResponseConflictsMax),
  "canApply": zod.boolean()
})


export const applyAgentPromptImportBodyInputHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const applyAgentPromptImportBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "previewId": zod.uuid(),
  "inputHash": zod.string().regex(applyAgentPromptImportBodyInputHashRegExp),
  "confirmed": zod.literal(true)
})

export const applyAgentPromptImportResponseAddedMin = 0;

export const applyAgentPromptImportResponseUpdatedMin = 0;

export const applyAgentPromptImportResponseRemovedMin = 0;



export const applyAgentPromptImportResponse = zod.object({
  "previewId": zod.uuid(),
  "inputHash": zod.string(),
  "added": zod.int().min(applyAgentPromptImportResponseAddedMin),
  "updated": zod.int().min(applyAgentPromptImportResponseUpdatedMin),
  "removed": zod.int().min(applyAgentPromptImportResponseRemovedMin),
  "appliedAt": zod.iso.datetime({"offset":true})
})





export const copyAgentPromptToEntityBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "clientEntryId": zod.uuid()
})

export const copyAgentPromptToEntityResponseTargetsItemKeyMax = 100;

export const copyAgentPromptToEntityResponseTargetsMax = 20;


export const copyAgentPromptToEntityResponseDescriptionMax = 500;

export const copyAgentPromptToEntityResponseCategoryMax = 60;

export const copyAgentPromptToEntityResponseSortOrderMin = 0;
export const copyAgentPromptToEntityResponseSortOrderMax = 100000;


export const copyAgentPromptToEntityResponsePromptsItemContentMax = 4000;

export const copyAgentPromptToEntityResponsePromptsMax = 20;



export const copyAgentPromptToEntityResponse = zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(copyAgentPromptToEntityResponseTargetsItemKeyMax).optional()
})).min(1).max(copyAgentPromptToEntityResponseTargetsMax).optional(),
  "origin": zod.enum(['personal', 'entity', 'tenant', 'platform']).optional(),
  "inherited": zod.boolean().optional(),
  "copiedFrom": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid()
}),zod.null()]).optional(),
  "description": zod.string().max(copyAgentPromptToEntityResponseDescriptionMax).optional(),
  "category": zod.string().max(copyAgentPromptToEntityResponseCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(copyAgentPromptToEntityResponseSortOrderMin).max(copyAgentPromptToEntityResponseSortOrderMax).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "kind": zod.enum(['prompt', 'review_set']),
  "title": zod.string(),
  "content": zod.string(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(copyAgentPromptToEntityResponsePromptsItemContentMax)
})).max(copyAgentPromptToEntityResponsePromptsMax),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "canEdit": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listAgentPromptsQueryFunctionKeyMax = 100;

export const listAgentPromptsQueryModuleKeyMax = 100;

export const listAgentPromptsQuerySearchMax = 200;

export const listAgentPromptsQueryCategoryMax = 60;

export const listAgentPromptsQueryStatusDefault = `all`;
export const listAgentPromptsQueryLimitDefault = 25;
export const listAgentPromptsQueryLimitMax = 100;

export const listAgentPromptsQueryOffsetDefault = 0;
export const listAgentPromptsQueryOffsetMin = 0;
export const listAgentPromptsQueryOffsetMax = 100000;



export const listAgentPromptsQueryParams = zod.object({
  "origin": zod.enum(['personal', 'entity', 'tenant']).optional(),
  "functionKey": zod.string().min(1).max(listAgentPromptsQueryFunctionKeyMax).optional(),
  "moduleKey": zod.string().min(1).max(listAgentPromptsQueryModuleKeyMax).optional(),
  "search": zod.string().max(listAgentPromptsQuerySearchMax).optional(),
  "category": zod.string().max(listAgentPromptsQueryCategoryMax).optional(),
  "status": zod.enum(['all', 'active', 'inactive']).default(listAgentPromptsQueryStatusDefault),
  "visibility": zod.enum(['personal', 'team']).optional(),
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAgentPromptsQueryLimitMax).default(listAgentPromptsQueryLimitDefault),
  "offset": zod.int().min(listAgentPromptsQueryOffsetMin).max(listAgentPromptsQueryOffsetMax).default(listAgentPromptsQueryOffsetDefault)
})

export const listAgentPromptsResponseItemsItemTargetsItemKeyMax = 100;

export const listAgentPromptsResponseItemsItemTargetsMax = 20;


export const listAgentPromptsResponseItemsItemDescriptionMax = 500;

export const listAgentPromptsResponseItemsItemCategoryMax = 60;

export const listAgentPromptsResponseItemsItemSortOrderMin = 0;
export const listAgentPromptsResponseItemsItemSortOrderMax = 100000;


export const listAgentPromptsResponseItemsItemPromptsItemContentMax = 4000;

export const listAgentPromptsResponseItemsItemPromptsMax = 20;

export const listAgentPromptsResponseTotalMin = 0;



export const listAgentPromptsResponse = zod.object({
  "items": zod.array(zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(listAgentPromptsResponseItemsItemTargetsItemKeyMax).optional()
})).min(1).max(listAgentPromptsResponseItemsItemTargetsMax).optional(),
  "origin": zod.enum(['personal', 'entity', 'tenant', 'platform']).optional(),
  "inherited": zod.boolean().optional(),
  "copiedFrom": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid()
}),zod.null()]).optional(),
  "description": zod.string().max(listAgentPromptsResponseItemsItemDescriptionMax).optional(),
  "category": zod.string().max(listAgentPromptsResponseItemsItemCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(listAgentPromptsResponseItemsItemSortOrderMin).max(listAgentPromptsResponseItemsItemSortOrderMax).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "kind": zod.enum(['prompt', 'review_set']),
  "title": zod.string(),
  "content": zod.string(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(listAgentPromptsResponseItemsItemPromptsItemContentMax)
})).max(listAgentPromptsResponseItemsItemPromptsMax),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "canEdit": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAgentPromptsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createAgentPromptBodyTargetsItemKeyMax = 100;

export const createAgentPromptBodyTargetsMax = 20;

export const createAgentPromptBodyDescriptionMax = 500;

export const createAgentPromptBodyCategoryMax = 60;

export const createAgentPromptBodySortOrderMin = 0;
export const createAgentPromptBodySortOrderMax = 100000;

export const createAgentPromptBodyTitleMax = 120;

export const createAgentPromptBodyContentMax = 4000;



export const createAgentPromptBody = zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(createAgentPromptBodyTargetsItemKeyMax).optional()
})).min(1).max(createAgentPromptBodyTargetsMax).optional(),
  "description": zod.string().max(createAgentPromptBodyDescriptionMax).optional(),
  "category": zod.string().min(1).max(createAgentPromptBodyCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(createAgentPromptBodySortOrderMin).max(createAgentPromptBodySortOrderMax).optional(),
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "title": zod.string().min(1).max(createAgentPromptBodyTitleMax),
  "content": zod.string().min(1).max(createAgentPromptBodyContentMax)
})

export const createAgentPromptResponseTargetsItemKeyMax = 100;

export const createAgentPromptResponseTargetsMax = 20;


export const createAgentPromptResponseDescriptionMax = 500;

export const createAgentPromptResponseCategoryMax = 60;

export const createAgentPromptResponseSortOrderMin = 0;
export const createAgentPromptResponseSortOrderMax = 100000;


export const createAgentPromptResponsePromptsItemContentMax = 4000;

export const createAgentPromptResponsePromptsMax = 20;



export const createAgentPromptResponse = zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(createAgentPromptResponseTargetsItemKeyMax).optional()
})).min(1).max(createAgentPromptResponseTargetsMax).optional(),
  "origin": zod.enum(['personal', 'entity', 'tenant', 'platform']).optional(),
  "inherited": zod.boolean().optional(),
  "copiedFrom": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid()
}),zod.null()]).optional(),
  "description": zod.string().max(createAgentPromptResponseDescriptionMax).optional(),
  "category": zod.string().max(createAgentPromptResponseCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(createAgentPromptResponseSortOrderMin).max(createAgentPromptResponseSortOrderMax).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "kind": zod.enum(['prompt', 'review_set']),
  "title": zod.string(),
  "content": zod.string(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(createAgentPromptResponsePromptsItemContentMax)
})).max(createAgentPromptResponsePromptsMax),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "canEdit": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getAgentPromptParams = zod.object({
  "id": zod.uuid()
})

export const getAgentPromptQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional()
})

export const getAgentPromptResponseTargetsItemKeyMax = 100;

export const getAgentPromptResponseTargetsMax = 20;


export const getAgentPromptResponseDescriptionMax = 500;

export const getAgentPromptResponseCategoryMax = 60;

export const getAgentPromptResponseSortOrderMin = 0;
export const getAgentPromptResponseSortOrderMax = 100000;


export const getAgentPromptResponsePromptsItemContentMax = 4000;

export const getAgentPromptResponsePromptsMax = 20;



export const getAgentPromptResponse = zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(getAgentPromptResponseTargetsItemKeyMax).optional()
})).min(1).max(getAgentPromptResponseTargetsMax).optional(),
  "origin": zod.enum(['personal', 'entity', 'tenant', 'platform']).optional(),
  "inherited": zod.boolean().optional(),
  "copiedFrom": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid()
}),zod.null()]).optional(),
  "description": zod.string().max(getAgentPromptResponseDescriptionMax).optional(),
  "category": zod.string().max(getAgentPromptResponseCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(getAgentPromptResponseSortOrderMin).max(getAgentPromptResponseSortOrderMax).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "kind": zod.enum(['prompt', 'review_set']),
  "title": zod.string(),
  "content": zod.string(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(getAgentPromptResponsePromptsItemContentMax)
})).max(getAgentPromptResponsePromptsMax),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "canEdit": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const updateAgentPromptParams = zod.object({
  "id": zod.uuid()
})

export const updateAgentPromptBodyTargetsItemKeyMax = 100;

export const updateAgentPromptBodyTargetsMax = 20;

export const updateAgentPromptBodyDescriptionMax = 500;

export const updateAgentPromptBodyCategoryMax = 60;

export const updateAgentPromptBodySortOrderMin = 0;
export const updateAgentPromptBodySortOrderMax = 100000;


export const updateAgentPromptBodyTitleMax = 120;

export const updateAgentPromptBodyContentMax = 4000;



export const updateAgentPromptBody = zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(updateAgentPromptBodyTargetsItemKeyMax).optional()
})).min(1).max(updateAgentPromptBodyTargetsMax).optional(),
  "description": zod.string().max(updateAgentPromptBodyDescriptionMax).optional(),
  "category": zod.string().min(1).max(updateAgentPromptBodyCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(updateAgentPromptBodySortOrderMin).max(updateAgentPromptBodySortOrderMax).optional(),
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "expectedRevision": zod.int().min(1),
  "title": zod.string().min(1).max(updateAgentPromptBodyTitleMax).optional(),
  "content": zod.string().min(1).max(updateAgentPromptBodyContentMax).optional(),
  "deleted": zod.literal(true).optional()
})

export const updateAgentPromptResponseTargetsItemKeyMax = 100;

export const updateAgentPromptResponseTargetsMax = 20;


export const updateAgentPromptResponseDescriptionMax = 500;

export const updateAgentPromptResponseCategoryMax = 60;

export const updateAgentPromptResponseSortOrderMin = 0;
export const updateAgentPromptResponseSortOrderMax = 100000;


export const updateAgentPromptResponsePromptsItemContentMax = 4000;

export const updateAgentPromptResponsePromptsMax = 20;



export const updateAgentPromptResponse = zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(updateAgentPromptResponseTargetsItemKeyMax).optional()
})).min(1).max(updateAgentPromptResponseTargetsMax).optional(),
  "origin": zod.enum(['personal', 'entity', 'tenant', 'platform']).optional(),
  "inherited": zod.boolean().optional(),
  "copiedFrom": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid()
}),zod.null()]).optional(),
  "description": zod.string().max(updateAgentPromptResponseDescriptionMax).optional(),
  "category": zod.string().max(updateAgentPromptResponseCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(updateAgentPromptResponseSortOrderMin).max(updateAgentPromptResponseSortOrderMax).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "kind": zod.enum(['prompt', 'review_set']),
  "title": zod.string(),
  "content": zod.string(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(updateAgentPromptResponsePromptsItemContentMax)
})).max(updateAgentPromptResponsePromptsMax),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "canEdit": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listAgentReviewSetsQueryLimitDefault = 25;
export const listAgentReviewSetsQueryLimitMax = 100;

export const listAgentReviewSetsQueryOffsetDefault = 0;
export const listAgentReviewSetsQueryOffsetMin = 0;
export const listAgentReviewSetsQueryOffsetMax = 100000;



export const listAgentReviewSetsQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAgentReviewSetsQueryLimitMax).default(listAgentReviewSetsQueryLimitDefault),
  "offset": zod.int().min(listAgentReviewSetsQueryOffsetMin).max(listAgentReviewSetsQueryOffsetMax).default(listAgentReviewSetsQueryOffsetDefault)
})

export const listAgentReviewSetsResponseItemsItemTargetsItemKeyMax = 100;

export const listAgentReviewSetsResponseItemsItemTargetsMax = 20;


export const listAgentReviewSetsResponseItemsItemDescriptionMax = 500;

export const listAgentReviewSetsResponseItemsItemCategoryMax = 60;

export const listAgentReviewSetsResponseItemsItemSortOrderMin = 0;
export const listAgentReviewSetsResponseItemsItemSortOrderMax = 100000;


export const listAgentReviewSetsResponseItemsItemPromptsItemContentMax = 4000;

export const listAgentReviewSetsResponseItemsItemPromptsMax = 20;

export const listAgentReviewSetsResponseTotalMin = 0;



export const listAgentReviewSetsResponse = zod.object({
  "items": zod.array(zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(listAgentReviewSetsResponseItemsItemTargetsItemKeyMax).optional()
})).min(1).max(listAgentReviewSetsResponseItemsItemTargetsMax).optional(),
  "origin": zod.enum(['personal', 'entity', 'tenant', 'platform']).optional(),
  "inherited": zod.boolean().optional(),
  "copiedFrom": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid()
}),zod.null()]).optional(),
  "description": zod.string().max(listAgentReviewSetsResponseItemsItemDescriptionMax).optional(),
  "category": zod.string().max(listAgentReviewSetsResponseItemsItemCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(listAgentReviewSetsResponseItemsItemSortOrderMin).max(listAgentReviewSetsResponseItemsItemSortOrderMax).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "kind": zod.enum(['prompt', 'review_set']),
  "title": zod.string(),
  "content": zod.string(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(listAgentReviewSetsResponseItemsItemPromptsItemContentMax)
})).max(listAgentReviewSetsResponseItemsItemPromptsMax),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "canEdit": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAgentReviewSetsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createAgentReviewSetBodyTitleMax = 120;


export const createAgentReviewSetBodyPromptsMax = 20;



export const createAgentReviewSetBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "title": zod.string().min(1).max(createAgentReviewSetBodyTitleMax),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
})).min(1).max(createAgentReviewSetBodyPromptsMax)
})

export const createAgentReviewSetResponseTargetsItemKeyMax = 100;

export const createAgentReviewSetResponseTargetsMax = 20;


export const createAgentReviewSetResponseDescriptionMax = 500;

export const createAgentReviewSetResponseCategoryMax = 60;

export const createAgentReviewSetResponseSortOrderMin = 0;
export const createAgentReviewSetResponseSortOrderMax = 100000;


export const createAgentReviewSetResponsePromptsItemContentMax = 4000;

export const createAgentReviewSetResponsePromptsMax = 20;



export const createAgentReviewSetResponse = zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(createAgentReviewSetResponseTargetsItemKeyMax).optional()
})).min(1).max(createAgentReviewSetResponseTargetsMax).optional(),
  "origin": zod.enum(['personal', 'entity', 'tenant', 'platform']).optional(),
  "inherited": zod.boolean().optional(),
  "copiedFrom": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid()
}),zod.null()]).optional(),
  "description": zod.string().max(createAgentReviewSetResponseDescriptionMax).optional(),
  "category": zod.string().max(createAgentReviewSetResponseCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(createAgentReviewSetResponseSortOrderMin).max(createAgentReviewSetResponseSortOrderMax).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "kind": zod.enum(['prompt', 'review_set']),
  "title": zod.string(),
  "content": zod.string(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(createAgentReviewSetResponsePromptsItemContentMax)
})).max(createAgentReviewSetResponsePromptsMax),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "canEdit": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getAgentReviewSetParams = zod.object({
  "id": zod.uuid()
})

export const getAgentReviewSetQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional()
})

export const getAgentReviewSetResponseTargetsItemKeyMax = 100;

export const getAgentReviewSetResponseTargetsMax = 20;


export const getAgentReviewSetResponseDescriptionMax = 500;

export const getAgentReviewSetResponseCategoryMax = 60;

export const getAgentReviewSetResponseSortOrderMin = 0;
export const getAgentReviewSetResponseSortOrderMax = 100000;


export const getAgentReviewSetResponsePromptsItemContentMax = 4000;

export const getAgentReviewSetResponsePromptsMax = 20;



export const getAgentReviewSetResponse = zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(getAgentReviewSetResponseTargetsItemKeyMax).optional()
})).min(1).max(getAgentReviewSetResponseTargetsMax).optional(),
  "origin": zod.enum(['personal', 'entity', 'tenant', 'platform']).optional(),
  "inherited": zod.boolean().optional(),
  "copiedFrom": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid()
}),zod.null()]).optional(),
  "description": zod.string().max(getAgentReviewSetResponseDescriptionMax).optional(),
  "category": zod.string().max(getAgentReviewSetResponseCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(getAgentReviewSetResponseSortOrderMin).max(getAgentReviewSetResponseSortOrderMax).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "kind": zod.enum(['prompt', 'review_set']),
  "title": zod.string(),
  "content": zod.string(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(getAgentReviewSetResponsePromptsItemContentMax)
})).max(getAgentReviewSetResponsePromptsMax),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "canEdit": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const updateAgentReviewSetParams = zod.object({
  "id": zod.uuid()
})


export const updateAgentReviewSetBodyTitleMax = 120;


export const updateAgentReviewSetBodyPromptsMax = 20;



export const updateAgentReviewSetBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "expectedRevision": zod.int().min(1),
  "title": zod.string().min(1).max(updateAgentReviewSetBodyTitleMax).optional(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
})).min(1).max(updateAgentReviewSetBodyPromptsMax).optional(),
  "deleted": zod.literal(true).optional()
})

export const updateAgentReviewSetResponseTargetsItemKeyMax = 100;

export const updateAgentReviewSetResponseTargetsMax = 20;


export const updateAgentReviewSetResponseDescriptionMax = 500;

export const updateAgentReviewSetResponseCategoryMax = 60;

export const updateAgentReviewSetResponseSortOrderMin = 0;
export const updateAgentReviewSetResponseSortOrderMax = 100000;


export const updateAgentReviewSetResponsePromptsItemContentMax = 4000;

export const updateAgentReviewSetResponsePromptsMax = 20;



export const updateAgentReviewSetResponse = zod.object({
  "targets": zod.array(zod.object({
  "kind": zod.enum(['general', 'function', 'module']),
  "key": zod.string().min(1).max(updateAgentReviewSetResponseTargetsItemKeyMax).optional()
})).min(1).max(updateAgentReviewSetResponseTargetsMax).optional(),
  "origin": zod.enum(['personal', 'entity', 'tenant', 'platform']).optional(),
  "inherited": zod.boolean().optional(),
  "copiedFrom": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "tenantId": zod.uuid()
}),zod.null()]).optional(),
  "description": zod.string().max(updateAgentReviewSetResponseDescriptionMax).optional(),
  "category": zod.string().max(updateAgentReviewSetResponseCategoryMax).optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().min(updateAgentReviewSetResponseSortOrderMin).max(updateAgentReviewSetResponseSortOrderMax).optional(),
  "id": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "visibility": zod.enum(['personal', 'team']),
  "kind": zod.enum(['prompt', 'review_set']),
  "title": zod.string(),
  "content": zod.string(),
  "prompts": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(updateAgentReviewSetResponsePromptsItemContentMax)
})).max(updateAgentReviewSetResponsePromptsMax),
  "revision": zod.int(),
  "deleted": zod.boolean(),
  "canEdit": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listAgentMessagesParams = zod.object({
  "id": zod.uuid()
})

export const listAgentMessagesQueryLimitDefault = 25;
export const listAgentMessagesQueryLimitMax = 100;

export const listAgentMessagesQueryOffsetDefault = 0;
export const listAgentMessagesQueryOffsetMin = 0;
export const listAgentMessagesQueryOffsetMax = 100000;



export const listAgentMessagesQueryParams = zod.object({
  "scopeKind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().optional(),
  "entityId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAgentMessagesQueryLimitMax).default(listAgentMessagesQueryLimitDefault),
  "offset": zod.int().min(listAgentMessagesQueryOffsetMin).max(listAgentMessagesQueryOffsetMax).default(listAgentMessagesQueryOffsetDefault)
})


export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardActionKeyMax = 120;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardTitleMax = 300;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemNameMax = 120;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemLabelMax = 120;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemValueMax = 30000;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemMinLengthMin = 0;


export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemOptionsItemMax = 120;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemOptionsMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsMax = 20;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardMissingInputsItemMax = 120;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardMissingInputsMax = 40;


export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardEvidenceItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardEvidenceMax = 20;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardAvailableActionsMax = 8;


export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardProposalReviewDestructiveDefault = false;
export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardDependencyOwnerMax = 120;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemActionKeyMax = 120;


export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemDestinationMax = 500;


export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemDestinationRegExp = new RegExp('^/(?!/)[a-zA-Z0-9/?=&._-]+$');
export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemMinimumInputsItemMax = 120;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemMinimumInputsMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemMissingInputsItemMax = 120;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemMissingInputsMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemExplanationMax = 2000;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillNameMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillTitleMax = 300;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillSubjectMax = 500;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillBodyMax = 30000;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillContentMax = 30000;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillMarkdownMax = 30000;

export const listAgentMessagesResponseItemsItemResponseOneContinuationsMax = 20;

export const listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemIdMax = 60;


export const listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemIdRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemLabelMax = 80;

export const listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemDescriptionMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemPromptMax = 500;

export const listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemDestinationMax = 500;


export const listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemDestinationRegExp = new RegExp('^/(?!/)[a-zA-Z0-9/?=&._-]+$');
export const listAgentMessagesResponseItemsItemResponseOneSuggestedStepsMax = 6;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestQueryHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestChannelDefault = `agent`;
export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMin = 2000;
export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMax = 24000;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMaxPassagesMin = 2;
export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMaxPassagesMax = 24;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMessageMax = 1000;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestBackgroundStateMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemCitationMax = 24;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemCrmIdentityMax = 150;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemSourceVersionMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemExcerptHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemLabelMax = 500;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemLocationMax = 500;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemExcerptMax = 2000;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemScoreMin = 0;
export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemScoreMax = 1;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemStartMin = 0;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemEndMin = 0;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesMax = 24;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestSourcesItemMessageMax = 1000;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestSourcesMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestWarningsItemMax = 1000;

export const listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestWarningsMax = 100;




export const listAgentMessagesResponseItemsItemResponseOneSowTwoWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsProjectTitleMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomerNameMax = 300;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsAgreementIdMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsPreparedDateMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsStartDateMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsSprintWeeksMax = 52;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsNarrativeItemTextMax = 20000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsNarrativeMax = 5;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsTablesItemRowsItemItemMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsTablesItemRowsItemMax = 7;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsTablesItemRowsMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsTablesMax = 6;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemIdMax = 80;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemTitleMax = 300;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemDescriptionMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemIdMax = 80;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemTitleMax = 300;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemDescriptionMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemIdMax = 80;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemMilestonesMax = 500;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemDateMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemNotesMax = 2000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialReferenceMax = 300;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialSourceStatusMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialTermsMax = 20000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialAssumptionsMax = 20000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialExclusionsMax = 20000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialReviewReasonMin = 10;
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialReviewReasonMax = 2000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialLinesItemTitleMax = 300;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialLinesMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsUnresolvedFactsItemFieldMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsUnresolvedFactsItemMessageMax = 2000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsUnresolvedFactsMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomFieldsItemSectionIdMax = 48;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomFieldsItemFieldIdMax = 48;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomFieldsItemValueMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomFieldsMax = 600;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomProseItemSectionIdMax = 48;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomProseItemTextMax = 20000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomProseMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesItemSectionIdMax = 48;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesItemRowsItemItemMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesItemRowsItemMax = 8;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesItemRowsMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoRevisionMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoSourceKeyMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoLabelMax = 500;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoExcerptMax = 12000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesMax = 20;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoConfirmedFactsItemQuoteMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoConfirmedFactsItemSourceIdsItemMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoConfirmedFactsItemSourceIdsMax = 20;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoConfirmedFactsMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoAssumptionsItemQuoteMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoAssumptionsItemSourceIdsItemMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoAssumptionsItemSourceIdsMax = 20;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoAssumptionsMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoGapsMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoCorrectionsMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsTopMin = 5;
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsTopMax = 50;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsRightMin = 5;
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsRightMax = 50;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMin = 5;
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMax = 50;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMin = 5;
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMax = 50;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemTypeMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemTextMax = 200000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemMarksItemTypeMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemMarksMax = 20;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemContentMax = 10000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemTypeMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemTextMax = 200000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemMarksItemTypeMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemMarksMax = 20;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemContentMax = 10000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentSectionsItemsItemTitleMax = 160;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentSectionsItemsItemAuthoringNotesMax = 4000;


export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentSectionsItemsMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemNameMax = 80;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemFontSizeMin = 6;
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemFontSizeMax = 96;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMin = 0;
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMax = 144;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemLineHeightMax = 3;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsMin = 7;
export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsMax = 100;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentTemplateGuidanceMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentTemplateSectionGuidanceMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemTypeMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemTextMax = 200000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemMarksItemTypeMax = 40;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemMarksMax = 20;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemContentMax = 10000;

export const listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentMax = 10000;

export const listAgentMessagesResponseItemsItemResponseOneWebEvidenceMax = 15;


export const listAgentMessagesResponseItemsItemResponseOneSourcesItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneTitleMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneBriefMax = 10000;

export const listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneScenesItemTitleMax = 200;

export const listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneScenesItemPromptMax = 20000;

export const listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneScenesItemNegativePromptMax = 5000;

export const listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneScenesMax = 8;


export const listAgentMessagesResponseItemsItemResponseOneProposalsItemReviewDestructiveDefault = false;
export const listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemIdMax = 64;


export const listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemLabelMax = 300;

export const listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsItemIdMax = 64;


export const listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsItemIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsItemLabelMax = 160;

export const listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsItemDescriptionMax = 300;

export const listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsMax = 8;

export const listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsMax = 6;


export const listAgentMessagesResponseItemsItemPromptSnapshotOneContentMax = 4000;

export const listAgentMessagesResponseTotalMin = 0;



export const listAgentMessagesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "content": zod.string(),
  "status": zod.enum(['running', 'completed', 'interrupted', 'failed']),
  "response": zod.union([zod.object({
  "tenderPreparationId": zod.uuid().optional(),
  "continuations": zod.array(zod.object({
  "workCard": zod.object({
  "version": zod.literal(1),
  "actionId": zod.uuid(),
  "revision": zod.int().min(1),
  "actionKey": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardActionKeyMax),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardTitleMax),
  "state": zod.enum(['needs_details', 'ready_for_review', 'awaiting_review', 'pending', 'uncertain', 'completed', 'failed', 'cancelled', 'stale', 'expired', 'native_only', 'read_only']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "nativeSchema": zod.enum(['#/components/schemas/AccountCreate', '#/components/schemas/EmailCampaignCreate', '#/components/schemas/CampaignBriefChange', '#/components/schemas/ContentHubAssetCreate', '#/components/schemas/CreateResearchThread', '#/components/schemas/CreateResearchDocument']).optional().describe('Canonical native input reference. The registered action schema owns its supported subset and all validation; field metadata is only a rendering hint.'),
  "fields": zod.array(zod.object({
  "name": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemNameMax),
  "label": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemLabelMax),
  "control": zod.enum(['text', 'multiline', 'select']),
  "required": zod.boolean(),
  "value": zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemValueMax).optional(),
  "minLength": zod.int().min(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemMinLengthMin).optional(),
  "maxLength": zod.int().min(1).optional(),
  "options": zod.array(zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemOptionsItemMax)).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsItemOptionsMax)
})).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardFieldsMax),
  "missingInputs": zod.array(zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardMissingInputsItemMax)).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardMissingInputsMax),
  "evidence": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardEvidenceItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardEvidenceMax).describe('Authorized source evidence only. Empty for supplied inert draft values; never infer source attribution.'),
  "availableActions": zod.array(zod.enum(['details', 'review', 'cancel', 'open_native', 'confirm', 'check_result'])).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardAvailableActionsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional(),
  "execution": zod.object({
  "replayed": zod.boolean().optional().describe('True for read-only receipt recovery or a review that found an existing execution. Only an explicit false on a fresh successful confirmation is eligible for create-and-open navigation.'),
  "id": zod.uuid(),
  "proposalId": zod.uuid(),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'partial', 'indeterminate']),
  "receipt": zod.record(zod.string(), zod.unknown()).nullable(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "auditIds": zod.array(zod.uuid()),
  "jobIds": zod.array(zod.uuid()),
  "startedAt": zod.iso.datetime({"offset":true}),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "dependencyOwner": zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemWorkCardDependencyOwnerMax).optional(),
  "reviewRequired": zod.literal(true)
}).optional().describe('Server-derived presentation over private continuation and canonical proposal/receipt owners. Never accept a submitted card as authority or dispatch model-provided UI. Edits use the existing actionId/revision continuation request; confirmation uses the exact canonical proposal.'),
  "actionKey": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemActionKeyMax),
  "actionId": zod.uuid().optional(),
  "revision": zod.int().min(1).optional(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "state": zod.enum(['needs_details', 'ready_for_review', 'native_only', 'read_only']),
  "detailsMode": zod.enum(['exact_review', 'native_clarification', 'read_query']),
  "screenMode": zod.enum(['review_draft', 'native_workflow']),
  "destination": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemDestinationMax).regex(listAgentMessagesResponseItemsItemResponseOneContinuationsItemDestinationRegExp).describe('Exact server-allowlisted application route; never includes supplied private text.'),
  "draftEligible": zod.boolean().describe('True only for an existing inert local creation adapter. Required inputs and explicit proposal confirmation still apply.'),
  "minimumInputs": zod.array(zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemMinimumInputsItemMax)).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemMinimumInputsMax),
  "missingInputs": zod.array(zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemMissingInputsItemMax)).max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemMissingInputsMax).describe('Invalid or missing field paths, never submitted values.'),
  "explanation": zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemExplanationMax).optional(),
  "prefill": zod.object({
  "name": zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillNameMax).optional(),
  "title": zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillTitleMax).optional(),
  "subject": zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillSubjectMax).optional(),
  "body": zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillBodyMax).optional(),
  "content": zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillContentMax).optional(),
  "markdown": zod.string().max(listAgentMessagesResponseItemsItemResponseOneContinuationsItemPrefillMarkdownMax).optional(),
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional()
}).optional().describe('Editable non-authoritative values in this actor-private response. Transfer only within the same signed-in actor and scope; never in a URL.'),
  "reviewRequired": zod.literal(true)
}).describe('Non-authoritative choices for one recognized action. Recheck current scope, permissions, modules and native prerequisites before review or navigation. Never dispatch from these fields.')).max(listAgentMessagesResponseItemsItemResponseOneContinuationsMax).optional(),
  "suggestedSteps": zod.array(zod.object({
  "id": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemIdMax).regex(listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemIdRegExp),
  "kind": zod.enum(['ask', 'open']),
  "label": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemLabelMax),
  "description": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemDescriptionMax).optional(),
  "prompt": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemPromptMax).optional(),
  "destination": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemDestinationMax).regex(listAgentMessagesResponseItemsItemResponseOneSuggestedStepsItemDestinationRegExp).optional().describe('In-app route validated against the application navigation catalogue; required when kind is open.')
}).describe('A clickable next step the Agent recommends after its answer. `ask` sends `prompt` back to the Agent as the user\'s next message; `open` navigates to a server-validated in-app destination. Neither executes work; changes still need an exact review and confirmation, and destinations recheck access.')).max(listAgentMessagesResponseItemsItemResponseOneSuggestedStepsMax).optional().describe('Clickable next steps for the user after an answer that identifies work (for example what needs attention).'),
  "workspaceEvidence": zod.object({
  "id": zod.uuid(),
  "manifestHash": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "manifest": zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "workspaceId": zod.uuid(),
  "workspaceRevision": zod.uuid(),
  "contextFingerprint": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestContextFingerprintRegExp),
  "queryHash": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestQueryHashRegExp),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestChannelDefault),
  "retrievalMode": zod.enum(['lexical']),
  "maxEvidenceChars": zod.int().min(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMin).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMaxEvidenceCharsMax),
  "maxPassages": zod.int().min(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMaxPassagesMin).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMaxPassagesMax),
  "state": zod.enum(['ready', 'partial', 'insufficient', 'conflicting', 'unavailable']),
  "message": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestMessageMax),
  "backgroundState": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestBackgroundStateMax),
  "passages": zod.array(zod.object({
  "id": zod.uuid(),
  "citation": zod.int().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemCitationMax),
  "kind": zod.enum(['workspace', 'knowledge', 'crm']),
  "tier": zod.enum(['primary', 'background']),
  "reason": zod.enum(['automatic', 'explicit', 'entity_background']),
  "role": zod.enum(['provided', 'working', 'submission']).nullable(),
  "membershipId": zod.uuid().nullable(),
  "membershipRevision": zod.uuid().nullable(),
  "folderRevision": zod.uuid().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "extractionRevision": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "managedDocumentId": zod.uuid().nullable(),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "knowledgeFileId": zod.uuid().nullable(),
  "indexDocumentId": zod.uuid().nullable(),
  "chunkId": zod.uuid().nullable(),
  "crmIdentity": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemCrmIdentityMax).nullable(),
  "sourceVersion": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemSourceVersionMax),
  "contentHash": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemContentHashRegExp),
  "excerptHash": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemExcerptHashRegExp),
  "label": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemLabelMax),
  "location": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemLocationMax),
  "excerpt": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemExcerptMax),
  "score": zod.number().min(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemScoreMin).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemScoreMax),
  "start": zod.int().min(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemStartMin).nullable(),
  "end": zod.int().min(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesItemEndMin).nullable()
})).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestPassagesMax),
  "sources": zod.array(zod.object({
  "membershipId": zod.uuid(),
  "role": zod.enum(['provided', 'working', 'submission']),
  "state": zod.enum(['excluded', 'stored', 'pending', 'ready', 'unsupported', 'failed', 'denied', 'stale', 'unavailable', 'irrelevant', 'omitted_budget']),
  "message": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestSourcesItemMessageMax)
})).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestSourcesMax),
  "warnings": zod.array(zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestWarningsItemMax)).max(listAgentMessagesResponseItemsItemResponseOneWorkspaceEvidenceManifestWarningsMax)
})
}).optional(),
  "sow": zod.object({
  "proposalId": zod.uuid().optional(),
  "proposalRevision": zod.int().min(1).optional(),
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid(),
  "templateVersionId": zod.uuid(),
  "title": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoWorkspaceContextManifestHashRegExp)
}).optional(),
  "requestId": zod.uuid().nullish(),
  "facts": zod.object({
  "projectTitle": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsNarrativeItemTextMax)
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsTablesItemRowsItemItemMax)).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsTablesItemRowsItemMax)).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsTablesItemRowsMax)
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemIdMax),
  "title": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemTitleMax),
  "description": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemIdMax),
  "title": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemTitleMax),
  "description": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemIdMax),
  "milestones": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesItemNotesMax)
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsInvoicesMax),
  "milestoneDays": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialReviewReasonMin).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsUnresolvedFactsItemMessageMax)
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomFieldsItemValueMax).nullable()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomProseItemTextMax)
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesItemRowsItemItemMax)).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesItemRowsItemMax)).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesItemRowsMax)
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}),
  "selectedSources": zod.array(zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'document', 'request']),
  "id": zod.uuid()
}).and(zod.object({
  "hash": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoHashRegExp),
  "revision": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoRevisionMax),
  "sourceKey": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoSourceKeyMax),
  "label": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoLabelMax),
  "excerpt": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesItemTwoExcerptMax)
}))).max(listAgentMessagesResponseItemsItemResponseOneSowTwoSelectedSourcesMax),
  "confirmedFacts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoConfirmedFactsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoConfirmedFactsItemSourceIdsItemMax)).max(listAgentMessagesResponseItemsItemResponseOneSowTwoConfirmedFactsItemSourceIdsMax)
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoConfirmedFactsMax),
  "assumptions": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoAssumptionsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoAssumptionsItemSourceIdsItemMax)).max(listAgentMessagesResponseItemsItemResponseOneSowTwoAssumptionsItemSourceIdsMax)
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoAssumptionsMax),
  "gaps": zod.array(zod.object({
  "field": zod.string(),
  "message": zod.string()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoGapsMax),
  "corrections": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string(),
  "after": zod.string(),
  "reason": zod.string()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoCorrectionsMax),
  "validation": zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsTopMin).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsRightMin).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMin).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMin).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderItemContentMax).optional()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemTypeMax),
  "text": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterItemContentMax).optional()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemFontSizeMin).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMin).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMin).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsItemLineHeightMax)
})).min(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsMin).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentTemplateSectionGuidanceItemGuidanceMax)
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemTypeMax),
  "text": zod.string().max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentItemContentMax).optional()
})).max(listAgentMessagesResponseItemsItemResponseOneSowTwoContentContentMax)
}),
  "sourceStatus": zod.enum(['current', 'stale'])
})).optional(),
  "webEvidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(listAgentMessagesResponseItemsItemResponseOneWebEvidenceMax).optional(),
  "reply": zod.string(),
  "conversationId": zod.uuid(),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(listAgentMessagesResponseItemsItemResponseOneSourcesItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})),
  "draftHandoffs": zod.array(zod.object({
  "channel": zod.enum(['email', 'social', 'quote', 'video_project']),
  "label": zod.string(),
  "deepLink": zod.string(),
  "draft": zod.string(),
  "videoProject": zod.union([zod.object({
  "mode": zod.enum(['single_clip', 'storyboard']),
  "title": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneTitleMax),
  "brief": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneBriefMax),
  "aspectRatio": zod.enum(['16:9', '9:16']),
  "scenes": zod.array(zod.object({
  "title": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneScenesItemTitleMax),
  "prompt": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneScenesItemPromptMax),
  "negativePrompt": zod.string().max(listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneScenesItemNegativePromptMax).nullable(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)])
})).min(1).max(listAgentMessagesResponseItemsItemResponseOneDraftHandoffsItemVideoProjectOneScenesMax)
}),zod.null()]).optional(),
  "aiAuditId": zod.uuid().nullish()
})),
  "evidenceState": zod.enum(['ready', 'crm_only', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence']),
  "evidenceMessage": zod.string(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "proposals": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(listAgentMessagesResponseItemsItemResponseOneProposalsItemReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})),
  "clarification": zod.union([zod.object({
  "id": zod.uuid(),
  "questions": zod.array(zod.object({
  "id": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemIdMax).regex(listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemIdRegExp),
  "label": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemLabelMax),
  "mode": zod.enum(['single_choice', 'multiple_choice', 'text']),
  "options": zod.array(zod.object({
  "id": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsItemIdMax).regex(listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsItemIdRegExp),
  "label": zod.string().min(1).max(listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsItemLabelMax),
  "description": zod.string().max(listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsItemDescriptionMax).nullish()
})).max(listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsItemOptionsMax),
  "allowFreeText": zod.boolean()
})).min(1).max(listAgentMessagesResponseItemsItemResponseOneClarificationOneQuestionsMax)
}),zod.null()]).optional()
}),zod.null()]).optional(),
  "errorCode": zod.string().nullish(),
  "promptSnapshot": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(listAgentMessagesResponseItemsItemPromptSnapshotOneContentMax)
}),zod.null()]),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAgentMessagesResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary Explicitly admit an actor-private bounded ElevenLabs session for a private or exact record-shared chat
 */
export const startAgentVoiceBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "conversationId": zod.uuid(),
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).optional().describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "requestId": zod.uuid()
})

export const startAgentVoiceResponse = zod.object({
  "sessionId": zod.uuid(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable().describe('Null means no configured session duration; idle sessions still expire after 30 minutes without speech activity.'),
  "maxSeconds": zod.int().nullable().describe('Original configured duration at admission; null means no quota.')
})


/**
 * @summary Transcribe bounded PCM audio, speak a reply, or end a private session
 */
export const operateAgentVoiceBodyAudioBase64Min = 4268;
export const operateAgentVoiceBodyAudioBase64Max = 1280000;

export const operateAgentVoiceBodyTextMax = 1000;



export const operateAgentVoiceBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "conversationId": zod.uuid().optional().describe('Exact chat pin for cancelling an admission whose response was lost'),
  "context": zod.union([zod.object({
  "kind": zod.enum(['tender']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['campaign']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['content_asset']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['social_post']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['managed_document']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['sow_preparation']),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "recordId": zod.uuid()
}).describe('An exact shared SOW preparation record. Its native SOW preparation reader is the authority; a SOW Files document or a legacy author-private SOW session is never accepted in its place.')]).optional().describe('Explicit exact native record. Omitted context on existing conversation operations remains private; private history is never converted.'),
  "sessionId": zod.uuid(),
  "requestId": zod.uuid(),
  "operation": zod.enum(['transcribe', 'speak', 'end']),
  "audioBase64": zod.string().min(operateAgentVoiceBodyAudioBase64Min).max(operateAgentVoiceBodyAudioBase64Max).optional().describe('Mono signed 16-bit little-endian PCM at 16000Hz, 0.1–30 seconds'),
  "text": zod.string().min(1).max(operateAgentVoiceBodyTextMax).optional()
})

export const operateAgentVoiceResponseTextMax = 4000;

export const operateAgentVoiceResponseAudioBase64Max = 6990508;



export const operateAgentVoiceResponse = zod.object({
  "text": zod.string().max(operateAgentVoiceResponseTextMax).optional(),
  "audioBase64": zod.string().max(operateAgentVoiceResponseAudioBase64Max).optional(),
  "ended": zod.boolean().optional()
})


/**
 * Both the floating Agent and the full Agent workspace use this endpoint.
 * The server retrieves safe, relevant business records from the database;
 * model, endpoint, credentials and grounding remain server-side.
 * @summary Send a message to the authenticated database-grounded Agent
 */

export const chatWithAgentBodyAttachmentsItemContentHashRegExp = new RegExp('^[0-9a-f]{64}$');
export const chatWithAgentBodyAttachmentsMax = 10;

export const chatWithAgentBodyContinuationActionKeyMax = 120;


export const chatWithAgentBodyContinuationFieldsMaxOne = 30000;

export const chatWithAgentBodyWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const chatWithAgentBodyResearchModeDefault = `internal`;
export const chatWithAgentBodyPublicSearchQueriesItemMin = 3;
export const chatWithAgentBodyPublicSearchQueriesItemMax = 300;

export const chatWithAgentBodyPublicSearchQueriesMax = 3;


export const chatWithAgentBodyMessageMax = 4000;

export const chatWithAgentBodyInteractionModeDefault = `chat`;
export const chatWithAgentBodyPathnameDefault = `/`;
export const chatWithAgentBodyPathnameMax = 500;

export const chatWithAgentBodyClarificationAnswersAnswersItemQuestionIdMax = 64;


export const chatWithAgentBodyClarificationAnswersAnswersItemQuestionIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const chatWithAgentBodyClarificationAnswersAnswersItemOptionIdsItemMax = 64;


export const chatWithAgentBodyClarificationAnswersAnswersItemOptionIdsItemRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const chatWithAgentBodyClarificationAnswersAnswersItemOptionIdsMax = 8;

export const chatWithAgentBodyClarificationAnswersAnswersItemTextMax = 1000;

export const chatWithAgentBodyClarificationAnswersAnswersMax = 6;



export const chatWithAgentBody = zod.object({
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "contentHash": zod.string().regex(chatWithAgentBodyAttachmentsItemContentHashRegExp)
})).max(chatWithAgentBodyAttachmentsMax).optional().describe('Exact private sources for this turn; archive originals include readable members with explicit omission warnings. Empty selection excludes attachment retrieval.'),
  "continuation": zod.object({
  "actionKey": zod.string().min(1).max(chatWithAgentBodyContinuationActionKeyMax),
  "actionId": zod.uuid(),
  "revision": zod.int().min(1),
  "mode": zod.enum(['details', 'review', 'cancel']),
  "fields": zod.record(zod.string(), zod.string().max(chatWithAgentBodyContinuationFieldsMaxOne)).optional()
}).optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(chatWithAgentBodyWorkspaceContextManifestHashRegExp)
}).optional(),
  "sowSession": zod.object({
  "id": zod.uuid(),
  "expectedRevision": zod.int().min(1)
}).optional(),
  "researchMode": zod.enum(['internal', 'public_research']).default(chatWithAgentBodyResearchModeDefault),
  "publicSearchQueries": zod.array(zod.string().min(chatWithAgentBodyPublicSearchQueriesItemMin).max(chatWithAgentBodyPublicSearchQueriesItemMax)).min(1).max(chatWithAgentBodyPublicSearchQueriesMax).optional(),
  "clientRequestId": zod.uuid().optional(),
  "savedPrompt": zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
}).optional(),
  "message": zod.string().min(1).max(chatWithAgentBodyMessageMax),
  "conversationId": zod.uuid().optional(),
  "interactionMode": zod.enum(['chat', 'voice']).default(chatWithAgentBodyInteractionModeDefault),
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "pathname": zod.string().max(chatWithAgentBodyPathnameMax).default(chatWithAgentBodyPathnameDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "clarificationAnswers": zod.object({
  "groupId": zod.uuid(),
  "answers": zod.array(zod.object({
  "questionId": zod.string().min(1).max(chatWithAgentBodyClarificationAnswersAnswersItemQuestionIdMax).regex(chatWithAgentBodyClarificationAnswersAnswersItemQuestionIdRegExp),
  "optionIds": zod.array(zod.string().min(1).max(chatWithAgentBodyClarificationAnswersAnswersItemOptionIdsItemMax).regex(chatWithAgentBodyClarificationAnswersAnswersItemOptionIdsItemRegExp)).max(chatWithAgentBodyClarificationAnswersAnswersItemOptionIdsMax),
  "text": zod.string().max(chatWithAgentBodyClarificationAnswersAnswersItemTextMax).nullish()
})).min(1).max(chatWithAgentBodyClarificationAnswersAnswersMax)
}).optional()
})


export const chatWithAgentResponseContinuationsItemWorkCardActionKeyMax = 120;

export const chatWithAgentResponseContinuationsItemWorkCardTitleMax = 300;

export const chatWithAgentResponseContinuationsItemWorkCardFieldsItemNameMax = 120;

export const chatWithAgentResponseContinuationsItemWorkCardFieldsItemLabelMax = 120;

export const chatWithAgentResponseContinuationsItemWorkCardFieldsItemValueMax = 30000;

export const chatWithAgentResponseContinuationsItemWorkCardFieldsItemMinLengthMin = 0;


export const chatWithAgentResponseContinuationsItemWorkCardFieldsItemOptionsItemMax = 120;

export const chatWithAgentResponseContinuationsItemWorkCardFieldsItemOptionsMax = 40;

export const chatWithAgentResponseContinuationsItemWorkCardFieldsMax = 20;

export const chatWithAgentResponseContinuationsItemWorkCardMissingInputsItemMax = 120;

export const chatWithAgentResponseContinuationsItemWorkCardMissingInputsMax = 40;


export const chatWithAgentResponseContinuationsItemWorkCardEvidenceItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseContinuationsItemWorkCardEvidenceMax = 20;

export const chatWithAgentResponseContinuationsItemWorkCardAvailableActionsMax = 8;


export const chatWithAgentResponseContinuationsItemWorkCardProposalReviewDestructiveDefault = false;
export const chatWithAgentResponseContinuationsItemWorkCardDependencyOwnerMax = 120;

export const chatWithAgentResponseContinuationsItemActionKeyMax = 120;


export const chatWithAgentResponseContinuationsItemDestinationMax = 500;


export const chatWithAgentResponseContinuationsItemDestinationRegExp = new RegExp('^/(?!/)[a-zA-Z0-9/?=&._-]+$');
export const chatWithAgentResponseContinuationsItemMinimumInputsItemMax = 120;

export const chatWithAgentResponseContinuationsItemMinimumInputsMax = 40;

export const chatWithAgentResponseContinuationsItemMissingInputsItemMax = 120;

export const chatWithAgentResponseContinuationsItemMissingInputsMax = 40;

export const chatWithAgentResponseContinuationsItemExplanationMax = 2000;

export const chatWithAgentResponseContinuationsItemPrefillNameMax = 200;

export const chatWithAgentResponseContinuationsItemPrefillTitleMax = 300;

export const chatWithAgentResponseContinuationsItemPrefillSubjectMax = 500;

export const chatWithAgentResponseContinuationsItemPrefillBodyMax = 30000;

export const chatWithAgentResponseContinuationsItemPrefillContentMax = 30000;

export const chatWithAgentResponseContinuationsItemPrefillMarkdownMax = 30000;

export const chatWithAgentResponseContinuationsMax = 20;

export const chatWithAgentResponseSuggestedStepsItemIdMax = 60;


export const chatWithAgentResponseSuggestedStepsItemIdRegExp = new RegExp('^[A-Za-z0-9_-]+$');
export const chatWithAgentResponseSuggestedStepsItemLabelMax = 80;

export const chatWithAgentResponseSuggestedStepsItemDescriptionMax = 200;

export const chatWithAgentResponseSuggestedStepsItemPromptMax = 500;

export const chatWithAgentResponseSuggestedStepsItemDestinationMax = 500;


export const chatWithAgentResponseSuggestedStepsItemDestinationRegExp = new RegExp('^/(?!/)[a-zA-Z0-9/?=&._-]+$');
export const chatWithAgentResponseSuggestedStepsMax = 6;

export const chatWithAgentResponseWorkspaceEvidenceManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseWorkspaceEvidenceManifestContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseWorkspaceEvidenceManifestQueryHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseWorkspaceEvidenceManifestChannelDefault = `agent`;
export const chatWithAgentResponseWorkspaceEvidenceManifestMaxEvidenceCharsMin = 2000;
export const chatWithAgentResponseWorkspaceEvidenceManifestMaxEvidenceCharsMax = 24000;

export const chatWithAgentResponseWorkspaceEvidenceManifestMaxPassagesMin = 2;
export const chatWithAgentResponseWorkspaceEvidenceManifestMaxPassagesMax = 24;

export const chatWithAgentResponseWorkspaceEvidenceManifestMessageMax = 1000;

export const chatWithAgentResponseWorkspaceEvidenceManifestBackgroundStateMax = 100;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemCitationMax = 24;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemCrmIdentityMax = 150;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemSourceVersionMax = 200;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemExcerptHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemLabelMax = 500;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemLocationMax = 500;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemExcerptMax = 2000;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemScoreMin = 0;
export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemScoreMax = 1;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemStartMin = 0;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemEndMin = 0;

export const chatWithAgentResponseWorkspaceEvidenceManifestPassagesMax = 24;

export const chatWithAgentResponseWorkspaceEvidenceManifestSourcesItemMessageMax = 1000;

export const chatWithAgentResponseWorkspaceEvidenceManifestSourcesMax = 100;

export const chatWithAgentResponseWorkspaceEvidenceManifestWarningsItemMax = 1000;

export const chatWithAgentResponseWorkspaceEvidenceManifestWarningsMax = 100;




export const chatWithAgentResponseSowTwoWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseSowTwoFactsProjectTitleMax = 200;

export const chatWithAgentResponseSowTwoFactsCustomerNameMax = 300;

export const chatWithAgentResponseSowTwoFactsAgreementIdMax = 100;

export const chatWithAgentResponseSowTwoFactsPreparedDateMax = 40;

export const chatWithAgentResponseSowTwoFactsStartDateMax = 40;

export const chatWithAgentResponseSowTwoFactsSprintWeeksMax = 52;

export const chatWithAgentResponseSowTwoFactsNarrativeItemTextMax = 20000;

export const chatWithAgentResponseSowTwoFactsNarrativeMax = 5;

export const chatWithAgentResponseSowTwoFactsTablesItemRowsItemItemMax = 4000;

export const chatWithAgentResponseSowTwoFactsTablesItemRowsItemMax = 7;

export const chatWithAgentResponseSowTwoFactsTablesItemRowsMax = 100;

export const chatWithAgentResponseSowTwoFactsTablesMax = 6;

export const chatWithAgentResponseSowTwoFactsInvestmentItemIdMax = 80;

export const chatWithAgentResponseSowTwoFactsInvestmentItemTitleMax = 300;

export const chatWithAgentResponseSowTwoFactsInvestmentItemDescriptionMax = 4000;

export const chatWithAgentResponseSowTwoFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsInvestmentMax = 100;

export const chatWithAgentResponseSowTwoFactsMaterialsItemIdMax = 80;

export const chatWithAgentResponseSowTwoFactsMaterialsItemTitleMax = 300;

export const chatWithAgentResponseSowTwoFactsMaterialsItemDescriptionMax = 4000;

export const chatWithAgentResponseSowTwoFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsMaterialsMax = 100;

export const chatWithAgentResponseSowTwoFactsInvoicesItemIdMax = 80;

export const chatWithAgentResponseSowTwoFactsInvoicesItemMilestonesMax = 500;

export const chatWithAgentResponseSowTwoFactsInvoicesItemDateMax = 40;

export const chatWithAgentResponseSowTwoFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsInvoicesItemNotesMax = 2000;

export const chatWithAgentResponseSowTwoFactsInvoicesMax = 100;

export const chatWithAgentResponseSowTwoFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const chatWithAgentResponseSowTwoFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseSowTwoFactsQuoteCommercialReferenceMax = 300;

export const chatWithAgentResponseSowTwoFactsQuoteCommercialSourceStatusMax = 100;

export const chatWithAgentResponseSowTwoFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const chatWithAgentResponseSowTwoFactsQuoteCommercialTermsMax = 20000;

export const chatWithAgentResponseSowTwoFactsQuoteCommercialAssumptionsMax = 20000;

export const chatWithAgentResponseSowTwoFactsQuoteCommercialExclusionsMax = 20000;

export const chatWithAgentResponseSowTwoFactsQuoteCommercialReviewReasonMin = 10;
export const chatWithAgentResponseSowTwoFactsQuoteCommercialReviewReasonMax = 2000;

export const chatWithAgentResponseSowTwoFactsQuoteCommercialLinesItemTitleMax = 300;

export const chatWithAgentResponseSowTwoFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const chatWithAgentResponseSowTwoFactsQuoteCommercialLinesMax = 100;

export const chatWithAgentResponseSowTwoFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const chatWithAgentResponseSowTwoFactsUnresolvedFactsItemFieldMax = 100;

export const chatWithAgentResponseSowTwoFactsUnresolvedFactsItemMessageMax = 2000;

export const chatWithAgentResponseSowTwoFactsUnresolvedFactsMax = 200;

export const chatWithAgentResponseSowTwoFactsCustomFieldsItemSectionIdMax = 48;

export const chatWithAgentResponseSowTwoFactsCustomFieldsItemFieldIdMax = 48;

export const chatWithAgentResponseSowTwoFactsCustomFieldsItemValueMax = 4000;

export const chatWithAgentResponseSowTwoFactsCustomFieldsMax = 600;

export const chatWithAgentResponseSowTwoFactsCustomProseItemSectionIdMax = 48;

export const chatWithAgentResponseSowTwoFactsCustomProseItemTextMax = 20000;

export const chatWithAgentResponseSowTwoFactsCustomProseMax = 40;

export const chatWithAgentResponseSowTwoFactsCustomTablesItemSectionIdMax = 48;

export const chatWithAgentResponseSowTwoFactsCustomTablesItemRowsItemItemMax = 4000;

export const chatWithAgentResponseSowTwoFactsCustomTablesItemRowsItemMax = 8;

export const chatWithAgentResponseSowTwoFactsCustomTablesItemRowsMax = 100;

export const chatWithAgentResponseSowTwoFactsCustomTablesMax = 40;

export const chatWithAgentResponseSowTwoSelectedSourcesItemTwoHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseSowTwoSelectedSourcesItemTwoRevisionMax = 100;

export const chatWithAgentResponseSowTwoSelectedSourcesItemTwoSourceKeyMax = 100;

export const chatWithAgentResponseSowTwoSelectedSourcesItemTwoLabelMax = 500;

export const chatWithAgentResponseSowTwoSelectedSourcesItemTwoExcerptMax = 12000;

export const chatWithAgentResponseSowTwoSelectedSourcesMax = 20;

export const chatWithAgentResponseSowTwoConfirmedFactsItemQuoteMax = 4000;

export const chatWithAgentResponseSowTwoConfirmedFactsItemSourceIdsItemMax = 100;

export const chatWithAgentResponseSowTwoConfirmedFactsItemSourceIdsMax = 20;

export const chatWithAgentResponseSowTwoConfirmedFactsMax = 200;

export const chatWithAgentResponseSowTwoAssumptionsItemQuoteMax = 4000;

export const chatWithAgentResponseSowTwoAssumptionsItemSourceIdsItemMax = 100;

export const chatWithAgentResponseSowTwoAssumptionsItemSourceIdsMax = 20;

export const chatWithAgentResponseSowTwoAssumptionsMax = 200;

export const chatWithAgentResponseSowTwoGapsMax = 200;

export const chatWithAgentResponseSowTwoCorrectionsMax = 200;

export const chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsTopMin = 5;
export const chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsTopMax = 50;

export const chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsRightMin = 5;
export const chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsRightMax = 50;

export const chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsBottomMin = 5;
export const chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsBottomMax = 50;

export const chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsLeftMin = 5;
export const chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsLeftMax = 50;

export const chatWithAgentResponseSowTwoContentLayoutHeaderItemTypeMax = 40;

export const chatWithAgentResponseSowTwoContentLayoutHeaderItemTextMax = 200000;

export const chatWithAgentResponseSowTwoContentLayoutHeaderItemMarksItemTypeMax = 40;

export const chatWithAgentResponseSowTwoContentLayoutHeaderItemMarksMax = 20;

export const chatWithAgentResponseSowTwoContentLayoutHeaderItemContentMax = 10000;

export const chatWithAgentResponseSowTwoContentLayoutHeaderMax = 100;

export const chatWithAgentResponseSowTwoContentLayoutFooterItemTypeMax = 40;

export const chatWithAgentResponseSowTwoContentLayoutFooterItemTextMax = 200000;

export const chatWithAgentResponseSowTwoContentLayoutFooterItemMarksItemTypeMax = 40;

export const chatWithAgentResponseSowTwoContentLayoutFooterItemMarksMax = 20;

export const chatWithAgentResponseSowTwoContentLayoutFooterItemContentMax = 10000;

export const chatWithAgentResponseSowTwoContentLayoutFooterMax = 100;

export const chatWithAgentResponseSowTwoContentSectionsItemsItemTitleMax = 160;

export const chatWithAgentResponseSowTwoContentSectionsItemsItemAuthoringNotesMax = 4000;


export const chatWithAgentResponseSowTwoContentSectionsItemsMax = 200;

export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemNameMax = 80;

export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemFontSizeMin = 6;
export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemFontSizeMax = 96;

export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemSpaceAfterMin = 0;
export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemSpaceAfterMax = 144;

export const chatWithAgentResponseSowTwoContentStylesDefinitionsItemLineHeightMax = 3;

export const chatWithAgentResponseSowTwoContentStylesDefinitionsMin = 7;
export const chatWithAgentResponseSowTwoContentStylesDefinitionsMax = 100;

export const chatWithAgentResponseSowTwoContentTemplateGuidanceMax = 4000;

export const chatWithAgentResponseSowTwoContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const chatWithAgentResponseSowTwoContentTemplateSectionGuidanceMax = 200;

export const chatWithAgentResponseSowTwoContentContentItemTypeMax = 40;

export const chatWithAgentResponseSowTwoContentContentItemTextMax = 200000;

export const chatWithAgentResponseSowTwoContentContentItemMarksItemTypeMax = 40;

export const chatWithAgentResponseSowTwoContentContentItemMarksMax = 20;

export const chatWithAgentResponseSowTwoContentContentItemContentMax = 10000;

export const chatWithAgentResponseSowTwoContentContentMax = 10000;

export const chatWithAgentResponseWebEvidenceMax = 15;


export const chatWithAgentResponseSourcesItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const chatWithAgentResponseDraftHandoffsItemVideoProjectOneTitleMax = 200;

export const chatWithAgentResponseDraftHandoffsItemVideoProjectOneBriefMax = 10000;

export const chatWithAgentResponseDraftHandoffsItemVideoProjectOneScenesItemTitleMax = 200;

export const chatWithAgentResponseDraftHandoffsItemVideoProjectOneScenesItemPromptMax = 20000;

export const chatWithAgentResponseDraftHandoffsItemVideoProjectOneScenesItemNegativePromptMax = 5000;

export const chatWithAgentResponseDraftHandoffsItemVideoProjectOneScenesMax = 8;


export const chatWithAgentResponseProposalsItemReviewDestructiveDefault = false;
export const chatWithAgentResponseClarificationOneQuestionsItemIdMax = 64;


export const chatWithAgentResponseClarificationOneQuestionsItemIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const chatWithAgentResponseClarificationOneQuestionsItemLabelMax = 300;

export const chatWithAgentResponseClarificationOneQuestionsItemOptionsItemIdMax = 64;


export const chatWithAgentResponseClarificationOneQuestionsItemOptionsItemIdRegExp = new RegExp('^[A-Za-z0-9][A-Za-z0-9_-]*$');
export const chatWithAgentResponseClarificationOneQuestionsItemOptionsItemLabelMax = 160;

export const chatWithAgentResponseClarificationOneQuestionsItemOptionsItemDescriptionMax = 300;

export const chatWithAgentResponseClarificationOneQuestionsItemOptionsMax = 8;

export const chatWithAgentResponseClarificationOneQuestionsMax = 6;



export const chatWithAgentResponse = zod.object({
  "tenderPreparationId": zod.uuid().optional(),
  "continuations": zod.array(zod.object({
  "workCard": zod.object({
  "version": zod.literal(1),
  "actionId": zod.uuid(),
  "revision": zod.int().min(1),
  "actionKey": zod.string().min(1).max(chatWithAgentResponseContinuationsItemWorkCardActionKeyMax),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "title": zod.string().min(1).max(chatWithAgentResponseContinuationsItemWorkCardTitleMax),
  "state": zod.enum(['needs_details', 'ready_for_review', 'awaiting_review', 'pending', 'uncertain', 'completed', 'failed', 'cancelled', 'stale', 'expired', 'native_only', 'read_only']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "nativeSchema": zod.enum(['#/components/schemas/AccountCreate', '#/components/schemas/EmailCampaignCreate', '#/components/schemas/CampaignBriefChange', '#/components/schemas/ContentHubAssetCreate', '#/components/schemas/CreateResearchThread', '#/components/schemas/CreateResearchDocument']).optional().describe('Canonical native input reference. The registered action schema owns its supported subset and all validation; field metadata is only a rendering hint.'),
  "fields": zod.array(zod.object({
  "name": zod.string().min(1).max(chatWithAgentResponseContinuationsItemWorkCardFieldsItemNameMax),
  "label": zod.string().min(1).max(chatWithAgentResponseContinuationsItemWorkCardFieldsItemLabelMax),
  "control": zod.enum(['text', 'multiline', 'select']),
  "required": zod.boolean(),
  "value": zod.string().max(chatWithAgentResponseContinuationsItemWorkCardFieldsItemValueMax).optional(),
  "minLength": zod.int().min(chatWithAgentResponseContinuationsItemWorkCardFieldsItemMinLengthMin).optional(),
  "maxLength": zod.int().min(1).optional(),
  "options": zod.array(zod.string().max(chatWithAgentResponseContinuationsItemWorkCardFieldsItemOptionsItemMax)).max(chatWithAgentResponseContinuationsItemWorkCardFieldsItemOptionsMax)
})).max(chatWithAgentResponseContinuationsItemWorkCardFieldsMax),
  "missingInputs": zod.array(zod.string().max(chatWithAgentResponseContinuationsItemWorkCardMissingInputsItemMax)).max(chatWithAgentResponseContinuationsItemWorkCardMissingInputsMax),
  "evidence": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(chatWithAgentResponseContinuationsItemWorkCardEvidenceItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})).max(chatWithAgentResponseContinuationsItemWorkCardEvidenceMax).describe('Authorized source evidence only. Empty for supplied inert draft values; never infer source attribution.'),
  "availableActions": zod.array(zod.enum(['details', 'review', 'cancel', 'open_native', 'confirm', 'check_result'])).max(chatWithAgentResponseContinuationsItemWorkCardAvailableActionsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(chatWithAgentResponseContinuationsItemWorkCardProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional(),
  "execution": zod.object({
  "replayed": zod.boolean().optional().describe('True for read-only receipt recovery or a review that found an existing execution. Only an explicit false on a fresh successful confirmation is eligible for create-and-open navigation.'),
  "id": zod.uuid(),
  "proposalId": zod.uuid(),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'partial', 'indeterminate']),
  "receipt": zod.record(zod.string(), zod.unknown()).nullable(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "auditIds": zod.array(zod.uuid()),
  "jobIds": zod.array(zod.uuid()),
  "startedAt": zod.iso.datetime({"offset":true}),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish()
}).optional(),
  "dependencyOwner": zod.string().max(chatWithAgentResponseContinuationsItemWorkCardDependencyOwnerMax).optional(),
  "reviewRequired": zod.literal(true)
}).optional().describe('Server-derived presentation over private continuation and canonical proposal/receipt owners. Never accept a submitted card as authority or dispatch model-provided UI. Edits use the existing actionId/revision continuation request; confirmation uses the exact canonical proposal.'),
  "actionKey": zod.string().min(1).max(chatWithAgentResponseContinuationsItemActionKeyMax),
  "actionId": zod.uuid().optional(),
  "revision": zod.int().min(1).optional(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "state": zod.enum(['needs_details', 'ready_for_review', 'native_only', 'read_only']),
  "detailsMode": zod.enum(['exact_review', 'native_clarification', 'read_query']),
  "screenMode": zod.enum(['review_draft', 'native_workflow']),
  "destination": zod.string().min(1).max(chatWithAgentResponseContinuationsItemDestinationMax).regex(chatWithAgentResponseContinuationsItemDestinationRegExp).describe('Exact server-allowlisted application route; never includes supplied private text.'),
  "draftEligible": zod.boolean().describe('True only for an existing inert local creation adapter. Required inputs and explicit proposal confirmation still apply.'),
  "minimumInputs": zod.array(zod.string().min(1).max(chatWithAgentResponseContinuationsItemMinimumInputsItemMax)).max(chatWithAgentResponseContinuationsItemMinimumInputsMax),
  "missingInputs": zod.array(zod.string().min(1).max(chatWithAgentResponseContinuationsItemMissingInputsItemMax)).max(chatWithAgentResponseContinuationsItemMissingInputsMax).describe('Invalid or missing field paths, never submitted values.'),
  "explanation": zod.string().max(chatWithAgentResponseContinuationsItemExplanationMax).optional(),
  "prefill": zod.object({
  "name": zod.string().max(chatWithAgentResponseContinuationsItemPrefillNameMax).optional(),
  "title": zod.string().max(chatWithAgentResponseContinuationsItemPrefillTitleMax).optional(),
  "subject": zod.string().max(chatWithAgentResponseContinuationsItemPrefillSubjectMax).optional(),
  "body": zod.string().max(chatWithAgentResponseContinuationsItemPrefillBodyMax).optional(),
  "content": zod.string().max(chatWithAgentResponseContinuationsItemPrefillContentMax).optional(),
  "markdown": zod.string().max(chatWithAgentResponseContinuationsItemPrefillMarkdownMax).optional(),
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "accountKind": zod.enum(['organization', 'person']).optional()
}).optional().describe('Editable non-authoritative values in this actor-private response. Transfer only within the same signed-in actor and scope; never in a URL.'),
  "reviewRequired": zod.literal(true)
}).describe('Non-authoritative choices for one recognized action. Recheck current scope, permissions, modules and native prerequisites before review or navigation. Never dispatch from these fields.')).max(chatWithAgentResponseContinuationsMax).optional(),
  "suggestedSteps": zod.array(zod.object({
  "id": zod.string().min(1).max(chatWithAgentResponseSuggestedStepsItemIdMax).regex(chatWithAgentResponseSuggestedStepsItemIdRegExp),
  "kind": zod.enum(['ask', 'open']),
  "label": zod.string().min(1).max(chatWithAgentResponseSuggestedStepsItemLabelMax),
  "description": zod.string().max(chatWithAgentResponseSuggestedStepsItemDescriptionMax).optional(),
  "prompt": zod.string().min(1).max(chatWithAgentResponseSuggestedStepsItemPromptMax).optional(),
  "destination": zod.string().min(1).max(chatWithAgentResponseSuggestedStepsItemDestinationMax).regex(chatWithAgentResponseSuggestedStepsItemDestinationRegExp).optional().describe('In-app route validated against the application navigation catalogue; required when kind is open.')
}).describe('A clickable next step the Agent recommends after its answer. `ask` sends `prompt` back to the Agent as the user\'s next message; `open` navigates to a server-validated in-app destination. Neither executes work; changes still need an exact review and confirmation, and destinations recheck access.')).max(chatWithAgentResponseSuggestedStepsMax).optional().describe('Clickable next steps for the user after an answer that identifies work (for example what needs attention).'),
  "workspaceEvidence": zod.object({
  "id": zod.uuid(),
  "manifestHash": zod.string().regex(chatWithAgentResponseWorkspaceEvidenceManifestHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "manifest": zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "workspaceId": zod.uuid(),
  "workspaceRevision": zod.uuid(),
  "contextFingerprint": zod.string().regex(chatWithAgentResponseWorkspaceEvidenceManifestContextFingerprintRegExp),
  "queryHash": zod.string().regex(chatWithAgentResponseWorkspaceEvidenceManifestQueryHashRegExp),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(chatWithAgentResponseWorkspaceEvidenceManifestChannelDefault),
  "retrievalMode": zod.enum(['lexical']),
  "maxEvidenceChars": zod.int().min(chatWithAgentResponseWorkspaceEvidenceManifestMaxEvidenceCharsMin).max(chatWithAgentResponseWorkspaceEvidenceManifestMaxEvidenceCharsMax),
  "maxPassages": zod.int().min(chatWithAgentResponseWorkspaceEvidenceManifestMaxPassagesMin).max(chatWithAgentResponseWorkspaceEvidenceManifestMaxPassagesMax),
  "state": zod.enum(['ready', 'partial', 'insufficient', 'conflicting', 'unavailable']),
  "message": zod.string().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestMessageMax),
  "backgroundState": zod.string().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestBackgroundStateMax),
  "passages": zod.array(zod.object({
  "id": zod.uuid(),
  "citation": zod.int().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemCitationMax),
  "kind": zod.enum(['workspace', 'knowledge', 'crm']),
  "tier": zod.enum(['primary', 'background']),
  "reason": zod.enum(['automatic', 'explicit', 'entity_background']),
  "role": zod.enum(['provided', 'working', 'submission']).nullable(),
  "membershipId": zod.uuid().nullable(),
  "membershipRevision": zod.uuid().nullable(),
  "folderRevision": zod.uuid().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "extractionRevision": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "managedDocumentId": zod.uuid().nullable(),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "knowledgeFileId": zod.uuid().nullable(),
  "indexDocumentId": zod.uuid().nullable(),
  "chunkId": zod.uuid().nullable(),
  "crmIdentity": zod.string().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemCrmIdentityMax).nullable(),
  "sourceVersion": zod.string().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemSourceVersionMax),
  "contentHash": zod.string().regex(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemContentHashRegExp),
  "excerptHash": zod.string().regex(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemExcerptHashRegExp),
  "label": zod.string().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemLabelMax),
  "location": zod.string().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemLocationMax),
  "excerpt": zod.string().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemExcerptMax),
  "score": zod.number().min(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemScoreMin).max(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemScoreMax),
  "start": zod.int().min(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemStartMin).nullable(),
  "end": zod.int().min(chatWithAgentResponseWorkspaceEvidenceManifestPassagesItemEndMin).nullable()
})).max(chatWithAgentResponseWorkspaceEvidenceManifestPassagesMax),
  "sources": zod.array(zod.object({
  "membershipId": zod.uuid(),
  "role": zod.enum(['provided', 'working', 'submission']),
  "state": zod.enum(['excluded', 'stored', 'pending', 'ready', 'unsupported', 'failed', 'denied', 'stale', 'unavailable', 'irrelevant', 'omitted_budget']),
  "message": zod.string().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestSourcesItemMessageMax)
})).max(chatWithAgentResponseWorkspaceEvidenceManifestSourcesMax),
  "warnings": zod.array(zod.string().min(1).max(chatWithAgentResponseWorkspaceEvidenceManifestWarningsItemMax)).max(chatWithAgentResponseWorkspaceEvidenceManifestWarningsMax)
})
}).optional(),
  "sow": zod.object({
  "proposalId": zod.uuid().optional(),
  "proposalRevision": zod.int().min(1).optional(),
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid(),
  "templateVersionId": zod.uuid(),
  "title": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(chatWithAgentResponseSowTwoWorkspaceContextManifestHashRegExp)
}).optional(),
  "requestId": zod.uuid().nullish(),
  "facts": zod.object({
  "projectTitle": zod.string().max(chatWithAgentResponseSowTwoFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(chatWithAgentResponseSowTwoFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(chatWithAgentResponseSowTwoFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(chatWithAgentResponseSowTwoFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(chatWithAgentResponseSowTwoFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(chatWithAgentResponseSowTwoFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(chatWithAgentResponseSowTwoFactsNarrativeItemTextMax)
})).max(chatWithAgentResponseSowTwoFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(chatWithAgentResponseSowTwoFactsTablesItemRowsItemItemMax)).max(chatWithAgentResponseSowTwoFactsTablesItemRowsItemMax)).max(chatWithAgentResponseSowTwoFactsTablesItemRowsMax)
})).max(chatWithAgentResponseSowTwoFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(chatWithAgentResponseSowTwoFactsInvestmentItemIdMax),
  "title": zod.string().max(chatWithAgentResponseSowTwoFactsInvestmentItemTitleMax),
  "description": zod.string().max(chatWithAgentResponseSowTwoFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(chatWithAgentResponseSowTwoFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(chatWithAgentResponseSowTwoFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(chatWithAgentResponseSowTwoFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(chatWithAgentResponseSowTwoFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(chatWithAgentResponseSowTwoFactsMaterialsItemIdMax),
  "title": zod.string().max(chatWithAgentResponseSowTwoFactsMaterialsItemTitleMax),
  "description": zod.string().max(chatWithAgentResponseSowTwoFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(chatWithAgentResponseSowTwoFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(chatWithAgentResponseSowTwoFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(chatWithAgentResponseSowTwoFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(chatWithAgentResponseSowTwoFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(chatWithAgentResponseSowTwoFactsInvoicesItemIdMax),
  "milestones": zod.string().max(chatWithAgentResponseSowTwoFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(chatWithAgentResponseSowTwoFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(chatWithAgentResponseSowTwoFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(chatWithAgentResponseSowTwoFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(chatWithAgentResponseSowTwoFactsInvoicesItemNotesMax)
})).max(chatWithAgentResponseSowTwoFactsInvoicesMax),
  "milestoneDays": zod.string().regex(chatWithAgentResponseSowTwoFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(chatWithAgentResponseSowTwoFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(chatWithAgentResponseSowTwoFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(chatWithAgentResponseSowTwoFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(chatWithAgentResponseSowTwoFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(chatWithAgentResponseSowTwoFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(chatWithAgentResponseSowTwoFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(chatWithAgentResponseSowTwoFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(chatWithAgentResponseSowTwoFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(chatWithAgentResponseSowTwoFactsQuoteCommercialReviewReasonMin).max(chatWithAgentResponseSowTwoFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(chatWithAgentResponseSowTwoFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(chatWithAgentResponseSowTwoFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(chatWithAgentResponseSowTwoFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(chatWithAgentResponseSowTwoFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(chatWithAgentResponseSowTwoFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(chatWithAgentResponseSowTwoFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(chatWithAgentResponseSowTwoFactsUnresolvedFactsItemMessageMax)
})).max(chatWithAgentResponseSowTwoFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(chatWithAgentResponseSowTwoFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(chatWithAgentResponseSowTwoFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(chatWithAgentResponseSowTwoFactsCustomFieldsItemValueMax).nullable()
})).max(chatWithAgentResponseSowTwoFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(chatWithAgentResponseSowTwoFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(chatWithAgentResponseSowTwoFactsCustomProseItemTextMax)
})).max(chatWithAgentResponseSowTwoFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(chatWithAgentResponseSowTwoFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(chatWithAgentResponseSowTwoFactsCustomTablesItemRowsItemItemMax)).max(chatWithAgentResponseSowTwoFactsCustomTablesItemRowsItemMax)).max(chatWithAgentResponseSowTwoFactsCustomTablesItemRowsMax)
})).max(chatWithAgentResponseSowTwoFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}),
  "selectedSources": zod.array(zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'document', 'request']),
  "id": zod.uuid()
}).and(zod.object({
  "hash": zod.string().regex(chatWithAgentResponseSowTwoSelectedSourcesItemTwoHashRegExp),
  "revision": zod.string().max(chatWithAgentResponseSowTwoSelectedSourcesItemTwoRevisionMax),
  "sourceKey": zod.string().max(chatWithAgentResponseSowTwoSelectedSourcesItemTwoSourceKeyMax),
  "label": zod.string().max(chatWithAgentResponseSowTwoSelectedSourcesItemTwoLabelMax),
  "excerpt": zod.string().max(chatWithAgentResponseSowTwoSelectedSourcesItemTwoExcerptMax)
}))).max(chatWithAgentResponseSowTwoSelectedSourcesMax),
  "confirmedFacts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(chatWithAgentResponseSowTwoConfirmedFactsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(chatWithAgentResponseSowTwoConfirmedFactsItemSourceIdsItemMax)).max(chatWithAgentResponseSowTwoConfirmedFactsItemSourceIdsMax)
})).max(chatWithAgentResponseSowTwoConfirmedFactsMax),
  "assumptions": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(chatWithAgentResponseSowTwoAssumptionsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(chatWithAgentResponseSowTwoAssumptionsItemSourceIdsItemMax)).max(chatWithAgentResponseSowTwoAssumptionsItemSourceIdsMax)
})).max(chatWithAgentResponseSowTwoAssumptionsMax),
  "gaps": zod.array(zod.object({
  "field": zod.string(),
  "message": zod.string()
})).max(chatWithAgentResponseSowTwoGapsMax),
  "corrections": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string(),
  "after": zod.string(),
  "reason": zod.string()
})).max(chatWithAgentResponseSowTwoCorrectionsMax),
  "validation": zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsTopMin).max(chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsRightMin).max(chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsBottomMin).max(chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsLeftMin).max(chatWithAgentResponseSowTwoContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(chatWithAgentResponseSowTwoContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(chatWithAgentResponseSowTwoContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(chatWithAgentResponseSowTwoContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(chatWithAgentResponseSowTwoContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(chatWithAgentResponseSowTwoContentLayoutHeaderItemContentMax).optional()
})).max(chatWithAgentResponseSowTwoContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(chatWithAgentResponseSowTwoContentLayoutFooterItemTypeMax),
  "text": zod.string().max(chatWithAgentResponseSowTwoContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(chatWithAgentResponseSowTwoContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(chatWithAgentResponseSowTwoContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(chatWithAgentResponseSowTwoContentLayoutFooterItemContentMax).optional()
})).max(chatWithAgentResponseSowTwoContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(chatWithAgentResponseSowTwoContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(chatWithAgentResponseSowTwoContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(chatWithAgentResponseSowTwoContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(chatWithAgentResponseSowTwoContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(chatWithAgentResponseSowTwoContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(chatWithAgentResponseSowTwoContentStylesDefinitionsItemFontSizeMin).max(chatWithAgentResponseSowTwoContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(chatWithAgentResponseSowTwoContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(chatWithAgentResponseSowTwoContentStylesDefinitionsItemSpaceBeforeMin).max(chatWithAgentResponseSowTwoContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(chatWithAgentResponseSowTwoContentStylesDefinitionsItemSpaceAfterMin).max(chatWithAgentResponseSowTwoContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(chatWithAgentResponseSowTwoContentStylesDefinitionsItemLineHeightMax)
})).min(chatWithAgentResponseSowTwoContentStylesDefinitionsMin).max(chatWithAgentResponseSowTwoContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(chatWithAgentResponseSowTwoContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(chatWithAgentResponseSowTwoContentTemplateSectionGuidanceItemGuidanceMax)
})).max(chatWithAgentResponseSowTwoContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(chatWithAgentResponseSowTwoContentContentItemTypeMax),
  "text": zod.string().max(chatWithAgentResponseSowTwoContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(chatWithAgentResponseSowTwoContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(chatWithAgentResponseSowTwoContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(chatWithAgentResponseSowTwoContentContentItemContentMax).optional()
})).max(chatWithAgentResponseSowTwoContentContentMax)
}),
  "sourceStatus": zod.enum(['current', 'stale'])
})).optional(),
  "webEvidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(chatWithAgentResponseWebEvidenceMax).optional(),
  "reply": zod.string(),
  "conversationId": zod.uuid(),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.string(),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish(),
  "citation": zod.int().min(1),
  "sourceType": zod.enum(['crm_record', 'uploaded_document', 'crm_inventory', 'workspace_evidence', 'conversation_attachment', 'shared_conversation_attachment']),
  "sourceVersion": zod.string().nullish(),
  "tier": zod.enum(['primary', 'background']).optional(),
  "contentHash": zod.string().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(chatWithAgentResponseSourcesItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "sourceIdentity": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "freshness": zod.iso.datetime({"offset":true}).nullable(),
  "retrievalScore": zod.number().nullable()
})),
  "draftHandoffs": zod.array(zod.object({
  "channel": zod.enum(['email', 'social', 'quote', 'video_project']),
  "label": zod.string(),
  "deepLink": zod.string(),
  "draft": zod.string(),
  "videoProject": zod.union([zod.object({
  "mode": zod.enum(['single_clip', 'storyboard']),
  "title": zod.string().min(1).max(chatWithAgentResponseDraftHandoffsItemVideoProjectOneTitleMax),
  "brief": zod.string().min(1).max(chatWithAgentResponseDraftHandoffsItemVideoProjectOneBriefMax),
  "aspectRatio": zod.enum(['16:9', '9:16']),
  "scenes": zod.array(zod.object({
  "title": zod.string().min(1).max(chatWithAgentResponseDraftHandoffsItemVideoProjectOneScenesItemTitleMax),
  "prompt": zod.string().min(1).max(chatWithAgentResponseDraftHandoffsItemVideoProjectOneScenesItemPromptMax),
  "negativePrompt": zod.string().max(chatWithAgentResponseDraftHandoffsItemVideoProjectOneScenesItemNegativePromptMax).nullable(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)])
})).min(1).max(chatWithAgentResponseDraftHandoffsItemVideoProjectOneScenesMax)
}),zod.null()]).optional(),
  "aiAuditId": zod.uuid().nullish()
})),
  "evidenceState": zod.enum(['ready', 'crm_only', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence']),
  "evidenceMessage": zod.string(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "proposals": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(chatWithAgentResponseProposalsItemReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})),
  "clarification": zod.union([zod.object({
  "id": zod.uuid(),
  "questions": zod.array(zod.object({
  "id": zod.string().min(1).max(chatWithAgentResponseClarificationOneQuestionsItemIdMax).regex(chatWithAgentResponseClarificationOneQuestionsItemIdRegExp),
  "label": zod.string().min(1).max(chatWithAgentResponseClarificationOneQuestionsItemLabelMax),
  "mode": zod.enum(['single_choice', 'multiple_choice', 'text']),
  "options": zod.array(zod.object({
  "id": zod.string().min(1).max(chatWithAgentResponseClarificationOneQuestionsItemOptionsItemIdMax).regex(chatWithAgentResponseClarificationOneQuestionsItemOptionsItemIdRegExp),
  "label": zod.string().min(1).max(chatWithAgentResponseClarificationOneQuestionsItemOptionsItemLabelMax),
  "description": zod.string().max(chatWithAgentResponseClarificationOneQuestionsItemOptionsItemDescriptionMax).nullish()
})).max(chatWithAgentResponseClarificationOneQuestionsItemOptionsMax),
  "allowFreeText": zod.boolean()
})).min(1).max(chatWithAgentResponseClarificationOneQuestionsMax)
}),zod.null()]).optional()
})


/**
 * @summary Resolve an explicitly selected Agent access scope
 */
export const getAgentContextBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
})
})

export const getAgentContextResponseBillingBalanceMin = 0;

export const getAgentContextResponseBillingActionCostMin = 0;



export const getAgentContextResponse = zod.object({
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "label": zod.string(),
  "permissions": zod.array(zod.string()),
  "capabilities": zod.array(zod.object({
  "key": zod.string(),
  "label": zod.string(),
  "category": zod.string(),
  "scope": zod.enum(['entity', 'tenant', 'platform']),
  "kind": zod.enum(['read', 'execute', 'human_handoff']),
  "available": zod.boolean(),
  "requiredPermission": zod.string(),
  "description": zod.string(),
  "unavailableReason": zod.string().nullish(),
  "handoffPath": zod.string().nullish()
})),
  "billing": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "label": zod.string(),
  "balance": zod.int().min(getAgentContextResponseBillingBalanceMin).nullable(),
  "actionCost": zod.int().min(getAgentContextResponseBillingActionCostMin)
})
})


/**
 * @summary Read the exact bid setup without creating documents or tasks
 */
export const previewBidSetupBodyDocumentsItemKeyMax = 64;


export const previewBidSetupBodyDocumentsItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]*$');
export const previewBidSetupBodyDocumentsItemTitleMax = 200;

export const previewBidSetupBodyDocumentsItemSkeletonTextMax = 4000;

export const previewBidSetupBodyDocumentsItemRequirementIdsMax = 100;

export const previewBidSetupBodyDocumentsMax = 20;

export const previewBidSetupBodyAssignmentsItemKeyMax = 64;


export const previewBidSetupBodyAssignmentsItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]*$');
export const previewBidSetupBodyAssignmentsItemTitleMax = 200;

export const previewBidSetupBodyAssignmentsItemRequirementIdsMax = 100;

export const previewBidSetupBodyAssignmentsItemDocumentKeysItemMax = 64;

export const previewBidSetupBodyAssignmentsItemDocumentKeysMax = 20;

export const previewBidSetupBodyAssignmentsMax = 40;



export const previewBidSetupBody = zod.object({
  "tenderId": zod.uuid(),
  "documents": zod.array(zod.object({
  "key": zod.string().min(1).max(previewBidSetupBodyDocumentsItemKeyMax).regex(previewBidSetupBodyDocumentsItemKeyRegExp),
  "title": zod.string().min(1).max(previewBidSetupBodyDocumentsItemTitleMax),
  "skeletonText": zod.string().max(previewBidSetupBodyDocumentsItemSkeletonTextMax),
  "requirementIds": zod.array(zod.uuid()).max(previewBidSetupBodyDocumentsItemRequirementIdsMax)
})).min(1).max(previewBidSetupBodyDocumentsMax),
  "assignments": zod.array(zod.object({
  "key": zod.string().min(1).max(previewBidSetupBodyAssignmentsItemKeyMax).regex(previewBidSetupBodyAssignmentsItemKeyRegExp),
  "title": zod.string().min(1).max(previewBidSetupBodyAssignmentsItemTitleMax),
  "ownerAppUserId": zod.uuid().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "requirementIds": zod.array(zod.uuid()).max(previewBidSetupBodyAssignmentsItemRequirementIdsMax),
  "documentKeys": zod.array(zod.string().max(previewBidSetupBodyAssignmentsItemDocumentKeysItemMax)).max(previewBidSetupBodyAssignmentsItemDocumentKeysMax)
})).max(previewBidSetupBodyAssignmentsMax)
})

export const previewBidSetupResponseInputDocumentsItemKeyMax = 64;


export const previewBidSetupResponseInputDocumentsItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]*$');
export const previewBidSetupResponseInputDocumentsItemTitleMax = 200;

export const previewBidSetupResponseInputDocumentsItemSkeletonTextMax = 4000;

export const previewBidSetupResponseInputDocumentsItemRequirementIdsMax = 100;

export const previewBidSetupResponseInputDocumentsMax = 20;

export const previewBidSetupResponseInputAssignmentsItemKeyMax = 64;


export const previewBidSetupResponseInputAssignmentsItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9_-]*$');
export const previewBidSetupResponseInputAssignmentsItemTitleMax = 200;

export const previewBidSetupResponseInputAssignmentsItemRequirementIdsMax = 100;

export const previewBidSetupResponseInputAssignmentsItemDocumentKeysItemMax = 64;

export const previewBidSetupResponseInputAssignmentsItemDocumentKeysMax = 20;

export const previewBidSetupResponseInputAssignmentsMax = 40;

export const previewBidSetupResponseExistingAssignmentsMax = 40;

export const previewBidSetupResponseSourceRevisionsMax = 30;

export const previewBidSetupResponseOwnersMax = 40;

export const previewBidSetupResponseStageModelsMax = 4;

export const previewBidSetupResponseWarningsMax = 150;



export const previewBidSetupResponse = zod.object({
  "input": zod.object({
  "tenderId": zod.uuid(),
  "documents": zod.array(zod.object({
  "key": zod.string().min(1).max(previewBidSetupResponseInputDocumentsItemKeyMax).regex(previewBidSetupResponseInputDocumentsItemKeyRegExp),
  "title": zod.string().min(1).max(previewBidSetupResponseInputDocumentsItemTitleMax),
  "skeletonText": zod.string().max(previewBidSetupResponseInputDocumentsItemSkeletonTextMax),
  "requirementIds": zod.array(zod.uuid()).max(previewBidSetupResponseInputDocumentsItemRequirementIdsMax)
})).min(1).max(previewBidSetupResponseInputDocumentsMax),
  "assignments": zod.array(zod.object({
  "key": zod.string().min(1).max(previewBidSetupResponseInputAssignmentsItemKeyMax).regex(previewBidSetupResponseInputAssignmentsItemKeyRegExp),
  "title": zod.string().min(1).max(previewBidSetupResponseInputAssignmentsItemTitleMax),
  "ownerAppUserId": zod.uuid().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "requirementIds": zod.array(zod.uuid()).max(previewBidSetupResponseInputAssignmentsItemRequirementIdsMax),
  "documentKeys": zod.array(zod.string().max(previewBidSetupResponseInputAssignmentsItemDocumentKeysItemMax)).max(previewBidSetupResponseInputAssignmentsItemDocumentKeysMax)
})).max(previewBidSetupResponseInputAssignmentsMax)
}),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "tenantName": zod.string(),
  "entityName": zod.string(),
  "tenderTitle": zod.string(),
  "inventoryFingerprint": zod.string(),
  "storageFingerprint": zod.string(),
  "priorStepHashes": zod.record(zod.string(), zod.string()).optional(),
  "existingAssignments": zod.array(zod.object({
  "key": zod.string(),
  "activityId": zod.uuid(),
  "ownerAppUserId": zod.string().nullable(),
  "ownerName": zod.string().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable()
})).max(previewBidSetupResponseExistingAssignmentsMax).optional(),
  "sourceRevisions": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.string(),
  "hash": zod.string()
})).max(previewBidSetupResponseSourceRevisionsMax),
  "owners": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "authorizationRevision": zod.string()
})).max(previewBidSetupResponseOwnersMax),
  "stageModels": zod.array(zod.object({
  "stage": zod.enum(['research', 'assessment', 'drafting', 'buyer_review']),
  "choiceId": zod.string().nullable(),
  "selectionRevision": zod.int().nullable(),
  "policyFingerprint": zod.string(),
  "binding": zod.record(zod.string(), zod.unknown()).nullable()
})).max(previewBidSetupResponseStageModelsMax),
  "warnings": zod.array(zod.string()).max(previewBidSetupResponseWarningsMax),
  "permittedDraftWork": zod.string()
})


export const getBidSetupProgressParams = zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid()
})

export const getBidSetupProgressQuerySearchMax = 200;

export const getBidSetupProgressQueryLimitDefault = 20;
export const getBidSetupProgressQueryLimitMax = 100;

export const getBidSetupProgressQueryOffsetDefault = 0;
export const getBidSetupProgressQueryOffsetMin = 0;



export const getBidSetupProgressQueryParams = zod.object({
  "search": zod.string().max(getBidSetupProgressQuerySearchMax).optional(),
  "filesOnly": zod.boolean().optional(),
  "limit": zod.int().min(1).max(getBidSetupProgressQueryLimitMax).default(getBidSetupProgressQueryLimitDefault),
  "offset": zod.int().min(getBidSetupProgressQueryOffsetMin).default(getBidSetupProgressQueryOffsetDefault)
})

export const getBidSetupProgressResponse = zod.object({
  "planId": zod.uuid(),
  "tenderId": zod.uuid(),
  "status": zod.enum(['proposed', 'approved', 'cancelled', 'superseded']),
  "snapshotHash": zod.string(),
  "link": zod.string(),
  "error": zod.string().nullable(),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "items": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['document', 'assignment']),
  "documentId": zod.uuid().nullable(),
  "versionId": zod.uuid().nullable(),
  "activityId": zod.uuid().nullable(),
  "materialized": zod.boolean(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "status": zod.string(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "ownerAppUserId": zod.string().nullable(),
  "completionEvidence": zod.string().nullable(),
  "blockers": zod.array(zod.string())
}))
})


/**
 * @summary Resume the unchanged approved actor-bound setup without repeating completed writes
 */
export const resumeBidSetupParams = zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid()
})

export const resumeBidSetupResponse = zod.object({
  "planId": zod.uuid(),
  "tenderId": zod.uuid(),
  "status": zod.enum(['proposed', 'approved', 'cancelled', 'superseded']),
  "snapshotHash": zod.string(),
  "link": zod.string(),
  "error": zod.string().nullable(),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "items": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['document', 'assignment']),
  "documentId": zod.uuid().nullable(),
  "versionId": zod.uuid().nullable(),
  "activityId": zod.uuid().nullable(),
  "materialized": zod.boolean(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "status": zod.string(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "ownerAppUserId": zod.string().nullable(),
  "completionEvidence": zod.string().nullable(),
  "blockers": zod.array(zod.string())
}))
})


export const cancelBidSetupParams = zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid()
})

export const cancelBidSetupBodyReasonMin = 3;
export const cancelBidSetupBodyReasonMax = 1000;



export const cancelBidSetupBody = zod.object({
  "reason": zod.string().min(cancelBidSetupBodyReasonMin).max(cancelBidSetupBodyReasonMax)
})

export const cancelBidSetupResponse = zod.object({
  "planId": zod.uuid(),
  "tenderId": zod.uuid(),
  "status": zod.enum(['proposed', 'approved', 'cancelled', 'superseded']),
  "snapshotHash": zod.string(),
  "link": zod.string(),
  "error": zod.string().nullable(),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "items": zod.array(zod.object({
  "key": zod.string(),
  "kind": zod.enum(['document', 'assignment']),
  "documentId": zod.uuid().nullable(),
  "versionId": zod.uuid().nullable(),
  "activityId": zod.uuid().nullable(),
  "materialized": zod.boolean(),
  "requirementIds": zod.array(zod.uuid()),
  "documentKeys": zod.array(zod.string()),
  "status": zod.string(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "ownerAppUserId": zod.string().nullable(),
  "completionEvidence": zod.string().nullable(),
  "blockers": zod.array(zod.string())
}))
})


/**
 * @summary Prepare a side-effect-free, durable Agent action proposal
 */
export const prepareAgentActionBodyActionKeyMax = 120;



export const prepareAgentActionBody = zod.object({
  "conversationId": zod.uuid(),
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string().min(1).max(prepareAgentActionBodyActionKeyMax),
  "arguments": zod.record(zod.string(), zod.unknown())
})


export const prepareAgentActionResponseReviewDestructiveDefault = false;

export const prepareAgentActionResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(prepareAgentActionResponseReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})


/**
 * @summary Read one actor-owned Agent proposal
 */
export const getAgentProposalParams = zod.object({
  "id": zod.uuid()
})


export const getAgentProposalResponseReviewDestructiveDefault = false;

export const getAgentProposalResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(getAgentProposalResponseReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})


/**
 * @summary Confirm and execute the exact stored proposal
 */
export const reviewAgentProposalParams = zod.object({
  "id": zod.uuid()
})

export const reviewAgentProposalBodyPreviewHashMin = 64;
export const reviewAgentProposalBodyPreviewHashMax = 64;

export const reviewAgentProposalBodyReasonMin = 3;
export const reviewAgentProposalBodyReasonMax = 1000;



export const reviewAgentProposalBody = zod.object({
  "previewHash": zod.string().min(reviewAgentProposalBodyPreviewHashMin).max(reviewAgentProposalBodyPreviewHashMax),
  "reason": zod.string().min(reviewAgentProposalBodyReasonMin).max(reviewAgentProposalBodyReasonMax)
})

export const reviewAgentProposalResponse = zod.object({
  "replayed": zod.boolean().optional().describe('True for read-only receipt recovery or a review that found an existing execution. Only an explicit false on a fresh successful confirmation is eligible for create-and-open navigation.'),
  "id": zod.uuid(),
  "proposalId": zod.uuid(),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'partial', 'indeterminate']),
  "receipt": zod.record(zod.string(), zod.unknown()).nullable(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "auditIds": zod.array(zod.uuid()),
  "jobIds": zod.array(zod.uuid()),
  "startedAt": zod.iso.datetime({"offset":true}),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish()
})


/**
 * @summary Cancel an unexecuted Agent proposal
 */
export const cancelAgentProposalParams = zod.object({
  "id": zod.uuid()
})

export const cancelAgentProposalBodyReasonMin = 3;
export const cancelAgentProposalBodyReasonMax = 1000;



export const cancelAgentProposalBody = zod.object({
  "reason": zod.string().min(cancelAgentProposalBodyReasonMin).max(cancelAgentProposalBodyReasonMax)
})


export const cancelAgentProposalResponseReviewDestructiveDefault = false;

export const cancelAgentProposalResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(cancelAgentProposalResponseReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})


/**
 * @summary Read one actor-owned Agent execution status and receipt
 */
export const getAgentExecutionParams = zod.object({
  "id": zod.uuid()
})

export const getAgentExecutionResponse = zod.object({
  "replayed": zod.boolean().optional().describe('True for read-only receipt recovery or a review that found an existing execution. Only an explicit false on a fresh successful confirmation is eligible for create-and-open navigation.'),
  "id": zod.uuid(),
  "proposalId": zod.uuid(),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'partial', 'indeterminate']),
  "receipt": zod.record(zod.string(), zod.unknown()).nullable(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "auditIds": zod.array(zod.uuid()),
  "jobIds": zod.array(zod.uuid()),
  "startedAt": zod.iso.datetime({"offset":true}),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish()
})


/**
 * @summary List authorized stored file metadata
 */
export const listFilesQueryLimitDefault = 25;
export const listFilesQueryLimitMax = 100;

export const listFilesQueryOffsetDefault = 0;
export const listFilesQueryOffsetMin = 0;



export const listFilesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listFilesQueryLimitMax).default(listFilesQueryLimitDefault),
  "offset": zod.int().min(listFilesQueryOffsetMin).default(listFilesQueryOffsetDefault)
})

export const listFilesHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const listFilesHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(listFilesHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const listFilesResponseTotalMin = 0;



export const listFilesResponse = zod.object({
  "files": zod.array(zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "ownerDisplayName": zod.string().nullish()
})),
  "total": zod.int().min(listFilesResponseTotalMin)
})


/**
 * @summary Upload a file
 */
export const uploadFileHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const uploadFileHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(uploadFileHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const uploadFileBody = zod.object({
  "file": zod.instanceof(Blob)
})

export const uploadFileResponse = zod.object({
  "id": zod.string(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "ownerDisplayName": zod.string().nullish()
})


/**
 * @summary Delete a stored file
 */
export const deleteFileParams = zod.object({
  "id": zod.string()
})

export const deleteFileResponse = zod.void()


/**
 * @summary Download file content
 */
export const downloadFileParams = zod.object({
  "id": zod.string()
})

export const downloadFileResponse = zod.unknown()


/**
 * Filters apply before counts, source facets and stable modified-time/kind/ID pagination. Hierarchy views reference canonical sources without copying or provisioning. Account links never grant source access. Campaign files follow current native step media references; campaigns have no inferred primary account. Native Word snapshots remain actor-private.
 * @summary Search all authorized registered file and managed document metadata
 */
export const listFileLibraryQuerySearchMax = 200;

export const listFileLibraryQuerySourceMax = 80;

export const listFileLibraryQueryStatusMax = 40;

export const listFileLibraryQueryFolderMax = 500;

export const listFileLibraryQueryTypeMax = 120;

export const listFileLibraryQueryLabelMax = 80;

export const listFileLibraryQueryLimitDefault = 25;
export const listFileLibraryQueryLimitMax = 100;

export const listFileLibraryQueryOffsetDefault = 0;
export const listFileLibraryQueryOffsetMin = 0;



export const listFileLibraryQueryParams = zod.object({
  "entryId": zod.uuid().optional().describe('Exact canonical library entry for authenticated app links; all source permissions still apply.'),
  "grouping": zod.enum(['tenders', 'campaigns', 'accounts']).optional(),
  "tenderId": zod.uuid().optional(),
  "campaignId": zod.uuid().optional(),
  "accountId": zod.uuid().optional(),
  "search": zod.string().max(listFileLibraryQuerySearchMax).optional(),
  "kind": zod.enum(['file', 'document']).optional().describe('Restrict eligible canonical identities before counts and paging.'),
  "source": zod.string().max(listFileLibraryQuerySourceMax).optional(),
  "status": zod.string().max(listFileLibraryQueryStatusMax).optional(),
  "folder": zod.string().max(listFileLibraryQueryFolderMax).optional(),
  "type": zod.string().max(listFileLibraryQueryTypeMax).optional(),
  "label": zod.string().max(listFileLibraryQueryLabelMax).optional(),
  "limit": zod.int().min(1).max(listFileLibraryQueryLimitMax).default(listFileLibraryQueryLimitDefault),
  "offset": zod.int().min(listFileLibraryQueryOffsetMin).default(listFileLibraryQueryOffsetDefault)
})

export const listFileLibraryResponseItemsItemSizeBytesMin = 0;

export const listFileLibraryResponseTotalMin = 0;


export const listFileLibraryResponseOffsetMin = 0;

export const listFileLibraryResponseRegistrationCreatedMin = 0;

export const listFileLibraryResponseRegistrationUpdatedMin = 0;

export const listFileLibraryResponseRegistrationUnchangedMin = 0;



export const listFileLibraryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['file', 'document']),
  "title": zod.string(),
  "contentType": zod.string().nullable(),
  "sizeBytes": zod.int().min(listFileLibraryResponseItemsItemSizeBytesMin).nullable(),
  "sourceKind": zod.string(),
  "sourceLabel": zod.string(),
  "sourceUrl": zod.string().nullish(),
  "owningRecordType": zod.string().nullish(),
  "owningRecordId": zod.string().nullish(),
  "managementMode": zod.enum(['managed', 'source_owned']),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.string(),
  "canEdit": zod.boolean(),
  "canCreateManagedCopy": zod.boolean(),
  "downloadUrl": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listFileLibraryResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listFileLibraryResponseOffsetMin),
  "registration": zod.object({
  "created": zod.int().min(listFileLibraryResponseRegistrationCreatedMin),
  "updated": zod.int().min(listFileLibraryResponseRegistrationUpdatedMin),
  "unchanged": zod.int().min(listFileLibraryResponseRegistrationUnchangedMin),
  "discrepancies": zod.array(zod.string()),
  "sources": zod.array(zod.string())
})
})


/**
 * Requires tenant.settings.manage and current native entity.records.read. Never changes the active workspace or grants business-record access.
 * @summary Page entities with native file access in the administration tenant
 */
export const listTenantLibraryEntitiesQueryLimitDefault = 25;
export const listTenantLibraryEntitiesQueryLimitMax = 100;

export const listTenantLibraryEntitiesQueryOffsetDefault = 0;
export const listTenantLibraryEntitiesQueryOffsetMin = 0;



export const listTenantLibraryEntitiesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenantLibraryEntitiesQueryLimitMax).default(listTenantLibraryEntitiesQueryLimitDefault),
  "offset": zod.int().min(listTenantLibraryEntitiesQueryOffsetMin).default(listTenantLibraryEntitiesQueryOffsetDefault)
})

export const listTenantLibraryEntitiesResponseTotalMin = 0;


export const listTenantLibraryEntitiesResponseOffsetMin = 0;



export const listTenantLibraryEntitiesResponse = zod.object({
  "items": zod.array(zod.object({
  "tenantId": zod.uuid(),
  "tenantName": zod.string(),
  "entityId": zod.uuid(),
  "entityName": zod.string()
})),
  "total": zod.int().min(listTenantLibraryEntitiesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listTenantLibraryEntitiesResponseOffsetMin)
})


/**
 * Requires tenant.settings.manage plus native entity and source permissions. Filters, counts and facets use the native complete library snapshot. No writes or active-context changes.
 * @summary Read-only library in an authorized entity of the administration tenant
 */
export const listTenantFileLibraryParams = zod.object({
  "entityId": zod.uuid()
})

export const listTenantFileLibraryQuerySearchMax = 200;

export const listTenantFileLibraryQuerySourceMax = 80;

export const listTenantFileLibraryQueryStatusMax = 40;

export const listTenantFileLibraryQueryFolderMax = 500;

export const listTenantFileLibraryQueryTypeMax = 120;

export const listTenantFileLibraryQueryLabelMax = 80;

export const listTenantFileLibraryQueryLimitDefault = 25;
export const listTenantFileLibraryQueryLimitMax = 100;

export const listTenantFileLibraryQueryOffsetDefault = 0;
export const listTenantFileLibraryQueryOffsetMin = 0;



export const listTenantFileLibraryQueryParams = zod.object({
  "search": zod.string().max(listTenantFileLibraryQuerySearchMax).optional(),
  "source": zod.string().max(listTenantFileLibraryQuerySourceMax).optional(),
  "status": zod.string().max(listTenantFileLibraryQueryStatusMax).optional(),
  "folder": zod.string().max(listTenantFileLibraryQueryFolderMax).optional(),
  "type": zod.string().max(listTenantFileLibraryQueryTypeMax).optional(),
  "label": zod.string().max(listTenantFileLibraryQueryLabelMax).optional(),
  "limit": zod.int().min(1).max(listTenantFileLibraryQueryLimitMax).default(listTenantFileLibraryQueryLimitDefault),
  "offset": zod.int().min(listTenantFileLibraryQueryOffsetMin).default(listTenantFileLibraryQueryOffsetDefault)
})

export const listTenantFileLibraryResponseItemsItemSizeBytesMin = 0;

export const listTenantFileLibraryResponseTotalMin = 0;


export const listTenantFileLibraryResponseOffsetMin = 0;

export const listTenantFileLibraryResponseRegistrationCreatedMin = 0;

export const listTenantFileLibraryResponseRegistrationUpdatedMin = 0;

export const listTenantFileLibraryResponseRegistrationUnchangedMin = 0;



export const listTenantFileLibraryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['file', 'document']),
  "title": zod.string(),
  "contentType": zod.string().nullable(),
  "sizeBytes": zod.int().min(listTenantFileLibraryResponseItemsItemSizeBytesMin).nullable(),
  "sourceKind": zod.string(),
  "sourceLabel": zod.string(),
  "sourceUrl": zod.string().nullish(),
  "owningRecordType": zod.string().nullish(),
  "owningRecordId": zod.string().nullish(),
  "managementMode": zod.enum(['managed', 'source_owned']),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.string(),
  "canEdit": zod.boolean(),
  "canCreateManagedCopy": zod.boolean(),
  "downloadUrl": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenantFileLibraryResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listTenantFileLibraryResponseOffsetMin),
  "registration": zod.object({
  "created": zod.int().min(listTenantFileLibraryResponseRegistrationCreatedMin),
  "updated": zod.int().min(listTenantFileLibraryResponseRegistrationUpdatedMin),
  "unchanged": zod.int().min(listTenantFileLibraryResponseRegistrationUnchangedMin),
  "discrepancies": zod.array(zod.string()),
  "sources": zod.array(zod.string())
})
})


/**
 * Requires current tenant administration, native entity/source/file permission and exact tenant/entity ownership. Managed documents export clean Markdown through their native saved-revision owner. Source-owned external resources remain in their native workflow.
 * @summary Read permitted original file bytes or a clean saved document projection
 */
export const downloadTenantLibraryContentParams = zod.object({
  "entityId": zod.uuid(),
  "kind": zod.enum(['file', 'document']),
  "id": zod.uuid()
})

export const downloadTenantLibraryContentResponse = zod.unknown()


/**
 * @summary Idempotently register existing entity file sources
 */
export const registerFileLibrarySourcesResponseCreatedMin = 0;

export const registerFileLibrarySourcesResponseUpdatedMin = 0;

export const registerFileLibrarySourcesResponseUnchangedMin = 0;



export const registerFileLibrarySourcesResponse = zod.object({
  "created": zod.int().min(registerFileLibrarySourcesResponseCreatedMin),
  "updated": zod.int().min(registerFileLibrarySourcesResponseUpdatedMin),
  "unchanged": zod.int().min(registerFileLibrarySourcesResponseUnchangedMin),
  "discrepancies": zod.array(zod.string()),
  "sources": zod.array(zod.string())
})


/**
 * Requires entity.records.write and the current source permission. Native Word metadata stays source-owned.
 * @summary Update folder, labels, or archive state
 */
export const updateFileLibraryEntryParams = zod.object({
  "id": zod.uuid()
})

export const updateFileLibraryEntryBodyFolderMax = 500;

export const updateFileLibraryEntryBodyLabelsItemMax = 80;

export const updateFileLibraryEntryBodyLabelsMax = 20;



export const updateFileLibraryEntryBody = zod.object({
  "folder": zod.string().max(updateFileLibraryEntryBodyFolderMax).optional(),
  "labels": zod.array(zod.string().min(1).max(updateFileLibraryEntryBodyLabelsItemMax)).max(updateFileLibraryEntryBodyLabelsMax).optional(),
  "archived": zod.boolean().optional()
})

export const updateFileLibraryEntryResponseSizeBytesMin = 0;



export const updateFileLibraryEntryResponse = zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['file', 'document']),
  "title": zod.string(),
  "contentType": zod.string().nullable(),
  "sizeBytes": zod.int().min(updateFileLibraryEntryResponseSizeBytesMin).nullable(),
  "sourceKind": zod.string(),
  "sourceLabel": zod.string(),
  "sourceUrl": zod.string().nullish(),
  "owningRecordType": zod.string().nullish(),
  "owningRecordId": zod.string().nullish(),
  "managementMode": zod.enum(['managed', 'source_owned']),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.string(),
  "canEdit": zod.boolean(),
  "canCreateManagedCopy": zod.boolean(),
  "downloadUrl": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires entity.records.read. Capabilities come from the caller's current permissions and the host record; a missing or invisible host returns 404.
 * @summary Read the server-computed file library capabilities of a host record
 */
export const getFileHostParams = zod.object({
  "hostKind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']),
  "hostId": zod.uuid()
})

export const getFileHostResponse = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "title": zod.string(),
  "capabilities": zod.object({
  "read": zod.boolean(),
  "edit": zod.boolean(),
  "delete": zod.boolean(),
  "share": zod.boolean(),
  "createDocument": zod.boolean(),
  "createImage": zod.boolean(),
  "manageVersions": zod.boolean()
})
})


/**
 * Requires entity.records.write. Every file must belong to the host. Idempotent by requestId; a replay returns the original outcome.
 * @summary Move selected library files of one host into a library folder
 */
export const moveLibraryFilesBodyFilesMax = 100;

export const moveLibraryFilesBodyFolderMax = 500;

export const moveLibraryFilesBodyExpectedFolderMax = 500;



export const moveLibraryFilesBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "files": zod.array(zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
})).min(1).max(moveLibraryFilesBodyFilesMax),
  "folder": zod.string().max(moveLibraryFilesBodyFolderMax),
  "expectedFolder": zod.string().max(moveLibraryFilesBodyExpectedFolderMax).nullish().describe('Folder the caller last saw the files in. A file found elsewhere fails as stale (FOLDER_MOVE_STALE) and is left unchanged.'),
  "requestId": zod.uuid()
})

export const moveLibraryFilesResponseMovedMin = 0;



export const moveLibraryFilesResponse = zod.object({
  "requestId": zod.uuid(),
  "folder": zod.string(),
  "moved": zod.int().min(moveLibraryFilesResponseMovedMin),
  "results": zod.array(zod.object({
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "ok": zod.boolean(),
  "error": zod.string().nullable()
}))
})


/**
 * Writes nothing. Returns the exact current version token that a confirmed delete must repeat, and any records that retain the file.
 * @summary Prepare a delete review for one library file
 */
export const reviewLibraryFileDeletionBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
})
})

export const reviewLibraryFileDeletionResponseVersionRegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewLibraryFileDeletionResponseVersionsMin = 0;

export const reviewLibraryFileDeletionResponseActiveShareLinksMin = 0;



export const reviewLibraryFileDeletionResponse = zod.object({
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "version": zod.string().regex(reviewLibraryFileDeletionResponseVersionRegExp),
  "filename": zod.string(),
  "deletable": zod.boolean(),
  "blockers": zod.array(zod.string()),
  "versions": zod.int().min(reviewLibraryFileDeletionResponseVersionsMin),
  "activeShareLinks": zod.int().min(reviewLibraryFileDeletionResponseActiveShareLinksMin)
})


/**
 * Requires entity.records.write and the reviewed version token. A changed file returns 409. Idempotent by requestId.
 * @summary Delete one reviewed library file
 */
export const confirmLibraryFileDeletionBodyVersionRegExp = new RegExp('^[a-f0-9]{64}$');


export const confirmLibraryFileDeletionBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "version": zod.string().regex(confirmLibraryFileDeletionBodyVersionRegExp),
  "requestId": zod.uuid()
})

export const confirmLibraryFileDeletionResponse = zod.object({
  "requestId": zod.uuid(),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "filename": zod.string(),
  "deleted": zod.boolean(),
  "recycleBinItemId": zod.uuid().nullable().describe('The recycle bin item holding the file until it is restored or purged.')
})


/**
 * Requires entity.records.read and host ownership of the file. A file without saved versions reports its original as v1.0.
 * @summary Page the version history of a library file
 */
export const listLibraryFileVersionsParams = zod.object({
  "hostKind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']),
  "hostId": zod.uuid(),
  "fileKind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']),
  "fileId": zod.uuid()
})

export const listLibraryFileVersionsQueryLimitDefault = 25;
export const listLibraryFileVersionsQueryLimitMax = 100;

export const listLibraryFileVersionsQueryOffsetDefault = 0;
export const listLibraryFileVersionsQueryOffsetMin = 0;



export const listLibraryFileVersionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listLibraryFileVersionsQueryLimitMax).default(listLibraryFileVersionsQueryLimitDefault),
  "offset": zod.int().min(listLibraryFileVersionsQueryOffsetMin).default(listLibraryFileVersionsQueryOffsetDefault)
})


export const listLibraryFileVersionsResponseItemsItemMinorMin = 0;

export const listLibraryFileVersionsResponseItemsItemSizeBytesMin = 0;

export const listLibraryFileVersionsResponseTotalMin = 0;



export const listLibraryFileVersionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid().nullable().describe('Null for an original that has never been versioned.'),
  "label": zod.string(),
  "major": zod.int().min(1),
  "minor": zod.int().min(listLibraryFileVersionsResponseItemsItemMinorMin),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(listLibraryFileVersionsResponseItemsItemSizeBytesMin),
  "sha256": zod.string().nullable(),
  "note": zod.string(),
  "restoredFromVersionId": zod.uuid().nullable(),
  "isCurrent": zod.boolean(),
  "isOriginal": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listLibraryFileVersionsResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int(),
  "currentVersionId": zod.uuid().nullable(),
  "canUpload": zod.boolean(),
  "uploadBlockedReason": zod.string().nullable()
})


/**
 * Requires entity.records.write. The current version must equal expectedCurrentVersionId (omit while the file is still the v1.0 original). Files retained by other records keep their native history. Idempotent by requestId.
 * @summary Upload a new major or minor version of an uploaded library file
 */
export const uploadLibraryFileVersionParams = zod.object({
  "hostKind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']),
  "hostId": zod.uuid(),
  "fileKind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']),
  "fileId": zod.uuid()
})

export const uploadLibraryFileVersionQueryNoteMax = 500;



export const uploadLibraryFileVersionQueryParams = zod.object({
  "requestId": zod.uuid(),
  "versionKind": zod.enum(['major', 'minor']),
  "expectedCurrentVersionId": zod.uuid().optional(),
  "note": zod.string().max(uploadLibraryFileVersionQueryNoteMax).optional()
})

export const uploadLibraryFileVersionBody = zod.object({
  "file": zod.instanceof(Blob)
})


export const uploadLibraryFileVersionResponseMinorMin = 0;

export const uploadLibraryFileVersionResponseSizeBytesMin = 0;



export const uploadLibraryFileVersionResponse = zod.object({
  "id": zod.uuid().nullable().describe('Null for an original that has never been versioned.'),
  "label": zod.string(),
  "major": zod.int().min(1),
  "minor": zod.int().min(uploadLibraryFileVersionResponseMinorMin),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(uploadLibraryFileVersionResponseSizeBytesMin),
  "sha256": zod.string().nullable(),
  "note": zod.string(),
  "restoredFromVersionId": zod.uuid().nullable(),
  "isCurrent": zod.boolean(),
  "isOriginal": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Download the exact bytes of one saved version
 */
export const downloadLibraryFileVersionParams = zod.object({
  "hostKind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']),
  "hostId": zod.uuid(),
  "fileKind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']),
  "fileId": zod.uuid(),
  "versionId": zod.uuid()
})

export const downloadLibraryFileVersionResponse = zod.unknown()


/**
 * Writes nothing. Restoring creates a new version; history is never rewritten.
 * @summary Review restoring a saved version, including an integrity check of its stored bytes
 */
export const reviewLibraryFileRestoreParams = zod.object({
  "hostKind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']),
  "hostId": zod.uuid(),
  "fileKind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']),
  "fileId": zod.uuid(),
  "versionId": zod.uuid()
})


export const reviewLibraryFileRestoreResponseVersionMinorMin = 0;

export const reviewLibraryFileRestoreResponseVersionSizeBytesMin = 0;



export const reviewLibraryFileRestoreResponse = zod.object({
  "version": zod.object({
  "id": zod.uuid().nullable().describe('Null for an original that has never been versioned.'),
  "label": zod.string(),
  "major": zod.int().min(1),
  "minor": zod.int().min(reviewLibraryFileRestoreResponseVersionMinorMin),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(reviewLibraryFileRestoreResponseVersionSizeBytesMin),
  "sha256": zod.string().nullable(),
  "note": zod.string(),
  "restoredFromVersionId": zod.uuid().nullable(),
  "isCurrent": zod.boolean(),
  "isOriginal": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "currentVersionId": zod.uuid().nullable(),
  "nextMajorLabel": zod.string(),
  "nextMinorLabel": zod.string(),
  "integrityVerified": zod.boolean(),
  "canRestore": zod.boolean(),
  "blockedReason": zod.string().nullable()
})


/**
 * Requires entity.records.write, a matching expectedCurrentVersionId and verified stored bytes. Idempotent by requestId.
 * @summary Restore a saved version as a new current version
 */
export const restoreLibraryFileVersionParams = zod.object({
  "hostKind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']),
  "hostId": zod.uuid(),
  "fileKind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']),
  "fileId": zod.uuid(),
  "versionId": zod.uuid()
})

export const restoreLibraryFileVersionBody = zod.object({
  "expectedCurrentVersionId": zod.uuid().nullable(),
  "versionKind": zod.enum(['major', 'minor']),
  "requestId": zod.uuid()
})


export const restoreLibraryFileVersionResponseMinorMin = 0;

export const restoreLibraryFileVersionResponseSizeBytesMin = 0;



export const restoreLibraryFileVersionResponse = zod.object({
  "id": zod.uuid().nullable().describe('Null for an original that has never been versioned.'),
  "label": zod.string(),
  "major": zod.int().min(1),
  "minor": zod.int().min(restoreLibraryFileVersionResponseMinorMin),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(restoreLibraryFileVersionResponseSizeBytesMin),
  "sha256": zod.string().nullable(),
  "note": zod.string(),
  "restoredFromVersionId": zod.uuid().nullable(),
  "isCurrent": zod.boolean(),
  "isOriginal": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires share permission on the host. Tokens are never returned.
 * @summary Page share links of a host, optionally for one file
 */
export const listFileShareLinksQueryLimitDefault = 25;
export const listFileShareLinksQueryLimitMax = 100;

export const listFileShareLinksQueryOffsetDefault = 0;
export const listFileShareLinksQueryOffsetMin = 0;



export const listFileShareLinksQueryParams = zod.object({
  "hostKind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']),
  "hostId": zod.uuid(),
  "fileKind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).optional(),
  "fileId": zod.uuid().optional(),
  "status": zod.enum(['active', 'expired', 'revoked']).optional(),
  "limit": zod.int().min(1).max(listFileShareLinksQueryLimitMax).default(listFileShareLinksQueryLimitDefault),
  "offset": zod.int().min(listFileShareLinksQueryOffsetMin).default(listFileShareLinksQueryOffsetDefault)
})

export const listFileShareLinksResponseItemsItemOpenCountMin = 0;

export const listFileShareLinksResponseTotalMin = 0;



export const listFileShareLinksResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "versionId": zod.uuid().nullable().describe('Published major version the link opens; null means the original upload (v1.0) of a file without version history, or a link made before version pinning.'),
  "title": zod.string().describe('Download filename captured when the link was made.'),
  "documentTitle": zod.string().describe('Semantic document title captured when the link was made; older links fall back to the filename.'),
  "status": zod.enum(['active', 'expired', 'revoked']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "lastOpenedAt": zod.iso.datetime({"offset":true}).nullable(),
  "openCount": zod.int().min(listFileShareLinksResponseItemsItemOpenCountMin),
  "audience": zod.enum(['signed-in', 'external']).describe('signed-in links re-check the opener\'s permission; external links open without signing in within tenant policy.'),
  "hasPassword": zod.boolean(),
  "createdByMe": zod.boolean()
})),
  "total": zod.int().min(listFileShareLinksResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires share permission on the host. A signed-in link (default) only opens for colleagues who pass the host's permission check. An external link opens without signing in and must satisfy the tenant's outside-sharing policy (enabled, maximum expiry, password requirement); use createProtectedFileShareLink to add a password. Expiry is required (1-90 days). The token is returned once; a requestId replay returns the link without its token.
 * @summary Create a share link to a library file
 */
export const createFileShareLinkBodyExpiresInDaysMax = 90;



export const createFileShareLinkBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "versionId": zod.uuid().nullish(),
  "expiresInDays": zod.int().min(1).max(createFileShareLinkBodyExpiresInDaysMax),
  "audience": zod.enum(['signed-in', 'external']).optional().describe('signed-in links re-check the opener\'s permission; external links open without signing in within tenant policy.'),
  "requestId": zod.uuid()
})

export const createFileShareLinkResponseLinkOpenCountMin = 0;



export const createFileShareLinkResponse = zod.object({
  "link": zod.object({
  "id": zod.uuid(),
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "versionId": zod.uuid().nullable().describe('Published major version the link opens; null means the original upload (v1.0) of a file without version history, or a link made before version pinning.'),
  "title": zod.string().describe('Download filename captured when the link was made.'),
  "documentTitle": zod.string().describe('Semantic document title captured when the link was made; older links fall back to the filename.'),
  "status": zod.enum(['active', 'expired', 'revoked']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "lastOpenedAt": zod.iso.datetime({"offset":true}).nullable(),
  "openCount": zod.int().min(createFileShareLinkResponseLinkOpenCountMin),
  "audience": zod.enum(['signed-in', 'external']).describe('signed-in links re-check the opener\'s permission; external links open without signing in within tenant policy.'),
  "hasPassword": zod.boolean(),
  "createdByMe": zod.boolean()
}),
  "token": zod.string().nullable().describe('Shown once on creation; null when a requestId is replayed.'),
  "replayed": zod.boolean()
})


/**
 * New share links never carry passwords (Solution Studio sharing). Always returns 410 SHARE_PASSWORD_RETIRED. Existing password links stay readable until they expire or are revoked.
 * @deprecated
 * @summary Retired - password-protected share links
 */
export const createProtectedFileShareLinkBodyExpiresInDaysMax = 90;

export const createProtectedFileShareLinkBodyPasswordMin = 8;
export const createProtectedFileShareLinkBodyPasswordMax = 72;



export const createProtectedFileShareLinkBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "versionId": zod.uuid().nullish(),
  "expiresInDays": zod.int().min(1).max(createProtectedFileShareLinkBodyExpiresInDaysMax),
  "password": zod.string().min(createProtectedFileShareLinkBodyPasswordMin).max(createProtectedFileShareLinkBodyPasswordMax),
  "requestId": zod.uuid()
})

export const createProtectedFileShareLinkResponseLinkOpenCountMin = 0;



export const createProtectedFileShareLinkResponse = zod.object({
  "link": zod.object({
  "id": zod.uuid(),
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "versionId": zod.uuid().nullable().describe('Published major version the link opens; null means the original upload (v1.0) of a file without version history, or a link made before version pinning.'),
  "title": zod.string().describe('Download filename captured when the link was made.'),
  "documentTitle": zod.string().describe('Semantic document title captured when the link was made; older links fall back to the filename.'),
  "status": zod.enum(['active', 'expired', 'revoked']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "lastOpenedAt": zod.iso.datetime({"offset":true}).nullable(),
  "openCount": zod.int().min(createProtectedFileShareLinkResponseLinkOpenCountMin),
  "audience": zod.enum(['signed-in', 'external']).describe('signed-in links re-check the opener\'s permission; external links open without signing in within tenant policy.'),
  "hasPassword": zod.boolean(),
  "createdByMe": zod.boolean()
}),
  "token": zod.string().nullable().describe('Shown once on creation; null when a requestId is replayed.'),
  "replayed": zod.boolean()
})


/**
 * Allowed for the link's creator or anyone with share permission on its host. Revoked links return 410 when opened.
 * @summary Withdraw a share link
 */
export const revokeFileShareLinkParams = zod.object({
  "linkId": zod.uuid()
})

export const revokeFileShareLinkBody = zod.object({
  "confirmed": zod.literal(true)
})

export const revokeFileShareLinkResponseOpenCountMin = 0;



export const revokeFileShareLinkResponse = zod.object({
  "id": zod.uuid(),
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "versionId": zod.uuid().nullable().describe('Published major version the link opens; null means the original upload (v1.0) of a file without version history, or a link made before version pinning.'),
  "title": zod.string().describe('Download filename captured when the link was made.'),
  "documentTitle": zod.string().describe('Semantic document title captured when the link was made; older links fall back to the filename.'),
  "status": zod.enum(['active', 'expired', 'revoked']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "lastOpenedAt": zod.iso.datetime({"offset":true}).nullable(),
  "openCount": zod.int().min(revokeFileShareLinkResponseOpenCountMin),
  "audience": zod.enum(['signed-in', 'external']).describe('signed-in links re-check the opener\'s permission; external links open without signing in within tenant policy.'),
  "hasPassword": zod.boolean(),
  "createdByMe": zod.boolean()
})


/**
 * Requires sign-in. The caller must pass the host's current read permission; unknown tokens and denied callers both return 404. Expired or revoked links return 410. Every attempt is audited without the token.
 * @summary Open a share link as the signed-in caller
 */
export const resolveFileShareLinkBodyTokenRegExp = new RegExp('^[A-Za-z0-9_-]{43}$');


export const resolveFileShareLinkBody = zod.object({
  "token": zod.string().regex(resolveFileShareLinkBodyTokenRegExp)
})

export const resolveFileShareLinkResponseSizeBytesMin = 0;



export const resolveFileShareLinkResponse = zod.object({
  "linkId": zod.uuid(),
  "title": zod.string(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(resolveFileShareLinkResponseSizeBytesMin),
  "versionLabel": zod.string().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
})
})


/**
 * Same checks as resolveFileShareLink. Serves the pinned version when the link has one.
 * @summary Download the file behind a share link as the signed-in caller
 */
export const downloadSharedFileBodyTokenRegExp = new RegExp('^[A-Za-z0-9_-]{43}$');


export const downloadSharedFileBody = zod.object({
  "token": zod.string().regex(downloadSharedFileBodyTokenRegExp)
})

export const downloadSharedFileResponse = zod.unknown()


/**
 * Requires entity.records.read. Items stay restorable until their retention ends, then are purged automatically.
 * @summary Page deleted files, folders and documents that can still be restored
 */
export const listRecycleBinQuerySearchMax = 200;

export const listRecycleBinQueryLimitDefault = 25;
export const listRecycleBinQueryLimitMax = 100;

export const listRecycleBinQueryOffsetDefault = 0;
export const listRecycleBinQueryOffsetMin = 0;



export const listRecycleBinQueryParams = zod.object({
  "kind": zod.enum(['file', 'folder', 'document']).optional(),
  "search": zod.string().max(listRecycleBinQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listRecycleBinQueryLimitMax).default(listRecycleBinQueryLimitDefault),
  "offset": zod.int().min(listRecycleBinQueryOffsetMin).default(listRecycleBinQueryOffsetDefault)
})

export const listRecycleBinResponseItemsItemContentsFilesMin = 0;

export const listRecycleBinResponseItemsItemContentsDocumentsMin = 0;

export const listRecycleBinResponseItemsItemContentsFoldersMin = 0;


export const listRecycleBinResponseTotalMin = 0;




export const listRecycleBinResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['file', 'folder', 'document']),
  "targetId": zod.string(),
  "title": zod.string(),
  "originalFolder": zod.string(),
  "contents": zod.object({
  "files": zod.int().min(listRecycleBinResponseItemsItemContentsFilesMin),
  "documents": zod.int().min(listRecycleBinResponseItemsItemContentsDocumentsMin),
  "folders": zod.int().min(listRecycleBinResponseItemsItemContentsFoldersMin)
}),
  "deletedAt": zod.iso.datetime({"offset":true}),
  "deletedByAppUserId": zod.uuid(),
  "deletedByMe": zod.boolean(),
  "retentionDays": zod.int().min(1),
  "purgeAfter": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['restorable', 'expired']),
  "canRestore": zod.boolean(),
  "canPurge": zod.boolean()
})),
  "total": zod.int().min(listRecycleBinResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int(),
  "retentionDays": zod.int().min(1)
})


/**
 * Requires entity.records.write. Nothing is destroyed; each item is restorable until its retention ends. Returns a result per item. Idempotent by requestId.
 * @summary Delete files, folders or documents to the recycle bin
 */
export const moveToRecycleBinBodyItemsItemPathMax = 500;

export const moveToRecycleBinBodyItemsMax = 100;



export const moveToRecycleBinBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "items": zod.array(zod.object({
  "kind": zod.enum(['file', 'folder', 'document']),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}).optional(),
  "id": zod.uuid().optional(),
  "path": zod.string().min(1).max(moveToRecycleBinBodyItemsItemPathMax).optional()
}).describe('One item to delete. Files need `file`, documents need `id`, folders need `path`.')).min(1).max(moveToRecycleBinBodyItemsMax),
  "requestId": zod.uuid()
})

export const moveToRecycleBinResponseDeletedMin = 0;

export const moveToRecycleBinResponseResultsItemItemPathMax = 500;



export const moveToRecycleBinResponse = zod.object({
  "requestId": zod.uuid(),
  "deleted": zod.int().min(moveToRecycleBinResponseDeletedMin),
  "results": zod.array(zod.object({
  "item": zod.object({
  "kind": zod.enum(['file', 'folder', 'document']),
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}).optional(),
  "id": zod.uuid().optional(),
  "path": zod.string().min(1).max(moveToRecycleBinResponseResultsItemItemPathMax).optional()
}).describe('One item to delete. Files need `file`, documents need `id`, folders need `path`.'),
  "ok": zod.boolean(),
  "recycleBinItemId": zod.uuid().nullable(),
  "error": zod.string().nullable()
}))
})


/**
 * Requires entity.records.write. Expired items cannot be restored. Returns a result per item. Idempotent by requestId.
 * @summary Restore deleted items to their original folders
 */
export const restoreRecycleBinItemsBodyIdsMax = 100;



export const restoreRecycleBinItemsBody = zod.object({
  "ids": zod.array(zod.uuid()).min(1).max(restoreRecycleBinItemsBodyIdsMax),
  "requestId": zod.uuid()
})

export const restoreRecycleBinItemsResponseRestoredMin = 0;



export const restoreRecycleBinItemsResponse = zod.object({
  "requestId": zod.uuid(),
  "restored": zod.int().min(restoreRecycleBinItemsResponseRestoredMin),
  "results": zod.array(zod.object({
  "id": zod.uuid(),
  "ok": zod.boolean(),
  "error": zod.string().nullable()
}))
})


/**
 * Requires entity.manage and the item's exact name typed as confirmation. Stored bytes are removed by the clean-up worker after the records are gone. Idempotent by requestId.
 * @summary Permanently delete one recycle bin item
 */
export const purgeRecycleBinItemParams = zod.object({
  "itemId": zod.uuid()
})

export const purgeRecycleBinItemBodyConfirmationMax = 500;



export const purgeRecycleBinItemBody = zod.object({
  "confirmation": zod.string().min(1).max(purgeRecycleBinItemBodyConfirmationMax).describe('The item\'s exact name.'),
  "requestId": zod.uuid()
})

export const purgeRecycleBinItemResponse = zod.object({
  "requestId": zod.uuid(),
  "id": zod.uuid(),
  "purged": zod.boolean()
})


/**
 * Requires entity.records.read. Entities without saved settings keep deleted items for 90 days.
 * @summary Read the library's recycle bin settings
 */
export const getFileManagementSettingsResponseRecycleRetentionDaysMax = 3650;

export const getFileManagementSettingsResponseRevisionMin = 0;



export const getFileManagementSettingsResponse = zod.object({
  "recycleRetentionDays": zod.int().min(1).max(getFileManagementSettingsResponseRecycleRetentionDaysMax),
  "defaultRecycleRetentionDays": zod.int(),
  "revision": zod.int().min(getFileManagementSettingsResponseRevisionMin),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires entity.manage. Applies to items deleted from now on. A stale expectedRevision returns 409. Idempotent by requestId.
 * @summary Change how long deleted items stay restorable
 */
export const updateRecycleRetentionBodyRetentionDaysMax = 3650;

export const updateRecycleRetentionBodyExpectedRevisionMin = 0;



export const updateRecycleRetentionBody = zod.object({
  "retentionDays": zod.int().min(1).max(updateRecycleRetentionBodyRetentionDaysMax),
  "expectedRevision": zod.int().min(updateRecycleRetentionBodyExpectedRevisionMin),
  "requestId": zod.uuid()
})

export const updateRecycleRetentionResponseRecycleRetentionDaysMax = 3650;

export const updateRecycleRetentionResponseRevisionMin = 0;



export const updateRecycleRetentionResponse = zod.object({
  "recycleRetentionDays": zod.int().min(1).max(updateRecycleRetentionResponseRecycleRetentionDaysMax),
  "defaultRecycleRetentionDays": zod.int(),
  "revision": zod.int().min(updateRecycleRetentionResponseRevisionMin),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires entity.records.read. Tenants without saved rules allow outside links for up to 90 days without a required password.
 * @summary Read the tenant's outside-sharing rules
 */
export const getFileSharingPolicyResponseMaxExpiryDaysMax = 90;

export const getFileSharingPolicyResponseRevisionMin = 0;



export const getFileSharingPolicyResponse = zod.object({
  "allowExternalSharing": zod.boolean(),
  "maxExpiryDays": zod.int().min(1).max(getFileSharingPolicyResponseMaxExpiryDaysMax),
  "requirePassword": zod.boolean(),
  "revision": zod.int().min(getFileSharingPolicyResponseRevisionMin),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires tenant.settings.manage. Tightened rules also stop existing outside links that no longer comply. A stale expectedRevision returns 409. Idempotent by requestId.
 * @summary Change the tenant's outside-sharing rules
 */
export const updateFileSharingPolicyBodyMaxExpiryDaysMax = 90;

export const updateFileSharingPolicyBodyExpectedRevisionMin = 0;



export const updateFileSharingPolicyBody = zod.object({
  "allowExternalSharing": zod.boolean(),
  "maxExpiryDays": zod.int().min(1).max(updateFileSharingPolicyBodyMaxExpiryDaysMax),
  "requirePassword": zod.boolean(),
  "expectedRevision": zod.int().min(updateFileSharingPolicyBodyExpectedRevisionMin),
  "requestId": zod.uuid()
})

export const updateFileSharingPolicyResponseMaxExpiryDaysMax = 90;

export const updateFileSharingPolicyResponseRevisionMin = 0;



export const updateFileSharingPolicyResponse = zod.object({
  "allowExternalSharing": zod.boolean(),
  "maxExpiryDays": zod.int().min(1).max(updateFileSharingPolicyResponseMaxExpiryDaysMax),
  "requirePassword": zod.boolean(),
  "revision": zod.int().min(updateFileSharingPolicyResponseRevisionMin),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires entity.records.read. Includes empty folders and folders implied by visible files and documents. `search` is a literal, case-insensitive match on folder names. Returns the breadcrumb trail of `parent`.
 * @summary Page the folders directly inside a library folder
 */
export const listLibraryFoldersQueryParentMax = 500;

export const listLibraryFoldersQuerySearchMax = 120;

export const listLibraryFoldersQueryLimitDefault = 50;
export const listLibraryFoldersQueryLimitMax = 200;

export const listLibraryFoldersQueryOffsetDefault = 0;
export const listLibraryFoldersQueryOffsetMin = 0;



export const listLibraryFoldersQueryParams = zod.object({
  "parent": zod.string().max(listLibraryFoldersQueryParentMax).optional(),
  "search": zod.string().max(listLibraryFoldersQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listLibraryFoldersQueryLimitMax).default(listLibraryFoldersQueryLimitDefault),
  "offset": zod.int().min(listLibraryFoldersQueryOffsetMin).default(listLibraryFoldersQueryOffsetDefault)
})

export const listLibraryFoldersResponseTotalMin = 0;



export const listLibraryFoldersResponse = zod.object({
  "parent": zod.string(),
  "breadcrumbs": zod.array(zod.object({
  "path": zod.string(),
  "name": zod.string()
})).describe('Folders from the library root down to `parent`; empty at the root.'),
  "items": zod.array(zod.object({
  "path": zod.string(),
  "name": zod.string(),
  "parent": zod.string(),
  "explicit": zod.boolean().describe('True for folders created explicitly; false for folders implied by their contents.')
})),
  "total": zod.int().min(listLibraryFoldersResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires entity.records.write on the entity library. Missing parent folders are created too. Idempotent by requestId.
 * @summary Create a library folder
 */
export const createLibraryFolderBodyPathMax = 500;



export const createLibraryFolderBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "path": zod.string().min(1).max(createLibraryFolderBodyPathMax),
  "requestId": zod.uuid()
})

export const createLibraryFolderResponse = zod.object({
  "requestId": zod.uuid(),
  "path": zod.string(),
  "created": zod.boolean()
})


/**
 * Requires entity.records.write on the entity library. Folder ancestry is immutable, so newPath must keep the same parent (400 FOLDER_ANCESTRY_IMMUTABLE). Refused when a sibling of any case already has the name or the folder holds native Word files. Idempotent by requestId.
 * @summary Rename a folder in place with everything inside it
 */
export const renameLibraryFolderBodyPathMax = 500;

export const renameLibraryFolderBodyNewPathMax = 500;



export const renameLibraryFolderBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "path": zod.string().min(1).max(renameLibraryFolderBodyPathMax),
  "newPath": zod.string().min(1).max(renameLibraryFolderBodyNewPathMax),
  "requestId": zod.uuid()
})

export const renameLibraryFolderResponseFilesMin = 0;

export const renameLibraryFolderResponseDocumentsMin = 0;

export const renameLibraryFolderResponseFoldersMin = 0;



export const renameLibraryFolderResponse = zod.object({
  "requestId": zod.uuid(),
  "path": zod.string(),
  "newPath": zod.string(),
  "files": zod.int().min(renameLibraryFolderResponseFilesMin),
  "documents": zod.int().min(renameLibraryFolderResponseDocumentsMin),
  "folders": zod.int().min(renameLibraryFolderResponseFoldersMin)
})


/**
 * Requires read access to each file and entity.records.write on the entity library. Returns a result per file. Idempotent by requestId.
 * @summary Copy library files into an entity library folder as new uploads
 */
export const copyLibraryFilesBodyFilesMax = 100;

export const copyLibraryFilesBodyFolderMax = 500;



export const copyLibraryFilesBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "files": zod.array(zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
})).min(1).max(copyLibraryFilesBodyFilesMax),
  "folder": zod.string().max(copyLibraryFilesBodyFolderMax),
  "requestId": zod.uuid()
})

export const copyLibraryFilesResponseCopiedMin = 0;



export const copyLibraryFilesResponse = zod.object({
  "requestId": zod.uuid(),
  "folder": zod.string(),
  "copied": zod.int().min(copyLibraryFilesResponseCopiedMin),
  "results": zod.array(zod.object({
  "file": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}),
  "ok": zod.boolean(),
  "copy": zod.object({
  "kind": zod.enum(['library-entry', 'file', 'tender-source', 'tender-export']).describe('library-entry is an entity library entry ID; file is a stored file ID; tender-source and tender-export are tender record IDs.'),
  "id": zod.uuid()
}).nullable(),
  "error": zod.string().nullable()
}))
})


/**
 * Requires entity.records.read. Files whose source permission the caller lacks and items in the recycle bin are excluded.
 * @summary Page every stored file and managed document the entity owns
 */
export const listFileInventoryQuerySearchMax = 200;

export const listFileInventoryQueryFolderMax = 500;

export const listFileInventoryQueryLimitDefault = 25;
export const listFileInventoryQueryLimitMax = 100;

export const listFileInventoryQueryOffsetDefault = 0;
export const listFileInventoryQueryOffsetMin = 0;



export const listFileInventoryQueryParams = zod.object({
  "kind": zod.enum(['file', 'document']).optional(),
  "search": zod.string().max(listFileInventoryQuerySearchMax).optional(),
  "folder": zod.string().max(listFileInventoryQueryFolderMax).optional(),
  "limit": zod.int().min(1).max(listFileInventoryQueryLimitMax).default(listFileInventoryQueryLimitDefault),
  "offset": zod.int().min(listFileInventoryQueryOffsetMin).default(listFileInventoryQueryOffsetDefault)
})

export const listFileInventoryResponseItemsItemSizeBytesMin = 0;

export const listFileInventoryResponseTotalMin = 0;



export const listFileInventoryResponse = zod.object({
  "items": zod.array(zod.object({
  "kind": zod.enum(['file', 'document']),
  "id": zod.string(),
  "title": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(listFileInventoryResponseItemsItemSizeBytesMin).nullable(),
  "folder": zod.string(),
  "sourceKind": zod.string(),
  "sourceLabel": zod.string(),
  "status": zod.string(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listFileInventoryResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires entity.manage. Storage keys are never returned.
 * @summary Page stored-file clean-ups queued after failed uploads, deletes and purges
 */
export const listStorageCleanupQueryLimitDefault = 25;
export const listStorageCleanupQueryLimitMax = 100;

export const listStorageCleanupQueryOffsetDefault = 0;
export const listStorageCleanupQueryOffsetMin = 0;



export const listStorageCleanupQueryParams = zod.object({
  "state": zod.enum(['pending', 'deleted', 'retained']).optional(),
  "limit": zod.int().min(1).max(listStorageCleanupQueryLimitMax).default(listStorageCleanupQueryLimitDefault),
  "offset": zod.int().min(listStorageCleanupQueryOffsetMin).default(listStorageCleanupQueryOffsetDefault)
})

export const listStorageCleanupResponseItemsItemAttemptsMin = 0;

export const listStorageCleanupResponseTotalMin = 0;



export const listStorageCleanupResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "reason": zod.enum(['upload_failed', 'delete_failed', 'purge']),
  "state": zod.enum(['pending', 'deleted', 'retained']),
  "attempts": zod.int().min(listStorageCleanupResponseItemsItemAttemptsMin),
  "lastErrorCode": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "retryAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int().min(listStorageCleanupResponseTotalMin),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Requires entity.manage. Deletes queued stored bytes that no record references; referenced bytes are kept.
 * @summary Run one bounded storage clean-up pass now
 */
export const runStorageCleanupBody = zod.object({
  "confirmed": zod.literal(true)
})

export const runStorageCleanupResponseDeletedMin = 0;

export const runStorageCleanupResponseRetainedMin = 0;

export const runStorageCleanupResponseFailedMin = 0;



export const runStorageCleanupResponse = zod.object({
  "deleted": zod.int().min(runStorageCleanupResponseDeletedMin),
  "retained": zod.int().min(runStorageCleanupResponseRetainedMin),
  "failed": zod.int().min(runStorageCleanupResponseFailedMin)
})


/**
 * No sign-in. Rate limited per address. Unknown, expired, revoked and policy-blocked links all return the same 404. A password-protected link reveals only that a password is needed.
 * @summary Read an outside share link before downloading
 */
export const getPublicFileSharePathTokenRegExp = new RegExp('^[A-Za-z0-9_-]{43}$');


export const getPublicFileShareParams = zod.object({
  "token": zod.string().regex(getPublicFileSharePathTokenRegExp)
})

export const getPublicFileShareResponseSizeBytesMin = 0;



export const getPublicFileShareResponse = zod.object({
  "requiresPassword": zod.boolean(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "title": zod.string().nullable(),
  "filename": zod.string().nullable(),
  "contentType": zod.string().nullable(),
  "sizeBytes": zod.int().min(getPublicFileShareResponseSizeBytesMin).nullable()
})


/**
 * No sign-in. Checks the password when one is set (failed attempts are rate limited), counts the open and records it without the token or password.
 * @summary Download the file behind an outside share link
 */
export const downloadPublicFileSharePathTokenRegExp = new RegExp('^[A-Za-z0-9_-]{43}$');


export const downloadPublicFileShareParams = zod.object({
  "token": zod.string().regex(downloadPublicFileSharePathTokenRegExp)
})

export const downloadPublicFileShareBodyPasswordMax = 200;



export const downloadPublicFileShareBody = zod.object({
  "password": zod.string().max(downloadPublicFileShareBodyPasswordMax).optional()
})

export const downloadPublicFileShareResponse = zod.unknown()


/**
 * Requires entity.records.write and project image generation. Nothing enters the library until the draft is saved. Idempotent by requestId.
 * @summary Generate a private image draft for review before saving it to a host library
 */
export const createLibraryImageDraftBodyPromptMin = 3;
export const createLibraryImageDraftBodyPromptMax = 2000;

export const createLibraryImageDraftBodyFolderMax = 500;



export const createLibraryImageDraftBody = zod.object({
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "prompt": zod.string().min(createLibraryImageDraftBodyPromptMin).max(createLibraryImageDraftBodyPromptMax),
  "folder": zod.string().max(createLibraryImageDraftBodyFolderMax).optional(),
  "requestId": zod.uuid()
})

export const createLibraryImageDraftResponseSizeBytesMin = 0;



export const createLibraryImageDraftResponse = zod.object({
  "id": zod.uuid(),
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "status": zod.enum(['ready', 'saved', 'discarded']),
  "prompt": zod.string(),
  "folder": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(createLibraryImageDraftResponseSizeBytesMin),
  "savedLibraryEntryId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Read one of the caller's image drafts
 */
export const getLibraryImageDraftParams = zod.object({
  "draftId": zod.uuid()
})

export const getLibraryImageDraftResponseSizeBytesMin = 0;



export const getLibraryImageDraftResponse = zod.object({
  "id": zod.uuid(),
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "status": zod.enum(['ready', 'saved', 'discarded']),
  "prompt": zod.string(),
  "folder": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(getLibraryImageDraftResponseSizeBytesMin),
  "savedLibraryEntryId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Discard one of the caller's unsaved image drafts
 */
export const discardLibraryImageDraftParams = zod.object({
  "draftId": zod.uuid()
})

export const discardLibraryImageDraftResponseSizeBytesMin = 0;



export const discardLibraryImageDraftResponse = zod.object({
  "id": zod.uuid(),
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "status": zod.enum(['ready', 'saved', 'discarded']),
  "prompt": zod.string(),
  "folder": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(discardLibraryImageDraftResponseSizeBytesMin),
  "savedLibraryEntryId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Read the image bytes of one of the caller's drafts
 */
export const downloadLibraryImageDraftParams = zod.object({
  "draftId": zod.uuid()
})

export const downloadLibraryImageDraftResponse = zod.unknown()


/**
 * Requires entity.records.write. Creates an uploaded library file in the draft's folder. Idempotent by requestId.
 * @summary Save a reviewed image draft into the library
 */
export const saveLibraryImageDraftParams = zod.object({
  "draftId": zod.uuid()
})

export const saveLibraryImageDraftBodyFilenameMax = 200;



export const saveLibraryImageDraftBody = zod.object({
  "filename": zod.string().min(1).max(saveLibraryImageDraftBodyFilenameMax),
  "requestId": zod.uuid()
})

export const saveLibraryImageDraftResponseSizeBytesMin = 0;



export const saveLibraryImageDraftResponse = zod.object({
  "id": zod.uuid(),
  "host": zod.object({
  "kind": zod.enum(['entity-files', 'workspace', 'account', 'tender', 'proposal', 'campaign']).describe('Owning record whose permissions govern a library file. The tenant library is browse-only and is not accepted here.'),
  "id": zod.uuid()
}),
  "status": zod.enum(['ready', 'saved', 'discarded']),
  "prompt": zod.string(),
  "folder": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(saveLibraryImageDraftResponseSizeBytesMin),
  "savedLibraryEntryId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Create an editable managed copy of a permitted source file
 */
export const createManagedDocumentCopyParams = zod.object({
  "id": zod.uuid()
})

export const createManagedDocumentCopyHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const createManagedDocumentCopyHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(createManagedDocumentCopyHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const createManagedDocumentCopyResponseSowOneFactsProjectTitleMax = 200;

export const createManagedDocumentCopyResponseSowOneFactsCustomerNameMax = 300;

export const createManagedDocumentCopyResponseSowOneFactsAgreementIdMax = 100;

export const createManagedDocumentCopyResponseSowOneFactsPreparedDateMax = 40;

export const createManagedDocumentCopyResponseSowOneFactsStartDateMax = 40;

export const createManagedDocumentCopyResponseSowOneFactsSprintWeeksMax = 52;

export const createManagedDocumentCopyResponseSowOneFactsNarrativeItemTextMax = 20000;

export const createManagedDocumentCopyResponseSowOneFactsNarrativeMax = 5;

export const createManagedDocumentCopyResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const createManagedDocumentCopyResponseSowOneFactsTablesItemRowsItemMax = 7;

export const createManagedDocumentCopyResponseSowOneFactsTablesItemRowsMax = 100;

export const createManagedDocumentCopyResponseSowOneFactsTablesMax = 6;

export const createManagedDocumentCopyResponseSowOneFactsInvestmentItemIdMax = 80;

export const createManagedDocumentCopyResponseSowOneFactsInvestmentItemTitleMax = 300;

export const createManagedDocumentCopyResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const createManagedDocumentCopyResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsInvestmentMax = 100;

export const createManagedDocumentCopyResponseSowOneFactsMaterialsItemIdMax = 80;

export const createManagedDocumentCopyResponseSowOneFactsMaterialsItemTitleMax = 300;

export const createManagedDocumentCopyResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const createManagedDocumentCopyResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsMaterialsMax = 100;

export const createManagedDocumentCopyResponseSowOneFactsInvoicesItemIdMax = 80;

export const createManagedDocumentCopyResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const createManagedDocumentCopyResponseSowOneFactsInvoicesItemDateMax = 40;

export const createManagedDocumentCopyResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const createManagedDocumentCopyResponseSowOneFactsInvoicesMax = 100;

export const createManagedDocumentCopyResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const createManagedDocumentCopyResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const createManagedDocumentCopyResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentCopyResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const createManagedDocumentCopyResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const createManagedDocumentCopyResponseSowOneFactsUnresolvedFactsMax = 200;

export const createManagedDocumentCopyResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const createManagedDocumentCopyResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const createManagedDocumentCopyResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const createManagedDocumentCopyResponseSowOneFactsCustomFieldsMax = 600;

export const createManagedDocumentCopyResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const createManagedDocumentCopyResponseSowOneFactsCustomProseItemTextMax = 20000;

export const createManagedDocumentCopyResponseSowOneFactsCustomProseMax = 40;

export const createManagedDocumentCopyResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const createManagedDocumentCopyResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const createManagedDocumentCopyResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const createManagedDocumentCopyResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const createManagedDocumentCopyResponseSowOneFactsCustomTablesMax = 40;

export const createManagedDocumentCopyResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const createManagedDocumentCopyResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentCopyResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const createManagedDocumentCopyResponseSowApprovalPolicyOneRevisionsMax = 3;

export const createManagedDocumentCopyResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const createManagedDocumentCopyResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const createManagedDocumentCopyResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const createManagedDocumentCopyResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const createManagedDocumentCopyResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const createManagedDocumentCopyResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const createManagedDocumentCopyResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const createManagedDocumentCopyResponseDraftContentLayoutHeaderMax = 100;

export const createManagedDocumentCopyResponseDraftContentLayoutFooterItemTypeMax = 40;

export const createManagedDocumentCopyResponseDraftContentLayoutFooterItemTextMax = 200000;

export const createManagedDocumentCopyResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const createManagedDocumentCopyResponseDraftContentLayoutFooterItemMarksMax = 20;

export const createManagedDocumentCopyResponseDraftContentLayoutFooterItemContentMax = 10000;

export const createManagedDocumentCopyResponseDraftContentLayoutFooterMax = 100;

export const createManagedDocumentCopyResponseDraftContentSectionsItemsItemTitleMax = 160;

export const createManagedDocumentCopyResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const createManagedDocumentCopyResponseDraftContentSectionsItemsMax = 200;

export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsMin = 7;
export const createManagedDocumentCopyResponseDraftContentStylesDefinitionsMax = 100;

export const createManagedDocumentCopyResponseDraftContentTemplateGuidanceMax = 4000;

export const createManagedDocumentCopyResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createManagedDocumentCopyResponseDraftContentTemplateSectionGuidanceMax = 200;

export const createManagedDocumentCopyResponseDraftContentContentItemTypeMax = 40;

export const createManagedDocumentCopyResponseDraftContentContentItemTextMax = 200000;

export const createManagedDocumentCopyResponseDraftContentContentItemMarksItemTypeMax = 40;

export const createManagedDocumentCopyResponseDraftContentContentItemMarksMax = 20;

export const createManagedDocumentCopyResponseDraftContentContentItemContentMax = 10000;

export const createManagedDocumentCopyResponseDraftContentContentMax = 10000;

export const createManagedDocumentCopyResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentCopyResponseVersionsItemMajorVersionMin = 0;

export const createManagedDocumentCopyResponseVersionsItemMinorVersionMin = 0;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderMax = 100;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const createManagedDocumentCopyResponseVersionsItemContentLayoutFooterMax = 100;

export const createManagedDocumentCopyResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const createManagedDocumentCopyResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const createManagedDocumentCopyResponseVersionsItemContentSectionsItemsMax = 200;

export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsMin = 7;
export const createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsMax = 100;

export const createManagedDocumentCopyResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const createManagedDocumentCopyResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createManagedDocumentCopyResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const createManagedDocumentCopyResponseVersionsItemContentContentItemTypeMax = 40;

export const createManagedDocumentCopyResponseVersionsItemContentContentItemTextMax = 200000;

export const createManagedDocumentCopyResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const createManagedDocumentCopyResponseVersionsItemContentContentItemMarksMax = 20;

export const createManagedDocumentCopyResponseVersionsItemContentContentItemContentMax = 10000;

export const createManagedDocumentCopyResponseVersionsItemContentContentMax = 10000;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const createManagedDocumentCopyResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(createManagedDocumentCopyResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(createManagedDocumentCopyResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(createManagedDocumentCopyResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(createManagedDocumentCopyResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(createManagedDocumentCopyResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(createManagedDocumentCopyResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(createManagedDocumentCopyResponseSowOneFactsNarrativeItemTextMax)
})).max(createManagedDocumentCopyResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(createManagedDocumentCopyResponseSowOneFactsTablesItemRowsItemItemMax)).max(createManagedDocumentCopyResponseSowOneFactsTablesItemRowsItemMax)).max(createManagedDocumentCopyResponseSowOneFactsTablesItemRowsMax)
})).max(createManagedDocumentCopyResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(createManagedDocumentCopyResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(createManagedDocumentCopyResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(createManagedDocumentCopyResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(createManagedDocumentCopyResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(createManagedDocumentCopyResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(createManagedDocumentCopyResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(createManagedDocumentCopyResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(createManagedDocumentCopyResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(createManagedDocumentCopyResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(createManagedDocumentCopyResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(createManagedDocumentCopyResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(createManagedDocumentCopyResponseSowOneFactsInvoicesItemNotesMax)
})).max(createManagedDocumentCopyResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialReviewReasonMin).max(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(createManagedDocumentCopyResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(createManagedDocumentCopyResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(createManagedDocumentCopyResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(createManagedDocumentCopyResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(createManagedDocumentCopyResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(createManagedDocumentCopyResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(createManagedDocumentCopyResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(createManagedDocumentCopyResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(createManagedDocumentCopyResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(createManagedDocumentCopyResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(createManagedDocumentCopyResponseSowOneFactsCustomProseItemTextMax)
})).max(createManagedDocumentCopyResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(createManagedDocumentCopyResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(createManagedDocumentCopyResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(createManagedDocumentCopyResponseSowOneFactsCustomTablesItemRowsItemMax)).max(createManagedDocumentCopyResponseSowOneFactsCustomTablesItemRowsMax)
})).max(createManagedDocumentCopyResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(createManagedDocumentCopyResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(createManagedDocumentCopyResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(createManagedDocumentCopyResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(createManagedDocumentCopyResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(createManagedDocumentCopyResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(createManagedDocumentCopyResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsTopMin).max(createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsRightMin).max(createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(createManagedDocumentCopyResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(createManagedDocumentCopyResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentCopyResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentCopyResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(createManagedDocumentCopyResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(createManagedDocumentCopyResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentCopyResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentCopyResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(createManagedDocumentCopyResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createManagedDocumentCopyResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createManagedDocumentCopyResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createManagedDocumentCopyResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemFontSizeMin).max(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createManagedDocumentCopyResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(createManagedDocumentCopyResponseDraftContentStylesDefinitionsMin).max(createManagedDocumentCopyResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createManagedDocumentCopyResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createManagedDocumentCopyResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(createManagedDocumentCopyResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(createManagedDocumentCopyResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentCopyResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentCopyResponseDraftContentContentItemContentMax).optional()
})).max(createManagedDocumentCopyResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(createManagedDocumentCopyResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(createManagedDocumentCopyResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(createManagedDocumentCopyResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(createManagedDocumentCopyResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(createManagedDocumentCopyResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentCopyResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(createManagedDocumentCopyResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createManagedDocumentCopyResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createManagedDocumentCopyResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createManagedDocumentCopyResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsMin).max(createManagedDocumentCopyResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createManagedDocumentCopyResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createManagedDocumentCopyResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(createManagedDocumentCopyResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(createManagedDocumentCopyResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentCopyResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentCopyResponseVersionsItemContentContentItemContentMax).optional()
})).max(createManagedDocumentCopyResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(createManagedDocumentCopyResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Create a managed document at version 0.1
 */
export const createManagedDocumentHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const createManagedDocumentHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(createManagedDocumentHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})


export const createManagedDocumentBodyTemplateDraftSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const createManagedDocumentBodyTemplateSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentBodyTitleMax = 200;

export const createManagedDocumentBodyCategoryDefault = `general`;
export const createManagedDocumentBodyCategoryMax = 80;

export const createManagedDocumentBodyFolderDefault = ``;
export const createManagedDocumentBodyFolderMax = 500;

export const createManagedDocumentBodyLabelsItemMax = 80;

export const createManagedDocumentBodyLabelsMax = 20;

export const createManagedDocumentBodyContentLayoutPageSettingsMarginsTopMin = 5;
export const createManagedDocumentBodyContentLayoutPageSettingsMarginsTopMax = 50;

export const createManagedDocumentBodyContentLayoutPageSettingsMarginsRightMin = 5;
export const createManagedDocumentBodyContentLayoutPageSettingsMarginsRightMax = 50;

export const createManagedDocumentBodyContentLayoutPageSettingsMarginsBottomMin = 5;
export const createManagedDocumentBodyContentLayoutPageSettingsMarginsBottomMax = 50;

export const createManagedDocumentBodyContentLayoutPageSettingsMarginsLeftMin = 5;
export const createManagedDocumentBodyContentLayoutPageSettingsMarginsLeftMax = 50;

export const createManagedDocumentBodyContentLayoutHeaderItemTypeMax = 40;

export const createManagedDocumentBodyContentLayoutHeaderItemTextMax = 200000;

export const createManagedDocumentBodyContentLayoutHeaderItemMarksItemTypeMax = 40;

export const createManagedDocumentBodyContentLayoutHeaderItemMarksMax = 20;

export const createManagedDocumentBodyContentLayoutHeaderItemContentMax = 10000;

export const createManagedDocumentBodyContentLayoutHeaderMax = 100;

export const createManagedDocumentBodyContentLayoutFooterItemTypeMax = 40;

export const createManagedDocumentBodyContentLayoutFooterItemTextMax = 200000;

export const createManagedDocumentBodyContentLayoutFooterItemMarksItemTypeMax = 40;

export const createManagedDocumentBodyContentLayoutFooterItemMarksMax = 20;

export const createManagedDocumentBodyContentLayoutFooterItemContentMax = 10000;

export const createManagedDocumentBodyContentLayoutFooterMax = 100;

export const createManagedDocumentBodyContentSectionsItemsItemTitleMax = 160;

export const createManagedDocumentBodyContentSectionsItemsItemAuthoringNotesMax = 4000;


export const createManagedDocumentBodyContentSectionsItemsMax = 200;

export const createManagedDocumentBodyContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createManagedDocumentBodyContentStylesDefinitionsItemNameMax = 80;

export const createManagedDocumentBodyContentStylesDefinitionsItemFontSizeMin = 6;
export const createManagedDocumentBodyContentStylesDefinitionsItemFontSizeMax = 96;

export const createManagedDocumentBodyContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createManagedDocumentBodyContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const createManagedDocumentBodyContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const createManagedDocumentBodyContentStylesDefinitionsItemSpaceAfterMin = 0;
export const createManagedDocumentBodyContentStylesDefinitionsItemSpaceAfterMax = 144;

export const createManagedDocumentBodyContentStylesDefinitionsItemLineHeightMax = 3;

export const createManagedDocumentBodyContentStylesDefinitionsMin = 7;
export const createManagedDocumentBodyContentStylesDefinitionsMax = 100;

export const createManagedDocumentBodyContentTemplateGuidanceMax = 4000;

export const createManagedDocumentBodyContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createManagedDocumentBodyContentTemplateSectionGuidanceMax = 200;

export const createManagedDocumentBodyContentContentItemTypeMax = 40;

export const createManagedDocumentBodyContentContentItemTextMax = 200000;

export const createManagedDocumentBodyContentContentItemMarksItemTypeMax = 40;

export const createManagedDocumentBodyContentContentItemMarksMax = 20;

export const createManagedDocumentBodyContentContentItemContentMax = 10000;

export const createManagedDocumentBodyContentContentMax = 10000;

export const createManagedDocumentBodySowFactsProjectTitleMax = 200;

export const createManagedDocumentBodySowFactsCustomerNameMax = 300;

export const createManagedDocumentBodySowFactsAgreementIdMax = 100;

export const createManagedDocumentBodySowFactsPreparedDateMax = 40;

export const createManagedDocumentBodySowFactsStartDateMax = 40;

export const createManagedDocumentBodySowFactsSprintWeeksMax = 52;

export const createManagedDocumentBodySowFactsNarrativeItemTextMax = 20000;

export const createManagedDocumentBodySowFactsNarrativeMax = 5;

export const createManagedDocumentBodySowFactsTablesItemRowsItemItemMax = 4000;

export const createManagedDocumentBodySowFactsTablesItemRowsItemMax = 7;

export const createManagedDocumentBodySowFactsTablesItemRowsMax = 100;

export const createManagedDocumentBodySowFactsTablesMax = 6;

export const createManagedDocumentBodySowFactsInvestmentItemIdMax = 80;

export const createManagedDocumentBodySowFactsInvestmentItemTitleMax = 300;

export const createManagedDocumentBodySowFactsInvestmentItemDescriptionMax = 4000;

export const createManagedDocumentBodySowFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsInvestmentMax = 100;

export const createManagedDocumentBodySowFactsMaterialsItemIdMax = 80;

export const createManagedDocumentBodySowFactsMaterialsItemTitleMax = 300;

export const createManagedDocumentBodySowFactsMaterialsItemDescriptionMax = 4000;

export const createManagedDocumentBodySowFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsMaterialsMax = 100;

export const createManagedDocumentBodySowFactsInvoicesItemIdMax = 80;

export const createManagedDocumentBodySowFactsInvoicesItemMilestonesMax = 500;

export const createManagedDocumentBodySowFactsInvoicesItemDateMax = 40;

export const createManagedDocumentBodySowFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsInvoicesItemNotesMax = 2000;

export const createManagedDocumentBodySowFactsInvoicesMax = 100;

export const createManagedDocumentBodySowFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const createManagedDocumentBodySowFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentBodySowFactsQuoteCommercialReferenceMax = 300;

export const createManagedDocumentBodySowFactsQuoteCommercialSourceStatusMax = 100;

export const createManagedDocumentBodySowFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const createManagedDocumentBodySowFactsQuoteCommercialTermsMax = 20000;

export const createManagedDocumentBodySowFactsQuoteCommercialAssumptionsMax = 20000;

export const createManagedDocumentBodySowFactsQuoteCommercialExclusionsMax = 20000;

export const createManagedDocumentBodySowFactsQuoteCommercialReviewReasonMin = 10;
export const createManagedDocumentBodySowFactsQuoteCommercialReviewReasonMax = 2000;

export const createManagedDocumentBodySowFactsQuoteCommercialLinesItemTitleMax = 300;

export const createManagedDocumentBodySowFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const createManagedDocumentBodySowFactsQuoteCommercialLinesMax = 100;

export const createManagedDocumentBodySowFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentBodySowFactsUnresolvedFactsItemFieldMax = 100;

export const createManagedDocumentBodySowFactsUnresolvedFactsItemMessageMax = 2000;

export const createManagedDocumentBodySowFactsUnresolvedFactsMax = 200;

export const createManagedDocumentBodySowFactsCustomFieldsItemSectionIdMax = 48;

export const createManagedDocumentBodySowFactsCustomFieldsItemFieldIdMax = 48;

export const createManagedDocumentBodySowFactsCustomFieldsItemValueMax = 4000;

export const createManagedDocumentBodySowFactsCustomFieldsMax = 600;

export const createManagedDocumentBodySowFactsCustomProseItemSectionIdMax = 48;

export const createManagedDocumentBodySowFactsCustomProseItemTextMax = 20000;

export const createManagedDocumentBodySowFactsCustomProseMax = 40;

export const createManagedDocumentBodySowFactsCustomTablesItemSectionIdMax = 48;

export const createManagedDocumentBodySowFactsCustomTablesItemRowsItemItemMax = 4000;

export const createManagedDocumentBodySowFactsCustomTablesItemRowsItemMax = 8;

export const createManagedDocumentBodySowFactsCustomTablesItemRowsMax = 100;

export const createManagedDocumentBodySowFactsCustomTablesMax = 40;



export const createManagedDocumentBody = zod.object({
  "templateDraftSource": zod.object({
  "documentId": zod.uuid(),
  "revision": zod.int().min(1),
  "contentHash": zod.string().regex(createManagedDocumentBodyTemplateDraftSourceContentHashRegExp)
}).optional(),
  "templateSource": zod.object({
  "documentId": zod.uuid(),
  "revision": zod.int().min(1),
  "contentHash": zod.string().regex(createManagedDocumentBodyTemplateSourceContentHashRegExp)
}).optional(),
  "clientRequestId": zod.uuid().optional(),
  "title": zod.string().min(1).max(createManagedDocumentBodyTitleMax),
  "category": zod.string().min(1).max(createManagedDocumentBodyCategoryMax).default(createManagedDocumentBodyCategoryDefault),
  "folder": zod.string().max(createManagedDocumentBodyFolderMax).default(createManagedDocumentBodyFolderDefault),
  "labels": zod.array(zod.string().min(1).max(createManagedDocumentBodyLabelsItemMax)).max(createManagedDocumentBodyLabelsMax).optional(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createManagedDocumentBodyContentLayoutPageSettingsMarginsTopMin).max(createManagedDocumentBodyContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createManagedDocumentBodyContentLayoutPageSettingsMarginsRightMin).max(createManagedDocumentBodyContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createManagedDocumentBodyContentLayoutPageSettingsMarginsBottomMin).max(createManagedDocumentBodyContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createManagedDocumentBodyContentLayoutPageSettingsMarginsLeftMin).max(createManagedDocumentBodyContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentBodyContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(createManagedDocumentBodyContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentBodyContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentBodyContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentBodyContentLayoutHeaderItemContentMax).optional()
})).max(createManagedDocumentBodyContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentBodyContentLayoutFooterItemTypeMax),
  "text": zod.string().max(createManagedDocumentBodyContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentBodyContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentBodyContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentBodyContentLayoutFooterItemContentMax).optional()
})).max(createManagedDocumentBodyContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createManagedDocumentBodyContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createManagedDocumentBodyContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createManagedDocumentBodyContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createManagedDocumentBodyContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createManagedDocumentBodyContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createManagedDocumentBodyContentStylesDefinitionsItemFontSizeMin).max(createManagedDocumentBodyContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createManagedDocumentBodyContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createManagedDocumentBodyContentStylesDefinitionsItemSpaceBeforeMin).max(createManagedDocumentBodyContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createManagedDocumentBodyContentStylesDefinitionsItemSpaceAfterMin).max(createManagedDocumentBodyContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createManagedDocumentBodyContentStylesDefinitionsItemLineHeightMax)
})).min(createManagedDocumentBodyContentStylesDefinitionsMin).max(createManagedDocumentBodyContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createManagedDocumentBodyContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createManagedDocumentBodyContentTemplateSectionGuidanceItemGuidanceMax)
})).max(createManagedDocumentBodyContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentBodyContentContentItemTypeMax),
  "text": zod.string().max(createManagedDocumentBodyContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentBodyContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentBodyContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentBodyContentContentItemContentMax).optional()
})).max(createManagedDocumentBodyContentContentMax)
}).optional(),
  "sow": zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(createManagedDocumentBodySowFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(createManagedDocumentBodySowFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(createManagedDocumentBodySowFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(createManagedDocumentBodySowFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(createManagedDocumentBodySowFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(createManagedDocumentBodySowFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(createManagedDocumentBodySowFactsNarrativeItemTextMax)
})).max(createManagedDocumentBodySowFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(createManagedDocumentBodySowFactsTablesItemRowsItemItemMax)).max(createManagedDocumentBodySowFactsTablesItemRowsItemMax)).max(createManagedDocumentBodySowFactsTablesItemRowsMax)
})).max(createManagedDocumentBodySowFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(createManagedDocumentBodySowFactsInvestmentItemIdMax),
  "title": zod.string().max(createManagedDocumentBodySowFactsInvestmentItemTitleMax),
  "description": zod.string().max(createManagedDocumentBodySowFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(createManagedDocumentBodySowFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(createManagedDocumentBodySowFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(createManagedDocumentBodySowFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(createManagedDocumentBodySowFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(createManagedDocumentBodySowFactsMaterialsItemIdMax),
  "title": zod.string().max(createManagedDocumentBodySowFactsMaterialsItemTitleMax),
  "description": zod.string().max(createManagedDocumentBodySowFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(createManagedDocumentBodySowFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(createManagedDocumentBodySowFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(createManagedDocumentBodySowFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(createManagedDocumentBodySowFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(createManagedDocumentBodySowFactsInvoicesItemIdMax),
  "milestones": zod.string().max(createManagedDocumentBodySowFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(createManagedDocumentBodySowFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(createManagedDocumentBodySowFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(createManagedDocumentBodySowFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(createManagedDocumentBodySowFactsInvoicesItemNotesMax)
})).max(createManagedDocumentBodySowFactsInvoicesMax),
  "milestoneDays": zod.string().regex(createManagedDocumentBodySowFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(createManagedDocumentBodySowFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(createManagedDocumentBodySowFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(createManagedDocumentBodySowFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(createManagedDocumentBodySowFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(createManagedDocumentBodySowFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(createManagedDocumentBodySowFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(createManagedDocumentBodySowFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(createManagedDocumentBodySowFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(createManagedDocumentBodySowFactsQuoteCommercialReviewReasonMin).max(createManagedDocumentBodySowFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(createManagedDocumentBodySowFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(createManagedDocumentBodySowFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(createManagedDocumentBodySowFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(createManagedDocumentBodySowFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(createManagedDocumentBodySowFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(createManagedDocumentBodySowFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(createManagedDocumentBodySowFactsUnresolvedFactsItemMessageMax)
})).max(createManagedDocumentBodySowFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(createManagedDocumentBodySowFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(createManagedDocumentBodySowFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(createManagedDocumentBodySowFactsCustomFieldsItemValueMax).nullable()
})).max(createManagedDocumentBodySowFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(createManagedDocumentBodySowFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(createManagedDocumentBodySowFactsCustomProseItemTextMax)
})).max(createManagedDocumentBodySowFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(createManagedDocumentBodySowFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(createManagedDocumentBodySowFactsCustomTablesItemRowsItemItemMax)).max(createManagedDocumentBodySowFactsCustomTablesItemRowsItemMax)).max(createManagedDocumentBodySowFactsCustomTablesItemRowsMax)
})).max(createManagedDocumentBodySowFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}).optional()
})

export const createManagedDocumentResponseSowOneFactsProjectTitleMax = 200;

export const createManagedDocumentResponseSowOneFactsCustomerNameMax = 300;

export const createManagedDocumentResponseSowOneFactsAgreementIdMax = 100;

export const createManagedDocumentResponseSowOneFactsPreparedDateMax = 40;

export const createManagedDocumentResponseSowOneFactsStartDateMax = 40;

export const createManagedDocumentResponseSowOneFactsSprintWeeksMax = 52;

export const createManagedDocumentResponseSowOneFactsNarrativeItemTextMax = 20000;

export const createManagedDocumentResponseSowOneFactsNarrativeMax = 5;

export const createManagedDocumentResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const createManagedDocumentResponseSowOneFactsTablesItemRowsItemMax = 7;

export const createManagedDocumentResponseSowOneFactsTablesItemRowsMax = 100;

export const createManagedDocumentResponseSowOneFactsTablesMax = 6;

export const createManagedDocumentResponseSowOneFactsInvestmentItemIdMax = 80;

export const createManagedDocumentResponseSowOneFactsInvestmentItemTitleMax = 300;

export const createManagedDocumentResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const createManagedDocumentResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsInvestmentMax = 100;

export const createManagedDocumentResponseSowOneFactsMaterialsItemIdMax = 80;

export const createManagedDocumentResponseSowOneFactsMaterialsItemTitleMax = 300;

export const createManagedDocumentResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const createManagedDocumentResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsMaterialsMax = 100;

export const createManagedDocumentResponseSowOneFactsInvoicesItemIdMax = 80;

export const createManagedDocumentResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const createManagedDocumentResponseSowOneFactsInvoicesItemDateMax = 40;

export const createManagedDocumentResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const createManagedDocumentResponseSowOneFactsInvoicesMax = 100;

export const createManagedDocumentResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const createManagedDocumentResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const createManagedDocumentResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const createManagedDocumentResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const createManagedDocumentResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const createManagedDocumentResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const createManagedDocumentResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const createManagedDocumentResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const createManagedDocumentResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const createManagedDocumentResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const createManagedDocumentResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const createManagedDocumentResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const createManagedDocumentResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const createManagedDocumentResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const createManagedDocumentResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const createManagedDocumentResponseSowOneFactsUnresolvedFactsMax = 200;

export const createManagedDocumentResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const createManagedDocumentResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const createManagedDocumentResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const createManagedDocumentResponseSowOneFactsCustomFieldsMax = 600;

export const createManagedDocumentResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const createManagedDocumentResponseSowOneFactsCustomProseItemTextMax = 20000;

export const createManagedDocumentResponseSowOneFactsCustomProseMax = 40;

export const createManagedDocumentResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const createManagedDocumentResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const createManagedDocumentResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const createManagedDocumentResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const createManagedDocumentResponseSowOneFactsCustomTablesMax = 40;

export const createManagedDocumentResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const createManagedDocumentResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const createManagedDocumentResponseSowApprovalPolicyOneRevisionsMax = 3;

export const createManagedDocumentResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const createManagedDocumentResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const createManagedDocumentResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const createManagedDocumentResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const createManagedDocumentResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const createManagedDocumentResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const createManagedDocumentResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const createManagedDocumentResponseDraftContentLayoutHeaderMax = 100;

export const createManagedDocumentResponseDraftContentLayoutFooterItemTypeMax = 40;

export const createManagedDocumentResponseDraftContentLayoutFooterItemTextMax = 200000;

export const createManagedDocumentResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const createManagedDocumentResponseDraftContentLayoutFooterItemMarksMax = 20;

export const createManagedDocumentResponseDraftContentLayoutFooterItemContentMax = 10000;

export const createManagedDocumentResponseDraftContentLayoutFooterMax = 100;

export const createManagedDocumentResponseDraftContentSectionsItemsItemTitleMax = 160;

export const createManagedDocumentResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const createManagedDocumentResponseDraftContentSectionsItemsMax = 200;

export const createManagedDocumentResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createManagedDocumentResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const createManagedDocumentResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const createManagedDocumentResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const createManagedDocumentResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const createManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const createManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const createManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const createManagedDocumentResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const createManagedDocumentResponseDraftContentStylesDefinitionsMin = 7;
export const createManagedDocumentResponseDraftContentStylesDefinitionsMax = 100;

export const createManagedDocumentResponseDraftContentTemplateGuidanceMax = 4000;

export const createManagedDocumentResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createManagedDocumentResponseDraftContentTemplateSectionGuidanceMax = 200;

export const createManagedDocumentResponseDraftContentContentItemTypeMax = 40;

export const createManagedDocumentResponseDraftContentContentItemTextMax = 200000;

export const createManagedDocumentResponseDraftContentContentItemMarksItemTypeMax = 40;

export const createManagedDocumentResponseDraftContentContentItemMarksMax = 20;

export const createManagedDocumentResponseDraftContentContentItemContentMax = 10000;

export const createManagedDocumentResponseDraftContentContentMax = 10000;

export const createManagedDocumentResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentResponseVersionsItemMajorVersionMin = 0;

export const createManagedDocumentResponseVersionsItemMinorVersionMin = 0;

export const createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const createManagedDocumentResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const createManagedDocumentResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const createManagedDocumentResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const createManagedDocumentResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const createManagedDocumentResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const createManagedDocumentResponseVersionsItemContentLayoutHeaderMax = 100;

export const createManagedDocumentResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const createManagedDocumentResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const createManagedDocumentResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const createManagedDocumentResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const createManagedDocumentResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const createManagedDocumentResponseVersionsItemContentLayoutFooterMax = 100;

export const createManagedDocumentResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const createManagedDocumentResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const createManagedDocumentResponseVersionsItemContentSectionsItemsMax = 200;

export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsMin = 7;
export const createManagedDocumentResponseVersionsItemContentStylesDefinitionsMax = 100;

export const createManagedDocumentResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const createManagedDocumentResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createManagedDocumentResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const createManagedDocumentResponseVersionsItemContentContentItemTypeMax = 40;

export const createManagedDocumentResponseVersionsItemContentContentItemTextMax = 200000;

export const createManagedDocumentResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const createManagedDocumentResponseVersionsItemContentContentItemMarksMax = 20;

export const createManagedDocumentResponseVersionsItemContentContentItemContentMax = 10000;

export const createManagedDocumentResponseVersionsItemContentContentMax = 10000;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const createManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const createManagedDocumentResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const createManagedDocumentResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(createManagedDocumentResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(createManagedDocumentResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(createManagedDocumentResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(createManagedDocumentResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(createManagedDocumentResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(createManagedDocumentResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(createManagedDocumentResponseSowOneFactsNarrativeItemTextMax)
})).max(createManagedDocumentResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(createManagedDocumentResponseSowOneFactsTablesItemRowsItemItemMax)).max(createManagedDocumentResponseSowOneFactsTablesItemRowsItemMax)).max(createManagedDocumentResponseSowOneFactsTablesItemRowsMax)
})).max(createManagedDocumentResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(createManagedDocumentResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(createManagedDocumentResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(createManagedDocumentResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(createManagedDocumentResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(createManagedDocumentResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(createManagedDocumentResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(createManagedDocumentResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(createManagedDocumentResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(createManagedDocumentResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(createManagedDocumentResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(createManagedDocumentResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(createManagedDocumentResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(createManagedDocumentResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(createManagedDocumentResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(createManagedDocumentResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(createManagedDocumentResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(createManagedDocumentResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(createManagedDocumentResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(createManagedDocumentResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(createManagedDocumentResponseSowOneFactsInvoicesItemNotesMax)
})).max(createManagedDocumentResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(createManagedDocumentResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(createManagedDocumentResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(createManagedDocumentResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(createManagedDocumentResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(createManagedDocumentResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(createManagedDocumentResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(createManagedDocumentResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(createManagedDocumentResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(createManagedDocumentResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(createManagedDocumentResponseSowOneFactsQuoteCommercialReviewReasonMin).max(createManagedDocumentResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(createManagedDocumentResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(createManagedDocumentResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(createManagedDocumentResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(createManagedDocumentResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(createManagedDocumentResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(createManagedDocumentResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(createManagedDocumentResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(createManagedDocumentResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(createManagedDocumentResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(createManagedDocumentResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(createManagedDocumentResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(createManagedDocumentResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(createManagedDocumentResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(createManagedDocumentResponseSowOneFactsCustomProseItemTextMax)
})).max(createManagedDocumentResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(createManagedDocumentResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(createManagedDocumentResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(createManagedDocumentResponseSowOneFactsCustomTablesItemRowsItemMax)).max(createManagedDocumentResponseSowOneFactsCustomTablesItemRowsMax)
})).max(createManagedDocumentResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(createManagedDocumentResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(createManagedDocumentResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(createManagedDocumentResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(createManagedDocumentResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(createManagedDocumentResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(createManagedDocumentResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsTopMin).max(createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsRightMin).max(createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(createManagedDocumentResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(createManagedDocumentResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(createManagedDocumentResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(createManagedDocumentResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(createManagedDocumentResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createManagedDocumentResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createManagedDocumentResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createManagedDocumentResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createManagedDocumentResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createManagedDocumentResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createManagedDocumentResponseDraftContentStylesDefinitionsItemFontSizeMin).max(createManagedDocumentResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createManagedDocumentResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(createManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(createManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createManagedDocumentResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(createManagedDocumentResponseDraftContentStylesDefinitionsMin).max(createManagedDocumentResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createManagedDocumentResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createManagedDocumentResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(createManagedDocumentResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(createManagedDocumentResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentResponseDraftContentContentItemContentMax).optional()
})).max(createManagedDocumentResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(createManagedDocumentResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(createManagedDocumentResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(createManagedDocumentResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(createManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(createManagedDocumentResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(createManagedDocumentResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(createManagedDocumentResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(createManagedDocumentResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createManagedDocumentResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createManagedDocumentResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createManagedDocumentResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createManagedDocumentResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(createManagedDocumentResponseVersionsItemContentStylesDefinitionsMin).max(createManagedDocumentResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createManagedDocumentResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createManagedDocumentResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(createManagedDocumentResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(createManagedDocumentResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentResponseVersionsItemContentContentItemContentMax).optional()
})).max(createManagedDocumentResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(createManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(createManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createManagedDocumentResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createManagedDocumentResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(createManagedDocumentResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(createManagedDocumentResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Read the original actor-owned creation outcome
 */
export const getManagedDocumentCreationOutcomeParams = zod.object({
  "requestId": zod.uuid()
})

export const getManagedDocumentCreationOutcomeResponseSowOneFactsProjectTitleMax = 200;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomerNameMax = 300;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsAgreementIdMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsPreparedDateMax = 40;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsStartDateMax = 40;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsSprintWeeksMax = 52;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsNarrativeItemTextMax = 20000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsNarrativeMax = 5;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsTablesItemRowsItemMax = 7;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsTablesItemRowsMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsTablesMax = 6;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemIdMax = 80;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemTitleMax = 300;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemIdMax = 80;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemTitleMax = 300;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemIdMax = 80;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemDateMax = 40;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCreationOutcomeResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsUnresolvedFactsMax = 200;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomFieldsMax = 600;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomProseItemTextMax = 20000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomProseMax = 40;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesMax = 40;

export const getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneRevisionsMax = 3;

export const getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderMax = 100;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemTextMax = 200000;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemMarksMax = 20;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterMax = 100;

export const getManagedDocumentCreationOutcomeResponseDraftContentSectionsItemsItemTitleMax = 160;

export const getManagedDocumentCreationOutcomeResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentCreationOutcomeResponseDraftContentSectionsItemsMax = 200;

export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsMin = 7;
export const getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsMax = 100;

export const getManagedDocumentCreationOutcomeResponseDraftContentTemplateGuidanceMax = 4000;

export const getManagedDocumentCreationOutcomeResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentCreationOutcomeResponseDraftContentTemplateSectionGuidanceMax = 200;

export const getManagedDocumentCreationOutcomeResponseDraftContentContentItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseDraftContentContentItemTextMax = 200000;

export const getManagedDocumentCreationOutcomeResponseDraftContentContentItemMarksItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseDraftContentContentItemMarksMax = 20;

export const getManagedDocumentCreationOutcomeResponseDraftContentContentItemContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseDraftContentContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentCreationOutcomeResponseVersionsItemMajorVersionMin = 0;

export const getManagedDocumentCreationOutcomeResponseVersionsItemMinorVersionMin = 0;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderMax = 100;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterMax = 100;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentCreationOutcomeResponseVersionsItemContentSectionsItemsMax = 200;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsMin = 7;
export const getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsMax = 100;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemTextMax = 200000;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemMarksMax = 20;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseVersionsItemContentContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const getManagedDocumentCreationOutcomeResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(getManagedDocumentCreationOutcomeResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsNarrativeItemTextMax)
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsTablesItemRowsItemItemMax)).max(getManagedDocumentCreationOutcomeResponseSowOneFactsTablesItemRowsItemMax)).max(getManagedDocumentCreationOutcomeResponseSowOneFactsTablesItemRowsMax)
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesItemNotesMax)
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialReviewReasonMin).max(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomProseItemTextMax)
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesItemRowsItemMax)).max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesItemRowsMax)
})).max(getManagedDocumentCreationOutcomeResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getManagedDocumentCreationOutcomeResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsTopMin).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsRightMin).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentCreationOutcomeResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentCreationOutcomeResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemFontSizeMin).max(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsMin).max(getManagedDocumentCreationOutcomeResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentCreationOutcomeResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentCreationOutcomeResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentCreationOutcomeResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCreationOutcomeResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCreationOutcomeResponseDraftContentContentItemContentMax).optional()
})).max(getManagedDocumentCreationOutcomeResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(getManagedDocumentCreationOutcomeResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(getManagedDocumentCreationOutcomeResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(getManagedDocumentCreationOutcomeResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentCreationOutcomeResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsMin).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentCreationOutcomeResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentCreationOutcomeResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentContentItemContentMax).optional()
})).max(getManagedDocumentCreationOutcomeResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(getManagedDocumentCreationOutcomeResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Convert DOCX or UTF-8 Markdown for review without adopting it
 */
export const previewManagedDocumentImportBody = zod.object({
  "file": zod.instanceof(Blob)
})

export const previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsTopMin = 5;
export const previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsTopMax = 50;

export const previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsRightMin = 5;
export const previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsRightMax = 50;

export const previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsBottomMin = 5;
export const previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsBottomMax = 50;

export const previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsLeftMin = 5;
export const previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsLeftMax = 50;

export const previewManagedDocumentImportResponseContentLayoutHeaderItemTypeMax = 40;

export const previewManagedDocumentImportResponseContentLayoutHeaderItemTextMax = 200000;

export const previewManagedDocumentImportResponseContentLayoutHeaderItemMarksItemTypeMax = 40;

export const previewManagedDocumentImportResponseContentLayoutHeaderItemMarksMax = 20;

export const previewManagedDocumentImportResponseContentLayoutHeaderItemContentMax = 10000;

export const previewManagedDocumentImportResponseContentLayoutHeaderMax = 100;

export const previewManagedDocumentImportResponseContentLayoutFooterItemTypeMax = 40;

export const previewManagedDocumentImportResponseContentLayoutFooterItemTextMax = 200000;

export const previewManagedDocumentImportResponseContentLayoutFooterItemMarksItemTypeMax = 40;

export const previewManagedDocumentImportResponseContentLayoutFooterItemMarksMax = 20;

export const previewManagedDocumentImportResponseContentLayoutFooterItemContentMax = 10000;

export const previewManagedDocumentImportResponseContentLayoutFooterMax = 100;

export const previewManagedDocumentImportResponseContentSectionsItemsItemTitleMax = 160;

export const previewManagedDocumentImportResponseContentSectionsItemsItemAuthoringNotesMax = 4000;


export const previewManagedDocumentImportResponseContentSectionsItemsMax = 200;

export const previewManagedDocumentImportResponseContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const previewManagedDocumentImportResponseContentStylesDefinitionsItemNameMax = 80;

export const previewManagedDocumentImportResponseContentStylesDefinitionsItemFontSizeMin = 6;
export const previewManagedDocumentImportResponseContentStylesDefinitionsItemFontSizeMax = 96;

export const previewManagedDocumentImportResponseContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewManagedDocumentImportResponseContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const previewManagedDocumentImportResponseContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const previewManagedDocumentImportResponseContentStylesDefinitionsItemSpaceAfterMin = 0;
export const previewManagedDocumentImportResponseContentStylesDefinitionsItemSpaceAfterMax = 144;

export const previewManagedDocumentImportResponseContentStylesDefinitionsItemLineHeightMax = 3;

export const previewManagedDocumentImportResponseContentStylesDefinitionsMin = 7;
export const previewManagedDocumentImportResponseContentStylesDefinitionsMax = 100;

export const previewManagedDocumentImportResponseContentTemplateGuidanceMax = 4000;

export const previewManagedDocumentImportResponseContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const previewManagedDocumentImportResponseContentTemplateSectionGuidanceMax = 200;

export const previewManagedDocumentImportResponseContentContentItemTypeMax = 40;

export const previewManagedDocumentImportResponseContentContentItemTextMax = 200000;

export const previewManagedDocumentImportResponseContentContentItemMarksItemTypeMax = 40;

export const previewManagedDocumentImportResponseContentContentItemMarksMax = 20;

export const previewManagedDocumentImportResponseContentContentItemContentMax = 10000;

export const previewManagedDocumentImportResponseContentContentMax = 10000;



export const previewManagedDocumentImportResponse = zod.object({
  "filename": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsTopMin).max(previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsRightMin).max(previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsBottomMin).max(previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsLeftMin).max(previewManagedDocumentImportResponseContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentImportResponseContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(previewManagedDocumentImportResponseContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentImportResponseContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewManagedDocumentImportResponseContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewManagedDocumentImportResponseContentLayoutHeaderItemContentMax).optional()
})).max(previewManagedDocumentImportResponseContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentImportResponseContentLayoutFooterItemTypeMax),
  "text": zod.string().max(previewManagedDocumentImportResponseContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentImportResponseContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewManagedDocumentImportResponseContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewManagedDocumentImportResponseContentLayoutFooterItemContentMax).optional()
})).max(previewManagedDocumentImportResponseContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(previewManagedDocumentImportResponseContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(previewManagedDocumentImportResponseContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(previewManagedDocumentImportResponseContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(previewManagedDocumentImportResponseContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(previewManagedDocumentImportResponseContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(previewManagedDocumentImportResponseContentStylesDefinitionsItemFontSizeMin).max(previewManagedDocumentImportResponseContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(previewManagedDocumentImportResponseContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(previewManagedDocumentImportResponseContentStylesDefinitionsItemSpaceBeforeMin).max(previewManagedDocumentImportResponseContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(previewManagedDocumentImportResponseContentStylesDefinitionsItemSpaceAfterMin).max(previewManagedDocumentImportResponseContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(previewManagedDocumentImportResponseContentStylesDefinitionsItemLineHeightMax)
})).min(previewManagedDocumentImportResponseContentStylesDefinitionsMin).max(previewManagedDocumentImportResponseContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(previewManagedDocumentImportResponseContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(previewManagedDocumentImportResponseContentTemplateSectionGuidanceItemGuidanceMax)
})).max(previewManagedDocumentImportResponseContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentImportResponseContentContentItemTypeMax),
  "text": zod.string().max(previewManagedDocumentImportResponseContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentImportResponseContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewManagedDocumentImportResponseContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewManagedDocumentImportResponseContentContentItemContentMax).optional()
})).max(previewManagedDocumentImportResponseContentContentMax)
}),
  "warnings": zod.array(zod.string()),
  "supported": zod.boolean(),
  "originalPreservedOnAdoption": zod.literal(true)
})


/**
 * @summary Preserve a DOCX or Markdown original and adopt a reviewed conversion
 */
export const adoptManagedDocumentImportHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const adoptManagedDocumentImportHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(adoptManagedDocumentImportHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const adoptManagedDocumentImportBodyTitleMax = 200;

export const adoptManagedDocumentImportBodyCategoryMax = 80;

export const adoptManagedDocumentImportBodyFolderMax = 500;



export const adoptManagedDocumentImportBody = zod.object({
  "file": zod.instanceof(Blob),
  "title": zod.string().min(1).max(adoptManagedDocumentImportBodyTitleMax).optional(),
  "category": zod.string().min(1).max(adoptManagedDocumentImportBodyCategoryMax).optional(),
  "folder": zod.string().max(adoptManagedDocumentImportBodyFolderMax).optional()
})

export const adoptManagedDocumentImportResponseSowOneFactsProjectTitleMax = 200;

export const adoptManagedDocumentImportResponseSowOneFactsCustomerNameMax = 300;

export const adoptManagedDocumentImportResponseSowOneFactsAgreementIdMax = 100;

export const adoptManagedDocumentImportResponseSowOneFactsPreparedDateMax = 40;

export const adoptManagedDocumentImportResponseSowOneFactsStartDateMax = 40;

export const adoptManagedDocumentImportResponseSowOneFactsSprintWeeksMax = 52;

export const adoptManagedDocumentImportResponseSowOneFactsNarrativeItemTextMax = 20000;

export const adoptManagedDocumentImportResponseSowOneFactsNarrativeMax = 5;

export const adoptManagedDocumentImportResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const adoptManagedDocumentImportResponseSowOneFactsTablesItemRowsItemMax = 7;

export const adoptManagedDocumentImportResponseSowOneFactsTablesItemRowsMax = 100;

export const adoptManagedDocumentImportResponseSowOneFactsTablesMax = 6;

export const adoptManagedDocumentImportResponseSowOneFactsInvestmentItemIdMax = 80;

export const adoptManagedDocumentImportResponseSowOneFactsInvestmentItemTitleMax = 300;

export const adoptManagedDocumentImportResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const adoptManagedDocumentImportResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsInvestmentMax = 100;

export const adoptManagedDocumentImportResponseSowOneFactsMaterialsItemIdMax = 80;

export const adoptManagedDocumentImportResponseSowOneFactsMaterialsItemTitleMax = 300;

export const adoptManagedDocumentImportResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const adoptManagedDocumentImportResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsMaterialsMax = 100;

export const adoptManagedDocumentImportResponseSowOneFactsInvoicesItemIdMax = 80;

export const adoptManagedDocumentImportResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const adoptManagedDocumentImportResponseSowOneFactsInvoicesItemDateMax = 40;

export const adoptManagedDocumentImportResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const adoptManagedDocumentImportResponseSowOneFactsInvoicesMax = 100;

export const adoptManagedDocumentImportResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const adoptManagedDocumentImportResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const adoptManagedDocumentImportResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const adoptManagedDocumentImportResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const adoptManagedDocumentImportResponseSowOneFactsUnresolvedFactsMax = 200;

export const adoptManagedDocumentImportResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const adoptManagedDocumentImportResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const adoptManagedDocumentImportResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const adoptManagedDocumentImportResponseSowOneFactsCustomFieldsMax = 600;

export const adoptManagedDocumentImportResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const adoptManagedDocumentImportResponseSowOneFactsCustomProseItemTextMax = 20000;

export const adoptManagedDocumentImportResponseSowOneFactsCustomProseMax = 40;

export const adoptManagedDocumentImportResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const adoptManagedDocumentImportResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const adoptManagedDocumentImportResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const adoptManagedDocumentImportResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const adoptManagedDocumentImportResponseSowOneFactsCustomTablesMax = 40;

export const adoptManagedDocumentImportResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const adoptManagedDocumentImportResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const adoptManagedDocumentImportResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const adoptManagedDocumentImportResponseSowApprovalPolicyOneRevisionsMax = 3;

export const adoptManagedDocumentImportResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const adoptManagedDocumentImportResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const adoptManagedDocumentImportResponseDraftContentLayoutHeaderMax = 100;

export const adoptManagedDocumentImportResponseDraftContentLayoutFooterItemTypeMax = 40;

export const adoptManagedDocumentImportResponseDraftContentLayoutFooterItemTextMax = 200000;

export const adoptManagedDocumentImportResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const adoptManagedDocumentImportResponseDraftContentLayoutFooterItemMarksMax = 20;

export const adoptManagedDocumentImportResponseDraftContentLayoutFooterItemContentMax = 10000;

export const adoptManagedDocumentImportResponseDraftContentLayoutFooterMax = 100;

export const adoptManagedDocumentImportResponseDraftContentSectionsItemsItemTitleMax = 160;

export const adoptManagedDocumentImportResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const adoptManagedDocumentImportResponseDraftContentSectionsItemsMax = 200;

export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsMin = 7;
export const adoptManagedDocumentImportResponseDraftContentStylesDefinitionsMax = 100;

export const adoptManagedDocumentImportResponseDraftContentTemplateGuidanceMax = 4000;

export const adoptManagedDocumentImportResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const adoptManagedDocumentImportResponseDraftContentTemplateSectionGuidanceMax = 200;

export const adoptManagedDocumentImportResponseDraftContentContentItemTypeMax = 40;

export const adoptManagedDocumentImportResponseDraftContentContentItemTextMax = 200000;

export const adoptManagedDocumentImportResponseDraftContentContentItemMarksItemTypeMax = 40;

export const adoptManagedDocumentImportResponseDraftContentContentItemMarksMax = 20;

export const adoptManagedDocumentImportResponseDraftContentContentItemContentMax = 10000;

export const adoptManagedDocumentImportResponseDraftContentContentMax = 10000;

export const adoptManagedDocumentImportResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const adoptManagedDocumentImportResponseVersionsItemMajorVersionMin = 0;

export const adoptManagedDocumentImportResponseVersionsItemMinorVersionMin = 0;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderMax = 100;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterMax = 100;

export const adoptManagedDocumentImportResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const adoptManagedDocumentImportResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const adoptManagedDocumentImportResponseVersionsItemContentSectionsItemsMax = 200;

export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsMin = 7;
export const adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsMax = 100;

export const adoptManagedDocumentImportResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const adoptManagedDocumentImportResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const adoptManagedDocumentImportResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const adoptManagedDocumentImportResponseVersionsItemContentContentItemTypeMax = 40;

export const adoptManagedDocumentImportResponseVersionsItemContentContentItemTextMax = 200000;

export const adoptManagedDocumentImportResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const adoptManagedDocumentImportResponseVersionsItemContentContentItemMarksMax = 20;

export const adoptManagedDocumentImportResponseVersionsItemContentContentItemContentMax = 10000;

export const adoptManagedDocumentImportResponseVersionsItemContentContentMax = 10000;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const adoptManagedDocumentImportResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(adoptManagedDocumentImportResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsNarrativeItemTextMax)
})).max(adoptManagedDocumentImportResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(adoptManagedDocumentImportResponseSowOneFactsTablesItemRowsItemItemMax)).max(adoptManagedDocumentImportResponseSowOneFactsTablesItemRowsItemMax)).max(adoptManagedDocumentImportResponseSowOneFactsTablesItemRowsMax)
})).max(adoptManagedDocumentImportResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(adoptManagedDocumentImportResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(adoptManagedDocumentImportResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(adoptManagedDocumentImportResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(adoptManagedDocumentImportResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(adoptManagedDocumentImportResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsInvoicesItemNotesMax)
})).max(adoptManagedDocumentImportResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialReviewReasonMin).max(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(adoptManagedDocumentImportResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(adoptManagedDocumentImportResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(adoptManagedDocumentImportResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(adoptManagedDocumentImportResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsCustomProseItemTextMax)
})).max(adoptManagedDocumentImportResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(adoptManagedDocumentImportResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(adoptManagedDocumentImportResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(adoptManagedDocumentImportResponseSowOneFactsCustomTablesItemRowsItemMax)).max(adoptManagedDocumentImportResponseSowOneFactsCustomTablesItemRowsMax)
})).max(adoptManagedDocumentImportResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(adoptManagedDocumentImportResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(adoptManagedDocumentImportResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(adoptManagedDocumentImportResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(adoptManagedDocumentImportResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(adoptManagedDocumentImportResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(adoptManagedDocumentImportResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsTopMin).max(adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsRightMin).max(adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(adoptManagedDocumentImportResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(adoptManagedDocumentImportResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(adoptManagedDocumentImportResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(adoptManagedDocumentImportResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(adoptManagedDocumentImportResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(adoptManagedDocumentImportResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(adoptManagedDocumentImportResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(adoptManagedDocumentImportResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(adoptManagedDocumentImportResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemFontSizeMin).max(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsMin).max(adoptManagedDocumentImportResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(adoptManagedDocumentImportResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(adoptManagedDocumentImportResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(adoptManagedDocumentImportResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(adoptManagedDocumentImportResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(adoptManagedDocumentImportResponseDraftContentContentItemContentMax).optional()
})).max(adoptManagedDocumentImportResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(adoptManagedDocumentImportResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(adoptManagedDocumentImportResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(adoptManagedDocumentImportResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(adoptManagedDocumentImportResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(adoptManagedDocumentImportResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(adoptManagedDocumentImportResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(adoptManagedDocumentImportResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsMin).max(adoptManagedDocumentImportResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(adoptManagedDocumentImportResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(adoptManagedDocumentImportResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(adoptManagedDocumentImportResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(adoptManagedDocumentImportResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(adoptManagedDocumentImportResponseVersionsItemContentContentItemContentMax).optional()
})).max(adoptManagedDocumentImportResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(adoptManagedDocumentImportResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get the private authoring workspace and exact draft revision
 */
export const getManagedDocumentParams = zod.object({
  "id": zod.uuid()
})

export const getManagedDocumentResponseSowOneFactsProjectTitleMax = 200;

export const getManagedDocumentResponseSowOneFactsCustomerNameMax = 300;

export const getManagedDocumentResponseSowOneFactsAgreementIdMax = 100;

export const getManagedDocumentResponseSowOneFactsPreparedDateMax = 40;

export const getManagedDocumentResponseSowOneFactsStartDateMax = 40;

export const getManagedDocumentResponseSowOneFactsSprintWeeksMax = 52;

export const getManagedDocumentResponseSowOneFactsNarrativeItemTextMax = 20000;

export const getManagedDocumentResponseSowOneFactsNarrativeMax = 5;

export const getManagedDocumentResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const getManagedDocumentResponseSowOneFactsTablesItemRowsItemMax = 7;

export const getManagedDocumentResponseSowOneFactsTablesItemRowsMax = 100;

export const getManagedDocumentResponseSowOneFactsTablesMax = 6;

export const getManagedDocumentResponseSowOneFactsInvestmentItemIdMax = 80;

export const getManagedDocumentResponseSowOneFactsInvestmentItemTitleMax = 300;

export const getManagedDocumentResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const getManagedDocumentResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsInvestmentMax = 100;

export const getManagedDocumentResponseSowOneFactsMaterialsItemIdMax = 80;

export const getManagedDocumentResponseSowOneFactsMaterialsItemTitleMax = 300;

export const getManagedDocumentResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const getManagedDocumentResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsMaterialsMax = 100;

export const getManagedDocumentResponseSowOneFactsInvoicesItemIdMax = 80;

export const getManagedDocumentResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const getManagedDocumentResponseSowOneFactsInvoicesItemDateMax = 40;

export const getManagedDocumentResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const getManagedDocumentResponseSowOneFactsInvoicesMax = 100;

export const getManagedDocumentResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const getManagedDocumentResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const getManagedDocumentResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const getManagedDocumentResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getManagedDocumentResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const getManagedDocumentResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const getManagedDocumentResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const getManagedDocumentResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const getManagedDocumentResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const getManagedDocumentResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const getManagedDocumentResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const getManagedDocumentResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const getManagedDocumentResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const getManagedDocumentResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const getManagedDocumentResponseSowOneFactsUnresolvedFactsMax = 200;

export const getManagedDocumentResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const getManagedDocumentResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const getManagedDocumentResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const getManagedDocumentResponseSowOneFactsCustomFieldsMax = 600;

export const getManagedDocumentResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const getManagedDocumentResponseSowOneFactsCustomProseItemTextMax = 20000;

export const getManagedDocumentResponseSowOneFactsCustomProseMax = 40;

export const getManagedDocumentResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const getManagedDocumentResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const getManagedDocumentResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const getManagedDocumentResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const getManagedDocumentResponseSowOneFactsCustomTablesMax = 40;

export const getManagedDocumentResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const getManagedDocumentResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const getManagedDocumentResponseSowApprovalPolicyOneRevisionsMax = 3;

export const getManagedDocumentResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const getManagedDocumentResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentResponseDraftContentLayoutHeaderMax = 100;

export const getManagedDocumentResponseDraftContentLayoutFooterItemTypeMax = 40;

export const getManagedDocumentResponseDraftContentLayoutFooterItemTextMax = 200000;

export const getManagedDocumentResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentResponseDraftContentLayoutFooterItemMarksMax = 20;

export const getManagedDocumentResponseDraftContentLayoutFooterItemContentMax = 10000;

export const getManagedDocumentResponseDraftContentLayoutFooterMax = 100;

export const getManagedDocumentResponseDraftContentSectionsItemsItemTitleMax = 160;

export const getManagedDocumentResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentResponseDraftContentSectionsItemsMax = 200;

export const getManagedDocumentResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentResponseDraftContentStylesDefinitionsMin = 7;
export const getManagedDocumentResponseDraftContentStylesDefinitionsMax = 100;

export const getManagedDocumentResponseDraftContentTemplateGuidanceMax = 4000;

export const getManagedDocumentResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentResponseDraftContentTemplateSectionGuidanceMax = 200;

export const getManagedDocumentResponseDraftContentContentItemTypeMax = 40;

export const getManagedDocumentResponseDraftContentContentItemTextMax = 200000;

export const getManagedDocumentResponseDraftContentContentItemMarksItemTypeMax = 40;

export const getManagedDocumentResponseDraftContentContentItemMarksMax = 20;

export const getManagedDocumentResponseDraftContentContentItemContentMax = 10000;

export const getManagedDocumentResponseDraftContentContentMax = 10000;

export const getManagedDocumentResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentResponseVersionsItemMajorVersionMin = 0;

export const getManagedDocumentResponseVersionsItemMinorVersionMin = 0;

export const getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentResponseVersionsItemContentLayoutHeaderMax = 100;

export const getManagedDocumentResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const getManagedDocumentResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const getManagedDocumentResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const getManagedDocumentResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const getManagedDocumentResponseVersionsItemContentLayoutFooterMax = 100;

export const getManagedDocumentResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const getManagedDocumentResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentResponseVersionsItemContentSectionsItemsMax = 200;

export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsMin = 7;
export const getManagedDocumentResponseVersionsItemContentStylesDefinitionsMax = 100;

export const getManagedDocumentResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const getManagedDocumentResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const getManagedDocumentResponseVersionsItemContentContentItemTypeMax = 40;

export const getManagedDocumentResponseVersionsItemContentContentItemTextMax = 200000;

export const getManagedDocumentResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const getManagedDocumentResponseVersionsItemContentContentItemMarksMax = 20;

export const getManagedDocumentResponseVersionsItemContentContentItemContentMax = 10000;

export const getManagedDocumentResponseVersionsItemContentContentMax = 10000;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const getManagedDocumentResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const getManagedDocumentResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(getManagedDocumentResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(getManagedDocumentResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(getManagedDocumentResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(getManagedDocumentResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(getManagedDocumentResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(getManagedDocumentResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(getManagedDocumentResponseSowOneFactsNarrativeItemTextMax)
})).max(getManagedDocumentResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(getManagedDocumentResponseSowOneFactsTablesItemRowsItemItemMax)).max(getManagedDocumentResponseSowOneFactsTablesItemRowsItemMax)).max(getManagedDocumentResponseSowOneFactsTablesItemRowsMax)
})).max(getManagedDocumentResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(getManagedDocumentResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(getManagedDocumentResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getManagedDocumentResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getManagedDocumentResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getManagedDocumentResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(getManagedDocumentResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(getManagedDocumentResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(getManagedDocumentResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getManagedDocumentResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getManagedDocumentResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getManagedDocumentResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(getManagedDocumentResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(getManagedDocumentResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(getManagedDocumentResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(getManagedDocumentResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(getManagedDocumentResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(getManagedDocumentResponseSowOneFactsInvoicesItemNotesMax)
})).max(getManagedDocumentResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(getManagedDocumentResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(getManagedDocumentResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(getManagedDocumentResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(getManagedDocumentResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(getManagedDocumentResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(getManagedDocumentResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(getManagedDocumentResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(getManagedDocumentResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(getManagedDocumentResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(getManagedDocumentResponseSowOneFactsQuoteCommercialReviewReasonMin).max(getManagedDocumentResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(getManagedDocumentResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(getManagedDocumentResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(getManagedDocumentResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(getManagedDocumentResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(getManagedDocumentResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(getManagedDocumentResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(getManagedDocumentResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(getManagedDocumentResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(getManagedDocumentResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(getManagedDocumentResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(getManagedDocumentResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(getManagedDocumentResponseSowOneFactsCustomProseItemTextMax)
})).max(getManagedDocumentResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(getManagedDocumentResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(getManagedDocumentResponseSowOneFactsCustomTablesItemRowsItemMax)).max(getManagedDocumentResponseSowOneFactsCustomTablesItemRowsMax)
})).max(getManagedDocumentResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(getManagedDocumentResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(getManagedDocumentResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getManagedDocumentResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(getManagedDocumentResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getManagedDocumentResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getManagedDocumentResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsTopMin).max(getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsRightMin).max(getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentResponseDraftContentStylesDefinitionsItemFontSizeMin).max(getManagedDocumentResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentResponseDraftContentStylesDefinitionsMin).max(getManagedDocumentResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentResponseDraftContentContentItemContentMax).optional()
})).max(getManagedDocumentResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(getManagedDocumentResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(getManagedDocumentResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(getManagedDocumentResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentResponseVersionsItemContentStylesDefinitionsMin).max(getManagedDocumentResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentResponseVersionsItemContentContentItemContentMax).optional()
})).max(getManagedDocumentResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(getManagedDocumentResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(getManagedDocumentResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Autosave a working draft using optimistic concurrency
 */
export const saveManagedDocumentDraftParams = zod.object({
  "id": zod.uuid()
})


export const saveManagedDocumentDraftBodyTitleMax = 200;

export const saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsTopMin = 5;
export const saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsTopMax = 50;

export const saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsRightMin = 5;
export const saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsRightMax = 50;

export const saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsBottomMin = 5;
export const saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsBottomMax = 50;

export const saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsLeftMin = 5;
export const saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsLeftMax = 50;

export const saveManagedDocumentDraftBodyContentLayoutHeaderItemTypeMax = 40;

export const saveManagedDocumentDraftBodyContentLayoutHeaderItemTextMax = 200000;

export const saveManagedDocumentDraftBodyContentLayoutHeaderItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftBodyContentLayoutHeaderItemMarksMax = 20;

export const saveManagedDocumentDraftBodyContentLayoutHeaderItemContentMax = 10000;

export const saveManagedDocumentDraftBodyContentLayoutHeaderMax = 100;

export const saveManagedDocumentDraftBodyContentLayoutFooterItemTypeMax = 40;

export const saveManagedDocumentDraftBodyContentLayoutFooterItemTextMax = 200000;

export const saveManagedDocumentDraftBodyContentLayoutFooterItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftBodyContentLayoutFooterItemMarksMax = 20;

export const saveManagedDocumentDraftBodyContentLayoutFooterItemContentMax = 10000;

export const saveManagedDocumentDraftBodyContentLayoutFooterMax = 100;

export const saveManagedDocumentDraftBodyContentSectionsItemsItemTitleMax = 160;

export const saveManagedDocumentDraftBodyContentSectionsItemsItemAuthoringNotesMax = 4000;


export const saveManagedDocumentDraftBodyContentSectionsItemsMax = 200;

export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemNameMax = 80;

export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemFontSizeMin = 6;
export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemFontSizeMax = 96;

export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemSpaceAfterMin = 0;
export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemSpaceAfterMax = 144;

export const saveManagedDocumentDraftBodyContentStylesDefinitionsItemLineHeightMax = 3;

export const saveManagedDocumentDraftBodyContentStylesDefinitionsMin = 7;
export const saveManagedDocumentDraftBodyContentStylesDefinitionsMax = 100;

export const saveManagedDocumentDraftBodyContentTemplateGuidanceMax = 4000;

export const saveManagedDocumentDraftBodyContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const saveManagedDocumentDraftBodyContentTemplateSectionGuidanceMax = 200;

export const saveManagedDocumentDraftBodyContentContentItemTypeMax = 40;

export const saveManagedDocumentDraftBodyContentContentItemTextMax = 200000;

export const saveManagedDocumentDraftBodyContentContentItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftBodyContentContentItemMarksMax = 20;

export const saveManagedDocumentDraftBodyContentContentItemContentMax = 10000;

export const saveManagedDocumentDraftBodyContentContentMax = 10000;

export const saveManagedDocumentDraftBodySowFactsProjectTitleMax = 200;

export const saveManagedDocumentDraftBodySowFactsCustomerNameMax = 300;

export const saveManagedDocumentDraftBodySowFactsAgreementIdMax = 100;

export const saveManagedDocumentDraftBodySowFactsPreparedDateMax = 40;

export const saveManagedDocumentDraftBodySowFactsStartDateMax = 40;

export const saveManagedDocumentDraftBodySowFactsSprintWeeksMax = 52;

export const saveManagedDocumentDraftBodySowFactsNarrativeItemTextMax = 20000;

export const saveManagedDocumentDraftBodySowFactsNarrativeMax = 5;

export const saveManagedDocumentDraftBodySowFactsTablesItemRowsItemItemMax = 4000;

export const saveManagedDocumentDraftBodySowFactsTablesItemRowsItemMax = 7;

export const saveManagedDocumentDraftBodySowFactsTablesItemRowsMax = 100;

export const saveManagedDocumentDraftBodySowFactsTablesMax = 6;

export const saveManagedDocumentDraftBodySowFactsInvestmentItemIdMax = 80;

export const saveManagedDocumentDraftBodySowFactsInvestmentItemTitleMax = 300;

export const saveManagedDocumentDraftBodySowFactsInvestmentItemDescriptionMax = 4000;

export const saveManagedDocumentDraftBodySowFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsInvestmentMax = 100;

export const saveManagedDocumentDraftBodySowFactsMaterialsItemIdMax = 80;

export const saveManagedDocumentDraftBodySowFactsMaterialsItemTitleMax = 300;

export const saveManagedDocumentDraftBodySowFactsMaterialsItemDescriptionMax = 4000;

export const saveManagedDocumentDraftBodySowFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsMaterialsMax = 100;

export const saveManagedDocumentDraftBodySowFactsInvoicesItemIdMax = 80;

export const saveManagedDocumentDraftBodySowFactsInvoicesItemMilestonesMax = 500;

export const saveManagedDocumentDraftBodySowFactsInvoicesItemDateMax = 40;

export const saveManagedDocumentDraftBodySowFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsInvoicesItemNotesMax = 2000;

export const saveManagedDocumentDraftBodySowFactsInvoicesMax = 100;

export const saveManagedDocumentDraftBodySowFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const saveManagedDocumentDraftBodySowFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const saveManagedDocumentDraftBodySowFactsQuoteCommercialReferenceMax = 300;

export const saveManagedDocumentDraftBodySowFactsQuoteCommercialSourceStatusMax = 100;

export const saveManagedDocumentDraftBodySowFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const saveManagedDocumentDraftBodySowFactsQuoteCommercialTermsMax = 20000;

export const saveManagedDocumentDraftBodySowFactsQuoteCommercialAssumptionsMax = 20000;

export const saveManagedDocumentDraftBodySowFactsQuoteCommercialExclusionsMax = 20000;

export const saveManagedDocumentDraftBodySowFactsQuoteCommercialReviewReasonMin = 10;
export const saveManagedDocumentDraftBodySowFactsQuoteCommercialReviewReasonMax = 2000;

export const saveManagedDocumentDraftBodySowFactsQuoteCommercialLinesItemTitleMax = 300;

export const saveManagedDocumentDraftBodySowFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const saveManagedDocumentDraftBodySowFactsQuoteCommercialLinesMax = 100;

export const saveManagedDocumentDraftBodySowFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftBodySowFactsUnresolvedFactsItemFieldMax = 100;

export const saveManagedDocumentDraftBodySowFactsUnresolvedFactsItemMessageMax = 2000;

export const saveManagedDocumentDraftBodySowFactsUnresolvedFactsMax = 200;

export const saveManagedDocumentDraftBodySowFactsCustomFieldsItemSectionIdMax = 48;

export const saveManagedDocumentDraftBodySowFactsCustomFieldsItemFieldIdMax = 48;

export const saveManagedDocumentDraftBodySowFactsCustomFieldsItemValueMax = 4000;

export const saveManagedDocumentDraftBodySowFactsCustomFieldsMax = 600;

export const saveManagedDocumentDraftBodySowFactsCustomProseItemSectionIdMax = 48;

export const saveManagedDocumentDraftBodySowFactsCustomProseItemTextMax = 20000;

export const saveManagedDocumentDraftBodySowFactsCustomProseMax = 40;

export const saveManagedDocumentDraftBodySowFactsCustomTablesItemSectionIdMax = 48;

export const saveManagedDocumentDraftBodySowFactsCustomTablesItemRowsItemItemMax = 4000;

export const saveManagedDocumentDraftBodySowFactsCustomTablesItemRowsItemMax = 8;

export const saveManagedDocumentDraftBodySowFactsCustomTablesItemRowsMax = 100;

export const saveManagedDocumentDraftBodySowFactsCustomTablesMax = 40;



export const saveManagedDocumentDraftBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "title": zod.string().min(1).max(saveManagedDocumentDraftBodyTitleMax),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsTopMin).max(saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsRightMin).max(saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsBottomMin).max(saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsLeftMin).max(saveManagedDocumentDraftBodyContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftBodyContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftBodyContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftBodyContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftBodyContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftBodyContentLayoutHeaderItemContentMax).optional()
})).max(saveManagedDocumentDraftBodyContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftBodyContentLayoutFooterItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftBodyContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftBodyContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftBodyContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftBodyContentLayoutFooterItemContentMax).optional()
})).max(saveManagedDocumentDraftBodyContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(saveManagedDocumentDraftBodyContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(saveManagedDocumentDraftBodyContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(saveManagedDocumentDraftBodyContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(saveManagedDocumentDraftBodyContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(saveManagedDocumentDraftBodyContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(saveManagedDocumentDraftBodyContentStylesDefinitionsItemFontSizeMin).max(saveManagedDocumentDraftBodyContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(saveManagedDocumentDraftBodyContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(saveManagedDocumentDraftBodyContentStylesDefinitionsItemSpaceBeforeMin).max(saveManagedDocumentDraftBodyContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(saveManagedDocumentDraftBodyContentStylesDefinitionsItemSpaceAfterMin).max(saveManagedDocumentDraftBodyContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(saveManagedDocumentDraftBodyContentStylesDefinitionsItemLineHeightMax)
})).min(saveManagedDocumentDraftBodyContentStylesDefinitionsMin).max(saveManagedDocumentDraftBodyContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(saveManagedDocumentDraftBodyContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(saveManagedDocumentDraftBodyContentTemplateSectionGuidanceItemGuidanceMax)
})).max(saveManagedDocumentDraftBodyContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftBodyContentContentItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftBodyContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftBodyContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftBodyContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftBodyContentContentItemContentMax).optional()
})).max(saveManagedDocumentDraftBodyContentContentMax)
}),
  "sowFacts": zod.object({
  "projectTitle": zod.string().max(saveManagedDocumentDraftBodySowFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(saveManagedDocumentDraftBodySowFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(saveManagedDocumentDraftBodySowFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(saveManagedDocumentDraftBodySowFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(saveManagedDocumentDraftBodySowFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(saveManagedDocumentDraftBodySowFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(saveManagedDocumentDraftBodySowFactsNarrativeItemTextMax)
})).max(saveManagedDocumentDraftBodySowFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(saveManagedDocumentDraftBodySowFactsTablesItemRowsItemItemMax)).max(saveManagedDocumentDraftBodySowFactsTablesItemRowsItemMax)).max(saveManagedDocumentDraftBodySowFactsTablesItemRowsMax)
})).max(saveManagedDocumentDraftBodySowFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(saveManagedDocumentDraftBodySowFactsInvestmentItemIdMax),
  "title": zod.string().max(saveManagedDocumentDraftBodySowFactsInvestmentItemTitleMax),
  "description": zod.string().max(saveManagedDocumentDraftBodySowFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(saveManagedDocumentDraftBodySowFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(saveManagedDocumentDraftBodySowFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(saveManagedDocumentDraftBodySowFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(saveManagedDocumentDraftBodySowFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(saveManagedDocumentDraftBodySowFactsMaterialsItemIdMax),
  "title": zod.string().max(saveManagedDocumentDraftBodySowFactsMaterialsItemTitleMax),
  "description": zod.string().max(saveManagedDocumentDraftBodySowFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(saveManagedDocumentDraftBodySowFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(saveManagedDocumentDraftBodySowFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(saveManagedDocumentDraftBodySowFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(saveManagedDocumentDraftBodySowFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(saveManagedDocumentDraftBodySowFactsInvoicesItemIdMax),
  "milestones": zod.string().max(saveManagedDocumentDraftBodySowFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(saveManagedDocumentDraftBodySowFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(saveManagedDocumentDraftBodySowFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(saveManagedDocumentDraftBodySowFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(saveManagedDocumentDraftBodySowFactsInvoicesItemNotesMax)
})).max(saveManagedDocumentDraftBodySowFactsInvoicesMax),
  "milestoneDays": zod.string().regex(saveManagedDocumentDraftBodySowFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(saveManagedDocumentDraftBodySowFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(saveManagedDocumentDraftBodySowFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(saveManagedDocumentDraftBodySowFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(saveManagedDocumentDraftBodySowFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(saveManagedDocumentDraftBodySowFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(saveManagedDocumentDraftBodySowFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(saveManagedDocumentDraftBodySowFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(saveManagedDocumentDraftBodySowFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(saveManagedDocumentDraftBodySowFactsQuoteCommercialReviewReasonMin).max(saveManagedDocumentDraftBodySowFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(saveManagedDocumentDraftBodySowFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(saveManagedDocumentDraftBodySowFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(saveManagedDocumentDraftBodySowFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(saveManagedDocumentDraftBodySowFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(saveManagedDocumentDraftBodySowFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(saveManagedDocumentDraftBodySowFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(saveManagedDocumentDraftBodySowFactsUnresolvedFactsItemMessageMax)
})).max(saveManagedDocumentDraftBodySowFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(saveManagedDocumentDraftBodySowFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(saveManagedDocumentDraftBodySowFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(saveManagedDocumentDraftBodySowFactsCustomFieldsItemValueMax).nullable()
})).max(saveManagedDocumentDraftBodySowFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(saveManagedDocumentDraftBodySowFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(saveManagedDocumentDraftBodySowFactsCustomProseItemTextMax)
})).max(saveManagedDocumentDraftBodySowFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(saveManagedDocumentDraftBodySowFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(saveManagedDocumentDraftBodySowFactsCustomTablesItemRowsItemItemMax)).max(saveManagedDocumentDraftBodySowFactsCustomTablesItemRowsItemMax)).max(saveManagedDocumentDraftBodySowFactsCustomTablesItemRowsMax)
})).max(saveManagedDocumentDraftBodySowFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}).optional()
})

export const saveManagedDocumentDraftResponseSowOneFactsProjectTitleMax = 200;

export const saveManagedDocumentDraftResponseSowOneFactsCustomerNameMax = 300;

export const saveManagedDocumentDraftResponseSowOneFactsAgreementIdMax = 100;

export const saveManagedDocumentDraftResponseSowOneFactsPreparedDateMax = 40;

export const saveManagedDocumentDraftResponseSowOneFactsStartDateMax = 40;

export const saveManagedDocumentDraftResponseSowOneFactsSprintWeeksMax = 52;

export const saveManagedDocumentDraftResponseSowOneFactsNarrativeItemTextMax = 20000;

export const saveManagedDocumentDraftResponseSowOneFactsNarrativeMax = 5;

export const saveManagedDocumentDraftResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const saveManagedDocumentDraftResponseSowOneFactsTablesItemRowsItemMax = 7;

export const saveManagedDocumentDraftResponseSowOneFactsTablesItemRowsMax = 100;

export const saveManagedDocumentDraftResponseSowOneFactsTablesMax = 6;

export const saveManagedDocumentDraftResponseSowOneFactsInvestmentItemIdMax = 80;

export const saveManagedDocumentDraftResponseSowOneFactsInvestmentItemTitleMax = 300;

export const saveManagedDocumentDraftResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const saveManagedDocumentDraftResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsInvestmentMax = 100;

export const saveManagedDocumentDraftResponseSowOneFactsMaterialsItemIdMax = 80;

export const saveManagedDocumentDraftResponseSowOneFactsMaterialsItemTitleMax = 300;

export const saveManagedDocumentDraftResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const saveManagedDocumentDraftResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsMaterialsMax = 100;

export const saveManagedDocumentDraftResponseSowOneFactsInvoicesItemIdMax = 80;

export const saveManagedDocumentDraftResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const saveManagedDocumentDraftResponseSowOneFactsInvoicesItemDateMax = 40;

export const saveManagedDocumentDraftResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const saveManagedDocumentDraftResponseSowOneFactsInvoicesMax = 100;

export const saveManagedDocumentDraftResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const saveManagedDocumentDraftResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const saveManagedDocumentDraftResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const saveManagedDocumentDraftResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const saveManagedDocumentDraftResponseSowOneFactsUnresolvedFactsMax = 200;

export const saveManagedDocumentDraftResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const saveManagedDocumentDraftResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const saveManagedDocumentDraftResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const saveManagedDocumentDraftResponseSowOneFactsCustomFieldsMax = 600;

export const saveManagedDocumentDraftResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const saveManagedDocumentDraftResponseSowOneFactsCustomProseItemTextMax = 20000;

export const saveManagedDocumentDraftResponseSowOneFactsCustomProseMax = 40;

export const saveManagedDocumentDraftResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const saveManagedDocumentDraftResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const saveManagedDocumentDraftResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const saveManagedDocumentDraftResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const saveManagedDocumentDraftResponseSowOneFactsCustomTablesMax = 40;

export const saveManagedDocumentDraftResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const saveManagedDocumentDraftResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const saveManagedDocumentDraftResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const saveManagedDocumentDraftResponseSowApprovalPolicyOneRevisionsMax = 3;

export const saveManagedDocumentDraftResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const saveManagedDocumentDraftResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const saveManagedDocumentDraftResponseDraftContentLayoutHeaderMax = 100;

export const saveManagedDocumentDraftResponseDraftContentLayoutFooterItemTypeMax = 40;

export const saveManagedDocumentDraftResponseDraftContentLayoutFooterItemTextMax = 200000;

export const saveManagedDocumentDraftResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftResponseDraftContentLayoutFooterItemMarksMax = 20;

export const saveManagedDocumentDraftResponseDraftContentLayoutFooterItemContentMax = 10000;

export const saveManagedDocumentDraftResponseDraftContentLayoutFooterMax = 100;

export const saveManagedDocumentDraftResponseDraftContentSectionsItemsItemTitleMax = 160;

export const saveManagedDocumentDraftResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const saveManagedDocumentDraftResponseDraftContentSectionsItemsMax = 200;

export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsMin = 7;
export const saveManagedDocumentDraftResponseDraftContentStylesDefinitionsMax = 100;

export const saveManagedDocumentDraftResponseDraftContentTemplateGuidanceMax = 4000;

export const saveManagedDocumentDraftResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const saveManagedDocumentDraftResponseDraftContentTemplateSectionGuidanceMax = 200;

export const saveManagedDocumentDraftResponseDraftContentContentItemTypeMax = 40;

export const saveManagedDocumentDraftResponseDraftContentContentItemTextMax = 200000;

export const saveManagedDocumentDraftResponseDraftContentContentItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftResponseDraftContentContentItemMarksMax = 20;

export const saveManagedDocumentDraftResponseDraftContentContentItemContentMax = 10000;

export const saveManagedDocumentDraftResponseDraftContentContentMax = 10000;

export const saveManagedDocumentDraftResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const saveManagedDocumentDraftResponseVersionsItemMajorVersionMin = 0;

export const saveManagedDocumentDraftResponseVersionsItemMinorVersionMin = 0;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderMax = 100;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterMax = 100;

export const saveManagedDocumentDraftResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const saveManagedDocumentDraftResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const saveManagedDocumentDraftResponseVersionsItemContentSectionsItemsMax = 200;

export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsMin = 7;
export const saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsMax = 100;

export const saveManagedDocumentDraftResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const saveManagedDocumentDraftResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const saveManagedDocumentDraftResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const saveManagedDocumentDraftResponseVersionsItemContentContentItemTypeMax = 40;

export const saveManagedDocumentDraftResponseVersionsItemContentContentItemTextMax = 200000;

export const saveManagedDocumentDraftResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftResponseVersionsItemContentContentItemMarksMax = 20;

export const saveManagedDocumentDraftResponseVersionsItemContentContentItemContentMax = 10000;

export const saveManagedDocumentDraftResponseVersionsItemContentContentMax = 10000;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const saveManagedDocumentDraftResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(saveManagedDocumentDraftResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsNarrativeItemTextMax)
})).max(saveManagedDocumentDraftResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(saveManagedDocumentDraftResponseSowOneFactsTablesItemRowsItemItemMax)).max(saveManagedDocumentDraftResponseSowOneFactsTablesItemRowsItemMax)).max(saveManagedDocumentDraftResponseSowOneFactsTablesItemRowsMax)
})).max(saveManagedDocumentDraftResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(saveManagedDocumentDraftResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(saveManagedDocumentDraftResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(saveManagedDocumentDraftResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(saveManagedDocumentDraftResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(saveManagedDocumentDraftResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsInvoicesItemNotesMax)
})).max(saveManagedDocumentDraftResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialReviewReasonMin).max(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(saveManagedDocumentDraftResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(saveManagedDocumentDraftResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(saveManagedDocumentDraftResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(saveManagedDocumentDraftResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsCustomProseItemTextMax)
})).max(saveManagedDocumentDraftResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(saveManagedDocumentDraftResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(saveManagedDocumentDraftResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(saveManagedDocumentDraftResponseSowOneFactsCustomTablesItemRowsItemMax)).max(saveManagedDocumentDraftResponseSowOneFactsCustomTablesItemRowsMax)
})).max(saveManagedDocumentDraftResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(saveManagedDocumentDraftResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(saveManagedDocumentDraftResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(saveManagedDocumentDraftResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(saveManagedDocumentDraftResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(saveManagedDocumentDraftResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(saveManagedDocumentDraftResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsTopMin).max(saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsRightMin).max(saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(saveManagedDocumentDraftResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(saveManagedDocumentDraftResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(saveManagedDocumentDraftResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(saveManagedDocumentDraftResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(saveManagedDocumentDraftResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(saveManagedDocumentDraftResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemFontSizeMin).max(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsMin).max(saveManagedDocumentDraftResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(saveManagedDocumentDraftResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(saveManagedDocumentDraftResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(saveManagedDocumentDraftResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftResponseDraftContentContentItemContentMax).optional()
})).max(saveManagedDocumentDraftResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(saveManagedDocumentDraftResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(saveManagedDocumentDraftResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(saveManagedDocumentDraftResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(saveManagedDocumentDraftResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(saveManagedDocumentDraftResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(saveManagedDocumentDraftResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(saveManagedDocumentDraftResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsMin).max(saveManagedDocumentDraftResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(saveManagedDocumentDraftResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(saveManagedDocumentDraftResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(saveManagedDocumentDraftResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftResponseVersionsItemContentContentItemContentMax).optional()
})).max(saveManagedDocumentDraftResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(saveManagedDocumentDraftResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const changeManagedDocumentSectionsParams = zod.object({
  "id": zod.uuid()
})

export const changeManagedDocumentSectionsBodyExpectedRevisionMax = 2147483646;

export const changeManagedDocumentSectionsBodyTitleMax = 160;

export const changeManagedDocumentSectionsBodyBlockIndexMin = 0;
export const changeManagedDocumentSectionsBodyBlockIndexMax = 10000;

export const changeManagedDocumentSectionsBodyLabelMax = 160;

export const changeManagedDocumentSectionsBodyAuthoringNotesMax = 4000;

export const changeManagedDocumentSectionsBodyTemplateGuidanceMax = 4000;

export const changeManagedDocumentSectionsBodyTemplateSectionGuidanceItemGuidanceMax = 4000;

export const changeManagedDocumentSectionsBodyTemplateSectionGuidanceMax = 200;

export const changeManagedDocumentSectionsBodySectionsItemsItemTitleMax = 160;

export const changeManagedDocumentSectionsBodySectionsItemsItemAuthoringNotesMax = 4000;


export const changeManagedDocumentSectionsBodySectionsItemsMax = 200;

export const changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsTopMin = 5;
export const changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsTopMax = 50;

export const changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsRightMin = 5;
export const changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsRightMax = 50;

export const changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsBottomMin = 5;
export const changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsBottomMax = 50;

export const changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsLeftMin = 5;
export const changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsLeftMax = 50;

export const changeManagedDocumentSectionsBodyContentLayoutHeaderItemTypeMax = 40;

export const changeManagedDocumentSectionsBodyContentLayoutHeaderItemTextMax = 200000;

export const changeManagedDocumentSectionsBodyContentLayoutHeaderItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsBodyContentLayoutHeaderItemMarksMax = 20;

export const changeManagedDocumentSectionsBodyContentLayoutHeaderItemContentMax = 10000;

export const changeManagedDocumentSectionsBodyContentLayoutHeaderMax = 100;

export const changeManagedDocumentSectionsBodyContentLayoutFooterItemTypeMax = 40;

export const changeManagedDocumentSectionsBodyContentLayoutFooterItemTextMax = 200000;

export const changeManagedDocumentSectionsBodyContentLayoutFooterItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsBodyContentLayoutFooterItemMarksMax = 20;

export const changeManagedDocumentSectionsBodyContentLayoutFooterItemContentMax = 10000;

export const changeManagedDocumentSectionsBodyContentLayoutFooterMax = 100;

export const changeManagedDocumentSectionsBodyContentSectionsItemsItemTitleMax = 160;

export const changeManagedDocumentSectionsBodyContentSectionsItemsItemAuthoringNotesMax = 4000;


export const changeManagedDocumentSectionsBodyContentSectionsItemsMax = 200;

export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemNameMax = 80;

export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemFontSizeMin = 6;
export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemFontSizeMax = 96;

export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemSpaceAfterMin = 0;
export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemSpaceAfterMax = 144;

export const changeManagedDocumentSectionsBodyContentStylesDefinitionsItemLineHeightMax = 3;

export const changeManagedDocumentSectionsBodyContentStylesDefinitionsMin = 7;
export const changeManagedDocumentSectionsBodyContentStylesDefinitionsMax = 100;

export const changeManagedDocumentSectionsBodyContentTemplateGuidanceMax = 4000;

export const changeManagedDocumentSectionsBodyContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const changeManagedDocumentSectionsBodyContentTemplateSectionGuidanceMax = 200;

export const changeManagedDocumentSectionsBodyContentContentItemTypeMax = 40;

export const changeManagedDocumentSectionsBodyContentContentItemTextMax = 200000;

export const changeManagedDocumentSectionsBodyContentContentItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsBodyContentContentItemMarksMax = 20;

export const changeManagedDocumentSectionsBodyContentContentItemContentMax = 10000;

export const changeManagedDocumentSectionsBodyContentContentMax = 10000;



export const changeManagedDocumentSectionsBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1).max(changeManagedDocumentSectionsBodyExpectedRevisionMax),
  "action": zod.enum(['setup', 'structure', 'protection', 'content', 'guidance', 'convert', 'insert', 'settings', 'remove', 'template']),
  "title": zod.string().min(1).max(changeManagedDocumentSectionsBodyTitleMax).optional(),
  "hidden": zod.boolean().optional(),
  "unlockConfirmed": zod.boolean().optional(),
  "boundaryMode": zod.enum(['independent']).optional(),
  "blockIndex": zod.int().min(changeManagedDocumentSectionsBodyBlockIndexMin).max(changeManagedDocumentSectionsBodyBlockIndexMax).optional(),
  "label": zod.string().min(1).max(changeManagedDocumentSectionsBodyLabelMax).optional(),
  "authoringNotes": zod.string().max(changeManagedDocumentSectionsBodyAuthoringNotesMax).optional(),
  "markReviewed": zod.boolean().optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(changeManagedDocumentSectionsBodyTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(changeManagedDocumentSectionsBodyTemplateSectionGuidanceItemGuidanceMax)
})).max(changeManagedDocumentSectionsBodyTemplateSectionGuidanceMax)
}).optional(),
  "confirmed": zod.literal(true).optional(),
  "mode": zod.enum(['headings', 'whole']).optional(),
  "sectionId": zod.uuid().optional(),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(changeManagedDocumentSectionsBodySectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(changeManagedDocumentSectionsBodySectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(changeManagedDocumentSectionsBodySectionsItemsMax)
}).optional(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']).optional(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsTopMin).max(changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsRightMin).max(changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsBottomMin).max(changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsLeftMin).max(changeManagedDocumentSectionsBodyContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsBodyContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsBodyContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsBodyContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsBodyContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsBodyContentLayoutHeaderItemContentMax).optional()
})).max(changeManagedDocumentSectionsBodyContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsBodyContentLayoutFooterItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsBodyContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsBodyContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsBodyContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsBodyContentLayoutFooterItemContentMax).optional()
})).max(changeManagedDocumentSectionsBodyContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(changeManagedDocumentSectionsBodyContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(changeManagedDocumentSectionsBodyContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(changeManagedDocumentSectionsBodyContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemFontSizeMin).max(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemSpaceBeforeMin).max(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemSpaceAfterMin).max(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(changeManagedDocumentSectionsBodyContentStylesDefinitionsItemLineHeightMax)
})).min(changeManagedDocumentSectionsBodyContentStylesDefinitionsMin).max(changeManagedDocumentSectionsBodyContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(changeManagedDocumentSectionsBodyContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(changeManagedDocumentSectionsBodyContentTemplateSectionGuidanceItemGuidanceMax)
})).max(changeManagedDocumentSectionsBodyContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsBodyContentContentItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsBodyContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsBodyContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsBodyContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsBodyContentContentItemContentMax).optional()
})).max(changeManagedDocumentSectionsBodyContentContentMax)
}).optional()
})

export const changeManagedDocumentSectionsResponseSowOneFactsProjectTitleMax = 200;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomerNameMax = 300;

export const changeManagedDocumentSectionsResponseSowOneFactsAgreementIdMax = 100;

export const changeManagedDocumentSectionsResponseSowOneFactsPreparedDateMax = 40;

export const changeManagedDocumentSectionsResponseSowOneFactsStartDateMax = 40;

export const changeManagedDocumentSectionsResponseSowOneFactsSprintWeeksMax = 52;

export const changeManagedDocumentSectionsResponseSowOneFactsNarrativeItemTextMax = 20000;

export const changeManagedDocumentSectionsResponseSowOneFactsNarrativeMax = 5;

export const changeManagedDocumentSectionsResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const changeManagedDocumentSectionsResponseSowOneFactsTablesItemRowsItemMax = 7;

export const changeManagedDocumentSectionsResponseSowOneFactsTablesItemRowsMax = 100;

export const changeManagedDocumentSectionsResponseSowOneFactsTablesMax = 6;

export const changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemIdMax = 80;

export const changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemTitleMax = 300;

export const changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsInvestmentMax = 100;

export const changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemIdMax = 80;

export const changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemTitleMax = 300;

export const changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsMaterialsMax = 100;

export const changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemIdMax = 80;

export const changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemDateMax = 40;

export const changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const changeManagedDocumentSectionsResponseSowOneFactsInvoicesMax = 100;

export const changeManagedDocumentSectionsResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const changeManagedDocumentSectionsResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentSectionsResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const changeManagedDocumentSectionsResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const changeManagedDocumentSectionsResponseSowOneFactsUnresolvedFactsMax = 200;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomFieldsMax = 600;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomProseItemTextMax = 20000;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomProseMax = 40;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const changeManagedDocumentSectionsResponseSowOneFactsCustomTablesMax = 40;

export const changeManagedDocumentSectionsResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const changeManagedDocumentSectionsResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const changeManagedDocumentSectionsResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const changeManagedDocumentSectionsResponseSowApprovalPolicyOneRevisionsMax = 3;

export const changeManagedDocumentSectionsResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const changeManagedDocumentSectionsResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const changeManagedDocumentSectionsResponseDraftContentLayoutHeaderMax = 100;

export const changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemTextMax = 200000;

export const changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemMarksMax = 20;

export const changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemContentMax = 10000;

export const changeManagedDocumentSectionsResponseDraftContentLayoutFooterMax = 100;

export const changeManagedDocumentSectionsResponseDraftContentSectionsItemsItemTitleMax = 160;

export const changeManagedDocumentSectionsResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const changeManagedDocumentSectionsResponseDraftContentSectionsItemsMax = 200;

export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsMin = 7;
export const changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsMax = 100;

export const changeManagedDocumentSectionsResponseDraftContentTemplateGuidanceMax = 4000;

export const changeManagedDocumentSectionsResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const changeManagedDocumentSectionsResponseDraftContentTemplateSectionGuidanceMax = 200;

export const changeManagedDocumentSectionsResponseDraftContentContentItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseDraftContentContentItemTextMax = 200000;

export const changeManagedDocumentSectionsResponseDraftContentContentItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseDraftContentContentItemMarksMax = 20;

export const changeManagedDocumentSectionsResponseDraftContentContentItemContentMax = 10000;

export const changeManagedDocumentSectionsResponseDraftContentContentMax = 10000;

export const changeManagedDocumentSectionsResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const changeManagedDocumentSectionsResponseVersionsItemMajorVersionMin = 0;

export const changeManagedDocumentSectionsResponseVersionsItemMinorVersionMin = 0;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderMax = 100;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterMax = 100;

export const changeManagedDocumentSectionsResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const changeManagedDocumentSectionsResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const changeManagedDocumentSectionsResponseVersionsItemContentSectionsItemsMax = 200;

export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsMin = 7;
export const changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsMax = 100;

export const changeManagedDocumentSectionsResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const changeManagedDocumentSectionsResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const changeManagedDocumentSectionsResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const changeManagedDocumentSectionsResponseVersionsItemContentContentItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseVersionsItemContentContentItemTextMax = 200000;

export const changeManagedDocumentSectionsResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseVersionsItemContentContentItemMarksMax = 20;

export const changeManagedDocumentSectionsResponseVersionsItemContentContentItemContentMax = 10000;

export const changeManagedDocumentSectionsResponseVersionsItemContentContentMax = 10000;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const changeManagedDocumentSectionsResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(changeManagedDocumentSectionsResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsNarrativeItemTextMax)
})).max(changeManagedDocumentSectionsResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsTablesItemRowsItemItemMax)).max(changeManagedDocumentSectionsResponseSowOneFactsTablesItemRowsItemMax)).max(changeManagedDocumentSectionsResponseSowOneFactsTablesItemRowsMax)
})).max(changeManagedDocumentSectionsResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(changeManagedDocumentSectionsResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(changeManagedDocumentSectionsResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsInvoicesItemNotesMax)
})).max(changeManagedDocumentSectionsResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialReviewReasonMin).max(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(changeManagedDocumentSectionsResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(changeManagedDocumentSectionsResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(changeManagedDocumentSectionsResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(changeManagedDocumentSectionsResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsCustomProseItemTextMax)
})).max(changeManagedDocumentSectionsResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(changeManagedDocumentSectionsResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(changeManagedDocumentSectionsResponseSowOneFactsCustomTablesItemRowsItemMax)).max(changeManagedDocumentSectionsResponseSowOneFactsCustomTablesItemRowsMax)
})).max(changeManagedDocumentSectionsResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(changeManagedDocumentSectionsResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(changeManagedDocumentSectionsResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(changeManagedDocumentSectionsResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(changeManagedDocumentSectionsResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(changeManagedDocumentSectionsResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(changeManagedDocumentSectionsResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsTopMin).max(changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsRightMin).max(changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(changeManagedDocumentSectionsResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(changeManagedDocumentSectionsResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(changeManagedDocumentSectionsResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(changeManagedDocumentSectionsResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(changeManagedDocumentSectionsResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(changeManagedDocumentSectionsResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemFontSizeMin).max(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsMin).max(changeManagedDocumentSectionsResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(changeManagedDocumentSectionsResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(changeManagedDocumentSectionsResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(changeManagedDocumentSectionsResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsResponseDraftContentContentItemContentMax).optional()
})).max(changeManagedDocumentSectionsResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(changeManagedDocumentSectionsResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(changeManagedDocumentSectionsResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(changeManagedDocumentSectionsResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(changeManagedDocumentSectionsResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(changeManagedDocumentSectionsResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsMin).max(changeManagedDocumentSectionsResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(changeManagedDocumentSectionsResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(changeManagedDocumentSectionsResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(changeManagedDocumentSectionsResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsResponseVersionsItemContentContentItemContentMax).optional()
})).max(changeManagedDocumentSectionsResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(changeManagedDocumentSectionsResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getManagedDocumentSectionOutcomeParams = zod.object({
  "id": zod.uuid()
})

export const getManagedDocumentSectionOutcomeQueryParams = zod.object({
  "clientRequestId": zod.uuid()
})

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsProjectTitleMax = 200;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomerNameMax = 300;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsAgreementIdMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsPreparedDateMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsStartDateMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsSprintWeeksMax = 52;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsNarrativeItemTextMax = 20000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsNarrativeMax = 5;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsTablesItemRowsItemItemMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsTablesItemRowsItemMax = 7;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsTablesItemRowsMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsTablesMax = 6;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemIdMax = 80;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemTitleMax = 300;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemDescriptionMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemIdMax = 80;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemTitleMax = 300;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemDescriptionMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemIdMax = 80;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemMilestonesMax = 500;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemDateMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemNotesMax = 2000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialReferenceMax = 300;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialTermsMax = 20000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialLinesMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsUnresolvedFactsMax = 200;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomFieldsItemValueMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomFieldsMax = 600;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomProseItemSectionIdMax = 48;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomProseItemTextMax = 20000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomProseMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesItemSectionIdMax = 48;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesItemRowsItemMax = 8;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesItemRowsMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneLocalRevisionMin = 0;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneRevisionsMax = 3;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemTextMax = 200000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemMarksMax = 20;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentSectionsItemsItemTitleMax = 160;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentSectionsItemsMax = 200;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsMin = 7;
export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentTemplateGuidanceMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentTemplateSectionGuidanceMax = 200;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemTextMax = 200000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemMarksItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemMarksMax = 20;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemMajorVersionMin = 0;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemMinorVersionMin = 0;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemTextMax = 200000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemMarksMax = 20;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentSectionsItemsItemTitleMax = 160;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentSectionsItemsMax = 200;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsMin = 7;
export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentTemplateGuidanceMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentTemplateSectionGuidanceMax = 200;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemTextMax = 200000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemMarksItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemMarksMax = 20;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentMax = 10000;




export const getManagedDocumentSectionOutcomeResponse = zod.object({
  "appliedRevision": zod.int().nullable(),
  "workspace": zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsNarrativeItemTextMax)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsTablesItemRowsItemItemMax)).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsTablesItemRowsItemMax)).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsTablesItemRowsMax)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesItemNotesMax)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsUnresolvedFactsItemMessageMax)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomProseItemTextMax)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesItemRowsItemItemMax)).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesItemRowsItemMax)).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesItemRowsMax)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getManagedDocumentSectionOutcomeResponseWorkspaceSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentItemContentMax).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentContentMax)
}),
  "contentHash": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentItemContentMax).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMin).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(getManagedDocumentSectionOutcomeResponseWorkspaceAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})
})


export const getManagedDocumentCollaborationParams = zod.object({
  "id": zod.uuid()
})

export const getManagedDocumentCollaborationQueryParams = zod.object({
  "sessionId": zod.uuid(),
  "clientRequestId": zod.uuid().optional()
})

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsProjectTitleMax = 200;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomerNameMax = 300;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsAgreementIdMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsPreparedDateMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsStartDateMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsSprintWeeksMax = 52;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsNarrativeItemTextMax = 20000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsNarrativeMax = 5;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsItemItemMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsItemMax = 7;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesMax = 6;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemIdMax = 80;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemTitleMax = 300;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemDescriptionMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemIdMax = 80;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemTitleMax = 300;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemDescriptionMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemIdMax = 80;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemMilestonesMax = 500;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemDateMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemNotesMax = 2000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReferenceMax = 300;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialTermsMax = 20000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsMax = 200;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemValueMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsMax = 600;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseItemSectionIdMax = 48;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseItemTextMax = 20000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemSectionIdMax = 48;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsItemMax = 8;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneLocalRevisionMin = 0;

export const getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneRevisionsMax = 3;

export const getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemTextMax = 200000;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemMarksMax = 20;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsItemTitleMax = 160;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsMax = 200;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsMin = 7;
export const getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateGuidanceMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateSectionGuidanceMax = 200;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemTextMax = 200000;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemMarksItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemMarksMax = 20;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemMajorVersionMin = 0;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemMinorVersionMin = 0;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemTextMax = 200000;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemMarksMax = 20;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsItemTitleMax = 160;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsMax = 200;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsMin = 7;
export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateGuidanceMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateSectionGuidanceMax = 200;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemTextMax = 200000;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemMarksItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemMarksMax = 20;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentMax = 10000;


export const getManagedDocumentCollaborationResponseCrdtStateMax = 5592408;

export const getManagedDocumentCollaborationResponseStateVectorMax = 131072;

export const getManagedDocumentCollaborationResponseAutoVersionLabelMax = 32;

export const getManagedDocumentCollaborationResponsePeersItemNameMax = 200;

export const getManagedDocumentCollaborationResponsePeersItemCursorAnchorMax = 2048;

export const getManagedDocumentCollaborationResponsePeersItemCursorHeadMax = 2048;

export const getManagedDocumentCollaborationResponsePeersMax = 32;



export const getManagedDocumentCollaborationResponse = zod.object({
  "workspace": zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsNarrativeItemTextMax)
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsItemItemMax)).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsItemMax)).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsMax)
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemNotesMax)
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMin).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsItemMessageMax)
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseItemTextMax)
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsItemItemMax)).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsItemMax)).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsMax)
})).max(getManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMin).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMin).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMin).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsMin).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemContentMax).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceDraftContentContentMax)
}),
  "contentHash": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMin).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMin).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMin).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsMin).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemContentMax).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMin).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(getManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "epoch": zod.uuid(),
  "receiptRevision": zod.int().nullable(),
  "crdtState": zod.string().max(getManagedDocumentCollaborationResponseCrdtStateMax).optional(),
  "stateVector": zod.string().max(getManagedDocumentCollaborationResponseStateVectorMax).optional(),
  "canEdit": zod.boolean().optional().describe('Whether the signed-in caller may change content in this live session. Viewers join read-only.'),
  "autoVersionLabel": zod.string().max(getManagedDocumentCollaborationResponseAutoVersionLabelMax).nullish().describe('Label of the automatic version created when the last editor left live editing (null when none was needed).'),
  "peers": zod.array(zod.object({
  "sessionId": zod.uuid(),
  "actorId": zod.uuid(),
  "name": zod.string().max(getManagedDocumentCollaborationResponsePeersItemNameMax).nullish().describe('Server-resolved display name. Never taken from the client.'),
  "canEdit": zod.boolean().optional().describe('False for people who can only view.'),
  "seenAt": zod.iso.datetime({"offset":true}),
  "cursor": zod.object({
  "anchor": zod.string().max(getManagedDocumentCollaborationResponsePeersItemCursorAnchorMax),
  "head": zod.string().max(getManagedDocumentCollaborationResponsePeersItemCursorHeadMax)
}).optional()
})).max(getManagedDocumentCollaborationResponsePeersMax)
}).describe('Authorized durable collaboration snapshot. CRDT state is compacted without losing operation identity; absent state is legacy semantic mode.')


export const updateManagedDocumentCollaborationParams = zod.object({
  "id": zod.uuid()
})

export const updateManagedDocumentCollaborationBodyUpdateMin = 4;
export const updateManagedDocumentCollaborationBodyUpdateMax = 349528;

export const updateManagedDocumentCollaborationBodyStateVectorMax = 131072;

export const updateManagedDocumentCollaborationBodyCursorAnchorMax = 2048;

export const updateManagedDocumentCollaborationBodyCursorHeadMax = 2048;

export const updateManagedDocumentCollaborationBodyExpectedRevisionMax = 2147483646;

export const updateManagedDocumentCollaborationBodyBaseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateManagedDocumentCollaborationBodyTitleMax = 200;

export const updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsTopMin = 5;
export const updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsTopMax = 50;

export const updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsRightMin = 5;
export const updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsRightMax = 50;

export const updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsBottomMin = 5;
export const updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsBottomMax = 50;

export const updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsLeftMin = 5;
export const updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsLeftMax = 50;

export const updateManagedDocumentCollaborationBodyContentLayoutHeaderItemTypeMax = 40;

export const updateManagedDocumentCollaborationBodyContentLayoutHeaderItemTextMax = 200000;

export const updateManagedDocumentCollaborationBodyContentLayoutHeaderItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationBodyContentLayoutHeaderItemMarksMax = 20;

export const updateManagedDocumentCollaborationBodyContentLayoutHeaderItemContentMax = 10000;

export const updateManagedDocumentCollaborationBodyContentLayoutHeaderMax = 100;

export const updateManagedDocumentCollaborationBodyContentLayoutFooterItemTypeMax = 40;

export const updateManagedDocumentCollaborationBodyContentLayoutFooterItemTextMax = 200000;

export const updateManagedDocumentCollaborationBodyContentLayoutFooterItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationBodyContentLayoutFooterItemMarksMax = 20;

export const updateManagedDocumentCollaborationBodyContentLayoutFooterItemContentMax = 10000;

export const updateManagedDocumentCollaborationBodyContentLayoutFooterMax = 100;

export const updateManagedDocumentCollaborationBodyContentSectionsItemsItemTitleMax = 160;

export const updateManagedDocumentCollaborationBodyContentSectionsItemsItemAuthoringNotesMax = 4000;


export const updateManagedDocumentCollaborationBodyContentSectionsItemsMax = 200;

export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemNameMax = 80;

export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemFontSizeMin = 6;
export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemFontSizeMax = 96;

export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemSpaceAfterMin = 0;
export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemSpaceAfterMax = 144;

export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemLineHeightMax = 3;

export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsMin = 7;
export const updateManagedDocumentCollaborationBodyContentStylesDefinitionsMax = 100;

export const updateManagedDocumentCollaborationBodyContentTemplateGuidanceMax = 4000;

export const updateManagedDocumentCollaborationBodyContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const updateManagedDocumentCollaborationBodyContentTemplateSectionGuidanceMax = 200;

export const updateManagedDocumentCollaborationBodyContentContentItemTypeMax = 40;

export const updateManagedDocumentCollaborationBodyContentContentItemTextMax = 200000;

export const updateManagedDocumentCollaborationBodyContentContentItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationBodyContentContentItemMarksMax = 20;

export const updateManagedDocumentCollaborationBodyContentContentItemContentMax = 10000;

export const updateManagedDocumentCollaborationBodyContentContentMax = 10000;



export const updateManagedDocumentCollaborationBody = zod.object({
  "sessionId": zod.uuid(),
  "action": zod.enum(['join', 'heartbeat', 'sync', 'leave', 'commit', 'live_join', 'update']),
  "update": zod.string().min(updateManagedDocumentCollaborationBodyUpdateMin).max(updateManagedDocumentCollaborationBodyUpdateMax).optional(),
  "stateVector": zod.string().max(updateManagedDocumentCollaborationBodyStateVectorMax).optional(),
  "cursor": zod.object({
  "anchor": zod.string().max(updateManagedDocumentCollaborationBodyCursorAnchorMax),
  "head": zod.string().max(updateManagedDocumentCollaborationBodyCursorHeadMax)
}).optional(),
  "clearCursor": zod.boolean().optional(),
  "clientRequestId": zod.uuid().optional(),
  "epoch": zod.uuid().optional(),
  "expectedRevision": zod.int().min(1).max(updateManagedDocumentCollaborationBodyExpectedRevisionMax).optional(),
  "baseContentHash": zod.string().regex(updateManagedDocumentCollaborationBodyBaseContentHashRegExp).optional(),
  "title": zod.string().min(1).max(updateManagedDocumentCollaborationBodyTitleMax).optional(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsTopMin).max(updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsRightMin).max(updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsBottomMin).max(updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsLeftMin).max(updateManagedDocumentCollaborationBodyContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationBodyContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationBodyContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationBodyContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationBodyContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationBodyContentLayoutHeaderItemContentMax).optional()
})).max(updateManagedDocumentCollaborationBodyContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationBodyContentLayoutFooterItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationBodyContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationBodyContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationBodyContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationBodyContentLayoutFooterItemContentMax).optional()
})).max(updateManagedDocumentCollaborationBodyContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(updateManagedDocumentCollaborationBodyContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(updateManagedDocumentCollaborationBodyContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(updateManagedDocumentCollaborationBodyContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemFontSizeMin).max(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemSpaceBeforeMin).max(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemSpaceAfterMin).max(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(updateManagedDocumentCollaborationBodyContentStylesDefinitionsItemLineHeightMax)
})).min(updateManagedDocumentCollaborationBodyContentStylesDefinitionsMin).max(updateManagedDocumentCollaborationBodyContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(updateManagedDocumentCollaborationBodyContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(updateManagedDocumentCollaborationBodyContentTemplateSectionGuidanceItemGuidanceMax)
})).max(updateManagedDocumentCollaborationBodyContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationBodyContentContentItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationBodyContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationBodyContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationBodyContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationBodyContentContentItemContentMax).optional()
})).max(updateManagedDocumentCollaborationBodyContentContentMax)
}).optional()
})

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsProjectTitleMax = 200;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomerNameMax = 300;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsAgreementIdMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsPreparedDateMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsStartDateMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsSprintWeeksMax = 52;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsNarrativeItemTextMax = 20000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsNarrativeMax = 5;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsItemItemMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsItemMax = 7;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesMax = 6;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemIdMax = 80;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemTitleMax = 300;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemDescriptionMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemIdMax = 80;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemTitleMax = 300;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemDescriptionMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemIdMax = 80;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemMilestonesMax = 500;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemDateMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemNotesMax = 2000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReferenceMax = 300;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialTermsMax = 20000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsMax = 200;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemValueMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsMax = 600;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseItemSectionIdMax = 48;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseItemTextMax = 20000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemSectionIdMax = 48;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsItemMax = 8;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneLocalRevisionMin = 0;

export const updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneRevisionsMax = 3;

export const updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemTextMax = 200000;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemMarksMax = 20;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemTextMax = 200000;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemMarksMax = 20;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsItemTitleMax = 160;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsMax = 200;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemNameMax = 80;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsMin = 7;
export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateGuidanceMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateSectionGuidanceMax = 200;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemTextMax = 200000;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemMarksMax = 20;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemMajorVersionMin = 0;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemMinorVersionMin = 0;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemTextMax = 200000;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemMarksMax = 20;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsItemTitleMax = 160;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsMax = 200;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsMin = 7;
export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateGuidanceMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateSectionGuidanceMax = 200;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemTextMax = 200000;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemMarksMax = 20;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentMax = 10000;


export const updateManagedDocumentCollaborationResponseCrdtStateMax = 5592408;

export const updateManagedDocumentCollaborationResponseStateVectorMax = 131072;

export const updateManagedDocumentCollaborationResponseAutoVersionLabelMax = 32;

export const updateManagedDocumentCollaborationResponsePeersItemNameMax = 200;

export const updateManagedDocumentCollaborationResponsePeersItemCursorAnchorMax = 2048;

export const updateManagedDocumentCollaborationResponsePeersItemCursorHeadMax = 2048;

export const updateManagedDocumentCollaborationResponsePeersMax = 32;



export const updateManagedDocumentCollaborationResponse = zod.object({
  "workspace": zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsNarrativeItemTextMax)
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsItemItemMax)).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsItemMax)).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesItemRowsMax)
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesItemNotesMax)
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMin).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsItemMessageMax)
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseItemTextMax)
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsItemItemMax)).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsItemMax)).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesItemRowsMax)
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(updateManagedDocumentCollaborationResponseWorkspaceSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMin).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMin).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMin).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMin).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderItemContentMax).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterItemContentMax).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMin).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMin).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMin).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsItemLineHeightMax)
})).min(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsMin).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentItemContentMax).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceDraftContentContentMax)
}),
  "contentHash": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMin).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMin).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMin).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsMin).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentItemContentMax).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMin).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(updateManagedDocumentCollaborationResponseWorkspaceAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "epoch": zod.uuid(),
  "receiptRevision": zod.int().nullable(),
  "crdtState": zod.string().max(updateManagedDocumentCollaborationResponseCrdtStateMax).optional(),
  "stateVector": zod.string().max(updateManagedDocumentCollaborationResponseStateVectorMax).optional(),
  "canEdit": zod.boolean().optional().describe('Whether the signed-in caller may change content in this live session. Viewers join read-only.'),
  "autoVersionLabel": zod.string().max(updateManagedDocumentCollaborationResponseAutoVersionLabelMax).nullish().describe('Label of the automatic version created when the last editor left live editing (null when none was needed).'),
  "peers": zod.array(zod.object({
  "sessionId": zod.uuid(),
  "actorId": zod.uuid(),
  "name": zod.string().max(updateManagedDocumentCollaborationResponsePeersItemNameMax).nullish().describe('Server-resolved display name. Never taken from the client.'),
  "canEdit": zod.boolean().optional().describe('False for people who can only view.'),
  "seenAt": zod.iso.datetime({"offset":true}),
  "cursor": zod.object({
  "anchor": zod.string().max(updateManagedDocumentCollaborationResponsePeersItemCursorAnchorMax),
  "head": zod.string().max(updateManagedDocumentCollaborationResponsePeersItemCursorHeadMax)
}).optional()
})).max(updateManagedDocumentCollaborationResponsePeersMax)
}).describe('Authorized durable collaboration snapshot. CRDT state is compacted without losing operation identity; absent state is legacy semantic mode.')


export const getManagedDocumentEditingReviewParams = zod.object({
  "id": zod.uuid()
})

export const getManagedDocumentEditingReviewQueryLimitDefault = 20;
export const getManagedDocumentEditingReviewQueryLimitMax = 50;

export const getManagedDocumentEditingReviewQueryOffsetDefault = 0;
export const getManagedDocumentEditingReviewQueryOffsetMin = 0;
export const getManagedDocumentEditingReviewQueryOffsetMax = 1000;

export const getManagedDocumentEditingReviewQueryShowResolvedDefault = false;
export const getManagedDocumentEditingReviewQueryShowDecidedDefault = false;

export const getManagedDocumentEditingReviewQueryParams = zod.object({
  "limit": zod.int().min(1).max(getManagedDocumentEditingReviewQueryLimitMax).default(getManagedDocumentEditingReviewQueryLimitDefault),
  "offset": zod.int().min(getManagedDocumentEditingReviewQueryOffsetMin).max(getManagedDocumentEditingReviewQueryOffsetMax).default(getManagedDocumentEditingReviewQueryOffsetDefault),
  "showResolved": zod.boolean().default(getManagedDocumentEditingReviewQueryShowResolvedDefault),
  "showDecided": zod.boolean().default(getManagedDocumentEditingReviewQueryShowDecidedDefault),
  "author": zod.uuid().optional().describe('Show only tracked changes recorded by this person.'),
  "clientRequestId": zod.uuid().optional()
})


export const getManagedDocumentEditingReviewResponseInlineTotalMin = 0;

export const getManagedDocumentEditingReviewResponseThreadsItemAnchorPathItemMin = 0;
export const getManagedDocumentEditingReviewResponseThreadsItemAnchorPathItemMax = 19999;

export const getManagedDocumentEditingReviewResponseThreadsItemAnchorPathMax = 30;

export const getManagedDocumentEditingReviewResponseThreadsItemAnchorEndPathItemMin = 0;
export const getManagedDocumentEditingReviewResponseThreadsItemAnchorEndPathItemMax = 19999;

export const getManagedDocumentEditingReviewResponseThreadsItemAnchorEndPathMax = 30;

export const getManagedDocumentEditingReviewResponseThreadsItemAnchorBlockIndexMin = 0;
export const getManagedDocumentEditingReviewResponseThreadsItemAnchorBlockIndexMax = 19999;

export const getManagedDocumentEditingReviewResponseThreadsItemAnchorFromMin = 0;
export const getManagedDocumentEditingReviewResponseThreadsItemAnchorFromMax = 1000000;

export const getManagedDocumentEditingReviewResponseThreadsItemAnchorToMin = 0;
export const getManagedDocumentEditingReviewResponseThreadsItemAnchorToMax = 1000000;

export const getManagedDocumentEditingReviewResponseThreadsItemAnchorQuoteMax = 2000;

export const getManagedDocumentEditingReviewResponseThreadsItemAnchorContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getManagedDocumentEditingReviewResponseThreadTotalMin = 0;

export const getManagedDocumentEditingReviewResponseChangeTotalMin = 0;

export const getManagedDocumentEditingReviewResponseOpenThreadTotalMin = 0;

export const getManagedDocumentEditingReviewResponsePendingChangeTotalMin = 0;


export const getManagedDocumentEditingReviewResponseOffsetMin = 0;



export const getManagedDocumentEditingReviewResponse = zod.object({
  "revision": zod.int().min(1),
  "tracking": zod.boolean(),
  "appliedRevision": zod.int().nullish(),
  "inlineTotal": zod.int().min(getManagedDocumentEditingReviewResponseInlineTotalMin).optional(),
  "inlineChanges": zod.array(zod.object({
  "id": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "authorName": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['pending', 'accepted', 'rejected']),
  "insertion": zod.string(),
  "deletion": zod.string(),
  "decision": zod.object({
  "id": zod.uuid(),
  "body": zod.string(),
  "authorAppUserId": zod.uuid(),
  "authorName": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "editedAt": zod.iso.datetime({"offset":true}).optional(),
  "deletedAt": zod.iso.datetime({"offset":true}).optional(),
  "canEdit": zod.boolean().optional()
}).optional()
})).optional(),
  "threads": zod.array(zod.object({
  "id": zod.uuid(),
  "anchor": zod.object({
  "path": zod.array(zod.int().min(getManagedDocumentEditingReviewResponseThreadsItemAnchorPathItemMin).max(getManagedDocumentEditingReviewResponseThreadsItemAnchorPathItemMax)).min(1).max(getManagedDocumentEditingReviewResponseThreadsItemAnchorPathMax).optional(),
  "endPath": zod.array(zod.int().min(getManagedDocumentEditingReviewResponseThreadsItemAnchorEndPathItemMin).max(getManagedDocumentEditingReviewResponseThreadsItemAnchorEndPathItemMax)).min(1).max(getManagedDocumentEditingReviewResponseThreadsItemAnchorEndPathMax).optional(),
  "blockIndex": zod.int().min(getManagedDocumentEditingReviewResponseThreadsItemAnchorBlockIndexMin).max(getManagedDocumentEditingReviewResponseThreadsItemAnchorBlockIndexMax),
  "from": zod.int().min(getManagedDocumentEditingReviewResponseThreadsItemAnchorFromMin).max(getManagedDocumentEditingReviewResponseThreadsItemAnchorFromMax),
  "to": zod.int().min(getManagedDocumentEditingReviewResponseThreadsItemAnchorToMin).max(getManagedDocumentEditingReviewResponseThreadsItemAnchorToMax),
  "quote": zod.string().min(1).max(getManagedDocumentEditingReviewResponseThreadsItemAnchorQuoteMax),
  "contentHash": zod.string().regex(getManagedDocumentEditingReviewResponseThreadsItemAnchorContentHashRegExp)
}).describe('Exact immutable content-hash anchor. Offsets alone never authorize relocation after edits.'),
  "attached": zod.boolean(),
  "resolved": zod.boolean(),
  "messages": zod.array(zod.object({
  "id": zod.uuid(),
  "body": zod.string(),
  "authorAppUserId": zod.uuid(),
  "authorName": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "editedAt": zod.iso.datetime({"offset":true}).optional(),
  "deletedAt": zod.iso.datetime({"offset":true}).optional(),
  "canEdit": zod.boolean().optional()
})),
  "events": zod.array(zod.object({
  "id": zod.uuid(),
  "body": zod.string(),
  "authorAppUserId": zod.uuid(),
  "authorName": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "editedAt": zod.iso.datetime({"offset":true}).optional(),
  "deletedAt": zod.iso.datetime({"offset":true}).optional(),
  "canEdit": zod.boolean().optional()
}))
})),
  "changes": zod.array(zod.object({
  "id": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "authorName": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['pending', 'accepted', 'rejected']),
  "beforeText": zod.string(),
  "afterText": zod.string(),
  "canReject": zod.boolean(),
  "decision": zod.object({
  "id": zod.uuid(),
  "body": zod.string(),
  "authorAppUserId": zod.uuid(),
  "authorName": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "editedAt": zod.iso.datetime({"offset":true}).optional(),
  "deletedAt": zod.iso.datetime({"offset":true}).optional(),
  "canEdit": zod.boolean().optional()
}).optional()
})),
  "threadTotal": zod.int().min(getManagedDocumentEditingReviewResponseThreadTotalMin),
  "changeTotal": zod.int().min(getManagedDocumentEditingReviewResponseChangeTotalMin),
  "openThreadTotal": zod.int().min(getManagedDocumentEditingReviewResponseOpenThreadTotalMin).optional().describe('Unresolved comment threads in the whole draft.'),
  "pendingChangeTotal": zod.int().min(getManagedDocumentEditingReviewResponsePendingChangeTotalMin).optional().describe('Undecided tracked changes (edit groups and inline edits) in the whole draft.'),
  "changeAuthors": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().nullable()
})).optional().describe('People who recorded tracked changes, for the per-author filter.'),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getManagedDocumentEditingReviewResponseOffsetMin)
})


export const changeManagedDocumentEditingReviewParams = zod.object({
  "id": zod.uuid()
})

export const changeManagedDocumentEditingReviewBodyExpectedRevisionMax = 2147483646;

export const changeManagedDocumentEditingReviewBodyBodyMax = 4000;

export const changeManagedDocumentEditingReviewBodyAnchorPathItemMin = 0;
export const changeManagedDocumentEditingReviewBodyAnchorPathItemMax = 19999;

export const changeManagedDocumentEditingReviewBodyAnchorPathMax = 30;

export const changeManagedDocumentEditingReviewBodyAnchorEndPathItemMin = 0;
export const changeManagedDocumentEditingReviewBodyAnchorEndPathItemMax = 19999;

export const changeManagedDocumentEditingReviewBodyAnchorEndPathMax = 30;

export const changeManagedDocumentEditingReviewBodyAnchorBlockIndexMin = 0;
export const changeManagedDocumentEditingReviewBodyAnchorBlockIndexMax = 19999;

export const changeManagedDocumentEditingReviewBodyAnchorFromMin = 0;
export const changeManagedDocumentEditingReviewBodyAnchorFromMax = 1000000;

export const changeManagedDocumentEditingReviewBodyAnchorToMin = 0;
export const changeManagedDocumentEditingReviewBodyAnchorToMax = 1000000;

export const changeManagedDocumentEditingReviewBodyAnchorQuoteMax = 2000;

export const changeManagedDocumentEditingReviewBodyAnchorContentHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const changeManagedDocumentEditingReviewBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1).max(changeManagedDocumentEditingReviewBodyExpectedRevisionMax),
  "action": zod.enum(['tracking', 'comment', 'reply', 'edit_comment', 'delete_comment', 'resolve', 'reopen', 'accept', 'reject', 'accept_inline', 'reject_inline']),
  "enabled": zod.boolean().optional(),
  "messageId": zod.uuid().optional(),
  "id": zod.uuid().optional(),
  "all": zod.boolean().optional(),
  "body": zod.string().min(1).max(changeManagedDocumentEditingReviewBodyBodyMax).optional(),
  "anchor": zod.object({
  "path": zod.array(zod.int().min(changeManagedDocumentEditingReviewBodyAnchorPathItemMin).max(changeManagedDocumentEditingReviewBodyAnchorPathItemMax)).min(1).max(changeManagedDocumentEditingReviewBodyAnchorPathMax).optional(),
  "endPath": zod.array(zod.int().min(changeManagedDocumentEditingReviewBodyAnchorEndPathItemMin).max(changeManagedDocumentEditingReviewBodyAnchorEndPathItemMax)).min(1).max(changeManagedDocumentEditingReviewBodyAnchorEndPathMax).optional(),
  "blockIndex": zod.int().min(changeManagedDocumentEditingReviewBodyAnchorBlockIndexMin).max(changeManagedDocumentEditingReviewBodyAnchorBlockIndexMax),
  "from": zod.int().min(changeManagedDocumentEditingReviewBodyAnchorFromMin).max(changeManagedDocumentEditingReviewBodyAnchorFromMax),
  "to": zod.int().min(changeManagedDocumentEditingReviewBodyAnchorToMin).max(changeManagedDocumentEditingReviewBodyAnchorToMax),
  "quote": zod.string().min(1).max(changeManagedDocumentEditingReviewBodyAnchorQuoteMax),
  "contentHash": zod.string().regex(changeManagedDocumentEditingReviewBodyAnchorContentHashRegExp)
}).optional().describe('Exact immutable content-hash anchor. Offsets alone never authorize relocation after edits.')
})

export const changeManagedDocumentEditingReviewResponseSowOneFactsProjectTitleMax = 200;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomerNameMax = 300;

export const changeManagedDocumentEditingReviewResponseSowOneFactsAgreementIdMax = 100;

export const changeManagedDocumentEditingReviewResponseSowOneFactsPreparedDateMax = 40;

export const changeManagedDocumentEditingReviewResponseSowOneFactsStartDateMax = 40;

export const changeManagedDocumentEditingReviewResponseSowOneFactsSprintWeeksMax = 52;

export const changeManagedDocumentEditingReviewResponseSowOneFactsNarrativeItemTextMax = 20000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsNarrativeMax = 5;

export const changeManagedDocumentEditingReviewResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsTablesItemRowsItemMax = 7;

export const changeManagedDocumentEditingReviewResponseSowOneFactsTablesItemRowsMax = 100;

export const changeManagedDocumentEditingReviewResponseSowOneFactsTablesMax = 6;

export const changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemIdMax = 80;

export const changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemTitleMax = 300;

export const changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentMax = 100;

export const changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemIdMax = 80;

export const changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemTitleMax = 300;

export const changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsMax = 100;

export const changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemIdMax = 80;

export const changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemDateMax = 40;

export const changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesMax = 100;

export const changeManagedDocumentEditingReviewResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const changeManagedDocumentEditingReviewResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const changeManagedDocumentEditingReviewResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const changeManagedDocumentEditingReviewResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsUnresolvedFactsMax = 200;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomFieldsMax = 600;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomProseItemTextMax = 20000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomProseMax = 40;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesMax = 40;

export const changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneRevisionsMax = 3;

export const changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderMax = 100;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemTextMax = 200000;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemMarksMax = 20;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterMax = 100;

export const changeManagedDocumentEditingReviewResponseDraftContentSectionsItemsItemTitleMax = 160;

export const changeManagedDocumentEditingReviewResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const changeManagedDocumentEditingReviewResponseDraftContentSectionsItemsMax = 200;

export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsMin = 7;
export const changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsMax = 100;

export const changeManagedDocumentEditingReviewResponseDraftContentTemplateGuidanceMax = 4000;

export const changeManagedDocumentEditingReviewResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const changeManagedDocumentEditingReviewResponseDraftContentTemplateSectionGuidanceMax = 200;

export const changeManagedDocumentEditingReviewResponseDraftContentContentItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseDraftContentContentItemTextMax = 200000;

export const changeManagedDocumentEditingReviewResponseDraftContentContentItemMarksItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseDraftContentContentItemMarksMax = 20;

export const changeManagedDocumentEditingReviewResponseDraftContentContentItemContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseDraftContentContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const changeManagedDocumentEditingReviewResponseVersionsItemMajorVersionMin = 0;

export const changeManagedDocumentEditingReviewResponseVersionsItemMinorVersionMin = 0;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderMax = 100;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterMax = 100;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const changeManagedDocumentEditingReviewResponseVersionsItemContentSectionsItemsMax = 200;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsMin = 7;
export const changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsMax = 100;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemTextMax = 200000;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemMarksMax = 20;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseVersionsItemContentContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const changeManagedDocumentEditingReviewResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(changeManagedDocumentEditingReviewResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsNarrativeItemTextMax)
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsTablesItemRowsItemItemMax)).max(changeManagedDocumentEditingReviewResponseSowOneFactsTablesItemRowsItemMax)).max(changeManagedDocumentEditingReviewResponseSowOneFactsTablesItemRowsMax)
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesItemNotesMax)
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialReviewReasonMin).max(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(changeManagedDocumentEditingReviewResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomProseItemTextMax)
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesItemRowsItemMax)).max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesItemRowsMax)
})).max(changeManagedDocumentEditingReviewResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(changeManagedDocumentEditingReviewResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsTopMin).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsRightMin).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(changeManagedDocumentEditingReviewResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(changeManagedDocumentEditingReviewResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(changeManagedDocumentEditingReviewResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemFontSizeMin).max(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsMin).max(changeManagedDocumentEditingReviewResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(changeManagedDocumentEditingReviewResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(changeManagedDocumentEditingReviewResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(changeManagedDocumentEditingReviewResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentEditingReviewResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentEditingReviewResponseDraftContentContentItemContentMax).optional()
})).max(changeManagedDocumentEditingReviewResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(changeManagedDocumentEditingReviewResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(changeManagedDocumentEditingReviewResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(changeManagedDocumentEditingReviewResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(changeManagedDocumentEditingReviewResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(changeManagedDocumentEditingReviewResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsMin).max(changeManagedDocumentEditingReviewResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(changeManagedDocumentEditingReviewResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(changeManagedDocumentEditingReviewResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(changeManagedDocumentEditingReviewResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentEditingReviewResponseVersionsItemContentContentItemContentMax).optional()
})).max(changeManagedDocumentEditingReviewResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(changeManagedDocumentEditingReviewResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Store a validated private image bound to this exact document
 */
export const uploadManagedDocumentImageParams = zod.object({
  "id": zod.uuid()
})

export const uploadManagedDocumentImageBodyDataBase64Min = 4;
export const uploadManagedDocumentImageBodyDataBase64Max = 2796204;



export const uploadManagedDocumentImageBody = zod.object({
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/gif', 'image/webp']),
  "dataBase64": zod.string().min(uploadManagedDocumentImageBodyDataBase64Min).max(uploadManagedDocumentImageBodyDataBase64Max)
})

export const uploadManagedDocumentImageResponseSrcMax = 200;



export const uploadManagedDocumentImageResponse = zod.object({
  "src": zod.string().max(uploadManagedDocumentImageResponseSrcMax)
})


/**
 * @summary Read a private image under current native document authority
 */
export const downloadManagedDocumentImagePathImageIdMax = 70;


export const downloadManagedDocumentImagePathImageIdRegExp = new RegExp('^[a-f0-9]{64}[.](png|jpeg|gif|webp)$');


export const downloadManagedDocumentImageParams = zod.object({
  "id": zod.uuid(),
  "imageId": zod.string().max(downloadManagedDocumentImagePathImageIdMax).regex(downloadManagedDocumentImagePathImageIdRegExp)
})

export const downloadManagedDocumentImageResponse = zod.unknown()


/**
 * @summary List immutable document versions
 */
export const listManagedDocumentVersionsParams = zod.object({
  "id": zod.uuid()
})

export const listManagedDocumentVersionsQueryLimitDefault = 25;
export const listManagedDocumentVersionsQueryLimitMax = 100;

export const listManagedDocumentVersionsQueryOffsetDefault = 0;
export const listManagedDocumentVersionsQueryOffsetMin = 0;



export const listManagedDocumentVersionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listManagedDocumentVersionsQueryLimitMax).default(listManagedDocumentVersionsQueryLimitDefault),
  "offset": zod.int().min(listManagedDocumentVersionsQueryOffsetMin).default(listManagedDocumentVersionsQueryOffsetDefault)
})

export const listManagedDocumentVersionsHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const listManagedDocumentVersionsHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(listManagedDocumentVersionsHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const listManagedDocumentVersionsResponseItemsItemMajorVersionMin = 0;

export const listManagedDocumentVersionsResponseItemsItemMinorVersionMin = 0;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemTypeMax = 40;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemTextMax = 200000;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemMarksMax = 20;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemContentMax = 10000;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderMax = 100;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemTypeMax = 40;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemTextMax = 200000;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemMarksMax = 20;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemContentMax = 10000;

export const listManagedDocumentVersionsResponseItemsItemContentLayoutFooterMax = 100;

export const listManagedDocumentVersionsResponseItemsItemContentSectionsItemsItemTitleMax = 160;

export const listManagedDocumentVersionsResponseItemsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const listManagedDocumentVersionsResponseItemsItemContentSectionsItemsMax = 200;

export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemNameMax = 80;

export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsMin = 7;
export const listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsMax = 100;

export const listManagedDocumentVersionsResponseItemsItemContentTemplateGuidanceMax = 4000;

export const listManagedDocumentVersionsResponseItemsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const listManagedDocumentVersionsResponseItemsItemContentTemplateSectionGuidanceMax = 200;

export const listManagedDocumentVersionsResponseItemsItemContentContentItemTypeMax = 40;

export const listManagedDocumentVersionsResponseItemsItemContentContentItemTextMax = 200000;

export const listManagedDocumentVersionsResponseItemsItemContentContentItemMarksItemTypeMax = 40;

export const listManagedDocumentVersionsResponseItemsItemContentContentItemMarksMax = 20;

export const listManagedDocumentVersionsResponseItemsItemContentContentItemContentMax = 10000;

export const listManagedDocumentVersionsResponseItemsItemContentContentMax = 10000;

export const listManagedDocumentVersionsResponseTotalMin = 0;


export const listManagedDocumentVersionsResponseOffsetMin = 0;



export const listManagedDocumentVersionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(listManagedDocumentVersionsResponseItemsItemMajorVersionMin),
  "minorVersion": zod.int().min(listManagedDocumentVersionsResponseItemsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsTopMin).max(listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsRightMin).max(listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsBottomMin).max(listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsLeftMin).max(listManagedDocumentVersionsResponseItemsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderItemContentMax).optional()
})).max(listManagedDocumentVersionsResponseItemsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(listManagedDocumentVersionsResponseItemsItemContentLayoutFooterItemContentMax).optional()
})).max(listManagedDocumentVersionsResponseItemsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(listManagedDocumentVersionsResponseItemsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(listManagedDocumentVersionsResponseItemsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(listManagedDocumentVersionsResponseItemsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemFontSizeMin).max(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemSpaceBeforeMin).max(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemSpaceAfterMin).max(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsItemLineHeightMax)
})).min(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsMin).max(listManagedDocumentVersionsResponseItemsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(listManagedDocumentVersionsResponseItemsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(listManagedDocumentVersionsResponseItemsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(listManagedDocumentVersionsResponseItemsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(listManagedDocumentVersionsResponseItemsItemContentContentItemTypeMax),
  "text": zod.string().max(listManagedDocumentVersionsResponseItemsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(listManagedDocumentVersionsResponseItemsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(listManagedDocumentVersionsResponseItemsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(listManagedDocumentVersionsResponseItemsItemContentContentItemContentMax).optional()
})).max(listManagedDocumentVersionsResponseItemsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listManagedDocumentVersionsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listManagedDocumentVersionsResponseOffsetMin)
})


/**
 * @summary Create an immutable minor draft checkpoint
 */
export const checkpointManagedDocumentParams = zod.object({
  "id": zod.uuid()
})

export const checkpointManagedDocumentHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const checkpointManagedDocumentHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(checkpointManagedDocumentHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const checkpointManagedDocumentBodyReasonMax = 2000;



export const checkpointManagedDocumentBody = zod.object({
  "reason": zod.string().min(1).max(checkpointManagedDocumentBodyReasonMax)
})

export const checkpointManagedDocumentResponseMajorVersionMin = 0;

export const checkpointManagedDocumentResponseMinorVersionMin = 0;

export const checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsTopMin = 5;
export const checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsTopMax = 50;

export const checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsRightMin = 5;
export const checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsRightMax = 50;

export const checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsBottomMin = 5;
export const checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsBottomMax = 50;

export const checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsLeftMin = 5;
export const checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsLeftMax = 50;

export const checkpointManagedDocumentResponseContentLayoutHeaderItemTypeMax = 40;

export const checkpointManagedDocumentResponseContentLayoutHeaderItemTextMax = 200000;

export const checkpointManagedDocumentResponseContentLayoutHeaderItemMarksItemTypeMax = 40;

export const checkpointManagedDocumentResponseContentLayoutHeaderItemMarksMax = 20;

export const checkpointManagedDocumentResponseContentLayoutHeaderItemContentMax = 10000;

export const checkpointManagedDocumentResponseContentLayoutHeaderMax = 100;

export const checkpointManagedDocumentResponseContentLayoutFooterItemTypeMax = 40;

export const checkpointManagedDocumentResponseContentLayoutFooterItemTextMax = 200000;

export const checkpointManagedDocumentResponseContentLayoutFooterItemMarksItemTypeMax = 40;

export const checkpointManagedDocumentResponseContentLayoutFooterItemMarksMax = 20;

export const checkpointManagedDocumentResponseContentLayoutFooterItemContentMax = 10000;

export const checkpointManagedDocumentResponseContentLayoutFooterMax = 100;

export const checkpointManagedDocumentResponseContentSectionsItemsItemTitleMax = 160;

export const checkpointManagedDocumentResponseContentSectionsItemsItemAuthoringNotesMax = 4000;


export const checkpointManagedDocumentResponseContentSectionsItemsMax = 200;

export const checkpointManagedDocumentResponseContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const checkpointManagedDocumentResponseContentStylesDefinitionsItemNameMax = 80;

export const checkpointManagedDocumentResponseContentStylesDefinitionsItemFontSizeMin = 6;
export const checkpointManagedDocumentResponseContentStylesDefinitionsItemFontSizeMax = 96;

export const checkpointManagedDocumentResponseContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const checkpointManagedDocumentResponseContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const checkpointManagedDocumentResponseContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const checkpointManagedDocumentResponseContentStylesDefinitionsItemSpaceAfterMin = 0;
export const checkpointManagedDocumentResponseContentStylesDefinitionsItemSpaceAfterMax = 144;

export const checkpointManagedDocumentResponseContentStylesDefinitionsItemLineHeightMax = 3;

export const checkpointManagedDocumentResponseContentStylesDefinitionsMin = 7;
export const checkpointManagedDocumentResponseContentStylesDefinitionsMax = 100;

export const checkpointManagedDocumentResponseContentTemplateGuidanceMax = 4000;

export const checkpointManagedDocumentResponseContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const checkpointManagedDocumentResponseContentTemplateSectionGuidanceMax = 200;

export const checkpointManagedDocumentResponseContentContentItemTypeMax = 40;

export const checkpointManagedDocumentResponseContentContentItemTextMax = 200000;

export const checkpointManagedDocumentResponseContentContentItemMarksItemTypeMax = 40;

export const checkpointManagedDocumentResponseContentContentItemMarksMax = 20;

export const checkpointManagedDocumentResponseContentContentItemContentMax = 10000;

export const checkpointManagedDocumentResponseContentContentMax = 10000;



export const checkpointManagedDocumentResponse = zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(checkpointManagedDocumentResponseMajorVersionMin),
  "minorVersion": zod.int().min(checkpointManagedDocumentResponseMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsTopMin).max(checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsRightMin).max(checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsBottomMin).max(checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsLeftMin).max(checkpointManagedDocumentResponseContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(checkpointManagedDocumentResponseContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(checkpointManagedDocumentResponseContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(checkpointManagedDocumentResponseContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(checkpointManagedDocumentResponseContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(checkpointManagedDocumentResponseContentLayoutHeaderItemContentMax).optional()
})).max(checkpointManagedDocumentResponseContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(checkpointManagedDocumentResponseContentLayoutFooterItemTypeMax),
  "text": zod.string().max(checkpointManagedDocumentResponseContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(checkpointManagedDocumentResponseContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(checkpointManagedDocumentResponseContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(checkpointManagedDocumentResponseContentLayoutFooterItemContentMax).optional()
})).max(checkpointManagedDocumentResponseContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(checkpointManagedDocumentResponseContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(checkpointManagedDocumentResponseContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(checkpointManagedDocumentResponseContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(checkpointManagedDocumentResponseContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(checkpointManagedDocumentResponseContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(checkpointManagedDocumentResponseContentStylesDefinitionsItemFontSizeMin).max(checkpointManagedDocumentResponseContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(checkpointManagedDocumentResponseContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(checkpointManagedDocumentResponseContentStylesDefinitionsItemSpaceBeforeMin).max(checkpointManagedDocumentResponseContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(checkpointManagedDocumentResponseContentStylesDefinitionsItemSpaceAfterMin).max(checkpointManagedDocumentResponseContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(checkpointManagedDocumentResponseContentStylesDefinitionsItemLineHeightMax)
})).min(checkpointManagedDocumentResponseContentStylesDefinitionsMin).max(checkpointManagedDocumentResponseContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(checkpointManagedDocumentResponseContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(checkpointManagedDocumentResponseContentTemplateSectionGuidanceItemGuidanceMax)
})).max(checkpointManagedDocumentResponseContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(checkpointManagedDocumentResponseContentContentItemTypeMax),
  "text": zod.string().max(checkpointManagedDocumentResponseContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(checkpointManagedDocumentResponseContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(checkpointManagedDocumentResponseContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(checkpointManagedDocumentResponseContentContentItemContentMax).optional()
})).max(checkpointManagedDocumentResponseContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * Read-only. Shown before checkpointManagedDocument so the person confirms the version they are about to save; the saved version is then listed and restorable from the document's file library history.
 * @summary Preview the next saved version number and what changed since the latest version
 */
export const previewManagedDocumentVersionParams = zod.object({
  "id": zod.uuid()
})

export const previewManagedDocumentVersionResponseMajorVersionMin = 0;

export const previewManagedDocumentVersionResponseMinorVersionMin = 0;

export const previewManagedDocumentVersionResponseChangedBlocksMin = 0;

export const previewManagedDocumentVersionResponseAddedWordsMin = 0;

export const previewManagedDocumentVersionResponseRemovedWordsMin = 0;




export const previewManagedDocumentVersionResponse = zod.object({
  "nextLabel": zod.string(),
  "majorVersion": zod.int().min(previewManagedDocumentVersionResponseMajorVersionMin),
  "minorVersion": zod.int().min(previewManagedDocumentVersionResponseMinorVersionMin),
  "latestVersionId": zod.uuid().nullable(),
  "latestLabel": zod.string().nullable(),
  "unchanged": zod.boolean().describe('True when the draft matches the latest saved version exactly.'),
  "changedBlocks": zod.int().min(previewManagedDocumentVersionResponseChangedBlocksMin),
  "addedWords": zod.int().min(previewManagedDocumentVersionResponseAddedWordsMin),
  "removedWords": zod.int().min(previewManagedDocumentVersionResponseRemovedWordsMin),
  "revision": zod.int().min(1).describe('Draft revision the preview describes.')
})


/**
 * The style library is shared by everyone who can read entity records. Applying a style copies it into the document, so documents never depend on library rows.
 * @summary Page the entity's reusable named paragraph styles
 */
export const listDocumentStylesQuerySearchMax = 80;

export const listDocumentStylesQueryIncludeArchivedDefault = false;
export const listDocumentStylesQueryLimitDefault = 25;
export const listDocumentStylesQueryLimitMax = 100;

export const listDocumentStylesQueryOffsetDefault = 0;
export const listDocumentStylesQueryOffsetMin = 0;



export const listDocumentStylesQueryParams = zod.object({
  "search": zod.string().max(listDocumentStylesQuerySearchMax).optional(),
  "includeArchived": zod.boolean().default(listDocumentStylesQueryIncludeArchivedDefault),
  "limit": zod.int().min(1).max(listDocumentStylesQueryLimitMax).default(listDocumentStylesQueryLimitDefault),
  "offset": zod.int().min(listDocumentStylesQueryOffsetMin).default(listDocumentStylesQueryOffsetDefault)
})

export const listDocumentStylesResponseItemsItemNameMax = 80;

export const listDocumentStylesResponseItemsItemDefinitionFontSizeMin = 6;
export const listDocumentStylesResponseItemsItemDefinitionFontSizeMax = 96;

export const listDocumentStylesResponseItemsItemDefinitionColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const listDocumentStylesResponseItemsItemDefinitionSpaceBeforeMin = 0;
export const listDocumentStylesResponseItemsItemDefinitionSpaceBeforeMax = 144;

export const listDocumentStylesResponseItemsItemDefinitionSpaceAfterMin = 0;
export const listDocumentStylesResponseItemsItemDefinitionSpaceAfterMax = 144;

export const listDocumentStylesResponseItemsItemDefinitionLineHeightMax = 3;


export const listDocumentStylesResponseTotalMin = 0;


export const listDocumentStylesResponseOffsetMin = 0;



export const listDocumentStylesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(listDocumentStylesResponseItemsItemNameMax),
  "definition": zod.object({
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(listDocumentStylesResponseItemsItemDefinitionFontSizeMin).max(listDocumentStylesResponseItemsItemDefinitionFontSizeMax),
  "color": zod.string().regex(listDocumentStylesResponseItemsItemDefinitionColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(listDocumentStylesResponseItemsItemDefinitionSpaceBeforeMin).max(listDocumentStylesResponseItemsItemDefinitionSpaceBeforeMax),
  "spaceAfter": zod.number().min(listDocumentStylesResponseItemsItemDefinitionSpaceAfterMin).max(listDocumentStylesResponseItemsItemDefinitionSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(listDocumentStylesResponseItemsItemDefinitionLineHeightMax)
}),
  "revision": zod.int().min(1),
  "archived": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listDocumentStylesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listDocumentStylesResponseOffsetMin),
  "canEdit": zod.boolean().describe('Whether the caller may add, change or archive library styles.')
})


/**
 * Requires permission to change entity records. Active style names are unique regardless of letter case.
 * @summary Add a named paragraph style to the entity style library
 */
export const createDocumentStyleBodyNameMax = 80;

export const createDocumentStyleBodyDefinitionFontSizeMin = 6;
export const createDocumentStyleBodyDefinitionFontSizeMax = 96;

export const createDocumentStyleBodyDefinitionColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createDocumentStyleBodyDefinitionSpaceBeforeMin = 0;
export const createDocumentStyleBodyDefinitionSpaceBeforeMax = 144;

export const createDocumentStyleBodyDefinitionSpaceAfterMin = 0;
export const createDocumentStyleBodyDefinitionSpaceAfterMax = 144;

export const createDocumentStyleBodyDefinitionLineHeightMax = 3;



export const createDocumentStyleBody = zod.object({
  "name": zod.string().min(1).max(createDocumentStyleBodyNameMax),
  "definition": zod.object({
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createDocumentStyleBodyDefinitionFontSizeMin).max(createDocumentStyleBodyDefinitionFontSizeMax),
  "color": zod.string().regex(createDocumentStyleBodyDefinitionColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createDocumentStyleBodyDefinitionSpaceBeforeMin).max(createDocumentStyleBodyDefinitionSpaceBeforeMax),
  "spaceAfter": zod.number().min(createDocumentStyleBodyDefinitionSpaceAfterMin).max(createDocumentStyleBodyDefinitionSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createDocumentStyleBodyDefinitionLineHeightMax)
})
})

export const createDocumentStyleResponseNameMax = 80;

export const createDocumentStyleResponseDefinitionFontSizeMin = 6;
export const createDocumentStyleResponseDefinitionFontSizeMax = 96;

export const createDocumentStyleResponseDefinitionColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createDocumentStyleResponseDefinitionSpaceBeforeMin = 0;
export const createDocumentStyleResponseDefinitionSpaceBeforeMax = 144;

export const createDocumentStyleResponseDefinitionSpaceAfterMin = 0;
export const createDocumentStyleResponseDefinitionSpaceAfterMax = 144;

export const createDocumentStyleResponseDefinitionLineHeightMax = 3;




export const createDocumentStyleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(createDocumentStyleResponseNameMax),
  "definition": zod.object({
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createDocumentStyleResponseDefinitionFontSizeMin).max(createDocumentStyleResponseDefinitionFontSizeMax),
  "color": zod.string().regex(createDocumentStyleResponseDefinitionColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createDocumentStyleResponseDefinitionSpaceBeforeMin).max(createDocumentStyleResponseDefinitionSpaceBeforeMax),
  "spaceAfter": zod.number().min(createDocumentStyleResponseDefinitionSpaceAfterMin).max(createDocumentStyleResponseDefinitionSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createDocumentStyleResponseDefinitionLineHeightMax)
}),
  "revision": zod.int().min(1),
  "archived": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Rename or reformat a library style using its reviewed revision
 */
export const updateDocumentStyleParams = zod.object({
  "styleId": zod.uuid()
})


export const updateDocumentStyleBodyNameMax = 80;

export const updateDocumentStyleBodyDefinitionFontSizeMin = 6;
export const updateDocumentStyleBodyDefinitionFontSizeMax = 96;

export const updateDocumentStyleBodyDefinitionColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateDocumentStyleBodyDefinitionSpaceBeforeMin = 0;
export const updateDocumentStyleBodyDefinitionSpaceBeforeMax = 144;

export const updateDocumentStyleBodyDefinitionSpaceAfterMin = 0;
export const updateDocumentStyleBodyDefinitionSpaceAfterMax = 144;

export const updateDocumentStyleBodyDefinitionLineHeightMax = 3;



export const updateDocumentStyleBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "name": zod.string().min(1).max(updateDocumentStyleBodyNameMax).optional(),
  "definition": zod.object({
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(updateDocumentStyleBodyDefinitionFontSizeMin).max(updateDocumentStyleBodyDefinitionFontSizeMax),
  "color": zod.string().regex(updateDocumentStyleBodyDefinitionColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(updateDocumentStyleBodyDefinitionSpaceBeforeMin).max(updateDocumentStyleBodyDefinitionSpaceBeforeMax),
  "spaceAfter": zod.number().min(updateDocumentStyleBodyDefinitionSpaceAfterMin).max(updateDocumentStyleBodyDefinitionSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(updateDocumentStyleBodyDefinitionLineHeightMax)
}).optional()
})

export const updateDocumentStyleResponseNameMax = 80;

export const updateDocumentStyleResponseDefinitionFontSizeMin = 6;
export const updateDocumentStyleResponseDefinitionFontSizeMax = 96;

export const updateDocumentStyleResponseDefinitionColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateDocumentStyleResponseDefinitionSpaceBeforeMin = 0;
export const updateDocumentStyleResponseDefinitionSpaceBeforeMax = 144;

export const updateDocumentStyleResponseDefinitionSpaceAfterMin = 0;
export const updateDocumentStyleResponseDefinitionSpaceAfterMax = 144;

export const updateDocumentStyleResponseDefinitionLineHeightMax = 3;




export const updateDocumentStyleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(updateDocumentStyleResponseNameMax),
  "definition": zod.object({
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(updateDocumentStyleResponseDefinitionFontSizeMin).max(updateDocumentStyleResponseDefinitionFontSizeMax),
  "color": zod.string().regex(updateDocumentStyleResponseDefinitionColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(updateDocumentStyleResponseDefinitionSpaceBeforeMin).max(updateDocumentStyleResponseDefinitionSpaceBeforeMax),
  "spaceAfter": zod.number().min(updateDocumentStyleResponseDefinitionSpaceAfterMin).max(updateDocumentStyleResponseDefinitionSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(updateDocumentStyleResponseDefinitionLineHeightMax)
}),
  "revision": zod.int().min(1),
  "archived": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Withdraw a library style; documents that already use it keep their copy
 */
export const archiveDocumentStyleParams = zod.object({
  "styleId": zod.uuid()
})




export const archiveDocumentStyleBody = zod.object({
  "expectedRevision": zod.int().min(1)
})

export const archiveDocumentStyleResponseNameMax = 80;

export const archiveDocumentStyleResponseDefinitionFontSizeMin = 6;
export const archiveDocumentStyleResponseDefinitionFontSizeMax = 96;

export const archiveDocumentStyleResponseDefinitionColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const archiveDocumentStyleResponseDefinitionSpaceBeforeMin = 0;
export const archiveDocumentStyleResponseDefinitionSpaceBeforeMax = 144;

export const archiveDocumentStyleResponseDefinitionSpaceAfterMin = 0;
export const archiveDocumentStyleResponseDefinitionSpaceAfterMax = 144;

export const archiveDocumentStyleResponseDefinitionLineHeightMax = 3;




export const archiveDocumentStyleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(archiveDocumentStyleResponseNameMax),
  "definition": zod.object({
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(archiveDocumentStyleResponseDefinitionFontSizeMin).max(archiveDocumentStyleResponseDefinitionFontSizeMax),
  "color": zod.string().regex(archiveDocumentStyleResponseDefinitionColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(archiveDocumentStyleResponseDefinitionSpaceBeforeMin).max(archiveDocumentStyleResponseDefinitionSpaceBeforeMax),
  "spaceAfter": zod.number().min(archiveDocumentStyleResponseDefinitionSpaceAfterMin).max(archiveDocumentStyleResponseDefinitionSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(archiveDocumentStyleResponseDefinitionLineHeightMax)
}),
  "revision": zod.int().min(1),
  "archived": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Named style templates shared across the entity, newest first
 */
export const listDocumentStyleTemplatesQuerySearchMax = 80;

export const listDocumentStyleTemplatesQueryLimitDefault = 10;
export const listDocumentStyleTemplatesQueryLimitMax = 50;

export const listDocumentStyleTemplatesQueryOffsetDefault = 0;
export const listDocumentStyleTemplatesQueryOffsetMin = 0;
export const listDocumentStyleTemplatesQueryOffsetMax = 10000;



export const listDocumentStyleTemplatesQueryParams = zod.object({
  "search": zod.string().max(listDocumentStyleTemplatesQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listDocumentStyleTemplatesQueryLimitMax).default(listDocumentStyleTemplatesQueryLimitDefault),
  "offset": zod.int().min(listDocumentStyleTemplatesQueryOffsetMin).max(listDocumentStyleTemplatesQueryOffsetMax).default(listDocumentStyleTemplatesQueryOffsetDefault)
})

export const listDocumentStyleTemplatesResponseItemsItemNameMax = 80;

export const listDocumentStyleTemplatesResponseItemsItemDescriptionMax = 500;

export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemNameMax = 80;

export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemFontSizeMin = 6;
export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemFontSizeMax = 96;

export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemSpaceBeforeMin = 0;
export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemSpaceBeforeMax = 144;

export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemSpaceAfterMin = 0;
export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemSpaceAfterMax = 144;

export const listDocumentStyleTemplatesResponseItemsItemDefinitionsItemLineHeightMax = 3;

export const listDocumentStyleTemplatesResponseItemsItemDefinitionsMin = 7;
export const listDocumentStyleTemplatesResponseItemsItemDefinitionsMax = 100;


export const listDocumentStyleTemplatesResponseTotalMin = 0;


export const listDocumentStyleTemplatesResponseOffsetMin = 0;



export const listDocumentStyleTemplatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(listDocumentStyleTemplatesResponseItemsItemNameMax),
  "description": zod.string().max(listDocumentStyleTemplatesResponseItemsItemDescriptionMax),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemFontSizeMin).max(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemFontSizeMax),
  "color": zod.string().regex(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemSpaceBeforeMin).max(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemSpaceAfterMin).max(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(listDocumentStyleTemplatesResponseItemsItemDefinitionsItemLineHeightMax)
})).min(listDocumentStyleTemplatesResponseItemsItemDefinitionsMin).max(listDocumentStyleTemplatesResponseItemsItemDefinitionsMax),
  "revision": zod.int().min(1),
  "archived": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listDocumentStyleTemplatesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listDocumentStyleTemplatesResponseOffsetMin),
  "canEdit": zod.boolean().describe('Whether the caller may add, change or archive style templates.')
})


/**
 * @summary Save a document's named styles as a reusable template
 */
export const createDocumentStyleTemplateBodyNameMax = 80;

export const createDocumentStyleTemplateBodyDescriptionMax = 500;

export const createDocumentStyleTemplateBodyDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createDocumentStyleTemplateBodyDefinitionsItemNameMax = 80;

export const createDocumentStyleTemplateBodyDefinitionsItemFontSizeMin = 6;
export const createDocumentStyleTemplateBodyDefinitionsItemFontSizeMax = 96;

export const createDocumentStyleTemplateBodyDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createDocumentStyleTemplateBodyDefinitionsItemSpaceBeforeMin = 0;
export const createDocumentStyleTemplateBodyDefinitionsItemSpaceBeforeMax = 144;

export const createDocumentStyleTemplateBodyDefinitionsItemSpaceAfterMin = 0;
export const createDocumentStyleTemplateBodyDefinitionsItemSpaceAfterMax = 144;

export const createDocumentStyleTemplateBodyDefinitionsItemLineHeightMax = 3;

export const createDocumentStyleTemplateBodyDefinitionsMin = 7;
export const createDocumentStyleTemplateBodyDefinitionsMax = 100;



export const createDocumentStyleTemplateBody = zod.object({
  "name": zod.string().min(1).max(createDocumentStyleTemplateBodyNameMax),
  "description": zod.string().max(createDocumentStyleTemplateBodyDescriptionMax).optional(),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createDocumentStyleTemplateBodyDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createDocumentStyleTemplateBodyDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createDocumentStyleTemplateBodyDefinitionsItemFontSizeMin).max(createDocumentStyleTemplateBodyDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createDocumentStyleTemplateBodyDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createDocumentStyleTemplateBodyDefinitionsItemSpaceBeforeMin).max(createDocumentStyleTemplateBodyDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createDocumentStyleTemplateBodyDefinitionsItemSpaceAfterMin).max(createDocumentStyleTemplateBodyDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createDocumentStyleTemplateBodyDefinitionsItemLineHeightMax)
})).min(createDocumentStyleTemplateBodyDefinitionsMin).max(createDocumentStyleTemplateBodyDefinitionsMax)
})

export const createDocumentStyleTemplateResponseNameMax = 80;

export const createDocumentStyleTemplateResponseDescriptionMax = 500;

export const createDocumentStyleTemplateResponseDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createDocumentStyleTemplateResponseDefinitionsItemNameMax = 80;

export const createDocumentStyleTemplateResponseDefinitionsItemFontSizeMin = 6;
export const createDocumentStyleTemplateResponseDefinitionsItemFontSizeMax = 96;

export const createDocumentStyleTemplateResponseDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMin = 0;
export const createDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMax = 144;

export const createDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMin = 0;
export const createDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMax = 144;

export const createDocumentStyleTemplateResponseDefinitionsItemLineHeightMax = 3;

export const createDocumentStyleTemplateResponseDefinitionsMin = 7;
export const createDocumentStyleTemplateResponseDefinitionsMax = 100;




export const createDocumentStyleTemplateResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(createDocumentStyleTemplateResponseNameMax),
  "description": zod.string().max(createDocumentStyleTemplateResponseDescriptionMax),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createDocumentStyleTemplateResponseDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createDocumentStyleTemplateResponseDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createDocumentStyleTemplateResponseDefinitionsItemFontSizeMin).max(createDocumentStyleTemplateResponseDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createDocumentStyleTemplateResponseDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMin).max(createDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMin).max(createDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createDocumentStyleTemplateResponseDefinitionsItemLineHeightMax)
})).min(createDocumentStyleTemplateResponseDefinitionsMin).max(createDocumentStyleTemplateResponseDefinitionsMax),
  "revision": zod.int().min(1),
  "archived": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Rename or replace a style template using its reviewed revision
 */
export const updateDocumentStyleTemplateParams = zod.object({
  "templateId": zod.uuid()
})


export const updateDocumentStyleTemplateBodyNameMax = 80;

export const updateDocumentStyleTemplateBodyDescriptionMax = 500;

export const updateDocumentStyleTemplateBodyDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const updateDocumentStyleTemplateBodyDefinitionsItemNameMax = 80;

export const updateDocumentStyleTemplateBodyDefinitionsItemFontSizeMin = 6;
export const updateDocumentStyleTemplateBodyDefinitionsItemFontSizeMax = 96;

export const updateDocumentStyleTemplateBodyDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateDocumentStyleTemplateBodyDefinitionsItemSpaceBeforeMin = 0;
export const updateDocumentStyleTemplateBodyDefinitionsItemSpaceBeforeMax = 144;

export const updateDocumentStyleTemplateBodyDefinitionsItemSpaceAfterMin = 0;
export const updateDocumentStyleTemplateBodyDefinitionsItemSpaceAfterMax = 144;

export const updateDocumentStyleTemplateBodyDefinitionsItemLineHeightMax = 3;

export const updateDocumentStyleTemplateBodyDefinitionsMin = 7;
export const updateDocumentStyleTemplateBodyDefinitionsMax = 100;



export const updateDocumentStyleTemplateBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "name": zod.string().min(1).max(updateDocumentStyleTemplateBodyNameMax).optional(),
  "description": zod.string().max(updateDocumentStyleTemplateBodyDescriptionMax).optional(),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(updateDocumentStyleTemplateBodyDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(updateDocumentStyleTemplateBodyDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(updateDocumentStyleTemplateBodyDefinitionsItemFontSizeMin).max(updateDocumentStyleTemplateBodyDefinitionsItemFontSizeMax),
  "color": zod.string().regex(updateDocumentStyleTemplateBodyDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(updateDocumentStyleTemplateBodyDefinitionsItemSpaceBeforeMin).max(updateDocumentStyleTemplateBodyDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(updateDocumentStyleTemplateBodyDefinitionsItemSpaceAfterMin).max(updateDocumentStyleTemplateBodyDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(updateDocumentStyleTemplateBodyDefinitionsItemLineHeightMax)
})).min(updateDocumentStyleTemplateBodyDefinitionsMin).max(updateDocumentStyleTemplateBodyDefinitionsMax).optional()
})

export const updateDocumentStyleTemplateResponseNameMax = 80;

export const updateDocumentStyleTemplateResponseDescriptionMax = 500;

export const updateDocumentStyleTemplateResponseDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const updateDocumentStyleTemplateResponseDefinitionsItemNameMax = 80;

export const updateDocumentStyleTemplateResponseDefinitionsItemFontSizeMin = 6;
export const updateDocumentStyleTemplateResponseDefinitionsItemFontSizeMax = 96;

export const updateDocumentStyleTemplateResponseDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMin = 0;
export const updateDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMax = 144;

export const updateDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMin = 0;
export const updateDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMax = 144;

export const updateDocumentStyleTemplateResponseDefinitionsItemLineHeightMax = 3;

export const updateDocumentStyleTemplateResponseDefinitionsMin = 7;
export const updateDocumentStyleTemplateResponseDefinitionsMax = 100;




export const updateDocumentStyleTemplateResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(updateDocumentStyleTemplateResponseNameMax),
  "description": zod.string().max(updateDocumentStyleTemplateResponseDescriptionMax),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(updateDocumentStyleTemplateResponseDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(updateDocumentStyleTemplateResponseDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(updateDocumentStyleTemplateResponseDefinitionsItemFontSizeMin).max(updateDocumentStyleTemplateResponseDefinitionsItemFontSizeMax),
  "color": zod.string().regex(updateDocumentStyleTemplateResponseDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(updateDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMin).max(updateDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(updateDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMin).max(updateDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(updateDocumentStyleTemplateResponseDefinitionsItemLineHeightMax)
})).min(updateDocumentStyleTemplateResponseDefinitionsMin).max(updateDocumentStyleTemplateResponseDefinitionsMax),
  "revision": zod.int().min(1),
  "archived": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Withdraw a style template; documents that applied it keep their copy
 */
export const archiveDocumentStyleTemplateParams = zod.object({
  "templateId": zod.uuid()
})




export const archiveDocumentStyleTemplateBody = zod.object({
  "expectedRevision": zod.int().min(1)
})

export const archiveDocumentStyleTemplateResponseNameMax = 80;

export const archiveDocumentStyleTemplateResponseDescriptionMax = 500;

export const archiveDocumentStyleTemplateResponseDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const archiveDocumentStyleTemplateResponseDefinitionsItemNameMax = 80;

export const archiveDocumentStyleTemplateResponseDefinitionsItemFontSizeMin = 6;
export const archiveDocumentStyleTemplateResponseDefinitionsItemFontSizeMax = 96;

export const archiveDocumentStyleTemplateResponseDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const archiveDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMin = 0;
export const archiveDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMax = 144;

export const archiveDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMin = 0;
export const archiveDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMax = 144;

export const archiveDocumentStyleTemplateResponseDefinitionsItemLineHeightMax = 3;

export const archiveDocumentStyleTemplateResponseDefinitionsMin = 7;
export const archiveDocumentStyleTemplateResponseDefinitionsMax = 100;




export const archiveDocumentStyleTemplateResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(archiveDocumentStyleTemplateResponseNameMax),
  "description": zod.string().max(archiveDocumentStyleTemplateResponseDescriptionMax),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(archiveDocumentStyleTemplateResponseDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(archiveDocumentStyleTemplateResponseDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(archiveDocumentStyleTemplateResponseDefinitionsItemFontSizeMin).max(archiveDocumentStyleTemplateResponseDefinitionsItemFontSizeMax),
  "color": zod.string().regex(archiveDocumentStyleTemplateResponseDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(archiveDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMin).max(archiveDocumentStyleTemplateResponseDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(archiveDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMin).max(archiveDocumentStyleTemplateResponseDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(archiveDocumentStyleTemplateResponseDefinitionsItemLineHeightMax)
})).min(archiveDocumentStyleTemplateResponseDefinitionsMin).max(archiveDocumentStyleTemplateResponseDefinitionsMax),
  "revision": zod.int().min(1),
  "archived": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Managed documents that author Content Hub assets or microsite rich-content blocks
 */
export const listContentDocumentBindingsQueryComponentIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,120}$');
export const listContentDocumentBindingsQueryLimitDefault = 25;
export const listContentDocumentBindingsQueryLimitMax = 100;

export const listContentDocumentBindingsQueryOffsetDefault = 0;
export const listContentDocumentBindingsQueryOffsetMin = 0;
export const listContentDocumentBindingsQueryOffsetMax = 10000;



export const listContentDocumentBindingsQueryParams = zod.object({
  "targetKind": zod.enum(['content_hub_asset', 'microsite_rich_content']).optional(),
  "assetId": zod.uuid().optional(),
  "componentId": zod.string().regex(listContentDocumentBindingsQueryComponentIdRegExp).optional(),
  "documentId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listContentDocumentBindingsQueryLimitMax).default(listContentDocumentBindingsQueryLimitDefault),
  "offset": zod.int().min(listContentDocumentBindingsQueryOffsetMin).max(listContentDocumentBindingsQueryOffsetMax).default(listContentDocumentBindingsQueryOffsetDefault)
})

export const listContentDocumentBindingsResponseTotalMin = 0;


export const listContentDocumentBindingsResponseOffsetMin = 0;



export const listContentDocumentBindingsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "documentTitle": zod.string(),
  "targetKind": zod.enum(['content_hub_asset', 'microsite_rich_content']),
  "assetId": zod.uuid().nullable(),
  "componentId": zod.string().nullable(),
  "lastAppliedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "created": zod.boolean().describe('True when this request created the authoring document.')
})),
  "total": zod.int().min(listContentDocumentBindingsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentDocumentBindingsResponseOffsetMin)
})


/**
 * Returns the existing authoring document, or creates one from the target's current content. The target itself is unchanged.
 * @summary Open a Content Hub asset or microsite rich-content block in the rich document editor
 */
export const openContentDocumentBodyTargetTwoComponentIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,120}$');
export const openContentDocumentBodyInitialContentLayoutPageSettingsMarginsTopMin = 5;
export const openContentDocumentBodyInitialContentLayoutPageSettingsMarginsTopMax = 50;

export const openContentDocumentBodyInitialContentLayoutPageSettingsMarginsRightMin = 5;
export const openContentDocumentBodyInitialContentLayoutPageSettingsMarginsRightMax = 50;

export const openContentDocumentBodyInitialContentLayoutPageSettingsMarginsBottomMin = 5;
export const openContentDocumentBodyInitialContentLayoutPageSettingsMarginsBottomMax = 50;

export const openContentDocumentBodyInitialContentLayoutPageSettingsMarginsLeftMin = 5;
export const openContentDocumentBodyInitialContentLayoutPageSettingsMarginsLeftMax = 50;

export const openContentDocumentBodyInitialContentLayoutHeaderItemTypeMax = 40;

export const openContentDocumentBodyInitialContentLayoutHeaderItemTextMax = 200000;

export const openContentDocumentBodyInitialContentLayoutHeaderItemMarksItemTypeMax = 40;

export const openContentDocumentBodyInitialContentLayoutHeaderItemMarksMax = 20;

export const openContentDocumentBodyInitialContentLayoutHeaderItemContentMax = 10000;

export const openContentDocumentBodyInitialContentLayoutHeaderMax = 100;

export const openContentDocumentBodyInitialContentLayoutFooterItemTypeMax = 40;

export const openContentDocumentBodyInitialContentLayoutFooterItemTextMax = 200000;

export const openContentDocumentBodyInitialContentLayoutFooterItemMarksItemTypeMax = 40;

export const openContentDocumentBodyInitialContentLayoutFooterItemMarksMax = 20;

export const openContentDocumentBodyInitialContentLayoutFooterItemContentMax = 10000;

export const openContentDocumentBodyInitialContentLayoutFooterMax = 100;

export const openContentDocumentBodyInitialContentSectionsItemsItemTitleMax = 160;

export const openContentDocumentBodyInitialContentSectionsItemsItemAuthoringNotesMax = 4000;


export const openContentDocumentBodyInitialContentSectionsItemsMax = 200;

export const openContentDocumentBodyInitialContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const openContentDocumentBodyInitialContentStylesDefinitionsItemNameMax = 80;

export const openContentDocumentBodyInitialContentStylesDefinitionsItemFontSizeMin = 6;
export const openContentDocumentBodyInitialContentStylesDefinitionsItemFontSizeMax = 96;

export const openContentDocumentBodyInitialContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const openContentDocumentBodyInitialContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const openContentDocumentBodyInitialContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const openContentDocumentBodyInitialContentStylesDefinitionsItemSpaceAfterMin = 0;
export const openContentDocumentBodyInitialContentStylesDefinitionsItemSpaceAfterMax = 144;

export const openContentDocumentBodyInitialContentStylesDefinitionsItemLineHeightMax = 3;

export const openContentDocumentBodyInitialContentStylesDefinitionsMin = 7;
export const openContentDocumentBodyInitialContentStylesDefinitionsMax = 100;

export const openContentDocumentBodyInitialContentTemplateGuidanceMax = 4000;

export const openContentDocumentBodyInitialContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const openContentDocumentBodyInitialContentTemplateSectionGuidanceMax = 200;

export const openContentDocumentBodyInitialContentContentItemTypeMax = 40;

export const openContentDocumentBodyInitialContentContentItemTextMax = 200000;

export const openContentDocumentBodyInitialContentContentItemMarksItemTypeMax = 40;

export const openContentDocumentBodyInitialContentContentItemMarksMax = 20;

export const openContentDocumentBodyInitialContentContentItemContentMax = 10000;

export const openContentDocumentBodyInitialContentContentMax = 10000;



export const openContentDocumentBody = zod.object({
  "target": zod.union([zod.object({
  "kind": zod.enum(['content_hub_asset']),
  "assetId": zod.uuid()
}),zod.object({
  "kind": zod.enum(['microsite_rich_content']),
  "componentId": zod.string().regex(openContentDocumentBodyTargetTwoComponentIdRegExp)
})]),
  "initialContent": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(openContentDocumentBodyInitialContentLayoutPageSettingsMarginsTopMin).max(openContentDocumentBodyInitialContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(openContentDocumentBodyInitialContentLayoutPageSettingsMarginsRightMin).max(openContentDocumentBodyInitialContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(openContentDocumentBodyInitialContentLayoutPageSettingsMarginsBottomMin).max(openContentDocumentBodyInitialContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(openContentDocumentBodyInitialContentLayoutPageSettingsMarginsLeftMin).max(openContentDocumentBodyInitialContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(openContentDocumentBodyInitialContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(openContentDocumentBodyInitialContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(openContentDocumentBodyInitialContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(openContentDocumentBodyInitialContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(openContentDocumentBodyInitialContentLayoutHeaderItemContentMax).optional()
})).max(openContentDocumentBodyInitialContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(openContentDocumentBodyInitialContentLayoutFooterItemTypeMax),
  "text": zod.string().max(openContentDocumentBodyInitialContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(openContentDocumentBodyInitialContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(openContentDocumentBodyInitialContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(openContentDocumentBodyInitialContentLayoutFooterItemContentMax).optional()
})).max(openContentDocumentBodyInitialContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(openContentDocumentBodyInitialContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(openContentDocumentBodyInitialContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(openContentDocumentBodyInitialContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(openContentDocumentBodyInitialContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(openContentDocumentBodyInitialContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(openContentDocumentBodyInitialContentStylesDefinitionsItemFontSizeMin).max(openContentDocumentBodyInitialContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(openContentDocumentBodyInitialContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(openContentDocumentBodyInitialContentStylesDefinitionsItemSpaceBeforeMin).max(openContentDocumentBodyInitialContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(openContentDocumentBodyInitialContentStylesDefinitionsItemSpaceAfterMin).max(openContentDocumentBodyInitialContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(openContentDocumentBodyInitialContentStylesDefinitionsItemLineHeightMax)
})).min(openContentDocumentBodyInitialContentStylesDefinitionsMin).max(openContentDocumentBodyInitialContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(openContentDocumentBodyInitialContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(openContentDocumentBodyInitialContentTemplateSectionGuidanceItemGuidanceMax)
})).max(openContentDocumentBodyInitialContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(openContentDocumentBodyInitialContentContentItemTypeMax),
  "text": zod.string().max(openContentDocumentBodyInitialContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(openContentDocumentBodyInitialContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(openContentDocumentBodyInitialContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(openContentDocumentBodyInitialContentContentItemContentMax).optional()
})).max(openContentDocumentBodyInitialContentContentMax)
}).optional().describe('Microsite blocks only. The editor\'s reading of the block\'s current HTML; ignored when a document already exists.')
})

export const openContentDocumentResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "documentTitle": zod.string(),
  "targetKind": zod.enum(['content_hub_asset', 'microsite_rich_content']),
  "assetId": zod.uuid().nullable(),
  "componentId": zod.string().nullable(),
  "lastAppliedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "created": zod.boolean().describe('True when this request created the authoring document.')
})


/**
 * Content Hub assets receive Markdown and return to draft for review; microsite blocks receive sanitized HTML in the draft. Publishing stays a separate step.
 * @summary Write the authoring document back to its target as a new draft
 */
export const applyContentDocumentParams = zod.object({
  "bindingId": zod.uuid()
})

export const applyContentDocumentBodyExpectedTargetRevisionMin = 0;



export const applyContentDocumentBody = zod.object({
  "expectedTargetRevision": zod.int().min(applyContentDocumentBodyExpectedTargetRevisionMin).describe('Content Hub asset version or microsite draft revision the person reviewed.')
})

export const applyContentDocumentResponseTargetRevisionMin = 0;



export const applyContentDocumentResponse = zod.object({
  "binding": zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "documentTitle": zod.string(),
  "targetKind": zod.enum(['content_hub_asset', 'microsite_rich_content']),
  "assetId": zod.uuid().nullable(),
  "componentId": zod.string().nullable(),
  "lastAppliedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "created": zod.boolean().describe('True when this request created the authoring document.')
}),
  "outcome": zod.enum(['applied', 'unchanged']),
  "targetRevision": zod.int().min(applyContentDocumentResponseTargetRevisionMin)
})


/**
 * Writes nothing to any document. The proposal is private to the requester; the person reviews the tidied text and inserts it through the editor's normal save. A requestId replay returns the original proposal.
 * @summary Ask AI to tidy dictated text into a proposal for review
 */
export const createTranscriptCleanupBodyTranscriptMax = 20000;



export const createTranscriptCleanupBody = zod.object({
  "requestId": zod.uuid(),
  "transcript": zod.string().min(1).max(createTranscriptCleanupBodyTranscriptMax),
  "documentId": zod.uuid().optional().describe('Optional managed document the text is intended for; read permission is checked.')
})

export const createTranscriptCleanupResponse = zod.object({
  "id": zod.uuid(),
  "original": zod.string(),
  "cleaned": zod.string(),
  "status": zod.enum(['proposed', 'applied', 'discarded']),
  "documentId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Record whether the requester inserted or discarded a clean-up proposal
 */
export const decideTranscriptCleanupParams = zod.object({
  "cleanupId": zod.uuid()
})

export const decideTranscriptCleanupBody = zod.object({
  "decision": zod.enum(['applied', 'discarded'])
})

export const decideTranscriptCleanupResponse = zod.object({
  "id": zod.uuid(),
  "original": zod.string(),
  "cleaned": zod.string(),
  "status": zod.enum(['proposed', 'applied', 'discarded']),
  "documentId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Read one exact authorized immutable snapshot
 */
export const getManagedDocumentVersionParams = zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid()
})

export const getManagedDocumentVersionResponseMajorVersionMin = 0;

export const getManagedDocumentVersionResponseMinorVersionMin = 0;

export const getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsTopMin = 5;
export const getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsTopMax = 50;

export const getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsRightMin = 5;
export const getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsRightMax = 50;

export const getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsBottomMin = 5;
export const getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsBottomMax = 50;

export const getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsLeftMin = 5;
export const getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsLeftMax = 50;

export const getManagedDocumentVersionResponseContentLayoutHeaderItemTypeMax = 40;

export const getManagedDocumentVersionResponseContentLayoutHeaderItemTextMax = 200000;

export const getManagedDocumentVersionResponseContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getManagedDocumentVersionResponseContentLayoutHeaderItemMarksMax = 20;

export const getManagedDocumentVersionResponseContentLayoutHeaderItemContentMax = 10000;

export const getManagedDocumentVersionResponseContentLayoutHeaderMax = 100;

export const getManagedDocumentVersionResponseContentLayoutFooterItemTypeMax = 40;

export const getManagedDocumentVersionResponseContentLayoutFooterItemTextMax = 200000;

export const getManagedDocumentVersionResponseContentLayoutFooterItemMarksItemTypeMax = 40;

export const getManagedDocumentVersionResponseContentLayoutFooterItemMarksMax = 20;

export const getManagedDocumentVersionResponseContentLayoutFooterItemContentMax = 10000;

export const getManagedDocumentVersionResponseContentLayoutFooterMax = 100;

export const getManagedDocumentVersionResponseContentSectionsItemsItemTitleMax = 160;

export const getManagedDocumentVersionResponseContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getManagedDocumentVersionResponseContentSectionsItemsMax = 200;

export const getManagedDocumentVersionResponseContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getManagedDocumentVersionResponseContentStylesDefinitionsItemNameMax = 80;

export const getManagedDocumentVersionResponseContentStylesDefinitionsItemFontSizeMin = 6;
export const getManagedDocumentVersionResponseContentStylesDefinitionsItemFontSizeMax = 96;

export const getManagedDocumentVersionResponseContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getManagedDocumentVersionResponseContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getManagedDocumentVersionResponseContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getManagedDocumentVersionResponseContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getManagedDocumentVersionResponseContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getManagedDocumentVersionResponseContentStylesDefinitionsItemLineHeightMax = 3;

export const getManagedDocumentVersionResponseContentStylesDefinitionsMin = 7;
export const getManagedDocumentVersionResponseContentStylesDefinitionsMax = 100;

export const getManagedDocumentVersionResponseContentTemplateGuidanceMax = 4000;

export const getManagedDocumentVersionResponseContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getManagedDocumentVersionResponseContentTemplateSectionGuidanceMax = 200;

export const getManagedDocumentVersionResponseContentContentItemTypeMax = 40;

export const getManagedDocumentVersionResponseContentContentItemTextMax = 200000;

export const getManagedDocumentVersionResponseContentContentItemMarksItemTypeMax = 40;

export const getManagedDocumentVersionResponseContentContentItemMarksMax = 20;

export const getManagedDocumentVersionResponseContentContentItemContentMax = 10000;

export const getManagedDocumentVersionResponseContentContentMax = 10000;



export const getManagedDocumentVersionResponse = zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(getManagedDocumentVersionResponseMajorVersionMin),
  "minorVersion": zod.int().min(getManagedDocumentVersionResponseMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsTopMin).max(getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsRightMin).max(getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsBottomMin).max(getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsLeftMin).max(getManagedDocumentVersionResponseContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentVersionResponseContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getManagedDocumentVersionResponseContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentVersionResponseContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentVersionResponseContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentVersionResponseContentLayoutHeaderItemContentMax).optional()
})).max(getManagedDocumentVersionResponseContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentVersionResponseContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getManagedDocumentVersionResponseContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentVersionResponseContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentVersionResponseContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentVersionResponseContentLayoutFooterItemContentMax).optional()
})).max(getManagedDocumentVersionResponseContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getManagedDocumentVersionResponseContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getManagedDocumentVersionResponseContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getManagedDocumentVersionResponseContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getManagedDocumentVersionResponseContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getManagedDocumentVersionResponseContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getManagedDocumentVersionResponseContentStylesDefinitionsItemFontSizeMin).max(getManagedDocumentVersionResponseContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getManagedDocumentVersionResponseContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getManagedDocumentVersionResponseContentStylesDefinitionsItemSpaceBeforeMin).max(getManagedDocumentVersionResponseContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getManagedDocumentVersionResponseContentStylesDefinitionsItemSpaceAfterMin).max(getManagedDocumentVersionResponseContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getManagedDocumentVersionResponseContentStylesDefinitionsItemLineHeightMax)
})).min(getManagedDocumentVersionResponseContentStylesDefinitionsMin).max(getManagedDocumentVersionResponseContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getManagedDocumentVersionResponseContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getManagedDocumentVersionResponseContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getManagedDocumentVersionResponseContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentVersionResponseContentContentItemTypeMax),
  "text": zod.string().max(getManagedDocumentVersionResponseContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getManagedDocumentVersionResponseContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getManagedDocumentVersionResponseContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getManagedDocumentVersionResponseContentContentItemContentMax).optional()
})).max(getManagedDocumentVersionResponseContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Restore a historical snapshot into a new draft using the reviewed current revision
 */
export const restoreManagedDocumentVersionParams = zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid()
})

export const restoreManagedDocumentVersionHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const restoreManagedDocumentVersionHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(restoreManagedDocumentVersionHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const restoreManagedDocumentVersionBodyReasonMax = 2000;




export const restoreManagedDocumentVersionBody = zod.object({
  "reason": zod.string().min(1).max(restoreManagedDocumentVersionBodyReasonMax),
  "expectedRevision": zod.int().min(1)
})

export const restoreManagedDocumentVersionResponseSowOneFactsProjectTitleMax = 200;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomerNameMax = 300;

export const restoreManagedDocumentVersionResponseSowOneFactsAgreementIdMax = 100;

export const restoreManagedDocumentVersionResponseSowOneFactsPreparedDateMax = 40;

export const restoreManagedDocumentVersionResponseSowOneFactsStartDateMax = 40;

export const restoreManagedDocumentVersionResponseSowOneFactsSprintWeeksMax = 52;

export const restoreManagedDocumentVersionResponseSowOneFactsNarrativeItemTextMax = 20000;

export const restoreManagedDocumentVersionResponseSowOneFactsNarrativeMax = 5;

export const restoreManagedDocumentVersionResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const restoreManagedDocumentVersionResponseSowOneFactsTablesItemRowsItemMax = 7;

export const restoreManagedDocumentVersionResponseSowOneFactsTablesItemRowsMax = 100;

export const restoreManagedDocumentVersionResponseSowOneFactsTablesMax = 6;

export const restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemIdMax = 80;

export const restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemTitleMax = 300;

export const restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsInvestmentMax = 100;

export const restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemIdMax = 80;

export const restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemTitleMax = 300;

export const restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsMaterialsMax = 100;

export const restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemIdMax = 80;

export const restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemDateMax = 40;

export const restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const restoreManagedDocumentVersionResponseSowOneFactsInvoicesMax = 100;

export const restoreManagedDocumentVersionResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const restoreManagedDocumentVersionResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const restoreManagedDocumentVersionResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const restoreManagedDocumentVersionResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const restoreManagedDocumentVersionResponseSowOneFactsUnresolvedFactsMax = 200;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomFieldsMax = 600;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomProseItemTextMax = 20000;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomProseMax = 40;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const restoreManagedDocumentVersionResponseSowOneFactsCustomTablesMax = 40;

export const restoreManagedDocumentVersionResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const restoreManagedDocumentVersionResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const restoreManagedDocumentVersionResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const restoreManagedDocumentVersionResponseSowApprovalPolicyOneRevisionsMax = 3;

export const restoreManagedDocumentVersionResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const restoreManagedDocumentVersionResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const restoreManagedDocumentVersionResponseDraftContentLayoutHeaderMax = 100;

export const restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemTextMax = 200000;

export const restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemMarksMax = 20;

export const restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemContentMax = 10000;

export const restoreManagedDocumentVersionResponseDraftContentLayoutFooterMax = 100;

export const restoreManagedDocumentVersionResponseDraftContentSectionsItemsItemTitleMax = 160;

export const restoreManagedDocumentVersionResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const restoreManagedDocumentVersionResponseDraftContentSectionsItemsMax = 200;

export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsMin = 7;
export const restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsMax = 100;

export const restoreManagedDocumentVersionResponseDraftContentTemplateGuidanceMax = 4000;

export const restoreManagedDocumentVersionResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const restoreManagedDocumentVersionResponseDraftContentTemplateSectionGuidanceMax = 200;

export const restoreManagedDocumentVersionResponseDraftContentContentItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseDraftContentContentItemTextMax = 200000;

export const restoreManagedDocumentVersionResponseDraftContentContentItemMarksItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseDraftContentContentItemMarksMax = 20;

export const restoreManagedDocumentVersionResponseDraftContentContentItemContentMax = 10000;

export const restoreManagedDocumentVersionResponseDraftContentContentMax = 10000;

export const restoreManagedDocumentVersionResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const restoreManagedDocumentVersionResponseVersionsItemMajorVersionMin = 0;

export const restoreManagedDocumentVersionResponseVersionsItemMinorVersionMin = 0;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderMax = 100;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterMax = 100;

export const restoreManagedDocumentVersionResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const restoreManagedDocumentVersionResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const restoreManagedDocumentVersionResponseVersionsItemContentSectionsItemsMax = 200;

export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsMin = 7;
export const restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsMax = 100;

export const restoreManagedDocumentVersionResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const restoreManagedDocumentVersionResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const restoreManagedDocumentVersionResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const restoreManagedDocumentVersionResponseVersionsItemContentContentItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseVersionsItemContentContentItemTextMax = 200000;

export const restoreManagedDocumentVersionResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseVersionsItemContentContentItemMarksMax = 20;

export const restoreManagedDocumentVersionResponseVersionsItemContentContentItemContentMax = 10000;

export const restoreManagedDocumentVersionResponseVersionsItemContentContentMax = 10000;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const restoreManagedDocumentVersionResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(restoreManagedDocumentVersionResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsNarrativeItemTextMax)
})).max(restoreManagedDocumentVersionResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsTablesItemRowsItemItemMax)).max(restoreManagedDocumentVersionResponseSowOneFactsTablesItemRowsItemMax)).max(restoreManagedDocumentVersionResponseSowOneFactsTablesItemRowsMax)
})).max(restoreManagedDocumentVersionResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(restoreManagedDocumentVersionResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(restoreManagedDocumentVersionResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsInvoicesItemNotesMax)
})).max(restoreManagedDocumentVersionResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialReviewReasonMin).max(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(restoreManagedDocumentVersionResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(restoreManagedDocumentVersionResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(restoreManagedDocumentVersionResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(restoreManagedDocumentVersionResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsCustomProseItemTextMax)
})).max(restoreManagedDocumentVersionResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(restoreManagedDocumentVersionResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(restoreManagedDocumentVersionResponseSowOneFactsCustomTablesItemRowsItemMax)).max(restoreManagedDocumentVersionResponseSowOneFactsCustomTablesItemRowsMax)
})).max(restoreManagedDocumentVersionResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(restoreManagedDocumentVersionResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(restoreManagedDocumentVersionResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(restoreManagedDocumentVersionResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(restoreManagedDocumentVersionResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(restoreManagedDocumentVersionResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(restoreManagedDocumentVersionResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsTopMin).max(restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsRightMin).max(restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(restoreManagedDocumentVersionResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(restoreManagedDocumentVersionResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(restoreManagedDocumentVersionResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(restoreManagedDocumentVersionResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(restoreManagedDocumentVersionResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(restoreManagedDocumentVersionResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(restoreManagedDocumentVersionResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(restoreManagedDocumentVersionResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemFontSizeMin).max(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsMin).max(restoreManagedDocumentVersionResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(restoreManagedDocumentVersionResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(restoreManagedDocumentVersionResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(restoreManagedDocumentVersionResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(restoreManagedDocumentVersionResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(restoreManagedDocumentVersionResponseDraftContentContentItemContentMax).optional()
})).max(restoreManagedDocumentVersionResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(restoreManagedDocumentVersionResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(restoreManagedDocumentVersionResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(restoreManagedDocumentVersionResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(restoreManagedDocumentVersionResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(restoreManagedDocumentVersionResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsMin).max(restoreManagedDocumentVersionResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(restoreManagedDocumentVersionResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(restoreManagedDocumentVersionResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(restoreManagedDocumentVersionResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(restoreManagedDocumentVersionResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(restoreManagedDocumentVersionResponseVersionsItemContentContentItemContentMax).optional()
})).max(restoreManagedDocumentVersionResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(restoreManagedDocumentVersionResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Page currently eligible ordinary templates in this entity
 */
export const listManagedDocumentTemplatesQueryLimitDefault = 25;
export const listManagedDocumentTemplatesQueryLimitMax = 100;

export const listManagedDocumentTemplatesQueryOffsetDefault = 0;
export const listManagedDocumentTemplatesQueryOffsetMin = 0;

export const listManagedDocumentTemplatesQuerySearchMax = 200;



export const listManagedDocumentTemplatesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listManagedDocumentTemplatesQueryLimitMax).default(listManagedDocumentTemplatesQueryLimitDefault),
  "offset": zod.int().min(listManagedDocumentTemplatesQueryOffsetMin).default(listManagedDocumentTemplatesQueryOffsetDefault),
  "search": zod.string().max(listManagedDocumentTemplatesQuerySearchMax).optional()
})

export const listManagedDocumentTemplatesResponse = zod.object({
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "revision": zod.int(),
  "contentHash": zod.string(),
  "sections": zod.array(zod.string())
}))
})


/**
 * @summary Prepare a clean native reusable-template review without creating a document
 */
export const previewManagedDocumentTemplateParams = zod.object({
  "id": zod.uuid()
})




export const previewManagedDocumentTemplateQueryParams = zod.object({
  "expectedRevision": zod.int().min(1)
})

export const previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsTopMin = 5;
export const previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsTopMax = 50;

export const previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsRightMin = 5;
export const previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsRightMax = 50;

export const previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsBottomMin = 5;
export const previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsBottomMax = 50;

export const previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsLeftMin = 5;
export const previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsLeftMax = 50;

export const previewManagedDocumentTemplateResponseContentLayoutHeaderItemTypeMax = 40;

export const previewManagedDocumentTemplateResponseContentLayoutHeaderItemTextMax = 200000;

export const previewManagedDocumentTemplateResponseContentLayoutHeaderItemMarksItemTypeMax = 40;

export const previewManagedDocumentTemplateResponseContentLayoutHeaderItemMarksMax = 20;

export const previewManagedDocumentTemplateResponseContentLayoutHeaderItemContentMax = 10000;

export const previewManagedDocumentTemplateResponseContentLayoutHeaderMax = 100;

export const previewManagedDocumentTemplateResponseContentLayoutFooterItemTypeMax = 40;

export const previewManagedDocumentTemplateResponseContentLayoutFooterItemTextMax = 200000;

export const previewManagedDocumentTemplateResponseContentLayoutFooterItemMarksItemTypeMax = 40;

export const previewManagedDocumentTemplateResponseContentLayoutFooterItemMarksMax = 20;

export const previewManagedDocumentTemplateResponseContentLayoutFooterItemContentMax = 10000;

export const previewManagedDocumentTemplateResponseContentLayoutFooterMax = 100;

export const previewManagedDocumentTemplateResponseContentSectionsItemsItemTitleMax = 160;

export const previewManagedDocumentTemplateResponseContentSectionsItemsItemAuthoringNotesMax = 4000;


export const previewManagedDocumentTemplateResponseContentSectionsItemsMax = 200;

export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemNameMax = 80;

export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemFontSizeMin = 6;
export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemFontSizeMax = 96;

export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemSpaceAfterMin = 0;
export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemSpaceAfterMax = 144;

export const previewManagedDocumentTemplateResponseContentStylesDefinitionsItemLineHeightMax = 3;

export const previewManagedDocumentTemplateResponseContentStylesDefinitionsMin = 7;
export const previewManagedDocumentTemplateResponseContentStylesDefinitionsMax = 100;

export const previewManagedDocumentTemplateResponseContentTemplateGuidanceMax = 4000;

export const previewManagedDocumentTemplateResponseContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const previewManagedDocumentTemplateResponseContentTemplateSectionGuidanceMax = 200;

export const previewManagedDocumentTemplateResponseContentContentItemTypeMax = 40;

export const previewManagedDocumentTemplateResponseContentContentItemTextMax = 200000;

export const previewManagedDocumentTemplateResponseContentContentItemMarksItemTypeMax = 40;

export const previewManagedDocumentTemplateResponseContentContentItemMarksMax = 20;

export const previewManagedDocumentTemplateResponseContentContentItemContentMax = 10000;

export const previewManagedDocumentTemplateResponseContentContentMax = 10000;



export const previewManagedDocumentTemplateResponse = zod.object({
  "filename": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsTopMin).max(previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsRightMin).max(previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsBottomMin).max(previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsLeftMin).max(previewManagedDocumentTemplateResponseContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentTemplateResponseContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(previewManagedDocumentTemplateResponseContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentTemplateResponseContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewManagedDocumentTemplateResponseContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewManagedDocumentTemplateResponseContentLayoutHeaderItemContentMax).optional()
})).max(previewManagedDocumentTemplateResponseContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentTemplateResponseContentLayoutFooterItemTypeMax),
  "text": zod.string().max(previewManagedDocumentTemplateResponseContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentTemplateResponseContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewManagedDocumentTemplateResponseContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewManagedDocumentTemplateResponseContentLayoutFooterItemContentMax).optional()
})).max(previewManagedDocumentTemplateResponseContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(previewManagedDocumentTemplateResponseContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(previewManagedDocumentTemplateResponseContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(previewManagedDocumentTemplateResponseContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemFontSizeMin).max(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemSpaceBeforeMin).max(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemSpaceAfterMin).max(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(previewManagedDocumentTemplateResponseContentStylesDefinitionsItemLineHeightMax)
})).min(previewManagedDocumentTemplateResponseContentStylesDefinitionsMin).max(previewManagedDocumentTemplateResponseContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(previewManagedDocumentTemplateResponseContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(previewManagedDocumentTemplateResponseContentTemplateSectionGuidanceItemGuidanceMax)
})).max(previewManagedDocumentTemplateResponseContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentTemplateResponseContentContentItemTypeMax),
  "text": zod.string().max(previewManagedDocumentTemplateResponseContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewManagedDocumentTemplateResponseContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewManagedDocumentTemplateResponseContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewManagedDocumentTemplateResponseContentContentItemContentMax).optional()
})).max(previewManagedDocumentTemplateResponseContentContentMax)
}),
  "warnings": zod.array(zod.string()),
  "supported": zod.boolean(),
  "originalPreservedOnAdoption": zod.literal(true)
})


/**
 * @summary Export the exact saved working revision without creating a checkpoint
 */
export const downloadManagedDocumentDraftParams = zod.object({
  "id": zod.uuid()
})


export const downloadManagedDocumentDraftQueryProjectionDefault = `clean`;

export const downloadManagedDocumentDraftQueryParams = zod.object({
  "expectedRevision": zod.int().min(1),
  "format": zod.enum(['docx', 'pdf', 'markdown']),
  "projection": zod.enum(['clean', 'review']).default(downloadManagedDocumentDraftQueryProjectionDefault)
})

export const downloadManagedDocumentDraftResponse = zod.unknown()


/**
 * @summary Export an immutable version as DOCX, PDF or Markdown
 */
export const downloadManagedDocumentVersionParams = zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid()
})

export const downloadManagedDocumentVersionQueryProjectionDefault = `clean`;

export const downloadManagedDocumentVersionQueryParams = zod.object({
  "format": zod.enum(['docx', 'pdf', 'markdown']),
  "projection": zod.enum(['clean', 'review']).default(downloadManagedDocumentVersionQueryProjectionDefault)
})

export const downloadManagedDocumentVersionResponse = zod.unknown()


/**
 * @summary Submit the exact current content for publication review
 */
export const submitManagedDocumentReviewParams = zod.object({
  "id": zod.uuid()
})

export const submitManagedDocumentReviewBodyReasonMax = 2000;



export const submitManagedDocumentReviewBody = zod.object({
  "reason": zod.string().min(1).max(submitManagedDocumentReviewBodyReasonMax)
})

export const submitManagedDocumentReviewResponse = zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})


/**
 * @summary Approve, return, cancel, or reverse an exact-version review
 */
export const decideManagedDocumentReviewParams = zod.object({
  "id": zod.uuid()
})

export const decideManagedDocumentReviewBodyNoteMax = 4000;

export const decideManagedDocumentReviewBodyEditedAfterApprovalDefault = false;

export const decideManagedDocumentReviewBody = zod.object({
  "outcome": zod.enum(['approved', 'changes_requested', 'cancelled', 'reversed']),
  "note": zod.string().min(1).max(decideManagedDocumentReviewBodyNoteMax),
  "editedAfterApproval": zod.boolean().default(decideManagedDocumentReviewBodyEditedAfterApprovalDefault)
})

export const decideManagedDocumentReviewResponse = zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})


/**
 * @summary Add a version-bound review comment
 */
export const commentManagedDocumentReviewParams = zod.object({
  "id": zod.uuid()
})

export const commentManagedDocumentReviewBodyBodyMax = 8000;



export const commentManagedDocumentReviewBody = zod.object({
  "body": zod.string().min(1).max(commentManagedDocumentReviewBodyBodyMax),
  "anchor": zod.record(zod.string(), zod.unknown()).optional()
})

export const commentManagedDocumentReviewResponse = zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get the active entity publication approval policy
 */

export const getDocumentApprovalPolicyResponseOneEligibleCategoriesItemMax = 80;

export const getDocumentApprovalPolicyResponseOneEligibleCategoriesMax = 100;

export const getDocumentApprovalPolicyResponseOneConfidenceThresholdBasisPointsMin = 0;
export const getDocumentApprovalPolicyResponseOneConfidenceThresholdBasisPointsMax = 10000;

export const getDocumentApprovalPolicyResponseOneMinimumComparableHumanDecisionsMax = 1000;

export const getDocumentApprovalPolicyResponseOneSimilarityThresholdBasisPointsMin = 0;
export const getDocumentApprovalPolicyResponseOneSimilarityThresholdBasisPointsMax = 10000;

export const getDocumentApprovalPolicyResponseOneEvidenceWindowDaysMax = 3650;




export const getDocumentApprovalPolicyResponse = zod.object({
  "expectedVersion": zod.int().min(1),
  "mode": zod.enum(['manual_only', 'evidence_gated_ai']),
  "eligibleCategories": zod.array(zod.string().min(1).max(getDocumentApprovalPolicyResponseOneEligibleCategoriesItemMax)).max(getDocumentApprovalPolicyResponseOneEligibleCategoriesMax),
  "reviewRules": zod.record(zod.string(), zod.unknown()),
  "confidenceThresholdBasisPoints": zod.int().min(getDocumentApprovalPolicyResponseOneConfidenceThresholdBasisPointsMin).max(getDocumentApprovalPolicyResponseOneConfidenceThresholdBasisPointsMax),
  "minimumComparableHumanDecisions": zod.int().min(1).max(getDocumentApprovalPolicyResponseOneMinimumComparableHumanDecisionsMax),
  "similarityThresholdBasisPoints": zod.int().min(getDocumentApprovalPolicyResponseOneSimilarityThresholdBasisPointsMin).max(getDocumentApprovalPolicyResponseOneSimilarityThresholdBasisPointsMax),
  "evidenceWindowDays": zod.int().min(1).max(getDocumentApprovalPolicyResponseOneEvidenceWindowDaysMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Replace the entity policy using optimistic concurrency
 */

export const updateDocumentApprovalPolicyBodyEligibleCategoriesItemMax = 80;

export const updateDocumentApprovalPolicyBodyEligibleCategoriesMax = 100;

export const updateDocumentApprovalPolicyBodyConfidenceThresholdBasisPointsMin = 0;
export const updateDocumentApprovalPolicyBodyConfidenceThresholdBasisPointsMax = 10000;

export const updateDocumentApprovalPolicyBodyMinimumComparableHumanDecisionsMax = 1000;

export const updateDocumentApprovalPolicyBodySimilarityThresholdBasisPointsMin = 0;
export const updateDocumentApprovalPolicyBodySimilarityThresholdBasisPointsMax = 10000;

export const updateDocumentApprovalPolicyBodyEvidenceWindowDaysMax = 3650;



export const updateDocumentApprovalPolicyBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "mode": zod.enum(['manual_only', 'evidence_gated_ai']),
  "eligibleCategories": zod.array(zod.string().min(1).max(updateDocumentApprovalPolicyBodyEligibleCategoriesItemMax)).max(updateDocumentApprovalPolicyBodyEligibleCategoriesMax),
  "reviewRules": zod.record(zod.string(), zod.unknown()),
  "confidenceThresholdBasisPoints": zod.int().min(updateDocumentApprovalPolicyBodyConfidenceThresholdBasisPointsMin).max(updateDocumentApprovalPolicyBodyConfidenceThresholdBasisPointsMax),
  "minimumComparableHumanDecisions": zod.int().min(1).max(updateDocumentApprovalPolicyBodyMinimumComparableHumanDecisionsMax),
  "similarityThresholdBasisPoints": zod.int().min(updateDocumentApprovalPolicyBodySimilarityThresholdBasisPointsMin).max(updateDocumentApprovalPolicyBodySimilarityThresholdBasisPointsMax),
  "evidenceWindowDays": zod.int().min(1).max(updateDocumentApprovalPolicyBodyEvidenceWindowDaysMax)
})


export const updateDocumentApprovalPolicyResponseOneEligibleCategoriesItemMax = 80;

export const updateDocumentApprovalPolicyResponseOneEligibleCategoriesMax = 100;

export const updateDocumentApprovalPolicyResponseOneConfidenceThresholdBasisPointsMin = 0;
export const updateDocumentApprovalPolicyResponseOneConfidenceThresholdBasisPointsMax = 10000;

export const updateDocumentApprovalPolicyResponseOneMinimumComparableHumanDecisionsMax = 1000;

export const updateDocumentApprovalPolicyResponseOneSimilarityThresholdBasisPointsMin = 0;
export const updateDocumentApprovalPolicyResponseOneSimilarityThresholdBasisPointsMax = 10000;

export const updateDocumentApprovalPolicyResponseOneEvidenceWindowDaysMax = 3650;




export const updateDocumentApprovalPolicyResponse = zod.object({
  "expectedVersion": zod.int().min(1),
  "mode": zod.enum(['manual_only', 'evidence_gated_ai']),
  "eligibleCategories": zod.array(zod.string().min(1).max(updateDocumentApprovalPolicyResponseOneEligibleCategoriesItemMax)).max(updateDocumentApprovalPolicyResponseOneEligibleCategoriesMax),
  "reviewRules": zod.record(zod.string(), zod.unknown()),
  "confidenceThresholdBasisPoints": zod.int().min(updateDocumentApprovalPolicyResponseOneConfidenceThresholdBasisPointsMin).max(updateDocumentApprovalPolicyResponseOneConfidenceThresholdBasisPointsMax),
  "minimumComparableHumanDecisions": zod.int().min(1).max(updateDocumentApprovalPolicyResponseOneMinimumComparableHumanDecisionsMax),
  "similarityThresholdBasisPoints": zod.int().min(updateDocumentApprovalPolicyResponseOneSimilarityThresholdBasisPointsMin).max(updateDocumentApprovalPolicyResponseOneSimilarityThresholdBasisPointsMax),
  "evidenceWindowDays": zod.int().min(1).max(updateDocumentApprovalPolicyResponseOneEvidenceWindowDaysMax)
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Read authorized shared and own personal document conversations without creating
 */
export const listDocumentConversationsParams = zod.object({
  "id": zod.uuid()
})

export const listDocumentConversationsQueryLimitDefault = 25;
export const listDocumentConversationsQueryLimitMax = 50;

export const listDocumentConversationsQueryOffsetDefault = 0;
export const listDocumentConversationsQueryOffsetMin = 0;
export const listDocumentConversationsQueryOffsetMax = 100000;



export const listDocumentConversationsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDocumentConversationsQueryLimitMax).default(listDocumentConversationsQueryLimitDefault),
  "offset": zod.int().min(listDocumentConversationsQueryOffsetMin).max(listDocumentConversationsQueryOffsetMax).default(listDocumentConversationsQueryOffsetDefault)
})


export const listDocumentConversationsResponseItemsMax = 50;




export const listDocumentConversationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "workspaceId": zod.uuid().nullable(),
  "visibility": zod.enum(['shared', 'personal']),
  "createdByAppUserId": zod.uuid(),
  "title": zod.string(),
  "revision": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(listDocumentConversationsResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int().min(1),
  "offset": zod.int()
})


/**
 * @summary Explicitly create an immutable audience and document bound conversation
 */
export const createDocumentConversationParams = zod.object({
  "id": zod.uuid()
})

export const createDocumentConversationBodyTitleMax = 200;



export const createDocumentConversationBody = zod.object({
  "clientRequestId": zod.uuid(),
  "title": zod.string().min(1).max(createDocumentConversationBodyTitleMax),
  "visibility": zod.enum(['shared', 'personal']),
  "workspaceId": zod.uuid().nullish()
})




export const createDocumentConversationResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "workspaceId": zod.uuid().nullable(),
  "visibility": zod.enum(['shared', 'personal']),
  "createdByAppUserId": zod.uuid(),
  "title": zod.string(),
  "revision": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Read the original actor owned conversation creation outcome
 */
export const getDocumentConversationCreationOutcomeParams = zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid()
})




export const getDocumentConversationCreationOutcomeResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "workspaceId": zod.uuid().nullable(),
  "visibility": zod.enum(['shared', 'personal']),
  "createdByAppUserId": zod.uuid(),
  "title": zod.string(),
  "revision": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Read exact current document and audience binding
 */
export const getDocumentConversationParams = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid()
})




export const getDocumentConversationResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "workspaceId": zod.uuid().nullable(),
  "visibility": zod.enum(['shared', 'personal']),
  "createdByAppUserId": zod.uuid(),
  "title": zod.string(),
  "revision": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Read bounded stable document turn history with current source checks
 */
export const listDocumentConversationMessagesParams = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid()
})

export const listDocumentConversationMessagesQueryLimitDefault = 25;
export const listDocumentConversationMessagesQueryLimitMax = 50;

export const listDocumentConversationMessagesQueryOffsetDefault = 0;
export const listDocumentConversationMessagesQueryOffsetMin = 0;
export const listDocumentConversationMessagesQueryOffsetMax = 100000;



export const listDocumentConversationMessagesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listDocumentConversationMessagesQueryLimitMax).default(listDocumentConversationMessagesQueryLimitDefault),
  "offset": zod.int().min(listDocumentConversationMessagesQueryOffsetMin).max(listDocumentConversationMessagesQueryOffsetMax).default(listDocumentConversationMessagesQueryOffsetDefault)
})


export const listDocumentConversationMessagesResponseItemsItemAnswerMax = 100000;


export const listDocumentConversationMessagesResponseItemsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listDocumentConversationMessagesResponseItemsItemMetricsDurationMsMin = 0;

export const listDocumentConversationMessagesResponseItemsItemMetricsModelStepsMin = 0;

export const listDocumentConversationMessagesResponseItemsItemMetricsPromptCharsMin = 0;

export const listDocumentConversationMessagesResponseItemsItemMetricsUploadCharsMin = 0;

export const listDocumentConversationMessagesResponseItemsItemMetricsInputTokensMin = 0;

export const listDocumentConversationMessagesResponseItemsItemMetricsOutputTokensMin = 0;

export const listDocumentConversationMessagesResponseItemsItemMetricsActionsProposedMin = 0;

export const listDocumentConversationMessagesResponseItemsMax = 50;




export const listDocumentConversationMessagesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "sequence": zod.int().min(1),
  "message": zod.string(),
  "answer": zod.string().max(listDocumentConversationMessagesResponseItemsItemAnswerMax).nullable(),
  "status": zod.enum(['running', 'completed', 'failed', 'cancelled', 'interrupted']),
  "restricted": zod.boolean(),
  "draftRevision": zod.int().min(1),
  "contentHash": zod.string().regex(listDocumentConversationMessagesResponseItemsItemContentHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "metrics": zod.object({
  "durationMs": zod.int().min(listDocumentConversationMessagesResponseItemsItemMetricsDurationMsMin),
  "modelSteps": zod.int().min(listDocumentConversationMessagesResponseItemsItemMetricsModelStepsMin),
  "promptChars": zod.int().min(listDocumentConversationMessagesResponseItemsItemMetricsPromptCharsMin),
  "uploadChars": zod.int().min(listDocumentConversationMessagesResponseItemsItemMetricsUploadCharsMin),
  "snapshot": zod.enum(['saved', 'full', 'delta']),
  "mode": zod.enum(['answer', 'proposal']),
  "inputTokens": zod.int().min(listDocumentConversationMessagesResponseItemsItemMetricsInputTokensMin).nullable(),
  "outputTokens": zod.int().min(listDocumentConversationMessagesResponseItemsItemMetricsOutputTokensMin).nullable(),
  "actionsProposed": zod.int().min(listDocumentConversationMessagesResponseItemsItemMetricsActionsProposedMin)
}).nullish()
})).max(listDocumentConversationMessagesResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int().min(1),
  "offset": zod.int()
})


/**
 * @summary Read durable revision and pending activity without generating
 */
export const getDocumentConversationActivityParams = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid()
})




export const getDocumentConversationActivityResponse = zod.object({
  "revision": zod.int().min(1),
  "runningTurnId": zod.uuid().nullable(),
  "leaseExpiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "expired": zod.boolean()
})


/**
 * @summary Reserve and run one explicit turn with one provider attempt and private native proposal
 */
export const sendDocumentConversationTurnParams = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid()
})

export const sendDocumentConversationTurnBodyMessageMax = 4000;


export const sendDocumentConversationTurnBodyContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendDocumentConversationTurnBodyTargetSectionIdsMax = 20;

export const sendDocumentConversationTurnBodyTargetBlockIndexMin = 0;
export const sendDocumentConversationTurnBodyTargetBlockIndexMax = 9999;

export const sendDocumentConversationTurnBodyTargetFromMin = 0;
export const sendDocumentConversationTurnBodyTargetFromMax = 1000000;

export const sendDocumentConversationTurnBodyTargetToMin = 0;
export const sendDocumentConversationTurnBodyTargetToMax = 1000000;


export const sendDocumentConversationTurnBodyTargetContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendDocumentConversationTurnBodySnapshotBaseHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendDocumentConversationTurnBodySnapshotChangesItemIndexMin = 0;
export const sendDocumentConversationTurnBodySnapshotChangesItemIndexMax = 20000;

export const sendDocumentConversationTurnBodySnapshotChangesItemDeleteCountMin = 0;
export const sendDocumentConversationTurnBodySnapshotChangesItemDeleteCountMax = 20000;

export const sendDocumentConversationTurnBodySnapshotChangesItemInsertMax = 5000;

export const sendDocumentConversationTurnBodySnapshotChangesMax = 200;



export const sendDocumentConversationTurnBody = zod.object({
  "clientRequestId": zod.uuid(),
  "message": zod.string().min(1).max(sendDocumentConversationTurnBodyMessageMax),
  "expectedRevision": zod.int().min(1),
  "contentHash": zod.string().regex(sendDocumentConversationTurnBodyContentHashRegExp),
  "mode": zod.enum(['answer', 'proposal']),
  "target": zod.object({
  "kind": zod.enum(['selection', 'cursor', 'section', 'sections']),
  "sectionIds": zod.array(zod.uuid()).min(1).max(sendDocumentConversationTurnBodyTargetSectionIdsMax).optional(),
  "blockIndex": zod.int().min(sendDocumentConversationTurnBodyTargetBlockIndexMin).max(sendDocumentConversationTurnBodyTargetBlockIndexMax),
  "from": zod.int().min(sendDocumentConversationTurnBodyTargetFromMin).max(sendDocumentConversationTurnBodyTargetFromMax),
  "to": zod.int().min(sendDocumentConversationTurnBodyTargetToMin).max(sendDocumentConversationTurnBodyTargetToMax),
  "expectedRevision": zod.int().min(1),
  "contentHash": zod.string().regex(sendDocumentConversationTurnBodyTargetContentHashRegExp)
}).optional(),
  "snapshot": zod.object({
  "kind": zod.enum(['full', 'delta']),
  "content": zod.record(zod.string(), zod.unknown()).optional(),
  "baseHash": zod.string().regex(sendDocumentConversationTurnBodySnapshotBaseHashRegExp).optional(),
  "changes": zod.array(zod.object({
  "index": zod.int().min(sendDocumentConversationTurnBodySnapshotChangesItemIndexMin).max(sendDocumentConversationTurnBodySnapshotChangesItemIndexMax),
  "deleteCount": zod.int().min(sendDocumentConversationTurnBodySnapshotChangesItemDeleteCountMin).max(sendDocumentConversationTurnBodySnapshotChangesItemDeleteCountMax),
  "insert": zod.array(zod.record(zod.string(), zod.unknown())).max(sendDocumentConversationTurnBodySnapshotChangesItemInsertMax)
})).max(sendDocumentConversationTurnBodySnapshotChangesMax).optional()
}).optional().describe('Optional live editor snapshot used as untrusted conversation evidence. kind=full uploads the whole body; kind=delta replaces top-level blocks of this person\'s last snapshot in this conversation (baseHash). Bounded to 120,000 serialized characters, 5,000 structural values, depth 32 and 200 sections.')
})


export const sendDocumentConversationTurnResponseMessageAnswerMax = 100000;


export const sendDocumentConversationTurnResponseMessageContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendDocumentConversationTurnResponseMessageMetricsDurationMsMin = 0;

export const sendDocumentConversationTurnResponseMessageMetricsModelStepsMin = 0;

export const sendDocumentConversationTurnResponseMessageMetricsPromptCharsMin = 0;

export const sendDocumentConversationTurnResponseMessageMetricsUploadCharsMin = 0;

export const sendDocumentConversationTurnResponseMessageMetricsInputTokensMin = 0;

export const sendDocumentConversationTurnResponseMessageMetricsOutputTokensMin = 0;

export const sendDocumentConversationTurnResponseMessageMetricsActionsProposedMin = 0;

export const sendDocumentConversationTurnResponseSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const sendDocumentConversationTurnResponseActionsItemSummaryMax = 500;

export const sendDocumentConversationTurnResponseActionsItemFolderMax = 200;

export const sendDocumentConversationTurnResponseActionsItemReasonMax = 1000;

export const sendDocumentConversationTurnResponseActionsItemTargetIdsMax = 50;

export const sendDocumentConversationTurnResponseActionsMax = 5;



export const sendDocumentConversationTurnResponse = zod.object({
  "clientRequestId": zod.uuid(),
  "message": zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "sequence": zod.int().min(1),
  "message": zod.string(),
  "answer": zod.string().max(sendDocumentConversationTurnResponseMessageAnswerMax).nullable(),
  "status": zod.enum(['running', 'completed', 'failed', 'cancelled', 'interrupted']),
  "restricted": zod.boolean(),
  "draftRevision": zod.int().min(1),
  "contentHash": zod.string().regex(sendDocumentConversationTurnResponseMessageContentHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "metrics": zod.object({
  "durationMs": zod.int().min(sendDocumentConversationTurnResponseMessageMetricsDurationMsMin),
  "modelSteps": zod.int().min(sendDocumentConversationTurnResponseMessageMetricsModelStepsMin),
  "promptChars": zod.int().min(sendDocumentConversationTurnResponseMessageMetricsPromptCharsMin),
  "uploadChars": zod.int().min(sendDocumentConversationTurnResponseMessageMetricsUploadCharsMin),
  "snapshot": zod.enum(['saved', 'full', 'delta']),
  "mode": zod.enum(['answer', 'proposal']),
  "inputTokens": zod.int().min(sendDocumentConversationTurnResponseMessageMetricsInputTokensMin).nullable(),
  "outputTokens": zod.int().min(sendDocumentConversationTurnResponseMessageMetricsOutputTokensMin).nullable(),
  "actionsProposed": zod.int().min(sendDocumentConversationTurnResponseMessageMetricsActionsProposedMin)
}).nullish()
}),
  "proposalId": zod.uuid().nullable(),
  "snapshotHash": zod.string().regex(sendDocumentConversationTurnResponseSnapshotHashRegExp).nullish(),
  "actions": zod.array(zod.object({
  "action": zod.enum(['move', 'publish', 'restore_version', 'share_link', 'resolve_suggestions']),
  "summary": zod.string().min(1).max(sendDocumentConversationTurnResponseActionsItemSummaryMax),
  "folder": zod.string().max(sendDocumentConversationTurnResponseActionsItemFolderMax).optional(),
  "versionId": zod.uuid().optional(),
  "reason": zod.string().min(1).max(sendDocumentConversationTurnResponseActionsItemReasonMax).optional(),
  "shareState": zod.enum(['unpublished', 'revoked']).optional(),
  "decision": zod.enum(['accept', 'reject', 'resolve_comment']).optional(),
  "targetIds": zod.array(zod.uuid()).max(sendDocumentConversationTurnResponseActionsItemTargetIdsMax).optional()
}).describe('A transient native action the document agent suggests. It is never executed until the person confirms it through runDocumentAgentAction, which reruns the native permission checks and audit.')).max(sendDocumentConversationTurnResponseActionsMax).optional()
})


/**
 * @summary Recover the exact actor original without resending or provider work
 */
export const getDocumentConversationTurnOutcomeParams = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "requestId": zod.uuid()
})


export const getDocumentConversationTurnOutcomeResponseMessageAnswerMax = 100000;


export const getDocumentConversationTurnOutcomeResponseMessageContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentConversationTurnOutcomeResponseMessageMetricsDurationMsMin = 0;

export const getDocumentConversationTurnOutcomeResponseMessageMetricsModelStepsMin = 0;

export const getDocumentConversationTurnOutcomeResponseMessageMetricsPromptCharsMin = 0;

export const getDocumentConversationTurnOutcomeResponseMessageMetricsUploadCharsMin = 0;

export const getDocumentConversationTurnOutcomeResponseMessageMetricsInputTokensMin = 0;

export const getDocumentConversationTurnOutcomeResponseMessageMetricsOutputTokensMin = 0;

export const getDocumentConversationTurnOutcomeResponseMessageMetricsActionsProposedMin = 0;

export const getDocumentConversationTurnOutcomeResponseSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getDocumentConversationTurnOutcomeResponseActionsItemSummaryMax = 500;

export const getDocumentConversationTurnOutcomeResponseActionsItemFolderMax = 200;

export const getDocumentConversationTurnOutcomeResponseActionsItemReasonMax = 1000;

export const getDocumentConversationTurnOutcomeResponseActionsItemTargetIdsMax = 50;

export const getDocumentConversationTurnOutcomeResponseActionsMax = 5;



export const getDocumentConversationTurnOutcomeResponse = zod.object({
  "clientRequestId": zod.uuid(),
  "message": zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "sequence": zod.int().min(1),
  "message": zod.string(),
  "answer": zod.string().max(getDocumentConversationTurnOutcomeResponseMessageAnswerMax).nullable(),
  "status": zod.enum(['running', 'completed', 'failed', 'cancelled', 'interrupted']),
  "restricted": zod.boolean(),
  "draftRevision": zod.int().min(1),
  "contentHash": zod.string().regex(getDocumentConversationTurnOutcomeResponseMessageContentHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "metrics": zod.object({
  "durationMs": zod.int().min(getDocumentConversationTurnOutcomeResponseMessageMetricsDurationMsMin),
  "modelSteps": zod.int().min(getDocumentConversationTurnOutcomeResponseMessageMetricsModelStepsMin),
  "promptChars": zod.int().min(getDocumentConversationTurnOutcomeResponseMessageMetricsPromptCharsMin),
  "uploadChars": zod.int().min(getDocumentConversationTurnOutcomeResponseMessageMetricsUploadCharsMin),
  "snapshot": zod.enum(['saved', 'full', 'delta']),
  "mode": zod.enum(['answer', 'proposal']),
  "inputTokens": zod.int().min(getDocumentConversationTurnOutcomeResponseMessageMetricsInputTokensMin).nullable(),
  "outputTokens": zod.int().min(getDocumentConversationTurnOutcomeResponseMessageMetricsOutputTokensMin).nullable(),
  "actionsProposed": zod.int().min(getDocumentConversationTurnOutcomeResponseMessageMetricsActionsProposedMin)
}).nullish()
}),
  "proposalId": zod.uuid().nullable(),
  "snapshotHash": zod.string().regex(getDocumentConversationTurnOutcomeResponseSnapshotHashRegExp).nullish(),
  "actions": zod.array(zod.object({
  "action": zod.enum(['move', 'publish', 'restore_version', 'share_link', 'resolve_suggestions']),
  "summary": zod.string().min(1).max(getDocumentConversationTurnOutcomeResponseActionsItemSummaryMax),
  "folder": zod.string().max(getDocumentConversationTurnOutcomeResponseActionsItemFolderMax).optional(),
  "versionId": zod.uuid().optional(),
  "reason": zod.string().min(1).max(getDocumentConversationTurnOutcomeResponseActionsItemReasonMax).optional(),
  "shareState": zod.enum(['unpublished', 'revoked']).optional(),
  "decision": zod.enum(['accept', 'reject', 'resolve_comment']).optional(),
  "targetIds": zod.array(zod.uuid()).max(getDocumentConversationTurnOutcomeResponseActionsItemTargetIdsMax).optional()
}).describe('A transient native action the document agent suggests. It is never executed until the person confirms it through runDocumentAgentAction, which reruns the native permission checks and audit.')).max(getDocumentConversationTurnOutcomeResponseActionsMax).optional()
})


/**
 * @summary Run one confirmed native action suggested by the document agent through native permissions and audit
 */
export const runDocumentAgentActionParams = zod.object({
  "id": zod.uuid()
})


export const runDocumentAgentActionBodyProposalSummaryMax = 500;

export const runDocumentAgentActionBodyProposalFolderMax = 200;

export const runDocumentAgentActionBodyProposalReasonMax = 1000;

export const runDocumentAgentActionBodyProposalTargetIdsMax = 50;



export const runDocumentAgentActionBody = zod.object({
  "clientRequestId": zod.uuid(),
  "turnId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "confirmed": zod.literal(true),
  "proposal": zod.object({
  "action": zod.enum(['move', 'publish', 'restore_version', 'share_link', 'resolve_suggestions']),
  "summary": zod.string().min(1).max(runDocumentAgentActionBodyProposalSummaryMax),
  "folder": zod.string().max(runDocumentAgentActionBodyProposalFolderMax).optional(),
  "versionId": zod.uuid().optional(),
  "reason": zod.string().min(1).max(runDocumentAgentActionBodyProposalReasonMax).optional(),
  "shareState": zod.enum(['unpublished', 'revoked']).optional(),
  "decision": zod.enum(['accept', 'reject', 'resolve_comment']).optional(),
  "targetIds": zod.array(zod.uuid()).max(runDocumentAgentActionBodyProposalTargetIdsMax).optional()
}).describe('A transient native action the document agent suggests. It is never executed until the person confirms it through runDocumentAgentAction, which reruns the native permission checks and audit.')
})

export const runDocumentAgentActionResponse = zod.object({
  "clientRequestId": zod.uuid(),
  "action": zod.enum(['move', 'publish', 'restore_version', 'share_link', 'resolve_suggestions']),
  "replayed": zod.boolean(),
  "summary": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Persist Stop and fence late results for an authorized editor
 */
export const stopDocumentConversationTurnParams = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "turnId": zod.uuid()
})


export const stopDocumentConversationTurnResponseAnswerMax = 100000;


export const stopDocumentConversationTurnResponseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const stopDocumentConversationTurnResponseMetricsDurationMsMin = 0;

export const stopDocumentConversationTurnResponseMetricsModelStepsMin = 0;

export const stopDocumentConversationTurnResponseMetricsPromptCharsMin = 0;

export const stopDocumentConversationTurnResponseMetricsUploadCharsMin = 0;

export const stopDocumentConversationTurnResponseMetricsInputTokensMin = 0;

export const stopDocumentConversationTurnResponseMetricsOutputTokensMin = 0;

export const stopDocumentConversationTurnResponseMetricsActionsProposedMin = 0;



export const stopDocumentConversationTurnResponse = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "authorAppUserId": zod.uuid(),
  "sequence": zod.int().min(1),
  "message": zod.string(),
  "answer": zod.string().max(stopDocumentConversationTurnResponseAnswerMax).nullable(),
  "status": zod.enum(['running', 'completed', 'failed', 'cancelled', 'interrupted']),
  "restricted": zod.boolean(),
  "draftRevision": zod.int().min(1),
  "contentHash": zod.string().regex(stopDocumentConversationTurnResponseContentHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "metrics": zod.object({
  "durationMs": zod.int().min(stopDocumentConversationTurnResponseMetricsDurationMsMin),
  "modelSteps": zod.int().min(stopDocumentConversationTurnResponseMetricsModelStepsMin),
  "promptChars": zod.int().min(stopDocumentConversationTurnResponseMetricsPromptCharsMin),
  "uploadChars": zod.int().min(stopDocumentConversationTurnResponseMetricsUploadCharsMin),
  "snapshot": zod.enum(['saved', 'full', 'delta']),
  "mode": zod.enum(['answer', 'proposal']),
  "inputTokens": zod.int().min(stopDocumentConversationTurnResponseMetricsInputTokensMin).nullable(),
  "outputTokens": zod.int().min(stopDocumentConversationTurnResponseMetricsOutputTokensMin).nullable(),
  "actionsProposed": zod.int().min(stopDocumentConversationTurnResponseMetricsActionsProposedMin)
}).nullish()
})


/**
 * @summary Create a grounded inspectable authoring or review proposal
 */
export const createManagedDocumentAiProposalParams = zod.object({
  "id": zod.uuid()
})

export const createManagedDocumentAiProposalBodyWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentAiProposalBodyTargetSectionIdsMax = 20;

export const createManagedDocumentAiProposalBodyTargetBlockIndexMin = 0;
export const createManagedDocumentAiProposalBodyTargetBlockIndexMax = 9999;

export const createManagedDocumentAiProposalBodyTargetFromMin = 0;
export const createManagedDocumentAiProposalBodyTargetFromMax = 1000000;

export const createManagedDocumentAiProposalBodyTargetToMin = 0;
export const createManagedDocumentAiProposalBodyTargetToMax = 1000000;


export const createManagedDocumentAiProposalBodyTargetContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createManagedDocumentAiProposalBodyInstructionMax = 8000;



export const createManagedDocumentAiProposalBody = zod.object({
  "clientRequestId": zod.uuid().optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(createManagedDocumentAiProposalBodyWorkspaceContextManifestHashRegExp)
}).optional(),
  "target": zod.object({
  "kind": zod.enum(['selection', 'cursor', 'section', 'sections']),
  "sectionIds": zod.array(zod.uuid()).min(1).max(createManagedDocumentAiProposalBodyTargetSectionIdsMax).optional(),
  "blockIndex": zod.int().min(createManagedDocumentAiProposalBodyTargetBlockIndexMin).max(createManagedDocumentAiProposalBodyTargetBlockIndexMax),
  "from": zod.int().min(createManagedDocumentAiProposalBodyTargetFromMin).max(createManagedDocumentAiProposalBodyTargetFromMax),
  "to": zod.int().min(createManagedDocumentAiProposalBodyTargetToMin).max(createManagedDocumentAiProposalBodyTargetToMax),
  "expectedRevision": zod.int().min(1),
  "contentHash": zod.string().regex(createManagedDocumentAiProposalBodyTargetContentHashRegExp)
}).optional(),
  "action": zod.enum(['draft', 'rewrite', 'expand', 'shorten', 'tone', 'summarize', 'compare', 'review']),
  "instruction": zod.string().min(1).max(createManagedDocumentAiProposalBodyInstructionMax),
  "comparisonVersionId": zod.uuid().nullish()
})

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemTypeMax = 40;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemTextMax = 200000;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemMarksMax = 20;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemContentMax = 10000;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderMax = 100;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemTypeMax = 40;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemTextMax = 200000;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemMarksMax = 20;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemContentMax = 10000;

export const createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterMax = 100;

export const createManagedDocumentAiProposalResponseProposedContentOneSectionsItemsItemTitleMax = 160;

export const createManagedDocumentAiProposalResponseProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const createManagedDocumentAiProposalResponseProposedContentOneSectionsItemsMax = 200;

export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemNameMax = 80;

export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsMin = 7;
export const createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsMax = 100;

export const createManagedDocumentAiProposalResponseProposedContentOneTemplateGuidanceMax = 4000;

export const createManagedDocumentAiProposalResponseProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createManagedDocumentAiProposalResponseProposedContentOneTemplateSectionGuidanceMax = 200;

export const createManagedDocumentAiProposalResponseProposedContentOneContentItemTypeMax = 40;

export const createManagedDocumentAiProposalResponseProposedContentOneContentItemTextMax = 200000;

export const createManagedDocumentAiProposalResponseProposedContentOneContentItemMarksItemTypeMax = 40;

export const createManagedDocumentAiProposalResponseProposedContentOneContentItemMarksMax = 20;

export const createManagedDocumentAiProposalResponseProposedContentOneContentItemContentMax = 10000;

export const createManagedDocumentAiProposalResponseProposedContentOneContentMax = 10000;



export const createManagedDocumentAiProposalResponse = zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsTopMin).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsRightMin).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsBottomMin).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsLeftMin).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterItemContentMax).optional()
})).max(createManagedDocumentAiProposalResponseProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createManagedDocumentAiProposalResponseProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createManagedDocumentAiProposalResponseProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createManagedDocumentAiProposalResponseProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemFontSizeMin).max(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsMin).max(createManagedDocumentAiProposalResponseProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createManagedDocumentAiProposalResponseProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createManagedDocumentAiProposalResponseProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(createManagedDocumentAiProposalResponseProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentAiProposalResponseProposedContentOneContentItemTypeMax),
  "text": zod.string().max(createManagedDocumentAiProposalResponseProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createManagedDocumentAiProposalResponseProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createManagedDocumentAiProposalResponseProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createManagedDocumentAiProposalResponseProposedContentOneContentItemContentMax).optional()
})).max(createManagedDocumentAiProposalResponseProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Accept or reject an exact-revision AI proposal
 */
export const decideManagedDocumentAiProposalParams = zod.object({
  "id": zod.uuid(),
  "proposalId": zod.uuid()
})


export const decideManagedDocumentAiProposalBodySectionIdsMax = 20;

export const decideManagedDocumentAiProposalBodyBlockIndexesItemMin = 0;
export const decideManagedDocumentAiProposalBodyBlockIndexesItemMax = 9999;

export const decideManagedDocumentAiProposalBodyBlockIndexesMax = 100;



export const decideManagedDocumentAiProposalBody = zod.object({
  "decision": zod.enum(['accepted', 'rejected']),
  "expectedRevision": zod.int().min(1),
  "sectionIds": zod.array(zod.uuid()).min(1).max(decideManagedDocumentAiProposalBodySectionIdsMax).optional(),
  "blockIndexes": zod.array(zod.int().min(decideManagedDocumentAiProposalBodyBlockIndexesItemMin).max(decideManagedDocumentAiProposalBodyBlockIndexesItemMax)).min(1).max(decideManagedDocumentAiProposalBodyBlockIndexesMax).optional(),
  "delivery": zod.enum(['document', 'live_session']).optional().describe('document (default) saves the accepted content on the server. live_session records the reviewed acceptance after the same protection checks; the requester\'s editor then applies the change as a collaborator in the live session, where the native draft path enforces protection again and records tracked changes. Only Document agent proposals support live_session.'),
  "agentMode": zod.enum(['coauthor', 'auto']).optional().describe('Document agent mode chosen for a live_session delivery: coauthor applies tracked suggestions, auto applies directly with a brief highlight.')
})

export const decideManagedDocumentAiProposalResponseSowOneFactsProjectTitleMax = 200;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomerNameMax = 300;

export const decideManagedDocumentAiProposalResponseSowOneFactsAgreementIdMax = 100;

export const decideManagedDocumentAiProposalResponseSowOneFactsPreparedDateMax = 40;

export const decideManagedDocumentAiProposalResponseSowOneFactsStartDateMax = 40;

export const decideManagedDocumentAiProposalResponseSowOneFactsSprintWeeksMax = 52;

export const decideManagedDocumentAiProposalResponseSowOneFactsNarrativeItemTextMax = 20000;

export const decideManagedDocumentAiProposalResponseSowOneFactsNarrativeMax = 5;

export const decideManagedDocumentAiProposalResponseSowOneFactsTablesItemRowsItemItemMax = 4000;

export const decideManagedDocumentAiProposalResponseSowOneFactsTablesItemRowsItemMax = 7;

export const decideManagedDocumentAiProposalResponseSowOneFactsTablesItemRowsMax = 100;

export const decideManagedDocumentAiProposalResponseSowOneFactsTablesMax = 6;

export const decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemIdMax = 80;

export const decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemTitleMax = 300;

export const decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemDescriptionMax = 4000;

export const decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsInvestmentMax = 100;

export const decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemIdMax = 80;

export const decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemTitleMax = 300;

export const decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemDescriptionMax = 4000;

export const decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsMaterialsMax = 100;

export const decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemIdMax = 80;

export const decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemMilestonesMax = 500;

export const decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemDateMax = 40;

export const decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemNotesMax = 2000;

export const decideManagedDocumentAiProposalResponseSowOneFactsInvoicesMax = 100;

export const decideManagedDocumentAiProposalResponseSowOneFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialReferenceMax = 300;

export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialSourceStatusMax = 100;

export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialTermsMax = 20000;

export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialAssumptionsMax = 20000;

export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialExclusionsMax = 20000;

export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialReviewReasonMin = 10;
export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialReviewReasonMax = 2000;

export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialLinesItemTitleMax = 300;

export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialLinesMax = 100;

export const decideManagedDocumentAiProposalResponseSowOneFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const decideManagedDocumentAiProposalResponseSowOneFactsUnresolvedFactsItemFieldMax = 100;

export const decideManagedDocumentAiProposalResponseSowOneFactsUnresolvedFactsItemMessageMax = 2000;

export const decideManagedDocumentAiProposalResponseSowOneFactsUnresolvedFactsMax = 200;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomFieldsItemSectionIdMax = 48;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomFieldsItemFieldIdMax = 48;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomFieldsItemValueMax = 4000;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomFieldsMax = 600;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomProseItemSectionIdMax = 48;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomProseItemTextMax = 20000;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomProseMax = 40;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesItemSectionIdMax = 48;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesItemRowsItemItemMax = 4000;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesItemRowsItemMax = 8;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesItemRowsMax = 100;

export const decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesMax = 40;

export const decideManagedDocumentAiProposalResponseSowApprovalPolicyOneLocalRevisionMin = 0;

export const decideManagedDocumentAiProposalResponseSowApprovalPolicyOneFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideManagedDocumentAiProposalResponseSowApprovalPolicyOneRevisionsItemRevisionMin = 0;

export const decideManagedDocumentAiProposalResponseSowApprovalPolicyOneRevisionsMax = 3;

export const decideManagedDocumentAiProposalResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax = 100;

export const decideManagedDocumentAiProposalResponseSowApprovalPolicyOneEligibilityUserIdsMax = 100;


export const decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsTopMin = 5;
export const decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsTopMax = 50;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsRightMin = 5;
export const decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsRightMax = 50;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsBottomMin = 5;
export const decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsBottomMax = 50;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsLeftMin = 5;
export const decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsLeftMax = 50;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemTextMax = 200000;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemMarksItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemMarksMax = 20;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemContentMax = 10000;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderMax = 100;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemTextMax = 200000;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemMarksItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemMarksMax = 20;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemContentMax = 10000;

export const decideManagedDocumentAiProposalResponseDraftContentLayoutFooterMax = 100;

export const decideManagedDocumentAiProposalResponseDraftContentSectionsItemsItemTitleMax = 160;

export const decideManagedDocumentAiProposalResponseDraftContentSectionsItemsItemAuthoringNotesMax = 4000;


export const decideManagedDocumentAiProposalResponseDraftContentSectionsItemsMax = 200;

export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemNameMax = 80;

export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemFontSizeMin = 6;
export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemFontSizeMax = 96;

export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemSpaceAfterMin = 0;
export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemSpaceAfterMax = 144;

export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemLineHeightMax = 3;

export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsMin = 7;
export const decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsMax = 100;

export const decideManagedDocumentAiProposalResponseDraftContentTemplateGuidanceMax = 4000;

export const decideManagedDocumentAiProposalResponseDraftContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const decideManagedDocumentAiProposalResponseDraftContentTemplateSectionGuidanceMax = 200;

export const decideManagedDocumentAiProposalResponseDraftContentContentItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseDraftContentContentItemTextMax = 200000;

export const decideManagedDocumentAiProposalResponseDraftContentContentItemMarksItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseDraftContentContentItemMarksMax = 20;

export const decideManagedDocumentAiProposalResponseDraftContentContentItemContentMax = 10000;

export const decideManagedDocumentAiProposalResponseDraftContentContentMax = 10000;

export const decideManagedDocumentAiProposalResponseDraftContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideManagedDocumentAiProposalResponseVersionsItemMajorVersionMin = 0;

export const decideManagedDocumentAiProposalResponseVersionsItemMinorVersionMin = 0;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemTextMax = 200000;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemMarksMax = 20;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemContentMax = 10000;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderMax = 100;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemTextMax = 200000;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemMarksMax = 20;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemContentMax = 10000;

export const decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterMax = 100;

export const decideManagedDocumentAiProposalResponseVersionsItemContentSectionsItemsItemTitleMax = 160;

export const decideManagedDocumentAiProposalResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const decideManagedDocumentAiProposalResponseVersionsItemContentSectionsItemsMax = 200;

export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemNameMax = 80;

export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsMin = 7;
export const decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsMax = 100;

export const decideManagedDocumentAiProposalResponseVersionsItemContentTemplateGuidanceMax = 4000;

export const decideManagedDocumentAiProposalResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const decideManagedDocumentAiProposalResponseVersionsItemContentTemplateSectionGuidanceMax = 200;

export const decideManagedDocumentAiProposalResponseVersionsItemContentContentItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseVersionsItemContentContentItemTextMax = 200000;

export const decideManagedDocumentAiProposalResponseVersionsItemContentContentItemMarksItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseVersionsItemContentContentItemMarksMax = 20;

export const decideManagedDocumentAiProposalResponseVersionsItemContentContentItemContentMax = 10000;

export const decideManagedDocumentAiProposalResponseVersionsItemContentContentMax = 10000;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin = 5;
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax = 50;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin = 5;
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax = 50;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin = 5;
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax = 50;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin = 5;
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax = 50;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax = 200000;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax = 20;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax = 10000;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderMax = 100;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax = 200000;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax = 20;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax = 10000;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterMax = 100;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax = 160;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax = 4000;


export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneSectionsItemsMax = 200;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax = 80;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin = 6;
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax = 96;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin = 0;
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax = 144;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin = 0;
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax = 144;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax = 3;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsMin = 7;
export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsMax = 100;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneTemplateGuidanceMax = 4000;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax = 4000;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax = 200;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemTextMax = 200000;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax = 40;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemMarksMax = 20;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemContentMax = 10000;

export const decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentMax = 10000;




export const decideManagedDocumentAiProposalResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "category": zod.string(),
  "folder": zod.string(),
  "labels": zod.array(zod.string()),
  "status": zod.enum(['draft', 'in_review', 'approved', 'published', 'archived']),
  "sourceKind": zod.string(),
  "ownershipMode": zod.enum(['managed', 'source_owned_copy']),
  "sow": zod.union([zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(decideManagedDocumentAiProposalResponseSowOneFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsNarrativeItemTextMax)
})).max(decideManagedDocumentAiProposalResponseSowOneFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsTablesItemRowsItemItemMax)).max(decideManagedDocumentAiProposalResponseSowOneFactsTablesItemRowsItemMax)).max(decideManagedDocumentAiProposalResponseSowOneFactsTablesItemRowsMax)
})).max(decideManagedDocumentAiProposalResponseSowOneFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemIdMax),
  "title": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemTitleMax),
  "description": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(decideManagedDocumentAiProposalResponseSowOneFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemIdMax),
  "title": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemTitleMax),
  "description": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(decideManagedDocumentAiProposalResponseSowOneFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemIdMax),
  "milestones": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsInvoicesItemNotesMax)
})).max(decideManagedDocumentAiProposalResponseSowOneFactsInvoicesMax),
  "milestoneDays": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialReviewReasonMin).max(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(decideManagedDocumentAiProposalResponseSowOneFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(decideManagedDocumentAiProposalResponseSowOneFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsUnresolvedFactsItemMessageMax)
})).max(decideManagedDocumentAiProposalResponseSowOneFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsCustomFieldsItemValueMax).nullable()
})).max(decideManagedDocumentAiProposalResponseSowOneFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsCustomProseItemTextMax)
})).max(decideManagedDocumentAiProposalResponseSowOneFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesItemRowsItemItemMax)).max(decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesItemRowsItemMax)).max(decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesItemRowsMax)
})).max(decideManagedDocumentAiProposalResponseSowOneFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
}),zod.null()]).optional(),
  "sowValidation": zod.union([zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),zod.null()]).optional(),
  "sowApprovalPolicy": zod.union([zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(decideManagedDocumentAiProposalResponseSowApprovalPolicyOneLocalRevisionMin),
  "fingerprint": zod.string().regex(decideManagedDocumentAiProposalResponseSowApprovalPolicyOneFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(decideManagedDocumentAiProposalResponseSowApprovalPolicyOneRevisionsItemRevisionMin)
})).max(decideManagedDocumentAiProposalResponseSowApprovalPolicyOneRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(decideManagedDocumentAiProposalResponseSowApprovalPolicyOneOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(decideManagedDocumentAiProposalResponseSowApprovalPolicyOneEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
}),zod.null()]).optional(),
  "sowApprovalStatus": zod.enum(['review_required', 'approved']).nullish(),
  "sowApprovalReason": zod.string().nullish(),
  "sowRequestId": zod.uuid().nullish(),
  "draft": zod.object({
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsTopMin).max(decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsRightMin).max(decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsBottomMin).max(decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsLeftMin).max(decideManagedDocumentAiProposalResponseDraftContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderItemContentMax).optional()
})).max(decideManagedDocumentAiProposalResponseDraftContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemTypeMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(decideManagedDocumentAiProposalResponseDraftContentLayoutFooterItemContentMax).optional()
})).max(decideManagedDocumentAiProposalResponseDraftContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(decideManagedDocumentAiProposalResponseDraftContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(decideManagedDocumentAiProposalResponseDraftContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(decideManagedDocumentAiProposalResponseDraftContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemFontSizeMin).max(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemSpaceBeforeMin).max(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemSpaceAfterMin).max(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsItemLineHeightMax)
})).min(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsMin).max(decideManagedDocumentAiProposalResponseDraftContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(decideManagedDocumentAiProposalResponseDraftContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(decideManagedDocumentAiProposalResponseDraftContentTemplateSectionGuidanceItemGuidanceMax)
})).max(decideManagedDocumentAiProposalResponseDraftContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseDraftContentContentItemTypeMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseDraftContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseDraftContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(decideManagedDocumentAiProposalResponseDraftContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(decideManagedDocumentAiProposalResponseDraftContentContentItemContentMax).optional()
})).max(decideManagedDocumentAiProposalResponseDraftContentContentMax)
}),
  "contentHash": zod.string().regex(decideManagedDocumentAiProposalResponseDraftContentHashRegExp),
  "conversionWarnings": zod.array(zod.string()),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "versions": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "majorVersion": zod.int().min(decideManagedDocumentAiProposalResponseVersionsItemMajorVersionMin),
  "minorVersion": zod.int().min(decideManagedDocumentAiProposalResponseVersionsItemMinorVersionMin),
  "kind": zod.enum(['draft', 'review', 'publication', 'restore', 'import']),
  "title": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsTopMin).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsRightMin).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsBottomMin).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsLeftMin).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderItemContentMax).optional()
})).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterItemContentMax).optional()
})).max(decideManagedDocumentAiProposalResponseVersionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(decideManagedDocumentAiProposalResponseVersionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemFontSizeMin).max(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMin).max(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsMin).max(decideManagedDocumentAiProposalResponseVersionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(decideManagedDocumentAiProposalResponseVersionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(decideManagedDocumentAiProposalResponseVersionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(decideManagedDocumentAiProposalResponseVersionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentContentItemTypeMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseVersionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseVersionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(decideManagedDocumentAiProposalResponseVersionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(decideManagedDocumentAiProposalResponseVersionsItemContentContentItemContentMax).optional()
})).max(decideManagedDocumentAiProposalResponseVersionsItemContentContentMax)
}).optional(),
  "contentHash": zod.string(),
  "reason": zod.string(),
  "actorId": zod.uuid().nullish(),
  "restoredFromVersionId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "reviews": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'cancelled', 'invalidated']),
  "sowApprovalCurrent": zod.boolean().nullish(),
  "submissionNote": zod.string().nullish(),
  "policyVersion": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "comments": zod.array(zod.object({
  "id": zod.uuid(),
  "versionId": zod.uuid(),
  "body": zod.string(),
  "anchor": zod.record(zod.string(), zod.unknown()),
  "resolved": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "decisions": zod.array(zod.record(zod.string(), zod.unknown()))
})),
  "aiProposals": zod.array(zod.object({
  "id": zod.uuid(),
  "draftRevision": zod.int(),
  "contentHash": zod.string(),
  "action": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "proposedContent": zod.union([zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMin).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMin).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMin).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMin).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemTypeMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderItemContentMax).optional()
})).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemTypeMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterItemContentMax).optional()
})).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMin).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMin).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMin).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsItemLineHeightMax)
})).min(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsMin).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceItemGuidanceMax)
})).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemTypeMax),
  "text": zod.string().max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentItemContentMax).optional()
})).max(decideManagedDocumentAiProposalResponseAiProposalsItemProposedContentOneContentMax)
}),zod.null()]).optional(),
  "findings": zod.array(zod.record(zod.string(), zod.unknown())),
  "sources": zod.array(zod.record(zod.string(), zod.unknown())),
  "limitations": zod.array(zod.string()),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "publication": zod.union([zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Governed by the `document_proofing` AI action. Accepts at most 8 plain-text paragraphs of up to 2,000 characters from the open document. Suggestions are returned for the person to accept or dismiss one by one; nothing is stored or applied to the document.
 * @summary Suggest AI spelling and grammar fixes for paragraphs of a managed document
 */
export const proofManagedDocumentParams = zod.object({
  "id": zod.uuid()
})

export const proofManagedDocumentBodyParagraphsItemIdRegExp = new RegExp('^[A-Za-z0-9_-]{1,64}$');
export const proofManagedDocumentBodyParagraphsItemTextMax = 2000;

export const proofManagedDocumentBodyParagraphsMax = 8;



export const proofManagedDocumentBody = zod.object({
  "paragraphs": zod.array(zod.object({
  "id": zod.string().regex(proofManagedDocumentBodyParagraphsItemIdRegExp),
  "text": zod.string().min(1).max(proofManagedDocumentBodyParagraphsItemTextMax)
})).min(1).max(proofManagedDocumentBodyParagraphsMax)
}).describe('Plain-text paragraphs from the open document. Text is treated as untrusted data and is never stored.')

export const proofManagedDocumentResponseIssuesItemStartMin = 0;


export const proofManagedDocumentResponseIssuesMax = 60;



export const proofManagedDocumentResponse = zod.object({
  "issues": zod.array(zod.object({
  "paragraphId": zod.string(),
  "start": zod.int().min(proofManagedDocumentResponseIssuesItemStartMin).describe('Offset into the paragraph text'),
  "end": zod.int().min(1).describe('Exclusive end offset into the paragraph text'),
  "original": zod.string().describe('Exact text at the offsets'),
  "replacement": zod.string().describe('Suggested text; empty means remove the original'),
  "kind": zod.enum(['spelling', 'grammar']),
  "confidence": zod.enum(['obvious', 'likely', 'unsure']),
  "reason": zod.string()
})).max(proofManagedDocumentResponseIssuesMax),
  "auditId": zod.uuid()
})


/**
 * @summary Evaluate a pending review against entity evidence policy
 */
export const evaluateManagedDocumentAiApprovalParams = zod.object({
  "id": zod.uuid()
})

export const evaluateManagedDocumentAiApprovalResponseConfidenceBasisPointsMin = 0;
export const evaluateManagedDocumentAiApprovalResponseConfidenceBasisPointsMax = 10000;

export const evaluateManagedDocumentAiApprovalResponseComparableHumanDecisionsMin = 0;

export const evaluateManagedDocumentAiApprovalResponseApprovedWithoutChangesMin = 0;

export const evaluateManagedDocumentAiApprovalResponseEditedApprovalsMin = 0;

export const evaluateManagedDocumentAiApprovalResponseRejectionsMin = 0;

export const evaluateManagedDocumentAiApprovalResponseReversalsMin = 0;



export const evaluateManagedDocumentAiApprovalResponse = zod.object({
  "id": zod.uuid(),
  "outcome": zod.enum(['eligible', 'escalated', 'failed', 'stale']),
  "confidenceBasisPoints": zod.int().min(evaluateManagedDocumentAiApprovalResponseConfidenceBasisPointsMin).max(evaluateManagedDocumentAiApprovalResponseConfidenceBasisPointsMax),
  "comparableHumanDecisions": zod.int().min(evaluateManagedDocumentAiApprovalResponseComparableHumanDecisionsMin),
  "approvedWithoutChanges": zod.int().min(evaluateManagedDocumentAiApprovalResponseApprovedWithoutChangesMin),
  "editedApprovals": zod.int().min(evaluateManagedDocumentAiApprovalResponseEditedApprovalsMin),
  "rejections": zod.int().min(evaluateManagedDocumentAiApprovalResponseRejectionsMin),
  "reversals": zod.int().min(evaluateManagedDocumentAiApprovalResponseReversalsMin),
  "reasons": zod.array(zod.string()),
  "policyVersion": zod.int(),
  "modelVersion": zod.string(),
  "instructionVersion": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Explicitly publish the latest valid approved snapshot
 */
export const publishManagedDocumentParams = zod.object({
  "id": zod.uuid()
})

export const publishManagedDocumentHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const publishManagedDocumentHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(publishManagedDocumentHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const publishManagedDocumentBodyReasonMax = 2000;



export const publishManagedDocumentBody = zod.object({
  "reason": zod.string().min(1).max(publishManagedDocumentBodyReasonMax)
})




export const publishManagedDocumentResponse = zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Unpublish, revoke, or archive a public document link
 */
export const changeManagedDocumentPublicationStateParams = zod.object({
  "id": zod.uuid()
})

export const changeManagedDocumentPublicationStateBodyReasonMax = 2000;




export const changeManagedDocumentPublicationStateBody = zod.object({
  "state": zod.enum(['unpublished', 'revoked', 'archived']),
  "reason": zod.string().min(1).max(changeManagedDocumentPublicationStateBodyReasonMax),
  "expectedRevision": zod.int().min(1)
})




export const changeManagedDocumentPublicationStateResponse = zod.object({
  "publicId": zod.uuid(),
  "status": zod.enum(['active', 'unpublished', 'revoked', 'archived']),
  "revision": zod.int().min(1),
  "publicUrl": zod.string(),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Read only the latest explicitly published major snapshot
 */
export const getPublicManagedDocumentParams = zod.object({
  "publicId": zod.uuid()
})

export const getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsTopMin = 5;
export const getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsTopMax = 50;

export const getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsRightMin = 5;
export const getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsRightMax = 50;

export const getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsBottomMin = 5;
export const getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsBottomMax = 50;

export const getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsLeftMin = 5;
export const getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsLeftMax = 50;

export const getPublicManagedDocumentResponseContentLayoutHeaderItemTypeMax = 40;

export const getPublicManagedDocumentResponseContentLayoutHeaderItemTextMax = 200000;

export const getPublicManagedDocumentResponseContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getPublicManagedDocumentResponseContentLayoutHeaderItemMarksMax = 20;

export const getPublicManagedDocumentResponseContentLayoutHeaderItemContentMax = 10000;

export const getPublicManagedDocumentResponseContentLayoutHeaderMax = 100;

export const getPublicManagedDocumentResponseContentLayoutFooterItemTypeMax = 40;

export const getPublicManagedDocumentResponseContentLayoutFooterItemTextMax = 200000;

export const getPublicManagedDocumentResponseContentLayoutFooterItemMarksItemTypeMax = 40;

export const getPublicManagedDocumentResponseContentLayoutFooterItemMarksMax = 20;

export const getPublicManagedDocumentResponseContentLayoutFooterItemContentMax = 10000;

export const getPublicManagedDocumentResponseContentLayoutFooterMax = 100;

export const getPublicManagedDocumentResponseContentSectionsItemsItemTitleMax = 160;

export const getPublicManagedDocumentResponseContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getPublicManagedDocumentResponseContentSectionsItemsMax = 200;

export const getPublicManagedDocumentResponseContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getPublicManagedDocumentResponseContentStylesDefinitionsItemNameMax = 80;

export const getPublicManagedDocumentResponseContentStylesDefinitionsItemFontSizeMin = 6;
export const getPublicManagedDocumentResponseContentStylesDefinitionsItemFontSizeMax = 96;

export const getPublicManagedDocumentResponseContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getPublicManagedDocumentResponseContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getPublicManagedDocumentResponseContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getPublicManagedDocumentResponseContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getPublicManagedDocumentResponseContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getPublicManagedDocumentResponseContentStylesDefinitionsItemLineHeightMax = 3;

export const getPublicManagedDocumentResponseContentStylesDefinitionsMin = 7;
export const getPublicManagedDocumentResponseContentStylesDefinitionsMax = 100;

export const getPublicManagedDocumentResponseContentTemplateGuidanceMax = 4000;

export const getPublicManagedDocumentResponseContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getPublicManagedDocumentResponseContentTemplateSectionGuidanceMax = 200;

export const getPublicManagedDocumentResponseContentContentItemTypeMax = 40;

export const getPublicManagedDocumentResponseContentContentItemTextMax = 200000;

export const getPublicManagedDocumentResponseContentContentItemMarksItemTypeMax = 40;

export const getPublicManagedDocumentResponseContentContentItemMarksMax = 20;

export const getPublicManagedDocumentResponseContentContentItemContentMax = 10000;

export const getPublicManagedDocumentResponseContentContentMax = 10000;



export const getPublicManagedDocumentResponse = zod.object({
  "title": zod.string(),
  "version": zod.string(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsTopMin).max(getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsRightMin).max(getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsBottomMin).max(getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsLeftMin).max(getPublicManagedDocumentResponseContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getPublicManagedDocumentResponseContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getPublicManagedDocumentResponseContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getPublicManagedDocumentResponseContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getPublicManagedDocumentResponseContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getPublicManagedDocumentResponseContentLayoutHeaderItemContentMax).optional()
})).max(getPublicManagedDocumentResponseContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getPublicManagedDocumentResponseContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getPublicManagedDocumentResponseContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getPublicManagedDocumentResponseContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getPublicManagedDocumentResponseContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getPublicManagedDocumentResponseContentLayoutFooterItemContentMax).optional()
})).max(getPublicManagedDocumentResponseContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getPublicManagedDocumentResponseContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getPublicManagedDocumentResponseContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getPublicManagedDocumentResponseContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getPublicManagedDocumentResponseContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getPublicManagedDocumentResponseContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getPublicManagedDocumentResponseContentStylesDefinitionsItemFontSizeMin).max(getPublicManagedDocumentResponseContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getPublicManagedDocumentResponseContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getPublicManagedDocumentResponseContentStylesDefinitionsItemSpaceBeforeMin).max(getPublicManagedDocumentResponseContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getPublicManagedDocumentResponseContentStylesDefinitionsItemSpaceAfterMin).max(getPublicManagedDocumentResponseContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getPublicManagedDocumentResponseContentStylesDefinitionsItemLineHeightMax)
})).min(getPublicManagedDocumentResponseContentStylesDefinitionsMin).max(getPublicManagedDocumentResponseContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getPublicManagedDocumentResponseContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getPublicManagedDocumentResponseContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getPublicManagedDocumentResponseContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getPublicManagedDocumentResponseContentContentItemTypeMax),
  "text": zod.string().max(getPublicManagedDocumentResponseContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getPublicManagedDocumentResponseContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getPublicManagedDocumentResponseContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getPublicManagedDocumentResponseContentContentItemContentMax).optional()
})).max(getPublicManagedDocumentResponseContentContentMax)
}),
  "publishedAt": zod.iso.datetime({"offset":true}),
  "representations": zod.array(zod.object({
  "format": zod.enum(['docx', 'pdf']),
  "url": zod.string()
}))
})


/**
 * @summary Download a public approved representation
 */
export const downloadPublicManagedDocumentParams = zod.object({
  "publicId": zod.uuid(),
  "format": zod.enum(['docx', 'pdf'])
})

export const downloadPublicManagedDocumentResponse = zod.unknown()


/**
 * @summary Signed-in portal identity and account match
 */
export const getPortalMeHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})




export const getPortalMeResponse = zod.object({
  "role": zod.enum(['member', 'entity_admin', 'viewer', 'actor']).describe('Authorization role within the active portal context.'),
  "matched": zod.boolean().describe('True when the signed-in email matched a CRM contact or active portal-user email for an entity account.'),
  "contactName": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "user": zod.object({
  "email": zod.email(),
  "name": zod.string()
}),
  "contexts": zod.array(zod.object({
  "kind": zod.enum(['organisation', 'self', 'delegate']),
  "accessType": zod.enum(['contact', 'membership', 'self', 'share']),
  "role": zod.enum(['member', 'entity_admin', 'viewer', 'actor']).describe('Authorization role within the active portal context.'),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "contactId": zod.uuid().nullable(),
  "contactName": zod.string(),
  "contactEmail": zod.email(),
  "accountId": zod.uuid(),
  "personAccountId": zod.uuid().optional(),
  "membershipId": zod.uuid().optional(),
  "shareId": zod.uuid().optional(),
  "onBehalfOf": zod.object({
  "name": zod.string(),
  "email": zod.email()
}).optional(),
  "companyName": zod.string(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])
})).min(1),
  "active": zod.object({
  "kind": zod.enum(['organisation', 'self', 'delegate']),
  "accessType": zod.enum(['contact', 'membership', 'self', 'share']),
  "role": zod.enum(['member', 'entity_admin', 'viewer', 'actor']).describe('Authorization role within the active portal context.'),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "contactId": zod.uuid().nullable(),
  "contactName": zod.string(),
  "contactEmail": zod.email(),
  "accountId": zod.uuid(),
  "personAccountId": zod.uuid().optional(),
  "membershipId": zod.uuid().optional(),
  "shareId": zod.uuid().optional(),
  "onBehalfOf": zod.object({
  "name": zod.string(),
  "email": zod.email()
}).optional(),
  "companyName": zod.string(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other'])
})
})


/**
 * @summary Account-scoped engagement overview for the signed-in portal user
 */
export const getPortalOverviewHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const getPortalOverviewResponse = zod.object({
  "companyName": zod.string(),
  "enquiries": zod.array(zod.object({
  "id": zod.uuid(),
  "subject": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "submittedByEmail": zod.email().nullable(),
  "submittedOnBehalfOf": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "opportunities": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "stageLabel": zod.string().describe('Customer-friendly wording of the internal pipeline stage.'),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "updates": zod.array(zod.object({
  "id": zod.uuid(),
  "body": zod.string(),
  "context": zod.string().describe('Which record this update relates to (enquiry/engagement).'),
  "createdAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary External-safe profile for the signed-in portal user's entity
 */
export const getPortalProfileHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const getPortalProfileResponse = zod.object({
  "profile": zod.union([zod.object({
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "organisationType": zod.string().nullable(),
  "industry": zod.string().nullable(),
  "website": zod.string().nullable(),
  "email": zod.string().nullable(),
  "phone": zod.string().nullable(),
  "addressLine1": zod.string().nullable(),
  "addressLine2": zod.string().nullable(),
  "city": zod.string().nullable(),
  "stateProvince": zod.string().nullable(),
  "postcode": zod.string().nullable(),
  "country": zod.string().nullable()
}).describe('External-safe entity profile. Internal owners, notes, scoring and classifications are omitted.'),zod.null()])
})


/**
 * @summary Account-scoped agreements for the signed-in portal user
 */
export const getPortalAgreementsHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const getPortalAgreementsResponseTotalMin = 0;



export const getPortalAgreementsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "type": zod.enum(['nda', 'msa', 'partner', 'referral', 'other']),
  "status": zod.enum(['draft', 'pending', 'active', 'expired', 'terminated']),
  "signedDate": zod.iso.datetime({"offset":true}).nullable(),
  "expiryDate": zod.iso.datetime({"offset":true}).nullable()
}).describe('External-safe agreement summary. Internal notes and document locations are omitted.')),
  "total": zod.int().min(getPortalAgreementsResponseTotalMin)
})


/**
 * @summary Account-scoped products and services for the signed-in portal user
 */
export const getPortalProductsHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const getPortalProductsResponseTotalMin = 0;



export const getPortalProductsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "itemType": zod.enum(['product', 'module', 'service']),
  "status": zod.enum(['active', 'pending', 'expired', 'cancelled']),
  "procuredDate": zod.iso.datetime({"offset":true}).nullable(),
  "startDate": zod.iso.datetime({"offset":true}).nullable(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullable(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullable(),
  "autoRenew": zod.boolean(),
  "billingFrequency": zod.enum(['monthly', 'quarterly', 'annual', 'one_time']).nullable()
}).describe('External-safe product or service summary. Internal notes, values and catalogue identifiers are omitted.')),
  "total": zod.int().min(getPortalProductsResponseTotalMin)
})


/**
 * @summary Account-scoped interaction history for the signed-in portal user
 */
export const getPortalInteractionsHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const getPortalInteractionsResponseTotalMin = 0;



export const getPortalInteractionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "contactName": zod.string().nullable(),
  "type": zod.enum(['meeting', 'call', 'email', 'presentation', 'event', 'other']),
  "direction": zod.enum(['inbound', 'outbound']),
  "subject": zod.string(),
  "interactionDate": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['planned', 'completed', 'cancelled'])
}).describe('External-safe interaction summary. Internal notes and follow-up metadata are omitted.')),
  "total": zod.int().min(getPortalInteractionsResponseTotalMin)
})


/**
 * @summary Supplier finance summary for the active portal organisation
 */
export const getPortalFinanceSummaryHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const getPortalFinanceSummaryResponseCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getPortalFinanceSummaryResponseOverdueCountMin = 0;

export const getPortalFinanceSummaryResponseLastPaymentOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');


export const getPortalFinanceSummaryResponse = zod.object({
  "outstandingTotal": zod.string(),
  "currency": zod.string().regex(getPortalFinanceSummaryResponseCurrencyRegExp),
  "overdueCount": zod.int().min(getPortalFinanceSummaryResponseOverdueCountMin),
  "lastPayment": zod.union([zod.object({
  "amount": zod.string(),
  "currency": zod.string().regex(getPortalFinanceSummaryResponseLastPaymentOneCurrencyRegExp),
  "paymentDate": zod.iso.datetime({"offset":true}),
  "invoiceNumber": zod.string()
}),zod.null()]),
  "connected": zod.boolean(),
  "lastSyncAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary List locally synced invoices or bills for the active supplier organisation
 */
export const listPortalFinanceInvoicesQueryLimitDefault = 50;
export const listPortalFinanceInvoicesQueryLimitMax = 100;

export const listPortalFinanceInvoicesQueryOffsetDefault = 0;
export const listPortalFinanceInvoicesQueryOffsetMin = 0;



export const listPortalFinanceInvoicesQueryParams = zod.object({
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']).optional(),
  "dateFrom": zod.iso.date().optional(),
  "dateTo": zod.iso.date().optional(),
  "limit": zod.int().min(1).max(listPortalFinanceInvoicesQueryLimitMax).default(listPortalFinanceInvoicesQueryLimitDefault),
  "offset": zod.int().min(listPortalFinanceInvoicesQueryOffsetMin).default(listPortalFinanceInvoicesQueryOffsetDefault)
})

export const listPortalFinanceInvoicesHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const listPortalFinanceInvoicesResponseDataItemCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listPortalFinanceInvoicesResponseTotalMin = 0;



export const listPortalFinanceInvoicesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullable(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "currency": zod.string().regex(listPortalFinanceInvoicesResponseDataItemCurrencyRegExp),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullable(),
  "lastSyncedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPortalFinanceInvoicesResponseTotalMin)
})


/**
 * @summary Get one locally synced supplier invoice or bill with line items
 */
export const getPortalFinanceInvoiceParams = zod.object({
  "id": zod.uuid()
})

export const getPortalFinanceInvoiceHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const getPortalFinanceInvoiceResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');


export const getPortalFinanceInvoiceResponse = zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullable(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "currency": zod.string().regex(getPortalFinanceInvoiceResponseOneCurrencyRegExp),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullable(),
  "lastSyncedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "description": zod.string(),
  "quantity": zod.string(),
  "unitAmount": zod.string().nullable(),
  "lineAmount": zod.string().nullable(),
  "taxAmount": zod.string(),
  "sortOrder": zod.int()
}))
}))


/**
 * @summary List payments for the active supplier organisation's synced documents
 */
export const listPortalFinancePaymentsQueryLimitDefault = 50;
export const listPortalFinancePaymentsQueryLimitMax = 100;

export const listPortalFinancePaymentsQueryOffsetDefault = 0;
export const listPortalFinancePaymentsQueryOffsetMin = 0;



export const listPortalFinancePaymentsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPortalFinancePaymentsQueryLimitMax).default(listPortalFinancePaymentsQueryLimitDefault),
  "offset": zod.int().min(listPortalFinancePaymentsQueryOffsetMin).default(listPortalFinancePaymentsQueryOffsetDefault)
})

export const listPortalFinancePaymentsHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const listPortalFinancePaymentsResponseDataItemCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listPortalFinancePaymentsResponseTotalMin = 0;



export const listPortalFinancePaymentsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "invoiceId": zod.uuid(),
  "invoiceNumber": zod.string(),
  "amount": zod.string(),
  "currency": zod.string().regex(listPortalFinancePaymentsResponseDataItemCurrencyRegExp),
  "paymentDate": zod.iso.datetime({"offset":true}),
  "method": zod.enum(['bank_transfer', 'manual', 'card', 'other']),
  "reference": zod.string().nullable()
})),
  "total": zod.int().min(listPortalFinancePaymentsResponseTotalMin)
})


/**
 * @summary List portal users for the signed-in entity administrator's own entity
 */
export const listPortalUsersHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const listPortalUsersResponseTotalMin = 0;



export const listPortalUsersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "email": zod.email(),
  "name": zod.string().nullable(),
  "role": zod.string().nullable(),
  "isActive": zod.boolean(),
  "isAdmin": zod.boolean(),
  "lastSignedInAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int().min(listPortalUsersResponseTotalMin)
})


/**
 * @summary Add an active member to the signed-in entity administrator's own entity
 */
export const createPortalUserHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const createPortalUserBodyNameMax = 200;

export const createPortalUserBodyRoleMax = 200;



export const createPortalUserBody = zod.object({
  "email": zod.email(),
  "name": zod.string().max(createPortalUserBodyNameMax).nullish(),
  "role": zod.string().max(createPortalUserBodyRoleMax).nullish()
})

export const createPortalUserResponse = zod.object({
  "id": zod.uuid(),
  "email": zod.email(),
  "name": zod.string().nullable(),
  "role": zod.string().nullable(),
  "isActive": zod.boolean(),
  "isAdmin": zod.boolean(),
  "lastSignedInAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Update access or entity-admin status within the caller's own entity
 */
export const updatePortalUserParams = zod.object({
  "id": zod.uuid()
})

export const updatePortalUserHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const updatePortalUserBody = zod.object({
  "isActive": zod.boolean().optional(),
  "isAdmin": zod.boolean().optional()
})

export const updatePortalUserResponse = zod.object({
  "id": zod.uuid(),
  "email": zod.email(),
  "name": zod.string().nullable(),
  "role": zod.string().nullable(),
  "isActive": zod.boolean(),
  "isAdmin": zod.boolean(),
  "lastSignedInAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary List shares created by the consumer in the active self context
 */
export const listPortalSharesHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const listPortalSharesResponseTotalMin = 0;



export const listPortalSharesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "ownerAccountId": zod.uuid(),
  "granteeEmail": zod.email(),
  "granteeName": zod.string().nullable(),
  "permission": zod.enum(['view', 'act']),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdByEmail": zod.email(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listPortalSharesResponseTotalMin)
})


/**
 * @summary Share the active consumer account with another person
 */
export const createPortalShareHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const createPortalShareBodyGranteeNameMax = 200;



export const createPortalShareBody = zod.object({
  "granteeEmail": zod.email(),
  "granteeName": zod.string().max(createPortalShareBodyGranteeNameMax).nullish(),
  "permission": zod.enum(['view', 'act']),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
})

export const createPortalShareResponse = zod.object({
  "id": zod.uuid(),
  "ownerAccountId": zod.uuid(),
  "granteeEmail": zod.email(),
  "granteeName": zod.string().nullable(),
  "permission": zod.enum(['view', 'act']),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdByEmail": zod.email(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Change a consumer share permission or expiry
 */
export const updatePortalShareParams = zod.object({
  "id": zod.uuid()
})

export const updatePortalShareHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const updatePortalShareBody = zod.object({
  "permission": zod.enum(['view', 'act']).optional(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
})

export const updatePortalShareResponse = zod.object({
  "id": zod.uuid(),
  "ownerAccountId": zod.uuid(),
  "granteeEmail": zod.email(),
  "granteeName": zod.string().nullable(),
  "permission": zod.enum(['view', 'act']),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdByEmail": zod.email(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Revoke a consumer portal share immediately
 */
export const revokePortalShareParams = zod.object({
  "id": zod.uuid()
})

export const revokePortalShareHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const revokePortalShareResponse = zod.void()


/**
 * @summary Submit a new enquiry as the signed-in portal user
 */
export const createPortalEnquiryHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const createPortalEnquiryBodySubjectMax = 200;

export const createPortalEnquiryBodyMessageMax = 5000;



export const createPortalEnquiryBody = zod.object({
  "subject": zod.string().max(createPortalEnquiryBodySubjectMax).optional(),
  "message": zod.string().min(1).max(createPortalEnquiryBodyMessageMax)
})

export const createPortalEnquiryResponse = zod.object({
  "id": zod.uuid(),
  "subject": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "submittedByEmail": zod.email().nullable(),
  "submittedOnBehalfOf": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary list Portal Sow Requests
 */
export const listPortalSowRequestsQueryLimitDefault = 20;
export const listPortalSowRequestsQueryLimitMax = 20;

export const listPortalSowRequestsQueryOffsetDefault = 0;
export const listPortalSowRequestsQueryOffsetMin = 0;



export const listPortalSowRequestsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPortalSowRequestsQueryLimitMax).default(listPortalSowRequestsQueryLimitDefault),
  "offset": zod.int().min(listPortalSowRequestsQueryOffsetMin).default(listPortalSowRequestsQueryOffsetDefault)
})

export const listPortalSowRequestsHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})


export const listPortalSowRequestsResponseItemsItemSummaryMax = 12000;

export const listPortalSowRequestsResponseItemsItemGuidanceMax = 1000;

export const listPortalSowRequestsResponseItemsItemMessagesItemTextMax = 4000;

export const listPortalSowRequestsResponseItemsItemMessagesMax = 15;

export const listPortalSowRequestsResponseItemsItemAttachmentsItemFilenameMax = 120;

export const listPortalSowRequestsResponseItemsItemAttachmentsMax = 5;

export const listPortalSowRequestsResponseItemsItemStatusMessageMax = 1000;

export const listPortalSowRequestsResponseItemsMax = 20;

export const listPortalSowRequestsResponseTotalMin = 0;

export const listPortalSowRequestsResponseLimitMax = 20;

export const listPortalSowRequestsResponseOffsetMin = 0;



export const listPortalSowRequestsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "summary": zod.string().max(listPortalSowRequestsResponseItemsItemSummaryMax),
  "guidance": zod.string().max(listPortalSowRequestsResponseItemsItemGuidanceMax),
  "messages": zod.array(zod.object({
  "id": zod.uuid(),
  "text": zod.string().max(listPortalSowRequestsResponseItemsItemMessagesItemTextMax)
})).max(listPortalSowRequestsResponseItemsItemMessagesMax),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(listPortalSowRequestsResponseItemsItemAttachmentsItemFilenameMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(listPortalSowRequestsResponseItemsItemAttachmentsMax),
  "status": zod.enum(['draft', 'received', 'processing', 'needs_information', 'failed', 'completed_for_staff']),
  "statusMessage": zod.string().max(listPortalSowRequestsResponseItemsItemStatusMessageMax),
  "submitted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listPortalSowRequestsResponseItemsMax),
  "total": zod.int().min(listPortalSowRequestsResponseTotalMin),
  "limit": zod.int().min(1).max(listPortalSowRequestsResponseLimitMax),
  "offset": zod.int().min(listPortalSowRequestsResponseOffsetMin)
})


/**
 * @summary create Portal Sow Request
 */
export const createPortalSowRequestHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const createPortalSowRequestBodyMessageMax = 4000;



export const createPortalSowRequestBody = zod.object({
  "idempotencyKey": zod.uuid(),
  "message": zod.string().min(1).max(createPortalSowRequestBodyMessageMax)
})


export const createPortalSowRequestResponseSummaryMax = 12000;

export const createPortalSowRequestResponseGuidanceMax = 1000;

export const createPortalSowRequestResponseMessagesItemTextMax = 4000;

export const createPortalSowRequestResponseMessagesMax = 15;

export const createPortalSowRequestResponseAttachmentsItemFilenameMax = 120;

export const createPortalSowRequestResponseAttachmentsMax = 5;

export const createPortalSowRequestResponseStatusMessageMax = 1000;



export const createPortalSowRequestResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "summary": zod.string().max(createPortalSowRequestResponseSummaryMax),
  "guidance": zod.string().max(createPortalSowRequestResponseGuidanceMax),
  "messages": zod.array(zod.object({
  "id": zod.uuid(),
  "text": zod.string().max(createPortalSowRequestResponseMessagesItemTextMax)
})).max(createPortalSowRequestResponseMessagesMax),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(createPortalSowRequestResponseAttachmentsItemFilenameMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(createPortalSowRequestResponseAttachmentsMax),
  "status": zod.enum(['draft', 'received', 'processing', 'needs_information', 'failed', 'completed_for_staff']),
  "statusMessage": zod.string().max(createPortalSowRequestResponseStatusMessageMax),
  "submitted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary get Portal Sow Request
 */
export const getPortalSowRequestParams = zod.object({
  "id": zod.uuid()
})

export const getPortalSowRequestHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})


export const getPortalSowRequestResponseSummaryMax = 12000;

export const getPortalSowRequestResponseGuidanceMax = 1000;

export const getPortalSowRequestResponseMessagesItemTextMax = 4000;

export const getPortalSowRequestResponseMessagesMax = 15;

export const getPortalSowRequestResponseAttachmentsItemFilenameMax = 120;

export const getPortalSowRequestResponseAttachmentsMax = 5;

export const getPortalSowRequestResponseStatusMessageMax = 1000;



export const getPortalSowRequestResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "summary": zod.string().max(getPortalSowRequestResponseSummaryMax),
  "guidance": zod.string().max(getPortalSowRequestResponseGuidanceMax),
  "messages": zod.array(zod.object({
  "id": zod.uuid(),
  "text": zod.string().max(getPortalSowRequestResponseMessagesItemTextMax)
})).max(getPortalSowRequestResponseMessagesMax),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(getPortalSowRequestResponseAttachmentsItemFilenameMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(getPortalSowRequestResponseAttachmentsMax),
  "status": zod.enum(['draft', 'received', 'processing', 'needs_information', 'failed', 'completed_for_staff']),
  "statusMessage": zod.string().max(getPortalSowRequestResponseStatusMessageMax),
  "submitted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary add Portal Sow Message
 */
export const addPortalSowMessageParams = zod.object({
  "id": zod.uuid()
})

export const addPortalSowMessageHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})


export const addPortalSowMessageBodyMessageMax = 4000;



export const addPortalSowMessageBody = zod.object({
  "operationId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "message": zod.string().min(1).max(addPortalSowMessageBodyMessageMax)
})


export const addPortalSowMessageResponseSummaryMax = 12000;

export const addPortalSowMessageResponseGuidanceMax = 1000;

export const addPortalSowMessageResponseMessagesItemTextMax = 4000;

export const addPortalSowMessageResponseMessagesMax = 15;

export const addPortalSowMessageResponseAttachmentsItemFilenameMax = 120;

export const addPortalSowMessageResponseAttachmentsMax = 5;

export const addPortalSowMessageResponseStatusMessageMax = 1000;



export const addPortalSowMessageResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "summary": zod.string().max(addPortalSowMessageResponseSummaryMax),
  "guidance": zod.string().max(addPortalSowMessageResponseGuidanceMax),
  "messages": zod.array(zod.object({
  "id": zod.uuid(),
  "text": zod.string().max(addPortalSowMessageResponseMessagesItemTextMax)
})).max(addPortalSowMessageResponseMessagesMax),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(addPortalSowMessageResponseAttachmentsItemFilenameMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(addPortalSowMessageResponseAttachmentsMax),
  "status": zod.enum(['draft', 'received', 'processing', 'needs_information', 'failed', 'completed_for_staff']),
  "statusMessage": zod.string().max(addPortalSowMessageResponseStatusMessageMax),
  "submitted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary add Portal Sow Attachment
 */
export const addPortalSowAttachmentParams = zod.object({
  "id": zod.uuid()
})

export const addPortalSowAttachmentHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})


export const addPortalSowAttachmentBodyFilenameMax = 120;


export const addPortalSowAttachmentBodyFilenameRegExp = new RegExp('^[^/\\\\]+$');
export const addPortalSowAttachmentBodyContentTypeMax = 200;

export const addPortalSowAttachmentBodyDataMin = 4;
export const addPortalSowAttachmentBodyDataMax = 5592408;


export const addPortalSowAttachmentBodyDataRegExp = new RegExp('^[A-Za-z0-9+/]+={0,2}$');


export const addPortalSowAttachmentBody = zod.object({
  "operationId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "filename": zod.string().min(1).max(addPortalSowAttachmentBodyFilenameMax).regex(addPortalSowAttachmentBodyFilenameRegExp),
  "contentType": zod.string().min(1).max(addPortalSowAttachmentBodyContentTypeMax),
  "data": zod.string().min(addPortalSowAttachmentBodyDataMin).max(addPortalSowAttachmentBodyDataMax).regex(addPortalSowAttachmentBodyDataRegExp)
})


export const addPortalSowAttachmentResponseSummaryMax = 12000;

export const addPortalSowAttachmentResponseGuidanceMax = 1000;

export const addPortalSowAttachmentResponseMessagesItemTextMax = 4000;

export const addPortalSowAttachmentResponseMessagesMax = 15;

export const addPortalSowAttachmentResponseAttachmentsItemFilenameMax = 120;

export const addPortalSowAttachmentResponseAttachmentsMax = 5;

export const addPortalSowAttachmentResponseStatusMessageMax = 1000;



export const addPortalSowAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "summary": zod.string().max(addPortalSowAttachmentResponseSummaryMax),
  "guidance": zod.string().max(addPortalSowAttachmentResponseGuidanceMax),
  "messages": zod.array(zod.object({
  "id": zod.uuid(),
  "text": zod.string().max(addPortalSowAttachmentResponseMessagesItemTextMax)
})).max(addPortalSowAttachmentResponseMessagesMax),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(addPortalSowAttachmentResponseAttachmentsItemFilenameMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(addPortalSowAttachmentResponseAttachmentsMax),
  "status": zod.enum(['draft', 'received', 'processing', 'needs_information', 'failed', 'completed_for_staff']),
  "statusMessage": zod.string().max(addPortalSowAttachmentResponseStatusMessageMax),
  "submitted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary get Portal Sow Attachment
 */
export const getPortalSowAttachmentParams = zod.object({
  "id": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const getPortalSowAttachmentHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const getPortalSowAttachmentResponse = zod.unknown()


/**
 * @summary submit Portal Sow Request
 */
export const submitPortalSowRequestParams = zod.object({
  "id": zod.uuid()
})

export const submitPortalSowRequestHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})




export const submitPortalSowRequestBody = zod.object({
  "expectedRevision": zod.int().min(1)
})


export const submitPortalSowRequestResponseSummaryMax = 12000;

export const submitPortalSowRequestResponseGuidanceMax = 1000;

export const submitPortalSowRequestResponseMessagesItemTextMax = 4000;

export const submitPortalSowRequestResponseMessagesMax = 15;

export const submitPortalSowRequestResponseAttachmentsItemFilenameMax = 120;

export const submitPortalSowRequestResponseAttachmentsMax = 5;

export const submitPortalSowRequestResponseStatusMessageMax = 1000;



export const submitPortalSowRequestResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "summary": zod.string().max(submitPortalSowRequestResponseSummaryMax),
  "guidance": zod.string().max(submitPortalSowRequestResponseGuidanceMax),
  "messages": zod.array(zod.object({
  "id": zod.uuid(),
  "text": zod.string().max(submitPortalSowRequestResponseMessagesItemTextMax)
})).max(submitPortalSowRequestResponseMessagesMax),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(submitPortalSowRequestResponseAttachmentsItemFilenameMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(submitPortalSowRequestResponseAttachmentsMax),
  "status": zod.enum(['draft', 'received', 'processing', 'needs_information', 'failed', 'completed_for_staff']),
  "statusMessage": zod.string().max(submitPortalSowRequestResponseStatusMessageMax),
  "submitted": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Full service delivery hierarchy (area -> line -> component)
 */
export const getServiceCatalogueHierarchyResponse = zod.object({
  "areas": zod.array(zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).and(zod.object({
  "lines": zod.array(zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "areaId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).and(zod.object({
  "components": zod.array(zod.object({
  "description": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "lineId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})))
})))
})))
})


/**
 * @summary Create a service area
 */
export const createServiceAreaBodyTwoNameMax = 200;

export const createServiceAreaBodyTwoSlugMax = 200;



export const createServiceAreaBody = zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "name": zod.string().min(1).max(createServiceAreaBodyTwoNameMax),
  "slug": zod.string().min(1).max(createServiceAreaBodyTwoSlugMax)
}))

export const createServiceAreaResponse = zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a service area
 */
export const updateServiceAreaParams = zod.object({
  "id": zod.uuid()
})

export const updateServiceAreaBodyTwoNameMax = 200;

export const updateServiceAreaBodyTwoSlugMax = 200;



export const updateServiceAreaBody = zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "name": zod.string().min(1).max(updateServiceAreaBodyTwoNameMax).optional(),
  "slug": zod.string().min(1).max(updateServiceAreaBodyTwoSlugMax).optional()
}))

export const updateServiceAreaResponse = zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a service area
 */
export const deleteServiceAreaParams = zod.object({
  "id": zod.uuid()
})

export const deleteServiceAreaResponse = zod.void()


/**
 * @summary List service lines
 */
export const listServiceLinesQueryParams = zod.object({
  "areaId": zod.uuid().optional()
})

export const listServiceLinesResponseTotalMin = 0;



export const listServiceLinesResponse = zod.object({
  "items": zod.array(zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "areaId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listServiceLinesResponseTotalMin)
})


/**
 * @summary Create a service line
 */
export const createServiceLineBodyTwoNameMax = 200;

export const createServiceLineBodyTwoSlugMax = 200;



export const createServiceLineBody = zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "areaId": zod.uuid(),
  "name": zod.string().min(1).max(createServiceLineBodyTwoNameMax),
  "slug": zod.string().min(1).max(createServiceLineBodyTwoSlugMax)
}))

export const createServiceLineResponse = zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "areaId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a service line
 */
export const updateServiceLineParams = zod.object({
  "id": zod.uuid()
})

export const updateServiceLineBodyTwoNameMax = 200;

export const updateServiceLineBodyTwoSlugMax = 200;



export const updateServiceLineBody = zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "areaId": zod.uuid().optional(),
  "name": zod.string().min(1).max(updateServiceLineBodyTwoNameMax).optional(),
  "slug": zod.string().min(1).max(updateServiceLineBodyTwoSlugMax).optional()
}))

export const updateServiceLineResponse = zod.object({
  "description": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "areaId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a service line
 */
export const deleteServiceLineParams = zod.object({
  "id": zod.uuid()
})

export const deleteServiceLineResponse = zod.void()


/**
 * @summary List service components
 */
export const listServiceComponentsQueryParams = zod.object({
  "lineId": zod.uuid().optional()
})

export const listServiceComponentsResponseTotalMin = 0;



export const listServiceComponentsResponse = zod.object({
  "items": zod.array(zod.object({
  "description": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "lineId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listServiceComponentsResponseTotalMin)
})


/**
 * @summary Create a service component
 */
export const createServiceComponentBodyTwoNameMax = 200;

export const createServiceComponentBodyTwoSlugMax = 200;



export const createServiceComponentBody = zod.object({
  "description": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "lineId": zod.uuid(),
  "name": zod.string().min(1).max(createServiceComponentBodyTwoNameMax),
  "slug": zod.string().min(1).max(createServiceComponentBodyTwoSlugMax)
}))

export const createServiceComponentResponse = zod.object({
  "description": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "lineId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a service component
 */
export const updateServiceComponentParams = zod.object({
  "id": zod.uuid()
})

export const updateServiceComponentBodyTwoNameMax = 200;

export const updateServiceComponentBodyTwoSlugMax = 200;



export const updateServiceComponentBody = zod.object({
  "description": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "lineId": zod.uuid().optional(),
  "name": zod.string().min(1).max(updateServiceComponentBodyTwoNameMax).optional(),
  "slug": zod.string().min(1).max(updateServiceComponentBodyTwoSlugMax).optional()
}))

export const updateServiceComponentResponse = zod.object({
  "description": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "lineId": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a service component
 */
export const deleteServiceComponentParams = zod.object({
  "id": zod.uuid()
})

export const deleteServiceComponentResponse = zod.void()


/**
 * @summary List catalogue deliverables
 */
export const listCatalogueDeliverablesQueryParams = zod.object({
  "productId": zod.uuid().optional(),
  "moduleId": zod.uuid().optional(),
  "search": zod.string().optional()
})

export const listCatalogueDeliverablesResponseTotalMin = 0;



export const listCatalogueDeliverablesResponse = zod.object({
  "items": zod.array(zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "estimatedHours": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "title": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listCatalogueDeliverablesResponseTotalMin)
})


/**
 * @summary Create a catalogue deliverable (auto-generates a code when omitted)
 */
export const createCatalogueDeliverableBodyTwoTitleMax = 200;



export const createCatalogueDeliverableBody = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "estimatedHours": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "code": zod.string().optional().describe('Optional explicit code; auto-generated from category when omitted.'),
  "title": zod.string().min(1).max(createCatalogueDeliverableBodyTwoTitleMax)
}))

export const createCatalogueDeliverableResponse = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "estimatedHours": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "title": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Preview the next auto-generated deliverable code
 */
export const getNextDeliverableCodeQueryParams = zod.object({
  "category": zod.string().optional()
})

export const getNextDeliverableCodeResponse = zod.object({
  "code": zod.string()
})


/**
 * @summary Update a catalogue deliverable
 */
export const updateCatalogueDeliverableParams = zod.object({
  "id": zod.uuid()
})

export const updateCatalogueDeliverableBodyTwoTitleMax = 200;



export const updateCatalogueDeliverableBody = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "estimatedHours": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "code": zod.string().optional(),
  "title": zod.string().min(1).max(updateCatalogueDeliverableBodyTwoTitleMax).optional()
}))

export const updateCatalogueDeliverableResponse = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "estimatedHours": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "title": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a catalogue deliverable
 */
export const deleteCatalogueDeliverableParams = zod.object({
  "id": zod.uuid()
})

export const deleteCatalogueDeliverableResponse = zod.void()


/**
 * @summary List catalogue services
 */
export const listCatalogueServicesQueryParams = zod.object({
  "componentId": zod.uuid().optional(),
  "isFeatured": zod.boolean().optional(),
  "search": zod.string().optional()
})

export const listCatalogueServicesResponseTotalMin = 0;



export const listCatalogueServicesResponse = zod.object({
  "items": zod.array(zod.object({
  "componentId": zod.uuid().nullish(),
  "description": zod.string().nullish(),
  "shortDescription": zod.string().nullish(),
  "serviceType": zod.string(),
  "servicePrice": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isFeatured": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listCatalogueServicesResponseTotalMin)
})


/**
 * @summary Create a catalogue service
 */
export const createCatalogueServiceBodyTwoNameMax = 200;

export const createCatalogueServiceBodyTwoSlugMax = 200;



export const createCatalogueServiceBody = zod.object({
  "componentId": zod.uuid().nullish(),
  "description": zod.string().nullish(),
  "shortDescription": zod.string().nullish(),
  "serviceType": zod.string().optional(),
  "servicePrice": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isFeatured": zod.boolean().optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "name": zod.string().min(1).max(createCatalogueServiceBodyTwoNameMax),
  "slug": zod.string().min(1).max(createCatalogueServiceBodyTwoSlugMax)
}))

export const createCatalogueServiceResponse = zod.object({
  "componentId": zod.uuid().nullish(),
  "description": zod.string().nullish(),
  "shortDescription": zod.string().nullish(),
  "serviceType": zod.string(),
  "servicePrice": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isFeatured": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a catalogue service
 */
export const updateCatalogueServiceParams = zod.object({
  "id": zod.uuid()
})

export const updateCatalogueServiceBodyTwoNameMax = 200;

export const updateCatalogueServiceBodyTwoSlugMax = 200;



export const updateCatalogueServiceBody = zod.object({
  "componentId": zod.uuid().nullish(),
  "description": zod.string().nullish(),
  "shortDescription": zod.string().nullish(),
  "serviceType": zod.string().optional(),
  "servicePrice": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isFeatured": zod.boolean().optional(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "name": zod.string().min(1).max(updateCatalogueServiceBodyTwoNameMax).optional(),
  "slug": zod.string().min(1).max(updateCatalogueServiceBodyTwoSlugMax).optional()
}))

export const updateCatalogueServiceResponse = zod.object({
  "componentId": zod.uuid().nullish(),
  "description": zod.string().nullish(),
  "shortDescription": zod.string().nullish(),
  "serviceType": zod.string(),
  "servicePrice": zod.string().nullish(),
  "effortHours": zod.string().nullish(),
  "isFeatured": zod.boolean(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a catalogue service
 */
export const deleteCatalogueServiceParams = zod.object({
  "id": zod.uuid()
})

export const deleteCatalogueServiceResponse = zod.void()


/**
 * @summary List links between catalogue items and service offerings
 */
export const listCatalogueServiceLinksQueryParams = zod.object({
  "itemType": zod.string().optional(),
  "itemId": zod.uuid().optional(),
  "offeringId": zod.uuid().optional()
})

export const listCatalogueServiceLinksResponseTotalMin = 0;



export const listCatalogueServiceLinksResponse = zod.object({
  "items": zod.array(zod.object({
  "relationshipType": zod.string(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "itemType": zod.enum(['category', 'solution', 'product', 'module', 'capability']),
  "itemId": zod.uuid(),
  "offeringId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listCatalogueServiceLinksResponseTotalMin)
})


/**
 * @summary Link a catalogue item to a service offering
 */
export const createCatalogueServiceLinkBody = zod.object({
  "relationshipType": zod.string().optional(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "itemType": zod.enum(['category', 'solution', 'product', 'module', 'capability']),
  "itemId": zod.uuid(),
  "offeringId": zod.uuid()
}))

export const createCatalogueServiceLinkResponse = zod.object({
  "relationshipType": zod.string(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "itemType": zod.enum(['category', 'solution', 'product', 'module', 'capability']),
  "itemId": zod.uuid(),
  "offeringId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Remove a catalogue-item-to-service link
 */
export const deleteCatalogueServiceLinkParams = zod.object({
  "id": zod.uuid()
})

export const deleteCatalogueServiceLinkResponse = zod.void()


/**
 * @summary List catalogue collateral (marketing/sales files and links)
 */
export const listCatalogueCollateralsQueryParams = zod.object({
  "productId": zod.uuid().optional(),
  "solutionId": zod.uuid().optional(),
  "category": zod.string().optional()
})

export const listCatalogueCollateralsResponseTotalMin = 0;



export const listCatalogueCollateralsResponse = zod.object({
  "items": zod.array(zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "solutionId": zod.uuid().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listCatalogueCollateralsResponseTotalMin)
})


/**
 * @summary Create a catalogue collateral entry
 */
export const createCatalogueCollateralBodyTwoTitleMax = 200;



export const createCatalogueCollateralBody = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "solutionId": zod.uuid().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "title": zod.string().min(1).max(createCatalogueCollateralBodyTwoTitleMax)
}))

export const createCatalogueCollateralResponse = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "solutionId": zod.uuid().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a catalogue collateral entry
 */
export const updateCatalogueCollateralParams = zod.object({
  "id": zod.uuid()
})

export const updateCatalogueCollateralBodyTwoTitleMax = 200;



export const updateCatalogueCollateralBody = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "solutionId": zod.uuid().nullish(),
  "isActive": zod.boolean().optional(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "title": zod.string().min(1).max(updateCatalogueCollateralBodyTwoTitleMax).optional()
}))

export const updateCatalogueCollateralResponse = zod.object({
  "description": zod.string().nullish(),
  "category": zod.string().nullish(),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "productId": zod.uuid().nullish(),
  "solutionId": zod.uuid().nullish(),
  "isActive": zod.boolean(),
  "sortOrder": zod.int()
}).and(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a catalogue collateral entry
 */
export const deleteCatalogueCollateralParams = zod.object({
  "id": zod.uuid()
})

export const deleteCatalogueCollateralResponse = zod.void()


/**
 * @summary List procured products/modules/services for a partner
 */
export const listPartnerProductsQueryParams = zod.object({
  "accountId": zod.uuid()
})

export const listPartnerProductsResponseTotalMin = 0;



export const listPartnerProductsResponse = zod.object({
  "items": zod.array(zod.object({
  "itemType": zod.enum(['product', 'module', 'service']),
  "catalogueProductId": zod.uuid().nullish(),
  "catalogueModuleId": zod.uuid().nullish(),
  "catalogueServiceId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'pending', 'expired', 'cancelled']),
  "procuredDate": zod.iso.datetime({"offset":true}).nullish(),
  "startDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "autoRenew": zod.boolean(),
  "value": zod.number().nullish(),
  "currency": zod.string(),
  "billingFrequency": zod.enum(['monthly', 'quarterly', 'annual', 'one_time']).nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listPartnerProductsResponseTotalMin)
})


/**
 * @summary Record a procured product/module/service for a partner
 */
export const createPartnerProductBodyTwoNameMax = 200;



export const createPartnerProductBody = zod.object({
  "itemType": zod.enum(['product', 'module', 'service']).optional(),
  "catalogueProductId": zod.uuid().nullish(),
  "catalogueModuleId": zod.uuid().nullish(),
  "catalogueServiceId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'pending', 'expired', 'cancelled']).optional(),
  "procuredDate": zod.iso.datetime({"offset":true}).nullish(),
  "startDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "autoRenew": zod.boolean().optional(),
  "value": zod.number().nullish(),
  "currency": zod.string().optional(),
  "billingFrequency": zod.enum(['monthly', 'quarterly', 'annual', 'one_time']).nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "accountId": zod.uuid(),
  "name": zod.string().min(1).max(createPartnerProductBodyTwoNameMax)
}))

export const createPartnerProductResponse = zod.object({
  "itemType": zod.enum(['product', 'module', 'service']),
  "catalogueProductId": zod.uuid().nullish(),
  "catalogueModuleId": zod.uuid().nullish(),
  "catalogueServiceId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'pending', 'expired', 'cancelled']),
  "procuredDate": zod.iso.datetime({"offset":true}).nullish(),
  "startDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "autoRenew": zod.boolean(),
  "value": zod.number().nullish(),
  "currency": zod.string(),
  "billingFrequency": zod.enum(['monthly', 'quarterly', 'annual', 'one_time']).nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a partner product record
 */
export const updatePartnerProductParams = zod.object({
  "id": zod.uuid()
})

export const updatePartnerProductBodyTwoNameMax = 200;



export const updatePartnerProductBody = zod.object({
  "itemType": zod.enum(['product', 'module', 'service']).optional(),
  "catalogueProductId": zod.uuid().nullish(),
  "catalogueModuleId": zod.uuid().nullish(),
  "catalogueServiceId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'pending', 'expired', 'cancelled']).optional(),
  "procuredDate": zod.iso.datetime({"offset":true}).nullish(),
  "startDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "autoRenew": zod.boolean().optional(),
  "value": zod.number().nullish(),
  "currency": zod.string().optional(),
  "billingFrequency": zod.enum(['monthly', 'quarterly', 'annual', 'one_time']).nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "name": zod.string().min(1).max(updatePartnerProductBodyTwoNameMax).optional()
}))

export const updatePartnerProductResponse = zod.object({
  "itemType": zod.enum(['product', 'module', 'service']),
  "catalogueProductId": zod.uuid().nullish(),
  "catalogueModuleId": zod.uuid().nullish(),
  "catalogueServiceId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'pending', 'expired', 'cancelled']),
  "procuredDate": zod.iso.datetime({"offset":true}).nullish(),
  "startDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "autoRenew": zod.boolean(),
  "value": zod.number().nullish(),
  "currency": zod.string(),
  "billingFrequency": zod.enum(['monthly', 'quarterly', 'annual', 'one_time']).nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a partner product record
 */
export const deletePartnerProductParams = zod.object({
  "id": zod.uuid()
})

export const deletePartnerProductResponse = zod.void()


/**
 * @summary Renew a partner product (advances renewal/expiration dates)
 */
export const renewPartnerProductParams = zod.object({
  "id": zod.uuid()
})

export const renewPartnerProductBody = zod.object({
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish()
})

export const renewPartnerProductResponse = zod.object({
  "itemType": zod.enum(['product', 'module', 'service']),
  "catalogueProductId": zod.uuid().nullish(),
  "catalogueModuleId": zod.uuid().nullish(),
  "catalogueServiceId": zod.uuid().nullish(),
  "status": zod.enum(['active', 'pending', 'expired', 'cancelled']),
  "procuredDate": zod.iso.datetime({"offset":true}).nullish(),
  "startDate": zod.iso.datetime({"offset":true}).nullish(),
  "expirationDate": zod.iso.datetime({"offset":true}).nullish(),
  "renewalDate": zod.iso.datetime({"offset":true}).nullish(),
  "autoRenew": zod.boolean(),
  "value": zod.number().nullish(),
  "currency": zod.string(),
  "billingFrequency": zod.enum(['monthly', 'quarterly', 'annual', 'one_time']).nullish(),
  "notes": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "name": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Get the target-market segment ratings and target industry list
 */
export const getTargetMarketConfigResponse = zod.object({
  "targetIndustries": zod.array(zod.string()).describe('Free-text industry names treated as target market for scoring.'),
  "segmentRatings": zod.record(zod.string(), zod.int()).describe('Importance rating per TargetSegment key, 1-5 (validated server-side); unset segments default to 3.')
})


/**
 * @summary Replace the target-market configuration
 */
export const updateTargetMarketConfigBody = zod.object({
  "targetIndustries": zod.array(zod.string()).describe('Free-text industry names treated as target market for scoring.'),
  "segmentRatings": zod.record(zod.string(), zod.int()).describe('Importance rating per TargetSegment key, 1-5 (validated server-side); unset segments default to 3.')
})

export const updateTargetMarketConfigResponse = zod.object({
  "targetIndustries": zod.array(zod.string()).describe('Free-text industry names treated as target market for scoring.'),
  "segmentRatings": zod.record(zod.string(), zod.int()).describe('Importance rating per TargetSegment key, 1-5 (validated server-side); unset segments default to 3.')
})


/**
 * @summary Compute health-score-based temperature/focus recommendations for every account
 */
export const getAccountRecommendationsResponseRecommendationsItemScoreMin = 0;
export const getAccountRecommendationsResponseRecommendationsItemScoreMax = 100;



export const getAccountRecommendationsResponse = zod.object({
  "recommendations": zod.array(zod.object({
  "accountId": zod.uuid(),
  "companyName": zod.string(),
  "currentTemperature": zod.string().optional(),
  "currentFocus": zod.string().optional(),
  "recommendedTemperature": zod.enum(['hot', 'warm', 'cool', 'cold', 'new']),
  "recommendedFocus": zod.enum(['strategic', 'key', 'growth', 'standard']),
  "score": zod.int().min(getAccountRecommendationsResponseRecommendationsItemScoreMin).max(getAccountRecommendationsResponseRecommendationsItemScoreMax),
  "reasons": zod.array(zod.string()),
  "contactCount": zod.int().optional(),
  "recentActivityCount": zod.int().optional(),
  "openOpportunityCount": zod.int().optional(),
  "wonOpportunityCount": zod.int().optional()
}))
})


/**
 * @summary Apply recommended temperature/focus values to the selected accounts
 */



export const applyAccountRecommendationsBody = zod.object({
  "accountIds": zod.array(zod.uuid()).min(1),
  "field": zod.enum(['temperature', 'focus', 'both'])
})

export const applyAccountRecommendationsResponseUpdatedMin = 0;



export const applyAccountRecommendationsResponse = zod.object({
  "updated": zod.int().min(applyAccountRecommendationsResponseUpdatedMin)
})


/**
 * @summary Generate an AI narrative brief for a account via the project LLM
 */
export const generateAccountBriefParams = zod.object({
  "id": zod.uuid()
})

export const generateAccountBriefResponse = zod.object({
  "brief": zod.string(),
  "strategicBriefs": zod.array(zod.object({
  "briefId": zod.uuid(),
  "documentId": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "recordName": zod.string(),
  "importance": zod.enum(['strategic', 'key', 'growth', 'standard']),
  "excerpt": zod.string().describe('Short plain-text start of the brief as given to the AI'),
  "truncated": zod.boolean().describe('True when only part of the brief fitted the AI size limit'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deepLink": zod.string().describe('Record page with the Strategic brief tab open')
}).describe('A strategic brief (and importance level) the AI was given as grounding. Only briefs the caller can read are returned.')).describe('Strategic briefs the AI was given for this account brief')
})


/**
 * @summary Rank accounts by transparent fit, engagement, and buying-signal factors
 */
export const listRankedProspectsQueryMinScoreDefault = 0;
export const listRankedProspectsQueryMinScoreMin = 0;
export const listRankedProspectsQueryMinScoreMax = 100;

export const listRankedProspectsQuerySortDefault = `score_desc`;
export const listRankedProspectsQueryLimitDefault = 100;
export const listRankedProspectsQueryLimitMax = 250;



export const listRankedProspectsQueryParams = zod.object({
  "minScore": zod.int().min(listRankedProspectsQueryMinScoreMin).max(listRankedProspectsQueryMinScoreMax).default(listRankedProspectsQueryMinScoreDefault),
  "industry": zod.string().optional(),
  "sort": zod.enum(['score_desc', 'score_asc', 'account']).default(listRankedProspectsQuerySortDefault),
  "limit": zod.int().min(1).max(listRankedProspectsQueryLimitMax).default(listRankedProspectsQueryLimitDefault)
})

export const listRankedProspectsResponseItemsItemScoreMin = 0;
export const listRankedProspectsResponseItemsItemScoreMax = 100;

export const listRankedProspectsResponseItemsItemFitScoreMin = 0;
export const listRankedProspectsResponseItemsItemFitScoreMax = 100;

export const listRankedProspectsResponseItemsItemEngagementScoreMin = 0;
export const listRankedProspectsResponseItemsItemEngagementScoreMax = 100;

export const listRankedProspectsResponseItemsItemSignalScoreMin = 0;
export const listRankedProspectsResponseItemsItemSignalScoreMax = 100;

export const listRankedProspectsResponseItemsItemEvidenceInteractionCountMin = 0;

export const listRankedProspectsResponseItemsItemEvidenceConfirmedSignalCountMin = 0;

export const listRankedProspectsResponseItemsItemEvidenceProductFitMin = 0;
export const listRankedProspectsResponseItemsItemEvidenceProductFitMax = 100;

export const listRankedProspectsResponseItemsItemEvidenceProgressivenessMin = 0;
export const listRankedProspectsResponseItemsItemEvidenceProgressivenessMax = 100;

export const listRankedProspectsResponseTotalMin = 0;



export const listRankedProspectsResponse = zod.object({
  "items": zod.array(zod.object({
  "accountId": zod.uuid(),
  "companyName": zod.string(),
  "industry": zod.string().nullish(),
  "score": zod.int().min(listRankedProspectsResponseItemsItemScoreMin).max(listRankedProspectsResponseItemsItemScoreMax),
  "fitScore": zod.int().min(listRankedProspectsResponseItemsItemFitScoreMin).max(listRankedProspectsResponseItemsItemFitScoreMax),
  "engagementScore": zod.int().min(listRankedProspectsResponseItemsItemEngagementScoreMin).max(listRankedProspectsResponseItemsItemEngagementScoreMax),
  "signalScore": zod.int().min(listRankedProspectsResponseItemsItemSignalScoreMin).max(listRankedProspectsResponseItemsItemSignalScoreMax),
  "weights": zod.object({
  "fit": zod.number(),
  "engagement": zod.number(),
  "signals": zod.number()
}),
  "evidence": zod.object({
  "interactionCount": zod.int().min(listRankedProspectsResponseItemsItemEvidenceInteractionCountMin),
  "channels": zod.record(zod.string(), zod.int()),
  "confirmedSignalCount": zod.int().min(listRankedProspectsResponseItemsItemEvidenceConfirmedSignalCountMin),
  "signalTypes": zod.array(zod.string()),
  "sourceUrls": zod.array(zod.url()),
  "targetIndustry": zod.boolean(),
  "targetSegments": zod.array(zod.string()),
  "productFit": zod.number().min(listRankedProspectsResponseItemsItemEvidenceProductFitMin).max(listRankedProspectsResponseItemsItemEvidenceProductFitMax).nullable(),
  "progressiveness": zod.number().min(listRankedProspectsResponseItemsItemEvidenceProgressivenessMin).max(listRankedProspectsResponseItemsItemEvidenceProgressivenessMax).nullable()
}),
  "calculatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listRankedProspectsResponseTotalMin)
})


/**
 * @summary Recompute signal-aware ICP scores for every account
 */
export const recomputePortfolioScoresResponseUpdatedMin = 0;



export const recomputePortfolioScoresResponse = zod.object({
  "updated": zod.int().min(recomputePortfolioScoresResponseUpdatedMin)
})


/**
 * @summary Get the transparent ICP score and evidence for one account
 */
export const getAccountScoreBreakdownParams = zod.object({
  "accountId": zod.uuid()
})

export const getAccountScoreBreakdownResponseScoreMin = 0;
export const getAccountScoreBreakdownResponseScoreMax = 100;

export const getAccountScoreBreakdownResponseFitScoreMin = 0;
export const getAccountScoreBreakdownResponseFitScoreMax = 100;

export const getAccountScoreBreakdownResponseEngagementScoreMin = 0;
export const getAccountScoreBreakdownResponseEngagementScoreMax = 100;

export const getAccountScoreBreakdownResponseSignalScoreMin = 0;
export const getAccountScoreBreakdownResponseSignalScoreMax = 100;

export const getAccountScoreBreakdownResponseEvidenceInteractionCountMin = 0;

export const getAccountScoreBreakdownResponseEvidenceConfirmedSignalCountMin = 0;

export const getAccountScoreBreakdownResponseEvidenceProductFitMin = 0;
export const getAccountScoreBreakdownResponseEvidenceProductFitMax = 100;

export const getAccountScoreBreakdownResponseEvidenceProgressivenessMin = 0;
export const getAccountScoreBreakdownResponseEvidenceProgressivenessMax = 100;



export const getAccountScoreBreakdownResponse = zod.object({
  "accountId": zod.uuid(),
  "companyName": zod.string(),
  "industry": zod.string().nullish(),
  "score": zod.int().min(getAccountScoreBreakdownResponseScoreMin).max(getAccountScoreBreakdownResponseScoreMax),
  "fitScore": zod.int().min(getAccountScoreBreakdownResponseFitScoreMin).max(getAccountScoreBreakdownResponseFitScoreMax),
  "engagementScore": zod.int().min(getAccountScoreBreakdownResponseEngagementScoreMin).max(getAccountScoreBreakdownResponseEngagementScoreMax),
  "signalScore": zod.int().min(getAccountScoreBreakdownResponseSignalScoreMin).max(getAccountScoreBreakdownResponseSignalScoreMax),
  "weights": zod.object({
  "fit": zod.number(),
  "engagement": zod.number(),
  "signals": zod.number()
}),
  "evidence": zod.object({
  "interactionCount": zod.int().min(getAccountScoreBreakdownResponseEvidenceInteractionCountMin),
  "channels": zod.record(zod.string(), zod.int()),
  "confirmedSignalCount": zod.int().min(getAccountScoreBreakdownResponseEvidenceConfirmedSignalCountMin),
  "signalTypes": zod.array(zod.string()),
  "sourceUrls": zod.array(zod.url()),
  "targetIndustry": zod.boolean(),
  "targetSegments": zod.array(zod.string()),
  "productFit": zod.number().min(getAccountScoreBreakdownResponseEvidenceProductFitMin).max(getAccountScoreBreakdownResponseEvidenceProductFitMax).nullable(),
  "progressiveness": zod.number().min(getAccountScoreBreakdownResponseEvidenceProgressivenessMin).max(getAccountScoreBreakdownResponseEvidenceProgressivenessMax).nullable()
}),
  "calculatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get configured structured win and loss reasons
 */
export const getOpportunityOutcomeTaxonomyResponse = zod.object({
  "won": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string()
})),
  "lost": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string()
}))
})


/**
 * @summary Close a opportunity with a structured won or lost reason
 */
export const captureOpportunityOutcomeParams = zod.object({
  "opportunityId": zod.uuid()
})

export const captureOpportunityOutcomeBodyExpectedStageIdMax = 80;

export const captureOpportunityOutcomeBodyReasonCodeMax = 100;

export const captureOpportunityOutcomeBodyCompetitorMax = 200;

export const captureOpportunityOutcomeBodyNotesMax = 5000;



export const captureOpportunityOutcomeBody = zod.object({
  "requestId": zod.uuid(),
  "expectedStageId": zod.string().min(1).max(captureOpportunityOutcomeBodyExpectedStageIdMax),
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "outcome": zod.enum(['won', 'lost']),
  "reasonCode": zod.string().min(1).max(captureOpportunityOutcomeBodyReasonCodeMax),
  "competitor": zod.string().max(captureOpportunityOutcomeBodyCompetitorMax).nullish(),
  "notes": zod.string().max(captureOpportunityOutcomeBodyNotesMax).nullish()
})

export const captureOpportunityOutcomeResponseOneReasonCodeMax = 100;

export const captureOpportunityOutcomeResponseOneCompetitorMax = 200;

export const captureOpportunityOutcomeResponseOneNotesMax = 5000;

export const captureOpportunityOutcomeResponseOneCapturedByMax = 200;



export const captureOpportunityOutcomeResponse = zod.object({
  "outcome": zod.enum(['won', 'lost']),
  "reasonCode": zod.string().min(1).max(captureOpportunityOutcomeResponseOneReasonCodeMax),
  "competitor": zod.string().max(captureOpportunityOutcomeResponseOneCompetitorMax).nullish(),
  "notes": zod.string().max(captureOpportunityOutcomeResponseOneNotesMax).nullish(),
  "capturedBy": zod.string().max(captureOpportunityOutcomeResponseOneCapturedByMax).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "opportunityId": zod.uuid(),
  "opportunityTitle": zod.string(),
  "accountId": zod.uuid().nullable(),
  "companyName": zod.string().nullable(),
  "segment": zod.string().nullish(),
  "closedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List structured opportunity outcomes
 */
export const listOpportunityOutcomesQueryLimitDefault = 100;
export const listOpportunityOutcomesQueryLimitMax = 250;



export const listOpportunityOutcomesQueryParams = zod.object({
  "outcome": zod.enum(['won', 'lost']).optional(),
  "reasonCode": zod.string().optional(),
  "limit": zod.int().min(1).max(listOpportunityOutcomesQueryLimitMax).default(listOpportunityOutcomesQueryLimitDefault)
})

export const listOpportunityOutcomesResponseItemsItemOneReasonCodeMax = 100;

export const listOpportunityOutcomesResponseItemsItemOneCompetitorMax = 200;

export const listOpportunityOutcomesResponseItemsItemOneNotesMax = 5000;

export const listOpportunityOutcomesResponseItemsItemOneCapturedByMax = 200;



export const listOpportunityOutcomesResponse = zod.object({
  "items": zod.array(zod.object({
  "outcome": zod.enum(['won', 'lost']),
  "reasonCode": zod.string().min(1).max(listOpportunityOutcomesResponseItemsItemOneReasonCodeMax),
  "competitor": zod.string().max(listOpportunityOutcomesResponseItemsItemOneCompetitorMax).nullish(),
  "notes": zod.string().max(listOpportunityOutcomesResponseItemsItemOneNotesMax).nullish(),
  "capturedBy": zod.string().max(listOpportunityOutcomesResponseItemsItemOneCapturedByMax).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "opportunityId": zod.uuid(),
  "opportunityTitle": zod.string(),
  "accountId": zod.uuid().nullable(),
  "companyName": zod.string().nullable(),
  "segment": zod.string().nullish(),
  "closedAt": zod.iso.datetime({"offset":true})
})))
})


/**
 * @summary Generate an attributed market and win/loss analysis
 */
export const generateMarketAnalysisBodyLookbackDaysDefault = 90;
export const generateMarketAnalysisBodyLookbackDaysMax = 365;



export const generateMarketAnalysisBody = zod.object({
  "lookbackDays": zod.int().min(1).max(generateMarketAnalysisBodyLookbackDaysMax).default(generateMarketAnalysisBodyLookbackDaysDefault)
})

export const generateMarketAnalysisResponseWinLossPatternsItemCountMin = 0;



export const generateMarketAnalysisResponse = zod.object({
  "id": zod.uuid(),
  "lookbackDays": zod.int(),
  "summary": zod.string(),
  "trends": zod.array(zod.object({
  "label": zod.string(),
  "insight": zod.string(),
  "evidence": zod.array(zod.string()),
  "sourceUrls": zod.array(zod.string())
})),
  "winLossPatterns": zod.array(zod.object({
  "pattern": zod.string(),
  "outcome": zod.enum(['won', 'lost', 'mixed']),
  "count": zod.int().min(generateMarketAnalysisResponseWinLossPatternsItemCountMin),
  "rationale": zod.string()
})),
  "sources": zod.array(zod.object({
  "label": zod.string(),
  "url": zod.string(),
  "kind": zod.enum(['signal', 'opportunity']),
  "occurredAt": zod.iso.datetime({"offset":true})
})),
  "generatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get the most recently generated market analysis
 */
export const getLatestMarketAnalysisResponseWinLossPatternsItemCountMin = 0;



export const getLatestMarketAnalysisResponse = zod.object({
  "id": zod.uuid(),
  "lookbackDays": zod.int(),
  "summary": zod.string(),
  "trends": zod.array(zod.object({
  "label": zod.string(),
  "insight": zod.string(),
  "evidence": zod.array(zod.string()),
  "sourceUrls": zod.array(zod.string())
})),
  "winLossPatterns": zod.array(zod.object({
  "pattern": zod.string(),
  "outcome": zod.enum(['won', 'lost', 'mixed']),
  "count": zod.int().min(getLatestMarketAnalysisResponseWinLossPatternsItemCountMin),
  "rationale": zod.string()
})),
  "sources": zod.array(zod.object({
  "label": zod.string(),
  "url": zod.string(),
  "kind": zod.enum(['signal', 'opportunity']),
  "occurredAt": zod.iso.datetime({"offset":true})
})),
  "generatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Generate an authority-gated concrete next-best-action
 */
export const generateNextBestActionParams = zod.object({
  "accountId": zod.uuid()
})

export const generateNextBestActionResponseScoreSnapshotMin = 0;
export const generateNextBestActionResponseScoreSnapshotMax = 100;



export const generateNextBestActionResponse = zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "companyName": zod.string(),
  "actionType": zod.enum(['email', 'social', 'call', 'review_signal', 'create_opportunity']),
  "title": zod.string(),
  "rationale": zod.string(),
  "deepLink": zod.string(),
  "status": zod.enum(['open', 'processing', 'completed', 'dismissed']),
  "scoreSnapshot": zod.int().min(generateNextBestActionResponseScoreSnapshotMin).max(generateNextBestActionResponseScoreSnapshotMax),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List the cross-portfolio next-action queue
 */
export const listNextBestActionsQueryStatusDefault = `open`;
export const listNextBestActionsQueryLimitDefault = 100;
export const listNextBestActionsQueryLimitMax = 250;



export const listNextBestActionsQueryParams = zod.object({
  "accountId": zod.uuid().optional(),
  "status": zod.enum(['open', 'completed', 'dismissed']).default(listNextBestActionsQueryStatusDefault),
  "limit": zod.int().min(1).max(listNextBestActionsQueryLimitMax).default(listNextBestActionsQueryLimitDefault)
})

export const listNextBestActionsResponseItemsItemScoreSnapshotMin = 0;
export const listNextBestActionsResponseItemsItemScoreSnapshotMax = 100;



export const listNextBestActionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "companyName": zod.string(),
  "actionType": zod.enum(['email', 'social', 'call', 'review_signal', 'create_opportunity']),
  "title": zod.string(),
  "rationale": zod.string(),
  "deepLink": zod.string(),
  "status": zod.enum(['open', 'processing', 'completed', 'dismissed']),
  "scoreSnapshot": zod.int().min(listNextBestActionsResponseItemsItemScoreSnapshotMin).max(listNextBestActionsResponseItemsItemScoreSnapshotMax),
  "createdAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Complete or dismiss a recommended action
 */
export const updateNextBestActionStatusParams = zod.object({
  "id": zod.uuid()
})

export const updateNextBestActionStatusBody = zod.object({
  "status": zod.enum(['completed', 'dismissed'])
})

export const updateNextBestActionStatusResponseScoreSnapshotMin = 0;
export const updateNextBestActionStatusResponseScoreSnapshotMax = 100;



export const updateNextBestActionStatusResponse = zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "companyName": zod.string(),
  "actionType": zod.enum(['email', 'social', 'call', 'review_signal', 'create_opportunity']),
  "title": zod.string(),
  "rationale": zod.string(),
  "deepLink": zod.string(),
  "status": zod.enum(['open', 'processing', 'completed', 'dismissed']),
  "scoreSnapshot": zod.int().min(updateNextBestActionStatusResponseScoreSnapshotMin).max(updateNextBestActionStatusResponseScoreSnapshotMax),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List the latest explainable health assessment for each authorised relationship
 */
export const listRelationshipHealthQueryLimitDefault = 50;
export const listRelationshipHealthQueryLimitMax = 100;

export const listRelationshipHealthQueryOffsetDefault = 0;
export const listRelationshipHealthQueryOffsetMin = 0;

export const listRelationshipHealthQueryIncludeTestDataDefault = false;

export const listRelationshipHealthQueryParams = zod.object({
  "limit": zod.int().min(1).max(listRelationshipHealthQueryLimitMax).default(listRelationshipHealthQueryLimitDefault),
  "offset": zod.int().min(listRelationshipHealthQueryOffsetMin).default(listRelationshipHealthQueryOffsetDefault),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "evidenceState": zod.enum(['insufficient', 'fresh', 'stale', 'unavailable']).optional(),
  "includeTestData": zod.boolean().default(listRelationshipHealthQueryIncludeTestDataDefault)
})


export const listRelationshipHealthResponseItemsItemScoreMin = 0;
export const listRelationshipHealthResponseItemsItemScoreMax = 100;

export const listRelationshipHealthResponseItemsItemRulesVersionMax = 100;

export const listRelationshipHealthResponseItemsItemExpectedContactDaysMax = 3650;

export const listRelationshipHealthResponseItemsItemStaleAfterDaysMax = 3650;

export const listRelationshipHealthResponseItemsItemSummaryMax = 4000;

export const listRelationshipHealthResponseItemsItemEvidenceItemSourceKindMax = 80;

export const listRelationshipHealthResponseItemsItemEvidenceItemSourceRefMax = 500;

export const listRelationshipHealthResponseItemsItemEvidenceItemFactorKeyMax = 80;

export const listRelationshipHealthResponseItemsItemEvidenceItemSourcePathMax = 1000;

export const listRelationshipHealthResponseItemsItemEvidenceItemLabelMax = 300;

export const listRelationshipHealthResponseItemsItemEvidenceItemImpactMin = -100;
export const listRelationshipHealthResponseItemsItemEvidenceItemImpactMax = 100;

export const listRelationshipHealthResponseTotalMin = 0;

export const listRelationshipHealthResponseLimitMax = 100;

export const listRelationshipHealthResponseOffsetMin = 0;



export const listRelationshipHealthResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "accountName": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "version": zod.int().min(1),
  "evidenceState": zod.enum(['insufficient', 'fresh', 'stale', 'unavailable']),
  "score": zod.int().min(listRelationshipHealthResponseItemsItemScoreMin).max(listRelationshipHealthResponseItemsItemScoreMax).nullish(),
  "trend": zod.enum(['improving', 'stable', 'declining', 'unknown']),
  "rulesVersion": zod.string().min(1).max(listRelationshipHealthResponseItemsItemRulesVersionMax),
  "expectedContactDays": zod.int().min(1).max(listRelationshipHealthResponseItemsItemExpectedContactDaysMax),
  "staleAfterDays": zod.int().min(1).max(listRelationshipHealthResponseItemsItemStaleAfterDaysMax),
  "summary": zod.string().min(1).max(listRelationshipHealthResponseItemsItemSummaryMax),
  "evaluatedAt": zod.iso.datetime({"offset":true}),
  "evidenceThrough": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "interactionId": zod.uuid().nullish(),
  "signalId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "auditId": zod.uuid().nullish(),
  "sourceKind": zod.string().min(1).max(listRelationshipHealthResponseItemsItemEvidenceItemSourceKindMax),
  "sourceRef": zod.string().min(1).max(listRelationshipHealthResponseItemsItemEvidenceItemSourceRefMax),
  "factorKey": zod.string().min(1).max(listRelationshipHealthResponseItemsItemEvidenceItemFactorKeyMax),
  "freshness": zod.enum(['fresh', 'aging', 'stale', 'unknown']),
  "sourcePath": zod.string().min(1).max(listRelationshipHealthResponseItemsItemEvidenceItemSourcePathMax).nullish(),
  "label": zod.string().min(1).max(listRelationshipHealthResponseItemsItemEvidenceItemLabelMax),
  "impact": zod.int().min(listRelationshipHealthResponseItemsItemEvidenceItemImpactMin).max(listRelationshipHealthResponseItemsItemEvidenceItemImpactMax),
  "observedAt": zod.iso.datetime({"offset":true}),
  "detail": zod.record(zod.string(), zod.unknown())
}))
})),
  "total": zod.int().min(listRelationshipHealthResponseTotalMin),
  "limit": zod.int().min(1).max(listRelationshipHealthResponseLimitMax),
  "offset": zod.int().min(listRelationshipHealthResponseOffsetMin)
})


/**
 * @summary Read the latest explainable health assessment for one authorised relationship
 */
export const getRelationshipHealthParams = zod.object({
  "id": zod.uuid()
})


export const getRelationshipHealthResponseScoreMin = 0;
export const getRelationshipHealthResponseScoreMax = 100;

export const getRelationshipHealthResponseRulesVersionMax = 100;

export const getRelationshipHealthResponseExpectedContactDaysMax = 3650;

export const getRelationshipHealthResponseStaleAfterDaysMax = 3650;

export const getRelationshipHealthResponseSummaryMax = 4000;

export const getRelationshipHealthResponseEvidenceItemSourceKindMax = 80;

export const getRelationshipHealthResponseEvidenceItemSourceRefMax = 500;

export const getRelationshipHealthResponseEvidenceItemFactorKeyMax = 80;

export const getRelationshipHealthResponseEvidenceItemSourcePathMax = 1000;

export const getRelationshipHealthResponseEvidenceItemLabelMax = 300;

export const getRelationshipHealthResponseEvidenceItemImpactMin = -100;
export const getRelationshipHealthResponseEvidenceItemImpactMax = 100;



export const getRelationshipHealthResponse = zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "accountName": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "version": zod.int().min(1),
  "evidenceState": zod.enum(['insufficient', 'fresh', 'stale', 'unavailable']),
  "score": zod.int().min(getRelationshipHealthResponseScoreMin).max(getRelationshipHealthResponseScoreMax).nullish(),
  "trend": zod.enum(['improving', 'stable', 'declining', 'unknown']),
  "rulesVersion": zod.string().min(1).max(getRelationshipHealthResponseRulesVersionMax),
  "expectedContactDays": zod.int().min(1).max(getRelationshipHealthResponseExpectedContactDaysMax),
  "staleAfterDays": zod.int().min(1).max(getRelationshipHealthResponseStaleAfterDaysMax),
  "summary": zod.string().min(1).max(getRelationshipHealthResponseSummaryMax),
  "evaluatedAt": zod.iso.datetime({"offset":true}),
  "evidenceThrough": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "interactionId": zod.uuid().nullish(),
  "signalId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "auditId": zod.uuid().nullish(),
  "sourceKind": zod.string().min(1).max(getRelationshipHealthResponseEvidenceItemSourceKindMax),
  "sourceRef": zod.string().min(1).max(getRelationshipHealthResponseEvidenceItemSourceRefMax),
  "factorKey": zod.string().min(1).max(getRelationshipHealthResponseEvidenceItemFactorKeyMax),
  "freshness": zod.enum(['fresh', 'aging', 'stale', 'unknown']),
  "sourcePath": zod.string().min(1).max(getRelationshipHealthResponseEvidenceItemSourcePathMax).nullish(),
  "label": zod.string().min(1).max(getRelationshipHealthResponseEvidenceItemLabelMax),
  "impact": zod.int().min(getRelationshipHealthResponseEvidenceItemImpactMin).max(getRelationshipHealthResponseEvidenceItemImpactMax),
  "observedAt": zod.iso.datetime({"offset":true}),
  "detail": zod.record(zod.string(), zod.unknown())
}))
})


/**
 * @summary Recalculate bounded health assessments without dispatching outreach
 */
export const refreshRelationshipHealthBodyAccountIdsMax = 100;

export const refreshRelationshipHealthBodyIncludeTestDataDefault = false;

export const refreshRelationshipHealthBody = zod.object({
  "accountIds": zod.array(zod.uuid()).min(1).max(refreshRelationshipHealthBodyAccountIdsMax).optional(),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "includeTestData": zod.boolean().default(refreshRelationshipHealthBodyIncludeTestDataDefault)
})


export const refreshRelationshipHealthResponseItemsItemScoreMin = 0;
export const refreshRelationshipHealthResponseItemsItemScoreMax = 100;

export const refreshRelationshipHealthResponseItemsItemRulesVersionMax = 100;

export const refreshRelationshipHealthResponseItemsItemExpectedContactDaysMax = 3650;

export const refreshRelationshipHealthResponseItemsItemStaleAfterDaysMax = 3650;

export const refreshRelationshipHealthResponseItemsItemSummaryMax = 4000;

export const refreshRelationshipHealthResponseItemsItemEvidenceItemSourceKindMax = 80;

export const refreshRelationshipHealthResponseItemsItemEvidenceItemSourceRefMax = 500;

export const refreshRelationshipHealthResponseItemsItemEvidenceItemFactorKeyMax = 80;

export const refreshRelationshipHealthResponseItemsItemEvidenceItemSourcePathMax = 1000;

export const refreshRelationshipHealthResponseItemsItemEvidenceItemLabelMax = 300;

export const refreshRelationshipHealthResponseItemsItemEvidenceItemImpactMin = -100;
export const refreshRelationshipHealthResponseItemsItemEvidenceItemImpactMax = 100;

export const refreshRelationshipHealthResponseTotalMin = 0;

export const refreshRelationshipHealthResponseLimitMax = 100;

export const refreshRelationshipHealthResponseOffsetMin = 0;



export const refreshRelationshipHealthResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "accountName": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "version": zod.int().min(1),
  "evidenceState": zod.enum(['insufficient', 'fresh', 'stale', 'unavailable']),
  "score": zod.int().min(refreshRelationshipHealthResponseItemsItemScoreMin).max(refreshRelationshipHealthResponseItemsItemScoreMax).nullish(),
  "trend": zod.enum(['improving', 'stable', 'declining', 'unknown']),
  "rulesVersion": zod.string().min(1).max(refreshRelationshipHealthResponseItemsItemRulesVersionMax),
  "expectedContactDays": zod.int().min(1).max(refreshRelationshipHealthResponseItemsItemExpectedContactDaysMax),
  "staleAfterDays": zod.int().min(1).max(refreshRelationshipHealthResponseItemsItemStaleAfterDaysMax),
  "summary": zod.string().min(1).max(refreshRelationshipHealthResponseItemsItemSummaryMax),
  "evaluatedAt": zod.iso.datetime({"offset":true}),
  "evidenceThrough": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "interactionId": zod.uuid().nullish(),
  "signalId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "auditId": zod.uuid().nullish(),
  "sourceKind": zod.string().min(1).max(refreshRelationshipHealthResponseItemsItemEvidenceItemSourceKindMax),
  "sourceRef": zod.string().min(1).max(refreshRelationshipHealthResponseItemsItemEvidenceItemSourceRefMax),
  "factorKey": zod.string().min(1).max(refreshRelationshipHealthResponseItemsItemEvidenceItemFactorKeyMax),
  "freshness": zod.enum(['fresh', 'aging', 'stale', 'unknown']),
  "sourcePath": zod.string().min(1).max(refreshRelationshipHealthResponseItemsItemEvidenceItemSourcePathMax).nullish(),
  "label": zod.string().min(1).max(refreshRelationshipHealthResponseItemsItemEvidenceItemLabelMax),
  "impact": zod.int().min(refreshRelationshipHealthResponseItemsItemEvidenceItemImpactMin).max(refreshRelationshipHealthResponseItemsItemEvidenceItemImpactMax),
  "observedAt": zod.iso.datetime({"offset":true}),
  "detail": zod.record(zod.string(), zod.unknown())
}))
})),
  "total": zod.int().min(refreshRelationshipHealthResponseTotalMin),
  "limit": zod.int().min(1).max(refreshRelationshipHealthResponseLimitMax),
  "offset": zod.int().min(refreshRelationshipHealthResponseOffsetMin)
})


/**
 * @summary Read the deterministic versioned scoring rules and relationship expectations
 */
export const getRelationshipHealthRulesResponseVersionMax = 100;

export const getRelationshipHealthRulesResponseLookbackDaysMax = 3650;

export const getRelationshipHealthRulesResponseMinimumMeaningfulEventsMax = 100;

export const getRelationshipHealthRulesResponseTrendThresholdMax = 100;

export const getRelationshipHealthRulesResponseExpectationsItemExpectedContactDaysMax = 3650;

export const getRelationshipHealthRulesResponseExpectationsItemStaleAfterDaysMax = 3650;


export const getRelationshipHealthRulesResponseFactorsItemKeyMax = 80;

export const getRelationshipHealthRulesResponseFactorsItemLabelMax = 200;

export const getRelationshipHealthRulesResponseFactorsItemMaximumImpactMin = 0;
export const getRelationshipHealthRulesResponseFactorsItemMaximumImpactMax = 100;

export const getRelationshipHealthRulesResponseFactorsItemDescriptionMax = 1000;


export const getRelationshipHealthRulesResponseCautionsItemMax = 500;




export const getRelationshipHealthRulesResponse = zod.object({
  "version": zod.string().min(1).max(getRelationshipHealthRulesResponseVersionMax),
  "lookbackDays": zod.int().min(1).max(getRelationshipHealthRulesResponseLookbackDaysMax),
  "minimumMeaningfulEvents": zod.int().min(1).max(getRelationshipHealthRulesResponseMinimumMeaningfulEventsMax),
  "trendThreshold": zod.int().min(1).max(getRelationshipHealthRulesResponseTrendThresholdMax),
  "expectations": zod.array(zod.object({
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "expectedContactDays": zod.int().min(1).max(getRelationshipHealthRulesResponseExpectationsItemExpectedContactDaysMax),
  "staleAfterDays": zod.int().min(1).max(getRelationshipHealthRulesResponseExpectationsItemStaleAfterDaysMax)
})).min(1),
  "factors": zod.array(zod.object({
  "key": zod.string().min(1).max(getRelationshipHealthRulesResponseFactorsItemKeyMax),
  "label": zod.string().min(1).max(getRelationshipHealthRulesResponseFactorsItemLabelMax),
  "maximumImpact": zod.int().min(getRelationshipHealthRulesResponseFactorsItemMaximumImpactMin).max(getRelationshipHealthRulesResponseFactorsItemMaximumImpactMax),
  "description": zod.string().min(1).max(getRelationshipHealthRulesResponseFactorsItemDescriptionMax)
})).min(1),
  "cautions": zod.array(zod.string().min(1).max(getRelationshipHealthRulesResponseCautionsItemMax)).min(1)
})


/**
 * @summary List versioned relationship-health assessments for the current entity
 */
export const listRelationshipHealthSnapshotsQueryLimitDefault = 50;
export const listRelationshipHealthSnapshotsQueryLimitMax = 100;

export const listRelationshipHealthSnapshotsQueryOffsetDefault = 0;
export const listRelationshipHealthSnapshotsQueryOffsetMin = 0;



export const listRelationshipHealthSnapshotsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listRelationshipHealthSnapshotsQueryLimitMax).default(listRelationshipHealthSnapshotsQueryLimitDefault),
  "offset": zod.int().min(listRelationshipHealthSnapshotsQueryOffsetMin).default(listRelationshipHealthSnapshotsQueryOffsetDefault),
  "accountId": zod.uuid().optional()
})


export const listRelationshipHealthSnapshotsResponseItemsItemScoreMin = 0;
export const listRelationshipHealthSnapshotsResponseItemsItemScoreMax = 100;

export const listRelationshipHealthSnapshotsResponseItemsItemRulesVersionMax = 100;

export const listRelationshipHealthSnapshotsResponseItemsItemExpectedContactDaysMax = 3650;

export const listRelationshipHealthSnapshotsResponseItemsItemStaleAfterDaysMax = 3650;

export const listRelationshipHealthSnapshotsResponseItemsItemSummaryMax = 4000;

export const listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemSourceKindMax = 80;

export const listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemSourceRefMax = 500;

export const listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemFactorKeyMax = 80;

export const listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemSourcePathMax = 1000;

export const listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemLabelMax = 300;

export const listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemImpactMin = -100;
export const listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemImpactMax = 100;

export const listRelationshipHealthSnapshotsResponseTotalMin = 0;

export const listRelationshipHealthSnapshotsResponseLimitMax = 100;

export const listRelationshipHealthSnapshotsResponseOffsetMin = 0;



export const listRelationshipHealthSnapshotsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "accountName": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "version": zod.int().min(1),
  "evidenceState": zod.enum(['insufficient', 'fresh', 'stale', 'unavailable']),
  "score": zod.int().min(listRelationshipHealthSnapshotsResponseItemsItemScoreMin).max(listRelationshipHealthSnapshotsResponseItemsItemScoreMax).nullish(),
  "trend": zod.enum(['improving', 'stable', 'declining', 'unknown']),
  "rulesVersion": zod.string().min(1).max(listRelationshipHealthSnapshotsResponseItemsItemRulesVersionMax),
  "expectedContactDays": zod.int().min(1).max(listRelationshipHealthSnapshotsResponseItemsItemExpectedContactDaysMax),
  "staleAfterDays": zod.int().min(1).max(listRelationshipHealthSnapshotsResponseItemsItemStaleAfterDaysMax),
  "summary": zod.string().min(1).max(listRelationshipHealthSnapshotsResponseItemsItemSummaryMax),
  "evaluatedAt": zod.iso.datetime({"offset":true}),
  "evidenceThrough": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "interactionId": zod.uuid().nullish(),
  "signalId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "auditId": zod.uuid().nullish(),
  "sourceKind": zod.string().min(1).max(listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemSourceKindMax),
  "sourceRef": zod.string().min(1).max(listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemSourceRefMax),
  "factorKey": zod.string().min(1).max(listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemFactorKeyMax),
  "freshness": zod.enum(['fresh', 'aging', 'stale', 'unknown']),
  "sourcePath": zod.string().min(1).max(listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemSourcePathMax).nullish(),
  "label": zod.string().min(1).max(listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemLabelMax),
  "impact": zod.int().min(listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemImpactMin).max(listRelationshipHealthSnapshotsResponseItemsItemEvidenceItemImpactMax),
  "observedAt": zod.iso.datetime({"offset":true}),
  "detail": zod.record(zod.string(), zod.unknown())
}))
})),
  "total": zod.int().min(listRelationshipHealthSnapshotsResponseTotalMin),
  "limit": zod.int().min(1).max(listRelationshipHealthSnapshotsResponseLimitMax),
  "offset": zod.int().min(listRelationshipHealthSnapshotsResponseOffsetMin)
})


/**
 * @summary List governed outreach plans for the current entity
 */
export const listOutreachPlansQueryLimitDefault = 50;
export const listOutreachPlansQueryLimitMax = 100;

export const listOutreachPlansQueryOffsetDefault = 0;
export const listOutreachPlansQueryOffsetMin = 0;



export const listOutreachPlansQueryParams = zod.object({
  "limit": zod.int().min(1).max(listOutreachPlansQueryLimitMax).default(listOutreachPlansQueryLimitDefault),
  "offset": zod.int().min(listOutreachPlansQueryOffsetMin).default(listOutreachPlansQueryOffsetDefault),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']).optional()
})

export const listOutreachPlansResponseItemsItemNameMax = 200;


export const listOutreachPlansResponseTotalMin = 0;

export const listOutreachPlansResponseLimitMax = 100;

export const listOutreachPlansResponseOffsetMin = 0;



export const listOutreachPlansResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(listOutreachPlansResponseItemsItemNameMax),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "pausedAt": zod.iso.datetime({"offset":true}).nullish(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listOutreachPlansResponseTotalMin),
  "limit": zod.int().min(1).max(listOutreachPlansResponseLimitMax),
  "offset": zod.int().min(listOutreachPlansResponseOffsetMin)
})


/**
 * @summary Create an inactive outreach plan with its immutable first revision
 */
export const createOutreachPlanBodyNameMax = 200;

export const createOutreachPlanBodyRevisionGoalMax = 1000;

export const createOutreachPlanBodyRevisionRecipientRulesAccountIdsMax = 10000;

export const createOutreachPlanBodyRevisionRecipientRulesRelationshipTypesItemMax = 80;

export const createOutreachPlanBodyRevisionRecipientRulesRelationshipTypesMax = 50;

export const createOutreachPlanBodyRevisionChannelsItemSenderKeyMax = 200;

export const createOutreachPlanBodyRevisionChannelsMax = 20;

export const createOutreachPlanBodyRevisionPermittedInformationCrmFieldsItemMax = 120;

export const createOutreachPlanBodyRevisionPermittedInformationCrmFieldsMax = 100;

export const createOutreachPlanBodyRevisionPermittedInformationKnowledgeSourceIdsItemMax = 200;

export const createOutreachPlanBodyRevisionPermittedInformationKnowledgeSourceIdsMax = 100;

export const createOutreachPlanBodyRevisionContactWindowsTimezoneFallbackMax = 100;

export const createOutreachPlanBodyRevisionContactWindowsWeekdaysItemMax = 7;

export const createOutreachPlanBodyRevisionContactWindowsWeekdaysMax = 7;

export const createOutreachPlanBodyRevisionContactWindowsStartLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const createOutreachPlanBodyRevisionContactWindowsEndLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const createOutreachPlanBodyRevisionFrequencyLimitsMaxContactsPerRecipientMax = 100;

export const createOutreachPlanBodyRevisionFrequencyLimitsPeriodDaysMax = 365;

export const createOutreachPlanBodyRevisionFrequencyLimitsMinimumHoursBetweenMax = 8760;

export const createOutreachPlanBodyRevisionSpendingLimitsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const createOutreachPlanBodyRevisionSpendingLimitsMaximumTotalMinorMin = 0;

export const createOutreachPlanBodyRevisionSpendingLimitsMaximumPerRecipientMinorMin = 0;

export const createOutreachPlanBodyRevisionReplyLimitsMaximumAutomatedTurnsMin = 0;
export const createOutreachPlanBodyRevisionReplyLimitsMaximumAutomatedTurnsMax = 20;



export const createOutreachPlanBody = zod.object({
  "name": zod.string().min(1).max(createOutreachPlanBodyNameMax),
  "revision": zod.object({
  "goal": zod.string().min(1).max(createOutreachPlanBodyRevisionGoalMax),
  "recipientRules": zod.object({
  "mode": zod.enum(['explicit', 'eligibility_rules']),
  "accountIds": zod.array(zod.uuid()).max(createOutreachPlanBodyRevisionRecipientRulesAccountIdsMax).optional(),
  "relationshipTypes": zod.array(zod.string().min(1).max(createOutreachPlanBodyRevisionRecipientRulesRelationshipTypesItemMax)).max(createOutreachPlanBodyRevisionRecipientRulesRelationshipTypesMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
}),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(createOutreachPlanBodyRevisionChannelsItemSenderKeyMax),
  "callMode": zod.enum(['ai_led', 'staff_led']).nullish()
})).min(1).max(createOutreachPlanBodyRevisionChannelsMax),
  "permittedInformation": zod.object({
  "crmFields": zod.array(zod.string().min(1).max(createOutreachPlanBodyRevisionPermittedInformationCrmFieldsItemMax)).max(createOutreachPlanBodyRevisionPermittedInformationCrmFieldsMax),
  "knowledgeSourceIds": zod.array(zod.string().min(1).max(createOutreachPlanBodyRevisionPermittedInformationKnowledgeSourceIdsItemMax)).max(createOutreachPlanBodyRevisionPermittedInformationKnowledgeSourceIdsMax),
  "publicSafeOnly": zod.boolean()
}),
  "contactWindows": zod.object({
  "timezoneFallback": zod.string().min(1).max(createOutreachPlanBodyRevisionContactWindowsTimezoneFallbackMax),
  "weekdays": zod.array(zod.int().min(1).max(createOutreachPlanBodyRevisionContactWindowsWeekdaysItemMax)).min(1).max(createOutreachPlanBodyRevisionContactWindowsWeekdaysMax),
  "startLocal": zod.string().regex(createOutreachPlanBodyRevisionContactWindowsStartLocalRegExp),
  "endLocal": zod.string().regex(createOutreachPlanBodyRevisionContactWindowsEndLocalRegExp)
}),
  "frequencyLimits": zod.object({
  "maxContactsPerRecipient": zod.int().min(1).max(createOutreachPlanBodyRevisionFrequencyLimitsMaxContactsPerRecipientMax),
  "periodDays": zod.int().min(1).max(createOutreachPlanBodyRevisionFrequencyLimitsPeriodDaysMax),
  "minimumHoursBetween": zod.int().min(1).max(createOutreachPlanBodyRevisionFrequencyLimitsMinimumHoursBetweenMax)
}),
  "spendingLimits": zod.object({
  "currency": zod.string().regex(createOutreachPlanBodyRevisionSpendingLimitsCurrencyRegExp),
  "maximumTotalMinor": zod.int().min(createOutreachPlanBodyRevisionSpendingLimitsMaximumTotalMinorMin),
  "maximumPerRecipientMinor": zod.int().min(createOutreachPlanBodyRevisionSpendingLimitsMaximumPerRecipientMinorMin)
}),
  "replyLimits": zod.object({
  "maximumAutomatedTurns": zod.int().min(createOutreachPlanBodyRevisionReplyLimitsMaximumAutomatedTurnsMin).max(createOutreachPlanBodyRevisionReplyLimitsMaximumAutomatedTurnsMax),
  "stopOnHumanRequest": zod.boolean(),
  "stopOnObjection": zod.boolean()
}),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "escalationOwnerAppUserId": zod.uuid()
})
})

export const createOutreachPlanResponseOneNameMax = 200;



export const createOutreachPlanResponseTwoRevisionsItemGoalMax = 1000;

export const createOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax = 10000;

export const createOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax = 80;

export const createOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax = 50;

export const createOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax = 200;

export const createOutreachPlanResponseTwoRevisionsItemChannelsMax = 20;

export const createOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax = 120;

export const createOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax = 100;

export const createOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax = 200;

export const createOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax = 100;

export const createOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax = 100;

export const createOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax = 7;

export const createOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax = 7;

export const createOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const createOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const createOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax = 100;

export const createOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax = 365;

export const createOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax = 8760;

export const createOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const createOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin = 0;

export const createOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin = 0;

export const createOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin = 0;
export const createOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax = 20;


export const createOutreachPlanResponseTwoMemberCountMin = 0;



export const createOutreachPlanResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(createOutreachPlanResponseOneNameMax),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "pausedAt": zod.iso.datetime({"offset":true}).nullish(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "revisions": zod.array(zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "revision": zod.int().min(1),
  "goal": zod.string().min(1).max(createOutreachPlanResponseTwoRevisionsItemGoalMax),
  "recipientRules": zod.object({
  "mode": zod.enum(['explicit', 'eligibility_rules']),
  "accountIds": zod.array(zod.uuid()).max(createOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax).optional(),
  "relationshipTypes": zod.array(zod.string().min(1).max(createOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax)).max(createOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
}),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(createOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax),
  "callMode": zod.enum(['ai_led', 'staff_led']).nullish()
})).min(1).max(createOutreachPlanResponseTwoRevisionsItemChannelsMax),
  "permittedInformation": zod.object({
  "crmFields": zod.array(zod.string().min(1).max(createOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax)).max(createOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax),
  "knowledgeSourceIds": zod.array(zod.string().min(1).max(createOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax)).max(createOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax),
  "publicSafeOnly": zod.boolean()
}),
  "contactWindows": zod.object({
  "timezoneFallback": zod.string().min(1).max(createOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax),
  "weekdays": zod.array(zod.int().min(1).max(createOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax)).min(1).max(createOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax),
  "startLocal": zod.string().regex(createOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp),
  "endLocal": zod.string().regex(createOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp)
}),
  "frequencyLimits": zod.object({
  "maxContactsPerRecipient": zod.int().min(1).max(createOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax),
  "periodDays": zod.int().min(1).max(createOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax),
  "minimumHoursBetween": zod.int().min(1).max(createOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax)
}),
  "spendingLimits": zod.object({
  "currency": zod.string().regex(createOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp),
  "maximumTotalMinor": zod.int().min(createOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin),
  "maximumPerRecipientMinor": zod.int().min(createOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin)
}),
  "replyLimits": zod.object({
  "maximumAutomatedTurns": zod.int().min(createOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin).max(createOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax),
  "stopOnHumanRequest": zod.boolean(),
  "stopOnObjection": zod.boolean()
}),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "escalationOwnerAppUserId": zod.uuid(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "approvals": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "revision": zod.int().min(1),
  "auditId": zod.uuid(),
  "approvedByAppUserId": zod.uuid(),
  "status": zod.enum(['approved', 'revoked', 'stale']),
  "reason": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "memberCount": zod.int().min(createOutreachPlanResponseTwoMemberCountMin)
}))


/**
 * @summary Read one outreach plan and its exact immutable revisions
 */
export const getOutreachPlanParams = zod.object({
  "id": zod.uuid()
})

export const getOutreachPlanResponseOneNameMax = 200;



export const getOutreachPlanResponseTwoRevisionsItemGoalMax = 1000;

export const getOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax = 10000;

export const getOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax = 80;

export const getOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax = 50;

export const getOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax = 200;

export const getOutreachPlanResponseTwoRevisionsItemChannelsMax = 20;

export const getOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax = 120;

export const getOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax = 100;

export const getOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax = 200;

export const getOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax = 100;

export const getOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax = 100;

export const getOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax = 7;

export const getOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax = 7;

export const getOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const getOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const getOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax = 100;

export const getOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax = 365;

export const getOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax = 8760;

export const getOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin = 0;

export const getOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin = 0;

export const getOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin = 0;
export const getOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax = 20;


export const getOutreachPlanResponseTwoMemberCountMin = 0;



export const getOutreachPlanResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(getOutreachPlanResponseOneNameMax),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "pausedAt": zod.iso.datetime({"offset":true}).nullish(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "revisions": zod.array(zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "revision": zod.int().min(1),
  "goal": zod.string().min(1).max(getOutreachPlanResponseTwoRevisionsItemGoalMax),
  "recipientRules": zod.object({
  "mode": zod.enum(['explicit', 'eligibility_rules']),
  "accountIds": zod.array(zod.uuid()).max(getOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax).optional(),
  "relationshipTypes": zod.array(zod.string().min(1).max(getOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax)).max(getOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
}),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(getOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax),
  "callMode": zod.enum(['ai_led', 'staff_led']).nullish()
})).min(1).max(getOutreachPlanResponseTwoRevisionsItemChannelsMax),
  "permittedInformation": zod.object({
  "crmFields": zod.array(zod.string().min(1).max(getOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax)).max(getOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax),
  "knowledgeSourceIds": zod.array(zod.string().min(1).max(getOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax)).max(getOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax),
  "publicSafeOnly": zod.boolean()
}),
  "contactWindows": zod.object({
  "timezoneFallback": zod.string().min(1).max(getOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax),
  "weekdays": zod.array(zod.int().min(1).max(getOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax)).min(1).max(getOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax),
  "startLocal": zod.string().regex(getOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp),
  "endLocal": zod.string().regex(getOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp)
}),
  "frequencyLimits": zod.object({
  "maxContactsPerRecipient": zod.int().min(1).max(getOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax),
  "periodDays": zod.int().min(1).max(getOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax),
  "minimumHoursBetween": zod.int().min(1).max(getOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax)
}),
  "spendingLimits": zod.object({
  "currency": zod.string().regex(getOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp),
  "maximumTotalMinor": zod.int().min(getOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin),
  "maximumPerRecipientMinor": zod.int().min(getOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin)
}),
  "replyLimits": zod.object({
  "maximumAutomatedTurns": zod.int().min(getOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin).max(getOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax),
  "stopOnHumanRequest": zod.boolean(),
  "stopOnObjection": zod.boolean()
}),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "escalationOwnerAppUserId": zod.uuid(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "approvals": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "revision": zod.int().min(1),
  "auditId": zod.uuid(),
  "approvedByAppUserId": zod.uuid(),
  "status": zod.enum(['approved', 'revoked', 'stale']),
  "reason": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "memberCount": zod.int().min(getOutreachPlanResponseTwoMemberCountMin)
}))


/**
 * @summary Append an immutable plan revision and invalidate prior bounded authority
 */
export const reviseOutreachPlanParams = zod.object({
  "id": zod.uuid()
})


export const reviseOutreachPlanBodyRevisionGoalMax = 1000;

export const reviseOutreachPlanBodyRevisionRecipientRulesAccountIdsMax = 10000;

export const reviseOutreachPlanBodyRevisionRecipientRulesRelationshipTypesItemMax = 80;

export const reviseOutreachPlanBodyRevisionRecipientRulesRelationshipTypesMax = 50;

export const reviseOutreachPlanBodyRevisionChannelsItemSenderKeyMax = 200;

export const reviseOutreachPlanBodyRevisionChannelsMax = 20;

export const reviseOutreachPlanBodyRevisionPermittedInformationCrmFieldsItemMax = 120;

export const reviseOutreachPlanBodyRevisionPermittedInformationCrmFieldsMax = 100;

export const reviseOutreachPlanBodyRevisionPermittedInformationKnowledgeSourceIdsItemMax = 200;

export const reviseOutreachPlanBodyRevisionPermittedInformationKnowledgeSourceIdsMax = 100;

export const reviseOutreachPlanBodyRevisionContactWindowsTimezoneFallbackMax = 100;

export const reviseOutreachPlanBodyRevisionContactWindowsWeekdaysItemMax = 7;

export const reviseOutreachPlanBodyRevisionContactWindowsWeekdaysMax = 7;

export const reviseOutreachPlanBodyRevisionContactWindowsStartLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const reviseOutreachPlanBodyRevisionContactWindowsEndLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const reviseOutreachPlanBodyRevisionFrequencyLimitsMaxContactsPerRecipientMax = 100;

export const reviseOutreachPlanBodyRevisionFrequencyLimitsPeriodDaysMax = 365;

export const reviseOutreachPlanBodyRevisionFrequencyLimitsMinimumHoursBetweenMax = 8760;

export const reviseOutreachPlanBodyRevisionSpendingLimitsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviseOutreachPlanBodyRevisionSpendingLimitsMaximumTotalMinorMin = 0;

export const reviseOutreachPlanBodyRevisionSpendingLimitsMaximumPerRecipientMinorMin = 0;

export const reviseOutreachPlanBodyRevisionReplyLimitsMaximumAutomatedTurnsMin = 0;
export const reviseOutreachPlanBodyRevisionReplyLimitsMaximumAutomatedTurnsMax = 20;



export const reviseOutreachPlanBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "revision": zod.object({
  "goal": zod.string().min(1).max(reviseOutreachPlanBodyRevisionGoalMax),
  "recipientRules": zod.object({
  "mode": zod.enum(['explicit', 'eligibility_rules']),
  "accountIds": zod.array(zod.uuid()).max(reviseOutreachPlanBodyRevisionRecipientRulesAccountIdsMax).optional(),
  "relationshipTypes": zod.array(zod.string().min(1).max(reviseOutreachPlanBodyRevisionRecipientRulesRelationshipTypesItemMax)).max(reviseOutreachPlanBodyRevisionRecipientRulesRelationshipTypesMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
}),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(reviseOutreachPlanBodyRevisionChannelsItemSenderKeyMax),
  "callMode": zod.enum(['ai_led', 'staff_led']).nullish()
})).min(1).max(reviseOutreachPlanBodyRevisionChannelsMax),
  "permittedInformation": zod.object({
  "crmFields": zod.array(zod.string().min(1).max(reviseOutreachPlanBodyRevisionPermittedInformationCrmFieldsItemMax)).max(reviseOutreachPlanBodyRevisionPermittedInformationCrmFieldsMax),
  "knowledgeSourceIds": zod.array(zod.string().min(1).max(reviseOutreachPlanBodyRevisionPermittedInformationKnowledgeSourceIdsItemMax)).max(reviseOutreachPlanBodyRevisionPermittedInformationKnowledgeSourceIdsMax),
  "publicSafeOnly": zod.boolean()
}),
  "contactWindows": zod.object({
  "timezoneFallback": zod.string().min(1).max(reviseOutreachPlanBodyRevisionContactWindowsTimezoneFallbackMax),
  "weekdays": zod.array(zod.int().min(1).max(reviseOutreachPlanBodyRevisionContactWindowsWeekdaysItemMax)).min(1).max(reviseOutreachPlanBodyRevisionContactWindowsWeekdaysMax),
  "startLocal": zod.string().regex(reviseOutreachPlanBodyRevisionContactWindowsStartLocalRegExp),
  "endLocal": zod.string().regex(reviseOutreachPlanBodyRevisionContactWindowsEndLocalRegExp)
}),
  "frequencyLimits": zod.object({
  "maxContactsPerRecipient": zod.int().min(1).max(reviseOutreachPlanBodyRevisionFrequencyLimitsMaxContactsPerRecipientMax),
  "periodDays": zod.int().min(1).max(reviseOutreachPlanBodyRevisionFrequencyLimitsPeriodDaysMax),
  "minimumHoursBetween": zod.int().min(1).max(reviseOutreachPlanBodyRevisionFrequencyLimitsMinimumHoursBetweenMax)
}),
  "spendingLimits": zod.object({
  "currency": zod.string().regex(reviseOutreachPlanBodyRevisionSpendingLimitsCurrencyRegExp),
  "maximumTotalMinor": zod.int().min(reviseOutreachPlanBodyRevisionSpendingLimitsMaximumTotalMinorMin),
  "maximumPerRecipientMinor": zod.int().min(reviseOutreachPlanBodyRevisionSpendingLimitsMaximumPerRecipientMinorMin)
}),
  "replyLimits": zod.object({
  "maximumAutomatedTurns": zod.int().min(reviseOutreachPlanBodyRevisionReplyLimitsMaximumAutomatedTurnsMin).max(reviseOutreachPlanBodyRevisionReplyLimitsMaximumAutomatedTurnsMax),
  "stopOnHumanRequest": zod.boolean(),
  "stopOnObjection": zod.boolean()
}),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "escalationOwnerAppUserId": zod.uuid()
})
})


export const reviseOutreachPlanResponseGoalMax = 1000;

export const reviseOutreachPlanResponseRecipientRulesAccountIdsMax = 10000;

export const reviseOutreachPlanResponseRecipientRulesRelationshipTypesItemMax = 80;

export const reviseOutreachPlanResponseRecipientRulesRelationshipTypesMax = 50;

export const reviseOutreachPlanResponseChannelsItemSenderKeyMax = 200;

export const reviseOutreachPlanResponseChannelsMax = 20;

export const reviseOutreachPlanResponsePermittedInformationCrmFieldsItemMax = 120;

export const reviseOutreachPlanResponsePermittedInformationCrmFieldsMax = 100;

export const reviseOutreachPlanResponsePermittedInformationKnowledgeSourceIdsItemMax = 200;

export const reviseOutreachPlanResponsePermittedInformationKnowledgeSourceIdsMax = 100;

export const reviseOutreachPlanResponseContactWindowsTimezoneFallbackMax = 100;

export const reviseOutreachPlanResponseContactWindowsWeekdaysItemMax = 7;

export const reviseOutreachPlanResponseContactWindowsWeekdaysMax = 7;

export const reviseOutreachPlanResponseContactWindowsStartLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const reviseOutreachPlanResponseContactWindowsEndLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const reviseOutreachPlanResponseFrequencyLimitsMaxContactsPerRecipientMax = 100;

export const reviseOutreachPlanResponseFrequencyLimitsPeriodDaysMax = 365;

export const reviseOutreachPlanResponseFrequencyLimitsMinimumHoursBetweenMax = 8760;

export const reviseOutreachPlanResponseSpendingLimitsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviseOutreachPlanResponseSpendingLimitsMaximumTotalMinorMin = 0;

export const reviseOutreachPlanResponseSpendingLimitsMaximumPerRecipientMinorMin = 0;

export const reviseOutreachPlanResponseReplyLimitsMaximumAutomatedTurnsMin = 0;
export const reviseOutreachPlanResponseReplyLimitsMaximumAutomatedTurnsMax = 20;



export const reviseOutreachPlanResponse = zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "revision": zod.int().min(1),
  "goal": zod.string().min(1).max(reviseOutreachPlanResponseGoalMax),
  "recipientRules": zod.object({
  "mode": zod.enum(['explicit', 'eligibility_rules']),
  "accountIds": zod.array(zod.uuid()).max(reviseOutreachPlanResponseRecipientRulesAccountIdsMax).optional(),
  "relationshipTypes": zod.array(zod.string().min(1).max(reviseOutreachPlanResponseRecipientRulesRelationshipTypesItemMax)).max(reviseOutreachPlanResponseRecipientRulesRelationshipTypesMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
}),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(reviseOutreachPlanResponseChannelsItemSenderKeyMax),
  "callMode": zod.enum(['ai_led', 'staff_led']).nullish()
})).min(1).max(reviseOutreachPlanResponseChannelsMax),
  "permittedInformation": zod.object({
  "crmFields": zod.array(zod.string().min(1).max(reviseOutreachPlanResponsePermittedInformationCrmFieldsItemMax)).max(reviseOutreachPlanResponsePermittedInformationCrmFieldsMax),
  "knowledgeSourceIds": zod.array(zod.string().min(1).max(reviseOutreachPlanResponsePermittedInformationKnowledgeSourceIdsItemMax)).max(reviseOutreachPlanResponsePermittedInformationKnowledgeSourceIdsMax),
  "publicSafeOnly": zod.boolean()
}),
  "contactWindows": zod.object({
  "timezoneFallback": zod.string().min(1).max(reviseOutreachPlanResponseContactWindowsTimezoneFallbackMax),
  "weekdays": zod.array(zod.int().min(1).max(reviseOutreachPlanResponseContactWindowsWeekdaysItemMax)).min(1).max(reviseOutreachPlanResponseContactWindowsWeekdaysMax),
  "startLocal": zod.string().regex(reviseOutreachPlanResponseContactWindowsStartLocalRegExp),
  "endLocal": zod.string().regex(reviseOutreachPlanResponseContactWindowsEndLocalRegExp)
}),
  "frequencyLimits": zod.object({
  "maxContactsPerRecipient": zod.int().min(1).max(reviseOutreachPlanResponseFrequencyLimitsMaxContactsPerRecipientMax),
  "periodDays": zod.int().min(1).max(reviseOutreachPlanResponseFrequencyLimitsPeriodDaysMax),
  "minimumHoursBetween": zod.int().min(1).max(reviseOutreachPlanResponseFrequencyLimitsMinimumHoursBetweenMax)
}),
  "spendingLimits": zod.object({
  "currency": zod.string().regex(reviseOutreachPlanResponseSpendingLimitsCurrencyRegExp),
  "maximumTotalMinor": zod.int().min(reviseOutreachPlanResponseSpendingLimitsMaximumTotalMinorMin),
  "maximumPerRecipientMinor": zod.int().min(reviseOutreachPlanResponseSpendingLimitsMaximumPerRecipientMinorMin)
}),
  "replyLimits": zod.object({
  "maximumAutomatedTurns": zod.int().min(reviseOutreachPlanResponseReplyLimitsMaximumAutomatedTurnsMin).max(reviseOutreachPlanResponseReplyLimitsMaximumAutomatedTurnsMax),
  "stopOnHumanRequest": zod.boolean(),
  "stopOnObjection": zod.boolean()
}),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "escalationOwnerAppUserId": zod.uuid(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Validate the exact current revision and show authority limitations
 */
export const previewOutreachPlanParams = zod.object({
  "id": zod.uuid()
})


export const previewOutreachPlanResponseIssuesItemCodeMax = 100;

export const previewOutreachPlanResponseIssuesItemPathMax = 200;

export const previewOutreachPlanResponseIssuesItemMessageMax = 500;


export const previewOutreachPlanResponseAuthorityItemActionTypeMax = 100;




export const previewOutreachPlanResponse = zod.object({
  "planId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "revision": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "approvalKind": zod.enum(['bounded_plan']),
  "doesNotApproveIndividualMessages": zod.boolean(),
  "canSubmitReview": zod.boolean(),
  "canActivate": zod.boolean(),
  "issues": zod.array(zod.object({
  "code": zod.string().min(1).max(previewOutreachPlanResponseIssuesItemCodeMax),
  "path": zod.string().min(1).max(previewOutreachPlanResponseIssuesItemPathMax),
  "message": zod.string().min(1).max(previewOutreachPlanResponseIssuesItemMessageMax)
})),
  "policyVersion": zod.int().min(1),
  "authority": zod.array(zod.object({
  "actionType": zod.string().min(1).max(previewOutreachPlanResponseAuthorityItemActionTypeMax),
  "level": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])
})).min(1),
  "reviewAuditId": zod.uuid().nullish()
})


/**
 * @summary Submit an exact immutable plan revision for administrator activation
 */
export const submitOutreachPlanReviewParams = zod.object({
  "id": zod.uuid()
})


export const submitOutreachPlanReviewBodyNoteMax = 1000;

export const submitOutreachPlanReviewBodyHealthSnapshotIdsMax = 100;

export const submitOutreachPlanReviewBodyNextActionIdsMax = 100;



export const submitOutreachPlanReviewBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "requestId": zod.uuid(),
  "note": zod.string().min(1).max(submitOutreachPlanReviewBodyNoteMax).optional(),
  "healthSnapshotIds": zod.array(zod.uuid()).max(submitOutreachPlanReviewBodyHealthSnapshotIdsMax),
  "nextActionIds": zod.array(zod.uuid()).max(submitOutreachPlanReviewBodyNextActionIdsMax)
})


export const submitOutreachPlanReviewResponseIssuesItemCodeMax = 100;

export const submitOutreachPlanReviewResponseIssuesItemPathMax = 200;

export const submitOutreachPlanReviewResponseIssuesItemMessageMax = 500;


export const submitOutreachPlanReviewResponseAuthorityItemActionTypeMax = 100;




export const submitOutreachPlanReviewResponse = zod.object({
  "planId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "revision": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "approvalKind": zod.enum(['bounded_plan']),
  "doesNotApproveIndividualMessages": zod.boolean(),
  "canSubmitReview": zod.boolean(),
  "canActivate": zod.boolean(),
  "issues": zod.array(zod.object({
  "code": zod.string().min(1).max(submitOutreachPlanReviewResponseIssuesItemCodeMax),
  "path": zod.string().min(1).max(submitOutreachPlanReviewResponseIssuesItemPathMax),
  "message": zod.string().min(1).max(submitOutreachPlanReviewResponseIssuesItemMessageMax)
})),
  "policyVersion": zod.int().min(1),
  "authority": zod.array(zod.object({
  "actionType": zod.string().min(1).max(submitOutreachPlanReviewResponseAuthorityItemActionTypeMax),
  "level": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])
})).min(1),
  "reviewAuditId": zod.uuid().nullish()
})


/**
 * @summary Administrator activation of one exact staff-reviewed plan revision
 */
export const activateOutreachPlanParams = zod.object({
  "id": zod.uuid()
})




export const activateOutreachPlanBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "reviewAuditId": zod.uuid()
})

export const activateOutreachPlanResponseOneNameMax = 200;



export const activateOutreachPlanResponseTwoRevisionsItemGoalMax = 1000;

export const activateOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax = 10000;

export const activateOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax = 80;

export const activateOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax = 50;

export const activateOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax = 200;

export const activateOutreachPlanResponseTwoRevisionsItemChannelsMax = 20;

export const activateOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax = 120;

export const activateOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax = 100;

export const activateOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax = 200;

export const activateOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax = 100;

export const activateOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax = 100;

export const activateOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax = 7;

export const activateOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax = 7;

export const activateOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const activateOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const activateOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax = 100;

export const activateOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax = 365;

export const activateOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax = 8760;

export const activateOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const activateOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin = 0;

export const activateOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin = 0;

export const activateOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin = 0;
export const activateOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax = 20;


export const activateOutreachPlanResponseTwoMemberCountMin = 0;



export const activateOutreachPlanResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(activateOutreachPlanResponseOneNameMax),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "pausedAt": zod.iso.datetime({"offset":true}).nullish(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "revisions": zod.array(zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "revision": zod.int().min(1),
  "goal": zod.string().min(1).max(activateOutreachPlanResponseTwoRevisionsItemGoalMax),
  "recipientRules": zod.object({
  "mode": zod.enum(['explicit', 'eligibility_rules']),
  "accountIds": zod.array(zod.uuid()).max(activateOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax).optional(),
  "relationshipTypes": zod.array(zod.string().min(1).max(activateOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax)).max(activateOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
}),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(activateOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax),
  "callMode": zod.enum(['ai_led', 'staff_led']).nullish()
})).min(1).max(activateOutreachPlanResponseTwoRevisionsItemChannelsMax),
  "permittedInformation": zod.object({
  "crmFields": zod.array(zod.string().min(1).max(activateOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax)).max(activateOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax),
  "knowledgeSourceIds": zod.array(zod.string().min(1).max(activateOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax)).max(activateOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax),
  "publicSafeOnly": zod.boolean()
}),
  "contactWindows": zod.object({
  "timezoneFallback": zod.string().min(1).max(activateOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax),
  "weekdays": zod.array(zod.int().min(1).max(activateOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax)).min(1).max(activateOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax),
  "startLocal": zod.string().regex(activateOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp),
  "endLocal": zod.string().regex(activateOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp)
}),
  "frequencyLimits": zod.object({
  "maxContactsPerRecipient": zod.int().min(1).max(activateOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax),
  "periodDays": zod.int().min(1).max(activateOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax),
  "minimumHoursBetween": zod.int().min(1).max(activateOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax)
}),
  "spendingLimits": zod.object({
  "currency": zod.string().regex(activateOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp),
  "maximumTotalMinor": zod.int().min(activateOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin),
  "maximumPerRecipientMinor": zod.int().min(activateOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin)
}),
  "replyLimits": zod.object({
  "maximumAutomatedTurns": zod.int().min(activateOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin).max(activateOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax),
  "stopOnHumanRequest": zod.boolean(),
  "stopOnObjection": zod.boolean()
}),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "escalationOwnerAppUserId": zod.uuid(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "approvals": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "revision": zod.int().min(1),
  "auditId": zod.uuid(),
  "approvedByAppUserId": zod.uuid(),
  "status": zod.enum(['approved', 'revoked', 'stale']),
  "reason": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "memberCount": zod.int().min(activateOutreachPlanResponseTwoMemberCountMin)
}))


/**
 * @summary Pause new activity under an active plan
 */
export const pauseOutreachPlanParams = zod.object({
  "id": zod.uuid()
})


export const pauseOutreachPlanBodyReasonMin = 3;
export const pauseOutreachPlanBodyReasonMax = 1000;



export const pauseOutreachPlanBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "expectedStatus": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "reason": zod.string().min(pauseOutreachPlanBodyReasonMin).max(pauseOutreachPlanBodyReasonMax)
})

export const pauseOutreachPlanResponseOneNameMax = 200;



export const pauseOutreachPlanResponseTwoRevisionsItemGoalMax = 1000;

export const pauseOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax = 10000;

export const pauseOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax = 80;

export const pauseOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax = 50;

export const pauseOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax = 200;

export const pauseOutreachPlanResponseTwoRevisionsItemChannelsMax = 20;

export const pauseOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax = 120;

export const pauseOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax = 100;

export const pauseOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax = 200;

export const pauseOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax = 100;

export const pauseOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax = 100;

export const pauseOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax = 7;

export const pauseOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax = 7;

export const pauseOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const pauseOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const pauseOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax = 100;

export const pauseOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax = 365;

export const pauseOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax = 8760;

export const pauseOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const pauseOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin = 0;

export const pauseOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin = 0;

export const pauseOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin = 0;
export const pauseOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax = 20;


export const pauseOutreachPlanResponseTwoMemberCountMin = 0;



export const pauseOutreachPlanResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(pauseOutreachPlanResponseOneNameMax),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "pausedAt": zod.iso.datetime({"offset":true}).nullish(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "revisions": zod.array(zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "revision": zod.int().min(1),
  "goal": zod.string().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemGoalMax),
  "recipientRules": zod.object({
  "mode": zod.enum(['explicit', 'eligibility_rules']),
  "accountIds": zod.array(zod.uuid()).max(pauseOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax).optional(),
  "relationshipTypes": zod.array(zod.string().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax)).max(pauseOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
}),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax),
  "callMode": zod.enum(['ai_led', 'staff_led']).nullish()
})).min(1).max(pauseOutreachPlanResponseTwoRevisionsItemChannelsMax),
  "permittedInformation": zod.object({
  "crmFields": zod.array(zod.string().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax)).max(pauseOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax),
  "knowledgeSourceIds": zod.array(zod.string().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax)).max(pauseOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax),
  "publicSafeOnly": zod.boolean()
}),
  "contactWindows": zod.object({
  "timezoneFallback": zod.string().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax),
  "weekdays": zod.array(zod.int().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax)).min(1).max(pauseOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax),
  "startLocal": zod.string().regex(pauseOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp),
  "endLocal": zod.string().regex(pauseOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp)
}),
  "frequencyLimits": zod.object({
  "maxContactsPerRecipient": zod.int().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax),
  "periodDays": zod.int().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax),
  "minimumHoursBetween": zod.int().min(1).max(pauseOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax)
}),
  "spendingLimits": zod.object({
  "currency": zod.string().regex(pauseOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp),
  "maximumTotalMinor": zod.int().min(pauseOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin),
  "maximumPerRecipientMinor": zod.int().min(pauseOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin)
}),
  "replyLimits": zod.object({
  "maximumAutomatedTurns": zod.int().min(pauseOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin).max(pauseOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax),
  "stopOnHumanRequest": zod.boolean(),
  "stopOnObjection": zod.boolean()
}),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "escalationOwnerAppUserId": zod.uuid(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "approvals": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "revision": zod.int().min(1),
  "auditId": zod.uuid(),
  "approvedByAppUserId": zod.uuid(),
  "status": zod.enum(['approved', 'revoked', 'stale']),
  "reason": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "memberCount": zod.int().min(pauseOutreachPlanResponseTwoMemberCountMin)
}))


/**
 * @summary Administrator resume of a paused plan with current approval and policy checks
 */
export const resumeOutreachPlanParams = zod.object({
  "id": zod.uuid()
})


export const resumeOutreachPlanBodyReasonMin = 3;
export const resumeOutreachPlanBodyReasonMax = 1000;



export const resumeOutreachPlanBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "expectedStatus": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "reason": zod.string().min(resumeOutreachPlanBodyReasonMin).max(resumeOutreachPlanBodyReasonMax)
})

export const resumeOutreachPlanResponseOneNameMax = 200;



export const resumeOutreachPlanResponseTwoRevisionsItemGoalMax = 1000;

export const resumeOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax = 10000;

export const resumeOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax = 80;

export const resumeOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax = 50;

export const resumeOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax = 200;

export const resumeOutreachPlanResponseTwoRevisionsItemChannelsMax = 20;

export const resumeOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax = 120;

export const resumeOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax = 100;

export const resumeOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax = 200;

export const resumeOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax = 100;

export const resumeOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax = 100;

export const resumeOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax = 7;

export const resumeOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax = 7;

export const resumeOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const resumeOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const resumeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax = 100;

export const resumeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax = 365;

export const resumeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax = 8760;

export const resumeOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const resumeOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin = 0;

export const resumeOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin = 0;

export const resumeOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin = 0;
export const resumeOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax = 20;


export const resumeOutreachPlanResponseTwoMemberCountMin = 0;



export const resumeOutreachPlanResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(resumeOutreachPlanResponseOneNameMax),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "pausedAt": zod.iso.datetime({"offset":true}).nullish(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "revisions": zod.array(zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "revision": zod.int().min(1),
  "goal": zod.string().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemGoalMax),
  "recipientRules": zod.object({
  "mode": zod.enum(['explicit', 'eligibility_rules']),
  "accountIds": zod.array(zod.uuid()).max(resumeOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax).optional(),
  "relationshipTypes": zod.array(zod.string().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax)).max(resumeOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
}),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax),
  "callMode": zod.enum(['ai_led', 'staff_led']).nullish()
})).min(1).max(resumeOutreachPlanResponseTwoRevisionsItemChannelsMax),
  "permittedInformation": zod.object({
  "crmFields": zod.array(zod.string().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax)).max(resumeOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax),
  "knowledgeSourceIds": zod.array(zod.string().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax)).max(resumeOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax),
  "publicSafeOnly": zod.boolean()
}),
  "contactWindows": zod.object({
  "timezoneFallback": zod.string().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax),
  "weekdays": zod.array(zod.int().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax)).min(1).max(resumeOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax),
  "startLocal": zod.string().regex(resumeOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp),
  "endLocal": zod.string().regex(resumeOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp)
}),
  "frequencyLimits": zod.object({
  "maxContactsPerRecipient": zod.int().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax),
  "periodDays": zod.int().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax),
  "minimumHoursBetween": zod.int().min(1).max(resumeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax)
}),
  "spendingLimits": zod.object({
  "currency": zod.string().regex(resumeOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp),
  "maximumTotalMinor": zod.int().min(resumeOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin),
  "maximumPerRecipientMinor": zod.int().min(resumeOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin)
}),
  "replyLimits": zod.object({
  "maximumAutomatedTurns": zod.int().min(resumeOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin).max(resumeOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax),
  "stopOnHumanRequest": zod.boolean(),
  "stopOnObjection": zod.boolean()
}),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "escalationOwnerAppUserId": zod.uuid(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "approvals": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "revision": zod.int().min(1),
  "auditId": zod.uuid(),
  "approvedByAppUserId": zod.uuid(),
  "status": zod.enum(['approved', 'revoked', 'stale']),
  "reason": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "memberCount": zod.int().min(resumeOutreachPlanResponseTwoMemberCountMin)
}))


/**
 * @summary Administrator revocation of all future authority under a plan
 */
export const revokeOutreachPlanParams = zod.object({
  "id": zod.uuid()
})


export const revokeOutreachPlanBodyReasonMin = 3;
export const revokeOutreachPlanBodyReasonMax = 1000;



export const revokeOutreachPlanBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "expectedStatus": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "reason": zod.string().min(revokeOutreachPlanBodyReasonMin).max(revokeOutreachPlanBodyReasonMax)
})

export const revokeOutreachPlanResponseOneNameMax = 200;



export const revokeOutreachPlanResponseTwoRevisionsItemGoalMax = 1000;

export const revokeOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax = 10000;

export const revokeOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax = 80;

export const revokeOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax = 50;

export const revokeOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax = 200;

export const revokeOutreachPlanResponseTwoRevisionsItemChannelsMax = 20;

export const revokeOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax = 120;

export const revokeOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax = 100;

export const revokeOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax = 200;

export const revokeOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax = 100;

export const revokeOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax = 100;

export const revokeOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax = 7;

export const revokeOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax = 7;

export const revokeOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const revokeOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp = new RegExp('^([01]\\d|2[0-3]):[0-5]\\d$');
export const revokeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax = 100;

export const revokeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax = 365;

export const revokeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax = 8760;

export const revokeOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const revokeOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin = 0;

export const revokeOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin = 0;

export const revokeOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin = 0;
export const revokeOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax = 20;


export const revokeOutreachPlanResponseTwoMemberCountMin = 0;



export const revokeOutreachPlanResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(revokeOutreachPlanResponseOneNameMax),
  "status": zod.enum(['draft', 'pending_review', 'active', 'paused', 'suspended', 'revoked', 'expired']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid(),
  "pausedAt": zod.iso.datetime({"offset":true}).nullish(),
  "suspendedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "revisions": zod.array(zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "revision": zod.int().min(1),
  "goal": zod.string().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemGoalMax),
  "recipientRules": zod.object({
  "mode": zod.enum(['explicit', 'eligibility_rules']),
  "accountIds": zod.array(zod.uuid()).max(revokeOutreachPlanResponseTwoRevisionsItemRecipientRulesAccountIdsMax).optional(),
  "relationshipTypes": zod.array(zod.string().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesItemMax)).max(revokeOutreachPlanResponseTwoRevisionsItemRecipientRulesRelationshipTypesMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
}),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemChannelsItemSenderKeyMax),
  "callMode": zod.enum(['ai_led', 'staff_led']).nullish()
})).min(1).max(revokeOutreachPlanResponseTwoRevisionsItemChannelsMax),
  "permittedInformation": zod.object({
  "crmFields": zod.array(zod.string().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsItemMax)).max(revokeOutreachPlanResponseTwoRevisionsItemPermittedInformationCrmFieldsMax),
  "knowledgeSourceIds": zod.array(zod.string().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsItemMax)).max(revokeOutreachPlanResponseTwoRevisionsItemPermittedInformationKnowledgeSourceIdsMax),
  "publicSafeOnly": zod.boolean()
}),
  "contactWindows": zod.object({
  "timezoneFallback": zod.string().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemContactWindowsTimezoneFallbackMax),
  "weekdays": zod.array(zod.int().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysItemMax)).min(1).max(revokeOutreachPlanResponseTwoRevisionsItemContactWindowsWeekdaysMax),
  "startLocal": zod.string().regex(revokeOutreachPlanResponseTwoRevisionsItemContactWindowsStartLocalRegExp),
  "endLocal": zod.string().regex(revokeOutreachPlanResponseTwoRevisionsItemContactWindowsEndLocalRegExp)
}),
  "frequencyLimits": zod.object({
  "maxContactsPerRecipient": zod.int().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMaxContactsPerRecipientMax),
  "periodDays": zod.int().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsPeriodDaysMax),
  "minimumHoursBetween": zod.int().min(1).max(revokeOutreachPlanResponseTwoRevisionsItemFrequencyLimitsMinimumHoursBetweenMax)
}),
  "spendingLimits": zod.object({
  "currency": zod.string().regex(revokeOutreachPlanResponseTwoRevisionsItemSpendingLimitsCurrencyRegExp),
  "maximumTotalMinor": zod.int().min(revokeOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumTotalMinorMin),
  "maximumPerRecipientMinor": zod.int().min(revokeOutreachPlanResponseTwoRevisionsItemSpendingLimitsMaximumPerRecipientMinorMin)
}),
  "replyLimits": zod.object({
  "maximumAutomatedTurns": zod.int().min(revokeOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMin).max(revokeOutreachPlanResponseTwoRevisionsItemReplyLimitsMaximumAutomatedTurnsMax),
  "stopOnHumanRequest": zod.boolean(),
  "stopOnObjection": zod.boolean()
}),
  "startsAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "escalationOwnerAppUserId": zod.uuid(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "approvals": zod.array(zod.object({
  "id": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "revision": zod.int().min(1),
  "auditId": zod.uuid(),
  "approvedByAppUserId": zod.uuid(),
  "status": zod.enum(['approved', 'revoked', 'stale']),
  "reason": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "memberCount": zod.int().min(revokeOutreachPlanResponseTwoMemberCountMin)
}))


/**
 * @summary List canonical review, activation, pause, resume, expiry, and revocation audit events
 */
export const listOutreachPlanHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listOutreachPlanHistoryQueryLimitDefault = 50;
export const listOutreachPlanHistoryQueryLimitMax = 100;

export const listOutreachPlanHistoryQueryOffsetDefault = 0;
export const listOutreachPlanHistoryQueryOffsetMin = 0;



export const listOutreachPlanHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listOutreachPlanHistoryQueryLimitMax).default(listOutreachPlanHistoryQueryLimitDefault),
  "offset": zod.int().min(listOutreachPlanHistoryQueryOffsetMin).default(listOutreachPlanHistoryQueryOffsetDefault)
})


export const listOutreachPlanHistoryResponseTotalMin = 0;

export const listOutreachPlanHistoryResponseLimitMax = 100;

export const listOutreachPlanHistoryResponseOffsetMin = 0;



export const listOutreachPlanHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "auditId": zod.uuid(),
  "event": zod.enum(['review_submitted', 'activated', 'paused', 'resumed', 'revoked', 'expired']),
  "planRevisionId": zod.uuid().nullish(),
  "revision": zod.int().min(1),
  "status": zod.enum(['executed', 'pending_approval', 'approved', 'rejected', 'deferred', 'dismissed', 'blocked', 'failed']),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "requestedBy": zod.string().nullable(),
  "approvedBy": zod.string().nullish(),
  "reason": zod.string().nullish(),
  "approvalId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listOutreachPlanHistoryResponseTotalMin),
  "limit": zod.int().min(1).max(listOutreachPlanHistoryResponseLimitMax),
  "offset": zod.int().min(listOutreachPlanHistoryResponseOffsetMin)
})


/**
 * @summary List durable execution and delivery history for an outreach plan
 */
export const listOutreachExecutionsParams = zod.object({
  "id": zod.uuid()
})

export const listOutreachExecutionsQueryLimitDefault = 50;
export const listOutreachExecutionsQueryLimitMax = 100;

export const listOutreachExecutionsQueryOffsetDefault = 0;
export const listOutreachExecutionsQueryOffsetMin = 0;



export const listOutreachExecutionsQueryParams = zod.object({
  "status": zod.enum(['scheduled', 'claimed', 'blocked', 'provider_accepted', 'delivered', 'completed', 'failed', 'unknown', 'manual_handoff', 'cancelled']).optional(),
  "limit": zod.int().min(1).max(listOutreachExecutionsQueryLimitMax).default(listOutreachExecutionsQueryLimitDefault),
  "offset": zod.int().min(listOutreachExecutionsQueryOffsetMin).default(listOutreachExecutionsQueryOffsetDefault)
})


export const listOutreachExecutionsResponseItemsItemSenderKeyMax = 200;

export const listOutreachExecutionsResponseItemsItemRecipientKeyMax = 200;

export const listOutreachExecutionsResponseItemsItemRecipientTimezoneMax = 100;

export const listOutreachExecutionsResponseItemsItemAttemptCountMin = 0;

export const listOutreachExecutionsResponseItemsItemCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listOutreachExecutionsResponseItemsItemEstimatedCostMinorMin = 0;

export const listOutreachExecutionsResponseItemsItemActualCostMinorMin = 0;

export const listOutreachExecutionsResponseTotalMin = 0;

export const listOutreachExecutionsResponseLimitMax = 100;

export const listOutreachExecutionsResponseOffsetMin = 0;



export const listOutreachExecutionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "memberId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "contactId": zod.uuid().nullable(),
  "nextActionId": zod.uuid().nullable(),
  "socialPostId": zod.uuid().nullable(),
  "socialPostVersion": zod.int().min(1).nullable(),
  "socialInboxItemId": zod.uuid().nullable(),
  "replyStateId": zod.uuid().nullable(),
  "auditId": zod.uuid().nullable(),
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(listOutreachExecutionsResponseItemsItemSenderKeyMax),
  "recipientKey": zod.string().min(1).max(listOutreachExecutionsResponseItemsItemRecipientKeyMax),
  "recipientTimezone": zod.string().min(1).max(listOutreachExecutionsResponseItemsItemRecipientTimezoneMax),
  "deduplicationKey": zod.uuid(),
  "status": zod.enum(['scheduled', 'claimed', 'blocked', 'provider_accepted', 'delivered', 'completed', 'failed', 'unknown', 'manual_handoff', 'cancelled']),
  "attemptCount": zod.int().min(listOutreachExecutionsResponseItemsItemAttemptCountMin),
  "dueAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable(),
  "currency": zod.string().regex(listOutreachExecutionsResponseItemsItemCurrencyRegExp),
  "estimatedCostMinor": zod.int().min(listOutreachExecutionsResponseItemsItemEstimatedCostMinorMin),
  "actualCostMinor": zod.int().min(listOutreachExecutionsResponseItemsItemActualCostMinorMin).nullable(),
  "leaseExpiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerActionId": zod.string().nullable(),
  "providerAcceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "blockedReason": zod.string().nullable(),
  "blockedDetail": zod.string().nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listOutreachExecutionsResponseTotalMin),
  "limit": zod.int().min(1).max(listOutreachExecutionsResponseLimitMax),
  "offset": zod.int().min(listOutreachExecutionsResponseOffsetMin)
})


/**
 * @summary Reserve and schedule one execution under an exact approved plan revision
 */
export const scheduleOutreachExecutionParams = zod.object({
  "id": zod.uuid()
})



export const scheduleOutreachExecutionBodySenderKeyMax = 200;

export const scheduleOutreachExecutionBodyEstimatedCostMinorMin = 0;
export const scheduleOutreachExecutionBodyEstimatedCostMinorMax = 1000000000;



export const scheduleOutreachExecutionBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "requestId": zod.uuid().describe('Stable idempotency key reused for provider dispatch when supported'),
  "accountId": zod.uuid(),
  "contactId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "socialPostId": zod.uuid().nullish().describe('Canonical approved Content Hub social post used by public social outreach'),
  "socialPostVersion": zod.int().min(1).nullish().describe('Exact separately approved canonical social post version'),
  "socialInboxItemId": zod.uuid().nullish().describe('Exact canonical inbound social conversation used for an eligible private reply'),
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(scheduleOutreachExecutionBodySenderKeyMax),
  "dueAt": zod.iso.datetime({"offset":true}),
  "estimatedCostMinor": zod.int().min(scheduleOutreachExecutionBodyEstimatedCostMinorMin).max(scheduleOutreachExecutionBodyEstimatedCostMinorMax)
})


export const scheduleOutreachExecutionResponseSenderKeyMax = 200;

export const scheduleOutreachExecutionResponseRecipientKeyMax = 200;

export const scheduleOutreachExecutionResponseRecipientTimezoneMax = 100;

export const scheduleOutreachExecutionResponseAttemptCountMin = 0;

export const scheduleOutreachExecutionResponseCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const scheduleOutreachExecutionResponseEstimatedCostMinorMin = 0;

export const scheduleOutreachExecutionResponseActualCostMinorMin = 0;



export const scheduleOutreachExecutionResponse = zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "memberId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "contactId": zod.uuid().nullable(),
  "nextActionId": zod.uuid().nullable(),
  "socialPostId": zod.uuid().nullable(),
  "socialPostVersion": zod.int().min(1).nullable(),
  "socialInboxItemId": zod.uuid().nullable(),
  "replyStateId": zod.uuid().nullable(),
  "auditId": zod.uuid().nullable(),
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(scheduleOutreachExecutionResponseSenderKeyMax),
  "recipientKey": zod.string().min(1).max(scheduleOutreachExecutionResponseRecipientKeyMax),
  "recipientTimezone": zod.string().min(1).max(scheduleOutreachExecutionResponseRecipientTimezoneMax),
  "deduplicationKey": zod.uuid(),
  "status": zod.enum(['scheduled', 'claimed', 'blocked', 'provider_accepted', 'delivered', 'completed', 'failed', 'unknown', 'manual_handoff', 'cancelled']),
  "attemptCount": zod.int().min(scheduleOutreachExecutionResponseAttemptCountMin),
  "dueAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable(),
  "currency": zod.string().regex(scheduleOutreachExecutionResponseCurrencyRegExp),
  "estimatedCostMinor": zod.int().min(scheduleOutreachExecutionResponseEstimatedCostMinorMin),
  "actualCostMinor": zod.int().min(scheduleOutreachExecutionResponseActualCostMinorMin).nullable(),
  "leaseExpiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerActionId": zod.string().nullable(),
  "providerAcceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "blockedReason": zod.string().nullable(),
  "blockedDetail": zod.string().nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List upcoming, blocked, accepted, unknown, and handoff work for a plan
 */
export const listOutreachScheduleParams = zod.object({
  "id": zod.uuid()
})

export const listOutreachScheduleQueryLimitDefault = 50;
export const listOutreachScheduleQueryLimitMax = 100;

export const listOutreachScheduleQueryOffsetDefault = 0;
export const listOutreachScheduleQueryOffsetMin = 0;



export const listOutreachScheduleQueryParams = zod.object({
  "limit": zod.int().min(1).max(listOutreachScheduleQueryLimitMax).default(listOutreachScheduleQueryLimitDefault),
  "offset": zod.int().min(listOutreachScheduleQueryOffsetMin).default(listOutreachScheduleQueryOffsetDefault)
})


export const listOutreachScheduleResponseItemsItemSenderKeyMax = 200;

export const listOutreachScheduleResponseItemsItemRecipientKeyMax = 200;

export const listOutreachScheduleResponseItemsItemRecipientTimezoneMax = 100;

export const listOutreachScheduleResponseItemsItemAttemptCountMin = 0;

export const listOutreachScheduleResponseItemsItemCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listOutreachScheduleResponseItemsItemEstimatedCostMinorMin = 0;

export const listOutreachScheduleResponseItemsItemActualCostMinorMin = 0;

export const listOutreachScheduleResponseTotalMin = 0;

export const listOutreachScheduleResponseLimitMax = 100;

export const listOutreachScheduleResponseOffsetMin = 0;



export const listOutreachScheduleResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "memberId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "contactId": zod.uuid().nullable(),
  "nextActionId": zod.uuid().nullable(),
  "socialPostId": zod.uuid().nullable(),
  "socialPostVersion": zod.int().min(1).nullable(),
  "socialInboxItemId": zod.uuid().nullable(),
  "replyStateId": zod.uuid().nullable(),
  "auditId": zod.uuid().nullable(),
  "channel": zod.enum(['email', 'sms', 'public_social', 'private_social', 'call']),
  "senderKey": zod.string().min(1).max(listOutreachScheduleResponseItemsItemSenderKeyMax),
  "recipientKey": zod.string().min(1).max(listOutreachScheduleResponseItemsItemRecipientKeyMax),
  "recipientTimezone": zod.string().min(1).max(listOutreachScheduleResponseItemsItemRecipientTimezoneMax),
  "deduplicationKey": zod.uuid(),
  "status": zod.enum(['scheduled', 'claimed', 'blocked', 'provider_accepted', 'delivered', 'completed', 'failed', 'unknown', 'manual_handoff', 'cancelled']),
  "attemptCount": zod.int().min(listOutreachScheduleResponseItemsItemAttemptCountMin),
  "dueAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable(),
  "currency": zod.string().regex(listOutreachScheduleResponseItemsItemCurrencyRegExp),
  "estimatedCostMinor": zod.int().min(listOutreachScheduleResponseItemsItemEstimatedCostMinorMin),
  "actualCostMinor": zod.int().min(listOutreachScheduleResponseItemsItemActualCostMinorMin).nullable(),
  "leaseExpiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerActionId": zod.string().nullable(),
  "providerAcceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "blockedReason": zod.string().nullable(),
  "blockedDetail": zod.string().nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listOutreachScheduleResponseTotalMin),
  "limit": zod.int().min(1).max(listOutreachScheduleResponseLimitMax),
  "offset": zod.int().min(listOutreachScheduleResponseOffsetMin)
})


/**
 * @summary List plan-scoped reply conversations and staff handoffs
 */
export const listOutreachReplyStatesQueryLimitDefault = 50;
export const listOutreachReplyStatesQueryLimitMax = 100;

export const listOutreachReplyStatesQueryOffsetDefault = 0;
export const listOutreachReplyStatesQueryOffsetMin = 0;



export const listOutreachReplyStatesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listOutreachReplyStatesQueryLimitMax).default(listOutreachReplyStatesQueryLimitDefault),
  "offset": zod.int().min(listOutreachReplyStatesQueryOffsetMin).default(listOutreachReplyStatesQueryOffsetDefault),
  "status": zod.enum(['active', 'handoff', 'staff_owned', 'stopped', 'completed', 'quarantined']).optional(),
  "planId": zod.uuid().optional()
})

export const listOutreachReplyStatesResponseItemsItemAutomatedTurnCountMin = 0;

export const listOutreachReplyStatesResponseTotalMin = 0;

export const listOutreachReplyStatesResponseLimitMax = 100;

export const listOutreachReplyStatesResponseOffsetMin = 0;



export const listOutreachReplyStatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "memberId": zod.uuid(),
  "accountId": zod.uuid(),
  "contactId": zod.uuid().nullable(),
  "channel": zod.enum(['email', 'sms', 'private_social', 'call']),
  "status": zod.enum(['active', 'handoff', 'staff_owned', 'stopped', 'completed', 'quarantined']),
  "automatedTurnCount": zod.int().min(listOutreachReplyStatesResponseItemsItemAutomatedTurnCountMin),
  "lastClassification": zod.union([zod.enum(['routine', 'opt_out', 'human_request', 'sensitive', 'out_of_scope', 'uncertain', 'voice_handoff']),zod.null()]),
  "handoffReason": zod.string().nullable(),
  "handoffBrief": zod.string().nullable(),
  "suggestedResponse": zod.string().nullable(),
  "staffActionId": zod.uuid().nullable(),
  "ownedByAppUserId": zod.uuid().nullable(),
  "claimedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastInboundAt": zod.iso.datetime({"offset":true}).nullable(),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listOutreachReplyStatesResponseTotalMin),
  "limit": zod.int().min(1).max(listOutreachReplyStatesResponseLimitMax),
  "offset": zod.int().min(listOutreachReplyStatesResponseOffsetMin)
})


/**
 * @summary Atomically take staff ownership and stop automated continuation
 */
export const claimOutreachReplyStateParams = zod.object({
  "id": zod.uuid()
})

export const claimOutreachReplyStateResponseAutomatedTurnCountMin = 0;



export const claimOutreachReplyStateResponse = zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "memberId": zod.uuid(),
  "accountId": zod.uuid(),
  "contactId": zod.uuid().nullable(),
  "channel": zod.enum(['email', 'sms', 'private_social', 'call']),
  "status": zod.enum(['active', 'handoff', 'staff_owned', 'stopped', 'completed', 'quarantined']),
  "automatedTurnCount": zod.int().min(claimOutreachReplyStateResponseAutomatedTurnCountMin),
  "lastClassification": zod.union([zod.enum(['routine', 'opt_out', 'human_request', 'sensitive', 'out_of_scope', 'uncertain', 'voice_handoff']),zod.null()]),
  "handoffReason": zod.string().nullable(),
  "handoffBrief": zod.string().nullable(),
  "suggestedResponse": zod.string().nullable(),
  "staffActionId": zod.uuid().nullable(),
  "ownedByAppUserId": zod.uuid().nullable(),
  "claimedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastInboundAt": zod.iso.datetime({"offset":true}).nullable(),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Close a staff-owned conversation or deliberately resume bounded automation
 */
export const resolveOutreachReplyStateParams = zod.object({
  "id": zod.uuid()
})

export const resolveOutreachReplyStateBodyReasonMax = 1000;



export const resolveOutreachReplyStateBody = zod.object({
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "resolution": zod.enum(['resume_automation', 'close_conversation']),
  "reason": zod.string().min(1).max(resolveOutreachReplyStateBodyReasonMax)
})

export const resolveOutreachReplyStateResponseAutomatedTurnCountMin = 0;



export const resolveOutreachReplyStateResponse = zod.object({
  "id": zod.uuid(),
  "planId": zod.uuid(),
  "planRevisionId": zod.uuid(),
  "memberId": zod.uuid(),
  "accountId": zod.uuid(),
  "contactId": zod.uuid().nullable(),
  "channel": zod.enum(['email', 'sms', 'private_social', 'call']),
  "status": zod.enum(['active', 'handoff', 'staff_owned', 'stopped', 'completed', 'quarantined']),
  "automatedTurnCount": zod.int().min(resolveOutreachReplyStateResponseAutomatedTurnCountMin),
  "lastClassification": zod.union([zod.enum(['routine', 'opt_out', 'human_request', 'sensitive', 'out_of_scope', 'uncertain', 'voice_handoff']),zod.null()]),
  "handoffReason": zod.string().nullable(),
  "handoffBrief": zod.string().nullable(),
  "suggestedResponse": zod.string().nullable(),
  "staffActionId": zod.uuid().nullable(),
  "ownedByAppUserId": zod.uuid().nullable(),
  "claimedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastInboundAt": zod.iso.datetime({"offset":true}).nullable(),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List entity-scoped staff feedback linked to canonical actions and plan versions
 */
export const listRelationshipHealthFeedbackQueryLimitDefault = 50;
export const listRelationshipHealthFeedbackQueryLimitMax = 100;

export const listRelationshipHealthFeedbackQueryOffsetDefault = 0;
export const listRelationshipHealthFeedbackQueryOffsetMin = 0;



export const listRelationshipHealthFeedbackQueryParams = zod.object({
  "limit": zod.int().min(1).max(listRelationshipHealthFeedbackQueryLimitMax).default(listRelationshipHealthFeedbackQueryLimitDefault),
  "offset": zod.int().min(listRelationshipHealthFeedbackQueryOffsetMin).default(listRelationshipHealthFeedbackQueryOffsetDefault),
  "planId": zod.uuid().optional(),
  "nextActionId": zod.uuid().optional(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']).optional()
})

export const listRelationshipHealthFeedbackResponseTotalMin = 0;

export const listRelationshipHealthFeedbackResponseLimitMax = 100;

export const listRelationshipHealthFeedbackResponseOffsetMin = 0;



export const listRelationshipHealthFeedbackResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "snapshotId": zod.uuid().nullable(),
  "planId": zod.uuid().nullable(),
  "planRevisionId": zod.uuid().nullable(),
  "executionId": zod.uuid().nullable(),
  "nextActionId": zod.uuid().nullable(),
  "auditId": zod.uuid().nullable(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']),
  "outcome": zod.enum(['accepted', 'edited', 'rejected', 'deferred', 'staff_handoff', 'delivered', 'failed', 'unknown', 'meaningful_reply', 'no_reply', 'opt_out', 'commitment_completed', 'relationship_improved', 'relationship_stable', 'relationship_declined', 'missing_evidence']),
  "detail": zod.record(zod.string(), zod.unknown()),
  "recordedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listRelationshipHealthFeedbackResponseTotalMin),
  "limit": zod.int().min(1).max(listRelationshipHealthFeedbackResponseLimitMax),
  "offset": zod.int().min(listRelationshipHealthFeedbackResponseOffsetMin)
})


/**
 * @summary Record idempotent staff feedback without granting outreach authority
 */
export const recordRelationshipHealthFeedbackBodyOneDetailNoteMax = 1000;

export const recordRelationshipHealthFeedbackBodyOneDetailEditSignalsMax = 8;

export const recordRelationshipHealthFeedbackBodyTwoDetailNoteMax = 1000;

export const recordRelationshipHealthFeedbackBodyTwoDetailEditSignalsMax = 8;

export const recordRelationshipHealthFeedbackBodyThreeDetailNoteMax = 1000;

export const recordRelationshipHealthFeedbackBodyThreeDetailEditSignalsMax = 8;

export const recordRelationshipHealthFeedbackBodyFourDetailNoteMax = 1000;

export const recordRelationshipHealthFeedbackBodyFourDetailEditSignalsMax = 8;

export const recordRelationshipHealthFeedbackBodyFiveDetailNoteMax = 1000;

export const recordRelationshipHealthFeedbackBodyFiveDetailEditSignalsMax = 8;

export const recordRelationshipHealthFeedbackBodySixDetailNoteMax = 1000;

export const recordRelationshipHealthFeedbackBodySixDetailEditSignalsMax = 8;

export const recordRelationshipHealthFeedbackBodySevenDetailNoteMax = 1000;

export const recordRelationshipHealthFeedbackBodySevenDetailEditSignalsMax = 8;



export const recordRelationshipHealthFeedbackBody = zod.union([zod.object({
  "requestId": zod.uuid().optional(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']).optional(),
  "outcome": zod.enum(['accepted', 'edited', 'rejected', 'deferred', 'staff_handoff', 'delivered', 'failed', 'unknown', 'meaningful_reply', 'no_reply', 'opt_out', 'commitment_completed', 'relationship_improved', 'relationship_stable', 'relationship_declined', 'missing_evidence']).optional(),
  "snapshotId": zod.uuid(),
  "planId": zod.uuid().optional(),
  "planRevisionId": zod.uuid().optional(),
  "executionId": zod.uuid().optional(),
  "nextActionId": zod.uuid().optional(),
  "auditId": zod.uuid().optional(),
  "detail": zod.object({
  "note": zod.string().min(1).max(recordRelationshipHealthFeedbackBodyOneDetailNoteMax).optional(),
  "editSignals": zod.array(zod.enum(['shorter', 'longer', 'warmer', 'more_direct', 'question_led', 'less_frequent', 'later', 'earlier'])).max(recordRelationshipHealthFeedbackBodyOneDetailEditSignalsMax).optional()
}).optional()
}),zod.object({
  "requestId": zod.uuid().optional(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']).optional(),
  "outcome": zod.enum(['accepted', 'edited', 'rejected', 'deferred', 'staff_handoff', 'delivered', 'failed', 'unknown', 'meaningful_reply', 'no_reply', 'opt_out', 'commitment_completed', 'relationship_improved', 'relationship_stable', 'relationship_declined', 'missing_evidence']).optional(),
  "snapshotId": zod.uuid().optional(),
  "planId": zod.uuid(),
  "planRevisionId": zod.uuid().optional(),
  "executionId": zod.uuid().optional(),
  "nextActionId": zod.uuid().optional(),
  "auditId": zod.uuid().optional(),
  "detail": zod.object({
  "note": zod.string().min(1).max(recordRelationshipHealthFeedbackBodyTwoDetailNoteMax).optional(),
  "editSignals": zod.array(zod.enum(['shorter', 'longer', 'warmer', 'more_direct', 'question_led', 'less_frequent', 'later', 'earlier'])).max(recordRelationshipHealthFeedbackBodyTwoDetailEditSignalsMax).optional()
}).optional()
}),zod.object({
  "requestId": zod.uuid().optional(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']).optional(),
  "outcome": zod.enum(['accepted', 'edited', 'rejected', 'deferred', 'staff_handoff', 'delivered', 'failed', 'unknown', 'meaningful_reply', 'no_reply', 'opt_out', 'commitment_completed', 'relationship_improved', 'relationship_stable', 'relationship_declined', 'missing_evidence']).optional(),
  "snapshotId": zod.uuid().optional(),
  "planId": zod.uuid().optional(),
  "planRevisionId": zod.uuid(),
  "executionId": zod.uuid().optional(),
  "nextActionId": zod.uuid().optional(),
  "auditId": zod.uuid().optional(),
  "detail": zod.object({
  "note": zod.string().min(1).max(recordRelationshipHealthFeedbackBodyThreeDetailNoteMax).optional(),
  "editSignals": zod.array(zod.enum(['shorter', 'longer', 'warmer', 'more_direct', 'question_led', 'less_frequent', 'later', 'earlier'])).max(recordRelationshipHealthFeedbackBodyThreeDetailEditSignalsMax).optional()
}).optional()
}),zod.object({
  "requestId": zod.uuid().optional(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']).optional(),
  "outcome": zod.enum(['accepted', 'edited', 'rejected', 'deferred', 'staff_handoff', 'delivered', 'failed', 'unknown', 'meaningful_reply', 'no_reply', 'opt_out', 'commitment_completed', 'relationship_improved', 'relationship_stable', 'relationship_declined', 'missing_evidence']).optional(),
  "snapshotId": zod.uuid().optional(),
  "planId": zod.uuid().optional(),
  "planRevisionId": zod.uuid().optional(),
  "executionId": zod.uuid(),
  "nextActionId": zod.uuid().optional(),
  "auditId": zod.uuid().optional(),
  "detail": zod.object({
  "note": zod.string().min(1).max(recordRelationshipHealthFeedbackBodyFourDetailNoteMax).optional(),
  "editSignals": zod.array(zod.enum(['shorter', 'longer', 'warmer', 'more_direct', 'question_led', 'less_frequent', 'later', 'earlier'])).max(recordRelationshipHealthFeedbackBodyFourDetailEditSignalsMax).optional()
}).optional()
}),zod.object({
  "requestId": zod.uuid().optional(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']).optional(),
  "outcome": zod.enum(['accepted', 'edited', 'rejected', 'deferred', 'staff_handoff', 'delivered', 'failed', 'unknown', 'meaningful_reply', 'no_reply', 'opt_out', 'commitment_completed', 'relationship_improved', 'relationship_stable', 'relationship_declined', 'missing_evidence']).optional(),
  "snapshotId": zod.uuid().optional(),
  "planId": zod.uuid().optional(),
  "planRevisionId": zod.uuid().optional(),
  "executionId": zod.uuid().optional(),
  "nextActionId": zod.uuid(),
  "auditId": zod.uuid().optional(),
  "detail": zod.object({
  "note": zod.string().min(1).max(recordRelationshipHealthFeedbackBodyFiveDetailNoteMax).optional(),
  "editSignals": zod.array(zod.enum(['shorter', 'longer', 'warmer', 'more_direct', 'question_led', 'less_frequent', 'later', 'earlier'])).max(recordRelationshipHealthFeedbackBodyFiveDetailEditSignalsMax).optional()
}).optional()
}),zod.object({
  "requestId": zod.uuid().optional(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']).optional(),
  "outcome": zod.enum(['accepted', 'edited', 'rejected', 'deferred', 'staff_handoff', 'delivered', 'failed', 'unknown', 'meaningful_reply', 'no_reply', 'opt_out', 'commitment_completed', 'relationship_improved', 'relationship_stable', 'relationship_declined', 'missing_evidence']).optional(),
  "snapshotId": zod.uuid().optional(),
  "planId": zod.uuid().optional(),
  "planRevisionId": zod.uuid().optional(),
  "executionId": zod.uuid().optional(),
  "nextActionId": zod.uuid().optional(),
  "auditId": zod.uuid(),
  "detail": zod.object({
  "note": zod.string().min(1).max(recordRelationshipHealthFeedbackBodySixDetailNoteMax).optional(),
  "editSignals": zod.array(zod.enum(['shorter', 'longer', 'warmer', 'more_direct', 'question_led', 'less_frequent', 'later', 'earlier'])).max(recordRelationshipHealthFeedbackBodySixDetailEditSignalsMax).optional()
}).optional()
})]).and(zod.object({
  "requestId": zod.uuid(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']),
  "outcome": zod.enum(['accepted', 'edited', 'rejected', 'deferred', 'staff_handoff', 'delivered', 'failed', 'unknown', 'meaningful_reply', 'no_reply', 'opt_out', 'commitment_completed', 'relationship_improved', 'relationship_stable', 'relationship_declined', 'missing_evidence']),
  "snapshotId": zod.uuid().optional(),
  "planId": zod.uuid().optional(),
  "planRevisionId": zod.uuid().optional(),
  "executionId": zod.uuid().optional(),
  "nextActionId": zod.uuid().optional(),
  "auditId": zod.uuid().optional(),
  "detail": zod.object({
  "note": zod.string().min(1).max(recordRelationshipHealthFeedbackBodySevenDetailNoteMax).optional(),
  "editSignals": zod.array(zod.enum(['shorter', 'longer', 'warmer', 'more_direct', 'question_led', 'less_frequent', 'later', 'earlier'])).max(recordRelationshipHealthFeedbackBodySevenDetailEditSignalsMax).optional()
}).optional()
}))

export const recordRelationshipHealthFeedbackResponse = zod.object({
  "id": zod.uuid(),
  "snapshotId": zod.uuid().nullable(),
  "planId": zod.uuid().nullable(),
  "planRevisionId": zod.uuid().nullable(),
  "executionId": zod.uuid().nullable(),
  "nextActionId": zod.uuid().nullable(),
  "auditId": zod.uuid().nullable(),
  "feedbackType": zod.enum(['approval', 'edit', 'rejection', 'deferral', 'handoff', 'delivery', 'reply', 'commitment', 'relationship_outcome']),
  "outcome": zod.enum(['accepted', 'edited', 'rejected', 'deferred', 'staff_handoff', 'delivered', 'failed', 'unknown', 'meaningful_reply', 'no_reply', 'opt_out', 'commitment_completed', 'relationship_improved', 'relationship_stable', 'relationship_declined', 'missing_evidence']),
  "detail": zod.record(zod.string(), zod.unknown()),
  "recordedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List inspectable immutable recommendation-learning versions
 */
export const listRelationshipHealthLearningVersionsQueryLimitDefault = 50;
export const listRelationshipHealthLearningVersionsQueryLimitMax = 100;

export const listRelationshipHealthLearningVersionsQueryOffsetDefault = 0;
export const listRelationshipHealthLearningVersionsQueryOffsetMin = 0;



export const listRelationshipHealthLearningVersionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listRelationshipHealthLearningVersionsQueryLimitMax).default(listRelationshipHealthLearningVersionsQueryLimitDefault),
  "offset": zod.int().min(listRelationshipHealthLearningVersionsQueryOffsetMin).default(listRelationshipHealthLearningVersionsQueryOffsetDefault)
})


export const listRelationshipHealthLearningVersionsResponseItemsItemConfigurationPriorityOffsetMin = -8;
export const listRelationshipHealthLearningVersionsResponseItemsItemConfigurationPriorityOffsetMax = 8;

export const listRelationshipHealthLearningVersionsResponseItemsItemConfigurationTimingOffsetHoursMin = -24;
export const listRelationshipHealthLearningVersionsResponseItemsItemConfigurationTimingOffsetHoursMax = 48;

export const listRelationshipHealthLearningVersionsResponseItemsItemEvidenceCountsMinOne = 0;


export const listRelationshipHealthLearningVersionsResponseTotalMin = 0;

export const listRelationshipHealthLearningVersionsResponseLimitMax = 100;

export const listRelationshipHealthLearningVersionsResponseOffsetMin = 0;



export const listRelationshipHealthLearningVersionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "status": zod.enum(['active', 'superseded']),
  "basedOnVersionId": zod.uuid().nullable(),
  "configuration": zod.object({
  "priorityOffset": zod.int().min(listRelationshipHealthLearningVersionsResponseItemsItemConfigurationPriorityOffsetMin).max(listRelationshipHealthLearningVersionsResponseItemsItemConfigurationPriorityOffsetMax),
  "timingOffsetHours": zod.int().min(listRelationshipHealthLearningVersionsResponseItemsItemConfigurationTimingOffsetHoursMin).max(listRelationshipHealthLearningVersionsResponseItemsItemConfigurationTimingOffsetHoursMax),
  "contentStyle": zod.enum(['balanced', 'concise', 'question_led'])
}),
  "evidence": zod.object({
  "windowStart": zod.iso.datetime({"offset":true}),
  "windowEnd": zod.iso.datetime({"offset":true}),
  "feedbackIds": zod.array(zod.uuid()),
  "nextActionIds": zod.array(zod.uuid()),
  "planRevisionIds": zod.array(zod.uuid()),
  "executionIds": zod.array(zod.uuid()),
  "snapshotIds": zod.array(zod.uuid()),
  "counts": zod.record(zod.string(), zod.int().min(listRelationshipHealthLearningVersionsResponseItemsItemEvidenceCountsMinOne))
}),
  "explanation": zod.array(zod.string()).min(1),
  "correlationNotice": zod.string(),
  "policyBoundary": zod.string(),
  "createdByAppUserId": zod.uuid(),
  "activatedAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listRelationshipHealthLearningVersionsResponseTotalMin),
  "limit": zod.int().min(1).max(listRelationshipHealthLearningVersionsResponseLimitMax),
  "offset": zod.int().min(listRelationshipHealthLearningVersionsResponseOffsetMin)
})


/**
 * @summary Activate a bounded recommendation-learning version without enabling outreach
 */

export const refreshRelationshipHealthLearningResponseConfigurationPriorityOffsetMin = -8;
export const refreshRelationshipHealthLearningResponseConfigurationPriorityOffsetMax = 8;

export const refreshRelationshipHealthLearningResponseConfigurationTimingOffsetHoursMin = -24;
export const refreshRelationshipHealthLearningResponseConfigurationTimingOffsetHoursMax = 48;

export const refreshRelationshipHealthLearningResponseEvidenceCountsMinOne = 0;




export const refreshRelationshipHealthLearningResponse = zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "status": zod.enum(['active', 'superseded']),
  "basedOnVersionId": zod.uuid().nullable(),
  "configuration": zod.object({
  "priorityOffset": zod.int().min(refreshRelationshipHealthLearningResponseConfigurationPriorityOffsetMin).max(refreshRelationshipHealthLearningResponseConfigurationPriorityOffsetMax),
  "timingOffsetHours": zod.int().min(refreshRelationshipHealthLearningResponseConfigurationTimingOffsetHoursMin).max(refreshRelationshipHealthLearningResponseConfigurationTimingOffsetHoursMax),
  "contentStyle": zod.enum(['balanced', 'concise', 'question_led'])
}),
  "evidence": zod.object({
  "windowStart": zod.iso.datetime({"offset":true}),
  "windowEnd": zod.iso.datetime({"offset":true}),
  "feedbackIds": zod.array(zod.uuid()),
  "nextActionIds": zod.array(zod.uuid()),
  "planRevisionIds": zod.array(zod.uuid()),
  "executionIds": zod.array(zod.uuid()),
  "snapshotIds": zod.array(zod.uuid()),
  "counts": zod.record(zod.string(), zod.int().min(refreshRelationshipHealthLearningResponseEvidenceCountsMinOne))
}),
  "explanation": zod.array(zod.string()).min(1),
  "correlationNotice": zod.string(),
  "policyBoundary": zod.string(),
  "createdByAppUserId": zod.uuid(),
  "activatedAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Create a new active version from a prior learned configuration
 */
export const rollbackRelationshipHealthLearningParams = zod.object({
  "id": zod.uuid()
})


export const rollbackRelationshipHealthLearningResponseConfigurationPriorityOffsetMin = -8;
export const rollbackRelationshipHealthLearningResponseConfigurationPriorityOffsetMax = 8;

export const rollbackRelationshipHealthLearningResponseConfigurationTimingOffsetHoursMin = -24;
export const rollbackRelationshipHealthLearningResponseConfigurationTimingOffsetHoursMax = 48;

export const rollbackRelationshipHealthLearningResponseEvidenceCountsMinOne = 0;




export const rollbackRelationshipHealthLearningResponse = zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "status": zod.enum(['active', 'superseded']),
  "basedOnVersionId": zod.uuid().nullable(),
  "configuration": zod.object({
  "priorityOffset": zod.int().min(rollbackRelationshipHealthLearningResponseConfigurationPriorityOffsetMin).max(rollbackRelationshipHealthLearningResponseConfigurationPriorityOffsetMax),
  "timingOffsetHours": zod.int().min(rollbackRelationshipHealthLearningResponseConfigurationTimingOffsetHoursMin).max(rollbackRelationshipHealthLearningResponseConfigurationTimingOffsetHoursMax),
  "contentStyle": zod.enum(['balanced', 'concise', 'question_led'])
}),
  "evidence": zod.object({
  "windowStart": zod.iso.datetime({"offset":true}),
  "windowEnd": zod.iso.datetime({"offset":true}),
  "feedbackIds": zod.array(zod.uuid()),
  "nextActionIds": zod.array(zod.uuid()),
  "planRevisionIds": zod.array(zod.uuid()),
  "executionIds": zod.array(zod.uuid()),
  "snapshotIds": zod.array(zod.uuid()),
  "counts": zod.record(zod.string(), zod.int().min(rollbackRelationshipHealthLearningResponseEvidenceCountsMinOne))
}),
  "explanation": zod.array(zod.string()).min(1),
  "correlationNotice": zod.string(),
  "policyBoundary": zod.string(),
  "createdByAppUserId": zod.uuid(),
  "activatedAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Report delivery, engagement, relationship evidence and operational failures separately
 */
export const getRelationshipHealthAutomationReportQueryParams = zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true})
})

export const getRelationshipHealthAutomationReportResponseDeliveryStatusesMinOne = 0;

export const getRelationshipHealthAutomationReportResponseDeliveryChannelsMinOne = 0;

export const getRelationshipHealthAutomationReportResponseDeliveryEstimatedCostMinorMin = 0;

export const getRelationshipHealthAutomationReportResponseDeliveryActualCostMinorMin = 0;

export const getRelationshipHealthAutomationReportResponseEngagementClassificationsMinOne = 0;

export const getRelationshipHealthAutomationReportResponseEngagementMeaningfulRepliesMin = 0;

export const getRelationshipHealthAutomationReportResponseEngagementOptOutsMin = 0;

export const getRelationshipHealthAutomationReportResponseEngagementHumanRequestsMin = 0;

export const getRelationshipHealthAutomationReportResponseEngagementAutomatedTurnsMin = 0;

export const getRelationshipHealthAutomationReportResponseRelationshipOutcomesTrendsMinOne = 0;

export const getRelationshipHealthAutomationReportResponseRelationshipOutcomesEvidenceStatesMinOne = 0;

export const getRelationshipHealthAutomationReportResponseRelationshipOutcomesMissingEvidenceMin = 0;

export const getRelationshipHealthAutomationReportResponseOperationsPlanStatusesMinOne = 0;

export const getRelationshipHealthAutomationReportResponseOperationsReplyStatusesMinOne = 0;

export const getRelationshipHealthAutomationReportResponseOperationsBlockedMin = 0;

export const getRelationshipHealthAutomationReportResponseOperationsFailedMin = 0;

export const getRelationshipHealthAutomationReportResponseOperationsUnknownMin = 0;

export const getRelationshipHealthAutomationReportResponseOperationsHandoffsMin = 0;

export const getRelationshipHealthAutomationReportResponseFeedbackTypesMinOne = 0;

export const getRelationshipHealthAutomationReportResponseFeedbackOutcomesMinOne = 0;


export const getRelationshipHealthAutomationReportResponseLearningOneConfigurationPriorityOffsetMin = -8;
export const getRelationshipHealthAutomationReportResponseLearningOneConfigurationPriorityOffsetMax = 8;

export const getRelationshipHealthAutomationReportResponseLearningOneConfigurationTimingOffsetHoursMin = -24;
export const getRelationshipHealthAutomationReportResponseLearningOneConfigurationTimingOffsetHoursMax = 48;

export const getRelationshipHealthAutomationReportResponseLearningOneEvidenceCountsMinOne = 0;





export const getRelationshipHealthAutomationReportResponse = zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "delivery": zod.object({
  "statuses": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseDeliveryStatusesMinOne)),
  "channels": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseDeliveryChannelsMinOne)),
  "estimatedCostMinor": zod.int().min(getRelationshipHealthAutomationReportResponseDeliveryEstimatedCostMinorMin),
  "actualCostMinor": zod.int().min(getRelationshipHealthAutomationReportResponseDeliveryActualCostMinorMin)
}),
  "engagement": zod.object({
  "classifications": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseEngagementClassificationsMinOne)),
  "meaningfulReplies": zod.int().min(getRelationshipHealthAutomationReportResponseEngagementMeaningfulRepliesMin),
  "optOuts": zod.int().min(getRelationshipHealthAutomationReportResponseEngagementOptOutsMin),
  "humanRequests": zod.int().min(getRelationshipHealthAutomationReportResponseEngagementHumanRequestsMin),
  "automatedTurns": zod.int().min(getRelationshipHealthAutomationReportResponseEngagementAutomatedTurnsMin),
  "evidenceState": zod.enum(['observed', 'missing'])
}),
  "relationshipOutcomes": zod.object({
  "trends": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseRelationshipOutcomesTrendsMinOne)),
  "evidenceStates": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseRelationshipOutcomesEvidenceStatesMinOne)),
  "missingEvidence": zod.int().min(getRelationshipHealthAutomationReportResponseRelationshipOutcomesMissingEvidenceMin),
  "caution": zod.string()
}),
  "operations": zod.object({
  "planStatuses": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseOperationsPlanStatusesMinOne)),
  "replyStatuses": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseOperationsReplyStatusesMinOne)),
  "blocked": zod.int().min(getRelationshipHealthAutomationReportResponseOperationsBlockedMin),
  "failed": zod.int().min(getRelationshipHealthAutomationReportResponseOperationsFailedMin),
  "unknown": zod.int().min(getRelationshipHealthAutomationReportResponseOperationsUnknownMin),
  "handoffs": zod.int().min(getRelationshipHealthAutomationReportResponseOperationsHandoffsMin)
}),
  "feedback": zod.object({
  "types": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseFeedbackTypesMinOne)),
  "outcomes": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseFeedbackOutcomesMinOne))
}),
  "learning": zod.union([zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "status": zod.enum(['active', 'superseded']),
  "basedOnVersionId": zod.uuid().nullable(),
  "configuration": zod.object({
  "priorityOffset": zod.int().min(getRelationshipHealthAutomationReportResponseLearningOneConfigurationPriorityOffsetMin).max(getRelationshipHealthAutomationReportResponseLearningOneConfigurationPriorityOffsetMax),
  "timingOffsetHours": zod.int().min(getRelationshipHealthAutomationReportResponseLearningOneConfigurationTimingOffsetHoursMin).max(getRelationshipHealthAutomationReportResponseLearningOneConfigurationTimingOffsetHoursMax),
  "contentStyle": zod.enum(['balanced', 'concise', 'question_led'])
}),
  "evidence": zod.object({
  "windowStart": zod.iso.datetime({"offset":true}),
  "windowEnd": zod.iso.datetime({"offset":true}),
  "feedbackIds": zod.array(zod.uuid()),
  "nextActionIds": zod.array(zod.uuid()),
  "planRevisionIds": zod.array(zod.uuid()),
  "executionIds": zod.array(zod.uuid()),
  "snapshotIds": zod.array(zod.uuid()),
  "counts": zod.record(zod.string(), zod.int().min(getRelationshipHealthAutomationReportResponseLearningOneEvidenceCountsMinOne))
}),
  "explanation": zod.array(zod.string()).min(1),
  "correlationNotice": zod.string(),
  "policyBoundary": zod.string(),
  "createdByAppUserId": zod.uuid(),
  "activatedAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "limitations": zod.array(zod.string()).min(1)
})


/**
 * @summary List the open, prioritized next-action approvals feed (excludes snoozed and dismissed)
 */
export const listNextActionFeedQueryLimitDefault = 50;
export const listNextActionFeedQueryLimitMax = 100;

export const listNextActionFeedQueryOffsetDefault = 0;
export const listNextActionFeedQueryOffsetMin = 0;



export const listNextActionFeedQueryParams = zod.object({
  "actionId": zod.uuid().optional().describe('Read one exact open action and recheck its source lifecycle without generating or executing work'),
  "limit": zod.int().min(1).max(listNextActionFeedQueryLimitMax).default(listNextActionFeedQueryLimitDefault),
  "offset": zod.int().min(listNextActionFeedQueryOffsetMin).default(listNextActionFeedQueryOffsetDefault),
  "accountId": zod.uuid().optional().describe('Restrict the unified feed to actions linked to one account'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional().describe('Restrict actions to accounts in one CRM audience; omit for the unified all-audience feed')
})

export const listNextActionFeedResponseItemsItemPriorityMin = 0;
export const listNextActionFeedResponseItemsItemPriorityMax = 100;

export const listNextActionFeedResponseItemsItemScoreSnapshotMin = 0;
export const listNextActionFeedResponseItemsItemScoreSnapshotMax = 100;

export const listNextActionFeedResponseItemsItemRecommendationHealthScoreMin = 0;
export const listNextActionFeedResponseItemsItemRecommendationHealthScoreMax = 100;


export const listNextActionFeedResponseItemsItemRecommendationGroundingSourcesItemScoreMin = 0;
export const listNextActionFeedResponseItemsItemRecommendationGroundingSourcesItemScoreMax = 1;


export const listNextActionFeedResponseItemsItemRecommendationLearningOnePriorityOffsetMin = -8;
export const listNextActionFeedResponseItemsItemRecommendationLearningOnePriorityOffsetMax = 8;

export const listNextActionFeedResponseItemsItemRecommendationLearningOneTimingOffsetHoursMin = -24;
export const listNextActionFeedResponseItemsItemRecommendationLearningOneTimingOffsetHoursMax = 48;


export const listNextActionFeedResponseItemsItemRecommendationLearningOneEvidenceCountsMinOne = 0;

export const listNextActionFeedResponseTotalMin = 0;


export const listNextActionFeedResponseOffsetMin = 0;



export const listNextActionFeedResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactName": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "actionType": zod.enum(['email', 'sms', 'social', 'call', 'review_signal', 'create_deal']),
  "title": zod.string(),
  "rationale": zod.string(),
  "deepLink": zod.string(),
  "status": zod.enum(['open', 'processing', 'completed', 'dismissed']),
  "priority": zod.int().min(listNextActionFeedResponseItemsItemPriorityMin).max(listNextActionFeedResponseItemsItemPriorityMax),
  "scoreSnapshot": zod.int().min(listNextActionFeedResponseItemsItemScoreSnapshotMin).max(listNextActionFeedResponseItemsItemScoreSnapshotMax),
  "sourceKind": zod.string().nullish().describe('Signal provider key (e.g. \'email\')'),
  "sourceRef": zod.string().nullish().describe('Stable reference to the underlying signal record'),
  "draft": zod.object({
  "to": zod.email(),
  "subject": zod.string(),
  "body": zod.string(),
  "replyToMessageId": zod.uuid().optional().describe('Canonical email message to reply to in the same provider thread')
}).nullish().describe('Prepared email draft, used only after explicit human review'),
  "recommendation": zod.object({
  "version": zod.enum(['relationship-recommendation-v1']),
  "recipient": zod.object({
  "accountId": zod.uuid(),
  "contactId": zod.uuid().nullable(),
  "name": zod.string()
}),
  "timing": zod.object({
  "recommendedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string()
}),
  "channel": zod.enum(['email', 'sms', 'call']),
  "objective": zod.string(),
  "content": zod.union([zod.object({
  "kind": zod.enum(['message']),
  "subject": zod.string(),
  "body": zod.string()
}),zod.object({
  "kind": zod.enum(['call_brief']),
  "opening": zod.string(),
  "talkingPoints": zod.array(zod.string()),
  "questions": zod.array(zod.string()),
  "desiredOutcome": zod.string()
})]),
  "health": zod.object({
  "snapshotId": zod.uuid(),
  "rulesVersion": zod.string(),
  "score": zod.int().min(listNextActionFeedResponseItemsItemRecommendationHealthScoreMin).max(listNextActionFeedResponseItemsItemRecommendationHealthScoreMax),
  "trend": zod.enum(['improving', 'stable', 'declining', 'unknown'])
}),
  "evidence": zod.array(zod.object({
  "sourceKind": zod.string(),
  "sourceRef": zod.string(),
  "label": zod.string(),
  "observedAt": zod.iso.datetime({"offset":true}),
  "freshness": zod.enum(['fresh', 'aging', 'stale', 'unknown']),
  "sourcePath": zod.string().nullable()
})),
  "grounding": zod.object({
  "state": zod.enum(['ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence', 'unavailable']),
  "message": zod.string(),
  "sources": zod.array(zod.object({
  "knowledgeFileId": zod.uuid(),
  "documentId": zod.uuid(),
  "title": zod.string(),
  "location": zod.string(),
  "sourceVersion": zod.int().min(1),
  "freshness": zod.iso.datetime({"offset":true}),
  "score": zod.number().min(listNextActionFeedResponseItemsItemRecommendationGroundingSourcesItemScoreMin).max(listNextActionFeedResponseItemsItemRecommendationGroundingSourcesItemScoreMax)
}))
}),
  "learning": zod.union([zod.object({
  "versionId": zod.uuid(),
  "version": zod.int().min(1),
  "priorityOffset": zod.int().min(listNextActionFeedResponseItemsItemRecommendationLearningOnePriorityOffsetMin).max(listNextActionFeedResponseItemsItemRecommendationLearningOnePriorityOffsetMax),
  "timingOffsetHours": zod.int().min(listNextActionFeedResponseItemsItemRecommendationLearningOneTimingOffsetHoursMin).max(listNextActionFeedResponseItemsItemRecommendationLearningOneTimingOffsetHoursMax),
  "contentStyle": zod.enum(['balanced', 'concise', 'question_led']),
  "explanation": zod.array(zod.string()).min(1),
  "correlationNotice": zod.string(),
  "policyBoundary": zod.string(),
  "evidenceCounts": zod.record(zod.string(), zod.int().min(listNextActionFeedResponseItemsItemRecommendationLearningOneEvidenceCountsMinOne))
}),zod.null()]).optional(),
  "limitations": zod.array(zod.string()),
  "strategicBriefs": zod.array(zod.object({
  "briefId": zod.uuid(),
  "documentId": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "recordName": zod.string(),
  "importance": zod.enum(['strategic', 'key', 'growth', 'standard']),
  "excerpt": zod.string().describe('Short plain-text start of the brief as given to the AI'),
  "truncated": zod.boolean().describe('True when only part of the brief fitted the AI size limit'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deepLink": zod.string().describe('Record page with the Strategic brief tab open')
}).describe('A strategic brief (and importance level) the AI was given as grounding. Only briefs the caller can read are returned.')).optional().describe('Strategic briefs the AI was given when drafting this suggestion')
}).nullable().describe('Evidence-backed, review-only relationship outreach proposal; never execution authority'),
  "priorityReasons": zod.array(zod.string()).optional().describe('Why the action ranks higher, e.g. \'Strategic account\', \'Key contact\' or \'Strategic brief on file\'.'),
  "snoozedUntil": zod.iso.datetime({"offset":true}).nullish(),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listNextActionFeedResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listNextActionFeedResponseOffsetMin),
  "generatedAt": zod.iso.datetime({"offset":true}).nullable().describe('Completion time of the most recent signal-driven engine run')
})


/**
 * @summary Run the signal-driven next-action engine now (email signals first; authority-gated)
 */
export const refreshNextActionsBodyRequestedByMax = 200;



export const refreshNextActionsBody = zod.object({
  "requestedBy": zod.string().max(refreshNextActionsBodyRequestedByMax).optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional()
})

export const refreshNextActionsResponseSignalsConsideredMin = 0;

export const refreshNextActionsResponseCreatedMin = 0;

export const refreshNextActionsResponseUpdatedMin = 0;

export const refreshNextActionsResponseSkippedMin = 0;

export const refreshNextActionsResponseClosedMin = 0;

export const refreshNextActionsResponseProvidersItemSignalsMin = 0;



export const refreshNextActionsResponse = zod.object({
  "signalsConsidered": zod.int().min(refreshNextActionsResponseSignalsConsideredMin),
  "created": zod.int().min(refreshNextActionsResponseCreatedMin),
  "updated": zod.int().min(refreshNextActionsResponseUpdatedMin),
  "skipped": zod.int().min(refreshNextActionsResponseSkippedMin),
  "closed": zod.int().min(refreshNextActionsResponseClosedMin).describe('Open actions closed because their source signal is no longer active'),
  "llm": zod.enum(['generated', 'fallback', 'skipped']),
  "llmError": zod.string().optional(),
  "providers": zod.array(zod.object({
  "key": zod.string(),
  "signals": zod.int().min(refreshNextActionsResponseProvidersItemSignalsMin),
  "error": zod.string().optional()
})),
  "auditId": zod.uuid()
})


/**
 * @summary Dismiss a proposed next action so it no longer appears in the feed
 */
export const dismissNextActionParams = zod.object({
  "id": zod.uuid()
})

export const dismissNextActionResponsePriorityMin = 0;
export const dismissNextActionResponsePriorityMax = 100;

export const dismissNextActionResponseScoreSnapshotMin = 0;
export const dismissNextActionResponseScoreSnapshotMax = 100;

export const dismissNextActionResponseRecommendationHealthScoreMin = 0;
export const dismissNextActionResponseRecommendationHealthScoreMax = 100;


export const dismissNextActionResponseRecommendationGroundingSourcesItemScoreMin = 0;
export const dismissNextActionResponseRecommendationGroundingSourcesItemScoreMax = 1;


export const dismissNextActionResponseRecommendationLearningOnePriorityOffsetMin = -8;
export const dismissNextActionResponseRecommendationLearningOnePriorityOffsetMax = 8;

export const dismissNextActionResponseRecommendationLearningOneTimingOffsetHoursMin = -24;
export const dismissNextActionResponseRecommendationLearningOneTimingOffsetHoursMax = 48;


export const dismissNextActionResponseRecommendationLearningOneEvidenceCountsMinOne = 0;



export const dismissNextActionResponse = zod.object({
  "id": zod.uuid(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactName": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "actionType": zod.enum(['email', 'sms', 'social', 'call', 'review_signal', 'create_deal']),
  "title": zod.string(),
  "rationale": zod.string(),
  "deepLink": zod.string(),
  "status": zod.enum(['open', 'processing', 'completed', 'dismissed']),
  "priority": zod.int().min(dismissNextActionResponsePriorityMin).max(dismissNextActionResponsePriorityMax),
  "scoreSnapshot": zod.int().min(dismissNextActionResponseScoreSnapshotMin).max(dismissNextActionResponseScoreSnapshotMax),
  "sourceKind": zod.string().nullish().describe('Signal provider key (e.g. \'email\')'),
  "sourceRef": zod.string().nullish().describe('Stable reference to the underlying signal record'),
  "draft": zod.object({
  "to": zod.email(),
  "subject": zod.string(),
  "body": zod.string(),
  "replyToMessageId": zod.uuid().optional().describe('Canonical email message to reply to in the same provider thread')
}).nullish().describe('Prepared email draft, used only after explicit human review'),
  "recommendation": zod.object({
  "version": zod.enum(['relationship-recommendation-v1']),
  "recipient": zod.object({
  "accountId": zod.uuid(),
  "contactId": zod.uuid().nullable(),
  "name": zod.string()
}),
  "timing": zod.object({
  "recommendedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string()
}),
  "channel": zod.enum(['email', 'sms', 'call']),
  "objective": zod.string(),
  "content": zod.union([zod.object({
  "kind": zod.enum(['message']),
  "subject": zod.string(),
  "body": zod.string()
}),zod.object({
  "kind": zod.enum(['call_brief']),
  "opening": zod.string(),
  "talkingPoints": zod.array(zod.string()),
  "questions": zod.array(zod.string()),
  "desiredOutcome": zod.string()
})]),
  "health": zod.object({
  "snapshotId": zod.uuid(),
  "rulesVersion": zod.string(),
  "score": zod.int().min(dismissNextActionResponseRecommendationHealthScoreMin).max(dismissNextActionResponseRecommendationHealthScoreMax),
  "trend": zod.enum(['improving', 'stable', 'declining', 'unknown'])
}),
  "evidence": zod.array(zod.object({
  "sourceKind": zod.string(),
  "sourceRef": zod.string(),
  "label": zod.string(),
  "observedAt": zod.iso.datetime({"offset":true}),
  "freshness": zod.enum(['fresh', 'aging', 'stale', 'unknown']),
  "sourcePath": zod.string().nullable()
})),
  "grounding": zod.object({
  "state": zod.enum(['ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence', 'unavailable']),
  "message": zod.string(),
  "sources": zod.array(zod.object({
  "knowledgeFileId": zod.uuid(),
  "documentId": zod.uuid(),
  "title": zod.string(),
  "location": zod.string(),
  "sourceVersion": zod.int().min(1),
  "freshness": zod.iso.datetime({"offset":true}),
  "score": zod.number().min(dismissNextActionResponseRecommendationGroundingSourcesItemScoreMin).max(dismissNextActionResponseRecommendationGroundingSourcesItemScoreMax)
}))
}),
  "learning": zod.union([zod.object({
  "versionId": zod.uuid(),
  "version": zod.int().min(1),
  "priorityOffset": zod.int().min(dismissNextActionResponseRecommendationLearningOnePriorityOffsetMin).max(dismissNextActionResponseRecommendationLearningOnePriorityOffsetMax),
  "timingOffsetHours": zod.int().min(dismissNextActionResponseRecommendationLearningOneTimingOffsetHoursMin).max(dismissNextActionResponseRecommendationLearningOneTimingOffsetHoursMax),
  "contentStyle": zod.enum(['balanced', 'concise', 'question_led']),
  "explanation": zod.array(zod.string()).min(1),
  "correlationNotice": zod.string(),
  "policyBoundary": zod.string(),
  "evidenceCounts": zod.record(zod.string(), zod.int().min(dismissNextActionResponseRecommendationLearningOneEvidenceCountsMinOne))
}),zod.null()]).optional(),
  "limitations": zod.array(zod.string()),
  "strategicBriefs": zod.array(zod.object({
  "briefId": zod.uuid(),
  "documentId": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "recordName": zod.string(),
  "importance": zod.enum(['strategic', 'key', 'growth', 'standard']),
  "excerpt": zod.string().describe('Short plain-text start of the brief as given to the AI'),
  "truncated": zod.boolean().describe('True when only part of the brief fitted the AI size limit'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deepLink": zod.string().describe('Record page with the Strategic brief tab open')
}).describe('A strategic brief (and importance level) the AI was given as grounding. Only briefs the caller can read are returned.')).optional().describe('Strategic briefs the AI was given when drafting this suggestion')
}).nullable().describe('Evidence-backed, review-only relationship outreach proposal; never execution authority'),
  "priorityReasons": zod.array(zod.string()).optional().describe('Why the action ranks higher, e.g. \'Strategic account\', \'Key contact\' or \'Strategic brief on file\'.'),
  "snoozedUntil": zod.iso.datetime({"offset":true}).nullish(),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Snooze a proposed next action; it reappears in the feed after the snooze window
 */
export const snoozeNextActionParams = zod.object({
  "id": zod.uuid()
})

export const snoozeNextActionBodyHoursDefault = 24;
export const snoozeNextActionBodyHoursMax = 720;



export const snoozeNextActionBody = zod.object({
  "hours": zod.int().min(1).max(snoozeNextActionBodyHoursMax).default(snoozeNextActionBodyHoursDefault)
})

export const snoozeNextActionResponsePriorityMin = 0;
export const snoozeNextActionResponsePriorityMax = 100;

export const snoozeNextActionResponseScoreSnapshotMin = 0;
export const snoozeNextActionResponseScoreSnapshotMax = 100;

export const snoozeNextActionResponseRecommendationHealthScoreMin = 0;
export const snoozeNextActionResponseRecommendationHealthScoreMax = 100;


export const snoozeNextActionResponseRecommendationGroundingSourcesItemScoreMin = 0;
export const snoozeNextActionResponseRecommendationGroundingSourcesItemScoreMax = 1;


export const snoozeNextActionResponseRecommendationLearningOnePriorityOffsetMin = -8;
export const snoozeNextActionResponseRecommendationLearningOnePriorityOffsetMax = 8;

export const snoozeNextActionResponseRecommendationLearningOneTimingOffsetHoursMin = -24;
export const snoozeNextActionResponseRecommendationLearningOneTimingOffsetHoursMax = 48;


export const snoozeNextActionResponseRecommendationLearningOneEvidenceCountsMinOne = 0;



export const snoozeNextActionResponse = zod.object({
  "id": zod.uuid(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactName": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "actionType": zod.enum(['email', 'sms', 'social', 'call', 'review_signal', 'create_deal']),
  "title": zod.string(),
  "rationale": zod.string(),
  "deepLink": zod.string(),
  "status": zod.enum(['open', 'processing', 'completed', 'dismissed']),
  "priority": zod.int().min(snoozeNextActionResponsePriorityMin).max(snoozeNextActionResponsePriorityMax),
  "scoreSnapshot": zod.int().min(snoozeNextActionResponseScoreSnapshotMin).max(snoozeNextActionResponseScoreSnapshotMax),
  "sourceKind": zod.string().nullish().describe('Signal provider key (e.g. \'email\')'),
  "sourceRef": zod.string().nullish().describe('Stable reference to the underlying signal record'),
  "draft": zod.object({
  "to": zod.email(),
  "subject": zod.string(),
  "body": zod.string(),
  "replyToMessageId": zod.uuid().optional().describe('Canonical email message to reply to in the same provider thread')
}).nullish().describe('Prepared email draft, used only after explicit human review'),
  "recommendation": zod.object({
  "version": zod.enum(['relationship-recommendation-v1']),
  "recipient": zod.object({
  "accountId": zod.uuid(),
  "contactId": zod.uuid().nullable(),
  "name": zod.string()
}),
  "timing": zod.object({
  "recommendedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string()
}),
  "channel": zod.enum(['email', 'sms', 'call']),
  "objective": zod.string(),
  "content": zod.union([zod.object({
  "kind": zod.enum(['message']),
  "subject": zod.string(),
  "body": zod.string()
}),zod.object({
  "kind": zod.enum(['call_brief']),
  "opening": zod.string(),
  "talkingPoints": zod.array(zod.string()),
  "questions": zod.array(zod.string()),
  "desiredOutcome": zod.string()
})]),
  "health": zod.object({
  "snapshotId": zod.uuid(),
  "rulesVersion": zod.string(),
  "score": zod.int().min(snoozeNextActionResponseRecommendationHealthScoreMin).max(snoozeNextActionResponseRecommendationHealthScoreMax),
  "trend": zod.enum(['improving', 'stable', 'declining', 'unknown'])
}),
  "evidence": zod.array(zod.object({
  "sourceKind": zod.string(),
  "sourceRef": zod.string(),
  "label": zod.string(),
  "observedAt": zod.iso.datetime({"offset":true}),
  "freshness": zod.enum(['fresh', 'aging', 'stale', 'unknown']),
  "sourcePath": zod.string().nullable()
})),
  "grounding": zod.object({
  "state": zod.enum(['ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence', 'unavailable']),
  "message": zod.string(),
  "sources": zod.array(zod.object({
  "knowledgeFileId": zod.uuid(),
  "documentId": zod.uuid(),
  "title": zod.string(),
  "location": zod.string(),
  "sourceVersion": zod.int().min(1),
  "freshness": zod.iso.datetime({"offset":true}),
  "score": zod.number().min(snoozeNextActionResponseRecommendationGroundingSourcesItemScoreMin).max(snoozeNextActionResponseRecommendationGroundingSourcesItemScoreMax)
}))
}),
  "learning": zod.union([zod.object({
  "versionId": zod.uuid(),
  "version": zod.int().min(1),
  "priorityOffset": zod.int().min(snoozeNextActionResponseRecommendationLearningOnePriorityOffsetMin).max(snoozeNextActionResponseRecommendationLearningOnePriorityOffsetMax),
  "timingOffsetHours": zod.int().min(snoozeNextActionResponseRecommendationLearningOneTimingOffsetHoursMin).max(snoozeNextActionResponseRecommendationLearningOneTimingOffsetHoursMax),
  "contentStyle": zod.enum(['balanced', 'concise', 'question_led']),
  "explanation": zod.array(zod.string()).min(1),
  "correlationNotice": zod.string(),
  "policyBoundary": zod.string(),
  "evidenceCounts": zod.record(zod.string(), zod.int().min(snoozeNextActionResponseRecommendationLearningOneEvidenceCountsMinOne))
}),zod.null()]).optional(),
  "limitations": zod.array(zod.string()),
  "strategicBriefs": zod.array(zod.object({
  "briefId": zod.uuid(),
  "documentId": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "recordName": zod.string(),
  "importance": zod.enum(['strategic', 'key', 'growth', 'standard']),
  "excerpt": zod.string().describe('Short plain-text start of the brief as given to the AI'),
  "truncated": zod.boolean().describe('True when only part of the brief fitted the AI size limit'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deepLink": zod.string().describe('Record page with the Strategic brief tab open')
}).describe('A strategic brief (and importance level) the AI was given as grounding. Only briefs the caller can read are returned.')).optional().describe('Strategic briefs the AI was given when drafting this suggestion')
}).nullable().describe('Evidence-backed, review-only relationship outreach proposal; never execution authority'),
  "priorityReasons": zod.array(zod.string()).optional().describe('Why the action ranks higher, e.g. \'Strategic account\', \'Key contact\' or \'Strategic brief on file\'.'),
  "snoozedUntil": zod.iso.datetime({"offset":true}).nullish(),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Re-checks authority before executing. Email actions with a draft send the (possibly edited) draft through the connected Microsoft 365 mailbox and record the outbound message; non-email actions are marked completed. human_only authority returns the draft for manual use and never sends.
 * @summary Approve a proposed next action; email actions send the reviewed draft, other actions complete and deep-link
 */
export const approveNextActionParams = zod.object({
  "id": zod.uuid()
})

export const approveNextActionBodyToMax = 320;

export const approveNextActionBodySubjectMax = 300;

export const approveNextActionBodyBodyMax = 20000;

export const approveNextActionBodyApprovedByMax = 200;



export const approveNextActionBody = zod.object({
  "requestId": zod.uuid().optional().describe('Stable idempotency key reused when the same approval is retried'),
  "to": zod.email().max(approveNextActionBodyToMax).optional().describe('Optional edited recipient (defaults to the prepared draft recipient)'),
  "subject": zod.string().max(approveNextActionBodySubjectMax).optional().describe('Optional edited subject (defaults to the prepared draft subject)'),
  "body": zod.string().max(approveNextActionBodyBodyMax).optional().describe('Optional edited body (defaults to the prepared draft body)'),
  "approvedBy": zod.string().max(approveNextActionBodyApprovedByMax).optional()
})

export const approveNextActionResponseActionPriorityMin = 0;
export const approveNextActionResponseActionPriorityMax = 100;

export const approveNextActionResponseActionScoreSnapshotMin = 0;
export const approveNextActionResponseActionScoreSnapshotMax = 100;

export const approveNextActionResponseActionRecommendationHealthScoreMin = 0;
export const approveNextActionResponseActionRecommendationHealthScoreMax = 100;


export const approveNextActionResponseActionRecommendationGroundingSourcesItemScoreMin = 0;
export const approveNextActionResponseActionRecommendationGroundingSourcesItemScoreMax = 1;


export const approveNextActionResponseActionRecommendationLearningOnePriorityOffsetMin = -8;
export const approveNextActionResponseActionRecommendationLearningOnePriorityOffsetMax = 8;

export const approveNextActionResponseActionRecommendationLearningOneTimingOffsetHoursMin = -24;
export const approveNextActionResponseActionRecommendationLearningOneTimingOffsetHoursMax = 48;


export const approveNextActionResponseActionRecommendationLearningOneEvidenceCountsMinOne = 0;



export const approveNextActionResponse = zod.object({
  "outcome": zod.enum(['sent', 'completed', 'human_only']).describe('sent = email dispatched via the connected mailbox; completed = non-email action resolved; human_only = automated send refused, draft returned for manual use'),
  "action": zod.object({
  "id": zod.uuid(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "contactName": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "actionType": zod.enum(['email', 'sms', 'social', 'call', 'review_signal', 'create_deal']),
  "title": zod.string(),
  "rationale": zod.string(),
  "deepLink": zod.string(),
  "status": zod.enum(['open', 'processing', 'completed', 'dismissed']),
  "priority": zod.int().min(approveNextActionResponseActionPriorityMin).max(approveNextActionResponseActionPriorityMax),
  "scoreSnapshot": zod.int().min(approveNextActionResponseActionScoreSnapshotMin).max(approveNextActionResponseActionScoreSnapshotMax),
  "sourceKind": zod.string().nullish().describe('Signal provider key (e.g. \'email\')'),
  "sourceRef": zod.string().nullish().describe('Stable reference to the underlying signal record'),
  "draft": zod.object({
  "to": zod.email(),
  "subject": zod.string(),
  "body": zod.string(),
  "replyToMessageId": zod.uuid().optional().describe('Canonical email message to reply to in the same provider thread')
}).nullish().describe('Prepared email draft, used only after explicit human review'),
  "recommendation": zod.object({
  "version": zod.enum(['relationship-recommendation-v1']),
  "recipient": zod.object({
  "accountId": zod.uuid(),
  "contactId": zod.uuid().nullable(),
  "name": zod.string()
}),
  "timing": zod.object({
  "recommendedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string()
}),
  "channel": zod.enum(['email', 'sms', 'call']),
  "objective": zod.string(),
  "content": zod.union([zod.object({
  "kind": zod.enum(['message']),
  "subject": zod.string(),
  "body": zod.string()
}),zod.object({
  "kind": zod.enum(['call_brief']),
  "opening": zod.string(),
  "talkingPoints": zod.array(zod.string()),
  "questions": zod.array(zod.string()),
  "desiredOutcome": zod.string()
})]),
  "health": zod.object({
  "snapshotId": zod.uuid(),
  "rulesVersion": zod.string(),
  "score": zod.int().min(approveNextActionResponseActionRecommendationHealthScoreMin).max(approveNextActionResponseActionRecommendationHealthScoreMax),
  "trend": zod.enum(['improving', 'stable', 'declining', 'unknown'])
}),
  "evidence": zod.array(zod.object({
  "sourceKind": zod.string(),
  "sourceRef": zod.string(),
  "label": zod.string(),
  "observedAt": zod.iso.datetime({"offset":true}),
  "freshness": zod.enum(['fresh', 'aging', 'stale', 'unknown']),
  "sourcePath": zod.string().nullable()
})),
  "grounding": zod.object({
  "state": zod.enum(['ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence', 'unavailable']),
  "message": zod.string(),
  "sources": zod.array(zod.object({
  "knowledgeFileId": zod.uuid(),
  "documentId": zod.uuid(),
  "title": zod.string(),
  "location": zod.string(),
  "sourceVersion": zod.int().min(1),
  "freshness": zod.iso.datetime({"offset":true}),
  "score": zod.number().min(approveNextActionResponseActionRecommendationGroundingSourcesItemScoreMin).max(approveNextActionResponseActionRecommendationGroundingSourcesItemScoreMax)
}))
}),
  "learning": zod.union([zod.object({
  "versionId": zod.uuid(),
  "version": zod.int().min(1),
  "priorityOffset": zod.int().min(approveNextActionResponseActionRecommendationLearningOnePriorityOffsetMin).max(approveNextActionResponseActionRecommendationLearningOnePriorityOffsetMax),
  "timingOffsetHours": zod.int().min(approveNextActionResponseActionRecommendationLearningOneTimingOffsetHoursMin).max(approveNextActionResponseActionRecommendationLearningOneTimingOffsetHoursMax),
  "contentStyle": zod.enum(['balanced', 'concise', 'question_led']),
  "explanation": zod.array(zod.string()).min(1),
  "correlationNotice": zod.string(),
  "policyBoundary": zod.string(),
  "evidenceCounts": zod.record(zod.string(), zod.int().min(approveNextActionResponseActionRecommendationLearningOneEvidenceCountsMinOne))
}),zod.null()]).optional(),
  "limitations": zod.array(zod.string()),
  "strategicBriefs": zod.array(zod.object({
  "briefId": zod.uuid(),
  "documentId": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "recordName": zod.string(),
  "importance": zod.enum(['strategic', 'key', 'growth', 'standard']),
  "excerpt": zod.string().describe('Short plain-text start of the brief as given to the AI'),
  "truncated": zod.boolean().describe('True when only part of the brief fitted the AI size limit'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deepLink": zod.string().describe('Record page with the Strategic brief tab open')
}).describe('A strategic brief (and importance level) the AI was given as grounding. Only briefs the caller can read are returned.')).optional().describe('Strategic briefs the AI was given when drafting this suggestion')
}).nullable().describe('Evidence-backed, review-only relationship outreach proposal; never execution authority'),
  "priorityReasons": zod.array(zod.string()).optional().describe('Why the action ranks higher, e.g. \'Strategic account\', \'Key contact\' or \'Strategic brief on file\'.'),
  "snoozedUntil": zod.iso.datetime({"offset":true}).nullish(),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "messageId": zod.uuid().optional().describe('Id of the recorded outbound email_messages row (outcome sent only)'),
  "sentTo": zod.string().optional().describe('Recipient the email was actually sent to (outcome sent only)'),
  "sentSubject": zod.string().optional().describe('Subject the email was actually sent with (outcome sent only)'),
  "message": zod.string().optional().describe('Explanation returned when automated sending is blocked'),
  "draft": zod.object({
  "to": zod.email(),
  "subject": zod.string(),
  "body": zod.string(),
  "replyToMessageId": zod.uuid().optional().describe('Canonical email message to reply to in the same provider thread')
}).nullish().describe('Prepared email draft, used only after explicit human review')
})


/**
 * @summary Get cross-channel acquisition funnel stages and channel/campaign breakdowns
 */
export const getAcquisitionFunnelQueryDaysDefault = 90;
export const getAcquisitionFunnelQueryDaysMax = 730;



export const getAcquisitionFunnelQueryParams = zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "days": zod.int().min(1).max(getAcquisitionFunnelQueryDaysMax).default(getAcquisitionFunnelQueryDaysDefault),
  "channel": zod.string().optional(),
  "campaign": zod.string().optional()
})

export const getAcquisitionFunnelResponseStagesItemCountMin = 0;

export const getAcquisitionFunnelResponseStagesItemConversionRateMin = 0;

export const getAcquisitionFunnelResponseBreakdownsItemStagesItemCountMin = 0;

export const getAcquisitionFunnelResponseBreakdownsItemStagesItemConversionRateMin = 0;



export const getAcquisitionFunnelResponse = zod.object({
  "dateFrom": zod.iso.datetime({"offset":true}),
  "dateTo": zod.iso.datetime({"offset":true}),
  "stages": zod.array(zod.object({
  "stage": zod.enum(['first_touch', 'engaged', 'enquiry', 'opportunity', 'won']),
  "count": zod.int().min(getAcquisitionFunnelResponseStagesItemCountMin),
  "conversionRate": zod.number().min(getAcquisitionFunnelResponseStagesItemConversionRateMin)
})),
  "breakdowns": zod.array(zod.object({
  "key": zod.string(),
  "label": zod.string(),
  "channel": zod.string(),
  "campaign": zod.string().nullish(),
  "stages": zod.array(zod.object({
  "stage": zod.enum(['first_touch', 'engaged', 'enquiry', 'opportunity', 'won']),
  "count": zod.int().min(getAcquisitionFunnelResponseBreakdownsItemStagesItemCountMin),
  "conversionRate": zod.number().min(getAcquisitionFunnelResponseBreakdownsItemStagesItemConversionRateMin)
}))
}))
})


/**
 * @summary Rebuild won-opportunity attribution from unified interactions
 */
export const refreshOpportunityAttributionsResponseOpportunitiesMin = 0;

export const refreshOpportunityAttributionsResponseUpdatedMin = 0;



export const refreshOpportunityAttributionsResponse = zod.object({
  "opportunities": zod.int().min(refreshOpportunityAttributionsResponseOpportunitiesMin),
  "updated": zod.int().min(refreshOpportunityAttributionsResponseUpdatedMin)
})


/**
 * @summary Get first-touch and contributing-touch attribution for a won opportunity
 */
export const getOpportunityAttributionParams = zod.object({
  "opportunityId": zod.uuid()
})

export const getOpportunityAttributionResponseTotalTouchesMin = 0;



export const getOpportunityAttributionResponse = zod.object({
  "opportunity": zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "stage": zod.string(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish()
}),
  "firstTouch": zod.union([zod.object({
  "id": zod.uuid(),
  "interactionId": zod.uuid(),
  "attributionType": zod.enum(['first_touch', 'contributing']),
  "channel": zod.string(),
  "type": zod.string(),
  "subject": zod.string().nullish(),
  "body": zod.string(),
  "campaign": zod.string().nullish(),
  "weight": zod.number(),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "deepLink": zod.string()
}),zod.null()]).optional(),
  "contributingTouches": zod.array(zod.object({
  "id": zod.uuid(),
  "interactionId": zod.uuid(),
  "attributionType": zod.enum(['first_touch', 'contributing']),
  "channel": zod.string(),
  "type": zod.string(),
  "subject": zod.string().nullish(),
  "body": zod.string(),
  "campaign": zod.string().nullish(),
  "weight": zod.number(),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "deepLink": zod.string()
})),
  "totalTouches": zod.int().min(getOpportunityAttributionResponseTotalTouchesMin)
})


/**
 * @summary Get combined social, email, chat, voice and signal performance
 */
export const getAcquisitionChannelPerformanceQueryDaysDefault = 90;
export const getAcquisitionChannelPerformanceQueryDaysMax = 730;



export const getAcquisitionChannelPerformanceQueryParams = zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional(),
  "days": zod.int().min(1).max(getAcquisitionChannelPerformanceQueryDaysMax).default(getAcquisitionChannelPerformanceQueryDaysDefault)
})

export const getAcquisitionChannelPerformanceResponseItemsItemTouchesMin = 0;

export const getAcquisitionChannelPerformanceResponseItemsItemInboundMin = 0;

export const getAcquisitionChannelPerformanceResponseItemsItemOutboundMin = 0;

export const getAcquisitionChannelPerformanceResponseItemsItemEngagedAccountsMin = 0;

export const getAcquisitionChannelPerformanceResponseItemsItemEnquiriesMin = 0;

export const getAcquisitionChannelPerformanceResponseItemsItemOpportunitiesMin = 0;

export const getAcquisitionChannelPerformanceResponseItemsItemWonOpportunitiesMin = 0;

export const getAcquisitionChannelPerformanceResponseItemsItemEngagementsMin = 0;

export const getAcquisitionChannelPerformanceResponseItemsItemConversionRateMin = 0;



export const getAcquisitionChannelPerformanceResponse = zod.object({
  "dateFrom": zod.iso.datetime({"offset":true}),
  "dateTo": zod.iso.datetime({"offset":true}),
  "items": zod.array(zod.object({
  "channel": zod.enum(['social', 'email', 'chat', 'voice', 'web']),
  "touches": zod.int().min(getAcquisitionChannelPerformanceResponseItemsItemTouchesMin),
  "inbound": zod.int().min(getAcquisitionChannelPerformanceResponseItemsItemInboundMin),
  "outbound": zod.int().min(getAcquisitionChannelPerformanceResponseItemsItemOutboundMin),
  "engagedAccounts": zod.int().min(getAcquisitionChannelPerformanceResponseItemsItemEngagedAccountsMin),
  "enquiries": zod.int().min(getAcquisitionChannelPerformanceResponseItemsItemEnquiriesMin),
  "opportunities": zod.int().min(getAcquisitionChannelPerformanceResponseItemsItemOpportunitiesMin),
  "wonOpportunities": zod.int().min(getAcquisitionChannelPerformanceResponseItemsItemWonOpportunitiesMin),
  "engagements": zod.number().min(getAcquisitionChannelPerformanceResponseItemsItemEngagementsMin),
  "conversionRate": zod.number().min(getAcquisitionChannelPerformanceResponseItemsItemConversionRateMin)
}))
})


/**
 * @summary List saved natural-language acquisition reports
 */
export const listAcquisitionReportsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "prompt": zod.string(),
  "title": zod.string(),
  "description": zod.string(),
  "chartType": zod.enum(['bar', 'line', 'area']),
  "metric": zod.string(),
  "dimension": zod.string(),
  "dateFrom": zod.iso.datetime({"offset":true}),
  "dateTo": zod.iso.datetime({"offset":true}),
  "data": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.number(),
  "secondaryValue": zod.number().nullish()
})),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['interaction', 'opportunity', 'signal', 'aggregate']),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish()
})),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Generate and save a safe parameterized chart from a natural-language request
 */
export const generateAcquisitionReportBodyNameMax = 160;

export const generateAcquisitionReportBodyPromptMin = 3;
export const generateAcquisitionReportBodyPromptMax = 2000;

export const generateAcquisitionReportBodyDaysDefault = 90;
export const generateAcquisitionReportBodyDaysMax = 730;



export const generateAcquisitionReportBody = zod.object({
  "name": zod.string().min(1).max(generateAcquisitionReportBodyNameMax),
  "prompt": zod.string().min(generateAcquisitionReportBodyPromptMin).max(generateAcquisitionReportBodyPromptMax),
  "days": zod.int().min(1).max(generateAcquisitionReportBodyDaysMax).default(generateAcquisitionReportBodyDaysDefault)
})

export const generateAcquisitionReportResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "prompt": zod.string(),
  "title": zod.string(),
  "description": zod.string(),
  "chartType": zod.enum(['bar', 'line', 'area']),
  "metric": zod.string(),
  "dimension": zod.string(),
  "dateFrom": zod.iso.datetime({"offset":true}),
  "dateTo": zod.iso.datetime({"offset":true}),
  "data": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.number(),
  "secondaryValue": zod.number().nullish()
})),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['interaction', 'opportunity', 'signal', 'aggregate']),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish()
})),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Reopen a saved acquisition report
 */
export const getAcquisitionReportParams = zod.object({
  "id": zod.uuid()
})

export const getAcquisitionReportResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "prompt": zod.string(),
  "title": zod.string(),
  "description": zod.string(),
  "chartType": zod.enum(['bar', 'line', 'area']),
  "metric": zod.string(),
  "dimension": zod.string(),
  "dateFrom": zod.iso.datetime({"offset":true}),
  "dateTo": zod.iso.datetime({"offset":true}),
  "data": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.number(),
  "secondaryValue": zod.number().nullish()
})),
  "sources": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['interaction', 'opportunity', 'signal', 'aggregate']),
  "label": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullish(),
  "deepLink": zod.string().nullish()
})),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get the progressiveness assessment for a account
 */
export const getAccountProgressivenessParams = zod.object({
  "accountId": zod.uuid()
})

export const getAccountProgressivenessResponseOneLeadershipBuyInMax = 5;

export const getAccountProgressivenessResponseOneBudgetAllocationMax = 5;

export const getAccountProgressivenessResponseOneChangeReadinessMax = 5;

export const getAccountProgressivenessResponseOneTechMaturityMax = 5;

export const getAccountProgressivenessResponseOneAdoptionSpeedMax = 5;

export const getAccountProgressivenessResponseOneInternalCapabilityMax = 5;



export const getAccountProgressivenessResponse = zod.object({
  "leadershipBuyIn": zod.int().min(1).max(getAccountProgressivenessResponseOneLeadershipBuyInMax).nullish(),
  "budgetAllocation": zod.int().min(1).max(getAccountProgressivenessResponseOneBudgetAllocationMax).nullish(),
  "changeReadiness": zod.int().min(1).max(getAccountProgressivenessResponseOneChangeReadinessMax).nullish(),
  "techMaturity": zod.int().min(1).max(getAccountProgressivenessResponseOneTechMaturityMax).nullish(),
  "adoptionSpeed": zod.int().min(1).max(getAccountProgressivenessResponseOneAdoptionSpeedMax).nullish(),
  "internalCapability": zod.int().min(1).max(getAccountProgressivenessResponseOneInternalCapabilityMax).nullish(),
  "notes": zod.string().nullish(),
  "assessedBy": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "overallScore": zod.string().nullish(),
  "category": zod.string().nullish(),
  "assessedAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Create or update the progressiveness assessment for a account
 */
export const upsertAccountProgressivenessParams = zod.object({
  "accountId": zod.uuid()
})

export const upsertAccountProgressivenessBodyLeadershipBuyInMax = 5;

export const upsertAccountProgressivenessBodyBudgetAllocationMax = 5;

export const upsertAccountProgressivenessBodyChangeReadinessMax = 5;

export const upsertAccountProgressivenessBodyTechMaturityMax = 5;

export const upsertAccountProgressivenessBodyAdoptionSpeedMax = 5;

export const upsertAccountProgressivenessBodyInternalCapabilityMax = 5;



export const upsertAccountProgressivenessBody = zod.object({
  "leadershipBuyIn": zod.int().min(1).max(upsertAccountProgressivenessBodyLeadershipBuyInMax).nullish(),
  "budgetAllocation": zod.int().min(1).max(upsertAccountProgressivenessBodyBudgetAllocationMax).nullish(),
  "changeReadiness": zod.int().min(1).max(upsertAccountProgressivenessBodyChangeReadinessMax).nullish(),
  "techMaturity": zod.int().min(1).max(upsertAccountProgressivenessBodyTechMaturityMax).nullish(),
  "adoptionSpeed": zod.int().min(1).max(upsertAccountProgressivenessBodyAdoptionSpeedMax).nullish(),
  "internalCapability": zod.int().min(1).max(upsertAccountProgressivenessBodyInternalCapabilityMax).nullish(),
  "notes": zod.string().nullish(),
  "assessedBy": zod.string().nullish()
})

export const upsertAccountProgressivenessResponseOneLeadershipBuyInMax = 5;

export const upsertAccountProgressivenessResponseOneBudgetAllocationMax = 5;

export const upsertAccountProgressivenessResponseOneChangeReadinessMax = 5;

export const upsertAccountProgressivenessResponseOneTechMaturityMax = 5;

export const upsertAccountProgressivenessResponseOneAdoptionSpeedMax = 5;

export const upsertAccountProgressivenessResponseOneInternalCapabilityMax = 5;



export const upsertAccountProgressivenessResponse = zod.object({
  "leadershipBuyIn": zod.int().min(1).max(upsertAccountProgressivenessResponseOneLeadershipBuyInMax).nullish(),
  "budgetAllocation": zod.int().min(1).max(upsertAccountProgressivenessResponseOneBudgetAllocationMax).nullish(),
  "changeReadiness": zod.int().min(1).max(upsertAccountProgressivenessResponseOneChangeReadinessMax).nullish(),
  "techMaturity": zod.int().min(1).max(upsertAccountProgressivenessResponseOneTechMaturityMax).nullish(),
  "adoptionSpeed": zod.int().min(1).max(upsertAccountProgressivenessResponseOneAdoptionSpeedMax).nullish(),
  "internalCapability": zod.int().min(1).max(upsertAccountProgressivenessResponseOneInternalCapabilityMax).nullish(),
  "notes": zod.string().nullish(),
  "assessedBy": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "overallScore": zod.string().nullish(),
  "category": zod.string().nullish(),
  "assessedAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List product-fit scores, optionally filtered by account or product
 */
export const listAccountProductFitQueryLimitDefault = 50;
export const listAccountProductFitQueryLimitMax = 100;

export const listAccountProductFitQueryOffsetDefault = 0;
export const listAccountProductFitQueryOffsetMin = 0;



export const listAccountProductFitQueryParams = zod.object({
  "accountId": zod.uuid().optional(),
  "productId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listAccountProductFitQueryLimitMax).default(listAccountProductFitQueryLimitDefault),
  "offset": zod.int().min(listAccountProductFitQueryOffsetMin).default(listAccountProductFitQueryOffsetDefault)
})

export const listAccountProductFitResponseItemsItemOneFitScoreMin = 0;
export const listAccountProductFitResponseItemsItemOneFitScoreMax = 100;

export const listAccountProductFitResponseTotalMin = 0;



export const listAccountProductFitResponse = zod.object({
  "items": zod.array(zod.object({
  "fitScore": zod.int().min(listAccountProductFitResponseItemsItemOneFitScoreMin).max(listAccountProductFitResponseItemsItemOneFitScoreMax).nullish(),
  "targetPriority": zod.enum(['A', 'B', 'C', 'watchlist']).nullish(),
  "signals": zod.record(zod.string(), zod.enum(['none', 'weak', 'moderate', 'strong'])).optional(),
  "rationale": zod.string().nullish(),
  "status": zod.enum(['draft', 'reviewed', 'confirmed', 'rejected']).optional(),
  "reviewedBy": zod.string().nullish(),
  "lastReviewedAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "productId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listAccountProductFitResponseTotalMin)
})


/**
 * @summary Create a product-fit score for a account/product pair
 */
export const createAccountProductFitBodyOneFitScoreMin = 0;
export const createAccountProductFitBodyOneFitScoreMax = 100;



export const createAccountProductFitBody = zod.object({
  "fitScore": zod.int().min(createAccountProductFitBodyOneFitScoreMin).max(createAccountProductFitBodyOneFitScoreMax).nullish(),
  "targetPriority": zod.enum(['A', 'B', 'C', 'watchlist']).nullish(),
  "signals": zod.record(zod.string(), zod.enum(['none', 'weak', 'moderate', 'strong'])).optional(),
  "rationale": zod.string().nullish(),
  "status": zod.enum(['draft', 'reviewed', 'confirmed', 'rejected']).optional(),
  "reviewedBy": zod.string().nullish(),
  "lastReviewedAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "accountId": zod.uuid(),
  "productId": zod.uuid()
}))

export const createAccountProductFitResponseOneFitScoreMin = 0;
export const createAccountProductFitResponseOneFitScoreMax = 100;



export const createAccountProductFitResponse = zod.object({
  "fitScore": zod.int().min(createAccountProductFitResponseOneFitScoreMin).max(createAccountProductFitResponseOneFitScoreMax).nullish(),
  "targetPriority": zod.enum(['A', 'B', 'C', 'watchlist']).nullish(),
  "signals": zod.record(zod.string(), zod.enum(['none', 'weak', 'moderate', 'strong'])).optional(),
  "rationale": zod.string().nullish(),
  "status": zod.enum(['draft', 'reviewed', 'confirmed', 'rejected']).optional(),
  "reviewedBy": zod.string().nullish(),
  "lastReviewedAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "productId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a product-fit score
 */
export const updateAccountProductFitParams = zod.object({
  "id": zod.uuid()
})

export const updateAccountProductFitBodyFitScoreMin = 0;
export const updateAccountProductFitBodyFitScoreMax = 100;



export const updateAccountProductFitBody = zod.object({
  "fitScore": zod.int().min(updateAccountProductFitBodyFitScoreMin).max(updateAccountProductFitBodyFitScoreMax).nullish(),
  "targetPriority": zod.enum(['A', 'B', 'C', 'watchlist']).nullish(),
  "signals": zod.record(zod.string(), zod.enum(['none', 'weak', 'moderate', 'strong'])).optional(),
  "rationale": zod.string().nullish(),
  "status": zod.enum(['draft', 'reviewed', 'confirmed', 'rejected']).optional(),
  "reviewedBy": zod.string().nullish(),
  "lastReviewedAt": zod.iso.datetime({"offset":true}).nullish()
})

export const updateAccountProductFitResponseOneFitScoreMin = 0;
export const updateAccountProductFitResponseOneFitScoreMax = 100;



export const updateAccountProductFitResponse = zod.object({
  "fitScore": zod.int().min(updateAccountProductFitResponseOneFitScoreMin).max(updateAccountProductFitResponseOneFitScoreMax).nullish(),
  "targetPriority": zod.enum(['A', 'B', 'C', 'watchlist']).nullish(),
  "signals": zod.record(zod.string(), zod.enum(['none', 'weak', 'moderate', 'strong'])).optional(),
  "rationale": zod.string().nullish(),
  "status": zod.enum(['draft', 'reviewed', 'confirmed', 'rejected']).optional(),
  "reviewedBy": zod.string().nullish(),
  "lastReviewedAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "accountId": zod.uuid(),
  "productId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a product-fit score
 */
export const deleteAccountProductFitParams = zod.object({
  "id": zod.uuid()
})

export const deleteAccountProductFitResponse = zod.void()


/**
 * @summary List backend-approved tender AI model choices and verified controls
 */
export const listTenderAiModelsResponseDataItemChoiceIdRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,63}$');
export const listTenderAiModelsResponseDataItemDisplayNameMax = 120;

export const listTenderAiModelsResponseDataItemDescriptionMax = 500;

export const listTenderAiModelsResponseDataItemDisabledReasonMax = 500;


export const listTenderAiModelsResponseDataItemMaxOutputTokensMax = 131072;

export const listTenderAiModelsResponseDataItemMaxTimeoutMsMin = 1000;
export const listTenderAiModelsResponseDataItemMaxTimeoutMsMax = 120000;

export const listTenderAiModelsResponseDataMax = 20;

export const listTenderAiModelsResponseAvailableChoiceCountMin = 0;



export const listTenderAiModelsResponse = zod.object({
  "data": zod.array(zod.object({
  "choiceId": zod.string().regex(listTenderAiModelsResponseDataItemChoiceIdRegExp),
  "displayName": zod.string().min(1).max(listTenderAiModelsResponseDataItemDisplayNameMax),
  "description": zod.string().max(listTenderAiModelsResponseDataItemDescriptionMax),
  "isDefault": zod.boolean(),
  "availability": zod.enum(['configured_unverified', 'disabled', 'unavailable']),
  "disabledReason": zod.string().max(listTenderAiModelsResponseDataItemDisabledReasonMax).nullish(),
  "reasoningEfforts": zod.array(zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh'])),
  "defaultReasoningEffort": zod.union([zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh']),zod.null()]),
  "contextWindowTokens": zod.int().min(1).nullable(),
  "maxOutputTokens": zod.int().min(1).max(listTenderAiModelsResponseDataItemMaxOutputTokensMax),
  "maxTimeoutMs": zod.int().min(listTenderAiModelsResponseDataItemMaxTimeoutMsMin).max(listTenderAiModelsResponseDataItemMaxTimeoutMsMax),
  "pricingEstimateAvailable": zod.boolean(),
  "connectionMode": zod.enum(['cdf-managed', 'byo-direct']),
  "tokenParameter": zod.enum(['max_tokens', 'max_completion_tokens'])
})).max(listTenderAiModelsResponseDataMax),
  "defaultChoiceId": zod.string().nullable(),
  "availableChoiceCount": zod.int().min(listTenderAiModelsResponseAvailableChoiceCountMin),
  "multiModelAvailable": zod.boolean(),
  "connectionMode": zod.enum(['cdf-managed', 'byo-direct']),
  "catalogueSource": zod.enum(['project_default', 'server_allowlist', 'invalid_configuration']),
  "liveAvailabilityVerified": zod.boolean().describe('False until an authorized provider request verifies the configured route.'),
  "message": zod.string()
})


/**
 * @summary Get entity tender storage defaults
 */
export const getTenderSettingsResponseReferencePrefixRegExp = new RegExp('^[A-Z0-9][A-Z0-9-]{0,11}$');
export const getTenderSettingsResponseDigestHourMin = 0;
export const getTenderSettingsResponseDigestHourMax = 23;

export const getTenderSettingsResponseDigestTimezoneMax = 64;

export const getTenderSettingsResponseBidRulesPromptMax = 8000;

export const getTenderSettingsResponseBidRulesRevisionMin = 0;




export const getTenderSettingsResponse = zod.object({
  "id": zod.uuid(),
  "referencePrefix": zod.string().regex(getTenderSettingsResponseReferencePrefixRegExp),
  "defaultStorageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerConfiguration": zod.record(zod.string(), zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
})),
  "digestEnabled": zod.boolean().describe('Send the daily tender opportunity digest email to tender staff.'),
  "digestHour": zod.int().min(getTenderSettingsResponseDigestHourMin).max(getTenderSettingsResponseDigestHourMax).describe('Local hour (24-hour clock) from which the daily digest is sent.'),
  "digestTimezone": zod.string().min(1).max(getTenderSettingsResponseDigestTimezoneMax).describe('IANA timezone used for the digest send hour and day.'),
  "bidRulesPrompt": zod.string().max(getTenderSettingsResponseBidRulesPromptMax).describe('Bid rules combined with the Offerings Profile when tenders are ranked. Edited in the Web Signals Targeting step and on tender settings.'),
  "bidRulesRevision": zod.int().min(getTenderSettingsResponseBidRulesRevisionMin).describe('Revision of the bid rules prompt; 0 until first saved.'),
  "bidRulesUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Save entity tender defaults using optimistic concurrency
 */
export const updateTenderSettingsBodyExpectedRevisionMin = 0;

export const updateTenderSettingsBodyReferencePrefixRegExp = new RegExp('^[A-Z0-9][A-Z0-9-]{0,11}$');
export const updateTenderSettingsBodyDigestHourMin = 0;
export const updateTenderSettingsBodyDigestHourMax = 23;

export const updateTenderSettingsBodyDigestTimezoneMax = 64;



export const updateTenderSettingsBody = zod.object({
  "expectedRevision": zod.int().min(updateTenderSettingsBodyExpectedRevisionMin),
  "referencePrefix": zod.string().regex(updateTenderSettingsBodyReferencePrefixRegExp),
  "defaultStorageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerConfiguration": zod.record(zod.string(), zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
})),
  "digestEnabled": zod.boolean().optional().describe('Omit to keep the current value.'),
  "digestHour": zod.int().min(updateTenderSettingsBodyDigestHourMin).max(updateTenderSettingsBodyDigestHourMax).optional().describe('Omit to keep the current value.'),
  "digestTimezone": zod.string().min(1).max(updateTenderSettingsBodyDigestTimezoneMax).optional().describe('IANA timezone such as Australia/Sydney. Omit to keep the current value.')
})

export const updateTenderSettingsResponseReferencePrefixRegExp = new RegExp('^[A-Z0-9][A-Z0-9-]{0,11}$');
export const updateTenderSettingsResponseDigestHourMin = 0;
export const updateTenderSettingsResponseDigestHourMax = 23;

export const updateTenderSettingsResponseDigestTimezoneMax = 64;

export const updateTenderSettingsResponseBidRulesPromptMax = 8000;

export const updateTenderSettingsResponseBidRulesRevisionMin = 0;




export const updateTenderSettingsResponse = zod.object({
  "id": zod.uuid(),
  "referencePrefix": zod.string().regex(updateTenderSettingsResponseReferencePrefixRegExp),
  "defaultStorageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerConfiguration": zod.record(zod.string(), zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
})),
  "digestEnabled": zod.boolean().describe('Send the daily tender opportunity digest email to tender staff.'),
  "digestHour": zod.int().min(updateTenderSettingsResponseDigestHourMin).max(updateTenderSettingsResponseDigestHourMax).describe('Local hour (24-hour clock) from which the daily digest is sent.'),
  "digestTimezone": zod.string().min(1).max(updateTenderSettingsResponseDigestTimezoneMax).describe('IANA timezone used for the digest send hour and day.'),
  "bidRulesPrompt": zod.string().max(updateTenderSettingsResponseBidRulesPromptMax).describe('Bid rules combined with the Offerings Profile when tenders are ranked. Edited in the Web Signals Targeting step and on tender settings.'),
  "bidRulesRevision": zod.int().min(updateTenderSettingsResponseBidRulesRevisionMin).describe('Revision of the bid rules prompt; 0 until first saved.'),
  "bidRulesUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Save the entity bid rules prompt used with the Offerings Profile to recommend Respond, Maybe or Not for us; open tenders are re-scored
 */
export const updateTenderBidRulesBodyExpectedBidRulesRevisionMin = 0;

export const updateTenderBidRulesBodyBidRulesPromptMax = 8000;



export const updateTenderBidRulesBody = zod.object({
  "expectedBidRulesRevision": zod.int().min(updateTenderBidRulesBodyExpectedBidRulesRevisionMin).describe('The bidRulesRevision that was loaded.'),
  "bidRulesPrompt": zod.string().max(updateTenderBidRulesBodyBidRulesPromptMax)
})

export const updateTenderBidRulesResponseReferencePrefixRegExp = new RegExp('^[A-Z0-9][A-Z0-9-]{0,11}$');
export const updateTenderBidRulesResponseDigestHourMin = 0;
export const updateTenderBidRulesResponseDigestHourMax = 23;

export const updateTenderBidRulesResponseDigestTimezoneMax = 64;

export const updateTenderBidRulesResponseBidRulesPromptMax = 8000;

export const updateTenderBidRulesResponseBidRulesRevisionMin = 0;




export const updateTenderBidRulesResponse = zod.object({
  "id": zod.uuid(),
  "referencePrefix": zod.string().regex(updateTenderBidRulesResponseReferencePrefixRegExp),
  "defaultStorageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerConfiguration": zod.record(zod.string(), zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
})),
  "digestEnabled": zod.boolean().describe('Send the daily tender opportunity digest email to tender staff.'),
  "digestHour": zod.int().min(updateTenderBidRulesResponseDigestHourMin).max(updateTenderBidRulesResponseDigestHourMax).describe('Local hour (24-hour clock) from which the daily digest is sent.'),
  "digestTimezone": zod.string().min(1).max(updateTenderBidRulesResponseDigestTimezoneMax).describe('IANA timezone used for the digest send hour and day.'),
  "bidRulesPrompt": zod.string().max(updateTenderBidRulesResponseBidRulesPromptMax).describe('Bid rules combined with the Offerings Profile when tenders are ranked. Edited in the Web Signals Targeting step and on tender settings.'),
  "bidRulesRevision": zod.int().min(updateTenderBidRulesResponseBidRulesRevisionMin).describe('Revision of the bid rules prompt; 0 until first saved.'),
  "bidRulesUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get safe entity SharePoint tender-storage readiness without credentials
 */
export const getTenderSharePointReadinessResponseDestinationRevisionMin = 0;



export const getTenderSharePointReadinessResponse = zod.object({
  "connectionId": zod.uuid().nullable(),
  "authStatus": zod.enum(['not_connected', 'connected', 'reauth_required', 'denied']),
  "destinationConfigured": zod.boolean(),
  "accountDisplayName": zod.string().nullable(),
  "siteId": zod.string().nullable(),
  "siteName": zod.string().nullable(),
  "siteUrl": zod.url().nullable(),
  "driveId": zod.string().nullable(),
  "driveName": zod.string().nullable(),
  "folderItemId": zod.string().nullable(),
  "folderPath": zod.string(),
  "destinationRevision": zod.int().min(getTenderSharePointReadinessResponseDestinationRevisionMin),
  "lastVerifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "setupMessage": zod.string().nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Start explicit administrator consent for SharePoint tender storage
 */
export const startTenderSharePointConnectionResponse = zod.object({
  "authorizationUrl": zod.url()
})


/**
 * @summary Reauthorize tender storage without changing its verified destination
 */
export const reconnectTenderSharePointConnectionParams = zod.object({
  "connectionId": zod.uuid()
})

export const reconnectTenderSharePointConnectionResponse = zod.object({
  "authorizationUrl": zod.url()
})


/**
 * @summary Complete browser-bound SharePoint tender-storage consent
 */
export const completeTenderSharePointConnectionQueryCodeMax = 8192;



export const completeTenderSharePointConnectionQueryParams = zod.object({
  "code": zod.string().min(1).max(completeTenderSharePointConnectionQueryCodeMax),
  "state": zod.uuid()
})

export const completeTenderSharePointConnectionResponse = zod.void()


/**
 * @summary Search bounded SharePoint sites visible to the connected administrator
 */
export const listTenderSharePointSitesParams = zod.object({
  "connectionId": zod.uuid()
})

export const listTenderSharePointSitesQuerySearchMin = 2;
export const listTenderSharePointSitesQuerySearchMax = 100;

export const listTenderSharePointSitesQueryLimitDefault = 25;
export const listTenderSharePointSitesQueryLimitMax = 50;

export const listTenderSharePointSitesQueryCursorMax = 4096;



export const listTenderSharePointSitesQueryParams = zod.object({
  "search": zod.string().min(listTenderSharePointSitesQuerySearchMin).max(listTenderSharePointSitesQuerySearchMax),
  "limit": zod.int().min(1).max(listTenderSharePointSitesQueryLimitMax).default(listTenderSharePointSitesQueryLimitDefault),
  "cursor": zod.string().max(listTenderSharePointSitesQueryCursorMax).optional()
})

export const listTenderSharePointSitesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "displayName": zod.string(),
  "webUrl": zod.url()
})),
  "nextCursor": zod.string().nullable()
})


/**
 * @summary List bounded document libraries for a SharePoint site
 */
export const listTenderSharePointDrivesPathSiteIdMax = 512;



export const listTenderSharePointDrivesParams = zod.object({
  "connectionId": zod.uuid(),
  "siteId": zod.string().min(1).max(listTenderSharePointDrivesPathSiteIdMax)
})

export const listTenderSharePointDrivesQueryLimitDefault = 25;
export const listTenderSharePointDrivesQueryLimitMax = 50;

export const listTenderSharePointDrivesQueryCursorMax = 4096;



export const listTenderSharePointDrivesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderSharePointDrivesQueryLimitMax).default(listTenderSharePointDrivesQueryLimitDefault),
  "cursor": zod.string().max(listTenderSharePointDrivesQueryCursorMax).optional()
})

export const listTenderSharePointDrivesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "driveType": zod.string()
})),
  "nextCursor": zod.string().nullable()
})


/**
 * @summary List bounded folders below a SharePoint drive item
 */
export const listTenderSharePointFoldersPathDriveIdMax = 512;

export const listTenderSharePointFoldersPathItemIdMax = 512;



export const listTenderSharePointFoldersParams = zod.object({
  "connectionId": zod.uuid(),
  "driveId": zod.string().min(1).max(listTenderSharePointFoldersPathDriveIdMax),
  "itemId": zod.string().min(1).max(listTenderSharePointFoldersPathItemIdMax)
})

export const listTenderSharePointFoldersQueryLimitDefault = 25;
export const listTenderSharePointFoldersQueryLimitMax = 50;

export const listTenderSharePointFoldersQueryCursorMax = 4096;



export const listTenderSharePointFoldersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderSharePointFoldersQueryLimitMax).default(listTenderSharePointFoldersQueryLimitDefault),
  "cursor": zod.string().max(listTenderSharePointFoldersQueryCursorMax).optional()
})

export const listTenderSharePointFoldersResponseItemsItemChildCountMin = 0;



export const listTenderSharePointFoldersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "childCount": zod.int().min(listTenderSharePointFoldersResponseItemsItemChildCountMin)
})),
  "nextCursor": zod.string().nullable()
})


/**
 * @summary Verify and save the SharePoint tender destination
 */
export const selectTenderSharePointDestinationParams = zod.object({
  "connectionId": zod.uuid()
})

export const selectTenderSharePointDestinationBodySiteIdMax = 512;

export const selectTenderSharePointDestinationBodyDriveIdMax = 512;

export const selectTenderSharePointDestinationBodyFolderItemIdMax = 512;

export const selectTenderSharePointDestinationBodyFolderPathMax = 1000;

export const selectTenderSharePointDestinationBodyExpectedDestinationRevisionMin = 0;



export const selectTenderSharePointDestinationBody = zod.object({
  "siteId": zod.string().min(1).max(selectTenderSharePointDestinationBodySiteIdMax),
  "driveId": zod.string().min(1).max(selectTenderSharePointDestinationBodyDriveIdMax),
  "folderItemId": zod.string().min(1).max(selectTenderSharePointDestinationBodyFolderItemIdMax).nullish(),
  "folderPath": zod.string().max(selectTenderSharePointDestinationBodyFolderPathMax).optional(),
  "expectedDestinationRevision": zod.int().min(selectTenderSharePointDestinationBodyExpectedDestinationRevisionMin)
})

export const selectTenderSharePointDestinationResponseDestinationRevisionMin = 0;



export const selectTenderSharePointDestinationResponse = zod.object({
  "connectionId": zod.uuid().nullable(),
  "authStatus": zod.enum(['not_connected', 'connected', 'reauth_required', 'denied']),
  "destinationConfigured": zod.boolean(),
  "accountDisplayName": zod.string().nullable(),
  "siteId": zod.string().nullable(),
  "siteName": zod.string().nullable(),
  "siteUrl": zod.url().nullable(),
  "driveId": zod.string().nullable(),
  "driveName": zod.string().nullable(),
  "folderItemId": zod.string().nullable(),
  "folderPath": zod.string(),
  "destinationRevision": zod.int().min(selectTenderSharePointDestinationResponseDestinationRevisionMin),
  "lastVerifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "setupMessage": zod.string().nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Get safe entity SharePoint Embedded readiness without credentials
 */
export const getTenderEmbeddedReadinessResponseDestinationRevisionMin = 0;



export const getTenderEmbeddedReadinessResponse = zod.object({
  "connectionId": zod.uuid().nullable(),
  "platformConfigured": zod.boolean(),
  "authStatus": zod.enum(['not_connected', 'connected', 'reauth_required', 'denied']),
  "destinationConfigured": zod.boolean(),
  "accountDisplayName": zod.string().nullable(),
  "tenantId": zod.string().nullable(),
  "containerTypeId": zod.string().nullable(),
  "containerId": zod.string().nullable(),
  "driveId": zod.string().nullable(),
  "containerName": zod.string().nullable(),
  "containerWebUrl": zod.url().nullable(),
  "destinationRevision": zod.int().min(getTenderEmbeddedReadinessResponseDestinationRevisionMin),
  "lastVerifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "setupMessage": zod.string().nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Start explicit administrator consent for Embedded tender storage
 */
export const startTenderEmbeddedConnectionResponse = zod.object({
  "authorizationUrl": zod.url()
})


/**
 * @summary Reauthorize Embedded storage without changing its verified entity container
 */
export const reconnectTenderEmbeddedConnectionParams = zod.object({
  "connectionId": zod.uuid()
})

export const reconnectTenderEmbeddedConnectionResponse = zod.object({
  "authorizationUrl": zod.url()
})


/**
 * @summary Complete browser-bound SharePoint Embedded consent
 */
export const completeTenderEmbeddedConnectionQueryCodeMax = 8192;



export const completeTenderEmbeddedConnectionQueryParams = zod.object({
  "code": zod.string().min(1).max(completeTenderEmbeddedConnectionQueryCodeMax),
  "state": zod.uuid()
})

export const completeTenderEmbeddedConnectionResponse = zod.void()


/**
 * @summary List bounded Embedded containers of the approved project type
 */
export const listTenderEmbeddedContainersParams = zod.object({
  "connectionId": zod.uuid()
})

export const listTenderEmbeddedContainersQueryLimitDefault = 25;
export const listTenderEmbeddedContainersQueryLimitMax = 50;

export const listTenderEmbeddedContainersQueryCursorMax = 4096;



export const listTenderEmbeddedContainersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderEmbeddedContainersQueryLimitMax).default(listTenderEmbeddedContainersQueryLimitDefault),
  "cursor": zod.string().max(listTenderEmbeddedContainersQueryCursorMax).optional()
})

export const listTenderEmbeddedContainersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "displayName": zod.string(),
  "containerTypeId": zod.string(),
  "status": zod.string(),
  "webUrl": zod.url().nullable(),
  "selectable": zod.boolean()
})),
  "nextCursor": zod.string().nullable()
})


/**
 * @summary Verify and save the entity Embedded container mapping
 */
export const selectTenderEmbeddedDestinationParams = zod.object({
  "connectionId": zod.uuid()
})

export const selectTenderEmbeddedDestinationBodyContainerIdMax = 512;

export const selectTenderEmbeddedDestinationBodyExpectedDestinationRevisionMin = 0;



export const selectTenderEmbeddedDestinationBody = zod.object({
  "containerId": zod.string().min(1).max(selectTenderEmbeddedDestinationBodyContainerIdMax),
  "expectedDestinationRevision": zod.int().min(selectTenderEmbeddedDestinationBodyExpectedDestinationRevisionMin)
})

export const selectTenderEmbeddedDestinationResponseDestinationRevisionMin = 0;



export const selectTenderEmbeddedDestinationResponse = zod.object({
  "connectionId": zod.uuid().nullable(),
  "platformConfigured": zod.boolean(),
  "authStatus": zod.enum(['not_connected', 'connected', 'reauth_required', 'denied']),
  "destinationConfigured": zod.boolean(),
  "accountDisplayName": zod.string().nullable(),
  "tenantId": zod.string().nullable(),
  "containerTypeId": zod.string().nullable(),
  "containerId": zod.string().nullable(),
  "driveId": zod.string().nullable(),
  "containerName": zod.string().nullable(),
  "containerWebUrl": zod.url().nullable(),
  "destinationRevision": zod.int().min(selectTenderEmbeddedDestinationResponseDestinationRevisionMin),
  "lastVerifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "setupMessage": zod.string().nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})



export const createTenderPreparationBodyAttachmentsItemContentHashRegExp = new RegExp('^[0-9a-f]{64}$');
export const createTenderPreparationBodyAttachmentsMax = 10;



export const createTenderPreparationBody = zod.object({
  "requestId": zod.uuid(),
  "conversationId": zod.uuid().optional(),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "contentHash": zod.string().regex(createTenderPreparationBodyAttachmentsItemContentHashRegExp)
})).min(1).max(createTenderPreparationBodyAttachmentsMax).optional()
})


export const createTenderPreparationResponseFilesItemFilenameMax = 1024;

export const createTenderPreparationResponseFilesItemContentHashMax = 64;

export const createTenderPreparationResponseFilesItemWarningsItemMax = 500;

export const createTenderPreparationResponseFilesItemWarningsMax = 110;

export const createTenderPreparationResponseFilesItemLocationsItemMax = 300;

export const createTenderPreparationResponseFilesItemLocationsMax = 250;

export const createTenderPreparationResponseFilesMax = 25;

export const createTenderPreparationResponseMetadataTypeSuggestionExplanationMax = 1000;

export const createTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const createTenderPreparationResponseMetadataTypeSuggestionCitationsMax = 20;

export const createTenderPreparationResponseMetadataTitleMax = 300;

export const createTenderPreparationResponseMetadataBuyerMax = 300;

export const createTenderPreparationResponseMetadataReferenceMax = 200;

export const createTenderPreparationResponseMetadataSummaryMax = 10000;

export const createTenderPreparationResponseMetadataDatesItemKindMax = 100;

export const createTenderPreparationResponseMetadataDatesItemValueMax = 200;

export const createTenderPreparationResponseMetadataDatesItemTimezoneMax = 100;

export const createTenderPreparationResponseMetadataDatesItemPrecisionMax = 100;

export const createTenderPreparationResponseMetadataDatesItemCitationsItemMax = 100;

export const createTenderPreparationResponseMetadataDatesItemCitationsMax = 20;

export const createTenderPreparationResponseMetadataDatesMax = 100;

export const createTenderPreparationResponseMetadataCriteriaItemIdMax = 100;

export const createTenderPreparationResponseMetadataCriteriaItemDescriptionMax = 10000;

export const createTenderPreparationResponseMetadataCriteriaItemWeightMax = 100;

export const createTenderPreparationResponseMetadataCriteriaItemResponseLimitMax = 200;

export const createTenderPreparationResponseMetadataCriteriaItemCitationsItemMax = 100;

export const createTenderPreparationResponseMetadataCriteriaItemCitationsMax = 20;

export const createTenderPreparationResponseMetadataCriteriaMax = 100;

export const createTenderPreparationResponseMetadataObligationsItemMax = 2000;

export const createTenderPreparationResponseMetadataObligationsMax = 100;

export const createTenderPreparationResponseMetadataMissingDocumentsItemMax = 1000;

export const createTenderPreparationResponseMetadataMissingDocumentsMax = 100;

export const createTenderPreparationResponseMetadataQaItemMax = 5000;

export const createTenderPreparationResponseMetadataQaMax = 100;

export const createTenderPreparationResponseMetadataWarningsItemMax = 1000;

export const createTenderPreparationResponseMetadataWarningsMax = 100;


export const createTenderPreparationResponseMatchesMax = 2;

export const createTenderPreparationResponseWarningsItemMax = 1000;

export const createTenderPreparationResponseWarningsMax = 100;

export const createTenderPreparationResponseReviewFieldsTitleMax = 300;

export const createTenderPreparationResponseReviewFieldsBriefingMdMax = 50000;

export const createTenderPreparationResponseReviewFieldsSelectedOutputKindsMax = 4;

export const createTenderPreparationResponseReviewSelectedFilesMax = 100;

export const createTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const createTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const createTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const createTenderPreparationResponseReviewMetadataTitleMax = 300;

export const createTenderPreparationResponseReviewMetadataBuyerMax = 300;

export const createTenderPreparationResponseReviewMetadataReferenceMax = 200;

export const createTenderPreparationResponseReviewMetadataSummaryMax = 10000;

export const createTenderPreparationResponseReviewMetadataDatesItemKindMax = 100;

export const createTenderPreparationResponseReviewMetadataDatesItemValueMax = 200;

export const createTenderPreparationResponseReviewMetadataDatesItemTimezoneMax = 100;

export const createTenderPreparationResponseReviewMetadataDatesItemPrecisionMax = 100;

export const createTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const createTenderPreparationResponseReviewMetadataDatesItemCitationsMax = 20;

export const createTenderPreparationResponseReviewMetadataDatesMax = 100;

export const createTenderPreparationResponseReviewMetadataCriteriaItemIdMax = 100;

export const createTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const createTenderPreparationResponseReviewMetadataCriteriaItemWeightMax = 100;

export const createTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const createTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const createTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const createTenderPreparationResponseReviewMetadataCriteriaMax = 100;

export const createTenderPreparationResponseReviewMetadataObligationsItemMax = 2000;

export const createTenderPreparationResponseReviewMetadataObligationsMax = 100;

export const createTenderPreparationResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const createTenderPreparationResponseReviewMetadataMissingDocumentsMax = 100;

export const createTenderPreparationResponseReviewMetadataQaItemMax = 5000;

export const createTenderPreparationResponseReviewMetadataQaMax = 100;

export const createTenderPreparationResponseReviewMetadataWarningsItemMax = 1000;

export const createTenderPreparationResponseReviewMetadataWarningsMax = 100;

export const createTenderPreparationResponseReviewSourceLabelsMax = 100;


export const createTenderPreparationResponseReviewProposalReviewDestructiveDefault = false;
export const createTenderPreparationResponseReceiptSourcesMax = 100;

export const createTenderPreparationResponseAccountReviewWebsiteMax = 2000;

export const createTenderPreparationResponseAccountReviewIndustryMax = 200;

export const createTenderPreparationResponseAccountReviewPhoneMax = 100;

export const createTenderPreparationResponseAccountReviewEmailMax = 320;

export const createTenderPreparationResponseAccountReviewEmailDomainMax = 253;

export const createTenderPreparationResponseAccountReviewAddressLine1Max = 500;

export const createTenderPreparationResponseAccountReviewCityMax = 200;

export const createTenderPreparationResponseAccountReviewStateProvinceMax = 200;

export const createTenderPreparationResponseAccountReviewPostcodeMax = 50;

export const createTenderPreparationResponseAccountReviewCountryMax = 200;

export const createTenderPreparationResponseAccountReviewNotesMax = 10000;

export const createTenderPreparationResponseAccountReviewAnnualRevenueMin = 0;
export const createTenderPreparationResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const createTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const createTenderPreparationResponseAccountReviewNumberOfEmployeesMin = 0;
export const createTenderPreparationResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const createTenderPreparationResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(createTenderPreparationResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(createTenderPreparationResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(createTenderPreparationResponseFilesItemWarningsItemMax)).max(createTenderPreparationResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(createTenderPreparationResponseFilesItemLocationsItemMax)).max(createTenderPreparationResponseFilesItemLocationsMax)
})).max(createTenderPreparationResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(createTenderPreparationResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(createTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax)).max(createTenderPreparationResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(createTenderPreparationResponseMetadataTitleMax),
  "buyer": zod.string().max(createTenderPreparationResponseMetadataBuyerMax),
  "reference": zod.string().max(createTenderPreparationResponseMetadataReferenceMax),
  "summary": zod.string().max(createTenderPreparationResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(createTenderPreparationResponseMetadataDatesItemKindMax),
  "value": zod.string().max(createTenderPreparationResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(createTenderPreparationResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(createTenderPreparationResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(createTenderPreparationResponseMetadataDatesItemCitationsItemMax)).min(1).max(createTenderPreparationResponseMetadataDatesItemCitationsMax)
})).max(createTenderPreparationResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(createTenderPreparationResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(createTenderPreparationResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(createTenderPreparationResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(createTenderPreparationResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(createTenderPreparationResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(createTenderPreparationResponseMetadataCriteriaItemCitationsMax)
})).max(createTenderPreparationResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(createTenderPreparationResponseMetadataObligationsItemMax)).max(createTenderPreparationResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(createTenderPreparationResponseMetadataMissingDocumentsItemMax)).max(createTenderPreparationResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(createTenderPreparationResponseMetadataQaItemMax)).max(createTenderPreparationResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(createTenderPreparationResponseMetadataWarningsItemMax)).max(createTenderPreparationResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(createTenderPreparationResponseMatchesMax),
  "warnings": zod.array(zod.string().max(createTenderPreparationResponseWarningsItemMax)).max(createTenderPreparationResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(createTenderPreparationResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(createTenderPreparationResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(createTenderPreparationResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(createTenderPreparationResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(createTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(createTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(createTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(createTenderPreparationResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(createTenderPreparationResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(createTenderPreparationResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(createTenderPreparationResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(createTenderPreparationResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(createTenderPreparationResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(createTenderPreparationResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(createTenderPreparationResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(createTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(createTenderPreparationResponseReviewMetadataDatesItemCitationsMax)
})).max(createTenderPreparationResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(createTenderPreparationResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(createTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(createTenderPreparationResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(createTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(createTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(createTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax)
})).max(createTenderPreparationResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(createTenderPreparationResponseReviewMetadataObligationsItemMax)).max(createTenderPreparationResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(createTenderPreparationResponseReviewMetadataMissingDocumentsItemMax)).max(createTenderPreparationResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(createTenderPreparationResponseReviewMetadataQaItemMax)).max(createTenderPreparationResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(createTenderPreparationResponseReviewMetadataWarningsItemMax)).max(createTenderPreparationResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(createTenderPreparationResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(createTenderPreparationResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(createTenderPreparationResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(createTenderPreparationResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(createTenderPreparationResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(createTenderPreparationResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(createTenderPreparationResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(createTenderPreparationResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(createTenderPreparationResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(createTenderPreparationResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(createTenderPreparationResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(createTenderPreparationResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(createTenderPreparationResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(createTenderPreparationResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(createTenderPreparationResponseAccountReviewAnnualRevenueMin).max(createTenderPreparationResponseAccountReviewAnnualRevenueMax).multipleOf(createTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(createTenderPreparationResponseAccountReviewNumberOfEmployeesMin).max(createTenderPreparationResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


export const getTenderPreparationParams = zod.object({
  "id": zod.uuid()
})

export const getTenderPreparationQueryParams = zod.object({
  "limit": zod.int().optional(),
  "offset": zod.int().optional()
})


export const getTenderPreparationResponseFilesItemFilenameMax = 1024;

export const getTenderPreparationResponseFilesItemContentHashMax = 64;

export const getTenderPreparationResponseFilesItemWarningsItemMax = 500;

export const getTenderPreparationResponseFilesItemWarningsMax = 110;

export const getTenderPreparationResponseFilesItemLocationsItemMax = 300;

export const getTenderPreparationResponseFilesItemLocationsMax = 250;

export const getTenderPreparationResponseFilesMax = 25;

export const getTenderPreparationResponseMetadataTypeSuggestionExplanationMax = 1000;

export const getTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const getTenderPreparationResponseMetadataTypeSuggestionCitationsMax = 20;

export const getTenderPreparationResponseMetadataTitleMax = 300;

export const getTenderPreparationResponseMetadataBuyerMax = 300;

export const getTenderPreparationResponseMetadataReferenceMax = 200;

export const getTenderPreparationResponseMetadataSummaryMax = 10000;

export const getTenderPreparationResponseMetadataDatesItemKindMax = 100;

export const getTenderPreparationResponseMetadataDatesItemValueMax = 200;

export const getTenderPreparationResponseMetadataDatesItemTimezoneMax = 100;

export const getTenderPreparationResponseMetadataDatesItemPrecisionMax = 100;

export const getTenderPreparationResponseMetadataDatesItemCitationsItemMax = 100;

export const getTenderPreparationResponseMetadataDatesItemCitationsMax = 20;

export const getTenderPreparationResponseMetadataDatesMax = 100;

export const getTenderPreparationResponseMetadataCriteriaItemIdMax = 100;

export const getTenderPreparationResponseMetadataCriteriaItemDescriptionMax = 10000;

export const getTenderPreparationResponseMetadataCriteriaItemWeightMax = 100;

export const getTenderPreparationResponseMetadataCriteriaItemResponseLimitMax = 200;

export const getTenderPreparationResponseMetadataCriteriaItemCitationsItemMax = 100;

export const getTenderPreparationResponseMetadataCriteriaItemCitationsMax = 20;

export const getTenderPreparationResponseMetadataCriteriaMax = 100;

export const getTenderPreparationResponseMetadataObligationsItemMax = 2000;

export const getTenderPreparationResponseMetadataObligationsMax = 100;

export const getTenderPreparationResponseMetadataMissingDocumentsItemMax = 1000;

export const getTenderPreparationResponseMetadataMissingDocumentsMax = 100;

export const getTenderPreparationResponseMetadataQaItemMax = 5000;

export const getTenderPreparationResponseMetadataQaMax = 100;

export const getTenderPreparationResponseMetadataWarningsItemMax = 1000;

export const getTenderPreparationResponseMetadataWarningsMax = 100;


export const getTenderPreparationResponseMatchesMax = 2;

export const getTenderPreparationResponseWarningsItemMax = 1000;

export const getTenderPreparationResponseWarningsMax = 100;

export const getTenderPreparationResponseReviewFieldsTitleMax = 300;

export const getTenderPreparationResponseReviewFieldsBriefingMdMax = 50000;

export const getTenderPreparationResponseReviewFieldsSelectedOutputKindsMax = 4;

export const getTenderPreparationResponseReviewSelectedFilesMax = 100;

export const getTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const getTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const getTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const getTenderPreparationResponseReviewMetadataTitleMax = 300;

export const getTenderPreparationResponseReviewMetadataBuyerMax = 300;

export const getTenderPreparationResponseReviewMetadataReferenceMax = 200;

export const getTenderPreparationResponseReviewMetadataSummaryMax = 10000;

export const getTenderPreparationResponseReviewMetadataDatesItemKindMax = 100;

export const getTenderPreparationResponseReviewMetadataDatesItemValueMax = 200;

export const getTenderPreparationResponseReviewMetadataDatesItemTimezoneMax = 100;

export const getTenderPreparationResponseReviewMetadataDatesItemPrecisionMax = 100;

export const getTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const getTenderPreparationResponseReviewMetadataDatesItemCitationsMax = 20;

export const getTenderPreparationResponseReviewMetadataDatesMax = 100;

export const getTenderPreparationResponseReviewMetadataCriteriaItemIdMax = 100;

export const getTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const getTenderPreparationResponseReviewMetadataCriteriaItemWeightMax = 100;

export const getTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const getTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const getTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const getTenderPreparationResponseReviewMetadataCriteriaMax = 100;

export const getTenderPreparationResponseReviewMetadataObligationsItemMax = 2000;

export const getTenderPreparationResponseReviewMetadataObligationsMax = 100;

export const getTenderPreparationResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const getTenderPreparationResponseReviewMetadataMissingDocumentsMax = 100;

export const getTenderPreparationResponseReviewMetadataQaItemMax = 5000;

export const getTenderPreparationResponseReviewMetadataQaMax = 100;

export const getTenderPreparationResponseReviewMetadataWarningsItemMax = 1000;

export const getTenderPreparationResponseReviewMetadataWarningsMax = 100;

export const getTenderPreparationResponseReviewSourceLabelsMax = 100;


export const getTenderPreparationResponseReviewProposalReviewDestructiveDefault = false;
export const getTenderPreparationResponseReceiptSourcesMax = 100;

export const getTenderPreparationResponseAccountReviewWebsiteMax = 2000;

export const getTenderPreparationResponseAccountReviewIndustryMax = 200;

export const getTenderPreparationResponseAccountReviewPhoneMax = 100;

export const getTenderPreparationResponseAccountReviewEmailMax = 320;

export const getTenderPreparationResponseAccountReviewEmailDomainMax = 253;

export const getTenderPreparationResponseAccountReviewAddressLine1Max = 500;

export const getTenderPreparationResponseAccountReviewCityMax = 200;

export const getTenderPreparationResponseAccountReviewStateProvinceMax = 200;

export const getTenderPreparationResponseAccountReviewPostcodeMax = 50;

export const getTenderPreparationResponseAccountReviewCountryMax = 200;

export const getTenderPreparationResponseAccountReviewNotesMax = 10000;

export const getTenderPreparationResponseAccountReviewAnnualRevenueMin = 0;
export const getTenderPreparationResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const getTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const getTenderPreparationResponseAccountReviewNumberOfEmployeesMin = 0;
export const getTenderPreparationResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const getTenderPreparationResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(getTenderPreparationResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(getTenderPreparationResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(getTenderPreparationResponseFilesItemWarningsItemMax)).max(getTenderPreparationResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(getTenderPreparationResponseFilesItemLocationsItemMax)).max(getTenderPreparationResponseFilesItemLocationsMax)
})).max(getTenderPreparationResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(getTenderPreparationResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(getTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax)).max(getTenderPreparationResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(getTenderPreparationResponseMetadataTitleMax),
  "buyer": zod.string().max(getTenderPreparationResponseMetadataBuyerMax),
  "reference": zod.string().max(getTenderPreparationResponseMetadataReferenceMax),
  "summary": zod.string().max(getTenderPreparationResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(getTenderPreparationResponseMetadataDatesItemKindMax),
  "value": zod.string().max(getTenderPreparationResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(getTenderPreparationResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(getTenderPreparationResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(getTenderPreparationResponseMetadataDatesItemCitationsItemMax)).min(1).max(getTenderPreparationResponseMetadataDatesItemCitationsMax)
})).max(getTenderPreparationResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(getTenderPreparationResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(getTenderPreparationResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(getTenderPreparationResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(getTenderPreparationResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(getTenderPreparationResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(getTenderPreparationResponseMetadataCriteriaItemCitationsMax)
})).max(getTenderPreparationResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(getTenderPreparationResponseMetadataObligationsItemMax)).max(getTenderPreparationResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(getTenderPreparationResponseMetadataMissingDocumentsItemMax)).max(getTenderPreparationResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(getTenderPreparationResponseMetadataQaItemMax)).max(getTenderPreparationResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(getTenderPreparationResponseMetadataWarningsItemMax)).max(getTenderPreparationResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(getTenderPreparationResponseMatchesMax),
  "warnings": zod.array(zod.string().max(getTenderPreparationResponseWarningsItemMax)).max(getTenderPreparationResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(getTenderPreparationResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(getTenderPreparationResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(getTenderPreparationResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(getTenderPreparationResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(getTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(getTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(getTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(getTenderPreparationResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(getTenderPreparationResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(getTenderPreparationResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(getTenderPreparationResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(getTenderPreparationResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(getTenderPreparationResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(getTenderPreparationResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(getTenderPreparationResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(getTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(getTenderPreparationResponseReviewMetadataDatesItemCitationsMax)
})).max(getTenderPreparationResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(getTenderPreparationResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(getTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(getTenderPreparationResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(getTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(getTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(getTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax)
})).max(getTenderPreparationResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(getTenderPreparationResponseReviewMetadataObligationsItemMax)).max(getTenderPreparationResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(getTenderPreparationResponseReviewMetadataMissingDocumentsItemMax)).max(getTenderPreparationResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(getTenderPreparationResponseReviewMetadataQaItemMax)).max(getTenderPreparationResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(getTenderPreparationResponseReviewMetadataWarningsItemMax)).max(getTenderPreparationResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(getTenderPreparationResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(getTenderPreparationResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(getTenderPreparationResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(getTenderPreparationResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(getTenderPreparationResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(getTenderPreparationResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(getTenderPreparationResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(getTenderPreparationResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(getTenderPreparationResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(getTenderPreparationResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(getTenderPreparationResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(getTenderPreparationResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(getTenderPreparationResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(getTenderPreparationResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(getTenderPreparationResponseAccountReviewAnnualRevenueMin).max(getTenderPreparationResponseAccountReviewAnnualRevenueMax).multipleOf(getTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(getTenderPreparationResponseAccountReviewNumberOfEmployeesMin).max(getTenderPreparationResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


export const uploadTenderPreparationParams = zod.object({
  "id": zod.uuid()
})

export const uploadTenderPreparationBodyFilenameMax = 255;

export const uploadTenderPreparationBodyContentTypeMax = 200;

export const uploadTenderPreparationBodyDataBase64Min = 4;
export const uploadTenderPreparationBodyDataBase64Max = 27962028;



export const uploadTenderPreparationBody = zod.object({
  "uploadId": zod.uuid(),
  "filename": zod.string().min(1).max(uploadTenderPreparationBodyFilenameMax),
  "contentType": zod.string().min(1).max(uploadTenderPreparationBodyContentTypeMax),
  "dataBase64": zod.string().min(uploadTenderPreparationBodyDataBase64Min).max(uploadTenderPreparationBodyDataBase64Max)
})


export const uploadTenderPreparationResponseFilesItemFilenameMax = 1024;

export const uploadTenderPreparationResponseFilesItemContentHashMax = 64;

export const uploadTenderPreparationResponseFilesItemWarningsItemMax = 500;

export const uploadTenderPreparationResponseFilesItemWarningsMax = 110;

export const uploadTenderPreparationResponseFilesItemLocationsItemMax = 300;

export const uploadTenderPreparationResponseFilesItemLocationsMax = 250;

export const uploadTenderPreparationResponseFilesMax = 25;

export const uploadTenderPreparationResponseMetadataTypeSuggestionExplanationMax = 1000;

export const uploadTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const uploadTenderPreparationResponseMetadataTypeSuggestionCitationsMax = 20;

export const uploadTenderPreparationResponseMetadataTitleMax = 300;

export const uploadTenderPreparationResponseMetadataBuyerMax = 300;

export const uploadTenderPreparationResponseMetadataReferenceMax = 200;

export const uploadTenderPreparationResponseMetadataSummaryMax = 10000;

export const uploadTenderPreparationResponseMetadataDatesItemKindMax = 100;

export const uploadTenderPreparationResponseMetadataDatesItemValueMax = 200;

export const uploadTenderPreparationResponseMetadataDatesItemTimezoneMax = 100;

export const uploadTenderPreparationResponseMetadataDatesItemPrecisionMax = 100;

export const uploadTenderPreparationResponseMetadataDatesItemCitationsItemMax = 100;

export const uploadTenderPreparationResponseMetadataDatesItemCitationsMax = 20;

export const uploadTenderPreparationResponseMetadataDatesMax = 100;

export const uploadTenderPreparationResponseMetadataCriteriaItemIdMax = 100;

export const uploadTenderPreparationResponseMetadataCriteriaItemDescriptionMax = 10000;

export const uploadTenderPreparationResponseMetadataCriteriaItemWeightMax = 100;

export const uploadTenderPreparationResponseMetadataCriteriaItemResponseLimitMax = 200;

export const uploadTenderPreparationResponseMetadataCriteriaItemCitationsItemMax = 100;

export const uploadTenderPreparationResponseMetadataCriteriaItemCitationsMax = 20;

export const uploadTenderPreparationResponseMetadataCriteriaMax = 100;

export const uploadTenderPreparationResponseMetadataObligationsItemMax = 2000;

export const uploadTenderPreparationResponseMetadataObligationsMax = 100;

export const uploadTenderPreparationResponseMetadataMissingDocumentsItemMax = 1000;

export const uploadTenderPreparationResponseMetadataMissingDocumentsMax = 100;

export const uploadTenderPreparationResponseMetadataQaItemMax = 5000;

export const uploadTenderPreparationResponseMetadataQaMax = 100;

export const uploadTenderPreparationResponseMetadataWarningsItemMax = 1000;

export const uploadTenderPreparationResponseMetadataWarningsMax = 100;


export const uploadTenderPreparationResponseMatchesMax = 2;

export const uploadTenderPreparationResponseWarningsItemMax = 1000;

export const uploadTenderPreparationResponseWarningsMax = 100;

export const uploadTenderPreparationResponseReviewFieldsTitleMax = 300;

export const uploadTenderPreparationResponseReviewFieldsBriefingMdMax = 50000;

export const uploadTenderPreparationResponseReviewFieldsSelectedOutputKindsMax = 4;

export const uploadTenderPreparationResponseReviewSelectedFilesMax = 100;

export const uploadTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const uploadTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const uploadTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const uploadTenderPreparationResponseReviewMetadataTitleMax = 300;

export const uploadTenderPreparationResponseReviewMetadataBuyerMax = 300;

export const uploadTenderPreparationResponseReviewMetadataReferenceMax = 200;

export const uploadTenderPreparationResponseReviewMetadataSummaryMax = 10000;

export const uploadTenderPreparationResponseReviewMetadataDatesItemKindMax = 100;

export const uploadTenderPreparationResponseReviewMetadataDatesItemValueMax = 200;

export const uploadTenderPreparationResponseReviewMetadataDatesItemTimezoneMax = 100;

export const uploadTenderPreparationResponseReviewMetadataDatesItemPrecisionMax = 100;

export const uploadTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const uploadTenderPreparationResponseReviewMetadataDatesItemCitationsMax = 20;

export const uploadTenderPreparationResponseReviewMetadataDatesMax = 100;

export const uploadTenderPreparationResponseReviewMetadataCriteriaItemIdMax = 100;

export const uploadTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const uploadTenderPreparationResponseReviewMetadataCriteriaItemWeightMax = 100;

export const uploadTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const uploadTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const uploadTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const uploadTenderPreparationResponseReviewMetadataCriteriaMax = 100;

export const uploadTenderPreparationResponseReviewMetadataObligationsItemMax = 2000;

export const uploadTenderPreparationResponseReviewMetadataObligationsMax = 100;

export const uploadTenderPreparationResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const uploadTenderPreparationResponseReviewMetadataMissingDocumentsMax = 100;

export const uploadTenderPreparationResponseReviewMetadataQaItemMax = 5000;

export const uploadTenderPreparationResponseReviewMetadataQaMax = 100;

export const uploadTenderPreparationResponseReviewMetadataWarningsItemMax = 1000;

export const uploadTenderPreparationResponseReviewMetadataWarningsMax = 100;

export const uploadTenderPreparationResponseReviewSourceLabelsMax = 100;


export const uploadTenderPreparationResponseReviewProposalReviewDestructiveDefault = false;
export const uploadTenderPreparationResponseReceiptSourcesMax = 100;

export const uploadTenderPreparationResponseAccountReviewWebsiteMax = 2000;

export const uploadTenderPreparationResponseAccountReviewIndustryMax = 200;

export const uploadTenderPreparationResponseAccountReviewPhoneMax = 100;

export const uploadTenderPreparationResponseAccountReviewEmailMax = 320;

export const uploadTenderPreparationResponseAccountReviewEmailDomainMax = 253;

export const uploadTenderPreparationResponseAccountReviewAddressLine1Max = 500;

export const uploadTenderPreparationResponseAccountReviewCityMax = 200;

export const uploadTenderPreparationResponseAccountReviewStateProvinceMax = 200;

export const uploadTenderPreparationResponseAccountReviewPostcodeMax = 50;

export const uploadTenderPreparationResponseAccountReviewCountryMax = 200;

export const uploadTenderPreparationResponseAccountReviewNotesMax = 10000;

export const uploadTenderPreparationResponseAccountReviewAnnualRevenueMin = 0;
export const uploadTenderPreparationResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const uploadTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const uploadTenderPreparationResponseAccountReviewNumberOfEmployeesMin = 0;
export const uploadTenderPreparationResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const uploadTenderPreparationResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(uploadTenderPreparationResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(uploadTenderPreparationResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(uploadTenderPreparationResponseFilesItemWarningsItemMax)).max(uploadTenderPreparationResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(uploadTenderPreparationResponseFilesItemLocationsItemMax)).max(uploadTenderPreparationResponseFilesItemLocationsMax)
})).max(uploadTenderPreparationResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(uploadTenderPreparationResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(uploadTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax)).max(uploadTenderPreparationResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(uploadTenderPreparationResponseMetadataTitleMax),
  "buyer": zod.string().max(uploadTenderPreparationResponseMetadataBuyerMax),
  "reference": zod.string().max(uploadTenderPreparationResponseMetadataReferenceMax),
  "summary": zod.string().max(uploadTenderPreparationResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(uploadTenderPreparationResponseMetadataDatesItemKindMax),
  "value": zod.string().max(uploadTenderPreparationResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(uploadTenderPreparationResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(uploadTenderPreparationResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(uploadTenderPreparationResponseMetadataDatesItemCitationsItemMax)).min(1).max(uploadTenderPreparationResponseMetadataDatesItemCitationsMax)
})).max(uploadTenderPreparationResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(uploadTenderPreparationResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(uploadTenderPreparationResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(uploadTenderPreparationResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(uploadTenderPreparationResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(uploadTenderPreparationResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(uploadTenderPreparationResponseMetadataCriteriaItemCitationsMax)
})).max(uploadTenderPreparationResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(uploadTenderPreparationResponseMetadataObligationsItemMax)).max(uploadTenderPreparationResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(uploadTenderPreparationResponseMetadataMissingDocumentsItemMax)).max(uploadTenderPreparationResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(uploadTenderPreparationResponseMetadataQaItemMax)).max(uploadTenderPreparationResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(uploadTenderPreparationResponseMetadataWarningsItemMax)).max(uploadTenderPreparationResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(uploadTenderPreparationResponseMatchesMax),
  "warnings": zod.array(zod.string().max(uploadTenderPreparationResponseWarningsItemMax)).max(uploadTenderPreparationResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(uploadTenderPreparationResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(uploadTenderPreparationResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(uploadTenderPreparationResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(uploadTenderPreparationResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(uploadTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(uploadTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(uploadTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(uploadTenderPreparationResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(uploadTenderPreparationResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(uploadTenderPreparationResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(uploadTenderPreparationResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(uploadTenderPreparationResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(uploadTenderPreparationResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(uploadTenderPreparationResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(uploadTenderPreparationResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(uploadTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(uploadTenderPreparationResponseReviewMetadataDatesItemCitationsMax)
})).max(uploadTenderPreparationResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(uploadTenderPreparationResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(uploadTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(uploadTenderPreparationResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(uploadTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(uploadTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(uploadTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax)
})).max(uploadTenderPreparationResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(uploadTenderPreparationResponseReviewMetadataObligationsItemMax)).max(uploadTenderPreparationResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(uploadTenderPreparationResponseReviewMetadataMissingDocumentsItemMax)).max(uploadTenderPreparationResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(uploadTenderPreparationResponseReviewMetadataQaItemMax)).max(uploadTenderPreparationResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(uploadTenderPreparationResponseReviewMetadataWarningsItemMax)).max(uploadTenderPreparationResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(uploadTenderPreparationResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(uploadTenderPreparationResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(uploadTenderPreparationResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(uploadTenderPreparationResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(uploadTenderPreparationResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(uploadTenderPreparationResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(uploadTenderPreparationResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(uploadTenderPreparationResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(uploadTenderPreparationResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(uploadTenderPreparationResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(uploadTenderPreparationResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(uploadTenderPreparationResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(uploadTenderPreparationResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(uploadTenderPreparationResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(uploadTenderPreparationResponseAccountReviewAnnualRevenueMin).max(uploadTenderPreparationResponseAccountReviewAnnualRevenueMax).multipleOf(uploadTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(uploadTenderPreparationResponseAccountReviewNumberOfEmployeesMin).max(uploadTenderPreparationResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


export const prepareTenderDocumentsParams = zod.object({
  "id": zod.uuid()
})




export const prepareTenderDocumentsBody = zod.object({
  "expectedRevision": zod.int().min(1)
})


export const prepareTenderDocumentsResponseFilesItemFilenameMax = 1024;

export const prepareTenderDocumentsResponseFilesItemContentHashMax = 64;

export const prepareTenderDocumentsResponseFilesItemWarningsItemMax = 500;

export const prepareTenderDocumentsResponseFilesItemWarningsMax = 110;

export const prepareTenderDocumentsResponseFilesItemLocationsItemMax = 300;

export const prepareTenderDocumentsResponseFilesItemLocationsMax = 250;

export const prepareTenderDocumentsResponseFilesMax = 25;

export const prepareTenderDocumentsResponseMetadataTypeSuggestionExplanationMax = 1000;

export const prepareTenderDocumentsResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const prepareTenderDocumentsResponseMetadataTypeSuggestionCitationsMax = 20;

export const prepareTenderDocumentsResponseMetadataTitleMax = 300;

export const prepareTenderDocumentsResponseMetadataBuyerMax = 300;

export const prepareTenderDocumentsResponseMetadataReferenceMax = 200;

export const prepareTenderDocumentsResponseMetadataSummaryMax = 10000;

export const prepareTenderDocumentsResponseMetadataDatesItemKindMax = 100;

export const prepareTenderDocumentsResponseMetadataDatesItemValueMax = 200;

export const prepareTenderDocumentsResponseMetadataDatesItemTimezoneMax = 100;

export const prepareTenderDocumentsResponseMetadataDatesItemPrecisionMax = 100;

export const prepareTenderDocumentsResponseMetadataDatesItemCitationsItemMax = 100;

export const prepareTenderDocumentsResponseMetadataDatesItemCitationsMax = 20;

export const prepareTenderDocumentsResponseMetadataDatesMax = 100;

export const prepareTenderDocumentsResponseMetadataCriteriaItemIdMax = 100;

export const prepareTenderDocumentsResponseMetadataCriteriaItemDescriptionMax = 10000;

export const prepareTenderDocumentsResponseMetadataCriteriaItemWeightMax = 100;

export const prepareTenderDocumentsResponseMetadataCriteriaItemResponseLimitMax = 200;

export const prepareTenderDocumentsResponseMetadataCriteriaItemCitationsItemMax = 100;

export const prepareTenderDocumentsResponseMetadataCriteriaItemCitationsMax = 20;

export const prepareTenderDocumentsResponseMetadataCriteriaMax = 100;

export const prepareTenderDocumentsResponseMetadataObligationsItemMax = 2000;

export const prepareTenderDocumentsResponseMetadataObligationsMax = 100;

export const prepareTenderDocumentsResponseMetadataMissingDocumentsItemMax = 1000;

export const prepareTenderDocumentsResponseMetadataMissingDocumentsMax = 100;

export const prepareTenderDocumentsResponseMetadataQaItemMax = 5000;

export const prepareTenderDocumentsResponseMetadataQaMax = 100;

export const prepareTenderDocumentsResponseMetadataWarningsItemMax = 1000;

export const prepareTenderDocumentsResponseMetadataWarningsMax = 100;


export const prepareTenderDocumentsResponseMatchesMax = 2;

export const prepareTenderDocumentsResponseWarningsItemMax = 1000;

export const prepareTenderDocumentsResponseWarningsMax = 100;

export const prepareTenderDocumentsResponseReviewFieldsTitleMax = 300;

export const prepareTenderDocumentsResponseReviewFieldsBriefingMdMax = 50000;

export const prepareTenderDocumentsResponseReviewFieldsSelectedOutputKindsMax = 4;

export const prepareTenderDocumentsResponseReviewSelectedFilesMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const prepareTenderDocumentsResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const prepareTenderDocumentsResponseReviewMetadataTitleMax = 300;

export const prepareTenderDocumentsResponseReviewMetadataBuyerMax = 300;

export const prepareTenderDocumentsResponseReviewMetadataReferenceMax = 200;

export const prepareTenderDocumentsResponseReviewMetadataSummaryMax = 10000;

export const prepareTenderDocumentsResponseReviewMetadataDatesItemKindMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataDatesItemValueMax = 200;

export const prepareTenderDocumentsResponseReviewMetadataDatesItemTimezoneMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataDatesItemPrecisionMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataDatesItemCitationsMax = 20;

export const prepareTenderDocumentsResponseReviewMetadataDatesMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataCriteriaItemIdMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const prepareTenderDocumentsResponseReviewMetadataCriteriaItemWeightMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const prepareTenderDocumentsResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const prepareTenderDocumentsResponseReviewMetadataCriteriaMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataObligationsItemMax = 2000;

export const prepareTenderDocumentsResponseReviewMetadataObligationsMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const prepareTenderDocumentsResponseReviewMetadataMissingDocumentsMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataQaItemMax = 5000;

export const prepareTenderDocumentsResponseReviewMetadataQaMax = 100;

export const prepareTenderDocumentsResponseReviewMetadataWarningsItemMax = 1000;

export const prepareTenderDocumentsResponseReviewMetadataWarningsMax = 100;

export const prepareTenderDocumentsResponseReviewSourceLabelsMax = 100;


export const prepareTenderDocumentsResponseReviewProposalReviewDestructiveDefault = false;
export const prepareTenderDocumentsResponseReceiptSourcesMax = 100;

export const prepareTenderDocumentsResponseAccountReviewWebsiteMax = 2000;

export const prepareTenderDocumentsResponseAccountReviewIndustryMax = 200;

export const prepareTenderDocumentsResponseAccountReviewPhoneMax = 100;

export const prepareTenderDocumentsResponseAccountReviewEmailMax = 320;

export const prepareTenderDocumentsResponseAccountReviewEmailDomainMax = 253;

export const prepareTenderDocumentsResponseAccountReviewAddressLine1Max = 500;

export const prepareTenderDocumentsResponseAccountReviewCityMax = 200;

export const prepareTenderDocumentsResponseAccountReviewStateProvinceMax = 200;

export const prepareTenderDocumentsResponseAccountReviewPostcodeMax = 50;

export const prepareTenderDocumentsResponseAccountReviewCountryMax = 200;

export const prepareTenderDocumentsResponseAccountReviewNotesMax = 10000;

export const prepareTenderDocumentsResponseAccountReviewAnnualRevenueMin = 0;
export const prepareTenderDocumentsResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const prepareTenderDocumentsResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const prepareTenderDocumentsResponseAccountReviewNumberOfEmployeesMin = 0;
export const prepareTenderDocumentsResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const prepareTenderDocumentsResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(prepareTenderDocumentsResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(prepareTenderDocumentsResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(prepareTenderDocumentsResponseFilesItemWarningsItemMax)).max(prepareTenderDocumentsResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(prepareTenderDocumentsResponseFilesItemLocationsItemMax)).max(prepareTenderDocumentsResponseFilesItemLocationsMax)
})).max(prepareTenderDocumentsResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(prepareTenderDocumentsResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(prepareTenderDocumentsResponseMetadataTypeSuggestionCitationsItemMax)).max(prepareTenderDocumentsResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(prepareTenderDocumentsResponseMetadataTitleMax),
  "buyer": zod.string().max(prepareTenderDocumentsResponseMetadataBuyerMax),
  "reference": zod.string().max(prepareTenderDocumentsResponseMetadataReferenceMax),
  "summary": zod.string().max(prepareTenderDocumentsResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(prepareTenderDocumentsResponseMetadataDatesItemKindMax),
  "value": zod.string().max(prepareTenderDocumentsResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(prepareTenderDocumentsResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(prepareTenderDocumentsResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(prepareTenderDocumentsResponseMetadataDatesItemCitationsItemMax)).min(1).max(prepareTenderDocumentsResponseMetadataDatesItemCitationsMax)
})).max(prepareTenderDocumentsResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(prepareTenderDocumentsResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(prepareTenderDocumentsResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(prepareTenderDocumentsResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(prepareTenderDocumentsResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(prepareTenderDocumentsResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(prepareTenderDocumentsResponseMetadataCriteriaItemCitationsMax)
})).max(prepareTenderDocumentsResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(prepareTenderDocumentsResponseMetadataObligationsItemMax)).max(prepareTenderDocumentsResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(prepareTenderDocumentsResponseMetadataMissingDocumentsItemMax)).max(prepareTenderDocumentsResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(prepareTenderDocumentsResponseMetadataQaItemMax)).max(prepareTenderDocumentsResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(prepareTenderDocumentsResponseMetadataWarningsItemMax)).max(prepareTenderDocumentsResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(prepareTenderDocumentsResponseMatchesMax),
  "warnings": zod.array(zod.string().max(prepareTenderDocumentsResponseWarningsItemMax)).max(prepareTenderDocumentsResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(prepareTenderDocumentsResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(prepareTenderDocumentsResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(prepareTenderDocumentsResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(prepareTenderDocumentsResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(prepareTenderDocumentsResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(prepareTenderDocumentsResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(prepareTenderDocumentsResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(prepareTenderDocumentsResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(prepareTenderDocumentsResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(prepareTenderDocumentsResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(prepareTenderDocumentsResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(prepareTenderDocumentsResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(prepareTenderDocumentsResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(prepareTenderDocumentsResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(prepareTenderDocumentsResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(prepareTenderDocumentsResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(prepareTenderDocumentsResponseReviewMetadataDatesItemCitationsMax)
})).max(prepareTenderDocumentsResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(prepareTenderDocumentsResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(prepareTenderDocumentsResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(prepareTenderDocumentsResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(prepareTenderDocumentsResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(prepareTenderDocumentsResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(prepareTenderDocumentsResponseReviewMetadataCriteriaItemCitationsMax)
})).max(prepareTenderDocumentsResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(prepareTenderDocumentsResponseReviewMetadataObligationsItemMax)).max(prepareTenderDocumentsResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(prepareTenderDocumentsResponseReviewMetadataMissingDocumentsItemMax)).max(prepareTenderDocumentsResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(prepareTenderDocumentsResponseReviewMetadataQaItemMax)).max(prepareTenderDocumentsResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(prepareTenderDocumentsResponseReviewMetadataWarningsItemMax)).max(prepareTenderDocumentsResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(prepareTenderDocumentsResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(prepareTenderDocumentsResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(prepareTenderDocumentsResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(prepareTenderDocumentsResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(prepareTenderDocumentsResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(prepareTenderDocumentsResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(prepareTenderDocumentsResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(prepareTenderDocumentsResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(prepareTenderDocumentsResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(prepareTenderDocumentsResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(prepareTenderDocumentsResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(prepareTenderDocumentsResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(prepareTenderDocumentsResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(prepareTenderDocumentsResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(prepareTenderDocumentsResponseAccountReviewAnnualRevenueMin).max(prepareTenderDocumentsResponseAccountReviewAnnualRevenueMax).multipleOf(prepareTenderDocumentsResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(prepareTenderDocumentsResponseAccountReviewNumberOfEmployeesMin).max(prepareTenderDocumentsResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


export const reviewTenderPreparationParams = zod.object({
  "id": zod.uuid()
})


export const reviewTenderPreparationBodyFieldsTitleMax = 300;

export const reviewTenderPreparationBodyFieldsBriefingMdMax = 50000;

export const reviewTenderPreparationBodyFieldsSelectedOutputKindsMax = 4;

export const reviewTenderPreparationBodyMetadataTypeSuggestionExplanationMax = 1000;

export const reviewTenderPreparationBodyMetadataTypeSuggestionCitationsItemMax = 100;

export const reviewTenderPreparationBodyMetadataTypeSuggestionCitationsMax = 20;

export const reviewTenderPreparationBodyMetadataTitleMax = 300;

export const reviewTenderPreparationBodyMetadataBuyerMax = 300;

export const reviewTenderPreparationBodyMetadataReferenceMax = 200;

export const reviewTenderPreparationBodyMetadataSummaryMax = 10000;

export const reviewTenderPreparationBodyMetadataDatesItemKindMax = 100;

export const reviewTenderPreparationBodyMetadataDatesItemValueMax = 200;

export const reviewTenderPreparationBodyMetadataDatesItemTimezoneMax = 100;

export const reviewTenderPreparationBodyMetadataDatesItemPrecisionMax = 100;

export const reviewTenderPreparationBodyMetadataDatesItemCitationsItemMax = 100;

export const reviewTenderPreparationBodyMetadataDatesItemCitationsMax = 20;

export const reviewTenderPreparationBodyMetadataDatesMax = 100;

export const reviewTenderPreparationBodyMetadataCriteriaItemIdMax = 100;

export const reviewTenderPreparationBodyMetadataCriteriaItemDescriptionMax = 10000;

export const reviewTenderPreparationBodyMetadataCriteriaItemWeightMax = 100;

export const reviewTenderPreparationBodyMetadataCriteriaItemResponseLimitMax = 200;

export const reviewTenderPreparationBodyMetadataCriteriaItemCitationsItemMax = 100;

export const reviewTenderPreparationBodyMetadataCriteriaItemCitationsMax = 20;

export const reviewTenderPreparationBodyMetadataCriteriaMax = 100;

export const reviewTenderPreparationBodyMetadataObligationsItemMax = 2000;

export const reviewTenderPreparationBodyMetadataObligationsMax = 100;

export const reviewTenderPreparationBodyMetadataMissingDocumentsItemMax = 1000;

export const reviewTenderPreparationBodyMetadataMissingDocumentsMax = 100;

export const reviewTenderPreparationBodyMetadataQaItemMax = 5000;

export const reviewTenderPreparationBodyMetadataQaMax = 100;

export const reviewTenderPreparationBodyMetadataWarningsItemMax = 1000;

export const reviewTenderPreparationBodyMetadataWarningsMax = 100;

export const reviewTenderPreparationBodySelectedFilesMax = 100;



export const reviewTenderPreparationBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(reviewTenderPreparationBodyFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(reviewTenderPreparationBodyFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(reviewTenderPreparationBodyFieldsSelectedOutputKindsMax).optional()
}),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(reviewTenderPreparationBodyMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationBodyMetadataTypeSuggestionCitationsItemMax)).max(reviewTenderPreparationBodyMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(reviewTenderPreparationBodyMetadataTitleMax),
  "buyer": zod.string().max(reviewTenderPreparationBodyMetadataBuyerMax),
  "reference": zod.string().max(reviewTenderPreparationBodyMetadataReferenceMax),
  "summary": zod.string().max(reviewTenderPreparationBodyMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(reviewTenderPreparationBodyMetadataDatesItemKindMax),
  "value": zod.string().max(reviewTenderPreparationBodyMetadataDatesItemValueMax),
  "timezone": zod.string().max(reviewTenderPreparationBodyMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(reviewTenderPreparationBodyMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationBodyMetadataDatesItemCitationsItemMax)).min(1).max(reviewTenderPreparationBodyMetadataDatesItemCitationsMax)
})).max(reviewTenderPreparationBodyMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(reviewTenderPreparationBodyMetadataCriteriaItemIdMax),
  "description": zod.string().max(reviewTenderPreparationBodyMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(reviewTenderPreparationBodyMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(reviewTenderPreparationBodyMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationBodyMetadataCriteriaItemCitationsItemMax)).min(1).max(reviewTenderPreparationBodyMetadataCriteriaItemCitationsMax)
})).max(reviewTenderPreparationBodyMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(reviewTenderPreparationBodyMetadataObligationsItemMax)).max(reviewTenderPreparationBodyMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(reviewTenderPreparationBodyMetadataMissingDocumentsItemMax)).max(reviewTenderPreparationBodyMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(reviewTenderPreparationBodyMetadataQaItemMax)).max(reviewTenderPreparationBodyMetadataQaMax),
  "warnings": zod.array(zod.string().max(reviewTenderPreparationBodyMetadataWarningsItemMax)).max(reviewTenderPreparationBodyMetadataWarningsMax)
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(reviewTenderPreparationBodySelectedFilesMax)
})


export const reviewTenderPreparationResponseFilesItemFilenameMax = 1024;

export const reviewTenderPreparationResponseFilesItemContentHashMax = 64;

export const reviewTenderPreparationResponseFilesItemWarningsItemMax = 500;

export const reviewTenderPreparationResponseFilesItemWarningsMax = 110;

export const reviewTenderPreparationResponseFilesItemLocationsItemMax = 300;

export const reviewTenderPreparationResponseFilesItemLocationsMax = 250;

export const reviewTenderPreparationResponseFilesMax = 25;

export const reviewTenderPreparationResponseMetadataTypeSuggestionExplanationMax = 1000;

export const reviewTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const reviewTenderPreparationResponseMetadataTypeSuggestionCitationsMax = 20;

export const reviewTenderPreparationResponseMetadataTitleMax = 300;

export const reviewTenderPreparationResponseMetadataBuyerMax = 300;

export const reviewTenderPreparationResponseMetadataReferenceMax = 200;

export const reviewTenderPreparationResponseMetadataSummaryMax = 10000;

export const reviewTenderPreparationResponseMetadataDatesItemKindMax = 100;

export const reviewTenderPreparationResponseMetadataDatesItemValueMax = 200;

export const reviewTenderPreparationResponseMetadataDatesItemTimezoneMax = 100;

export const reviewTenderPreparationResponseMetadataDatesItemPrecisionMax = 100;

export const reviewTenderPreparationResponseMetadataDatesItemCitationsItemMax = 100;

export const reviewTenderPreparationResponseMetadataDatesItemCitationsMax = 20;

export const reviewTenderPreparationResponseMetadataDatesMax = 100;

export const reviewTenderPreparationResponseMetadataCriteriaItemIdMax = 100;

export const reviewTenderPreparationResponseMetadataCriteriaItemDescriptionMax = 10000;

export const reviewTenderPreparationResponseMetadataCriteriaItemWeightMax = 100;

export const reviewTenderPreparationResponseMetadataCriteriaItemResponseLimitMax = 200;

export const reviewTenderPreparationResponseMetadataCriteriaItemCitationsItemMax = 100;

export const reviewTenderPreparationResponseMetadataCriteriaItemCitationsMax = 20;

export const reviewTenderPreparationResponseMetadataCriteriaMax = 100;

export const reviewTenderPreparationResponseMetadataObligationsItemMax = 2000;

export const reviewTenderPreparationResponseMetadataObligationsMax = 100;

export const reviewTenderPreparationResponseMetadataMissingDocumentsItemMax = 1000;

export const reviewTenderPreparationResponseMetadataMissingDocumentsMax = 100;

export const reviewTenderPreparationResponseMetadataQaItemMax = 5000;

export const reviewTenderPreparationResponseMetadataQaMax = 100;

export const reviewTenderPreparationResponseMetadataWarningsItemMax = 1000;

export const reviewTenderPreparationResponseMetadataWarningsMax = 100;


export const reviewTenderPreparationResponseMatchesMax = 2;

export const reviewTenderPreparationResponseWarningsItemMax = 1000;

export const reviewTenderPreparationResponseWarningsMax = 100;

export const reviewTenderPreparationResponseReviewFieldsTitleMax = 300;

export const reviewTenderPreparationResponseReviewFieldsBriefingMdMax = 50000;

export const reviewTenderPreparationResponseReviewFieldsSelectedOutputKindsMax = 4;

export const reviewTenderPreparationResponseReviewSelectedFilesMax = 100;

export const reviewTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const reviewTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const reviewTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const reviewTenderPreparationResponseReviewMetadataTitleMax = 300;

export const reviewTenderPreparationResponseReviewMetadataBuyerMax = 300;

export const reviewTenderPreparationResponseReviewMetadataReferenceMax = 200;

export const reviewTenderPreparationResponseReviewMetadataSummaryMax = 10000;

export const reviewTenderPreparationResponseReviewMetadataDatesItemKindMax = 100;

export const reviewTenderPreparationResponseReviewMetadataDatesItemValueMax = 200;

export const reviewTenderPreparationResponseReviewMetadataDatesItemTimezoneMax = 100;

export const reviewTenderPreparationResponseReviewMetadataDatesItemPrecisionMax = 100;

export const reviewTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const reviewTenderPreparationResponseReviewMetadataDatesItemCitationsMax = 20;

export const reviewTenderPreparationResponseReviewMetadataDatesMax = 100;

export const reviewTenderPreparationResponseReviewMetadataCriteriaItemIdMax = 100;

export const reviewTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const reviewTenderPreparationResponseReviewMetadataCriteriaItemWeightMax = 100;

export const reviewTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const reviewTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const reviewTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const reviewTenderPreparationResponseReviewMetadataCriteriaMax = 100;

export const reviewTenderPreparationResponseReviewMetadataObligationsItemMax = 2000;

export const reviewTenderPreparationResponseReviewMetadataObligationsMax = 100;

export const reviewTenderPreparationResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const reviewTenderPreparationResponseReviewMetadataMissingDocumentsMax = 100;

export const reviewTenderPreparationResponseReviewMetadataQaItemMax = 5000;

export const reviewTenderPreparationResponseReviewMetadataQaMax = 100;

export const reviewTenderPreparationResponseReviewMetadataWarningsItemMax = 1000;

export const reviewTenderPreparationResponseReviewMetadataWarningsMax = 100;

export const reviewTenderPreparationResponseReviewSourceLabelsMax = 100;


export const reviewTenderPreparationResponseReviewProposalReviewDestructiveDefault = false;
export const reviewTenderPreparationResponseReceiptSourcesMax = 100;

export const reviewTenderPreparationResponseAccountReviewWebsiteMax = 2000;

export const reviewTenderPreparationResponseAccountReviewIndustryMax = 200;

export const reviewTenderPreparationResponseAccountReviewPhoneMax = 100;

export const reviewTenderPreparationResponseAccountReviewEmailMax = 320;

export const reviewTenderPreparationResponseAccountReviewEmailDomainMax = 253;

export const reviewTenderPreparationResponseAccountReviewAddressLine1Max = 500;

export const reviewTenderPreparationResponseAccountReviewCityMax = 200;

export const reviewTenderPreparationResponseAccountReviewStateProvinceMax = 200;

export const reviewTenderPreparationResponseAccountReviewPostcodeMax = 50;

export const reviewTenderPreparationResponseAccountReviewCountryMax = 200;

export const reviewTenderPreparationResponseAccountReviewNotesMax = 10000;

export const reviewTenderPreparationResponseAccountReviewAnnualRevenueMin = 0;
export const reviewTenderPreparationResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const reviewTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const reviewTenderPreparationResponseAccountReviewNumberOfEmployeesMin = 0;
export const reviewTenderPreparationResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const reviewTenderPreparationResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(reviewTenderPreparationResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(reviewTenderPreparationResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(reviewTenderPreparationResponseFilesItemWarningsItemMax)).max(reviewTenderPreparationResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(reviewTenderPreparationResponseFilesItemLocationsItemMax)).max(reviewTenderPreparationResponseFilesItemLocationsMax)
})).max(reviewTenderPreparationResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(reviewTenderPreparationResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax)).max(reviewTenderPreparationResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(reviewTenderPreparationResponseMetadataTitleMax),
  "buyer": zod.string().max(reviewTenderPreparationResponseMetadataBuyerMax),
  "reference": zod.string().max(reviewTenderPreparationResponseMetadataReferenceMax),
  "summary": zod.string().max(reviewTenderPreparationResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(reviewTenderPreparationResponseMetadataDatesItemKindMax),
  "value": zod.string().max(reviewTenderPreparationResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(reviewTenderPreparationResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(reviewTenderPreparationResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationResponseMetadataDatesItemCitationsItemMax)).min(1).max(reviewTenderPreparationResponseMetadataDatesItemCitationsMax)
})).max(reviewTenderPreparationResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(reviewTenderPreparationResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(reviewTenderPreparationResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(reviewTenderPreparationResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(reviewTenderPreparationResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(reviewTenderPreparationResponseMetadataCriteriaItemCitationsMax)
})).max(reviewTenderPreparationResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(reviewTenderPreparationResponseMetadataObligationsItemMax)).max(reviewTenderPreparationResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(reviewTenderPreparationResponseMetadataMissingDocumentsItemMax)).max(reviewTenderPreparationResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(reviewTenderPreparationResponseMetadataQaItemMax)).max(reviewTenderPreparationResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(reviewTenderPreparationResponseMetadataWarningsItemMax)).max(reviewTenderPreparationResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(reviewTenderPreparationResponseMatchesMax),
  "warnings": zod.array(zod.string().max(reviewTenderPreparationResponseWarningsItemMax)).max(reviewTenderPreparationResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(reviewTenderPreparationResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(reviewTenderPreparationResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(reviewTenderPreparationResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(reviewTenderPreparationResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(reviewTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(reviewTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(reviewTenderPreparationResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(reviewTenderPreparationResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(reviewTenderPreparationResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(reviewTenderPreparationResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(reviewTenderPreparationResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(reviewTenderPreparationResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(reviewTenderPreparationResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(reviewTenderPreparationResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(reviewTenderPreparationResponseReviewMetadataDatesItemCitationsMax)
})).max(reviewTenderPreparationResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(reviewTenderPreparationResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(reviewTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(reviewTenderPreparationResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(reviewTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(reviewTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax)
})).max(reviewTenderPreparationResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(reviewTenderPreparationResponseReviewMetadataObligationsItemMax)).max(reviewTenderPreparationResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(reviewTenderPreparationResponseReviewMetadataMissingDocumentsItemMax)).max(reviewTenderPreparationResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(reviewTenderPreparationResponseReviewMetadataQaItemMax)).max(reviewTenderPreparationResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(reviewTenderPreparationResponseReviewMetadataWarningsItemMax)).max(reviewTenderPreparationResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(reviewTenderPreparationResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(reviewTenderPreparationResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(reviewTenderPreparationResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(reviewTenderPreparationResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(reviewTenderPreparationResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(reviewTenderPreparationResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(reviewTenderPreparationResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(reviewTenderPreparationResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(reviewTenderPreparationResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(reviewTenderPreparationResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(reviewTenderPreparationResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(reviewTenderPreparationResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(reviewTenderPreparationResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(reviewTenderPreparationResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(reviewTenderPreparationResponseAccountReviewAnnualRevenueMin).max(reviewTenderPreparationResponseAccountReviewAnnualRevenueMax).multipleOf(reviewTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(reviewTenderPreparationResponseAccountReviewNumberOfEmployeesMin).max(reviewTenderPreparationResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


export const confirmTenderPreparationParams = zod.object({
  "id": zod.uuid()
})

export const confirmTenderPreparationBodyHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const confirmTenderPreparationBody = zod.object({
  "hash": zod.string().regex(confirmTenderPreparationBodyHashRegExp)
})


export const confirmTenderPreparationResponseFilesItemFilenameMax = 1024;

export const confirmTenderPreparationResponseFilesItemContentHashMax = 64;

export const confirmTenderPreparationResponseFilesItemWarningsItemMax = 500;

export const confirmTenderPreparationResponseFilesItemWarningsMax = 110;

export const confirmTenderPreparationResponseFilesItemLocationsItemMax = 300;

export const confirmTenderPreparationResponseFilesItemLocationsMax = 250;

export const confirmTenderPreparationResponseFilesMax = 25;

export const confirmTenderPreparationResponseMetadataTypeSuggestionExplanationMax = 1000;

export const confirmTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const confirmTenderPreparationResponseMetadataTypeSuggestionCitationsMax = 20;

export const confirmTenderPreparationResponseMetadataTitleMax = 300;

export const confirmTenderPreparationResponseMetadataBuyerMax = 300;

export const confirmTenderPreparationResponseMetadataReferenceMax = 200;

export const confirmTenderPreparationResponseMetadataSummaryMax = 10000;

export const confirmTenderPreparationResponseMetadataDatesItemKindMax = 100;

export const confirmTenderPreparationResponseMetadataDatesItemValueMax = 200;

export const confirmTenderPreparationResponseMetadataDatesItemTimezoneMax = 100;

export const confirmTenderPreparationResponseMetadataDatesItemPrecisionMax = 100;

export const confirmTenderPreparationResponseMetadataDatesItemCitationsItemMax = 100;

export const confirmTenderPreparationResponseMetadataDatesItemCitationsMax = 20;

export const confirmTenderPreparationResponseMetadataDatesMax = 100;

export const confirmTenderPreparationResponseMetadataCriteriaItemIdMax = 100;

export const confirmTenderPreparationResponseMetadataCriteriaItemDescriptionMax = 10000;

export const confirmTenderPreparationResponseMetadataCriteriaItemWeightMax = 100;

export const confirmTenderPreparationResponseMetadataCriteriaItemResponseLimitMax = 200;

export const confirmTenderPreparationResponseMetadataCriteriaItemCitationsItemMax = 100;

export const confirmTenderPreparationResponseMetadataCriteriaItemCitationsMax = 20;

export const confirmTenderPreparationResponseMetadataCriteriaMax = 100;

export const confirmTenderPreparationResponseMetadataObligationsItemMax = 2000;

export const confirmTenderPreparationResponseMetadataObligationsMax = 100;

export const confirmTenderPreparationResponseMetadataMissingDocumentsItemMax = 1000;

export const confirmTenderPreparationResponseMetadataMissingDocumentsMax = 100;

export const confirmTenderPreparationResponseMetadataQaItemMax = 5000;

export const confirmTenderPreparationResponseMetadataQaMax = 100;

export const confirmTenderPreparationResponseMetadataWarningsItemMax = 1000;

export const confirmTenderPreparationResponseMetadataWarningsMax = 100;


export const confirmTenderPreparationResponseMatchesMax = 2;

export const confirmTenderPreparationResponseWarningsItemMax = 1000;

export const confirmTenderPreparationResponseWarningsMax = 100;

export const confirmTenderPreparationResponseReviewFieldsTitleMax = 300;

export const confirmTenderPreparationResponseReviewFieldsBriefingMdMax = 50000;

export const confirmTenderPreparationResponseReviewFieldsSelectedOutputKindsMax = 4;

export const confirmTenderPreparationResponseReviewSelectedFilesMax = 100;

export const confirmTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const confirmTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const confirmTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const confirmTenderPreparationResponseReviewMetadataTitleMax = 300;

export const confirmTenderPreparationResponseReviewMetadataBuyerMax = 300;

export const confirmTenderPreparationResponseReviewMetadataReferenceMax = 200;

export const confirmTenderPreparationResponseReviewMetadataSummaryMax = 10000;

export const confirmTenderPreparationResponseReviewMetadataDatesItemKindMax = 100;

export const confirmTenderPreparationResponseReviewMetadataDatesItemValueMax = 200;

export const confirmTenderPreparationResponseReviewMetadataDatesItemTimezoneMax = 100;

export const confirmTenderPreparationResponseReviewMetadataDatesItemPrecisionMax = 100;

export const confirmTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const confirmTenderPreparationResponseReviewMetadataDatesItemCitationsMax = 20;

export const confirmTenderPreparationResponseReviewMetadataDatesMax = 100;

export const confirmTenderPreparationResponseReviewMetadataCriteriaItemIdMax = 100;

export const confirmTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const confirmTenderPreparationResponseReviewMetadataCriteriaItemWeightMax = 100;

export const confirmTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const confirmTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const confirmTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const confirmTenderPreparationResponseReviewMetadataCriteriaMax = 100;

export const confirmTenderPreparationResponseReviewMetadataObligationsItemMax = 2000;

export const confirmTenderPreparationResponseReviewMetadataObligationsMax = 100;

export const confirmTenderPreparationResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const confirmTenderPreparationResponseReviewMetadataMissingDocumentsMax = 100;

export const confirmTenderPreparationResponseReviewMetadataQaItemMax = 5000;

export const confirmTenderPreparationResponseReviewMetadataQaMax = 100;

export const confirmTenderPreparationResponseReviewMetadataWarningsItemMax = 1000;

export const confirmTenderPreparationResponseReviewMetadataWarningsMax = 100;

export const confirmTenderPreparationResponseReviewSourceLabelsMax = 100;


export const confirmTenderPreparationResponseReviewProposalReviewDestructiveDefault = false;
export const confirmTenderPreparationResponseReceiptSourcesMax = 100;

export const confirmTenderPreparationResponseAccountReviewWebsiteMax = 2000;

export const confirmTenderPreparationResponseAccountReviewIndustryMax = 200;

export const confirmTenderPreparationResponseAccountReviewPhoneMax = 100;

export const confirmTenderPreparationResponseAccountReviewEmailMax = 320;

export const confirmTenderPreparationResponseAccountReviewEmailDomainMax = 253;

export const confirmTenderPreparationResponseAccountReviewAddressLine1Max = 500;

export const confirmTenderPreparationResponseAccountReviewCityMax = 200;

export const confirmTenderPreparationResponseAccountReviewStateProvinceMax = 200;

export const confirmTenderPreparationResponseAccountReviewPostcodeMax = 50;

export const confirmTenderPreparationResponseAccountReviewCountryMax = 200;

export const confirmTenderPreparationResponseAccountReviewNotesMax = 10000;

export const confirmTenderPreparationResponseAccountReviewAnnualRevenueMin = 0;
export const confirmTenderPreparationResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const confirmTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const confirmTenderPreparationResponseAccountReviewNumberOfEmployeesMin = 0;
export const confirmTenderPreparationResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const confirmTenderPreparationResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(confirmTenderPreparationResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(confirmTenderPreparationResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(confirmTenderPreparationResponseFilesItemWarningsItemMax)).max(confirmTenderPreparationResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(confirmTenderPreparationResponseFilesItemLocationsItemMax)).max(confirmTenderPreparationResponseFilesItemLocationsMax)
})).max(confirmTenderPreparationResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(confirmTenderPreparationResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax)).max(confirmTenderPreparationResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(confirmTenderPreparationResponseMetadataTitleMax),
  "buyer": zod.string().max(confirmTenderPreparationResponseMetadataBuyerMax),
  "reference": zod.string().max(confirmTenderPreparationResponseMetadataReferenceMax),
  "summary": zod.string().max(confirmTenderPreparationResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(confirmTenderPreparationResponseMetadataDatesItemKindMax),
  "value": zod.string().max(confirmTenderPreparationResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(confirmTenderPreparationResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(confirmTenderPreparationResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationResponseMetadataDatesItemCitationsItemMax)).min(1).max(confirmTenderPreparationResponseMetadataDatesItemCitationsMax)
})).max(confirmTenderPreparationResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(confirmTenderPreparationResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(confirmTenderPreparationResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(confirmTenderPreparationResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(confirmTenderPreparationResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(confirmTenderPreparationResponseMetadataCriteriaItemCitationsMax)
})).max(confirmTenderPreparationResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(confirmTenderPreparationResponseMetadataObligationsItemMax)).max(confirmTenderPreparationResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(confirmTenderPreparationResponseMetadataMissingDocumentsItemMax)).max(confirmTenderPreparationResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(confirmTenderPreparationResponseMetadataQaItemMax)).max(confirmTenderPreparationResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(confirmTenderPreparationResponseMetadataWarningsItemMax)).max(confirmTenderPreparationResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(confirmTenderPreparationResponseMatchesMax),
  "warnings": zod.array(zod.string().max(confirmTenderPreparationResponseWarningsItemMax)).max(confirmTenderPreparationResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(confirmTenderPreparationResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(confirmTenderPreparationResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(confirmTenderPreparationResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(confirmTenderPreparationResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(confirmTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(confirmTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(confirmTenderPreparationResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(confirmTenderPreparationResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(confirmTenderPreparationResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(confirmTenderPreparationResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(confirmTenderPreparationResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(confirmTenderPreparationResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(confirmTenderPreparationResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(confirmTenderPreparationResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(confirmTenderPreparationResponseReviewMetadataDatesItemCitationsMax)
})).max(confirmTenderPreparationResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(confirmTenderPreparationResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(confirmTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(confirmTenderPreparationResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(confirmTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(confirmTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax)
})).max(confirmTenderPreparationResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(confirmTenderPreparationResponseReviewMetadataObligationsItemMax)).max(confirmTenderPreparationResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(confirmTenderPreparationResponseReviewMetadataMissingDocumentsItemMax)).max(confirmTenderPreparationResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(confirmTenderPreparationResponseReviewMetadataQaItemMax)).max(confirmTenderPreparationResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(confirmTenderPreparationResponseReviewMetadataWarningsItemMax)).max(confirmTenderPreparationResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(confirmTenderPreparationResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(confirmTenderPreparationResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(confirmTenderPreparationResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(confirmTenderPreparationResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(confirmTenderPreparationResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(confirmTenderPreparationResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(confirmTenderPreparationResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(confirmTenderPreparationResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(confirmTenderPreparationResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(confirmTenderPreparationResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(confirmTenderPreparationResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(confirmTenderPreparationResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(confirmTenderPreparationResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(confirmTenderPreparationResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(confirmTenderPreparationResponseAccountReviewAnnualRevenueMin).max(confirmTenderPreparationResponseAccountReviewAnnualRevenueMax).multipleOf(confirmTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(confirmTenderPreparationResponseAccountReviewNumberOfEmployeesMin).max(confirmTenderPreparationResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


export const confirmTenderPreparationAccountParams = zod.object({
  "id": zod.uuid()
})

export const confirmTenderPreparationAccountBodyHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const confirmTenderPreparationAccountBody = zod.object({
  "hash": zod.string().regex(confirmTenderPreparationAccountBodyHashRegExp)
})


export const confirmTenderPreparationAccountResponseFilesItemFilenameMax = 1024;

export const confirmTenderPreparationAccountResponseFilesItemContentHashMax = 64;

export const confirmTenderPreparationAccountResponseFilesItemWarningsItemMax = 500;

export const confirmTenderPreparationAccountResponseFilesItemWarningsMax = 110;

export const confirmTenderPreparationAccountResponseFilesItemLocationsItemMax = 300;

export const confirmTenderPreparationAccountResponseFilesItemLocationsMax = 250;

export const confirmTenderPreparationAccountResponseFilesMax = 25;

export const confirmTenderPreparationAccountResponseMetadataTypeSuggestionExplanationMax = 1000;

export const confirmTenderPreparationAccountResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const confirmTenderPreparationAccountResponseMetadataTypeSuggestionCitationsMax = 20;

export const confirmTenderPreparationAccountResponseMetadataTitleMax = 300;

export const confirmTenderPreparationAccountResponseMetadataBuyerMax = 300;

export const confirmTenderPreparationAccountResponseMetadataReferenceMax = 200;

export const confirmTenderPreparationAccountResponseMetadataSummaryMax = 10000;

export const confirmTenderPreparationAccountResponseMetadataDatesItemKindMax = 100;

export const confirmTenderPreparationAccountResponseMetadataDatesItemValueMax = 200;

export const confirmTenderPreparationAccountResponseMetadataDatesItemTimezoneMax = 100;

export const confirmTenderPreparationAccountResponseMetadataDatesItemPrecisionMax = 100;

export const confirmTenderPreparationAccountResponseMetadataDatesItemCitationsItemMax = 100;

export const confirmTenderPreparationAccountResponseMetadataDatesItemCitationsMax = 20;

export const confirmTenderPreparationAccountResponseMetadataDatesMax = 100;

export const confirmTenderPreparationAccountResponseMetadataCriteriaItemIdMax = 100;

export const confirmTenderPreparationAccountResponseMetadataCriteriaItemDescriptionMax = 10000;

export const confirmTenderPreparationAccountResponseMetadataCriteriaItemWeightMax = 100;

export const confirmTenderPreparationAccountResponseMetadataCriteriaItemResponseLimitMax = 200;

export const confirmTenderPreparationAccountResponseMetadataCriteriaItemCitationsItemMax = 100;

export const confirmTenderPreparationAccountResponseMetadataCriteriaItemCitationsMax = 20;

export const confirmTenderPreparationAccountResponseMetadataCriteriaMax = 100;

export const confirmTenderPreparationAccountResponseMetadataObligationsItemMax = 2000;

export const confirmTenderPreparationAccountResponseMetadataObligationsMax = 100;

export const confirmTenderPreparationAccountResponseMetadataMissingDocumentsItemMax = 1000;

export const confirmTenderPreparationAccountResponseMetadataMissingDocumentsMax = 100;

export const confirmTenderPreparationAccountResponseMetadataQaItemMax = 5000;

export const confirmTenderPreparationAccountResponseMetadataQaMax = 100;

export const confirmTenderPreparationAccountResponseMetadataWarningsItemMax = 1000;

export const confirmTenderPreparationAccountResponseMetadataWarningsMax = 100;


export const confirmTenderPreparationAccountResponseMatchesMax = 2;

export const confirmTenderPreparationAccountResponseWarningsItemMax = 1000;

export const confirmTenderPreparationAccountResponseWarningsMax = 100;

export const confirmTenderPreparationAccountResponseReviewFieldsTitleMax = 300;

export const confirmTenderPreparationAccountResponseReviewFieldsBriefingMdMax = 50000;

export const confirmTenderPreparationAccountResponseReviewFieldsSelectedOutputKindsMax = 4;

export const confirmTenderPreparationAccountResponseReviewSelectedFilesMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const confirmTenderPreparationAccountResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const confirmTenderPreparationAccountResponseReviewMetadataTitleMax = 300;

export const confirmTenderPreparationAccountResponseReviewMetadataBuyerMax = 300;

export const confirmTenderPreparationAccountResponseReviewMetadataReferenceMax = 200;

export const confirmTenderPreparationAccountResponseReviewMetadataSummaryMax = 10000;

export const confirmTenderPreparationAccountResponseReviewMetadataDatesItemKindMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataDatesItemValueMax = 200;

export const confirmTenderPreparationAccountResponseReviewMetadataDatesItemTimezoneMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataDatesItemPrecisionMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataDatesItemCitationsMax = 20;

export const confirmTenderPreparationAccountResponseReviewMetadataDatesMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemIdMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemWeightMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const confirmTenderPreparationAccountResponseReviewMetadataCriteriaMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataObligationsItemMax = 2000;

export const confirmTenderPreparationAccountResponseReviewMetadataObligationsMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const confirmTenderPreparationAccountResponseReviewMetadataMissingDocumentsMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataQaItemMax = 5000;

export const confirmTenderPreparationAccountResponseReviewMetadataQaMax = 100;

export const confirmTenderPreparationAccountResponseReviewMetadataWarningsItemMax = 1000;

export const confirmTenderPreparationAccountResponseReviewMetadataWarningsMax = 100;

export const confirmTenderPreparationAccountResponseReviewSourceLabelsMax = 100;


export const confirmTenderPreparationAccountResponseReviewProposalReviewDestructiveDefault = false;
export const confirmTenderPreparationAccountResponseReceiptSourcesMax = 100;

export const confirmTenderPreparationAccountResponseAccountReviewWebsiteMax = 2000;

export const confirmTenderPreparationAccountResponseAccountReviewIndustryMax = 200;

export const confirmTenderPreparationAccountResponseAccountReviewPhoneMax = 100;

export const confirmTenderPreparationAccountResponseAccountReviewEmailMax = 320;

export const confirmTenderPreparationAccountResponseAccountReviewEmailDomainMax = 253;

export const confirmTenderPreparationAccountResponseAccountReviewAddressLine1Max = 500;

export const confirmTenderPreparationAccountResponseAccountReviewCityMax = 200;

export const confirmTenderPreparationAccountResponseAccountReviewStateProvinceMax = 200;

export const confirmTenderPreparationAccountResponseAccountReviewPostcodeMax = 50;

export const confirmTenderPreparationAccountResponseAccountReviewCountryMax = 200;

export const confirmTenderPreparationAccountResponseAccountReviewNotesMax = 10000;

export const confirmTenderPreparationAccountResponseAccountReviewAnnualRevenueMin = 0;
export const confirmTenderPreparationAccountResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const confirmTenderPreparationAccountResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const confirmTenderPreparationAccountResponseAccountReviewNumberOfEmployeesMin = 0;
export const confirmTenderPreparationAccountResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const confirmTenderPreparationAccountResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(confirmTenderPreparationAccountResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(confirmTenderPreparationAccountResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(confirmTenderPreparationAccountResponseFilesItemWarningsItemMax)).max(confirmTenderPreparationAccountResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(confirmTenderPreparationAccountResponseFilesItemLocationsItemMax)).max(confirmTenderPreparationAccountResponseFilesItemLocationsMax)
})).max(confirmTenderPreparationAccountResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(confirmTenderPreparationAccountResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationAccountResponseMetadataTypeSuggestionCitationsItemMax)).max(confirmTenderPreparationAccountResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(confirmTenderPreparationAccountResponseMetadataTitleMax),
  "buyer": zod.string().max(confirmTenderPreparationAccountResponseMetadataBuyerMax),
  "reference": zod.string().max(confirmTenderPreparationAccountResponseMetadataReferenceMax),
  "summary": zod.string().max(confirmTenderPreparationAccountResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(confirmTenderPreparationAccountResponseMetadataDatesItemKindMax),
  "value": zod.string().max(confirmTenderPreparationAccountResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(confirmTenderPreparationAccountResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(confirmTenderPreparationAccountResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationAccountResponseMetadataDatesItemCitationsItemMax)).min(1).max(confirmTenderPreparationAccountResponseMetadataDatesItemCitationsMax)
})).max(confirmTenderPreparationAccountResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(confirmTenderPreparationAccountResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(confirmTenderPreparationAccountResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(confirmTenderPreparationAccountResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(confirmTenderPreparationAccountResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationAccountResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(confirmTenderPreparationAccountResponseMetadataCriteriaItemCitationsMax)
})).max(confirmTenderPreparationAccountResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(confirmTenderPreparationAccountResponseMetadataObligationsItemMax)).max(confirmTenderPreparationAccountResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(confirmTenderPreparationAccountResponseMetadataMissingDocumentsItemMax)).max(confirmTenderPreparationAccountResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(confirmTenderPreparationAccountResponseMetadataQaItemMax)).max(confirmTenderPreparationAccountResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(confirmTenderPreparationAccountResponseMetadataWarningsItemMax)).max(confirmTenderPreparationAccountResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(confirmTenderPreparationAccountResponseMatchesMax),
  "warnings": zod.array(zod.string().max(confirmTenderPreparationAccountResponseWarningsItemMax)).max(confirmTenderPreparationAccountResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(confirmTenderPreparationAccountResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(confirmTenderPreparationAccountResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(confirmTenderPreparationAccountResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(confirmTenderPreparationAccountResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(confirmTenderPreparationAccountResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(confirmTenderPreparationAccountResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(confirmTenderPreparationAccountResponseReviewMetadataDatesItemCitationsMax)
})).max(confirmTenderPreparationAccountResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(confirmTenderPreparationAccountResponseReviewMetadataCriteriaItemCitationsMax)
})).max(confirmTenderPreparationAccountResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataObligationsItemMax)).max(confirmTenderPreparationAccountResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataMissingDocumentsItemMax)).max(confirmTenderPreparationAccountResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataQaItemMax)).max(confirmTenderPreparationAccountResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(confirmTenderPreparationAccountResponseReviewMetadataWarningsItemMax)).max(confirmTenderPreparationAccountResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(confirmTenderPreparationAccountResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(confirmTenderPreparationAccountResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(confirmTenderPreparationAccountResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(confirmTenderPreparationAccountResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(confirmTenderPreparationAccountResponseAccountReviewAnnualRevenueMin).max(confirmTenderPreparationAccountResponseAccountReviewAnnualRevenueMax).multipleOf(confirmTenderPreparationAccountResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(confirmTenderPreparationAccountResponseAccountReviewNumberOfEmployeesMin).max(confirmTenderPreparationAccountResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


export const cancelTenderPreparationReviewParams = zod.object({
  "id": zod.uuid()
})

export const cancelTenderPreparationReviewBodyHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const cancelTenderPreparationReviewBody = zod.object({
  "hash": zod.string().regex(cancelTenderPreparationReviewBodyHashRegExp)
})


export const cancelTenderPreparationReviewResponseFilesItemFilenameMax = 1024;

export const cancelTenderPreparationReviewResponseFilesItemContentHashMax = 64;

export const cancelTenderPreparationReviewResponseFilesItemWarningsItemMax = 500;

export const cancelTenderPreparationReviewResponseFilesItemWarningsMax = 110;

export const cancelTenderPreparationReviewResponseFilesItemLocationsItemMax = 300;

export const cancelTenderPreparationReviewResponseFilesItemLocationsMax = 250;

export const cancelTenderPreparationReviewResponseFilesMax = 25;

export const cancelTenderPreparationReviewResponseMetadataTypeSuggestionExplanationMax = 1000;

export const cancelTenderPreparationReviewResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const cancelTenderPreparationReviewResponseMetadataTypeSuggestionCitationsMax = 20;

export const cancelTenderPreparationReviewResponseMetadataTitleMax = 300;

export const cancelTenderPreparationReviewResponseMetadataBuyerMax = 300;

export const cancelTenderPreparationReviewResponseMetadataReferenceMax = 200;

export const cancelTenderPreparationReviewResponseMetadataSummaryMax = 10000;

export const cancelTenderPreparationReviewResponseMetadataDatesItemKindMax = 100;

export const cancelTenderPreparationReviewResponseMetadataDatesItemValueMax = 200;

export const cancelTenderPreparationReviewResponseMetadataDatesItemTimezoneMax = 100;

export const cancelTenderPreparationReviewResponseMetadataDatesItemPrecisionMax = 100;

export const cancelTenderPreparationReviewResponseMetadataDatesItemCitationsItemMax = 100;

export const cancelTenderPreparationReviewResponseMetadataDatesItemCitationsMax = 20;

export const cancelTenderPreparationReviewResponseMetadataDatesMax = 100;

export const cancelTenderPreparationReviewResponseMetadataCriteriaItemIdMax = 100;

export const cancelTenderPreparationReviewResponseMetadataCriteriaItemDescriptionMax = 10000;

export const cancelTenderPreparationReviewResponseMetadataCriteriaItemWeightMax = 100;

export const cancelTenderPreparationReviewResponseMetadataCriteriaItemResponseLimitMax = 200;

export const cancelTenderPreparationReviewResponseMetadataCriteriaItemCitationsItemMax = 100;

export const cancelTenderPreparationReviewResponseMetadataCriteriaItemCitationsMax = 20;

export const cancelTenderPreparationReviewResponseMetadataCriteriaMax = 100;

export const cancelTenderPreparationReviewResponseMetadataObligationsItemMax = 2000;

export const cancelTenderPreparationReviewResponseMetadataObligationsMax = 100;

export const cancelTenderPreparationReviewResponseMetadataMissingDocumentsItemMax = 1000;

export const cancelTenderPreparationReviewResponseMetadataMissingDocumentsMax = 100;

export const cancelTenderPreparationReviewResponseMetadataQaItemMax = 5000;

export const cancelTenderPreparationReviewResponseMetadataQaMax = 100;

export const cancelTenderPreparationReviewResponseMetadataWarningsItemMax = 1000;

export const cancelTenderPreparationReviewResponseMetadataWarningsMax = 100;


export const cancelTenderPreparationReviewResponseMatchesMax = 2;

export const cancelTenderPreparationReviewResponseWarningsItemMax = 1000;

export const cancelTenderPreparationReviewResponseWarningsMax = 100;

export const cancelTenderPreparationReviewResponseReviewFieldsTitleMax = 300;

export const cancelTenderPreparationReviewResponseReviewFieldsBriefingMdMax = 50000;

export const cancelTenderPreparationReviewResponseReviewFieldsSelectedOutputKindsMax = 4;

export const cancelTenderPreparationReviewResponseReviewSelectedFilesMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const cancelTenderPreparationReviewResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const cancelTenderPreparationReviewResponseReviewMetadataTitleMax = 300;

export const cancelTenderPreparationReviewResponseReviewMetadataBuyerMax = 300;

export const cancelTenderPreparationReviewResponseReviewMetadataReferenceMax = 200;

export const cancelTenderPreparationReviewResponseReviewMetadataSummaryMax = 10000;

export const cancelTenderPreparationReviewResponseReviewMetadataDatesItemKindMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataDatesItemValueMax = 200;

export const cancelTenderPreparationReviewResponseReviewMetadataDatesItemTimezoneMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataDatesItemPrecisionMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataDatesItemCitationsMax = 20;

export const cancelTenderPreparationReviewResponseReviewMetadataDatesMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemIdMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemWeightMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const cancelTenderPreparationReviewResponseReviewMetadataCriteriaMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataObligationsItemMax = 2000;

export const cancelTenderPreparationReviewResponseReviewMetadataObligationsMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const cancelTenderPreparationReviewResponseReviewMetadataMissingDocumentsMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataQaItemMax = 5000;

export const cancelTenderPreparationReviewResponseReviewMetadataQaMax = 100;

export const cancelTenderPreparationReviewResponseReviewMetadataWarningsItemMax = 1000;

export const cancelTenderPreparationReviewResponseReviewMetadataWarningsMax = 100;

export const cancelTenderPreparationReviewResponseReviewSourceLabelsMax = 100;


export const cancelTenderPreparationReviewResponseReviewProposalReviewDestructiveDefault = false;
export const cancelTenderPreparationReviewResponseReceiptSourcesMax = 100;

export const cancelTenderPreparationReviewResponseAccountReviewWebsiteMax = 2000;

export const cancelTenderPreparationReviewResponseAccountReviewIndustryMax = 200;

export const cancelTenderPreparationReviewResponseAccountReviewPhoneMax = 100;

export const cancelTenderPreparationReviewResponseAccountReviewEmailMax = 320;

export const cancelTenderPreparationReviewResponseAccountReviewEmailDomainMax = 253;

export const cancelTenderPreparationReviewResponseAccountReviewAddressLine1Max = 500;

export const cancelTenderPreparationReviewResponseAccountReviewCityMax = 200;

export const cancelTenderPreparationReviewResponseAccountReviewStateProvinceMax = 200;

export const cancelTenderPreparationReviewResponseAccountReviewPostcodeMax = 50;

export const cancelTenderPreparationReviewResponseAccountReviewCountryMax = 200;

export const cancelTenderPreparationReviewResponseAccountReviewNotesMax = 10000;

export const cancelTenderPreparationReviewResponseAccountReviewAnnualRevenueMin = 0;
export const cancelTenderPreparationReviewResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const cancelTenderPreparationReviewResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const cancelTenderPreparationReviewResponseAccountReviewNumberOfEmployeesMin = 0;
export const cancelTenderPreparationReviewResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const cancelTenderPreparationReviewResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(cancelTenderPreparationReviewResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(cancelTenderPreparationReviewResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(cancelTenderPreparationReviewResponseFilesItemWarningsItemMax)).max(cancelTenderPreparationReviewResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(cancelTenderPreparationReviewResponseFilesItemLocationsItemMax)).max(cancelTenderPreparationReviewResponseFilesItemLocationsMax)
})).max(cancelTenderPreparationReviewResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(cancelTenderPreparationReviewResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(cancelTenderPreparationReviewResponseMetadataTypeSuggestionCitationsItemMax)).max(cancelTenderPreparationReviewResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(cancelTenderPreparationReviewResponseMetadataTitleMax),
  "buyer": zod.string().max(cancelTenderPreparationReviewResponseMetadataBuyerMax),
  "reference": zod.string().max(cancelTenderPreparationReviewResponseMetadataReferenceMax),
  "summary": zod.string().max(cancelTenderPreparationReviewResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(cancelTenderPreparationReviewResponseMetadataDatesItemKindMax),
  "value": zod.string().max(cancelTenderPreparationReviewResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(cancelTenderPreparationReviewResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(cancelTenderPreparationReviewResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(cancelTenderPreparationReviewResponseMetadataDatesItemCitationsItemMax)).min(1).max(cancelTenderPreparationReviewResponseMetadataDatesItemCitationsMax)
})).max(cancelTenderPreparationReviewResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(cancelTenderPreparationReviewResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(cancelTenderPreparationReviewResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(cancelTenderPreparationReviewResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(cancelTenderPreparationReviewResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(cancelTenderPreparationReviewResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(cancelTenderPreparationReviewResponseMetadataCriteriaItemCitationsMax)
})).max(cancelTenderPreparationReviewResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(cancelTenderPreparationReviewResponseMetadataObligationsItemMax)).max(cancelTenderPreparationReviewResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(cancelTenderPreparationReviewResponseMetadataMissingDocumentsItemMax)).max(cancelTenderPreparationReviewResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(cancelTenderPreparationReviewResponseMetadataQaItemMax)).max(cancelTenderPreparationReviewResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(cancelTenderPreparationReviewResponseMetadataWarningsItemMax)).max(cancelTenderPreparationReviewResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(cancelTenderPreparationReviewResponseMatchesMax),
  "warnings": zod.array(zod.string().max(cancelTenderPreparationReviewResponseWarningsItemMax)).max(cancelTenderPreparationReviewResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(cancelTenderPreparationReviewResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(cancelTenderPreparationReviewResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(cancelTenderPreparationReviewResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(cancelTenderPreparationReviewResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(cancelTenderPreparationReviewResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(cancelTenderPreparationReviewResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(cancelTenderPreparationReviewResponseReviewMetadataDatesItemCitationsMax)
})).max(cancelTenderPreparationReviewResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(cancelTenderPreparationReviewResponseReviewMetadataCriteriaItemCitationsMax)
})).max(cancelTenderPreparationReviewResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataObligationsItemMax)).max(cancelTenderPreparationReviewResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataMissingDocumentsItemMax)).max(cancelTenderPreparationReviewResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataQaItemMax)).max(cancelTenderPreparationReviewResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(cancelTenderPreparationReviewResponseReviewMetadataWarningsItemMax)).max(cancelTenderPreparationReviewResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(cancelTenderPreparationReviewResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(cancelTenderPreparationReviewResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(cancelTenderPreparationReviewResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(cancelTenderPreparationReviewResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(cancelTenderPreparationReviewResponseAccountReviewAnnualRevenueMin).max(cancelTenderPreparationReviewResponseAccountReviewAnnualRevenueMax).multipleOf(cancelTenderPreparationReviewResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(cancelTenderPreparationReviewResponseAccountReviewNumberOfEmployeesMin).max(cancelTenderPreparationReviewResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


export const adoptTenderPreparationParams = zod.object({
  "id": zod.uuid()
})


export const adoptTenderPreparationResponseFilesItemFilenameMax = 1024;

export const adoptTenderPreparationResponseFilesItemContentHashMax = 64;

export const adoptTenderPreparationResponseFilesItemWarningsItemMax = 500;

export const adoptTenderPreparationResponseFilesItemWarningsMax = 110;

export const adoptTenderPreparationResponseFilesItemLocationsItemMax = 300;

export const adoptTenderPreparationResponseFilesItemLocationsMax = 250;

export const adoptTenderPreparationResponseFilesMax = 25;

export const adoptTenderPreparationResponseMetadataTypeSuggestionExplanationMax = 1000;

export const adoptTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const adoptTenderPreparationResponseMetadataTypeSuggestionCitationsMax = 20;

export const adoptTenderPreparationResponseMetadataTitleMax = 300;

export const adoptTenderPreparationResponseMetadataBuyerMax = 300;

export const adoptTenderPreparationResponseMetadataReferenceMax = 200;

export const adoptTenderPreparationResponseMetadataSummaryMax = 10000;

export const adoptTenderPreparationResponseMetadataDatesItemKindMax = 100;

export const adoptTenderPreparationResponseMetadataDatesItemValueMax = 200;

export const adoptTenderPreparationResponseMetadataDatesItemTimezoneMax = 100;

export const adoptTenderPreparationResponseMetadataDatesItemPrecisionMax = 100;

export const adoptTenderPreparationResponseMetadataDatesItemCitationsItemMax = 100;

export const adoptTenderPreparationResponseMetadataDatesItemCitationsMax = 20;

export const adoptTenderPreparationResponseMetadataDatesMax = 100;

export const adoptTenderPreparationResponseMetadataCriteriaItemIdMax = 100;

export const adoptTenderPreparationResponseMetadataCriteriaItemDescriptionMax = 10000;

export const adoptTenderPreparationResponseMetadataCriteriaItemWeightMax = 100;

export const adoptTenderPreparationResponseMetadataCriteriaItemResponseLimitMax = 200;

export const adoptTenderPreparationResponseMetadataCriteriaItemCitationsItemMax = 100;

export const adoptTenderPreparationResponseMetadataCriteriaItemCitationsMax = 20;

export const adoptTenderPreparationResponseMetadataCriteriaMax = 100;

export const adoptTenderPreparationResponseMetadataObligationsItemMax = 2000;

export const adoptTenderPreparationResponseMetadataObligationsMax = 100;

export const adoptTenderPreparationResponseMetadataMissingDocumentsItemMax = 1000;

export const adoptTenderPreparationResponseMetadataMissingDocumentsMax = 100;

export const adoptTenderPreparationResponseMetadataQaItemMax = 5000;

export const adoptTenderPreparationResponseMetadataQaMax = 100;

export const adoptTenderPreparationResponseMetadataWarningsItemMax = 1000;

export const adoptTenderPreparationResponseMetadataWarningsMax = 100;


export const adoptTenderPreparationResponseMatchesMax = 2;

export const adoptTenderPreparationResponseWarningsItemMax = 1000;

export const adoptTenderPreparationResponseWarningsMax = 100;

export const adoptTenderPreparationResponseReviewFieldsTitleMax = 300;

export const adoptTenderPreparationResponseReviewFieldsBriefingMdMax = 50000;

export const adoptTenderPreparationResponseReviewFieldsSelectedOutputKindsMax = 4;

export const adoptTenderPreparationResponseReviewSelectedFilesMax = 100;

export const adoptTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const adoptTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const adoptTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const adoptTenderPreparationResponseReviewMetadataTitleMax = 300;

export const adoptTenderPreparationResponseReviewMetadataBuyerMax = 300;

export const adoptTenderPreparationResponseReviewMetadataReferenceMax = 200;

export const adoptTenderPreparationResponseReviewMetadataSummaryMax = 10000;

export const adoptTenderPreparationResponseReviewMetadataDatesItemKindMax = 100;

export const adoptTenderPreparationResponseReviewMetadataDatesItemValueMax = 200;

export const adoptTenderPreparationResponseReviewMetadataDatesItemTimezoneMax = 100;

export const adoptTenderPreparationResponseReviewMetadataDatesItemPrecisionMax = 100;

export const adoptTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const adoptTenderPreparationResponseReviewMetadataDatesItemCitationsMax = 20;

export const adoptTenderPreparationResponseReviewMetadataDatesMax = 100;

export const adoptTenderPreparationResponseReviewMetadataCriteriaItemIdMax = 100;

export const adoptTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const adoptTenderPreparationResponseReviewMetadataCriteriaItemWeightMax = 100;

export const adoptTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const adoptTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const adoptTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const adoptTenderPreparationResponseReviewMetadataCriteriaMax = 100;

export const adoptTenderPreparationResponseReviewMetadataObligationsItemMax = 2000;

export const adoptTenderPreparationResponseReviewMetadataObligationsMax = 100;

export const adoptTenderPreparationResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const adoptTenderPreparationResponseReviewMetadataMissingDocumentsMax = 100;

export const adoptTenderPreparationResponseReviewMetadataQaItemMax = 5000;

export const adoptTenderPreparationResponseReviewMetadataQaMax = 100;

export const adoptTenderPreparationResponseReviewMetadataWarningsItemMax = 1000;

export const adoptTenderPreparationResponseReviewMetadataWarningsMax = 100;

export const adoptTenderPreparationResponseReviewSourceLabelsMax = 100;


export const adoptTenderPreparationResponseReviewProposalReviewDestructiveDefault = false;
export const adoptTenderPreparationResponseReceiptSourcesMax = 100;

export const adoptTenderPreparationResponseAccountReviewWebsiteMax = 2000;

export const adoptTenderPreparationResponseAccountReviewIndustryMax = 200;

export const adoptTenderPreparationResponseAccountReviewPhoneMax = 100;

export const adoptTenderPreparationResponseAccountReviewEmailMax = 320;

export const adoptTenderPreparationResponseAccountReviewEmailDomainMax = 253;

export const adoptTenderPreparationResponseAccountReviewAddressLine1Max = 500;

export const adoptTenderPreparationResponseAccountReviewCityMax = 200;

export const adoptTenderPreparationResponseAccountReviewStateProvinceMax = 200;

export const adoptTenderPreparationResponseAccountReviewPostcodeMax = 50;

export const adoptTenderPreparationResponseAccountReviewCountryMax = 200;

export const adoptTenderPreparationResponseAccountReviewNotesMax = 10000;

export const adoptTenderPreparationResponseAccountReviewAnnualRevenueMin = 0;
export const adoptTenderPreparationResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const adoptTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const adoptTenderPreparationResponseAccountReviewNumberOfEmployeesMin = 0;
export const adoptTenderPreparationResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const adoptTenderPreparationResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(adoptTenderPreparationResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(adoptTenderPreparationResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(adoptTenderPreparationResponseFilesItemWarningsItemMax)).max(adoptTenderPreparationResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(adoptTenderPreparationResponseFilesItemLocationsItemMax)).max(adoptTenderPreparationResponseFilesItemLocationsMax)
})).max(adoptTenderPreparationResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(adoptTenderPreparationResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(adoptTenderPreparationResponseMetadataTypeSuggestionCitationsItemMax)).max(adoptTenderPreparationResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(adoptTenderPreparationResponseMetadataTitleMax),
  "buyer": zod.string().max(adoptTenderPreparationResponseMetadataBuyerMax),
  "reference": zod.string().max(adoptTenderPreparationResponseMetadataReferenceMax),
  "summary": zod.string().max(adoptTenderPreparationResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(adoptTenderPreparationResponseMetadataDatesItemKindMax),
  "value": zod.string().max(adoptTenderPreparationResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(adoptTenderPreparationResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(adoptTenderPreparationResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(adoptTenderPreparationResponseMetadataDatesItemCitationsItemMax)).min(1).max(adoptTenderPreparationResponseMetadataDatesItemCitationsMax)
})).max(adoptTenderPreparationResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(adoptTenderPreparationResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(adoptTenderPreparationResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(adoptTenderPreparationResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(adoptTenderPreparationResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(adoptTenderPreparationResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(adoptTenderPreparationResponseMetadataCriteriaItemCitationsMax)
})).max(adoptTenderPreparationResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(adoptTenderPreparationResponseMetadataObligationsItemMax)).max(adoptTenderPreparationResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(adoptTenderPreparationResponseMetadataMissingDocumentsItemMax)).max(adoptTenderPreparationResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(adoptTenderPreparationResponseMetadataQaItemMax)).max(adoptTenderPreparationResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(adoptTenderPreparationResponseMetadataWarningsItemMax)).max(adoptTenderPreparationResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(adoptTenderPreparationResponseMatchesMax),
  "warnings": zod.array(zod.string().max(adoptTenderPreparationResponseWarningsItemMax)).max(adoptTenderPreparationResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(adoptTenderPreparationResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(adoptTenderPreparationResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(adoptTenderPreparationResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(adoptTenderPreparationResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(adoptTenderPreparationResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(adoptTenderPreparationResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(adoptTenderPreparationResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(adoptTenderPreparationResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(adoptTenderPreparationResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(adoptTenderPreparationResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(adoptTenderPreparationResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(adoptTenderPreparationResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(adoptTenderPreparationResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(adoptTenderPreparationResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(adoptTenderPreparationResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(adoptTenderPreparationResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(adoptTenderPreparationResponseReviewMetadataDatesItemCitationsMax)
})).max(adoptTenderPreparationResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(adoptTenderPreparationResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(adoptTenderPreparationResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(adoptTenderPreparationResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(adoptTenderPreparationResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(adoptTenderPreparationResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(adoptTenderPreparationResponseReviewMetadataCriteriaItemCitationsMax)
})).max(adoptTenderPreparationResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(adoptTenderPreparationResponseReviewMetadataObligationsItemMax)).max(adoptTenderPreparationResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(adoptTenderPreparationResponseReviewMetadataMissingDocumentsItemMax)).max(adoptTenderPreparationResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(adoptTenderPreparationResponseReviewMetadataQaItemMax)).max(adoptTenderPreparationResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(adoptTenderPreparationResponseReviewMetadataWarningsItemMax)).max(adoptTenderPreparationResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(adoptTenderPreparationResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(adoptTenderPreparationResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(adoptTenderPreparationResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(adoptTenderPreparationResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(adoptTenderPreparationResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(adoptTenderPreparationResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(adoptTenderPreparationResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(adoptTenderPreparationResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(adoptTenderPreparationResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(adoptTenderPreparationResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(adoptTenderPreparationResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(adoptTenderPreparationResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(adoptTenderPreparationResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(adoptTenderPreparationResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(adoptTenderPreparationResponseAccountReviewAnnualRevenueMin).max(adoptTenderPreparationResponseAccountReviewAnnualRevenueMax).multipleOf(adoptTenderPreparationResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(adoptTenderPreparationResponseAccountReviewNumberOfEmployeesMin).max(adoptTenderPreparationResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


export const reviewTenderPreparationAccountParams = zod.object({
  "id": zod.uuid()
})

export const reviewTenderPreparationAccountBodyNameMax = 200;

export const reviewTenderPreparationAccountBodyWebsiteMax = 2000;

export const reviewTenderPreparationAccountBodyIndustryMax = 200;

export const reviewTenderPreparationAccountBodyPhoneMax = 100;

export const reviewTenderPreparationAccountBodyEmailMax = 320;

export const reviewTenderPreparationAccountBodyEmailDomainMax = 253;

export const reviewTenderPreparationAccountBodyAddressLine1Max = 500;

export const reviewTenderPreparationAccountBodyCityMax = 200;

export const reviewTenderPreparationAccountBodyStateProvinceMax = 200;

export const reviewTenderPreparationAccountBodyPostcodeMax = 50;

export const reviewTenderPreparationAccountBodyCountryMax = 200;

export const reviewTenderPreparationAccountBodyNotesMax = 10000;

export const reviewTenderPreparationAccountBodyAnnualRevenueMin = 0;
export const reviewTenderPreparationAccountBodyAnnualRevenueMax = 99999999999999;
export const reviewTenderPreparationAccountBodyAnnualRevenueMultipleOf = 0.01;

export const reviewTenderPreparationAccountBodyNumberOfEmployeesMin = 0;
export const reviewTenderPreparationAccountBodyNumberOfEmployeesMax = 2147483647;



export const reviewTenderPreparationAccountBody = zod.object({
  "name": zod.string().min(1).max(reviewTenderPreparationAccountBodyNameMax),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(reviewTenderPreparationAccountBodyWebsiteMax).nullish(),
  "industry": zod.string().max(reviewTenderPreparationAccountBodyIndustryMax).nullish(),
  "phone": zod.string().max(reviewTenderPreparationAccountBodyPhoneMax).nullish(),
  "email": zod.string().max(reviewTenderPreparationAccountBodyEmailMax).nullish(),
  "emailDomain": zod.string().max(reviewTenderPreparationAccountBodyEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(reviewTenderPreparationAccountBodyAddressLine1Max).nullish(),
  "city": zod.string().max(reviewTenderPreparationAccountBodyCityMax).nullish(),
  "stateProvince": zod.string().max(reviewTenderPreparationAccountBodyStateProvinceMax).nullish(),
  "postcode": zod.string().max(reviewTenderPreparationAccountBodyPostcodeMax).nullish(),
  "country": zod.string().max(reviewTenderPreparationAccountBodyCountryMax).nullish(),
  "notes": zod.string().max(reviewTenderPreparationAccountBodyNotesMax).nullish(),
  "annualRevenue": zod.number().min(reviewTenderPreparationAccountBodyAnnualRevenueMin).max(reviewTenderPreparationAccountBodyAnnualRevenueMax).multipleOf(reviewTenderPreparationAccountBodyAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(reviewTenderPreparationAccountBodyNumberOfEmployeesMin).max(reviewTenderPreparationAccountBodyNumberOfEmployeesMax).nullish()
})


export const reviewTenderPreparationAccountResponseFilesItemFilenameMax = 1024;

export const reviewTenderPreparationAccountResponseFilesItemContentHashMax = 64;

export const reviewTenderPreparationAccountResponseFilesItemWarningsItemMax = 500;

export const reviewTenderPreparationAccountResponseFilesItemWarningsMax = 110;

export const reviewTenderPreparationAccountResponseFilesItemLocationsItemMax = 300;

export const reviewTenderPreparationAccountResponseFilesItemLocationsMax = 250;

export const reviewTenderPreparationAccountResponseFilesMax = 25;

export const reviewTenderPreparationAccountResponseMetadataTypeSuggestionExplanationMax = 1000;

export const reviewTenderPreparationAccountResponseMetadataTypeSuggestionCitationsItemMax = 100;

export const reviewTenderPreparationAccountResponseMetadataTypeSuggestionCitationsMax = 20;

export const reviewTenderPreparationAccountResponseMetadataTitleMax = 300;

export const reviewTenderPreparationAccountResponseMetadataBuyerMax = 300;

export const reviewTenderPreparationAccountResponseMetadataReferenceMax = 200;

export const reviewTenderPreparationAccountResponseMetadataSummaryMax = 10000;

export const reviewTenderPreparationAccountResponseMetadataDatesItemKindMax = 100;

export const reviewTenderPreparationAccountResponseMetadataDatesItemValueMax = 200;

export const reviewTenderPreparationAccountResponseMetadataDatesItemTimezoneMax = 100;

export const reviewTenderPreparationAccountResponseMetadataDatesItemPrecisionMax = 100;

export const reviewTenderPreparationAccountResponseMetadataDatesItemCitationsItemMax = 100;

export const reviewTenderPreparationAccountResponseMetadataDatesItemCitationsMax = 20;

export const reviewTenderPreparationAccountResponseMetadataDatesMax = 100;

export const reviewTenderPreparationAccountResponseMetadataCriteriaItemIdMax = 100;

export const reviewTenderPreparationAccountResponseMetadataCriteriaItemDescriptionMax = 10000;

export const reviewTenderPreparationAccountResponseMetadataCriteriaItemWeightMax = 100;

export const reviewTenderPreparationAccountResponseMetadataCriteriaItemResponseLimitMax = 200;

export const reviewTenderPreparationAccountResponseMetadataCriteriaItemCitationsItemMax = 100;

export const reviewTenderPreparationAccountResponseMetadataCriteriaItemCitationsMax = 20;

export const reviewTenderPreparationAccountResponseMetadataCriteriaMax = 100;

export const reviewTenderPreparationAccountResponseMetadataObligationsItemMax = 2000;

export const reviewTenderPreparationAccountResponseMetadataObligationsMax = 100;

export const reviewTenderPreparationAccountResponseMetadataMissingDocumentsItemMax = 1000;

export const reviewTenderPreparationAccountResponseMetadataMissingDocumentsMax = 100;

export const reviewTenderPreparationAccountResponseMetadataQaItemMax = 5000;

export const reviewTenderPreparationAccountResponseMetadataQaMax = 100;

export const reviewTenderPreparationAccountResponseMetadataWarningsItemMax = 1000;

export const reviewTenderPreparationAccountResponseMetadataWarningsMax = 100;


export const reviewTenderPreparationAccountResponseMatchesMax = 2;

export const reviewTenderPreparationAccountResponseWarningsItemMax = 1000;

export const reviewTenderPreparationAccountResponseWarningsMax = 100;

export const reviewTenderPreparationAccountResponseReviewFieldsTitleMax = 300;

export const reviewTenderPreparationAccountResponseReviewFieldsBriefingMdMax = 50000;

export const reviewTenderPreparationAccountResponseReviewFieldsSelectedOutputKindsMax = 4;

export const reviewTenderPreparationAccountResponseReviewSelectedFilesMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataTypeSuggestionExplanationMax = 1000;

export const reviewTenderPreparationAccountResponseReviewMetadataTypeSuggestionCitationsItemMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataTypeSuggestionCitationsMax = 20;

export const reviewTenderPreparationAccountResponseReviewMetadataTitleMax = 300;

export const reviewTenderPreparationAccountResponseReviewMetadataBuyerMax = 300;

export const reviewTenderPreparationAccountResponseReviewMetadataReferenceMax = 200;

export const reviewTenderPreparationAccountResponseReviewMetadataSummaryMax = 10000;

export const reviewTenderPreparationAccountResponseReviewMetadataDatesItemKindMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataDatesItemValueMax = 200;

export const reviewTenderPreparationAccountResponseReviewMetadataDatesItemTimezoneMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataDatesItemPrecisionMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataDatesItemCitationsItemMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataDatesItemCitationsMax = 20;

export const reviewTenderPreparationAccountResponseReviewMetadataDatesMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemIdMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemDescriptionMax = 10000;

export const reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemWeightMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemResponseLimitMax = 200;

export const reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemCitationsItemMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemCitationsMax = 20;

export const reviewTenderPreparationAccountResponseReviewMetadataCriteriaMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataObligationsItemMax = 2000;

export const reviewTenderPreparationAccountResponseReviewMetadataObligationsMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataMissingDocumentsItemMax = 1000;

export const reviewTenderPreparationAccountResponseReviewMetadataMissingDocumentsMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataQaItemMax = 5000;

export const reviewTenderPreparationAccountResponseReviewMetadataQaMax = 100;

export const reviewTenderPreparationAccountResponseReviewMetadataWarningsItemMax = 1000;

export const reviewTenderPreparationAccountResponseReviewMetadataWarningsMax = 100;

export const reviewTenderPreparationAccountResponseReviewSourceLabelsMax = 100;


export const reviewTenderPreparationAccountResponseReviewProposalReviewDestructiveDefault = false;
export const reviewTenderPreparationAccountResponseReceiptSourcesMax = 100;

export const reviewTenderPreparationAccountResponseAccountReviewWebsiteMax = 2000;

export const reviewTenderPreparationAccountResponseAccountReviewIndustryMax = 200;

export const reviewTenderPreparationAccountResponseAccountReviewPhoneMax = 100;

export const reviewTenderPreparationAccountResponseAccountReviewEmailMax = 320;

export const reviewTenderPreparationAccountResponseAccountReviewEmailDomainMax = 253;

export const reviewTenderPreparationAccountResponseAccountReviewAddressLine1Max = 500;

export const reviewTenderPreparationAccountResponseAccountReviewCityMax = 200;

export const reviewTenderPreparationAccountResponseAccountReviewStateProvinceMax = 200;

export const reviewTenderPreparationAccountResponseAccountReviewPostcodeMax = 50;

export const reviewTenderPreparationAccountResponseAccountReviewCountryMax = 200;

export const reviewTenderPreparationAccountResponseAccountReviewNotesMax = 10000;

export const reviewTenderPreparationAccountResponseAccountReviewAnnualRevenueMin = 0;
export const reviewTenderPreparationAccountResponseAccountReviewAnnualRevenueMax = 99999999999999;
export const reviewTenderPreparationAccountResponseAccountReviewAnnualRevenueMultipleOf = 0.01;

export const reviewTenderPreparationAccountResponseAccountReviewNumberOfEmployeesMin = 0;
export const reviewTenderPreparationAccountResponseAccountReviewNumberOfEmployeesMax = 2147483647;



export const reviewTenderPreparationAccountResponse = zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid().nullish(),
  "files": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string().max(reviewTenderPreparationAccountResponseFilesItemFilenameMax),
  "contentHash": zod.string().max(reviewTenderPreparationAccountResponseFilesItemContentHashMax),
  "status": zod.enum(['ready', 'partial', 'unsupported', 'failed']),
  "warnings": zod.array(zod.string().max(reviewTenderPreparationAccountResponseFilesItemWarningsItemMax)).max(reviewTenderPreparationAccountResponseFilesItemWarningsMax),
  "locations": zod.array(zod.string().max(reviewTenderPreparationAccountResponseFilesItemLocationsItemMax)).max(reviewTenderPreparationAccountResponseFilesItemLocationsMax)
})).max(reviewTenderPreparationAccountResponseFilesMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(reviewTenderPreparationAccountResponseMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationAccountResponseMetadataTypeSuggestionCitationsItemMax)).max(reviewTenderPreparationAccountResponseMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(reviewTenderPreparationAccountResponseMetadataTitleMax),
  "buyer": zod.string().max(reviewTenderPreparationAccountResponseMetadataBuyerMax),
  "reference": zod.string().max(reviewTenderPreparationAccountResponseMetadataReferenceMax),
  "summary": zod.string().max(reviewTenderPreparationAccountResponseMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(reviewTenderPreparationAccountResponseMetadataDatesItemKindMax),
  "value": zod.string().max(reviewTenderPreparationAccountResponseMetadataDatesItemValueMax),
  "timezone": zod.string().max(reviewTenderPreparationAccountResponseMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(reviewTenderPreparationAccountResponseMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationAccountResponseMetadataDatesItemCitationsItemMax)).min(1).max(reviewTenderPreparationAccountResponseMetadataDatesItemCitationsMax)
})).max(reviewTenderPreparationAccountResponseMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(reviewTenderPreparationAccountResponseMetadataCriteriaItemIdMax),
  "description": zod.string().max(reviewTenderPreparationAccountResponseMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(reviewTenderPreparationAccountResponseMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(reviewTenderPreparationAccountResponseMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationAccountResponseMetadataCriteriaItemCitationsItemMax)).min(1).max(reviewTenderPreparationAccountResponseMetadataCriteriaItemCitationsMax)
})).max(reviewTenderPreparationAccountResponseMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(reviewTenderPreparationAccountResponseMetadataObligationsItemMax)).max(reviewTenderPreparationAccountResponseMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(reviewTenderPreparationAccountResponseMetadataMissingDocumentsItemMax)).max(reviewTenderPreparationAccountResponseMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(reviewTenderPreparationAccountResponseMetadataQaItemMax)).max(reviewTenderPreparationAccountResponseMetadataQaMax),
  "warnings": zod.array(zod.string().max(reviewTenderPreparationAccountResponseMetadataWarningsItemMax)).max(reviewTenderPreparationAccountResponseMetadataWarningsMax)
}).optional(),
  "analysis": zod.object({
  "status": zod.enum(['pending', 'complete', 'failed']),
  "sourceRevision": zod.int().min(1)
}).optional(),
  "matches": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string()
})).max(reviewTenderPreparationAccountResponseMatchesMax),
  "warnings": zod.array(zod.string().max(reviewTenderPreparationAccountResponseWarningsItemMax)).max(reviewTenderPreparationAccountResponseWarningsMax),
  "review": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(reviewTenderPreparationAccountResponseReviewFieldsTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(reviewTenderPreparationAccountResponseReviewFieldsBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(reviewTenderPreparationAccountResponseReviewFieldsSelectedOutputKindsMax).optional()
}),
  "selectedFiles": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(reviewTenderPreparationAccountResponseReviewSelectedFilesMax),
  "consequence": zod.string(),
  "metadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(reviewTenderPreparationAccountResponseReviewMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataTypeSuggestionCitationsItemMax)).max(reviewTenderPreparationAccountResponseReviewMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataTitleMax),
  "buyer": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataBuyerMax),
  "reference": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataReferenceMax),
  "summary": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataDatesItemKindMax),
  "value": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataDatesItemValueMax),
  "timezone": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataDatesItemCitationsItemMax)).min(1).max(reviewTenderPreparationAccountResponseReviewMetadataDatesItemCitationsMax)
})).max(reviewTenderPreparationAccountResponseReviewMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemIdMax),
  "description": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemCitationsItemMax)).min(1).max(reviewTenderPreparationAccountResponseReviewMetadataCriteriaItemCitationsMax)
})).max(reviewTenderPreparationAccountResponseReviewMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataObligationsItemMax)).max(reviewTenderPreparationAccountResponseReviewMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataMissingDocumentsItemMax)).max(reviewTenderPreparationAccountResponseReviewMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataQaItemMax)).max(reviewTenderPreparationAccountResponseReviewMetadataQaMax),
  "warnings": zod.array(zod.string().max(reviewTenderPreparationAccountResponseReviewMetadataWarningsItemMax)).max(reviewTenderPreparationAccountResponseReviewMetadataWarningsMax)
}),
  "sourceLabels": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentHash": zod.string(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral'])
})).max(reviewTenderPreparationAccountResponseReviewSourceLabelsMax),
  "proposal": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(reviewTenderPreparationAccountResponseReviewProposalReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
}).optional()
}).optional(),
  "receipt": zod.object({
  "tenderId": zod.uuid(),
  "link": zod.string(),
  "sources": zod.array(zod.object({
  "fileId": zod.uuid(),
  "sourceId": zod.uuid().optional(),
  "status": zod.enum(['pending', 'available', 'failed'])
})).max(reviewTenderPreparationAccountResponseReceiptSourcesMax)
}).optional(),
  "accountReview": zod.object({
  "hash": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "name": zod.string(),
  "accountKind": zod.enum(['organization', 'person']),
  "relationshipType": zod.enum(['b2b_customer', 'b2c_consumer', 'partner', 'supplier', 'investor', 'prospect', 'other']),
  "website": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewWebsiteMax).nullish(),
  "industry": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewIndustryMax).nullish(),
  "phone": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewPhoneMax).nullish(),
  "email": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewEmailMax).nullish(),
  "emailDomain": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewEmailDomainMax).nullish(),
  "addressLine1": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewAddressLine1Max).nullish(),
  "city": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewCityMax).nullish(),
  "stateProvince": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewStateProvinceMax).nullish(),
  "postcode": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewPostcodeMax).nullish(),
  "country": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewCountryMax).nullish(),
  "notes": zod.string().max(reviewTenderPreparationAccountResponseAccountReviewNotesMax).nullish(),
  "annualRevenue": zod.number().min(reviewTenderPreparationAccountResponseAccountReviewAnnualRevenueMin).max(reviewTenderPreparationAccountResponseAccountReviewAnnualRevenueMax).multipleOf(reviewTenderPreparationAccountResponseAccountReviewAnnualRevenueMultipleOf).nullish(),
  "numberOfEmployees": zod.int().min(reviewTenderPreparationAccountResponseAccountReviewNumberOfEmployeesMin).max(reviewTenderPreparationAccountResponseAccountReviewNumberOfEmployeesMax).nullish()
}).optional(),
  "accountReceipt": zod.object({
  "id": zod.uuid(),
  "name": zod.string()
}).optional()
})


/**
 * Read-only native projection. Linked SOW proposal/document pairs appear once. Status remains the source workflow status; this listing grants no approval authority.
 * @summary List authorized Tender proposals and managed SOW documents
 */
export const listProposalsQueryStatusMax = 50;

export const listProposalsQuerySearchMax = 200;

export const listProposalsQueryLimitDefault = 50;
export const listProposalsQueryLimitMax = 100;

export const listProposalsQueryOffsetDefault = 0;
export const listProposalsQueryOffsetMin = 0;



export const listProposalsQueryParams = zod.object({
  "type": zod.enum(['tender', 'sow']).optional(),
  "accountId": zod.uuid().optional(),
  "quoteRequestId": zod.uuid().optional(),
  "ownerAppUserId": zod.uuid().optional(),
  "status": zod.string().min(1).max(listProposalsQueryStatusMax).optional(),
  "search": zod.string().max(listProposalsQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listProposalsQueryLimitMax).default(listProposalsQueryLimitDefault),
  "offset": zod.int().min(listProposalsQueryOffsetMin).default(listProposalsQueryOffsetDefault)
})

export const listProposalsResponseTotalMin = 0;

export const listProposalsResponseLimitMax = 100;

export const listProposalsResponseOffsetMin = 0;



export const listProposalsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid().describe('Canonical Tender ID or historical managed SOW document ID.'),
  "type": zod.enum(['tender', 'sow']).describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "source": zod.enum(['tender', 'managed_sow']),
  "title": zod.string(),
  "reference": zod.string().nullish(),
  "accountId": zod.uuid().nullish(),
  "accountName": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.string().describe('Unmodified native source status.'),
  "sowDocumentId": zod.uuid().nullish(),
  "sowDocumentStatus": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listProposalsResponseTotalMin),
  "limit": zod.int().min(1).max(listProposalsResponseLimitMax),
  "offset": zod.int().min(listProposalsResponseOffsetMin)
})


/**
 * @summary List entity tenders
 */
export const listTendersQuerySearchMax = 200;

export const listTendersQueryLimitDefault = 50;
export const listTendersQueryLimitMax = 100;

export const listTendersQueryOffsetDefault = 0;
export const listTendersQueryOffsetMin = 0;



export const listTendersQueryParams = zod.object({
  "accountId": zod.uuid().optional(),
  "quoteRequestId": zod.uuid().optional(),
  "status": zod.enum(['draft', 'in_preparation', 'in_review', 'changes_requested', 'approved', 'submitted', 'closed', 'archived']).optional(),
  "ownerAppUserId": zod.uuid().optional(),
  "search": zod.string().max(listTendersQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listTendersQueryLimitMax).default(listTendersQueryLimitDefault),
  "offset": zod.int().min(listTendersQueryOffsetMin).default(listTendersQueryOffsetDefault)
})


export const listTendersResponseTotalMin = 0;

export const listTendersResponseLimitMax = 100;

export const listTendersResponseOffsetMin = 0;



export const listTendersResponse = zod.object({
  "data": zod.array(zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "sowDocumentId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "reference": zod.string(),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().nullish(),
  "status": zod.enum(['draft', 'in_preparation', 'in_review', 'changes_requested', 'approved', 'submitted', 'closed', 'archived']),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])),
  "revision": zod.int().min(1),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submissionReference": zod.string().nullish(),
  "outcome": zod.string().nullish(),
  "outcomeNote": zod.string().nullish(),
  "closedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "accountName": zod.string().nullish()
}))),
  "total": zod.int().min(listTendersResponseTotalMin),
  "limit": zod.int().min(1).max(listTendersResponseLimitMax),
  "offset": zod.int().min(listTendersResponseOffsetMin)
})


/**
 * @summary Create a tender for an entity account
 */
export const createTenderHeaderIdempotencyKeyMax = 128;



export const createTenderHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createTenderHeaderIdempotencyKeyMax).optional()
})

export const createTenderBodyTitleMax = 300;

export const createTenderBodyBriefingMdMax = 50000;

export const createTenderBodySelectedOutputKindsMax = 4;



export const createTenderBody = zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(createTenderBodyTitleMax),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(createTenderBodyBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(createTenderBodySelectedOutputKindsMax).optional()
})




export const createTenderResponse = zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "sowDocumentId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "reference": zod.string(),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().nullish(),
  "status": zod.enum(['draft', 'in_preparation', 'in_review', 'changes_requested', 'approved', 'submitted', 'closed', 'archived']),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])),
  "revision": zod.int().min(1),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submissionReference": zod.string().nullish(),
  "outcome": zod.string().nullish(),
  "outcomeNote": zod.string().nullish(),
  "closedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get a tender and foundation workflow counts
 */
export const getTenderParams = zod.object({
  "id": zod.uuid()
})


export const getTenderResponseTwoDocumentMetadataTypeSuggestionExplanationMax = 1000;

export const getTenderResponseTwoDocumentMetadataTypeSuggestionCitationsItemMax = 100;

export const getTenderResponseTwoDocumentMetadataTypeSuggestionCitationsMax = 20;

export const getTenderResponseTwoDocumentMetadataTitleMax = 300;

export const getTenderResponseTwoDocumentMetadataBuyerMax = 300;

export const getTenderResponseTwoDocumentMetadataReferenceMax = 200;

export const getTenderResponseTwoDocumentMetadataSummaryMax = 10000;

export const getTenderResponseTwoDocumentMetadataDatesItemKindMax = 100;

export const getTenderResponseTwoDocumentMetadataDatesItemValueMax = 200;

export const getTenderResponseTwoDocumentMetadataDatesItemTimezoneMax = 100;

export const getTenderResponseTwoDocumentMetadataDatesItemPrecisionMax = 100;

export const getTenderResponseTwoDocumentMetadataDatesItemCitationsItemMax = 100;

export const getTenderResponseTwoDocumentMetadataDatesItemCitationsMax = 20;

export const getTenderResponseTwoDocumentMetadataDatesMax = 100;

export const getTenderResponseTwoDocumentMetadataCriteriaItemIdMax = 100;

export const getTenderResponseTwoDocumentMetadataCriteriaItemDescriptionMax = 10000;

export const getTenderResponseTwoDocumentMetadataCriteriaItemWeightMax = 100;

export const getTenderResponseTwoDocumentMetadataCriteriaItemResponseLimitMax = 200;

export const getTenderResponseTwoDocumentMetadataCriteriaItemCitationsItemMax = 100;

export const getTenderResponseTwoDocumentMetadataCriteriaItemCitationsMax = 20;

export const getTenderResponseTwoDocumentMetadataCriteriaMax = 100;

export const getTenderResponseTwoDocumentMetadataObligationsItemMax = 2000;

export const getTenderResponseTwoDocumentMetadataObligationsMax = 100;

export const getTenderResponseTwoDocumentMetadataMissingDocumentsItemMax = 1000;

export const getTenderResponseTwoDocumentMetadataMissingDocumentsMax = 100;

export const getTenderResponseTwoDocumentMetadataQaItemMax = 5000;

export const getTenderResponseTwoDocumentMetadataQaMax = 100;

export const getTenderResponseTwoDocumentMetadataWarningsItemMax = 1000;

export const getTenderResponseTwoDocumentMetadataWarningsMax = 100;

export const getTenderResponseTwoWorkflowCountsSourcesMin = 0;

export const getTenderResponseTwoWorkflowCountsRequirementsMin = 0;

export const getTenderResponseTwoWorkflowCountsResponseSectionsMin = 0;

export const getTenderResponseTwoWorkflowCountsEvidenceSelectionsMin = 0;

export const getTenderResponseTwoWorkflowCountsAiRunsMin = 0;

export const getTenderResponseTwoWorkflowCountsProposalsMin = 0;

export const getTenderResponseTwoWorkflowCountsPackageRevisionsMin = 0;

export const getTenderResponseTwoWorkflowCountsReviewsMin = 0;

export const getTenderResponseTwoWorkflowCountsExportsMin = 0;



export const getTenderResponse = zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "sowDocumentId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "reference": zod.string(),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().nullish(),
  "status": zod.enum(['draft', 'in_preparation', 'in_review', 'changes_requested', 'approved', 'submitted', 'closed', 'archived']),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])),
  "revision": zod.int().min(1),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submissionReference": zod.string().nullish(),
  "outcome": zod.string().nullish(),
  "outcomeNote": zod.string().nullish(),
  "closedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "documentMetadata": zod.object({
  "typeSuggestion": zod.object({
  "type": zod.enum(['tender', 'sow', 'inconclusive']),
  "explanation": zod.string().min(1).max(getTenderResponseTwoDocumentMetadataTypeSuggestionExplanationMax),
  "citations": zod.array(zod.string().max(getTenderResponseTwoDocumentMetadataTypeSuggestionCitationsItemMax)).max(getTenderResponseTwoDocumentMetadataTypeSuggestionCitationsMax)
}).optional(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish().describe('Exact normalized closing timestamp only when a complete date, time and timezone are explicitly supported by the cited closing entry.'),
  "title": zod.string().max(getTenderResponseTwoDocumentMetadataTitleMax),
  "buyer": zod.string().max(getTenderResponseTwoDocumentMetadataBuyerMax),
  "reference": zod.string().max(getTenderResponseTwoDocumentMetadataReferenceMax),
  "summary": zod.string().max(getTenderResponseTwoDocumentMetadataSummaryMax),
  "dates": zod.array(zod.object({
  "kind": zod.string().max(getTenderResponseTwoDocumentMetadataDatesItemKindMax),
  "value": zod.string().max(getTenderResponseTwoDocumentMetadataDatesItemValueMax),
  "timezone": zod.string().max(getTenderResponseTwoDocumentMetadataDatesItemTimezoneMax),
  "precision": zod.string().max(getTenderResponseTwoDocumentMetadataDatesItemPrecisionMax),
  "citations": zod.array(zod.string().max(getTenderResponseTwoDocumentMetadataDatesItemCitationsItemMax)).min(1).max(getTenderResponseTwoDocumentMetadataDatesItemCitationsMax)
})).max(getTenderResponseTwoDocumentMetadataDatesMax),
  "criteria": zod.array(zod.object({
  "id": zod.string().max(getTenderResponseTwoDocumentMetadataCriteriaItemIdMax),
  "description": zod.string().max(getTenderResponseTwoDocumentMetadataCriteriaItemDescriptionMax),
  "weight": zod.string().max(getTenderResponseTwoDocumentMetadataCriteriaItemWeightMax),
  "responseLimit": zod.string().max(getTenderResponseTwoDocumentMetadataCriteriaItemResponseLimitMax),
  "citations": zod.array(zod.string().max(getTenderResponseTwoDocumentMetadataCriteriaItemCitationsItemMax)).min(1).max(getTenderResponseTwoDocumentMetadataCriteriaItemCitationsMax)
})).max(getTenderResponseTwoDocumentMetadataCriteriaMax),
  "obligations": zod.array(zod.string().max(getTenderResponseTwoDocumentMetadataObligationsItemMax)).max(getTenderResponseTwoDocumentMetadataObligationsMax),
  "missingDocuments": zod.array(zod.string().max(getTenderResponseTwoDocumentMetadataMissingDocumentsItemMax)).max(getTenderResponseTwoDocumentMetadataMissingDocumentsMax),
  "qa": zod.array(zod.string().max(getTenderResponseTwoDocumentMetadataQaItemMax)).max(getTenderResponseTwoDocumentMetadataQaMax),
  "warnings": zod.array(zod.string().max(getTenderResponseTwoDocumentMetadataWarningsItemMax)).max(getTenderResponseTwoDocumentMetadataWarningsMax)
}).optional(),
  "account": zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "reference": zod.string().nullish()
}),
  "quote": zod.union([zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "reference": zod.string().nullish()
}),zod.null()]).optional(),
  "workflowCounts": zod.object({
  "sources": zod.int().min(getTenderResponseTwoWorkflowCountsSourcesMin),
  "requirements": zod.int().min(getTenderResponseTwoWorkflowCountsRequirementsMin),
  "responseSections": zod.int().min(getTenderResponseTwoWorkflowCountsResponseSectionsMin),
  "evidenceSelections": zod.int().min(getTenderResponseTwoWorkflowCountsEvidenceSelectionsMin),
  "aiRuns": zod.int().min(getTenderResponseTwoWorkflowCountsAiRunsMin),
  "proposals": zod.int().min(getTenderResponseTwoWorkflowCountsProposalsMin),
  "packageRevisions": zod.int().min(getTenderResponseTwoWorkflowCountsPackageRevisionsMin),
  "reviews": zod.int().min(getTenderResponseTwoWorkflowCountsReviewsMin),
  "exports": zod.int().min(getTenderResponseTwoWorkflowCountsExportsMin)
})
}))


/**
 * @summary Update tender metadata or link a matching-account quote
 */
export const updateTenderParams = zod.object({
  "id": zod.uuid()
})


export const updateTenderBodyTitleMax = 300;

export const updateTenderBodyBriefingMdMax = 50000;

export const updateTenderBodySelectedOutputKindsMax = 4;



export const updateTenderBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "accountId": zod.uuid().optional(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(updateTenderBodyTitleMax).optional(),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().max(updateTenderBodyBriefingMdMax).nullish(),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']).optional(),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(updateTenderBodySelectedOutputKindsMax).optional()
})




export const updateTenderResponse = zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "sowDocumentId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "reference": zod.string(),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().nullish(),
  "status": zod.enum(['draft', 'in_preparation', 'in_review', 'changes_requested', 'approved', 'submitted', 'closed', 'archived']),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])),
  "revision": zod.int().min(1),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submissionReference": zod.string().nullish(),
  "outcome": zod.string().nullish(),
  "outcomeNote": zod.string().nullish(),
  "closedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a draft tender before response work exists
 */
export const deleteTenderParams = zod.object({
  "id": zod.uuid()
})

export const deleteTenderResponse = zod.void()


/**
 * @summary Record a permitted tender lifecycle transition
 */
export const transitionTenderParams = zod.object({
  "id": zod.uuid()
})


export const transitionTenderBodyNoteMax = 2000;

export const transitionTenderBodySubmissionReferenceMax = 300;

export const transitionTenderBodyOutcomeMax = 200;

export const transitionTenderBodyOutcomeNoteMax = 5000;



export const transitionTenderBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "status": zod.enum(['draft', 'in_preparation', 'in_review', 'changes_requested', 'approved', 'submitted', 'closed', 'archived']),
  "note": zod.string().min(1).max(transitionTenderBodyNoteMax),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submissionReference": zod.string().max(transitionTenderBodySubmissionReferenceMax).nullish(),
  "outcome": zod.string().max(transitionTenderBodyOutcomeMax).nullish(),
  "outcomeNote": zod.string().max(transitionTenderBodyOutcomeNoteMax).nullish()
})




export const transitionTenderResponse = zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "sowDocumentId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "reference": zod.string(),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().nullish(),
  "status": zod.enum(['draft', 'in_preparation', 'in_review', 'changes_requested', 'approved', 'submitted', 'closed', 'archived']),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])),
  "revision": zod.int().min(1),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submissionReference": zod.string().nullish(),
  "outcome": zod.string().nullish(),
  "outcomeNote": zod.string().nullish(),
  "closedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List append-only tender history
 */
export const listTenderEventsParams = zod.object({
  "id": zod.uuid()
})

export const listTenderEventsQueryLimitDefault = 50;
export const listTenderEventsQueryLimitMax = 100;

export const listTenderEventsQueryOffsetDefault = 0;
export const listTenderEventsQueryOffsetMin = 0;



export const listTenderEventsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderEventsQueryLimitMax).default(listTenderEventsQueryLimitDefault),
  "offset": zod.int().min(listTenderEventsQueryOffsetMin).default(listTenderEventsQueryOffsetDefault)
})

export const listTenderEventsResponseTotalMin = 0;

export const listTenderEventsResponseLimitMax = 100;

export const listTenderEventsResponseOffsetMin = 0;



export const listTenderEventsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "type": zod.enum(['created', 'updated', 'status_changed', 'quote_linked', 'quote_unlinked', 'submitted', 'archived']),
  "actorAppUserId": zod.uuid().nullish(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderEventsResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderEventsResponseLimitMax),
  "offset": zod.int().min(listTenderEventsResponseOffsetMin)
})


/**
 * @summary Browse authorized proposal files and grounding without changing evidence
 */
export const listTenderFilesParams = zod.object({
  "id": zod.uuid()
})

export const listTenderFilesQuerySearchMax = 200;

export const listTenderFilesQueryTypeMax = 200;

export const listTenderFilesQueryLimitDefault = 50;
export const listTenderFilesQueryLimitMax = 100;

export const listTenderFilesQueryOffsetDefault = 0;
export const listTenderFilesQueryOffsetMin = 0;



export const listTenderFilesQueryParams = zod.object({
  "search": zod.string().max(listTenderFilesQuerySearchMax).optional(),
  "type": zod.string().max(listTenderFilesQueryTypeMax).optional(),
  "category": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral', 'uploads', 'working', 'submission', 'response', 'entity_grounding', 'tender_grounding']).optional(),
  "limit": zod.int().min(1).max(listTenderFilesQueryLimitMax).default(listTenderFilesQueryLimitDefault),
  "offset": zod.int().min(listTenderFilesQueryOffsetMin).default(listTenderFilesQueryOffsetDefault)
})

export const listTenderFilesHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const listTenderFilesHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(listTenderFilesHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const listTenderFilesResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string(),
  "title": zod.string(),
  "categories": zod.array(zod.string()),
  "locations": zod.array(zod.string()),
  "status": zod.string(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "contentType": zod.string().nullable(),
  "sizeBytes": zod.int().nullable(),
  "documentId": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "sourceId": zod.uuid().nullable(),
  "outputId": zod.uuid().nullable(),
  "knowledgeId": zod.uuid().nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary List current tender collateral
 */
export const listTenderSourcesParams = zod.object({
  "id": zod.uuid()
})

export const listTenderSourcesQuerySearchMax = 200;

export const listTenderSourcesQueryLimitDefault = 50;
export const listTenderSourcesQueryLimitMax = 100;

export const listTenderSourcesQueryOffsetDefault = 0;
export const listTenderSourcesQueryOffsetMin = 0;



export const listTenderSourcesQueryParams = zod.object({
  "search": zod.string().max(listTenderSourcesQuerySearchMax).optional(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']).optional(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']).optional(),
  "limit": zod.int().min(1).max(listTenderSourcesQueryLimitMax).default(listTenderSourcesQueryLimitDefault),
  "offset": zod.int().min(listTenderSourcesQueryOffsetMin).default(listTenderSourcesQueryOffsetDefault)
})

export const listTenderSourcesHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const listTenderSourcesHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(listTenderSourcesHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const listTenderSourcesResponseDataItemLabelMax = 300;

export const listTenderSourcesResponseDataItemDescriptorTwoFilenameMax = 500;

export const listTenderSourcesResponseDataItemDescriptorTwoContentTypeMax = 200;

export const listTenderSourcesResponseDataItemDescriptorTwoContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderSourcesResponseDataItemDescriptorTwoSourceRevisionMax = 300;


export const listTenderSourcesResponseDataItemSizeBytesMin = 0;

export const listTenderSourcesResponseTotalMin = 0;

export const listTenderSourcesResponseLimitMax = 100;

export const listTenderSourcesResponseOffsetMin = 0;



export const listTenderSourcesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "lineageId": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(listTenderSourcesResponseDataItemLabelMax),
  "fileId": zod.uuid().nullish(),
  "descriptor": zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}).and(zod.object({
  "filename": zod.string().min(1).max(listTenderSourcesResponseDataItemDescriptorTwoFilenameMax),
  "contentType": zod.string().min(1).max(listTenderSourcesResponseDataItemDescriptorTwoContentTypeMax),
  "contentHash": zod.string().regex(listTenderSourcesResponseDataItemDescriptorTwoContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "sourceRevision": zod.string().min(1).max(listTenderSourcesResponseDataItemDescriptorTwoSourceRevisionMax)
})),
  "revision": zod.int().min(1),
  "isCurrent": zod.boolean(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']),
  "uploadMessage": zod.string().nullish(),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'failed']),
  "extractionMessage": zod.string().nullish(),
  "extractedTextAvailable": zod.boolean(),
  "sizeBytes": zod.int().min(listTenderSourcesResponseDataItemSizeBytesMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderSourcesResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderSourcesResponseLimitMax),
  "offset": zod.int().min(listTenderSourcesResponseOffsetMin)
})


/**
 * @summary Upload immutable tender collateral to application storage
 */
export const uploadTenderSourceParams = zod.object({
  "id": zod.uuid()
})

export const uploadTenderSourceHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadTenderSourceHeaderIdempotencyKeyMax = 128;



export const uploadTenderSourceHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(uploadTenderSourceHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.'),
  "Idempotency-Key": zod.string().min(1).max(uploadTenderSourceHeaderIdempotencyKeyMax)
})

export const uploadTenderSourceBodyLabelMax = 300;



export const uploadTenderSourceBody = zod.object({
  "file": zod.instanceof(Blob),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(uploadTenderSourceBodyLabelMax)
})

export const uploadTenderSourceResponseLabelMax = 300;

export const uploadTenderSourceResponseDescriptorTwoFilenameMax = 500;

export const uploadTenderSourceResponseDescriptorTwoContentTypeMax = 200;

export const uploadTenderSourceResponseDescriptorTwoContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadTenderSourceResponseDescriptorTwoSourceRevisionMax = 300;


export const uploadTenderSourceResponseSizeBytesMin = 0;



export const uploadTenderSourceResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "lineageId": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(uploadTenderSourceResponseLabelMax),
  "fileId": zod.uuid().nullish(),
  "descriptor": zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}).and(zod.object({
  "filename": zod.string().min(1).max(uploadTenderSourceResponseDescriptorTwoFilenameMax),
  "contentType": zod.string().min(1).max(uploadTenderSourceResponseDescriptorTwoContentTypeMax),
  "contentHash": zod.string().regex(uploadTenderSourceResponseDescriptorTwoContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "sourceRevision": zod.string().min(1).max(uploadTenderSourceResponseDescriptorTwoSourceRevisionMax)
})),
  "revision": zod.int().min(1),
  "isCurrent": zod.boolean(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']),
  "uploadMessage": zod.string().nullish(),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'failed']),
  "extractionMessage": zod.string().nullish(),
  "extractedTextAvailable": zod.boolean(),
  "sizeBytes": zod.int().min(uploadTenderSourceResponseSizeBytesMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get the verified SharePoint Word launch URL for current collateral
 */
export const getTenderSourceOfficeLaunchParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})

export const getTenderSourceOfficeLaunchResponse = zod.object({
  "url": zod.url(),
  "itemId": zod.string(),
  "expectedETag": zod.string(),
  "note": zod.string()
})


/**
 * @summary Import a changed native Word file as a new immutable tender source revision
 */
export const reconcileTenderSourceFromSharePointParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})

export const reconcileTenderSourceFromSharePointHeaderIdempotencyKeyMax = 128;



export const reconcileTenderSourceFromSharePointHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(reconcileTenderSourceFromSharePointHeaderIdempotencyKeyMax)
})


export const reconcileTenderSourceFromSharePointBodyExpectedETagMax = 500;



export const reconcileTenderSourceFromSharePointBody = zod.object({
  "expectedSourceRevision": zod.int().min(1),
  "expectedETag": zod.string().min(1).max(reconcileTenderSourceFromSharePointBodyExpectedETagMax)
})

export const reconcileTenderSourceFromSharePointResponseLabelMax = 300;

export const reconcileTenderSourceFromSharePointResponseDescriptorTwoFilenameMax = 500;

export const reconcileTenderSourceFromSharePointResponseDescriptorTwoContentTypeMax = 200;

export const reconcileTenderSourceFromSharePointResponseDescriptorTwoContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reconcileTenderSourceFromSharePointResponseDescriptorTwoSourceRevisionMax = 300;


export const reconcileTenderSourceFromSharePointResponseSizeBytesMin = 0;



export const reconcileTenderSourceFromSharePointResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "lineageId": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(reconcileTenderSourceFromSharePointResponseLabelMax),
  "fileId": zod.uuid().nullish(),
  "descriptor": zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}).and(zod.object({
  "filename": zod.string().min(1).max(reconcileTenderSourceFromSharePointResponseDescriptorTwoFilenameMax),
  "contentType": zod.string().min(1).max(reconcileTenderSourceFromSharePointResponseDescriptorTwoContentTypeMax),
  "contentHash": zod.string().regex(reconcileTenderSourceFromSharePointResponseDescriptorTwoContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "sourceRevision": zod.string().min(1).max(reconcileTenderSourceFromSharePointResponseDescriptorTwoSourceRevisionMax)
})),
  "revision": zod.int().min(1),
  "isCurrent": zod.boolean(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']),
  "uploadMessage": zod.string().nullish(),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'failed']),
  "extractionMessage": zod.string().nullish(),
  "extractedTextAvailable": zod.boolean(),
  "sizeBytes": zod.int().min(reconcileTenderSourceFromSharePointResponseSizeBytesMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Import a changed Embedded Word file as a new immutable tender source revision
 */
export const reconcileTenderSourceFromEmbeddedParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})

export const reconcileTenderSourceFromEmbeddedHeaderIdempotencyKeyMax = 128;



export const reconcileTenderSourceFromEmbeddedHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(reconcileTenderSourceFromEmbeddedHeaderIdempotencyKeyMax)
})


export const reconcileTenderSourceFromEmbeddedBodyExpectedETagMax = 500;



export const reconcileTenderSourceFromEmbeddedBody = zod.object({
  "expectedSourceRevision": zod.int().min(1),
  "expectedETag": zod.string().min(1).max(reconcileTenderSourceFromEmbeddedBodyExpectedETagMax)
})

export const reconcileTenderSourceFromEmbeddedResponseLabelMax = 300;

export const reconcileTenderSourceFromEmbeddedResponseDescriptorTwoFilenameMax = 500;

export const reconcileTenderSourceFromEmbeddedResponseDescriptorTwoContentTypeMax = 200;

export const reconcileTenderSourceFromEmbeddedResponseDescriptorTwoContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reconcileTenderSourceFromEmbeddedResponseDescriptorTwoSourceRevisionMax = 300;


export const reconcileTenderSourceFromEmbeddedResponseSizeBytesMin = 0;



export const reconcileTenderSourceFromEmbeddedResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "lineageId": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(reconcileTenderSourceFromEmbeddedResponseLabelMax),
  "fileId": zod.uuid().nullish(),
  "descriptor": zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}).and(zod.object({
  "filename": zod.string().min(1).max(reconcileTenderSourceFromEmbeddedResponseDescriptorTwoFilenameMax),
  "contentType": zod.string().min(1).max(reconcileTenderSourceFromEmbeddedResponseDescriptorTwoContentTypeMax),
  "contentHash": zod.string().regex(reconcileTenderSourceFromEmbeddedResponseDescriptorTwoContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "sourceRevision": zod.string().min(1).max(reconcileTenderSourceFromEmbeddedResponseDescriptorTwoSourceRevisionMax)
})),
  "revision": zod.int().min(1),
  "isCurrent": zod.boolean(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']),
  "uploadMessage": zod.string().nullish(),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'failed']),
  "extractionMessage": zod.string().nullish(),
  "extractedTextAvailable": zod.boolean(),
  "sizeBytes": zod.int().min(reconcileTenderSourceFromEmbeddedResponseSizeBytesMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get one tender collateral revision
 */
export const getTenderSourceParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})

export const getTenderSourceResponseLabelMax = 300;

export const getTenderSourceResponseDescriptorTwoFilenameMax = 500;

export const getTenderSourceResponseDescriptorTwoContentTypeMax = 200;

export const getTenderSourceResponseDescriptorTwoContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getTenderSourceResponseDescriptorTwoSourceRevisionMax = 300;


export const getTenderSourceResponseSizeBytesMin = 0;



export const getTenderSourceResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "lineageId": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(getTenderSourceResponseLabelMax),
  "fileId": zod.uuid().nullish(),
  "descriptor": zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}).and(zod.object({
  "filename": zod.string().min(1).max(getTenderSourceResponseDescriptorTwoFilenameMax),
  "contentType": zod.string().min(1).max(getTenderSourceResponseDescriptorTwoContentTypeMax),
  "contentHash": zod.string().regex(getTenderSourceResponseDescriptorTwoContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "sourceRevision": zod.string().min(1).max(getTenderSourceResponseDescriptorTwoSourceRevisionMax)
})),
  "revision": zod.int().min(1),
  "isCurrent": zod.boolean(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']),
  "uploadMessage": zod.string().nullish(),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'failed']),
  "extractionMessage": zod.string().nullish(),
  "extractedTextAvailable": zod.boolean(),
  "sizeBytes": zod.int().min(getTenderSourceResponseSizeBytesMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Create a metadata-only revision for tender collateral
 */
export const updateTenderSourceParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})


export const updateTenderSourceBodyLabelMax = 300;



export const updateTenderSourceBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']).optional(),
  "label": zod.string().min(1).max(updateTenderSourceBodyLabelMax).optional()
})

export const updateTenderSourceResponseLabelMax = 300;

export const updateTenderSourceResponseDescriptorTwoFilenameMax = 500;

export const updateTenderSourceResponseDescriptorTwoContentTypeMax = 200;

export const updateTenderSourceResponseDescriptorTwoContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateTenderSourceResponseDescriptorTwoSourceRevisionMax = 300;


export const updateTenderSourceResponseSizeBytesMin = 0;



export const updateTenderSourceResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "lineageId": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(updateTenderSourceResponseLabelMax),
  "fileId": zod.uuid().nullish(),
  "descriptor": zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}).and(zod.object({
  "filename": zod.string().min(1).max(updateTenderSourceResponseDescriptorTwoFilenameMax),
  "contentType": zod.string().min(1).max(updateTenderSourceResponseDescriptorTwoContentTypeMax),
  "contentHash": zod.string().regex(updateTenderSourceResponseDescriptorTwoContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "sourceRevision": zod.string().min(1).max(updateTenderSourceResponseDescriptorTwoSourceRevisionMax)
})),
  "revision": zod.int().min(1),
  "isCurrent": zod.boolean(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']),
  "uploadMessage": zod.string().nullish(),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'failed']),
  "extractionMessage": zod.string().nullish(),
  "extractedTextAvailable": zod.boolean(),
  "sizeBytes": zod.int().min(updateTenderSourceResponseSizeBytesMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Download exact bytes for one tender collateral revision
 */
export const downloadTenderSourceParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})

export const downloadTenderSourceResponse = zod.unknown()


/**
 * @summary List immutable revisions for one tender collateral item
 */
export const listTenderSourceRevisionsParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})

export const listTenderSourceRevisionsQueryLimitDefault = 50;
export const listTenderSourceRevisionsQueryLimitMax = 100;

export const listTenderSourceRevisionsQueryOffsetDefault = 0;
export const listTenderSourceRevisionsQueryOffsetMin = 0;



export const listTenderSourceRevisionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderSourceRevisionsQueryLimitMax).default(listTenderSourceRevisionsQueryLimitDefault),
  "offset": zod.int().min(listTenderSourceRevisionsQueryOffsetMin).default(listTenderSourceRevisionsQueryOffsetDefault)
})

export const listTenderSourceRevisionsResponseDataItemLabelMax = 300;

export const listTenderSourceRevisionsResponseDataItemDescriptorTwoFilenameMax = 500;

export const listTenderSourceRevisionsResponseDataItemDescriptorTwoContentTypeMax = 200;

export const listTenderSourceRevisionsResponseDataItemDescriptorTwoContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderSourceRevisionsResponseDataItemDescriptorTwoSourceRevisionMax = 300;


export const listTenderSourceRevisionsResponseDataItemSizeBytesMin = 0;

export const listTenderSourceRevisionsResponseTotalMin = 0;

export const listTenderSourceRevisionsResponseLimitMax = 100;

export const listTenderSourceRevisionsResponseOffsetMin = 0;



export const listTenderSourceRevisionsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "lineageId": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(listTenderSourceRevisionsResponseDataItemLabelMax),
  "fileId": zod.uuid().nullish(),
  "descriptor": zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}).and(zod.object({
  "filename": zod.string().min(1).max(listTenderSourceRevisionsResponseDataItemDescriptorTwoFilenameMax),
  "contentType": zod.string().min(1).max(listTenderSourceRevisionsResponseDataItemDescriptorTwoContentTypeMax),
  "contentHash": zod.string().regex(listTenderSourceRevisionsResponseDataItemDescriptorTwoContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "sourceRevision": zod.string().min(1).max(listTenderSourceRevisionsResponseDataItemDescriptorTwoSourceRevisionMax)
})),
  "revision": zod.int().min(1),
  "isCurrent": zod.boolean(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']),
  "uploadMessage": zod.string().nullish(),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'failed']),
  "extractionMessage": zod.string().nullish(),
  "extractedTextAvailable": zod.boolean(),
  "sizeBytes": zod.int().min(listTenderSourceRevisionsResponseDataItemSizeBytesMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderSourceRevisionsResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderSourceRevisionsResponseLimitMax),
  "offset": zod.int().min(listTenderSourceRevisionsResponseOffsetMin)
})


/**
 * @summary Upload a new immutable revision for tender collateral
 */
export const reviseTenderSourceParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})

export const reviseTenderSourceHeaderIdempotencyKeyMax = 128;



export const reviseTenderSourceHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(reviseTenderSourceHeaderIdempotencyKeyMax)
})


export const reviseTenderSourceBodyLabelMax = 300;



export const reviseTenderSourceBody = zod.object({
  "file": zod.instanceof(Blob),
  "expectedRevision": zod.int().min(1),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(reviseTenderSourceBodyLabelMax)
})

export const reviseTenderSourceResponseLabelMax = 300;

export const reviseTenderSourceResponseDescriptorTwoFilenameMax = 500;

export const reviseTenderSourceResponseDescriptorTwoContentTypeMax = 200;

export const reviseTenderSourceResponseDescriptorTwoContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reviseTenderSourceResponseDescriptorTwoSourceRevisionMax = 300;


export const reviseTenderSourceResponseSizeBytesMin = 0;



export const reviseTenderSourceResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "lineageId": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(reviseTenderSourceResponseLabelMax),
  "fileId": zod.uuid().nullish(),
  "descriptor": zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}).and(zod.object({
  "filename": zod.string().min(1).max(reviseTenderSourceResponseDescriptorTwoFilenameMax),
  "contentType": zod.string().min(1).max(reviseTenderSourceResponseDescriptorTwoContentTypeMax),
  "contentHash": zod.string().regex(reviseTenderSourceResponseDescriptorTwoContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "sourceRevision": zod.string().min(1).max(reviseTenderSourceResponseDescriptorTwoSourceRevisionMax)
})),
  "revision": zod.int().min(1),
  "isCurrent": zod.boolean(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']),
  "uploadMessage": zod.string().nullish(),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'failed']),
  "extractionMessage": zod.string().nullish(),
  "extractedTextAvailable": zod.boolean(),
  "sizeBytes": zod.int().min(reviseTenderSourceResponseSizeBytesMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Retry bounded extraction from an available collateral revision
 */
export const retryTenderSourceExtractionParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})

export const retryTenderSourceExtractionResponseLabelMax = 300;

export const retryTenderSourceExtractionResponseDescriptorTwoFilenameMax = 500;

export const retryTenderSourceExtractionResponseDescriptorTwoContentTypeMax = 200;

export const retryTenderSourceExtractionResponseDescriptorTwoContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const retryTenderSourceExtractionResponseDescriptorTwoSourceRevisionMax = 300;


export const retryTenderSourceExtractionResponseSizeBytesMin = 0;



export const retryTenderSourceExtractionResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "lineageId": zod.uuid(),
  "kind": zod.enum(['instructions', 'buyer_template', 'addendum', 'supporting_collateral']),
  "label": zod.string().min(1).max(retryTenderSourceExtractionResponseLabelMax),
  "fileId": zod.uuid().nullish(),
  "descriptor": zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}).and(zod.object({
  "filename": zod.string().min(1).max(retryTenderSourceExtractionResponseDescriptorTwoFilenameMax),
  "contentType": zod.string().min(1).max(retryTenderSourceExtractionResponseDescriptorTwoContentTypeMax),
  "contentHash": zod.string().regex(retryTenderSourceExtractionResponseDescriptorTwoContentHashRegExp),
  "capturedAt": zod.iso.datetime({"offset":true}),
  "sourceRevision": zod.string().min(1).max(retryTenderSourceExtractionResponseDescriptorTwoSourceRevisionMax)
})),
  "revision": zod.int().min(1),
  "isCurrent": zod.boolean(),
  "uploadStatus": zod.enum(['staging', 'available', 'failed']),
  "uploadMessage": zod.string().nullish(),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'failed']),
  "extractionMessage": zod.string().nullish(),
  "extractedTextAvailable": zod.boolean(),
  "sizeBytes": zod.int().min(retryTenderSourceExtractionResponseSizeBytesMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Inspect safe answer targets in one current buyer DOCX template
 */
export const inspectTenderBuyerTemplateParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})


export const inspectTenderBuyerTemplateResponseTemplateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const inspectTenderBuyerTemplateResponseInspectionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const inspectTenderBuyerTemplateResponseTargetsItemTargetIdMax = 300;

export const inspectTenderBuyerTemplateResponseTargetsItemLabelMax = 300;

export const inspectTenderBuyerTemplateResponseTargetsItemPartNameMax = 500;

export const inspectTenderBuyerTemplateResponseTargetsMax = 500;

export const inspectTenderBuyerTemplateResponseUnsupportedConstructsMax = 100;

export const inspectTenderBuyerTemplateResponseWarningsMax = 100;


export const inspectTenderBuyerTemplateResponseMappingOneTemplateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const inspectTenderBuyerTemplateResponseMappingOneInspectionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const inspectTenderBuyerTemplateResponseMappingOneMappingHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const inspectTenderBuyerTemplateResponseMappingOneEntriesItemTargetIdMax = 300;

export const inspectTenderBuyerTemplateResponseMappingOneEntriesItemRequirementKeyMax = 100;

export const inspectTenderBuyerTemplateResponseMappingOneEntriesMax = 500;



export const inspectTenderBuyerTemplateResponse = zod.object({
  "tenderId": zod.uuid(),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "templateHash": zod.string().regex(inspectTenderBuyerTemplateResponseTemplateHashRegExp),
  "inspectionHash": zod.string().regex(inspectTenderBuyerTemplateResponseInspectionHashRegExp),
  "editable": zod.boolean(),
  "handoffRequired": zod.boolean(),
  "handoffReason": zod.string().nullish(),
  "targets": zod.array(zod.object({
  "targetId": zod.string().min(1).max(inspectTenderBuyerTemplateResponseTargetsItemTargetIdMax),
  "kind": zod.enum(['content_control', 'bookmark']),
  "label": zod.string().min(1).max(inspectTenderBuyerTemplateResponseTargetsItemLabelMax),
  "partName": zod.string().min(1).max(inspectTenderBuyerTemplateResponseTargetsItemPartNameMax),
  "supported": zod.boolean(),
  "reason": zod.string().nullish()
})).max(inspectTenderBuyerTemplateResponseTargetsMax),
  "unsupportedConstructs": zod.array(zod.string()).max(inspectTenderBuyerTemplateResponseUnsupportedConstructsMax),
  "warnings": zod.array(zod.string()).max(inspectTenderBuyerTemplateResponseWarningsMax),
  "mapping": zod.union([zod.object({
  "mappingRevision": zod.int().min(1),
  "templateSourceId": zod.uuid(),
  "templateHash": zod.string().regex(inspectTenderBuyerTemplateResponseMappingOneTemplateHashRegExp),
  "inspectionHash": zod.string().regex(inspectTenderBuyerTemplateResponseMappingOneInspectionHashRegExp),
  "mappingHash": zod.string().regex(inspectTenderBuyerTemplateResponseMappingOneMappingHashRegExp),
  "entries": zod.array(zod.object({
  "targetId": zod.string().min(1).max(inspectTenderBuyerTemplateResponseMappingOneEntriesItemTargetIdMax),
  "requirementId": zod.uuid(),
  "responseSectionId": zod.uuid(),
  "requirementKey": zod.string().min(1).max(inspectTenderBuyerTemplateResponseMappingOneEntriesItemRequirementKeyMax)
})).min(1).max(inspectTenderBuyerTemplateResponseMappingOneEntriesMax),
  "confirmedAt": zod.iso.datetime({"offset":true}),
  "confirmedByAppUserId": zod.uuid()
}),zod.null()]).optional(),
  "handoff": zod.object({
  "downloadUrl": zod.string(),
  "reuploadUrl": zod.string(),
  "officeLaunchUrl": zod.string().nullish(),
  "instructions": zod.string()
})
})


/**
 * @summary Confirm requirement answers for unique buyer-template targets
 */
export const confirmTenderBuyerTemplateMappingParams = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid()
})


export const confirmTenderBuyerTemplateMappingBodyEntriesItemTargetIdMax = 300;

export const confirmTenderBuyerTemplateMappingBodyEntriesMax = 500;



export const confirmTenderBuyerTemplateMappingBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "entries": zod.array(zod.object({
  "targetId": zod.string().min(1).max(confirmTenderBuyerTemplateMappingBodyEntriesItemTargetIdMax),
  "requirementId": zod.uuid()
})).min(1).max(confirmTenderBuyerTemplateMappingBodyEntriesMax)
})


export const confirmTenderBuyerTemplateMappingResponseTemplateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenderBuyerTemplateMappingResponseInspectionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenderBuyerTemplateMappingResponseTargetsItemTargetIdMax = 300;

export const confirmTenderBuyerTemplateMappingResponseTargetsItemLabelMax = 300;

export const confirmTenderBuyerTemplateMappingResponseTargetsItemPartNameMax = 500;

export const confirmTenderBuyerTemplateMappingResponseTargetsMax = 500;

export const confirmTenderBuyerTemplateMappingResponseUnsupportedConstructsMax = 100;

export const confirmTenderBuyerTemplateMappingResponseWarningsMax = 100;


export const confirmTenderBuyerTemplateMappingResponseMappingOneTemplateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenderBuyerTemplateMappingResponseMappingOneInspectionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenderBuyerTemplateMappingResponseMappingOneMappingHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmTenderBuyerTemplateMappingResponseMappingOneEntriesItemTargetIdMax = 300;

export const confirmTenderBuyerTemplateMappingResponseMappingOneEntriesItemRequirementKeyMax = 100;

export const confirmTenderBuyerTemplateMappingResponseMappingOneEntriesMax = 500;



export const confirmTenderBuyerTemplateMappingResponse = zod.object({
  "tenderId": zod.uuid(),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "templateHash": zod.string().regex(confirmTenderBuyerTemplateMappingResponseTemplateHashRegExp),
  "inspectionHash": zod.string().regex(confirmTenderBuyerTemplateMappingResponseInspectionHashRegExp),
  "editable": zod.boolean(),
  "handoffRequired": zod.boolean(),
  "handoffReason": zod.string().nullish(),
  "targets": zod.array(zod.object({
  "targetId": zod.string().min(1).max(confirmTenderBuyerTemplateMappingResponseTargetsItemTargetIdMax),
  "kind": zod.enum(['content_control', 'bookmark']),
  "label": zod.string().min(1).max(confirmTenderBuyerTemplateMappingResponseTargetsItemLabelMax),
  "partName": zod.string().min(1).max(confirmTenderBuyerTemplateMappingResponseTargetsItemPartNameMax),
  "supported": zod.boolean(),
  "reason": zod.string().nullish()
})).max(confirmTenderBuyerTemplateMappingResponseTargetsMax),
  "unsupportedConstructs": zod.array(zod.string()).max(confirmTenderBuyerTemplateMappingResponseUnsupportedConstructsMax),
  "warnings": zod.array(zod.string()).max(confirmTenderBuyerTemplateMappingResponseWarningsMax),
  "mapping": zod.union([zod.object({
  "mappingRevision": zod.int().min(1),
  "templateSourceId": zod.uuid(),
  "templateHash": zod.string().regex(confirmTenderBuyerTemplateMappingResponseMappingOneTemplateHashRegExp),
  "inspectionHash": zod.string().regex(confirmTenderBuyerTemplateMappingResponseMappingOneInspectionHashRegExp),
  "mappingHash": zod.string().regex(confirmTenderBuyerTemplateMappingResponseMappingOneMappingHashRegExp),
  "entries": zod.array(zod.object({
  "targetId": zod.string().min(1).max(confirmTenderBuyerTemplateMappingResponseMappingOneEntriesItemTargetIdMax),
  "requirementId": zod.uuid(),
  "responseSectionId": zod.uuid(),
  "requirementKey": zod.string().min(1).max(confirmTenderBuyerTemplateMappingResponseMappingOneEntriesItemRequirementKeyMax)
})).min(1).max(confirmTenderBuyerTemplateMappingResponseMappingOneEntriesMax),
  "confirmedAt": zod.iso.datetime({"offset":true}),
  "confirmedByAppUserId": zod.uuid()
}),zod.null()]).optional(),
  "handoff": zod.object({
  "downloadUrl": zod.string(),
  "reuploadUrl": zod.string(),
  "officeLaunchUrl": zod.string().nullish(),
  "instructions": zod.string()
})
})


/**
 * @summary List ordered tender response sections
 */
export const listTenderResponseSectionsParams = zod.object({
  "id": zod.uuid()
})

export const listTenderResponseSectionsQueryLimitDefault = 50;
export const listTenderResponseSectionsQueryLimitMax = 100;

export const listTenderResponseSectionsQueryOffsetDefault = 0;
export const listTenderResponseSectionsQueryOffsetMin = 0;



export const listTenderResponseSectionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderResponseSectionsQueryLimitMax).default(listTenderResponseSectionsQueryLimitDefault),
  "offset": zod.int().min(listTenderResponseSectionsQueryOffsetMin).default(listTenderResponseSectionsQueryOffsetDefault)
})

export const listTenderResponseSectionsResponseDataItemKeyMax = 100;

export const listTenderResponseSectionsResponseDataItemTitleMax = 300;

export const listTenderResponseSectionsResponseDataItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listTenderResponseSectionsResponseDataItemSortOrderMin = 0;

export const listTenderResponseSectionsResponseTotalMin = 0;

export const listTenderResponseSectionsResponseLimitMax = 500;

export const listTenderResponseSectionsResponseOffsetMin = 0;



export const listTenderResponseSectionsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "key": zod.string().min(1).max(listTenderResponseSectionsResponseDataItemKeyMax),
  "title": zod.string().min(1).max(listTenderResponseSectionsResponseDataItemTitleMax),
  "content": zod.record(zod.string(), zod.unknown()),
  "contentHash": zod.string().regex(listTenderResponseSectionsResponseDataItemContentHashRegExp),
  "revision": zod.int().min(1),
  "sortOrder": zod.int().min(listTenderResponseSectionsResponseDataItemSortOrderMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderResponseSectionsResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderResponseSectionsResponseLimitMax),
  "offset": zod.int().min(listTenderResponseSectionsResponseOffsetMin)
})


/**
 * @summary Create a tender response section
 */
export const createTenderResponseSectionParams = zod.object({
  "id": zod.uuid()
})

export const createTenderResponseSectionBodyKeyMax = 100;

export const createTenderResponseSectionBodyTitleMax = 300;



export const createTenderResponseSectionBody = zod.object({
  "key": zod.string().min(1).max(createTenderResponseSectionBodyKeyMax),
  "title": zod.string().min(1).max(createTenderResponseSectionBodyTitleMax),
  "content": zod.record(zod.string(), zod.unknown()).optional()
})

export const createTenderResponseSectionResponseKeyMax = 100;

export const createTenderResponseSectionResponseTitleMax = 300;

export const createTenderResponseSectionResponseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const createTenderResponseSectionResponseSortOrderMin = 0;



export const createTenderResponseSectionResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "key": zod.string().min(1).max(createTenderResponseSectionResponseKeyMax),
  "title": zod.string().min(1).max(createTenderResponseSectionResponseTitleMax),
  "content": zod.record(zod.string(), zod.unknown()),
  "contentHash": zod.string().regex(createTenderResponseSectionResponseContentHashRegExp),
  "revision": zod.int().min(1),
  "sortOrder": zod.int().min(createTenderResponseSectionResponseSortOrderMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Reorder every response section using stable identifiers
 */
export const reorderTenderResponseSectionsParams = zod.object({
  "id": zod.uuid()
})

export const reorderTenderResponseSectionsBodyOrderedIdsMax = 500;



export const reorderTenderResponseSectionsBody = zod.object({
  "orderedIds": zod.array(zod.uuid()).max(reorderTenderResponseSectionsBodyOrderedIdsMax)
})

export const reorderTenderResponseSectionsResponseDataItemKeyMax = 100;

export const reorderTenderResponseSectionsResponseDataItemTitleMax = 300;

export const reorderTenderResponseSectionsResponseDataItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const reorderTenderResponseSectionsResponseDataItemSortOrderMin = 0;

export const reorderTenderResponseSectionsResponseTotalMin = 0;

export const reorderTenderResponseSectionsResponseLimitMax = 500;

export const reorderTenderResponseSectionsResponseOffsetMin = 0;



export const reorderTenderResponseSectionsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "key": zod.string().min(1).max(reorderTenderResponseSectionsResponseDataItemKeyMax),
  "title": zod.string().min(1).max(reorderTenderResponseSectionsResponseDataItemTitleMax),
  "content": zod.record(zod.string(), zod.unknown()),
  "contentHash": zod.string().regex(reorderTenderResponseSectionsResponseDataItemContentHashRegExp),
  "revision": zod.int().min(1),
  "sortOrder": zod.int().min(reorderTenderResponseSectionsResponseDataItemSortOrderMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(reorderTenderResponseSectionsResponseTotalMin),
  "limit": zod.int().min(1).max(reorderTenderResponseSectionsResponseLimitMax),
  "offset": zod.int().min(reorderTenderResponseSectionsResponseOffsetMin)
})


/**
 * @summary Update a response section with optimistic concurrency
 */
export const updateTenderResponseSectionParams = zod.object({
  "id": zod.uuid(),
  "sectionId": zod.uuid()
})


export const updateTenderResponseSectionBodyKeyMax = 100;

export const updateTenderResponseSectionBodyTitleMax = 300;



export const updateTenderResponseSectionBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "key": zod.string().min(1).max(updateTenderResponseSectionBodyKeyMax).optional(),
  "title": zod.string().min(1).max(updateTenderResponseSectionBodyTitleMax).optional(),
  "content": zod.record(zod.string(), zod.unknown()).optional()
})

export const updateTenderResponseSectionResponseKeyMax = 100;

export const updateTenderResponseSectionResponseTitleMax = 300;

export const updateTenderResponseSectionResponseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const updateTenderResponseSectionResponseSortOrderMin = 0;



export const updateTenderResponseSectionResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "key": zod.string().min(1).max(updateTenderResponseSectionResponseKeyMax),
  "title": zod.string().min(1).max(updateTenderResponseSectionResponseTitleMax),
  "content": zod.record(zod.string(), zod.unknown()),
  "contentHash": zod.string().regex(updateTenderResponseSectionResponseContentHashRegExp),
  "revision": zod.int().min(1),
  "sortOrder": zod.int().min(updateTenderResponseSectionResponseSortOrderMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete an unmapped response section
 */
export const deleteTenderResponseSectionParams = zod.object({
  "id": zod.uuid(),
  "sectionId": zod.uuid()
})

export const deleteTenderResponseSectionResponse = zod.void()


/**
 * @summary List the ordered requirement-to-answer matrix
 */
export const listTenderRequirementsParams = zod.object({
  "id": zod.uuid()
})

export const listTenderRequirementsQueryLimitDefault = 50;
export const listTenderRequirementsQueryLimitMax = 100;

export const listTenderRequirementsQueryOffsetDefault = 0;
export const listTenderRequirementsQueryOffsetMin = 0;



export const listTenderRequirementsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderRequirementsQueryLimitMax).default(listTenderRequirementsQueryLimitDefault),
  "offset": zod.int().min(listTenderRequirementsQueryOffsetMin).default(listTenderRequirementsQueryOffsetDefault)
})

export const listTenderRequirementsResponseDataItemConstraintsWordLimitMax = 100000;

export const listTenderRequirementsResponseDataItemConstraintsNotesItemMax = 1000;

export const listTenderRequirementsResponseDataItemConstraintsNotesMax = 20;

export const listTenderRequirementsResponseDataItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listTenderRequirementsResponseDataItemSortOrderMin = 0;

export const listTenderRequirementsResponseTotalMin = 0;

export const listTenderRequirementsResponseLimitMax = 500;

export const listTenderRequirementsResponseOffsetMin = 0;



export const listTenderRequirementsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "requirementKey": zod.string(),
  "buyerReference": zod.string().nullish(),
  "text": zod.string(),
  "constraints": zod.object({
  "designation": zod.enum(['mandatory', 'optional']),
  "wordLimit": zod.int().min(1).max(listTenderRequirementsResponseDataItemConstraintsWordLimitMax).nullish(),
  "notes": zod.array(zod.string().min(1).max(listTenderRequirementsResponseDataItemConstraintsNotesItemMax)).max(listTenderRequirementsResponseDataItemConstraintsNotesMax).optional(),
  "authorConfirmed": zod.boolean()
}),
  "sourceId": zod.uuid().nullish(),
  "sourceRevision": zod.string().nullable(),
  "sourceHash": zod.string().regex(listTenderRequirementsResponseDataItemSourceHashRegExp).nullable(),
  "sourceLocation": zod.string().nullish(),
  "responseSectionId": zod.uuid().nullish(),
  "reviewStatus": zod.enum(['proposed', 'confirmed', 'rejected']),
  "coverageStatus": zod.enum(['unaddressed', 'partial', 'covered', 'not_applicable']),
  "authorConfirmed": zod.boolean(),
  "revision": zod.int().min(1),
  "sortOrder": zod.int().min(listTenderRequirementsResponseDataItemSortOrderMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderRequirementsResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderRequirementsResponseLimitMax),
  "offset": zod.int().min(listTenderRequirementsResponseOffsetMin)
})


/**
 * @summary Add a manual or source-backed tender requirement
 */
export const createTenderRequirementParams = zod.object({
  "id": zod.uuid()
})

export const createTenderRequirementBodyRequirementKeyMax = 100;

export const createTenderRequirementBodyBuyerReferenceMax = 500;

export const createTenderRequirementBodyTextMax = 20000;

export const createTenderRequirementBodyConstraintsWordLimitMax = 100000;

export const createTenderRequirementBodyConstraintsNotesItemMax = 1000;

export const createTenderRequirementBodyConstraintsNotesMax = 20;

export const createTenderRequirementBodySourceLocationMax = 1000;



export const createTenderRequirementBody = zod.object({
  "requirementKey": zod.string().min(1).max(createTenderRequirementBodyRequirementKeyMax),
  "buyerReference": zod.string().max(createTenderRequirementBodyBuyerReferenceMax).nullish(),
  "text": zod.string().min(1).max(createTenderRequirementBodyTextMax),
  "constraints": zod.object({
  "designation": zod.enum(['mandatory', 'optional']),
  "wordLimit": zod.int().min(1).max(createTenderRequirementBodyConstraintsWordLimitMax).nullish(),
  "notes": zod.array(zod.string().min(1).max(createTenderRequirementBodyConstraintsNotesItemMax)).max(createTenderRequirementBodyConstraintsNotesMax).optional(),
  "authorConfirmed": zod.boolean()
}),
  "sourceId": zod.uuid().nullish(),
  "sourceLocation": zod.string().max(createTenderRequirementBodySourceLocationMax).nullish(),
  "responseSectionId": zod.uuid().nullish(),
  "reviewStatus": zod.enum(['proposed', 'confirmed', 'rejected']).optional()
})

export const createTenderRequirementResponseConstraintsWordLimitMax = 100000;

export const createTenderRequirementResponseConstraintsNotesItemMax = 1000;

export const createTenderRequirementResponseConstraintsNotesMax = 20;

export const createTenderRequirementResponseSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const createTenderRequirementResponseSortOrderMin = 0;



export const createTenderRequirementResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "requirementKey": zod.string(),
  "buyerReference": zod.string().nullish(),
  "text": zod.string(),
  "constraints": zod.object({
  "designation": zod.enum(['mandatory', 'optional']),
  "wordLimit": zod.int().min(1).max(createTenderRequirementResponseConstraintsWordLimitMax).nullish(),
  "notes": zod.array(zod.string().min(1).max(createTenderRequirementResponseConstraintsNotesItemMax)).max(createTenderRequirementResponseConstraintsNotesMax).optional(),
  "authorConfirmed": zod.boolean()
}),
  "sourceId": zod.uuid().nullish(),
  "sourceRevision": zod.string().nullable(),
  "sourceHash": zod.string().regex(createTenderRequirementResponseSourceHashRegExp).nullable(),
  "sourceLocation": zod.string().nullish(),
  "responseSectionId": zod.uuid().nullish(),
  "reviewStatus": zod.enum(['proposed', 'confirmed', 'rejected']),
  "coverageStatus": zod.enum(['unaddressed', 'partial', 'covered', 'not_applicable']),
  "authorConfirmed": zod.boolean(),
  "revision": zod.int().min(1),
  "sortOrder": zod.int().min(createTenderRequirementResponseSortOrderMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Reorder every requirement using stable identifiers
 */
export const reorderTenderRequirementsParams = zod.object({
  "id": zod.uuid()
})

export const reorderTenderRequirementsBodyOrderedIdsMax = 500;



export const reorderTenderRequirementsBody = zod.object({
  "orderedIds": zod.array(zod.uuid()).max(reorderTenderRequirementsBodyOrderedIdsMax)
})

export const reorderTenderRequirementsResponseDataItemConstraintsWordLimitMax = 100000;

export const reorderTenderRequirementsResponseDataItemConstraintsNotesItemMax = 1000;

export const reorderTenderRequirementsResponseDataItemConstraintsNotesMax = 20;

export const reorderTenderRequirementsResponseDataItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const reorderTenderRequirementsResponseDataItemSortOrderMin = 0;

export const reorderTenderRequirementsResponseTotalMin = 0;

export const reorderTenderRequirementsResponseLimitMax = 500;

export const reorderTenderRequirementsResponseOffsetMin = 0;



export const reorderTenderRequirementsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "requirementKey": zod.string(),
  "buyerReference": zod.string().nullish(),
  "text": zod.string(),
  "constraints": zod.object({
  "designation": zod.enum(['mandatory', 'optional']),
  "wordLimit": zod.int().min(1).max(reorderTenderRequirementsResponseDataItemConstraintsWordLimitMax).nullish(),
  "notes": zod.array(zod.string().min(1).max(reorderTenderRequirementsResponseDataItemConstraintsNotesItemMax)).max(reorderTenderRequirementsResponseDataItemConstraintsNotesMax).optional(),
  "authorConfirmed": zod.boolean()
}),
  "sourceId": zod.uuid().nullish(),
  "sourceRevision": zod.string().nullable(),
  "sourceHash": zod.string().regex(reorderTenderRequirementsResponseDataItemSourceHashRegExp).nullable(),
  "sourceLocation": zod.string().nullish(),
  "responseSectionId": zod.uuid().nullish(),
  "reviewStatus": zod.enum(['proposed', 'confirmed', 'rejected']),
  "coverageStatus": zod.enum(['unaddressed', 'partial', 'covered', 'not_applicable']),
  "authorConfirmed": zod.boolean(),
  "revision": zod.int().min(1),
  "sortOrder": zod.int().min(reorderTenderRequirementsResponseDataItemSortOrderMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(reorderTenderRequirementsResponseTotalMin),
  "limit": zod.int().min(1).max(reorderTenderRequirementsResponseLimitMax),
  "offset": zod.int().min(reorderTenderRequirementsResponseOffsetMin)
})


/**
 * @summary Correct or map a requirement with optimistic concurrency
 */
export const updateTenderRequirementParams = zod.object({
  "id": zod.uuid(),
  "requirementId": zod.uuid()
})


export const updateTenderRequirementBodyRequirementKeyMax = 100;

export const updateTenderRequirementBodyBuyerReferenceMax = 500;

export const updateTenderRequirementBodyTextMax = 20000;

export const updateTenderRequirementBodyConstraintsWordLimitMax = 100000;

export const updateTenderRequirementBodyConstraintsNotesItemMax = 1000;

export const updateTenderRequirementBodyConstraintsNotesMax = 20;

export const updateTenderRequirementBodySourceLocationMax = 1000;



export const updateTenderRequirementBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "requirementKey": zod.string().min(1).max(updateTenderRequirementBodyRequirementKeyMax).optional(),
  "buyerReference": zod.string().max(updateTenderRequirementBodyBuyerReferenceMax).nullish(),
  "text": zod.string().min(1).max(updateTenderRequirementBodyTextMax).optional(),
  "constraints": zod.object({
  "designation": zod.enum(['mandatory', 'optional']),
  "wordLimit": zod.int().min(1).max(updateTenderRequirementBodyConstraintsWordLimitMax).nullish(),
  "notes": zod.array(zod.string().min(1).max(updateTenderRequirementBodyConstraintsNotesItemMax)).max(updateTenderRequirementBodyConstraintsNotesMax).optional(),
  "authorConfirmed": zod.boolean()
}).optional(),
  "sourceId": zod.uuid().nullish(),
  "sourceLocation": zod.string().max(updateTenderRequirementBodySourceLocationMax).nullish(),
  "responseSectionId": zod.uuid().nullish(),
  "reviewStatus": zod.enum(['proposed', 'confirmed', 'rejected']).optional()
})

export const updateTenderRequirementResponseConstraintsWordLimitMax = 100000;

export const updateTenderRequirementResponseConstraintsNotesItemMax = 1000;

export const updateTenderRequirementResponseConstraintsNotesMax = 20;

export const updateTenderRequirementResponseSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const updateTenderRequirementResponseSortOrderMin = 0;



export const updateTenderRequirementResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "requirementKey": zod.string(),
  "buyerReference": zod.string().nullish(),
  "text": zod.string(),
  "constraints": zod.object({
  "designation": zod.enum(['mandatory', 'optional']),
  "wordLimit": zod.int().min(1).max(updateTenderRequirementResponseConstraintsWordLimitMax).nullish(),
  "notes": zod.array(zod.string().min(1).max(updateTenderRequirementResponseConstraintsNotesItemMax)).max(updateTenderRequirementResponseConstraintsNotesMax).optional(),
  "authorConfirmed": zod.boolean()
}),
  "sourceId": zod.uuid().nullish(),
  "sourceRevision": zod.string().nullable(),
  "sourceHash": zod.string().regex(updateTenderRequirementResponseSourceHashRegExp).nullable(),
  "sourceLocation": zod.string().nullish(),
  "responseSectionId": zod.uuid().nullish(),
  "reviewStatus": zod.enum(['proposed', 'confirmed', 'rejected']),
  "coverageStatus": zod.enum(['unaddressed', 'partial', 'covered', 'not_applicable']),
  "authorConfirmed": zod.boolean(),
  "revision": zod.int().min(1),
  "sortOrder": zod.int().min(updateTenderRequirementResponseSortOrderMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a requirement and its requirement-scoped evidence mappings
 */
export const deleteTenderRequirementParams = zod.object({
  "id": zod.uuid(),
  "requirementId": zod.uuid()
})

export const deleteTenderRequirementResponse = zod.void()


/**
 * @summary Discover traceable tender-private and authorized entity evidence
 */
export const searchTenderEvidenceParams = zod.object({
  "id": zod.uuid()
})

export const searchTenderEvidenceQueryQMin = 2;
export const searchTenderEvidenceQueryQMax = 500;

export const searchTenderEvidenceQueryLimitDefault = 10;
export const searchTenderEvidenceQueryLimitMax = 25;



export const searchTenderEvidenceQueryParams = zod.object({
  "workspaceId": zod.uuid().optional(),
  "q": zod.string().min(searchTenderEvidenceQueryQMin).max(searchTenderEvidenceQueryQMax),
  "mode": zod.enum(['selected_only', 'entity_wide']),
  "limit": zod.int().min(1).max(searchTenderEvidenceQueryLimitMax).default(searchTenderEvidenceQueryLimitDefault)
})

export const searchTenderEvidenceResponseWorkspaceEvidenceContextFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const searchTenderEvidenceResponseWorkspaceEvidenceQueryHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const searchTenderEvidenceResponseWorkspaceEvidenceChannelDefault = `agent`;
export const searchTenderEvidenceResponseWorkspaceEvidenceMaxEvidenceCharsMin = 2000;
export const searchTenderEvidenceResponseWorkspaceEvidenceMaxEvidenceCharsMax = 24000;

export const searchTenderEvidenceResponseWorkspaceEvidenceMaxPassagesMin = 2;
export const searchTenderEvidenceResponseWorkspaceEvidenceMaxPassagesMax = 24;

export const searchTenderEvidenceResponseWorkspaceEvidenceMessageMax = 1000;

export const searchTenderEvidenceResponseWorkspaceEvidenceBackgroundStateMax = 100;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemCitationMax = 24;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemCrmIdentityMax = 150;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemSourceVersionMax = 200;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemExcerptHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemLabelMax = 500;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemLocationMax = 500;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemExcerptMax = 2000;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemScoreMin = 0;
export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemScoreMax = 1;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemStartMin = 0;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesItemEndMin = 0;

export const searchTenderEvidenceResponseWorkspaceEvidencePassagesMax = 24;

export const searchTenderEvidenceResponseWorkspaceEvidenceSourcesItemMessageMax = 1000;

export const searchTenderEvidenceResponseWorkspaceEvidenceSourcesMax = 100;

export const searchTenderEvidenceResponseWorkspaceEvidenceWarningsItemMax = 1000;

export const searchTenderEvidenceResponseWorkspaceEvidenceWarningsMax = 100;

export const searchTenderEvidenceResponseItemsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const searchTenderEvidenceResponseItemsMax = 25;

export const searchTenderEvidenceResponseSourceStatesMax = 250;



export const searchTenderEvidenceResponse = zod.object({
  "workspaceEvidence": zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "workspaceId": zod.uuid(),
  "workspaceRevision": zod.uuid(),
  "contextFingerprint": zod.string().regex(searchTenderEvidenceResponseWorkspaceEvidenceContextFingerprintRegExp),
  "queryHash": zod.string().regex(searchTenderEvidenceResponseWorkspaceEvidenceQueryHashRegExp),
  "channel": zod.enum(['agent', 'quotes', 'guidance', 'content_generate']).default(searchTenderEvidenceResponseWorkspaceEvidenceChannelDefault),
  "retrievalMode": zod.enum(['lexical']),
  "maxEvidenceChars": zod.int().min(searchTenderEvidenceResponseWorkspaceEvidenceMaxEvidenceCharsMin).max(searchTenderEvidenceResponseWorkspaceEvidenceMaxEvidenceCharsMax),
  "maxPassages": zod.int().min(searchTenderEvidenceResponseWorkspaceEvidenceMaxPassagesMin).max(searchTenderEvidenceResponseWorkspaceEvidenceMaxPassagesMax),
  "state": zod.enum(['ready', 'partial', 'insufficient', 'conflicting', 'unavailable']),
  "message": zod.string().min(1).max(searchTenderEvidenceResponseWorkspaceEvidenceMessageMax),
  "backgroundState": zod.string().min(1).max(searchTenderEvidenceResponseWorkspaceEvidenceBackgroundStateMax),
  "passages": zod.array(zod.object({
  "id": zod.uuid(),
  "citation": zod.int().min(1).max(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemCitationMax),
  "kind": zod.enum(['workspace', 'knowledge', 'crm']),
  "tier": zod.enum(['primary', 'background']),
  "reason": zod.enum(['automatic', 'explicit', 'entity_background']),
  "role": zod.enum(['provided', 'working', 'submission']).nullable(),
  "membershipId": zod.uuid().nullable(),
  "membershipRevision": zod.uuid().nullable(),
  "folderRevision": zod.uuid().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "extractionRevision": zod.uuid().nullable(),
  "libraryEntryId": zod.uuid().nullable(),
  "managedDocumentId": zod.uuid().nullable(),
  "fileId": zod.uuid().nullable(),
  "managedVersionId": zod.uuid().nullable(),
  "tenderSourceId": zod.uuid().nullable(),
  "knowledgeFileId": zod.uuid().nullable(),
  "indexDocumentId": zod.uuid().nullable(),
  "chunkId": zod.uuid().nullable(),
  "crmIdentity": zod.string().min(1).max(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemCrmIdentityMax).nullable(),
  "sourceVersion": zod.string().min(1).max(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemSourceVersionMax),
  "contentHash": zod.string().regex(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemContentHashRegExp),
  "excerptHash": zod.string().regex(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemExcerptHashRegExp),
  "label": zod.string().min(1).max(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemLabelMax),
  "location": zod.string().min(1).max(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemLocationMax),
  "excerpt": zod.string().min(1).max(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemExcerptMax),
  "score": zod.number().min(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemScoreMin).max(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemScoreMax),
  "start": zod.int().min(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemStartMin).nullable(),
  "end": zod.int().min(searchTenderEvidenceResponseWorkspaceEvidencePassagesItemEndMin).nullable()
})).max(searchTenderEvidenceResponseWorkspaceEvidencePassagesMax),
  "sources": zod.array(zod.object({
  "membershipId": zod.uuid(),
  "role": zod.enum(['provided', 'working', 'submission']),
  "state": zod.enum(['excluded', 'stored', 'pending', 'ready', 'unsupported', 'failed', 'denied', 'stale', 'unavailable', 'irrelevant', 'omitted_budget']),
  "message": zod.string().min(1).max(searchTenderEvidenceResponseWorkspaceEvidenceSourcesItemMessageMax)
})).max(searchTenderEvidenceResponseWorkspaceEvidenceSourcesMax),
  "warnings": zod.array(zod.string().min(1).max(searchTenderEvidenceResponseWorkspaceEvidenceWarningsItemMax)).max(searchTenderEvidenceResponseWorkspaceEvidenceWarningsMax)
}).optional(),
  "mode": zod.enum(['selected_only', 'entity_wide']),
  "items": zod.array(zod.object({
  "candidateId": zod.string(),
  "sourceType": zod.enum(['tender_source', 'knowledge']),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.string(),
  "sourceHash": zod.string().regex(searchTenderEvidenceResponseItemsItemSourceHashRegExp),
  "title": zod.string(),
  "location": zod.string(),
  "excerpt": zod.string(),
  "state": zod.enum(['valid', 'missing', 'stale', 'conflicting', 'denied', 'unsupported']),
  "message": zod.string(),
  "channelEligible": zod.boolean(),
  "selected": zod.boolean(),
  "score": zod.number()
})).max(searchTenderEvidenceResponseItemsMax),
  "sourceStates": zod.array(zod.object({
  "sourceType": zod.enum(['tender_source', 'knowledge']),
  "sourceId": zod.uuid(),
  "title": zod.string(),
  "revision": zod.string(),
  "state": zod.enum(['valid', 'missing', 'stale', 'conflicting', 'denied', 'unsupported']),
  "message": zod.string(),
  "channelEligible": zod.boolean()
})).max(searchTenderEvidenceResponseSourceStatesMax),
  "state": zod.enum(['ready', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'empty_index', 'no_sources', 'low_confidence']),
  "message": zod.string()
})


/**
 * @summary List selected evidence with current validation state
 */
export const listTenderEvidenceParams = zod.object({
  "id": zod.uuid()
})

export const listTenderEvidenceQueryLimitDefault = 50;
export const listTenderEvidenceQueryLimitMax = 100;

export const listTenderEvidenceQueryOffsetDefault = 0;
export const listTenderEvidenceQueryOffsetMin = 0;



export const listTenderEvidenceQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderEvidenceQueryLimitMax).default(listTenderEvidenceQueryLimitDefault),
  "offset": zod.int().min(listTenderEvidenceQueryOffsetMin).default(listTenderEvidenceQueryOffsetDefault)
})

export const listTenderEvidenceResponseDataItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderEvidenceResponseTotalMin = 0;

export const listTenderEvidenceResponseLimitMax = 100;

export const listTenderEvidenceResponseOffsetMin = 0;



export const listTenderEvidenceResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "requirementId": zod.uuid().nullish(),
  "sourceType": zod.enum(['tender_source', 'knowledge']),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.string(),
  "sourceHash": zod.string().regex(listTenderEvidenceResponseDataItemSourceHashRegExp),
  "location": zod.string(),
  "excerpt": zod.string(),
  "eligibility": zod.record(zod.string(), zod.unknown()),
  "validationState": zod.enum(['valid', 'missing', 'stale', 'conflicting', 'denied', 'unsupported']),
  "validationMessage": zod.string(),
  "selectedByAppUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderEvidenceResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderEvidenceResponseLimitMax),
  "offset": zod.int().min(listTenderEvidenceResponseOffsetMin)
})


/**
 * @summary Pin one exact evidence revision and excerpt
 */
export const selectTenderEvidenceParams = zod.object({
  "id": zod.uuid()
})

export const selectTenderEvidenceBodySourceRevisionMax = 300;

export const selectTenderEvidenceBodyLocationMax = 1000;



export const selectTenderEvidenceBody = zod.object({
  "requirementId": zod.uuid().nullish(),
  "sourceType": zod.enum(['tender_source', 'knowledge']),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.string().min(1).max(selectTenderEvidenceBodySourceRevisionMax),
  "location": zod.string().min(1).max(selectTenderEvidenceBodyLocationMax),
  "discoveryMode": zod.enum(['selected_only', 'entity_wide'])
})

export const selectTenderEvidenceResponseSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const selectTenderEvidenceResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "requirementId": zod.uuid().nullish(),
  "sourceType": zod.enum(['tender_source', 'knowledge']),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.string(),
  "sourceHash": zod.string().regex(selectTenderEvidenceResponseSourceHashRegExp),
  "location": zod.string(),
  "excerpt": zod.string(),
  "eligibility": zod.record(zod.string(), zod.unknown()),
  "validationState": zod.enum(['valid', 'missing', 'stale', 'conflicting', 'denied', 'unsupported']),
  "validationMessage": zod.string(),
  "selectedByAppUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Remove one selected evidence mapping
 */
export const deleteTenderEvidenceParams = zod.object({
  "id": zod.uuid(),
  "evidenceId": zod.uuid()
})

export const deleteTenderEvidenceResponse = zod.void()


/**
 * @summary Evaluate deterministic requirement coverage and constraints
 */
export const getTenderCoverageParams = zod.object({
  "id": zod.uuid()
})

export const getTenderCoverageResponseItemsItemWordCountMin = 0;


export const getTenderCoverageResponseTotalMin = 0;

export const getTenderCoverageResponseCoveredMin = 0;

export const getTenderCoverageResponsePartialMin = 0;

export const getTenderCoverageResponseUnaddressedMin = 0;

export const getTenderCoverageResponseNotApplicableMin = 0;



export const getTenderCoverageResponse = zod.object({
  "items": zod.array(zod.object({
  "requirementId": zod.uuid(),
  "requirementKey": zod.string(),
  "status": zod.enum(['unaddressed', 'partial', 'covered', 'not_applicable']),
  "wordCount": zod.int().min(getTenderCoverageResponseItemsItemWordCountMin),
  "wordLimit": zod.int().min(1).nullable(),
  "evidenceStates": zod.array(zod.enum(['valid', 'missing', 'stale', 'conflicting', 'denied', 'unsupported'])),
  "warnings": zod.array(zod.string())
})),
  "total": zod.int().min(getTenderCoverageResponseTotalMin),
  "covered": zod.int().min(getTenderCoverageResponseCoveredMin),
  "partial": zod.int().min(getTenderCoverageResponsePartialMin),
  "unaddressed": zod.int().min(getTenderCoverageResponseUnaddressedMin),
  "notApplicable": zod.int().min(getTenderCoverageResponseNotApplicableMin),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "basis": zod.enum(['deterministic_section_content_constraints_and_pinned_evidence'])
})


/**
 * @summary List durable AI runs for a tender
 */
export const listTenderAiRunsParams = zod.object({
  "id": zod.uuid()
})

export const listTenderAiRunsQueryLimitDefault = 50;
export const listTenderAiRunsQueryLimitMax = 100;

export const listTenderAiRunsQueryOffsetDefault = 0;
export const listTenderAiRunsQueryOffsetMin = 0;



export const listTenderAiRunsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderAiRunsQueryLimitMax).default(listTenderAiRunsQueryLimitDefault),
  "offset": zod.int().min(listTenderAiRunsQueryOffsetMin).default(listTenderAiRunsQueryOffsetDefault)
})

export const listTenderAiRunsResponseDataItemWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderAiRunsResponseDataItemInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderAiRunsResponseDataItemProgressCompletedMin = 0;


export const listTenderAiRunsResponseDataItemAttemptCountMin = 0;

export const listTenderAiRunsResponseDataItemMaxAttemptsMax = 5;

export const listTenderAiRunsResponseTotalMin = 0;

export const listTenderAiRunsResponseLimitMax = 100;

export const listTenderAiRunsResponseOffsetMin = 0;



export const listTenderAiRunsResponse = zod.object({
  "data": zod.array(zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(listTenderAiRunsResponseDataItemWorkspaceContextManifestHashRegExp)
}).optional(),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "modelId": zod.string(),
  "settings": zod.record(zod.string(), zod.unknown()),
  "inputHash": zod.string().regex(listTenderAiRunsResponseDataItemInputHashRegExp),
  "progressCompleted": zod.int().min(listTenderAiRunsResponseDataItemProgressCompletedMin),
  "progressTotal": zod.int().min(1),
  "attemptCount": zod.int().min(listTenderAiRunsResponseDataItemAttemptCountMin),
  "maxAttempts": zod.int().min(1).max(listTenderAiRunsResponseDataItemMaxAttemptsMax),
  "cancelRequested": zod.boolean(),
  "usage": zod.record(zod.string(), zod.unknown()).nullish(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderAiRunsResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderAiRunsResponseLimitMax),
  "offset": zod.int().min(listTenderAiRunsResponseOffsetMin)
})


/**
 * @summary Queue a source-grounded tender AI proposal run
 */
export const createTenderAiRunParams = zod.object({
  "id": zod.uuid()
})

export const createTenderAiRunHeaderIdempotencyKeyMax = 128;



export const createTenderAiRunHeader = zod.object({
  "Idempotency-Key": zod.string().min(1).max(createTenderAiRunHeaderIdempotencyKeyMax)
})

export const createTenderAiRunBodyWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderAiRunBodyModelChoiceIdMax = 64;

export const createTenderAiRunBodyMaxOutputTokensMax = 131072;

export const createTenderAiRunBodyTimeoutMsMin = 1000;
export const createTenderAiRunBodyTimeoutMsMax = 120000;

export const createTenderAiRunBodyInstructionMax = 4000;

export const createTenderAiRunBodyTargetRequirementIdsMax = 250;



export const createTenderAiRunBody = zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(createTenderAiRunBodyWorkspaceContextManifestHashRegExp)
}).optional(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "modelChoiceId": zod.string().min(1).max(createTenderAiRunBodyModelChoiceIdMax).optional(),
  "reasoningEffort": zod.enum(['none', 'minimal', 'low', 'medium', 'high', 'xhigh']).optional(),
  "maxOutputTokens": zod.int().min(1).max(createTenderAiRunBodyMaxOutputTokensMax).optional(),
  "timeoutMs": zod.int().min(createTenderAiRunBodyTimeoutMsMin).max(createTenderAiRunBodyTimeoutMsMax).optional(),
  "instruction": zod.string().max(createTenderAiRunBodyInstructionMax).optional(),
  "targetSectionId": zod.uuid().nullish(),
  "targetRequirementIds": zod.array(zod.uuid()).max(createTenderAiRunBodyTargetRequirementIdsMax).optional(),
  "discoveryMode": zod.enum(['selected_only', 'entity_wide'])
})

export const createTenderAiRunResponseWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderAiRunResponseInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderAiRunResponseProgressCompletedMin = 0;


export const createTenderAiRunResponseAttemptCountMin = 0;

export const createTenderAiRunResponseMaxAttemptsMax = 5;



export const createTenderAiRunResponse = zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(createTenderAiRunResponseWorkspaceContextManifestHashRegExp)
}).optional(),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "modelId": zod.string(),
  "settings": zod.record(zod.string(), zod.unknown()),
  "inputHash": zod.string().regex(createTenderAiRunResponseInputHashRegExp),
  "progressCompleted": zod.int().min(createTenderAiRunResponseProgressCompletedMin),
  "progressTotal": zod.int().min(1),
  "attemptCount": zod.int().min(createTenderAiRunResponseAttemptCountMin),
  "maxAttempts": zod.int().min(1).max(createTenderAiRunResponseMaxAttemptsMax),
  "cancelRequested": zod.boolean(),
  "usage": zod.record(zod.string(), zod.unknown()).nullish(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get durable AI run progress and provenance
 */
export const getTenderAiRunParams = zod.object({
  "id": zod.uuid(),
  "runId": zod.uuid()
})

export const getTenderAiRunResponseWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getTenderAiRunResponseInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getTenderAiRunResponseProgressCompletedMin = 0;


export const getTenderAiRunResponseAttemptCountMin = 0;

export const getTenderAiRunResponseMaxAttemptsMax = 5;



export const getTenderAiRunResponse = zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(getTenderAiRunResponseWorkspaceContextManifestHashRegExp)
}).optional(),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "modelId": zod.string(),
  "settings": zod.record(zod.string(), zod.unknown()),
  "inputHash": zod.string().regex(getTenderAiRunResponseInputHashRegExp),
  "progressCompleted": zod.int().min(getTenderAiRunResponseProgressCompletedMin),
  "progressTotal": zod.int().min(1),
  "attemptCount": zod.int().min(getTenderAiRunResponseAttemptCountMin),
  "maxAttempts": zod.int().min(1).max(getTenderAiRunResponseMaxAttemptsMax),
  "cancelRequested": zod.boolean(),
  "usage": zod.record(zod.string(), zod.unknown()).nullish(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Request cancellation without discarding saved human work
 */
export const cancelTenderAiRunParams = zod.object({
  "id": zod.uuid(),
  "runId": zod.uuid()
})

export const cancelTenderAiRunResponseWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelTenderAiRunResponseInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const cancelTenderAiRunResponseProgressCompletedMin = 0;


export const cancelTenderAiRunResponseAttemptCountMin = 0;

export const cancelTenderAiRunResponseMaxAttemptsMax = 5;



export const cancelTenderAiRunResponse = zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(cancelTenderAiRunResponseWorkspaceContextManifestHashRegExp)
}).optional(),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "modelId": zod.string(),
  "settings": zod.record(zod.string(), zod.unknown()),
  "inputHash": zod.string().regex(cancelTenderAiRunResponseInputHashRegExp),
  "progressCompleted": zod.int().min(cancelTenderAiRunResponseProgressCompletedMin),
  "progressTotal": zod.int().min(1),
  "attemptCount": zod.int().min(cancelTenderAiRunResponseAttemptCountMin),
  "maxAttempts": zod.int().min(1).max(cancelTenderAiRunResponseMaxAttemptsMax),
  "cancelRequested": zod.boolean(),
  "usage": zod.record(zod.string(), zod.unknown()).nullish(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Requeue a recoverable failed AI run within its retry limit
 */
export const retryTenderAiRunParams = zod.object({
  "id": zod.uuid(),
  "runId": zod.uuid()
})

export const retryTenderAiRunResponseWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const retryTenderAiRunResponseInputHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const retryTenderAiRunResponseProgressCompletedMin = 0;


export const retryTenderAiRunResponseAttemptCountMin = 0;

export const retryTenderAiRunResponseMaxAttemptsMax = 5;



export const retryTenderAiRunResponse = zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(retryTenderAiRunResponseWorkspaceContextManifestHashRegExp)
}).optional(),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'failed', 'cancelled']),
  "modelId": zod.string(),
  "settings": zod.record(zod.string(), zod.unknown()),
  "inputHash": zod.string().regex(retryTenderAiRunResponseInputHashRegExp),
  "progressCompleted": zod.int().min(retryTenderAiRunResponseProgressCompletedMin),
  "progressTotal": zod.int().min(1),
  "attemptCount": zod.int().min(retryTenderAiRunResponseAttemptCountMin),
  "maxAttempts": zod.int().min(1).max(retryTenderAiRunResponseMaxAttemptsMax),
  "cancelRequested": zod.boolean(),
  "usage": zod.record(zod.string(), zod.unknown()).nullish(),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List immutable AI proposals awaiting an author decision
 */
export const listTenderProposalsParams = zod.object({
  "id": zod.uuid()
})

export const listTenderProposalsQueryLimitDefault = 50;
export const listTenderProposalsQueryLimitMax = 100;

export const listTenderProposalsQueryOffsetDefault = 0;
export const listTenderProposalsQueryOffsetMin = 0;



export const listTenderProposalsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderProposalsQueryLimitMax).default(listTenderProposalsQueryLimitDefault),
  "offset": zod.int().min(listTenderProposalsQueryOffsetMin).default(listTenderProposalsQueryOffsetDefault)
})


export const listTenderProposalsResponseDataItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderProposalsResponseTotalMin = 0;

export const listTenderProposalsResponseLimitMax = 100;

export const listTenderProposalsResponseOffsetMin = 0;



export const listTenderProposalsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "runId": zod.uuid(),
  "targetType": zod.enum(['tender', 'requirement', 'section']),
  "targetId": zod.uuid().nullish(),
  "baseRevision": zod.int().min(1),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "content": zod.record(zod.string(), zod.unknown()),
  "citations": zod.array(zod.record(zod.string(), zod.unknown())),
  "contentHash": zod.string().regex(listTenderProposalsResponseDataItemContentHashRegExp),
  "decisionNote": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "total": zod.int().min(listTenderProposalsResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderProposalsResponseLimitMax),
  "offset": zod.int().min(listTenderProposalsResponseOffsetMin)
})


/**
 * @summary Accept or reject a proposal against its exact base revision
 */
export const decideTenderProposalParams = zod.object({
  "id": zod.uuid(),
  "proposalId": zod.uuid()
})

export const decideTenderProposalBodyNoteMax = 2000;



export const decideTenderProposalBody = zod.object({
  "decision": zod.enum(['accept', 'reject']),
  "note": zod.string().max(decideTenderProposalBodyNoteMax).optional()
})


export const decideTenderProposalResponseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const decideTenderProposalResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "runId": zod.uuid(),
  "targetType": zod.enum(['tender', 'requirement', 'section']),
  "targetId": zod.uuid().nullish(),
  "baseRevision": zod.int().min(1),
  "kind": zod.enum(['requirement_extraction', 'outline', 'section_draft', 'rewrite', 'whole_response', 'compliance_check']),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "content": zod.record(zod.string(), zod.unknown()),
  "citations": zod.array(zod.record(zod.string(), zod.unknown())),
  "contentHash": zod.string().regex(decideTenderProposalResponseContentHashRegExp),
  "decisionNote": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish()
})


/**
 * @summary List immutable response-package checkpoints
 */
export const listTenderPackagesParams = zod.object({
  "id": zod.uuid()
})

export const listTenderPackagesQueryLimitDefault = 50;
export const listTenderPackagesQueryLimitMax = 100;

export const listTenderPackagesQueryOffsetDefault = 0;
export const listTenderPackagesQueryOffsetMin = 0;



export const listTenderPackagesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderPackagesQueryLimitMax).default(listTenderPackagesQueryLimitDefault),
  "offset": zod.int().min(listTenderPackagesQueryOffsetMin).default(listTenderPackagesQueryOffsetDefault)
})


export const listTenderPackagesResponseDataItemSnapshotBidSignedScansMax = 10;

export const listTenderPackagesResponseDataItemSnapshotBidDocumentsMax = 60;



export const listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneTemplateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneInspectionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneMappingHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneEntriesItemTargetIdMax = 300;

export const listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneEntriesItemRequirementKeyMax = 100;

export const listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneEntriesMax = 500;



export const listTenderPackagesResponseDataItemSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderPackagesResponseTotalMin = 0;

export const listTenderPackagesResponseLimitMax = 100;

export const listTenderPackagesResponseOffsetMin = 0;



export const listTenderPackagesResponse = zod.object({
  "data": zod.array(zod.object({
  "current": zod.boolean().optional().describe('Current content and evidence still match this checkpoint.'),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "revisionNo": zod.int().min(1),
  "snapshot": zod.object({
  "bid": zod.object({
  "version": zod.literal(1),
  "policyVersion": zod.string(),
  "planRevisionId": zod.uuid(),
  "fingerprint": zod.string(),
  "supplierName": zod.string(),
  "signedScans": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "fileId": zod.uuid(),
  "hash": zod.string(),
  "revision": zod.string(),
  "filename": zod.string()
})).max(listTenderPackagesResponseDataItemSnapshotBidSignedScansMax).optional(),
  "documents": zod.array(zod.object({
  "key": zod.string(),
  "documentId": zod.uuid(),
  "versionId": zod.uuid().nullable(),
  "title": zod.string(),
  "revision": zod.int(),
  "contentHash": zod.string(),
  "content": zod.record(zod.string(), zod.unknown()),
  "requirementIds": zod.array(zod.uuid()),
  "role": zod.enum(['appendix_1', 'summary', 'schedule_1', 'schedule_2', 'schedule_3', 'case_study', 'other'])
})).max(listTenderPackagesResponseDataItemSnapshotBidDocumentsMax),
  "blockers": zod.array(zod.string()),
  "checklist": zod.array(zod.string()),
  "lessonRevisions": zod.array(zod.object({
  "lessonId": zod.uuid(),
  "revision": zod.int(),
  "current": zod.boolean()
}))
}).optional(),
  "tenderRevision": zod.int().min(1),
  "quoteRevisionId": zod.uuid().nullish(),
  "quoteSnapshot": zod.record(zod.string(), zod.unknown()).nullish(),
  "buyerTemplateSourceId": zod.uuid().nullish(),
  "buyerTemplateMapping": zod.union([zod.object({
  "mappingRevision": zod.int().min(1),
  "templateSourceId": zod.uuid(),
  "templateHash": zod.string().regex(listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneTemplateHashRegExp),
  "inspectionHash": zod.string().regex(listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneInspectionHashRegExp),
  "mappingHash": zod.string().regex(listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneMappingHashRegExp),
  "entries": zod.array(zod.object({
  "targetId": zod.string().min(1).max(listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneEntriesItemTargetIdMax),
  "requirementId": zod.uuid(),
  "responseSectionId": zod.uuid(),
  "requirementKey": zod.string().min(1).max(listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneEntriesItemRequirementKeyMax)
})).min(1).max(listTenderPackagesResponseDataItemSnapshotBuyerTemplateMappingOneEntriesMax),
  "confirmedAt": zod.iso.datetime({"offset":true}),
  "confirmedByAppUserId": zod.uuid()
}),zod.null()]).optional(),
  "sourceRevisionIds": zod.array(zod.string()),
  "evidenceRevisionIds": zod.array(zod.string()),
  "requirementRevisions": zod.array(zod.object({
  "requirementId": zod.uuid(),
  "revision": zod.int().min(1)
})),
  "responseSectionRevisions": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "revision": zod.int().min(1)
})),
  "outputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix']))
}),
  "snapshotHash": zod.string().regex(listTenderPackagesResponseDataItemSnapshotHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listTenderPackagesResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderPackagesResponseLimitMax),
  "offset": zod.int().min(listTenderPackagesResponseOffsetMin)
})


/**
 * @summary Freeze all output-affecting inputs into one immutable package revision
 */
export const createTenderPackageParams = zod.object({
  "id": zod.uuid()
})

export const createTenderPackageBodySignedSourceIdsMax = 10;

export const createTenderPackageBodyOutputKindsMax = 4;



export const createTenderPackageBody = zod.object({
  "signedSourceIds": zod.array(zod.uuid()).max(createTenderPackageBodySignedSourceIdsMax).optional().describe('Explicitly reviewed current PDF scans; signatures remain human responsibilities.'),
  "outputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(createTenderPackageBodyOutputKindsMax),
  "includeQuote": zod.boolean(),
  "buyerTemplateSourceId": zod.uuid().optional().describe('Exact current buyer-template source to use for converted or native-template output.')
})


export const createTenderPackageResponseSnapshotBidSignedScansMax = 10;

export const createTenderPackageResponseSnapshotBidDocumentsMax = 60;



export const createTenderPackageResponseSnapshotBuyerTemplateMappingOneTemplateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageResponseSnapshotBuyerTemplateMappingOneInspectionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageResponseSnapshotBuyerTemplateMappingOneMappingHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageResponseSnapshotBuyerTemplateMappingOneEntriesItemTargetIdMax = 300;

export const createTenderPackageResponseSnapshotBuyerTemplateMappingOneEntriesItemRequirementKeyMax = 100;

export const createTenderPackageResponseSnapshotBuyerTemplateMappingOneEntriesMax = 500;



export const createTenderPackageResponseSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const createTenderPackageResponse = zod.object({
  "current": zod.boolean().optional().describe('Current content and evidence still match this checkpoint.'),
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "revisionNo": zod.int().min(1),
  "snapshot": zod.object({
  "bid": zod.object({
  "version": zod.literal(1),
  "policyVersion": zod.string(),
  "planRevisionId": zod.uuid(),
  "fingerprint": zod.string(),
  "supplierName": zod.string(),
  "signedScans": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "fileId": zod.uuid(),
  "hash": zod.string(),
  "revision": zod.string(),
  "filename": zod.string()
})).max(createTenderPackageResponseSnapshotBidSignedScansMax).optional(),
  "documents": zod.array(zod.object({
  "key": zod.string(),
  "documentId": zod.uuid(),
  "versionId": zod.uuid().nullable(),
  "title": zod.string(),
  "revision": zod.int(),
  "contentHash": zod.string(),
  "content": zod.record(zod.string(), zod.unknown()),
  "requirementIds": zod.array(zod.uuid()),
  "role": zod.enum(['appendix_1', 'summary', 'schedule_1', 'schedule_2', 'schedule_3', 'case_study', 'other'])
})).max(createTenderPackageResponseSnapshotBidDocumentsMax),
  "blockers": zod.array(zod.string()),
  "checklist": zod.array(zod.string()),
  "lessonRevisions": zod.array(zod.object({
  "lessonId": zod.uuid(),
  "revision": zod.int(),
  "current": zod.boolean()
}))
}).optional(),
  "tenderRevision": zod.int().min(1),
  "quoteRevisionId": zod.uuid().nullish(),
  "quoteSnapshot": zod.record(zod.string(), zod.unknown()).nullish(),
  "buyerTemplateSourceId": zod.uuid().nullish(),
  "buyerTemplateMapping": zod.union([zod.object({
  "mappingRevision": zod.int().min(1),
  "templateSourceId": zod.uuid(),
  "templateHash": zod.string().regex(createTenderPackageResponseSnapshotBuyerTemplateMappingOneTemplateHashRegExp),
  "inspectionHash": zod.string().regex(createTenderPackageResponseSnapshotBuyerTemplateMappingOneInspectionHashRegExp),
  "mappingHash": zod.string().regex(createTenderPackageResponseSnapshotBuyerTemplateMappingOneMappingHashRegExp),
  "entries": zod.array(zod.object({
  "targetId": zod.string().min(1).max(createTenderPackageResponseSnapshotBuyerTemplateMappingOneEntriesItemTargetIdMax),
  "requirementId": zod.uuid(),
  "responseSectionId": zod.uuid(),
  "requirementKey": zod.string().min(1).max(createTenderPackageResponseSnapshotBuyerTemplateMappingOneEntriesItemRequirementKeyMax)
})).min(1).max(createTenderPackageResponseSnapshotBuyerTemplateMappingOneEntriesMax),
  "confirmedAt": zod.iso.datetime({"offset":true}),
  "confirmedByAppUserId": zod.uuid()
}),zod.null()]).optional(),
  "sourceRevisionIds": zod.array(zod.string()),
  "evidenceRevisionIds": zod.array(zod.string()),
  "requirementRevisions": zod.array(zod.object({
  "requirementId": zod.uuid(),
  "revision": zod.int().min(1)
})),
  "responseSectionRevisions": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "revision": zod.int().min(1)
})),
  "outputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix']))
}),
  "snapshotHash": zod.string().regex(createTenderPackageResponseSnapshotHashRegExp),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Submit an exact package checkpoint for administrator review
 */
export const submitTenderPackageReviewParams = zod.object({
  "id": zod.uuid(),
  "packageRevisionId": zod.uuid()
})

export const submitTenderPackageReviewBodyNoteMax = 4000;



export const submitTenderPackageReviewBody = zod.object({
  "note": zod.string().max(submitTenderPackageReviewBodyNoteMax).optional()
})

export const submitTenderPackageReviewResponsePackageSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const submitTenderPackageReviewResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "packageRevisionId": zod.uuid(),
  "packageSnapshotHash": zod.string().regex(submitTenderPackageReviewResponsePackageSnapshotHashRegExp),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'invalidated', 'cancelled']),
  "submissionNote": zod.string().nullish(),
  "decisionNote": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish(),
  "invalidatedAt": zod.iso.datetime({"offset":true}).nullish()
})


/**
 * @summary Generate the selected Word outputs from one current immutable package checkpoint
 */
export const createTenderPackageExportsParams = zod.object({
  "id": zod.uuid(),
  "packageRevisionId": zod.uuid()
})

export const createTenderPackageExportsHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageExportsHeaderIdempotencyKeyMax = 128;



export const createTenderPackageExportsHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(createTenderPackageExportsHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.'),
  "Idempotency-Key": zod.string().min(1).max(createTenderPackageExportsHeaderIdempotencyKeyMax)
})

export const createTenderPackageExportsBody = zod.object({
  "purpose": zod.enum(['draft', 'approved'])
})


export const createTenderPackageExportsResponseManifestPackageSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const createTenderPackageExportsResponseManifestBidSignedScansMax = 10;

export const createTenderPackageExportsResponseManifestBidDocumentsMax = 60;

export const createTenderPackageExportsResponseManifestSelectedOutputsMax = 4;


export const createTenderPackageExportsResponseManifestBuyerTemplateMappingOneTemplateHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageExportsResponseManifestBuyerTemplateMappingOneInspectionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageExportsResponseManifestBuyerTemplateMappingOneMappingHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageExportsResponseManifestBuyerTemplateMappingOneEntriesItemTargetIdMax = 300;

export const createTenderPackageExportsResponseManifestBuyerTemplateMappingOneEntriesItemRequirementKeyMax = 100;

export const createTenderPackageExportsResponseManifestBuyerTemplateMappingOneEntriesMax = 500;

export const createTenderPackageExportsResponseManifestSourceRevisionsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageExportsResponseManifestEvidenceRevisionsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const createTenderPackageExportsResponseArtifactsItemPackageSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageExportsResponseArtifactsItemFilenameMax = 500;


export const createTenderPackageExportsResponseArtifactsItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createTenderPackageExportsResponseArtifactsItemWarningsMax = 100;

export const createTenderPackageExportsResponseArtifactsItemAttemptCountMin = 0;



export const createTenderPackageExportsResponse = zod.object({
  "manifest": zod.object({
  "packageRevisionId": zod.uuid(),
  "packageRevisionNo": zod.int().min(1),
  "packageSnapshotHash": zod.string().regex(createTenderPackageExportsResponseManifestPackageSnapshotHashRegExp),
  "tenderRevision": zod.int().min(1),
  "bid": zod.object({
  "version": zod.literal(1),
  "policyVersion": zod.string(),
  "planRevisionId": zod.uuid(),
  "fingerprint": zod.string(),
  "supplierName": zod.string(),
  "signedScans": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "fileId": zod.uuid(),
  "hash": zod.string(),
  "revision": zod.string(),
  "filename": zod.string()
})).max(createTenderPackageExportsResponseManifestBidSignedScansMax).optional(),
  "documents": zod.array(zod.object({
  "key": zod.string(),
  "documentId": zod.uuid(),
  "versionId": zod.uuid().nullable(),
  "title": zod.string(),
  "revision": zod.int(),
  "contentHash": zod.string(),
  "content": zod.record(zod.string(), zod.unknown()),
  "requirementIds": zod.array(zod.uuid()),
  "role": zod.enum(['appendix_1', 'summary', 'schedule_1', 'schedule_2', 'schedule_3', 'case_study', 'other'])
})).max(createTenderPackageExportsResponseManifestBidDocumentsMax),
  "blockers": zod.array(zod.string()),
  "checklist": zod.array(zod.string()),
  "lessonRevisions": zod.array(zod.object({
  "lessonId": zod.uuid(),
  "revision": zod.int(),
  "current": zod.boolean()
}))
}).optional(),
  "purpose": zod.enum(['draft', 'approved']),
  "selectedOutputs": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])).min(1).max(createTenderPackageExportsResponseManifestSelectedOutputsMax),
  "buyerTemplateSourceId": zod.uuid().nullish(),
  "buyerTemplateMapping": zod.union([zod.object({
  "mappingRevision": zod.int().min(1),
  "templateSourceId": zod.uuid(),
  "templateHash": zod.string().regex(createTenderPackageExportsResponseManifestBuyerTemplateMappingOneTemplateHashRegExp),
  "inspectionHash": zod.string().regex(createTenderPackageExportsResponseManifestBuyerTemplateMappingOneInspectionHashRegExp),
  "mappingHash": zod.string().regex(createTenderPackageExportsResponseManifestBuyerTemplateMappingOneMappingHashRegExp),
  "entries": zod.array(zod.object({
  "targetId": zod.string().min(1).max(createTenderPackageExportsResponseManifestBuyerTemplateMappingOneEntriesItemTargetIdMax),
  "requirementId": zod.uuid(),
  "responseSectionId": zod.uuid(),
  "requirementKey": zod.string().min(1).max(createTenderPackageExportsResponseManifestBuyerTemplateMappingOneEntriesItemRequirementKeyMax)
})).min(1).max(createTenderPackageExportsResponseManifestBuyerTemplateMappingOneEntriesMax),
  "confirmedAt": zod.iso.datetime({"offset":true}),
  "confirmedByAppUserId": zod.uuid()
}),zod.null()]).optional(),
  "quoteRevisionId": zod.uuid().nullish(),
  "sourceRevisions": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.string(),
  "contentHash": zod.string().regex(createTenderPackageExportsResponseManifestSourceRevisionsItemContentHashRegExp)
})),
  "evidenceRevisions": zod.array(zod.object({
  "selectionId": zod.uuid(),
  "sourceType": zod.enum(['tender_source', 'knowledge']),
  "sourceId": zod.string(),
  "sourceRevision": zod.string(),
  "sourceHash": zod.string().regex(createTenderPackageExportsResponseManifestEvidenceRevisionsItemSourceHashRegExp),
  "location": zod.string()
})),
  "requirementRevisions": zod.array(zod.object({
  "requirementId": zod.uuid(),
  "revision": zod.int().min(1)
})),
  "responseSectionRevisions": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "revision": zod.int().min(1)
}))
}),
  "artifacts": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "packageRevisionId": zod.uuid(),
  "packageSnapshotHash": zod.string().regex(createTenderPackageExportsResponseArtifactsItemPackageSnapshotHashRegExp),
  "outputKind": zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix']),
  "purpose": zod.enum(['draft', 'approved']),
  "status": zod.enum(['queued', 'generated', 'saved', 'failed']),
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "fileId": zod.uuid().nullish(),
  "filename": zod.string().min(1).max(createTenderPackageExportsResponseArtifactsItemFilenameMax),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(1).nullish(),
  "contentHash": zod.string().regex(createTenderPackageExportsResponseArtifactsItemContentHashRegExp).nullish(),
  "warnings": zod.array(zod.string()).max(createTenderPackageExportsResponseArtifactsItemWarningsMax),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "attemptCount": zod.int().min(createTenderPackageExportsResponseArtifactsItemAttemptCountMin),
  "downloadUrl": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
}))
})


/**
 * @summary List generated tender artifact history
 */
export const listTenderExportsParams = zod.object({
  "id": zod.uuid()
})

export const listTenderExportsQuerySearchMax = 200;

export const listTenderExportsQueryLimitDefault = 50;
export const listTenderExportsQueryLimitMax = 100;

export const listTenderExportsQueryOffsetDefault = 0;
export const listTenderExportsQueryOffsetMin = 0;



export const listTenderExportsQueryParams = zod.object({
  "search": zod.string().max(listTenderExportsQuerySearchMax).optional(),
  "status": zod.enum(['queued', 'generated', 'saved', 'failed']).optional(),
  "limit": zod.int().min(1).max(listTenderExportsQueryLimitMax).default(listTenderExportsQueryLimitDefault),
  "offset": zod.int().min(listTenderExportsQueryOffsetMin).default(listTenderExportsQueryOffsetDefault)
})

export const listTenderExportsResponseDataItemPackageSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderExportsResponseDataItemFilenameMax = 500;


export const listTenderExportsResponseDataItemContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderExportsResponseDataItemWarningsMax = 100;

export const listTenderExportsResponseDataItemAttemptCountMin = 0;

export const listTenderExportsResponseTotalMin = 0;

export const listTenderExportsResponseLimitMax = 100;

export const listTenderExportsResponseOffsetMin = 0;



export const listTenderExportsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "packageRevisionId": zod.uuid(),
  "packageSnapshotHash": zod.string().regex(listTenderExportsResponseDataItemPackageSnapshotHashRegExp),
  "outputKind": zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix']),
  "purpose": zod.enum(['draft', 'approved']),
  "status": zod.enum(['queued', 'generated', 'saved', 'failed']),
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "fileId": zod.uuid().nullish(),
  "filename": zod.string().min(1).max(listTenderExportsResponseDataItemFilenameMax),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(1).nullish(),
  "contentHash": zod.string().regex(listTenderExportsResponseDataItemContentHashRegExp).nullish(),
  "warnings": zod.array(zod.string()).max(listTenderExportsResponseDataItemWarningsMax),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "attemptCount": zod.int().min(listTenderExportsResponseDataItemAttemptCountMin),
  "downloadUrl": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "total": zod.int().min(listTenderExportsResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderExportsResponseLimitMax),
  "offset": zod.int().min(listTenderExportsResponseOffsetMin)
})


/**
 * @summary Download one saved private tender Word artifact
 */
export const downloadTenderExportParams = zod.object({
  "id": zod.uuid(),
  "exportId": zod.uuid()
})

export const downloadTenderExportResponse = zod.unknown()


/**
 * @summary Get the verified SharePoint Word launch URL for a saved tender output
 */
export const getTenderExportOfficeLaunchParams = zod.object({
  "id": zod.uuid(),
  "exportId": zod.uuid()
})

export const getTenderExportOfficeLaunchResponse = zod.object({
  "url": zod.url(),
  "itemId": zod.string(),
  "expectedETag": zod.string(),
  "note": zod.string()
})


/**
 * @summary List package review history
 */
export const listTenderReviewsParams = zod.object({
  "id": zod.uuid()
})

export const listTenderReviewsQueryLimitDefault = 50;
export const listTenderReviewsQueryLimitMax = 100;

export const listTenderReviewsQueryOffsetDefault = 0;
export const listTenderReviewsQueryOffsetMin = 0;



export const listTenderReviewsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listTenderReviewsQueryLimitMax).default(listTenderReviewsQueryLimitDefault),
  "offset": zod.int().min(listTenderReviewsQueryOffsetMin).default(listTenderReviewsQueryOffsetDefault)
})

export const listTenderReviewsResponseDataItemPackageSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listTenderReviewsResponseTotalMin = 0;

export const listTenderReviewsResponseLimitMax = 100;

export const listTenderReviewsResponseOffsetMin = 0;



export const listTenderReviewsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "packageRevisionId": zod.uuid(),
  "packageSnapshotHash": zod.string().regex(listTenderReviewsResponseDataItemPackageSnapshotHashRegExp),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'invalidated', 'cancelled']),
  "submissionNote": zod.string().nullish(),
  "decisionNote": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish(),
  "invalidatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "total": zod.int().min(listTenderReviewsResponseTotalMin),
  "limit": zod.int().min(1).max(listTenderReviewsResponseLimitMax),
  "offset": zod.int().min(listTenderReviewsResponseOffsetMin)
})


/**
 * @summary Approve or return the exact reviewed package
 */
export const decideTenderReviewParams = zod.object({
  "id": zod.uuid(),
  "reviewId": zod.uuid()
})

export const decideTenderReviewBodyNoteMax = 4000;



export const decideTenderReviewBody = zod.object({
  "decision": zod.enum(['approve', 'request_changes']),
  "note": zod.string().min(1).max(decideTenderReviewBodyNoteMax)
})

export const decideTenderReviewResponsePackageSnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const decideTenderReviewResponse = zod.object({
  "id": zod.uuid(),
  "tenderId": zod.uuid(),
  "packageRevisionId": zod.uuid(),
  "packageSnapshotHash": zod.string().regex(decideTenderReviewResponsePackageSnapshotHashRegExp),
  "status": zod.enum(['pending', 'approved', 'changes_requested', 'invalidated', 'cancelled']),
  "submissionNote": zod.string().nullish(),
  "decisionNote": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "decidedAt": zod.iso.datetime({"offset":true}).nullish(),
  "invalidatedAt": zod.iso.datetime({"offset":true}).nullish()
})


/**
 * @summary Record an external submission fact without sending or publishing anything
 */
export const recordTenderManualSubmissionParams = zod.object({
  "id": zod.uuid(),
  "packageRevisionId": zod.uuid()
})

export const recordTenderManualSubmissionBodyReferenceMax = 200;

export const recordTenderManualSubmissionBodyOutcomeMax = 200;

export const recordTenderManualSubmissionBodyNoteMax = 4000;



export const recordTenderManualSubmissionBody = zod.object({
  "submittedAt": zod.iso.datetime({"offset":true}),
  "reference": zod.string().min(1).max(recordTenderManualSubmissionBodyReferenceMax),
  "outcome": zod.string().max(recordTenderManualSubmissionBodyOutcomeMax).optional(),
  "note": zod.string().max(recordTenderManualSubmissionBodyNoteMax).optional()
})




export const recordTenderManualSubmissionResponse = zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "sowDocumentId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "reference": zod.string(),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().nullish(),
  "status": zod.enum(['draft', 'in_preparation', 'in_review', 'changes_requested', 'approved', 'submitted', 'closed', 'archived']),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])),
  "revision": zod.int().min(1),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submissionReference": zod.string().nullish(),
  "outcome": zod.string().nullish(),
  "outcomeNote": zod.string().nullish(),
  "closedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List tenders linked to a quote
 */
export const listQuoteTendersParams = zod.object({
  "id": zod.uuid()
})

export const listQuoteTendersQueryLimitDefault = 50;
export const listQuoteTendersQueryLimitMax = 100;

export const listQuoteTendersQueryOffsetDefault = 0;
export const listQuoteTendersQueryOffsetMin = 0;



export const listQuoteTendersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listQuoteTendersQueryLimitMax).default(listQuoteTendersQueryLimitDefault),
  "offset": zod.int().min(listQuoteTendersQueryOffsetMin).default(listQuoteTendersQueryOffsetDefault)
})


export const listQuoteTendersResponseTotalMin = 0;

export const listQuoteTendersResponseLimitMax = 100;

export const listQuoteTendersResponseOffsetMin = 0;



export const listQuoteTendersResponse = zod.object({
  "data": zod.array(zod.object({
  "proposalType": zod.enum(['tender', 'sow']).optional().describe('Supported native proposal types. Omission on legacy creation means Tender. Fixed after creation.'),
  "sowDocumentId": zod.uuid().nullish(),
  "id": zod.uuid(),
  "reference": zod.string(),
  "accountId": zod.uuid(),
  "quoteRequestId": zod.uuid().nullish(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullish(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "briefingMd": zod.string().nullish(),
  "status": zod.enum(['draft', 'in_preparation', 'in_review', 'changes_requested', 'approved', 'submitted', 'closed', 'archived']),
  "storageProvider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "providerLocation": zod.union([zod.object({
  "provider": zod.enum(['application', 'sharepoint', 'sharepoint_embedded']),
  "connectionId": zod.uuid().optional(),
  "tenantId": zod.string().optional(),
  "containerTypeId": zod.string().optional(),
  "siteId": zod.string().optional(),
  "driveId": zod.string().optional(),
  "folderItemId": zod.string().optional(),
  "path": zod.string().optional(),
  "containerId": zod.string().optional(),
  "itemId": zod.string().optional(),
  "versionId": zod.string().optional(),
  "eTag": zod.string().optional(),
  "webUrl": zod.url().optional()
}),zod.null()]).optional(),
  "selectedOutputKinds": zod.array(zod.enum(['standalone_response', 'completed_buyer_template', 'converted_template', 'compliance_matrix'])),
  "revision": zod.int().min(1),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submissionReference": zod.string().nullish(),
  "outcome": zod.string().nullish(),
  "outcomeNote": zod.string().nullish(),
  "closedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "accountName": zod.string().nullish()
}))),
  "total": zod.int().min(listQuoteTendersResponseTotalMin),
  "limit": zod.int().min(1).max(listQuoteTendersResponseLimitMax),
  "offset": zod.int().min(listQuoteTendersResponseOffsetMin)
})


/**
 * @summary List quote requests
 */
export const listQuoteRequestsQueryLimitDefault = 50;
export const listQuoteRequestsQueryLimitMax = 100;

export const listQuoteRequestsQueryOffsetDefault = 0;
export const listQuoteRequestsQueryOffsetMin = 0;



export const listQuoteRequestsQueryParams = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).optional(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']).optional(),
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().optional(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']).optional(),
  "source": zod.enum(['staff', 'guest', 'ai']).optional(),
  "limit": zod.int().min(1).max(listQuoteRequestsQueryLimitMax).default(listQuoteRequestsQueryLimitDefault),
  "offset": zod.int().min(listQuoteRequestsQueryOffsetMin).default(listQuoteRequestsQueryOffsetDefault)
})

export const listQuoteRequestsResponseDataItemOneKindDefault = `quote`;
export const listQuoteRequestsResponseDataItemOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listQuoteRequestsResponseDataItemOneDiscountPctDefault = `0`;
export const listQuoteRequestsResponseDataItemOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const listQuoteRequestsResponseDataItemOneAssumptionsMdMax = 20000;

export const listQuoteRequestsResponseDataItemOneExclusionsMdMax = 20000;

export const listQuoteRequestsResponseDataItemOneContingencyPctDefault = `0`;
export const listQuoteRequestsResponseDataItemOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const listQuoteRequestsResponseDataItemOneContingencyLabelDefault = `Contingency`;
export const listQuoteRequestsResponseDataItemOneContingencyLabelMax = 200;

export const listQuoteRequestsResponseDataItemTwoCurrentRevisionNoMin = 0;



export const listQuoteRequestsResponse = zod.object({
  "data": zod.array(zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(listQuoteRequestsResponseDataItemOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(listQuoteRequestsResponseDataItemOneCurrencyRegExp),
  "discountPct": zod.string().regex(listQuoteRequestsResponseDataItemOneDiscountPctRegExp).default(listQuoteRequestsResponseDataItemOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(listQuoteRequestsResponseDataItemOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(listQuoteRequestsResponseDataItemOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(listQuoteRequestsResponseDataItemOneContingencyPctRegExp).default(listQuoteRequestsResponseDataItemOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(listQuoteRequestsResponseDataItemOneContingencyLabelMax).default(listQuoteRequestsResponseDataItemOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(listQuoteRequestsResponseDataItemTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int()
})


/**
 * @summary Create a quote request (reference is server-generated)
 */
export const createQuoteRequestBodyOneKindDefault = `quote`;
export const createQuoteRequestBodyOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const createQuoteRequestBodyOneDiscountPctDefault = `0`;
export const createQuoteRequestBodyOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const createQuoteRequestBodyOneAssumptionsMdMax = 20000;

export const createQuoteRequestBodyOneExclusionsMdMax = 20000;

export const createQuoteRequestBodyOneContingencyPctDefault = `0`;
export const createQuoteRequestBodyOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const createQuoteRequestBodyOneContingencyLabelDefault = `Contingency`;
export const createQuoteRequestBodyOneContingencyLabelMax = 200;



export const createQuoteRequestBody = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(createQuoteRequestBodyOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(createQuoteRequestBodyOneCurrencyRegExp).optional(),
  "discountPct": zod.string().regex(createQuoteRequestBodyOneDiscountPctRegExp).default(createQuoteRequestBodyOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(createQuoteRequestBodyOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(createQuoteRequestBodyOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(createQuoteRequestBodyOneContingencyPctRegExp).default(createQuoteRequestBodyOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(createQuoteRequestBodyOneContingencyLabelMax).default(createQuoteRequestBodyOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
})

export const createQuoteRequestResponseOneKindDefault = `quote`;
export const createQuoteRequestResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const createQuoteRequestResponseOneDiscountPctDefault = `0`;
export const createQuoteRequestResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const createQuoteRequestResponseOneAssumptionsMdMax = 20000;

export const createQuoteRequestResponseOneExclusionsMdMax = 20000;

export const createQuoteRequestResponseOneContingencyPctDefault = `0`;
export const createQuoteRequestResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const createQuoteRequestResponseOneContingencyLabelDefault = `Contingency`;
export const createQuoteRequestResponseOneContingencyLabelMax = 200;

export const createQuoteRequestResponseTwoCurrentRevisionNoMin = 0;



export const createQuoteRequestResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(createQuoteRequestResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(createQuoteRequestResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(createQuoteRequestResponseOneDiscountPctRegExp).default(createQuoteRequestResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(createQuoteRequestResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(createQuoteRequestResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(createQuoteRequestResponseOneContingencyPctRegExp).default(createQuoteRequestResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(createQuoteRequestResponseOneContingencyLabelMax).default(createQuoteRequestResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(createQuoteRequestResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Get a quote request with its items and documents
 */
export const getQuoteRequestParams = zod.object({
  "id": zod.uuid()
})

export const getQuoteRequestResponseOneOneKindDefault = `quote`;
export const getQuoteRequestResponseOneOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getQuoteRequestResponseOneOneDiscountPctDefault = `0`;
export const getQuoteRequestResponseOneOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const getQuoteRequestResponseOneOneAssumptionsMdMax = 20000;

export const getQuoteRequestResponseOneOneExclusionsMdMax = 20000;

export const getQuoteRequestResponseOneOneContingencyPctDefault = `0`;
export const getQuoteRequestResponseOneOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const getQuoteRequestResponseOneOneContingencyLabelDefault = `Contingency`;
export const getQuoteRequestResponseOneOneContingencyLabelMax = 200;

export const getQuoteRequestResponseOneTwoCurrentRevisionNoMin = 0;

export const getQuoteRequestResponseTwoItemsItemOneInclusionDefault = `included`;
export const getQuoteRequestResponseTwoItemsItemOnePricingMethodDefault = `fixed`;
export const getQuoteRequestResponseTwoItemsItemOneEffortHoursRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const getQuoteRequestResponseTwoItemsItemOneLineDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const getQuoteRequestResponseTwoItemsItemOneTaxRatePctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const getQuoteRequestResponseTwoSectionsItemOneTitleMax = 200;

export const getQuoteRequestResponseTwoSectionsItemOneSortOrderMin = 0;



export const getQuoteRequestResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(getQuoteRequestResponseOneOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(getQuoteRequestResponseOneOneCurrencyRegExp),
  "discountPct": zod.string().regex(getQuoteRequestResponseOneOneDiscountPctRegExp).default(getQuoteRequestResponseOneOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(getQuoteRequestResponseOneOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(getQuoteRequestResponseOneOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(getQuoteRequestResponseOneOneContingencyPctRegExp).default(getQuoteRequestResponseOneOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(getQuoteRequestResponseOneOneContingencyLabelMax).default(getQuoteRequestResponseOneOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(getQuoteRequestResponseOneTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).and(zod.object({
  "items": zod.array(zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "priceListItemId": zod.uuid().nullish(),
  "sectionId": zod.uuid().nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']).default(getQuoteRequestResponseTwoItemsItemOneInclusionDefault),
  "alternativeToItemId": zod.uuid().nullable(),
  "pricingMethod": zod.enum(['fixed', 'effort']).default(getQuoteRequestResponseTwoItemsItemOnePricingMethodDefault),
  "effortHours": zod.string().regex(getQuoteRequestResponseTwoItemsItemOneEffortHoursRegExp).nullable(),
  "rateId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "hourlyRateSnapshot": zod.string().nullable(),
  "unitCost": zod.string().nullish(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "quantity": zod.string().optional(),
  "unitPrice": zod.string().nullish(),
  "oneOffUnitPrice": zod.string().nullish(),
  "recurringUnitPrice": zod.string().nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']).optional(),
  "lineDiscountPct": zod.string().regex(getQuoteRequestResponseTwoItemsItemOneLineDiscountPctRegExp).optional(),
  "taxRatePct": zod.string().regex(getQuoteRequestResponseTwoItemsItemOneTaxRatePctRegExp).optional(),
  "aiRationale": zod.string().nullish(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "lineTotal": zod.string().nullish(),
  "lineOneOffTotal": zod.string(),
  "lineRecurringTotal": zod.string(),
  "lineCost": zod.string().optional().describe('Internal line cost returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal line margin percentage returned only to quote administrators.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "sections": zod.array(zod.object({
  "title": zod.string().min(1).max(getQuoteRequestResponseTwoSectionsItemOneTitleMax),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(getQuoteRequestResponseTwoSectionsItemOneSortOrderMin)
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "documents": zod.array(zod.object({
  "fileId": zod.uuid(),
  "label": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "uploadedByUserId": zod.uuid().nullish(),
  "filename": zod.string().nullish(),
  "contentType": zod.string().nullish(),
  "sizeBytes": zod.int().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})))
}))


/**
 * @summary Update status, pricing, notes, or linked account/contact/partner
 */
export const updateQuoteRequestParams = zod.object({
  "id": zod.uuid()
})

export const updateQuoteRequestBodyCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const updateQuoteRequestBodyDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const updateQuoteRequestBodyAssumptionsMdMax = 20000;

export const updateQuoteRequestBodyExclusionsMdMax = 20000;

export const updateQuoteRequestBodyContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const updateQuoteRequestBodyContingencyLabelMax = 200;



export const updateQuoteRequestBody = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).optional(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "currency": zod.string().regex(updateQuoteRequestBodyCurrencyRegExp).optional(),
  "discountPct": zod.string().regex(updateQuoteRequestBodyDiscountPctRegExp).optional(),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(updateQuoteRequestBodyAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(updateQuoteRequestBodyExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(updateQuoteRequestBodyContingencyPctRegExp).optional(),
  "contingencyLabel": zod.string().min(1).max(updateQuoteRequestBodyContingencyLabelMax).optional(),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
})

export const updateQuoteRequestResponseOneKindDefault = `quote`;
export const updateQuoteRequestResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const updateQuoteRequestResponseOneDiscountPctDefault = `0`;
export const updateQuoteRequestResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const updateQuoteRequestResponseOneAssumptionsMdMax = 20000;

export const updateQuoteRequestResponseOneExclusionsMdMax = 20000;

export const updateQuoteRequestResponseOneContingencyPctDefault = `0`;
export const updateQuoteRequestResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const updateQuoteRequestResponseOneContingencyLabelDefault = `Contingency`;
export const updateQuoteRequestResponseOneContingencyLabelMax = 200;

export const updateQuoteRequestResponseTwoCurrentRevisionNoMin = 0;



export const updateQuoteRequestResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(updateQuoteRequestResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(updateQuoteRequestResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(updateQuoteRequestResponseOneDiscountPctRegExp).default(updateQuoteRequestResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(updateQuoteRequestResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(updateQuoteRequestResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(updateQuoteRequestResponseOneContingencyPctRegExp).default(updateQuoteRequestResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(updateQuoteRequestResponseOneContingencyLabelMax).default(updateQuoteRequestResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(updateQuoteRequestResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a quote request
 */
export const deleteQuoteRequestParams = zod.object({
  "id": zod.uuid()
})

export const deleteQuoteRequestResponse = zod.void()


/**
 * @summary List line items for a quote request
 */
export const listQuoteRequestItemsParams = zod.object({
  "quoteRequestId": zod.uuid()
})

export const listQuoteRequestItemsResponseDataItemOneInclusionDefault = `included`;
export const listQuoteRequestItemsResponseDataItemOnePricingMethodDefault = `fixed`;
export const listQuoteRequestItemsResponseDataItemOneEffortHoursRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const listQuoteRequestItemsResponseDataItemOneLineDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const listQuoteRequestItemsResponseDataItemOneTaxRatePctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const listQuoteRequestItemsResponseSectionsItemOneTitleMax = 200;

export const listQuoteRequestItemsResponseSectionsItemOneSortOrderMin = 0;



export const listQuoteRequestItemsResponse = zod.object({
  "data": zod.array(zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "priceListItemId": zod.uuid().nullish(),
  "sectionId": zod.uuid().nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']).default(listQuoteRequestItemsResponseDataItemOneInclusionDefault),
  "alternativeToItemId": zod.uuid().nullable(),
  "pricingMethod": zod.enum(['fixed', 'effort']).default(listQuoteRequestItemsResponseDataItemOnePricingMethodDefault),
  "effortHours": zod.string().regex(listQuoteRequestItemsResponseDataItemOneEffortHoursRegExp).nullable(),
  "rateId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "hourlyRateSnapshot": zod.string().nullable(),
  "unitCost": zod.string().nullish(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "quantity": zod.string().optional(),
  "unitPrice": zod.string().nullish(),
  "oneOffUnitPrice": zod.string().nullish(),
  "recurringUnitPrice": zod.string().nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']).optional(),
  "lineDiscountPct": zod.string().regex(listQuoteRequestItemsResponseDataItemOneLineDiscountPctRegExp).optional(),
  "taxRatePct": zod.string().regex(listQuoteRequestItemsResponseDataItemOneTaxRatePctRegExp).optional(),
  "aiRationale": zod.string().nullish(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "lineTotal": zod.string().nullish(),
  "lineOneOffTotal": zod.string(),
  "lineRecurringTotal": zod.string(),
  "lineCost": zod.string().optional().describe('Internal line cost returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal line margin percentage returned only to quote administrators.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int(),
  "sections": zod.array(zod.object({
  "title": zod.string().min(1).max(listQuoteRequestItemsResponseSectionsItemOneTitleMax),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(listQuoteRequestItemsResponseSectionsItemOneSortOrderMin)
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})))
})


/**
 * @summary Add a line item to a quote request
 */
export const createQuoteRequestItemParams = zod.object({
  "quoteRequestId": zod.uuid()
})

export const createQuoteRequestItemBodyOneInclusionDefault = `included`;
export const createQuoteRequestItemBodyOnePricingMethodDefault = `fixed`;
export const createQuoteRequestItemBodyOneEffortHoursRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const createQuoteRequestItemBodyOneLineDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const createQuoteRequestItemBodyOneTaxRatePctRegExp = new RegExp('^\\d+(\\.\\d+)?$');


export const createQuoteRequestItemBody = zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "priceListItemId": zod.uuid().nullish(),
  "sectionId": zod.uuid().nullish(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']).default(createQuoteRequestItemBodyOneInclusionDefault),
  "alternativeToItemId": zod.uuid().nullish(),
  "pricingMethod": zod.enum(['fixed', 'effort']).default(createQuoteRequestItemBodyOnePricingMethodDefault),
  "effortHours": zod.string().regex(createQuoteRequestItemBodyOneEffortHoursRegExp).nullish(),
  "rateId": zod.uuid().nullish(),
  "roleName": zod.string().nullish(),
  "hourlyRateSnapshot": zod.string().nullish(),
  "unitCost": zod.string().nullish(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "quantity": zod.string().optional(),
  "unitPrice": zod.string().nullish(),
  "oneOffUnitPrice": zod.string().nullish(),
  "recurringUnitPrice": zod.string().nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']).optional(),
  "lineDiscountPct": zod.string().regex(createQuoteRequestItemBodyOneLineDiscountPctRegExp).optional(),
  "taxRatePct": zod.string().regex(createQuoteRequestItemBodyOneTaxRatePctRegExp).optional(),
  "aiRationale": zod.string().nullish(),
  "sortOrder": zod.int().optional()
})

export const createQuoteRequestItemResponseOneInclusionDefault = `included`;
export const createQuoteRequestItemResponseOnePricingMethodDefault = `fixed`;
export const createQuoteRequestItemResponseOneEffortHoursRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const createQuoteRequestItemResponseOneLineDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const createQuoteRequestItemResponseOneTaxRatePctRegExp = new RegExp('^\\d+(\\.\\d+)?$');


export const createQuoteRequestItemResponse = zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "priceListItemId": zod.uuid().nullish(),
  "sectionId": zod.uuid().nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']).default(createQuoteRequestItemResponseOneInclusionDefault),
  "alternativeToItemId": zod.uuid().nullable(),
  "pricingMethod": zod.enum(['fixed', 'effort']).default(createQuoteRequestItemResponseOnePricingMethodDefault),
  "effortHours": zod.string().regex(createQuoteRequestItemResponseOneEffortHoursRegExp).nullable(),
  "rateId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "hourlyRateSnapshot": zod.string().nullable(),
  "unitCost": zod.string().nullish(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "quantity": zod.string().optional(),
  "unitPrice": zod.string().nullish(),
  "oneOffUnitPrice": zod.string().nullish(),
  "recurringUnitPrice": zod.string().nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']).optional(),
  "lineDiscountPct": zod.string().regex(createQuoteRequestItemResponseOneLineDiscountPctRegExp).optional(),
  "taxRatePct": zod.string().regex(createQuoteRequestItemResponseOneTaxRatePctRegExp).optional(),
  "aiRationale": zod.string().nullish(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "lineTotal": zod.string().nullish(),
  "lineOneOffTotal": zod.string(),
  "lineRecurringTotal": zod.string(),
  "lineCost": zod.string().optional().describe('Internal line cost returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal line margin percentage returned only to quote administrators.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a line item
 */
export const updateQuoteRequestItemParams = zod.object({
  "quoteRequestId": zod.uuid(),
  "itemId": zod.uuid()
})

export const updateQuoteRequestItemBodyEffortHoursRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const updateQuoteRequestItemBodyLineDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const updateQuoteRequestItemBodyTaxRatePctRegExp = new RegExp('^\\d+(\\.\\d+)?$');


export const updateQuoteRequestItemBody = zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']).optional(),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "priceListItemId": zod.uuid().nullish(),
  "sectionId": zod.uuid().nullish(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']).optional(),
  "alternativeToItemId": zod.uuid().nullish(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().regex(updateQuoteRequestItemBodyEffortHoursRegExp).nullish(),
  "rateId": zod.uuid().nullish(),
  "roleName": zod.string().nullish(),
  "hourlyRateSnapshot": zod.string().nullish(),
  "unitCost": zod.string().nullish(),
  "label": zod.string().optional(),
  "description": zod.string().nullish(),
  "quantity": zod.string().optional(),
  "unitPrice": zod.string().nullish(),
  "oneOffUnitPrice": zod.string().nullish(),
  "recurringUnitPrice": zod.string().nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']).optional(),
  "lineDiscountPct": zod.string().regex(updateQuoteRequestItemBodyLineDiscountPctRegExp).optional(),
  "taxRatePct": zod.string().regex(updateQuoteRequestItemBodyTaxRatePctRegExp).optional(),
  "aiRationale": zod.string().nullish(),
  "sortOrder": zod.int().optional()
})

export const updateQuoteRequestItemResponseOneInclusionDefault = `included`;
export const updateQuoteRequestItemResponseOnePricingMethodDefault = `fixed`;
export const updateQuoteRequestItemResponseOneEffortHoursRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const updateQuoteRequestItemResponseOneLineDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const updateQuoteRequestItemResponseOneTaxRatePctRegExp = new RegExp('^\\d+(\\.\\d+)?$');


export const updateQuoteRequestItemResponse = zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "priceListItemId": zod.uuid().nullish(),
  "sectionId": zod.uuid().nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']).default(updateQuoteRequestItemResponseOneInclusionDefault),
  "alternativeToItemId": zod.uuid().nullable(),
  "pricingMethod": zod.enum(['fixed', 'effort']).default(updateQuoteRequestItemResponseOnePricingMethodDefault),
  "effortHours": zod.string().regex(updateQuoteRequestItemResponseOneEffortHoursRegExp).nullable(),
  "rateId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "hourlyRateSnapshot": zod.string().nullable(),
  "unitCost": zod.string().nullish(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "quantity": zod.string().optional(),
  "unitPrice": zod.string().nullish(),
  "oneOffUnitPrice": zod.string().nullish(),
  "recurringUnitPrice": zod.string().nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']).optional(),
  "lineDiscountPct": zod.string().regex(updateQuoteRequestItemResponseOneLineDiscountPctRegExp).optional(),
  "taxRatePct": zod.string().regex(updateQuoteRequestItemResponseOneTaxRatePctRegExp).optional(),
  "aiRationale": zod.string().nullish(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "lineTotal": zod.string().nullish(),
  "lineOneOffTotal": zod.string(),
  "lineRecurringTotal": zod.string(),
  "lineCost": zod.string().optional().describe('Internal line cost returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal line margin percentage returned only to quote administrators.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Remove a line item
 */
export const deleteQuoteRequestItemParams = zod.object({
  "quoteRequestId": zod.uuid(),
  "itemId": zod.uuid()
})

export const deleteQuoteRequestItemResponse = zod.void()


/**
 * @summary Add a work-package section to a quote
 */
export const createQuoteSectionParams = zod.object({
  "id": zod.uuid()
})

export const createQuoteSectionBodyOneTitleMax = 200;

export const createQuoteSectionBodyOneSortOrderMin = 0;



export const createQuoteSectionBody = zod.object({
  "title": zod.string().min(1).max(createQuoteSectionBodyOneTitleMax),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(createQuoteSectionBodyOneSortOrderMin).optional()
})

export const createQuoteSectionResponseOneTitleMax = 200;

export const createQuoteSectionResponseOneSortOrderMin = 0;



export const createQuoteSectionResponse = zod.object({
  "title": zod.string().min(1).max(createQuoteSectionResponseOneTitleMax),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(createQuoteSectionResponseOneSortOrderMin)
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Replace the complete order of a quote's sections
 */
export const reorderQuoteSectionsParams = zod.object({
  "id": zod.uuid()
})

export const reorderQuoteSectionsBody = zod.object({
  "sectionIds": zod.array(zod.uuid())
})

export const reorderQuoteSectionsResponseOneTitleMax = 200;

export const reorderQuoteSectionsResponseOneSortOrderMin = 0;



export const reorderQuoteSectionsResponseItem = zod.object({
  "title": zod.string().min(1).max(reorderQuoteSectionsResponseOneTitleMax),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(reorderQuoteSectionsResponseOneSortOrderMin)
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
export const reorderQuoteSectionsResponse = zod.array(reorderQuoteSectionsResponseItem)


/**
 * @summary Rename or update a quote section
 */
export const updateQuoteSectionParams = zod.object({
  "id": zod.uuid(),
  "sectionId": zod.uuid()
})

export const updateQuoteSectionBodyTitleMax = 200;

export const updateQuoteSectionBodySortOrderMin = 0;



export const updateQuoteSectionBody = zod.object({
  "title": zod.string().min(1).max(updateQuoteSectionBodyTitleMax).optional(),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(updateQuoteSectionBodySortOrderMin).optional()
})

export const updateQuoteSectionResponseOneTitleMax = 200;

export const updateQuoteSectionResponseOneSortOrderMin = 0;



export const updateQuoteSectionResponse = zod.object({
  "title": zod.string().min(1).max(updateQuoteSectionResponseOneTitleMax),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(updateQuoteSectionResponseOneSortOrderMin)
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Delete a quote section and leave its lines unsectioned
 */
export const deleteQuoteSectionParams = zod.object({
  "id": zod.uuid(),
  "sectionId": zod.uuid()
})

export const deleteQuoteSectionResponse = zod.void()


/**
 * @summary List documents attached to a quote request
 */
export const listQuoteRequestDocumentsParams = zod.object({
  "quoteRequestId": zod.uuid()
})

export const listQuoteRequestDocumentsResponse = zod.object({
  "data": zod.array(zod.object({
  "fileId": zod.uuid(),
  "label": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "uploadedByUserId": zod.uuid().nullish(),
  "filename": zod.string().nullish(),
  "contentType": zod.string().nullish(),
  "sizeBytes": zod.int().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int()
})


/**
 * @summary Attach an already-uploaded file (via /api/files) to a quote request
 */
export const createQuoteRequestDocumentParams = zod.object({
  "quoteRequestId": zod.uuid()
})

export const createQuoteRequestDocumentBody = zod.object({
  "fileId": zod.uuid(),
  "label": zod.string().nullish()
})

export const createQuoteRequestDocumentResponse = zod.object({
  "fileId": zod.uuid(),
  "label": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "uploadedByUserId": zod.uuid().nullish(),
  "filename": zod.string().nullish(),
  "contentType": zod.string().nullish(),
  "sizeBytes": zod.int().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Detach a document from a quote request
 */
export const deleteQuoteRequestDocumentParams = zod.object({
  "quoteRequestId": zod.uuid(),
  "documentId": zod.uuid()
})

export const deleteQuoteRequestDocumentResponse = zod.void()


/**
 * @summary Recalculate line and quote totals from immutable unit-price snapshots
 */
export const recalculateQuoteParams = zod.object({
  "id": zod.uuid()
})

export const recalculateQuoteResponseOneKindDefault = `quote`;
export const recalculateQuoteResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const recalculateQuoteResponseOneDiscountPctDefault = `0`;
export const recalculateQuoteResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const recalculateQuoteResponseOneAssumptionsMdMax = 20000;

export const recalculateQuoteResponseOneExclusionsMdMax = 20000;

export const recalculateQuoteResponseOneContingencyPctDefault = `0`;
export const recalculateQuoteResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const recalculateQuoteResponseOneContingencyLabelDefault = `Contingency`;
export const recalculateQuoteResponseOneContingencyLabelMax = 200;

export const recalculateQuoteResponseTwoCurrentRevisionNoMin = 0;



export const recalculateQuoteResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(recalculateQuoteResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(recalculateQuoteResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(recalculateQuoteResponseOneDiscountPctRegExp).default(recalculateQuoteResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(recalculateQuoteResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(recalculateQuoteResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(recalculateQuoteResponseOneContingencyPctRegExp).default(recalculateQuoteResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(recalculateQuoteResponseOneContingencyLabelMax).default(recalculateQuoteResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(recalculateQuoteResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Prepare an editable priced quote draft from a staff brief
 */
export const draftQuoteWithAiBodyBriefMax = 4000;



export const draftQuoteWithAiBody = zod.object({
  "brief": zod.string().min(1).max(draftQuoteWithAiBodyBriefMax),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requestId": zod.uuid().optional()
})

export const draftQuoteWithAiResponseQuoteOneOneKindDefault = `quote`;
export const draftQuoteWithAiResponseQuoteOneOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const draftQuoteWithAiResponseQuoteOneOneDiscountPctDefault = `0`;
export const draftQuoteWithAiResponseQuoteOneOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftQuoteWithAiResponseQuoteOneOneAssumptionsMdMax = 20000;

export const draftQuoteWithAiResponseQuoteOneOneExclusionsMdMax = 20000;

export const draftQuoteWithAiResponseQuoteOneOneContingencyPctDefault = `0`;
export const draftQuoteWithAiResponseQuoteOneOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftQuoteWithAiResponseQuoteOneOneContingencyLabelDefault = `Contingency`;
export const draftQuoteWithAiResponseQuoteOneOneContingencyLabelMax = 200;

export const draftQuoteWithAiResponseQuoteOneTwoCurrentRevisionNoMin = 0;

export const draftQuoteWithAiResponseQuoteTwoItemsItemOneInclusionDefault = `included`;
export const draftQuoteWithAiResponseQuoteTwoItemsItemOnePricingMethodDefault = `fixed`;
export const draftQuoteWithAiResponseQuoteTwoItemsItemOneEffortHoursRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftQuoteWithAiResponseQuoteTwoItemsItemOneLineDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftQuoteWithAiResponseQuoteTwoItemsItemOneTaxRatePctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftQuoteWithAiResponseQuoteTwoSectionsItemOneTitleMax = 200;

export const draftQuoteWithAiResponseQuoteTwoSectionsItemOneSortOrderMin = 0;



export const draftQuoteWithAiResponse = zod.object({
  "quote": zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(draftQuoteWithAiResponseQuoteOneOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(draftQuoteWithAiResponseQuoteOneOneCurrencyRegExp),
  "discountPct": zod.string().regex(draftQuoteWithAiResponseQuoteOneOneDiscountPctRegExp).default(draftQuoteWithAiResponseQuoteOneOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(draftQuoteWithAiResponseQuoteOneOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(draftQuoteWithAiResponseQuoteOneOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(draftQuoteWithAiResponseQuoteOneOneContingencyPctRegExp).default(draftQuoteWithAiResponseQuoteOneOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(draftQuoteWithAiResponseQuoteOneOneContingencyLabelMax).default(draftQuoteWithAiResponseQuoteOneOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(draftQuoteWithAiResponseQuoteOneTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).and(zod.object({
  "items": zod.array(zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "priceListItemId": zod.uuid().nullish(),
  "sectionId": zod.uuid().nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']).default(draftQuoteWithAiResponseQuoteTwoItemsItemOneInclusionDefault),
  "alternativeToItemId": zod.uuid().nullable(),
  "pricingMethod": zod.enum(['fixed', 'effort']).default(draftQuoteWithAiResponseQuoteTwoItemsItemOnePricingMethodDefault),
  "effortHours": zod.string().regex(draftQuoteWithAiResponseQuoteTwoItemsItemOneEffortHoursRegExp).nullable(),
  "rateId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "hourlyRateSnapshot": zod.string().nullable(),
  "unitCost": zod.string().nullish(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "quantity": zod.string().optional(),
  "unitPrice": zod.string().nullish(),
  "oneOffUnitPrice": zod.string().nullish(),
  "recurringUnitPrice": zod.string().nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']).optional(),
  "lineDiscountPct": zod.string().regex(draftQuoteWithAiResponseQuoteTwoItemsItemOneLineDiscountPctRegExp).optional(),
  "taxRatePct": zod.string().regex(draftQuoteWithAiResponseQuoteTwoItemsItemOneTaxRatePctRegExp).optional(),
  "aiRationale": zod.string().nullish(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "lineTotal": zod.string().nullish(),
  "lineOneOffTotal": zod.string(),
  "lineRecurringTotal": zod.string(),
  "lineCost": zod.string().optional().describe('Internal line cost returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal line margin percentage returned only to quote administrators.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "sections": zod.array(zod.object({
  "title": zod.string().min(1).max(draftQuoteWithAiResponseQuoteTwoSectionsItemOneTitleMax),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(draftQuoteWithAiResponseQuoteTwoSectionsItemOneSortOrderMin)
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "documents": zod.array(zod.object({
  "fileId": zod.uuid(),
  "label": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "uploadedByUserId": zod.uuid().nullish(),
  "filename": zod.string().nullish(),
  "contentType": zod.string().nullish(),
  "sizeBytes": zod.int().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})))
})),
  "summary": zod.string(),
  "assumptions": zod.array(zod.string()),
  "openQuestions": zod.array(zod.string()),
  "governanceActionId": zod.uuid(),
  "draftOnly": zod.literal(true)
})


/**
 * @summary Prepare an editable priced quote draft from an opportunity and staff brief
 */
export const draftOpportunityQuoteWithAiParams = zod.object({
  "id": zod.uuid()
})

export const draftOpportunityQuoteWithAiBodyBriefMax = 4000;



export const draftOpportunityQuoteWithAiBody = zod.object({
  "brief": zod.string().min(1).max(draftOpportunityQuoteWithAiBodyBriefMax),
  "priceListId": zod.uuid().nullish(),
  "requestId": zod.uuid().optional()
})

export const draftOpportunityQuoteWithAiResponseQuoteOneOneKindDefault = `quote`;
export const draftOpportunityQuoteWithAiResponseQuoteOneOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const draftOpportunityQuoteWithAiResponseQuoteOneOneDiscountPctDefault = `0`;
export const draftOpportunityQuoteWithAiResponseQuoteOneOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftOpportunityQuoteWithAiResponseQuoteOneOneAssumptionsMdMax = 20000;

export const draftOpportunityQuoteWithAiResponseQuoteOneOneExclusionsMdMax = 20000;

export const draftOpportunityQuoteWithAiResponseQuoteOneOneContingencyPctDefault = `0`;
export const draftOpportunityQuoteWithAiResponseQuoteOneOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftOpportunityQuoteWithAiResponseQuoteOneOneContingencyLabelDefault = `Contingency`;
export const draftOpportunityQuoteWithAiResponseQuoteOneOneContingencyLabelMax = 200;

export const draftOpportunityQuoteWithAiResponseQuoteOneTwoCurrentRevisionNoMin = 0;

export const draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOneInclusionDefault = `included`;
export const draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOnePricingMethodDefault = `fixed`;
export const draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOneEffortHoursRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOneLineDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOneTaxRatePctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const draftOpportunityQuoteWithAiResponseQuoteTwoSectionsItemOneTitleMax = 200;

export const draftOpportunityQuoteWithAiResponseQuoteTwoSectionsItemOneSortOrderMin = 0;



export const draftOpportunityQuoteWithAiResponse = zod.object({
  "quote": zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(draftOpportunityQuoteWithAiResponseQuoteOneOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(draftOpportunityQuoteWithAiResponseQuoteOneOneCurrencyRegExp),
  "discountPct": zod.string().regex(draftOpportunityQuoteWithAiResponseQuoteOneOneDiscountPctRegExp).default(draftOpportunityQuoteWithAiResponseQuoteOneOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(draftOpportunityQuoteWithAiResponseQuoteOneOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(draftOpportunityQuoteWithAiResponseQuoteOneOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(draftOpportunityQuoteWithAiResponseQuoteOneOneContingencyPctRegExp).default(draftOpportunityQuoteWithAiResponseQuoteOneOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(draftOpportunityQuoteWithAiResponseQuoteOneOneContingencyLabelMax).default(draftOpportunityQuoteWithAiResponseQuoteOneOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(draftOpportunityQuoteWithAiResponseQuoteOneTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).and(zod.object({
  "items": zod.array(zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "priceListItemId": zod.uuid().nullish(),
  "sectionId": zod.uuid().nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']).default(draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOneInclusionDefault),
  "alternativeToItemId": zod.uuid().nullable(),
  "pricingMethod": zod.enum(['fixed', 'effort']).default(draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOnePricingMethodDefault),
  "effortHours": zod.string().regex(draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOneEffortHoursRegExp).nullable(),
  "rateId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "hourlyRateSnapshot": zod.string().nullable(),
  "unitCost": zod.string().nullish(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "quantity": zod.string().optional(),
  "unitPrice": zod.string().nullish(),
  "oneOffUnitPrice": zod.string().nullish(),
  "recurringUnitPrice": zod.string().nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']).optional(),
  "lineDiscountPct": zod.string().regex(draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOneLineDiscountPctRegExp).optional(),
  "taxRatePct": zod.string().regex(draftOpportunityQuoteWithAiResponseQuoteTwoItemsItemOneTaxRatePctRegExp).optional(),
  "aiRationale": zod.string().nullish(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "lineTotal": zod.string().nullish(),
  "lineOneOffTotal": zod.string(),
  "lineRecurringTotal": zod.string(),
  "lineCost": zod.string().optional().describe('Internal line cost returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal line margin percentage returned only to quote administrators.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "sections": zod.array(zod.object({
  "title": zod.string().min(1).max(draftOpportunityQuoteWithAiResponseQuoteTwoSectionsItemOneTitleMax),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(draftOpportunityQuoteWithAiResponseQuoteTwoSectionsItemOneSortOrderMin)
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "documents": zod.array(zod.object({
  "fileId": zod.uuid(),
  "label": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "uploadedByUserId": zod.uuid().nullish(),
  "filename": zod.string().nullish(),
  "contentType": zod.string().nullish(),
  "sizeBytes": zod.int().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})))
})),
  "summary": zod.string(),
  "assumptions": zod.array(zod.string()),
  "openQuestions": zod.array(zod.string()),
  "governanceActionId": zod.uuid(),
  "draftOnly": zod.literal(true)
})


/**
 * @summary Apply a staff instruction to an AI quote as a new editable revision
 */
export const reviseQuoteWithAiParams = zod.object({
  "id": zod.uuid()
})

export const reviseQuoteWithAiBodyInstructionMax = 4000;



export const reviseQuoteWithAiBody = zod.object({
  "instruction": zod.string().min(1).max(reviseQuoteWithAiBodyInstructionMax),
  "requestId": zod.uuid().optional()
})

export const reviseQuoteWithAiResponseQuoteOneOneKindDefault = `quote`;
export const reviseQuoteWithAiResponseQuoteOneOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviseQuoteWithAiResponseQuoteOneOneDiscountPctDefault = `0`;
export const reviseQuoteWithAiResponseQuoteOneOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const reviseQuoteWithAiResponseQuoteOneOneAssumptionsMdMax = 20000;

export const reviseQuoteWithAiResponseQuoteOneOneExclusionsMdMax = 20000;

export const reviseQuoteWithAiResponseQuoteOneOneContingencyPctDefault = `0`;
export const reviseQuoteWithAiResponseQuoteOneOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const reviseQuoteWithAiResponseQuoteOneOneContingencyLabelDefault = `Contingency`;
export const reviseQuoteWithAiResponseQuoteOneOneContingencyLabelMax = 200;

export const reviseQuoteWithAiResponseQuoteOneTwoCurrentRevisionNoMin = 0;

export const reviseQuoteWithAiResponseQuoteTwoItemsItemOneInclusionDefault = `included`;
export const reviseQuoteWithAiResponseQuoteTwoItemsItemOnePricingMethodDefault = `fixed`;
export const reviseQuoteWithAiResponseQuoteTwoItemsItemOneEffortHoursRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const reviseQuoteWithAiResponseQuoteTwoItemsItemOneLineDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const reviseQuoteWithAiResponseQuoteTwoItemsItemOneTaxRatePctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const reviseQuoteWithAiResponseQuoteTwoSectionsItemOneTitleMax = 200;

export const reviseQuoteWithAiResponseQuoteTwoSectionsItemOneSortOrderMin = 0;



export const reviseQuoteWithAiResponse = zod.object({
  "quote": zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(reviseQuoteWithAiResponseQuoteOneOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(reviseQuoteWithAiResponseQuoteOneOneCurrencyRegExp),
  "discountPct": zod.string().regex(reviseQuoteWithAiResponseQuoteOneOneDiscountPctRegExp).default(reviseQuoteWithAiResponseQuoteOneOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(reviseQuoteWithAiResponseQuoteOneOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(reviseQuoteWithAiResponseQuoteOneOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(reviseQuoteWithAiResponseQuoteOneOneContingencyPctRegExp).default(reviseQuoteWithAiResponseQuoteOneOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(reviseQuoteWithAiResponseQuoteOneOneContingencyLabelMax).default(reviseQuoteWithAiResponseQuoteOneOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(reviseQuoteWithAiResponseQuoteOneTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).and(zod.object({
  "items": zod.array(zod.object({
  "itemType": zod.enum(['solution', 'product', 'module', 'service']),
  "solutionId": zod.uuid().nullish(),
  "productId": zod.uuid().nullish(),
  "moduleId": zod.uuid().nullish(),
  "serviceId": zod.uuid().nullish(),
  "priceListItemId": zod.uuid().nullish(),
  "sectionId": zod.uuid().nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']).default(reviseQuoteWithAiResponseQuoteTwoItemsItemOneInclusionDefault),
  "alternativeToItemId": zod.uuid().nullable(),
  "pricingMethod": zod.enum(['fixed', 'effort']).default(reviseQuoteWithAiResponseQuoteTwoItemsItemOnePricingMethodDefault),
  "effortHours": zod.string().regex(reviseQuoteWithAiResponseQuoteTwoItemsItemOneEffortHoursRegExp).nullable(),
  "rateId": zod.uuid().nullable(),
  "roleName": zod.string().nullable(),
  "hourlyRateSnapshot": zod.string().nullable(),
  "unitCost": zod.string().nullish(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "quantity": zod.string().optional(),
  "unitPrice": zod.string().nullish(),
  "oneOffUnitPrice": zod.string().nullish(),
  "recurringUnitPrice": zod.string().nullish(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']).optional(),
  "lineDiscountPct": zod.string().regex(reviseQuoteWithAiResponseQuoteTwoItemsItemOneLineDiscountPctRegExp).optional(),
  "taxRatePct": zod.string().regex(reviseQuoteWithAiResponseQuoteTwoItemsItemOneTaxRatePctRegExp).optional(),
  "aiRationale": zod.string().nullish(),
  "sortOrder": zod.int().optional()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "lineTotal": zod.string().nullish(),
  "lineOneOffTotal": zod.string(),
  "lineRecurringTotal": zod.string(),
  "lineCost": zod.string().optional().describe('Internal line cost returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal line margin percentage returned only to quote administrators.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "sections": zod.array(zod.object({
  "title": zod.string().min(1).max(reviseQuoteWithAiResponseQuoteTwoSectionsItemOneTitleMax),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int().min(reviseQuoteWithAiResponseQuoteTwoSectionsItemOneSortOrderMin)
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "documents": zod.array(zod.object({
  "fileId": zod.uuid(),
  "label": zod.string().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "uploadedByUserId": zod.uuid().nullish(),
  "filename": zod.string().nullish(),
  "contentType": zod.string().nullish(),
  "sizeBytes": zod.int().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})))
})),
  "summary": zod.string(),
  "assumptions": zod.array(zod.string()),
  "openQuestions": zod.array(zod.string()),
  "governanceActionId": zod.uuid(),
  "draftOnly": zod.literal(true)
})


/**
 * @summary Generate, store and email the current quote PDF with a secure decision link
 */
export const sendQuoteParams = zod.object({
  "id": zod.uuid()
})

export const sendQuoteHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const sendQuoteHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(sendQuoteHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const sendQuoteResponseQuoteOneKindDefault = `quote`;
export const sendQuoteResponseQuoteOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const sendQuoteResponseQuoteOneDiscountPctDefault = `0`;
export const sendQuoteResponseQuoteOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const sendQuoteResponseQuoteOneAssumptionsMdMax = 20000;

export const sendQuoteResponseQuoteOneExclusionsMdMax = 20000;

export const sendQuoteResponseQuoteOneContingencyPctDefault = `0`;
export const sendQuoteResponseQuoteOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const sendQuoteResponseQuoteOneContingencyLabelDefault = `Contingency`;
export const sendQuoteResponseQuoteOneContingencyLabelMax = 200;

export const sendQuoteResponseQuoteTwoCurrentRevisionNoMin = 0;



export const sendQuoteResponse = zod.object({
  "quote": zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(sendQuoteResponseQuoteOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(sendQuoteResponseQuoteOneCurrencyRegExp),
  "discountPct": zod.string().regex(sendQuoteResponseQuoteOneDiscountPctRegExp).default(sendQuoteResponseQuoteOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(sendQuoteResponseQuoteOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(sendQuoteResponseQuoteOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(sendQuoteResponseQuoteOneContingencyPctRegExp).default(sendQuoteResponseQuoteOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(sendQuoteResponseQuoteOneContingencyLabelMax).default(sendQuoteResponseQuoteOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(sendQuoteResponseQuoteTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "publicUrl": zod.url().describe('Secure customer review URL created for this delivery.'),
  "pdfDownloadUrl": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Download the latest generated PDF for a quote
 */
export const downloadQuotePdfParams = zod.object({
  "id": zod.uuid()
})

export const downloadQuotePdfResponse = zod.unknown()


/**
 * @summary Download the current quote as a customer or internal Excel pricing schedule
 */
export const downloadQuotePricingScheduleParams = zod.object({
  "id": zod.uuid()
})

export const downloadQuotePricingScheduleQueryAudienceDefault = `customer`;

export const downloadQuotePricingScheduleQueryParams = zod.object({
  "audience": zod.enum(['customer', 'internal']).default(downloadQuotePricingScheduleQueryAudienceDefault)
})

export const downloadQuotePricingScheduleResponse = zod.unknown()


/**
 * @summary Mark a recalculated quote as priced when approval is satisfied
 */
export const markQuotePricedParams = zod.object({
  "id": zod.uuid()
})

export const markQuotePricedResponseOneKindDefault = `quote`;
export const markQuotePricedResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const markQuotePricedResponseOneDiscountPctDefault = `0`;
export const markQuotePricedResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const markQuotePricedResponseOneAssumptionsMdMax = 20000;

export const markQuotePricedResponseOneExclusionsMdMax = 20000;

export const markQuotePricedResponseOneContingencyPctDefault = `0`;
export const markQuotePricedResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const markQuotePricedResponseOneContingencyLabelDefault = `Contingency`;
export const markQuotePricedResponseOneContingencyLabelMax = 200;

export const markQuotePricedResponseTwoCurrentRevisionNoMin = 0;



export const markQuotePricedResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(markQuotePricedResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(markQuotePricedResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(markQuotePricedResponseOneDiscountPctRegExp).default(markQuotePricedResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(markQuotePricedResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(markQuotePricedResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(markQuotePricedResponseOneContingencyPctRegExp).default(markQuotePricedResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(markQuotePricedResponseOneContingencyLabelMax).default(markQuotePricedResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(markQuotePricedResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Expire up to 100 sent quotes whose validity has elapsed
 */
export const expireDueQuotesResponseExpiredMin = 0;



export const expireDueQuotesResponse = zod.object({
  "expired": zod.int().min(expireDueQuotesResponseExpiredMin)
})


/**
 * @summary Snapshot matching prices from an active price list onto quote lines
 */
export const applyQuotePriceListParams = zod.object({
  "id": zod.uuid()
})

export const applyQuotePriceListBody = zod.object({
  "priceListId": zod.uuid()
})

export const applyQuotePriceListResponseOneKindDefault = `quote`;
export const applyQuotePriceListResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const applyQuotePriceListResponseOneDiscountPctDefault = `0`;
export const applyQuotePriceListResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const applyQuotePriceListResponseOneAssumptionsMdMax = 20000;

export const applyQuotePriceListResponseOneExclusionsMdMax = 20000;

export const applyQuotePriceListResponseOneContingencyPctDefault = `0`;
export const applyQuotePriceListResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const applyQuotePriceListResponseOneContingencyLabelDefault = `Contingency`;
export const applyQuotePriceListResponseOneContingencyLabelMax = 200;

export const applyQuotePriceListResponseTwoCurrentRevisionNoMin = 0;



export const applyQuotePriceListResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(applyQuotePriceListResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(applyQuotePriceListResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(applyQuotePriceListResponseOneDiscountPctRegExp).default(applyQuotePriceListResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(applyQuotePriceListResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(applyQuotePriceListResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(applyQuotePriceListResponseOneContingencyPctRegExp).default(applyQuotePriceListResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(applyQuotePriceListResponseOneContingencyLabelMax).default(applyQuotePriceListResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(applyQuotePriceListResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Evaluate the configured discount threshold and request approval when required
 */
export const requestQuoteApprovalParams = zod.object({
  "id": zod.uuid()
})

export const requestQuoteApprovalResponseOneKindDefault = `quote`;
export const requestQuoteApprovalResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const requestQuoteApprovalResponseOneDiscountPctDefault = `0`;
export const requestQuoteApprovalResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const requestQuoteApprovalResponseOneAssumptionsMdMax = 20000;

export const requestQuoteApprovalResponseOneExclusionsMdMax = 20000;

export const requestQuoteApprovalResponseOneContingencyPctDefault = `0`;
export const requestQuoteApprovalResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const requestQuoteApprovalResponseOneContingencyLabelDefault = `Contingency`;
export const requestQuoteApprovalResponseOneContingencyLabelMax = 200;

export const requestQuoteApprovalResponseTwoCurrentRevisionNoMin = 0;



export const requestQuoteApprovalResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(requestQuoteApprovalResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(requestQuoteApprovalResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(requestQuoteApprovalResponseOneDiscountPctRegExp).default(requestQuoteApprovalResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(requestQuoteApprovalResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(requestQuoteApprovalResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(requestQuoteApprovalResponseOneContingencyPctRegExp).default(requestQuoteApprovalResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(requestQuoteApprovalResponseOneContingencyLabelMax).default(requestQuoteApprovalResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(requestQuoteApprovalResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Approve a pending quote as an entity administrator
 */
export const approveQuoteParams = zod.object({
  "id": zod.uuid()
})

export const approveQuoteBodyNoteMax = 2000;



export const approveQuoteBody = zod.object({
  "note": zod.string().max(approveQuoteBodyNoteMax).nullish()
})

export const approveQuoteResponseOneKindDefault = `quote`;
export const approveQuoteResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const approveQuoteResponseOneDiscountPctDefault = `0`;
export const approveQuoteResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const approveQuoteResponseOneAssumptionsMdMax = 20000;

export const approveQuoteResponseOneExclusionsMdMax = 20000;

export const approveQuoteResponseOneContingencyPctDefault = `0`;
export const approveQuoteResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const approveQuoteResponseOneContingencyLabelDefault = `Contingency`;
export const approveQuoteResponseOneContingencyLabelMax = 200;

export const approveQuoteResponseTwoCurrentRevisionNoMin = 0;



export const approveQuoteResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(approveQuoteResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(approveQuoteResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(approveQuoteResponseOneDiscountPctRegExp).default(approveQuoteResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(approveQuoteResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(approveQuoteResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(approveQuoteResponseOneContingencyPctRegExp).default(approveQuoteResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(approveQuoteResponseOneContingencyLabelMax).default(approveQuoteResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(approveQuoteResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Reject a pending quote as an entity administrator
 */
export const rejectQuoteParams = zod.object({
  "id": zod.uuid()
})

export const rejectQuoteBodyNoteMax = 2000;



export const rejectQuoteBody = zod.object({
  "note": zod.string().min(1).max(rejectQuoteBodyNoteMax)
})

export const rejectQuoteResponseOneKindDefault = `quote`;
export const rejectQuoteResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const rejectQuoteResponseOneDiscountPctDefault = `0`;
export const rejectQuoteResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const rejectQuoteResponseOneAssumptionsMdMax = 20000;

export const rejectQuoteResponseOneExclusionsMdMax = 20000;

export const rejectQuoteResponseOneContingencyPctDefault = `0`;
export const rejectQuoteResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const rejectQuoteResponseOneContingencyLabelDefault = `Contingency`;
export const rejectQuoteResponseOneContingencyLabelMax = 200;

export const rejectQuoteResponseTwoCurrentRevisionNoMin = 0;



export const rejectQuoteResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(rejectQuoteResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(rejectQuoteResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(rejectQuoteResponseOneDiscountPctRegExp).default(rejectQuoteResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(rejectQuoteResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(rejectQuoteResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(rejectQuoteResponseOneContingencyPctRegExp).default(rejectQuoteResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(rejectQuoteResponseOneContingencyLabelMax).default(rejectQuoteResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(rejectQuoteResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Duplicate a quote and its immutable line-price snapshots as a new draft
 */
export const duplicateQuoteParams = zod.object({
  "id": zod.uuid()
})

export const duplicateQuoteResponseOneKindDefault = `quote`;
export const duplicateQuoteResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const duplicateQuoteResponseOneDiscountPctDefault = `0`;
export const duplicateQuoteResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const duplicateQuoteResponseOneAssumptionsMdMax = 20000;

export const duplicateQuoteResponseOneExclusionsMdMax = 20000;

export const duplicateQuoteResponseOneContingencyPctDefault = `0`;
export const duplicateQuoteResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const duplicateQuoteResponseOneContingencyLabelDefault = `Contingency`;
export const duplicateQuoteResponseOneContingencyLabelMax = 200;

export const duplicateQuoteResponseTwoCurrentRevisionNoMin = 0;



export const duplicateQuoteResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(duplicateQuoteResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(duplicateQuoteResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(duplicateQuoteResponseOneDiscountPctRegExp).default(duplicateQuoteResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(duplicateQuoteResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(duplicateQuoteResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(duplicateQuoteResponseOneContingencyPctRegExp).default(duplicateQuoteResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(duplicateQuoteResponseOneContingencyLabelMax).default(duplicateQuoteResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(duplicateQuoteResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List immutable numbered quote revisions
 */
export const listQuoteRevisionsParams = zod.object({
  "id": zod.uuid()
})

export const listQuoteRevisionsQueryLimitDefault = 50;
export const listQuoteRevisionsQueryLimitMax = 100;

export const listQuoteRevisionsQueryOffsetDefault = 0;
export const listQuoteRevisionsQueryOffsetMin = 0;



export const listQuoteRevisionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listQuoteRevisionsQueryLimitMax).default(listQuoteRevisionsQueryLimitDefault),
  "offset": zod.int().min(listQuoteRevisionsQueryOffsetMin).default(listQuoteRevisionsQueryOffsetDefault)
})


export const listQuoteRevisionsResponseTotalMin = 0;



export const listQuoteRevisionsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "revisionNo": zod.int().min(1),
  "snapshot": zod.record(zod.string(), zod.unknown()),
  "createdByUserId": zod.uuid().nullish(),
  "reason": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listQuoteRevisionsResponseTotalMin)
})


/**
 * @summary Restore an editable quote from an immutable revision snapshot
 */
export const restoreQuoteRevisionParams = zod.object({
  "id": zod.uuid(),
  "revisionId": zod.uuid()
})

export const restoreQuoteRevisionResponseOneKindDefault = `quote`;
export const restoreQuoteRevisionResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const restoreQuoteRevisionResponseOneDiscountPctDefault = `0`;
export const restoreQuoteRevisionResponseOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const restoreQuoteRevisionResponseOneAssumptionsMdMax = 20000;

export const restoreQuoteRevisionResponseOneExclusionsMdMax = 20000;

export const restoreQuoteRevisionResponseOneContingencyPctDefault = `0`;
export const restoreQuoteRevisionResponseOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const restoreQuoteRevisionResponseOneContingencyLabelDefault = `Contingency`;
export const restoreQuoteRevisionResponseOneContingencyLabelMax = 200;

export const restoreQuoteRevisionResponseTwoCurrentRevisionNoMin = 0;



export const restoreQuoteRevisionResponse = zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(restoreQuoteRevisionResponseOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(restoreQuoteRevisionResponseOneCurrencyRegExp),
  "discountPct": zod.string().regex(restoreQuoteRevisionResponseOneDiscountPctRegExp).default(restoreQuoteRevisionResponseOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(restoreQuoteRevisionResponseOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(restoreQuoteRevisionResponseOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(restoreQuoteRevisionResponseOneContingencyPctRegExp).default(restoreQuoteRevisionResponseOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(restoreQuoteRevisionResponseOneContingencyLabelMax).default(restoreQuoteRevisionResponseOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(restoreQuoteRevisionResponseTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List the append-only quote event timeline
 */
export const listQuoteEventsParams = zod.object({
  "id": zod.uuid()
})

export const listQuoteEventsQueryLimitDefault = 50;
export const listQuoteEventsQueryLimitMax = 100;

export const listQuoteEventsQueryOffsetDefault = 0;
export const listQuoteEventsQueryOffsetMin = 0;



export const listQuoteEventsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listQuoteEventsQueryLimitMax).default(listQuoteEventsQueryLimitDefault),
  "offset": zod.int().min(listQuoteEventsQueryOffsetMin).default(listQuoteEventsQueryOffsetDefault)
})

export const listQuoteEventsResponseTotalMin = 0;



export const listQuoteEventsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "quoteRequestId": zod.uuid(),
  "type": zod.enum(['created', 'updated', 'priced', 'approval_requested', 'approved', 'rejected', 'sent', 'viewed', 'accepted', 'declined', 'expired', 'ai_drafted']),
  "actorKind": zod.enum(['staff', 'ai', 'customer', 'system']),
  "actorId": zod.string().nullish(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listQuoteEventsResponseTotalMin)
})


/**
 * @summary List quotes linked to an opportunity
 */
export const listOpportunityQuotesParams = zod.object({
  "id": zod.uuid()
})

export const listOpportunityQuotesQueryLimitDefault = 50;
export const listOpportunityQuotesQueryLimitMax = 100;

export const listOpportunityQuotesQueryOffsetDefault = 0;
export const listOpportunityQuotesQueryOffsetMin = 0;



export const listOpportunityQuotesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listOpportunityQuotesQueryLimitMax).default(listOpportunityQuotesQueryLimitDefault),
  "offset": zod.int().min(listOpportunityQuotesQueryOffsetMin).default(listOpportunityQuotesQueryOffsetDefault)
})

export const listOpportunityQuotesResponseDataItemOneKindDefault = `quote`;
export const listOpportunityQuotesResponseDataItemOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listOpportunityQuotesResponseDataItemOneDiscountPctDefault = `0`;
export const listOpportunityQuotesResponseDataItemOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const listOpportunityQuotesResponseDataItemOneAssumptionsMdMax = 20000;

export const listOpportunityQuotesResponseDataItemOneExclusionsMdMax = 20000;

export const listOpportunityQuotesResponseDataItemOneContingencyPctDefault = `0`;
export const listOpportunityQuotesResponseDataItemOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const listOpportunityQuotesResponseDataItemOneContingencyLabelDefault = `Contingency`;
export const listOpportunityQuotesResponseDataItemOneContingencyLabelMax = 200;

export const listOpportunityQuotesResponseDataItemTwoCurrentRevisionNoMin = 0;



export const listOpportunityQuotesResponse = zod.object({
  "data": zod.array(zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(listOpportunityQuotesResponseDataItemOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(listOpportunityQuotesResponseDataItemOneCurrencyRegExp),
  "discountPct": zod.string().regex(listOpportunityQuotesResponseDataItemOneDiscountPctRegExp).default(listOpportunityQuotesResponseDataItemOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(listOpportunityQuotesResponseDataItemOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(listOpportunityQuotesResponseDataItemOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(listOpportunityQuotesResponseDataItemOneContingencyPctRegExp).default(listOpportunityQuotesResponseDataItemOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(listOpportunityQuotesResponseDataItemOneContingencyLabelMax).default(listOpportunityQuotesResponseDataItemOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(listOpportunityQuotesResponseDataItemTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int()
})


/**
 * @summary List quotes linked to an account
 */
export const listAccountQuotesParams = zod.object({
  "id": zod.uuid()
})

export const listAccountQuotesQueryLimitDefault = 50;
export const listAccountQuotesQueryLimitMax = 100;

export const listAccountQuotesQueryOffsetDefault = 0;
export const listAccountQuotesQueryOffsetMin = 0;



export const listAccountQuotesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listAccountQuotesQueryLimitMax).default(listAccountQuotesQueryLimitDefault),
  "offset": zod.int().min(listAccountQuotesQueryOffsetMin).default(listAccountQuotesQueryOffsetDefault)
})

export const listAccountQuotesResponseDataItemOneKindDefault = `quote`;
export const listAccountQuotesResponseDataItemOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listAccountQuotesResponseDataItemOneDiscountPctDefault = `0`;
export const listAccountQuotesResponseDataItemOneDiscountPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const listAccountQuotesResponseDataItemOneAssumptionsMdMax = 20000;

export const listAccountQuotesResponseDataItemOneExclusionsMdMax = 20000;

export const listAccountQuotesResponseDataItemOneContingencyPctDefault = `0`;
export const listAccountQuotesResponseDataItemOneContingencyPctRegExp = new RegExp('^\\d+(\\.\\d+)?$');
export const listAccountQuotesResponseDataItemOneContingencyLabelDefault = `Contingency`;
export const listAccountQuotesResponseDataItemOneContingencyLabelMax = 200;

export const listAccountQuotesResponseDataItemTwoCurrentRevisionNoMin = 0;



export const listAccountQuotesResponse = zod.object({
  "data": zod.array(zod.object({
  "kind": zod.enum(['quote', 'estimate', 'tender']).default(listAccountQuotesResponseDataItemOneKindDefault),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "priceListId": zod.uuid().nullish(),
  "requesterName": zod.string().nullish(),
  "requesterEmail": zod.string().nullish(),
  "requesterPhone": zod.string().nullish(),
  "requesterOrganization": zod.string().nullish(),
  "notes": zod.string().nullish(),
  "currency": zod.string().regex(listAccountQuotesResponseDataItemOneCurrencyRegExp),
  "discountPct": zod.string().regex(listAccountQuotesResponseDataItemOneDiscountPctRegExp).default(listAccountQuotesResponseDataItemOneDiscountPctDefault),
  "termsMd": zod.string().nullish(),
  "assumptionsMd": zod.string().max(listAccountQuotesResponseDataItemOneAssumptionsMdMax).nullish(),
  "exclusionsMd": zod.string().max(listAccountQuotesResponseDataItemOneExclusionsMdMax).nullish(),
  "contingencyPct": zod.string().regex(listAccountQuotesResponseDataItemOneContingencyPctRegExp).default(listAccountQuotesResponseDataItemOneContingencyPctDefault),
  "contingencyLabel": zod.string().min(1).max(listAccountQuotesResponseDataItemOneContingencyLabelMax).default(listAccountQuotesResponseDataItemOneContingencyLabelDefault),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "reference": zod.string(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "source": zod.enum(['staff', 'guest', 'ai']),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "currentRevisionNo": zod.int().min(listAccountQuotesResponseDataItemTwoCurrentRevisionNoMin),
  "internalNotes": zod.string().nullish(),
  "subtotal": zod.string().nullish(),
  "discountAmount": zod.string().nullish(),
  "totalPrice": zod.string().nullish(),
  "taxAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyAmount": zod.string(),
  "costTotal": zod.string().optional().describe('Internal total returned only to quote administrators.'),
  "marginPct": zod.string().nullish().describe('Internal margin percentage returned only to quote administrators.'),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "requiresApproval": zod.boolean(),
  "approvalStatus": zod.enum(['not_required', 'pending', 'approved', 'rejected']),
  "approvedByUserId": zod.uuid().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "approvalNote": zod.string().nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentByUserId": zod.uuid().nullish(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declinedAt": zod.iso.datetime({"offset":true}).nullish(),
  "declineReason": zod.string().nullish(),
  "aiGenerated": zod.boolean(),
  "aiBrief": zod.string().nullish(),
  "aiRationaleMd": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "respondedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int()
})


/**
 * @summary View a quote through its opaque customer decision token
 */
export const getPublicQuotePathTokenMin = 43;
export const getPublicQuotePathTokenMax = 43;


export const getPublicQuotePathTokenRegExp = new RegExp('^[A-Za-z0-9_-]+$');


export const getPublicQuoteParams = zod.object({
  "token": zod.string().min(getPublicQuotePathTokenMin).max(getPublicQuotePathTokenMax).regex(getPublicQuotePathTokenRegExp)
})

export const getPublicQuoteResponseCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getPublicQuoteResponseAccentColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');


export const getPublicQuoteResponse = zod.object({
  "reference": zod.string(),
  "kind": zod.enum(['quote', 'estimate', 'tender']),
  "organizationName": zod.string(),
  "customerName": zod.string(),
  "customerOrganization": zod.string().nullish(),
  "status": zod.enum(['draft', 'submitted', 'in_review', 'priced', 'pending_approval', 'sent', 'accepted', 'declined', 'expired']),
  "currency": zod.string().regex(getPublicQuoteResponseCurrencyRegExp),
  "validUntil": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual']),
  "taxAmount": zod.string(),
  "totalPrice": zod.string(),
  "optionalTotal": zod.string(),
  "contingencyLabel": zod.string(),
  "contingencyAmount": zod.string(),
  "assumptionsMd": zod.string().nullish(),
  "exclusionsMd": zod.string().nullish(),
  "termsMd": zod.string().nullish(),
  "accentColour": zod.string().regex(getPublicQuoteResponseAccentColourRegExp),
  "footerText": zod.string().nullish(),
  "pdfDownloadUrl": zod.string(),
  "sections": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "descriptionMd": zod.string().nullish(),
  "sortOrder": zod.int()
})),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "sectionId": zod.uuid().nullish(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "alternativeToItemId": zod.uuid().nullish(),
  "quantity": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "recurringInterval": zod.enum(['none', 'monthly', 'annual'])
}))
})


/**
 * @summary Download the stored quote PDF through an active customer token
 */
export const downloadPublicQuotePdfPathTokenMin = 43;
export const downloadPublicQuotePdfPathTokenMax = 43;


export const downloadPublicQuotePdfPathTokenRegExp = new RegExp('^[A-Za-z0-9_-]+$');


export const downloadPublicQuotePdfParams = zod.object({
  "token": zod.string().min(downloadPublicQuotePdfPathTokenMin).max(downloadPublicQuotePdfPathTokenMax).regex(downloadPublicQuotePdfPathTokenRegExp)
})

export const downloadPublicQuotePdfResponse = zod.unknown()


/**
 * @summary Accept a quote once through its active customer token
 */
export const acceptPublicQuotePathTokenMin = 43;
export const acceptPublicQuotePathTokenMax = 43;


export const acceptPublicQuotePathTokenRegExp = new RegExp('^[A-Za-z0-9_-]+$');


export const acceptPublicQuoteParams = zod.object({
  "token": zod.string().min(acceptPublicQuotePathTokenMin).max(acceptPublicQuotePathTokenMax).regex(acceptPublicQuotePathTokenRegExp)
})

export const acceptPublicQuoteBodyNameMax = 200;

export const acceptPublicQuoteBodyNoteMax = 2000;



export const acceptPublicQuoteBody = zod.object({
  "name": zod.string().min(1).max(acceptPublicQuoteBodyNameMax),
  "note": zod.string().max(acceptPublicQuoteBodyNoteMax).nullish()
})

export const acceptPublicQuoteResponse = zod.object({
  "status": zod.enum(['accepted', 'declined']),
  "message": zod.string()
})


/**
 * @summary Decline a quote once through its active customer token
 */
export const declinePublicQuotePathTokenMin = 43;
export const declinePublicQuotePathTokenMax = 43;


export const declinePublicQuotePathTokenRegExp = new RegExp('^[A-Za-z0-9_-]+$');


export const declinePublicQuoteParams = zod.object({
  "token": zod.string().min(declinePublicQuotePathTokenMin).max(declinePublicQuotePathTokenMax).regex(declinePublicQuotePathTokenRegExp)
})

export const declinePublicQuoteBodyNameMax = 200;

export const declinePublicQuoteBodyReasonMax = 2000;



export const declinePublicQuoteBody = zod.object({
  "name": zod.string().min(1).max(declinePublicQuoteBodyNameMax),
  "reason": zod.string().min(1).max(declinePublicQuoteBodyReasonMax)
})

export const declinePublicQuoteResponse = zod.object({
  "status": zod.enum(['accepted', 'declined']),
  "message": zod.string()
})


/**
 * @summary Get the mock Xero organisation connection state
 */
export const getXeroConnectionResponse = zod.object({
  "connected": zod.boolean(),
  "connection": zod.union([zod.object({
  "id": zod.uuid(),
  "organisationName": zod.string(),
  "tenantId": zod.string(),
  "status": zod.enum(['connected', 'disconnected']),
  "connectedAt": zod.iso.datetime({"offset":true}),
  "disconnectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),zod.null()]).optional()
})


/**
 * @summary Connect (or reconnect) the mock Xero organisation
 */
export const connectXeroOrganisationBodyOrganisationNameMax = 200;



export const connectXeroOrganisationBody = zod.object({
  "organisationName": zod.string().max(connectXeroOrganisationBodyOrganisationNameMax).optional()
})

export const connectXeroOrganisationResponse = zod.object({
  "id": zod.uuid(),
  "organisationName": zod.string(),
  "tenantId": zod.string(),
  "status": zod.enum(['connected', 'disconnected']),
  "connectedAt": zod.iso.datetime({"offset":true}),
  "disconnectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Disconnect the mock Xero organisation
 */
export const disconnectXeroOrganisationResponse = zod.object({
  "id": zod.uuid(),
  "organisationName": zod.string(),
  "tenantId": zod.string(),
  "status": zod.enum(['connected', 'disconnected']),
  "connectedAt": zod.iso.datetime({"offset":true}),
  "disconnectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List mock Xero inventory items pulled in for the quote builder
 */
export const listXeroItemsQuerySearchMax = 100;

export const listXeroItemsQueryLimitDefault = 50;
export const listXeroItemsQueryLimitMax = 100;

export const listXeroItemsQueryOffsetDefault = 0;
export const listXeroItemsQueryOffsetMin = 0;



export const listXeroItemsQueryParams = zod.object({
  "search": zod.string().max(listXeroItemsQuerySearchMax).optional().describe('Matches item code, name, or description'),
  "limit": zod.int().min(1).max(listXeroItemsQueryLimitMax).default(listXeroItemsQueryLimitDefault),
  "offset": zod.int().min(listXeroItemsQueryOffsetMin).default(listXeroItemsQueryOffsetDefault)
})

export const listXeroItemsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "code": zod.string(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "unitPrice": zod.string().nullish(),
  "taxRateName": zod.string().nullish(),
  "taxRatePercent": zod.string().nullish(),
  "revenueAccountCode": zod.string().nullish()
})),
  "total": zod.int()
})


/**
 * @summary List mock Xero contacts pulled in for quote requester details
 */
export const listXeroContactsQuerySearchMax = 100;

export const listXeroContactsQueryLimitDefault = 50;
export const listXeroContactsQueryLimitMax = 100;

export const listXeroContactsQueryOffsetDefault = 0;
export const listXeroContactsQueryOffsetMin = 0;



export const listXeroContactsQueryParams = zod.object({
  "search": zod.string().max(listXeroContactsQuerySearchMax).optional().describe('Matches contact name or email'),
  "limit": zod.int().min(1).max(listXeroContactsQueryLimitMax).default(listXeroContactsQueryLimitDefault),
  "offset": zod.int().min(listXeroContactsQueryOffsetMin).default(listXeroContactsQueryOffsetDefault)
})

export const listXeroContactsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "xeroContactId": zod.string().optional(),
  "name": zod.string(),
  "firstName": zod.string().nullish(),
  "lastName": zod.string().nullish(),
  "email": zod.string().nullish(),
  "phone": zod.string().nullish(),
  "city": zod.string().nullish(),
  "country": zod.string().nullish()
})),
  "total": zod.int()
})


/**
 * Regenerates the mock Xero catalogue (items and contacts), replacing existing synced rows.
 * @summary Sync inventory items and contacts from the mock Xero organisation
 */
export const syncXeroCatalogResponse = zod.object({
  "items": zod.int(),
  "contacts": zod.int()
})


/**
 * @summary Clear the synced mock Xero catalogue
 */
export const clearXeroCatalogResponse = zod.object({
  "items": zod.int(),
  "contacts": zod.int()
})


/**
 * @summary List mock Xero invoices
 */
export const listXeroInvoicesQueryLimitDefault = 50;
export const listXeroInvoicesQueryLimitMax = 100;

export const listXeroInvoicesQueryOffsetDefault = 0;
export const listXeroInvoicesQueryOffsetMin = 0;



export const listXeroInvoicesQueryParams = zod.object({
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']).optional(),
  "quoteRequestId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listXeroInvoicesQueryLimitMax).default(listXeroInvoicesQueryLimitDefault),
  "offset": zod.int().min(listXeroInvoicesQueryOffsetMin).default(listXeroInvoicesQueryOffsetDefault)
})

export const listXeroInvoicesResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "currency": zod.string(),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int()
})


/**
 * @summary Get a mock Xero invoice with its lines
 */
export const getXeroInvoiceParams = zod.object({
  "id": zod.uuid()
})

export const getXeroInvoiceResponse = zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "currency": zod.string(),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "invoiceId": zod.uuid(),
  "description": zod.string(),
  "quantity": zod.string(),
  "unitAmount": zod.string().nullish(),
  "lineAmount": zod.string().nullish(),
  "taxAmount": zod.string(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "allowedTransitions": zod.array(zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']))
}))


/**
 * @summary Generate a mock Xero draft invoice from a sent or accepted quote request
 */
export const createXeroInvoiceFromQuoteBody = zod.object({
  "quoteRequestId": zod.uuid()
})

export const createXeroInvoiceFromQuoteResponse = zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "currency": zod.string(),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "invoiceId": zod.uuid(),
  "description": zod.string(),
  "quantity": zod.string(),
  "unitAmount": zod.string().nullish(),
  "lineAmount": zod.string().nullish(),
  "taxAmount": zod.string(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "allowedTransitions": zod.array(zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']))
}))


/**
 * @summary Transition a mock Xero invoice to the next lifecycle status
 */
export const updateXeroInvoiceStatusParams = zod.object({
  "id": zod.uuid()
})

export const updateXeroInvoiceStatusBody = zod.object({
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED'])
})

export const updateXeroInvoiceStatusResponse = zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "currency": zod.string(),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "invoiceId": zod.uuid(),
  "description": zod.string(),
  "quantity": zod.string(),
  "unitAmount": zod.string().nullish(),
  "lineAmount": zod.string().nullish(),
  "taxAmount": zod.string(),
  "sortOrder": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "allowedTransitions": zod.array(zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']))
}))


/**
 * @summary List mock bank feed statement lines
 */
export const listXeroBankTransactionsQueryLimitDefault = 50;
export const listXeroBankTransactionsQueryLimitMax = 100;

export const listXeroBankTransactionsQueryOffsetDefault = 0;
export const listXeroBankTransactionsQueryOffsetMin = 0;



export const listXeroBankTransactionsQueryParams = zod.object({
  "status": zod.enum(['unmatched', 'suggested', 'matched', 'reconciled', 'excluded']).optional(),
  "limit": zod.int().min(1).max(listXeroBankTransactionsQueryLimitMax).default(listXeroBankTransactionsQueryLimitDefault),
  "offset": zod.int().min(listXeroBankTransactionsQueryOffsetMin).default(listXeroBankTransactionsQueryOffsetDefault)
})

export const listXeroBankTransactionsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "transactionDate": zod.iso.datetime({"offset":true}),
  "payee": zod.string(),
  "reference": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['credit', 'debit']),
  "amount": zod.string(),
  "status": zod.enum(['unmatched', 'suggested', 'matched', 'reconciled', 'excluded']),
  "matchedInvoiceId": zod.uuid().nullish(),
  "reconciledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int()
})


/**
 * @summary Clear all mock bank feed statement lines
 */
export const clearXeroBankTransactionsResponse = zod.object({
  "cleared": zod.int()
})


/**
 * Replaces any existing statement lines with a deterministic mix of exact matches, partial payments, typo'd references, duplicates and unrelated noise, so the reconciliation demo has realistic material.
 * @summary Regenerate the mock bank feed from authorised invoices
 */
export const generateXeroBankFeedResponse = zod.object({
  "generated": zod.int(),
  "exactMatches": zod.int(),
  "partialPayments": zod.int(),
  "typoedReferences": zod.int(),
  "duplicates": zod.int(),
  "noise": zod.int()
})


/**
 * Scores each unmatched credit statement line against every AUTHORISED invoice using reference similarity, amount proximity and date proximity, then persists the best suggestion per transaction with a confidence tier and human-readable reasons. Previously rejected pairs are not re-suggested.
 * @summary Run the match engine against unmatched bank credits and AUTHORISED invoices
 */
export const runXeroMatchingResponse = zod.object({
  "transactionsConsidered": zod.int(),
  "invoicesConsidered": zod.int(),
  "suggestionsCreated": zod.int(),
  "unmatchedCredits": zod.int()
})


/**
 * @summary List match suggestions with their transaction and invoice
 */
export const listXeroMatchSuggestionsQueryLimitDefault = 50;
export const listXeroMatchSuggestionsQueryLimitMax = 100;

export const listXeroMatchSuggestionsQueryOffsetDefault = 0;
export const listXeroMatchSuggestionsQueryOffsetMin = 0;



export const listXeroMatchSuggestionsQueryParams = zod.object({
  "status": zod.enum(['suggested', 'accepted', 'rejected']).optional(),
  "limit": zod.int().min(1).max(listXeroMatchSuggestionsQueryLimitMax).default(listXeroMatchSuggestionsQueryLimitDefault),
  "offset": zod.int().min(listXeroMatchSuggestionsQueryOffsetMin).default(listXeroMatchSuggestionsQueryOffsetDefault)
})

export const listXeroMatchSuggestionsResponseDataItemScoreMin = 0;
export const listXeroMatchSuggestionsResponseDataItemScoreMax = 100;



export const listXeroMatchSuggestionsResponse = zod.object({
  "data": zod.array(zod.object({
  "id": zod.uuid(),
  "bankTransactionId": zod.uuid(),
  "invoiceId": zod.uuid(),
  "score": zod.int().min(listXeroMatchSuggestionsResponseDataItemScoreMin).max(listXeroMatchSuggestionsResponseDataItemScoreMax),
  "confidence": zod.enum(['high', 'medium', 'low']),
  "reasons": zod.array(zod.string()),
  "status": zod.enum(['suggested', 'accepted', 'rejected']),
  "transaction": zod.object({
  "id": zod.uuid(),
  "transactionDate": zod.iso.datetime({"offset":true}),
  "payee": zod.string(),
  "reference": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['credit', 'debit']),
  "amount": zod.string(),
  "status": zod.enum(['unmatched', 'suggested', 'matched', 'reconciled', 'excluded']),
  "matchedInvoiceId": zod.uuid().nullish(),
  "reconciledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "invoice": zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "currency": zod.string(),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "amountPaid": zod.string(),
  "amountOutstanding": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int()
})


/**
 * Records a payment against the invoice, marks the statement line reconciled, and marks the invoice PAID once payments cover its total. Partial payments leave the invoice AUTHORISED with an amount outstanding.
 * @summary Accept a suggestion — reconciles the transaction and records a payment
 */
export const acceptXeroMatchSuggestionParams = zod.object({
  "id": zod.uuid()
})

export const acceptXeroMatchSuggestionResponseScoreMin = 0;
export const acceptXeroMatchSuggestionResponseScoreMax = 100;



export const acceptXeroMatchSuggestionResponse = zod.object({
  "id": zod.uuid(),
  "bankTransactionId": zod.uuid(),
  "invoiceId": zod.uuid(),
  "score": zod.int().min(acceptXeroMatchSuggestionResponseScoreMin).max(acceptXeroMatchSuggestionResponseScoreMax),
  "confidence": zod.enum(['high', 'medium', 'low']),
  "reasons": zod.array(zod.string()),
  "status": zod.enum(['suggested', 'accepted', 'rejected']),
  "transaction": zod.object({
  "id": zod.uuid(),
  "transactionDate": zod.iso.datetime({"offset":true}),
  "payee": zod.string(),
  "reference": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['credit', 'debit']),
  "amount": zod.string(),
  "status": zod.enum(['unmatched', 'suggested', 'matched', 'reconciled', 'excluded']),
  "matchedInvoiceId": zod.uuid().nullish(),
  "reconciledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "invoice": zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "currency": zod.string(),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "amountPaid": zod.string(),
  "amountOutstanding": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Reject a suggestion so it is not re-proposed by the match engine
 */
export const rejectXeroMatchSuggestionParams = zod.object({
  "id": zod.uuid()
})

export const rejectXeroMatchSuggestionResponseScoreMin = 0;
export const rejectXeroMatchSuggestionResponseScoreMax = 100;



export const rejectXeroMatchSuggestionResponse = zod.object({
  "id": zod.uuid(),
  "bankTransactionId": zod.uuid(),
  "invoiceId": zod.uuid(),
  "score": zod.int().min(rejectXeroMatchSuggestionResponseScoreMin).max(rejectXeroMatchSuggestionResponseScoreMax),
  "confidence": zod.enum(['high', 'medium', 'low']),
  "reasons": zod.array(zod.string()),
  "status": zod.enum(['suggested', 'accepted', 'rejected']),
  "transaction": zod.object({
  "id": zod.uuid(),
  "transactionDate": zod.iso.datetime({"offset":true}),
  "payee": zod.string(),
  "reference": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['credit', 'debit']),
  "amount": zod.string(),
  "status": zod.enum(['unmatched', 'suggested', 'matched', 'reconciled', 'excluded']),
  "matchedInvoiceId": zod.uuid().nullish(),
  "reconciledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "invoice": zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "currency": zod.string(),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "amountPaid": zod.string(),
  "amountOutstanding": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Manually match a bank statement line to an AUTHORISED invoice
 */
export const manuallyMatchXeroTransactionBody = zod.object({
  "bankTransactionId": zod.uuid(),
  "invoiceId": zod.uuid()
})

export const manuallyMatchXeroTransactionResponseScoreMin = 0;
export const manuallyMatchXeroTransactionResponseScoreMax = 100;



export const manuallyMatchXeroTransactionResponse = zod.object({
  "id": zod.uuid(),
  "bankTransactionId": zod.uuid(),
  "invoiceId": zod.uuid(),
  "score": zod.int().min(manuallyMatchXeroTransactionResponseScoreMin).max(manuallyMatchXeroTransactionResponseScoreMax),
  "confidence": zod.enum(['high', 'medium', 'low']),
  "reasons": zod.array(zod.string()),
  "status": zod.enum(['suggested', 'accepted', 'rejected']),
  "transaction": zod.object({
  "id": zod.uuid(),
  "transactionDate": zod.iso.datetime({"offset":true}),
  "payee": zod.string(),
  "reference": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['credit', 'debit']),
  "amount": zod.string(),
  "status": zod.enum(['unmatched', 'suggested', 'matched', 'reconciled', 'excluded']),
  "matchedInvoiceId": zod.uuid().nullish(),
  "reconciledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "invoice": zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "currency": zod.string(),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "amountPaid": zod.string(),
  "amountOutstanding": zod.string()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Removes the payment recorded for the statement line, returns it to unmatched, and reverts the invoice to AUTHORISED if its remaining payments no longer cover the total.
 * @summary Unmatch a previously reconciled statement line
 */
export const unmatchXeroBankTransactionBody = zod.object({
  "bankTransactionId": zod.uuid()
})

export const unmatchXeroBankTransactionResponse = zod.object({
  "transaction": zod.object({
  "id": zod.uuid(),
  "transactionDate": zod.iso.datetime({"offset":true}),
  "payee": zod.string(),
  "reference": zod.string().nullish(),
  "description": zod.string().nullish(),
  "type": zod.enum(['credit', 'debit']),
  "amount": zod.string(),
  "status": zod.enum(['unmatched', 'suggested', 'matched', 'reconciled', 'excluded']),
  "matchedInvoiceId": zod.uuid().nullish(),
  "reconciledAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "affectedInvoices": zod.array(zod.object({
  "id": zod.uuid(),
  "invoiceNumber": zod.string(),
  "reference": zod.string().nullish(),
  "quoteRequestId": zod.uuid().nullish(),
  "status": zod.enum(['DRAFT', 'SUBMITTED', 'AUTHORISED', 'PAID', 'VOIDED']),
  "currency": zod.string(),
  "subTotal": zod.string(),
  "totalTax": zod.string(),
  "total": zod.string(),
  "issueDate": zod.iso.datetime({"offset":true}),
  "dueDate": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "amountPaid": zod.string(),
  "amountOutstanding": zod.string()
})))
})


/**
 * @summary Reconciliation validation report and summary dashboard numbers
 */
export const getXeroReconciliationReportQueryDaysDefault = 30;
export const getXeroReconciliationReportQueryDaysMin = 0;
export const getXeroReconciliationReportQueryDaysMax = 365;



export const getXeroReconciliationReportQueryParams = zod.object({
  "days": zod.int().min(getXeroReconciliationReportQueryDaysMin).max(getXeroReconciliationReportQueryDaysMax).default(getXeroReconciliationReportQueryDaysDefault).describe('Aging threshold in days for unmatched AUTHORISED invoices')
})

export const getXeroReconciliationReportResponseIssuesMax = 200;



export const getXeroReconciliationReportResponse = zod.object({
  "summary": zod.object({
  "invoiceCount": zod.int(),
  "totalInvoiced": zod.string(),
  "totalReconciled": zod.string(),
  "totalOutstanding": zod.string(),
  "unmatchedTransactionCount": zod.int(),
  "suggestedCount": zod.int(),
  "reconciledTransactionCount": zod.int(),
  "issueCount": zod.int()
}),
  "issues": zod.array(zod.object({
  "type": zod.enum(['amount_mismatch', 'over_payment', 'under_payment', 'duplicate_transaction', 'aging_unmatched', 'orphan_credit']),
  "severity": zod.enum(['high', 'medium', 'low']),
  "message": zod.string(),
  "details": zod.array(zod.string()),
  "bankTransactionId": zod.uuid().nullish(),
  "invoiceId": zod.uuid().nullish(),
  "invoiceNumber": zod.string().nullish()
})).max(getXeroReconciliationReportResponseIssuesMax),
  "issueTotal": zod.int()
})


/**
 * @summary List accounting platform options for AUS/NZ businesses with their connection state
 */
export const listAccountingIntegrationsResponseItemsMax = 20;



export const listAccountingIntegrationsResponse = zod.object({
  "items": zod.array(zod.object({
  "platform": zod.enum(['xero', 'myob', 'quickbooks', 'reckon', 'saasu']),
  "label": zod.string(),
  "description": zod.string(),
  "entityIdLabel": zod.string(),
  "supportsRegion": zod.boolean(),
  "crmSync": zod.boolean().describe('True when the platform drives CRM invoicing today (Xero); others are configuration-only for now.'),
  "connection": zod.union([zod.object({
  "status": zod.enum(['connected', 'disconnected']),
  "organisationName": zod.string(),
  "clientId": zod.string(),
  "entityId": zod.string(),
  "hasClientSecret": zod.boolean(),
  "region": zod.string().nullish(),
  "connectedAt": zod.iso.datetime({"offset":true}),
  "disconnectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Stored connection details. The client secret is never returned — only whether one is stored.'),zod.null()])
})).max(listAccountingIntegrationsResponseItemsMax)
})


/**
 * Mock only — credentials are validated for shape and stored locally; no real OAuth handshake or platform API call is made. Connecting Xero also activates the mock Xero organisation used by the CRM invoicing flow.
 * @summary Save OAuth credentials and mock-connect an accounting platform
 */
export const connectAccountingIntegrationParams = zod.object({
  "platform": zod.enum(['xero', 'myob', 'quickbooks', 'reckon', 'saasu'])
})

export const connectAccountingIntegrationBodyOrganisationNameMax = 200;

export const connectAccountingIntegrationBodyClientIdMax = 200;

export const connectAccountingIntegrationBodyClientSecretMax = 500;

export const connectAccountingIntegrationBodyEntityIdMax = 200;

export const connectAccountingIntegrationBodyRegionMax = 50;



export const connectAccountingIntegrationBody = zod.object({
  "organisationName": zod.string().min(1).max(connectAccountingIntegrationBodyOrganisationNameMax),
  "clientId": zod.string().min(1).max(connectAccountingIntegrationBodyClientIdMax),
  "clientSecret": zod.string().min(1).max(connectAccountingIntegrationBodyClientSecretMax),
  "entityId": zod.string().min(1).max(connectAccountingIntegrationBodyEntityIdMax),
  "region": zod.string().max(connectAccountingIntegrationBodyRegionMax).optional()
})

export const connectAccountingIntegrationResponse = zod.object({
  "platform": zod.enum(['xero', 'myob', 'quickbooks', 'reckon', 'saasu']),
  "label": zod.string(),
  "description": zod.string(),
  "entityIdLabel": zod.string(),
  "supportsRegion": zod.boolean(),
  "crmSync": zod.boolean().describe('True when the platform drives CRM invoicing today (Xero); others are configuration-only for now.'),
  "connection": zod.union([zod.object({
  "status": zod.enum(['connected', 'disconnected']),
  "organisationName": zod.string(),
  "clientId": zod.string(),
  "entityId": zod.string(),
  "hasClientSecret": zod.boolean(),
  "region": zod.string().nullish(),
  "connectedAt": zod.iso.datetime({"offset":true}),
  "disconnectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Stored connection details. The client secret is never returned — only whether one is stored.'),zod.null()])
})


/**
 * @summary Disconnect an accounting platform and clear its stored secret
 */
export const disconnectAccountingIntegrationParams = zod.object({
  "platform": zod.enum(['xero', 'myob', 'quickbooks', 'reckon', 'saasu'])
})

export const disconnectAccountingIntegrationResponse = zod.object({
  "platform": zod.enum(['xero', 'myob', 'quickbooks', 'reckon', 'saasu']),
  "label": zod.string(),
  "description": zod.string(),
  "entityIdLabel": zod.string(),
  "supportsRegion": zod.boolean(),
  "crmSync": zod.boolean().describe('True when the platform drives CRM invoicing today (Xero); others are configuration-only for now.'),
  "connection": zod.union([zod.object({
  "status": zod.enum(['connected', 'disconnected']),
  "organisationName": zod.string(),
  "clientId": zod.string(),
  "entityId": zod.string(),
  "hasClientSecret": zod.boolean(),
  "region": zod.string().nullish(),
  "connectedAt": zod.iso.datetime({"offset":true}),
  "disconnectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Stored connection details. The client secret is never returned — only whether one is stored.'),zod.null()])
})


/**
 * @summary List business case templates
 */
export const listBusinessCaseTemplatesQueryLimitDefault = 50;
export const listBusinessCaseTemplatesQueryLimitMax = 100;

export const listBusinessCaseTemplatesQueryOffsetDefault = 0;
export const listBusinessCaseTemplatesQueryOffsetMin = 0;



export const listBusinessCaseTemplatesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listBusinessCaseTemplatesQueryLimitMax).default(listBusinessCaseTemplatesQueryLimitDefault),
  "offset": zod.int().min(listBusinessCaseTemplatesQueryOffsetMin).default(listBusinessCaseTemplatesQueryOffsetDefault),
  "catalogueProductId": zod.uuid().optional()
})

export const listBusinessCaseTemplatesResponseTotalMin = 0;



export const listBusinessCaseTemplatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "isPublished": zod.boolean(),
  "templateData": zod.record(zod.string(), zod.unknown()).describe('Arbitrary jsonb template structure (sections, prompts, default figures).'),
  "catalogueProductId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listBusinessCaseTemplatesResponseTotalMin)
})


/**
 * @summary Create a business case template
 */
export const createBusinessCaseTemplateBodyNameMax = 200;

export const createBusinessCaseTemplateBodySlugMax = 200;



export const createBusinessCaseTemplateBody = zod.object({
  "name": zod.string().min(1).max(createBusinessCaseTemplateBodyNameMax),
  "slug": zod.string().min(1).max(createBusinessCaseTemplateBodySlugMax),
  "description": zod.string().nullish(),
  "isPublished": zod.boolean().optional(),
  "templateData": zod.record(zod.string(), zod.unknown()).optional(),
  "catalogueProductId": zod.uuid().nullish()
})

export const createBusinessCaseTemplateResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "isPublished": zod.boolean(),
  "templateData": zod.record(zod.string(), zod.unknown()).describe('Arbitrary jsonb template structure (sections, prompts, default figures).'),
  "catalogueProductId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get a business case template
 */
export const getBusinessCaseTemplateParams = zod.object({
  "id": zod.uuid()
})

export const getBusinessCaseTemplateResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "isPublished": zod.boolean(),
  "templateData": zod.record(zod.string(), zod.unknown()).describe('Arbitrary jsonb template structure (sections, prompts, default figures).'),
  "catalogueProductId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a business case template
 */
export const updateBusinessCaseTemplateParams = zod.object({
  "id": zod.uuid()
})

export const updateBusinessCaseTemplateBodyNameMax = 200;

export const updateBusinessCaseTemplateBodySlugMax = 200;



export const updateBusinessCaseTemplateBody = zod.object({
  "name": zod.string().min(1).max(updateBusinessCaseTemplateBodyNameMax).optional(),
  "slug": zod.string().min(1).max(updateBusinessCaseTemplateBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "isPublished": zod.boolean().optional(),
  "templateData": zod.record(zod.string(), zod.unknown()).optional(),
  "catalogueProductId": zod.uuid().nullish()
})

export const updateBusinessCaseTemplateResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "isPublished": zod.boolean(),
  "templateData": zod.record(zod.string(), zod.unknown()).describe('Arbitrary jsonb template structure (sections, prompts, default figures).'),
  "catalogueProductId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a business case template (cascades to its saved cases)
 */
export const deleteBusinessCaseTemplateParams = zod.object({
  "id": zod.uuid()
})

export const deleteBusinessCaseTemplateResponse = zod.void()


/**
 * @summary List saved business cases
 */
export const listSavedBusinessCasesQueryLimitDefault = 50;
export const listSavedBusinessCasesQueryLimitMax = 100;

export const listSavedBusinessCasesQueryOffsetDefault = 0;
export const listSavedBusinessCasesQueryOffsetMin = 0;



export const listSavedBusinessCasesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSavedBusinessCasesQueryLimitMax).default(listSavedBusinessCasesQueryLimitDefault),
  "offset": zod.int().min(listSavedBusinessCasesQueryOffsetMin).default(listSavedBusinessCasesQueryOffsetDefault),
  "templateId": zod.uuid().optional(),
  "accountId": zod.uuid().optional()
})

export const listSavedBusinessCasesResponseTotalMin = 0;



export const listSavedBusinessCasesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "templateId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "isDefault": zod.boolean(),
  "caseData": zod.record(zod.string(), zod.unknown()),
  "accountId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSavedBusinessCasesResponseTotalMin)
})


/**
 * @summary Create a saved business case from a template
 */
export const createSavedBusinessCaseBodyNameMax = 200;



export const createSavedBusinessCaseBody = zod.object({
  "templateId": zod.uuid(),
  "name": zod.string().min(1).max(createSavedBusinessCaseBodyNameMax),
  "description": zod.string().nullish(),
  "isDefault": zod.boolean().optional(),
  "caseData": zod.record(zod.string(), zod.unknown()).optional(),
  "accountId": zod.uuid().nullish()
})

export const createSavedBusinessCaseResponse = zod.object({
  "id": zod.uuid(),
  "templateId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "isDefault": zod.boolean(),
  "caseData": zod.record(zod.string(), zod.unknown()),
  "accountId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get a saved business case
 */
export const getSavedBusinessCaseParams = zod.object({
  "id": zod.uuid()
})

export const getSavedBusinessCaseResponse = zod.object({
  "id": zod.uuid(),
  "templateId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "isDefault": zod.boolean(),
  "caseData": zod.record(zod.string(), zod.unknown()),
  "accountId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a saved business case
 */
export const updateSavedBusinessCaseParams = zod.object({
  "id": zod.uuid()
})

export const updateSavedBusinessCaseBodyNameMax = 200;



export const updateSavedBusinessCaseBody = zod.object({
  "name": zod.string().min(1).max(updateSavedBusinessCaseBodyNameMax).optional(),
  "description": zod.string().nullish(),
  "caseData": zod.record(zod.string(), zod.unknown()).optional(),
  "accountId": zod.uuid().nullish()
})

export const updateSavedBusinessCaseResponse = zod.object({
  "id": zod.uuid(),
  "templateId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "isDefault": zod.boolean(),
  "caseData": zod.record(zod.string(), zod.unknown()),
  "accountId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a saved business case
 */
export const deleteSavedBusinessCaseParams = zod.object({
  "id": zod.uuid()
})

export const deleteSavedBusinessCaseResponse = zod.void()


/**
 * @summary Mark this saved case as the default for its template (clears the previous default)
 */
export const setDefaultSavedBusinessCaseParams = zod.object({
  "id": zod.uuid()
})

export const setDefaultSavedBusinessCaseResponse = zod.object({
  "id": zod.uuid(),
  "templateId": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "isDefault": zod.boolean(),
  "caseData": zod.record(zod.string(), zod.unknown()),
  "accountId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List document suites
 */
export const listDocumentSuitesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Create a document suite
 */
export const createDocumentSuiteBodyNameMax = 200;

export const createDocumentSuiteBodySlugMax = 200;



export const createDocumentSuiteBody = zod.object({
  "name": zod.string().min(1).max(createDocumentSuiteBodyNameMax),
  "slug": zod.string().min(1).max(createDocumentSuiteBodySlugMax),
  "description": zod.string().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
})

export const createDocumentSuiteResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get a document suite
 */
export const getDocumentSuiteParams = zod.object({
  "id": zod.uuid()
})

export const getDocumentSuiteResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a document suite
 */
export const updateDocumentSuiteParams = zod.object({
  "id": zod.uuid()
})

export const updateDocumentSuiteBodyNameMax = 200;

export const updateDocumentSuiteBodySlugMax = 200;



export const updateDocumentSuiteBody = zod.object({
  "name": zod.string().min(1).max(updateDocumentSuiteBodyNameMax).optional(),
  "slug": zod.string().min(1).max(updateDocumentSuiteBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
})

export const updateDocumentSuiteResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a document suite
 */
export const deleteDocumentSuiteParams = zod.object({
  "id": zod.uuid()
})

export const deleteDocumentSuiteResponse = zod.void()


/**
 * @summary List catalogue documents
 */
export const listCatalogueDocumentsQueryParams = zod.object({
  "suiteId": zod.uuid().optional(),
  "itemType": zod.enum(['category', 'solution', 'product', 'module', 'capability']).optional(),
  "itemId": zod.uuid().optional()
})

export const listCatalogueDocumentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "suiteId": zod.uuid(),
  "title": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "itemType": zod.union([zod.enum(['category', 'solution', 'product', 'module', 'capability']),zod.null()]).optional(),
  "itemId": zod.uuid().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Create a catalogue document
 */
export const createCatalogueDocumentBodyTitleMax = 200;

export const createCatalogueDocumentBodySlugMax = 200;



export const createCatalogueDocumentBody = zod.object({
  "suiteId": zod.uuid(),
  "title": zod.string().min(1).max(createCatalogueDocumentBodyTitleMax),
  "slug": zod.string().min(1).max(createCatalogueDocumentBodySlugMax),
  "description": zod.string().nullish(),
  "itemType": zod.union([zod.enum(['category', 'solution', 'product', 'module', 'capability']),zod.null()]).optional(),
  "itemId": zod.uuid().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
})

export const createCatalogueDocumentResponse = zod.object({
  "id": zod.uuid(),
  "suiteId": zod.uuid(),
  "title": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "itemType": zod.union([zod.enum(['category', 'solution', 'product', 'module', 'capability']),zod.null()]).optional(),
  "itemId": zod.uuid().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get a catalogue document
 */
export const getCatalogueDocumentParams = zod.object({
  "id": zod.uuid()
})

export const getCatalogueDocumentResponse = zod.object({
  "id": zod.uuid(),
  "suiteId": zod.uuid(),
  "title": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "itemType": zod.union([zod.enum(['category', 'solution', 'product', 'module', 'capability']),zod.null()]).optional(),
  "itemId": zod.uuid().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a catalogue document
 */
export const updateCatalogueDocumentParams = zod.object({
  "id": zod.uuid()
})

export const updateCatalogueDocumentBodyTitleMax = 200;

export const updateCatalogueDocumentBodySlugMax = 200;



export const updateCatalogueDocumentBody = zod.object({
  "suiteId": zod.uuid().optional(),
  "title": zod.string().min(1).max(updateCatalogueDocumentBodyTitleMax).optional(),
  "slug": zod.string().min(1).max(updateCatalogueDocumentBodySlugMax).optional(),
  "description": zod.string().nullish(),
  "itemType": zod.union([zod.enum(['category', 'solution', 'product', 'module', 'capability']),zod.null()]).optional(),
  "itemId": zod.uuid().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
})

export const updateCatalogueDocumentResponse = zod.object({
  "id": zod.uuid(),
  "suiteId": zod.uuid(),
  "title": zod.string(),
  "slug": zod.string(),
  "description": zod.string().nullish(),
  "itemType": zod.union([zod.enum(['category', 'solution', 'product', 'module', 'capability']),zod.null()]).optional(),
  "itemId": zod.uuid().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a catalogue document
 */
export const deleteCatalogueDocumentParams = zod.object({
  "id": zod.uuid()
})

export const deleteCatalogueDocumentResponse = zod.void()


/**
 * @summary List catalogue artifacts
 */
export const listCatalogueArtifactsQueryParams = zod.object({
  "documentId": zod.uuid().optional()
})

export const listCatalogueArtifactsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "artifactType": zod.enum(['datasheet', 'case_study', 'whitepaper', 'presentation', 'video', 'other']),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Attach an artifact to a catalogue document
 */
export const createCatalogueArtifactBodyTitleMax = 200;



export const createCatalogueArtifactBody = zod.object({
  "documentId": zod.uuid(),
  "title": zod.string().min(1).max(createCatalogueArtifactBodyTitleMax),
  "description": zod.string().nullish(),
  "artifactType": zod.enum(['datasheet', 'case_study', 'whitepaper', 'presentation', 'video', 'other']).optional(),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
})

export const createCatalogueArtifactResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "artifactType": zod.enum(['datasheet', 'case_study', 'whitepaper', 'presentation', 'video', 'other']),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a catalogue artifact
 */
export const updateCatalogueArtifactParams = zod.object({
  "id": zod.uuid()
})

export const updateCatalogueArtifactBodyTitleMax = 200;



export const updateCatalogueArtifactBody = zod.object({
  "title": zod.string().min(1).max(updateCatalogueArtifactBodyTitleMax).optional(),
  "description": zod.string().nullish(),
  "artifactType": zod.enum(['datasheet', 'case_study', 'whitepaper', 'presentation', 'video', 'other']).optional(),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "sortOrder": zod.int().optional(),
  "isActive": zod.boolean().optional()
})

export const updateCatalogueArtifactResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "title": zod.string(),
  "description": zod.string().nullish(),
  "artifactType": zod.enum(['datasheet', 'case_study', 'whitepaper', 'presentation', 'video', 'other']),
  "fileId": zod.uuid().nullish(),
  "url": zod.string().nullish(),
  "sortOrder": zod.int(),
  "isActive": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Remove an artifact from a catalogue document
 */
export const deleteCatalogueArtifactParams = zod.object({
  "id": zod.uuid()
})

export const deleteCatalogueArtifactResponse = zod.void()


/**
 * @summary Harvest a public website into citable knowledge sources
 */
export const startWebHarvestBodyUrlMax = 2048;



export const startWebHarvestBody = zod.object({
  "url": zod.url().max(startWebHarvestBodyUrlMax),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])).optional()
})


export const startWebHarvestResponseSourcesMax = 6;

export const startWebHarvestResponseFailuresMax = 5;



export const startWebHarvestResponse = zod.object({
  "runId": zod.uuid(),
  "rootUrl": zod.url(),
  "createdByUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "articleExists": zod.boolean(),
  "sources": zod.array(zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(startWebHarvestResponseSourcesMax),
  "failures": zod.array(zod.object({
  "url": zod.url(),
  "title": zod.string(),
  "error": zod.string()
})).max(startWebHarvestResponseFailuresMax)
})


/**
 * @summary Get a website harvest and its indexed sources
 */
export const getWebHarvestRunParams = zod.object({
  "runId": zod.uuid()
})


export const getWebHarvestRunResponseSourcesMax = 6;

export const getWebHarvestRunResponseFailuresMax = 5;



export const getWebHarvestRunResponse = zod.object({
  "runId": zod.uuid(),
  "rootUrl": zod.url(),
  "createdByUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "articleExists": zod.boolean(),
  "sources": zod.array(zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(getWebHarvestRunResponseSourcesMax),
  "failures": zod.array(zod.object({
  "url": zod.url(),
  "title": zod.string(),
  "error": zod.string()
})).max(getWebHarvestRunResponseFailuresMax)
})


/**
 * @summary Remove every knowledge source created by a website harvest
 */
export const deleteWebHarvestRunParams = zod.object({
  "runId": zod.uuid()
})

export const deleteWebHarvestRunResponseDeletedCountMin = 0;



export const deleteWebHarvestRunResponse = zod.object({
  "deletedCount": zod.int().min(deleteWebHarvestRunResponseDeletedCountMin)
})


/**
 * @summary Generate a review-only article draft from harvested pages
 */
export const generateWebHarvestArticleParams = zod.object({
  "runId": zod.uuid()
})

export const generateWebHarvestArticleBodyPromptMax = 4000;



export const generateWebHarvestArticleBody = zod.object({
  "prompt": zod.string().min(1).max(generateWebHarvestArticleBodyPromptMax).optional()
})

export const generateWebHarvestArticleResponse = zod.object({
  "title": zod.string(),
  "markdown": zod.string(),
  "citedUrls": zod.array(zod.url()),
  "promptUsed": zod.string()
})


/**
 * @summary Save a reviewed website article as an indexed knowledge source
 */
export const saveWebHarvestArticleParams = zod.object({
  "runId": zod.uuid()
})

export const saveWebHarvestArticleBodyTitleMax = 200;

export const saveWebHarvestArticleBodyMarkdownMax = 100000;

export const saveWebHarvestArticleBodyPromptUsedMax = 4000;



export const saveWebHarvestArticleBody = zod.object({
  "title": zod.string().min(1).max(saveWebHarvestArticleBodyTitleMax),
  "markdown": zod.string().min(1).max(saveWebHarvestArticleBodyMarkdownMax),
  "promptUsed": zod.string().min(1).max(saveWebHarvestArticleBodyPromptUsedMax),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])).optional()
})




export const saveWebHarvestArticleResponse = zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List uploaded knowledge files
 */
export const listKnowledgeFilesQueryPageDefault = 1;

export const listKnowledgeFilesQueryLimitDefault = 25;
export const listKnowledgeFilesQueryLimitMax = 100;



export const listKnowledgeFilesQueryParams = zod.object({
  "suiteId": zod.uuid().optional(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']).optional(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']).optional(),
  "harvestRunId": zod.uuid().optional(),
  "page": zod.int().min(1).default(listKnowledgeFilesQueryPageDefault),
  "limit": zod.int().min(1).max(listKnowledgeFilesQueryLimitMax).default(listKnowledgeFilesQueryLimitDefault)
})


export const listKnowledgeFilesResponseTotalMin = 0;





export const listKnowledgeFilesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listKnowledgeFilesResponseTotalMin),
  "page": zod.int().min(1),
  "limit": zod.int().min(1)
})


/**
 * @summary Register an uploaded file as a knowledge file for AI analysis
 */
export const createKnowledgeFileBodyTitleMax = 200;



export const createKnowledgeFileBody = zod.object({
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string().min(1).max(createKnowledgeFileBodyTitleMax),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']).optional(),
  "sourceUrl": zod.url().nullish(),
  "harvestRunId": zod.uuid().nullish(),
  "harvestPrompt": zod.string().nullish(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])).optional()
})




export const createKnowledgeFileResponse = zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get a knowledge file
 */
export const getKnowledgeFileParams = zod.object({
  "id": zod.uuid()
})




export const getKnowledgeFileResponse = zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a knowledge file (and its RAG document/chunks, if analysed)
 */
export const deleteKnowledgeFileParams = zod.object({
  "id": zod.uuid()
})

export const deleteKnowledgeFileResponse = zod.void()


/**
 * @summary Run (or re-run) AI analysis, writing chunks into the shared documents/RAG store
 */
export const analyzeKnowledgeFileParams = zod.object({
  "id": zod.uuid()
})




export const analyzeKnowledgeFileBody = zod.object({
  "requestId": zod.uuid(),
  "expectedRevision": zod.int().min(1)
})




export const analyzeKnowledgeFileResponse = zod.object({
  "knowledgeFile": zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "session": zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid().nullish(),
  "knowledgeFileId": zod.uuid(),
  "status": zod.enum(['pending', 'running', 'completed', 'failed']),
  "summary": zod.string().nullish(),
  "chunkCount": zod.int().nullish(),
  "errorMessage": zod.string().nullish(),
  "stage": zod.enum(['stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "stageHistory": zod.array(zod.object({
  "stage": zod.enum(['stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "at": zod.iso.datetime({"offset":true}),
  "detail": zod.string().optional()
})),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "replayed": zod.boolean()
})


/**
 * @summary Approve or withdraw a ready knowledge source for public website and voice answers
 */
export const updateKnowledgeVoiceApprovalParams = zod.object({
  "id": zod.uuid()
})




export const updateKnowledgeVoiceApprovalBody = zod.object({
  "approvedForVoice": zod.boolean(),
  "expectedRevision": zod.int().min(1)
})




export const updateKnowledgeVoiceApprovalResponse = zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Set the AI channels allowed to retrieve a knowledge source
 */
export const updateKnowledgeChannelsParams = zod.object({
  "id": zod.uuid()
})

export const updateKnowledgeChannelsBody = zod.object({
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites']))
})




export const updateKnowledgeChannelsResponse = zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List AI analysis session history for a knowledge file
 */
export const listAnalysisSessionsParams = zod.object({
  "id": zod.uuid()
})

export const listAnalysisSessionsQueryPageDefault = 1;

export const listAnalysisSessionsQueryLimitDefault = 20;
export const listAnalysisSessionsQueryLimitMax = 100;



export const listAnalysisSessionsQueryParams = zod.object({
  "page": zod.int().min(1).default(listAnalysisSessionsQueryPageDefault),
  "limit": zod.int().min(1).max(listAnalysisSessionsQueryLimitMax).default(listAnalysisSessionsQueryLimitDefault)
})

export const listAnalysisSessionsResponseTotalMin = 0;





export const listAnalysisSessionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid().nullish(),
  "knowledgeFileId": zod.uuid(),
  "status": zod.enum(['pending', 'running', 'completed', 'failed']),
  "summary": zod.string().nullish(),
  "chunkCount": zod.int().nullish(),
  "errorMessage": zod.string().nullish(),
  "stage": zod.enum(['stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "stageHistory": zod.array(zod.object({
  "stage": zod.enum(['stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "at": zod.iso.datetime({"offset":true}),
  "detail": zod.string().optional()
})),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listAnalysisSessionsResponseTotalMin),
  "page": zod.int().min(1),
  "limit": zod.int().min(1)
})


/**
 * @summary Atomically replace a knowledge source and retire its active index
 */
export const replaceKnowledgeFileParams = zod.object({
  "id": zod.uuid()
})


export const replaceKnowledgeFileBodyTitleMax = 200;



export const replaceKnowledgeFileBody = zod.object({
  "fileId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "title": zod.string().min(1).max(replaceKnowledgeFileBodyTitleMax).optional()
})




export const replaceKnowledgeFileResponse = zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Open an authorized indexed knowledge source and its cited chunks
 */
export const getKnowledgeSourceParams = zod.object({
  "id": zod.uuid()
})

export const getKnowledgeSourceQueryPageDefault = 1;

export const getKnowledgeSourceQueryLimitDefault = 20;
export const getKnowledgeSourceQueryLimitMax = 100;



export const getKnowledgeSourceQueryParams = zod.object({
  "page": zod.int().min(1).default(getKnowledgeSourceQueryPageDefault),
  "limit": zod.int().min(1).max(getKnowledgeSourceQueryLimitMax).default(getKnowledgeSourceQueryLimitDefault),
  "chunkId": zod.uuid().optional()
})


export const getKnowledgeSourceResponseChunksItemChunkIndexMin = 0;

export const getKnowledgeSourceResponseTotalMin = 0;





export const getKnowledgeSourceResponse = zod.object({
  "knowledgeFile": zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid(),
  "suiteId": zod.uuid().nullish(),
  "title": zod.string(),
  "status": zod.enum(['uploaded', 'analyzing', 'analyzed', 'stored', 'extracting', 'chunking', 'embedding', 'ready', 'failed']),
  "ragDocumentId": zod.uuid().nullish(),
  "errorMessage": zod.string().nullish(),
  "approvedForVoice": zod.boolean(),
  "sourceKind": zod.enum(['upload', 'sharepoint', 'web']),
  "sourceUrl": zod.url().nullable(),
  "harvestRunId": zod.uuid().nullable(),
  "harvestPrompt": zod.string().nullable(),
  "channels": zod.array(zod.enum(['agent', 'content_generate', 'quotes', 'guidance', 'public_chat', 'voice', 'microsites'])),
  "revision": zod.int().min(1),
  "lastIndexedAt": zod.iso.datetime({"offset":true}).nullish(),
  "uploadedByUserId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "filename": zod.string(),
  "sharePoint": zod.union([zod.object({
  "id": zod.uuid(),
  "driveId": zod.string(),
  "driveItemId": zod.string(),
  "pendingKnowledgeFileId": zod.uuid().nullish(),
  "stored": zod.boolean(),
  "format": zod.string(),
  "knowledgeFileId": zod.uuid().nullish(),
  "name": zod.string(),
  "webUrl": zod.string(),
  "sourcePath": zod.string().optional(),
  "etag": zod.string().nullish(),
  "importedAt": zod.iso.datetime({"offset":true}).nullish(),
  "sourceStatus": zod.enum(['current', 'removed_upstream', 'disconnected']),
  "outcome": zod.enum(['created', 'updated', 'unchanged', 'retained', 'skipped', 'failed', 'folder']),
  "indexed": zod.boolean(),
  "reason": zod.string().nullish()
}),zod.null()]).optional(),
  "chunks": zod.array(zod.object({
  "id": zod.uuid(),
  "chunkIndex": zod.int().min(getKnowledgeSourceResponseChunksItemChunkIndexMin),
  "location": zod.string(),
  "content": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(getKnowledgeSourceResponseTotalMin),
  "page": zod.int().min(1),
  "limit": zod.int().min(1)
})


/**
 * @summary Retrieve the private stored original with entity Knowledge permission
 */
export const getKnowledgeStoredContentParams = zod.object({
  "id": zod.uuid()
})

export const getKnowledgeStoredContentResponse = zod.unknown()


/**
 * @summary Reconcile current stored, indexed, retained and unsuccessful source items
 */
export const listKnowledgeSharePointItemsParams = zod.object({
  "id": zod.uuid()
})

export const listKnowledgeSharePointItemsQueryPageDefault = 1;

export const listKnowledgeSharePointItemsQueryLimitDefault = 25;
export const listKnowledgeSharePointItemsQueryLimitMax = 100;



export const listKnowledgeSharePointItemsQueryParams = zod.object({
  "page": zod.int().min(1).default(listKnowledgeSharePointItemsQueryPageDefault),
  "limit": zod.int().min(1).max(listKnowledgeSharePointItemsQueryLimitMax).default(listKnowledgeSharePointItemsQueryLimitDefault)
})

export const listKnowledgeSharePointItemsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "driveId": zod.string(),
  "driveItemId": zod.string(),
  "pendingKnowledgeFileId": zod.uuid().nullish(),
  "stored": zod.boolean(),
  "format": zod.string(),
  "knowledgeFileId": zod.uuid().nullish(),
  "name": zod.string(),
  "webUrl": zod.string(),
  "sourcePath": zod.string().optional(),
  "etag": zod.string().nullish(),
  "importedAt": zod.iso.datetime({"offset":true}).nullish(),
  "sourceStatus": zod.enum(['current', 'removed_upstream', 'disconnected']),
  "outcome": zod.enum(['created', 'updated', 'unchanged', 'retained', 'skipped', 'failed', 'folder']),
  "indexed": zod.boolean(),
  "reason": zod.string().nullish()
})),
  "total": zod.int(),
  "page": zod.int(),
  "limit": zod.int()
})


/**
 * @summary View ingestion and retrieval readiness without document content or secrets
 */
export const getKnowledgeHealthResponseTotalFilesMin = 0;

export const getKnowledgeHealthResponseReadyFilesMin = 0;

export const getKnowledgeHealthResponseFailedFilesMin = 0;

export const getKnowledgeHealthResponseProcessingFilesMin = 0;

export const getKnowledgeHealthResponseStaleFilesMin = 0;

export const getKnowledgeHealthResponseDocumentCountMin = 0;

export const getKnowledgeHealthResponseChunkCountMin = 0;

export const getKnowledgeHealthResponseEmbeddedChunkCountMin = 0;

export const getKnowledgeHealthResponseEmbeddingCoverageMin = 0;
export const getKnowledgeHealthResponseEmbeddingCoverageMax = 1;


export const getKnowledgeHealthResponseSharePointTotalConnectionsMin = 0;

export const getKnowledgeHealthResponseSharePointEnabledConnectionsMin = 0;

export const getKnowledgeHealthResponseSharePointReauthRequiredConnectionsMin = 0;

export const getKnowledgeHealthResponseSharePointFailingConnectionsMin = 0;

export const getKnowledgeHealthResponseRetrievalRequestsMin = 0;

export const getKnowledgeHealthResponseRetrievalReturnedSourcesMin = 0;

export const getKnowledgeHealthResponseRetrievalDeniedMatchesMin = 0;

export const getKnowledgeHealthResponseRetrievalLowConfidenceQueriesMin = 0;



export const getKnowledgeHealthResponse = zod.object({
  "state": zod.enum(['empty', 'not_ready', 'ready']),
  "totalFiles": zod.int().min(getKnowledgeHealthResponseTotalFilesMin),
  "readyFiles": zod.int().min(getKnowledgeHealthResponseReadyFilesMin),
  "failedFiles": zod.int().min(getKnowledgeHealthResponseFailedFilesMin),
  "processingFiles": zod.int().min(getKnowledgeHealthResponseProcessingFilesMin),
  "staleFiles": zod.int().min(getKnowledgeHealthResponseStaleFilesMin),
  "documentCount": zod.int().min(getKnowledgeHealthResponseDocumentCountMin),
  "chunkCount": zod.int().min(getKnowledgeHealthResponseChunkCountMin),
  "embeddedChunkCount": zod.int().min(getKnowledgeHealthResponseEmbeddedChunkCountMin),
  "embeddingCoverage": zod.number().min(getKnowledgeHealthResponseEmbeddingCoverageMin).max(getKnowledgeHealthResponseEmbeddingCoverageMax),
  "supportedTypes": zod.array(zod.string()),
  "staleAfterDays": zod.int().min(1),
  "failures": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "errorMessage": zod.string(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "sharePoint": zod.object({
  "totalConnections": zod.int().min(getKnowledgeHealthResponseSharePointTotalConnectionsMin),
  "enabledConnections": zod.int().min(getKnowledgeHealthResponseSharePointEnabledConnectionsMin),
  "reauthRequiredConnections": zod.int().min(getKnowledgeHealthResponseSharePointReauthRequiredConnectionsMin),
  "failingConnections": zod.int().min(getKnowledgeHealthResponseSharePointFailingConnectionsMin),
  "lastSyncFailures": zod.array(zod.object({
  "connectionId": zod.uuid(),
  "sourceName": zod.string(),
  "status": zod.enum(['reauth_required', 'partial', 'failed']),
  "error": zod.string(),
  "finishedAt": zod.iso.datetime({"offset":true}).nullable()
}))
}),
  "retrieval": zod.object({
  "requests": zod.int().min(getKnowledgeHealthResponseRetrievalRequestsMin),
  "returnedSources": zod.int().min(getKnowledgeHealthResponseRetrievalReturnedSourcesMin),
  "deniedMatches": zod.int().min(getKnowledgeHealthResponseRetrievalDeniedMatchesMin),
  "lowConfidenceQueries": zod.int().min(getKnowledgeHealthResponseRetrievalLowConfidenceQueriesMin),
  "lastState": zod.enum(['ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence']),
  "lastRetrievedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "checkedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Start administrator consent for a read-only SharePoint knowledge connection
 */
export const startKnowledgeSharePointConnectionResponse = zod.object({
  "authorizationUrl": zod.url()
})


/**
 * @summary Reauthorize an existing SharePoint knowledge connection without changing its selected source
 */
export const reconnectKnowledgeSharePointConnectionParams = zod.object({
  "id": zod.uuid()
})

export const reconnectKnowledgeSharePointConnectionResponse = zod.object({
  "authorizationUrl": zod.url()
})


/**
 * @summary Complete the browser-bound Microsoft authorization-code flow
 */
export const completeKnowledgeSharePointConnectionQueryCodeMax = 8192;



export const completeKnowledgeSharePointConnectionQueryParams = zod.object({
  "code": zod.string().min(1).max(completeKnowledgeSharePointConnectionQueryCodeMax),
  "state": zod.uuid()
})

export const completeKnowledgeSharePointConnectionResponse = zod.void()


/**
 * @summary List safe SharePoint connection metadata for the selected entity
 */
export const listKnowledgeSharePointConnectionsQueryPageDefault = 1;

export const listKnowledgeSharePointConnectionsQueryLimitDefault = 25;
export const listKnowledgeSharePointConnectionsQueryLimitMax = 100;



export const listKnowledgeSharePointConnectionsQueryParams = zod.object({
  "page": zod.int().min(1).default(listKnowledgeSharePointConnectionsQueryPageDefault),
  "limit": zod.int().min(1).max(listKnowledgeSharePointConnectionsQueryLimitMax).default(listKnowledgeSharePointConnectionsQueryLimitDefault)
})

export const listKnowledgeSharePointConnectionsResponseItemsItemScheduleMinutesMin = 5;
export const listKnowledgeSharePointConnectionsResponseItemsItemScheduleMinutesMax = 10080;

export const listKnowledgeSharePointConnectionsResponseTotalMin = 0;





export const listKnowledgeSharePointConnectionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "accountDisplayName": zod.string(),
  "mode": zod.enum(['mirror', 'manual_retained']).optional(),
  "lastSuccessfulRefreshAt": zod.iso.datetime({"offset":true}).nullish(),
  "disconnectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "authStatus": zod.enum(['connected', 'reauth_required']),
  "sourceConfigured": zod.boolean(),
  "siteId": zod.string(),
  "siteName": zod.string(),
  "siteUrl": zod.string(),
  "driveId": zod.string(),
  "driveName": zod.string(),
  "folderItemId": zod.string().nullish(),
  "folderPath": zod.string(),
  "scheduleMinutes": zod.int().min(listKnowledgeSharePointConnectionsResponseItemsItemScheduleMinutesMin).max(listKnowledgeSharePointConnectionsResponseItemsItemScheduleMinutesMax),
  "enabled": zod.boolean(),
  "lastSyncStartedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastSyncFinishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastSyncStatus": zod.enum(['idle', 'running', 'succeeded', 'partial', 'failed']),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listKnowledgeSharePointConnectionsResponseTotalMin),
  "page": zod.int().min(1),
  "limit": zod.int().min(1)
})


/**
 * @summary Configure the selected library, optional folder, schedule, or enabled state
 */
export const updateKnowledgeSharePointConnectionParams = zod.object({
  "id": zod.uuid()
})

export const updateKnowledgeSharePointConnectionBodySiteIdMax = 512;

export const updateKnowledgeSharePointConnectionBodySiteNameMax = 300;

export const updateKnowledgeSharePointConnectionBodySiteUrlMax = 2048;

export const updateKnowledgeSharePointConnectionBodyDriveIdMax = 512;

export const updateKnowledgeSharePointConnectionBodyDriveNameMax = 300;

export const updateKnowledgeSharePointConnectionBodyFolderItemIdMax = 512;

export const updateKnowledgeSharePointConnectionBodyFolderPathMax = 2048;

export const updateKnowledgeSharePointConnectionBodyScheduleMinutesMin = 5;
export const updateKnowledgeSharePointConnectionBodyScheduleMinutesMax = 10080;



export const updateKnowledgeSharePointConnectionBody = zod.object({
  "mode": zod.enum(['mirror', 'manual_retained']).optional(),
  "siteId": zod.string().min(1).max(updateKnowledgeSharePointConnectionBodySiteIdMax).optional(),
  "siteName": zod.string().min(1).max(updateKnowledgeSharePointConnectionBodySiteNameMax).optional(),
  "siteUrl": zod.url().max(updateKnowledgeSharePointConnectionBodySiteUrlMax).optional(),
  "driveId": zod.string().min(1).max(updateKnowledgeSharePointConnectionBodyDriveIdMax).optional(),
  "driveName": zod.string().min(1).max(updateKnowledgeSharePointConnectionBodyDriveNameMax).optional(),
  "folderItemId": zod.string().max(updateKnowledgeSharePointConnectionBodyFolderItemIdMax).nullish(),
  "folderPath": zod.string().max(updateKnowledgeSharePointConnectionBodyFolderPathMax).optional(),
  "scheduleMinutes": zod.int().min(updateKnowledgeSharePointConnectionBodyScheduleMinutesMin).max(updateKnowledgeSharePointConnectionBodyScheduleMinutesMax).optional(),
  "enabled": zod.boolean().optional()
})

export const updateKnowledgeSharePointConnectionResponseScheduleMinutesMin = 5;
export const updateKnowledgeSharePointConnectionResponseScheduleMinutesMax = 10080;



export const updateKnowledgeSharePointConnectionResponse = zod.object({
  "id": zod.uuid(),
  "accountDisplayName": zod.string(),
  "mode": zod.enum(['mirror', 'manual_retained']).optional(),
  "lastSuccessfulRefreshAt": zod.iso.datetime({"offset":true}).nullish(),
  "disconnectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "authStatus": zod.enum(['connected', 'reauth_required']),
  "sourceConfigured": zod.boolean(),
  "siteId": zod.string(),
  "siteName": zod.string(),
  "siteUrl": zod.string(),
  "driveId": zod.string(),
  "driveName": zod.string(),
  "folderItemId": zod.string().nullish(),
  "folderPath": zod.string(),
  "scheduleMinutes": zod.int().min(updateKnowledgeSharePointConnectionResponseScheduleMinutesMin).max(updateKnowledgeSharePointConnectionResponseScheduleMinutesMax),
  "enabled": zod.boolean(),
  "lastSyncStartedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastSyncFinishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastSyncStatus": zod.enum(['idle', 'running', 'succeeded', 'partial', 'failed']),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Remove a SharePoint knowledge connection without changing SharePoint
 */
export const deleteKnowledgeSharePointConnectionParams = zod.object({
  "id": zod.uuid()
})

export const deleteKnowledgeSharePointConnectionResponse = zod.void()


/**
 * @summary Search SharePoint sites visible to the connected administrator
 */
export const listKnowledgeSharePointSitesParams = zod.object({
  "id": zod.uuid()
})

export const listKnowledgeSharePointSitesQuerySearchMin = 2;
export const listKnowledgeSharePointSitesQuerySearchMax = 100;

export const listKnowledgeSharePointSitesQueryLimitDefault = 25;
export const listKnowledgeSharePointSitesQueryLimitMax = 50;

export const listKnowledgeSharePointSitesQueryCursorMax = 4096;



export const listKnowledgeSharePointSitesQueryParams = zod.object({
  "search": zod.string().min(listKnowledgeSharePointSitesQuerySearchMin).max(listKnowledgeSharePointSitesQuerySearchMax),
  "limit": zod.int().min(1).max(listKnowledgeSharePointSitesQueryLimitMax).default(listKnowledgeSharePointSitesQueryLimitDefault),
  "cursor": zod.string().max(listKnowledgeSharePointSitesQueryCursorMax).optional()
})

export const listKnowledgeSharePointSitesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "displayName": zod.string(),
  "webUrl": zod.url()
})),
  "nextCursor": zod.string().nullable()
})


/**
 * @summary Run an immediate delta sync for one SharePoint knowledge connection
 */
export const syncKnowledgeSharePointConnectionParams = zod.object({
  "id": zod.uuid()
})

export const syncKnowledgeSharePointConnectionResponseCreatedCountMin = 0;

export const syncKnowledgeSharePointConnectionResponseUpdatedCountMin = 0;

export const syncKnowledgeSharePointConnectionResponseRetiredCountMin = 0;

export const syncKnowledgeSharePointConnectionResponseRetainedCountMin = 0;

export const syncKnowledgeSharePointConnectionResponseUnchangedCountMin = 0;

export const syncKnowledgeSharePointConnectionResponseSkippedCountMin = 0;

export const syncKnowledgeSharePointConnectionResponseFailedCountMin = 0;



export const syncKnowledgeSharePointConnectionResponse = zod.object({
  "id": zod.uuid(),
  "connectionId": zod.uuid(),
  "startedAt": zod.iso.datetime({"offset":true}),
  "finishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "status": zod.enum(['running', 'succeeded', 'partial', 'failed']),
  "createdCount": zod.int().min(syncKnowledgeSharePointConnectionResponseCreatedCountMin),
  "updatedCount": zod.int().min(syncKnowledgeSharePointConnectionResponseUpdatedCountMin),
  "retiredCount": zod.int().min(syncKnowledgeSharePointConnectionResponseRetiredCountMin),
  "retainedCount": zod.int().min(syncKnowledgeSharePointConnectionResponseRetainedCountMin).optional(),
  "unchangedCount": zod.int().min(syncKnowledgeSharePointConnectionResponseUnchangedCountMin).optional(),
  "skippedCount": zod.int().min(syncKnowledgeSharePointConnectionResponseSkippedCountMin),
  "failedCount": zod.int().min(syncKnowledgeSharePointConnectionResponseFailedCountMin),
  "error": zod.string().nullable(),
  "trigger": zod.enum(['schedule', 'manual'])
})


/**
 * @summary List bounded SharePoint sync history for one connection
 */
export const listKnowledgeSharePointSyncRunsParams = zod.object({
  "id": zod.uuid()
})

export const listKnowledgeSharePointSyncRunsQueryPageDefault = 1;

export const listKnowledgeSharePointSyncRunsQueryLimitDefault = 25;
export const listKnowledgeSharePointSyncRunsQueryLimitMax = 100;



export const listKnowledgeSharePointSyncRunsQueryParams = zod.object({
  "page": zod.int().min(1).default(listKnowledgeSharePointSyncRunsQueryPageDefault),
  "limit": zod.int().min(1).max(listKnowledgeSharePointSyncRunsQueryLimitMax).default(listKnowledgeSharePointSyncRunsQueryLimitDefault)
})

export const listKnowledgeSharePointSyncRunsResponseItemsItemCreatedCountMin = 0;

export const listKnowledgeSharePointSyncRunsResponseItemsItemUpdatedCountMin = 0;

export const listKnowledgeSharePointSyncRunsResponseItemsItemRetiredCountMin = 0;

export const listKnowledgeSharePointSyncRunsResponseItemsItemRetainedCountMin = 0;

export const listKnowledgeSharePointSyncRunsResponseItemsItemUnchangedCountMin = 0;

export const listKnowledgeSharePointSyncRunsResponseItemsItemSkippedCountMin = 0;

export const listKnowledgeSharePointSyncRunsResponseItemsItemFailedCountMin = 0;

export const listKnowledgeSharePointSyncRunsResponseTotalMin = 0;


export const listKnowledgeSharePointSyncRunsResponseLimitMax = 100;



export const listKnowledgeSharePointSyncRunsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "connectionId": zod.uuid(),
  "startedAt": zod.iso.datetime({"offset":true}),
  "finishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "status": zod.enum(['running', 'succeeded', 'partial', 'failed']),
  "createdCount": zod.int().min(listKnowledgeSharePointSyncRunsResponseItemsItemCreatedCountMin),
  "updatedCount": zod.int().min(listKnowledgeSharePointSyncRunsResponseItemsItemUpdatedCountMin),
  "retiredCount": zod.int().min(listKnowledgeSharePointSyncRunsResponseItemsItemRetiredCountMin),
  "retainedCount": zod.int().min(listKnowledgeSharePointSyncRunsResponseItemsItemRetainedCountMin).optional(),
  "unchangedCount": zod.int().min(listKnowledgeSharePointSyncRunsResponseItemsItemUnchangedCountMin).optional(),
  "skippedCount": zod.int().min(listKnowledgeSharePointSyncRunsResponseItemsItemSkippedCountMin),
  "failedCount": zod.int().min(listKnowledgeSharePointSyncRunsResponseItemsItemFailedCountMin),
  "error": zod.string().nullable(),
  "trigger": zod.enum(['schedule', 'manual'])
})),
  "total": zod.int().min(listKnowledgeSharePointSyncRunsResponseTotalMin),
  "page": zod.int().min(1),
  "limit": zod.int().min(1).max(listKnowledgeSharePointSyncRunsResponseLimitMax)
})


/**
 * @summary List document libraries for a selected SharePoint site
 */
export const listKnowledgeSharePointDrivesPathSiteIdMax = 512;



export const listKnowledgeSharePointDrivesParams = zod.object({
  "id": zod.uuid(),
  "siteId": zod.string().min(1).max(listKnowledgeSharePointDrivesPathSiteIdMax)
})

export const listKnowledgeSharePointDrivesQueryLimitDefault = 25;
export const listKnowledgeSharePointDrivesQueryLimitMax = 50;

export const listKnowledgeSharePointDrivesQueryCursorMax = 4096;



export const listKnowledgeSharePointDrivesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listKnowledgeSharePointDrivesQueryLimitMax).default(listKnowledgeSharePointDrivesQueryLimitDefault),
  "cursor": zod.string().max(listKnowledgeSharePointDrivesQueryCursorMax).optional()
})

export const listKnowledgeSharePointDrivesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "driveType": zod.string()
})),
  "nextCursor": zod.string().nullable()
})


/**
 * @summary List folders below a drive root or selected folder
 */
export const listKnowledgeSharePointFoldersPathDriveIdMax = 512;

export const listKnowledgeSharePointFoldersPathItemIdMax = 512;



export const listKnowledgeSharePointFoldersParams = zod.object({
  "id": zod.uuid(),
  "driveId": zod.string().min(1).max(listKnowledgeSharePointFoldersPathDriveIdMax),
  "itemId": zod.string().min(1).max(listKnowledgeSharePointFoldersPathItemIdMax)
})

export const listKnowledgeSharePointFoldersQueryLimitDefault = 25;
export const listKnowledgeSharePointFoldersQueryLimitMax = 50;

export const listKnowledgeSharePointFoldersQueryCursorMax = 4096;



export const listKnowledgeSharePointFoldersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listKnowledgeSharePointFoldersQueryLimitMax).default(listKnowledgeSharePointFoldersQueryLimitDefault),
  "cursor": zod.string().max(listKnowledgeSharePointFoldersQueryCursorMax).optional()
})

export const listKnowledgeSharePointFoldersResponseItemsItemChildCountMin = 0;



export const listKnowledgeSharePointFoldersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "webUrl": zod.url(),
  "childCount": zod.int().min(listKnowledgeSharePointFoldersResponseItemsItemChildCountMin)
})),
  "nextCursor": zod.string().nullable()
})


/**
 * @summary Record a retry-safe batch of privacy-minimised workflow map events
 */
export const recordWorkflowMapMetricsBodyEventsItemNodeKindMax = 40;

export const recordWorkflowMapMetricsBodyEventsItemControlMax = 80;

export const recordWorkflowMapMetricsBodyEventsItemReasonMax = 80;

export const recordWorkflowMapMetricsBodyEventsItemDurationMsMin = 0;
export const recordWorkflowMapMetricsBodyEventsItemDurationMsMax = 600000;

export const recordWorkflowMapMetricsBodyEventsItemChannelMax = 40;

export const recordWorkflowMapMetricsBodyEventsItemWindowDefault = `90d`;
export const recordWorkflowMapMetricsBodyEventsMax = 50;



export const recordWorkflowMapMetricsBody = zod.object({
  "events": zod.array(zod.object({
  "eventId": zod.uuid(),
  "name": zod.enum(['map_open', 'view_change', 'node_select', 'camera_control', 'layer_change', 'fullscreen_change', 'fallback', 'signal_drilldown', 'signal_window_change', 'signal_channel_filter', 'building_enter', 'building_exit', 'timeline_scrub', 'timeline_play', 'timeline_range', 'timeline_mode', 'workforce_view', 'control_room_open', 'agent_setting_change', 'coaching_submit', 'steer_submit', 'review_action', 'floorplan_view', 'floorplan_select']),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "view": zod.enum(['3d', 'arena', 'floor', 'list']).optional(),
  "nodeKind": zod.string().max(recordWorkflowMapMetricsBodyEventsItemNodeKindMax).optional(),
  "control": zod.string().max(recordWorkflowMapMetricsBodyEventsItemControlMax).optional(),
  "reason": zod.string().max(recordWorkflowMapMetricsBodyEventsItemReasonMax).optional(),
  "durationMs": zod.int().min(recordWorkflowMapMetricsBodyEventsItemDurationMsMin).max(recordWorkflowMapMetricsBodyEventsItemDurationMsMax).optional(),
  "channel": zod.string().max(recordWorkflowMapMetricsBodyEventsItemChannelMax).optional(),
  "countBucket": zod.enum(['1', '2-5', '6-20', '20+']).optional(),
  "setting": zod.enum(['level', 'instruction', 'suggestion']).optional(),
  "level": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']).optional(),
  "mode": zod.enum(['signals', 'work']).optional(),
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(recordWorkflowMapMetricsBodyEventsItemWindowDefault)
})).min(1).max(recordWorkflowMapMetricsBodyEventsMax)
})

export const recordWorkflowMapMetricsResponseAcceptedMin = 0;

export const recordWorkflowMapMetricsResponseDuplicatesMin = 0;



export const recordWorkflowMapMetricsResponse = zod.object({
  "accepted": zod.int().min(recordWorkflowMapMetricsResponseAcceptedMin),
  "duplicates": zod.int().min(recordWorkflowMapMetricsResponseDuplicatesMin)
})


/**
 * @summary Review aggregate journey, authorization, AI, knowledge, and workflow-map health without sensitive content
 */
export const getCrmProgrammeOperationsQueryRangeDaysDefault = 30;
export const getCrmProgrammeOperationsQueryRangeDaysMax = 365;



export const getCrmProgrammeOperationsQueryParams = zod.object({
  "rangeDays": zod.int().min(1).max(getCrmProgrammeOperationsQueryRangeDaysMax).default(getCrmProgrammeOperationsQueryRangeDaysDefault)
})

export const getCrmProgrammeOperationsResponseRangeDaysMax = 365;

export const getCrmProgrammeOperationsResponseJourneysActiveRecordsMin = 0;

export const getCrmProgrammeOperationsResponseJourneysCompletedRecordsMin = 0;

export const getCrmProgrammeOperationsResponseJourneysOverdueRecordsMin = 0;

export const getCrmProgrammeOperationsResponseJourneysTransitionsMin = 0;

export const getCrmProgrammeOperationsResponseJourneysTerminalOutcomesMin = 0;

export const getCrmProgrammeOperationsResponseJourneysPositiveOutcomeRateMin = 0;
export const getCrmProgrammeOperationsResponseJourneysPositiveOutcomeRateMax = 1;

export const getCrmProgrammeOperationsResponseJourneysByJourneyItemActiveRecordsMin = 0;

export const getCrmProgrammeOperationsResponseJourneysByJourneyItemCompletedRecordsMin = 0;

export const getCrmProgrammeOperationsResponseJourneysByJourneyItemOverdueRecordsMin = 0;

export const getCrmProgrammeOperationsResponseJourneysByJourneyItemTransitionsMin = 0;

export const getCrmProgrammeOperationsResponseJourneysByJourneyItemUniqueRecordsMin = 0;

export const getCrmProgrammeOperationsResponseJourneysByJourneyItemTerminalOutcomesMin = 0;

export const getCrmProgrammeOperationsResponseJourneysByJourneyItemPositiveOutcomesMin = 0;

export const getCrmProgrammeOperationsResponseJourneysByJourneyItemAverageObservedStageHoursMin = 0;

export const getCrmProgrammeOperationsResponseJourneysOutcomesItemCountMin = 0;

export const getCrmProgrammeOperationsResponseAuthorizationTotalEventsMin = 0;

export const getCrmProgrammeOperationsResponseAuthorizationExpectedDenialsMin = 0;

export const getCrmProgrammeOperationsResponseAuthorizationFaultsMin = 0;

export const getCrmProgrammeOperationsResponseAuthorizationByCodeItemCountMin = 0;

export const getCrmProgrammeOperationsResponseAiTotalActionsMin = 0;

export const getCrmProgrammeOperationsResponseAiRecommendationAcceptanceRateMin = 0;
export const getCrmProgrammeOperationsResponseAiRecommendationAcceptanceRateMax = 1;

export const getCrmProgrammeOperationsResponseAiExecutionSuccessRateMin = 0;
export const getCrmProgrammeOperationsResponseAiExecutionSuccessRateMax = 1;

export const getCrmProgrammeOperationsResponseAiAuthorityBlocksMin = 0;

export const getCrmProgrammeOperationsResponseAiApprovalOverridesMin = 0;

export const getCrmProgrammeOperationsResponseAiByStatusItemCountMin = 0;

export const getCrmProgrammeOperationsResponseAiByAuthorityItemCountMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeTotalFilesMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeReadyFilesMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeFailedFilesMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeProcessingFilesMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeStaleFilesMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeDocumentCountMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeChunkCountMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeEmbeddedChunkCountMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeEmbeddingCoverageMin = 0;
export const getCrmProgrammeOperationsResponseKnowledgeEmbeddingCoverageMax = 1;


export const getCrmProgrammeOperationsResponseKnowledgeSharePointTotalConnectionsMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeSharePointEnabledConnectionsMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeSharePointReauthRequiredConnectionsMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeSharePointFailingConnectionsMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeRetrievalRequestsMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeRetrievalReturnedSourcesMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeRetrievalDeniedMatchesMin = 0;

export const getCrmProgrammeOperationsResponseKnowledgeRetrievalLowConfidenceQueriesMin = 0;

export const getCrmProgrammeOperationsResponseVisualizationTotalEventsMin = 0;

export const getCrmProgrammeOperationsResponseVisualizationMapOpensMin = 0;

export const getCrmProgrammeOperationsResponseVisualizationFallbacksMin = 0;

export const getCrmProgrammeOperationsResponseVisualizationFallbackRateMin = 0;
export const getCrmProgrammeOperationsResponseVisualizationFallbackRateMax = 1;

export const getCrmProgrammeOperationsResponseVisualizationAverageControlDurationMsMin = 0;

export const getCrmProgrammeOperationsResponseVisualizationByViewItemCountMin = 0;

export const getCrmProgrammeOperationsResponseVisualizationByInteractionTypeItemCountMin = 0;

export const getCrmProgrammeOperationsResponseVisualizationByFallbackReasonItemCountMin = 0;



export const getCrmProgrammeOperationsResponse = zod.object({
  "generatedAt": zod.iso.datetime({"offset":true}),
  "windowStartedAt": zod.iso.datetime({"offset":true}),
  "rangeDays": zod.int().min(1).max(getCrmProgrammeOperationsResponseRangeDaysMax),
  "journeys": zod.object({
  "activeRecords": zod.int().min(getCrmProgrammeOperationsResponseJourneysActiveRecordsMin),
  "completedRecords": zod.int().min(getCrmProgrammeOperationsResponseJourneysCompletedRecordsMin),
  "overdueRecords": zod.int().min(getCrmProgrammeOperationsResponseJourneysOverdueRecordsMin),
  "transitions": zod.int().min(getCrmProgrammeOperationsResponseJourneysTransitionsMin),
  "terminalOutcomes": zod.int().min(getCrmProgrammeOperationsResponseJourneysTerminalOutcomesMin),
  "positiveOutcomeRate": zod.number().min(getCrmProgrammeOperationsResponseJourneysPositiveOutcomeRateMin).max(getCrmProgrammeOperationsResponseJourneysPositiveOutcomeRateMax).nullable(),
  "byJourney": zod.array(zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "label": zod.string(),
  "activeRecords": zod.int().min(getCrmProgrammeOperationsResponseJourneysByJourneyItemActiveRecordsMin),
  "completedRecords": zod.int().min(getCrmProgrammeOperationsResponseJourneysByJourneyItemCompletedRecordsMin),
  "overdueRecords": zod.int().min(getCrmProgrammeOperationsResponseJourneysByJourneyItemOverdueRecordsMin),
  "transitions": zod.int().min(getCrmProgrammeOperationsResponseJourneysByJourneyItemTransitionsMin),
  "uniqueRecords": zod.int().min(getCrmProgrammeOperationsResponseJourneysByJourneyItemUniqueRecordsMin),
  "terminalOutcomes": zod.int().min(getCrmProgrammeOperationsResponseJourneysByJourneyItemTerminalOutcomesMin),
  "positiveOutcomes": zod.int().min(getCrmProgrammeOperationsResponseJourneysByJourneyItemPositiveOutcomesMin),
  "averageObservedStageHours": zod.number().min(getCrmProgrammeOperationsResponseJourneysByJourneyItemAverageObservedStageHoursMin).nullable()
})),
  "outcomes": zod.array(zod.object({
  "key": zod.string(),
  "count": zod.int().min(getCrmProgrammeOperationsResponseJourneysOutcomesItemCountMin)
}))
}),
  "authorization": zod.object({
  "startedAt": zod.iso.datetime({"offset":true}),
  "totalEvents": zod.int().min(getCrmProgrammeOperationsResponseAuthorizationTotalEventsMin),
  "expectedDenials": zod.int().min(getCrmProgrammeOperationsResponseAuthorizationExpectedDenialsMin),
  "faults": zod.int().min(getCrmProgrammeOperationsResponseAuthorizationFaultsMin),
  "byCode": zod.array(zod.object({
  "key": zod.string(),
  "count": zod.int().min(getCrmProgrammeOperationsResponseAuthorizationByCodeItemCountMin)
})),
  "contentCaptured": zod.literal(false),
  "identityCaptured": zod.literal(false)
}),
  "ai": zod.object({
  "totalActions": zod.int().min(getCrmProgrammeOperationsResponseAiTotalActionsMin),
  "recommendationAcceptanceRate": zod.number().min(getCrmProgrammeOperationsResponseAiRecommendationAcceptanceRateMin).max(getCrmProgrammeOperationsResponseAiRecommendationAcceptanceRateMax).nullable(),
  "executionSuccessRate": zod.number().min(getCrmProgrammeOperationsResponseAiExecutionSuccessRateMin).max(getCrmProgrammeOperationsResponseAiExecutionSuccessRateMax).nullable(),
  "authorityBlocks": zod.int().min(getCrmProgrammeOperationsResponseAiAuthorityBlocksMin),
  "approvalOverrides": zod.int().min(getCrmProgrammeOperationsResponseAiApprovalOverridesMin),
  "byStatus": zod.array(zod.object({
  "key": zod.string(),
  "count": zod.int().min(getCrmProgrammeOperationsResponseAiByStatusItemCountMin)
})),
  "byAuthority": zod.array(zod.object({
  "key": zod.string(),
  "count": zod.int().min(getCrmProgrammeOperationsResponseAiByAuthorityItemCountMin)
}))
}),
  "knowledge": zod.object({
  "state": zod.enum(['empty', 'not_ready', 'ready']),
  "totalFiles": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeTotalFilesMin),
  "readyFiles": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeReadyFilesMin),
  "failedFiles": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeFailedFilesMin),
  "processingFiles": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeProcessingFilesMin),
  "staleFiles": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeStaleFilesMin),
  "documentCount": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeDocumentCountMin),
  "chunkCount": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeChunkCountMin),
  "embeddedChunkCount": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeEmbeddedChunkCountMin),
  "embeddingCoverage": zod.number().min(getCrmProgrammeOperationsResponseKnowledgeEmbeddingCoverageMin).max(getCrmProgrammeOperationsResponseKnowledgeEmbeddingCoverageMax),
  "supportedTypes": zod.array(zod.string()),
  "staleAfterDays": zod.int().min(1),
  "failures": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "errorMessage": zod.string(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "sharePoint": zod.object({
  "totalConnections": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeSharePointTotalConnectionsMin),
  "enabledConnections": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeSharePointEnabledConnectionsMin),
  "reauthRequiredConnections": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeSharePointReauthRequiredConnectionsMin),
  "failingConnections": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeSharePointFailingConnectionsMin),
  "lastSyncFailures": zod.array(zod.object({
  "connectionId": zod.uuid(),
  "sourceName": zod.string(),
  "status": zod.enum(['reauth_required', 'partial', 'failed']),
  "error": zod.string(),
  "finishedAt": zod.iso.datetime({"offset":true}).nullable()
}))
}),
  "retrieval": zod.object({
  "requests": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeRetrievalRequestsMin),
  "returnedSources": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeRetrievalReturnedSourcesMin),
  "deniedMatches": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeRetrievalDeniedMatchesMin),
  "lowConfidenceQueries": zod.int().min(getCrmProgrammeOperationsResponseKnowledgeRetrievalLowConfidenceQueriesMin),
  "lastState": zod.enum(['ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence']),
  "lastRetrievedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "checkedAt": zod.iso.datetime({"offset":true})
}),
  "visualization": zod.object({
  "totalEvents": zod.int().min(getCrmProgrammeOperationsResponseVisualizationTotalEventsMin),
  "mapOpens": zod.int().min(getCrmProgrammeOperationsResponseVisualizationMapOpensMin),
  "fallbacks": zod.int().min(getCrmProgrammeOperationsResponseVisualizationFallbacksMin),
  "fallbackRate": zod.number().min(getCrmProgrammeOperationsResponseVisualizationFallbackRateMin).max(getCrmProgrammeOperationsResponseVisualizationFallbackRateMax).nullable(),
  "averageControlDurationMs": zod.number().min(getCrmProgrammeOperationsResponseVisualizationAverageControlDurationMsMin).nullable(),
  "byView": zod.array(zod.object({
  "key": zod.string(),
  "count": zod.int().min(getCrmProgrammeOperationsResponseVisualizationByViewItemCountMin)
})),
  "byInteractionType": zod.array(zod.object({
  "key": zod.string(),
  "count": zod.int().min(getCrmProgrammeOperationsResponseVisualizationByInteractionTypeItemCountMin)
})),
  "byFallbackReason": zod.array(zod.object({
  "key": zod.string(),
  "count": zod.int().min(getCrmProgrammeOperationsResponseVisualizationByFallbackReasonItemCountMin)
}))
}),
  "privacy": zod.object({
  "contentCaptured": zod.literal(false),
  "identityCaptured": zod.literal(false),
  "detail": zod.string()
})
})


/**
 * @summary List archived legacy records
 */
export const listLegacySourceRecordsQueryPageDefault = 1;

export const listLegacySourceRecordsQueryLimitDefault = 50;
export const listLegacySourceRecordsQueryLimitMax = 100;



export const listLegacySourceRecordsQueryParams = zod.object({
  "domain": zod.string().optional(),
  "sourceTable": zod.string().optional(),
  "search": zod.string().optional(),
  "page": zod.int().min(1).default(listLegacySourceRecordsQueryPageDefault),
  "limit": zod.int().min(1).max(listLegacySourceRecordsQueryLimitMax).default(listLegacySourceRecordsQueryLimitDefault)
})

export const listLegacySourceRecordsResponseTotalMin = 0;





export const listLegacySourceRecordsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "domain": zod.string(),
  "sourceTable": zod.string(),
  "legacyId": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "targetTable": zod.string().nullish(),
  "targetId": zod.uuid().nullish(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "sourceCreatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "sourceUpdatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "importedAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listLegacySourceRecordsResponseTotalMin),
  "page": zod.int().min(1),
  "limit": zod.int().min(1)
})


/**
 * @summary Count archived legacy records by domain and source table
 */
export const getLegacySourceRecordStatsResponseTotalMin = 0;

export const getLegacySourceRecordStatsResponseGroupsItemCountMin = 0;



export const getLegacySourceRecordStatsResponse = zod.object({
  "total": zod.int().min(getLegacySourceRecordStatsResponseTotalMin),
  "groups": zod.array(zod.object({
  "domain": zod.string(),
  "sourceTable": zod.string(),
  "count": zod.int().min(getLegacySourceRecordStatsResponseGroupsItemCountMin)
}))
})


/**
 * @summary Get one archived legacy record and its complete source payload
 */
export const getLegacySourceRecordParams = zod.object({
  "id": zod.uuid()
})

export const getLegacySourceRecordResponse = zod.object({
  "id": zod.uuid(),
  "domain": zod.string(),
  "sourceTable": zod.string(),
  "legacyId": zod.string(),
  "title": zod.string(),
  "summary": zod.string().nullish(),
  "targetTable": zod.string().nullish(),
  "targetId": zod.uuid().nullish(),
  "payload": zod.record(zod.string(), zod.unknown()),
  "sourceCreatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "sourceUpdatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "importedAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get unified Content Hub metrics and recent activity
 */
export const getContentHubOverviewResponseRecentPostsItemOneTitleMax = 200;

export const getContentHubOverviewResponseRecentPostsItemOneContentMax = 10000;


export const getContentHubOverviewResponseRecentPostsItemOneMediaAssetIdsMax = 10;


export const getContentHubOverviewResponseRecentPostsItemTwoRevisionCountMin = 0;

export const getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const getContentHubOverviewResponseRecentPostsItemTwoPublishResultsItemAttemptCountMin = 0;

export const getContentHubOverviewResponseUpcomingBookingsItemOneNameMax = 200;

export const getContentHubOverviewResponseUpcomingBookingsItemOnePhoneMax = 100;

export const getContentHubOverviewResponseUpcomingBookingsItemOneServiceMax = 300;

export const getContentHubOverviewResponseUpcomingBookingsItemOneNotesMax = 5000;

export const getContentHubOverviewResponseUpcomingBookingsItemOneConsentToContactDefault = false;

export const getContentHubOverviewResponse = zod.object({
  "metrics": zod.array(zod.object({
  "key": zod.string(),
  "label": zod.string(),
  "value": zod.number(),
  "detail": zod.string()
})),
  "recentPosts": zod.array(zod.object({
  "title": zod.string().min(1).max(getContentHubOverviewResponseRecentPostsItemOneTitleMax),
  "content": zod.string().min(1).max(getContentHubOverviewResponseRecentPostsItemOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(getContentHubOverviewResponseRecentPostsItemOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(getContentHubOverviewResponseRecentPostsItemTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(getContentHubOverviewResponseRecentPostsItemTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(getContentHubOverviewResponseRecentPostsItemTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "upcomingBookings": zod.array(zod.object({
  "name": zod.string().min(1).max(getContentHubOverviewResponseUpcomingBookingsItemOneNameMax),
  "email": zod.email(),
  "phone": zod.string().max(getContentHubOverviewResponseUpcomingBookingsItemOnePhoneMax).nullish(),
  "service": zod.string().min(1).max(getContentHubOverviewResponseUpcomingBookingsItemOneServiceMax),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().max(getContentHubOverviewResponseUpcomingBookingsItemOneNotesMax).nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "slotId": zod.uuid().nullish(),
  "consentToContact": zod.boolean().default(getContentHubOverviewResponseUpcomingBookingsItemOneConsentToContactDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['pending', 'confirmed', 'completed', 'cancelled']),
  "source": zod.enum(['manual', 'public_microsite']),
  "micrositeBindingId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "generatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get scoped media storage, processing, scanning and generation readiness
 */



export const getContentHubMediaReadinessResponse = zod.object({
  "accepts": zod.array(zod.enum(['image/png', 'image/jpeg', 'image/webp', 'video/mp4', 'video/quicktime', 'video/webm'])),
  "maxUploadBytes": zod.int().min(1),
  "capabilities": zod.array(zod.object({
  "key": zod.string(),
  "label": zod.string(),
  "state": zod.enum(['ready', 'unavailable', 'unsupported']),
  "detail": zod.string()
}))
})


/**
 * @summary List available OpenRouter video models and connection readiness
 */
export const listContentHubVideoModelsResponseModelsItemPriceUsdPerSecondMin = 0;

export const listContentHubVideoModelsResponseModelsMin = 3;
export const listContentHubVideoModelsResponseModelsMax = 3;



export const listContentHubVideoModelsResponse = zod.object({
  "connection": zod.object({
  "enabled": zod.boolean(),
  "status": zod.enum(['ready', 'disabled']),
  "reason": zod.string().optional(),
  "provider": zod.enum(['openrouter']),
  "stitchAvailable": zod.boolean()
}),
  "models": zod.array(zod.object({
  "id": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),
  "label": zod.string(),
  "tier": zod.enum(['draft', 'polish', 'economy']),
  "supportedAspectRatios": zod.array(zod.enum(['16:9', '9:16'])),
  "supportedDurationsSeconds": zod.array(zod.union([zod.literal(4),zod.literal(6),zod.literal(8)])),
  "supportedResolutions": zod.array(zod.enum(['720p', '1080p'])),
  "resolutionConstraints": zod.object({
  "1080p": zod.object({
  "aspectRatios": zod.array(zod.enum(['16:9', '9:16'])),
  "durationsSeconds": zod.array(zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]))
})
}),
  "priceUsdPerSecond": zod.number().min(listContentHubVideoModelsResponseModelsItemPriceUsdPerSecondMin),
  "supportsFirstFrame": zod.boolean(),
  "supportsReferenceImages": zod.boolean()
})).min(listContentHubVideoModelsResponseModelsMin).max(listContentHubVideoModelsResponseModelsMax)
})


/**
 * @summary List entity-scoped video projects
 */
export const listVideoProjectsQueryLimitDefault = 24;
export const listVideoProjectsQueryLimitMax = 100;

export const listVideoProjectsQueryOffsetDefault = 0;
export const listVideoProjectsQueryOffsetMin = 0;



export const listVideoProjectsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listVideoProjectsQueryLimitMax).default(listVideoProjectsQueryLimitDefault),
  "offset": zod.int().min(listVideoProjectsQueryOffsetMin).default(listVideoProjectsQueryOffsetDefault),
  "status": zod.enum(['draft', 'rendering', 'ready', 'failed']).optional()
})

export const listVideoProjectsResponseItemsItemDistributionOneDownloadEnabledDefault = true;
export const listVideoProjectsResponseItemsItemDistributionOneAutoPostToSocialDefault = false;
export const listVideoProjectsResponseItemsItemDistributionOneSocialNetworksItemMax = 100;

export const listVideoProjectsResponseItemsItemDistributionOneSocialNetworksMax = 20;

export const listVideoProjectsResponseItemsItemScenesItemPositionMax = 8;

export const listVideoProjectsResponseItemsItemScenesMax = 8;

export const listVideoProjectsResponseTotalMin = 0;


export const listVideoProjectsResponseOffsetMin = 0;



export const listVideoProjectsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "brief": zod.string(),
  "mode": zod.enum(['single_clip', 'storyboard']),
  "aspectRatio": zod.enum(['16:9', '9:16']),
  "resolution": zod.enum(['720p', '1080p']),
  "defaultModel": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),
  "continuityMode": zod.enum(['last_frame', 'none']),
  "status": zod.enum(['draft', 'rendering', 'ready', 'failed']),
  "finalMediaAssetId": zod.uuid().nullish(),
  "distribution": zod.object({
  "downloadEnabled": zod.literal(true).default(listVideoProjectsResponseItemsItemDistributionOneDownloadEnabledDefault),
  "autoPostToSocial": zod.boolean().default(listVideoProjectsResponseItemsItemDistributionOneAutoPostToSocialDefault),
  "socialNetworks": zod.array(zod.string().min(1).max(listVideoProjectsResponseItemsItemDistributionOneSocialNetworksItemMax)).max(listVideoProjectsResponseItemsItemDistributionOneSocialNetworksMax)
}).and(zod.object({
  "campaignId": zod.uuid().nullable(),
  "campaignStepId": zod.uuid().nullable(),
  "socialPostId": zod.uuid().nullable(),
  "status": zod.enum(['disabled', 'waiting_for_networks', 'waiting_for_video', 'queued', 'partial', 'stale', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
}))
})),
  "createdBy": zod.string(),
  "scenes": zod.array(zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "position": zod.int().min(1).max(listVideoProjectsResponseItemsItemScenesItemPositionMax),
  "title": zod.string(),
  "prompt": zod.string(),
  "negativePrompt": zod.string().nullish(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]),
  "status": zod.enum(['draft', 'rendering', 'ready', 'stale', 'failed']),
  "currentJobId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "lastFrameStorageKey": zod.string().nullish(),
  "firstFrameSource": zod.enum(['previous_scene', 'none']),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).min(1).max(listVideoProjectsResponseItemsItemScenesMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listVideoProjectsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listVideoProjectsResponseOffsetMin)
})


/**
 * @summary Create a video project and its initial scene
 */
export const createVideoProjectBodyTitleMax = 200;

export const createVideoProjectBodyBriefDefault = ``;
export const createVideoProjectBodyBriefMax = 10000;

export const createVideoProjectBodyDistributionDownloadEnabledDefault = true;
export const createVideoProjectBodyDistributionAutoPostToSocialDefault = false;
export const createVideoProjectBodyDistributionSocialNetworksItemMax = 100;

export const createVideoProjectBodyDistributionSocialNetworksMax = 20;

export const createVideoProjectBodyInitialSceneTitleMax = 200;

export const createVideoProjectBodyInitialPromptDefault = ``;
export const createVideoProjectBodyInitialPromptMax = 20000;



export const createVideoProjectBody = zod.object({
  "title": zod.string().min(1).max(createVideoProjectBodyTitleMax),
  "brief": zod.string().max(createVideoProjectBodyBriefMax).default(createVideoProjectBodyBriefDefault),
  "mode": zod.enum(['single_clip', 'storyboard']),
  "aspectRatio": zod.enum(['16:9', '9:16']),
  "resolution": zod.enum(['720p', '1080p']),
  "defaultModel": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),
  "continuityMode": zod.enum(['last_frame', 'none']).optional(),
  "distribution": zod.object({
  "downloadEnabled": zod.literal(true).default(createVideoProjectBodyDistributionDownloadEnabledDefault),
  "autoPostToSocial": zod.boolean().default(createVideoProjectBodyDistributionAutoPostToSocialDefault),
  "socialNetworks": zod.array(zod.string().min(1).max(createVideoProjectBodyDistributionSocialNetworksItemMax)).max(createVideoProjectBodyDistributionSocialNetworksMax)
}).optional(),
  "initialDurationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]),
  "initialSceneTitle": zod.string().min(1).max(createVideoProjectBodyInitialSceneTitleMax).optional(),
  "initialPrompt": zod.string().max(createVideoProjectBodyInitialPromptMax).default(createVideoProjectBodyInitialPromptDefault)
})

export const createVideoProjectResponseDistributionOneDownloadEnabledDefault = true;
export const createVideoProjectResponseDistributionOneAutoPostToSocialDefault = false;
export const createVideoProjectResponseDistributionOneSocialNetworksItemMax = 100;

export const createVideoProjectResponseDistributionOneSocialNetworksMax = 20;

export const createVideoProjectResponseScenesItemPositionMax = 8;

export const createVideoProjectResponseScenesMax = 8;



export const createVideoProjectResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "brief": zod.string(),
  "mode": zod.enum(['single_clip', 'storyboard']),
  "aspectRatio": zod.enum(['16:9', '9:16']),
  "resolution": zod.enum(['720p', '1080p']),
  "defaultModel": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),
  "continuityMode": zod.enum(['last_frame', 'none']),
  "status": zod.enum(['draft', 'rendering', 'ready', 'failed']),
  "finalMediaAssetId": zod.uuid().nullish(),
  "distribution": zod.object({
  "downloadEnabled": zod.literal(true).default(createVideoProjectResponseDistributionOneDownloadEnabledDefault),
  "autoPostToSocial": zod.boolean().default(createVideoProjectResponseDistributionOneAutoPostToSocialDefault),
  "socialNetworks": zod.array(zod.string().min(1).max(createVideoProjectResponseDistributionOneSocialNetworksItemMax)).max(createVideoProjectResponseDistributionOneSocialNetworksMax)
}).and(zod.object({
  "campaignId": zod.uuid().nullable(),
  "campaignStepId": zod.uuid().nullable(),
  "socialPostId": zod.uuid().nullable(),
  "status": zod.enum(['disabled', 'waiting_for_networks', 'waiting_for_video', 'queued', 'partial', 'stale', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
}))
})),
  "createdBy": zod.string(),
  "scenes": zod.array(zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "position": zod.int().min(1).max(createVideoProjectResponseScenesItemPositionMax),
  "title": zod.string(),
  "prompt": zod.string(),
  "negativePrompt": zod.string().nullish(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]),
  "status": zod.enum(['draft', 'rendering', 'ready', 'stale', 'failed']),
  "currentJobId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "lastFrameStorageKey": zod.string().nullish(),
  "firstFrameSource": zod.enum(['previous_scene', 'none']),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).min(1).max(createVideoProjectResponseScenesMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get a video project and ordered scenes
 */
export const getVideoProjectParams = zod.object({
  "id": zod.uuid()
})

export const getVideoProjectResponseDistributionOneDownloadEnabledDefault = true;
export const getVideoProjectResponseDistributionOneAutoPostToSocialDefault = false;
export const getVideoProjectResponseDistributionOneSocialNetworksItemMax = 100;

export const getVideoProjectResponseDistributionOneSocialNetworksMax = 20;

export const getVideoProjectResponseScenesItemPositionMax = 8;

export const getVideoProjectResponseScenesMax = 8;



export const getVideoProjectResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "brief": zod.string(),
  "mode": zod.enum(['single_clip', 'storyboard']),
  "aspectRatio": zod.enum(['16:9', '9:16']),
  "resolution": zod.enum(['720p', '1080p']),
  "defaultModel": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),
  "continuityMode": zod.enum(['last_frame', 'none']),
  "status": zod.enum(['draft', 'rendering', 'ready', 'failed']),
  "finalMediaAssetId": zod.uuid().nullish(),
  "distribution": zod.object({
  "downloadEnabled": zod.literal(true).default(getVideoProjectResponseDistributionOneDownloadEnabledDefault),
  "autoPostToSocial": zod.boolean().default(getVideoProjectResponseDistributionOneAutoPostToSocialDefault),
  "socialNetworks": zod.array(zod.string().min(1).max(getVideoProjectResponseDistributionOneSocialNetworksItemMax)).max(getVideoProjectResponseDistributionOneSocialNetworksMax)
}).and(zod.object({
  "campaignId": zod.uuid().nullable(),
  "campaignStepId": zod.uuid().nullable(),
  "socialPostId": zod.uuid().nullable(),
  "status": zod.enum(['disabled', 'waiting_for_networks', 'waiting_for_video', 'queued', 'partial', 'stale', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
}))
})),
  "createdBy": zod.string(),
  "scenes": zod.array(zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "position": zod.int().min(1).max(getVideoProjectResponseScenesItemPositionMax),
  "title": zod.string(),
  "prompt": zod.string(),
  "negativePrompt": zod.string().nullish(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]),
  "status": zod.enum(['draft', 'rendering', 'ready', 'stale', 'failed']),
  "currentJobId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "lastFrameStorageKey": zod.string().nullish(),
  "firstFrameSource": zod.enum(['previous_scene', 'none']),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).min(1).max(getVideoProjectResponseScenesMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update video project settings
 */
export const updateVideoProjectParams = zod.object({
  "id": zod.uuid()
})

export const updateVideoProjectBodyTitleMax = 200;

export const updateVideoProjectBodyBriefMax = 10000;

export const updateVideoProjectBodyDistributionDownloadEnabledDefault = true;
export const updateVideoProjectBodyDistributionAutoPostToSocialDefault = false;
export const updateVideoProjectBodyDistributionSocialNetworksItemMax = 100;

export const updateVideoProjectBodyDistributionSocialNetworksMax = 20;



export const updateVideoProjectBody = zod.object({
  "title": zod.string().min(1).max(updateVideoProjectBodyTitleMax).optional(),
  "brief": zod.string().max(updateVideoProjectBodyBriefMax).optional(),
  "aspectRatio": zod.enum(['16:9', '9:16']).optional(),
  "resolution": zod.enum(['720p', '1080p']).optional(),
  "defaultModel": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']).optional(),
  "continuityMode": zod.enum(['last_frame', 'none']).optional(),
  "distribution": zod.object({
  "downloadEnabled": zod.literal(true).default(updateVideoProjectBodyDistributionDownloadEnabledDefault),
  "autoPostToSocial": zod.boolean().default(updateVideoProjectBodyDistributionAutoPostToSocialDefault),
  "socialNetworks": zod.array(zod.string().min(1).max(updateVideoProjectBodyDistributionSocialNetworksItemMax)).max(updateVideoProjectBodyDistributionSocialNetworksMax)
}).optional()
})

export const updateVideoProjectResponseDistributionOneDownloadEnabledDefault = true;
export const updateVideoProjectResponseDistributionOneAutoPostToSocialDefault = false;
export const updateVideoProjectResponseDistributionOneSocialNetworksItemMax = 100;

export const updateVideoProjectResponseDistributionOneSocialNetworksMax = 20;

export const updateVideoProjectResponseScenesItemPositionMax = 8;

export const updateVideoProjectResponseScenesMax = 8;



export const updateVideoProjectResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "brief": zod.string(),
  "mode": zod.enum(['single_clip', 'storyboard']),
  "aspectRatio": zod.enum(['16:9', '9:16']),
  "resolution": zod.enum(['720p', '1080p']),
  "defaultModel": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),
  "continuityMode": zod.enum(['last_frame', 'none']),
  "status": zod.enum(['draft', 'rendering', 'ready', 'failed']),
  "finalMediaAssetId": zod.uuid().nullish(),
  "distribution": zod.object({
  "downloadEnabled": zod.literal(true).default(updateVideoProjectResponseDistributionOneDownloadEnabledDefault),
  "autoPostToSocial": zod.boolean().default(updateVideoProjectResponseDistributionOneAutoPostToSocialDefault),
  "socialNetworks": zod.array(zod.string().min(1).max(updateVideoProjectResponseDistributionOneSocialNetworksItemMax)).max(updateVideoProjectResponseDistributionOneSocialNetworksMax)
}).and(zod.object({
  "campaignId": zod.uuid().nullable(),
  "campaignStepId": zod.uuid().nullable(),
  "socialPostId": zod.uuid().nullable(),
  "status": zod.enum(['disabled', 'waiting_for_networks', 'waiting_for_video', 'queued', 'partial', 'stale', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
}))
})),
  "createdBy": zod.string(),
  "scenes": zod.array(zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "position": zod.int().min(1).max(updateVideoProjectResponseScenesItemPositionMax),
  "title": zod.string(),
  "prompt": zod.string(),
  "negativePrompt": zod.string().nullish(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]),
  "status": zod.enum(['draft', 'rendering', 'ready', 'stale', 'failed']),
  "currentJobId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "lastFrameStorageKey": zod.string().nullish(),
  "firstFrameSource": zod.enum(['previous_scene', 'none']),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).min(1).max(updateVideoProjectResponseScenesMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a video project when no generation job is active
 */
export const deleteVideoProjectParams = zod.object({
  "id": zod.uuid()
})

export const deleteVideoProjectResponse = zod.void()


/**
 * Uses the managed text-AI connection and the current entity's authorized
 * grounding. The response is a draft only; it never renders video or
 * mutates a scene until a media manager explicitly applies the proposal.
 * @summary Propose an editable scene revision using the governed staff Agent
 */
export const chatWithVideoProjectParams = zod.object({
  "id": zod.uuid()
})

export const chatWithVideoProjectBodyMessageMax = 4000;



export const chatWithVideoProjectBody = zod.object({
  "message": zod.string().min(1).max(chatWithVideoProjectBodyMessageMax),
  "sceneId": zod.uuid().nullish()
})


export const chatWithVideoProjectResponseProposedSceneEditOneTitleMax = 200;

export const chatWithVideoProjectResponseProposedSceneEditOnePromptMax = 20000;

export const chatWithVideoProjectResponseProposedSceneEditOneNegativePromptMax = 5000;



export const chatWithVideoProjectResponse = zod.object({
  "reply": zod.string().min(1),
  "aiAuditId": zod.uuid(),
  "proposedSceneEdit": zod.union([zod.object({
  "sceneId": zod.uuid(),
  "title": zod.string().min(1).max(chatWithVideoProjectResponseProposedSceneEditOneTitleMax),
  "prompt": zod.string().min(1).max(chatWithVideoProjectResponseProposedSceneEditOnePromptMax),
  "negativePrompt": zod.string().max(chatWithVideoProjectResponseProposedSceneEditOneNegativePromptMax).nullable(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)])
}),zod.null()])
})


/**
 * @summary Add a scene to a storyboard project
 */
export const createVideoSceneParams = zod.object({
  "id": zod.uuid()
})

export const createVideoSceneBodyTitleMax = 200;

export const createVideoSceneBodyPromptMax = 20000;

export const createVideoSceneBodyNegativePromptMax = 5000;

export const createVideoSceneBodyNotesMax = 5000;



export const createVideoSceneBody = zod.object({
  "title": zod.string().min(1).max(createVideoSceneBodyTitleMax),
  "prompt": zod.string().max(createVideoSceneBodyPromptMax),
  "negativePrompt": zod.string().max(createVideoSceneBodyNegativePromptMax).nullish(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]),
  "notes": zod.string().max(createVideoSceneBodyNotesMax).nullish()
})

export const createVideoSceneResponsePositionMax = 8;



export const createVideoSceneResponse = zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "position": zod.int().min(1).max(createVideoSceneResponsePositionMax),
  "title": zod.string(),
  "prompt": zod.string(),
  "negativePrompt": zod.string().nullish(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]),
  "status": zod.enum(['draft', 'rendering', 'ready', 'stale', 'failed']),
  "currentJobId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "lastFrameStorageKey": zod.string().nullish(),
  "firstFrameSource": zod.enum(['previous_scene', 'none']),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a video scene and mark rendered output stale when needed
 */
export const updateVideoSceneParams = zod.object({
  "id": zod.uuid(),
  "sceneId": zod.uuid()
})

export const updateVideoSceneBodyTitleMax = 200;

export const updateVideoSceneBodyPromptMax = 20000;

export const updateVideoSceneBodyNegativePromptMax = 5000;

export const updateVideoSceneBodyNotesMax = 5000;



export const updateVideoSceneBody = zod.object({
  "title": zod.string().min(1).max(updateVideoSceneBodyTitleMax).optional(),
  "prompt": zod.string().max(updateVideoSceneBodyPromptMax).optional(),
  "negativePrompt": zod.string().max(updateVideoSceneBodyNegativePromptMax).nullish(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]).optional(),
  "notes": zod.string().max(updateVideoSceneBodyNotesMax).nullish()
})

export const updateVideoSceneResponsePositionMax = 8;



export const updateVideoSceneResponse = zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "position": zod.int().min(1).max(updateVideoSceneResponsePositionMax),
  "title": zod.string(),
  "prompt": zod.string(),
  "negativePrompt": zod.string().nullish(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]),
  "status": zod.enum(['draft', 'rendering', 'ready', 'stale', 'failed']),
  "currentJobId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "lastFrameStorageKey": zod.string().nullish(),
  "firstFrameSource": zod.enum(['previous_scene', 'none']),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a storyboard scene
 */
export const deleteVideoSceneParams = zod.object({
  "id": zod.uuid(),
  "sceneId": zod.uuid()
})

export const deleteVideoSceneResponse = zod.void()


/**
 * @summary Read the extracted continuity frame for a rendered scene
 */
export const getVideoSceneLastFrameParams = zod.object({
  "id": zod.uuid(),
  "sceneId": zod.uuid()
})

export const getVideoSceneLastFrameResponse = zod.unknown()


/**
 * @summary Replace the complete storyboard scene order
 */
export const reorderVideoScenesParams = zod.object({
  "id": zod.uuid()
})

export const reorderVideoScenesBodySceneIdsMax = 8;



export const reorderVideoScenesBody = zod.object({
  "sceneIds": zod.array(zod.uuid()).min(1).max(reorderVideoScenesBodySceneIdsMax)
})

export const reorderVideoScenesResponsePositionMax = 8;



export const reorderVideoScenesResponseItem = zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "position": zod.int().min(1).max(reorderVideoScenesResponsePositionMax),
  "title": zod.string(),
  "prompt": zod.string(),
  "negativePrompt": zod.string().nullish(),
  "durationSeconds": zod.union([zod.literal(4),zod.literal(6),zod.literal(8)]),
  "status": zod.enum(['draft', 'rendering', 'ready', 'stale', 'failed']),
  "currentJobId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "lastFrameStorageKey": zod.string().nullish(),
  "firstFrameSource": zod.enum(['previous_scene', 'none']),
  "notes": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
export const reorderVideoScenesResponse = zod.array(reorderVideoScenesResponseItem)


/**
 * @summary Queue an OpenRouter render and record metered usage
 */
export const renderVideoSceneParams = zod.object({
  "id": zod.uuid(),
  "sceneId": zod.uuid()
})

export const renderVideoSceneBody = zod.object({
  "model": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite'])
})

export const renderVideoSceneResponseEstimatedCostUsdMin = 0;




export const renderVideoSceneResponse = zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "sceneId": zod.uuid().nullish(),
  "kind": zod.enum(['scene_render', 'final_assembly']),
  "provider": zod.enum(['openrouter']),
  "model": zod.union([zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),zod.null()]).optional(),
  "params": zod.record(zod.string(), zod.unknown()),
  "estimatedCostUsd": zod.number().min(renderVideoSceneResponseEstimatedCostUsdMin),
  "providerJobId": zod.string().nullish(),
  "status": zod.enum(['queued', 'submitted', 'polling', 'downloading', 'assembling', 'succeeded', 'failed', 'cancelled']),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "attempt": zod.int().min(1),
  "startedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Queue in-app assembly after every scene is ready
 */
export const assembleVideoProjectParams = zod.object({
  "id": zod.uuid()
})

export const assembleVideoProjectResponseEstimatedCostUsdMin = 0;




export const assembleVideoProjectResponse = zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "sceneId": zod.uuid().nullish(),
  "kind": zod.enum(['scene_render', 'final_assembly']),
  "provider": zod.enum(['openrouter']),
  "model": zod.union([zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),zod.null()]).optional(),
  "params": zod.record(zod.string(), zod.unknown()),
  "estimatedCostUsd": zod.number().min(assembleVideoProjectResponseEstimatedCostUsdMin),
  "providerJobId": zod.string().nullish(),
  "status": zod.enum(['queued', 'submitted', 'polling', 'downloading', 'assembling', 'succeeded', 'failed', 'cancelled']),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "attempt": zod.int().min(1),
  "startedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List generation and assembly history for a project
 */
export const listVideoProjectJobsParams = zod.object({
  "id": zod.uuid()
})

export const listVideoProjectJobsQueryLimitDefault = 50;
export const listVideoProjectJobsQueryLimitMax = 100;

export const listVideoProjectJobsQueryOffsetDefault = 0;
export const listVideoProjectJobsQueryOffsetMin = 0;



export const listVideoProjectJobsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listVideoProjectJobsQueryLimitMax).default(listVideoProjectJobsQueryLimitDefault),
  "offset": zod.int().min(listVideoProjectJobsQueryOffsetMin).default(listVideoProjectJobsQueryOffsetDefault)
})

export const listVideoProjectJobsResponseItemsItemEstimatedCostUsdMin = 0;


export const listVideoProjectJobsResponseTotalMin = 0;


export const listVideoProjectJobsResponseOffsetMin = 0;



export const listVideoProjectJobsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "sceneId": zod.uuid().nullish(),
  "kind": zod.enum(['scene_render', 'final_assembly']),
  "provider": zod.enum(['openrouter']),
  "model": zod.union([zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),zod.null()]).optional(),
  "params": zod.record(zod.string(), zod.unknown()),
  "estimatedCostUsd": zod.number().min(listVideoProjectJobsResponseItemsItemEstimatedCostUsdMin),
  "providerJobId": zod.string().nullish(),
  "status": zod.enum(['queued', 'submitted', 'polling', 'downloading', 'assembling', 'succeeded', 'failed', 'cancelled']),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "attempt": zod.int().min(1),
  "startedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listVideoProjectJobsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listVideoProjectJobsResponseOffsetMin)
})


/**
 * @summary Get one video generation or assembly job
 */
export const getVideoGenerationJobParams = zod.object({
  "jobId": zod.uuid()
})

export const getVideoGenerationJobResponseEstimatedCostUsdMin = 0;




export const getVideoGenerationJobResponse = zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "sceneId": zod.uuid().nullish(),
  "kind": zod.enum(['scene_render', 'final_assembly']),
  "provider": zod.enum(['openrouter']),
  "model": zod.union([zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),zod.null()]).optional(),
  "params": zod.record(zod.string(), zod.unknown()),
  "estimatedCostUsd": zod.number().min(getVideoGenerationJobResponseEstimatedCostUsdMin),
  "providerJobId": zod.string().nullish(),
  "status": zod.enum(['queued', 'submitted', 'polling', 'downloading', 'assembling', 'succeeded', 'failed', 'cancelled']),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "attempt": zod.int().min(1),
  "startedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Cancel a queued or in-progress video job
 */
export const cancelVideoGenerationJobParams = zod.object({
  "jobId": zod.uuid()
})

export const cancelVideoGenerationJobResponseEstimatedCostUsdMin = 0;




export const cancelVideoGenerationJobResponse = zod.object({
  "id": zod.uuid(),
  "projectId": zod.uuid(),
  "sceneId": zod.uuid().nullish(),
  "kind": zod.enum(['scene_render', 'final_assembly']),
  "provider": zod.enum(['openrouter']),
  "model": zod.union([zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),zod.null()]).optional(),
  "params": zod.record(zod.string(), zod.unknown()),
  "estimatedCostUsd": zod.number().min(cancelVideoGenerationJobResponseEstimatedCostUsdMin),
  "providerJobId": zod.string().nullish(),
  "status": zod.enum(['queued', 'submitted', 'polling', 'downloading', 'assembling', 'succeeded', 'failed', 'cancelled']),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish(),
  "attempt": zod.int().min(1),
  "startedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "finishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Download the finished project as an authenticated MP4
 */
export const downloadVideoProjectParams = zod.object({
  "id": zod.uuid()
})

export const downloadVideoProjectResponse = zod.unknown()


/**
 * @summary Summarise metered video generation usage by model
 */
export const getVideoGenerationUsageQueryParams = zod.object({
  "from": zod.iso.datetime({"offset":true}).optional(),
  "to": zod.iso.datetime({"offset":true}).optional()
})

export const getVideoGenerationUsageResponseTotalRunsMin = 0;

export const getVideoGenerationUsageResponseTotalSecondsMin = 0;

export const getVideoGenerationUsageResponseEstimatedCostUsdMin = 0;

export const getVideoGenerationUsageResponseActualCostUsdMin = 0;

export const getVideoGenerationUsageResponseByModelItemRunsMin = 0;

export const getVideoGenerationUsageResponseByModelItemSecondsMin = 0;

export const getVideoGenerationUsageResponseByModelItemEstimatedCostUsdMin = 0;

export const getVideoGenerationUsageResponseByModelItemActualCostUsdMin = 0;

export const getVideoGenerationUsageResponseByModelMax = 3;



export const getVideoGenerationUsageResponse = zod.object({
  "from": zod.iso.datetime({"offset":true}).nullable(),
  "to": zod.iso.datetime({"offset":true}).nullable(),
  "totalRuns": zod.int().min(getVideoGenerationUsageResponseTotalRunsMin),
  "totalSeconds": zod.int().min(getVideoGenerationUsageResponseTotalSecondsMin),
  "estimatedCostUsd": zod.number().min(getVideoGenerationUsageResponseEstimatedCostUsdMin),
  "actualCostUsd": zod.number().min(getVideoGenerationUsageResponseActualCostUsdMin),
  "byModel": zod.array(zod.object({
  "provider": zod.enum(['openrouter']),
  "model": zod.enum(['google/veo-3.1-fast', 'google/veo-3.1', 'google/veo-3.1-lite']),
  "runs": zod.int().min(getVideoGenerationUsageResponseByModelItemRunsMin),
  "seconds": zod.int().min(getVideoGenerationUsageResponseByModelItemSecondsMin),
  "estimatedCostUsd": zod.number().min(getVideoGenerationUsageResponseByModelItemEstimatedCostUsdMin),
  "actualCostUsd": zod.number().min(getVideoGenerationUsageResponseByModelItemActualCostUsdMin)
})).max(getVideoGenerationUsageResponseByModelMax)
})


/**
 * @summary List entity-scoped Content Hub media
 */
export const listContentHubMediaQueryIncludeSceneClipsDefault = false;
export const listContentHubMediaQueryLimitDefault = 24;
export const listContentHubMediaQueryLimitMax = 100;

export const listContentHubMediaQueryOffsetDefault = 0;
export const listContentHubMediaQueryOffsetMin = 0;



export const listContentHubMediaQueryParams = zod.object({
  "kind": zod.enum(['image', 'video']).optional(),
  "status": zod.enum(['processing', 'ready', 'failed']).optional(),
  "origin": zod.enum(['uploaded', 'ai_generated']).optional(),
  "includeSceneClips": zod.boolean().default(listContentHubMediaQueryIncludeSceneClipsDefault).describe('Include individual storyboard scene outputs; final videos and single clips are returned by default'),
  "limit": zod.int().min(1).max(listContentHubMediaQueryLimitMax).default(listContentHubMediaQueryLimitDefault),
  "offset": zod.int().min(listContentHubMediaQueryOffsetMin).default(listContentHubMediaQueryOffsetDefault)
})

export const listContentHubMediaResponseItemsItemSizeBytesMax = 20971520;

export const listContentHubMediaResponseItemsItemChecksumSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listContentHubMediaResponseItemsItemProcessingAttemptsMin = 0;

export const listContentHubMediaResponseTotalMin = 0;


export const listContentHubMediaResponseOffsetMin = 0;



export const listContentHubMediaResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'video/mp4', 'video/quicktime', 'video/webm']),
  "sizeBytes": zod.int().min(1).max(listContentHubMediaResponseItemsItemSizeBytesMax),
  "checksumSha256": zod.string().regex(listContentHubMediaResponseItemsItemChecksumSha256RegExp),
  "origin": zod.union([zod.object({
  "source": zod.enum(['openrouter', 'project_ai']),
  "model": zod.string().nullable(),
  "projectId": zod.uuid().nullable(),
  "sceneId": zod.uuid().nullable(),
  "kind": zod.enum(['scene', 'final', 'image'])
}),zod.null()]),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "scanStatus": zod.enum(['pending', 'structural_passed', 'failed']),
  "derivativeStatus": zod.enum(['pending', 'ready', 'failed']),
  "selectable": zod.boolean(),
  "processingAttempts": zod.int().min(listContentHubMediaResponseItemsItemProcessingAttemptsMin),
  "failureCode": zod.string().nullable(),
  "failureMessage": zod.string().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listContentHubMediaResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubMediaResponseOffsetMin)
})


/**
 * @summary Upload a private original for asynchronous validation and derivative processing
 */
export const uploadContentHubMediaBody = zod.object({
  "file": zod.instanceof(Blob)
})

export const uploadContentHubMediaResponseSizeBytesMax = 20971520;

export const uploadContentHubMediaResponseChecksumSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const uploadContentHubMediaResponseProcessingAttemptsMin = 0;



export const uploadContentHubMediaResponse = zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'video/mp4', 'video/quicktime', 'video/webm']),
  "sizeBytes": zod.int().min(1).max(uploadContentHubMediaResponseSizeBytesMax),
  "checksumSha256": zod.string().regex(uploadContentHubMediaResponseChecksumSha256RegExp),
  "origin": zod.union([zod.object({
  "source": zod.enum(['openrouter', 'project_ai']),
  "model": zod.string().nullable(),
  "projectId": zod.uuid().nullable(),
  "sceneId": zod.uuid().nullable(),
  "kind": zod.enum(['scene', 'final', 'image'])
}),zod.null()]),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "scanStatus": zod.enum(['pending', 'structural_passed', 'failed']),
  "derivativeStatus": zod.enum(['pending', 'ready', 'failed']),
  "selectable": zod.boolean(),
  "processingAttempts": zod.int().min(uploadContentHubMediaResponseProcessingAttemptsMin),
  "failureCode": zod.string().nullable(),
  "failureMessage": zod.string().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Validate that selected media is ready in the current entity
 */
export const validateContentHubMediaSelectionBodyAssetIdsMax = 10;



export const validateContentHubMediaSelectionBody = zod.object({
  "assetIds": zod.array(zod.uuid()).min(1).max(validateContentHubMediaSelectionBodyAssetIdsMax)
})

export const validateContentHubMediaSelectionResponseItemsItemSizeBytesMax = 20971520;

export const validateContentHubMediaSelectionResponseItemsItemChecksumSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const validateContentHubMediaSelectionResponseItemsItemProcessingAttemptsMin = 0;



export const validateContentHubMediaSelectionResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'video/mp4', 'video/quicktime', 'video/webm']),
  "sizeBytes": zod.int().min(1).max(validateContentHubMediaSelectionResponseItemsItemSizeBytesMax),
  "checksumSha256": zod.string().regex(validateContentHubMediaSelectionResponseItemsItemChecksumSha256RegExp),
  "origin": zod.union([zod.object({
  "source": zod.enum(['openrouter', 'project_ai']),
  "model": zod.string().nullable(),
  "projectId": zod.uuid().nullable(),
  "sceneId": zod.uuid().nullable(),
  "kind": zod.enum(['scene', 'final', 'image'])
}),zod.null()]),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "scanStatus": zod.enum(['pending', 'structural_passed', 'failed']),
  "derivativeStatus": zod.enum(['pending', 'ready', 'failed']),
  "selectable": zod.boolean(),
  "processingAttempts": zod.int().min(validateContentHubMediaSelectionResponseItemsItemProcessingAttemptsMin),
  "failureCode": zod.string().nullable(),
  "failureMessage": zod.string().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Generate an image with the configured project model and save it to entity-scoped media
 */
export const generateContentHubImageBodyPromptMax = 4000;

export const generateContentHubImageBodySizeDefault = `1024x1024`;

export const generateContentHubImageBody = zod.object({
  "prompt": zod.string().min(1).max(generateContentHubImageBodyPromptMax),
  "size": zod.enum(['1024x1024', '1536x1024', '1024x1536']).default(generateContentHubImageBodySizeDefault)
})

export const generateContentHubImageResponseOneSizeBytesMax = 20971520;

export const generateContentHubImageResponseOneChecksumSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const generateContentHubImageResponseOneProcessingAttemptsMin = 0;




export const generateContentHubImageResponse = zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'video/mp4', 'video/quicktime', 'video/webm']),
  "sizeBytes": zod.int().min(1).max(generateContentHubImageResponseOneSizeBytesMax),
  "checksumSha256": zod.string().regex(generateContentHubImageResponseOneChecksumSha256RegExp),
  "origin": zod.union([zod.object({
  "source": zod.enum(['openrouter', 'project_ai']),
  "model": zod.string().nullable(),
  "projectId": zod.uuid().nullable(),
  "sceneId": zod.uuid().nullable(),
  "kind": zod.enum(['scene', 'final', 'image'])
}),zod.null()]),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "scanStatus": zod.enum(['pending', 'structural_passed', 'failed']),
  "derivativeStatus": zod.enum(['pending', 'ready', 'failed']),
  "selectable": zod.boolean(),
  "processingAttempts": zod.int().min(generateContentHubImageResponseOneProcessingAttemptsMin),
  "failureCode": zod.string().nullable(),
  "failureMessage": zod.string().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "derivatives": zod.array(zod.object({
  "id": zod.uuid(),
  "profile": zod.enum(['preview', 'provider']),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(1),
  "status": zod.enum(['pending', 'ready', 'failed']),
  "createdAt": zod.iso.datetime({"offset":true})
}))
}))


/**
 * @summary Get safe media metadata and derivative states
 */
export const getContentHubMediaParams = zod.object({
  "id": zod.uuid()
})

export const getContentHubMediaResponseOneSizeBytesMax = 20971520;

export const getContentHubMediaResponseOneChecksumSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const getContentHubMediaResponseOneProcessingAttemptsMin = 0;




export const getContentHubMediaResponse = zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'video/mp4', 'video/quicktime', 'video/webm']),
  "sizeBytes": zod.int().min(1).max(getContentHubMediaResponseOneSizeBytesMax),
  "checksumSha256": zod.string().regex(getContentHubMediaResponseOneChecksumSha256RegExp),
  "origin": zod.union([zod.object({
  "source": zod.enum(['openrouter', 'project_ai']),
  "model": zod.string().nullable(),
  "projectId": zod.uuid().nullable(),
  "sceneId": zod.uuid().nullable(),
  "kind": zod.enum(['scene', 'final', 'image'])
}),zod.null()]),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "scanStatus": zod.enum(['pending', 'structural_passed', 'failed']),
  "derivativeStatus": zod.enum(['pending', 'ready', 'failed']),
  "selectable": zod.boolean(),
  "processingAttempts": zod.int().min(getContentHubMediaResponseOneProcessingAttemptsMin),
  "failureCode": zod.string().nullable(),
  "failureMessage": zod.string().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "derivatives": zod.array(zod.object({
  "id": zod.uuid(),
  "profile": zod.enum(['preview', 'provider']),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(1),
  "status": zod.enum(['pending', 'ready', 'failed']),
  "createdAt": zod.iso.datetime({"offset":true})
}))
}))


/**
 * @summary Delete unreferenced media and revoke its delivery grants
 */
export const deleteContentHubMediaParams = zod.object({
  "id": zod.uuid()
})

export const deleteContentHubMediaQueryReasonMin = 3;
export const deleteContentHubMediaQueryReasonMax = 500;



export const deleteContentHubMediaQueryParams = zod.object({
  "reason": zod.string().min(deleteContentHubMediaQueryReasonMin).max(deleteContentHubMediaQueryReasonMax)
})

export const deleteContentHubMediaResponse = zod.void()


/**
 * @summary Download a ready media original with an attachment filename
 */
export const downloadContentHubMediaParams = zod.object({
  "id": zod.uuid()
})

export const downloadContentHubMediaResponse = zod.unknown()


/**
 * @summary Download an authenticated preview derivative, never the private original
 */
export const getContentHubMediaPreviewParams = zod.object({
  "id": zod.uuid()
})

export const getContentHubMediaPreviewResponse = zod.unknown()


/**
 * @summary Retry a failed media processing operation
 */
export const retryContentHubMediaProcessingParams = zod.object({
  "id": zod.uuid()
})

export const retryContentHubMediaProcessingResponseSizeBytesMax = 20971520;

export const retryContentHubMediaProcessingResponseChecksumSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const retryContentHubMediaProcessingResponseProcessingAttemptsMin = 0;



export const retryContentHubMediaProcessingResponse = zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'video/mp4', 'video/quicktime', 'video/webm']),
  "sizeBytes": zod.int().min(1).max(retryContentHubMediaProcessingResponseSizeBytesMax),
  "checksumSha256": zod.string().regex(retryContentHubMediaProcessingResponseChecksumSha256RegExp),
  "origin": zod.union([zod.object({
  "source": zod.enum(['openrouter', 'project_ai']),
  "model": zod.string().nullable(),
  "projectId": zod.uuid().nullable(),
  "sceneId": zod.uuid().nullable(),
  "kind": zod.enum(['scene', 'final', 'image'])
}),zod.null()]),
  "status": zod.enum(['processing', 'ready', 'failed']),
  "scanStatus": zod.enum(['pending', 'structural_passed', 'failed']),
  "derivativeStatus": zod.enum(['pending', 'ready', 'failed']),
  "selectable": zod.boolean(),
  "processingAttempts": zod.int().min(retryContentHubMediaProcessingResponseProcessingAttemptsMin),
  "failureCode": zod.string().nullable(),
  "failureMessage": zod.string().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Create an expiring provider-fetchable URL for a ready derivative
 */
export const createContentHubMediaDeliveryParams = zod.object({
  "id": zod.uuid()
})

export const createContentHubMediaDeliveryBodyLifetimeSecondsDefault = 3600;
export const createContentHubMediaDeliveryBodyLifetimeSecondsMin = 300;
export const createContentHubMediaDeliveryBodyLifetimeSecondsMax = 86400;



export const createContentHubMediaDeliveryBody = zod.object({
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "lifetimeSeconds": zod.int().min(createContentHubMediaDeliveryBodyLifetimeSecondsMin).max(createContentHubMediaDeliveryBodyLifetimeSecondsMax).default(createContentHubMediaDeliveryBodyLifetimeSecondsDefault)
})

export const createContentHubMediaDeliveryResponse = zod.object({
  "url": zod.url(),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Fetch one derivative through an unguessable unexpired delivery grant
 */
export const getPublicContentHubMediaDeliveryPathTokenRegExp = new RegExp('^[A-Za-z0-9_-]{43}$');


export const getPublicContentHubMediaDeliveryParams = zod.object({
  "token": zod.string().regex(getPublicContentHubMediaDeliveryPathTokenRegExp)
})

export const getPublicContentHubMediaDeliveryResponse = zod.unknown()


export const listEntityProfileEnrichmentsQueryLimitDefault = 10;
export const listEntityProfileEnrichmentsQueryLimitMax = 50;

export const listEntityProfileEnrichmentsQueryOffsetDefault = 0;
export const listEntityProfileEnrichmentsQueryOffsetMin = 0;



export const listEntityProfileEnrichmentsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEntityProfileEnrichmentsQueryLimitMax).default(listEntityProfileEnrichmentsQueryLimitDefault),
  "offset": zod.int().min(listEntityProfileEnrichmentsQueryOffsetMin).default(listEntityProfileEnrichmentsQueryOffsetDefault)
})


export const listEntityProfileEnrichmentsResponseItemsItemOneProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const listEntityProfileEnrichmentsResponseItemsItemOneWebsiteUrlMax = 2048;

export const listEntityProfileEnrichmentsResponseItemsItemOnePromptMax = 20000;

export const listEntityProfileEnrichmentsResponseItemsItemOneFieldsItemLiteralEvidenceMax = 10000;

export const listEntityProfileEnrichmentsResponseItemsItemOneFieldsItemUrlMax = 2048;

export const listEntityProfileEnrichmentsResponseItemsItemOneFieldsItemUncertaintyMax = 2000;

export const listEntityProfileEnrichmentsResponseItemsItemOneFieldsMax = 50;

export const listEntityProfileEnrichmentsResponseItemsItemOneMissingFactsItemMax = 1000;

export const listEntityProfileEnrichmentsResponseItemsItemOneMissingFactsMax = 100;

export const listEntityProfileEnrichmentsResponseItemsItemOneFailureMax = 2000;

export const listEntityProfileEnrichmentsResponseItemsItemTwoProfileVersionMin = 0;

export const listEntityProfileEnrichmentsResponseItemsItemTwoIdentityCandidatesItemUrlMax = 2048;

export const listEntityProfileEnrichmentsResponseItemsItemTwoIdentityCandidatesItemTitleMax = 500;

export const listEntityProfileEnrichmentsResponseItemsItemTwoIdentityCandidatesItemExcerptMax = 2000;

export const listEntityProfileEnrichmentsResponseItemsItemTwoIdentityCandidatesMax = 15;

export const listEntityProfileEnrichmentsResponseItemsItemTwoPublicSearchTermsItemMax = 300;

export const listEntityProfileEnrichmentsResponseItemsItemTwoPublicSearchTermsMax = 3;


export const listEntityProfileEnrichmentsResponseItemsItemTwoQualificationFactsItemValueMax = 2000;

export const listEntityProfileEnrichmentsResponseItemsItemTwoQualificationFactsItemLiteralEvidenceMax = 10000;

export const listEntityProfileEnrichmentsResponseItemsItemTwoQualificationFactsItemUrlMax = 2048;

export const listEntityProfileEnrichmentsResponseItemsItemTwoQualificationFactsMax = 50;

export const listEntityProfileEnrichmentsResponseTotalMin = 0;

export const listEntityProfileEnrichmentsResponseLimitMax = 50;

export const listEntityProfileEnrichmentsResponseOffsetMin = 0;



export const listEntityProfileEnrichmentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(listEntityProfileEnrichmentsResponseItemsItemOneProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "status": zod.enum(['pending', 'ready', 'failed', 'setup_required', 'adopted', 'rejected']),
  "websiteUrl": zod.url().max(listEntityProfileEnrichmentsResponseItemsItemOneWebsiteUrlMax).nullable(),
  "prompt": zod.string().max(listEntityProfileEnrichmentsResponseItemsItemOnePromptMax).nullable(),
  "fields": zod.array(zod.object({
  "key": zod.enum(['businessName', 'description', 'industry', 'websiteUrl', 'locationText', 'services', 'markets', 'qualificationFacts']),
  "existingValue": zod.unknown(),
  "proposedValue": zod.unknown(),
  "attribution": zod.enum(['web_evidence', 'user_assertion', 'suggestion', 'unknown']),
  "literalEvidence": zod.string().max(listEntityProfileEnrichmentsResponseItemsItemOneFieldsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(listEntityProfileEnrichmentsResponseItemsItemOneFieldsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "uncertainty": zod.string().max(listEntityProfileEnrichmentsResponseItemsItemOneFieldsItemUncertaintyMax).nullable()
})).max(listEntityProfileEnrichmentsResponseItemsItemOneFieldsMax),
  "missingFacts": zod.array(zod.string().max(listEntityProfileEnrichmentsResponseItemsItemOneMissingFactsItemMax)).max(listEntityProfileEnrichmentsResponseItemsItemOneMissingFactsMax),
  "failure": zod.string().max(listEntityProfileEnrichmentsResponseItemsItemOneFailureMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "profileVersion": zod.int().min(listEntityProfileEnrichmentsResponseItemsItemTwoProfileVersionMin),
  "identityCandidates": zod.array(zod.object({
  "url": zod.url().max(listEntityProfileEnrichmentsResponseItemsItemTwoIdentityCandidatesItemUrlMax),
  "title": zod.string().max(listEntityProfileEnrichmentsResponseItemsItemTwoIdentityCandidatesItemTitleMax),
  "excerpt": zod.string().max(listEntityProfileEnrichmentsResponseItemsItemTwoIdentityCandidatesItemExcerptMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(listEntityProfileEnrichmentsResponseItemsItemTwoIdentityCandidatesMax),
  "publicSearchTerms": zod.array(zod.string().max(listEntityProfileEnrichmentsResponseItemsItemTwoPublicSearchTermsItemMax)).max(listEntityProfileEnrichmentsResponseItemsItemTwoPublicSearchTermsMax),
  "savedProfileVersion": zod.int().min(1).nullable(),
  "qualificationFacts": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['accreditation', 'panel_membership', 'tax_status', 'annual_turnover', 'employee_count', 'research_activities']),
  "value": zod.string().min(1).max(listEntityProfileEnrichmentsResponseItemsItemTwoQualificationFactsItemValueMax),
  "literalEvidence": zod.string().max(listEntityProfileEnrichmentsResponseItemsItemTwoQualificationFactsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(listEntityProfileEnrichmentsResponseItemsItemTwoQualificationFactsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "attribution": zod.enum(['user_assertion'])
})).max(listEntityProfileEnrichmentsResponseItemsItemTwoQualificationFactsMax)
}))),
  "total": zod.int().min(listEntityProfileEnrichmentsResponseTotalMin),
  "limit": zod.int().min(1).max(listEntityProfileEnrichmentsResponseLimitMax),
  "offset": zod.int().min(listEntityProfileEnrichmentsResponseOffsetMin)
})


export const createEntityProfileEnrichmentBodyWebsiteUrlMax = 1000;

export const createEntityProfileEnrichmentBodyPromptMax = 20000;

export const createEntityProfileEnrichmentBodyPublicSearchTermsItemMin = 3;
export const createEntityProfileEnrichmentBodyPublicSearchTermsItemMax = 300;

export const createEntityProfileEnrichmentBodyPublicSearchTermsMax = 3;



export const createEntityProfileEnrichmentBody = zod.object({
  "requestKey": zod.uuid(),
  "websiteUrl": zod.url().max(createEntityProfileEnrichmentBodyWebsiteUrlMax).nullable(),
  "prompt": zod.string().max(createEntityProfileEnrichmentBodyPromptMax).nullable(),
  "publicSearchTerms": zod.array(zod.string().min(createEntityProfileEnrichmentBodyPublicSearchTermsItemMin).max(createEntityProfileEnrichmentBodyPublicSearchTermsItemMax)).max(createEntityProfileEnrichmentBodyPublicSearchTermsMax)
})


export const createEntityProfileEnrichmentResponseOneProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const createEntityProfileEnrichmentResponseOneWebsiteUrlMax = 2048;

export const createEntityProfileEnrichmentResponseOnePromptMax = 20000;

export const createEntityProfileEnrichmentResponseOneFieldsItemLiteralEvidenceMax = 10000;

export const createEntityProfileEnrichmentResponseOneFieldsItemUrlMax = 2048;

export const createEntityProfileEnrichmentResponseOneFieldsItemUncertaintyMax = 2000;

export const createEntityProfileEnrichmentResponseOneFieldsMax = 50;

export const createEntityProfileEnrichmentResponseOneMissingFactsItemMax = 1000;

export const createEntityProfileEnrichmentResponseOneMissingFactsMax = 100;

export const createEntityProfileEnrichmentResponseOneFailureMax = 2000;

export const createEntityProfileEnrichmentResponseTwoProfileVersionMin = 0;

export const createEntityProfileEnrichmentResponseTwoIdentityCandidatesItemUrlMax = 2048;

export const createEntityProfileEnrichmentResponseTwoIdentityCandidatesItemTitleMax = 500;

export const createEntityProfileEnrichmentResponseTwoIdentityCandidatesItemExcerptMax = 2000;

export const createEntityProfileEnrichmentResponseTwoIdentityCandidatesMax = 15;

export const createEntityProfileEnrichmentResponseTwoPublicSearchTermsItemMax = 300;

export const createEntityProfileEnrichmentResponseTwoPublicSearchTermsMax = 3;


export const createEntityProfileEnrichmentResponseTwoQualificationFactsItemValueMax = 2000;

export const createEntityProfileEnrichmentResponseTwoQualificationFactsItemLiteralEvidenceMax = 10000;

export const createEntityProfileEnrichmentResponseTwoQualificationFactsItemUrlMax = 2048;

export const createEntityProfileEnrichmentResponseTwoQualificationFactsMax = 50;



export const createEntityProfileEnrichmentResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(createEntityProfileEnrichmentResponseOneProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "status": zod.enum(['pending', 'ready', 'failed', 'setup_required', 'adopted', 'rejected']),
  "websiteUrl": zod.url().max(createEntityProfileEnrichmentResponseOneWebsiteUrlMax).nullable(),
  "prompt": zod.string().max(createEntityProfileEnrichmentResponseOnePromptMax).nullable(),
  "fields": zod.array(zod.object({
  "key": zod.enum(['businessName', 'description', 'industry', 'websiteUrl', 'locationText', 'services', 'markets', 'qualificationFacts']),
  "existingValue": zod.unknown(),
  "proposedValue": zod.unknown(),
  "attribution": zod.enum(['web_evidence', 'user_assertion', 'suggestion', 'unknown']),
  "literalEvidence": zod.string().max(createEntityProfileEnrichmentResponseOneFieldsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(createEntityProfileEnrichmentResponseOneFieldsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "uncertainty": zod.string().max(createEntityProfileEnrichmentResponseOneFieldsItemUncertaintyMax).nullable()
})).max(createEntityProfileEnrichmentResponseOneFieldsMax),
  "missingFacts": zod.array(zod.string().max(createEntityProfileEnrichmentResponseOneMissingFactsItemMax)).max(createEntityProfileEnrichmentResponseOneMissingFactsMax),
  "failure": zod.string().max(createEntityProfileEnrichmentResponseOneFailureMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "profileVersion": zod.int().min(createEntityProfileEnrichmentResponseTwoProfileVersionMin),
  "identityCandidates": zod.array(zod.object({
  "url": zod.url().max(createEntityProfileEnrichmentResponseTwoIdentityCandidatesItemUrlMax),
  "title": zod.string().max(createEntityProfileEnrichmentResponseTwoIdentityCandidatesItemTitleMax),
  "excerpt": zod.string().max(createEntityProfileEnrichmentResponseTwoIdentityCandidatesItemExcerptMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(createEntityProfileEnrichmentResponseTwoIdentityCandidatesMax),
  "publicSearchTerms": zod.array(zod.string().max(createEntityProfileEnrichmentResponseTwoPublicSearchTermsItemMax)).max(createEntityProfileEnrichmentResponseTwoPublicSearchTermsMax),
  "savedProfileVersion": zod.int().min(1).nullable(),
  "qualificationFacts": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['accreditation', 'panel_membership', 'tax_status', 'annual_turnover', 'employee_count', 'research_activities']),
  "value": zod.string().min(1).max(createEntityProfileEnrichmentResponseTwoQualificationFactsItemValueMax),
  "literalEvidence": zod.string().max(createEntityProfileEnrichmentResponseTwoQualificationFactsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(createEntityProfileEnrichmentResponseTwoQualificationFactsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "attribution": zod.enum(['user_assertion'])
})).max(createEntityProfileEnrichmentResponseTwoQualificationFactsMax)
}))


export const getEntityProfileEnrichmentParams = zod.object({
  "proposalId": zod.uuid()
})


export const getEntityProfileEnrichmentResponseOneProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const getEntityProfileEnrichmentResponseOneWebsiteUrlMax = 2048;

export const getEntityProfileEnrichmentResponseOnePromptMax = 20000;

export const getEntityProfileEnrichmentResponseOneFieldsItemLiteralEvidenceMax = 10000;

export const getEntityProfileEnrichmentResponseOneFieldsItemUrlMax = 2048;

export const getEntityProfileEnrichmentResponseOneFieldsItemUncertaintyMax = 2000;

export const getEntityProfileEnrichmentResponseOneFieldsMax = 50;

export const getEntityProfileEnrichmentResponseOneMissingFactsItemMax = 1000;

export const getEntityProfileEnrichmentResponseOneMissingFactsMax = 100;

export const getEntityProfileEnrichmentResponseOneFailureMax = 2000;

export const getEntityProfileEnrichmentResponseTwoProfileVersionMin = 0;

export const getEntityProfileEnrichmentResponseTwoIdentityCandidatesItemUrlMax = 2048;

export const getEntityProfileEnrichmentResponseTwoIdentityCandidatesItemTitleMax = 500;

export const getEntityProfileEnrichmentResponseTwoIdentityCandidatesItemExcerptMax = 2000;

export const getEntityProfileEnrichmentResponseTwoIdentityCandidatesMax = 15;

export const getEntityProfileEnrichmentResponseTwoPublicSearchTermsItemMax = 300;

export const getEntityProfileEnrichmentResponseTwoPublicSearchTermsMax = 3;


export const getEntityProfileEnrichmentResponseTwoQualificationFactsItemValueMax = 2000;

export const getEntityProfileEnrichmentResponseTwoQualificationFactsItemLiteralEvidenceMax = 10000;

export const getEntityProfileEnrichmentResponseTwoQualificationFactsItemUrlMax = 2048;

export const getEntityProfileEnrichmentResponseTwoQualificationFactsMax = 50;



export const getEntityProfileEnrichmentResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(getEntityProfileEnrichmentResponseOneProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "status": zod.enum(['pending', 'ready', 'failed', 'setup_required', 'adopted', 'rejected']),
  "websiteUrl": zod.url().max(getEntityProfileEnrichmentResponseOneWebsiteUrlMax).nullable(),
  "prompt": zod.string().max(getEntityProfileEnrichmentResponseOnePromptMax).nullable(),
  "fields": zod.array(zod.object({
  "key": zod.enum(['businessName', 'description', 'industry', 'websiteUrl', 'locationText', 'services', 'markets', 'qualificationFacts']),
  "existingValue": zod.unknown(),
  "proposedValue": zod.unknown(),
  "attribution": zod.enum(['web_evidence', 'user_assertion', 'suggestion', 'unknown']),
  "literalEvidence": zod.string().max(getEntityProfileEnrichmentResponseOneFieldsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(getEntityProfileEnrichmentResponseOneFieldsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "uncertainty": zod.string().max(getEntityProfileEnrichmentResponseOneFieldsItemUncertaintyMax).nullable()
})).max(getEntityProfileEnrichmentResponseOneFieldsMax),
  "missingFacts": zod.array(zod.string().max(getEntityProfileEnrichmentResponseOneMissingFactsItemMax)).max(getEntityProfileEnrichmentResponseOneMissingFactsMax),
  "failure": zod.string().max(getEntityProfileEnrichmentResponseOneFailureMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "profileVersion": zod.int().min(getEntityProfileEnrichmentResponseTwoProfileVersionMin),
  "identityCandidates": zod.array(zod.object({
  "url": zod.url().max(getEntityProfileEnrichmentResponseTwoIdentityCandidatesItemUrlMax),
  "title": zod.string().max(getEntityProfileEnrichmentResponseTwoIdentityCandidatesItemTitleMax),
  "excerpt": zod.string().max(getEntityProfileEnrichmentResponseTwoIdentityCandidatesItemExcerptMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(getEntityProfileEnrichmentResponseTwoIdentityCandidatesMax),
  "publicSearchTerms": zod.array(zod.string().max(getEntityProfileEnrichmentResponseTwoPublicSearchTermsItemMax)).max(getEntityProfileEnrichmentResponseTwoPublicSearchTermsMax),
  "savedProfileVersion": zod.int().min(1).nullable(),
  "qualificationFacts": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['accreditation', 'panel_membership', 'tax_status', 'annual_turnover', 'employee_count', 'research_activities']),
  "value": zod.string().min(1).max(getEntityProfileEnrichmentResponseTwoQualificationFactsItemValueMax),
  "literalEvidence": zod.string().max(getEntityProfileEnrichmentResponseTwoQualificationFactsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(getEntityProfileEnrichmentResponseTwoQualificationFactsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "attribution": zod.enum(['user_assertion'])
})).max(getEntityProfileEnrichmentResponseTwoQualificationFactsMax)
}))


export const decideEntityProfileEnrichmentParams = zod.object({
  "proposalId": zod.uuid()
})


export const decideEntityProfileEnrichmentBodyExpectedProfileVersionMin = 0;

export const decideEntityProfileEnrichmentBodyFieldsItemValueOneMax = 5000;

export const decideEntityProfileEnrichmentBodyFieldsItemValueTwoItemMax = 500;

export const decideEntityProfileEnrichmentBodyFieldsItemValueTwoMax = 100;

export const decideEntityProfileEnrichmentBodyFieldsMax = 7;

export const decideEntityProfileEnrichmentBodyQualificationFactsItemValueMax = 2000;

export const decideEntityProfileEnrichmentBodyQualificationFactsItemLiteralEvidenceMax = 10000;

export const decideEntityProfileEnrichmentBodyQualificationFactsItemUrlMax = 2048;

export const decideEntityProfileEnrichmentBodyQualificationFactsMax = 50;



export const decideEntityProfileEnrichmentBody = zod.object({
  "requestKey": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "expectedProfileVersion": zod.int().min(decideEntityProfileEnrichmentBodyExpectedProfileVersionMin),
  "fields": zod.array(zod.object({
  "key": zod.enum(['businessName', 'description', 'industry', 'websiteUrl', 'locationText', 'services', 'markets']),
  "value": zod.union([zod.string().max(decideEntityProfileEnrichmentBodyFieldsItemValueOneMax),zod.array(zod.string().max(decideEntityProfileEnrichmentBodyFieldsItemValueTwoItemMax)).max(decideEntityProfileEnrichmentBodyFieldsItemValueTwoMax)])
})).max(decideEntityProfileEnrichmentBodyFieldsMax),
  "qualificationFacts": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['accreditation', 'panel_membership', 'tax_status', 'annual_turnover', 'employee_count', 'research_activities']),
  "value": zod.string().min(1).max(decideEntityProfileEnrichmentBodyQualificationFactsItemValueMax),
  "literalEvidence": zod.string().max(decideEntityProfileEnrichmentBodyQualificationFactsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(decideEntityProfileEnrichmentBodyQualificationFactsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "attribution": zod.enum(['user_assertion'])
})).max(decideEntityProfileEnrichmentBodyQualificationFactsMax).optional()
})


export const decideEntityProfileEnrichmentResponseOneProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const decideEntityProfileEnrichmentResponseOneWebsiteUrlMax = 2048;

export const decideEntityProfileEnrichmentResponseOnePromptMax = 20000;

export const decideEntityProfileEnrichmentResponseOneFieldsItemLiteralEvidenceMax = 10000;

export const decideEntityProfileEnrichmentResponseOneFieldsItemUrlMax = 2048;

export const decideEntityProfileEnrichmentResponseOneFieldsItemUncertaintyMax = 2000;

export const decideEntityProfileEnrichmentResponseOneFieldsMax = 50;

export const decideEntityProfileEnrichmentResponseOneMissingFactsItemMax = 1000;

export const decideEntityProfileEnrichmentResponseOneMissingFactsMax = 100;

export const decideEntityProfileEnrichmentResponseOneFailureMax = 2000;

export const decideEntityProfileEnrichmentResponseTwoProfileVersionMin = 0;

export const decideEntityProfileEnrichmentResponseTwoIdentityCandidatesItemUrlMax = 2048;

export const decideEntityProfileEnrichmentResponseTwoIdentityCandidatesItemTitleMax = 500;

export const decideEntityProfileEnrichmentResponseTwoIdentityCandidatesItemExcerptMax = 2000;

export const decideEntityProfileEnrichmentResponseTwoIdentityCandidatesMax = 15;

export const decideEntityProfileEnrichmentResponseTwoPublicSearchTermsItemMax = 300;

export const decideEntityProfileEnrichmentResponseTwoPublicSearchTermsMax = 3;


export const decideEntityProfileEnrichmentResponseTwoQualificationFactsItemValueMax = 2000;

export const decideEntityProfileEnrichmentResponseTwoQualificationFactsItemLiteralEvidenceMax = 10000;

export const decideEntityProfileEnrichmentResponseTwoQualificationFactsItemUrlMax = 2048;

export const decideEntityProfileEnrichmentResponseTwoQualificationFactsMax = 50;



export const decideEntityProfileEnrichmentResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(decideEntityProfileEnrichmentResponseOneProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "status": zod.enum(['pending', 'ready', 'failed', 'setup_required', 'adopted', 'rejected']),
  "websiteUrl": zod.url().max(decideEntityProfileEnrichmentResponseOneWebsiteUrlMax).nullable(),
  "prompt": zod.string().max(decideEntityProfileEnrichmentResponseOnePromptMax).nullable(),
  "fields": zod.array(zod.object({
  "key": zod.enum(['businessName', 'description', 'industry', 'websiteUrl', 'locationText', 'services', 'markets', 'qualificationFacts']),
  "existingValue": zod.unknown(),
  "proposedValue": zod.unknown(),
  "attribution": zod.enum(['web_evidence', 'user_assertion', 'suggestion', 'unknown']),
  "literalEvidence": zod.string().max(decideEntityProfileEnrichmentResponseOneFieldsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(decideEntityProfileEnrichmentResponseOneFieldsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "uncertainty": zod.string().max(decideEntityProfileEnrichmentResponseOneFieldsItemUncertaintyMax).nullable()
})).max(decideEntityProfileEnrichmentResponseOneFieldsMax),
  "missingFacts": zod.array(zod.string().max(decideEntityProfileEnrichmentResponseOneMissingFactsItemMax)).max(decideEntityProfileEnrichmentResponseOneMissingFactsMax),
  "failure": zod.string().max(decideEntityProfileEnrichmentResponseOneFailureMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "profileVersion": zod.int().min(decideEntityProfileEnrichmentResponseTwoProfileVersionMin),
  "identityCandidates": zod.array(zod.object({
  "url": zod.url().max(decideEntityProfileEnrichmentResponseTwoIdentityCandidatesItemUrlMax),
  "title": zod.string().max(decideEntityProfileEnrichmentResponseTwoIdentityCandidatesItemTitleMax),
  "excerpt": zod.string().max(decideEntityProfileEnrichmentResponseTwoIdentityCandidatesItemExcerptMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(decideEntityProfileEnrichmentResponseTwoIdentityCandidatesMax),
  "publicSearchTerms": zod.array(zod.string().max(decideEntityProfileEnrichmentResponseTwoPublicSearchTermsItemMax)).max(decideEntityProfileEnrichmentResponseTwoPublicSearchTermsMax),
  "savedProfileVersion": zod.int().min(1).nullable(),
  "qualificationFacts": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['accreditation', 'panel_membership', 'tax_status', 'annual_turnover', 'employee_count', 'research_activities']),
  "value": zod.string().min(1).max(decideEntityProfileEnrichmentResponseTwoQualificationFactsItemValueMax),
  "literalEvidence": zod.string().max(decideEntityProfileEnrichmentResponseTwoQualificationFactsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(decideEntityProfileEnrichmentResponseTwoQualificationFactsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "attribution": zod.enum(['user_assertion'])
})).max(decideEntityProfileEnrichmentResponseTwoQualificationFactsMax)
}))


export const selectEntityProfileEnrichmentWebsiteParams = zod.object({
  "proposalId": zod.uuid()
})


export const selectEntityProfileEnrichmentWebsiteBodyWebsiteUrlMax = 2048;



export const selectEntityProfileEnrichmentWebsiteBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "websiteUrl": zod.url().max(selectEntityProfileEnrichmentWebsiteBodyWebsiteUrlMax)
})


export const selectEntityProfileEnrichmentWebsiteResponseOneProfileProfileHashRegExp = new RegExp('^[a-f0-9]{64}$');

export const selectEntityProfileEnrichmentWebsiteResponseOneWebsiteUrlMax = 2048;

export const selectEntityProfileEnrichmentWebsiteResponseOnePromptMax = 20000;

export const selectEntityProfileEnrichmentWebsiteResponseOneFieldsItemLiteralEvidenceMax = 10000;

export const selectEntityProfileEnrichmentWebsiteResponseOneFieldsItemUrlMax = 2048;

export const selectEntityProfileEnrichmentWebsiteResponseOneFieldsItemUncertaintyMax = 2000;

export const selectEntityProfileEnrichmentWebsiteResponseOneFieldsMax = 50;

export const selectEntityProfileEnrichmentWebsiteResponseOneMissingFactsItemMax = 1000;

export const selectEntityProfileEnrichmentWebsiteResponseOneMissingFactsMax = 100;

export const selectEntityProfileEnrichmentWebsiteResponseOneFailureMax = 2000;

export const selectEntityProfileEnrichmentWebsiteResponseTwoProfileVersionMin = 0;

export const selectEntityProfileEnrichmentWebsiteResponseTwoIdentityCandidatesItemUrlMax = 2048;

export const selectEntityProfileEnrichmentWebsiteResponseTwoIdentityCandidatesItemTitleMax = 500;

export const selectEntityProfileEnrichmentWebsiteResponseTwoIdentityCandidatesItemExcerptMax = 2000;

export const selectEntityProfileEnrichmentWebsiteResponseTwoIdentityCandidatesMax = 15;

export const selectEntityProfileEnrichmentWebsiteResponseTwoPublicSearchTermsItemMax = 300;

export const selectEntityProfileEnrichmentWebsiteResponseTwoPublicSearchTermsMax = 3;


export const selectEntityProfileEnrichmentWebsiteResponseTwoQualificationFactsItemValueMax = 2000;

export const selectEntityProfileEnrichmentWebsiteResponseTwoQualificationFactsItemLiteralEvidenceMax = 10000;

export const selectEntityProfileEnrichmentWebsiteResponseTwoQualificationFactsItemUrlMax = 2048;

export const selectEntityProfileEnrichmentWebsiteResponseTwoQualificationFactsMax = 50;



export const selectEntityProfileEnrichmentWebsiteResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "ownerEntityId": zod.uuid(),
  "revision": zod.int().min(1),
  "requestKey": zod.uuid(),
  "profile": zod.object({
  "entityProfileId": zod.uuid().nullable(),
  "entityProfileUpdatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "profileHash": zod.string().regex(selectEntityProfileEnrichmentWebsiteResponseOneProfileProfileHashRegExp),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable()
}),
  "status": zod.enum(['pending', 'ready', 'failed', 'setup_required', 'adopted', 'rejected']),
  "websiteUrl": zod.url().max(selectEntityProfileEnrichmentWebsiteResponseOneWebsiteUrlMax).nullable(),
  "prompt": zod.string().max(selectEntityProfileEnrichmentWebsiteResponseOnePromptMax).nullable(),
  "fields": zod.array(zod.object({
  "key": zod.enum(['businessName', 'description', 'industry', 'websiteUrl', 'locationText', 'services', 'markets', 'qualificationFacts']),
  "existingValue": zod.unknown(),
  "proposedValue": zod.unknown(),
  "attribution": zod.enum(['web_evidence', 'user_assertion', 'suggestion', 'unknown']),
  "literalEvidence": zod.string().max(selectEntityProfileEnrichmentWebsiteResponseOneFieldsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(selectEntityProfileEnrichmentWebsiteResponseOneFieldsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "uncertainty": zod.string().max(selectEntityProfileEnrichmentWebsiteResponseOneFieldsItemUncertaintyMax).nullable()
})).max(selectEntityProfileEnrichmentWebsiteResponseOneFieldsMax),
  "missingFacts": zod.array(zod.string().max(selectEntityProfileEnrichmentWebsiteResponseOneMissingFactsItemMax)).max(selectEntityProfileEnrichmentWebsiteResponseOneMissingFactsMax),
  "failure": zod.string().max(selectEntityProfileEnrichmentWebsiteResponseOneFailureMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "profileVersion": zod.int().min(selectEntityProfileEnrichmentWebsiteResponseTwoProfileVersionMin),
  "identityCandidates": zod.array(zod.object({
  "url": zod.url().max(selectEntityProfileEnrichmentWebsiteResponseTwoIdentityCandidatesItemUrlMax),
  "title": zod.string().max(selectEntityProfileEnrichmentWebsiteResponseTwoIdentityCandidatesItemTitleMax),
  "excerpt": zod.string().max(selectEntityProfileEnrichmentWebsiteResponseTwoIdentityCandidatesItemExcerptMax),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(selectEntityProfileEnrichmentWebsiteResponseTwoIdentityCandidatesMax),
  "publicSearchTerms": zod.array(zod.string().max(selectEntityProfileEnrichmentWebsiteResponseTwoPublicSearchTermsItemMax)).max(selectEntityProfileEnrichmentWebsiteResponseTwoPublicSearchTermsMax),
  "savedProfileVersion": zod.int().min(1).nullable(),
  "qualificationFacts": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['accreditation', 'panel_membership', 'tax_status', 'annual_turnover', 'employee_count', 'research_activities']),
  "value": zod.string().min(1).max(selectEntityProfileEnrichmentWebsiteResponseTwoQualificationFactsItemValueMax),
  "literalEvidence": zod.string().max(selectEntityProfileEnrichmentWebsiteResponseTwoQualificationFactsItemLiteralEvidenceMax).nullable(),
  "url": zod.url().max(selectEntityProfileEnrichmentWebsiteResponseTwoQualificationFactsItemUrlMax).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true}).nullable(),
  "attribution": zod.enum(['user_assertion'])
})).max(selectEntityProfileEnrichmentWebsiteResponseTwoQualificationFactsMax)
}))


/**
 * @summary Get the entity profile used across administration and Content Hub
 */
export const getEntityProfileResponseOneExpectedVersionMin = 0;

export const getEntityProfileResponseOneBusinessNameMax = 200;

export const getEntityProfileResponseOneTaglineMax = 300;

export const getEntityProfileResponseOneDescriptionMax = 5000;

export const getEntityProfileResponseOneIndustryMax = 200;

export const getEntityProfileResponseOneWebsiteUrlMax = 1000;

export const getEntityProfileResponseOneContactEmailMax = 320;

export const getEntityProfileResponseOneContactPhoneMax = 100;

export const getEntityProfileResponseOneLocationTextMax = 500;

export const getEntityProfileResponseOneMarketsMax = 50;

export const getEntityProfileResponseOneTargetAudienceMax = 3000;

export const getEntityProfileResponseOneServicesMax = 100;

export const getEntityProfileResponseOneValuePropositionMax = 3000;

export const getEntityProfileResponseOneDifferentiatorsMax = 50;

export const getEntityProfileResponseOneToneOfVoiceMax = 3000;

export const getEntityProfileResponseOneAiPersonaMax = 3000;

export const getEntityProfileResponseOneVoiceExamplesMax = 10000;

export const getEntityProfileResponseOneSignatureCtasMax = 50;

export const getEntityProfileResponseOneHashtagBankMax = 100;

export const getEntityProfileResponseOnePreferredPlatformsMax = 20;

export const getEntityProfileResponseOneContentPillarsMax = 50;

export const getEntityProfileResponseOneImageStyleMax = 500;

export const getEntityProfileResponseOneRestrictedClaimsMax = 5000;

export const getEntityProfileResponseOneDisclaimersMax = 5000;

export const getEntityProfileResponseOneLocaleMax = 50;

export const getEntityProfileResponseOneTimezoneMax = 100;

export const getEntityProfileResponseOneCurrencyMax = 10;

export const getEntityProfileResponseTwoLogoOneSizeBytesMax = 8388608;



export const getEntityProfileResponse = zod.object({
  "expectedVersion": zod.int().min(getEntityProfileResponseOneExpectedVersionMin).optional(),
  "businessName": zod.string().max(getEntityProfileResponseOneBusinessNameMax),
  "tagline": zod.string().max(getEntityProfileResponseOneTaglineMax),
  "description": zod.string().max(getEntityProfileResponseOneDescriptionMax),
  "industry": zod.string().max(getEntityProfileResponseOneIndustryMax),
  "websiteUrl": zod.string().max(getEntityProfileResponseOneWebsiteUrlMax),
  "contactEmail": zod.string().max(getEntityProfileResponseOneContactEmailMax),
  "contactPhone": zod.string().max(getEntityProfileResponseOneContactPhoneMax),
  "locationText": zod.string().max(getEntityProfileResponseOneLocationTextMax),
  "markets": zod.array(zod.string()).max(getEntityProfileResponseOneMarketsMax),
  "targetAudience": zod.string().max(getEntityProfileResponseOneTargetAudienceMax),
  "services": zod.array(zod.string()).max(getEntityProfileResponseOneServicesMax),
  "valueProposition": zod.string().max(getEntityProfileResponseOneValuePropositionMax),
  "differentiators": zod.array(zod.string()).max(getEntityProfileResponseOneDifferentiatorsMax),
  "toneOfVoice": zod.string().max(getEntityProfileResponseOneToneOfVoiceMax),
  "aiPersona": zod.string().max(getEntityProfileResponseOneAiPersonaMax),
  "voiceExamples": zod.string().max(getEntityProfileResponseOneVoiceExamplesMax),
  "signatureCtas": zod.array(zod.string()).max(getEntityProfileResponseOneSignatureCtasMax),
  "hashtagBank": zod.array(zod.string()).max(getEntityProfileResponseOneHashtagBankMax),
  "preferredPlatforms": zod.array(zod.string()).max(getEntityProfileResponseOnePreferredPlatformsMax),
  "contentPillars": zod.array(zod.string()).max(getEntityProfileResponseOneContentPillarsMax),
  "imageStyle": zod.string().max(getEntityProfileResponseOneImageStyleMax),
  "restrictedClaims": zod.string().max(getEntityProfileResponseOneRestrictedClaimsMax),
  "disclaimers": zod.string().max(getEntityProfileResponseOneDisclaimersMax),
  "locale": zod.string().max(getEntityProfileResponseOneLocaleMax),
  "timezone": zod.string().max(getEntityProfileResponseOneTimezoneMax),
  "currency": zod.string().max(getEntityProfileResponseOneCurrencyMax),
  "requireApproval": zod.boolean(),
  "notifyOnPublish": zod.boolean()
}).and(zod.object({
  "id": zod.uuid().nullish(),
  "logo": zod.union([zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(getEntityProfileResponseTwoLogoOneSizeBytesMax),
  "updatedAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
}))


/**
 * @summary Update the entity profile used across administration and Content Hub
 */
export const updateEntityProfileBodyExpectedVersionMin = 0;

export const updateEntityProfileBodyBusinessNameMax = 200;

export const updateEntityProfileBodyTaglineMax = 300;

export const updateEntityProfileBodyDescriptionMax = 5000;

export const updateEntityProfileBodyIndustryMax = 200;

export const updateEntityProfileBodyWebsiteUrlMax = 1000;

export const updateEntityProfileBodyContactEmailMax = 320;

export const updateEntityProfileBodyContactPhoneMax = 100;

export const updateEntityProfileBodyLocationTextMax = 500;

export const updateEntityProfileBodyMarketsMax = 50;

export const updateEntityProfileBodyTargetAudienceMax = 3000;

export const updateEntityProfileBodyServicesMax = 100;

export const updateEntityProfileBodyValuePropositionMax = 3000;

export const updateEntityProfileBodyDifferentiatorsMax = 50;

export const updateEntityProfileBodyToneOfVoiceMax = 3000;

export const updateEntityProfileBodyAiPersonaMax = 3000;

export const updateEntityProfileBodyVoiceExamplesMax = 10000;

export const updateEntityProfileBodySignatureCtasMax = 50;

export const updateEntityProfileBodyHashtagBankMax = 100;

export const updateEntityProfileBodyPreferredPlatformsMax = 20;

export const updateEntityProfileBodyContentPillarsMax = 50;

export const updateEntityProfileBodyImageStyleMax = 500;

export const updateEntityProfileBodyRestrictedClaimsMax = 5000;

export const updateEntityProfileBodyDisclaimersMax = 5000;

export const updateEntityProfileBodyLocaleMax = 50;

export const updateEntityProfileBodyTimezoneMax = 100;

export const updateEntityProfileBodyCurrencyMax = 10;



export const updateEntityProfileBody = zod.object({
  "expectedVersion": zod.int().min(updateEntityProfileBodyExpectedVersionMin),
  "businessName": zod.string().max(updateEntityProfileBodyBusinessNameMax).optional(),
  "tagline": zod.string().max(updateEntityProfileBodyTaglineMax).optional(),
  "description": zod.string().max(updateEntityProfileBodyDescriptionMax).optional(),
  "industry": zod.string().max(updateEntityProfileBodyIndustryMax).optional(),
  "websiteUrl": zod.string().max(updateEntityProfileBodyWebsiteUrlMax).optional(),
  "contactEmail": zod.string().max(updateEntityProfileBodyContactEmailMax).optional(),
  "contactPhone": zod.string().max(updateEntityProfileBodyContactPhoneMax).optional(),
  "locationText": zod.string().max(updateEntityProfileBodyLocationTextMax).optional(),
  "markets": zod.array(zod.string()).max(updateEntityProfileBodyMarketsMax).optional(),
  "targetAudience": zod.string().max(updateEntityProfileBodyTargetAudienceMax).optional(),
  "services": zod.array(zod.string()).max(updateEntityProfileBodyServicesMax).optional(),
  "valueProposition": zod.string().max(updateEntityProfileBodyValuePropositionMax).optional(),
  "differentiators": zod.array(zod.string()).max(updateEntityProfileBodyDifferentiatorsMax).optional(),
  "toneOfVoice": zod.string().max(updateEntityProfileBodyToneOfVoiceMax).optional(),
  "aiPersona": zod.string().max(updateEntityProfileBodyAiPersonaMax).optional(),
  "voiceExamples": zod.string().max(updateEntityProfileBodyVoiceExamplesMax).optional(),
  "signatureCtas": zod.array(zod.string()).max(updateEntityProfileBodySignatureCtasMax).optional(),
  "hashtagBank": zod.array(zod.string()).max(updateEntityProfileBodyHashtagBankMax).optional(),
  "preferredPlatforms": zod.array(zod.string()).max(updateEntityProfileBodyPreferredPlatformsMax).optional(),
  "contentPillars": zod.array(zod.string()).max(updateEntityProfileBodyContentPillarsMax).optional(),
  "imageStyle": zod.string().max(updateEntityProfileBodyImageStyleMax).optional(),
  "restrictedClaims": zod.string().max(updateEntityProfileBodyRestrictedClaimsMax).optional(),
  "disclaimers": zod.string().max(updateEntityProfileBodyDisclaimersMax).optional(),
  "locale": zod.string().max(updateEntityProfileBodyLocaleMax).optional(),
  "timezone": zod.string().max(updateEntityProfileBodyTimezoneMax).optional(),
  "currency": zod.string().max(updateEntityProfileBodyCurrencyMax).optional(),
  "requireApproval": zod.boolean().optional(),
  "notifyOnPublish": zod.boolean().optional()
})

export const updateEntityProfileResponseOneExpectedVersionMin = 0;

export const updateEntityProfileResponseOneBusinessNameMax = 200;

export const updateEntityProfileResponseOneTaglineMax = 300;

export const updateEntityProfileResponseOneDescriptionMax = 5000;

export const updateEntityProfileResponseOneIndustryMax = 200;

export const updateEntityProfileResponseOneWebsiteUrlMax = 1000;

export const updateEntityProfileResponseOneContactEmailMax = 320;

export const updateEntityProfileResponseOneContactPhoneMax = 100;

export const updateEntityProfileResponseOneLocationTextMax = 500;

export const updateEntityProfileResponseOneMarketsMax = 50;

export const updateEntityProfileResponseOneTargetAudienceMax = 3000;

export const updateEntityProfileResponseOneServicesMax = 100;

export const updateEntityProfileResponseOneValuePropositionMax = 3000;

export const updateEntityProfileResponseOneDifferentiatorsMax = 50;

export const updateEntityProfileResponseOneToneOfVoiceMax = 3000;

export const updateEntityProfileResponseOneAiPersonaMax = 3000;

export const updateEntityProfileResponseOneVoiceExamplesMax = 10000;

export const updateEntityProfileResponseOneSignatureCtasMax = 50;

export const updateEntityProfileResponseOneHashtagBankMax = 100;

export const updateEntityProfileResponseOnePreferredPlatformsMax = 20;

export const updateEntityProfileResponseOneContentPillarsMax = 50;

export const updateEntityProfileResponseOneImageStyleMax = 500;

export const updateEntityProfileResponseOneRestrictedClaimsMax = 5000;

export const updateEntityProfileResponseOneDisclaimersMax = 5000;

export const updateEntityProfileResponseOneLocaleMax = 50;

export const updateEntityProfileResponseOneTimezoneMax = 100;

export const updateEntityProfileResponseOneCurrencyMax = 10;

export const updateEntityProfileResponseTwoLogoOneSizeBytesMax = 8388608;



export const updateEntityProfileResponse = zod.object({
  "expectedVersion": zod.int().min(updateEntityProfileResponseOneExpectedVersionMin).optional(),
  "businessName": zod.string().max(updateEntityProfileResponseOneBusinessNameMax),
  "tagline": zod.string().max(updateEntityProfileResponseOneTaglineMax),
  "description": zod.string().max(updateEntityProfileResponseOneDescriptionMax),
  "industry": zod.string().max(updateEntityProfileResponseOneIndustryMax),
  "websiteUrl": zod.string().max(updateEntityProfileResponseOneWebsiteUrlMax),
  "contactEmail": zod.string().max(updateEntityProfileResponseOneContactEmailMax),
  "contactPhone": zod.string().max(updateEntityProfileResponseOneContactPhoneMax),
  "locationText": zod.string().max(updateEntityProfileResponseOneLocationTextMax),
  "markets": zod.array(zod.string()).max(updateEntityProfileResponseOneMarketsMax),
  "targetAudience": zod.string().max(updateEntityProfileResponseOneTargetAudienceMax),
  "services": zod.array(zod.string()).max(updateEntityProfileResponseOneServicesMax),
  "valueProposition": zod.string().max(updateEntityProfileResponseOneValuePropositionMax),
  "differentiators": zod.array(zod.string()).max(updateEntityProfileResponseOneDifferentiatorsMax),
  "toneOfVoice": zod.string().max(updateEntityProfileResponseOneToneOfVoiceMax),
  "aiPersona": zod.string().max(updateEntityProfileResponseOneAiPersonaMax),
  "voiceExamples": zod.string().max(updateEntityProfileResponseOneVoiceExamplesMax),
  "signatureCtas": zod.array(zod.string()).max(updateEntityProfileResponseOneSignatureCtasMax),
  "hashtagBank": zod.array(zod.string()).max(updateEntityProfileResponseOneHashtagBankMax),
  "preferredPlatforms": zod.array(zod.string()).max(updateEntityProfileResponseOnePreferredPlatformsMax),
  "contentPillars": zod.array(zod.string()).max(updateEntityProfileResponseOneContentPillarsMax),
  "imageStyle": zod.string().max(updateEntityProfileResponseOneImageStyleMax),
  "restrictedClaims": zod.string().max(updateEntityProfileResponseOneRestrictedClaimsMax),
  "disclaimers": zod.string().max(updateEntityProfileResponseOneDisclaimersMax),
  "locale": zod.string().max(updateEntityProfileResponseOneLocaleMax),
  "timezone": zod.string().max(updateEntityProfileResponseOneTimezoneMax),
  "currency": zod.string().max(updateEntityProfileResponseOneCurrencyMax),
  "requireApproval": zod.boolean(),
  "notifyOnPublish": zod.boolean()
}).and(zod.object({
  "id": zod.uuid().nullish(),
  "logo": zod.union([zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(updateEntityProfileResponseTwoLogoOneSizeBytesMax),
  "updatedAt": zod.iso.datetime({"offset":true})
}),zod.null()]),
  "version": zod.int(),
  "createdAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
}))


/**
 * @summary Download the current entity profile logo
 */
export const getEntityProfileLogoResponse = zod.unknown()


/**
 * @summary Upload and select the shared entity and microsite logo
 */
export const uploadEntityProfileLogoBody = zod.object({
  "file": zod.instanceof(Blob)
})

export const uploadEntityProfileLogoResponseSizeBytesMax = 8388608;



export const uploadEntityProfileLogoResponse = zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "contentType": zod.enum(['image/png', 'image/jpeg', 'image/webp', 'image/avif']),
  "sizeBytes": zod.int().min(1).max(uploadEntityProfileLogoResponseSizeBytesMax),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Remove the shared entity and microsite logo
 */
export const deleteEntityProfileLogoResponse = zod.void()


/**
 * @summary Produce a concise editable summary from the entity website
 */
export const summariseEntityProfileWebsiteBodyWebsiteUrlMax = 1000;



export const summariseEntityProfileWebsiteBody = zod.object({
  "websiteUrl": zod.url().min(1).max(summariseEntityProfileWebsiteBodyWebsiteUrlMax)
})

export const summariseEntityProfileWebsiteResponseSummaryMax = 5000;



export const summariseEntityProfileWebsiteResponse = zod.object({
  "summary": zod.string().min(1).max(summariseEntityProfileWebsiteResponseSummaryMax),
  "sourceUrl": zod.url()
})


/**
 * @summary List Content Hub bookings
 */
export const listContentHubBookingsQueryLimitDefault = 25;
export const listContentHubBookingsQueryLimitMax = 100;

export const listContentHubBookingsQueryOffsetDefault = 0;
export const listContentHubBookingsQueryOffsetMin = 0;



export const listContentHubBookingsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listContentHubBookingsQueryLimitMax).default(listContentHubBookingsQueryLimitDefault),
  "offset": zod.int().min(listContentHubBookingsQueryOffsetMin).default(listContentHubBookingsQueryOffsetDefault),
  "status": zod.enum(['pending', 'confirmed', 'completed', 'cancelled']).optional()
})

export const listContentHubBookingsResponseItemsItemOneNameMax = 200;

export const listContentHubBookingsResponseItemsItemOnePhoneMax = 100;

export const listContentHubBookingsResponseItemsItemOneServiceMax = 300;

export const listContentHubBookingsResponseItemsItemOneNotesMax = 5000;

export const listContentHubBookingsResponseItemsItemOneConsentToContactDefault = false;
export const listContentHubBookingsResponseTotalMin = 0;


export const listContentHubBookingsResponseOffsetMin = 0;



export const listContentHubBookingsResponse = zod.object({
  "items": zod.array(zod.object({
  "name": zod.string().min(1).max(listContentHubBookingsResponseItemsItemOneNameMax),
  "email": zod.email(),
  "phone": zod.string().max(listContentHubBookingsResponseItemsItemOnePhoneMax).nullish(),
  "service": zod.string().min(1).max(listContentHubBookingsResponseItemsItemOneServiceMax),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().max(listContentHubBookingsResponseItemsItemOneNotesMax).nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "slotId": zod.uuid().nullish(),
  "consentToContact": zod.boolean().default(listContentHubBookingsResponseItemsItemOneConsentToContactDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['pending', 'confirmed', 'completed', 'cancelled']),
  "source": zod.enum(['manual', 'public_microsite']),
  "micrositeBindingId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listContentHubBookingsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubBookingsResponseOffsetMin)
})


/**
 * @summary Create a booking and link it to CRM records
 */
export const createContentHubBookingBodyNameMax = 200;

export const createContentHubBookingBodyPhoneMax = 100;

export const createContentHubBookingBodyServiceMax = 300;

export const createContentHubBookingBodyNotesMax = 5000;

export const createContentHubBookingBodyConsentToContactDefault = false;

export const createContentHubBookingBody = zod.object({
  "name": zod.string().min(1).max(createContentHubBookingBodyNameMax),
  "email": zod.email(),
  "phone": zod.string().max(createContentHubBookingBodyPhoneMax).nullish(),
  "service": zod.string().min(1).max(createContentHubBookingBodyServiceMax),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().max(createContentHubBookingBodyNotesMax).nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "slotId": zod.uuid().nullish(),
  "consentToContact": zod.boolean().default(createContentHubBookingBodyConsentToContactDefault)
})

export const createContentHubBookingResponseOneNameMax = 200;

export const createContentHubBookingResponseOnePhoneMax = 100;

export const createContentHubBookingResponseOneServiceMax = 300;

export const createContentHubBookingResponseOneNotesMax = 5000;

export const createContentHubBookingResponseOneConsentToContactDefault = false;

export const createContentHubBookingResponse = zod.object({
  "name": zod.string().min(1).max(createContentHubBookingResponseOneNameMax),
  "email": zod.email(),
  "phone": zod.string().max(createContentHubBookingResponseOnePhoneMax).nullish(),
  "service": zod.string().min(1).max(createContentHubBookingResponseOneServiceMax),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().max(createContentHubBookingResponseOneNotesMax).nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "slotId": zod.uuid().nullish(),
  "consentToContact": zod.boolean().default(createContentHubBookingResponseOneConsentToContactDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['pending', 'confirmed', 'completed', 'cancelled']),
  "source": zod.enum(['manual', 'public_microsite']),
  "micrositeBindingId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a booking status or notes
 */
export const updateContentHubBookingParams = zod.object({
  "id": zod.uuid()
})

export const updateContentHubBookingBodyNotesMax = 5000;

export const updateContentHubBookingBodyReasonMax = 1000;



export const updateContentHubBookingBody = zod.object({
  "status": zod.enum(['pending', 'confirmed', 'completed', 'cancelled']).optional(),
  "startsAt": zod.iso.datetime({"offset":true}).optional(),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().max(updateContentHubBookingBodyNotesMax).nullish(),
  "slotId": zod.uuid().nullish(),
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(1).max(updateContentHubBookingBodyReasonMax).optional()
})

export const updateContentHubBookingResponseOneNameMax = 200;

export const updateContentHubBookingResponseOnePhoneMax = 100;

export const updateContentHubBookingResponseOneServiceMax = 300;

export const updateContentHubBookingResponseOneNotesMax = 5000;

export const updateContentHubBookingResponseOneConsentToContactDefault = false;

export const updateContentHubBookingResponse = zod.object({
  "name": zod.string().min(1).max(updateContentHubBookingResponseOneNameMax),
  "email": zod.email(),
  "phone": zod.string().max(updateContentHubBookingResponseOnePhoneMax).nullish(),
  "service": zod.string().min(1).max(updateContentHubBookingResponseOneServiceMax),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}).nullish(),
  "notes": zod.string().max(updateContentHubBookingResponseOneNotesMax).nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "slotId": zod.uuid().nullish(),
  "consentToContact": zod.boolean().default(updateContentHubBookingResponseOneConsentToContactDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['pending', 'confirmed', 'completed', 'cancelled']),
  "source": zod.enum(['manual', 'public_microsite']),
  "micrositeBindingId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List immutable CRM-linked booking history
 */
export const listContentHubBookingHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listContentHubBookingHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "bookingId": zod.uuid(),
  "type": zod.enum(['created', 'confirmed', 'rescheduled', 'cancelled', 'completed', 'notes_updated']),
  "actor": zod.string(),
  "reason": zod.string().nullable(),
  "fromStatus": zod.union([zod.enum(['pending', 'confirmed', 'completed', 'cancelled']),zod.null()]),
  "toStatus": zod.union([zod.enum(['pending', 'confirmed', 'completed', 'cancelled']),zod.null()]),
  "fromStartsAt": zod.iso.datetime({"offset":true}).nullable(),
  "toStartsAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary List configured booking availability slots
 */
export const listContentHubBookingSlotsQueryLimitDefault = 25;
export const listContentHubBookingSlotsQueryLimitMax = 100;

export const listContentHubBookingSlotsQueryOffsetDefault = 0;
export const listContentHubBookingSlotsQueryOffsetMin = 0;

export const listContentHubBookingSlotsQueryIncludePastDefault = false;

export const listContentHubBookingSlotsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listContentHubBookingSlotsQueryLimitMax).default(listContentHubBookingSlotsQueryLimitDefault),
  "offset": zod.int().min(listContentHubBookingSlotsQueryOffsetMin).default(listContentHubBookingSlotsQueryOffsetDefault),
  "includePast": zod.boolean().default(listContentHubBookingSlotsQueryIncludePastDefault)
})

export const listContentHubBookingSlotsResponseItemsItemOneServiceMax = 300;

export const listContentHubBookingSlotsResponseItemsItemOneDescriptionMax = 1000;

export const listContentHubBookingSlotsResponseItemsItemOneTimezoneMax = 100;

export const listContentHubBookingSlotsResponseItemsItemOneCapacityMax = 100;

export const listContentHubBookingSlotsResponseItemsItemOneActiveDefault = true;
export const listContentHubBookingSlotsResponseItemsItemTwoReservedMin = 0;

export const listContentHubBookingSlotsResponseItemsItemTwoRemainingMin = 0;

export const listContentHubBookingSlotsResponseTotalMin = 0;


export const listContentHubBookingSlotsResponseOffsetMin = 0;



export const listContentHubBookingSlotsResponse = zod.object({
  "items": zod.array(zod.object({
  "service": zod.string().min(1).max(listContentHubBookingSlotsResponseItemsItemOneServiceMax),
  "description": zod.string().max(listContentHubBookingSlotsResponseItemsItemOneDescriptionMax).nullish(),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string().min(1).max(listContentHubBookingSlotsResponseItemsItemOneTimezoneMax),
  "capacity": zod.int().min(1).max(listContentHubBookingSlotsResponseItemsItemOneCapacityMax),
  "active": zod.boolean().default(listContentHubBookingSlotsResponseItemsItemOneActiveDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "reserved": zod.int().min(listContentHubBookingSlotsResponseItemsItemTwoReservedMin),
  "remaining": zod.int().min(listContentHubBookingSlotsResponseItemsItemTwoRemainingMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listContentHubBookingSlotsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubBookingSlotsResponseOffsetMin)
})


/**
 * @summary Configure one capacity-controlled booking slot
 */
export const createContentHubBookingSlotBodyServiceMax = 300;

export const createContentHubBookingSlotBodyDescriptionMax = 1000;

export const createContentHubBookingSlotBodyTimezoneMax = 100;

export const createContentHubBookingSlotBodyCapacityMax = 100;

export const createContentHubBookingSlotBodyActiveDefault = true;

export const createContentHubBookingSlotBody = zod.object({
  "service": zod.string().min(1).max(createContentHubBookingSlotBodyServiceMax),
  "description": zod.string().max(createContentHubBookingSlotBodyDescriptionMax).nullish(),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string().min(1).max(createContentHubBookingSlotBodyTimezoneMax),
  "capacity": zod.int().min(1).max(createContentHubBookingSlotBodyCapacityMax),
  "active": zod.boolean().default(createContentHubBookingSlotBodyActiveDefault)
})

export const createContentHubBookingSlotResponseOneServiceMax = 300;

export const createContentHubBookingSlotResponseOneDescriptionMax = 1000;

export const createContentHubBookingSlotResponseOneTimezoneMax = 100;

export const createContentHubBookingSlotResponseOneCapacityMax = 100;

export const createContentHubBookingSlotResponseOneActiveDefault = true;
export const createContentHubBookingSlotResponseTwoReservedMin = 0;

export const createContentHubBookingSlotResponseTwoRemainingMin = 0;



export const createContentHubBookingSlotResponse = zod.object({
  "service": zod.string().min(1).max(createContentHubBookingSlotResponseOneServiceMax),
  "description": zod.string().max(createContentHubBookingSlotResponseOneDescriptionMax).nullish(),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string().min(1).max(createContentHubBookingSlotResponseOneTimezoneMax),
  "capacity": zod.int().min(1).max(createContentHubBookingSlotResponseOneCapacityMax),
  "active": zod.boolean().default(createContentHubBookingSlotResponseOneActiveDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "reserved": zod.int().min(createContentHubBookingSlotResponseTwoReservedMin),
  "remaining": zod.int().min(createContentHubBookingSlotResponseTwoRemainingMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update a booking slot without invalidating existing reservations
 */
export const updateContentHubBookingSlotParams = zod.object({
  "id": zod.uuid()
})

export const updateContentHubBookingSlotBodyDescriptionMax = 1000;

export const updateContentHubBookingSlotBodyCapacityMax = 100;



export const updateContentHubBookingSlotBody = zod.object({
  "description": zod.string().max(updateContentHubBookingSlotBodyDescriptionMax).nullish(),
  "capacity": zod.int().min(1).max(updateContentHubBookingSlotBodyCapacityMax).optional(),
  "active": zod.boolean().optional(),
  "expectedUpdatedAt": zod.iso.datetime({"offset":true})
})

export const updateContentHubBookingSlotResponseOneServiceMax = 300;

export const updateContentHubBookingSlotResponseOneDescriptionMax = 1000;

export const updateContentHubBookingSlotResponseOneTimezoneMax = 100;

export const updateContentHubBookingSlotResponseOneCapacityMax = 100;

export const updateContentHubBookingSlotResponseOneActiveDefault = true;
export const updateContentHubBookingSlotResponseTwoReservedMin = 0;

export const updateContentHubBookingSlotResponseTwoRemainingMin = 0;



export const updateContentHubBookingSlotResponse = zod.object({
  "service": zod.string().min(1).max(updateContentHubBookingSlotResponseOneServiceMax),
  "description": zod.string().max(updateContentHubBookingSlotResponseOneDescriptionMax).nullish(),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "timezone": zod.string().min(1).max(updateContentHubBookingSlotResponseOneTimezoneMax),
  "capacity": zod.int().min(1).max(updateContentHubBookingSlotResponseOneCapacityMax),
  "active": zod.boolean().default(updateContentHubBookingSlotResponseOneActiveDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "reserved": zod.int().min(updateContentHubBookingSlotResponseTwoReservedMin),
  "remaining": zod.int().min(updateContentHubBookingSlotResponseTwoRemainingMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List generated and manually created Content Hub assets
 */
export const listContentHubAssetsQueryLimitDefault = 25;
export const listContentHubAssetsQueryLimitMax = 100;

export const listContentHubAssetsQueryOffsetDefault = 0;
export const listContentHubAssetsQueryOffsetMin = 0;



export const listContentHubAssetsQueryParams = zod.object({
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']).optional(),
  "limit": zod.int().min(1).max(listContentHubAssetsQueryLimitMax).default(listContentHubAssetsQueryLimitDefault),
  "offset": zod.int().min(listContentHubAssetsQueryOffsetMin).default(listContentHubAssetsQueryOffsetDefault)
})

export const listContentHubAssetsResponseItemsItemOneTitleMax = 300;

export const listContentHubAssetsResponseItemsItemOneContentMax = 30000;

export const listContentHubAssetsResponseItemsItemOneStatusDefault = `draft`;
export const listContentHubAssetsResponseTotalMin = 0;


export const listContentHubAssetsResponseOffsetMin = 0;



export const listContentHubAssetsResponse = zod.object({
  "items": zod.array(zod.object({
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']),
  "title": zod.string().min(1).max(listContentHubAssetsResponseItemsItemOneTitleMax),
  "content": zod.string().min(1).max(listContentHubAssetsResponseItemsItemOneContentMax),
  "status": zod.enum(['draft', 'approved', 'archived']).default(listContentHubAssetsResponseItemsItemOneStatusDefault),
  "metadata": zod.record(zod.string(), zod.unknown()).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "publicEnabled": zod.boolean(),
  "aiAuditId": zod.uuid().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listContentHubAssetsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubAssetsResponseOffsetMin)
})


/**
 * @summary Create a Content Hub asset
 */
export const createContentHubAssetBodyTitleMax = 300;

export const createContentHubAssetBodyContentMax = 30000;

export const createContentHubAssetBodyStatusDefault = `draft`;

export const createContentHubAssetBody = zod.object({
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']),
  "title": zod.string().min(1).max(createContentHubAssetBodyTitleMax),
  "content": zod.string().min(1).max(createContentHubAssetBodyContentMax),
  "status": zod.enum(['draft', 'approved', 'archived']).default(createContentHubAssetBodyStatusDefault),
  "metadata": zod.record(zod.string(), zod.unknown()).optional()
})

export const createContentHubAssetResponseOneTitleMax = 300;

export const createContentHubAssetResponseOneContentMax = 30000;

export const createContentHubAssetResponseOneStatusDefault = `draft`;


export const createContentHubAssetResponse = zod.object({
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']),
  "title": zod.string().min(1).max(createContentHubAssetResponseOneTitleMax),
  "content": zod.string().min(1).max(createContentHubAssetResponseOneContentMax),
  "status": zod.enum(['draft', 'approved', 'archived']).default(createContentHubAssetResponseOneStatusDefault),
  "metadata": zod.record(zod.string(), zod.unknown()).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "publicEnabled": zod.boolean(),
  "aiAuditId": zod.uuid().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Generate a brand-grounded Content Hub asset for human review
 */
export const generateContentHubAssetBodyTopicMax = 2000;

export const generateContentHubAssetBodyFormatMax = 200;

export const generateContentHubAssetBodySourceFactsMax = 10000;



export const generateContentHubAssetBody = zod.object({
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']),
  "topic": zod.string().min(1).max(generateContentHubAssetBodyTopicMax),
  "format": zod.string().max(generateContentHubAssetBodyFormatMax).optional(),
  "sourceFacts": zod.string().max(generateContentHubAssetBodySourceFactsMax).optional()
})

export const generateContentHubAssetResponseOneOneTitleMax = 300;

export const generateContentHubAssetResponseOneOneContentMax = 30000;

export const generateContentHubAssetResponseOneOneStatusDefault = `draft`;


export const generateContentHubAssetResponse = zod.object({
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']),
  "title": zod.string().min(1).max(generateContentHubAssetResponseOneOneTitleMax),
  "content": zod.string().min(1).max(generateContentHubAssetResponseOneOneContentMax),
  "status": zod.enum(['draft', 'approved', 'archived']).default(generateContentHubAssetResponseOneOneStatusDefault),
  "metadata": zod.record(zod.string(), zod.unknown()).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "publicEnabled": zod.boolean(),
  "aiAuditId": zod.uuid().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).and(zod.object({
  "sources": zod.array(zod.object({
  "knowledgeFileId": zod.uuid(),
  "title": zod.string(),
  "location": zod.string(),
  "score": zod.number()
})),
  "knowledgeState": zod.enum(['ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence'])
}))


/**
 * @summary Get an entity-scoped reusable asset
 */
export const getContentHubAssetParams = zod.object({
  "id": zod.uuid()
})

export const getContentHubAssetResponseOneTitleMax = 300;

export const getContentHubAssetResponseOneContentMax = 30000;

export const getContentHubAssetResponseOneStatusDefault = `draft`;


export const getContentHubAssetResponse = zod.object({
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']),
  "title": zod.string().min(1).max(getContentHubAssetResponseOneTitleMax),
  "content": zod.string().min(1).max(getContentHubAssetResponseOneContentMax),
  "status": zod.enum(['draft', 'approved', 'archived']).default(getContentHubAssetResponseOneStatusDefault),
  "metadata": zod.record(zod.string(), zod.unknown()).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "publicEnabled": zod.boolean(),
  "aiAuditId": zod.uuid().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update an asset using optimistic version control
 */
export const updateContentHubAssetParams = zod.object({
  "id": zod.uuid()
})


export const updateContentHubAssetBodyTitleMax = 300;

export const updateContentHubAssetBodyContentMax = 30000;



export const updateContentHubAssetBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "title": zod.string().min(1).max(updateContentHubAssetBodyTitleMax).optional(),
  "content": zod.string().min(1).max(updateContentHubAssetBodyContentMax).optional(),
  "status": zod.enum(['draft', 'approved', 'archived']).optional(),
  "metadata": zod.record(zod.string(), zod.unknown()).optional(),
  "publicEnabled": zod.boolean().optional()
})

export const updateContentHubAssetResponseOneTitleMax = 300;

export const updateContentHubAssetResponseOneContentMax = 30000;

export const updateContentHubAssetResponseOneStatusDefault = `draft`;


export const updateContentHubAssetResponse = zod.object({
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']),
  "title": zod.string().min(1).max(updateContentHubAssetResponseOneTitleMax),
  "content": zod.string().min(1).max(updateContentHubAssetResponseOneContentMax),
  "status": zod.enum(['draft', 'approved', 'archived']).default(updateContentHubAssetResponseOneStatusDefault),
  "metadata": zod.record(zod.string(), zod.unknown()).optional()
}).and(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "publicEnabled": zod.boolean(),
  "aiAuditId": zod.uuid().nullable(),
  "createdBy": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List immutable asset versions
 */
export const listContentHubAssetVersionsParams = zod.object({
  "id": zod.uuid()
})

export const listContentHubAssetVersionsQueryLimitDefault = 25;
export const listContentHubAssetVersionsQueryLimitMax = 100;

export const listContentHubAssetVersionsQueryOffsetDefault = 0;
export const listContentHubAssetVersionsQueryOffsetMin = 0;



export const listContentHubAssetVersionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listContentHubAssetVersionsQueryLimitMax).default(listContentHubAssetVersionsQueryLimitDefault),
  "offset": zod.int().min(listContentHubAssetVersionsQueryOffsetMin).default(listContentHubAssetVersionsQueryOffsetDefault)
})


export const listContentHubAssetVersionsResponseTotalMin = 0;


export const listContentHubAssetVersionsResponseOffsetMin = 0;



export const listContentHubAssetVersionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "assetId": zod.uuid(),
  "version": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string(),
  "status": zod.enum(['draft', 'approved', 'archived']),
  "metadata": zod.record(zod.string(), zod.unknown()),
  "provenance": zod.record(zod.string(), zod.unknown()),
  "action": zod.enum(['created', 'generated', 'updated', 'published', 'unpublished']),
  "actor": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listContentHubAssetVersionsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubAssetVersionsResponseOffsetMin)
})


/**
 * @summary Reuse an asset in the shared social post editor
 */
export const reuseContentHubAssetParams = zod.object({
  "id": zod.uuid()
})




export const reuseContentHubAssetBody = zod.object({
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1)
})

export const reuseContentHubAssetResponseOneTitleMax = 200;

export const reuseContentHubAssetResponseOneContentMax = 10000;


export const reuseContentHubAssetResponseOneMediaAssetIdsMax = 10;


export const reuseContentHubAssetResponseTwoRevisionCountMin = 0;

export const reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const reuseContentHubAssetResponseTwoPublishResultsItemAttemptCountMin = 0;



export const reuseContentHubAssetResponse = zod.object({
  "title": zod.string().min(1).max(reuseContentHubAssetResponseOneTitleMax),
  "content": zod.string().min(1).max(reuseContentHubAssetResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(reuseContentHubAssetResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(reuseContentHubAssetResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(reuseContentHubAssetResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(reuseContentHubAssetResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Export an asset with provenance metadata
 */
export const exportContentHubAssetParams = zod.object({
  "id": zod.uuid()
})

export const exportContentHubAssetResponse = zod.object({
  "filename": zod.string(),
  "mediaType": zod.enum(['text/markdown']),
  "content": zod.string(),
  "provenance": zod.record(zod.string(), zod.unknown())
})


/**
 * @summary List configured local intelligence sources and readiness
 */
export const listContentHubIntelligenceSourcesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "kind": zod.enum(['manual_observation', 'internal_history', 'platform_analytics', 'weather', 'local_authority', 'industry_news']),
  "status": zod.enum(['active', 'paused', 'unavailable']),
  "setupMessage": zod.string().nullable(),
  "createdBy": zod.string(),
  "lastIngestedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Configure an approved intelligence source
 */
export const createContentHubIntelligenceSourceBodyNameMax = 200;



export const createContentHubIntelligenceSourceBody = zod.object({
  "name": zod.string().min(1).max(createContentHubIntelligenceSourceBodyNameMax),
  "kind": zod.enum(['manual_observation', 'internal_history', 'platform_analytics', 'weather', 'local_authority', 'industry_news'])
})

export const createContentHubIntelligenceSourceResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "kind": zod.enum(['manual_observation', 'internal_history', 'platform_analytics', 'weather', 'local_authority', 'industry_news']),
  "status": zod.enum(['active', 'paused', 'unavailable']),
  "setupMessage": zod.string().nullable(),
  "createdBy": zod.string(),
  "lastIngestedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Pause or resume an intelligence source
 */
export const updateContentHubIntelligenceSourceParams = zod.object({
  "id": zod.uuid()
})

export const updateContentHubIntelligenceSourceBody = zod.object({
  "status": zod.enum(['active', 'paused'])
})

export const updateContentHubIntelligenceSourceResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "kind": zod.enum(['manual_observation', 'internal_history', 'platform_analytics', 'weather', 'local_authority', 'industry_news']),
  "status": zod.enum(['active', 'paused', 'unavailable']),
  "setupMessage": zod.string().nullable(),
  "createdBy": zod.string(),
  "lastIngestedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Ingest a bounded batch of untrusted attributed intelligence
 */
export const ingestContentHubIntelligenceParams = zod.object({
  "id": zod.uuid()
})

export const ingestContentHubIntelligenceBodyItemsItemExternalIdMax = 500;

export const ingestContentHubIntelligenceBodyItemsItemTitleMax = 500;

export const ingestContentHubIntelligenceBodyItemsItemSummaryMax = 5000;

export const ingestContentHubIntelligenceBodyItemsItemSourceUrlMax = 2000;

export const ingestContentHubIntelligenceBodyItemsItemRelevanceDefault = 50;
export const ingestContentHubIntelligenceBodyItemsItemRelevanceMin = 0;
export const ingestContentHubIntelligenceBodyItemsItemRelevanceMax = 100;

export const ingestContentHubIntelligenceBodyItemsMax = 50;



export const ingestContentHubIntelligenceBody = zod.object({
  "items": zod.array(zod.object({
  "externalId": zod.string().max(ingestContentHubIntelligenceBodyItemsItemExternalIdMax).optional(),
  "title": zod.string().min(1).max(ingestContentHubIntelligenceBodyItemsItemTitleMax),
  "summary": zod.string().min(1).max(ingestContentHubIntelligenceBodyItemsItemSummaryMax),
  "sourceUrl": zod.url().max(ingestContentHubIntelligenceBodyItemsItemSourceUrlMax).optional(),
  "occurredAt": zod.iso.datetime({"offset":true}).optional(),
  "relevance": zod.int().min(ingestContentHubIntelligenceBodyItemsItemRelevanceMin).max(ingestContentHubIntelligenceBodyItemsItemRelevanceMax).default(ingestContentHubIntelligenceBodyItemsItemRelevanceDefault)
})).min(1).max(ingestContentHubIntelligenceBodyItemsMax)
})

export const ingestContentHubIntelligenceResponseCreatedMin = 0;

export const ingestContentHubIntelligenceResponseDuplicatesMin = 0;



export const ingestContentHubIntelligenceResponse = zod.object({
  "created": zod.int().min(ingestContentHubIntelligenceResponseCreatedMin),
  "duplicates": zod.int().min(ingestContentHubIntelligenceResponseDuplicatesMin)
})


/**
 * @summary List attributed intelligence awaiting or after review
 */
export const listContentHubIntelligenceItemsQueryLimitDefault = 25;
export const listContentHubIntelligenceItemsQueryLimitMax = 100;

export const listContentHubIntelligenceItemsQueryOffsetDefault = 0;
export const listContentHubIntelligenceItemsQueryOffsetMin = 0;



export const listContentHubIntelligenceItemsQueryParams = zod.object({
  "status": zod.enum(['pending_review', 'reviewed', 'converting', 'rejected', 'converted']).optional(),
  "limit": zod.int().min(1).max(listContentHubIntelligenceItemsQueryLimitMax).default(listContentHubIntelligenceItemsQueryLimitDefault),
  "offset": zod.int().min(listContentHubIntelligenceItemsQueryOffsetMin).default(listContentHubIntelligenceItemsQueryOffsetDefault)
})

export const listContentHubIntelligenceItemsResponseItemsItemRelevanceMin = 0;
export const listContentHubIntelligenceItemsResponseItemsItemRelevanceMax = 100;

export const listContentHubIntelligenceItemsResponseTotalMin = 0;


export const listContentHubIntelligenceItemsResponseOffsetMin = 0;



export const listContentHubIntelligenceItemsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "sourceName": zod.string(),
  "sourceKind": zod.enum(['manual_observation', 'internal_history', 'platform_analytics', 'weather', 'local_authority', 'industry_news']),
  "externalId": zod.string().nullable(),
  "fingerprint": zod.string(),
  "title": zod.string(),
  "summary": zod.string(),
  "sourceUrl": zod.string().nullable(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullable(),
  "relevance": zod.int().min(listContentHubIntelligenceItemsResponseItemsItemRelevanceMin).max(listContentHubIntelligenceItemsResponseItemsItemRelevanceMax),
  "status": zod.enum(['pending_review', 'reviewed', 'converting', 'rejected', 'converted']),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "convertedPostId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listContentHubIntelligenceItemsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubIntelligenceItemsResponseOffsetMin)
})


/**
 * @summary Record an explicit human review decision
 */
export const reviewContentHubIntelligenceItemParams = zod.object({
  "id": zod.uuid()
})

export const reviewContentHubIntelligenceItemBody = zod.object({
  "decision": zod.enum(['reviewed', 'rejected'])
})

export const reviewContentHubIntelligenceItemResponseRelevanceMin = 0;
export const reviewContentHubIntelligenceItemResponseRelevanceMax = 100;



export const reviewContentHubIntelligenceItemResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "sourceName": zod.string(),
  "sourceKind": zod.enum(['manual_observation', 'internal_history', 'platform_analytics', 'weather', 'local_authority', 'industry_news']),
  "externalId": zod.string().nullable(),
  "fingerprint": zod.string(),
  "title": zod.string(),
  "summary": zod.string(),
  "sourceUrl": zod.string().nullable(),
  "occurredAt": zod.iso.datetime({"offset":true}).nullable(),
  "relevance": zod.int().min(reviewContentHubIntelligenceItemResponseRelevanceMin).max(reviewContentHubIntelligenceItemResponseRelevanceMax),
  "status": zod.enum(['pending_review', 'reviewed', 'converting', 'rejected', 'converted']),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "convertedPostId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Convert a reviewed item to a standard social draft
 */
export const convertContentHubIntelligenceItemParams = zod.object({
  "id": zod.uuid()
})




export const convertContentHubIntelligenceItemBody = zod.object({
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1)
})

export const convertContentHubIntelligenceItemResponseOneTitleMax = 200;

export const convertContentHubIntelligenceItemResponseOneContentMax = 10000;


export const convertContentHubIntelligenceItemResponseOneMediaAssetIdsMax = 10;


export const convertContentHubIntelligenceItemResponseTwoRevisionCountMin = 0;

export const convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const convertContentHubIntelligenceItemResponseTwoPublishResultsItemAttemptCountMin = 0;



export const convertContentHubIntelligenceItemResponse = zod.object({
  "title": zod.string().min(1).max(convertContentHubIntelligenceItemResponseOneTitleMax),
  "content": zod.string().min(1).max(convertContentHubIntelligenceItemResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(convertContentHubIntelligenceItemResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(convertContentHubIntelligenceItemResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(convertContentHubIntelligenceItemResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(convertContentHubIntelligenceItemResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List advertising product and account readiness without exposing credentials
 */
export const listContentHubAdvertisingProvidersResponse = zod.object({
  "verifiedAt": zod.iso.date(),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "items": zod.array(zod.object({
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "label": zod.string(),
  "providerSupport": zod.enum(['supported', 'restricted', 'unsupported']),
  "implementationStatus": zod.enum(['available', 'partial', 'planned']),
  "readiness": zod.enum(['ready', 'connection_required', 'provider_approval_required', 'adapter_unavailable', 'unsupported']),
  "connectionId": zod.uuid().nullable(),
  "displayName": zod.string().nullable(),
  "grantedCapabilities": zod.array(zod.string()),
  "detail": zod.string(),
  "setupRequirements": zod.array(zod.record(zod.string(), zod.unknown()))
}))
})


/**
 * @summary List entity-scoped advertising campaigns
 */
export const listContentHubAdvertisingCampaignsQueryLimitDefault = 25;
export const listContentHubAdvertisingCampaignsQueryLimitMax = 100;

export const listContentHubAdvertisingCampaignsQueryOffsetDefault = 0;
export const listContentHubAdvertisingCampaignsQueryOffsetMin = 0;



export const listContentHubAdvertisingCampaignsQueryParams = zod.object({
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']).optional(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']).optional(),
  "limit": zod.int().min(1).max(listContentHubAdvertisingCampaignsQueryLimitMax).default(listContentHubAdvertisingCampaignsQueryLimitDefault),
  "offset": zod.int().min(listContentHubAdvertisingCampaignsQueryOffsetMin).default(listContentHubAdvertisingCampaignsQueryOffsetDefault)
})

export const listContentHubAdvertisingCampaignsResponseItemsItemOneNameMax = 200;

export const listContentHubAdvertisingCampaignsResponseItemsItemOneAdAccountIdMin = 2;
export const listContentHubAdvertisingCampaignsResponseItemsItemOneAdAccountIdMax = 200;


export const listContentHubAdvertisingCampaignsResponseItemsItemOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const listContentHubAdvertisingCampaignsResponseItemsItemOneBudgetMinorMin = 500;
export const listContentHubAdvertisingCampaignsResponseItemsItemOneBudgetMinorMax = 10000000;

export const listContentHubAdvertisingCampaignsResponseItemsItemOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listContentHubAdvertisingCampaignsResponseItemsItemOneCtaUrlRegExp = new RegExp('^https:/');
export const listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceLocationsItemMin = 2;
export const listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceLocationsItemMax = 120;

export const listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceLocationsMax = 25;

export const listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceAgeMinMin = 18;
export const listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceAgeMinMax = 65;

export const listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceAgeMaxMin = 18;
export const listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceAgeMaxMax = 65;

export const listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceInterestsItemMax = 120;

export const listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceInterestsMax = 25;

export const listContentHubAdvertisingCampaignsResponseItemsItemOneCreativeTextMax = 5000;




export const listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsImpressionsMin = 0;

export const listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsReachMin = 0;

export const listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsClicksMin = 0;

export const listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsEngagementsMin = 0;

export const listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsLeadsMin = 0;

export const listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsConversionsMin = 0;

export const listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsSpendMinorMin = 0;

export const listContentHubAdvertisingCampaignsResponseTotalMin = 0;


export const listContentHubAdvertisingCampaignsResponseOffsetMin = 0;



export const listContentHubAdvertisingCampaignsResponse = zod.object({
  "items": zod.array(zod.object({
  "name": zod.string().min(1).max(listContentHubAdvertisingCampaignsResponseItemsItemOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(listContentHubAdvertisingCampaignsResponseItemsItemOneAdAccountIdMin).max(listContentHubAdvertisingCampaignsResponseItemsItemOneAdAccountIdMax).regex(listContentHubAdvertisingCampaignsResponseItemsItemOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemOneBudgetMinorMin).max(listContentHubAdvertisingCampaignsResponseItemsItemOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(listContentHubAdvertisingCampaignsResponseItemsItemOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(listContentHubAdvertisingCampaignsResponseItemsItemOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceLocationsItemMin).max(listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceLocationsItemMax)).min(1).max(listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceLocationsMax),
  "ageMin": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceAgeMinMin).max(listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceAgeMinMax),
  "ageMax": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceAgeMaxMin).max(listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceInterestsItemMax)).max(listContentHubAdvertisingCampaignsResponseItemsItemOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(listContentHubAdvertisingCampaignsResponseItemsItemOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(listContentHubAdvertisingCampaignsResponseItemsItemTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listContentHubAdvertisingCampaignsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubAdvertisingCampaignsResponseOffsetMin)
})


/**
 * @summary Create an inert advertising draft from approved content
 */
export const createContentHubAdvertisingCampaignBodyNameMax = 200;

export const createContentHubAdvertisingCampaignBodyAdAccountIdMin = 2;
export const createContentHubAdvertisingCampaignBodyAdAccountIdMax = 200;


export const createContentHubAdvertisingCampaignBodyAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const createContentHubAdvertisingCampaignBodyBudgetMinorMin = 500;
export const createContentHubAdvertisingCampaignBodyBudgetMinorMax = 10000000;

export const createContentHubAdvertisingCampaignBodyCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const createContentHubAdvertisingCampaignBodyCtaUrlRegExp = new RegExp('^https:/');
export const createContentHubAdvertisingCampaignBodyAudienceLocationsItemMin = 2;
export const createContentHubAdvertisingCampaignBodyAudienceLocationsItemMax = 120;

export const createContentHubAdvertisingCampaignBodyAudienceLocationsMax = 25;

export const createContentHubAdvertisingCampaignBodyAudienceAgeMinMin = 18;
export const createContentHubAdvertisingCampaignBodyAudienceAgeMinMax = 65;

export const createContentHubAdvertisingCampaignBodyAudienceAgeMaxMin = 18;
export const createContentHubAdvertisingCampaignBodyAudienceAgeMaxMax = 65;

export const createContentHubAdvertisingCampaignBodyAudienceInterestsItemMax = 120;

export const createContentHubAdvertisingCampaignBodyAudienceInterestsMax = 25;

export const createContentHubAdvertisingCampaignBodyCreativeTextMax = 5000;



export const createContentHubAdvertisingCampaignBody = zod.object({
  "name": zod.string().min(1).max(createContentHubAdvertisingCampaignBodyNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(createContentHubAdvertisingCampaignBodyAdAccountIdMin).max(createContentHubAdvertisingCampaignBodyAdAccountIdMax).regex(createContentHubAdvertisingCampaignBodyAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(createContentHubAdvertisingCampaignBodyBudgetMinorMin).max(createContentHubAdvertisingCampaignBodyBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(createContentHubAdvertisingCampaignBodyCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(createContentHubAdvertisingCampaignBodyCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(createContentHubAdvertisingCampaignBodyAudienceLocationsItemMin).max(createContentHubAdvertisingCampaignBodyAudienceLocationsItemMax)).min(1).max(createContentHubAdvertisingCampaignBodyAudienceLocationsMax),
  "ageMin": zod.int().min(createContentHubAdvertisingCampaignBodyAudienceAgeMinMin).max(createContentHubAdvertisingCampaignBodyAudienceAgeMinMax),
  "ageMax": zod.int().min(createContentHubAdvertisingCampaignBodyAudienceAgeMaxMin).max(createContentHubAdvertisingCampaignBodyAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(createContentHubAdvertisingCampaignBodyAudienceInterestsItemMax)).max(createContentHubAdvertisingCampaignBodyAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(createContentHubAdvertisingCampaignBodyCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
})

export const createContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const createContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const createContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const createContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const createContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const createContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const createContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const createContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const createContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const createContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const createContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const createContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const createContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const createContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const createContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const createContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const createContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const createContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const createContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const createContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const createContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const createContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const createContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const createContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const createContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const createContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(createContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(createContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(createContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(createContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(createContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(createContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(createContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(createContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(createContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(createContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(createContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(createContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(createContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(createContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(createContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(createContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(createContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(createContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(createContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(createContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(createContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(createContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(createContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(createContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(createContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Get campaign settings and sourced provider result
 */
export const getContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})

export const getContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const getContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const getContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const getContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const getContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const getContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const getContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const getContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const getContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const getContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const getContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const getContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const getContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const getContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const getContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const getContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const getContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const getContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const getContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const getContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const getContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const getContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const getContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const getContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const getContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(getContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(getContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(getContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(getContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(getContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(getContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(getContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(getContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(getContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(getContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(getContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(getContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(getContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(getContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(getContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(getContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(getContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(getContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(getContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(getContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(getContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(getContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(getContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(getContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(getContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Create a new immutable settings version and clear approval
 */
export const updateContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})


export const updateContentHubAdvertisingCampaignBodyNameMax = 200;

export const updateContentHubAdvertisingCampaignBodyAdAccountIdMin = 2;
export const updateContentHubAdvertisingCampaignBodyAdAccountIdMax = 200;


export const updateContentHubAdvertisingCampaignBodyAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const updateContentHubAdvertisingCampaignBodyBudgetMinorMin = 500;
export const updateContentHubAdvertisingCampaignBodyBudgetMinorMax = 10000000;

export const updateContentHubAdvertisingCampaignBodyCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const updateContentHubAdvertisingCampaignBodyCtaUrlRegExp = new RegExp('^https:/');
export const updateContentHubAdvertisingCampaignBodyAudienceLocationsItemMin = 2;
export const updateContentHubAdvertisingCampaignBodyAudienceLocationsItemMax = 120;

export const updateContentHubAdvertisingCampaignBodyAudienceLocationsMax = 25;

export const updateContentHubAdvertisingCampaignBodyAudienceAgeMinMin = 18;
export const updateContentHubAdvertisingCampaignBodyAudienceAgeMinMax = 65;

export const updateContentHubAdvertisingCampaignBodyAudienceAgeMaxMin = 18;
export const updateContentHubAdvertisingCampaignBodyAudienceAgeMaxMax = 65;

export const updateContentHubAdvertisingCampaignBodyAudienceInterestsItemMax = 120;

export const updateContentHubAdvertisingCampaignBodyAudienceInterestsMax = 25;

export const updateContentHubAdvertisingCampaignBodyCreativeTextMax = 5000;



export const updateContentHubAdvertisingCampaignBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "name": zod.string().min(1).max(updateContentHubAdvertisingCampaignBodyNameMax).optional(),
  "adAccountId": zod.string().min(updateContentHubAdvertisingCampaignBodyAdAccountIdMin).max(updateContentHubAdvertisingCampaignBodyAdAccountIdMax).regex(updateContentHubAdvertisingCampaignBodyAdAccountIdRegExp).optional(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']).optional(),
  "budgetType": zod.enum(['daily', 'lifetime']).optional(),
  "budgetMinor": zod.int().min(updateContentHubAdvertisingCampaignBodyBudgetMinorMin).max(updateContentHubAdvertisingCampaignBodyBudgetMinorMax).optional(),
  "currency": zod.string().regex(updateContentHubAdvertisingCampaignBodyCurrencyRegExp).optional(),
  "startsAt": zod.iso.datetime({"offset":true}).optional(),
  "endsAt": zod.iso.datetime({"offset":true}).optional(),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']).optional(),
  "ctaUrl": zod.url().regex(updateContentHubAdvertisingCampaignBodyCtaUrlRegExp).optional(),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(updateContentHubAdvertisingCampaignBodyAudienceLocationsItemMin).max(updateContentHubAdvertisingCampaignBodyAudienceLocationsItemMax)).min(1).max(updateContentHubAdvertisingCampaignBodyAudienceLocationsMax),
  "ageMin": zod.int().min(updateContentHubAdvertisingCampaignBodyAudienceAgeMinMin).max(updateContentHubAdvertisingCampaignBodyAudienceAgeMinMax),
  "ageMax": zod.int().min(updateContentHubAdvertisingCampaignBodyAudienceAgeMaxMin).max(updateContentHubAdvertisingCampaignBodyAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(updateContentHubAdvertisingCampaignBodyAudienceInterestsItemMax)).max(updateContentHubAdvertisingCampaignBodyAudienceInterestsMax)
}).optional(),
  "creativeText": zod.string().min(1).max(updateContentHubAdvertisingCampaignBodyCreativeTextMax).optional(),
  "mediaAssetId": zod.uuid().nullish()
})

export const updateContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const updateContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const updateContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const updateContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const updateContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const updateContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const updateContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const updateContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const updateContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const updateContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const updateContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const updateContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const updateContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const updateContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const updateContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const updateContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const updateContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const updateContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const updateContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const updateContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const updateContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const updateContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const updateContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const updateContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const updateContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const updateContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(updateContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(updateContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(updateContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(updateContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(updateContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(updateContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(updateContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(updateContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(updateContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(updateContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(updateContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(updateContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(updateContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(updateContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(updateContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(updateContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(updateContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(updateContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(updateContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(updateContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(updateContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(updateContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(updateContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(updateContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(updateContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List immutable advertising settings history
 */
export const listContentHubAdvertisingCampaignVersionsParams = zod.object({
  "id": zod.uuid()
})

export const listContentHubAdvertisingCampaignVersionsQueryLimitDefault = 25;
export const listContentHubAdvertisingCampaignVersionsQueryLimitMax = 100;

export const listContentHubAdvertisingCampaignVersionsQueryOffsetDefault = 0;
export const listContentHubAdvertisingCampaignVersionsQueryOffsetMin = 0;



export const listContentHubAdvertisingCampaignVersionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listContentHubAdvertisingCampaignVersionsQueryLimitMax).default(listContentHubAdvertisingCampaignVersionsQueryLimitDefault),
  "offset": zod.int().min(listContentHubAdvertisingCampaignVersionsQueryOffsetMin).default(listContentHubAdvertisingCampaignVersionsQueryOffsetDefault)
})


export const listContentHubAdvertisingCampaignVersionsResponseItemsItemBudgetMinorMin = 500;
export const listContentHubAdvertisingCampaignVersionsResponseItemsItemBudgetMinorMax = 10000000;

export const listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceLocationsItemMin = 2;
export const listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceLocationsItemMax = 120;

export const listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceLocationsMax = 25;

export const listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceAgeMinMin = 18;
export const listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceAgeMinMax = 65;

export const listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceAgeMaxMin = 18;
export const listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceAgeMaxMax = 65;

export const listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceInterestsItemMax = 120;

export const listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceInterestsMax = 25;

export const listContentHubAdvertisingCampaignVersionsResponseTotalMin = 0;


export const listContentHubAdvertisingCampaignVersionsResponseOffsetMin = 0;



export const listContentHubAdvertisingCampaignVersionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "campaignId": zod.uuid(),
  "version": zod.int().min(1),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(listContentHubAdvertisingCampaignVersionsResponseItemsItemBudgetMinorMin).max(listContentHubAdvertisingCampaignVersionsResponseItemsItemBudgetMinorMax),
  "currency": zod.string(),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.string(),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceLocationsItemMin).max(listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceLocationsItemMax)).min(1).max(listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceLocationsMax),
  "ageMin": zod.int().min(listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceAgeMinMin).max(listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceAgeMinMax),
  "ageMax": zod.int().min(listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceAgeMaxMin).max(listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceInterestsItemMax)).max(listContentHubAdvertisingCampaignVersionsResponseItemsItemAudienceInterestsMax)
}),
  "creativeText": zod.string(),
  "mediaAssetId": zod.uuid().nullable(),
  "action": zod.enum(['created', 'edited', 'submitted', 'approved', 'rejected']),
  "actor": zod.string(),
  "note": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listContentHubAdvertisingCampaignVersionsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubAdvertisingCampaignVersionsResponseOffsetMin)
})


/**
 * @summary List provider lifecycle attempts and outcomes
 */
export const listContentHubAdvertisingCampaignAttemptsParams = zod.object({
  "id": zod.uuid()
})

export const listContentHubAdvertisingCampaignAttemptsQueryLimitDefault = 25;
export const listContentHubAdvertisingCampaignAttemptsQueryLimitMax = 100;

export const listContentHubAdvertisingCampaignAttemptsQueryOffsetDefault = 0;
export const listContentHubAdvertisingCampaignAttemptsQueryOffsetMin = 0;



export const listContentHubAdvertisingCampaignAttemptsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listContentHubAdvertisingCampaignAttemptsQueryLimitMax).default(listContentHubAdvertisingCampaignAttemptsQueryLimitDefault),
  "offset": zod.int().min(listContentHubAdvertisingCampaignAttemptsQueryOffsetMin).default(listContentHubAdvertisingCampaignAttemptsQueryOffsetDefault)
})


export const listContentHubAdvertisingCampaignAttemptsResponseTotalMin = 0;


export const listContentHubAdvertisingCampaignAttemptsResponseOffsetMin = 0;



export const listContentHubAdvertisingCampaignAttemptsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "campaignId": zod.uuid(),
  "campaignVersion": zod.int().min(1),
  "operation": zod.enum(['launch', 'pause', 'resume', 'cancel', 'sync']),
  "requestId": zod.uuid(),
  "actor": zod.string(),
  "status": zod.enum(['started', 'succeeded', 'failed', 'unavailable', 'uncertain']),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "startedAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listContentHubAdvertisingCampaignAttemptsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubAdvertisingCampaignAttemptsResponseOffsetMin)
})


/**
 * @summary Submit the current inert draft for approval
 */
export const submitContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})


export const submitContentHubAdvertisingCampaignBodyNoteMin = 3;
export const submitContentHubAdvertisingCampaignBodyNoteMax = 500;



export const submitContentHubAdvertisingCampaignBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "note": zod.string().min(submitContentHubAdvertisingCampaignBodyNoteMin).max(submitContentHubAdvertisingCampaignBodyNoteMax).optional()
})

export const submitContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const submitContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const submitContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const submitContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const submitContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const submitContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const submitContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const submitContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const submitContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const submitContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const submitContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const submitContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const submitContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const submitContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const submitContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const submitContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const submitContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const submitContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const submitContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const submitContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const submitContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const submitContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const submitContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const submitContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const submitContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const submitContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(submitContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(submitContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(submitContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(submitContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(submitContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(submitContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(submitContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(submitContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(submitContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(submitContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(submitContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(submitContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(submitContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(submitContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(submitContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(submitContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(submitContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(submitContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(submitContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(submitContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(submitContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(submitContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(submitContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(submitContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(submitContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Approve the immutable current settings as the authenticated actor
 */
export const approveContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})


export const approveContentHubAdvertisingCampaignBodyNoteMin = 3;
export const approveContentHubAdvertisingCampaignBodyNoteMax = 500;



export const approveContentHubAdvertisingCampaignBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "note": zod.string().min(approveContentHubAdvertisingCampaignBodyNoteMin).max(approveContentHubAdvertisingCampaignBodyNoteMax).optional()
})

export const approveContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const approveContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const approveContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const approveContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const approveContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const approveContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const approveContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const approveContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const approveContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const approveContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const approveContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const approveContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const approveContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const approveContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const approveContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const approveContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const approveContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const approveContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const approveContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const approveContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const approveContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const approveContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const approveContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const approveContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const approveContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const approveContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(approveContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(approveContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(approveContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(approveContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(approveContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(approveContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(approveContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(approveContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(approveContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(approveContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(approveContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(approveContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(approveContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(approveContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(approveContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(approveContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(approveContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(approveContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(approveContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(approveContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(approveContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(approveContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(approveContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(approveContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(approveContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Reject the current settings back to an inert draft
 */
export const rejectContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})


export const rejectContentHubAdvertisingCampaignBodyReasonMin = 3;
export const rejectContentHubAdvertisingCampaignBodyReasonMax = 500;



export const rejectContentHubAdvertisingCampaignBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "reason": zod.string().min(rejectContentHubAdvertisingCampaignBodyReasonMin).max(rejectContentHubAdvertisingCampaignBodyReasonMax)
})

export const rejectContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const rejectContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const rejectContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const rejectContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const rejectContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const rejectContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const rejectContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const rejectContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const rejectContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const rejectContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const rejectContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const rejectContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const rejectContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const rejectContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const rejectContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const rejectContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const rejectContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const rejectContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const rejectContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(rejectContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(rejectContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(rejectContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(rejectContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(rejectContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(rejectContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(rejectContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(rejectContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(rejectContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(rejectContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(rejectContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(rejectContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(rejectContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(rejectContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(rejectContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(rejectContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(rejectContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(rejectContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(rejectContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Explicitly launch approved settings through an eligible advertising product
 */
export const launchContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})

export const launchContentHubAdvertisingCampaignBody = zod.object({
  "requestId": zod.uuid()
}).and(zod.object({
  "confirmation": zod.enum(['LAUNCH'])
}))

export const launchContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const launchContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const launchContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const launchContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const launchContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const launchContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const launchContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const launchContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const launchContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const launchContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const launchContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const launchContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const launchContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const launchContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const launchContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const launchContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const launchContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const launchContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const launchContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const launchContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const launchContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const launchContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const launchContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const launchContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const launchContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const launchContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(launchContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(launchContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(launchContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(launchContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(launchContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(launchContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(launchContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(launchContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(launchContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(launchContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(launchContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(launchContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(launchContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(launchContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(launchContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(launchContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(launchContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(launchContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(launchContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(launchContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(launchContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(launchContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(launchContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(launchContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(launchContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Pause an active provider campaign
 */
export const pauseContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})

export const pauseContentHubAdvertisingCampaignBody = zod.object({
  "requestId": zod.uuid()
})

export const pauseContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const pauseContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const pauseContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const pauseContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const pauseContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const pauseContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const pauseContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const pauseContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const pauseContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const pauseContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const pauseContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const pauseContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const pauseContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const pauseContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const pauseContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const pauseContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const pauseContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const pauseContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const pauseContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(pauseContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(pauseContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(pauseContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(pauseContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(pauseContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(pauseContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(pauseContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(pauseContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(pauseContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(pauseContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(pauseContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(pauseContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(pauseContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(pauseContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(pauseContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(pauseContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(pauseContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(pauseContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(pauseContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Resume or apply newly approved settings to a paused campaign
 */
export const resumeContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})

export const resumeContentHubAdvertisingCampaignBody = zod.object({
  "requestId": zod.uuid()
})

export const resumeContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const resumeContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const resumeContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const resumeContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const resumeContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const resumeContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const resumeContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const resumeContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const resumeContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const resumeContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const resumeContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const resumeContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const resumeContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const resumeContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const resumeContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const resumeContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const resumeContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const resumeContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const resumeContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(resumeContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(resumeContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(resumeContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(resumeContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(resumeContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(resumeContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(resumeContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(resumeContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(resumeContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(resumeContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(resumeContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(resumeContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(resumeContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(resumeContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(resumeContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(resumeContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(resumeContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(resumeContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(resumeContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Cancel a local draft or provider campaign
 */
export const cancelContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})

export const cancelContentHubAdvertisingCampaignBody = zod.object({
  "requestId": zod.uuid()
})

export const cancelContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const cancelContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const cancelContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const cancelContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const cancelContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const cancelContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const cancelContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const cancelContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const cancelContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const cancelContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const cancelContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const cancelContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const cancelContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const cancelContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const cancelContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const cancelContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const cancelContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const cancelContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const cancelContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(cancelContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(cancelContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(cancelContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(cancelContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(cancelContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(cancelContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(cancelContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(cancelContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(cancelContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(cancelContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(cancelContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(cancelContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(cancelContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(cancelContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(cancelContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(cancelContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(cancelContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(cancelContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(cancelContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Synchronize provider status and sourced metrics
 */
export const syncContentHubAdvertisingCampaignParams = zod.object({
  "id": zod.uuid()
})

export const syncContentHubAdvertisingCampaignBody = zod.object({
  "requestId": zod.uuid()
})

export const syncContentHubAdvertisingCampaignResponseOneNameMax = 200;

export const syncContentHubAdvertisingCampaignResponseOneAdAccountIdMin = 2;
export const syncContentHubAdvertisingCampaignResponseOneAdAccountIdMax = 200;


export const syncContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp = new RegExp('^[A-Za-z0-9:_-]+$');
export const syncContentHubAdvertisingCampaignResponseOneBudgetMinorMin = 500;
export const syncContentHubAdvertisingCampaignResponseOneBudgetMinorMax = 10000000;

export const syncContentHubAdvertisingCampaignResponseOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const syncContentHubAdvertisingCampaignResponseOneCtaUrlRegExp = new RegExp('^https:/');
export const syncContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin = 2;
export const syncContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax = 120;

export const syncContentHubAdvertisingCampaignResponseOneAudienceLocationsMax = 25;

export const syncContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin = 18;
export const syncContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax = 65;

export const syncContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin = 18;
export const syncContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax = 65;

export const syncContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax = 120;

export const syncContentHubAdvertisingCampaignResponseOneAudienceInterestsMax = 25;

export const syncContentHubAdvertisingCampaignResponseOneCreativeTextMax = 5000;




export const syncContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin = 0;

export const syncContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin = 0;

export const syncContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin = 0;

export const syncContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin = 0;

export const syncContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin = 0;

export const syncContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin = 0;

export const syncContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin = 0;



export const syncContentHubAdvertisingCampaignResponse = zod.object({
  "name": zod.string().min(1).max(syncContentHubAdvertisingCampaignResponseOneNameMax),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connectionId": zod.uuid(),
  "adAccountId": zod.string().min(syncContentHubAdvertisingCampaignResponseOneAdAccountIdMin).max(syncContentHubAdvertisingCampaignResponseOneAdAccountIdMax).regex(syncContentHubAdvertisingCampaignResponseOneAdAccountIdRegExp),
  "sourcePostId": zod.uuid(),
  "objective": zod.enum(['awareness', 'traffic', 'engagement', 'leads', 'sales']),
  "budgetType": zod.enum(['daily', 'lifetime']),
  "budgetMinor": zod.int().min(syncContentHubAdvertisingCampaignResponseOneBudgetMinorMin).max(syncContentHubAdvertisingCampaignResponseOneBudgetMinorMax).describe('Budget in minor currency units.'),
  "currency": zod.string().regex(syncContentHubAdvertisingCampaignResponseOneCurrencyRegExp),
  "startsAt": zod.iso.datetime({"offset":true}),
  "endsAt": zod.iso.datetime({"offset":true}),
  "ctaLabel": zod.enum(['learn_more', 'sign_up', 'book_now', 'contact_us']),
  "ctaUrl": zod.url().regex(syncContentHubAdvertisingCampaignResponseOneCtaUrlRegExp),
  "audience": zod.object({
  "locations": zod.array(zod.string().min(syncContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMin).max(syncContentHubAdvertisingCampaignResponseOneAudienceLocationsItemMax)).min(1).max(syncContentHubAdvertisingCampaignResponseOneAudienceLocationsMax),
  "ageMin": zod.int().min(syncContentHubAdvertisingCampaignResponseOneAudienceAgeMinMin).max(syncContentHubAdvertisingCampaignResponseOneAudienceAgeMinMax),
  "ageMax": zod.int().min(syncContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMin).max(syncContentHubAdvertisingCampaignResponseOneAudienceAgeMaxMax),
  "interests": zod.array(zod.string().min(1).max(syncContentHubAdvertisingCampaignResponseOneAudienceInterestsItemMax)).max(syncContentHubAdvertisingCampaignResponseOneAudienceInterestsMax)
}),
  "creativeText": zod.string().min(1).max(syncContentHubAdvertisingCampaignResponseOneCreativeTextMax),
  "mediaAssetId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sourcePostVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'launching', 'active', 'paused', 'completed', 'cancelled', 'failed', 'unavailable', 'uncertain']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "launchedBy": zod.string().nullable(),
  "launchedAt": zod.iso.datetime({"offset":true}).nullable(),
  "providerCampaignId": zod.string().nullable(),
  "providerAdSetId": zod.string().nullable(),
  "providerAdId": zod.string().nullable(),
  "providerStatus": zod.string().nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastError": zod.string().nullable(),
  "latestMetrics": zod.object({
  "impressions": zod.int().min(syncContentHubAdvertisingCampaignResponseTwoLatestMetricsImpressionsMin).optional(),
  "reach": zod.int().min(syncContentHubAdvertisingCampaignResponseTwoLatestMetricsReachMin).optional(),
  "clicks": zod.int().min(syncContentHubAdvertisingCampaignResponseTwoLatestMetricsClicksMin).optional(),
  "engagements": zod.int().min(syncContentHubAdvertisingCampaignResponseTwoLatestMetricsEngagementsMin).optional(),
  "leads": zod.int().min(syncContentHubAdvertisingCampaignResponseTwoLatestMetricsLeadsMin).optional(),
  "conversions": zod.int().min(syncContentHubAdvertisingCampaignResponseTwoLatestMetricsConversionsMin).optional(),
  "spendMinor": zod.int().min(syncContentHubAdvertisingCampaignResponseTwoLatestMetricsSpendMinorMin).optional()
}),
  "metricsSourceAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Get public asset metadata through an active entity binding
 */
export const getPublicContentHubAssetPathSlugMax = 120;



export const getPublicContentHubAssetParams = zod.object({
  "slug": zod.string().min(1).max(getPublicContentHubAssetPathSlugMax),
  "id": zod.uuid()
})

export const getPublicContentHubAssetResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "kind": zod.enum(['lead_magnet', 'testimonial', 'case_study', 'faq', 'operation']),
  "requiresCapture": zod.literal(true)
})


/**
 * @summary Capture consent and deliver an entity-scoped public asset
 */
export const capturePublicContentHubAssetPathSlugMax = 120;



export const capturePublicContentHubAssetParams = zod.object({
  "slug": zod.string().min(1).max(capturePublicContentHubAssetPathSlugMax),
  "id": zod.uuid()
})

export const capturePublicContentHubAssetBodyNameMax = 200;

export const capturePublicContentHubAssetBodyWebsiteDefault = ``;
export const capturePublicContentHubAssetBodyWebsiteMax = 200;



export const capturePublicContentHubAssetBody = zod.object({
  "requestId": zod.uuid(),
  "name": zod.string().min(1).max(capturePublicContentHubAssetBodyNameMax),
  "email": zod.email(),
  "consentToContact": zod.literal(true),
  "website": zod.string().max(capturePublicContentHubAssetBodyWebsiteMax).default(capturePublicContentHubAssetBodyWebsiteDefault)
})




export const capturePublicContentHubAssetResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "content": zod.string(),
  "version": zod.int().min(1),
  "replayed": zod.boolean()
})


/**
 * @summary List review requests and delivery outcomes
 */
export const listContentHubReviewRequestsQueryLimitDefault = 25;
export const listContentHubReviewRequestsQueryLimitMax = 100;

export const listContentHubReviewRequestsQueryOffsetDefault = 0;
export const listContentHubReviewRequestsQueryOffsetMin = 0;



export const listContentHubReviewRequestsQueryParams = zod.object({
  "status": zod.enum(['draft', 'queued', 'sent', 'opened', 'clicked', 'completed', 'failed']).optional(),
  "limit": zod.int().min(1).max(listContentHubReviewRequestsQueryLimitMax).default(listContentHubReviewRequestsQueryLimitDefault),
  "offset": zod.int().min(listContentHubReviewRequestsQueryOffsetMin).default(listContentHubReviewRequestsQueryOffsetDefault)
})

export const listContentHubReviewRequestsResponseItemsItemOneRecipientNameMax = 200;

export const listContentHubReviewRequestsResponseItemsItemOneSubjectMax = 300;

export const listContentHubReviewRequestsResponseItemsItemOneMessageMax = 10000;

export const listContentHubReviewRequestsResponseItemsItemOneReviewUrlMax = 2000;

export const listContentHubReviewRequestsResponseItemsItemTwoSendCountMin = 0;


export const listContentHubReviewRequestsResponseTotalMin = 0;


export const listContentHubReviewRequestsResponseOffsetMin = 0;



export const listContentHubReviewRequestsResponse = zod.object({
  "items": zod.array(zod.object({
  "recipientName": zod.string().min(1).max(listContentHubReviewRequestsResponseItemsItemOneRecipientNameMax),
  "recipientEmail": zod.email(),
  "subject": zod.string().min(1).max(listContentHubReviewRequestsResponseItemsItemOneSubjectMax),
  "message": zod.string().min(1).max(listContentHubReviewRequestsResponseItemsItemOneMessageMax),
  "reviewUrl": zod.url().min(1).max(listContentHubReviewRequestsResponseItemsItemOneReviewUrlMax),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'queued', 'sent', 'opened', 'clicked', 'completed', 'failed']),
  "sentAt": zod.iso.datetime({"offset":true}).nullable(),
  "openedAt": zod.iso.datetime({"offset":true}).nullable(),
  "clickedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "sendCount": zod.int().min(listContentHubReviewRequestsResponseItemsItemTwoSendCountMin),
  "maxSends": zod.int().min(1),
  "nextResendAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastError": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listContentHubReviewRequestsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubReviewRequestsResponseOffsetMin)
})


/**
 * @summary Create a review request draft
 */
export const createContentHubReviewRequestBodyRecipientNameMax = 200;

export const createContentHubReviewRequestBodySubjectMax = 300;

export const createContentHubReviewRequestBodyMessageMax = 10000;

export const createContentHubReviewRequestBodyReviewUrlMax = 2000;



export const createContentHubReviewRequestBody = zod.object({
  "recipientName": zod.string().min(1).max(createContentHubReviewRequestBodyRecipientNameMax),
  "recipientEmail": zod.email(),
  "subject": zod.string().min(1).max(createContentHubReviewRequestBodySubjectMax),
  "message": zod.string().min(1).max(createContentHubReviewRequestBodyMessageMax),
  "reviewUrl": zod.url().min(1).max(createContentHubReviewRequestBodyReviewUrlMax),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
})

export const createContentHubReviewRequestResponseOneRecipientNameMax = 200;

export const createContentHubReviewRequestResponseOneSubjectMax = 300;

export const createContentHubReviewRequestResponseOneMessageMax = 10000;

export const createContentHubReviewRequestResponseOneReviewUrlMax = 2000;

export const createContentHubReviewRequestResponseTwoSendCountMin = 0;




export const createContentHubReviewRequestResponse = zod.object({
  "recipientName": zod.string().min(1).max(createContentHubReviewRequestResponseOneRecipientNameMax),
  "recipientEmail": zod.email(),
  "subject": zod.string().min(1).max(createContentHubReviewRequestResponseOneSubjectMax),
  "message": zod.string().min(1).max(createContentHubReviewRequestResponseOneMessageMax),
  "reviewUrl": zod.url().min(1).max(createContentHubReviewRequestResponseOneReviewUrlMax),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'queued', 'sent', 'opened', 'clicked', 'completed', 'failed']),
  "sentAt": zod.iso.datetime({"offset":true}).nullable(),
  "openedAt": zod.iso.datetime({"offset":true}).nullable(),
  "clickedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "sendCount": zod.int().min(createContentHubReviewRequestResponseTwoSendCountMin),
  "maxSends": zod.int().min(1),
  "nextResendAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastError": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Send a review request through the connected mailbox
 */
export const sendContentHubReviewRequestParams = zod.object({
  "id": zod.uuid()
})

export const sendContentHubReviewRequestBodyReasonMin = 3;
export const sendContentHubReviewRequestBodyReasonMax = 500;



export const sendContentHubReviewRequestBody = zod.object({
  "reason": zod.string().min(sendContentHubReviewRequestBodyReasonMin).max(sendContentHubReviewRequestBodyReasonMax).optional()
})

export const sendContentHubReviewRequestResponseOneRecipientNameMax = 200;

export const sendContentHubReviewRequestResponseOneSubjectMax = 300;

export const sendContentHubReviewRequestResponseOneMessageMax = 10000;

export const sendContentHubReviewRequestResponseOneReviewUrlMax = 2000;

export const sendContentHubReviewRequestResponseTwoSendCountMin = 0;




export const sendContentHubReviewRequestResponse = zod.object({
  "recipientName": zod.string().min(1).max(sendContentHubReviewRequestResponseOneRecipientNameMax),
  "recipientEmail": zod.email(),
  "subject": zod.string().min(1).max(sendContentHubReviewRequestResponseOneSubjectMax),
  "message": zod.string().min(1).max(sendContentHubReviewRequestResponseOneMessageMax),
  "reviewUrl": zod.url().min(1).max(sendContentHubReviewRequestResponseOneReviewUrlMax),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'queued', 'sent', 'opened', 'clicked', 'completed', 'failed']),
  "sentAt": zod.iso.datetime({"offset":true}).nullable(),
  "openedAt": zod.iso.datetime({"offset":true}).nullable(),
  "clickedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "sendCount": zod.int().min(sendContentHubReviewRequestResponseTwoSendCountMin),
  "maxSends": zod.int().min(1),
  "nextResendAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastError": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List durable provider delivery attempts for a review request
 */
export const listContentHubReviewRequestHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listContentHubReviewRequestHistoryResponseItemsItemAttemptCountMin = 0;

export const listContentHubReviewRequestHistoryResponseTotalMin = 0;


export const listContentHubReviewRequestHistoryResponseOffsetMin = 0;



export const listContentHubReviewRequestHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['campaign', 'sequence', 'review_request']),
  "campaignId": zod.uuid().nullish(),
  "sequenceId": zod.uuid().nullish(),
  "stepId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "enrollmentId": zod.uuid().nullish(),
  "reviewRequestId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "toAddress": zod.email(),
  "subject": zod.string().optional(),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'sent', 'suppressed', 'failed', 'uncertain', 'cancelled']),
  "reason": zod.string().nullish(),
  "providerKey": zod.string(),
  "providerMessageId": zod.string().nullish(),
  "attemptCount": zod.int().min(listContentHubReviewRequestHistoryResponseItemsItemAttemptCountMin),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listContentHubReviewRequestHistoryResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubReviewRequestHistoryResponseOffsetMin)
})


/**
 * @summary Get Content Hub automation settings
 */
export const getContentHubAutomationSettingsResponseOneGenerateScheduleMax = 100;

export const getContentHubAutomationSettingsResponseOnePublishScheduleMax = 100;

export const getContentHubAutomationSettingsResponseOnePostsPerRunMax = 20;

export const getContentHubAutomationSettingsResponseOneCommentKeywordRulesItemKeywordMax = 100;

export const getContentHubAutomationSettingsResponseOneCommentKeywordRulesItemReplyMax = 1000;

export const getContentHubAutomationSettingsResponseOneCommentKeywordRulesMax = 100;



export const getContentHubAutomationSettingsResponse = zod.object({
  "enabled": zod.boolean(),
  "generateSchedule": zod.string().max(getContentHubAutomationSettingsResponseOneGenerateScheduleMax),
  "publishSchedule": zod.string().max(getContentHubAutomationSettingsResponseOnePublishScheduleMax),
  "postsPerRun": zod.int().min(1).max(getContentHubAutomationSettingsResponseOnePostsPerRunMax),
  "autoApprove": zod.boolean(),
  "commentKeywordRules": zod.array(zod.object({
  "keyword": zod.string().min(1).max(getContentHubAutomationSettingsResponseOneCommentKeywordRulesItemKeywordMax),
  "reply": zod.string().min(1).max(getContentHubAutomationSettingsResponseOneCommentKeywordRulesItemReplyMax),
  "createLead": zod.boolean()
})).max(getContentHubAutomationSettingsResponseOneCommentKeywordRulesMax)
}).and(zod.object({
  "id": zod.uuid(),
  "lastGeneratedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastPublishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update Content Hub automation settings
 */
export const updateContentHubAutomationSettingsBodyGenerateScheduleMax = 100;

export const updateContentHubAutomationSettingsBodyPublishScheduleMax = 100;

export const updateContentHubAutomationSettingsBodyPostsPerRunMax = 20;

export const updateContentHubAutomationSettingsBodyCommentKeywordRulesItemKeywordMax = 100;

export const updateContentHubAutomationSettingsBodyCommentKeywordRulesItemReplyMax = 1000;

export const updateContentHubAutomationSettingsBodyCommentKeywordRulesMax = 100;



export const updateContentHubAutomationSettingsBody = zod.object({
  "enabled": zod.boolean().optional(),
  "generateSchedule": zod.string().max(updateContentHubAutomationSettingsBodyGenerateScheduleMax).optional(),
  "publishSchedule": zod.string().max(updateContentHubAutomationSettingsBodyPublishScheduleMax).optional(),
  "postsPerRun": zod.int().min(1).max(updateContentHubAutomationSettingsBodyPostsPerRunMax).optional(),
  "autoApprove": zod.boolean().optional(),
  "commentKeywordRules": zod.array(zod.object({
  "keyword": zod.string().min(1).max(updateContentHubAutomationSettingsBodyCommentKeywordRulesItemKeywordMax),
  "reply": zod.string().min(1).max(updateContentHubAutomationSettingsBodyCommentKeywordRulesItemReplyMax),
  "createLead": zod.boolean()
})).max(updateContentHubAutomationSettingsBodyCommentKeywordRulesMax).optional()
})

export const updateContentHubAutomationSettingsResponseOneGenerateScheduleMax = 100;

export const updateContentHubAutomationSettingsResponseOnePublishScheduleMax = 100;

export const updateContentHubAutomationSettingsResponseOnePostsPerRunMax = 20;

export const updateContentHubAutomationSettingsResponseOneCommentKeywordRulesItemKeywordMax = 100;

export const updateContentHubAutomationSettingsResponseOneCommentKeywordRulesItemReplyMax = 1000;

export const updateContentHubAutomationSettingsResponseOneCommentKeywordRulesMax = 100;



export const updateContentHubAutomationSettingsResponse = zod.object({
  "enabled": zod.boolean(),
  "generateSchedule": zod.string().max(updateContentHubAutomationSettingsResponseOneGenerateScheduleMax),
  "publishSchedule": zod.string().max(updateContentHubAutomationSettingsResponseOnePublishScheduleMax),
  "postsPerRun": zod.int().min(1).max(updateContentHubAutomationSettingsResponseOnePostsPerRunMax),
  "autoApprove": zod.boolean(),
  "commentKeywordRules": zod.array(zod.object({
  "keyword": zod.string().min(1).max(updateContentHubAutomationSettingsResponseOneCommentKeywordRulesItemKeywordMax),
  "reply": zod.string().min(1).max(updateContentHubAutomationSettingsResponseOneCommentKeywordRulesItemReplyMax),
  "createLead": zod.boolean()
})).max(updateContentHubAutomationSettingsResponseOneCommentKeywordRulesMax)
}).and(zod.object({
  "id": zod.uuid(),
  "lastGeneratedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastPublishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List paged durable Content Hub operation outcomes
 */
export const listContentHubAutomationRunsQueryLimitDefault = 25;
export const listContentHubAutomationRunsQueryLimitMax = 50;

export const listContentHubAutomationRunsQueryOffsetDefault = 0;
export const listContentHubAutomationRunsQueryOffsetMin = 0;
export const listContentHubAutomationRunsQueryOffsetMax = 1000;



export const listContentHubAutomationRunsQueryParams = zod.object({
  "category": zod.enum(['generation', 'social_publication', 'inbox_sync', 'messaging', 'email_delivery', 'advertising']).optional(),
  "limit": zod.int().min(1).max(listContentHubAutomationRunsQueryLimitMax).default(listContentHubAutomationRunsQueryLimitDefault),
  "offset": zod.int().min(listContentHubAutomationRunsQueryOffsetMin).max(listContentHubAutomationRunsQueryOffsetMax).default(listContentHubAutomationRunsQueryOffsetDefault)
})

export const listContentHubAutomationRunsResponseTotalMin = 0;


export const listContentHubAutomationRunsResponseOffsetMin = 0;



export const listContentHubAutomationRunsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "category": zod.enum(['generation', 'social_publication', 'inbox_sync', 'messaging', 'email_delivery', 'advertising']),
  "status": zod.enum(['queued', 'running', 'completed', 'partial', 'skipped', 'blocked', 'failed', 'unavailable', 'uncertain', 'cancelled']),
  "summary": zod.string(),
  "network": zod.union([zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),zod.null()]),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable()
})),
  "total": zod.int().min(listContentHubAutomationRunsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listContentHubAutomationRunsResponseOffsetMin)
})


/**
 * @summary Get reconciled Content Hub performance and outcome reporting
 */
export const getContentHubReportQueryNetworksMax = 7;



export const getContentHubReportQueryParams = zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).max(getContentHubReportQueryNetworksMax).optional()
})

export const getContentHubReportResponseInternalPostsCreatedMin = 0;

export const getContentHubReportResponseInternalPublishedTargetsMin = 0;

export const getContentHubReportResponseInternalInboxItemsMin = 0;

export const getContentHubReportResponseInternalSocialLeadsMin = 0;

export const getContentHubReportResponseInternalBookingsMin = 0;

export const getContentHubReportResponseInternalEmailsSentMin = 0;

export const getContentHubReportResponseInternalEmailsSuppressedMin = 0;

export const getContentHubReportResponseInternalAdvertisingCampaignsMin = 0;

export const getContentHubReportResponseInternalAdvertisingConversionsMin = 0;

export const getContentHubReportResponseProvidersItemPublishedTargetsMin = 0;

export const getContentHubReportResponseOutcomesItemCountMin = 0;



export const getContentHubReportResponse = zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "internal": zod.object({
  "postsCreated": zod.int().min(getContentHubReportResponseInternalPostsCreatedMin),
  "publishedTargets": zod.int().min(getContentHubReportResponseInternalPublishedTargetsMin),
  "inboxItems": zod.int().min(getContentHubReportResponseInternalInboxItemsMin),
  "socialLeads": zod.int().min(getContentHubReportResponseInternalSocialLeadsMin),
  "bookings": zod.int().min(getContentHubReportResponseInternalBookingsMin),
  "emailsSent": zod.int().min(getContentHubReportResponseInternalEmailsSentMin),
  "emailsSuppressed": zod.int().min(getContentHubReportResponseInternalEmailsSuppressedMin),
  "advertisingCampaigns": zod.int().min(getContentHubReportResponseInternalAdvertisingCampaignsMin),
  "advertisingConversions": zod.int().min(getContentHubReportResponseInternalAdvertisingConversionsMin)
}),
  "providers": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported']),
  "detail": zod.string(),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "publishedTargets": zod.int().min(getContentHubReportResponseProvidersItemPublishedTargetsMin),
  "metrics": zod.object({
  "impressions": zod.int().nullable(),
  "reach": zod.int().nullable(),
  "reactions": zod.int().nullable(),
  "comments": zod.int().nullable(),
  "shares": zod.int().nullable(),
  "clicks": zod.int().nullable(),
  "views": zod.int().nullable()
}),
  "metricStates": zod.object({
  "impressions": zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported']),
  "reach": zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported']),
  "reactions": zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported']),
  "comments": zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported']),
  "shares": zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported']),
  "clicks": zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported']),
  "views": zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported'])
})
})),
  "outcomes": zod.array(zod.object({
  "area": zod.enum(['social_publication', 'messaging', 'email_delivery', 'advertising']),
  "status": zod.string(),
  "count": zod.int().min(getContentHubReportResponseOutcomesItemCountMin)
}))
})


/**
 * @summary Export the same reconciled Content Hub report as CSV
 */
export const exportContentHubReportQueryNetworksMax = 7;



export const exportContentHubReportQueryParams = zod.object({
  "from": zod.iso.datetime({"offset":true}),
  "to": zod.iso.datetime({"offset":true}),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).max(exportContentHubReportQueryNetworksMax).optional()
})

export const exportContentHubReportResponse = zod.unknown()


/**
 * @summary Evaluate Content Hub readiness from live configuration and data
 */
export const getContentHubGoLiveChecklistResponse = zod.object({
  "checks": zod.array(zod.object({
  "key": zod.string(),
  "section": zod.string(),
  "label": zod.string(),
  "passed": zod.boolean(),
  "status": zod.enum(['ready', 'blocked', 'unavailable', 'manual']),
  "detail": zod.string(),
  "href": zod.string(),
  "manual": zod.boolean(),
  "observedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "passed": zod.int(),
  "total": zod.int(),
  "percent": zod.int()
})


/**
 * @summary List social network connection and publishing capabilities
 */
export const listSocialNetworksResponse = zod.object({
  "items": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "label": zod.string(),
  "status": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "canPublishText": zod.boolean(),
  "canReply": zod.boolean(),
  "oauthConfigured": zod.boolean()
}))
})


/**
 * Returns a fixed seven-provider matrix. Provider support, current implementation state, connection readiness and setup prerequisites are reported independently so unavailable features are never represented as empty success.
 * @summary List verified provider capabilities and implementation readiness
 */




export const listSocialProviderCapabilitiesResponseItemsMin = 7;
export const listSocialProviderCapabilitiesResponseItemsMax = 7;



export const listSocialProviderCapabilitiesResponse = zod.object({
  "verifiedAt": zod.iso.date(),
  "generatedAt": zod.iso.datetime({"offset":true}),
  "items": zod.array(zod.object({
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "label": zod.string().min(1),
  "targetKinds": zod.array(zod.enum(['member', 'organization_page', 'page', 'professional_account', 'account', 'channel', 'location', 'creator'])).min(1),
  "connectionStatus": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "setupState": zod.enum(['ready', 'connection_required', 'configuration_required', 'provider_approval_required', 'reauthorization_required', 'not_implemented']),
  "displayName": zod.string().nullable(),
  "externalAccountId": zod.string().nullable(),
  "accountType": zod.enum(['organization_page', 'page', 'professional_account', 'account', 'channel', 'location', 'creator']).nullable(),
  "grantedCapabilities": zod.array(zod.string()),
  "connectedAt": zod.iso.datetime({"offset":true}).nullable(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastVerifiedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastSynchronizedAt": zod.iso.datetime({"offset":true}).nullable(),
  "safeError": zod.string().nullable(),
  "documentationUrl": zod.url(),
  "setupRequirements": zod.array(zod.object({
  "key": zod.enum(['app_registration', 'api_product_approval', 'oauth_consent', 'eligible_target', 'verified_media_domain', 'paid_api_access', 'public_upload_audit']),
  "label": zod.string().min(1),
  "required": zod.boolean()
})),
  "capabilities": zod.array(zod.object({
  "key": zod.enum(['publish_text', 'publish_image', 'publish_video', 'publish_document', 'publish_carousel', 'read_comments', 'reply_comments', 'read_mentions', 'read_messages', 'send_messages', 'read_reviews', 'reply_reviews', 'read_analytics', 'manage_advertising']),
  "providerSupport": zod.enum(['supported', 'restricted', 'unsupported']),
  "implementationStatus": zod.enum(['available', 'partial', 'planned']),
  "requiredPermissions": zod.array(zod.string()),
  "detail": zod.string().min(1)
}))
})).min(listSocialProviderCapabilitiesResponseItemsMin).max(listSocialProviderCapabilitiesResponseItemsMax)
})


/**
 * @summary List the selected entity's social connection lifecycle audit history
 */
export const listSocialConnectionAuditQueryLimitDefault = 25;
export const listSocialConnectionAuditQueryLimitMax = 100;

export const listSocialConnectionAuditQueryOffsetDefault = 0;
export const listSocialConnectionAuditQueryOffsetMin = 0;



export const listSocialConnectionAuditQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSocialConnectionAuditQueryLimitMax).default(listSocialConnectionAuditQueryLimitDefault),
  "offset": zod.int().min(listSocialConnectionAuditQueryOffsetMin).default(listSocialConnectionAuditQueryOffsetDefault)
})

export const listSocialConnectionAuditResponseItemsItemBlockedQueuedActionsMin = 0;

export const listSocialConnectionAuditResponseTotalMin = 0;

export const listSocialConnectionAuditResponseLimitMax = 100;

export const listSocialConnectionAuditResponseOffsetMin = 0;



export const listSocialConnectionAuditResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "action": zod.enum(['channel_connected', 'channel_disconnected', 'channel_refresh_succeeded', 'channel_refresh_failed', 'channel_test_succeeded', 'channel_test_failed']),
  "outcome": zod.enum(['succeeded', 'failed']),
  "actorEmail": zod.string().nullable(),
  "reason": zod.string().nullable(),
  "externalAccountId": zod.string().nullable(),
  "blockedQueuedActions": zod.int().min(listSocialConnectionAuditResponseItemsItemBlockedQueuedActionsMin).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSocialConnectionAuditResponseTotalMin),
  "limit": zod.int().min(1).max(listSocialConnectionAuditResponseLimitMax),
  "offset": zod.int().min(listSocialConnectionAuditResponseOffsetMin)
})


/**
 * @summary Start a provider OAuth connection
 */
export const getSocialOAuthUrlParams = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])
})

export const getSocialOAuthUrlResponse = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "available": zod.boolean(),
  "authorizationUrl": zod.string().nullish(),
  "reason": zod.string().nullish()
})


/**
 * @summary Exchange provider authorization and stage eligible account selection
 */
export const completeSocialOAuthParams = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])
})





export const completeSocialOAuthQueryParams = zod.object({
  "code": zod.string().min(1),
  "state": zod.string().min(1)
})

export const completeSocialOAuthResponse = zod.void()


/**
 * @summary List eligible provider targets for this authorization attempt
 */
export const getSocialOAuthAccountSelectionParams = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "selectionId": zod.uuid()
})

export const getSocialOAuthAccountSelectionQueryLimitDefault = 25;
export const getSocialOAuthAccountSelectionQueryLimitMax = 100;

export const getSocialOAuthAccountSelectionQueryOffsetDefault = 0;
export const getSocialOAuthAccountSelectionQueryOffsetMin = 0;



export const getSocialOAuthAccountSelectionQueryParams = zod.object({
  "limit": zod.int().min(1).max(getSocialOAuthAccountSelectionQueryLimitMax).default(getSocialOAuthAccountSelectionQueryLimitDefault),
  "offset": zod.int().min(getSocialOAuthAccountSelectionQueryOffsetMin).default(getSocialOAuthAccountSelectionQueryOffsetDefault)
})




export const getSocialOAuthAccountSelectionResponseLimitMax = 100;

export const getSocialOAuthAccountSelectionResponseOffsetMin = 0;



export const getSocialOAuthAccountSelectionResponse = zod.object({
  "selectionId": zod.uuid(),
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "eligibleAccounts": zod.array(zod.object({
  "externalAccountId": zod.string().min(1),
  "displayName": zod.string().min(1),
  "accountType": zod.enum(['organization_page', 'page', 'professional_account', 'account', 'channel', 'location', 'creator']),
  "capabilities": zod.array(zod.string())
})),
  "total": zod.int().min(1),
  "limit": zod.int().min(1).max(getSocialOAuthAccountSelectionResponseLimitMax),
  "offset": zod.int().min(getSocialOAuthAccountSelectionResponseOffsetMin)
})


/**
 * @summary Connect one explicitly selected eligible provider target
 */
export const selectSocialOAuthAccountParams = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "selectionId": zod.uuid()
})

export const selectSocialOAuthAccountBodyExternalAccountIdMax = 500;



export const selectSocialOAuthAccountBody = zod.object({
  "externalAccountId": zod.string().min(1).max(selectSocialOAuthAccountBodyExternalAccountIdMax)
})

export const selectSocialOAuthAccountResponse = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['connected']),
  "displayName": zod.string(),
  "externalAccountId": zod.string(),
  "accountType": zod.enum(['organization_page', 'page', 'professional_account', 'account', 'channel', 'location', 'creator']),
  "grantedCapabilities": zod.array(zod.string()),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Refresh provider credentials under a persisted versioned lease
 */
export const refreshSocialNetworkConnectionParams = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])
})

export const refreshSocialNetworkConnectionResponse = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['refreshed', 'already_running', 'superseded']),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "refreshedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Disconnect an entity social account and block queued external execution
 */
export const disconnectSocialNetworkParams = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])
})

export const disconnectSocialNetworkBodyReasonMin = 10;
export const disconnectSocialNetworkBodyReasonMax = 500;



export const disconnectSocialNetworkBody = zod.object({
  "reason": zod.string().min(disconnectSocialNetworkBodyReasonMin).max(disconnectSocialNetworkBodyReasonMax)
})

export const disconnectSocialNetworkResponseBlockedQueuedActionsMin = 0;



export const disconnectSocialNetworkResponse = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['disconnected']),
  "blockedQueuedActions": zod.int().min(disconnectSocialNetworkResponseBlockedQueuedActionsMin)
})


export const listCampaignOutputsParams = zod.object({
  "id": zod.uuid()
})

export const listCampaignOutputsQueryLimitDefault = 25;
export const listCampaignOutputsQueryLimitMax = 100;

export const listCampaignOutputsQueryOffsetDefault = 0;
export const listCampaignOutputsQueryOffsetMin = 0;



export const listCampaignOutputsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listCampaignOutputsQueryLimitMax).default(listCampaignOutputsQueryLimitDefault),
  "offset": zod.int().min(listCampaignOutputsQueryOffsetMin).default(listCampaignOutputsQueryOffsetDefault)
})

export const listCampaignOutputsResponse = zod.object({
  "items": zod.array(zod.object({
  "manualHandoff": zod.boolean().optional().describe('Manual ad preparation document; native approval is never provider approval.'),
  "kind": zod.enum(['content_asset', 'managed_document', 'microsite']),
  "recordId": zod.uuid(),
  "revision": zod.string(),
  "currentRevision": zod.string().nullable(),
  "title": zod.string().nullable(),
  "state": zod.enum(['draft', 'in_review', 'approved', 'published', 'stale', 'unavailable', 'archived']),
  "editorUrl": zod.string().nullable(),
  "publicUrl": zod.string().nullable(),
  "limitations": zod.array(zod.string())
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Reads an exact authorized pack as text. Access audit only; no campaign, document or provider state changes.
 */
export const prepareManualAdHandoffParams = zod.object({
  "id": zod.uuid()
})




export const prepareManualAdHandoffQueryParams = zod.object({
  "documentId": zod.uuid(),
  "expectedRevision": zod.int().min(1)
})

export const prepareManualAdHandoffResponse = zod.object({
  "text": zod.string(),
  "filename": zod.string(),
  "revision": zod.int(),
  "preparedAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['handoff_prepared'])
})


export const reviewCampaignOutputBodyChangeExpectedBriefVersionMin = 0;

export const reviewCampaignOutputBodyChangeExpectedRevisionMin = 0;

export const reviewCampaignOutputBodyChangeFieldsOneTitleMax = 300;

export const reviewCampaignOutputBodyChangeFieldsOnePlacementMax = 300;

export const reviewCampaignOutputBodyChangeFieldsOneObjectiveMax = 2000;

export const reviewCampaignOutputBodyChangeFieldsOneDestinationUrlMax = 2000;

export const reviewCampaignOutputBodyChangeFieldsOneAudienceMax = 5000;

export const reviewCampaignOutputBodyChangeFieldsOneBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const reviewCampaignOutputBodyChangeFieldsOneCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviewCampaignOutputBodyChangeFieldsOneVariantsItemNameMax = 100;

export const reviewCampaignOutputBodyChangeFieldsOneVariantsItemFieldsItemMax = 5000;

export const reviewCampaignOutputBodyChangeFieldsOneVariantsItemFieldsMaxOne = 20;

export const reviewCampaignOutputBodyChangeFieldsOneVariantsMax = 20;

export const reviewCampaignOutputBodyChangeFieldsOneAssetsItemRevisionMax = 100;

export const reviewCampaignOutputBodyChangeFieldsOneAssetsMax = 20;

export const reviewCampaignOutputBodyChangeFieldsOneSourcesItemRevisionMax = 100;

export const reviewCampaignOutputBodyChangeFieldsOneSourcesMax = 50;

export const reviewCampaignOutputBodyChangeFieldsOneUnknownsItemMax = 2000;

export const reviewCampaignOutputBodyChangeFieldsOneUnknownsMax = 50;

export const reviewCampaignOutputBodyChangeReasonMax = 2000;



export const reviewCampaignOutputBody = zod.object({
  "conversationId": zod.uuid(),
  "change": zod.object({
  "campaignId": zod.uuid(),
  "expectedBriefVersion": zod.int().min(reviewCampaignOutputBodyChangeExpectedBriefVersionMin),
  "expectedCampaignUpdatedAt": zod.iso.datetime({"offset":true}),
  "operation": zod.enum(['create_document', 'save_document', 'save_page', 'create_ad_pack']),
  "recordId": zod.uuid().optional(),
  "expectedRevision": zod.int().min(reviewCampaignOutputBodyChangeExpectedRevisionMin).optional(),
  "fields": zod.union([zod.object({
  "title": zod.string().min(1).max(reviewCampaignOutputBodyChangeFieldsOneTitleMax),
  "format": zod.enum(['meta', 'linkedin', 'google_search', 'google_display', 'youtube', 'tiktok', 'x']),
  "placement": zod.string().max(reviewCampaignOutputBodyChangeFieldsOnePlacementMax),
  "objective": zod.string().max(reviewCampaignOutputBodyChangeFieldsOneObjectiveMax),
  "destinationUrl": zod.string().max(reviewCampaignOutputBodyChangeFieldsOneDestinationUrlMax),
  "audience": zod.string().max(reviewCampaignOutputBodyChangeFieldsOneAudienceMax),
  "startsAt": zod.iso.datetime({"offset":true}).nullable(),
  "endsAt": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(reviewCampaignOutputBodyChangeFieldsOneBudgetRegExp).nullable(),
  "currency": zod.string().regex(reviewCampaignOutputBodyChangeFieldsOneCurrencyRegExp).nullable(),
  "variants": zod.array(zod.object({
  "name": zod.string().min(1).max(reviewCampaignOutputBodyChangeFieldsOneVariantsItemNameMax),
  "fields": zod.record(zod.string(), zod.array(zod.string().max(reviewCampaignOutputBodyChangeFieldsOneVariantsItemFieldsItemMax)).max(reviewCampaignOutputBodyChangeFieldsOneVariantsItemFieldsMaxOne))
})).min(1).max(reviewCampaignOutputBodyChangeFieldsOneVariantsMax),
  "assets": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignOutputBodyChangeFieldsOneAssetsItemRevisionMax)
})).max(reviewCampaignOutputBodyChangeFieldsOneAssetsMax),
  "sources": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignOutputBodyChangeFieldsOneSourcesItemRevisionMax)
})).max(reviewCampaignOutputBodyChangeFieldsOneSourcesMax),
  "unknowns": zod.array(zod.string().max(reviewCampaignOutputBodyChangeFieldsOneUnknownsItemMax)).max(reviewCampaignOutputBodyChangeFieldsOneUnknownsMax)
}),zod.record(zod.string(), zod.unknown())]),
  "reason": zod.string().min(1).max(reviewCampaignOutputBodyChangeReasonMax)
})
})


export const reviewCampaignOutputResponseReviewDestructiveDefault = false;

export const reviewCampaignOutputResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(reviewCampaignOutputResponseReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})


/**
 * @summary Prepare a private exact social editorial review
 */

export const reviewSocialProductionBodyChangeReasonMin = 3;
export const reviewSocialProductionBodyChangeReasonMax = 1000;



export const reviewSocialProductionBody = zod.object({
  "conversationId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['create', 'update', 'submit', 'approve', 'reject', 'schedule', 'archive', 'duplicate', 'retry', 'reconcile']),
  "campaignId": zod.uuid().optional(),
  "postId": zod.uuid().optional(),
  "expectedVersion": zod.int().min(1).optional(),
  "fields": zod.record(zod.string(), zod.unknown()),
  "reason": zod.string().min(reviewSocialProductionBodyChangeReasonMin).max(reviewSocialProductionBodyChangeReasonMax)
})
})


export const reviewSocialProductionResponseReviewDestructiveDefault = false;

export const reviewSocialProductionResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(reviewSocialProductionResponseReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})


/**
 * @summary List social drafts, schedule and publish history
 */
export const listSocialPostsQueryLimitDefault = 50;
export const listSocialPostsQueryLimitMax = 100;

export const listSocialPostsQueryOffsetDefault = 0;
export const listSocialPostsQueryOffsetMin = 0;

export const listSocialPostsQuerySearchMax = 200;



export const listSocialPostsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSocialPostsQueryLimitMax).default(listSocialPostsQueryLimitDefault),
  "offset": zod.int().min(listSocialPostsQueryOffsetMin).default(listSocialPostsQueryOffsetDefault),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']).optional(),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']).optional(),
  "search": zod.string().max(listSocialPostsQuerySearchMax).optional()
})

export const listSocialPostsResponseItemsItemOneTitleMax = 200;

export const listSocialPostsResponseItemsItemOneContentMax = 10000;


export const listSocialPostsResponseItemsItemOneMediaAssetIdsMax = 10;


export const listSocialPostsResponseItemsItemTwoRevisionCountMin = 0;

export const listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const listSocialPostsResponseItemsItemTwoPublishResultsItemAttemptCountMin = 0;

export const listSocialPostsResponseTotalMin = 0;


export const listSocialPostsResponseOffsetMin = 0;



export const listSocialPostsResponse = zod.object({
  "items": zod.array(zod.object({
  "title": zod.string().min(1).max(listSocialPostsResponseItemsItemOneTitleMax),
  "content": zod.string().min(1).max(listSocialPostsResponseItemsItemOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(listSocialPostsResponseItemsItemOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(listSocialPostsResponseItemsItemTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(listSocialPostsResponseItemsItemTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(listSocialPostsResponseItemsItemTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listSocialPostsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listSocialPostsResponseOffsetMin),
  "displayTimezone": zod.string()
})


/**
 * @summary Create a manual social post draft
 */
export const createSocialPostBodyTitleMax = 200;

export const createSocialPostBodyContentMax = 10000;


export const createSocialPostBodyMediaAssetIdsMax = 10;



export const createSocialPostBody = zod.object({
  "title": zod.string().min(1).max(createSocialPostBodyTitleMax),
  "content": zod.string().min(1).max(createSocialPostBodyContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(createSocialPostBodyMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
})

export const createSocialPostResponseOneTitleMax = 200;

export const createSocialPostResponseOneContentMax = 10000;


export const createSocialPostResponseOneMediaAssetIdsMax = 10;


export const createSocialPostResponseTwoRevisionCountMin = 0;

export const createSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const createSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const createSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const createSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const createSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const createSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const createSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const createSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(createSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(createSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(createSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(createSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(createSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(createSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(createSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(createSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(createSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(createSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(createSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Get one social post with its selected media
 */
export const getSocialPostParams = zod.object({
  "id": zod.uuid()
})

export const getSocialPostResponseOneTitleMax = 200;

export const getSocialPostResponseOneContentMax = 10000;


export const getSocialPostResponseOneMediaAssetIdsMax = 10;


export const getSocialPostResponseTwoRevisionCountMin = 0;

export const getSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const getSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const getSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const getSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const getSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const getSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const getSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const getSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(getSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(getSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(getSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(getSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(getSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(getSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(getSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(getSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(getSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(getSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(getSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Update editable post content using optimistic version control
 */
export const updateSocialPostParams = zod.object({
  "id": zod.uuid()
})


export const updateSocialPostBodyTitleMax = 200;

export const updateSocialPostBodyContentMax = 10000;


export const updateSocialPostBodyMediaAssetIdsMax = 10;



export const updateSocialPostBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "title": zod.string().min(1).max(updateSocialPostBodyTitleMax).optional(),
  "content": zod.string().min(1).max(updateSocialPostBodyContentMax).optional(),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1).optional(),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(updateSocialPostBodyMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish()
})

export const updateSocialPostResponseOneTitleMax = 200;

export const updateSocialPostResponseOneContentMax = 10000;


export const updateSocialPostResponseOneMediaAssetIdsMax = 10;


export const updateSocialPostResponseTwoRevisionCountMin = 0;

export const updateSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const updateSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const updateSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const updateSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const updateSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const updateSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const updateSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const updateSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(updateSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(updateSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(updateSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(updateSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(updateSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(updateSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(updateSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(updateSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(updateSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(updateSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(updateSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary List immutable editorial revisions for a social post
 */
export const listSocialPostRevisionsParams = zod.object({
  "id": zod.uuid()
})

export const listSocialPostRevisionsQueryLimitDefault = 50;
export const listSocialPostRevisionsQueryLimitMax = 100;

export const listSocialPostRevisionsQueryOffsetDefault = 0;
export const listSocialPostRevisionsQueryOffsetMin = 0;



export const listSocialPostRevisionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSocialPostRevisionsQueryLimitMax).default(listSocialPostRevisionsQueryLimitDefault),
  "offset": zod.int().min(listSocialPostRevisionsQueryOffsetMin).default(listSocialPostRevisionsQueryOffsetDefault)
})


export const listSocialPostRevisionsResponseTotalMin = 0;


export const listSocialPostRevisionsResponseOffsetMin = 0;



export const listSocialPostRevisionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "postId": zod.uuid(),
  "version": zod.int().min(1),
  "action": zod.enum(['created', 'edited', 'submitted', 'approved', 'rejected', 'scheduled', 'archived', 'duplicated']),
  "title": zod.string(),
  "content": zod.string(),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})),
  "mediaAssetIds": zod.array(zod.uuid()),
  "actor": zod.string(),
  "note": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSocialPostRevisionsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listSocialPostRevisionsResponseOffsetMin)
})


/**
 * @summary Duplicate a post and its media as a new draft
 */
export const duplicateSocialPostParams = zod.object({
  "id": zod.uuid()
})




export const duplicateSocialPostBody = zod.object({
  "expectedVersion": zod.int().min(1)
})

export const duplicateSocialPostResponseOneTitleMax = 200;

export const duplicateSocialPostResponseOneContentMax = 10000;


export const duplicateSocialPostResponseOneMediaAssetIdsMax = 10;


export const duplicateSocialPostResponseTwoRevisionCountMin = 0;

export const duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const duplicateSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const duplicateSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(duplicateSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(duplicateSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(duplicateSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(duplicateSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(duplicateSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(duplicateSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Submit an editable draft for approval
 */
export const submitSocialPostParams = zod.object({
  "id": zod.uuid()
})




export const submitSocialPostBody = zod.object({
  "expectedVersion": zod.int().min(1)
})

export const submitSocialPostResponseOneTitleMax = 200;

export const submitSocialPostResponseOneContentMax = 10000;


export const submitSocialPostResponseOneMediaAssetIdsMax = 10;


export const submitSocialPostResponseTwoRevisionCountMin = 0;

export const submitSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const submitSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const submitSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const submitSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const submitSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const submitSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const submitSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const submitSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(submitSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(submitSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(submitSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(submitSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(submitSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(submitSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(submitSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(submitSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(submitSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(submitSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(submitSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Generate a target-market and signal-grounded social strategy
 */
export const generateSocialStrategyBodyObjectiveMax = 1000;



export const generateSocialStrategyBody = zod.object({
  "objective": zod.string().max(generateSocialStrategyBodyObjectiveMax).optional(),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).optional()
})

export const generateSocialStrategyResponse = zod.object({
  "summary": zod.string(),
  "topics": zod.array(zod.string()),
  "auditId": zod.uuid()
})


/**
 * @summary Generate per-network post variants for human approval
 */
export const generateSocialDraftBodyTopicMax = 1000;

export const generateSocialDraftBodyToneMax = 100;




export const generateSocialDraftBody = zod.object({
  "topic": zod.string().min(1).max(generateSocialDraftBodyTopicMax),
  "tone": zod.string().max(generateSocialDraftBodyToneMax).optional(),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish()
})

export const generateSocialDraftResponseOneOneTitleMax = 200;

export const generateSocialDraftResponseOneOneContentMax = 10000;


export const generateSocialDraftResponseOneOneMediaAssetIdsMax = 10;


export const generateSocialDraftResponseOneTwoRevisionCountMin = 0;

export const generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const generateSocialDraftResponseOneTwoPublishResultsItemAttemptCountMin = 0;



export const generateSocialDraftResponse = zod.object({
  "title": zod.string().min(1).max(generateSocialDraftResponseOneOneTitleMax),
  "content": zod.string().min(1).max(generateSocialDraftResponseOneOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(generateSocialDraftResponseOneOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(generateSocialDraftResponseOneTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(generateSocialDraftResponseOneTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(generateSocialDraftResponseOneTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).and(zod.object({
  "sources": zod.array(zod.object({
  "knowledgeFileId": zod.uuid(),
  "title": zod.string(),
  "location": zod.string(),
  "score": zod.number()
})),
  "knowledgeState": zod.enum(['ready', 'empty_index', 'no_sources', 'stale', 'conflicting', 'denied', 'failed_ingestion', 'low_confidence'])
}))


/**
 * @summary Human-approve a post and its variants
 */
export const approveSocialPostParams = zod.object({
  "id": zod.uuid()
})




export const approveSocialPostBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "autoSchedule": zod.boolean().optional().describe('After approval, automatically schedule the post at the next free business slot in the entity timezone')
})

export const approveSocialPostResponseOneTitleMax = 200;

export const approveSocialPostResponseOneContentMax = 10000;


export const approveSocialPostResponseOneMediaAssetIdsMax = 10;


export const approveSocialPostResponseTwoRevisionCountMin = 0;

export const approveSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const approveSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const approveSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const approveSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const approveSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const approveSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const approveSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const approveSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(approveSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(approveSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(approveSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(approveSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(approveSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(approveSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(approveSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(approveSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(approveSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(approveSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(approveSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Schedule an approved post for publishing
 */
export const scheduleSocialPostParams = zod.object({
  "id": zod.uuid()
})


export const scheduleSocialPostBodyLocalDateTimeRegExp = new RegExp('^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}$');
export const scheduleSocialPostBodyTimezoneMax = 100;



export const scheduleSocialPostBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "localDateTime": zod.string().regex(scheduleSocialPostBodyLocalDateTimeRegExp).describe('Wall-clock time in the supplied IANA timezone'),
  "timezone": zod.string().min(1).max(scheduleSocialPostBodyTimezoneMax).describe('IANA timezone identifier'),
  "disambiguation": zod.enum(['earlier', 'later']).nullish().describe('Required only when the local time occurs twice during a daylight-saving transition')
})

export const scheduleSocialPostResponseOneTitleMax = 200;

export const scheduleSocialPostResponseOneContentMax = 10000;


export const scheduleSocialPostResponseOneMediaAssetIdsMax = 10;


export const scheduleSocialPostResponseTwoRevisionCountMin = 0;

export const scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const scheduleSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const scheduleSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(scheduleSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(scheduleSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(scheduleSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(scheduleSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(scheduleSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(scheduleSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Reject a post awaiting approval with an authenticated audit actor
 */
export const rejectSocialPostParams = zod.object({
  "id": zod.uuid()
})


export const rejectSocialPostBodyReasonMin = 3;
export const rejectSocialPostBodyReasonMax = 1000;



export const rejectSocialPostBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "reason": zod.string().min(rejectSocialPostBodyReasonMin).max(rejectSocialPostBodyReasonMax)
})

export const rejectSocialPostResponseOneTitleMax = 200;

export const rejectSocialPostResponseOneContentMax = 10000;


export const rejectSocialPostResponseOneMediaAssetIdsMax = 10;


export const rejectSocialPostResponseTwoRevisionCountMin = 0;

export const rejectSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const rejectSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const rejectSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const rejectSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const rejectSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const rejectSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const rejectSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const rejectSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(rejectSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(rejectSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(rejectSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(rejectSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(rejectSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(rejectSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(rejectSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(rejectSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(rejectSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(rejectSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(rejectSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Archive a post while retaining revisions and publication history
 */
export const archiveSocialPostParams = zod.object({
  "id": zod.uuid()
})


export const archiveSocialPostBodyReasonMin = 3;
export const archiveSocialPostBodyReasonMax = 1000;



export const archiveSocialPostBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "reason": zod.string().min(archiveSocialPostBodyReasonMin).max(archiveSocialPostBodyReasonMax)
})

export const archiveSocialPostResponseOneTitleMax = 200;

export const archiveSocialPostResponseOneContentMax = 10000;


export const archiveSocialPostResponseOneMediaAssetIdsMax = 10;


export const archiveSocialPostResponseTwoRevisionCountMin = 0;

export const archiveSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const archiveSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const archiveSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const archiveSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const archiveSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const archiveSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const archiveSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const archiveSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(archiveSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(archiveSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(archiveSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(archiveSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(archiveSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(archiveSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(archiveSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(archiveSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(archiveSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(archiveSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(archiveSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Requeue selected failed publication targets without replaying successful targets
 */
export const retrySocialPostParams = zod.object({
  "id": zod.uuid()
})





export const retrySocialPostBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1)
})

export const retrySocialPostResponseOneTitleMax = 200;

export const retrySocialPostResponseOneContentMax = 10000;


export const retrySocialPostResponseOneMediaAssetIdsMax = 10;


export const retrySocialPostResponseTwoRevisionCountMin = 0;

export const retrySocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const retrySocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const retrySocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const retrySocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const retrySocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const retrySocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const retrySocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const retrySocialPostResponse = zod.object({
  "title": zod.string().min(1).max(retrySocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(retrySocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(retrySocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(retrySocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(retrySocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(retrySocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(retrySocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(retrySocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(retrySocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(retrySocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(retrySocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Save the required creator choices and verified media URLs for a TikTok post
 */
export const configureTikTokSocialPostParams = zod.object({
  "id": zod.uuid()
})

export const configureTikTokSocialPostBodyMediaUrlsItemMax = 2048;

export const configureTikTokSocialPostBodyMediaUrlsMax = 35;

export const configureTikTokSocialPostBodyVideoDurationSecondsExclusiveMin = 0;
export const configureTikTokSocialPostBodyVideoDurationSecondsMax = 600;

export const configureTikTokSocialPostBodyTitleMax = 2200;

export const configureTikTokSocialPostBodyDescriptionMax = 4000;



export const configureTikTokSocialPostBody = zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(configureTikTokSocialPostBodyMediaUrlsItemMax)).min(1).max(configureTikTokSocialPostBodyMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(configureTikTokSocialPostBodyVideoDurationSecondsExclusiveMin).max(configureTikTokSocialPostBodyVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(configureTikTokSocialPostBodyTitleMax),
  "description": zod.string().max(configureTikTokSocialPostBodyDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
})

export const configureTikTokSocialPostResponseOneTitleMax = 200;

export const configureTikTokSocialPostResponseOneContentMax = 10000;


export const configureTikTokSocialPostResponseOneMediaAssetIdsMax = 10;


export const configureTikTokSocialPostResponseTwoRevisionCountMin = 0;

export const configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const configureTikTokSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const configureTikTokSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(configureTikTokSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(configureTikTokSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(configureTikTokSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(configureTikTokSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(configureTikTokSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(configureTikTokSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Reconcile asynchronous provider publication outcomes for a publishing post
 */
export const reconcileSocialPostParams = zod.object({
  "id": zod.uuid()
})

export const reconcileSocialPostResponseOneTitleMax = 200;

export const reconcileSocialPostResponseOneContentMax = 10000;


export const reconcileSocialPostResponseOneMediaAssetIdsMax = 10;


export const reconcileSocialPostResponseTwoRevisionCountMin = 0;

export const reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax = 2048;

export const reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax = 35;

export const reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin = 0;
export const reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax = 600;

export const reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax = 2200;

export const reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax = 4000;



export const reconcileSocialPostResponseTwoPublishResultsItemAttemptCountMin = 0;



export const reconcileSocialPostResponse = zod.object({
  "title": zod.string().min(1).max(reconcileSocialPostResponseOneTitleMax),
  "content": zod.string().min(1).max(reconcileSocialPostResponseOneContentMax),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).min(1),
  "variants": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "content": zod.string()
})).optional(),
  "mediaAssetIds": zod.array(zod.uuid()).max(reconcileSocialPostResponseOneMediaAssetIdsMax).optional(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "campaignId": zod.uuid().optional().describe('Create an inert social step in this draft campaign when no existing step is selected.')
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'rejected', 'scheduled', 'publishing', 'published', 'partial_failed', 'failed', 'archived']),
  "version": zod.int().min(1),
  "media": zod.array(zod.object({
  "id": zod.uuid(),
  "filename": zod.string(),
  "kind": zod.enum(['image', 'video']),
  "contentType": zod.string(),
  "selectable": zod.boolean()
})),
  "revisionCount": zod.int().min(reconcileSocialPostResponseTwoRevisionCountMin),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "scheduleLocalDateTime": zod.string().nullish(),
  "scheduleTimezone": zod.string().nullish(),
  "scheduleDisambiguation": zod.enum(['earlier', 'later']).nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "submittedBy": zod.string().nullish(),
  "submittedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectedBy": zod.string().nullish(),
  "rejectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "rejectionReason": zod.string().nullish(),
  "archivedBy": zod.string().nullish(),
  "archivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "providerOptions": zod.object({
  "tiktok": zod.union([zod.object({
  "mediaType": zod.enum(['photo', 'video']),
  "mediaUrls": zod.array(zod.url().max(reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsItemMax)).min(1).max(reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneMediaUrlsMax),
  "videoDurationSeconds": zod.number().gt(reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsExclusiveMin).max(reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneVideoDurationSecondsMax).nullish(),
  "title": zod.string().max(reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneTitleMax),
  "description": zod.string().max(reconcileSocialPostResponseTwoProviderOptionsTiktokOneOneDescriptionMax),
  "privacyLevel": zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY']),
  "allowComment": zod.boolean(),
  "allowDuet": zod.boolean(),
  "allowStitch": zod.boolean(),
  "commercialContent": zod.boolean(),
  "brandOrganic": zod.boolean(),
  "brandContent": zod.boolean(),
  "isAigc": zod.boolean(),
  "consentConfirmed": zod.literal(true).describe('Explicit creator consent to transfer this media and publish it to TikTok')
}).and(zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "creatorInfoCheckedAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional()
}),
  "publishResults": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['processing', 'published', 'failed', 'uncertain', 'unsupported']),
  "externalId": zod.string().nullish(),
  "providerStatus": zod.string().nullish(),
  "providerPostIds": zod.array(zod.string()).nullish(),
  "url": zod.string().nullish(),
  "error": zod.string().nullish(),
  "errorCode": zod.string().nullish(),
  "retryable": zod.boolean().nullish(),
  "attemptCount": zod.int().min(reconcileSocialPostResponseTwoPublishResultsItemAttemptCountMin).nullish(),
  "nextRetryAt": zod.iso.datetime({"offset":true}).nullish(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Publish all due approved posts
 */
export const runSocialPublishingQueueResponse = zod.object({
  "processed": zod.int()
})


/**
 * @summary Verify stored credentials for a connected network without publishing
 */
export const testSocialNetworkConnectionParams = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])
})

export const testSocialNetworkConnectionResponse = zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "connected": zod.boolean(),
  "ok": zod.boolean(),
  "reason": zod.string().nullish(),
  "detail": zod.string().nullish(),
  "testedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Read current TikTok creator eligibility and required publication controls
 */



export const getTikTokCreatorInfoResponseMaxVideoPostDurationSecMax = 600;



export const getTikTokCreatorInfoResponse = zod.object({
  "creatorUsername": zod.string().min(1),
  "creatorNickname": zod.string().min(1),
  "privacyLevelOptions": zod.array(zod.enum(['PUBLIC_TO_EVERYONE', 'MUTUAL_FOLLOW_FRIENDS', 'FOLLOWER_OF_CREATOR', 'SELF_ONLY'])).min(1),
  "commentDisabled": zod.boolean(),
  "duetDisabled": zod.boolean(),
  "stitchDisabled": zod.boolean(),
  "maxVideoPostDurationSec": zod.int().min(1).max(getTikTokCreatorInfoResponseMaxVideoPostDurationSecMax),
  "directPostAudited": zod.boolean().describe('Whether visibility beyond Only me is enabled for this application'),
  "verifiedMediaPrefixesConfigured": zod.boolean().describe('Whether server-side verified media URL prefixes are configured'),
  "checkedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Generate one AI draft post from grounded strategy when open drafts are below the cap
 */
export const runSocialAutoGenerationResponse = zod.object({
  "created": zod.int(),
  "reason": zod.enum(['open_draft_cap_reached', 'no_topic', 'already_running']).nullish(),
  "topic": zod.string().nullish(),
  "postId": zod.uuid().nullish(),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).optional()
})


/**
 * @summary List the unified social inbox
 */
export const listSocialInboxQueryLimitDefault = 25;
export const listSocialInboxQueryLimitMax = 100;

export const listSocialInboxQueryOffsetDefault = 0;
export const listSocialInboxQueryOffsetMin = 0;



export const listSocialInboxQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSocialInboxQueryLimitMax).default(listSocialInboxQueryLimitDefault),
  "offset": zod.int().min(listSocialInboxQueryOffsetMin).default(listSocialInboxQueryOffsetDefault),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']).optional(),
  "status": zod.enum(['unread', 'open', 'replied', 'archived']).optional()
})

export const listSocialInboxResponseTotalMin = 0;


export const listSocialInboxResponseOffsetMin = 0;



export const listSocialInboxResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "externalId": zod.string(),
  "externalPostId": zod.string().nullish(),
  "type": zod.enum(['comment', 'mention', 'dm']),
  "authorExternalId": zod.string(),
  "authorName": zod.string(),
  "authorEmail": zod.string().nullish(),
  "body": zod.string(),
  "receivedAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['unread', 'open', 'replied', 'archived']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullable(),
  "suggestedReply": zod.string().nullish(),
  "replyText": zod.string().nullish(),
  "repliedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSocialInboxResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listSocialInboxResponseOffsetMin)
})


/**
 * @summary Poll connected social networks and match authors to CRM contacts
 */
export const syncSocialInboxResponseSyncedMin = 0;

export const syncSocialInboxResponseNetworksItemImportedMin = 0;

export const syncSocialInboxResponseNetworksItemExaminedMin = 0;



export const syncSocialInboxResponse = zod.object({
  "synced": zod.int().min(syncSocialInboxResponseSyncedMin),
  "networks": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['completed', 'skipped', 'failed']),
  "imported": zod.int().min(syncSocialInboxResponseNetworksItemImportedMin),
  "examined": zod.int().min(syncSocialInboxResponseNetworksItemExaminedMin),
  "reason": zod.string().nullish()
}))
})


/**
 * @summary Generate an AI-suggested reply for human review
 */
export const suggestSocialReplyParams = zod.object({
  "id": zod.uuid()
})

export const suggestSocialReplyResponse = zod.object({
  "id": zod.uuid(),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "externalId": zod.string(),
  "externalPostId": zod.string().nullish(),
  "type": zod.enum(['comment', 'mention', 'dm']),
  "authorExternalId": zod.string(),
  "authorName": zod.string(),
  "authorEmail": zod.string().nullish(),
  "body": zod.string(),
  "receivedAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['unread', 'open', 'replied', 'archived']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullable(),
  "suggestedReply": zod.string().nullish(),
  "replyText": zod.string().nullish(),
  "repliedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Send a reviewed reply through the provider adapter
 */
export const replySocialInboxItemParams = zod.object({
  "id": zod.uuid()
})

export const replySocialInboxItemBodyReplyMax = 5000;



export const replySocialInboxItemBody = zod.object({
  "reply": zod.string().min(1).max(replySocialInboxItemBodyReplyMax),
  "requestId": zod.uuid()
})

export const replySocialInboxItemResponse = zod.object({
  "id": zod.uuid(),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "externalId": zod.string(),
  "externalPostId": zod.string().nullish(),
  "type": zod.enum(['comment', 'mention', 'dm']),
  "authorExternalId": zod.string(),
  "authorName": zod.string(),
  "authorEmail": zod.string().nullish(),
  "body": zod.string(),
  "receivedAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['unread', 'open', 'replied', 'archived']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullable(),
  "suggestedReply": zod.string().nullish(),
  "replyText": zod.string().nullish(),
  "repliedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Convert an inbox item into a CRM enquiry lead
 */
export const convertSocialInboxItemToLeadParams = zod.object({
  "id": zod.uuid()
})

export const convertSocialInboxItemToLeadBodyNameMax = 200;

export const convertSocialInboxItemToLeadBodySubjectMax = 300;

export const convertSocialInboxItemToLeadBodyMessageMax = 5000;



export const convertSocialInboxItemToLeadBody = zod.object({
  "requestId": zod.uuid(),
  "name": zod.string().min(1).max(convertSocialInboxItemToLeadBodyNameMax).optional(),
  "email": zod.email(),
  "subject": zod.string().min(1).max(convertSocialInboxItemToLeadBodySubjectMax).optional(),
  "message": zod.string().min(1).max(convertSocialInboxItemToLeadBodyMessageMax).optional()
})

export const convertSocialInboxItemToLeadResponseEnquiryContactAttemptsMin = 0;



export const convertSocialInboxItemToLeadResponse = zod.object({
  "inboxItem": zod.object({
  "id": zod.uuid(),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "externalId": zod.string(),
  "externalPostId": zod.string().nullish(),
  "type": zod.enum(['comment', 'mention', 'dm']),
  "authorExternalId": zod.string(),
  "authorName": zod.string(),
  "authorEmail": zod.string().nullish(),
  "body": zod.string(),
  "receivedAt": zod.iso.datetime({"offset":true}),
  "status": zod.enum(['unread', 'open', 'replied', 'archived']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullable(),
  "suggestedReply": zod.string().nullish(),
  "replyText": zod.string().nullish(),
  "repliedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "enquiry": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "phone": zod.string().nullish(),
  "companyName": zod.string().nullish(),
  "subject": zod.string(),
  "message": zod.string(),
  "status": zod.enum(['new', 'in_progress', 'converted', 'closed', 'confirmed', 'cancelled']),
  "source": zod.enum(['web_form', 'chat', 'manual', 'portal', 'social', 'voice', 'email']),
  "type": zod.enum(['general', 'booking']).describe('Distinguishes a general enquiry from a meeting/booking request (package Module E, folded into the existing enquiries pipeline).'),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']),
  "bookingProduct": zod.string().nullish(),
  "preferredAt": zod.iso.datetime({"offset":true}).nullish(),
  "assignedTo": zod.string().nullish(),
  "firstResponseDueAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactedAt": zod.iso.datetime({"offset":true}).nullish(),
  "contactAttempts": zod.int().min(convertSocialInboxItemToLeadResponseEnquiryContactAttemptsMin),
  "outcomeReason": zod.string().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
})


/**
 * @summary List approved messaging automation rules for the selected entity
 */
export const listSocialMessageRulesQueryLimitDefault = 25;
export const listSocialMessageRulesQueryLimitMax = 100;

export const listSocialMessageRulesQueryOffsetDefault = 0;
export const listSocialMessageRulesQueryOffsetMin = 0;



export const listSocialMessageRulesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSocialMessageRulesQueryLimitMax).default(listSocialMessageRulesQueryLimitDefault),
  "offset": zod.int().min(listSocialMessageRulesQueryOffsetMin).default(listSocialMessageRulesQueryOffsetDefault)
})

export const listSocialMessageRulesResponseItemsItemNameMax = 200;





export const listSocialMessageRulesResponseItemsItemCurrentKeywordsItemMax = 100;

export const listSocialMessageRulesResponseItemsItemCurrentKeywordsMax = 50;

export const listSocialMessageRulesResponseItemsItemCurrentReplyTemplateMax = 5000;


export const listSocialMessageRulesResponseItemsItemCurrentBlockedTermsItemMax = 100;

export const listSocialMessageRulesResponseItemsItemCurrentBlockedTermsMax = 100;

export const listSocialMessageRulesResponseItemsItemCurrentBlockedAuthorsItemMax = 255;

export const listSocialMessageRulesResponseItemsItemCurrentBlockedAuthorsMax = 100;

export const listSocialMessageRulesResponseItemsItemCurrentCooldownMinutesMin = 0;
export const listSocialMessageRulesResponseItemsItemCurrentCooldownMinutesMax = 43200;

export const listSocialMessageRulesResponseItemsItemCurrentDailyCapMax = 10000;


export const listSocialMessageRulesResponseTotalMin = 0;


export const listSocialMessageRulesResponseOffsetMin = 0;



export const listSocialMessageRulesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(listSocialMessageRulesResponseItemsItemNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'active', 'paused']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "activeVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "current": zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "keywords": zod.array(zod.string().min(1).max(listSocialMessageRulesResponseItemsItemCurrentKeywordsItemMax)).min(1).max(listSocialMessageRulesResponseItemsItemCurrentKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(listSocialMessageRulesResponseItemsItemCurrentReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(listSocialMessageRulesResponseItemsItemCurrentBlockedTermsItemMax)).max(listSocialMessageRulesResponseItemsItemCurrentBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(listSocialMessageRulesResponseItemsItemCurrentBlockedAuthorsItemMax)).max(listSocialMessageRulesResponseItemsItemCurrentBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(listSocialMessageRulesResponseItemsItemCurrentCooldownMinutesMin).max(listSocialMessageRulesResponseItemsItemCurrentCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(listSocialMessageRulesResponseItemsItemCurrentDailyCapMax),
  "createdBy": zod.string().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSocialMessageRulesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listSocialMessageRulesResponseOffsetMin)
})


/**
 * @summary Create an inert draft rule
 */
export const createSocialMessageRuleBodyNameMax = 200;

export const createSocialMessageRuleBodyKeywordsItemMax = 100;

export const createSocialMessageRuleBodyKeywordsMax = 50;

export const createSocialMessageRuleBodyReplyTemplateMax = 5000;


export const createSocialMessageRuleBodyBlockedTermsItemMax = 100;

export const createSocialMessageRuleBodyBlockedTermsMax = 100;

export const createSocialMessageRuleBodyBlockedAuthorsItemMax = 255;

export const createSocialMessageRuleBodyBlockedAuthorsMax = 100;

export const createSocialMessageRuleBodyCooldownMinutesMin = 0;
export const createSocialMessageRuleBodyCooldownMinutesMax = 43200;

export const createSocialMessageRuleBodyDailyCapMax = 10000;



export const createSocialMessageRuleBody = zod.object({
  "name": zod.string().min(1).max(createSocialMessageRuleBodyNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "keywords": zod.array(zod.string().min(1).max(createSocialMessageRuleBodyKeywordsItemMax)).min(1).max(createSocialMessageRuleBodyKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(createSocialMessageRuleBodyReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(createSocialMessageRuleBodyBlockedTermsItemMax)).max(createSocialMessageRuleBodyBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(createSocialMessageRuleBodyBlockedAuthorsItemMax)).max(createSocialMessageRuleBodyBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(createSocialMessageRuleBodyCooldownMinutesMin).max(createSocialMessageRuleBodyCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(createSocialMessageRuleBodyDailyCapMax)
})

export const createSocialMessageRuleResponseNameMax = 200;





export const createSocialMessageRuleResponseCurrentKeywordsItemMax = 100;

export const createSocialMessageRuleResponseCurrentKeywordsMax = 50;

export const createSocialMessageRuleResponseCurrentReplyTemplateMax = 5000;


export const createSocialMessageRuleResponseCurrentBlockedTermsItemMax = 100;

export const createSocialMessageRuleResponseCurrentBlockedTermsMax = 100;

export const createSocialMessageRuleResponseCurrentBlockedAuthorsItemMax = 255;

export const createSocialMessageRuleResponseCurrentBlockedAuthorsMax = 100;

export const createSocialMessageRuleResponseCurrentCooldownMinutesMin = 0;
export const createSocialMessageRuleResponseCurrentCooldownMinutesMax = 43200;

export const createSocialMessageRuleResponseCurrentDailyCapMax = 10000;




export const createSocialMessageRuleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(createSocialMessageRuleResponseNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'active', 'paused']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "activeVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "current": zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "keywords": zod.array(zod.string().min(1).max(createSocialMessageRuleResponseCurrentKeywordsItemMax)).min(1).max(createSocialMessageRuleResponseCurrentKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(createSocialMessageRuleResponseCurrentReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(createSocialMessageRuleResponseCurrentBlockedTermsItemMax)).max(createSocialMessageRuleResponseCurrentBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(createSocialMessageRuleResponseCurrentBlockedAuthorsItemMax)).max(createSocialMessageRuleResponseCurrentBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(createSocialMessageRuleResponseCurrentCooldownMinutesMin).max(createSocialMessageRuleResponseCurrentCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(createSocialMessageRuleResponseCurrentDailyCapMax),
  "createdBy": zod.string().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getSocialMessageRuleParams = zod.object({
  "id": zod.uuid()
})

export const getSocialMessageRuleResponseNameMax = 200;





export const getSocialMessageRuleResponseCurrentKeywordsItemMax = 100;

export const getSocialMessageRuleResponseCurrentKeywordsMax = 50;

export const getSocialMessageRuleResponseCurrentReplyTemplateMax = 5000;


export const getSocialMessageRuleResponseCurrentBlockedTermsItemMax = 100;

export const getSocialMessageRuleResponseCurrentBlockedTermsMax = 100;

export const getSocialMessageRuleResponseCurrentBlockedAuthorsItemMax = 255;

export const getSocialMessageRuleResponseCurrentBlockedAuthorsMax = 100;

export const getSocialMessageRuleResponseCurrentCooldownMinutesMin = 0;
export const getSocialMessageRuleResponseCurrentCooldownMinutesMax = 43200;

export const getSocialMessageRuleResponseCurrentDailyCapMax = 10000;




export const getSocialMessageRuleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(getSocialMessageRuleResponseNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'active', 'paused']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "activeVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "current": zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "keywords": zod.array(zod.string().min(1).max(getSocialMessageRuleResponseCurrentKeywordsItemMax)).min(1).max(getSocialMessageRuleResponseCurrentKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(getSocialMessageRuleResponseCurrentReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(getSocialMessageRuleResponseCurrentBlockedTermsItemMax)).max(getSocialMessageRuleResponseCurrentBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(getSocialMessageRuleResponseCurrentBlockedAuthorsItemMax)).max(getSocialMessageRuleResponseCurrentBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(getSocialMessageRuleResponseCurrentCooldownMinutesMin).max(getSocialMessageRuleResponseCurrentCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(getSocialMessageRuleResponseCurrentDailyCapMax),
  "createdBy": zod.string().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Create a new immutable draft version and invalidate approval
 */
export const updateSocialMessageRuleParams = zod.object({
  "id": zod.uuid()
})

export const updateSocialMessageRuleBodyOneNameMax = 200;

export const updateSocialMessageRuleBodyOneKeywordsItemMax = 100;

export const updateSocialMessageRuleBodyOneKeywordsMax = 50;

export const updateSocialMessageRuleBodyOneReplyTemplateMax = 5000;


export const updateSocialMessageRuleBodyOneBlockedTermsItemMax = 100;

export const updateSocialMessageRuleBodyOneBlockedTermsMax = 100;

export const updateSocialMessageRuleBodyOneBlockedAuthorsItemMax = 255;

export const updateSocialMessageRuleBodyOneBlockedAuthorsMax = 100;

export const updateSocialMessageRuleBodyOneCooldownMinutesMin = 0;
export const updateSocialMessageRuleBodyOneCooldownMinutesMax = 43200;

export const updateSocialMessageRuleBodyOneDailyCapMax = 10000;




export const updateSocialMessageRuleBody = zod.object({
  "name": zod.string().min(1).max(updateSocialMessageRuleBodyOneNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "keywords": zod.array(zod.string().min(1).max(updateSocialMessageRuleBodyOneKeywordsItemMax)).min(1).max(updateSocialMessageRuleBodyOneKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(updateSocialMessageRuleBodyOneReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(updateSocialMessageRuleBodyOneBlockedTermsItemMax)).max(updateSocialMessageRuleBodyOneBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(updateSocialMessageRuleBodyOneBlockedAuthorsItemMax)).max(updateSocialMessageRuleBodyOneBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(updateSocialMessageRuleBodyOneCooldownMinutesMin).max(updateSocialMessageRuleBodyOneCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(updateSocialMessageRuleBodyOneDailyCapMax)
}).and(zod.object({
  "expectedVersion": zod.int().min(1)
}))

export const updateSocialMessageRuleResponseNameMax = 200;





export const updateSocialMessageRuleResponseCurrentKeywordsItemMax = 100;

export const updateSocialMessageRuleResponseCurrentKeywordsMax = 50;

export const updateSocialMessageRuleResponseCurrentReplyTemplateMax = 5000;


export const updateSocialMessageRuleResponseCurrentBlockedTermsItemMax = 100;

export const updateSocialMessageRuleResponseCurrentBlockedTermsMax = 100;

export const updateSocialMessageRuleResponseCurrentBlockedAuthorsItemMax = 255;

export const updateSocialMessageRuleResponseCurrentBlockedAuthorsMax = 100;

export const updateSocialMessageRuleResponseCurrentCooldownMinutesMin = 0;
export const updateSocialMessageRuleResponseCurrentCooldownMinutesMax = 43200;

export const updateSocialMessageRuleResponseCurrentDailyCapMax = 10000;




export const updateSocialMessageRuleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(updateSocialMessageRuleResponseNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'active', 'paused']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "activeVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "current": zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "keywords": zod.array(zod.string().min(1).max(updateSocialMessageRuleResponseCurrentKeywordsItemMax)).min(1).max(updateSocialMessageRuleResponseCurrentKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(updateSocialMessageRuleResponseCurrentReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(updateSocialMessageRuleResponseCurrentBlockedTermsItemMax)).max(updateSocialMessageRuleResponseCurrentBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(updateSocialMessageRuleResponseCurrentBlockedAuthorsItemMax)).max(updateSocialMessageRuleResponseCurrentBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(updateSocialMessageRuleResponseCurrentCooldownMinutesMin).max(updateSocialMessageRuleResponseCurrentCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(updateSocialMessageRuleResponseCurrentDailyCapMax),
  "createdBy": zod.string().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const previewSocialMessageRuleParams = zod.object({
  "id": zod.uuid()
})

export const previewSocialMessageRuleBodyTextMax = 10000;

export const previewSocialMessageRuleBodyAuthorExternalIdMax = 255;



export const previewSocialMessageRuleBody = zod.object({
  "text": zod.string().min(1).max(previewSocialMessageRuleBodyTextMax),
  "authorExternalId": zod.string().min(1).max(previewSocialMessageRuleBodyAuthorExternalIdMax),
  "itemType": zod.enum(['comment', 'mention', 'dm'])
})

export const previewSocialMessageRuleResponse = zod.object({
  "matched": zod.boolean(),
  "outcome": zod.enum(['matched', 'skipped', 'blocked']),
  "reason": zod.string(),
  "renderedReply": zod.string().nullable()
})


export const submitSocialMessageRuleParams = zod.object({
  "id": zod.uuid()
})


export const submitSocialMessageRuleBodyReasonMax = 1000;



export const submitSocialMessageRuleBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "reason": zod.string().max(submitSocialMessageRuleBodyReasonMax).optional()
})

export const submitSocialMessageRuleResponseNameMax = 200;





export const submitSocialMessageRuleResponseCurrentKeywordsItemMax = 100;

export const submitSocialMessageRuleResponseCurrentKeywordsMax = 50;

export const submitSocialMessageRuleResponseCurrentReplyTemplateMax = 5000;


export const submitSocialMessageRuleResponseCurrentBlockedTermsItemMax = 100;

export const submitSocialMessageRuleResponseCurrentBlockedTermsMax = 100;

export const submitSocialMessageRuleResponseCurrentBlockedAuthorsItemMax = 255;

export const submitSocialMessageRuleResponseCurrentBlockedAuthorsMax = 100;

export const submitSocialMessageRuleResponseCurrentCooldownMinutesMin = 0;
export const submitSocialMessageRuleResponseCurrentCooldownMinutesMax = 43200;

export const submitSocialMessageRuleResponseCurrentDailyCapMax = 10000;




export const submitSocialMessageRuleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(submitSocialMessageRuleResponseNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'active', 'paused']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "activeVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "current": zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "keywords": zod.array(zod.string().min(1).max(submitSocialMessageRuleResponseCurrentKeywordsItemMax)).min(1).max(submitSocialMessageRuleResponseCurrentKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(submitSocialMessageRuleResponseCurrentReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(submitSocialMessageRuleResponseCurrentBlockedTermsItemMax)).max(submitSocialMessageRuleResponseCurrentBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(submitSocialMessageRuleResponseCurrentBlockedAuthorsItemMax)).max(submitSocialMessageRuleResponseCurrentBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(submitSocialMessageRuleResponseCurrentCooldownMinutesMin).max(submitSocialMessageRuleResponseCurrentCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(submitSocialMessageRuleResponseCurrentDailyCapMax),
  "createdBy": zod.string().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Approve the current immutable version as the authenticated administrator
 */
export const approveSocialMessageRuleParams = zod.object({
  "id": zod.uuid()
})


export const approveSocialMessageRuleBodyReasonMax = 1000;



export const approveSocialMessageRuleBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "reason": zod.string().max(approveSocialMessageRuleBodyReasonMax).optional()
})

export const approveSocialMessageRuleResponseNameMax = 200;





export const approveSocialMessageRuleResponseCurrentKeywordsItemMax = 100;

export const approveSocialMessageRuleResponseCurrentKeywordsMax = 50;

export const approveSocialMessageRuleResponseCurrentReplyTemplateMax = 5000;


export const approveSocialMessageRuleResponseCurrentBlockedTermsItemMax = 100;

export const approveSocialMessageRuleResponseCurrentBlockedTermsMax = 100;

export const approveSocialMessageRuleResponseCurrentBlockedAuthorsItemMax = 255;

export const approveSocialMessageRuleResponseCurrentBlockedAuthorsMax = 100;

export const approveSocialMessageRuleResponseCurrentCooldownMinutesMin = 0;
export const approveSocialMessageRuleResponseCurrentCooldownMinutesMax = 43200;

export const approveSocialMessageRuleResponseCurrentDailyCapMax = 10000;




export const approveSocialMessageRuleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(approveSocialMessageRuleResponseNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'active', 'paused']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "activeVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "current": zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "keywords": zod.array(zod.string().min(1).max(approveSocialMessageRuleResponseCurrentKeywordsItemMax)).min(1).max(approveSocialMessageRuleResponseCurrentKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(approveSocialMessageRuleResponseCurrentReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(approveSocialMessageRuleResponseCurrentBlockedTermsItemMax)).max(approveSocialMessageRuleResponseCurrentBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(approveSocialMessageRuleResponseCurrentBlockedAuthorsItemMax)).max(approveSocialMessageRuleResponseCurrentBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(approveSocialMessageRuleResponseCurrentCooldownMinutesMin).max(approveSocialMessageRuleResponseCurrentCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(approveSocialMessageRuleResponseCurrentDailyCapMax),
  "createdBy": zod.string().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Activate only the currently approved version
 */
export const activateSocialMessageRuleParams = zod.object({
  "id": zod.uuid()
})


export const activateSocialMessageRuleBodyReasonMax = 1000;



export const activateSocialMessageRuleBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "reason": zod.string().max(activateSocialMessageRuleBodyReasonMax).optional()
})

export const activateSocialMessageRuleResponseNameMax = 200;





export const activateSocialMessageRuleResponseCurrentKeywordsItemMax = 100;

export const activateSocialMessageRuleResponseCurrentKeywordsMax = 50;

export const activateSocialMessageRuleResponseCurrentReplyTemplateMax = 5000;


export const activateSocialMessageRuleResponseCurrentBlockedTermsItemMax = 100;

export const activateSocialMessageRuleResponseCurrentBlockedTermsMax = 100;

export const activateSocialMessageRuleResponseCurrentBlockedAuthorsItemMax = 255;

export const activateSocialMessageRuleResponseCurrentBlockedAuthorsMax = 100;

export const activateSocialMessageRuleResponseCurrentCooldownMinutesMin = 0;
export const activateSocialMessageRuleResponseCurrentCooldownMinutesMax = 43200;

export const activateSocialMessageRuleResponseCurrentDailyCapMax = 10000;




export const activateSocialMessageRuleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(activateSocialMessageRuleResponseNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'active', 'paused']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "activeVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "current": zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "keywords": zod.array(zod.string().min(1).max(activateSocialMessageRuleResponseCurrentKeywordsItemMax)).min(1).max(activateSocialMessageRuleResponseCurrentKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(activateSocialMessageRuleResponseCurrentReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(activateSocialMessageRuleResponseCurrentBlockedTermsItemMax)).max(activateSocialMessageRuleResponseCurrentBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(activateSocialMessageRuleResponseCurrentBlockedAuthorsItemMax)).max(activateSocialMessageRuleResponseCurrentBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(activateSocialMessageRuleResponseCurrentCooldownMinutesMin).max(activateSocialMessageRuleResponseCurrentCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(activateSocialMessageRuleResponseCurrentDailyCapMax),
  "createdBy": zod.string().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const pauseSocialMessageRuleParams = zod.object({
  "id": zod.uuid()
})


export const pauseSocialMessageRuleBodyReasonMax = 1000;



export const pauseSocialMessageRuleBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "reason": zod.string().max(pauseSocialMessageRuleBodyReasonMax).optional()
})

export const pauseSocialMessageRuleResponseNameMax = 200;





export const pauseSocialMessageRuleResponseCurrentKeywordsItemMax = 100;

export const pauseSocialMessageRuleResponseCurrentKeywordsMax = 50;

export const pauseSocialMessageRuleResponseCurrentReplyTemplateMax = 5000;


export const pauseSocialMessageRuleResponseCurrentBlockedTermsItemMax = 100;

export const pauseSocialMessageRuleResponseCurrentBlockedTermsMax = 100;

export const pauseSocialMessageRuleResponseCurrentBlockedAuthorsItemMax = 255;

export const pauseSocialMessageRuleResponseCurrentBlockedAuthorsMax = 100;

export const pauseSocialMessageRuleResponseCurrentCooldownMinutesMin = 0;
export const pauseSocialMessageRuleResponseCurrentCooldownMinutesMax = 43200;

export const pauseSocialMessageRuleResponseCurrentDailyCapMax = 10000;




export const pauseSocialMessageRuleResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string().min(1).max(pauseSocialMessageRuleResponseNameMax),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "status": zod.enum(['draft', 'pending_approval', 'approved', 'active', 'paused']),
  "currentVersion": zod.int().min(1),
  "approvedVersion": zod.int().min(1).nullable(),
  "activeVersion": zod.int().min(1).nullable(),
  "approvedBy": zod.string().nullable(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullable(),
  "current": zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "keywords": zod.array(zod.string().min(1).max(pauseSocialMessageRuleResponseCurrentKeywordsItemMax)).min(1).max(pauseSocialMessageRuleResponseCurrentKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(pauseSocialMessageRuleResponseCurrentReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(pauseSocialMessageRuleResponseCurrentBlockedTermsItemMax)).max(pauseSocialMessageRuleResponseCurrentBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(pauseSocialMessageRuleResponseCurrentBlockedAuthorsItemMax)).max(pauseSocialMessageRuleResponseCurrentBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(pauseSocialMessageRuleResponseCurrentCooldownMinutesMin).max(pauseSocialMessageRuleResponseCurrentCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(pauseSocialMessageRuleResponseCurrentDailyCapMax),
  "createdBy": zod.string().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listSocialMessageRuleHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listSocialMessageRuleHistoryQueryLimitDefault = 25;
export const listSocialMessageRuleHistoryQueryLimitMax = 100;

export const listSocialMessageRuleHistoryQueryOffsetDefault = 0;
export const listSocialMessageRuleHistoryQueryOffsetMin = 0;



export const listSocialMessageRuleHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSocialMessageRuleHistoryQueryLimitMax).default(listSocialMessageRuleHistoryQueryLimitDefault),
  "offset": zod.int().min(listSocialMessageRuleHistoryQueryOffsetMin).default(listSocialMessageRuleHistoryQueryOffsetDefault)
})


export const listSocialMessageRuleHistoryResponseItemsItemKeywordsItemMax = 100;

export const listSocialMessageRuleHistoryResponseItemsItemKeywordsMax = 50;

export const listSocialMessageRuleHistoryResponseItemsItemReplyTemplateMax = 5000;


export const listSocialMessageRuleHistoryResponseItemsItemBlockedTermsItemMax = 100;

export const listSocialMessageRuleHistoryResponseItemsItemBlockedTermsMax = 100;

export const listSocialMessageRuleHistoryResponseItemsItemBlockedAuthorsItemMax = 255;

export const listSocialMessageRuleHistoryResponseItemsItemBlockedAuthorsMax = 100;

export const listSocialMessageRuleHistoryResponseItemsItemCooldownMinutesMin = 0;
export const listSocialMessageRuleHistoryResponseItemsItemCooldownMinutesMax = 43200;

export const listSocialMessageRuleHistoryResponseItemsItemDailyCapMax = 10000;


export const listSocialMessageRuleHistoryResponseTotalMin = 0;


export const listSocialMessageRuleHistoryResponseOffsetMin = 0;



export const listSocialMessageRuleHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "keywords": zod.array(zod.string().min(1).max(listSocialMessageRuleHistoryResponseItemsItemKeywordsItemMax)).min(1).max(listSocialMessageRuleHistoryResponseItemsItemKeywordsMax),
  "matchMode": zod.enum(['any', 'all']),
  "caseSensitive": zod.boolean(),
  "replyTemplate": zod.string().min(1).max(listSocialMessageRuleHistoryResponseItemsItemReplyTemplateMax),
  "allowedItemTypes": zod.array(zod.enum(['comment', 'mention', 'dm'])).min(1),
  "blockedTerms": zod.array(zod.string().min(1).max(listSocialMessageRuleHistoryResponseItemsItemBlockedTermsItemMax)).max(listSocialMessageRuleHistoryResponseItemsItemBlockedTermsMax),
  "blockedAuthors": zod.array(zod.string().min(1).max(listSocialMessageRuleHistoryResponseItemsItemBlockedAuthorsItemMax)).max(listSocialMessageRuleHistoryResponseItemsItemBlockedAuthorsMax),
  "cooldownMinutes": zod.int().min(listSocialMessageRuleHistoryResponseItemsItemCooldownMinutesMin).max(listSocialMessageRuleHistoryResponseItemsItemCooldownMinutesMax),
  "dailyCap": zod.int().min(1).max(listSocialMessageRuleHistoryResponseItemsItemDailyCapMax),
  "createdBy": zod.string().min(1),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSocialMessageRuleHistoryResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listSocialMessageRuleHistoryResponseOffsetMin)
})


export const listSocialMessageRuleExecutionsQueryLimitDefault = 25;
export const listSocialMessageRuleExecutionsQueryLimitMax = 100;

export const listSocialMessageRuleExecutionsQueryOffsetDefault = 0;
export const listSocialMessageRuleExecutionsQueryOffsetMin = 0;



export const listSocialMessageRuleExecutionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSocialMessageRuleExecutionsQueryLimitMax).default(listSocialMessageRuleExecutionsQueryLimitDefault),
  "offset": zod.int().min(listSocialMessageRuleExecutionsQueryOffsetMin).default(listSocialMessageRuleExecutionsQueryOffsetDefault)
})


export const listSocialMessageRuleExecutionsResponseTotalMin = 0;


export const listSocialMessageRuleExecutionsResponseOffsetMin = 0;



export const listSocialMessageRuleExecutionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "ruleId": zod.uuid().nullable(),
  "ruleVersion": zod.int().min(1).nullable(),
  "inboxItemId": zod.uuid(),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "outcome": zod.enum(['matched', 'skipped', 'blocked', 'dispatching', 'failed', 'completed', 'uncertain']),
  "reasonCode": zod.string(),
  "reason": zod.string(),
  "externalReplyId": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int().min(listSocialMessageRuleExecutionsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listSocialMessageRuleExecutionsResponseOffsetMin)
})


/**
 * @summary Process eligible inbox items through approved active rules
 */
export const runSocialMessageAutomationResponseProcessedMin = 0;

export const runSocialMessageAutomationResponseCompletedMin = 0;

export const runSocialMessageAutomationResponseBlockedMin = 0;

export const runSocialMessageAutomationResponseSkippedMin = 0;

export const runSocialMessageAutomationResponseFailedMin = 0;



export const runSocialMessageAutomationResponse = zod.object({
  "processed": zod.int().min(runSocialMessageAutomationResponseProcessedMin),
  "completed": zod.int().min(runSocialMessageAutomationResponseCompletedMin),
  "blocked": zod.int().min(runSocialMessageAutomationResponseBlockedMin),
  "skipped": zod.int().min(runSocialMessageAutomationResponseSkippedMin),
  "failed": zod.int().min(runSocialMessageAutomationResponseFailedMin)
})


/**
 * @summary Get per-network and per-post social metrics
 */
export const getSocialAnalyticsResponse = zod.object({
  "networks": zod.array(zod.object({
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "posts": zod.int(),
  "impressions": zod.int(),
  "engagement": zod.int()
})),
  "posts": zod.array(zod.object({
  "socialPostId": zod.uuid(),
  "network": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok']),
  "impressions": zod.int(),
  "reach": zod.int(),
  "reactions": zod.int(),
  "comments": zod.int(),
  "shares": zod.int(),
  "clicks": zod.int(),
  "views": zod.int(),
  "metricAvailability": zod.record(zod.string(), zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported'])),
  "sourceStatus": zod.enum(['measured', 'unmeasured', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "syncedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Refresh metrics for published posts
 */
export const syncSocialAnalyticsResponse = zod.object({
  "synced": zod.int()
})


/**
 * @summary Get Microsoft 365 mailbox connection and throttle status
 */
export const getEmailConnectionResponse = zod.object({
  "status": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "providerKey": zod.string(),
  "connected": zod.boolean(),
  "mailboxAddress": zod.string().nullish(),
  "displayName": zod.string().nullish(),
  "dailyLimit": zod.int(),
  "sentToday": zod.int(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "healthAutomationReady": zod.boolean(),
  "healthAutomationBlockedReason": zod.string().nullable()
})


/**
 * @summary Start delegated Microsoft Graph mailbox consent
 */
export const startMicrosoft365EmailOAuthResponse = zod.object({
  "authorizationUrl": zod.url()
})


/**
 * @summary Complete delegated Microsoft Graph mailbox consent
 */
export const completeMicrosoft365EmailOAuthQueryParams = zod.object({
  "code": zod.string(),
  "state": zod.string()
})

export const completeMicrosoft365EmailOAuthResponse = zod.void()


/**
 * @summary Send a connection test through the configured provider
 */
export const sendTestEmailBodySubjectMax = 998;




export const sendTestEmailBody = zod.object({
  "to": zod.email(),
  "subject": zod.string().min(1).max(sendTestEmailBodySubjectMax),
  "body": zod.string().min(1)
})

export const sendTestEmailResponse = zod.object({
  "id": zod.uuid(),
  "providerKey": zod.string(),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['test', 'sequence', 'campaign', 'review_request', 'reply', 'health_outreach', 'mailbox_intake']),
  "campaignStepId": zod.uuid().nullish(),
  "intakeMailboxId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "parentMessageId": zod.uuid().nullish(),
  "interactionId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "fromAddress": zod.string(),
  "toAddress": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "status": zod.enum(['queued', 'sent', 'delivered', 'failed', 'replied', 'unknown']),
  "trackingToken": zod.uuid(),
  "openCount": zod.int(),
  "clickCount": zod.int(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}).describe('Campaign steps use campaignStepId; sequence steps retain their existing stepId linkage.')



export const listEmailSequencesResponseItemsItemOneDailyLimitMax = 500;



export const listEmailSequencesResponseItemsItemTwoStepsItemOneDelayMinutesMin = 0;

export const listEmailSequencesResponseItemsItemTwoStepsItemOneVariantsItemWeightMax = 100;



export const listEmailSequencesResponse = zod.object({
  "items": zod.array(zod.object({
  "name": zod.string().min(1),
  "description": zod.string().optional(),
  "status": zod.enum(['draft', 'active', 'paused', 'archived']),
  "stopOnReply": zod.boolean(),
  "dailyLimit": zod.int().min(1).max(listEmailSequencesResponseItemsItemOneDailyLimitMax)
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'active', 'paused', 'archived']),
  "stopOnReply": zod.boolean(),
  "providerKey": zod.string(),
  "dailyLimit": zod.int(),
  "steps": zod.array(zod.object({
  "position": zod.int().min(1),
  "type": zod.enum(['email', 'wait', 'condition']),
  "name": zod.string().min(1),
  "subject": zod.string().optional(),
  "body": zod.string().optional(),
  "delayMinutes": zod.int().min(listEmailSequencesResponseItemsItemTwoStepsItemOneDelayMinutesMin),
  "condition": zod.enum(['opened', 'replied', 'not_opened', 'not_replied']).nullish(),
  "trueStepPosition": zod.int().nullish(),
  "falseStepPosition": zod.int().nullish(),
  "variants": zod.array(zod.object({
  "key": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "weight": zod.int().min(1).max(listEmailSequencesResponseItemsItemTwoStepsItemOneVariantsItemWeightMax)
})),
  "aiAuditId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sequenceId": zod.uuid(),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})))
})



export const createEmailSequenceBodyDailyLimitMax = 500;



export const createEmailSequenceBody = zod.object({
  "name": zod.string().min(1),
  "description": zod.string().optional(),
  "status": zod.enum(['draft', 'active', 'paused', 'archived']).optional(),
  "stopOnReply": zod.boolean().optional(),
  "dailyLimit": zod.int().min(1).max(createEmailSequenceBodyDailyLimitMax).optional()
})


export const createEmailSequenceResponseOneDailyLimitMax = 500;



export const createEmailSequenceResponseTwoStepsItemOneDelayMinutesMin = 0;

export const createEmailSequenceResponseTwoStepsItemOneVariantsItemWeightMax = 100;



export const createEmailSequenceResponse = zod.object({
  "name": zod.string().min(1),
  "description": zod.string().optional(),
  "status": zod.enum(['draft', 'active', 'paused', 'archived']),
  "stopOnReply": zod.boolean(),
  "dailyLimit": zod.int().min(1).max(createEmailSequenceResponseOneDailyLimitMax)
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'active', 'paused', 'archived']),
  "stopOnReply": zod.boolean(),
  "providerKey": zod.string(),
  "dailyLimit": zod.int(),
  "steps": zod.array(zod.object({
  "position": zod.int().min(1),
  "type": zod.enum(['email', 'wait', 'condition']),
  "name": zod.string().min(1),
  "subject": zod.string().optional(),
  "body": zod.string().optional(),
  "delayMinutes": zod.int().min(createEmailSequenceResponseTwoStepsItemOneDelayMinutesMin),
  "condition": zod.enum(['opened', 'replied', 'not_opened', 'not_replied']).nullish(),
  "trueStepPosition": zod.int().nullish(),
  "falseStepPosition": zod.int().nullish(),
  "variants": zod.array(zod.object({
  "key": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "weight": zod.int().min(1).max(createEmailSequenceResponseTwoStepsItemOneVariantsItemWeightMax)
})),
  "aiAuditId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sequenceId": zod.uuid(),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


export const updateEmailSequenceParams = zod.object({
  "id": zod.uuid()
})

export const updateEmailSequenceBodyNameMax = 200;

export const updateEmailSequenceBodyDescriptionMax = 2000;

export const updateEmailSequenceBodyDailyLimitMax = 500;



export const updateEmailSequenceBody = zod.object({
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "name": zod.string().min(1).max(updateEmailSequenceBodyNameMax).optional(),
  "description": zod.string().max(updateEmailSequenceBodyDescriptionMax).nullish(),
  "status": zod.enum(['draft', 'active', 'paused', 'archived']).optional(),
  "stopOnReply": zod.boolean().optional(),
  "dailyLimit": zod.int().min(1).max(updateEmailSequenceBodyDailyLimitMax).optional()
})


export const updateEmailSequenceResponseOneDailyLimitMax = 500;



export const updateEmailSequenceResponseTwoStepsItemOneDelayMinutesMin = 0;

export const updateEmailSequenceResponseTwoStepsItemOneVariantsItemWeightMax = 100;



export const updateEmailSequenceResponse = zod.object({
  "name": zod.string().min(1),
  "description": zod.string().optional(),
  "status": zod.enum(['draft', 'active', 'paused', 'archived']),
  "stopOnReply": zod.boolean(),
  "dailyLimit": zod.int().min(1).max(updateEmailSequenceResponseOneDailyLimitMax)
}).and(zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'active', 'paused', 'archived']),
  "stopOnReply": zod.boolean(),
  "providerKey": zod.string(),
  "dailyLimit": zod.int(),
  "steps": zod.array(zod.object({
  "position": zod.int().min(1),
  "type": zod.enum(['email', 'wait', 'condition']),
  "name": zod.string().min(1),
  "subject": zod.string().optional(),
  "body": zod.string().optional(),
  "delayMinutes": zod.int().min(updateEmailSequenceResponseTwoStepsItemOneDelayMinutesMin),
  "condition": zod.enum(['opened', 'replied', 'not_opened', 'not_replied']).nullish(),
  "trueStepPosition": zod.int().nullish(),
  "falseStepPosition": zod.int().nullish(),
  "variants": zod.array(zod.object({
  "key": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "weight": zod.int().min(1).max(updateEmailSequenceResponseTwoStepsItemOneVariantsItemWeightMax)
})),
  "aiAuditId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sequenceId": zod.uuid(),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


export const addEmailSequenceStepParams = zod.object({
  "id": zod.uuid()
})



export const addEmailSequenceStepBodyDelayMinutesMin = 0;

export const addEmailSequenceStepBodyVariantsItemWeightMax = 100;



export const addEmailSequenceStepBody = zod.object({
  "position": zod.int().min(1),
  "type": zod.enum(['email', 'wait', 'condition']),
  "name": zod.string().min(1),
  "subject": zod.string().optional(),
  "body": zod.string().optional(),
  "delayMinutes": zod.int().min(addEmailSequenceStepBodyDelayMinutesMin).optional(),
  "condition": zod.enum(['opened', 'replied', 'not_opened', 'not_replied']).nullish(),
  "trueStepPosition": zod.int().nullish(),
  "falseStepPosition": zod.int().nullish(),
  "variants": zod.array(zod.object({
  "key": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "weight": zod.int().min(1).max(addEmailSequenceStepBodyVariantsItemWeightMax)
})).optional(),
  "aiAuditId": zod.uuid().nullish()
})



export const addEmailSequenceStepResponseOneDelayMinutesMin = 0;

export const addEmailSequenceStepResponseOneVariantsItemWeightMax = 100;



export const addEmailSequenceStepResponse = zod.object({
  "position": zod.int().min(1),
  "type": zod.enum(['email', 'wait', 'condition']),
  "name": zod.string().min(1),
  "subject": zod.string().optional(),
  "body": zod.string().optional(),
  "delayMinutes": zod.int().min(addEmailSequenceStepResponseOneDelayMinutesMin),
  "condition": zod.enum(['opened', 'replied', 'not_opened', 'not_replied']).nullish(),
  "trueStepPosition": zod.int().nullish(),
  "falseStepPosition": zod.int().nullish(),
  "variants": zod.array(zod.object({
  "key": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "weight": zod.int().min(1).max(addEmailSequenceStepResponseOneVariantsItemWeightMax)
})),
  "aiAuditId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sequenceId": zod.uuid(),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


export const enrollEmailSequenceParams = zod.object({
  "id": zod.uuid()
})

export const enrollEmailSequenceBody = zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
})

export const enrollEmailSequenceResponse = zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sequenceId": zod.uuid(),
  "status": zod.enum(['active', 'paused', 'completed', 'replied', 'stopped', 'suppressed', 'failed']),
  "currentStepPosition": zod.int(),
  "nextActionAt": zod.iso.datetime({"offset":true}),
  "stoppedReason": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


export const listEmailSequenceEnrollmentsParams = zod.object({
  "id": zod.uuid()
})

export const listEmailSequenceEnrollmentsQueryLimitDefault = 25;
export const listEmailSequenceEnrollmentsQueryLimitMax = 100;

export const listEmailSequenceEnrollmentsQueryOffsetDefault = 0;
export const listEmailSequenceEnrollmentsQueryOffsetMin = 0;



export const listEmailSequenceEnrollmentsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEmailSequenceEnrollmentsQueryLimitMax).default(listEmailSequenceEnrollmentsQueryLimitDefault),
  "offset": zod.int().min(listEmailSequenceEnrollmentsQueryOffsetMin).default(listEmailSequenceEnrollmentsQueryOffsetDefault)
})

export const listEmailSequenceEnrollmentsResponseTotalMin = 0;


export const listEmailSequenceEnrollmentsResponseOffsetMin = 0;



export const listEmailSequenceEnrollmentsResponse = zod.object({
  "items": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sequenceId": zod.uuid(),
  "status": zod.enum(['active', 'paused', 'completed', 'replied', 'stopped', 'suppressed', 'failed']),
  "currentStepPosition": zod.int(),
  "nextActionAt": zod.iso.datetime({"offset":true}),
  "stoppedReason": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "total": zod.int().min(listEmailSequenceEnrollmentsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listEmailSequenceEnrollmentsResponseOffsetMin)
})


export const updateEmailSequenceEnrollmentParams = zod.object({
  "id": zod.uuid(),
  "enrollmentId": zod.uuid()
})

export const updateEmailSequenceEnrollmentBodyReasonMin = 3;
export const updateEmailSequenceEnrollmentBodyReasonMax = 500;



export const updateEmailSequenceEnrollmentBody = zod.object({
  "action": zod.enum(['pause', 'resume', 'stop']),
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(updateEmailSequenceEnrollmentBodyReasonMin).max(updateEmailSequenceEnrollmentBodyReasonMax)
})

export const updateEmailSequenceEnrollmentResponse = zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
}).and(zod.object({
  "id": zod.uuid(),
  "sequenceId": zod.uuid(),
  "status": zod.enum(['active', 'paused', 'completed', 'replied', 'stopped', 'suppressed', 'failed']),
  "currentStepPosition": zod.int(),
  "nextActionAt": zod.iso.datetime({"offset":true}),
  "stoppedReason": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


export const runEmailSequenceEngineResponse = zod.object({
  "processed": zod.int(),
  "sent": zod.int()
})


export const getCampaignBriefParams = zod.object({
  "id": zod.uuid()
})

export const getCampaignBriefResponseFieldsObjectiveMax = 5000;

export const getCampaignBriefResponseFieldsSuccessMeasureMax = 5000;

export const getCampaignBriefResponseFieldsOfferMax = 5000;

export const getCampaignBriefResponseFieldsAudienceRationaleMax = 5000;

export const getCampaignBriefResponseFieldsThemesItemMax = 1000;

export const getCampaignBriefResponseFieldsThemesMax = 50;

export const getCampaignBriefResponseFieldsOutputsMax = 14;

export const getCampaignBriefResponseFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const getCampaignBriefResponseFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getCampaignBriefResponseFieldsUnknownsItemMax = 1000;

export const getCampaignBriefResponseFieldsUnknownsMax = 50;

export const getCampaignBriefResponseFieldsEvidenceItemRevisionMax = 100;

export const getCampaignBriefResponseFieldsEvidenceMax = 50;

export const getCampaignBriefResponseFieldsContentItemRevisionMax = 100;

export const getCampaignBriefResponseFieldsContentMax = 50;

export const getCampaignBriefResponseFieldsAudienceOneContactIdsMax = 20000;

export const getCampaignBriefResponseFieldsAudienceOneExcludedContactIdsMax = 20000;

export const getCampaignBriefResponseFieldsAudienceOneChannelsMax = 3;



export const getCampaignBriefResponse = zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(getCampaignBriefResponseFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(getCampaignBriefResponseFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(getCampaignBriefResponseFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(getCampaignBriefResponseFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(getCampaignBriefResponseFieldsThemesItemMax)).max(getCampaignBriefResponseFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(getCampaignBriefResponseFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(getCampaignBriefResponseFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(getCampaignBriefResponseFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(getCampaignBriefResponseFieldsUnknownsItemMax)).max(getCampaignBriefResponseFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefResponseFieldsEvidenceItemRevisionMax)
})).max(getCampaignBriefResponseFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefResponseFieldsContentItemRevisionMax)
})).max(getCampaignBriefResponseFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(getCampaignBriefResponseFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(getCampaignBriefResponseFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(getCampaignBriefResponseFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
})


export const listCampaignBriefHistoryParams = zod.object({
  "id": zod.uuid()
})

export const listCampaignBriefHistoryQueryLimitDefault = 25;
export const listCampaignBriefHistoryQueryLimitMax = 100;

export const listCampaignBriefHistoryQueryOffsetDefault = 0;
export const listCampaignBriefHistoryQueryOffsetMin = 0;



export const listCampaignBriefHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listCampaignBriefHistoryQueryLimitMax).default(listCampaignBriefHistoryQueryLimitDefault),
  "offset": zod.int().min(listCampaignBriefHistoryQueryOffsetMin).default(listCampaignBriefHistoryQueryOffsetDefault)
})

export const listCampaignBriefHistoryResponseItemsItemFieldsObjectiveMax = 5000;

export const listCampaignBriefHistoryResponseItemsItemFieldsSuccessMeasureMax = 5000;

export const listCampaignBriefHistoryResponseItemsItemFieldsOfferMax = 5000;

export const listCampaignBriefHistoryResponseItemsItemFieldsAudienceRationaleMax = 5000;

export const listCampaignBriefHistoryResponseItemsItemFieldsThemesItemMax = 1000;

export const listCampaignBriefHistoryResponseItemsItemFieldsThemesMax = 50;

export const listCampaignBriefHistoryResponseItemsItemFieldsOutputsMax = 14;

export const listCampaignBriefHistoryResponseItemsItemFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const listCampaignBriefHistoryResponseItemsItemFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listCampaignBriefHistoryResponseItemsItemFieldsUnknownsItemMax = 1000;

export const listCampaignBriefHistoryResponseItemsItemFieldsUnknownsMax = 50;

export const listCampaignBriefHistoryResponseItemsItemFieldsEvidenceItemRevisionMax = 100;

export const listCampaignBriefHistoryResponseItemsItemFieldsEvidenceMax = 50;

export const listCampaignBriefHistoryResponseItemsItemFieldsContentItemRevisionMax = 100;

export const listCampaignBriefHistoryResponseItemsItemFieldsContentMax = 50;

export const listCampaignBriefHistoryResponseItemsItemFieldsAudienceOneContactIdsMax = 20000;

export const listCampaignBriefHistoryResponseItemsItemFieldsAudienceOneExcludedContactIdsMax = 20000;

export const listCampaignBriefHistoryResponseItemsItemFieldsAudienceOneChannelsMax = 3;

export const listCampaignBriefHistoryResponseItemsMax = 50;



export const listCampaignBriefHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(listCampaignBriefHistoryResponseItemsItemFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(listCampaignBriefHistoryResponseItemsItemFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(listCampaignBriefHistoryResponseItemsItemFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(listCampaignBriefHistoryResponseItemsItemFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(listCampaignBriefHistoryResponseItemsItemFieldsThemesItemMax)).max(listCampaignBriefHistoryResponseItemsItemFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(listCampaignBriefHistoryResponseItemsItemFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(listCampaignBriefHistoryResponseItemsItemFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(listCampaignBriefHistoryResponseItemsItemFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(listCampaignBriefHistoryResponseItemsItemFieldsUnknownsItemMax)).max(listCampaignBriefHistoryResponseItemsItemFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(listCampaignBriefHistoryResponseItemsItemFieldsEvidenceItemRevisionMax)
})).max(listCampaignBriefHistoryResponseItemsItemFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(listCampaignBriefHistoryResponseItemsItemFieldsContentItemRevisionMax)
})).max(listCampaignBriefHistoryResponseItemsItemFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(listCampaignBriefHistoryResponseItemsItemFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(listCampaignBriefHistoryResponseItemsItemFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(listCampaignBriefHistoryResponseItemsItemFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
})).max(listCampaignBriefHistoryResponseItemsMax),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const previewCampaignAudienceParams = zod.object({
  "id": zod.uuid()
})

export const previewCampaignAudienceQueryLimitDefault = 25;
export const previewCampaignAudienceQueryLimitMax = 100;

export const previewCampaignAudienceQueryOffsetDefault = 0;
export const previewCampaignAudienceQueryOffsetMin = 0;



export const previewCampaignAudienceQueryParams = zod.object({
  "limit": zod.int().min(1).max(previewCampaignAudienceQueryLimitMax).default(previewCampaignAudienceQueryLimitDefault),
  "offset": zod.int().min(previewCampaignAudienceQueryOffsetMin).default(previewCampaignAudienceQueryOffsetDefault)
})

export const previewCampaignAudienceBodyContactIdsMax = 20000;

export const previewCampaignAudienceBodyExcludedContactIdsMax = 20000;

export const previewCampaignAudienceBodyChannelsMax = 3;



export const previewCampaignAudienceBody = zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(previewCampaignAudienceBodyContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(previewCampaignAudienceBodyExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(previewCampaignAudienceBodyChannelsMax)
})

export const previewCampaignAudienceResponseItemsItemChannelsItemReasonsMax = 50;

export const previewCampaignAudienceResponseItemsItemChannelsMax = 50;

export const previewCampaignAudienceResponseItemsMax = 100;

export const previewCampaignAudienceResponseTotalsMax = 50;



export const previewCampaignAudienceResponse = zod.object({
  "items": zod.array(zod.object({
  "contactId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "email": zod.string(),
  "excluded": zod.boolean(),
  "channels": zod.array(zod.object({
  "channel": zod.string(),
  "eligible": zod.boolean(),
  "reasons": zod.array(zod.string()).max(previewCampaignAudienceResponseItemsItemChannelsItemReasonsMax),
  "destination": zod.string().nullable()
})).max(previewCampaignAudienceResponseItemsItemChannelsMax)
})).max(previewCampaignAudienceResponseItemsMax),
  "total": zod.int(),
  "excluded": zod.int(),
  "totals": zod.array(zod.object({
  "channel": zod.string(),
  "eligible": zod.int(),
  "ineligible": zod.int()
})).max(previewCampaignAudienceResponseTotalsMax),
  "fingerprint": zod.string(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const reviewCampaignMessagingBodyChangeReasonMin = 3;
export const reviewCampaignMessagingBodyChangeReasonMax = 500;



export const reviewCampaignMessagingBody = zod.object({
  "conversationId": zod.uuid(),
  "change": zod.object({
  "operation": zod.enum(['update', 'save_step', 'remove_step', 'send', 'control', 'retry']),
  "campaignId": zod.uuid(),
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "stepId": zod.uuid().nullish(),
  "deliveryId": zod.uuid().nullish(),
  "fields": zod.record(zod.string(), zod.unknown()).describe('Exact native fields for the selected operation; validated against its native generated schema.'),
  "reason": zod.string().min(reviewCampaignMessagingBodyChangeReasonMin).max(reviewCampaignMessagingBodyChangeReasonMax)
})
})


export const reviewCampaignMessagingResponseReviewDestructiveDefault = false;

export const reviewCampaignMessagingResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(reviewCampaignMessagingResponseReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})


export const reviewCampaignBriefBodyChangeExpectedVersionMin = 0;

export const reviewCampaignBriefBodyChangeFieldsObjectiveMax = 5000;

export const reviewCampaignBriefBodyChangeFieldsSuccessMeasureMax = 5000;

export const reviewCampaignBriefBodyChangeFieldsOfferMax = 5000;

export const reviewCampaignBriefBodyChangeFieldsAudienceRationaleMax = 5000;

export const reviewCampaignBriefBodyChangeFieldsThemesItemMax = 1000;

export const reviewCampaignBriefBodyChangeFieldsThemesMax = 50;

export const reviewCampaignBriefBodyChangeFieldsOutputsMax = 14;

export const reviewCampaignBriefBodyChangeFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const reviewCampaignBriefBodyChangeFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviewCampaignBriefBodyChangeFieldsUnknownsItemMax = 1000;

export const reviewCampaignBriefBodyChangeFieldsUnknownsMax = 50;

export const reviewCampaignBriefBodyChangeFieldsEvidenceItemRevisionMax = 100;

export const reviewCampaignBriefBodyChangeFieldsEvidenceMax = 50;

export const reviewCampaignBriefBodyChangeFieldsContentItemRevisionMax = 100;

export const reviewCampaignBriefBodyChangeFieldsContentMax = 50;

export const reviewCampaignBriefBodyChangeFieldsAudienceOneContactIdsMax = 20000;

export const reviewCampaignBriefBodyChangeFieldsAudienceOneExcludedContactIdsMax = 20000;

export const reviewCampaignBriefBodyChangeFieldsAudienceOneChannelsMax = 3;

export const reviewCampaignBriefBodyChangeReasonMin = 3;
export const reviewCampaignBriefBodyChangeReasonMax = 500;



export const reviewCampaignBriefBody = zod.object({
  "requestId": zod.uuid(),
  "change": zod.object({
  "campaignId": zod.uuid(),
  "expectedVersion": zod.int().min(reviewCampaignBriefBodyChangeExpectedVersionMin),
  "expectedCampaignUpdatedAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "objective": zod.string().max(reviewCampaignBriefBodyChangeFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(reviewCampaignBriefBodyChangeFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(reviewCampaignBriefBodyChangeFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(reviewCampaignBriefBodyChangeFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(reviewCampaignBriefBodyChangeFieldsThemesItemMax)).max(reviewCampaignBriefBodyChangeFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(reviewCampaignBriefBodyChangeFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(reviewCampaignBriefBodyChangeFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(reviewCampaignBriefBodyChangeFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(reviewCampaignBriefBodyChangeFieldsUnknownsItemMax)).max(reviewCampaignBriefBodyChangeFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefBodyChangeFieldsEvidenceItemRevisionMax)
})).max(reviewCampaignBriefBodyChangeFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefBodyChangeFieldsContentItemRevisionMax)
})).max(reviewCampaignBriefBodyChangeFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(reviewCampaignBriefBodyChangeFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(reviewCampaignBriefBodyChangeFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(reviewCampaignBriefBodyChangeFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "reason": zod.string().min(reviewCampaignBriefBodyChangeReasonMin).max(reviewCampaignBriefBodyChangeReasonMax)
})
})

export const reviewCampaignBriefResponseChangeExpectedVersionMin = 0;

export const reviewCampaignBriefResponseChangeFieldsObjectiveMax = 5000;

export const reviewCampaignBriefResponseChangeFieldsSuccessMeasureMax = 5000;

export const reviewCampaignBriefResponseChangeFieldsOfferMax = 5000;

export const reviewCampaignBriefResponseChangeFieldsAudienceRationaleMax = 5000;

export const reviewCampaignBriefResponseChangeFieldsThemesItemMax = 1000;

export const reviewCampaignBriefResponseChangeFieldsThemesMax = 50;

export const reviewCampaignBriefResponseChangeFieldsOutputsMax = 14;

export const reviewCampaignBriefResponseChangeFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const reviewCampaignBriefResponseChangeFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviewCampaignBriefResponseChangeFieldsUnknownsItemMax = 1000;

export const reviewCampaignBriefResponseChangeFieldsUnknownsMax = 50;

export const reviewCampaignBriefResponseChangeFieldsEvidenceItemRevisionMax = 100;

export const reviewCampaignBriefResponseChangeFieldsEvidenceMax = 50;

export const reviewCampaignBriefResponseChangeFieldsContentItemRevisionMax = 100;

export const reviewCampaignBriefResponseChangeFieldsContentMax = 50;

export const reviewCampaignBriefResponseChangeFieldsAudienceOneContactIdsMax = 20000;

export const reviewCampaignBriefResponseChangeFieldsAudienceOneExcludedContactIdsMax = 20000;

export const reviewCampaignBriefResponseChangeFieldsAudienceOneChannelsMax = 3;

export const reviewCampaignBriefResponseChangeReasonMin = 3;
export const reviewCampaignBriefResponseChangeReasonMax = 500;

export const reviewCampaignBriefResponseBeforeOneFieldsObjectiveMax = 5000;

export const reviewCampaignBriefResponseBeforeOneFieldsSuccessMeasureMax = 5000;

export const reviewCampaignBriefResponseBeforeOneFieldsOfferMax = 5000;

export const reviewCampaignBriefResponseBeforeOneFieldsAudienceRationaleMax = 5000;

export const reviewCampaignBriefResponseBeforeOneFieldsThemesItemMax = 1000;

export const reviewCampaignBriefResponseBeforeOneFieldsThemesMax = 50;

export const reviewCampaignBriefResponseBeforeOneFieldsOutputsMax = 14;

export const reviewCampaignBriefResponseBeforeOneFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const reviewCampaignBriefResponseBeforeOneFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviewCampaignBriefResponseBeforeOneFieldsUnknownsItemMax = 1000;

export const reviewCampaignBriefResponseBeforeOneFieldsUnknownsMax = 50;

export const reviewCampaignBriefResponseBeforeOneFieldsEvidenceItemRevisionMax = 100;

export const reviewCampaignBriefResponseBeforeOneFieldsEvidenceMax = 50;

export const reviewCampaignBriefResponseBeforeOneFieldsContentItemRevisionMax = 100;

export const reviewCampaignBriefResponseBeforeOneFieldsContentMax = 50;

export const reviewCampaignBriefResponseBeforeOneFieldsAudienceOneContactIdsMax = 20000;

export const reviewCampaignBriefResponseBeforeOneFieldsAudienceOneExcludedContactIdsMax = 20000;

export const reviewCampaignBriefResponseBeforeOneFieldsAudienceOneChannelsMax = 3;

export const reviewCampaignBriefResponseAfterFieldsObjectiveMax = 5000;

export const reviewCampaignBriefResponseAfterFieldsSuccessMeasureMax = 5000;

export const reviewCampaignBriefResponseAfterFieldsOfferMax = 5000;

export const reviewCampaignBriefResponseAfterFieldsAudienceRationaleMax = 5000;

export const reviewCampaignBriefResponseAfterFieldsThemesItemMax = 1000;

export const reviewCampaignBriefResponseAfterFieldsThemesMax = 50;

export const reviewCampaignBriefResponseAfterFieldsOutputsMax = 14;

export const reviewCampaignBriefResponseAfterFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const reviewCampaignBriefResponseAfterFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviewCampaignBriefResponseAfterFieldsUnknownsItemMax = 1000;

export const reviewCampaignBriefResponseAfterFieldsUnknownsMax = 50;

export const reviewCampaignBriefResponseAfterFieldsEvidenceItemRevisionMax = 100;

export const reviewCampaignBriefResponseAfterFieldsEvidenceMax = 50;

export const reviewCampaignBriefResponseAfterFieldsContentItemRevisionMax = 100;

export const reviewCampaignBriefResponseAfterFieldsContentMax = 50;

export const reviewCampaignBriefResponseAfterFieldsAudienceOneContactIdsMax = 20000;

export const reviewCampaignBriefResponseAfterFieldsAudienceOneExcludedContactIdsMax = 20000;

export const reviewCampaignBriefResponseAfterFieldsAudienceOneChannelsMax = 3;

export const reviewCampaignBriefResponseReceiptOneFieldsObjectiveMax = 5000;

export const reviewCampaignBriefResponseReceiptOneFieldsSuccessMeasureMax = 5000;

export const reviewCampaignBriefResponseReceiptOneFieldsOfferMax = 5000;

export const reviewCampaignBriefResponseReceiptOneFieldsAudienceRationaleMax = 5000;

export const reviewCampaignBriefResponseReceiptOneFieldsThemesItemMax = 1000;

export const reviewCampaignBriefResponseReceiptOneFieldsThemesMax = 50;

export const reviewCampaignBriefResponseReceiptOneFieldsOutputsMax = 14;

export const reviewCampaignBriefResponseReceiptOneFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const reviewCampaignBriefResponseReceiptOneFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const reviewCampaignBriefResponseReceiptOneFieldsUnknownsItemMax = 1000;

export const reviewCampaignBriefResponseReceiptOneFieldsUnknownsMax = 50;

export const reviewCampaignBriefResponseReceiptOneFieldsEvidenceItemRevisionMax = 100;

export const reviewCampaignBriefResponseReceiptOneFieldsEvidenceMax = 50;

export const reviewCampaignBriefResponseReceiptOneFieldsContentItemRevisionMax = 100;

export const reviewCampaignBriefResponseReceiptOneFieldsContentMax = 50;

export const reviewCampaignBriefResponseReceiptOneFieldsAudienceOneContactIdsMax = 20000;

export const reviewCampaignBriefResponseReceiptOneFieldsAudienceOneExcludedContactIdsMax = 20000;

export const reviewCampaignBriefResponseReceiptOneFieldsAudienceOneChannelsMax = 3;



export const reviewCampaignBriefResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "change": zod.object({
  "campaignId": zod.uuid(),
  "expectedVersion": zod.int().min(reviewCampaignBriefResponseChangeExpectedVersionMin),
  "expectedCampaignUpdatedAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "objective": zod.string().max(reviewCampaignBriefResponseChangeFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(reviewCampaignBriefResponseChangeFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(reviewCampaignBriefResponseChangeFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(reviewCampaignBriefResponseChangeFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(reviewCampaignBriefResponseChangeFieldsThemesItemMax)).max(reviewCampaignBriefResponseChangeFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(reviewCampaignBriefResponseChangeFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(reviewCampaignBriefResponseChangeFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(reviewCampaignBriefResponseChangeFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(reviewCampaignBriefResponseChangeFieldsUnknownsItemMax)).max(reviewCampaignBriefResponseChangeFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefResponseChangeFieldsEvidenceItemRevisionMax)
})).max(reviewCampaignBriefResponseChangeFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefResponseChangeFieldsContentItemRevisionMax)
})).max(reviewCampaignBriefResponseChangeFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(reviewCampaignBriefResponseChangeFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(reviewCampaignBriefResponseChangeFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(reviewCampaignBriefResponseChangeFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "reason": zod.string().min(reviewCampaignBriefResponseChangeReasonMin).max(reviewCampaignBriefResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(reviewCampaignBriefResponseBeforeOneFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(reviewCampaignBriefResponseBeforeOneFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(reviewCampaignBriefResponseBeforeOneFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(reviewCampaignBriefResponseBeforeOneFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(reviewCampaignBriefResponseBeforeOneFieldsThemesItemMax)).max(reviewCampaignBriefResponseBeforeOneFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(reviewCampaignBriefResponseBeforeOneFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(reviewCampaignBriefResponseBeforeOneFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(reviewCampaignBriefResponseBeforeOneFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(reviewCampaignBriefResponseBeforeOneFieldsUnknownsItemMax)).max(reviewCampaignBriefResponseBeforeOneFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(reviewCampaignBriefResponseBeforeOneFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefResponseBeforeOneFieldsContentItemRevisionMax)
})).max(reviewCampaignBriefResponseBeforeOneFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(reviewCampaignBriefResponseBeforeOneFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(reviewCampaignBriefResponseBeforeOneFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(reviewCampaignBriefResponseBeforeOneFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),zod.null()]),
  "after": zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(reviewCampaignBriefResponseAfterFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(reviewCampaignBriefResponseAfterFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(reviewCampaignBriefResponseAfterFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(reviewCampaignBriefResponseAfterFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(reviewCampaignBriefResponseAfterFieldsThemesItemMax)).max(reviewCampaignBriefResponseAfterFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(reviewCampaignBriefResponseAfterFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(reviewCampaignBriefResponseAfterFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(reviewCampaignBriefResponseAfterFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(reviewCampaignBriefResponseAfterFieldsUnknownsItemMax)).max(reviewCampaignBriefResponseAfterFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefResponseAfterFieldsEvidenceItemRevisionMax)
})).max(reviewCampaignBriefResponseAfterFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefResponseAfterFieldsContentItemRevisionMax)
})).max(reviewCampaignBriefResponseAfterFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(reviewCampaignBriefResponseAfterFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(reviewCampaignBriefResponseAfterFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(reviewCampaignBriefResponseAfterFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "receipt": zod.union([zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(reviewCampaignBriefResponseReceiptOneFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(reviewCampaignBriefResponseReceiptOneFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(reviewCampaignBriefResponseReceiptOneFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(reviewCampaignBriefResponseReceiptOneFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(reviewCampaignBriefResponseReceiptOneFieldsThemesItemMax)).max(reviewCampaignBriefResponseReceiptOneFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(reviewCampaignBriefResponseReceiptOneFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(reviewCampaignBriefResponseReceiptOneFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(reviewCampaignBriefResponseReceiptOneFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(reviewCampaignBriefResponseReceiptOneFieldsUnknownsItemMax)).max(reviewCampaignBriefResponseReceiptOneFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(reviewCampaignBriefResponseReceiptOneFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(reviewCampaignBriefResponseReceiptOneFieldsContentItemRevisionMax)
})).max(reviewCampaignBriefResponseReceiptOneFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(reviewCampaignBriefResponseReceiptOneFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(reviewCampaignBriefResponseReceiptOneFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(reviewCampaignBriefResponseReceiptOneFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),zod.null()])
})


export const getCampaignBriefReviewParams = zod.object({
  "id": zod.uuid()
})

export const getCampaignBriefReviewResponseChangeExpectedVersionMin = 0;

export const getCampaignBriefReviewResponseChangeFieldsObjectiveMax = 5000;

export const getCampaignBriefReviewResponseChangeFieldsSuccessMeasureMax = 5000;

export const getCampaignBriefReviewResponseChangeFieldsOfferMax = 5000;

export const getCampaignBriefReviewResponseChangeFieldsAudienceRationaleMax = 5000;

export const getCampaignBriefReviewResponseChangeFieldsThemesItemMax = 1000;

export const getCampaignBriefReviewResponseChangeFieldsThemesMax = 50;

export const getCampaignBriefReviewResponseChangeFieldsOutputsMax = 14;

export const getCampaignBriefReviewResponseChangeFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const getCampaignBriefReviewResponseChangeFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getCampaignBriefReviewResponseChangeFieldsUnknownsItemMax = 1000;

export const getCampaignBriefReviewResponseChangeFieldsUnknownsMax = 50;

export const getCampaignBriefReviewResponseChangeFieldsEvidenceItemRevisionMax = 100;

export const getCampaignBriefReviewResponseChangeFieldsEvidenceMax = 50;

export const getCampaignBriefReviewResponseChangeFieldsContentItemRevisionMax = 100;

export const getCampaignBriefReviewResponseChangeFieldsContentMax = 50;

export const getCampaignBriefReviewResponseChangeFieldsAudienceOneContactIdsMax = 20000;

export const getCampaignBriefReviewResponseChangeFieldsAudienceOneExcludedContactIdsMax = 20000;

export const getCampaignBriefReviewResponseChangeFieldsAudienceOneChannelsMax = 3;

export const getCampaignBriefReviewResponseChangeReasonMin = 3;
export const getCampaignBriefReviewResponseChangeReasonMax = 500;

export const getCampaignBriefReviewResponseBeforeOneFieldsObjectiveMax = 5000;

export const getCampaignBriefReviewResponseBeforeOneFieldsSuccessMeasureMax = 5000;

export const getCampaignBriefReviewResponseBeforeOneFieldsOfferMax = 5000;

export const getCampaignBriefReviewResponseBeforeOneFieldsAudienceRationaleMax = 5000;

export const getCampaignBriefReviewResponseBeforeOneFieldsThemesItemMax = 1000;

export const getCampaignBriefReviewResponseBeforeOneFieldsThemesMax = 50;

export const getCampaignBriefReviewResponseBeforeOneFieldsOutputsMax = 14;

export const getCampaignBriefReviewResponseBeforeOneFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const getCampaignBriefReviewResponseBeforeOneFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getCampaignBriefReviewResponseBeforeOneFieldsUnknownsItemMax = 1000;

export const getCampaignBriefReviewResponseBeforeOneFieldsUnknownsMax = 50;

export const getCampaignBriefReviewResponseBeforeOneFieldsEvidenceItemRevisionMax = 100;

export const getCampaignBriefReviewResponseBeforeOneFieldsEvidenceMax = 50;

export const getCampaignBriefReviewResponseBeforeOneFieldsContentItemRevisionMax = 100;

export const getCampaignBriefReviewResponseBeforeOneFieldsContentMax = 50;

export const getCampaignBriefReviewResponseBeforeOneFieldsAudienceOneContactIdsMax = 20000;

export const getCampaignBriefReviewResponseBeforeOneFieldsAudienceOneExcludedContactIdsMax = 20000;

export const getCampaignBriefReviewResponseBeforeOneFieldsAudienceOneChannelsMax = 3;

export const getCampaignBriefReviewResponseAfterFieldsObjectiveMax = 5000;

export const getCampaignBriefReviewResponseAfterFieldsSuccessMeasureMax = 5000;

export const getCampaignBriefReviewResponseAfterFieldsOfferMax = 5000;

export const getCampaignBriefReviewResponseAfterFieldsAudienceRationaleMax = 5000;

export const getCampaignBriefReviewResponseAfterFieldsThemesItemMax = 1000;

export const getCampaignBriefReviewResponseAfterFieldsThemesMax = 50;

export const getCampaignBriefReviewResponseAfterFieldsOutputsMax = 14;

export const getCampaignBriefReviewResponseAfterFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const getCampaignBriefReviewResponseAfterFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getCampaignBriefReviewResponseAfterFieldsUnknownsItemMax = 1000;

export const getCampaignBriefReviewResponseAfterFieldsUnknownsMax = 50;

export const getCampaignBriefReviewResponseAfterFieldsEvidenceItemRevisionMax = 100;

export const getCampaignBriefReviewResponseAfterFieldsEvidenceMax = 50;

export const getCampaignBriefReviewResponseAfterFieldsContentItemRevisionMax = 100;

export const getCampaignBriefReviewResponseAfterFieldsContentMax = 50;

export const getCampaignBriefReviewResponseAfterFieldsAudienceOneContactIdsMax = 20000;

export const getCampaignBriefReviewResponseAfterFieldsAudienceOneExcludedContactIdsMax = 20000;

export const getCampaignBriefReviewResponseAfterFieldsAudienceOneChannelsMax = 3;

export const getCampaignBriefReviewResponseReceiptOneFieldsObjectiveMax = 5000;

export const getCampaignBriefReviewResponseReceiptOneFieldsSuccessMeasureMax = 5000;

export const getCampaignBriefReviewResponseReceiptOneFieldsOfferMax = 5000;

export const getCampaignBriefReviewResponseReceiptOneFieldsAudienceRationaleMax = 5000;

export const getCampaignBriefReviewResponseReceiptOneFieldsThemesItemMax = 1000;

export const getCampaignBriefReviewResponseReceiptOneFieldsThemesMax = 50;

export const getCampaignBriefReviewResponseReceiptOneFieldsOutputsMax = 14;

export const getCampaignBriefReviewResponseReceiptOneFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const getCampaignBriefReviewResponseReceiptOneFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getCampaignBriefReviewResponseReceiptOneFieldsUnknownsItemMax = 1000;

export const getCampaignBriefReviewResponseReceiptOneFieldsUnknownsMax = 50;

export const getCampaignBriefReviewResponseReceiptOneFieldsEvidenceItemRevisionMax = 100;

export const getCampaignBriefReviewResponseReceiptOneFieldsEvidenceMax = 50;

export const getCampaignBriefReviewResponseReceiptOneFieldsContentItemRevisionMax = 100;

export const getCampaignBriefReviewResponseReceiptOneFieldsContentMax = 50;

export const getCampaignBriefReviewResponseReceiptOneFieldsAudienceOneContactIdsMax = 20000;

export const getCampaignBriefReviewResponseReceiptOneFieldsAudienceOneExcludedContactIdsMax = 20000;

export const getCampaignBriefReviewResponseReceiptOneFieldsAudienceOneChannelsMax = 3;



export const getCampaignBriefReviewResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "change": zod.object({
  "campaignId": zod.uuid(),
  "expectedVersion": zod.int().min(getCampaignBriefReviewResponseChangeExpectedVersionMin),
  "expectedCampaignUpdatedAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "objective": zod.string().max(getCampaignBriefReviewResponseChangeFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(getCampaignBriefReviewResponseChangeFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(getCampaignBriefReviewResponseChangeFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(getCampaignBriefReviewResponseChangeFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(getCampaignBriefReviewResponseChangeFieldsThemesItemMax)).max(getCampaignBriefReviewResponseChangeFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(getCampaignBriefReviewResponseChangeFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(getCampaignBriefReviewResponseChangeFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(getCampaignBriefReviewResponseChangeFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(getCampaignBriefReviewResponseChangeFieldsUnknownsItemMax)).max(getCampaignBriefReviewResponseChangeFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefReviewResponseChangeFieldsEvidenceItemRevisionMax)
})).max(getCampaignBriefReviewResponseChangeFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefReviewResponseChangeFieldsContentItemRevisionMax)
})).max(getCampaignBriefReviewResponseChangeFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(getCampaignBriefReviewResponseChangeFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(getCampaignBriefReviewResponseChangeFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(getCampaignBriefReviewResponseChangeFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "reason": zod.string().min(getCampaignBriefReviewResponseChangeReasonMin).max(getCampaignBriefReviewResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(getCampaignBriefReviewResponseBeforeOneFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(getCampaignBriefReviewResponseBeforeOneFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(getCampaignBriefReviewResponseBeforeOneFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(getCampaignBriefReviewResponseBeforeOneFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(getCampaignBriefReviewResponseBeforeOneFieldsThemesItemMax)).max(getCampaignBriefReviewResponseBeforeOneFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(getCampaignBriefReviewResponseBeforeOneFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(getCampaignBriefReviewResponseBeforeOneFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(getCampaignBriefReviewResponseBeforeOneFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(getCampaignBriefReviewResponseBeforeOneFieldsUnknownsItemMax)).max(getCampaignBriefReviewResponseBeforeOneFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefReviewResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(getCampaignBriefReviewResponseBeforeOneFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefReviewResponseBeforeOneFieldsContentItemRevisionMax)
})).max(getCampaignBriefReviewResponseBeforeOneFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(getCampaignBriefReviewResponseBeforeOneFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(getCampaignBriefReviewResponseBeforeOneFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(getCampaignBriefReviewResponseBeforeOneFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),zod.null()]),
  "after": zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(getCampaignBriefReviewResponseAfterFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(getCampaignBriefReviewResponseAfterFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(getCampaignBriefReviewResponseAfterFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(getCampaignBriefReviewResponseAfterFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(getCampaignBriefReviewResponseAfterFieldsThemesItemMax)).max(getCampaignBriefReviewResponseAfterFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(getCampaignBriefReviewResponseAfterFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(getCampaignBriefReviewResponseAfterFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(getCampaignBriefReviewResponseAfterFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(getCampaignBriefReviewResponseAfterFieldsUnknownsItemMax)).max(getCampaignBriefReviewResponseAfterFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefReviewResponseAfterFieldsEvidenceItemRevisionMax)
})).max(getCampaignBriefReviewResponseAfterFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefReviewResponseAfterFieldsContentItemRevisionMax)
})).max(getCampaignBriefReviewResponseAfterFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(getCampaignBriefReviewResponseAfterFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(getCampaignBriefReviewResponseAfterFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(getCampaignBriefReviewResponseAfterFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "receipt": zod.union([zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(getCampaignBriefReviewResponseReceiptOneFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(getCampaignBriefReviewResponseReceiptOneFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(getCampaignBriefReviewResponseReceiptOneFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(getCampaignBriefReviewResponseReceiptOneFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(getCampaignBriefReviewResponseReceiptOneFieldsThemesItemMax)).max(getCampaignBriefReviewResponseReceiptOneFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(getCampaignBriefReviewResponseReceiptOneFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(getCampaignBriefReviewResponseReceiptOneFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(getCampaignBriefReviewResponseReceiptOneFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(getCampaignBriefReviewResponseReceiptOneFieldsUnknownsItemMax)).max(getCampaignBriefReviewResponseReceiptOneFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefReviewResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(getCampaignBriefReviewResponseReceiptOneFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(getCampaignBriefReviewResponseReceiptOneFieldsContentItemRevisionMax)
})).max(getCampaignBriefReviewResponseReceiptOneFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(getCampaignBriefReviewResponseReceiptOneFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(getCampaignBriefReviewResponseReceiptOneFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(getCampaignBriefReviewResponseReceiptOneFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),zod.null()])
})


export const confirmCampaignBriefParams = zod.object({
  "id": zod.uuid()
})

export const confirmCampaignBriefBody = zod.object({
  "hash": zod.string()
})

export const confirmCampaignBriefResponseChangeExpectedVersionMin = 0;

export const confirmCampaignBriefResponseChangeFieldsObjectiveMax = 5000;

export const confirmCampaignBriefResponseChangeFieldsSuccessMeasureMax = 5000;

export const confirmCampaignBriefResponseChangeFieldsOfferMax = 5000;

export const confirmCampaignBriefResponseChangeFieldsAudienceRationaleMax = 5000;

export const confirmCampaignBriefResponseChangeFieldsThemesItemMax = 1000;

export const confirmCampaignBriefResponseChangeFieldsThemesMax = 50;

export const confirmCampaignBriefResponseChangeFieldsOutputsMax = 14;

export const confirmCampaignBriefResponseChangeFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const confirmCampaignBriefResponseChangeFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const confirmCampaignBriefResponseChangeFieldsUnknownsItemMax = 1000;

export const confirmCampaignBriefResponseChangeFieldsUnknownsMax = 50;

export const confirmCampaignBriefResponseChangeFieldsEvidenceItemRevisionMax = 100;

export const confirmCampaignBriefResponseChangeFieldsEvidenceMax = 50;

export const confirmCampaignBriefResponseChangeFieldsContentItemRevisionMax = 100;

export const confirmCampaignBriefResponseChangeFieldsContentMax = 50;

export const confirmCampaignBriefResponseChangeFieldsAudienceOneContactIdsMax = 20000;

export const confirmCampaignBriefResponseChangeFieldsAudienceOneExcludedContactIdsMax = 20000;

export const confirmCampaignBriefResponseChangeFieldsAudienceOneChannelsMax = 3;

export const confirmCampaignBriefResponseChangeReasonMin = 3;
export const confirmCampaignBriefResponseChangeReasonMax = 500;

export const confirmCampaignBriefResponseBeforeOneFieldsObjectiveMax = 5000;

export const confirmCampaignBriefResponseBeforeOneFieldsSuccessMeasureMax = 5000;

export const confirmCampaignBriefResponseBeforeOneFieldsOfferMax = 5000;

export const confirmCampaignBriefResponseBeforeOneFieldsAudienceRationaleMax = 5000;

export const confirmCampaignBriefResponseBeforeOneFieldsThemesItemMax = 1000;

export const confirmCampaignBriefResponseBeforeOneFieldsThemesMax = 50;

export const confirmCampaignBriefResponseBeforeOneFieldsOutputsMax = 14;

export const confirmCampaignBriefResponseBeforeOneFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const confirmCampaignBriefResponseBeforeOneFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const confirmCampaignBriefResponseBeforeOneFieldsUnknownsItemMax = 1000;

export const confirmCampaignBriefResponseBeforeOneFieldsUnknownsMax = 50;

export const confirmCampaignBriefResponseBeforeOneFieldsEvidenceItemRevisionMax = 100;

export const confirmCampaignBriefResponseBeforeOneFieldsEvidenceMax = 50;

export const confirmCampaignBriefResponseBeforeOneFieldsContentItemRevisionMax = 100;

export const confirmCampaignBriefResponseBeforeOneFieldsContentMax = 50;

export const confirmCampaignBriefResponseBeforeOneFieldsAudienceOneContactIdsMax = 20000;

export const confirmCampaignBriefResponseBeforeOneFieldsAudienceOneExcludedContactIdsMax = 20000;

export const confirmCampaignBriefResponseBeforeOneFieldsAudienceOneChannelsMax = 3;

export const confirmCampaignBriefResponseAfterFieldsObjectiveMax = 5000;

export const confirmCampaignBriefResponseAfterFieldsSuccessMeasureMax = 5000;

export const confirmCampaignBriefResponseAfterFieldsOfferMax = 5000;

export const confirmCampaignBriefResponseAfterFieldsAudienceRationaleMax = 5000;

export const confirmCampaignBriefResponseAfterFieldsThemesItemMax = 1000;

export const confirmCampaignBriefResponseAfterFieldsThemesMax = 50;

export const confirmCampaignBriefResponseAfterFieldsOutputsMax = 14;

export const confirmCampaignBriefResponseAfterFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const confirmCampaignBriefResponseAfterFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const confirmCampaignBriefResponseAfterFieldsUnknownsItemMax = 1000;

export const confirmCampaignBriefResponseAfterFieldsUnknownsMax = 50;

export const confirmCampaignBriefResponseAfterFieldsEvidenceItemRevisionMax = 100;

export const confirmCampaignBriefResponseAfterFieldsEvidenceMax = 50;

export const confirmCampaignBriefResponseAfterFieldsContentItemRevisionMax = 100;

export const confirmCampaignBriefResponseAfterFieldsContentMax = 50;

export const confirmCampaignBriefResponseAfterFieldsAudienceOneContactIdsMax = 20000;

export const confirmCampaignBriefResponseAfterFieldsAudienceOneExcludedContactIdsMax = 20000;

export const confirmCampaignBriefResponseAfterFieldsAudienceOneChannelsMax = 3;

export const confirmCampaignBriefResponseReceiptOneFieldsObjectiveMax = 5000;

export const confirmCampaignBriefResponseReceiptOneFieldsSuccessMeasureMax = 5000;

export const confirmCampaignBriefResponseReceiptOneFieldsOfferMax = 5000;

export const confirmCampaignBriefResponseReceiptOneFieldsAudienceRationaleMax = 5000;

export const confirmCampaignBriefResponseReceiptOneFieldsThemesItemMax = 1000;

export const confirmCampaignBriefResponseReceiptOneFieldsThemesMax = 50;

export const confirmCampaignBriefResponseReceiptOneFieldsOutputsMax = 14;

export const confirmCampaignBriefResponseReceiptOneFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const confirmCampaignBriefResponseReceiptOneFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const confirmCampaignBriefResponseReceiptOneFieldsUnknownsItemMax = 1000;

export const confirmCampaignBriefResponseReceiptOneFieldsUnknownsMax = 50;

export const confirmCampaignBriefResponseReceiptOneFieldsEvidenceItemRevisionMax = 100;

export const confirmCampaignBriefResponseReceiptOneFieldsEvidenceMax = 50;

export const confirmCampaignBriefResponseReceiptOneFieldsContentItemRevisionMax = 100;

export const confirmCampaignBriefResponseReceiptOneFieldsContentMax = 50;

export const confirmCampaignBriefResponseReceiptOneFieldsAudienceOneContactIdsMax = 20000;

export const confirmCampaignBriefResponseReceiptOneFieldsAudienceOneExcludedContactIdsMax = 20000;

export const confirmCampaignBriefResponseReceiptOneFieldsAudienceOneChannelsMax = 3;



export const confirmCampaignBriefResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "change": zod.object({
  "campaignId": zod.uuid(),
  "expectedVersion": zod.int().min(confirmCampaignBriefResponseChangeExpectedVersionMin),
  "expectedCampaignUpdatedAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "objective": zod.string().max(confirmCampaignBriefResponseChangeFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(confirmCampaignBriefResponseChangeFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(confirmCampaignBriefResponseChangeFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(confirmCampaignBriefResponseChangeFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(confirmCampaignBriefResponseChangeFieldsThemesItemMax)).max(confirmCampaignBriefResponseChangeFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(confirmCampaignBriefResponseChangeFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(confirmCampaignBriefResponseChangeFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(confirmCampaignBriefResponseChangeFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(confirmCampaignBriefResponseChangeFieldsUnknownsItemMax)).max(confirmCampaignBriefResponseChangeFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(confirmCampaignBriefResponseChangeFieldsEvidenceItemRevisionMax)
})).max(confirmCampaignBriefResponseChangeFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(confirmCampaignBriefResponseChangeFieldsContentItemRevisionMax)
})).max(confirmCampaignBriefResponseChangeFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(confirmCampaignBriefResponseChangeFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(confirmCampaignBriefResponseChangeFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(confirmCampaignBriefResponseChangeFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "reason": zod.string().min(confirmCampaignBriefResponseChangeReasonMin).max(confirmCampaignBriefResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(confirmCampaignBriefResponseBeforeOneFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(confirmCampaignBriefResponseBeforeOneFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(confirmCampaignBriefResponseBeforeOneFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(confirmCampaignBriefResponseBeforeOneFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(confirmCampaignBriefResponseBeforeOneFieldsThemesItemMax)).max(confirmCampaignBriefResponseBeforeOneFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(confirmCampaignBriefResponseBeforeOneFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(confirmCampaignBriefResponseBeforeOneFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(confirmCampaignBriefResponseBeforeOneFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(confirmCampaignBriefResponseBeforeOneFieldsUnknownsItemMax)).max(confirmCampaignBriefResponseBeforeOneFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(confirmCampaignBriefResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(confirmCampaignBriefResponseBeforeOneFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(confirmCampaignBriefResponseBeforeOneFieldsContentItemRevisionMax)
})).max(confirmCampaignBriefResponseBeforeOneFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(confirmCampaignBriefResponseBeforeOneFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(confirmCampaignBriefResponseBeforeOneFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(confirmCampaignBriefResponseBeforeOneFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),zod.null()]),
  "after": zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(confirmCampaignBriefResponseAfterFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(confirmCampaignBriefResponseAfterFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(confirmCampaignBriefResponseAfterFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(confirmCampaignBriefResponseAfterFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(confirmCampaignBriefResponseAfterFieldsThemesItemMax)).max(confirmCampaignBriefResponseAfterFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(confirmCampaignBriefResponseAfterFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(confirmCampaignBriefResponseAfterFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(confirmCampaignBriefResponseAfterFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(confirmCampaignBriefResponseAfterFieldsUnknownsItemMax)).max(confirmCampaignBriefResponseAfterFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(confirmCampaignBriefResponseAfterFieldsEvidenceItemRevisionMax)
})).max(confirmCampaignBriefResponseAfterFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(confirmCampaignBriefResponseAfterFieldsContentItemRevisionMax)
})).max(confirmCampaignBriefResponseAfterFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(confirmCampaignBriefResponseAfterFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(confirmCampaignBriefResponseAfterFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(confirmCampaignBriefResponseAfterFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "receipt": zod.union([zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(confirmCampaignBriefResponseReceiptOneFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(confirmCampaignBriefResponseReceiptOneFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(confirmCampaignBriefResponseReceiptOneFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(confirmCampaignBriefResponseReceiptOneFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(confirmCampaignBriefResponseReceiptOneFieldsThemesItemMax)).max(confirmCampaignBriefResponseReceiptOneFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(confirmCampaignBriefResponseReceiptOneFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(confirmCampaignBriefResponseReceiptOneFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(confirmCampaignBriefResponseReceiptOneFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(confirmCampaignBriefResponseReceiptOneFieldsUnknownsItemMax)).max(confirmCampaignBriefResponseReceiptOneFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(confirmCampaignBriefResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(confirmCampaignBriefResponseReceiptOneFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(confirmCampaignBriefResponseReceiptOneFieldsContentItemRevisionMax)
})).max(confirmCampaignBriefResponseReceiptOneFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(confirmCampaignBriefResponseReceiptOneFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(confirmCampaignBriefResponseReceiptOneFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(confirmCampaignBriefResponseReceiptOneFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),zod.null()])
})


export const cancelCampaignBriefParams = zod.object({
  "id": zod.uuid()
})

export const cancelCampaignBriefResponseChangeExpectedVersionMin = 0;

export const cancelCampaignBriefResponseChangeFieldsObjectiveMax = 5000;

export const cancelCampaignBriefResponseChangeFieldsSuccessMeasureMax = 5000;

export const cancelCampaignBriefResponseChangeFieldsOfferMax = 5000;

export const cancelCampaignBriefResponseChangeFieldsAudienceRationaleMax = 5000;

export const cancelCampaignBriefResponseChangeFieldsThemesItemMax = 1000;

export const cancelCampaignBriefResponseChangeFieldsThemesMax = 50;

export const cancelCampaignBriefResponseChangeFieldsOutputsMax = 14;

export const cancelCampaignBriefResponseChangeFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const cancelCampaignBriefResponseChangeFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const cancelCampaignBriefResponseChangeFieldsUnknownsItemMax = 1000;

export const cancelCampaignBriefResponseChangeFieldsUnknownsMax = 50;

export const cancelCampaignBriefResponseChangeFieldsEvidenceItemRevisionMax = 100;

export const cancelCampaignBriefResponseChangeFieldsEvidenceMax = 50;

export const cancelCampaignBriefResponseChangeFieldsContentItemRevisionMax = 100;

export const cancelCampaignBriefResponseChangeFieldsContentMax = 50;

export const cancelCampaignBriefResponseChangeFieldsAudienceOneContactIdsMax = 20000;

export const cancelCampaignBriefResponseChangeFieldsAudienceOneExcludedContactIdsMax = 20000;

export const cancelCampaignBriefResponseChangeFieldsAudienceOneChannelsMax = 3;

export const cancelCampaignBriefResponseChangeReasonMin = 3;
export const cancelCampaignBriefResponseChangeReasonMax = 500;

export const cancelCampaignBriefResponseBeforeOneFieldsObjectiveMax = 5000;

export const cancelCampaignBriefResponseBeforeOneFieldsSuccessMeasureMax = 5000;

export const cancelCampaignBriefResponseBeforeOneFieldsOfferMax = 5000;

export const cancelCampaignBriefResponseBeforeOneFieldsAudienceRationaleMax = 5000;

export const cancelCampaignBriefResponseBeforeOneFieldsThemesItemMax = 1000;

export const cancelCampaignBriefResponseBeforeOneFieldsThemesMax = 50;

export const cancelCampaignBriefResponseBeforeOneFieldsOutputsMax = 14;

export const cancelCampaignBriefResponseBeforeOneFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const cancelCampaignBriefResponseBeforeOneFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const cancelCampaignBriefResponseBeforeOneFieldsUnknownsItemMax = 1000;

export const cancelCampaignBriefResponseBeforeOneFieldsUnknownsMax = 50;

export const cancelCampaignBriefResponseBeforeOneFieldsEvidenceItemRevisionMax = 100;

export const cancelCampaignBriefResponseBeforeOneFieldsEvidenceMax = 50;

export const cancelCampaignBriefResponseBeforeOneFieldsContentItemRevisionMax = 100;

export const cancelCampaignBriefResponseBeforeOneFieldsContentMax = 50;

export const cancelCampaignBriefResponseBeforeOneFieldsAudienceOneContactIdsMax = 20000;

export const cancelCampaignBriefResponseBeforeOneFieldsAudienceOneExcludedContactIdsMax = 20000;

export const cancelCampaignBriefResponseBeforeOneFieldsAudienceOneChannelsMax = 3;

export const cancelCampaignBriefResponseAfterFieldsObjectiveMax = 5000;

export const cancelCampaignBriefResponseAfterFieldsSuccessMeasureMax = 5000;

export const cancelCampaignBriefResponseAfterFieldsOfferMax = 5000;

export const cancelCampaignBriefResponseAfterFieldsAudienceRationaleMax = 5000;

export const cancelCampaignBriefResponseAfterFieldsThemesItemMax = 1000;

export const cancelCampaignBriefResponseAfterFieldsThemesMax = 50;

export const cancelCampaignBriefResponseAfterFieldsOutputsMax = 14;

export const cancelCampaignBriefResponseAfterFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const cancelCampaignBriefResponseAfterFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const cancelCampaignBriefResponseAfterFieldsUnknownsItemMax = 1000;

export const cancelCampaignBriefResponseAfterFieldsUnknownsMax = 50;

export const cancelCampaignBriefResponseAfterFieldsEvidenceItemRevisionMax = 100;

export const cancelCampaignBriefResponseAfterFieldsEvidenceMax = 50;

export const cancelCampaignBriefResponseAfterFieldsContentItemRevisionMax = 100;

export const cancelCampaignBriefResponseAfterFieldsContentMax = 50;

export const cancelCampaignBriefResponseAfterFieldsAudienceOneContactIdsMax = 20000;

export const cancelCampaignBriefResponseAfterFieldsAudienceOneExcludedContactIdsMax = 20000;

export const cancelCampaignBriefResponseAfterFieldsAudienceOneChannelsMax = 3;

export const cancelCampaignBriefResponseReceiptOneFieldsObjectiveMax = 5000;

export const cancelCampaignBriefResponseReceiptOneFieldsSuccessMeasureMax = 5000;

export const cancelCampaignBriefResponseReceiptOneFieldsOfferMax = 5000;

export const cancelCampaignBriefResponseReceiptOneFieldsAudienceRationaleMax = 5000;

export const cancelCampaignBriefResponseReceiptOneFieldsThemesItemMax = 1000;

export const cancelCampaignBriefResponseReceiptOneFieldsThemesMax = 50;

export const cancelCampaignBriefResponseReceiptOneFieldsOutputsMax = 14;

export const cancelCampaignBriefResponseReceiptOneFieldsBudgetRegExp = new RegExp('^[0-9]{1,12}(\\.[0-9]{1,2})?$');
export const cancelCampaignBriefResponseReceiptOneFieldsCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const cancelCampaignBriefResponseReceiptOneFieldsUnknownsItemMax = 1000;

export const cancelCampaignBriefResponseReceiptOneFieldsUnknownsMax = 50;

export const cancelCampaignBriefResponseReceiptOneFieldsEvidenceItemRevisionMax = 100;

export const cancelCampaignBriefResponseReceiptOneFieldsEvidenceMax = 50;

export const cancelCampaignBriefResponseReceiptOneFieldsContentItemRevisionMax = 100;

export const cancelCampaignBriefResponseReceiptOneFieldsContentMax = 50;

export const cancelCampaignBriefResponseReceiptOneFieldsAudienceOneContactIdsMax = 20000;

export const cancelCampaignBriefResponseReceiptOneFieldsAudienceOneExcludedContactIdsMax = 20000;

export const cancelCampaignBriefResponseReceiptOneFieldsAudienceOneChannelsMax = 3;



export const cancelCampaignBriefResponse = zod.object({
  "id": zod.uuid(),
  "hash": zod.string(),
  "change": zod.object({
  "campaignId": zod.uuid(),
  "expectedVersion": zod.int().min(cancelCampaignBriefResponseChangeExpectedVersionMin),
  "expectedCampaignUpdatedAt": zod.iso.datetime({"offset":true}),
  "fields": zod.object({
  "objective": zod.string().max(cancelCampaignBriefResponseChangeFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(cancelCampaignBriefResponseChangeFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(cancelCampaignBriefResponseChangeFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(cancelCampaignBriefResponseChangeFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(cancelCampaignBriefResponseChangeFieldsThemesItemMax)).max(cancelCampaignBriefResponseChangeFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(cancelCampaignBriefResponseChangeFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(cancelCampaignBriefResponseChangeFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(cancelCampaignBriefResponseChangeFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(cancelCampaignBriefResponseChangeFieldsUnknownsItemMax)).max(cancelCampaignBriefResponseChangeFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(cancelCampaignBriefResponseChangeFieldsEvidenceItemRevisionMax)
})).max(cancelCampaignBriefResponseChangeFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(cancelCampaignBriefResponseChangeFieldsContentItemRevisionMax)
})).max(cancelCampaignBriefResponseChangeFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(cancelCampaignBriefResponseChangeFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(cancelCampaignBriefResponseChangeFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(cancelCampaignBriefResponseChangeFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "reason": zod.string().min(cancelCampaignBriefResponseChangeReasonMin).max(cancelCampaignBriefResponseChangeReasonMax)
}),
  "before": zod.union([zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(cancelCampaignBriefResponseBeforeOneFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(cancelCampaignBriefResponseBeforeOneFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(cancelCampaignBriefResponseBeforeOneFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(cancelCampaignBriefResponseBeforeOneFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(cancelCampaignBriefResponseBeforeOneFieldsThemesItemMax)).max(cancelCampaignBriefResponseBeforeOneFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(cancelCampaignBriefResponseBeforeOneFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(cancelCampaignBriefResponseBeforeOneFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(cancelCampaignBriefResponseBeforeOneFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(cancelCampaignBriefResponseBeforeOneFieldsUnknownsItemMax)).max(cancelCampaignBriefResponseBeforeOneFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(cancelCampaignBriefResponseBeforeOneFieldsEvidenceItemRevisionMax)
})).max(cancelCampaignBriefResponseBeforeOneFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(cancelCampaignBriefResponseBeforeOneFieldsContentItemRevisionMax)
})).max(cancelCampaignBriefResponseBeforeOneFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(cancelCampaignBriefResponseBeforeOneFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(cancelCampaignBriefResponseBeforeOneFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(cancelCampaignBriefResponseBeforeOneFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),zod.null()]),
  "after": zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(cancelCampaignBriefResponseAfterFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(cancelCampaignBriefResponseAfterFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(cancelCampaignBriefResponseAfterFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(cancelCampaignBriefResponseAfterFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(cancelCampaignBriefResponseAfterFieldsThemesItemMax)).max(cancelCampaignBriefResponseAfterFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(cancelCampaignBriefResponseAfterFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(cancelCampaignBriefResponseAfterFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(cancelCampaignBriefResponseAfterFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(cancelCampaignBriefResponseAfterFieldsUnknownsItemMax)).max(cancelCampaignBriefResponseAfterFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(cancelCampaignBriefResponseAfterFieldsEvidenceItemRevisionMax)
})).max(cancelCampaignBriefResponseAfterFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(cancelCampaignBriefResponseAfterFieldsContentItemRevisionMax)
})).max(cancelCampaignBriefResponseAfterFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(cancelCampaignBriefResponseAfterFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(cancelCampaignBriefResponseAfterFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(cancelCampaignBriefResponseAfterFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),
  "status": zod.enum(['reviewed', 'committed', 'cancelled']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "receipt": zod.union([zod.object({
  "campaignId": zod.uuid(),
  "version": zod.int(),
  "fields": zod.object({
  "objective": zod.string().max(cancelCampaignBriefResponseReceiptOneFieldsObjectiveMax).nullable(),
  "successMeasure": zod.string().max(cancelCampaignBriefResponseReceiptOneFieldsSuccessMeasureMax).nullable(),
  "offer": zod.string().max(cancelCampaignBriefResponseReceiptOneFieldsOfferMax).nullable(),
  "audienceRationale": zod.string().max(cancelCampaignBriefResponseReceiptOneFieldsAudienceRationaleMax).nullable(),
  "themes": zod.array(zod.string().max(cancelCampaignBriefResponseReceiptOneFieldsThemesItemMax)).max(cancelCampaignBriefResponseReceiptOneFieldsThemesMax),
  "outputs": zod.array(zod.enum(['email', 'sms', 'whatsapp', 'social', 'media', 'web_page', 'download', 'meta_ads', 'linkedin_ads', 'google_search', 'google_display', 'youtube_ads', 'tiktok_ads', 'x_ads'])).max(cancelCampaignBriefResponseReceiptOneFieldsOutputsMax),
  "ownerId": zod.uuid().nullable(),
  "plannedStart": zod.iso.datetime({"offset":true}).nullable(),
  "plannedEnd": zod.iso.datetime({"offset":true}).nullable(),
  "budget": zod.string().regex(cancelCampaignBriefResponseReceiptOneFieldsBudgetRegExp).nullable(),
  "currency": zod.string().regex(cancelCampaignBriefResponseReceiptOneFieldsCurrencyRegExp).nullable(),
  "unknowns": zod.array(zod.string().min(1).max(cancelCampaignBriefResponseReceiptOneFieldsUnknownsItemMax)).max(cancelCampaignBriefResponseReceiptOneFieldsUnknownsMax),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(cancelCampaignBriefResponseReceiptOneFieldsEvidenceItemRevisionMax)
})).max(cancelCampaignBriefResponseReceiptOneFieldsEvidenceMax),
  "content": zod.array(zod.object({
  "kind": zod.enum(['content_asset', 'social_post', 'tender', 'managed_document', 'microsite', 'media_asset']),
  "recordId": zod.uuid(),
  "revision": zod.string().min(1).max(cancelCampaignBriefResponseReceiptOneFieldsContentItemRevisionMax)
})).max(cancelCampaignBriefResponseReceiptOneFieldsContentMax),
  "audience": zod.union([zod.object({
  "segmentId": zod.uuid().nullable(),
  "contactIds": zod.array(zod.uuid()).max(cancelCampaignBriefResponseReceiptOneFieldsAudienceOneContactIdsMax),
  "excludedContactIds": zod.array(zod.uuid()).max(cancelCampaignBriefResponseReceiptOneFieldsAudienceOneExcludedContactIdsMax),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp']),
  "stepId": zod.uuid().nullable()
})).min(1).max(cancelCampaignBriefResponseReceiptOneFieldsAudienceOneChannelsMax)
}),zod.null()])
}),
  "updatedBy": zod.uuid(),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "audienceFingerprint": zod.string().nullable(),
  "current": zod.boolean()
}),zod.null()])
})


export const listEmailCampaignsQueryLimitDefault = 50;
export const listEmailCampaignsQueryLimitMax = 100;

export const listEmailCampaignsQueryOffsetDefault = 0;
export const listEmailCampaignsQueryOffsetMin = 0;



export const listEmailCampaignsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEmailCampaignsQueryLimitMax).default(listEmailCampaignsQueryLimitDefault),
  "offset": zod.int().min(listEmailCampaignsQueryOffsetMin).default(listEmailCampaignsQueryOffsetDefault),
  "campaignId": zod.uuid().optional().describe('Exact canonical campaign backlink; scoped to the active entity.')
})


export const listEmailCampaignsResponseItemsItemStepsItemOneNameMax = 200;

export const listEmailCampaignsResponseItemsItemStepsItemOneSmsBodyMax = 1600;

export const listEmailCampaignsResponseItemsItemStepsItemOneSmsConsentModeDefault = `unless_opted_out`;
export const listEmailCampaignsResponseItemsItemStepsItemOneAutoPostWhenReadyDefault = false;
export const listEmailCampaignsResponseItemsItemProgressChannelsItemTotalMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsQueuedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsDispatchingMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsRetryMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsAwaitingApprovalMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsPendingMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsUnconfirmedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsAwaitingProviderConfirmationMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsSucceededMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsPartialMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsDefinitiveFailedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsSuppressedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemCountsCancelledMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemPlannedStepCountMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesAcceptedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesSentMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesDeliveredMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesReadMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesPublishedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsTotalMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsQueuedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsDispatchingMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsRetryMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsPendingMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsUnconfirmedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsPublishedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsFailedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsSkippedMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsCancelledMin = 0;

export const listEmailCampaignsResponseItemsItemProgressChannelsMax = 4;

export const listEmailCampaignsResponseItemsItemProgressDiscrepanciesMax = 4;

export const listEmailCampaignsResponseItemsItemProgressSnapshotTokenRegExp = new RegExp('^[a-f0-9]{64}$');
export const listEmailCampaignsResponseTotalMin = 0;



export const listEmailCampaignsResponse = zod.object({
  "items": zod.array(zod.object({
  "name": zod.string().min(1),
  "subject": zod.string(),
  "body": zod.string(),
  "recipients": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().optional(),
  "accountId": zod.uuid().optional()
})),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "providerKey": zod.string(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "steps": zod.array(zod.object({
  "type": zod.enum(['email', 'sms', 'social_post', 'whatsapp']),
  "name": zod.string().min(1).max(listEmailCampaignsResponseItemsItemStepsItemOneNameMax),
  "subject": zod.string().nullish(),
  "body": zod.string().nullish(),
  "smsBody": zod.string().max(listEmailCampaignsResponseItemsItemStepsItemOneSmsBodyMax).nullish(),
  "smsConsentMode": zod.enum(['unless_opted_out', 'opted_in_only']).default(listEmailCampaignsResponseItemsItemStepsItemOneSmsConsentModeDefault),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).optional(),
  "videoProjectId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "autoPostWhenReady": zod.boolean().default(listEmailCampaignsResponseItemsItemStepsItemOneAutoPostWhenReadyDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "campaignId": zod.uuid(),
  "position": zod.int().min(1),
  "smsOverrideConfirmedBy": zod.string().nullish(),
  "smsOverrideConfirmedAt": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['pending', 'queued', 'partial', 'sent', 'awaiting_approval', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
})),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "progress": zod.object({
  "version": zod.literal(1),
  "lifecycle": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "control": zod.enum(['unrestricted', 'paused', 'cancelled']),
  "state": zod.enum(['empty', 'pending', 'awaiting_approval', 'queued', 'dispatching', 'unconfirmed', 'settled']),
  "outcome": zod.enum(['none', 'succeeded', 'partial', 'failed', 'stopped']).nullable(),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp', 'social_post']),
  "unit": zod.enum(['recipient_delivery', 'social_step']),
  "total": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsQueuedMin),
  "dispatching": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsDispatchingMin),
  "retry": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsRetryMin),
  "awaitingApproval": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsAwaitingApprovalMin),
  "pending": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsPendingMin),
  "unconfirmed": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsUnconfirmedMin),
  "awaitingProviderConfirmation": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsAwaitingProviderConfirmationMin),
  "succeeded": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsSucceededMin),
  "partial": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsPartialMin),
  "definitiveFailed": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsDefinitiveFailedMin),
  "suppressed": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsSuppressedMin),
  "cancelled": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemCountsCancelledMin)
}),
  "plannedStepCount": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemPlannedStepCountMin),
  "milestones": zod.object({
  "accepted": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesAcceptedMin).nullable(),
  "sent": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesSentMin).nullable(),
  "delivered": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesDeliveredMin).nullable(),
  "read": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesReadMin).nullable(),
  "published": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemMilestonesPublishedMin).nullable()
}),
  "socialTargets": zod.object({
  "total": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsQueuedMin),
  "dispatching": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsDispatchingMin),
  "retry": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsRetryMin),
  "pending": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsPendingMin),
  "unconfirmed": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsUnconfirmedMin),
  "published": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsPublishedMin),
  "failed": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsFailedMin),
  "skipped": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsSkippedMin),
  "cancelled": zod.int().min(listEmailCampaignsResponseItemsItemProgressChannelsItemSocialTargetsCountsCancelledMin)
})
}).nullable()
}).describe('Exclusive counts sum to total. Email/SMS/WhatsApp use recipient_delivery; social_post uses social_step. Target counts have their own network-target unit.')).max(listEmailCampaignsResponseItemsItemProgressChannelsMax),
  "evidence": zod.object({
  "firstAcceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestSentAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestDeliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestReadAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestPublishedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "hasUnconfirmed": zod.boolean(),
  "hasPendingApproval": zod.boolean(),
  "discrepancies": zod.array(zod.enum(['legacy_status_differs', 'missing_execution', 'ambiguous_social_link', 'unsupported_fact'])).max(listEmailCampaignsResponseItemsItemProgressDiscrepanciesMax),
  "snapshotToken": zod.string().regex(listEmailCampaignsResponseItemsItemProgressSnapshotTokenRegExp)
}).optional().describe('Read-only complete scoped dispatch/publication facts; never readiness, approval or permission to send. No mixed-channel percentage. Missing progress means unavailable, never inferred from lifecycle.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Draft campaigns may have empty subject, body and recipients; delivery readiness is checked separately. Optional progress is read-only; absence means detailed progress unavailable.')),
  "total": zod.int().min(listEmailCampaignsResponseTotalMin).optional()
})


export const createEmailCampaignBodyNameMax = 200;

export const createEmailCampaignBodySubjectMax = 998;

export const createEmailCampaignBodyBodyMax = 100000;

export const createEmailCampaignBodyRecipientsDefault = [];
export const createEmailCampaignBodyRecipientsMax = 20000;

export const createEmailCampaignBodyStepsItemNameMax = 200;

export const createEmailCampaignBodyStepsItemSmsBodyMax = 1600;

export const createEmailCampaignBodyStepsItemSmsConsentModeDefault = `unless_opted_out`;
export const createEmailCampaignBodyStepsItemAutoPostWhenReadyDefault = false;

export const createEmailCampaignBody = zod.object({
  "name": zod.string().min(1).max(createEmailCampaignBodyNameMax),
  "subject": zod.string().max(createEmailCampaignBodySubjectMax).optional(),
  "body": zod.string().max(createEmailCampaignBodyBodyMax).optional(),
  "recipients": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().optional(),
  "accountId": zod.uuid().optional()
})).max(createEmailCampaignBodyRecipientsMax).default(createEmailCampaignBodyRecipientsDefault),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "steps": zod.array(zod.object({
  "type": zod.enum(['email', 'sms', 'social_post', 'whatsapp']),
  "name": zod.string().min(1).max(createEmailCampaignBodyStepsItemNameMax),
  "subject": zod.string().nullish(),
  "body": zod.string().nullish(),
  "smsBody": zod.string().max(createEmailCampaignBodyStepsItemSmsBodyMax).nullish(),
  "smsConsentMode": zod.enum(['unless_opted_out', 'opted_in_only']).default(createEmailCampaignBodyStepsItemSmsConsentModeDefault),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).optional(),
  "videoProjectId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "autoPostWhenReady": zod.boolean().default(createEmailCampaignBodyStepsItemAutoPostWhenReadyDefault)
})).optional().describe('Optional cross-channel steps. Email and SMS steps use their respective consent-checked delivery paths; social-post steps are created in pending approval unless a media manager explicitly enables autoPostWhenReady for a generated-video project.')
}).describe('A name-only campaign is saved as an unscheduled unfinished draft. Subject, body and recipients may be completed later. Scheduling and delivery require complete content and recipients for every email step; channel-specific consent and review remain mandatory.')


export const createEmailCampaignResponseStepsItemOneNameMax = 200;

export const createEmailCampaignResponseStepsItemOneSmsBodyMax = 1600;

export const createEmailCampaignResponseStepsItemOneSmsConsentModeDefault = `unless_opted_out`;
export const createEmailCampaignResponseStepsItemOneAutoPostWhenReadyDefault = false;
export const createEmailCampaignResponseProgressChannelsItemTotalMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsQueuedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsDispatchingMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsRetryMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsAwaitingApprovalMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsPendingMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsUnconfirmedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsAwaitingProviderConfirmationMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsSucceededMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsPartialMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsDefinitiveFailedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsSuppressedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemCountsCancelledMin = 0;

export const createEmailCampaignResponseProgressChannelsItemPlannedStepCountMin = 0;

export const createEmailCampaignResponseProgressChannelsItemMilestonesAcceptedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemMilestonesSentMin = 0;

export const createEmailCampaignResponseProgressChannelsItemMilestonesDeliveredMin = 0;

export const createEmailCampaignResponseProgressChannelsItemMilestonesReadMin = 0;

export const createEmailCampaignResponseProgressChannelsItemMilestonesPublishedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsTotalMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsQueuedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsDispatchingMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsRetryMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPendingMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsUnconfirmedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPublishedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsFailedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsSkippedMin = 0;

export const createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsCancelledMin = 0;

export const createEmailCampaignResponseProgressChannelsMax = 4;

export const createEmailCampaignResponseProgressDiscrepanciesMax = 4;

export const createEmailCampaignResponseProgressSnapshotTokenRegExp = new RegExp('^[a-f0-9]{64}$');


export const createEmailCampaignResponse = zod.object({
  "name": zod.string().min(1),
  "subject": zod.string(),
  "body": zod.string(),
  "recipients": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().optional(),
  "accountId": zod.uuid().optional()
})),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "providerKey": zod.string(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "steps": zod.array(zod.object({
  "type": zod.enum(['email', 'sms', 'social_post', 'whatsapp']),
  "name": zod.string().min(1).max(createEmailCampaignResponseStepsItemOneNameMax),
  "subject": zod.string().nullish(),
  "body": zod.string().nullish(),
  "smsBody": zod.string().max(createEmailCampaignResponseStepsItemOneSmsBodyMax).nullish(),
  "smsConsentMode": zod.enum(['unless_opted_out', 'opted_in_only']).default(createEmailCampaignResponseStepsItemOneSmsConsentModeDefault),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).optional(),
  "videoProjectId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "autoPostWhenReady": zod.boolean().default(createEmailCampaignResponseStepsItemOneAutoPostWhenReadyDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "campaignId": zod.uuid(),
  "position": zod.int().min(1),
  "smsOverrideConfirmedBy": zod.string().nullish(),
  "smsOverrideConfirmedAt": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['pending', 'queued', 'partial', 'sent', 'awaiting_approval', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
})),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "progress": zod.object({
  "version": zod.literal(1),
  "lifecycle": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "control": zod.enum(['unrestricted', 'paused', 'cancelled']),
  "state": zod.enum(['empty', 'pending', 'awaiting_approval', 'queued', 'dispatching', 'unconfirmed', 'settled']),
  "outcome": zod.enum(['none', 'succeeded', 'partial', 'failed', 'stopped']).nullable(),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp', 'social_post']),
  "unit": zod.enum(['recipient_delivery', 'social_step']),
  "total": zod.int().min(createEmailCampaignResponseProgressChannelsItemTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsQueuedMin),
  "dispatching": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsDispatchingMin),
  "retry": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsRetryMin),
  "awaitingApproval": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsAwaitingApprovalMin),
  "pending": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsPendingMin),
  "unconfirmed": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsUnconfirmedMin),
  "awaitingProviderConfirmation": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsAwaitingProviderConfirmationMin),
  "succeeded": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsSucceededMin),
  "partial": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsPartialMin),
  "definitiveFailed": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsDefinitiveFailedMin),
  "suppressed": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsSuppressedMin),
  "cancelled": zod.int().min(createEmailCampaignResponseProgressChannelsItemCountsCancelledMin)
}),
  "plannedStepCount": zod.int().min(createEmailCampaignResponseProgressChannelsItemPlannedStepCountMin),
  "milestones": zod.object({
  "accepted": zod.int().min(createEmailCampaignResponseProgressChannelsItemMilestonesAcceptedMin).nullable(),
  "sent": zod.int().min(createEmailCampaignResponseProgressChannelsItemMilestonesSentMin).nullable(),
  "delivered": zod.int().min(createEmailCampaignResponseProgressChannelsItemMilestonesDeliveredMin).nullable(),
  "read": zod.int().min(createEmailCampaignResponseProgressChannelsItemMilestonesReadMin).nullable(),
  "published": zod.int().min(createEmailCampaignResponseProgressChannelsItemMilestonesPublishedMin).nullable()
}),
  "socialTargets": zod.object({
  "total": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsQueuedMin),
  "dispatching": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsDispatchingMin),
  "retry": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsRetryMin),
  "pending": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPendingMin),
  "unconfirmed": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsUnconfirmedMin),
  "published": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPublishedMin),
  "failed": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsFailedMin),
  "skipped": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsSkippedMin),
  "cancelled": zod.int().min(createEmailCampaignResponseProgressChannelsItemSocialTargetsCountsCancelledMin)
})
}).nullable()
}).describe('Exclusive counts sum to total. Email/SMS/WhatsApp use recipient_delivery; social_post uses social_step. Target counts have their own network-target unit.')).max(createEmailCampaignResponseProgressChannelsMax),
  "evidence": zod.object({
  "firstAcceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestSentAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestDeliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestReadAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestPublishedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "hasUnconfirmed": zod.boolean(),
  "hasPendingApproval": zod.boolean(),
  "discrepancies": zod.array(zod.enum(['legacy_status_differs', 'missing_execution', 'ambiguous_social_link', 'unsupported_fact'])).max(createEmailCampaignResponseProgressDiscrepanciesMax),
  "snapshotToken": zod.string().regex(createEmailCampaignResponseProgressSnapshotTokenRegExp)
}).optional().describe('Read-only complete scoped dispatch/publication facts; never readiness, approval or permission to send. No mixed-channel percentage. Missing progress means unavailable, never inferred from lifecycle.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Draft campaigns may have empty subject, body and recipients; delivery readiness is checked separately. Optional progress is read-only; absence means detailed progress unavailable.')


export const updateEmailCampaignParams = zod.object({
  "id": zod.uuid()
})

export const updateEmailCampaignBodyNameMax = 200;

export const updateEmailCampaignBodySubjectMax = 998;

export const updateEmailCampaignBodyBodyMax = 100000;

export const updateEmailCampaignBodyRecipientsMin = 0;
export const updateEmailCampaignBodyRecipientsMax = 500;



export const updateEmailCampaignBody = zod.object({
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "name": zod.string().min(1).max(updateEmailCampaignBodyNameMax).optional(),
  "subject": zod.string().max(updateEmailCampaignBodySubjectMax).optional(),
  "body": zod.string().max(updateEmailCampaignBodyBodyMax).optional(),
  "recipients": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
})).min(updateEmailCampaignBodyRecipientsMin).max(updateEmailCampaignBodyRecipientsMax).optional(),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish()
})


export const updateEmailCampaignResponseStepsItemOneNameMax = 200;

export const updateEmailCampaignResponseStepsItemOneSmsBodyMax = 1600;

export const updateEmailCampaignResponseStepsItemOneSmsConsentModeDefault = `unless_opted_out`;
export const updateEmailCampaignResponseStepsItemOneAutoPostWhenReadyDefault = false;
export const updateEmailCampaignResponseProgressChannelsItemTotalMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsQueuedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsDispatchingMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsRetryMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsAwaitingApprovalMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsPendingMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsUnconfirmedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsAwaitingProviderConfirmationMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsSucceededMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsPartialMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsDefinitiveFailedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsSuppressedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemCountsCancelledMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemPlannedStepCountMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemMilestonesAcceptedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemMilestonesSentMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemMilestonesDeliveredMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemMilestonesReadMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemMilestonesPublishedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsTotalMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsQueuedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsDispatchingMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsRetryMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPendingMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsUnconfirmedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPublishedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsFailedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsSkippedMin = 0;

export const updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsCancelledMin = 0;

export const updateEmailCampaignResponseProgressChannelsMax = 4;

export const updateEmailCampaignResponseProgressDiscrepanciesMax = 4;

export const updateEmailCampaignResponseProgressSnapshotTokenRegExp = new RegExp('^[a-f0-9]{64}$');


export const updateEmailCampaignResponse = zod.object({
  "name": zod.string().min(1),
  "subject": zod.string(),
  "body": zod.string(),
  "recipients": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().optional(),
  "accountId": zod.uuid().optional()
})),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "providerKey": zod.string(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "steps": zod.array(zod.object({
  "type": zod.enum(['email', 'sms', 'social_post', 'whatsapp']),
  "name": zod.string().min(1).max(updateEmailCampaignResponseStepsItemOneNameMax),
  "subject": zod.string().nullish(),
  "body": zod.string().nullish(),
  "smsBody": zod.string().max(updateEmailCampaignResponseStepsItemOneSmsBodyMax).nullish(),
  "smsConsentMode": zod.enum(['unless_opted_out', 'opted_in_only']).default(updateEmailCampaignResponseStepsItemOneSmsConsentModeDefault),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).optional(),
  "videoProjectId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "autoPostWhenReady": zod.boolean().default(updateEmailCampaignResponseStepsItemOneAutoPostWhenReadyDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "campaignId": zod.uuid(),
  "position": zod.int().min(1),
  "smsOverrideConfirmedBy": zod.string().nullish(),
  "smsOverrideConfirmedAt": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['pending', 'queued', 'partial', 'sent', 'awaiting_approval', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
})),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "progress": zod.object({
  "version": zod.literal(1),
  "lifecycle": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "control": zod.enum(['unrestricted', 'paused', 'cancelled']),
  "state": zod.enum(['empty', 'pending', 'awaiting_approval', 'queued', 'dispatching', 'unconfirmed', 'settled']),
  "outcome": zod.enum(['none', 'succeeded', 'partial', 'failed', 'stopped']).nullable(),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp', 'social_post']),
  "unit": zod.enum(['recipient_delivery', 'social_step']),
  "total": zod.int().min(updateEmailCampaignResponseProgressChannelsItemTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsQueuedMin),
  "dispatching": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsDispatchingMin),
  "retry": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsRetryMin),
  "awaitingApproval": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsAwaitingApprovalMin),
  "pending": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsPendingMin),
  "unconfirmed": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsUnconfirmedMin),
  "awaitingProviderConfirmation": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsAwaitingProviderConfirmationMin),
  "succeeded": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsSucceededMin),
  "partial": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsPartialMin),
  "definitiveFailed": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsDefinitiveFailedMin),
  "suppressed": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsSuppressedMin),
  "cancelled": zod.int().min(updateEmailCampaignResponseProgressChannelsItemCountsCancelledMin)
}),
  "plannedStepCount": zod.int().min(updateEmailCampaignResponseProgressChannelsItemPlannedStepCountMin),
  "milestones": zod.object({
  "accepted": zod.int().min(updateEmailCampaignResponseProgressChannelsItemMilestonesAcceptedMin).nullable(),
  "sent": zod.int().min(updateEmailCampaignResponseProgressChannelsItemMilestonesSentMin).nullable(),
  "delivered": zod.int().min(updateEmailCampaignResponseProgressChannelsItemMilestonesDeliveredMin).nullable(),
  "read": zod.int().min(updateEmailCampaignResponseProgressChannelsItemMilestonesReadMin).nullable(),
  "published": zod.int().min(updateEmailCampaignResponseProgressChannelsItemMilestonesPublishedMin).nullable()
}),
  "socialTargets": zod.object({
  "total": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsQueuedMin),
  "dispatching": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsDispatchingMin),
  "retry": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsRetryMin),
  "pending": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPendingMin),
  "unconfirmed": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsUnconfirmedMin),
  "published": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPublishedMin),
  "failed": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsFailedMin),
  "skipped": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsSkippedMin),
  "cancelled": zod.int().min(updateEmailCampaignResponseProgressChannelsItemSocialTargetsCountsCancelledMin)
})
}).nullable()
}).describe('Exclusive counts sum to total. Email/SMS/WhatsApp use recipient_delivery; social_post uses social_step. Target counts have their own network-target unit.')).max(updateEmailCampaignResponseProgressChannelsMax),
  "evidence": zod.object({
  "firstAcceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestSentAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestDeliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestReadAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestPublishedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "hasUnconfirmed": zod.boolean(),
  "hasPendingApproval": zod.boolean(),
  "discrepancies": zod.array(zod.enum(['legacy_status_differs', 'missing_execution', 'ambiguous_social_link', 'unsupported_fact'])).max(updateEmailCampaignResponseProgressDiscrepanciesMax),
  "snapshotToken": zod.string().regex(updateEmailCampaignResponseProgressSnapshotTokenRegExp)
}).optional().describe('Read-only complete scoped dispatch/publication facts; never readiness, approval or permission to send. No mixed-channel percentage. Missing progress means unavailable, never inferred from lifecycle.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Draft campaigns may have empty subject, body and recipients; delivery readiness is checked separately. Optional progress is read-only; absence means detailed progress unavailable.')


export const sendEmailCampaignParams = zod.object({
  "id": zod.uuid()
})


export const sendEmailCampaignResponseStepsItemOneNameMax = 200;

export const sendEmailCampaignResponseStepsItemOneSmsBodyMax = 1600;

export const sendEmailCampaignResponseStepsItemOneSmsConsentModeDefault = `unless_opted_out`;
export const sendEmailCampaignResponseStepsItemOneAutoPostWhenReadyDefault = false;
export const sendEmailCampaignResponseProgressChannelsItemTotalMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsQueuedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsDispatchingMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsRetryMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsAwaitingApprovalMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsPendingMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsUnconfirmedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsAwaitingProviderConfirmationMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsSucceededMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsPartialMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsDefinitiveFailedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsSuppressedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemCountsCancelledMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemPlannedStepCountMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemMilestonesAcceptedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemMilestonesSentMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemMilestonesDeliveredMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemMilestonesReadMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemMilestonesPublishedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsTotalMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsQueuedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsDispatchingMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsRetryMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPendingMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsUnconfirmedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPublishedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsFailedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsSkippedMin = 0;

export const sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsCancelledMin = 0;

export const sendEmailCampaignResponseProgressChannelsMax = 4;

export const sendEmailCampaignResponseProgressDiscrepanciesMax = 4;

export const sendEmailCampaignResponseProgressSnapshotTokenRegExp = new RegExp('^[a-f0-9]{64}$');


export const sendEmailCampaignResponse = zod.object({
  "name": zod.string().min(1),
  "subject": zod.string(),
  "body": zod.string(),
  "recipients": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().optional(),
  "accountId": zod.uuid().optional()
})),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "providerKey": zod.string(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "steps": zod.array(zod.object({
  "type": zod.enum(['email', 'sms', 'social_post', 'whatsapp']),
  "name": zod.string().min(1).max(sendEmailCampaignResponseStepsItemOneNameMax),
  "subject": zod.string().nullish(),
  "body": zod.string().nullish(),
  "smsBody": zod.string().max(sendEmailCampaignResponseStepsItemOneSmsBodyMax).nullish(),
  "smsConsentMode": zod.enum(['unless_opted_out', 'opted_in_only']).default(sendEmailCampaignResponseStepsItemOneSmsConsentModeDefault),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).optional(),
  "videoProjectId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "autoPostWhenReady": zod.boolean().default(sendEmailCampaignResponseStepsItemOneAutoPostWhenReadyDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "campaignId": zod.uuid(),
  "position": zod.int().min(1),
  "smsOverrideConfirmedBy": zod.string().nullish(),
  "smsOverrideConfirmedAt": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['pending', 'queued', 'partial', 'sent', 'awaiting_approval', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
})),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "progress": zod.object({
  "version": zod.literal(1),
  "lifecycle": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "control": zod.enum(['unrestricted', 'paused', 'cancelled']),
  "state": zod.enum(['empty', 'pending', 'awaiting_approval', 'queued', 'dispatching', 'unconfirmed', 'settled']),
  "outcome": zod.enum(['none', 'succeeded', 'partial', 'failed', 'stopped']).nullable(),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp', 'social_post']),
  "unit": zod.enum(['recipient_delivery', 'social_step']),
  "total": zod.int().min(sendEmailCampaignResponseProgressChannelsItemTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsQueuedMin),
  "dispatching": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsDispatchingMin),
  "retry": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsRetryMin),
  "awaitingApproval": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsAwaitingApprovalMin),
  "pending": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsPendingMin),
  "unconfirmed": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsUnconfirmedMin),
  "awaitingProviderConfirmation": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsAwaitingProviderConfirmationMin),
  "succeeded": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsSucceededMin),
  "partial": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsPartialMin),
  "definitiveFailed": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsDefinitiveFailedMin),
  "suppressed": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsSuppressedMin),
  "cancelled": zod.int().min(sendEmailCampaignResponseProgressChannelsItemCountsCancelledMin)
}),
  "plannedStepCount": zod.int().min(sendEmailCampaignResponseProgressChannelsItemPlannedStepCountMin),
  "milestones": zod.object({
  "accepted": zod.int().min(sendEmailCampaignResponseProgressChannelsItemMilestonesAcceptedMin).nullable(),
  "sent": zod.int().min(sendEmailCampaignResponseProgressChannelsItemMilestonesSentMin).nullable(),
  "delivered": zod.int().min(sendEmailCampaignResponseProgressChannelsItemMilestonesDeliveredMin).nullable(),
  "read": zod.int().min(sendEmailCampaignResponseProgressChannelsItemMilestonesReadMin).nullable(),
  "published": zod.int().min(sendEmailCampaignResponseProgressChannelsItemMilestonesPublishedMin).nullable()
}),
  "socialTargets": zod.object({
  "total": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsQueuedMin),
  "dispatching": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsDispatchingMin),
  "retry": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsRetryMin),
  "pending": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPendingMin),
  "unconfirmed": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsUnconfirmedMin),
  "published": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPublishedMin),
  "failed": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsFailedMin),
  "skipped": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsSkippedMin),
  "cancelled": zod.int().min(sendEmailCampaignResponseProgressChannelsItemSocialTargetsCountsCancelledMin)
})
}).nullable()
}).describe('Exclusive counts sum to total. Email/SMS/WhatsApp use recipient_delivery; social_post uses social_step. Target counts have their own network-target unit.')).max(sendEmailCampaignResponseProgressChannelsMax),
  "evidence": zod.object({
  "firstAcceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestSentAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestDeliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestReadAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestPublishedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "hasUnconfirmed": zod.boolean(),
  "hasPendingApproval": zod.boolean(),
  "discrepancies": zod.array(zod.enum(['legacy_status_differs', 'missing_execution', 'ambiguous_social_link', 'unsupported_fact'])).max(sendEmailCampaignResponseProgressDiscrepanciesMax),
  "snapshotToken": zod.string().regex(sendEmailCampaignResponseProgressSnapshotTokenRegExp)
}).optional().describe('Read-only complete scoped dispatch/publication facts; never readiness, approval or permission to send. No mixed-channel percentage. Missing progress means unavailable, never inferred from lifecycle.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Draft campaigns may have empty subject, body and recipients; delivery readiness is checked separately. Optional progress is read-only; absence means detailed progress unavailable.')


export const controlEmailCampaignParams = zod.object({
  "id": zod.uuid()
})

export const controlEmailCampaignBodyReasonMin = 3;
export const controlEmailCampaignBodyReasonMax = 500;



export const controlEmailCampaignBody = zod.object({
  "action": zod.enum(['pause', 'resume', 'stop']),
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(controlEmailCampaignBodyReasonMin).max(controlEmailCampaignBodyReasonMax)
})


export const controlEmailCampaignResponseStepsItemOneNameMax = 200;

export const controlEmailCampaignResponseStepsItemOneSmsBodyMax = 1600;

export const controlEmailCampaignResponseStepsItemOneSmsConsentModeDefault = `unless_opted_out`;
export const controlEmailCampaignResponseStepsItemOneAutoPostWhenReadyDefault = false;
export const controlEmailCampaignResponseProgressChannelsItemTotalMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsQueuedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsDispatchingMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsRetryMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsAwaitingApprovalMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsPendingMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsUnconfirmedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsAwaitingProviderConfirmationMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsSucceededMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsPartialMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsDefinitiveFailedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsSuppressedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemCountsCancelledMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemPlannedStepCountMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemMilestonesAcceptedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemMilestonesSentMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemMilestonesDeliveredMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemMilestonesReadMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemMilestonesPublishedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsTotalMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsQueuedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsDispatchingMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsRetryMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPendingMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsUnconfirmedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPublishedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsFailedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsSkippedMin = 0;

export const controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsCancelledMin = 0;

export const controlEmailCampaignResponseProgressChannelsMax = 4;

export const controlEmailCampaignResponseProgressDiscrepanciesMax = 4;

export const controlEmailCampaignResponseProgressSnapshotTokenRegExp = new RegExp('^[a-f0-9]{64}$');


export const controlEmailCampaignResponse = zod.object({
  "name": zod.string().min(1),
  "subject": zod.string(),
  "body": zod.string(),
  "recipients": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().optional(),
  "accountId": zod.uuid().optional()
})),
  "scheduledAt": zod.iso.datetime({"offset":true}).nullish(),
  "id": zod.uuid(),
  "status": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "providerKey": zod.string(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "steps": zod.array(zod.object({
  "type": zod.enum(['email', 'sms', 'social_post', 'whatsapp']),
  "name": zod.string().min(1).max(controlEmailCampaignResponseStepsItemOneNameMax),
  "subject": zod.string().nullish(),
  "body": zod.string().nullish(),
  "smsBody": zod.string().max(controlEmailCampaignResponseStepsItemOneSmsBodyMax).nullish(),
  "smsConsentMode": zod.enum(['unless_opted_out', 'opted_in_only']).default(controlEmailCampaignResponseStepsItemOneSmsConsentModeDefault),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).optional(),
  "videoProjectId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "autoPostWhenReady": zod.boolean().default(controlEmailCampaignResponseStepsItemOneAutoPostWhenReadyDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "campaignId": zod.uuid(),
  "position": zod.int().min(1),
  "smsOverrideConfirmedBy": zod.string().nullish(),
  "smsOverrideConfirmedAt": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['pending', 'queued', 'partial', 'sent', 'awaiting_approval', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
})),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))),
  "progress": zod.object({
  "version": zod.literal(1),
  "lifecycle": zod.enum(['draft', 'scheduled', 'queued', 'sending', 'paused', 'sent', 'partial', 'failed', 'cancelled']),
  "control": zod.enum(['unrestricted', 'paused', 'cancelled']),
  "state": zod.enum(['empty', 'pending', 'awaiting_approval', 'queued', 'dispatching', 'unconfirmed', 'settled']),
  "outcome": zod.enum(['none', 'succeeded', 'partial', 'failed', 'stopped']).nullable(),
  "channels": zod.array(zod.object({
  "channel": zod.enum(['email', 'sms', 'whatsapp', 'social_post']),
  "unit": zod.enum(['recipient_delivery', 'social_step']),
  "total": zod.int().min(controlEmailCampaignResponseProgressChannelsItemTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsQueuedMin),
  "dispatching": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsDispatchingMin),
  "retry": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsRetryMin),
  "awaitingApproval": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsAwaitingApprovalMin),
  "pending": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsPendingMin),
  "unconfirmed": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsUnconfirmedMin),
  "awaitingProviderConfirmation": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsAwaitingProviderConfirmationMin),
  "succeeded": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsSucceededMin),
  "partial": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsPartialMin),
  "definitiveFailed": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsDefinitiveFailedMin),
  "suppressed": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsSuppressedMin),
  "cancelled": zod.int().min(controlEmailCampaignResponseProgressChannelsItemCountsCancelledMin)
}),
  "plannedStepCount": zod.int().min(controlEmailCampaignResponseProgressChannelsItemPlannedStepCountMin),
  "milestones": zod.object({
  "accepted": zod.int().min(controlEmailCampaignResponseProgressChannelsItemMilestonesAcceptedMin).nullable(),
  "sent": zod.int().min(controlEmailCampaignResponseProgressChannelsItemMilestonesSentMin).nullable(),
  "delivered": zod.int().min(controlEmailCampaignResponseProgressChannelsItemMilestonesDeliveredMin).nullable(),
  "read": zod.int().min(controlEmailCampaignResponseProgressChannelsItemMilestonesReadMin).nullable(),
  "published": zod.int().min(controlEmailCampaignResponseProgressChannelsItemMilestonesPublishedMin).nullable()
}),
  "socialTargets": zod.object({
  "total": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsQueuedMin),
  "dispatching": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsDispatchingMin),
  "retry": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsRetryMin),
  "pending": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPendingMin),
  "unconfirmed": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsUnconfirmedMin),
  "published": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsPublishedMin),
  "failed": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsFailedMin),
  "skipped": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsSkippedMin),
  "cancelled": zod.int().min(controlEmailCampaignResponseProgressChannelsItemSocialTargetsCountsCancelledMin)
})
}).nullable()
}).describe('Exclusive counts sum to total. Email/SMS/WhatsApp use recipient_delivery; social_post uses social_step. Target counts have their own network-target unit.')).max(controlEmailCampaignResponseProgressChannelsMax),
  "evidence": zod.object({
  "firstAcceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestSentAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestDeliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestReadAt": zod.iso.datetime({"offset":true}).nullable(),
  "latestPublishedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "hasUnconfirmed": zod.boolean(),
  "hasPendingApproval": zod.boolean(),
  "discrepancies": zod.array(zod.enum(['legacy_status_differs', 'missing_execution', 'ambiguous_social_link', 'unsupported_fact'])).max(controlEmailCampaignResponseProgressDiscrepanciesMax),
  "snapshotToken": zod.string().regex(controlEmailCampaignResponseProgressSnapshotTokenRegExp)
}).optional().describe('Read-only complete scoped dispatch/publication facts; never readiness, approval or permission to send. No mixed-channel percentage. Missing progress means unavailable, never inferred from lifecycle.'),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Draft campaigns may have empty subject, body and recipients; delivery readiness is checked separately. Optional progress is read-only; absence means detailed progress unavailable.')


export const listEmailCampaignDeliveriesParams = zod.object({
  "id": zod.uuid()
})

export const listEmailCampaignDeliveriesQueryLimitDefault = 25;
export const listEmailCampaignDeliveriesQueryLimitMax = 100;

export const listEmailCampaignDeliveriesQueryOffsetDefault = 0;
export const listEmailCampaignDeliveriesQueryOffsetMin = 0;



export const listEmailCampaignDeliveriesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listEmailCampaignDeliveriesQueryLimitMax).default(listEmailCampaignDeliveriesQueryLimitDefault),
  "offset": zod.int().min(listEmailCampaignDeliveriesQueryOffsetMin).default(listEmailCampaignDeliveriesQueryOffsetDefault)
})

export const listEmailCampaignDeliveriesResponseItemsItemAttemptCountMin = 0;

export const listEmailCampaignDeliveriesResponseTotalMin = 0;


export const listEmailCampaignDeliveriesResponseOffsetMin = 0;



export const listEmailCampaignDeliveriesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['campaign', 'sequence', 'review_request']),
  "campaignId": zod.uuid().nullish(),
  "sequenceId": zod.uuid().nullish(),
  "stepId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "enrollmentId": zod.uuid().nullish(),
  "reviewRequestId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "toAddress": zod.email(),
  "subject": zod.string().optional(),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'sent', 'suppressed', 'failed', 'uncertain', 'cancelled']),
  "reason": zod.string().nullish(),
  "providerKey": zod.string(),
  "providerMessageId": zod.string().nullish(),
  "attemptCount": zod.int().min(listEmailCampaignDeliveriesResponseItemsItemAttemptCountMin),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listEmailCampaignDeliveriesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listEmailCampaignDeliveriesResponseOffsetMin)
})


/**
 * @summary Preview CRM consent and suppression eligibility without sending
 */
export const previewEmailRecipientsBodyRecipientsMax = 500;



export const previewEmailRecipientsBody = zod.object({
  "recipients": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish()
})).min(1).max(previewEmailRecipientsBodyRecipientsMax)
})

export const previewEmailRecipientsResponseTotalMin = 0;

export const previewEmailRecipientsResponseEligibleMin = 0;

export const previewEmailRecipientsResponseBlockedMin = 0;



export const previewEmailRecipientsResponse = zod.object({
  "items": zod.array(zod.object({
  "email": zod.email(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "eligible": zod.boolean(),
  "status": zod.enum(['eligible', 'suppressed', 'contact_opt_out', 'consent_opted_out', 'consent_missing', 'identity_mismatch']),
  "reason": zod.string()
})),
  "total": zod.int().min(previewEmailRecipientsResponseTotalMin),
  "eligible": zod.int().min(previewEmailRecipientsResponseEligibleMin),
  "blocked": zod.int().min(previewEmailRecipientsResponseBlockedMin)
})


/**
 * @summary Retry a known pre-dispatch failure; uncertain deliveries cannot be retried
 */
export const retryEmailDeliveryParams = zod.object({
  "id": zod.uuid()
})

export const retryEmailDeliveryResponseAttemptCountMin = 0;



export const retryEmailDeliveryResponse = zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['campaign', 'sequence', 'review_request']),
  "campaignId": zod.uuid().nullish(),
  "sequenceId": zod.uuid().nullish(),
  "stepId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "enrollmentId": zod.uuid().nullish(),
  "reviewRequestId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "toAddress": zod.email(),
  "subject": zod.string().optional(),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'sent', 'suppressed', 'failed', 'uncertain', 'cancelled']),
  "reason": zod.string().nullish(),
  "providerKey": zod.string(),
  "providerMessageId": zod.string().nullish(),
  "attemptCount": zod.int().min(retryEmailDeliveryResponseAttemptCountMin),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Show whether SMS uses Twilio or the network-free simulation provider
 */
export const getSmsProviderStatusResponse = zod.object({
  "provider": zod.enum(['twilio', 'simulation']),
  "configured": zod.boolean()
})


/**
 * @summary Accept a signed inbound SMS from the connected Twilio number
 */
export const receiveTwilioSmsBodyMessageSidMin = 10;
export const receiveTwilioSmsBodyMessageSidMax = 80;

export const receiveTwilioSmsBodyFromMin = 5;
export const receiveTwilioSmsBodyFromMax = 50;

export const receiveTwilioSmsBodyToMin = 5;
export const receiveTwilioSmsBodyToMax = 50;

export const receiveTwilioSmsBodyBodyMax = 1600;



export const receiveTwilioSmsBody = zod.object({
  "MessageSid": zod.string().min(receiveTwilioSmsBodyMessageSidMin).max(receiveTwilioSmsBodyMessageSidMax),
  "From": zod.string().min(receiveTwilioSmsBodyFromMin).max(receiveTwilioSmsBodyFromMax),
  "To": zod.string().min(receiveTwilioSmsBodyToMin).max(receiveTwilioSmsBodyToMax),
  "Body": zod.string().max(receiveTwilioSmsBodyBodyMax)
})

export const receiveTwilioSmsResponse = zod.unknown()


/**
 * @summary Accept a signed SMS delivery status callback
 */
export const receiveTwilioSmsStatusQueryParams = zod.object({
  "ref": zod.uuid()
})

export const receiveTwilioSmsStatusBodyMessageSidMin = 10;
export const receiveTwilioSmsStatusBodyMessageSidMax = 80;

export const receiveTwilioSmsStatusBodyMessageStatusMin = 2;
export const receiveTwilioSmsStatusBodyMessageStatusMax = 40;

export const receiveTwilioSmsStatusBodyErrorCodeMax = 40;

export const receiveTwilioSmsStatusBodyErrorMessageMax = 500;



export const receiveTwilioSmsStatusBody = zod.object({
  "MessageSid": zod.string().min(receiveTwilioSmsStatusBodyMessageSidMin).max(receiveTwilioSmsStatusBodyMessageSidMax),
  "MessageStatus": zod.string().min(receiveTwilioSmsStatusBodyMessageStatusMin).max(receiveTwilioSmsStatusBodyMessageStatusMax),
  "ErrorCode": zod.string().max(receiveTwilioSmsStatusBodyErrorCodeMax).nullish(),
  "ErrorMessage": zod.string().max(receiveTwilioSmsStatusBodyErrorMessageMax).nullish()
})

export const receiveTwilioSmsStatusResponse = zod.void()


export const sendTestSmsBodyToMin = 5;
export const sendTestSmsBodyToMax = 50;

export const sendTestSmsBodyBodyMax = 1600;



export const sendTestSmsBody = zod.object({
  "to": zod.string().min(sendTestSmsBodyToMin).max(sendTestSmsBodyToMax),
  "body": zod.string().min(1).max(sendTestSmsBodyBodyMax)
})

export const sendTestSmsResponseAttemptCountMin = 0;

export const sendTestSmsResponseClicksMin = 0;



export const sendTestSmsResponse = zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['campaign', 'test', 'reply', 'health']),
  "campaignId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "messageId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "contactName": zod.string().nullish(),
  "toNumber": zod.string(),
  "fromNumber": zod.string(),
  "body": zod.string().optional(),
  "providerKey": zod.enum(['twilio', 'simulation']),
  "providerMessageId": zod.string().nullish(),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'sent', 'suppressed', 'failed', 'uncertain', 'cancelled']),
  "reason": zod.string().nullish(),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int().min(sendTestSmsResponseAttemptCountMin),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "clicks": zod.int().min(sendTestSmsResponseClicksMin),
  "registered": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const updateSmsCampaignStepParams = zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid()
})

export const updateSmsCampaignStepBodySmsBodyMax = 1600;

export const updateSmsCampaignStepBodyConfirmOverrideDefault = false;

export const updateSmsCampaignStepBody = zod.object({
  "smsBody": zod.string().min(1).max(updateSmsCampaignStepBodySmsBodyMax),
  "smsConsentMode": zod.enum(['unless_opted_out', 'opted_in_only']),
  "confirmOverride": zod.boolean().default(updateSmsCampaignStepBodyConfirmOverrideDefault).describe('Explicitly confirms a change from opted-in-only to unless-opted-out.')
})

export const updateSmsCampaignStepResponseOneNameMax = 200;

export const updateSmsCampaignStepResponseOneSmsBodyMax = 1600;

export const updateSmsCampaignStepResponseOneSmsConsentModeDefault = `unless_opted_out`;
export const updateSmsCampaignStepResponseOneAutoPostWhenReadyDefault = false;


export const updateSmsCampaignStepResponse = zod.object({
  "type": zod.enum(['email', 'sms', 'social_post', 'whatsapp']),
  "name": zod.string().min(1).max(updateSmsCampaignStepResponseOneNameMax),
  "subject": zod.string().nullish(),
  "body": zod.string().nullish(),
  "smsBody": zod.string().max(updateSmsCampaignStepResponseOneSmsBodyMax).nullish(),
  "smsConsentMode": zod.enum(['unless_opted_out', 'opted_in_only']).default(updateSmsCampaignStepResponseOneSmsConsentModeDefault),
  "networks": zod.array(zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok'])).optional(),
  "videoProjectId": zod.uuid().nullish(),
  "mediaAssetId": zod.uuid().nullish(),
  "autoPostWhenReady": zod.boolean().default(updateSmsCampaignStepResponseOneAutoPostWhenReadyDefault)
}).and(zod.object({
  "id": zod.uuid(),
  "campaignId": zod.uuid(),
  "position": zod.int().min(1),
  "smsOverrideConfirmedBy": zod.string().nullish(),
  "smsOverrideConfirmedAt": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['pending', 'queued', 'partial', 'sent', 'awaiting_approval', 'failed']),
  "networkOutcomes": zod.array(zod.object({
  "network": zod.string(),
  "status": zod.enum(['queued', 'skipped', 'published', 'failed']),
  "reason": zod.string().optional()
})),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


export const previewSmsRecipientsParams = zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid()
})

export const previewSmsRecipientsQueryLimitDefault = 25;
export const previewSmsRecipientsQueryLimitMax = 100;

export const previewSmsRecipientsQueryOffsetDefault = 0;
export const previewSmsRecipientsQueryOffsetMin = 0;



export const previewSmsRecipientsQueryParams = zod.object({
  "limit": zod.int().min(1).max(previewSmsRecipientsQueryLimitMax).default(previewSmsRecipientsQueryLimitDefault),
  "offset": zod.int().min(previewSmsRecipientsQueryOffsetMin).default(previewSmsRecipientsQueryOffsetDefault)
})

export const previewSmsRecipientsResponseTotalMin = 0;

export const previewSmsRecipientsResponseEligibleTotalMin = 0;

export const previewSmsRecipientsResponseSuppressedTotalMin = 0;


export const previewSmsRecipientsResponseOffsetMin = 0;



export const previewSmsRecipientsResponse = zod.object({
  "eligible": zod.array(zod.object({
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "email": zod.email(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "company": zod.string().nullish(),
  "mobile": zod.string().nullish(),
  "normalizedNumber": zod.string().nullish(),
  "eligible": zod.boolean(),
  "suppressionReason": zod.union([zod.enum(['no_mobile', 'do_not_phone', 'opted_out', 'stop_reply', 'suppression_list', 'invalid_number', 'consent_missing']),zod.null()]),
  "reason": zod.string().nullish(),
  "previouslyTextedAt": zod.iso.datetime({"offset":true}).nullish(),
  "previousCampaignId": zod.uuid().nullish(),
  "previousCampaignName": zod.string().nullish()
})),
  "suppressed": zod.array(zod.object({
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "email": zod.email(),
  "firstName": zod.string(),
  "lastName": zod.string(),
  "company": zod.string().nullish(),
  "mobile": zod.string().nullish(),
  "normalizedNumber": zod.string().nullish(),
  "eligible": zod.boolean(),
  "suppressionReason": zod.union([zod.enum(['no_mobile', 'do_not_phone', 'opted_out', 'stop_reply', 'suppression_list', 'invalid_number', 'consent_missing']),zod.null()]),
  "reason": zod.string().nullish(),
  "previouslyTextedAt": zod.iso.datetime({"offset":true}).nullish(),
  "previousCampaignId": zod.uuid().nullish(),
  "previousCampaignName": zod.string().nullish()
})),
  "total": zod.int().min(previewSmsRecipientsResponseTotalMin),
  "eligibleTotal": zod.int().min(previewSmsRecipientsResponseEligibleTotalMin),
  "suppressedTotal": zod.int().min(previewSmsRecipientsResponseSuppressedTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(previewSmsRecipientsResponseOffsetMin)
})


export const sendSmsStepParams = zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid()
})

export const sendSmsStepResponseQueuedMin = 0;

export const sendSmsStepResponseSuppressedMin = 0;

export const sendSmsStepResponseTotalMin = 0;



export const sendSmsStepResponse = zod.object({
  "queued": zod.int().min(sendSmsStepResponseQueuedMin),
  "suppressed": zod.int().min(sendSmsStepResponseSuppressedMin),
  "total": zod.int().min(sendSmsStepResponseTotalMin)
})


export const listSmsDeliveriesParams = zod.object({
  "campaignId": zod.uuid()
})

export const listSmsDeliveriesQueryLimitDefault = 25;
export const listSmsDeliveriesQueryLimitMax = 100;

export const listSmsDeliveriesQueryOffsetDefault = 0;
export const listSmsDeliveriesQueryOffsetMin = 0;



export const listSmsDeliveriesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSmsDeliveriesQueryLimitMax).default(listSmsDeliveriesQueryLimitDefault),
  "offset": zod.int().min(listSmsDeliveriesQueryOffsetMin).default(listSmsDeliveriesQueryOffsetDefault)
})

export const listSmsDeliveriesResponseItemsItemAttemptCountMin = 0;

export const listSmsDeliveriesResponseItemsItemClicksMin = 0;

export const listSmsDeliveriesResponseTotalMin = 0;


export const listSmsDeliveriesResponseOffsetMin = 0;



export const listSmsDeliveriesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['campaign', 'test', 'reply', 'health']),
  "campaignId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "messageId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "contactName": zod.string().nullish(),
  "toNumber": zod.string(),
  "fromNumber": zod.string(),
  "body": zod.string().optional(),
  "providerKey": zod.enum(['twilio', 'simulation']),
  "providerMessageId": zod.string().nullish(),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'sent', 'suppressed', 'failed', 'uncertain', 'cancelled']),
  "reason": zod.string().nullish(),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int().min(listSmsDeliveriesResponseItemsItemAttemptCountMin),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "clicks": zod.int().min(listSmsDeliveriesResponseItemsItemClicksMin),
  "registered": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSmsDeliveriesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listSmsDeliveriesResponseOffsetMin)
})


export const getSmsCampaignSummaryParams = zod.object({
  "campaignId": zod.uuid()
})

export const getSmsCampaignSummaryResponseSentMin = 0;

export const getSmsCampaignSummaryResponseDeliveredMin = 0;

export const getSmsCampaignSummaryResponseFailedMin = 0;

export const getSmsCampaignSummaryResponseSuppressedMin = 0;

export const getSmsCampaignSummaryResponseClickedMin = 0;

export const getSmsCampaignSummaryResponseRegisteredMin = 0;



export const getSmsCampaignSummaryResponse = zod.object({
  "sent": zod.int().min(getSmsCampaignSummaryResponseSentMin),
  "delivered": zod.int().min(getSmsCampaignSummaryResponseDeliveredMin),
  "failed": zod.int().min(getSmsCampaignSummaryResponseFailedMin),
  "suppressed": zod.int().min(getSmsCampaignSummaryResponseSuppressedMin),
  "clicked": zod.int().min(getSmsCampaignSummaryResponseClickedMin),
  "registered": zod.int().min(getSmsCampaignSummaryResponseRegisteredMin)
})


export const retrySmsDeliveryParams = zod.object({
  "id": zod.uuid()
})

export const retrySmsDeliveryResponseAttemptCountMin = 0;

export const retrySmsDeliveryResponseClicksMin = 0;



export const retrySmsDeliveryResponse = zod.object({
  "id": zod.uuid(),
  "kind": zod.enum(['campaign', 'test', 'reply', 'health']),
  "campaignId": zod.uuid().nullish(),
  "campaignStepId": zod.uuid().nullish(),
  "messageId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "contactName": zod.string().nullish(),
  "toNumber": zod.string(),
  "fromNumber": zod.string(),
  "body": zod.string().optional(),
  "providerKey": zod.enum(['twilio', 'simulation']),
  "providerMessageId": zod.string().nullish(),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'sent', 'suppressed', 'failed', 'uncertain', 'cancelled']),
  "reason": zod.string().nullish(),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "attemptCount": zod.int().min(retrySmsDeliveryResponseAttemptCountMin),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "clicks": zod.int().min(retrySmsDeliveryResponseClicksMin),
  "registered": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getContactSmsHistoryParams = zod.object({
  "contactId": zod.uuid()
})

export const getContactSmsHistoryQueryLimitDefault = 20;
export const getContactSmsHistoryQueryLimitMax = 100;

export const getContactSmsHistoryQueryOffsetDefault = 0;
export const getContactSmsHistoryQueryOffsetMin = 0;



export const getContactSmsHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(getContactSmsHistoryQueryLimitMax).default(getContactSmsHistoryQueryLimitDefault),
  "offset": zod.int().min(getContactSmsHistoryQueryOffsetMin).default(getContactSmsHistoryQueryOffsetDefault)
})

export const getContactSmsHistoryResponseItemsItemClicksMin = 0;


export const getContactSmsHistoryResponseTotalMin = 0;


export const getContactSmsHistoryResponseOffsetMin = 0;



export const getContactSmsHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "campaignId": zod.uuid().nullish(),
  "campaignName": zod.string().nullish(),
  "direction": zod.enum(['inbound', 'outbound']),
  "body": zod.string(),
  "status": zod.enum(['queued', 'sent', 'delivered', 'undelivered', 'failed', 'received']),
  "clicks": zod.int().min(getContactSmsHistoryResponseItemsItemClicksMin),
  "segments": zod.int().min(1),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "errorCode": zod.string().nullish(),
  "errorMessage": zod.string().nullish()
})),
  "total": zod.int().min(getContactSmsHistoryResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getContactSmsHistoryResponseOffsetMin)
})


export const listEmailMessagesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "providerKey": zod.string(),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['test', 'sequence', 'campaign', 'review_request', 'reply', 'health_outreach', 'mailbox_intake']),
  "campaignStepId": zod.uuid().nullish(),
  "intakeMailboxId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "nextActionId": zod.uuid().nullish(),
  "parentMessageId": zod.uuid().nullish(),
  "interactionId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "fromAddress": zod.string(),
  "toAddress": zod.string(),
  "subject": zod.string(),
  "body": zod.string(),
  "status": zod.enum(['queued', 'sent', 'delivered', 'failed', 'replied', 'unknown']),
  "trackingToken": zod.uuid(),
  "openCount": zod.int(),
  "clickCount": zod.int(),
  "sentAt": zod.iso.datetime({"offset":true}).nullish(),
  "receivedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}).describe('Campaign steps use campaignStepId; sequence steps retain their existing stepId linkage.'))
})


export const syncEmailRepliesResponse = zod.object({
  "synced": zod.int()
})



export const draftEmailWithAiBodyInvestorUpdateDefault = false;

export const draftEmailWithAiBody = zod.object({
  "objective": zod.string().min(1),
  "contactId": zod.uuid().optional(),
  "accountId": zod.uuid().optional(),
  "tone": zod.string().optional(),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "investorUpdate": zod.boolean().default(draftEmailWithAiBodyInvestorUpdateDefault)
})

export const draftEmailWithAiResponse = zod.object({
  "subject": zod.string(),
  "body": zod.string(),
  "auditId": zod.uuid(),
  "strategicBriefs": zod.array(zod.object({
  "briefId": zod.uuid(),
  "documentId": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "recordName": zod.string(),
  "importance": zod.enum(['strategic', 'key', 'growth', 'standard']),
  "excerpt": zod.string().describe('Short plain-text start of the brief as given to the AI'),
  "truncated": zod.boolean().describe('True when only part of the brief fitted the AI size limit'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deepLink": zod.string().describe('Record page with the Strategic brief tab open')
}).describe('A strategic brief (and importance level) the AI was given as grounding. Only briefs the caller can read are returned.')).describe('Strategic briefs the AI was given for this draft')
})


export const suggestEmailReplyParams = zod.object({
  "id": zod.uuid()
})

export const suggestEmailReplyResponse = zod.object({
  "suggestion": zod.string(),
  "auditId": zod.uuid(),
  "strategicBriefs": zod.array(zod.object({
  "briefId": zod.uuid(),
  "documentId": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "recordName": zod.string(),
  "importance": zod.enum(['strategic', 'key', 'growth', 'standard']),
  "excerpt": zod.string().describe('Short plain-text start of the brief as given to the AI'),
  "truncated": zod.boolean().describe('True when only part of the brief fitted the AI size limit'),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deepLink": zod.string().describe('Record page with the Strategic brief tab open')
}).describe('A strategic brief (and importance level) the AI was given as grounding. Only briefs the caller can read are returned.'))
})


export const listCommunicationExtractionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "messageId": zod.uuid(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "type": zod.enum(['commitment', 'requirement', 'follow_up']),
  "summary": zod.string(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['pending_review', 'approved', 'rejected', 'completed']),
  "aiAuditId": zod.uuid().nullish(),
  "reviewedBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
}))
})


export const reviewCommunicationExtractionParams = zod.object({
  "id": zod.uuid()
})

export const reviewCommunicationExtractionBody = zod.object({
  "status": zod.enum(['approved', 'rejected', 'completed']),
  "reviewedBy": zod.string().optional()
})

export const reviewCommunicationExtractionResponse = zod.object({
  "id": zod.uuid(),
  "messageId": zod.uuid(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "type": zod.enum(['commitment', 'requirement', 'follow_up']),
  "summary": zod.string(),
  "dueAt": zod.iso.datetime({"offset":true}).nullish(),
  "status": zod.enum(['pending_review', 'approved', 'rejected', 'completed']),
  "aiAuditId": zod.uuid().nullish(),
  "reviewedBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})


export const trackEmailOpenParams = zod.object({
  "token": zod.uuid()
})

export const trackEmailOpenResponse = zod.unknown()


/**
 * Redirects only to the http(s) URL recorded in the tracked message body. Unknown tracking tokens and destinations that are not recorded for the token return the same 404 response and never redirect.
 * @summary Record a tracked click and redirect to the recorded destination
 */
export const trackEmailClickParams = zod.object({
  "token": zod.uuid()
})

export const trackEmailClickQueryParams = zod.object({
  "url": zod.url().describe('Original destination carried by the tracked link; must match a URL recorded in the tracked message body')
})

export const trackEmailClickResponse = zod.void()


export const unsubscribeEmailParams = zod.object({
  "token": zod.uuid()
})

export const unsubscribeEmailResponse = zod.unknown()


/**
 * @summary List safe Microsoft 365 intake connection readiness
 */
export const listMailboxIntakeConnectionsQueryLimitDefault = 25;
export const listMailboxIntakeConnectionsQueryLimitMax = 100;

export const listMailboxIntakeConnectionsQueryOffsetDefault = 0;
export const listMailboxIntakeConnectionsQueryOffsetMin = 0;



export const listMailboxIntakeConnectionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listMailboxIntakeConnectionsQueryLimitMax).default(listMailboxIntakeConnectionsQueryLimitDefault),
  "offset": zod.int().min(listMailboxIntakeConnectionsQueryOffsetMin).default(listMailboxIntakeConnectionsQueryOffsetDefault)
})

export const listMailboxIntakeConnectionsResponseItemsItemAllowedMailboxesMax = 50;

export const listMailboxIntakeConnectionsResponseTotalMin = 0;

export const listMailboxIntakeConnectionsResponseLimitMax = 100;

export const listMailboxIntakeConnectionsResponseOffsetMin = 0;



export const listMailboxIntakeConnectionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "provider": zod.enum(['microsoft365']),
  "accessMode": zod.enum(['delegated', 'application']),
  "status": zod.enum(['setup_required', 'ready', 'expired', 'revoked', 'disconnected', 'error']),
  "readiness": zod.object({
  "state": zod.enum(['setup_required', 'ready', 'blocked', 'error']),
  "code": zod.string(),
  "message": zod.string()
}),
  "externalTenantId": zod.string().nullish(),
  "scopedConnectionId": zod.uuid().nullish(),
  "allowedMailboxes": zod.array(zod.email()).max(listMailboxIntakeConnectionsResponseItemsItemAllowedMailboxesMax).optional(),
  "connectionSource": zod.enum(['legacy', 'tenant', 'entity']).optional(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listMailboxIntakeConnectionsResponseTotalMin),
  "limit": zod.int().min(1).max(listMailboxIntakeConnectionsResponseLimitMax),
  "offset": zod.int().min(listMailboxIntakeConnectionsResponseOffsetMin)
})


/**
 * @summary Register the current delegated mailbox identity or the server-owned shared-mailbox application identity
 */
export const createMailboxIntakeConnectionBodyUseScopedConnectionDefault = false;

export const createMailboxIntakeConnectionBody = zod.object({
  "accessMode": zod.enum(['delegated', 'application']),
  "useScopedConnection": zod.boolean().default(createMailboxIntakeConnectionBodyUseScopedConnectionDefault),
  "expectedConnectionId": zod.uuid().optional(),
  "reconnectConnectionId": zod.uuid().optional()
})

export const createMailboxIntakeConnectionResponseAllowedMailboxesMax = 50;



export const createMailboxIntakeConnectionResponse = zod.object({
  "id": zod.uuid(),
  "provider": zod.enum(['microsoft365']),
  "accessMode": zod.enum(['delegated', 'application']),
  "status": zod.enum(['setup_required', 'ready', 'expired', 'revoked', 'disconnected', 'error']),
  "readiness": zod.object({
  "state": zod.enum(['setup_required', 'ready', 'blocked', 'error']),
  "code": zod.string(),
  "message": zod.string()
}),
  "externalTenantId": zod.string().nullish(),
  "scopedConnectionId": zod.uuid().nullish(),
  "allowedMailboxes": zod.array(zod.email()).max(createMailboxIntakeConnectionResponseAllowedMailboxesMax).optional(),
  "connectionSource": zod.enum(['legacy', 'tenant', 'entity']).optional(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Recheck the selected non-secret connection identity and consent
 */
export const verifyMailboxIntakeConnectionParams = zod.object({
  "connectionId": zod.uuid()
})

export const verifyMailboxIntakeConnectionResponseAllowedMailboxesMax = 50;



export const verifyMailboxIntakeConnectionResponse = zod.object({
  "id": zod.uuid(),
  "provider": zod.enum(['microsoft365']),
  "accessMode": zod.enum(['delegated', 'application']),
  "status": zod.enum(['setup_required', 'ready', 'expired', 'revoked', 'disconnected', 'error']),
  "readiness": zod.object({
  "state": zod.enum(['setup_required', 'ready', 'blocked', 'error']),
  "code": zod.string(),
  "message": zod.string()
}),
  "externalTenantId": zod.string().nullish(),
  "scopedConnectionId": zod.uuid().nullish(),
  "allowedMailboxes": zod.array(zod.email()).max(verifyMailboxIntakeConnectionResponseAllowedMailboxesMax).optional(),
  "connectionSource": zod.enum(['legacy', 'tenant', 'entity']).optional(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Stop intake for every mailbox using the selected connection
 */
export const disconnectMailboxIntakeConnectionParams = zod.object({
  "connectionId": zod.uuid()
})

export const disconnectMailboxIntakeConnectionBodyReasonMin = 3;
export const disconnectMailboxIntakeConnectionBodyReasonMax = 500;



export const disconnectMailboxIntakeConnectionBody = zod.object({
  "reason": zod.string().min(disconnectMailboxIntakeConnectionBodyReasonMin).max(disconnectMailboxIntakeConnectionBodyReasonMax)
})

export const disconnectMailboxIntakeConnectionResponseAllowedMailboxesMax = 50;



export const disconnectMailboxIntakeConnectionResponse = zod.object({
  "id": zod.uuid(),
  "provider": zod.enum(['microsoft365']),
  "accessMode": zod.enum(['delegated', 'application']),
  "status": zod.enum(['setup_required', 'ready', 'expired', 'revoked', 'disconnected', 'error']),
  "readiness": zod.object({
  "state": zod.enum(['setup_required', 'ready', 'blocked', 'error']),
  "code": zod.string(),
  "message": zod.string()
}),
  "externalTenantId": zod.string().nullish(),
  "scopedConnectionId": zod.uuid().nullish(),
  "allowedMailboxes": zod.array(zod.email()).max(disconnectMailboxIntakeConnectionResponseAllowedMailboxesMax).optional(),
  "connectionSource": zod.enum(['legacy', 'tenant', 'entity']).optional(),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Validate Microsoft Graph endpoint challenges and queue authenticated subscription hints
 */
export const receiveMailboxGraphNotificationsQueryValidationTokenMax = 4096;



export const receiveMailboxGraphNotificationsQueryParams = zod.object({
  "validationToken": zod.string().min(1).max(receiveMailboxGraphNotificationsQueryValidationTokenMax).optional()
})

export const receiveMailboxGraphNotificationsBodyValueItemSubscriptionIdMax = 500;

export const receiveMailboxGraphNotificationsBodyValueItemClientStateMax = 500;

export const receiveMailboxGraphNotificationsBodyValueItemResourceMax = 2000;

export const receiveMailboxGraphNotificationsBodyValueItemResourceDataIdMax = 1000;

export const receiveMailboxGraphNotificationsBodyValueMax = 100;



export const receiveMailboxGraphNotificationsBody = zod.object({
  "value": zod.array(zod.object({
  "subscriptionId": zod.string().min(1).max(receiveMailboxGraphNotificationsBodyValueItemSubscriptionIdMax),
  "clientState": zod.string().min(1).max(receiveMailboxGraphNotificationsBodyValueItemClientStateMax),
  "changeType": zod.enum(['created', 'updated', 'deleted']).nullish(),
  "lifecycleEvent": zod.enum(['missed', 'subscriptionRemoved', 'reauthorizationRequired']).nullish(),
  "resource": zod.string().max(receiveMailboxGraphNotificationsBodyValueItemResourceMax).nullish(),
  "subscriptionExpirationDateTime": zod.iso.datetime({"offset":true}).nullish(),
  "resourceData": zod.object({
  "id": zod.string().max(receiveMailboxGraphNotificationsBodyValueItemResourceDataIdMax).optional()
}).nullish()
})).min(1).max(receiveMailboxGraphNotificationsBodyValueMax)
})

export const receiveMailboxGraphNotificationsResponse = zod.string()


/**
 * @summary List configured inbound mailboxes and truthful readiness
 */
export const listMailboxIntakeMailboxesQueryLimitDefault = 25;
export const listMailboxIntakeMailboxesQueryLimitMax = 100;

export const listMailboxIntakeMailboxesQueryOffsetDefault = 0;
export const listMailboxIntakeMailboxesQueryOffsetMin = 0;



export const listMailboxIntakeMailboxesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listMailboxIntakeMailboxesQueryLimitMax).default(listMailboxIntakeMailboxesQueryLimitDefault),
  "offset": zod.int().min(listMailboxIntakeMailboxesQueryOffsetMin).default(listMailboxIntakeMailboxesQueryOffsetDefault),
  "status": zod.enum(['inactive', 'ready', 'active', 'paused', 'setup_required', 'disconnected', 'error']).optional()
})

export const listMailboxIntakeMailboxesResponseTotalMin = 0;

export const listMailboxIntakeMailboxesResponseLimitMax = 100;

export const listMailboxIntakeMailboxesResponseOffsetMin = 0;



export const listMailboxIntakeMailboxesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "connectionId": zod.uuid(),
  "provider": zod.enum(['microsoft365']),
  "mailboxType": zod.enum(['individual', 'shared']),
  "mailboxAddress": zod.email(),
  "displayName": zod.string().nullish(),
  "status": zod.enum(['inactive', 'ready', 'active', 'paused', 'setup_required', 'disconnected', 'error']),
  "readiness": zod.object({
  "state": zod.enum(['setup_required', 'ready', 'blocked', 'error']),
  "code": zod.string(),
  "message": zod.string()
}),
  "monitoringEnabled": zod.boolean(),
  "automaticRoutingEnabled": zod.boolean(),
  "activationWatermarkAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastSuccessfulSyncAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "folders": zod.array(zod.object({
  "id": zod.uuid(),
  "providerFolderId": zod.string(),
  "displayName": zod.string(),
  "enabled": zod.boolean(),
  "lastSuccessfulSyncAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish()
})),
  "subscriptions": zod.array(zod.object({
  "id": zod.uuid(),
  "folderId": zod.uuid(),
  "status": zod.enum(['active', 'renewal_due', 'reauthorization_required', 'removed', 'expired', 'disconnected', 'error']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "lastNotificationAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listMailboxIntakeMailboxesResponseTotalMin),
  "limit": zod.int().min(1).max(listMailboxIntakeMailboxesResponseLimitMax),
  "offset": zod.int().min(listMailboxIntakeMailboxesResponseOffsetMin)
})


/**
 * @summary Add an inactive individual or shared mailbox configuration
 */
export const createMailboxIntakeMailboxBodyDisplayNameMax = 200;

export const createMailboxIntakeMailboxBodyFolderIdsItemMax = 500;

export const createMailboxIntakeMailboxBodyFolderIdsMax = 20;



export const createMailboxIntakeMailboxBody = zod.object({
  "connectionId": zod.uuid(),
  "mailboxType": zod.enum(['individual', 'shared']),
  "mailboxAddress": zod.email(),
  "displayName": zod.string().max(createMailboxIntakeMailboxBodyDisplayNameMax).nullish(),
  "folderIds": zod.array(zod.string().min(1).max(createMailboxIntakeMailboxBodyFolderIdsItemMax)).min(1).max(createMailboxIntakeMailboxBodyFolderIdsMax)
})

export const createMailboxIntakeMailboxResponse = zod.object({
  "id": zod.uuid(),
  "connectionId": zod.uuid(),
  "provider": zod.enum(['microsoft365']),
  "mailboxType": zod.enum(['individual', 'shared']),
  "mailboxAddress": zod.email(),
  "displayName": zod.string().nullish(),
  "status": zod.enum(['inactive', 'ready', 'active', 'paused', 'setup_required', 'disconnected', 'error']),
  "readiness": zod.object({
  "state": zod.enum(['setup_required', 'ready', 'blocked', 'error']),
  "code": zod.string(),
  "message": zod.string()
}),
  "monitoringEnabled": zod.boolean(),
  "automaticRoutingEnabled": zod.boolean(),
  "activationWatermarkAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastSuccessfulSyncAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "folders": zod.array(zod.object({
  "id": zod.uuid(),
  "providerFolderId": zod.string(),
  "displayName": zod.string(),
  "enabled": zod.boolean(),
  "lastSuccessfulSyncAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish()
})),
  "subscriptions": zod.array(zod.object({
  "id": zod.uuid(),
  "folderId": zod.uuid(),
  "status": zod.enum(['active', 'renewal_due', 'reauthorization_required', 'removed', 'expired', 'disconnected', 'error']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "lastNotificationAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getMailboxIntakeMailboxParams = zod.object({
  "mailboxId": zod.uuid()
})

export const getMailboxIntakeMailboxResponse = zod.object({
  "id": zod.uuid(),
  "connectionId": zod.uuid(),
  "provider": zod.enum(['microsoft365']),
  "mailboxType": zod.enum(['individual', 'shared']),
  "mailboxAddress": zod.email(),
  "displayName": zod.string().nullish(),
  "status": zod.enum(['inactive', 'ready', 'active', 'paused', 'setup_required', 'disconnected', 'error']),
  "readiness": zod.object({
  "state": zod.enum(['setup_required', 'ready', 'blocked', 'error']),
  "code": zod.string(),
  "message": zod.string()
}),
  "monitoringEnabled": zod.boolean(),
  "automaticRoutingEnabled": zod.boolean(),
  "activationWatermarkAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastSuccessfulSyncAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "folders": zod.array(zod.object({
  "id": zod.uuid(),
  "providerFolderId": zod.string(),
  "displayName": zod.string(),
  "enabled": zod.boolean(),
  "lastSuccessfulSyncAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish()
})),
  "subscriptions": zod.array(zod.object({
  "id": zod.uuid(),
  "folderId": zod.uuid(),
  "status": zod.enum(['active', 'renewal_due', 'reauthorization_required', 'removed', 'expired', 'disconnected', 'error']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "lastNotificationAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const updateMailboxIntakeMailboxParams = zod.object({
  "mailboxId": zod.uuid()
})

export const updateMailboxIntakeMailboxBodyDisplayNameMax = 200;

export const updateMailboxIntakeMailboxBodyFolderIdsItemMax = 500;

export const updateMailboxIntakeMailboxBodyFolderIdsMax = 20;

export const updateMailboxIntakeMailboxBodyReasonMin = 3;
export const updateMailboxIntakeMailboxBodyReasonMax = 500;



export const updateMailboxIntakeMailboxBody = zod.object({
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "displayName": zod.string().max(updateMailboxIntakeMailboxBodyDisplayNameMax).nullish(),
  "folderIds": zod.array(zod.string().min(1).max(updateMailboxIntakeMailboxBodyFolderIdsItemMax)).min(1).max(updateMailboxIntakeMailboxBodyFolderIdsMax).optional(),
  "action": zod.enum(['verify', 'activate', 'pause', 'resume', 'disconnect']).optional(),
  "automaticRoutingEnabled": zod.boolean().optional(),
  "reason": zod.string().min(updateMailboxIntakeMailboxBodyReasonMin).max(updateMailboxIntakeMailboxBodyReasonMax).optional()
})

export const updateMailboxIntakeMailboxResponse = zod.object({
  "id": zod.uuid(),
  "connectionId": zod.uuid(),
  "provider": zod.enum(['microsoft365']),
  "mailboxType": zod.enum(['individual', 'shared']),
  "mailboxAddress": zod.email(),
  "displayName": zod.string().nullish(),
  "status": zod.enum(['inactive', 'ready', 'active', 'paused', 'setup_required', 'disconnected', 'error']),
  "readiness": zod.object({
  "state": zod.enum(['setup_required', 'ready', 'blocked', 'error']),
  "code": zod.string(),
  "message": zod.string()
}),
  "monitoringEnabled": zod.boolean(),
  "automaticRoutingEnabled": zod.boolean(),
  "activationWatermarkAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastSuccessfulSyncAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "folders": zod.array(zod.object({
  "id": zod.uuid(),
  "providerFolderId": zod.string(),
  "displayName": zod.string(),
  "enabled": zod.boolean(),
  "lastSuccessfulSyncAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish()
})),
  "subscriptions": zod.array(zod.object({
  "id": zod.uuid(),
  "folderId": zod.uuid(),
  "status": zod.enum(['active', 'renewal_due', 'reauthorization_required', 'removed', 'expired', 'disconnected', 'error']),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "lastNotificationAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Download one private source attachment in the active entity
 */
export const downloadMailboxAttachmentParams = zod.object({
  "attachmentId": zod.uuid()
})

export const downloadMailboxAttachmentResponse = zod.unknown()


export const listMailboxRoutingPromptRevisionsParams = zod.object({
  "mailboxId": zod.uuid()
})

export const listMailboxRoutingPromptRevisionsQueryLimitDefault = 25;
export const listMailboxRoutingPromptRevisionsQueryLimitMax = 100;

export const listMailboxRoutingPromptRevisionsQueryOffsetDefault = 0;
export const listMailboxRoutingPromptRevisionsQueryOffsetMin = 0;



export const listMailboxRoutingPromptRevisionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listMailboxRoutingPromptRevisionsQueryLimitMax).default(listMailboxRoutingPromptRevisionsQueryLimitDefault),
  "offset": zod.int().min(listMailboxRoutingPromptRevisionsQueryOffsetMin).default(listMailboxRoutingPromptRevisionsQueryOffsetDefault)
})

export const listMailboxRoutingPromptRevisionsResponseItemsItemOnePromptMax = 20000;

export const listMailboxRoutingPromptRevisionsResponseItemsItemOneNoteMax = 1000;

export const listMailboxRoutingPromptRevisionsResponseItemsItemOneTargetOwnerIdMax = 200;

export const listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersFolderIdsItemMax = 500;

export const listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersFolderIdsMax = 20;

export const listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersAllowedSenderDomainsItemMax = 255;

export const listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersAllowedSenderDomainsMax = 100;

export const listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersBlockedSenderDomainsItemMax = 255;

export const listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersBlockedSenderDomainsMax = 100;


export const listMailboxRoutingPromptRevisionsResponseTotalMin = 0;

export const listMailboxRoutingPromptRevisionsResponseLimitMax = 100;

export const listMailboxRoutingPromptRevisionsResponseOffsetMin = 0;



export const listMailboxRoutingPromptRevisionsResponse = zod.object({
  "items": zod.array(zod.object({
  "prompt": zod.string().min(1).max(listMailboxRoutingPromptRevisionsResponseItemsItemOnePromptMax),
  "note": zod.string().min(1).max(listMailboxRoutingPromptRevisionsResponseItemsItemOneNoteMax),
  "target": zod.object({
  "kind": zod.enum(['lead', 'pipeline']),
  "pipeline": zod.union([zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),zod.null()]).optional(),
  "stage": zod.string().nullish(),
  "ownerId": zod.string().min(1).max(listMailboxRoutingPromptRevisionsResponseItemsItemOneTargetOwnerIdMax)
}),
  "filters": zod.object({
  "folderIds": zod.array(zod.string().min(1).max(listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersFolderIdsItemMax)).max(listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersFolderIdsMax),
  "allowedSenderDomains": zod.array(zod.string().min(1).max(listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersAllowedSenderDomainsItemMax)).max(listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersAllowedSenderDomainsMax),
  "blockedSenderDomains": zod.array(zod.string().min(1).max(listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersBlockedSenderDomainsItemMax)).max(listMailboxRoutingPromptRevisionsResponseItemsItemOneFiltersBlockedSenderDomainsMax)
})
}).and(zod.object({
  "id": zod.uuid(),
  "configurationId": zod.uuid(),
  "version": zod.int().min(1),
  "status": zod.enum(['draft', 'active', 'retired']),
  "configurationUpdatedAt": zod.iso.datetime({"offset":true}),
  "aiAuditId": zod.uuid().nullish(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish()
}))),
  "total": zod.int().min(listMailboxRoutingPromptRevisionsResponseTotalMin),
  "limit": zod.int().min(1).max(listMailboxRoutingPromptRevisionsResponseLimitMax),
  "offset": zod.int().min(listMailboxRoutingPromptRevisionsResponseOffsetMin)
})


export const createMailboxRoutingPromptRevisionParams = zod.object({
  "mailboxId": zod.uuid()
})

export const createMailboxRoutingPromptRevisionBodyPromptMax = 20000;

export const createMailboxRoutingPromptRevisionBodyNoteMax = 1000;

export const createMailboxRoutingPromptRevisionBodyTargetOwnerIdMax = 200;

export const createMailboxRoutingPromptRevisionBodyFiltersFolderIdsItemMax = 500;

export const createMailboxRoutingPromptRevisionBodyFiltersFolderIdsMax = 20;

export const createMailboxRoutingPromptRevisionBodyFiltersAllowedSenderDomainsItemMax = 255;

export const createMailboxRoutingPromptRevisionBodyFiltersAllowedSenderDomainsMax = 100;

export const createMailboxRoutingPromptRevisionBodyFiltersBlockedSenderDomainsItemMax = 255;

export const createMailboxRoutingPromptRevisionBodyFiltersBlockedSenderDomainsMax = 100;



export const createMailboxRoutingPromptRevisionBody = zod.object({
  "prompt": zod.string().min(1).max(createMailboxRoutingPromptRevisionBodyPromptMax),
  "note": zod.string().min(1).max(createMailboxRoutingPromptRevisionBodyNoteMax),
  "target": zod.object({
  "kind": zod.enum(['lead', 'pipeline']),
  "pipeline": zod.union([zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),zod.null()]).optional(),
  "stage": zod.string().nullish(),
  "ownerId": zod.string().min(1).max(createMailboxRoutingPromptRevisionBodyTargetOwnerIdMax)
}),
  "filters": zod.object({
  "folderIds": zod.array(zod.string().min(1).max(createMailboxRoutingPromptRevisionBodyFiltersFolderIdsItemMax)).max(createMailboxRoutingPromptRevisionBodyFiltersFolderIdsMax),
  "allowedSenderDomains": zod.array(zod.string().min(1).max(createMailboxRoutingPromptRevisionBodyFiltersAllowedSenderDomainsItemMax)).max(createMailboxRoutingPromptRevisionBodyFiltersAllowedSenderDomainsMax),
  "blockedSenderDomains": zod.array(zod.string().min(1).max(createMailboxRoutingPromptRevisionBodyFiltersBlockedSenderDomainsItemMax)).max(createMailboxRoutingPromptRevisionBodyFiltersBlockedSenderDomainsMax)
})
})

export const createMailboxRoutingPromptRevisionResponseOnePromptMax = 20000;

export const createMailboxRoutingPromptRevisionResponseOneNoteMax = 1000;

export const createMailboxRoutingPromptRevisionResponseOneTargetOwnerIdMax = 200;

export const createMailboxRoutingPromptRevisionResponseOneFiltersFolderIdsItemMax = 500;

export const createMailboxRoutingPromptRevisionResponseOneFiltersFolderIdsMax = 20;

export const createMailboxRoutingPromptRevisionResponseOneFiltersAllowedSenderDomainsItemMax = 255;

export const createMailboxRoutingPromptRevisionResponseOneFiltersAllowedSenderDomainsMax = 100;

export const createMailboxRoutingPromptRevisionResponseOneFiltersBlockedSenderDomainsItemMax = 255;

export const createMailboxRoutingPromptRevisionResponseOneFiltersBlockedSenderDomainsMax = 100;




export const createMailboxRoutingPromptRevisionResponse = zod.object({
  "prompt": zod.string().min(1).max(createMailboxRoutingPromptRevisionResponseOnePromptMax),
  "note": zod.string().min(1).max(createMailboxRoutingPromptRevisionResponseOneNoteMax),
  "target": zod.object({
  "kind": zod.enum(['lead', 'pipeline']),
  "pipeline": zod.union([zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),zod.null()]).optional(),
  "stage": zod.string().nullish(),
  "ownerId": zod.string().min(1).max(createMailboxRoutingPromptRevisionResponseOneTargetOwnerIdMax)
}),
  "filters": zod.object({
  "folderIds": zod.array(zod.string().min(1).max(createMailboxRoutingPromptRevisionResponseOneFiltersFolderIdsItemMax)).max(createMailboxRoutingPromptRevisionResponseOneFiltersFolderIdsMax),
  "allowedSenderDomains": zod.array(zod.string().min(1).max(createMailboxRoutingPromptRevisionResponseOneFiltersAllowedSenderDomainsItemMax)).max(createMailboxRoutingPromptRevisionResponseOneFiltersAllowedSenderDomainsMax),
  "blockedSenderDomains": zod.array(zod.string().min(1).max(createMailboxRoutingPromptRevisionResponseOneFiltersBlockedSenderDomainsItemMax)).max(createMailboxRoutingPromptRevisionResponseOneFiltersBlockedSenderDomainsMax)
})
}).and(zod.object({
  "id": zod.uuid(),
  "configurationId": zod.uuid(),
  "version": zod.int().min(1),
  "status": zod.enum(['draft', 'active', 'retired']),
  "configurationUpdatedAt": zod.iso.datetime({"offset":true}),
  "aiAuditId": zod.uuid().nullish(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish()
}))


export const testMailboxRoutingPromptRevisionParams = zod.object({
  "mailboxId": zod.uuid(),
  "revisionId": zod.uuid()
})

export const testMailboxRoutingPromptRevisionBodyIncludeAttachmentsDefault = true;

export const testMailboxRoutingPromptRevisionBody = zod.object({
  "messageId": zod.uuid(),
  "includeAttachments": zod.boolean().default(testMailboxRoutingPromptRevisionBodyIncludeAttachmentsDefault)
})

export const testMailboxRoutingPromptRevisionResponseEvidenceItemExcerptMax = 1000;

export const testMailboxRoutingPromptRevisionResponseProposedTargetOneOwnerIdMax = 200;

export const testMailboxRoutingPromptRevisionResponseSourceContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const testMailboxRoutingPromptRevisionResponseAttachmentEvidenceHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const testMailboxRoutingPromptRevisionResponse = zod.object({
  "id": zod.uuid(),
  "configurationId": zod.uuid(),
  "promptRevisionId": zod.uuid(),
  "sourceId": zod.uuid(),
  "classification": zod.enum(['irrelevant', 'linked_reply', 'new_lead_request', 'pipeline_request', 'needs_review']),
  "reason": zod.string(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['message', 'attachment']),
  "id": zod.uuid(),
  "excerpt": zod.string().max(testMailboxRoutingPromptRevisionResponseEvidenceItemExcerptMax).nullish()
})),
  "missingEvidence": zod.array(zod.string()),
  "extractedFields": zod.object({
  "organisationName": zod.string().optional(),
  "contactName": zod.string().optional(),
  "contactEmail": zod.email().optional(),
  "requestSummary": zod.string().optional()
}),
  "proposedTarget": zod.union([zod.object({
  "kind": zod.enum(['lead', 'pipeline']),
  "pipeline": zod.union([zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),zod.null()]).optional(),
  "stage": zod.string().nullish(),
  "ownerId": zod.string().min(1).max(testMailboxRoutingPromptRevisionResponseProposedTargetOneOwnerIdMax)
}),zod.null()]),
  "sourceContentHash": zod.string().regex(testMailboxRoutingPromptRevisionResponseSourceContentHashRegExp),
  "attachmentEvidenceHash": zod.string().regex(testMailboxRoutingPromptRevisionResponseAttachmentEvidenceHashRegExp).nullable(),
  "model": zod.string().nullable(),
  "writesPerformed": zod.literal(false),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true})
})


export const activateMailboxRoutingPromptRevisionParams = zod.object({
  "mailboxId": zod.uuid(),
  "revisionId": zod.uuid()
})

export const activateMailboxRoutingPromptRevisionBodyReasonMin = 3;
export const activateMailboxRoutingPromptRevisionBodyReasonMax = 500;



export const activateMailboxRoutingPromptRevisionBody = zod.object({
  "expectedConfigurationUpdatedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(activateMailboxRoutingPromptRevisionBodyReasonMin).max(activateMailboxRoutingPromptRevisionBodyReasonMax)
})

export const activateMailboxRoutingPromptRevisionResponseOnePromptMax = 20000;

export const activateMailboxRoutingPromptRevisionResponseOneNoteMax = 1000;

export const activateMailboxRoutingPromptRevisionResponseOneTargetOwnerIdMax = 200;

export const activateMailboxRoutingPromptRevisionResponseOneFiltersFolderIdsItemMax = 500;

export const activateMailboxRoutingPromptRevisionResponseOneFiltersFolderIdsMax = 20;

export const activateMailboxRoutingPromptRevisionResponseOneFiltersAllowedSenderDomainsItemMax = 255;

export const activateMailboxRoutingPromptRevisionResponseOneFiltersAllowedSenderDomainsMax = 100;

export const activateMailboxRoutingPromptRevisionResponseOneFiltersBlockedSenderDomainsItemMax = 255;

export const activateMailboxRoutingPromptRevisionResponseOneFiltersBlockedSenderDomainsMax = 100;




export const activateMailboxRoutingPromptRevisionResponse = zod.object({
  "prompt": zod.string().min(1).max(activateMailboxRoutingPromptRevisionResponseOnePromptMax),
  "note": zod.string().min(1).max(activateMailboxRoutingPromptRevisionResponseOneNoteMax),
  "target": zod.object({
  "kind": zod.enum(['lead', 'pipeline']),
  "pipeline": zod.union([zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']),zod.null()]).optional(),
  "stage": zod.string().nullish(),
  "ownerId": zod.string().min(1).max(activateMailboxRoutingPromptRevisionResponseOneTargetOwnerIdMax)
}),
  "filters": zod.object({
  "folderIds": zod.array(zod.string().min(1).max(activateMailboxRoutingPromptRevisionResponseOneFiltersFolderIdsItemMax)).max(activateMailboxRoutingPromptRevisionResponseOneFiltersFolderIdsMax),
  "allowedSenderDomains": zod.array(zod.string().min(1).max(activateMailboxRoutingPromptRevisionResponseOneFiltersAllowedSenderDomainsItemMax)).max(activateMailboxRoutingPromptRevisionResponseOneFiltersAllowedSenderDomainsMax),
  "blockedSenderDomains": zod.array(zod.string().min(1).max(activateMailboxRoutingPromptRevisionResponseOneFiltersBlockedSenderDomainsItemMax)).max(activateMailboxRoutingPromptRevisionResponseOneFiltersBlockedSenderDomainsMax)
})
}).and(zod.object({
  "id": zod.uuid(),
  "configurationId": zod.uuid(),
  "version": zod.int().min(1),
  "status": zod.enum(['draft', 'active', 'retired']),
  "configurationUpdatedAt": zod.iso.datetime({"offset":true}),
  "aiAuditId": zod.uuid().nullish(),
  "createdBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish()
}))


export const pauseMailboxRoutingPromptParams = zod.object({
  "mailboxId": zod.uuid()
})

export const pauseMailboxRoutingPromptBodyReasonMin = 3;
export const pauseMailboxRoutingPromptBodyReasonMax = 500;



export const pauseMailboxRoutingPromptBody = zod.object({
  "expectedConfigurationUpdatedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(pauseMailboxRoutingPromptBodyReasonMin).max(pauseMailboxRoutingPromptBodyReasonMax)
})




export const pauseMailboxRoutingPromptResponse = zod.object({
  "configurationId": zod.uuid(),
  "mailboxId": zod.uuid(),
  "status": zod.enum(['draft', 'active', 'paused']),
  "activeRevision": zod.int().min(1).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listMailboxRoutingCandidatesQueryLimitDefault = 25;
export const listMailboxRoutingCandidatesQueryLimitMax = 100;

export const listMailboxRoutingCandidatesQueryOffsetDefault = 0;
export const listMailboxRoutingCandidatesQueryOffsetMin = 0;



export const listMailboxRoutingCandidatesQueryParams = zod.object({
  "mailboxId": zod.uuid().optional(),
  "status": zod.enum(['pending_review', 'eligible_automatic', 'approved', 'dismissed', 'executed', 'stale', 'failed']).optional(),
  "limit": zod.int().min(1).max(listMailboxRoutingCandidatesQueryLimitMax).default(listMailboxRoutingCandidatesQueryLimitDefault),
  "offset": zod.int().min(listMailboxRoutingCandidatesQueryOffsetMin).default(listMailboxRoutingCandidatesQueryOffsetDefault)
})

export const listMailboxRoutingCandidatesResponseItemsItemEmailBodyExcerptMax = 4000;

export const listMailboxRoutingCandidatesResponseItemsItemEvidenceItemExcerptMax = 1000;

export const listMailboxRoutingCandidatesResponseItemsItemAttachmentsItemSizeBytesMin = 0;

export const listMailboxRoutingCandidatesResponseTotalMin = 0;

export const listMailboxRoutingCandidatesResponseLimitMax = 100;

export const listMailboxRoutingCandidatesResponseOffsetMin = 0;



export const listMailboxRoutingCandidatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "mailboxId": zod.uuid(),
  "sourceId": zod.uuid(),
  "messageId": zod.uuid(),
  "email": zod.object({
  "subject": zod.string(),
  "fromAddress": zod.string(),
  "toAddress": zod.string(),
  "bodyExcerpt": zod.string().max(listMailboxRoutingCandidatesResponseItemsItemEmailBodyExcerptMax),
  "receivedAt": zod.iso.datetime({"offset":true}),
  "outlookWebUrl": zod.url().nullable()
}),
  "promptRevisionId": zod.uuid().nullish(),
  "classification": zod.enum(['irrelevant', 'linked_reply', 'new_lead_request', 'pipeline_request', 'needs_review']),
  "status": zod.enum(['pending_review', 'eligible_automatic', 'approved', 'dismissed', 'executed', 'stale', 'failed']),
  "knownContactNewNeed": zod.boolean(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "linkedMessageId": zod.uuid().nullish(),
  "reason": zod.string(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['message', 'attachment']),
  "id": zod.uuid(),
  "excerpt": zod.string().max(listMailboxRoutingCandidatesResponseItemsItemEvidenceItemExcerptMax).nullish()
})),
  "missingEvidence": zod.array(zod.string()),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid().nullish(),
  "attachmentType": zod.enum(['file', 'item', 'reference']),
  "isInline": zod.boolean(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(listMailboxRoutingCandidatesResponseItemsItemAttachmentsItemSizeBytesMin),
  "contentHash": zod.string().nullish(),
  "storageStatus": zod.enum(['pending', 'ready', 'failed', 'unavailable']),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'encrypted', 'oversized', 'failed', 'unavailable']),
  "extractionErrorCode": zod.string().nullish(),
  "requiredEvidence": zod.boolean(),
  "contentUrl": zod.string().nullable()
})),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listMailboxRoutingCandidatesResponseTotalMin),
  "limit": zod.int().min(1).max(listMailboxRoutingCandidatesResponseLimitMax),
  "offset": zod.int().min(listMailboxRoutingCandidatesResponseOffsetMin)
})


export const getMailboxRoutingCandidateParams = zod.object({
  "candidateId": zod.uuid()
})

export const getMailboxRoutingCandidateResponseEmailBodyExcerptMax = 4000;

export const getMailboxRoutingCandidateResponseEvidenceItemExcerptMax = 1000;

export const getMailboxRoutingCandidateResponseAttachmentsItemSizeBytesMin = 0;



export const getMailboxRoutingCandidateResponse = zod.object({
  "id": zod.uuid(),
  "mailboxId": zod.uuid(),
  "sourceId": zod.uuid(),
  "messageId": zod.uuid(),
  "email": zod.object({
  "subject": zod.string(),
  "fromAddress": zod.string(),
  "toAddress": zod.string(),
  "bodyExcerpt": zod.string().max(getMailboxRoutingCandidateResponseEmailBodyExcerptMax),
  "receivedAt": zod.iso.datetime({"offset":true}),
  "outlookWebUrl": zod.url().nullable()
}),
  "promptRevisionId": zod.uuid().nullish(),
  "classification": zod.enum(['irrelevant', 'linked_reply', 'new_lead_request', 'pipeline_request', 'needs_review']),
  "status": zod.enum(['pending_review', 'eligible_automatic', 'approved', 'dismissed', 'executed', 'stale', 'failed']),
  "knownContactNewNeed": zod.boolean(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "linkedMessageId": zod.uuid().nullish(),
  "reason": zod.string(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['message', 'attachment']),
  "id": zod.uuid(),
  "excerpt": zod.string().max(getMailboxRoutingCandidateResponseEvidenceItemExcerptMax).nullish()
})),
  "missingEvidence": zod.array(zod.string()),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid().nullish(),
  "attachmentType": zod.enum(['file', 'item', 'reference']),
  "isInline": zod.boolean(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(getMailboxRoutingCandidateResponseAttachmentsItemSizeBytesMin),
  "contentHash": zod.string().nullish(),
  "storageStatus": zod.enum(['pending', 'ready', 'failed', 'unavailable']),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'encrypted', 'oversized', 'failed', 'unavailable']),
  "extractionErrorCode": zod.string().nullish(),
  "requiredEvidence": zod.boolean(),
  "contentUrl": zod.string().nullable()
})),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const decideMailboxRoutingCandidateParams = zod.object({
  "candidateId": zod.uuid()
})

export const decideMailboxRoutingCandidateBodyReasonMin = 3;
export const decideMailboxRoutingCandidateBodyReasonMax = 1000;



export const decideMailboxRoutingCandidateBody = zod.object({
  "action": zod.enum(['approve', 'correct', 'link', 'dismiss', 'retry']),
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(decideMailboxRoutingCandidateBodyReasonMin).max(decideMailboxRoutingCandidateBodyReasonMax),
  "classification": zod.union([zod.enum(['irrelevant', 'linked_reply', 'new_lead_request', 'pipeline_request', 'needs_review']),zod.null()]).optional(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "linkedMessageId": zod.uuid().nullish()
})

export const decideMailboxRoutingCandidateResponseAttemptCountMin = 0;



export const decideMailboxRoutingCandidateResponse = zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "status": zod.enum(['queued', 'claimed', 'executed', 'dismissed', 'failed', 'stale', 'cancelled']),
  "targetKind": zod.enum(['lead', 'pipeline', 'link_only', 'none']),
  "promptRevisionId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "interactionId": zod.uuid().nullish(),
  "aiAuditId": zod.uuid().nullish(),
  "actorType": zod.enum(['automation', 'staff']),
  "actorId": zod.string(),
  "reason": zod.string(),
  "attemptCount": zod.int().min(decideMailboxRoutingCandidateResponseAttemptCountMin),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "executedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Queue a historical preview that performs no CRM writes
 */
export const createMailboxHistoryPreviewBodyFolderIdsMax = 20;



export const createMailboxHistoryPreviewBody = zod.object({
  "mailboxId": zod.uuid(),
  "folderIds": zod.array(zod.uuid()).min(1).max(createMailboxHistoryPreviewBodyFolderIdsMax),
  "receivedFrom": zod.iso.datetime({"offset":true}),
  "receivedTo": zod.iso.datetime({"offset":true}),
  "promptRevisionId": zod.uuid()
})


export const createMailboxHistoryPreviewResponseTotalItemsMin = 0;

export const createMailboxHistoryPreviewResponseProcessedItemsMin = 0;

export const createMailboxHistoryPreviewResponseCreatedItemsMin = 0;

export const createMailboxHistoryPreviewResponseReviewItemsMin = 0;

export const createMailboxHistoryPreviewResponseDuplicateItemsMin = 0;

export const createMailboxHistoryPreviewResponseFailedItemsMin = 0;

export const createMailboxHistoryPreviewResponseAttemptCountMin = 0;



export const createMailboxHistoryPreviewResponse = zod.object({
  "id": zod.uuid(),
  "mailboxId": zod.uuid(),
  "kind": zod.enum(['sync', 'analysis', 'lookback_preview', 'lookback_import', 'subscription_renewal']),
  "status": zod.enum(['queued', 'running', 'paused', 'retry', 'completed', 'failed', 'cancelled', 'stale']),
  "promptConfigurationId": zod.uuid().nullish(),
  "promptRevision": zod.int().min(1).nullish(),
  "totalItems": zod.int().min(createMailboxHistoryPreviewResponseTotalItemsMin),
  "processedItems": zod.int().min(createMailboxHistoryPreviewResponseProcessedItemsMin),
  "createdItems": zod.int().min(createMailboxHistoryPreviewResponseCreatedItemsMin),
  "reviewItems": zod.int().min(createMailboxHistoryPreviewResponseReviewItemsMin),
  "duplicateItems": zod.int().min(createMailboxHistoryPreviewResponseDuplicateItemsMin),
  "failedItems": zod.int().min(createMailboxHistoryPreviewResponseFailedItemsMin),
  "attemptCount": zod.int().min(createMailboxHistoryPreviewResponseAttemptCountMin),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getMailboxHistoryPreviewParams = zod.object({
  "previewJobId": zod.uuid()
})

export const getMailboxHistoryPreviewQueryLimitDefault = 25;
export const getMailboxHistoryPreviewQueryLimitMax = 100;

export const getMailboxHistoryPreviewQueryOffsetDefault = 0;
export const getMailboxHistoryPreviewQueryOffsetMin = 0;



export const getMailboxHistoryPreviewQueryParams = zod.object({
  "limit": zod.int().min(1).max(getMailboxHistoryPreviewQueryLimitMax).default(getMailboxHistoryPreviewQueryLimitDefault),
  "offset": zod.int().min(getMailboxHistoryPreviewQueryOffsetMin).default(getMailboxHistoryPreviewQueryOffsetDefault)
})


export const getMailboxHistoryPreviewResponseJobTotalItemsMin = 0;

export const getMailboxHistoryPreviewResponseJobProcessedItemsMin = 0;

export const getMailboxHistoryPreviewResponseJobCreatedItemsMin = 0;

export const getMailboxHistoryPreviewResponseJobReviewItemsMin = 0;

export const getMailboxHistoryPreviewResponseJobDuplicateItemsMin = 0;

export const getMailboxHistoryPreviewResponseJobFailedItemsMin = 0;

export const getMailboxHistoryPreviewResponseJobAttemptCountMin = 0;

export const getMailboxHistoryPreviewResponseCandidatesItemEmailBodyExcerptMax = 4000;

export const getMailboxHistoryPreviewResponseCandidatesItemEvidenceItemExcerptMax = 1000;

export const getMailboxHistoryPreviewResponseCandidatesItemAttachmentsItemSizeBytesMin = 0;

export const getMailboxHistoryPreviewResponseTotalMin = 0;

export const getMailboxHistoryPreviewResponseLimitMax = 100;

export const getMailboxHistoryPreviewResponseOffsetMin = 0;



export const getMailboxHistoryPreviewResponse = zod.object({
  "job": zod.object({
  "id": zod.uuid(),
  "mailboxId": zod.uuid(),
  "kind": zod.enum(['sync', 'analysis', 'lookback_preview', 'lookback_import', 'subscription_renewal']),
  "status": zod.enum(['queued', 'running', 'paused', 'retry', 'completed', 'failed', 'cancelled', 'stale']),
  "promptConfigurationId": zod.uuid().nullish(),
  "promptRevision": zod.int().min(1).nullish(),
  "totalItems": zod.int().min(getMailboxHistoryPreviewResponseJobTotalItemsMin),
  "processedItems": zod.int().min(getMailboxHistoryPreviewResponseJobProcessedItemsMin),
  "createdItems": zod.int().min(getMailboxHistoryPreviewResponseJobCreatedItemsMin),
  "reviewItems": zod.int().min(getMailboxHistoryPreviewResponseJobReviewItemsMin),
  "duplicateItems": zod.int().min(getMailboxHistoryPreviewResponseJobDuplicateItemsMin),
  "failedItems": zod.int().min(getMailboxHistoryPreviewResponseJobFailedItemsMin),
  "attemptCount": zod.int().min(getMailboxHistoryPreviewResponseJobAttemptCountMin),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "candidates": zod.array(zod.object({
  "id": zod.uuid(),
  "mailboxId": zod.uuid(),
  "sourceId": zod.uuid(),
  "messageId": zod.uuid(),
  "email": zod.object({
  "subject": zod.string(),
  "fromAddress": zod.string(),
  "toAddress": zod.string(),
  "bodyExcerpt": zod.string().max(getMailboxHistoryPreviewResponseCandidatesItemEmailBodyExcerptMax),
  "receivedAt": zod.iso.datetime({"offset":true}),
  "outlookWebUrl": zod.url().nullable()
}),
  "promptRevisionId": zod.uuid().nullish(),
  "classification": zod.enum(['irrelevant', 'linked_reply', 'new_lead_request', 'pipeline_request', 'needs_review']),
  "status": zod.enum(['pending_review', 'eligible_automatic', 'approved', 'dismissed', 'executed', 'stale', 'failed']),
  "knownContactNewNeed": zod.boolean(),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "linkedMessageId": zod.uuid().nullish(),
  "reason": zod.string(),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['message', 'attachment']),
  "id": zod.uuid(),
  "excerpt": zod.string().max(getMailboxHistoryPreviewResponseCandidatesItemEvidenceItemExcerptMax).nullish()
})),
  "missingEvidence": zod.array(zod.string()),
  "attachments": zod.array(zod.object({
  "id": zod.uuid(),
  "fileId": zod.uuid().nullish(),
  "attachmentType": zod.enum(['file', 'item', 'reference']),
  "isInline": zod.boolean(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(getMailboxHistoryPreviewResponseCandidatesItemAttachmentsItemSizeBytesMin),
  "contentHash": zod.string().nullish(),
  "storageStatus": zod.enum(['pending', 'ready', 'failed', 'unavailable']),
  "extractionStatus": zod.enum(['pending', 'ready', 'unsupported', 'encrypted', 'oversized', 'failed', 'unavailable']),
  "extractionErrorCode": zod.string().nullish(),
  "requiredEvidence": zod.boolean(),
  "contentUrl": zod.string().nullable()
})),
  "aiAuditId": zod.uuid().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(getMailboxHistoryPreviewResponseTotalMin),
  "limit": zod.int().min(1).max(getMailboxHistoryPreviewResponseLimitMax),
  "offset": zod.int().min(getMailboxHistoryPreviewResponseOffsetMin),
  "writesPerformed": zod.literal(false)
})


/**
 * @summary Confirm an exact completed preview and selected candidates for import
 */
export const confirmMailboxHistoryPreviewParams = zod.object({
  "previewJobId": zod.uuid()
})

export const confirmMailboxHistoryPreviewBodyCandidateIdsMax = 1000;

export const confirmMailboxHistoryPreviewBodyReasonMin = 3;
export const confirmMailboxHistoryPreviewBodyReasonMax = 500;



export const confirmMailboxHistoryPreviewBody = zod.object({
  "expectedPreviewUpdatedAt": zod.iso.datetime({"offset":true}),
  "promptRevisionId": zod.uuid(),
  "candidateIds": zod.array(zod.uuid()).min(1).max(confirmMailboxHistoryPreviewBodyCandidateIdsMax),
  "reason": zod.string().min(confirmMailboxHistoryPreviewBodyReasonMin).max(confirmMailboxHistoryPreviewBodyReasonMax)
})


export const confirmMailboxHistoryPreviewResponseTotalItemsMin = 0;

export const confirmMailboxHistoryPreviewResponseProcessedItemsMin = 0;

export const confirmMailboxHistoryPreviewResponseCreatedItemsMin = 0;

export const confirmMailboxHistoryPreviewResponseReviewItemsMin = 0;

export const confirmMailboxHistoryPreviewResponseDuplicateItemsMin = 0;

export const confirmMailboxHistoryPreviewResponseFailedItemsMin = 0;

export const confirmMailboxHistoryPreviewResponseAttemptCountMin = 0;



export const confirmMailboxHistoryPreviewResponse = zod.object({
  "id": zod.uuid(),
  "mailboxId": zod.uuid(),
  "kind": zod.enum(['sync', 'analysis', 'lookback_preview', 'lookback_import', 'subscription_renewal']),
  "status": zod.enum(['queued', 'running', 'paused', 'retry', 'completed', 'failed', 'cancelled', 'stale']),
  "promptConfigurationId": zod.uuid().nullish(),
  "promptRevision": zod.int().min(1).nullish(),
  "totalItems": zod.int().min(confirmMailboxHistoryPreviewResponseTotalItemsMin),
  "processedItems": zod.int().min(confirmMailboxHistoryPreviewResponseProcessedItemsMin),
  "createdItems": zod.int().min(confirmMailboxHistoryPreviewResponseCreatedItemsMin),
  "reviewItems": zod.int().min(confirmMailboxHistoryPreviewResponseReviewItemsMin),
  "duplicateItems": zod.int().min(confirmMailboxHistoryPreviewResponseDuplicateItemsMin),
  "failedItems": zod.int().min(confirmMailboxHistoryPreviewResponseFailedItemsMin),
  "attemptCount": zod.int().min(confirmMailboxHistoryPreviewResponseAttemptCountMin),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listMailboxIntakeJobsQueryLimitDefault = 25;
export const listMailboxIntakeJobsQueryLimitMax = 100;

export const listMailboxIntakeJobsQueryOffsetDefault = 0;
export const listMailboxIntakeJobsQueryOffsetMin = 0;



export const listMailboxIntakeJobsQueryParams = zod.object({
  "mailboxId": zod.uuid().optional(),
  "kind": zod.enum(['sync', 'analysis', 'lookback_preview', 'lookback_import', 'subscription_renewal']).optional(),
  "status": zod.enum(['queued', 'running', 'paused', 'retry', 'completed', 'failed', 'cancelled', 'stale']).optional(),
  "limit": zod.int().min(1).max(listMailboxIntakeJobsQueryLimitMax).default(listMailboxIntakeJobsQueryLimitDefault),
  "offset": zod.int().min(listMailboxIntakeJobsQueryOffsetMin).default(listMailboxIntakeJobsQueryOffsetDefault)
})


export const listMailboxIntakeJobsResponseItemsItemTotalItemsMin = 0;

export const listMailboxIntakeJobsResponseItemsItemProcessedItemsMin = 0;

export const listMailboxIntakeJobsResponseItemsItemCreatedItemsMin = 0;

export const listMailboxIntakeJobsResponseItemsItemReviewItemsMin = 0;

export const listMailboxIntakeJobsResponseItemsItemDuplicateItemsMin = 0;

export const listMailboxIntakeJobsResponseItemsItemFailedItemsMin = 0;

export const listMailboxIntakeJobsResponseItemsItemAttemptCountMin = 0;

export const listMailboxIntakeJobsResponseTotalMin = 0;

export const listMailboxIntakeJobsResponseLimitMax = 100;

export const listMailboxIntakeJobsResponseOffsetMin = 0;



export const listMailboxIntakeJobsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "mailboxId": zod.uuid(),
  "kind": zod.enum(['sync', 'analysis', 'lookback_preview', 'lookback_import', 'subscription_renewal']),
  "status": zod.enum(['queued', 'running', 'paused', 'retry', 'completed', 'failed', 'cancelled', 'stale']),
  "promptConfigurationId": zod.uuid().nullish(),
  "promptRevision": zod.int().min(1).nullish(),
  "totalItems": zod.int().min(listMailboxIntakeJobsResponseItemsItemTotalItemsMin),
  "processedItems": zod.int().min(listMailboxIntakeJobsResponseItemsItemProcessedItemsMin),
  "createdItems": zod.int().min(listMailboxIntakeJobsResponseItemsItemCreatedItemsMin),
  "reviewItems": zod.int().min(listMailboxIntakeJobsResponseItemsItemReviewItemsMin),
  "duplicateItems": zod.int().min(listMailboxIntakeJobsResponseItemsItemDuplicateItemsMin),
  "failedItems": zod.int().min(listMailboxIntakeJobsResponseItemsItemFailedItemsMin),
  "attemptCount": zod.int().min(listMailboxIntakeJobsResponseItemsItemAttemptCountMin),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listMailboxIntakeJobsResponseTotalMin),
  "limit": zod.int().min(1).max(listMailboxIntakeJobsResponseLimitMax),
  "offset": zod.int().min(listMailboxIntakeJobsResponseOffsetMin)
})


export const cancelMailboxIntakeJobParams = zod.object({
  "jobId": zod.uuid()
})

export const cancelMailboxIntakeJobBodyReasonMin = 3;
export const cancelMailboxIntakeJobBodyReasonMax = 500;



export const cancelMailboxIntakeJobBody = zod.object({
  "reason": zod.string().min(cancelMailboxIntakeJobBodyReasonMin).max(cancelMailboxIntakeJobBodyReasonMax),
  "expectedUpdatedAt": zod.iso.datetime({"offset":true})
})


export const cancelMailboxIntakeJobResponseTotalItemsMin = 0;

export const cancelMailboxIntakeJobResponseProcessedItemsMin = 0;

export const cancelMailboxIntakeJobResponseCreatedItemsMin = 0;

export const cancelMailboxIntakeJobResponseReviewItemsMin = 0;

export const cancelMailboxIntakeJobResponseDuplicateItemsMin = 0;

export const cancelMailboxIntakeJobResponseFailedItemsMin = 0;

export const cancelMailboxIntakeJobResponseAttemptCountMin = 0;



export const cancelMailboxIntakeJobResponse = zod.object({
  "id": zod.uuid(),
  "mailboxId": zod.uuid(),
  "kind": zod.enum(['sync', 'analysis', 'lookback_preview', 'lookback_import', 'subscription_renewal']),
  "status": zod.enum(['queued', 'running', 'paused', 'retry', 'completed', 'failed', 'cancelled', 'stale']),
  "promptConfigurationId": zod.uuid().nullish(),
  "promptRevision": zod.int().min(1).nullish(),
  "totalItems": zod.int().min(cancelMailboxIntakeJobResponseTotalItemsMin),
  "processedItems": zod.int().min(cancelMailboxIntakeJobResponseProcessedItemsMin),
  "createdItems": zod.int().min(cancelMailboxIntakeJobResponseCreatedItemsMin),
  "reviewItems": zod.int().min(cancelMailboxIntakeJobResponseReviewItemsMin),
  "duplicateItems": zod.int().min(cancelMailboxIntakeJobResponseDuplicateItemsMin),
  "failedItems": zod.int().min(cancelMailboxIntakeJobResponseFailedItemsMin),
  "attemptCount": zod.int().min(cancelMailboxIntakeJobResponseAttemptCountMin),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "completedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listMailboxRoutingExecutionsQueryLimitDefault = 25;
export const listMailboxRoutingExecutionsQueryLimitMax = 100;

export const listMailboxRoutingExecutionsQueryOffsetDefault = 0;
export const listMailboxRoutingExecutionsQueryOffsetMin = 0;



export const listMailboxRoutingExecutionsQueryParams = zod.object({
  "mailboxId": zod.uuid().optional(),
  "enquiryId": zod.uuid().optional(),
  "opportunityId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listMailboxRoutingExecutionsQueryLimitMax).default(listMailboxRoutingExecutionsQueryLimitDefault),
  "offset": zod.int().min(listMailboxRoutingExecutionsQueryOffsetMin).default(listMailboxRoutingExecutionsQueryOffsetDefault)
})

export const listMailboxRoutingExecutionsResponseItemsItemAttemptCountMin = 0;

export const listMailboxRoutingExecutionsResponseTotalMin = 0;

export const listMailboxRoutingExecutionsResponseLimitMax = 100;

export const listMailboxRoutingExecutionsResponseOffsetMin = 0;



export const listMailboxRoutingExecutionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "status": zod.enum(['queued', 'claimed', 'executed', 'dismissed', 'failed', 'stale', 'cancelled']),
  "targetKind": zod.enum(['lead', 'pipeline', 'link_only', 'none']),
  "promptRevisionId": zod.uuid().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "interactionId": zod.uuid().nullish(),
  "aiAuditId": zod.uuid().nullish(),
  "actorType": zod.enum(['automation', 'staff']),
  "actorId": zod.string(),
  "reason": zod.string(),
  "attemptCount": zod.int().min(listMailboxRoutingExecutionsResponseItemsItemAttemptCountMin),
  "lastErrorCode": zod.string().nullish(),
  "lastError": zod.string().nullish(),
  "executedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listMailboxRoutingExecutionsResponseTotalMin),
  "limit": zod.int().min(1).max(listMailboxRoutingExecutionsResponseLimitMax),
  "offset": zod.int().min(listMailboxRoutingExecutionsResponseOffsetMin)
})


/**
 * @summary Get the signed-in user's writing-style profile
 */
export const getOutlookStyleProfileResponse = zod.object({
  "styleProfile": zod.string().nullable(),
  "emailsAnalyzed": zod.int(),
  "analyzedAt": zod.iso.datetime({"offset":true}).nullable()
}).describe('Writing-style text and analysis metadata. GET returns the saved state; the analyze operation returns an unsaved preview.')


/**
 * @summary Explicitly save the reviewed writing-style profile
 */
export const updateOutlookStyleProfileBodyStyleProfileMax = 4000;

export const updateOutlookStyleProfileBodyAnalysisEmailsAnalyzedMin = 3;
export const updateOutlookStyleProfileBodyAnalysisEmailsAnalyzedMax = 100;



export const updateOutlookStyleProfileBody = zod.object({
  "styleProfile": zod.string().min(1).max(updateOutlookStyleProfileBodyStyleProfileMax),
  "analysis": zod.object({
  "emailsAnalyzed": zod.int().min(updateOutlookStyleProfileBodyAnalysisEmailsAnalyzedMin).max(updateOutlookStyleProfileBodyAnalysisEmailsAnalyzedMax),
  "analyzedAt": zod.iso.datetime({"offset":true})
}).optional().describe('Display metadata from the reviewed analysis preview; confers no execution authority. Omit when manually editing an existing saved profile.')
})

export const updateOutlookStyleProfileResponse = zod.object({
  "styleProfile": zod.string().nullable(),
  "emailsAnalyzed": zod.int(),
  "analyzedAt": zod.iso.datetime({"offset":true}).nullable()
}).describe('Writing-style text and analysis metadata. GET returns the saved state; the analyze operation returns an unsaved preview.')


/**
 * @summary Clear the signed-in user's writing-style profile
 */
export const clearOutlookStyleProfileResponse = zod.object({
  "cleared": zod.boolean()
})


/**
 * Accepts stripped plain-text samples only — no Graph tokens and no raw email HTML. Requires at least three usable samples. Returns a preview without updating the saved profile; use updateOutlookStyleProfile only after explicit review.
 * @summary Analyse plain-text Sent Items samples into an unsaved writing-style preview
 */
export const analyzeOutlookStyleProfileBodySamplesItemMax = 8000;

export const analyzeOutlookStyleProfileBodySamplesMin = 3;
export const analyzeOutlookStyleProfileBodySamplesMax = 100;



export const analyzeOutlookStyleProfileBody = zod.object({
  "samples": zod.array(zod.string().min(1).max(analyzeOutlookStyleProfileBodySamplesItemMax)).min(analyzeOutlookStyleProfileBodySamplesMin).max(analyzeOutlookStyleProfileBodySamplesMax)
}).describe('Plain-text sent-email samples; raw HTML and Graph tokens must never be supplied')

export const analyzeOutlookStyleProfileResponse = zod.object({
  "styleProfile": zod.string().nullable(),
  "emailsAnalyzed": zod.int(),
  "analyzedAt": zod.iso.datetime({"offset":true}).nullable()
}).describe('Writing-style text and analysis metadata. GET returns the saved state; the analyze operation returns an unsaved preview.')


/**
 * Accepts stripped plain-text message content only — no Graph tokens and no raw email HTML. When a stored style profile exists it is applied automatically.
 * @summary Draft an AI reply for a message, personalised with the user's stored writing-style profile
 */
export const generateOutlookSmartReplyBodyFromMax = 320;

export const generateOutlookSmartReplyBodySubjectMax = 998;

export const generateOutlookSmartReplyBodyBodyMax = 8000;

export const generateOutlookSmartReplyBodySenderNameMax = 120;



export const generateOutlookSmartReplyBody = zod.object({
  "from": zod.string().min(1).max(generateOutlookSmartReplyBodyFromMax),
  "subject": zod.string().max(generateOutlookSmartReplyBodySubjectMax),
  "body": zod.string().min(1).max(generateOutlookSmartReplyBodyBodyMax),
  "senderName": zod.string().max(generateOutlookSmartReplyBodySenderNameMax).optional().describe('Display name of the email sender, used for the first-name sign-off')
}).describe('Plain-text message content for the reply draft; raw HTML and Graph tokens must never be supplied')

export const generateOutlookSmartReplyResponse = zod.object({
  "draft": zod.string(),
  "auditId": zod.uuid(),
  "styleProfileApplied": zod.boolean().describe('True when the user\'s stored writing-style profile was injected into the prompt')
})


/**
 * Accepts the sender address and stripped plain-text message content only — no Graph tokens and no raw email HTML. Returns editable suggestions and a single existing matching account when one is found. Nothing is saved.
 * @summary Suggest new-contact details for an email sender using AI
 */
export const suggestOutlookContactBodyEmailMax = 320;

export const suggestOutlookContactBodyNameMax = 200;

export const suggestOutlookContactBodySubjectMax = 998;

export const suggestOutlookContactBodyBodyMax = 8000;



export const suggestOutlookContactBody = zod.object({
  "email": zod.email().max(suggestOutlookContactBodyEmailMax),
  "name": zod.string().max(suggestOutlookContactBodyNameMax).optional().describe('Display name shown on the email sender'),
  "subject": zod.string().max(suggestOutlookContactBodySubjectMax),
  "body": zod.string().min(1).max(suggestOutlookContactBodyBodyMax)
}).describe('Sender address plus plain-text message content; raw HTML and Graph tokens must never be supplied')

export const suggestOutlookContactResponse = zod.object({
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "jobTitle": zod.string().nullable(),
  "phone": zod.string().nullable(),
  "mobile": zod.string().nullable(),
  "companyName": zod.string().nullable().describe('Organisation named in the email, whether or not it matches an account'),
  "account": zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "matchedBy": zod.enum(['email_domain', 'company_name'])
}).nullable().describe('The single existing account matched by the sender\'s email domain or the company name; null when none or more than one match'),
  "auditId": zod.uuid()
})


/**
 * @summary Get the signed-in user's Azure DevOps link for an Outlook message
 */
export const getOutlookDevOpsLinkQueryStableMessageIdMax = 1024;



export const getOutlookDevOpsLinkQueryParams = zod.object({
  "stableMessageId": zod.string().min(1).max(getOutlookDevOpsLinkQueryStableMessageIdMax)
})

export const getOutlookDevOpsLinkResponseLinkOneStableMessageIdMax = 1024;

export const getOutlookDevOpsLinkResponseLinkOneProjectMax = 255;


export const getOutlookDevOpsLinkResponseLinkOneWorkItemUrlMax = 2048;



export const getOutlookDevOpsLinkResponse = zod.object({
  "link": zod.union([zod.object({
  "id": zod.uuid(),
  "stableMessageId": zod.string().min(1).max(getOutlookDevOpsLinkResponseLinkOneStableMessageIdMax),
  "organization": zod.enum(['circlet']),
  "project": zod.string().min(1).max(getOutlookDevOpsLinkResponseLinkOneProjectMax),
  "workItemId": zod.int().min(1),
  "workItemUrl": zod.url().max(getOutlookDevOpsLinkResponseLinkOneWorkItemUrlMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('User-owned Outlook message mapping. Email content, credentials, and access tokens are never stored.'),zod.null()])
})


/**
 * @summary Create or replace the signed-in user's Azure DevOps link for an Outlook message
 */
export const upsertOutlookDevOpsLinkBodyStableMessageIdMax = 1024;

export const upsertOutlookDevOpsLinkBodyProjectMax = 255;


export const upsertOutlookDevOpsLinkBodyWorkItemUrlMax = 2048;



export const upsertOutlookDevOpsLinkBody = zod.object({
  "stableMessageId": zod.string().min(1).max(upsertOutlookDevOpsLinkBodyStableMessageIdMax),
  "organization": zod.enum(['circlet']),
  "project": zod.string().min(1).max(upsertOutlookDevOpsLinkBodyProjectMax),
  "workItemId": zod.int().min(1),
  "workItemUrl": zod.url().max(upsertOutlookDevOpsLinkBodyWorkItemUrlMax)
})

export const upsertOutlookDevOpsLinkResponseStableMessageIdMax = 1024;

export const upsertOutlookDevOpsLinkResponseProjectMax = 255;


export const upsertOutlookDevOpsLinkResponseWorkItemUrlMax = 2048;



export const upsertOutlookDevOpsLinkResponse = zod.object({
  "id": zod.uuid(),
  "stableMessageId": zod.string().min(1).max(upsertOutlookDevOpsLinkResponseStableMessageIdMax),
  "organization": zod.enum(['circlet']),
  "project": zod.string().min(1).max(upsertOutlookDevOpsLinkResponseProjectMax),
  "workItemId": zod.int().min(1),
  "workItemUrl": zod.url().max(upsertOutlookDevOpsLinkResponseWorkItemUrlMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('User-owned Outlook message mapping. Email content, credentials, and access tokens are never stored.')


/**
 * @summary Remove the signed-in user's Azure DevOps link for an Outlook message
 */
export const deleteOutlookDevOpsLinkQueryStableMessageIdMax = 1024;



export const deleteOutlookDevOpsLinkQueryParams = zod.object({
  "stableMessageId": zod.string().min(1).max(deleteOutlookDevOpsLinkQueryStableMessageIdMax)
})

export const deleteOutlookDevOpsLinkResponse = zod.object({
  "removed": zod.boolean()
})


/**
 * @summary List configured web-ingestion rules
 */
export const listIngestionRulesResponseItemsItemOneNameMax = 200;

export const listIngestionRulesResponseItemsItemOneDescriptionMax = 2000;

export const listIngestionRulesResponseItemsItemOneSourcesItemUrlMax = 2000;

export const listIngestionRulesResponseItemsItemOneSourcesItemLabelMax = 200;

export const listIngestionRulesResponseItemsItemOneSourcesMax = 50;

export const listIngestionRulesResponseItemsItemOneKeywordsItemMax = 100;

export const listIngestionRulesResponseItemsItemOneKeywordsMax = 100;

export const listIngestionRulesResponseItemsItemOneFrequencyMinutesMin = 60;
export const listIngestionRulesResponseItemsItemOneFrequencyMinutesMax = 43200;

export const listIngestionRulesResponseItemsItemOneTargetAccountIdsMax = 500;

export const listIngestionRulesResponseItemsItemOneAutoAttachThresholdMin = 0.5;
export const listIngestionRulesResponseItemsItemOneAutoAttachThresholdMax = 1;



export const listIngestionRulesResponse = zod.object({
  "items": zod.array(zod.object({
  "name": zod.string().min(1).max(listIngestionRulesResponseItemsItemOneNameMax),
  "description": zod.string().max(listIngestionRulesResponseItemsItemOneDescriptionMax).nullish(),
  "status": zod.enum(['active', 'paused']),
  "sources": zod.array(zod.object({
  "type": zod.enum(['news', 'website', 'jobs']),
  "url": zod.url().max(listIngestionRulesResponseItemsItemOneSourcesItemUrlMax),
  "label": zod.string().max(listIngestionRulesResponseItemsItemOneSourcesItemLabelMax).optional()
})).min(1).max(listIngestionRulesResponseItemsItemOneSourcesMax),
  "keywords": zod.array(zod.string().min(1).max(listIngestionRulesResponseItemsItemOneKeywordsItemMax)).max(listIngestionRulesResponseItemsItemOneKeywordsMax),
  "frequencyMinutes": zod.int().min(listIngestionRulesResponseItemsItemOneFrequencyMinutesMin).max(listIngestionRulesResponseItemsItemOneFrequencyMinutesMax),
  "targetAccountIds": zod.array(zod.uuid()).max(listIngestionRulesResponseItemsItemOneTargetAccountIdsMax),
  "autoAttachThreshold": zod.number().min(listIngestionRulesResponseItemsItemOneAutoAttachThresholdMin).max(listIngestionRulesResponseItemsItemOneAutoAttachThresholdMax)
}).and(zod.object({
  "id": zod.uuid(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastError": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})))
})


/**
 * @summary Create a scheduled, provenance-aware ingestion rule
 */
export const createIngestionRuleBodyNameMax = 200;

export const createIngestionRuleBodyDescriptionMax = 2000;

export const createIngestionRuleBodySourcesItemUrlMax = 2000;

export const createIngestionRuleBodySourcesItemLabelMax = 200;

export const createIngestionRuleBodySourcesMax = 50;

export const createIngestionRuleBodyKeywordsItemMax = 100;

export const createIngestionRuleBodyKeywordsMax = 100;

export const createIngestionRuleBodyFrequencyMinutesMin = 60;
export const createIngestionRuleBodyFrequencyMinutesMax = 43200;

export const createIngestionRuleBodyTargetAccountIdsMax = 500;

export const createIngestionRuleBodyAutoAttachThresholdMin = 0.5;
export const createIngestionRuleBodyAutoAttachThresholdMax = 1;



export const createIngestionRuleBody = zod.object({
  "name": zod.string().min(1).max(createIngestionRuleBodyNameMax),
  "description": zod.string().max(createIngestionRuleBodyDescriptionMax).nullish(),
  "status": zod.enum(['active', 'paused']),
  "sources": zod.array(zod.object({
  "type": zod.enum(['news', 'website', 'jobs']),
  "url": zod.url().max(createIngestionRuleBodySourcesItemUrlMax),
  "label": zod.string().max(createIngestionRuleBodySourcesItemLabelMax).optional()
})).min(1).max(createIngestionRuleBodySourcesMax),
  "keywords": zod.array(zod.string().min(1).max(createIngestionRuleBodyKeywordsItemMax)).max(createIngestionRuleBodyKeywordsMax),
  "frequencyMinutes": zod.int().min(createIngestionRuleBodyFrequencyMinutesMin).max(createIngestionRuleBodyFrequencyMinutesMax),
  "targetAccountIds": zod.array(zod.uuid()).max(createIngestionRuleBodyTargetAccountIdsMax),
  "autoAttachThreshold": zod.number().min(createIngestionRuleBodyAutoAttachThresholdMin).max(createIngestionRuleBodyAutoAttachThresholdMax)
})

export const createIngestionRuleResponseOneNameMax = 200;

export const createIngestionRuleResponseOneDescriptionMax = 2000;

export const createIngestionRuleResponseOneSourcesItemUrlMax = 2000;

export const createIngestionRuleResponseOneSourcesItemLabelMax = 200;

export const createIngestionRuleResponseOneSourcesMax = 50;

export const createIngestionRuleResponseOneKeywordsItemMax = 100;

export const createIngestionRuleResponseOneKeywordsMax = 100;

export const createIngestionRuleResponseOneFrequencyMinutesMin = 60;
export const createIngestionRuleResponseOneFrequencyMinutesMax = 43200;

export const createIngestionRuleResponseOneTargetAccountIdsMax = 500;

export const createIngestionRuleResponseOneAutoAttachThresholdMin = 0.5;
export const createIngestionRuleResponseOneAutoAttachThresholdMax = 1;



export const createIngestionRuleResponse = zod.object({
  "name": zod.string().min(1).max(createIngestionRuleResponseOneNameMax),
  "description": zod.string().max(createIngestionRuleResponseOneDescriptionMax).nullish(),
  "status": zod.enum(['active', 'paused']),
  "sources": zod.array(zod.object({
  "type": zod.enum(['news', 'website', 'jobs']),
  "url": zod.url().max(createIngestionRuleResponseOneSourcesItemUrlMax),
  "label": zod.string().max(createIngestionRuleResponseOneSourcesItemLabelMax).optional()
})).min(1).max(createIngestionRuleResponseOneSourcesMax),
  "keywords": zod.array(zod.string().min(1).max(createIngestionRuleResponseOneKeywordsItemMax)).max(createIngestionRuleResponseOneKeywordsMax),
  "frequencyMinutes": zod.int().min(createIngestionRuleResponseOneFrequencyMinutesMin).max(createIngestionRuleResponseOneFrequencyMinutesMax),
  "targetAccountIds": zod.array(zod.uuid()).max(createIngestionRuleResponseOneTargetAccountIdsMax),
  "autoAttachThreshold": zod.number().min(createIngestionRuleResponseOneAutoAttachThresholdMin).max(createIngestionRuleResponseOneAutoAttachThresholdMax)
}).and(zod.object({
  "id": zod.uuid(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastError": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


export const updateIngestionRuleParams = zod.object({
  "id": zod.uuid()
})

export const updateIngestionRuleBodyNameMax = 200;

export const updateIngestionRuleBodyDescriptionMax = 2000;

export const updateIngestionRuleBodySourcesItemUrlMax = 2000;

export const updateIngestionRuleBodySourcesItemLabelMax = 200;

export const updateIngestionRuleBodySourcesMax = 50;

export const updateIngestionRuleBodyKeywordsItemMax = 100;

export const updateIngestionRuleBodyKeywordsMax = 100;

export const updateIngestionRuleBodyFrequencyMinutesMin = 60;
export const updateIngestionRuleBodyFrequencyMinutesMax = 43200;

export const updateIngestionRuleBodyTargetAccountIdsMax = 500;

export const updateIngestionRuleBodyAutoAttachThresholdMin = 0.5;
export const updateIngestionRuleBodyAutoAttachThresholdMax = 1;



export const updateIngestionRuleBody = zod.object({
  "name": zod.string().min(1).max(updateIngestionRuleBodyNameMax),
  "description": zod.string().max(updateIngestionRuleBodyDescriptionMax).nullish(),
  "status": zod.enum(['active', 'paused']),
  "sources": zod.array(zod.object({
  "type": zod.enum(['news', 'website', 'jobs']),
  "url": zod.url().max(updateIngestionRuleBodySourcesItemUrlMax),
  "label": zod.string().max(updateIngestionRuleBodySourcesItemLabelMax).optional()
})).min(1).max(updateIngestionRuleBodySourcesMax),
  "keywords": zod.array(zod.string().min(1).max(updateIngestionRuleBodyKeywordsItemMax)).max(updateIngestionRuleBodyKeywordsMax),
  "frequencyMinutes": zod.int().min(updateIngestionRuleBodyFrequencyMinutesMin).max(updateIngestionRuleBodyFrequencyMinutesMax),
  "targetAccountIds": zod.array(zod.uuid()).max(updateIngestionRuleBodyTargetAccountIdsMax),
  "autoAttachThreshold": zod.number().min(updateIngestionRuleBodyAutoAttachThresholdMin).max(updateIngestionRuleBodyAutoAttachThresholdMax)
})

export const updateIngestionRuleResponseOneNameMax = 200;

export const updateIngestionRuleResponseOneDescriptionMax = 2000;

export const updateIngestionRuleResponseOneSourcesItemUrlMax = 2000;

export const updateIngestionRuleResponseOneSourcesItemLabelMax = 200;

export const updateIngestionRuleResponseOneSourcesMax = 50;

export const updateIngestionRuleResponseOneKeywordsItemMax = 100;

export const updateIngestionRuleResponseOneKeywordsMax = 100;

export const updateIngestionRuleResponseOneFrequencyMinutesMin = 60;
export const updateIngestionRuleResponseOneFrequencyMinutesMax = 43200;

export const updateIngestionRuleResponseOneTargetAccountIdsMax = 500;

export const updateIngestionRuleResponseOneAutoAttachThresholdMin = 0.5;
export const updateIngestionRuleResponseOneAutoAttachThresholdMax = 1;



export const updateIngestionRuleResponse = zod.object({
  "name": zod.string().min(1).max(updateIngestionRuleResponseOneNameMax),
  "description": zod.string().max(updateIngestionRuleResponseOneDescriptionMax).nullish(),
  "status": zod.enum(['active', 'paused']),
  "sources": zod.array(zod.object({
  "type": zod.enum(['news', 'website', 'jobs']),
  "url": zod.url().max(updateIngestionRuleResponseOneSourcesItemUrlMax),
  "label": zod.string().max(updateIngestionRuleResponseOneSourcesItemLabelMax).optional()
})).min(1).max(updateIngestionRuleResponseOneSourcesMax),
  "keywords": zod.array(zod.string().min(1).max(updateIngestionRuleResponseOneKeywordsItemMax)).max(updateIngestionRuleResponseOneKeywordsMax),
  "frequencyMinutes": zod.int().min(updateIngestionRuleResponseOneFrequencyMinutesMin).max(updateIngestionRuleResponseOneFrequencyMinutesMax),
  "targetAccountIds": zod.array(zod.uuid()).max(updateIngestionRuleResponseOneTargetAccountIdsMax),
  "autoAttachThreshold": zod.number().min(updateIngestionRuleResponseOneAutoAttachThresholdMin).max(updateIngestionRuleResponseOneAutoAttachThresholdMax)
}).and(zod.object({
  "id": zod.uuid(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastError": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Fetch and classify every configured source now
 */
export const runIngestionRuleParams = zod.object({
  "id": zod.uuid()
})

export const runIngestionRuleResponse = zod.object({
  "fetched": zod.int(),
  "ingested": zod.int(),
  "duplicates": zod.int(),
  "classified": zod.int(),
  "autoAttached": zod.int(),
  "errors": zod.array(zod.string())
})


/**
 * @summary Ingest a source snapshot delivered by an approved fetch connector
 */
export const ingestWebSignalDocumentParams = zod.object({
  "id": zod.uuid()
})

export const ingestWebSignalDocumentBodySourceUrlMax = 2000;

export const ingestWebSignalDocumentBodyTitleMax = 500;

export const ingestWebSignalDocumentBodyContentMin = 20;
export const ingestWebSignalDocumentBodyContentMax = 200000;



export const ingestWebSignalDocumentBody = zod.object({
  "sourceType": zod.enum(['news', 'website', 'jobs']),
  "sourceUrl": zod.url().max(ingestWebSignalDocumentBodySourceUrlMax),
  "title": zod.string().min(1).max(ingestWebSignalDocumentBodyTitleMax),
  "content": zod.string().min(ingestWebSignalDocumentBodyContentMin).max(ingestWebSignalDocumentBodyContentMax),
  "publishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "metadata": zod.record(zod.string(), zod.unknown()).optional()
})

export const ingestWebSignalDocumentResponseCandidateOneFitScoreMin = 0;
export const ingestWebSignalDocumentResponseCandidateOneFitScoreMax = 100;



export const ingestWebSignalDocumentResponseCandidateOneConfidenceMin = 0;
export const ingestWebSignalDocumentResponseCandidateOneConfidenceMax = 1;

export const ingestWebSignalDocumentResponseCandidateOneTargetMarketSimilarityMin = -1;
export const ingestWebSignalDocumentResponseCandidateOneTargetMarketSimilarityMax = 1;

export const ingestWebSignalDocumentResponseCandidateOneTenderRecommendationOneReasonsMax = 10;

export const ingestWebSignalDocumentResponseCandidateOneTenderRecommendationOneDisqualifiersMax = 20;



export const ingestWebSignalDocumentResponse = zod.object({
  "document": zod.object({
  "id": zod.uuid(),
  "ruleId": zod.uuid().nullable(),
  "sourceType": zod.enum(['news', 'website', 'jobs']),
  "sourceUrl": zod.url(),
  "canonicalUrl": zod.url(),
  "title": zod.string(),
  "content": zod.string().optional(),
  "contentHash": zod.string(),
  "httpStatus": zod.int().nullish(),
  "fetchedAt": zod.iso.datetime({"offset":true}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "embeddingAvailable": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "candidate": zod.union([zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "companyName": zod.string().nullable(),
  "discoverySourceId": zod.uuid().nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "recipeId": zod.uuid().nullish(),
  "discoveryRunId": zod.uuid().nullish(),
  "candidateKey": zod.string().nullish(),
  "discoveryKind": zod.enum(['tender', 'project', 'potential_customer', 'buying_signal', 'other']).nullish(),
  "opportunityTitle": zod.string().nullish(),
  "organizationName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "fitScore": zod.number().min(ingestWebSignalDocumentResponseCandidateOneFitScoreMin).max(ingestWebSignalDocumentResponseCandidateOneFitScoreMax).nullish(),
  "fitReasons": zod.array(zod.string()).optional(),
  "unknowns": zod.array(zod.string()).optional(),
  "extractedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "editedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "reviewStatus": zod.enum(['unreviewed', 'accepted', 'dismissed', 'deferred', 'duplicate', 'promoted', 'changed']).optional(),
  "reviewRevision": zod.int().min(1).optional(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "duplicateCandidateId": zod.uuid().nullish(),
  "latestEvidenceRevision": zod.int().min(1).nullish(),
  "observedDeadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastMaterialChangeAt": zod.iso.datetime({"offset":true}).nullish(),
  "type": zod.enum(['hiring_surge', 'funding_budget', 'expansion', 'leadership_change', 'technology_adoption', 'explicit_need', 'other']),
  "confidence": zod.number().min(ingestWebSignalDocumentResponseCandidateOneConfidenceMin).max(ingestWebSignalDocumentResponseCandidateOneConfidenceMax),
  "rationale": zod.string(),
  "targetMarketSimilarity": zod.number().min(ingestWebSignalDocumentResponseCandidateOneTargetMarketSimilarityMin).max(ingestWebSignalDocumentResponseCandidateOneTargetMarketSimilarityMax).nullish(),
  "status": zod.enum(['pending', 'confirmed', 'dismissed']),
  "sourceUrl": zod.url(),
  "sourceTitle": zod.string(),
  "fetchedAt": zod.iso.datetime({"offset":true}),
  "signalId": zod.uuid().nullable(),
  "accountMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "opportunityMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "reviewedBy": zod.string().nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "industry": zod.string().nullish().describe('Industry suggested by AI or set by a reviewer'),
  "industrySource": zod.enum(['ai', 'human']).nullish(),
  "jobId": zod.uuid().nullish().describe('Job that found this candidate'),
  "decision": zod.enum(['pursue', 'not_pursuing']).nullish(),
  "tenderRecommendation": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "reasons": zod.array(zod.string()).max(ingestWebSignalDocumentResponseCandidateOneTenderRecommendationOneReasonsMax),
  "disqualifiers": zod.array(zod.string()).max(ingestWebSignalDocumentResponseCandidateOneTenderRecommendationOneDisqualifiersMax),
  "confidence": zod.enum(['high', 'medium', 'low']).nullable()
}),zod.null()]).optional().describe('Bid recommendation of the tender opportunity created from this candidate (tender portal candidates only).')
}),zod.null()]).optional(),
  "duplicate": zod.boolean()
})


export const listIngestedDocumentsQueryLimitDefault = 100;
export const listIngestedDocumentsQueryLimitMax = 250;



export const listIngestedDocumentsQueryParams = zod.object({
  "ruleId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listIngestedDocumentsQueryLimitMax).default(listIngestedDocumentsQueryLimitDefault)
})

export const listIngestedDocumentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "ruleId": zod.uuid().nullable(),
  "sourceType": zod.enum(['news', 'website', 'jobs']),
  "sourceUrl": zod.url(),
  "canonicalUrl": zod.url(),
  "title": zod.string(),
  "content": zod.string().optional(),
  "contentHash": zod.string(),
  "httpStatus": zod.int().nullish(),
  "fetchedAt": zod.iso.datetime({"offset":true}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullish(),
  "embeddingAvailable": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
}))
})


export const listWebSignalCandidatesQueryIndustryMax = 120;

export const listWebSignalCandidatesQueryLimitDefault = 100;
export const listWebSignalCandidatesQueryLimitMax = 250;

export const listWebSignalCandidatesQueryOffsetDefault = 0;
export const listWebSignalCandidatesQueryOffsetMin = 0;



export const listWebSignalCandidatesQueryParams = zod.object({
  "status": zod.enum(['pending', 'confirmed', 'dismissed']).optional(),
  "accountId": zod.uuid().optional(),
  "industry": zod.string().min(1).max(listWebSignalCandidatesQueryIndustryMax).optional().describe('Only candidates in this industry (case-insensitive)'),
  "withoutIndustry": zod.boolean().optional().describe('Only candidates that have no industry yet'),
  "jobId": zod.uuid().optional().describe('Only candidates found by this job'),
  "decision": zod.enum(['pursue', 'not_pursuing', 'undecided']).optional().describe('Filter by the recorded Pursue decision'),
  "limit": zod.int().min(1).max(listWebSignalCandidatesQueryLimitMax).default(listWebSignalCandidatesQueryLimitDefault),
  "offset": zod.int().min(listWebSignalCandidatesQueryOffsetMin).default(listWebSignalCandidatesQueryOffsetDefault)
})

export const listWebSignalCandidatesResponseItemsItemFitScoreMin = 0;
export const listWebSignalCandidatesResponseItemsItemFitScoreMax = 100;



export const listWebSignalCandidatesResponseItemsItemConfidenceMin = 0;
export const listWebSignalCandidatesResponseItemsItemConfidenceMax = 1;

export const listWebSignalCandidatesResponseItemsItemTargetMarketSimilarityMin = -1;
export const listWebSignalCandidatesResponseItemsItemTargetMarketSimilarityMax = 1;

export const listWebSignalCandidatesResponseItemsItemTenderRecommendationOneReasonsMax = 10;

export const listWebSignalCandidatesResponseItemsItemTenderRecommendationOneDisqualifiersMax = 20;

export const listWebSignalCandidatesResponseTotalMin = 0;


export const listWebSignalCandidatesResponseOffsetMin = 0;



export const listWebSignalCandidatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "companyName": zod.string().nullable(),
  "discoverySourceId": zod.uuid().nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "recipeId": zod.uuid().nullish(),
  "discoveryRunId": zod.uuid().nullish(),
  "candidateKey": zod.string().nullish(),
  "discoveryKind": zod.enum(['tender', 'project', 'potential_customer', 'buying_signal', 'other']).nullish(),
  "opportunityTitle": zod.string().nullish(),
  "organizationName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "fitScore": zod.number().min(listWebSignalCandidatesResponseItemsItemFitScoreMin).max(listWebSignalCandidatesResponseItemsItemFitScoreMax).nullish(),
  "fitReasons": zod.array(zod.string()).optional(),
  "unknowns": zod.array(zod.string()).optional(),
  "extractedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "editedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "reviewStatus": zod.enum(['unreviewed', 'accepted', 'dismissed', 'deferred', 'duplicate', 'promoted', 'changed']).optional(),
  "reviewRevision": zod.int().min(1).optional(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "duplicateCandidateId": zod.uuid().nullish(),
  "latestEvidenceRevision": zod.int().min(1).nullish(),
  "observedDeadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastMaterialChangeAt": zod.iso.datetime({"offset":true}).nullish(),
  "type": zod.enum(['hiring_surge', 'funding_budget', 'expansion', 'leadership_change', 'technology_adoption', 'explicit_need', 'other']),
  "confidence": zod.number().min(listWebSignalCandidatesResponseItemsItemConfidenceMin).max(listWebSignalCandidatesResponseItemsItemConfidenceMax),
  "rationale": zod.string(),
  "targetMarketSimilarity": zod.number().min(listWebSignalCandidatesResponseItemsItemTargetMarketSimilarityMin).max(listWebSignalCandidatesResponseItemsItemTargetMarketSimilarityMax).nullish(),
  "status": zod.enum(['pending', 'confirmed', 'dismissed']),
  "sourceUrl": zod.url(),
  "sourceTitle": zod.string(),
  "fetchedAt": zod.iso.datetime({"offset":true}),
  "signalId": zod.uuid().nullable(),
  "accountMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "opportunityMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "reviewedBy": zod.string().nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "industry": zod.string().nullish().describe('Industry suggested by AI or set by a reviewer'),
  "industrySource": zod.enum(['ai', 'human']).nullish(),
  "jobId": zod.uuid().nullish().describe('Job that found this candidate'),
  "decision": zod.enum(['pursue', 'not_pursuing']).nullish(),
  "tenderRecommendation": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "reasons": zod.array(zod.string()).max(listWebSignalCandidatesResponseItemsItemTenderRecommendationOneReasonsMax),
  "disqualifiers": zod.array(zod.string()).max(listWebSignalCandidatesResponseItemsItemTenderRecommendationOneDisqualifiersMax),
  "confidence": zod.enum(['high', 'medium', 'low']).nullable()
}),zod.null()]).optional().describe('Bid recommendation of the tender opportunity created from this candidate (tender portal candidates only).')
})),
  "total": zod.int().min(listWebSignalCandidatesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebSignalCandidatesResponseOffsetMin)
})


/**
 * @summary Count Review queue candidates per industry, using the same filters as the Review queue
 */
export const listWebSignalCandidateIndustriesQueryLimitDefault = 50;
export const listWebSignalCandidateIndustriesQueryLimitMax = 100;

export const listWebSignalCandidateIndustriesQueryOffsetDefault = 0;
export const listWebSignalCandidateIndustriesQueryOffsetMin = 0;



export const listWebSignalCandidateIndustriesQueryParams = zod.object({
  "status": zod.enum(['pending', 'confirmed', 'dismissed']).optional(),
  "jobId": zod.uuid().optional(),
  "decision": zod.enum(['pursue', 'not_pursuing', 'undecided']).optional(),
  "limit": zod.int().min(1).max(listWebSignalCandidateIndustriesQueryLimitMax).default(listWebSignalCandidateIndustriesQueryLimitDefault),
  "offset": zod.int().min(listWebSignalCandidateIndustriesQueryOffsetMin).default(listWebSignalCandidateIndustriesQueryOffsetDefault)
})

export const listWebSignalCandidateIndustriesResponseItemsItemCountMin = 0;

export const listWebSignalCandidateIndustriesResponseTotalMin = 0;


export const listWebSignalCandidateIndustriesResponseOffsetMin = 0;



export const listWebSignalCandidateIndustriesResponse = zod.object({
  "items": zod.array(zod.object({
  "industry": zod.string().nullable(),
  "count": zod.int().min(listWebSignalCandidateIndustriesResponseItemsItemCountMin)
})),
  "total": zod.int().min(listWebSignalCandidateIndustriesResponseTotalMin).describe('Number of industry groups'),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebSignalCandidateIndustriesResponseOffsetMin)
})


export const reviewWebSignalCandidateParams = zod.object({
  "id": zod.uuid()
})

export const reviewWebSignalCandidateBodyReviewedByMax = 200;



export const reviewWebSignalCandidateBody = zod.object({
  "action": zod.enum(['confirm', 'reassign', 'dismiss']),
  "accountId": zod.uuid().nullish(),
  "reviewedBy": zod.string().max(reviewWebSignalCandidateBodyReviewedByMax).optional()
})

export const reviewWebSignalCandidateResponseFitScoreMin = 0;
export const reviewWebSignalCandidateResponseFitScoreMax = 100;



export const reviewWebSignalCandidateResponseConfidenceMin = 0;
export const reviewWebSignalCandidateResponseConfidenceMax = 1;

export const reviewWebSignalCandidateResponseTargetMarketSimilarityMin = -1;
export const reviewWebSignalCandidateResponseTargetMarketSimilarityMax = 1;

export const reviewWebSignalCandidateResponseTenderRecommendationOneReasonsMax = 10;

export const reviewWebSignalCandidateResponseTenderRecommendationOneDisqualifiersMax = 20;



export const reviewWebSignalCandidateResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "companyName": zod.string().nullable(),
  "discoverySourceId": zod.uuid().nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "recipeId": zod.uuid().nullish(),
  "discoveryRunId": zod.uuid().nullish(),
  "candidateKey": zod.string().nullish(),
  "discoveryKind": zod.enum(['tender', 'project', 'potential_customer', 'buying_signal', 'other']).nullish(),
  "opportunityTitle": zod.string().nullish(),
  "organizationName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "fitScore": zod.number().min(reviewWebSignalCandidateResponseFitScoreMin).max(reviewWebSignalCandidateResponseFitScoreMax).nullish(),
  "fitReasons": zod.array(zod.string()).optional(),
  "unknowns": zod.array(zod.string()).optional(),
  "extractedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "editedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "reviewStatus": zod.enum(['unreviewed', 'accepted', 'dismissed', 'deferred', 'duplicate', 'promoted', 'changed']).optional(),
  "reviewRevision": zod.int().min(1).optional(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "duplicateCandidateId": zod.uuid().nullish(),
  "latestEvidenceRevision": zod.int().min(1).nullish(),
  "observedDeadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastMaterialChangeAt": zod.iso.datetime({"offset":true}).nullish(),
  "type": zod.enum(['hiring_surge', 'funding_budget', 'expansion', 'leadership_change', 'technology_adoption', 'explicit_need', 'other']),
  "confidence": zod.number().min(reviewWebSignalCandidateResponseConfidenceMin).max(reviewWebSignalCandidateResponseConfidenceMax),
  "rationale": zod.string(),
  "targetMarketSimilarity": zod.number().min(reviewWebSignalCandidateResponseTargetMarketSimilarityMin).max(reviewWebSignalCandidateResponseTargetMarketSimilarityMax).nullish(),
  "status": zod.enum(['pending', 'confirmed', 'dismissed']),
  "sourceUrl": zod.url(),
  "sourceTitle": zod.string(),
  "fetchedAt": zod.iso.datetime({"offset":true}),
  "signalId": zod.uuid().nullable(),
  "accountMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "opportunityMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "reviewedBy": zod.string().nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "industry": zod.string().nullish().describe('Industry suggested by AI or set by a reviewer'),
  "industrySource": zod.enum(['ai', 'human']).nullish(),
  "jobId": zod.uuid().nullish().describe('Job that found this candidate'),
  "decision": zod.enum(['pursue', 'not_pursuing']).nullish(),
  "tenderRecommendation": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "reasons": zod.array(zod.string()).max(reviewWebSignalCandidateResponseTenderRecommendationOneReasonsMax),
  "disqualifiers": zod.array(zod.string()).max(reviewWebSignalCandidateResponseTenderRecommendationOneDisqualifiersMax),
  "confidence": zod.enum(['high', 'medium', 'low']).nullable()
}),zod.null()]).optional().describe('Bid recommendation of the tender opportunity created from this candidate (tender portal candidates only).')
})


export const getWebSignalDigestQueryDaysDefault = 7;
export const getWebSignalDigestQueryDaysMax = 90;



export const getWebSignalDigestQueryParams = zod.object({
  "days": zod.int().min(1).max(getWebSignalDigestQueryDaysMax).default(getWebSignalDigestQueryDaysDefault)
})

export const getWebSignalDigestResponseItemsItemFitScoreMin = 0;
export const getWebSignalDigestResponseItemsItemFitScoreMax = 100;



export const getWebSignalDigestResponseItemsItemConfidenceMin = 0;
export const getWebSignalDigestResponseItemsItemConfidenceMax = 1;

export const getWebSignalDigestResponseItemsItemTargetMarketSimilarityMin = -1;
export const getWebSignalDigestResponseItemsItemTargetMarketSimilarityMax = 1;

export const getWebSignalDigestResponseItemsItemTenderRecommendationOneReasonsMax = 10;

export const getWebSignalDigestResponseItemsItemTenderRecommendationOneDisqualifiersMax = 20;



export const getWebSignalDigestResponse = zod.object({
  "days": zod.int(),
  "total": zod.int(),
  "pending": zod.int(),
  "confirmed": zod.int(),
  "byType": zod.record(zod.string(), zod.int()),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "companyName": zod.string().nullable(),
  "discoverySourceId": zod.uuid().nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "recipeId": zod.uuid().nullish(),
  "discoveryRunId": zod.uuid().nullish(),
  "candidateKey": zod.string().nullish(),
  "discoveryKind": zod.enum(['tender', 'project', 'potential_customer', 'buying_signal', 'other']).nullish(),
  "opportunityTitle": zod.string().nullish(),
  "organizationName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "fitScore": zod.number().min(getWebSignalDigestResponseItemsItemFitScoreMin).max(getWebSignalDigestResponseItemsItemFitScoreMax).nullish(),
  "fitReasons": zod.array(zod.string()).optional(),
  "unknowns": zod.array(zod.string()).optional(),
  "extractedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "editedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "reviewStatus": zod.enum(['unreviewed', 'accepted', 'dismissed', 'deferred', 'duplicate', 'promoted', 'changed']).optional(),
  "reviewRevision": zod.int().min(1).optional(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "duplicateCandidateId": zod.uuid().nullish(),
  "latestEvidenceRevision": zod.int().min(1).nullish(),
  "observedDeadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastMaterialChangeAt": zod.iso.datetime({"offset":true}).nullish(),
  "type": zod.enum(['hiring_surge', 'funding_budget', 'expansion', 'leadership_change', 'technology_adoption', 'explicit_need', 'other']),
  "confidence": zod.number().min(getWebSignalDigestResponseItemsItemConfidenceMin).max(getWebSignalDigestResponseItemsItemConfidenceMax),
  "rationale": zod.string(),
  "targetMarketSimilarity": zod.number().min(getWebSignalDigestResponseItemsItemTargetMarketSimilarityMin).max(getWebSignalDigestResponseItemsItemTargetMarketSimilarityMax).nullish(),
  "status": zod.enum(['pending', 'confirmed', 'dismissed']),
  "sourceUrl": zod.url(),
  "sourceTitle": zod.string(),
  "fetchedAt": zod.iso.datetime({"offset":true}),
  "signalId": zod.uuid().nullable(),
  "accountMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "opportunityMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "reviewedBy": zod.string().nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "industry": zod.string().nullish().describe('Industry suggested by AI or set by a reviewer'),
  "industrySource": zod.enum(['ai', 'human']).nullish(),
  "jobId": zod.uuid().nullish().describe('Job that found this candidate'),
  "decision": zod.enum(['pursue', 'not_pursuing']).nullish(),
  "tenderRecommendation": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "reasons": zod.array(zod.string()).max(getWebSignalDigestResponseItemsItemTenderRecommendationOneReasonsMax),
  "disqualifiers": zod.array(zod.string()).max(getWebSignalDigestResponseItemsItemTenderRecommendationOneDisqualifiersMax),
  "confidence": zod.enum(['high', 'medium', 'low']).nullable()
}),zod.null()]).optional().describe('Bid recommendation of the tender opportunity created from this candidate (tender portal candidates only).')
}))
})


export const listAccountWebSignalsParams = zod.object({
  "accountId": zod.uuid()
})

export const listAccountWebSignalsResponseItemsItemFitScoreMin = 0;
export const listAccountWebSignalsResponseItemsItemFitScoreMax = 100;



export const listAccountWebSignalsResponseItemsItemConfidenceMin = 0;
export const listAccountWebSignalsResponseItemsItemConfidenceMax = 1;

export const listAccountWebSignalsResponseItemsItemTargetMarketSimilarityMin = -1;
export const listAccountWebSignalsResponseItemsItemTargetMarketSimilarityMax = 1;

export const listAccountWebSignalsResponseItemsItemTenderRecommendationOneReasonsMax = 10;

export const listAccountWebSignalsResponseItemsItemTenderRecommendationOneDisqualifiersMax = 20;



export const listAccountWebSignalsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "companyName": zod.string().nullable(),
  "discoverySourceId": zod.uuid().nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "recipeId": zod.uuid().nullish(),
  "discoveryRunId": zod.uuid().nullish(),
  "candidateKey": zod.string().nullish(),
  "discoveryKind": zod.enum(['tender', 'project', 'potential_customer', 'buying_signal', 'other']).nullish(),
  "opportunityTitle": zod.string().nullish(),
  "organizationName": zod.string().nullish(),
  "sourceReference": zod.string().nullish(),
  "fitScore": zod.number().min(listAccountWebSignalsResponseItemsItemFitScoreMin).max(listAccountWebSignalsResponseItemsItemFitScoreMax).nullish(),
  "fitReasons": zod.array(zod.string()).optional(),
  "unknowns": zod.array(zod.string()).optional(),
  "extractedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "editedFields": zod.record(zod.string(), zod.unknown()).optional(),
  "reviewStatus": zod.enum(['unreviewed', 'accepted', 'dismissed', 'deferred', 'duplicate', 'promoted', 'changed']).optional(),
  "reviewRevision": zod.int().min(1).optional(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "duplicateCandidateId": zod.uuid().nullish(),
  "latestEvidenceRevision": zod.int().min(1).nullish(),
  "observedDeadlineAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastMaterialChangeAt": zod.iso.datetime({"offset":true}).nullish(),
  "type": zod.enum(['hiring_surge', 'funding_budget', 'expansion', 'leadership_change', 'technology_adoption', 'explicit_need', 'other']),
  "confidence": zod.number().min(listAccountWebSignalsResponseItemsItemConfidenceMin).max(listAccountWebSignalsResponseItemsItemConfidenceMax),
  "rationale": zod.string(),
  "targetMarketSimilarity": zod.number().min(listAccountWebSignalsResponseItemsItemTargetMarketSimilarityMin).max(listAccountWebSignalsResponseItemsItemTargetMarketSimilarityMax).nullish(),
  "status": zod.enum(['pending', 'confirmed', 'dismissed']),
  "sourceUrl": zod.url(),
  "sourceTitle": zod.string(),
  "fetchedAt": zod.iso.datetime({"offset":true}),
  "signalId": zod.uuid().nullable(),
  "accountMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "opportunityMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "reviewedBy": zod.string().nullish(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "industry": zod.string().nullish().describe('Industry suggested by AI or set by a reviewer'),
  "industrySource": zod.enum(['ai', 'human']).nullish(),
  "jobId": zod.uuid().nullish().describe('Job that found this candidate'),
  "decision": zod.enum(['pursue', 'not_pursuing']).nullish(),
  "tenderRecommendation": zod.union([zod.object({
  "opportunityId": zod.uuid(),
  "recommendation": zod.union([zod.enum(['respond', 'maybe', 'not_for_us']),zod.null()]),
  "rankingMethod": zod.union([zod.enum(['prefilter', 'ai', 'keyword']),zod.null()]),
  "matchBand": zod.union([zod.enum(['strong', 'possible', 'low']),zod.null()]),
  "reasons": zod.array(zod.string()).max(listAccountWebSignalsResponseItemsItemTenderRecommendationOneReasonsMax),
  "disqualifiers": zod.array(zod.string()).max(listAccountWebSignalsResponseItemsItemTenderRecommendationOneDisqualifiersMax),
  "confidence": zod.enum(['high', 'medium', 'low']).nullable()
}),zod.null()]).optional().describe('Bid recommendation of the tender opportunity created from this candidate (tender portal candidates only).')
}))
})


/**
 * @summary List versioned discovery targeting profiles
 */
export const listWebDiscoveryTargetingProfilesQueryLimitDefault = 25;
export const listWebDiscoveryTargetingProfilesQueryLimitMax = 100;

export const listWebDiscoveryTargetingProfilesQueryOffsetDefault = 0;
export const listWebDiscoveryTargetingProfilesQueryOffsetMin = 0;



export const listWebDiscoveryTargetingProfilesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWebDiscoveryTargetingProfilesQueryLimitMax).default(listWebDiscoveryTargetingProfilesQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoveryTargetingProfilesQueryOffsetMin).default(listWebDiscoveryTargetingProfilesQueryOffsetDefault)
})



export const listWebDiscoveryTargetingProfilesResponseItemsItemCustomerProfilesItemLabelMax = 160;

export const listWebDiscoveryTargetingProfilesResponseItemsItemCustomerProfilesItemDescriptionMax = 1200;

export const listWebDiscoveryTargetingProfilesResponseItemsItemCustomerProfilesItemCharacteristicsItemMax = 240;

export const listWebDiscoveryTargetingProfilesResponseItemsItemCustomerProfilesItemCharacteristicsMax = 20;

export const listWebDiscoveryTargetingProfilesResponseItemsItemQualificationCriteriaItemKeyRegExp = new RegExp('^[a-z][a-z0-9_]{1,63}$');
export const listWebDiscoveryTargetingProfilesResponseItemsItemQualificationCriteriaItemLabelMax = 160;

export const listWebDiscoveryTargetingProfilesResponseItemsItemQualificationCriteriaItemDescriptionMax = 1200;

export const listWebDiscoveryTargetingProfilesResponseItemsItemEvidenceSummaryItemIdMax = 200;

export const listWebDiscoveryTargetingProfilesResponseItemsItemEvidenceSummaryItemLabelMax = 300;

export const listWebDiscoveryTargetingProfilesResponseItemsItemEvidenceSummaryItemRevisionMax = 200;

export const listWebDiscoveryTargetingProfilesResponseTotalMin = 0;


export const listWebDiscoveryTargetingProfilesResponseOffsetMin = 0;



export const listWebDiscoveryTargetingProfilesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "revision": zod.int().min(1),
  "status": zod.enum(['draft', 'confirmed', 'superseded', 'withdrawn']),
  "name": zod.string(),
  "markets": zod.array(zod.string()),
  "customerProfiles": zod.array(zod.object({
  "label": zod.string().min(1).max(listWebDiscoveryTargetingProfilesResponseItemsItemCustomerProfilesItemLabelMax),
  "description": zod.string().min(1).max(listWebDiscoveryTargetingProfilesResponseItemsItemCustomerProfilesItemDescriptionMax),
  "characteristics": zod.array(zod.string().min(1).max(listWebDiscoveryTargetingProfilesResponseItemsItemCustomerProfilesItemCharacteristicsItemMax)).max(listWebDiscoveryTargetingProfilesResponseItemsItemCustomerProfilesItemCharacteristicsMax)
})),
  "geographies": zod.array(zod.string()),
  "exclusions": zod.array(zod.string()),
  "qualificationCriteria": zod.array(zod.object({
  "key": zod.string().regex(listWebDiscoveryTargetingProfilesResponseItemsItemQualificationCriteriaItemKeyRegExp),
  "label": zod.string().min(1).max(listWebDiscoveryTargetingProfilesResponseItemsItemQualificationCriteriaItemLabelMax),
  "description": zod.string().min(1).max(listWebDiscoveryTargetingProfilesResponseItemsItemQualificationCriteriaItemDescriptionMax),
  "required": zod.boolean()
})),
  "evidenceSummary": zod.array(zod.object({
  "id": zod.string().min(1).max(listWebDiscoveryTargetingProfilesResponseItemsItemEvidenceSummaryItemIdMax),
  "kind": zod.enum(['product', 'service', 'capability', 'account_history', 'opportunity_history', 'outcome_history', 'public_web']),
  "label": zod.string().min(1).max(listWebDiscoveryTargetingProfilesResponseItemsItemEvidenceSummaryItemLabelMax),
  "facts": zod.record(zod.string(), zod.unknown()),
  "revision": zod.string().min(1).max(listWebDiscoveryTargetingProfilesResponseItemsItemEvidenceSummaryItemRevisionMax),
  "observedAt": zod.iso.datetime({"offset":true}),
  "url": zod.url().nullish()
})),
  "rationale": zod.string(),
  "evidenceFingerprint": zod.string(),
  "auditId": zod.uuid().nullable(),
  "createdBy": zod.string(),
  "confirmedBy": zod.string().nullable(),
  "confirmedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listWebDiscoveryTargetingProfilesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoveryTargetingProfilesResponseOffsetMin)
})


/**
 * Creates a review-only draft. It never confirms targeting, enables a source, creates CRM records, or starts outreach.
 * @summary Generate an evidence-grounded targeting draft and optional public suggestions
 */
export const createWebDiscoveryTargetingProposalBodyNameMax = 200;

export const createWebDiscoveryTargetingProposalBodyFeedbackMax = 2000;

export const createWebDiscoveryTargetingProposalBodyPublicCriteriaMarketsItemMax = 160;

export const createWebDiscoveryTargetingProposalBodyPublicCriteriaMarketsMax = 20;

export const createWebDiscoveryTargetingProposalBodyPublicCriteriaGeographiesItemMax = 160;

export const createWebDiscoveryTargetingProposalBodyPublicCriteriaGeographiesMax = 20;

export const createWebDiscoveryTargetingProposalBodyPublicCriteriaOpportunityTypesItemMax = 160;

export const createWebDiscoveryTargetingProposalBodyPublicCriteriaOpportunityTypesMax = 20;

export const createWebDiscoveryTargetingProposalBodyIncludePublicSuggestionsDefault = true;

export const createWebDiscoveryTargetingProposalBody = zod.object({
  "requestId": zod.uuid(),
  "name": zod.string().min(1).max(createWebDiscoveryTargetingProposalBodyNameMax).optional(),
  "baseProfileId": zod.uuid().nullish(),
  "feedback": zod.string().min(1).max(createWebDiscoveryTargetingProposalBodyFeedbackMax).optional(),
  "publicCriteria": zod.object({
  "markets": zod.array(zod.string().min(1).max(createWebDiscoveryTargetingProposalBodyPublicCriteriaMarketsItemMax)).max(createWebDiscoveryTargetingProposalBodyPublicCriteriaMarketsMax).optional(),
  "geographies": zod.array(zod.string().min(1).max(createWebDiscoveryTargetingProposalBodyPublicCriteriaGeographiesItemMax)).max(createWebDiscoveryTargetingProposalBodyPublicCriteriaGeographiesMax).optional(),
  "opportunityTypes": zod.array(zod.string().min(1).max(createWebDiscoveryTargetingProposalBodyPublicCriteriaOpportunityTypesItemMax)).max(createWebDiscoveryTargetingProposalBodyPublicCriteriaOpportunityTypesMax).optional()
}).optional(),
  "includePublicSuggestions": zod.boolean().default(createWebDiscoveryTargetingProposalBodyIncludePublicSuggestionsDefault)
})



export const createWebDiscoveryTargetingProposalResponseProfileCustomerProfilesItemLabelMax = 160;

export const createWebDiscoveryTargetingProposalResponseProfileCustomerProfilesItemDescriptionMax = 1200;

export const createWebDiscoveryTargetingProposalResponseProfileCustomerProfilesItemCharacteristicsItemMax = 240;

export const createWebDiscoveryTargetingProposalResponseProfileCustomerProfilesItemCharacteristicsMax = 20;

export const createWebDiscoveryTargetingProposalResponseProfileQualificationCriteriaItemKeyRegExp = new RegExp('^[a-z][a-z0-9_]{1,63}$');
export const createWebDiscoveryTargetingProposalResponseProfileQualificationCriteriaItemLabelMax = 160;

export const createWebDiscoveryTargetingProposalResponseProfileQualificationCriteriaItemDescriptionMax = 1200;

export const createWebDiscoveryTargetingProposalResponseProfileEvidenceSummaryItemIdMax = 200;

export const createWebDiscoveryTargetingProposalResponseProfileEvidenceSummaryItemLabelMax = 300;

export const createWebDiscoveryTargetingProposalResponseProfileEvidenceSummaryItemRevisionMax = 200;

export const createWebDiscoveryTargetingProposalResponseMissingInputsItemMax = 300;

export const createWebDiscoveryTargetingProposalResponseMissingInputsMax = 20;

export const createWebDiscoveryTargetingProposalResponseEvidenceItemIdMax = 200;

export const createWebDiscoveryTargetingProposalResponseEvidenceItemLabelMax = 300;

export const createWebDiscoveryTargetingProposalResponseEvidenceItemRevisionMax = 200;

export const createWebDiscoveryTargetingProposalResponseEvidenceMax = 200;

export const createWebDiscoveryTargetingProposalResponseSourceSuggestionsItemNameMax = 240;

export const createWebDiscoveryTargetingProposalResponseSourceSuggestionsItemRationaleMax = 2000;

export const createWebDiscoveryTargetingProposalResponseSourceSuggestionsItemEvidenceIdsMax = 10;

export const createWebDiscoveryTargetingProposalResponseSourceSuggestionsMax = 25;

export const createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemNameMax = 240;

export const createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemMarketMax = 240;

export const createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemRationaleMax = 2000;

export const createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemObservedFactsItemMax = 500;

export const createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemObservedFactsMax = 20;

export const createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemUncertaintyItemMax = 500;

export const createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemUncertaintyMax = 20;

export const createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemEvidenceIdsMax = 10;

export const createWebDiscoveryTargetingProposalResponseCustomerSuggestionsMax = 50;

export const createWebDiscoveryTargetingProposalResponseSearchMessageMax = 1000;

export const createWebDiscoveryTargetingProposalResponseSearchQueriesItemMax = 240;

export const createWebDiscoveryTargetingProposalResponseSearchQueriesMax = 3;



export const createWebDiscoveryTargetingProposalResponse = zod.object({
  "profile": zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "revision": zod.int().min(1),
  "status": zod.enum(['draft', 'confirmed', 'superseded', 'withdrawn']),
  "name": zod.string(),
  "markets": zod.array(zod.string()),
  "customerProfiles": zod.array(zod.object({
  "label": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseProfileCustomerProfilesItemLabelMax),
  "description": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseProfileCustomerProfilesItemDescriptionMax),
  "characteristics": zod.array(zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseProfileCustomerProfilesItemCharacteristicsItemMax)).max(createWebDiscoveryTargetingProposalResponseProfileCustomerProfilesItemCharacteristicsMax)
})),
  "geographies": zod.array(zod.string()),
  "exclusions": zod.array(zod.string()),
  "qualificationCriteria": zod.array(zod.object({
  "key": zod.string().regex(createWebDiscoveryTargetingProposalResponseProfileQualificationCriteriaItemKeyRegExp),
  "label": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseProfileQualificationCriteriaItemLabelMax),
  "description": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseProfileQualificationCriteriaItemDescriptionMax),
  "required": zod.boolean()
})),
  "evidenceSummary": zod.array(zod.object({
  "id": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseProfileEvidenceSummaryItemIdMax),
  "kind": zod.enum(['product', 'service', 'capability', 'account_history', 'opportunity_history', 'outcome_history', 'public_web']),
  "label": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseProfileEvidenceSummaryItemLabelMax),
  "facts": zod.record(zod.string(), zod.unknown()),
  "revision": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseProfileEvidenceSummaryItemRevisionMax),
  "observedAt": zod.iso.datetime({"offset":true}),
  "url": zod.url().nullish()
})),
  "rationale": zod.string(),
  "evidenceFingerprint": zod.string(),
  "auditId": zod.uuid().nullable(),
  "createdBy": zod.string(),
  "confirmedBy": zod.string().nullable(),
  "confirmedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "missingInputs": zod.array(zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseMissingInputsItemMax)).max(createWebDiscoveryTargetingProposalResponseMissingInputsMax),
  "evidence": zod.array(zod.object({
  "id": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseEvidenceItemIdMax),
  "kind": zod.enum(['product', 'service', 'capability', 'account_history', 'opportunity_history', 'outcome_history', 'public_web']),
  "label": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseEvidenceItemLabelMax),
  "facts": zod.record(zod.string(), zod.unknown()),
  "revision": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseEvidenceItemRevisionMax),
  "observedAt": zod.iso.datetime({"offset":true}),
  "url": zod.url().nullish()
})).max(createWebDiscoveryTargetingProposalResponseEvidenceMax),
  "sourceSuggestions": zod.array(zod.object({
  "name": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseSourceSuggestionsItemNameMax),
  "url": zod.url(),
  "rationale": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseSourceSuggestionsItemRationaleMax),
  "evidenceIds": zod.array(zod.string()).min(1).max(createWebDiscoveryTargetingProposalResponseSourceSuggestionsItemEvidenceIdsMax),
  "verification": zod.enum(['unverified'])
})).max(createWebDiscoveryTargetingProposalResponseSourceSuggestionsMax),
  "customerSuggestions": zod.array(zod.object({
  "name": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemNameMax),
  "website": zod.url().nullable(),
  "market": zod.string().max(createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemMarketMax).nullable(),
  "rationale": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemRationaleMax),
  "observedFacts": zod.array(zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemObservedFactsItemMax)).max(createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemObservedFactsMax),
  "uncertainty": zod.array(zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemUncertaintyItemMax)).max(createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemUncertaintyMax),
  "evidenceIds": zod.array(zod.string()).min(1).max(createWebDiscoveryTargetingProposalResponseCustomerSuggestionsItemEvidenceIdsMax),
  "verification": zod.enum(['unverified'])
})).max(createWebDiscoveryTargetingProposalResponseCustomerSuggestionsMax),
  "search": zod.object({
  "state": zod.enum(['disabled', 'approval_required', 'misconfigured', 'quota_exhausted', 'timeout', 'failed', 'ready']),
  "ready": zod.boolean(),
  "message": zod.string().min(1).max(createWebDiscoveryTargetingProposalResponseSearchMessageMax),
  "queries": zod.array(zod.string().max(createWebDiscoveryTargetingProposalResponseSearchQueriesItemMax)).max(createWebDiscoveryTargetingProposalResponseSearchQueriesMax)
})
})


/**
 * @summary Edit one unconfirmed targeting profile revision
 */
export const updateWebDiscoveryTargetingProfileParams = zod.object({
  "profileId": zod.uuid()
})


export const updateWebDiscoveryTargetingProfileBodyNameMax = 200;

export const updateWebDiscoveryTargetingProfileBodyMarketsItemMax = 160;

export const updateWebDiscoveryTargetingProfileBodyMarketsMax = 50;

export const updateWebDiscoveryTargetingProfileBodyCustomerProfilesItemLabelMax = 160;

export const updateWebDiscoveryTargetingProfileBodyCustomerProfilesItemDescriptionMax = 1200;

export const updateWebDiscoveryTargetingProfileBodyCustomerProfilesItemCharacteristicsItemMax = 240;

export const updateWebDiscoveryTargetingProfileBodyCustomerProfilesItemCharacteristicsMax = 20;

export const updateWebDiscoveryTargetingProfileBodyCustomerProfilesMax = 30;

export const updateWebDiscoveryTargetingProfileBodyGeographiesItemMax = 160;

export const updateWebDiscoveryTargetingProfileBodyGeographiesMax = 50;

export const updateWebDiscoveryTargetingProfileBodyExclusionsItemMax = 500;

export const updateWebDiscoveryTargetingProfileBodyExclusionsMax = 50;

export const updateWebDiscoveryTargetingProfileBodyQualificationCriteriaItemKeyRegExp = new RegExp('^[a-z][a-z0-9_]{1,63}$');
export const updateWebDiscoveryTargetingProfileBodyQualificationCriteriaItemLabelMax = 160;

export const updateWebDiscoveryTargetingProfileBodyQualificationCriteriaItemDescriptionMax = 1200;

export const updateWebDiscoveryTargetingProfileBodyQualificationCriteriaMax = 50;

export const updateWebDiscoveryTargetingProfileBodyRationaleMax = 8000;



export const updateWebDiscoveryTargetingProfileBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "name": zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyNameMax).optional(),
  "markets": zod.array(zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyMarketsItemMax)).max(updateWebDiscoveryTargetingProfileBodyMarketsMax).optional(),
  "customerProfiles": zod.array(zod.object({
  "label": zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyCustomerProfilesItemLabelMax),
  "description": zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyCustomerProfilesItemDescriptionMax),
  "characteristics": zod.array(zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyCustomerProfilesItemCharacteristicsItemMax)).max(updateWebDiscoveryTargetingProfileBodyCustomerProfilesItemCharacteristicsMax)
})).max(updateWebDiscoveryTargetingProfileBodyCustomerProfilesMax).optional(),
  "geographies": zod.array(zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyGeographiesItemMax)).max(updateWebDiscoveryTargetingProfileBodyGeographiesMax).optional(),
  "exclusions": zod.array(zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyExclusionsItemMax)).max(updateWebDiscoveryTargetingProfileBodyExclusionsMax).optional(),
  "qualificationCriteria": zod.array(zod.object({
  "key": zod.string().regex(updateWebDiscoveryTargetingProfileBodyQualificationCriteriaItemKeyRegExp),
  "label": zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyQualificationCriteriaItemLabelMax),
  "description": zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyQualificationCriteriaItemDescriptionMax),
  "required": zod.boolean()
})).max(updateWebDiscoveryTargetingProfileBodyQualificationCriteriaMax).optional(),
  "rationale": zod.string().min(1).max(updateWebDiscoveryTargetingProfileBodyRationaleMax).optional()
})



export const updateWebDiscoveryTargetingProfileResponseCustomerProfilesItemLabelMax = 160;

export const updateWebDiscoveryTargetingProfileResponseCustomerProfilesItemDescriptionMax = 1200;

export const updateWebDiscoveryTargetingProfileResponseCustomerProfilesItemCharacteristicsItemMax = 240;

export const updateWebDiscoveryTargetingProfileResponseCustomerProfilesItemCharacteristicsMax = 20;

export const updateWebDiscoveryTargetingProfileResponseQualificationCriteriaItemKeyRegExp = new RegExp('^[a-z][a-z0-9_]{1,63}$');
export const updateWebDiscoveryTargetingProfileResponseQualificationCriteriaItemLabelMax = 160;

export const updateWebDiscoveryTargetingProfileResponseQualificationCriteriaItemDescriptionMax = 1200;

export const updateWebDiscoveryTargetingProfileResponseEvidenceSummaryItemIdMax = 200;

export const updateWebDiscoveryTargetingProfileResponseEvidenceSummaryItemLabelMax = 300;

export const updateWebDiscoveryTargetingProfileResponseEvidenceSummaryItemRevisionMax = 200;



export const updateWebDiscoveryTargetingProfileResponse = zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "revision": zod.int().min(1),
  "status": zod.enum(['draft', 'confirmed', 'superseded', 'withdrawn']),
  "name": zod.string(),
  "markets": zod.array(zod.string()),
  "customerProfiles": zod.array(zod.object({
  "label": zod.string().min(1).max(updateWebDiscoveryTargetingProfileResponseCustomerProfilesItemLabelMax),
  "description": zod.string().min(1).max(updateWebDiscoveryTargetingProfileResponseCustomerProfilesItemDescriptionMax),
  "characteristics": zod.array(zod.string().min(1).max(updateWebDiscoveryTargetingProfileResponseCustomerProfilesItemCharacteristicsItemMax)).max(updateWebDiscoveryTargetingProfileResponseCustomerProfilesItemCharacteristicsMax)
})),
  "geographies": zod.array(zod.string()),
  "exclusions": zod.array(zod.string()),
  "qualificationCriteria": zod.array(zod.object({
  "key": zod.string().regex(updateWebDiscoveryTargetingProfileResponseQualificationCriteriaItemKeyRegExp),
  "label": zod.string().min(1).max(updateWebDiscoveryTargetingProfileResponseQualificationCriteriaItemLabelMax),
  "description": zod.string().min(1).max(updateWebDiscoveryTargetingProfileResponseQualificationCriteriaItemDescriptionMax),
  "required": zod.boolean()
})),
  "evidenceSummary": zod.array(zod.object({
  "id": zod.string().min(1).max(updateWebDiscoveryTargetingProfileResponseEvidenceSummaryItemIdMax),
  "kind": zod.enum(['product', 'service', 'capability', 'account_history', 'opportunity_history', 'outcome_history', 'public_web']),
  "label": zod.string().min(1).max(updateWebDiscoveryTargetingProfileResponseEvidenceSummaryItemLabelMax),
  "facts": zod.record(zod.string(), zod.unknown()),
  "revision": zod.string().min(1).max(updateWebDiscoveryTargetingProfileResponseEvidenceSummaryItemRevisionMax),
  "observedAt": zod.iso.datetime({"offset":true}),
  "url": zod.url().nullish()
})),
  "rationale": zod.string(),
  "evidenceFingerprint": zod.string(),
  "auditId": zod.uuid().nullable(),
  "createdBy": zod.string(),
  "confirmedBy": zod.string().nullable(),
  "confirmedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Confirm one exact targeting profile revision
 */
export const confirmWebDiscoveryTargetingProfileParams = zod.object({
  "profileId": zod.uuid()
})




export const confirmWebDiscoveryTargetingProfileBody = zod.object({
  "expectedRevision": zod.int().min(1)
})



export const confirmWebDiscoveryTargetingProfileResponseCustomerProfilesItemLabelMax = 160;

export const confirmWebDiscoveryTargetingProfileResponseCustomerProfilesItemDescriptionMax = 1200;

export const confirmWebDiscoveryTargetingProfileResponseCustomerProfilesItemCharacteristicsItemMax = 240;

export const confirmWebDiscoveryTargetingProfileResponseCustomerProfilesItemCharacteristicsMax = 20;

export const confirmWebDiscoveryTargetingProfileResponseQualificationCriteriaItemKeyRegExp = new RegExp('^[a-z][a-z0-9_]{1,63}$');
export const confirmWebDiscoveryTargetingProfileResponseQualificationCriteriaItemLabelMax = 160;

export const confirmWebDiscoveryTargetingProfileResponseQualificationCriteriaItemDescriptionMax = 1200;

export const confirmWebDiscoveryTargetingProfileResponseEvidenceSummaryItemIdMax = 200;

export const confirmWebDiscoveryTargetingProfileResponseEvidenceSummaryItemLabelMax = 300;

export const confirmWebDiscoveryTargetingProfileResponseEvidenceSummaryItemRevisionMax = 200;



export const confirmWebDiscoveryTargetingProfileResponse = zod.object({
  "id": zod.uuid(),
  "version": zod.int().min(1),
  "revision": zod.int().min(1),
  "status": zod.enum(['draft', 'confirmed', 'superseded', 'withdrawn']),
  "name": zod.string(),
  "markets": zod.array(zod.string()),
  "customerProfiles": zod.array(zod.object({
  "label": zod.string().min(1).max(confirmWebDiscoveryTargetingProfileResponseCustomerProfilesItemLabelMax),
  "description": zod.string().min(1).max(confirmWebDiscoveryTargetingProfileResponseCustomerProfilesItemDescriptionMax),
  "characteristics": zod.array(zod.string().min(1).max(confirmWebDiscoveryTargetingProfileResponseCustomerProfilesItemCharacteristicsItemMax)).max(confirmWebDiscoveryTargetingProfileResponseCustomerProfilesItemCharacteristicsMax)
})),
  "geographies": zod.array(zod.string()),
  "exclusions": zod.array(zod.string()),
  "qualificationCriteria": zod.array(zod.object({
  "key": zod.string().regex(confirmWebDiscoveryTargetingProfileResponseQualificationCriteriaItemKeyRegExp),
  "label": zod.string().min(1).max(confirmWebDiscoveryTargetingProfileResponseQualificationCriteriaItemLabelMax),
  "description": zod.string().min(1).max(confirmWebDiscoveryTargetingProfileResponseQualificationCriteriaItemDescriptionMax),
  "required": zod.boolean()
})),
  "evidenceSummary": zod.array(zod.object({
  "id": zod.string().min(1).max(confirmWebDiscoveryTargetingProfileResponseEvidenceSummaryItemIdMax),
  "kind": zod.enum(['product', 'service', 'capability', 'account_history', 'opportunity_history', 'outcome_history', 'public_web']),
  "label": zod.string().min(1).max(confirmWebDiscoveryTargetingProfileResponseEvidenceSummaryItemLabelMax),
  "facts": zod.record(zod.string(), zod.unknown()),
  "revision": zod.string().min(1).max(confirmWebDiscoveryTargetingProfileResponseEvidenceSummaryItemRevisionMax),
  "observedAt": zod.iso.datetime({"offset":true}),
  "url": zod.url().nullish()
})),
  "rationale": zod.string(),
  "evidenceFingerprint": zod.string(),
  "auditId": zod.uuid().nullable(),
  "createdBy": zod.string(),
  "confirmedBy": zod.string().nullable(),
  "confirmedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List configured discovery sources without protected session references
 */
export const listWebDiscoverySourcesQueryLimitDefault = 25;
export const listWebDiscoverySourcesQueryLimitMax = 100;

export const listWebDiscoverySourcesQueryOffsetDefault = 0;
export const listWebDiscoverySourcesQueryOffsetMin = 0;



export const listWebDiscoverySourcesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWebDiscoverySourcesQueryLimitMax).default(listWebDiscoverySourcesQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoverySourcesQueryOffsetMin).default(listWebDiscoverySourcesQueryOffsetDefault)
})

export const listWebDiscoverySourcesResponseItemsItemGovernmentOneAdministeringBodyMax = 500;

export const listWebDiscoverySourcesResponseItemsItemGovernmentOneLocalJurisdictionOneIdMax = 100;


export const listWebDiscoverySourcesResponseItemsItemGovernmentOneLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const listWebDiscoverySourcesResponseItemsItemGovernmentOneLocalJurisdictionOneNameMax = 200;

export const listWebDiscoverySourcesResponseItemsItemGovernmentOneCategoriesMax = 8;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneCodeMax = 120;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneDetailMax = 2000;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneListingsFoundMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneFilteredOutMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneCreatedMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneUpdatedMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneUnchangedMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneSkippedMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneDocumentsAddedMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneDetailFailuresMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneRequestsMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneBytesMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthOpenTendersMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthConsecutiveFailuresMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthHistoryItemListingsFoundMin = 0;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthHistoryItemCodeMax = 120;

export const listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthHistoryMax = 10;

export const listWebDiscoverySourcesResponseItemsItemCadenceMinutesMin = 5;

export const listWebDiscoverySourcesResponseItemsItemMaxPagesPerRunMax = 1000;



export const listWebDiscoverySourcesResponseTotalMin = 0;


export const listWebDiscoverySourcesResponseOffsetMin = 0;



export const listWebDiscoverySourcesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKey": zod.string(),
  "government": zod.union([zod.object({
  "administeringBody": zod.string().min(1).max(listWebDiscoverySourcesResponseItemsItemGovernmentOneAdministeringBodyMax),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(listWebDiscoverySourcesResponseItemsItemGovernmentOneLocalJurisdictionOneIdMax).regex(listWebDiscoverySourcesResponseItemsItemGovernmentOneLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(listWebDiscoverySourcesResponseItemsItemGovernmentOneLocalJurisdictionOneNameMax)
}),zod.null()]),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).min(1).max(listWebDiscoverySourcesResponseItemsItemGovernmentOneCategoriesMax)
}),zod.null()]).optional(),
  "name": zod.string(),
  "sourceType": zod.enum(['public', 'signed_in', 'feed']),
  "category": zod.enum(['general', 'government', 'tender']).optional().describe('Tender sources run a built-in portal connector and need no recipe or targeting profile.'),
  "connectorKey": zod.string().nullish(),
  "jurisdictionFilter": zod.array(zod.string()).optional(),
  "keywordFilter": zod.array(zod.string()).optional(),
  "lastScanSummary": zod.union([zod.object({
  "status": zod.enum(['completed', 'partial', 'failed', 'blocked']),
  "code": zod.string().max(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneCodeMax),
  "detail": zod.string().max(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneDetailMax),
  "trigger": zod.enum(['scheduled', 'manual']),
  "startedAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}),
  "listingsFound": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneListingsFoundMin),
  "filteredOut": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneFilteredOutMin),
  "created": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneCreatedMin),
  "updated": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneUpdatedMin),
  "unchanged": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneUnchangedMin),
  "skipped": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneSkippedMin),
  "documentsAdded": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneDocumentsAddedMin),
  "detailFailures": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneDetailFailuresMin),
  "requests": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneRequestsMin),
  "bytes": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneBytesMin),
  "health": zod.object({
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']).describe('ok: tenders read; empty: the portal listed none; page_changed: the page or feed no longer matches how it is read; blocked: the portal refused, needs sign-in or a browser; error: temporary failure.'),
  "openTenders": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthOpenTendersMin).describe('Open tender opportunities currently held from this portal.'),
  "consecutiveFailures": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthConsecutiveFailuresMin),
  "needsAttention": zod.boolean().describe('True after repeated failed scans.'),
  "lastSuccessAt": zod.iso.datetime({"offset":true}).nullable(),
  "history": zod.array(zod.object({
  "completedAt": zod.iso.datetime({"offset":true}),
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']),
  "listingsFound": zod.int().min(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthHistoryItemListingsFoundMin),
  "code": zod.string().max(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthHistoryItemCodeMax)
})).max(listWebDiscoverySourcesResponseItemsItemLastScanSummaryOneHealthHistoryMax).describe('Most recent scans first.')
}).optional().describe('Portal health after the most recent scan. Absent on summaries recorded before health tracking.')
}).describe('Result of the most recent tender portal scan.'),zod.null()]).optional(),
  "baseUrl": zod.url(),
  "status": zod.enum(['inactive', 'active', 'paused', 'revoked']),
  "readiness": zod.enum(['unconfigured', 'ready', 'sign_in_required', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "sessionStatus": zod.enum(['none', 'available', 'renewal_required', 'revoked', 'expired']),
  "targetingProfileId": zod.uuid().nullable(),
  "allowedHosts": zod.array(zod.string()),
  "allowedPaths": zod.array(zod.string()),
  "excludedPaths": zod.array(zod.string()),
  "extractionFields": zod.array(zod.string()),
  "cadenceMinutes": zod.int().min(listWebDiscoverySourcesResponseItemsItemCadenceMinutesMin),
  "maxPagesPerRun": zod.int().min(1).max(listWebDiscoverySourcesResponseItemsItemMaxPagesPerRunMax),
  "maxBytesPerRun": zod.int().min(1),
  "revision": zod.int().min(1),
  "configuredBy": zod.string(),
  "readinessCode": zod.string().nullable(),
  "readinessDetail": zod.string().nullable(),
  "readinessCheckedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Public source configuration and lifecycle metadata. Protected browser state references are deliberately excluded.')),
  "total": zod.int().min(listWebDiscoverySourcesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoverySourcesResponseOffsetMin)
})


/**
 * @summary Add an inactive discovery source for staff configuration
 */
export const createWebDiscoverySourceBodySourceKeyMax = 120;


export const createWebDiscoverySourceBodySourceKeyRegExp = new RegExp('^[a-z0-9]+(?:[a-z0-9-]*[a-z0-9])?$');
export const createWebDiscoverySourceBodyGovernmentOneAdministeringBodyMax = 500;

export const createWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneIdMax = 100;


export const createWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const createWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneNameMax = 200;

export const createWebDiscoverySourceBodyGovernmentOneCategoriesMax = 8;

export const createWebDiscoverySourceBodyNameMax = 200;

export const createWebDiscoverySourceBodyBaseUrlMax = 2000;

export const createWebDiscoverySourceBodyAllowedHostsItemMax = 253;

export const createWebDiscoverySourceBodyAllowedHostsMax = 20;

export const createWebDiscoverySourceBodyAllowedPathsItemMax = 500;


export const createWebDiscoverySourceBodyAllowedPathsItemRegExp = new RegExp('^');
export const createWebDiscoverySourceBodyAllowedPathsMax = 50;

export const createWebDiscoverySourceBodyExcludedPathsItemMax = 500;


export const createWebDiscoverySourceBodyExcludedPathsItemRegExp = new RegExp('^');
export const createWebDiscoverySourceBodyExcludedPathsMax = 50;

export const createWebDiscoverySourceBodyExtractionFieldsMax = 20;

export const createWebDiscoverySourceBodyCadenceMinutesMin = 5;
export const createWebDiscoverySourceBodyCadenceMinutesMax = 525600;

export const createWebDiscoverySourceBodyMaxPagesPerRunMax = 1000;

export const createWebDiscoverySourceBodyMaxBytesPerRunMin = 1024;
export const createWebDiscoverySourceBodyMaxBytesPerRunMax = 100000000;



export const createWebDiscoverySourceBody = zod.object({
  "sourceKey": zod.string().min(1).max(createWebDiscoverySourceBodySourceKeyMax).regex(createWebDiscoverySourceBodySourceKeyRegExp),
  "government": zod.union([zod.object({
  "administeringBody": zod.string().min(1).max(createWebDiscoverySourceBodyGovernmentOneAdministeringBodyMax),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(createWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneIdMax).regex(createWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(createWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneNameMax)
}),zod.null()]),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).min(1).max(createWebDiscoverySourceBodyGovernmentOneCategoriesMax)
}),zod.null()]).optional(),
  "name": zod.string().min(1).max(createWebDiscoverySourceBodyNameMax),
  "sourceType": zod.enum(['public', 'signed_in', 'feed']),
  "baseUrl": zod.url().max(createWebDiscoverySourceBodyBaseUrlMax),
  "targetingProfileId": zod.uuid().nullish(),
  "allowedHosts": zod.array(zod.string().min(1).max(createWebDiscoverySourceBodyAllowedHostsItemMax)).min(1).max(createWebDiscoverySourceBodyAllowedHostsMax),
  "allowedPaths": zod.array(zod.string().min(1).max(createWebDiscoverySourceBodyAllowedPathsItemMax).regex(createWebDiscoverySourceBodyAllowedPathsItemRegExp)).min(1).max(createWebDiscoverySourceBodyAllowedPathsMax),
  "excludedPaths": zod.array(zod.string().min(1).max(createWebDiscoverySourceBodyExcludedPathsItemMax).regex(createWebDiscoverySourceBodyExcludedPathsItemRegExp)).max(createWebDiscoverySourceBodyExcludedPathsMax),
  "extractionFields": zod.array(zod.enum(['title', 'summary', 'organization', 'reference', 'location', 'published_at', 'deadline_at', 'value', 'currency', 'contact_name', 'contact_email', 'contact_phone'])).min(1).max(createWebDiscoverySourceBodyExtractionFieldsMax),
  "cadenceMinutes": zod.int().min(createWebDiscoverySourceBodyCadenceMinutesMin).max(createWebDiscoverySourceBodyCadenceMinutesMax),
  "maxPagesPerRun": zod.int().min(1).max(createWebDiscoverySourceBodyMaxPagesPerRunMax),
  "maxBytesPerRun": zod.int().min(createWebDiscoverySourceBodyMaxBytesPerRunMin).max(createWebDiscoverySourceBodyMaxBytesPerRunMax)
})

export const createWebDiscoverySourceResponseGovernmentOneAdministeringBodyMax = 500;

export const createWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneIdMax = 100;


export const createWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const createWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneNameMax = 200;

export const createWebDiscoverySourceResponseGovernmentOneCategoriesMax = 8;

export const createWebDiscoverySourceResponseLastScanSummaryOneCodeMax = 120;

export const createWebDiscoverySourceResponseLastScanSummaryOneDetailMax = 2000;

export const createWebDiscoverySourceResponseLastScanSummaryOneListingsFoundMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneFilteredOutMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneCreatedMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneUpdatedMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneUnchangedMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneSkippedMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneDocumentsAddedMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneDetailFailuresMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneRequestsMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneBytesMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneHealthOpenTendersMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneHealthConsecutiveFailuresMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryItemListingsFoundMin = 0;

export const createWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryItemCodeMax = 120;

export const createWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryMax = 10;

export const createWebDiscoverySourceResponseCadenceMinutesMin = 5;

export const createWebDiscoverySourceResponseMaxPagesPerRunMax = 1000;





export const createWebDiscoverySourceResponse = zod.object({
  "id": zod.uuid(),
  "sourceKey": zod.string(),
  "government": zod.union([zod.object({
  "administeringBody": zod.string().min(1).max(createWebDiscoverySourceResponseGovernmentOneAdministeringBodyMax),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(createWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneIdMax).regex(createWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(createWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneNameMax)
}),zod.null()]),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).min(1).max(createWebDiscoverySourceResponseGovernmentOneCategoriesMax)
}),zod.null()]).optional(),
  "name": zod.string(),
  "sourceType": zod.enum(['public', 'signed_in', 'feed']),
  "category": zod.enum(['general', 'government', 'tender']).optional().describe('Tender sources run a built-in portal connector and need no recipe or targeting profile.'),
  "connectorKey": zod.string().nullish(),
  "jurisdictionFilter": zod.array(zod.string()).optional(),
  "keywordFilter": zod.array(zod.string()).optional(),
  "lastScanSummary": zod.union([zod.object({
  "status": zod.enum(['completed', 'partial', 'failed', 'blocked']),
  "code": zod.string().max(createWebDiscoverySourceResponseLastScanSummaryOneCodeMax),
  "detail": zod.string().max(createWebDiscoverySourceResponseLastScanSummaryOneDetailMax),
  "trigger": zod.enum(['scheduled', 'manual']),
  "startedAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}),
  "listingsFound": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneListingsFoundMin),
  "filteredOut": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneFilteredOutMin),
  "created": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneCreatedMin),
  "updated": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneUpdatedMin),
  "unchanged": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneUnchangedMin),
  "skipped": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneSkippedMin),
  "documentsAdded": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneDocumentsAddedMin),
  "detailFailures": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneDetailFailuresMin),
  "requests": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneRequestsMin),
  "bytes": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneBytesMin),
  "health": zod.object({
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']).describe('ok: tenders read; empty: the portal listed none; page_changed: the page or feed no longer matches how it is read; blocked: the portal refused, needs sign-in or a browser; error: temporary failure.'),
  "openTenders": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneHealthOpenTendersMin).describe('Open tender opportunities currently held from this portal.'),
  "consecutiveFailures": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneHealthConsecutiveFailuresMin),
  "needsAttention": zod.boolean().describe('True after repeated failed scans.'),
  "lastSuccessAt": zod.iso.datetime({"offset":true}).nullable(),
  "history": zod.array(zod.object({
  "completedAt": zod.iso.datetime({"offset":true}),
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']),
  "listingsFound": zod.int().min(createWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryItemListingsFoundMin),
  "code": zod.string().max(createWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryItemCodeMax)
})).max(createWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryMax).describe('Most recent scans first.')
}).optional().describe('Portal health after the most recent scan. Absent on summaries recorded before health tracking.')
}).describe('Result of the most recent tender portal scan.'),zod.null()]).optional(),
  "baseUrl": zod.url(),
  "status": zod.enum(['inactive', 'active', 'paused', 'revoked']),
  "readiness": zod.enum(['unconfigured', 'ready', 'sign_in_required', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "sessionStatus": zod.enum(['none', 'available', 'renewal_required', 'revoked', 'expired']),
  "targetingProfileId": zod.uuid().nullable(),
  "allowedHosts": zod.array(zod.string()),
  "allowedPaths": zod.array(zod.string()),
  "excludedPaths": zod.array(zod.string()),
  "extractionFields": zod.array(zod.string()),
  "cadenceMinutes": zod.int().min(createWebDiscoverySourceResponseCadenceMinutesMin),
  "maxPagesPerRun": zod.int().min(1).max(createWebDiscoverySourceResponseMaxPagesPerRunMax),
  "maxBytesPerRun": zod.int().min(1),
  "revision": zod.int().min(1),
  "configuredBy": zod.string(),
  "readinessCode": zod.string().nullable(),
  "readinessDetail": zod.string().nullable(),
  "readinessCheckedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Public source configuration and lifecycle metadata. Protected browser state references are deliberately excluded.')


/**
 * @summary List built-in tender portals that can be monitored in one click, with any existing source
 */
export const listTenderSourceSuggestionsResponseItemsItemKeyMax = 120;

export const listTenderSourceSuggestionsResponseItemsItemConnectorKeyMax = 80;

export const listTenderSourceSuggestionsResponseItemsItemNameMax = 200;

export const listTenderSourceSuggestionsResponseItemsItemDefaultCadenceMinutesMin = 5;

export const listTenderSourceSuggestionsResponseItemsMax = 50;



export const listTenderSourceSuggestionsResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string().max(listTenderSourceSuggestionsResponseItemsItemKeyMax),
  "connectorKey": zod.string().max(listTenderSourceSuggestionsResponseItemsItemConnectorKeyMax),
  "name": zod.string().max(listTenderSourceSuggestionsResponseItemsItemNameMax),
  "url": zod.url(),
  "jurisdiction": zod.string().nullable(),
  "kind": zod.enum(['api', 'rss', 'html', 'recipe']),
  "defaultCadenceMinutes": zod.int().min(listTenderSourceSuggestionsResponseItemsItemDefaultCadenceMinutesMin),
  "requiresBrowser": zod.boolean(),
  "sourceId": zod.uuid().nullable().describe('Existing monitored source for this portal, when already added.')
})).max(listTenderSourceSuggestionsResponseItemsMax)
})


/**
 * @summary Add a monitored tender portal from a built-in suggestion (idempotent per entity)
 */
export const createTenderSourceFromSuggestionBodySuggestionKeyMax = 120;


export const createTenderSourceFromSuggestionBodySuggestionKeyRegExp = new RegExp('^[a-z0-9]+(?:-[a-z0-9]+)*$');


export const createTenderSourceFromSuggestionBody = zod.object({
  "suggestionKey": zod.string().min(1).max(createTenderSourceFromSuggestionBodySuggestionKeyMax).regex(createTenderSourceFromSuggestionBodySuggestionKeyRegExp)
})

export const createTenderSourceFromSuggestionResponseSourceGovernmentOneAdministeringBodyMax = 500;

export const createTenderSourceFromSuggestionResponseSourceGovernmentOneLocalJurisdictionOneIdMax = 100;


export const createTenderSourceFromSuggestionResponseSourceGovernmentOneLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const createTenderSourceFromSuggestionResponseSourceGovernmentOneLocalJurisdictionOneNameMax = 200;

export const createTenderSourceFromSuggestionResponseSourceGovernmentOneCategoriesMax = 8;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneCodeMax = 120;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneDetailMax = 2000;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneListingsFoundMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneFilteredOutMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneCreatedMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneUpdatedMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneUnchangedMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneSkippedMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneDocumentsAddedMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneDetailFailuresMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneRequestsMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneBytesMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthOpenTendersMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthConsecutiveFailuresMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthHistoryItemListingsFoundMin = 0;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthHistoryItemCodeMax = 120;

export const createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthHistoryMax = 10;

export const createTenderSourceFromSuggestionResponseSourceCadenceMinutesMin = 5;

export const createTenderSourceFromSuggestionResponseSourceMaxPagesPerRunMax = 1000;





export const createTenderSourceFromSuggestionResponse = zod.object({
  "created": zod.boolean(),
  "source": zod.object({
  "id": zod.uuid(),
  "sourceKey": zod.string(),
  "government": zod.union([zod.object({
  "administeringBody": zod.string().min(1).max(createTenderSourceFromSuggestionResponseSourceGovernmentOneAdministeringBodyMax),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(createTenderSourceFromSuggestionResponseSourceGovernmentOneLocalJurisdictionOneIdMax).regex(createTenderSourceFromSuggestionResponseSourceGovernmentOneLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(createTenderSourceFromSuggestionResponseSourceGovernmentOneLocalJurisdictionOneNameMax)
}),zod.null()]),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).min(1).max(createTenderSourceFromSuggestionResponseSourceGovernmentOneCategoriesMax)
}),zod.null()]).optional(),
  "name": zod.string(),
  "sourceType": zod.enum(['public', 'signed_in', 'feed']),
  "category": zod.enum(['general', 'government', 'tender']).optional().describe('Tender sources run a built-in portal connector and need no recipe or targeting profile.'),
  "connectorKey": zod.string().nullish(),
  "jurisdictionFilter": zod.array(zod.string()).optional(),
  "keywordFilter": zod.array(zod.string()).optional(),
  "lastScanSummary": zod.union([zod.object({
  "status": zod.enum(['completed', 'partial', 'failed', 'blocked']),
  "code": zod.string().max(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneCodeMax),
  "detail": zod.string().max(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneDetailMax),
  "trigger": zod.enum(['scheduled', 'manual']),
  "startedAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}),
  "listingsFound": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneListingsFoundMin),
  "filteredOut": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneFilteredOutMin),
  "created": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneCreatedMin),
  "updated": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneUpdatedMin),
  "unchanged": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneUnchangedMin),
  "skipped": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneSkippedMin),
  "documentsAdded": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneDocumentsAddedMin),
  "detailFailures": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneDetailFailuresMin),
  "requests": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneRequestsMin),
  "bytes": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneBytesMin),
  "health": zod.object({
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']).describe('ok: tenders read; empty: the portal listed none; page_changed: the page or feed no longer matches how it is read; blocked: the portal refused, needs sign-in or a browser; error: temporary failure.'),
  "openTenders": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthOpenTendersMin).describe('Open tender opportunities currently held from this portal.'),
  "consecutiveFailures": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthConsecutiveFailuresMin),
  "needsAttention": zod.boolean().describe('True after repeated failed scans.'),
  "lastSuccessAt": zod.iso.datetime({"offset":true}).nullable(),
  "history": zod.array(zod.object({
  "completedAt": zod.iso.datetime({"offset":true}),
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']),
  "listingsFound": zod.int().min(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthHistoryItemListingsFoundMin),
  "code": zod.string().max(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthHistoryItemCodeMax)
})).max(createTenderSourceFromSuggestionResponseSourceLastScanSummaryOneHealthHistoryMax).describe('Most recent scans first.')
}).optional().describe('Portal health after the most recent scan. Absent on summaries recorded before health tracking.')
}).describe('Result of the most recent tender portal scan.'),zod.null()]).optional(),
  "baseUrl": zod.url(),
  "status": zod.enum(['inactive', 'active', 'paused', 'revoked']),
  "readiness": zod.enum(['unconfigured', 'ready', 'sign_in_required', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "sessionStatus": zod.enum(['none', 'available', 'renewal_required', 'revoked', 'expired']),
  "targetingProfileId": zod.uuid().nullable(),
  "allowedHosts": zod.array(zod.string()),
  "allowedPaths": zod.array(zod.string()),
  "excludedPaths": zod.array(zod.string()),
  "extractionFields": zod.array(zod.string()),
  "cadenceMinutes": zod.int().min(createTenderSourceFromSuggestionResponseSourceCadenceMinutesMin),
  "maxPagesPerRun": zod.int().min(1).max(createTenderSourceFromSuggestionResponseSourceMaxPagesPerRunMax),
  "maxBytesPerRun": zod.int().min(1),
  "revision": zod.int().min(1),
  "configuredBy": zod.string(),
  "readinessCode": zod.string().nullable(),
  "readinessDetail": zod.string().nullable(),
  "readinessCheckedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Public source configuration and lifecycle metadata. Protected browser state references are deliberately excluded.')
})


/**
 * Requires entity.records.write. Reads a bounded number of same-website pages (robots.txt honoured, never signs in), classifies how each tender page can be read and returns up to five sample tenders per portal. Organisation or category seeds use public web search only when it is switched on. Suggestions are never scanned until approved.
 * @summary Find tender-listing portals from a website address, organisation or category and store them as suggestions
 */
export const runTenderPortalDiscoveryBodySeedMax = 500;



export const runTenderPortalDiscoveryBody = zod.object({
  "seed": zod.string().min(1).max(runTenderPortalDiscoveryBodySeedMax).describe('Website address, organisation name or category such as \'NSW councils\'.')
})

export const runTenderPortalDiscoveryResponsePagesCheckedMin = 0;

export const runTenderPortalDiscoveryResponseRequestsMin = 0;

export const runTenderPortalDiscoveryResponseNotesMax = 10;

export const runTenderPortalDiscoveryResponseLinkedSitesMax = 10;

export const runTenderPortalDiscoveryResponseCandidatesItemSamplesItemTitleMax = 300;

export const runTenderPortalDiscoveryResponseCandidatesItemSamplesMax = 5;


export const runTenderPortalDiscoveryResponseCandidatesMax = 10;



export const runTenderPortalDiscoveryResponse = zod.object({
  "seed": zod.string(),
  "searchedUrl": zod.string(),
  "pagesChecked": zod.int().min(runTenderPortalDiscoveryResponsePagesCheckedMin),
  "requests": zod.int().min(runTenderPortalDiscoveryResponseRequestsMin),
  "notes": zod.array(zod.string()).max(runTenderPortalDiscoveryResponseNotesMax),
  "linkedSites": zod.array(zod.object({
  "url": zod.string(),
  "title": zod.string()
})).max(runTenderPortalDiscoveryResponseLinkedSitesMax),
  "candidates": zod.array(zod.object({
  "id": zod.uuid(),
  "seed": zod.string(),
  "url": zod.string(),
  "host": zod.string(),
  "title": zod.string(),
  "readMethod": zod.enum(['feed', 'listing_page', 'browser_page', 'requires_sign_in', 'unsupported']),
  "detail": zod.string(),
  "samples": zod.array(zod.object({
  "title": zod.string().max(runTenderPortalDiscoveryResponseCandidatesItemSamplesItemTitleMax),
  "url": zod.string().nullable(),
  "reference": zod.string().nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "buyerName": zod.string().nullable()
})).max(runTenderPortalDiscoveryResponseCandidatesItemSamplesMax),
  "readConfig": zod.object({
  "feedUrl": zod.string().optional(),
  "feedFormat": zod.enum(['rss', 'atom', 'json', 'ocds']).optional(),
  "listingUrl": zod.string().optional(),
  "detailPattern": zod.string().optional()
}),
  "status": zod.enum(['suggested', 'approved', 'rejected']),
  "approvedSourceId": zod.uuid().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewNote": zod.string().nullable(),
  "revision": zod.int().min(1),
  "lastDiscoveredAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(runTenderPortalDiscoveryResponseCandidatesMax)
})


/**
 * Requires entity.records.read.
 * @summary List discovered tender portal suggestions by review status (paginated)
 */
export const listTenderPortalCandidatesQueryStatusDefault = `suggested`;
export const listTenderPortalCandidatesQueryLimitDefault = 10;
export const listTenderPortalCandidatesQueryLimitMax = 50;

export const listTenderPortalCandidatesQueryOffsetDefault = 0;
export const listTenderPortalCandidatesQueryOffsetMin = 0;
export const listTenderPortalCandidatesQueryOffsetMax = 10000;



export const listTenderPortalCandidatesQueryParams = zod.object({
  "status": zod.enum(['suggested', 'approved', 'rejected']).default(listTenderPortalCandidatesQueryStatusDefault),
  "limit": zod.int().min(1).max(listTenderPortalCandidatesQueryLimitMax).default(listTenderPortalCandidatesQueryLimitDefault),
  "offset": zod.int().min(listTenderPortalCandidatesQueryOffsetMin).max(listTenderPortalCandidatesQueryOffsetMax).default(listTenderPortalCandidatesQueryOffsetDefault)
})

export const listTenderPortalCandidatesResponseItemsItemSamplesItemTitleMax = 300;

export const listTenderPortalCandidatesResponseItemsItemSamplesMax = 5;


export const listTenderPortalCandidatesResponseItemsMax = 50;

export const listTenderPortalCandidatesResponseTotalMin = 0;


export const listTenderPortalCandidatesResponseOffsetMin = 0;



export const listTenderPortalCandidatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "seed": zod.string(),
  "url": zod.string(),
  "host": zod.string(),
  "title": zod.string(),
  "readMethod": zod.enum(['feed', 'listing_page', 'browser_page', 'requires_sign_in', 'unsupported']),
  "detail": zod.string(),
  "samples": zod.array(zod.object({
  "title": zod.string().max(listTenderPortalCandidatesResponseItemsItemSamplesItemTitleMax),
  "url": zod.string().nullable(),
  "reference": zod.string().nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "buyerName": zod.string().nullable()
})).max(listTenderPortalCandidatesResponseItemsItemSamplesMax),
  "readConfig": zod.object({
  "feedUrl": zod.string().optional(),
  "feedFormat": zod.enum(['rss', 'atom', 'json', 'ocds']).optional(),
  "listingUrl": zod.string().optional(),
  "detailPattern": zod.string().optional()
}),
  "status": zod.enum(['suggested', 'approved', 'rejected']),
  "approvedSourceId": zod.uuid().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewNote": zod.string().nullable(),
  "revision": zod.int().min(1),
  "lastDiscoveredAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(listTenderPortalCandidatesResponseItemsMax),
  "total": zod.int().min(listTenderPortalCandidatesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listTenderPortalCandidatesResponseOffsetMin)
})


/**
 * Requires entity.integrations.manage, the permission used to add tender portals. Sign-in and unreadable pages cannot be approved.
 * @summary Approve a discovered portal; it becomes a tender source in the Tender portals list
 */
export const approveTenderPortalCandidateParams = zod.object({
  "candidateId": zod.uuid()
})


export const approveTenderPortalCandidateBodyNoteMax = 1000;



export const approveTenderPortalCandidateBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "note": zod.string().max(approveTenderPortalCandidateBodyNoteMax).nullish()
})

export const approveTenderPortalCandidateResponseCandidateSamplesItemTitleMax = 300;

export const approveTenderPortalCandidateResponseCandidateSamplesMax = 5;




export const approveTenderPortalCandidateResponse = zod.object({
  "candidate": zod.object({
  "id": zod.uuid(),
  "seed": zod.string(),
  "url": zod.string(),
  "host": zod.string(),
  "title": zod.string(),
  "readMethod": zod.enum(['feed', 'listing_page', 'browser_page', 'requires_sign_in', 'unsupported']),
  "detail": zod.string(),
  "samples": zod.array(zod.object({
  "title": zod.string().max(approveTenderPortalCandidateResponseCandidateSamplesItemTitleMax),
  "url": zod.string().nullable(),
  "reference": zod.string().nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "buyerName": zod.string().nullable()
})).max(approveTenderPortalCandidateResponseCandidateSamplesMax),
  "readConfig": zod.object({
  "feedUrl": zod.string().optional(),
  "feedFormat": zod.enum(['rss', 'atom', 'json', 'ocds']).optional(),
  "listingUrl": zod.string().optional(),
  "detailPattern": zod.string().optional()
}),
  "status": zod.enum(['suggested', 'approved', 'rejected']),
  "approvedSourceId": zod.uuid().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewNote": zod.string().nullable(),
  "revision": zod.int().min(1),
  "lastDiscoveredAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "sourceId": zod.uuid(),
  "sourceCreated": zod.boolean(),
  "collectionReady": zod.boolean().describe('False while the reader for discovered portals is not yet switched on; the source then waits paused.')
})


/**
 * Requires entity.integrations.manage.
 * @summary Reject a discovered portal; it stays rejected when found again and is never scanned
 */
export const rejectTenderPortalCandidateParams = zod.object({
  "candidateId": zod.uuid()
})


export const rejectTenderPortalCandidateBodyNoteMax = 1000;



export const rejectTenderPortalCandidateBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "note": zod.string().max(rejectTenderPortalCandidateBodyNoteMax).nullish()
})

export const rejectTenderPortalCandidateResponseSamplesItemTitleMax = 300;

export const rejectTenderPortalCandidateResponseSamplesMax = 5;




export const rejectTenderPortalCandidateResponse = zod.object({
  "id": zod.uuid(),
  "seed": zod.string(),
  "url": zod.string(),
  "host": zod.string(),
  "title": zod.string(),
  "readMethod": zod.enum(['feed', 'listing_page', 'browser_page', 'requires_sign_in', 'unsupported']),
  "detail": zod.string(),
  "samples": zod.array(zod.object({
  "title": zod.string().max(rejectTenderPortalCandidateResponseSamplesItemTitleMax),
  "url": zod.string().nullable(),
  "reference": zod.string().nullable(),
  "closesAt": zod.iso.datetime({"offset":true}).nullable(),
  "buyerName": zod.string().nullable()
})).max(rejectTenderPortalCandidateResponseSamplesMax),
  "readConfig": zod.object({
  "feedUrl": zod.string().optional(),
  "feedFormat": zod.enum(['rss', 'atom', 'json', 'ocds']).optional(),
  "listingUrl": zod.string().optional(),
  "detailPattern": zod.string().optional()
}),
  "status": zod.enum(['suggested', 'approved', 'rejected']),
  "approvedSourceId": zod.uuid().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewNote": zod.string().nullable(),
  "revision": zod.int().min(1),
  "lastDiscoveredAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Run an active tender portal source now; results appear in Tender opportunities
 */
export const runTenderSourceScanParams = zod.object({
  "sourceId": zod.uuid()
})




export const runTenderSourceScanBody = zod.object({
  "expectedRevision": zod.int().min(1)
})

export const runTenderSourceScanResponse = zod.object({
  "sourceId": zod.uuid(),
  "queuedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Remove a tender portal source; opportunities it found are kept
 */
export const deleteTenderDiscoverySourceParams = zod.object({
  "sourceId": zod.uuid()
})




export const deleteTenderDiscoverySourceQueryParams = zod.object({
  "expectedRevision": zod.int().min(1)
})

export const deleteTenderDiscoverySourceResponse = zod.void()


/**
 * @summary Edit, activate, or pause a discovery source with optimistic revision checking
 */
export const updateWebDiscoverySourceParams = zod.object({
  "sourceId": zod.uuid()
})

export const updateWebDiscoverySourceBodyJurisdictionFilterItemMax = 80;

export const updateWebDiscoverySourceBodyJurisdictionFilterMax = 20;

export const updateWebDiscoverySourceBodyKeywordFilterItemMax = 100;

export const updateWebDiscoverySourceBodyKeywordFilterMax = 50;

export const updateWebDiscoverySourceBodyGovernmentOneAdministeringBodyMax = 500;

export const updateWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneIdMax = 100;


export const updateWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const updateWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneNameMax = 200;

export const updateWebDiscoverySourceBodyGovernmentOneCategoriesMax = 8;


export const updateWebDiscoverySourceBodyNameMax = 200;

export const updateWebDiscoverySourceBodyBaseUrlMax = 2000;

export const updateWebDiscoverySourceBodyAllowedHostsItemMax = 253;

export const updateWebDiscoverySourceBodyAllowedHostsMax = 20;

export const updateWebDiscoverySourceBodyAllowedPathsItemMax = 500;


export const updateWebDiscoverySourceBodyAllowedPathsItemRegExp = new RegExp('^');
export const updateWebDiscoverySourceBodyAllowedPathsMax = 50;

export const updateWebDiscoverySourceBodyExcludedPathsItemMax = 500;


export const updateWebDiscoverySourceBodyExcludedPathsItemRegExp = new RegExp('^');
export const updateWebDiscoverySourceBodyExcludedPathsMax = 50;

export const updateWebDiscoverySourceBodyExtractionFieldsMax = 20;

export const updateWebDiscoverySourceBodyCadenceMinutesMin = 5;
export const updateWebDiscoverySourceBodyCadenceMinutesMax = 525600;

export const updateWebDiscoverySourceBodyMaxPagesPerRunMax = 1000;

export const updateWebDiscoverySourceBodyMaxBytesPerRunMin = 1024;
export const updateWebDiscoverySourceBodyMaxBytesPerRunMax = 100000000;



export const updateWebDiscoverySourceBody = zod.object({
  "jurisdictionFilter": zod.array(zod.string().min(1).max(updateWebDiscoverySourceBodyJurisdictionFilterItemMax)).max(updateWebDiscoverySourceBodyJurisdictionFilterMax).optional().describe('Tender portal sources only.'),
  "keywordFilter": zod.array(zod.string().min(1).max(updateWebDiscoverySourceBodyKeywordFilterItemMax)).max(updateWebDiscoverySourceBodyKeywordFilterMax).optional().describe('Tender portal sources only.'),
  "government": zod.union([zod.object({
  "administeringBody": zod.string().min(1).max(updateWebDiscoverySourceBodyGovernmentOneAdministeringBodyMax),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(updateWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneIdMax).regex(updateWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(updateWebDiscoverySourceBodyGovernmentOneLocalJurisdictionOneNameMax)
}),zod.null()]),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).min(1).max(updateWebDiscoverySourceBodyGovernmentOneCategoriesMax)
}),zod.null()]).optional(),
  "expectedRevision": zod.int().min(1),
  "name": zod.string().min(1).max(updateWebDiscoverySourceBodyNameMax).optional(),
  "baseUrl": zod.url().max(updateWebDiscoverySourceBodyBaseUrlMax).optional(),
  "status": zod.enum(['inactive', 'active', 'paused']).optional(),
  "targetingProfileId": zod.uuid().nullish(),
  "allowedHosts": zod.array(zod.string().min(1).max(updateWebDiscoverySourceBodyAllowedHostsItemMax)).min(1).max(updateWebDiscoverySourceBodyAllowedHostsMax).optional(),
  "allowedPaths": zod.array(zod.string().min(1).max(updateWebDiscoverySourceBodyAllowedPathsItemMax).regex(updateWebDiscoverySourceBodyAllowedPathsItemRegExp)).min(1).max(updateWebDiscoverySourceBodyAllowedPathsMax).optional(),
  "excludedPaths": zod.array(zod.string().min(1).max(updateWebDiscoverySourceBodyExcludedPathsItemMax).regex(updateWebDiscoverySourceBodyExcludedPathsItemRegExp)).max(updateWebDiscoverySourceBodyExcludedPathsMax).optional(),
  "extractionFields": zod.array(zod.enum(['title', 'summary', 'organization', 'reference', 'location', 'published_at', 'deadline_at', 'value', 'currency', 'contact_name', 'contact_email', 'contact_phone'])).min(1).max(updateWebDiscoverySourceBodyExtractionFieldsMax).optional(),
  "cadenceMinutes": zod.int().min(updateWebDiscoverySourceBodyCadenceMinutesMin).max(updateWebDiscoverySourceBodyCadenceMinutesMax).optional(),
  "maxPagesPerRun": zod.int().min(1).max(updateWebDiscoverySourceBodyMaxPagesPerRunMax).optional(),
  "maxBytesPerRun": zod.int().min(updateWebDiscoverySourceBodyMaxBytesPerRunMin).max(updateWebDiscoverySourceBodyMaxBytesPerRunMax).optional()
})

export const updateWebDiscoverySourceResponseGovernmentOneAdministeringBodyMax = 500;

export const updateWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneIdMax = 100;


export const updateWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const updateWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneNameMax = 200;

export const updateWebDiscoverySourceResponseGovernmentOneCategoriesMax = 8;

export const updateWebDiscoverySourceResponseLastScanSummaryOneCodeMax = 120;

export const updateWebDiscoverySourceResponseLastScanSummaryOneDetailMax = 2000;

export const updateWebDiscoverySourceResponseLastScanSummaryOneListingsFoundMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneFilteredOutMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneCreatedMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneUpdatedMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneUnchangedMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneSkippedMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneDocumentsAddedMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneDetailFailuresMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneRequestsMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneBytesMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneHealthOpenTendersMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneHealthConsecutiveFailuresMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryItemListingsFoundMin = 0;

export const updateWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryItemCodeMax = 120;

export const updateWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryMax = 10;

export const updateWebDiscoverySourceResponseCadenceMinutesMin = 5;

export const updateWebDiscoverySourceResponseMaxPagesPerRunMax = 1000;





export const updateWebDiscoverySourceResponse = zod.object({
  "id": zod.uuid(),
  "sourceKey": zod.string(),
  "government": zod.union([zod.object({
  "administeringBody": zod.string().min(1).max(updateWebDiscoverySourceResponseGovernmentOneAdministeringBodyMax),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(updateWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneIdMax).regex(updateWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(updateWebDiscoverySourceResponseGovernmentOneLocalJurisdictionOneNameMax)
}),zod.null()]),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).min(1).max(updateWebDiscoverySourceResponseGovernmentOneCategoriesMax)
}),zod.null()]).optional(),
  "name": zod.string(),
  "sourceType": zod.enum(['public', 'signed_in', 'feed']),
  "category": zod.enum(['general', 'government', 'tender']).optional().describe('Tender sources run a built-in portal connector and need no recipe or targeting profile.'),
  "connectorKey": zod.string().nullish(),
  "jurisdictionFilter": zod.array(zod.string()).optional(),
  "keywordFilter": zod.array(zod.string()).optional(),
  "lastScanSummary": zod.union([zod.object({
  "status": zod.enum(['completed', 'partial', 'failed', 'blocked']),
  "code": zod.string().max(updateWebDiscoverySourceResponseLastScanSummaryOneCodeMax),
  "detail": zod.string().max(updateWebDiscoverySourceResponseLastScanSummaryOneDetailMax),
  "trigger": zod.enum(['scheduled', 'manual']),
  "startedAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}),
  "listingsFound": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneListingsFoundMin),
  "filteredOut": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneFilteredOutMin),
  "created": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneCreatedMin),
  "updated": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneUpdatedMin),
  "unchanged": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneUnchangedMin),
  "skipped": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneSkippedMin),
  "documentsAdded": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneDocumentsAddedMin),
  "detailFailures": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneDetailFailuresMin),
  "requests": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneRequestsMin),
  "bytes": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneBytesMin),
  "health": zod.object({
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']).describe('ok: tenders read; empty: the portal listed none; page_changed: the page or feed no longer matches how it is read; blocked: the portal refused, needs sign-in or a browser; error: temporary failure.'),
  "openTenders": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneHealthOpenTendersMin).describe('Open tender opportunities currently held from this portal.'),
  "consecutiveFailures": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneHealthConsecutiveFailuresMin),
  "needsAttention": zod.boolean().describe('True after repeated failed scans.'),
  "lastSuccessAt": zod.iso.datetime({"offset":true}).nullable(),
  "history": zod.array(zod.object({
  "completedAt": zod.iso.datetime({"offset":true}),
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']),
  "listingsFound": zod.int().min(updateWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryItemListingsFoundMin),
  "code": zod.string().max(updateWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryItemCodeMax)
})).max(updateWebDiscoverySourceResponseLastScanSummaryOneHealthHistoryMax).describe('Most recent scans first.')
}).optional().describe('Portal health after the most recent scan. Absent on summaries recorded before health tracking.')
}).describe('Result of the most recent tender portal scan.'),zod.null()]).optional(),
  "baseUrl": zod.url(),
  "status": zod.enum(['inactive', 'active', 'paused', 'revoked']),
  "readiness": zod.enum(['unconfigured', 'ready', 'sign_in_required', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "sessionStatus": zod.enum(['none', 'available', 'renewal_required', 'revoked', 'expired']),
  "targetingProfileId": zod.uuid().nullable(),
  "allowedHosts": zod.array(zod.string()),
  "allowedPaths": zod.array(zod.string()),
  "excludedPaths": zod.array(zod.string()),
  "extractionFields": zod.array(zod.string()),
  "cadenceMinutes": zod.int().min(updateWebDiscoverySourceResponseCadenceMinutesMin),
  "maxPagesPerRun": zod.int().min(1).max(updateWebDiscoverySourceResponseMaxPagesPerRunMax),
  "maxBytesPerRun": zod.int().min(1),
  "revision": zod.int().min(1),
  "configuredBy": zod.string(),
  "readinessCode": zod.string().nullable(),
  "readinessDetail": zod.string().nullable(),
  "readinessCheckedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Public source configuration and lifecycle metadata. Protected browser state references are deliberately excluded.')


/**
 * @summary Start an actor-bound isolated sign-in or renewal viewer for a restricted source
 */
export const startWebDiscoverySignInSessionParams = zod.object({
  "sourceId": zod.uuid()
})




export const startWebDiscoverySignInSessionBody = zod.object({
  "expectedSourceRevision": zod.int().min(1),
  "mode": zod.enum(['initial', 'renewal'])
})






export const startWebDiscoverySignInSessionResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "mode": zod.enum(['initial', 'renewal']),
  "status": zod.enum(['starting', 'active', 'mfa_required', 'challenge_required', 'completed', 'cancelled', 'expired', 'failed']),
  "readiness": zod.enum(['sign_in_required', 'ready', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "code": zod.string(),
  "detail": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "lastObservedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1),
  "viewerPath": zod.string().min(1).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Safe viewer lifecycle metadata. Credentials, request headers, page bodies, screenshots, worker identifiers, storage references, ciphertext and browser state are excluded.')


/**
 * @summary Inspect one actor-bound sign-in session without protected browser state
 */
export const getWebDiscoverySignInSessionParams = zod.object({
  "sourceId": zod.uuid(),
  "sessionId": zod.uuid()
})






export const getWebDiscoverySignInSessionResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "mode": zod.enum(['initial', 'renewal']),
  "status": zod.enum(['starting', 'active', 'mfa_required', 'challenge_required', 'completed', 'cancelled', 'expired', 'failed']),
  "readiness": zod.enum(['sign_in_required', 'ready', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "code": zod.string(),
  "detail": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "lastObservedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1),
  "viewerPath": zod.string().min(1).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Safe viewer lifecycle metadata. Credentials, request headers, page bodies, screenshots, worker identifiers, storage references, ciphertext and browser state are excluded.')


/**
 * @summary Read one transient no-store viewer frame for direct staff interaction
 */
export const getWebDiscoverySignInViewerFrameParams = zod.object({
  "sourceId": zod.uuid(),
  "sessionId": zod.uuid()
})

export const getWebDiscoverySignInViewerFrameResponseImageBase64Max = 2000000;



export const getWebDiscoverySignInViewerFrameResponse = zod.object({
  "contentType": zod.enum(['image/jpeg']),
  "imageBase64": zod.string().min(1).max(getWebDiscoverySignInViewerFrameResponseImageBase64Max),
  "capturedAt": zod.iso.datetime({"offset":true})
}).describe('Transient no-store viewer frame returned only to the initiating authorized actor.')


/**
 * @summary Send bounded direct staff input to the isolated viewer without retaining keystrokes
 */
export const sendWebDiscoverySignInViewerInputParams = zod.object({
  "sourceId": zod.uuid(),
  "sessionId": zod.uuid()
})

export const sendWebDiscoverySignInViewerInputBodyXMin = 0;
export const sendWebDiscoverySignInViewerInputBodyXMax = 4096;

export const sendWebDiscoverySignInViewerInputBodyYMin = 0;
export const sendWebDiscoverySignInViewerInputBodyYMax = 4096;

export const sendWebDiscoverySignInViewerInputBodyValueMax = 4096;

export const sendWebDiscoverySignInViewerInputBodyDeltaYMin = -4000;
export const sendWebDiscoverySignInViewerInputBodyDeltaYMax = 4000;



export const sendWebDiscoverySignInViewerInputBody = zod.object({
  "action": zod.enum(['click', 'type', 'press', 'scroll']),
  "x": zod.int().min(sendWebDiscoverySignInViewerInputBodyXMin).max(sendWebDiscoverySignInViewerInputBodyXMax).optional(),
  "y": zod.int().min(sendWebDiscoverySignInViewerInputBodyYMin).max(sendWebDiscoverySignInViewerInputBodyYMax).optional(),
  "value": zod.string().max(sendWebDiscoverySignInViewerInputBodyValueMax).optional(),
  "deltaY": zod.int().min(sendWebDiscoverySignInViewerInputBodyDeltaYMin).max(sendWebDiscoverySignInViewerInputBodyDeltaYMax).optional()
}).describe('Bounded direct staff input. Values are transient and must never be logged or persisted.')






export const sendWebDiscoverySignInViewerInputResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "mode": zod.enum(['initial', 'renewal']),
  "status": zod.enum(['starting', 'active', 'mfa_required', 'challenge_required', 'completed', 'cancelled', 'expired', 'failed']),
  "readiness": zod.enum(['sign_in_required', 'ready', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "code": zod.string(),
  "detail": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "lastObservedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1),
  "viewerPath": zod.string().min(1).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Safe viewer lifecycle metadata. Credentials, request headers, page bodies, screenshots, worker identifiers, storage references, ciphertext and browser state are excluded.')


/**
 * @summary Validate sign-in and encrypt reusable state from one exact viewer revision
 */
export const completeWebDiscoverySignInSessionParams = zod.object({
  "sourceId": zod.uuid(),
  "sessionId": zod.uuid()
})




export const completeWebDiscoverySignInSessionBody = zod.object({
  "expectedRevision": zod.int().min(1)
})






export const completeWebDiscoverySignInSessionResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "mode": zod.enum(['initial', 'renewal']),
  "status": zod.enum(['starting', 'active', 'mfa_required', 'challenge_required', 'completed', 'cancelled', 'expired', 'failed']),
  "readiness": zod.enum(['sign_in_required', 'ready', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "code": zod.string(),
  "detail": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "lastObservedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1),
  "viewerPath": zod.string().min(1).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Safe viewer lifecycle metadata. Credentials, request headers, page bodies, screenshots, worker identifiers, storage references, ciphertext and browser state are excluded.')


/**
 * @summary Cancel and dispose one actor-bound sign-in viewer
 */
export const cancelWebDiscoverySignInSessionParams = zod.object({
  "sourceId": zod.uuid(),
  "sessionId": zod.uuid()
})




export const cancelWebDiscoverySignInSessionBody = zod.object({
  "expectedRevision": zod.int().min(1)
})






export const cancelWebDiscoverySignInSessionResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "mode": zod.enum(['initial', 'renewal']),
  "status": zod.enum(['starting', 'active', 'mfa_required', 'challenge_required', 'completed', 'cancelled', 'expired', 'failed']),
  "readiness": zod.enum(['sign_in_required', 'ready', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "code": zod.string(),
  "detail": zod.string(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "lastObservedAt": zod.iso.datetime({"offset":true}).nullable(),
  "revision": zod.int().min(1),
  "viewerPath": zod.string().min(1).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Safe viewer lifecycle metadata. Credentials, request headers, page bodies, screenshots, worker identifiers, storage references, ciphertext and browser state are excluded.')


/**
 * @summary Revoke reusable browser state and active viewers for a restricted source
 */
export const revokeWebDiscoverySourceSessionParams = zod.object({
  "sourceId": zod.uuid()
})




export const revokeWebDiscoverySourceSessionBody = zod.object({
  "expectedSourceRevision": zod.int().min(1)
})

export const revokeWebDiscoverySourceSessionResponseGovernmentOneAdministeringBodyMax = 500;

export const revokeWebDiscoverySourceSessionResponseGovernmentOneLocalJurisdictionOneIdMax = 100;


export const revokeWebDiscoverySourceSessionResponseGovernmentOneLocalJurisdictionOneIdRegExp = new RegExp('^[a-zA-Z0-9][a-zA-Z0-9._:-]*$');
export const revokeWebDiscoverySourceSessionResponseGovernmentOneLocalJurisdictionOneNameMax = 200;

export const revokeWebDiscoverySourceSessionResponseGovernmentOneCategoriesMax = 8;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneCodeMax = 120;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneDetailMax = 2000;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneListingsFoundMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneFilteredOutMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneCreatedMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneUpdatedMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneUnchangedMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneSkippedMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneDocumentsAddedMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneDetailFailuresMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneRequestsMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneBytesMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthOpenTendersMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthConsecutiveFailuresMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthHistoryItemListingsFoundMin = 0;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthHistoryItemCodeMax = 120;

export const revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthHistoryMax = 10;

export const revokeWebDiscoverySourceSessionResponseCadenceMinutesMin = 5;

export const revokeWebDiscoverySourceSessionResponseMaxPagesPerRunMax = 1000;





export const revokeWebDiscoverySourceSessionResponse = zod.object({
  "id": zod.uuid(),
  "sourceKey": zod.string(),
  "government": zod.union([zod.object({
  "administeringBody": zod.string().min(1).max(revokeWebDiscoverySourceSessionResponseGovernmentOneAdministeringBodyMax),
  "jurisdictionLevel": zod.enum(['federal', 'state', 'local']),
  "state": zod.union([zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),zod.null()]),
  "localJurisdiction": zod.union([zod.object({
  "id": zod.string().min(1).max(revokeWebDiscoverySourceSessionResponseGovernmentOneLocalJurisdictionOneIdMax).regex(revokeWebDiscoverySourceSessionResponseGovernmentOneLocalJurisdictionOneIdRegExp),
  "state": zod.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']),
  "name": zod.string().min(1).max(revokeWebDiscoverySourceSessionResponseGovernmentOneLocalJurisdictionOneNameMax)
}),zod.null()]),
  "categories": zod.array(zod.enum(['supplier_panel', 'supplier_register', 'grant', 'rebate', 'subsidy', 'business_support', 'tax_incentive', 'tender']).describe('tender marks a public tender opportunity mirrored from Tender opportunities.')).min(1).max(revokeWebDiscoverySourceSessionResponseGovernmentOneCategoriesMax)
}),zod.null()]).optional(),
  "name": zod.string(),
  "sourceType": zod.enum(['public', 'signed_in', 'feed']),
  "category": zod.enum(['general', 'government', 'tender']).optional().describe('Tender sources run a built-in portal connector and need no recipe or targeting profile.'),
  "connectorKey": zod.string().nullish(),
  "jurisdictionFilter": zod.array(zod.string()).optional(),
  "keywordFilter": zod.array(zod.string()).optional(),
  "lastScanSummary": zod.union([zod.object({
  "status": zod.enum(['completed', 'partial', 'failed', 'blocked']),
  "code": zod.string().max(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneCodeMax),
  "detail": zod.string().max(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneDetailMax),
  "trigger": zod.enum(['scheduled', 'manual']),
  "startedAt": zod.iso.datetime({"offset":true}),
  "completedAt": zod.iso.datetime({"offset":true}),
  "listingsFound": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneListingsFoundMin),
  "filteredOut": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneFilteredOutMin),
  "created": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneCreatedMin),
  "updated": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneUpdatedMin),
  "unchanged": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneUnchangedMin),
  "skipped": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneSkippedMin),
  "documentsAdded": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneDocumentsAddedMin),
  "detailFailures": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneDetailFailuresMin),
  "requests": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneRequestsMin),
  "bytes": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneBytesMin),
  "health": zod.object({
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']).describe('ok: tenders read; empty: the portal listed none; page_changed: the page or feed no longer matches how it is read; blocked: the portal refused, needs sign-in or a browser; error: temporary failure.'),
  "openTenders": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthOpenTendersMin).describe('Open tender opportunities currently held from this portal.'),
  "consecutiveFailures": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthConsecutiveFailuresMin),
  "needsAttention": zod.boolean().describe('True after repeated failed scans.'),
  "lastSuccessAt": zod.iso.datetime({"offset":true}).nullable(),
  "history": zod.array(zod.object({
  "completedAt": zod.iso.datetime({"offset":true}),
  "outcome": zod.enum(['ok', 'empty', 'page_changed', 'blocked', 'error']),
  "listingsFound": zod.int().min(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthHistoryItemListingsFoundMin),
  "code": zod.string().max(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthHistoryItemCodeMax)
})).max(revokeWebDiscoverySourceSessionResponseLastScanSummaryOneHealthHistoryMax).describe('Most recent scans first.')
}).optional().describe('Portal health after the most recent scan. Absent on summaries recorded before health tracking.')
}).describe('Result of the most recent tender portal scan.'),zod.null()]).optional(),
  "baseUrl": zod.url(),
  "status": zod.enum(['inactive', 'active', 'paused', 'revoked']),
  "readiness": zod.enum(['unconfigured', 'ready', 'sign_in_required', 'renewal_required', 'blocked', 'unsupported', 'unavailable']),
  "sessionStatus": zod.enum(['none', 'available', 'renewal_required', 'revoked', 'expired']),
  "targetingProfileId": zod.uuid().nullable(),
  "allowedHosts": zod.array(zod.string()),
  "allowedPaths": zod.array(zod.string()),
  "excludedPaths": zod.array(zod.string()),
  "extractionFields": zod.array(zod.string()),
  "cadenceMinutes": zod.int().min(revokeWebDiscoverySourceSessionResponseCadenceMinutesMin),
  "maxPagesPerRun": zod.int().min(1).max(revokeWebDiscoverySourceSessionResponseMaxPagesPerRunMax),
  "maxBytesPerRun": zod.int().min(1),
  "revision": zod.int().min(1),
  "configuredBy": zod.string(),
  "readinessCode": zod.string().nullable(),
  "readinessDetail": zod.string().nullable(),
  "readinessCheckedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Public source configuration and lifecycle metadata. Protected browser state references are deliberately excluded.')


/**
 * @summary List immutable recipe versions for one discovery source
 */
export const listWebDiscoveryRecipesParams = zod.object({
  "sourceId": zod.uuid()
})

export const listWebDiscoveryRecipesQueryLimitDefault = 25;
export const listWebDiscoveryRecipesQueryLimitMax = 100;

export const listWebDiscoveryRecipesQueryOffsetDefault = 0;
export const listWebDiscoveryRecipesQueryOffsetMin = 0;



export const listWebDiscoveryRecipesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWebDiscoveryRecipesQueryLimitMax).default(listWebDiscoveryRecipesQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoveryRecipesQueryOffsetMin).default(listWebDiscoveryRecipesQueryOffsetDefault)
})




export const listWebDiscoveryRecipesResponseItemsItemDefinitionEntryPathsItemMax = 500;


export const listWebDiscoveryRecipesResponseItemsItemDefinitionEntryPathsItemRegExp = new RegExp('^');
export const listWebDiscoveryRecipesResponseItemsItemDefinitionEntryPathsMax = 20;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionFieldsMax = 20;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionKeywordsItemMax = 120;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionKeywordsMax = 25;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionExclusionsItemMax = 120;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionExclusionsMax = 25;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionRequiredMarkersItemMax = 120;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionRequiredMarkersMax = 20;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionReadOnlyFiltersItemParameterMax = 80;


export const listWebDiscoveryRecipesResponseItemsItemDefinitionReadOnlyFiltersItemParameterRegExp = new RegExp('^[A-Za-z0-9_.~-]+$');
export const listWebDiscoveryRecipesResponseItemsItemDefinitionReadOnlyFiltersItemValueMax = 200;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionReadOnlyFiltersMax = 20;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryMaxDepthMin = 0;
export const listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryMaxDepthMax = 3;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryMaxLinksPerPageMax = 100;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryIncludePathsItemMax = 500;


export const listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryIncludePathsItemRegExp = new RegExp('^');
export const listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryIncludePathsMax = 50;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryExcludedPathsItemMax = 500;


export const listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryExcludedPathsItemRegExp = new RegExp('^');
export const listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryExcludedPathsMax = 50;

export const listWebDiscoveryRecipesResponseItemsItemDefinitionPaginationMaxPagesMax = 100;



export const listWebDiscoveryRecipesResponseTotalMin = 0;


export const listWebDiscoveryRecipesResponseOffsetMin = 0;



export const listWebDiscoveryRecipesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "version": zod.int().min(1),
  "revision": zod.int().min(1),
  "schemaVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'confirmed', 'superseded', 'withdrawn']),
  "definition": zod.object({
  "entryPaths": zod.array(zod.string().min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionEntryPathsItemMax).regex(listWebDiscoveryRecipesResponseItemsItemDefinitionEntryPathsItemRegExp)).min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionEntryPathsMax),
  "fields": zod.array(zod.enum(['title', 'summary', 'organization', 'reference', 'location', 'published_at', 'deadline_at', 'value', 'currency', 'contact_name', 'contact_email', 'contact_phone'])).min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionFieldsMax),
  "keywords": zod.array(zod.string().min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionKeywordsItemMax)).max(listWebDiscoveryRecipesResponseItemsItemDefinitionKeywordsMax),
  "exclusions": zod.array(zod.string().min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionExclusionsItemMax)).max(listWebDiscoveryRecipesResponseItemsItemDefinitionExclusionsMax),
  "requiredMarkers": zod.array(zod.string().min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionRequiredMarkersItemMax)).max(listWebDiscoveryRecipesResponseItemsItemDefinitionRequiredMarkersMax),
  "readOnlyFilters": zod.array(zod.object({
  "parameter": zod.string().min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionReadOnlyFiltersItemParameterMax).regex(listWebDiscoveryRecipesResponseItemsItemDefinitionReadOnlyFiltersItemParameterRegExp),
  "value": zod.string().max(listWebDiscoveryRecipesResponseItemsItemDefinitionReadOnlyFiltersItemValueMax)
})).max(listWebDiscoveryRecipesResponseItemsItemDefinitionReadOnlyFiltersMax),
  "linkDiscovery": zod.object({
  "enabled": zod.boolean(),
  "maxDepth": zod.int().min(listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryMaxDepthMin).max(listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryMaxDepthMax),
  "maxLinksPerPage": zod.int().min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryMaxLinksPerPageMax),
  "includePaths": zod.array(zod.string().min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryIncludePathsItemMax).regex(listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryIncludePathsItemRegExp)).max(listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryIncludePathsMax),
  "excludedPaths": zod.array(zod.string().min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryExcludedPathsItemMax).regex(listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryExcludedPathsItemRegExp)).max(listWebDiscoveryRecipesResponseItemsItemDefinitionLinkDiscoveryExcludedPathsMax)
}),
  "pagination": zod.object({
  "mode": zod.enum(['none', 'next_link']),
  "maxPages": zod.int().min(1).max(listWebDiscoveryRecipesResponseItemsItemDefinitionPaginationMaxPagesMax)
})
}),
  "contentHash": zod.string(),
  "previewedSourceRevision": zod.int().min(1).nullable(),
  "previewedRecipeRevision": zod.int().min(1).nullable(),
  "previewReadiness": zod.enum(['ready', 'sign_in_required', 'blocked', 'unsupported', 'unavailable']).nullable(),
  "previewCode": zod.string().nullable(),
  "previewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "confirmedBy": zod.string().nullable(),
  "confirmedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listWebDiscoveryRecipesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoveryRecipesResponseOffsetMin)
})


/**
 * @summary Create an editable bounded declarative recipe draft
 */
export const createWebDiscoveryRecipeParams = zod.object({
  "sourceId": zod.uuid()
})

export const createWebDiscoveryRecipeBodyDefinitionEntryPathsItemMax = 500;


export const createWebDiscoveryRecipeBodyDefinitionEntryPathsItemRegExp = new RegExp('^');
export const createWebDiscoveryRecipeBodyDefinitionEntryPathsMax = 20;

export const createWebDiscoveryRecipeBodyDefinitionFieldsMax = 20;

export const createWebDiscoveryRecipeBodyDefinitionKeywordsItemMax = 120;

export const createWebDiscoveryRecipeBodyDefinitionKeywordsMax = 25;

export const createWebDiscoveryRecipeBodyDefinitionExclusionsItemMax = 120;

export const createWebDiscoveryRecipeBodyDefinitionExclusionsMax = 25;

export const createWebDiscoveryRecipeBodyDefinitionRequiredMarkersItemMax = 120;

export const createWebDiscoveryRecipeBodyDefinitionRequiredMarkersMax = 20;

export const createWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemParameterMax = 80;


export const createWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemParameterRegExp = new RegExp('^[A-Za-z0-9_.~-]+$');
export const createWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemValueMax = 200;

export const createWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersMax = 20;

export const createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxDepthMin = 0;
export const createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxDepthMax = 3;

export const createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxLinksPerPageMax = 100;

export const createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsItemMax = 500;


export const createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsItemRegExp = new RegExp('^');
export const createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsMax = 50;

export const createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsItemMax = 500;


export const createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsItemRegExp = new RegExp('^');
export const createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsMax = 50;

export const createWebDiscoveryRecipeBodyDefinitionPaginationMaxPagesMax = 100;



export const createWebDiscoveryRecipeBody = zod.object({
  "definition": zod.object({
  "entryPaths": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeBodyDefinitionEntryPathsItemMax).regex(createWebDiscoveryRecipeBodyDefinitionEntryPathsItemRegExp)).min(1).max(createWebDiscoveryRecipeBodyDefinitionEntryPathsMax),
  "fields": zod.array(zod.enum(['title', 'summary', 'organization', 'reference', 'location', 'published_at', 'deadline_at', 'value', 'currency', 'contact_name', 'contact_email', 'contact_phone'])).min(1).max(createWebDiscoveryRecipeBodyDefinitionFieldsMax),
  "keywords": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeBodyDefinitionKeywordsItemMax)).max(createWebDiscoveryRecipeBodyDefinitionKeywordsMax),
  "exclusions": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeBodyDefinitionExclusionsItemMax)).max(createWebDiscoveryRecipeBodyDefinitionExclusionsMax),
  "requiredMarkers": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeBodyDefinitionRequiredMarkersItemMax)).max(createWebDiscoveryRecipeBodyDefinitionRequiredMarkersMax),
  "readOnlyFilters": zod.array(zod.object({
  "parameter": zod.string().min(1).max(createWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemParameterMax).regex(createWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemParameterRegExp),
  "value": zod.string().max(createWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemValueMax)
})).max(createWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersMax),
  "linkDiscovery": zod.object({
  "enabled": zod.boolean(),
  "maxDepth": zod.int().min(createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxDepthMin).max(createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxDepthMax),
  "maxLinksPerPage": zod.int().min(1).max(createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxLinksPerPageMax),
  "includePaths": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsItemMax).regex(createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsItemRegExp)).max(createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsMax),
  "excludedPaths": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsItemMax).regex(createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsItemRegExp)).max(createWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsMax)
}),
  "pagination": zod.object({
  "mode": zod.enum(['none', 'next_link']),
  "maxPages": zod.int().min(1).max(createWebDiscoveryRecipeBodyDefinitionPaginationMaxPagesMax)
})
})
})




export const createWebDiscoveryRecipeResponseDefinitionEntryPathsItemMax = 500;


export const createWebDiscoveryRecipeResponseDefinitionEntryPathsItemRegExp = new RegExp('^');
export const createWebDiscoveryRecipeResponseDefinitionEntryPathsMax = 20;

export const createWebDiscoveryRecipeResponseDefinitionFieldsMax = 20;

export const createWebDiscoveryRecipeResponseDefinitionKeywordsItemMax = 120;

export const createWebDiscoveryRecipeResponseDefinitionKeywordsMax = 25;

export const createWebDiscoveryRecipeResponseDefinitionExclusionsItemMax = 120;

export const createWebDiscoveryRecipeResponseDefinitionExclusionsMax = 25;

export const createWebDiscoveryRecipeResponseDefinitionRequiredMarkersItemMax = 120;

export const createWebDiscoveryRecipeResponseDefinitionRequiredMarkersMax = 20;

export const createWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterMax = 80;


export const createWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterRegExp = new RegExp('^[A-Za-z0-9_.~-]+$');
export const createWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemValueMax = 200;

export const createWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersMax = 20;

export const createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMin = 0;
export const createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMax = 3;

export const createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxLinksPerPageMax = 100;

export const createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemMax = 500;


export const createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemRegExp = new RegExp('^');
export const createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsMax = 50;

export const createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemMax = 500;


export const createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemRegExp = new RegExp('^');
export const createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsMax = 50;

export const createWebDiscoveryRecipeResponseDefinitionPaginationMaxPagesMax = 100;





export const createWebDiscoveryRecipeResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "version": zod.int().min(1),
  "revision": zod.int().min(1),
  "schemaVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'confirmed', 'superseded', 'withdrawn']),
  "definition": zod.object({
  "entryPaths": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeResponseDefinitionEntryPathsItemMax).regex(createWebDiscoveryRecipeResponseDefinitionEntryPathsItemRegExp)).min(1).max(createWebDiscoveryRecipeResponseDefinitionEntryPathsMax),
  "fields": zod.array(zod.enum(['title', 'summary', 'organization', 'reference', 'location', 'published_at', 'deadline_at', 'value', 'currency', 'contact_name', 'contact_email', 'contact_phone'])).min(1).max(createWebDiscoveryRecipeResponseDefinitionFieldsMax),
  "keywords": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeResponseDefinitionKeywordsItemMax)).max(createWebDiscoveryRecipeResponseDefinitionKeywordsMax),
  "exclusions": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeResponseDefinitionExclusionsItemMax)).max(createWebDiscoveryRecipeResponseDefinitionExclusionsMax),
  "requiredMarkers": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeResponseDefinitionRequiredMarkersItemMax)).max(createWebDiscoveryRecipeResponseDefinitionRequiredMarkersMax),
  "readOnlyFilters": zod.array(zod.object({
  "parameter": zod.string().min(1).max(createWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterMax).regex(createWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterRegExp),
  "value": zod.string().max(createWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemValueMax)
})).max(createWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersMax),
  "linkDiscovery": zod.object({
  "enabled": zod.boolean(),
  "maxDepth": zod.int().min(createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMin).max(createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMax),
  "maxLinksPerPage": zod.int().min(1).max(createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxLinksPerPageMax),
  "includePaths": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemMax).regex(createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemRegExp)).max(createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsMax),
  "excludedPaths": zod.array(zod.string().min(1).max(createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemMax).regex(createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemRegExp)).max(createWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsMax)
}),
  "pagination": zod.object({
  "mode": zod.enum(['none', 'next_link']),
  "maxPages": zod.int().min(1).max(createWebDiscoveryRecipeResponseDefinitionPaginationMaxPagesMax)
})
}),
  "contentHash": zod.string(),
  "previewedSourceRevision": zod.int().min(1).nullable(),
  "previewedRecipeRevision": zod.int().min(1).nullable(),
  "previewReadiness": zod.enum(['ready', 'sign_in_required', 'blocked', 'unsupported', 'unavailable']).nullable(),
  "previewCode": zod.string().nullable(),
  "previewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "confirmedBy": zod.string().nullable(),
  "confirmedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Edit one unconfirmed recipe draft
 */
export const updateWebDiscoveryRecipeParams = zod.object({
  "sourceId": zod.uuid(),
  "recipeId": zod.uuid()
})


export const updateWebDiscoveryRecipeBodyDefinitionEntryPathsItemMax = 500;


export const updateWebDiscoveryRecipeBodyDefinitionEntryPathsItemRegExp = new RegExp('^');
export const updateWebDiscoveryRecipeBodyDefinitionEntryPathsMax = 20;

export const updateWebDiscoveryRecipeBodyDefinitionFieldsMax = 20;

export const updateWebDiscoveryRecipeBodyDefinitionKeywordsItemMax = 120;

export const updateWebDiscoveryRecipeBodyDefinitionKeywordsMax = 25;

export const updateWebDiscoveryRecipeBodyDefinitionExclusionsItemMax = 120;

export const updateWebDiscoveryRecipeBodyDefinitionExclusionsMax = 25;

export const updateWebDiscoveryRecipeBodyDefinitionRequiredMarkersItemMax = 120;

export const updateWebDiscoveryRecipeBodyDefinitionRequiredMarkersMax = 20;

export const updateWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemParameterMax = 80;


export const updateWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemParameterRegExp = new RegExp('^[A-Za-z0-9_.~-]+$');
export const updateWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemValueMax = 200;

export const updateWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersMax = 20;

export const updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxDepthMin = 0;
export const updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxDepthMax = 3;

export const updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxLinksPerPageMax = 100;

export const updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsItemMax = 500;


export const updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsItemRegExp = new RegExp('^');
export const updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsMax = 50;

export const updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsItemMax = 500;


export const updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsItemRegExp = new RegExp('^');
export const updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsMax = 50;

export const updateWebDiscoveryRecipeBodyDefinitionPaginationMaxPagesMax = 100;



export const updateWebDiscoveryRecipeBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "definition": zod.object({
  "entryPaths": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeBodyDefinitionEntryPathsItemMax).regex(updateWebDiscoveryRecipeBodyDefinitionEntryPathsItemRegExp)).min(1).max(updateWebDiscoveryRecipeBodyDefinitionEntryPathsMax),
  "fields": zod.array(zod.enum(['title', 'summary', 'organization', 'reference', 'location', 'published_at', 'deadline_at', 'value', 'currency', 'contact_name', 'contact_email', 'contact_phone'])).min(1).max(updateWebDiscoveryRecipeBodyDefinitionFieldsMax),
  "keywords": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeBodyDefinitionKeywordsItemMax)).max(updateWebDiscoveryRecipeBodyDefinitionKeywordsMax),
  "exclusions": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeBodyDefinitionExclusionsItemMax)).max(updateWebDiscoveryRecipeBodyDefinitionExclusionsMax),
  "requiredMarkers": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeBodyDefinitionRequiredMarkersItemMax)).max(updateWebDiscoveryRecipeBodyDefinitionRequiredMarkersMax),
  "readOnlyFilters": zod.array(zod.object({
  "parameter": zod.string().min(1).max(updateWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemParameterMax).regex(updateWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemParameterRegExp),
  "value": zod.string().max(updateWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersItemValueMax)
})).max(updateWebDiscoveryRecipeBodyDefinitionReadOnlyFiltersMax),
  "linkDiscovery": zod.object({
  "enabled": zod.boolean(),
  "maxDepth": zod.int().min(updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxDepthMin).max(updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxDepthMax),
  "maxLinksPerPage": zod.int().min(1).max(updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryMaxLinksPerPageMax),
  "includePaths": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsItemMax).regex(updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsItemRegExp)).max(updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryIncludePathsMax),
  "excludedPaths": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsItemMax).regex(updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsItemRegExp)).max(updateWebDiscoveryRecipeBodyDefinitionLinkDiscoveryExcludedPathsMax)
}),
  "pagination": zod.object({
  "mode": zod.enum(['none', 'next_link']),
  "maxPages": zod.int().min(1).max(updateWebDiscoveryRecipeBodyDefinitionPaginationMaxPagesMax)
})
})
})




export const updateWebDiscoveryRecipeResponseDefinitionEntryPathsItemMax = 500;


export const updateWebDiscoveryRecipeResponseDefinitionEntryPathsItemRegExp = new RegExp('^');
export const updateWebDiscoveryRecipeResponseDefinitionEntryPathsMax = 20;

export const updateWebDiscoveryRecipeResponseDefinitionFieldsMax = 20;

export const updateWebDiscoveryRecipeResponseDefinitionKeywordsItemMax = 120;

export const updateWebDiscoveryRecipeResponseDefinitionKeywordsMax = 25;

export const updateWebDiscoveryRecipeResponseDefinitionExclusionsItemMax = 120;

export const updateWebDiscoveryRecipeResponseDefinitionExclusionsMax = 25;

export const updateWebDiscoveryRecipeResponseDefinitionRequiredMarkersItemMax = 120;

export const updateWebDiscoveryRecipeResponseDefinitionRequiredMarkersMax = 20;

export const updateWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterMax = 80;


export const updateWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterRegExp = new RegExp('^[A-Za-z0-9_.~-]+$');
export const updateWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemValueMax = 200;

export const updateWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersMax = 20;

export const updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMin = 0;
export const updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMax = 3;

export const updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxLinksPerPageMax = 100;

export const updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemMax = 500;


export const updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemRegExp = new RegExp('^');
export const updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsMax = 50;

export const updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemMax = 500;


export const updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemRegExp = new RegExp('^');
export const updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsMax = 50;

export const updateWebDiscoveryRecipeResponseDefinitionPaginationMaxPagesMax = 100;





export const updateWebDiscoveryRecipeResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "version": zod.int().min(1),
  "revision": zod.int().min(1),
  "schemaVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'confirmed', 'superseded', 'withdrawn']),
  "definition": zod.object({
  "entryPaths": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeResponseDefinitionEntryPathsItemMax).regex(updateWebDiscoveryRecipeResponseDefinitionEntryPathsItemRegExp)).min(1).max(updateWebDiscoveryRecipeResponseDefinitionEntryPathsMax),
  "fields": zod.array(zod.enum(['title', 'summary', 'organization', 'reference', 'location', 'published_at', 'deadline_at', 'value', 'currency', 'contact_name', 'contact_email', 'contact_phone'])).min(1).max(updateWebDiscoveryRecipeResponseDefinitionFieldsMax),
  "keywords": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeResponseDefinitionKeywordsItemMax)).max(updateWebDiscoveryRecipeResponseDefinitionKeywordsMax),
  "exclusions": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeResponseDefinitionExclusionsItemMax)).max(updateWebDiscoveryRecipeResponseDefinitionExclusionsMax),
  "requiredMarkers": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeResponseDefinitionRequiredMarkersItemMax)).max(updateWebDiscoveryRecipeResponseDefinitionRequiredMarkersMax),
  "readOnlyFilters": zod.array(zod.object({
  "parameter": zod.string().min(1).max(updateWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterMax).regex(updateWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterRegExp),
  "value": zod.string().max(updateWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemValueMax)
})).max(updateWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersMax),
  "linkDiscovery": zod.object({
  "enabled": zod.boolean(),
  "maxDepth": zod.int().min(updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMin).max(updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMax),
  "maxLinksPerPage": zod.int().min(1).max(updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxLinksPerPageMax),
  "includePaths": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemMax).regex(updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemRegExp)).max(updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsMax),
  "excludedPaths": zod.array(zod.string().min(1).max(updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemMax).regex(updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemRegExp)).max(updateWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsMax)
}),
  "pagination": zod.object({
  "mode": zod.enum(['none', 'next_link']),
  "maxPages": zod.int().min(1).max(updateWebDiscoveryRecipeResponseDefinitionPaginationMaxPagesMax)
})
}),
  "contentHash": zod.string(),
  "previewedSourceRevision": zod.int().min(1).nullable(),
  "previewedRecipeRevision": zod.int().min(1).nullable(),
  "previewReadiness": zod.enum(['ready', 'sign_in_required', 'blocked', 'unsupported', 'unavailable']).nullable(),
  "previewCode": zod.string().nullable(),
  "previewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "confirmedBy": zod.string().nullable(),
  "confirmedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Execute a bounded real-page readiness preview for one exact draft revision
 */
export const previewWebDiscoveryRecipeParams = zod.object({
  "sourceId": zod.uuid(),
  "recipeId": zod.uuid()
})





export const previewWebDiscoveryRecipeBody = zod.object({
  "expectedSourceRevision": zod.int().min(1),
  "expectedRecipeRevision": zod.int().min(1)
})




export const previewWebDiscoveryRecipeResponsePagesFetchedMin = 0;

export const previewWebDiscoveryRecipeResponseBytesFetchedMin = 0;

export const previewWebDiscoveryRecipeResponseItemsItemTitleMax = 500;

export const previewWebDiscoveryRecipeResponseItemsItemExcerptMax = 4000;

export const previewWebDiscoveryRecipeResponseItemsItemMatchedKeywordsMax = 25;

export const previewWebDiscoveryRecipeResponseItemsMax = 100;



export const previewWebDiscoveryRecipeResponse = zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid(),
  "recipeVersion": zod.int().min(1),
  "recipeRevision": zod.int().min(1),
  "readiness": zod.enum(['ready', 'sign_in_required', 'blocked', 'unsupported', 'unavailable']),
  "code": zod.string(),
  "detail": zod.string(),
  "checkedAt": zod.iso.datetime({"offset":true}),
  "pagesFetched": zod.int().min(previewWebDiscoveryRecipeResponsePagesFetchedMin),
  "bytesFetched": zod.int().min(previewWebDiscoveryRecipeResponseBytesFetchedMin),
  "truncated": zod.boolean(),
  "items": zod.array(zod.object({
  "url": zod.url(),
  "title": zod.string().min(1).max(previewWebDiscoveryRecipeResponseItemsItemTitleMax),
  "excerpt": zod.string().min(1).max(previewWebDiscoveryRecipeResponseItemsItemExcerptMax),
  "contentHash": zod.string(),
  "contentType": zod.string(),
  "fields": zod.record(zod.string(), zod.string().nullable()),
  "matchedKeywords": zod.array(zod.string()).max(previewWebDiscoveryRecipeResponseItemsItemMatchedKeywordsMax)
})).max(previewWebDiscoveryRecipeResponseItemsMax)
})


/**
 * @summary Confirm one exact recipe revision after a successful current-source preview
 */
export const confirmWebDiscoveryRecipeParams = zod.object({
  "sourceId": zod.uuid(),
  "recipeId": zod.uuid()
})





export const confirmWebDiscoveryRecipeBody = zod.object({
  "expectedSourceRevision": zod.int().min(1),
  "expectedRecipeRevision": zod.int().min(1)
})




export const confirmWebDiscoveryRecipeResponseDefinitionEntryPathsItemMax = 500;


export const confirmWebDiscoveryRecipeResponseDefinitionEntryPathsItemRegExp = new RegExp('^');
export const confirmWebDiscoveryRecipeResponseDefinitionEntryPathsMax = 20;

export const confirmWebDiscoveryRecipeResponseDefinitionFieldsMax = 20;

export const confirmWebDiscoveryRecipeResponseDefinitionKeywordsItemMax = 120;

export const confirmWebDiscoveryRecipeResponseDefinitionKeywordsMax = 25;

export const confirmWebDiscoveryRecipeResponseDefinitionExclusionsItemMax = 120;

export const confirmWebDiscoveryRecipeResponseDefinitionExclusionsMax = 25;

export const confirmWebDiscoveryRecipeResponseDefinitionRequiredMarkersItemMax = 120;

export const confirmWebDiscoveryRecipeResponseDefinitionRequiredMarkersMax = 20;

export const confirmWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterMax = 80;


export const confirmWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterRegExp = new RegExp('^[A-Za-z0-9_.~-]+$');
export const confirmWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemValueMax = 200;

export const confirmWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersMax = 20;

export const confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMin = 0;
export const confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMax = 3;

export const confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxLinksPerPageMax = 100;

export const confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemMax = 500;


export const confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemRegExp = new RegExp('^');
export const confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsMax = 50;

export const confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemMax = 500;


export const confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemRegExp = new RegExp('^');
export const confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsMax = 50;

export const confirmWebDiscoveryRecipeResponseDefinitionPaginationMaxPagesMax = 100;





export const confirmWebDiscoveryRecipeResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "version": zod.int().min(1),
  "revision": zod.int().min(1),
  "schemaVersion": zod.int().min(1),
  "status": zod.enum(['draft', 'confirmed', 'superseded', 'withdrawn']),
  "definition": zod.object({
  "entryPaths": zod.array(zod.string().min(1).max(confirmWebDiscoveryRecipeResponseDefinitionEntryPathsItemMax).regex(confirmWebDiscoveryRecipeResponseDefinitionEntryPathsItemRegExp)).min(1).max(confirmWebDiscoveryRecipeResponseDefinitionEntryPathsMax),
  "fields": zod.array(zod.enum(['title', 'summary', 'organization', 'reference', 'location', 'published_at', 'deadline_at', 'value', 'currency', 'contact_name', 'contact_email', 'contact_phone'])).min(1).max(confirmWebDiscoveryRecipeResponseDefinitionFieldsMax),
  "keywords": zod.array(zod.string().min(1).max(confirmWebDiscoveryRecipeResponseDefinitionKeywordsItemMax)).max(confirmWebDiscoveryRecipeResponseDefinitionKeywordsMax),
  "exclusions": zod.array(zod.string().min(1).max(confirmWebDiscoveryRecipeResponseDefinitionExclusionsItemMax)).max(confirmWebDiscoveryRecipeResponseDefinitionExclusionsMax),
  "requiredMarkers": zod.array(zod.string().min(1).max(confirmWebDiscoveryRecipeResponseDefinitionRequiredMarkersItemMax)).max(confirmWebDiscoveryRecipeResponseDefinitionRequiredMarkersMax),
  "readOnlyFilters": zod.array(zod.object({
  "parameter": zod.string().min(1).max(confirmWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterMax).regex(confirmWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemParameterRegExp),
  "value": zod.string().max(confirmWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersItemValueMax)
})).max(confirmWebDiscoveryRecipeResponseDefinitionReadOnlyFiltersMax),
  "linkDiscovery": zod.object({
  "enabled": zod.boolean(),
  "maxDepth": zod.int().min(confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMin).max(confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxDepthMax),
  "maxLinksPerPage": zod.int().min(1).max(confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryMaxLinksPerPageMax),
  "includePaths": zod.array(zod.string().min(1).max(confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemMax).regex(confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsItemRegExp)).max(confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryIncludePathsMax),
  "excludedPaths": zod.array(zod.string().min(1).max(confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemMax).regex(confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsItemRegExp)).max(confirmWebDiscoveryRecipeResponseDefinitionLinkDiscoveryExcludedPathsMax)
}),
  "pagination": zod.object({
  "mode": zod.enum(['none', 'next_link']),
  "maxPages": zod.int().min(1).max(confirmWebDiscoveryRecipeResponseDefinitionPaginationMaxPagesMax)
})
}),
  "contentHash": zod.string(),
  "previewedSourceRevision": zod.int().min(1).nullable(),
  "previewedRecipeRevision": zod.int().min(1).nullable(),
  "previewReadiness": zod.enum(['ready', 'sign_in_required', 'blocked', 'unsupported', 'unavailable']).nullable(),
  "previewCode": zod.string().nullable(),
  "previewedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "confirmedBy": zod.string().nullable(),
  "confirmedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Queue an idempotent manual discovery scan for the current source configuration
 */
export const createWebDiscoveryScanRunParams = zod.object({
  "sourceId": zod.uuid()
})


export const createWebDiscoveryScanRunBodyIdempotencyKeyMin = 8;
export const createWebDiscoveryScanRunBodyIdempotencyKeyMax = 160;


export const createWebDiscoveryScanRunBodyIdempotencyKeyRegExp = new RegExp('^[A-Za-z0-9._:-]+$');


export const createWebDiscoveryScanRunBody = zod.object({
  "expectedSourceRevision": zod.int().min(1),
  "idempotencyKey": zod.string().min(createWebDiscoveryScanRunBodyIdempotencyKeyMin).max(createWebDiscoveryScanRunBodyIdempotencyKeyMax).regex(createWebDiscoveryScanRunBodyIdempotencyKeyRegExp)
})


export const createWebDiscoveryScanRunResponseAttemptCountMin = 0;

export const createWebDiscoveryScanRunResponsePagesReservedMin = 0;

export const createWebDiscoveryScanRunResponsePagesConsumedMin = 0;

export const createWebDiscoveryScanRunResponseBytesReservedMin = 0;

export const createWebDiscoveryScanRunResponseBytesConsumedMin = 0;

export const createWebDiscoveryScanRunResponseCostReservedMinorMin = 0;

export const createWebDiscoveryScanRunResponseCostConsumedMinorMin = 0;

export const createWebDiscoveryScanRunResponseCurrencyRegExp = new RegExp('^[A-Z]{3}$');


export const createWebDiscoveryScanRunResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "targetingProfileId": zod.uuid(),
  "recipeId": zod.uuid(),
  "trigger": zod.enum(['manual', 'scheduled', 'readiness_preview']),
  "status": zod.enum(['queued', 'claimed', 'running', 'paused', 'completed', 'partial', 'failed', 'cancelled', 'blocked']),
  "idempotencyKey": zod.string(),
  "revision": zod.int().min(1),
  "attemptCount": zod.int().min(createWebDiscoveryScanRunResponseAttemptCountMin),
  "checkpoint": zod.record(zod.string(), zod.unknown()),
  "pagesReserved": zod.int().min(createWebDiscoveryScanRunResponsePagesReservedMin),
  "pagesConsumed": zod.int().min(createWebDiscoveryScanRunResponsePagesConsumedMin),
  "bytesReserved": zod.int().min(createWebDiscoveryScanRunResponseBytesReservedMin),
  "bytesConsumed": zod.int().min(createWebDiscoveryScanRunResponseBytesConsumedMin),
  "costReservedMinor": zod.int().min(createWebDiscoveryScanRunResponseCostReservedMinorMin),
  "costConsumedMinor": zod.int().min(createWebDiscoveryScanRunResponseCostConsumedMinorMin),
  "currency": zod.string().regex(createWebDiscoveryScanRunResponseCurrencyRegExp),
  "requestedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastErrorDetail": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Durable run projection. Worker lease tokens are deliberately excluded.')


/**
 * @summary Cancel undispatched or in-flight discovery work without retrying it
 */
export const cancelWebDiscoveryScanRunParams = zod.object({
  "runId": zod.uuid()
})




export const cancelWebDiscoveryScanRunBody = zod.object({
  "expectedRevision": zod.int().min(1)
})


export const cancelWebDiscoveryScanRunResponseAttemptCountMin = 0;

export const cancelWebDiscoveryScanRunResponsePagesReservedMin = 0;

export const cancelWebDiscoveryScanRunResponsePagesConsumedMin = 0;

export const cancelWebDiscoveryScanRunResponseBytesReservedMin = 0;

export const cancelWebDiscoveryScanRunResponseBytesConsumedMin = 0;

export const cancelWebDiscoveryScanRunResponseCostReservedMinorMin = 0;

export const cancelWebDiscoveryScanRunResponseCostConsumedMinorMin = 0;

export const cancelWebDiscoveryScanRunResponseCurrencyRegExp = new RegExp('^[A-Z]{3}$');


export const cancelWebDiscoveryScanRunResponse = zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "targetingProfileId": zod.uuid(),
  "recipeId": zod.uuid(),
  "trigger": zod.enum(['manual', 'scheduled', 'readiness_preview']),
  "status": zod.enum(['queued', 'claimed', 'running', 'paused', 'completed', 'partial', 'failed', 'cancelled', 'blocked']),
  "idempotencyKey": zod.string(),
  "revision": zod.int().min(1),
  "attemptCount": zod.int().min(cancelWebDiscoveryScanRunResponseAttemptCountMin),
  "checkpoint": zod.record(zod.string(), zod.unknown()),
  "pagesReserved": zod.int().min(cancelWebDiscoveryScanRunResponsePagesReservedMin),
  "pagesConsumed": zod.int().min(cancelWebDiscoveryScanRunResponsePagesConsumedMin),
  "bytesReserved": zod.int().min(cancelWebDiscoveryScanRunResponseBytesReservedMin),
  "bytesConsumed": zod.int().min(cancelWebDiscoveryScanRunResponseBytesConsumedMin),
  "costReservedMinor": zod.int().min(cancelWebDiscoveryScanRunResponseCostReservedMinorMin),
  "costConsumedMinor": zod.int().min(cancelWebDiscoveryScanRunResponseCostConsumedMinorMin),
  "currency": zod.string().regex(cancelWebDiscoveryScanRunResponseCurrencyRegExp),
  "requestedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastErrorDetail": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Durable run projection. Worker lease tokens are deliberately excluded.')


/**
 * @summary List durable manual, scheduled, and readiness-preview scan runs
 */
export const listWebDiscoveryScanRunsQueryLimitDefault = 25;
export const listWebDiscoveryScanRunsQueryLimitMax = 100;

export const listWebDiscoveryScanRunsQueryOffsetDefault = 0;
export const listWebDiscoveryScanRunsQueryOffsetMin = 0;



export const listWebDiscoveryScanRunsQueryParams = zod.object({
  "sourceId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listWebDiscoveryScanRunsQueryLimitMax).default(listWebDiscoveryScanRunsQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoveryScanRunsQueryOffsetMin).default(listWebDiscoveryScanRunsQueryOffsetDefault)
})


export const listWebDiscoveryScanRunsResponseItemsItemAttemptCountMin = 0;

export const listWebDiscoveryScanRunsResponseItemsItemPagesReservedMin = 0;

export const listWebDiscoveryScanRunsResponseItemsItemPagesConsumedMin = 0;

export const listWebDiscoveryScanRunsResponseItemsItemBytesReservedMin = 0;

export const listWebDiscoveryScanRunsResponseItemsItemBytesConsumedMin = 0;

export const listWebDiscoveryScanRunsResponseItemsItemCostReservedMinorMin = 0;

export const listWebDiscoveryScanRunsResponseItemsItemCostConsumedMinorMin = 0;

export const listWebDiscoveryScanRunsResponseItemsItemCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const listWebDiscoveryScanRunsResponseTotalMin = 0;


export const listWebDiscoveryScanRunsResponseOffsetMin = 0;



export const listWebDiscoveryScanRunsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceId": zod.uuid(),
  "targetingProfileId": zod.uuid(),
  "recipeId": zod.uuid(),
  "trigger": zod.enum(['manual', 'scheduled', 'readiness_preview']),
  "status": zod.enum(['queued', 'claimed', 'running', 'paused', 'completed', 'partial', 'failed', 'cancelled', 'blocked']),
  "idempotencyKey": zod.string(),
  "revision": zod.int().min(1),
  "attemptCount": zod.int().min(listWebDiscoveryScanRunsResponseItemsItemAttemptCountMin),
  "checkpoint": zod.record(zod.string(), zod.unknown()),
  "pagesReserved": zod.int().min(listWebDiscoveryScanRunsResponseItemsItemPagesReservedMin),
  "pagesConsumed": zod.int().min(listWebDiscoveryScanRunsResponseItemsItemPagesConsumedMin),
  "bytesReserved": zod.int().min(listWebDiscoveryScanRunsResponseItemsItemBytesReservedMin),
  "bytesConsumed": zod.int().min(listWebDiscoveryScanRunsResponseItemsItemBytesConsumedMin),
  "costReservedMinor": zod.int().min(listWebDiscoveryScanRunsResponseItemsItemCostReservedMinorMin),
  "costConsumedMinor": zod.int().min(listWebDiscoveryScanRunsResponseItemsItemCostConsumedMinorMin),
  "currency": zod.string().regex(listWebDiscoveryScanRunsResponseItemsItemCurrencyRegExp),
  "requestedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastErrorCode": zod.string().nullable(),
  "lastErrorDetail": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).describe('Durable run projection. Worker lease tokens are deliberately excluded.')),
  "total": zod.int().min(listWebDiscoveryScanRunsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoveryScanRunsResponseOffsetMin)
})


/**
 * @summary List saved Web Discovery jobs
 */
export const listWebDiscoveryJobsQueryLimitDefault = 25;
export const listWebDiscoveryJobsQueryLimitMax = 100;

export const listWebDiscoveryJobsQueryOffsetDefault = 0;
export const listWebDiscoveryJobsQueryOffsetMin = 0;



export const listWebDiscoveryJobsQueryParams = zod.object({
  "status": zod.enum(['draft', 'active', 'paused']).optional(),
  "limit": zod.int().min(1).max(listWebDiscoveryJobsQueryLimitMax).default(listWebDiscoveryJobsQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoveryJobsQueryOffsetMin).default(listWebDiscoveryJobsQueryOffsetDefault)
})


export const listWebDiscoveryJobsResponseTotalMin = 0;


export const listWebDiscoveryJobsResponseOffsetMin = 0;



export const listWebDiscoveryJobsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "targetingProfileId": zod.uuid().nullable(),
  "sourceIds": zod.array(zod.uuid()),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string(),
  "searchQueries": zod.array(zod.string()),
  "cadenceMinutes": zod.int(),
  "status": zod.enum(['draft', 'active', 'paused']),
  "revision": zod.int().min(1),
  "definitionHash": zod.string(),
  "tested": zod.boolean().describe('The current definition has a successful test run.'),
  "lastSuccessfulTestRunId": zod.uuid().nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "updatedBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listWebDiscoveryJobsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoveryJobsResponseOffsetMin)
})


/**
 * @summary Save a job whose exact definition has passed a test run
 */
export const createWebDiscoveryJobBodyDefinitionNameMax = 160;

export const createWebDiscoveryJobBodyDefinitionDescriptionMax = 2000;

export const createWebDiscoveryJobBodyDefinitionSourceIdsMax = 25;

export const createWebDiscoveryJobBodyDefinitionAiInstructionsMax = 8000;

export const createWebDiscoveryJobBodyDefinitionSearchQueriesItemMax = 200;

export const createWebDiscoveryJobBodyDefinitionSearchQueriesMax = 10;

export const createWebDiscoveryJobBodyDefinitionCadenceMinutesMin = 60;
export const createWebDiscoveryJobBodyDefinitionCadenceMinutesMax = 525600;

export const createWebDiscoveryJobBodyActivateDefault = false;

export const createWebDiscoveryJobBody = zod.object({
  "definition": zod.object({
  "name": zod.string().min(1).max(createWebDiscoveryJobBodyDefinitionNameMax),
  "description": zod.string().max(createWebDiscoveryJobBodyDefinitionDescriptionMax).nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "sourceIds": zod.array(zod.uuid()).max(createWebDiscoveryJobBodyDefinitionSourceIdsMax),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string().min(1).max(createWebDiscoveryJobBodyDefinitionAiInstructionsMax),
  "searchQueries": zod.array(zod.string().min(1).max(createWebDiscoveryJobBodyDefinitionSearchQueriesItemMax)).max(createWebDiscoveryJobBodyDefinitionSearchQueriesMax),
  "cadenceMinutes": zod.int().min(createWebDiscoveryJobBodyDefinitionCadenceMinutesMin).max(createWebDiscoveryJobBodyDefinitionCadenceMinutesMax).describe('Schedule interval; at least hourly.')
}).describe('What a job checks and how AI picks out opportunities. Its hash identifies the exact definition a test run covered.'),
  "testRunId": zod.uuid().describe('A successful test run of exactly this definition.'),
  "activate": zod.boolean().default(createWebDiscoveryJobBodyActivateDefault).describe('Start scheduled runs immediately.')
})




export const createWebDiscoveryJobResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "targetingProfileId": zod.uuid().nullable(),
  "sourceIds": zod.array(zod.uuid()),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string(),
  "searchQueries": zod.array(zod.string()),
  "cadenceMinutes": zod.int(),
  "status": zod.enum(['draft', 'active', 'paused']),
  "revision": zod.int().min(1),
  "definitionHash": zod.string(),
  "tested": zod.boolean().describe('The current definition has a successful test run.'),
  "lastSuccessfulTestRunId": zod.uuid().nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "updatedBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Test a saved or unsaved job definition without adding anything to the Review queue
 */
export const testWebDiscoveryJobDefinitionBodyDefinitionNameMax = 160;

export const testWebDiscoveryJobDefinitionBodyDefinitionDescriptionMax = 2000;

export const testWebDiscoveryJobDefinitionBodyDefinitionSourceIdsMax = 25;

export const testWebDiscoveryJobDefinitionBodyDefinitionAiInstructionsMax = 8000;

export const testWebDiscoveryJobDefinitionBodyDefinitionSearchQueriesItemMax = 200;

export const testWebDiscoveryJobDefinitionBodyDefinitionSearchQueriesMax = 10;

export const testWebDiscoveryJobDefinitionBodyDefinitionCadenceMinutesMin = 60;
export const testWebDiscoveryJobDefinitionBodyDefinitionCadenceMinutesMax = 525600;



export const testWebDiscoveryJobDefinitionBody = zod.object({
  "definition": zod.object({
  "name": zod.string().min(1).max(testWebDiscoveryJobDefinitionBodyDefinitionNameMax),
  "description": zod.string().max(testWebDiscoveryJobDefinitionBodyDefinitionDescriptionMax).nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "sourceIds": zod.array(zod.uuid()).max(testWebDiscoveryJobDefinitionBodyDefinitionSourceIdsMax),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string().min(1).max(testWebDiscoveryJobDefinitionBodyDefinitionAiInstructionsMax),
  "searchQueries": zod.array(zod.string().min(1).max(testWebDiscoveryJobDefinitionBodyDefinitionSearchQueriesItemMax)).max(testWebDiscoveryJobDefinitionBodyDefinitionSearchQueriesMax),
  "cadenceMinutes": zod.int().min(testWebDiscoveryJobDefinitionBodyDefinitionCadenceMinutesMin).max(testWebDiscoveryJobDefinitionBodyDefinitionCadenceMinutesMax).describe('Schedule interval; at least hourly.')
}).describe('What a job checks and how AI picks out opportunities. Its hash identifies the exact definition a test run covered.'),
  "jobId": zod.uuid().optional().describe('The saved job being edited, if any.')
})

export const testWebDiscoveryJobDefinitionResponseRunDefinitionNameMax = 160;

export const testWebDiscoveryJobDefinitionResponseRunDefinitionDescriptionMax = 2000;

export const testWebDiscoveryJobDefinitionResponseRunDefinitionSourceIdsMax = 25;

export const testWebDiscoveryJobDefinitionResponseRunDefinitionAiInstructionsMax = 8000;

export const testWebDiscoveryJobDefinitionResponseRunDefinitionSearchQueriesItemMax = 200;

export const testWebDiscoveryJobDefinitionResponseRunDefinitionSearchQueriesMax = 10;

export const testWebDiscoveryJobDefinitionResponseRunDefinitionCadenceMinutesMin = 60;
export const testWebDiscoveryJobDefinitionResponseRunDefinitionCadenceMinutesMax = 525600;

export const testWebDiscoveryJobDefinitionResponseRunDurationMsMin = 0;

export const testWebDiscoveryJobDefinitionResponseRunSourcesCheckedItemPagesFetchedMin = 0;

export const testWebDiscoveryJobDefinitionResponseRunPagesFetchedMin = 0;

export const testWebDiscoveryJobDefinitionResponseRunSearchQueriesRunMin = 0;

export const testWebDiscoveryJobDefinitionResponseRunResultsFoundMin = 0;

export const testWebDiscoveryJobDefinitionResponseRunNewCandidatesMin = 0;

export const testWebDiscoveryJobDefinitionResponseRunDuplicatesMin = 0;

export const testWebDiscoveryJobDefinitionResponseRunTokenUsagePromptTokensMin = 0;

export const testWebDiscoveryJobDefinitionResponseRunTokenUsageCompletionTokensMin = 0;

export const testWebDiscoveryJobDefinitionResponseRunTokenUsageTotalTokensMin = 0;

export const testWebDiscoveryJobDefinitionResponseResultsItemPositionMin = 0;

export const testWebDiscoveryJobDefinitionResponseResultsMax = 50;



export const testWebDiscoveryJobDefinitionResponse = zod.object({
  "run": zod.object({
  "id": zod.uuid(),
  "jobId": zod.uuid().nullable().describe('Null for a test of an unsaved definition.'),
  "trigger": zod.enum(['test', 'manual', 'schedule']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'partial', 'failed']),
  "definitionHash": zod.string(),
  "definition": zod.object({
  "name": zod.string().min(1).max(testWebDiscoveryJobDefinitionResponseRunDefinitionNameMax),
  "description": zod.string().max(testWebDiscoveryJobDefinitionResponseRunDefinitionDescriptionMax).nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "sourceIds": zod.array(zod.uuid()).max(testWebDiscoveryJobDefinitionResponseRunDefinitionSourceIdsMax),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string().min(1).max(testWebDiscoveryJobDefinitionResponseRunDefinitionAiInstructionsMax),
  "searchQueries": zod.array(zod.string().min(1).max(testWebDiscoveryJobDefinitionResponseRunDefinitionSearchQueriesItemMax)).max(testWebDiscoveryJobDefinitionResponseRunDefinitionSearchQueriesMax),
  "cadenceMinutes": zod.int().min(testWebDiscoveryJobDefinitionResponseRunDefinitionCadenceMinutesMin).max(testWebDiscoveryJobDefinitionResponseRunDefinitionCadenceMinutesMax).describe('Schedule interval; at least hourly.')
}).describe('What a job checks and how AI picks out opportunities. Its hash identifies the exact definition a test run covered.'),
  "requestedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "durationMs": zod.int().min(testWebDiscoveryJobDefinitionResponseRunDurationMsMin).nullable(),
  "sourcesChecked": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "name": zod.string(),
  "status": zod.enum(['checked', 'skipped', 'failed']),
  "pagesFetched": zod.int().min(testWebDiscoveryJobDefinitionResponseRunSourcesCheckedItemPagesFetchedMin),
  "message": zod.string().nullable()
})),
  "pagesFetched": zod.int().min(testWebDiscoveryJobDefinitionResponseRunPagesFetchedMin),
  "searchQueriesRun": zod.int().min(testWebDiscoveryJobDefinitionResponseRunSearchQueriesRunMin),
  "resultsFound": zod.int().min(testWebDiscoveryJobDefinitionResponseRunResultsFoundMin),
  "newCandidates": zod.int().min(testWebDiscoveryJobDefinitionResponseRunNewCandidatesMin),
  "duplicates": zod.int().min(testWebDiscoveryJobDefinitionResponseRunDuplicatesMin),
  "webSearchState": zod.enum(['disabled', 'used', 'skipped', 'failed']),
  "webSearchMessage": zod.string().nullable().describe('Why web search was skipped or failed.'),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "tokenUsage": zod.object({
  "promptTokens": zod.int().min(testWebDiscoveryJobDefinitionResponseRunTokenUsagePromptTokensMin),
  "completionTokens": zod.int().min(testWebDiscoveryJobDefinitionResponseRunTokenUsageCompletionTokensMin),
  "totalTokens": zod.int().min(testWebDiscoveryJobDefinitionResponseRunTokenUsageTotalTokensMin)
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "results": zod.array(zod.object({
  "id": zod.uuid(),
  "runId": zod.uuid(),
  "position": zod.int().min(testWebDiscoveryJobDefinitionResponseResultsItemPositionMin),
  "title": zod.string(),
  "url": zod.string(),
  "canonicalUrl": zod.string(),
  "summary": zod.string(),
  "extractedFields": zod.record(zod.string(), zod.unknown()),
  "suggestedIndustry": zod.string().nullable(),
  "origin": zod.enum(['site', 'web_search']),
  "sourceId": zod.uuid().nullable(),
  "candidateId": zod.uuid().nullable().describe('The Review queue candidate created or matched; always null for test runs.'),
  "duplicate": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(testWebDiscoveryJobDefinitionResponseResultsMax),
  "warnings": zod.array(zod.string())
})


/**
 * @summary Get one saved job
 */
export const getWebDiscoveryJobParams = zod.object({
  "jobId": zod.uuid()
})




export const getWebDiscoveryJobResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "targetingProfileId": zod.uuid().nullable(),
  "sourceIds": zod.array(zod.uuid()),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string(),
  "searchQueries": zod.array(zod.string()),
  "cadenceMinutes": zod.int(),
  "status": zod.enum(['draft', 'active', 'paused']),
  "revision": zod.int().min(1),
  "definitionHash": zod.string(),
  "tested": zod.boolean().describe('The current definition has a successful test run.'),
  "lastSuccessfulTestRunId": zod.uuid().nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "updatedBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Edit, activate or pause a job; a changed definition needs a successful test of that definition
 */
export const updateWebDiscoveryJobParams = zod.object({
  "jobId": zod.uuid()
})


export const updateWebDiscoveryJobBodyDefinitionNameMax = 160;

export const updateWebDiscoveryJobBodyDefinitionDescriptionMax = 2000;

export const updateWebDiscoveryJobBodyDefinitionSourceIdsMax = 25;

export const updateWebDiscoveryJobBodyDefinitionAiInstructionsMax = 8000;

export const updateWebDiscoveryJobBodyDefinitionSearchQueriesItemMax = 200;

export const updateWebDiscoveryJobBodyDefinitionSearchQueriesMax = 10;

export const updateWebDiscoveryJobBodyDefinitionCadenceMinutesMin = 60;
export const updateWebDiscoveryJobBodyDefinitionCadenceMinutesMax = 525600;



export const updateWebDiscoveryJobBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "definition": zod.object({
  "name": zod.string().min(1).max(updateWebDiscoveryJobBodyDefinitionNameMax),
  "description": zod.string().max(updateWebDiscoveryJobBodyDefinitionDescriptionMax).nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "sourceIds": zod.array(zod.uuid()).max(updateWebDiscoveryJobBodyDefinitionSourceIdsMax),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string().min(1).max(updateWebDiscoveryJobBodyDefinitionAiInstructionsMax),
  "searchQueries": zod.array(zod.string().min(1).max(updateWebDiscoveryJobBodyDefinitionSearchQueriesItemMax)).max(updateWebDiscoveryJobBodyDefinitionSearchQueriesMax),
  "cadenceMinutes": zod.int().min(updateWebDiscoveryJobBodyDefinitionCadenceMinutesMin).max(updateWebDiscoveryJobBodyDefinitionCadenceMinutesMax).describe('Schedule interval; at least hourly.')
}).optional().describe('What a job checks and how AI picks out opportunities. Its hash identifies the exact definition a test run covered.'),
  "testRunId": zod.uuid().optional().describe('Required when the definition changes.'),
  "status": zod.enum(['draft', 'active', 'paused']).optional()
})




export const updateWebDiscoveryJobResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullable(),
  "targetingProfileId": zod.uuid().nullable(),
  "sourceIds": zod.array(zod.uuid()),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string(),
  "searchQueries": zod.array(zod.string()),
  "cadenceMinutes": zod.int(),
  "status": zod.enum(['draft', 'active', 'paused']),
  "revision": zod.int().min(1),
  "definitionHash": zod.string(),
  "tested": zod.boolean().describe('The current definition has a successful test run.'),
  "lastSuccessfulTestRunId": zod.uuid().nullable(),
  "lastRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "nextRunAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdBy": zod.string(),
  "updatedBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a job and its run history; Review queue candidates are kept
 */
export const deleteWebDiscoveryJobParams = zod.object({
  "jobId": zod.uuid()
})




export const deleteWebDiscoveryJobQueryParams = zod.object({
  "expectedRevision": zod.int().min(1)
})

export const deleteWebDiscoveryJobResponse = zod.void()


/**
 * @summary List a job's execution history, newest first
 */
export const listWebDiscoveryJobRunsParams = zod.object({
  "jobId": zod.uuid()
})

export const listWebDiscoveryJobRunsQueryLimitDefault = 25;
export const listWebDiscoveryJobRunsQueryLimitMax = 100;

export const listWebDiscoveryJobRunsQueryOffsetDefault = 0;
export const listWebDiscoveryJobRunsQueryOffsetMin = 0;



export const listWebDiscoveryJobRunsQueryParams = zod.object({
  "trigger": zod.enum(['test', 'manual', 'schedule']).optional(),
  "limit": zod.int().min(1).max(listWebDiscoveryJobRunsQueryLimitMax).default(listWebDiscoveryJobRunsQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoveryJobRunsQueryOffsetMin).default(listWebDiscoveryJobRunsQueryOffsetDefault)
})

export const listWebDiscoveryJobRunsResponseItemsItemDefinitionNameMax = 160;

export const listWebDiscoveryJobRunsResponseItemsItemDefinitionDescriptionMax = 2000;

export const listWebDiscoveryJobRunsResponseItemsItemDefinitionSourceIdsMax = 25;

export const listWebDiscoveryJobRunsResponseItemsItemDefinitionAiInstructionsMax = 8000;

export const listWebDiscoveryJobRunsResponseItemsItemDefinitionSearchQueriesItemMax = 200;

export const listWebDiscoveryJobRunsResponseItemsItemDefinitionSearchQueriesMax = 10;

export const listWebDiscoveryJobRunsResponseItemsItemDefinitionCadenceMinutesMin = 60;
export const listWebDiscoveryJobRunsResponseItemsItemDefinitionCadenceMinutesMax = 525600;

export const listWebDiscoveryJobRunsResponseItemsItemDurationMsMin = 0;

export const listWebDiscoveryJobRunsResponseItemsItemSourcesCheckedItemPagesFetchedMin = 0;

export const listWebDiscoveryJobRunsResponseItemsItemPagesFetchedMin = 0;

export const listWebDiscoveryJobRunsResponseItemsItemSearchQueriesRunMin = 0;

export const listWebDiscoveryJobRunsResponseItemsItemResultsFoundMin = 0;

export const listWebDiscoveryJobRunsResponseItemsItemNewCandidatesMin = 0;

export const listWebDiscoveryJobRunsResponseItemsItemDuplicatesMin = 0;

export const listWebDiscoveryJobRunsResponseItemsItemTokenUsagePromptTokensMin = 0;

export const listWebDiscoveryJobRunsResponseItemsItemTokenUsageCompletionTokensMin = 0;

export const listWebDiscoveryJobRunsResponseItemsItemTokenUsageTotalTokensMin = 0;

export const listWebDiscoveryJobRunsResponseTotalMin = 0;


export const listWebDiscoveryJobRunsResponseOffsetMin = 0;



export const listWebDiscoveryJobRunsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "jobId": zod.uuid().nullable().describe('Null for a test of an unsaved definition.'),
  "trigger": zod.enum(['test', 'manual', 'schedule']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'partial', 'failed']),
  "definitionHash": zod.string(),
  "definition": zod.object({
  "name": zod.string().min(1).max(listWebDiscoveryJobRunsResponseItemsItemDefinitionNameMax),
  "description": zod.string().max(listWebDiscoveryJobRunsResponseItemsItemDefinitionDescriptionMax).nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "sourceIds": zod.array(zod.uuid()).max(listWebDiscoveryJobRunsResponseItemsItemDefinitionSourceIdsMax),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string().min(1).max(listWebDiscoveryJobRunsResponseItemsItemDefinitionAiInstructionsMax),
  "searchQueries": zod.array(zod.string().min(1).max(listWebDiscoveryJobRunsResponseItemsItemDefinitionSearchQueriesItemMax)).max(listWebDiscoveryJobRunsResponseItemsItemDefinitionSearchQueriesMax),
  "cadenceMinutes": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemDefinitionCadenceMinutesMin).max(listWebDiscoveryJobRunsResponseItemsItemDefinitionCadenceMinutesMax).describe('Schedule interval; at least hourly.')
}).describe('What a job checks and how AI picks out opportunities. Its hash identifies the exact definition a test run covered.'),
  "requestedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "durationMs": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemDurationMsMin).nullable(),
  "sourcesChecked": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "name": zod.string(),
  "status": zod.enum(['checked', 'skipped', 'failed']),
  "pagesFetched": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemSourcesCheckedItemPagesFetchedMin),
  "message": zod.string().nullable()
})),
  "pagesFetched": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemPagesFetchedMin),
  "searchQueriesRun": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemSearchQueriesRunMin),
  "resultsFound": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemResultsFoundMin),
  "newCandidates": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemNewCandidatesMin),
  "duplicates": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemDuplicatesMin),
  "webSearchState": zod.enum(['disabled', 'used', 'skipped', 'failed']),
  "webSearchMessage": zod.string().nullable().describe('Why web search was skipped or failed.'),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "tokenUsage": zod.object({
  "promptTokens": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemTokenUsagePromptTokensMin),
  "completionTokens": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemTokenUsageCompletionTokensMin),
  "totalTokens": zod.int().min(listWebDiscoveryJobRunsResponseItemsItemTokenUsageTotalTokensMin)
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listWebDiscoveryJobRunsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoveryJobRunsResponseOffsetMin)
})


/**
 * @summary Run a saved, tested job now
 */
export const runWebDiscoveryJobParams = zod.object({
  "jobId": zod.uuid()
})




export const runWebDiscoveryJobBody = zod.object({
  "expectedRevision": zod.int().min(1)
})

export const runWebDiscoveryJobResponseDefinitionNameMax = 160;

export const runWebDiscoveryJobResponseDefinitionDescriptionMax = 2000;

export const runWebDiscoveryJobResponseDefinitionSourceIdsMax = 25;

export const runWebDiscoveryJobResponseDefinitionAiInstructionsMax = 8000;

export const runWebDiscoveryJobResponseDefinitionSearchQueriesItemMax = 200;

export const runWebDiscoveryJobResponseDefinitionSearchQueriesMax = 10;

export const runWebDiscoveryJobResponseDefinitionCadenceMinutesMin = 60;
export const runWebDiscoveryJobResponseDefinitionCadenceMinutesMax = 525600;

export const runWebDiscoveryJobResponseDurationMsMin = 0;

export const runWebDiscoveryJobResponseSourcesCheckedItemPagesFetchedMin = 0;

export const runWebDiscoveryJobResponsePagesFetchedMin = 0;

export const runWebDiscoveryJobResponseSearchQueriesRunMin = 0;

export const runWebDiscoveryJobResponseResultsFoundMin = 0;

export const runWebDiscoveryJobResponseNewCandidatesMin = 0;

export const runWebDiscoveryJobResponseDuplicatesMin = 0;

export const runWebDiscoveryJobResponseTokenUsagePromptTokensMin = 0;

export const runWebDiscoveryJobResponseTokenUsageCompletionTokensMin = 0;

export const runWebDiscoveryJobResponseTokenUsageTotalTokensMin = 0;



export const runWebDiscoveryJobResponse = zod.object({
  "id": zod.uuid(),
  "jobId": zod.uuid().nullable().describe('Null for a test of an unsaved definition.'),
  "trigger": zod.enum(['test', 'manual', 'schedule']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'partial', 'failed']),
  "definitionHash": zod.string(),
  "definition": zod.object({
  "name": zod.string().min(1).max(runWebDiscoveryJobResponseDefinitionNameMax),
  "description": zod.string().max(runWebDiscoveryJobResponseDefinitionDescriptionMax).nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "sourceIds": zod.array(zod.uuid()).max(runWebDiscoveryJobResponseDefinitionSourceIdsMax),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string().min(1).max(runWebDiscoveryJobResponseDefinitionAiInstructionsMax),
  "searchQueries": zod.array(zod.string().min(1).max(runWebDiscoveryJobResponseDefinitionSearchQueriesItemMax)).max(runWebDiscoveryJobResponseDefinitionSearchQueriesMax),
  "cadenceMinutes": zod.int().min(runWebDiscoveryJobResponseDefinitionCadenceMinutesMin).max(runWebDiscoveryJobResponseDefinitionCadenceMinutesMax).describe('Schedule interval; at least hourly.')
}).describe('What a job checks and how AI picks out opportunities. Its hash identifies the exact definition a test run covered.'),
  "requestedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "durationMs": zod.int().min(runWebDiscoveryJobResponseDurationMsMin).nullable(),
  "sourcesChecked": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "name": zod.string(),
  "status": zod.enum(['checked', 'skipped', 'failed']),
  "pagesFetched": zod.int().min(runWebDiscoveryJobResponseSourcesCheckedItemPagesFetchedMin),
  "message": zod.string().nullable()
})),
  "pagesFetched": zod.int().min(runWebDiscoveryJobResponsePagesFetchedMin),
  "searchQueriesRun": zod.int().min(runWebDiscoveryJobResponseSearchQueriesRunMin),
  "resultsFound": zod.int().min(runWebDiscoveryJobResponseResultsFoundMin),
  "newCandidates": zod.int().min(runWebDiscoveryJobResponseNewCandidatesMin),
  "duplicates": zod.int().min(runWebDiscoveryJobResponseDuplicatesMin),
  "webSearchState": zod.enum(['disabled', 'used', 'skipped', 'failed']),
  "webSearchMessage": zod.string().nullable().describe('Why web search was skipped or failed.'),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "tokenUsage": zod.object({
  "promptTokens": zod.int().min(runWebDiscoveryJobResponseTokenUsagePromptTokensMin),
  "completionTokens": zod.int().min(runWebDiscoveryJobResponseTokenUsageCompletionTokensMin),
  "totalTokens": zod.int().min(runWebDiscoveryJobResponseTokenUsageTotalTokensMin)
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get one job run or test run
 */
export const getWebDiscoveryJobRunParams = zod.object({
  "runId": zod.uuid()
})

export const getWebDiscoveryJobRunResponseDefinitionNameMax = 160;

export const getWebDiscoveryJobRunResponseDefinitionDescriptionMax = 2000;

export const getWebDiscoveryJobRunResponseDefinitionSourceIdsMax = 25;

export const getWebDiscoveryJobRunResponseDefinitionAiInstructionsMax = 8000;

export const getWebDiscoveryJobRunResponseDefinitionSearchQueriesItemMax = 200;

export const getWebDiscoveryJobRunResponseDefinitionSearchQueriesMax = 10;

export const getWebDiscoveryJobRunResponseDefinitionCadenceMinutesMin = 60;
export const getWebDiscoveryJobRunResponseDefinitionCadenceMinutesMax = 525600;

export const getWebDiscoveryJobRunResponseDurationMsMin = 0;

export const getWebDiscoveryJobRunResponseSourcesCheckedItemPagesFetchedMin = 0;

export const getWebDiscoveryJobRunResponsePagesFetchedMin = 0;

export const getWebDiscoveryJobRunResponseSearchQueriesRunMin = 0;

export const getWebDiscoveryJobRunResponseResultsFoundMin = 0;

export const getWebDiscoveryJobRunResponseNewCandidatesMin = 0;

export const getWebDiscoveryJobRunResponseDuplicatesMin = 0;

export const getWebDiscoveryJobRunResponseTokenUsagePromptTokensMin = 0;

export const getWebDiscoveryJobRunResponseTokenUsageCompletionTokensMin = 0;

export const getWebDiscoveryJobRunResponseTokenUsageTotalTokensMin = 0;



export const getWebDiscoveryJobRunResponse = zod.object({
  "id": zod.uuid(),
  "jobId": zod.uuid().nullable().describe('Null for a test of an unsaved definition.'),
  "trigger": zod.enum(['test', 'manual', 'schedule']),
  "status": zod.enum(['queued', 'running', 'succeeded', 'partial', 'failed']),
  "definitionHash": zod.string(),
  "definition": zod.object({
  "name": zod.string().min(1).max(getWebDiscoveryJobRunResponseDefinitionNameMax),
  "description": zod.string().max(getWebDiscoveryJobRunResponseDefinitionDescriptionMax).nullish(),
  "targetingProfileId": zod.uuid().nullish(),
  "sourceIds": zod.array(zod.uuid()).max(getWebDiscoveryJobRunResponseDefinitionSourceIdsMax),
  "webSearchEnabled": zod.boolean(),
  "aiInstructions": zod.string().min(1).max(getWebDiscoveryJobRunResponseDefinitionAiInstructionsMax),
  "searchQueries": zod.array(zod.string().min(1).max(getWebDiscoveryJobRunResponseDefinitionSearchQueriesItemMax)).max(getWebDiscoveryJobRunResponseDefinitionSearchQueriesMax),
  "cadenceMinutes": zod.int().min(getWebDiscoveryJobRunResponseDefinitionCadenceMinutesMin).max(getWebDiscoveryJobRunResponseDefinitionCadenceMinutesMax).describe('Schedule interval; at least hourly.')
}).describe('What a job checks and how AI picks out opportunities. Its hash identifies the exact definition a test run covered.'),
  "requestedBy": zod.string(),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "durationMs": zod.int().min(getWebDiscoveryJobRunResponseDurationMsMin).nullable(),
  "sourcesChecked": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "name": zod.string(),
  "status": zod.enum(['checked', 'skipped', 'failed']),
  "pagesFetched": zod.int().min(getWebDiscoveryJobRunResponseSourcesCheckedItemPagesFetchedMin),
  "message": zod.string().nullable()
})),
  "pagesFetched": zod.int().min(getWebDiscoveryJobRunResponsePagesFetchedMin),
  "searchQueriesRun": zod.int().min(getWebDiscoveryJobRunResponseSearchQueriesRunMin),
  "resultsFound": zod.int().min(getWebDiscoveryJobRunResponseResultsFoundMin),
  "newCandidates": zod.int().min(getWebDiscoveryJobRunResponseNewCandidatesMin),
  "duplicates": zod.int().min(getWebDiscoveryJobRunResponseDuplicatesMin),
  "webSearchState": zod.enum(['disabled', 'used', 'skipped', 'failed']),
  "webSearchMessage": zod.string().nullable().describe('Why web search was skipped or failed.'),
  "errorCode": zod.string().nullable(),
  "errorMessage": zod.string().nullable(),
  "tokenUsage": zod.object({
  "promptTokens": zod.int().min(getWebDiscoveryJobRunResponseTokenUsagePromptTokensMin),
  "completionTokens": zod.int().min(getWebDiscoveryJobRunResponseTokenUsageCompletionTokensMin),
  "totalTokens": zod.int().min(getWebDiscoveryJobRunResponseTokenUsageTotalTokensMin)
}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List the opportunities a run returned
 */
export const listWebDiscoveryJobRunResultsParams = zod.object({
  "runId": zod.uuid()
})

export const listWebDiscoveryJobRunResultsQueryLimitDefault = 25;
export const listWebDiscoveryJobRunResultsQueryLimitMax = 100;

export const listWebDiscoveryJobRunResultsQueryOffsetDefault = 0;
export const listWebDiscoveryJobRunResultsQueryOffsetMin = 0;



export const listWebDiscoveryJobRunResultsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWebDiscoveryJobRunResultsQueryLimitMax).default(listWebDiscoveryJobRunResultsQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoveryJobRunResultsQueryOffsetMin).default(listWebDiscoveryJobRunResultsQueryOffsetDefault)
})

export const listWebDiscoveryJobRunResultsResponseItemsItemPositionMin = 0;

export const listWebDiscoveryJobRunResultsResponseTotalMin = 0;


export const listWebDiscoveryJobRunResultsResponseOffsetMin = 0;



export const listWebDiscoveryJobRunResultsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "runId": zod.uuid(),
  "position": zod.int().min(listWebDiscoveryJobRunResultsResponseItemsItemPositionMin),
  "title": zod.string(),
  "url": zod.string(),
  "canonicalUrl": zod.string(),
  "summary": zod.string(),
  "extractedFields": zod.record(zod.string(), zod.unknown()),
  "suggestedIndustry": zod.string().nullable(),
  "origin": zod.enum(['site', 'web_search']),
  "sourceId": zod.uuid().nullable(),
  "candidateId": zod.uuid().nullable().describe('The Review queue candidate created or matched; always null for test runs.'),
  "duplicate": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listWebDiscoveryJobRunResultsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoveryJobRunResultsResponseOffsetMin)
})


/**
 * @summary Get a candidate's industry, notes, extra information, AI assessment and decision
 */
export const getWebDiscoveryCandidateEnrichmentParams = zod.object({
  "candidateId": zod.uuid()
})

export const getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemLabelMax = 120;

export const getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemValueMax = 4000;

export const getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsItemTitleMax = 300;

export const getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsItemUrlMax = 2048;

export const getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsMax = 10;

export const getWebDiscoveryCandidateEnrichmentResponseAssessmentOneCitationsItemTitleMax = 300;

export const getWebDiscoveryCandidateEnrichmentResponseAssessmentOneCitationsItemUrlMax = 2048;

export const getWebDiscoveryCandidateEnrichmentResponseRevisionMin = 0;



export const getWebDiscoveryCandidateEnrichmentResponse = zod.object({
  "candidateId": zod.uuid(),
  "jobId": zod.uuid().nullable(),
  "runId": zod.uuid().nullable(),
  "industry": zod.string().nullable(),
  "industrySource": zod.enum(['ai', 'human']).nullable(),
  "notes": zod.string().nullable(),
  "extraInformation": zod.array(zod.object({
  "label": zod.string().min(1).max(getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemLabelMax),
  "value": zod.string().min(1).max(getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemValueMax),
  "source": zod.enum(['human', 'ai']),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsItemTitleMax),
  "url": zod.url().max(getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsItemUrlMax)
})).max(getWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsMax)
})),
  "assessment": zod.union([zod.object({
  "recommendation": zod.enum(['pursue', 'do_not_pursue', 'needs_more_information']),
  "reasons": zod.array(zod.string()),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(getWebDiscoveryCandidateEnrichmentResponseAssessmentOneCitationsItemTitleMax),
  "url": zod.url().max(getWebDiscoveryCandidateEnrichmentResponseAssessmentOneCitationsItemUrlMax)
})),
  "assessedAt": zod.iso.datetime({"offset":true})
}).describe('AI suggestion only; a person records the decision.'),zod.null()]),
  "decision": zod.union([zod.object({
  "decision": zod.enum(['pursue', 'not_pursuing']),
  "decidedBy": zod.string(),
  "decidedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().nullable()
}),zod.null()]),
  "revision": zod.int().min(getWebDiscoveryCandidateEnrichmentResponseRevisionMin).describe('0 until something is saved.'),
  "updatedBy": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Change a candidate's industry, notes or extra information
 */
export const updateWebDiscoveryCandidateEnrichmentParams = zod.object({
  "candidateId": zod.uuid()
})

export const updateWebDiscoveryCandidateEnrichmentBodyExpectedRevisionMin = 0;

export const updateWebDiscoveryCandidateEnrichmentBodyIndustryMax = 120;

export const updateWebDiscoveryCandidateEnrichmentBodyNotesMax = 10000;

export const updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemLabelMax = 120;

export const updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemValueMax = 4000;

export const updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemCitationsItemTitleMax = 300;

export const updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemCitationsItemUrlMax = 2048;

export const updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemCitationsMax = 10;

export const updateWebDiscoveryCandidateEnrichmentBodyExtraInformationMax = 50;



export const updateWebDiscoveryCandidateEnrichmentBody = zod.object({
  "expectedRevision": zod.int().min(updateWebDiscoveryCandidateEnrichmentBodyExpectedRevisionMin),
  "industry": zod.string().min(1).max(updateWebDiscoveryCandidateEnrichmentBodyIndustryMax).nullish(),
  "notes": zod.string().max(updateWebDiscoveryCandidateEnrichmentBodyNotesMax).nullish(),
  "extraInformation": zod.array(zod.object({
  "label": zod.string().min(1).max(updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemLabelMax),
  "value": zod.string().min(1).max(updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemValueMax),
  "source": zod.enum(['human', 'ai']),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemCitationsItemTitleMax),
  "url": zod.url().max(updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemCitationsItemUrlMax)
})).max(updateWebDiscoveryCandidateEnrichmentBodyExtraInformationItemCitationsMax)
})).max(updateWebDiscoveryCandidateEnrichmentBodyExtraInformationMax).optional()
})

export const updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemLabelMax = 120;

export const updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemValueMax = 4000;

export const updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsItemTitleMax = 300;

export const updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsItemUrlMax = 2048;

export const updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsMax = 10;

export const updateWebDiscoveryCandidateEnrichmentResponseAssessmentOneCitationsItemTitleMax = 300;

export const updateWebDiscoveryCandidateEnrichmentResponseAssessmentOneCitationsItemUrlMax = 2048;

export const updateWebDiscoveryCandidateEnrichmentResponseRevisionMin = 0;



export const updateWebDiscoveryCandidateEnrichmentResponse = zod.object({
  "candidateId": zod.uuid(),
  "jobId": zod.uuid().nullable(),
  "runId": zod.uuid().nullable(),
  "industry": zod.string().nullable(),
  "industrySource": zod.enum(['ai', 'human']).nullable(),
  "notes": zod.string().nullable(),
  "extraInformation": zod.array(zod.object({
  "label": zod.string().min(1).max(updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemLabelMax),
  "value": zod.string().min(1).max(updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemValueMax),
  "source": zod.enum(['human', 'ai']),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsItemTitleMax),
  "url": zod.url().max(updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsItemUrlMax)
})).max(updateWebDiscoveryCandidateEnrichmentResponseExtraInformationItemCitationsMax)
})),
  "assessment": zod.union([zod.object({
  "recommendation": zod.enum(['pursue', 'do_not_pursue', 'needs_more_information']),
  "reasons": zod.array(zod.string()),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(updateWebDiscoveryCandidateEnrichmentResponseAssessmentOneCitationsItemTitleMax),
  "url": zod.url().max(updateWebDiscoveryCandidateEnrichmentResponseAssessmentOneCitationsItemUrlMax)
})),
  "assessedAt": zod.iso.datetime({"offset":true})
}).describe('AI suggestion only; a person records the decision.'),zod.null()]),
  "decision": zod.union([zod.object({
  "decision": zod.enum(['pursue', 'not_pursuing']),
  "decidedBy": zod.string(),
  "decidedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().nullable()
}),zod.null()]),
  "revision": zod.int().min(updateWebDiscoveryCandidateEnrichmentResponseRevisionMin).describe('0 until something is saved.'),
  "updatedBy": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Ask AI for cited extra information; nothing is saved until the reviewer keeps it
 */
export const requestWebDiscoveryCandidateEnrichmentParams = zod.object({
  "candidateId": zod.uuid()
})

export const requestWebDiscoveryCandidateEnrichmentBodyExpectedRevisionMin = 0;

export const requestWebDiscoveryCandidateEnrichmentBodyFocusMax = 1000;



export const requestWebDiscoveryCandidateEnrichmentBody = zod.object({
  "expectedRevision": zod.int().min(requestWebDiscoveryCandidateEnrichmentBodyExpectedRevisionMin),
  "focus": zod.string().max(requestWebDiscoveryCandidateEnrichmentBodyFocusMax).optional().describe('What the reviewer wants to know more about.')
})

export const requestWebDiscoveryCandidateEnrichmentResponseEntriesItemLabelMax = 120;

export const requestWebDiscoveryCandidateEnrichmentResponseEntriesItemValueMax = 4000;

export const requestWebDiscoveryCandidateEnrichmentResponseEntriesItemCitationsItemTitleMax = 300;

export const requestWebDiscoveryCandidateEnrichmentResponseEntriesItemCitationsItemUrlMax = 2048;

export const requestWebDiscoveryCandidateEnrichmentResponseEntriesItemCitationsMax = 10;

export const requestWebDiscoveryCandidateEnrichmentResponseTokenUsagePromptTokensMin = 0;

export const requestWebDiscoveryCandidateEnrichmentResponseTokenUsageCompletionTokensMin = 0;

export const requestWebDiscoveryCandidateEnrichmentResponseTokenUsageTotalTokensMin = 0;



export const requestWebDiscoveryCandidateEnrichmentResponse = zod.object({
  "candidateId": zod.uuid(),
  "entries": zod.array(zod.object({
  "label": zod.string().min(1).max(requestWebDiscoveryCandidateEnrichmentResponseEntriesItemLabelMax),
  "value": zod.string().min(1).max(requestWebDiscoveryCandidateEnrichmentResponseEntriesItemValueMax),
  "source": zod.enum(['human', 'ai']),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(requestWebDiscoveryCandidateEnrichmentResponseEntriesItemCitationsItemTitleMax),
  "url": zod.url().max(requestWebDiscoveryCandidateEnrichmentResponseEntriesItemCitationsItemUrlMax)
})).max(requestWebDiscoveryCandidateEnrichmentResponseEntriesItemCitationsMax)
})),
  "tokenUsage": zod.object({
  "promptTokens": zod.int().min(requestWebDiscoveryCandidateEnrichmentResponseTokenUsagePromptTokensMin),
  "completionTokens": zod.int().min(requestWebDiscoveryCandidateEnrichmentResponseTokenUsageCompletionTokensMin),
  "totalTokens": zod.int().min(requestWebDiscoveryCandidateEnrichmentResponseTokenUsageTotalTokensMin)
})
})


/**
 * @summary Ask AI to recommend whether to pursue the candidate, with reasons and citations
 */
export const requestWebDiscoveryCandidateAssessmentParams = zod.object({
  "candidateId": zod.uuid()
})

export const requestWebDiscoveryCandidateAssessmentBodyExpectedRevisionMin = 0;



export const requestWebDiscoveryCandidateAssessmentBody = zod.object({
  "expectedRevision": zod.int().min(requestWebDiscoveryCandidateAssessmentBodyExpectedRevisionMin)
})

export const requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemLabelMax = 120;

export const requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemValueMax = 4000;

export const requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemCitationsItemTitleMax = 300;

export const requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemCitationsItemUrlMax = 2048;

export const requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemCitationsMax = 10;

export const requestWebDiscoveryCandidateAssessmentResponseAssessmentOneCitationsItemTitleMax = 300;

export const requestWebDiscoveryCandidateAssessmentResponseAssessmentOneCitationsItemUrlMax = 2048;

export const requestWebDiscoveryCandidateAssessmentResponseRevisionMin = 0;



export const requestWebDiscoveryCandidateAssessmentResponse = zod.object({
  "candidateId": zod.uuid(),
  "jobId": zod.uuid().nullable(),
  "runId": zod.uuid().nullable(),
  "industry": zod.string().nullable(),
  "industrySource": zod.enum(['ai', 'human']).nullable(),
  "notes": zod.string().nullable(),
  "extraInformation": zod.array(zod.object({
  "label": zod.string().min(1).max(requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemLabelMax),
  "value": zod.string().min(1).max(requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemValueMax),
  "source": zod.enum(['human', 'ai']),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemCitationsItemTitleMax),
  "url": zod.url().max(requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemCitationsItemUrlMax)
})).max(requestWebDiscoveryCandidateAssessmentResponseExtraInformationItemCitationsMax)
})),
  "assessment": zod.union([zod.object({
  "recommendation": zod.enum(['pursue', 'do_not_pursue', 'needs_more_information']),
  "reasons": zod.array(zod.string()),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(requestWebDiscoveryCandidateAssessmentResponseAssessmentOneCitationsItemTitleMax),
  "url": zod.url().max(requestWebDiscoveryCandidateAssessmentResponseAssessmentOneCitationsItemUrlMax)
})),
  "assessedAt": zod.iso.datetime({"offset":true})
}).describe('AI suggestion only; a person records the decision.'),zod.null()]),
  "decision": zod.union([zod.object({
  "decision": zod.enum(['pursue', 'not_pursuing']),
  "decidedBy": zod.string(),
  "decidedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().nullable()
}),zod.null()]),
  "revision": zod.int().min(requestWebDiscoveryCandidateAssessmentResponseRevisionMin).describe('0 until something is saved.'),
  "updatedBy": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Record Pursue or Not pursuing; nothing is created in pursuits or proposals
 */
export const recordWebDiscoveryCandidateDecisionParams = zod.object({
  "candidateId": zod.uuid()
})

export const recordWebDiscoveryCandidateDecisionBodyExpectedRevisionMin = 0;

export const recordWebDiscoveryCandidateDecisionBodyReasonMax = 2000;



export const recordWebDiscoveryCandidateDecisionBody = zod.object({
  "expectedRevision": zod.int().min(recordWebDiscoveryCandidateDecisionBodyExpectedRevisionMin),
  "decision": zod.enum(['pursue', 'not_pursuing']),
  "reason": zod.string().max(recordWebDiscoveryCandidateDecisionBodyReasonMax).optional()
})

export const recordWebDiscoveryCandidateDecisionResponseExtraInformationItemLabelMax = 120;

export const recordWebDiscoveryCandidateDecisionResponseExtraInformationItemValueMax = 4000;

export const recordWebDiscoveryCandidateDecisionResponseExtraInformationItemCitationsItemTitleMax = 300;

export const recordWebDiscoveryCandidateDecisionResponseExtraInformationItemCitationsItemUrlMax = 2048;

export const recordWebDiscoveryCandidateDecisionResponseExtraInformationItemCitationsMax = 10;

export const recordWebDiscoveryCandidateDecisionResponseAssessmentOneCitationsItemTitleMax = 300;

export const recordWebDiscoveryCandidateDecisionResponseAssessmentOneCitationsItemUrlMax = 2048;

export const recordWebDiscoveryCandidateDecisionResponseRevisionMin = 0;



export const recordWebDiscoveryCandidateDecisionResponse = zod.object({
  "candidateId": zod.uuid(),
  "jobId": zod.uuid().nullable(),
  "runId": zod.uuid().nullable(),
  "industry": zod.string().nullable(),
  "industrySource": zod.enum(['ai', 'human']).nullable(),
  "notes": zod.string().nullable(),
  "extraInformation": zod.array(zod.object({
  "label": zod.string().min(1).max(recordWebDiscoveryCandidateDecisionResponseExtraInformationItemLabelMax),
  "value": zod.string().min(1).max(recordWebDiscoveryCandidateDecisionResponseExtraInformationItemValueMax),
  "source": zod.enum(['human', 'ai']),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(recordWebDiscoveryCandidateDecisionResponseExtraInformationItemCitationsItemTitleMax),
  "url": zod.url().max(recordWebDiscoveryCandidateDecisionResponseExtraInformationItemCitationsItemUrlMax)
})).max(recordWebDiscoveryCandidateDecisionResponseExtraInformationItemCitationsMax)
})),
  "assessment": zod.union([zod.object({
  "recommendation": zod.enum(['pursue', 'do_not_pursue', 'needs_more_information']),
  "reasons": zod.array(zod.string()),
  "citations": zod.array(zod.object({
  "title": zod.string().min(1).max(recordWebDiscoveryCandidateDecisionResponseAssessmentOneCitationsItemTitleMax),
  "url": zod.url().max(recordWebDiscoveryCandidateDecisionResponseAssessmentOneCitationsItemUrlMax)
})),
  "assessedAt": zod.iso.datetime({"offset":true})
}).describe('AI suggestion only; a person records the decision.'),zod.null()]),
  "decision": zod.union([zod.object({
  "decision": zod.enum(['pursue', 'not_pursuing']),
  "decidedBy": zod.string(),
  "decidedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().nullable()
}),zod.null()]),
  "revision": zod.int().min(recordWebDiscoveryCandidateDecisionResponseRevisionMin).describe('0 until something is saved.'),
  "updatedBy": zod.string().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary List documents attached to a candidate
 */
export const listWebDiscoveryCandidateDocumentsParams = zod.object({
  "candidateId": zod.uuid()
})

export const listWebDiscoveryCandidateDocumentsQueryLimitDefault = 25;
export const listWebDiscoveryCandidateDocumentsQueryLimitMax = 100;

export const listWebDiscoveryCandidateDocumentsQueryOffsetDefault = 0;
export const listWebDiscoveryCandidateDocumentsQueryOffsetMin = 0;



export const listWebDiscoveryCandidateDocumentsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWebDiscoveryCandidateDocumentsQueryLimitMax).default(listWebDiscoveryCandidateDocumentsQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoveryCandidateDocumentsQueryOffsetMin).default(listWebDiscoveryCandidateDocumentsQueryOffsetDefault)
})

export const listWebDiscoveryCandidateDocumentsResponseTotalMin = 0;


export const listWebDiscoveryCandidateDocumentsResponseOffsetMin = 0;



export const listWebDiscoveryCandidateDocumentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "documentId": zod.uuid(),
  "label": zod.string().nullable(),
  "title": zod.string(),
  "sourceUrl": zod.string().nullable(),
  "addedBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listWebDiscoveryCandidateDocumentsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoveryCandidateDocumentsResponseOffsetMin)
})


/**
 * @summary Attach an existing Web signals document to a candidate
 */
export const addWebDiscoveryCandidateDocumentParams = zod.object({
  "candidateId": zod.uuid()
})

export const addWebDiscoveryCandidateDocumentBodyLabelMax = 160;



export const addWebDiscoveryCandidateDocumentBody = zod.object({
  "documentId": zod.uuid(),
  "label": zod.string().min(1).max(addWebDiscoveryCandidateDocumentBodyLabelMax).optional()
})

export const addWebDiscoveryCandidateDocumentResponse = zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "documentId": zod.uuid(),
  "label": zod.string().nullable(),
  "title": zod.string(),
  "sourceUrl": zod.string().nullable(),
  "addedBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Upload a file (PDF, Word, Excel, PowerPoint, text, CSV, Markdown or HTML, up to 10 MB) into Web signals documents and attach it to a candidate
 */
export const uploadWebDiscoveryCandidateDocumentParams = zod.object({
  "candidateId": zod.uuid()
})

export const uploadWebDiscoveryCandidateDocumentBodyFilenameMax = 255;

export const uploadWebDiscoveryCandidateDocumentBodyContentTypeMin = 3;
export const uploadWebDiscoveryCandidateDocumentBodyContentTypeMax = 200;

export const uploadWebDiscoveryCandidateDocumentBodyDataBase64Min = 4;
export const uploadWebDiscoveryCandidateDocumentBodyDataBase64Max = 13981016;

export const uploadWebDiscoveryCandidateDocumentBodyLabelMax = 160;



export const uploadWebDiscoveryCandidateDocumentBody = zod.object({
  "filename": zod.string().min(1).max(uploadWebDiscoveryCandidateDocumentBodyFilenameMax),
  "contentType": zod.string().min(uploadWebDiscoveryCandidateDocumentBodyContentTypeMin).max(uploadWebDiscoveryCandidateDocumentBodyContentTypeMax),
  "dataBase64": zod.string().min(uploadWebDiscoveryCandidateDocumentBodyDataBase64Min).max(uploadWebDiscoveryCandidateDocumentBodyDataBase64Max).describe('Canonical padded base64 of at most 10 MiB'),
  "label": zod.string().min(1).max(uploadWebDiscoveryCandidateDocumentBodyLabelMax).optional()
})

export const uploadWebDiscoveryCandidateDocumentResponse = zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "documentId": zod.uuid(),
  "label": zod.string().nullable(),
  "title": zod.string(),
  "sourceUrl": zod.string().nullable(),
  "addedBy": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Detach a document from a candidate; the document itself is kept
 */
export const removeWebDiscoveryCandidateDocumentParams = zod.object({
  "candidateId": zod.uuid(),
  "documentId": zod.uuid()
})

export const removeWebDiscoveryCandidateDocumentResponse = zod.void()


/**
 * @summary List who changed a candidate's enrichment, assessment and decision, and when
 */
export const listWebDiscoveryCandidateHistoryParams = zod.object({
  "candidateId": zod.uuid()
})

export const listWebDiscoveryCandidateHistoryQueryLimitDefault = 25;
export const listWebDiscoveryCandidateHistoryQueryLimitMax = 100;

export const listWebDiscoveryCandidateHistoryQueryOffsetDefault = 0;
export const listWebDiscoveryCandidateHistoryQueryOffsetMin = 0;



export const listWebDiscoveryCandidateHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWebDiscoveryCandidateHistoryQueryLimitMax).default(listWebDiscoveryCandidateHistoryQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoveryCandidateHistoryQueryOffsetMin).default(listWebDiscoveryCandidateHistoryQueryOffsetDefault)
})

export const listWebDiscoveryCandidateHistoryResponseTotalMin = 0;


export const listWebDiscoveryCandidateHistoryResponseOffsetMin = 0;



export const listWebDiscoveryCandidateHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "action": zod.enum(['industry_changed', 'notes_updated', 'extra_information_updated', 'document_added', 'document_removed', 'enrichment_requested', 'assessment_recorded', 'decision_recorded']),
  "actor": zod.string(),
  "details": zod.record(zod.string(), zod.unknown()),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listWebDiscoveryCandidateHistoryResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoveryCandidateHistoryResponseOffsetMin)
})


/**
 * @summary List bounded immutable evidence revisions for a discovery candidate
 */
export const listWebDiscoveryEvidenceParams = zod.object({
  "candidateId": zod.uuid()
})

export const listWebDiscoveryEvidenceQueryLimitDefault = 25;
export const listWebDiscoveryEvidenceQueryLimitMax = 100;

export const listWebDiscoveryEvidenceQueryOffsetDefault = 0;
export const listWebDiscoveryEvidenceQueryOffsetMin = 0;



export const listWebDiscoveryEvidenceQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWebDiscoveryEvidenceQueryLimitMax).default(listWebDiscoveryEvidenceQueryLimitDefault),
  "offset": zod.int().min(listWebDiscoveryEvidenceQueryOffsetMin).default(listWebDiscoveryEvidenceQueryOffsetDefault)
})


export const listWebDiscoveryEvidenceResponseItemsItemExcerptMax = 12000;

export const listWebDiscoveryEvidenceResponseTotalMin = 0;


export const listWebDiscoveryEvidenceResponseOffsetMin = 0;



export const listWebDiscoveryEvidenceResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "documentId": zod.uuid(),
  "sourceId": zod.uuid(),
  "scanRunId": zod.uuid(),
  "profileId": zod.uuid(),
  "recipeId": zod.uuid(),
  "revision": zod.int().min(1),
  "sourceIdentifier": zod.string().nullable(),
  "canonicalUrl": zod.url(),
  "title": zod.string(),
  "excerpt": zod.string().min(1).max(listWebDiscoveryEvidenceResponseItemsItemExcerptMax),
  "contentHash": zod.string(),
  "facts": zod.record(zod.string(), zod.unknown()),
  "uncertainty": zod.array(zod.string()),
  "restrictedSource": zod.boolean(),
  "retrievedAt": zod.iso.datetime({"offset":true}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}).describe('Bounded immutable evidence only; login responses and browser session material are never evidence.')),
  "total": zod.int().min(listWebDiscoveryEvidenceResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listWebDiscoveryEvidenceResponseOffsetMin)
})


/**
 * @summary Get the review-first discovery promotion policy
 */
export const getWebDiscoveryAutomationPolicyResponseRevisionMin = 0;





export const getWebDiscoveryAutomationPolicyResponseMinimumQualificationScoreMin = 0;
export const getWebDiscoveryAutomationPolicyResponseMinimumQualificationScoreMax = 100;

export const getWebDiscoveryAutomationPolicyResponseMaxPromotionsPerDayMin = 0;

export const getWebDiscoveryAutomationPolicyResponseMaxSpendMinorPerDayMin = 0;

export const getWebDiscoveryAutomationPolicyResponseCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getWebDiscoveryAutomationPolicyResponseTenderRankingStrongMinScoreMin = 2;
export const getWebDiscoveryAutomationPolicyResponseTenderRankingStrongMinScoreMax = 100;

export const getWebDiscoveryAutomationPolicyResponseTenderRankingPossibleMinScoreMax = 99;

export const getWebDiscoveryAutomationPolicyResponseTenderRankingAllowedJurisdictionsItemMax = 80;

export const getWebDiscoveryAutomationPolicyResponseTenderRankingAllowedJurisdictionsMax = 20;

export const getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsItemMin = 2;
export const getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsItemMax = 120;

export const getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsMax = 50;

export const getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedCategoryCodesItemMax = 100;

export const getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedCategoryCodesMax = 100;

export const getWebDiscoveryAutomationPolicyResponseTenderRankingMinEstimatedValueMin = 0;

export const getWebDiscoveryAutomationPolicyResponseTenderRankingMaxEstimatedValueMin = 0;



export const getWebDiscoveryAutomationPolicyResponse = zod.object({
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getWebDiscoveryAutomationPolicyResponseRevisionMin),
  "mode": zod.enum(['review_only', 'automatic']),
  "enabled": zod.boolean(),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable(),
  "allowedSourceIds": zod.array(zod.uuid()),
  "sourceRevisionBindings": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid(),
  "recipeVersion": zod.int().min(1),
  "recipeRevision": zod.int().min(1)
})),
  "minimumQualificationScore": zod.number().min(getWebDiscoveryAutomationPolicyResponseMinimumQualificationScoreMin).max(getWebDiscoveryAutomationPolicyResponseMinimumQualificationScoreMax),
  "requireUnambiguousAccount": zod.boolean(),
  "allowAccountCreation": zod.boolean(),
  "allowOpportunityCreation": zod.boolean(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).nullable(),
  "openStage": zod.string().nullable(),
  "ownerId": zod.string().nullable(),
  "maxPromotionsPerDay": zod.int().min(getWebDiscoveryAutomationPolicyResponseMaxPromotionsPerDayMin),
  "maxSpendMinorPerDay": zod.int().min(getWebDiscoveryAutomationPolicyResponseMaxSpendMinorPerDayMin),
  "currency": zod.string().regex(getWebDiscoveryAutomationPolicyResponseCurrencyRegExp),
  "auditId": zod.uuid().nullable(),
  "configuredBy": zod.string().nullable(),
  "configuredAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "tenderRanking": zod.object({
  "strongMinScore": zod.int().min(getWebDiscoveryAutomationPolicyResponseTenderRankingStrongMinScoreMin).max(getWebDiscoveryAutomationPolicyResponseTenderRankingStrongMinScoreMax),
  "possibleMinScore": zod.int().min(1).max(getWebDiscoveryAutomationPolicyResponseTenderRankingPossibleMinScoreMax),
  "allowedJurisdictions": zod.array(zod.string().min(1).max(getWebDiscoveryAutomationPolicyResponseTenderRankingAllowedJurisdictionsItemMax)).max(getWebDiscoveryAutomationPolicyResponseTenderRankingAllowedJurisdictionsMax).describe('Empty allows every jurisdiction.'),
  "excludedKeywords": zod.array(zod.string().min(getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsItemMin).max(getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsItemMax)).max(getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsMax),
  "excludedCategoryCodes": zod.array(zod.string().min(1).max(getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedCategoryCodesItemMax)).max(getWebDiscoveryAutomationPolicyResponseTenderRankingExcludedCategoryCodesMax),
  "minEstimatedValue": zod.number().min(getWebDiscoveryAutomationPolicyResponseTenderRankingMinEstimatedValueMin).nullable(),
  "maxEstimatedValue": zod.number().min(getWebDiscoveryAutomationPolicyResponseTenderRankingMaxEstimatedValueMin).nullable(),
  "aiEnabled": zod.boolean().describe('When false, ranking uses keyword scoring only.')
}).optional().describe('Tender opportunity match bands and deterministic pre-filters. Scores at or above strongMinScore are Strong, at or above possibleMinScore are Possible, otherwise Low (kept visible as Low match).')
})


/**
 * @summary Configure the exact administrator-approved discovery promotion policy
 */
export const updateWebDiscoveryAutomationPolicyBodyExpectedRevisionMin = 0;





export const updateWebDiscoveryAutomationPolicyBodySourceRevisionBindingsMax = 100;

export const updateWebDiscoveryAutomationPolicyBodyMinimumQualificationScoreMin = 0;
export const updateWebDiscoveryAutomationPolicyBodyMinimumQualificationScoreMax = 100;

export const updateWebDiscoveryAutomationPolicyBodyOpenStageMax = 80;

export const updateWebDiscoveryAutomationPolicyBodyOwnerIdMax = 200;

export const updateWebDiscoveryAutomationPolicyBodyMaxPromotionsPerDayMin = 0;
export const updateWebDiscoveryAutomationPolicyBodyMaxPromotionsPerDayMax = 10000;

export const updateWebDiscoveryAutomationPolicyBodyMaxSpendMinorPerDayMin = 0;

export const updateWebDiscoveryAutomationPolicyBodyCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const updateWebDiscoveryAutomationPolicyBodyTenderRankingStrongMinScoreMin = 2;
export const updateWebDiscoveryAutomationPolicyBodyTenderRankingStrongMinScoreMax = 100;

export const updateWebDiscoveryAutomationPolicyBodyTenderRankingPossibleMinScoreMax = 99;

export const updateWebDiscoveryAutomationPolicyBodyTenderRankingAllowedJurisdictionsItemMax = 80;

export const updateWebDiscoveryAutomationPolicyBodyTenderRankingAllowedJurisdictionsMax = 20;

export const updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedKeywordsItemMin = 2;
export const updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedKeywordsItemMax = 120;

export const updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedKeywordsMax = 50;

export const updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedCategoryCodesItemMax = 100;

export const updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedCategoryCodesMax = 100;

export const updateWebDiscoveryAutomationPolicyBodyTenderRankingMinEstimatedValueMin = 0;

export const updateWebDiscoveryAutomationPolicyBodyTenderRankingMaxEstimatedValueMin = 0;



export const updateWebDiscoveryAutomationPolicyBody = zod.object({
  "expectedRevision": zod.int().min(updateWebDiscoveryAutomationPolicyBodyExpectedRevisionMin),
  "mode": zod.enum(['review_only', 'automatic']),
  "enabled": zod.boolean(),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable(),
  "sourceRevisionBindings": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid(),
  "recipeVersion": zod.int().min(1),
  "recipeRevision": zod.int().min(1)
})).max(updateWebDiscoveryAutomationPolicyBodySourceRevisionBindingsMax),
  "minimumQualificationScore": zod.number().min(updateWebDiscoveryAutomationPolicyBodyMinimumQualificationScoreMin).max(updateWebDiscoveryAutomationPolicyBodyMinimumQualificationScoreMax),
  "requireUnambiguousAccount": zod.boolean(),
  "allowAccountCreation": zod.boolean(),
  "allowOpportunityCreation": zod.boolean(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).nullable(),
  "openStage": zod.string().min(1).max(updateWebDiscoveryAutomationPolicyBodyOpenStageMax).nullable(),
  "ownerId": zod.string().max(updateWebDiscoveryAutomationPolicyBodyOwnerIdMax).nullable(),
  "maxPromotionsPerDay": zod.int().min(updateWebDiscoveryAutomationPolicyBodyMaxPromotionsPerDayMin).max(updateWebDiscoveryAutomationPolicyBodyMaxPromotionsPerDayMax),
  "maxSpendMinorPerDay": zod.int().min(updateWebDiscoveryAutomationPolicyBodyMaxSpendMinorPerDayMin),
  "currency": zod.string().regex(updateWebDiscoveryAutomationPolicyBodyCurrencyRegExp),
  "tenderRanking": zod.object({
  "strongMinScore": zod.int().min(updateWebDiscoveryAutomationPolicyBodyTenderRankingStrongMinScoreMin).max(updateWebDiscoveryAutomationPolicyBodyTenderRankingStrongMinScoreMax),
  "possibleMinScore": zod.int().min(1).max(updateWebDiscoveryAutomationPolicyBodyTenderRankingPossibleMinScoreMax),
  "allowedJurisdictions": zod.array(zod.string().min(1).max(updateWebDiscoveryAutomationPolicyBodyTenderRankingAllowedJurisdictionsItemMax)).max(updateWebDiscoveryAutomationPolicyBodyTenderRankingAllowedJurisdictionsMax).describe('Empty allows every jurisdiction.'),
  "excludedKeywords": zod.array(zod.string().min(updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedKeywordsItemMin).max(updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedKeywordsItemMax)).max(updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedKeywordsMax),
  "excludedCategoryCodes": zod.array(zod.string().min(1).max(updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedCategoryCodesItemMax)).max(updateWebDiscoveryAutomationPolicyBodyTenderRankingExcludedCategoryCodesMax),
  "minEstimatedValue": zod.number().min(updateWebDiscoveryAutomationPolicyBodyTenderRankingMinEstimatedValueMin).nullable(),
  "maxEstimatedValue": zod.number().min(updateWebDiscoveryAutomationPolicyBodyTenderRankingMaxEstimatedValueMin).nullable(),
  "aiEnabled": zod.boolean().describe('When false, ranking uses keyword scoring only.')
}).optional().describe('Tender opportunity match bands and deterministic pre-filters. Scores at or above strongMinScore are Strong, at or above possibleMinScore are Possible, otherwise Low (kept visible as Low match).')
})

export const updateWebDiscoveryAutomationPolicyResponseRevisionMin = 0;





export const updateWebDiscoveryAutomationPolicyResponseMinimumQualificationScoreMin = 0;
export const updateWebDiscoveryAutomationPolicyResponseMinimumQualificationScoreMax = 100;

export const updateWebDiscoveryAutomationPolicyResponseMaxPromotionsPerDayMin = 0;

export const updateWebDiscoveryAutomationPolicyResponseMaxSpendMinorPerDayMin = 0;

export const updateWebDiscoveryAutomationPolicyResponseCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const updateWebDiscoveryAutomationPolicyResponseTenderRankingStrongMinScoreMin = 2;
export const updateWebDiscoveryAutomationPolicyResponseTenderRankingStrongMinScoreMax = 100;

export const updateWebDiscoveryAutomationPolicyResponseTenderRankingPossibleMinScoreMax = 99;

export const updateWebDiscoveryAutomationPolicyResponseTenderRankingAllowedJurisdictionsItemMax = 80;

export const updateWebDiscoveryAutomationPolicyResponseTenderRankingAllowedJurisdictionsMax = 20;

export const updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsItemMin = 2;
export const updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsItemMax = 120;

export const updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsMax = 50;

export const updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedCategoryCodesItemMax = 100;

export const updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedCategoryCodesMax = 100;

export const updateWebDiscoveryAutomationPolicyResponseTenderRankingMinEstimatedValueMin = 0;

export const updateWebDiscoveryAutomationPolicyResponseTenderRankingMaxEstimatedValueMin = 0;



export const updateWebDiscoveryAutomationPolicyResponse = zod.object({
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(updateWebDiscoveryAutomationPolicyResponseRevisionMin),
  "mode": zod.enum(['review_only', 'automatic']),
  "enabled": zod.boolean(),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable(),
  "allowedSourceIds": zod.array(zod.uuid()),
  "sourceRevisionBindings": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid(),
  "recipeVersion": zod.int().min(1),
  "recipeRevision": zod.int().min(1)
})),
  "minimumQualificationScore": zod.number().min(updateWebDiscoveryAutomationPolicyResponseMinimumQualificationScoreMin).max(updateWebDiscoveryAutomationPolicyResponseMinimumQualificationScoreMax),
  "requireUnambiguousAccount": zod.boolean(),
  "allowAccountCreation": zod.boolean(),
  "allowOpportunityCreation": zod.boolean(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).nullable(),
  "openStage": zod.string().nullable(),
  "ownerId": zod.string().nullable(),
  "maxPromotionsPerDay": zod.int().min(updateWebDiscoveryAutomationPolicyResponseMaxPromotionsPerDayMin),
  "maxSpendMinorPerDay": zod.int().min(updateWebDiscoveryAutomationPolicyResponseMaxSpendMinorPerDayMin),
  "currency": zod.string().regex(updateWebDiscoveryAutomationPolicyResponseCurrencyRegExp),
  "auditId": zod.uuid().nullable(),
  "configuredBy": zod.string().nullable(),
  "configuredAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "tenderRanking": zod.object({
  "strongMinScore": zod.int().min(updateWebDiscoveryAutomationPolicyResponseTenderRankingStrongMinScoreMin).max(updateWebDiscoveryAutomationPolicyResponseTenderRankingStrongMinScoreMax),
  "possibleMinScore": zod.int().min(1).max(updateWebDiscoveryAutomationPolicyResponseTenderRankingPossibleMinScoreMax),
  "allowedJurisdictions": zod.array(zod.string().min(1).max(updateWebDiscoveryAutomationPolicyResponseTenderRankingAllowedJurisdictionsItemMax)).max(updateWebDiscoveryAutomationPolicyResponseTenderRankingAllowedJurisdictionsMax).describe('Empty allows every jurisdiction.'),
  "excludedKeywords": zod.array(zod.string().min(updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsItemMin).max(updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsItemMax)).max(updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedKeywordsMax),
  "excludedCategoryCodes": zod.array(zod.string().min(1).max(updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedCategoryCodesItemMax)).max(updateWebDiscoveryAutomationPolicyResponseTenderRankingExcludedCategoryCodesMax),
  "minEstimatedValue": zod.number().min(updateWebDiscoveryAutomationPolicyResponseTenderRankingMinEstimatedValueMin).nullable(),
  "maxEstimatedValue": zod.number().min(updateWebDiscoveryAutomationPolicyResponseTenderRankingMaxEstimatedValueMin).nullable(),
  "aiEnabled": zod.boolean().describe('When false, ranking uses keyword scoring only.')
}).optional().describe('Tender opportunity match bands and deterministic pre-filters. Scores at or above strongMinScore are Strong, at or above possibleMinScore are Possible, otherwise Low (kept visible as Low match).')
})


/**
 * @summary Preview exact evidence, CRM matches, proposed changes and promotion eligibility
 */
export const getWebDiscoveryCandidateReviewPreviewParams = zod.object({
  "candidateId": zod.uuid()
})




export const getWebDiscoveryCandidateReviewPreviewResponseEvidenceExcerptMax = 12000;

export const getWebDiscoveryCandidateReviewPreviewResponseFitScoreMin = 0;
export const getWebDiscoveryCandidateReviewPreviewResponseFitScoreMax = 100;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyRevisionMin = 0;





export const getWebDiscoveryCandidateReviewPreviewResponsePolicyMinimumQualificationScoreMin = 0;
export const getWebDiscoveryCandidateReviewPreviewResponsePolicyMinimumQualificationScoreMax = 100;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyMaxPromotionsPerDayMin = 0;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyMaxSpendMinorPerDayMin = 0;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingStrongMinScoreMin = 2;
export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingStrongMinScoreMax = 100;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingPossibleMinScoreMax = 99;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingAllowedJurisdictionsItemMax = 80;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingAllowedJurisdictionsMax = 20;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedKeywordsItemMin = 2;
export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedKeywordsItemMax = 120;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedKeywordsMax = 50;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedCategoryCodesItemMax = 100;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedCategoryCodesMax = 100;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingMinEstimatedValueMin = 0;

export const getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingMaxEstimatedValueMin = 0;



export const getWebDiscoveryCandidateReviewPreviewResponse = zod.object({
  "candidateId": zod.uuid(),
  "reviewRevision": zod.int().min(1),
  "reviewStatus": zod.enum(['unreviewed', 'accepted', 'dismissed', 'deferred', 'duplicate', 'promoted', 'changed']),
  "evidenceRevision": zod.int().min(1),
  "evidence": zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "documentId": zod.uuid(),
  "sourceId": zod.uuid(),
  "scanRunId": zod.uuid(),
  "profileId": zod.uuid(),
  "recipeId": zod.uuid(),
  "revision": zod.int().min(1),
  "sourceIdentifier": zod.string().nullable(),
  "canonicalUrl": zod.url(),
  "title": zod.string(),
  "excerpt": zod.string().min(1).max(getWebDiscoveryCandidateReviewPreviewResponseEvidenceExcerptMax),
  "contentHash": zod.string(),
  "facts": zod.record(zod.string(), zod.unknown()),
  "uncertainty": zod.array(zod.string()),
  "restrictedSource": zod.boolean(),
  "retrievedAt": zod.iso.datetime({"offset":true}),
  "publishedAt": zod.iso.datetime({"offset":true}).nullable(),
  "deadlineAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}).describe('Bounded immutable evidence only; login responses and browser session material are never evidence.'),
  "fitScore": zod.number().min(getWebDiscoveryCandidateReviewPreviewResponseFitScoreMin).max(getWebDiscoveryCandidateReviewPreviewResponseFitScoreMax).nullable(),
  "fitReasons": zod.array(zod.string()),
  "unknowns": zod.array(zod.string()),
  "accountMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "opportunityMatch": zod.object({
  "status": zod.enum(['none', 'matched', 'ambiguous']),
  "matchedId": zod.uuid().nullable(),
  "candidateIds": zod.array(zod.uuid()),
  "reasons": zod.array(zod.string())
}),
  "proposedAccount": zod.object({
  "action": zod.enum(['reuse', 'create', 'review', 'unavailable']),
  "recordId": zod.uuid().nullable(),
  "fields": zod.record(zod.string(), zod.unknown()),
  "reasons": zod.array(zod.string())
}),
  "proposedOpportunity": zod.object({
  "action": zod.enum(['reuse', 'create', 'review', 'unavailable']),
  "recordId": zod.uuid().nullable(),
  "fields": zod.record(zod.string(), zod.unknown()),
  "reasons": zod.array(zod.string())
}),
  "policy": zod.object({
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getWebDiscoveryCandidateReviewPreviewResponsePolicyRevisionMin),
  "mode": zod.enum(['review_only', 'automatic']),
  "enabled": zod.boolean(),
  "targetingProfileId": zod.uuid().nullable(),
  "targetingProfileRevision": zod.int().min(1).nullable(),
  "allowedSourceIds": zod.array(zod.uuid()),
  "sourceRevisionBindings": zod.array(zod.object({
  "sourceId": zod.uuid(),
  "sourceRevision": zod.int().min(1),
  "recipeId": zod.uuid(),
  "recipeVersion": zod.int().min(1),
  "recipeRevision": zod.int().min(1)
})),
  "minimumQualificationScore": zod.number().min(getWebDiscoveryCandidateReviewPreviewResponsePolicyMinimumQualificationScoreMin).max(getWebDiscoveryCandidateReviewPreviewResponsePolicyMinimumQualificationScoreMax),
  "requireUnambiguousAccount": zod.boolean(),
  "allowAccountCreation": zod.boolean(),
  "allowOpportunityCreation": zod.boolean(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).nullable(),
  "openStage": zod.string().nullable(),
  "ownerId": zod.string().nullable(),
  "maxPromotionsPerDay": zod.int().min(getWebDiscoveryCandidateReviewPreviewResponsePolicyMaxPromotionsPerDayMin),
  "maxSpendMinorPerDay": zod.int().min(getWebDiscoveryCandidateReviewPreviewResponsePolicyMaxSpendMinorPerDayMin),
  "currency": zod.string().regex(getWebDiscoveryCandidateReviewPreviewResponsePolicyCurrencyRegExp),
  "auditId": zod.uuid().nullable(),
  "configuredBy": zod.string().nullable(),
  "configuredAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "tenderRanking": zod.object({
  "strongMinScore": zod.int().min(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingStrongMinScoreMin).max(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingStrongMinScoreMax),
  "possibleMinScore": zod.int().min(1).max(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingPossibleMinScoreMax),
  "allowedJurisdictions": zod.array(zod.string().min(1).max(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingAllowedJurisdictionsItemMax)).max(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingAllowedJurisdictionsMax).describe('Empty allows every jurisdiction.'),
  "excludedKeywords": zod.array(zod.string().min(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedKeywordsItemMin).max(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedKeywordsItemMax)).max(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedKeywordsMax),
  "excludedCategoryCodes": zod.array(zod.string().min(1).max(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedCategoryCodesItemMax)).max(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingExcludedCategoryCodesMax),
  "minEstimatedValue": zod.number().min(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingMinEstimatedValueMin).nullable(),
  "maxEstimatedValue": zod.number().min(getWebDiscoveryCandidateReviewPreviewResponsePolicyTenderRankingMaxEstimatedValueMin).nullable(),
  "aiEnabled": zod.boolean().describe('When false, ranking uses keyword scoring only.')
}).optional().describe('Tender opportunity match bands and deterministic pre-filters. Scores at or above strongMinScore are Strong, at or above possibleMinScore are Possible, otherwise Low (kept visible as Low match).')
}),
  "eligibility": zod.object({
  "eligible": zod.boolean(),
  "reasons": zod.array(zod.string()),
  "warnings": zod.array(zod.string())
})
})


/**
 * @summary Dismiss, defer or resolve a duplicate discovery with optimistic revision checks
 */
export const reviewWebDiscoveryCandidateParams = zod.object({
  "candidateId": zod.uuid()
})



export const reviewWebDiscoveryCandidateBodyReasonMax = 1000;



export const reviewWebDiscoveryCandidateBody = zod.object({
  "action": zod.enum(['dismiss', 'defer', 'resolve_duplicate']),
  "expectedReviewRevision": zod.int().min(1),
  "expectedEvidenceRevision": zod.int().min(1),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "duplicateCandidateId": zod.uuid().nullish(),
  "reason": zod.string().min(1).max(reviewWebDiscoveryCandidateBodyReasonMax).nullish()
})

export const reviewWebDiscoveryCandidateResponseReviewRevisionMin = 2;



export const reviewWebDiscoveryCandidateResponse = zod.object({
  "candidateId": zod.uuid(),
  "reviewStatus": zod.enum(['dismissed', 'deferred', 'duplicate']),
  "reviewRevision": zod.int().min(reviewWebDiscoveryCandidateResponseReviewRevisionMin),
  "auditId": zod.uuid(),
  "reviewedBy": zod.string(),
  "reviewedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get canonical CRM promotion linkage for a discovery candidate
 */
export const getWebDiscoveryPromotionParams = zod.object({
  "candidateId": zod.uuid()
})





export const getWebDiscoveryPromotionResponse = zod.object({
  "promotion": zod.union([zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "evidenceId": zod.uuid(),
  "policyId": zod.uuid().nullable(),
  "policyRevision": zod.int().min(1).nullable(),
  "targetingProfileId": zod.uuid(),
  "sourceId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "accountHref": zod.string().nullable(),
  "opportunityHref": zod.string().nullable(),
  "auditId": zod.uuid().nullable(),
  "promotionKey": zod.string(),
  "candidateReviewRevision": zod.int().min(1),
  "status": zod.enum(['reserved', 'promoted', 'blocked', 'failed', 'cancelled']),
  "promotedBy": zod.string(),
  "promotedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().nullable(),
  "errorDetail": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),zod.null()])
})


/**
 * @summary Atomically accept a reviewed discovery and create or link canonical CRM records
 */
export const promoteWebDiscoveryCandidateParams = zod.object({
  "candidateId": zod.uuid()
})




export const promoteWebDiscoveryCandidateBodyIdempotencyKeyMin = 8;
export const promoteWebDiscoveryCandidateBodyIdempotencyKeyMax = 160;


export const promoteWebDiscoveryCandidateBodyIdempotencyKeyRegExp = new RegExp('^[A-Za-z0-9._:-]+$');
export const promoteWebDiscoveryCandidateBodyEditsAccountNameMax = 300;

export const promoteWebDiscoveryCandidateBodyEditsOpportunityTitleMax = 500;

export const promoteWebDiscoveryCandidateBodyEditsReviewNoteMax = 1000;



export const promoteWebDiscoveryCandidateBody = zod.object({
  "expectedReviewRevision": zod.int().min(1),
  "expectedEvidenceRevision": zod.int().min(1),
  "expectedPolicyRevision": zod.int().min(1),
  "idempotencyKey": zod.string().min(promoteWebDiscoveryCandidateBodyIdempotencyKeyMin).max(promoteWebDiscoveryCandidateBodyIdempotencyKeyMax).regex(promoteWebDiscoveryCandidateBodyIdempotencyKeyRegExp),
  "edits": zod.object({
  "accountName": zod.string().min(1).max(promoteWebDiscoveryCandidateBodyEditsAccountNameMax).optional(),
  "opportunityTitle": zod.string().min(1).max(promoteWebDiscoveryCandidateBodyEditsOpportunityTitleMax).optional(),
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().optional(),
  "reviewNote": zod.string().max(promoteWebDiscoveryCandidateBodyEditsReviewNoteMax).optional()
}).optional()
})





export const promoteWebDiscoveryCandidateResponse = zod.object({
  "promotion": zod.object({
  "id": zod.uuid(),
  "candidateId": zod.uuid(),
  "evidenceId": zod.uuid(),
  "policyId": zod.uuid().nullable(),
  "policyRevision": zod.int().min(1).nullable(),
  "targetingProfileId": zod.uuid(),
  "sourceId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "accountHref": zod.string().nullable(),
  "opportunityHref": zod.string().nullable(),
  "auditId": zod.uuid().nullable(),
  "promotionKey": zod.string(),
  "candidateReviewRevision": zod.int().min(1),
  "status": zod.enum(['reserved', 'promoted', 'blocked', 'failed', 'cancelled']),
  "promotedBy": zod.string(),
  "promotedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().nullable(),
  "errorDetail": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "replayed": zod.boolean()
})


/**
 * @summary Get telephony connection state and effective voice-agent settings
 */
export const getVoiceStatusResponseSettingsGreetingMax = 1000;

export const getVoiceStatusResponseSettingsConsentMessageMax = 1000;

export const getVoiceStatusResponseSettingsBehaviorMax = 4000;

export const getVoiceStatusResponseSettingsVoiceNameMax = 120;

export const getVoiceStatusResponseSettingsVadThresholdMin = 0.1;
export const getVoiceStatusResponseSettingsVadThresholdMax = 0.95;

export const getVoiceStatusResponseSettingsSilenceDurationMsMin = 200;
export const getVoiceStatusResponseSettingsSilenceDurationMsMax = 3000;

export const getVoiceStatusResponseSettingsBusinessNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');
export const getVoiceStatusResponseSettingsTransferNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');


export const getVoiceStatusResponse = zod.object({
  "connectionStatus": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "connected": zod.boolean(),
  "mode": zod.enum(['simulation', 'live']),
  "providerKey": zod.enum(['simulation', 'twilio']),
  "voiceLiveConfigured": zod.boolean(),
  "displayName": zod.string().nullish(),
  "phoneNumber": zod.string().nullish(),
  "settings": zod.object({
  "greeting": zod.string().min(1).max(getVoiceStatusResponseSettingsGreetingMax),
  "consentMessage": zod.string().min(1).max(getVoiceStatusResponseSettingsConsentMessageMax),
  "recordingEnabled": zod.boolean(),
  "behavior": zod.string().min(1).max(getVoiceStatusResponseSettingsBehaviorMax),
  "enquiryCaptureMode": zod.enum(['after_consent', 'useful_request', 'every_call']),
  "voiceName": zod.string().min(1).max(getVoiceStatusResponseSettingsVoiceNameMax),
  "vadThreshold": zod.number().min(getVoiceStatusResponseSettingsVadThresholdMin).max(getVoiceStatusResponseSettingsVadThresholdMax),
  "silenceDurationMs": zod.int().min(getVoiceStatusResponseSettingsSilenceDurationMsMin).max(getVoiceStatusResponseSettingsSilenceDurationMsMax),
  "businessNumber": zod.string().regex(getVoiceStatusResponseSettingsBusinessNumberRegExp).nullish(),
  "transferNumber": zod.string().regex(getVoiceStatusResponseSettingsTransferNumberRegExp).nullish(),
  "callAuthentication": zod.object({
  "staffApprovalEnabled": zod.boolean(),
  "customerPortalApprovalEnabled": zod.boolean(),
  "customerOtpFallbackEnabled": zod.boolean()
})
})
})


/**
 * @summary Check authenticated staff browser-voice availability and configuration
 */
export const getVoiceLiveConfigStatusResponseRecordingDisclosureMax = 1000;

export const getVoiceLiveConfigStatusResponseAgentNameMax = 200;

export const getVoiceLiveConfigStatusResponseGreetingMax = 1000;



export const getVoiceLiveConfigStatusResponse = zod.object({
  "available": zod.boolean(),
  "conversationRecording": zod.literal(false),
  "recordingDisclosure": zod.string().min(1).max(getVoiceLiveConfigStatusResponseRecordingDisclosureMax),
  "agentName": zod.string().min(1).max(getVoiceLiveConfigStatusResponseAgentNameMax),
  "greeting": zod.string().min(1).max(getVoiceLiveConfigStatusResponseGreetingMax),
  "voiceLiveConfigured": zod.boolean()
})


/**
 * @summary Mint a short-lived one-time ticket for an authenticated staff voice session
 */
export const createVoiceLiveTicketResponse = zod.object({
  "ticket": zod.uuid(),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Open an authenticated staff browser voice websocket using a one-time ticket
 */
export const connectStaffVoiceLiveQueryParams = zod.object({
  "ticket": zod.uuid()
})

export const connectStaffVoiceLiveResponse = zod.void()


/**
 * @summary Get caller-safe browser voice availability and recording disclosure
 */
export const getPublicVoiceStatusResponse = zod.object({
  "available": zod.boolean(),
  "browserVoiceAvailable": zod.boolean(),
  "callbackAvailable": zod.boolean(),
  "telephonyConnected": zod.boolean(),
  "mode": zod.enum(['simulation', 'live']),
  "recordingDisclosure": zod.string()
})


/**
 * @summary Open a browser voice websocket, optionally scoped to a microsite slug
 */
export const connectPublicVoiceLiveQuerySlugMax = 120;



export const connectPublicVoiceLiveQueryParams = zod.object({
  "slug": zod.string().min(1).max(connectPublicVoiceLiveQuerySlugMax).optional()
})

export const connectPublicVoiceLiveResponse = zod.void()


/**
 * @summary Get caller-safe voice and callback availability for a microsite
 */
export const getPublicMicrositeVoiceStatusPathSlugMax = 120;



export const getPublicMicrositeVoiceStatusParams = zod.object({
  "slug": zod.string().min(1).max(getPublicMicrositeVoiceStatusPathSlugMax)
})

export const getPublicMicrositeVoiceStatusResponse = zod.object({
  "available": zod.boolean(),
  "browserVoiceAvailable": zod.boolean(),
  "callbackAvailable": zod.boolean(),
  "telephonyConnected": zod.boolean(),
  "mode": zod.enum(['simulation', 'live']),
  "recordingDisclosure": zod.string()
})


/**
 * @summary Request an entity-scoped outbound click-to-call callback
 */
export const requestPublicMicrositeCallbackPathSlugMax = 120;



export const requestPublicMicrositeCallbackParams = zod.object({
  "slug": zod.string().min(1).max(requestPublicMicrositeCallbackPathSlugMax)
})

export const requestPublicMicrositeCallbackBodyNameMax = 200;

export const requestPublicMicrositeCallbackBodyPhoneRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');
export const requestPublicMicrositeCallbackBodyMessageMax = 2000;

export const requestPublicMicrositeCallbackBodyWebsiteMax = 200;



export const requestPublicMicrositeCallbackBody = zod.object({
  "name": zod.string().min(1).max(requestPublicMicrositeCallbackBodyNameMax),
  "phone": zod.string().regex(requestPublicMicrositeCallbackBodyPhoneRegExp),
  "message": zod.string().max(requestPublicMicrositeCallbackBodyMessageMax).optional(),
  "website": zod.string().max(requestPublicMicrositeCallbackBodyWebsiteMax).optional()
})

export const requestPublicMicrositeCallbackResponse = zod.object({
  "callId": zod.uuid(),
  "contactId": zod.uuid(),
  "enquiryId": zod.uuid(),
  "status": zod.enum(['queued', 'ringing', 'in_progress', 'completed', 'transfer_requested', 'failed', 'no_answer', 'cancelled']),
  "mode": zod.enum(['simulation', 'live']),
  "message": zod.string()
})


/**
 * @summary Get the active entity voice style, editable draft, capabilities and activation evidence
 */
export const getVoiceStyleWorkspaceResponseActiveVersionMin = 0;

export const getVoiceStyleWorkspaceResponseActiveRevisionMin = 0;

export const getVoiceStyleWorkspaceResponseActiveProfileConversationWarmthMin = 0;
export const getVoiceStyleWorkspaceResponseActiveProfileConversationWarmthMax = 100;

export const getVoiceStyleWorkspaceResponseActiveProfileConversationBrevityMin = 0;
export const getVoiceStyleWorkspaceResponseActiveProfileConversationBrevityMax = 100;

export const getVoiceStyleWorkspaceResponseActiveProfileConversationGreetingMax = 500;

export const getVoiceStyleWorkspaceResponseActiveProfileConversationExamplePhrasesItemMax = 300;

export const getVoiceStyleWorkspaceResponseActiveProfileConversationExamplePhrasesMax = 8;

export const getVoiceStyleWorkspaceResponseActiveProfileConversationAdvancedInstructionsMax = 4000;

export const getVoiceStyleWorkspaceResponseActiveProfileSoundVoiceNameMax = 160;

export const getVoiceStyleWorkspaceResponseActiveProfileSoundAccentMax = 80;

export const getVoiceStyleWorkspaceResponseActiveProfileSoundSpeakingRateMin = 0.8;
export const getVoiceStyleWorkspaceResponseActiveProfileSoundSpeakingRateMax = 1.2;

export const getVoiceStyleWorkspaceResponseActiveProfileSoundResponseTimingMsMin = 300;
export const getVoiceStyleWorkspaceResponseActiveProfileSoundResponseTimingMsMax = 2000;

export const getVoiceStyleWorkspaceResponseDraftOneVersionMin = 0;

export const getVoiceStyleWorkspaceResponseDraftOneRevisionMin = 0;

export const getVoiceStyleWorkspaceResponseDraftOneProfileConversationWarmthMin = 0;
export const getVoiceStyleWorkspaceResponseDraftOneProfileConversationWarmthMax = 100;

export const getVoiceStyleWorkspaceResponseDraftOneProfileConversationBrevityMin = 0;
export const getVoiceStyleWorkspaceResponseDraftOneProfileConversationBrevityMax = 100;

export const getVoiceStyleWorkspaceResponseDraftOneProfileConversationGreetingMax = 500;

export const getVoiceStyleWorkspaceResponseDraftOneProfileConversationExamplePhrasesItemMax = 300;

export const getVoiceStyleWorkspaceResponseDraftOneProfileConversationExamplePhrasesMax = 8;

export const getVoiceStyleWorkspaceResponseDraftOneProfileConversationAdvancedInstructionsMax = 4000;

export const getVoiceStyleWorkspaceResponseDraftOneProfileSoundVoiceNameMax = 160;

export const getVoiceStyleWorkspaceResponseDraftOneProfileSoundAccentMax = 80;

export const getVoiceStyleWorkspaceResponseDraftOneProfileSoundSpeakingRateMin = 0.8;
export const getVoiceStyleWorkspaceResponseDraftOneProfileSoundSpeakingRateMax = 1.2;

export const getVoiceStyleWorkspaceResponseDraftOneProfileSoundResponseTimingMsMin = 300;
export const getVoiceStyleWorkspaceResponseDraftOneProfileSoundResponseTimingMsMax = 2000;



export const getVoiceStyleWorkspaceResponse = zod.object({
  "active": zod.object({
  "id": zod.uuid().nullable(),
  "version": zod.int().min(getVoiceStyleWorkspaceResponseActiveVersionMin),
  "revision": zod.int().min(getVoiceStyleWorkspaceResponseActiveRevisionMin),
  "status": zod.enum(['draft', 'active', 'retired']),
  "baseActiveVersionId": zod.uuid().nullish(),
  "profile": zod.object({
  "schemaVersion": zod.literal(1),
  "conversation": zod.object({
  "tone": zod.enum(['professional', 'conversational', 'energetic', 'calm']),
  "formality": zod.enum(['formal', 'balanced', 'casual']),
  "warmth": zod.int().min(getVoiceStyleWorkspaceResponseActiveProfileConversationWarmthMin).max(getVoiceStyleWorkspaceResponseActiveProfileConversationWarmthMax),
  "brevity": zod.int().min(getVoiceStyleWorkspaceResponseActiveProfileConversationBrevityMin).max(getVoiceStyleWorkspaceResponseActiveProfileConversationBrevityMax),
  "greeting": zod.string().min(1).max(getVoiceStyleWorkspaceResponseActiveProfileConversationGreetingMax),
  "questionPacing": zod.enum(['one_at_a_time', 'group_related']),
  "examplePhrases": zod.array(zod.string().min(1).max(getVoiceStyleWorkspaceResponseActiveProfileConversationExamplePhrasesItemMax)).max(getVoiceStyleWorkspaceResponseActiveProfileConversationExamplePhrasesMax),
  "advancedInstructions": zod.string().max(getVoiceStyleWorkspaceResponseActiveProfileConversationAdvancedInstructionsMax)
}),
  "sound": zod.object({
  "voiceName": zod.string().min(1).max(getVoiceStyleWorkspaceResponseActiveProfileSoundVoiceNameMax),
  "accent": zod.string().min(1).max(getVoiceStyleWorkspaceResponseActiveProfileSoundAccentMax),
  "speakingRate": zod.number().min(getVoiceStyleWorkspaceResponseActiveProfileSoundSpeakingRateMin).max(getVoiceStyleWorkspaceResponseActiveProfileSoundSpeakingRateMax),
  "responseTimingMs": zod.int().min(getVoiceStyleWorkspaceResponseActiveProfileSoundResponseTimingMsMin).max(getVoiceStyleWorkspaceResponseActiveProfileSoundResponseTimingMsMax)
})
}),
  "compiledInstructions": zod.string(),
  "compiledHash": zod.string(),
  "protectedFingerprint": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "draft": zod.union([zod.object({
  "id": zod.uuid().nullable(),
  "version": zod.int().min(getVoiceStyleWorkspaceResponseDraftOneVersionMin),
  "revision": zod.int().min(getVoiceStyleWorkspaceResponseDraftOneRevisionMin),
  "status": zod.enum(['draft', 'active', 'retired']),
  "baseActiveVersionId": zod.uuid().nullish(),
  "profile": zod.object({
  "schemaVersion": zod.literal(1),
  "conversation": zod.object({
  "tone": zod.enum(['professional', 'conversational', 'energetic', 'calm']),
  "formality": zod.enum(['formal', 'balanced', 'casual']),
  "warmth": zod.int().min(getVoiceStyleWorkspaceResponseDraftOneProfileConversationWarmthMin).max(getVoiceStyleWorkspaceResponseDraftOneProfileConversationWarmthMax),
  "brevity": zod.int().min(getVoiceStyleWorkspaceResponseDraftOneProfileConversationBrevityMin).max(getVoiceStyleWorkspaceResponseDraftOneProfileConversationBrevityMax),
  "greeting": zod.string().min(1).max(getVoiceStyleWorkspaceResponseDraftOneProfileConversationGreetingMax),
  "questionPacing": zod.enum(['one_at_a_time', 'group_related']),
  "examplePhrases": zod.array(zod.string().min(1).max(getVoiceStyleWorkspaceResponseDraftOneProfileConversationExamplePhrasesItemMax)).max(getVoiceStyleWorkspaceResponseDraftOneProfileConversationExamplePhrasesMax),
  "advancedInstructions": zod.string().max(getVoiceStyleWorkspaceResponseDraftOneProfileConversationAdvancedInstructionsMax)
}),
  "sound": zod.object({
  "voiceName": zod.string().min(1).max(getVoiceStyleWorkspaceResponseDraftOneProfileSoundVoiceNameMax),
  "accent": zod.string().min(1).max(getVoiceStyleWorkspaceResponseDraftOneProfileSoundAccentMax),
  "speakingRate": zod.number().min(getVoiceStyleWorkspaceResponseDraftOneProfileSoundSpeakingRateMin).max(getVoiceStyleWorkspaceResponseDraftOneProfileSoundSpeakingRateMax),
  "responseTimingMs": zod.int().min(getVoiceStyleWorkspaceResponseDraftOneProfileSoundResponseTimingMsMin).max(getVoiceStyleWorkspaceResponseDraftOneProfileSoundResponseTimingMsMax)
})
}),
  "compiledInstructions": zod.string(),
  "compiledHash": zod.string(),
  "protectedFingerprint": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable()
}),zod.null()]),
  "activationEligibility": zod.object({
  "id": zod.uuid(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable()
}).nullable(),
  "capabilities": zod.object({
  "apiVersion": zod.string(),
  "voices": zod.array(zod.object({
  "name": zod.string(),
  "label": zod.string(),
  "accent": zod.string()
})),
  "controls": zod.record(zod.string(), zod.unknown())
}),
  "aiAvailable": zod.boolean(),
  "voiceLiveAvailable": zod.boolean(),
  "entityId": zod.uuid()
})


/**
 * @summary Optimistically create or update the entity voice-style draft
 */
export const saveVoiceStyleDraftBodyExpectedRevisionMin = 0;

export const saveVoiceStyleDraftBodyProfileConversationWarmthMin = 0;
export const saveVoiceStyleDraftBodyProfileConversationWarmthMax = 100;

export const saveVoiceStyleDraftBodyProfileConversationBrevityMin = 0;
export const saveVoiceStyleDraftBodyProfileConversationBrevityMax = 100;

export const saveVoiceStyleDraftBodyProfileConversationGreetingMax = 500;

export const saveVoiceStyleDraftBodyProfileConversationExamplePhrasesItemMax = 300;

export const saveVoiceStyleDraftBodyProfileConversationExamplePhrasesMax = 8;

export const saveVoiceStyleDraftBodyProfileConversationAdvancedInstructionsMax = 4000;

export const saveVoiceStyleDraftBodyProfileSoundVoiceNameMax = 160;

export const saveVoiceStyleDraftBodyProfileSoundAccentMax = 80;

export const saveVoiceStyleDraftBodyProfileSoundSpeakingRateMin = 0.8;
export const saveVoiceStyleDraftBodyProfileSoundSpeakingRateMax = 1.2;

export const saveVoiceStyleDraftBodyProfileSoundResponseTimingMsMin = 300;
export const saveVoiceStyleDraftBodyProfileSoundResponseTimingMsMax = 2000;



export const saveVoiceStyleDraftBody = zod.object({
  "expectedRevision": zod.int().min(saveVoiceStyleDraftBodyExpectedRevisionMin),
  "profile": zod.object({
  "schemaVersion": zod.literal(1),
  "conversation": zod.object({
  "tone": zod.enum(['professional', 'conversational', 'energetic', 'calm']),
  "formality": zod.enum(['formal', 'balanced', 'casual']),
  "warmth": zod.int().min(saveVoiceStyleDraftBodyProfileConversationWarmthMin).max(saveVoiceStyleDraftBodyProfileConversationWarmthMax),
  "brevity": zod.int().min(saveVoiceStyleDraftBodyProfileConversationBrevityMin).max(saveVoiceStyleDraftBodyProfileConversationBrevityMax),
  "greeting": zod.string().min(1).max(saveVoiceStyleDraftBodyProfileConversationGreetingMax),
  "questionPacing": zod.enum(['one_at_a_time', 'group_related']),
  "examplePhrases": zod.array(zod.string().min(1).max(saveVoiceStyleDraftBodyProfileConversationExamplePhrasesItemMax)).max(saveVoiceStyleDraftBodyProfileConversationExamplePhrasesMax),
  "advancedInstructions": zod.string().max(saveVoiceStyleDraftBodyProfileConversationAdvancedInstructionsMax)
}),
  "sound": zod.object({
  "voiceName": zod.string().min(1).max(saveVoiceStyleDraftBodyProfileSoundVoiceNameMax),
  "accent": zod.string().min(1).max(saveVoiceStyleDraftBodyProfileSoundAccentMax),
  "speakingRate": zod.number().min(saveVoiceStyleDraftBodyProfileSoundSpeakingRateMin).max(saveVoiceStyleDraftBodyProfileSoundSpeakingRateMax),
  "responseTimingMs": zod.int().min(saveVoiceStyleDraftBodyProfileSoundResponseTimingMsMin).max(saveVoiceStyleDraftBodyProfileSoundResponseTimingMsMax)
})
})
})

export const saveVoiceStyleDraftResponseVersionMin = 0;

export const saveVoiceStyleDraftResponseRevisionMin = 0;

export const saveVoiceStyleDraftResponseProfileConversationWarmthMin = 0;
export const saveVoiceStyleDraftResponseProfileConversationWarmthMax = 100;

export const saveVoiceStyleDraftResponseProfileConversationBrevityMin = 0;
export const saveVoiceStyleDraftResponseProfileConversationBrevityMax = 100;

export const saveVoiceStyleDraftResponseProfileConversationGreetingMax = 500;

export const saveVoiceStyleDraftResponseProfileConversationExamplePhrasesItemMax = 300;

export const saveVoiceStyleDraftResponseProfileConversationExamplePhrasesMax = 8;

export const saveVoiceStyleDraftResponseProfileConversationAdvancedInstructionsMax = 4000;

export const saveVoiceStyleDraftResponseProfileSoundVoiceNameMax = 160;

export const saveVoiceStyleDraftResponseProfileSoundAccentMax = 80;

export const saveVoiceStyleDraftResponseProfileSoundSpeakingRateMin = 0.8;
export const saveVoiceStyleDraftResponseProfileSoundSpeakingRateMax = 1.2;

export const saveVoiceStyleDraftResponseProfileSoundResponseTimingMsMin = 300;
export const saveVoiceStyleDraftResponseProfileSoundResponseTimingMsMax = 2000;



export const saveVoiceStyleDraftResponse = zod.object({
  "id": zod.uuid().nullable(),
  "version": zod.int().min(saveVoiceStyleDraftResponseVersionMin),
  "revision": zod.int().min(saveVoiceStyleDraftResponseRevisionMin),
  "status": zod.enum(['draft', 'active', 'retired']),
  "baseActiveVersionId": zod.uuid().nullish(),
  "profile": zod.object({
  "schemaVersion": zod.literal(1),
  "conversation": zod.object({
  "tone": zod.enum(['professional', 'conversational', 'energetic', 'calm']),
  "formality": zod.enum(['formal', 'balanced', 'casual']),
  "warmth": zod.int().min(saveVoiceStyleDraftResponseProfileConversationWarmthMin).max(saveVoiceStyleDraftResponseProfileConversationWarmthMax),
  "brevity": zod.int().min(saveVoiceStyleDraftResponseProfileConversationBrevityMin).max(saveVoiceStyleDraftResponseProfileConversationBrevityMax),
  "greeting": zod.string().min(1).max(saveVoiceStyleDraftResponseProfileConversationGreetingMax),
  "questionPacing": zod.enum(['one_at_a_time', 'group_related']),
  "examplePhrases": zod.array(zod.string().min(1).max(saveVoiceStyleDraftResponseProfileConversationExamplePhrasesItemMax)).max(saveVoiceStyleDraftResponseProfileConversationExamplePhrasesMax),
  "advancedInstructions": zod.string().max(saveVoiceStyleDraftResponseProfileConversationAdvancedInstructionsMax)
}),
  "sound": zod.object({
  "voiceName": zod.string().min(1).max(saveVoiceStyleDraftResponseProfileSoundVoiceNameMax),
  "accent": zod.string().min(1).max(saveVoiceStyleDraftResponseProfileSoundAccentMax),
  "speakingRate": zod.number().min(saveVoiceStyleDraftResponseProfileSoundSpeakingRateMin).max(saveVoiceStyleDraftResponseProfileSoundSpeakingRateMax),
  "responseTimingMs": zod.int().min(saveVoiceStyleDraftResponseProfileSoundResponseTimingMsMin).max(saveVoiceStyleDraftResponseProfileSoundResponseTimingMsMax)
})
}),
  "compiledInstructions": zod.string(),
  "compiledHash": zod.string(),
  "protectedFingerprint": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Generate a review-only AI voice-style proposal for the current draft
 */

export const proposeVoiceStyleBodyMessageMax = 2000;



export const proposeVoiceStyleBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "message": zod.string().min(1).max(proposeVoiceStyleBodyMessageMax)
})


export const proposeVoiceStyleResponseProfileConversationWarmthMin = 0;
export const proposeVoiceStyleResponseProfileConversationWarmthMax = 100;

export const proposeVoiceStyleResponseProfileConversationBrevityMin = 0;
export const proposeVoiceStyleResponseProfileConversationBrevityMax = 100;

export const proposeVoiceStyleResponseProfileConversationGreetingMax = 500;

export const proposeVoiceStyleResponseProfileConversationExamplePhrasesItemMax = 300;

export const proposeVoiceStyleResponseProfileConversationExamplePhrasesMax = 8;

export const proposeVoiceStyleResponseProfileConversationAdvancedInstructionsMax = 4000;

export const proposeVoiceStyleResponseProfileSoundVoiceNameMax = 160;

export const proposeVoiceStyleResponseProfileSoundAccentMax = 80;

export const proposeVoiceStyleResponseProfileSoundSpeakingRateMin = 0.8;
export const proposeVoiceStyleResponseProfileSoundSpeakingRateMax = 1.2;

export const proposeVoiceStyleResponseProfileSoundResponseTimingMsMin = 300;
export const proposeVoiceStyleResponseProfileSoundResponseTimingMsMax = 2000;



export const proposeVoiceStyleResponse = zod.object({
  "draftId": zod.uuid(),
  "draftRevision": zod.int().min(1),
  "profile": zod.object({
  "schemaVersion": zod.literal(1),
  "conversation": zod.object({
  "tone": zod.enum(['professional', 'conversational', 'energetic', 'calm']),
  "formality": zod.enum(['formal', 'balanced', 'casual']),
  "warmth": zod.int().min(proposeVoiceStyleResponseProfileConversationWarmthMin).max(proposeVoiceStyleResponseProfileConversationWarmthMax),
  "brevity": zod.int().min(proposeVoiceStyleResponseProfileConversationBrevityMin).max(proposeVoiceStyleResponseProfileConversationBrevityMax),
  "greeting": zod.string().min(1).max(proposeVoiceStyleResponseProfileConversationGreetingMax),
  "questionPacing": zod.enum(['one_at_a_time', 'group_related']),
  "examplePhrases": zod.array(zod.string().min(1).max(proposeVoiceStyleResponseProfileConversationExamplePhrasesItemMax)).max(proposeVoiceStyleResponseProfileConversationExamplePhrasesMax),
  "advancedInstructions": zod.string().max(proposeVoiceStyleResponseProfileConversationAdvancedInstructionsMax)
}),
  "sound": zod.object({
  "voiceName": zod.string().min(1).max(proposeVoiceStyleResponseProfileSoundVoiceNameMax),
  "accent": zod.string().min(1).max(proposeVoiceStyleResponseProfileSoundAccentMax),
  "speakingRate": zod.number().min(proposeVoiceStyleResponseProfileSoundSpeakingRateMin).max(proposeVoiceStyleResponseProfileSoundSpeakingRateMax),
  "responseTimingMs": zod.int().min(proposeVoiceStyleResponseProfileSoundResponseTimingMsMin).max(proposeVoiceStyleResponseProfileSoundResponseTimingMsMax)
})
}),
  "explanation": zod.string(),
  "sampleExchange": zod.array(zod.object({
  "speaker": zod.enum(['Caller', 'Assistant']),
  "text": zod.string()
})),
  "changedFields": zod.array(zod.string())
})


/**
 * @summary Create an immutable live-test snapshot from the exact current draft
 */

export const createVoiceStyleTestResponseProfileConversationWarmthMin = 0;
export const createVoiceStyleTestResponseProfileConversationWarmthMax = 100;

export const createVoiceStyleTestResponseProfileConversationBrevityMin = 0;
export const createVoiceStyleTestResponseProfileConversationBrevityMax = 100;

export const createVoiceStyleTestResponseProfileConversationGreetingMax = 500;

export const createVoiceStyleTestResponseProfileConversationExamplePhrasesItemMax = 300;

export const createVoiceStyleTestResponseProfileConversationExamplePhrasesMax = 8;

export const createVoiceStyleTestResponseProfileConversationAdvancedInstructionsMax = 4000;

export const createVoiceStyleTestResponseProfileSoundVoiceNameMax = 160;

export const createVoiceStyleTestResponseProfileSoundAccentMax = 80;

export const createVoiceStyleTestResponseProfileSoundSpeakingRateMin = 0.8;
export const createVoiceStyleTestResponseProfileSoundSpeakingRateMax = 1.2;

export const createVoiceStyleTestResponseProfileSoundResponseTimingMsMin = 300;
export const createVoiceStyleTestResponseProfileSoundResponseTimingMsMax = 2000;



export const createVoiceStyleTestResponse = zod.object({
  "id": zod.uuid(),
  "draftId": zod.uuid(),
  "draftRevision": zod.int().min(1),
  "compiledHash": zod.string(),
  "profile": zod.object({
  "schemaVersion": zod.literal(1),
  "conversation": zod.object({
  "tone": zod.enum(['professional', 'conversational', 'energetic', 'calm']),
  "formality": zod.enum(['formal', 'balanced', 'casual']),
  "warmth": zod.int().min(createVoiceStyleTestResponseProfileConversationWarmthMin).max(createVoiceStyleTestResponseProfileConversationWarmthMax),
  "brevity": zod.int().min(createVoiceStyleTestResponseProfileConversationBrevityMin).max(createVoiceStyleTestResponseProfileConversationBrevityMax),
  "greeting": zod.string().min(1).max(createVoiceStyleTestResponseProfileConversationGreetingMax),
  "questionPacing": zod.enum(['one_at_a_time', 'group_related']),
  "examplePhrases": zod.array(zod.string().min(1).max(createVoiceStyleTestResponseProfileConversationExamplePhrasesItemMax)).max(createVoiceStyleTestResponseProfileConversationExamplePhrasesMax),
  "advancedInstructions": zod.string().max(createVoiceStyleTestResponseProfileConversationAdvancedInstructionsMax)
}),
  "sound": zod.object({
  "voiceName": zod.string().min(1).max(createVoiceStyleTestResponseProfileSoundVoiceNameMax),
  "accent": zod.string().min(1).max(createVoiceStyleTestResponseProfileSoundAccentMax),
  "speakingRate": zod.number().min(createVoiceStyleTestResponseProfileSoundSpeakingRateMin).max(createVoiceStyleTestResponseProfileSoundSpeakingRateMax),
  "responseTimingMs": zod.int().min(createVoiceStyleTestResponseProfileSoundResponseTimingMsMin).max(createVoiceStyleTestResponseProfileSoundResponseTimingMsMax)
})
})
})


/**
 * @summary Mint a one-use staff voice ticket bound to an immutable draft test snapshot
 */
export const createVoiceStyleTestTicketParams = zod.object({
  "id": zod.uuid()
})

export const createVoiceStyleTestTicketResponse = zod.object({
  "ticket": zod.uuid(),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Explicitly activate a tested exact voice-style draft
 */



export const activateVoiceStyleBody = zod.object({
  "draftId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "testId": zod.uuid()
})

export const activateVoiceStyleResponseVersionMin = 0;

export const activateVoiceStyleResponseRevisionMin = 0;

export const activateVoiceStyleResponseProfileConversationWarmthMin = 0;
export const activateVoiceStyleResponseProfileConversationWarmthMax = 100;

export const activateVoiceStyleResponseProfileConversationBrevityMin = 0;
export const activateVoiceStyleResponseProfileConversationBrevityMax = 100;

export const activateVoiceStyleResponseProfileConversationGreetingMax = 500;

export const activateVoiceStyleResponseProfileConversationExamplePhrasesItemMax = 300;

export const activateVoiceStyleResponseProfileConversationExamplePhrasesMax = 8;

export const activateVoiceStyleResponseProfileConversationAdvancedInstructionsMax = 4000;

export const activateVoiceStyleResponseProfileSoundVoiceNameMax = 160;

export const activateVoiceStyleResponseProfileSoundAccentMax = 80;

export const activateVoiceStyleResponseProfileSoundSpeakingRateMin = 0.8;
export const activateVoiceStyleResponseProfileSoundSpeakingRateMax = 1.2;

export const activateVoiceStyleResponseProfileSoundResponseTimingMsMin = 300;
export const activateVoiceStyleResponseProfileSoundResponseTimingMsMax = 2000;



export const activateVoiceStyleResponse = zod.object({
  "id": zod.uuid().nullable(),
  "version": zod.int().min(activateVoiceStyleResponseVersionMin),
  "revision": zod.int().min(activateVoiceStyleResponseRevisionMin),
  "status": zod.enum(['draft', 'active', 'retired']),
  "baseActiveVersionId": zod.uuid().nullish(),
  "profile": zod.object({
  "schemaVersion": zod.literal(1),
  "conversation": zod.object({
  "tone": zod.enum(['professional', 'conversational', 'energetic', 'calm']),
  "formality": zod.enum(['formal', 'balanced', 'casual']),
  "warmth": zod.int().min(activateVoiceStyleResponseProfileConversationWarmthMin).max(activateVoiceStyleResponseProfileConversationWarmthMax),
  "brevity": zod.int().min(activateVoiceStyleResponseProfileConversationBrevityMin).max(activateVoiceStyleResponseProfileConversationBrevityMax),
  "greeting": zod.string().min(1).max(activateVoiceStyleResponseProfileConversationGreetingMax),
  "questionPacing": zod.enum(['one_at_a_time', 'group_related']),
  "examplePhrases": zod.array(zod.string().min(1).max(activateVoiceStyleResponseProfileConversationExamplePhrasesItemMax)).max(activateVoiceStyleResponseProfileConversationExamplePhrasesMax),
  "advancedInstructions": zod.string().max(activateVoiceStyleResponseProfileConversationAdvancedInstructionsMax)
}),
  "sound": zod.object({
  "voiceName": zod.string().min(1).max(activateVoiceStyleResponseProfileSoundVoiceNameMax),
  "accent": zod.string().min(1).max(activateVoiceStyleResponseProfileSoundAccentMax),
  "speakingRate": zod.number().min(activateVoiceStyleResponseProfileSoundSpeakingRateMin).max(activateVoiceStyleResponseProfileSoundSpeakingRateMax),
  "responseTimingMs": zod.int().min(activateVoiceStyleResponseProfileSoundResponseTimingMsMin).max(activateVoiceStyleResponseProfileSoundResponseTimingMsMax)
})
}),
  "compiledInstructions": zod.string(),
  "compiledHash": zod.string(),
  "protectedFingerprint": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary List immutable active and retired voice-style versions
 */
export const listVoiceStyleHistoryQueryLimitDefault = 20;
export const listVoiceStyleHistoryQueryLimitMax = 50;

export const listVoiceStyleHistoryQueryOffsetDefault = 0;
export const listVoiceStyleHistoryQueryOffsetMin = 0;



export const listVoiceStyleHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listVoiceStyleHistoryQueryLimitMax).default(listVoiceStyleHistoryQueryLimitDefault),
  "offset": zod.int().min(listVoiceStyleHistoryQueryOffsetMin).default(listVoiceStyleHistoryQueryOffsetDefault)
})

export const listVoiceStyleHistoryResponseItemsItemVersionMin = 0;

export const listVoiceStyleHistoryResponseItemsItemRevisionMin = 0;

export const listVoiceStyleHistoryResponseItemsItemProfileConversationWarmthMin = 0;
export const listVoiceStyleHistoryResponseItemsItemProfileConversationWarmthMax = 100;

export const listVoiceStyleHistoryResponseItemsItemProfileConversationBrevityMin = 0;
export const listVoiceStyleHistoryResponseItemsItemProfileConversationBrevityMax = 100;

export const listVoiceStyleHistoryResponseItemsItemProfileConversationGreetingMax = 500;

export const listVoiceStyleHistoryResponseItemsItemProfileConversationExamplePhrasesItemMax = 300;

export const listVoiceStyleHistoryResponseItemsItemProfileConversationExamplePhrasesMax = 8;

export const listVoiceStyleHistoryResponseItemsItemProfileConversationAdvancedInstructionsMax = 4000;

export const listVoiceStyleHistoryResponseItemsItemProfileSoundVoiceNameMax = 160;

export const listVoiceStyleHistoryResponseItemsItemProfileSoundAccentMax = 80;

export const listVoiceStyleHistoryResponseItemsItemProfileSoundSpeakingRateMin = 0.8;
export const listVoiceStyleHistoryResponseItemsItemProfileSoundSpeakingRateMax = 1.2;

export const listVoiceStyleHistoryResponseItemsItemProfileSoundResponseTimingMsMin = 300;
export const listVoiceStyleHistoryResponseItemsItemProfileSoundResponseTimingMsMax = 2000;

export const listVoiceStyleHistoryResponseTotalMin = 0;


export const listVoiceStyleHistoryResponseOffsetMin = 0;



export const listVoiceStyleHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid().nullable(),
  "version": zod.int().min(listVoiceStyleHistoryResponseItemsItemVersionMin),
  "revision": zod.int().min(listVoiceStyleHistoryResponseItemsItemRevisionMin),
  "status": zod.enum(['draft', 'active', 'retired']),
  "baseActiveVersionId": zod.uuid().nullish(),
  "profile": zod.object({
  "schemaVersion": zod.literal(1),
  "conversation": zod.object({
  "tone": zod.enum(['professional', 'conversational', 'energetic', 'calm']),
  "formality": zod.enum(['formal', 'balanced', 'casual']),
  "warmth": zod.int().min(listVoiceStyleHistoryResponseItemsItemProfileConversationWarmthMin).max(listVoiceStyleHistoryResponseItemsItemProfileConversationWarmthMax),
  "brevity": zod.int().min(listVoiceStyleHistoryResponseItemsItemProfileConversationBrevityMin).max(listVoiceStyleHistoryResponseItemsItemProfileConversationBrevityMax),
  "greeting": zod.string().min(1).max(listVoiceStyleHistoryResponseItemsItemProfileConversationGreetingMax),
  "questionPacing": zod.enum(['one_at_a_time', 'group_related']),
  "examplePhrases": zod.array(zod.string().min(1).max(listVoiceStyleHistoryResponseItemsItemProfileConversationExamplePhrasesItemMax)).max(listVoiceStyleHistoryResponseItemsItemProfileConversationExamplePhrasesMax),
  "advancedInstructions": zod.string().max(listVoiceStyleHistoryResponseItemsItemProfileConversationAdvancedInstructionsMax)
}),
  "sound": zod.object({
  "voiceName": zod.string().min(1).max(listVoiceStyleHistoryResponseItemsItemProfileSoundVoiceNameMax),
  "accent": zod.string().min(1).max(listVoiceStyleHistoryResponseItemsItemProfileSoundAccentMax),
  "speakingRate": zod.number().min(listVoiceStyleHistoryResponseItemsItemProfileSoundSpeakingRateMin).max(listVoiceStyleHistoryResponseItemsItemProfileSoundSpeakingRateMax),
  "responseTimingMs": zod.int().min(listVoiceStyleHistoryResponseItemsItemProfileSoundResponseTimingMsMin).max(listVoiceStyleHistoryResponseItemsItemProfileSoundResponseTimingMsMax)
})
}),
  "compiledInstructions": zod.string(),
  "compiledHash": zod.string(),
  "protectedFingerprint": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int().min(listVoiceStyleHistoryResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listVoiceStyleHistoryResponseOffsetMin)
})


/**
 * @summary Restore an earlier version into the editable draft lifecycle
 */
export const restoreVoiceStyleVersionParams = zod.object({
  "id": zod.uuid()
})

export const restoreVoiceStyleVersionBodyExpectedRevisionMin = 0;



export const restoreVoiceStyleVersionBody = zod.object({
  "expectedRevision": zod.int().min(restoreVoiceStyleVersionBodyExpectedRevisionMin)
})

export const restoreVoiceStyleVersionResponseVersionMin = 0;

export const restoreVoiceStyleVersionResponseRevisionMin = 0;

export const restoreVoiceStyleVersionResponseProfileConversationWarmthMin = 0;
export const restoreVoiceStyleVersionResponseProfileConversationWarmthMax = 100;

export const restoreVoiceStyleVersionResponseProfileConversationBrevityMin = 0;
export const restoreVoiceStyleVersionResponseProfileConversationBrevityMax = 100;

export const restoreVoiceStyleVersionResponseProfileConversationGreetingMax = 500;

export const restoreVoiceStyleVersionResponseProfileConversationExamplePhrasesItemMax = 300;

export const restoreVoiceStyleVersionResponseProfileConversationExamplePhrasesMax = 8;

export const restoreVoiceStyleVersionResponseProfileConversationAdvancedInstructionsMax = 4000;

export const restoreVoiceStyleVersionResponseProfileSoundVoiceNameMax = 160;

export const restoreVoiceStyleVersionResponseProfileSoundAccentMax = 80;

export const restoreVoiceStyleVersionResponseProfileSoundSpeakingRateMin = 0.8;
export const restoreVoiceStyleVersionResponseProfileSoundSpeakingRateMax = 1.2;

export const restoreVoiceStyleVersionResponseProfileSoundResponseTimingMsMin = 300;
export const restoreVoiceStyleVersionResponseProfileSoundResponseTimingMsMax = 2000;



export const restoreVoiceStyleVersionResponse = zod.object({
  "id": zod.uuid().nullable(),
  "version": zod.int().min(restoreVoiceStyleVersionResponseVersionMin),
  "revision": zod.int().min(restoreVoiceStyleVersionResponseRevisionMin),
  "status": zod.enum(['draft', 'active', 'retired']),
  "baseActiveVersionId": zod.uuid().nullish(),
  "profile": zod.object({
  "schemaVersion": zod.literal(1),
  "conversation": zod.object({
  "tone": zod.enum(['professional', 'conversational', 'energetic', 'calm']),
  "formality": zod.enum(['formal', 'balanced', 'casual']),
  "warmth": zod.int().min(restoreVoiceStyleVersionResponseProfileConversationWarmthMin).max(restoreVoiceStyleVersionResponseProfileConversationWarmthMax),
  "brevity": zod.int().min(restoreVoiceStyleVersionResponseProfileConversationBrevityMin).max(restoreVoiceStyleVersionResponseProfileConversationBrevityMax),
  "greeting": zod.string().min(1).max(restoreVoiceStyleVersionResponseProfileConversationGreetingMax),
  "questionPacing": zod.enum(['one_at_a_time', 'group_related']),
  "examplePhrases": zod.array(zod.string().min(1).max(restoreVoiceStyleVersionResponseProfileConversationExamplePhrasesItemMax)).max(restoreVoiceStyleVersionResponseProfileConversationExamplePhrasesMax),
  "advancedInstructions": zod.string().max(restoreVoiceStyleVersionResponseProfileConversationAdvancedInstructionsMax)
}),
  "sound": zod.object({
  "voiceName": zod.string().min(1).max(restoreVoiceStyleVersionResponseProfileSoundVoiceNameMax),
  "accent": zod.string().min(1).max(restoreVoiceStyleVersionResponseProfileSoundAccentMax),
  "speakingRate": zod.number().min(restoreVoiceStyleVersionResponseProfileSoundSpeakingRateMin).max(restoreVoiceStyleVersionResponseProfileSoundSpeakingRateMax),
  "responseTimingMs": zod.int().min(restoreVoiceStyleVersionResponseProfileSoundResponseTimingMsMin).max(restoreVoiceStyleVersionResponseProfileSoundResponseTimingMsMax)
})
}),
  "compiledInstructions": zod.string(),
  "compiledHash": zod.string(),
  "protectedFingerprint": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Update the org-scoped voice-agent behavior and consent disclosure
 */
export const updateVoiceSettingsBodyGreetingMax = 1000;

export const updateVoiceSettingsBodyConsentMessageMax = 1000;

export const updateVoiceSettingsBodyBehaviorMax = 4000;

export const updateVoiceSettingsBodyVoiceNameMax = 120;

export const updateVoiceSettingsBodyVadThresholdMin = 0.1;
export const updateVoiceSettingsBodyVadThresholdMax = 0.95;

export const updateVoiceSettingsBodySilenceDurationMsMin = 200;
export const updateVoiceSettingsBodySilenceDurationMsMax = 3000;

export const updateVoiceSettingsBodyBusinessNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');
export const updateVoiceSettingsBodyTransferNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');


export const updateVoiceSettingsBody = zod.object({
  "greeting": zod.string().min(1).max(updateVoiceSettingsBodyGreetingMax),
  "consentMessage": zod.string().min(1).max(updateVoiceSettingsBodyConsentMessageMax),
  "recordingEnabled": zod.boolean(),
  "behavior": zod.string().min(1).max(updateVoiceSettingsBodyBehaviorMax),
  "enquiryCaptureMode": zod.enum(['after_consent', 'useful_request', 'every_call']),
  "voiceName": zod.string().min(1).max(updateVoiceSettingsBodyVoiceNameMax),
  "vadThreshold": zod.number().min(updateVoiceSettingsBodyVadThresholdMin).max(updateVoiceSettingsBodyVadThresholdMax),
  "silenceDurationMs": zod.int().min(updateVoiceSettingsBodySilenceDurationMsMin).max(updateVoiceSettingsBodySilenceDurationMsMax),
  "businessNumber": zod.string().regex(updateVoiceSettingsBodyBusinessNumberRegExp).nullish(),
  "transferNumber": zod.string().regex(updateVoiceSettingsBodyTransferNumberRegExp).nullish(),
  "callAuthentication": zod.object({
  "staffApprovalEnabled": zod.boolean(),
  "customerPortalApprovalEnabled": zod.boolean(),
  "customerOtpFallbackEnabled": zod.boolean()
})
})

export const updateVoiceSettingsResponseGreetingMax = 1000;

export const updateVoiceSettingsResponseConsentMessageMax = 1000;

export const updateVoiceSettingsResponseBehaviorMax = 4000;

export const updateVoiceSettingsResponseVoiceNameMax = 120;

export const updateVoiceSettingsResponseVadThresholdMin = 0.1;
export const updateVoiceSettingsResponseVadThresholdMax = 0.95;

export const updateVoiceSettingsResponseSilenceDurationMsMin = 200;
export const updateVoiceSettingsResponseSilenceDurationMsMax = 3000;

export const updateVoiceSettingsResponseBusinessNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');
export const updateVoiceSettingsResponseTransferNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');


export const updateVoiceSettingsResponse = zod.object({
  "greeting": zod.string().min(1).max(updateVoiceSettingsResponseGreetingMax),
  "consentMessage": zod.string().min(1).max(updateVoiceSettingsResponseConsentMessageMax),
  "recordingEnabled": zod.boolean(),
  "behavior": zod.string().min(1).max(updateVoiceSettingsResponseBehaviorMax),
  "enquiryCaptureMode": zod.enum(['after_consent', 'useful_request', 'every_call']),
  "voiceName": zod.string().min(1).max(updateVoiceSettingsResponseVoiceNameMax),
  "vadThreshold": zod.number().min(updateVoiceSettingsResponseVadThresholdMin).max(updateVoiceSettingsResponseVadThresholdMax),
  "silenceDurationMs": zod.int().min(updateVoiceSettingsResponseSilenceDurationMsMin).max(updateVoiceSettingsResponseSilenceDurationMsMax),
  "businessNumber": zod.string().regex(updateVoiceSettingsResponseBusinessNumberRegExp).nullish(),
  "transferNumber": zod.string().regex(updateVoiceSettingsResponseTransferNumberRegExp).nullish(),
  "callAuthentication": zod.object({
  "staffApprovalEnabled": zod.boolean(),
  "customerPortalApprovalEnabled": zod.boolean(),
  "customerOtpFallbackEnabled": zod.boolean()
})
})


/**
 * @summary Connect and provision a Twilio-pattern telephony account
 */
export const connectTelephonyBodyAccountSidRegExp = new RegExp('^AC[a-fA-F0-9]{32}$');
export const connectTelephonyBodyAuthTokenMin = 16;

export const connectTelephonyBodyPhoneNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');
export const connectTelephonyBodyTransferNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');


export const connectTelephonyBody = zod.object({
  "accountSid": zod.string().regex(connectTelephonyBodyAccountSidRegExp),
  "authToken": zod.string().min(connectTelephonyBodyAuthTokenMin),
  "phoneNumber": zod.string().regex(connectTelephonyBodyPhoneNumberRegExp),
  "transferNumber": zod.string().regex(connectTelephonyBodyTransferNumberRegExp).nullish()
})

export const connectTelephonyResponseSettingsGreetingMax = 1000;

export const connectTelephonyResponseSettingsConsentMessageMax = 1000;

export const connectTelephonyResponseSettingsBehaviorMax = 4000;

export const connectTelephonyResponseSettingsVoiceNameMax = 120;

export const connectTelephonyResponseSettingsVadThresholdMin = 0.1;
export const connectTelephonyResponseSettingsVadThresholdMax = 0.95;

export const connectTelephonyResponseSettingsSilenceDurationMsMin = 200;
export const connectTelephonyResponseSettingsSilenceDurationMsMax = 3000;

export const connectTelephonyResponseSettingsBusinessNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');
export const connectTelephonyResponseSettingsTransferNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');


export const connectTelephonyResponse = zod.object({
  "connectionStatus": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "connected": zod.boolean(),
  "mode": zod.enum(['simulation', 'live']),
  "providerKey": zod.enum(['simulation', 'twilio']),
  "voiceLiveConfigured": zod.boolean(),
  "displayName": zod.string().nullish(),
  "phoneNumber": zod.string().nullish(),
  "settings": zod.object({
  "greeting": zod.string().min(1).max(connectTelephonyResponseSettingsGreetingMax),
  "consentMessage": zod.string().min(1).max(connectTelephonyResponseSettingsConsentMessageMax),
  "recordingEnabled": zod.boolean(),
  "behavior": zod.string().min(1).max(connectTelephonyResponseSettingsBehaviorMax),
  "enquiryCaptureMode": zod.enum(['after_consent', 'useful_request', 'every_call']),
  "voiceName": zod.string().min(1).max(connectTelephonyResponseSettingsVoiceNameMax),
  "vadThreshold": zod.number().min(connectTelephonyResponseSettingsVadThresholdMin).max(connectTelephonyResponseSettingsVadThresholdMax),
  "silenceDurationMs": zod.int().min(connectTelephonyResponseSettingsSilenceDurationMsMin).max(connectTelephonyResponseSettingsSilenceDurationMsMax),
  "businessNumber": zod.string().regex(connectTelephonyResponseSettingsBusinessNumberRegExp).nullish(),
  "transferNumber": zod.string().regex(connectTelephonyResponseSettingsTransferNumberRegExp).nullish(),
  "callAuthentication": zod.object({
  "staffApprovalEnabled": zod.boolean(),
  "customerPortalApprovalEnabled": zod.boolean(),
  "customerOtpFallbackEnabled": zod.boolean()
})
})
})


/**
 * @summary Configure the environment-backed Twilio number to use the inbound voice webhook
 */
export const provisionVoiceTelephonyResponseSettingsGreetingMax = 1000;

export const provisionVoiceTelephonyResponseSettingsConsentMessageMax = 1000;

export const provisionVoiceTelephonyResponseSettingsBehaviorMax = 4000;

export const provisionVoiceTelephonyResponseSettingsVoiceNameMax = 120;

export const provisionVoiceTelephonyResponseSettingsVadThresholdMin = 0.1;
export const provisionVoiceTelephonyResponseSettingsVadThresholdMax = 0.95;

export const provisionVoiceTelephonyResponseSettingsSilenceDurationMsMin = 200;
export const provisionVoiceTelephonyResponseSettingsSilenceDurationMsMax = 3000;

export const provisionVoiceTelephonyResponseSettingsBusinessNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');
export const provisionVoiceTelephonyResponseSettingsTransferNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');


export const provisionVoiceTelephonyResponse = zod.object({
  "connectionStatus": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "connected": zod.boolean(),
  "mode": zod.enum(['simulation', 'live']),
  "providerKey": zod.enum(['simulation', 'twilio']),
  "voiceLiveConfigured": zod.boolean(),
  "displayName": zod.string().nullish(),
  "phoneNumber": zod.string().nullish(),
  "settings": zod.object({
  "greeting": zod.string().min(1).max(provisionVoiceTelephonyResponseSettingsGreetingMax),
  "consentMessage": zod.string().min(1).max(provisionVoiceTelephonyResponseSettingsConsentMessageMax),
  "recordingEnabled": zod.boolean(),
  "behavior": zod.string().min(1).max(provisionVoiceTelephonyResponseSettingsBehaviorMax),
  "enquiryCaptureMode": zod.enum(['after_consent', 'useful_request', 'every_call']),
  "voiceName": zod.string().min(1).max(provisionVoiceTelephonyResponseSettingsVoiceNameMax),
  "vadThreshold": zod.number().min(provisionVoiceTelephonyResponseSettingsVadThresholdMin).max(provisionVoiceTelephonyResponseSettingsVadThresholdMax),
  "silenceDurationMs": zod.int().min(provisionVoiceTelephonyResponseSettingsSilenceDurationMsMin).max(provisionVoiceTelephonyResponseSettingsSilenceDurationMsMax),
  "businessNumber": zod.string().regex(provisionVoiceTelephonyResponseSettingsBusinessNumberRegExp).nullish(),
  "transferNumber": zod.string().regex(provisionVoiceTelephonyResponseSettingsTransferNumberRegExp).nullish(),
  "callAuthentication": zod.object({
  "staffApprovalEnabled": zod.boolean(),
  "customerPortalApprovalEnabled": zod.boolean(),
  "customerOtpFallbackEnabled": zod.boolean()
})
})
})


/**
 * @summary Disconnect the telephony account and return to simulation mode
 */
export const disconnectTelephonyResponseSettingsGreetingMax = 1000;

export const disconnectTelephonyResponseSettingsConsentMessageMax = 1000;

export const disconnectTelephonyResponseSettingsBehaviorMax = 4000;

export const disconnectTelephonyResponseSettingsVoiceNameMax = 120;

export const disconnectTelephonyResponseSettingsVadThresholdMin = 0.1;
export const disconnectTelephonyResponseSettingsVadThresholdMax = 0.95;

export const disconnectTelephonyResponseSettingsSilenceDurationMsMin = 200;
export const disconnectTelephonyResponseSettingsSilenceDurationMsMax = 3000;

export const disconnectTelephonyResponseSettingsBusinessNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');
export const disconnectTelephonyResponseSettingsTransferNumberRegExp = new RegExp('^[+][1-9][0-9]{7,14}$');


export const disconnectTelephonyResponse = zod.object({
  "connectionStatus": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "connected": zod.boolean(),
  "mode": zod.enum(['simulation', 'live']),
  "providerKey": zod.enum(['simulation', 'twilio']),
  "voiceLiveConfigured": zod.boolean(),
  "displayName": zod.string().nullish(),
  "phoneNumber": zod.string().nullish(),
  "settings": zod.object({
  "greeting": zod.string().min(1).max(disconnectTelephonyResponseSettingsGreetingMax),
  "consentMessage": zod.string().min(1).max(disconnectTelephonyResponseSettingsConsentMessageMax),
  "recordingEnabled": zod.boolean(),
  "behavior": zod.string().min(1).max(disconnectTelephonyResponseSettingsBehaviorMax),
  "enquiryCaptureMode": zod.enum(['after_consent', 'useful_request', 'every_call']),
  "voiceName": zod.string().min(1).max(disconnectTelephonyResponseSettingsVoiceNameMax),
  "vadThreshold": zod.number().min(disconnectTelephonyResponseSettingsVadThresholdMin).max(disconnectTelephonyResponseSettingsVadThresholdMax),
  "silenceDurationMs": zod.int().min(disconnectTelephonyResponseSettingsSilenceDurationMsMin).max(disconnectTelephonyResponseSettingsSilenceDurationMsMax),
  "businessNumber": zod.string().regex(disconnectTelephonyResponseSettingsBusinessNumberRegExp).nullish(),
  "transferNumber": zod.string().regex(disconnectTelephonyResponseSettingsTransferNumberRegExp).nullish(),
  "callAuthentication": zod.object({
  "staffApprovalEnabled": zod.boolean(),
  "customerPortalApprovalEnabled": zod.boolean(),
  "customerOtpFallbackEnabled": zod.boolean()
})
})
})


export const listVoiceCallsQueryPageDefault = 1;

export const listVoiceCallsQueryLimitDefault = 20;
export const listVoiceCallsQueryLimitMax = 100;



export const listVoiceCallsQueryParams = zod.object({
  "contactId": zod.uuid().optional(),
  "direction": zod.enum(['inbound', 'outbound']).optional(),
  "status": zod.enum(['queued', 'ringing', 'in_progress', 'completed', 'transfer_requested', 'failed', 'no_answer', 'cancelled']).optional(),
  "page": zod.int().min(1).default(listVoiceCallsQueryPageDefault),
  "limit": zod.int().min(1).max(listVoiceCallsQueryLimitMax).default(listVoiceCallsQueryLimitDefault)
})

export const listVoiceCallsResponseItemsItemVoiceStyleVersionVersionMin = 0;

export const listVoiceCallsResponseTotalMin = 0;





export const listVoiceCallsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "providerKey": zod.string(),
  "mode": zod.enum(['simulation', 'live']),
  "externalCallId": zod.string().nullish(),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['ai', 'click_to_call']),
  "status": zod.enum(['queued', 'ringing', 'in_progress', 'completed', 'transfer_requested', 'failed', 'no_answer', 'cancelled']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "fromNumber": zod.string(),
  "toNumber": zod.string(),
  "objective": zod.string().nullish(),
  "consentPlayed": zod.boolean(),
  "transferRequested": zod.boolean(),
  "recordingReference": zod.string().nullish(),
  "transcript": zod.string(),
  "summary": zod.string().nullish(),
  "outcome": zod.enum(['enquiry', 'qualified', 'follow_up', 'transfer_requested', 'message', 'no_answer', 'other']).nullish(),
  "durationSeconds": zod.int().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "lastError": zod.string().nullish(),
  "voiceStyleVersion": zod.object({
  "versionId": zod.uuid().nullable(),
  "version": zod.int().min(listVoiceCallsResponseItemsItemVoiceStyleVersionVersionMin),
  "source": zod.enum(['legacy', 'active', 'draft_test'])
}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listVoiceCallsResponseTotalMin),
  "page": zod.int().min(1),
  "limit": zod.int().min(1)
})


export const getVoiceCallParams = zod.object({
  "id": zod.uuid()
})

export const getVoiceCallResponseVoiceStyleVersionVersionMin = 0;



export const getVoiceCallResponse = zod.object({
  "id": zod.uuid(),
  "providerKey": zod.string(),
  "mode": zod.enum(['simulation', 'live']),
  "externalCallId": zod.string().nullish(),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['ai', 'click_to_call']),
  "status": zod.enum(['queued', 'ringing', 'in_progress', 'completed', 'transfer_requested', 'failed', 'no_answer', 'cancelled']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "fromNumber": zod.string(),
  "toNumber": zod.string(),
  "objective": zod.string().nullish(),
  "consentPlayed": zod.boolean(),
  "transferRequested": zod.boolean(),
  "recordingReference": zod.string().nullish(),
  "transcript": zod.string(),
  "summary": zod.string().nullish(),
  "outcome": zod.enum(['enquiry', 'qualified', 'follow_up', 'transfer_requested', 'message', 'no_answer', 'other']).nullish(),
  "durationSeconds": zod.int().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "lastError": zod.string().nullish(),
  "voiceStyleVersion": zod.object({
  "versionId": zod.uuid().nullable(),
  "version": zod.int().min(getVoiceCallResponseVoiceStyleVersionVersionMin),
  "source": zod.enum(['legacy', 'active', 'draft_test'])
}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getVoiceCallRecordingParams = zod.object({
  "id": zod.uuid()
})

export const getVoiceCallRecordingResponse = zod.unknown()


/**
 * @summary Start an AI or click-to-call interaction for a CRM contact
 */
export const startOutboundVoiceCallBodyObjectiveMax = 2000;



export const startOutboundVoiceCallBody = zod.object({
  "contactId": zod.uuid(),
  "objective": zod.string().min(1).max(startOutboundVoiceCallBodyObjectiveMax),
  "kind": zod.enum(['ai', 'click_to_call'])
})

export const startOutboundVoiceCallResponseVoiceStyleVersionVersionMin = 0;



export const startOutboundVoiceCallResponse = zod.object({
  "id": zod.uuid(),
  "providerKey": zod.string(),
  "mode": zod.enum(['simulation', 'live']),
  "externalCallId": zod.string().nullish(),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['ai', 'click_to_call']),
  "status": zod.enum(['queued', 'ringing', 'in_progress', 'completed', 'transfer_requested', 'failed', 'no_answer', 'cancelled']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "fromNumber": zod.string(),
  "toNumber": zod.string(),
  "objective": zod.string().nullish(),
  "consentPlayed": zod.boolean(),
  "transferRequested": zod.boolean(),
  "recordingReference": zod.string().nullish(),
  "transcript": zod.string(),
  "summary": zod.string().nullish(),
  "outcome": zod.enum(['enquiry', 'qualified', 'follow_up', 'transfer_requested', 'message', 'no_answer', 'other']).nullish(),
  "durationSeconds": zod.int().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "lastError": zod.string().nullish(),
  "voiceStyleVersion": zod.object({
  "versionId": zod.uuid().nullable(),
  "version": zod.int().min(startOutboundVoiceCallResponseVoiceStyleVersionVersionMin),
  "source": zod.enum(['legacy', 'active', 'draft_test'])
}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Revalidates the exact active plan, reviewed call brief, recipient, contact window, live sender and entity permission before starting the canonical click-to-call workflow.
 * @summary Initiate one prepared staff-led Relationship Health call
 */
export const startHealthOutreachCallParams = zod.object({
  "executionId": zod.uuid()
})

export const startHealthOutreachCallResponseVoiceStyleVersionVersionMin = 0;



export const startHealthOutreachCallResponse = zod.object({
  "id": zod.uuid(),
  "providerKey": zod.string(),
  "mode": zod.enum(['simulation', 'live']),
  "externalCallId": zod.string().nullish(),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['ai', 'click_to_call']),
  "status": zod.enum(['queued', 'ringing', 'in_progress', 'completed', 'transfer_requested', 'failed', 'no_answer', 'cancelled']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "fromNumber": zod.string(),
  "toNumber": zod.string(),
  "objective": zod.string().nullish(),
  "consentPlayed": zod.boolean(),
  "transferRequested": zod.boolean(),
  "recordingReference": zod.string().nullish(),
  "transcript": zod.string(),
  "summary": zod.string().nullish(),
  "outcome": zod.enum(['enquiry', 'qualified', 'follow_up', 'transfer_requested', 'message', 'no_answer', 'other']).nullish(),
  "durationSeconds": zod.int().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "lastError": zod.string().nullish(),
  "voiceStyleVersion": zod.object({
  "versionId": zod.uuid().nullable(),
  "version": zod.int().min(startHealthOutreachCallResponseVoiceStyleVersionVersionMin),
  "source": zod.enum(['legacy', 'active', 'draft_test'])
}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires Workforce authentication and entity.records.read. Raw identity claims and verification material are never returned.
 * @summary List entity-scoped telephone authentication requests and grants
 */
export const listCallAuthHistoryQueryLimitDefault = 50;
export const listCallAuthHistoryQueryLimitMax = 100;

export const listCallAuthHistoryQueryOffsetDefault = 0;
export const listCallAuthHistoryQueryOffsetMin = 0;

export const listCallAuthHistoryQueryPairingReferenceRegExp = new RegExp('^[A-Z0-9]{6,12}$');


export const listCallAuthHistoryQueryParams = zod.object({
  "limit": zod.int().min(1).max(listCallAuthHistoryQueryLimitMax).default(listCallAuthHistoryQueryLimitDefault),
  "offset": zod.int().min(listCallAuthHistoryQueryOffsetMin).default(listCallAuthHistoryQueryOffsetDefault),
  "identityType": zod.enum(['customer', 'staff']).optional(),
  "pairingReference": zod.string().regex(listCallAuthHistoryQueryPairingReferenceRegExp).optional().describe('Optional non-secret pairing locator entered by the signed-in staff member.'),
  "requestStatus": zod.enum(['pending', 'approved', 'denied', 'expired', 'cancelled']).optional(),
  "callId": zod.uuid().optional()
})

export const listCallAuthHistoryResponseItemsItemRequestPairingReferenceRegExp = new RegExp('^[A-Z0-9]{6,12}$');
export const listCallAuthHistoryResponseItemsItemRequestCallerHintMax = 80;

export const listCallAuthHistoryResponseItemsItemRequestTenantNameMax = 200;

export const listCallAuthHistoryResponseItemsItemRequestEntityNameMax = 200;

export const listCallAuthHistoryResponseItemsItemRequestPurposeMax = 200;

export const listCallAuthHistoryResponseItemsItemRequestCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const listCallAuthHistoryResponseItemsItemRequestCapabilitiesMax = 20;

export const listCallAuthHistoryResponseItemsItemOtpChallengeOneAttemptsRemainingMin = 0;
export const listCallAuthHistoryResponseItemsItemOtpChallengeOneAttemptsRemainingMax = 3;

export const listCallAuthHistoryResponseItemsItemOtpChallengeOneDestinationHintMax = 120;

export const listCallAuthHistoryResponseItemsItemGrantOnePurposeMax = 200;

export const listCallAuthHistoryResponseItemsItemGrantOneCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const listCallAuthHistoryResponseItemsItemGrantOneCapabilitiesMax = 20;


export const listCallAuthHistoryResponseTotalMin = 0;

export const listCallAuthHistoryResponseLimitMax = 100;

export const listCallAuthHistoryResponseOffsetMin = 0;



export const listCallAuthHistoryResponse = zod.object({
  "items": zod.array(zod.object({
  "request": zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "pairingReference": zod.string().regex(listCallAuthHistoryResponseItemsItemRequestPairingReferenceRegExp),
  "identityType": zod.enum(['customer', 'staff']),
  "callerHint": zod.string().min(1).max(listCallAuthHistoryResponseItemsItemRequestCallerHintMax).describe('Masked caller information safe for the approval interface.'),
  "tenantName": zod.string().min(1).max(listCallAuthHistoryResponseItemsItemRequestTenantNameMax),
  "entityName": zod.string().min(1).max(listCallAuthHistoryResponseItemsItemRequestEntityNameMax),
  "purpose": zod.string().min(1).max(listCallAuthHistoryResponseItemsItemRequestPurposeMax),
  "capabilities": zod.array(zod.string().regex(listCallAuthHistoryResponseItemsItemRequestCapabilitiesItemRegExp)).min(1).max(listCallAuthHistoryResponseItemsItemRequestCapabilitiesMax),
  "status": zod.enum(['pending', 'approved', 'denied', 'expired', 'cancelled']),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "consumedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "otpChallenge": zod.union([zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "callId": zod.uuid(),
  "status": zod.enum(['pending', 'verified', 'locked', 'expired', 'cancelled']),
  "attemptsRemaining": zod.int().min(listCallAuthHistoryResponseItemsItemOtpChallengeOneAttemptsRemainingMin).max(listCallAuthHistoryResponseItemsItemOtpChallengeOneAttemptsRemainingMax),
  "destinationHint": zod.string().min(1).max(listCallAuthHistoryResponseItemsItemOtpChallengeOneDestinationHintMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullish(),
  "consumedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]).optional(),
  "grant": zod.union([zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "requestId": zod.uuid(),
  "identityType": zod.enum(['customer', 'staff']),
  "customerAccountId": zod.uuid().nullish(),
  "purpose": zod.string().min(1).max(listCallAuthHistoryResponseItemsItemGrantOnePurposeMax),
  "capabilities": zod.array(zod.string().regex(listCallAuthHistoryResponseItemsItemGrantOneCapabilitiesItemRegExp)).min(1).max(listCallAuthHistoryResponseItemsItemGrantOneCapabilitiesMax),
  "authorizationRevision": zod.int().min(1),
  "status": zod.enum(['active', 'revoked', 'expired', 'ended']),
  "firstUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]).optional()
})),
  "total": zod.int().min(listCallAuthHistoryResponseTotalMin),
  "limit": zod.int().min(1).max(listCallAuthHistoryResponseLimitMax),
  "offset": zod.int().min(listCallAuthHistoryResponseOffsetMin)
})


/**
 * Requires Workforce authentication and never returns provider tokens, OTP material, or raw identity claims.
 * @summary Read the safe authentication state for one entity-scoped call
 */
export const getCallAuthStatusParams = zod.object({
  "callId": zod.uuid()
})

export const getCallAuthStatusResponseCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const getCallAuthStatusResponseCapabilitiesMax = 20;



export const getCallAuthStatusResponse = zod.object({
  "callId": zod.uuid(),
  "state": zod.enum(['anonymous', 'verification_pending', 'verified_customer', 'verified_staff']),
  "requestId": zod.uuid().nullish(),
  "grantId": zod.uuid().nullish(),
  "identityType": zod.union([zod.enum(['customer', 'staff']),zod.null()]).optional(),
  "capabilities": zod.array(zod.string().regex(getCallAuthStatusResponseCapabilitiesItemRegExp)).max(getCallAuthStatusResponseCapabilitiesMax),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish()
})


/**
 * The server binds the grant to the validated Workforce subject, current entity permission set, and authorization revision.
 * @summary Approve a pending staff telephone request as the signed-in Workforce user
 */
export const approveStaffCallAuthRequestParams = zod.object({
  "requestId": zod.uuid()
})

export const approveStaffCallAuthRequestBody = zod.object({
  "expectedUpdatedAt": zod.iso.datetime({"offset":true})
})

export const approveStaffCallAuthRequestResponsePurposeMax = 200;

export const approveStaffCallAuthRequestResponseCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const approveStaffCallAuthRequestResponseCapabilitiesMax = 20;




export const approveStaffCallAuthRequestResponse = zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "requestId": zod.uuid(),
  "identityType": zod.enum(['customer', 'staff']),
  "customerAccountId": zod.uuid().nullish(),
  "purpose": zod.string().min(1).max(approveStaffCallAuthRequestResponsePurposeMax),
  "capabilities": zod.array(zod.string().regex(approveStaffCallAuthRequestResponseCapabilitiesItemRegExp)).min(1).max(approveStaffCallAuthRequestResponseCapabilitiesMax),
  "authorizationRevision": zod.int().min(1),
  "status": zod.enum(['active', 'revoked', 'expired', 'ended']),
  "firstUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Deny a pending staff telephone request
 */
export const denyStaffCallAuthRequestParams = zod.object({
  "requestId": zod.uuid()
})

export const denyStaffCallAuthRequestBodyReasonMax = 500;



export const denyStaffCallAuthRequestBody = zod.object({
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(1).max(denyStaffCallAuthRequestBodyReasonMax).optional()
})

export const denyStaffCallAuthRequestResponsePairingReferenceRegExp = new RegExp('^[A-Z0-9]{6,12}$');
export const denyStaffCallAuthRequestResponseCallerHintMax = 80;

export const denyStaffCallAuthRequestResponseTenantNameMax = 200;

export const denyStaffCallAuthRequestResponseEntityNameMax = 200;

export const denyStaffCallAuthRequestResponsePurposeMax = 200;

export const denyStaffCallAuthRequestResponseCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const denyStaffCallAuthRequestResponseCapabilitiesMax = 20;



export const denyStaffCallAuthRequestResponse = zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "pairingReference": zod.string().regex(denyStaffCallAuthRequestResponsePairingReferenceRegExp),
  "identityType": zod.enum(['customer', 'staff']),
  "callerHint": zod.string().min(1).max(denyStaffCallAuthRequestResponseCallerHintMax).describe('Masked caller information safe for the approval interface.'),
  "tenantName": zod.string().min(1).max(denyStaffCallAuthRequestResponseTenantNameMax),
  "entityName": zod.string().min(1).max(denyStaffCallAuthRequestResponseEntityNameMax),
  "purpose": zod.string().min(1).max(denyStaffCallAuthRequestResponsePurposeMax),
  "capabilities": zod.array(zod.string().regex(denyStaffCallAuthRequestResponseCapabilitiesItemRegExp)).min(1).max(denyStaffCallAuthRequestResponseCapabilitiesMax),
  "status": zod.enum(['pending', 'approved', 'denied', 'expired', 'cancelled']),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "consumedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Revoke an active staff or customer telephone grant
 */
export const revokeStaffCallAuthGrantParams = zod.object({
  "grantId": zod.uuid()
})

export const revokeStaffCallAuthGrantBodyReasonMax = 500;



export const revokeStaffCallAuthGrantBody = zod.object({
  "reason": zod.string().min(1).max(revokeStaffCallAuthGrantBodyReasonMax)
})

export const revokeStaffCallAuthGrantResponsePurposeMax = 200;

export const revokeStaffCallAuthGrantResponseCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const revokeStaffCallAuthGrantResponseCapabilitiesMax = 20;




export const revokeStaffCallAuthGrantResponse = zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "requestId": zod.uuid(),
  "identityType": zod.enum(['customer', 'staff']),
  "customerAccountId": zod.uuid().nullish(),
  "purpose": zod.string().min(1).max(revokeStaffCallAuthGrantResponsePurposeMax),
  "capabilities": zod.array(zod.string().regex(revokeStaffCallAuthGrantResponseCapabilitiesItemRegExp)).min(1).max(revokeStaffCallAuthGrantResponseCapabilitiesMax),
  "authorizationRevision": zod.int().min(1),
  "status": zod.enum(['active', 'revoked', 'expired', 'ended']),
  "firstUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * Requires External ID and a server-derived portal context. Only customer requests for that account are returned.
 * @summary List call approval requests for the signed-in customer context
 */
export const listPortalCallAuthRequestsQueryLimitDefault = 50;
export const listPortalCallAuthRequestsQueryLimitMax = 100;

export const listPortalCallAuthRequestsQueryOffsetDefault = 0;
export const listPortalCallAuthRequestsQueryOffsetMin = 0;

export const listPortalCallAuthRequestsQueryPairingReferenceRegExp = new RegExp('^[A-Z0-9]{6,12}$');


export const listPortalCallAuthRequestsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listPortalCallAuthRequestsQueryLimitMax).default(listPortalCallAuthRequestsQueryLimitDefault),
  "offset": zod.int().min(listPortalCallAuthRequestsQueryOffsetMin).default(listPortalCallAuthRequestsQueryOffsetDefault),
  "pairingReference": zod.string().regex(listPortalCallAuthRequestsQueryPairingReferenceRegExp).optional(),
  "requestStatus": zod.enum(['pending', 'approved', 'denied', 'expired', 'cancelled']).optional()
})

export const listPortalCallAuthRequestsHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const listPortalCallAuthRequestsResponseItemsItemRequestPairingReferenceRegExp = new RegExp('^[A-Z0-9]{6,12}$');
export const listPortalCallAuthRequestsResponseItemsItemRequestCallerHintMax = 80;

export const listPortalCallAuthRequestsResponseItemsItemRequestTenantNameMax = 200;

export const listPortalCallAuthRequestsResponseItemsItemRequestEntityNameMax = 200;

export const listPortalCallAuthRequestsResponseItemsItemRequestPurposeMax = 200;

export const listPortalCallAuthRequestsResponseItemsItemRequestCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const listPortalCallAuthRequestsResponseItemsItemRequestCapabilitiesMax = 20;

export const listPortalCallAuthRequestsResponseItemsItemOtpChallengeOneAttemptsRemainingMin = 0;
export const listPortalCallAuthRequestsResponseItemsItemOtpChallengeOneAttemptsRemainingMax = 3;

export const listPortalCallAuthRequestsResponseItemsItemOtpChallengeOneDestinationHintMax = 120;

export const listPortalCallAuthRequestsResponseItemsItemGrantOnePurposeMax = 200;

export const listPortalCallAuthRequestsResponseItemsItemGrantOneCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const listPortalCallAuthRequestsResponseItemsItemGrantOneCapabilitiesMax = 20;


export const listPortalCallAuthRequestsResponseTotalMin = 0;

export const listPortalCallAuthRequestsResponseLimitMax = 100;

export const listPortalCallAuthRequestsResponseOffsetMin = 0;



export const listPortalCallAuthRequestsResponse = zod.object({
  "items": zod.array(zod.object({
  "request": zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "pairingReference": zod.string().regex(listPortalCallAuthRequestsResponseItemsItemRequestPairingReferenceRegExp),
  "identityType": zod.enum(['customer', 'staff']),
  "callerHint": zod.string().min(1).max(listPortalCallAuthRequestsResponseItemsItemRequestCallerHintMax).describe('Masked caller information safe for the approval interface.'),
  "tenantName": zod.string().min(1).max(listPortalCallAuthRequestsResponseItemsItemRequestTenantNameMax),
  "entityName": zod.string().min(1).max(listPortalCallAuthRequestsResponseItemsItemRequestEntityNameMax),
  "purpose": zod.string().min(1).max(listPortalCallAuthRequestsResponseItemsItemRequestPurposeMax),
  "capabilities": zod.array(zod.string().regex(listPortalCallAuthRequestsResponseItemsItemRequestCapabilitiesItemRegExp)).min(1).max(listPortalCallAuthRequestsResponseItemsItemRequestCapabilitiesMax),
  "status": zod.enum(['pending', 'approved', 'denied', 'expired', 'cancelled']),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "consumedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}),
  "otpChallenge": zod.union([zod.object({
  "id": zod.uuid(),
  "requestId": zod.uuid(),
  "callId": zod.uuid(),
  "status": zod.enum(['pending', 'verified', 'locked', 'expired', 'cancelled']),
  "attemptsRemaining": zod.int().min(listPortalCallAuthRequestsResponseItemsItemOtpChallengeOneAttemptsRemainingMin).max(listPortalCallAuthRequestsResponseItemsItemOtpChallengeOneAttemptsRemainingMax),
  "destinationHint": zod.string().min(1).max(listPortalCallAuthRequestsResponseItemsItemOtpChallengeOneDestinationHintMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullish(),
  "consumedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]).optional(),
  "grant": zod.union([zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "requestId": zod.uuid(),
  "identityType": zod.enum(['customer', 'staff']),
  "customerAccountId": zod.uuid().nullish(),
  "purpose": zod.string().min(1).max(listPortalCallAuthRequestsResponseItemsItemGrantOnePurposeMax),
  "capabilities": zod.array(zod.string().regex(listPortalCallAuthRequestsResponseItemsItemGrantOneCapabilitiesItemRegExp)).min(1).max(listPortalCallAuthRequestsResponseItemsItemGrantOneCapabilitiesMax),
  "authorizationRevision": zod.int().min(1),
  "status": zod.enum(['active', 'revoked', 'expired', 'ended']),
  "firstUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
}),zod.null()]).optional()
})),
  "total": zod.int().min(listPortalCallAuthRequestsResponseTotalMin),
  "limit": zod.int().min(1).max(listPortalCallAuthRequestsResponseLimitMax),
  "offset": zod.int().min(listPortalCallAuthRequestsResponseOffsetMin)
})


/**
 * The account and External ID subject are derived by the server; neither may be supplied in the request body.
 * @summary Approve a pending customer call for the signed-in portal account
 */
export const approveCustomerCallAuthRequestParams = zod.object({
  "requestId": zod.uuid()
})

export const approveCustomerCallAuthRequestHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const approveCustomerCallAuthRequestBody = zod.object({
  "expectedUpdatedAt": zod.iso.datetime({"offset":true})
})

export const approveCustomerCallAuthRequestResponsePurposeMax = 200;

export const approveCustomerCallAuthRequestResponseCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const approveCustomerCallAuthRequestResponseCapabilitiesMax = 20;




export const approveCustomerCallAuthRequestResponse = zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "requestId": zod.uuid(),
  "identityType": zod.enum(['customer', 'staff']),
  "customerAccountId": zod.uuid().nullish(),
  "purpose": zod.string().min(1).max(approveCustomerCallAuthRequestResponsePurposeMax),
  "capabilities": zod.array(zod.string().regex(approveCustomerCallAuthRequestResponseCapabilitiesItemRegExp)).min(1).max(approveCustomerCallAuthRequestResponseCapabilitiesMax),
  "authorizationRevision": zod.int().min(1),
  "status": zod.enum(['active', 'revoked', 'expired', 'ended']),
  "firstUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Deny a pending customer call approval request
 */
export const denyCustomerCallAuthRequestParams = zod.object({
  "requestId": zod.uuid()
})

export const denyCustomerCallAuthRequestHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const denyCustomerCallAuthRequestBodyReasonMax = 500;



export const denyCustomerCallAuthRequestBody = zod.object({
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "reason": zod.string().min(1).max(denyCustomerCallAuthRequestBodyReasonMax).optional()
})

export const denyCustomerCallAuthRequestResponsePairingReferenceRegExp = new RegExp('^[A-Z0-9]{6,12}$');
export const denyCustomerCallAuthRequestResponseCallerHintMax = 80;

export const denyCustomerCallAuthRequestResponseTenantNameMax = 200;

export const denyCustomerCallAuthRequestResponseEntityNameMax = 200;

export const denyCustomerCallAuthRequestResponsePurposeMax = 200;

export const denyCustomerCallAuthRequestResponseCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const denyCustomerCallAuthRequestResponseCapabilitiesMax = 20;



export const denyCustomerCallAuthRequestResponse = zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "pairingReference": zod.string().regex(denyCustomerCallAuthRequestResponsePairingReferenceRegExp),
  "identityType": zod.enum(['customer', 'staff']),
  "callerHint": zod.string().min(1).max(denyCustomerCallAuthRequestResponseCallerHintMax).describe('Masked caller information safe for the approval interface.'),
  "tenantName": zod.string().min(1).max(denyCustomerCallAuthRequestResponseTenantNameMax),
  "entityName": zod.string().min(1).max(denyCustomerCallAuthRequestResponseEntityNameMax),
  "purpose": zod.string().min(1).max(denyCustomerCallAuthRequestResponsePurposeMax),
  "capabilities": zod.array(zod.string().regex(denyCustomerCallAuthRequestResponseCapabilitiesItemRegExp)).min(1).max(denyCustomerCallAuthRequestResponseCapabilitiesMax),
  "status": zod.enum(['pending', 'approved', 'denied', 'expired', 'cancelled']),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "consumedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Revoke the signed-in customer's active call grant
 */
export const revokeCustomerCallAuthGrantParams = zod.object({
  "grantId": zod.uuid()
})

export const revokeCustomerCallAuthGrantHeader = zod.object({
  "x-portal-context": zod.uuid().optional().describe('Account id from GET /api/portal/me. Unknown contexts are rejected.')
})

export const revokeCustomerCallAuthGrantBodyReasonMax = 500;



export const revokeCustomerCallAuthGrantBody = zod.object({
  "reason": zod.string().min(1).max(revokeCustomerCallAuthGrantBodyReasonMax)
})

export const revokeCustomerCallAuthGrantResponsePurposeMax = 200;

export const revokeCustomerCallAuthGrantResponseCapabilitiesItemRegExp = new RegExp('^[a-z][a-z0-9_.:-]{2,119}$');
export const revokeCustomerCallAuthGrantResponseCapabilitiesMax = 20;




export const revokeCustomerCallAuthGrantResponse = zod.object({
  "id": zod.uuid(),
  "callId": zod.uuid(),
  "requestId": zod.uuid(),
  "identityType": zod.enum(['customer', 'staff']),
  "customerAccountId": zod.uuid().nullish(),
  "purpose": zod.string().min(1).max(revokeCustomerCallAuthGrantResponsePurposeMax),
  "capabilities": zod.array(zod.string().regex(revokeCustomerCallAuthGrantResponseCapabilitiesItemRegExp)).min(1).max(revokeCustomerCallAuthGrantResponseCapabilitiesMax),
  "authorizationRevision": zod.int().min(1),
  "status": zod.enum(['active', 'revoked', 'expired', 'ended']),
  "firstUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastUsedAt": zod.iso.datetime({"offset":true}).nullish(),
  "revokedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "terminalAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Exercise the complete inbound voice-agent loop without a telephony account
 */
export const simulateInboundVoiceCallBodyFromNumberMin = 3;
export const simulateInboundVoiceCallBodyFromNumberMax = 40;

export const simulateInboundVoiceCallBodyTurnsItemMax = 4000;

export const simulateInboundVoiceCallBodyTurnsMax = 12;



export const simulateInboundVoiceCallBody = zod.object({
  "fromNumber": zod.string().min(simulateInboundVoiceCallBodyFromNumberMin).max(simulateInboundVoiceCallBodyFromNumberMax),
  "contactId": zod.uuid().nullish(),
  "turns": zod.array(zod.string().min(1).max(simulateInboundVoiceCallBodyTurnsItemMax)).min(1).max(simulateInboundVoiceCallBodyTurnsMax)
})

export const simulateInboundVoiceCallResponseVoiceStyleVersionVersionMin = 0;



export const simulateInboundVoiceCallResponse = zod.object({
  "id": zod.uuid(),
  "providerKey": zod.string(),
  "mode": zod.enum(['simulation', 'live']),
  "externalCallId": zod.string().nullish(),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['ai', 'click_to_call']),
  "status": zod.enum(['queued', 'ringing', 'in_progress', 'completed', 'transfer_requested', 'failed', 'no_answer', 'cancelled']),
  "contactId": zod.uuid().nullish(),
  "accountId": zod.uuid().nullish(),
  "fromNumber": zod.string(),
  "toNumber": zod.string(),
  "objective": zod.string().nullish(),
  "consentPlayed": zod.boolean(),
  "transferRequested": zod.boolean(),
  "recordingReference": zod.string().nullish(),
  "transcript": zod.string(),
  "summary": zod.string().nullish(),
  "outcome": zod.enum(['enquiry', 'qualified', 'follow_up', 'transfer_requested', 'message', 'no_answer', 'other']).nullish(),
  "durationSeconds": zod.int().nullish(),
  "enquiryId": zod.uuid().nullish(),
  "outreachExecutionId": zod.uuid().nullish(),
  "lastError": zod.string().nullish(),
  "voiceStyleVersion": zod.object({
  "versionId": zod.uuid().nullable(),
  "version": zod.int().min(simulateInboundVoiceCallResponseVoiceStyleVersionVersionMin),
  "source": zod.enum(['legacy', 'active', 'draft_test'])
}).nullish(),
  "startedAt": zod.iso.datetime({"offset":true}).nullish(),
  "endedAt": zod.iso.datetime({"offset":true}).nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Twilio-compatible inbound call webhook
 */
export const receiveTwilioInboundVoiceCallBody = zod.object({
  "CallSid": zod.string(),
  "From": zod.string(),
  "To": zod.string()
})

export const receiveTwilioInboundVoiceCallResponse = zod.unknown()


export const answerTwilioOutboundVoiceCallQueryParams = zod.object({
  "callId": zod.uuid()
})

export const answerTwilioOutboundVoiceCallBody = zod.object({
  "CallSid": zod.string().optional()
})

export const answerTwilioOutboundVoiceCallResponse = zod.unknown()


export const continueTwilioVoiceTurnQueryParams = zod.object({
  "callId": zod.uuid()
})

export const continueTwilioVoiceTurnBody = zod.object({
  "CallSid": zod.string().optional(),
  "SpeechResult": zod.string().optional()
})

export const continueTwilioVoiceTurnResponse = zod.unknown()


/**
 * @summary Accept generic Twilio call status callbacks and resolve the CRM call by CallSid
 */
export const updateTwilioVoiceCallStatusQueryParams = zod.object({
  "callId": zod.uuid().optional().describe('Legacy CRM call identifier retained for existing outbound callbacks')
})

export const updateTwilioVoiceCallStatusBodyCallDurationRegExp = new RegExp('^[0-9]+$');
export const updateTwilioVoiceCallStatusBodySequenceNumberRegExp = new RegExp('^[0-9]+$');


export const updateTwilioVoiceCallStatusBody = zod.object({
  "CallSid": zod.string(),
  "CallStatus": zod.string(),
  "CallDuration": zod.string().regex(updateTwilioVoiceCallStatusBodyCallDurationRegExp).optional(),
  "SequenceNumber": zod.string().regex(updateTwilioVoiceCallStatusBodySequenceNumberRegExp).optional()
})

export const updateTwilioVoiceCallStatusResponse = zod.void()


export const updateTwilioVoiceRecordingQueryParams = zod.object({
  "callId": zod.uuid()
})

export const updateTwilioVoiceRecordingBody = zod.object({
  "CallSid": zod.string().optional(),
  "RecordingSid": zod.string().optional(),
  "RecordingUrl": zod.string().optional()
})

export const updateTwilioVoiceRecordingResponse = zod.void()


/**
 * Public only at the HTTP boundary. The exact callback URL and form payload must pass Twilio signature validation. Digits are never returned, persisted, logged, recorded, transcribed, or sent to the AI.
 * @summary Accept bounded keypad digits for one customer verification challenge
 */
export const verifyTwilioCallAuthDigitsQueryParams = zod.object({
  "callId": zod.uuid(),
  "challengeId": zod.uuid()
})

export const verifyTwilioCallAuthDigitsHeaderXTwilioSignatureMin = 20;
export const verifyTwilioCallAuthDigitsHeaderXTwilioSignatureMax = 256;



export const verifyTwilioCallAuthDigitsHeader = zod.object({
  "x-twilio-signature": zod.string().min(verifyTwilioCallAuthDigitsHeaderXTwilioSignatureMin).max(verifyTwilioCallAuthDigitsHeaderXTwilioSignatureMax).describe('Twilio request signature validated against the exact public callback URL and form body.')
})

export const verifyTwilioCallAuthDigitsBodyCallSidRegExp = new RegExp('^CA[a-fA-F0-9]{32}$');
export const verifyTwilioCallAuthDigitsBodyDigitsRegExp = new RegExp('^[0-9]{6}$');


export const verifyTwilioCallAuthDigitsBody = zod.object({
  "CallSid": zod.string().regex(verifyTwilioCallAuthDigitsBodyCallSidRegExp),
  "Digits": zod.string().regex(verifyTwilioCallAuthDigitsBodyDigitsRegExp)
})

export const verifyTwilioCallAuthDigitsResponse = zod.unknown()


/**
 * The callback is signature-validated and intentionally stores no message body, destination, code, or campaign interaction.
 * @summary Accept signed provider delivery status for an authentication SMS
 */
export const receiveTwilioCallAuthSmsStatusQueryParams = zod.object({
  "callId": zod.uuid(),
  "challengeId": zod.uuid()
})

export const receiveTwilioCallAuthSmsStatusHeaderXTwilioSignatureMin = 20;
export const receiveTwilioCallAuthSmsStatusHeaderXTwilioSignatureMax = 256;



export const receiveTwilioCallAuthSmsStatusHeader = zod.object({
  "x-twilio-signature": zod.string().min(receiveTwilioCallAuthSmsStatusHeaderXTwilioSignatureMin).max(receiveTwilioCallAuthSmsStatusHeaderXTwilioSignatureMax).describe('Twilio request signature validated against the exact public callback URL and form body.')
})

export const receiveTwilioCallAuthSmsStatusBodyMessageSidMax = 100;

export const receiveTwilioCallAuthSmsStatusBodyMessageStatusMax = 40;



export const receiveTwilioCallAuthSmsStatusBody = zod.object({
  "MessageSid": zod.string().min(1).max(receiveTwilioCallAuthSmsStatusBodyMessageSidMax),
  "MessageStatus": zod.string().min(1).max(receiveTwilioCallAuthSmsStatusBodyMessageStatusMax)
})

export const receiveTwilioCallAuthSmsStatusResponse = zod.void()


/**
 * @summary List effective org-scoped platform configuration
 */
export const listPlatformConfigResponse = zod.object({
  "items": zod.array(zod.object({
  "namespace": zod.string(),
  "key": zod.string(),
  "value": zod.unknown(),
  "version": zod.int(),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


export const getJourneyWorkforceParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement'])
})

export const getJourneyWorkforceQueryWindowDefault = `30d`;
export const getJourneyWorkforceQueryIncludeTestDataDefault = false;

export const getJourneyWorkforceQueryParams = zod.object({
  "recordId": zod.uuid().optional(),
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(getJourneyWorkforceQueryWindowDefault),
  "includeTestData": zod.boolean().default(getJourneyWorkforceQueryIncludeTestDataDefault)
})

export const getJourneyWorkforceResponseStagesItemActionsItemAgentExecutedMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemAgentRecommendedMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemAgentPendingApprovalMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemAgentApprovedMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemAgentRejectedMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemAgentDeferredMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemAgentDismissedMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemAgentBlockedMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemAgentFailedMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemHumanTransitionsMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemHumanApprovalsMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemHumanRejectionsMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemHumanDismissalsMin = 0;

export const getJourneyWorkforceResponseStagesItemActionsItemHumanTotalMin = 0;

export const getJourneyWorkforceResponseStagesItemHumanTransitionsMin = 0;

export const getJourneyWorkforceResponseStagesItemHumanApprovalsMin = 0;

export const getJourneyWorkforceResponseStagesItemHumanRejectionsMin = 0;

export const getJourneyWorkforceResponseStagesItemHumanDismissalsMin = 0;

export const getJourneyWorkforceResponseStagesItemHumanTotalMin = 0;



export const getJourneyWorkforceResponse = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "window": zod.enum(['7d', '30d', '90d', 'all']),
  "bucket": zod.enum(['day', 'month']),
  "series": zod.array(zod.object({
  "t": zod.iso.datetime({"offset":true}),
  "agent": zod.int(),
  "human": zod.int()
})),
  "totals": zod.object({
  "agent": zod.int(),
  "human": zod.int()
}),
  "stages": zod.array(zod.object({
  "stageId": zod.string(),
  "label": zod.string(),
  "actions": zod.array(zod.object({
  "actionType": zod.string(),
  "agent": zod.object({
  "executed": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemAgentExecutedMin),
  "recommended": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemAgentRecommendedMin),
  "pending_approval": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemAgentPendingApprovalMin),
  "approved": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemAgentApprovedMin),
  "rejected": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemAgentRejectedMin),
  "deferred": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemAgentDeferredMin),
  "dismissed": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemAgentDismissedMin),
  "blocked": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemAgentBlockedMin),
  "failed": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemAgentFailedMin)
}),
  "human": zod.object({
  "transitions": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemHumanTransitionsMin),
  "approvals": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemHumanApprovalsMin),
  "rejections": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemHumanRejectionsMin),
  "dismissals": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemHumanDismissalsMin),
  "total": zod.int().min(getJourneyWorkforceResponseStagesItemActionsItemHumanTotalMin)
}),
  "operator": zod.enum(['agent', 'human', 'mixed', 'human_only']),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "authoritySource": zod.enum(['stage_override', 'crm_policy', 'default']),
  "lastAgentAt": zod.iso.datetime({"offset":true}).nullish(),
  "lastHumanAt": zod.iso.datetime({"offset":true}).nullish(),
  "suggestions": zod.array(zod.object({
  "actionType": zod.string(),
  "from": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "to": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "evidence": zod.string()
}))
})),
  "human": zod.object({
  "transitions": zod.int().min(getJourneyWorkforceResponseStagesItemHumanTransitionsMin),
  "approvals": zod.int().min(getJourneyWorkforceResponseStagesItemHumanApprovalsMin),
  "rejections": zod.int().min(getJourneyWorkforceResponseStagesItemHumanRejectionsMin),
  "dismissals": zod.int().min(getJourneyWorkforceResponseStagesItemHumanDismissalsMin),
  "total": zod.int().min(getJourneyWorkforceResponseStagesItemHumanTotalMin)
}),
  "series": zod.array(zod.object({
  "t": zod.iso.datetime({"offset":true}),
  "agent": zod.int(),
  "human": zod.int()
}))
}))
})


/**
 * @summary Get named agent and human desks grouped by business function
 */
export const getJourneyFloorplanParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement'])
})

export const getJourneyFloorplanQueryWindowDefault = `30d`;
export const getJourneyFloorplanQueryIncludeTestDataDefault = false;

export const getJourneyFloorplanQueryParams = zod.object({
  "recordId": zod.uuid().optional(),
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(getJourneyFloorplanQueryWindowDefault),
  "includeTestData": zod.boolean().default(getJourneyFloorplanQueryIncludeTestDataDefault)
})

export const getJourneyFloorplanResponseFunctionsItemIdMax = 160;

export const getJourneyFloorplanResponseFunctionsItemKeyMax = 80;

export const getJourneyFloorplanResponseFunctionsItemLabelMax = 80;

export const getJourneyFloorplanResponseFunctionsItemColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getJourneyFloorplanResponseFunctionsItemTotalsAgentsMin = 0;

export const getJourneyFloorplanResponseFunctionsItemTotalsHumansMin = 0;

export const getJourneyFloorplanResponseFunctionsItemTotalsQueueMin = 0;

export const getJourneyFloorplanResponseFunctionsItemTotalsThroughputMin = 0;

export const getJourneyFloorplanResponseFunctionsItemDesksItemIdMax = 160;

export const getJourneyFloorplanResponseFunctionsItemDesksItemLabelMax = 200;

export const getJourneyFloorplanResponseFunctionsItemDesksItemRefMax = 160;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueuePendingApprovalMin = 0;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueueRecommendedMin = 0;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueueBlockedMin = 0;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueueAssignedOpenMin = 0;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueueAwaitingDecisionMin = 0;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsItemIdMax = 160;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsItemRecordLabelMax = 500;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsItemStageIdMax = 100;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsItemDeepLinkMax = 2048;

export const getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsMax = 50;

export const getJourneyFloorplanResponseFunctionsItemDesksItemThroughputMin = 0;

export const getJourneyFloorplanResponseFunctionsItemDesksItemBusynessMin = 0;
export const getJourneyFloorplanResponseFunctionsItemDesksItemBusynessMax = 1;

export const getJourneyFloorplanResponseUnassignedIdMax = 160;

export const getJourneyFloorplanResponseUnassignedKeyMax = 80;

export const getJourneyFloorplanResponseUnassignedLabelMax = 80;

export const getJourneyFloorplanResponseUnassignedColourRegExp = new RegExp('^#[0-9A-Fa-f]{6}$');
export const getJourneyFloorplanResponseUnassignedTotalsAgentsMin = 0;

export const getJourneyFloorplanResponseUnassignedTotalsHumansMin = 0;

export const getJourneyFloorplanResponseUnassignedTotalsQueueMin = 0;

export const getJourneyFloorplanResponseUnassignedTotalsThroughputMin = 0;

export const getJourneyFloorplanResponseUnassignedDesksItemIdMax = 160;

export const getJourneyFloorplanResponseUnassignedDesksItemLabelMax = 200;

export const getJourneyFloorplanResponseUnassignedDesksItemRefMax = 160;

export const getJourneyFloorplanResponseUnassignedDesksItemQueuePendingApprovalMin = 0;

export const getJourneyFloorplanResponseUnassignedDesksItemQueueRecommendedMin = 0;

export const getJourneyFloorplanResponseUnassignedDesksItemQueueBlockedMin = 0;

export const getJourneyFloorplanResponseUnassignedDesksItemQueueAssignedOpenMin = 0;

export const getJourneyFloorplanResponseUnassignedDesksItemQueueAwaitingDecisionMin = 0;

export const getJourneyFloorplanResponseUnassignedDesksItemQueueItemsItemIdMax = 160;

export const getJourneyFloorplanResponseUnassignedDesksItemQueueItemsItemRecordLabelMax = 500;

export const getJourneyFloorplanResponseUnassignedDesksItemQueueItemsItemStageIdMax = 100;

export const getJourneyFloorplanResponseUnassignedDesksItemQueueItemsItemDeepLinkMax = 2048;

export const getJourneyFloorplanResponseUnassignedDesksItemQueueItemsMax = 50;

export const getJourneyFloorplanResponseUnassignedDesksItemThroughputMin = 0;

export const getJourneyFloorplanResponseUnassignedDesksItemBusynessMin = 0;
export const getJourneyFloorplanResponseUnassignedDesksItemBusynessMax = 1;



export const getJourneyFloorplanResponse = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "window": zod.enum(['7d', '30d', '90d', 'all']),
  "functions": zod.array(zod.object({
  "id": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemIdMax),
  "key": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemKeyMax),
  "label": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemLabelMax),
  "colour": zod.string().regex(getJourneyFloorplanResponseFunctionsItemColourRegExp),
  "totals": zod.object({
  "agents": zod.int().min(getJourneyFloorplanResponseFunctionsItemTotalsAgentsMin),
  "humans": zod.int().min(getJourneyFloorplanResponseFunctionsItemTotalsHumansMin),
  "queue": zod.int().min(getJourneyFloorplanResponseFunctionsItemTotalsQueueMin),
  "throughput": zod.int().min(getJourneyFloorplanResponseFunctionsItemTotalsThroughputMin)
}),
  "desks": zod.array(zod.object({
  "id": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemDesksItemIdMax),
  "kind": zod.enum(['agent', 'human']),
  "label": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemDesksItemLabelMax),
  "ref": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemDesksItemRefMax),
  "queue": zod.object({
  "pendingApproval": zod.int().min(getJourneyFloorplanResponseFunctionsItemDesksItemQueuePendingApprovalMin),
  "recommended": zod.int().min(getJourneyFloorplanResponseFunctionsItemDesksItemQueueRecommendedMin),
  "blocked": zod.int().min(getJourneyFloorplanResponseFunctionsItemDesksItemQueueBlockedMin),
  "assignedOpen": zod.int().min(getJourneyFloorplanResponseFunctionsItemDesksItemQueueAssignedOpenMin),
  "awaitingDecision": zod.int().min(getJourneyFloorplanResponseFunctionsItemDesksItemQueueAwaitingDecisionMin),
  "items": zod.array(zod.object({
  "id": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsItemIdMax),
  "recordId": zod.uuid(),
  "recordLabel": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsItemRecordLabelMax),
  "recordKind": zod.enum(['enquiry', 'opportunity', 'partner']),
  "stageId": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsItemStageIdMax),
  "status": zod.enum(['pending_approval', 'recommended', 'blocked', 'assigned_open', 'awaiting_decision']),
  "waitingSince": zod.iso.datetime({"offset":true}),
  "deepLink": zod.string().min(1).max(getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsItemDeepLinkMax)
})).max(getJourneyFloorplanResponseFunctionsItemDesksItemQueueItemsMax)
}),
  "throughput": zod.int().min(getJourneyFloorplanResponseFunctionsItemDesksItemThroughputMin),
  "lastActivityAt": zod.iso.datetime({"offset":true}).nullable(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']).optional(),
  "busyness": zod.number().min(getJourneyFloorplanResponseFunctionsItemDesksItemBusynessMin).max(getJourneyFloorplanResponseFunctionsItemDesksItemBusynessMax),
  "band": zod.enum(['idle', 'steady', 'busy', 'overloaded'])
}))
})),
  "unassigned": zod.object({
  "id": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedIdMax),
  "key": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedKeyMax),
  "label": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedLabelMax),
  "colour": zod.string().regex(getJourneyFloorplanResponseUnassignedColourRegExp),
  "totals": zod.object({
  "agents": zod.int().min(getJourneyFloorplanResponseUnassignedTotalsAgentsMin),
  "humans": zod.int().min(getJourneyFloorplanResponseUnassignedTotalsHumansMin),
  "queue": zod.int().min(getJourneyFloorplanResponseUnassignedTotalsQueueMin),
  "throughput": zod.int().min(getJourneyFloorplanResponseUnassignedTotalsThroughputMin)
}),
  "desks": zod.array(zod.object({
  "id": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedDesksItemIdMax),
  "kind": zod.enum(['agent', 'human']),
  "label": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedDesksItemLabelMax),
  "ref": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedDesksItemRefMax),
  "queue": zod.object({
  "pendingApproval": zod.int().min(getJourneyFloorplanResponseUnassignedDesksItemQueuePendingApprovalMin),
  "recommended": zod.int().min(getJourneyFloorplanResponseUnassignedDesksItemQueueRecommendedMin),
  "blocked": zod.int().min(getJourneyFloorplanResponseUnassignedDesksItemQueueBlockedMin),
  "assignedOpen": zod.int().min(getJourneyFloorplanResponseUnassignedDesksItemQueueAssignedOpenMin),
  "awaitingDecision": zod.int().min(getJourneyFloorplanResponseUnassignedDesksItemQueueAwaitingDecisionMin),
  "items": zod.array(zod.object({
  "id": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedDesksItemQueueItemsItemIdMax),
  "recordId": zod.uuid(),
  "recordLabel": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedDesksItemQueueItemsItemRecordLabelMax),
  "recordKind": zod.enum(['enquiry', 'opportunity', 'partner']),
  "stageId": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedDesksItemQueueItemsItemStageIdMax),
  "status": zod.enum(['pending_approval', 'recommended', 'blocked', 'assigned_open', 'awaiting_decision']),
  "waitingSince": zod.iso.datetime({"offset":true}),
  "deepLink": zod.string().min(1).max(getJourneyFloorplanResponseUnassignedDesksItemQueueItemsItemDeepLinkMax)
})).max(getJourneyFloorplanResponseUnassignedDesksItemQueueItemsMax)
}),
  "throughput": zod.int().min(getJourneyFloorplanResponseUnassignedDesksItemThroughputMin),
  "lastActivityAt": zod.iso.datetime({"offset":true}).nullable(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']).optional(),
  "busyness": zod.number().min(getJourneyFloorplanResponseUnassignedDesksItemBusynessMin).max(getJourneyFloorplanResponseUnassignedDesksItemBusynessMax),
  "band": zod.enum(['idle', 'steady', 'busy', 'overloaded'])
}))
}),
  "anonymised": zod.boolean()
})


export const getJourneyBacklogParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement'])
})

export const getJourneyBacklogQueryWindowDefault = `30d`;
export const getJourneyBacklogQueryIncludeTestDataDefault = false;

export const getJourneyBacklogQueryParams = zod.object({
  "recordId": zod.uuid().optional(),
  "window": zod.enum(['7d', '30d', '90d', 'all']).default(getJourneyBacklogQueryWindowDefault),
  "includeTestData": zod.boolean().default(getJourneyBacklogQueryIncludeTestDataDefault)
})

export const getJourneyBacklogResponseStagesItemWaitingMin = 0;

export const getJourneyBacklogResponseStagesItemOldestAgeMinutesMin = 0;

export const getJourneyBacklogResponseStagesItemExecutedInWindowMin = 0;

export const getJourneyBacklogResponseStagesItemQueuesItemTotalMin = 0;

export const getJourneyBacklogResponseStagesItemQueuesItemItemsItemAgeMinutesMin = 0;

export const getJourneyBacklogResponseStagesItemQueuesItemItemsMax = 50;

export const getJourneyBacklogResponseChannelsItemInflowMin = 0;



export const getJourneyBacklogResponse = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "window": zod.enum(['7d', '30d', '90d', 'all']),
  "stages": zod.array(zod.object({
  "stageId": zod.string(),
  "label": zod.string(),
  "waiting": zod.int().min(getJourneyBacklogResponseStagesItemWaitingMin),
  "oldestAgeMinutes": zod.int().min(getJourneyBacklogResponseStagesItemOldestAgeMinutesMin),
  "executedInWindow": zod.int().min(getJourneyBacklogResponseStagesItemExecutedInWindowMin),
  "queues": zod.array(zod.object({
  "actionType": zod.string(),
  "actor": zod.enum(['agent', 'human']),
  "outcome": zod.enum(['pending_approval', 'recommended', 'deferred', 'blocked']),
  "total": zod.int().min(getJourneyBacklogResponseStagesItemQueuesItemTotalMin),
  "items": zod.array(zod.object({
  "itemId": zod.uuid(),
  "kind": zod.enum(['next_action', 'record_guidance']),
  "recordId": zod.uuid(),
  "recordLabel": zod.string(),
  "channel": zod.string(),
  "waitingSince": zod.iso.datetime({"offset":true}),
  "ageMinutes": zod.int().min(getJourneyBacklogResponseStagesItemQueuesItemItemsItemAgeMinutesMin)
})).max(getJourneyBacklogResponseStagesItemQueuesItemItemsMax)
}))
})),
  "channels": zod.array(zod.object({
  "channel": zod.string(),
  "inflow": zod.int().min(getJourneyBacklogResponseChannelsItemInflowMin),
  "lastAt": zod.iso.datetime({"offset":true})
}))
})


export const getStageAuthorityPathStageIdMax = 100;



export const getStageAuthorityParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "stageId": zod.string().min(1).max(getStageAuthorityPathStageIdMax)
})

export const getStageAuthorityQueryLimitDefault = 20;
export const getStageAuthorityQueryLimitMax = 100;

export const getStageAuthorityQueryOffsetDefault = 0;
export const getStageAuthorityQueryOffsetMin = 0;



export const getStageAuthorityQueryParams = zod.object({
  "limit": zod.int().min(1).max(getStageAuthorityQueryLimitMax).default(getStageAuthorityQueryLimitDefault),
  "offset": zod.int().min(getStageAuthorityQueryOffsetMin).default(getStageAuthorityQueryOffsetDefault)
})

export const getStageAuthorityResponsePolicyHistoryItemsItemPreviousVersionMin = 0;


export const getStageAuthorityResponsePolicyHistoryTotalMin = 0;


export const getStageAuthorityResponsePolicyHistoryOffsetMin = 0;



export const getStageAuthorityResponse = zod.object({
  "policy": zod.object({
  "actionTypes": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "defaultLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "currentLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "preparedOutputEditable": zod.boolean(),
  "manualAlternative": zod.string()
})),
  "effects": zod.record(zod.string(), zod.string()),
  "history": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actor": zod.string(),
  "actorAppUserId": zod.uuid().nullish(),
  "previousVersion": zod.int().min(getStageAuthorityResponsePolicyHistoryItemsItemPreviousVersionMin),
  "version": zod.int().min(1),
  "changedActionTypes": zod.array(zod.string()),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "previousLevels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(getStageAuthorityResponsePolicyHistoryTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getStageAuthorityResponsePolicyHistoryOffsetMin)
})
}).optional(),
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "stageId": zod.string(),
  "version": zod.int(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']))
})


export const updateStageAuthorityPathStageIdMax = 100;



export const updateStageAuthorityParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "stageId": zod.string().min(1).max(updateStageAuthorityPathStageIdMax)
})

export const updateStageAuthorityBody = zod.object({
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']))
})

export const updateStageAuthorityResponsePolicyHistoryItemsItemPreviousVersionMin = 0;


export const updateStageAuthorityResponsePolicyHistoryTotalMin = 0;


export const updateStageAuthorityResponsePolicyHistoryOffsetMin = 0;



export const updateStageAuthorityResponse = zod.object({
  "policy": zod.object({
  "actionTypes": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "defaultLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "currentLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "preparedOutputEditable": zod.boolean(),
  "manualAlternative": zod.string()
})),
  "effects": zod.record(zod.string(), zod.string()),
  "history": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actor": zod.string(),
  "actorAppUserId": zod.uuid().nullish(),
  "previousVersion": zod.int().min(updateStageAuthorityResponsePolicyHistoryItemsItemPreviousVersionMin),
  "version": zod.int().min(1),
  "changedActionTypes": zod.array(zod.string()),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "previousLevels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(updateStageAuthorityResponsePolicyHistoryTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(updateStageAuthorityResponsePolicyHistoryOffsetMin)
})
}).optional(),
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "stageId": zod.string(),
  "version": zod.int(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']))
})


export const listAgentInstructionsResponseVersionMin = 0;



export const listAgentInstructionsResponseItem = zod.object({
  "id": zod.string(),
  "actionType": zod.string(),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "version": zod.int().min(listAgentInstructionsResponseVersionMin),
  "content": zod.string(),
  "note": zod.string(),
  "status": zod.enum(['draft', 'active', 'retired']),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "proposedBy": zod.string().nullable(),
  "proposedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewStatus": zod.union([zod.enum(['awaiting_review', 'activated', 'declined']),zod.null()]),
  "reviewNote": zod.string().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable()
})
export const listAgentInstructionsResponse = zod.array(listAgentInstructionsResponseItem)


export const listAgentInstructionVersionsPathActionTypeMax = 100;



export const listAgentInstructionVersionsParams = zod.object({
  "actionType": zod.string().min(1).max(listAgentInstructionVersionsPathActionTypeMax)
})

export const listAgentInstructionVersionsQueryStageIdMax = 100;

export const listAgentInstructionVersionsQueryLimitDefault = 20;
export const listAgentInstructionVersionsQueryLimitMax = 100;

export const listAgentInstructionVersionsQueryOffsetDefault = 0;
export const listAgentInstructionVersionsQueryOffsetMin = 0;



export const listAgentInstructionVersionsQueryParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']).optional(),
  "stageId": zod.string().min(1).max(listAgentInstructionVersionsQueryStageIdMax).optional(),
  "limit": zod.int().min(1).max(listAgentInstructionVersionsQueryLimitMax).default(listAgentInstructionVersionsQueryLimitDefault),
  "offset": zod.int().min(listAgentInstructionVersionsQueryOffsetMin).default(listAgentInstructionVersionsQueryOffsetDefault)
})

export const listAgentInstructionVersionsResponseEffectiveActiveVersionMin = 0;

export const listAgentInstructionVersionsResponseItemsItemVersionMin = 0;



export const listAgentInstructionVersionsResponse = zod.object({
  "effectiveActive": zod.object({
  "id": zod.string(),
  "actionType": zod.string(),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "version": zod.int().min(listAgentInstructionVersionsResponseEffectiveActiveVersionMin),
  "content": zod.string(),
  "note": zod.string(),
  "status": zod.enum(['draft', 'active', 'retired']),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "proposedBy": zod.string().nullable(),
  "proposedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewStatus": zod.union([zod.enum(['awaiting_review', 'activated', 'declined']),zod.null()]),
  "reviewNote": zod.string().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable()
}).optional(),
  "activations": zod.array(zod.object({
  "id": zod.string(),
  "actor": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "version": zod.int(),
  "previousVersion": zod.int(),
  "note": zod.string()
})).optional(),
  "activationTotal": zod.int().optional(),
  "items": zod.array(zod.object({
  "id": zod.string(),
  "actionType": zod.string(),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "version": zod.int().min(listAgentInstructionVersionsResponseItemsItemVersionMin),
  "content": zod.string(),
  "note": zod.string(),
  "status": zod.enum(['draft', 'active', 'retired']),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "proposedBy": zod.string().nullable(),
  "proposedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewStatus": zod.union([zod.enum(['awaiting_review', 'activated', 'declined']),zod.null()]),
  "reviewNote": zod.string().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createAgentInstructionVersionPathActionTypeMax = 100;



export const createAgentInstructionVersionParams = zod.object({
  "actionType": zod.string().min(1).max(createAgentInstructionVersionPathActionTypeMax)
})

export const createAgentInstructionVersionQueryStageIdMax = 100;



export const createAgentInstructionVersionQueryParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']).optional(),
  "stageId": zod.string().min(1).max(createAgentInstructionVersionQueryStageIdMax).optional()
})

export const createAgentInstructionVersionBodyContentMax = 20000;

export const createAgentInstructionVersionBodyNoteMax = 1000;



export const createAgentInstructionVersionBody = zod.object({
  "content": zod.string().min(1).max(createAgentInstructionVersionBodyContentMax),
  "note": zod.string().min(1).max(createAgentInstructionVersionBodyNoteMax)
})

export const createAgentInstructionVersionResponseVersionMin = 0;



export const createAgentInstructionVersionResponse = zod.object({
  "id": zod.string(),
  "actionType": zod.string(),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "version": zod.int().min(createAgentInstructionVersionResponseVersionMin),
  "content": zod.string(),
  "note": zod.string(),
  "status": zod.enum(['draft', 'active', 'retired']),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "proposedBy": zod.string().nullable(),
  "proposedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewStatus": zod.union([zod.enum(['awaiting_review', 'activated', 'declined']),zod.null()]),
  "reviewNote": zod.string().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable()
})


export const activateAgentInstructionVersionPathActionTypeMax = 100;

export const activateAgentInstructionVersionPathVersionMin = 0;



export const activateAgentInstructionVersionParams = zod.object({
  "actionType": zod.string().min(1).max(activateAgentInstructionVersionPathActionTypeMax),
  "version": zod.int().min(activateAgentInstructionVersionPathVersionMin)
})

export const activateAgentInstructionVersionQueryStageIdMax = 100;



export const activateAgentInstructionVersionQueryParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']).optional(),
  "stageId": zod.string().min(1).max(activateAgentInstructionVersionQueryStageIdMax).optional()
})

export const activateAgentInstructionVersionResponseVersionMin = 0;



export const activateAgentInstructionVersionResponse = zod.object({
  "id": zod.string(),
  "actionType": zod.string(),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "version": zod.int().min(activateAgentInstructionVersionResponseVersionMin),
  "content": zod.string(),
  "note": zod.string(),
  "status": zod.enum(['draft', 'active', 'retired']),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "proposedBy": zod.string().nullable(),
  "proposedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewStatus": zod.union([zod.enum(['awaiting_review', 'activated', 'declined']),zod.null()]),
  "reviewNote": zod.string().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable()
})


export const declineAgentInstructionVersionPathActionTypeMax = 100;




export const declineAgentInstructionVersionParams = zod.object({
  "actionType": zod.string().min(1).max(declineAgentInstructionVersionPathActionTypeMax),
  "version": zod.int().min(1)
})

export const declineAgentInstructionVersionQueryStageIdMax = 100;



export const declineAgentInstructionVersionQueryParams = zod.object({
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "stageId": zod.string().min(1).max(declineAgentInstructionVersionQueryStageIdMax)
})

export const declineAgentInstructionVersionBodyNoteMax = 1000;



export const declineAgentInstructionVersionBody = zod.object({
  "note": zod.string().min(1).max(declineAgentInstructionVersionBodyNoteMax)
})

export const declineAgentInstructionVersionResponseVersionMin = 0;



export const declineAgentInstructionVersionResponse = zod.object({
  "id": zod.string(),
  "actionType": zod.string(),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "version": zod.int().min(declineAgentInstructionVersionResponseVersionMin),
  "content": zod.string(),
  "note": zod.string(),
  "status": zod.enum(['draft', 'active', 'retired']),
  "createdBy": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "activatedBy": zod.string().nullish(),
  "activatedAt": zod.iso.datetime({"offset":true}).nullish(),
  "proposedBy": zod.string().nullable(),
  "proposedAt": zod.iso.datetime({"offset":true}).nullable(),
  "reviewStatus": zod.union([zod.enum(['awaiting_review', 'activated', 'declined']),zod.null()]),
  "reviewNote": zod.string().nullable(),
  "reviewedBy": zod.string().nullable(),
  "reviewedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Read the validated AI action catalogue, effective authority levels, and versioned change history
 */
export const getAiAuthorityPolicyQueryLimitDefault = 50;
export const getAiAuthorityPolicyQueryLimitMax = 100;

export const getAiAuthorityPolicyQueryOffsetDefault = 0;
export const getAiAuthorityPolicyQueryOffsetMin = 0;



export const getAiAuthorityPolicyQueryParams = zod.object({
  "limit": zod.int().min(1).max(getAiAuthorityPolicyQueryLimitMax).default(getAiAuthorityPolicyQueryLimitDefault),
  "offset": zod.int().min(getAiAuthorityPolicyQueryOffsetMin).default(getAiAuthorityPolicyQueryOffsetDefault)
})


export const getAiAuthorityPolicyResponseOneStageOverridesItemPolicyHistoryItemsItemPreviousVersionMin = 0;


export const getAiAuthorityPolicyResponseOneStageOverridesItemPolicyHistoryTotalMin = 0;


export const getAiAuthorityPolicyResponseOneStageOverridesItemPolicyHistoryOffsetMin = 0;

export const getAiAuthorityPolicyResponseTwoHistoryItemsItemPreviousVersionMin = 0;


export const getAiAuthorityPolicyResponseTwoHistoryTotalMin = 0;


export const getAiAuthorityPolicyResponseTwoHistoryOffsetMin = 0;



export const getAiAuthorityPolicyResponse = zod.object({
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.string().nullish(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])),
  "effects": zod.record(zod.string(), zod.string()),
  "stageOverrides": zod.array(zod.object({
  "policy": zod.object({
  "actionTypes": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "defaultLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "currentLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "preparedOutputEditable": zod.boolean(),
  "manualAlternative": zod.string()
})),
  "effects": zod.record(zod.string(), zod.string()),
  "history": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actor": zod.string(),
  "actorAppUserId": zod.uuid().nullish(),
  "previousVersion": zod.int().min(getAiAuthorityPolicyResponseOneStageOverridesItemPolicyHistoryItemsItemPreviousVersionMin),
  "version": zod.int().min(1),
  "changedActionTypes": zod.array(zod.string()),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "previousLevels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(getAiAuthorityPolicyResponseOneStageOverridesItemPolicyHistoryTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getAiAuthorityPolicyResponseOneStageOverridesItemPolicyHistoryOffsetMin)
})
}).optional(),
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "stageId": zod.string(),
  "version": zod.int(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']))
})).optional(),
  "actionTypes": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "defaultLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "currentLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "preparedOutputEditable": zod.boolean(),
  "manualAlternative": zod.string()
}))
}).and(zod.object({
  "history": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actor": zod.string(),
  "actorAppUserId": zod.uuid().nullish(),
  "previousVersion": zod.int().min(getAiAuthorityPolicyResponseTwoHistoryItemsItemPreviousVersionMin),
  "version": zod.int().min(1),
  "changedActionTypes": zod.array(zod.string()),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "previousLevels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(getAiAuthorityPolicyResponseTwoHistoryTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(getAiAuthorityPolicyResponseTwoHistoryOffsetMin)
})
}))


/**
 * @summary Replace every supported AI action level using optimistic version validation
 */



export const updateAiAuthorityPolicyBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']))
})


export const updateAiAuthorityPolicyResponseStageOverridesItemPolicyHistoryItemsItemPreviousVersionMin = 0;


export const updateAiAuthorityPolicyResponseStageOverridesItemPolicyHistoryTotalMin = 0;


export const updateAiAuthorityPolicyResponseStageOverridesItemPolicyHistoryOffsetMin = 0;



export const updateAiAuthorityPolicyResponse = zod.object({
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "updatedBy": zod.string().nullish(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])),
  "effects": zod.record(zod.string(), zod.string()),
  "stageOverrides": zod.array(zod.object({
  "policy": zod.object({
  "actionTypes": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "defaultLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "currentLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "preparedOutputEditable": zod.boolean(),
  "manualAlternative": zod.string()
})),
  "effects": zod.record(zod.string(), zod.string()),
  "history": zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actor": zod.string(),
  "actorAppUserId": zod.uuid().nullish(),
  "previousVersion": zod.int().min(updateAiAuthorityPolicyResponseStageOverridesItemPolicyHistoryItemsItemPreviousVersionMin),
  "version": zod.int().min(1),
  "changedActionTypes": zod.array(zod.string()),
  "journeyKey": zod.string().nullish(),
  "stageId": zod.string().nullish(),
  "previousLevels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only'])).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(updateAiAuthorityPolicyResponseStageOverridesItemPolicyHistoryTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(updateAiAuthorityPolicyResponseStageOverridesItemPolicyHistoryOffsetMin)
})
}).optional(),
  "journeyKey": zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),
  "stageId": zod.string(),
  "version": zod.int(),
  "levels": zod.record(zod.string(), zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']))
})).optional(),
  "actionTypes": zod.array(zod.object({
  "id": zod.string(),
  "label": zod.string(),
  "description": zod.string(),
  "defaultLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "currentLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "preparedOutputEditable": zod.boolean(),
  "manualAlternative": zod.string()
}))
})


/**
 * @summary Create or replace one org-scoped configuration value
 */
export const updatePlatformConfigParams = zod.object({
  "namespace": zod.string(),
  "key": zod.string()
})

export const updatePlatformConfigBody = zod.object({
  "value": zod.unknown(),
  "updatedBy": zod.string().optional()
})

export const updatePlatformConfigResponse = zod.object({
  "namespace": zod.string(),
  "key": zod.string(),
  "value": zod.unknown(),
  "version": zod.int(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List every planned channel and its connection status
 */
export const listChannelConnectionsResponse = zod.object({
  "items": zod.array(zod.object({
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok', 'microsoft365', 'telephony']),
  "label": zod.string(),
  "status": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "displayName": zod.string().nullish(),
  "externalAccountId": zod.string().nullish(),
  "supportsLiveOAuth": zod.boolean(),
  "connectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "errorMessage": zod.string().nullish()
}))
})


/**
 * @summary Connect or stage a provider account
 */
export const connectChannelParams = zod.object({
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok', 'microsoft365', 'telephony'])
})

export const connectChannelBody = zod.object({
  "displayName": zod.string().optional(),
  "externalAccountId": zod.string().optional(),
  "credentials": zod.record(zod.string(), zod.unknown()).optional(),
  "expiresAt": zod.iso.datetime({"offset":true}).optional()
})

export const connectChannelResponse = zod.object({
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok', 'microsoft365', 'telephony']),
  "label": zod.string(),
  "status": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "displayName": zod.string().nullish(),
  "externalAccountId": zod.string().nullish(),
  "supportsLiveOAuth": zod.boolean(),
  "connectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "errorMessage": zod.string().nullish()
})


/**
 * @summary Disconnect a provider and erase its credentials
 */
export const disconnectChannelParams = zod.object({
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok', 'microsoft365', 'telephony'])
})

export const disconnectChannelResponse = zod.object({
  "provider": zod.enum(['linkedin', 'facebook', 'instagram', 'x', 'youtube', 'google_business', 'tiktok', 'microsoft365', 'telephony']),
  "label": zod.string(),
  "status": zod.enum(['disconnected', 'connected', 'error', 'expired']),
  "displayName": zod.string().nullish(),
  "externalAccountId": zod.string().nullish(),
  "supportsLiveOAuth": zod.boolean(),
  "connectedAt": zod.iso.datetime({"offset":true}).nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}).nullish(),
  "errorMessage": zod.string().nullish()
})


/**
 * @summary Unified timeline merging normalized interactions, activities and enquiries
 */
export const listUnifiedTimelineQueryLimitDefault = 50;
export const listUnifiedTimelineQueryLimitMax = 100;

export const listUnifiedTimelineQueryOffsetDefault = 0;
export const listUnifiedTimelineQueryOffsetMin = 0;



export const listUnifiedTimelineQueryParams = zod.object({
  "accountId": zod.uuid().optional(),
  "contactId": zod.uuid().optional(),
  "channel": zod.string().optional(),
  "limit": zod.int().min(1).max(listUnifiedTimelineQueryLimitMax).default(listUnifiedTimelineQueryLimitDefault),
  "offset": zod.int().min(listUnifiedTimelineQueryOffsetMin).default(listUnifiedTimelineQueryOffsetDefault)
})

export const listUnifiedTimelineResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.string(),
  "channel": zod.string(),
  "type": zod.string(),
  "direction": zod.enum(['inbound', 'outbound', 'internal']),
  "subject": zod.string().nullish(),
  "body": zod.string(),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "source": zod.enum(['interaction', 'activity', 'enquiry'])
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * @summary Record a normalized cross-channel interaction and recompute lead scores
 */



export const createInteractionBody = zod.object({
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "channel": zod.string(),
  "type": zod.string(),
  "direction": zod.enum(['inbound', 'outbound', 'internal']).optional(),
  "subject": zod.string().nullish(),
  "body": zod.string().min(1),
  "sourceId": zod.string().nullish(),
  "metadata": zod.record(zod.string(), zod.unknown()).optional(),
  "occurredAt": zod.iso.datetime({"offset":true}).optional()
})




export const createInteractionResponse = zod.object({
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "channel": zod.string(),
  "type": zod.string(),
  "direction": zod.enum(['inbound', 'outbound', 'internal']),
  "subject": zod.string().nullish(),
  "body": zod.string().min(1),
  "sourceId": zod.string().nullish(),
  "metadata": zod.record(zod.string(), zod.unknown()).optional(),
  "occurredAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "id": zod.uuid(),
  "direction": zod.enum(['inbound', 'outbound', 'internal']),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Publish a signal and recompute linked lead scores
 */
export const publishSignalBodyConfidenceMin = 0;
export const publishSignalBodyConfidenceMax = 1;



export const publishSignalBody = zod.object({
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "source": zod.string(),
  "type": zod.string(),
  "payload": zod.record(zod.string(), zod.unknown()).optional(),
  "confidence": zod.number().min(publishSignalBodyConfidenceMin).max(publishSignalBodyConfidenceMax).optional(),
  "occurredAt": zod.iso.datetime({"offset":true}).optional()
})

export const publishSignalResponseOneConfidenceMin = 0;
export const publishSignalResponseOneConfidenceMax = 1;



export const publishSignalResponse = zod.object({
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "source": zod.string(),
  "type": zod.string(),
  "payload": zod.record(zod.string(), zod.unknown()).optional(),
  "confidence": zod.number().min(publishSignalResponseOneConfidenceMin).max(publishSignalResponseOneConfidenceMax),
  "occurredAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "id": zod.uuid(),
  "confidence": zod.number(),
  "occurredAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true})
}))


/**
 * @summary Get a account or contact lead score
 */
export const getLeadScoreQueryParams = zod.object({
  "entityType": zod.enum(['account', 'contact']),
  "entityId": zod.uuid()
})

export const getLeadScoreResponse = zod.object({
  "entityType": zod.enum(['account', 'contact']),
  "entityId": zod.uuid(),
  "score": zod.int(),
  "fitScore": zod.int(),
  "engagementScore": zod.int(),
  "signalScore": zod.int(),
  "breakdown": zod.record(zod.string(), zod.number()),
  "calculatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Enforce configured authority and create an audited AI action
 */
export const requestAiActionBody = zod.object({
  "actionType": zod.string(),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "input": zod.record(zod.string(), zod.unknown()).optional(),
  "requestedBy": zod.string().optional()
})


export const requestAiActionResponseFeedbackOneCommentMax = 1000;



export const requestAiActionResponse = zod.object({
  "id": zod.uuid(),
  "actionType": zod.string(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "status": zod.enum(['executed', 'recommended', 'pending_approval', 'approved', 'rejected', 'deferred', 'dismissed', 'blocked', 'failed']),
  "requestId": zod.uuid().nullish(),
  "journeyKey": zod.union([zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),zod.null()]).optional(),
  "entityType": zod.union([zod.enum(['enquiry', 'opportunity', 'partner']),zod.null()]).optional(),
  "entityId": zod.uuid().nullish(),
  "stageId": zod.string().nullish(),
  "revision": zod.int().min(1),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "input": zod.record(zod.string(), zod.unknown()),
  "output": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestedBy": zod.string().nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "feedback": zod.union([zod.object({
  "rating": zod.enum(['helpful', 'not_helpful']),
  "comment": zod.string().max(requestAiActionResponseFeedbackOneCommentMax).optional()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List AI action audit records
 */

export const listAiActionAuditResponseItemsItemFeedbackOneCommentMax = 1000;



export const listAiActionAuditResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "actionType": zod.string(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "status": zod.enum(['executed', 'recommended', 'pending_approval', 'approved', 'rejected', 'deferred', 'dismissed', 'blocked', 'failed']),
  "requestId": zod.uuid().nullish(),
  "journeyKey": zod.union([zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),zod.null()]).optional(),
  "entityType": zod.union([zod.enum(['enquiry', 'opportunity', 'partner']),zod.null()]).optional(),
  "entityId": zod.uuid().nullish(),
  "stageId": zod.string().nullish(),
  "revision": zod.int().min(1),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "input": zod.record(zod.string(), zod.unknown()),
  "output": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestedBy": zod.string().nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "feedback": zod.union([zod.object({
  "rating": zod.enum(['helpful', 'not_helpful']),
  "comment": zod.string().max(listAiActionAuditResponseItemsItemFeedbackOneCommentMax).optional()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
})


/**
 * @summary Approve or reject a prepared AI action
 */
export const approveAiActionParams = zod.object({
  "id": zod.uuid()
})

export const approveAiActionBody = zod.object({
  "decision": zod.enum(['approved', 'rejected']),
  "approvedBy": zod.string().optional()
})


export const approveAiActionResponseFeedbackOneCommentMax = 1000;



export const approveAiActionResponse = zod.object({
  "id": zod.uuid(),
  "actionType": zod.string(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "status": zod.enum(['executed', 'recommended', 'pending_approval', 'approved', 'rejected', 'deferred', 'dismissed', 'blocked', 'failed']),
  "requestId": zod.uuid().nullish(),
  "journeyKey": zod.union([zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),zod.null()]).optional(),
  "entityType": zod.union([zod.enum(['enquiry', 'opportunity', 'partner']),zod.null()]).optional(),
  "entityId": zod.uuid().nullish(),
  "stageId": zod.string().nullish(),
  "revision": zod.int().min(1),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "input": zod.record(zod.string(), zod.unknown()),
  "output": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestedBy": zod.string().nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "feedback": zod.union([zod.object({
  "rating": zod.enum(['helpful', 'not_helpful']),
  "comment": zod.string().max(approveAiActionResponseFeedbackOneCommentMax).optional()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Approve, reject, defer, dismiss, edit, or provide feedback on governed AI work
 */
export const decideAiActionParams = zod.object({
  "id": zod.uuid()
})


export const decideAiActionBodyEditedPreparedOutputTitleMax = 200;

export const decideAiActionBodyEditedPreparedOutputBodyMax = 8000;

export const decideAiActionBodyFeedbackCommentMax = 1000;



export const decideAiActionBody = zod.object({
  "decision": zod.enum(['approve', 'reject', 'defer', 'dismiss', 'feedback']),
  "expectedRevision": zod.int().min(1),
  "editedPreparedOutput": zod.object({
  "title": zod.string().min(1).max(decideAiActionBodyEditedPreparedOutputTitleMax),
  "body": zod.string().min(1).max(decideAiActionBodyEditedPreparedOutputBodyMax)
}).optional(),
  "deferUntil": zod.iso.datetime({"offset":true}).optional(),
  "feedback": zod.object({
  "rating": zod.enum(['helpful', 'not_helpful']),
  "comment": zod.string().max(decideAiActionBodyFeedbackCommentMax).optional()
}).optional()
})


export const decideAiActionResponseFeedbackOneCommentMax = 1000;



export const decideAiActionResponse = zod.object({
  "id": zod.uuid(),
  "actionType": zod.string(),
  "authorityLevel": zod.enum(['automated', 'recommended', 'prepared_with_approval', 'human_only']),
  "status": zod.enum(['executed', 'recommended', 'pending_approval', 'approved', 'rejected', 'deferred', 'dismissed', 'blocked', 'failed']),
  "requestId": zod.uuid().nullish(),
  "journeyKey": zod.union([zod.enum(['enquiry_to_outcome', 'opportunity_b2b_sales', 'opportunity_b2c_sales', 'investor_funding', 'partner_engagement']),zod.null()]).optional(),
  "entityType": zod.union([zod.enum(['enquiry', 'opportunity', 'partner']),zod.null()]).optional(),
  "entityId": zod.uuid().nullish(),
  "stageId": zod.string().nullish(),
  "revision": zod.int().min(1),
  "accountId": zod.uuid().nullish(),
  "contactId": zod.uuid().nullish(),
  "input": zod.record(zod.string(), zod.unknown()),
  "output": zod.record(zod.string(), zod.unknown()).nullish(),
  "requestedBy": zod.string().nullish(),
  "approvedBy": zod.string().nullish(),
  "approvedAt": zod.iso.datetime({"offset":true}).nullish(),
  "deferredUntil": zod.iso.datetime({"offset":true}).nullish(),
  "feedback": zod.union([zod.object({
  "rating": zod.enum(['helpful', 'not_helpful']),
  "comment": zod.string().max(decideAiActionResponseFeedbackOneCommentMax).optional()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Expired snoozes are omitted so their items return to the queue at the due time.
 * @summary List the signed-in user's active Focus-queue snoozes, dismissals and done marks
 */
export const listQueueItemStatesQueryItemTypeMax = 60;


export const listQueueItemStatesQueryItemTypeRegExp = new RegExp('^[a-z][a-z0-9_.-]*$');
export const listQueueItemStatesQueryLimitDefault = 200;
export const listQueueItemStatesQueryLimitMax = 500;

export const listQueueItemStatesQueryOffsetDefault = 0;
export const listQueueItemStatesQueryOffsetMin = 0;
export const listQueueItemStatesQueryOffsetMax = 100000;



export const listQueueItemStatesQueryParams = zod.object({
  "itemType": zod.string().min(1).max(listQueueItemStatesQueryItemTypeMax).regex(listQueueItemStatesQueryItemTypeRegExp).optional(),
  "limit": zod.int().min(1).max(listQueueItemStatesQueryLimitMax).default(listQueueItemStatesQueryLimitDefault),
  "offset": zod.int().min(listQueueItemStatesQueryOffsetMin).max(listQueueItemStatesQueryOffsetMax).default(listQueueItemStatesQueryOffsetDefault)
})

export const listQueueItemStatesResponseTotalMin = 0;


export const listQueueItemStatesResponseOffsetMin = 0;



export const listQueueItemStatesResponse = zod.object({
  "items": zod.array(zod.object({
  "itemType": zod.string(),
  "itemId": zod.string(),
  "state": zod.enum(['snoozed', 'dismissed', 'done']),
  "snoozedUntil": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listQueueItemStatesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listQueueItemStatesResponseOffsetMin)
})


/**
 * @summary Snooze, dismiss or mark one queue item done for the signed-in user
 */
export const setQueueItemStatePathItemTypeMax = 60;


export const setQueueItemStatePathItemTypeRegExp = new RegExp('^[a-z][a-z0-9_.-]*$');
export const setQueueItemStatePathItemIdMax = 200;



export const setQueueItemStateParams = zod.object({
  "itemType": zod.string().min(1).max(setQueueItemStatePathItemTypeMax).regex(setQueueItemStatePathItemTypeRegExp),
  "itemId": zod.string().min(1).max(setQueueItemStatePathItemIdMax)
})

export const setQueueItemStateBody = zod.object({
  "state": zod.enum(['snoozed', 'dismissed', 'done']),
  "snoozedUntil": zod.iso.datetime({"offset":true}).nullish().describe('Required for snoozed; must be in the future and within 365 days.')
})

export const setQueueItemStateResponse = zod.object({
  "itemType": zod.string(),
  "itemId": zod.string(),
  "state": zod.enum(['snoozed', 'dismissed', 'done']),
  "snoozedUntil": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Return one item to the signed-in user's queue
 */
export const clearQueueItemStatePathItemTypeMax = 60;


export const clearQueueItemStatePathItemTypeRegExp = new RegExp('^[a-z][a-z0-9_.-]*$');
export const clearQueueItemStatePathItemIdMax = 200;



export const clearQueueItemStateParams = zod.object({
  "itemType": zod.string().min(1).max(clearQueueItemStatePathItemTypeMax).regex(clearQueueItemStatePathItemTypeRegExp),
  "itemId": zod.string().min(1).max(clearQueueItemStatePathItemIdMax)
})

export const clearQueueItemStateResponse = zod.void()


/**
 * Each address appears once. Your own saved entry wins over a colleague's shared entry. Saving an address never grants mailbox access; Microsoft 365 decides who can open it.
 * @summary List the shared mailboxes the signed-in user saved plus those colleagues made available to the entity
 */
export const listSavedSharedMailboxesQueryLimitDefault = 100;
export const listSavedSharedMailboxesQueryLimitMax = 200;

export const listSavedSharedMailboxesQueryOffsetDefault = 0;
export const listSavedSharedMailboxesQueryOffsetMin = 0;
export const listSavedSharedMailboxesQueryOffsetMax = 100000;



export const listSavedSharedMailboxesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSavedSharedMailboxesQueryLimitMax).default(listSavedSharedMailboxesQueryLimitDefault),
  "offset": zod.int().min(listSavedSharedMailboxesQueryOffsetMin).max(listSavedSharedMailboxesQueryOffsetMax).default(listSavedSharedMailboxesQueryOffsetDefault)
})

export const listSavedSharedMailboxesResponseItemsItemAddressMin = 3;
export const listSavedSharedMailboxesResponseItemsItemAddressMax = 254;

export const listSavedSharedMailboxesResponseItemsItemAddedByNameMax = 200;

export const listSavedSharedMailboxesResponseTotalMin = 0;


export const listSavedSharedMailboxesResponseOffsetMin = 0;



export const listSavedSharedMailboxesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "address": zod.string().min(listSavedSharedMailboxesResponseItemsItemAddressMin).max(listSavedSharedMailboxesResponseItemsItemAddressMax),
  "sharedWithEntity": zod.boolean().describe('Everyone in the entity sees this mailbox in their list.'),
  "mine": zod.boolean().describe('The signed-in user saved this entry and can share or remove it.'),
  "addedByName": zod.string().max(listSavedSharedMailboxesResponseItemsItemAddedByNameMax).nullable(),
  "hidden": zod.boolean().describe('The signed-in user hid this colleague\'s shared mailbox from their own list.'),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSavedSharedMailboxesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listSavedSharedMailboxesResponseOffsetMin)
})


/**
 * Saving the same address again returns the existing entry. Each person can save up to 20 addresses.
 * @summary Save a shared mailbox address to the signed-in user's list
 */
export const saveSharedMailboxBodyAddressMin = 3;
export const saveSharedMailboxBodyAddressMax = 254;

export const saveSharedMailboxBodySharedWithEntityDefault = false;

export const saveSharedMailboxBody = zod.object({
  "address": zod.string().min(saveSharedMailboxBodyAddressMin).max(saveSharedMailboxBodyAddressMax),
  "sharedWithEntity": zod.boolean().default(saveSharedMailboxBodySharedWithEntityDefault)
})

export const saveSharedMailboxResponseAddressMin = 3;
export const saveSharedMailboxResponseAddressMax = 254;

export const saveSharedMailboxResponseAddedByNameMax = 200;



export const saveSharedMailboxResponse = zod.object({
  "id": zod.uuid(),
  "address": zod.string().min(saveSharedMailboxResponseAddressMin).max(saveSharedMailboxResponseAddressMax),
  "sharedWithEntity": zod.boolean().describe('Everyone in the entity sees this mailbox in their list.'),
  "mine": zod.boolean().describe('The signed-in user saved this entry and can share or remove it.'),
  "addedByName": zod.string().max(saveSharedMailboxResponseAddedByNameMax).nullable(),
  "hidden": zod.boolean().describe('The signed-in user hid this colleague\'s shared mailbox from their own list.'),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Addresses already saved are skipped, as are addresses beyond the 20-address limit. Imported entries are private.
 * @summary Move shared mailbox addresses previously remembered in a browser into the signed-in user's private list
 */
export const importSavedSharedMailboxesBodyAddressesItemMin = 3;
export const importSavedSharedMailboxesBodyAddressesItemMax = 254;

export const importSavedSharedMailboxesBodyAddressesMax = 20;



export const importSavedSharedMailboxesBody = zod.object({
  "addresses": zod.array(zod.string().min(importSavedSharedMailboxesBodyAddressesItemMin).max(importSavedSharedMailboxesBodyAddressesItemMax)).min(1).max(importSavedSharedMailboxesBodyAddressesMax)
})

export const importSavedSharedMailboxesResponseImportedMin = 0;

export const importSavedSharedMailboxesResponseSkippedMin = 0;



export const importSavedSharedMailboxesResponse = zod.object({
  "imported": zod.int().min(importSavedSharedMailboxesResponseImportedMin),
  "skipped": zod.int().min(importSavedSharedMailboxesResponseSkippedMin)
})


/**
 * @summary Make a mailbox you saved available to everyone in the entity, or private again
 */
export const updateSavedSharedMailboxParams = zod.object({
  "id": zod.uuid()
})

export const updateSavedSharedMailboxBody = zod.object({
  "sharedWithEntity": zod.boolean()
})

export const updateSavedSharedMailboxResponseAddressMin = 3;
export const updateSavedSharedMailboxResponseAddressMax = 254;

export const updateSavedSharedMailboxResponseAddedByNameMax = 200;



export const updateSavedSharedMailboxResponse = zod.object({
  "id": zod.uuid(),
  "address": zod.string().min(updateSavedSharedMailboxResponseAddressMin).max(updateSavedSharedMailboxResponseAddressMax),
  "sharedWithEntity": zod.boolean().describe('Everyone in the entity sees this mailbox in their list.'),
  "mine": zod.boolean().describe('The signed-in user saved this entry and can share or remove it.'),
  "addedByName": zod.string().max(updateSavedSharedMailboxResponseAddedByNameMax).nullable(),
  "hidden": zod.boolean().describe('The signed-in user hid this colleague\'s shared mailbox from their own list.'),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Remove a mailbox you saved; if it was shared, colleagues no longer see your entry
 */
export const deleteSavedSharedMailboxParams = zod.object({
  "id": zod.uuid()
})

export const deleteSavedSharedMailboxResponse = zod.void()


/**
 * @summary Hide a colleague's shared mailbox from your own list only
 */
export const hideSavedSharedMailboxParams = zod.object({
  "id": zod.uuid()
})

export const hideSavedSharedMailboxResponse = zod.void()


/**
 * @summary Show a hidden shared mailbox in your list again
 */
export const unhideSavedSharedMailboxParams = zod.object({
  "id": zod.uuid()
})

export const unhideSavedSharedMailboxResponse = zod.void()


/**
 * Replays the stored reverse request through the same native API permission guards. Each undo can be used once.
 * @summary Reverse one instant low-risk Agent change within 24 hours
 */
export const undoAgentExecutionParams = zod.object({
  "id": zod.uuid()
})

export const undoAgentExecutionResponse = zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['undone']),
  "label": zod.string(),
  "receipt": zod.record(zod.string(), zod.unknown())
})


/**
 * @summary Get the signed-in user's effective desktop and mobile homepage layout
 */
export const getHomepageLayoutQueryTabDefault = `all`;

export const getHomepageLayoutQueryParams = zod.object({
  "tab": zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor']).default(getHomepageLayoutQueryTabDefault).describe('Personal audience page; omitted selects All for existing clients.')
})

export const getHomepageLayoutResponseOneWidgetsItemTitleMax = 300;

export const getHomepageLayoutResponseOneWidgetsMax = 50;

export const getHomepageLayoutResponseOneDesktopItemComponentIdTwoRegExp = new RegExp('^widget:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
export const getHomepageLayoutResponseOneDesktopItemColumnMin = 0;
export const getHomepageLayoutResponseOneDesktopItemColumnMax = 11;

export const getHomepageLayoutResponseOneDesktopItemRowMin = 0;
export const getHomepageLayoutResponseOneDesktopItemRowMax = 199;

export const getHomepageLayoutResponseOneDesktopItemRowSpanMax = 12;

export const getHomepageLayoutResponseOneDesktopMin = 8;
export const getHomepageLayoutResponseOneDesktopMax = 58;

export const getHomepageLayoutResponseOneMobileItemComponentIdTwoRegExp = new RegExp('^widget:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
export const getHomepageLayoutResponseOneMobileItemColumnMin = 0;
export const getHomepageLayoutResponseOneMobileItemColumnMax = 11;

export const getHomepageLayoutResponseOneMobileItemRowMin = 0;
export const getHomepageLayoutResponseOneMobileItemRowMax = 199;

export const getHomepageLayoutResponseOneMobileItemRowSpanMax = 12;

export const getHomepageLayoutResponseOneMobileMin = 8;
export const getHomepageLayoutResponseOneMobileMax = 58;

export const getHomepageLayoutResponseTwoVersionMin = 0;

export const getHomepageLayoutResponseTwoPolicyVersionMin = 0;



export const getHomepageLayoutResponse = zod.object({
  "schemaVersion": zod.literal(3),
  "widgets": zod.array(zod.object({
  "instanceId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().max(getHomepageLayoutResponseOneWidgetsItemTitleMax).optional(),
  "config": zod.record(zod.string(), zod.unknown())
})).max(getHomepageLayoutResponseOneWidgetsMax),
  "desktop": zod.array(zod.object({
  "componentId": zod.union([zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),zod.string().regex(getHomepageLayoutResponseOneDesktopItemComponentIdTwoRegExp)]),
  "column": zod.int().min(getHomepageLayoutResponseOneDesktopItemColumnMin).max(getHomepageLayoutResponseOneDesktopItemColumnMax),
  "row": zod.int().min(getHomepageLayoutResponseOneDesktopItemRowMin).max(getHomepageLayoutResponseOneDesktopItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(getHomepageLayoutResponseOneDesktopItemRowSpanMax),
  "visible": zod.boolean(),
  "collapsed": zod.boolean().describe('Whether the section content is collapsed for this viewport')
})).min(getHomepageLayoutResponseOneDesktopMin).max(getHomepageLayoutResponseOneDesktopMax),
  "mobile": zod.array(zod.object({
  "componentId": zod.union([zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),zod.string().regex(getHomepageLayoutResponseOneMobileItemComponentIdTwoRegExp)]),
  "column": zod.int().min(getHomepageLayoutResponseOneMobileItemColumnMin).max(getHomepageLayoutResponseOneMobileItemColumnMax),
  "row": zod.int().min(getHomepageLayoutResponseOneMobileItemRowMin).max(getHomepageLayoutResponseOneMobileItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(getHomepageLayoutResponseOneMobileItemRowSpanMax),
  "visible": zod.boolean(),
  "collapsed": zod.boolean().describe('Whether the section content is collapsed for this viewport')
})).min(getHomepageLayoutResponseOneMobileMin).max(getHomepageLayoutResponseOneMobileMax)
}).and(zod.object({
  "tab": zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor']),
  "version": zod.int().min(getHomepageLayoutResponseTwoVersionMin),
  "policyVersion": zod.int().min(getHomepageLayoutResponseTwoPolicyVersionMin),
  "requiredComponentIds": zod.array(zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot'])),
  "reconciled": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))


/**
 * @summary Save the signed-in user's desktop and mobile homepage layout
 */
export const saveHomepageLayoutQueryTabDefault = `all`;

export const saveHomepageLayoutQueryParams = zod.object({
  "tab": zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor']).default(saveHomepageLayoutQueryTabDefault).describe('Personal audience page; omitted selects All for existing clients.')
})

export const saveHomepageLayoutBodyVersionMin = 0;

export const saveHomepageLayoutBodyLayoutWidgetsItemTitleMax = 300;

export const saveHomepageLayoutBodyLayoutWidgetsMax = 50;

export const saveHomepageLayoutBodyLayoutDesktopItemComponentIdTwoRegExp = new RegExp('^widget:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
export const saveHomepageLayoutBodyLayoutDesktopItemColumnMin = 0;
export const saveHomepageLayoutBodyLayoutDesktopItemColumnMax = 11;

export const saveHomepageLayoutBodyLayoutDesktopItemRowMin = 0;
export const saveHomepageLayoutBodyLayoutDesktopItemRowMax = 199;

export const saveHomepageLayoutBodyLayoutDesktopItemRowSpanMax = 12;

export const saveHomepageLayoutBodyLayoutDesktopMin = 8;
export const saveHomepageLayoutBodyLayoutDesktopMax = 58;

export const saveHomepageLayoutBodyLayoutMobileItemComponentIdTwoRegExp = new RegExp('^widget:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
export const saveHomepageLayoutBodyLayoutMobileItemColumnMin = 0;
export const saveHomepageLayoutBodyLayoutMobileItemColumnMax = 11;

export const saveHomepageLayoutBodyLayoutMobileItemRowMin = 0;
export const saveHomepageLayoutBodyLayoutMobileItemRowMax = 199;

export const saveHomepageLayoutBodyLayoutMobileItemRowSpanMax = 12;

export const saveHomepageLayoutBodyLayoutMobileMin = 8;
export const saveHomepageLayoutBodyLayoutMobileMax = 58;



export const saveHomepageLayoutBody = zod.object({
  "version": zod.int().min(saveHomepageLayoutBodyVersionMin),
  "layout": zod.object({
  "schemaVersion": zod.literal(3),
  "widgets": zod.array(zod.object({
  "instanceId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().max(saveHomepageLayoutBodyLayoutWidgetsItemTitleMax).optional(),
  "config": zod.record(zod.string(), zod.unknown())
})).max(saveHomepageLayoutBodyLayoutWidgetsMax),
  "desktop": zod.array(zod.object({
  "componentId": zod.union([zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),zod.string().regex(saveHomepageLayoutBodyLayoutDesktopItemComponentIdTwoRegExp)]),
  "column": zod.int().min(saveHomepageLayoutBodyLayoutDesktopItemColumnMin).max(saveHomepageLayoutBodyLayoutDesktopItemColumnMax),
  "row": zod.int().min(saveHomepageLayoutBodyLayoutDesktopItemRowMin).max(saveHomepageLayoutBodyLayoutDesktopItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(saveHomepageLayoutBodyLayoutDesktopItemRowSpanMax),
  "visible": zod.boolean(),
  "collapsed": zod.boolean().describe('Whether the section content is collapsed for this viewport')
})).min(saveHomepageLayoutBodyLayoutDesktopMin).max(saveHomepageLayoutBodyLayoutDesktopMax),
  "mobile": zod.array(zod.object({
  "componentId": zod.union([zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),zod.string().regex(saveHomepageLayoutBodyLayoutMobileItemComponentIdTwoRegExp)]),
  "column": zod.int().min(saveHomepageLayoutBodyLayoutMobileItemColumnMin).max(saveHomepageLayoutBodyLayoutMobileItemColumnMax),
  "row": zod.int().min(saveHomepageLayoutBodyLayoutMobileItemRowMin).max(saveHomepageLayoutBodyLayoutMobileItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(saveHomepageLayoutBodyLayoutMobileItemRowSpanMax),
  "visible": zod.boolean(),
  "collapsed": zod.boolean().describe('Whether the section content is collapsed for this viewport')
})).min(saveHomepageLayoutBodyLayoutMobileMin).max(saveHomepageLayoutBodyLayoutMobileMax)
})
})

export const saveHomepageLayoutResponseOneWidgetsItemTitleMax = 300;

export const saveHomepageLayoutResponseOneWidgetsMax = 50;

export const saveHomepageLayoutResponseOneDesktopItemComponentIdTwoRegExp = new RegExp('^widget:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
export const saveHomepageLayoutResponseOneDesktopItemColumnMin = 0;
export const saveHomepageLayoutResponseOneDesktopItemColumnMax = 11;

export const saveHomepageLayoutResponseOneDesktopItemRowMin = 0;
export const saveHomepageLayoutResponseOneDesktopItemRowMax = 199;

export const saveHomepageLayoutResponseOneDesktopItemRowSpanMax = 12;

export const saveHomepageLayoutResponseOneDesktopMin = 8;
export const saveHomepageLayoutResponseOneDesktopMax = 58;

export const saveHomepageLayoutResponseOneMobileItemComponentIdTwoRegExp = new RegExp('^widget:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
export const saveHomepageLayoutResponseOneMobileItemColumnMin = 0;
export const saveHomepageLayoutResponseOneMobileItemColumnMax = 11;

export const saveHomepageLayoutResponseOneMobileItemRowMin = 0;
export const saveHomepageLayoutResponseOneMobileItemRowMax = 199;

export const saveHomepageLayoutResponseOneMobileItemRowSpanMax = 12;

export const saveHomepageLayoutResponseOneMobileMin = 8;
export const saveHomepageLayoutResponseOneMobileMax = 58;

export const saveHomepageLayoutResponseTwoVersionMin = 0;

export const saveHomepageLayoutResponseTwoPolicyVersionMin = 0;



export const saveHomepageLayoutResponse = zod.object({
  "schemaVersion": zod.literal(3),
  "widgets": zod.array(zod.object({
  "instanceId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().max(saveHomepageLayoutResponseOneWidgetsItemTitleMax).optional(),
  "config": zod.record(zod.string(), zod.unknown())
})).max(saveHomepageLayoutResponseOneWidgetsMax),
  "desktop": zod.array(zod.object({
  "componentId": zod.union([zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),zod.string().regex(saveHomepageLayoutResponseOneDesktopItemComponentIdTwoRegExp)]),
  "column": zod.int().min(saveHomepageLayoutResponseOneDesktopItemColumnMin).max(saveHomepageLayoutResponseOneDesktopItemColumnMax),
  "row": zod.int().min(saveHomepageLayoutResponseOneDesktopItemRowMin).max(saveHomepageLayoutResponseOneDesktopItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(saveHomepageLayoutResponseOneDesktopItemRowSpanMax),
  "visible": zod.boolean(),
  "collapsed": zod.boolean().describe('Whether the section content is collapsed for this viewport')
})).min(saveHomepageLayoutResponseOneDesktopMin).max(saveHomepageLayoutResponseOneDesktopMax),
  "mobile": zod.array(zod.object({
  "componentId": zod.union([zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),zod.string().regex(saveHomepageLayoutResponseOneMobileItemComponentIdTwoRegExp)]),
  "column": zod.int().min(saveHomepageLayoutResponseOneMobileItemColumnMin).max(saveHomepageLayoutResponseOneMobileItemColumnMax),
  "row": zod.int().min(saveHomepageLayoutResponseOneMobileItemRowMin).max(saveHomepageLayoutResponseOneMobileItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(saveHomepageLayoutResponseOneMobileItemRowSpanMax),
  "visible": zod.boolean(),
  "collapsed": zod.boolean().describe('Whether the section content is collapsed for this viewport')
})).min(saveHomepageLayoutResponseOneMobileMin).max(saveHomepageLayoutResponseOneMobileMax)
}).and(zod.object({
  "tab": zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor']),
  "version": zod.int().min(saveHomepageLayoutResponseTwoVersionMin),
  "policyVersion": zod.int().min(saveHomepageLayoutResponseTwoPolicyVersionMin),
  "requiredComponentIds": zod.array(zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot'])),
  "reconciled": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))


/**
 * @summary Reset the signed-in user's layout to current defaults and administrator requirements
 */
export const resetHomepageLayoutQueryTabDefault = `all`;

export const resetHomepageLayoutQueryParams = zod.object({
  "tab": zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor']).default(resetHomepageLayoutQueryTabDefault).describe('Personal audience page; omitted selects All for existing clients.')
})

export const resetHomepageLayoutBodyVersionMin = 0;



export const resetHomepageLayoutBody = zod.object({
  "version": zod.int().min(resetHomepageLayoutBodyVersionMin)
})

export const resetHomepageLayoutResponseOneWidgetsItemTitleMax = 300;

export const resetHomepageLayoutResponseOneWidgetsMax = 50;

export const resetHomepageLayoutResponseOneDesktopItemComponentIdTwoRegExp = new RegExp('^widget:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
export const resetHomepageLayoutResponseOneDesktopItemColumnMin = 0;
export const resetHomepageLayoutResponseOneDesktopItemColumnMax = 11;

export const resetHomepageLayoutResponseOneDesktopItemRowMin = 0;
export const resetHomepageLayoutResponseOneDesktopItemRowMax = 199;

export const resetHomepageLayoutResponseOneDesktopItemRowSpanMax = 12;

export const resetHomepageLayoutResponseOneDesktopMin = 8;
export const resetHomepageLayoutResponseOneDesktopMax = 58;

export const resetHomepageLayoutResponseOneMobileItemComponentIdTwoRegExp = new RegExp('^widget:[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$');
export const resetHomepageLayoutResponseOneMobileItemColumnMin = 0;
export const resetHomepageLayoutResponseOneMobileItemColumnMax = 11;

export const resetHomepageLayoutResponseOneMobileItemRowMin = 0;
export const resetHomepageLayoutResponseOneMobileItemRowMax = 199;

export const resetHomepageLayoutResponseOneMobileItemRowSpanMax = 12;

export const resetHomepageLayoutResponseOneMobileMin = 8;
export const resetHomepageLayoutResponseOneMobileMax = 58;

export const resetHomepageLayoutResponseTwoVersionMin = 0;

export const resetHomepageLayoutResponseTwoPolicyVersionMin = 0;



export const resetHomepageLayoutResponse = zod.object({
  "schemaVersion": zod.literal(3),
  "widgets": zod.array(zod.object({
  "instanceId": zod.uuid(),
  "type": zod.enum(['text', 'quick_links', 'kpi', 'pipeline_chart', 'recent_records']),
  "title": zod.string().max(resetHomepageLayoutResponseOneWidgetsItemTitleMax).optional(),
  "config": zod.record(zod.string(), zod.unknown())
})).max(resetHomepageLayoutResponseOneWidgetsMax),
  "desktop": zod.array(zod.object({
  "componentId": zod.union([zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),zod.string().regex(resetHomepageLayoutResponseOneDesktopItemComponentIdTwoRegExp)]),
  "column": zod.int().min(resetHomepageLayoutResponseOneDesktopItemColumnMin).max(resetHomepageLayoutResponseOneDesktopItemColumnMax),
  "row": zod.int().min(resetHomepageLayoutResponseOneDesktopItemRowMin).max(resetHomepageLayoutResponseOneDesktopItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(resetHomepageLayoutResponseOneDesktopItemRowSpanMax),
  "visible": zod.boolean(),
  "collapsed": zod.boolean().describe('Whether the section content is collapsed for this viewport')
})).min(resetHomepageLayoutResponseOneDesktopMin).max(resetHomepageLayoutResponseOneDesktopMax),
  "mobile": zod.array(zod.object({
  "componentId": zod.union([zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),zod.string().regex(resetHomepageLayoutResponseOneMobileItemComponentIdTwoRegExp)]),
  "column": zod.int().min(resetHomepageLayoutResponseOneMobileItemColumnMin).max(resetHomepageLayoutResponseOneMobileItemColumnMax),
  "row": zod.int().min(resetHomepageLayoutResponseOneMobileItemRowMin).max(resetHomepageLayoutResponseOneMobileItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(resetHomepageLayoutResponseOneMobileItemRowSpanMax),
  "visible": zod.boolean(),
  "collapsed": zod.boolean().describe('Whether the section content is collapsed for this viewport')
})).min(resetHomepageLayoutResponseOneMobileMin).max(resetHomepageLayoutResponseOneMobileMax)
}).and(zod.object({
  "tab": zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor']),
  "version": zod.int().min(resetHomepageLayoutResponseTwoVersionMin),
  "policyVersion": zod.int().min(resetHomepageLayoutResponseTwoPolicyVersionMin),
  "requiredComponentIds": zod.array(zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot'])),
  "reconciled": zod.boolean(),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))


/**
 * @summary Get the administrator homepage component policy
 */
export const getAdminHomepagePolicyResponseOneDesktopItemColumnMin = 0;
export const getAdminHomepagePolicyResponseOneDesktopItemColumnMax = 11;

export const getAdminHomepagePolicyResponseOneDesktopItemRowMin = 0;
export const getAdminHomepagePolicyResponseOneDesktopItemRowMax = 199;

export const getAdminHomepagePolicyResponseOneDesktopItemRowSpanMax = 12;

export const getAdminHomepagePolicyResponseOneDesktopMax = 8;

export const getAdminHomepagePolicyResponseOneMobileItemColumnMin = 0;
export const getAdminHomepagePolicyResponseOneMobileItemColumnMax = 11;

export const getAdminHomepagePolicyResponseOneMobileItemRowMin = 0;
export const getAdminHomepagePolicyResponseOneMobileItemRowMax = 199;

export const getAdminHomepagePolicyResponseOneMobileItemRowSpanMax = 12;

export const getAdminHomepagePolicyResponseOneMobileMax = 8;

export const getAdminHomepagePolicyResponseTwoVersionMin = 0;



export const getAdminHomepagePolicyResponse = zod.object({
  "schemaVersion": zod.literal(3),
  "desktop": zod.array(zod.object({
  "componentId": zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),
  "column": zod.int().min(getAdminHomepagePolicyResponseOneDesktopItemColumnMin).max(getAdminHomepagePolicyResponseOneDesktopItemColumnMax),
  "row": zod.int().min(getAdminHomepagePolicyResponseOneDesktopItemRowMin).max(getAdminHomepagePolicyResponseOneDesktopItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(getAdminHomepagePolicyResponseOneDesktopItemRowSpanMax)
})).max(getAdminHomepagePolicyResponseOneDesktopMax),
  "mobile": zod.array(zod.object({
  "componentId": zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),
  "column": zod.int().min(getAdminHomepagePolicyResponseOneMobileItemColumnMin).max(getAdminHomepagePolicyResponseOneMobileItemColumnMax),
  "row": zod.int().min(getAdminHomepagePolicyResponseOneMobileItemRowMin).max(getAdminHomepagePolicyResponseOneMobileItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(getAdminHomepagePolicyResponseOneMobileItemRowSpanMax)
})).max(getAdminHomepagePolicyResponseOneMobileMax)
}).and(zod.object({
  "version": zod.int().min(getAdminHomepagePolicyResponseTwoVersionMin),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))


/**
 * @summary Update required locked components and their desktop/mobile placement
 */
export const updateAdminHomepagePolicyBodyVersionMin = 0;

export const updateAdminHomepagePolicyBodyPolicyDesktopItemColumnMin = 0;
export const updateAdminHomepagePolicyBodyPolicyDesktopItemColumnMax = 11;

export const updateAdminHomepagePolicyBodyPolicyDesktopItemRowMin = 0;
export const updateAdminHomepagePolicyBodyPolicyDesktopItemRowMax = 199;

export const updateAdminHomepagePolicyBodyPolicyDesktopItemRowSpanMax = 12;

export const updateAdminHomepagePolicyBodyPolicyDesktopMax = 8;

export const updateAdminHomepagePolicyBodyPolicyMobileItemColumnMin = 0;
export const updateAdminHomepagePolicyBodyPolicyMobileItemColumnMax = 11;

export const updateAdminHomepagePolicyBodyPolicyMobileItemRowMin = 0;
export const updateAdminHomepagePolicyBodyPolicyMobileItemRowMax = 199;

export const updateAdminHomepagePolicyBodyPolicyMobileItemRowSpanMax = 12;

export const updateAdminHomepagePolicyBodyPolicyMobileMax = 8;



export const updateAdminHomepagePolicyBody = zod.object({
  "version": zod.int().min(updateAdminHomepagePolicyBodyVersionMin),
  "policy": zod.object({
  "schemaVersion": zod.literal(3),
  "desktop": zod.array(zod.object({
  "componentId": zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),
  "column": zod.int().min(updateAdminHomepagePolicyBodyPolicyDesktopItemColumnMin).max(updateAdminHomepagePolicyBodyPolicyDesktopItemColumnMax),
  "row": zod.int().min(updateAdminHomepagePolicyBodyPolicyDesktopItemRowMin).max(updateAdminHomepagePolicyBodyPolicyDesktopItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(updateAdminHomepagePolicyBodyPolicyDesktopItemRowSpanMax)
})).max(updateAdminHomepagePolicyBodyPolicyDesktopMax),
  "mobile": zod.array(zod.object({
  "componentId": zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),
  "column": zod.int().min(updateAdminHomepagePolicyBodyPolicyMobileItemColumnMin).max(updateAdminHomepagePolicyBodyPolicyMobileItemColumnMax),
  "row": zod.int().min(updateAdminHomepagePolicyBodyPolicyMobileItemRowMin).max(updateAdminHomepagePolicyBodyPolicyMobileItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(updateAdminHomepagePolicyBodyPolicyMobileItemRowSpanMax)
})).max(updateAdminHomepagePolicyBodyPolicyMobileMax)
})
})

export const updateAdminHomepagePolicyResponseOneDesktopItemColumnMin = 0;
export const updateAdminHomepagePolicyResponseOneDesktopItemColumnMax = 11;

export const updateAdminHomepagePolicyResponseOneDesktopItemRowMin = 0;
export const updateAdminHomepagePolicyResponseOneDesktopItemRowMax = 199;

export const updateAdminHomepagePolicyResponseOneDesktopItemRowSpanMax = 12;

export const updateAdminHomepagePolicyResponseOneDesktopMax = 8;

export const updateAdminHomepagePolicyResponseOneMobileItemColumnMin = 0;
export const updateAdminHomepagePolicyResponseOneMobileItemColumnMax = 11;

export const updateAdminHomepagePolicyResponseOneMobileItemRowMin = 0;
export const updateAdminHomepagePolicyResponseOneMobileItemRowMax = 199;

export const updateAdminHomepagePolicyResponseOneMobileItemRowSpanMax = 12;

export const updateAdminHomepagePolicyResponseOneMobileMax = 8;

export const updateAdminHomepagePolicyResponseTwoVersionMin = 0;



export const updateAdminHomepagePolicyResponse = zod.object({
  "schemaVersion": zod.literal(3),
  "desktop": zod.array(zod.object({
  "componentId": zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),
  "column": zod.int().min(updateAdminHomepagePolicyResponseOneDesktopItemColumnMin).max(updateAdminHomepagePolicyResponseOneDesktopItemColumnMax),
  "row": zod.int().min(updateAdminHomepagePolicyResponseOneDesktopItemRowMin).max(updateAdminHomepagePolicyResponseOneDesktopItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(updateAdminHomepagePolicyResponseOneDesktopItemRowSpanMax)
})).max(updateAdminHomepagePolicyResponseOneDesktopMax),
  "mobile": zod.array(zod.object({
  "componentId": zod.enum(['daily-workflow', 'daily-briefing', 'briefing-insights', 'ask-ai', 'workspace-overview', 'next-actions', 'needs-attention', 'pipeline-snapshot']),
  "column": zod.int().min(updateAdminHomepagePolicyResponseOneMobileItemColumnMin).max(updateAdminHomepagePolicyResponseOneMobileItemColumnMax),
  "row": zod.int().min(updateAdminHomepagePolicyResponseOneMobileItemRowMin).max(updateAdminHomepagePolicyResponseOneMobileItemRowMax),
  "columnSpan": zod.union([zod.literal(1),zod.literal(4),zod.literal(6),zod.literal(12)]),
  "rowSpan": zod.int().min(1).max(updateAdminHomepagePolicyResponseOneMobileItemRowSpanMax)
})).max(updateAdminHomepagePolicyResponseOneMobileMax)
}).and(zod.object({
  "version": zod.int().min(updateAdminHomepagePolicyResponseTwoVersionMin),
  "updatedAt": zod.iso.datetime({"offset":true}).nullable()
}))


/**
 * @summary Get every saved sidebar layout for the active entity
 */
export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemIdMax = 100;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemHeadingMax = 40;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemOneKeyMax = 100;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemOneTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemOneHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemTwoTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemTwoHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemThreeIdMax = 100;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemThreeTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemThreeHrefMax = 2048;


export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemFourIdMax = 100;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemFourTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemFourToMax = 2048;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsMax = 500;

export const getNavigationLayoutsResponseLayoutsAllOneSectionsMax = 50;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemIdMax = 100;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemHeadingMax = 40;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemOneKeyMax = 100;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemOneTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemOneHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemTwoTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemTwoHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemThreeIdMax = 100;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemThreeTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemThreeHrefMax = 2048;


export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemFourIdMax = 100;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemFourTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemFourToMax = 2048;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsMax = 500;

export const getNavigationLayoutsResponseLayoutsB2cOneSectionsMax = 50;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemIdMax = 100;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemHeadingMax = 40;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemOneKeyMax = 100;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemOneTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemOneHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemTwoTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemTwoHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemThreeIdMax = 100;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemThreeTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemThreeHrefMax = 2048;


export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemFourIdMax = 100;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemFourTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemFourToMax = 2048;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsMax = 500;

export const getNavigationLayoutsResponseLayoutsB2bOneSectionsMax = 50;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemIdMax = 100;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemHeadingMax = 40;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemOneKeyMax = 100;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemOneTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemOneHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemTwoTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemTwoHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemThreeIdMax = 100;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemThreeTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemThreeHrefMax = 2048;


export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemFourIdMax = 100;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemFourTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemFourToMax = 2048;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsMax = 500;

export const getNavigationLayoutsResponseLayoutsPartnerOneSectionsMax = 50;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemIdMax = 100;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemHeadingMax = 40;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemOneKeyMax = 100;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemOneTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemOneHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemTwoTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemTwoHiddenDefault = false;
export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemThreeIdMax = 100;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemThreeTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemThreeHrefMax = 2048;


export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemFourIdMax = 100;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemFourTitleMax = 60;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemFourToMax = 2048;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsMax = 500;

export const getNavigationLayoutsResponseLayoutsInvestorOneSectionsMax = 50;

export const getNavigationLayoutsResponseVersionsAllMin = 0;

export const getNavigationLayoutsResponseVersionsB2cMin = 0;

export const getNavigationLayoutsResponseVersionsB2bMin = 0;

export const getNavigationLayoutsResponseVersionsPartnerMin = 0;

export const getNavigationLayoutsResponseVersionsInvestorMin = 0;



export const getNavigationLayoutsResponse = zod.object({
  "layouts": zod.object({
  "all": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemThreeHrefMax).regex(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsItemFourToMax)
})])).max(getNavigationLayoutsResponseLayoutsAllOneSectionsItemItemsMax)
})).max(getNavigationLayoutsResponseLayoutsAllOneSectionsMax)
}),zod.null()]),
  "b2c": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemThreeHrefMax).regex(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsItemFourToMax)
})])).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsItemItemsMax)
})).max(getNavigationLayoutsResponseLayoutsB2cOneSectionsMax)
}),zod.null()]),
  "b2b": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemThreeHrefMax).regex(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsItemFourToMax)
})])).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsItemItemsMax)
})).max(getNavigationLayoutsResponseLayoutsB2bOneSectionsMax)
}),zod.null()]),
  "partner": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemThreeHrefMax).regex(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsItemFourToMax)
})])).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsItemItemsMax)
})).max(getNavigationLayoutsResponseLayoutsPartnerOneSectionsMax)
}),zod.null()]),
  "investor": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemThreeHrefMax).regex(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsItemFourToMax)
})])).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsItemItemsMax)
})).max(getNavigationLayoutsResponseLayoutsInvestorOneSectionsMax)
}),zod.null()])
}),
  "versions": zod.object({
  "all": zod.int().min(getNavigationLayoutsResponseVersionsAllMin),
  "b2c": zod.int().min(getNavigationLayoutsResponseVersionsB2cMin),
  "b2b": zod.int().min(getNavigationLayoutsResponseVersionsB2bMin),
  "partner": zod.int().min(getNavigationLayoutsResponseVersionsPartnerMin),
  "investor": zod.int().min(getNavigationLayoutsResponseVersionsInvestorMin)
})
})


/**
 * @summary Get standard app screens, available icons, and published custom pages
 */
export const getAdminEntityNavigationCatalogueResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string(),
  "defaultTitle": zod.string(),
  "iconName": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string(),
  "permissions": zod.array(zod.string()).optional(),
  "moduleKey": zod.string().optional(),
  "views": zod.array(zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor']))
})),
  "iconNames": zod.array(zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe'])),
  "customPages": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "icon": zod.string().nullable()
}))
})


/**
 * @summary Save one entity sidebar layout using optimistic concurrency
 */
export const saveEntityNavigationLayoutParams = zod.object({
  "view": zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor'])
})

export const saveEntityNavigationLayoutBodyDocumentSectionsItemIdMax = 100;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemHeadingMax = 40;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemOneKeyMax = 100;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemOneTitleMax = 60;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemOneHiddenDefault = false;
export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemTwoTitleMax = 60;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemTwoHiddenDefault = false;
export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemThreeIdMax = 100;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemThreeTitleMax = 60;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemThreeHrefMax = 2048;


export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemFourIdMax = 100;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemFourTitleMax = 60;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemFourToMax = 2048;

export const saveEntityNavigationLayoutBodyDocumentSectionsItemItemsMax = 500;

export const saveEntityNavigationLayoutBodyDocumentSectionsMax = 50;

export const saveEntityNavigationLayoutBodyExpectedVersionMin = 0;

export const saveEntityNavigationLayoutBodyReasonMin = 10;
export const saveEntityNavigationLayoutBodyReasonMax = 500;



export const saveEntityNavigationLayoutBody = zod.object({
  "document": zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemIdMax),
  "heading": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemThreeHrefMax).regex(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsItemFourToMax)
})])).max(saveEntityNavigationLayoutBodyDocumentSectionsItemItemsMax)
})).max(saveEntityNavigationLayoutBodyDocumentSectionsMax)
}),
  "expectedVersion": zod.int().min(saveEntityNavigationLayoutBodyExpectedVersionMin),
  "reason": zod.string().min(saveEntityNavigationLayoutBodyReasonMin).max(saveEntityNavigationLayoutBodyReasonMax)
})

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemIdMax = 100;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemHeadingMax = 40;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneKeyMax = 100;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneTitleMax = 60;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneHiddenDefault = false;
export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemTwoTitleMax = 60;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemTwoHiddenDefault = false;
export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeIdMax = 100;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeTitleMax = 60;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeHrefMax = 2048;


export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourIdMax = 100;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourTitleMax = 60;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourToMax = 2048;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsMax = 500;

export const saveEntityNavigationLayoutResponseDocumentOneSectionsMax = 50;

export const saveEntityNavigationLayoutResponseVersionMin = 0;



export const saveEntityNavigationLayoutResponse = zod.object({
  "document": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeHrefMax).regex(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourToMax)
})])).max(saveEntityNavigationLayoutResponseDocumentOneSectionsItemItemsMax)
})).max(saveEntityNavigationLayoutResponseDocumentOneSectionsMax)
}),zod.null()]),
  "version": zod.int().min(saveEntityNavigationLayoutResponseVersionMin),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})


/**
 * @summary Remove one custom entity sidebar layout
 */
export const resetEntityNavigationLayoutParams = zod.object({
  "view": zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor'])
})

export const resetEntityNavigationLayoutBodyExpectedVersionMin = 0;

export const resetEntityNavigationLayoutBodyReasonMin = 10;
export const resetEntityNavigationLayoutBodyReasonMax = 500;



export const resetEntityNavigationLayoutBody = zod.object({
  "expectedVersion": zod.int().min(resetEntityNavigationLayoutBodyExpectedVersionMin).optional().describe('Optional loaded version; rejects concurrent changes.'),
  "reason": zod.string().min(resetEntityNavigationLayoutBodyReasonMin).max(resetEntityNavigationLayoutBodyReasonMax)
})

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemIdMax = 100;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemHeadingMax = 40;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneKeyMax = 100;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneTitleMax = 60;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneHiddenDefault = false;
export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemTwoTitleMax = 60;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemTwoHiddenDefault = false;
export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeIdMax = 100;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeTitleMax = 60;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeHrefMax = 2048;


export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourIdMax = 100;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourTitleMax = 60;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourToMax = 2048;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsMax = 500;

export const resetEntityNavigationLayoutResponseDocumentOneSectionsMax = 50;

export const resetEntityNavigationLayoutResponseVersionMin = 0;



export const resetEntityNavigationLayoutResponse = zod.object({
  "document": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeHrefMax).regex(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsItemFourToMax)
})])).max(resetEntityNavigationLayoutResponseDocumentOneSectionsItemItemsMax)
})).max(resetEntityNavigationLayoutResponseDocumentOneSectionsMax)
}),zod.null()]),
  "version": zod.int().min(resetEntityNavigationLayoutResponseVersionMin),
  "updatedAt": zod.iso.datetime({"offset":true}).nullish()
})


/**
 * @summary Copy one saved entity sidebar layout to other workspace views
 */
export const copyEntityNavigationLayoutParams = zod.object({
  "view": zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor'])
})

export const copyEntityNavigationLayoutBodyExpectedVersionsOneAllMin = 0;

export const copyEntityNavigationLayoutBodyExpectedVersionsOneB2cMin = 0;

export const copyEntityNavigationLayoutBodyExpectedVersionsOneB2bMin = 0;

export const copyEntityNavigationLayoutBodyExpectedVersionsOnePartnerMin = 0;

export const copyEntityNavigationLayoutBodyExpectedVersionsOneInvestorMin = 0;

export const copyEntityNavigationLayoutBodyToViewsMax = 4;

export const copyEntityNavigationLayoutBodyReasonMin = 10;
export const copyEntityNavigationLayoutBodyReasonMax = 500;



export const copyEntityNavigationLayoutBody = zod.object({
  "expectedVersions": zod.object({
  "all": zod.int().min(copyEntityNavigationLayoutBodyExpectedVersionsOneAllMin),
  "b2c": zod.int().min(copyEntityNavigationLayoutBodyExpectedVersionsOneB2cMin),
  "b2b": zod.int().min(copyEntityNavigationLayoutBodyExpectedVersionsOneB2bMin),
  "partner": zod.int().min(copyEntityNavigationLayoutBodyExpectedVersionsOnePartnerMin),
  "investor": zod.int().min(copyEntityNavigationLayoutBodyExpectedVersionsOneInvestorMin)
}).optional().describe('Optional loaded versions for source and targets; rejects concurrent changes.'),
  "toViews": zod.array(zod.enum(['all', 'b2c', 'b2b', 'partner', 'investor'])).min(1).max(copyEntityNavigationLayoutBodyToViewsMax),
  "reason": zod.string().min(copyEntityNavigationLayoutBodyReasonMin).max(copyEntityNavigationLayoutBodyReasonMax)
})

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemHeadingMax = 40;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemOneKeyMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemOneTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemOneHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemTwoTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemTwoHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemThreeIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemThreeTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemThreeHrefMax = 2048;


export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemFourIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemFourTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemFourToMax = 2048;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsMax = 500;

export const copyEntityNavigationLayoutResponseLayoutsAllOneSectionsMax = 50;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemHeadingMax = 40;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemOneKeyMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemOneTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemOneHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemTwoTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemTwoHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemThreeIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemThreeTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemThreeHrefMax = 2048;


export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemFourIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemFourTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemFourToMax = 2048;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsMax = 500;

export const copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsMax = 50;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemHeadingMax = 40;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemOneKeyMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemOneTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemOneHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemTwoTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemTwoHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemThreeIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemThreeTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemThreeHrefMax = 2048;


export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemFourIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemFourTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemFourToMax = 2048;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsMax = 500;

export const copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsMax = 50;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemHeadingMax = 40;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemOneKeyMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemOneTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemOneHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemTwoTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemTwoHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemThreeIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemThreeTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemThreeHrefMax = 2048;


export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemFourIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemFourTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemFourToMax = 2048;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsMax = 500;

export const copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsMax = 50;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemHeadingMax = 40;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemOneKeyMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemOneTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemOneHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemTwoTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemTwoHiddenDefault = false;
export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemThreeIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemThreeTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemThreeHrefMax = 2048;


export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemThreeHrefRegExp = new RegExp('^https:/');
export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemFourIdMax = 100;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemFourTitleMax = 60;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemFourToMax = 2048;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsMax = 500;

export const copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsMax = 50;

export const copyEntityNavigationLayoutResponseVersionsAllMin = 0;

export const copyEntityNavigationLayoutResponseVersionsB2cMin = 0;

export const copyEntityNavigationLayoutResponseVersionsB2bMin = 0;

export const copyEntityNavigationLayoutResponseVersionsPartnerMin = 0;

export const copyEntityNavigationLayoutResponseVersionsInvestorMin = 0;



export const copyEntityNavigationLayoutResponse = zod.object({
  "layouts": zod.object({
  "all": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemThreeHrefMax).regex(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsItemFourToMax)
})])).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsItemItemsMax)
})).max(copyEntityNavigationLayoutResponseLayoutsAllOneSectionsMax)
}),zod.null()]),
  "b2c": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemThreeHrefMax).regex(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsItemFourToMax)
})])).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsItemItemsMax)
})).max(copyEntityNavigationLayoutResponseLayoutsB2cOneSectionsMax)
}),zod.null()]),
  "b2b": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemThreeHrefMax).regex(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsItemFourToMax)
})])).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsItemItemsMax)
})).max(copyEntityNavigationLayoutResponseLayoutsB2bOneSectionsMax)
}),zod.null()]),
  "partner": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemThreeHrefMax).regex(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsItemFourToMax)
})])).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsItemItemsMax)
})).max(copyEntityNavigationLayoutResponseLayoutsPartnerOneSectionsMax)
}),zod.null()]),
  "investor": zod.union([zod.object({
  "sections": zod.array(zod.object({
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemIdMax),
  "heading": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemHeadingMax),
  "items": zod.array(zod.union([zod.object({
  "kind": zod.enum(['standard']),
  "key": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemOneKeyMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemOneTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemOneHiddenDefault)
}),zod.object({
  "kind": zod.enum(['custom-page']),
  "pageId": zod.uuid(),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemTwoTitleMax).optional(),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']).optional(),
  "hidden": zod.boolean().default(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemTwoHiddenDefault)
}),zod.object({
  "kind": zod.enum(['external']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemThreeIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemThreeTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "href": zod.url().max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemThreeHrefMax).regex(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemThreeHrefRegExp)
}),zod.object({
  "kind": zod.enum(['route']),
  "id": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemFourIdMax),
  "title": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemFourTitleMax),
  "icon": zod.enum(['layout-dashboard', 'file-text', 'bar-chart', 'users', 'briefcase', 'links', 'globe']),
  "to": zod.string().min(1).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsItemFourToMax)
})])).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsItemItemsMax)
})).max(copyEntityNavigationLayoutResponseLayoutsInvestorOneSectionsMax)
}),zod.null()])
}),
  "versions": zod.object({
  "all": zod.int().min(copyEntityNavigationLayoutResponseVersionsAllMin),
  "b2c": zod.int().min(copyEntityNavigationLayoutResponseVersionsB2cMin),
  "b2b": zod.int().min(copyEntityNavigationLayoutResponseVersionsB2bMin),
  "partner": zod.int().min(copyEntityNavigationLayoutResponseVersionsPartnerMin),
  "investor": zod.int().min(copyEntityNavigationLayoutResponseVersionsInvestorMin)
})
})


/**
 * @summary List shared research threads in the selected entity
 */
export const listResearchThreadsQueryLimitDefault = 25;
export const listResearchThreadsQueryLimitMax = 100;

export const listResearchThreadsQueryOffsetDefault = 0;
export const listResearchThreadsQueryOffsetMin = 0;

export const listResearchThreadsQuerySearchMax = 200;



export const listResearchThreadsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listResearchThreadsQueryLimitMax).default(listResearchThreadsQueryLimitDefault),
  "offset": zod.int().min(listResearchThreadsQueryOffsetMin).default(listResearchThreadsQueryOffsetDefault),
  "status": zod.enum(['active', 'archived']).optional(),
  "search": zod.string().max(listResearchThreadsQuerySearchMax).optional()
})


export const listResearchThreadsResponseTotalMin = 0;


export const listResearchThreadsResponseOffsetMin = 0;



export const listResearchThreadsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listResearchThreadsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listResearchThreadsResponseOffsetMin)
})


/**
 * @summary Create a shared research thread
 */
export const createResearchThreadBodyTitleDefault = `New research`;
export const createResearchThreadBodyTitleMax = 200;



export const createResearchThreadBody = zod.object({
  "title": zod.string().min(1).max(createResearchThreadBodyTitleMax).default(createResearchThreadBodyTitleDefault)
})




export const createResearchThreadResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get one shared research thread
 */
export const getResearchThreadParams = zod.object({
  "threadId": zod.uuid()
})




export const getResearchThreadResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Rename or archive a research thread using its current revision
 */
export const updateResearchThreadParams = zod.object({
  "threadId": zod.uuid()
})


export const updateResearchThreadBodyTitleMax = 200;



export const updateResearchThreadBody = zod.object({
  "baseRevision": zod.int().min(1),
  "title": zod.string().min(1).max(updateResearchThreadBodyTitleMax).optional(),
  "status": zod.enum(['active', 'archived']).optional()
})




export const updateResearchThreadResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Permanently delete a research thread after explicit confirmation
 */
export const deleteResearchThreadParams = zod.object({
  "threadId": zod.uuid()
})

export const deleteResearchThreadBody = zod.object({
  "confirmation": zod.enum(['DELETE'])
})

export const deleteResearchThreadResponse = zod.void()


/**
 * @summary List paged durable message history
 */
export const listResearchMessagesParams = zod.object({
  "threadId": zod.uuid()
})

export const listResearchMessagesQueryLimitDefault = 50;
export const listResearchMessagesQueryLimitMax = 100;

export const listResearchMessagesQueryOffsetDefault = 0;
export const listResearchMessagesQueryOffsetMin = 0;



export const listResearchMessagesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listResearchMessagesQueryLimitMax).default(listResearchMessagesQueryLimitDefault),
  "offset": zod.int().min(listResearchMessagesQueryOffsetMin).default(listResearchMessagesQueryOffsetDefault)
})

export const listResearchMessagesResponseTotalMin = 0;


export const listResearchMessagesResponseOffsetMin = 0;



export const listResearchMessagesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "role": zod.enum(['user', 'assistant', 'system']),
  "content": zod.string(),
  "authorAppUserId": zod.uuid().nullable(),
  "authorDisplayName": zod.string(),
  "state": zod.enum(['complete', 'incomplete', 'failed', 'cancelled']),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listResearchMessagesResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listResearchMessagesResponseOffsetMin)
})


/**
 * @summary List private files attached to a research thread
 */
export const listResearchThreadAttachmentsParams = zod.object({
  "threadId": zod.uuid()
})

export const listResearchThreadAttachmentsQueryLimitDefault = 25;
export const listResearchThreadAttachmentsQueryLimitMax = 100;

export const listResearchThreadAttachmentsQueryOffsetDefault = 0;
export const listResearchThreadAttachmentsQueryOffsetMin = 0;



export const listResearchThreadAttachmentsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listResearchThreadAttachmentsQueryLimitMax).default(listResearchThreadAttachmentsQueryLimitDefault),
  "offset": zod.int().min(listResearchThreadAttachmentsQueryOffsetMin).default(listResearchThreadAttachmentsQueryOffsetDefault)
})

export const listResearchThreadAttachmentsHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const listResearchThreadAttachmentsHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(listResearchThreadAttachmentsHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const listResearchThreadAttachmentsResponseItemsItemSizeBytesMin = 0;
export const listResearchThreadAttachmentsResponseItemsItemSizeBytesMax = 20971520;

export const listResearchThreadAttachmentsResponseTotalMin = 0;


export const listResearchThreadAttachmentsResponseOffsetMin = 0;



export const listResearchThreadAttachmentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "fileId": zod.uuid(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(listResearchThreadAttachmentsResponseItemsItemSizeBytesMin).max(listResearchThreadAttachmentsResponseItemsItemSizeBytesMax),
  "processingStatus": zod.enum(['pending', 'processing', 'ready', 'failed', 'unsupported']),
  "failureCode": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listResearchThreadAttachmentsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listResearchThreadAttachmentsResponseOffsetMin)
})


/**
 * @summary Validate and privately attach one file to a thread
 */
export const uploadResearchThreadAttachmentParams = zod.object({
  "threadId": zod.uuid()
})

export const uploadResearchThreadAttachmentHeaderXDocumentBindingFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const uploadResearchThreadAttachmentHeader = zod.object({
  "x-document-destination-id": zod.uuid().optional().describe('Explicit administrator-approved destination. Requires its reviewed binding fingerprint. Omit to use the effective category default.'),
  "x-document-binding-fingerprint": zod.string().regex(uploadResearchThreadAttachmentHeaderXDocumentBindingFingerprintRegExp).optional().describe('Effective storage fingerprint reviewed before saving. Stale values fail closed.')
})

export const uploadResearchThreadAttachmentBody = zod.object({
  "file": zod.instanceof(Blob)
})

export const uploadResearchThreadAttachmentResponseSizeBytesMin = 0;
export const uploadResearchThreadAttachmentResponseSizeBytesMax = 20971520;



export const uploadResearchThreadAttachmentResponse = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "fileId": zod.uuid(),
  "filename": zod.string(),
  "contentType": zod.string(),
  "sizeBytes": zod.int().min(uploadResearchThreadAttachmentResponseSizeBytesMin).max(uploadResearchThreadAttachmentResponseSizeBytesMax),
  "processingStatus": zod.enum(['pending', 'processing', 'ready', 'failed', 'unsupported']),
  "failureCode": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Remove a private attachment from a thread
 */
export const deleteResearchThreadAttachmentParams = zod.object({
  "threadId": zod.uuid(),
  "attachmentId": zod.uuid()
})

export const deleteResearchThreadAttachmentResponse = zod.void()


/**
 * @summary Read safe configuration and monthly-limit readiness for Azure AI Foundry web search
 */
export const getResearchWebSearchStatusResponseLimitsMaxResultsPerQueryMax = 5;

export const getResearchWebSearchStatusResponseLimitsMaxSearchesPerTurnMax = 3;

export const getResearchWebSearchStatusResponseLimitsMonthlyCreditCapMax = 1000;

export const getResearchWebSearchStatusResponseLimitsCreditsUsedThisMonthMin = 0;



export const getResearchWebSearchStatusResponse = zod.object({
  "provider": zod.enum(['azure_web_search']),
  "state": zod.enum(['disabled', 'approval_required', 'misconfigured', 'quota_exhausted', 'timeout', 'failed', 'ready']),
  "approved": zod.boolean(),
  "configured": zod.boolean(),
  "enabled": zod.boolean(),
  "liveSmokeTested": zod.boolean(),
  "message": zod.string(),
  "limits": zod.object({
  "searchDepth": zod.enum(['basic']),
  "maxResultsPerQuery": zod.int().min(1).max(getResearchWebSearchStatusResponseLimitsMaxResultsPerQueryMax),
  "maxSearchesPerTurn": zod.int().min(1).max(getResearchWebSearchStatusResponseLimitsMaxSearchesPerTurnMax),
  "monthlyCreditCap": zod.int().min(1).max(getResearchWebSearchStatusResponseLimitsMonthlyCreditCapMax),
  "creditsUsedThisMonth": zod.int().min(getResearchWebSearchStatusResponseLimitsCreditsUsedThisMonthMin)
}),
  "pricingCheckedAt": zod.iso.date(),
  "pricingUrl": zod.url(),
  "searchApiUrl": zod.url()
})


/**
 * @summary List paged run history for a thread
 */
export const listResearchRunsParams = zod.object({
  "threadId": zod.uuid()
})

export const listResearchRunsQueryLimitDefault = 25;
export const listResearchRunsQueryLimitMax = 100;

export const listResearchRunsQueryOffsetDefault = 0;
export const listResearchRunsQueryOffsetMin = 0;



export const listResearchRunsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listResearchRunsQueryLimitMax).default(listResearchRunsQueryLimitDefault),
  "offset": zod.int().min(listResearchRunsQueryOffsetMin).default(listResearchRunsQueryOffsetDefault)
})

export const listResearchRunsResponseTotalMin = 0;


export const listResearchRunsResponseOffsetMin = 0;



export const listResearchRunsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "retryOfRunId": zod.uuid().nullable(),
  "questionMessageId": zod.uuid().nullable(),
  "responseMessageId": zod.uuid().nullable(),
  "status": zod.enum(['queued', 'running', 'completed', 'failed', 'cancelled']),
  "errorCode": zod.string().nullable(),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listResearchRunsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listResearchRunsResponseOffsetMin)
})


/**
 * Requires entity.ai.use in addition to entity record write access. The client request ID is unique within the thread.
 * @summary Start a deduplicated grounded research run and stream typed events
 */
export const streamResearchRunParams = zod.object({
  "threadId": zod.uuid()
})

export const streamResearchRunBodyContentMax = 20000;

export const streamResearchRunBodyAttachmentIdsMax = 10;

export const streamResearchRunBodyPublicSearchQueriesItemMin = 3;
export const streamResearchRunBodyPublicSearchQueriesItemMax = 300;

export const streamResearchRunBodyPublicSearchQueriesMax = 3;



export const streamResearchRunBody = zod.object({
  "clientRequestId": zod.uuid(),
  "content": zod.string().min(1).max(streamResearchRunBodyContentMax),
  "attachmentIds": zod.array(zod.uuid()).max(streamResearchRunBodyAttachmentIdsMax),
  "sourceMode": zod.enum(['entity_only', 'entity_and_web']),
  "publicSearchQueries": zod.array(zod.string().min(streamResearchRunBodyPublicSearchQueriesItemMin).max(streamResearchRunBodyPublicSearchQueriesItemMax)).max(streamResearchRunBodyPublicSearchQueriesMax).describe('Explicit public-only terms sent to the approved web provider. Private context is never derived into these queries.')
})

export const streamResearchRunResponse = zod.unknown()


/**
 * @summary Request cancellation of a queued or running research run
 */
export const cancelResearchRunParams = zod.object({
  "threadId": zod.uuid(),
  "runId": zod.uuid()
})

export const cancelResearchRunResponse = zod.object({
  "id": zod.uuid(),
  "threadId": zod.uuid(),
  "clientRequestId": zod.uuid(),
  "retryOfRunId": zod.uuid().nullable(),
  "questionMessageId": zod.uuid().nullable(),
  "responseMessageId": zod.uuid().nullable(),
  "status": zod.enum(['queued', 'running', 'completed', 'failed', 'cancelled']),
  "errorCode": zod.string().nullable(),
  "startedAt": zod.iso.datetime({"offset":true}).nullable(),
  "completedAt": zod.iso.datetime({"offset":true}).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Retry a failed or cancelled run with a new client request ID
 */
export const retryResearchRunParams = zod.object({
  "threadId": zod.uuid(),
  "runId": zod.uuid()
})

export const retryResearchRunBody = zod.object({
  "clientRequestId": zod.uuid()
})

export const retryResearchRunResponse = zod.unknown()


/**
 * @summary List paged entity prompt shortcuts
 */
export const listResearchPromptsQuerySearchMax = 200;

export const listResearchPromptsQueryCategoryMax = 60;

export const listResearchPromptsQueryLimitDefault = 50;
export const listResearchPromptsQueryLimitMax = 100;

export const listResearchPromptsQueryOffsetDefault = 0;
export const listResearchPromptsQueryOffsetMin = 0;



export const listResearchPromptsQueryParams = zod.object({
  "search": zod.string().max(listResearchPromptsQuerySearchMax).optional(),
  "category": zod.string().max(listResearchPromptsQueryCategoryMax).optional(),
  "limit": zod.int().min(1).max(listResearchPromptsQueryLimitMax).default(listResearchPromptsQueryLimitDefault),
  "offset": zod.int().min(listResearchPromptsQueryOffsetMin).default(listResearchPromptsQueryOffsetDefault),
  "active": zod.boolean().optional()
})


export const listResearchPromptsResponseTotalMin = 0;


export const listResearchPromptsResponseOffsetMin = 0;



export const listResearchPromptsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "prompt": zod.string(),
  "category": zod.string(),
  "sortOrder": zod.int(),
  "active": zod.boolean(),
  "revision": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listResearchPromptsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listResearchPromptsResponseOffsetMin)
})


/**
 * @summary Create an entity prompt shortcut
 */
export const createResearchPromptBodyTitleMax = 120;

export const createResearchPromptBodyPromptMax = 8000;

export const createResearchPromptBodyCategoryMax = 80;

export const createResearchPromptBodySortOrderMin = 0;
export const createResearchPromptBodySortOrderMax = 10000;



export const createResearchPromptBody = zod.object({
  "title": zod.string().min(1).max(createResearchPromptBodyTitleMax),
  "prompt": zod.string().min(1).max(createResearchPromptBodyPromptMax),
  "category": zod.string().min(1).max(createResearchPromptBodyCategoryMax),
  "sortOrder": zod.int().min(createResearchPromptBodySortOrderMin).max(createResearchPromptBodySortOrderMax),
  "active": zod.boolean()
})




export const createResearchPromptResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "prompt": zod.string(),
  "category": zod.string(),
  "sortOrder": zod.int(),
  "active": zod.boolean(),
  "revision": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Update a prompt shortcut using its current revision
 */
export const updateResearchPromptParams = zod.object({
  "promptId": zod.uuid()
})

export const updateResearchPromptBodyOneTitleMax = 120;

export const updateResearchPromptBodyOnePromptMax = 8000;

export const updateResearchPromptBodyOneCategoryMax = 80;

export const updateResearchPromptBodyOneSortOrderMin = 0;
export const updateResearchPromptBodyOneSortOrderMax = 10000;




export const updateResearchPromptBody = zod.object({
  "title": zod.string().min(1).max(updateResearchPromptBodyOneTitleMax),
  "prompt": zod.string().min(1).max(updateResearchPromptBodyOnePromptMax),
  "category": zod.string().min(1).max(updateResearchPromptBodyOneCategoryMax),
  "sortOrder": zod.int().min(updateResearchPromptBodyOneSortOrderMin).max(updateResearchPromptBodyOneSortOrderMax),
  "active": zod.boolean()
}).and(zod.object({
  "baseRevision": zod.int().min(1)
}))




export const updateResearchPromptResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "prompt": zod.string(),
  "category": zod.string(),
  "sortOrder": zod.int(),
  "active": zod.boolean(),
  "revision": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Delete a prompt shortcut
 */
export const deleteResearchPromptParams = zod.object({
  "promptId": zod.uuid()
})

export const deleteResearchPromptResponse = zod.void()


/**
 * @summary List collaborators whose presence has not expired
 */
export const listResearchPresenceResponseItemsMax = 200;




export const listResearchPresenceResponse = zod.object({
  "items": zod.array(zod.object({
  "appUserId": zod.uuid(),
  "displayName": zod.string(),
  "activeThreadId": zod.uuid().nullable(),
  "view": zod.enum(['research', 'documents']),
  "lastHeartbeatAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
})).max(listResearchPresenceResponseItemsMax),
  "expiresInSeconds": zod.int().min(1)
})


/**
 * @summary Refresh the authenticated collaborator's TTL presence
 */
export const heartbeatResearchPresenceBody = zod.object({
  "activeThreadId": zod.uuid().nullish(),
  "view": zod.enum(['research', 'documents'])
})

export const heartbeatResearchPresenceResponse = zod.object({
  "appUserId": zod.uuid(),
  "displayName": zod.string(),
  "activeThreadId": zod.uuid().nullable(),
  "view": zod.enum(['research', 'documents']),
  "lastHeartbeatAt": zod.iso.datetime({"offset":true}),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List shared internal documents in the selected entity
 */
export const listResearchDocumentsQueryLimitDefault = 25;
export const listResearchDocumentsQueryLimitMax = 100;

export const listResearchDocumentsQueryOffsetDefault = 0;
export const listResearchDocumentsQueryOffsetMin = 0;

export const listResearchDocumentsQuerySearchMax = 200;



export const listResearchDocumentsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listResearchDocumentsQueryLimitMax).default(listResearchDocumentsQueryLimitDefault),
  "offset": zod.int().min(listResearchDocumentsQueryOffsetMin).default(listResearchDocumentsQueryOffsetDefault),
  "status": zod.enum(['active', 'archived']).optional(),
  "search": zod.string().max(listResearchDocumentsQuerySearchMax).optional()
})


export const listResearchDocumentsResponseTotalMin = 0;


export const listResearchDocumentsResponseOffsetMin = 0;



export const listResearchDocumentsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listResearchDocumentsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listResearchDocumentsResponseOffsetMin)
})


/**
 * @summary Create a blank or research-derived internal document and its immutable first version
 */
export const createResearchDocumentBodyTitleMax = 200;

export const createResearchDocumentBodyMarkdownMax = 1000000;

export const createResearchDocumentBodySourceMessageIdsMax = 100;



export const createResearchDocumentBody = zod.object({
  "title": zod.string().min(1).max(createResearchDocumentBodyTitleMax),
  "markdown": zod.string().max(createResearchDocumentBodyMarkdownMax),
  "threadId": zod.uuid().nullish(),
  "sourceMessageIds": zod.array(zod.uuid()).max(createResearchDocumentBodySourceMessageIdsMax).optional()
})




export const createResearchDocumentResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "markdown": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get an internal document and its linked threads
 */
export const getResearchDocumentParams = zod.object({
  "documentId": zod.uuid()
})





export const getResearchDocumentResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "markdown": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "threads": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))


/**
 * @summary Save Markdown using the current base revision
 */
export const saveResearchDocumentParams = zod.object({
  "documentId": zod.uuid()
})


export const saveResearchDocumentBodyTitleMax = 200;

export const saveResearchDocumentBodyMarkdownMax = 1000000;



export const saveResearchDocumentBody = zod.object({
  "baseRevision": zod.int().min(1),
  "title": zod.string().min(1).max(saveResearchDocumentBodyTitleMax),
  "markdown": zod.string().max(saveResearchDocumentBodyMarkdownMax),
  "status": zod.enum(['active', 'archived']).optional(),
  "action": zod.enum(['saved'])
})




export const saveResearchDocumentResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "markdown": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Explicitly append Markdown using the current base revision
 */
export const appendResearchDocumentParams = zod.object({
  "documentId": zod.uuid()
})


export const appendResearchDocumentBodyHeadingMax = 200;

export const appendResearchDocumentBodyMarkdownMax = 1000000;



export const appendResearchDocumentBody = zod.object({
  "baseRevision": zod.int().min(1),
  "heading": zod.string().min(1).max(appendResearchDocumentBodyHeadingMax).optional(),
  "markdown": zod.string().min(1).max(appendResearchDocumentBodyMarkdownMax)
})




export const appendResearchDocumentResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "markdown": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List immutable document versions
 */
export const listResearchDocumentVersionsParams = zod.object({
  "documentId": zod.uuid()
})

export const listResearchDocumentVersionsQueryLimitDefault = 25;
export const listResearchDocumentVersionsQueryLimitMax = 100;

export const listResearchDocumentVersionsQueryOffsetDefault = 0;
export const listResearchDocumentVersionsQueryOffsetMin = 0;



export const listResearchDocumentVersionsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listResearchDocumentVersionsQueryLimitMax).default(listResearchDocumentVersionsQueryLimitDefault),
  "offset": zod.int().min(listResearchDocumentVersionsQueryOffsetMin).default(listResearchDocumentVersionsQueryOffsetDefault)
})


export const listResearchDocumentVersionsResponseItemsItemEvidenceMax = 32;

export const listResearchDocumentVersionsResponseTotalMin = 0;


export const listResearchDocumentVersionsResponseOffsetMin = 0;



export const listResearchDocumentVersionsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "markdown": zod.string(),
  "action": zod.enum(['created', 'saved', 'appended', 'proposal_applied', 'restored']),
  "actorAppUserId": zod.uuid().nullable(),
  "actorDisplayName": zod.string(),
  "restoredFromVersionId": zod.uuid().nullable(),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(listResearchDocumentVersionsResponseItemsItemEvidenceMax),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listResearchDocumentVersionsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listResearchDocumentVersionsResponseOffsetMin)
})


/**
 * @summary Compare two authorized immutable versions
 */
export const compareResearchDocumentVersionsParams = zod.object({
  "documentId": zod.uuid()
})

export const compareResearchDocumentVersionsQueryParams = zod.object({
  "from": zod.uuid(),
  "to": zod.uuid()
})


export const compareResearchDocumentVersionsResponseFromEvidenceMax = 32;


export const compareResearchDocumentVersionsResponseToEvidenceMax = 32;



export const compareResearchDocumentVersionsResponse = zod.object({
  "from": zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "markdown": zod.string(),
  "action": zod.enum(['created', 'saved', 'appended', 'proposal_applied', 'restored']),
  "actorAppUserId": zod.uuid().nullable(),
  "actorDisplayName": zod.string(),
  "restoredFromVersionId": zod.uuid().nullable(),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(compareResearchDocumentVersionsResponseFromEvidenceMax),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "to": zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "markdown": zod.string(),
  "action": zod.enum(['created', 'saved', 'appended', 'proposal_applied', 'restored']),
  "actorAppUserId": zod.uuid().nullable(),
  "actorDisplayName": zod.string(),
  "restoredFromVersionId": zod.uuid().nullable(),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})).max(compareResearchDocumentVersionsResponseToEvidenceMax),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * @summary Restore an old version as a new current version
 */
export const restoreResearchDocumentVersionParams = zod.object({
  "documentId": zod.uuid(),
  "versionId": zod.uuid()
})




export const restoreResearchDocumentVersionBody = zod.object({
  "baseRevision": zod.int().min(1)
})




export const restoreResearchDocumentVersionResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "markdown": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List threads linked to an internal document
 */
export const listResearchDocumentThreadsParams = zod.object({
  "documentId": zod.uuid()
})




export const listResearchDocumentThreadsResponseItem = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
export const listResearchDocumentThreadsResponse = zod.array(listResearchDocumentThreadsResponseItem)


/**
 * @summary Link another entity thread to a document
 */
export const linkResearchDocumentThreadParams = zod.object({
  "documentId": zod.uuid()
})

export const linkResearchDocumentThreadBody = zod.object({
  "threadId": zod.uuid()
})

export const linkResearchDocumentThreadResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "threadId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Remove a document/thread link without deleting either record
 */
export const unlinkResearchDocumentThreadParams = zod.object({
  "documentId": zod.uuid(),
  "threadId": zod.uuid()
})

export const unlinkResearchDocumentThreadResponse = zod.void()


/**
 * @summary List reviewable document proposals
 */
export const listResearchDocumentProposalsParams = zod.object({
  "documentId": zod.uuid()
})

export const listResearchDocumentProposalsQueryLimitDefault = 25;
export const listResearchDocumentProposalsQueryLimitMax = 100;

export const listResearchDocumentProposalsQueryOffsetDefault = 0;
export const listResearchDocumentProposalsQueryOffsetMin = 0;



export const listResearchDocumentProposalsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listResearchDocumentProposalsQueryLimitMax).default(listResearchDocumentProposalsQueryLimitDefault),
  "offset": zod.int().min(listResearchDocumentProposalsQueryOffsetMin).default(listResearchDocumentProposalsQueryOffsetDefault)
})


export const listResearchDocumentProposalsResponseItemsItemSelectionStartMin = 0;


export const listResearchDocumentProposalsResponseItemsItemSelectedTextSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listResearchDocumentProposalsResponseTotalMin = 0;


export const listResearchDocumentProposalsResponseOffsetMin = 0;



export const listResearchDocumentProposalsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "runId": zod.uuid().nullable(),
  "baseRevision": zod.int().min(1),
  "action": zod.enum(['generate', 'rewrite', 'shorten', 'expand', 'change_tone', 'tidy', 'append']),
  "selectionStart": zod.int().min(listResearchDocumentProposalsResponseItemsItemSelectionStartMin).nullable(),
  "selectionEnd": zod.int().min(1).nullable(),
  "selectedTextSha256": zod.string().regex(listResearchDocumentProposalsResponseItemsItemSelectedTextSha256RegExp).nullable(),
  "proposedMarkdown": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'expired']),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "total": zod.int().min(listResearchDocumentProposalsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listResearchDocumentProposalsResponseOffsetMin)
})


/**
 * Requires entity.ai.use in addition to entity record write access.
 * @summary Generate a non-mutating AI proposal bound to a revision and selection fingerprint
 */
export const createResearchDocumentProposalParams = zod.object({
  "documentId": zod.uuid()
})


export const createResearchDocumentProposalBodyInstructionMax = 8000;

export const createResearchDocumentProposalBodySelectionStartMin = 0;


export const createResearchDocumentProposalBodySelectedTextSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const createResearchDocumentProposalBodySourceMessageIdsMax = 100;



export const createResearchDocumentProposalBody = zod.object({
  "baseRevision": zod.int().min(1),
  "action": zod.enum(['generate', 'rewrite', 'shorten', 'expand', 'change_tone', 'tidy', 'append']),
  "instruction": zod.string().max(createResearchDocumentProposalBodyInstructionMax).optional(),
  "selectionStart": zod.int().min(createResearchDocumentProposalBodySelectionStartMin).optional(),
  "selectionEnd": zod.int().min(1).optional(),
  "selectedTextSha256": zod.string().regex(createResearchDocumentProposalBodySelectedTextSha256RegExp).optional(),
  "sourceMessageIds": zod.array(zod.uuid()).max(createResearchDocumentProposalBodySourceMessageIdsMax).optional()
})


export const createResearchDocumentProposalResponseSelectionStartMin = 0;


export const createResearchDocumentProposalResponseSelectedTextSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const createResearchDocumentProposalResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "runId": zod.uuid().nullable(),
  "baseRevision": zod.int().min(1),
  "action": zod.enum(['generate', 'rewrite', 'shorten', 'expand', 'change_tone', 'tidy', 'append']),
  "selectionStart": zod.int().min(createResearchDocumentProposalResponseSelectionStartMin).nullable(),
  "selectionEnd": zod.int().min(1).nullable(),
  "selectedTextSha256": zod.string().regex(createResearchDocumentProposalResponseSelectedTextSha256RegExp).nullable(),
  "proposedMarkdown": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'expired']),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Accept a still-current proposal and create a new immutable version
 */
export const acceptResearchDocumentProposalParams = zod.object({
  "documentId": zod.uuid(),
  "proposalId": zod.uuid()
})




export const acceptResearchDocumentProposalBody = zod.object({
  "baseRevision": zod.int().min(1)
})




export const acceptResearchDocumentProposalResponse = zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "markdown": zod.string(),
  "status": zod.enum(['active', 'archived']),
  "revision": zod.int().min(1),
  "createdByAppUserId": zod.uuid().nullable(),
  "updatedByAppUserId": zod.uuid().nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Reject a pending proposal without changing the document
 */
export const rejectResearchDocumentProposalParams = zod.object({
  "documentId": zod.uuid(),
  "proposalId": zod.uuid()
})


export const rejectResearchDocumentProposalResponseSelectionStartMin = 0;


export const rejectResearchDocumentProposalResponseSelectedTextSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const rejectResearchDocumentProposalResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "runId": zod.uuid().nullable(),
  "baseRevision": zod.int().min(1),
  "action": zod.enum(['generate', 'rewrite', 'shorten', 'expand', 'change_tone', 'tidy', 'append']),
  "selectionStart": zod.int().min(rejectResearchDocumentProposalResponseSelectionStartMin).nullable(),
  "selectionEnd": zod.int().min(1).nullable(),
  "selectedTextSha256": zod.string().regex(rejectResearchDocumentProposalResponseSelectedTextSha256RegExp).nullable(),
  "proposedMarkdown": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'expired']),
  "evidence": zod.array(zod.object({
  "id": zod.uuid(),
  "sourceKind": zod.enum(['entity', 'attachment', 'public_web']),
  "sourceType": zod.string(),
  "sourceId": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "title": zod.string(),
  "authorizedLocation": zod.string().nullable(),
  "excerpt": zod.string(),
  "evidenceState": zod.enum(['available', 'missing', 'stale', 'conflicting', 'unavailable', 'unsupported']),
  "sourceTimestamp": zod.iso.datetime({"offset":true}).nullable(),
  "retrievedAt": zod.iso.datetime({"offset":true})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "resolvedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Requires entity.records.read.
 * @summary Get the validated sales-floor process definition
 */
export const getSalesFloorTwinDefinitionResponseStagesItemPositionMin = 3;
export const getSalesFloorTwinDefinitionResponseStagesItemPositionMax = 3;

export const getSalesFloorTwinDefinitionResponseStagesItemFootprintItemExclusiveMin = 0;

export const getSalesFloorTwinDefinitionResponseStagesItemFootprintMin = 2;
export const getSalesFloorTwinDefinitionResponseStagesItemFootprintMax = 2;

export const getSalesFloorTwinDefinitionResponseStagesItemDefaultCycleSecondsExclusiveMin = 0;

export const getSalesFloorTwinDefinitionResponseStagesMin = 9;
export const getSalesFloorTwinDefinitionResponseStagesMax = 9;

export const getSalesFloorTwinDefinitionResponseChannelsItemPositionMin = 3;
export const getSalesFloorTwinDefinitionResponseChannelsItemPositionMax = 3;

export const getSalesFloorTwinDefinitionResponseChannelsMin = 4;
export const getSalesFloorTwinDefinitionResponseChannelsMax = 4;

export const getSalesFloorTwinDefinitionResponseFlowsItemTravelSecondsExclusiveMin = 0;

export const getSalesFloorTwinDefinitionResponseWorkersItemIdMin = 4;
export const getSalesFloorTwinDefinitionResponseWorkersItemIdMax = 128;


export const getSalesFloorTwinDefinitionResponseWorkersItemIdRegExp = new RegExp('^[A-Za-z0-9._:-]+$');
export const getSalesFloorTwinDefinitionResponseWorkersItemPositionMin = 3;
export const getSalesFloorTwinDefinitionResponseWorkersItemPositionMax = 3;





export const getSalesFloorTwinDefinitionResponse = zod.object({
  "id": zod.enum(['pmf-sales-floor']),
  "name": zod.string(),
  "stages": zod.array(zod.object({
  "id": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "name": zod.string(),
  "shortLabel": zod.string(),
  "description": zod.string(),
  "position": zod.array(zod.number()).min(getSalesFloorTwinDefinitionResponseStagesItemPositionMin).max(getSalesFloorTwinDefinitionResponseStagesItemPositionMax),
  "footprint": zod.array(zod.number().gt(getSalesFloorTwinDefinitionResponseStagesItemFootprintItemExclusiveMin)).min(getSalesFloorTwinDefinitionResponseStagesItemFootprintMin).max(getSalesFloorTwinDefinitionResponseStagesItemFootprintMax),
  "defaultCycleSeconds": zod.number().gt(getSalesFloorTwinDefinitionResponseStagesItemDefaultCycleSecondsExclusiveMin),
  "workedBy": zod.enum(['people', 'agents', 'both']),
  "approvalRule": zod.object({
  "kind": zod.enum(['value-threshold']),
  "approverRole": zod.enum(['sales-manager']),
  "description": zod.string()
}).optional()
})).min(getSalesFloorTwinDefinitionResponseStagesMin).max(getSalesFloorTwinDefinitionResponseStagesMax),
  "channels": zod.array(zod.object({
  "id": zod.enum(['social', 'email', 'web', 'phone']),
  "name": zod.string(),
  "position": zod.array(zod.number()).min(getSalesFloorTwinDefinitionResponseChannelsItemPositionMin).max(getSalesFloorTwinDefinitionResponseChannelsItemPositionMax)
})).min(getSalesFloorTwinDefinitionResponseChannelsMin).max(getSalesFloorTwinDefinitionResponseChannelsMax),
  "flows": zod.array(zod.object({
  "id": zod.string(),
  "from": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "to": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "label": zod.string(),
  "travelSeconds": zod.number().gt(getSalesFloorTwinDefinitionResponseFlowsItemTravelSecondsExclusiveMin),
  "kind": zod.enum(['forward', 'clarification', 'revision', 'exit']),
  "isLoop": zod.boolean().optional(),
  "via": zod.enum(['customer-clarification', 'handover', 'archive']).optional()
})),
  "workers": zod.array(zod.object({
  "id": zod.string().min(getSalesFloorTwinDefinitionResponseWorkersItemIdMin).max(getSalesFloorTwinDefinitionResponseWorkersItemIdMax).regex(getSalesFloorTwinDefinitionResponseWorkersItemIdRegExp),
  "name": zod.string(),
  "kind": zod.enum(['person', 'agent']),
  "role": zod.enum(['sales-coordinator', 'sales-manager', 'events-specialist', 'intake-triage-agent', 'response-drafting-agent', 'pricing-agent', 'follow-up-agent']),
  "homeStage": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "position": zod.array(zod.number()).min(getSalesFloorTwinDefinitionResponseWorkersItemPositionMin).max(getSalesFloorTwinDefinitionResponseWorkersItemPositionMax),
  "canWork": zod.array(zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost'])).min(1),
  "coordinatorNumber": zod.int().min(1).optional()
}))
})


/**
 * Requires entity.records.read. The response is capped at 400 enquiry tokens and 200 events.
 * @summary Get a bounded operational snapshot of enquiries and linked opportunities
 */
export const getSalesFloorTwinSnapshotQueryWindowDefault = `7d`;
export const getSalesFloorTwinSnapshotQueryIncludeTestDataDefault = false;

export const getSalesFloorTwinSnapshotQueryParams = zod.object({
  "window": zod.enum(['24h', '7d', '30d']).default(getSalesFloorTwinSnapshotQueryWindowDefault),
  "audience": zod.enum(['b2b', 'b2c', 'partner', 'investor']).optional(),
  "pipeline": zod.enum(['b2b_sales', 'b2c_sales', 'investor_funding']).optional(),
  "includeTestData": zod.boolean().default(getSalesFloorTwinSnapshotQueryIncludeTestDataDefault).describe('Include records flagged as test or demo data. They are excluded by default.')
})

export const getSalesFloorTwinSnapshotResponseSeedMin = 0;

export const getSalesFloorTwinSnapshotResponseElapsedSecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseLeversEnquiriesPerHourMin = 0;

export const getSalesFloorTwinSnapshotResponseLeversAgentShareMin = 0;
export const getSalesFloorTwinSnapshotResponseLeversAgentShareMax = 1;

export const getSalesFloorTwinSnapshotResponseLeversCoordinatorsOnShiftMin = 0;

export const getSalesFloorTwinSnapshotResponseLeversApprovalThresholdMin = 0;

export const getSalesFloorTwinSnapshotResponseStagesQueueDepthMin = 0;

export const getSalesFloorTwinSnapshotResponseStagesInProgressMin = 0;

export const getSalesFloorTwinSnapshotResponseStagesCompletedMin = 0;

export const getSalesFloorTwinSnapshotResponseWorkersItemCompletedWorkItemsMin = 0;

export const getSalesFloorTwinSnapshotResponseWorkersItemBusySecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemIdMin = 4;
export const getSalesFloorTwinSnapshotResponseEnquiriesItemIdMax = 128;


export const getSalesFloorTwinSnapshotResponseEnquiriesItemIdRegExp = new RegExp('^[A-Za-z0-9._:-]+$');
export const getSalesFloorTwinSnapshotResponseEnquiriesItemPartySizeMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemEstimatedValueAudMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemArrivalTimestampMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemProgressMin = 0;
export const getSalesFloorTwinSnapshotResponseEnquiriesItemProgressMax = 1;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemQueueEnteredAtMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemProcessingStartedAtMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemProcessingRemainingSecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemProcessingDurationSecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemFlowRemainingSecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemWaitUntilSecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemClarificationCountMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemRevisionCountMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemQuoteSentAtMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemQuoteSentCountMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemHistoryItemAtSecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseEnquiriesItemHistoryMax = 20;

export const getSalesFloorTwinSnapshotResponseEnquiriesMax = 400;

export const getSalesFloorTwinSnapshotResponseEnquiryPositionsItemProgressMin = 0;
export const getSalesFloorTwinSnapshotResponseEnquiryPositionsItemProgressMax = 1;

export const getSalesFloorTwinSnapshotResponseEnquiryPositionsMax = 400;

export const getSalesFloorTwinSnapshotResponseLedgerArrivedMin = 0;

export const getSalesFloorTwinSnapshotResponseLedgerDroppedMin = 0;

export const getSalesFloorTwinSnapshotResponseLedgerOutstandingMin = 0;

export const getSalesFloorTwinSnapshotResponseLedgerInProgressMin = 0;

export const getSalesFloorTwinSnapshotResponseLedgerCompletedToQuoteMin = 0;

export const getSalesFloorTwinSnapshotResponseLedgerWonMin = 0;

export const getSalesFloorTwinSnapshotResponseLedgerLostMin = 0;

export const getSalesFloorTwinSnapshotResponseLedgerSlaBreachesMin = 0;

export const getSalesFloorTwinSnapshotResponseReadingsEnquiriesOutstandingMin = 0;

export const getSalesFloorTwinSnapshotResponseReadingsQuotesSentPerHourMin = 0;

export const getSalesFloorTwinSnapshotResponseReadingsAverageTimeToQuoteSecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseReadingsWinRateMin = 0;
export const getSalesFloorTwinSnapshotResponseReadingsWinRateMax = 1;

export const getSalesFloorTwinSnapshotResponseReadingsAgentWorkloadPercentMin = 0;
export const getSalesFloorTwinSnapshotResponseReadingsAgentWorkloadPercentMax = 100;

export const getSalesFloorTwinSnapshotResponseReadingsHumanWorkloadPercentMin = 0;
export const getSalesFloorTwinSnapshotResponseReadingsHumanWorkloadPercentMax = 100;

export const getSalesFloorTwinSnapshotResponseReadingsSlaBreachesMin = 0;

export const getSalesFloorTwinSnapshotResponseReadingsWonValueAudMin = 0;

export const getSalesFloorTwinSnapshotResponseReadingsAverageTimeInStageSecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseReadingsStageCountsMinOne = 0;

export const getSalesFloorTwinSnapshotResponseReadingsHistoryItemMin = 0;

export const getSalesFloorTwinSnapshotResponseRecentEventsItemAtSecondsMin = 0;

export const getSalesFloorTwinSnapshotResponseRecentEventsMax = 200;

export const getSalesFloorTwinSnapshotResponseTotalsMatchingEnquiriesMin = 0;

export const getSalesFloorTwinSnapshotResponseTotalsReturnedEnquiriesMin = 0;
export const getSalesFloorTwinSnapshotResponseTotalsReturnedEnquiriesMax = 400;

export const getSalesFloorTwinSnapshotResponseTotalsMatchingEventsMin = 0;

export const getSalesFloorTwinSnapshotResponseTotalsReturnedEventsMin = 0;
export const getSalesFloorTwinSnapshotResponseTotalsReturnedEventsMax = 200;

export const getSalesFloorTwinSnapshotResponseTotalsWonValueAudMin = 0;



export const getSalesFloorTwinSnapshotResponse = zod.object({
  "definitionId": zod.enum(['pmf-sales-floor']),
  "scenarioId": zod.enum(['agent-assisted']),
  "seed": zod.int().min(getSalesFloorTwinSnapshotResponseSeedMin),
  "elapsedSeconds": zod.number().min(getSalesFloorTwinSnapshotResponseElapsedSecondsMin),
  "levers": zod.object({
  "enquiriesPerHour": zod.number().min(getSalesFloorTwinSnapshotResponseLeversEnquiriesPerHourMin),
  "agentShare": zod.number().min(getSalesFloorTwinSnapshotResponseLeversAgentShareMin).max(getSalesFloorTwinSnapshotResponseLeversAgentShareMax),
  "coordinatorsOnShift": zod.int().min(getSalesFloorTwinSnapshotResponseLeversCoordinatorsOnShiftMin),
  "approvalThreshold": zod.number().min(getSalesFloorTwinSnapshotResponseLeversApprovalThresholdMin),
  "speed": zod.literal(1),
  "paused": zod.boolean()
}),
  "stages": zod.record(zod.string(), zod.object({
  "id": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "queueDepth": zod.int().min(getSalesFloorTwinSnapshotResponseStagesQueueDepthMin),
  "inProgress": zod.int().min(getSalesFloorTwinSnapshotResponseStagesInProgressMin),
  "completed": zod.int().min(getSalesFloorTwinSnapshotResponseStagesCompletedMin)
})),
  "workers": zod.array(zod.object({
  "id": zod.string(),
  "name": zod.string(),
  "kind": zod.enum(['person', 'agent']),
  "role": zod.string(),
  "homeStage": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "active": zod.boolean(),
  "state": zod.enum(['idle', 'working', 'processing']),
  "currentEnquiryId": zod.string().nullable(),
  "completedWorkItems": zod.int().min(getSalesFloorTwinSnapshotResponseWorkersItemCompletedWorkItemsMin),
  "busySeconds": zod.number().min(getSalesFloorTwinSnapshotResponseWorkersItemBusySecondsMin)
})),
  "enquiries": zod.array(zod.object({
  "id": zod.string().min(getSalesFloorTwinSnapshotResponseEnquiriesItemIdMin).max(getSalesFloorTwinSnapshotResponseEnquiriesItemIdMax).regex(getSalesFloorTwinSnapshotResponseEnquiriesItemIdRegExp),
  "type": zod.enum(['group-ski-booking', 'corporate-retreat', 'wedding-event', 'school-trip', 'season-pass-query', 'accommodation-only']),
  "channel": zod.enum(['social', 'email', 'web', 'phone']),
  "customerName": zod.string(),
  "organisationName": zod.string().nullable(),
  "partySize": zod.int().min(getSalesFloorTwinSnapshotResponseEnquiriesItemPartySizeMin),
  "estimatedValueAud": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemEstimatedValueAudMin),
  "valueBand": zod.enum(['under-5k', '5k-15k', '15k-40k', '40k-plus']),
  "priority": zod.enum(['standard', 'high', 'urgent']),
  "arrivalTimestamp": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemArrivalTimestampMin),
  "quality": zod.enum(['genuine', 'spam', 'duplicate']),
  "phase": zod.enum(['queued', 'processing', 'flow', 'waiting', 'completed', 'dropped']),
  "stageId": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "assignedWorkerId": zod.string().nullable(),
  "fromStageId": zod.union([zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),zod.null()]),
  "toStageId": zod.union([zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),zod.null()]),
  "flowId": zod.string().nullable(),
  "progress": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemProgressMin).max(getSalesFloorTwinSnapshotResponseEnquiriesItemProgressMax),
  "queueEnteredAt": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemQueueEnteredAtMin),
  "processingStartedAt": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemProcessingStartedAtMin).nullable(),
  "processingRemainingSeconds": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemProcessingRemainingSecondsMin),
  "processingDurationSeconds": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemProcessingDurationSecondsMin),
  "flowRemainingSeconds": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemFlowRemainingSecondsMin),
  "waitUntilSeconds": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemWaitUntilSecondsMin).nullable(),
  "approvalPending": zod.boolean(),
  "approved": zod.boolean(),
  "clarificationCount": zod.int().min(getSalesFloorTwinSnapshotResponseEnquiriesItemClarificationCountMin),
  "revisionCount": zod.int().min(getSalesFloorTwinSnapshotResponseEnquiriesItemRevisionCountMin),
  "quoteSentAt": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemQuoteSentAtMin).nullable(),
  "quoteSentCount": zod.int().min(getSalesFloorTwinSnapshotResponseEnquiriesItemQuoteSentCountMin),
  "slaBreached": zod.boolean(),
  "history": zod.array(zod.object({
  "atSeconds": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiriesItemHistoryItemAtSecondsMin),
  "type": zod.enum(['arrived', 'entered', 'started', 'completed', 'clarification', 'approved', 'quote-sent', 'won', 'lost', 'dropped']),
  "stageId": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "workerId": zod.string().nullable(),
  "note": zod.string()
})).max(getSalesFloorTwinSnapshotResponseEnquiriesItemHistoryMax)
})).max(getSalesFloorTwinSnapshotResponseEnquiriesMax),
  "enquiryPositions": zod.array(zod.object({
  "enquiryId": zod.string(),
  "phase": zod.enum(['processing', 'completed']),
  "stageId": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "fromStageId": zod.union([zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),zod.null()]),
  "toStageId": zod.union([zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),zod.null()]),
  "progress": zod.number().min(getSalesFloorTwinSnapshotResponseEnquiryPositionsItemProgressMin).max(getSalesFloorTwinSnapshotResponseEnquiryPositionsItemProgressMax)
})).max(getSalesFloorTwinSnapshotResponseEnquiryPositionsMax),
  "ledger": zod.object({
  "arrived": zod.int().min(getSalesFloorTwinSnapshotResponseLedgerArrivedMin),
  "dropped": zod.int().min(getSalesFloorTwinSnapshotResponseLedgerDroppedMin),
  "outstanding": zod.int().min(getSalesFloorTwinSnapshotResponseLedgerOutstandingMin),
  "inProgress": zod.int().min(getSalesFloorTwinSnapshotResponseLedgerInProgressMin),
  "completedToQuote": zod.int().min(getSalesFloorTwinSnapshotResponseLedgerCompletedToQuoteMin),
  "won": zod.int().min(getSalesFloorTwinSnapshotResponseLedgerWonMin),
  "lost": zod.int().min(getSalesFloorTwinSnapshotResponseLedgerLostMin),
  "slaBreaches": zod.int().min(getSalesFloorTwinSnapshotResponseLedgerSlaBreachesMin)
}),
  "readings": zod.object({
  "enquiriesOutstanding": zod.int().min(getSalesFloorTwinSnapshotResponseReadingsEnquiriesOutstandingMin),
  "quotesSentPerHour": zod.number().min(getSalesFloorTwinSnapshotResponseReadingsQuotesSentPerHourMin),
  "averageTimeToQuoteSeconds": zod.number().min(getSalesFloorTwinSnapshotResponseReadingsAverageTimeToQuoteSecondsMin),
  "winRate": zod.number().min(getSalesFloorTwinSnapshotResponseReadingsWinRateMin).max(getSalesFloorTwinSnapshotResponseReadingsWinRateMax),
  "agentWorkloadPercent": zod.number().min(getSalesFloorTwinSnapshotResponseReadingsAgentWorkloadPercentMin).max(getSalesFloorTwinSnapshotResponseReadingsAgentWorkloadPercentMax),
  "humanWorkloadPercent": zod.number().min(getSalesFloorTwinSnapshotResponseReadingsHumanWorkloadPercentMin).max(getSalesFloorTwinSnapshotResponseReadingsHumanWorkloadPercentMax),
  "slaBreaches": zod.int().min(getSalesFloorTwinSnapshotResponseReadingsSlaBreachesMin),
  "wonValueAud": zod.number().min(getSalesFloorTwinSnapshotResponseReadingsWonValueAudMin),
  "averageTimeInStageSeconds": zod.number().min(getSalesFloorTwinSnapshotResponseReadingsAverageTimeInStageSecondsMin),
  "stageCounts": zod.record(zod.string(), zod.int().min(getSalesFloorTwinSnapshotResponseReadingsStageCountsMinOne)),
  "history": zod.record(zod.string(), zod.array(zod.number().min(getSalesFloorTwinSnapshotResponseReadingsHistoryItemMin)))
}),
  "recentEvents": zod.array(zod.object({
  "id": zod.string(),
  "atSeconds": zod.number().min(getSalesFloorTwinSnapshotResponseRecentEventsItemAtSecondsMin),
  "type": zod.enum(['arrived', 'triaged', 'clarification-requested', 'quote-approved', 'quote-sent', 'won', 'lost']),
  "enquiryId": zod.string(),
  "stageId": zod.enum(['intake', 'triage', 'review', 'response', 'quote', 'quoteSent', 'followUp', 'won', 'lost']),
  "message": zod.string()
})).max(getSalesFloorTwinSnapshotResponseRecentEventsMax),
  "engine": zod.record(zod.string(), zod.unknown()),
  "truncated": zod.boolean(),
  "totals": zod.object({
  "matchingEnquiries": zod.int().min(getSalesFloorTwinSnapshotResponseTotalsMatchingEnquiriesMin),
  "returnedEnquiries": zod.int().min(getSalesFloorTwinSnapshotResponseTotalsReturnedEnquiriesMin).max(getSalesFloorTwinSnapshotResponseTotalsReturnedEnquiriesMax),
  "matchingEvents": zod.int().min(getSalesFloorTwinSnapshotResponseTotalsMatchingEventsMin),
  "returnedEvents": zod.int().min(getSalesFloorTwinSnapshotResponseTotalsReturnedEventsMin).max(getSalesFloorTwinSnapshotResponseTotalsReturnedEventsMax),
  "wonValueAud": zod.number().min(getSalesFloorTwinSnapshotResponseTotalsWonValueAudMin)
}),
  "generatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary List safe basemap and address-lookup readiness
 */
export const listGeographicProvidersResponse = zod.object({
  "basemaps": zod.array(zod.object({
  "id": zod.enum(['openstreetmap', 'azure_maps', 'manual', 'azure_geocoding']),
  "label": zod.string(),
  "kind": zod.enum(['basemap', 'geocoder']),
  "ready": zod.boolean(),
  "status": zod.enum(['ready', 'setup_required', 'unavailable']),
  "message": zod.string().optional(),
  "attribution": zod.string()
})),
  "geocoders": zod.array(zod.object({
  "id": zod.enum(['openstreetmap', 'azure_maps', 'manual', 'azure_geocoding']),
  "label": zod.string(),
  "kind": zod.enum(['basemap', 'geocoder']),
  "ready": zod.boolean(),
  "status": zod.enum(['ready', 'setup_required', 'unavailable']),
  "message": zod.string().optional(),
  "attribution": zod.string()
})),
  "defaultBasemap": zod.enum(['openstreetmap'])
})


/**
 * @summary Proxy one authorized Azure Maps viewport tile without exposing credentials
 */
export const getAzureGeographicBasemapTilePathZMin = 0;
export const getAzureGeographicBasemapTilePathZMax = 22;

export const getAzureGeographicBasemapTilePathXMin = 0;

export const getAzureGeographicBasemapTilePathYMin = 0;



export const getAzureGeographicBasemapTileParams = zod.object({
  "z": zod.int().min(getAzureGeographicBasemapTilePathZMin).max(getAzureGeographicBasemapTilePathZMax),
  "x": zod.int().min(getAzureGeographicBasemapTilePathXMin),
  "y": zod.int().min(getAzureGeographicBasemapTilePathYMin)
})

export const getAzureGeographicBasemapTileResponse = zod.unknown()


export const listGeographicLayersQueryLimitDefault = 50;
export const listGeographicLayersQueryLimitMax = 100;

export const listGeographicLayersQueryOffsetDefault = 0;
export const listGeographicLayersQueryOffsetMin = 0;



export const listGeographicLayersQueryParams = zod.object({
  "limit": zod.int().min(1).max(listGeographicLayersQueryLimitMax).default(listGeographicLayersQueryLimitDefault),
  "offset": zod.int().min(listGeographicLayersQueryOffsetMin).default(listGeographicLayersQueryOffsetDefault)
})


export const listGeographicLayersResponseItemsItemFeatureCountMin = 0;

export const listGeographicLayersResponseTotalMin = 0;

export const listGeographicLayersResponseLimitMax = 100;

export const listGeographicLayersResponseOffsetMin = 0;



export const listGeographicLayersResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "sourceType": zod.enum(['custom', 'crm', 'csv', 'geojson', 'kml', 'shapefile']),
  "visibleByDefault": zod.boolean(),
  "version": zod.int().min(1),
  "featureCount": zod.int().min(listGeographicLayersResponseItemsItemFeatureCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listGeographicLayersResponseTotalMin),
  "limit": zod.int().min(1).max(listGeographicLayersResponseLimitMax),
  "offset": zod.int().min(listGeographicLayersResponseOffsetMin)
})


export const createGeographicLayerBodyNameMax = 120;

export const createGeographicLayerBodyDescriptionMax = 2000;

export const createGeographicLayerBodyVisibleByDefaultDefault = true;

export const createGeographicLayerBody = zod.object({
  "name": zod.string().min(1).max(createGeographicLayerBodyNameMax),
  "description": zod.string().max(createGeographicLayerBodyDescriptionMax).nullish(),
  "visibleByDefault": zod.boolean().default(createGeographicLayerBodyVisibleByDefaultDefault)
})


export const createGeographicLayerResponseFeatureCountMin = 0;



export const createGeographicLayerResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "sourceType": zod.enum(['custom', 'crm', 'csv', 'geojson', 'kml', 'shapefile']),
  "visibleByDefault": zod.boolean(),
  "version": zod.int().min(1),
  "featureCount": zod.int().min(createGeographicLayerResponseFeatureCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const updateGeographicLayerParams = zod.object({
  "id": zod.uuid()
})


export const updateGeographicLayerBodyNameMax = 120;

export const updateGeographicLayerBodyDescriptionMax = 2000;



export const updateGeographicLayerBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "name": zod.string().min(1).max(updateGeographicLayerBodyNameMax).optional(),
  "description": zod.string().max(updateGeographicLayerBodyDescriptionMax).nullish(),
  "visibleByDefault": zod.boolean().optional()
})


export const updateGeographicLayerResponseFeatureCountMin = 0;



export const updateGeographicLayerResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "description": zod.string().nullish(),
  "sourceType": zod.enum(['custom', 'crm', 'csv', 'geojson', 'kml', 'shapefile']),
  "visibleByDefault": zod.boolean(),
  "version": zod.int().min(1),
  "featureCount": zod.int().min(updateGeographicLayerResponseFeatureCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const deleteGeographicLayerParams = zod.object({
  "id": zod.uuid()
})




export const deleteGeographicLayerQueryParams = zod.object({
  "expectedVersion": zod.int().min(1)
})

export const deleteGeographicLayerResponse = zod.void()


export const listGeographicFeaturesQuerySearchMax = 200;

export const listGeographicFeaturesQueryMinLongitudeMin = -180;
export const listGeographicFeaturesQueryMinLongitudeMax = 180;

export const listGeographicFeaturesQueryMinLatitudeMin = -90;
export const listGeographicFeaturesQueryMinLatitudeMax = 90;

export const listGeographicFeaturesQueryMaxLongitudeMin = -180;
export const listGeographicFeaturesQueryMaxLongitudeMax = 180;

export const listGeographicFeaturesQueryMaxLatitudeMin = -90;
export const listGeographicFeaturesQueryMaxLatitudeMax = 90;

export const listGeographicFeaturesQueryLimitDefault = 50;
export const listGeographicFeaturesQueryLimitMax = 100;

export const listGeographicFeaturesQueryOffsetDefault = 0;
export const listGeographicFeaturesQueryOffsetMin = 0;



export const listGeographicFeaturesQueryParams = zod.object({
  "layerId": zod.uuid().optional(),
  "recordType": zod.enum(['account', 'contact', 'enquiry', 'opportunity']).optional(),
  "recordId": zod.uuid().optional(),
  "search": zod.string().max(listGeographicFeaturesQuerySearchMax).optional(),
  "minLongitude": zod.number().min(listGeographicFeaturesQueryMinLongitudeMin).max(listGeographicFeaturesQueryMinLongitudeMax).optional(),
  "minLatitude": zod.number().min(listGeographicFeaturesQueryMinLatitudeMin).max(listGeographicFeaturesQueryMinLatitudeMax).optional(),
  "maxLongitude": zod.number().min(listGeographicFeaturesQueryMaxLongitudeMin).max(listGeographicFeaturesQueryMaxLongitudeMax).optional(),
  "maxLatitude": zod.number().min(listGeographicFeaturesQueryMaxLatitudeMin).max(listGeographicFeaturesQueryMaxLatitudeMax).optional(),
  "limit": zod.int().min(1).max(listGeographicFeaturesQueryLimitMax).default(listGeographicFeaturesQueryLimitDefault),
  "offset": zod.int().min(listGeographicFeaturesQueryOffsetMin).default(listGeographicFeaturesQueryOffsetDefault)
})

export const listGeographicFeaturesResponseItemsItemGeometryOneCoordinatesMin = 2;
export const listGeographicFeaturesResponseItemsItemGeometryOneCoordinatesMax = 2;

export const listGeographicFeaturesResponseItemsItemGeometryTwoCoordinatesItemMin = 2;
export const listGeographicFeaturesResponseItemsItemGeometryTwoCoordinatesItemMax = 2;

export const listGeographicFeaturesResponseItemsItemGeometryTwoCoordinatesMin = 2;
export const listGeographicFeaturesResponseItemsItemGeometryTwoCoordinatesMax = 10000;

export const listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesItemItemMin = 2;
export const listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesItemItemMax = 2;

export const listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesItemMin = 4;
export const listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesItemMax = 10000;

export const listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesMax = 100;

export const listGeographicFeaturesResponseItemsItemLinksMax = 20;


export const listGeographicFeaturesResponseTotalMin = 0;

export const listGeographicFeaturesResponseLimitMax = 500;

export const listGeographicFeaturesResponseOffsetMin = 0;



export const listGeographicFeaturesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "layerId": zod.uuid(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "geometry": zod.union([zod.object({
  "type": zod.enum(['Point']),
  "coordinates": zod.array(zod.number()).min(listGeographicFeaturesResponseItemsItemGeometryOneCoordinatesMin).max(listGeographicFeaturesResponseItemsItemGeometryOneCoordinatesMax)
}),zod.object({
  "type": zod.enum(['LineString']),
  "coordinates": zod.array(zod.array(zod.number()).min(listGeographicFeaturesResponseItemsItemGeometryTwoCoordinatesItemMin).max(listGeographicFeaturesResponseItemsItemGeometryTwoCoordinatesItemMax)).min(listGeographicFeaturesResponseItemsItemGeometryTwoCoordinatesMin).max(listGeographicFeaturesResponseItemsItemGeometryTwoCoordinatesMax)
}),zod.object({
  "type": zod.enum(['Polygon']),
  "coordinates": zod.array(zod.array(zod.array(zod.number()).min(listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesItemItemMin).max(listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesItemItemMax)).min(listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesItemMin).max(listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesItemMax)).min(1).max(listGeographicFeaturesResponseItemsItemGeometryThreeCoordinatesMax)
})]),
  "properties": zod.record(zod.string(), zod.unknown()),
  "links": zod.array(zod.object({
  "recordType": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid()
})).max(listGeographicFeaturesResponseItemsItemLinksMax),
  "sourceFeatureId": zod.string().nullish(),
  "version": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listGeographicFeaturesResponseTotalMin),
  "limit": zod.int().min(1).max(listGeographicFeaturesResponseLimitMax),
  "offset": zod.int().min(listGeographicFeaturesResponseOffsetMin),
  "bounded": zod.boolean()
})


export const createGeographicFeatureBodyLabelMax = 200;

export const createGeographicFeatureBodyDescriptionMax = 5000;

export const createGeographicFeatureBodyGeometryOneCoordinatesMin = 2;
export const createGeographicFeatureBodyGeometryOneCoordinatesMax = 2;

export const createGeographicFeatureBodyGeometryTwoCoordinatesItemMin = 2;
export const createGeographicFeatureBodyGeometryTwoCoordinatesItemMax = 2;

export const createGeographicFeatureBodyGeometryTwoCoordinatesMin = 2;
export const createGeographicFeatureBodyGeometryTwoCoordinatesMax = 10000;

export const createGeographicFeatureBodyGeometryThreeCoordinatesItemItemMin = 2;
export const createGeographicFeatureBodyGeometryThreeCoordinatesItemItemMax = 2;

export const createGeographicFeatureBodyGeometryThreeCoordinatesItemMin = 4;
export const createGeographicFeatureBodyGeometryThreeCoordinatesItemMax = 10000;

export const createGeographicFeatureBodyGeometryThreeCoordinatesMax = 100;

export const createGeographicFeatureBodyLinksMax = 20;



export const createGeographicFeatureBody = zod.object({
  "layerId": zod.uuid(),
  "label": zod.string().min(1).max(createGeographicFeatureBodyLabelMax),
  "description": zod.string().max(createGeographicFeatureBodyDescriptionMax).nullish(),
  "geometry": zod.union([zod.object({
  "type": zod.enum(['Point']),
  "coordinates": zod.array(zod.number()).min(createGeographicFeatureBodyGeometryOneCoordinatesMin).max(createGeographicFeatureBodyGeometryOneCoordinatesMax)
}),zod.object({
  "type": zod.enum(['LineString']),
  "coordinates": zod.array(zod.array(zod.number()).min(createGeographicFeatureBodyGeometryTwoCoordinatesItemMin).max(createGeographicFeatureBodyGeometryTwoCoordinatesItemMax)).min(createGeographicFeatureBodyGeometryTwoCoordinatesMin).max(createGeographicFeatureBodyGeometryTwoCoordinatesMax)
}),zod.object({
  "type": zod.enum(['Polygon']),
  "coordinates": zod.array(zod.array(zod.array(zod.number()).min(createGeographicFeatureBodyGeometryThreeCoordinatesItemItemMin).max(createGeographicFeatureBodyGeometryThreeCoordinatesItemItemMax)).min(createGeographicFeatureBodyGeometryThreeCoordinatesItemMin).max(createGeographicFeatureBodyGeometryThreeCoordinatesItemMax)).min(1).max(createGeographicFeatureBodyGeometryThreeCoordinatesMax)
})]),
  "properties": zod.record(zod.string(), zod.unknown()).optional(),
  "links": zod.array(zod.object({
  "recordType": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid()
})).max(createGeographicFeatureBodyLinksMax).optional()
})

export const createGeographicFeatureResponseGeometryOneCoordinatesMin = 2;
export const createGeographicFeatureResponseGeometryOneCoordinatesMax = 2;

export const createGeographicFeatureResponseGeometryTwoCoordinatesItemMin = 2;
export const createGeographicFeatureResponseGeometryTwoCoordinatesItemMax = 2;

export const createGeographicFeatureResponseGeometryTwoCoordinatesMin = 2;
export const createGeographicFeatureResponseGeometryTwoCoordinatesMax = 10000;

export const createGeographicFeatureResponseGeometryThreeCoordinatesItemItemMin = 2;
export const createGeographicFeatureResponseGeometryThreeCoordinatesItemItemMax = 2;

export const createGeographicFeatureResponseGeometryThreeCoordinatesItemMin = 4;
export const createGeographicFeatureResponseGeometryThreeCoordinatesItemMax = 10000;

export const createGeographicFeatureResponseGeometryThreeCoordinatesMax = 100;

export const createGeographicFeatureResponseLinksMax = 20;




export const createGeographicFeatureResponse = zod.object({
  "id": zod.uuid(),
  "layerId": zod.uuid(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "geometry": zod.union([zod.object({
  "type": zod.enum(['Point']),
  "coordinates": zod.array(zod.number()).min(createGeographicFeatureResponseGeometryOneCoordinatesMin).max(createGeographicFeatureResponseGeometryOneCoordinatesMax)
}),zod.object({
  "type": zod.enum(['LineString']),
  "coordinates": zod.array(zod.array(zod.number()).min(createGeographicFeatureResponseGeometryTwoCoordinatesItemMin).max(createGeographicFeatureResponseGeometryTwoCoordinatesItemMax)).min(createGeographicFeatureResponseGeometryTwoCoordinatesMin).max(createGeographicFeatureResponseGeometryTwoCoordinatesMax)
}),zod.object({
  "type": zod.enum(['Polygon']),
  "coordinates": zod.array(zod.array(zod.array(zod.number()).min(createGeographicFeatureResponseGeometryThreeCoordinatesItemItemMin).max(createGeographicFeatureResponseGeometryThreeCoordinatesItemItemMax)).min(createGeographicFeatureResponseGeometryThreeCoordinatesItemMin).max(createGeographicFeatureResponseGeometryThreeCoordinatesItemMax)).min(1).max(createGeographicFeatureResponseGeometryThreeCoordinatesMax)
})]),
  "properties": zod.record(zod.string(), zod.unknown()),
  "links": zod.array(zod.object({
  "recordType": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid()
})).max(createGeographicFeatureResponseLinksMax),
  "sourceFeatureId": zod.string().nullish(),
  "version": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getGeographicFeatureParams = zod.object({
  "id": zod.uuid()
})

export const getGeographicFeatureResponseGeometryOneCoordinatesMin = 2;
export const getGeographicFeatureResponseGeometryOneCoordinatesMax = 2;

export const getGeographicFeatureResponseGeometryTwoCoordinatesItemMin = 2;
export const getGeographicFeatureResponseGeometryTwoCoordinatesItemMax = 2;

export const getGeographicFeatureResponseGeometryTwoCoordinatesMin = 2;
export const getGeographicFeatureResponseGeometryTwoCoordinatesMax = 10000;

export const getGeographicFeatureResponseGeometryThreeCoordinatesItemItemMin = 2;
export const getGeographicFeatureResponseGeometryThreeCoordinatesItemItemMax = 2;

export const getGeographicFeatureResponseGeometryThreeCoordinatesItemMin = 4;
export const getGeographicFeatureResponseGeometryThreeCoordinatesItemMax = 10000;

export const getGeographicFeatureResponseGeometryThreeCoordinatesMax = 100;

export const getGeographicFeatureResponseLinksMax = 20;




export const getGeographicFeatureResponse = zod.object({
  "id": zod.uuid(),
  "layerId": zod.uuid(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "geometry": zod.union([zod.object({
  "type": zod.enum(['Point']),
  "coordinates": zod.array(zod.number()).min(getGeographicFeatureResponseGeometryOneCoordinatesMin).max(getGeographicFeatureResponseGeometryOneCoordinatesMax)
}),zod.object({
  "type": zod.enum(['LineString']),
  "coordinates": zod.array(zod.array(zod.number()).min(getGeographicFeatureResponseGeometryTwoCoordinatesItemMin).max(getGeographicFeatureResponseGeometryTwoCoordinatesItemMax)).min(getGeographicFeatureResponseGeometryTwoCoordinatesMin).max(getGeographicFeatureResponseGeometryTwoCoordinatesMax)
}),zod.object({
  "type": zod.enum(['Polygon']),
  "coordinates": zod.array(zod.array(zod.array(zod.number()).min(getGeographicFeatureResponseGeometryThreeCoordinatesItemItemMin).max(getGeographicFeatureResponseGeometryThreeCoordinatesItemItemMax)).min(getGeographicFeatureResponseGeometryThreeCoordinatesItemMin).max(getGeographicFeatureResponseGeometryThreeCoordinatesItemMax)).min(1).max(getGeographicFeatureResponseGeometryThreeCoordinatesMax)
})]),
  "properties": zod.record(zod.string(), zod.unknown()),
  "links": zod.array(zod.object({
  "recordType": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid()
})).max(getGeographicFeatureResponseLinksMax),
  "sourceFeatureId": zod.string().nullish(),
  "version": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const updateGeographicFeatureParams = zod.object({
  "id": zod.uuid()
})

export const updateGeographicFeatureBodyOneLabelMax = 200;

export const updateGeographicFeatureBodyOneDescriptionMax = 5000;

export const updateGeographicFeatureBodyOneGeometryOneCoordinatesMin = 2;
export const updateGeographicFeatureBodyOneGeometryOneCoordinatesMax = 2;

export const updateGeographicFeatureBodyOneGeometryTwoCoordinatesItemMin = 2;
export const updateGeographicFeatureBodyOneGeometryTwoCoordinatesItemMax = 2;

export const updateGeographicFeatureBodyOneGeometryTwoCoordinatesMin = 2;
export const updateGeographicFeatureBodyOneGeometryTwoCoordinatesMax = 10000;

export const updateGeographicFeatureBodyOneGeometryThreeCoordinatesItemItemMin = 2;
export const updateGeographicFeatureBodyOneGeometryThreeCoordinatesItemItemMax = 2;

export const updateGeographicFeatureBodyOneGeometryThreeCoordinatesItemMin = 4;
export const updateGeographicFeatureBodyOneGeometryThreeCoordinatesItemMax = 10000;

export const updateGeographicFeatureBodyOneGeometryThreeCoordinatesMax = 100;

export const updateGeographicFeatureBodyOneLinksMax = 20;




export const updateGeographicFeatureBody = zod.object({
  "layerId": zod.uuid(),
  "label": zod.string().min(1).max(updateGeographicFeatureBodyOneLabelMax),
  "description": zod.string().max(updateGeographicFeatureBodyOneDescriptionMax).nullish(),
  "geometry": zod.union([zod.object({
  "type": zod.enum(['Point']),
  "coordinates": zod.array(zod.number()).min(updateGeographicFeatureBodyOneGeometryOneCoordinatesMin).max(updateGeographicFeatureBodyOneGeometryOneCoordinatesMax)
}),zod.object({
  "type": zod.enum(['LineString']),
  "coordinates": zod.array(zod.array(zod.number()).min(updateGeographicFeatureBodyOneGeometryTwoCoordinatesItemMin).max(updateGeographicFeatureBodyOneGeometryTwoCoordinatesItemMax)).min(updateGeographicFeatureBodyOneGeometryTwoCoordinatesMin).max(updateGeographicFeatureBodyOneGeometryTwoCoordinatesMax)
}),zod.object({
  "type": zod.enum(['Polygon']),
  "coordinates": zod.array(zod.array(zod.array(zod.number()).min(updateGeographicFeatureBodyOneGeometryThreeCoordinatesItemItemMin).max(updateGeographicFeatureBodyOneGeometryThreeCoordinatesItemItemMax)).min(updateGeographicFeatureBodyOneGeometryThreeCoordinatesItemMin).max(updateGeographicFeatureBodyOneGeometryThreeCoordinatesItemMax)).min(1).max(updateGeographicFeatureBodyOneGeometryThreeCoordinatesMax)
})]),
  "properties": zod.record(zod.string(), zod.unknown()).optional(),
  "links": zod.array(zod.object({
  "recordType": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid()
})).max(updateGeographicFeatureBodyOneLinksMax).optional()
}).and(zod.object({
  "expectedVersion": zod.int().min(1)
}))

export const updateGeographicFeatureResponseGeometryOneCoordinatesMin = 2;
export const updateGeographicFeatureResponseGeometryOneCoordinatesMax = 2;

export const updateGeographicFeatureResponseGeometryTwoCoordinatesItemMin = 2;
export const updateGeographicFeatureResponseGeometryTwoCoordinatesItemMax = 2;

export const updateGeographicFeatureResponseGeometryTwoCoordinatesMin = 2;
export const updateGeographicFeatureResponseGeometryTwoCoordinatesMax = 10000;

export const updateGeographicFeatureResponseGeometryThreeCoordinatesItemItemMin = 2;
export const updateGeographicFeatureResponseGeometryThreeCoordinatesItemItemMax = 2;

export const updateGeographicFeatureResponseGeometryThreeCoordinatesItemMin = 4;
export const updateGeographicFeatureResponseGeometryThreeCoordinatesItemMax = 10000;

export const updateGeographicFeatureResponseGeometryThreeCoordinatesMax = 100;

export const updateGeographicFeatureResponseLinksMax = 20;




export const updateGeographicFeatureResponse = zod.object({
  "id": zod.uuid(),
  "layerId": zod.uuid(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "geometry": zod.union([zod.object({
  "type": zod.enum(['Point']),
  "coordinates": zod.array(zod.number()).min(updateGeographicFeatureResponseGeometryOneCoordinatesMin).max(updateGeographicFeatureResponseGeometryOneCoordinatesMax)
}),zod.object({
  "type": zod.enum(['LineString']),
  "coordinates": zod.array(zod.array(zod.number()).min(updateGeographicFeatureResponseGeometryTwoCoordinatesItemMin).max(updateGeographicFeatureResponseGeometryTwoCoordinatesItemMax)).min(updateGeographicFeatureResponseGeometryTwoCoordinatesMin).max(updateGeographicFeatureResponseGeometryTwoCoordinatesMax)
}),zod.object({
  "type": zod.enum(['Polygon']),
  "coordinates": zod.array(zod.array(zod.array(zod.number()).min(updateGeographicFeatureResponseGeometryThreeCoordinatesItemItemMin).max(updateGeographicFeatureResponseGeometryThreeCoordinatesItemItemMax)).min(updateGeographicFeatureResponseGeometryThreeCoordinatesItemMin).max(updateGeographicFeatureResponseGeometryThreeCoordinatesItemMax)).min(1).max(updateGeographicFeatureResponseGeometryThreeCoordinatesMax)
})]),
  "properties": zod.record(zod.string(), zod.unknown()),
  "links": zod.array(zod.object({
  "recordType": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid()
})).max(updateGeographicFeatureResponseLinksMax),
  "sourceFeatureId": zod.string().nullish(),
  "version": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const deleteGeographicFeatureParams = zod.object({
  "id": zod.uuid()
})




export const deleteGeographicFeatureQueryParams = zod.object({
  "expectedVersion": zod.int().min(1)
})

export const deleteGeographicFeatureResponse = zod.void()


export const getGeographicAddressResolutionParams = zod.object({
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid()
})

export const getGeographicAddressResolutionResponseAddressFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getGeographicAddressResolutionResponseCoordinateMin = 2;
export const getGeographicAddressResolutionResponseCoordinateMax = 2;

export const getGeographicAddressResolutionResponseConfidenceMin = 0;
export const getGeographicAddressResolutionResponseConfidenceMax = 1;

export const getGeographicAddressResolutionResponseCandidatesItemCoordinateMin = 2;
export const getGeographicAddressResolutionResponseCandidatesItemCoordinateMax = 2;

export const getGeographicAddressResolutionResponseCandidatesItemConfidenceMin = 0;
export const getGeographicAddressResolutionResponseCandidatesItemConfidenceMax = 1;

export const getGeographicAddressResolutionResponseCandidatesMax = 10;




export const getGeographicAddressResolutionResponse = zod.object({
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "address": zod.string(),
  "addressFingerprint": zod.string().regex(getGeographicAddressResolutionResponseAddressFingerprintRegExp),
  "status": zod.enum(['unresolved', 'ambiguous', 'resolved', 'corrected', 'failed', 'stale']),
  "provider": zod.enum(['manual', 'azure']),
  "coordinate": zod.array(zod.number()).min(getGeographicAddressResolutionResponseCoordinateMin).max(getGeographicAddressResolutionResponseCoordinateMax).nullish(),
  "precision": zod.string().nullish(),
  "confidence": zod.number().min(getGeographicAddressResolutionResponseConfidenceMin).max(getGeographicAddressResolutionResponseConfidenceMax).nullish(),
  "candidates": zod.array(zod.object({
  "coordinate": zod.array(zod.number()).min(getGeographicAddressResolutionResponseCandidatesItemCoordinateMin).max(getGeographicAddressResolutionResponseCandidatesItemCoordinateMax),
  "label": zod.string(),
  "confidence": zod.number().min(getGeographicAddressResolutionResponseCandidatesItemConfidenceMin).max(getGeographicAddressResolutionResponseCandidatesItemConfidenceMax).optional()
})).max(getGeographicAddressResolutionResponseCandidatesMax),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const correctGeographicAddressResolutionParams = zod.object({
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid()
})

export const correctGeographicAddressResolutionBodyCoordinateMin = 2;
export const correctGeographicAddressResolutionBodyCoordinateMax = 2;

export const correctGeographicAddressResolutionBodyExpectedVersionMin = 0;



export const correctGeographicAddressResolutionBody = zod.object({
  "coordinate": zod.array(zod.number()).min(correctGeographicAddressResolutionBodyCoordinateMin).max(correctGeographicAddressResolutionBodyCoordinateMax),
  "expectedVersion": zod.int().min(correctGeographicAddressResolutionBodyExpectedVersionMin)
})

export const correctGeographicAddressResolutionResponseAddressFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const correctGeographicAddressResolutionResponseCoordinateMin = 2;
export const correctGeographicAddressResolutionResponseCoordinateMax = 2;

export const correctGeographicAddressResolutionResponseConfidenceMin = 0;
export const correctGeographicAddressResolutionResponseConfidenceMax = 1;

export const correctGeographicAddressResolutionResponseCandidatesItemCoordinateMin = 2;
export const correctGeographicAddressResolutionResponseCandidatesItemCoordinateMax = 2;

export const correctGeographicAddressResolutionResponseCandidatesItemConfidenceMin = 0;
export const correctGeographicAddressResolutionResponseCandidatesItemConfidenceMax = 1;

export const correctGeographicAddressResolutionResponseCandidatesMax = 10;




export const correctGeographicAddressResolutionResponse = zod.object({
  "recordType": zod.enum(['account', 'contact']),
  "recordId": zod.uuid(),
  "address": zod.string(),
  "addressFingerprint": zod.string().regex(correctGeographicAddressResolutionResponseAddressFingerprintRegExp),
  "status": zod.enum(['unresolved', 'ambiguous', 'resolved', 'corrected', 'failed', 'stale']),
  "provider": zod.enum(['manual', 'azure']),
  "coordinate": zod.array(zod.number()).min(correctGeographicAddressResolutionResponseCoordinateMin).max(correctGeographicAddressResolutionResponseCoordinateMax).nullish(),
  "precision": zod.string().nullish(),
  "confidence": zod.number().min(correctGeographicAddressResolutionResponseConfidenceMin).max(correctGeographicAddressResolutionResponseConfidenceMax).nullish(),
  "candidates": zod.array(zod.object({
  "coordinate": zod.array(zod.number()).min(correctGeographicAddressResolutionResponseCandidatesItemCoordinateMin).max(correctGeographicAddressResolutionResponseCandidatesItemCoordinateMax),
  "label": zod.string(),
  "confidence": zod.number().min(correctGeographicAddressResolutionResponseCandidatesItemConfidenceMin).max(correctGeographicAddressResolutionResponseCandidatesItemConfidenceMax).optional()
})).max(correctGeographicAddressResolutionResponseCandidatesMax),
  "version": zod.int().min(1),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Explicitly request a bounded Azure lookup after separate setup
 */
export const startGeographicAddressLookupBodyRecordIdsMax = 25;



export const startGeographicAddressLookupBody = zod.object({
  "recordType": zod.enum(['account', 'contact']),
  "recordIds": zod.array(zod.uuid()).min(1).max(startGeographicAddressLookupBodyRecordIdsMax),
  "idempotencyKey": zod.uuid()
})

export const startGeographicAddressLookupResponseCursorMin = 0;

export const startGeographicAddressLookupResponseTotalMax = 25;

export const startGeographicAddressLookupResponseAttemptedMin = 0;

export const startGeographicAddressLookupResponseResolvedMin = 0;

export const startGeographicAddressLookupResponseAmbiguousMin = 0;

export const startGeographicAddressLookupResponseFailedMin = 0;



export const startGeographicAddressLookupResponse = zod.object({
  "id": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "status": zod.enum(['queued', 'running', 'completed', 'cancelled', 'failed']),
  "cursor": zod.int().min(startGeographicAddressLookupResponseCursorMin),
  "total": zod.int().min(1).max(startGeographicAddressLookupResponseTotalMax),
  "attempted": zod.int().min(startGeographicAddressLookupResponseAttemptedMin),
  "resolved": zod.int().min(startGeographicAddressLookupResponseResolvedMin),
  "ambiguous": zod.int().min(startGeographicAddressLookupResponseAmbiguousMin),
  "failed": zod.int().min(startGeographicAddressLookupResponseFailedMin),
  "error": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const getGeographicAddressLookupParams = zod.object({
  "id": zod.uuid()
})

export const getGeographicAddressLookupResponseCursorMin = 0;

export const getGeographicAddressLookupResponseTotalMax = 25;

export const getGeographicAddressLookupResponseAttemptedMin = 0;

export const getGeographicAddressLookupResponseResolvedMin = 0;

export const getGeographicAddressLookupResponseAmbiguousMin = 0;

export const getGeographicAddressLookupResponseFailedMin = 0;



export const getGeographicAddressLookupResponse = zod.object({
  "id": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "status": zod.enum(['queued', 'running', 'completed', 'cancelled', 'failed']),
  "cursor": zod.int().min(getGeographicAddressLookupResponseCursorMin),
  "total": zod.int().min(1).max(getGeographicAddressLookupResponseTotalMax),
  "attempted": zod.int().min(getGeographicAddressLookupResponseAttemptedMin),
  "resolved": zod.int().min(getGeographicAddressLookupResponseResolvedMin),
  "ambiguous": zod.int().min(getGeographicAddressLookupResponseAmbiguousMin),
  "failed": zod.int().min(getGeographicAddressLookupResponseFailedMin),
  "error": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const cancelGeographicAddressLookupParams = zod.object({
  "id": zod.uuid()
})

export const cancelGeographicAddressLookupResponseCursorMin = 0;

export const cancelGeographicAddressLookupResponseTotalMax = 25;

export const cancelGeographicAddressLookupResponseAttemptedMin = 0;

export const cancelGeographicAddressLookupResponseResolvedMin = 0;

export const cancelGeographicAddressLookupResponseAmbiguousMin = 0;

export const cancelGeographicAddressLookupResponseFailedMin = 0;



export const cancelGeographicAddressLookupResponse = zod.object({
  "id": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "status": zod.enum(['queued', 'running', 'completed', 'cancelled', 'failed']),
  "cursor": zod.int().min(cancelGeographicAddressLookupResponseCursorMin),
  "total": zod.int().min(1).max(cancelGeographicAddressLookupResponseTotalMax),
  "attempted": zod.int().min(cancelGeographicAddressLookupResponseAttemptedMin),
  "resolved": zod.int().min(cancelGeographicAddressLookupResponseResolvedMin),
  "ambiguous": zod.int().min(cancelGeographicAddressLookupResponseAmbiguousMin),
  "failed": zod.int().min(cancelGeographicAddressLookupResponseFailedMin),
  "error": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Process the next bounded page of a resumable lookup job
 */
export const runGeographicAddressLookupParams = zod.object({
  "id": zod.uuid()
})

export const runGeographicAddressLookupResponseCursorMin = 0;

export const runGeographicAddressLookupResponseTotalMax = 25;

export const runGeographicAddressLookupResponseAttemptedMin = 0;

export const runGeographicAddressLookupResponseResolvedMin = 0;

export const runGeographicAddressLookupResponseAmbiguousMin = 0;

export const runGeographicAddressLookupResponseFailedMin = 0;



export const runGeographicAddressLookupResponse = zod.object({
  "id": zod.uuid(),
  "recordType": zod.enum(['account', 'contact']),
  "status": zod.enum(['queued', 'running', 'completed', 'cancelled', 'failed']),
  "cursor": zod.int().min(runGeographicAddressLookupResponseCursorMin),
  "total": zod.int().min(1).max(runGeographicAddressLookupResponseTotalMax),
  "attempted": zod.int().min(runGeographicAddressLookupResponseAttemptedMin),
  "resolved": zod.int().min(runGeographicAddressLookupResponseResolvedMin),
  "ambiguous": zod.int().min(runGeographicAddressLookupResponseAmbiguousMin),
  "failed": zod.int().min(runGeographicAddressLookupResponseFailedMin),
  "error": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const previewGeographicImportQueryLayerNameMax = 120;



export const previewGeographicImportQueryParams = zod.object({
  "idempotencyKey": zod.uuid(),
  "layerName": zod.string().min(1).max(previewGeographicImportQueryLayerNameMax)
})

export const previewGeographicImportBody = zod.object({
  "file": zod.instanceof(Blob)
})

export const previewGeographicImportResponseOneSummaryValidMin = 0;

export const previewGeographicImportResponseOneSummaryInvalidMin = 0;

export const previewGeographicImportResponseOneSummaryUnresolvedMin = 0;

export const previewGeographicImportResponseOneSummaryErrorsMax = 100;

export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryOneCoordinatesMin = 2;
export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryOneCoordinatesMax = 2;

export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryTwoCoordinatesItemMin = 2;
export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryTwoCoordinatesItemMax = 2;

export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryTwoCoordinatesMin = 2;
export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryTwoCoordinatesMax = 10000;

export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesItemItemMin = 2;
export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesItemItemMax = 2;

export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesItemMin = 4;
export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesItemMax = 10000;

export const previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesMax = 100;

export const previewGeographicImportResponseTwoPreviewFeaturesItemLinksMax = 20;


export const previewGeographicImportResponseTwoPreviewFeaturesMax = 200;



export const previewGeographicImportResponse = zod.object({
  "id": zod.uuid(),
  "layerId": zod.uuid().nullish(),
  "filename": zod.string(),
  "format": zod.enum(['csv', 'geojson', 'kml', 'shapefile']),
  "status": zod.enum(['previewed', 'committed', 'failed', 'cancelled']),
  "summary": zod.object({
  "valid": zod.int().min(previewGeographicImportResponseOneSummaryValidMin),
  "invalid": zod.int().min(previewGeographicImportResponseOneSummaryInvalidMin),
  "unresolved": zod.int().min(previewGeographicImportResponseOneSummaryUnresolvedMin),
  "errors": zod.array(zod.string()).max(previewGeographicImportResponseOneSummaryErrorsMax).optional()
}),
  "error": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "previewFeatures": zod.array(zod.object({
  "id": zod.uuid(),
  "layerId": zod.uuid(),
  "label": zod.string(),
  "description": zod.string().nullish(),
  "geometry": zod.union([zod.object({
  "type": zod.enum(['Point']),
  "coordinates": zod.array(zod.number()).min(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryOneCoordinatesMin).max(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryOneCoordinatesMax)
}),zod.object({
  "type": zod.enum(['LineString']),
  "coordinates": zod.array(zod.array(zod.number()).min(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryTwoCoordinatesItemMin).max(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryTwoCoordinatesItemMax)).min(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryTwoCoordinatesMin).max(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryTwoCoordinatesMax)
}),zod.object({
  "type": zod.enum(['Polygon']),
  "coordinates": zod.array(zod.array(zod.array(zod.number()).min(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesItemItemMin).max(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesItemItemMax)).min(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesItemMin).max(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesItemMax)).min(1).max(previewGeographicImportResponseTwoPreviewFeaturesItemGeometryThreeCoordinatesMax)
})]),
  "properties": zod.record(zod.string(), zod.unknown()),
  "links": zod.array(zod.object({
  "recordType": zod.enum(['account', 'contact', 'enquiry', 'opportunity']),
  "recordId": zod.uuid()
})).max(previewGeographicImportResponseTwoPreviewFeaturesItemLinksMax),
  "sourceFeatureId": zod.string().nullish(),
  "version": zod.int().min(1),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(previewGeographicImportResponseTwoPreviewFeaturesMax)
}))


export const getGeographicImportParams = zod.object({
  "id": zod.uuid()
})

export const getGeographicImportResponseSummaryValidMin = 0;

export const getGeographicImportResponseSummaryInvalidMin = 0;

export const getGeographicImportResponseSummaryUnresolvedMin = 0;

export const getGeographicImportResponseSummaryErrorsMax = 100;



export const getGeographicImportResponse = zod.object({
  "id": zod.uuid(),
  "layerId": zod.uuid().nullish(),
  "filename": zod.string(),
  "format": zod.enum(['csv', 'geojson', 'kml', 'shapefile']),
  "status": zod.enum(['previewed', 'committed', 'failed', 'cancelled']),
  "summary": zod.object({
  "valid": zod.int().min(getGeographicImportResponseSummaryValidMin),
  "invalid": zod.int().min(getGeographicImportResponseSummaryInvalidMin),
  "unresolved": zod.int().min(getGeographicImportResponseSummaryUnresolvedMin),
  "errors": zod.array(zod.string()).max(getGeographicImportResponseSummaryErrorsMax).optional()
}),
  "error": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const commitGeographicImportParams = zod.object({
  "id": zod.uuid()
})

export const commitGeographicImportBody = zod.object({
  "expectedStatus": zod.enum(['previewed'])
})

export const commitGeographicImportResponseSummaryValidMin = 0;

export const commitGeographicImportResponseSummaryInvalidMin = 0;

export const commitGeographicImportResponseSummaryUnresolvedMin = 0;

export const commitGeographicImportResponseSummaryErrorsMax = 100;



export const commitGeographicImportResponse = zod.object({
  "id": zod.uuid(),
  "layerId": zod.uuid().nullish(),
  "filename": zod.string(),
  "format": zod.enum(['csv', 'geojson', 'kml', 'shapefile']),
  "status": zod.enum(['previewed', 'committed', 'failed', 'cancelled']),
  "summary": zod.object({
  "valid": zod.int().min(commitGeographicImportResponseSummaryValidMin),
  "invalid": zod.int().min(commitGeographicImportResponseSummaryInvalidMin),
  "unresolved": zod.int().min(commitGeographicImportResponseSummaryUnresolvedMin),
  "errors": zod.array(zod.string()).max(commitGeographicImportResponseSummaryErrorsMax).optional()
}),
  "error": zod.string().nullish(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Get the signed-in user's private iCloud connection status
 */
export const getIcloudConnectionResponseContactCountMin = 0;

export const getIcloudConnectionResponseSnapshotVersionMin = 0;

export const getIcloudConnectionResponseBackupSnapshotVersionMin = 0;



export const getIcloudConnectionResponse = zod.object({
  "connected": zod.boolean(),
  "status": zod.enum(['connected', 'needs_reconnect']).nullable(),
  "appleId": zod.string().nullable(),
  "contactCount": zod.int().min(getIcloudConnectionResponseContactCountMin),
  "lastSyncedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastBackupAt": zod.iso.datetime({"offset":true}).nullable(),
  "snapshotVersion": zod.int().min(getIcloudConnectionResponseSnapshotVersionMin),
  "backupSnapshotVersion": zod.int().min(getIcloudConnectionResponseBackupSnapshotVersionMin).nullable()
})


/**
 * @summary Connect and import the signed-in user's own iCloud address book
 */
export const connectIcloudBodyAppleIdMin = 3;
export const connectIcloudBodyAppleIdMax = 320;

export const connectIcloudBodyAppPasswordMax = 128;



export const connectIcloudBody = zod.object({
  "appleId": zod.email().min(connectIcloudBodyAppleIdMin).max(connectIcloudBodyAppleIdMax),
  "appPassword": zod.string().min(1).max(connectIcloudBodyAppPasswordMax)
})

export const connectIcloudResponseContactCountMin = 0;

export const connectIcloudResponseSnapshotVersionMin = 0;

export const connectIcloudResponseBackupSnapshotVersionMin = 0;



export const connectIcloudResponse = zod.object({
  "connected": zod.boolean(),
  "status": zod.enum(['connected', 'needs_reconnect']).nullable(),
  "appleId": zod.string().nullable(),
  "contactCount": zod.int().min(connectIcloudResponseContactCountMin),
  "lastSyncedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastBackupAt": zod.iso.datetime({"offset":true}).nullable(),
  "snapshotVersion": zod.int().min(connectIcloudResponseSnapshotVersionMin),
  "backupSnapshotVersion": zod.int().min(connectIcloudResponseBackupSnapshotVersionMin).nullable()
})


/**
 * @summary Disconnect and delete the signed-in user's private iCloud data
 */
export const disconnectIcloudResponse = zod.object({
  "disconnected": zod.literal(true)
})


/**
 * @summary Manually refresh the signed-in user's private iCloud snapshot
 */
export const syncIcloudResponseContactCountMin = 0;

export const syncIcloudResponseSnapshotVersionMin = 0;

export const syncIcloudResponseBackupSnapshotVersionMin = 0;



export const syncIcloudResponse = zod.object({
  "connected": zod.boolean(),
  "status": zod.enum(['connected', 'needs_reconnect']).nullable(),
  "appleId": zod.string().nullable(),
  "contactCount": zod.int().min(syncIcloudResponseContactCountMin),
  "lastSyncedAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastBackupAt": zod.iso.datetime({"offset":true}).nullable(),
  "snapshotVersion": zod.int().min(syncIcloudResponseSnapshotVersionMin),
  "backupSnapshotVersion": zod.int().min(syncIcloudResponseBackupSnapshotVersionMin).nullable()
})


/**
 * @summary List the signed-in user's private imported iCloud contacts
 */
export const listIcloudContactsQuerySearchMax = 200;

export const listIcloudContactsQueryLimitDefault = 50;
export const listIcloudContactsQueryLimitMax = 100;

export const listIcloudContactsQueryOffsetDefault = 0;
export const listIcloudContactsQueryOffsetMin = 0;



export const listIcloudContactsQueryParams = zod.object({
  "search": zod.string().max(listIcloudContactsQuerySearchMax).optional(),
  "limit": zod.int().min(1).max(listIcloudContactsQueryLimitMax).default(listIcloudContactsQueryLimitDefault),
  "offset": zod.int().min(listIcloudContactsQueryOffsetMin).default(listIcloudContactsQueryOffsetDefault)
})

export const listIcloudContactsResponseTotalMin = 0;

export const listIcloudContactsResponseLimitMax = 100;

export const listIcloudContactsResponseOffsetMin = 0;

export const listIcloudContactsResponseSnapshotVersionMin = 0;



export const listIcloudContactsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "uid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "linkedContactId": zod.uuid().nullable(),
  "syncedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listIcloudContactsResponseTotalMin),
  "limit": zod.int().min(1).max(listIcloudContactsResponseLimitMax),
  "offset": zod.int().min(listIcloudContactsResponseOffsetMin),
  "snapshotVersion": zod.int().min(listIcloudContactsResponseSnapshotVersionMin),
  "lastSyncedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * @summary Preview shared CRM matches for selected private iCloud contacts
 */
export const previewIcloudContactPromotionBodyUidsItemMax = 500;

export const previewIcloudContactPromotionBodyUidsMax = 100;



export const previewIcloudContactPromotionBody = zod.object({
  "uids": zod.array(zod.string().min(1).max(previewIcloudContactPromotionBodyUidsItemMax)).min(1).max(previewIcloudContactPromotionBodyUidsMax)
})

export const previewIcloudContactPromotionResponse = zod.object({
  "items": zod.array(zod.object({
  "uid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "matches": zod.array(zod.object({
  "contactId": zod.uuid(),
  "name": zod.string(),
  "email": zod.string(),
  "matchType": zod.enum(['email', 'phone', 'name'])
})),
  "alreadyLinkedContactId": zod.uuid().nullable(),
  "canCreate": zod.boolean()
}))
})


/**
 * @summary Explicitly create or link selected private iCloud contacts in the shared CRM
 */
export const promoteIcloudContactsBodyDecisionsItemUidMax = 500;

export const promoteIcloudContactsBodyDecisionsMax = 100;



export const promoteIcloudContactsBody = zod.object({
  "decisions": zod.array(zod.object({
  "uid": zod.string().min(1).max(promoteIcloudContactsBodyDecisionsItemUidMax),
  "action": zod.enum(['create', 'link', 'skip']),
  "contactId": zod.uuid().optional(),
  "accountId": zod.uuid().optional()
})).min(1).max(promoteIcloudContactsBodyDecisionsMax)
})

export const promoteIcloudContactsResponse = zod.object({
  "results": zod.array(zod.object({
  "uid": zod.string(),
  "outcome": zod.enum(['created', 'linked', 'skipped']),
  "contactId": zod.uuid().nullable()
}))
})


/**
 * @summary Build a vCard backup of the signed-in user's current snapshot
 */
export const getIcloudBackupResponseContactCountMin = 0;

export const getIcloudBackupResponseSnapshotVersionMin = 0;



export const getIcloudBackupResponse = zod.object({
  "filename": zod.string(),
  "vcard": zod.string(),
  "contactCount": zod.int().min(getIcloudBackupResponseContactCountMin),
  "snapshotVersion": zod.int().min(getIcloudBackupResponseSnapshotVersionMin)
})


/**
 * @summary List the signed-in user's private duplicate-analysis prompts
 */
export const listIcloudPromptsResponseItem = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "instruction": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
export const listIcloudPromptsResponse = zod.array(listIcloudPromptsResponseItem)


/**
 * @summary Save a private duplicate-analysis prompt
 */
export const createIcloudPromptBodyNameMax = 200;

export const createIcloudPromptBodyInstructionMax = 12000;



export const createIcloudPromptBody = zod.object({
  "name": zod.string().min(1).max(createIcloudPromptBodyNameMax),
  "instruction": zod.string().min(1).max(createIcloudPromptBodyInstructionMax)
})

export const createIcloudPromptResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "instruction": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const updateIcloudPromptParams = zod.object({
  "id": zod.uuid()
})

export const updateIcloudPromptBodyNameMax = 200;

export const updateIcloudPromptBodyInstructionMax = 12000;



export const updateIcloudPromptBody = zod.object({
  "name": zod.string().min(1).max(updateIcloudPromptBodyNameMax).optional(),
  "instruction": zod.string().min(1).max(updateIcloudPromptBodyInstructionMax).optional()
})

export const updateIcloudPromptResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "instruction": zod.string(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const deleteIcloudPromptParams = zod.object({
  "id": zod.uuid()
})

export const deleteIcloudPromptResponse = zod.void()


/**
 * @summary List the signed-in user's private merge rules
 */
export const listIcloudRulesResponseSortOrderMin = 0;
export const listIcloudRulesResponseSortOrderMax = 10000;



export const listIcloudRulesResponseItem = zod.object({
  "id": zod.uuid(),
  "field": zod.enum(['name', 'email', 'phone', 'organization']),
  "match": zod.enum(['exact', 'similar']),
  "effect": zod.enum(['merge', 'never_merge']),
  "enabled": zod.boolean(),
  "sortOrder": zod.int().min(listIcloudRulesResponseSortOrderMin).max(listIcloudRulesResponseSortOrderMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})
export const listIcloudRulesResponse = zod.array(listIcloudRulesResponseItem)


export const createIcloudRuleBodyEnabledDefault = true;
export const createIcloudRuleBodySortOrderDefault = 0;
export const createIcloudRuleBodySortOrderMin = 0;
export const createIcloudRuleBodySortOrderMax = 10000;



export const createIcloudRuleBody = zod.object({
  "field": zod.enum(['name', 'email', 'phone', 'organization']),
  "match": zod.enum(['exact', 'similar']),
  "effect": zod.enum(['merge', 'never_merge']),
  "enabled": zod.boolean().default(createIcloudRuleBodyEnabledDefault),
  "sortOrder": zod.int().min(createIcloudRuleBodySortOrderMin).max(createIcloudRuleBodySortOrderMax).default(createIcloudRuleBodySortOrderDefault)
})

export const createIcloudRuleResponseSortOrderMin = 0;
export const createIcloudRuleResponseSortOrderMax = 10000;



export const createIcloudRuleResponse = zod.object({
  "id": zod.uuid(),
  "field": zod.enum(['name', 'email', 'phone', 'organization']),
  "match": zod.enum(['exact', 'similar']),
  "effect": zod.enum(['merge', 'never_merge']),
  "enabled": zod.boolean(),
  "sortOrder": zod.int().min(createIcloudRuleResponseSortOrderMin).max(createIcloudRuleResponseSortOrderMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const reorderIcloudRulesBodyRuleIdsMax = 100;



export const reorderIcloudRulesBody = zod.object({
  "ruleIds": zod.array(zod.uuid()).max(reorderIcloudRulesBodyRuleIdsMax)
})

export const reorderIcloudRulesResponse = zod.void()


export const updateIcloudRuleParams = zod.object({
  "id": zod.uuid()
})

export const updateIcloudRuleBodySortOrderMin = 0;
export const updateIcloudRuleBodySortOrderMax = 10000;



export const updateIcloudRuleBody = zod.object({
  "field": zod.enum(['name', 'email', 'phone', 'organization']).optional(),
  "match": zod.enum(['exact', 'similar']).optional(),
  "effect": zod.enum(['merge', 'never_merge']).optional(),
  "enabled": zod.boolean().optional(),
  "sortOrder": zod.int().min(updateIcloudRuleBodySortOrderMin).max(updateIcloudRuleBodySortOrderMax).optional()
})

export const updateIcloudRuleResponseSortOrderMin = 0;
export const updateIcloudRuleResponseSortOrderMax = 10000;



export const updateIcloudRuleResponse = zod.object({
  "id": zod.uuid(),
  "field": zod.enum(['name', 'email', 'phone', 'organization']),
  "match": zod.enum(['exact', 'similar']),
  "effect": zod.enum(['merge', 'never_merge']),
  "enabled": zod.boolean(),
  "sortOrder": zod.int().min(updateIcloudRuleResponseSortOrderMin).max(updateIcloudRuleResponseSortOrderMax),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const deleteIcloudRuleParams = zod.object({
  "id": zod.uuid()
})

export const deleteIcloudRuleResponse = zod.void()


export const listIcloudBatchesQueryLimitDefault = 50;
export const listIcloudBatchesQueryLimitMax = 100;

export const listIcloudBatchesQueryOffsetDefault = 0;
export const listIcloudBatchesQueryOffsetMin = 0;



export const listIcloudBatchesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listIcloudBatchesQueryLimitMax).default(listIcloudBatchesQueryLimitDefault),
  "offset": zod.int().min(listIcloudBatchesQueryOffsetMin).default(listIcloudBatchesQueryOffsetDefault)
})

export const listIcloudBatchesResponseItemsItemSnapshotVersionMin = 0;

export const listIcloudBatchesResponseItemsItemItemCountMin = 0;

export const listIcloudBatchesResponseItemsItemPendingCountMin = 0;

export const listIcloudBatchesResponseItemsItemApprovedCountMin = 0;

export const listIcloudBatchesResponseItemsItemRejectedCountMin = 0;

export const listIcloudBatchesResponseItemsItemAppliedCountMin = 0;

export const listIcloudBatchesResponseTotalMin = 0;

export const listIcloudBatchesResponseLimitMax = 100;

export const listIcloudBatchesResponseOffsetMin = 0;



export const listIcloudBatchesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "status": zod.enum(['draft', 'executing', 'executed']),
  "instructionUsed": zod.string().nullable(),
  "snapshotVersion": zod.int().min(listIcloudBatchesResponseItemsItemSnapshotVersionMin),
  "executedAt": zod.iso.datetime({"offset":true}).nullable(),
  "itemCount": zod.int().min(listIcloudBatchesResponseItemsItemItemCountMin),
  "pendingCount": zod.int().min(listIcloudBatchesResponseItemsItemPendingCountMin),
  "approvedCount": zod.int().min(listIcloudBatchesResponseItemsItemApprovedCountMin),
  "rejectedCount": zod.int().min(listIcloudBatchesResponseItemsItemRejectedCountMin),
  "appliedCount": zod.int().min(listIcloudBatchesResponseItemsItemAppliedCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listIcloudBatchesResponseTotalMin),
  "limit": zod.int().min(1).max(listIcloudBatchesResponseLimitMax),
  "offset": zod.int().min(listIcloudBatchesResponseOffsetMin)
})


export const createIcloudBatchBodyNameMax = 200;



export const createIcloudBatchBody = zod.object({
  "name": zod.string().min(1).max(createIcloudBatchBodyNameMax)
})

export const createIcloudBatchResponseOneSnapshotVersionMin = 0;

export const createIcloudBatchResponseOneItemCountMin = 0;

export const createIcloudBatchResponseOnePendingCountMin = 0;

export const createIcloudBatchResponseOneApprovedCountMin = 0;

export const createIcloudBatchResponseOneRejectedCountMin = 0;

export const createIcloudBatchResponseOneAppliedCountMin = 0;



export const createIcloudBatchResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "status": zod.enum(['draft', 'executing', 'executed']),
  "instructionUsed": zod.string().nullable(),
  "snapshotVersion": zod.int().min(createIcloudBatchResponseOneSnapshotVersionMin),
  "executedAt": zod.iso.datetime({"offset":true}).nullable(),
  "itemCount": zod.int().min(createIcloudBatchResponseOneItemCountMin),
  "pendingCount": zod.int().min(createIcloudBatchResponseOnePendingCountMin),
  "approvedCount": zod.int().min(createIcloudBatchResponseOneApprovedCountMin),
  "rejectedCount": zod.int().min(createIcloudBatchResponseOneRejectedCountMin),
  "appliedCount": zod.int().min(createIcloudBatchResponseOneAppliedCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "primaryUid": zod.string(),
  "removeUids": zod.array(zod.string()),
  "sources": zod.array(zod.object({
  "uid": zod.string(),
  "url": zod.url(),
  "etag": zod.string()
})),
  "contacts": zod.array(zod.object({
  "uid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
})),
  "merged": zod.object({
  "primaryUid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
}),
  "decision": zod.enum(['pending', 'approved', 'rejected']),
  "result": zod.enum(['pending', 'applied', 'failed', 'stale', 'skipped', 'restored']),
  "resultError": zod.string().nullable(),
  "confidence": zod.enum(['high', 'medium', 'low']),
  "reason": zod.string(),
  "appliedAt": zod.iso.datetime({"offset":true}).nullable(),
  "originalsPurgeAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoredAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoreAvailable": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))


export const getIcloudBatchParams = zod.object({
  "id": zod.uuid()
})

export const getIcloudBatchResponseOneSnapshotVersionMin = 0;

export const getIcloudBatchResponseOneItemCountMin = 0;

export const getIcloudBatchResponseOnePendingCountMin = 0;

export const getIcloudBatchResponseOneApprovedCountMin = 0;

export const getIcloudBatchResponseOneRejectedCountMin = 0;

export const getIcloudBatchResponseOneAppliedCountMin = 0;



export const getIcloudBatchResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "status": zod.enum(['draft', 'executing', 'executed']),
  "instructionUsed": zod.string().nullable(),
  "snapshotVersion": zod.int().min(getIcloudBatchResponseOneSnapshotVersionMin),
  "executedAt": zod.iso.datetime({"offset":true}).nullable(),
  "itemCount": zod.int().min(getIcloudBatchResponseOneItemCountMin),
  "pendingCount": zod.int().min(getIcloudBatchResponseOnePendingCountMin),
  "approvedCount": zod.int().min(getIcloudBatchResponseOneApprovedCountMin),
  "rejectedCount": zod.int().min(getIcloudBatchResponseOneRejectedCountMin),
  "appliedCount": zod.int().min(getIcloudBatchResponseOneAppliedCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "primaryUid": zod.string(),
  "removeUids": zod.array(zod.string()),
  "sources": zod.array(zod.object({
  "uid": zod.string(),
  "url": zod.url(),
  "etag": zod.string()
})),
  "contacts": zod.array(zod.object({
  "uid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
})),
  "merged": zod.object({
  "primaryUid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
}),
  "decision": zod.enum(['pending', 'approved', 'rejected']),
  "result": zod.enum(['pending', 'applied', 'failed', 'stale', 'skipped', 'restored']),
  "resultError": zod.string().nullable(),
  "confidence": zod.enum(['high', 'medium', 'low']),
  "reason": zod.string(),
  "appliedAt": zod.iso.datetime({"offset":true}).nullable(),
  "originalsPurgeAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoredAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoreAvailable": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))


export const deleteIcloudBatchParams = zod.object({
  "id": zod.uuid()
})

export const deleteIcloudBatchResponse = zod.void()


/**
 * @summary Generate AI-assisted duplicate proposals from the current private snapshot
 */
export const generateIcloudBatchParams = zod.object({
  "id": zod.uuid()
})

export const generateIcloudBatchBodyInstructionMax = 12000;



export const generateIcloudBatchBody = zod.object({
  "promptId": zod.uuid().optional(),
  "instruction": zod.string().min(1).max(generateIcloudBatchBodyInstructionMax).optional()
})

export const generateIcloudBatchResponseOneSnapshotVersionMin = 0;

export const generateIcloudBatchResponseOneItemCountMin = 0;

export const generateIcloudBatchResponseOnePendingCountMin = 0;

export const generateIcloudBatchResponseOneApprovedCountMin = 0;

export const generateIcloudBatchResponseOneRejectedCountMin = 0;

export const generateIcloudBatchResponseOneAppliedCountMin = 0;



export const generateIcloudBatchResponse = zod.object({
  "id": zod.uuid(),
  "name": zod.string(),
  "status": zod.enum(['draft', 'executing', 'executed']),
  "instructionUsed": zod.string().nullable(),
  "snapshotVersion": zod.int().min(generateIcloudBatchResponseOneSnapshotVersionMin),
  "executedAt": zod.iso.datetime({"offset":true}).nullable(),
  "itemCount": zod.int().min(generateIcloudBatchResponseOneItemCountMin),
  "pendingCount": zod.int().min(generateIcloudBatchResponseOnePendingCountMin),
  "approvedCount": zod.int().min(generateIcloudBatchResponseOneApprovedCountMin),
  "rejectedCount": zod.int().min(generateIcloudBatchResponseOneRejectedCountMin),
  "appliedCount": zod.int().min(generateIcloudBatchResponseOneAppliedCountMin),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "primaryUid": zod.string(),
  "removeUids": zod.array(zod.string()),
  "sources": zod.array(zod.object({
  "uid": zod.string(),
  "url": zod.url(),
  "etag": zod.string()
})),
  "contacts": zod.array(zod.object({
  "uid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
})),
  "merged": zod.object({
  "primaryUid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
}),
  "decision": zod.enum(['pending', 'approved', 'rejected']),
  "result": zod.enum(['pending', 'applied', 'failed', 'stale', 'skipped', 'restored']),
  "resultError": zod.string().nullable(),
  "confidence": zod.enum(['high', 'medium', 'low']),
  "reason": zod.string(),
  "appliedAt": zod.iso.datetime({"offset":true}).nullable(),
  "originalsPurgeAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoredAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoreAvailable": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
}))
}))


export const decideIcloudBatchItemParams = zod.object({
  "id": zod.uuid(),
  "itemId": zod.uuid()
})

export const decideIcloudBatchItemBody = zod.object({
  "decision": zod.enum(['pending', 'approved', 'rejected'])
})

export const decideIcloudBatchItemResponse = zod.object({
  "id": zod.uuid(),
  "primaryUid": zod.string(),
  "removeUids": zod.array(zod.string()),
  "sources": zod.array(zod.object({
  "uid": zod.string(),
  "url": zod.url(),
  "etag": zod.string()
})),
  "contacts": zod.array(zod.object({
  "uid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
})),
  "merged": zod.object({
  "primaryUid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
}),
  "decision": zod.enum(['pending', 'approved', 'rejected']),
  "result": zod.enum(['pending', 'applied', 'failed', 'stale', 'skipped', 'restored']),
  "resultError": zod.string().nullable(),
  "confidence": zod.enum(['high', 'medium', 'low']),
  "reason": zod.string(),
  "appliedAt": zod.iso.datetime({"offset":true}).nullable(),
  "originalsPurgeAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoredAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoreAvailable": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * @summary Apply approved merges to the signed-in user's verified iCloud address book
 */
export const executeIcloudBatchParams = zod.object({
  "id": zod.uuid()
})

export const executeIcloudBatchResponseAppliedMin = 0;

export const executeIcloudBatchResponseFailedMin = 0;

export const executeIcloudBatchResponseStaleMin = 0;

export const executeIcloudBatchResponseSkippedMin = 0;



export const executeIcloudBatchResponse = zod.object({
  "applied": zod.int().min(executeIcloudBatchResponseAppliedMin),
  "failed": zod.int().min(executeIcloudBatchResponseFailedMin),
  "stale": zod.int().min(executeIcloudBatchResponseStaleMin),
  "skipped": zod.int().min(executeIcloudBatchResponseSkippedMin),
  "results": zod.array(zod.object({
  "itemId": zod.uuid(),
  "primaryUid": zod.string(),
  "result": zod.enum(['applied', 'failed', 'stale', 'skipped']),
  "error": zod.string().nullable()
}))
})


/**
 * @summary Restore an applied merge within its 30-day retention window
 */
export const restoreIcloudBatchItemParams = zod.object({
  "id": zod.uuid(),
  "itemId": zod.uuid()
})

export const restoreIcloudBatchItemResponse = zod.object({
  "id": zod.uuid(),
  "primaryUid": zod.string(),
  "removeUids": zod.array(zod.string()),
  "sources": zod.array(zod.object({
  "uid": zod.string(),
  "url": zod.url(),
  "etag": zod.string()
})),
  "contacts": zod.array(zod.object({
  "uid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
})),
  "merged": zod.object({
  "primaryUid": zod.string(),
  "displayName": zod.string(),
  "firstName": zod.string().nullable(),
  "lastName": zod.string().nullable(),
  "organization": zod.string().nullable(),
  "emails": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
})),
  "phones": zod.array(zod.object({
  "label": zod.string(),
  "value": zod.string()
}))
}),
  "decision": zod.enum(['pending', 'approved', 'rejected']),
  "result": zod.enum(['pending', 'applied', 'failed', 'stale', 'skipped', 'restored']),
  "resultError": zod.string().nullable(),
  "confidence": zod.enum(['high', 'medium', 'low']),
  "reason": zod.string(),
  "appliedAt": zod.iso.datetime({"offset":true}).nullable(),
  "originalsPurgeAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoredAt": zod.iso.datetime({"offset":true}).nullable(),
  "restoreAvailable": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listIcloudWritebackLogQueryLimitDefault = 50;
export const listIcloudWritebackLogQueryLimitMax = 100;

export const listIcloudWritebackLogQueryOffsetDefault = 0;
export const listIcloudWritebackLogQueryOffsetMin = 0;



export const listIcloudWritebackLogQueryParams = zod.object({
  "limit": zod.int().min(1).max(listIcloudWritebackLogQueryLimitMax).default(listIcloudWritebackLogQueryLimitDefault),
  "offset": zod.int().min(listIcloudWritebackLogQueryOffsetMin).default(listIcloudWritebackLogQueryOffsetDefault)
})

export const listIcloudWritebackLogResponseTotalMin = 0;

export const listIcloudWritebackLogResponseLimitMax = 100;

export const listIcloudWritebackLogResponseOffsetMin = 0;



export const listIcloudWritebackLogResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "batchId": zod.uuid(),
  "itemId": zod.uuid(),
  "uid": zod.string(),
  "url": zod.url(),
  "action": zod.enum(['update', 'delete', 'restore_create', 'restore_update']),
  "etagBefore": zod.string().nullable(),
  "etagAfter": zod.string().nullable(),
  "result": zod.enum(['ok', 'failed']),
  "error": zod.string().nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listIcloudWritebackLogResponseTotalMin),
  "limit": zod.int().min(1).max(listIcloudWritebackLogResponseLimitMax),
  "offset": zod.int().min(listIcloudWritebackLogResponseOffsetMin)
})


/**
 * Public-safe business sender and setup gaps for campaign staff. No credential administration.
 */
export const getWhatsAppCampaignReadinessResponseRevisionMin = 0;

export const getWhatsAppCampaignReadinessResponseSenderOneRevisionMin = 0;

export const getWhatsAppCampaignReadinessResponseSenderOnePhoneNumberMax = 16;


export const getWhatsAppCampaignReadinessResponseSenderOnePhoneNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const getWhatsAppCampaignReadinessResponseSenderOneProviderAccountIdMax = 200;

export const getWhatsAppCampaignReadinessResponseSenderOneProviderPhoneNumberIdMax = 200;

export const getWhatsAppCampaignReadinessResponseSenderOneReadinessCodeMax = 200;

export const getWhatsAppCampaignReadinessResponseSenderOneReadinessMessageMax = 1000;

export const getWhatsAppCampaignReadinessResponseSenderOneReadinessChecksItemCodeMax = 200;

export const getWhatsAppCampaignReadinessResponseSenderOneReadinessChecksItemMessageMax = 1000;

export const getWhatsAppCampaignReadinessResponseSenderOneReadinessChecksMax = 100;

export const getWhatsAppCampaignReadinessResponseReadinessCodeMax = 200;

export const getWhatsAppCampaignReadinessResponseReadinessMessageMax = 1000;

export const getWhatsAppCampaignReadinessResponseReadinessChecksItemCodeMax = 200;

export const getWhatsAppCampaignReadinessResponseReadinessChecksItemMessageMax = 1000;

export const getWhatsAppCampaignReadinessResponseReadinessChecksMax = 100;

export const getWhatsAppCampaignReadinessResponseCampaignCountriesMax = 2;



export const getWhatsAppCampaignReadinessResponse = zod.object({
  "revision": zod.int().min(getWhatsAppCampaignReadinessResponseRevisionMin),
  "sender": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(getWhatsAppCampaignReadinessResponseSenderOneRevisionMin),
  "revisionId": zod.uuid().nullable(),
  "phoneNumber": zod.string().max(getWhatsAppCampaignReadinessResponseSenderOnePhoneNumberMax).regex(getWhatsAppCampaignReadinessResponseSenderOnePhoneNumberRegExp),
  "providerAccountId": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseSenderOneProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseSenderOneProviderPhoneNumberIdMax),
  "onboardingPath": zod.enum(['personal_conversion', 'business_app_coexistence', 'existing_cloud_api']),
  "status": zod.enum(['setup_required', 'pending_verification', 'ready', 'unavailable', 'revoked', 'disconnected']),
  "active": zod.boolean(),
  "coexistenceVerified": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseSenderOneReadinessCodeMax),
  "message": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseSenderOneReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseSenderOneReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseSenderOneReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(getWhatsAppCampaignReadinessResponseSenderOneReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),zod.null()]),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseReadinessCodeMax),
  "message": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(getWhatsAppCampaignReadinessResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(getWhatsAppCampaignReadinessResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "campaignCountries": zod.array(zod.enum(['AU', 'NZ'])).max(getWhatsAppCampaignReadinessResponseCampaignCountriesMax)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.integrations.manage. Owner resolved from authorized server context.
 */
export const getWhatsAppSettingsResponseRevisionMin = 0;

export const getWhatsAppSettingsResponseSenderOneRevisionMin = 0;

export const getWhatsAppSettingsResponseSenderOnePhoneNumberMax = 16;


export const getWhatsAppSettingsResponseSenderOnePhoneNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const getWhatsAppSettingsResponseSenderOneProviderAccountIdMax = 200;

export const getWhatsAppSettingsResponseSenderOneProviderPhoneNumberIdMax = 200;

export const getWhatsAppSettingsResponseSenderOneReadinessCodeMax = 200;

export const getWhatsAppSettingsResponseSenderOneReadinessMessageMax = 1000;

export const getWhatsAppSettingsResponseSenderOneReadinessChecksItemCodeMax = 200;

export const getWhatsAppSettingsResponseSenderOneReadinessChecksItemMessageMax = 1000;

export const getWhatsAppSettingsResponseSenderOneReadinessChecksMax = 100;

export const getWhatsAppSettingsResponseReadinessCodeMax = 200;

export const getWhatsAppSettingsResponseReadinessMessageMax = 1000;

export const getWhatsAppSettingsResponseReadinessChecksItemCodeMax = 200;

export const getWhatsAppSettingsResponseReadinessChecksItemMessageMax = 1000;

export const getWhatsAppSettingsResponseReadinessChecksMax = 100;

export const getWhatsAppSettingsResponseCampaignCountriesMax = 2;



export const getWhatsAppSettingsResponse = zod.object({
  "revision": zod.int().min(getWhatsAppSettingsResponseRevisionMin),
  "sender": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(getWhatsAppSettingsResponseSenderOneRevisionMin),
  "revisionId": zod.uuid().nullable(),
  "phoneNumber": zod.string().max(getWhatsAppSettingsResponseSenderOnePhoneNumberMax).regex(getWhatsAppSettingsResponseSenderOnePhoneNumberRegExp),
  "providerAccountId": zod.string().min(1).max(getWhatsAppSettingsResponseSenderOneProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(getWhatsAppSettingsResponseSenderOneProviderPhoneNumberIdMax),
  "onboardingPath": zod.enum(['personal_conversion', 'business_app_coexistence', 'existing_cloud_api']),
  "status": zod.enum(['setup_required', 'pending_verification', 'ready', 'unavailable', 'revoked', 'disconnected']),
  "active": zod.boolean(),
  "coexistenceVerified": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(getWhatsAppSettingsResponseSenderOneReadinessCodeMax),
  "message": zod.string().min(1).max(getWhatsAppSettingsResponseSenderOneReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(getWhatsAppSettingsResponseSenderOneReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(getWhatsAppSettingsResponseSenderOneReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(getWhatsAppSettingsResponseSenderOneReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),zod.null()]),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(getWhatsAppSettingsResponseReadinessCodeMax),
  "message": zod.string().min(1).max(getWhatsAppSettingsResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(getWhatsAppSettingsResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(getWhatsAppSettingsResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(getWhatsAppSettingsResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "campaignCountries": zod.array(zod.enum(['AU', 'NZ'])).max(getWhatsAppSettingsResponseCampaignCountriesMax)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.integrations.manage. Owner resolved from authorized server context.
 */
export const configureWhatsAppSenderBodyExpectedRevisionMin = 0;

export const configureWhatsAppSenderBodyPhoneNumberMax = 16;


export const configureWhatsAppSenderBodyPhoneNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const configureWhatsAppSenderBodyProviderAccountIdMax = 100;

export const configureWhatsAppSenderBodyProviderPhoneNumberIdMax = 100;



export const configureWhatsAppSenderBody = zod.object({
  "expectedRevision": zod.int().min(configureWhatsAppSenderBodyExpectedRevisionMin),
  "requestKey": zod.uuid(),
  "onboardingPath": zod.enum(['personal_conversion', 'business_app_coexistence', 'existing_cloud_api']),
  "phoneNumber": zod.string().max(configureWhatsAppSenderBodyPhoneNumberMax).regex(configureWhatsAppSenderBodyPhoneNumberRegExp),
  "providerAccountId": zod.string().min(1).max(configureWhatsAppSenderBodyProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(configureWhatsAppSenderBodyProviderPhoneNumberIdMax)
})

export const configureWhatsAppSenderResponseRevisionMin = 0;

export const configureWhatsAppSenderResponseSenderOneRevisionMin = 0;

export const configureWhatsAppSenderResponseSenderOnePhoneNumberMax = 16;


export const configureWhatsAppSenderResponseSenderOnePhoneNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const configureWhatsAppSenderResponseSenderOneProviderAccountIdMax = 200;

export const configureWhatsAppSenderResponseSenderOneProviderPhoneNumberIdMax = 200;

export const configureWhatsAppSenderResponseSenderOneReadinessCodeMax = 200;

export const configureWhatsAppSenderResponseSenderOneReadinessMessageMax = 1000;

export const configureWhatsAppSenderResponseSenderOneReadinessChecksItemCodeMax = 200;

export const configureWhatsAppSenderResponseSenderOneReadinessChecksItemMessageMax = 1000;

export const configureWhatsAppSenderResponseSenderOneReadinessChecksMax = 100;

export const configureWhatsAppSenderResponseReadinessCodeMax = 200;

export const configureWhatsAppSenderResponseReadinessMessageMax = 1000;

export const configureWhatsAppSenderResponseReadinessChecksItemCodeMax = 200;

export const configureWhatsAppSenderResponseReadinessChecksItemMessageMax = 1000;

export const configureWhatsAppSenderResponseReadinessChecksMax = 100;

export const configureWhatsAppSenderResponseCampaignCountriesMax = 2;



export const configureWhatsAppSenderResponse = zod.object({
  "revision": zod.int().min(configureWhatsAppSenderResponseRevisionMin),
  "sender": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(configureWhatsAppSenderResponseSenderOneRevisionMin),
  "revisionId": zod.uuid().nullable(),
  "phoneNumber": zod.string().max(configureWhatsAppSenderResponseSenderOnePhoneNumberMax).regex(configureWhatsAppSenderResponseSenderOnePhoneNumberRegExp),
  "providerAccountId": zod.string().min(1).max(configureWhatsAppSenderResponseSenderOneProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(configureWhatsAppSenderResponseSenderOneProviderPhoneNumberIdMax),
  "onboardingPath": zod.enum(['personal_conversion', 'business_app_coexistence', 'existing_cloud_api']),
  "status": zod.enum(['setup_required', 'pending_verification', 'ready', 'unavailable', 'revoked', 'disconnected']),
  "active": zod.boolean(),
  "coexistenceVerified": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(configureWhatsAppSenderResponseSenderOneReadinessCodeMax),
  "message": zod.string().min(1).max(configureWhatsAppSenderResponseSenderOneReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(configureWhatsAppSenderResponseSenderOneReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(configureWhatsAppSenderResponseSenderOneReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(configureWhatsAppSenderResponseSenderOneReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),zod.null()]),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(configureWhatsAppSenderResponseReadinessCodeMax),
  "message": zod.string().min(1).max(configureWhatsAppSenderResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(configureWhatsAppSenderResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(configureWhatsAppSenderResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(configureWhatsAppSenderResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "campaignCountries": zod.array(zod.enum(['AU', 'NZ'])).max(configureWhatsAppSenderResponseCampaignCountriesMax)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.integrations.manage. Owner resolved from authorized server context.
 */
export const verifyWhatsAppSenderBodyExpectedRevisionMin = 0;



export const verifyWhatsAppSenderBody = zod.object({
  "expectedRevision": zod.int().min(verifyWhatsAppSenderBodyExpectedRevisionMin),
  "requestKey": zod.uuid()
})

export const verifyWhatsAppSenderResponseRevisionMin = 0;

export const verifyWhatsAppSenderResponseSenderOneRevisionMin = 0;

export const verifyWhatsAppSenderResponseSenderOnePhoneNumberMax = 16;


export const verifyWhatsAppSenderResponseSenderOnePhoneNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const verifyWhatsAppSenderResponseSenderOneProviderAccountIdMax = 200;

export const verifyWhatsAppSenderResponseSenderOneProviderPhoneNumberIdMax = 200;

export const verifyWhatsAppSenderResponseSenderOneReadinessCodeMax = 200;

export const verifyWhatsAppSenderResponseSenderOneReadinessMessageMax = 1000;

export const verifyWhatsAppSenderResponseSenderOneReadinessChecksItemCodeMax = 200;

export const verifyWhatsAppSenderResponseSenderOneReadinessChecksItemMessageMax = 1000;

export const verifyWhatsAppSenderResponseSenderOneReadinessChecksMax = 100;

export const verifyWhatsAppSenderResponseReadinessCodeMax = 200;

export const verifyWhatsAppSenderResponseReadinessMessageMax = 1000;

export const verifyWhatsAppSenderResponseReadinessChecksItemCodeMax = 200;

export const verifyWhatsAppSenderResponseReadinessChecksItemMessageMax = 1000;

export const verifyWhatsAppSenderResponseReadinessChecksMax = 100;

export const verifyWhatsAppSenderResponseCampaignCountriesMax = 2;



export const verifyWhatsAppSenderResponse = zod.object({
  "revision": zod.int().min(verifyWhatsAppSenderResponseRevisionMin),
  "sender": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(verifyWhatsAppSenderResponseSenderOneRevisionMin),
  "revisionId": zod.uuid().nullable(),
  "phoneNumber": zod.string().max(verifyWhatsAppSenderResponseSenderOnePhoneNumberMax).regex(verifyWhatsAppSenderResponseSenderOnePhoneNumberRegExp),
  "providerAccountId": zod.string().min(1).max(verifyWhatsAppSenderResponseSenderOneProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(verifyWhatsAppSenderResponseSenderOneProviderPhoneNumberIdMax),
  "onboardingPath": zod.enum(['personal_conversion', 'business_app_coexistence', 'existing_cloud_api']),
  "status": zod.enum(['setup_required', 'pending_verification', 'ready', 'unavailable', 'revoked', 'disconnected']),
  "active": zod.boolean(),
  "coexistenceVerified": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(verifyWhatsAppSenderResponseSenderOneReadinessCodeMax),
  "message": zod.string().min(1).max(verifyWhatsAppSenderResponseSenderOneReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(verifyWhatsAppSenderResponseSenderOneReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(verifyWhatsAppSenderResponseSenderOneReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(verifyWhatsAppSenderResponseSenderOneReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),zod.null()]),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(verifyWhatsAppSenderResponseReadinessCodeMax),
  "message": zod.string().min(1).max(verifyWhatsAppSenderResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(verifyWhatsAppSenderResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(verifyWhatsAppSenderResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(verifyWhatsAppSenderResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "campaignCountries": zod.array(zod.enum(['AU', 'NZ'])).max(verifyWhatsAppSenderResponseCampaignCountriesMax)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.integrations.manage. Owner resolved from authorized server context.
 */
export const disconnectWhatsAppSenderBodyExpectedRevisionMin = 0;



export const disconnectWhatsAppSenderBody = zod.object({
  "expectedRevision": zod.int().min(disconnectWhatsAppSenderBodyExpectedRevisionMin),
  "requestKey": zod.uuid()
})

export const disconnectWhatsAppSenderResponseRevisionMin = 0;

export const disconnectWhatsAppSenderResponseSenderOneRevisionMin = 0;

export const disconnectWhatsAppSenderResponseSenderOnePhoneNumberMax = 16;


export const disconnectWhatsAppSenderResponseSenderOnePhoneNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const disconnectWhatsAppSenderResponseSenderOneProviderAccountIdMax = 200;

export const disconnectWhatsAppSenderResponseSenderOneProviderPhoneNumberIdMax = 200;

export const disconnectWhatsAppSenderResponseSenderOneReadinessCodeMax = 200;

export const disconnectWhatsAppSenderResponseSenderOneReadinessMessageMax = 1000;

export const disconnectWhatsAppSenderResponseSenderOneReadinessChecksItemCodeMax = 200;

export const disconnectWhatsAppSenderResponseSenderOneReadinessChecksItemMessageMax = 1000;

export const disconnectWhatsAppSenderResponseSenderOneReadinessChecksMax = 100;

export const disconnectWhatsAppSenderResponseReadinessCodeMax = 200;

export const disconnectWhatsAppSenderResponseReadinessMessageMax = 1000;

export const disconnectWhatsAppSenderResponseReadinessChecksItemCodeMax = 200;

export const disconnectWhatsAppSenderResponseReadinessChecksItemMessageMax = 1000;

export const disconnectWhatsAppSenderResponseReadinessChecksMax = 100;

export const disconnectWhatsAppSenderResponseCampaignCountriesMax = 2;



export const disconnectWhatsAppSenderResponse = zod.object({
  "revision": zod.int().min(disconnectWhatsAppSenderResponseRevisionMin),
  "sender": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(disconnectWhatsAppSenderResponseSenderOneRevisionMin),
  "revisionId": zod.uuid().nullable(),
  "phoneNumber": zod.string().max(disconnectWhatsAppSenderResponseSenderOnePhoneNumberMax).regex(disconnectWhatsAppSenderResponseSenderOnePhoneNumberRegExp),
  "providerAccountId": zod.string().min(1).max(disconnectWhatsAppSenderResponseSenderOneProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(disconnectWhatsAppSenderResponseSenderOneProviderPhoneNumberIdMax),
  "onboardingPath": zod.enum(['personal_conversion', 'business_app_coexistence', 'existing_cloud_api']),
  "status": zod.enum(['setup_required', 'pending_verification', 'ready', 'unavailable', 'revoked', 'disconnected']),
  "active": zod.boolean(),
  "coexistenceVerified": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(disconnectWhatsAppSenderResponseSenderOneReadinessCodeMax),
  "message": zod.string().min(1).max(disconnectWhatsAppSenderResponseSenderOneReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(disconnectWhatsAppSenderResponseSenderOneReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(disconnectWhatsAppSenderResponseSenderOneReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(disconnectWhatsAppSenderResponseSenderOneReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),zod.null()]),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(disconnectWhatsAppSenderResponseReadinessCodeMax),
  "message": zod.string().min(1).max(disconnectWhatsAppSenderResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(disconnectWhatsAppSenderResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(disconnectWhatsAppSenderResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(disconnectWhatsAppSenderResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "campaignCountries": zod.array(zod.enum(['AU', 'NZ'])).max(disconnectWhatsAppSenderResponseCampaignCountriesMax)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.integrations.manage. Owner resolved from authorized server context.
 */
export const beginWhatsAppOnboardingBodyExpectedRevisionMin = 0;



export const beginWhatsAppOnboardingBody = zod.object({
  "expectedRevision": zod.int().min(beginWhatsAppOnboardingBodyExpectedRevisionMin),
  "path": zod.enum(['personal_conversion', 'business_app_coexistence', 'existing_cloud_api']),
  "requestKey": zod.uuid()
})

export const beginWhatsAppOnboardingResponsePublicAppIdMax = 200;

export const beginWhatsAppOnboardingResponseConfigurationIdMax = 200;

export const beginWhatsAppOnboardingResponseMessageMax = 1000;



export const beginWhatsAppOnboardingResponse = zod.object({
  "id": zod.uuid(),
  "status": zod.enum(['available', 'unavailable', 'owner_setup_required']),
  "expiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "publicAppId": zod.string().min(1).max(beginWhatsAppOnboardingResponsePublicAppIdMax).nullable(),
  "configurationId": zod.string().min(1).max(beginWhatsAppOnboardingResponseConfigurationIdMax).nullable(),
  "message": zod.string().min(1).max(beginWhatsAppOnboardingResponseMessageMax)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.integrations.manage. Owner resolved from authorized server context.
 */
export const completeWhatsAppOnboardingBodyProviderAccountIdRegExp = new RegExp('^[0-9]{1,100}$');
export const completeWhatsAppOnboardingBodyProviderPhoneNumberIdRegExp = new RegExp('^[0-9]{1,100}$');
export const completeWhatsAppOnboardingBodyPhoneNumberMax = 16;


export const completeWhatsAppOnboardingBodyPhoneNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const completeWhatsAppOnboardingBodyCodeMax = 4000;



export const completeWhatsAppOnboardingBody = zod.object({
  "providerAccountId": zod.string().regex(completeWhatsAppOnboardingBodyProviderAccountIdRegExp),
  "providerPhoneNumberId": zod.string().regex(completeWhatsAppOnboardingBodyProviderPhoneNumberIdRegExp),
  "phoneNumber": zod.string().max(completeWhatsAppOnboardingBodyPhoneNumberMax).regex(completeWhatsAppOnboardingBodyPhoneNumberRegExp),
  "sessionId": zod.uuid(),
  "code": zod.string().min(1).max(completeWhatsAppOnboardingBodyCodeMax),
  "requestKey": zod.uuid()
})

export const completeWhatsAppOnboardingResponseRevisionMin = 0;

export const completeWhatsAppOnboardingResponseSenderOneRevisionMin = 0;

export const completeWhatsAppOnboardingResponseSenderOnePhoneNumberMax = 16;


export const completeWhatsAppOnboardingResponseSenderOnePhoneNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const completeWhatsAppOnboardingResponseSenderOneProviderAccountIdMax = 200;

export const completeWhatsAppOnboardingResponseSenderOneProviderPhoneNumberIdMax = 200;

export const completeWhatsAppOnboardingResponseSenderOneReadinessCodeMax = 200;

export const completeWhatsAppOnboardingResponseSenderOneReadinessMessageMax = 1000;

export const completeWhatsAppOnboardingResponseSenderOneReadinessChecksItemCodeMax = 200;

export const completeWhatsAppOnboardingResponseSenderOneReadinessChecksItemMessageMax = 1000;

export const completeWhatsAppOnboardingResponseSenderOneReadinessChecksMax = 100;

export const completeWhatsAppOnboardingResponseReadinessCodeMax = 200;

export const completeWhatsAppOnboardingResponseReadinessMessageMax = 1000;

export const completeWhatsAppOnboardingResponseReadinessChecksItemCodeMax = 200;

export const completeWhatsAppOnboardingResponseReadinessChecksItemMessageMax = 1000;

export const completeWhatsAppOnboardingResponseReadinessChecksMax = 100;

export const completeWhatsAppOnboardingResponseCampaignCountriesMax = 2;



export const completeWhatsAppOnboardingResponse = zod.object({
  "revision": zod.int().min(completeWhatsAppOnboardingResponseRevisionMin),
  "sender": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(completeWhatsAppOnboardingResponseSenderOneRevisionMin),
  "revisionId": zod.uuid().nullable(),
  "phoneNumber": zod.string().max(completeWhatsAppOnboardingResponseSenderOnePhoneNumberMax).regex(completeWhatsAppOnboardingResponseSenderOnePhoneNumberRegExp),
  "providerAccountId": zod.string().min(1).max(completeWhatsAppOnboardingResponseSenderOneProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(completeWhatsAppOnboardingResponseSenderOneProviderPhoneNumberIdMax),
  "onboardingPath": zod.enum(['personal_conversion', 'business_app_coexistence', 'existing_cloud_api']),
  "status": zod.enum(['setup_required', 'pending_verification', 'ready', 'unavailable', 'revoked', 'disconnected']),
  "active": zod.boolean(),
  "coexistenceVerified": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(completeWhatsAppOnboardingResponseSenderOneReadinessCodeMax),
  "message": zod.string().min(1).max(completeWhatsAppOnboardingResponseSenderOneReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(completeWhatsAppOnboardingResponseSenderOneReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(completeWhatsAppOnboardingResponseSenderOneReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(completeWhatsAppOnboardingResponseSenderOneReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
}),zod.null()]),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(completeWhatsAppOnboardingResponseReadinessCodeMax),
  "message": zod.string().min(1).max(completeWhatsAppOnboardingResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(completeWhatsAppOnboardingResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(completeWhatsAppOnboardingResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(completeWhatsAppOnboardingResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
}),
  "campaignCountries": zod.array(zod.enum(['AU', 'NZ'])).max(completeWhatsAppOnboardingResponseCampaignCountriesMax)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.read. Owner resolved from authorized server context.
 */
export const listWhatsAppTemplatesQueryLimitDefault = 25;
export const listWhatsAppTemplatesQueryLimitMax = 100;

export const listWhatsAppTemplatesQueryOffsetDefault = 0;
export const listWhatsAppTemplatesQueryOffsetMin = 0;



export const listWhatsAppTemplatesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWhatsAppTemplatesQueryLimitMax).default(listWhatsAppTemplatesQueryLimitDefault),
  "offset": zod.int().min(listWhatsAppTemplatesQueryOffsetMin).default(listWhatsAppTemplatesQueryOffsetDefault)
})

export const listWhatsAppTemplatesResponseItemsItemValidationErrorsItemMax = 200;

export const listWhatsAppTemplatesResponseItemsItemValidationErrorsMax = 50;


export const listWhatsAppTemplatesResponseItemsItemProviderTemplateIdMax = 200;

export const listWhatsAppTemplatesResponseItemsItemNameMax = 200;

export const listWhatsAppTemplatesResponseItemsItemLanguageMax = 35;

export const listWhatsAppTemplatesResponseItemsItemComponentsItemProviderTypeMax = 100;

export const listWhatsAppTemplatesResponseItemsItemComponentsItemExampleValuesItemMax = 2000;

export const listWhatsAppTemplatesResponseItemsItemComponentsItemExampleValuesMax = 40;

export const listWhatsAppTemplatesResponseItemsItemComponentsItemTextMin = 0;
export const listWhatsAppTemplatesResponseItemsItemComponentsItemTextMax = 4000;

export const listWhatsAppTemplatesResponseItemsItemComponentsItemButtonsItemTextMax = 100;

export const listWhatsAppTemplatesResponseItemsItemComponentsItemButtonsItemValueMax = 2000;

export const listWhatsAppTemplatesResponseItemsItemComponentsItemButtonsMax = 10;

export const listWhatsAppTemplatesResponseItemsItemComponentsMax = 10;

export const listWhatsAppTemplatesResponseItemsItemContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');
export const listWhatsAppTemplatesResponseItemsMax = 100;

export const listWhatsAppTemplatesResponseTotalMin = 0;



export const listWhatsAppTemplatesResponse = zod.object({
  "items": zod.array(zod.object({
  "eligible": zod.boolean(),
  "validationErrors": zod.array(zod.string().max(listWhatsAppTemplatesResponseItemsItemValidationErrorsItemMax)).max(listWhatsAppTemplatesResponseItemsItemValidationErrorsMax),
  "id": zod.uuid(),
  "senderId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "version": zod.int().min(1),
  "providerTemplateId": zod.string().min(1).max(listWhatsAppTemplatesResponseItemsItemProviderTemplateIdMax),
  "name": zod.string().min(1).max(listWhatsAppTemplatesResponseItemsItemNameMax),
  "language": zod.string().min(1).max(listWhatsAppTemplatesResponseItemsItemLanguageMax),
  "category": zod.enum(['marketing', 'utility', 'authentication']),
  "approvalStatus": zod.enum(['pending', 'approved', 'rejected', 'paused', 'disabled', 'deleted', 'unavailable']),
  "components": zod.array(zod.object({
  "providerType": zod.string().max(listWhatsAppTemplatesResponseItemsItemComponentsItemProviderTypeMax).optional(),
  "exampleValues": zod.array(zod.string().max(listWhatsAppTemplatesResponseItemsItemComponentsItemExampleValuesItemMax)).max(listWhatsAppTemplatesResponseItemsItemComponentsItemExampleValuesMax).optional(),
  "type": zod.enum(['header', 'body', 'footer', 'buttons', 'unsupported']),
  "format": zod.enum(['text', 'image', 'document', 'video']).optional(),
  "text": zod.string().min(listWhatsAppTemplatesResponseItemsItemComponentsItemTextMin).max(listWhatsAppTemplatesResponseItemsItemComponentsItemTextMax).optional(),
  "buttons": zod.array(zod.object({
  "type": zod.enum(['url', 'phone_number', 'quick_reply']),
  "text": zod.string().min(1).max(listWhatsAppTemplatesResponseItemsItemComponentsItemButtonsItemTextMax),
  "value": zod.string().min(1).max(listWhatsAppTemplatesResponseItemsItemComponentsItemButtonsItemValueMax).optional()
})).max(listWhatsAppTemplatesResponseItemsItemComponentsItemButtonsMax).optional()
})).max(listWhatsAppTemplatesResponseItemsItemComponentsMax),
  "contentSha256": zod.string().regex(listWhatsAppTemplatesResponseItemsItemContentSha256RegExp),
  "updatedAt": zod.iso.datetime({"offset":true})
})).max(listWhatsAppTemplatesResponseItemsMax),
  "total": zod.int().min(listWhatsAppTemplatesResponseTotalMin)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.content.manage. Owner resolved from authorized server context.
 */
export const createWhatsAppTemplateBodyNameMax = 512;

export const createWhatsAppTemplateBodyLanguageMax = 35;

export const createWhatsAppTemplateBodyComponentsItemProviderTypeMax = 100;

export const createWhatsAppTemplateBodyComponentsItemExampleValuesItemMax = 2000;

export const createWhatsAppTemplateBodyComponentsItemExampleValuesMax = 40;

export const createWhatsAppTemplateBodyComponentsItemTextMin = 0;
export const createWhatsAppTemplateBodyComponentsItemTextMax = 4000;

export const createWhatsAppTemplateBodyComponentsItemButtonsItemTextMax = 100;

export const createWhatsAppTemplateBodyComponentsItemButtonsItemValueMax = 2000;

export const createWhatsAppTemplateBodyComponentsItemButtonsMax = 10;

export const createWhatsAppTemplateBodyComponentsMax = 10;



export const createWhatsAppTemplateBody = zod.object({
  "name": zod.string().min(1).max(createWhatsAppTemplateBodyNameMax),
  "language": zod.string().min(1).max(createWhatsAppTemplateBodyLanguageMax),
  "category": zod.enum(['marketing', 'utility', 'authentication']),
  "components": zod.array(zod.object({
  "providerType": zod.string().max(createWhatsAppTemplateBodyComponentsItemProviderTypeMax).optional(),
  "exampleValues": zod.array(zod.string().max(createWhatsAppTemplateBodyComponentsItemExampleValuesItemMax)).max(createWhatsAppTemplateBodyComponentsItemExampleValuesMax).optional(),
  "type": zod.enum(['header', 'body', 'footer', 'buttons', 'unsupported']),
  "format": zod.enum(['text', 'image', 'document', 'video']).optional(),
  "text": zod.string().min(createWhatsAppTemplateBodyComponentsItemTextMin).max(createWhatsAppTemplateBodyComponentsItemTextMax).optional(),
  "buttons": zod.array(zod.object({
  "type": zod.enum(['url', 'phone_number', 'quick_reply']),
  "text": zod.string().min(1).max(createWhatsAppTemplateBodyComponentsItemButtonsItemTextMax),
  "value": zod.string().min(1).max(createWhatsAppTemplateBodyComponentsItemButtonsItemValueMax).optional()
})).max(createWhatsAppTemplateBodyComponentsItemButtonsMax).optional()
})).max(createWhatsAppTemplateBodyComponentsMax),
  "requestKey": zod.uuid()
})

export const createWhatsAppTemplateResponseValidationErrorsItemMax = 200;

export const createWhatsAppTemplateResponseValidationErrorsMax = 50;


export const createWhatsAppTemplateResponseProviderTemplateIdMax = 200;

export const createWhatsAppTemplateResponseNameMax = 200;

export const createWhatsAppTemplateResponseLanguageMax = 35;

export const createWhatsAppTemplateResponseComponentsItemProviderTypeMax = 100;

export const createWhatsAppTemplateResponseComponentsItemExampleValuesItemMax = 2000;

export const createWhatsAppTemplateResponseComponentsItemExampleValuesMax = 40;

export const createWhatsAppTemplateResponseComponentsItemTextMin = 0;
export const createWhatsAppTemplateResponseComponentsItemTextMax = 4000;

export const createWhatsAppTemplateResponseComponentsItemButtonsItemTextMax = 100;

export const createWhatsAppTemplateResponseComponentsItemButtonsItemValueMax = 2000;

export const createWhatsAppTemplateResponseComponentsItemButtonsMax = 10;

export const createWhatsAppTemplateResponseComponentsMax = 10;

export const createWhatsAppTemplateResponseContentSha256RegExp = new RegExp('^[a-f0-9]{64}$');


export const createWhatsAppTemplateResponse = zod.object({
  "eligible": zod.boolean(),
  "validationErrors": zod.array(zod.string().max(createWhatsAppTemplateResponseValidationErrorsItemMax)).max(createWhatsAppTemplateResponseValidationErrorsMax),
  "id": zod.uuid(),
  "senderId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "version": zod.int().min(1),
  "providerTemplateId": zod.string().min(1).max(createWhatsAppTemplateResponseProviderTemplateIdMax),
  "name": zod.string().min(1).max(createWhatsAppTemplateResponseNameMax),
  "language": zod.string().min(1).max(createWhatsAppTemplateResponseLanguageMax),
  "category": zod.enum(['marketing', 'utility', 'authentication']),
  "approvalStatus": zod.enum(['pending', 'approved', 'rejected', 'paused', 'disabled', 'deleted', 'unavailable']),
  "components": zod.array(zod.object({
  "providerType": zod.string().max(createWhatsAppTemplateResponseComponentsItemProviderTypeMax).optional(),
  "exampleValues": zod.array(zod.string().max(createWhatsAppTemplateResponseComponentsItemExampleValuesItemMax)).max(createWhatsAppTemplateResponseComponentsItemExampleValuesMax).optional(),
  "type": zod.enum(['header', 'body', 'footer', 'buttons', 'unsupported']),
  "format": zod.enum(['text', 'image', 'document', 'video']).optional(),
  "text": zod.string().min(createWhatsAppTemplateResponseComponentsItemTextMin).max(createWhatsAppTemplateResponseComponentsItemTextMax).optional(),
  "buttons": zod.array(zod.object({
  "type": zod.enum(['url', 'phone_number', 'quick_reply']),
  "text": zod.string().min(1).max(createWhatsAppTemplateResponseComponentsItemButtonsItemTextMax),
  "value": zod.string().min(1).max(createWhatsAppTemplateResponseComponentsItemButtonsItemValueMax).optional()
})).max(createWhatsAppTemplateResponseComponentsItemButtonsMax).optional()
})).max(createWhatsAppTemplateResponseComponentsMax),
  "contentSha256": zod.string().regex(createWhatsAppTemplateResponseContentSha256RegExp),
  "updatedAt": zod.iso.datetime({"offset":true})
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.integrations.manage. Owner resolved from authorized server context.
 */
export const syncWhatsAppTemplatesBodyExpectedRevisionMin = 0;



export const syncWhatsAppTemplatesBody = zod.object({
  "expectedRevision": zod.int().min(syncWhatsAppTemplatesBodyExpectedRevisionMin),
  "requestKey": zod.uuid()
})

export const syncWhatsAppTemplatesResponseCodeMax = 200;

export const syncWhatsAppTemplatesResponseMessageMax = 1000;

export const syncWhatsAppTemplatesResponseChecksItemCodeMax = 200;

export const syncWhatsAppTemplatesResponseChecksItemMessageMax = 1000;

export const syncWhatsAppTemplatesResponseChecksMax = 100;



export const syncWhatsAppTemplatesResponse = zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(syncWhatsAppTemplatesResponseCodeMax),
  "message": zod.string().min(1).max(syncWhatsAppTemplatesResponseMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(syncWhatsAppTemplatesResponseChecksItemCodeMax),
  "message": zod.string().min(1).max(syncWhatsAppTemplatesResponseChecksItemMessageMax),
  "passed": zod.boolean()
})).max(syncWhatsAppTemplatesResponseChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.read. Owner resolved from authorized server context.
 */
export const getWhatsAppPermissionParams = zod.object({
  "contactId": zod.uuid()
})

export const getWhatsAppPermissionQueryRecipientNumberMax = 16;


export const getWhatsAppPermissionQueryRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');


export const getWhatsAppPermissionQueryParams = zod.object({
  "recipientNumber": zod.string().max(getWhatsAppPermissionQueryRecipientNumberMax).regex(getWhatsAppPermissionQueryRecipientNumberRegExp)
})

export const getWhatsAppPermissionResponseRecipientNumberMax = 16;


export const getWhatsAppPermissionResponseRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const getWhatsAppPermissionResponseRevisionMin = 0;



export const getWhatsAppPermissionResponse = zod.object({
  "contactId": zod.uuid(),
  "recipientNumber": zod.string().max(getWhatsAppPermissionResponseRecipientNumberMax).regex(getWhatsAppPermissionResponseRecipientNumberRegExp),
  "status": zod.enum(['unknown', 'opted_in', 'withdrawn']),
  "revision": zod.int().min(getWhatsAppPermissionResponseRevisionMin),
  "evidenceId": zod.uuid().nullable()
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.write. Owner resolved from authorized server context.
 */
export const recordWhatsAppPermissionParams = zod.object({
  "contactId": zod.uuid()
})

export const recordWhatsAppPermissionBodyRecipientNumberMax = 16;


export const recordWhatsAppPermissionBodyRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const recordWhatsAppPermissionBodyExpectedRevisionMin = 0;

export const recordWhatsAppPermissionBodyPurposeMax = 1000;

export const recordWhatsAppPermissionBodyWordingMax = 4000;

export const recordWhatsAppPermissionBodySourceMax = 200;

export const recordWhatsAppPermissionBodyEvidenceReferenceMax = 1000;



export const recordWhatsAppPermissionBody = zod.object({
  "recipientNumber": zod.string().max(recordWhatsAppPermissionBodyRecipientNumberMax).regex(recordWhatsAppPermissionBodyRecipientNumberRegExp),
  "expectedRevision": zod.int().min(recordWhatsAppPermissionBodyExpectedRevisionMin),
  "purpose": zod.string().min(1).max(recordWhatsAppPermissionBodyPurposeMax),
  "wording": zod.string().min(1).max(recordWhatsAppPermissionBodyWordingMax),
  "source": zod.string().min(1).max(recordWhatsAppPermissionBodySourceMax),
  "consentAt": zod.iso.datetime({"offset":true}),
  "evidenceReference": zod.string().min(1).max(recordWhatsAppPermissionBodyEvidenceReferenceMax),
  "requestKey": zod.uuid()
})

export const recordWhatsAppPermissionResponseRecipientNumberMax = 16;


export const recordWhatsAppPermissionResponseRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const recordWhatsAppPermissionResponseRevisionMin = 0;



export const recordWhatsAppPermissionResponse = zod.object({
  "contactId": zod.uuid(),
  "recipientNumber": zod.string().max(recordWhatsAppPermissionResponseRecipientNumberMax).regex(recordWhatsAppPermissionResponseRecipientNumberRegExp),
  "status": zod.enum(['unknown', 'opted_in', 'withdrawn']),
  "revision": zod.int().min(recordWhatsAppPermissionResponseRevisionMin),
  "evidenceId": zod.uuid().nullable()
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.write. Owner resolved from authorized server context.
 */
export const withdrawWhatsAppPermissionParams = zod.object({
  "contactId": zod.uuid()
})

export const withdrawWhatsAppPermissionBodyRecipientNumberMax = 16;


export const withdrawWhatsAppPermissionBodyRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const withdrawWhatsAppPermissionBodyExpectedRevisionMin = 0;

export const withdrawWhatsAppPermissionBodyReasonMax = 1000;

export const withdrawWhatsAppPermissionBodyEvidenceReferenceMax = 1000;



export const withdrawWhatsAppPermissionBody = zod.object({
  "recipientNumber": zod.string().max(withdrawWhatsAppPermissionBodyRecipientNumberMax).regex(withdrawWhatsAppPermissionBodyRecipientNumberRegExp),
  "expectedRevision": zod.int().min(withdrawWhatsAppPermissionBodyExpectedRevisionMin),
  "reason": zod.string().min(1).max(withdrawWhatsAppPermissionBodyReasonMax),
  "evidenceReference": zod.string().min(1).max(withdrawWhatsAppPermissionBodyEvidenceReferenceMax),
  "requestKey": zod.uuid()
})

export const withdrawWhatsAppPermissionResponseRecipientNumberMax = 16;


export const withdrawWhatsAppPermissionResponseRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const withdrawWhatsAppPermissionResponseRevisionMin = 0;



export const withdrawWhatsAppPermissionResponse = zod.object({
  "contactId": zod.uuid(),
  "recipientNumber": zod.string().max(withdrawWhatsAppPermissionResponseRecipientNumberMax).regex(withdrawWhatsAppPermissionResponseRecipientNumberRegExp),
  "status": zod.enum(['unknown', 'opted_in', 'withdrawn']),
  "revision": zod.int().min(withdrawWhatsAppPermissionResponseRevisionMin),
  "evidenceId": zod.uuid().nullable()
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.read. Owner resolved from authorized server context.
 */
export const listWhatsAppPermissionEvidenceParams = zod.object({
  "contactId": zod.uuid()
})

export const listWhatsAppPermissionEvidenceQueryLimitDefault = 25;
export const listWhatsAppPermissionEvidenceQueryLimitMax = 100;

export const listWhatsAppPermissionEvidenceQueryOffsetDefault = 0;
export const listWhatsAppPermissionEvidenceQueryOffsetMin = 0;



export const listWhatsAppPermissionEvidenceQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWhatsAppPermissionEvidenceQueryLimitMax).default(listWhatsAppPermissionEvidenceQueryLimitDefault),
  "offset": zod.int().min(listWhatsAppPermissionEvidenceQueryOffsetMin).default(listWhatsAppPermissionEvidenceQueryOffsetDefault)
})

export const listWhatsAppPermissionEvidenceResponseItemsItemRecipientNumberMax = 16;


export const listWhatsAppPermissionEvidenceResponseItemsItemRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');

export const listWhatsAppPermissionEvidenceResponseItemsItemPurposeMax = 1000;

export const listWhatsAppPermissionEvidenceResponseItemsItemWordingMax = 4000;

export const listWhatsAppPermissionEvidenceResponseItemsItemSourceMax = 200;

export const listWhatsAppPermissionEvidenceResponseItemsItemRecordedByMax = 200;

export const listWhatsAppPermissionEvidenceResponseItemsItemEvidenceReferenceMax = 1000;

export const listWhatsAppPermissionEvidenceResponseItemsMax = 100;

export const listWhatsAppPermissionEvidenceResponseTotalMin = 0;



export const listWhatsAppPermissionEvidenceResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "contactId": zod.uuid(),
  "recipientNumber": zod.string().max(listWhatsAppPermissionEvidenceResponseItemsItemRecipientNumberMax).regex(listWhatsAppPermissionEvidenceResponseItemsItemRecipientNumberRegExp),
  "revision": zod.int().min(1),
  "action": zod.enum(['recorded', 'withdrawn']),
  "purpose": zod.string().min(1).max(listWhatsAppPermissionEvidenceResponseItemsItemPurposeMax),
  "wording": zod.string().min(1).max(listWhatsAppPermissionEvidenceResponseItemsItemWordingMax),
  "source": zod.string().min(1).max(listWhatsAppPermissionEvidenceResponseItemsItemSourceMax),
  "consentAt": zod.iso.datetime({"offset":true}),
  "recordedBy": zod.string().min(1).max(listWhatsAppPermissionEvidenceResponseItemsItemRecordedByMax),
  "evidenceReference": zod.string().min(1).max(listWhatsAppPermissionEvidenceResponseItemsItemEvidenceReferenceMax),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(listWhatsAppPermissionEvidenceResponseItemsMax),
  "total": zod.int().min(listWhatsAppPermissionEvidenceResponseTotalMin)
})


export const getWhatsAppCampaignStepParams = zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid()
})

export const getWhatsAppCampaignStepResponseOneParameterBindingsMinOne = 0;
export const getWhatsAppCampaignStepResponseOneParameterBindingsMaxOne = 2000;




export const getWhatsAppCampaignStepResponse = zod.union([zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid(),
  "templateId": zod.uuid(),
  "templateSnapshotId": zod.uuid(),
  "parameterBindings": zod.record(zod.string(), zod.string().min(getWhatsAppCampaignStepResponseOneParameterBindingsMinOne).max(getWhatsAppCampaignStepResponseOneParameterBindingsMaxOne)),
  "revision": zod.int().min(1)
}),zod.null()])


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.content.manage. Owner resolved from authorized server context.
 */
export const updateWhatsAppCampaignStepParams = zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid()
})

export const updateWhatsAppCampaignStepBodyParameterBindingsMinOne = 0;
export const updateWhatsAppCampaignStepBodyParameterBindingsMaxOne = 2000;

export const updateWhatsAppCampaignStepBodyExpectedRevisionMin = 0;



export const updateWhatsAppCampaignStepBody = zod.object({
  "templateId": zod.uuid(),
  "templateSnapshotId": zod.uuid(),
  "parameterBindings": zod.record(zod.string(), zod.string().min(updateWhatsAppCampaignStepBodyParameterBindingsMinOne).max(updateWhatsAppCampaignStepBodyParameterBindingsMaxOne)),
  "expectedRevision": zod.int().min(updateWhatsAppCampaignStepBodyExpectedRevisionMin),
  "requestKey": zod.uuid()
})

export const updateWhatsAppCampaignStepResponseParameterBindingsMinOne = 0;
export const updateWhatsAppCampaignStepResponseParameterBindingsMaxOne = 2000;




export const updateWhatsAppCampaignStepResponse = zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid(),
  "templateId": zod.uuid(),
  "templateSnapshotId": zod.uuid(),
  "parameterBindings": zod.record(zod.string(), zod.string().min(updateWhatsAppCampaignStepResponseParameterBindingsMinOne).max(updateWhatsAppCampaignStepResponseParameterBindingsMaxOne)),
  "revision": zod.int().min(1)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.content.manage. Owner resolved from authorized server context.
 */
export const previewWhatsAppRecipientsParams = zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid()
})

export const previewWhatsAppRecipientsQueryLimitDefault = 25;
export const previewWhatsAppRecipientsQueryLimitMax = 100;

export const previewWhatsAppRecipientsQueryOffsetDefault = 0;
export const previewWhatsAppRecipientsQueryOffsetMin = 0;



export const previewWhatsAppRecipientsQueryParams = zod.object({
  "limit": zod.int().min(1).max(previewWhatsAppRecipientsQueryLimitMax).default(previewWhatsAppRecipientsQueryLimitDefault),
  "offset": zod.int().min(previewWhatsAppRecipientsQueryOffsetMin).default(previewWhatsAppRecipientsQueryOffsetDefault)
})

export const previewWhatsAppRecipientsResponseItemsItemRecipientIndexMin = 0;

export const previewWhatsAppRecipientsResponseItemsItemResolvedContentMax = 6400;

export const previewWhatsAppRecipientsResponseItemsItemRecipientNumberMax = 16;


export const previewWhatsAppRecipientsResponseItemsItemRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const previewWhatsAppRecipientsResponseItemsItemExclusionReasonsMax = 20;

export const previewWhatsAppRecipientsResponseItemsItemPermissionRevisionMin = 0;

export const previewWhatsAppRecipientsResponseItemsItemResolvedParametersMinOne = 0;
export const previewWhatsAppRecipientsResponseItemsItemResolvedParametersMaxOne = 2000;

export const previewWhatsAppRecipientsResponseItemsMax = 100;

export const previewWhatsAppRecipientsResponseTotalMin = 0;

export const previewWhatsAppRecipientsResponseEligibleCountMin = 0;

export const previewWhatsAppRecipientsResponseExcludedCountMin = 0;

export const previewWhatsAppRecipientsResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const previewWhatsAppRecipientsResponse = zod.object({
  "launchable": zod.boolean().describe('False until a later durable launch review is persisted and readiness is proved.'),
  "items": zod.array(zod.object({
  "recipientIndex": zod.int().min(previewWhatsAppRecipientsResponseItemsItemRecipientIndexMin),
  "resolvedContent": zod.string().max(previewWhatsAppRecipientsResponseItemsItemResolvedContentMax).nullable(),
  "contactId": zod.uuid().nullable(),
  "recipientNumber": zod.string().max(previewWhatsAppRecipientsResponseItemsItemRecipientNumberMax).regex(previewWhatsAppRecipientsResponseItemsItemRecipientNumberRegExp).nullable(),
  "country": zod.enum(['AU', 'NZ']).nullable(),
  "eligible": zod.boolean(),
  "exclusionReasons": zod.array(zod.enum(['permission_unknown', 'permission_withdrawn', 'number_changed', 'invalid_number', 'unsupported_country', 'suppressed', 'sender_unavailable', 'sender_changed', 'template_unapproved', 'template_changed', 'missing_parameter', 'duplicate_number', 'contact_unavailable', 'campaign_paused', 'service_window_closed', 'template_stale', 'template_unavailable', 'unsupported_component', 'invalid_parameter', 'conflicting_contact_ownership', 'incomplete_evidence', 'do_not_phone', 'ambiguous_contact'])).max(previewWhatsAppRecipientsResponseItemsItemExclusionReasonsMax),
  "permissionRevision": zod.int().min(previewWhatsAppRecipientsResponseItemsItemPermissionRevisionMin),
  "resolvedParameters": zod.record(zod.string(), zod.string().min(previewWhatsAppRecipientsResponseItemsItemResolvedParametersMinOne).max(previewWhatsAppRecipientsResponseItemsItemResolvedParametersMaxOne))
})).max(previewWhatsAppRecipientsResponseItemsMax),
  "total": zod.int().min(previewWhatsAppRecipientsResponseTotalMin),
  "eligibleCount": zod.int().min(previewWhatsAppRecipientsResponseEligibleCountMin),
  "excludedCount": zod.int().min(previewWhatsAppRecipientsResponseExcludedCountMin),
  "previewId": zod.uuid().nullable(),
  "fingerprint": zod.string().regex(previewWhatsAppRecipientsResponseFingerprintRegExp),
  "senderRevisionId": zod.uuid().nullable(),
  "templateSnapshotId": zod.uuid().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.content.manage. Owner resolved from authorized server context.
 */
export const sendWhatsAppCampaignStepParams = zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid()
})

export const sendWhatsAppCampaignStepBodyFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const sendWhatsAppCampaignStepBody = zod.object({
  "previewId": zod.uuid(),
  "fingerprint": zod.string().regex(sendWhatsAppCampaignStepBodyFingerprintRegExp),
  "requestKey": zod.uuid(),
  "scheduledAt": zod.iso.datetime({"offset":true}).optional()
})

export const sendWhatsAppCampaignStepResponseQueuedMin = 0;

export const sendWhatsAppCampaignStepResponseExcludedMin = 0;



export const sendWhatsAppCampaignStepResponse = zod.object({
  "queued": zod.int().min(sendWhatsAppCampaignStepResponseQueuedMin),
  "excluded": zod.int().min(sendWhatsAppCampaignStepResponseExcludedMin),
  "requestKey": zod.uuid()
})


/**
 * Persist a ten-minute actor-bound review of the entire current recipient set. No send is performed.
 */
export const reviewWhatsAppCampaignStepParams = zod.object({
  "campaignId": zod.uuid(),
  "stepId": zod.uuid()
})

export const reviewWhatsAppCampaignStepResponseItemsItemRecipientIndexMin = 0;

export const reviewWhatsAppCampaignStepResponseItemsItemResolvedContentMax = 6400;

export const reviewWhatsAppCampaignStepResponseItemsItemRecipientNumberMax = 16;


export const reviewWhatsAppCampaignStepResponseItemsItemRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const reviewWhatsAppCampaignStepResponseItemsItemExclusionReasonsMax = 20;

export const reviewWhatsAppCampaignStepResponseItemsItemPermissionRevisionMin = 0;

export const reviewWhatsAppCampaignStepResponseItemsItemResolvedParametersMinOne = 0;
export const reviewWhatsAppCampaignStepResponseItemsItemResolvedParametersMaxOne = 2000;

export const reviewWhatsAppCampaignStepResponseItemsMax = 100;

export const reviewWhatsAppCampaignStepResponseTotalMin = 0;

export const reviewWhatsAppCampaignStepResponseEligibleCountMin = 0;

export const reviewWhatsAppCampaignStepResponseExcludedCountMin = 0;

export const reviewWhatsAppCampaignStepResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const reviewWhatsAppCampaignStepResponse = zod.object({
  "launchable": zod.boolean().describe('False until a later durable launch review is persisted and readiness is proved.'),
  "items": zod.array(zod.object({
  "recipientIndex": zod.int().min(reviewWhatsAppCampaignStepResponseItemsItemRecipientIndexMin),
  "resolvedContent": zod.string().max(reviewWhatsAppCampaignStepResponseItemsItemResolvedContentMax).nullable(),
  "contactId": zod.uuid().nullable(),
  "recipientNumber": zod.string().max(reviewWhatsAppCampaignStepResponseItemsItemRecipientNumberMax).regex(reviewWhatsAppCampaignStepResponseItemsItemRecipientNumberRegExp).nullable(),
  "country": zod.enum(['AU', 'NZ']).nullable(),
  "eligible": zod.boolean(),
  "exclusionReasons": zod.array(zod.enum(['permission_unknown', 'permission_withdrawn', 'number_changed', 'invalid_number', 'unsupported_country', 'suppressed', 'sender_unavailable', 'sender_changed', 'template_unapproved', 'template_changed', 'missing_parameter', 'duplicate_number', 'contact_unavailable', 'campaign_paused', 'service_window_closed', 'template_stale', 'template_unavailable', 'unsupported_component', 'invalid_parameter', 'conflicting_contact_ownership', 'incomplete_evidence', 'do_not_phone', 'ambiguous_contact'])).max(reviewWhatsAppCampaignStepResponseItemsItemExclusionReasonsMax),
  "permissionRevision": zod.int().min(reviewWhatsAppCampaignStepResponseItemsItemPermissionRevisionMin),
  "resolvedParameters": zod.record(zod.string(), zod.string().min(reviewWhatsAppCampaignStepResponseItemsItemResolvedParametersMinOne).max(reviewWhatsAppCampaignStepResponseItemsItemResolvedParametersMaxOne))
})).max(reviewWhatsAppCampaignStepResponseItemsMax),
  "total": zod.int().min(reviewWhatsAppCampaignStepResponseTotalMin),
  "eligibleCount": zod.int().min(reviewWhatsAppCampaignStepResponseEligibleCountMin),
  "excludedCount": zod.int().min(reviewWhatsAppCampaignStepResponseExcludedCountMin),
  "previewId": zod.uuid().nullable(),
  "fingerprint": zod.string().regex(reviewWhatsAppCampaignStepResponseFingerprintRegExp),
  "senderRevisionId": zod.uuid().nullable(),
  "templateSnapshotId": zod.uuid().nullable(),
  "expiresAt": zod.iso.datetime({"offset":true})
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.content.manage. Owner resolved from authorized server context.
 */
export const sendWhatsAppTestBodyRecipientNumberMax = 16;


export const sendWhatsAppTestBodyRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const sendWhatsAppTestBodyResolvedParametersMinOne = 0;
export const sendWhatsAppTestBodyResolvedParametersMaxOne = 2000;



export const sendWhatsAppTestBody = zod.object({
  "contactId": zod.uuid(),
  "recipientNumber": zod.string().max(sendWhatsAppTestBodyRecipientNumberMax).regex(sendWhatsAppTestBodyRecipientNumberRegExp),
  "templateSnapshotId": zod.uuid(),
  "resolvedParameters": zod.record(zod.string(), zod.string().min(sendWhatsAppTestBodyResolvedParametersMinOne).max(sendWhatsAppTestBodyResolvedParametersMaxOne)),
  "requestKey": zod.uuid()
})

export const sendWhatsAppTestResponseMessageProviderAccountIdMax = 200;

export const sendWhatsAppTestResponseMessageProviderPhoneNumberIdMax = 200;

export const sendWhatsAppTestResponseMessageProviderMessageIdMax = 200;

export const sendWhatsAppTestResponseMessageFromNumberMax = 16;


export const sendWhatsAppTestResponseMessageFromNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const sendWhatsAppTestResponseMessageToNumberMax = 16;


export const sendWhatsAppTestResponseMessageToNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const sendWhatsAppTestResponseMessageBodyMin = 0;
export const sendWhatsAppTestResponseMessageBodyMax = 6400;

export const sendWhatsAppTestResponseMessageUnsupportedTypeMax = 200;

export const sendWhatsAppTestResponseMessageResolvedParametersMinOne = 0;
export const sendWhatsAppTestResponseMessageResolvedParametersMaxOne = 2000;

export const sendWhatsAppTestResponseMessageAuthorIdMax = 200;

export const sendWhatsAppTestResponseMessageErrorCodeMax = 200;

export const sendWhatsAppTestResponseAttemptCountMin = 0;

export const sendWhatsAppTestResponseReasonMin = 0;
export const sendWhatsAppTestResponseReasonMax = 1000;

export const sendWhatsAppTestResponseLastErrorCodeMax = 200;



export const sendWhatsAppTestResponse = zod.object({
  "id": zod.uuid(),
  "message": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "senderId": zod.uuid(),
  "senderRevisionId": zod.uuid(),
  "providerAccountId": zod.string().min(1).max(sendWhatsAppTestResponseMessageProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(sendWhatsAppTestResponseMessageProviderPhoneNumberIdMax),
  "providerMessageId": zod.string().min(1).max(sendWhatsAppTestResponseMessageProviderMessageIdMax).nullable(),
  "contactId": zod.uuid().nullable(),
  "campaignId": zod.uuid().nullable(),
  "stepId": zod.uuid().nullable(),
  "interactionId": zod.uuid().nullable(),
  "parentMessageId": zod.uuid().nullable(),
  "templateSnapshotId": zod.uuid().nullable(),
  "fromNumber": zod.string().max(sendWhatsAppTestResponseMessageFromNumberMax).regex(sendWhatsAppTestResponseMessageFromNumberRegExp),
  "toNumber": zod.string().max(sendWhatsAppTestResponseMessageToNumberMax).regex(sendWhatsAppTestResponseMessageToNumberRegExp),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['campaign', 'test', 'staff_reply', 'inbound']),
  "contentType": zod.enum(['text', 'template', 'image', 'audio', 'video', 'document', 'unsupported']),
  "body": zod.string().min(sendWhatsAppTestResponseMessageBodyMin).max(sendWhatsAppTestResponseMessageBodyMax).nullable(),
  "fileId": zod.uuid().nullable(),
  "mediaStatus": zod.enum(['none', 'pending', 'ready', 'unsupported', 'unavailable']).optional(),
  "unsupportedType": zod.string().min(1).max(sendWhatsAppTestResponseMessageUnsupportedTypeMax).nullable(),
  "resolvedParameters": zod.record(zod.string(), zod.string().min(sendWhatsAppTestResponseMessageResolvedParametersMinOne).max(sendWhatsAppTestResponseMessageResolvedParametersMaxOne)),
  "status": zod.enum(['queued', 'accepted', 'sent', 'delivered', 'read', 'failed', 'unknown', 'received', 'suppressed', 'cancelled']),
  "authorId": zod.string().min(1).max(sendWhatsAppTestResponseMessageAuthorIdMax).nullable(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "sentAt": zod.iso.datetime({"offset":true}).nullable(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "readAt": zod.iso.datetime({"offset":true}).nullable(),
  "receivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().min(1).max(sendWhatsAppTestResponseMessageErrorCodeMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'accepted', 'suppressed', 'failed', 'unknown', 'cancelled']),
  "attemptCount": zod.int().min(sendWhatsAppTestResponseAttemptCountMin),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable(),
  "reason": zod.string().min(sendWhatsAppTestResponseReasonMin).max(sendWhatsAppTestResponseReasonMax).nullable(),
  "lastErrorCode": zod.string().min(1).max(sendWhatsAppTestResponseLastErrorCodeMax).nullable()
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.content.manage. Owner resolved from authorized server context.
 */
export const listWhatsAppDeliveriesParams = zod.object({
  "campaignId": zod.uuid()
})

export const listWhatsAppDeliveriesQueryLimitDefault = 25;
export const listWhatsAppDeliveriesQueryLimitMax = 100;

export const listWhatsAppDeliveriesQueryOffsetDefault = 0;
export const listWhatsAppDeliveriesQueryOffsetMin = 0;



export const listWhatsAppDeliveriesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWhatsAppDeliveriesQueryLimitMax).default(listWhatsAppDeliveriesQueryLimitDefault),
  "offset": zod.int().min(listWhatsAppDeliveriesQueryOffsetMin).default(listWhatsAppDeliveriesQueryOffsetDefault)
})

export const listWhatsAppDeliveriesResponseItemsItemMessageProviderAccountIdMax = 200;

export const listWhatsAppDeliveriesResponseItemsItemMessageProviderPhoneNumberIdMax = 200;

export const listWhatsAppDeliveriesResponseItemsItemMessageProviderMessageIdMax = 200;

export const listWhatsAppDeliveriesResponseItemsItemMessageFromNumberMax = 16;


export const listWhatsAppDeliveriesResponseItemsItemMessageFromNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const listWhatsAppDeliveriesResponseItemsItemMessageToNumberMax = 16;


export const listWhatsAppDeliveriesResponseItemsItemMessageToNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const listWhatsAppDeliveriesResponseItemsItemMessageBodyMin = 0;
export const listWhatsAppDeliveriesResponseItemsItemMessageBodyMax = 6400;

export const listWhatsAppDeliveriesResponseItemsItemMessageUnsupportedTypeMax = 200;

export const listWhatsAppDeliveriesResponseItemsItemMessageResolvedParametersMinOne = 0;
export const listWhatsAppDeliveriesResponseItemsItemMessageResolvedParametersMaxOne = 2000;

export const listWhatsAppDeliveriesResponseItemsItemMessageAuthorIdMax = 200;

export const listWhatsAppDeliveriesResponseItemsItemMessageErrorCodeMax = 200;

export const listWhatsAppDeliveriesResponseItemsItemAttemptCountMin = 0;

export const listWhatsAppDeliveriesResponseItemsItemReasonMin = 0;
export const listWhatsAppDeliveriesResponseItemsItemReasonMax = 1000;

export const listWhatsAppDeliveriesResponseItemsItemLastErrorCodeMax = 200;

export const listWhatsAppDeliveriesResponseItemsMax = 100;

export const listWhatsAppDeliveriesResponseTotalMin = 0;



export const listWhatsAppDeliveriesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "message": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "senderId": zod.uuid(),
  "senderRevisionId": zod.uuid(),
  "providerAccountId": zod.string().min(1).max(listWhatsAppDeliveriesResponseItemsItemMessageProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(listWhatsAppDeliveriesResponseItemsItemMessageProviderPhoneNumberIdMax),
  "providerMessageId": zod.string().min(1).max(listWhatsAppDeliveriesResponseItemsItemMessageProviderMessageIdMax).nullable(),
  "contactId": zod.uuid().nullable(),
  "campaignId": zod.uuid().nullable(),
  "stepId": zod.uuid().nullable(),
  "interactionId": zod.uuid().nullable(),
  "parentMessageId": zod.uuid().nullable(),
  "templateSnapshotId": zod.uuid().nullable(),
  "fromNumber": zod.string().max(listWhatsAppDeliveriesResponseItemsItemMessageFromNumberMax).regex(listWhatsAppDeliveriesResponseItemsItemMessageFromNumberRegExp),
  "toNumber": zod.string().max(listWhatsAppDeliveriesResponseItemsItemMessageToNumberMax).regex(listWhatsAppDeliveriesResponseItemsItemMessageToNumberRegExp),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['campaign', 'test', 'staff_reply', 'inbound']),
  "contentType": zod.enum(['text', 'template', 'image', 'audio', 'video', 'document', 'unsupported']),
  "body": zod.string().min(listWhatsAppDeliveriesResponseItemsItemMessageBodyMin).max(listWhatsAppDeliveriesResponseItemsItemMessageBodyMax).nullable(),
  "fileId": zod.uuid().nullable(),
  "mediaStatus": zod.enum(['none', 'pending', 'ready', 'unsupported', 'unavailable']).optional(),
  "unsupportedType": zod.string().min(1).max(listWhatsAppDeliveriesResponseItemsItemMessageUnsupportedTypeMax).nullable(),
  "resolvedParameters": zod.record(zod.string(), zod.string().min(listWhatsAppDeliveriesResponseItemsItemMessageResolvedParametersMinOne).max(listWhatsAppDeliveriesResponseItemsItemMessageResolvedParametersMaxOne)),
  "status": zod.enum(['queued', 'accepted', 'sent', 'delivered', 'read', 'failed', 'unknown', 'received', 'suppressed', 'cancelled']),
  "authorId": zod.string().min(1).max(listWhatsAppDeliveriesResponseItemsItemMessageAuthorIdMax).nullable(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "sentAt": zod.iso.datetime({"offset":true}).nullable(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "readAt": zod.iso.datetime({"offset":true}).nullable(),
  "receivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().min(1).max(listWhatsAppDeliveriesResponseItemsItemMessageErrorCodeMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'accepted', 'suppressed', 'failed', 'unknown', 'cancelled']),
  "attemptCount": zod.int().min(listWhatsAppDeliveriesResponseItemsItemAttemptCountMin),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable(),
  "reason": zod.string().min(listWhatsAppDeliveriesResponseItemsItemReasonMin).max(listWhatsAppDeliveriesResponseItemsItemReasonMax).nullable(),
  "lastErrorCode": zod.string().min(1).max(listWhatsAppDeliveriesResponseItemsItemLastErrorCodeMax).nullable()
})).max(listWhatsAppDeliveriesResponseItemsMax),
  "total": zod.int().min(listWhatsAppDeliveriesResponseTotalMin)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.content.manage. Owner resolved from authorized server context.
 */
export const getWhatsAppCampaignSummaryParams = zod.object({
  "campaignId": zod.uuid()
})

export const getWhatsAppCampaignSummaryResponseTotalMin = 0;

export const getWhatsAppCampaignSummaryResponseCountsQueuedMin = 0;

export const getWhatsAppCampaignSummaryResponseCountsAcceptedMin = 0;

export const getWhatsAppCampaignSummaryResponseCountsSentMin = 0;

export const getWhatsAppCampaignSummaryResponseCountsDeliveredMin = 0;

export const getWhatsAppCampaignSummaryResponseCountsReadMin = 0;

export const getWhatsAppCampaignSummaryResponseCountsFailedMin = 0;

export const getWhatsAppCampaignSummaryResponseCountsUnknownMin = 0;

export const getWhatsAppCampaignSummaryResponseCountsSuppressedMin = 0;

export const getWhatsAppCampaignSummaryResponseCountsCancelledMin = 0;

export const getWhatsAppCampaignSummaryResponseProviderRateMin = 0;



export const getWhatsAppCampaignSummaryResponse = zod.object({
  "campaignId": zod.uuid(),
  "total": zod.int().min(getWhatsAppCampaignSummaryResponseTotalMin),
  "counts": zod.object({
  "queued": zod.int().min(getWhatsAppCampaignSummaryResponseCountsQueuedMin),
  "accepted": zod.int().min(getWhatsAppCampaignSummaryResponseCountsAcceptedMin),
  "sent": zod.int().min(getWhatsAppCampaignSummaryResponseCountsSentMin),
  "delivered": zod.int().min(getWhatsAppCampaignSummaryResponseCountsDeliveredMin),
  "read": zod.int().min(getWhatsAppCampaignSummaryResponseCountsReadMin),
  "failed": zod.int().min(getWhatsAppCampaignSummaryResponseCountsFailedMin),
  "unknown": zod.int().min(getWhatsAppCampaignSummaryResponseCountsUnknownMin),
  "suppressed": zod.int().min(getWhatsAppCampaignSummaryResponseCountsSuppressedMin),
  "cancelled": zod.int().min(getWhatsAppCampaignSummaryResponseCountsCancelledMin)
}),
  "providerRate": zod.int().min(getWhatsAppCampaignSummaryResponseProviderRateMin).nullable(),
  "rateSource": zod.enum(['provider', 'unavailable']),
  "readReceiptsMayBeAbsent": zod.boolean(),
  "costEstimate": zod.object({
  "amount": zod.number().nullable(),
  "currency": zod.string().nullable(),
  "source": zod.enum(['unavailable']),
  "asOf": zod.iso.datetime({"offset":true}).nullable(),
  "billed": zod.literal(false)
})
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.content.manage. Owner resolved from authorized server context.
 */
export const pauseWhatsAppCampaignParams = zod.object({
  "campaignId": zod.uuid()
})

export const pauseWhatsAppCampaignBody = zod.object({
  "expectedUpdatedAt": zod.iso.datetime({"offset":true}),
  "requestKey": zod.uuid()
})

export const pauseWhatsAppCampaignResponseQueuedMin = 0;

export const pauseWhatsAppCampaignResponseExcludedMin = 0;



export const pauseWhatsAppCampaignResponse = zod.object({
  "queued": zod.int().min(pauseWhatsAppCampaignResponseQueuedMin),
  "excluded": zod.int().min(pauseWhatsAppCampaignResponseExcludedMin),
  "requestKey": zod.uuid()
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.content.manage. Owner resolved from authorized server context.
 */
export const retryWhatsAppDeliveryParams = zod.object({
  "id": zod.uuid()
})

export const retryWhatsAppDeliveryBodyExpectedRevisionMin = 0;



export const retryWhatsAppDeliveryBody = zod.object({
  "expectedRevision": zod.int().min(retryWhatsAppDeliveryBodyExpectedRevisionMin),
  "requestKey": zod.uuid()
})

export const retryWhatsAppDeliveryResponseMessageProviderAccountIdMax = 200;

export const retryWhatsAppDeliveryResponseMessageProviderPhoneNumberIdMax = 200;

export const retryWhatsAppDeliveryResponseMessageProviderMessageIdMax = 200;

export const retryWhatsAppDeliveryResponseMessageFromNumberMax = 16;


export const retryWhatsAppDeliveryResponseMessageFromNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const retryWhatsAppDeliveryResponseMessageToNumberMax = 16;


export const retryWhatsAppDeliveryResponseMessageToNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const retryWhatsAppDeliveryResponseMessageBodyMin = 0;
export const retryWhatsAppDeliveryResponseMessageBodyMax = 6400;

export const retryWhatsAppDeliveryResponseMessageUnsupportedTypeMax = 200;

export const retryWhatsAppDeliveryResponseMessageResolvedParametersMinOne = 0;
export const retryWhatsAppDeliveryResponseMessageResolvedParametersMaxOne = 2000;

export const retryWhatsAppDeliveryResponseMessageAuthorIdMax = 200;

export const retryWhatsAppDeliveryResponseMessageErrorCodeMax = 200;

export const retryWhatsAppDeliveryResponseAttemptCountMin = 0;

export const retryWhatsAppDeliveryResponseReasonMin = 0;
export const retryWhatsAppDeliveryResponseReasonMax = 1000;

export const retryWhatsAppDeliveryResponseLastErrorCodeMax = 200;



export const retryWhatsAppDeliveryResponse = zod.object({
  "id": zod.uuid(),
  "message": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "senderId": zod.uuid(),
  "senderRevisionId": zod.uuid(),
  "providerAccountId": zod.string().min(1).max(retryWhatsAppDeliveryResponseMessageProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(retryWhatsAppDeliveryResponseMessageProviderPhoneNumberIdMax),
  "providerMessageId": zod.string().min(1).max(retryWhatsAppDeliveryResponseMessageProviderMessageIdMax).nullable(),
  "contactId": zod.uuid().nullable(),
  "campaignId": zod.uuid().nullable(),
  "stepId": zod.uuid().nullable(),
  "interactionId": zod.uuid().nullable(),
  "parentMessageId": zod.uuid().nullable(),
  "templateSnapshotId": zod.uuid().nullable(),
  "fromNumber": zod.string().max(retryWhatsAppDeliveryResponseMessageFromNumberMax).regex(retryWhatsAppDeliveryResponseMessageFromNumberRegExp),
  "toNumber": zod.string().max(retryWhatsAppDeliveryResponseMessageToNumberMax).regex(retryWhatsAppDeliveryResponseMessageToNumberRegExp),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['campaign', 'test', 'staff_reply', 'inbound']),
  "contentType": zod.enum(['text', 'template', 'image', 'audio', 'video', 'document', 'unsupported']),
  "body": zod.string().min(retryWhatsAppDeliveryResponseMessageBodyMin).max(retryWhatsAppDeliveryResponseMessageBodyMax).nullable(),
  "fileId": zod.uuid().nullable(),
  "mediaStatus": zod.enum(['none', 'pending', 'ready', 'unsupported', 'unavailable']).optional(),
  "unsupportedType": zod.string().min(1).max(retryWhatsAppDeliveryResponseMessageUnsupportedTypeMax).nullable(),
  "resolvedParameters": zod.record(zod.string(), zod.string().min(retryWhatsAppDeliveryResponseMessageResolvedParametersMinOne).max(retryWhatsAppDeliveryResponseMessageResolvedParametersMaxOne)),
  "status": zod.enum(['queued', 'accepted', 'sent', 'delivered', 'read', 'failed', 'unknown', 'received', 'suppressed', 'cancelled']),
  "authorId": zod.string().min(1).max(retryWhatsAppDeliveryResponseMessageAuthorIdMax).nullable(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "sentAt": zod.iso.datetime({"offset":true}).nullable(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "readAt": zod.iso.datetime({"offset":true}).nullable(),
  "receivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().min(1).max(retryWhatsAppDeliveryResponseMessageErrorCodeMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'accepted', 'suppressed', 'failed', 'unknown', 'cancelled']),
  "attemptCount": zod.int().min(retryWhatsAppDeliveryResponseAttemptCountMin),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable(),
  "reason": zod.string().min(retryWhatsAppDeliveryResponseReasonMin).max(retryWhatsAppDeliveryResponseReasonMax).nullable(),
  "lastErrorCode": zod.string().min(1).max(retryWhatsAppDeliveryResponseLastErrorCodeMax).nullable()
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.read. Owner resolved from authorized server context.
 */
export const listWhatsAppConversationsQueryLimitDefault = 25;
export const listWhatsAppConversationsQueryLimitMax = 100;

export const listWhatsAppConversationsQueryOffsetDefault = 0;
export const listWhatsAppConversationsQueryOffsetMin = 0;



export const listWhatsAppConversationsQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWhatsAppConversationsQueryLimitMax).default(listWhatsAppConversationsQueryLimitDefault),
  "offset": zod.int().min(listWhatsAppConversationsQueryOffsetMin).default(listWhatsAppConversationsQueryOffsetDefault),
  "contactId": zod.uuid().optional(),
  "status": zod.enum(['open', 'closed']).optional()
})

export const listWhatsAppConversationsResponseItemsItemRecipientNumberMax = 16;


export const listWhatsAppConversationsResponseItemsItemRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const listWhatsAppConversationsResponseItemsItemAssignedToMax = 200;

export const listWhatsAppConversationsResponseItemsItemUnreadCountMin = 0;


export const listWhatsAppConversationsResponseItemsItemReadinessCodeMax = 200;

export const listWhatsAppConversationsResponseItemsItemReadinessMessageMax = 1000;

export const listWhatsAppConversationsResponseItemsItemReadinessChecksItemCodeMax = 200;

export const listWhatsAppConversationsResponseItemsItemReadinessChecksItemMessageMax = 1000;

export const listWhatsAppConversationsResponseItemsItemReadinessChecksMax = 100;

export const listWhatsAppConversationsResponseItemsMax = 100;

export const listWhatsAppConversationsResponseTotalMin = 0;



export const listWhatsAppConversationsResponse = zod.object({
  "items": zod.array(zod.object({
  "senderRevisionId": zod.uuid().nullable().describe('Current revision of this conversation’s original sender; unavailable senders cannot authorize replies.'),
  "id": zod.uuid(),
  "senderId": zod.uuid(),
  "recipientNumber": zod.string().max(listWhatsAppConversationsResponseItemsItemRecipientNumberMax).regex(listWhatsAppConversationsResponseItemsItemRecipientNumberRegExp),
  "contactId": zod.uuid().nullable(),
  "assignedTo": zod.string().min(1).max(listWhatsAppConversationsResponseItemsItemAssignedToMax).nullable(),
  "status": zod.enum(['open', 'closed']),
  "lastVerifiedInboundAt": zod.iso.datetime({"offset":true}).nullable(),
  "windowExpiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastMessageAt": zod.iso.datetime({"offset":true}).nullable(),
  "unreadCount": zod.int().min(listWhatsAppConversationsResponseItemsItemUnreadCountMin),
  "revision": zod.int().min(1),
  "canReplyFreeText": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(listWhatsAppConversationsResponseItemsItemReadinessCodeMax),
  "message": zod.string().min(1).max(listWhatsAppConversationsResponseItemsItemReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(listWhatsAppConversationsResponseItemsItemReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(listWhatsAppConversationsResponseItemsItemReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(listWhatsAppConversationsResponseItemsItemReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
})).max(listWhatsAppConversationsResponseItemsMax),
  "total": zod.int().min(listWhatsAppConversationsResponseTotalMin)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.read. Owner resolved from authorized server context.
 */
export const getWhatsAppConversationParams = zod.object({
  "id": zod.uuid()
})

export const getWhatsAppConversationResponseRecipientNumberMax = 16;


export const getWhatsAppConversationResponseRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const getWhatsAppConversationResponseAssignedToMax = 200;

export const getWhatsAppConversationResponseUnreadCountMin = 0;


export const getWhatsAppConversationResponseReadinessCodeMax = 200;

export const getWhatsAppConversationResponseReadinessMessageMax = 1000;

export const getWhatsAppConversationResponseReadinessChecksItemCodeMax = 200;

export const getWhatsAppConversationResponseReadinessChecksItemMessageMax = 1000;

export const getWhatsAppConversationResponseReadinessChecksMax = 100;



export const getWhatsAppConversationResponse = zod.object({
  "senderRevisionId": zod.uuid().nullable().describe('Current revision of this conversation’s original sender; unavailable senders cannot authorize replies.'),
  "id": zod.uuid(),
  "senderId": zod.uuid(),
  "recipientNumber": zod.string().max(getWhatsAppConversationResponseRecipientNumberMax).regex(getWhatsAppConversationResponseRecipientNumberRegExp),
  "contactId": zod.uuid().nullable(),
  "assignedTo": zod.string().min(1).max(getWhatsAppConversationResponseAssignedToMax).nullable(),
  "status": zod.enum(['open', 'closed']),
  "lastVerifiedInboundAt": zod.iso.datetime({"offset":true}).nullable(),
  "windowExpiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastMessageAt": zod.iso.datetime({"offset":true}).nullable(),
  "unreadCount": zod.int().min(getWhatsAppConversationResponseUnreadCountMin),
  "revision": zod.int().min(1),
  "canReplyFreeText": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(getWhatsAppConversationResponseReadinessCodeMax),
  "message": zod.string().min(1).max(getWhatsAppConversationResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(getWhatsAppConversationResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(getWhatsAppConversationResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(getWhatsAppConversationResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.write. Owner resolved from authorized server context.
 */
export const updateWhatsAppConversationParams = zod.object({
  "id": zod.uuid()
})


export const updateWhatsAppConversationBodyAssignedToMax = 200;



export const updateWhatsAppConversationBody = zod.object({
  "contactId": zod.uuid().nullish(),
  "expectedRevision": zod.int().min(1),
  "assignedTo": zod.string().min(1).max(updateWhatsAppConversationBodyAssignedToMax).nullish(),
  "status": zod.enum(['open', 'closed']).optional(),
  "requestKey": zod.uuid()
})

export const updateWhatsAppConversationResponseRecipientNumberMax = 16;


export const updateWhatsAppConversationResponseRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const updateWhatsAppConversationResponseAssignedToMax = 200;

export const updateWhatsAppConversationResponseUnreadCountMin = 0;


export const updateWhatsAppConversationResponseReadinessCodeMax = 200;

export const updateWhatsAppConversationResponseReadinessMessageMax = 1000;

export const updateWhatsAppConversationResponseReadinessChecksItemCodeMax = 200;

export const updateWhatsAppConversationResponseReadinessChecksItemMessageMax = 1000;

export const updateWhatsAppConversationResponseReadinessChecksMax = 100;



export const updateWhatsAppConversationResponse = zod.object({
  "senderRevisionId": zod.uuid().nullable().describe('Current revision of this conversation’s original sender; unavailable senders cannot authorize replies.'),
  "id": zod.uuid(),
  "senderId": zod.uuid(),
  "recipientNumber": zod.string().max(updateWhatsAppConversationResponseRecipientNumberMax).regex(updateWhatsAppConversationResponseRecipientNumberRegExp),
  "contactId": zod.uuid().nullable(),
  "assignedTo": zod.string().min(1).max(updateWhatsAppConversationResponseAssignedToMax).nullable(),
  "status": zod.enum(['open', 'closed']),
  "lastVerifiedInboundAt": zod.iso.datetime({"offset":true}).nullable(),
  "windowExpiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastMessageAt": zod.iso.datetime({"offset":true}).nullable(),
  "unreadCount": zod.int().min(updateWhatsAppConversationResponseUnreadCountMin),
  "revision": zod.int().min(1),
  "canReplyFreeText": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(updateWhatsAppConversationResponseReadinessCodeMax),
  "message": zod.string().min(1).max(updateWhatsAppConversationResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(updateWhatsAppConversationResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(updateWhatsAppConversationResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(updateWhatsAppConversationResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.read. Owner resolved from authorized server context.
 */
export const listWhatsAppMessagesParams = zod.object({
  "id": zod.uuid()
})

export const listWhatsAppMessagesQueryLimitDefault = 25;
export const listWhatsAppMessagesQueryLimitMax = 100;

export const listWhatsAppMessagesQueryOffsetDefault = 0;
export const listWhatsAppMessagesQueryOffsetMin = 0;



export const listWhatsAppMessagesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listWhatsAppMessagesQueryLimitMax).default(listWhatsAppMessagesQueryLimitDefault),
  "offset": zod.int().min(listWhatsAppMessagesQueryOffsetMin).default(listWhatsAppMessagesQueryOffsetDefault)
})

export const listWhatsAppMessagesResponseItemsItemProviderAccountIdMax = 200;

export const listWhatsAppMessagesResponseItemsItemProviderPhoneNumberIdMax = 200;

export const listWhatsAppMessagesResponseItemsItemProviderMessageIdMax = 200;

export const listWhatsAppMessagesResponseItemsItemFromNumberMax = 16;


export const listWhatsAppMessagesResponseItemsItemFromNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const listWhatsAppMessagesResponseItemsItemToNumberMax = 16;


export const listWhatsAppMessagesResponseItemsItemToNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const listWhatsAppMessagesResponseItemsItemBodyMin = 0;
export const listWhatsAppMessagesResponseItemsItemBodyMax = 6400;

export const listWhatsAppMessagesResponseItemsItemUnsupportedTypeMax = 200;

export const listWhatsAppMessagesResponseItemsItemResolvedParametersMinOne = 0;
export const listWhatsAppMessagesResponseItemsItemResolvedParametersMaxOne = 2000;

export const listWhatsAppMessagesResponseItemsItemAuthorIdMax = 200;

export const listWhatsAppMessagesResponseItemsItemErrorCodeMax = 200;

export const listWhatsAppMessagesResponseItemsMax = 100;

export const listWhatsAppMessagesResponseTotalMin = 0;



export const listWhatsAppMessagesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "senderId": zod.uuid(),
  "senderRevisionId": zod.uuid(),
  "providerAccountId": zod.string().min(1).max(listWhatsAppMessagesResponseItemsItemProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(listWhatsAppMessagesResponseItemsItemProviderPhoneNumberIdMax),
  "providerMessageId": zod.string().min(1).max(listWhatsAppMessagesResponseItemsItemProviderMessageIdMax).nullable(),
  "contactId": zod.uuid().nullable(),
  "campaignId": zod.uuid().nullable(),
  "stepId": zod.uuid().nullable(),
  "interactionId": zod.uuid().nullable(),
  "parentMessageId": zod.uuid().nullable(),
  "templateSnapshotId": zod.uuid().nullable(),
  "fromNumber": zod.string().max(listWhatsAppMessagesResponseItemsItemFromNumberMax).regex(listWhatsAppMessagesResponseItemsItemFromNumberRegExp),
  "toNumber": zod.string().max(listWhatsAppMessagesResponseItemsItemToNumberMax).regex(listWhatsAppMessagesResponseItemsItemToNumberRegExp),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['campaign', 'test', 'staff_reply', 'inbound']),
  "contentType": zod.enum(['text', 'template', 'image', 'audio', 'video', 'document', 'unsupported']),
  "body": zod.string().min(listWhatsAppMessagesResponseItemsItemBodyMin).max(listWhatsAppMessagesResponseItemsItemBodyMax).nullable(),
  "fileId": zod.uuid().nullable(),
  "mediaStatus": zod.enum(['none', 'pending', 'ready', 'unsupported', 'unavailable']).optional(),
  "unsupportedType": zod.string().min(1).max(listWhatsAppMessagesResponseItemsItemUnsupportedTypeMax).nullable(),
  "resolvedParameters": zod.record(zod.string(), zod.string().min(listWhatsAppMessagesResponseItemsItemResolvedParametersMinOne).max(listWhatsAppMessagesResponseItemsItemResolvedParametersMaxOne)),
  "status": zod.enum(['queued', 'accepted', 'sent', 'delivered', 'read', 'failed', 'unknown', 'received', 'suppressed', 'cancelled']),
  "authorId": zod.string().min(1).max(listWhatsAppMessagesResponseItemsItemAuthorIdMax).nullable(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "sentAt": zod.iso.datetime({"offset":true}).nullable(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "readAt": zod.iso.datetime({"offset":true}).nullable(),
  "receivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().min(1).max(listWhatsAppMessagesResponseItemsItemErrorCodeMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
})).max(listWhatsAppMessagesResponseItemsMax),
  "total": zod.int().min(listWhatsAppMessagesResponseTotalMin)
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.read. Owner resolved from authorized server context.
 */
export const markWhatsAppConversationReadParams = zod.object({
  "id": zod.uuid()
})

export const markWhatsAppConversationReadBody = zod.object({
  "readThroughMessageId": zod.uuid(),
  "requestKey": zod.uuid()
})

export const markWhatsAppConversationReadResponseRecipientNumberMax = 16;


export const markWhatsAppConversationReadResponseRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const markWhatsAppConversationReadResponseAssignedToMax = 200;

export const markWhatsAppConversationReadResponseUnreadCountMin = 0;


export const markWhatsAppConversationReadResponseReadinessCodeMax = 200;

export const markWhatsAppConversationReadResponseReadinessMessageMax = 1000;

export const markWhatsAppConversationReadResponseReadinessChecksItemCodeMax = 200;

export const markWhatsAppConversationReadResponseReadinessChecksItemMessageMax = 1000;

export const markWhatsAppConversationReadResponseReadinessChecksMax = 100;



export const markWhatsAppConversationReadResponse = zod.object({
  "senderRevisionId": zod.uuid().nullable().describe('Current revision of this conversation’s original sender; unavailable senders cannot authorize replies.'),
  "id": zod.uuid(),
  "senderId": zod.uuid(),
  "recipientNumber": zod.string().max(markWhatsAppConversationReadResponseRecipientNumberMax).regex(markWhatsAppConversationReadResponseRecipientNumberRegExp),
  "contactId": zod.uuid().nullable(),
  "assignedTo": zod.string().min(1).max(markWhatsAppConversationReadResponseAssignedToMax).nullable(),
  "status": zod.enum(['open', 'closed']),
  "lastVerifiedInboundAt": zod.iso.datetime({"offset":true}).nullable(),
  "windowExpiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastMessageAt": zod.iso.datetime({"offset":true}).nullable(),
  "unreadCount": zod.int().min(markWhatsAppConversationReadResponseUnreadCountMin),
  "revision": zod.int().min(1),
  "canReplyFreeText": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(markWhatsAppConversationReadResponseReadinessCodeMax),
  "message": zod.string().min(1).max(markWhatsAppConversationReadResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(markWhatsAppConversationReadResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(markWhatsAppConversationReadResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(markWhatsAppConversationReadResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
})


/**
 * Foundation contract; service enabled in ordered follow-up task. Requires entity.records.write. Owner resolved from authorized server context.
 */
export const replyWhatsAppConversationParams = zod.object({
  "id": zod.uuid()
})

export const replyWhatsAppConversationBodyOneBodyMax = 4096;

export const replyWhatsAppConversationBodyTwoResolvedParametersMinOne = 0;
export const replyWhatsAppConversationBodyTwoResolvedParametersMaxOne = 2000;



export const replyWhatsAppConversationBody = zod.union([zod.object({
  "kind": zod.enum(['text']),
  "body": zod.string().min(1).max(replyWhatsAppConversationBodyOneBodyMax),
  "expectedSenderRevisionId": zod.uuid(),
  "requestKey": zod.uuid()
}),zod.object({
  "kind": zod.enum(['template']),
  "templateSnapshotId": zod.uuid(),
  "resolvedParameters": zod.record(zod.string(), zod.string().min(replyWhatsAppConversationBodyTwoResolvedParametersMinOne).max(replyWhatsAppConversationBodyTwoResolvedParametersMaxOne)),
  "expectedSenderRevisionId": zod.uuid(),
  "requestKey": zod.uuid()
})])

export const replyWhatsAppConversationResponseMessageProviderAccountIdMax = 200;

export const replyWhatsAppConversationResponseMessageProviderPhoneNumberIdMax = 200;

export const replyWhatsAppConversationResponseMessageProviderMessageIdMax = 200;

export const replyWhatsAppConversationResponseMessageFromNumberMax = 16;


export const replyWhatsAppConversationResponseMessageFromNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const replyWhatsAppConversationResponseMessageToNumberMax = 16;


export const replyWhatsAppConversationResponseMessageToNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const replyWhatsAppConversationResponseMessageBodyMin = 0;
export const replyWhatsAppConversationResponseMessageBodyMax = 6400;

export const replyWhatsAppConversationResponseMessageUnsupportedTypeMax = 200;

export const replyWhatsAppConversationResponseMessageResolvedParametersMinOne = 0;
export const replyWhatsAppConversationResponseMessageResolvedParametersMaxOne = 2000;

export const replyWhatsAppConversationResponseMessageAuthorIdMax = 200;

export const replyWhatsAppConversationResponseMessageErrorCodeMax = 200;

export const replyWhatsAppConversationResponseAttemptCountMin = 0;

export const replyWhatsAppConversationResponseReasonMin = 0;
export const replyWhatsAppConversationResponseReasonMax = 1000;

export const replyWhatsAppConversationResponseLastErrorCodeMax = 200;



export const replyWhatsAppConversationResponse = zod.object({
  "id": zod.uuid(),
  "message": zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "senderId": zod.uuid(),
  "senderRevisionId": zod.uuid(),
  "providerAccountId": zod.string().min(1).max(replyWhatsAppConversationResponseMessageProviderAccountIdMax),
  "providerPhoneNumberId": zod.string().min(1).max(replyWhatsAppConversationResponseMessageProviderPhoneNumberIdMax),
  "providerMessageId": zod.string().min(1).max(replyWhatsAppConversationResponseMessageProviderMessageIdMax).nullable(),
  "contactId": zod.uuid().nullable(),
  "campaignId": zod.uuid().nullable(),
  "stepId": zod.uuid().nullable(),
  "interactionId": zod.uuid().nullable(),
  "parentMessageId": zod.uuid().nullable(),
  "templateSnapshotId": zod.uuid().nullable(),
  "fromNumber": zod.string().max(replyWhatsAppConversationResponseMessageFromNumberMax).regex(replyWhatsAppConversationResponseMessageFromNumberRegExp),
  "toNumber": zod.string().max(replyWhatsAppConversationResponseMessageToNumberMax).regex(replyWhatsAppConversationResponseMessageToNumberRegExp),
  "direction": zod.enum(['inbound', 'outbound']),
  "kind": zod.enum(['campaign', 'test', 'staff_reply', 'inbound']),
  "contentType": zod.enum(['text', 'template', 'image', 'audio', 'video', 'document', 'unsupported']),
  "body": zod.string().min(replyWhatsAppConversationResponseMessageBodyMin).max(replyWhatsAppConversationResponseMessageBodyMax).nullable(),
  "fileId": zod.uuid().nullable(),
  "mediaStatus": zod.enum(['none', 'pending', 'ready', 'unsupported', 'unavailable']).optional(),
  "unsupportedType": zod.string().min(1).max(replyWhatsAppConversationResponseMessageUnsupportedTypeMax).nullable(),
  "resolvedParameters": zod.record(zod.string(), zod.string().min(replyWhatsAppConversationResponseMessageResolvedParametersMinOne).max(replyWhatsAppConversationResponseMessageResolvedParametersMaxOne)),
  "status": zod.enum(['queued', 'accepted', 'sent', 'delivered', 'read', 'failed', 'unknown', 'received', 'suppressed', 'cancelled']),
  "authorId": zod.string().min(1).max(replyWhatsAppConversationResponseMessageAuthorIdMax).nullable(),
  "acceptedAt": zod.iso.datetime({"offset":true}).nullable(),
  "sentAt": zod.iso.datetime({"offset":true}).nullable(),
  "deliveredAt": zod.iso.datetime({"offset":true}).nullable(),
  "readAt": zod.iso.datetime({"offset":true}).nullable(),
  "receivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().min(1).max(replyWhatsAppConversationResponseMessageErrorCodeMax).nullable(),
  "createdAt": zod.iso.datetime({"offset":true})
}),
  "status": zod.enum(['queued', 'dispatching', 'retry', 'accepted', 'suppressed', 'failed', 'unknown', 'cancelled']),
  "attemptCount": zod.int().min(replyWhatsAppConversationResponseAttemptCountMin),
  "runAt": zod.iso.datetime({"offset":true}),
  "nextAttemptAt": zod.iso.datetime({"offset":true}).nullable(),
  "reason": zod.string().min(replyWhatsAppConversationResponseReasonMin).max(replyWhatsAppConversationResponseReasonMax).nullable(),
  "lastErrorCode": zod.string().min(1).max(replyWhatsAppConversationResponseLastErrorCodeMax).nullable()
})


/**
 * Validate provider challenge with server secret; no entity selector.
 */
export const verifyWhatsAppWebhookQueryHubModeMax = 1000;

export const verifyWhatsAppWebhookQueryHubVerifyTokenMax = 1000;

export const verifyWhatsAppWebhookQueryHubChallengeMax = 1000;



export const verifyWhatsAppWebhookQueryParams = zod.object({
  "hub.mode": zod.string().min(1).max(verifyWhatsAppWebhookQueryHubModeMax),
  "hub.verify_token": zod.string().min(1).max(verifyWhatsAppWebhookQueryHubVerifyTokenMax),
  "hub.challenge": zod.string().min(1).max(verifyWhatsAppWebhookQueryHubChallengeMax)
})

export const verifyWhatsAppWebhookResponse = zod.string()


/**
 * Verify raw-body signature before parsing; resolve entity from verified globally unique sender mapping; bounded events, no automated reply.
 */
export const receiveWhatsAppWebhookHeaderXHubSignature256Max = 100;



export const receiveWhatsAppWebhookHeader = zod.object({
  "X-Hub-Signature-256": zod.string().max(receiveWhatsAppWebhookHeaderXHubSignature256Max)
})

export const receiveWhatsAppWebhookBody = zod.record(zod.string(), zod.unknown()).describe('Untrusted provider boundary. Task 2 pins the supported Meta version; task 5 validates exact nested events after raw-body signature verification. No owner is accepted from this body.')

export const receiveWhatsAppWebhookResponse = zod.void()


/**
 * Download privately stored supported media with current business records access.
 */
export const getWhatsAppMediaContentParams = zod.object({
  "id": zod.uuid()
})

export const getWhatsAppMediaContentResponse = zod.unknown()


/**
 * Record a staff-marked WhatsApp marketing opt-out without changing other channels.
 */
export const optOutWhatsAppConversationParams = zod.object({
  "id": zod.uuid()
})

export const optOutWhatsAppConversationBodyExpectedRevisionMin = 0;



export const optOutWhatsAppConversationBody = zod.object({
  "expectedRevision": zod.int().min(optOutWhatsAppConversationBodyExpectedRevisionMin),
  "requestKey": zod.uuid()
})

export const optOutWhatsAppConversationResponseRecipientNumberMax = 16;


export const optOutWhatsAppConversationResponseRecipientNumberRegExp = new RegExp('^\\+[1-9][0-9]{7,14}$');
export const optOutWhatsAppConversationResponseAssignedToMax = 200;

export const optOutWhatsAppConversationResponseUnreadCountMin = 0;


export const optOutWhatsAppConversationResponseReadinessCodeMax = 200;

export const optOutWhatsAppConversationResponseReadinessMessageMax = 1000;

export const optOutWhatsAppConversationResponseReadinessChecksItemCodeMax = 200;

export const optOutWhatsAppConversationResponseReadinessChecksItemMessageMax = 1000;

export const optOutWhatsAppConversationResponseReadinessChecksMax = 100;



export const optOutWhatsAppConversationResponse = zod.object({
  "senderRevisionId": zod.uuid().nullable().describe('Current revision of this conversation’s original sender; unavailable senders cannot authorize replies.'),
  "id": zod.uuid(),
  "senderId": zod.uuid(),
  "recipientNumber": zod.string().max(optOutWhatsAppConversationResponseRecipientNumberMax).regex(optOutWhatsAppConversationResponseRecipientNumberRegExp),
  "contactId": zod.uuid().nullable(),
  "assignedTo": zod.string().min(1).max(optOutWhatsAppConversationResponseAssignedToMax).nullable(),
  "status": zod.enum(['open', 'closed']),
  "lastVerifiedInboundAt": zod.iso.datetime({"offset":true}).nullable(),
  "windowExpiresAt": zod.iso.datetime({"offset":true}).nullable(),
  "lastMessageAt": zod.iso.datetime({"offset":true}).nullable(),
  "unreadCount": zod.int().min(optOutWhatsAppConversationResponseUnreadCountMin),
  "revision": zod.int().min(1),
  "canReplyFreeText": zod.boolean(),
  "readiness": zod.object({
  "available": zod.boolean(),
  "code": zod.string().min(1).max(optOutWhatsAppConversationResponseReadinessCodeMax),
  "message": zod.string().min(1).max(optOutWhatsAppConversationResponseReadinessMessageMax),
  "checks": zod.array(zod.object({
  "code": zod.string().min(1).max(optOutWhatsAppConversationResponseReadinessChecksItemCodeMax),
  "message": zod.string().min(1).max(optOutWhatsAppConversationResponseReadinessChecksItemMessageMax),
  "passed": zod.boolean()
})).max(optOutWhatsAppConversationResponseReadinessChecksMax),
  "verifiedAt": zod.iso.datetime({"offset":true}).nullable()
})
})


export const listAgentDocumentReviewsQueryLimitDefault = 20;
export const listAgentDocumentReviewsQueryLimitMax = 100;

export const listAgentDocumentReviewsQueryOffsetDefault = 0;
export const listAgentDocumentReviewsQueryOffsetMin = 0;
export const listAgentDocumentReviewsQueryOffsetMax = 100000;



export const listAgentDocumentReviewsQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "limit": zod.int().min(1).max(listAgentDocumentReviewsQueryLimitMax).default(listAgentDocumentReviewsQueryLimitDefault),
  "offset": zod.int().min(listAgentDocumentReviewsQueryOffsetMin).max(listAgentDocumentReviewsQueryOffsetMax).default(listAgentDocumentReviewsQueryOffsetDefault)
})


export const listAgentDocumentReviewsResponseItemsItemChecksItemPromptContentMax = 4000;

export const listAgentDocumentReviewsResponseItemsItemChecksItemFindingsItemQuoteMax = 2000;

export const listAgentDocumentReviewsResponseItemsItemChecksItemFindingsItemFindingMax = 3000;

export const listAgentDocumentReviewsResponseItemsItemChecksItemFindingsItemSuggestedTextMax = 4000;

export const listAgentDocumentReviewsResponseItemsItemChecksItemFindingsMax = 50;

export const listAgentDocumentReviewsResponseItemsItemChecksMax = 20;




export const listAgentDocumentReviewsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "title": zod.string(),
  "status": zod.enum(['running', 'completed', 'partial', 'failed', 'interrupted', 'cancelled']),
  "warnings": zod.array(zod.string()),
  "checks": zod.array(zod.object({
  "prompt": zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(listAgentDocumentReviewsResponseItemsItemChecksItemPromptContentMax)
}),
  "status": zod.enum(['pending', 'completed', 'failed']),
  "summary": zod.string(),
  "findings": zod.array(zod.object({
  "anchor": zod.string(),
  "quote": zod.string().max(listAgentDocumentReviewsResponseItemsItemChecksItemFindingsItemQuoteMax),
  "finding": zod.string().max(listAgentDocumentReviewsResponseItemsItemChecksItemFindingsItemFindingMax),
  "suggestedText": zod.string().max(listAgentDocumentReviewsResponseItemsItemChecksItemFindingsItemSuggestedTextMax)
})).max(listAgentDocumentReviewsResponseItemsItemChecksItemFindingsMax),
  "model": zod.string()
})).max(listAgentDocumentReviewsResponseItemsItemChecksMax),
  "parentReviewId": zod.uuid().nullable(),
  "setRevision": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
}),zod.null()]),
  "commentDraft": zod.union([zod.object({
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "commentCount": zod.int(),
  "skippedCount": zod.int()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})




export const createAgentDocumentReviewBodyQuestionMax = 4000;



export const createAgentDocumentReviewBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "clientRequestId": zod.uuid(),
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "prompt": zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
}).optional(),
  "reviewSet": zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
}).optional(),
  "parentReviewId": zod.uuid().optional(),
  "question": zod.string().min(1).max(createAgentDocumentReviewBodyQuestionMax).optional()
})


export const createAgentDocumentReviewResponseChecksItemPromptContentMax = 4000;

export const createAgentDocumentReviewResponseChecksItemFindingsItemQuoteMax = 2000;

export const createAgentDocumentReviewResponseChecksItemFindingsItemFindingMax = 3000;

export const createAgentDocumentReviewResponseChecksItemFindingsItemSuggestedTextMax = 4000;

export const createAgentDocumentReviewResponseChecksItemFindingsMax = 50;

export const createAgentDocumentReviewResponseChecksMax = 20;




export const createAgentDocumentReviewResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "title": zod.string(),
  "status": zod.enum(['running', 'completed', 'partial', 'failed', 'interrupted', 'cancelled']),
  "warnings": zod.array(zod.string()),
  "checks": zod.array(zod.object({
  "prompt": zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(createAgentDocumentReviewResponseChecksItemPromptContentMax)
}),
  "status": zod.enum(['pending', 'completed', 'failed']),
  "summary": zod.string(),
  "findings": zod.array(zod.object({
  "anchor": zod.string(),
  "quote": zod.string().max(createAgentDocumentReviewResponseChecksItemFindingsItemQuoteMax),
  "finding": zod.string().max(createAgentDocumentReviewResponseChecksItemFindingsItemFindingMax),
  "suggestedText": zod.string().max(createAgentDocumentReviewResponseChecksItemFindingsItemSuggestedTextMax)
})).max(createAgentDocumentReviewResponseChecksItemFindingsMax),
  "model": zod.string()
})).max(createAgentDocumentReviewResponseChecksMax),
  "parentReviewId": zod.uuid().nullable(),
  "setRevision": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
}),zod.null()]),
  "commentDraft": zod.union([zod.object({
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "commentCount": zod.int(),
  "skippedCount": zod.int()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})


export const getAgentDocumentReviewParams = zod.object({
  "id": zod.uuid()
})

export const getAgentDocumentReviewQueryParams = zod.object({
  "tenantId": zod.uuid(),
  "entityId": zod.uuid()
})


export const getAgentDocumentReviewResponseChecksItemPromptContentMax = 4000;

export const getAgentDocumentReviewResponseChecksItemFindingsItemQuoteMax = 2000;

export const getAgentDocumentReviewResponseChecksItemFindingsItemFindingMax = 3000;

export const getAgentDocumentReviewResponseChecksItemFindingsItemSuggestedTextMax = 4000;

export const getAgentDocumentReviewResponseChecksItemFindingsMax = 50;

export const getAgentDocumentReviewResponseChecksMax = 20;




export const getAgentDocumentReviewResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "title": zod.string(),
  "status": zod.enum(['running', 'completed', 'partial', 'failed', 'interrupted', 'cancelled']),
  "warnings": zod.array(zod.string()),
  "checks": zod.array(zod.object({
  "prompt": zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(getAgentDocumentReviewResponseChecksItemPromptContentMax)
}),
  "status": zod.enum(['pending', 'completed', 'failed']),
  "summary": zod.string(),
  "findings": zod.array(zod.object({
  "anchor": zod.string(),
  "quote": zod.string().max(getAgentDocumentReviewResponseChecksItemFindingsItemQuoteMax),
  "finding": zod.string().max(getAgentDocumentReviewResponseChecksItemFindingsItemFindingMax),
  "suggestedText": zod.string().max(getAgentDocumentReviewResponseChecksItemFindingsItemSuggestedTextMax)
})).max(getAgentDocumentReviewResponseChecksItemFindingsMax),
  "model": zod.string()
})).max(getAgentDocumentReviewResponseChecksMax),
  "parentReviewId": zod.uuid().nullable(),
  "setRevision": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
}),zod.null()]),
  "commentDraft": zod.union([zod.object({
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "commentCount": zod.int(),
  "skippedCount": zod.int()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})


export const cancelAgentDocumentReviewParams = zod.object({
  "id": zod.uuid()
})

export const cancelAgentDocumentReviewBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
})
})


export const cancelAgentDocumentReviewResponseChecksItemPromptContentMax = 4000;

export const cancelAgentDocumentReviewResponseChecksItemFindingsItemQuoteMax = 2000;

export const cancelAgentDocumentReviewResponseChecksItemFindingsItemFindingMax = 3000;

export const cancelAgentDocumentReviewResponseChecksItemFindingsItemSuggestedTextMax = 4000;

export const cancelAgentDocumentReviewResponseChecksItemFindingsMax = 50;

export const cancelAgentDocumentReviewResponseChecksMax = 20;




export const cancelAgentDocumentReviewResponse = zod.object({
  "id": zod.uuid(),
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "contentHash": zod.string(),
  "title": zod.string(),
  "status": zod.enum(['running', 'completed', 'partial', 'failed', 'interrupted', 'cancelled']),
  "warnings": zod.array(zod.string()),
  "checks": zod.array(zod.object({
  "prompt": zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "title": zod.string(),
  "content": zod.string().max(cancelAgentDocumentReviewResponseChecksItemPromptContentMax)
}),
  "status": zod.enum(['pending', 'completed', 'failed']),
  "summary": zod.string(),
  "findings": zod.array(zod.object({
  "anchor": zod.string(),
  "quote": zod.string().max(cancelAgentDocumentReviewResponseChecksItemFindingsItemQuoteMax),
  "finding": zod.string().max(cancelAgentDocumentReviewResponseChecksItemFindingsItemFindingMax),
  "suggestedText": zod.string().max(cancelAgentDocumentReviewResponseChecksItemFindingsItemSuggestedTextMax)
})).max(cancelAgentDocumentReviewResponseChecksItemFindingsMax),
  "model": zod.string()
})).max(cancelAgentDocumentReviewResponseChecksMax),
  "parentReviewId": zod.uuid().nullable(),
  "setRevision": zod.union([zod.object({
  "id": zod.uuid(),
  "revision": zod.int().min(1)
}),zod.null()]),
  "commentDraft": zod.union([zod.object({
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "commentCount": zod.int(),
  "skippedCount": zod.int()
}),zod.null()]).optional(),
  "createdAt": zod.iso.datetime({"offset":true})
})


export const previewAgentReviewCommentsParams = zod.object({
  "id": zod.uuid()
})

export const previewAgentReviewCommentsBodyFindingsItemCheckIndexMin = 0;
export const previewAgentReviewCommentsBodyFindingsItemCheckIndexMax = 19;

export const previewAgentReviewCommentsBodyFindingsItemFindingIndexMin = 0;
export const previewAgentReviewCommentsBodyFindingsItemFindingIndexMax = 49;

export const previewAgentReviewCommentsBodyFindingsMax = 100;



export const previewAgentReviewCommentsBody = zod.object({
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "findings": zod.array(zod.object({
  "checkIndex": zod.int().min(previewAgentReviewCommentsBodyFindingsItemCheckIndexMin).max(previewAgentReviewCommentsBodyFindingsItemCheckIndexMax),
  "findingIndex": zod.int().min(previewAgentReviewCommentsBodyFindingsItemFindingIndexMin).max(previewAgentReviewCommentsBodyFindingsItemFindingIndexMax)
})).min(1).max(previewAgentReviewCommentsBodyFindingsMax)
})

export const previewAgentReviewCommentsResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const previewAgentReviewCommentsResponse = zod.object({
  "fingerprint": zod.string().regex(previewAgentReviewCommentsResponseFingerprintRegExp),
  "title": zod.string(),
  "versionId": zod.uuid(),
  "items": zod.array(zod.object({
  "checkIndex": zod.int(),
  "findingIndex": zod.int(),
  "quote": zod.string(),
  "body": zod.string(),
  "mappable": zod.boolean(),
  "reason": zod.string()
})),
  "warnings": zod.array(zod.string())
})


export const applyAgentReviewCommentsParams = zod.object({
  "id": zod.uuid()
})

export const applyAgentReviewCommentsBodyFindingsItemCheckIndexMin = 0;
export const applyAgentReviewCommentsBodyFindingsItemCheckIndexMax = 19;

export const applyAgentReviewCommentsBodyFindingsItemFindingIndexMin = 0;
export const applyAgentReviewCommentsBodyFindingsItemFindingIndexMax = 49;

export const applyAgentReviewCommentsBodyFindingsMax = 100;

export const applyAgentReviewCommentsBodyFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');


export const applyAgentReviewCommentsBody = zod.object({
  "documentId": zod.uuid().optional().describe('Original reviewed document for destination review; validated against the private report.'),
  "accessScope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "findings": zod.array(zod.object({
  "checkIndex": zod.int().min(applyAgentReviewCommentsBodyFindingsItemCheckIndexMin).max(applyAgentReviewCommentsBodyFindingsItemCheckIndexMax),
  "findingIndex": zod.int().min(applyAgentReviewCommentsBodyFindingsItemFindingIndexMin).max(applyAgentReviewCommentsBodyFindingsItemFindingIndexMax)
})).min(1).max(applyAgentReviewCommentsBodyFindingsMax),
  "fingerprint": zod.string().regex(applyAgentReviewCommentsBodyFingerprintRegExp)
})

export const applyAgentReviewCommentsResponse = zod.object({
  "documentId": zod.uuid(),
  "versionId": zod.uuid(),
  "commentCount": zod.int(),
  "skippedCount": zod.int()
})


export const listSowSessionsQueryLimitDefault = 25;
export const listSowSessionsQueryLimitMax = 100;

export const listSowSessionsQueryOffsetDefault = 0;
export const listSowSessionsQueryOffsetMin = 0;
export const listSowSessionsQueryOffsetMax = 100000;



export const listSowSessionsQueryParams = zod.object({
  "proposalId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listSowSessionsQueryLimitMax).default(listSowSessionsQueryLimitDefault),
  "offset": zod.int().min(listSowSessionsQueryOffsetMin).max(listSowSessionsQueryOffsetMax).default(listSowSessionsQueryOffsetDefault)
})






export const listSowSessionsResponse = zod.object({
  "items": zod.array(zod.object({
  "proposalId": zod.uuid().optional(),
  "proposalRevision": zod.int().min(1).optional(),
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid(),
  "templateVersionId": zod.uuid(),
  "title": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})



export const startSowSessionBodyWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const startSowSessionBodySelectedSourcesMax = 20;



export const startSowSessionBody = zod.object({
  "proposalId": zod.uuid().optional(),
  "expectedProposalRevision": zod.int().min(1).optional(),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(startSowSessionBodyWorkspaceContextManifestHashRegExp)
}).optional(),
  "clientRequestId": zod.uuid(),
  "templateVersionId": zod.uuid(),
  "selectedSources": zod.array(zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'document', 'request']),
  "id": zod.uuid()
})).max(startSowSessionBodySelectedSourcesMax)
})




export const startSowSessionResponseTwoWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const startSowSessionResponseTwoFactsProjectTitleMax = 200;

export const startSowSessionResponseTwoFactsCustomerNameMax = 300;

export const startSowSessionResponseTwoFactsAgreementIdMax = 100;

export const startSowSessionResponseTwoFactsPreparedDateMax = 40;

export const startSowSessionResponseTwoFactsStartDateMax = 40;

export const startSowSessionResponseTwoFactsSprintWeeksMax = 52;

export const startSowSessionResponseTwoFactsNarrativeItemTextMax = 20000;

export const startSowSessionResponseTwoFactsNarrativeMax = 5;

export const startSowSessionResponseTwoFactsTablesItemRowsItemItemMax = 4000;

export const startSowSessionResponseTwoFactsTablesItemRowsItemMax = 7;

export const startSowSessionResponseTwoFactsTablesItemRowsMax = 100;

export const startSowSessionResponseTwoFactsTablesMax = 6;

export const startSowSessionResponseTwoFactsInvestmentItemIdMax = 80;

export const startSowSessionResponseTwoFactsInvestmentItemTitleMax = 300;

export const startSowSessionResponseTwoFactsInvestmentItemDescriptionMax = 4000;

export const startSowSessionResponseTwoFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsInvestmentMax = 100;

export const startSowSessionResponseTwoFactsMaterialsItemIdMax = 80;

export const startSowSessionResponseTwoFactsMaterialsItemTitleMax = 300;

export const startSowSessionResponseTwoFactsMaterialsItemDescriptionMax = 4000;

export const startSowSessionResponseTwoFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsMaterialsMax = 100;

export const startSowSessionResponseTwoFactsInvoicesItemIdMax = 80;

export const startSowSessionResponseTwoFactsInvoicesItemMilestonesMax = 500;

export const startSowSessionResponseTwoFactsInvoicesItemDateMax = 40;

export const startSowSessionResponseTwoFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsInvoicesItemNotesMax = 2000;

export const startSowSessionResponseTwoFactsInvoicesMax = 100;

export const startSowSessionResponseTwoFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const startSowSessionResponseTwoFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const startSowSessionResponseTwoFactsQuoteCommercialReferenceMax = 300;

export const startSowSessionResponseTwoFactsQuoteCommercialSourceStatusMax = 100;

export const startSowSessionResponseTwoFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const startSowSessionResponseTwoFactsQuoteCommercialTermsMax = 20000;

export const startSowSessionResponseTwoFactsQuoteCommercialAssumptionsMax = 20000;

export const startSowSessionResponseTwoFactsQuoteCommercialExclusionsMax = 20000;

export const startSowSessionResponseTwoFactsQuoteCommercialReviewReasonMin = 10;
export const startSowSessionResponseTwoFactsQuoteCommercialReviewReasonMax = 2000;

export const startSowSessionResponseTwoFactsQuoteCommercialLinesItemTitleMax = 300;

export const startSowSessionResponseTwoFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const startSowSessionResponseTwoFactsQuoteCommercialLinesMax = 100;

export const startSowSessionResponseTwoFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const startSowSessionResponseTwoFactsUnresolvedFactsItemFieldMax = 100;

export const startSowSessionResponseTwoFactsUnresolvedFactsItemMessageMax = 2000;

export const startSowSessionResponseTwoFactsUnresolvedFactsMax = 200;

export const startSowSessionResponseTwoFactsCustomFieldsItemSectionIdMax = 48;

export const startSowSessionResponseTwoFactsCustomFieldsItemFieldIdMax = 48;

export const startSowSessionResponseTwoFactsCustomFieldsItemValueMax = 4000;

export const startSowSessionResponseTwoFactsCustomFieldsMax = 600;

export const startSowSessionResponseTwoFactsCustomProseItemSectionIdMax = 48;

export const startSowSessionResponseTwoFactsCustomProseItemTextMax = 20000;

export const startSowSessionResponseTwoFactsCustomProseMax = 40;

export const startSowSessionResponseTwoFactsCustomTablesItemSectionIdMax = 48;

export const startSowSessionResponseTwoFactsCustomTablesItemRowsItemItemMax = 4000;

export const startSowSessionResponseTwoFactsCustomTablesItemRowsItemMax = 8;

export const startSowSessionResponseTwoFactsCustomTablesItemRowsMax = 100;

export const startSowSessionResponseTwoFactsCustomTablesMax = 40;

export const startSowSessionResponseTwoSelectedSourcesItemTwoHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const startSowSessionResponseTwoSelectedSourcesItemTwoRevisionMax = 100;

export const startSowSessionResponseTwoSelectedSourcesItemTwoSourceKeyMax = 100;

export const startSowSessionResponseTwoSelectedSourcesItemTwoLabelMax = 500;

export const startSowSessionResponseTwoSelectedSourcesItemTwoExcerptMax = 12000;

export const startSowSessionResponseTwoSelectedSourcesMax = 20;

export const startSowSessionResponseTwoConfirmedFactsItemQuoteMax = 4000;

export const startSowSessionResponseTwoConfirmedFactsItemSourceIdsItemMax = 100;

export const startSowSessionResponseTwoConfirmedFactsItemSourceIdsMax = 20;

export const startSowSessionResponseTwoConfirmedFactsMax = 200;

export const startSowSessionResponseTwoAssumptionsItemQuoteMax = 4000;

export const startSowSessionResponseTwoAssumptionsItemSourceIdsItemMax = 100;

export const startSowSessionResponseTwoAssumptionsItemSourceIdsMax = 20;

export const startSowSessionResponseTwoAssumptionsMax = 200;

export const startSowSessionResponseTwoGapsMax = 200;

export const startSowSessionResponseTwoCorrectionsMax = 200;

export const startSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMin = 5;
export const startSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMax = 50;

export const startSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMin = 5;
export const startSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMax = 50;

export const startSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMin = 5;
export const startSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMax = 50;

export const startSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMin = 5;
export const startSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMax = 50;

export const startSowSessionResponseTwoContentLayoutHeaderItemTypeMax = 40;

export const startSowSessionResponseTwoContentLayoutHeaderItemTextMax = 200000;

export const startSowSessionResponseTwoContentLayoutHeaderItemMarksItemTypeMax = 40;

export const startSowSessionResponseTwoContentLayoutHeaderItemMarksMax = 20;

export const startSowSessionResponseTwoContentLayoutHeaderItemContentMax = 10000;

export const startSowSessionResponseTwoContentLayoutHeaderMax = 100;

export const startSowSessionResponseTwoContentLayoutFooterItemTypeMax = 40;

export const startSowSessionResponseTwoContentLayoutFooterItemTextMax = 200000;

export const startSowSessionResponseTwoContentLayoutFooterItemMarksItemTypeMax = 40;

export const startSowSessionResponseTwoContentLayoutFooterItemMarksMax = 20;

export const startSowSessionResponseTwoContentLayoutFooterItemContentMax = 10000;

export const startSowSessionResponseTwoContentLayoutFooterMax = 100;

export const startSowSessionResponseTwoContentSectionsItemsItemTitleMax = 160;

export const startSowSessionResponseTwoContentSectionsItemsItemAuthoringNotesMax = 4000;


export const startSowSessionResponseTwoContentSectionsItemsMax = 200;

export const startSowSessionResponseTwoContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const startSowSessionResponseTwoContentStylesDefinitionsItemNameMax = 80;

export const startSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMin = 6;
export const startSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMax = 96;

export const startSowSessionResponseTwoContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const startSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const startSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const startSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMin = 0;
export const startSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMax = 144;

export const startSowSessionResponseTwoContentStylesDefinitionsItemLineHeightMax = 3;

export const startSowSessionResponseTwoContentStylesDefinitionsMin = 7;
export const startSowSessionResponseTwoContentStylesDefinitionsMax = 100;

export const startSowSessionResponseTwoContentTemplateGuidanceMax = 4000;

export const startSowSessionResponseTwoContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const startSowSessionResponseTwoContentTemplateSectionGuidanceMax = 200;

export const startSowSessionResponseTwoContentContentItemTypeMax = 40;

export const startSowSessionResponseTwoContentContentItemTextMax = 200000;

export const startSowSessionResponseTwoContentContentItemMarksItemTypeMax = 40;

export const startSowSessionResponseTwoContentContentItemMarksMax = 20;

export const startSowSessionResponseTwoContentContentItemContentMax = 10000;

export const startSowSessionResponseTwoContentContentMax = 10000;



export const startSowSessionResponse = zod.object({
  "proposalId": zod.uuid().optional(),
  "proposalRevision": zod.int().min(1).optional(),
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid(),
  "templateVersionId": zod.uuid(),
  "title": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(startSowSessionResponseTwoWorkspaceContextManifestHashRegExp)
}).optional(),
  "requestId": zod.uuid().nullish(),
  "facts": zod.object({
  "projectTitle": zod.string().max(startSowSessionResponseTwoFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(startSowSessionResponseTwoFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(startSowSessionResponseTwoFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(startSowSessionResponseTwoFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(startSowSessionResponseTwoFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(startSowSessionResponseTwoFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(startSowSessionResponseTwoFactsNarrativeItemTextMax)
})).max(startSowSessionResponseTwoFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(startSowSessionResponseTwoFactsTablesItemRowsItemItemMax)).max(startSowSessionResponseTwoFactsTablesItemRowsItemMax)).max(startSowSessionResponseTwoFactsTablesItemRowsMax)
})).max(startSowSessionResponseTwoFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(startSowSessionResponseTwoFactsInvestmentItemIdMax),
  "title": zod.string().max(startSowSessionResponseTwoFactsInvestmentItemTitleMax),
  "description": zod.string().max(startSowSessionResponseTwoFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(startSowSessionResponseTwoFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(startSowSessionResponseTwoFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(startSowSessionResponseTwoFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(startSowSessionResponseTwoFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(startSowSessionResponseTwoFactsMaterialsItemIdMax),
  "title": zod.string().max(startSowSessionResponseTwoFactsMaterialsItemTitleMax),
  "description": zod.string().max(startSowSessionResponseTwoFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(startSowSessionResponseTwoFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(startSowSessionResponseTwoFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(startSowSessionResponseTwoFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(startSowSessionResponseTwoFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(startSowSessionResponseTwoFactsInvoicesItemIdMax),
  "milestones": zod.string().max(startSowSessionResponseTwoFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(startSowSessionResponseTwoFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(startSowSessionResponseTwoFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(startSowSessionResponseTwoFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(startSowSessionResponseTwoFactsInvoicesItemNotesMax)
})).max(startSowSessionResponseTwoFactsInvoicesMax),
  "milestoneDays": zod.string().regex(startSowSessionResponseTwoFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(startSowSessionResponseTwoFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(startSowSessionResponseTwoFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(startSowSessionResponseTwoFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(startSowSessionResponseTwoFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(startSowSessionResponseTwoFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(startSowSessionResponseTwoFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(startSowSessionResponseTwoFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(startSowSessionResponseTwoFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(startSowSessionResponseTwoFactsQuoteCommercialReviewReasonMin).max(startSowSessionResponseTwoFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(startSowSessionResponseTwoFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(startSowSessionResponseTwoFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(startSowSessionResponseTwoFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(startSowSessionResponseTwoFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(startSowSessionResponseTwoFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(startSowSessionResponseTwoFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(startSowSessionResponseTwoFactsUnresolvedFactsItemMessageMax)
})).max(startSowSessionResponseTwoFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(startSowSessionResponseTwoFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(startSowSessionResponseTwoFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(startSowSessionResponseTwoFactsCustomFieldsItemValueMax).nullable()
})).max(startSowSessionResponseTwoFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(startSowSessionResponseTwoFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(startSowSessionResponseTwoFactsCustomProseItemTextMax)
})).max(startSowSessionResponseTwoFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(startSowSessionResponseTwoFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(startSowSessionResponseTwoFactsCustomTablesItemRowsItemItemMax)).max(startSowSessionResponseTwoFactsCustomTablesItemRowsItemMax)).max(startSowSessionResponseTwoFactsCustomTablesItemRowsMax)
})).max(startSowSessionResponseTwoFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}),
  "selectedSources": zod.array(zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'document', 'request']),
  "id": zod.uuid()
}).and(zod.object({
  "hash": zod.string().regex(startSowSessionResponseTwoSelectedSourcesItemTwoHashRegExp),
  "revision": zod.string().max(startSowSessionResponseTwoSelectedSourcesItemTwoRevisionMax),
  "sourceKey": zod.string().max(startSowSessionResponseTwoSelectedSourcesItemTwoSourceKeyMax),
  "label": zod.string().max(startSowSessionResponseTwoSelectedSourcesItemTwoLabelMax),
  "excerpt": zod.string().max(startSowSessionResponseTwoSelectedSourcesItemTwoExcerptMax)
}))).max(startSowSessionResponseTwoSelectedSourcesMax),
  "confirmedFacts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(startSowSessionResponseTwoConfirmedFactsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(startSowSessionResponseTwoConfirmedFactsItemSourceIdsItemMax)).max(startSowSessionResponseTwoConfirmedFactsItemSourceIdsMax)
})).max(startSowSessionResponseTwoConfirmedFactsMax),
  "assumptions": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(startSowSessionResponseTwoAssumptionsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(startSowSessionResponseTwoAssumptionsItemSourceIdsItemMax)).max(startSowSessionResponseTwoAssumptionsItemSourceIdsMax)
})).max(startSowSessionResponseTwoAssumptionsMax),
  "gaps": zod.array(zod.object({
  "field": zod.string(),
  "message": zod.string()
})).max(startSowSessionResponseTwoGapsMax),
  "corrections": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string(),
  "after": zod.string(),
  "reason": zod.string()
})).max(startSowSessionResponseTwoCorrectionsMax),
  "validation": zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(startSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMin).max(startSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(startSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMin).max(startSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(startSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMin).max(startSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(startSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMin).max(startSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(startSowSessionResponseTwoContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(startSowSessionResponseTwoContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(startSowSessionResponseTwoContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(startSowSessionResponseTwoContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(startSowSessionResponseTwoContentLayoutHeaderItemContentMax).optional()
})).max(startSowSessionResponseTwoContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(startSowSessionResponseTwoContentLayoutFooterItemTypeMax),
  "text": zod.string().max(startSowSessionResponseTwoContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(startSowSessionResponseTwoContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(startSowSessionResponseTwoContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(startSowSessionResponseTwoContentLayoutFooterItemContentMax).optional()
})).max(startSowSessionResponseTwoContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(startSowSessionResponseTwoContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(startSowSessionResponseTwoContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(startSowSessionResponseTwoContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(startSowSessionResponseTwoContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(startSowSessionResponseTwoContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(startSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMin).max(startSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(startSowSessionResponseTwoContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(startSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMin).max(startSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(startSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMin).max(startSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(startSowSessionResponseTwoContentStylesDefinitionsItemLineHeightMax)
})).min(startSowSessionResponseTwoContentStylesDefinitionsMin).max(startSowSessionResponseTwoContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(startSowSessionResponseTwoContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(startSowSessionResponseTwoContentTemplateSectionGuidanceItemGuidanceMax)
})).max(startSowSessionResponseTwoContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(startSowSessionResponseTwoContentContentItemTypeMax),
  "text": zod.string().max(startSowSessionResponseTwoContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(startSowSessionResponseTwoContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(startSowSessionResponseTwoContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(startSowSessionResponseTwoContentContentItemContentMax).optional()
})).max(startSowSessionResponseTwoContentContentMax)
}),
  "sourceStatus": zod.enum(['current', 'stale'])
}))


export const getSowSessionParams = zod.object({
  "id": zod.uuid()
})




export const getSowSessionResponseTwoWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowSessionResponseTwoFactsProjectTitleMax = 200;

export const getSowSessionResponseTwoFactsCustomerNameMax = 300;

export const getSowSessionResponseTwoFactsAgreementIdMax = 100;

export const getSowSessionResponseTwoFactsPreparedDateMax = 40;

export const getSowSessionResponseTwoFactsStartDateMax = 40;

export const getSowSessionResponseTwoFactsSprintWeeksMax = 52;

export const getSowSessionResponseTwoFactsNarrativeItemTextMax = 20000;

export const getSowSessionResponseTwoFactsNarrativeMax = 5;

export const getSowSessionResponseTwoFactsTablesItemRowsItemItemMax = 4000;

export const getSowSessionResponseTwoFactsTablesItemRowsItemMax = 7;

export const getSowSessionResponseTwoFactsTablesItemRowsMax = 100;

export const getSowSessionResponseTwoFactsTablesMax = 6;

export const getSowSessionResponseTwoFactsInvestmentItemIdMax = 80;

export const getSowSessionResponseTwoFactsInvestmentItemTitleMax = 300;

export const getSowSessionResponseTwoFactsInvestmentItemDescriptionMax = 4000;

export const getSowSessionResponseTwoFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsInvestmentMax = 100;

export const getSowSessionResponseTwoFactsMaterialsItemIdMax = 80;

export const getSowSessionResponseTwoFactsMaterialsItemTitleMax = 300;

export const getSowSessionResponseTwoFactsMaterialsItemDescriptionMax = 4000;

export const getSowSessionResponseTwoFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsMaterialsMax = 100;

export const getSowSessionResponseTwoFactsInvoicesItemIdMax = 80;

export const getSowSessionResponseTwoFactsInvoicesItemMilestonesMax = 500;

export const getSowSessionResponseTwoFactsInvoicesItemDateMax = 40;

export const getSowSessionResponseTwoFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsInvoicesItemNotesMax = 2000;

export const getSowSessionResponseTwoFactsInvoicesMax = 100;

export const getSowSessionResponseTwoFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const getSowSessionResponseTwoFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowSessionResponseTwoFactsQuoteCommercialReferenceMax = 300;

export const getSowSessionResponseTwoFactsQuoteCommercialSourceStatusMax = 100;

export const getSowSessionResponseTwoFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const getSowSessionResponseTwoFactsQuoteCommercialTermsMax = 20000;

export const getSowSessionResponseTwoFactsQuoteCommercialAssumptionsMax = 20000;

export const getSowSessionResponseTwoFactsQuoteCommercialExclusionsMax = 20000;

export const getSowSessionResponseTwoFactsQuoteCommercialReviewReasonMin = 10;
export const getSowSessionResponseTwoFactsQuoteCommercialReviewReasonMax = 2000;

export const getSowSessionResponseTwoFactsQuoteCommercialLinesItemTitleMax = 300;

export const getSowSessionResponseTwoFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const getSowSessionResponseTwoFactsQuoteCommercialLinesMax = 100;

export const getSowSessionResponseTwoFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const getSowSessionResponseTwoFactsUnresolvedFactsItemFieldMax = 100;

export const getSowSessionResponseTwoFactsUnresolvedFactsItemMessageMax = 2000;

export const getSowSessionResponseTwoFactsUnresolvedFactsMax = 200;

export const getSowSessionResponseTwoFactsCustomFieldsItemSectionIdMax = 48;

export const getSowSessionResponseTwoFactsCustomFieldsItemFieldIdMax = 48;

export const getSowSessionResponseTwoFactsCustomFieldsItemValueMax = 4000;

export const getSowSessionResponseTwoFactsCustomFieldsMax = 600;

export const getSowSessionResponseTwoFactsCustomProseItemSectionIdMax = 48;

export const getSowSessionResponseTwoFactsCustomProseItemTextMax = 20000;

export const getSowSessionResponseTwoFactsCustomProseMax = 40;

export const getSowSessionResponseTwoFactsCustomTablesItemSectionIdMax = 48;

export const getSowSessionResponseTwoFactsCustomTablesItemRowsItemItemMax = 4000;

export const getSowSessionResponseTwoFactsCustomTablesItemRowsItemMax = 8;

export const getSowSessionResponseTwoFactsCustomTablesItemRowsMax = 100;

export const getSowSessionResponseTwoFactsCustomTablesMax = 40;

export const getSowSessionResponseTwoSelectedSourcesItemTwoHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowSessionResponseTwoSelectedSourcesItemTwoRevisionMax = 100;

export const getSowSessionResponseTwoSelectedSourcesItemTwoSourceKeyMax = 100;

export const getSowSessionResponseTwoSelectedSourcesItemTwoLabelMax = 500;

export const getSowSessionResponseTwoSelectedSourcesItemTwoExcerptMax = 12000;

export const getSowSessionResponseTwoSelectedSourcesMax = 20;

export const getSowSessionResponseTwoConfirmedFactsItemQuoteMax = 4000;

export const getSowSessionResponseTwoConfirmedFactsItemSourceIdsItemMax = 100;

export const getSowSessionResponseTwoConfirmedFactsItemSourceIdsMax = 20;

export const getSowSessionResponseTwoConfirmedFactsMax = 200;

export const getSowSessionResponseTwoAssumptionsItemQuoteMax = 4000;

export const getSowSessionResponseTwoAssumptionsItemSourceIdsItemMax = 100;

export const getSowSessionResponseTwoAssumptionsItemSourceIdsMax = 20;

export const getSowSessionResponseTwoAssumptionsMax = 200;

export const getSowSessionResponseTwoGapsMax = 200;

export const getSowSessionResponseTwoCorrectionsMax = 200;

export const getSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMin = 5;
export const getSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMax = 50;

export const getSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMin = 5;
export const getSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMax = 50;

export const getSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMin = 5;
export const getSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMax = 50;

export const getSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMin = 5;
export const getSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMax = 50;

export const getSowSessionResponseTwoContentLayoutHeaderItemTypeMax = 40;

export const getSowSessionResponseTwoContentLayoutHeaderItemTextMax = 200000;

export const getSowSessionResponseTwoContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getSowSessionResponseTwoContentLayoutHeaderItemMarksMax = 20;

export const getSowSessionResponseTwoContentLayoutHeaderItemContentMax = 10000;

export const getSowSessionResponseTwoContentLayoutHeaderMax = 100;

export const getSowSessionResponseTwoContentLayoutFooterItemTypeMax = 40;

export const getSowSessionResponseTwoContentLayoutFooterItemTextMax = 200000;

export const getSowSessionResponseTwoContentLayoutFooterItemMarksItemTypeMax = 40;

export const getSowSessionResponseTwoContentLayoutFooterItemMarksMax = 20;

export const getSowSessionResponseTwoContentLayoutFooterItemContentMax = 10000;

export const getSowSessionResponseTwoContentLayoutFooterMax = 100;

export const getSowSessionResponseTwoContentSectionsItemsItemTitleMax = 160;

export const getSowSessionResponseTwoContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getSowSessionResponseTwoContentSectionsItemsMax = 200;

export const getSowSessionResponseTwoContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getSowSessionResponseTwoContentStylesDefinitionsItemNameMax = 80;

export const getSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMin = 6;
export const getSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMax = 96;

export const getSowSessionResponseTwoContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getSowSessionResponseTwoContentStylesDefinitionsItemLineHeightMax = 3;

export const getSowSessionResponseTwoContentStylesDefinitionsMin = 7;
export const getSowSessionResponseTwoContentStylesDefinitionsMax = 100;

export const getSowSessionResponseTwoContentTemplateGuidanceMax = 4000;

export const getSowSessionResponseTwoContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getSowSessionResponseTwoContentTemplateSectionGuidanceMax = 200;

export const getSowSessionResponseTwoContentContentItemTypeMax = 40;

export const getSowSessionResponseTwoContentContentItemTextMax = 200000;

export const getSowSessionResponseTwoContentContentItemMarksItemTypeMax = 40;

export const getSowSessionResponseTwoContentContentItemMarksMax = 20;

export const getSowSessionResponseTwoContentContentItemContentMax = 10000;

export const getSowSessionResponseTwoContentContentMax = 10000;



export const getSowSessionResponse = zod.object({
  "proposalId": zod.uuid().optional(),
  "proposalRevision": zod.int().min(1).optional(),
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid(),
  "templateVersionId": zod.uuid(),
  "title": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(getSowSessionResponseTwoWorkspaceContextManifestHashRegExp)
}).optional(),
  "requestId": zod.uuid().nullish(),
  "facts": zod.object({
  "projectTitle": zod.string().max(getSowSessionResponseTwoFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(getSowSessionResponseTwoFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(getSowSessionResponseTwoFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(getSowSessionResponseTwoFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(getSowSessionResponseTwoFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(getSowSessionResponseTwoFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(getSowSessionResponseTwoFactsNarrativeItemTextMax)
})).max(getSowSessionResponseTwoFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(getSowSessionResponseTwoFactsTablesItemRowsItemItemMax)).max(getSowSessionResponseTwoFactsTablesItemRowsItemMax)).max(getSowSessionResponseTwoFactsTablesItemRowsMax)
})).max(getSowSessionResponseTwoFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(getSowSessionResponseTwoFactsInvestmentItemIdMax),
  "title": zod.string().max(getSowSessionResponseTwoFactsInvestmentItemTitleMax),
  "description": zod.string().max(getSowSessionResponseTwoFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getSowSessionResponseTwoFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getSowSessionResponseTwoFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getSowSessionResponseTwoFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(getSowSessionResponseTwoFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(getSowSessionResponseTwoFactsMaterialsItemIdMax),
  "title": zod.string().max(getSowSessionResponseTwoFactsMaterialsItemTitleMax),
  "description": zod.string().max(getSowSessionResponseTwoFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(getSowSessionResponseTwoFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(getSowSessionResponseTwoFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(getSowSessionResponseTwoFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(getSowSessionResponseTwoFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(getSowSessionResponseTwoFactsInvoicesItemIdMax),
  "milestones": zod.string().max(getSowSessionResponseTwoFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(getSowSessionResponseTwoFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(getSowSessionResponseTwoFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(getSowSessionResponseTwoFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(getSowSessionResponseTwoFactsInvoicesItemNotesMax)
})).max(getSowSessionResponseTwoFactsInvoicesMax),
  "milestoneDays": zod.string().regex(getSowSessionResponseTwoFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(getSowSessionResponseTwoFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(getSowSessionResponseTwoFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(getSowSessionResponseTwoFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(getSowSessionResponseTwoFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(getSowSessionResponseTwoFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(getSowSessionResponseTwoFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(getSowSessionResponseTwoFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(getSowSessionResponseTwoFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(getSowSessionResponseTwoFactsQuoteCommercialReviewReasonMin).max(getSowSessionResponseTwoFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(getSowSessionResponseTwoFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(getSowSessionResponseTwoFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(getSowSessionResponseTwoFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(getSowSessionResponseTwoFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(getSowSessionResponseTwoFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(getSowSessionResponseTwoFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(getSowSessionResponseTwoFactsUnresolvedFactsItemMessageMax)
})).max(getSowSessionResponseTwoFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(getSowSessionResponseTwoFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(getSowSessionResponseTwoFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(getSowSessionResponseTwoFactsCustomFieldsItemValueMax).nullable()
})).max(getSowSessionResponseTwoFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(getSowSessionResponseTwoFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(getSowSessionResponseTwoFactsCustomProseItemTextMax)
})).max(getSowSessionResponseTwoFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(getSowSessionResponseTwoFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(getSowSessionResponseTwoFactsCustomTablesItemRowsItemItemMax)).max(getSowSessionResponseTwoFactsCustomTablesItemRowsItemMax)).max(getSowSessionResponseTwoFactsCustomTablesItemRowsMax)
})).max(getSowSessionResponseTwoFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}),
  "selectedSources": zod.array(zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'document', 'request']),
  "id": zod.uuid()
}).and(zod.object({
  "hash": zod.string().regex(getSowSessionResponseTwoSelectedSourcesItemTwoHashRegExp),
  "revision": zod.string().max(getSowSessionResponseTwoSelectedSourcesItemTwoRevisionMax),
  "sourceKey": zod.string().max(getSowSessionResponseTwoSelectedSourcesItemTwoSourceKeyMax),
  "label": zod.string().max(getSowSessionResponseTwoSelectedSourcesItemTwoLabelMax),
  "excerpt": zod.string().max(getSowSessionResponseTwoSelectedSourcesItemTwoExcerptMax)
}))).max(getSowSessionResponseTwoSelectedSourcesMax),
  "confirmedFacts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(getSowSessionResponseTwoConfirmedFactsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(getSowSessionResponseTwoConfirmedFactsItemSourceIdsItemMax)).max(getSowSessionResponseTwoConfirmedFactsItemSourceIdsMax)
})).max(getSowSessionResponseTwoConfirmedFactsMax),
  "assumptions": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(getSowSessionResponseTwoAssumptionsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(getSowSessionResponseTwoAssumptionsItemSourceIdsItemMax)).max(getSowSessionResponseTwoAssumptionsItemSourceIdsMax)
})).max(getSowSessionResponseTwoAssumptionsMax),
  "gaps": zod.array(zod.object({
  "field": zod.string(),
  "message": zod.string()
})).max(getSowSessionResponseTwoGapsMax),
  "corrections": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string(),
  "after": zod.string(),
  "reason": zod.string()
})).max(getSowSessionResponseTwoCorrectionsMax),
  "validation": zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMin).max(getSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMin).max(getSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMin).max(getSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMin).max(getSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowSessionResponseTwoContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getSowSessionResponseTwoContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowSessionResponseTwoContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getSowSessionResponseTwoContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getSowSessionResponseTwoContentLayoutHeaderItemContentMax).optional()
})).max(getSowSessionResponseTwoContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowSessionResponseTwoContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getSowSessionResponseTwoContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowSessionResponseTwoContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getSowSessionResponseTwoContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getSowSessionResponseTwoContentLayoutFooterItemContentMax).optional()
})).max(getSowSessionResponseTwoContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getSowSessionResponseTwoContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getSowSessionResponseTwoContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getSowSessionResponseTwoContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getSowSessionResponseTwoContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getSowSessionResponseTwoContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMin).max(getSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getSowSessionResponseTwoContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMin).max(getSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMin).max(getSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getSowSessionResponseTwoContentStylesDefinitionsItemLineHeightMax)
})).min(getSowSessionResponseTwoContentStylesDefinitionsMin).max(getSowSessionResponseTwoContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getSowSessionResponseTwoContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getSowSessionResponseTwoContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getSowSessionResponseTwoContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowSessionResponseTwoContentContentItemTypeMax),
  "text": zod.string().max(getSowSessionResponseTwoContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowSessionResponseTwoContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getSowSessionResponseTwoContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getSowSessionResponseTwoContentContentItemContentMax).optional()
})).max(getSowSessionResponseTwoContentContentMax)
}),
  "sourceStatus": zod.enum(['current', 'stale'])
}))


export const updateSowSessionParams = zod.object({
  "id": zod.uuid()
})


export const updateSowSessionBodyReasonMax = 1000;

export const updateSowSessionBodyWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateSowSessionBodyFactsProjectTitleMax = 200;

export const updateSowSessionBodyFactsCustomerNameMax = 300;

export const updateSowSessionBodyFactsAgreementIdMax = 100;

export const updateSowSessionBodyFactsPreparedDateMax = 40;

export const updateSowSessionBodyFactsStartDateMax = 40;

export const updateSowSessionBodyFactsSprintWeeksMax = 52;

export const updateSowSessionBodyFactsNarrativeItemTextMax = 20000;

export const updateSowSessionBodyFactsNarrativeMax = 5;

export const updateSowSessionBodyFactsTablesItemRowsItemItemMax = 4000;

export const updateSowSessionBodyFactsTablesItemRowsItemMax = 7;

export const updateSowSessionBodyFactsTablesItemRowsMax = 100;

export const updateSowSessionBodyFactsTablesMax = 6;

export const updateSowSessionBodyFactsInvestmentItemIdMax = 80;

export const updateSowSessionBodyFactsInvestmentItemTitleMax = 300;

export const updateSowSessionBodyFactsInvestmentItemDescriptionMax = 4000;

export const updateSowSessionBodyFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsInvestmentMax = 100;

export const updateSowSessionBodyFactsMaterialsItemIdMax = 80;

export const updateSowSessionBodyFactsMaterialsItemTitleMax = 300;

export const updateSowSessionBodyFactsMaterialsItemDescriptionMax = 4000;

export const updateSowSessionBodyFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsMaterialsMax = 100;

export const updateSowSessionBodyFactsInvoicesItemIdMax = 80;

export const updateSowSessionBodyFactsInvoicesItemMilestonesMax = 500;

export const updateSowSessionBodyFactsInvoicesItemDateMax = 40;

export const updateSowSessionBodyFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsInvoicesItemNotesMax = 2000;

export const updateSowSessionBodyFactsInvoicesMax = 100;

export const updateSowSessionBodyFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const updateSowSessionBodyFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateSowSessionBodyFactsQuoteCommercialReferenceMax = 300;

export const updateSowSessionBodyFactsQuoteCommercialSourceStatusMax = 100;

export const updateSowSessionBodyFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const updateSowSessionBodyFactsQuoteCommercialTermsMax = 20000;

export const updateSowSessionBodyFactsQuoteCommercialAssumptionsMax = 20000;

export const updateSowSessionBodyFactsQuoteCommercialExclusionsMax = 20000;

export const updateSowSessionBodyFactsQuoteCommercialReviewReasonMin = 10;
export const updateSowSessionBodyFactsQuoteCommercialReviewReasonMax = 2000;

export const updateSowSessionBodyFactsQuoteCommercialLinesItemTitleMax = 300;

export const updateSowSessionBodyFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const updateSowSessionBodyFactsQuoteCommercialLinesMax = 100;

export const updateSowSessionBodyFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionBodyFactsUnresolvedFactsItemFieldMax = 100;

export const updateSowSessionBodyFactsUnresolvedFactsItemMessageMax = 2000;

export const updateSowSessionBodyFactsUnresolvedFactsMax = 200;

export const updateSowSessionBodyFactsCustomFieldsItemSectionIdMax = 48;

export const updateSowSessionBodyFactsCustomFieldsItemFieldIdMax = 48;

export const updateSowSessionBodyFactsCustomFieldsItemValueMax = 4000;

export const updateSowSessionBodyFactsCustomFieldsMax = 600;

export const updateSowSessionBodyFactsCustomProseItemSectionIdMax = 48;

export const updateSowSessionBodyFactsCustomProseItemTextMax = 20000;

export const updateSowSessionBodyFactsCustomProseMax = 40;

export const updateSowSessionBodyFactsCustomTablesItemSectionIdMax = 48;

export const updateSowSessionBodyFactsCustomTablesItemRowsItemItemMax = 4000;

export const updateSowSessionBodyFactsCustomTablesItemRowsItemMax = 8;

export const updateSowSessionBodyFactsCustomTablesItemRowsMax = 100;

export const updateSowSessionBodyFactsCustomTablesMax = 40;

export const updateSowSessionBodySelectedSourcesMax = 20;



export const updateSowSessionBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "reason": zod.string().min(1).max(updateSowSessionBodyReasonMax),
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(updateSowSessionBodyWorkspaceContextManifestHashRegExp)
}).optional(),
  "facts": zod.object({
  "projectTitle": zod.string().max(updateSowSessionBodyFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(updateSowSessionBodyFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(updateSowSessionBodyFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(updateSowSessionBodyFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(updateSowSessionBodyFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(updateSowSessionBodyFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(updateSowSessionBodyFactsNarrativeItemTextMax)
})).max(updateSowSessionBodyFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(updateSowSessionBodyFactsTablesItemRowsItemItemMax)).max(updateSowSessionBodyFactsTablesItemRowsItemMax)).max(updateSowSessionBodyFactsTablesItemRowsMax)
})).max(updateSowSessionBodyFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(updateSowSessionBodyFactsInvestmentItemIdMax),
  "title": zod.string().max(updateSowSessionBodyFactsInvestmentItemTitleMax),
  "description": zod.string().max(updateSowSessionBodyFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(updateSowSessionBodyFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(updateSowSessionBodyFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(updateSowSessionBodyFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(updateSowSessionBodyFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(updateSowSessionBodyFactsMaterialsItemIdMax),
  "title": zod.string().max(updateSowSessionBodyFactsMaterialsItemTitleMax),
  "description": zod.string().max(updateSowSessionBodyFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(updateSowSessionBodyFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(updateSowSessionBodyFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(updateSowSessionBodyFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(updateSowSessionBodyFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(updateSowSessionBodyFactsInvoicesItemIdMax),
  "milestones": zod.string().max(updateSowSessionBodyFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(updateSowSessionBodyFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(updateSowSessionBodyFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(updateSowSessionBodyFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(updateSowSessionBodyFactsInvoicesItemNotesMax)
})).max(updateSowSessionBodyFactsInvoicesMax),
  "milestoneDays": zod.string().regex(updateSowSessionBodyFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(updateSowSessionBodyFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(updateSowSessionBodyFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(updateSowSessionBodyFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(updateSowSessionBodyFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(updateSowSessionBodyFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(updateSowSessionBodyFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(updateSowSessionBodyFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(updateSowSessionBodyFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(updateSowSessionBodyFactsQuoteCommercialReviewReasonMin).max(updateSowSessionBodyFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(updateSowSessionBodyFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(updateSowSessionBodyFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(updateSowSessionBodyFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(updateSowSessionBodyFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(updateSowSessionBodyFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(updateSowSessionBodyFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(updateSowSessionBodyFactsUnresolvedFactsItemMessageMax)
})).max(updateSowSessionBodyFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(updateSowSessionBodyFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(updateSowSessionBodyFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(updateSowSessionBodyFactsCustomFieldsItemValueMax).nullable()
})).max(updateSowSessionBodyFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(updateSowSessionBodyFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(updateSowSessionBodyFactsCustomProseItemTextMax)
})).max(updateSowSessionBodyFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(updateSowSessionBodyFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(updateSowSessionBodyFactsCustomTablesItemRowsItemItemMax)).max(updateSowSessionBodyFactsCustomTablesItemRowsItemMax)).max(updateSowSessionBodyFactsCustomTablesItemRowsMax)
})).max(updateSowSessionBodyFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}).optional(),
  "selectedSources": zod.array(zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'document', 'request']),
  "id": zod.uuid()
})).max(updateSowSessionBodySelectedSourcesMax).optional()
})




export const updateSowSessionResponseTwoWorkspaceContextManifestHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateSowSessionResponseTwoFactsProjectTitleMax = 200;

export const updateSowSessionResponseTwoFactsCustomerNameMax = 300;

export const updateSowSessionResponseTwoFactsAgreementIdMax = 100;

export const updateSowSessionResponseTwoFactsPreparedDateMax = 40;

export const updateSowSessionResponseTwoFactsStartDateMax = 40;

export const updateSowSessionResponseTwoFactsSprintWeeksMax = 52;

export const updateSowSessionResponseTwoFactsNarrativeItemTextMax = 20000;

export const updateSowSessionResponseTwoFactsNarrativeMax = 5;

export const updateSowSessionResponseTwoFactsTablesItemRowsItemItemMax = 4000;

export const updateSowSessionResponseTwoFactsTablesItemRowsItemMax = 7;

export const updateSowSessionResponseTwoFactsTablesItemRowsMax = 100;

export const updateSowSessionResponseTwoFactsTablesMax = 6;

export const updateSowSessionResponseTwoFactsInvestmentItemIdMax = 80;

export const updateSowSessionResponseTwoFactsInvestmentItemTitleMax = 300;

export const updateSowSessionResponseTwoFactsInvestmentItemDescriptionMax = 4000;

export const updateSowSessionResponseTwoFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsInvestmentMax = 100;

export const updateSowSessionResponseTwoFactsMaterialsItemIdMax = 80;

export const updateSowSessionResponseTwoFactsMaterialsItemTitleMax = 300;

export const updateSowSessionResponseTwoFactsMaterialsItemDescriptionMax = 4000;

export const updateSowSessionResponseTwoFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsMaterialsMax = 100;

export const updateSowSessionResponseTwoFactsInvoicesItemIdMax = 80;

export const updateSowSessionResponseTwoFactsInvoicesItemMilestonesMax = 500;

export const updateSowSessionResponseTwoFactsInvoicesItemDateMax = 40;

export const updateSowSessionResponseTwoFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsInvoicesItemNotesMax = 2000;

export const updateSowSessionResponseTwoFactsInvoicesMax = 100;

export const updateSowSessionResponseTwoFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const updateSowSessionResponseTwoFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateSowSessionResponseTwoFactsQuoteCommercialReferenceMax = 300;

export const updateSowSessionResponseTwoFactsQuoteCommercialSourceStatusMax = 100;

export const updateSowSessionResponseTwoFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const updateSowSessionResponseTwoFactsQuoteCommercialTermsMax = 20000;

export const updateSowSessionResponseTwoFactsQuoteCommercialAssumptionsMax = 20000;

export const updateSowSessionResponseTwoFactsQuoteCommercialExclusionsMax = 20000;

export const updateSowSessionResponseTwoFactsQuoteCommercialReviewReasonMin = 10;
export const updateSowSessionResponseTwoFactsQuoteCommercialReviewReasonMax = 2000;

export const updateSowSessionResponseTwoFactsQuoteCommercialLinesItemTitleMax = 300;

export const updateSowSessionResponseTwoFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const updateSowSessionResponseTwoFactsQuoteCommercialLinesMax = 100;

export const updateSowSessionResponseTwoFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const updateSowSessionResponseTwoFactsUnresolvedFactsItemFieldMax = 100;

export const updateSowSessionResponseTwoFactsUnresolvedFactsItemMessageMax = 2000;

export const updateSowSessionResponseTwoFactsUnresolvedFactsMax = 200;

export const updateSowSessionResponseTwoFactsCustomFieldsItemSectionIdMax = 48;

export const updateSowSessionResponseTwoFactsCustomFieldsItemFieldIdMax = 48;

export const updateSowSessionResponseTwoFactsCustomFieldsItemValueMax = 4000;

export const updateSowSessionResponseTwoFactsCustomFieldsMax = 600;

export const updateSowSessionResponseTwoFactsCustomProseItemSectionIdMax = 48;

export const updateSowSessionResponseTwoFactsCustomProseItemTextMax = 20000;

export const updateSowSessionResponseTwoFactsCustomProseMax = 40;

export const updateSowSessionResponseTwoFactsCustomTablesItemSectionIdMax = 48;

export const updateSowSessionResponseTwoFactsCustomTablesItemRowsItemItemMax = 4000;

export const updateSowSessionResponseTwoFactsCustomTablesItemRowsItemMax = 8;

export const updateSowSessionResponseTwoFactsCustomTablesItemRowsMax = 100;

export const updateSowSessionResponseTwoFactsCustomTablesMax = 40;

export const updateSowSessionResponseTwoSelectedSourcesItemTwoHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const updateSowSessionResponseTwoSelectedSourcesItemTwoRevisionMax = 100;

export const updateSowSessionResponseTwoSelectedSourcesItemTwoSourceKeyMax = 100;

export const updateSowSessionResponseTwoSelectedSourcesItemTwoLabelMax = 500;

export const updateSowSessionResponseTwoSelectedSourcesItemTwoExcerptMax = 12000;

export const updateSowSessionResponseTwoSelectedSourcesMax = 20;

export const updateSowSessionResponseTwoConfirmedFactsItemQuoteMax = 4000;

export const updateSowSessionResponseTwoConfirmedFactsItemSourceIdsItemMax = 100;

export const updateSowSessionResponseTwoConfirmedFactsItemSourceIdsMax = 20;

export const updateSowSessionResponseTwoConfirmedFactsMax = 200;

export const updateSowSessionResponseTwoAssumptionsItemQuoteMax = 4000;

export const updateSowSessionResponseTwoAssumptionsItemSourceIdsItemMax = 100;

export const updateSowSessionResponseTwoAssumptionsItemSourceIdsMax = 20;

export const updateSowSessionResponseTwoAssumptionsMax = 200;

export const updateSowSessionResponseTwoGapsMax = 200;

export const updateSowSessionResponseTwoCorrectionsMax = 200;

export const updateSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMin = 5;
export const updateSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMax = 50;

export const updateSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMin = 5;
export const updateSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMax = 50;

export const updateSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMin = 5;
export const updateSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMax = 50;

export const updateSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMin = 5;
export const updateSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMax = 50;

export const updateSowSessionResponseTwoContentLayoutHeaderItemTypeMax = 40;

export const updateSowSessionResponseTwoContentLayoutHeaderItemTextMax = 200000;

export const updateSowSessionResponseTwoContentLayoutHeaderItemMarksItemTypeMax = 40;

export const updateSowSessionResponseTwoContentLayoutHeaderItemMarksMax = 20;

export const updateSowSessionResponseTwoContentLayoutHeaderItemContentMax = 10000;

export const updateSowSessionResponseTwoContentLayoutHeaderMax = 100;

export const updateSowSessionResponseTwoContentLayoutFooterItemTypeMax = 40;

export const updateSowSessionResponseTwoContentLayoutFooterItemTextMax = 200000;

export const updateSowSessionResponseTwoContentLayoutFooterItemMarksItemTypeMax = 40;

export const updateSowSessionResponseTwoContentLayoutFooterItemMarksMax = 20;

export const updateSowSessionResponseTwoContentLayoutFooterItemContentMax = 10000;

export const updateSowSessionResponseTwoContentLayoutFooterMax = 100;

export const updateSowSessionResponseTwoContentSectionsItemsItemTitleMax = 160;

export const updateSowSessionResponseTwoContentSectionsItemsItemAuthoringNotesMax = 4000;


export const updateSowSessionResponseTwoContentSectionsItemsMax = 200;

export const updateSowSessionResponseTwoContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const updateSowSessionResponseTwoContentStylesDefinitionsItemNameMax = 80;

export const updateSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMin = 6;
export const updateSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMax = 96;

export const updateSowSessionResponseTwoContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const updateSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const updateSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const updateSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMin = 0;
export const updateSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMax = 144;

export const updateSowSessionResponseTwoContentStylesDefinitionsItemLineHeightMax = 3;

export const updateSowSessionResponseTwoContentStylesDefinitionsMin = 7;
export const updateSowSessionResponseTwoContentStylesDefinitionsMax = 100;

export const updateSowSessionResponseTwoContentTemplateGuidanceMax = 4000;

export const updateSowSessionResponseTwoContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const updateSowSessionResponseTwoContentTemplateSectionGuidanceMax = 200;

export const updateSowSessionResponseTwoContentContentItemTypeMax = 40;

export const updateSowSessionResponseTwoContentContentItemTextMax = 200000;

export const updateSowSessionResponseTwoContentContentItemMarksItemTypeMax = 40;

export const updateSowSessionResponseTwoContentContentItemMarksMax = 20;

export const updateSowSessionResponseTwoContentContentItemContentMax = 10000;

export const updateSowSessionResponseTwoContentContentMax = 10000;



export const updateSowSessionResponse = zod.object({
  "proposalId": zod.uuid().optional(),
  "proposalRevision": zod.int().min(1).optional(),
  "id": zod.uuid(),
  "revision": zod.int().min(1),
  "conversationId": zod.uuid(),
  "templateVersionId": zod.uuid(),
  "title": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
}).and(zod.object({
  "workspaceContext": zod.object({
  "workspaceId": zod.uuid(),
  "snapshotId": zod.uuid(),
  "manifestHash": zod.string().regex(updateSowSessionResponseTwoWorkspaceContextManifestHashRegExp)
}).optional(),
  "requestId": zod.uuid().nullish(),
  "facts": zod.object({
  "projectTitle": zod.string().max(updateSowSessionResponseTwoFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(updateSowSessionResponseTwoFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(updateSowSessionResponseTwoFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(updateSowSessionResponseTwoFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(updateSowSessionResponseTwoFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(updateSowSessionResponseTwoFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(updateSowSessionResponseTwoFactsNarrativeItemTextMax)
})).max(updateSowSessionResponseTwoFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(updateSowSessionResponseTwoFactsTablesItemRowsItemItemMax)).max(updateSowSessionResponseTwoFactsTablesItemRowsItemMax)).max(updateSowSessionResponseTwoFactsTablesItemRowsMax)
})).max(updateSowSessionResponseTwoFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(updateSowSessionResponseTwoFactsInvestmentItemIdMax),
  "title": zod.string().max(updateSowSessionResponseTwoFactsInvestmentItemTitleMax),
  "description": zod.string().max(updateSowSessionResponseTwoFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(updateSowSessionResponseTwoFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(updateSowSessionResponseTwoFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(updateSowSessionResponseTwoFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(updateSowSessionResponseTwoFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(updateSowSessionResponseTwoFactsMaterialsItemIdMax),
  "title": zod.string().max(updateSowSessionResponseTwoFactsMaterialsItemTitleMax),
  "description": zod.string().max(updateSowSessionResponseTwoFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(updateSowSessionResponseTwoFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(updateSowSessionResponseTwoFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(updateSowSessionResponseTwoFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(updateSowSessionResponseTwoFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(updateSowSessionResponseTwoFactsInvoicesItemIdMax),
  "milestones": zod.string().max(updateSowSessionResponseTwoFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(updateSowSessionResponseTwoFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(updateSowSessionResponseTwoFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(updateSowSessionResponseTwoFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(updateSowSessionResponseTwoFactsInvoicesItemNotesMax)
})).max(updateSowSessionResponseTwoFactsInvoicesMax),
  "milestoneDays": zod.string().regex(updateSowSessionResponseTwoFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(updateSowSessionResponseTwoFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(updateSowSessionResponseTwoFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(updateSowSessionResponseTwoFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(updateSowSessionResponseTwoFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(updateSowSessionResponseTwoFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(updateSowSessionResponseTwoFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(updateSowSessionResponseTwoFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(updateSowSessionResponseTwoFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(updateSowSessionResponseTwoFactsQuoteCommercialReviewReasonMin).max(updateSowSessionResponseTwoFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(updateSowSessionResponseTwoFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(updateSowSessionResponseTwoFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(updateSowSessionResponseTwoFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(updateSowSessionResponseTwoFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(updateSowSessionResponseTwoFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(updateSowSessionResponseTwoFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(updateSowSessionResponseTwoFactsUnresolvedFactsItemMessageMax)
})).max(updateSowSessionResponseTwoFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(updateSowSessionResponseTwoFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(updateSowSessionResponseTwoFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(updateSowSessionResponseTwoFactsCustomFieldsItemValueMax).nullable()
})).max(updateSowSessionResponseTwoFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(updateSowSessionResponseTwoFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(updateSowSessionResponseTwoFactsCustomProseItemTextMax)
})).max(updateSowSessionResponseTwoFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(updateSowSessionResponseTwoFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(updateSowSessionResponseTwoFactsCustomTablesItemRowsItemItemMax)).max(updateSowSessionResponseTwoFactsCustomTablesItemRowsItemMax)).max(updateSowSessionResponseTwoFactsCustomTablesItemRowsMax)
})).max(updateSowSessionResponseTwoFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}),
  "selectedSources": zod.array(zod.object({
  "kind": zod.enum(['account', 'contact', 'opportunity', 'document', 'request']),
  "id": zod.uuid()
}).and(zod.object({
  "hash": zod.string().regex(updateSowSessionResponseTwoSelectedSourcesItemTwoHashRegExp),
  "revision": zod.string().max(updateSowSessionResponseTwoSelectedSourcesItemTwoRevisionMax),
  "sourceKey": zod.string().max(updateSowSessionResponseTwoSelectedSourcesItemTwoSourceKeyMax),
  "label": zod.string().max(updateSowSessionResponseTwoSelectedSourcesItemTwoLabelMax),
  "excerpt": zod.string().max(updateSowSessionResponseTwoSelectedSourcesItemTwoExcerptMax)
}))).max(updateSowSessionResponseTwoSelectedSourcesMax),
  "confirmedFacts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(updateSowSessionResponseTwoConfirmedFactsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(updateSowSessionResponseTwoConfirmedFactsItemSourceIdsItemMax)).max(updateSowSessionResponseTwoConfirmedFactsItemSourceIdsMax)
})).max(updateSowSessionResponseTwoConfirmedFactsMax),
  "assumptions": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'agreementId', 'preparedDate', 'startDate', 'sprintWeeks', 'narrative', 'tables', 'investment', 'materials', 'invoices', 'milestoneDays', 'displayedMaterialsTotal', 'engagementPack', 'quoteCommercial', 'custom']),
  "kind": zod.enum(['user', 'evidence', 'assumption']),
  "quote": zod.string().max(updateSowSessionResponseTwoAssumptionsItemQuoteMax),
  "sourceIds": zod.array(zod.string().max(updateSowSessionResponseTwoAssumptionsItemSourceIdsItemMax)).max(updateSowSessionResponseTwoAssumptionsItemSourceIdsMax)
})).max(updateSowSessionResponseTwoAssumptionsMax),
  "gaps": zod.array(zod.object({
  "field": zod.string(),
  "message": zod.string()
})).max(updateSowSessionResponseTwoGapsMax),
  "corrections": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string(),
  "after": zod.string(),
  "reason": zod.string()
})).max(updateSowSessionResponseTwoCorrectionsMax),
  "validation": zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(updateSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMin).max(updateSowSessionResponseTwoContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(updateSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMin).max(updateSowSessionResponseTwoContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(updateSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMin).max(updateSowSessionResponseTwoContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(updateSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMin).max(updateSowSessionResponseTwoContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(updateSowSessionResponseTwoContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(updateSowSessionResponseTwoContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateSowSessionResponseTwoContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateSowSessionResponseTwoContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateSowSessionResponseTwoContentLayoutHeaderItemContentMax).optional()
})).max(updateSowSessionResponseTwoContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(updateSowSessionResponseTwoContentLayoutFooterItemTypeMax),
  "text": zod.string().max(updateSowSessionResponseTwoContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateSowSessionResponseTwoContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateSowSessionResponseTwoContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateSowSessionResponseTwoContentLayoutFooterItemContentMax).optional()
})).max(updateSowSessionResponseTwoContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(updateSowSessionResponseTwoContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(updateSowSessionResponseTwoContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(updateSowSessionResponseTwoContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(updateSowSessionResponseTwoContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(updateSowSessionResponseTwoContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(updateSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMin).max(updateSowSessionResponseTwoContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(updateSowSessionResponseTwoContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(updateSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMin).max(updateSowSessionResponseTwoContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(updateSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMin).max(updateSowSessionResponseTwoContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(updateSowSessionResponseTwoContentStylesDefinitionsItemLineHeightMax)
})).min(updateSowSessionResponseTwoContentStylesDefinitionsMin).max(updateSowSessionResponseTwoContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(updateSowSessionResponseTwoContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(updateSowSessionResponseTwoContentTemplateSectionGuidanceItemGuidanceMax)
})).max(updateSowSessionResponseTwoContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(updateSowSessionResponseTwoContentContentItemTypeMax),
  "text": zod.string().max(updateSowSessionResponseTwoContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(updateSowSessionResponseTwoContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(updateSowSessionResponseTwoContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(updateSowSessionResponseTwoContentContentItemContentMax).optional()
})).max(updateSowSessionResponseTwoContentContentMax)
}),
  "sourceStatus": zod.enum(['current', 'stale'])
}))


export const prepareSowSessionReviewParams = zod.object({
  "id": zod.uuid()
})




export const prepareSowSessionReviewBody = zod.object({
  "expectedRevision": zod.int().min(1)
})


export const prepareSowSessionReviewResponseReviewDestructiveDefault = false;

export const prepareSowSessionReviewResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(prepareSowSessionReviewResponseReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})


export const getSowApprovalPolicyParams = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})

export const getSowApprovalPolicyResponseLocalRevisionMin = 0;

export const getSowApprovalPolicyResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowApprovalPolicyResponseRevisionsItemRevisionMin = 0;

export const getSowApprovalPolicyResponseRevisionsMax = 3;

export const getSowApprovalPolicyResponseOverridesEligibilityOneUserIdsMax = 100;

export const getSowApprovalPolicyResponseEligibilityUserIdsMax = 100;



export const getSowApprovalPolicyResponse = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(getSowApprovalPolicyResponseLocalRevisionMin),
  "fingerprint": zod.string().regex(getSowApprovalPolicyResponseFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getSowApprovalPolicyResponseRevisionsItemRevisionMin)
})).max(getSowApprovalPolicyResponseRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getSowApprovalPolicyResponseOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getSowApprovalPolicyResponseEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
})


export const writeSowApprovalPolicyParams = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})

export const writeSowApprovalPolicyBodyExpectedRevisionMin = 0;

export const writeSowApprovalPolicyBodyExpectedFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const writeSowApprovalPolicyBodyOverridesEligibilityOneUserIdsMax = 100;

export const writeSowApprovalPolicyBodyReasonMin = 10;
export const writeSowApprovalPolicyBodyReasonMax = 2000;



export const writeSowApprovalPolicyBody = zod.object({
  "expectedRevision": zod.int().min(writeSowApprovalPolicyBodyExpectedRevisionMin),
  "expectedFingerprint": zod.string().regex(writeSowApprovalPolicyBodyExpectedFingerprintRegExp),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(writeSowApprovalPolicyBodyOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "reason": zod.string().min(writeSowApprovalPolicyBodyReasonMin).max(writeSowApprovalPolicyBodyReasonMax)
})

export const writeSowApprovalPolicyResponseLocalRevisionMin = 0;

export const writeSowApprovalPolicyResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const writeSowApprovalPolicyResponseRevisionsItemRevisionMin = 0;

export const writeSowApprovalPolicyResponseRevisionsMax = 3;

export const writeSowApprovalPolicyResponseOverridesEligibilityOneUserIdsMax = 100;

export const writeSowApprovalPolicyResponseEligibilityUserIdsMax = 100;



export const writeSowApprovalPolicyResponse = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(writeSowApprovalPolicyResponseLocalRevisionMin),
  "fingerprint": zod.string().regex(writeSowApprovalPolicyResponseFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(writeSowApprovalPolicyResponseRevisionsItemRevisionMin)
})).max(writeSowApprovalPolicyResponseRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(writeSowApprovalPolicyResponseOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(writeSowApprovalPolicyResponseEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
})


export const listSowApprovalCandidatesParams = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity'])
})

export const listSowApprovalCandidatesQueryLimitDefault = 25;
export const listSowApprovalCandidatesQueryLimitMax = 100;

export const listSowApprovalCandidatesQueryOffsetDefault = 0;
export const listSowApprovalCandidatesQueryOffsetMin = 0;

export const listSowApprovalCandidatesQuerySearchMax = 100;



export const listSowApprovalCandidatesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSowApprovalCandidatesQueryLimitMax).default(listSowApprovalCandidatesQueryLimitDefault),
  "offset": zod.int().min(listSowApprovalCandidatesQueryOffsetMin).default(listSowApprovalCandidatesQueryOffsetDefault),
  "search": zod.string().max(listSowApprovalCandidatesQuerySearchMax).optional()
})

export const listSowApprovalCandidatesResponseItemsMax = 100;

export const listSowApprovalCandidatesResponseTotalMin = 0;

export const listSowApprovalCandidatesResponseLimitMax = 100;

export const listSowApprovalCandidatesResponseOffsetMin = 0;



export const listSowApprovalCandidatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "displayName": zod.string()
})).max(listSowApprovalCandidatesResponseItemsMax),
  "total": zod.int().min(listSowApprovalCandidatesResponseTotalMin),
  "limit": zod.int().min(1).max(listSowApprovalCandidatesResponseLimitMax),
  "offset": zod.int().min(listSowApprovalCandidatesResponseOffsetMin)
})


export const getEffectiveSowApprovalPolicyResponseLocalRevisionMin = 0;

export const getEffectiveSowApprovalPolicyResponseFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getEffectiveSowApprovalPolicyResponseRevisionsItemRevisionMin = 0;

export const getEffectiveSowApprovalPolicyResponseRevisionsMax = 3;

export const getEffectiveSowApprovalPolicyResponseOverridesEligibilityOneUserIdsMax = 100;

export const getEffectiveSowApprovalPolicyResponseEligibilityUserIdsMax = 100;



export const getEffectiveSowApprovalPolicyResponse = zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "localRevision": zod.int().min(getEffectiveSowApprovalPolicyResponseLocalRevisionMin),
  "fingerprint": zod.string().regex(getEffectiveSowApprovalPolicyResponseFingerprintRegExp),
  "revisions": zod.array(zod.object({
  "scope": zod.enum(['platform', 'tenant', 'entity']),
  "id": zod.uuid().nullable(),
  "revision": zod.int().min(getEffectiveSowApprovalPolicyResponseRevisionsItemRevisionMin)
})).max(getEffectiveSowApprovalPolicyResponseRevisionsMax),
  "overrides": zod.object({
  "eligibility": zod.union([zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getEffectiveSowApprovalPolicyResponseOverridesEligibilityOneUserIdsMax)
}),zod.null()]),
  "eligibilityLocked": zod.boolean(),
  "authorApproval": zod.boolean().nullable(),
  "authorApprovalLocked": zod.boolean()
}),
  "humanApprovalRequired": zod.literal(true),
  "eligibility": zod.object({
  "mode": zod.enum(['authorised', 'selected_users']),
  "userIds": zod.array(zod.uuid()).max(getEffectiveSowApprovalPolicyResponseEligibilityUserIdsMax)
}),
  "authorApproval": zod.boolean(),
  "eligibilityOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
}),
  "authorApprovalOrigin": zod.object({
  "origin": zod.enum(['default', 'platform', 'tenant', 'entity']),
  "lockedBy": zod.union([zod.enum(['platform', 'tenant', 'entity']),zod.null()]),
  "canOverride": zod.boolean()
})
})


export const listSowEmailEvidenceQueryLimitDefault = 20;
export const listSowEmailEvidenceQueryLimitMax = 100;

export const listSowEmailEvidenceQueryOffsetDefault = 0;
export const listSowEmailEvidenceQueryOffsetMin = 0;



export const listSowEmailEvidenceQueryParams = zod.object({
  "customerId": zod.uuid(),
  "limit": zod.int().min(1).max(listSowEmailEvidenceQueryLimitMax).default(listSowEmailEvidenceQueryLimitDefault),
  "offset": zod.int().min(listSowEmailEvidenceQueryOffsetMin).default(listSowEmailEvidenceQueryOffsetDefault)
})

export const listSowEmailEvidenceResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "subject": zod.string().nullable(),
  "from": zod.string()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


export const createSowQuoteRequestParams = zod.object({
  "id": zod.uuid()
})



export const createSowQuoteRequestBodyOptionalItemIdsMax = 100;

export const createSowQuoteRequestBodyReviewReasonMin = 10;
export const createSowQuoteRequestBodyReviewReasonMax = 2000;



export const createSowQuoteRequestBody = zod.object({
  "proposalId": zod.uuid().optional(),
  "expectedProposalRevision": zod.int().min(1).optional(),
  "idempotencyKey": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "templateVersionId": zod.uuid(),
  "optionalItemIds": zod.array(zod.uuid()).max(createSowQuoteRequestBodyOptionalItemIdsMax),
  "reviewReason": zod.string().min(createSowQuoteRequestBodyReviewReasonMin).max(createSowQuoteRequestBodyReviewReasonMax)
})


export const createSowQuoteRequestResponseSourceRevisionMax = 100;

export const createSowQuoteRequestResponseSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowQuoteRequestResponseAnalysisOneOneSummaryMax = 3000;

export const createSowQuoteRequestResponseAnalysisOneOneTemplateRationaleMax = 2000;

export const createSowQuoteRequestResponseAnalysisOneOneFactsItemValueMax = 4000;

export const createSowQuoteRequestResponseAnalysisOneOneFactsItemSourceIndexMin = 0;
export const createSowQuoteRequestResponseAnalysisOneOneFactsItemSourceIndexMax = 19;

export const createSowQuoteRequestResponseAnalysisOneOneFactsItemQuoteMax = 4000;

export const createSowQuoteRequestResponseAnalysisOneOneFactsMax = 80;

export const createSowQuoteRequestResponseAnalysisOneOneEffortItemLabelMax = 300;

export const createSowQuoteRequestResponseAnalysisOneOneEffortItemDaysRegExp = new RegExp('^[1-9][0-9]{0,3}$');
export const createSowQuoteRequestResponseAnalysisOneOneEffortItemSourceIndexMin = 0;
export const createSowQuoteRequestResponseAnalysisOneOneEffortItemSourceIndexMax = 19;

export const createSowQuoteRequestResponseAnalysisOneOneEffortItemQuoteMax = 2000;

export const createSowQuoteRequestResponseAnalysisOneOneEffortMax = 20;

export const createSowQuoteRequestResponseAnalysisOneOneUnresolvedItemFieldMax = 100;

export const createSowQuoteRequestResponseAnalysisOneOneUnresolvedItemMessageMax = 2000;

export const createSowQuoteRequestResponseAnalysisOneOneUnresolvedMax = 100;

export const createSowQuoteRequestResponseAnalysisOneTwoModelMax = 200;

export const createSowQuoteRequestResponseAnalysisOneTwoSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowQuoteRequestResponseAnalysisOneTwoCatalogueHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowQuoteRequestResponseAnalysisOneTwoPolicyFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowQuoteRequestResponseSourcesItemSourceIdMax = 200;

export const createSowQuoteRequestResponseSourcesItemRevisionMax = 100;

export const createSowQuoteRequestResponseSourcesItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowQuoteRequestResponseSourcesItemExtractionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowQuoteRequestResponseSourcesItemExcerptMax = 60000;

export const createSowQuoteRequestResponseSourcesItemWarningsItemMax = 2000;

export const createSowQuoteRequestResponseSourcesItemWarningsMax = 50;

export const createSowQuoteRequestResponseSourcesItemAttachmentsItemRevisionMax = 100;

export const createSowQuoteRequestResponseSourcesItemAttachmentsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowQuoteRequestResponseSourcesItemAttachmentsItemContentTypeMax = 200;

export const createSowQuoteRequestResponseSourcesItemAttachmentsItemSizeBytesMin = 0;
export const createSowQuoteRequestResponseSourcesItemAttachmentsItemSizeBytesMax = 16777216;

export const createSowQuoteRequestResponseSourcesItemAttachmentsMax = 20;

export const createSowQuoteRequestResponseSourcesMax = 20;

export const createSowQuoteRequestResponseTemplateSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowQuoteRequestResponseExtractedFieldsItemFieldMax = 100;

export const createSowQuoteRequestResponseExtractedFieldsItemValueMax = 8000;

export const createSowQuoteRequestResponseExtractedFieldsItemSourceIndexMin = 0;
export const createSowQuoteRequestResponseExtractedFieldsItemSourceIndexMax = 19;

export const createSowQuoteRequestResponseExtractedFieldsItemQuoteMax = 4000;

export const createSowQuoteRequestResponseExtractedFieldsMax = 200;

export const createSowQuoteRequestResponseUnresolvedItemsItemFieldMax = 100;

export const createSowQuoteRequestResponseUnresolvedItemsItemMessageMax = 2000;

export const createSowQuoteRequestResponseUnresolvedItemsMax = 200;

export const createSowQuoteRequestResponseProcessingErrorMax = 2000;



export const createSowQuoteRequestResponseQuoteHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const createSowQuoteRequestResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "customerId": zod.uuid(),
  "revision": zod.int().min(1),
  "sourceKind": zod.enum(['email', 'portal', 'quote']),
  "sourceRevision": zod.string().min(1).max(createSowQuoteRequestResponseSourceRevisionMax),
  "sourceHash": zod.string().regex(createSowQuoteRequestResponseSourceHashRegExp),
  "analysis": zod.union([zod.object({
  "summary": zod.string().max(createSowQuoteRequestResponseAnalysisOneOneSummaryMax),
  "template": zod.object({
  "status": zod.enum(['matched', 'ambiguous', 'none']),
  "templateVersionId": zod.uuid().nullable(),
  "rationale": zod.string().min(1).max(createSowQuoteRequestResponseAnalysisOneOneTemplateRationaleMax)
}),
  "facts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'recipient', 'startDate', 'deadline', 'scope', 'background', 'exclusion', 'commercial']),
  "value": zod.string().max(createSowQuoteRequestResponseAnalysisOneOneFactsItemValueMax),
  "sourceIndex": zod.int().min(createSowQuoteRequestResponseAnalysisOneOneFactsItemSourceIndexMin).max(createSowQuoteRequestResponseAnalysisOneOneFactsItemSourceIndexMax),
  "quote": zod.string().min(1).max(createSowQuoteRequestResponseAnalysisOneOneFactsItemQuoteMax)
})).max(createSowQuoteRequestResponseAnalysisOneOneFactsMax),
  "effort": zod.array(zod.object({
  "label": zod.string().min(1).max(createSowQuoteRequestResponseAnalysisOneOneEffortItemLabelMax),
  "days": zod.string().regex(createSowQuoteRequestResponseAnalysisOneOneEffortItemDaysRegExp),
  "kind": zod.enum(['paid', 'donated']),
  "sourceIndex": zod.int().min(createSowQuoteRequestResponseAnalysisOneOneEffortItemSourceIndexMin).max(createSowQuoteRequestResponseAnalysisOneOneEffortItemSourceIndexMax),
  "quote": zod.string().min(1).max(createSowQuoteRequestResponseAnalysisOneOneEffortItemQuoteMax)
})).max(createSowQuoteRequestResponseAnalysisOneOneEffortMax),
  "unresolved": zod.array(zod.object({
  "field": zod.string().min(1).max(createSowQuoteRequestResponseAnalysisOneOneUnresolvedItemFieldMax),
  "message": zod.string().min(1).max(createSowQuoteRequestResponseAnalysisOneOneUnresolvedItemMessageMax)
})).max(createSowQuoteRequestResponseAnalysisOneOneUnresolvedMax)
}).and(zod.object({
  "attemptId": zod.uuid(),
  "model": zod.string().min(1).max(createSowQuoteRequestResponseAnalysisOneTwoModelMax),
  "sourceHash": zod.string().regex(createSowQuoteRequestResponseAnalysisOneTwoSourceHashRegExp),
  "catalogueHash": zod.string().regex(createSowQuoteRequestResponseAnalysisOneTwoCatalogueHashRegExp),
  "policyFingerprint": zod.string().regex(createSowQuoteRequestResponseAnalysisOneTwoPolicyFingerprintRegExp),
  "createdAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional(),
  "sessionId": zod.uuid().nullish(),
  "sources": zod.array(zod.object({
  "kind": zod.enum(['email_paste', 'email_record', 'attachment', 'portal_chat', 'quote']),
  "sourceId": zod.string().min(1).max(createSowQuoteRequestResponseSourcesItemSourceIdMax),
  "revision": zod.string().min(1).max(createSowQuoteRequestResponseSourcesItemRevisionMax),
  "hash": zod.string().regex(createSowQuoteRequestResponseSourcesItemHashRegExp),
  "extractionHash": zod.string().regex(createSowQuoteRequestResponseSourcesItemExtractionHashRegExp),
  "excerpt": zod.string().max(createSowQuoteRequestResponseSourcesItemExcerptMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable']),
  "warnings": zod.array(zod.string().max(createSowQuoteRequestResponseSourcesItemWarningsItemMax)).max(createSowQuoteRequestResponseSourcesItemWarningsMax),
  "attachments": zod.array(zod.object({
  "fileId": zod.uuid(),
  "revision": zod.string().min(1).max(createSowQuoteRequestResponseSourcesItemAttachmentsItemRevisionMax),
  "hash": zod.string().regex(createSowQuoteRequestResponseSourcesItemAttachmentsItemHashRegExp),
  "contentType": zod.string().max(createSowQuoteRequestResponseSourcesItemAttachmentsItemContentTypeMax),
  "sizeBytes": zod.int().min(createSowQuoteRequestResponseSourcesItemAttachmentsItemSizeBytesMin).max(createSowQuoteRequestResponseSourcesItemAttachmentsItemSizeBytesMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(createSowQuoteRequestResponseSourcesItemAttachmentsMax)
})).min(1).max(createSowQuoteRequestResponseSourcesMax),
  "templateVersionId": zod.uuid().nullable(),
  "templateSourceHash": zod.string().regex(createSowQuoteRequestResponseTemplateSourceHashRegExp).nullable(),
  "extractedFields": zod.array(zod.object({
  "field": zod.string().min(1).max(createSowQuoteRequestResponseExtractedFieldsItemFieldMax),
  "value": zod.string().max(createSowQuoteRequestResponseExtractedFieldsItemValueMax),
  "sourceIndex": zod.int().min(createSowQuoteRequestResponseExtractedFieldsItemSourceIndexMin).max(createSowQuoteRequestResponseExtractedFieldsItemSourceIndexMax),
  "quote": zod.string().min(1).max(createSowQuoteRequestResponseExtractedFieldsItemQuoteMax)
})).max(createSowQuoteRequestResponseExtractedFieldsMax),
  "unresolvedItems": zod.array(zod.object({
  "field": zod.string().min(1).max(createSowQuoteRequestResponseUnresolvedItemsItemFieldMax),
  "message": zod.string().min(1).max(createSowQuoteRequestResponseUnresolvedItemsItemMessageMax)
})).max(createSowQuoteRequestResponseUnresolvedItemsMax),
  "processingState": zod.enum(['received', 'analyzing', 'needs_information', 'needs_template', 'ready_for_review', 'materializing', 'drafted', 'failed', 'cancelled']),
  "processingError": zod.string().max(createSowQuoteRequestResponseProcessingErrorMax).nullable(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "quoteId": zod.uuid().nullable(),
  "quoteRevision": zod.int().min(1).nullable(),
  "quoteHash": zod.string().regex(createSowQuoteRequestResponseQuoteHashRegExp).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const createSowEmailRequestBodyTextMax = 60000;

export const createSowEmailRequestBodyAttachmentFileIdsMax = 10;



export const createSowEmailRequestBody = zod.object({
  "idempotencyKey": zod.uuid(),
  "customerId": zod.uuid(),
  "text": zod.string().max(createSowEmailRequestBodyTextMax).nullable(),
  "emailId": zod.uuid().nullable(),
  "attachmentFileIds": zod.array(zod.uuid()).max(createSowEmailRequestBodyAttachmentFileIdsMax)
})


export const createSowEmailRequestResponseSourceRevisionMax = 100;

export const createSowEmailRequestResponseSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowEmailRequestResponseAnalysisOneOneSummaryMax = 3000;

export const createSowEmailRequestResponseAnalysisOneOneTemplateRationaleMax = 2000;

export const createSowEmailRequestResponseAnalysisOneOneFactsItemValueMax = 4000;

export const createSowEmailRequestResponseAnalysisOneOneFactsItemSourceIndexMin = 0;
export const createSowEmailRequestResponseAnalysisOneOneFactsItemSourceIndexMax = 19;

export const createSowEmailRequestResponseAnalysisOneOneFactsItemQuoteMax = 4000;

export const createSowEmailRequestResponseAnalysisOneOneFactsMax = 80;

export const createSowEmailRequestResponseAnalysisOneOneEffortItemLabelMax = 300;

export const createSowEmailRequestResponseAnalysisOneOneEffortItemDaysRegExp = new RegExp('^[1-9][0-9]{0,3}$');
export const createSowEmailRequestResponseAnalysisOneOneEffortItemSourceIndexMin = 0;
export const createSowEmailRequestResponseAnalysisOneOneEffortItemSourceIndexMax = 19;

export const createSowEmailRequestResponseAnalysisOneOneEffortItemQuoteMax = 2000;

export const createSowEmailRequestResponseAnalysisOneOneEffortMax = 20;

export const createSowEmailRequestResponseAnalysisOneOneUnresolvedItemFieldMax = 100;

export const createSowEmailRequestResponseAnalysisOneOneUnresolvedItemMessageMax = 2000;

export const createSowEmailRequestResponseAnalysisOneOneUnresolvedMax = 100;

export const createSowEmailRequestResponseAnalysisOneTwoModelMax = 200;

export const createSowEmailRequestResponseAnalysisOneTwoSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowEmailRequestResponseAnalysisOneTwoCatalogueHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowEmailRequestResponseAnalysisOneTwoPolicyFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowEmailRequestResponseSourcesItemSourceIdMax = 200;

export const createSowEmailRequestResponseSourcesItemRevisionMax = 100;

export const createSowEmailRequestResponseSourcesItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowEmailRequestResponseSourcesItemExtractionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowEmailRequestResponseSourcesItemExcerptMax = 60000;

export const createSowEmailRequestResponseSourcesItemWarningsItemMax = 2000;

export const createSowEmailRequestResponseSourcesItemWarningsMax = 50;

export const createSowEmailRequestResponseSourcesItemAttachmentsItemRevisionMax = 100;

export const createSowEmailRequestResponseSourcesItemAttachmentsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowEmailRequestResponseSourcesItemAttachmentsItemContentTypeMax = 200;

export const createSowEmailRequestResponseSourcesItemAttachmentsItemSizeBytesMin = 0;
export const createSowEmailRequestResponseSourcesItemAttachmentsItemSizeBytesMax = 16777216;

export const createSowEmailRequestResponseSourcesItemAttachmentsMax = 20;

export const createSowEmailRequestResponseSourcesMax = 20;

export const createSowEmailRequestResponseTemplateSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowEmailRequestResponseExtractedFieldsItemFieldMax = 100;

export const createSowEmailRequestResponseExtractedFieldsItemValueMax = 8000;

export const createSowEmailRequestResponseExtractedFieldsItemSourceIndexMin = 0;
export const createSowEmailRequestResponseExtractedFieldsItemSourceIndexMax = 19;

export const createSowEmailRequestResponseExtractedFieldsItemQuoteMax = 4000;

export const createSowEmailRequestResponseExtractedFieldsMax = 200;

export const createSowEmailRequestResponseUnresolvedItemsItemFieldMax = 100;

export const createSowEmailRequestResponseUnresolvedItemsItemMessageMax = 2000;

export const createSowEmailRequestResponseUnresolvedItemsMax = 200;

export const createSowEmailRequestResponseProcessingErrorMax = 2000;



export const createSowEmailRequestResponseQuoteHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const createSowEmailRequestResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "customerId": zod.uuid(),
  "revision": zod.int().min(1),
  "sourceKind": zod.enum(['email', 'portal', 'quote']),
  "sourceRevision": zod.string().min(1).max(createSowEmailRequestResponseSourceRevisionMax),
  "sourceHash": zod.string().regex(createSowEmailRequestResponseSourceHashRegExp),
  "analysis": zod.union([zod.object({
  "summary": zod.string().max(createSowEmailRequestResponseAnalysisOneOneSummaryMax),
  "template": zod.object({
  "status": zod.enum(['matched', 'ambiguous', 'none']),
  "templateVersionId": zod.uuid().nullable(),
  "rationale": zod.string().min(1).max(createSowEmailRequestResponseAnalysisOneOneTemplateRationaleMax)
}),
  "facts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'recipient', 'startDate', 'deadline', 'scope', 'background', 'exclusion', 'commercial']),
  "value": zod.string().max(createSowEmailRequestResponseAnalysisOneOneFactsItemValueMax),
  "sourceIndex": zod.int().min(createSowEmailRequestResponseAnalysisOneOneFactsItemSourceIndexMin).max(createSowEmailRequestResponseAnalysisOneOneFactsItemSourceIndexMax),
  "quote": zod.string().min(1).max(createSowEmailRequestResponseAnalysisOneOneFactsItemQuoteMax)
})).max(createSowEmailRequestResponseAnalysisOneOneFactsMax),
  "effort": zod.array(zod.object({
  "label": zod.string().min(1).max(createSowEmailRequestResponseAnalysisOneOneEffortItemLabelMax),
  "days": zod.string().regex(createSowEmailRequestResponseAnalysisOneOneEffortItemDaysRegExp),
  "kind": zod.enum(['paid', 'donated']),
  "sourceIndex": zod.int().min(createSowEmailRequestResponseAnalysisOneOneEffortItemSourceIndexMin).max(createSowEmailRequestResponseAnalysisOneOneEffortItemSourceIndexMax),
  "quote": zod.string().min(1).max(createSowEmailRequestResponseAnalysisOneOneEffortItemQuoteMax)
})).max(createSowEmailRequestResponseAnalysisOneOneEffortMax),
  "unresolved": zod.array(zod.object({
  "field": zod.string().min(1).max(createSowEmailRequestResponseAnalysisOneOneUnresolvedItemFieldMax),
  "message": zod.string().min(1).max(createSowEmailRequestResponseAnalysisOneOneUnresolvedItemMessageMax)
})).max(createSowEmailRequestResponseAnalysisOneOneUnresolvedMax)
}).and(zod.object({
  "attemptId": zod.uuid(),
  "model": zod.string().min(1).max(createSowEmailRequestResponseAnalysisOneTwoModelMax),
  "sourceHash": zod.string().regex(createSowEmailRequestResponseAnalysisOneTwoSourceHashRegExp),
  "catalogueHash": zod.string().regex(createSowEmailRequestResponseAnalysisOneTwoCatalogueHashRegExp),
  "policyFingerprint": zod.string().regex(createSowEmailRequestResponseAnalysisOneTwoPolicyFingerprintRegExp),
  "createdAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional(),
  "sessionId": zod.uuid().nullish(),
  "sources": zod.array(zod.object({
  "kind": zod.enum(['email_paste', 'email_record', 'attachment', 'portal_chat', 'quote']),
  "sourceId": zod.string().min(1).max(createSowEmailRequestResponseSourcesItemSourceIdMax),
  "revision": zod.string().min(1).max(createSowEmailRequestResponseSourcesItemRevisionMax),
  "hash": zod.string().regex(createSowEmailRequestResponseSourcesItemHashRegExp),
  "extractionHash": zod.string().regex(createSowEmailRequestResponseSourcesItemExtractionHashRegExp),
  "excerpt": zod.string().max(createSowEmailRequestResponseSourcesItemExcerptMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable']),
  "warnings": zod.array(zod.string().max(createSowEmailRequestResponseSourcesItemWarningsItemMax)).max(createSowEmailRequestResponseSourcesItemWarningsMax),
  "attachments": zod.array(zod.object({
  "fileId": zod.uuid(),
  "revision": zod.string().min(1).max(createSowEmailRequestResponseSourcesItemAttachmentsItemRevisionMax),
  "hash": zod.string().regex(createSowEmailRequestResponseSourcesItemAttachmentsItemHashRegExp),
  "contentType": zod.string().max(createSowEmailRequestResponseSourcesItemAttachmentsItemContentTypeMax),
  "sizeBytes": zod.int().min(createSowEmailRequestResponseSourcesItemAttachmentsItemSizeBytesMin).max(createSowEmailRequestResponseSourcesItemAttachmentsItemSizeBytesMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(createSowEmailRequestResponseSourcesItemAttachmentsMax)
})).min(1).max(createSowEmailRequestResponseSourcesMax),
  "templateVersionId": zod.uuid().nullable(),
  "templateSourceHash": zod.string().regex(createSowEmailRequestResponseTemplateSourceHashRegExp).nullable(),
  "extractedFields": zod.array(zod.object({
  "field": zod.string().min(1).max(createSowEmailRequestResponseExtractedFieldsItemFieldMax),
  "value": zod.string().max(createSowEmailRequestResponseExtractedFieldsItemValueMax),
  "sourceIndex": zod.int().min(createSowEmailRequestResponseExtractedFieldsItemSourceIndexMin).max(createSowEmailRequestResponseExtractedFieldsItemSourceIndexMax),
  "quote": zod.string().min(1).max(createSowEmailRequestResponseExtractedFieldsItemQuoteMax)
})).max(createSowEmailRequestResponseExtractedFieldsMax),
  "unresolvedItems": zod.array(zod.object({
  "field": zod.string().min(1).max(createSowEmailRequestResponseUnresolvedItemsItemFieldMax),
  "message": zod.string().min(1).max(createSowEmailRequestResponseUnresolvedItemsItemMessageMax)
})).max(createSowEmailRequestResponseUnresolvedItemsMax),
  "processingState": zod.enum(['received', 'analyzing', 'needs_information', 'needs_template', 'ready_for_review', 'materializing', 'drafted', 'failed', 'cancelled']),
  "processingError": zod.string().max(createSowEmailRequestResponseProcessingErrorMax).nullable(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "quoteId": zod.uuid().nullable(),
  "quoteRevision": zod.int().min(1).nullable(),
  "quoteHash": zod.string().regex(createSowEmailRequestResponseQuoteHashRegExp).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const listSowRequestsQueryLimitDefault = 25;
export const listSowRequestsQueryLimitMax = 100;

export const listSowRequestsQueryOffsetDefault = 0;
export const listSowRequestsQueryOffsetMin = 0;



export const listSowRequestsQueryParams = zod.object({
  "customerId": zod.uuid().optional(),
  "quoteId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listSowRequestsQueryLimitMax).default(listSowRequestsQueryLimitDefault),
  "offset": zod.int().min(listSowRequestsQueryOffsetMin).default(listSowRequestsQueryOffsetDefault)
})


export const listSowRequestsResponseItemsItemSourceRevisionMax = 100;

export const listSowRequestsResponseItemsItemSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listSowRequestsResponseItemsItemAnalysisOneOneSummaryMax = 3000;

export const listSowRequestsResponseItemsItemAnalysisOneOneTemplateRationaleMax = 2000;

export const listSowRequestsResponseItemsItemAnalysisOneOneFactsItemValueMax = 4000;

export const listSowRequestsResponseItemsItemAnalysisOneOneFactsItemSourceIndexMin = 0;
export const listSowRequestsResponseItemsItemAnalysisOneOneFactsItemSourceIndexMax = 19;

export const listSowRequestsResponseItemsItemAnalysisOneOneFactsItemQuoteMax = 4000;

export const listSowRequestsResponseItemsItemAnalysisOneOneFactsMax = 80;

export const listSowRequestsResponseItemsItemAnalysisOneOneEffortItemLabelMax = 300;

export const listSowRequestsResponseItemsItemAnalysisOneOneEffortItemDaysRegExp = new RegExp('^[1-9][0-9]{0,3}$');
export const listSowRequestsResponseItemsItemAnalysisOneOneEffortItemSourceIndexMin = 0;
export const listSowRequestsResponseItemsItemAnalysisOneOneEffortItemSourceIndexMax = 19;

export const listSowRequestsResponseItemsItemAnalysisOneOneEffortItemQuoteMax = 2000;

export const listSowRequestsResponseItemsItemAnalysisOneOneEffortMax = 20;

export const listSowRequestsResponseItemsItemAnalysisOneOneUnresolvedItemFieldMax = 100;

export const listSowRequestsResponseItemsItemAnalysisOneOneUnresolvedItemMessageMax = 2000;

export const listSowRequestsResponseItemsItemAnalysisOneOneUnresolvedMax = 100;

export const listSowRequestsResponseItemsItemAnalysisOneTwoModelMax = 200;

export const listSowRequestsResponseItemsItemAnalysisOneTwoSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listSowRequestsResponseItemsItemAnalysisOneTwoCatalogueHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listSowRequestsResponseItemsItemAnalysisOneTwoPolicyFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const listSowRequestsResponseItemsItemSourcesItemSourceIdMax = 200;

export const listSowRequestsResponseItemsItemSourcesItemRevisionMax = 100;

export const listSowRequestsResponseItemsItemSourcesItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listSowRequestsResponseItemsItemSourcesItemExtractionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listSowRequestsResponseItemsItemSourcesItemExcerptMax = 60000;

export const listSowRequestsResponseItemsItemSourcesItemWarningsItemMax = 2000;

export const listSowRequestsResponseItemsItemSourcesItemWarningsMax = 50;

export const listSowRequestsResponseItemsItemSourcesItemAttachmentsItemRevisionMax = 100;

export const listSowRequestsResponseItemsItemSourcesItemAttachmentsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listSowRequestsResponseItemsItemSourcesItemAttachmentsItemContentTypeMax = 200;

export const listSowRequestsResponseItemsItemSourcesItemAttachmentsItemSizeBytesMin = 0;
export const listSowRequestsResponseItemsItemSourcesItemAttachmentsItemSizeBytesMax = 16777216;

export const listSowRequestsResponseItemsItemSourcesItemAttachmentsMax = 20;

export const listSowRequestsResponseItemsItemSourcesMax = 20;

export const listSowRequestsResponseItemsItemTemplateSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listSowRequestsResponseItemsItemExtractedFieldsItemFieldMax = 100;

export const listSowRequestsResponseItemsItemExtractedFieldsItemValueMax = 8000;

export const listSowRequestsResponseItemsItemExtractedFieldsItemSourceIndexMin = 0;
export const listSowRequestsResponseItemsItemExtractedFieldsItemSourceIndexMax = 19;

export const listSowRequestsResponseItemsItemExtractedFieldsItemQuoteMax = 4000;

export const listSowRequestsResponseItemsItemExtractedFieldsMax = 200;

export const listSowRequestsResponseItemsItemUnresolvedItemsItemFieldMax = 100;

export const listSowRequestsResponseItemsItemUnresolvedItemsItemMessageMax = 2000;

export const listSowRequestsResponseItemsItemUnresolvedItemsMax = 200;

export const listSowRequestsResponseItemsItemProcessingErrorMax = 2000;



export const listSowRequestsResponseItemsItemQuoteHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const listSowRequestsResponseTotalMin = 0;


export const listSowRequestsResponseOffsetMin = 0;



export const listSowRequestsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "customerId": zod.uuid(),
  "revision": zod.int().min(1),
  "sourceKind": zod.enum(['email', 'portal', 'quote']),
  "sourceRevision": zod.string().min(1).max(listSowRequestsResponseItemsItemSourceRevisionMax),
  "sourceHash": zod.string().regex(listSowRequestsResponseItemsItemSourceHashRegExp),
  "analysis": zod.union([zod.object({
  "summary": zod.string().max(listSowRequestsResponseItemsItemAnalysisOneOneSummaryMax),
  "template": zod.object({
  "status": zod.enum(['matched', 'ambiguous', 'none']),
  "templateVersionId": zod.uuid().nullable(),
  "rationale": zod.string().min(1).max(listSowRequestsResponseItemsItemAnalysisOneOneTemplateRationaleMax)
}),
  "facts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'recipient', 'startDate', 'deadline', 'scope', 'background', 'exclusion', 'commercial']),
  "value": zod.string().max(listSowRequestsResponseItemsItemAnalysisOneOneFactsItemValueMax),
  "sourceIndex": zod.int().min(listSowRequestsResponseItemsItemAnalysisOneOneFactsItemSourceIndexMin).max(listSowRequestsResponseItemsItemAnalysisOneOneFactsItemSourceIndexMax),
  "quote": zod.string().min(1).max(listSowRequestsResponseItemsItemAnalysisOneOneFactsItemQuoteMax)
})).max(listSowRequestsResponseItemsItemAnalysisOneOneFactsMax),
  "effort": zod.array(zod.object({
  "label": zod.string().min(1).max(listSowRequestsResponseItemsItemAnalysisOneOneEffortItemLabelMax),
  "days": zod.string().regex(listSowRequestsResponseItemsItemAnalysisOneOneEffortItemDaysRegExp),
  "kind": zod.enum(['paid', 'donated']),
  "sourceIndex": zod.int().min(listSowRequestsResponseItemsItemAnalysisOneOneEffortItemSourceIndexMin).max(listSowRequestsResponseItemsItemAnalysisOneOneEffortItemSourceIndexMax),
  "quote": zod.string().min(1).max(listSowRequestsResponseItemsItemAnalysisOneOneEffortItemQuoteMax)
})).max(listSowRequestsResponseItemsItemAnalysisOneOneEffortMax),
  "unresolved": zod.array(zod.object({
  "field": zod.string().min(1).max(listSowRequestsResponseItemsItemAnalysisOneOneUnresolvedItemFieldMax),
  "message": zod.string().min(1).max(listSowRequestsResponseItemsItemAnalysisOneOneUnresolvedItemMessageMax)
})).max(listSowRequestsResponseItemsItemAnalysisOneOneUnresolvedMax)
}).and(zod.object({
  "attemptId": zod.uuid(),
  "model": zod.string().min(1).max(listSowRequestsResponseItemsItemAnalysisOneTwoModelMax),
  "sourceHash": zod.string().regex(listSowRequestsResponseItemsItemAnalysisOneTwoSourceHashRegExp),
  "catalogueHash": zod.string().regex(listSowRequestsResponseItemsItemAnalysisOneTwoCatalogueHashRegExp),
  "policyFingerprint": zod.string().regex(listSowRequestsResponseItemsItemAnalysisOneTwoPolicyFingerprintRegExp),
  "createdAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional(),
  "sessionId": zod.uuid().nullish(),
  "sources": zod.array(zod.object({
  "kind": zod.enum(['email_paste', 'email_record', 'attachment', 'portal_chat', 'quote']),
  "sourceId": zod.string().min(1).max(listSowRequestsResponseItemsItemSourcesItemSourceIdMax),
  "revision": zod.string().min(1).max(listSowRequestsResponseItemsItemSourcesItemRevisionMax),
  "hash": zod.string().regex(listSowRequestsResponseItemsItemSourcesItemHashRegExp),
  "extractionHash": zod.string().regex(listSowRequestsResponseItemsItemSourcesItemExtractionHashRegExp),
  "excerpt": zod.string().max(listSowRequestsResponseItemsItemSourcesItemExcerptMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable']),
  "warnings": zod.array(zod.string().max(listSowRequestsResponseItemsItemSourcesItemWarningsItemMax)).max(listSowRequestsResponseItemsItemSourcesItemWarningsMax),
  "attachments": zod.array(zod.object({
  "fileId": zod.uuid(),
  "revision": zod.string().min(1).max(listSowRequestsResponseItemsItemSourcesItemAttachmentsItemRevisionMax),
  "hash": zod.string().regex(listSowRequestsResponseItemsItemSourcesItemAttachmentsItemHashRegExp),
  "contentType": zod.string().max(listSowRequestsResponseItemsItemSourcesItemAttachmentsItemContentTypeMax),
  "sizeBytes": zod.int().min(listSowRequestsResponseItemsItemSourcesItemAttachmentsItemSizeBytesMin).max(listSowRequestsResponseItemsItemSourcesItemAttachmentsItemSizeBytesMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(listSowRequestsResponseItemsItemSourcesItemAttachmentsMax)
})).min(1).max(listSowRequestsResponseItemsItemSourcesMax),
  "templateVersionId": zod.uuid().nullable(),
  "templateSourceHash": zod.string().regex(listSowRequestsResponseItemsItemTemplateSourceHashRegExp).nullable(),
  "extractedFields": zod.array(zod.object({
  "field": zod.string().min(1).max(listSowRequestsResponseItemsItemExtractedFieldsItemFieldMax),
  "value": zod.string().max(listSowRequestsResponseItemsItemExtractedFieldsItemValueMax),
  "sourceIndex": zod.int().min(listSowRequestsResponseItemsItemExtractedFieldsItemSourceIndexMin).max(listSowRequestsResponseItemsItemExtractedFieldsItemSourceIndexMax),
  "quote": zod.string().min(1).max(listSowRequestsResponseItemsItemExtractedFieldsItemQuoteMax)
})).max(listSowRequestsResponseItemsItemExtractedFieldsMax),
  "unresolvedItems": zod.array(zod.object({
  "field": zod.string().min(1).max(listSowRequestsResponseItemsItemUnresolvedItemsItemFieldMax),
  "message": zod.string().min(1).max(listSowRequestsResponseItemsItemUnresolvedItemsItemMessageMax)
})).max(listSowRequestsResponseItemsItemUnresolvedItemsMax),
  "processingState": zod.enum(['received', 'analyzing', 'needs_information', 'needs_template', 'ready_for_review', 'materializing', 'drafted', 'failed', 'cancelled']),
  "processingError": zod.string().max(listSowRequestsResponseItemsItemProcessingErrorMax).nullable(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "quoteId": zod.uuid().nullable(),
  "quoteRevision": zod.int().min(1).nullable(),
  "quoteHash": zod.string().regex(listSowRequestsResponseItemsItemQuoteHashRegExp).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int().min(listSowRequestsResponseTotalMin),
  "limit": zod.int().min(1),
  "offset": zod.int().min(listSowRequestsResponseOffsetMin)
})


export const getSowRequestParams = zod.object({
  "id": zod.uuid()
})


export const getSowRequestResponseSourceRevisionMax = 100;

export const getSowRequestResponseSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowRequestResponseAnalysisOneOneSummaryMax = 3000;

export const getSowRequestResponseAnalysisOneOneTemplateRationaleMax = 2000;

export const getSowRequestResponseAnalysisOneOneFactsItemValueMax = 4000;

export const getSowRequestResponseAnalysisOneOneFactsItemSourceIndexMin = 0;
export const getSowRequestResponseAnalysisOneOneFactsItemSourceIndexMax = 19;

export const getSowRequestResponseAnalysisOneOneFactsItemQuoteMax = 4000;

export const getSowRequestResponseAnalysisOneOneFactsMax = 80;

export const getSowRequestResponseAnalysisOneOneEffortItemLabelMax = 300;

export const getSowRequestResponseAnalysisOneOneEffortItemDaysRegExp = new RegExp('^[1-9][0-9]{0,3}$');
export const getSowRequestResponseAnalysisOneOneEffortItemSourceIndexMin = 0;
export const getSowRequestResponseAnalysisOneOneEffortItemSourceIndexMax = 19;

export const getSowRequestResponseAnalysisOneOneEffortItemQuoteMax = 2000;

export const getSowRequestResponseAnalysisOneOneEffortMax = 20;

export const getSowRequestResponseAnalysisOneOneUnresolvedItemFieldMax = 100;

export const getSowRequestResponseAnalysisOneOneUnresolvedItemMessageMax = 2000;

export const getSowRequestResponseAnalysisOneOneUnresolvedMax = 100;

export const getSowRequestResponseAnalysisOneTwoModelMax = 200;

export const getSowRequestResponseAnalysisOneTwoSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowRequestResponseAnalysisOneTwoCatalogueHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowRequestResponseAnalysisOneTwoPolicyFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowRequestResponseSourcesItemSourceIdMax = 200;

export const getSowRequestResponseSourcesItemRevisionMax = 100;

export const getSowRequestResponseSourcesItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowRequestResponseSourcesItemExtractionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowRequestResponseSourcesItemExcerptMax = 60000;

export const getSowRequestResponseSourcesItemWarningsItemMax = 2000;

export const getSowRequestResponseSourcesItemWarningsMax = 50;

export const getSowRequestResponseSourcesItemAttachmentsItemRevisionMax = 100;

export const getSowRequestResponseSourcesItemAttachmentsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowRequestResponseSourcesItemAttachmentsItemContentTypeMax = 200;

export const getSowRequestResponseSourcesItemAttachmentsItemSizeBytesMin = 0;
export const getSowRequestResponseSourcesItemAttachmentsItemSizeBytesMax = 16777216;

export const getSowRequestResponseSourcesItemAttachmentsMax = 20;

export const getSowRequestResponseSourcesMax = 20;

export const getSowRequestResponseTemplateSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const getSowRequestResponseExtractedFieldsItemFieldMax = 100;

export const getSowRequestResponseExtractedFieldsItemValueMax = 8000;

export const getSowRequestResponseExtractedFieldsItemSourceIndexMin = 0;
export const getSowRequestResponseExtractedFieldsItemSourceIndexMax = 19;

export const getSowRequestResponseExtractedFieldsItemQuoteMax = 4000;

export const getSowRequestResponseExtractedFieldsMax = 200;

export const getSowRequestResponseUnresolvedItemsItemFieldMax = 100;

export const getSowRequestResponseUnresolvedItemsItemMessageMax = 2000;

export const getSowRequestResponseUnresolvedItemsMax = 200;

export const getSowRequestResponseProcessingErrorMax = 2000;



export const getSowRequestResponseQuoteHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const getSowRequestResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "customerId": zod.uuid(),
  "revision": zod.int().min(1),
  "sourceKind": zod.enum(['email', 'portal', 'quote']),
  "sourceRevision": zod.string().min(1).max(getSowRequestResponseSourceRevisionMax),
  "sourceHash": zod.string().regex(getSowRequestResponseSourceHashRegExp),
  "analysis": zod.union([zod.object({
  "summary": zod.string().max(getSowRequestResponseAnalysisOneOneSummaryMax),
  "template": zod.object({
  "status": zod.enum(['matched', 'ambiguous', 'none']),
  "templateVersionId": zod.uuid().nullable(),
  "rationale": zod.string().min(1).max(getSowRequestResponseAnalysisOneOneTemplateRationaleMax)
}),
  "facts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'recipient', 'startDate', 'deadline', 'scope', 'background', 'exclusion', 'commercial']),
  "value": zod.string().max(getSowRequestResponseAnalysisOneOneFactsItemValueMax),
  "sourceIndex": zod.int().min(getSowRequestResponseAnalysisOneOneFactsItemSourceIndexMin).max(getSowRequestResponseAnalysisOneOneFactsItemSourceIndexMax),
  "quote": zod.string().min(1).max(getSowRequestResponseAnalysisOneOneFactsItemQuoteMax)
})).max(getSowRequestResponseAnalysisOneOneFactsMax),
  "effort": zod.array(zod.object({
  "label": zod.string().min(1).max(getSowRequestResponseAnalysisOneOneEffortItemLabelMax),
  "days": zod.string().regex(getSowRequestResponseAnalysisOneOneEffortItemDaysRegExp),
  "kind": zod.enum(['paid', 'donated']),
  "sourceIndex": zod.int().min(getSowRequestResponseAnalysisOneOneEffortItemSourceIndexMin).max(getSowRequestResponseAnalysisOneOneEffortItemSourceIndexMax),
  "quote": zod.string().min(1).max(getSowRequestResponseAnalysisOneOneEffortItemQuoteMax)
})).max(getSowRequestResponseAnalysisOneOneEffortMax),
  "unresolved": zod.array(zod.object({
  "field": zod.string().min(1).max(getSowRequestResponseAnalysisOneOneUnresolvedItemFieldMax),
  "message": zod.string().min(1).max(getSowRequestResponseAnalysisOneOneUnresolvedItemMessageMax)
})).max(getSowRequestResponseAnalysisOneOneUnresolvedMax)
}).and(zod.object({
  "attemptId": zod.uuid(),
  "model": zod.string().min(1).max(getSowRequestResponseAnalysisOneTwoModelMax),
  "sourceHash": zod.string().regex(getSowRequestResponseAnalysisOneTwoSourceHashRegExp),
  "catalogueHash": zod.string().regex(getSowRequestResponseAnalysisOneTwoCatalogueHashRegExp),
  "policyFingerprint": zod.string().regex(getSowRequestResponseAnalysisOneTwoPolicyFingerprintRegExp),
  "createdAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional(),
  "sessionId": zod.uuid().nullish(),
  "sources": zod.array(zod.object({
  "kind": zod.enum(['email_paste', 'email_record', 'attachment', 'portal_chat', 'quote']),
  "sourceId": zod.string().min(1).max(getSowRequestResponseSourcesItemSourceIdMax),
  "revision": zod.string().min(1).max(getSowRequestResponseSourcesItemRevisionMax),
  "hash": zod.string().regex(getSowRequestResponseSourcesItemHashRegExp),
  "extractionHash": zod.string().regex(getSowRequestResponseSourcesItemExtractionHashRegExp),
  "excerpt": zod.string().max(getSowRequestResponseSourcesItemExcerptMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable']),
  "warnings": zod.array(zod.string().max(getSowRequestResponseSourcesItemWarningsItemMax)).max(getSowRequestResponseSourcesItemWarningsMax),
  "attachments": zod.array(zod.object({
  "fileId": zod.uuid(),
  "revision": zod.string().min(1).max(getSowRequestResponseSourcesItemAttachmentsItemRevisionMax),
  "hash": zod.string().regex(getSowRequestResponseSourcesItemAttachmentsItemHashRegExp),
  "contentType": zod.string().max(getSowRequestResponseSourcesItemAttachmentsItemContentTypeMax),
  "sizeBytes": zod.int().min(getSowRequestResponseSourcesItemAttachmentsItemSizeBytesMin).max(getSowRequestResponseSourcesItemAttachmentsItemSizeBytesMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(getSowRequestResponseSourcesItemAttachmentsMax)
})).min(1).max(getSowRequestResponseSourcesMax),
  "templateVersionId": zod.uuid().nullable(),
  "templateSourceHash": zod.string().regex(getSowRequestResponseTemplateSourceHashRegExp).nullable(),
  "extractedFields": zod.array(zod.object({
  "field": zod.string().min(1).max(getSowRequestResponseExtractedFieldsItemFieldMax),
  "value": zod.string().max(getSowRequestResponseExtractedFieldsItemValueMax),
  "sourceIndex": zod.int().min(getSowRequestResponseExtractedFieldsItemSourceIndexMin).max(getSowRequestResponseExtractedFieldsItemSourceIndexMax),
  "quote": zod.string().min(1).max(getSowRequestResponseExtractedFieldsItemQuoteMax)
})).max(getSowRequestResponseExtractedFieldsMax),
  "unresolvedItems": zod.array(zod.object({
  "field": zod.string().min(1).max(getSowRequestResponseUnresolvedItemsItemFieldMax),
  "message": zod.string().min(1).max(getSowRequestResponseUnresolvedItemsItemMessageMax)
})).max(getSowRequestResponseUnresolvedItemsMax),
  "processingState": zod.enum(['received', 'analyzing', 'needs_information', 'needs_template', 'ready_for_review', 'materializing', 'drafted', 'failed', 'cancelled']),
  "processingError": zod.string().max(getSowRequestResponseProcessingErrorMax).nullable(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "quoteId": zod.uuid().nullable(),
  "quoteRevision": zod.int().min(1).nullable(),
  "quoteHash": zod.string().regex(getSowRequestResponseQuoteHashRegExp).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const analyzeSowEmailRequestParams = zod.object({
  "id": zod.uuid()
})




export const analyzeSowEmailRequestBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "attemptId": zod.uuid()
})


export const analyzeSowEmailRequestResponseSourceRevisionMax = 100;

export const analyzeSowEmailRequestResponseSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const analyzeSowEmailRequestResponseAnalysisOneOneSummaryMax = 3000;

export const analyzeSowEmailRequestResponseAnalysisOneOneTemplateRationaleMax = 2000;

export const analyzeSowEmailRequestResponseAnalysisOneOneFactsItemValueMax = 4000;

export const analyzeSowEmailRequestResponseAnalysisOneOneFactsItemSourceIndexMin = 0;
export const analyzeSowEmailRequestResponseAnalysisOneOneFactsItemSourceIndexMax = 19;

export const analyzeSowEmailRequestResponseAnalysisOneOneFactsItemQuoteMax = 4000;

export const analyzeSowEmailRequestResponseAnalysisOneOneFactsMax = 80;

export const analyzeSowEmailRequestResponseAnalysisOneOneEffortItemLabelMax = 300;

export const analyzeSowEmailRequestResponseAnalysisOneOneEffortItemDaysRegExp = new RegExp('^[1-9][0-9]{0,3}$');
export const analyzeSowEmailRequestResponseAnalysisOneOneEffortItemSourceIndexMin = 0;
export const analyzeSowEmailRequestResponseAnalysisOneOneEffortItemSourceIndexMax = 19;

export const analyzeSowEmailRequestResponseAnalysisOneOneEffortItemQuoteMax = 2000;

export const analyzeSowEmailRequestResponseAnalysisOneOneEffortMax = 20;

export const analyzeSowEmailRequestResponseAnalysisOneOneUnresolvedItemFieldMax = 100;

export const analyzeSowEmailRequestResponseAnalysisOneOneUnresolvedItemMessageMax = 2000;

export const analyzeSowEmailRequestResponseAnalysisOneOneUnresolvedMax = 100;

export const analyzeSowEmailRequestResponseAnalysisOneTwoModelMax = 200;

export const analyzeSowEmailRequestResponseAnalysisOneTwoSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const analyzeSowEmailRequestResponseAnalysisOneTwoCatalogueHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const analyzeSowEmailRequestResponseAnalysisOneTwoPolicyFingerprintRegExp = new RegExp('^[a-f0-9]{64}$');
export const analyzeSowEmailRequestResponseSourcesItemSourceIdMax = 200;

export const analyzeSowEmailRequestResponseSourcesItemRevisionMax = 100;

export const analyzeSowEmailRequestResponseSourcesItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const analyzeSowEmailRequestResponseSourcesItemExtractionHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const analyzeSowEmailRequestResponseSourcesItemExcerptMax = 60000;

export const analyzeSowEmailRequestResponseSourcesItemWarningsItemMax = 2000;

export const analyzeSowEmailRequestResponseSourcesItemWarningsMax = 50;

export const analyzeSowEmailRequestResponseSourcesItemAttachmentsItemRevisionMax = 100;

export const analyzeSowEmailRequestResponseSourcesItemAttachmentsItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const analyzeSowEmailRequestResponseSourcesItemAttachmentsItemContentTypeMax = 200;

export const analyzeSowEmailRequestResponseSourcesItemAttachmentsItemSizeBytesMin = 0;
export const analyzeSowEmailRequestResponseSourcesItemAttachmentsItemSizeBytesMax = 16777216;

export const analyzeSowEmailRequestResponseSourcesItemAttachmentsMax = 20;

export const analyzeSowEmailRequestResponseSourcesMax = 20;

export const analyzeSowEmailRequestResponseTemplateSourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const analyzeSowEmailRequestResponseExtractedFieldsItemFieldMax = 100;

export const analyzeSowEmailRequestResponseExtractedFieldsItemValueMax = 8000;

export const analyzeSowEmailRequestResponseExtractedFieldsItemSourceIndexMin = 0;
export const analyzeSowEmailRequestResponseExtractedFieldsItemSourceIndexMax = 19;

export const analyzeSowEmailRequestResponseExtractedFieldsItemQuoteMax = 4000;

export const analyzeSowEmailRequestResponseExtractedFieldsMax = 200;

export const analyzeSowEmailRequestResponseUnresolvedItemsItemFieldMax = 100;

export const analyzeSowEmailRequestResponseUnresolvedItemsItemMessageMax = 2000;

export const analyzeSowEmailRequestResponseUnresolvedItemsMax = 200;

export const analyzeSowEmailRequestResponseProcessingErrorMax = 2000;



export const analyzeSowEmailRequestResponseQuoteHashRegExp = new RegExp('^[a-f0-9]{64}$');


export const analyzeSowEmailRequestResponse = zod.object({
  "id": zod.uuid(),
  "tenantId": zod.uuid(),
  "entityId": zod.uuid(),
  "customerId": zod.uuid(),
  "revision": zod.int().min(1),
  "sourceKind": zod.enum(['email', 'portal', 'quote']),
  "sourceRevision": zod.string().min(1).max(analyzeSowEmailRequestResponseSourceRevisionMax),
  "sourceHash": zod.string().regex(analyzeSowEmailRequestResponseSourceHashRegExp),
  "analysis": zod.union([zod.object({
  "summary": zod.string().max(analyzeSowEmailRequestResponseAnalysisOneOneSummaryMax),
  "template": zod.object({
  "status": zod.enum(['matched', 'ambiguous', 'none']),
  "templateVersionId": zod.uuid().nullable(),
  "rationale": zod.string().min(1).max(analyzeSowEmailRequestResponseAnalysisOneOneTemplateRationaleMax)
}),
  "facts": zod.array(zod.object({
  "field": zod.enum(['projectTitle', 'customerName', 'recipient', 'startDate', 'deadline', 'scope', 'background', 'exclusion', 'commercial']),
  "value": zod.string().max(analyzeSowEmailRequestResponseAnalysisOneOneFactsItemValueMax),
  "sourceIndex": zod.int().min(analyzeSowEmailRequestResponseAnalysisOneOneFactsItemSourceIndexMin).max(analyzeSowEmailRequestResponseAnalysisOneOneFactsItemSourceIndexMax),
  "quote": zod.string().min(1).max(analyzeSowEmailRequestResponseAnalysisOneOneFactsItemQuoteMax)
})).max(analyzeSowEmailRequestResponseAnalysisOneOneFactsMax),
  "effort": zod.array(zod.object({
  "label": zod.string().min(1).max(analyzeSowEmailRequestResponseAnalysisOneOneEffortItemLabelMax),
  "days": zod.string().regex(analyzeSowEmailRequestResponseAnalysisOneOneEffortItemDaysRegExp),
  "kind": zod.enum(['paid', 'donated']),
  "sourceIndex": zod.int().min(analyzeSowEmailRequestResponseAnalysisOneOneEffortItemSourceIndexMin).max(analyzeSowEmailRequestResponseAnalysisOneOneEffortItemSourceIndexMax),
  "quote": zod.string().min(1).max(analyzeSowEmailRequestResponseAnalysisOneOneEffortItemQuoteMax)
})).max(analyzeSowEmailRequestResponseAnalysisOneOneEffortMax),
  "unresolved": zod.array(zod.object({
  "field": zod.string().min(1).max(analyzeSowEmailRequestResponseAnalysisOneOneUnresolvedItemFieldMax),
  "message": zod.string().min(1).max(analyzeSowEmailRequestResponseAnalysisOneOneUnresolvedItemMessageMax)
})).max(analyzeSowEmailRequestResponseAnalysisOneOneUnresolvedMax)
}).and(zod.object({
  "attemptId": zod.uuid(),
  "model": zod.string().min(1).max(analyzeSowEmailRequestResponseAnalysisOneTwoModelMax),
  "sourceHash": zod.string().regex(analyzeSowEmailRequestResponseAnalysisOneTwoSourceHashRegExp),
  "catalogueHash": zod.string().regex(analyzeSowEmailRequestResponseAnalysisOneTwoCatalogueHashRegExp),
  "policyFingerprint": zod.string().regex(analyzeSowEmailRequestResponseAnalysisOneTwoPolicyFingerprintRegExp),
  "createdAt": zod.iso.datetime({"offset":true})
})),zod.null()]).optional(),
  "sessionId": zod.uuid().nullish(),
  "sources": zod.array(zod.object({
  "kind": zod.enum(['email_paste', 'email_record', 'attachment', 'portal_chat', 'quote']),
  "sourceId": zod.string().min(1).max(analyzeSowEmailRequestResponseSourcesItemSourceIdMax),
  "revision": zod.string().min(1).max(analyzeSowEmailRequestResponseSourcesItemRevisionMax),
  "hash": zod.string().regex(analyzeSowEmailRequestResponseSourcesItemHashRegExp),
  "extractionHash": zod.string().regex(analyzeSowEmailRequestResponseSourcesItemExtractionHashRegExp),
  "excerpt": zod.string().max(analyzeSowEmailRequestResponseSourcesItemExcerptMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable']),
  "warnings": zod.array(zod.string().max(analyzeSowEmailRequestResponseSourcesItemWarningsItemMax)).max(analyzeSowEmailRequestResponseSourcesItemWarningsMax),
  "attachments": zod.array(zod.object({
  "fileId": zod.uuid(),
  "revision": zod.string().min(1).max(analyzeSowEmailRequestResponseSourcesItemAttachmentsItemRevisionMax),
  "hash": zod.string().regex(analyzeSowEmailRequestResponseSourcesItemAttachmentsItemHashRegExp),
  "contentType": zod.string().max(analyzeSowEmailRequestResponseSourcesItemAttachmentsItemContentTypeMax),
  "sizeBytes": zod.int().min(analyzeSowEmailRequestResponseSourcesItemAttachmentsItemSizeBytesMin).max(analyzeSowEmailRequestResponseSourcesItemAttachmentsItemSizeBytesMax),
  "extractionState": zod.enum(['complete', 'partial', 'unsupported', 'unreadable'])
})).max(analyzeSowEmailRequestResponseSourcesItemAttachmentsMax)
})).min(1).max(analyzeSowEmailRequestResponseSourcesMax),
  "templateVersionId": zod.uuid().nullable(),
  "templateSourceHash": zod.string().regex(analyzeSowEmailRequestResponseTemplateSourceHashRegExp).nullable(),
  "extractedFields": zod.array(zod.object({
  "field": zod.string().min(1).max(analyzeSowEmailRequestResponseExtractedFieldsItemFieldMax),
  "value": zod.string().max(analyzeSowEmailRequestResponseExtractedFieldsItemValueMax),
  "sourceIndex": zod.int().min(analyzeSowEmailRequestResponseExtractedFieldsItemSourceIndexMin).max(analyzeSowEmailRequestResponseExtractedFieldsItemSourceIndexMax),
  "quote": zod.string().min(1).max(analyzeSowEmailRequestResponseExtractedFieldsItemQuoteMax)
})).max(analyzeSowEmailRequestResponseExtractedFieldsMax),
  "unresolvedItems": zod.array(zod.object({
  "field": zod.string().min(1).max(analyzeSowEmailRequestResponseUnresolvedItemsItemFieldMax),
  "message": zod.string().min(1).max(analyzeSowEmailRequestResponseUnresolvedItemsItemMessageMax)
})).max(analyzeSowEmailRequestResponseUnresolvedItemsMax),
  "processingState": zod.enum(['received', 'analyzing', 'needs_information', 'needs_template', 'ready_for_review', 'materializing', 'drafted', 'failed', 'cancelled']),
  "processingError": zod.string().max(analyzeSowEmailRequestResponseProcessingErrorMax).nullable(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().min(1).nullable(),
  "quoteId": zod.uuid().nullable(),
  "quoteRevision": zod.int().min(1).nullable(),
  "quoteHash": zod.string().regex(analyzeSowEmailRequestResponseQuoteHashRegExp).nullable(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true})
})


export const prepareSowRequestDraftParams = zod.object({
  "id": zod.uuid()
})




export const prepareSowRequestDraftBody = zod.object({
  "expectedRevision": zod.int().min(1),
  "templateVersionId": zod.uuid().nullable()
})


export const prepareSowRequestDraftResponseReviewDestructiveDefault = false;

export const prepareSowRequestDraftResponse = zod.object({
  "id": zod.uuid(),
  "conversationId": zod.uuid(),
  "scope": zod.object({
  "kind": zod.enum(['entity', 'tenant', 'platform']),
  "tenantId": zod.uuid().nullish(),
  "entityId": zod.uuid().nullish()
}),
  "actionKey": zod.string(),
  "actionVersion": zod.int().min(1),
  "status": zod.enum(['prepared', 'reviewed', 'executing', 'succeeded', 'failed', 'partial', 'cancelled', 'expired', 'stale']),
  "review": zod.object({
  "title": zod.string(),
  "summary": zod.string(),
  "targets": zod.array(zod.string()),
  "changes": zod.array(zod.object({
  "field": zod.string(),
  "before": zod.string().nullable(),
  "after": zod.string().nullable()
})),
  "sideEffects": zod.array(zod.string()),
  "requirements": zod.array(zod.string()),
  "costs": zod.array(zod.string()),
  "reasonRequired": zod.boolean(),
  "destructive": zod.boolean().default(prepareSowRequestDraftResponseReviewDestructiveDefault),
  "nonTransactionalEffects": zod.array(zod.string()).optional()
}),
  "previewHash": zod.string(),
  "reviewReason": zod.string().nullish(),
  "executionId": zod.uuid().nullish(),
  "expiresAt": zod.iso.datetime({"offset":true}),
  "createdAt": zod.iso.datetime({"offset":true}),
  "autonomyTier": zod.enum(['instant', 'confirm']).optional().describe('instant changes run on request with a 24-hour undo; confirm changes always need an exact review.'),
  "autonomyReason": zod.string().optional()
})


export const getSowTemplateSourceQueryTemplateKeyDefault = `circle-t-sow`;

export const getSowTemplateSourceQueryParams = zod.object({
  "templateKey": zod.enum(['circle-t-sow', 'circle-t-engagement-pack']).default(getSowTemplateSourceQueryTemplateKeyDefault)
})

export const getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemTypeMax = 40;

export const getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemTextMax = 200000;

export const getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemMarksMax = 20;

export const getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemContentMax = 10000;

export const getSowTemplateSourceResponseTermsItemContentLayoutHeaderMax = 100;

export const getSowTemplateSourceResponseTermsItemContentLayoutFooterItemTypeMax = 40;

export const getSowTemplateSourceResponseTermsItemContentLayoutFooterItemTextMax = 200000;

export const getSowTemplateSourceResponseTermsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const getSowTemplateSourceResponseTermsItemContentLayoutFooterItemMarksMax = 20;

export const getSowTemplateSourceResponseTermsItemContentLayoutFooterItemContentMax = 10000;

export const getSowTemplateSourceResponseTermsItemContentLayoutFooterMax = 100;

export const getSowTemplateSourceResponseTermsItemContentSectionsItemsItemTitleMax = 160;

export const getSowTemplateSourceResponseTermsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getSowTemplateSourceResponseTermsItemContentSectionsItemsMax = 200;

export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemNameMax = 80;

export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsMin = 7;
export const getSowTemplateSourceResponseTermsItemContentStylesDefinitionsMax = 100;

export const getSowTemplateSourceResponseTermsItemContentTemplateGuidanceMax = 4000;

export const getSowTemplateSourceResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getSowTemplateSourceResponseTermsItemContentTemplateSectionGuidanceMax = 200;

export const getSowTemplateSourceResponseTermsItemContentContentItemTypeMax = 40;

export const getSowTemplateSourceResponseTermsItemContentContentItemTextMax = 200000;

export const getSowTemplateSourceResponseTermsItemContentContentItemMarksItemTypeMax = 40;

export const getSowTemplateSourceResponseTermsItemContentContentItemMarksMax = 20;

export const getSowTemplateSourceResponseTermsItemContentContentItemContentMax = 10000;

export const getSowTemplateSourceResponseTermsItemContentContentMax = 10000;



export const getSowTemplateSourceResponse = zod.object({
  "sourceHash": zod.string(),
  "sourceFile": zod.string(),
  "templateKey": zod.string().optional(),
  "adoptionState": zod.enum(['review_required']).optional(),
  "definition": zod.record(zod.string(), zod.unknown()),
  "terms": zod.array(zod.object({
  "key": zod.enum(['materials', 'agreement', 'payment', 'schedule1', 'operations']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsTopMin).max(getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsRightMin).max(getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsBottomMin).max(getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsLeftMin).max(getSowTemplateSourceResponseTermsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getSowTemplateSourceResponseTermsItemContentLayoutHeaderItemContentMax).optional()
})).max(getSowTemplateSourceResponseTermsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateSourceResponseTermsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getSowTemplateSourceResponseTermsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateSourceResponseTermsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getSowTemplateSourceResponseTermsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getSowTemplateSourceResponseTermsItemContentLayoutFooterItemContentMax).optional()
})).max(getSowTemplateSourceResponseTermsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getSowTemplateSourceResponseTermsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getSowTemplateSourceResponseTermsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getSowTemplateSourceResponseTermsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemFontSizeMin).max(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin).max(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin).max(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsItemLineHeightMax)
})).min(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsMin).max(getSowTemplateSourceResponseTermsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getSowTemplateSourceResponseTermsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getSowTemplateSourceResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getSowTemplateSourceResponseTermsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateSourceResponseTermsItemContentContentItemTypeMax),
  "text": zod.string().max(getSowTemplateSourceResponseTermsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateSourceResponseTermsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getSowTemplateSourceResponseTermsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getSowTemplateSourceResponseTermsItemContentContentItemContentMax).optional()
})).max(getSowTemplateSourceResponseTermsItemContentContentMax)
})
}))
})


/**
 * Shared, entity-scoped SOW preparation records visible to current record readers. Opening the list never creates a record, thread, document or template.
 */
export const listSowPreparationsQuerySearchMax = 160;

export const listSowPreparationsQueryStatusDefault = `active`;
export const listSowPreparationsQueryLimitDefault = 25;
export const listSowPreparationsQueryLimitMax = 100;

export const listSowPreparationsQueryOffsetDefault = 0;
export const listSowPreparationsQueryOffsetMin = 0;
export const listSowPreparationsQueryOffsetMax = 100000;



export const listSowPreparationsQueryParams = zod.object({
  "search": zod.string().min(1).max(listSowPreparationsQuerySearchMax).optional(),
  "status": zod.enum(['active', 'archived', 'all']).default(listSowPreparationsQueryStatusDefault),
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().optional(),
  "quoteId": zod.uuid().optional(),
  "limit": zod.int().min(1).max(listSowPreparationsQueryLimitMax).default(listSowPreparationsQueryLimitDefault),
  "offset": zod.int().min(listSowPreparationsQueryOffsetMin).max(listSowPreparationsQueryOffsetMax).default(listSowPreparationsQueryOffsetDefault)
})




export const listSowPreparationsResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "documentStatus": zod.string().nullable(),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Explicitly creates a shared preparation pinned to an exact template version. Replaying the same clientRequestId returns the original outcome; a different body is rejected.
 */
export const createSowPreparationBodyTitleMax = 200;

export const createSowPreparationBodyBriefMax = 8000;



export const createSowPreparationBody = zod.object({
  "clientRequestId": zod.uuid(),
  "title": zod.string().min(1).max(createSowPreparationBodyTitleMax),
  "brief": zod.string().max(createSowPreparationBodyBriefMax).optional(),
  "templateVersionId": zod.uuid(),
  "accountId": zod.uuid().optional(),
  "opportunityId": zod.uuid().optional(),
  "quoteId": zod.uuid().optional(),
  "documentId": zod.uuid().optional()
})






export const createSowPreparationResponse = zod.object({
  "preparation": zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


export const getSowPreparationParams = zod.object({
  "id": zod.uuid()
})





export const getSowPreparationResponse = zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
})


/**
 * Compare-and-swap update by a current record writer. A stale expectedRevision retains the current record.
 */
export const updateSowPreparationParams = zod.object({
  "id": zod.uuid()
})


export const updateSowPreparationBodyTitleMax = 200;

export const updateSowPreparationBodyBriefMax = 8000;



export const updateSowPreparationBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "title": zod.string().min(1).max(updateSowPreparationBodyTitleMax).optional(),
  "brief": zod.string().max(updateSowPreparationBodyBriefMax).optional(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).optional().describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid().optional(),
  "accountId": zod.uuid().nullish(),
  "opportunityId": zod.uuid().nullish(),
  "quoteId": zod.uuid().nullish()
})






export const updateSowPreparationResponse = zod.object({
  "preparation": zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Explicitly links an existing template-bound canonical Files SOW under its original ID. No document, chat or history is copied and document access is not broadened.
 */
export const linkSowPreparationDocumentParams = zod.object({
  "id": zod.uuid()
})




export const linkSowPreparationDocumentBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "documentId": zod.uuid()
})






export const linkSowPreparationDocumentResponse = zod.object({
  "preparation": zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Archives the preparation only. Linked Files documents, their versions, approvals and history are preserved.
 */
export const archiveSowPreparationParams = zod.object({
  "id": zod.uuid()
})


export const archiveSowPreparationBodyReasonMin = 10;
export const archiveSowPreparationBodyReasonMax = 1000;



export const archiveSowPreparationBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "reason": zod.string().min(archiveSowPreparationBodyReasonMin).max(archiveSowPreparationBodyReasonMax)
})






export const archiveSowPreparationResponse = zod.object({
  "preparation": zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Read-only suggested and confirmed SOW scope with exact brief/evidence provenance, current freshness for the caller and visible gaps. Excerpts the caller can no longer access are withheld. Never creates or analyses anything.
 */
export const getSowPreparationScopeParams = zod.object({
  "id": zod.uuid()
})


export const getSowPreparationScopeResponseStaleConfirmedCountMin = 0;



export const getSowPreparationScopeResponse = zod.object({
  "preparationId": zod.uuid(),
  "revision": zod.int().min(1),
  "briefHash": zod.string(),
  "state": zod.enum(['incomplete', 'ready', 'stale']).describe('stale when any confirmed item\'s evidence changed, conflicts or became unavailable; prepared work depending on it must be reviewed again.'),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "text": zod.string(),
  "status": zod.enum(['suggested', 'confirmed', 'rejected']),
  "origin": zod.enum(['analysis', 'manual']),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['brief', 'workspace']),
  "excerpt": zod.string().nullable().describe('Withheld (null) when the caller cannot currently access the source.'),
  "available": zod.boolean(),
  "briefHash": zod.string().nullable(),
  "workspaceId": zod.uuid().nullable(),
  "snapshotId": zod.uuid().nullable(),
  "manifestHash": zod.string().nullable(),
  "passageId": zod.string().nullable(),
  "citation": zod.int().nullable(),
  "label": zod.string().nullable(),
  "location": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "contentHash": zod.string().nullable(),
  "excerptHash": zod.string().nullable()
}).describe('Exact provenance. Brief evidence carries a verbatim brief excerpt and brief hash; workspace evidence carries the reviewed snapshot passage pin.')),
  "itemHash": zod.string().describe('Exact reviewed content hash required to confirm or reject.'),
  "freshness": zod.enum(['current', 'stale', 'unavailable']),
  "freshnessMessage": zod.string().nullable(),
  "suggestedByAppUserId": zod.uuid(),
  "suggestedAt": zod.iso.datetime({"offset":true}),
  "decidedByAppUserId": zod.uuid().nullable(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "gaps": zod.array(zod.object({
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "message": zod.string()
})),
  "analysis": zod.union([zod.object({
  "snapshotId": zod.uuid().nullable(),
  "briefHash": zod.string(),
  "evidenceState": zod.string().describe('none, complete or partial coverage of the reviewed evidence snapshot.'),
  "analysedAt": zod.iso.datetime({"offset":true}),
  "analysedByAppUserId": zod.uuid(),
  "briefChanged": zod.boolean()
}),zod.null()]),
  "staleConfirmedCount": zod.int().min(getSowPreparationScopeResponseStaleConfirmedCountMin),
  "workspaceId": zod.uuid().nullable().describe('Existing Files workspace anchored to this preparation, if any.'),
  "canWrite": zod.boolean()
})


/**
 * Explicitly analyses the saved brief and, optionally, the caller's own reviewed evidence snapshot from this preparation's workspace. Produces suggestions only; unconfirmed items replace earlier unconfirmed suggestions and confirmed items are kept. Missing values stay as unanswered questions.
 */
export const suggestSowPreparationScopeParams = zod.object({
  "id": zod.uuid()
})




export const suggestSowPreparationScopeBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "snapshotId": zod.uuid().optional().describe('Caller\'s reviewed evidence snapshot from this preparation\'s workspace.')
})




export const suggestSowPreparationScopeResponseScopeStaleConfirmedCountMin = 0;




export const suggestSowPreparationScopeResponse = zod.object({
  "preparation": zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
}),
  "scope": zod.object({
  "preparationId": zod.uuid(),
  "revision": zod.int().min(1),
  "briefHash": zod.string(),
  "state": zod.enum(['incomplete', 'ready', 'stale']).describe('stale when any confirmed item\'s evidence changed, conflicts or became unavailable; prepared work depending on it must be reviewed again.'),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "text": zod.string(),
  "status": zod.enum(['suggested', 'confirmed', 'rejected']),
  "origin": zod.enum(['analysis', 'manual']),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['brief', 'workspace']),
  "excerpt": zod.string().nullable().describe('Withheld (null) when the caller cannot currently access the source.'),
  "available": zod.boolean(),
  "briefHash": zod.string().nullable(),
  "workspaceId": zod.uuid().nullable(),
  "snapshotId": zod.uuid().nullable(),
  "manifestHash": zod.string().nullable(),
  "passageId": zod.string().nullable(),
  "citation": zod.int().nullable(),
  "label": zod.string().nullable(),
  "location": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "contentHash": zod.string().nullable(),
  "excerptHash": zod.string().nullable()
}).describe('Exact provenance. Brief evidence carries a verbatim brief excerpt and brief hash; workspace evidence carries the reviewed snapshot passage pin.')),
  "itemHash": zod.string().describe('Exact reviewed content hash required to confirm or reject.'),
  "freshness": zod.enum(['current', 'stale', 'unavailable']),
  "freshnessMessage": zod.string().nullable(),
  "suggestedByAppUserId": zod.uuid(),
  "suggestedAt": zod.iso.datetime({"offset":true}),
  "decidedByAppUserId": zod.uuid().nullable(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "gaps": zod.array(zod.object({
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "message": zod.string()
})),
  "analysis": zod.union([zod.object({
  "snapshotId": zod.uuid().nullable(),
  "briefHash": zod.string(),
  "evidenceState": zod.string().describe('none, complete or partial coverage of the reviewed evidence snapshot.'),
  "analysedAt": zod.iso.datetime({"offset":true}),
  "analysedByAppUserId": zod.uuid(),
  "briefChanged": zod.boolean()
}),zod.null()]),
  "staleConfirmedCount": zod.int().min(suggestSowPreparationScopeResponseScopeStaleConfirmedCountMin),
  "workspaceId": zod.uuid().nullable().describe('Existing Files workspace anchored to this preparation, if any.'),
  "canWrite": zod.boolean()
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Adds one staff-authored suggested scope item with an optional verbatim brief excerpt or one cited passage from the caller's reviewed evidence snapshot. It stays suggested until explicitly confirmed.
 */
export const addSowPreparationScopeItemParams = zod.object({
  "id": zod.uuid()
})


export const addSowPreparationScopeItemBodyTextMax = 1000;

export const addSowPreparationScopeItemBodyBriefExcerptMax = 1000;

export const addSowPreparationScopeItemBodyCitationPassageIdMax = 200;



export const addSowPreparationScopeItemBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "text": zod.string().min(1).max(addSowPreparationScopeItemBodyTextMax),
  "briefExcerpt": zod.string().min(1).max(addSowPreparationScopeItemBodyBriefExcerptMax).optional(),
  "citation": zod.object({
  "snapshotId": zod.uuid(),
  "passageId": zod.string().min(1).max(addSowPreparationScopeItemBodyCitationPassageIdMax)
}).optional()
})




export const addSowPreparationScopeItemResponseScopeStaleConfirmedCountMin = 0;




export const addSowPreparationScopeItemResponse = zod.object({
  "preparation": zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
}),
  "scope": zod.object({
  "preparationId": zod.uuid(),
  "revision": zod.int().min(1),
  "briefHash": zod.string(),
  "state": zod.enum(['incomplete', 'ready', 'stale']).describe('stale when any confirmed item\'s evidence changed, conflicts or became unavailable; prepared work depending on it must be reviewed again.'),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "text": zod.string(),
  "status": zod.enum(['suggested', 'confirmed', 'rejected']),
  "origin": zod.enum(['analysis', 'manual']),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['brief', 'workspace']),
  "excerpt": zod.string().nullable().describe('Withheld (null) when the caller cannot currently access the source.'),
  "available": zod.boolean(),
  "briefHash": zod.string().nullable(),
  "workspaceId": zod.uuid().nullable(),
  "snapshotId": zod.uuid().nullable(),
  "manifestHash": zod.string().nullable(),
  "passageId": zod.string().nullable(),
  "citation": zod.int().nullable(),
  "label": zod.string().nullable(),
  "location": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "contentHash": zod.string().nullable(),
  "excerptHash": zod.string().nullable()
}).describe('Exact provenance. Brief evidence carries a verbatim brief excerpt and brief hash; workspace evidence carries the reviewed snapshot passage pin.')),
  "itemHash": zod.string().describe('Exact reviewed content hash required to confirm or reject.'),
  "freshness": zod.enum(['current', 'stale', 'unavailable']),
  "freshnessMessage": zod.string().nullable(),
  "suggestedByAppUserId": zod.uuid(),
  "suggestedAt": zod.iso.datetime({"offset":true}),
  "decidedByAppUserId": zod.uuid().nullable(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "gaps": zod.array(zod.object({
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "message": zod.string()
})),
  "analysis": zod.union([zod.object({
  "snapshotId": zod.uuid().nullable(),
  "briefHash": zod.string(),
  "evidenceState": zod.string().describe('none, complete or partial coverage of the reviewed evidence snapshot.'),
  "analysedAt": zod.iso.datetime({"offset":true}),
  "analysedByAppUserId": zod.uuid(),
  "briefChanged": zod.boolean()
}),zod.null()]),
  "staleConfirmedCount": zod.int().min(addSowPreparationScopeItemResponseScopeStaleConfirmedCountMin),
  "workspaceId": zod.uuid().nullable().describe('Existing Files workspace anchored to this preparation, if any.'),
  "canWrite": zod.boolean()
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Explicitly confirms or rejects exact reviewed scope items by item hash, recording the actor. Stale or unavailable evidence and unanswered questions cannot be confirmed.
 */
export const reviewSowPreparationScopeParams = zod.object({
  "id": zod.uuid()
})


export const reviewSowPreparationScopeBodyDecisionsItemItemHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reviewSowPreparationScopeBodyDecisionsMax = 50;



export const reviewSowPreparationScopeBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "decisions": zod.array(zod.object({
  "itemId": zod.uuid(),
  "itemHash": zod.string().regex(reviewSowPreparationScopeBodyDecisionsItemItemHashRegExp),
  "decision": zod.enum(['confirm', 'reject'])
})).min(1).max(reviewSowPreparationScopeBodyDecisionsMax)
})




export const reviewSowPreparationScopeResponseScopeStaleConfirmedCountMin = 0;




export const reviewSowPreparationScopeResponse = zod.object({
  "preparation": zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
}),
  "scope": zod.object({
  "preparationId": zod.uuid(),
  "revision": zod.int().min(1),
  "briefHash": zod.string(),
  "state": zod.enum(['incomplete', 'ready', 'stale']).describe('stale when any confirmed item\'s evidence changed, conflicts or became unavailable; prepared work depending on it must be reviewed again.'),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "text": zod.string(),
  "status": zod.enum(['suggested', 'confirmed', 'rejected']),
  "origin": zod.enum(['analysis', 'manual']),
  "evidence": zod.array(zod.object({
  "kind": zod.enum(['brief', 'workspace']),
  "excerpt": zod.string().nullable().describe('Withheld (null) when the caller cannot currently access the source.'),
  "available": zod.boolean(),
  "briefHash": zod.string().nullable(),
  "workspaceId": zod.uuid().nullable(),
  "snapshotId": zod.uuid().nullable(),
  "manifestHash": zod.string().nullable(),
  "passageId": zod.string().nullable(),
  "citation": zod.int().nullable(),
  "label": zod.string().nullable(),
  "location": zod.string().nullable(),
  "sourceVersion": zod.string().nullable(),
  "sourceRevisionId": zod.uuid().nullable(),
  "contentHash": zod.string().nullable(),
  "excerptHash": zod.string().nullable()
}).describe('Exact provenance. Brief evidence carries a verbatim brief excerpt and brief hash; workspace evidence carries the reviewed snapshot passage pin.')),
  "itemHash": zod.string().describe('Exact reviewed content hash required to confirm or reject.'),
  "freshness": zod.enum(['current', 'stale', 'unavailable']),
  "freshnessMessage": zod.string().nullable(),
  "suggestedByAppUserId": zod.uuid(),
  "suggestedAt": zod.iso.datetime({"offset":true}),
  "decidedByAppUserId": zod.uuid().nullable(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable()
})),
  "gaps": zod.array(zod.object({
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "message": zod.string()
})),
  "analysis": zod.union([zod.object({
  "snapshotId": zod.uuid().nullable(),
  "briefHash": zod.string(),
  "evidenceState": zod.string().describe('none, complete or partial coverage of the reviewed evidence snapshot.'),
  "analysedAt": zod.iso.datetime({"offset":true}),
  "analysedByAppUserId": zod.uuid(),
  "briefChanged": zod.boolean()
}),zod.null()]),
  "staleConfirmedCount": zod.int().min(reviewSowPreparationScopeResponseScopeStaleConfirmedCountMin),
  "workspaceId": zod.uuid().nullable().describe('Existing Files workspace anchored to this preparation, if any.'),
  "canWrite": zod.boolean()
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Read-only currently approved reviewed preparation plan for this SOW, with its exact pins, linked human activities and whether current template, document, scope, evidence, owners or model policy still match. The private Agent review and execution receipt are never included. Never creates anything.
 */
export const getSowPreparationPlanParams = zod.object({
  "id": zod.uuid()
})

export const getSowPreparationPlanResponsePlanOneSnapshotInputActivitiesItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,39}$');
export const getSowPreparationPlanResponsePlanOneSnapshotInputActivitiesItemTitleMax = 200;

export const getSowPreparationPlanResponsePlanOneSnapshotInputActivitiesMax = 20;

export const getSowPreparationPlanResponsePlanOneSnapshotInputModelChoiceIdMax = 200;



export const getSowPreparationPlanResponse = zod.object({
  "preparationId": zod.uuid(),
  "plan": zod.union([zod.object({
  "proposalId": zod.uuid(),
  "snapshotHash": zod.string(),
  "approvedByAppUserId": zod.uuid(),
  "approvedAt": zod.iso.datetime({"offset":true}),
  "snapshot": zod.object({
  "input": zod.object({
  "preparationId": zod.uuid(),
  "target": zod.enum(['linked_document', 'new_document']).describe('linked_document updates only the preparation\'s own linked Files SOW through drafting; new_document reserves a new canonical draft created later by explicit drafting adoption.'),
  "activities": zod.array(zod.object({
  "key": zod.string().regex(getSowPreparationPlanResponsePlanOneSnapshotInputActivitiesItemKeyRegExp),
  "title": zod.string().min(1).max(getSowPreparationPlanResponsePlanOneSnapshotInputActivitiesItemTitleMax),
  "ownerAppUserId": zod.uuid().nullable().describe('Only an explicitly chosen owner; null stays unassigned.'),
  "dueAt": zod.iso.datetime({"offset":true}).nullable()
})).max(getSowPreparationPlanResponsePlanOneSnapshotInputActivitiesMax),
  "modelChoiceId": zod.string().min(1).max(getSowPreparationPlanResponsePlanOneSnapshotInputModelChoiceIdMax).nullable()
}),
  "preparationId": zod.uuid(),
  "preparationTitle": zod.string(),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "document": zod.object({
  "target": zod.enum(['linked_document', 'new_document']),
  "documentId": zod.uuid().nullable(),
  "title": zod.string(),
  "draftRevision": zod.int().nullable(),
  "status": zod.string().nullable()
}),
  "scope": zod.object({
  "state": zod.enum(['incomplete', 'ready', 'stale']),
  "confirmedItems": zod.array(zod.object({
  "id": zod.string(),
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "text": zod.string(),
  "itemHash": zod.string()
})),
  "gaps": zod.array(zod.object({
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "message": zod.string()
})),
  "fingerprint": zod.string().describe('Exact brief, confirmed items and their current evidence freshness.')
}),
  "activities": zod.array(zod.object({
  "key": zod.string(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullable(),
  "ownerName": zod.string().nullable(),
  "ownerAuthorizationRevision": zod.string().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "existingActivityId": zod.uuid().nullable(),
  "action": zod.enum(['create', 'update', 'unchanged'])
})),
  "model": zod.object({
  "stage": zod.string(),
  "choiceId": zod.string().nullable(),
  "modelRevision": zod.int().nullable(),
  "policyFingerprint": zod.string(),
  "executable": zod.boolean(),
  "eligibleChoiceIds": zod.array(zod.string()),
  "reasons": zod.array(zod.string())
}),
  "readiness": zod.object({
  "state": zod.enum(['ready', 'blocked']),
  "blockers": zod.array(zod.string())
}),
  "warnings": zod.array(zod.string()),
  "permittedWork": zod.string(),
  "snapshotHash": zod.string().describe('Exact hash pinned by the private review; any change requires a fresh review.')
}),
  "activities": zod.array(zod.object({
  "key": zod.string(),
  "activityId": zod.uuid(),
  "subject": zod.string().nullable(),
  "status": zod.string().nullable()
})),
  "current": zod.boolean(),
  "staleReasons": zod.array(zod.string())
}),zod.null()])
})


/**
 * Builds the exact reviewed SOW preparation plan without any write, provider call or task creation. Shows the document target, confirmed scope and evidence fingerprint, unresolved gaps, proposed human activities with explicitly chosen owners/dates and the current model eligibility. Confirmation happens only through the private reviewed Agent action entity.sow.preparation_plan.
 */
export const previewSowPreparationPlanParams = zod.object({
  "id": zod.uuid()
})

export const previewSowPreparationPlanBodyActivitiesItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,39}$');
export const previewSowPreparationPlanBodyActivitiesItemTitleMax = 200;

export const previewSowPreparationPlanBodyActivitiesMax = 20;

export const previewSowPreparationPlanBodyModelChoiceIdMax = 200;



export const previewSowPreparationPlanBody = zod.object({
  "preparationId": zod.uuid(),
  "target": zod.enum(['linked_document', 'new_document']).describe('linked_document updates only the preparation\'s own linked Files SOW through drafting; new_document reserves a new canonical draft created later by explicit drafting adoption.'),
  "activities": zod.array(zod.object({
  "key": zod.string().regex(previewSowPreparationPlanBodyActivitiesItemKeyRegExp),
  "title": zod.string().min(1).max(previewSowPreparationPlanBodyActivitiesItemTitleMax),
  "ownerAppUserId": zod.uuid().nullable().describe('Only an explicitly chosen owner; null stays unassigned.'),
  "dueAt": zod.iso.datetime({"offset":true}).nullable()
})).max(previewSowPreparationPlanBodyActivitiesMax),
  "modelChoiceId": zod.string().min(1).max(previewSowPreparationPlanBodyModelChoiceIdMax).nullable()
})

export const previewSowPreparationPlanResponseInputActivitiesItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,39}$');
export const previewSowPreparationPlanResponseInputActivitiesItemTitleMax = 200;

export const previewSowPreparationPlanResponseInputActivitiesMax = 20;

export const previewSowPreparationPlanResponseInputModelChoiceIdMax = 200;



export const previewSowPreparationPlanResponse = zod.object({
  "input": zod.object({
  "preparationId": zod.uuid(),
  "target": zod.enum(['linked_document', 'new_document']).describe('linked_document updates only the preparation\'s own linked Files SOW through drafting; new_document reserves a new canonical draft created later by explicit drafting adoption.'),
  "activities": zod.array(zod.object({
  "key": zod.string().regex(previewSowPreparationPlanResponseInputActivitiesItemKeyRegExp),
  "title": zod.string().min(1).max(previewSowPreparationPlanResponseInputActivitiesItemTitleMax),
  "ownerAppUserId": zod.uuid().nullable().describe('Only an explicitly chosen owner; null stays unassigned.'),
  "dueAt": zod.iso.datetime({"offset":true}).nullable()
})).max(previewSowPreparationPlanResponseInputActivitiesMax),
  "modelChoiceId": zod.string().min(1).max(previewSowPreparationPlanResponseInputModelChoiceIdMax).nullable()
}),
  "preparationId": zod.uuid(),
  "preparationTitle": zod.string(),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "document": zod.object({
  "target": zod.enum(['linked_document', 'new_document']),
  "documentId": zod.uuid().nullable(),
  "title": zod.string(),
  "draftRevision": zod.int().nullable(),
  "status": zod.string().nullable()
}),
  "scope": zod.object({
  "state": zod.enum(['incomplete', 'ready', 'stale']),
  "confirmedItems": zod.array(zod.object({
  "id": zod.string(),
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "text": zod.string(),
  "itemHash": zod.string()
})),
  "gaps": zod.array(zod.object({
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "message": zod.string()
})),
  "fingerprint": zod.string().describe('Exact brief, confirmed items and their current evidence freshness.')
}),
  "activities": zod.array(zod.object({
  "key": zod.string(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullable(),
  "ownerName": zod.string().nullable(),
  "ownerAuthorizationRevision": zod.string().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "existingActivityId": zod.uuid().nullable(),
  "action": zod.enum(['create', 'update', 'unchanged'])
})),
  "model": zod.object({
  "stage": zod.string(),
  "choiceId": zod.string().nullable(),
  "modelRevision": zod.int().nullable(),
  "policyFingerprint": zod.string(),
  "executable": zod.boolean(),
  "eligibleChoiceIds": zod.array(zod.string()),
  "reasons": zod.array(zod.string())
}),
  "readiness": zod.object({
  "state": zod.enum(['ready', 'blocked']),
  "blockers": zod.array(zod.string())
}),
  "warnings": zod.array(zod.string()),
  "permittedWork": zod.string(),
  "snapshotHash": zod.string().describe('Exact hash pinned by the private review; any change requires a fresh review.')
})


/**
 * Explicitly confirms the exact previewed SOW preparation plan. The server rebuilds the preview and requires the identical snapshot hash, current preparation revision, SOW write and Agent permission. Only then does it save the approved plan pins and create or reassign the listed human activities through the native activity owner. Never approves terms, publishes, generates content or assigns an owner that was not explicitly chosen. Reusing the same clientRequestId replays the original outcome.
 */
export const confirmSowPreparationPlanParams = zod.object({
  "id": zod.uuid()
})


export const confirmSowPreparationPlanBodySnapshotHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const confirmSowPreparationPlanBodyInputActivitiesItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,39}$');
export const confirmSowPreparationPlanBodyInputActivitiesItemTitleMax = 200;

export const confirmSowPreparationPlanBodyInputActivitiesMax = 20;

export const confirmSowPreparationPlanBodyInputModelChoiceIdMax = 200;

export const confirmSowPreparationPlanBodyReasonMax = 500;



export const confirmSowPreparationPlanBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "snapshotHash": zod.string().regex(confirmSowPreparationPlanBodySnapshotHashRegExp),
  "input": zod.object({
  "preparationId": zod.uuid(),
  "target": zod.enum(['linked_document', 'new_document']).describe('linked_document updates only the preparation\'s own linked Files SOW through drafting; new_document reserves a new canonical draft created later by explicit drafting adoption.'),
  "activities": zod.array(zod.object({
  "key": zod.string().regex(confirmSowPreparationPlanBodyInputActivitiesItemKeyRegExp),
  "title": zod.string().min(1).max(confirmSowPreparationPlanBodyInputActivitiesItemTitleMax),
  "ownerAppUserId": zod.uuid().nullable().describe('Only an explicitly chosen owner; null stays unassigned.'),
  "dueAt": zod.iso.datetime({"offset":true}).nullable()
})).max(confirmSowPreparationPlanBodyInputActivitiesMax),
  "modelChoiceId": zod.string().min(1).max(confirmSowPreparationPlanBodyInputModelChoiceIdMax).nullable()
}),
  "reason": zod.string().min(1).max(confirmSowPreparationPlanBodyReasonMax)
})



export const confirmSowPreparationPlanResponsePlanPlanOneSnapshotInputActivitiesItemKeyRegExp = new RegExp('^[a-z0-9][a-z0-9-]{0,39}$');
export const confirmSowPreparationPlanResponsePlanPlanOneSnapshotInputActivitiesItemTitleMax = 200;

export const confirmSowPreparationPlanResponsePlanPlanOneSnapshotInputActivitiesMax = 20;

export const confirmSowPreparationPlanResponsePlanPlanOneSnapshotInputModelChoiceIdMax = 200;




export const confirmSowPreparationPlanResponse = zod.object({
  "preparation": zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
}),
  "plan": zod.object({
  "preparationId": zod.uuid(),
  "plan": zod.union([zod.object({
  "proposalId": zod.uuid(),
  "snapshotHash": zod.string(),
  "approvedByAppUserId": zod.uuid(),
  "approvedAt": zod.iso.datetime({"offset":true}),
  "snapshot": zod.object({
  "input": zod.object({
  "preparationId": zod.uuid(),
  "target": zod.enum(['linked_document', 'new_document']).describe('linked_document updates only the preparation\'s own linked Files SOW through drafting; new_document reserves a new canonical draft created later by explicit drafting adoption.'),
  "activities": zod.array(zod.object({
  "key": zod.string().regex(confirmSowPreparationPlanResponsePlanPlanOneSnapshotInputActivitiesItemKeyRegExp),
  "title": zod.string().min(1).max(confirmSowPreparationPlanResponsePlanPlanOneSnapshotInputActivitiesItemTitleMax),
  "ownerAppUserId": zod.uuid().nullable().describe('Only an explicitly chosen owner; null stays unassigned.'),
  "dueAt": zod.iso.datetime({"offset":true}).nullable()
})).max(confirmSowPreparationPlanResponsePlanPlanOneSnapshotInputActivitiesMax),
  "modelChoiceId": zod.string().min(1).max(confirmSowPreparationPlanResponsePlanPlanOneSnapshotInputModelChoiceIdMax).nullable()
}),
  "preparationId": zod.uuid(),
  "preparationTitle": zod.string(),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "document": zod.object({
  "target": zod.enum(['linked_document', 'new_document']),
  "documentId": zod.uuid().nullable(),
  "title": zod.string(),
  "draftRevision": zod.int().nullable(),
  "status": zod.string().nullable()
}),
  "scope": zod.object({
  "state": zod.enum(['incomplete', 'ready', 'stale']),
  "confirmedItems": zod.array(zod.object({
  "id": zod.string(),
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "text": zod.string(),
  "itemHash": zod.string()
})),
  "gaps": zod.array(zod.object({
  "category": zod.enum(['scope', 'deliverable', 'acceptance', 'assumption', 'exclusion', 'date', 'question']),
  "message": zod.string()
})),
  "fingerprint": zod.string().describe('Exact brief, confirmed items and their current evidence freshness.')
}),
  "activities": zod.array(zod.object({
  "key": zod.string(),
  "title": zod.string(),
  "ownerAppUserId": zod.uuid().nullable(),
  "ownerName": zod.string().nullable(),
  "ownerAuthorizationRevision": zod.string().nullable(),
  "dueAt": zod.iso.datetime({"offset":true}).nullable(),
  "existingActivityId": zod.uuid().nullable(),
  "action": zod.enum(['create', 'update', 'unchanged'])
})),
  "model": zod.object({
  "stage": zod.string(),
  "choiceId": zod.string().nullable(),
  "modelRevision": zod.int().nullable(),
  "policyFingerprint": zod.string(),
  "executable": zod.boolean(),
  "eligibleChoiceIds": zod.array(zod.string()),
  "reasons": zod.array(zod.string())
}),
  "readiness": zod.object({
  "state": zod.enum(['ready', 'blocked']),
  "blockers": zod.array(zod.string())
}),
  "warnings": zod.array(zod.string()),
  "permittedWork": zod.string(),
  "snapshotHash": zod.string().describe('Exact hash pinned by the private review; any change requires a fresh review.')
}),
  "activities": zod.array(zod.object({
  "key": zod.string(),
  "activityId": zod.uuid(),
  "subject": zod.string().nullable(),
  "status": zod.string().nullable()
})),
  "current": zod.boolean(),
  "staleReasons": zod.array(zod.string())
}),zod.null()])
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Read-only grounded SOW drafting state. Lists recent proposal runs with their exact template, confirmed scope, document and lesson pins, per-proposal staleness against the saved document, citations re-read under the caller's own access (inaccessible excerpts are withheld), unresolved gaps and an advisory completeness review. Advisory review never approves or publishes; the canonical Files/SOW approval policy remains the approval owner. Never calls a provider or writes.
 */
export const getSowPreparationDraftingParams = zod.object({
  "id": zod.uuid()
})




export const getSowPreparationDraftingResponse = zod.object({
  "preparationId": zod.uuid(),
  "revision": zod.int().min(1),
  "canWrite": zod.boolean(),
  "documentId": zod.uuid().nullable(),
  "templateVersionId": zod.uuid(),
  "targets": zod.array(zod.object({
  "key": zod.string(),
  "label": zod.string(),
  "kind": zod.enum(['narrative', 'table', 'custom_prose', 'custom_table']),
  "columns": zod.array(zod.string())
})),
  "runs": zod.array(zod.object({
  "id": zod.uuid(),
  "requestedByAppUserId": zod.uuid(),
  "requestedAt": zod.iso.datetime({"offset":true}),
  "instruction": zod.string().nullable(),
  "pins": zod.object({
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "scopeFingerprint": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().nullable(),
  "documentHash": zod.string().nullable(),
  "lessonsFingerprint": zod.string(),
  "modelPolicyFingerprint": zod.string()
}),
  "facts": zod.array(zod.object({
  "id": zod.string(),
  "category": zod.string(),
  "text": zod.string(),
  "referenceIds": zod.array(zod.string())
})),
  "references": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['brief', 'workspace']),
  "label": zod.string().nullable(),
  "location": zod.string().nullable(),
  "excerpt": zod.string().nullable(),
  "available": zod.boolean()
})),
  "lessons": zod.array(zod.object({
  "lessonId": zod.uuid(),
  "revision": zod.int(),
  "guidance": zod.string(),
  "category": zod.string(),
  "applicability": zod.string()
})),
  "proposals": zod.array(zod.object({
  "id": zod.uuid(),
  "targetKey": zod.string(),
  "targetLabel": zod.string(),
  "targetKind": zod.enum(['narrative', 'table', 'custom_prose', 'custom_table']),
  "paragraphs": zod.array(zod.object({
  "kind": zod.enum(['scope_statement', 'evidenced_claim', 'proposed_approach', 'commitment', 'unresolved']),
  "text": zod.string(),
  "factIds": zod.array(zod.string()),
  "referenceIds": zod.array(zod.string())
})),
  "rows": zod.array(zod.object({
  "cells": zod.array(zod.string()),
  "kind": zod.enum(['scope_statement', 'evidenced_claim', 'proposed_approach', 'commitment', 'unresolved']),
  "factIds": zod.array(zod.string()),
  "referenceIds": zod.array(zod.string())
})),
  "proposalHash": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "staleReasons": zod.array(zod.string()),
  "decidedByAppUserId": zod.uuid().nullable(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable(),
  "decisionNote": zod.string().nullable(),
  "acceptedVersionId": zod.uuid().nullable(),
  "acceptedDocumentRevision": zod.int().nullable()
})),
  "gaps": zod.array(zod.string()),
  "warnings": zod.array(zod.string())
})),
  "attempts": zod.array(zod.object({
  "clientRequestId": zod.uuid(),
  "status": zod.enum(['in_flight', 'cancelled', 'failed', 'completed']),
  "startedAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().nullable()
})).describe('The caller\'s own drafting requests only.'),
  "review": zod.object({
  "advisory": zod.boolean().describe('Always true. This review never approves or publishes.'),
  "approvalOwner": zod.string(),
  "readiness": zod.enum(['no_document', 'needs_drafting', 'proposals_pending', 'stale', 'ready_for_native_review']),
  "readyForReview": zod.boolean(),
  "documentRevision": zod.int().nullable(),
  "documentHash": zod.string().nullable(),
  "documentStatus": zod.string().nullable(),
  "approvalStatus": zod.string().nullable(),
  "gaps": zod.array(zod.string())
})
})


/**
 * Explicitly generates grounded section proposals for the template-editable portions of this SOW from confirmed scope, its currently accessible evidence, the exact pinned template, applicable approved lessons and an optional instruction. Missing scope, deliverables, acceptance, dates and prices stay unresolved. Pricing, quote lineage, protected clauses and signatures are never proposed. Nothing changes the document until a proposal is explicitly adopted. Reusing the clientRequestId replays the original outcome; an unconfirmed earlier attempt is never re-sent to the provider.
 */
export const proposeSowPreparationDraftParams = zod.object({
  "id": zod.uuid()
})


export const proposeSowPreparationDraftBodyInstructionMax = 2000;



export const proposeSowPreparationDraftBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "instruction": zod.string().min(1).max(proposeSowPreparationDraftBodyInstructionMax).optional()
})





export const proposeSowPreparationDraftResponse = zod.object({
  "drafting": zod.object({
  "preparationId": zod.uuid(),
  "revision": zod.int().min(1),
  "canWrite": zod.boolean(),
  "documentId": zod.uuid().nullable(),
  "templateVersionId": zod.uuid(),
  "targets": zod.array(zod.object({
  "key": zod.string(),
  "label": zod.string(),
  "kind": zod.enum(['narrative', 'table', 'custom_prose', 'custom_table']),
  "columns": zod.array(zod.string())
})),
  "runs": zod.array(zod.object({
  "id": zod.uuid(),
  "requestedByAppUserId": zod.uuid(),
  "requestedAt": zod.iso.datetime({"offset":true}),
  "instruction": zod.string().nullable(),
  "pins": zod.object({
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "scopeFingerprint": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().nullable(),
  "documentHash": zod.string().nullable(),
  "lessonsFingerprint": zod.string(),
  "modelPolicyFingerprint": zod.string()
}),
  "facts": zod.array(zod.object({
  "id": zod.string(),
  "category": zod.string(),
  "text": zod.string(),
  "referenceIds": zod.array(zod.string())
})),
  "references": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['brief', 'workspace']),
  "label": zod.string().nullable(),
  "location": zod.string().nullable(),
  "excerpt": zod.string().nullable(),
  "available": zod.boolean()
})),
  "lessons": zod.array(zod.object({
  "lessonId": zod.uuid(),
  "revision": zod.int(),
  "guidance": zod.string(),
  "category": zod.string(),
  "applicability": zod.string()
})),
  "proposals": zod.array(zod.object({
  "id": zod.uuid(),
  "targetKey": zod.string(),
  "targetLabel": zod.string(),
  "targetKind": zod.enum(['narrative', 'table', 'custom_prose', 'custom_table']),
  "paragraphs": zod.array(zod.object({
  "kind": zod.enum(['scope_statement', 'evidenced_claim', 'proposed_approach', 'commitment', 'unresolved']),
  "text": zod.string(),
  "factIds": zod.array(zod.string()),
  "referenceIds": zod.array(zod.string())
})),
  "rows": zod.array(zod.object({
  "cells": zod.array(zod.string()),
  "kind": zod.enum(['scope_statement', 'evidenced_claim', 'proposed_approach', 'commitment', 'unresolved']),
  "factIds": zod.array(zod.string()),
  "referenceIds": zod.array(zod.string())
})),
  "proposalHash": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "staleReasons": zod.array(zod.string()),
  "decidedByAppUserId": zod.uuid().nullable(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable(),
  "decisionNote": zod.string().nullable(),
  "acceptedVersionId": zod.uuid().nullable(),
  "acceptedDocumentRevision": zod.int().nullable()
})),
  "gaps": zod.array(zod.string()),
  "warnings": zod.array(zod.string())
})),
  "attempts": zod.array(zod.object({
  "clientRequestId": zod.uuid(),
  "status": zod.enum(['in_flight', 'cancelled', 'failed', 'completed']),
  "startedAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().nullable()
})).describe('The caller\'s own drafting requests only.'),
  "review": zod.object({
  "advisory": zod.boolean().describe('Always true. This review never approves or publishes.'),
  "approvalOwner": zod.string(),
  "readiness": zod.enum(['no_document', 'needs_drafting', 'proposals_pending', 'stale', 'ready_for_native_review']),
  "readyForReview": zod.boolean(),
  "documentRevision": zod.int().nullable(),
  "documentHash": zod.string().nullable(),
  "documentStatus": zod.string().nullable(),
  "approvalStatus": zod.string().nullable(),
  "gaps": zod.array(zod.string())
})
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Explicitly adopts or rejects one exact proposal. Adoption re-checks current write authority, template, confirmed scope, lessons and the proposal's saved target value inside the canonical transaction, then saves through the Files SOW owner (native rendering, protected terms, quote and pricing checks) and creates a checkpoint. Manual edits to other sections are preserved; a changed target is rejected as stale. Saving resets native review readiness; adoption never approves or publishes. Reusing the clientRequestId replays the original outcome.
 */
export const decideSowDraftProposalParams = zod.object({
  "id": zod.uuid(),
  "proposalId": zod.uuid()
})


export const decideSowDraftProposalBodyProposalHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const decideSowDraftProposalBodyNoteMax = 1000;



export const decideSowDraftProposalBody = zod.object({
  "clientRequestId": zod.uuid(),
  "expectedRevision": zod.int().min(1),
  "runId": zod.uuid(),
  "proposalHash": zod.string().regex(decideSowDraftProposalBodyProposalHashRegExp),
  "decision": zod.enum(['accept', 'reject']),
  "note": zod.string().min(1).max(decideSowDraftProposalBodyNoteMax).optional()
})





export const decideSowDraftProposalResponse = zod.object({
  "drafting": zod.object({
  "preparationId": zod.uuid(),
  "revision": zod.int().min(1),
  "canWrite": zod.boolean(),
  "documentId": zod.uuid().nullable(),
  "templateVersionId": zod.uuid(),
  "targets": zod.array(zod.object({
  "key": zod.string(),
  "label": zod.string(),
  "kind": zod.enum(['narrative', 'table', 'custom_prose', 'custom_table']),
  "columns": zod.array(zod.string())
})),
  "runs": zod.array(zod.object({
  "id": zod.uuid(),
  "requestedByAppUserId": zod.uuid(),
  "requestedAt": zod.iso.datetime({"offset":true}),
  "instruction": zod.string().nullable(),
  "pins": zod.object({
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "scopeFingerprint": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().nullable(),
  "documentHash": zod.string().nullable(),
  "lessonsFingerprint": zod.string(),
  "modelPolicyFingerprint": zod.string()
}),
  "facts": zod.array(zod.object({
  "id": zod.string(),
  "category": zod.string(),
  "text": zod.string(),
  "referenceIds": zod.array(zod.string())
})),
  "references": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['brief', 'workspace']),
  "label": zod.string().nullable(),
  "location": zod.string().nullable(),
  "excerpt": zod.string().nullable(),
  "available": zod.boolean()
})),
  "lessons": zod.array(zod.object({
  "lessonId": zod.uuid(),
  "revision": zod.int(),
  "guidance": zod.string(),
  "category": zod.string(),
  "applicability": zod.string()
})),
  "proposals": zod.array(zod.object({
  "id": zod.uuid(),
  "targetKey": zod.string(),
  "targetLabel": zod.string(),
  "targetKind": zod.enum(['narrative', 'table', 'custom_prose', 'custom_table']),
  "paragraphs": zod.array(zod.object({
  "kind": zod.enum(['scope_statement', 'evidenced_claim', 'proposed_approach', 'commitment', 'unresolved']),
  "text": zod.string(),
  "factIds": zod.array(zod.string()),
  "referenceIds": zod.array(zod.string())
})),
  "rows": zod.array(zod.object({
  "cells": zod.array(zod.string()),
  "kind": zod.enum(['scope_statement', 'evidenced_claim', 'proposed_approach', 'commitment', 'unresolved']),
  "factIds": zod.array(zod.string()),
  "referenceIds": zod.array(zod.string())
})),
  "proposalHash": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "staleReasons": zod.array(zod.string()),
  "decidedByAppUserId": zod.uuid().nullable(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable(),
  "decisionNote": zod.string().nullable(),
  "acceptedVersionId": zod.uuid().nullable(),
  "acceptedDocumentRevision": zod.int().nullable()
})),
  "gaps": zod.array(zod.string()),
  "warnings": zod.array(zod.string())
})),
  "attempts": zod.array(zod.object({
  "clientRequestId": zod.uuid(),
  "status": zod.enum(['in_flight', 'cancelled', 'failed', 'completed']),
  "startedAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().nullable()
})).describe('The caller\'s own drafting requests only.'),
  "review": zod.object({
  "advisory": zod.boolean().describe('Always true. This review never approves or publishes.'),
  "approvalOwner": zod.string(),
  "readiness": zod.enum(['no_document', 'needs_drafting', 'proposals_pending', 'stale', 'ready_for_native_review']),
  "readyForReview": zod.boolean(),
  "documentRevision": zod.int().nullable(),
  "documentHash": zod.string().nullable(),
  "documentStatus": zod.string().nullable(),
  "approvalStatus": zod.string().nullable(),
  "gaps": zod.array(zod.string())
})
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Cancels the caller's own in-flight drafting request. A late provider result for that request is discarded and never saved. Earlier proposals are kept.
 */
export const cancelSowPreparationDraftParams = zod.object({
  "id": zod.uuid()
})

export const cancelSowPreparationDraftBody = zod.object({
  "clientRequestId": zod.uuid()
})




export const cancelSowPreparationDraftResponse = zod.object({
  "preparationId": zod.uuid(),
  "revision": zod.int().min(1),
  "canWrite": zod.boolean(),
  "documentId": zod.uuid().nullable(),
  "templateVersionId": zod.uuid(),
  "targets": zod.array(zod.object({
  "key": zod.string(),
  "label": zod.string(),
  "kind": zod.enum(['narrative', 'table', 'custom_prose', 'custom_table']),
  "columns": zod.array(zod.string())
})),
  "runs": zod.array(zod.object({
  "id": zod.uuid(),
  "requestedByAppUserId": zod.uuid(),
  "requestedAt": zod.iso.datetime({"offset":true}),
  "instruction": zod.string().nullable(),
  "pins": zod.object({
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "scopeFingerprint": zod.string(),
  "documentId": zod.uuid().nullable(),
  "documentRevision": zod.int().nullable(),
  "documentHash": zod.string().nullable(),
  "lessonsFingerprint": zod.string(),
  "modelPolicyFingerprint": zod.string()
}),
  "facts": zod.array(zod.object({
  "id": zod.string(),
  "category": zod.string(),
  "text": zod.string(),
  "referenceIds": zod.array(zod.string())
})),
  "references": zod.array(zod.object({
  "id": zod.string(),
  "kind": zod.enum(['brief', 'workspace']),
  "label": zod.string().nullable(),
  "location": zod.string().nullable(),
  "excerpt": zod.string().nullable(),
  "available": zod.boolean()
})),
  "lessons": zod.array(zod.object({
  "lessonId": zod.uuid(),
  "revision": zod.int(),
  "guidance": zod.string(),
  "category": zod.string(),
  "applicability": zod.string()
})),
  "proposals": zod.array(zod.object({
  "id": zod.uuid(),
  "targetKey": zod.string(),
  "targetLabel": zod.string(),
  "targetKind": zod.enum(['narrative', 'table', 'custom_prose', 'custom_table']),
  "paragraphs": zod.array(zod.object({
  "kind": zod.enum(['scope_statement', 'evidenced_claim', 'proposed_approach', 'commitment', 'unresolved']),
  "text": zod.string(),
  "factIds": zod.array(zod.string()),
  "referenceIds": zod.array(zod.string())
})),
  "rows": zod.array(zod.object({
  "cells": zod.array(zod.string()),
  "kind": zod.enum(['scope_statement', 'evidenced_claim', 'proposed_approach', 'commitment', 'unresolved']),
  "factIds": zod.array(zod.string()),
  "referenceIds": zod.array(zod.string())
})),
  "proposalHash": zod.string(),
  "status": zod.enum(['pending', 'accepted', 'rejected', 'stale']),
  "staleReasons": zod.array(zod.string()),
  "decidedByAppUserId": zod.uuid().nullable(),
  "decidedAt": zod.iso.datetime({"offset":true}).nullable(),
  "decisionNote": zod.string().nullable(),
  "acceptedVersionId": zod.uuid().nullable(),
  "acceptedDocumentRevision": zod.int().nullable()
})),
  "gaps": zod.array(zod.string()),
  "warnings": zod.array(zod.string())
})),
  "attempts": zod.array(zod.object({
  "clientRequestId": zod.uuid(),
  "status": zod.enum(['in_flight', 'cancelled', 'failed', 'completed']),
  "startedAt": zod.iso.datetime({"offset":true}),
  "endedAt": zod.iso.datetime({"offset":true}).nullable(),
  "errorCode": zod.string().nullable()
})).describe('The caller\'s own drafting requests only.'),
  "review": zod.object({
  "advisory": zod.boolean().describe('Always true. This review never approves or publishes.'),
  "approvalOwner": zod.string(),
  "readiness": zod.enum(['no_document', 'needs_drafting', 'proposals_pending', 'stale', 'ready_for_native_review']),
  "readyForReview": zod.boolean(),
  "documentRevision": zod.int().nullable(),
  "documentHash": zod.string().nullable(),
  "documentStatus": zod.string().nullable(),
  "approvalStatus": zod.string().nullable(),
  "gaps": zod.array(zod.string())
})
})


/**
 * Reads the caller's own original preparation request outcome after an uncertain response, without replaying it.
 */
export const getSowPreparationOutcomeParams = zod.object({
  "clientRequestId": zod.uuid()
})






export const getSowPreparationOutcomeResponse = zod.object({
  "preparation": zod.object({
  "id": zod.uuid(),
  "workKind": zod.enum(['sow_preparation']),
  "title": zod.string(),
  "brief": zod.string(),
  "stage": zod.enum(['brief', 'scoping', 'drafting', 'review']).describe('Preparation progress only. Native document review/publication status is reported separately.'),
  "templateVersionId": zod.uuid(),
  "templateSourceHash": zod.string(),
  "accountId": zod.uuid().nullable(),
  "opportunityId": zod.uuid().nullable(),
  "quoteId": zod.uuid().nullable(),
  "documentId": zod.uuid().nullable(),
  "document": zod.union([zod.object({
  "id": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "draftRevision": zod.int().min(1),
  "templateVersionId": zod.uuid()
}),zod.null()]),
  "revision": zod.int().min(1),
  "archivedAt": zod.iso.datetime({"offset":true}).nullable(),
  "archiveReason": zod.string().nullable(),
  "createdByAppUserId": zod.uuid(),
  "createdAt": zod.iso.datetime({"offset":true}),
  "updatedAt": zod.iso.datetime({"offset":true}),
  "canWrite": zod.boolean().describe('Current native record-writer authority; not a grant.')
}),
  "outcome": zod.object({
  "clientRequestId": zod.uuid(),
  "preparationId": zod.uuid(),
  "kind": zod.enum(['created', 'updated', 'document_linked', 'archived', 'scope_suggested', 'scope_reviewed', 'plan_approved', 'draft_proposed', 'draft_decided']),
  "resultRevision": zod.int().min(1),
  "replayed": zod.boolean(),
  "createdAt": zod.iso.datetime({"offset":true})
})
})


/**
 * Discovers existing canonical Files SOW documents in the current entity under their original IDs, with any active preparation link. Never creates or links anything.
 */
export const listSowPreparationDocumentsQuerySearchMax = 160;

export const listSowPreparationDocumentsQueryUnlinkedOnlyDefault = false;
export const listSowPreparationDocumentsQueryLimitDefault = 25;
export const listSowPreparationDocumentsQueryLimitMax = 100;

export const listSowPreparationDocumentsQueryOffsetDefault = 0;
export const listSowPreparationDocumentsQueryOffsetMin = 0;
export const listSowPreparationDocumentsQueryOffsetMax = 100000;



export const listSowPreparationDocumentsQueryParams = zod.object({
  "search": zod.string().min(1).max(listSowPreparationDocumentsQuerySearchMax).optional(),
  "unlinkedOnly": zod.boolean().default(listSowPreparationDocumentsQueryUnlinkedOnlyDefault),
  "limit": zod.int().min(1).max(listSowPreparationDocumentsQueryLimitMax).default(listSowPreparationDocumentsQueryLimitDefault),
  "offset": zod.int().min(listSowPreparationDocumentsQueryOffsetMin).max(listSowPreparationDocumentsQueryOffsetMax).default(listSowPreparationDocumentsQueryOffsetDefault)
})

export const listSowPreparationDocumentsResponse = zod.object({
  "items": zod.array(zod.object({
  "documentId": zod.uuid(),
  "title": zod.string(),
  "status": zod.string(),
  "category": zod.string(),
  "templateVersionId": zod.uuid().nullable(),
  "linkable": zod.boolean().describe('True when the document is template-bound and has no active preparation.'),
  "preparationId": zod.uuid().nullable(),
  "updatedAt": zod.iso.datetime({"offset":true})
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * Scoped immutable template versions, newest first. The optional search matches the template key or custom template name.
 */
export const listSowTemplatesQueryLimitDefault = 25;
export const listSowTemplatesQueryLimitMax = 100;

export const listSowTemplatesQueryOffsetDefault = 0;
export const listSowTemplatesQueryOffsetMin = 0;

export const listSowTemplatesQuerySearchMax = 160;



export const listSowTemplatesQueryParams = zod.object({
  "limit": zod.int().min(1).max(listSowTemplatesQueryLimitMax).default(listSowTemplatesQueryLimitDefault),
  "offset": zod.int().min(listSowTemplatesQueryOffsetMin).default(listSowTemplatesQueryOffsetDefault),
  "search": zod.string().min(1).max(listSowTemplatesQuerySearchMax).optional()
})


export const listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemTypeMax = 40;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemTextMax = 200000;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemMarksMax = 20;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemContentMax = 10000;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderMax = 100;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemTypeMax = 40;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemTextMax = 200000;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemMarksMax = 20;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemContentMax = 10000;

export const listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterMax = 100;

export const listSowTemplatesResponseItemsItemTermsItemContentSectionsItemsItemTitleMax = 160;

export const listSowTemplatesResponseItemsItemTermsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const listSowTemplatesResponseItemsItemTermsItemContentSectionsItemsMax = 200;

export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemNameMax = 80;

export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsMin = 7;
export const listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsMax = 100;

export const listSowTemplatesResponseItemsItemTermsItemContentTemplateGuidanceMax = 4000;

export const listSowTemplatesResponseItemsItemTermsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const listSowTemplatesResponseItemsItemTermsItemContentTemplateSectionGuidanceMax = 200;

export const listSowTemplatesResponseItemsItemTermsItemContentContentItemTypeMax = 40;

export const listSowTemplatesResponseItemsItemTermsItemContentContentItemTextMax = 200000;

export const listSowTemplatesResponseItemsItemTermsItemContentContentItemMarksItemTypeMax = 40;

export const listSowTemplatesResponseItemsItemTermsItemContentContentItemMarksMax = 20;

export const listSowTemplatesResponseItemsItemTermsItemContentContentItemContentMax = 10000;

export const listSowTemplatesResponseItemsItemTermsItemContentContentMax = 10000;



export const listSowTemplatesResponse = zod.object({
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "version": zod.int().min(1),
  "sourceHash": zod.string(),
  "definition": zod.record(zod.string(), zod.unknown()),
  "terms": zod.array(zod.object({
  "key": zod.enum(['materials', 'agreement', 'payment', 'schedule1', 'operations']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsTopMin).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsRightMin).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsBottomMin).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsLeftMin).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderItemContentMax).optional()
})).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterItemContentMax).optional()
})).max(listSowTemplatesResponseItemsItemTermsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(listSowTemplatesResponseItemsItemTermsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(listSowTemplatesResponseItemsItemTermsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(listSowTemplatesResponseItemsItemTermsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemFontSizeMin).max(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemSpaceBeforeMin).max(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemSpaceAfterMin).max(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsItemLineHeightMax)
})).min(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsMin).max(listSowTemplatesResponseItemsItemTermsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(listSowTemplatesResponseItemsItemTermsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(listSowTemplatesResponseItemsItemTermsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(listSowTemplatesResponseItemsItemTermsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(listSowTemplatesResponseItemsItemTermsItemContentContentItemTypeMax),
  "text": zod.string().max(listSowTemplatesResponseItemsItemTermsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(listSowTemplatesResponseItemsItemTermsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(listSowTemplatesResponseItemsItemTermsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(listSowTemplatesResponseItemsItemTermsItemContentContentItemContentMax).optional()
})).max(listSowTemplatesResponseItemsItemTermsItemContentContentMax)
})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "format": zod.enum(['standard', 'engagement-pack', 'custom']).optional(),
  "name": zod.string().optional(),
  "description": zod.string().optional()
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int()
})


/**
 * A current Circle T entity administrator creates version 1 of an additional custom SOW template from exact reviewed content. Replaying the same reviewed request returns the original version; a different request for an existing key is rejected.
 */
export const createSowTemplateBodyKeyRegExp = new RegExp('^[a-z][a-z0-9-]{2,47}$');
export const createSowTemplateBodyDefinitionNameMax = 160;

export const createSowTemplateBodyDefinitionDescriptionMax = 2000;

export const createSowTemplateBodyDefinitionSectionsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const createSowTemplateBodyDefinitionSectionsItemHeadingMax = 200;

export const createSowTemplateBodyDefinitionSectionsItemGuidanceMax = 4000;

export const createSowTemplateBodyDefinitionSectionsItemFieldsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const createSowTemplateBodyDefinitionSectionsItemFieldsItemLabelMax = 200;

export const createSowTemplateBodyDefinitionSectionsItemFieldsItemOptionsItemMax = 200;

export const createSowTemplateBodyDefinitionSectionsItemFieldsItemOptionsMax = 30;

export const createSowTemplateBodyDefinitionSectionsItemFieldsItemGuidanceMax = 2000;

export const createSowTemplateBodyDefinitionSectionsItemFieldsMax = 30;

export const createSowTemplateBodyDefinitionSectionsItemColumnsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const createSowTemplateBodyDefinitionSectionsItemColumnsItemLabelMax = 200;

export const createSowTemplateBodyDefinitionSectionsItemColumnsMax = 8;

export const createSowTemplateBodyDefinitionSectionsItemMaxRowsMax = 100;

export const createSowTemplateBodyDefinitionSectionsItemComponentsMax = 3;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemTypeMax = 40;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemTextMax = 200000;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemMarksMax = 20;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemContentMax = 10000;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderMax = 100;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemTypeMax = 40;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemTextMax = 200000;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemMarksMax = 20;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemContentMax = 10000;

export const createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterMax = 100;

export const createSowTemplateBodyDefinitionSectionsItemContentSectionsItemsItemTitleMax = 160;

export const createSowTemplateBodyDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const createSowTemplateBodyDefinitionSectionsItemContentSectionsItemsMax = 200;

export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemNameMax = 80;

export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsMin = 7;
export const createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsMax = 100;

export const createSowTemplateBodyDefinitionSectionsItemContentTemplateGuidanceMax = 4000;

export const createSowTemplateBodyDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createSowTemplateBodyDefinitionSectionsItemContentTemplateSectionGuidanceMax = 200;

export const createSowTemplateBodyDefinitionSectionsItemContentContentItemTypeMax = 40;

export const createSowTemplateBodyDefinitionSectionsItemContentContentItemTextMax = 200000;

export const createSowTemplateBodyDefinitionSectionsItemContentContentItemMarksItemTypeMax = 40;

export const createSowTemplateBodyDefinitionSectionsItemContentContentItemMarksMax = 20;

export const createSowTemplateBodyDefinitionSectionsItemContentContentItemContentMax = 10000;

export const createSowTemplateBodyDefinitionSectionsItemContentContentMax = 10000;

export const createSowTemplateBodyDefinitionSectionsMax = 40;

export const createSowTemplateBodyContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const createSowTemplateBodyReasonMax = 2000;



export const createSowTemplateBody = zod.object({
  "key": zod.string().regex(createSowTemplateBodyKeyRegExp),
  "definition": zod.object({
  "format": zod.enum(['circle-t-custom-v1']),
  "name": zod.string().min(1).max(createSowTemplateBodyDefinitionNameMax),
  "description": zod.string().max(createSowTemplateBodyDefinitionDescriptionMax),
  "layout": zod.object({
  "pageSize": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "numberedHeadings": zod.boolean()
}),
  "sections": zod.array(zod.object({
  "id": zod.string().regex(createSowTemplateBodyDefinitionSectionsItemIdRegExp),
  "heading": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemHeadingMax),
  "kind": zod.enum(['fields', 'prose', 'table', 'protected', 'commercial', 'signature']),
  "required": zod.boolean(),
  "guidance": zod.string().max(createSowTemplateBodyDefinitionSectionsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.'),
  "fields": zod.array(zod.object({
  "id": zod.string().regex(createSowTemplateBodyDefinitionSectionsItemFieldsItemIdRegExp),
  "label": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemFieldsItemLabelMax),
  "type": zod.enum(['text', 'date', 'number', 'choice']),
  "required": zod.boolean(),
  "options": zod.array(zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemFieldsItemOptionsItemMax)).max(createSowTemplateBodyDefinitionSectionsItemFieldsItemOptionsMax).optional(),
  "guidance": zod.string().max(createSowTemplateBodyDefinitionSectionsItemFieldsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.')
})).max(createSowTemplateBodyDefinitionSectionsItemFieldsMax).optional(),
  "columns": zod.array(zod.object({
  "id": zod.string().regex(createSowTemplateBodyDefinitionSectionsItemColumnsItemIdRegExp),
  "label": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemColumnsItemLabelMax)
})).max(createSowTemplateBodyDefinitionSectionsItemColumnsMax).optional(),
  "maxRows": zod.int().min(1).max(createSowTemplateBodyDefinitionSectionsItemMaxRowsMax).optional(),
  "components": zod.array(zod.enum(['investment', 'materials', 'invoices'])).max(createSowTemplateBodyDefinitionSectionsItemComponentsMax).optional(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemContentMax).optional()
})).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemContentMax).optional()
})).max(createSowTemplateBodyDefinitionSectionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createSowTemplateBodyDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createSowTemplateBodyDefinitionSectionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin).max(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin).max(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsMin).max(createSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createSowTemplateBodyDefinitionSectionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createSowTemplateBodyDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(createSowTemplateBodyDefinitionSectionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemContentContentItemTypeMax),
  "text": zod.string().max(createSowTemplateBodyDefinitionSectionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateBodyDefinitionSectionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createSowTemplateBodyDefinitionSectionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createSowTemplateBodyDefinitionSectionsItemContentContentItemContentMax).optional()
})).max(createSowTemplateBodyDefinitionSectionsItemContentContentMax)
}).optional()
}).describe('fields, prose and table sections are author-editable project inputs. protected, commercial and signature sections are fixed by the template and native calculations.')).min(1).max(createSowTemplateBodyDefinitionSectionsMax)
}),
  "contentHash": zod.string().regex(createSowTemplateBodyContentHashRegExp),
  "reason": zod.string().min(1).max(createSowTemplateBodyReasonMax)
})


export const createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const createSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax = 40;

export const createSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax = 200000;

export const createSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const createSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax = 20;

export const createSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax = 10000;

export const createSowTemplateResponseTermsItemContentLayoutHeaderMax = 100;

export const createSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax = 40;

export const createSowTemplateResponseTermsItemContentLayoutFooterItemTextMax = 200000;

export const createSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const createSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax = 20;

export const createSowTemplateResponseTermsItemContentLayoutFooterItemContentMax = 10000;

export const createSowTemplateResponseTermsItemContentLayoutFooterMax = 100;

export const createSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax = 160;

export const createSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const createSowTemplateResponseTermsItemContentSectionsItemsMax = 200;

export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax = 80;

export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const createSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const createSowTemplateResponseTermsItemContentStylesDefinitionsMin = 7;
export const createSowTemplateResponseTermsItemContentStylesDefinitionsMax = 100;

export const createSowTemplateResponseTermsItemContentTemplateGuidanceMax = 4000;

export const createSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const createSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax = 200;

export const createSowTemplateResponseTermsItemContentContentItemTypeMax = 40;

export const createSowTemplateResponseTermsItemContentContentItemTextMax = 200000;

export const createSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax = 40;

export const createSowTemplateResponseTermsItemContentContentItemMarksMax = 20;

export const createSowTemplateResponseTermsItemContentContentItemContentMax = 10000;

export const createSowTemplateResponseTermsItemContentContentMax = 10000;



export const createSowTemplateResponse = zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "version": zod.int().min(1),
  "sourceHash": zod.string(),
  "definition": zod.record(zod.string(), zod.unknown()),
  "terms": zod.array(zod.object({
  "key": zod.enum(['materials', 'agreement', 'payment', 'schedule1', 'operations']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin).max(createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin).max(createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin).max(createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin).max(createSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(createSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax).optional()
})).max(createSowTemplateResponseTermsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(createSowTemplateResponseTermsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createSowTemplateResponseTermsItemContentLayoutFooterItemContentMax).optional()
})).max(createSowTemplateResponseTermsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(createSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(createSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(createSowTemplateResponseTermsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(createSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(createSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(createSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin).max(createSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(createSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(createSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin).max(createSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(createSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin).max(createSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(createSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax)
})).min(createSowTemplateResponseTermsItemContentStylesDefinitionsMin).max(createSowTemplateResponseTermsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(createSowTemplateResponseTermsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(createSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(createSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateResponseTermsItemContentContentItemTypeMax),
  "text": zod.string().max(createSowTemplateResponseTermsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(createSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(createSowTemplateResponseTermsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(createSowTemplateResponseTermsItemContentContentItemContentMax).optional()
})).max(createSowTemplateResponseTermsItemContentContentMax)
})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "format": zod.enum(['standard', 'engagement-pack', 'custom']).optional(),
  "name": zod.string().optional(),
  "description": zod.string().optional()
})


/**
 * Validate and deterministically render a proposed custom template with clearly labelled sample facts. Performs no business write.
 */
export const previewSowTemplateDefinitionBodyDefinitionNameMax = 160;

export const previewSowTemplateDefinitionBodyDefinitionDescriptionMax = 2000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemHeadingMax = 200;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemGuidanceMax = 4000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemLabelMax = 200;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemOptionsItemMax = 200;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemOptionsMax = 30;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemGuidanceMax = 2000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsMax = 30;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemColumnsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemColumnsItemLabelMax = 200;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemColumnsMax = 8;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemMaxRowsMax = 100;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemComponentsMax = 3;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemTypeMax = 40;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemTextMax = 200000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemMarksMax = 20;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemContentMax = 10000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderMax = 100;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemTypeMax = 40;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemTextMax = 200000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemMarksMax = 20;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemContentMax = 10000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterMax = 100;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentSectionsItemsItemTitleMax = 160;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentSectionsItemsMax = 200;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemNameMax = 80;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsMin = 7;
export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsMax = 100;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentTemplateGuidanceMax = 4000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentTemplateSectionGuidanceMax = 200;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemTypeMax = 40;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemTextMax = 200000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemMarksItemTypeMax = 40;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemMarksMax = 20;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemContentMax = 10000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentMax = 10000;

export const previewSowTemplateDefinitionBodyDefinitionSectionsMax = 40;

export const previewSowTemplateDefinitionBodyFactsProjectTitleMax = 200;

export const previewSowTemplateDefinitionBodyFactsCustomerNameMax = 300;

export const previewSowTemplateDefinitionBodyFactsAgreementIdMax = 100;

export const previewSowTemplateDefinitionBodyFactsPreparedDateMax = 40;

export const previewSowTemplateDefinitionBodyFactsStartDateMax = 40;

export const previewSowTemplateDefinitionBodyFactsSprintWeeksMax = 52;

export const previewSowTemplateDefinitionBodyFactsNarrativeItemTextMax = 20000;

export const previewSowTemplateDefinitionBodyFactsNarrativeMax = 5;

export const previewSowTemplateDefinitionBodyFactsTablesItemRowsItemItemMax = 4000;

export const previewSowTemplateDefinitionBodyFactsTablesItemRowsItemMax = 7;

export const previewSowTemplateDefinitionBodyFactsTablesItemRowsMax = 100;

export const previewSowTemplateDefinitionBodyFactsTablesMax = 6;

export const previewSowTemplateDefinitionBodyFactsInvestmentItemIdMax = 80;

export const previewSowTemplateDefinitionBodyFactsInvestmentItemTitleMax = 300;

export const previewSowTemplateDefinitionBodyFactsInvestmentItemDescriptionMax = 4000;

export const previewSowTemplateDefinitionBodyFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsInvestmentMax = 100;

export const previewSowTemplateDefinitionBodyFactsMaterialsItemIdMax = 80;

export const previewSowTemplateDefinitionBodyFactsMaterialsItemTitleMax = 300;

export const previewSowTemplateDefinitionBodyFactsMaterialsItemDescriptionMax = 4000;

export const previewSowTemplateDefinitionBodyFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsMaterialsMax = 100;

export const previewSowTemplateDefinitionBodyFactsInvoicesItemIdMax = 80;

export const previewSowTemplateDefinitionBodyFactsInvoicesItemMilestonesMax = 500;

export const previewSowTemplateDefinitionBodyFactsInvoicesItemDateMax = 40;

export const previewSowTemplateDefinitionBodyFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsInvoicesItemNotesMax = 2000;

export const previewSowTemplateDefinitionBodyFactsInvoicesMax = 100;

export const previewSowTemplateDefinitionBodyFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const previewSowTemplateDefinitionBodyFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewSowTemplateDefinitionBodyFactsQuoteCommercialReferenceMax = 300;

export const previewSowTemplateDefinitionBodyFactsQuoteCommercialSourceStatusMax = 100;

export const previewSowTemplateDefinitionBodyFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const previewSowTemplateDefinitionBodyFactsQuoteCommercialTermsMax = 20000;

export const previewSowTemplateDefinitionBodyFactsQuoteCommercialAssumptionsMax = 20000;

export const previewSowTemplateDefinitionBodyFactsQuoteCommercialExclusionsMax = 20000;

export const previewSowTemplateDefinitionBodyFactsQuoteCommercialReviewReasonMin = 10;
export const previewSowTemplateDefinitionBodyFactsQuoteCommercialReviewReasonMax = 2000;

export const previewSowTemplateDefinitionBodyFactsQuoteCommercialLinesItemTitleMax = 300;

export const previewSowTemplateDefinitionBodyFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const previewSowTemplateDefinitionBodyFactsQuoteCommercialLinesMax = 100;

export const previewSowTemplateDefinitionBodyFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const previewSowTemplateDefinitionBodyFactsUnresolvedFactsItemFieldMax = 100;

export const previewSowTemplateDefinitionBodyFactsUnresolvedFactsItemMessageMax = 2000;

export const previewSowTemplateDefinitionBodyFactsUnresolvedFactsMax = 200;

export const previewSowTemplateDefinitionBodyFactsCustomFieldsItemSectionIdMax = 48;

export const previewSowTemplateDefinitionBodyFactsCustomFieldsItemFieldIdMax = 48;

export const previewSowTemplateDefinitionBodyFactsCustomFieldsItemValueMax = 4000;

export const previewSowTemplateDefinitionBodyFactsCustomFieldsMax = 600;

export const previewSowTemplateDefinitionBodyFactsCustomProseItemSectionIdMax = 48;

export const previewSowTemplateDefinitionBodyFactsCustomProseItemTextMax = 20000;

export const previewSowTemplateDefinitionBodyFactsCustomProseMax = 40;

export const previewSowTemplateDefinitionBodyFactsCustomTablesItemSectionIdMax = 48;

export const previewSowTemplateDefinitionBodyFactsCustomTablesItemRowsItemItemMax = 4000;

export const previewSowTemplateDefinitionBodyFactsCustomTablesItemRowsItemMax = 8;

export const previewSowTemplateDefinitionBodyFactsCustomTablesItemRowsMax = 100;

export const previewSowTemplateDefinitionBodyFactsCustomTablesMax = 40;



export const previewSowTemplateDefinitionBody = zod.object({
  "definition": zod.object({
  "format": zod.enum(['circle-t-custom-v1']),
  "name": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionNameMax),
  "description": zod.string().max(previewSowTemplateDefinitionBodyDefinitionDescriptionMax),
  "layout": zod.object({
  "pageSize": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "numberedHeadings": zod.boolean()
}),
  "sections": zod.array(zod.object({
  "id": zod.string().regex(previewSowTemplateDefinitionBodyDefinitionSectionsItemIdRegExp),
  "heading": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemHeadingMax),
  "kind": zod.enum(['fields', 'prose', 'table', 'protected', 'commercial', 'signature']),
  "required": zod.boolean(),
  "guidance": zod.string().max(previewSowTemplateDefinitionBodyDefinitionSectionsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.'),
  "fields": zod.array(zod.object({
  "id": zod.string().regex(previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemIdRegExp),
  "label": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemLabelMax),
  "type": zod.enum(['text', 'date', 'number', 'choice']),
  "required": zod.boolean(),
  "options": zod.array(zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemOptionsItemMax)).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemOptionsMax).optional(),
  "guidance": zod.string().max(previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.')
})).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemFieldsMax).optional(),
  "columns": zod.array(zod.object({
  "id": zod.string().regex(previewSowTemplateDefinitionBodyDefinitionSectionsItemColumnsItemIdRegExp),
  "label": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemColumnsItemLabelMax)
})).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemColumnsMax).optional(),
  "maxRows": zod.int().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemMaxRowsMax).optional(),
  "components": zod.array(zod.enum(['investment', 'materials', 'invoices'])).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemComponentsMax).optional(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderItemContentMax).optional()
})).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterItemContentMax).optional()
})).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsMin).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemTypeMax),
  "text": zod.string().max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentItemContentMax).optional()
})).max(previewSowTemplateDefinitionBodyDefinitionSectionsItemContentContentMax)
}).optional()
}).describe('fields, prose and table sections are author-editable project inputs. protected, commercial and signature sections are fixed by the template and native calculations.')).min(1).max(previewSowTemplateDefinitionBodyDefinitionSectionsMax)
}),
  "facts": zod.object({
  "projectTitle": zod.string().max(previewSowTemplateDefinitionBodyFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(previewSowTemplateDefinitionBodyFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(previewSowTemplateDefinitionBodyFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(previewSowTemplateDefinitionBodyFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(previewSowTemplateDefinitionBodyFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(previewSowTemplateDefinitionBodyFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(previewSowTemplateDefinitionBodyFactsNarrativeItemTextMax)
})).max(previewSowTemplateDefinitionBodyFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(previewSowTemplateDefinitionBodyFactsTablesItemRowsItemItemMax)).max(previewSowTemplateDefinitionBodyFactsTablesItemRowsItemMax)).max(previewSowTemplateDefinitionBodyFactsTablesItemRowsMax)
})).max(previewSowTemplateDefinitionBodyFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(previewSowTemplateDefinitionBodyFactsInvestmentItemIdMax),
  "title": zod.string().max(previewSowTemplateDefinitionBodyFactsInvestmentItemTitleMax),
  "description": zod.string().max(previewSowTemplateDefinitionBodyFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(previewSowTemplateDefinitionBodyFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(previewSowTemplateDefinitionBodyFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(previewSowTemplateDefinitionBodyFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(previewSowTemplateDefinitionBodyFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(previewSowTemplateDefinitionBodyFactsMaterialsItemIdMax),
  "title": zod.string().max(previewSowTemplateDefinitionBodyFactsMaterialsItemTitleMax),
  "description": zod.string().max(previewSowTemplateDefinitionBodyFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(previewSowTemplateDefinitionBodyFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(previewSowTemplateDefinitionBodyFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(previewSowTemplateDefinitionBodyFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(previewSowTemplateDefinitionBodyFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(previewSowTemplateDefinitionBodyFactsInvoicesItemIdMax),
  "milestones": zod.string().max(previewSowTemplateDefinitionBodyFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(previewSowTemplateDefinitionBodyFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(previewSowTemplateDefinitionBodyFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(previewSowTemplateDefinitionBodyFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(previewSowTemplateDefinitionBodyFactsInvoicesItemNotesMax)
})).max(previewSowTemplateDefinitionBodyFactsInvoicesMax),
  "milestoneDays": zod.string().regex(previewSowTemplateDefinitionBodyFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(previewSowTemplateDefinitionBodyFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(previewSowTemplateDefinitionBodyFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(previewSowTemplateDefinitionBodyFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(previewSowTemplateDefinitionBodyFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(previewSowTemplateDefinitionBodyFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(previewSowTemplateDefinitionBodyFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(previewSowTemplateDefinitionBodyFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(previewSowTemplateDefinitionBodyFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(previewSowTemplateDefinitionBodyFactsQuoteCommercialReviewReasonMin).max(previewSowTemplateDefinitionBodyFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(previewSowTemplateDefinitionBodyFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(previewSowTemplateDefinitionBodyFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(previewSowTemplateDefinitionBodyFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(previewSowTemplateDefinitionBodyFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(previewSowTemplateDefinitionBodyFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(previewSowTemplateDefinitionBodyFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(previewSowTemplateDefinitionBodyFactsUnresolvedFactsItemMessageMax)
})).max(previewSowTemplateDefinitionBodyFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(previewSowTemplateDefinitionBodyFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(previewSowTemplateDefinitionBodyFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(previewSowTemplateDefinitionBodyFactsCustomFieldsItemValueMax).nullable()
})).max(previewSowTemplateDefinitionBodyFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(previewSowTemplateDefinitionBodyFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(previewSowTemplateDefinitionBodyFactsCustomProseItemTextMax)
})).max(previewSowTemplateDefinitionBodyFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(previewSowTemplateDefinitionBodyFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(previewSowTemplateDefinitionBodyFactsCustomTablesItemRowsItemItemMax)).max(previewSowTemplateDefinitionBodyFactsCustomTablesItemRowsItemMax)).max(previewSowTemplateDefinitionBodyFactsCustomTablesItemRowsMax)
})).max(previewSowTemplateDefinitionBodyFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
}).optional()
})

export const previewSowTemplateDefinitionResponseDefinitionNameMax = 160;

export const previewSowTemplateDefinitionResponseDefinitionDescriptionMax = 2000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemHeadingMax = 200;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemGuidanceMax = 4000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemLabelMax = 200;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemOptionsItemMax = 200;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemOptionsMax = 30;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemGuidanceMax = 2000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsMax = 30;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemColumnsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemColumnsItemLabelMax = 200;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemColumnsMax = 8;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemMaxRowsMax = 100;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemComponentsMax = 3;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemTextMax = 200000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemMarksMax = 20;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemContentMax = 10000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderMax = 100;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemTextMax = 200000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemMarksMax = 20;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemContentMax = 10000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterMax = 100;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentSectionsItemsItemTitleMax = 160;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentSectionsItemsMax = 200;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemNameMax = 80;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsMin = 7;
export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsMax = 100;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentTemplateGuidanceMax = 4000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentTemplateSectionGuidanceMax = 200;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemTextMax = 200000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemMarksItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemMarksMax = 20;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemContentMax = 10000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentMax = 10000;

export const previewSowTemplateDefinitionResponseDefinitionSectionsMax = 40;

export const previewSowTemplateDefinitionResponseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsTopMin = 5;
export const previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsTopMax = 50;

export const previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsRightMin = 5;
export const previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsRightMax = 50;

export const previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsBottomMin = 5;
export const previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsBottomMax = 50;

export const previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsLeftMin = 5;
export const previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsLeftMax = 50;

export const previewSowTemplateDefinitionResponseContentLayoutHeaderItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseContentLayoutHeaderItemTextMax = 200000;

export const previewSowTemplateDefinitionResponseContentLayoutHeaderItemMarksItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseContentLayoutHeaderItemMarksMax = 20;

export const previewSowTemplateDefinitionResponseContentLayoutHeaderItemContentMax = 10000;

export const previewSowTemplateDefinitionResponseContentLayoutHeaderMax = 100;

export const previewSowTemplateDefinitionResponseContentLayoutFooterItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseContentLayoutFooterItemTextMax = 200000;

export const previewSowTemplateDefinitionResponseContentLayoutFooterItemMarksItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseContentLayoutFooterItemMarksMax = 20;

export const previewSowTemplateDefinitionResponseContentLayoutFooterItemContentMax = 10000;

export const previewSowTemplateDefinitionResponseContentLayoutFooterMax = 100;

export const previewSowTemplateDefinitionResponseContentSectionsItemsItemTitleMax = 160;

export const previewSowTemplateDefinitionResponseContentSectionsItemsItemAuthoringNotesMax = 4000;


export const previewSowTemplateDefinitionResponseContentSectionsItemsMax = 200;

export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemNameMax = 80;

export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemFontSizeMin = 6;
export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemFontSizeMax = 96;

export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemSpaceAfterMin = 0;
export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemSpaceAfterMax = 144;

export const previewSowTemplateDefinitionResponseContentStylesDefinitionsItemLineHeightMax = 3;

export const previewSowTemplateDefinitionResponseContentStylesDefinitionsMin = 7;
export const previewSowTemplateDefinitionResponseContentStylesDefinitionsMax = 100;

export const previewSowTemplateDefinitionResponseContentTemplateGuidanceMax = 4000;

export const previewSowTemplateDefinitionResponseContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const previewSowTemplateDefinitionResponseContentTemplateSectionGuidanceMax = 200;

export const previewSowTemplateDefinitionResponseContentContentItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseContentContentItemTextMax = 200000;

export const previewSowTemplateDefinitionResponseContentContentItemMarksItemTypeMax = 40;

export const previewSowTemplateDefinitionResponseContentContentItemMarksMax = 20;

export const previewSowTemplateDefinitionResponseContentContentItemContentMax = 10000;

export const previewSowTemplateDefinitionResponseContentContentMax = 10000;



export const previewSowTemplateDefinitionResponse = zod.object({
  "definition": zod.object({
  "format": zod.enum(['circle-t-custom-v1']),
  "name": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionNameMax),
  "description": zod.string().max(previewSowTemplateDefinitionResponseDefinitionDescriptionMax),
  "layout": zod.object({
  "pageSize": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "numberedHeadings": zod.boolean()
}),
  "sections": zod.array(zod.object({
  "id": zod.string().regex(previewSowTemplateDefinitionResponseDefinitionSectionsItemIdRegExp),
  "heading": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemHeadingMax),
  "kind": zod.enum(['fields', 'prose', 'table', 'protected', 'commercial', 'signature']),
  "required": zod.boolean(),
  "guidance": zod.string().max(previewSowTemplateDefinitionResponseDefinitionSectionsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.'),
  "fields": zod.array(zod.object({
  "id": zod.string().regex(previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemIdRegExp),
  "label": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemLabelMax),
  "type": zod.enum(['text', 'date', 'number', 'choice']),
  "required": zod.boolean(),
  "options": zod.array(zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemOptionsItemMax)).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemOptionsMax).optional(),
  "guidance": zod.string().max(previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.')
})).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemFieldsMax).optional(),
  "columns": zod.array(zod.object({
  "id": zod.string().regex(previewSowTemplateDefinitionResponseDefinitionSectionsItemColumnsItemIdRegExp),
  "label": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemColumnsItemLabelMax)
})).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemColumnsMax).optional(),
  "maxRows": zod.int().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemMaxRowsMax).optional(),
  "components": zod.array(zod.enum(['investment', 'materials', 'invoices'])).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemComponentsMax).optional(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderItemContentMax).optional()
})).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterItemContentMax).optional()
})).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsMin).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemTypeMax),
  "text": zod.string().max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentItemContentMax).optional()
})).max(previewSowTemplateDefinitionResponseDefinitionSectionsItemContentContentMax)
}).optional()
}).describe('fields, prose and table sections are author-editable project inputs. protected, commercial and signature sections are fixed by the template and native calculations.')).min(1).max(previewSowTemplateDefinitionResponseDefinitionSectionsMax)
}),
  "contentHash": zod.string().regex(previewSowTemplateDefinitionResponseContentHashRegExp),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsTopMin).max(previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsRightMin).max(previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsBottomMin).max(previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsLeftMin).max(previewSowTemplateDefinitionResponseContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(previewSowTemplateDefinitionResponseContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewSowTemplateDefinitionResponseContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewSowTemplateDefinitionResponseContentLayoutHeaderItemContentMax).optional()
})).max(previewSowTemplateDefinitionResponseContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseContentLayoutFooterItemTypeMax),
  "text": zod.string().max(previewSowTemplateDefinitionResponseContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewSowTemplateDefinitionResponseContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewSowTemplateDefinitionResponseContentLayoutFooterItemContentMax).optional()
})).max(previewSowTemplateDefinitionResponseContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(previewSowTemplateDefinitionResponseContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(previewSowTemplateDefinitionResponseContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(previewSowTemplateDefinitionResponseContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemFontSizeMin).max(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemSpaceBeforeMin).max(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemSpaceAfterMin).max(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(previewSowTemplateDefinitionResponseContentStylesDefinitionsItemLineHeightMax)
})).min(previewSowTemplateDefinitionResponseContentStylesDefinitionsMin).max(previewSowTemplateDefinitionResponseContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(previewSowTemplateDefinitionResponseContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(previewSowTemplateDefinitionResponseContentTemplateSectionGuidanceItemGuidanceMax)
})).max(previewSowTemplateDefinitionResponseContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseContentContentItemTypeMax),
  "text": zod.string().max(previewSowTemplateDefinitionResponseContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(previewSowTemplateDefinitionResponseContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(previewSowTemplateDefinitionResponseContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(previewSowTemplateDefinitionResponseContentContentItemContentMax).optional()
})).max(previewSowTemplateDefinitionResponseContentContentMax)
}),
  "validation": zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
}),
  "sampleNotice": zod.string()
})


/**
 * Append the next immutable version of a custom template from exact reviewed content. Requires the current version, a change reason and a current Circle T administrator. Existing documents stay pinned.
 */
export const reviseCustomSowTemplateParams = zod.object({
  "id": zod.uuid()
})


export const reviseCustomSowTemplateBodyDefinitionNameMax = 160;

export const reviseCustomSowTemplateBodyDefinitionDescriptionMax = 2000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const reviseCustomSowTemplateBodyDefinitionSectionsItemHeadingMax = 200;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemGuidanceMax = 4000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemLabelMax = 200;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemOptionsItemMax = 200;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemOptionsMax = 30;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemGuidanceMax = 2000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsMax = 30;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemColumnsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const reviseCustomSowTemplateBodyDefinitionSectionsItemColumnsItemLabelMax = 200;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemColumnsMax = 8;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemMaxRowsMax = 100;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemComponentsMax = 3;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemTypeMax = 40;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemTextMax = 200000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemMarksMax = 20;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemContentMax = 10000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderMax = 100;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemTypeMax = 40;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemTextMax = 200000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemMarksMax = 20;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemContentMax = 10000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterMax = 100;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentSectionsItemsItemTitleMax = 160;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentSectionsItemsMax = 200;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemNameMax = 80;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsMin = 7;
export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsMax = 100;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentTemplateGuidanceMax = 4000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentTemplateSectionGuidanceMax = 200;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemTypeMax = 40;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemTextMax = 200000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemMarksItemTypeMax = 40;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemMarksMax = 20;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemContentMax = 10000;

export const reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentMax = 10000;

export const reviseCustomSowTemplateBodyDefinitionSectionsMax = 40;

export const reviseCustomSowTemplateBodyContentHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const reviseCustomSowTemplateBodyReasonMax = 2000;



export const reviseCustomSowTemplateBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "definition": zod.object({
  "format": zod.enum(['circle-t-custom-v1']),
  "name": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionNameMax),
  "description": zod.string().max(reviseCustomSowTemplateBodyDefinitionDescriptionMax),
  "layout": zod.object({
  "pageSize": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "numberedHeadings": zod.boolean()
}),
  "sections": zod.array(zod.object({
  "id": zod.string().regex(reviseCustomSowTemplateBodyDefinitionSectionsItemIdRegExp),
  "heading": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemHeadingMax),
  "kind": zod.enum(['fields', 'prose', 'table', 'protected', 'commercial', 'signature']),
  "required": zod.boolean(),
  "guidance": zod.string().max(reviseCustomSowTemplateBodyDefinitionSectionsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.'),
  "fields": zod.array(zod.object({
  "id": zod.string().regex(reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemIdRegExp),
  "label": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemLabelMax),
  "type": zod.enum(['text', 'date', 'number', 'choice']),
  "required": zod.boolean(),
  "options": zod.array(zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemOptionsItemMax)).max(reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemOptionsMax).optional(),
  "guidance": zod.string().max(reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.')
})).max(reviseCustomSowTemplateBodyDefinitionSectionsItemFieldsMax).optional(),
  "columns": zod.array(zod.object({
  "id": zod.string().regex(reviseCustomSowTemplateBodyDefinitionSectionsItemColumnsItemIdRegExp),
  "label": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemColumnsItemLabelMax)
})).max(reviseCustomSowTemplateBodyDefinitionSectionsItemColumnsMax).optional(),
  "maxRows": zod.int().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemMaxRowsMax).optional(),
  "components": zod.array(zod.enum(['investment', 'materials', 'invoices'])).max(reviseCustomSowTemplateBodyDefinitionSectionsItemComponentsMax).optional(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderItemContentMax).optional()
})).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterItemContentMax).optional()
})).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsMin).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemTypeMax),
  "text": zod.string().max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentItemContentMax).optional()
})).max(reviseCustomSowTemplateBodyDefinitionSectionsItemContentContentMax)
}).optional()
}).describe('fields, prose and table sections are author-editable project inputs. protected, commercial and signature sections are fixed by the template and native calculations.')).min(1).max(reviseCustomSowTemplateBodyDefinitionSectionsMax)
}),
  "contentHash": zod.string().regex(reviseCustomSowTemplateBodyContentHashRegExp),
  "reason": zod.string().min(1).max(reviseCustomSowTemplateBodyReasonMax)
})


export const reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax = 40;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax = 200000;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax = 20;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax = 10000;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderMax = 100;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax = 40;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemTextMax = 200000;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax = 20;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemContentMax = 10000;

export const reviseCustomSowTemplateResponseTermsItemContentLayoutFooterMax = 100;

export const reviseCustomSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax = 160;

export const reviseCustomSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const reviseCustomSowTemplateResponseTermsItemContentSectionsItemsMax = 200;

export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax = 80;

export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsMin = 7;
export const reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsMax = 100;

export const reviseCustomSowTemplateResponseTermsItemContentTemplateGuidanceMax = 4000;

export const reviseCustomSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const reviseCustomSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax = 200;

export const reviseCustomSowTemplateResponseTermsItemContentContentItemTypeMax = 40;

export const reviseCustomSowTemplateResponseTermsItemContentContentItemTextMax = 200000;

export const reviseCustomSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax = 40;

export const reviseCustomSowTemplateResponseTermsItemContentContentItemMarksMax = 20;

export const reviseCustomSowTemplateResponseTermsItemContentContentItemContentMax = 10000;

export const reviseCustomSowTemplateResponseTermsItemContentContentMax = 10000;



export const reviseCustomSowTemplateResponse = zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "version": zod.int().min(1),
  "sourceHash": zod.string(),
  "definition": zod.record(zod.string(), zod.unknown()),
  "terms": zod.array(zod.object({
  "key": zod.enum(['materials', 'agreement', 'payment', 'schedule1', 'operations']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin).max(reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin).max(reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin).max(reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin).max(reviseCustomSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax).optional()
})).max(reviseCustomSowTemplateResponseTermsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseCustomSowTemplateResponseTermsItemContentLayoutFooterItemContentMax).optional()
})).max(reviseCustomSowTemplateResponseTermsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(reviseCustomSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(reviseCustomSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(reviseCustomSowTemplateResponseTermsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin).max(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin).max(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin).max(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax)
})).min(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsMin).max(reviseCustomSowTemplateResponseTermsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(reviseCustomSowTemplateResponseTermsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(reviseCustomSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(reviseCustomSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateResponseTermsItemContentContentItemTypeMax),
  "text": zod.string().max(reviseCustomSowTemplateResponseTermsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseCustomSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseCustomSowTemplateResponseTermsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseCustomSowTemplateResponseTermsItemContentContentItemContentMax).optional()
})).max(reviseCustomSowTemplateResponseTermsItemContentContentMax)
})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "format": zod.enum(['standard', 'engagement-pack', 'custom']).optional(),
  "name": zod.string().optional(),
  "description": zod.string().optional()
})


/**
 * Prepare an unsaved custom-template draft copied from an existing built-in or custom version for administrator review. Performs no write.
 */
export const prepareSowTemplateCopyParams = zod.object({
  "id": zod.uuid()
})

export const prepareSowTemplateCopyResponseDefinitionNameMax = 160;

export const prepareSowTemplateCopyResponseDefinitionDescriptionMax = 2000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const prepareSowTemplateCopyResponseDefinitionSectionsItemHeadingMax = 200;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemGuidanceMax = 4000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemLabelMax = 200;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemOptionsItemMax = 200;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemOptionsMax = 30;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemGuidanceMax = 2000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsMax = 30;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemColumnsItemIdRegExp = new RegExp('^[a-z][a-z0-9-]{0,47}$');
export const prepareSowTemplateCopyResponseDefinitionSectionsItemColumnsItemLabelMax = 200;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemColumnsMax = 8;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemMaxRowsMax = 100;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemComponentsMax = 3;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemTypeMax = 40;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemTextMax = 200000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemMarksMax = 20;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemContentMax = 10000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderMax = 100;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemTypeMax = 40;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemTextMax = 200000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemMarksMax = 20;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemContentMax = 10000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterMax = 100;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentSectionsItemsItemTitleMax = 160;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentSectionsItemsMax = 200;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemNameMax = 80;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsMin = 7;
export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsMax = 100;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentTemplateGuidanceMax = 4000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentTemplateSectionGuidanceMax = 200;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemTypeMax = 40;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemTextMax = 200000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemMarksItemTypeMax = 40;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemMarksMax = 20;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemContentMax = 10000;

export const prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentMax = 10000;

export const prepareSowTemplateCopyResponseDefinitionSectionsMax = 40;

export const prepareSowTemplateCopyResponseContentHashRegExp = new RegExp('^[a-f0-9]{64}$');



export const prepareSowTemplateCopyResponse = zod.object({
  "definition": zod.object({
  "format": zod.enum(['circle-t-custom-v1']),
  "name": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionNameMax),
  "description": zod.string().max(prepareSowTemplateCopyResponseDefinitionDescriptionMax),
  "layout": zod.object({
  "pageSize": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "numberedHeadings": zod.boolean()
}),
  "sections": zod.array(zod.object({
  "id": zod.string().regex(prepareSowTemplateCopyResponseDefinitionSectionsItemIdRegExp),
  "heading": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemHeadingMax),
  "kind": zod.enum(['fields', 'prose', 'table', 'protected', 'commercial', 'signature']),
  "required": zod.boolean(),
  "guidance": zod.string().max(prepareSowTemplateCopyResponseDefinitionSectionsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.'),
  "fields": zod.array(zod.object({
  "id": zod.string().regex(prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemIdRegExp),
  "label": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemLabelMax),
  "type": zod.enum(['text', 'date', 'number', 'choice']),
  "required": zod.boolean(),
  "options": zod.array(zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemOptionsItemMax)).max(prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemOptionsMax).optional(),
  "guidance": zod.string().max(prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsItemGuidanceMax).describe('Example guidance for authors. Never rendered or treated as project data.')
})).max(prepareSowTemplateCopyResponseDefinitionSectionsItemFieldsMax).optional(),
  "columns": zod.array(zod.object({
  "id": zod.string().regex(prepareSowTemplateCopyResponseDefinitionSectionsItemColumnsItemIdRegExp),
  "label": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemColumnsItemLabelMax)
})).max(prepareSowTemplateCopyResponseDefinitionSectionsItemColumnsMax).optional(),
  "maxRows": zod.int().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemMaxRowsMax).optional(),
  "components": zod.array(zod.enum(['investment', 'materials', 'invoices'])).max(prepareSowTemplateCopyResponseDefinitionSectionsItemComponentsMax).optional(),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMin).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMin).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMin).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMin).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderItemContentMax).optional()
})).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterItemContentMax).optional()
})).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMin).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMin).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMin).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsItemLineHeightMax)
})).min(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsMin).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemTypeMax),
  "text": zod.string().max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentItemContentMax).optional()
})).max(prepareSowTemplateCopyResponseDefinitionSectionsItemContentContentMax)
}).optional()
}).describe('fields, prose and table sections are author-editable project inputs. protected, commercial and signature sections are fixed by the template and native calculations.')).min(1).max(prepareSowTemplateCopyResponseDefinitionSectionsMax)
}),
  "contentHash": zod.string().regex(prepareSowTemplateCopyResponseContentHashRegExp),
  "sourceTemplateId": zod.uuid(),
  "sourceVersion": zod.int().min(1),
  "sourceFormat": zod.enum(['standard', 'engagement-pack', 'custom'])
})


export const installSowTemplateBodySourceHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const installSowTemplateBodyTemplateKeyDefault = `circle-t-sow`;

export const installSowTemplateBody = zod.object({
  "sourceHash": zod.string().regex(installSowTemplateBodySourceHashRegExp),
  "templateKey": zod.enum(['circle-t-sow', 'circle-t-engagement-pack']).default(installSowTemplateBodyTemplateKeyDefault)
})


export const installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const installSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax = 40;

export const installSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax = 200000;

export const installSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const installSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax = 20;

export const installSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax = 10000;

export const installSowTemplateResponseTermsItemContentLayoutHeaderMax = 100;

export const installSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax = 40;

export const installSowTemplateResponseTermsItemContentLayoutFooterItemTextMax = 200000;

export const installSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const installSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax = 20;

export const installSowTemplateResponseTermsItemContentLayoutFooterItemContentMax = 10000;

export const installSowTemplateResponseTermsItemContentLayoutFooterMax = 100;

export const installSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax = 160;

export const installSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const installSowTemplateResponseTermsItemContentSectionsItemsMax = 200;

export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax = 80;

export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const installSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const installSowTemplateResponseTermsItemContentStylesDefinitionsMin = 7;
export const installSowTemplateResponseTermsItemContentStylesDefinitionsMax = 100;

export const installSowTemplateResponseTermsItemContentTemplateGuidanceMax = 4000;

export const installSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const installSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax = 200;

export const installSowTemplateResponseTermsItemContentContentItemTypeMax = 40;

export const installSowTemplateResponseTermsItemContentContentItemTextMax = 200000;

export const installSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax = 40;

export const installSowTemplateResponseTermsItemContentContentItemMarksMax = 20;

export const installSowTemplateResponseTermsItemContentContentItemContentMax = 10000;

export const installSowTemplateResponseTermsItemContentContentMax = 10000;



export const installSowTemplateResponse = zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "version": zod.int().min(1),
  "sourceHash": zod.string(),
  "definition": zod.record(zod.string(), zod.unknown()),
  "terms": zod.array(zod.object({
  "key": zod.enum(['materials', 'agreement', 'payment', 'schedule1', 'operations']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin).max(installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin).max(installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin).max(installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin).max(installSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(installSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(installSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(installSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(installSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(installSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax).optional()
})).max(installSowTemplateResponseTermsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(installSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(installSowTemplateResponseTermsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(installSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(installSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(installSowTemplateResponseTermsItemContentLayoutFooterItemContentMax).optional()
})).max(installSowTemplateResponseTermsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(installSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(installSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(installSowTemplateResponseTermsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(installSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(installSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(installSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin).max(installSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(installSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(installSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin).max(installSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(installSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin).max(installSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(installSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax)
})).min(installSowTemplateResponseTermsItemContentStylesDefinitionsMin).max(installSowTemplateResponseTermsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(installSowTemplateResponseTermsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(installSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(installSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(installSowTemplateResponseTermsItemContentContentItemTypeMax),
  "text": zod.string().max(installSowTemplateResponseTermsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(installSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(installSowTemplateResponseTermsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(installSowTemplateResponseTermsItemContentContentItemContentMax).optional()
})).max(installSowTemplateResponseTermsItemContentContentMax)
})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "format": zod.enum(['standard', 'engagement-pack', 'custom']).optional(),
  "name": zod.string().optional(),
  "description": zod.string().optional()
})


export const getSowTemplateParams = zod.object({
  "id": zod.uuid()
})


export const getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const getSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax = 40;

export const getSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax = 200000;

export const getSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const getSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax = 20;

export const getSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax = 10000;

export const getSowTemplateResponseTermsItemContentLayoutHeaderMax = 100;

export const getSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax = 40;

export const getSowTemplateResponseTermsItemContentLayoutFooterItemTextMax = 200000;

export const getSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const getSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax = 20;

export const getSowTemplateResponseTermsItemContentLayoutFooterItemContentMax = 10000;

export const getSowTemplateResponseTermsItemContentLayoutFooterMax = 100;

export const getSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax = 160;

export const getSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const getSowTemplateResponseTermsItemContentSectionsItemsMax = 200;

export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax = 80;

export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const getSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const getSowTemplateResponseTermsItemContentStylesDefinitionsMin = 7;
export const getSowTemplateResponseTermsItemContentStylesDefinitionsMax = 100;

export const getSowTemplateResponseTermsItemContentTemplateGuidanceMax = 4000;

export const getSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const getSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax = 200;

export const getSowTemplateResponseTermsItemContentContentItemTypeMax = 40;

export const getSowTemplateResponseTermsItemContentContentItemTextMax = 200000;

export const getSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax = 40;

export const getSowTemplateResponseTermsItemContentContentItemMarksMax = 20;

export const getSowTemplateResponseTermsItemContentContentItemContentMax = 10000;

export const getSowTemplateResponseTermsItemContentContentMax = 10000;



export const getSowTemplateResponse = zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "version": zod.int().min(1),
  "sourceHash": zod.string(),
  "definition": zod.record(zod.string(), zod.unknown()),
  "terms": zod.array(zod.object({
  "key": zod.enum(['materials', 'agreement', 'payment', 'schedule1', 'operations']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin).max(getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin).max(getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin).max(getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin).max(getSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(getSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax).optional()
})).max(getSowTemplateResponseTermsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(getSowTemplateResponseTermsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getSowTemplateResponseTermsItemContentLayoutFooterItemContentMax).optional()
})).max(getSowTemplateResponseTermsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(getSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(getSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(getSowTemplateResponseTermsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(getSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(getSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(getSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin).max(getSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(getSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(getSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin).max(getSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(getSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin).max(getSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(getSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax)
})).min(getSowTemplateResponseTermsItemContentStylesDefinitionsMin).max(getSowTemplateResponseTermsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(getSowTemplateResponseTermsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(getSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(getSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateResponseTermsItemContentContentItemTypeMax),
  "text": zod.string().max(getSowTemplateResponseTermsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(getSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(getSowTemplateResponseTermsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(getSowTemplateResponseTermsItemContentContentItemContentMax).optional()
})).max(getSowTemplateResponseTermsItemContentContentMax)
})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "format": zod.enum(['standard', 'engagement-pack', 'custom']).optional(),
  "name": zod.string().optional(),
  "description": zod.string().optional()
})


export const reviseSowTemplateParams = zod.object({
  "id": zod.uuid()
})


export const reviseSowTemplateBodyReasonMax = 2000;

export const reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const reviseSowTemplateBodyTermsItemContentLayoutHeaderItemTypeMax = 40;

export const reviseSowTemplateBodyTermsItemContentLayoutHeaderItemTextMax = 200000;

export const reviseSowTemplateBodyTermsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const reviseSowTemplateBodyTermsItemContentLayoutHeaderItemMarksMax = 20;

export const reviseSowTemplateBodyTermsItemContentLayoutHeaderItemContentMax = 10000;

export const reviseSowTemplateBodyTermsItemContentLayoutHeaderMax = 100;

export const reviseSowTemplateBodyTermsItemContentLayoutFooterItemTypeMax = 40;

export const reviseSowTemplateBodyTermsItemContentLayoutFooterItemTextMax = 200000;

export const reviseSowTemplateBodyTermsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const reviseSowTemplateBodyTermsItemContentLayoutFooterItemMarksMax = 20;

export const reviseSowTemplateBodyTermsItemContentLayoutFooterItemContentMax = 10000;

export const reviseSowTemplateBodyTermsItemContentLayoutFooterMax = 100;

export const reviseSowTemplateBodyTermsItemContentSectionsItemsItemTitleMax = 160;

export const reviseSowTemplateBodyTermsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const reviseSowTemplateBodyTermsItemContentSectionsItemsMax = 200;

export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemNameMax = 80;

export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsMin = 7;
export const reviseSowTemplateBodyTermsItemContentStylesDefinitionsMax = 100;

export const reviseSowTemplateBodyTermsItemContentTemplateGuidanceMax = 4000;

export const reviseSowTemplateBodyTermsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const reviseSowTemplateBodyTermsItemContentTemplateSectionGuidanceMax = 200;

export const reviseSowTemplateBodyTermsItemContentContentItemTypeMax = 40;

export const reviseSowTemplateBodyTermsItemContentContentItemTextMax = 200000;

export const reviseSowTemplateBodyTermsItemContentContentItemMarksItemTypeMax = 40;

export const reviseSowTemplateBodyTermsItemContentContentItemMarksMax = 20;

export const reviseSowTemplateBodyTermsItemContentContentItemContentMax = 10000;

export const reviseSowTemplateBodyTermsItemContentContentMax = 10000;

export const reviseSowTemplateBodyTermsMax = 20;

export const reviseSowTemplateBodyReviewedPricingItemQuantityRegExp = new RegExp('^[1-9][0-9]{0,3}$');
export const reviseSowTemplateBodyReviewedPricingItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const reviseSowTemplateBodyReviewedPricingItemReasonMax = 2000;

export const reviseSowTemplateBodyReviewedPricingMax = 50;



export const reviseSowTemplateBody = zod.object({
  "expectedVersion": zod.int().min(1),
  "reason": zod.string().min(1).max(reviseSowTemplateBodyReasonMax),
  "terms": zod.array(zod.object({
  "key": zod.enum(['materials', 'agreement', 'payment', 'schedule1', 'operations']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsTopMin).max(reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsRightMin).max(reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsBottomMin).max(reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsLeftMin).max(reviseSowTemplateBodyTermsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateBodyTermsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(reviseSowTemplateBodyTermsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateBodyTermsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseSowTemplateBodyTermsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseSowTemplateBodyTermsItemContentLayoutHeaderItemContentMax).optional()
})).max(reviseSowTemplateBodyTermsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateBodyTermsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(reviseSowTemplateBodyTermsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateBodyTermsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseSowTemplateBodyTermsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseSowTemplateBodyTermsItemContentLayoutFooterItemContentMax).optional()
})).max(reviseSowTemplateBodyTermsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(reviseSowTemplateBodyTermsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(reviseSowTemplateBodyTermsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(reviseSowTemplateBodyTermsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemFontSizeMin).max(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemSpaceBeforeMin).max(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemSpaceAfterMin).max(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(reviseSowTemplateBodyTermsItemContentStylesDefinitionsItemLineHeightMax)
})).min(reviseSowTemplateBodyTermsItemContentStylesDefinitionsMin).max(reviseSowTemplateBodyTermsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(reviseSowTemplateBodyTermsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(reviseSowTemplateBodyTermsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(reviseSowTemplateBodyTermsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateBodyTermsItemContentContentItemTypeMax),
  "text": zod.string().max(reviseSowTemplateBodyTermsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateBodyTermsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseSowTemplateBodyTermsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseSowTemplateBodyTermsItemContentContentItemContentMax).optional()
})).max(reviseSowTemplateBodyTermsItemContentContentMax)
})
})).min(1).max(reviseSowTemplateBodyTermsMax),
  "reviewedPricing": zod.array(zod.object({
  "quantity": zod.string().regex(reviseSowTemplateBodyReviewedPricingItemQuantityRegExp),
  "rate": zod.string().regex(reviseSowTemplateBodyReviewedPricingItemRateRegExp),
  "reason": zod.string().min(1).max(reviseSowTemplateBodyReviewedPricingItemReasonMax)
})).max(reviseSowTemplateBodyReviewedPricingMax).optional()
})


export const reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin = 5;
export const reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax = 50;

export const reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin = 5;
export const reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax = 50;

export const reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin = 5;
export const reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax = 50;

export const reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin = 5;
export const reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax = 50;

export const reviseSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax = 40;

export const reviseSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax = 200000;

export const reviseSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax = 40;

export const reviseSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax = 20;

export const reviseSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax = 10000;

export const reviseSowTemplateResponseTermsItemContentLayoutHeaderMax = 100;

export const reviseSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax = 40;

export const reviseSowTemplateResponseTermsItemContentLayoutFooterItemTextMax = 200000;

export const reviseSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax = 40;

export const reviseSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax = 20;

export const reviseSowTemplateResponseTermsItemContentLayoutFooterItemContentMax = 10000;

export const reviseSowTemplateResponseTermsItemContentLayoutFooterMax = 100;

export const reviseSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax = 160;

export const reviseSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax = 4000;


export const reviseSowTemplateResponseTermsItemContentSectionsItemsMax = 200;

export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax = 80;

export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin = 6;
export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax = 96;

export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin = 0;
export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax = 144;

export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax = 3;

export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsMin = 7;
export const reviseSowTemplateResponseTermsItemContentStylesDefinitionsMax = 100;

export const reviseSowTemplateResponseTermsItemContentTemplateGuidanceMax = 4000;

export const reviseSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const reviseSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax = 200;

export const reviseSowTemplateResponseTermsItemContentContentItemTypeMax = 40;

export const reviseSowTemplateResponseTermsItemContentContentItemTextMax = 200000;

export const reviseSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax = 40;

export const reviseSowTemplateResponseTermsItemContentContentItemMarksMax = 20;

export const reviseSowTemplateResponseTermsItemContentContentItemContentMax = 10000;

export const reviseSowTemplateResponseTermsItemContentContentMax = 10000;



export const reviseSowTemplateResponse = zod.object({
  "id": zod.uuid(),
  "key": zod.string(),
  "version": zod.int().min(1),
  "sourceHash": zod.string(),
  "definition": zod.record(zod.string(), zod.unknown()),
  "terms": zod.array(zod.object({
  "key": zod.enum(['materials', 'agreement', 'payment', 'schedule1', 'operations']),
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMin).max(reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMin).max(reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMin).max(reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMin).max(reviseSowTemplateResponseTermsItemContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateResponseTermsItemContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(reviseSowTemplateResponseTermsItemContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateResponseTermsItemContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseSowTemplateResponseTermsItemContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseSowTemplateResponseTermsItemContentLayoutHeaderItemContentMax).optional()
})).max(reviseSowTemplateResponseTermsItemContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateResponseTermsItemContentLayoutFooterItemTypeMax),
  "text": zod.string().max(reviseSowTemplateResponseTermsItemContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateResponseTermsItemContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseSowTemplateResponseTermsItemContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseSowTemplateResponseTermsItemContentLayoutFooterItemContentMax).optional()
})).max(reviseSowTemplateResponseTermsItemContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(reviseSowTemplateResponseTermsItemContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(reviseSowTemplateResponseTermsItemContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(reviseSowTemplateResponseTermsItemContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMin).max(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMin).max(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMin).max(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(reviseSowTemplateResponseTermsItemContentStylesDefinitionsItemLineHeightMax)
})).min(reviseSowTemplateResponseTermsItemContentStylesDefinitionsMin).max(reviseSowTemplateResponseTermsItemContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(reviseSowTemplateResponseTermsItemContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(reviseSowTemplateResponseTermsItemContentTemplateSectionGuidanceItemGuidanceMax)
})).max(reviseSowTemplateResponseTermsItemContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateResponseTermsItemContentContentItemTypeMax),
  "text": zod.string().max(reviseSowTemplateResponseTermsItemContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(reviseSowTemplateResponseTermsItemContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(reviseSowTemplateResponseTermsItemContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(reviseSowTemplateResponseTermsItemContentContentItemContentMax).optional()
})).max(reviseSowTemplateResponseTermsItemContentContentMax)
})
})),
  "createdAt": zod.iso.datetime({"offset":true}),
  "format": zod.enum(['standard', 'engagement-pack', 'custom']).optional(),
  "name": zod.string().optional(),
  "description": zod.string().optional()
})


export const validateSowFactsBodyFactsProjectTitleMax = 200;

export const validateSowFactsBodyFactsCustomerNameMax = 300;

export const validateSowFactsBodyFactsAgreementIdMax = 100;

export const validateSowFactsBodyFactsPreparedDateMax = 40;

export const validateSowFactsBodyFactsStartDateMax = 40;

export const validateSowFactsBodyFactsSprintWeeksMax = 52;

export const validateSowFactsBodyFactsNarrativeItemTextMax = 20000;

export const validateSowFactsBodyFactsNarrativeMax = 5;

export const validateSowFactsBodyFactsTablesItemRowsItemItemMax = 4000;

export const validateSowFactsBodyFactsTablesItemRowsItemMax = 7;

export const validateSowFactsBodyFactsTablesItemRowsMax = 100;

export const validateSowFactsBodyFactsTablesMax = 6;

export const validateSowFactsBodyFactsInvestmentItemIdMax = 80;

export const validateSowFactsBodyFactsInvestmentItemTitleMax = 300;

export const validateSowFactsBodyFactsInvestmentItemDescriptionMax = 4000;

export const validateSowFactsBodyFactsInvestmentItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsInvestmentItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsInvestmentItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsInvestmentMax = 100;

export const validateSowFactsBodyFactsMaterialsItemIdMax = 80;

export const validateSowFactsBodyFactsMaterialsItemTitleMax = 300;

export const validateSowFactsBodyFactsMaterialsItemDescriptionMax = 4000;

export const validateSowFactsBodyFactsMaterialsItemQuantityRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsMaterialsItemRateRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsMaterialsItemDiscountPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsMaterialsMax = 100;

export const validateSowFactsBodyFactsInvoicesItemIdMax = 80;

export const validateSowFactsBodyFactsInvoicesItemMilestonesMax = 500;

export const validateSowFactsBodyFactsInvoicesItemDateMax = 40;

export const validateSowFactsBodyFactsInvoicesItemGrossAmountRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsInvoicesItemPercentRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsInvoicesItemNotesMax = 2000;

export const validateSowFactsBodyFactsInvoicesMax = 100;

export const validateSowFactsBodyFactsMilestoneDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsDisplayedMaterialsTotalRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');

export const validateSowFactsBodyFactsQuoteCommercialHashRegExp = new RegExp('^[a-f0-9]{64}$');
export const validateSowFactsBodyFactsQuoteCommercialReferenceMax = 300;

export const validateSowFactsBodyFactsQuoteCommercialSourceStatusMax = 100;

export const validateSowFactsBodyFactsQuoteCommercialCurrencyRegExp = new RegExp('^[A-Z]{3}$');
export const validateSowFactsBodyFactsQuoteCommercialTermsMax = 20000;

export const validateSowFactsBodyFactsQuoteCommercialAssumptionsMax = 20000;

export const validateSowFactsBodyFactsQuoteCommercialExclusionsMax = 20000;

export const validateSowFactsBodyFactsQuoteCommercialReviewReasonMin = 10;
export const validateSowFactsBodyFactsQuoteCommercialReviewReasonMax = 2000;

export const validateSowFactsBodyFactsQuoteCommercialLinesItemTitleMax = 300;

export const validateSowFactsBodyFactsQuoteCommercialLinesItemDescriptionMax = 4000;

export const validateSowFactsBodyFactsQuoteCommercialLinesMax = 100;

export const validateSowFactsBodyFactsEngagementPackPurchasedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsEngagementPackDonatedDaysRegExp = new RegExp('^(0|[1-9][0-9]{0,8})(\\.[0-9]{1,4})?$');
export const validateSowFactsBodyFactsUnresolvedFactsItemFieldMax = 100;

export const validateSowFactsBodyFactsUnresolvedFactsItemMessageMax = 2000;

export const validateSowFactsBodyFactsUnresolvedFactsMax = 200;

export const validateSowFactsBodyFactsCustomFieldsItemSectionIdMax = 48;

export const validateSowFactsBodyFactsCustomFieldsItemFieldIdMax = 48;

export const validateSowFactsBodyFactsCustomFieldsItemValueMax = 4000;

export const validateSowFactsBodyFactsCustomFieldsMax = 600;

export const validateSowFactsBodyFactsCustomProseItemSectionIdMax = 48;

export const validateSowFactsBodyFactsCustomProseItemTextMax = 20000;

export const validateSowFactsBodyFactsCustomProseMax = 40;

export const validateSowFactsBodyFactsCustomTablesItemSectionIdMax = 48;

export const validateSowFactsBodyFactsCustomTablesItemRowsItemItemMax = 4000;

export const validateSowFactsBodyFactsCustomTablesItemRowsItemMax = 8;

export const validateSowFactsBodyFactsCustomTablesItemRowsMax = 100;

export const validateSowFactsBodyFactsCustomTablesMax = 40;



export const validateSowFactsBody = zod.object({
  "templateVersionId": zod.uuid(),
  "facts": zod.object({
  "projectTitle": zod.string().max(validateSowFactsBodyFactsProjectTitleMax).nullable(),
  "customerName": zod.string().max(validateSowFactsBodyFactsCustomerNameMax).nullable(),
  "agreementId": zod.string().max(validateSowFactsBodyFactsAgreementIdMax).nullable(),
  "preparedDate": zod.string().max(validateSowFactsBodyFactsPreparedDateMax).nullable(),
  "startDate": zod.string().max(validateSowFactsBodyFactsStartDateMax).nullable(),
  "sprintWeeks": zod.int().min(1).max(validateSowFactsBodyFactsSprintWeeksMax).nullable(),
  "narrative": zod.array(zod.object({
  "section": zod.enum(['summary', 'method', 'foundry', 'appendix']),
  "text": zod.string().max(validateSowFactsBodyFactsNarrativeItemTextMax)
})).max(validateSowFactsBodyFactsNarrativeMax),
  "tables": zod.array(zod.object({
  "section": zod.enum(['deliverables', 'components', 'milestones', 'risks', 'assumptions', 'resources']),
  "rows": zod.array(zod.array(zod.string().max(validateSowFactsBodyFactsTablesItemRowsItemItemMax)).max(validateSowFactsBodyFactsTablesItemRowsItemMax)).max(validateSowFactsBodyFactsTablesItemRowsMax)
})).max(validateSowFactsBodyFactsTablesMax),
  "investment": zod.array(zod.object({
  "id": zod.string().min(1).max(validateSowFactsBodyFactsInvestmentItemIdMax),
  "title": zod.string().max(validateSowFactsBodyFactsInvestmentItemTitleMax),
  "description": zod.string().max(validateSowFactsBodyFactsInvestmentItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(validateSowFactsBodyFactsInvestmentItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(validateSowFactsBodyFactsInvestmentItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(validateSowFactsBodyFactsInvestmentItemDiscountPercentRegExp).nullable()
})).max(validateSowFactsBodyFactsInvestmentMax),
  "materials": zod.array(zod.object({
  "id": zod.string().min(1).max(validateSowFactsBodyFactsMaterialsItemIdMax),
  "title": zod.string().max(validateSowFactsBodyFactsMaterialsItemTitleMax),
  "description": zod.string().max(validateSowFactsBodyFactsMaterialsItemDescriptionMax),
  "kind": zod.enum(['effort', 'operations', 'material', 'service', 'donated']),
  "quantity": zod.string().regex(validateSowFactsBodyFactsMaterialsItemQuantityRegExp).nullable(),
  "rate": zod.string().regex(validateSowFactsBodyFactsMaterialsItemRateRegExp).nullable(),
  "discountPercent": zod.string().regex(validateSowFactsBodyFactsMaterialsItemDiscountPercentRegExp).nullable()
})).max(validateSowFactsBodyFactsMaterialsMax),
  "invoices": zod.array(zod.object({
  "id": zod.string().min(1).max(validateSowFactsBodyFactsInvoicesItemIdMax),
  "milestones": zod.string().max(validateSowFactsBodyFactsInvoicesItemMilestonesMax),
  "date": zod.string().max(validateSowFactsBodyFactsInvoicesItemDateMax).nullable(),
  "grossAmount": zod.string().regex(validateSowFactsBodyFactsInvoicesItemGrossAmountRegExp).nullable(),
  "percent": zod.string().regex(validateSowFactsBodyFactsInvoicesItemPercentRegExp).nullable(),
  "notes": zod.string().max(validateSowFactsBodyFactsInvoicesItemNotesMax)
})).max(validateSowFactsBodyFactsInvoicesMax),
  "milestoneDays": zod.string().regex(validateSowFactsBodyFactsMilestoneDaysRegExp).nullable(),
  "displayedMaterialsTotal": zod.string().regex(validateSowFactsBodyFactsDisplayedMaterialsTotalRegExp).nullable(),
  "quoteCommercial": zod.object({
  "quoteId": zod.uuid(),
  "revision": zod.int().min(1),
  "hash": zod.string().regex(validateSowFactsBodyFactsQuoteCommercialHashRegExp),
  "reference": zod.string().max(validateSowFactsBodyFactsQuoteCommercialReferenceMax),
  "sourceStatus": zod.string().max(validateSowFactsBodyFactsQuoteCommercialSourceStatusMax),
  "currency": zod.string().regex(validateSowFactsBodyFactsQuoteCommercialCurrencyRegExp),
  "headerDiscountPercent": zod.string(),
  "contingencyPercent": zod.string(),
  "terms": zod.string().max(validateSowFactsBodyFactsQuoteCommercialTermsMax).nullable(),
  "assumptions": zod.string().max(validateSowFactsBodyFactsQuoteCommercialAssumptionsMax).nullable(),
  "exclusions": zod.string().max(validateSowFactsBodyFactsQuoteCommercialExclusionsMax).nullable(),
  "reviewReason": zod.string().min(validateSowFactsBodyFactsQuoteCommercialReviewReasonMin).max(validateSowFactsBodyFactsQuoteCommercialReviewReasonMax),
  "subtotal": zod.string(),
  "discountAmount": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string(),
  "taxAmount": zod.string(),
  "total": zod.string(),
  "contingencyAmount": zod.string(),
  "lines": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().max(validateSowFactsBodyFactsQuoteCommercialLinesItemTitleMax),
  "description": zod.string().max(validateSowFactsBodyFactsQuoteCommercialLinesItemDescriptionMax).nullable(),
  "inclusion": zod.enum(['included', 'optional', 'alternative']),
  "selected": zod.boolean(),
  "quantity": zod.string(),
  "pricingMethod": zod.enum(['fixed', 'effort']).optional(),
  "effortHours": zod.string().nullish(),
  "hourlyRate": zod.string().nullish(),
  "role": zod.string().nullish(),
  "rate": zod.string().nullable(),
  "recurringRate": zod.string().nullable(),
  "interval": zod.enum(['none', 'monthly', 'annual']),
  "discountPercent": zod.string(),
  "taxPercent": zod.string(),
  "oneOffTotal": zod.string(),
  "recurringTotal": zod.string()
})).max(validateSowFactsBodyFactsQuoteCommercialLinesMax)
}).optional(),
  "engagementPack": zod.object({
  "purchasedDays": zod.string().regex(validateSowFactsBodyFactsEngagementPackPurchasedDaysRegExp).nullable(),
  "donatedDays": zod.string().regex(validateSowFactsBodyFactsEngagementPackDonatedDaysRegExp).nullable()
}).optional(),
  "unresolvedFacts": zod.array(zod.object({
  "field": zod.string().max(validateSowFactsBodyFactsUnresolvedFactsItemFieldMax),
  "message": zod.string().max(validateSowFactsBodyFactsUnresolvedFactsItemMessageMax)
})).max(validateSowFactsBodyFactsUnresolvedFactsMax).optional(),
  "custom": zod.object({
  "fields": zod.array(zod.object({
  "sectionId": zod.string().max(validateSowFactsBodyFactsCustomFieldsItemSectionIdMax),
  "fieldId": zod.string().max(validateSowFactsBodyFactsCustomFieldsItemFieldIdMax),
  "value": zod.string().max(validateSowFactsBodyFactsCustomFieldsItemValueMax).nullable()
})).max(validateSowFactsBodyFactsCustomFieldsMax),
  "prose": zod.array(zod.object({
  "sectionId": zod.string().max(validateSowFactsBodyFactsCustomProseItemSectionIdMax),
  "text": zod.string().max(validateSowFactsBodyFactsCustomProseItemTextMax)
})).max(validateSowFactsBodyFactsCustomProseMax),
  "tables": zod.array(zod.object({
  "sectionId": zod.string().max(validateSowFactsBodyFactsCustomTablesItemSectionIdMax),
  "rows": zod.array(zod.array(zod.string().max(validateSowFactsBodyFactsCustomTablesItemRowsItemItemMax)).max(validateSowFactsBodyFactsCustomTablesItemRowsItemMax)).max(validateSowFactsBodyFactsCustomTablesItemRowsMax)
})).max(validateSowFactsBodyFactsCustomTablesMax)
}).optional().describe('Project values for an administrator-defined custom template. Rejected for the built-in formats.')
})
})

export const validateSowFactsResponseContentLayoutPageSettingsMarginsTopMin = 5;
export const validateSowFactsResponseContentLayoutPageSettingsMarginsTopMax = 50;

export const validateSowFactsResponseContentLayoutPageSettingsMarginsRightMin = 5;
export const validateSowFactsResponseContentLayoutPageSettingsMarginsRightMax = 50;

export const validateSowFactsResponseContentLayoutPageSettingsMarginsBottomMin = 5;
export const validateSowFactsResponseContentLayoutPageSettingsMarginsBottomMax = 50;

export const validateSowFactsResponseContentLayoutPageSettingsMarginsLeftMin = 5;
export const validateSowFactsResponseContentLayoutPageSettingsMarginsLeftMax = 50;

export const validateSowFactsResponseContentLayoutHeaderItemTypeMax = 40;

export const validateSowFactsResponseContentLayoutHeaderItemTextMax = 200000;

export const validateSowFactsResponseContentLayoutHeaderItemMarksItemTypeMax = 40;

export const validateSowFactsResponseContentLayoutHeaderItemMarksMax = 20;

export const validateSowFactsResponseContentLayoutHeaderItemContentMax = 10000;

export const validateSowFactsResponseContentLayoutHeaderMax = 100;

export const validateSowFactsResponseContentLayoutFooterItemTypeMax = 40;

export const validateSowFactsResponseContentLayoutFooterItemTextMax = 200000;

export const validateSowFactsResponseContentLayoutFooterItemMarksItemTypeMax = 40;

export const validateSowFactsResponseContentLayoutFooterItemMarksMax = 20;

export const validateSowFactsResponseContentLayoutFooterItemContentMax = 10000;

export const validateSowFactsResponseContentLayoutFooterMax = 100;

export const validateSowFactsResponseContentSectionsItemsItemTitleMax = 160;

export const validateSowFactsResponseContentSectionsItemsItemAuthoringNotesMax = 4000;


export const validateSowFactsResponseContentSectionsItemsMax = 200;

export const validateSowFactsResponseContentStylesDefinitionsItemIdRegExp = new RegExp('^(normal|heading-[1-6]|custom-[0-9a-f-]{36})$');
export const validateSowFactsResponseContentStylesDefinitionsItemNameMax = 80;

export const validateSowFactsResponseContentStylesDefinitionsItemFontSizeMin = 6;
export const validateSowFactsResponseContentStylesDefinitionsItemFontSizeMax = 96;

export const validateSowFactsResponseContentStylesDefinitionsItemColorRegExp = new RegExp('^#[0-9a-fA-F]{6}$');
export const validateSowFactsResponseContentStylesDefinitionsItemSpaceBeforeMin = 0;
export const validateSowFactsResponseContentStylesDefinitionsItemSpaceBeforeMax = 144;

export const validateSowFactsResponseContentStylesDefinitionsItemSpaceAfterMin = 0;
export const validateSowFactsResponseContentStylesDefinitionsItemSpaceAfterMax = 144;

export const validateSowFactsResponseContentStylesDefinitionsItemLineHeightMax = 3;

export const validateSowFactsResponseContentStylesDefinitionsMin = 7;
export const validateSowFactsResponseContentStylesDefinitionsMax = 100;

export const validateSowFactsResponseContentTemplateGuidanceMax = 4000;

export const validateSowFactsResponseContentTemplateSectionGuidanceItemGuidanceMax = 4000;

export const validateSowFactsResponseContentTemplateSectionGuidanceMax = 200;

export const validateSowFactsResponseContentContentItemTypeMax = 40;

export const validateSowFactsResponseContentContentItemTextMax = 200000;

export const validateSowFactsResponseContentContentItemMarksItemTypeMax = 40;

export const validateSowFactsResponseContentContentItemMarksMax = 20;

export const validateSowFactsResponseContentContentItemContentMax = 10000;

export const validateSowFactsResponseContentContentMax = 10000;



export const validateSowFactsResponse = zod.object({
  "content": zod.object({
  "type": zod.enum(['doc']),
  "layout": zod.object({
  "pageSettings": zod.object({
  "size": zod.enum(['a4', 'letter']),
  "orientation": zod.enum(['portrait', 'landscape']),
  "margins": zod.object({
  "top": zod.number().min(validateSowFactsResponseContentLayoutPageSettingsMarginsTopMin).max(validateSowFactsResponseContentLayoutPageSettingsMarginsTopMax),
  "right": zod.number().min(validateSowFactsResponseContentLayoutPageSettingsMarginsRightMin).max(validateSowFactsResponseContentLayoutPageSettingsMarginsRightMax),
  "bottom": zod.number().min(validateSowFactsResponseContentLayoutPageSettingsMarginsBottomMin).max(validateSowFactsResponseContentLayoutPageSettingsMarginsBottomMax),
  "left": zod.number().min(validateSowFactsResponseContentLayoutPageSettingsMarginsLeftMin).max(validateSowFactsResponseContentLayoutPageSettingsMarginsLeftMax)
})
}),
  "header": zod.array(zod.object({
  "type": zod.string().min(1).max(validateSowFactsResponseContentLayoutHeaderItemTypeMax),
  "text": zod.string().max(validateSowFactsResponseContentLayoutHeaderItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(validateSowFactsResponseContentLayoutHeaderItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(validateSowFactsResponseContentLayoutHeaderItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(validateSowFactsResponseContentLayoutHeaderItemContentMax).optional()
})).max(validateSowFactsResponseContentLayoutHeaderMax),
  "footer": zod.array(zod.object({
  "type": zod.string().min(1).max(validateSowFactsResponseContentLayoutFooterItemTypeMax),
  "text": zod.string().max(validateSowFactsResponseContentLayoutFooterItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(validateSowFactsResponseContentLayoutFooterItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(validateSowFactsResponseContentLayoutFooterItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(validateSowFactsResponseContentLayoutFooterItemContentMax).optional()
})).max(validateSowFactsResponseContentLayoutFooterMax)
}).optional().describe('Optional versioned layout in canonical document JSON. Omission preserves historical JSON and hashes. Header and footer contain structured nodes, never HTML.'),
  "sections": zod.object({
  "schemaVersion": zod.literal(1),
  "boundaryMode": zod.enum(['independent']).optional().describe('Independent editor-only boundaries; ordinary headings remain document content. Omitted for historical heading boundaries.'),
  "structure": zod.object({
  "allowAdd": zod.boolean(),
  "allowRename": zod.boolean(),
  "allowReorder": zod.boolean(),
  "allowHide": zod.boolean()
}),
  "items": zod.array(zod.object({
  "id": zod.uuid(),
  "title": zod.string().min(1).max(validateSowFactsResponseContentSectionsItemsItemTitleMax),
  "hidden": zod.boolean(),
  "protection": zod.enum(['editable', 'bulk_protected', 'locked']),
  "authoringNotes": zod.string().max(validateSowFactsResponseContentSectionsItemsItemAuthoringNotesMax).optional(),
  "reviewedAtRevision": zod.int().min(1).optional(),
  "templateDefined": zod.literal(true).optional()
})).min(1).max(validateSowFactsResponseContentSectionsItemsMax)
}).optional(),
  "styles": zod.object({
  "schemaVersion": zod.literal(1),
  "definitions": zod.array(zod.object({
  "id": zod.string().regex(validateSowFactsResponseContentStylesDefinitionsItemIdRegExp),
  "name": zod.string().min(1).max(validateSowFactsResponseContentStylesDefinitionsItemNameMax),
  "fontFamily": zod.enum(['Arial', 'Calibri', 'Times New Roman', 'Georgia', 'Verdana', 'Courier New']),
  "fontSize": zod.number().min(validateSowFactsResponseContentStylesDefinitionsItemFontSizeMin).max(validateSowFactsResponseContentStylesDefinitionsItemFontSizeMax),
  "color": zod.string().regex(validateSowFactsResponseContentStylesDefinitionsItemColorRegExp),
  "bold": zod.boolean(),
  "italic": zod.boolean(),
  "underline": zod.boolean(),
  "alignment": zod.enum(['left', 'center', 'right', 'justify']),
  "spaceBefore": zod.number().min(validateSowFactsResponseContentStylesDefinitionsItemSpaceBeforeMin).max(validateSowFactsResponseContentStylesDefinitionsItemSpaceBeforeMax),
  "spaceAfter": zod.number().min(validateSowFactsResponseContentStylesDefinitionsItemSpaceAfterMin).max(validateSowFactsResponseContentStylesDefinitionsItemSpaceAfterMax),
  "lineHeight": zod.number().min(1).max(validateSowFactsResponseContentStylesDefinitionsItemLineHeightMax)
})).min(validateSowFactsResponseContentStylesDefinitionsMin).max(validateSowFactsResponseContentStylesDefinitionsMax)
}).optional(),
  "template": zod.object({
  "available": zod.boolean(),
  "guidance": zod.string().max(validateSowFactsResponseContentTemplateGuidanceMax),
  "sectionGuidance": zod.array(zod.object({
  "sectionId": zod.uuid(),
  "guidance": zod.string().max(validateSowFactsResponseContentTemplateSectionGuidanceItemGuidanceMax)
})).max(validateSowFactsResponseContentTemplateSectionGuidanceMax)
}).optional(),
  "content": zod.array(zod.object({
  "type": zod.string().min(1).max(validateSowFactsResponseContentContentItemTypeMax),
  "text": zod.string().max(validateSowFactsResponseContentContentItemTextMax).optional(),
  "attrs": zod.record(zod.string(), zod.unknown()).optional(),
  "marks": zod.array(zod.object({
  "type": zod.string().min(1).max(validateSowFactsResponseContentContentItemMarksItemTypeMax),
  "attrs": zod.record(zod.string(), zod.unknown()).optional()
})).max(validateSowFactsResponseContentContentItemMarksMax).optional(),
  "content": zod.array(zod.unknown()).max(validateSowFactsResponseContentContentItemContentMax).optional()
})).max(validateSowFactsResponseContentContentMax)
}),
  "validation": zod.object({
  "readyForReview": zod.boolean(),
  "findings": zod.array(zod.object({
  "code": zod.string(),
  "field": zod.string(),
  "message": zod.string()
})),
  "subtotal": zod.string().nullable(),
  "gst": zod.string().nullable(),
  "gross": zod.string().nullable(),
  "materials": zod.string().nullable(),
  "invoices": zod.string().nullable(),
  "effortDays": zod.string().nullable()
})
})


export const listResearchGroundingQueryLimitDefault = 20;
export const listResearchGroundingQueryLimitMax = 100;

export const listResearchGroundingQueryOffsetDefault = 0;
export const listResearchGroundingQueryOffsetMin = 0;
export const listResearchGroundingQueryOffsetMax = 10000;

export const listResearchGroundingQuerySearchMax = 200;

export const listResearchGroundingQueryExpectedSourceRegExp = new RegExp('^[a-f0-9]{64}$');


export const listResearchGroundingQueryParams = zod.object({
  "limit": zod.int().min(1).max(listResearchGroundingQueryLimitMax).default(listResearchGroundingQueryLimitDefault),
  "offset": zod.int().min(listResearchGroundingQueryOffsetMin).max(listResearchGroundingQueryOffsetMax).default(listResearchGroundingQueryOffsetDefault),
  "search": zod.string().max(listResearchGroundingQuerySearchMax).optional(),
  "state": zod.enum(['eligible', 'excluded', 'unavailable']).optional(),
  "expectedSource": zod.string().regex(listResearchGroundingQueryExpectedSourceRegExp).optional()
})

export const listResearchGroundingResponseItemsItemKeyMax = 200;

export const listResearchGroundingResponseItemsItemTitleMax = 500;

export const listResearchGroundingResponseItemsItemPriorityMax = 5;

export const listResearchGroundingResponseItemsItemRevisionMax = 200;

export const listResearchGroundingResponseSourceVersionRegExp = new RegExp('^[a-f0-9]{64}$');


export const listResearchGroundingResponse = zod.object({
  "items": zod.array(zod.object({
  "key": zod.string().min(1).max(listResearchGroundingResponseItemsItemKeyMax),
  "title": zod.string().min(1).max(listResearchGroundingResponseItemsItemTitleMax),
  "type": zod.enum(['crm', 'knowledge']),
  "state": zod.enum(['eligible', 'excluded', 'unavailable']),
  "inclusion": zod.boolean().nullable(),
  "priority": zod.int().min(1).max(listResearchGroundingResponseItemsItemPriorityMax).nullable(),
  "inheritedPriority": zod.int(),
  "primary": zod.boolean(),
  "revision": zod.string().min(1).max(listResearchGroundingResponseItemsItemRevisionMax)
})),
  "total": zod.int(),
  "limit": zod.int(),
  "offset": zod.int(),
  "sourceVersion": zod.string().regex(listResearchGroundingResponseSourceVersionRegExp)
})


export const saveResearchGroundingBodyExpectedSourceRegExp = new RegExp('^[a-f0-9]{64}$');
export const saveResearchGroundingBodyKeyMax = 200;

export const saveResearchGroundingBodyPriorityMax = 5;



export const saveResearchGroundingBody = zod.object({
  "requestId": zod.uuid(),
  "expectedSource": zod.string().regex(saveResearchGroundingBodyExpectedSourceRegExp),
  "key": zod.string().min(1).max(saveResearchGroundingBodyKeyMax),
  "inclusion": zod.boolean().nullable(),
  "priority": zod.int().min(1).max(saveResearchGroundingBodyPriorityMax).nullable()
})

export const saveResearchGroundingResponseSavedVersionRegExp = new RegExp('^[a-f0-9]{64}$');


export const saveResearchGroundingResponse = zod.object({
  "requestId": zod.uuid(),
  "kind": zod.enum(['grounding', 'prompts']),
  "replayed": zod.boolean(),
  "currentMatch": zod.boolean(),
  "savedVersion": zod.string().regex(saveResearchGroundingResponseSavedVersionRegExp)
})


export const getResearchControlOutcomeParams = zod.object({
  "requestId": zod.uuid()
})

export const getResearchControlOutcomeResponseSavedVersionRegExp = new RegExp('^[a-f0-9]{64}$');


export const getResearchControlOutcomeResponse = zod.object({
  "requestId": zod.uuid(),
  "kind": zod.enum(['grounding', 'prompts']),
  "replayed": zod.boolean(),
  "currentMatch": zod.boolean(),
  "savedVersion": zod.string().regex(getResearchControlOutcomeResponseSavedVersionRegExp)
})


export const exportResearchPromptsResponseItemsItemTitleMax = 120;

export const exportResearchPromptsResponseItemsItemPromptMax = 8000;

export const exportResearchPromptsResponseItemsItemCategoryMax = 60;

export const exportResearchPromptsResponseItemsMax = 100;



export const exportResearchPromptsResponse = zod.object({
  "format": zod.enum(['research-prompts-v1']),
  "items": zod.array(zod.object({
  "title": zod.string().min(1).max(exportResearchPromptsResponseItemsItemTitleMax),
  "prompt": zod.string().min(1).max(exportResearchPromptsResponseItemsItemPromptMax),
  "category": zod.string().min(1).max(exportResearchPromptsResponseItemsItemCategoryMax)
})).min(1).max(exportResearchPromptsResponseItemsMax)
})


export const previewResearchPromptTransferBodyItemsItemTitleMax = 120;

export const previewResearchPromptTransferBodyItemsItemPromptMax = 8000;

export const previewResearchPromptTransferBodyItemsItemCategoryMax = 60;

export const previewResearchPromptTransferBodyItemsMax = 100;



export const previewResearchPromptTransferBody = zod.object({
  "format": zod.enum(['research-prompts-v1']),
  "items": zod.array(zod.object({
  "title": zod.string().min(1).max(previewResearchPromptTransferBodyItemsItemTitleMax),
  "prompt": zod.string().min(1).max(previewResearchPromptTransferBodyItemsItemPromptMax),
  "category": zod.string().min(1).max(previewResearchPromptTransferBodyItemsItemCategoryMax)
})).min(1).max(previewResearchPromptTransferBodyItemsMax)
})

export const previewResearchPromptTransferResponseVersionRegExp = new RegExp('^[a-f0-9]{64}$');
export const previewResearchPromptTransferResponseCreateItemMax = 120;

export const previewResearchPromptTransferResponseReplaceItemMax = 120;

export const previewResearchPromptTransferResponseUnchangedItemMax = 120;



export const previewResearchPromptTransferResponse = zod.object({
  "version": zod.string().regex(previewResearchPromptTransferResponseVersionRegExp),
  "create": zod.array(zod.string().min(1).max(previewResearchPromptTransferResponseCreateItemMax)),
  "replace": zod.array(zod.string().min(1).max(previewResearchPromptTransferResponseReplaceItemMax)),
  "unchanged": zod.array(zod.string().min(1).max(previewResearchPromptTransferResponseUnchangedItemMax))
})


export const applyResearchPromptTransferBodyExpectedVersionRegExp = new RegExp('^[a-f0-9]{64}$');
export const applyResearchPromptTransferBodyTransferItemsItemTitleMax = 120;

export const applyResearchPromptTransferBodyTransferItemsItemPromptMax = 8000;

export const applyResearchPromptTransferBodyTransferItemsItemCategoryMax = 60;

export const applyResearchPromptTransferBodyTransferItemsMax = 100;



export const applyResearchPromptTransferBody = zod.object({
  "requestId": zod.uuid(),
  "expectedVersion": zod.string().regex(applyResearchPromptTransferBodyExpectedVersionRegExp),
  "transfer": zod.object({
  "format": zod.enum(['research-prompts-v1']),
  "items": zod.array(zod.object({
  "title": zod.string().min(1).max(applyResearchPromptTransferBodyTransferItemsItemTitleMax),
  "prompt": zod.string().min(1).max(applyResearchPromptTransferBodyTransferItemsItemPromptMax),
  "category": zod.string().min(1).max(applyResearchPromptTransferBodyTransferItemsItemCategoryMax)
})).min(1).max(applyResearchPromptTransferBodyTransferItemsMax)
})
})

export const applyResearchPromptTransferResponseSavedVersionRegExp = new RegExp('^[a-f0-9]{64}$');


export const applyResearchPromptTransferResponse = zod.object({
  "requestId": zod.uuid(),
  "kind": zod.enum(['grounding', 'prompts']),
  "replayed": zod.boolean(),
  "currentMatch": zod.boolean(),
  "savedVersion": zod.string().regex(applyResearchPromptTransferResponseSavedVersionRegExp)
})
